(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ikwle", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $d5832e98440e922c$export$ffb0004e005737fa; }, function (v) { return $d5832e98440e922c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $d5832e98440e922c$export$34b9dba7ce09269b; }, function (v) { return $d5832e98440e922c$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $d5832e98440e922c$export$25062201e9e25d76; }, function (v) { return $d5832e98440e922c$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d5832e98440e922c$export$ffb0004e005737fa;
var $d5832e98440e922c$export$34b9dba7ce09269b;
var $d5832e98440e922c$export$25062201e9e25d76;
"use strict";

var $1T1QG = parcelRequire("1T1QG");
var $d5832e98440e922c$var$k = Symbol.for("react.element"), $d5832e98440e922c$var$l = Symbol.for("react.fragment"), $d5832e98440e922c$var$m = Object.prototype.hasOwnProperty, $d5832e98440e922c$var$n = $1T1QG.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d5832e98440e922c$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d5832e98440e922c$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d5832e98440e922c$var$m.call(a, b) && !$d5832e98440e922c$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d5832e98440e922c$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d5832e98440e922c$var$n.current
    };
}
$d5832e98440e922c$export$ffb0004e005737fa = $d5832e98440e922c$var$l;
$d5832e98440e922c$export$34b9dba7ce09269b = $d5832e98440e922c$var$q;
$d5832e98440e922c$export$25062201e9e25d76 = $d5832e98440e922c$var$q;

});
parcelRegister("1T1QG", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1pKBx"));

});
parcelRegister("1pKBx", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $107c46e4730f9658$export$dca3b0875bd9a954; }, function (v) { return $107c46e4730f9658$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $107c46e4730f9658$export$16fa2f45be04daa8; }, function (v) { return $107c46e4730f9658$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $107c46e4730f9658$export$ffb0004e005737fa; }, function (v) { return $107c46e4730f9658$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $107c46e4730f9658$export$e2c29f18771995cb; }, function (v) { return $107c46e4730f9658$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $107c46e4730f9658$export$221d75b3f55bb0bd; }, function (v) { return $107c46e4730f9658$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $107c46e4730f9658$export$5f8d39834fd61797; }, function (v) { return $107c46e4730f9658$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $107c46e4730f9658$export$74bf444e3cd11ea5; }, function (v) { return $107c46e4730f9658$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $107c46e4730f9658$export$ae55be85d98224ed; }, function (v) { return $107c46e4730f9658$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $107c46e4730f9658$export$e530037191fcd5d7; }, function (v) { return $107c46e4730f9658$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $107c46e4730f9658$export$fd42f52fd3ae1109; }, function (v) { return $107c46e4730f9658$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $107c46e4730f9658$export$c8a8987d4410bf2d; }, function (v) { return $107c46e4730f9658$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $107c46e4730f9658$export$d38cd72104c1f0e9; }, function (v) { return $107c46e4730f9658$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $107c46e4730f9658$export$7d1e3a5e95ceca43; }, function (v) { return $107c46e4730f9658$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $107c46e4730f9658$export$257a8862b851cb5b; }, function (v) { return $107c46e4730f9658$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $107c46e4730f9658$export$a8257692ac88316c; }, function (v) { return $107c46e4730f9658$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $107c46e4730f9658$export$488013bae63b21da; }, function (v) { return $107c46e4730f9658$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $107c46e4730f9658$export$7c73462e0d25e514; }, function (v) { return $107c46e4730f9658$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $107c46e4730f9658$export$7568632d0d33d16d; }, function (v) { return $107c46e4730f9658$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $107c46e4730f9658$export$88948ce120ea2619; }, function (v) { return $107c46e4730f9658$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $107c46e4730f9658$export$35808ee640e87ca7; }, function (v) { return $107c46e4730f9658$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $107c46e4730f9658$export$fae74005e78b1a27; }, function (v) { return $107c46e4730f9658$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $107c46e4730f9658$export$dc8fbce3eb94dc1e; }, function (v) { return $107c46e4730f9658$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $107c46e4730f9658$export$6a7bc4e911dc01cf; }, function (v) { return $107c46e4730f9658$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $107c46e4730f9658$export$6d9c69b0de29b591; }, function (v) { return $107c46e4730f9658$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $107c46e4730f9658$export$f680877a34711e37; }, function (v) { return $107c46e4730f9658$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $107c46e4730f9658$export$d5a552a76deda3c2; }, function (v) { return $107c46e4730f9658$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $107c46e4730f9658$export$aaabe4eda9ed9969; }, function (v) { return $107c46e4730f9658$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $107c46e4730f9658$export$e5c5a5f917a5871c; }, function (v) { return $107c46e4730f9658$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $107c46e4730f9658$export$1538c33de8887b59; }, function (v) { return $107c46e4730f9658$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $107c46e4730f9658$export$13e3392192263954; }, function (v) { return $107c46e4730f9658$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $107c46e4730f9658$export$b8f5890fc79d6aca; }, function (v) { return $107c46e4730f9658$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $107c46e4730f9658$export$60241385465d0a34; }, function (v) { return $107c46e4730f9658$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $107c46e4730f9658$export$306c0aa65ff9ec16; }, function (v) { return $107c46e4730f9658$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $107c46e4730f9658$export$7b286972b8d8ccbf; }, function (v) { return $107c46e4730f9658$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $107c46e4730f9658$export$83d89fbfd8236492; }, function (v) { return $107c46e4730f9658$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $107c46e4730f9658$export$dca3b0875bd9a954;
var $107c46e4730f9658$export$16fa2f45be04daa8;
var $107c46e4730f9658$export$ffb0004e005737fa;
var $107c46e4730f9658$export$e2c29f18771995cb;
var $107c46e4730f9658$export$221d75b3f55bb0bd;
var $107c46e4730f9658$export$5f8d39834fd61797;
var $107c46e4730f9658$export$74bf444e3cd11ea5;
var $107c46e4730f9658$export$ae55be85d98224ed;
var $107c46e4730f9658$export$e530037191fcd5d7;
var $107c46e4730f9658$export$fd42f52fd3ae1109;
var $107c46e4730f9658$export$c8a8987d4410bf2d;
var $107c46e4730f9658$export$d38cd72104c1f0e9;
var $107c46e4730f9658$export$7d1e3a5e95ceca43;
var $107c46e4730f9658$export$257a8862b851cb5b;
var $107c46e4730f9658$export$a8257692ac88316c;
var $107c46e4730f9658$export$488013bae63b21da;
var $107c46e4730f9658$export$7c73462e0d25e514;
var $107c46e4730f9658$export$7568632d0d33d16d;
var $107c46e4730f9658$export$88948ce120ea2619;
var $107c46e4730f9658$export$35808ee640e87ca7;
var $107c46e4730f9658$export$fae74005e78b1a27;
var $107c46e4730f9658$export$dc8fbce3eb94dc1e;
var $107c46e4730f9658$export$6a7bc4e911dc01cf;
var $107c46e4730f9658$export$6d9c69b0de29b591;
var $107c46e4730f9658$export$f680877a34711e37;
var $107c46e4730f9658$export$d5a552a76deda3c2;
var $107c46e4730f9658$export$aaabe4eda9ed9969;
var $107c46e4730f9658$export$e5c5a5f917a5871c;
var $107c46e4730f9658$export$1538c33de8887b59;
var $107c46e4730f9658$export$13e3392192263954;
var $107c46e4730f9658$export$b8f5890fc79d6aca;
var $107c46e4730f9658$export$60241385465d0a34;
var $107c46e4730f9658$export$306c0aa65ff9ec16;
var $107c46e4730f9658$export$7b286972b8d8ccbf;
var $107c46e4730f9658$export$83d89fbfd8236492;
"use strict";
var $107c46e4730f9658$var$l = Symbol.for("react.element"), $107c46e4730f9658$var$n = Symbol.for("react.portal"), $107c46e4730f9658$var$p = Symbol.for("react.fragment"), $107c46e4730f9658$var$q = Symbol.for("react.strict_mode"), $107c46e4730f9658$var$r = Symbol.for("react.profiler"), $107c46e4730f9658$var$t = Symbol.for("react.provider"), $107c46e4730f9658$var$u = Symbol.for("react.context"), $107c46e4730f9658$var$v = Symbol.for("react.forward_ref"), $107c46e4730f9658$var$w = Symbol.for("react.suspense"), $107c46e4730f9658$var$x = Symbol.for("react.memo"), $107c46e4730f9658$var$y = Symbol.for("react.lazy"), $107c46e4730f9658$var$z = Symbol.iterator;
function $107c46e4730f9658$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $107c46e4730f9658$var$z && a[$107c46e4730f9658$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $107c46e4730f9658$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $107c46e4730f9658$var$C = Object.assign, $107c46e4730f9658$var$D = {};
function $107c46e4730f9658$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $107c46e4730f9658$var$D;
    this.updater = e || $107c46e4730f9658$var$B;
}
$107c46e4730f9658$var$E.prototype.isReactComponent = {};
$107c46e4730f9658$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$107c46e4730f9658$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $107c46e4730f9658$var$F() {}
$107c46e4730f9658$var$F.prototype = $107c46e4730f9658$var$E.prototype;
function $107c46e4730f9658$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $107c46e4730f9658$var$D;
    this.updater = e || $107c46e4730f9658$var$B;
}
var $107c46e4730f9658$var$H = $107c46e4730f9658$var$G.prototype = new $107c46e4730f9658$var$F;
$107c46e4730f9658$var$H.constructor = $107c46e4730f9658$var$G;
$107c46e4730f9658$var$C($107c46e4730f9658$var$H, $107c46e4730f9658$var$E.prototype);
$107c46e4730f9658$var$H.isPureReactComponent = !0;
var $107c46e4730f9658$var$I = Array.isArray, $107c46e4730f9658$var$J = Object.prototype.hasOwnProperty, $107c46e4730f9658$var$K = {
    current: null
}, $107c46e4730f9658$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $107c46e4730f9658$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$107c46e4730f9658$var$J.call(b, d) && !$107c46e4730f9658$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $107c46e4730f9658$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $107c46e4730f9658$var$K.current
    };
}
function $107c46e4730f9658$var$N(a, b) {
    return {
        $$typeof: $107c46e4730f9658$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $107c46e4730f9658$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $107c46e4730f9658$var$l;
}
function $107c46e4730f9658$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $107c46e4730f9658$var$P = /\/+/g;
function $107c46e4730f9658$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $107c46e4730f9658$var$escape("" + a.key) : b.toString(36);
}
function $107c46e4730f9658$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $107c46e4730f9658$var$l:
                case $107c46e4730f9658$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $107c46e4730f9658$var$Q(h, 0) : d, $107c46e4730f9658$var$I(c) ? (e = "", null != a && (e = a.replace($107c46e4730f9658$var$P, "$&/") + "/"), $107c46e4730f9658$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($107c46e4730f9658$var$O(c) && (c = $107c46e4730f9658$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($107c46e4730f9658$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($107c46e4730f9658$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $107c46e4730f9658$var$Q(k, g);
        h += $107c46e4730f9658$var$R(k, b, e, f, c);
    }
    else if (f = $107c46e4730f9658$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $107c46e4730f9658$var$Q(k, g++), h += $107c46e4730f9658$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $107c46e4730f9658$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $107c46e4730f9658$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $107c46e4730f9658$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $107c46e4730f9658$var$U = {
    current: null
}, $107c46e4730f9658$var$V = {
    transition: null
}, $107c46e4730f9658$var$W = {
    ReactCurrentDispatcher: $107c46e4730f9658$var$U,
    ReactCurrentBatchConfig: $107c46e4730f9658$var$V,
    ReactCurrentOwner: $107c46e4730f9658$var$K
};
$107c46e4730f9658$export$dca3b0875bd9a954 = {
    map: $107c46e4730f9658$var$S,
    forEach: function(a, b, e) {
        $107c46e4730f9658$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $107c46e4730f9658$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $107c46e4730f9658$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$107c46e4730f9658$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$107c46e4730f9658$export$16fa2f45be04daa8 = $107c46e4730f9658$var$E;
$107c46e4730f9658$export$ffb0004e005737fa = $107c46e4730f9658$var$p;
$107c46e4730f9658$export$e2c29f18771995cb = $107c46e4730f9658$var$r;
$107c46e4730f9658$export$221d75b3f55bb0bd = $107c46e4730f9658$var$G;
$107c46e4730f9658$export$5f8d39834fd61797 = $107c46e4730f9658$var$q;
$107c46e4730f9658$export$74bf444e3cd11ea5 = $107c46e4730f9658$var$w;
$107c46e4730f9658$export$ae55be85d98224ed = $107c46e4730f9658$var$W;
$107c46e4730f9658$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $107c46e4730f9658$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $107c46e4730f9658$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$107c46e4730f9658$var$J.call(b, f) && !$107c46e4730f9658$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $107c46e4730f9658$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$107c46e4730f9658$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $107c46e4730f9658$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $107c46e4730f9658$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$107c46e4730f9658$export$c8a8987d4410bf2d = $107c46e4730f9658$var$M;
$107c46e4730f9658$export$d38cd72104c1f0e9 = function(a) {
    var b = $107c46e4730f9658$var$M.bind(null, a);
    b.type = a;
    return b;
};
$107c46e4730f9658$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$107c46e4730f9658$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $107c46e4730f9658$var$v,
        render: a
    };
};
$107c46e4730f9658$export$a8257692ac88316c = $107c46e4730f9658$var$O;
$107c46e4730f9658$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $107c46e4730f9658$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $107c46e4730f9658$var$T
    };
};
$107c46e4730f9658$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $107c46e4730f9658$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$107c46e4730f9658$export$7568632d0d33d16d = function(a) {
    var b = $107c46e4730f9658$var$V.transition;
    $107c46e4730f9658$var$V.transition = {};
    try {
        a();
    } finally{
        $107c46e4730f9658$var$V.transition = b;
    }
};
$107c46e4730f9658$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$107c46e4730f9658$export$35808ee640e87ca7 = function(a, b) {
    return $107c46e4730f9658$var$U.current.useCallback(a, b);
};
$107c46e4730f9658$export$fae74005e78b1a27 = function(a) {
    return $107c46e4730f9658$var$U.current.useContext(a);
};
$107c46e4730f9658$export$dc8fbce3eb94dc1e = function() {};
$107c46e4730f9658$export$6a7bc4e911dc01cf = function(a) {
    return $107c46e4730f9658$var$U.current.useDeferredValue(a);
};
$107c46e4730f9658$export$6d9c69b0de29b591 = function(a, b) {
    return $107c46e4730f9658$var$U.current.useEffect(a, b);
};
$107c46e4730f9658$export$f680877a34711e37 = function() {
    return $107c46e4730f9658$var$U.current.useId();
};
$107c46e4730f9658$export$d5a552a76deda3c2 = function(a, b, e) {
    return $107c46e4730f9658$var$U.current.useImperativeHandle(a, b, e);
};
$107c46e4730f9658$export$aaabe4eda9ed9969 = function(a, b) {
    return $107c46e4730f9658$var$U.current.useInsertionEffect(a, b);
};
$107c46e4730f9658$export$e5c5a5f917a5871c = function(a, b) {
    return $107c46e4730f9658$var$U.current.useLayoutEffect(a, b);
};
$107c46e4730f9658$export$1538c33de8887b59 = function(a, b) {
    return $107c46e4730f9658$var$U.current.useMemo(a, b);
};
$107c46e4730f9658$export$13e3392192263954 = function(a, b, e) {
    return $107c46e4730f9658$var$U.current.useReducer(a, b, e);
};
$107c46e4730f9658$export$b8f5890fc79d6aca = function(a) {
    return $107c46e4730f9658$var$U.current.useRef(a);
};
$107c46e4730f9658$export$60241385465d0a34 = function(a) {
    return $107c46e4730f9658$var$U.current.useState(a);
};
$107c46e4730f9658$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $107c46e4730f9658$var$U.current.useSyncExternalStore(a, b, e);
};
$107c46e4730f9658$export$7b286972b8d8ccbf = function() {
    return $107c46e4730f9658$var$U.current.useTransition();
};
$107c46e4730f9658$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("8i6oL", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kABRc = parcelRequire("kABRc");
function $6094f7c74a80ac36$var$emptyFunction() {}
function $6094f7c74a80ac36$var$emptyFunctionWithReset() {}
$6094f7c74a80ac36$var$emptyFunctionWithReset.resetWarningCache = $6094f7c74a80ac36$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kABRc) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $6094f7c74a80ac36$var$emptyFunctionWithReset,
        resetWarningCache: $6094f7c74a80ac36$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kABRc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $efd489137c87ab6c$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $efd489137c87ab6c$var$ReactPropTypesSecret;

});


parcelRegister("3HlGj", function(module, exports) {
"use strict";

var $5fo1G = parcelRequire("5fo1G");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $2b1634c126835a35$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $2b1634c126835a35$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $2b1634c126835a35$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $2b1634c126835a35$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $2b1634c126835a35$var$TYPE_STATICS = {};
$2b1634c126835a35$var$TYPE_STATICS[$5fo1G.ForwardRef] = $2b1634c126835a35$var$FORWARD_REF_STATICS;
$2b1634c126835a35$var$TYPE_STATICS[$5fo1G.Memo] = $2b1634c126835a35$var$MEMO_STATICS;
function $2b1634c126835a35$var$getStatics(component) {
    // React v16.11 and below
    if ($5fo1G.isMemo(component)) return $2b1634c126835a35$var$MEMO_STATICS;
     // React v16.12 and above
    return $2b1634c126835a35$var$TYPE_STATICS[component["$$typeof"]] || $2b1634c126835a35$var$REACT_STATICS;
}
var $2b1634c126835a35$var$defineProperty = Object.defineProperty;
var $2b1634c126835a35$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $2b1634c126835a35$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $2b1634c126835a35$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $2b1634c126835a35$var$getPrototypeOf = Object.getPrototypeOf;
var $2b1634c126835a35$var$objectPrototype = Object.prototype;
function $2b1634c126835a35$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($2b1634c126835a35$var$objectPrototype) {
            var inheritedComponent = $2b1634c126835a35$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $2b1634c126835a35$var$objectPrototype) $2b1634c126835a35$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $2b1634c126835a35$var$getOwnPropertyNames(sourceComponent);
        if ($2b1634c126835a35$var$getOwnPropertySymbols) keys = keys.concat($2b1634c126835a35$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $2b1634c126835a35$var$getStatics(targetComponent);
        var sourceStatics = $2b1634c126835a35$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$2b1634c126835a35$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $2b1634c126835a35$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $2b1634c126835a35$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $2b1634c126835a35$var$hoistNonReactStatics;

});
parcelRegister("5fo1G", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3ehIe"));

});
parcelRegister("3ehIe", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $25a06b39950824e2$export$2b8d127b894957b9; }, function (v) { return $25a06b39950824e2$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $25a06b39950824e2$export$cea3a54a6425200c; }, function (v) { return $25a06b39950824e2$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $25a06b39950824e2$export$a7c73072b1a182ae; }, function (v) { return $25a06b39950824e2$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $25a06b39950824e2$export$9f27bc3417b4524d; }, function (v) { return $25a06b39950824e2$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $25a06b39950824e2$export$db77ccec0bb4ccac; }, function (v) { return $25a06b39950824e2$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $25a06b39950824e2$export$8392c0c9d3dcbd35; }, function (v) { return $25a06b39950824e2$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $25a06b39950824e2$export$ffb0004e005737fa; }, function (v) { return $25a06b39950824e2$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $25a06b39950824e2$export$b624eff549462981; }, function (v) { return $25a06b39950824e2$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $25a06b39950824e2$export$7897aa7841a5380c; }, function (v) { return $25a06b39950824e2$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $25a06b39950824e2$export$602eac185826482c; }, function (v) { return $25a06b39950824e2$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $25a06b39950824e2$export$e2c29f18771995cb; }, function (v) { return $25a06b39950824e2$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $25a06b39950824e2$export$5f8d39834fd61797; }, function (v) { return $25a06b39950824e2$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $25a06b39950824e2$export$74bf444e3cd11ea5; }, function (v) { return $25a06b39950824e2$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $25a06b39950824e2$export$92387174baf9b227; }, function (v) { return $25a06b39950824e2$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $25a06b39950824e2$export$ec112efeb987d9c6; }, function (v) { return $25a06b39950824e2$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $25a06b39950824e2$export$b706b080d889d2c9; }, function (v) { return $25a06b39950824e2$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $25a06b39950824e2$export$5be5a87408f70ddc; }, function (v) { return $25a06b39950824e2$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $25a06b39950824e2$export$45a5e7f76e0caa8d; }, function (v) { return $25a06b39950824e2$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $25a06b39950824e2$export$455c2e768291efa6; }, function (v) { return $25a06b39950824e2$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $25a06b39950824e2$export$9522e17588c12572; }, function (v) { return $25a06b39950824e2$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $25a06b39950824e2$export$2110ac352bb060b9; }, function (v) { return $25a06b39950824e2$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $25a06b39950824e2$export$56885ab8b9c456ab; }, function (v) { return $25a06b39950824e2$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $25a06b39950824e2$export$d927fcb6adf8f9de; }, function (v) { return $25a06b39950824e2$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $25a06b39950824e2$export$b82d16f27459e05a; }, function (v) { return $25a06b39950824e2$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $25a06b39950824e2$export$522c17b4f5e123e8; }, function (v) { return $25a06b39950824e2$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $25a06b39950824e2$export$1aabd8a0274ecfd6; }, function (v) { return $25a06b39950824e2$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $25a06b39950824e2$export$9b621391a187a31a; }, function (v) { return $25a06b39950824e2$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $25a06b39950824e2$export$f5bbd400c2f4426f; }, function (v) { return $25a06b39950824e2$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $25a06b39950824e2$export$2b8d127b894957b9;
var $25a06b39950824e2$export$cea3a54a6425200c;
var $25a06b39950824e2$export$a7c73072b1a182ae;
var $25a06b39950824e2$export$9f27bc3417b4524d;
var $25a06b39950824e2$export$db77ccec0bb4ccac;
var $25a06b39950824e2$export$8392c0c9d3dcbd35;
var $25a06b39950824e2$export$ffb0004e005737fa;
var $25a06b39950824e2$export$b624eff549462981;
var $25a06b39950824e2$export$7897aa7841a5380c;
var $25a06b39950824e2$export$602eac185826482c;
var $25a06b39950824e2$export$e2c29f18771995cb;
var $25a06b39950824e2$export$5f8d39834fd61797;
var $25a06b39950824e2$export$74bf444e3cd11ea5;
var $25a06b39950824e2$export$92387174baf9b227;
var $25a06b39950824e2$export$ec112efeb987d9c6;
var $25a06b39950824e2$export$b706b080d889d2c9;
var $25a06b39950824e2$export$5be5a87408f70ddc;
var $25a06b39950824e2$export$45a5e7f76e0caa8d;
var $25a06b39950824e2$export$455c2e768291efa6;
var $25a06b39950824e2$export$9522e17588c12572;
var $25a06b39950824e2$export$2110ac352bb060b9;
var $25a06b39950824e2$export$56885ab8b9c456ab;
var $25a06b39950824e2$export$d927fcb6adf8f9de;
var $25a06b39950824e2$export$b82d16f27459e05a;
var $25a06b39950824e2$export$522c17b4f5e123e8;
var $25a06b39950824e2$export$1aabd8a0274ecfd6;
var $25a06b39950824e2$export$9b621391a187a31a;
var $25a06b39950824e2$export$f5bbd400c2f4426f;
"use strict";
var $25a06b39950824e2$var$b = "function" === typeof Symbol && Symbol.for, $25a06b39950824e2$var$c = $25a06b39950824e2$var$b ? Symbol.for("react.element") : 60103, $25a06b39950824e2$var$d = $25a06b39950824e2$var$b ? Symbol.for("react.portal") : 60106, $25a06b39950824e2$var$e = $25a06b39950824e2$var$b ? Symbol.for("react.fragment") : 60107, $25a06b39950824e2$var$f = $25a06b39950824e2$var$b ? Symbol.for("react.strict_mode") : 60108, $25a06b39950824e2$var$g = $25a06b39950824e2$var$b ? Symbol.for("react.profiler") : 60114, $25a06b39950824e2$var$h = $25a06b39950824e2$var$b ? Symbol.for("react.provider") : 60109, $25a06b39950824e2$var$k = $25a06b39950824e2$var$b ? Symbol.for("react.context") : 60110, $25a06b39950824e2$var$l = $25a06b39950824e2$var$b ? Symbol.for("react.async_mode") : 60111, $25a06b39950824e2$var$m = $25a06b39950824e2$var$b ? Symbol.for("react.concurrent_mode") : 60111, $25a06b39950824e2$var$n = $25a06b39950824e2$var$b ? Symbol.for("react.forward_ref") : 60112, $25a06b39950824e2$var$p = $25a06b39950824e2$var$b ? Symbol.for("react.suspense") : 60113, $25a06b39950824e2$var$q = $25a06b39950824e2$var$b ? Symbol.for("react.suspense_list") : 60120, $25a06b39950824e2$var$r = $25a06b39950824e2$var$b ? Symbol.for("react.memo") : 60115, $25a06b39950824e2$var$t = $25a06b39950824e2$var$b ? Symbol.for("react.lazy") : 60116, $25a06b39950824e2$var$v = $25a06b39950824e2$var$b ? Symbol.for("react.block") : 60121, $25a06b39950824e2$var$w = $25a06b39950824e2$var$b ? Symbol.for("react.fundamental") : 60117, $25a06b39950824e2$var$x = $25a06b39950824e2$var$b ? Symbol.for("react.responder") : 60118, $25a06b39950824e2$var$y = $25a06b39950824e2$var$b ? Symbol.for("react.scope") : 60119;
function $25a06b39950824e2$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $25a06b39950824e2$var$c:
                switch(a = a.type, a){
                    case $25a06b39950824e2$var$l:
                    case $25a06b39950824e2$var$m:
                    case $25a06b39950824e2$var$e:
                    case $25a06b39950824e2$var$g:
                    case $25a06b39950824e2$var$f:
                    case $25a06b39950824e2$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $25a06b39950824e2$var$k:
                            case $25a06b39950824e2$var$n:
                            case $25a06b39950824e2$var$t:
                            case $25a06b39950824e2$var$r:
                            case $25a06b39950824e2$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $25a06b39950824e2$var$d:
                return u;
        }
    }
}
function $25a06b39950824e2$var$A(a) {
    return $25a06b39950824e2$var$z(a) === $25a06b39950824e2$var$m;
}
$25a06b39950824e2$export$2b8d127b894957b9 = $25a06b39950824e2$var$l;
$25a06b39950824e2$export$cea3a54a6425200c = $25a06b39950824e2$var$m;
$25a06b39950824e2$export$a7c73072b1a182ae = $25a06b39950824e2$var$k;
$25a06b39950824e2$export$9f27bc3417b4524d = $25a06b39950824e2$var$h;
$25a06b39950824e2$export$db77ccec0bb4ccac = $25a06b39950824e2$var$c;
$25a06b39950824e2$export$8392c0c9d3dcbd35 = $25a06b39950824e2$var$n;
$25a06b39950824e2$export$ffb0004e005737fa = $25a06b39950824e2$var$e;
$25a06b39950824e2$export$b624eff549462981 = $25a06b39950824e2$var$t;
$25a06b39950824e2$export$7897aa7841a5380c = $25a06b39950824e2$var$r;
$25a06b39950824e2$export$602eac185826482c = $25a06b39950824e2$var$d;
$25a06b39950824e2$export$e2c29f18771995cb = $25a06b39950824e2$var$g;
$25a06b39950824e2$export$5f8d39834fd61797 = $25a06b39950824e2$var$f;
$25a06b39950824e2$export$74bf444e3cd11ea5 = $25a06b39950824e2$var$p;
$25a06b39950824e2$export$92387174baf9b227 = function(a) {
    return $25a06b39950824e2$var$A(a) || $25a06b39950824e2$var$z(a) === $25a06b39950824e2$var$l;
};
$25a06b39950824e2$export$ec112efeb987d9c6 = $25a06b39950824e2$var$A;
$25a06b39950824e2$export$b706b080d889d2c9 = function(a) {
    return $25a06b39950824e2$var$z(a) === $25a06b39950824e2$var$k;
};
$25a06b39950824e2$export$5be5a87408f70ddc = function(a) {
    return $25a06b39950824e2$var$z(a) === $25a06b39950824e2$var$h;
};
$25a06b39950824e2$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $25a06b39950824e2$var$c;
};
$25a06b39950824e2$export$455c2e768291efa6 = function(a) {
    return $25a06b39950824e2$var$z(a) === $25a06b39950824e2$var$n;
};
$25a06b39950824e2$export$9522e17588c12572 = function(a) {
    return $25a06b39950824e2$var$z(a) === $25a06b39950824e2$var$e;
};
$25a06b39950824e2$export$2110ac352bb060b9 = function(a) {
    return $25a06b39950824e2$var$z(a) === $25a06b39950824e2$var$t;
};
$25a06b39950824e2$export$56885ab8b9c456ab = function(a) {
    return $25a06b39950824e2$var$z(a) === $25a06b39950824e2$var$r;
};
$25a06b39950824e2$export$d927fcb6adf8f9de = function(a) {
    return $25a06b39950824e2$var$z(a) === $25a06b39950824e2$var$d;
};
$25a06b39950824e2$export$b82d16f27459e05a = function(a) {
    return $25a06b39950824e2$var$z(a) === $25a06b39950824e2$var$g;
};
$25a06b39950824e2$export$522c17b4f5e123e8 = function(a) {
    return $25a06b39950824e2$var$z(a) === $25a06b39950824e2$var$f;
};
$25a06b39950824e2$export$1aabd8a0274ecfd6 = function(a) {
    return $25a06b39950824e2$var$z(a) === $25a06b39950824e2$var$p;
};
$25a06b39950824e2$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $25a06b39950824e2$var$e || a === $25a06b39950824e2$var$m || a === $25a06b39950824e2$var$g || a === $25a06b39950824e2$var$f || a === $25a06b39950824e2$var$p || a === $25a06b39950824e2$var$q || "object" === typeof a && null !== a && (a.$$typeof === $25a06b39950824e2$var$t || a.$$typeof === $25a06b39950824e2$var$r || a.$$typeof === $25a06b39950824e2$var$h || a.$$typeof === $25a06b39950824e2$var$k || a.$$typeof === $25a06b39950824e2$var$n || a.$$typeof === $25a06b39950824e2$var$w || a.$$typeof === $25a06b39950824e2$var$x || a.$$typeof === $25a06b39950824e2$var$y || a.$$typeof === $25a06b39950824e2$var$v);
};
$25a06b39950824e2$export$f5bbd400c2f4426f = $25a06b39950824e2$var$z;

});



parcelRegister("bAW23", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $8710127e0f817e70$export$ae55be85d98224ed; }, function (v) { return $8710127e0f817e70$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $8710127e0f817e70$export$d39a5bbd09211389; }, function (v) { return $8710127e0f817e70$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $8710127e0f817e70$export$882461b6382ed46c; }, function (v) { return $8710127e0f817e70$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $8710127e0f817e70$export$466bfc07425424d5; }, function (v) { return $8710127e0f817e70$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $8710127e0f817e70$export$cd75ccfd720a3cd4; }, function (v) { return $8710127e0f817e70$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $8710127e0f817e70$export$fa8d919ba61d84db; }, function (v) { return $8710127e0f817e70$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $8710127e0f817e70$export$757ceba2d55c277e; }, function (v) { return $8710127e0f817e70$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $8710127e0f817e70$export$b3890eb0ae9dca99; }, function (v) { return $8710127e0f817e70$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $8710127e0f817e70$export$502457920280e6be; }, function (v) { return $8710127e0f817e70$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $8710127e0f817e70$export$c78a37762a8d58e1; }, function (v) { return $8710127e0f817e70$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $8710127e0f817e70$export$dc54d992c10e8a18; }, function (v) { return $8710127e0f817e70$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $8710127e0f817e70$export$83d89fbfd8236492; }, function (v) { return $8710127e0f817e70$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $8710127e0f817e70$export$ae55be85d98224ed;
var $8710127e0f817e70$export$d39a5bbd09211389;
var $8710127e0f817e70$export$882461b6382ed46c;
var $8710127e0f817e70$export$466bfc07425424d5;
var $8710127e0f817e70$export$cd75ccfd720a3cd4;
var $8710127e0f817e70$export$fa8d919ba61d84db;
var $8710127e0f817e70$export$757ceba2d55c277e;
var $8710127e0f817e70$export$b3890eb0ae9dca99;
var $8710127e0f817e70$export$502457920280e6be;
var $8710127e0f817e70$export$c78a37762a8d58e1;
var $8710127e0f817e70$export$dc54d992c10e8a18;
var $8710127e0f817e70$export$83d89fbfd8236492;
"use strict";

var $1T1QG = parcelRequire("1T1QG");

var $fy3yX = parcelRequire("fy3yX");
function $8710127e0f817e70$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $8710127e0f817e70$var$da = new Set, $8710127e0f817e70$var$ea = {};
function $8710127e0f817e70$var$fa(a, b) {
    $8710127e0f817e70$var$ha(a, b);
    $8710127e0f817e70$var$ha(a + "Capture", b);
}
function $8710127e0f817e70$var$ha(a, b) {
    $8710127e0f817e70$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$8710127e0f817e70$var$da.add(b[a]);
}
var $8710127e0f817e70$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $8710127e0f817e70$var$ja = Object.prototype.hasOwnProperty, $8710127e0f817e70$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $8710127e0f817e70$var$la = {}, $8710127e0f817e70$var$ma = {};
function $8710127e0f817e70$var$oa(a) {
    if ($8710127e0f817e70$var$ja.call($8710127e0f817e70$var$ma, a)) return !0;
    if ($8710127e0f817e70$var$ja.call($8710127e0f817e70$var$la, a)) return !1;
    if ($8710127e0f817e70$var$ka.test(a)) return $8710127e0f817e70$var$ma[a] = !0;
    $8710127e0f817e70$var$la[a] = !0;
    return !1;
}
function $8710127e0f817e70$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $8710127e0f817e70$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $8710127e0f817e70$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $8710127e0f817e70$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $8710127e0f817e70$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $8710127e0f817e70$var$z[a] = new $8710127e0f817e70$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $8710127e0f817e70$var$z[b] = new $8710127e0f817e70$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $8710127e0f817e70$var$z[a] = new $8710127e0f817e70$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $8710127e0f817e70$var$z[a] = new $8710127e0f817e70$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $8710127e0f817e70$var$z[a] = new $8710127e0f817e70$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $8710127e0f817e70$var$z[a] = new $8710127e0f817e70$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $8710127e0f817e70$var$z[a] = new $8710127e0f817e70$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $8710127e0f817e70$var$z[a] = new $8710127e0f817e70$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $8710127e0f817e70$var$z[a] = new $8710127e0f817e70$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $8710127e0f817e70$var$ra = /[\-:]([a-z])/g;
function $8710127e0f817e70$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($8710127e0f817e70$var$ra, $8710127e0f817e70$var$sa);
    $8710127e0f817e70$var$z[b] = new $8710127e0f817e70$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($8710127e0f817e70$var$ra, $8710127e0f817e70$var$sa);
    $8710127e0f817e70$var$z[b] = new $8710127e0f817e70$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($8710127e0f817e70$var$ra, $8710127e0f817e70$var$sa);
    $8710127e0f817e70$var$z[b] = new $8710127e0f817e70$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $8710127e0f817e70$var$z[a] = new $8710127e0f817e70$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$8710127e0f817e70$var$z.xlinkHref = new $8710127e0f817e70$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $8710127e0f817e70$var$z[a] = new $8710127e0f817e70$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $8710127e0f817e70$var$ta(a, b, c, d) {
    var e = $8710127e0f817e70$var$z.hasOwnProperty(b) ? $8710127e0f817e70$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $8710127e0f817e70$var$qa(b, c, e, d) && (c = null), d || null === e ? $8710127e0f817e70$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $8710127e0f817e70$var$ua = $1T1QG.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $8710127e0f817e70$var$va = Symbol.for("react.element"), $8710127e0f817e70$var$wa = Symbol.for("react.portal"), $8710127e0f817e70$var$ya = Symbol.for("react.fragment"), $8710127e0f817e70$var$za = Symbol.for("react.strict_mode"), $8710127e0f817e70$var$Aa = Symbol.for("react.profiler"), $8710127e0f817e70$var$Ba = Symbol.for("react.provider"), $8710127e0f817e70$var$Ca = Symbol.for("react.context"), $8710127e0f817e70$var$Da = Symbol.for("react.forward_ref"), $8710127e0f817e70$var$Ea = Symbol.for("react.suspense"), $8710127e0f817e70$var$Fa = Symbol.for("react.suspense_list"), $8710127e0f817e70$var$Ga = Symbol.for("react.memo"), $8710127e0f817e70$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $8710127e0f817e70$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $8710127e0f817e70$var$Ja = Symbol.iterator;
function $8710127e0f817e70$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $8710127e0f817e70$var$Ja && a[$8710127e0f817e70$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $8710127e0f817e70$var$A = Object.assign, $8710127e0f817e70$var$La;
function $8710127e0f817e70$var$Ma(a) {
    if (void 0 === $8710127e0f817e70$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $8710127e0f817e70$var$La = b && b[1] || "";
    }
    return "\n" + $8710127e0f817e70$var$La + a;
}
var $8710127e0f817e70$var$Na = !1;
function $8710127e0f817e70$var$Oa(a, b) {
    if (!a || $8710127e0f817e70$var$Na) return "";
    $8710127e0f817e70$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $8710127e0f817e70$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $8710127e0f817e70$var$Ma(a) : "";
}
function $8710127e0f817e70$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $8710127e0f817e70$var$Ma(a.type);
        case 16:
            return $8710127e0f817e70$var$Ma("Lazy");
        case 13:
            return $8710127e0f817e70$var$Ma("Suspense");
        case 19:
            return $8710127e0f817e70$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $8710127e0f817e70$var$Oa(a.type, !1), a;
        case 11:
            return a = $8710127e0f817e70$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $8710127e0f817e70$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $8710127e0f817e70$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $8710127e0f817e70$var$ya:
            return "Fragment";
        case $8710127e0f817e70$var$wa:
            return "Portal";
        case $8710127e0f817e70$var$Aa:
            return "Profiler";
        case $8710127e0f817e70$var$za:
            return "StrictMode";
        case $8710127e0f817e70$var$Ea:
            return "Suspense";
        case $8710127e0f817e70$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $8710127e0f817e70$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $8710127e0f817e70$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $8710127e0f817e70$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $8710127e0f817e70$var$Ga:
            return b = a.displayName || null, null !== b ? b : $8710127e0f817e70$var$Qa(a.type) || "Memo";
        case $8710127e0f817e70$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $8710127e0f817e70$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $8710127e0f817e70$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $8710127e0f817e70$var$Qa(b);
        case 8:
            return b === $8710127e0f817e70$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $8710127e0f817e70$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $8710127e0f817e70$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $8710127e0f817e70$var$Ua(a) {
    var b = $8710127e0f817e70$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $8710127e0f817e70$var$Va(a) {
    a._valueTracker || (a._valueTracker = $8710127e0f817e70$var$Ua(a));
}
function $8710127e0f817e70$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $8710127e0f817e70$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $8710127e0f817e70$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $8710127e0f817e70$var$Ya(a, b) {
    var c = b.checked;
    return $8710127e0f817e70$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $8710127e0f817e70$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $8710127e0f817e70$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $8710127e0f817e70$var$ab(a, b) {
    b = b.checked;
    null != b && $8710127e0f817e70$var$ta(a, "checked", b, !1);
}
function $8710127e0f817e70$var$bb(a, b) {
    $8710127e0f817e70$var$ab(a, b);
    var c = $8710127e0f817e70$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $8710127e0f817e70$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $8710127e0f817e70$var$cb(a, b.type, $8710127e0f817e70$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $8710127e0f817e70$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $8710127e0f817e70$var$cb(a, b, c) {
    if ("number" !== b || $8710127e0f817e70$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $8710127e0f817e70$var$eb = Array.isArray;
function $8710127e0f817e70$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $8710127e0f817e70$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $8710127e0f817e70$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($8710127e0f817e70$var$p(91));
    return $8710127e0f817e70$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $8710127e0f817e70$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($8710127e0f817e70$var$p(92));
            if ($8710127e0f817e70$var$eb(c)) {
                if (1 < c.length) throw Error($8710127e0f817e70$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $8710127e0f817e70$var$Sa(c)
    };
}
function $8710127e0f817e70$var$ib(a, b) {
    var c = $8710127e0f817e70$var$Sa(b.value), d = $8710127e0f817e70$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $8710127e0f817e70$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $8710127e0f817e70$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $8710127e0f817e70$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $8710127e0f817e70$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $8710127e0f817e70$var$mb, $8710127e0f817e70$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $8710127e0f817e70$var$mb = $8710127e0f817e70$var$mb || document.createElement("div");
        $8710127e0f817e70$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $8710127e0f817e70$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $8710127e0f817e70$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $8710127e0f817e70$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $8710127e0f817e70$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($8710127e0f817e70$var$pb).forEach(function(a) {
    $8710127e0f817e70$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $8710127e0f817e70$var$pb[b] = $8710127e0f817e70$var$pb[a];
    });
});
function $8710127e0f817e70$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $8710127e0f817e70$var$pb.hasOwnProperty(a) && $8710127e0f817e70$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $8710127e0f817e70$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $8710127e0f817e70$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $8710127e0f817e70$var$tb = $8710127e0f817e70$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $8710127e0f817e70$var$ub(a, b) {
    if (b) {
        if ($8710127e0f817e70$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($8710127e0f817e70$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($8710127e0f817e70$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($8710127e0f817e70$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($8710127e0f817e70$var$p(62));
    }
}
function $8710127e0f817e70$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $8710127e0f817e70$var$wb = null;
function $8710127e0f817e70$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $8710127e0f817e70$var$yb = null, $8710127e0f817e70$var$zb = null, $8710127e0f817e70$var$Ab = null;
function $8710127e0f817e70$var$Bb(a) {
    if (a = $8710127e0f817e70$var$Cb(a)) {
        if ("function" !== typeof $8710127e0f817e70$var$yb) throw Error($8710127e0f817e70$var$p(280));
        var b = a.stateNode;
        b && (b = $8710127e0f817e70$var$Db(b), $8710127e0f817e70$var$yb(a.stateNode, a.type, b));
    }
}
function $8710127e0f817e70$var$Eb(a) {
    $8710127e0f817e70$var$zb ? $8710127e0f817e70$var$Ab ? $8710127e0f817e70$var$Ab.push(a) : $8710127e0f817e70$var$Ab = [
        a
    ] : $8710127e0f817e70$var$zb = a;
}
function $8710127e0f817e70$var$Fb() {
    if ($8710127e0f817e70$var$zb) {
        var a = $8710127e0f817e70$var$zb, b = $8710127e0f817e70$var$Ab;
        $8710127e0f817e70$var$Ab = $8710127e0f817e70$var$zb = null;
        $8710127e0f817e70$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$8710127e0f817e70$var$Bb(b[a]);
    }
}
function $8710127e0f817e70$var$Gb(a, b) {
    return a(b);
}
function $8710127e0f817e70$var$Hb() {}
var $8710127e0f817e70$var$Ib = !1;
function $8710127e0f817e70$var$Jb(a, b, c) {
    if ($8710127e0f817e70$var$Ib) return a(b, c);
    $8710127e0f817e70$var$Ib = !0;
    try {
        return $8710127e0f817e70$var$Gb(a, b, c);
    } finally{
        if ($8710127e0f817e70$var$Ib = !1, null !== $8710127e0f817e70$var$zb || null !== $8710127e0f817e70$var$Ab) $8710127e0f817e70$var$Hb(), $8710127e0f817e70$var$Fb();
    }
}
function $8710127e0f817e70$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $8710127e0f817e70$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($8710127e0f817e70$var$p(231, b, typeof c));
    return c;
}
var $8710127e0f817e70$var$Lb = !1;
if ($8710127e0f817e70$var$ia) try {
    var $8710127e0f817e70$var$Mb = {};
    Object.defineProperty($8710127e0f817e70$var$Mb, "passive", {
        get: function() {
            $8710127e0f817e70$var$Lb = !0;
        }
    });
    window.addEventListener("test", $8710127e0f817e70$var$Mb, $8710127e0f817e70$var$Mb);
    window.removeEventListener("test", $8710127e0f817e70$var$Mb, $8710127e0f817e70$var$Mb);
} catch (a) {
    $8710127e0f817e70$var$Lb = !1;
}
function $8710127e0f817e70$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $8710127e0f817e70$var$Ob = !1, $8710127e0f817e70$var$Pb = null, $8710127e0f817e70$var$Qb = !1, $8710127e0f817e70$var$Rb = null, $8710127e0f817e70$var$Sb = {
    onError: function(a) {
        $8710127e0f817e70$var$Ob = !0;
        $8710127e0f817e70$var$Pb = a;
    }
};
function $8710127e0f817e70$var$Tb(a, b, c, d, e, f, g, h, k) {
    $8710127e0f817e70$var$Ob = !1;
    $8710127e0f817e70$var$Pb = null;
    $8710127e0f817e70$var$Nb.apply($8710127e0f817e70$var$Sb, arguments);
}
function $8710127e0f817e70$var$Ub(a, b, c, d, e, f, g, h, k) {
    $8710127e0f817e70$var$Tb.apply(this, arguments);
    if ($8710127e0f817e70$var$Ob) {
        if ($8710127e0f817e70$var$Ob) {
            var l = $8710127e0f817e70$var$Pb;
            $8710127e0f817e70$var$Ob = !1;
            $8710127e0f817e70$var$Pb = null;
        } else throw Error($8710127e0f817e70$var$p(198));
        $8710127e0f817e70$var$Qb || ($8710127e0f817e70$var$Qb = !0, $8710127e0f817e70$var$Rb = l);
    }
}
function $8710127e0f817e70$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $8710127e0f817e70$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $8710127e0f817e70$var$Xb(a) {
    if ($8710127e0f817e70$var$Vb(a) !== a) throw Error($8710127e0f817e70$var$p(188));
}
function $8710127e0f817e70$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $8710127e0f817e70$var$Vb(a);
        if (null === b) throw Error($8710127e0f817e70$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $8710127e0f817e70$var$Xb(e), a;
                if (f === d) return $8710127e0f817e70$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($8710127e0f817e70$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($8710127e0f817e70$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($8710127e0f817e70$var$p(190));
    }
    if (3 !== c.tag) throw Error($8710127e0f817e70$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $8710127e0f817e70$var$Zb(a) {
    a = $8710127e0f817e70$var$Yb(a);
    return null !== a ? $8710127e0f817e70$var$$b(a) : null;
}
function $8710127e0f817e70$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $8710127e0f817e70$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $8710127e0f817e70$var$ac = $fy3yX.unstable_scheduleCallback, $8710127e0f817e70$var$bc = $fy3yX.unstable_cancelCallback, $8710127e0f817e70$var$cc = $fy3yX.unstable_shouldYield, $8710127e0f817e70$var$dc = $fy3yX.unstable_requestPaint, $8710127e0f817e70$var$B = $fy3yX.unstable_now, $8710127e0f817e70$var$ec = $fy3yX.unstable_getCurrentPriorityLevel, $8710127e0f817e70$var$fc = $fy3yX.unstable_ImmediatePriority, $8710127e0f817e70$var$gc = $fy3yX.unstable_UserBlockingPriority, $8710127e0f817e70$var$hc = $fy3yX.unstable_NormalPriority, $8710127e0f817e70$var$ic = $fy3yX.unstable_LowPriority, $8710127e0f817e70$var$jc = $fy3yX.unstable_IdlePriority, $8710127e0f817e70$var$kc = null, $8710127e0f817e70$var$lc = null;
function $8710127e0f817e70$var$mc(a) {
    if ($8710127e0f817e70$var$lc && "function" === typeof $8710127e0f817e70$var$lc.onCommitFiberRoot) try {
        $8710127e0f817e70$var$lc.onCommitFiberRoot($8710127e0f817e70$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $8710127e0f817e70$var$oc = Math.clz32 ? Math.clz32 : $8710127e0f817e70$var$nc, $8710127e0f817e70$var$pc = Math.log, $8710127e0f817e70$var$qc = Math.LN2;
function $8710127e0f817e70$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($8710127e0f817e70$var$pc(a) / $8710127e0f817e70$var$qc | 0) | 0;
}
var $8710127e0f817e70$var$rc = 64, $8710127e0f817e70$var$sc = 4194304;
function $8710127e0f817e70$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $8710127e0f817e70$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $8710127e0f817e70$var$tc(h) : (f &= g, 0 !== f && (d = $8710127e0f817e70$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $8710127e0f817e70$var$tc(g) : 0 !== f && (d = $8710127e0f817e70$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $8710127e0f817e70$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $8710127e0f817e70$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $8710127e0f817e70$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $8710127e0f817e70$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $8710127e0f817e70$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $8710127e0f817e70$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $8710127e0f817e70$var$yc() {
    var a = $8710127e0f817e70$var$rc;
    $8710127e0f817e70$var$rc <<= 1;
    0 === ($8710127e0f817e70$var$rc & 4194240) && ($8710127e0f817e70$var$rc = 64);
    return a;
}
function $8710127e0f817e70$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $8710127e0f817e70$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $8710127e0f817e70$var$oc(b);
    a[b] = c;
}
function $8710127e0f817e70$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $8710127e0f817e70$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $8710127e0f817e70$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $8710127e0f817e70$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $8710127e0f817e70$var$C = 0;
function $8710127e0f817e70$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $8710127e0f817e70$var$Ec, $8710127e0f817e70$var$Fc, $8710127e0f817e70$var$Gc, $8710127e0f817e70$var$Hc, $8710127e0f817e70$var$Ic, $8710127e0f817e70$var$Jc = !1, $8710127e0f817e70$var$Kc = [], $8710127e0f817e70$var$Lc = null, $8710127e0f817e70$var$Mc = null, $8710127e0f817e70$var$Nc = null, $8710127e0f817e70$var$Oc = new Map, $8710127e0f817e70$var$Pc = new Map, $8710127e0f817e70$var$Qc = [], $8710127e0f817e70$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $8710127e0f817e70$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $8710127e0f817e70$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $8710127e0f817e70$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $8710127e0f817e70$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $8710127e0f817e70$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $8710127e0f817e70$var$Pc.delete(b.pointerId);
    }
}
function $8710127e0f817e70$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $8710127e0f817e70$var$Cb(b), null !== b && $8710127e0f817e70$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $8710127e0f817e70$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $8710127e0f817e70$var$Lc = $8710127e0f817e70$var$Tc($8710127e0f817e70$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $8710127e0f817e70$var$Mc = $8710127e0f817e70$var$Tc($8710127e0f817e70$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $8710127e0f817e70$var$Nc = $8710127e0f817e70$var$Tc($8710127e0f817e70$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $8710127e0f817e70$var$Oc.set(f, $8710127e0f817e70$var$Tc($8710127e0f817e70$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $8710127e0f817e70$var$Pc.set(f, $8710127e0f817e70$var$Tc($8710127e0f817e70$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $8710127e0f817e70$var$Vc(a) {
    var b = $8710127e0f817e70$var$Wc(a.target);
    if (null !== b) {
        var c = $8710127e0f817e70$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $8710127e0f817e70$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $8710127e0f817e70$var$Ic(a.priority, function() {
                        $8710127e0f817e70$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $8710127e0f817e70$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $8710127e0f817e70$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $8710127e0f817e70$var$wb = d;
            c.target.dispatchEvent(d);
            $8710127e0f817e70$var$wb = null;
        } else return b = $8710127e0f817e70$var$Cb(c), null !== b && $8710127e0f817e70$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $8710127e0f817e70$var$Zc(a, b, c) {
    $8710127e0f817e70$var$Xc(a) && c.delete(b);
}
function $8710127e0f817e70$var$$c() {
    $8710127e0f817e70$var$Jc = !1;
    null !== $8710127e0f817e70$var$Lc && $8710127e0f817e70$var$Xc($8710127e0f817e70$var$Lc) && ($8710127e0f817e70$var$Lc = null);
    null !== $8710127e0f817e70$var$Mc && $8710127e0f817e70$var$Xc($8710127e0f817e70$var$Mc) && ($8710127e0f817e70$var$Mc = null);
    null !== $8710127e0f817e70$var$Nc && $8710127e0f817e70$var$Xc($8710127e0f817e70$var$Nc) && ($8710127e0f817e70$var$Nc = null);
    $8710127e0f817e70$var$Oc.forEach($8710127e0f817e70$var$Zc);
    $8710127e0f817e70$var$Pc.forEach($8710127e0f817e70$var$Zc);
}
function $8710127e0f817e70$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $8710127e0f817e70$var$Jc || ($8710127e0f817e70$var$Jc = !0, $fy3yX.unstable_scheduleCallback($fy3yX.unstable_NormalPriority, $8710127e0f817e70$var$$c)));
}
function $8710127e0f817e70$var$bd(a) {
    function b(b) {
        return $8710127e0f817e70$var$ad(b, a);
    }
    if (0 < $8710127e0f817e70$var$Kc.length) {
        $8710127e0f817e70$var$ad($8710127e0f817e70$var$Kc[0], a);
        for(var c = 1; c < $8710127e0f817e70$var$Kc.length; c++){
            var d = $8710127e0f817e70$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $8710127e0f817e70$var$Lc && $8710127e0f817e70$var$ad($8710127e0f817e70$var$Lc, a);
    null !== $8710127e0f817e70$var$Mc && $8710127e0f817e70$var$ad($8710127e0f817e70$var$Mc, a);
    null !== $8710127e0f817e70$var$Nc && $8710127e0f817e70$var$ad($8710127e0f817e70$var$Nc, a);
    $8710127e0f817e70$var$Oc.forEach(b);
    $8710127e0f817e70$var$Pc.forEach(b);
    for(c = 0; c < $8710127e0f817e70$var$Qc.length; c++)d = $8710127e0f817e70$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $8710127e0f817e70$var$Qc.length && (c = $8710127e0f817e70$var$Qc[0], null === c.blockedOn);)$8710127e0f817e70$var$Vc(c), null === c.blockedOn && $8710127e0f817e70$var$Qc.shift();
}
var $8710127e0f817e70$var$cd = $8710127e0f817e70$var$ua.ReactCurrentBatchConfig, $8710127e0f817e70$var$dd = !0;
function $8710127e0f817e70$var$ed(a, b, c, d) {
    var e = $8710127e0f817e70$var$C, f = $8710127e0f817e70$var$cd.transition;
    $8710127e0f817e70$var$cd.transition = null;
    try {
        $8710127e0f817e70$var$C = 1, $8710127e0f817e70$var$fd(a, b, c, d);
    } finally{
        $8710127e0f817e70$var$C = e, $8710127e0f817e70$var$cd.transition = f;
    }
}
function $8710127e0f817e70$var$gd(a, b, c, d) {
    var e = $8710127e0f817e70$var$C, f = $8710127e0f817e70$var$cd.transition;
    $8710127e0f817e70$var$cd.transition = null;
    try {
        $8710127e0f817e70$var$C = 4, $8710127e0f817e70$var$fd(a, b, c, d);
    } finally{
        $8710127e0f817e70$var$C = e, $8710127e0f817e70$var$cd.transition = f;
    }
}
function $8710127e0f817e70$var$fd(a, b, c, d) {
    if ($8710127e0f817e70$var$dd) {
        var e = $8710127e0f817e70$var$Yc(a, b, c, d);
        if (null === e) $8710127e0f817e70$var$hd(a, b, d, $8710127e0f817e70$var$id, c), $8710127e0f817e70$var$Sc(a, d);
        else if ($8710127e0f817e70$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($8710127e0f817e70$var$Sc(a, d), b & 4 && -1 < $8710127e0f817e70$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $8710127e0f817e70$var$Cb(e);
                null !== f && $8710127e0f817e70$var$Ec(f);
                f = $8710127e0f817e70$var$Yc(a, b, c, d);
                null === f && $8710127e0f817e70$var$hd(a, b, d, $8710127e0f817e70$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $8710127e0f817e70$var$hd(a, b, d, null, c);
    }
}
var $8710127e0f817e70$var$id = null;
function $8710127e0f817e70$var$Yc(a, b, c, d) {
    $8710127e0f817e70$var$id = null;
    a = $8710127e0f817e70$var$xb(d);
    a = $8710127e0f817e70$var$Wc(a);
    if (null !== a) {
        if (b = $8710127e0f817e70$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $8710127e0f817e70$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $8710127e0f817e70$var$id = a;
    return null;
}
function $8710127e0f817e70$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($8710127e0f817e70$var$ec()){
                case $8710127e0f817e70$var$fc:
                    return 1;
                case $8710127e0f817e70$var$gc:
                    return 4;
                case $8710127e0f817e70$var$hc:
                case $8710127e0f817e70$var$ic:
                    return 16;
                case $8710127e0f817e70$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $8710127e0f817e70$var$kd = null, $8710127e0f817e70$var$ld = null, $8710127e0f817e70$var$md = null;
function $8710127e0f817e70$var$nd() {
    if ($8710127e0f817e70$var$md) return $8710127e0f817e70$var$md;
    var a, b = $8710127e0f817e70$var$ld, c = b.length, d, e = "value" in $8710127e0f817e70$var$kd ? $8710127e0f817e70$var$kd.value : $8710127e0f817e70$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $8710127e0f817e70$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $8710127e0f817e70$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $8710127e0f817e70$var$pd() {
    return !0;
}
function $8710127e0f817e70$var$qd() {
    return !1;
}
function $8710127e0f817e70$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $8710127e0f817e70$var$pd : $8710127e0f817e70$var$qd;
        this.isPropagationStopped = $8710127e0f817e70$var$qd;
        return this;
    }
    $8710127e0f817e70$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $8710127e0f817e70$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $8710127e0f817e70$var$pd);
        },
        persist: function() {},
        isPersistent: $8710127e0f817e70$var$pd
    });
    return b;
}
var $8710127e0f817e70$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $8710127e0f817e70$var$td = $8710127e0f817e70$var$rd($8710127e0f817e70$var$sd), $8710127e0f817e70$var$ud = $8710127e0f817e70$var$A({}, $8710127e0f817e70$var$sd, {
    view: 0,
    detail: 0
}), $8710127e0f817e70$var$vd = $8710127e0f817e70$var$rd($8710127e0f817e70$var$ud), $8710127e0f817e70$var$wd, $8710127e0f817e70$var$xd, $8710127e0f817e70$var$yd, $8710127e0f817e70$var$Ad = $8710127e0f817e70$var$A({}, $8710127e0f817e70$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $8710127e0f817e70$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $8710127e0f817e70$var$yd && ($8710127e0f817e70$var$yd && "mousemove" === a.type ? ($8710127e0f817e70$var$wd = a.screenX - $8710127e0f817e70$var$yd.screenX, $8710127e0f817e70$var$xd = a.screenY - $8710127e0f817e70$var$yd.screenY) : $8710127e0f817e70$var$xd = $8710127e0f817e70$var$wd = 0, $8710127e0f817e70$var$yd = a);
        return $8710127e0f817e70$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $8710127e0f817e70$var$xd;
    }
}), $8710127e0f817e70$var$Bd = $8710127e0f817e70$var$rd($8710127e0f817e70$var$Ad), $8710127e0f817e70$var$Cd = $8710127e0f817e70$var$A({}, $8710127e0f817e70$var$Ad, {
    dataTransfer: 0
}), $8710127e0f817e70$var$Dd = $8710127e0f817e70$var$rd($8710127e0f817e70$var$Cd), $8710127e0f817e70$var$Ed = $8710127e0f817e70$var$A({}, $8710127e0f817e70$var$ud, {
    relatedTarget: 0
}), $8710127e0f817e70$var$Fd = $8710127e0f817e70$var$rd($8710127e0f817e70$var$Ed), $8710127e0f817e70$var$Gd = $8710127e0f817e70$var$A({}, $8710127e0f817e70$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8710127e0f817e70$var$Hd = $8710127e0f817e70$var$rd($8710127e0f817e70$var$Gd), $8710127e0f817e70$var$Id = $8710127e0f817e70$var$A({}, $8710127e0f817e70$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $8710127e0f817e70$var$Jd = $8710127e0f817e70$var$rd($8710127e0f817e70$var$Id), $8710127e0f817e70$var$Kd = $8710127e0f817e70$var$A({}, $8710127e0f817e70$var$sd, {
    data: 0
}), $8710127e0f817e70$var$Ld = $8710127e0f817e70$var$rd($8710127e0f817e70$var$Kd), $8710127e0f817e70$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $8710127e0f817e70$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $8710127e0f817e70$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $8710127e0f817e70$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $8710127e0f817e70$var$Od[a]) ? !!b[a] : !1;
}
function $8710127e0f817e70$var$zd() {
    return $8710127e0f817e70$var$Pd;
}
var $8710127e0f817e70$var$Qd = $8710127e0f817e70$var$A({}, $8710127e0f817e70$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $8710127e0f817e70$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $8710127e0f817e70$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $8710127e0f817e70$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $8710127e0f817e70$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $8710127e0f817e70$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $8710127e0f817e70$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $8710127e0f817e70$var$Rd = $8710127e0f817e70$var$rd($8710127e0f817e70$var$Qd), $8710127e0f817e70$var$Sd = $8710127e0f817e70$var$A({}, $8710127e0f817e70$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $8710127e0f817e70$var$Td = $8710127e0f817e70$var$rd($8710127e0f817e70$var$Sd), $8710127e0f817e70$var$Ud = $8710127e0f817e70$var$A({}, $8710127e0f817e70$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $8710127e0f817e70$var$zd
}), $8710127e0f817e70$var$Vd = $8710127e0f817e70$var$rd($8710127e0f817e70$var$Ud), $8710127e0f817e70$var$Wd = $8710127e0f817e70$var$A({}, $8710127e0f817e70$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8710127e0f817e70$var$Xd = $8710127e0f817e70$var$rd($8710127e0f817e70$var$Wd), $8710127e0f817e70$var$Yd = $8710127e0f817e70$var$A({}, $8710127e0f817e70$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $8710127e0f817e70$var$Zd = $8710127e0f817e70$var$rd($8710127e0f817e70$var$Yd), $8710127e0f817e70$var$$d = [
    9,
    13,
    27,
    32
], $8710127e0f817e70$var$ae = $8710127e0f817e70$var$ia && "CompositionEvent" in window, $8710127e0f817e70$var$be = null;
$8710127e0f817e70$var$ia && "documentMode" in document && ($8710127e0f817e70$var$be = document.documentMode);
var $8710127e0f817e70$var$ce = $8710127e0f817e70$var$ia && "TextEvent" in window && !$8710127e0f817e70$var$be, $8710127e0f817e70$var$de = $8710127e0f817e70$var$ia && (!$8710127e0f817e70$var$ae || $8710127e0f817e70$var$be && 8 < $8710127e0f817e70$var$be && 11 >= $8710127e0f817e70$var$be), $8710127e0f817e70$var$ee = String.fromCharCode(32), $8710127e0f817e70$var$fe = !1;
function $8710127e0f817e70$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $8710127e0f817e70$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $8710127e0f817e70$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $8710127e0f817e70$var$ie = !1;
function $8710127e0f817e70$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $8710127e0f817e70$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $8710127e0f817e70$var$fe = !0;
            return $8710127e0f817e70$var$ee;
        case "textInput":
            return a = b.data, a === $8710127e0f817e70$var$ee && $8710127e0f817e70$var$fe ? null : a;
        default:
            return null;
    }
}
function $8710127e0f817e70$var$ke(a, b) {
    if ($8710127e0f817e70$var$ie) return "compositionend" === a || !$8710127e0f817e70$var$ae && $8710127e0f817e70$var$ge(a, b) ? (a = $8710127e0f817e70$var$nd(), $8710127e0f817e70$var$md = $8710127e0f817e70$var$ld = $8710127e0f817e70$var$kd = null, $8710127e0f817e70$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $8710127e0f817e70$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $8710127e0f817e70$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $8710127e0f817e70$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$8710127e0f817e70$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $8710127e0f817e70$var$ne(a, b, c, d) {
    $8710127e0f817e70$var$Eb(d);
    b = $8710127e0f817e70$var$oe(b, "onChange");
    0 < b.length && (c = new $8710127e0f817e70$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $8710127e0f817e70$var$pe = null, $8710127e0f817e70$var$qe = null;
function $8710127e0f817e70$var$re(a) {
    $8710127e0f817e70$var$se(a, 0);
}
function $8710127e0f817e70$var$te(a) {
    var b = $8710127e0f817e70$var$ue(a);
    if ($8710127e0f817e70$var$Wa(b)) return a;
}
function $8710127e0f817e70$var$ve(a, b) {
    if ("change" === a) return b;
}
var $8710127e0f817e70$var$we = !1;
if ($8710127e0f817e70$var$ia) {
    var $8710127e0f817e70$var$xe;
    if ($8710127e0f817e70$var$ia) {
        var $8710127e0f817e70$var$ye = "oninput" in document;
        if (!$8710127e0f817e70$var$ye) {
            var $8710127e0f817e70$var$ze = document.createElement("div");
            $8710127e0f817e70$var$ze.setAttribute("oninput", "return;");
            $8710127e0f817e70$var$ye = "function" === typeof $8710127e0f817e70$var$ze.oninput;
        }
        $8710127e0f817e70$var$xe = $8710127e0f817e70$var$ye;
    } else $8710127e0f817e70$var$xe = !1;
    $8710127e0f817e70$var$we = $8710127e0f817e70$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $8710127e0f817e70$var$Ae() {
    $8710127e0f817e70$var$pe && ($8710127e0f817e70$var$pe.detachEvent("onpropertychange", $8710127e0f817e70$var$Be), $8710127e0f817e70$var$qe = $8710127e0f817e70$var$pe = null);
}
function $8710127e0f817e70$var$Be(a) {
    if ("value" === a.propertyName && $8710127e0f817e70$var$te($8710127e0f817e70$var$qe)) {
        var b = [];
        $8710127e0f817e70$var$ne(b, $8710127e0f817e70$var$qe, a, $8710127e0f817e70$var$xb(a));
        $8710127e0f817e70$var$Jb($8710127e0f817e70$var$re, b);
    }
}
function $8710127e0f817e70$var$Ce(a, b, c) {
    "focusin" === a ? ($8710127e0f817e70$var$Ae(), $8710127e0f817e70$var$pe = b, $8710127e0f817e70$var$qe = c, $8710127e0f817e70$var$pe.attachEvent("onpropertychange", $8710127e0f817e70$var$Be)) : "focusout" === a && $8710127e0f817e70$var$Ae();
}
function $8710127e0f817e70$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $8710127e0f817e70$var$te($8710127e0f817e70$var$qe);
}
function $8710127e0f817e70$var$Ee(a, b) {
    if ("click" === a) return $8710127e0f817e70$var$te(b);
}
function $8710127e0f817e70$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $8710127e0f817e70$var$te(b);
}
function $8710127e0f817e70$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $8710127e0f817e70$var$He = "function" === typeof Object.is ? Object.is : $8710127e0f817e70$var$Ge;
function $8710127e0f817e70$var$Ie(a, b) {
    if ($8710127e0f817e70$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$8710127e0f817e70$var$ja.call(b, e) || !$8710127e0f817e70$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $8710127e0f817e70$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $8710127e0f817e70$var$Ke(a, b) {
    var c = $8710127e0f817e70$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $8710127e0f817e70$var$Je(c);
    }
}
function $8710127e0f817e70$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $8710127e0f817e70$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $8710127e0f817e70$var$Me() {
    for(var a = window, b = $8710127e0f817e70$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $8710127e0f817e70$var$Xa(a.document);
    }
    return b;
}
function $8710127e0f817e70$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $8710127e0f817e70$var$Oe(a) {
    var b = $8710127e0f817e70$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $8710127e0f817e70$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $8710127e0f817e70$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $8710127e0f817e70$var$Ke(c, f);
                var g = $8710127e0f817e70$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $8710127e0f817e70$var$Pe = $8710127e0f817e70$var$ia && "documentMode" in document && 11 >= document.documentMode, $8710127e0f817e70$var$Qe = null, $8710127e0f817e70$var$Re = null, $8710127e0f817e70$var$Se = null, $8710127e0f817e70$var$Te = !1;
function $8710127e0f817e70$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $8710127e0f817e70$var$Te || null == $8710127e0f817e70$var$Qe || $8710127e0f817e70$var$Qe !== $8710127e0f817e70$var$Xa(d) || (d = $8710127e0f817e70$var$Qe, "selectionStart" in d && $8710127e0f817e70$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $8710127e0f817e70$var$Se && $8710127e0f817e70$var$Ie($8710127e0f817e70$var$Se, d) || ($8710127e0f817e70$var$Se = d, d = $8710127e0f817e70$var$oe($8710127e0f817e70$var$Re, "onSelect"), 0 < d.length && (b = new $8710127e0f817e70$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $8710127e0f817e70$var$Qe)));
}
function $8710127e0f817e70$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $8710127e0f817e70$var$We = {
    animationend: $8710127e0f817e70$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $8710127e0f817e70$var$Ve("Animation", "AnimationIteration"),
    animationstart: $8710127e0f817e70$var$Ve("Animation", "AnimationStart"),
    transitionend: $8710127e0f817e70$var$Ve("Transition", "TransitionEnd")
}, $8710127e0f817e70$var$Xe = {}, $8710127e0f817e70$var$Ye = {};
$8710127e0f817e70$var$ia && ($8710127e0f817e70$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $8710127e0f817e70$var$We.animationend.animation, delete $8710127e0f817e70$var$We.animationiteration.animation, delete $8710127e0f817e70$var$We.animationstart.animation), "TransitionEvent" in window || delete $8710127e0f817e70$var$We.transitionend.transition);
function $8710127e0f817e70$var$Ze(a) {
    if ($8710127e0f817e70$var$Xe[a]) return $8710127e0f817e70$var$Xe[a];
    if (!$8710127e0f817e70$var$We[a]) return a;
    var b = $8710127e0f817e70$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $8710127e0f817e70$var$Ye) return $8710127e0f817e70$var$Xe[a] = b[c];
    return a;
}
var $8710127e0f817e70$var$$e = $8710127e0f817e70$var$Ze("animationend"), $8710127e0f817e70$var$af = $8710127e0f817e70$var$Ze("animationiteration"), $8710127e0f817e70$var$bf = $8710127e0f817e70$var$Ze("animationstart"), $8710127e0f817e70$var$cf = $8710127e0f817e70$var$Ze("transitionend"), $8710127e0f817e70$var$df = new Map, $8710127e0f817e70$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $8710127e0f817e70$var$ff(a, b) {
    $8710127e0f817e70$var$df.set(a, b);
    $8710127e0f817e70$var$fa(b, [
        a
    ]);
}
for(var $8710127e0f817e70$var$gf = 0; $8710127e0f817e70$var$gf < $8710127e0f817e70$var$ef.length; $8710127e0f817e70$var$gf++){
    var $8710127e0f817e70$var$hf = $8710127e0f817e70$var$ef[$8710127e0f817e70$var$gf], $8710127e0f817e70$var$jf = $8710127e0f817e70$var$hf.toLowerCase(), $8710127e0f817e70$var$kf = $8710127e0f817e70$var$hf[0].toUpperCase() + $8710127e0f817e70$var$hf.slice(1);
    $8710127e0f817e70$var$ff($8710127e0f817e70$var$jf, "on" + $8710127e0f817e70$var$kf);
}
$8710127e0f817e70$var$ff($8710127e0f817e70$var$$e, "onAnimationEnd");
$8710127e0f817e70$var$ff($8710127e0f817e70$var$af, "onAnimationIteration");
$8710127e0f817e70$var$ff($8710127e0f817e70$var$bf, "onAnimationStart");
$8710127e0f817e70$var$ff("dblclick", "onDoubleClick");
$8710127e0f817e70$var$ff("focusin", "onFocus");
$8710127e0f817e70$var$ff("focusout", "onBlur");
$8710127e0f817e70$var$ff($8710127e0f817e70$var$cf, "onTransitionEnd");
$8710127e0f817e70$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$8710127e0f817e70$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$8710127e0f817e70$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$8710127e0f817e70$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$8710127e0f817e70$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$8710127e0f817e70$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$8710127e0f817e70$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$8710127e0f817e70$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$8710127e0f817e70$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$8710127e0f817e70$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $8710127e0f817e70$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $8710127e0f817e70$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($8710127e0f817e70$var$lf));
function $8710127e0f817e70$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $8710127e0f817e70$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $8710127e0f817e70$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $8710127e0f817e70$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $8710127e0f817e70$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($8710127e0f817e70$var$Qb) throw a = $8710127e0f817e70$var$Rb, $8710127e0f817e70$var$Qb = !1, $8710127e0f817e70$var$Rb = null, a;
}
function $8710127e0f817e70$var$D(a, b) {
    var c = b[$8710127e0f817e70$var$of];
    void 0 === c && (c = b[$8710127e0f817e70$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($8710127e0f817e70$var$pf(b, a, 2, !1), c.add(d));
}
function $8710127e0f817e70$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $8710127e0f817e70$var$pf(c, a, d, b);
}
var $8710127e0f817e70$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $8710127e0f817e70$var$sf(a) {
    if (!a[$8710127e0f817e70$var$rf]) {
        a[$8710127e0f817e70$var$rf] = !0;
        $8710127e0f817e70$var$da.forEach(function(b) {
            "selectionchange" !== b && ($8710127e0f817e70$var$mf.has(b) || $8710127e0f817e70$var$qf(b, !1, a), $8710127e0f817e70$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$8710127e0f817e70$var$rf] || (b[$8710127e0f817e70$var$rf] = !0, $8710127e0f817e70$var$qf("selectionchange", !1, b));
    }
}
function $8710127e0f817e70$var$pf(a, b, c, d) {
    switch($8710127e0f817e70$var$jd(b)){
        case 1:
            var e = $8710127e0f817e70$var$ed;
            break;
        case 4:
            e = $8710127e0f817e70$var$gd;
            break;
        default:
            e = $8710127e0f817e70$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$8710127e0f817e70$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $8710127e0f817e70$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $8710127e0f817e70$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $8710127e0f817e70$var$Jb(function() {
        var d = f, e = $8710127e0f817e70$var$xb(c), g = [];
        a: {
            var h = $8710127e0f817e70$var$df.get(a);
            if (void 0 !== h) {
                var k = $8710127e0f817e70$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $8710127e0f817e70$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $8710127e0f817e70$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $8710127e0f817e70$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $8710127e0f817e70$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $8710127e0f817e70$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $8710127e0f817e70$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $8710127e0f817e70$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $8710127e0f817e70$var$Vd;
                        break;
                    case $8710127e0f817e70$var$$e:
                    case $8710127e0f817e70$var$af:
                    case $8710127e0f817e70$var$bf:
                        k = $8710127e0f817e70$var$Hd;
                        break;
                    case $8710127e0f817e70$var$cf:
                        k = $8710127e0f817e70$var$Xd;
                        break;
                    case "scroll":
                        k = $8710127e0f817e70$var$vd;
                        break;
                    case "wheel":
                        k = $8710127e0f817e70$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $8710127e0f817e70$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $8710127e0f817e70$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $8710127e0f817e70$var$Kb(w, x), null != F && t.push($8710127e0f817e70$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $8710127e0f817e70$var$wb && (n = c.relatedTarget || c.fromElement) && ($8710127e0f817e70$var$Wc(n) || n[$8710127e0f817e70$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $8710127e0f817e70$var$Wc(n) : null, null !== n && (J = $8710127e0f817e70$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $8710127e0f817e70$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $8710127e0f817e70$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $8710127e0f817e70$var$ue(k);
                        u = null == n ? h : $8710127e0f817e70$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $8710127e0f817e70$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $8710127e0f817e70$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $8710127e0f817e70$var$vf(F))u++;
                            for(; 0 < w - u;)t = $8710127e0f817e70$var$vf(t), w--;
                            for(; 0 < u - w;)x = $8710127e0f817e70$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $8710127e0f817e70$var$vf(t);
                                x = $8710127e0f817e70$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $8710127e0f817e70$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $8710127e0f817e70$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $8710127e0f817e70$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $8710127e0f817e70$var$ve;
                else if ($8710127e0f817e70$var$me(h)) {
                    if ($8710127e0f817e70$var$we) na = $8710127e0f817e70$var$Fe;
                    else {
                        na = $8710127e0f817e70$var$De;
                        var xa = $8710127e0f817e70$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $8710127e0f817e70$var$Ee);
                if (na && (na = na(a, d))) {
                    $8710127e0f817e70$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $8710127e0f817e70$var$cb(h, "number", h.value);
            }
            xa = d ? $8710127e0f817e70$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($8710127e0f817e70$var$me(xa) || "true" === xa.contentEditable) $8710127e0f817e70$var$Qe = xa, $8710127e0f817e70$var$Re = d, $8710127e0f817e70$var$Se = null;
                    break;
                case "focusout":
                    $8710127e0f817e70$var$Se = $8710127e0f817e70$var$Re = $8710127e0f817e70$var$Qe = null;
                    break;
                case "mousedown":
                    $8710127e0f817e70$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $8710127e0f817e70$var$Te = !1;
                    $8710127e0f817e70$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($8710127e0f817e70$var$Pe) break;
                case "keydown":
                case "keyup":
                    $8710127e0f817e70$var$Ue(g, c, e);
            }
            var $a;
            if ($8710127e0f817e70$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $8710127e0f817e70$var$ie ? $8710127e0f817e70$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($8710127e0f817e70$var$de && "ko" !== c.locale && ($8710127e0f817e70$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $8710127e0f817e70$var$ie && ($a = $8710127e0f817e70$var$nd()) : ($8710127e0f817e70$var$kd = e, $8710127e0f817e70$var$ld = "value" in $8710127e0f817e70$var$kd ? $8710127e0f817e70$var$kd.value : $8710127e0f817e70$var$kd.textContent, $8710127e0f817e70$var$ie = !0)), xa = $8710127e0f817e70$var$oe(d, ba), 0 < xa.length && (ba = new $8710127e0f817e70$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $8710127e0f817e70$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $8710127e0f817e70$var$ce ? $8710127e0f817e70$var$je(a, c) : $8710127e0f817e70$var$ke(a, c)) d = $8710127e0f817e70$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $8710127e0f817e70$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $8710127e0f817e70$var$se(g, b);
    });
}
function $8710127e0f817e70$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $8710127e0f817e70$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $8710127e0f817e70$var$Kb(a, c), null != f && d.unshift($8710127e0f817e70$var$tf(a, f, e)), f = $8710127e0f817e70$var$Kb(a, b), null != f && d.push($8710127e0f817e70$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $8710127e0f817e70$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $8710127e0f817e70$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $8710127e0f817e70$var$Kb(c, f), null != k && g.unshift($8710127e0f817e70$var$tf(c, k, h))) : e || (k = $8710127e0f817e70$var$Kb(c, f), null != k && g.push($8710127e0f817e70$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $8710127e0f817e70$var$xf = /\r\n?/g, $8710127e0f817e70$var$yf = /\u0000|\uFFFD/g;
function $8710127e0f817e70$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($8710127e0f817e70$var$xf, "\n").replace($8710127e0f817e70$var$yf, "");
}
function $8710127e0f817e70$var$Af(a, b, c) {
    b = $8710127e0f817e70$var$zf(b);
    if ($8710127e0f817e70$var$zf(a) !== b && c) throw Error($8710127e0f817e70$var$p(425));
}
function $8710127e0f817e70$var$Bf() {}
var $8710127e0f817e70$var$Cf = null, $8710127e0f817e70$var$Df = null;
function $8710127e0f817e70$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $8710127e0f817e70$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $8710127e0f817e70$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $8710127e0f817e70$var$Hf = "function" === typeof Promise ? Promise : void 0, $8710127e0f817e70$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $8710127e0f817e70$var$Hf ? function(a) {
    return $8710127e0f817e70$var$Hf.resolve(null).then(a).catch($8710127e0f817e70$var$If);
} : $8710127e0f817e70$var$Ff;
function $8710127e0f817e70$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $8710127e0f817e70$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $8710127e0f817e70$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $8710127e0f817e70$var$bd(b);
}
function $8710127e0f817e70$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $8710127e0f817e70$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $8710127e0f817e70$var$Nf = Math.random().toString(36).slice(2), $8710127e0f817e70$var$Of = "__reactFiber$" + $8710127e0f817e70$var$Nf, $8710127e0f817e70$var$Pf = "__reactProps$" + $8710127e0f817e70$var$Nf, $8710127e0f817e70$var$uf = "__reactContainer$" + $8710127e0f817e70$var$Nf, $8710127e0f817e70$var$of = "__reactEvents$" + $8710127e0f817e70$var$Nf, $8710127e0f817e70$var$Qf = "__reactListeners$" + $8710127e0f817e70$var$Nf, $8710127e0f817e70$var$Rf = "__reactHandles$" + $8710127e0f817e70$var$Nf;
function $8710127e0f817e70$var$Wc(a) {
    var b = a[$8710127e0f817e70$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$8710127e0f817e70$var$uf] || c[$8710127e0f817e70$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $8710127e0f817e70$var$Mf(a); null !== a;){
                if (c = a[$8710127e0f817e70$var$Of]) return c;
                a = $8710127e0f817e70$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $8710127e0f817e70$var$Cb(a) {
    a = a[$8710127e0f817e70$var$Of] || a[$8710127e0f817e70$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $8710127e0f817e70$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($8710127e0f817e70$var$p(33));
}
function $8710127e0f817e70$var$Db(a) {
    return a[$8710127e0f817e70$var$Pf] || null;
}
var $8710127e0f817e70$var$Sf = [], $8710127e0f817e70$var$Tf = -1;
function $8710127e0f817e70$var$Uf(a) {
    return {
        current: a
    };
}
function $8710127e0f817e70$var$E(a) {
    0 > $8710127e0f817e70$var$Tf || (a.current = $8710127e0f817e70$var$Sf[$8710127e0f817e70$var$Tf], $8710127e0f817e70$var$Sf[$8710127e0f817e70$var$Tf] = null, $8710127e0f817e70$var$Tf--);
}
function $8710127e0f817e70$var$G(a, b) {
    $8710127e0f817e70$var$Tf++;
    $8710127e0f817e70$var$Sf[$8710127e0f817e70$var$Tf] = a.current;
    a.current = b;
}
var $8710127e0f817e70$var$Vf = {}, $8710127e0f817e70$var$H = $8710127e0f817e70$var$Uf($8710127e0f817e70$var$Vf), $8710127e0f817e70$var$Wf = $8710127e0f817e70$var$Uf(!1), $8710127e0f817e70$var$Xf = $8710127e0f817e70$var$Vf;
function $8710127e0f817e70$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $8710127e0f817e70$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $8710127e0f817e70$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $8710127e0f817e70$var$$f() {
    $8710127e0f817e70$var$E($8710127e0f817e70$var$Wf);
    $8710127e0f817e70$var$E($8710127e0f817e70$var$H);
}
function $8710127e0f817e70$var$ag(a, b, c) {
    if ($8710127e0f817e70$var$H.current !== $8710127e0f817e70$var$Vf) throw Error($8710127e0f817e70$var$p(168));
    $8710127e0f817e70$var$G($8710127e0f817e70$var$H, b);
    $8710127e0f817e70$var$G($8710127e0f817e70$var$Wf, c);
}
function $8710127e0f817e70$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($8710127e0f817e70$var$p(108, $8710127e0f817e70$var$Ra(a) || "Unknown", e));
    return $8710127e0f817e70$var$A({}, c, d);
}
function $8710127e0f817e70$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $8710127e0f817e70$var$Vf;
    $8710127e0f817e70$var$Xf = $8710127e0f817e70$var$H.current;
    $8710127e0f817e70$var$G($8710127e0f817e70$var$H, a);
    $8710127e0f817e70$var$G($8710127e0f817e70$var$Wf, $8710127e0f817e70$var$Wf.current);
    return !0;
}
function $8710127e0f817e70$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($8710127e0f817e70$var$p(169));
    c ? (a = $8710127e0f817e70$var$bg(a, b, $8710127e0f817e70$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $8710127e0f817e70$var$E($8710127e0f817e70$var$Wf), $8710127e0f817e70$var$E($8710127e0f817e70$var$H), $8710127e0f817e70$var$G($8710127e0f817e70$var$H, a)) : $8710127e0f817e70$var$E($8710127e0f817e70$var$Wf);
    $8710127e0f817e70$var$G($8710127e0f817e70$var$Wf, c);
}
var $8710127e0f817e70$var$eg = null, $8710127e0f817e70$var$fg = !1, $8710127e0f817e70$var$gg = !1;
function $8710127e0f817e70$var$hg(a) {
    null === $8710127e0f817e70$var$eg ? $8710127e0f817e70$var$eg = [
        a
    ] : $8710127e0f817e70$var$eg.push(a);
}
function $8710127e0f817e70$var$ig(a) {
    $8710127e0f817e70$var$fg = !0;
    $8710127e0f817e70$var$hg(a);
}
function $8710127e0f817e70$var$jg() {
    if (!$8710127e0f817e70$var$gg && null !== $8710127e0f817e70$var$eg) {
        $8710127e0f817e70$var$gg = !0;
        var a = 0, b = $8710127e0f817e70$var$C;
        try {
            var c = $8710127e0f817e70$var$eg;
            for($8710127e0f817e70$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $8710127e0f817e70$var$eg = null;
            $8710127e0f817e70$var$fg = !1;
        } catch (e) {
            throw null !== $8710127e0f817e70$var$eg && ($8710127e0f817e70$var$eg = $8710127e0f817e70$var$eg.slice(a + 1)), $8710127e0f817e70$var$ac($8710127e0f817e70$var$fc, $8710127e0f817e70$var$jg), e;
        } finally{
            $8710127e0f817e70$var$C = b, $8710127e0f817e70$var$gg = !1;
        }
    }
    return null;
}
var $8710127e0f817e70$var$kg = [], $8710127e0f817e70$var$lg = 0, $8710127e0f817e70$var$mg = null, $8710127e0f817e70$var$ng = 0, $8710127e0f817e70$var$og = [], $8710127e0f817e70$var$pg = 0, $8710127e0f817e70$var$qg = null, $8710127e0f817e70$var$rg = 1, $8710127e0f817e70$var$sg = "";
function $8710127e0f817e70$var$tg(a, b) {
    $8710127e0f817e70$var$kg[$8710127e0f817e70$var$lg++] = $8710127e0f817e70$var$ng;
    $8710127e0f817e70$var$kg[$8710127e0f817e70$var$lg++] = $8710127e0f817e70$var$mg;
    $8710127e0f817e70$var$mg = a;
    $8710127e0f817e70$var$ng = b;
}
function $8710127e0f817e70$var$ug(a, b, c) {
    $8710127e0f817e70$var$og[$8710127e0f817e70$var$pg++] = $8710127e0f817e70$var$rg;
    $8710127e0f817e70$var$og[$8710127e0f817e70$var$pg++] = $8710127e0f817e70$var$sg;
    $8710127e0f817e70$var$og[$8710127e0f817e70$var$pg++] = $8710127e0f817e70$var$qg;
    $8710127e0f817e70$var$qg = a;
    var d = $8710127e0f817e70$var$rg;
    a = $8710127e0f817e70$var$sg;
    var e = 32 - $8710127e0f817e70$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $8710127e0f817e70$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $8710127e0f817e70$var$rg = 1 << 32 - $8710127e0f817e70$var$oc(b) + e | c << e | d;
        $8710127e0f817e70$var$sg = f + a;
    } else $8710127e0f817e70$var$rg = 1 << f | c << e | d, $8710127e0f817e70$var$sg = a;
}
function $8710127e0f817e70$var$vg(a) {
    null !== a.return && ($8710127e0f817e70$var$tg(a, 1), $8710127e0f817e70$var$ug(a, 1, 0));
}
function $8710127e0f817e70$var$wg(a) {
    for(; a === $8710127e0f817e70$var$mg;)$8710127e0f817e70$var$mg = $8710127e0f817e70$var$kg[--$8710127e0f817e70$var$lg], $8710127e0f817e70$var$kg[$8710127e0f817e70$var$lg] = null, $8710127e0f817e70$var$ng = $8710127e0f817e70$var$kg[--$8710127e0f817e70$var$lg], $8710127e0f817e70$var$kg[$8710127e0f817e70$var$lg] = null;
    for(; a === $8710127e0f817e70$var$qg;)$8710127e0f817e70$var$qg = $8710127e0f817e70$var$og[--$8710127e0f817e70$var$pg], $8710127e0f817e70$var$og[$8710127e0f817e70$var$pg] = null, $8710127e0f817e70$var$sg = $8710127e0f817e70$var$og[--$8710127e0f817e70$var$pg], $8710127e0f817e70$var$og[$8710127e0f817e70$var$pg] = null, $8710127e0f817e70$var$rg = $8710127e0f817e70$var$og[--$8710127e0f817e70$var$pg], $8710127e0f817e70$var$og[$8710127e0f817e70$var$pg] = null;
}
var $8710127e0f817e70$var$xg = null, $8710127e0f817e70$var$yg = null, $8710127e0f817e70$var$I = !1, $8710127e0f817e70$var$zg = null;
function $8710127e0f817e70$var$Ag(a, b) {
    var c = $8710127e0f817e70$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $8710127e0f817e70$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $8710127e0f817e70$var$xg = a, $8710127e0f817e70$var$yg = $8710127e0f817e70$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $8710127e0f817e70$var$xg = a, $8710127e0f817e70$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $8710127e0f817e70$var$qg ? {
                id: $8710127e0f817e70$var$rg,
                overflow: $8710127e0f817e70$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $8710127e0f817e70$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $8710127e0f817e70$var$xg = a, $8710127e0f817e70$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $8710127e0f817e70$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $8710127e0f817e70$var$Eg(a) {
    if ($8710127e0f817e70$var$I) {
        var b = $8710127e0f817e70$var$yg;
        if (b) {
            var c = b;
            if (!$8710127e0f817e70$var$Cg(a, b)) {
                if ($8710127e0f817e70$var$Dg(a)) throw Error($8710127e0f817e70$var$p(418));
                b = $8710127e0f817e70$var$Lf(c.nextSibling);
                var d = $8710127e0f817e70$var$xg;
                b && $8710127e0f817e70$var$Cg(a, b) ? $8710127e0f817e70$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $8710127e0f817e70$var$I = !1, $8710127e0f817e70$var$xg = a);
            }
        } else {
            if ($8710127e0f817e70$var$Dg(a)) throw Error($8710127e0f817e70$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $8710127e0f817e70$var$I = !1;
            $8710127e0f817e70$var$xg = a;
        }
    }
}
function $8710127e0f817e70$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $8710127e0f817e70$var$xg = a;
}
function $8710127e0f817e70$var$Gg(a) {
    if (a !== $8710127e0f817e70$var$xg) return !1;
    if (!$8710127e0f817e70$var$I) return $8710127e0f817e70$var$Fg(a), $8710127e0f817e70$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$8710127e0f817e70$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $8710127e0f817e70$var$yg)) {
        if ($8710127e0f817e70$var$Dg(a)) throw $8710127e0f817e70$var$Hg(), Error($8710127e0f817e70$var$p(418));
        for(; b;)$8710127e0f817e70$var$Ag(a, b), b = $8710127e0f817e70$var$Lf(b.nextSibling);
    }
    $8710127e0f817e70$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($8710127e0f817e70$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $8710127e0f817e70$var$yg = $8710127e0f817e70$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $8710127e0f817e70$var$yg = null;
        }
    } else $8710127e0f817e70$var$yg = $8710127e0f817e70$var$xg ? $8710127e0f817e70$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $8710127e0f817e70$var$Hg() {
    for(var a = $8710127e0f817e70$var$yg; a;)a = $8710127e0f817e70$var$Lf(a.nextSibling);
}
function $8710127e0f817e70$var$Ig() {
    $8710127e0f817e70$var$yg = $8710127e0f817e70$var$xg = null;
    $8710127e0f817e70$var$I = !1;
}
function $8710127e0f817e70$var$Jg(a) {
    null === $8710127e0f817e70$var$zg ? $8710127e0f817e70$var$zg = [
        a
    ] : $8710127e0f817e70$var$zg.push(a);
}
var $8710127e0f817e70$var$Kg = $8710127e0f817e70$var$ua.ReactCurrentBatchConfig;
function $8710127e0f817e70$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $8710127e0f817e70$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $8710127e0f817e70$var$Mg = $8710127e0f817e70$var$Uf(null), $8710127e0f817e70$var$Ng = null, $8710127e0f817e70$var$Og = null, $8710127e0f817e70$var$Pg = null;
function $8710127e0f817e70$var$Qg() {
    $8710127e0f817e70$var$Pg = $8710127e0f817e70$var$Og = $8710127e0f817e70$var$Ng = null;
}
function $8710127e0f817e70$var$Rg(a) {
    var b = $8710127e0f817e70$var$Mg.current;
    $8710127e0f817e70$var$E($8710127e0f817e70$var$Mg);
    a._currentValue = b;
}
function $8710127e0f817e70$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $8710127e0f817e70$var$Tg(a, b) {
    $8710127e0f817e70$var$Ng = a;
    $8710127e0f817e70$var$Pg = $8710127e0f817e70$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($8710127e0f817e70$var$Ug = !0), a.firstContext = null);
}
function $8710127e0f817e70$var$Vg(a) {
    var b = a._currentValue;
    if ($8710127e0f817e70$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $8710127e0f817e70$var$Og) {
            if (null === $8710127e0f817e70$var$Ng) throw Error($8710127e0f817e70$var$p(308));
            $8710127e0f817e70$var$Og = a;
            $8710127e0f817e70$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $8710127e0f817e70$var$Og = $8710127e0f817e70$var$Og.next = a;
    }
    return b;
}
var $8710127e0f817e70$var$Wg = null;
function $8710127e0f817e70$var$Xg(a) {
    null === $8710127e0f817e70$var$Wg ? $8710127e0f817e70$var$Wg = [
        a
    ] : $8710127e0f817e70$var$Wg.push(a);
}
function $8710127e0f817e70$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $8710127e0f817e70$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $8710127e0f817e70$var$Zg(a, d);
}
function $8710127e0f817e70$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $8710127e0f817e70$var$$g = !1;
function $8710127e0f817e70$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $8710127e0f817e70$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $8710127e0f817e70$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $8710127e0f817e70$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($8710127e0f817e70$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $8710127e0f817e70$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $8710127e0f817e70$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $8710127e0f817e70$var$Zg(a, c);
}
function $8710127e0f817e70$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $8710127e0f817e70$var$Cc(a, c);
    }
}
function $8710127e0f817e70$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $8710127e0f817e70$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $8710127e0f817e70$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $8710127e0f817e70$var$A({}, q, r);
                            break a;
                        case 2:
                            $8710127e0f817e70$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $8710127e0f817e70$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $8710127e0f817e70$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($8710127e0f817e70$var$p(191, e));
            e.call(d);
        }
    }
}
var $8710127e0f817e70$var$jh = (new $1T1QG.Component).refs;
function $8710127e0f817e70$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8710127e0f817e70$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $8710127e0f817e70$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $8710127e0f817e70$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $8710127e0f817e70$var$L(), e = $8710127e0f817e70$var$lh(a), f = $8710127e0f817e70$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $8710127e0f817e70$var$dh(a, f, e);
        null !== b && ($8710127e0f817e70$var$mh(b, a, e, d), $8710127e0f817e70$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $8710127e0f817e70$var$L(), e = $8710127e0f817e70$var$lh(a), f = $8710127e0f817e70$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $8710127e0f817e70$var$dh(a, f, e);
        null !== b && ($8710127e0f817e70$var$mh(b, a, e, d), $8710127e0f817e70$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $8710127e0f817e70$var$L(), d = $8710127e0f817e70$var$lh(a), e = $8710127e0f817e70$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $8710127e0f817e70$var$dh(a, e, d);
        null !== b && ($8710127e0f817e70$var$mh(b, a, d, c), $8710127e0f817e70$var$eh(b, a, d));
    }
};
function $8710127e0f817e70$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$8710127e0f817e70$var$Ie(c, d) || !$8710127e0f817e70$var$Ie(e, f) : !0;
}
function $8710127e0f817e70$var$ph(a, b, c) {
    var d = !1, e = $8710127e0f817e70$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $8710127e0f817e70$var$Vg(f) : (e = $8710127e0f817e70$var$Zf(b) ? $8710127e0f817e70$var$Xf : $8710127e0f817e70$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $8710127e0f817e70$var$Yf(a, e) : $8710127e0f817e70$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $8710127e0f817e70$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $8710127e0f817e70$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $8710127e0f817e70$var$nh.enqueueReplaceState(b, b.state, null);
}
function $8710127e0f817e70$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $8710127e0f817e70$var$jh;
    $8710127e0f817e70$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $8710127e0f817e70$var$Vg(f) : (f = $8710127e0f817e70$var$Zf(b) ? $8710127e0f817e70$var$Xf : $8710127e0f817e70$var$H.current, e.context = $8710127e0f817e70$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($8710127e0f817e70$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $8710127e0f817e70$var$nh.enqueueReplaceState(e, e.state, null), $8710127e0f817e70$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $8710127e0f817e70$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($8710127e0f817e70$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($8710127e0f817e70$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $8710127e0f817e70$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($8710127e0f817e70$var$p(284));
        if (!c._owner) throw Error($8710127e0f817e70$var$p(290, a));
    }
    return a;
}
function $8710127e0f817e70$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($8710127e0f817e70$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $8710127e0f817e70$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $8710127e0f817e70$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $8710127e0f817e70$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $8710127e0f817e70$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $8710127e0f817e70$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $8710127e0f817e70$var$Ha && $8710127e0f817e70$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $8710127e0f817e70$var$sh(a, b, c), d.return = a, d;
        d = $8710127e0f817e70$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $8710127e0f817e70$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $8710127e0f817e70$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $8710127e0f817e70$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $8710127e0f817e70$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $8710127e0f817e70$var$va:
                    return c = $8710127e0f817e70$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $8710127e0f817e70$var$sh(a, null, b), c.return = a, c;
                case $8710127e0f817e70$var$wa:
                    return b = $8710127e0f817e70$var$zh(b, a.mode, c), b.return = a, b;
                case $8710127e0f817e70$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($8710127e0f817e70$var$eb(b) || $8710127e0f817e70$var$Ka(b)) return b = $8710127e0f817e70$var$Ah(b, a.mode, c, null), b.return = a, b;
            $8710127e0f817e70$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $8710127e0f817e70$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $8710127e0f817e70$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $8710127e0f817e70$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($8710127e0f817e70$var$eb(c) || $8710127e0f817e70$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $8710127e0f817e70$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $8710127e0f817e70$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $8710127e0f817e70$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $8710127e0f817e70$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($8710127e0f817e70$var$eb(d) || $8710127e0f817e70$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $8710127e0f817e70$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $8710127e0f817e70$var$I && $8710127e0f817e70$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $8710127e0f817e70$var$I && $8710127e0f817e70$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $8710127e0f817e70$var$I && $8710127e0f817e70$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $8710127e0f817e70$var$Ka(h);
        if ("function" !== typeof l) throw Error($8710127e0f817e70$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($8710127e0f817e70$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $8710127e0f817e70$var$I && $8710127e0f817e70$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $8710127e0f817e70$var$I && $8710127e0f817e70$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $8710127e0f817e70$var$I && $8710127e0f817e70$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $8710127e0f817e70$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $8710127e0f817e70$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $8710127e0f817e70$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $8710127e0f817e70$var$Ha && $8710127e0f817e70$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $8710127e0f817e70$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $8710127e0f817e70$var$ya ? (d = $8710127e0f817e70$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $8710127e0f817e70$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $8710127e0f817e70$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $8710127e0f817e70$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $8710127e0f817e70$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $8710127e0f817e70$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($8710127e0f817e70$var$eb(f)) return n(a, d, f, h);
            if ($8710127e0f817e70$var$Ka(f)) return t(a, d, f, h);
            $8710127e0f817e70$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $8710127e0f817e70$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $8710127e0f817e70$var$Bh = $8710127e0f817e70$var$vh(!0), $8710127e0f817e70$var$Ch = $8710127e0f817e70$var$vh(!1), $8710127e0f817e70$var$Dh = {}, $8710127e0f817e70$var$Eh = $8710127e0f817e70$var$Uf($8710127e0f817e70$var$Dh), $8710127e0f817e70$var$Fh = $8710127e0f817e70$var$Uf($8710127e0f817e70$var$Dh), $8710127e0f817e70$var$Gh = $8710127e0f817e70$var$Uf($8710127e0f817e70$var$Dh);
function $8710127e0f817e70$var$Hh(a) {
    if (a === $8710127e0f817e70$var$Dh) throw Error($8710127e0f817e70$var$p(174));
    return a;
}
function $8710127e0f817e70$var$Ih(a, b) {
    $8710127e0f817e70$var$G($8710127e0f817e70$var$Gh, b);
    $8710127e0f817e70$var$G($8710127e0f817e70$var$Fh, a);
    $8710127e0f817e70$var$G($8710127e0f817e70$var$Eh, $8710127e0f817e70$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $8710127e0f817e70$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $8710127e0f817e70$var$lb(b, a);
    }
    $8710127e0f817e70$var$E($8710127e0f817e70$var$Eh);
    $8710127e0f817e70$var$G($8710127e0f817e70$var$Eh, b);
}
function $8710127e0f817e70$var$Jh() {
    $8710127e0f817e70$var$E($8710127e0f817e70$var$Eh);
    $8710127e0f817e70$var$E($8710127e0f817e70$var$Fh);
    $8710127e0f817e70$var$E($8710127e0f817e70$var$Gh);
}
function $8710127e0f817e70$var$Kh(a) {
    $8710127e0f817e70$var$Hh($8710127e0f817e70$var$Gh.current);
    var b = $8710127e0f817e70$var$Hh($8710127e0f817e70$var$Eh.current);
    var c = $8710127e0f817e70$var$lb(b, a.type);
    b !== c && ($8710127e0f817e70$var$G($8710127e0f817e70$var$Fh, a), $8710127e0f817e70$var$G($8710127e0f817e70$var$Eh, c));
}
function $8710127e0f817e70$var$Lh(a) {
    $8710127e0f817e70$var$Fh.current === a && ($8710127e0f817e70$var$E($8710127e0f817e70$var$Eh), $8710127e0f817e70$var$E($8710127e0f817e70$var$Fh));
}
var $8710127e0f817e70$var$M = $8710127e0f817e70$var$Uf(0);
function $8710127e0f817e70$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $8710127e0f817e70$var$Nh = [];
function $8710127e0f817e70$var$Oh() {
    for(var a = 0; a < $8710127e0f817e70$var$Nh.length; a++)$8710127e0f817e70$var$Nh[a]._workInProgressVersionPrimary = null;
    $8710127e0f817e70$var$Nh.length = 0;
}
var $8710127e0f817e70$var$Ph = $8710127e0f817e70$var$ua.ReactCurrentDispatcher, $8710127e0f817e70$var$Qh = $8710127e0f817e70$var$ua.ReactCurrentBatchConfig, $8710127e0f817e70$var$Rh = 0, $8710127e0f817e70$var$N = null, $8710127e0f817e70$var$O = null, $8710127e0f817e70$var$P = null, $8710127e0f817e70$var$Sh = !1, $8710127e0f817e70$var$Th = !1, $8710127e0f817e70$var$Uh = 0, $8710127e0f817e70$var$Vh = 0;
function $8710127e0f817e70$var$Q() {
    throw Error($8710127e0f817e70$var$p(321));
}
function $8710127e0f817e70$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$8710127e0f817e70$var$He(a[c], b[c])) return !1;
    return !0;
}
function $8710127e0f817e70$var$Xh(a, b, c, d, e, f) {
    $8710127e0f817e70$var$Rh = f;
    $8710127e0f817e70$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $8710127e0f817e70$var$Ph.current = null === a || null === a.memoizedState ? $8710127e0f817e70$var$Yh : $8710127e0f817e70$var$Zh;
    a = c(d, e);
    if ($8710127e0f817e70$var$Th) {
        f = 0;
        do {
            $8710127e0f817e70$var$Th = !1;
            $8710127e0f817e70$var$Uh = 0;
            if (25 <= f) throw Error($8710127e0f817e70$var$p(301));
            f += 1;
            $8710127e0f817e70$var$P = $8710127e0f817e70$var$O = null;
            b.updateQueue = null;
            $8710127e0f817e70$var$Ph.current = $8710127e0f817e70$var$$h;
            a = c(d, e);
        }while ($8710127e0f817e70$var$Th);
    }
    $8710127e0f817e70$var$Ph.current = $8710127e0f817e70$var$ai;
    b = null !== $8710127e0f817e70$var$O && null !== $8710127e0f817e70$var$O.next;
    $8710127e0f817e70$var$Rh = 0;
    $8710127e0f817e70$var$P = $8710127e0f817e70$var$O = $8710127e0f817e70$var$N = null;
    $8710127e0f817e70$var$Sh = !1;
    if (b) throw Error($8710127e0f817e70$var$p(300));
    return a;
}
function $8710127e0f817e70$var$bi() {
    var a = 0 !== $8710127e0f817e70$var$Uh;
    $8710127e0f817e70$var$Uh = 0;
    return a;
}
function $8710127e0f817e70$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $8710127e0f817e70$var$P ? $8710127e0f817e70$var$N.memoizedState = $8710127e0f817e70$var$P = a : $8710127e0f817e70$var$P = $8710127e0f817e70$var$P.next = a;
    return $8710127e0f817e70$var$P;
}
function $8710127e0f817e70$var$di() {
    if (null === $8710127e0f817e70$var$O) {
        var a = $8710127e0f817e70$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $8710127e0f817e70$var$O.next;
    var b = null === $8710127e0f817e70$var$P ? $8710127e0f817e70$var$N.memoizedState : $8710127e0f817e70$var$P.next;
    if (null !== b) $8710127e0f817e70$var$P = b, $8710127e0f817e70$var$O = a;
    else {
        if (null === a) throw Error($8710127e0f817e70$var$p(310));
        $8710127e0f817e70$var$O = a;
        a = {
            memoizedState: $8710127e0f817e70$var$O.memoizedState,
            baseState: $8710127e0f817e70$var$O.baseState,
            baseQueue: $8710127e0f817e70$var$O.baseQueue,
            queue: $8710127e0f817e70$var$O.queue,
            next: null
        };
        null === $8710127e0f817e70$var$P ? $8710127e0f817e70$var$N.memoizedState = $8710127e0f817e70$var$P = a : $8710127e0f817e70$var$P = $8710127e0f817e70$var$P.next = a;
    }
    return $8710127e0f817e70$var$P;
}
function $8710127e0f817e70$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $8710127e0f817e70$var$fi(a) {
    var b = $8710127e0f817e70$var$di(), c = b.queue;
    if (null === c) throw Error($8710127e0f817e70$var$p(311));
    c.lastRenderedReducer = a;
    var d = $8710127e0f817e70$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($8710127e0f817e70$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $8710127e0f817e70$var$N.lanes |= m;
                $8710127e0f817e70$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $8710127e0f817e70$var$He(d, b.memoizedState) || ($8710127e0f817e70$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $8710127e0f817e70$var$N.lanes |= f, $8710127e0f817e70$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $8710127e0f817e70$var$gi(a) {
    var b = $8710127e0f817e70$var$di(), c = b.queue;
    if (null === c) throw Error($8710127e0f817e70$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $8710127e0f817e70$var$He(f, b.memoizedState) || ($8710127e0f817e70$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $8710127e0f817e70$var$hi() {}
function $8710127e0f817e70$var$ii(a, b) {
    var c = $8710127e0f817e70$var$N, d = $8710127e0f817e70$var$di(), e = b(), f = !$8710127e0f817e70$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $8710127e0f817e70$var$Ug = !0);
    d = d.queue;
    $8710127e0f817e70$var$ji($8710127e0f817e70$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $8710127e0f817e70$var$P && $8710127e0f817e70$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $8710127e0f817e70$var$li(9, $8710127e0f817e70$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $8710127e0f817e70$var$R) throw Error($8710127e0f817e70$var$p(349));
        0 !== ($8710127e0f817e70$var$Rh & 30) || $8710127e0f817e70$var$ni(c, b, e);
    }
    return e;
}
function $8710127e0f817e70$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $8710127e0f817e70$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $8710127e0f817e70$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $8710127e0f817e70$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $8710127e0f817e70$var$oi(b) && $8710127e0f817e70$var$pi(a);
}
function $8710127e0f817e70$var$ki(a, b, c) {
    return c(function() {
        $8710127e0f817e70$var$oi(b) && $8710127e0f817e70$var$pi(a);
    });
}
function $8710127e0f817e70$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$8710127e0f817e70$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $8710127e0f817e70$var$pi(a) {
    var b = $8710127e0f817e70$var$Zg(a, 1);
    null !== b && $8710127e0f817e70$var$mh(b, a, 1, -1);
}
function $8710127e0f817e70$var$qi(a) {
    var b = $8710127e0f817e70$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $8710127e0f817e70$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $8710127e0f817e70$var$ri.bind(null, $8710127e0f817e70$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $8710127e0f817e70$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $8710127e0f817e70$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $8710127e0f817e70$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $8710127e0f817e70$var$si() {
    return $8710127e0f817e70$var$di().memoizedState;
}
function $8710127e0f817e70$var$ti(a, b, c, d) {
    var e = $8710127e0f817e70$var$ci();
    $8710127e0f817e70$var$N.flags |= a;
    e.memoizedState = $8710127e0f817e70$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $8710127e0f817e70$var$ui(a, b, c, d) {
    var e = $8710127e0f817e70$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $8710127e0f817e70$var$O) {
        var g = $8710127e0f817e70$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $8710127e0f817e70$var$Wh(d, g.deps)) {
            e.memoizedState = $8710127e0f817e70$var$li(b, c, f, d);
            return;
        }
    }
    $8710127e0f817e70$var$N.flags |= a;
    e.memoizedState = $8710127e0f817e70$var$li(1 | b, c, f, d);
}
function $8710127e0f817e70$var$vi(a, b) {
    return $8710127e0f817e70$var$ti(8390656, 8, a, b);
}
function $8710127e0f817e70$var$ji(a, b) {
    return $8710127e0f817e70$var$ui(2048, 8, a, b);
}
function $8710127e0f817e70$var$wi(a, b) {
    return $8710127e0f817e70$var$ui(4, 2, a, b);
}
function $8710127e0f817e70$var$xi(a, b) {
    return $8710127e0f817e70$var$ui(4, 4, a, b);
}
function $8710127e0f817e70$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $8710127e0f817e70$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $8710127e0f817e70$var$ui(4, 4, $8710127e0f817e70$var$yi.bind(null, b, a), c);
}
function $8710127e0f817e70$var$Ai() {}
function $8710127e0f817e70$var$Bi(a, b) {
    var c = $8710127e0f817e70$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $8710127e0f817e70$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $8710127e0f817e70$var$Ci(a, b) {
    var c = $8710127e0f817e70$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $8710127e0f817e70$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $8710127e0f817e70$var$Di(a, b, c) {
    if (0 === ($8710127e0f817e70$var$Rh & 21)) return a.baseState && (a.baseState = !1, $8710127e0f817e70$var$Ug = !0), a.memoizedState = c;
    $8710127e0f817e70$var$He(c, b) || (c = $8710127e0f817e70$var$yc(), $8710127e0f817e70$var$N.lanes |= c, $8710127e0f817e70$var$hh |= c, a.baseState = !0);
    return b;
}
function $8710127e0f817e70$var$Ei(a, b) {
    var c = $8710127e0f817e70$var$C;
    $8710127e0f817e70$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $8710127e0f817e70$var$Qh.transition;
    $8710127e0f817e70$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $8710127e0f817e70$var$C = c, $8710127e0f817e70$var$Qh.transition = d;
    }
}
function $8710127e0f817e70$var$Fi() {
    return $8710127e0f817e70$var$di().memoizedState;
}
function $8710127e0f817e70$var$Gi(a, b, c) {
    var d = $8710127e0f817e70$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8710127e0f817e70$var$Hi(a)) $8710127e0f817e70$var$Ii(b, c);
    else if (c = $8710127e0f817e70$var$Yg(a, b, c, d), null !== c) {
        var e = $8710127e0f817e70$var$L();
        $8710127e0f817e70$var$mh(c, a, d, e);
        $8710127e0f817e70$var$Ji(c, b, d);
    }
}
function $8710127e0f817e70$var$ri(a, b, c) {
    var d = $8710127e0f817e70$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8710127e0f817e70$var$Hi(a)) $8710127e0f817e70$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($8710127e0f817e70$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $8710127e0f817e70$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $8710127e0f817e70$var$Yg(a, b, e, d);
        null !== c && (e = $8710127e0f817e70$var$L(), $8710127e0f817e70$var$mh(c, a, d, e), $8710127e0f817e70$var$Ji(c, b, d));
    }
}
function $8710127e0f817e70$var$Hi(a) {
    var b = a.alternate;
    return a === $8710127e0f817e70$var$N || null !== b && b === $8710127e0f817e70$var$N;
}
function $8710127e0f817e70$var$Ii(a, b) {
    $8710127e0f817e70$var$Th = $8710127e0f817e70$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $8710127e0f817e70$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $8710127e0f817e70$var$Cc(a, c);
    }
}
var $8710127e0f817e70$var$ai = {
    readContext: $8710127e0f817e70$var$Vg,
    useCallback: $8710127e0f817e70$var$Q,
    useContext: $8710127e0f817e70$var$Q,
    useEffect: $8710127e0f817e70$var$Q,
    useImperativeHandle: $8710127e0f817e70$var$Q,
    useInsertionEffect: $8710127e0f817e70$var$Q,
    useLayoutEffect: $8710127e0f817e70$var$Q,
    useMemo: $8710127e0f817e70$var$Q,
    useReducer: $8710127e0f817e70$var$Q,
    useRef: $8710127e0f817e70$var$Q,
    useState: $8710127e0f817e70$var$Q,
    useDebugValue: $8710127e0f817e70$var$Q,
    useDeferredValue: $8710127e0f817e70$var$Q,
    useTransition: $8710127e0f817e70$var$Q,
    useMutableSource: $8710127e0f817e70$var$Q,
    useSyncExternalStore: $8710127e0f817e70$var$Q,
    useId: $8710127e0f817e70$var$Q,
    unstable_isNewReconciler: !1
}, $8710127e0f817e70$var$Yh = {
    readContext: $8710127e0f817e70$var$Vg,
    useCallback: function(a, b) {
        $8710127e0f817e70$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $8710127e0f817e70$var$Vg,
    useEffect: $8710127e0f817e70$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $8710127e0f817e70$var$ti(4194308, 4, $8710127e0f817e70$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $8710127e0f817e70$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $8710127e0f817e70$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $8710127e0f817e70$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $8710127e0f817e70$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $8710127e0f817e70$var$Gi.bind(null, $8710127e0f817e70$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $8710127e0f817e70$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $8710127e0f817e70$var$qi,
    useDebugValue: $8710127e0f817e70$var$Ai,
    useDeferredValue: function(a) {
        return $8710127e0f817e70$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $8710127e0f817e70$var$qi(!1), b = a[0];
        a = $8710127e0f817e70$var$Ei.bind(null, a[1]);
        $8710127e0f817e70$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $8710127e0f817e70$var$N, e = $8710127e0f817e70$var$ci();
        if ($8710127e0f817e70$var$I) {
            if (void 0 === c) throw Error($8710127e0f817e70$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $8710127e0f817e70$var$R) throw Error($8710127e0f817e70$var$p(349));
            0 !== ($8710127e0f817e70$var$Rh & 30) || $8710127e0f817e70$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $8710127e0f817e70$var$vi($8710127e0f817e70$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $8710127e0f817e70$var$li(9, $8710127e0f817e70$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $8710127e0f817e70$var$ci(), b = $8710127e0f817e70$var$R.identifierPrefix;
        if ($8710127e0f817e70$var$I) {
            var c = $8710127e0f817e70$var$sg;
            var d = $8710127e0f817e70$var$rg;
            c = (d & ~(1 << 32 - $8710127e0f817e70$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $8710127e0f817e70$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $8710127e0f817e70$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $8710127e0f817e70$var$Zh = {
    readContext: $8710127e0f817e70$var$Vg,
    useCallback: $8710127e0f817e70$var$Bi,
    useContext: $8710127e0f817e70$var$Vg,
    useEffect: $8710127e0f817e70$var$ji,
    useImperativeHandle: $8710127e0f817e70$var$zi,
    useInsertionEffect: $8710127e0f817e70$var$wi,
    useLayoutEffect: $8710127e0f817e70$var$xi,
    useMemo: $8710127e0f817e70$var$Ci,
    useReducer: $8710127e0f817e70$var$fi,
    useRef: $8710127e0f817e70$var$si,
    useState: function() {
        return $8710127e0f817e70$var$fi($8710127e0f817e70$var$ei);
    },
    useDebugValue: $8710127e0f817e70$var$Ai,
    useDeferredValue: function(a) {
        var b = $8710127e0f817e70$var$di();
        return $8710127e0f817e70$var$Di(b, $8710127e0f817e70$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $8710127e0f817e70$var$fi($8710127e0f817e70$var$ei)[0], b = $8710127e0f817e70$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $8710127e0f817e70$var$hi,
    useSyncExternalStore: $8710127e0f817e70$var$ii,
    useId: $8710127e0f817e70$var$Fi,
    unstable_isNewReconciler: !1
}, $8710127e0f817e70$var$$h = {
    readContext: $8710127e0f817e70$var$Vg,
    useCallback: $8710127e0f817e70$var$Bi,
    useContext: $8710127e0f817e70$var$Vg,
    useEffect: $8710127e0f817e70$var$ji,
    useImperativeHandle: $8710127e0f817e70$var$zi,
    useInsertionEffect: $8710127e0f817e70$var$wi,
    useLayoutEffect: $8710127e0f817e70$var$xi,
    useMemo: $8710127e0f817e70$var$Ci,
    useReducer: $8710127e0f817e70$var$gi,
    useRef: $8710127e0f817e70$var$si,
    useState: function() {
        return $8710127e0f817e70$var$gi($8710127e0f817e70$var$ei);
    },
    useDebugValue: $8710127e0f817e70$var$Ai,
    useDeferredValue: function(a) {
        var b = $8710127e0f817e70$var$di();
        return null === $8710127e0f817e70$var$O ? b.memoizedState = a : $8710127e0f817e70$var$Di(b, $8710127e0f817e70$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $8710127e0f817e70$var$gi($8710127e0f817e70$var$ei)[0], b = $8710127e0f817e70$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $8710127e0f817e70$var$hi,
    useSyncExternalStore: $8710127e0f817e70$var$ii,
    useId: $8710127e0f817e70$var$Fi,
    unstable_isNewReconciler: !1
};
function $8710127e0f817e70$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $8710127e0f817e70$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $8710127e0f817e70$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $8710127e0f817e70$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $8710127e0f817e70$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $8710127e0f817e70$var$Oi(a, b, c) {
    c = $8710127e0f817e70$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $8710127e0f817e70$var$Pi || ($8710127e0f817e70$var$Pi = !0, $8710127e0f817e70$var$Qi = d);
        $8710127e0f817e70$var$Mi(a, b);
    };
    return c;
}
function $8710127e0f817e70$var$Ri(a, b, c) {
    c = $8710127e0f817e70$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $8710127e0f817e70$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $8710127e0f817e70$var$Mi(a, b);
        "function" !== typeof d && (null === $8710127e0f817e70$var$Si ? $8710127e0f817e70$var$Si = new Set([
            this
        ]) : $8710127e0f817e70$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $8710127e0f817e70$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $8710127e0f817e70$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $8710127e0f817e70$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $8710127e0f817e70$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $8710127e0f817e70$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $8710127e0f817e70$var$ch(-1, 1), b.tag = 2, $8710127e0f817e70$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $8710127e0f817e70$var$Xi = $8710127e0f817e70$var$ua.ReactCurrentOwner, $8710127e0f817e70$var$Ug = !1;
function $8710127e0f817e70$var$Yi(a, b, c, d) {
    b.child = null === a ? $8710127e0f817e70$var$Ch(b, null, c, d) : $8710127e0f817e70$var$Bh(b, a.child, c, d);
}
function $8710127e0f817e70$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $8710127e0f817e70$var$Tg(b, e);
    d = $8710127e0f817e70$var$Xh(a, b, c, d, f, e);
    c = $8710127e0f817e70$var$bi();
    if (null !== a && !$8710127e0f817e70$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $8710127e0f817e70$var$$i(a, b, e);
    $8710127e0f817e70$var$I && c && $8710127e0f817e70$var$vg(b);
    b.flags |= 1;
    $8710127e0f817e70$var$Yi(a, b, d, e);
    return b.child;
}
function $8710127e0f817e70$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$8710127e0f817e70$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $8710127e0f817e70$var$cj(a, b, f, d, e);
        a = $8710127e0f817e70$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $8710127e0f817e70$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $8710127e0f817e70$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $8710127e0f817e70$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $8710127e0f817e70$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($8710127e0f817e70$var$Ie(f, d) && a.ref === b.ref) {
            if ($8710127e0f817e70$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($8710127e0f817e70$var$Ug = !0);
            else return b.lanes = a.lanes, $8710127e0f817e70$var$$i(a, b, e);
        }
    }
    return $8710127e0f817e70$var$dj(a, b, c, d, e);
}
function $8710127e0f817e70$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $8710127e0f817e70$var$G($8710127e0f817e70$var$fj, $8710127e0f817e70$var$gj), $8710127e0f817e70$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $8710127e0f817e70$var$G($8710127e0f817e70$var$fj, $8710127e0f817e70$var$gj), $8710127e0f817e70$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $8710127e0f817e70$var$G($8710127e0f817e70$var$fj, $8710127e0f817e70$var$gj);
            $8710127e0f817e70$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $8710127e0f817e70$var$G($8710127e0f817e70$var$fj, $8710127e0f817e70$var$gj), $8710127e0f817e70$var$gj |= d;
    $8710127e0f817e70$var$Yi(a, b, e, c);
    return b.child;
}
function $8710127e0f817e70$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $8710127e0f817e70$var$dj(a, b, c, d, e) {
    var f = $8710127e0f817e70$var$Zf(c) ? $8710127e0f817e70$var$Xf : $8710127e0f817e70$var$H.current;
    f = $8710127e0f817e70$var$Yf(b, f);
    $8710127e0f817e70$var$Tg(b, e);
    c = $8710127e0f817e70$var$Xh(a, b, c, d, f, e);
    d = $8710127e0f817e70$var$bi();
    if (null !== a && !$8710127e0f817e70$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $8710127e0f817e70$var$$i(a, b, e);
    $8710127e0f817e70$var$I && d && $8710127e0f817e70$var$vg(b);
    b.flags |= 1;
    $8710127e0f817e70$var$Yi(a, b, c, e);
    return b.child;
}
function $8710127e0f817e70$var$ij(a, b, c, d, e) {
    if ($8710127e0f817e70$var$Zf(c)) {
        var f = !0;
        $8710127e0f817e70$var$cg(b);
    } else f = !1;
    $8710127e0f817e70$var$Tg(b, e);
    if (null === b.stateNode) $8710127e0f817e70$var$jj(a, b), $8710127e0f817e70$var$ph(b, c, d), $8710127e0f817e70$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $8710127e0f817e70$var$Vg(l) : (l = $8710127e0f817e70$var$Zf(c) ? $8710127e0f817e70$var$Xf : $8710127e0f817e70$var$H.current, l = $8710127e0f817e70$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $8710127e0f817e70$var$qh(b, g, d, l);
        $8710127e0f817e70$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $8710127e0f817e70$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $8710127e0f817e70$var$Wf.current || $8710127e0f817e70$var$$g ? ("function" === typeof m && ($8710127e0f817e70$var$kh(b, c, m, d), k = b.memoizedState), (h = $8710127e0f817e70$var$$g || $8710127e0f817e70$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $8710127e0f817e70$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $8710127e0f817e70$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $8710127e0f817e70$var$Vg(k) : (k = $8710127e0f817e70$var$Zf(c) ? $8710127e0f817e70$var$Xf : $8710127e0f817e70$var$H.current, k = $8710127e0f817e70$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $8710127e0f817e70$var$qh(b, g, d, k);
        $8710127e0f817e70$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $8710127e0f817e70$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $8710127e0f817e70$var$Wf.current || $8710127e0f817e70$var$$g ? ("function" === typeof y && ($8710127e0f817e70$var$kh(b, c, y, d), n = b.memoizedState), (l = $8710127e0f817e70$var$$g || $8710127e0f817e70$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $8710127e0f817e70$var$kj(a, b, c, d, f, e);
}
function $8710127e0f817e70$var$kj(a, b, c, d, e, f) {
    $8710127e0f817e70$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $8710127e0f817e70$var$dg(b, c, !1), $8710127e0f817e70$var$$i(a, b, f);
    d = b.stateNode;
    $8710127e0f817e70$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $8710127e0f817e70$var$Bh(b, a.child, null, f), b.child = $8710127e0f817e70$var$Bh(b, null, h, f)) : $8710127e0f817e70$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $8710127e0f817e70$var$dg(b, c, !0);
    return b.child;
}
function $8710127e0f817e70$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $8710127e0f817e70$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $8710127e0f817e70$var$ag(a, b.context, !1);
    $8710127e0f817e70$var$Ih(a, b.containerInfo);
}
function $8710127e0f817e70$var$mj(a, b, c, d, e) {
    $8710127e0f817e70$var$Ig();
    $8710127e0f817e70$var$Jg(e);
    b.flags |= 256;
    $8710127e0f817e70$var$Yi(a, b, c, d);
    return b.child;
}
var $8710127e0f817e70$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $8710127e0f817e70$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $8710127e0f817e70$var$pj(a, b, c) {
    var d = b.pendingProps, e = $8710127e0f817e70$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $8710127e0f817e70$var$G($8710127e0f817e70$var$M, e & 1);
    if (null === a) {
        $8710127e0f817e70$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $8710127e0f817e70$var$qj(g, d, 0, null), a = $8710127e0f817e70$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $8710127e0f817e70$var$oj(c), b.memoizedState = $8710127e0f817e70$var$nj, a) : $8710127e0f817e70$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $8710127e0f817e70$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $8710127e0f817e70$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $8710127e0f817e70$var$wh(h, f) : (f = $8710127e0f817e70$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $8710127e0f817e70$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $8710127e0f817e70$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $8710127e0f817e70$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $8710127e0f817e70$var$rj(a, b) {
    b = $8710127e0f817e70$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $8710127e0f817e70$var$tj(a, b, c, d) {
    null !== d && $8710127e0f817e70$var$Jg(d);
    $8710127e0f817e70$var$Bh(b, a.child, null, c);
    a = $8710127e0f817e70$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $8710127e0f817e70$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $8710127e0f817e70$var$Li(Error($8710127e0f817e70$var$p(422))), $8710127e0f817e70$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $8710127e0f817e70$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $8710127e0f817e70$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $8710127e0f817e70$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $8710127e0f817e70$var$oj(g);
        b.memoizedState = $8710127e0f817e70$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $8710127e0f817e70$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($8710127e0f817e70$var$p(419));
        d = $8710127e0f817e70$var$Li(f, d, void 0);
        return $8710127e0f817e70$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($8710127e0f817e70$var$Ug || h) {
        d = $8710127e0f817e70$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $8710127e0f817e70$var$Zg(a, e), $8710127e0f817e70$var$mh(d, a, e, -1));
        }
        $8710127e0f817e70$var$uj();
        d = $8710127e0f817e70$var$Li(Error($8710127e0f817e70$var$p(421)));
        return $8710127e0f817e70$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $8710127e0f817e70$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $8710127e0f817e70$var$yg = $8710127e0f817e70$var$Lf(e.nextSibling);
    $8710127e0f817e70$var$xg = b;
    $8710127e0f817e70$var$I = !0;
    $8710127e0f817e70$var$zg = null;
    null !== a && ($8710127e0f817e70$var$og[$8710127e0f817e70$var$pg++] = $8710127e0f817e70$var$rg, $8710127e0f817e70$var$og[$8710127e0f817e70$var$pg++] = $8710127e0f817e70$var$sg, $8710127e0f817e70$var$og[$8710127e0f817e70$var$pg++] = $8710127e0f817e70$var$qg, $8710127e0f817e70$var$rg = a.id, $8710127e0f817e70$var$sg = a.overflow, $8710127e0f817e70$var$qg = b);
    b = $8710127e0f817e70$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $8710127e0f817e70$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $8710127e0f817e70$var$Sg(a.return, b, c);
}
function $8710127e0f817e70$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $8710127e0f817e70$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $8710127e0f817e70$var$Yi(a, b, d.children, c);
    d = $8710127e0f817e70$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $8710127e0f817e70$var$wj(a, c, b);
            else if (19 === a.tag) $8710127e0f817e70$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $8710127e0f817e70$var$G($8710127e0f817e70$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $8710127e0f817e70$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $8710127e0f817e70$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $8710127e0f817e70$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $8710127e0f817e70$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $8710127e0f817e70$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $8710127e0f817e70$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $8710127e0f817e70$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $8710127e0f817e70$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($8710127e0f817e70$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $8710127e0f817e70$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $8710127e0f817e70$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $8710127e0f817e70$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $8710127e0f817e70$var$lj(b);
            $8710127e0f817e70$var$Ig();
            break;
        case 5:
            $8710127e0f817e70$var$Kh(b);
            break;
        case 1:
            $8710127e0f817e70$var$Zf(b.type) && $8710127e0f817e70$var$cg(b);
            break;
        case 4:
            $8710127e0f817e70$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $8710127e0f817e70$var$G($8710127e0f817e70$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $8710127e0f817e70$var$G($8710127e0f817e70$var$M, $8710127e0f817e70$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $8710127e0f817e70$var$pj(a, b, c);
                $8710127e0f817e70$var$G($8710127e0f817e70$var$M, $8710127e0f817e70$var$M.current & 1);
                a = $8710127e0f817e70$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $8710127e0f817e70$var$G($8710127e0f817e70$var$M, $8710127e0f817e70$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $8710127e0f817e70$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $8710127e0f817e70$var$G($8710127e0f817e70$var$M, $8710127e0f817e70$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $8710127e0f817e70$var$ej(a, b, c);
    }
    return $8710127e0f817e70$var$$i(a, b, c);
}
var $8710127e0f817e70$var$Aj, $8710127e0f817e70$var$Bj, $8710127e0f817e70$var$Cj, $8710127e0f817e70$var$Dj;
$8710127e0f817e70$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$8710127e0f817e70$var$Bj = function() {};
$8710127e0f817e70$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $8710127e0f817e70$var$Hh($8710127e0f817e70$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $8710127e0f817e70$var$Ya(a, e);
                d = $8710127e0f817e70$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $8710127e0f817e70$var$A({}, e, {
                    value: void 0
                });
                d = $8710127e0f817e70$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $8710127e0f817e70$var$gb(a, e);
                d = $8710127e0f817e70$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $8710127e0f817e70$var$Bf);
        }
        $8710127e0f817e70$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($8710127e0f817e70$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($8710127e0f817e70$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $8710127e0f817e70$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$8710127e0f817e70$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $8710127e0f817e70$var$Ej(a, b) {
    if (!$8710127e0f817e70$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $8710127e0f817e70$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $8710127e0f817e70$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $8710127e0f817e70$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $8710127e0f817e70$var$S(b), null;
        case 1:
            return $8710127e0f817e70$var$Zf(b.type) && $8710127e0f817e70$var$$f(), $8710127e0f817e70$var$S(b), null;
        case 3:
            d = b.stateNode;
            $8710127e0f817e70$var$Jh();
            $8710127e0f817e70$var$E($8710127e0f817e70$var$Wf);
            $8710127e0f817e70$var$E($8710127e0f817e70$var$H);
            $8710127e0f817e70$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $8710127e0f817e70$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $8710127e0f817e70$var$zg && ($8710127e0f817e70$var$Gj($8710127e0f817e70$var$zg), $8710127e0f817e70$var$zg = null));
            $8710127e0f817e70$var$Bj(a, b);
            $8710127e0f817e70$var$S(b);
            return null;
        case 5:
            $8710127e0f817e70$var$Lh(b);
            var e = $8710127e0f817e70$var$Hh($8710127e0f817e70$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $8710127e0f817e70$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($8710127e0f817e70$var$p(166));
                    $8710127e0f817e70$var$S(b);
                    return null;
                }
                a = $8710127e0f817e70$var$Hh($8710127e0f817e70$var$Eh.current);
                if ($8710127e0f817e70$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$8710127e0f817e70$var$Of] = b;
                    d[$8710127e0f817e70$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $8710127e0f817e70$var$D("cancel", d);
                            $8710127e0f817e70$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $8710127e0f817e70$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $8710127e0f817e70$var$lf.length; e++)$8710127e0f817e70$var$D($8710127e0f817e70$var$lf[e], d);
                            break;
                        case "source":
                            $8710127e0f817e70$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $8710127e0f817e70$var$D("error", d);
                            $8710127e0f817e70$var$D("load", d);
                            break;
                        case "details":
                            $8710127e0f817e70$var$D("toggle", d);
                            break;
                        case "input":
                            $8710127e0f817e70$var$Za(d, f);
                            $8710127e0f817e70$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $8710127e0f817e70$var$D("invalid", d);
                            break;
                        case "textarea":
                            $8710127e0f817e70$var$hb(d, f), $8710127e0f817e70$var$D("invalid", d);
                    }
                    $8710127e0f817e70$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $8710127e0f817e70$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $8710127e0f817e70$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $8710127e0f817e70$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $8710127e0f817e70$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $8710127e0f817e70$var$Va(d);
                            $8710127e0f817e70$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $8710127e0f817e70$var$Va(d);
                            $8710127e0f817e70$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $8710127e0f817e70$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $8710127e0f817e70$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$8710127e0f817e70$var$Of] = b;
                    a[$8710127e0f817e70$var$Pf] = d;
                    $8710127e0f817e70$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $8710127e0f817e70$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $8710127e0f817e70$var$D("cancel", a);
                                $8710127e0f817e70$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $8710127e0f817e70$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $8710127e0f817e70$var$lf.length; e++)$8710127e0f817e70$var$D($8710127e0f817e70$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $8710127e0f817e70$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $8710127e0f817e70$var$D("error", a);
                                $8710127e0f817e70$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $8710127e0f817e70$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $8710127e0f817e70$var$Za(a, d);
                                e = $8710127e0f817e70$var$Ya(a, d);
                                $8710127e0f817e70$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $8710127e0f817e70$var$A({}, d, {
                                    value: void 0
                                });
                                $8710127e0f817e70$var$D("invalid", a);
                                break;
                            case "textarea":
                                $8710127e0f817e70$var$hb(a, d);
                                e = $8710127e0f817e70$var$gb(a, d);
                                $8710127e0f817e70$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $8710127e0f817e70$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $8710127e0f817e70$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $8710127e0f817e70$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $8710127e0f817e70$var$ob(a, k) : "number" === typeof k && $8710127e0f817e70$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($8710127e0f817e70$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $8710127e0f817e70$var$D("scroll", a) : null != k && $8710127e0f817e70$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $8710127e0f817e70$var$Va(a);
                                $8710127e0f817e70$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $8710127e0f817e70$var$Va(a);
                                $8710127e0f817e70$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $8710127e0f817e70$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $8710127e0f817e70$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $8710127e0f817e70$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $8710127e0f817e70$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $8710127e0f817e70$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $8710127e0f817e70$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($8710127e0f817e70$var$p(166));
                c = $8710127e0f817e70$var$Hh($8710127e0f817e70$var$Gh.current);
                $8710127e0f817e70$var$Hh($8710127e0f817e70$var$Eh.current);
                if ($8710127e0f817e70$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$8710127e0f817e70$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $8710127e0f817e70$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $8710127e0f817e70$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $8710127e0f817e70$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$8710127e0f817e70$var$Of] = b, b.stateNode = d;
            }
            $8710127e0f817e70$var$S(b);
            return null;
        case 13:
            $8710127e0f817e70$var$E($8710127e0f817e70$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($8710127e0f817e70$var$I && null !== $8710127e0f817e70$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $8710127e0f817e70$var$Hg(), $8710127e0f817e70$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $8710127e0f817e70$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($8710127e0f817e70$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($8710127e0f817e70$var$p(317));
                        f[$8710127e0f817e70$var$Of] = b;
                    } else $8710127e0f817e70$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $8710127e0f817e70$var$S(b);
                    f = !1;
                } else null !== $8710127e0f817e70$var$zg && ($8710127e0f817e70$var$Gj($8710127e0f817e70$var$zg), $8710127e0f817e70$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($8710127e0f817e70$var$M.current & 1) ? 0 === $8710127e0f817e70$var$T && ($8710127e0f817e70$var$T = 3) : $8710127e0f817e70$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $8710127e0f817e70$var$S(b);
            return null;
        case 4:
            return $8710127e0f817e70$var$Jh(), $8710127e0f817e70$var$Bj(a, b), null === a && $8710127e0f817e70$var$sf(b.stateNode.containerInfo), $8710127e0f817e70$var$S(b), null;
        case 10:
            return $8710127e0f817e70$var$Rg(b.type._context), $8710127e0f817e70$var$S(b), null;
        case 17:
            return $8710127e0f817e70$var$Zf(b.type) && $8710127e0f817e70$var$$f(), $8710127e0f817e70$var$S(b), null;
        case 19:
            $8710127e0f817e70$var$E($8710127e0f817e70$var$M);
            f = b.memoizedState;
            if (null === f) return $8710127e0f817e70$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $8710127e0f817e70$var$Ej(f, !1);
                else {
                    if (0 !== $8710127e0f817e70$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $8710127e0f817e70$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $8710127e0f817e70$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $8710127e0f817e70$var$G($8710127e0f817e70$var$M, $8710127e0f817e70$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $8710127e0f817e70$var$B() > $8710127e0f817e70$var$Hj && (b.flags |= 128, d = !0, $8710127e0f817e70$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $8710127e0f817e70$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $8710127e0f817e70$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$8710127e0f817e70$var$I) return $8710127e0f817e70$var$S(b), null;
                    } else 2 * $8710127e0f817e70$var$B() - f.renderingStartTime > $8710127e0f817e70$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $8710127e0f817e70$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $8710127e0f817e70$var$B(), b.sibling = null, c = $8710127e0f817e70$var$M.current, $8710127e0f817e70$var$G($8710127e0f817e70$var$M, d ? c & 1 | 2 : c & 1), b;
            $8710127e0f817e70$var$S(b);
            return null;
        case 22:
        case 23:
            return $8710127e0f817e70$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($8710127e0f817e70$var$gj & 1073741824) && ($8710127e0f817e70$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $8710127e0f817e70$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($8710127e0f817e70$var$p(156, b.tag));
}
function $8710127e0f817e70$var$Jj(a, b) {
    $8710127e0f817e70$var$wg(b);
    switch(b.tag){
        case 1:
            return $8710127e0f817e70$var$Zf(b.type) && $8710127e0f817e70$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $8710127e0f817e70$var$Jh(), $8710127e0f817e70$var$E($8710127e0f817e70$var$Wf), $8710127e0f817e70$var$E($8710127e0f817e70$var$H), $8710127e0f817e70$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $8710127e0f817e70$var$Lh(b), null;
        case 13:
            $8710127e0f817e70$var$E($8710127e0f817e70$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($8710127e0f817e70$var$p(340));
                $8710127e0f817e70$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $8710127e0f817e70$var$E($8710127e0f817e70$var$M), null;
        case 4:
            return $8710127e0f817e70$var$Jh(), null;
        case 10:
            return $8710127e0f817e70$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $8710127e0f817e70$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $8710127e0f817e70$var$Kj = !1, $8710127e0f817e70$var$U = !1, $8710127e0f817e70$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $8710127e0f817e70$var$V = null;
function $8710127e0f817e70$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $8710127e0f817e70$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $8710127e0f817e70$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $8710127e0f817e70$var$W(a, b, d);
    }
}
var $8710127e0f817e70$var$Oj = !1;
function $8710127e0f817e70$var$Pj(a, b) {
    $8710127e0f817e70$var$Cf = $8710127e0f817e70$var$dd;
    a = $8710127e0f817e70$var$Me();
    if ($8710127e0f817e70$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $8710127e0f817e70$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $8710127e0f817e70$var$dd = !1;
    for($8710127e0f817e70$var$V = b; null !== $8710127e0f817e70$var$V;)if (b = $8710127e0f817e70$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $8710127e0f817e70$var$V = a;
    else for(; null !== $8710127e0f817e70$var$V;){
        b = $8710127e0f817e70$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $8710127e0f817e70$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($8710127e0f817e70$var$p(163));
            }
        } catch (F) {
            $8710127e0f817e70$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $8710127e0f817e70$var$V = a;
            break;
        }
        $8710127e0f817e70$var$V = b.return;
    }
    n = $8710127e0f817e70$var$Oj;
    $8710127e0f817e70$var$Oj = !1;
    return n;
}
function $8710127e0f817e70$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $8710127e0f817e70$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $8710127e0f817e70$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $8710127e0f817e70$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $8710127e0f817e70$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $8710127e0f817e70$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$8710127e0f817e70$var$Of], delete b[$8710127e0f817e70$var$Pf], delete b[$8710127e0f817e70$var$of], delete b[$8710127e0f817e70$var$Qf], delete b[$8710127e0f817e70$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $8710127e0f817e70$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $8710127e0f817e70$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $8710127e0f817e70$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $8710127e0f817e70$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $8710127e0f817e70$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($8710127e0f817e70$var$Wj(a, b, c), a = a.sibling; null !== a;)$8710127e0f817e70$var$Wj(a, b, c), a = a.sibling;
}
function $8710127e0f817e70$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($8710127e0f817e70$var$Xj(a, b, c), a = a.sibling; null !== a;)$8710127e0f817e70$var$Xj(a, b, c), a = a.sibling;
}
var $8710127e0f817e70$var$X = null, $8710127e0f817e70$var$Yj = !1;
function $8710127e0f817e70$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$8710127e0f817e70$var$ak(a, b, c), c = c.sibling;
}
function $8710127e0f817e70$var$ak(a, b, c) {
    if ($8710127e0f817e70$var$lc && "function" === typeof $8710127e0f817e70$var$lc.onCommitFiberUnmount) try {
        $8710127e0f817e70$var$lc.onCommitFiberUnmount($8710127e0f817e70$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $8710127e0f817e70$var$U || $8710127e0f817e70$var$Mj(c, b);
        case 6:
            var d = $8710127e0f817e70$var$X, e = $8710127e0f817e70$var$Yj;
            $8710127e0f817e70$var$X = null;
            $8710127e0f817e70$var$Zj(a, b, c);
            $8710127e0f817e70$var$X = d;
            $8710127e0f817e70$var$Yj = e;
            null !== $8710127e0f817e70$var$X && ($8710127e0f817e70$var$Yj ? (a = $8710127e0f817e70$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $8710127e0f817e70$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $8710127e0f817e70$var$X && ($8710127e0f817e70$var$Yj ? (a = $8710127e0f817e70$var$X, c = c.stateNode, 8 === a.nodeType ? $8710127e0f817e70$var$Kf(a.parentNode, c) : 1 === a.nodeType && $8710127e0f817e70$var$Kf(a, c), $8710127e0f817e70$var$bd(a)) : $8710127e0f817e70$var$Kf($8710127e0f817e70$var$X, c.stateNode));
            break;
        case 4:
            d = $8710127e0f817e70$var$X;
            e = $8710127e0f817e70$var$Yj;
            $8710127e0f817e70$var$X = c.stateNode.containerInfo;
            $8710127e0f817e70$var$Yj = !0;
            $8710127e0f817e70$var$Zj(a, b, c);
            $8710127e0f817e70$var$X = d;
            $8710127e0f817e70$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$8710127e0f817e70$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $8710127e0f817e70$var$Nj(c, b, g) : 0 !== (f & 4) && $8710127e0f817e70$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $8710127e0f817e70$var$Zj(a, b, c);
            break;
        case 1:
            if (!$8710127e0f817e70$var$U && ($8710127e0f817e70$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $8710127e0f817e70$var$W(c, b, h);
            }
            $8710127e0f817e70$var$Zj(a, b, c);
            break;
        case 21:
            $8710127e0f817e70$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($8710127e0f817e70$var$U = (d = $8710127e0f817e70$var$U) || null !== c.memoizedState, $8710127e0f817e70$var$Zj(a, b, c), $8710127e0f817e70$var$U = d) : $8710127e0f817e70$var$Zj(a, b, c);
            break;
        default:
            $8710127e0f817e70$var$Zj(a, b, c);
    }
}
function $8710127e0f817e70$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $8710127e0f817e70$var$Lj);
        b.forEach(function(b) {
            var d = $8710127e0f817e70$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $8710127e0f817e70$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $8710127e0f817e70$var$X = h.stateNode;
                        $8710127e0f817e70$var$Yj = !1;
                        break a;
                    case 3:
                        $8710127e0f817e70$var$X = h.stateNode.containerInfo;
                        $8710127e0f817e70$var$Yj = !0;
                        break a;
                    case 4:
                        $8710127e0f817e70$var$X = h.stateNode.containerInfo;
                        $8710127e0f817e70$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $8710127e0f817e70$var$X) throw Error($8710127e0f817e70$var$p(160));
            $8710127e0f817e70$var$ak(f, g, e);
            $8710127e0f817e70$var$X = null;
            $8710127e0f817e70$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $8710127e0f817e70$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$8710127e0f817e70$var$ek(b, a), b = b.sibling;
}
function $8710127e0f817e70$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $8710127e0f817e70$var$dk(b, a);
            $8710127e0f817e70$var$fk(a);
            if (d & 4) {
                try {
                    $8710127e0f817e70$var$Qj(3, a, a.return), $8710127e0f817e70$var$Rj(3, a);
                } catch (t) {
                    $8710127e0f817e70$var$W(a, a.return, t);
                }
                try {
                    $8710127e0f817e70$var$Qj(5, a, a.return);
                } catch (t) {
                    $8710127e0f817e70$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $8710127e0f817e70$var$dk(b, a);
            $8710127e0f817e70$var$fk(a);
            d & 512 && null !== c && $8710127e0f817e70$var$Mj(c, c.return);
            break;
        case 5:
            $8710127e0f817e70$var$dk(b, a);
            $8710127e0f817e70$var$fk(a);
            d & 512 && null !== c && $8710127e0f817e70$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $8710127e0f817e70$var$ob(e, "");
                } catch (t) {
                    $8710127e0f817e70$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $8710127e0f817e70$var$ab(e, f);
                    $8710127e0f817e70$var$vb(h, g);
                    var l = $8710127e0f817e70$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $8710127e0f817e70$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $8710127e0f817e70$var$nb(e, q) : "children" === m ? $8710127e0f817e70$var$ob(e, q) : $8710127e0f817e70$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $8710127e0f817e70$var$bb(e, f);
                            break;
                        case "textarea":
                            $8710127e0f817e70$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $8710127e0f817e70$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $8710127e0f817e70$var$fb(e, !!f.multiple, f.defaultValue, !0) : $8710127e0f817e70$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$8710127e0f817e70$var$Pf] = f;
                } catch (t) {
                    $8710127e0f817e70$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $8710127e0f817e70$var$dk(b, a);
            $8710127e0f817e70$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($8710127e0f817e70$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $8710127e0f817e70$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $8710127e0f817e70$var$dk(b, a);
            $8710127e0f817e70$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $8710127e0f817e70$var$bd(b.containerInfo);
            } catch (t) {
                $8710127e0f817e70$var$W(a, a.return, t);
            }
            break;
        case 4:
            $8710127e0f817e70$var$dk(b, a);
            $8710127e0f817e70$var$fk(a);
            break;
        case 13:
            $8710127e0f817e70$var$dk(b, a);
            $8710127e0f817e70$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($8710127e0f817e70$var$gk = $8710127e0f817e70$var$B()));
            d & 4 && $8710127e0f817e70$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($8710127e0f817e70$var$U = (l = $8710127e0f817e70$var$U) || m, $8710127e0f817e70$var$dk(b, a), $8710127e0f817e70$var$U = l) : $8710127e0f817e70$var$dk(b, a);
            $8710127e0f817e70$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($8710127e0f817e70$var$V = a, m = a.child; null !== m;){
                    for(q = $8710127e0f817e70$var$V = m; null !== $8710127e0f817e70$var$V;){
                        r = $8710127e0f817e70$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $8710127e0f817e70$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $8710127e0f817e70$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $8710127e0f817e70$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $8710127e0f817e70$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $8710127e0f817e70$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $8710127e0f817e70$var$V = y) : $8710127e0f817e70$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $8710127e0f817e70$var$rb("display", g));
                            } catch (t) {
                                $8710127e0f817e70$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $8710127e0f817e70$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $8710127e0f817e70$var$dk(b, a);
            $8710127e0f817e70$var$fk(a);
            d & 4 && $8710127e0f817e70$var$bk(a);
            break;
        case 21:
            break;
        default:
            $8710127e0f817e70$var$dk(b, a), $8710127e0f817e70$var$fk(a);
    }
}
function $8710127e0f817e70$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($8710127e0f817e70$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($8710127e0f817e70$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($8710127e0f817e70$var$ob(e, ""), d.flags &= -33);
                    var f = $8710127e0f817e70$var$Vj(a);
                    $8710127e0f817e70$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $8710127e0f817e70$var$Vj(a);
                    $8710127e0f817e70$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($8710127e0f817e70$var$p(161));
            }
        } catch (k) {
            $8710127e0f817e70$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $8710127e0f817e70$var$ik(a, b, c) {
    $8710127e0f817e70$var$V = a;
    $8710127e0f817e70$var$jk(a, b, c);
}
function $8710127e0f817e70$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $8710127e0f817e70$var$V;){
        var e = $8710127e0f817e70$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $8710127e0f817e70$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $8710127e0f817e70$var$U;
                h = $8710127e0f817e70$var$Kj;
                var l = $8710127e0f817e70$var$U;
                $8710127e0f817e70$var$Kj = g;
                if (($8710127e0f817e70$var$U = k) && !l) for($8710127e0f817e70$var$V = e; null !== $8710127e0f817e70$var$V;)g = $8710127e0f817e70$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $8710127e0f817e70$var$kk(e) : null !== k ? (k.return = g, $8710127e0f817e70$var$V = k) : $8710127e0f817e70$var$kk(e);
                for(; null !== f;)$8710127e0f817e70$var$V = f, $8710127e0f817e70$var$jk(f, b, c), f = f.sibling;
                $8710127e0f817e70$var$V = e;
                $8710127e0f817e70$var$Kj = h;
                $8710127e0f817e70$var$U = l;
            }
            $8710127e0f817e70$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $8710127e0f817e70$var$V = f) : $8710127e0f817e70$var$lk(a, b, c);
    }
}
function $8710127e0f817e70$var$lk(a) {
    for(; null !== $8710127e0f817e70$var$V;){
        var b = $8710127e0f817e70$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $8710127e0f817e70$var$U || $8710127e0f817e70$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$8710127e0f817e70$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $8710127e0f817e70$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $8710127e0f817e70$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $8710127e0f817e70$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $8710127e0f817e70$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($8710127e0f817e70$var$p(163));
                }
                $8710127e0f817e70$var$U || b.flags & 512 && $8710127e0f817e70$var$Sj(b);
            } catch (r) {
                $8710127e0f817e70$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $8710127e0f817e70$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $8710127e0f817e70$var$V = c;
            break;
        }
        $8710127e0f817e70$var$V = b.return;
    }
}
function $8710127e0f817e70$var$hk(a) {
    for(; null !== $8710127e0f817e70$var$V;){
        var b = $8710127e0f817e70$var$V;
        if (b === a) {
            $8710127e0f817e70$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $8710127e0f817e70$var$V = c;
            break;
        }
        $8710127e0f817e70$var$V = b.return;
    }
}
function $8710127e0f817e70$var$kk(a) {
    for(; null !== $8710127e0f817e70$var$V;){
        var b = $8710127e0f817e70$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $8710127e0f817e70$var$Rj(4, b);
                    } catch (k) {
                        $8710127e0f817e70$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $8710127e0f817e70$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $8710127e0f817e70$var$Sj(b);
                    } catch (k) {
                        $8710127e0f817e70$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $8710127e0f817e70$var$Sj(b);
                    } catch (k) {
                        $8710127e0f817e70$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $8710127e0f817e70$var$W(b, b.return, k);
        }
        if (b === a) {
            $8710127e0f817e70$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $8710127e0f817e70$var$V = h;
            break;
        }
        $8710127e0f817e70$var$V = b.return;
    }
}
var $8710127e0f817e70$var$mk = Math.ceil, $8710127e0f817e70$var$nk = $8710127e0f817e70$var$ua.ReactCurrentDispatcher, $8710127e0f817e70$var$ok = $8710127e0f817e70$var$ua.ReactCurrentOwner, $8710127e0f817e70$var$pk = $8710127e0f817e70$var$ua.ReactCurrentBatchConfig, $8710127e0f817e70$var$K = 0, $8710127e0f817e70$var$R = null, $8710127e0f817e70$var$Y = null, $8710127e0f817e70$var$Z = 0, $8710127e0f817e70$var$gj = 0, $8710127e0f817e70$var$fj = $8710127e0f817e70$var$Uf(0), $8710127e0f817e70$var$T = 0, $8710127e0f817e70$var$qk = null, $8710127e0f817e70$var$hh = 0, $8710127e0f817e70$var$rk = 0, $8710127e0f817e70$var$sk = 0, $8710127e0f817e70$var$tk = null, $8710127e0f817e70$var$uk = null, $8710127e0f817e70$var$gk = 0, $8710127e0f817e70$var$Hj = Infinity, $8710127e0f817e70$var$vk = null, $8710127e0f817e70$var$Pi = !1, $8710127e0f817e70$var$Qi = null, $8710127e0f817e70$var$Si = null, $8710127e0f817e70$var$wk = !1, $8710127e0f817e70$var$xk = null, $8710127e0f817e70$var$yk = 0, $8710127e0f817e70$var$zk = 0, $8710127e0f817e70$var$Ak = null, $8710127e0f817e70$var$Bk = -1, $8710127e0f817e70$var$Ck = 0;
function $8710127e0f817e70$var$L() {
    return 0 !== ($8710127e0f817e70$var$K & 6) ? $8710127e0f817e70$var$B() : -1 !== $8710127e0f817e70$var$Bk ? $8710127e0f817e70$var$Bk : $8710127e0f817e70$var$Bk = $8710127e0f817e70$var$B();
}
function $8710127e0f817e70$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($8710127e0f817e70$var$K & 2) && 0 !== $8710127e0f817e70$var$Z) return $8710127e0f817e70$var$Z & -$8710127e0f817e70$var$Z;
    if (null !== $8710127e0f817e70$var$Kg.transition) return 0 === $8710127e0f817e70$var$Ck && ($8710127e0f817e70$var$Ck = $8710127e0f817e70$var$yc()), $8710127e0f817e70$var$Ck;
    a = $8710127e0f817e70$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $8710127e0f817e70$var$jd(a.type);
    return a;
}
function $8710127e0f817e70$var$mh(a, b, c, d) {
    if (50 < $8710127e0f817e70$var$zk) throw $8710127e0f817e70$var$zk = 0, $8710127e0f817e70$var$Ak = null, Error($8710127e0f817e70$var$p(185));
    $8710127e0f817e70$var$Ac(a, c, d);
    if (0 === ($8710127e0f817e70$var$K & 2) || a !== $8710127e0f817e70$var$R) a === $8710127e0f817e70$var$R && (0 === ($8710127e0f817e70$var$K & 2) && ($8710127e0f817e70$var$rk |= c), 4 === $8710127e0f817e70$var$T && $8710127e0f817e70$var$Dk(a, $8710127e0f817e70$var$Z)), $8710127e0f817e70$var$Ek(a, d), 1 === c && 0 === $8710127e0f817e70$var$K && 0 === (b.mode & 1) && ($8710127e0f817e70$var$Hj = $8710127e0f817e70$var$B() + 500, $8710127e0f817e70$var$fg && $8710127e0f817e70$var$jg());
}
function $8710127e0f817e70$var$Ek(a, b) {
    var c = a.callbackNode;
    $8710127e0f817e70$var$wc(a, b);
    var d = $8710127e0f817e70$var$uc(a, a === $8710127e0f817e70$var$R ? $8710127e0f817e70$var$Z : 0);
    if (0 === d) null !== c && $8710127e0f817e70$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $8710127e0f817e70$var$bc(c);
        if (1 === b) 0 === a.tag ? $8710127e0f817e70$var$ig($8710127e0f817e70$var$Fk.bind(null, a)) : $8710127e0f817e70$var$hg($8710127e0f817e70$var$Fk.bind(null, a)), $8710127e0f817e70$var$Jf(function() {
            0 === ($8710127e0f817e70$var$K & 6) && $8710127e0f817e70$var$jg();
        }), c = null;
        else {
            switch($8710127e0f817e70$var$Dc(d)){
                case 1:
                    c = $8710127e0f817e70$var$fc;
                    break;
                case 4:
                    c = $8710127e0f817e70$var$gc;
                    break;
                case 16:
                    c = $8710127e0f817e70$var$hc;
                    break;
                case 536870912:
                    c = $8710127e0f817e70$var$jc;
                    break;
                default:
                    c = $8710127e0f817e70$var$hc;
            }
            c = $8710127e0f817e70$var$Gk(c, $8710127e0f817e70$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $8710127e0f817e70$var$Hk(a, b) {
    $8710127e0f817e70$var$Bk = -1;
    $8710127e0f817e70$var$Ck = 0;
    if (0 !== ($8710127e0f817e70$var$K & 6)) throw Error($8710127e0f817e70$var$p(327));
    var c = a.callbackNode;
    if ($8710127e0f817e70$var$Ik() && a.callbackNode !== c) return null;
    var d = $8710127e0f817e70$var$uc(a, a === $8710127e0f817e70$var$R ? $8710127e0f817e70$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $8710127e0f817e70$var$Jk(a, d);
    else {
        b = d;
        var e = $8710127e0f817e70$var$K;
        $8710127e0f817e70$var$K |= 2;
        var f = $8710127e0f817e70$var$Kk();
        if ($8710127e0f817e70$var$R !== a || $8710127e0f817e70$var$Z !== b) $8710127e0f817e70$var$vk = null, $8710127e0f817e70$var$Hj = $8710127e0f817e70$var$B() + 500, $8710127e0f817e70$var$Lk(a, b);
        for(;;)try {
            $8710127e0f817e70$var$Mk();
            break;
        } catch (h) {
            $8710127e0f817e70$var$Nk(a, h);
        }
        $8710127e0f817e70$var$Qg();
        $8710127e0f817e70$var$nk.current = f;
        $8710127e0f817e70$var$K = e;
        null !== $8710127e0f817e70$var$Y ? b = 0 : ($8710127e0f817e70$var$R = null, $8710127e0f817e70$var$Z = 0, b = $8710127e0f817e70$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $8710127e0f817e70$var$xc(a), 0 !== e && (d = e, b = $8710127e0f817e70$var$Ok(a, e)));
        if (1 === b) throw c = $8710127e0f817e70$var$qk, $8710127e0f817e70$var$Lk(a, 0), $8710127e0f817e70$var$Dk(a, d), $8710127e0f817e70$var$Ek(a, $8710127e0f817e70$var$B()), c;
        if (6 === b) $8710127e0f817e70$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$8710127e0f817e70$var$Pk(e) && (b = $8710127e0f817e70$var$Jk(a, d), 2 === b && (f = $8710127e0f817e70$var$xc(a), 0 !== f && (d = f, b = $8710127e0f817e70$var$Ok(a, f))), 1 === b)) throw c = $8710127e0f817e70$var$qk, $8710127e0f817e70$var$Lk(a, 0), $8710127e0f817e70$var$Dk(a, d), $8710127e0f817e70$var$Ek(a, $8710127e0f817e70$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($8710127e0f817e70$var$p(345));
                case 2:
                    $8710127e0f817e70$var$Qk(a, $8710127e0f817e70$var$uk, $8710127e0f817e70$var$vk);
                    break;
                case 3:
                    $8710127e0f817e70$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $8710127e0f817e70$var$gk + 500 - $8710127e0f817e70$var$B(), 10 < b)) {
                        if (0 !== $8710127e0f817e70$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $8710127e0f817e70$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $8710127e0f817e70$var$Ff($8710127e0f817e70$var$Qk.bind(null, a, $8710127e0f817e70$var$uk, $8710127e0f817e70$var$vk), b);
                        break;
                    }
                    $8710127e0f817e70$var$Qk(a, $8710127e0f817e70$var$uk, $8710127e0f817e70$var$vk);
                    break;
                case 4:
                    $8710127e0f817e70$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $8710127e0f817e70$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $8710127e0f817e70$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $8710127e0f817e70$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $8710127e0f817e70$var$Ff($8710127e0f817e70$var$Qk.bind(null, a, $8710127e0f817e70$var$uk, $8710127e0f817e70$var$vk), d);
                        break;
                    }
                    $8710127e0f817e70$var$Qk(a, $8710127e0f817e70$var$uk, $8710127e0f817e70$var$vk);
                    break;
                case 5:
                    $8710127e0f817e70$var$Qk(a, $8710127e0f817e70$var$uk, $8710127e0f817e70$var$vk);
                    break;
                default:
                    throw Error($8710127e0f817e70$var$p(329));
            }
        }
    }
    $8710127e0f817e70$var$Ek(a, $8710127e0f817e70$var$B());
    return a.callbackNode === c ? $8710127e0f817e70$var$Hk.bind(null, a) : null;
}
function $8710127e0f817e70$var$Ok(a, b) {
    var c = $8710127e0f817e70$var$tk;
    a.current.memoizedState.isDehydrated && ($8710127e0f817e70$var$Lk(a, b).flags |= 256);
    a = $8710127e0f817e70$var$Jk(a, b);
    2 !== a && (b = $8710127e0f817e70$var$uk, $8710127e0f817e70$var$uk = c, null !== b && $8710127e0f817e70$var$Gj(b));
    return a;
}
function $8710127e0f817e70$var$Gj(a) {
    null === $8710127e0f817e70$var$uk ? $8710127e0f817e70$var$uk = a : $8710127e0f817e70$var$uk.push.apply($8710127e0f817e70$var$uk, a);
}
function $8710127e0f817e70$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$8710127e0f817e70$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $8710127e0f817e70$var$Dk(a, b) {
    b &= ~$8710127e0f817e70$var$sk;
    b &= ~$8710127e0f817e70$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $8710127e0f817e70$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $8710127e0f817e70$var$Fk(a) {
    if (0 !== ($8710127e0f817e70$var$K & 6)) throw Error($8710127e0f817e70$var$p(327));
    $8710127e0f817e70$var$Ik();
    var b = $8710127e0f817e70$var$uc(a, 0);
    if (0 === (b & 1)) return $8710127e0f817e70$var$Ek(a, $8710127e0f817e70$var$B()), null;
    var c = $8710127e0f817e70$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $8710127e0f817e70$var$xc(a);
        0 !== d && (b = d, c = $8710127e0f817e70$var$Ok(a, d));
    }
    if (1 === c) throw c = $8710127e0f817e70$var$qk, $8710127e0f817e70$var$Lk(a, 0), $8710127e0f817e70$var$Dk(a, b), $8710127e0f817e70$var$Ek(a, $8710127e0f817e70$var$B()), c;
    if (6 === c) throw Error($8710127e0f817e70$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $8710127e0f817e70$var$Qk(a, $8710127e0f817e70$var$uk, $8710127e0f817e70$var$vk);
    $8710127e0f817e70$var$Ek(a, $8710127e0f817e70$var$B());
    return null;
}
function $8710127e0f817e70$var$Rk(a, b) {
    var c = $8710127e0f817e70$var$K;
    $8710127e0f817e70$var$K |= 1;
    try {
        return a(b);
    } finally{
        $8710127e0f817e70$var$K = c, 0 === $8710127e0f817e70$var$K && ($8710127e0f817e70$var$Hj = $8710127e0f817e70$var$B() + 500, $8710127e0f817e70$var$fg && $8710127e0f817e70$var$jg());
    }
}
function $8710127e0f817e70$var$Sk(a) {
    null !== $8710127e0f817e70$var$xk && 0 === $8710127e0f817e70$var$xk.tag && 0 === ($8710127e0f817e70$var$K & 6) && $8710127e0f817e70$var$Ik();
    var b = $8710127e0f817e70$var$K;
    $8710127e0f817e70$var$K |= 1;
    var c = $8710127e0f817e70$var$pk.transition, d = $8710127e0f817e70$var$C;
    try {
        if ($8710127e0f817e70$var$pk.transition = null, $8710127e0f817e70$var$C = 1, a) return a();
    } finally{
        $8710127e0f817e70$var$C = d, $8710127e0f817e70$var$pk.transition = c, $8710127e0f817e70$var$K = b, 0 === ($8710127e0f817e70$var$K & 6) && $8710127e0f817e70$var$jg();
    }
}
function $8710127e0f817e70$var$Ij() {
    $8710127e0f817e70$var$gj = $8710127e0f817e70$var$fj.current;
    $8710127e0f817e70$var$E($8710127e0f817e70$var$fj);
}
function $8710127e0f817e70$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $8710127e0f817e70$var$Gf(c));
    if (null !== $8710127e0f817e70$var$Y) for(c = $8710127e0f817e70$var$Y.return; null !== c;){
        var d = c;
        $8710127e0f817e70$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $8710127e0f817e70$var$$f();
                break;
            case 3:
                $8710127e0f817e70$var$Jh();
                $8710127e0f817e70$var$E($8710127e0f817e70$var$Wf);
                $8710127e0f817e70$var$E($8710127e0f817e70$var$H);
                $8710127e0f817e70$var$Oh();
                break;
            case 5:
                $8710127e0f817e70$var$Lh(d);
                break;
            case 4:
                $8710127e0f817e70$var$Jh();
                break;
            case 13:
                $8710127e0f817e70$var$E($8710127e0f817e70$var$M);
                break;
            case 19:
                $8710127e0f817e70$var$E($8710127e0f817e70$var$M);
                break;
            case 10:
                $8710127e0f817e70$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $8710127e0f817e70$var$Ij();
        }
        c = c.return;
    }
    $8710127e0f817e70$var$R = a;
    $8710127e0f817e70$var$Y = a = $8710127e0f817e70$var$wh(a.current, null);
    $8710127e0f817e70$var$Z = $8710127e0f817e70$var$gj = b;
    $8710127e0f817e70$var$T = 0;
    $8710127e0f817e70$var$qk = null;
    $8710127e0f817e70$var$sk = $8710127e0f817e70$var$rk = $8710127e0f817e70$var$hh = 0;
    $8710127e0f817e70$var$uk = $8710127e0f817e70$var$tk = null;
    if (null !== $8710127e0f817e70$var$Wg) {
        for(b = 0; b < $8710127e0f817e70$var$Wg.length; b++)if (c = $8710127e0f817e70$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $8710127e0f817e70$var$Wg = null;
    }
    return a;
}
function $8710127e0f817e70$var$Nk(a, b) {
    do {
        var c = $8710127e0f817e70$var$Y;
        try {
            $8710127e0f817e70$var$Qg();
            $8710127e0f817e70$var$Ph.current = $8710127e0f817e70$var$ai;
            if ($8710127e0f817e70$var$Sh) {
                for(var d = $8710127e0f817e70$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $8710127e0f817e70$var$Sh = !1;
            }
            $8710127e0f817e70$var$Rh = 0;
            $8710127e0f817e70$var$P = $8710127e0f817e70$var$O = $8710127e0f817e70$var$N = null;
            $8710127e0f817e70$var$Th = !1;
            $8710127e0f817e70$var$Uh = 0;
            $8710127e0f817e70$var$ok.current = null;
            if (null === c || null === c.return) {
                $8710127e0f817e70$var$T = 1;
                $8710127e0f817e70$var$qk = b;
                $8710127e0f817e70$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $8710127e0f817e70$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $8710127e0f817e70$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $8710127e0f817e70$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $8710127e0f817e70$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $8710127e0f817e70$var$Ti(f, l, b);
                            $8710127e0f817e70$var$uj();
                            break a;
                        }
                        k = Error($8710127e0f817e70$var$p(426));
                    }
                } else if ($8710127e0f817e70$var$I && h.mode & 1) {
                    var J = $8710127e0f817e70$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $8710127e0f817e70$var$Wi(J, g, h, f, b);
                        $8710127e0f817e70$var$Jg($8710127e0f817e70$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $8710127e0f817e70$var$Ki(k, h);
                4 !== $8710127e0f817e70$var$T && ($8710127e0f817e70$var$T = 2);
                null === $8710127e0f817e70$var$tk ? $8710127e0f817e70$var$tk = [
                    f
                ] : $8710127e0f817e70$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $8710127e0f817e70$var$Oi(f, k, b);
                            $8710127e0f817e70$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $8710127e0f817e70$var$Si || !$8710127e0f817e70$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $8710127e0f817e70$var$Ri(f, h, b);
                                $8710127e0f817e70$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $8710127e0f817e70$var$Tk(c);
        } catch (na) {
            b = na;
            $8710127e0f817e70$var$Y === c && null !== c && ($8710127e0f817e70$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $8710127e0f817e70$var$Kk() {
    var a = $8710127e0f817e70$var$nk.current;
    $8710127e0f817e70$var$nk.current = $8710127e0f817e70$var$ai;
    return null === a ? $8710127e0f817e70$var$ai : a;
}
function $8710127e0f817e70$var$uj() {
    if (0 === $8710127e0f817e70$var$T || 3 === $8710127e0f817e70$var$T || 2 === $8710127e0f817e70$var$T) $8710127e0f817e70$var$T = 4;
    null === $8710127e0f817e70$var$R || 0 === ($8710127e0f817e70$var$hh & 268435455) && 0 === ($8710127e0f817e70$var$rk & 268435455) || $8710127e0f817e70$var$Dk($8710127e0f817e70$var$R, $8710127e0f817e70$var$Z);
}
function $8710127e0f817e70$var$Jk(a, b) {
    var c = $8710127e0f817e70$var$K;
    $8710127e0f817e70$var$K |= 2;
    var d = $8710127e0f817e70$var$Kk();
    if ($8710127e0f817e70$var$R !== a || $8710127e0f817e70$var$Z !== b) $8710127e0f817e70$var$vk = null, $8710127e0f817e70$var$Lk(a, b);
    for(;;)try {
        $8710127e0f817e70$var$Uk();
        break;
    } catch (e) {
        $8710127e0f817e70$var$Nk(a, e);
    }
    $8710127e0f817e70$var$Qg();
    $8710127e0f817e70$var$K = c;
    $8710127e0f817e70$var$nk.current = d;
    if (null !== $8710127e0f817e70$var$Y) throw Error($8710127e0f817e70$var$p(261));
    $8710127e0f817e70$var$R = null;
    $8710127e0f817e70$var$Z = 0;
    return $8710127e0f817e70$var$T;
}
function $8710127e0f817e70$var$Uk() {
    for(; null !== $8710127e0f817e70$var$Y;)$8710127e0f817e70$var$Vk($8710127e0f817e70$var$Y);
}
function $8710127e0f817e70$var$Mk() {
    for(; null !== $8710127e0f817e70$var$Y && !$8710127e0f817e70$var$cc();)$8710127e0f817e70$var$Vk($8710127e0f817e70$var$Y);
}
function $8710127e0f817e70$var$Vk(a) {
    var b = $8710127e0f817e70$var$Wk(a.alternate, a, $8710127e0f817e70$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $8710127e0f817e70$var$Tk(a) : $8710127e0f817e70$var$Y = b;
    $8710127e0f817e70$var$ok.current = null;
}
function $8710127e0f817e70$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $8710127e0f817e70$var$Fj(c, b, $8710127e0f817e70$var$gj), null !== c) {
                $8710127e0f817e70$var$Y = c;
                return;
            }
        } else {
            c = $8710127e0f817e70$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $8710127e0f817e70$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $8710127e0f817e70$var$T = 6;
                $8710127e0f817e70$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $8710127e0f817e70$var$Y = b;
            return;
        }
        $8710127e0f817e70$var$Y = b = a;
    }while (null !== b);
    0 === $8710127e0f817e70$var$T && ($8710127e0f817e70$var$T = 5);
}
function $8710127e0f817e70$var$Qk(a, b, c) {
    var d = $8710127e0f817e70$var$C, e = $8710127e0f817e70$var$pk.transition;
    try {
        $8710127e0f817e70$var$pk.transition = null, $8710127e0f817e70$var$C = 1, $8710127e0f817e70$var$Xk(a, b, c, d);
    } finally{
        $8710127e0f817e70$var$pk.transition = e, $8710127e0f817e70$var$C = d;
    }
    return null;
}
function $8710127e0f817e70$var$Xk(a, b, c, d) {
    do $8710127e0f817e70$var$Ik();
    while (null !== $8710127e0f817e70$var$xk);
    if (0 !== ($8710127e0f817e70$var$K & 6)) throw Error($8710127e0f817e70$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($8710127e0f817e70$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $8710127e0f817e70$var$Bc(a, f);
    a === $8710127e0f817e70$var$R && ($8710127e0f817e70$var$Y = $8710127e0f817e70$var$R = null, $8710127e0f817e70$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $8710127e0f817e70$var$wk || ($8710127e0f817e70$var$wk = !0, $8710127e0f817e70$var$Gk($8710127e0f817e70$var$hc, function() {
        $8710127e0f817e70$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $8710127e0f817e70$var$pk.transition;
        $8710127e0f817e70$var$pk.transition = null;
        var g = $8710127e0f817e70$var$C;
        $8710127e0f817e70$var$C = 1;
        var h = $8710127e0f817e70$var$K;
        $8710127e0f817e70$var$K |= 4;
        $8710127e0f817e70$var$ok.current = null;
        $8710127e0f817e70$var$Pj(a, c);
        $8710127e0f817e70$var$ek(c, a);
        $8710127e0f817e70$var$Oe($8710127e0f817e70$var$Df);
        $8710127e0f817e70$var$dd = !!$8710127e0f817e70$var$Cf;
        $8710127e0f817e70$var$Df = $8710127e0f817e70$var$Cf = null;
        a.current = c;
        $8710127e0f817e70$var$ik(c, a, e);
        $8710127e0f817e70$var$dc();
        $8710127e0f817e70$var$K = h;
        $8710127e0f817e70$var$C = g;
        $8710127e0f817e70$var$pk.transition = f;
    } else a.current = c;
    $8710127e0f817e70$var$wk && ($8710127e0f817e70$var$wk = !1, $8710127e0f817e70$var$xk = a, $8710127e0f817e70$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($8710127e0f817e70$var$Si = null);
    $8710127e0f817e70$var$mc(c.stateNode, d);
    $8710127e0f817e70$var$Ek(a, $8710127e0f817e70$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($8710127e0f817e70$var$Pi) throw $8710127e0f817e70$var$Pi = !1, a = $8710127e0f817e70$var$Qi, $8710127e0f817e70$var$Qi = null, a;
    0 !== ($8710127e0f817e70$var$yk & 1) && 0 !== a.tag && $8710127e0f817e70$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $8710127e0f817e70$var$Ak ? $8710127e0f817e70$var$zk++ : ($8710127e0f817e70$var$zk = 0, $8710127e0f817e70$var$Ak = a) : $8710127e0f817e70$var$zk = 0;
    $8710127e0f817e70$var$jg();
    return null;
}
function $8710127e0f817e70$var$Ik() {
    if (null !== $8710127e0f817e70$var$xk) {
        var a = $8710127e0f817e70$var$Dc($8710127e0f817e70$var$yk), b = $8710127e0f817e70$var$pk.transition, c = $8710127e0f817e70$var$C;
        try {
            $8710127e0f817e70$var$pk.transition = null;
            $8710127e0f817e70$var$C = 16 > a ? 16 : a;
            if (null === $8710127e0f817e70$var$xk) var d = !1;
            else {
                a = $8710127e0f817e70$var$xk;
                $8710127e0f817e70$var$xk = null;
                $8710127e0f817e70$var$yk = 0;
                if (0 !== ($8710127e0f817e70$var$K & 6)) throw Error($8710127e0f817e70$var$p(331));
                var e = $8710127e0f817e70$var$K;
                $8710127e0f817e70$var$K |= 4;
                for($8710127e0f817e70$var$V = a.current; null !== $8710127e0f817e70$var$V;){
                    var f = $8710127e0f817e70$var$V, g = f.child;
                    if (0 !== ($8710127e0f817e70$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($8710127e0f817e70$var$V = l; null !== $8710127e0f817e70$var$V;){
                                    var m = $8710127e0f817e70$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $8710127e0f817e70$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $8710127e0f817e70$var$V = q;
                                    else for(; null !== $8710127e0f817e70$var$V;){
                                        m = $8710127e0f817e70$var$V;
                                        var r = m.sibling, y = m.return;
                                        $8710127e0f817e70$var$Tj(m);
                                        if (m === l) {
                                            $8710127e0f817e70$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $8710127e0f817e70$var$V = r;
                                            break;
                                        }
                                        $8710127e0f817e70$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $8710127e0f817e70$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $8710127e0f817e70$var$V = g;
                    else b: for(; null !== $8710127e0f817e70$var$V;){
                        f = $8710127e0f817e70$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $8710127e0f817e70$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $8710127e0f817e70$var$V = x;
                            break b;
                        }
                        $8710127e0f817e70$var$V = f.return;
                    }
                }
                var w = a.current;
                for($8710127e0f817e70$var$V = w; null !== $8710127e0f817e70$var$V;){
                    g = $8710127e0f817e70$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $8710127e0f817e70$var$V = u;
                    else b: for(g = w; null !== $8710127e0f817e70$var$V;){
                        h = $8710127e0f817e70$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $8710127e0f817e70$var$Rj(9, h);
                            }
                        } catch (na) {
                            $8710127e0f817e70$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $8710127e0f817e70$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $8710127e0f817e70$var$V = F;
                            break b;
                        }
                        $8710127e0f817e70$var$V = h.return;
                    }
                }
                $8710127e0f817e70$var$K = e;
                $8710127e0f817e70$var$jg();
                if ($8710127e0f817e70$var$lc && "function" === typeof $8710127e0f817e70$var$lc.onPostCommitFiberRoot) try {
                    $8710127e0f817e70$var$lc.onPostCommitFiberRoot($8710127e0f817e70$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $8710127e0f817e70$var$C = c, $8710127e0f817e70$var$pk.transition = b;
        }
    }
    return !1;
}
function $8710127e0f817e70$var$Yk(a, b, c) {
    b = $8710127e0f817e70$var$Ki(c, b);
    b = $8710127e0f817e70$var$Oi(a, b, 1);
    a = $8710127e0f817e70$var$dh(a, b, 1);
    b = $8710127e0f817e70$var$L();
    null !== a && ($8710127e0f817e70$var$Ac(a, 1, b), $8710127e0f817e70$var$Ek(a, b));
}
function $8710127e0f817e70$var$W(a, b, c) {
    if (3 === a.tag) $8710127e0f817e70$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $8710127e0f817e70$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $8710127e0f817e70$var$Si || !$8710127e0f817e70$var$Si.has(d))) {
                a = $8710127e0f817e70$var$Ki(c, a);
                a = $8710127e0f817e70$var$Ri(b, a, 1);
                b = $8710127e0f817e70$var$dh(b, a, 1);
                a = $8710127e0f817e70$var$L();
                null !== b && ($8710127e0f817e70$var$Ac(b, 1, a), $8710127e0f817e70$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $8710127e0f817e70$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $8710127e0f817e70$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $8710127e0f817e70$var$R === a && ($8710127e0f817e70$var$Z & c) === c && (4 === $8710127e0f817e70$var$T || 3 === $8710127e0f817e70$var$T && ($8710127e0f817e70$var$Z & 130023424) === $8710127e0f817e70$var$Z && 500 > $8710127e0f817e70$var$B() - $8710127e0f817e70$var$gk ? $8710127e0f817e70$var$Lk(a, 0) : $8710127e0f817e70$var$sk |= c);
    $8710127e0f817e70$var$Ek(a, b);
}
function $8710127e0f817e70$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $8710127e0f817e70$var$sc, $8710127e0f817e70$var$sc <<= 1, 0 === ($8710127e0f817e70$var$sc & 130023424) && ($8710127e0f817e70$var$sc = 4194304)));
    var c = $8710127e0f817e70$var$L();
    a = $8710127e0f817e70$var$Zg(a, b);
    null !== a && ($8710127e0f817e70$var$Ac(a, b, c), $8710127e0f817e70$var$Ek(a, c));
}
function $8710127e0f817e70$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $8710127e0f817e70$var$Zk(a, c);
}
function $8710127e0f817e70$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($8710127e0f817e70$var$p(314));
    }
    null !== d && d.delete(b);
    $8710127e0f817e70$var$Zk(a, c);
}
var $8710127e0f817e70$var$Wk;
$8710127e0f817e70$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $8710127e0f817e70$var$Wf.current) $8710127e0f817e70$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $8710127e0f817e70$var$Ug = !1, $8710127e0f817e70$var$zj(a, b, c);
            $8710127e0f817e70$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $8710127e0f817e70$var$Ug = !1, $8710127e0f817e70$var$I && 0 !== (b.flags & 1048576) && $8710127e0f817e70$var$ug(b, $8710127e0f817e70$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $8710127e0f817e70$var$jj(a, b);
            a = b.pendingProps;
            var e = $8710127e0f817e70$var$Yf(b, $8710127e0f817e70$var$H.current);
            $8710127e0f817e70$var$Tg(b, c);
            e = $8710127e0f817e70$var$Xh(null, b, d, a, e, c);
            var f = $8710127e0f817e70$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $8710127e0f817e70$var$Zf(d) ? (f = !0, $8710127e0f817e70$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $8710127e0f817e70$var$ah(b), e.updater = $8710127e0f817e70$var$nh, b.stateNode = e, e._reactInternals = b, $8710127e0f817e70$var$rh(b, d, a, c), b = $8710127e0f817e70$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $8710127e0f817e70$var$I && f && $8710127e0f817e70$var$vg(b), $8710127e0f817e70$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $8710127e0f817e70$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $8710127e0f817e70$var$$k(d);
                a = $8710127e0f817e70$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $8710127e0f817e70$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $8710127e0f817e70$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $8710127e0f817e70$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $8710127e0f817e70$var$aj(null, b, d, $8710127e0f817e70$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($8710127e0f817e70$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8710127e0f817e70$var$Lg(d, e), $8710127e0f817e70$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8710127e0f817e70$var$Lg(d, e), $8710127e0f817e70$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $8710127e0f817e70$var$lj(b);
                if (null === a) throw Error($8710127e0f817e70$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $8710127e0f817e70$var$bh(a, b);
                $8710127e0f817e70$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $8710127e0f817e70$var$Ki(Error($8710127e0f817e70$var$p(423)), b);
                        b = $8710127e0f817e70$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $8710127e0f817e70$var$Ki(Error($8710127e0f817e70$var$p(424)), b);
                        b = $8710127e0f817e70$var$mj(a, b, d, c, e);
                        break a;
                    } else for($8710127e0f817e70$var$yg = $8710127e0f817e70$var$Lf(b.stateNode.containerInfo.firstChild), $8710127e0f817e70$var$xg = b, $8710127e0f817e70$var$I = !0, $8710127e0f817e70$var$zg = null, c = $8710127e0f817e70$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $8710127e0f817e70$var$Ig();
                    if (d === e) {
                        b = $8710127e0f817e70$var$$i(a, b, c);
                        break a;
                    }
                    $8710127e0f817e70$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $8710127e0f817e70$var$Kh(b), null === a && $8710127e0f817e70$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $8710127e0f817e70$var$Ef(d, e) ? g = null : null !== f && $8710127e0f817e70$var$Ef(d, f) && (b.flags |= 32), $8710127e0f817e70$var$hj(a, b), $8710127e0f817e70$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $8710127e0f817e70$var$Eg(b), null;
        case 13:
            return $8710127e0f817e70$var$pj(a, b, c);
        case 4:
            return $8710127e0f817e70$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $8710127e0f817e70$var$Bh(b, null, d, c) : $8710127e0f817e70$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8710127e0f817e70$var$Lg(d, e), $8710127e0f817e70$var$Zi(a, b, d, e, c);
        case 7:
            return $8710127e0f817e70$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $8710127e0f817e70$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $8710127e0f817e70$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $8710127e0f817e70$var$G($8710127e0f817e70$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($8710127e0f817e70$var$He(f.value, g)) {
                        if (f.children === e.children && !$8710127e0f817e70$var$Wf.current) {
                            b = $8710127e0f817e70$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $8710127e0f817e70$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $8710127e0f817e70$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($8710127e0f817e70$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $8710127e0f817e70$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $8710127e0f817e70$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $8710127e0f817e70$var$Tg(b, c), e = $8710127e0f817e70$var$Vg(e), d = d(e), b.flags |= 1, $8710127e0f817e70$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $8710127e0f817e70$var$Lg(d, b.pendingProps), e = $8710127e0f817e70$var$Lg(d.type, e), $8710127e0f817e70$var$aj(a, b, d, e, c);
        case 15:
            return $8710127e0f817e70$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8710127e0f817e70$var$Lg(d, e), $8710127e0f817e70$var$jj(a, b), b.tag = 1, $8710127e0f817e70$var$Zf(d) ? (a = !0, $8710127e0f817e70$var$cg(b)) : a = !1, $8710127e0f817e70$var$Tg(b, c), $8710127e0f817e70$var$ph(b, d, e), $8710127e0f817e70$var$rh(b, d, e, c), $8710127e0f817e70$var$kj(null, b, d, !0, a, c);
        case 19:
            return $8710127e0f817e70$var$yj(a, b, c);
        case 22:
            return $8710127e0f817e70$var$ej(a, b, c);
    }
    throw Error($8710127e0f817e70$var$p(156, b.tag));
};
function $8710127e0f817e70$var$Gk(a, b) {
    return $8710127e0f817e70$var$ac(a, b);
}
function $8710127e0f817e70$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $8710127e0f817e70$var$Bg(a, b, c, d) {
    return new $8710127e0f817e70$var$al(a, b, c, d);
}
function $8710127e0f817e70$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $8710127e0f817e70$var$$k(a) {
    if ("function" === typeof a) return $8710127e0f817e70$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $8710127e0f817e70$var$Da) return 11;
        if (a === $8710127e0f817e70$var$Ga) return 14;
    }
    return 2;
}
function $8710127e0f817e70$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $8710127e0f817e70$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $8710127e0f817e70$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $8710127e0f817e70$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $8710127e0f817e70$var$ya:
            return $8710127e0f817e70$var$Ah(c.children, e, f, b);
        case $8710127e0f817e70$var$za:
            g = 8;
            e |= 8;
            break;
        case $8710127e0f817e70$var$Aa:
            return a = $8710127e0f817e70$var$Bg(12, c, b, e | 2), a.elementType = $8710127e0f817e70$var$Aa, a.lanes = f, a;
        case $8710127e0f817e70$var$Ea:
            return a = $8710127e0f817e70$var$Bg(13, c, b, e), a.elementType = $8710127e0f817e70$var$Ea, a.lanes = f, a;
        case $8710127e0f817e70$var$Fa:
            return a = $8710127e0f817e70$var$Bg(19, c, b, e), a.elementType = $8710127e0f817e70$var$Fa, a.lanes = f, a;
        case $8710127e0f817e70$var$Ia:
            return $8710127e0f817e70$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $8710127e0f817e70$var$Ba:
                    g = 10;
                    break a;
                case $8710127e0f817e70$var$Ca:
                    g = 9;
                    break a;
                case $8710127e0f817e70$var$Da:
                    g = 11;
                    break a;
                case $8710127e0f817e70$var$Ga:
                    g = 14;
                    break a;
                case $8710127e0f817e70$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($8710127e0f817e70$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $8710127e0f817e70$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $8710127e0f817e70$var$Ah(a, b, c, d) {
    a = $8710127e0f817e70$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $8710127e0f817e70$var$qj(a, b, c, d) {
    a = $8710127e0f817e70$var$Bg(22, a, d, b);
    a.elementType = $8710127e0f817e70$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $8710127e0f817e70$var$xh(a, b, c) {
    a = $8710127e0f817e70$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $8710127e0f817e70$var$zh(a, b, c) {
    b = $8710127e0f817e70$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $8710127e0f817e70$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $8710127e0f817e70$var$zc(0);
    this.expirationTimes = $8710127e0f817e70$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $8710127e0f817e70$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $8710127e0f817e70$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $8710127e0f817e70$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $8710127e0f817e70$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $8710127e0f817e70$var$ah(f);
    return a;
}
function $8710127e0f817e70$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $8710127e0f817e70$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $8710127e0f817e70$var$el(a) {
    if (!a) return $8710127e0f817e70$var$Vf;
    a = a._reactInternals;
    a: {
        if ($8710127e0f817e70$var$Vb(a) !== a || 1 !== a.tag) throw Error($8710127e0f817e70$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($8710127e0f817e70$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($8710127e0f817e70$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($8710127e0f817e70$var$Zf(c)) return $8710127e0f817e70$var$bg(a, c, b);
    }
    return b;
}
function $8710127e0f817e70$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $8710127e0f817e70$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $8710127e0f817e70$var$el(null);
    c = a.current;
    d = $8710127e0f817e70$var$L();
    e = $8710127e0f817e70$var$lh(c);
    f = $8710127e0f817e70$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $8710127e0f817e70$var$dh(c, f, e);
    a.current.lanes = e;
    $8710127e0f817e70$var$Ac(a, e, d);
    $8710127e0f817e70$var$Ek(a, d);
    return a;
}
function $8710127e0f817e70$var$gl(a, b, c, d) {
    var e = b.current, f = $8710127e0f817e70$var$L(), g = $8710127e0f817e70$var$lh(e);
    c = $8710127e0f817e70$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $8710127e0f817e70$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $8710127e0f817e70$var$dh(e, b, g);
    null !== a && ($8710127e0f817e70$var$mh(a, e, g, f), $8710127e0f817e70$var$eh(a, e, g));
    return g;
}
function $8710127e0f817e70$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $8710127e0f817e70$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $8710127e0f817e70$var$jl(a, b) {
    $8710127e0f817e70$var$il(a, b);
    (a = a.alternate) && $8710127e0f817e70$var$il(a, b);
}
function $8710127e0f817e70$var$kl() {
    return null;
}
var $8710127e0f817e70$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $8710127e0f817e70$var$ml(a) {
    this._internalRoot = a;
}
$8710127e0f817e70$var$nl.prototype.render = $8710127e0f817e70$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($8710127e0f817e70$var$p(409));
    $8710127e0f817e70$var$gl(a, b, null, null);
};
$8710127e0f817e70$var$nl.prototype.unmount = $8710127e0f817e70$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $8710127e0f817e70$var$Sk(function() {
            $8710127e0f817e70$var$gl(null, a, null, null);
        });
        b[$8710127e0f817e70$var$uf] = null;
    }
};
function $8710127e0f817e70$var$nl(a) {
    this._internalRoot = a;
}
$8710127e0f817e70$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $8710127e0f817e70$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $8710127e0f817e70$var$Qc.length && 0 !== b && b < $8710127e0f817e70$var$Qc[c].priority; c++);
        $8710127e0f817e70$var$Qc.splice(c, 0, a);
        0 === c && $8710127e0f817e70$var$Vc(a);
    }
};
function $8710127e0f817e70$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $8710127e0f817e70$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $8710127e0f817e70$var$ql() {}
function $8710127e0f817e70$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $8710127e0f817e70$var$hl(g);
                f.call(a);
            };
        }
        var g = $8710127e0f817e70$var$fl(b, d, a, 0, null, !1, !1, "", $8710127e0f817e70$var$ql);
        a._reactRootContainer = g;
        a[$8710127e0f817e70$var$uf] = g.current;
        $8710127e0f817e70$var$sf(8 === a.nodeType ? a.parentNode : a);
        $8710127e0f817e70$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $8710127e0f817e70$var$hl(k);
            h.call(a);
        };
    }
    var k = $8710127e0f817e70$var$cl(a, 0, !1, null, null, !1, !1, "", $8710127e0f817e70$var$ql);
    a._reactRootContainer = k;
    a[$8710127e0f817e70$var$uf] = k.current;
    $8710127e0f817e70$var$sf(8 === a.nodeType ? a.parentNode : a);
    $8710127e0f817e70$var$Sk(function() {
        $8710127e0f817e70$var$gl(b, k, c, d);
    });
    return k;
}
function $8710127e0f817e70$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $8710127e0f817e70$var$hl(g);
                h.call(a);
            };
        }
        $8710127e0f817e70$var$gl(b, g, a, e);
    } else g = $8710127e0f817e70$var$rl(c, b, a, e, d);
    return $8710127e0f817e70$var$hl(g);
}
$8710127e0f817e70$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $8710127e0f817e70$var$tc(b.pendingLanes);
                0 !== c && ($8710127e0f817e70$var$Cc(b, c | 1), $8710127e0f817e70$var$Ek(b, $8710127e0f817e70$var$B()), 0 === ($8710127e0f817e70$var$K & 6) && ($8710127e0f817e70$var$Hj = $8710127e0f817e70$var$B() + 500, $8710127e0f817e70$var$jg()));
            }
            break;
        case 13:
            $8710127e0f817e70$var$Sk(function() {
                var b = $8710127e0f817e70$var$Zg(a, 1);
                if (null !== b) {
                    var c = $8710127e0f817e70$var$L();
                    $8710127e0f817e70$var$mh(b, a, 1, c);
                }
            }), $8710127e0f817e70$var$jl(a, 1);
    }
};
$8710127e0f817e70$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $8710127e0f817e70$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $8710127e0f817e70$var$L();
            $8710127e0f817e70$var$mh(b, a, 134217728, c);
        }
        $8710127e0f817e70$var$jl(a, 134217728);
    }
};
$8710127e0f817e70$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $8710127e0f817e70$var$lh(a), c = $8710127e0f817e70$var$Zg(a, b);
        if (null !== c) {
            var d = $8710127e0f817e70$var$L();
            $8710127e0f817e70$var$mh(c, a, b, d);
        }
        $8710127e0f817e70$var$jl(a, b);
    }
};
$8710127e0f817e70$var$Hc = function() {
    return $8710127e0f817e70$var$C;
};
$8710127e0f817e70$var$Ic = function(a, b) {
    var c = $8710127e0f817e70$var$C;
    try {
        return $8710127e0f817e70$var$C = a, b();
    } finally{
        $8710127e0f817e70$var$C = c;
    }
};
$8710127e0f817e70$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $8710127e0f817e70$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $8710127e0f817e70$var$Db(d);
                        if (!e) throw Error($8710127e0f817e70$var$p(90));
                        $8710127e0f817e70$var$Wa(d);
                        $8710127e0f817e70$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $8710127e0f817e70$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $8710127e0f817e70$var$fb(a, !!c.multiple, b, !1);
    }
};
$8710127e0f817e70$var$Gb = $8710127e0f817e70$var$Rk;
$8710127e0f817e70$var$Hb = $8710127e0f817e70$var$Sk;
var $8710127e0f817e70$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $8710127e0f817e70$var$Cb,
        $8710127e0f817e70$var$ue,
        $8710127e0f817e70$var$Db,
        $8710127e0f817e70$var$Eb,
        $8710127e0f817e70$var$Fb,
        $8710127e0f817e70$var$Rk
    ]
}, $8710127e0f817e70$var$ul = {
    findFiberByHostInstance: $8710127e0f817e70$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $8710127e0f817e70$var$vl = {
    bundleType: $8710127e0f817e70$var$ul.bundleType,
    version: $8710127e0f817e70$var$ul.version,
    rendererPackageName: $8710127e0f817e70$var$ul.rendererPackageName,
    rendererConfig: $8710127e0f817e70$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $8710127e0f817e70$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $8710127e0f817e70$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $8710127e0f817e70$var$ul.findFiberByHostInstance || $8710127e0f817e70$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $8710127e0f817e70$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$8710127e0f817e70$var$wl.isDisabled && $8710127e0f817e70$var$wl.supportsFiber) try {
        $8710127e0f817e70$var$kc = $8710127e0f817e70$var$wl.inject($8710127e0f817e70$var$vl), $8710127e0f817e70$var$lc = $8710127e0f817e70$var$wl;
    } catch (a) {}
}
$8710127e0f817e70$export$ae55be85d98224ed = $8710127e0f817e70$var$tl;
$8710127e0f817e70$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$8710127e0f817e70$var$ol(b)) throw Error($8710127e0f817e70$var$p(200));
    return $8710127e0f817e70$var$dl(a, b, null, c);
};
$8710127e0f817e70$export$882461b6382ed46c = function(a, b) {
    if (!$8710127e0f817e70$var$ol(a)) throw Error($8710127e0f817e70$var$p(299));
    var c = !1, d = "", e = $8710127e0f817e70$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $8710127e0f817e70$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$8710127e0f817e70$var$uf] = b.current;
    $8710127e0f817e70$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $8710127e0f817e70$var$ml(b);
};
$8710127e0f817e70$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($8710127e0f817e70$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($8710127e0f817e70$var$p(268, a));
    }
    a = $8710127e0f817e70$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$8710127e0f817e70$export$cd75ccfd720a3cd4 = function(a) {
    return $8710127e0f817e70$var$Sk(a);
};
$8710127e0f817e70$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$8710127e0f817e70$var$pl(b)) throw Error($8710127e0f817e70$var$p(200));
    return $8710127e0f817e70$var$sl(null, a, b, !0, c);
};
$8710127e0f817e70$export$757ceba2d55c277e = function(a, b, c) {
    if (!$8710127e0f817e70$var$ol(a)) throw Error($8710127e0f817e70$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $8710127e0f817e70$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $8710127e0f817e70$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$8710127e0f817e70$var$uf] = b.current;
    $8710127e0f817e70$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $8710127e0f817e70$var$nl(b);
};
$8710127e0f817e70$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$8710127e0f817e70$var$pl(b)) throw Error($8710127e0f817e70$var$p(200));
    return $8710127e0f817e70$var$sl(null, a, b, !1, c);
};
$8710127e0f817e70$export$502457920280e6be = function(a) {
    if (!$8710127e0f817e70$var$pl(a)) throw Error($8710127e0f817e70$var$p(40));
    return a._reactRootContainer ? ($8710127e0f817e70$var$Sk(function() {
        $8710127e0f817e70$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$8710127e0f817e70$var$uf] = null;
        });
    }), !0) : !1;
};
$8710127e0f817e70$export$c78a37762a8d58e1 = $8710127e0f817e70$var$Rk;
$8710127e0f817e70$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$8710127e0f817e70$var$pl(c)) throw Error($8710127e0f817e70$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($8710127e0f817e70$var$p(38));
    return $8710127e0f817e70$var$sl(a, b, c, !1, d);
};
$8710127e0f817e70$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fy3yX", function(module, exports) {
"use strict";

module.exports = (parcelRequire("14TgO"));

});
parcelRegister("14TgO", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $0c9109ae8c870d78$export$c4744153514ff05d; }, function (v) { return $0c9109ae8c870d78$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $0c9109ae8c870d78$export$3e506c1ccc9cc1a7; }, function (v) { return $0c9109ae8c870d78$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $0c9109ae8c870d78$export$e26fe2ed2fa76875; }, function (v) { return $0c9109ae8c870d78$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $0c9109ae8c870d78$export$502329bbf4b505b1; }, function (v) { return $0c9109ae8c870d78$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $0c9109ae8c870d78$export$6e3807111c4874c4; }, function (v) { return $0c9109ae8c870d78$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $0c9109ae8c870d78$export$c27134553091fb3a; }, function (v) { return $0c9109ae8c870d78$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $0c9109ae8c870d78$export$33ee1acdc04fd2a2; }, function (v) { return $0c9109ae8c870d78$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $0c9109ae8c870d78$export$b00a404bbd5edef2; }, function (v) { return $0c9109ae8c870d78$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $0c9109ae8c870d78$export$8352ce38b91d0c62; }, function (v) { return $0c9109ae8c870d78$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $0c9109ae8c870d78$export$d66a1c1c77bd778b; }, function (v) { return $0c9109ae8c870d78$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $0c9109ae8c870d78$export$d3dfb8e4810cb555; }, function (v) { return $0c9109ae8c870d78$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $0c9109ae8c870d78$export$839f9183b0465a69; }, function (v) { return $0c9109ae8c870d78$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $0c9109ae8c870d78$export$72fdf0e06517287b; }, function (v) { return $0c9109ae8c870d78$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $0c9109ae8c870d78$export$4b844e58a3e414b4; }, function (v) { return $0c9109ae8c870d78$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $0c9109ae8c870d78$export$816d2913ae6b83b1; }, function (v) { return $0c9109ae8c870d78$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $0c9109ae8c870d78$export$61bcfe829111a1d0; }, function (v) { return $0c9109ae8c870d78$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $0c9109ae8c870d78$export$7ee8c9beb337bc3f; }, function (v) { return $0c9109ae8c870d78$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $0c9109ae8c870d78$export$b5836b71941fa3ed; }, function (v) { return $0c9109ae8c870d78$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $0c9109ae8c870d78$export$cf845f2c119da08a; }, function (v) { return $0c9109ae8c870d78$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0c9109ae8c870d78$export$c4744153514ff05d;
var $0c9109ae8c870d78$export$3e506c1ccc9cc1a7;
var $0c9109ae8c870d78$export$e26fe2ed2fa76875;
var $0c9109ae8c870d78$export$502329bbf4b505b1;
var $0c9109ae8c870d78$export$6e3807111c4874c4;
var $0c9109ae8c870d78$export$c27134553091fb3a;
var $0c9109ae8c870d78$export$33ee1acdc04fd2a2;
var $0c9109ae8c870d78$export$b00a404bbd5edef2;
var $0c9109ae8c870d78$export$8352ce38b91d0c62;
var $0c9109ae8c870d78$export$d66a1c1c77bd778b;
var $0c9109ae8c870d78$export$d3dfb8e4810cb555;
var $0c9109ae8c870d78$export$839f9183b0465a69;
var $0c9109ae8c870d78$export$72fdf0e06517287b;
var $0c9109ae8c870d78$export$4b844e58a3e414b4;
var $0c9109ae8c870d78$export$816d2913ae6b83b1;
var $0c9109ae8c870d78$export$61bcfe829111a1d0;
var $0c9109ae8c870d78$export$7ee8c9beb337bc3f;
var $0c9109ae8c870d78$export$b5836b71941fa3ed;
var $0c9109ae8c870d78$export$cf845f2c119da08a;
"use strict";
function $0c9109ae8c870d78$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $0c9109ae8c870d78$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $0c9109ae8c870d78$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $0c9109ae8c870d78$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $0c9109ae8c870d78$var$g(C, c)) n < e && 0 > $0c9109ae8c870d78$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $0c9109ae8c870d78$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $0c9109ae8c870d78$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $0c9109ae8c870d78$var$l = performance;
    $0c9109ae8c870d78$export$c4744153514ff05d = function() {
        return $0c9109ae8c870d78$var$l.now();
    };
} else {
    var $0c9109ae8c870d78$var$p = Date, $0c9109ae8c870d78$var$q = $0c9109ae8c870d78$var$p.now();
    $0c9109ae8c870d78$export$c4744153514ff05d = function() {
        return $0c9109ae8c870d78$var$p.now() - $0c9109ae8c870d78$var$q;
    };
}
var $0c9109ae8c870d78$var$r = [], $0c9109ae8c870d78$var$t = [], $0c9109ae8c870d78$var$u = 1, $0c9109ae8c870d78$var$v = null, $0c9109ae8c870d78$var$y = 3, $0c9109ae8c870d78$var$z = !1, $0c9109ae8c870d78$var$A = !1, $0c9109ae8c870d78$var$B = !1, $0c9109ae8c870d78$var$D = "function" === typeof setTimeout ? setTimeout : null, $0c9109ae8c870d78$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $0c9109ae8c870d78$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $0c9109ae8c870d78$var$G(a) {
    for(var b = $0c9109ae8c870d78$var$h($0c9109ae8c870d78$var$t); null !== b;){
        if (null === b.callback) $0c9109ae8c870d78$var$k($0c9109ae8c870d78$var$t);
        else if (b.startTime <= a) $0c9109ae8c870d78$var$k($0c9109ae8c870d78$var$t), b.sortIndex = b.expirationTime, $0c9109ae8c870d78$var$f($0c9109ae8c870d78$var$r, b);
        else break;
        b = $0c9109ae8c870d78$var$h($0c9109ae8c870d78$var$t);
    }
}
function $0c9109ae8c870d78$var$H(a) {
    $0c9109ae8c870d78$var$B = !1;
    $0c9109ae8c870d78$var$G(a);
    if (!$0c9109ae8c870d78$var$A) {
        if (null !== $0c9109ae8c870d78$var$h($0c9109ae8c870d78$var$r)) $0c9109ae8c870d78$var$A = !0, $0c9109ae8c870d78$var$I($0c9109ae8c870d78$var$J);
        else {
            var b = $0c9109ae8c870d78$var$h($0c9109ae8c870d78$var$t);
            null !== b && $0c9109ae8c870d78$var$K($0c9109ae8c870d78$var$H, b.startTime - a);
        }
    }
}
function $0c9109ae8c870d78$var$J(a, b) {
    $0c9109ae8c870d78$var$A = !1;
    $0c9109ae8c870d78$var$B && ($0c9109ae8c870d78$var$B = !1, $0c9109ae8c870d78$var$E($0c9109ae8c870d78$var$L), $0c9109ae8c870d78$var$L = -1);
    $0c9109ae8c870d78$var$z = !0;
    var c = $0c9109ae8c870d78$var$y;
    try {
        $0c9109ae8c870d78$var$G(b);
        for($0c9109ae8c870d78$var$v = $0c9109ae8c870d78$var$h($0c9109ae8c870d78$var$r); null !== $0c9109ae8c870d78$var$v && (!($0c9109ae8c870d78$var$v.expirationTime > b) || a && !$0c9109ae8c870d78$var$M());){
            var d = $0c9109ae8c870d78$var$v.callback;
            if ("function" === typeof d) {
                $0c9109ae8c870d78$var$v.callback = null;
                $0c9109ae8c870d78$var$y = $0c9109ae8c870d78$var$v.priorityLevel;
                var e = d($0c9109ae8c870d78$var$v.expirationTime <= b);
                b = $0c9109ae8c870d78$export$c4744153514ff05d();
                "function" === typeof e ? $0c9109ae8c870d78$var$v.callback = e : $0c9109ae8c870d78$var$v === $0c9109ae8c870d78$var$h($0c9109ae8c870d78$var$r) && $0c9109ae8c870d78$var$k($0c9109ae8c870d78$var$r);
                $0c9109ae8c870d78$var$G(b);
            } else $0c9109ae8c870d78$var$k($0c9109ae8c870d78$var$r);
            $0c9109ae8c870d78$var$v = $0c9109ae8c870d78$var$h($0c9109ae8c870d78$var$r);
        }
        if (null !== $0c9109ae8c870d78$var$v) var w = !0;
        else {
            var m = $0c9109ae8c870d78$var$h($0c9109ae8c870d78$var$t);
            null !== m && $0c9109ae8c870d78$var$K($0c9109ae8c870d78$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $0c9109ae8c870d78$var$v = null, $0c9109ae8c870d78$var$y = c, $0c9109ae8c870d78$var$z = !1;
    }
}
var $0c9109ae8c870d78$var$N = !1, $0c9109ae8c870d78$var$O = null, $0c9109ae8c870d78$var$L = -1, $0c9109ae8c870d78$var$P = 5, $0c9109ae8c870d78$var$Q = -1;
function $0c9109ae8c870d78$var$M() {
    return $0c9109ae8c870d78$export$c4744153514ff05d() - $0c9109ae8c870d78$var$Q < $0c9109ae8c870d78$var$P ? !1 : !0;
}
function $0c9109ae8c870d78$var$R() {
    if (null !== $0c9109ae8c870d78$var$O) {
        var a = $0c9109ae8c870d78$export$c4744153514ff05d();
        $0c9109ae8c870d78$var$Q = a;
        var b = !0;
        try {
            b = $0c9109ae8c870d78$var$O(!0, a);
        } finally{
            b ? $0c9109ae8c870d78$var$S() : ($0c9109ae8c870d78$var$N = !1, $0c9109ae8c870d78$var$O = null);
        }
    } else $0c9109ae8c870d78$var$N = !1;
}
var $0c9109ae8c870d78$var$S;
if ("function" === typeof $0c9109ae8c870d78$var$F) $0c9109ae8c870d78$var$S = function() {
    $0c9109ae8c870d78$var$F($0c9109ae8c870d78$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $0c9109ae8c870d78$var$T = new MessageChannel, $0c9109ae8c870d78$var$U = $0c9109ae8c870d78$var$T.port2;
    $0c9109ae8c870d78$var$T.port1.onmessage = $0c9109ae8c870d78$var$R;
    $0c9109ae8c870d78$var$S = function() {
        $0c9109ae8c870d78$var$U.postMessage(null);
    };
} else $0c9109ae8c870d78$var$S = function() {
    $0c9109ae8c870d78$var$D($0c9109ae8c870d78$var$R, 0);
};
function $0c9109ae8c870d78$var$I(a) {
    $0c9109ae8c870d78$var$O = a;
    $0c9109ae8c870d78$var$N || ($0c9109ae8c870d78$var$N = !0, $0c9109ae8c870d78$var$S());
}
function $0c9109ae8c870d78$var$K(a, b) {
    $0c9109ae8c870d78$var$L = $0c9109ae8c870d78$var$D(function() {
        a($0c9109ae8c870d78$export$c4744153514ff05d());
    }, b);
}
$0c9109ae8c870d78$export$3e506c1ccc9cc1a7 = 5;
$0c9109ae8c870d78$export$e26fe2ed2fa76875 = 1;
$0c9109ae8c870d78$export$502329bbf4b505b1 = 4;
$0c9109ae8c870d78$export$6e3807111c4874c4 = 3;
$0c9109ae8c870d78$export$c27134553091fb3a = null;
$0c9109ae8c870d78$export$33ee1acdc04fd2a2 = 2;
$0c9109ae8c870d78$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$0c9109ae8c870d78$export$8352ce38b91d0c62 = function() {
    $0c9109ae8c870d78$var$A || $0c9109ae8c870d78$var$z || ($0c9109ae8c870d78$var$A = !0, $0c9109ae8c870d78$var$I($0c9109ae8c870d78$var$J));
};
$0c9109ae8c870d78$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $0c9109ae8c870d78$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$0c9109ae8c870d78$export$d3dfb8e4810cb555 = function() {
    return $0c9109ae8c870d78$var$y;
};
$0c9109ae8c870d78$export$839f9183b0465a69 = function() {
    return $0c9109ae8c870d78$var$h($0c9109ae8c870d78$var$r);
};
$0c9109ae8c870d78$export$72fdf0e06517287b = function(a) {
    switch($0c9109ae8c870d78$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $0c9109ae8c870d78$var$y;
    }
    var c = $0c9109ae8c870d78$var$y;
    $0c9109ae8c870d78$var$y = b;
    try {
        return a();
    } finally{
        $0c9109ae8c870d78$var$y = c;
    }
};
$0c9109ae8c870d78$export$4b844e58a3e414b4 = function() {};
$0c9109ae8c870d78$export$816d2913ae6b83b1 = function() {};
$0c9109ae8c870d78$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $0c9109ae8c870d78$var$y;
    $0c9109ae8c870d78$var$y = a;
    try {
        return b();
    } finally{
        $0c9109ae8c870d78$var$y = c;
    }
};
$0c9109ae8c870d78$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $0c9109ae8c870d78$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $0c9109ae8c870d78$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $0c9109ae8c870d78$var$f($0c9109ae8c870d78$var$t, a), null === $0c9109ae8c870d78$var$h($0c9109ae8c870d78$var$r) && a === $0c9109ae8c870d78$var$h($0c9109ae8c870d78$var$t) && ($0c9109ae8c870d78$var$B ? ($0c9109ae8c870d78$var$E($0c9109ae8c870d78$var$L), $0c9109ae8c870d78$var$L = -1) : $0c9109ae8c870d78$var$B = !0, $0c9109ae8c870d78$var$K($0c9109ae8c870d78$var$H, c - d))) : (a.sortIndex = e, $0c9109ae8c870d78$var$f($0c9109ae8c870d78$var$r, a), $0c9109ae8c870d78$var$A || $0c9109ae8c870d78$var$z || ($0c9109ae8c870d78$var$A = !0, $0c9109ae8c870d78$var$I($0c9109ae8c870d78$var$J)));
    return a;
};
$0c9109ae8c870d78$export$b5836b71941fa3ed = $0c9109ae8c870d78$var$M;
$0c9109ae8c870d78$export$cf845f2c119da08a = function(a) {
    var b = $0c9109ae8c870d78$var$y;
    return function() {
        var c = $0c9109ae8c870d78$var$y;
        $0c9109ae8c870d78$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $0c9109ae8c870d78$var$y = c;
        }
    };
};

});



parcelRegister("cEK7I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aVicc = parcelRequire("aVicc");

var $936cffa300883c72$var$React = $aVicc.__importStar((parcelRequire("1T1QG")));

var $9hkJK = parcelRequire("9hkJK");

var $8Mot8 = parcelRequire("8Mot8");
function $936cffa300883c72$var$useIntl() {
    var intl = $936cffa300883c72$var$React.useContext($9hkJK.Context);
    (0, $8Mot8.invariantIntlContext)(intl);
    return intl;
}
module.exports.default = $936cffa300883c72$var$useIntl;

});
parcelRegister("aVicc", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $7f3d5791896d3d7e$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $7f3d5791896d3d7e$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $7f3d5791896d3d7e$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $7f3d5791896d3d7e$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $7f3d5791896d3d7e$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $7f3d5791896d3d7e$export$f33643c0debef087; });
$parcel$export(module.exports, "__spreadArray", function () { return $7f3d5791896d3d7e$export$1216008129fb82ed; });
$parcel$export(module.exports, "__importStar", function () { return $7f3d5791896d3d7e$export$c21735bcef00d192; });
$parcel$export(module.exports, "__importDefault", function () { return $7f3d5791896d3d7e$export$da59b14a69baef04; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $7f3d5791896d3d7e$var$extendStatics = function(d, b) {
    $7f3d5791896d3d7e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $7f3d5791896d3d7e$var$extendStatics(d, b);
};
function $7f3d5791896d3d7e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $7f3d5791896d3d7e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7f3d5791896d3d7e$export$18ce0697a983be9b = function() {
    $7f3d5791896d3d7e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7f3d5791896d3d7e$export$18ce0697a983be9b.apply(this, arguments);
};
function $7f3d5791896d3d7e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $7f3d5791896d3d7e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $7f3d5791896d3d7e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $7f3d5791896d3d7e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $7f3d5791896d3d7e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $7f3d5791896d3d7e$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $7f3d5791896d3d7e$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $7f3d5791896d3d7e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $7f3d5791896d3d7e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $7f3d5791896d3d7e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $7f3d5791896d3d7e$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $7f3d5791896d3d7e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $7f3d5791896d3d7e$export$45d3717a4c69092e(o, m, p);
}
function $7f3d5791896d3d7e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $7f3d5791896d3d7e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $7f3d5791896d3d7e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($7f3d5791896d3d7e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $7f3d5791896d3d7e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $7f3d5791896d3d7e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $7f3d5791896d3d7e$export$10c90e4f7922046c(v) {
    return this instanceof $7f3d5791896d3d7e$export$10c90e4f7922046c ? (this.v = v, this) : new $7f3d5791896d3d7e$export$10c90e4f7922046c(v);
}
function $7f3d5791896d3d7e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7f3d5791896d3d7e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $7f3d5791896d3d7e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $7f3d5791896d3d7e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $7f3d5791896d3d7e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $7f3d5791896d3d7e$export$19a8beecd37a4c45 === "function" ? $7f3d5791896d3d7e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $7f3d5791896d3d7e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $7f3d5791896d3d7e$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $7f3d5791896d3d7e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7f3d5791896d3d7e$export$45d3717a4c69092e(result, mod, k);
    }
    $7f3d5791896d3d7e$var$__setModuleDefault(result, mod);
    return result;
}
function $7f3d5791896d3d7e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $7f3d5791896d3d7e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $7f3d5791896d3d7e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $7f3d5791896d3d7e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $7f3d5791896d3d7e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $7f3d5791896d3d7e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $7f3d5791896d3d7e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $7f3d5791896d3d7e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $7f3d5791896d3d7e$export$2e2bcd8739ae039 = {
    __extends: $7f3d5791896d3d7e$export$a8ba968b8961cb8a,
    __assign: $7f3d5791896d3d7e$export$18ce0697a983be9b,
    __rest: $7f3d5791896d3d7e$export$3c9a16f847548506,
    __decorate: $7f3d5791896d3d7e$export$29e00dfd3077644b,
    __param: $7f3d5791896d3d7e$export$d5ad3fd78186038f,
    __metadata: $7f3d5791896d3d7e$export$f1db080c865becb9,
    __awaiter: $7f3d5791896d3d7e$export$1050f835b63b671e,
    __generator: $7f3d5791896d3d7e$export$67ebef60e6f28a6,
    __createBinding: $7f3d5791896d3d7e$export$45d3717a4c69092e,
    __exportStar: $7f3d5791896d3d7e$export$f33643c0debef087,
    __values: $7f3d5791896d3d7e$export$19a8beecd37a4c45,
    __read: $7f3d5791896d3d7e$export$8d051b38c9118094,
    __spread: $7f3d5791896d3d7e$export$afc72e2116322959,
    __spreadArrays: $7f3d5791896d3d7e$export$6388937ca91ccae8,
    __spreadArray: $7f3d5791896d3d7e$export$1216008129fb82ed,
    __await: $7f3d5791896d3d7e$export$10c90e4f7922046c,
    __asyncGenerator: $7f3d5791896d3d7e$export$e427f37a30a4de9b,
    __asyncDelegator: $7f3d5791896d3d7e$export$bbd80228419bb833,
    __asyncValues: $7f3d5791896d3d7e$export$e3b29a3d6162315f,
    __makeTemplateObject: $7f3d5791896d3d7e$export$4fb47efe1390b86f,
    __importStar: $7f3d5791896d3d7e$export$c21735bcef00d192,
    __importDefault: $7f3d5791896d3d7e$export$da59b14a69baef04,
    __classPrivateFieldGet: $7f3d5791896d3d7e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $7f3d5791896d3d7e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $7f3d5791896d3d7e$export$81fdc39f203e4e04,
    __addDisposableResource: $7f3d5791896d3d7e$export$88ac25d8e944e405,
    __disposeResources: $7f3d5791896d3d7e$export$8f076105dc360e92
};

});

parcelRegister("9hkJK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Context = module.exports.Provider = void 0;

var $aVicc = parcelRequire("aVicc");

var $6c15c9839b78f34b$var$React = $aVicc.__importStar((parcelRequire("1T1QG")));

var $6c15c9839b78f34b$var$hoist_non_react_statics_1 = $aVicc.__importDefault((parcelRequire("3HlGj")));

var $8Mot8 = parcelRequire("8Mot8");
function $6c15c9839b78f34b$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $6c15c9839b78f34b$var$IntlContext = typeof window !== "undefined" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $6c15c9839b78f34b$var$React.createContext(null)) : $6c15c9839b78f34b$var$React.createContext(null);
var $6c15c9839b78f34b$var$IntlConsumer = $6c15c9839b78f34b$var$IntlContext.Consumer, $6c15c9839b78f34b$var$IntlProvider = $6c15c9839b78f34b$var$IntlContext.Provider;
module.exports.Provider = $6c15c9839b78f34b$var$IntlProvider;
module.exports.Context = $6c15c9839b78f34b$var$IntlContext;
function $6c15c9839b78f34b$var$injectIntl(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $6c15c9839b78f34b$var$React.createElement($6c15c9839b78f34b$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $8Mot8.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $6c15c9839b78f34b$var$React.createElement(WrappedComponent, $aVicc.__assign({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($6c15c9839b78f34b$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, $6c15c9839b78f34b$var$hoist_non_react_statics_1.default)($6c15c9839b78f34b$var$React.forwardRef(function(props, ref) {
        return $6c15c9839b78f34b$var$React.createElement(WithIntl, $aVicc.__assign({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, $6c15c9839b78f34b$var$hoist_non_react_statics_1.default)(WithIntl, WrappedComponent);
}
module.exports.default = $6c15c9839b78f34b$var$injectIntl;

});
parcelRegister("8Mot8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shallowEqual = module.exports.assignUniqueKeysToParts = module.exports.DEFAULT_INTL_CONFIG = module.exports.invariantIntlContext = void 0;

var $aVicc = parcelRequire("aVicc");

var $6645c96ba5d1dcc6$var$React = $aVicc.__importStar((parcelRequire("1T1QG")));

var $ir3Bv = parcelRequire("ir3Bv");

var $stxzp = parcelRequire("stxzp");
function $6645c96ba5d1dcc6$var$invariantIntlContext(intl) {
    (0, $ir3Bv.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
module.exports.invariantIntlContext = $6645c96ba5d1dcc6$var$invariantIntlContext;
module.exports.DEFAULT_INTL_CONFIG = $aVicc.__assign($aVicc.__assign({}, $stxzp.DEFAULT_INTL_CONFIG), {
    textComponent: $6645c96ba5d1dcc6$var$React.Fragment
});
/**
 * Takes a `formatXMLElementFn`, and composes it in function, which passes
 * argument `parts` through, assigning unique key to each part, to prevent
 * "Each child in a list should have a unique "key"" React error.
 * @param formatXMLElementFn
 */ function $6645c96ba5d1dcc6$var$assignUniqueKeysToParts(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($6645c96ba5d1dcc6$var$React.Children.toArray(parts));
    };
}
module.exports.assignUniqueKeysToParts = $6645c96ba5d1dcc6$var$assignUniqueKeysToParts;
function $6645c96ba5d1dcc6$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
module.exports.shallowEqual = $6645c96ba5d1dcc6$var$shallowEqual;

});
parcelRegister("ir3Bv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.invariant = module.exports.isMissingLocaleDataError = module.exports.defineProperty = module.exports.getMagnitude = module.exports.setMultiInternalSlots = module.exports.setInternalSlot = module.exports.isLiteralPart = module.exports.getMultiInternalSlots = module.exports.getInternalSlot = module.exports._formatToParts = void 0;

var $aVicc = parcelRequire("aVicc");

$aVicc.__exportStar((parcelRequire("gnSWw")), module.exports);

$aVicc.__exportStar((parcelRequire("iNyCI")), module.exports);

$aVicc.__exportStar((parcelRequire("5pFcL")), module.exports);

$aVicc.__exportStar((parcelRequire("d1Z6R")), module.exports);

$aVicc.__exportStar((parcelRequire("6AsWx")), module.exports);

$aVicc.__exportStar((parcelRequire("bN3dI")), module.exports);

$aVicc.__exportStar((parcelRequire("fYlKC")), module.exports);

$aVicc.__exportStar((parcelRequire("6YKhn")), module.exports);

$aVicc.__exportStar((parcelRequire("621q3")), module.exports);

$aVicc.__exportStar((parcelRequire("hQjmw")), module.exports);

$aVicc.__exportStar((parcelRequire("kiREC")), module.exports);

$aVicc.__exportStar((parcelRequire("5yvcd")), module.exports);

$aVicc.__exportStar((parcelRequire("1CwNb")), module.exports);

$aVicc.__exportStar((parcelRequire("8h1U4")), module.exports);

$aVicc.__exportStar((parcelRequire("5d3WN")), module.exports);

$aVicc.__exportStar((parcelRequire("3eW7k")), module.exports);

$aVicc.__exportStar((parcelRequire("3RAb5")), module.exports);

$aVicc.__exportStar((parcelRequire("3oUoa")), module.exports);

$aVicc.__exportStar((parcelRequire("cCbdw")), module.exports);

$aVicc.__exportStar((parcelRequire("bYbp2")), module.exports);

$aVicc.__exportStar((parcelRequire("6jY8S")), module.exports);

$aVicc.__exportStar((parcelRequire("j8xDe")), module.exports);

$aVicc.__exportStar((parcelRequire("44hiI")), module.exports);

$aVicc.__exportStar((parcelRequire("cLzG7")), module.exports);

$aVicc.__exportStar((parcelRequire("aRbYq")), module.exports);

$aVicc.__exportStar((parcelRequire("4QfFh")), module.exports);

$aVicc.__exportStar((parcelRequire("gyNxt")), module.exports);

$aVicc.__exportStar((parcelRequire("hh2aP")), module.exports);

$aVicc.__exportStar((parcelRequire("k17MG")), module.exports);

var $gDwll = parcelRequire("gDwll");
Object.defineProperty(module.exports, "_formatToParts", {
    enumerable: true,
    get: function() {
        return $aVicc.__importDefault($gDwll).default;
    }
});

$aVicc.__exportStar((parcelRequire("eBuJh")), module.exports);

$aVicc.__exportStar((parcelRequire("gcfxj")), module.exports);

var $04TLr = parcelRequire("04TLr");
Object.defineProperty(module.exports, "getInternalSlot", {
    enumerable: true,
    get: function() {
        return $04TLr.getInternalSlot;
    }
});
Object.defineProperty(module.exports, "getMultiInternalSlots", {
    enumerable: true,
    get: function() {
        return $04TLr.getMultiInternalSlots;
    }
});
Object.defineProperty(module.exports, "isLiteralPart", {
    enumerable: true,
    get: function() {
        return $04TLr.isLiteralPart;
    }
});
Object.defineProperty(module.exports, "setInternalSlot", {
    enumerable: true,
    get: function() {
        return $04TLr.setInternalSlot;
    }
});
Object.defineProperty(module.exports, "setMultiInternalSlots", {
    enumerable: true,
    get: function() {
        return $04TLr.setMultiInternalSlots;
    }
});
Object.defineProperty(module.exports, "getMagnitude", {
    enumerable: true,
    get: function() {
        return $04TLr.getMagnitude;
    }
});
Object.defineProperty(module.exports, "defineProperty", {
    enumerable: true,
    get: function() {
        return $04TLr.defineProperty;
    }
});

var $cErMV = parcelRequire("cErMV");
Object.defineProperty(module.exports, "isMissingLocaleDataError", {
    enumerable: true,
    get: function() {
        return $cErMV.isMissingLocaleDataError;
    }
});

$aVicc.__exportStar((parcelRequire("1gXBJ")), module.exports);

$aVicc.__exportStar((parcelRequire("3ceq9")), module.exports);

$aVicc.__exportStar((parcelRequire("9CY2y")), module.exports);

$aVicc.__exportStar((parcelRequire("dWkzC")), module.exports);

$aVicc.__exportStar((parcelRequire("cxmoU")), module.exports);

$aVicc.__exportStar((parcelRequire("2WuaN")), module.exports);

var $04TLr = parcelRequire("04TLr");
Object.defineProperty(module.exports, "invariant", {
    enumerable: true,
    get: function() {
        return $04TLr.invariant;
    }
});

$aVicc.__exportStar((parcelRequire("cwnVA")), module.exports);

});
parcelRegister("gnSWw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CanonicalizeLocaleList = void 0;
/**
 * http://ecma-international.org/ecma-402/7.0/index.html#sec-canonicalizelocalelist
 * @param locales
 */ function $bed969d1cf9ee9e8$var$CanonicalizeLocaleList(locales) {
    // TODO
    return Intl.getCanonicalLocales(locales);
}
module.exports.CanonicalizeLocaleList = $bed969d1cf9ee9e8$var$CanonicalizeLocaleList;

});

parcelRegister("iNyCI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CanonicalizeTimeZoneName = void 0;
/**
 * https://tc39.es/ecma402/#sec-canonicalizetimezonename
 * @param tz
 */ function $daf7a91953022419$var$CanonicalizeTimeZoneName(tz, _a) {
    var tzData = _a.tzData, uppercaseLinks = _a.uppercaseLinks;
    var uppercasedTz = tz.toUpperCase();
    var uppercasedZones = Object.keys(tzData).reduce(function(all, z) {
        all[z.toUpperCase()] = z;
        return all;
    }, {});
    var ianaTimeZone = uppercaseLinks[uppercasedTz] || uppercasedZones[uppercasedTz];
    if (ianaTimeZone === "Etc/UTC" || ianaTimeZone === "Etc/GMT") return "UTC";
    return ianaTimeZone;
}
module.exports.CanonicalizeTimeZoneName = $daf7a91953022419$var$CanonicalizeTimeZoneName;

});

parcelRegister("5pFcL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoerceOptionsToObject = void 0;

var $cwnVA = parcelRequire("cwnVA");
/**
 * https://tc39.es/ecma402/#sec-coerceoptionstoobject
 * @param options
 * @returns
 */ function $3f0f3ff5319aefe1$var$CoerceOptionsToObject(options) {
    if (typeof options === "undefined") return Object.create(null);
    return (0, $cwnVA.ToObject)(options);
}
module.exports.CoerceOptionsToObject = $3f0f3ff5319aefe1$var$CoerceOptionsToObject;

});
parcelRegister("cwnVA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.msFromTime = module.exports.OrdinaryHasInstance = module.exports.SecFromTime = module.exports.MinFromTime = module.exports.HourFromTime = module.exports.DateFromTime = module.exports.MonthFromTime = module.exports.InLeapYear = module.exports.DayWithinYear = module.exports.DaysInYear = module.exports.YearFromTime = module.exports.TimeFromYear = module.exports.DayFromYear = module.exports.WeekDay = module.exports.Day = module.exports.Type = module.exports.HasOwnProperty = module.exports.ArrayCreate = module.exports.SameValue = module.exports.ToObject = module.exports.TimeClip = module.exports.ToNumber = module.exports.ToString = void 0;
/**
 * https://tc39.es/ecma262/#sec-tostring
 */ function $91db08bd2b570637$var$ToString(o) {
    // Only symbol is irregular...
    if (typeof o === "symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return String(o);
}
module.exports.ToString = $91db08bd2b570637$var$ToString;
/**
 * https://tc39.es/ecma262/#sec-tonumber
 * @param val
 */ function $91db08bd2b570637$var$ToNumber(val) {
    if (val === undefined) return NaN;
    if (val === null) return 0;
    if (typeof val === "boolean") return val ? 1 : 0;
    if (typeof val === "number") return val;
    if (typeof val === "symbol" || typeof val === "bigint") throw new TypeError("Cannot convert symbol/bigint to number");
    return Number(val);
}
module.exports.ToNumber = $91db08bd2b570637$var$ToNumber;
/**
 * https://tc39.es/ecma262/#sec-tointeger
 * @param n
 */ function $91db08bd2b570637$var$ToInteger(n) {
    var number = $91db08bd2b570637$var$ToNumber(n);
    if (isNaN(number) || $91db08bd2b570637$var$SameValue(number, -0)) return 0;
    if (isFinite(number)) return number;
    var integer = Math.floor(Math.abs(number));
    if (number < 0) integer = -integer;
    if ($91db08bd2b570637$var$SameValue(integer, -0)) return 0;
    return integer;
}
/**
 * https://tc39.es/ecma262/#sec-timeclip
 * @param time
 */ function $91db08bd2b570637$var$TimeClip(time) {
    if (!isFinite(time)) return NaN;
    if (Math.abs(time) > 8.64 * 1e15) return NaN;
    return $91db08bd2b570637$var$ToInteger(time);
}
module.exports.TimeClip = $91db08bd2b570637$var$TimeClip;
/**
 * https://tc39.es/ecma262/#sec-toobject
 * @param arg
 */ function $91db08bd2b570637$var$ToObject(arg) {
    if (arg == null) throw new TypeError("undefined/null cannot be converted to object");
    return Object(arg);
}
module.exports.ToObject = $91db08bd2b570637$var$ToObject;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-samevalue
 * @param x
 * @param y
 */ function $91db08bd2b570637$var$SameValue(x, y) {
    if (Object.is) return Object.is(x, y);
    // SameValue algorithm
    if (x === y) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return x !== 0 || 1 / x === 1 / y;
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
}
module.exports.SameValue = $91db08bd2b570637$var$SameValue;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-arraycreate
 * @param len
 */ function $91db08bd2b570637$var$ArrayCreate(len) {
    return new Array(len);
}
module.exports.ArrayCreate = $91db08bd2b570637$var$ArrayCreate;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-hasownproperty
 * @param o
 * @param prop
 */ function $91db08bd2b570637$var$HasOwnProperty(o, prop) {
    return Object.prototype.hasOwnProperty.call(o, prop);
}
module.exports.HasOwnProperty = $91db08bd2b570637$var$HasOwnProperty;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#sec-type
 * @param x
 */ function $91db08bd2b570637$var$Type(x) {
    if (x === null) return "Null";
    if (typeof x === "undefined") return "Undefined";
    if (typeof x === "function" || typeof x === "object") return "Object";
    if (typeof x === "number") return "Number";
    if (typeof x === "boolean") return "Boolean";
    if (typeof x === "string") return "String";
    if (typeof x === "symbol") return "Symbol";
    if (typeof x === "bigint") return "BigInt";
}
module.exports.Type = $91db08bd2b570637$var$Type;
var $91db08bd2b570637$var$MS_PER_DAY = 86400000;
/**
 * https://www.ecma-international.org/ecma-262/11.0/index.html#eqn-modulo
 * @param x
 * @param y
 * @return k of the same sign as y
 */ function $91db08bd2b570637$var$mod(x, y) {
    return x - Math.floor(x / y) * y;
}
/**
 * https://tc39.es/ecma262/#eqn-Day
 * @param t
 */ function $91db08bd2b570637$var$Day(t) {
    return Math.floor(t / $91db08bd2b570637$var$MS_PER_DAY);
}
module.exports.Day = $91db08bd2b570637$var$Day;
/**
 * https://tc39.es/ecma262/#sec-week-day
 * @param t
 */ function $91db08bd2b570637$var$WeekDay(t) {
    return $91db08bd2b570637$var$mod($91db08bd2b570637$var$Day(t) + 4, 7);
}
module.exports.WeekDay = $91db08bd2b570637$var$WeekDay;
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param y
 */ function $91db08bd2b570637$var$DayFromYear(y) {
    return Date.UTC(y, 0) / $91db08bd2b570637$var$MS_PER_DAY;
}
module.exports.DayFromYear = $91db08bd2b570637$var$DayFromYear;
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param y
 */ function $91db08bd2b570637$var$TimeFromYear(y) {
    return Date.UTC(y, 0);
}
module.exports.TimeFromYear = $91db08bd2b570637$var$TimeFromYear;
/**
 * https://tc39.es/ecma262/#sec-year-number
 * @param t
 */ function $91db08bd2b570637$var$YearFromTime(t) {
    return new Date(t).getUTCFullYear();
}
module.exports.YearFromTime = $91db08bd2b570637$var$YearFromTime;
function $91db08bd2b570637$var$DaysInYear(y) {
    if (y % 4 !== 0) return 365;
    if (y % 100 !== 0) return 366;
    if (y % 400 !== 0) return 365;
    return 366;
}
module.exports.DaysInYear = $91db08bd2b570637$var$DaysInYear;
function $91db08bd2b570637$var$DayWithinYear(t) {
    return $91db08bd2b570637$var$Day(t) - $91db08bd2b570637$var$DayFromYear($91db08bd2b570637$var$YearFromTime(t));
}
module.exports.DayWithinYear = $91db08bd2b570637$var$DayWithinYear;
function $91db08bd2b570637$var$InLeapYear(t) {
    return $91db08bd2b570637$var$DaysInYear($91db08bd2b570637$var$YearFromTime(t)) === 365 ? 0 : 1;
}
module.exports.InLeapYear = $91db08bd2b570637$var$InLeapYear;
/**
 * https://tc39.es/ecma262/#sec-month-number
 * @param t
 */ function $91db08bd2b570637$var$MonthFromTime(t) {
    var dwy = $91db08bd2b570637$var$DayWithinYear(t);
    var leap = $91db08bd2b570637$var$InLeapYear(t);
    if (dwy >= 0 && dwy < 31) return 0;
    if (dwy < 59 + leap) return 1;
    if (dwy < 90 + leap) return 2;
    if (dwy < 120 + leap) return 3;
    if (dwy < 151 + leap) return 4;
    if (dwy < 181 + leap) return 5;
    if (dwy < 212 + leap) return 6;
    if (dwy < 243 + leap) return 7;
    if (dwy < 273 + leap) return 8;
    if (dwy < 304 + leap) return 9;
    if (dwy < 334 + leap) return 10;
    if (dwy < 365 + leap) return 11;
    throw new Error("Invalid time");
}
module.exports.MonthFromTime = $91db08bd2b570637$var$MonthFromTime;
function $91db08bd2b570637$var$DateFromTime(t) {
    var dwy = $91db08bd2b570637$var$DayWithinYear(t);
    var mft = $91db08bd2b570637$var$MonthFromTime(t);
    var leap = $91db08bd2b570637$var$InLeapYear(t);
    if (mft === 0) return dwy + 1;
    if (mft === 1) return dwy - 30;
    if (mft === 2) return dwy - 58 - leap;
    if (mft === 3) return dwy - 89 - leap;
    if (mft === 4) return dwy - 119 - leap;
    if (mft === 5) return dwy - 150 - leap;
    if (mft === 6) return dwy - 180 - leap;
    if (mft === 7) return dwy - 211 - leap;
    if (mft === 8) return dwy - 242 - leap;
    if (mft === 9) return dwy - 272 - leap;
    if (mft === 10) return dwy - 303 - leap;
    if (mft === 11) return dwy - 333 - leap;
    throw new Error("Invalid time");
}
module.exports.DateFromTime = $91db08bd2b570637$var$DateFromTime;
var $91db08bd2b570637$var$HOURS_PER_DAY = 24;
var $91db08bd2b570637$var$MINUTES_PER_HOUR = 60;
var $91db08bd2b570637$var$SECONDS_PER_MINUTE = 60;
var $91db08bd2b570637$var$MS_PER_SECOND = 1e3;
var $91db08bd2b570637$var$MS_PER_MINUTE = $91db08bd2b570637$var$MS_PER_SECOND * $91db08bd2b570637$var$SECONDS_PER_MINUTE;
var $91db08bd2b570637$var$MS_PER_HOUR = $91db08bd2b570637$var$MS_PER_MINUTE * $91db08bd2b570637$var$MINUTES_PER_HOUR;
function $91db08bd2b570637$var$HourFromTime(t) {
    return $91db08bd2b570637$var$mod(Math.floor(t / $91db08bd2b570637$var$MS_PER_HOUR), $91db08bd2b570637$var$HOURS_PER_DAY);
}
module.exports.HourFromTime = $91db08bd2b570637$var$HourFromTime;
function $91db08bd2b570637$var$MinFromTime(t) {
    return $91db08bd2b570637$var$mod(Math.floor(t / $91db08bd2b570637$var$MS_PER_MINUTE), $91db08bd2b570637$var$MINUTES_PER_HOUR);
}
module.exports.MinFromTime = $91db08bd2b570637$var$MinFromTime;
function $91db08bd2b570637$var$SecFromTime(t) {
    return $91db08bd2b570637$var$mod(Math.floor(t / $91db08bd2b570637$var$MS_PER_SECOND), $91db08bd2b570637$var$SECONDS_PER_MINUTE);
}
module.exports.SecFromTime = $91db08bd2b570637$var$SecFromTime;
function $91db08bd2b570637$var$IsCallable(fn) {
    return typeof fn === "function";
}
/**
 * The abstract operation OrdinaryHasInstance implements
 * the default algorithm for determining if an object O
 * inherits from the instance object inheritance path
 * provided by constructor C.
 * @param C class
 * @param O object
 * @param internalSlots internalSlots
 */ function $91db08bd2b570637$var$OrdinaryHasInstance(C, O, internalSlots) {
    if (!$91db08bd2b570637$var$IsCallable(C)) return false;
    if (internalSlots === null || internalSlots === void 0 ? void 0 : internalSlots.boundTargetFunction) {
        var BC = internalSlots === null || internalSlots === void 0 ? void 0 : internalSlots.boundTargetFunction;
        return O instanceof BC;
    }
    if (typeof O !== "object") return false;
    var P = C.prototype;
    if (typeof P !== "object") throw new TypeError("OrdinaryHasInstance called on an object with an invalid prototype property.");
    return Object.prototype.isPrototypeOf.call(P, O);
}
module.exports.OrdinaryHasInstance = $91db08bd2b570637$var$OrdinaryHasInstance;
function $91db08bd2b570637$var$msFromTime(t) {
    return $91db08bd2b570637$var$mod(t, $91db08bd2b570637$var$MS_PER_SECOND);
}
module.exports.msFromTime = $91db08bd2b570637$var$msFromTime;

});


parcelRegister("d1Z6R", function(module, exports) {
"use strict";
/**
 * https://tc39.es/ecma402/#sec-getnumberoption
 * @param options
 * @param property
 * @param min
 * @param max
 * @param fallback
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetNumberOption = void 0;

var $5c7IE = parcelRequire("5c7IE");
function $97cac57a8d905b54$var$GetNumberOption(options, property, minimum, maximum, fallback) {
    var val = options[property];
    // @ts-expect-error
    return (0, $5c7IE.DefaultNumberOption)(val, minimum, maximum, fallback);
}
module.exports.GetNumberOption = $97cac57a8d905b54$var$GetNumberOption;

});
parcelRegister("5c7IE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultNumberOption = void 0;
function $3c840f99ec0a532a$var$DefaultNumberOption(val, min, max, fallback) {
    if (val !== undefined) {
        val = Number(val);
        if (isNaN(val) || val < min || val > max) throw new RangeError("".concat(val, " is outside of range [").concat(min, ", ").concat(max, "]"));
        return Math.floor(val);
    }
    return fallback;
}
module.exports.DefaultNumberOption = $3c840f99ec0a532a$var$DefaultNumberOption;

});


parcelRegister("6AsWx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetOption = void 0;

var $cwnVA = parcelRequire("cwnVA");
/**
 * https://tc39.es/ecma402/#sec-getoption
 * @param opts
 * @param prop
 * @param type
 * @param values
 * @param fallback
 */ function $4cbc8e63899416d6$var$GetOption(opts, prop, type, values, fallback) {
    if (typeof opts !== "object") throw new TypeError("Options must be an object");
    var value = opts[prop];
    if (value !== undefined) {
        if (type !== "boolean" && type !== "string") throw new TypeError("invalid type");
        if (type === "boolean") value = Boolean(value);
        if (type === "string") value = (0, $cwnVA.ToString)(value);
        if (values !== undefined && !values.filter(function(val) {
            return val == value;
        }).length) throw new RangeError("".concat(value, " is not within ").concat(values.join(", ")));
        return value;
    }
    return fallback;
}
module.exports.GetOption = $4cbc8e63899416d6$var$GetOption;

});

parcelRegister("bN3dI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetOptionsObject = void 0;
/**
 * https://tc39.es/ecma402/#sec-getoptionsobject
 * @param options
 * @returns
 */ function $8956c4c25f5fb1ea$var$GetOptionsObject(options) {
    if (typeof options === "undefined") return Object.create(null);
    if (typeof options === "object") return options;
    throw new TypeError("Options must be an object");
}
module.exports.GetOptionsObject = $8956c4c25f5fb1ea$var$GetOptionsObject;

});

parcelRegister("fYlKC", function(module, exports) {
"use strict";
/**
 * https://tc39.es/ecma402/#sec-getstringorbooleanoption
 * @param opts
 * @param prop
 * @param values
 * @param trueValue
 * @param falsyValue
 * @param fallback
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetStringOrBooleanOption = void 0;

var $cwnVA = parcelRequire("cwnVA");
function $ba0d54e7f4f28368$var$GetStringOrBooleanOption(opts, prop, values, trueValue, falsyValue, fallback) {
    var value = opts[prop];
    if (value === undefined) return fallback;
    if (value === true) return trueValue;
    var valueBoolean = Boolean(value);
    if (valueBoolean === false) return falsyValue;
    value = (0, $cwnVA.ToString)(value);
    if (value === "true" || value === "false") return fallback;
    if ((values || []).indexOf(value) === -1) throw new RangeError("Invalid value ".concat(value));
    return value;
}
module.exports.GetStringOrBooleanOption = $ba0d54e7f4f28368$var$GetStringOrBooleanOption;

});

parcelRegister("6YKhn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsSanctionedSimpleUnitIdentifier = module.exports.SIMPLE_UNITS = module.exports.removeUnitNamespace = module.exports.SANCTIONED_UNITS = void 0;
/**
 * https://tc39.es/ecma402/#table-sanctioned-simple-unit-identifiers
 */ module.exports.SANCTIONED_UNITS = [
    "angle-degree",
    "area-acre",
    "area-hectare",
    "concentr-percent",
    "digital-bit",
    "digital-byte",
    "digital-gigabit",
    "digital-gigabyte",
    "digital-kilobit",
    "digital-kilobyte",
    "digital-megabit",
    "digital-megabyte",
    "digital-petabyte",
    "digital-terabit",
    "digital-terabyte",
    "duration-day",
    "duration-hour",
    "duration-millisecond",
    "duration-minute",
    "duration-month",
    "duration-second",
    "duration-week",
    "duration-year",
    "length-centimeter",
    "length-foot",
    "length-inch",
    "length-kilometer",
    "length-meter",
    "length-mile-scandinavian",
    "length-mile",
    "length-millimeter",
    "length-yard",
    "mass-gram",
    "mass-kilogram",
    "mass-ounce",
    "mass-pound",
    "mass-stone",
    "temperature-celsius",
    "temperature-fahrenheit",
    "volume-fluid-ounce",
    "volume-gallon",
    "volume-liter",
    "volume-milliliter"
];
// In CLDR, the unit name always follows the form `namespace-unit` pattern.
// For example: `digital-bit` instead of `bit`. This function removes the namespace prefix.
function $514c3ec9346fd9f4$var$removeUnitNamespace(unit) {
    return unit.slice(unit.indexOf("-") + 1);
}
module.exports.removeUnitNamespace = $514c3ec9346fd9f4$var$removeUnitNamespace;
/**
 * https://tc39.es/ecma402/#table-sanctioned-simple-unit-identifiers
 */ module.exports.SIMPLE_UNITS = module.exports.SANCTIONED_UNITS.map($514c3ec9346fd9f4$var$removeUnitNamespace);
/**
 * https://tc39.es/ecma402/#sec-issanctionedsimpleunitidentifier
 */ function $514c3ec9346fd9f4$var$IsSanctionedSimpleUnitIdentifier(unitIdentifier) {
    return module.exports.SIMPLE_UNITS.indexOf(unitIdentifier) > -1;
}
module.exports.IsSanctionedSimpleUnitIdentifier = $514c3ec9346fd9f4$var$IsSanctionedSimpleUnitIdentifier;

});

parcelRegister("621q3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsValidTimeZoneName = void 0;
/**
 * https://tc39.es/ecma402/#sec-isvalidtimezonename
 * @param tz
 * @param implDetails implementation details
 */ function $464407cea0acc98e$var$IsValidTimeZoneName(tz, _a) {
    var tzData = _a.tzData, uppercaseLinks = _a.uppercaseLinks;
    var uppercasedTz = tz.toUpperCase();
    var zoneNames = new Set();
    var linkNames = new Set();
    Object.keys(tzData).map(function(z) {
        return z.toUpperCase();
    }).forEach(function(z) {
        return zoneNames.add(z);
    });
    Object.keys(uppercaseLinks).forEach(function(linkName) {
        linkNames.add(linkName.toUpperCase());
        zoneNames.add(uppercaseLinks[linkName].toUpperCase());
    });
    return zoneNames.has(uppercasedTz) || linkNames.has(uppercasedTz);
}
module.exports.IsValidTimeZoneName = $464407cea0acc98e$var$IsValidTimeZoneName;

});

parcelRegister("hQjmw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsWellFormedCurrencyCode = void 0;
/**
 * This follows https://tc39.es/ecma402/#sec-case-sensitivity-and-case-mapping
 * @param str string to convert
 */ function $cfd64fefc50d95f2$var$toUpperCase(str) {
    return str.replace(/([a-z])/g, function(_, c) {
        return c.toUpperCase();
    });
}
var $cfd64fefc50d95f2$var$NOT_A_Z_REGEX = /[^A-Z]/;
/**
 * https://tc39.es/ecma402/#sec-iswellformedcurrencycode
 */ function $cfd64fefc50d95f2$var$IsWellFormedCurrencyCode(currency) {
    currency = $cfd64fefc50d95f2$var$toUpperCase(currency);
    if (currency.length !== 3) return false;
    if ($cfd64fefc50d95f2$var$NOT_A_Z_REGEX.test(currency)) return false;
    return true;
}
module.exports.IsWellFormedCurrencyCode = $cfd64fefc50d95f2$var$IsWellFormedCurrencyCode;

});

parcelRegister("kiREC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsWellFormedUnitIdentifier = void 0;

var $6YKhn = parcelRequire("6YKhn");
/**
 * This follows https://tc39.es/ecma402/#sec-case-sensitivity-and-case-mapping
 * @param str string to convert
 */ function $ec7f1bb27d180e03$var$toLowerCase(str) {
    return str.replace(/([A-Z])/g, function(_, c) {
        return c.toLowerCase();
    });
}
/**
 * https://tc39.es/ecma402/#sec-iswellformedunitidentifier
 * @param unit
 */ function $ec7f1bb27d180e03$var$IsWellFormedUnitIdentifier(unit) {
    unit = $ec7f1bb27d180e03$var$toLowerCase(unit);
    if ((0, $6YKhn.IsSanctionedSimpleUnitIdentifier)(unit)) return true;
    var units = unit.split("-per-");
    if (units.length !== 2) return false;
    var numerator = units[0], denominator = units[1];
    if (!(0, $6YKhn.IsSanctionedSimpleUnitIdentifier)(numerator) || !(0, $6YKhn.IsSanctionedSimpleUnitIdentifier)(denominator)) return false;
    return true;
}
module.exports.IsWellFormedUnitIdentifier = $ec7f1bb27d180e03$var$IsWellFormedUnitIdentifier;

});

parcelRegister("5yvcd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ApplyUnsignedRoundingMode = void 0;
function $40b853963eebe364$var$ApplyUnsignedRoundingMode(x, r1, r2, unsignedRoundingMode) {
    if (x === r1) return r1;
    if (unsignedRoundingMode === undefined) throw new Error("unsignedRoundingMode is mandatory");
    if (unsignedRoundingMode === "zero") return r1;
    if (unsignedRoundingMode === "infinity") return r2;
    var d1 = x - r1;
    var d2 = r2 - x;
    if (d1 < d2) return r1;
    if (d2 < d1) return r2;
    if (d1 !== d2) throw new Error("Unexpected error");
    if (unsignedRoundingMode === "half-zero") return r1;
    if (unsignedRoundingMode === "half-infinity") return r2;
    if (unsignedRoundingMode !== "half-even") throw new Error("Unexpected value for unsignedRoundingMode: ".concat(unsignedRoundingMode));
    var cardinality = r1 / (r2 - r1) % 2;
    if (cardinality === 0) return r1;
    return r2;
}
module.exports.ApplyUnsignedRoundingMode = $40b853963eebe364$var$ApplyUnsignedRoundingMode;

});

parcelRegister("1CwNb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CollapseNumberRange = void 0;
/**
 * https://tc39.es/ecma402/#sec-collapsenumberrange
 */ function $12e2c6eeb44754f5$var$CollapseNumberRange(result) {
    return result;
}
module.exports.CollapseNumberRange = $12e2c6eeb44754f5$var$CollapseNumberRange;

});

parcelRegister("8h1U4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ComputeExponent = void 0;

var $04TLr = parcelRequire("04TLr");

var $5d3WN = parcelRequire("5d3WN");

var $6jY8S = parcelRequire("6jY8S");
/**
 * The abstract operation ComputeExponent computes an exponent (power of ten) by which to scale x
 * according to the number formatting settings. It handles cases such as 999 rounding up to 1000,
 * requiring a different exponent.
 *
 * NOT IN SPEC: it returns [exponent, magnitude].
 */ function $6061633ead87e13f$var$ComputeExponent(numberFormat, x, _a) {
    var getInternalSlots = _a.getInternalSlots;
    if (x === 0) return [
        0,
        0
    ];
    if (x < 0) x = -x;
    var magnitude = (0, $04TLr.getMagnitude)(x);
    var exponent = (0, $5d3WN.ComputeExponentForMagnitude)(numberFormat, magnitude, {
        getInternalSlots: getInternalSlots
    });
    // Preserve more precision by doing multiplication when exponent is negative.
    x = exponent < 0 ? x * Math.pow(10, -exponent) : x / Math.pow(10, exponent);
    var formatNumberResult = (0, $6jY8S.FormatNumericToString)(getInternalSlots(numberFormat), x);
    if (formatNumberResult.roundedNumber === 0) return [
        exponent,
        magnitude
    ];
    var newMagnitude = (0, $04TLr.getMagnitude)(formatNumberResult.roundedNumber);
    if (newMagnitude === magnitude - exponent) return [
        exponent,
        magnitude
    ];
    return [
        (0, $5d3WN.ComputeExponentForMagnitude)(numberFormat, magnitude + 1, {
            getInternalSlots: getInternalSlots
        }),
        magnitude + 1
    ];
}
module.exports.ComputeExponent = $6061633ead87e13f$var$ComputeExponent;

});
parcelRegister("04TLr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.invariant = module.exports.UNICODE_EXTENSION_SEQUENCE_REGEX = module.exports.defineProperty = module.exports.isLiteralPart = module.exports.getMultiInternalSlots = module.exports.getInternalSlot = module.exports.setMultiInternalSlots = module.exports.setInternalSlot = module.exports.repeat = module.exports.getMagnitude = void 0;
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $00eba1704f58a0c5$var$getMagnitude(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
module.exports.getMagnitude = $00eba1704f58a0c5$var$getMagnitude;
function $00eba1704f58a0c5$var$repeat(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
module.exports.repeat = $00eba1704f58a0c5$var$repeat;
function $00eba1704f58a0c5$var$setInternalSlot(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
module.exports.setInternalSlot = $00eba1704f58a0c5$var$setInternalSlot;
function $00eba1704f58a0c5$var$setMultiInternalSlots(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $00eba1704f58a0c5$var$setInternalSlot(map, pl, k, props[k]);
    }
}
module.exports.setMultiInternalSlots = $00eba1704f58a0c5$var$setMultiInternalSlots;
function $00eba1704f58a0c5$var$getInternalSlot(map, pl, field) {
    return $00eba1704f58a0c5$var$getMultiInternalSlots(map, pl, field)[field];
}
module.exports.getInternalSlot = $00eba1704f58a0c5$var$getInternalSlot;
function $00eba1704f58a0c5$var$getMultiInternalSlots(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
module.exports.getMultiInternalSlots = $00eba1704f58a0c5$var$getMultiInternalSlots;
function $00eba1704f58a0c5$var$isLiteralPart(patternPart) {
    return patternPart.type === "literal";
}
module.exports.isLiteralPart = $00eba1704f58a0c5$var$isLiteralPart;
/*
  17 ECMAScript Standard Built-in Objects:
    Every built-in Function object, including constructors, that is not
    identified as an anonymous function has a name property whose value
    is a String.

    Unless otherwise specified, the name property of a built-in Function
    object, if it exists, has the attributes { [[Writable]]: false,
    [[Enumerable]]: false, [[Configurable]]: true }.
*/ function $00eba1704f58a0c5$var$defineProperty(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
module.exports.defineProperty = $00eba1704f58a0c5$var$defineProperty;
module.exports.UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function $00eba1704f58a0c5$var$invariant(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
module.exports.invariant = $00eba1704f58a0c5$var$invariant;

});

parcelRegister("5d3WN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ComputeExponentForMagnitude = void 0;
/**
 * The abstract operation ComputeExponentForMagnitude computes an exponent by which to scale a
 * number of the given magnitude (power of ten of the most significant digit) according to the
 * locale and the desired notation (scientific, engineering, or compact).
 */ function $3cb13a84eed78992$var$ComputeExponentForMagnitude(numberFormat, magnitude, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(numberFormat);
    var notation = internalSlots.notation, dataLocaleData = internalSlots.dataLocaleData, numberingSystem = internalSlots.numberingSystem;
    switch(notation){
        case "standard":
            return 0;
        case "scientific":
            return magnitude;
        case "engineering":
            return Math.floor(magnitude / 3) * 3;
        default:
            // Let exponent be an implementation- and locale-dependent (ILD) integer by which to scale a
            // number of the given magnitude in compact notation for the current locale.
            var compactDisplay = internalSlots.compactDisplay, style = internalSlots.style, currencyDisplay = internalSlots.currencyDisplay;
            var thresholdMap = void 0;
            if (style === "currency" && currencyDisplay !== "name") {
                var currency = dataLocaleData.numbers.currency[numberingSystem] || dataLocaleData.numbers.currency[dataLocaleData.numbers.nu[0]];
                thresholdMap = currency.short;
            } else {
                var decimal = dataLocaleData.numbers.decimal[numberingSystem] || dataLocaleData.numbers.decimal[dataLocaleData.numbers.nu[0]];
                thresholdMap = compactDisplay === "long" ? decimal.long : decimal.short;
            }
            if (!thresholdMap) return 0;
            var num = String(Math.pow(10, magnitude));
            var thresholds = Object.keys(thresholdMap); // TODO: this can be pre-processed
            if (num < thresholds[0]) return 0;
            if (num > thresholds[thresholds.length - 1]) return thresholds[thresholds.length - 1].length - 1;
            var i = thresholds.indexOf(num);
            if (i === -1) return 0;
            // See https://unicode.org/reports/tr35/tr35-numbers.html#Compact_Number_Formats
            // Special handling if the pattern is precisely `0`.
            var magnitudeKey = thresholds[i];
            // TODO: do we need to handle plural here?
            var compactPattern = thresholdMap[magnitudeKey].other;
            if (compactPattern === "0") return 0;
            // Example: in zh-TW, `10000000` maps to `0000萬`. So we need to return 8 - 4 = 4 here.
            return magnitudeKey.length - thresholdMap[magnitudeKey].other.match(/0+/)[0].length;
    }
}
module.exports.ComputeExponentForMagnitude = $3cb13a84eed78992$var$ComputeExponentForMagnitude;

});

parcelRegister("6jY8S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatNumericToString = void 0;

var $cwnVA = parcelRequire("cwnVA");

var $k17MG = parcelRequire("k17MG");

var $04TLr = parcelRequire("04TLr");

var $hh2aP = parcelRequire("hh2aP");
/**
 * https://tc39.es/ecma402/#sec-formatnumberstring
 */ function $49a32b645a6af800$var$FormatNumericToString(intlObject, x) {
    var isNegative = x < 0 || (0, $cwnVA.SameValue)(x, -0);
    if (isNegative) x = -x;
    var result;
    var rourndingType = intlObject.roundingType;
    switch(rourndingType){
        case "significantDigits":
            result = (0, $k17MG.ToRawPrecision)(x, intlObject.minimumSignificantDigits, intlObject.maximumSignificantDigits);
            break;
        case "fractionDigits":
            result = (0, $hh2aP.ToRawFixed)(x, intlObject.minimumFractionDigits, intlObject.maximumFractionDigits);
            break;
        default:
            result = (0, $k17MG.ToRawPrecision)(x, 1, 2);
            if (result.integerDigitsCount > 1) result = (0, $hh2aP.ToRawFixed)(x, 0, 0);
            break;
    }
    x = result.roundedNumber;
    var string = result.formattedString;
    var int = result.integerDigitsCount;
    var minInteger = intlObject.minimumIntegerDigits;
    if (int < minInteger) {
        var forwardZeros = (0, $04TLr.repeat)("0", minInteger - int);
        string = forwardZeros + string;
    }
    if (isNegative) x = -x;
    return {
        roundedNumber: x,
        formattedString: string
    };
}
module.exports.FormatNumericToString = $49a32b645a6af800$var$FormatNumericToString;

});
parcelRegister("k17MG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ToRawPrecision = void 0;

var $04TLr = parcelRequire("04TLr");
function $e929f06dfb66b8a8$var$ToRawPrecision(x, minPrecision, maxPrecision) {
    var p = maxPrecision;
    var m;
    var e;
    var xFinal;
    if (x === 0) {
        m = (0, $04TLr.repeat)("0", p);
        e = 0;
        xFinal = 0;
    } else {
        var xToString = x.toString();
        // If xToString is formatted as scientific notation, the number is either very small or very
        // large. If the precision of the formatted string is lower that requested max precision, we
        // should still infer them from the formatted string, otherwise the formatted result might have
        // precision loss (e.g. 1e41 will not have 0 in every trailing digits).
        var xToStringExponentIndex = xToString.indexOf("e");
        var _a = xToString.split("e"), xToStringMantissa = _a[0], xToStringExponent = _a[1];
        var xToStringMantissaWithoutDecimalPoint = xToStringMantissa.replace(".", "");
        if (xToStringExponentIndex >= 0 && xToStringMantissaWithoutDecimalPoint.length <= p) {
            e = +xToStringExponent;
            m = xToStringMantissaWithoutDecimalPoint + (0, $04TLr.repeat)("0", p - xToStringMantissaWithoutDecimalPoint.length);
            xFinal = x;
        } else {
            e = (0, $04TLr.getMagnitude)(x);
            var decimalPlaceOffset = e - p + 1;
            // n is the integer containing the required precision digits. To derive the formatted string,
            // we will adjust its decimal place in the logic below.
            var n = Math.round(adjustDecimalPlace(x, decimalPlaceOffset));
            // The rounding caused the change of magnitude, so we should increment `e` by 1.
            if (adjustDecimalPlace(n, p - 1) >= 10) {
                e = e + 1;
                // Divide n by 10 to swallow one precision.
                n = Math.floor(n / 10);
            }
            m = n.toString();
            // Equivalent of n * 10 ** (e - p + 1)
            xFinal = adjustDecimalPlace(n, p - 1 - e);
        }
    }
    var int;
    if (e >= p - 1) {
        m = m + (0, $04TLr.repeat)("0", e - p + 1);
        int = e + 1;
    } else if (e >= 0) {
        m = "".concat(m.slice(0, e + 1), ".").concat(m.slice(e + 1));
        int = e + 1;
    } else {
        m = "0.".concat((0, $04TLr.repeat)("0", -e - 1)).concat(m);
        int = 1;
    }
    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
        var cut = maxPrecision - minPrecision;
        while(cut > 0 && m[m.length - 1] === "0"){
            m = m.slice(0, -1);
            cut--;
        }
        if (m[m.length - 1] === ".") m = m.slice(0, -1);
    }
    return {
        formattedString: m,
        roundedNumber: xFinal,
        integerDigitsCount: int
    };
    // x / (10 ** magnitude), but try to preserve as much floating point precision as possible.
    function adjustDecimalPlace(x, magnitude) {
        return magnitude < 0 ? x * Math.pow(10, -magnitude) : x / Math.pow(10, magnitude);
    }
}
module.exports.ToRawPrecision = $e929f06dfb66b8a8$var$ToRawPrecision;

});

parcelRegister("hh2aP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ToRawFixed = void 0;

var $04TLr = parcelRequire("04TLr");
/**
 * TODO: dedup with intl-pluralrules and support BigInt
 * https://tc39.es/ecma402/#sec-torawfixed
 * @param x a finite non-negative Number or BigInt
 * @param minFraction and integer between 0 and 20
 * @param maxFraction and integer between 0 and 20
 */ function $c935b5dbf1754d5e$var$ToRawFixed(x, minFraction, maxFraction) {
    var f = maxFraction;
    var n = Math.round(x * Math.pow(10, f));
    var xFinal = n / Math.pow(10, f);
    // n is a positive integer, but it is possible to be greater than 1e21.
    // In such case we will go the slow path.
    // See also: https://tc39.es/ecma262/#sec-numeric-types-number-tostring
    var m;
    if (n < 1e21) m = n.toString();
    else {
        m = n.toString();
        var _a = m.split("e"), mantissa = _a[0], exponent = _a[1];
        m = mantissa.replace(".", "");
        m = m + (0, $04TLr.repeat)("0", Math.max(+exponent - m.length + 1, 0));
    }
    var int;
    if (f !== 0) {
        var k = m.length;
        if (k <= f) {
            var z = (0, $04TLr.repeat)("0", f + 1 - k);
            m = z + m;
            k = f + 1;
        }
        var a = m.slice(0, k - f);
        var b = m.slice(k - f);
        m = "".concat(a, ".").concat(b);
        int = a.length;
    } else int = m.length;
    var cut = maxFraction - minFraction;
    while(cut > 0 && m[m.length - 1] === "0"){
        m = m.slice(0, -1);
        cut--;
    }
    if (m[m.length - 1] === ".") m = m.slice(0, -1);
    return {
        formattedString: m,
        roundedNumber: xFinal,
        integerDigitsCount: int
    };
}
module.exports.ToRawFixed = $c935b5dbf1754d5e$var$ToRawFixed;

});



parcelRegister("3eW7k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CurrencyDigits = void 0;

var $cwnVA = parcelRequire("cwnVA");
/**
 * https://tc39.es/ecma402/#sec-currencydigits
 */ function $25bfc2beb90e4da9$var$CurrencyDigits(c, _a) {
    var currencyDigitsData = _a.currencyDigitsData;
    return (0, $cwnVA.HasOwnProperty)(currencyDigitsData, c) ? currencyDigitsData[c] : 2;
}
module.exports.CurrencyDigits = $25bfc2beb90e4da9$var$CurrencyDigits;

});

parcelRegister("3RAb5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatApproximately = void 0;
/**
 * https://tc39.es/ecma402/#sec-formatapproximately
 */ function $2d0262847ad2dcf5$var$FormatApproximately(numberFormat, result, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(numberFormat);
    var symbols = internalSlots.dataLocaleData.numbers.symbols[internalSlots.numberingSystem];
    var approximatelySign = symbols.approximatelySign;
    result.push({
        type: "approximatelySign",
        value: approximatelySign
    });
    return result;
}
module.exports.FormatApproximately = $2d0262847ad2dcf5$var$FormatApproximately;

});

parcelRegister("3oUoa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatNumericRange = void 0;

var $aRbYq = parcelRequire("aRbYq");
/**
 * https://tc39.es/ecma402/#sec-formatnumericrange
 */ function $279f5aa0bae7ab94$var$FormatNumericRange(numberFormat, x, y, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var parts = (0, $aRbYq.PartitionNumberRangePattern)(numberFormat, x, y, {
        getInternalSlots: getInternalSlots
    });
    return parts.map(function(part) {
        return part.value;
    }).join("");
}
module.exports.FormatNumericRange = $279f5aa0bae7ab94$var$FormatNumericRange;

});
parcelRegister("aRbYq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PartitionNumberRangePattern = void 0;

var $cLzG7 = parcelRequire("cLzG7");

var $1CwNb = parcelRequire("1CwNb");

var $3RAb5 = parcelRequire("3RAb5");
/**
 * https://tc39.es/ecma402/#sec-partitionnumberrangepattern
 */ function $7e78245706f9eef5$var$PartitionNumberRangePattern(numberFormat, x, y, _a) {
    var getInternalSlots = _a.getInternalSlots;
    if (isNaN(x) || isNaN(y)) throw new RangeError("Input must be a number");
    var result = [];
    var xResult = (0, $cLzG7.PartitionNumberPattern)(numberFormat, x, {
        getInternalSlots: getInternalSlots
    });
    var yResult = (0, $cLzG7.PartitionNumberPattern)(numberFormat, y, {
        getInternalSlots: getInternalSlots
    });
    if (xResult === yResult) return (0, $3RAb5.FormatApproximately)(numberFormat, xResult, {
        getInternalSlots: getInternalSlots
    });
    for(var _i = 0, xResult_1 = xResult; _i < xResult_1.length; _i++){
        var r = xResult_1[_i];
        r.source = "startRange";
    }
    result = result.concat(xResult);
    var internalSlots = getInternalSlots(numberFormat);
    var symbols = internalSlots.dataLocaleData.numbers.symbols[internalSlots.numberingSystem];
    result.push({
        type: "literal",
        value: symbols.rangeSign,
        source: "shared"
    });
    for(var _b = 0, yResult_1 = yResult; _b < yResult_1.length; _b++){
        var r = yResult_1[_b];
        r.source = "endRange";
    }
    result = result.concat(yResult);
    return (0, $1CwNb.CollapseNumberRange)(result);
}
module.exports.PartitionNumberRangePattern = $7e78245706f9eef5$var$PartitionNumberRangePattern;

});
parcelRegister("cLzG7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PartitionNumberPattern = void 0;

var $aVicc = parcelRequire("aVicc");

var $6jY8S = parcelRequire("6jY8S");

var $cwnVA = parcelRequire("cwnVA");

var $8h1U4 = parcelRequire("8h1U4");

var $94b58cc75d61a6e1$var$format_to_parts_1 = $aVicc.__importDefault((parcelRequire("gDwll")));
/**
 * https://tc39.es/ecma402/#sec-formatnumberstring
 */ function $94b58cc75d61a6e1$var$PartitionNumberPattern(numberFormat, x, _a) {
    var _b;
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(numberFormat);
    var pl = internalSlots.pl, dataLocaleData = internalSlots.dataLocaleData, numberingSystem = internalSlots.numberingSystem;
    var symbols = dataLocaleData.numbers.symbols[numberingSystem] || dataLocaleData.numbers.symbols[dataLocaleData.numbers.nu[0]];
    var magnitude = 0;
    var exponent = 0;
    var n;
    if (isNaN(x)) n = symbols.nan;
    else if (x == Number.POSITIVE_INFINITY || x == Number.NEGATIVE_INFINITY) n = symbols.infinity;
    else {
        if (!(0, $cwnVA.SameValue)(x, -0)) {
            if (!isFinite(x)) throw new Error("Input must be a mathematical value");
            if (internalSlots.style == "percent") x *= 100;
            _b = (0, $8h1U4.ComputeExponent)(numberFormat, x, {
                getInternalSlots: getInternalSlots
            }), exponent = _b[0], magnitude = _b[1];
            // Preserve more precision by doing multiplication when exponent is negative.
            x = exponent < 0 ? x * Math.pow(10, -exponent) : x / Math.pow(10, exponent);
        }
        var formatNumberResult = (0, $6jY8S.FormatNumericToString)(internalSlots, x);
        n = formatNumberResult.formattedString;
        x = formatNumberResult.roundedNumber;
    }
    // Based on https://tc39.es/ecma402/#sec-getnumberformatpattern
    // We need to do this before `x` is rounded.
    var sign;
    var signDisplay = internalSlots.signDisplay;
    switch(signDisplay){
        case "never":
            sign = 0;
            break;
        case "auto":
            if ((0, $cwnVA.SameValue)(x, 0) || x > 0 || isNaN(x)) sign = 0;
            else sign = -1;
            break;
        case "always":
            if ((0, $cwnVA.SameValue)(x, 0) || x > 0 || isNaN(x)) sign = 1;
            else sign = -1;
            break;
        default:
            // x === 0 -> x is 0 or x is -0
            if (x === 0 || isNaN(x)) sign = 0;
            else if (x > 0) sign = 1;
            else sign = -1;
    }
    return (0, $94b58cc75d61a6e1$var$format_to_parts_1.default)({
        roundedNumber: x,
        formattedString: n,
        exponent: exponent,
        magnitude: magnitude,
        sign: sign
    }, internalSlots.dataLocaleData, pl, internalSlots);
}
module.exports.PartitionNumberPattern = $94b58cc75d61a6e1$var$PartitionNumberPattern;

});
parcelRegister("gDwll", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hh2aP = parcelRequire("hh2aP");

var $3DRgV = parcelRequire("3DRgV");

var $jdPgx = parcelRequire("jdPgx");
// This is from: unicode-12.1.0/General_Category/Symbol/regex.js
// IE11 does not support unicode flag, otherwise this is just /\p{S}/u.
// /^\p{S}/u
var $c1c9608e06df1f20$var$CARET_S_UNICODE_REGEX = new RegExp("^".concat($jdPgx.S_UNICODE_REGEX.source));
// /\p{S}$/u
var $c1c9608e06df1f20$var$S_DOLLAR_UNICODE_REGEX = new RegExp("".concat($jdPgx.S_UNICODE_REGEX.source, "$"));
var $c1c9608e06df1f20$var$CLDR_NUMBER_PATTERN = /[#0](?:[\.,][#0]+)*/g;
function $c1c9608e06df1f20$var$formatToParts(numberResult, data, pl, options) {
    var sign = numberResult.sign, exponent = numberResult.exponent, magnitude = numberResult.magnitude;
    var notation = options.notation, style = options.style, numberingSystem = options.numberingSystem;
    var defaultNumberingSystem = data.numbers.nu[0];
    // #region Part 1: partition and interpolate the CLDR number pattern.
    // ----------------------------------------------------------
    var compactNumberPattern = null;
    if (notation === "compact" && magnitude) compactNumberPattern = $c1c9608e06df1f20$var$getCompactDisplayPattern(numberResult, pl, data, style, options.compactDisplay, options.currencyDisplay, numberingSystem);
    // This is used multiple times
    var nonNameCurrencyPart;
    if (style === "currency" && options.currencyDisplay !== "name") {
        var byCurrencyDisplay = data.currencies[options.currency];
        if (byCurrencyDisplay) switch(options.currencyDisplay){
            case "code":
                nonNameCurrencyPart = options.currency;
                break;
            case "symbol":
                nonNameCurrencyPart = byCurrencyDisplay.symbol;
                break;
            default:
                nonNameCurrencyPart = byCurrencyDisplay.narrow;
                break;
        }
        else // Fallback for unknown currency
        nonNameCurrencyPart = options.currency;
    }
    var numberPattern;
    if (!compactNumberPattern) {
        // Note: if the style is unit, or is currency and the currency display is name,
        // its unit parts will be interpolated in part 2. So here we can fallback to decimal.
        if (style === "decimal" || style === "unit" || style === "currency" && options.currencyDisplay === "name") {
            // Shortcut for decimal
            var decimalData = data.numbers.decimal[numberingSystem] || data.numbers.decimal[defaultNumberingSystem];
            numberPattern = $c1c9608e06df1f20$var$getPatternForSign(decimalData.standard, sign);
        } else if (style === "currency") {
            var currencyData = data.numbers.currency[numberingSystem] || data.numbers.currency[defaultNumberingSystem];
            // We replace number pattern part with `0` for easier postprocessing.
            numberPattern = $c1c9608e06df1f20$var$getPatternForSign(currencyData[options.currencySign], sign);
        } else {
            // percent
            var percentPattern = data.numbers.percent[numberingSystem] || data.numbers.percent[defaultNumberingSystem];
            numberPattern = $c1c9608e06df1f20$var$getPatternForSign(percentPattern, sign);
        }
    } else numberPattern = compactNumberPattern;
    // Extract the decimal number pattern string. It looks like "#,##0,00", which will later be
    // used to infer decimal group sizes.
    var decimalNumberPattern = $c1c9608e06df1f20$var$CLDR_NUMBER_PATTERN.exec(numberPattern)[0];
    // Now we start to substitute patterns
    // 1. replace strings like `0` and `#,##0.00` with `{0}`
    // 2. unquote characters (invariant: the quoted characters does not contain the special tokens)
    numberPattern = numberPattern.replace($c1c9608e06df1f20$var$CLDR_NUMBER_PATTERN, "{0}").replace(/'(.)'/g, "$1");
    // Handle currency spacing (both compact and non-compact).
    if (style === "currency" && options.currencyDisplay !== "name") {
        var currencyData = data.numbers.currency[numberingSystem] || data.numbers.currency[defaultNumberingSystem];
        // See `currencySpacing` substitution rule in TR-35.
        // Here we always assume the currencyMatch is "[:^S:]" and surroundingMatch is "[:digit:]".
        //
        // Example 1: for pattern "#,##0.00¤" with symbol "US$", we replace "¤" with the symbol,
        // but insert an extra non-break space before the symbol, because "[:^S:]" matches "U" in
        // "US$" and "[:digit:]" matches the latn numbering system digits.
        //
        // Example 2: for pattern "¤#,##0.00" with symbol "US$", there is no spacing between symbol
        // and number, because `$` does not match "[:^S:]".
        //
        // Implementation note: here we do the best effort to infer the insertion.
        // We also assume that `beforeInsertBetween` and `afterInsertBetween` will never be `;`.
        var afterCurrency = currencyData.currencySpacing.afterInsertBetween;
        if (afterCurrency && !$c1c9608e06df1f20$var$S_DOLLAR_UNICODE_REGEX.test(nonNameCurrencyPart)) numberPattern = numberPattern.replace("\xa4{0}", "\xa4".concat(afterCurrency, "{0}"));
        var beforeCurrency = currencyData.currencySpacing.beforeInsertBetween;
        if (beforeCurrency && !$c1c9608e06df1f20$var$CARET_S_UNICODE_REGEX.test(nonNameCurrencyPart)) numberPattern = numberPattern.replace("{0}\xa4", "{0}".concat(beforeCurrency, "\xa4"));
    }
    // The following tokens are special: `{0}`, `¤`, `%`, `-`, `+`, `{c:...}.
    var numberPatternParts = numberPattern.split(/({c:[^}]+}|\{0\}|[¤%\-\+])/g);
    var numberParts = [];
    var symbols = data.numbers.symbols[numberingSystem] || data.numbers.symbols[defaultNumberingSystem];
    for(var _i = 0, numberPatternParts_1 = numberPatternParts; _i < numberPatternParts_1.length; _i++){
        var part = numberPatternParts_1[_i];
        if (!part) continue;
        switch(part){
            case "{0}":
                // We only need to handle scientific and engineering notation here.
                numberParts.push.apply(numberParts, $c1c9608e06df1f20$var$paritionNumberIntoParts(symbols, numberResult, notation, exponent, numberingSystem, // If compact number pattern exists, do not insert group separators.
                !compactNumberPattern && Boolean(options.useGrouping), decimalNumberPattern));
                break;
            case "-":
                numberParts.push({
                    type: "minusSign",
                    value: symbols.minusSign
                });
                break;
            case "+":
                numberParts.push({
                    type: "plusSign",
                    value: symbols.plusSign
                });
                break;
            case "%":
                numberParts.push({
                    type: "percentSign",
                    value: symbols.percentSign
                });
                break;
            case "\xa4":
                // Computed above when handling currency spacing.
                numberParts.push({
                    type: "currency",
                    value: nonNameCurrencyPart
                });
                break;
            default:
                if (/^\{c:/.test(part)) numberParts.push({
                    type: "compact",
                    value: part.substring(3, part.length - 1)
                });
                else // literal
                numberParts.push({
                    type: "literal",
                    value: part
                });
                break;
        }
    }
    // #endregion
    // #region Part 2: interpolate unit pattern if necessary.
    // ----------------------------------------------
    switch(style){
        case "currency":
            // `currencyDisplay: 'name'` has similar pattern handling as units.
            if (options.currencyDisplay === "name") {
                var unitPattern = (data.numbers.currency[numberingSystem] || data.numbers.currency[defaultNumberingSystem]).unitPattern;
                // Select plural
                var unitName = void 0;
                var currencyNameData = data.currencies[options.currency];
                if (currencyNameData) unitName = $c1c9608e06df1f20$var$selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), currencyNameData.displayName);
                else // Fallback for unknown currency
                unitName = options.currency;
                // Do {0} and {1} substitution
                var unitPatternParts = unitPattern.split(/(\{[01]\})/g);
                var result = [];
                for(var _a = 0, unitPatternParts_1 = unitPatternParts; _a < unitPatternParts_1.length; _a++){
                    var part = unitPatternParts_1[_a];
                    switch(part){
                        case "{0}":
                            result.push.apply(result, numberParts);
                            break;
                        case "{1}":
                            result.push({
                                type: "currency",
                                value: unitName
                            });
                            break;
                        default:
                            if (part) result.push({
                                type: "literal",
                                value: part
                            });
                            break;
                    }
                }
                return result;
            } else return numberParts;
        case "unit":
            var unit = options.unit, unitDisplay = options.unitDisplay;
            var unitData = data.units.simple[unit];
            var unitPattern = void 0;
            if (unitData) // Simple unit pattern
            unitPattern = $c1c9608e06df1f20$var$selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), data.units.simple[unit][unitDisplay]);
            else {
                // See: http://unicode.org/reports/tr35/tr35-general.html#perUnitPatterns
                // If cannot find unit in the simple pattern, it must be "per" compound pattern.
                // Implementation note: we are not following TR-35 here because we need to format to parts!
                var _b = unit.split("-per-"), numeratorUnit = _b[0], denominatorUnit = _b[1];
                unitData = data.units.simple[numeratorUnit];
                var numeratorUnitPattern = $c1c9608e06df1f20$var$selectPlural(pl, numberResult.roundedNumber * Math.pow(10, exponent), data.units.simple[numeratorUnit][unitDisplay]);
                var perUnitPattern = data.units.simple[denominatorUnit].perUnit[unitDisplay];
                if (perUnitPattern) // perUnitPattern exists, combine it with numeratorUnitPattern
                unitPattern = perUnitPattern.replace("{0}", numeratorUnitPattern);
                else {
                    // get compoundUnit pattern (e.g. "{0} per {1}"), repalce {0} with numerator pattern and {1} with
                    // the denominator pattern in singular form.
                    var perPattern = data.units.compound.per[unitDisplay];
                    var denominatorPattern = $c1c9608e06df1f20$var$selectPlural(pl, 1, data.units.simple[denominatorUnit][unitDisplay]);
                    unitPattern = unitPattern = perPattern.replace("{0}", numeratorUnitPattern).replace("{1}", denominatorPattern.replace("{0}", ""));
                }
            }
            var result = [];
            // We need spacing around "{0}" because they are not treated as "unit" parts, but "literal".
            for(var _c = 0, _d = unitPattern.split(/(\s*\{0\}\s*)/); _c < _d.length; _c++){
                var part = _d[_c];
                var interpolateMatch = /^(\s*)\{0\}(\s*)$/.exec(part);
                if (interpolateMatch) {
                    // Space before "{0}"
                    if (interpolateMatch[1]) result.push({
                        type: "literal",
                        value: interpolateMatch[1]
                    });
                    // "{0}" itself
                    result.push.apply(result, numberParts);
                    // Space after "{0}"
                    if (interpolateMatch[2]) result.push({
                        type: "literal",
                        value: interpolateMatch[2]
                    });
                } else if (part) result.push({
                    type: "unit",
                    value: part
                });
            }
            return result;
        default:
            return numberParts;
    }
// #endregion
}
module.exports.default = $c1c9608e06df1f20$var$formatToParts;
// A subset of https://tc39.es/ecma402/#sec-partitionnotationsubpattern
// Plus the exponent parts handling.
function $c1c9608e06df1f20$var$paritionNumberIntoParts(symbols, numberResult, notation, exponent, numberingSystem, useGrouping, /**
 * This is the decimal number pattern without signs or symbols.
 * It is used to infer the group size when `useGrouping` is true.
 *
 * A typical value looks like "#,##0.00" (primary group size is 3).
 * Some locales like Hindi has secondary group size of 2 (e.g. "#,##,##0.00").
 */ decimalNumberPattern) {
    var result = [];
    // eslint-disable-next-line prefer-const
    var n = numberResult.formattedString, x = numberResult.roundedNumber;
    if (isNaN(x)) return [
        {
            type: "nan",
            value: n
        }
    ];
    else if (!isFinite(x)) return [
        {
            type: "infinity",
            value: n
        }
    ];
    var digitReplacementTable = $3DRgV.digitMapping[numberingSystem];
    if (digitReplacementTable) n = n.replace(/\d/g, function(digit) {
        return digitReplacementTable[+digit] || digit;
    });
    // TODO: Else use an implementation dependent algorithm to map n to the appropriate
    // representation of n in the given numbering system.
    var decimalSepIndex = n.indexOf(".");
    var integer;
    var fraction;
    if (decimalSepIndex > 0) {
        integer = n.slice(0, decimalSepIndex);
        fraction = n.slice(decimalSepIndex + 1);
    } else integer = n;
    // #region Grouping integer digits
    // The weird compact and x >= 10000 check is to ensure consistency with Node.js and Chrome.
    // Note that `de` does not have compact form for thousands, but Node.js does not insert grouping separator
    // unless the rounded number is greater than 10000:
    //   NumberFormat('de', {notation: 'compact', compactDisplay: 'short'}).format(1234) //=> "1234"
    //   NumberFormat('de').format(1234) //=> "1.234"
    if (useGrouping && (notation !== "compact" || x >= 10000)) {
        var groupSepSymbol = symbols.group;
        var groups = [];
        // > There may be two different grouping sizes: The primary grouping size used for the least
        // > significant integer group, and the secondary grouping size used for more significant groups.
        // > If a pattern contains multiple grouping separators, the interval between the last one and the
        // > end of the integer defines the primary grouping size, and the interval between the last two
        // > defines the secondary grouping size. All others are ignored.
        var integerNumberPattern = decimalNumberPattern.split(".")[0];
        var patternGroups = integerNumberPattern.split(",");
        var primaryGroupingSize = 3;
        var secondaryGroupingSize = 3;
        if (patternGroups.length > 1) primaryGroupingSize = patternGroups[patternGroups.length - 1].length;
        if (patternGroups.length > 2) secondaryGroupingSize = patternGroups[patternGroups.length - 2].length;
        var i = integer.length - primaryGroupingSize;
        if (i > 0) {
            // Slice the least significant integer group
            groups.push(integer.slice(i, i + primaryGroupingSize));
            // Then iteratively push the more signicant groups
            // TODO: handle surrogate pairs in some numbering system digits
            for(i -= secondaryGroupingSize; i > 0; i -= secondaryGroupingSize)groups.push(integer.slice(i, i + secondaryGroupingSize));
            groups.push(integer.slice(0, i + secondaryGroupingSize));
        } else groups.push(integer);
        while(groups.length > 0){
            var integerGroup = groups.pop();
            result.push({
                type: "integer",
                value: integerGroup
            });
            if (groups.length > 0) result.push({
                type: "group",
                value: groupSepSymbol
            });
        }
    } else result.push({
        type: "integer",
        value: integer
    });
    // #endregion
    if (fraction !== undefined) result.push({
        type: "decimal",
        value: symbols.decimal
    }, {
        type: "fraction",
        value: fraction
    });
    if ((notation === "scientific" || notation === "engineering") && isFinite(x)) {
        result.push({
            type: "exponentSeparator",
            value: symbols.exponential
        });
        if (exponent < 0) {
            result.push({
                type: "exponentMinusSign",
                value: symbols.minusSign
            });
            exponent = -exponent;
        }
        var exponentResult = (0, $hh2aP.ToRawFixed)(exponent, 0, 0);
        result.push({
            type: "exponentInteger",
            value: exponentResult.formattedString
        });
    }
    return result;
}
function $c1c9608e06df1f20$var$getPatternForSign(pattern, sign) {
    if (pattern.indexOf(";") < 0) pattern = "".concat(pattern, ";-").concat(pattern);
    var _a = pattern.split(";"), zeroPattern = _a[0], negativePattern = _a[1];
    switch(sign){
        case 0:
            return zeroPattern;
        case -1:
            return negativePattern;
        default:
            return negativePattern.indexOf("-") >= 0 ? negativePattern.replace(/-/g, "+") : "+".concat(zeroPattern);
    }
}
// Find the CLDR pattern for compact notation based on the magnitude of data and style.
//
// Example return value: "¤ {c:laki}000;¤{c:laki} -0" (`sw` locale):
// - Notice the `{c:...}` token that wraps the compact literal.
// - The consecutive zeros are normalized to single zero to match CLDR_NUMBER_PATTERN.
//
// Returning null means the compact display pattern cannot be found.
function $c1c9608e06df1f20$var$getCompactDisplayPattern(numberResult, pl, data, style, compactDisplay, currencyDisplay, numberingSystem) {
    var _a;
    var roundedNumber = numberResult.roundedNumber, sign = numberResult.sign, magnitude = numberResult.magnitude;
    var magnitudeKey = String(Math.pow(10, magnitude));
    var defaultNumberingSystem = data.numbers.nu[0];
    var pattern;
    if (style === "currency" && currencyDisplay !== "name") {
        var byNumberingSystem = data.numbers.currency;
        var currencyData = byNumberingSystem[numberingSystem] || byNumberingSystem[defaultNumberingSystem];
        // NOTE: compact notation ignores currencySign!
        var compactPluralRules = (_a = currencyData.short) === null || _a === void 0 ? void 0 : _a[magnitudeKey];
        if (!compactPluralRules) return null;
        pattern = $c1c9608e06df1f20$var$selectPlural(pl, roundedNumber, compactPluralRules);
    } else {
        var byNumberingSystem = data.numbers.decimal;
        var byCompactDisplay = byNumberingSystem[numberingSystem] || byNumberingSystem[defaultNumberingSystem];
        var compactPlaralRule = byCompactDisplay[compactDisplay][magnitudeKey];
        if (!compactPlaralRule) return null;
        pattern = $c1c9608e06df1f20$var$selectPlural(pl, roundedNumber, compactPlaralRule);
    }
    // See https://unicode.org/reports/tr35/tr35-numbers.html#Compact_Number_Formats
    // > If the value is precisely “0”, either explicit or defaulted, then the normal number format
    // > pattern for that sort of object is supplied.
    if (pattern === "0") return null;
    pattern = $c1c9608e06df1f20$var$getPatternForSign(pattern, sign)// Extract compact literal from the pattern
    .replace(/([^\s;\-\+\d¤]+)/g, "{c:$1}")// We replace one or more zeros with a single zero so it matches `CLDR_NUMBER_PATTERN`.
    .replace(/0+/, "0");
    return pattern;
}
function $c1c9608e06df1f20$var$selectPlural(pl, x, rules) {
    return rules[pl.select(x)] || rules.other;
}

});
parcelRegister("3DRgV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.digitMapping = void 0;
module.exports.digitMapping = {
    "adlm": [
        "\uD83A\uDD50",
        "\uD83A\uDD51",
        "\uD83A\uDD52",
        "\uD83A\uDD53",
        "\uD83A\uDD54",
        "\uD83A\uDD55",
        "\uD83A\uDD56",
        "\uD83A\uDD57",
        "\uD83A\uDD58",
        "\uD83A\uDD59"
    ],
    "ahom": [
        "\uD805\uDF30",
        "\uD805\uDF31",
        "\uD805\uDF32",
        "\uD805\uDF33",
        "\uD805\uDF34",
        "\uD805\uDF35",
        "\uD805\uDF36",
        "\uD805\uDF37",
        "\uD805\uDF38",
        "\uD805\uDF39"
    ],
    "arab": [
        "\u0660",
        "\u0661",
        "\u0662",
        "\u0663",
        "\u0664",
        "\u0665",
        "\u0666",
        "\u0667",
        "\u0668",
        "\u0669"
    ],
    "arabext": [
        "\u06F0",
        "\u06F1",
        "\u06F2",
        "\u06F3",
        "\u06F4",
        "\u06F5",
        "\u06F6",
        "\u06F7",
        "\u06F8",
        "\u06F9"
    ],
    "bali": [
        "\u1B50",
        "\u1B51",
        "\u1B52",
        "\u1B53",
        "\u1B54",
        "\u1B55",
        "\u1B56",
        "\u1B57",
        "\u1B58",
        "\u1B59"
    ],
    "beng": [
        "\u09E6",
        "\u09E7",
        "\u09E8",
        "\u09E9",
        "\u09EA",
        "\u09EB",
        "\u09EC",
        "\u09ED",
        "\u09EE",
        "\u09EF"
    ],
    "bhks": [
        "\uD807\uDC50",
        "\uD807\uDC51",
        "\uD807\uDC52",
        "\uD807\uDC53",
        "\uD807\uDC54",
        "\uD807\uDC55",
        "\uD807\uDC56",
        "\uD807\uDC57",
        "\uD807\uDC58",
        "\uD807\uDC59"
    ],
    "brah": [
        "\uD804\uDC66",
        "\uD804\uDC67",
        "\uD804\uDC68",
        "\uD804\uDC69",
        "\uD804\uDC6A",
        "\uD804\uDC6B",
        "\uD804\uDC6C",
        "\uD804\uDC6D",
        "\uD804\uDC6E",
        "\uD804\uDC6F"
    ],
    "cakm": [
        "\uD804\uDD36",
        "\uD804\uDD37",
        "\uD804\uDD38",
        "\uD804\uDD39",
        "\uD804\uDD3A",
        "\uD804\uDD3B",
        "\uD804\uDD3C",
        "\uD804\uDD3D",
        "\uD804\uDD3E",
        "\uD804\uDD3F"
    ],
    "cham": [
        "\uAA50",
        "\uAA51",
        "\uAA52",
        "\uAA53",
        "\uAA54",
        "\uAA55",
        "\uAA56",
        "\uAA57",
        "\uAA58",
        "\uAA59"
    ],
    "deva": [
        "\u0966",
        "\u0967",
        "\u0968",
        "\u0969",
        "\u096A",
        "\u096B",
        "\u096C",
        "\u096D",
        "\u096E",
        "\u096F"
    ],
    "diak": [
        "\uD806\uDD50",
        "\uD806\uDD51",
        "\uD806\uDD52",
        "\uD806\uDD53",
        "\uD806\uDD54",
        "\uD806\uDD55",
        "\uD806\uDD56",
        "\uD806\uDD57",
        "\uD806\uDD58",
        "\uD806\uDD59"
    ],
    "fullwide": [
        "\uFF10",
        "\uFF11",
        "\uFF12",
        "\uFF13",
        "\uFF14",
        "\uFF15",
        "\uFF16",
        "\uFF17",
        "\uFF18",
        "\uFF19"
    ],
    "gong": [
        "\uD807\uDDA0",
        "\uD807\uDDA1",
        "\uD807\uDDA2",
        "\uD807\uDDA3",
        "\uD807\uDDA4",
        "\uD807\uDDA5",
        "\uD807\uDDA6",
        "\uD807\uDDA7",
        "\uD807\uDDA8",
        "\uD807\uDDA9"
    ],
    "gonm": [
        "\uD807\uDD50",
        "\uD807\uDD51",
        "\uD807\uDD52",
        "\uD807\uDD53",
        "\uD807\uDD54",
        "\uD807\uDD55",
        "\uD807\uDD56",
        "\uD807\uDD57",
        "\uD807\uDD58",
        "\uD807\uDD59"
    ],
    "gujr": [
        "\u0AE6",
        "\u0AE7",
        "\u0AE8",
        "\u0AE9",
        "\u0AEA",
        "\u0AEB",
        "\u0AEC",
        "\u0AED",
        "\u0AEE",
        "\u0AEF"
    ],
    "guru": [
        "\u0A66",
        "\u0A67",
        "\u0A68",
        "\u0A69",
        "\u0A6A",
        "\u0A6B",
        "\u0A6C",
        "\u0A6D",
        "\u0A6E",
        "\u0A6F"
    ],
    "hanidec": [
        "\u3007",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D"
    ],
    "hmng": [
        "\uD81A\uDF50",
        "\uD81A\uDF51",
        "\uD81A\uDF52",
        "\uD81A\uDF53",
        "\uD81A\uDF54",
        "\uD81A\uDF55",
        "\uD81A\uDF56",
        "\uD81A\uDF57",
        "\uD81A\uDF58",
        "\uD81A\uDF59"
    ],
    "hmnp": [
        "\uD838\uDD40",
        "\uD838\uDD41",
        "\uD838\uDD42",
        "\uD838\uDD43",
        "\uD838\uDD44",
        "\uD838\uDD45",
        "\uD838\uDD46",
        "\uD838\uDD47",
        "\uD838\uDD48",
        "\uD838\uDD49"
    ],
    "java": [
        "\uA9D0",
        "\uA9D1",
        "\uA9D2",
        "\uA9D3",
        "\uA9D4",
        "\uA9D5",
        "\uA9D6",
        "\uA9D7",
        "\uA9D8",
        "\uA9D9"
    ],
    "kali": [
        "\uA900",
        "\uA901",
        "\uA902",
        "\uA903",
        "\uA904",
        "\uA905",
        "\uA906",
        "\uA907",
        "\uA908",
        "\uA909"
    ],
    "khmr": [
        "\u17E0",
        "\u17E1",
        "\u17E2",
        "\u17E3",
        "\u17E4",
        "\u17E5",
        "\u17E6",
        "\u17E7",
        "\u17E8",
        "\u17E9"
    ],
    "knda": [
        "\u0CE6",
        "\u0CE7",
        "\u0CE8",
        "\u0CE9",
        "\u0CEA",
        "\u0CEB",
        "\u0CEC",
        "\u0CED",
        "\u0CEE",
        "\u0CEF"
    ],
    "lana": [
        "\u1A80",
        "\u1A81",
        "\u1A82",
        "\u1A83",
        "\u1A84",
        "\u1A85",
        "\u1A86",
        "\u1A87",
        "\u1A88",
        "\u1A89"
    ],
    "lanatham": [
        "\u1A90",
        "\u1A91",
        "\u1A92",
        "\u1A93",
        "\u1A94",
        "\u1A95",
        "\u1A96",
        "\u1A97",
        "\u1A98",
        "\u1A99"
    ],
    "laoo": [
        "\u0ED0",
        "\u0ED1",
        "\u0ED2",
        "\u0ED3",
        "\u0ED4",
        "\u0ED5",
        "\u0ED6",
        "\u0ED7",
        "\u0ED8",
        "\u0ED9"
    ],
    "lepc": [
        "\u1A90",
        "\u1A91",
        "\u1A92",
        "\u1A93",
        "\u1A94",
        "\u1A95",
        "\u1A96",
        "\u1A97",
        "\u1A98",
        "\u1A99"
    ],
    "limb": [
        "\u1946",
        "\u1947",
        "\u1948",
        "\u1949",
        "\u194A",
        "\u194B",
        "\u194C",
        "\u194D",
        "\u194E",
        "\u194F"
    ],
    "mathbold": [
        "\uD835\uDFCE",
        "\uD835\uDFCF",
        "\uD835\uDFD0",
        "\uD835\uDFD1",
        "\uD835\uDFD2",
        "\uD835\uDFD3",
        "\uD835\uDFD4",
        "\uD835\uDFD5",
        "\uD835\uDFD6",
        "\uD835\uDFD7"
    ],
    "mathdbl": [
        "\uD835\uDFD8",
        "\uD835\uDFD9",
        "\uD835\uDFDA",
        "\uD835\uDFDB",
        "\uD835\uDFDC",
        "\uD835\uDFDD",
        "\uD835\uDFDE",
        "\uD835\uDFDF",
        "\uD835\uDFE0",
        "\uD835\uDFE1"
    ],
    "mathmono": [
        "\uD835\uDFF6",
        "\uD835\uDFF7",
        "\uD835\uDFF8",
        "\uD835\uDFF9",
        "\uD835\uDFFA",
        "\uD835\uDFFB",
        "\uD835\uDFFC",
        "\uD835\uDFFD",
        "\uD835\uDFFE",
        "\uD835\uDFFF"
    ],
    "mathsanb": [
        "\uD835\uDFEC",
        "\uD835\uDFED",
        "\uD835\uDFEE",
        "\uD835\uDFEF",
        "\uD835\uDFF0",
        "\uD835\uDFF1",
        "\uD835\uDFF2",
        "\uD835\uDFF3",
        "\uD835\uDFF4",
        "\uD835\uDFF5"
    ],
    "mathsans": [
        "\uD835\uDFE2",
        "\uD835\uDFE3",
        "\uD835\uDFE4",
        "\uD835\uDFE5",
        "\uD835\uDFE6",
        "\uD835\uDFE7",
        "\uD835\uDFE8",
        "\uD835\uDFE9",
        "\uD835\uDFEA",
        "\uD835\uDFEB"
    ],
    "mlym": [
        "\u0D66",
        "\u0D67",
        "\u0D68",
        "\u0D69",
        "\u0D6A",
        "\u0D6B",
        "\u0D6C",
        "\u0D6D",
        "\u0D6E",
        "\u0D6F"
    ],
    "modi": [
        "\uD805\uDE50",
        "\uD805\uDE51",
        "\uD805\uDE52",
        "\uD805\uDE53",
        "\uD805\uDE54",
        "\uD805\uDE55",
        "\uD805\uDE56",
        "\uD805\uDE57",
        "\uD805\uDE58",
        "\uD805\uDE59"
    ],
    "mong": [
        "\u1810",
        "\u1811",
        "\u1812",
        "\u1813",
        "\u1814",
        "\u1815",
        "\u1816",
        "\u1817",
        "\u1818",
        "\u1819"
    ],
    "mroo": [
        "\uD81A\uDE60",
        "\uD81A\uDE61",
        "\uD81A\uDE62",
        "\uD81A\uDE63",
        "\uD81A\uDE64",
        "\uD81A\uDE65",
        "\uD81A\uDE66",
        "\uD81A\uDE67",
        "\uD81A\uDE68",
        "\uD81A\uDE69"
    ],
    "mtei": [
        "\uABF0",
        "\uABF1",
        "\uABF2",
        "\uABF3",
        "\uABF4",
        "\uABF5",
        "\uABF6",
        "\uABF7",
        "\uABF8",
        "\uABF9"
    ],
    "mymr": [
        "\u1040",
        "\u1041",
        "\u1042",
        "\u1043",
        "\u1044",
        "\u1045",
        "\u1046",
        "\u1047",
        "\u1048",
        "\u1049"
    ],
    "mymrshan": [
        "\u1090",
        "\u1091",
        "\u1092",
        "\u1093",
        "\u1094",
        "\u1095",
        "\u1096",
        "\u1097",
        "\u1098",
        "\u1099"
    ],
    "mymrtlng": [
        "\uA9F0",
        "\uA9F1",
        "\uA9F2",
        "\uA9F3",
        "\uA9F4",
        "\uA9F5",
        "\uA9F6",
        "\uA9F7",
        "\uA9F8",
        "\uA9F9"
    ],
    "newa": [
        "\uD805\uDC50",
        "\uD805\uDC51",
        "\uD805\uDC52",
        "\uD805\uDC53",
        "\uD805\uDC54",
        "\uD805\uDC55",
        "\uD805\uDC56",
        "\uD805\uDC57",
        "\uD805\uDC58",
        "\uD805\uDC59"
    ],
    "nkoo": [
        "\u07C0",
        "\u07C1",
        "\u07C2",
        "\u07C3",
        "\u07C4",
        "\u07C5",
        "\u07C6",
        "\u07C7",
        "\u07C8",
        "\u07C9"
    ],
    "olck": [
        "\u1C50",
        "\u1C51",
        "\u1C52",
        "\u1C53",
        "\u1C54",
        "\u1C55",
        "\u1C56",
        "\u1C57",
        "\u1C58",
        "\u1C59"
    ],
    "orya": [
        "\u0B66",
        "\u0B67",
        "\u0B68",
        "\u0B69",
        "\u0B6A",
        "\u0B6B",
        "\u0B6C",
        "\u0B6D",
        "\u0B6E",
        "\u0B6F"
    ],
    "osma": [
        "\uD801\uDCA0",
        "\uD801\uDCA1",
        "\uD801\uDCA2",
        "\uD801\uDCA3",
        "\uD801\uDCA4",
        "\uD801\uDCA5",
        "\uD801\uDCA6",
        "\uD801\uDCA7",
        "\uD801\uDCA8",
        "\uD801\uDCA9"
    ],
    "rohg": [
        "\uD803\uDD30",
        "\uD803\uDD31",
        "\uD803\uDD32",
        "\uD803\uDD33",
        "\uD803\uDD34",
        "\uD803\uDD35",
        "\uD803\uDD36",
        "\uD803\uDD37",
        "\uD803\uDD38",
        "\uD803\uDD39"
    ],
    "saur": [
        "\uA8D0",
        "\uA8D1",
        "\uA8D2",
        "\uA8D3",
        "\uA8D4",
        "\uA8D5",
        "\uA8D6",
        "\uA8D7",
        "\uA8D8",
        "\uA8D9"
    ],
    "segment": [
        "\uD83E\uDFF0",
        "\uD83E\uDFF1",
        "\uD83E\uDFF2",
        "\uD83E\uDFF3",
        "\uD83E\uDFF4",
        "\uD83E\uDFF5",
        "\uD83E\uDFF6",
        "\uD83E\uDFF7",
        "\uD83E\uDFF8",
        "\uD83E\uDFF9"
    ],
    "shrd": [
        "\uD804\uDDD0",
        "\uD804\uDDD1",
        "\uD804\uDDD2",
        "\uD804\uDDD3",
        "\uD804\uDDD4",
        "\uD804\uDDD5",
        "\uD804\uDDD6",
        "\uD804\uDDD7",
        "\uD804\uDDD8",
        "\uD804\uDDD9"
    ],
    "sind": [
        "\uD804\uDEF0",
        "\uD804\uDEF1",
        "\uD804\uDEF2",
        "\uD804\uDEF3",
        "\uD804\uDEF4",
        "\uD804\uDEF5",
        "\uD804\uDEF6",
        "\uD804\uDEF7",
        "\uD804\uDEF8",
        "\uD804\uDEF9"
    ],
    "sinh": [
        "\u0DE6",
        "\u0DE7",
        "\u0DE8",
        "\u0DE9",
        "\u0DEA",
        "\u0DEB",
        "\u0DEC",
        "\u0DED",
        "\u0DEE",
        "\u0DEF"
    ],
    "sora": [
        "\uD804\uDCF0",
        "\uD804\uDCF1",
        "\uD804\uDCF2",
        "\uD804\uDCF3",
        "\uD804\uDCF4",
        "\uD804\uDCF5",
        "\uD804\uDCF6",
        "\uD804\uDCF7",
        "\uD804\uDCF8",
        "\uD804\uDCF9"
    ],
    "sund": [
        "\u1BB0",
        "\u1BB1",
        "\u1BB2",
        "\u1BB3",
        "\u1BB4",
        "\u1BB5",
        "\u1BB6",
        "\u1BB7",
        "\u1BB8",
        "\u1BB9"
    ],
    "takr": [
        "\uD805\uDEC0",
        "\uD805\uDEC1",
        "\uD805\uDEC2",
        "\uD805\uDEC3",
        "\uD805\uDEC4",
        "\uD805\uDEC5",
        "\uD805\uDEC6",
        "\uD805\uDEC7",
        "\uD805\uDEC8",
        "\uD805\uDEC9"
    ],
    "talu": [
        "\u19D0",
        "\u19D1",
        "\u19D2",
        "\u19D3",
        "\u19D4",
        "\u19D5",
        "\u19D6",
        "\u19D7",
        "\u19D8",
        "\u19D9"
    ],
    "tamldec": [
        "\u0BE6",
        "\u0BE7",
        "\u0BE8",
        "\u0BE9",
        "\u0BEA",
        "\u0BEB",
        "\u0BEC",
        "\u0BED",
        "\u0BEE",
        "\u0BEF"
    ],
    "telu": [
        "\u0C66",
        "\u0C67",
        "\u0C68",
        "\u0C69",
        "\u0C6A",
        "\u0C6B",
        "\u0C6C",
        "\u0C6D",
        "\u0C6E",
        "\u0C6F"
    ],
    "thai": [
        "\u0E50",
        "\u0E51",
        "\u0E52",
        "\u0E53",
        "\u0E54",
        "\u0E55",
        "\u0E56",
        "\u0E57",
        "\u0E58",
        "\u0E59"
    ],
    "tibt": [
        "\u0F20",
        "\u0F21",
        "\u0F22",
        "\u0F23",
        "\u0F24",
        "\u0F25",
        "\u0F26",
        "\u0F27",
        "\u0F28",
        "\u0F29"
    ],
    "tirh": [
        "\uD805\uDCD0",
        "\uD805\uDCD1",
        "\uD805\uDCD2",
        "\uD805\uDCD3",
        "\uD805\uDCD4",
        "\uD805\uDCD5",
        "\uD805\uDCD6",
        "\uD805\uDCD7",
        "\uD805\uDCD8",
        "\uD805\uDCD9"
    ],
    "vaii": [
        "\u1620",
        "\u1621",
        "\u1622",
        "\u1623",
        "\u1624",
        "\u1625",
        "\u1626",
        "\u1627",
        "\u1628",
        "\u1629"
    ],
    "wara": [
        "\uD806\uDCE0",
        "\uD806\uDCE1",
        "\uD806\uDCE2",
        "\uD806\uDCE3",
        "\uD806\uDCE4",
        "\uD806\uDCE5",
        "\uD806\uDCE6",
        "\uD806\uDCE7",
        "\uD806\uDCE8",
        "\uD806\uDCE9"
    ],
    "wcho": [
        "\uD838\uDEF0",
        "\uD838\uDEF1",
        "\uD838\uDEF2",
        "\uD838\uDEF3",
        "\uD838\uDEF4",
        "\uD838\uDEF5",
        "\uD838\uDEF6",
        "\uD838\uDEF7",
        "\uD838\uDEF8",
        "\uD838\uDEF9"
    ]
};

});

parcelRegister("jdPgx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.S_UNICODE_REGEX = void 0;
// @generated from regex-gen.ts
module.exports.S_UNICODE_REGEX = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20BF\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC1\uFDFC\uFDFD\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEE0-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDD78\uDD7A-\uDDCB\uDDCD-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6\uDF00-\uDF92\uDF94-\uDFCA]/;

});





parcelRegister("cCbdw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatNumericRangeToParts = void 0;

var $aRbYq = parcelRequire("aRbYq");
/**
 * https://tc39.es/ecma402/#sec-formatnumericrangetoparts
 */ function $92f1bc230a7675ca$var$FormatNumericRangeToParts(numberFormat, x, y, _a) {
    var getInternalSlots = _a.getInternalSlots;
    var parts = (0, $aRbYq.PartitionNumberRangePattern)(numberFormat, x, y, {
        getInternalSlots: getInternalSlots
    });
    return parts.map(function(part, index) {
        return {
            type: part.type,
            value: part.value,
            source: part.source,
            result: index.toString()
        };
    });
}
module.exports.FormatNumericRangeToParts = $92f1bc230a7675ca$var$FormatNumericRangeToParts;

});

parcelRegister("bYbp2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatNumericToParts = void 0;

var $cLzG7 = parcelRequire("cLzG7");

var $cwnVA = parcelRequire("cwnVA");
function $8b6e24a787bdb969$var$FormatNumericToParts(nf, x, implDetails) {
    var parts = (0, $cLzG7.PartitionNumberPattern)(nf, x, implDetails);
    var result = (0, $cwnVA.ArrayCreate)(0);
    for(var _i = 0, parts_1 = parts; _i < parts_1.length; _i++){
        var part = parts_1[_i];
        result.push({
            type: part.type,
            value: part.value
        });
    }
    return result;
}
module.exports.FormatNumericToParts = $8b6e24a787bdb969$var$FormatNumericToParts;

});

parcelRegister("j8xDe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetUnsignedRoundingMode = void 0;
var $dee8da3e56457344$var$negativeMapping = {
    ceil: "zero",
    floor: "infinity",
    expand: "infinity",
    trunc: "zero",
    halfCeil: "half-zero",
    halfFloor: "half-infinity",
    halfExpand: "half-infinity",
    halfTrunc: "half-zero",
    halfEven: "half-even"
};
var $dee8da3e56457344$var$positiveMapping = {
    ceil: "infinity",
    floor: "zero",
    expand: "infinity",
    trunc: "zero",
    halfCeil: "half-infinity",
    halfFloor: "half-zero",
    halfExpand: "half-infinity",
    halfTrunc: "half-zero",
    halfEven: "half-even"
};
function $dee8da3e56457344$var$GetUnsignedRoundingMode(roundingMode, isNegative) {
    if (isNegative) return $dee8da3e56457344$var$negativeMapping[roundingMode];
    return $dee8da3e56457344$var$positiveMapping[roundingMode];
}
module.exports.GetUnsignedRoundingMode = $dee8da3e56457344$var$GetUnsignedRoundingMode;

});

parcelRegister("44hiI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InitializeNumberFormat = void 0;

var $gBJRg = parcelRequire("gBJRg");

var $gnSWw = parcelRequire("gnSWw");

var $5pFcL = parcelRequire("5pFcL");

var $d1Z6R = parcelRequire("d1Z6R");

var $6AsWx = parcelRequire("6AsWx");

var $fYlKC = parcelRequire("fYlKC");

var $04TLr = parcelRequire("04TLr");

var $3eW7k = parcelRequire("3eW7k");

var $4QfFh = parcelRequire("4QfFh");

var $gyNxt = parcelRequire("gyNxt");
var $2f64f4ba80427467$var$VALID_ROUND_INCREMENT_VALUES = [
    1,
    2,
    5,
    10,
    20,
    25,
    50,
    100,
    200,
    250,
    500,
    1000,
    2000
];
/**
 * https://tc39.es/ecma402/#sec-initializenumberformat
 */ function $2f64f4ba80427467$var$InitializeNumberFormat(nf, locales, opts, _a) {
    var getInternalSlots = _a.getInternalSlots, localeData = _a.localeData, availableLocales = _a.availableLocales, numberingSystemNames = _a.numberingSystemNames, getDefaultLocale = _a.getDefaultLocale, currencyDigitsData = _a.currencyDigitsData;
    // @ts-ignore
    var requestedLocales = (0, $gnSWw.CanonicalizeLocaleList)(locales);
    var options = (0, $5pFcL.CoerceOptionsToObject)(opts);
    var opt = Object.create(null);
    var matcher = (0, $6AsWx.GetOption)(options, "localeMatcher", "string", [
        "lookup",
        "best fit"
    ], "best fit");
    opt.localeMatcher = matcher;
    var numberingSystem = (0, $6AsWx.GetOption)(options, "numberingSystem", "string", undefined, undefined);
    if (numberingSystem !== undefined && numberingSystemNames.indexOf(numberingSystem) < 0) // 8.a. If numberingSystem does not match the Unicode Locale Identifier type nonterminal,
    // throw a RangeError exception.
    throw RangeError("Invalid numberingSystems: ".concat(numberingSystem));
    opt.nu = numberingSystem;
    var r = (0, $gBJRg.ResolveLocale)(Array.from(availableLocales), requestedLocales, opt, // [[RelevantExtensionKeys]] slot, which is a constant
    [
        "nu"
    ], localeData, getDefaultLocale);
    var dataLocaleData = localeData[r.dataLocale];
    (0, $04TLr.invariant)(!!dataLocaleData, "Missing locale data for ".concat(r.dataLocale));
    var internalSlots = getInternalSlots(nf);
    internalSlots.locale = r.locale;
    internalSlots.dataLocale = r.dataLocale;
    internalSlots.numberingSystem = r.nu;
    internalSlots.dataLocaleData = dataLocaleData;
    (0, $gyNxt.SetNumberFormatUnitOptions)(nf, options, {
        getInternalSlots: getInternalSlots
    });
    var style = internalSlots.style;
    var mnfdDefault;
    var mxfdDefault;
    if (style === "currency") {
        var currency = internalSlots.currency;
        var cDigits = (0, $3eW7k.CurrencyDigits)(currency, {
            currencyDigitsData: currencyDigitsData
        });
        mnfdDefault = cDigits;
        mxfdDefault = cDigits;
    } else {
        mnfdDefault = 0;
        mxfdDefault = style === "percent" ? 0 : 3;
    }
    var notation = (0, $6AsWx.GetOption)(options, "notation", "string", [
        "standard",
        "scientific",
        "engineering",
        "compact"
    ], "standard");
    internalSlots.notation = notation;
    (0, $4QfFh.SetNumberFormatDigitOptions)(internalSlots, options, mnfdDefault, mxfdDefault, notation);
    var roundingIncrement = (0, $d1Z6R.GetNumberOption)(options, "roundingIncrement", 1, 5000, 1);
    if ($2f64f4ba80427467$var$VALID_ROUND_INCREMENT_VALUES.indexOf(roundingIncrement) === -1) throw new RangeError("Invalid rounding increment value: ".concat(roundingIncrement, ".\nValid values are ").concat($2f64f4ba80427467$var$VALID_ROUND_INCREMENT_VALUES, "."));
    if (roundingIncrement !== 1 && internalSlots.roundingType !== "fractionDigits") throw new TypeError("For roundingIncrement > 1 only fractionDigits is a valid roundingType");
    if (roundingIncrement !== 1 && internalSlots.maximumFractionDigits !== internalSlots.minimumFractionDigits) throw new RangeError("With roundingIncrement > 1, maximumFractionDigits and minimumFractionDigits must be equal.");
    internalSlots.roundingIncrement = roundingIncrement;
    var trailingZeroDisplay = (0, $6AsWx.GetOption)(options, "trailingZeroDisplay", "string", [
        "auto",
        "stripIfInteger"
    ], "auto");
    internalSlots.trailingZeroDisplay = trailingZeroDisplay;
    var compactDisplay = (0, $6AsWx.GetOption)(options, "compactDisplay", "string", [
        "short",
        "long"
    ], "short");
    var defaultUseGrouping = "auto";
    if (notation === "compact") {
        internalSlots.compactDisplay = compactDisplay;
        defaultUseGrouping = "min2";
    }
    internalSlots.useGrouping = (0, $fYlKC.GetStringOrBooleanOption)(options, "useGrouping", [
        "min2",
        "auto",
        "always"
    ], "always", false, defaultUseGrouping);
    internalSlots.signDisplay = (0, $6AsWx.GetOption)(options, "signDisplay", "string", [
        "auto",
        "never",
        "always",
        "exceptZero",
        "negative"
    ], "auto");
    internalSlots.roundingMode = (0, $6AsWx.GetOption)(options, "roundingMode", "string", [
        "ceil",
        "floor",
        "expand",
        "trunc",
        "halfCeil",
        "halfFloor",
        "halfExpand",
        "halfTrunc",
        "halfEven"
    ], "halfExpand");
    return nf;
}
module.exports.InitializeNumberFormat = $2f64f4ba80427467$var$InitializeNumberFormat;

});
parcelRegister("gBJRg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResolveLocale = module.exports.LookupSupportedLocales = module.exports.match = void 0;

var $kmHl2 = parcelRequire("kmHl2");

var $1ybNy = parcelRequire("1ybNy");
function $c173ac8682e66319$var$match(requestedLocales, availableLocales, defaultLocale, opts) {
    return (0, $1ybNy.ResolveLocale)(availableLocales, (0, $kmHl2.CanonicalizeLocaleList)(requestedLocales), {
        localeMatcher: (opts === null || opts === void 0 ? void 0 : opts.algorithm) || "best fit"
    }, [], {}, function() {
        return defaultLocale;
    }).locale;
}
module.exports.match = $c173ac8682e66319$var$match;

var $l58xz = parcelRequire("l58xz");
Object.defineProperty(module.exports, "LookupSupportedLocales", {
    enumerable: true,
    get: function() {
        return $l58xz.LookupSupportedLocales;
    }
});

var $1ybNy = parcelRequire("1ybNy");
Object.defineProperty(module.exports, "ResolveLocale", {
    enumerable: true,
    get: function() {
        return $1ybNy.ResolveLocale;
    }
});

});
parcelRegister("kmHl2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CanonicalizeLocaleList = void 0;
/**
 * http://ecma-international.org/ecma-402/7.0/index.html#sec-canonicalizelocalelist
 * @param locales
 */ function $ed377ad1d80059fa$var$CanonicalizeLocaleList(locales) {
    // TODO
    return Intl.getCanonicalLocales(locales);
}
module.exports.CanonicalizeLocaleList = $ed377ad1d80059fa$var$CanonicalizeLocaleList;

});

parcelRegister("1ybNy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResolveLocale = void 0;

var $2iNvu = parcelRequire("2iNvu");

var $2Acuw = parcelRequire("2Acuw");

var $9eD8W = parcelRequire("9eD8W");

var $es3oN = parcelRequire("es3oN");
/**
 * https://tc39.es/ecma402/#sec-resolvelocale
 */ function $12121e54d8105d0c$var$ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData, getDefaultLocale) {
    var matcher = options.localeMatcher;
    var r;
    if (matcher === "lookup") r = (0, $2Acuw.LookupMatcher)(Array.from(availableLocales), requestedLocales, getDefaultLocale);
    else r = (0, $2iNvu.BestFitMatcher)(Array.from(availableLocales), requestedLocales, getDefaultLocale);
    var foundLocale = r.locale;
    var result = {
        locale: "",
        dataLocale: foundLocale
    };
    var supportedExtension = "-u";
    for(var _i = 0, relevantExtensionKeys_1 = relevantExtensionKeys; _i < relevantExtensionKeys_1.length; _i++){
        var key = relevantExtensionKeys_1[_i];
        (0, $es3oN.invariant)(foundLocale in localeData, "Missing locale data for ".concat(foundLocale));
        var foundLocaleData = localeData[foundLocale];
        (0, $es3oN.invariant)(typeof foundLocaleData === "object" && foundLocaleData !== null, "locale data ".concat(key, " must be an object"));
        var keyLocaleData = foundLocaleData[key];
        (0, $es3oN.invariant)(Array.isArray(keyLocaleData), "keyLocaleData for ".concat(key, " must be an array"));
        var value = keyLocaleData[0];
        (0, $es3oN.invariant)(typeof value === "string" || value === null, "value must be string or null but got ".concat(typeof value, " in key ").concat(key));
        var supportedExtensionAddition = "";
        if (r.extension) {
            var requestedValue = (0, $9eD8W.UnicodeExtensionValue)(r.extension, key);
            if (requestedValue !== undefined) {
                if (requestedValue !== "") {
                    if (~keyLocaleData.indexOf(requestedValue)) {
                        value = requestedValue;
                        supportedExtensionAddition = "-".concat(key, "-").concat(value);
                    }
                } else if (~requestedValue.indexOf("true")) {
                    value = "true";
                    supportedExtensionAddition = "-".concat(key);
                }
            }
        }
        if (key in options) {
            var optionsValue = options[key];
            (0, $es3oN.invariant)(typeof optionsValue === "string" || typeof optionsValue === "undefined" || optionsValue === null, "optionsValue must be String, Undefined or Null");
            if (~keyLocaleData.indexOf(optionsValue)) {
                if (optionsValue !== value) {
                    value = optionsValue;
                    supportedExtensionAddition = "";
                }
            }
        }
        result[key] = value;
        supportedExtension += supportedExtensionAddition;
    }
    if (supportedExtension.length > 2) {
        var privateIndex = foundLocale.indexOf("-x-");
        if (privateIndex === -1) foundLocale = foundLocale + supportedExtension;
        else {
            var preExtension = foundLocale.slice(0, privateIndex);
            var postExtension = foundLocale.slice(privateIndex, foundLocale.length);
            foundLocale = preExtension + supportedExtension + postExtension;
        }
        foundLocale = Intl.getCanonicalLocales(foundLocale)[0];
    }
    result.locale = foundLocale;
    return result;
}
module.exports.ResolveLocale = $12121e54d8105d0c$var$ResolveLocale;

});
parcelRegister("2iNvu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BestFitMatcher = void 0;

var $es3oN = parcelRequire("es3oN");
/**
 * https://tc39.es/ecma402/#sec-bestfitmatcher
 * @param availableLocales
 * @param requestedLocales
 * @param getDefaultLocale
 */ function $1ad3aa40b3aa617b$var$BestFitMatcher(availableLocales, requestedLocales, getDefaultLocale) {
    var foundLocale;
    var extension;
    for(var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++){
        var l = requestedLocales_1[_i];
        var matchedLocale = (0, $es3oN.findBestMatch)(l.replace($es3oN.UNICODE_EXTENSION_SEQUENCE_REGEX, ""), availableLocales);
        if (matchedLocale) {
            foundLocale = matchedLocale;
            var noExtensionLocale = l.replace($es3oN.UNICODE_EXTENSION_SEQUENCE_REGEX, "");
            extension = l.slice(noExtensionLocale.length, l.length) || undefined;
            break;
        }
    }
    if (!foundLocale) return {
        locale: getDefaultLocale()
    };
    return {
        locale: foundLocale,
        extension: extension
    };
}
module.exports.BestFitMatcher = $1ad3aa40b3aa617b$var$BestFitMatcher;

});
parcelRegister("es3oN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findBestMatch = module.exports.findMatchingDistance = module.exports.invariant = module.exports.UNICODE_EXTENSION_SEQUENCE_REGEX = void 0;

var $aVicc = parcelRequire("aVicc");

var $bEi65 = parcelRequire("bEi65");

var $iUNPO = parcelRequire("iUNPO");
module.exports.UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function $a856512a82fdfcf2$var$invariant(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
module.exports.invariant = $a856512a82fdfcf2$var$invariant;
// This is effectively 2 languages in 2 different regions not even in the same cluster
var $a856512a82fdfcf2$var$DEFAULT_MATCHING_THRESHOLD = 840;
var $a856512a82fdfcf2$var$PROCESSED_DATA;
function $a856512a82fdfcf2$var$processData() {
    var _a, _b;
    if (!$a856512a82fdfcf2$var$PROCESSED_DATA) {
        var paradigmLocales = (_b = (_a = $bEi65.data.supplemental.languageMatching["written-new"][0]) === null || _a === void 0 ? void 0 : _a.paradigmLocales) === null || _b === void 0 ? void 0 : _b._locales.split(" ");
        var matchVariables = $bEi65.data.supplemental.languageMatching["written-new"].slice(1, 5);
        var data = $bEi65.data.supplemental.languageMatching["written-new"].slice(5);
        var matches = data.map(function(d) {
            var key = Object.keys(d)[0];
            var value = d[key];
            return {
                supported: key,
                desired: value._desired,
                distance: +value._distance,
                oneway: value.oneway === "true" ? true : false
            };
        }, {});
        $a856512a82fdfcf2$var$PROCESSED_DATA = {
            matches: matches,
            matchVariables: matchVariables.reduce(function(all, d) {
                var key = Object.keys(d)[0];
                var value = d[key];
                all[key.slice(1)] = value._value.split("+");
                return all;
            }, {}),
            paradigmLocales: $aVicc.__spreadArray($aVicc.__spreadArray([], paradigmLocales, true), paradigmLocales.map(function(l) {
                return new Intl.Locale(l.replace(/_/g, "-")).maximize().toString();
            }), true)
        };
    }
    return $a856512a82fdfcf2$var$PROCESSED_DATA;
}
function $a856512a82fdfcf2$var$isMatched(locale, languageMatchInfoLocale, matchVariables) {
    var _a = languageMatchInfoLocale.split("-"), language = _a[0], script = _a[1], region = _a[2];
    var matches = true;
    if (region && region[0] === "$") {
        var shouldInclude = region[1] !== "!";
        var matchRegions = shouldInclude ? matchVariables[region.slice(1)] : matchVariables[region.slice(2)];
        var expandedMatchedRegions = matchRegions.map(function(r) {
            return $iUNPO.regions[r] || [
                r
            ];
        }).reduce(function(all, list) {
            return $aVicc.__spreadArray($aVicc.__spreadArray([], all, true), list, true);
        }, []);
        matches && (matches = !(expandedMatchedRegions.indexOf(locale.region || "") > 1 != shouldInclude));
    } else matches && (matches = locale.region ? region === "*" || region === locale.region : true);
    matches && (matches = locale.script ? script === "*" || script === locale.script : true);
    matches && (matches = locale.language ? language === "*" || language === locale.language : true);
    return matches;
}
function $a856512a82fdfcf2$var$serializeLSR(lsr) {
    return [
        lsr.language,
        lsr.script,
        lsr.region
    ].filter(Boolean).join("-");
}
function $a856512a82fdfcf2$var$findMatchingDistanceForLSR(desired, supported, data) {
    for(var _i = 0, _a = data.matches; _i < _a.length; _i++){
        var d = _a[_i];
        var matches = $a856512a82fdfcf2$var$isMatched(desired, d.desired, data.matchVariables) && $a856512a82fdfcf2$var$isMatched(supported, d.supported, data.matchVariables);
        if (!d.oneway && !matches) matches = $a856512a82fdfcf2$var$isMatched(desired, d.supported, data.matchVariables) && $a856512a82fdfcf2$var$isMatched(supported, d.desired, data.matchVariables);
        if (matches) {
            var distance = d.distance * 10;
            if (data.paradigmLocales.indexOf($a856512a82fdfcf2$var$serializeLSR(desired)) > -1 != data.paradigmLocales.indexOf($a856512a82fdfcf2$var$serializeLSR(supported)) > -1) return distance - 1;
            return distance;
        }
    }
    throw new Error("No matching distance found");
}
function $a856512a82fdfcf2$var$findMatchingDistance(desired, supported) {
    var desiredLocale = new Intl.Locale(desired).maximize();
    var supportedLocale = new Intl.Locale(supported).maximize();
    var desiredLSR = {
        language: desiredLocale.language,
        script: desiredLocale.script || "",
        region: desiredLocale.region || ""
    };
    var supportedLSR = {
        language: supportedLocale.language,
        script: supportedLocale.script || "",
        region: supportedLocale.region || ""
    };
    var matchingDistance = 0;
    var data = $a856512a82fdfcf2$var$processData();
    if (desiredLSR.language !== supportedLSR.language) matchingDistance += $a856512a82fdfcf2$var$findMatchingDistanceForLSR({
        language: desiredLocale.language,
        script: "",
        region: ""
    }, {
        language: supportedLocale.language,
        script: "",
        region: ""
    }, data);
    if (desiredLSR.script !== supportedLSR.script) matchingDistance += $a856512a82fdfcf2$var$findMatchingDistanceForLSR({
        language: desiredLocale.language,
        script: desiredLSR.script,
        region: ""
    }, {
        language: supportedLocale.language,
        script: desiredLSR.script,
        region: ""
    }, data);
    if (desiredLSR.region !== supportedLSR.region) matchingDistance += $a856512a82fdfcf2$var$findMatchingDistanceForLSR(desiredLSR, supportedLSR, data);
    return matchingDistance;
}
module.exports.findMatchingDistance = $a856512a82fdfcf2$var$findMatchingDistance;
function $a856512a82fdfcf2$var$findBestMatch(desired, supportedLocales, threshold) {
    if (threshold === void 0) threshold = $a856512a82fdfcf2$var$DEFAULT_MATCHING_THRESHOLD;
    var bestMatch = undefined;
    var lowestDistance = Infinity;
    supportedLocales.forEach(function(supported, i) {
        // Add some weight to the distance based on the order of the supported locales
        var distance = $a856512a82fdfcf2$var$findMatchingDistance(desired, supported) + i;
        if (distance < lowestDistance) {
            lowestDistance = distance;
            bestMatch = supported;
        }
    });
    if (lowestDistance >= threshold) return;
    return bestMatch;
}
module.exports.findBestMatch = $a856512a82fdfcf2$var$findBestMatch;

});
parcelRegister("bEi65", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.data = void 0;
module.exports.data = {
    supplemental: {
        languageMatching: {
            "written-new": [
                {
                    paradigmLocales: {
                        _locales: "en en_GB es es_419 pt_BR pt_PT"
                    }
                },
                {
                    $enUS: {
                        _value: "AS+CA+GU+MH+MP+PH+PR+UM+US+VI"
                    }
                },
                {
                    $cnsar: {
                        _value: "HK+MO"
                    }
                },
                {
                    $americas: {
                        _value: "019"
                    }
                },
                {
                    $maghreb: {
                        _value: "MA+DZ+TN+LY+MR+EH"
                    }
                },
                {
                    no: {
                        _desired: "nb",
                        _distance: "1"
                    }
                },
                {
                    bs: {
                        _desired: "hr",
                        _distance: "4"
                    }
                },
                {
                    bs: {
                        _desired: "sh",
                        _distance: "4"
                    }
                },
                {
                    hr: {
                        _desired: "sh",
                        _distance: "4"
                    }
                },
                {
                    sr: {
                        _desired: "sh",
                        _distance: "4"
                    }
                },
                {
                    aa: {
                        _desired: "ssy",
                        _distance: "4"
                    }
                },
                {
                    de: {
                        _desired: "gsw",
                        _distance: "4",
                        _oneway: "true"
                    }
                },
                {
                    de: {
                        _desired: "lb",
                        _distance: "4",
                        _oneway: "true"
                    }
                },
                {
                    no: {
                        _desired: "da",
                        _distance: "8"
                    }
                },
                {
                    nb: {
                        _desired: "da",
                        _distance: "8"
                    }
                },
                {
                    ru: {
                        _desired: "ab",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ach",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    nl: {
                        _desired: "af",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ak",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "am",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "ay",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "az",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ur: {
                        _desired: "bal",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "be",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "bem",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "bh",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "bn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "bo",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "br",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "ca",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    fil: {
                        _desired: "ceb",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "chr",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ckb",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "co",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "crs",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    sk: {
                        _desired: "cs",
                        _distance: "20"
                    }
                },
                {
                    en: {
                        _desired: "cy",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ee",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "eo",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "eu",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    da: {
                        _desired: "fo",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    nl: {
                        _desired: "fy",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ga",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "gaa",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "gd",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "gl",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "gn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "gu",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ha",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "haw",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "ht",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "hy",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ia",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ig",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "is",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    id: {
                        _desired: "jv",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ka",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "kg",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "kk",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "km",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "kn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "kri",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    tr: {
                        _desired: "ku",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "ky",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    it: {
                        _desired: "la",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "lg",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "ln",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "lo",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "loz",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "lua",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "mai",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "mfe",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "mg",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "mi",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ml",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "mn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "mr",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    id: {
                        _desired: "ms",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "mt",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "my",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ne",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    nb: {
                        _desired: "nn",
                        _distance: "20"
                    }
                },
                {
                    no: {
                        _desired: "nn",
                        _distance: "20"
                    }
                },
                {
                    en: {
                        _desired: "nso",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ny",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "nyn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "oc",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "om",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "or",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "pa",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "pcm",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ps",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    es: {
                        _desired: "qu",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    de: {
                        _desired: "rm",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "rn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "rw",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    hi: {
                        _desired: "sa",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "sd",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "si",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "sn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "so",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "sq",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "st",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    id: {
                        _desired: "su",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "sw",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ta",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "te",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "tg",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ti",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "tk",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "tlh",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "tn",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "to",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "tt",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "tum",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "ug",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "uk",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "ur",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ru: {
                        _desired: "uz",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    fr: {
                        _desired: "wo",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "xh",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "yi",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "yo",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "za",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    en: {
                        _desired: "zu",
                        _distance: "30",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "aao",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "abh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "abv",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acx",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "acy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "adf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "aeb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "aec",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "afb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ajp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "apc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "apd",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "arq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ars",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ary",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "arz",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "auz",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "avl",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ayh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ayl",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ayn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ayp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "bbz",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "pga",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "shu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ar: {
                        _desired: "ssh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    az: {
                        _desired: "azb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    et: {
                        _desired: "vro",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "ffm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fub",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fue",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fuf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fuh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fui",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fuq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ff: {
                        _desired: "fuv",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    gn: {
                        _desired: "gnw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    gn: {
                        _desired: "gui",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    gn: {
                        _desired: "gun",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    gn: {
                        _desired: "nhd",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    iu: {
                        _desired: "ikt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "enb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "eyo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "niq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "oki",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "pko",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "sgc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "tec",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kln: {
                        _desired: "tuy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kok: {
                        _desired: "gom",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    kpe: {
                        _desired: "gkp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "ida",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lkb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lko",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lks",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lri",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lrm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lsm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lto",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lts",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "lwg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "nle",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "nyd",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    luy: {
                        _desired: "rag",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    lv: {
                        _desired: "ltg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "bhr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "bjq",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "bmm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "bzc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "msh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "skg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "tdx",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "tkg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "txy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "xmv",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mg: {
                        _desired: "xmw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    mn: {
                        _desired: "mvf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "bjn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "btj",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "bve",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "bvu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "coa",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "dup",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "hji",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "id",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "jak",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "jax",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "kvb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "kvr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "kxd",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "lce",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "lcf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "liw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "max",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "meo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "mfa",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "mfb",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "min",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "mqg",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "msi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "mui",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "orn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "ors",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "pel",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "pse",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "tmw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "urk",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "vkk",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "vkt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "xmm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "zlm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ms: {
                        _desired: "zmi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ne: {
                        _desired: "dty",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    om: {
                        _desired: "gax",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    om: {
                        _desired: "hae",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    om: {
                        _desired: "orc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    or: {
                        _desired: "spv",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ps: {
                        _desired: "pbt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    ps: {
                        _desired: "pst",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qub",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qud",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quf",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qug",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quk",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qul",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qup",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qur",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qus",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qux",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "quy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qva",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qve",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvj",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvl",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvm",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvs",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qvz",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qwa",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qwc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qwh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qws",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxa",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxl",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    qu: {
                        _desired: "qxw",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sc: {
                        _desired: "sdc",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sc: {
                        _desired: "sdn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sc: {
                        _desired: "sro",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sq: {
                        _desired: "aae",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sq: {
                        _desired: "aat",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    sq: {
                        _desired: "aln",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    syr: {
                        _desired: "aii",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    uz: {
                        _desired: "uzs",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    yi: {
                        _desired: "yih",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "cdo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "cjy",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "cpx",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "czh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "czo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "gan",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "hak",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "hsn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "lzh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "mnp",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "nan",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "wuu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    zh: {
                        _desired: "yue",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "*": {
                        _desired: "*",
                        _distance: "80"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "am-Ethi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "ru-Cyrl": {
                        _desired: "az-Latn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "bn-Beng",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "zh-Hans": {
                        _desired: "bo-Tibt",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "ru-Cyrl": {
                        _desired: "hy-Armn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ka-Geor",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "km-Khmr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "kn-Knda",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "lo-Laoo",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ml-Mlym",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "my-Mymr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ne-Deva",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "or-Orya",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "pa-Guru",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ps-Arab",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "sd-Arab",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "si-Sinh",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ta-Taml",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "te-Telu",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ti-Ethi",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "ru-Cyrl": {
                        _desired: "tk-Latn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "ur-Arab",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "ru-Cyrl": {
                        _desired: "uz-Latn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "en-Latn": {
                        _desired: "yi-Hebr",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "sr-Cyrl": {
                        _desired: "sr-Latn",
                        _distance: "5"
                    }
                },
                {
                    "zh-Hans": {
                        _desired: "za-Latn",
                        _distance: "10",
                        _oneway: "true"
                    }
                },
                {
                    "zh-Hans": {
                        _desired: "zh-Hani",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "zh-Hant": {
                        _desired: "zh-Hani",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "ar-Arab": {
                        _desired: "ar-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "bn-Beng": {
                        _desired: "bn-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "gu-Gujr": {
                        _desired: "gu-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "hi-Deva": {
                        _desired: "hi-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "kn-Knda": {
                        _desired: "kn-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "ml-Mlym": {
                        _desired: "ml-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "mr-Deva": {
                        _desired: "mr-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "ta-Taml": {
                        _desired: "ta-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "te-Telu": {
                        _desired: "te-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "zh-Hans": {
                        _desired: "zh-Latn",
                        _distance: "20",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Latn",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Hani",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Hira",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Kana",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Jpan": {
                        _desired: "ja-Hrkt",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Hrkt": {
                        _desired: "ja-Hira",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ja-Hrkt": {
                        _desired: "ja-Kana",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ko-Kore": {
                        _desired: "ko-Hani",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ko-Kore": {
                        _desired: "ko-Hang",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ko-Kore": {
                        _desired: "ko-Jamo",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "ko-Hang": {
                        _desired: "ko-Jamo",
                        _distance: "5",
                        _oneway: "true"
                    }
                },
                {
                    "*-*": {
                        _desired: "*-*",
                        _distance: "50"
                    }
                },
                {
                    "ar-*-$maghreb": {
                        _desired: "ar-*-$maghreb",
                        _distance: "4"
                    }
                },
                {
                    "ar-*-$!maghreb": {
                        _desired: "ar-*-$!maghreb",
                        _distance: "4"
                    }
                },
                {
                    "ar-*-*": {
                        _desired: "ar-*-*",
                        _distance: "5"
                    }
                },
                {
                    "en-*-$enUS": {
                        _desired: "en-*-$enUS",
                        _distance: "4"
                    }
                },
                {
                    "en-*-GB": {
                        _desired: "en-*-$!enUS",
                        _distance: "3"
                    }
                },
                {
                    "en-*-$!enUS": {
                        _desired: "en-*-$!enUS",
                        _distance: "4"
                    }
                },
                {
                    "en-*-*": {
                        _desired: "en-*-*",
                        _distance: "5"
                    }
                },
                {
                    "es-*-$americas": {
                        _desired: "es-*-$americas",
                        _distance: "4"
                    }
                },
                {
                    "es-*-$!americas": {
                        _desired: "es-*-$!americas",
                        _distance: "4"
                    }
                },
                {
                    "es-*-*": {
                        _desired: "es-*-*",
                        _distance: "5"
                    }
                },
                {
                    "pt-*-$americas": {
                        _desired: "pt-*-$americas",
                        _distance: "4"
                    }
                },
                {
                    "pt-*-$!americas": {
                        _desired: "pt-*-$!americas",
                        _distance: "4"
                    }
                },
                {
                    "pt-*-*": {
                        _desired: "pt-*-*",
                        _distance: "5"
                    }
                },
                {
                    "zh-Hant-$cnsar": {
                        _desired: "zh-Hant-$cnsar",
                        _distance: "4"
                    }
                },
                {
                    "zh-Hant-$!cnsar": {
                        _desired: "zh-Hant-$!cnsar",
                        _distance: "4"
                    }
                },
                {
                    "zh-Hant-*": {
                        _desired: "zh-Hant-*",
                        _distance: "5"
                    }
                },
                {
                    "*-*-*": {
                        _desired: "*-*-*",
                        _distance: "4"
                    }
                }
            ]
        }
    }
};

});

parcelRegister("iUNPO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.regions = void 0;
// This file is generated from regions-gen.ts
module.exports.regions = {
    "001": [
        "001",
        "001-status-grouping",
        "002",
        "005",
        "009",
        "011",
        "013",
        "014",
        "015",
        "017",
        "018",
        "019",
        "021",
        "029",
        "030",
        "034",
        "035",
        "039",
        "053",
        "054",
        "057",
        "061",
        "142",
        "143",
        "145",
        "150",
        "151",
        "154",
        "155",
        "AC",
        "AD",
        "AE",
        "AF",
        "AG",
        "AI",
        "AL",
        "AM",
        "AO",
        "AQ",
        "AR",
        "AS",
        "AT",
        "AU",
        "AW",
        "AX",
        "AZ",
        "BA",
        "BB",
        "BD",
        "BE",
        "BF",
        "BG",
        "BH",
        "BI",
        "BJ",
        "BL",
        "BM",
        "BN",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BT",
        "BV",
        "BW",
        "BY",
        "BZ",
        "CA",
        "CC",
        "CD",
        "CF",
        "CG",
        "CH",
        "CI",
        "CK",
        "CL",
        "CM",
        "CN",
        "CO",
        "CP",
        "CQ",
        "CR",
        "CU",
        "CV",
        "CW",
        "CX",
        "CY",
        "CZ",
        "DE",
        "DG",
        "DJ",
        "DK",
        "DM",
        "DO",
        "DZ",
        "EA",
        "EC",
        "EE",
        "EG",
        "EH",
        "ER",
        "ES",
        "ET",
        "EU",
        "EZ",
        "FI",
        "FJ",
        "FK",
        "FM",
        "FO",
        "FR",
        "GA",
        "GB",
        "GD",
        "GE",
        "GF",
        "GG",
        "GH",
        "GI",
        "GL",
        "GM",
        "GN",
        "GP",
        "GQ",
        "GR",
        "GS",
        "GT",
        "GU",
        "GW",
        "GY",
        "HK",
        "HM",
        "HN",
        "HR",
        "HT",
        "HU",
        "IC",
        "ID",
        "IE",
        "IL",
        "IM",
        "IN",
        "IO",
        "IQ",
        "IR",
        "IS",
        "IT",
        "JE",
        "JM",
        "JO",
        "JP",
        "KE",
        "KG",
        "KH",
        "KI",
        "KM",
        "KN",
        "KP",
        "KR",
        "KW",
        "KY",
        "KZ",
        "LA",
        "LB",
        "LC",
        "LI",
        "LK",
        "LR",
        "LS",
        "LT",
        "LU",
        "LV",
        "LY",
        "MA",
        "MC",
        "MD",
        "ME",
        "MF",
        "MG",
        "MH",
        "MK",
        "ML",
        "MM",
        "MN",
        "MO",
        "MP",
        "MQ",
        "MR",
        "MS",
        "MT",
        "MU",
        "MV",
        "MW",
        "MX",
        "MY",
        "MZ",
        "NA",
        "NC",
        "NE",
        "NF",
        "NG",
        "NI",
        "NL",
        "NO",
        "NP",
        "NR",
        "NU",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PF",
        "PG",
        "PH",
        "PK",
        "PL",
        "PM",
        "PN",
        "PR",
        "PS",
        "PT",
        "PW",
        "PY",
        "QA",
        "QO",
        "RE",
        "RO",
        "RS",
        "RU",
        "RW",
        "SA",
        "SB",
        "SC",
        "SD",
        "SE",
        "SG",
        "SH",
        "SI",
        "SJ",
        "SK",
        "SL",
        "SM",
        "SN",
        "SO",
        "SR",
        "SS",
        "ST",
        "SV",
        "SX",
        "SY",
        "SZ",
        "TA",
        "TC",
        "TD",
        "TF",
        "TG",
        "TH",
        "TJ",
        "TK",
        "TL",
        "TM",
        "TN",
        "TO",
        "TR",
        "TT",
        "TV",
        "TW",
        "TZ",
        "UA",
        "UG",
        "UM",
        "UN",
        "US",
        "UY",
        "UZ",
        "VA",
        "VC",
        "VE",
        "VG",
        "VI",
        "VN",
        "VU",
        "WF",
        "WS",
        "XK",
        "YE",
        "YT",
        "ZA",
        "ZM",
        "ZW"
    ],
    "002": [
        "002",
        "002-status-grouping",
        "011",
        "014",
        "015",
        "017",
        "018",
        "202",
        "AO",
        "BF",
        "BI",
        "BJ",
        "BW",
        "CD",
        "CF",
        "CG",
        "CI",
        "CM",
        "CV",
        "DJ",
        "DZ",
        "EA",
        "EG",
        "EH",
        "ER",
        "ET",
        "GA",
        "GH",
        "GM",
        "GN",
        "GQ",
        "GW",
        "IC",
        "IO",
        "KE",
        "KM",
        "LR",
        "LS",
        "LY",
        "MA",
        "MG",
        "ML",
        "MR",
        "MU",
        "MW",
        "MZ",
        "NA",
        "NE",
        "NG",
        "RE",
        "RW",
        "SC",
        "SD",
        "SH",
        "SL",
        "SN",
        "SO",
        "SS",
        "ST",
        "SZ",
        "TD",
        "TF",
        "TG",
        "TN",
        "TZ",
        "UG",
        "YT",
        "ZA",
        "ZM",
        "ZW"
    ],
    "003": [
        "003",
        "013",
        "021",
        "029",
        "AG",
        "AI",
        "AW",
        "BB",
        "BL",
        "BM",
        "BQ",
        "BS",
        "BZ",
        "CA",
        "CR",
        "CU",
        "CW",
        "DM",
        "DO",
        "GD",
        "GL",
        "GP",
        "GT",
        "HN",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "MX",
        "NI",
        "PA",
        "PM",
        "PR",
        "SV",
        "SX",
        "TC",
        "TT",
        "US",
        "VC",
        "VG",
        "VI"
    ],
    "005": [
        "005",
        "AR",
        "BO",
        "BR",
        "BV",
        "CL",
        "CO",
        "EC",
        "FK",
        "GF",
        "GS",
        "GY",
        "PE",
        "PY",
        "SR",
        "UY",
        "VE"
    ],
    "009": [
        "009",
        "053",
        "054",
        "057",
        "061",
        "AC",
        "AQ",
        "AS",
        "AU",
        "CC",
        "CK",
        "CP",
        "CX",
        "DG",
        "FJ",
        "FM",
        "GU",
        "HM",
        "KI",
        "MH",
        "MP",
        "NC",
        "NF",
        "NR",
        "NU",
        "NZ",
        "PF",
        "PG",
        "PN",
        "PW",
        "QO",
        "SB",
        "TA",
        "TK",
        "TO",
        "TV",
        "UM",
        "VU",
        "WF",
        "WS"
    ],
    "011": [
        "011",
        "BF",
        "BJ",
        "CI",
        "CV",
        "GH",
        "GM",
        "GN",
        "GW",
        "LR",
        "ML",
        "MR",
        "NE",
        "NG",
        "SH",
        "SL",
        "SN",
        "TG"
    ],
    "013": [
        "013",
        "BZ",
        "CR",
        "GT",
        "HN",
        "MX",
        "NI",
        "PA",
        "SV"
    ],
    "014": [
        "014",
        "BI",
        "DJ",
        "ER",
        "ET",
        "IO",
        "KE",
        "KM",
        "MG",
        "MU",
        "MW",
        "MZ",
        "RE",
        "RW",
        "SC",
        "SO",
        "SS",
        "TF",
        "TZ",
        "UG",
        "YT",
        "ZM",
        "ZW"
    ],
    "015": [
        "015",
        "DZ",
        "EA",
        "EG",
        "EH",
        "IC",
        "LY",
        "MA",
        "SD",
        "TN"
    ],
    "017": [
        "017",
        "AO",
        "CD",
        "CF",
        "CG",
        "CM",
        "GA",
        "GQ",
        "ST",
        "TD"
    ],
    "018": [
        "018",
        "BW",
        "LS",
        "NA",
        "SZ",
        "ZA"
    ],
    "019": [
        "003",
        "005",
        "013",
        "019",
        "019-status-grouping",
        "021",
        "029",
        "419",
        "AG",
        "AI",
        "AR",
        "AW",
        "BB",
        "BL",
        "BM",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BV",
        "BZ",
        "CA",
        "CL",
        "CO",
        "CR",
        "CU",
        "CW",
        "DM",
        "DO",
        "EC",
        "FK",
        "GD",
        "GF",
        "GL",
        "GP",
        "GS",
        "GT",
        "GY",
        "HN",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "MX",
        "NI",
        "PA",
        "PE",
        "PM",
        "PR",
        "PY",
        "SR",
        "SV",
        "SX",
        "TC",
        "TT",
        "US",
        "UY",
        "VC",
        "VE",
        "VG",
        "VI"
    ],
    "021": [
        "021",
        "BM",
        "CA",
        "GL",
        "PM",
        "US"
    ],
    "029": [
        "029",
        "AG",
        "AI",
        "AW",
        "BB",
        "BL",
        "BQ",
        "BS",
        "CU",
        "CW",
        "DM",
        "DO",
        "GD",
        "GP",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "PR",
        "SX",
        "TC",
        "TT",
        "VC",
        "VG",
        "VI"
    ],
    "030": [
        "030",
        "CN",
        "HK",
        "JP",
        "KP",
        "KR",
        "MN",
        "MO",
        "TW"
    ],
    "034": [
        "034",
        "AF",
        "BD",
        "BT",
        "IN",
        "IR",
        "LK",
        "MV",
        "NP",
        "PK"
    ],
    "035": [
        "035",
        "BN",
        "ID",
        "KH",
        "LA",
        "MM",
        "MY",
        "PH",
        "SG",
        "TH",
        "TL",
        "VN"
    ],
    "039": [
        "039",
        "AD",
        "AL",
        "BA",
        "ES",
        "GI",
        "GR",
        "HR",
        "IT",
        "ME",
        "MK",
        "MT",
        "PT",
        "RS",
        "SI",
        "SM",
        "VA",
        "XK"
    ],
    "053": [
        "053",
        "AU",
        "CC",
        "CX",
        "HM",
        "NF",
        "NZ"
    ],
    "054": [
        "054",
        "FJ",
        "NC",
        "PG",
        "SB",
        "VU"
    ],
    "057": [
        "057",
        "FM",
        "GU",
        "KI",
        "MH",
        "MP",
        "NR",
        "PW",
        "UM"
    ],
    "061": [
        "061",
        "AS",
        "CK",
        "NU",
        "PF",
        "PN",
        "TK",
        "TO",
        "TV",
        "WF",
        "WS"
    ],
    "142": [
        "030",
        "034",
        "035",
        "142",
        "143",
        "145",
        "AE",
        "AF",
        "AM",
        "AZ",
        "BD",
        "BH",
        "BN",
        "BT",
        "CN",
        "CY",
        "GE",
        "HK",
        "ID",
        "IL",
        "IN",
        "IQ",
        "IR",
        "JO",
        "JP",
        "KG",
        "KH",
        "KP",
        "KR",
        "KW",
        "KZ",
        "LA",
        "LB",
        "LK",
        "MM",
        "MN",
        "MO",
        "MV",
        "MY",
        "NP",
        "OM",
        "PH",
        "PK",
        "PS",
        "QA",
        "SA",
        "SG",
        "SY",
        "TH",
        "TJ",
        "TL",
        "TM",
        "TR",
        "TW",
        "UZ",
        "VN",
        "YE"
    ],
    "143": [
        "143",
        "KG",
        "KZ",
        "TJ",
        "TM",
        "UZ"
    ],
    "145": [
        "145",
        "AE",
        "AM",
        "AZ",
        "BH",
        "CY",
        "GE",
        "IL",
        "IQ",
        "JO",
        "KW",
        "LB",
        "OM",
        "PS",
        "QA",
        "SA",
        "SY",
        "TR",
        "YE"
    ],
    "150": [
        "039",
        "150",
        "151",
        "154",
        "155",
        "AD",
        "AL",
        "AT",
        "AX",
        "BA",
        "BE",
        "BG",
        "BY",
        "CH",
        "CQ",
        "CZ",
        "DE",
        "DK",
        "EE",
        "ES",
        "FI",
        "FO",
        "FR",
        "GB",
        "GG",
        "GI",
        "GR",
        "HR",
        "HU",
        "IE",
        "IM",
        "IS",
        "IT",
        "JE",
        "LI",
        "LT",
        "LU",
        "LV",
        "MC",
        "MD",
        "ME",
        "MK",
        "MT",
        "NL",
        "NO",
        "PL",
        "PT",
        "RO",
        "RS",
        "RU",
        "SE",
        "SI",
        "SJ",
        "SK",
        "SM",
        "UA",
        "VA",
        "XK"
    ],
    "151": [
        "151",
        "BG",
        "BY",
        "CZ",
        "HU",
        "MD",
        "PL",
        "RO",
        "RU",
        "SK",
        "UA"
    ],
    "154": [
        "154",
        "AX",
        "CQ",
        "DK",
        "EE",
        "FI",
        "FO",
        "GB",
        "GG",
        "IE",
        "IM",
        "IS",
        "JE",
        "LT",
        "LV",
        "NO",
        "SE",
        "SJ"
    ],
    "155": [
        "155",
        "AT",
        "BE",
        "CH",
        "DE",
        "FR",
        "LI",
        "LU",
        "MC",
        "NL"
    ],
    "202": [
        "011",
        "014",
        "017",
        "018",
        "202",
        "AO",
        "BF",
        "BI",
        "BJ",
        "BW",
        "CD",
        "CF",
        "CG",
        "CI",
        "CM",
        "CV",
        "DJ",
        "ER",
        "ET",
        "GA",
        "GH",
        "GM",
        "GN",
        "GQ",
        "GW",
        "IO",
        "KE",
        "KM",
        "LR",
        "LS",
        "MG",
        "ML",
        "MR",
        "MU",
        "MW",
        "MZ",
        "NA",
        "NE",
        "NG",
        "RE",
        "RW",
        "SC",
        "SH",
        "SL",
        "SN",
        "SO",
        "SS",
        "ST",
        "SZ",
        "TD",
        "TF",
        "TG",
        "TZ",
        "UG",
        "YT",
        "ZA",
        "ZM",
        "ZW"
    ],
    "419": [
        "005",
        "013",
        "029",
        "419",
        "AG",
        "AI",
        "AR",
        "AW",
        "BB",
        "BL",
        "BO",
        "BQ",
        "BR",
        "BS",
        "BV",
        "BZ",
        "CL",
        "CO",
        "CR",
        "CU",
        "CW",
        "DM",
        "DO",
        "EC",
        "FK",
        "GD",
        "GF",
        "GP",
        "GS",
        "GT",
        "GY",
        "HN",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "MX",
        "NI",
        "PA",
        "PE",
        "PR",
        "PY",
        "SR",
        "SV",
        "SX",
        "TC",
        "TT",
        "UY",
        "VC",
        "VE",
        "VG",
        "VI"
    ],
    "EU": [
        "AT",
        "BE",
        "BG",
        "CY",
        "CZ",
        "DE",
        "DK",
        "EE",
        "ES",
        "EU",
        "FI",
        "FR",
        "GR",
        "HR",
        "HU",
        "IE",
        "IT",
        "LT",
        "LU",
        "LV",
        "MT",
        "NL",
        "PL",
        "PT",
        "RO",
        "SE",
        "SI",
        "SK"
    ],
    "EZ": [
        "AT",
        "BE",
        "CY",
        "DE",
        "EE",
        "ES",
        "EZ",
        "FI",
        "FR",
        "GR",
        "IE",
        "IT",
        "LT",
        "LU",
        "LV",
        "MT",
        "NL",
        "PT",
        "SI",
        "SK"
    ],
    "QO": [
        "AC",
        "AQ",
        "CP",
        "DG",
        "QO",
        "TA"
    ],
    "UN": [
        "AD",
        "AE",
        "AF",
        "AG",
        "AL",
        "AM",
        "AO",
        "AR",
        "AT",
        "AU",
        "AZ",
        "BA",
        "BB",
        "BD",
        "BE",
        "BF",
        "BG",
        "BH",
        "BI",
        "BJ",
        "BN",
        "BO",
        "BR",
        "BS",
        "BT",
        "BW",
        "BY",
        "BZ",
        "CA",
        "CD",
        "CF",
        "CG",
        "CH",
        "CI",
        "CL",
        "CM",
        "CN",
        "CO",
        "CR",
        "CU",
        "CV",
        "CY",
        "CZ",
        "DE",
        "DJ",
        "DK",
        "DM",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ER",
        "ES",
        "ET",
        "FI",
        "FJ",
        "FM",
        "FR",
        "GA",
        "GB",
        "GD",
        "GE",
        "GH",
        "GM",
        "GN",
        "GQ",
        "GR",
        "GT",
        "GW",
        "GY",
        "HN",
        "HR",
        "HT",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IQ",
        "IR",
        "IS",
        "IT",
        "JM",
        "JO",
        "JP",
        "KE",
        "KG",
        "KH",
        "KI",
        "KM",
        "KN",
        "KP",
        "KR",
        "KW",
        "KZ",
        "LA",
        "LB",
        "LC",
        "LI",
        "LK",
        "LR",
        "LS",
        "LT",
        "LU",
        "LV",
        "LY",
        "MA",
        "MC",
        "MD",
        "ME",
        "MG",
        "MH",
        "MK",
        "ML",
        "MM",
        "MN",
        "MR",
        "MT",
        "MU",
        "MV",
        "MW",
        "MX",
        "MY",
        "MZ",
        "NA",
        "NE",
        "NG",
        "NI",
        "NL",
        "NO",
        "NP",
        "NR",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PG",
        "PH",
        "PK",
        "PL",
        "PT",
        "PW",
        "PY",
        "QA",
        "RO",
        "RS",
        "RU",
        "RW",
        "SA",
        "SB",
        "SC",
        "SD",
        "SE",
        "SG",
        "SI",
        "SK",
        "SL",
        "SM",
        "SN",
        "SO",
        "SR",
        "SS",
        "ST",
        "SV",
        "SY",
        "SZ",
        "TD",
        "TG",
        "TH",
        "TJ",
        "TL",
        "TM",
        "TN",
        "TO",
        "TR",
        "TT",
        "TV",
        "TZ",
        "UA",
        "UG",
        "UN",
        "US",
        "UY",
        "UZ",
        "VC",
        "VE",
        "VN",
        "VU",
        "WS",
        "YE",
        "ZA",
        "ZM",
        "ZW"
    ]
};

});



parcelRegister("2Acuw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LookupMatcher = void 0;

var $eTjQL = parcelRequire("eTjQL");

var $es3oN = parcelRequire("es3oN");
/**
 * https://tc39.es/ecma402/#sec-lookupmatcher
 * @param availableLocales
 * @param requestedLocales
 * @param getDefaultLocale
 */ function $1e18a20f7b971e30$var$LookupMatcher(availableLocales, requestedLocales, getDefaultLocale) {
    var result = {
        locale: ""
    };
    for(var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++){
        var locale = requestedLocales_1[_i];
        var noExtensionLocale = locale.replace($es3oN.UNICODE_EXTENSION_SEQUENCE_REGEX, "");
        var availableLocale = (0, $eTjQL.BestAvailableLocale)(availableLocales, noExtensionLocale);
        if (availableLocale) {
            result.locale = availableLocale;
            if (locale !== noExtensionLocale) result.extension = locale.slice(noExtensionLocale.length, locale.length);
            return result;
        }
    }
    result.locale = getDefaultLocale();
    return result;
}
module.exports.LookupMatcher = $1e18a20f7b971e30$var$LookupMatcher;

});
parcelRegister("eTjQL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BestAvailableLocale = void 0;
/**
 * https://tc39.es/ecma402/#sec-bestavailablelocale
 * @param availableLocales
 * @param locale
 */ function $ad759986b82a11f9$var$BestAvailableLocale(availableLocales, locale) {
    var candidate = locale;
    while(true){
        if (availableLocales.indexOf(candidate) > -1) return candidate;
        var pos = candidate.lastIndexOf("-");
        if (!~pos) return undefined;
        if (pos >= 2 && candidate[pos - 2] === "-") pos -= 2;
        candidate = candidate.slice(0, pos);
    }
}
module.exports.BestAvailableLocale = $ad759986b82a11f9$var$BestAvailableLocale;

});


parcelRegister("9eD8W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnicodeExtensionValue = void 0;

var $es3oN = parcelRequire("es3oN");
/**
 * https://tc39.es/ecma402/#sec-unicodeextensionvalue
 * @param extension
 * @param key
 */ function $6b93c8e2d2148612$var$UnicodeExtensionValue(extension, key) {
    (0, $es3oN.invariant)(key.length === 2, "key must have 2 elements");
    var size = extension.length;
    var searchValue = "-".concat(key, "-");
    var pos = extension.indexOf(searchValue);
    if (pos !== -1) {
        var start = pos + 4;
        var end = start;
        var k = start;
        var done = false;
        while(!done){
            var e = extension.indexOf("-", k);
            var len = void 0;
            if (e === -1) len = size - k;
            else len = e - k;
            if (len === 2) done = true;
            else if (e === -1) {
                end = size;
                done = true;
            } else {
                end = e;
                k = e + 1;
            }
        }
        return extension.slice(start, end);
    }
    searchValue = "-".concat(key);
    pos = extension.indexOf(searchValue);
    if (pos !== -1 && pos + 3 === size) return "";
    return undefined;
}
module.exports.UnicodeExtensionValue = $6b93c8e2d2148612$var$UnicodeExtensionValue;

});


parcelRegister("l58xz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LookupSupportedLocales = void 0;

var $eTjQL = parcelRequire("eTjQL");

var $es3oN = parcelRequire("es3oN");
/**
 * https://tc39.es/ecma402/#sec-lookupsupportedlocales
 * @param availableLocales
 * @param requestedLocales
 */ function $f590b08aee70b120$var$LookupSupportedLocales(availableLocales, requestedLocales) {
    var subset = [];
    for(var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++){
        var locale = requestedLocales_1[_i];
        var noExtensionLocale = locale.replace($es3oN.UNICODE_EXTENSION_SEQUENCE_REGEX, "");
        var availableLocale = (0, $eTjQL.BestAvailableLocale)(availableLocales, noExtensionLocale);
        if (availableLocale) subset.push(availableLocale);
    }
    return subset;
}
module.exports.LookupSupportedLocales = $f590b08aee70b120$var$LookupSupportedLocales;

});


parcelRegister("4QfFh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetNumberFormatDigitOptions = void 0;

var $d1Z6R = parcelRequire("d1Z6R");

var $5c7IE = parcelRequire("5c7IE");

var $6AsWx = parcelRequire("6AsWx");
/**
 * https://tc39.es/ecma402/#sec-setnfdigitoptions
 */ function $38682b74b23b3044$var$SetNumberFormatDigitOptions(internalSlots, opts, mnfdDefault, mxfdDefault, notation) {
    var mnid = (0, $d1Z6R.GetNumberOption)(opts, "minimumIntegerDigits", 1, 21, 1);
    var mnfd = opts.minimumFractionDigits;
    var mxfd = opts.maximumFractionDigits;
    var mnsd = opts.minimumSignificantDigits;
    var mxsd = opts.maximumSignificantDigits;
    internalSlots.minimumIntegerDigits = mnid;
    var roundingPriority = (0, $6AsWx.GetOption)(opts, "roundingPriority", "string", [
        "auto",
        "morePrecision",
        "lessPrecision"
    ], "auto");
    var hasSd = mnsd !== undefined || mxsd !== undefined;
    var hasFd = mnfd !== undefined || mxfd !== undefined;
    var needSd = true;
    var needFd = true;
    if (roundingPriority === "auto") {
        needSd = hasSd;
        if (hasSd || !hasFd && notation === "compact") needFd = false;
    }
    if (needSd) {
        if (hasSd) {
            mnsd = (0, $5c7IE.DefaultNumberOption)(mnsd, 1, 21, 1);
            mxsd = (0, $5c7IE.DefaultNumberOption)(mxsd, mnsd, 21, 21);
            internalSlots.minimumSignificantDigits = mnsd;
            internalSlots.maximumSignificantDigits = mxsd;
        } else {
            internalSlots.minimumSignificantDigits = 1;
            internalSlots.maximumSignificantDigits = 21;
        }
    }
    if (needFd) {
        if (hasFd) {
            // @ts-expect-error
            mnfd = (0, $5c7IE.DefaultNumberOption)(mnfd, 0, 20, undefined);
            // @ts-expect-error
            mxfd = (0, $5c7IE.DefaultNumberOption)(mxfd, 0, 20, undefined);
            if (mnfd === undefined) mnfd = Math.min(mnfdDefault, mxfd);
            else if (mxfd === undefined) mxfd = Math.max(mxfdDefault, mnfd);
            else if (mnfd > mxfd) throw new RangeError("Invalid range, ".concat(mnfd, " > ").concat(mxfd));
            internalSlots.minimumFractionDigits = mnfd;
            internalSlots.maximumFractionDigits = mxfd;
        } else {
            internalSlots.minimumFractionDigits = mnfdDefault;
            internalSlots.maximumFractionDigits = mxfdDefault;
        }
    }
    if (needSd || needFd) {
        if (roundingPriority === "morePrecision") internalSlots.roundingType = "morePrecision";
        else if (roundingPriority === "lessPrecision") internalSlots.roundingType = "lessPrecision";
        else if (hasSd) internalSlots.roundingType = "significantDigits";
        else internalSlots.roundingType = "fractionDigits";
    } else {
        internalSlots.roundingType = "morePrecision";
        internalSlots.minimumFractionDigits = 0;
        internalSlots.maximumFractionDigits = 0;
        internalSlots.minimumSignificantDigits = 1;
        internalSlots.maximumSignificantDigits = 2;
    }
}
module.exports.SetNumberFormatDigitOptions = $38682b74b23b3044$var$SetNumberFormatDigitOptions;

});

parcelRegister("gyNxt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetNumberFormatUnitOptions = void 0;

var $6AsWx = parcelRequire("6AsWx");

var $hQjmw = parcelRequire("hQjmw");

var $kiREC = parcelRequire("kiREC");
/**
 * https://tc39.es/ecma402/#sec-setnumberformatunitoptions
 */ function $031c7ce5ed140608$var$SetNumberFormatUnitOptions(nf, options, _a) {
    if (options === void 0) options = Object.create(null);
    var getInternalSlots = _a.getInternalSlots;
    var internalSlots = getInternalSlots(nf);
    var style = (0, $6AsWx.GetOption)(options, "style", "string", [
        "decimal",
        "percent",
        "currency",
        "unit"
    ], "decimal");
    internalSlots.style = style;
    var currency = (0, $6AsWx.GetOption)(options, "currency", "string", undefined, undefined);
    if (currency !== undefined && !(0, $hQjmw.IsWellFormedCurrencyCode)(currency)) throw RangeError("Malformed currency code");
    if (style === "currency" && currency === undefined) throw TypeError("currency cannot be undefined");
    var currencyDisplay = (0, $6AsWx.GetOption)(options, "currencyDisplay", "string", [
        "code",
        "symbol",
        "narrowSymbol",
        "name"
    ], "symbol");
    var currencySign = (0, $6AsWx.GetOption)(options, "currencySign", "string", [
        "standard",
        "accounting"
    ], "standard");
    var unit = (0, $6AsWx.GetOption)(options, "unit", "string", undefined, undefined);
    if (unit !== undefined && !(0, $kiREC.IsWellFormedUnitIdentifier)(unit)) throw RangeError("Invalid unit argument for Intl.NumberFormat()");
    if (style === "unit" && unit === undefined) throw TypeError("unit cannot be undefined");
    var unitDisplay = (0, $6AsWx.GetOption)(options, "unitDisplay", "string", [
        "short",
        "narrow",
        "long"
    ], "short");
    if (style === "currency") {
        internalSlots.currency = currency.toUpperCase();
        internalSlots.currencyDisplay = currencyDisplay;
        internalSlots.currencySign = currencySign;
    }
    if (style === "unit") {
        internalSlots.unit = unit;
        internalSlots.unitDisplay = unitDisplay;
    }
}
module.exports.SetNumberFormatUnitOptions = $031c7ce5ed140608$var$SetNumberFormatUnitOptions;

});


parcelRegister("eBuJh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PartitionPattern = void 0;

var $04TLr = parcelRequire("04TLr");
/**
 * https://tc39.es/ecma402/#sec-partitionpattern
 * @param pattern
 */ function $02be6492f9fabd52$var$PartitionPattern(pattern) {
    var result = [];
    var beginIndex = pattern.indexOf("{");
    var endIndex = 0;
    var nextIndex = 0;
    var length = pattern.length;
    while(beginIndex < pattern.length && beginIndex > -1){
        endIndex = pattern.indexOf("}", beginIndex);
        (0, $04TLr.invariant)(endIndex > beginIndex, "Invalid pattern ".concat(pattern));
        if (beginIndex > nextIndex) result.push({
            type: "literal",
            value: pattern.substring(nextIndex, beginIndex)
        });
        result.push({
            type: pattern.substring(beginIndex + 1, endIndex),
            value: undefined
        });
        nextIndex = endIndex + 1;
        beginIndex = pattern.indexOf("{", nextIndex);
    }
    if (nextIndex < length) result.push({
        type: "literal",
        value: pattern.substring(nextIndex, length)
    });
    return result;
}
module.exports.PartitionPattern = $02be6492f9fabd52$var$PartitionPattern;

});

parcelRegister("gcfxj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SupportedLocales = void 0;

var $gBJRg = parcelRequire("gBJRg");

var $cwnVA = parcelRequire("cwnVA");

var $6AsWx = parcelRequire("6AsWx");
/**
 * https://tc39.es/ecma402/#sec-supportedlocales
 * @param availableLocales
 * @param requestedLocales
 * @param options
 */ function $bca9d17d7b621af6$var$SupportedLocales(availableLocales, requestedLocales, options) {
    var matcher = "best fit";
    if (options !== undefined) {
        options = (0, $cwnVA.ToObject)(options);
        matcher = (0, $6AsWx.GetOption)(options, "localeMatcher", "string", [
            "lookup",
            "best fit"
        ], "best fit");
    }
    if (matcher === "best fit") return (0, $gBJRg.LookupSupportedLocales)(Array.from(availableLocales), requestedLocales);
    return (0, $gBJRg.LookupSupportedLocales)(Array.from(availableLocales), requestedLocales);
}
module.exports.SupportedLocales = $bca9d17d7b621af6$var$SupportedLocales;

});

parcelRegister("cErMV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMissingLocaleDataError = void 0;

var $aVicc = parcelRequire("aVicc");
var $935ec6a0a93d345d$var$MissingLocaleDataError = /** @class */ function(_super) {
    $aVicc.__extends(MissingLocaleDataError, _super);
    function MissingLocaleDataError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "MISSING_LOCALE_DATA";
        return _this;
    }
    return MissingLocaleDataError;
}(Error);
function $935ec6a0a93d345d$var$isMissingLocaleDataError(e) {
    return e.type === "MISSING_LOCALE_DATA";
}
module.exports.isMissingLocaleDataError = $935ec6a0a93d345d$var$isMissingLocaleDataError;

});

parcelRegister("1gXBJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3ceq9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RangePatternType = void 0;
var $253dadc038a3ff19$var$RangePatternType;
(function(RangePatternType) {
    RangePatternType["startRange"] = "startRange";
    RangePatternType["shared"] = "shared";
    RangePatternType["endRange"] = "endRange";
})($253dadc038a3ff19$var$RangePatternType || (module.exports.RangePatternType = $253dadc038a3ff19$var$RangePatternType = {}));

});

parcelRegister("9CY2y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dWkzC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cxmoU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2WuaN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("stxzp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createIntl = module.exports.formatNumberToParts = module.exports.formatNumber = module.exports.formatRelativeTime = module.exports.formatPlural = module.exports.formatList = module.exports.formatDisplayName = module.exports.formatTimeToParts = module.exports.formatTime = module.exports.formatDateToParts = module.exports.formatDate = module.exports.formatMessage = module.exports.getNamedFormat = module.exports.createFormatters = module.exports.DEFAULT_INTL_CONFIG = module.exports.filterProps = module.exports.createIntlCache = module.exports.defineMessage = module.exports.defineMessages = void 0;

var $aVicc = parcelRequire("aVicc");

$aVicc.__exportStar((parcelRequire("iNdjJ")), module.exports);
function $055987c230dff1f1$var$defineMessages(msgs) {
    return msgs;
}
module.exports.defineMessages = $055987c230dff1f1$var$defineMessages;
function $055987c230dff1f1$var$defineMessage(msg) {
    return msg;
}
module.exports.defineMessage = $055987c230dff1f1$var$defineMessage;

var $k3SeL = parcelRequire("k3SeL");
Object.defineProperty(module.exports, "createIntlCache", {
    enumerable: true,
    get: function() {
        return $k3SeL.createIntlCache;
    }
});
Object.defineProperty(module.exports, "filterProps", {
    enumerable: true,
    get: function() {
        return $k3SeL.filterProps;
    }
});
Object.defineProperty(module.exports, "DEFAULT_INTL_CONFIG", {
    enumerable: true,
    get: function() {
        return $k3SeL.DEFAULT_INTL_CONFIG;
    }
});
Object.defineProperty(module.exports, "createFormatters", {
    enumerable: true,
    get: function() {
        return $k3SeL.createFormatters;
    }
});
Object.defineProperty(module.exports, "getNamedFormat", {
    enumerable: true,
    get: function() {
        return $k3SeL.getNamedFormat;
    }
});

$aVicc.__exportStar((parcelRequire("jmw3j")), module.exports);

var $i9vHe = parcelRequire("i9vHe");
Object.defineProperty(module.exports, "formatMessage", {
    enumerable: true,
    get: function() {
        return $i9vHe.formatMessage;
    }
});

var $69Dp0 = parcelRequire("69Dp0");
Object.defineProperty(module.exports, "formatDate", {
    enumerable: true,
    get: function() {
        return $69Dp0.formatDate;
    }
});
Object.defineProperty(module.exports, "formatDateToParts", {
    enumerable: true,
    get: function() {
        return $69Dp0.formatDateToParts;
    }
});
Object.defineProperty(module.exports, "formatTime", {
    enumerable: true,
    get: function() {
        return $69Dp0.formatTime;
    }
});
Object.defineProperty(module.exports, "formatTimeToParts", {
    enumerable: true,
    get: function() {
        return $69Dp0.formatTimeToParts;
    }
});

var $dP7Wn = parcelRequire("dP7Wn");
Object.defineProperty(module.exports, "formatDisplayName", {
    enumerable: true,
    get: function() {
        return $dP7Wn.formatDisplayName;
    }
});

var $23bPf = parcelRequire("23bPf");
Object.defineProperty(module.exports, "formatList", {
    enumerable: true,
    get: function() {
        return $23bPf.formatList;
    }
});

var $4nIH0 = parcelRequire("4nIH0");
Object.defineProperty(module.exports, "formatPlural", {
    enumerable: true,
    get: function() {
        return $4nIH0.formatPlural;
    }
});

var $k0qbT = parcelRequire("k0qbT");
Object.defineProperty(module.exports, "formatRelativeTime", {
    enumerable: true,
    get: function() {
        return $k0qbT.formatRelativeTime;
    }
});

var $djBw9 = parcelRequire("djBw9");
Object.defineProperty(module.exports, "formatNumber", {
    enumerable: true,
    get: function() {
        return $djBw9.formatNumber;
    }
});
Object.defineProperty(module.exports, "formatNumberToParts", {
    enumerable: true,
    get: function() {
        return $djBw9.formatNumberToParts;
    }
});

var $aMxdT = parcelRequire("aMxdT");
Object.defineProperty(module.exports, "createIntl", {
    enumerable: true,
    get: function() {
        return $aMxdT.createIntl;
    }
});

});
parcelRegister("iNdjJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("k3SeL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getNamedFormat = module.exports.createFormatters = module.exports.createIntlCache = module.exports.DEFAULT_INTL_CONFIG = module.exports.filterProps = void 0;

var $aVicc = parcelRequire("aVicc");

var $hAlbz = parcelRequire("hAlbz");

var $jORks = parcelRequire("jORks");

var $jmw3j = parcelRequire("jmw3j");
function $e9ae28d120ca783e$var$filterProps(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
module.exports.filterProps = $e9ae28d120ca783e$var$filterProps;
var $e9ae28d120ca783e$var$defaultErrorHandler = function(error) {};
var $e9ae28d120ca783e$var$defaultWarnHandler = function(warning) {};
module.exports.DEFAULT_INTL_CONFIG = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $e9ae28d120ca783e$var$defaultErrorHandler,
    onWarn: $e9ae28d120ca783e$var$defaultWarnHandler
};
function $e9ae28d120ca783e$var$createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
module.exports.createIntlCache = $e9ae28d120ca783e$var$createIntlCache;
function $e9ae28d120ca783e$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
/**
 * Create intl formatters and populate cache
 * @param cache explicit cache to prevent leaking memory
 */ function $e9ae28d120ca783e$var$createFormatters(cache) {
    if (cache === void 0) cache = $e9ae28d120ca783e$var$createIntlCache();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $jORks.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, $aVicc.__spreadArray([
            void 0
        ], args, false)))();
    }, {
        cache: $e9ae28d120ca783e$var$createFastMemoizeCache(cache.dateTime),
        strategy: $jORks.strategies.variadic
    });
    var getNumberFormat = (0, $jORks.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, $aVicc.__spreadArray([
            void 0
        ], args, false)))();
    }, {
        cache: $e9ae28d120ca783e$var$createFastMemoizeCache(cache.number),
        strategy: $jORks.strategies.variadic
    });
    var getPluralRules = (0, $jORks.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, $aVicc.__spreadArray([
            void 0
        ], args, false)))();
    }, {
        cache: $e9ae28d120ca783e$var$createFastMemoizeCache(cache.pluralRules),
        strategy: $jORks.strategies.variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $jORks.memoize)(function(message, locales, overrideFormats, opts) {
            return new $hAlbz.IntlMessageFormat(message, locales, overrideFormats, $aVicc.__assign({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $e9ae28d120ca783e$var$createFastMemoizeCache(cache.message),
            strategy: $jORks.strategies.variadic
        }),
        getRelativeTimeFormat: (0, $jORks.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, $aVicc.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $e9ae28d120ca783e$var$createFastMemoizeCache(cache.relativeTime),
            strategy: $jORks.strategies.variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $jORks.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, $aVicc.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $e9ae28d120ca783e$var$createFastMemoizeCache(cache.list),
            strategy: $jORks.strategies.variadic
        }),
        getDisplayNames: (0, $jORks.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, $aVicc.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $e9ae28d120ca783e$var$createFastMemoizeCache(cache.displayNames),
            strategy: $jORks.strategies.variadic
        })
    };
}
module.exports.createFormatters = $e9ae28d120ca783e$var$createFormatters;
function $e9ae28d120ca783e$var$getNamedFormat(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new $jmw3j.UnsupportedFormatterError("No ".concat(type, " format named: ").concat(name)));
}
module.exports.getNamedFormat = $e9ae28d120ca783e$var$getNamedFormat;

});
parcelRegister("hAlbz", function(module, exports) {
"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aVicc = parcelRequire("aVicc");


$aVicc.__exportStar((parcelRequire("aA3Qo")), module.exports);

$aVicc.__exportStar((parcelRequire("7Ta3A")), module.exports);

$aVicc.__exportStar((parcelRequire("at5AZ")), module.exports);
module.exports.default = (parcelRequire("7Ta3A")).IntlMessageFormat;

});
parcelRegister("7Ta3A", function(module, exports) {
"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntlMessageFormat = void 0;

var $aVicc = parcelRequire("aVicc");

var $dlyQF = parcelRequire("dlyQF");

var $jORks = parcelRequire("jORks");

var $aA3Qo = parcelRequire("aA3Qo");
// -- MessageFormat --------------------------------------------------------
function $5be578858afef90a$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return $aVicc.__assign($aVicc.__assign($aVicc.__assign({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = $aVicc.__assign($aVicc.__assign({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $5be578858afef90a$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $5be578858afef90a$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, $aVicc.__assign({}, defaultConfig));
}
function $5be578858afef90a$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $5be578858afef90a$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $jORks.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, $aVicc.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $5be578858afef90a$var$createFastMemoizeCache(cache.number),
            strategy: $jORks.strategies.variadic
        }),
        getDateTimeFormat: (0, $jORks.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, $aVicc.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $5be578858afef90a$var$createFastMemoizeCache(cache.dateTime),
            strategy: $jORks.strategies.variadic
        }),
        getPluralRules: (0, $jORks.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, $aVicc.__spreadArray([
                void 0
            ], args, false)))();
        }, {
            cache: $5be578858afef90a$var$createFastMemoizeCache(cache.pluralRules),
            strategy: $jORks.strategies.variadic
        })
    };
}
var $5be578858afef90a$var$IntlMessageFormat = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== $aA3Qo.PART_TYPE.literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $aA3Qo.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            var _a = opts || {}, formatters = _a.formatters, parseOpts = $aVicc.__rest(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, $aVicc.__assign($aVicc.__assign({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $5be578858afef90a$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $5be578858afef90a$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === "undefined") return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = $dlyQF.parse;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();
module.exports.IntlMessageFormat = $5be578858afef90a$var$IntlMessageFormat;

});
parcelRegister("dlyQF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._Parser = module.exports.parse = void 0;

var $aVicc = parcelRequire("aVicc");

var $jMnXV = parcelRequire("jMnXV");

var $7gVaZ = parcelRequire("7gVaZ");

function $9b7844b38b776e18$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, (parcelRequire("6pyuE")).isSelectElement)(el) || (0, (parcelRequire("6pyuE")).isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $9b7844b38b776e18$var$pruneLocation(el.options[k].value);
        }
        else if ((0, (parcelRequire("6pyuE")).isNumberElement)(el) && (0, (parcelRequire("6pyuE")).isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, (parcelRequire("6pyuE")).isDateElement)(el) || (0, (parcelRequire("6pyuE")).isTimeElement)(el)) && (0, (parcelRequire("6pyuE")).isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, (parcelRequire("6pyuE")).isTagElement)(el)) $9b7844b38b776e18$var$pruneLocation(el.children);
    });
}
function $9b7844b38b776e18$var$parse(message, opts) {
    if (opts === void 0) opts = {};
    opts = $aVicc.__assign({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new $7gVaZ.Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError($jMnXV.ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $9b7844b38b776e18$var$pruneLocation(result.val);
    return result.val;
}
module.exports.parse = $9b7844b38b776e18$var$parse;

$aVicc.__exportStar((parcelRequire("6pyuE")), module.exports);
// only for testing
module.exports._Parser = $7gVaZ.Parser;

});
parcelRegister("jMnXV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorKind = void 0;
var $e66517100f2b485b$var$ErrorKind;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($e66517100f2b485b$var$ErrorKind || (module.exports.ErrorKind = $e66517100f2b485b$var$ErrorKind = {}));

});

parcelRegister("7gVaZ", function(module, exports) {
"use strict";
var $54b6610c68deccbd$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Parser = void 0;

var $aVicc = parcelRequire("aVicc");

var $jMnXV = parcelRequire("jMnXV");

var $6pyuE = parcelRequire("6pyuE");

var $c07zA = parcelRequire("c07zA");

var $kevq9 = parcelRequire("kevq9");

var $6ctJx = parcelRequire("6ctJx");
var $54b6610c68deccbd$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat($c07zA.SPACE_SEPARATOR_REGEX.source, "*"));
var $54b6610c68deccbd$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat($c07zA.SPACE_SEPARATOR_REGEX.source, "*$"));
function $54b6610c68deccbd$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $54b6610c68deccbd$var$hasNativeStartsWith = !!String.prototype.startsWith && "_a".startsWith("a", 1);
var $54b6610c68deccbd$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $54b6610c68deccbd$var$hasNativeFromEntries = !!Object.fromEntries;
var $54b6610c68deccbd$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $54b6610c68deccbd$var$hasTrimStart = !!String.prototype.trimStart;
var $54b6610c68deccbd$var$hasTrimEnd = !!String.prototype.trimEnd;
var $54b6610c68deccbd$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $54b6610c68deccbd$var$isSafeInteger = $54b6610c68deccbd$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $54b6610c68deccbd$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $54b6610c68deccbd$var$re = $54b6610c68deccbd$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $54b6610c68deccbd$var$REGEX_SUPPORTS_U_AND_Y = (($54b6610c68deccbd$var$_a = $54b6610c68deccbd$var$re.exec("a")) === null || $54b6610c68deccbd$var$_a === void 0 ? void 0 : $54b6610c68deccbd$var$_a[0]) === "a";
} catch (_) {
    $54b6610c68deccbd$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $54b6610c68deccbd$var$startsWith = $54b6610c68deccbd$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $54b6610c68deccbd$var$fromCodePoint = $54b6610c68deccbd$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $54b6610c68deccbd$var$fromEntries = // native
$54b6610c68deccbd$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $54b6610c68deccbd$var$codePointAt = $54b6610c68deccbd$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $54b6610c68deccbd$var$trimStart = $54b6610c68deccbd$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($54b6610c68deccbd$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $54b6610c68deccbd$var$trimEnd = $54b6610c68deccbd$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($54b6610c68deccbd$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $54b6610c68deccbd$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $54b6610c68deccbd$var$matchIdentifierAtIndex;
if ($54b6610c68deccbd$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $54b6610c68deccbd$var$IDENTIFIER_PREFIX_RE_1 = $54b6610c68deccbd$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $54b6610c68deccbd$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $54b6610c68deccbd$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $54b6610c68deccbd$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$54b6610c68deccbd$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $54b6610c68deccbd$var$codePointAt(s, index);
        if (c === undefined || $54b6610c68deccbd$var$_isWhiteSpace(c) || $54b6610c68deccbd$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $54b6610c68deccbd$var$fromCodePoint.apply(void 0, match);
};
var $54b6610c68deccbd$var$Parser = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: $6pyuE.TYPE.pound,
                    location: $54b6610c68deccbd$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error($jMnXV.ErrorKind.UNMATCHED_CLOSING_TAG, $54b6610c68deccbd$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $54b6610c68deccbd$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: $6pyuE.TYPE.literal,
                value: "<".concat(tagName, "/>"),
                location: $54b6610c68deccbd$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$54b6610c68deccbd$var$_isAlpha(this.char())) return this.error($jMnXV.ErrorKind.INVALID_TAG, $54b6610c68deccbd$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error($jMnXV.ErrorKind.UNMATCHED_CLOSING_TAG, $54b6610c68deccbd$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error($jMnXV.ErrorKind.INVALID_TAG, $54b6610c68deccbd$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: $6pyuE.TYPE.tag,
                        value: tagName,
                        children: children,
                        location: $54b6610c68deccbd$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error($jMnXV.ErrorKind.UNCLOSED_TAG, $54b6610c68deccbd$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error($jMnXV.ErrorKind.INVALID_TAG, $54b6610c68deccbd$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $54b6610c68deccbd$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $54b6610c68deccbd$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: $6pyuE.TYPE.literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$54b6610c68deccbd$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $54b6610c68deccbd$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $54b6610c68deccbd$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error($jMnXV.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, $54b6610c68deccbd$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error($jMnXV.ErrorKind.EMPTY_ARGUMENT, $54b6610c68deccbd$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error($jMnXV.ErrorKind.MALFORMED_ARGUMENT, $54b6610c68deccbd$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error($jMnXV.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, $54b6610c68deccbd$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: $6pyuE.TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $54b6610c68deccbd$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error($jMnXV.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, $54b6610c68deccbd$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error($jMnXV.ErrorKind.MALFORMED_ARGUMENT, $54b6610c68deccbd$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $54b6610c68deccbd$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $54b6610c68deccbd$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error($jMnXV.ErrorKind.EXPECT_ARGUMENT_TYPE, $54b6610c68deccbd$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $54b6610c68deccbd$var$trimEnd(result.val);
                    if (style.length === 0) return this.error($jMnXV.ErrorKind.EXPECT_ARGUMENT_STYLE, $54b6610c68deccbd$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $54b6610c68deccbd$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $54b6610c68deccbd$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $54b6610c68deccbd$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $54b6610c68deccbd$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: $6pyuE.TYPE.number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error($jMnXV.ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $6ctJx.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: $6pyuE.SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $kevq9.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? $6pyuE.TYPE.date : $6pyuE.TYPE.time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? $6pyuE.TYPE.number : argType === "date" ? $6pyuE.TYPE.date : $6pyuE.TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error($jMnXV.ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, $54b6610c68deccbd$var$createLocation(typeEndPosition_1, $aVicc.__assign({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error($jMnXV.ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $54b6610c68deccbd$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger($jMnXV.ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $jMnXV.ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $54b6610c68deccbd$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: $6pyuE.TYPE.select,
                        value: value,
                        options: $54b6610c68deccbd$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: $6pyuE.TYPE.plural,
                        value: value,
                        options: $54b6610c68deccbd$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error($jMnXV.ErrorKind.INVALID_ARGUMENT_TYPE, $54b6610c68deccbd$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error($jMnXV.ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, $54b6610c68deccbd$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error($jMnXV.ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $54b6610c68deccbd$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $kevq9.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error($jMnXV.ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: $6pyuE.SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $kevq9.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger($jMnXV.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, $jMnXV.ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $54b6610c68deccbd$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? $jMnXV.ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR : $jMnXV.ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? $jMnXV.ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : $jMnXV.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $54b6610c68deccbd$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $54b6610c68deccbd$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? $jMnXV.ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR : $jMnXV.ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, $54b6610c68deccbd$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error($jMnXV.ErrorKind.MISSING_OTHER_CLAUSE, $54b6610c68deccbd$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $54b6610c68deccbd$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$54b6610c68deccbd$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $54b6610c68deccbd$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($54b6610c68deccbd$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $54b6610c68deccbd$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
module.exports.Parser = $54b6610c68deccbd$var$Parser;
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $54b6610c68deccbd$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $54b6610c68deccbd$var$_isAlphaOrSlash(codepoint) {
    return $54b6610c68deccbd$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $54b6610c68deccbd$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $54b6610c68deccbd$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $54b6610c68deccbd$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("6pyuE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createNumberElement = module.exports.createLiteralElement = module.exports.isDateTimeSkeleton = module.exports.isNumberSkeleton = module.exports.isTagElement = module.exports.isPoundElement = module.exports.isPluralElement = module.exports.isSelectElement = module.exports.isTimeElement = module.exports.isDateElement = module.exports.isNumberElement = module.exports.isArgumentElement = module.exports.isLiteralElement = module.exports.SKELETON_TYPE = module.exports.TYPE = void 0;
var $4aafd590d8920652$var$TYPE;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($4aafd590d8920652$var$TYPE || (module.exports.TYPE = $4aafd590d8920652$var$TYPE = {}));
var $4aafd590d8920652$var$SKELETON_TYPE;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($4aafd590d8920652$var$SKELETON_TYPE || (module.exports.SKELETON_TYPE = $4aafd590d8920652$var$SKELETON_TYPE = {}));
/**
 * Type Guards
 */ function $4aafd590d8920652$var$isLiteralElement(el) {
    return el.type === $4aafd590d8920652$var$TYPE.literal;
}
module.exports.isLiteralElement = $4aafd590d8920652$var$isLiteralElement;
function $4aafd590d8920652$var$isArgumentElement(el) {
    return el.type === $4aafd590d8920652$var$TYPE.argument;
}
module.exports.isArgumentElement = $4aafd590d8920652$var$isArgumentElement;
function $4aafd590d8920652$var$isNumberElement(el) {
    return el.type === $4aafd590d8920652$var$TYPE.number;
}
module.exports.isNumberElement = $4aafd590d8920652$var$isNumberElement;
function $4aafd590d8920652$var$isDateElement(el) {
    return el.type === $4aafd590d8920652$var$TYPE.date;
}
module.exports.isDateElement = $4aafd590d8920652$var$isDateElement;
function $4aafd590d8920652$var$isTimeElement(el) {
    return el.type === $4aafd590d8920652$var$TYPE.time;
}
module.exports.isTimeElement = $4aafd590d8920652$var$isTimeElement;
function $4aafd590d8920652$var$isSelectElement(el) {
    return el.type === $4aafd590d8920652$var$TYPE.select;
}
module.exports.isSelectElement = $4aafd590d8920652$var$isSelectElement;
function $4aafd590d8920652$var$isPluralElement(el) {
    return el.type === $4aafd590d8920652$var$TYPE.plural;
}
module.exports.isPluralElement = $4aafd590d8920652$var$isPluralElement;
function $4aafd590d8920652$var$isPoundElement(el) {
    return el.type === $4aafd590d8920652$var$TYPE.pound;
}
module.exports.isPoundElement = $4aafd590d8920652$var$isPoundElement;
function $4aafd590d8920652$var$isTagElement(el) {
    return el.type === $4aafd590d8920652$var$TYPE.tag;
}
module.exports.isTagElement = $4aafd590d8920652$var$isTagElement;
function $4aafd590d8920652$var$isNumberSkeleton(el) {
    return !!(el && typeof el === "object" && el.type === $4aafd590d8920652$var$SKELETON_TYPE.number);
}
module.exports.isNumberSkeleton = $4aafd590d8920652$var$isNumberSkeleton;
function $4aafd590d8920652$var$isDateTimeSkeleton(el) {
    return !!(el && typeof el === "object" && el.type === $4aafd590d8920652$var$SKELETON_TYPE.dateTime);
}
module.exports.isDateTimeSkeleton = $4aafd590d8920652$var$isDateTimeSkeleton;
function $4aafd590d8920652$var$createLiteralElement(value) {
    return {
        type: $4aafd590d8920652$var$TYPE.literal,
        value: value
    };
}
module.exports.createLiteralElement = $4aafd590d8920652$var$createLiteralElement;
function $4aafd590d8920652$var$createNumberElement(value, style) {
    return {
        type: $4aafd590d8920652$var$TYPE.number,
        value: value,
        style: style
    };
}
module.exports.createNumberElement = $4aafd590d8920652$var$createNumberElement;

});

parcelRegister("c07zA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WHITE_SPACE_REGEX = module.exports.SPACE_SEPARATOR_REGEX = void 0;
// @generated from regex-gen.ts
module.exports.SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
module.exports.WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("kevq9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aVicc = parcelRequire("aVicc");

$aVicc.__exportStar((parcelRequire("34iMF")), module.exports);

$aVicc.__exportStar((parcelRequire("6RbMH")), module.exports);

});
parcelRegister("34iMF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseDateTimeSkeleton = void 0;
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $23c050edbd63f201$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */ function $23c050edbd63f201$var$parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace($23c050edbd63f201$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}
module.exports.parseDateTimeSkeleton = $23c050edbd63f201$var$parseDateTimeSkeleton;

});

parcelRegister("6RbMH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseNumberSkeleton = module.exports.parseNumberSkeletonFromString = void 0;

var $aVicc = parcelRequire("aVicc");

var $3NuSJ = parcelRequire("3NuSJ");
function $4fe0d5764665f8a7$var$parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split($3NuSJ.WHITE_SPACE_REGEX).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
module.exports.parseNumberSkeletonFromString = $4fe0d5764665f8a7$var$parseNumberSkeletonFromString;
function $4fe0d5764665f8a7$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $4fe0d5764665f8a7$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $4fe0d5764665f8a7$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $4fe0d5764665f8a7$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $4fe0d5764665f8a7$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $4fe0d5764665f8a7$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($4fe0d5764665f8a7$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $4fe0d5764665f8a7$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $4fe0d5764665f8a7$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$4fe0d5764665f8a7$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $4fe0d5764665f8a7$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $4fe0d5764665f8a7$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */ function $4fe0d5764665f8a7$var$parseNumberSkeleton(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $4fe0d5764665f8a7$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = $aVicc.__assign($aVicc.__assign($aVicc.__assign({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return $aVicc.__assign($aVicc.__assign({}, all), $4fe0d5764665f8a7$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = $aVicc.__assign($aVicc.__assign($aVicc.__assign({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return $aVicc.__assign($aVicc.__assign({}, all), $4fe0d5764665f8a7$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($4fe0d5764665f8a7$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($4fe0d5764665f8a7$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($4fe0d5764665f8a7$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($4fe0d5764665f8a7$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = $aVicc.__assign($aVicc.__assign({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = $aVicc.__assign($aVicc.__assign({}, result), $4fe0d5764665f8a7$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($4fe0d5764665f8a7$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = $aVicc.__assign($aVicc.__assign({}, result), $4fe0d5764665f8a7$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $4fe0d5764665f8a7$var$parseSign(token.stem);
        if (signOpts) result = $aVicc.__assign($aVicc.__assign({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $4fe0d5764665f8a7$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = $aVicc.__assign($aVicc.__assign({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}
module.exports.parseNumberSkeleton = $4fe0d5764665f8a7$var$parseNumberSkeleton;

});
parcelRegister("3NuSJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WHITE_SPACE_REGEX = void 0;
// @generated from regex-gen.ts
module.exports.WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("6ctJx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getBestPattern = void 0;

var $c00tN = parcelRequire("c00tN");
/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */ function $483aed8a5ec3cf25$var$getBestPattern(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $483aed8a5ec3cf25$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
module.exports.getBestPattern = $483aed8a5ec3cf25$var$getBestPattern;
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $483aed8a5ec3cf25$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = $c00tN.timeData[regionTag || ""] || $c00tN.timeData[languageTag || ""] || $c00tN.timeData["".concat(languageTag, "-001")] || $c00tN.timeData["001"];
    return hourCycles[0];
}

});
parcelRegister("c00tN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.timeData = void 0;
// @generated from time-data-gen.ts
// prettier-ignore  
module.exports.timeData = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("jORks", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $e6dc0dd450122b82$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "strategies", function () { return $e6dc0dd450122b82$export$c5491a8691a23b9e; });
//
// Main
//
function $e6dc0dd450122b82$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $e6dc0dd450122b82$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $e6dc0dd450122b82$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $e6dc0dd450122b82$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $e6dc0dd450122b82$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $e6dc0dd450122b82$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $e6dc0dd450122b82$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $e6dc0dd450122b82$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $e6dc0dd450122b82$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $e6dc0dd450122b82$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $e6dc0dd450122b82$var$monadic : $e6dc0dd450122b82$var$variadic;
    return $e6dc0dd450122b82$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $e6dc0dd450122b82$var$strategyVariadic(fn, options) {
    return $e6dc0dd450122b82$var$assemble(fn, this, $e6dc0dd450122b82$var$variadic, options.cache.create(), options.serializer);
}
function $e6dc0dd450122b82$var$strategyMonadic(fn, options) {
    return $e6dc0dd450122b82$var$assemble(fn, this, $e6dc0dd450122b82$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $e6dc0dd450122b82$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $e6dc0dd450122b82$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$e6dc0dd450122b82$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$e6dc0dd450122b82$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $e6dc0dd450122b82$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $e6dc0dd450122b82$var$ObjectWithoutPrototypeCache();
    }
};
var $e6dc0dd450122b82$export$c5491a8691a23b9e = {
    variadic: $e6dc0dd450122b82$var$strategyVariadic,
    monadic: $e6dc0dd450122b82$var$strategyMonadic
};

});

parcelRegister("aA3Qo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatToParts = module.exports.isFormatXMLElementFn = module.exports.PART_TYPE = void 0;

var $dlyQF = parcelRequire("dlyQF");

var $at5AZ = parcelRequire("at5AZ");
var $01fce84023ecc5f8$var$PART_TYPE;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($01fce84023ecc5f8$var$PART_TYPE || (module.exports.PART_TYPE = $01fce84023ecc5f8$var$PART_TYPE = {}));
function $01fce84023ecc5f8$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $01fce84023ecc5f8$var$PART_TYPE.literal || part.type !== $01fce84023ecc5f8$var$PART_TYPE.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $01fce84023ecc5f8$var$isFormatXMLElementFn(el) {
    return typeof el === "function";
}
module.exports.isFormatXMLElementFn = $01fce84023ecc5f8$var$isFormatXMLElementFn;
// TODO(skeleton): add skeleton support
function $01fce84023ecc5f8$var$formatToParts(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $dlyQF.isLiteralElement)(els[0])) return [
        {
            type: $01fce84023ecc5f8$var$PART_TYPE.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $dlyQF.isLiteralElement)(el)) {
            result.push({
                type: $01fce84023ecc5f8$var$PART_TYPE.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $dlyQF.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $01fce84023ecc5f8$var$PART_TYPE.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new $at5AZ.MissingValueError(varName, originalMessage);
        var value = values[varName];
        if ((0, $dlyQF.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $01fce84023ecc5f8$var$PART_TYPE.literal : $01fce84023ecc5f8$var$PART_TYPE.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $dlyQF.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $dlyQF.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $01fce84023ecc5f8$var$PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $dlyQF.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $dlyQF.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $01fce84023ecc5f8$var$PART_TYPE.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $dlyQF.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $dlyQF.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $01fce84023ecc5f8$var$PART_TYPE.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $dlyQF.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$01fce84023ecc5f8$var$isFormatXMLElementFn(formatFn)) throw new $at5AZ.InvalidValueTypeError(value_1, "function", originalMessage);
            var parts = $01fce84023ecc5f8$var$formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $01fce84023ecc5f8$var$PART_TYPE.literal : $01fce84023ecc5f8$var$PART_TYPE.object,
                    value: c
                };
            }));
        }
        if ((0, $dlyQF.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new $at5AZ.InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $01fce84023ecc5f8$var$formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $dlyQF.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new $at5AZ.FormatError('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', $at5AZ.ErrorCode.MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new $at5AZ.InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $01fce84023ecc5f8$var$formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $01fce84023ecc5f8$var$mergeLiteral(result);
}
module.exports.formatToParts = $01fce84023ecc5f8$var$formatToParts;

});
parcelRegister("at5AZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MissingValueError = module.exports.InvalidValueTypeError = module.exports.InvalidValueError = module.exports.FormatError = module.exports.ErrorCode = void 0;

var $aVicc = parcelRequire("aVicc");
var $79f0f3fc9873c3dc$var$ErrorCode;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($79f0f3fc9873c3dc$var$ErrorCode || (module.exports.ErrorCode = $79f0f3fc9873c3dc$var$ErrorCode = {}));
var $79f0f3fc9873c3dc$var$FormatError = /** @class */ function(_super) {
    $aVicc.__extends(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
module.exports.FormatError = $79f0f3fc9873c3dc$var$FormatError;
var $79f0f3fc9873c3dc$var$InvalidValueError = /** @class */ function(_super) {
    $aVicc.__extends(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $79f0f3fc9873c3dc$var$ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($79f0f3fc9873c3dc$var$FormatError);
module.exports.InvalidValueError = $79f0f3fc9873c3dc$var$InvalidValueError;
var $79f0f3fc9873c3dc$var$InvalidValueTypeError = /** @class */ function(_super) {
    $aVicc.__extends(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $79f0f3fc9873c3dc$var$ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($79f0f3fc9873c3dc$var$FormatError);
module.exports.InvalidValueTypeError = $79f0f3fc9873c3dc$var$InvalidValueTypeError;
var $79f0f3fc9873c3dc$var$MissingValueError = /** @class */ function(_super) {
    $aVicc.__extends(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $79f0f3fc9873c3dc$var$ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($79f0f3fc9873c3dc$var$FormatError);
module.exports.MissingValueError = $79f0f3fc9873c3dc$var$MissingValueError;

});




parcelRegister("jmw3j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MissingTranslationError = module.exports.MessageFormatError = module.exports.IntlFormatError = module.exports.MissingDataError = module.exports.InvalidConfigError = module.exports.UnsupportedFormatterError = module.exports.IntlError = module.exports.IntlErrorCode = void 0;

var $aVicc = parcelRequire("aVicc");
var $e188ef579917135c$var$IntlErrorCode;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($e188ef579917135c$var$IntlErrorCode || (module.exports.IntlErrorCode = $e188ef579917135c$var$IntlErrorCode = {}));
var $e188ef579917135c$var$IntlError = /** @class */ function(_super) {
    $aVicc.__extends(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
module.exports.IntlError = $e188ef579917135c$var$IntlError;
var $e188ef579917135c$var$UnsupportedFormatterError = /** @class */ function(_super) {
    $aVicc.__extends(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $e188ef579917135c$var$IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($e188ef579917135c$var$IntlError);
module.exports.UnsupportedFormatterError = $e188ef579917135c$var$UnsupportedFormatterError;
var $e188ef579917135c$var$InvalidConfigError = /** @class */ function(_super) {
    $aVicc.__extends(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $e188ef579917135c$var$IntlErrorCode.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($e188ef579917135c$var$IntlError);
module.exports.InvalidConfigError = $e188ef579917135c$var$InvalidConfigError;
var $e188ef579917135c$var$MissingDataError = /** @class */ function(_super) {
    $aVicc.__extends(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $e188ef579917135c$var$IntlErrorCode.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($e188ef579917135c$var$IntlError);
module.exports.MissingDataError = $e188ef579917135c$var$MissingDataError;
var $e188ef579917135c$var$IntlFormatError = /** @class */ function(_super) {
    $aVicc.__extends(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $e188ef579917135c$var$IntlErrorCode.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($e188ef579917135c$var$IntlError);
module.exports.IntlFormatError = $e188ef579917135c$var$IntlFormatError;
var $e188ef579917135c$var$MessageFormatError = /** @class */ function(_super) {
    $aVicc.__extends(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($e188ef579917135c$var$IntlFormatError);
module.exports.MessageFormatError = $e188ef579917135c$var$MessageFormatError;
var $e188ef579917135c$var$MissingTranslationError = /** @class */ function(_super) {
    $aVicc.__extends(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $e188ef579917135c$var$IntlErrorCode.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === "string" ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($e188ef579917135c$var$IntlError);
module.exports.MissingTranslationError = $e188ef579917135c$var$MissingTranslationError;

});


parcelRegister("i9vHe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatMessage = void 0;

var $aVicc = parcelRequire("aVicc");

var $ir3Bv = parcelRequire("ir3Bv");

var $hAlbz = parcelRequire("hAlbz");

var $jmw3j = parcelRequire("jmw3j");

var $dlyQF = parcelRequire("dlyQF");
function $d371a78182a38673$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = $aVicc.__assign({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $d371a78182a38673$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys($aVicc.__assign($aVicc.__assign({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = $aVicc.__assign($aVicc.__assign({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $d371a78182a38673$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = $hAlbz.IntlMessageFormat.formats;
    return $aVicc.__assign($aVicc.__assign($aVicc.__assign({}, mfFormats), f1), {
        date: $d371a78182a38673$var$deepMergeOptions($d371a78182a38673$var$setTimeZoneInOptions(mfFormats.date, timeZone), $d371a78182a38673$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $d371a78182a38673$var$deepMergeOptions($d371a78182a38673$var$setTimeZoneInOptions(mfFormats.time, timeZone), $d371a78182a38673$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $d371a78182a38673$var$formatMessage = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $ir3Bv.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === $dlyQF.TYPE.literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = $aVicc.__assign($aVicc.__assign({}, defaultRichTextElements), values || {});
    formats = $d371a78182a38673$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $d371a78182a38673$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new $jmw3j.MissingTranslationError(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new $jmw3j.MessageFormatError('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, $aVicc.__assign({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new $jmw3j.MessageFormatError('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new $jmw3j.MessageFormatError('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
};
module.exports.formatMessage = $d371a78182a38673$var$formatMessage;

});

parcelRegister("69Dp0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatTimeToParts = module.exports.formatDateToParts = module.exports.formatDateTimeRange = module.exports.formatTime = module.exports.formatDate = module.exports.getFormatter = void 0;

var $aVicc = parcelRequire("aVicc");

var $k3SeL = parcelRequire("k3SeL");

var $jmw3j = parcelRequire("jmw3j");
var $47b225d2b98a3404$var$DATE_TIME_FORMAT_OPTIONS = [
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem",
    "fractionalSecondDigits"
];
function $47b225d2b98a3404$var$getFormatter(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = $aVicc.__assign($aVicc.__assign({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $k3SeL.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $k3SeL.filterProps)(options, $47b225d2b98a3404$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = $aVicc.__assign($aVicc.__assign({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
module.exports.getFormatter = $47b225d2b98a3404$var$getFormatter;
function $47b225d2b98a3404$var$formatDate(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $47b225d2b98a3404$var$getFormatter(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new $jmw3j.IntlFormatError("Error formatting date.", config.locale, e));
    }
    return String(date);
}
module.exports.formatDate = $47b225d2b98a3404$var$formatDate;
function $47b225d2b98a3404$var$formatTime(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $47b225d2b98a3404$var$getFormatter(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new $jmw3j.IntlFormatError("Error formatting time.", config.locale, e));
    }
    return String(date);
}
module.exports.formatTime = $47b225d2b98a3404$var$formatTime;
function $47b225d2b98a3404$var$formatDateTimeRange(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $k3SeL.filterProps)(options, $47b225d2b98a3404$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new $jmw3j.IntlFormatError("Error formatting date time range.", config.locale, e));
    }
    return String(from);
}
module.exports.formatDateTimeRange = $47b225d2b98a3404$var$formatDateTimeRange;
function $47b225d2b98a3404$var$formatDateToParts(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $47b225d2b98a3404$var$getFormatter(config, "date", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new $jmw3j.IntlFormatError("Error formatting date.", config.locale, e));
    }
    return [];
}
module.exports.formatDateToParts = $47b225d2b98a3404$var$formatDateToParts;
function $47b225d2b98a3404$var$formatTimeToParts(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $47b225d2b98a3404$var$getFormatter(config, "time", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new $jmw3j.IntlFormatError("Error formatting time.", config.locale, e));
    }
    return [];
}
module.exports.formatTimeToParts = $47b225d2b98a3404$var$formatTimeToParts;

});

parcelRegister("dP7Wn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatDisplayName = void 0;

var $k3SeL = parcelRequire("k3SeL");

var $hAlbz = parcelRequire("hAlbz");

var $jmw3j = parcelRequire("jmw3j");
var $a10632993e4e58f3$var$DISPLAY_NAMES_OPTONS = [
    "style",
    "type",
    "fallback",
    "languageDisplay"
];
function $a10632993e4e58f3$var$formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new $hAlbz.FormatError('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', $hAlbz.ErrorCode.MISSING_INTL_API));
    var filteredOptions = (0, $k3SeL.filterProps)(options, $a10632993e4e58f3$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new $jmw3j.IntlFormatError("Error formatting display name.", locale, e));
    }
}
module.exports.formatDisplayName = $a10632993e4e58f3$var$formatDisplayName;

});

parcelRegister("23bPf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatListToParts = module.exports.formatList = void 0;

var $aVicc = parcelRequire("aVicc");

var $k3SeL = parcelRequire("k3SeL");

var $hAlbz = parcelRequire("hAlbz");

var $jmw3j = parcelRequire("jmw3j");
var $17e508e82cce2b66$var$LIST_FORMAT_OPTIONS = [
    "type",
    "style"
];
var $17e508e82cce2b66$var$now = Date.now();
function $17e508e82cce2b66$var$generateToken(i) {
    return "".concat($17e508e82cce2b66$var$now, "_").concat(i, "_").concat($17e508e82cce2b66$var$now);
}
function $17e508e82cce2b66$var$formatList(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $17e508e82cce2b66$var$formatListToParts(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? "" : results;
}
module.exports.formatList = $17e508e82cce2b66$var$formatList;
function $17e508e82cce2b66$var$formatListToParts(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new $hAlbz.FormatError('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', $hAlbz.ErrorCode.MISSING_INTL_API));
    var filteredOptions = (0, $k3SeL.filterProps)(options, $17e508e82cce2b66$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = $17e508e82cce2b66$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : $aVicc.__assign($aVicc.__assign({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new $jmw3j.IntlFormatError("Error formatting list.", locale, e));
    }
    // @ts-ignore
    return values;
}
module.exports.formatListToParts = $17e508e82cce2b66$var$formatListToParts;

});

parcelRegister("4nIH0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatPlural = void 0;

var $k3SeL = parcelRequire("k3SeL");

var $jmw3j = parcelRequire("jmw3j");

var $hAlbz = parcelRequire("hAlbz");
var $330bfa69e284da0b$var$PLURAL_FORMAT_OPTIONS = [
    "type"
];
function $330bfa69e284da0b$var$formatPlural(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new $hAlbz.FormatError('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', $hAlbz.ErrorCode.MISSING_INTL_API));
    var filteredOptions = (0, $k3SeL.filterProps)(options, $330bfa69e284da0b$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new $jmw3j.IntlFormatError("Error formatting plural.", locale, e));
    }
    return "other";
}
module.exports.formatPlural = $330bfa69e284da0b$var$formatPlural;

});

parcelRegister("k0qbT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatRelativeTime = void 0;

var $k3SeL = parcelRequire("k3SeL");

var $hAlbz = parcelRequire("hAlbz");

var $jmw3j = parcelRequire("jmw3j");
var $e9081fabd04800b9$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $e9081fabd04800b9$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $k3SeL.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, $k3SeL.filterProps)(options, $e9081fabd04800b9$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $e9081fabd04800b9$var$formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new $hAlbz.FormatError('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', $hAlbz.ErrorCode.MISSING_INTL_API));
    try {
        return $e9081fabd04800b9$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new $jmw3j.IntlFormatError("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}
module.exports.formatRelativeTime = $e9081fabd04800b9$var$formatRelativeTime;

});

parcelRegister("djBw9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatNumberToParts = module.exports.formatNumber = module.exports.getFormatter = void 0;

var $k3SeL = parcelRequire("k3SeL");

var $jmw3j = parcelRequire("jmw3j");
var $9b1a26ef4ca2b14b$var$NUMBER_FORMAT_OPTIONS = [
    "style",
    "currency",
    "currencyDisplay",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem"
];
function $9b1a26ef4ca2b14b$var$getFormatter(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $k3SeL.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, $k3SeL.filterProps)(options, $9b1a26ef4ca2b14b$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
module.exports.getFormatter = $9b1a26ef4ca2b14b$var$getFormatter;
function $9b1a26ef4ca2b14b$var$formatNumber(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $9b1a26ef4ca2b14b$var$getFormatter(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new $jmw3j.IntlFormatError("Error formatting number.", config.locale, e));
    }
    return String(value);
}
module.exports.formatNumber = $9b1a26ef4ca2b14b$var$formatNumber;
function $9b1a26ef4ca2b14b$var$formatNumberToParts(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $9b1a26ef4ca2b14b$var$getFormatter(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new $jmw3j.IntlFormatError("Error formatting number.", config.locale, e));
    }
    return [];
}
module.exports.formatNumberToParts = $9b1a26ef4ca2b14b$var$formatNumberToParts;

});

parcelRegister("aMxdT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createIntl = void 0;

var $aVicc = parcelRequire("aVicc");

var $k3SeL = parcelRequire("k3SeL");

var $jmw3j = parcelRequire("jmw3j");

var $djBw9 = parcelRequire("djBw9");

var $k0qbT = parcelRequire("k0qbT");

var $69Dp0 = parcelRequire("69Dp0");

var $4nIH0 = parcelRequire("4nIH0");

var $i9vHe = parcelRequire("i9vHe");

var $23bPf = parcelRequire("23bPf");

var $dP7Wn = parcelRequire("dP7Wn");
function $7d982879084a5833$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $7d982879084a5833$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $7d982879084a5833$var$messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */ function $7d982879084a5833$var$createIntl(config, cache) {
    var formatters = (0, $k3SeL.createFormatters)(cache);
    var resolvedConfig = $aVicc.__assign($aVicc.__assign({}, $k3SeL.DEFAULT_INTL_CONFIG), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new $jmw3j.InvalidConfigError('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new $jmw3j.MissingDataError('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new $jmw3j.MissingDataError('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    $7d982879084a5833$var$verifyConfigMessages(resolvedConfig);
    return $aVicc.__assign($aVicc.__assign({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: $djBw9.formatNumber.bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: $djBw9.formatNumberToParts.bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: $k0qbT.formatRelativeTime.bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: $69Dp0.formatDate.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: $69Dp0.formatDateToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: $69Dp0.formatTime.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: $69Dp0.formatDateTimeRange.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: $69Dp0.formatTimeToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: $4nIH0.formatPlural.bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: $i9vHe.formatMessage.bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: $i9vHe.formatMessage.bind(null, resolvedConfig, formatters),
        formatList: $23bPf.formatList.bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: $23bPf.formatListToParts.bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: $dP7Wn.formatDisplayName.bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}
module.exports.createIntl = $7d982879084a5833$var$createIntl;

});





parcelRegister("bl6fg", function(module, exports) {
"use strict";
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createIntl = void 0;

var $aVicc = parcelRequire("aVicc");

var $stxzp = parcelRequire("stxzp");

var $8416800b563a79db$var$React = $aVicc.__importStar((parcelRequire("1T1QG")));

var $8Mot8 = parcelRequire("8Mot8");

var $9hkJK = parcelRequire("9hkJK");

var $hAlbz = parcelRequire("hAlbz");
function $8416800b563a79db$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $8416800b563a79db$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $hAlbz.isFormatXMLElementFn)(v) ? (0, $8Mot8.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $8416800b563a79db$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $8416800b563a79db$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = $stxzp.formatMessage.apply(void 0, $aVicc.__spreadArray([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $8416800b563a79db$var$React.Children.toArray(chunks);
    return chunks;
};
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */ var $8416800b563a79db$var$createIntl = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = $aVicc.__rest(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $8416800b563a79db$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $stxzp.createIntl)($aVicc.__assign($aVicc.__assign($aVicc.__assign({}, $8Mot8.DEFAULT_INTL_CONFIG), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return $aVicc.__assign($aVicc.__assign({}, coreIntl), {
        formatMessage: $8416800b563a79db$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $8416800b563a79db$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};
module.exports.createIntl = $8416800b563a79db$var$createIntl;
var $8416800b563a79db$var$IntlProvider = /** @class */ function(_super) {
    $aVicc.__extends(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $stxzp.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, module.exports.createIntl)($8416800b563a79db$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $8416800b563a79db$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $8416800b563a79db$var$processIntlConfig(props);
        if (!(0, $8Mot8.shallowEqual)(prevConfig, config)) return {
            intl: (0, module.exports.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $8Mot8.invariantIntlContext)(this.state.intl);
        return $8416800b563a79db$var$React.createElement($9hkJK.Provider, {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = $8Mot8.DEFAULT_INTL_CONFIG;
    return IntlProvider;
}($8416800b563a79db$var$React.PureComponent);
module.exports.default = $8416800b563a79db$var$IntlProvider;

});

parcelRegister("gDR78", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aVicc = parcelRequire("aVicc");

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ var $c1d97d31fbefa8db$var$React = $aVicc.__importStar((parcelRequire("1T1QG")));

var $ir3Bv = parcelRequire("ir3Bv");

var $c1d97d31fbefa8db$var$useIntl_1 = $aVicc.__importDefault((parcelRequire("cEK7I")));
var $c1d97d31fbefa8db$var$MINUTE = 60;
var $c1d97d31fbefa8db$var$HOUR = 3600;
var $c1d97d31fbefa8db$var$DAY = 86400;
function $c1d97d31fbefa8db$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $c1d97d31fbefa8db$var$MINUTE) return "second";
    if (absValue < $c1d97d31fbefa8db$var$HOUR) return "minute";
    if (absValue < $c1d97d31fbefa8db$var$DAY) return "hour";
    return "day";
}
function $c1d97d31fbefa8db$var$getDurationInSeconds(unit) {
    switch(unit){
        case "second":
            return 1;
        case "minute":
            return $c1d97d31fbefa8db$var$MINUTE;
        case "hour":
            return $c1d97d31fbefa8db$var$HOUR;
        default:
            return $c1d97d31fbefa8db$var$DAY;
    }
}
function $c1d97d31fbefa8db$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case "second":
            return value;
        case "minute":
            return value * $c1d97d31fbefa8db$var$MINUTE;
        default:
            return value * $c1d97d31fbefa8db$var$HOUR;
    }
}
var $c1d97d31fbefa8db$var$INCREMENTABLE_UNITS = [
    "second",
    "minute",
    "hour"
];
function $c1d97d31fbefa8db$var$canIncrement(unit) {
    if (unit === void 0) unit = "second";
    return $c1d97d31fbefa8db$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $c1d97d31fbefa8db$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $c1d97d31fbefa8db$var$useIntl_1.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = $aVicc.__rest(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === "function") return children(formattedRelativeTime);
    if (Text) return $c1d97d31fbefa8db$var$React.createElement(Text, null, formattedRelativeTime);
    return $c1d97d31fbefa8db$var$React.createElement($c1d97d31fbefa8db$var$React.Fragment, null, formattedRelativeTime);
};
var $c1d97d31fbefa8db$var$FormattedRelativeTime = function(_a) {
    var value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = $aVicc.__rest(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $ir3Bv.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $c1d97d31fbefa8db$var$canIncrement(unit)), "Cannot schedule update with unit longer than hour");
    var _b = $c1d97d31fbefa8db$var$React.useState(), prevUnit = _b[0], setPrevUnit = _b[1];
    var _c = $c1d97d31fbefa8db$var$React.useState(0), prevValue = _c[0], setPrevValue = _c[1];
    var _d = $c1d97d31fbefa8db$var$React.useState(0), currentValueInSeconds = _d[0], setCurrentValueInSeconds = _d[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($c1d97d31fbefa8db$var$canIncrement(unit) ? $c1d97d31fbefa8db$var$valueToSeconds(value, unit) : 0);
    }
    $c1d97d31fbefa8db$var$React.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$c1d97d31fbefa8db$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $c1d97d31fbefa8db$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === "day") return clearUpdateTimer;
        var unitDuration = $c1d97d31fbefa8db$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($c1d97d31fbefa8db$var$canIncrement(unit) && typeof currentValueInSeconds === "number" && updateIntervalInSeconds) {
        currentUnit = $c1d97d31fbefa8db$var$selectUnit(currentValueInSeconds);
        var unitDuration = $c1d97d31fbefa8db$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $c1d97d31fbefa8db$var$React.createElement($c1d97d31fbefa8db$var$SimpleFormattedRelativeTime, $aVicc.__assign({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$c1d97d31fbefa8db$var$FormattedRelativeTime.displayName = "FormattedRelativeTime";
$c1d97d31fbefa8db$var$FormattedRelativeTime.defaultProps = {
    value: 0,
    unit: "second"
};
module.exports.default = $c1d97d31fbefa8db$var$FormattedRelativeTime;

});

parcelRegister("4sMkT", function(module, exports) {
"use strict";
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aVicc = parcelRequire("aVicc");

var $33ff457239dfd597$var$React = $aVicc.__importStar((parcelRequire("1T1QG")));

var $33ff457239dfd597$var$useIntl_1 = $aVicc.__importDefault((parcelRequire("cEK7I")));
var $33ff457239dfd597$var$FormattedPlural = function(props) {
    var _a = (0, $33ff457239dfd597$var$useIntl_1.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === "function") return children(formattedPlural);
    if (Text) return $33ff457239dfd597$var$React.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$33ff457239dfd597$var$FormattedPlural.defaultProps = {
    type: "cardinal"
};
$33ff457239dfd597$var$FormattedPlural.displayName = "FormattedPlural";
module.exports.default = $33ff457239dfd597$var$FormattedPlural;

});

parcelRegister("9vfuB", function(module, exports) {
"use strict";
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aVicc = parcelRequire("aVicc");

var $6eb306d2e93d465a$var$React = $aVicc.__importStar((parcelRequire("1T1QG")));

var $6eb306d2e93d465a$var$useIntl_1 = $aVicc.__importDefault((parcelRequire("cEK7I")));

var $8Mot8 = parcelRequire("8Mot8");
function $6eb306d2e93d465a$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = $aVicc.__rest(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = $aVicc.__rest(nextProps, [
        "values"
    ]);
    return (0, $8Mot8.shallowEqual)(nextValues, values) && (0, $8Mot8.shallowEqual)(otherProps, nextOtherProps);
}
function $6eb306d2e93d465a$var$FormattedMessage(props) {
    var intl = (0, $6eb306d2e93d465a$var$useIntl_1.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $6eb306d2e93d465a$var$React.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $6eb306d2e93d465a$var$React.createElement(Component, null, $6eb306d2e93d465a$var$React.Children.toArray(nodes));
    return $6eb306d2e93d465a$var$React.createElement($6eb306d2e93d465a$var$React.Fragment, null, nodes);
}
$6eb306d2e93d465a$var$FormattedMessage.displayName = "FormattedMessage";
var $6eb306d2e93d465a$var$MemoizedFormattedMessage = $6eb306d2e93d465a$var$React.memo($6eb306d2e93d465a$var$FormattedMessage, $6eb306d2e93d465a$var$areEqual);
$6eb306d2e93d465a$var$MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
module.exports.default = $6eb306d2e93d465a$var$MemoizedFormattedMessage;

});

parcelRegister("60Prr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aVicc = parcelRequire("aVicc");

var $460aa564f447c24f$var$React = $aVicc.__importStar((parcelRequire("1T1QG")));

var $460aa564f447c24f$var$useIntl_1 = $aVicc.__importDefault((parcelRequire("cEK7I")));
var $460aa564f447c24f$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $460aa564f447c24f$var$useIntl_1.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = $aVicc.__rest(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === "function") return children(formattedValue);
    var Text = intl.textComponent || $460aa564f447c24f$var$React.Fragment;
    return $460aa564f447c24f$var$React.createElement(Text, null, formattedValue);
};
$460aa564f447c24f$var$FormattedDateTimeRange.displayName = "FormattedDateTimeRange";
module.exports.default = $460aa564f447c24f$var$FormattedDateTimeRange;

});

parcelRegister("eUHG3", function(module, exports) {

$parcel$export(module.exports, "isInteger", function () { return isInteger; });
$parcel$export(module.exports, "Formik", function () { return Formik; });

var $dQ9aM = parcelRequire("dQ9aM");

var $kPnk0 = parcelRequire("kPnk0");

var $1T1QG = parcelRequire("1T1QG");

var $3nGPM = parcelRequire("3nGPM");

var $8mxLi = parcelRequire("8mxLi");

var $CU3qI = parcelRequire("CU3qI");

var $g2NX4 = parcelRequire("g2NX4");

var $3HlGj = parcelRequire("3HlGj");

var $4VrJM = parcelRequire("4VrJM");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $1T1QG.createContext)(undefined);
FormikContext.displayName = "FormikContext";
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $1T1QG.useContext)(FormikContext);
    !!!formik && (0, $8mxLi.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === "function";
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === "object";
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === "[object String]";
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $1T1QG.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== "undefined" ? document : undefined);
    if (typeof doc === "undefined") return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $g2NX4.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $CU3qI.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $g2NX4.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $CU3qI.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case "SET_VALUES":
            return _extends({}, state, {
                values: msg.payload
            });
        case "SET_TOUCHED":
            return _extends({}, state, {
                touched: msg.payload
            });
        case "SET_ERRORS":
            if ((0, (/*@__PURE__*/$parcel$interopDefault($3nGPM)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case "SET_STATUS":
            return _extends({}, state, {
                status: msg.payload
            });
        case "SET_ISSUBMITTING":
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case "SET_ISVALIDATING":
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case "SET_FIELD_VALUE":
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_TOUCHED":
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_ERROR":
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case "RESET_FORM":
            return _extends({}, state, msg.payload);
        case "SET_FORMIK_STATE":
            return msg.payload(state);
        case "SUBMIT_ATTEMPT":
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case "SUBMIT_FAILURE":
            return _extends({}, state, {
                isSubmitting: false
            });
        case "SUBMIT_SUCCESS":
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $1T1QG.useRef)(props.initialValues);
    var initialErrors = (0, $1T1QG.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $1T1QG.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $1T1QG.useRef)(props.initialStatus);
    var isMounted = (0, $1T1QG.useRef)(false);
    var fieldRegistry = (0, $1T1QG.useRef)({});
    (0, $1T1QG.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $1T1QG.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $1T1QG.useRef)({
        values: props.initialValues,
        errors: props.initialErrors || emptyErrors,
        touched: props.initialTouched || emptyTouched,
        status: props.initialStatus,
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $1T1QG.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $1T1QG.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $1T1QG.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === "ValidationError") resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $1T1QG.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $1T1QG.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === "DO_NOT_DELETE_YOU_WILL_BE_FIRED") return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $1T1QG.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $dQ9aM.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: "SET_ISVALIDATING",
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
                dispatch({
                    type: "SET_ERRORS",
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $1T1QG.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($3nGPM)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $1T1QG.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: "RESET_FORM",
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === "number" ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $1T1QG.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($3nGPM)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $1T1QG.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($3nGPM)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: "SET_ERRORS",
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $1T1QG.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($3nGPM)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: "SET_TOUCHED",
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $1T1QG.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($3nGPM)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: "SET_STATUS",
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: "SET_FIELD_ERROR",
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: "SET_ISVALIDATING",
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: "SET_ISVALIDATING",
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $1T1QG.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $1T1QG.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: "SET_TOUCHED",
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $1T1QG.useCallback)(function(errors) {
        dispatch({
            type: "SET_ERRORS",
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: "SET_VALUES",
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $1T1QG.useCallback)(function(field, value) {
        dispatch({
            type: "SET_FIELD_ERROR",
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: "SET_FIELD_VALUE",
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $1T1QG.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? "" : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: "SET_FIELD_TOUCHED",
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $1T1QG.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $1T1QG.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: "SET_FORMIK_STATE",
            payload: stateOrCb
        });
        else dispatch({
            type: "SET_FORMIK_STATE",
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $1T1QG.useCallback)(function(status) {
        dispatch({
            type: "SET_STATUS",
            payload: status
        });
    }, []);
    var setSubmitting = (0, $1T1QG.useCallback)(function(isSubmitting) {
        dispatch({
            type: "SET_ISSUBMITTING",
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: "SUBMIT_ATTEMPT"
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: "SUBMIT_SUCCESS"
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: "SUBMIT_FAILURE"
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: "SUBMIT_FAILURE"
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $1T1QG.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $1T1QG.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $1T1QG.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === "checkbox") {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === "radio") {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === "select" && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $1T1QG.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($3nGPM)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $1T1QG.useMemo)(function() {
        return typeof isInitialValid !== "undefined" ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $1T1QG.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $1T1QG.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $1T1QG.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $1T1QG.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? "validateSync" : "validate"](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $kPnk0.default)(value)) return prepareDataForValidation(value);
            else return value !== "" ? value : undefined;
        });
        else if ((0, $kPnk0.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== "" ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === "undefined") {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $dQ9aM.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $dQ9aM.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === "boolean") return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == "true" || valueProp == "false") return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $1T1QG.useLayoutEffect) : (0, $1T1QG.useEffect);
function useEventCallback(fn) {
    var ref = (0, $1T1QG.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $1T1QG.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $1T1QG.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $8mxLi.default)(false);
    var fieldHelpers = (0, $1T1QG.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $1T1QG.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === "string") {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $1T1QG.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $1T1QG.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || "input";
    if (typeof asElement === "string") {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $1T1QG.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $1T1QG.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $1T1QG.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : "#";
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $1T1QG.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = "Form";
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== "function") // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || "Component";
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $1T1QG.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $1T1QG.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $1T1QG.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($3HlGj)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $1T1QG.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $8mxLi.default)(false);
            return (0, $1T1QG.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || "Component"; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($3HlGj)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === "function" ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $4VrJM.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($3nGPM)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $1T1QG.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === "function" ? children(props) : !isEmptyChildren(children) ? (0, $1T1QG.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $1T1QG.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $1T1QG.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $1T1QG.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $8mxLi.default)(false);
        !!(component && render) && (0, $8mxLi.default)(false);
        !!(is && children && isFunction(children)) && (0, $8mxLi.default)(false);
        !!(component && children && isFunction(children)) && (0, $8mxLi.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $8mxLi.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === "string") {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $1T1QG.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $1T1QG.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || "input";
        if (typeof asElement === "string") {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $1T1QG.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $1T1QG.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $1T1QG.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("dQ9aM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1373f4168d091be$export$2e2bcd8739ae039; });
var $a1373f4168d091be$var$isMergeableObject = function isMergeableObject(value) {
    return $a1373f4168d091be$var$isNonNullObject(value) && !$a1373f4168d091be$var$isSpecial(value);
};
function $a1373f4168d091be$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $a1373f4168d091be$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $a1373f4168d091be$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $a1373f4168d091be$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $a1373f4168d091be$var$REACT_ELEMENT_TYPE = $a1373f4168d091be$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $a1373f4168d091be$var$isReactElement(value) {
    return value.$$typeof === $a1373f4168d091be$var$REACT_ELEMENT_TYPE;
}
function $a1373f4168d091be$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $a1373f4168d091be$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $a1373f4168d091be$var$deepmerge($a1373f4168d091be$var$emptyTarget(value), value, options) : value;
}
function $a1373f4168d091be$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $a1373f4168d091be$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $a1373f4168d091be$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $a1373f4168d091be$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $a1373f4168d091be$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $a1373f4168d091be$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $a1373f4168d091be$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $a1373f4168d091be$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $a1373f4168d091be$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $a1373f4168d091be$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $a1373f4168d091be$var$mergeObject(target, source, options);
}
$a1373f4168d091be$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $a1373f4168d091be$var$deepmerge(prev, next, options);
    }, {});
};
var $a1373f4168d091be$var$deepmerge_1 = $a1373f4168d091be$var$deepmerge;
var $a1373f4168d091be$export$2e2bcd8739ae039 = $a1373f4168d091be$var$deepmerge_1;

});

parcelRegister("kPnk0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f29aa93e78922c0c$export$2e2bcd8739ae039; });

var $1KJeP = parcelRequire("1KJeP");

var $wbPtc = parcelRequire("wbPtc");

var $4JZNr = parcelRequire("4JZNr");
/** `Object#toString` result references. */ var $f29aa93e78922c0c$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $f29aa93e78922c0c$var$funcProto = Function.prototype, $f29aa93e78922c0c$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $f29aa93e78922c0c$var$funcToString = $f29aa93e78922c0c$var$funcProto.toString;
/** Used to check objects for own properties. */ var $f29aa93e78922c0c$var$hasOwnProperty = $f29aa93e78922c0c$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $f29aa93e78922c0c$var$objectCtorString = $f29aa93e78922c0c$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $f29aa93e78922c0c$var$isPlainObject(value) {
    if (!(0, $4JZNr.default)(value) || (0, $1KJeP.default)(value) != $f29aa93e78922c0c$var$objectTag) return false;
    var proto = (0, $wbPtc.default)(value);
    if (proto === null) return true;
    var Ctor = $f29aa93e78922c0c$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $f29aa93e78922c0c$var$funcToString.call(Ctor) == $f29aa93e78922c0c$var$objectCtorString;
}
var $f29aa93e78922c0c$export$2e2bcd8739ae039 = $f29aa93e78922c0c$var$isPlainObject;

});
parcelRegister("1KJeP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $146d2da8d8ab0590$export$2e2bcd8739ae039; });

var $gqa38 = parcelRequire("gqa38");

var $5RHSZ = parcelRequire("5RHSZ");

var $1WATk = parcelRequire("1WATk");
/** `Object#toString` result references. */ var $146d2da8d8ab0590$var$nullTag = "[object Null]", $146d2da8d8ab0590$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $146d2da8d8ab0590$var$symToStringTag = (0, $gqa38.default) ? (0, $gqa38.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $146d2da8d8ab0590$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $146d2da8d8ab0590$var$undefinedTag : $146d2da8d8ab0590$var$nullTag;
    return $146d2da8d8ab0590$var$symToStringTag && $146d2da8d8ab0590$var$symToStringTag in Object(value) ? (0, $5RHSZ.default)(value) : (0, $1WATk.default)(value);
}
var $146d2da8d8ab0590$export$2e2bcd8739ae039 = $146d2da8d8ab0590$var$baseGetTag;

});
parcelRegister("gqa38", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf46deaae56c54a8$export$2e2bcd8739ae039; });

var $9ll1t = parcelRequire("9ll1t");
/** Built-in value references. */ var $bf46deaae56c54a8$var$Symbol = (0, $9ll1t.default).Symbol;
var $bf46deaae56c54a8$export$2e2bcd8739ae039 = $bf46deaae56c54a8$var$Symbol;

});
parcelRegister("9ll1t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cd661ea5cfba2b7$export$2e2bcd8739ae039; });

var $MhvlD = parcelRequire("MhvlD");
/** Detect free variable `self`. */ var $6cd661ea5cfba2b7$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $6cd661ea5cfba2b7$var$root = (0, $MhvlD.default) || $6cd661ea5cfba2b7$var$freeSelf || Function("return this")();
var $6cd661ea5cfba2b7$export$2e2bcd8739ae039 = $6cd661ea5cfba2b7$var$root;

});
parcelRegister("MhvlD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09120fdc7572bb18$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $09120fdc7572bb18$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $09120fdc7572bb18$export$2e2bcd8739ae039 = $09120fdc7572bb18$var$freeGlobal;

});



parcelRegister("5RHSZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4453f1d313298692$export$2e2bcd8739ae039; });

var $gqa38 = parcelRequire("gqa38");
/** Used for built-in method references. */ var $4453f1d313298692$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4453f1d313298692$var$hasOwnProperty = $4453f1d313298692$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4453f1d313298692$var$nativeObjectToString = $4453f1d313298692$var$objectProto.toString;
/** Built-in value references. */ var $4453f1d313298692$var$symToStringTag = (0, $gqa38.default) ? (0, $gqa38.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $4453f1d313298692$var$getRawTag(value) {
    var isOwn = $4453f1d313298692$var$hasOwnProperty.call(value, $4453f1d313298692$var$symToStringTag), tag = value[$4453f1d313298692$var$symToStringTag];
    try {
        value[$4453f1d313298692$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $4453f1d313298692$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$4453f1d313298692$var$symToStringTag] = tag;
        else delete value[$4453f1d313298692$var$symToStringTag];
    }
    return result;
}
var $4453f1d313298692$export$2e2bcd8739ae039 = $4453f1d313298692$var$getRawTag;

});

parcelRegister("1WATk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16a7d313b2dc170d$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $16a7d313b2dc170d$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $16a7d313b2dc170d$var$nativeObjectToString = $16a7d313b2dc170d$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $16a7d313b2dc170d$var$objectToString(value) {
    return $16a7d313b2dc170d$var$nativeObjectToString.call(value);
}
var $16a7d313b2dc170d$export$2e2bcd8739ae039 = $16a7d313b2dc170d$var$objectToString;

});


parcelRegister("wbPtc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $060c2a4c6abe076e$export$2e2bcd8739ae039; });

var $egmH2 = parcelRequire("egmH2");
/** Built-in value references. */ var $060c2a4c6abe076e$var$getPrototype = (0, $egmH2.default)(Object.getPrototypeOf, Object);
var $060c2a4c6abe076e$export$2e2bcd8739ae039 = $060c2a4c6abe076e$var$getPrototype;

});
parcelRegister("egmH2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a62429b9be657424$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $a62429b9be657424$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $a62429b9be657424$export$2e2bcd8739ae039 = $a62429b9be657424$var$overArg;

});


parcelRegister("4JZNr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $373b4cddfe5ad525$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $373b4cddfe5ad525$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $373b4cddfe5ad525$export$2e2bcd8739ae039 = $373b4cddfe5ad525$var$isObjectLike;

});


parcelRegister("3nGPM", function(module, exports) {
"use strict";
var $2764bf0e34cf93eb$var$isArray = Array.isArray;
var $2764bf0e34cf93eb$var$keyList = Object.keys;
var $2764bf0e34cf93eb$var$hasProp = Object.prototype.hasOwnProperty;
var $2764bf0e34cf93eb$var$hasElementType = typeof Element !== "undefined";
function $2764bf0e34cf93eb$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        var arrA = $2764bf0e34cf93eb$var$isArray(a), arrB = $2764bf0e34cf93eb$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$2764bf0e34cf93eb$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $2764bf0e34cf93eb$var$keyList(a);
        length = keys.length;
        if (length !== $2764bf0e34cf93eb$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$2764bf0e34cf93eb$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($2764bf0e34cf93eb$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$2764bf0e34cf93eb$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $2764bf0e34cf93eb$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("8mxLi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $616a91321f7f10a3$export$2e2bcd8739ae039; });
var $616a91321f7f10a3$var$isProduction = true;
function $616a91321f7f10a3$var$warning(condition, message) {
    if (!$616a91321f7f10a3$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $616a91321f7f10a3$export$2e2bcd8739ae039 = $616a91321f7f10a3$var$warning;

});

parcelRegister("CU3qI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $074f07f1f1736d34$export$2e2bcd8739ae039; });

var $lnwVj = parcelRequire("lnwVj");
/** Used to compose bitmasks for cloning. */ var $074f07f1f1736d34$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $074f07f1f1736d34$var$clone(value) {
    return (0, $lnwVj.default)(value, $074f07f1f1736d34$var$CLONE_SYMBOLS_FLAG);
}
var $074f07f1f1736d34$export$2e2bcd8739ae039 = $074f07f1f1736d34$var$clone;

});
parcelRegister("lnwVj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f90548db9877a9f0$export$2e2bcd8739ae039; });

var $jM8yz = parcelRequire("jM8yz");

var $90u1U = parcelRequire("90u1U");

var $8rINC = parcelRequire("8rINC");

var $8C6dA = parcelRequire("8C6dA");

var $g6cqQ = parcelRequire("g6cqQ");

var $hxqqj = parcelRequire("hxqqj");

var $4SU39 = parcelRequire("4SU39");

var $lePeF = parcelRequire("lePeF");

var $5jxL7 = parcelRequire("5jxL7");

var $5Ha17 = parcelRequire("5Ha17");

var $5yyiu = parcelRequire("5yyiu");

var $5tANM = parcelRequire("5tANM");

var $dAC45 = parcelRequire("dAC45");

var $eb4iR = parcelRequire("eb4iR");

var $58JU4 = parcelRequire("58JU4");

var $33nEL = parcelRequire("33nEL");

var $42zX7 = parcelRequire("42zX7");

var $lWJfM = parcelRequire("lWJfM");

var $Fe8Bj = parcelRequire("Fe8Bj");

var $2wlFV = parcelRequire("2wlFV");

var $5346i = parcelRequire("5346i");

var $8dFDc = parcelRequire("8dFDc");
/** Used to compose bitmasks for cloning. */ var $f90548db9877a9f0$var$CLONE_DEEP_FLAG = 1, $f90548db9877a9f0$var$CLONE_FLAT_FLAG = 2, $f90548db9877a9f0$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $f90548db9877a9f0$var$argsTag = "[object Arguments]", $f90548db9877a9f0$var$arrayTag = "[object Array]", $f90548db9877a9f0$var$boolTag = "[object Boolean]", $f90548db9877a9f0$var$dateTag = "[object Date]", $f90548db9877a9f0$var$errorTag = "[object Error]", $f90548db9877a9f0$var$funcTag = "[object Function]", $f90548db9877a9f0$var$genTag = "[object GeneratorFunction]", $f90548db9877a9f0$var$mapTag = "[object Map]", $f90548db9877a9f0$var$numberTag = "[object Number]", $f90548db9877a9f0$var$objectTag = "[object Object]", $f90548db9877a9f0$var$regexpTag = "[object RegExp]", $f90548db9877a9f0$var$setTag = "[object Set]", $f90548db9877a9f0$var$stringTag = "[object String]", $f90548db9877a9f0$var$symbolTag = "[object Symbol]", $f90548db9877a9f0$var$weakMapTag = "[object WeakMap]";
var $f90548db9877a9f0$var$arrayBufferTag = "[object ArrayBuffer]", $f90548db9877a9f0$var$dataViewTag = "[object DataView]", $f90548db9877a9f0$var$float32Tag = "[object Float32Array]", $f90548db9877a9f0$var$float64Tag = "[object Float64Array]", $f90548db9877a9f0$var$int8Tag = "[object Int8Array]", $f90548db9877a9f0$var$int16Tag = "[object Int16Array]", $f90548db9877a9f0$var$int32Tag = "[object Int32Array]", $f90548db9877a9f0$var$uint8Tag = "[object Uint8Array]", $f90548db9877a9f0$var$uint8ClampedTag = "[object Uint8ClampedArray]", $f90548db9877a9f0$var$uint16Tag = "[object Uint16Array]", $f90548db9877a9f0$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $f90548db9877a9f0$var$cloneableTags = {};
$f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$argsTag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$arrayTag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$arrayBufferTag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$dataViewTag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$boolTag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$dateTag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$float32Tag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$float64Tag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$int8Tag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$int16Tag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$int32Tag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$mapTag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$numberTag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$objectTag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$regexpTag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$setTag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$stringTag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$symbolTag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$uint8Tag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$uint8ClampedTag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$uint16Tag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$uint32Tag] = true;
$f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$errorTag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$funcTag] = $f90548db9877a9f0$var$cloneableTags[$f90548db9877a9f0$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $f90548db9877a9f0$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $f90548db9877a9f0$var$CLONE_DEEP_FLAG, isFlat = bitmask & $f90548db9877a9f0$var$CLONE_FLAT_FLAG, isFull = bitmask & $f90548db9877a9f0$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $Fe8Bj.default)(value)) return value;
    var isArr = (0, $33nEL.default)(value);
    if (isArr) {
        result = (0, $dAC45.default)(value);
        if (!isDeep) return (0, $4SU39.default)(value, result);
    } else {
        var tag = (0, $5tANM.default)(value), isFunc = tag == $f90548db9877a9f0$var$funcTag || tag == $f90548db9877a9f0$var$genTag;
        if ((0, $42zX7.default)(value)) return (0, $hxqqj.default)(value, isDeep);
        if (tag == $f90548db9877a9f0$var$objectTag || tag == $f90548db9877a9f0$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $58JU4.default)(value);
            if (!isDeep) return isFlat ? (0, $5jxL7.default)(value, (0, $g6cqQ.default)(result, value)) : (0, $lePeF.default)(value, (0, $8C6dA.default)(result, value));
        } else {
            if (!$f90548db9877a9f0$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $eb4iR.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $jM8yz.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $2wlFV.default)(value)) value.forEach(function(subValue) {
        result.add($f90548db9877a9f0$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $lWJfM.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $f90548db9877a9f0$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $5yyiu.default) : (0, $5Ha17.default) : isFlat ? (0, $8dFDc.default) : (0, $5346i.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $90u1U.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $8rINC.default)(result, key, $f90548db9877a9f0$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $f90548db9877a9f0$export$2e2bcd8739ae039 = $f90548db9877a9f0$var$baseClone;

});
parcelRegister("jM8yz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6592328fa3b7cff$export$2e2bcd8739ae039; });

var $f6PS2 = parcelRequire("f6PS2");

var $lJpJn = parcelRequire("lJpJn");

var $7WRWi = parcelRequire("7WRWi");

var $jDqSk = parcelRequire("jDqSk");

var $i1boX = parcelRequire("i1boX");

var $fxjv7 = parcelRequire("fxjv7");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e6592328fa3b7cff$var$Stack(entries) {
    var data = this.__data__ = new (0, $f6PS2.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$e6592328fa3b7cff$var$Stack.prototype.clear = (0, $lJpJn.default);
$e6592328fa3b7cff$var$Stack.prototype["delete"] = (0, $7WRWi.default);
$e6592328fa3b7cff$var$Stack.prototype.get = (0, $jDqSk.default);
$e6592328fa3b7cff$var$Stack.prototype.has = (0, $i1boX.default);
$e6592328fa3b7cff$var$Stack.prototype.set = (0, $fxjv7.default);
var $e6592328fa3b7cff$export$2e2bcd8739ae039 = $e6592328fa3b7cff$var$Stack;

});
parcelRegister("f6PS2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afffa6f4c96836f6$export$2e2bcd8739ae039; });

var $cyqgf = parcelRequire("cyqgf");

var $lXGX2 = parcelRequire("lXGX2");

var $kRtZq = parcelRequire("kRtZq");

var $aFFWE = parcelRequire("aFFWE");

var $9Q4pX = parcelRequire("9Q4pX");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $afffa6f4c96836f6$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$afffa6f4c96836f6$var$ListCache.prototype.clear = (0, $cyqgf.default);
$afffa6f4c96836f6$var$ListCache.prototype["delete"] = (0, $lXGX2.default);
$afffa6f4c96836f6$var$ListCache.prototype.get = (0, $kRtZq.default);
$afffa6f4c96836f6$var$ListCache.prototype.has = (0, $aFFWE.default);
$afffa6f4c96836f6$var$ListCache.prototype.set = (0, $9Q4pX.default);
var $afffa6f4c96836f6$export$2e2bcd8739ae039 = $afffa6f4c96836f6$var$ListCache;

});
parcelRegister("cyqgf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $923d07e5bd755e1b$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $923d07e5bd755e1b$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $923d07e5bd755e1b$export$2e2bcd8739ae039 = $923d07e5bd755e1b$var$listCacheClear;

});

parcelRegister("lXGX2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffd06ce239ba235e$export$2e2bcd8739ae039; });

var $dUJZ9 = parcelRequire("dUJZ9");
/** Used for built-in method references. */ var $ffd06ce239ba235e$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $ffd06ce239ba235e$var$splice = $ffd06ce239ba235e$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ffd06ce239ba235e$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $dUJZ9.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $ffd06ce239ba235e$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $ffd06ce239ba235e$export$2e2bcd8739ae039 = $ffd06ce239ba235e$var$listCacheDelete;

});
parcelRegister("dUJZ9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2142d06309f720f$export$2e2bcd8739ae039; });

var $lRO90 = parcelRequire("lRO90");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a2142d06309f720f$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $lRO90.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $a2142d06309f720f$export$2e2bcd8739ae039 = $a2142d06309f720f$var$assocIndexOf;

});
parcelRegister("lRO90", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $feb571d478a1b130$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $feb571d478a1b130$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $feb571d478a1b130$export$2e2bcd8739ae039 = $feb571d478a1b130$var$eq;

});



parcelRegister("kRtZq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f300053e63a9f018$export$2e2bcd8739ae039; });

var $dUJZ9 = parcelRequire("dUJZ9");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f300053e63a9f018$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $dUJZ9.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $f300053e63a9f018$export$2e2bcd8739ae039 = $f300053e63a9f018$var$listCacheGet;

});

parcelRegister("aFFWE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c4e452211e7ee66$export$2e2bcd8739ae039; });

var $dUJZ9 = parcelRequire("dUJZ9");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7c4e452211e7ee66$var$listCacheHas(key) {
    return (0, $dUJZ9.default)(this.__data__, key) > -1;
}
var $7c4e452211e7ee66$export$2e2bcd8739ae039 = $7c4e452211e7ee66$var$listCacheHas;

});

parcelRegister("9Q4pX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $729c659de0dce628$export$2e2bcd8739ae039; });

var $dUJZ9 = parcelRequire("dUJZ9");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $729c659de0dce628$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $dUJZ9.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $729c659de0dce628$export$2e2bcd8739ae039 = $729c659de0dce628$var$listCacheSet;

});


parcelRegister("lJpJn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd21c29410773135$export$2e2bcd8739ae039; });

var $f6PS2 = parcelRequire("f6PS2");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $fd21c29410773135$var$stackClear() {
    this.__data__ = new (0, $f6PS2.default);
    this.size = 0;
}
var $fd21c29410773135$export$2e2bcd8739ae039 = $fd21c29410773135$var$stackClear;

});

parcelRegister("7WRWi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c97ca62846496b6$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5c97ca62846496b6$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $5c97ca62846496b6$export$2e2bcd8739ae039 = $5c97ca62846496b6$var$stackDelete;

});

parcelRegister("jDqSk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4b681b6ccc50f73$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e4b681b6ccc50f73$var$stackGet(key) {
    return this.__data__.get(key);
}
var $e4b681b6ccc50f73$export$2e2bcd8739ae039 = $e4b681b6ccc50f73$var$stackGet;

});

parcelRegister("i1boX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03629973f563bb2e$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $03629973f563bb2e$var$stackHas(key) {
    return this.__data__.has(key);
}
var $03629973f563bb2e$export$2e2bcd8739ae039 = $03629973f563bb2e$var$stackHas;

});

parcelRegister("fxjv7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4f910932c841243$export$2e2bcd8739ae039; });

var $f6PS2 = parcelRequire("f6PS2");

var $1Q5Wv = parcelRequire("1Q5Wv");

var $brubW = parcelRequire("brubW");
/** Used as the size to enable large array optimizations. */ var $b4f910932c841243$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $b4f910932c841243$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $f6PS2.default)) {
        var pairs = data.__data__;
        if (!(0, $1Q5Wv.default) || pairs.length < $b4f910932c841243$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $brubW.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $b4f910932c841243$export$2e2bcd8739ae039 = $b4f910932c841243$var$stackSet;

});
parcelRegister("1Q5Wv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $156f41d5ff935813$export$2e2bcd8739ae039; });

var $bDPg8 = parcelRequire("bDPg8");

var $9ll1t = parcelRequire("9ll1t");
/* Built-in method references that are verified to be native. */ var $156f41d5ff935813$var$Map = (0, $bDPg8.default)((0, $9ll1t.default), "Map");
var $156f41d5ff935813$export$2e2bcd8739ae039 = $156f41d5ff935813$var$Map;

});
parcelRegister("bDPg8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $879b193d89752759$export$2e2bcd8739ae039; });

var $bRgu9 = parcelRequire("bRgu9");

var $1Xrb7 = parcelRequire("1Xrb7");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $879b193d89752759$var$getNative(object, key) {
    var value = (0, $1Xrb7.default)(object, key);
    return (0, $bRgu9.default)(value) ? value : undefined;
}
var $879b193d89752759$export$2e2bcd8739ae039 = $879b193d89752759$var$getNative;

});
parcelRegister("bRgu9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a216e99eb1e7ce9$export$2e2bcd8739ae039; });

var $7P8ts = parcelRequire("7P8ts");

var $gxHBa = parcelRequire("gxHBa");

var $Fe8Bj = parcelRequire("Fe8Bj");

var $TXIpm = parcelRequire("TXIpm");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8a216e99eb1e7ce9$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8a216e99eb1e7ce9$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8a216e99eb1e7ce9$var$funcProto = Function.prototype, $8a216e99eb1e7ce9$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8a216e99eb1e7ce9$var$funcToString = $8a216e99eb1e7ce9$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8a216e99eb1e7ce9$var$hasOwnProperty = $8a216e99eb1e7ce9$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8a216e99eb1e7ce9$var$reIsNative = RegExp("^" + $8a216e99eb1e7ce9$var$funcToString.call($8a216e99eb1e7ce9$var$hasOwnProperty).replace($8a216e99eb1e7ce9$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8a216e99eb1e7ce9$var$baseIsNative(value) {
    if (!(0, $Fe8Bj.default)(value) || (0, $gxHBa.default)(value)) return false;
    var pattern = (0, $7P8ts.default)(value) ? $8a216e99eb1e7ce9$var$reIsNative : $8a216e99eb1e7ce9$var$reIsHostCtor;
    return pattern.test((0, $TXIpm.default)(value));
}
var $8a216e99eb1e7ce9$export$2e2bcd8739ae039 = $8a216e99eb1e7ce9$var$baseIsNative;

});
parcelRegister("7P8ts", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b23de970ad41c77$export$2e2bcd8739ae039; });

var $1KJeP = parcelRequire("1KJeP");

var $Fe8Bj = parcelRequire("Fe8Bj");
/** `Object#toString` result references. */ var $5b23de970ad41c77$var$asyncTag = "[object AsyncFunction]", $5b23de970ad41c77$var$funcTag = "[object Function]", $5b23de970ad41c77$var$genTag = "[object GeneratorFunction]", $5b23de970ad41c77$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $5b23de970ad41c77$var$isFunction(value) {
    if (!(0, $Fe8Bj.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $1KJeP.default)(value);
    return tag == $5b23de970ad41c77$var$funcTag || tag == $5b23de970ad41c77$var$genTag || tag == $5b23de970ad41c77$var$asyncTag || tag == $5b23de970ad41c77$var$proxyTag;
}
var $5b23de970ad41c77$export$2e2bcd8739ae039 = $5b23de970ad41c77$var$isFunction;

});
parcelRegister("Fe8Bj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07becbe842560f43$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $07becbe842560f43$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $07becbe842560f43$export$2e2bcd8739ae039 = $07becbe842560f43$var$isObject;

});


parcelRegister("gxHBa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0b18c2991de85bf$export$2e2bcd8739ae039; });

var $dqEJl = parcelRequire("dqEJl");
/** Used to detect methods masquerading as native. */ var $c0b18c2991de85bf$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $dqEJl.default) && (0, $dqEJl.default).keys && (0, $dqEJl.default).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $c0b18c2991de85bf$var$isMasked(func) {
    return !!$c0b18c2991de85bf$var$maskSrcKey && $c0b18c2991de85bf$var$maskSrcKey in func;
}
var $c0b18c2991de85bf$export$2e2bcd8739ae039 = $c0b18c2991de85bf$var$isMasked;

});
parcelRegister("dqEJl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c6d4c4040f4af19$export$2e2bcd8739ae039; });

var $9ll1t = parcelRequire("9ll1t");
/** Used to detect overreaching core-js shims. */ var $9c6d4c4040f4af19$var$coreJsData = (0, $9ll1t.default)["__core-js_shared__"];
var $9c6d4c4040f4af19$export$2e2bcd8739ae039 = $9c6d4c4040f4af19$var$coreJsData;

});


parcelRegister("TXIpm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a837560248729dc$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $0a837560248729dc$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $0a837560248729dc$var$funcToString = $0a837560248729dc$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $0a837560248729dc$var$toSource(func) {
    if (func != null) {
        try {
            return $0a837560248729dc$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $0a837560248729dc$export$2e2bcd8739ae039 = $0a837560248729dc$var$toSource;

});


parcelRegister("1Xrb7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16d062310ad1c4f4$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $16d062310ad1c4f4$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $16d062310ad1c4f4$export$2e2bcd8739ae039 = $16d062310ad1c4f4$var$getValue;

});



parcelRegister("brubW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8549a2c1604511f6$export$2e2bcd8739ae039; });

var $lMY5G = parcelRequire("lMY5G");

var $hUYFe = parcelRequire("hUYFe");

var $fMJTk = parcelRequire("fMJTk");

var $3Cqib = parcelRequire("3Cqib");

var $d6gDT = parcelRequire("d6gDT");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8549a2c1604511f6$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$8549a2c1604511f6$var$MapCache.prototype.clear = (0, $lMY5G.default);
$8549a2c1604511f6$var$MapCache.prototype["delete"] = (0, $hUYFe.default);
$8549a2c1604511f6$var$MapCache.prototype.get = (0, $fMJTk.default);
$8549a2c1604511f6$var$MapCache.prototype.has = (0, $3Cqib.default);
$8549a2c1604511f6$var$MapCache.prototype.set = (0, $d6gDT.default);
var $8549a2c1604511f6$export$2e2bcd8739ae039 = $8549a2c1604511f6$var$MapCache;

});
parcelRegister("lMY5G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdccb168d43749aa$export$2e2bcd8739ae039; });

var $bqOZU = parcelRequire("bqOZU");

var $f6PS2 = parcelRequire("f6PS2");

var $1Q5Wv = parcelRequire("1Q5Wv");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $fdccb168d43749aa$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $bqOZU.default),
        "map": new ((0, $1Q5Wv.default) || (0, $f6PS2.default)),
        "string": new (0, $bqOZU.default)
    };
}
var $fdccb168d43749aa$export$2e2bcd8739ae039 = $fdccb168d43749aa$var$mapCacheClear;

});
parcelRegister("bqOZU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8529ae72ba31be7b$export$2e2bcd8739ae039; });

var $4qOtV = parcelRequire("4qOtV");

var $bQupP = parcelRequire("bQupP");

var $8ulmp = parcelRequire("8ulmp");

var $gZO7r = parcelRequire("gZO7r");

var $3539y = parcelRequire("3539y");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8529ae72ba31be7b$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8529ae72ba31be7b$var$Hash.prototype.clear = (0, $4qOtV.default);
$8529ae72ba31be7b$var$Hash.prototype["delete"] = (0, $bQupP.default);
$8529ae72ba31be7b$var$Hash.prototype.get = (0, $8ulmp.default);
$8529ae72ba31be7b$var$Hash.prototype.has = (0, $gZO7r.default);
$8529ae72ba31be7b$var$Hash.prototype.set = (0, $3539y.default);
var $8529ae72ba31be7b$export$2e2bcd8739ae039 = $8529ae72ba31be7b$var$Hash;

});
parcelRegister("4qOtV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33a0bfbe65127809$export$2e2bcd8739ae039; });

var $bOTYx = parcelRequire("bOTYx");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $33a0bfbe65127809$var$hashClear() {
    this.__data__ = (0, $bOTYx.default) ? (0, $bOTYx.default)(null) : {};
    this.size = 0;
}
var $33a0bfbe65127809$export$2e2bcd8739ae039 = $33a0bfbe65127809$var$hashClear;

});
parcelRegister("bOTYx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89afc8c8d1acc20b$export$2e2bcd8739ae039; });

var $bDPg8 = parcelRequire("bDPg8");
/* Built-in method references that are verified to be native. */ var $89afc8c8d1acc20b$var$nativeCreate = (0, $bDPg8.default)(Object, "create");
var $89afc8c8d1acc20b$export$2e2bcd8739ae039 = $89afc8c8d1acc20b$var$nativeCreate;

});


parcelRegister("bQupP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89fc24ed7c49f331$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $89fc24ed7c49f331$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $89fc24ed7c49f331$export$2e2bcd8739ae039 = $89fc24ed7c49f331$var$hashDelete;

});

parcelRegister("8ulmp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62e1b1d173843c23$export$2e2bcd8739ae039; });

var $bOTYx = parcelRequire("bOTYx");
/** Used to stand-in for `undefined` hash values. */ var $62e1b1d173843c23$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $62e1b1d173843c23$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $62e1b1d173843c23$var$hasOwnProperty = $62e1b1d173843c23$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $62e1b1d173843c23$var$hashGet(key) {
    var data = this.__data__;
    if (0, $bOTYx.default) {
        var result = data[key];
        return result === $62e1b1d173843c23$var$HASH_UNDEFINED ? undefined : result;
    }
    return $62e1b1d173843c23$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $62e1b1d173843c23$export$2e2bcd8739ae039 = $62e1b1d173843c23$var$hashGet;

});

parcelRegister("gZO7r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5f938761d09a607$export$2e2bcd8739ae039; });

var $bOTYx = parcelRequire("bOTYx");
/** Used for built-in method references. */ var $c5f938761d09a607$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c5f938761d09a607$var$hasOwnProperty = $c5f938761d09a607$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c5f938761d09a607$var$hashHas(key) {
    var data = this.__data__;
    return (0, $bOTYx.default) ? data[key] !== undefined : $c5f938761d09a607$var$hasOwnProperty.call(data, key);
}
var $c5f938761d09a607$export$2e2bcd8739ae039 = $c5f938761d09a607$var$hashHas;

});

parcelRegister("3539y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23e448e34ed61ff9$export$2e2bcd8739ae039; });

var $bOTYx = parcelRequire("bOTYx");
/** Used to stand-in for `undefined` hash values. */ var $23e448e34ed61ff9$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $23e448e34ed61ff9$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $bOTYx.default) && value === undefined ? $23e448e34ed61ff9$var$HASH_UNDEFINED : value;
    return this;
}
var $23e448e34ed61ff9$export$2e2bcd8739ae039 = $23e448e34ed61ff9$var$hashSet;

});



parcelRegister("hUYFe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0b6b9424e41b4a4$export$2e2bcd8739ae039; });

var $4Kl9A = parcelRequire("4Kl9A");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d0b6b9424e41b4a4$var$mapCacheDelete(key) {
    var result = (0, $4Kl9A.default)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $d0b6b9424e41b4a4$export$2e2bcd8739ae039 = $d0b6b9424e41b4a4$var$mapCacheDelete;

});
parcelRegister("4Kl9A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $374bddf4cfcd20f4$export$2e2bcd8739ae039; });

var $aunk3 = parcelRequire("aunk3");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $374bddf4cfcd20f4$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $aunk3.default)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $374bddf4cfcd20f4$export$2e2bcd8739ae039 = $374bddf4cfcd20f4$var$getMapData;

});
parcelRegister("aunk3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a2ecc195bfd504d$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $7a2ecc195bfd504d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $7a2ecc195bfd504d$export$2e2bcd8739ae039 = $7a2ecc195bfd504d$var$isKeyable;

});



parcelRegister("fMJTk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7deefc443e0d61b$export$2e2bcd8739ae039; });

var $4Kl9A = parcelRequire("4Kl9A");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b7deefc443e0d61b$var$mapCacheGet(key) {
    return (0, $4Kl9A.default)(this, key).get(key);
}
var $b7deefc443e0d61b$export$2e2bcd8739ae039 = $b7deefc443e0d61b$var$mapCacheGet;

});

parcelRegister("3Cqib", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a2950d04caf1066$export$2e2bcd8739ae039; });

var $4Kl9A = parcelRequire("4Kl9A");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2a2950d04caf1066$var$mapCacheHas(key) {
    return (0, $4Kl9A.default)(this, key).has(key);
}
var $2a2950d04caf1066$export$2e2bcd8739ae039 = $2a2950d04caf1066$var$mapCacheHas;

});

parcelRegister("d6gDT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9898bec037d1a5c7$export$2e2bcd8739ae039; });

var $4Kl9A = parcelRequire("4Kl9A");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $9898bec037d1a5c7$var$mapCacheSet(key, value) {
    var data = (0, $4Kl9A.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $9898bec037d1a5c7$export$2e2bcd8739ae039 = $9898bec037d1a5c7$var$mapCacheSet;

});




parcelRegister("90u1U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68eb68733025ba6c$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $68eb68733025ba6c$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $68eb68733025ba6c$export$2e2bcd8739ae039 = $68eb68733025ba6c$var$arrayEach;

});

parcelRegister("8rINC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $626398886e72cf9f$export$2e2bcd8739ae039; });

var $4x9Xx = parcelRequire("4x9Xx");

var $lRO90 = parcelRequire("lRO90");
/** Used for built-in method references. */ var $626398886e72cf9f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $626398886e72cf9f$var$hasOwnProperty = $626398886e72cf9f$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $626398886e72cf9f$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($626398886e72cf9f$var$hasOwnProperty.call(object, key) && (0, $lRO90.default)(objValue, value)) || value === undefined && !(key in object)) (0, $4x9Xx.default)(object, key, value);
}
var $626398886e72cf9f$export$2e2bcd8739ae039 = $626398886e72cf9f$var$assignValue;

});
parcelRegister("4x9Xx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34d1f838bcbdc983$export$2e2bcd8739ae039; });

var $frqAb = parcelRequire("frqAb");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $34d1f838bcbdc983$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $frqAb.default)) (0, $frqAb.default)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $34d1f838bcbdc983$export$2e2bcd8739ae039 = $34d1f838bcbdc983$var$baseAssignValue;

});
parcelRegister("frqAb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3ddff625609c4de$export$2e2bcd8739ae039; });

var $bDPg8 = parcelRequire("bDPg8");
var $b3ddff625609c4de$var$defineProperty = function() {
    try {
        var func = (0, $bDPg8.default)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $b3ddff625609c4de$export$2e2bcd8739ae039 = $b3ddff625609c4de$var$defineProperty;

});



parcelRegister("8C6dA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6456b2269b5ab3b3$export$2e2bcd8739ae039; });

var $cc9j5 = parcelRequire("cc9j5");

var $5346i = parcelRequire("5346i");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $6456b2269b5ab3b3$var$baseAssign(object, source) {
    return object && (0, $cc9j5.default)(source, (0, $5346i.default)(source), object);
}
var $6456b2269b5ab3b3$export$2e2bcd8739ae039 = $6456b2269b5ab3b3$var$baseAssign;

});
parcelRegister("cc9j5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e0dd3268e5d1c53$export$2e2bcd8739ae039; });

var $8rINC = parcelRequire("8rINC");

var $4x9Xx = parcelRequire("4x9Xx");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $8e0dd3268e5d1c53$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $4x9Xx.default)(object, key, newValue);
        else (0, $8rINC.default)(object, key, newValue);
    }
    return object;
}
var $8e0dd3268e5d1c53$export$2e2bcd8739ae039 = $8e0dd3268e5d1c53$var$copyObject;

});

parcelRegister("5346i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ad069d6188ea032$export$2e2bcd8739ae039; });

var $8RAQR = parcelRequire("8RAQR");

var $dsNHS = parcelRequire("dsNHS");

var $5uImb = parcelRequire("5uImb");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $3ad069d6188ea032$var$keys(object) {
    return (0, $5uImb.default)(object) ? (0, $8RAQR.default)(object) : (0, $dsNHS.default)(object);
}
var $3ad069d6188ea032$export$2e2bcd8739ae039 = $3ad069d6188ea032$var$keys;

});
parcelRegister("8RAQR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $673fdbebcafa2dfc$export$2e2bcd8739ae039; });

var $jDkwJ = parcelRequire("jDkwJ");

var $eAYys = parcelRequire("eAYys");

var $33nEL = parcelRequire("33nEL");

var $42zX7 = parcelRequire("42zX7");

var $g6IOa = parcelRequire("g6IOa");

var $2WO5x = parcelRequire("2WO5x");
/** Used for built-in method references. */ var $673fdbebcafa2dfc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $673fdbebcafa2dfc$var$hasOwnProperty = $673fdbebcafa2dfc$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $673fdbebcafa2dfc$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $33nEL.default)(value), isArg = !isArr && (0, $eAYys.default)(value), isBuff = !isArr && !isArg && (0, $42zX7.default)(value), isType = !isArr && !isArg && !isBuff && (0, $2WO5x.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $jDkwJ.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $673fdbebcafa2dfc$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $g6IOa.default)(key, length)))) result.push(key);
    return result;
}
var $673fdbebcafa2dfc$export$2e2bcd8739ae039 = $673fdbebcafa2dfc$var$arrayLikeKeys;

});
parcelRegister("jDkwJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4b1951583275f81$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $e4b1951583275f81$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $e4b1951583275f81$export$2e2bcd8739ae039 = $e4b1951583275f81$var$baseTimes;

});

parcelRegister("eAYys", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa03666a69407557$export$2e2bcd8739ae039; });

var $5gdGi = parcelRequire("5gdGi");

var $4JZNr = parcelRequire("4JZNr");
/** Used for built-in method references. */ var $aa03666a69407557$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $aa03666a69407557$var$hasOwnProperty = $aa03666a69407557$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $aa03666a69407557$var$propertyIsEnumerable = $aa03666a69407557$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $aa03666a69407557$var$isArguments = (0, $5gdGi.default)(function() {
    return arguments;
}()) ? (0, $5gdGi.default) : function(value) {
    return (0, $4JZNr.default)(value) && $aa03666a69407557$var$hasOwnProperty.call(value, "callee") && !$aa03666a69407557$var$propertyIsEnumerable.call(value, "callee");
};
var $aa03666a69407557$export$2e2bcd8739ae039 = $aa03666a69407557$var$isArguments;

});
parcelRegister("5gdGi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d490f2b2f68c137$export$2e2bcd8739ae039; });

var $1KJeP = parcelRequire("1KJeP");

var $4JZNr = parcelRequire("4JZNr");
/** `Object#toString` result references. */ var $3d490f2b2f68c137$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $3d490f2b2f68c137$var$baseIsArguments(value) {
    return (0, $4JZNr.default)(value) && (0, $1KJeP.default)(value) == $3d490f2b2f68c137$var$argsTag;
}
var $3d490f2b2f68c137$export$2e2bcd8739ae039 = $3d490f2b2f68c137$var$baseIsArguments;

});


parcelRegister("33nEL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2394009e090676ba$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $2394009e090676ba$var$isArray = Array.isArray;
var $2394009e090676ba$export$2e2bcd8739ae039 = $2394009e090676ba$var$isArray;

});

parcelRegister("42zX7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f133cbee951af38$export$2e2bcd8739ae039; });

var $9ll1t = parcelRequire("9ll1t");

var $8ymtS = parcelRequire("8ymtS");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $9ll1t.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $8ymtS.default);
var $2f133cbee951af38$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("8ymtS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63a2eff0154e29ac$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $63a2eff0154e29ac$var$stubFalse() {
    return false;
}
var $63a2eff0154e29ac$export$2e2bcd8739ae039 = $63a2eff0154e29ac$var$stubFalse;

});


parcelRegister("g6IOa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb9ff6d579aae878$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $bb9ff6d579aae878$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $bb9ff6d579aae878$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $bb9ff6d579aae878$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $bb9ff6d579aae878$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $bb9ff6d579aae878$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $bb9ff6d579aae878$export$2e2bcd8739ae039 = $bb9ff6d579aae878$var$isIndex;

});

parcelRegister("2WO5x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2257da097ca9123a$export$2e2bcd8739ae039; });

var $PZgH6 = parcelRequire("PZgH6");

var $azCpN = parcelRequire("azCpN");

var $4aMdn = parcelRequire("4aMdn");
/* Node.js helper references. */ var $2257da097ca9123a$var$nodeIsTypedArray = (0, $4aMdn.default) && (0, $4aMdn.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $2257da097ca9123a$var$isTypedArray = $2257da097ca9123a$var$nodeIsTypedArray ? (0, $azCpN.default)($2257da097ca9123a$var$nodeIsTypedArray) : (0, $PZgH6.default);
var $2257da097ca9123a$export$2e2bcd8739ae039 = $2257da097ca9123a$var$isTypedArray;

});
parcelRegister("PZgH6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09c44a22ba766f1c$export$2e2bcd8739ae039; });

var $1KJeP = parcelRequire("1KJeP");

var $aj2lF = parcelRequire("aj2lF");

var $4JZNr = parcelRequire("4JZNr");
/** `Object#toString` result references. */ var $09c44a22ba766f1c$var$argsTag = "[object Arguments]", $09c44a22ba766f1c$var$arrayTag = "[object Array]", $09c44a22ba766f1c$var$boolTag = "[object Boolean]", $09c44a22ba766f1c$var$dateTag = "[object Date]", $09c44a22ba766f1c$var$errorTag = "[object Error]", $09c44a22ba766f1c$var$funcTag = "[object Function]", $09c44a22ba766f1c$var$mapTag = "[object Map]", $09c44a22ba766f1c$var$numberTag = "[object Number]", $09c44a22ba766f1c$var$objectTag = "[object Object]", $09c44a22ba766f1c$var$regexpTag = "[object RegExp]", $09c44a22ba766f1c$var$setTag = "[object Set]", $09c44a22ba766f1c$var$stringTag = "[object String]", $09c44a22ba766f1c$var$weakMapTag = "[object WeakMap]";
var $09c44a22ba766f1c$var$arrayBufferTag = "[object ArrayBuffer]", $09c44a22ba766f1c$var$dataViewTag = "[object DataView]", $09c44a22ba766f1c$var$float32Tag = "[object Float32Array]", $09c44a22ba766f1c$var$float64Tag = "[object Float64Array]", $09c44a22ba766f1c$var$int8Tag = "[object Int8Array]", $09c44a22ba766f1c$var$int16Tag = "[object Int16Array]", $09c44a22ba766f1c$var$int32Tag = "[object Int32Array]", $09c44a22ba766f1c$var$uint8Tag = "[object Uint8Array]", $09c44a22ba766f1c$var$uint8ClampedTag = "[object Uint8ClampedArray]", $09c44a22ba766f1c$var$uint16Tag = "[object Uint16Array]", $09c44a22ba766f1c$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $09c44a22ba766f1c$var$typedArrayTags = {};
$09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$float32Tag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$float64Tag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$int8Tag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$int16Tag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$int32Tag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$uint8Tag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$uint8ClampedTag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$uint16Tag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$uint32Tag] = true;
$09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$argsTag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$arrayTag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$arrayBufferTag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$boolTag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$dataViewTag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$dateTag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$errorTag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$funcTag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$mapTag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$numberTag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$objectTag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$regexpTag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$setTag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$stringTag] = $09c44a22ba766f1c$var$typedArrayTags[$09c44a22ba766f1c$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $09c44a22ba766f1c$var$baseIsTypedArray(value) {
    return (0, $4JZNr.default)(value) && (0, $aj2lF.default)(value.length) && !!$09c44a22ba766f1c$var$typedArrayTags[(0, $1KJeP.default)(value)];
}
var $09c44a22ba766f1c$export$2e2bcd8739ae039 = $09c44a22ba766f1c$var$baseIsTypedArray;

});
parcelRegister("aj2lF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $780d8011517b0058$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $780d8011517b0058$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $780d8011517b0058$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $780d8011517b0058$var$MAX_SAFE_INTEGER;
}
var $780d8011517b0058$export$2e2bcd8739ae039 = $780d8011517b0058$var$isLength;

});


parcelRegister("azCpN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b2af8b82c84b4fe$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $7b2af8b82c84b4fe$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $7b2af8b82c84b4fe$export$2e2bcd8739ae039 = $7b2af8b82c84b4fe$var$baseUnary;

});

parcelRegister("4aMdn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $309d7f0b84d71000$export$2e2bcd8739ae039; });

var $MhvlD = parcelRequire("MhvlD");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $MhvlD.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $309d7f0b84d71000$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("dsNHS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cd4729339ca2b6e$export$2e2bcd8739ae039; });

var $dSmSR = parcelRequire("dSmSR");

var $5XQx7 = parcelRequire("5XQx7");
/** Used for built-in method references. */ var $9cd4729339ca2b6e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9cd4729339ca2b6e$var$hasOwnProperty = $9cd4729339ca2b6e$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $9cd4729339ca2b6e$var$baseKeys(object) {
    if (!(0, $dSmSR.default)(object)) return (0, $5XQx7.default)(object);
    var result = [];
    for(var key in Object(object))if ($9cd4729339ca2b6e$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $9cd4729339ca2b6e$export$2e2bcd8739ae039 = $9cd4729339ca2b6e$var$baseKeys;

});
parcelRegister("dSmSR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1a211c438e1442d$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $a1a211c438e1442d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $a1a211c438e1442d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $a1a211c438e1442d$var$objectProto;
    return value === proto;
}
var $a1a211c438e1442d$export$2e2bcd8739ae039 = $a1a211c438e1442d$var$isPrototype;

});

parcelRegister("5XQx7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $457b3669d3bc2ed4$export$2e2bcd8739ae039; });

var $egmH2 = parcelRequire("egmH2");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $457b3669d3bc2ed4$var$nativeKeys = (0, $egmH2.default)(Object.keys, Object);
var $457b3669d3bc2ed4$export$2e2bcd8739ae039 = $457b3669d3bc2ed4$var$nativeKeys;

});


parcelRegister("5uImb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4002296f8769c358$export$2e2bcd8739ae039; });

var $7P8ts = parcelRequire("7P8ts");

var $aj2lF = parcelRequire("aj2lF");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $4002296f8769c358$var$isArrayLike(value) {
    return value != null && (0, $aj2lF.default)(value.length) && !(0, $7P8ts.default)(value);
}
var $4002296f8769c358$export$2e2bcd8739ae039 = $4002296f8769c358$var$isArrayLike;

});



parcelRegister("g6cqQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb86d99c24a734ea$export$2e2bcd8739ae039; });

var $cc9j5 = parcelRequire("cc9j5");

var $8dFDc = parcelRequire("8dFDc");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $bb86d99c24a734ea$var$baseAssignIn(object, source) {
    return object && (0, $cc9j5.default)(source, (0, $8dFDc.default)(source), object);
}
var $bb86d99c24a734ea$export$2e2bcd8739ae039 = $bb86d99c24a734ea$var$baseAssignIn;

});
parcelRegister("8dFDc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fbfd4b922265130$export$2e2bcd8739ae039; });

var $8RAQR = parcelRequire("8RAQR");

var $8sAtq = parcelRequire("8sAtq");

var $5uImb = parcelRequire("5uImb");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $5fbfd4b922265130$var$keysIn(object) {
    return (0, $5uImb.default)(object) ? (0, $8RAQR.default)(object, true) : (0, $8sAtq.default)(object);
}
var $5fbfd4b922265130$export$2e2bcd8739ae039 = $5fbfd4b922265130$var$keysIn;

});
parcelRegister("8sAtq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $628d3b2c6091c454$export$2e2bcd8739ae039; });

var $Fe8Bj = parcelRequire("Fe8Bj");

var $dSmSR = parcelRequire("dSmSR");

var $j07iw = parcelRequire("j07iw");
/** Used for built-in method references. */ var $628d3b2c6091c454$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $628d3b2c6091c454$var$hasOwnProperty = $628d3b2c6091c454$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $628d3b2c6091c454$var$baseKeysIn(object) {
    if (!(0, $Fe8Bj.default)(object)) return (0, $j07iw.default)(object);
    var isProto = (0, $dSmSR.default)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$628d3b2c6091c454$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $628d3b2c6091c454$export$2e2bcd8739ae039 = $628d3b2c6091c454$var$baseKeysIn;

});
parcelRegister("j07iw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd53ad99cfd191cb$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $dd53ad99cfd191cb$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $dd53ad99cfd191cb$export$2e2bcd8739ae039 = $dd53ad99cfd191cb$var$nativeKeysIn;

});




parcelRegister("hxqqj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc4a03db83462f99$export$2e2bcd8739ae039; });

var $9ll1t = parcelRequire("9ll1t");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $9ll1t.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $cc4a03db83462f99$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("4SU39", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38e7aee4bc4640ea$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $38e7aee4bc4640ea$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $38e7aee4bc4640ea$export$2e2bcd8739ae039 = $38e7aee4bc4640ea$var$copyArray;

});

parcelRegister("lePeF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f762a614bf00c6cf$export$2e2bcd8739ae039; });

var $cc9j5 = parcelRequire("cc9j5");

var $9gx7Q = parcelRequire("9gx7Q");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $f762a614bf00c6cf$var$copySymbols(source, object) {
    return (0, $cc9j5.default)(source, (0, $9gx7Q.default)(source), object);
}
var $f762a614bf00c6cf$export$2e2bcd8739ae039 = $f762a614bf00c6cf$var$copySymbols;

});
parcelRegister("9gx7Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bef4db6bd9f145e$export$2e2bcd8739ae039; });

var $dtFSi = parcelRequire("dtFSi");

var $f86lh = parcelRequire("f86lh");
/** Used for built-in method references. */ var $6bef4db6bd9f145e$var$objectProto = Object.prototype;
/** Built-in value references. */ var $6bef4db6bd9f145e$var$propertyIsEnumerable = $6bef4db6bd9f145e$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6bef4db6bd9f145e$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $6bef4db6bd9f145e$var$getSymbols = !$6bef4db6bd9f145e$var$nativeGetSymbols ? (0, $f86lh.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $dtFSi.default)($6bef4db6bd9f145e$var$nativeGetSymbols(object), function(symbol) {
        return $6bef4db6bd9f145e$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $6bef4db6bd9f145e$export$2e2bcd8739ae039 = $6bef4db6bd9f145e$var$getSymbols;

});
parcelRegister("dtFSi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cfe773b5bf30dde$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $9cfe773b5bf30dde$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $9cfe773b5bf30dde$export$2e2bcd8739ae039 = $9cfe773b5bf30dde$var$arrayFilter;

});

parcelRegister("f86lh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b03c85cee75383c2$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $b03c85cee75383c2$var$stubArray() {
    return [];
}
var $b03c85cee75383c2$export$2e2bcd8739ae039 = $b03c85cee75383c2$var$stubArray;

});



parcelRegister("5jxL7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3de8e9efaf6d97c2$export$2e2bcd8739ae039; });

var $cc9j5 = parcelRequire("cc9j5");

var $5Qc0I = parcelRequire("5Qc0I");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $3de8e9efaf6d97c2$var$copySymbolsIn(source, object) {
    return (0, $cc9j5.default)(source, (0, $5Qc0I.default)(source), object);
}
var $3de8e9efaf6d97c2$export$2e2bcd8739ae039 = $3de8e9efaf6d97c2$var$copySymbolsIn;

});
parcelRegister("5Qc0I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $440b201a030deb5f$export$2e2bcd8739ae039; });

var $gVarM = parcelRequire("gVarM");

var $wbPtc = parcelRequire("wbPtc");

var $9gx7Q = parcelRequire("9gx7Q");

var $f86lh = parcelRequire("f86lh");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $440b201a030deb5f$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $440b201a030deb5f$var$getSymbolsIn = !$440b201a030deb5f$var$nativeGetSymbols ? (0, $f86lh.default) : function(object) {
    var result = [];
    while(object){
        (0, $gVarM.default)(result, (0, $9gx7Q.default)(object));
        object = (0, $wbPtc.default)(object);
    }
    return result;
};
var $440b201a030deb5f$export$2e2bcd8739ae039 = $440b201a030deb5f$var$getSymbolsIn;

});
parcelRegister("gVarM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c51a12c45d8731f9$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $c51a12c45d8731f9$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $c51a12c45d8731f9$export$2e2bcd8739ae039 = $c51a12c45d8731f9$var$arrayPush;

});



parcelRegister("5Ha17", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4258bd18f2cbd0fc$export$2e2bcd8739ae039; });

var $gX0fL = parcelRequire("gX0fL");

var $9gx7Q = parcelRequire("9gx7Q");

var $5346i = parcelRequire("5346i");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $4258bd18f2cbd0fc$var$getAllKeys(object) {
    return (0, $gX0fL.default)(object, (0, $5346i.default), (0, $9gx7Q.default));
}
var $4258bd18f2cbd0fc$export$2e2bcd8739ae039 = $4258bd18f2cbd0fc$var$getAllKeys;

});
parcelRegister("gX0fL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5725a4e8f710787$export$2e2bcd8739ae039; });

var $gVarM = parcelRequire("gVarM");

var $33nEL = parcelRequire("33nEL");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c5725a4e8f710787$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $33nEL.default)(object) ? result : (0, $gVarM.default)(result, symbolsFunc(object));
}
var $c5725a4e8f710787$export$2e2bcd8739ae039 = $c5725a4e8f710787$var$baseGetAllKeys;

});


parcelRegister("5yyiu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40babb70ae1830c9$export$2e2bcd8739ae039; });

var $gX0fL = parcelRequire("gX0fL");

var $5Qc0I = parcelRequire("5Qc0I");

var $8dFDc = parcelRequire("8dFDc");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $40babb70ae1830c9$var$getAllKeysIn(object) {
    return (0, $gX0fL.default)(object, (0, $8dFDc.default), (0, $5Qc0I.default));
}
var $40babb70ae1830c9$export$2e2bcd8739ae039 = $40babb70ae1830c9$var$getAllKeysIn;

});

parcelRegister("5tANM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fcc354917911053$export$2e2bcd8739ae039; });

var $5Uu5C = parcelRequire("5Uu5C");

var $1Q5Wv = parcelRequire("1Q5Wv");

var $5dnGY = parcelRequire("5dnGY");

var $7huBS = parcelRequire("7huBS");

var $26eAP = parcelRequire("26eAP");

var $1KJeP = parcelRequire("1KJeP");

var $TXIpm = parcelRequire("TXIpm");
/** `Object#toString` result references. */ var $3fcc354917911053$var$mapTag = "[object Map]", $3fcc354917911053$var$objectTag = "[object Object]", $3fcc354917911053$var$promiseTag = "[object Promise]", $3fcc354917911053$var$setTag = "[object Set]", $3fcc354917911053$var$weakMapTag = "[object WeakMap]";
var $3fcc354917911053$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $3fcc354917911053$var$dataViewCtorString = (0, $TXIpm.default)((0, $5Uu5C.default)), $3fcc354917911053$var$mapCtorString = (0, $TXIpm.default)((0, $1Q5Wv.default)), $3fcc354917911053$var$promiseCtorString = (0, $TXIpm.default)((0, $5dnGY.default)), $3fcc354917911053$var$setCtorString = (0, $TXIpm.default)((0, $7huBS.default)), $3fcc354917911053$var$weakMapCtorString = (0, $TXIpm.default)((0, $26eAP.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $3fcc354917911053$var$getTag = (0, $1KJeP.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $5Uu5C.default) && $3fcc354917911053$var$getTag(new (0, $5Uu5C.default)(new ArrayBuffer(1))) != $3fcc354917911053$var$dataViewTag || (0, $1Q5Wv.default) && $3fcc354917911053$var$getTag(new (0, $1Q5Wv.default)) != $3fcc354917911053$var$mapTag || (0, $5dnGY.default) && $3fcc354917911053$var$getTag((0, $5dnGY.default).resolve()) != $3fcc354917911053$var$promiseTag || (0, $7huBS.default) && $3fcc354917911053$var$getTag(new (0, $7huBS.default)) != $3fcc354917911053$var$setTag || (0, $26eAP.default) && $3fcc354917911053$var$getTag(new (0, $26eAP.default)) != $3fcc354917911053$var$weakMapTag) $3fcc354917911053$var$getTag = function(value) {
    var result = (0, $1KJeP.default)(value), Ctor = result == $3fcc354917911053$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $TXIpm.default)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $3fcc354917911053$var$dataViewCtorString:
            return $3fcc354917911053$var$dataViewTag;
        case $3fcc354917911053$var$mapCtorString:
            return $3fcc354917911053$var$mapTag;
        case $3fcc354917911053$var$promiseCtorString:
            return $3fcc354917911053$var$promiseTag;
        case $3fcc354917911053$var$setCtorString:
            return $3fcc354917911053$var$setTag;
        case $3fcc354917911053$var$weakMapCtorString:
            return $3fcc354917911053$var$weakMapTag;
    }
    return result;
};
var $3fcc354917911053$export$2e2bcd8739ae039 = $3fcc354917911053$var$getTag;

});
parcelRegister("5Uu5C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44d985e6709450a9$export$2e2bcd8739ae039; });

var $bDPg8 = parcelRequire("bDPg8");

var $9ll1t = parcelRequire("9ll1t");
/* Built-in method references that are verified to be native. */ var $44d985e6709450a9$var$DataView = (0, $bDPg8.default)((0, $9ll1t.default), "DataView");
var $44d985e6709450a9$export$2e2bcd8739ae039 = $44d985e6709450a9$var$DataView;

});

parcelRegister("5dnGY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cc08b6b073ca23a$export$2e2bcd8739ae039; });

var $bDPg8 = parcelRequire("bDPg8");

var $9ll1t = parcelRequire("9ll1t");
/* Built-in method references that are verified to be native. */ var $3cc08b6b073ca23a$var$Promise = (0, $bDPg8.default)((0, $9ll1t.default), "Promise");
var $3cc08b6b073ca23a$export$2e2bcd8739ae039 = $3cc08b6b073ca23a$var$Promise;

});

parcelRegister("7huBS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54d1dd7347bcf8f3$export$2e2bcd8739ae039; });

var $bDPg8 = parcelRequire("bDPg8");

var $9ll1t = parcelRequire("9ll1t");
/* Built-in method references that are verified to be native. */ var $54d1dd7347bcf8f3$var$Set = (0, $bDPg8.default)((0, $9ll1t.default), "Set");
var $54d1dd7347bcf8f3$export$2e2bcd8739ae039 = $54d1dd7347bcf8f3$var$Set;

});

parcelRegister("26eAP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1877763174885d3b$export$2e2bcd8739ae039; });

var $bDPg8 = parcelRequire("bDPg8");

var $9ll1t = parcelRequire("9ll1t");
/* Built-in method references that are verified to be native. */ var $1877763174885d3b$var$WeakMap = (0, $bDPg8.default)((0, $9ll1t.default), "WeakMap");
var $1877763174885d3b$export$2e2bcd8739ae039 = $1877763174885d3b$var$WeakMap;

});


parcelRegister("dAC45", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e4c2a0a25b476e1$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $9e4c2a0a25b476e1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9e4c2a0a25b476e1$var$hasOwnProperty = $9e4c2a0a25b476e1$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $9e4c2a0a25b476e1$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $9e4c2a0a25b476e1$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $9e4c2a0a25b476e1$export$2e2bcd8739ae039 = $9e4c2a0a25b476e1$var$initCloneArray;

});

parcelRegister("eb4iR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5256e4ae895d816$export$2e2bcd8739ae039; });

var $fDKXy = parcelRequire("fDKXy");

var $kdrYX = parcelRequire("kdrYX");

var $foypI = parcelRequire("foypI");

var $7B36A = parcelRequire("7B36A");

var $gbA0e = parcelRequire("gbA0e");
/** `Object#toString` result references. */ var $a5256e4ae895d816$var$boolTag = "[object Boolean]", $a5256e4ae895d816$var$dateTag = "[object Date]", $a5256e4ae895d816$var$mapTag = "[object Map]", $a5256e4ae895d816$var$numberTag = "[object Number]", $a5256e4ae895d816$var$regexpTag = "[object RegExp]", $a5256e4ae895d816$var$setTag = "[object Set]", $a5256e4ae895d816$var$stringTag = "[object String]", $a5256e4ae895d816$var$symbolTag = "[object Symbol]";
var $a5256e4ae895d816$var$arrayBufferTag = "[object ArrayBuffer]", $a5256e4ae895d816$var$dataViewTag = "[object DataView]", $a5256e4ae895d816$var$float32Tag = "[object Float32Array]", $a5256e4ae895d816$var$float64Tag = "[object Float64Array]", $a5256e4ae895d816$var$int8Tag = "[object Int8Array]", $a5256e4ae895d816$var$int16Tag = "[object Int16Array]", $a5256e4ae895d816$var$int32Tag = "[object Int32Array]", $a5256e4ae895d816$var$uint8Tag = "[object Uint8Array]", $a5256e4ae895d816$var$uint8ClampedTag = "[object Uint8ClampedArray]", $a5256e4ae895d816$var$uint16Tag = "[object Uint16Array]", $a5256e4ae895d816$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $a5256e4ae895d816$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $a5256e4ae895d816$var$arrayBufferTag:
            return (0, $fDKXy.default)(object);
        case $a5256e4ae895d816$var$boolTag:
        case $a5256e4ae895d816$var$dateTag:
            return new Ctor(+object);
        case $a5256e4ae895d816$var$dataViewTag:
            return (0, $kdrYX.default)(object, isDeep);
        case $a5256e4ae895d816$var$float32Tag:
        case $a5256e4ae895d816$var$float64Tag:
        case $a5256e4ae895d816$var$int8Tag:
        case $a5256e4ae895d816$var$int16Tag:
        case $a5256e4ae895d816$var$int32Tag:
        case $a5256e4ae895d816$var$uint8Tag:
        case $a5256e4ae895d816$var$uint8ClampedTag:
        case $a5256e4ae895d816$var$uint16Tag:
        case $a5256e4ae895d816$var$uint32Tag:
            return (0, $gbA0e.default)(object, isDeep);
        case $a5256e4ae895d816$var$mapTag:
            return new Ctor;
        case $a5256e4ae895d816$var$numberTag:
        case $a5256e4ae895d816$var$stringTag:
            return new Ctor(object);
        case $a5256e4ae895d816$var$regexpTag:
            return (0, $foypI.default)(object);
        case $a5256e4ae895d816$var$setTag:
            return new Ctor;
        case $a5256e4ae895d816$var$symbolTag:
            return (0, $7B36A.default)(object);
    }
}
var $a5256e4ae895d816$export$2e2bcd8739ae039 = $a5256e4ae895d816$var$initCloneByTag;

});
parcelRegister("fDKXy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b62eecb68ca3dfda$export$2e2bcd8739ae039; });

var $60juS = parcelRequire("60juS");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $b62eecb68ca3dfda$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $60juS.default)(result).set(new (0, $60juS.default)(arrayBuffer));
    return result;
}
var $b62eecb68ca3dfda$export$2e2bcd8739ae039 = $b62eecb68ca3dfda$var$cloneArrayBuffer;

});
parcelRegister("60juS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45f1dddc83c5840a$export$2e2bcd8739ae039; });

var $9ll1t = parcelRequire("9ll1t");
/** Built-in value references. */ var $45f1dddc83c5840a$var$Uint8Array = (0, $9ll1t.default).Uint8Array;
var $45f1dddc83c5840a$export$2e2bcd8739ae039 = $45f1dddc83c5840a$var$Uint8Array;

});


parcelRegister("kdrYX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb7aba33760b260c$export$2e2bcd8739ae039; });

var $fDKXy = parcelRequire("fDKXy");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $eb7aba33760b260c$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $fDKXy.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $eb7aba33760b260c$export$2e2bcd8739ae039 = $eb7aba33760b260c$var$cloneDataView;

});

parcelRegister("foypI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b353cac2f1aaae47$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $b353cac2f1aaae47$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $b353cac2f1aaae47$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $b353cac2f1aaae47$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $b353cac2f1aaae47$export$2e2bcd8739ae039 = $b353cac2f1aaae47$var$cloneRegExp;

});

parcelRegister("7B36A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $587e65b7f56ba264$export$2e2bcd8739ae039; });

var $gqa38 = parcelRequire("gqa38");
/** Used to convert symbols to primitives and strings. */ var $587e65b7f56ba264$var$symbolProto = (0, $gqa38.default) ? (0, $gqa38.default).prototype : undefined, $587e65b7f56ba264$var$symbolValueOf = $587e65b7f56ba264$var$symbolProto ? $587e65b7f56ba264$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $587e65b7f56ba264$var$cloneSymbol(symbol) {
    return $587e65b7f56ba264$var$symbolValueOf ? Object($587e65b7f56ba264$var$symbolValueOf.call(symbol)) : {};
}
var $587e65b7f56ba264$export$2e2bcd8739ae039 = $587e65b7f56ba264$var$cloneSymbol;

});

parcelRegister("gbA0e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc8999d00f624e31$export$2e2bcd8739ae039; });

var $fDKXy = parcelRequire("fDKXy");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $bc8999d00f624e31$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $fDKXy.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $bc8999d00f624e31$export$2e2bcd8739ae039 = $bc8999d00f624e31$var$cloneTypedArray;

});


parcelRegister("58JU4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3be14e93ac15066e$export$2e2bcd8739ae039; });

var $fOR3V = parcelRequire("fOR3V");

var $wbPtc = parcelRequire("wbPtc");

var $dSmSR = parcelRequire("dSmSR");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $3be14e93ac15066e$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $dSmSR.default)(object) ? (0, $fOR3V.default)((0, $wbPtc.default)(object)) : {};
}
var $3be14e93ac15066e$export$2e2bcd8739ae039 = $3be14e93ac15066e$var$initCloneObject;

});
parcelRegister("fOR3V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b844af94d94e29d1$export$2e2bcd8739ae039; });

var $Fe8Bj = parcelRequire("Fe8Bj");
/** Built-in value references. */ var $b844af94d94e29d1$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $b844af94d94e29d1$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $Fe8Bj.default)(proto)) return {};
        if ($b844af94d94e29d1$var$objectCreate) return $b844af94d94e29d1$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $b844af94d94e29d1$export$2e2bcd8739ae039 = $b844af94d94e29d1$var$baseCreate;

});


parcelRegister("lWJfM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffa21e2486d3626f$export$2e2bcd8739ae039; });

var $ft0BB = parcelRequire("ft0BB");

var $azCpN = parcelRequire("azCpN");

var $4aMdn = parcelRequire("4aMdn");
/* Node.js helper references. */ var $ffa21e2486d3626f$var$nodeIsMap = (0, $4aMdn.default) && (0, $4aMdn.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $ffa21e2486d3626f$var$isMap = $ffa21e2486d3626f$var$nodeIsMap ? (0, $azCpN.default)($ffa21e2486d3626f$var$nodeIsMap) : (0, $ft0BB.default);
var $ffa21e2486d3626f$export$2e2bcd8739ae039 = $ffa21e2486d3626f$var$isMap;

});
parcelRegister("ft0BB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b42a08b6736c1e39$export$2e2bcd8739ae039; });

var $5tANM = parcelRequire("5tANM");

var $4JZNr = parcelRequire("4JZNr");
/** `Object#toString` result references. */ var $b42a08b6736c1e39$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $b42a08b6736c1e39$var$baseIsMap(value) {
    return (0, $4JZNr.default)(value) && (0, $5tANM.default)(value) == $b42a08b6736c1e39$var$mapTag;
}
var $b42a08b6736c1e39$export$2e2bcd8739ae039 = $b42a08b6736c1e39$var$baseIsMap;

});


parcelRegister("2wlFV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d5f62283e2bc2c8$export$2e2bcd8739ae039; });

var $cADbe = parcelRequire("cADbe");

var $azCpN = parcelRequire("azCpN");

var $4aMdn = parcelRequire("4aMdn");
/* Node.js helper references. */ var $1d5f62283e2bc2c8$var$nodeIsSet = (0, $4aMdn.default) && (0, $4aMdn.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $1d5f62283e2bc2c8$var$isSet = $1d5f62283e2bc2c8$var$nodeIsSet ? (0, $azCpN.default)($1d5f62283e2bc2c8$var$nodeIsSet) : (0, $cADbe.default);
var $1d5f62283e2bc2c8$export$2e2bcd8739ae039 = $1d5f62283e2bc2c8$var$isSet;

});
parcelRegister("cADbe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92a73d2f98c0b629$export$2e2bcd8739ae039; });

var $5tANM = parcelRequire("5tANM");

var $4JZNr = parcelRequire("4JZNr");
/** `Object#toString` result references. */ var $92a73d2f98c0b629$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $92a73d2f98c0b629$var$baseIsSet(value) {
    return (0, $4JZNr.default)(value) && (0, $5tANM.default)(value) == $92a73d2f98c0b629$var$setTag;
}
var $92a73d2f98c0b629$export$2e2bcd8739ae039 = $92a73d2f98c0b629$var$baseIsSet;

});




parcelRegister("g2NX4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bae3949c121fca8c$export$2e2bcd8739ae039; });

var $7PtjW = parcelRequire("7PtjW");

var $4SU39 = parcelRequire("4SU39");

var $33nEL = parcelRequire("33nEL");

var $bdFhN = parcelRequire("bdFhN");

var $h5KhY = parcelRequire("h5KhY");

var $1FFHV = parcelRequire("1FFHV");

var $ajh04 = parcelRequire("ajh04");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $bae3949c121fca8c$var$toPath(value) {
    if ((0, $33nEL.default)(value)) return (0, $7PtjW.default)(value, (0, $1FFHV.default));
    return (0, $bdFhN.default)(value) ? [
        value
    ] : (0, $4SU39.default)((0, $h5KhY.default)((0, $ajh04.default)(value)));
}
var $bae3949c121fca8c$export$2e2bcd8739ae039 = $bae3949c121fca8c$var$toPath;

});
parcelRegister("7PtjW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b340a463d7df481$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $5b340a463d7df481$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $5b340a463d7df481$export$2e2bcd8739ae039 = $5b340a463d7df481$var$arrayMap;

});

parcelRegister("bdFhN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82b0ef2234077c5a$export$2e2bcd8739ae039; });

var $1KJeP = parcelRequire("1KJeP");

var $4JZNr = parcelRequire("4JZNr");
/** `Object#toString` result references. */ var $82b0ef2234077c5a$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $82b0ef2234077c5a$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $4JZNr.default)(value) && (0, $1KJeP.default)(value) == $82b0ef2234077c5a$var$symbolTag;
}
var $82b0ef2234077c5a$export$2e2bcd8739ae039 = $82b0ef2234077c5a$var$isSymbol;

});

parcelRegister("h5KhY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c716cf531b69a04b$export$2e2bcd8739ae039; });

var $dh7oh = parcelRequire("dh7oh");
/** Used to match property names within property paths. */ var $c716cf531b69a04b$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $c716cf531b69a04b$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $c716cf531b69a04b$var$stringToPath = (0, $dh7oh.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($c716cf531b69a04b$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($c716cf531b69a04b$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $c716cf531b69a04b$export$2e2bcd8739ae039 = $c716cf531b69a04b$var$stringToPath;

});
parcelRegister("dh7oh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9aa29886aa3a85fa$export$2e2bcd8739ae039; });

var $95MbP = parcelRequire("95MbP");
/** Used as the maximum memoize cache size. */ var $9aa29886aa3a85fa$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $9aa29886aa3a85fa$var$memoizeCapped(func) {
    var result = (0, $95MbP.default)(func, function(key) {
        if (cache.size === $9aa29886aa3a85fa$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $9aa29886aa3a85fa$export$2e2bcd8739ae039 = $9aa29886aa3a85fa$var$memoizeCapped;

});
parcelRegister("95MbP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69e9f62bb607790b$export$2e2bcd8739ae039; });

var $brubW = parcelRequire("brubW");
/** Error message constants. */ var $69e9f62bb607790b$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $69e9f62bb607790b$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($69e9f62bb607790b$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($69e9f62bb607790b$var$memoize.Cache || (0, $brubW.default));
    return memoized;
}
// Expose `MapCache`.
$69e9f62bb607790b$var$memoize.Cache = (0, $brubW.default);
var $69e9f62bb607790b$export$2e2bcd8739ae039 = $69e9f62bb607790b$var$memoize;

});



parcelRegister("1FFHV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1379f9033e9a58f8$export$2e2bcd8739ae039; });

var $bdFhN = parcelRequire("bdFhN");
/** Used as references for various `Number` constants. */ var $1379f9033e9a58f8$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $1379f9033e9a58f8$var$toKey(value) {
    if (typeof value == "string" || (0, $bdFhN.default)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$1379f9033e9a58f8$var$INFINITY ? "-0" : result;
}
var $1379f9033e9a58f8$export$2e2bcd8739ae039 = $1379f9033e9a58f8$var$toKey;

});

parcelRegister("ajh04", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7818dd950f67b6ae$export$2e2bcd8739ae039; });

var $5W96M = parcelRequire("5W96M");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $7818dd950f67b6ae$var$toString(value) {
    return value == null ? "" : (0, $5W96M.default)(value);
}
var $7818dd950f67b6ae$export$2e2bcd8739ae039 = $7818dd950f67b6ae$var$toString;

});
parcelRegister("5W96M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45296f46177e9545$export$2e2bcd8739ae039; });

var $gqa38 = parcelRequire("gqa38");

var $7PtjW = parcelRequire("7PtjW");

var $33nEL = parcelRequire("33nEL");

var $bdFhN = parcelRequire("bdFhN");
/** Used as references for various `Number` constants. */ var $45296f46177e9545$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $45296f46177e9545$var$symbolProto = (0, $gqa38.default) ? (0, $gqa38.default).prototype : undefined, $45296f46177e9545$var$symbolToString = $45296f46177e9545$var$symbolProto ? $45296f46177e9545$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $45296f46177e9545$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $33nEL.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $7PtjW.default)(value, $45296f46177e9545$var$baseToString) + "";
    if ((0, $bdFhN.default)(value)) return $45296f46177e9545$var$symbolToString ? $45296f46177e9545$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$45296f46177e9545$var$INFINITY ? "-0" : result;
}
var $45296f46177e9545$export$2e2bcd8739ae039 = $45296f46177e9545$var$baseToString;

});



parcelRegister("4VrJM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3962005bbd3a7f05$export$2e2bcd8739ae039; });

var $lnwVj = parcelRequire("lnwVj");
/** Used to compose bitmasks for cloning. */ var $3962005bbd3a7f05$var$CLONE_DEEP_FLAG = 1, $3962005bbd3a7f05$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $3962005bbd3a7f05$var$cloneDeep(value) {
    return (0, $lnwVj.default)(value, $3962005bbd3a7f05$var$CLONE_DEEP_FLAG | $3962005bbd3a7f05$var$CLONE_SYMBOLS_FLAG);
}
var $3962005bbd3a7f05$export$2e2bcd8739ae039 = $3962005bbd3a7f05$var$cloneDeep;

});


parcelRegister("kEAqK", function(module, exports) {
"use strict";

});

parcelRegister("e1j1e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $lMhFs = parcelRequire("lMhFs");

var $gZ2NO = parcelRequire("gZ2NO");

var $jX28O = parcelRequire("jX28O");

var $fj7tD = parcelRequire("fj7tD");
var $a34fe96bac8c20d1$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $jX28O.RawSha256();
        if (secret) {
            this.outer = new $jX28O.RawSha256();
            var inner = $a34fe96bac8c20d1$var$bufferFromSecret(secret);
            var outer = new Uint8Array($gZ2NO.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $gZ2NO.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $fj7tD.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $fj7tD.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $lMhFs.__awaiter)(this, void 0, void 0, function() {
            return (0, $lMhFs.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $a34fe96bac8c20d1$var$Sha256;
function $a34fe96bac8c20d1$var$bufferFromSecret(secret) {
    var input = (0, $fj7tD.convertToBuffer)(secret);
    if (input.byteLength > $gZ2NO.BLOCK_SIZE) {
        var bufferHash = new $jX28O.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($gZ2NO.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRegister("lMhFs", function(module, exports) {

$parcel$export(module.exports, "__awaiter", function () { return $fdabc92002ee400f$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $fdabc92002ee400f$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $fdabc92002ee400f$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $fdabc92002ee400f$var$extendStatics = function(d, b) {
    $fdabc92002ee400f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $fdabc92002ee400f$var$extendStatics(d, b);
};
function $fdabc92002ee400f$export$a8ba968b8961cb8a(d, b) {
    $fdabc92002ee400f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $fdabc92002ee400f$export$18ce0697a983be9b = function() {
    $fdabc92002ee400f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fdabc92002ee400f$export$18ce0697a983be9b.apply(this, arguments);
};
function $fdabc92002ee400f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $fdabc92002ee400f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $fdabc92002ee400f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $fdabc92002ee400f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $fdabc92002ee400f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $fdabc92002ee400f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $fdabc92002ee400f$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $fdabc92002ee400f$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $fdabc92002ee400f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $fdabc92002ee400f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $fdabc92002ee400f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($fdabc92002ee400f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $fdabc92002ee400f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $fdabc92002ee400f$export$10c90e4f7922046c(v) {
    return this instanceof $fdabc92002ee400f$export$10c90e4f7922046c ? (this.v = v, this) : new $fdabc92002ee400f$export$10c90e4f7922046c(v);
}
function $fdabc92002ee400f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $fdabc92002ee400f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $fdabc92002ee400f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $fdabc92002ee400f$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $fdabc92002ee400f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $fdabc92002ee400f$export$19a8beecd37a4c45 === "function" ? $fdabc92002ee400f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $fdabc92002ee400f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $fdabc92002ee400f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $fdabc92002ee400f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $fdabc92002ee400f$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $fdabc92002ee400f$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("gZ2NO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRegister("jX28O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $gZ2NO = parcelRequire("gZ2NO");
/**
 * @internal
 */ var $e865302c3a0026fa$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($gZ2NO.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $gZ2NO.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $gZ2NO.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $gZ2NO.BLOCK_SIZE >= $gZ2NO.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $gZ2NO.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $gZ2NO.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($gZ2NO.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($gZ2NO.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($gZ2NO.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $gZ2NO.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($gZ2NO.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $e865302c3a0026fa$var$RawSha256;

});

parcelRegister("fj7tD", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $bGDQ5 = parcelRequire("bGDQ5");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $bGDQ5.convertToBuffer;
    }
});

var $HrFgl = parcelRequire("HrFgl");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $HrFgl.isEmptyData;
    }
});

var $9K5kv = parcelRequire("9K5kv");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $9K5kv.numToUint8;
    }
});

var $9J6AQ = parcelRequire("9J6AQ");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $9J6AQ.uint32ArrayFrom;
    }
});

});
parcelRegister("bGDQ5", function(module, exports) {

var $cjtBX = parcelRequire("cjtBX");
var $8822852d5a74151e$require$Buffer = $cjtBX.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $5Dq42 = parcelRequire("5Dq42");
// Quick polyfill
var $8822852d5a74151e$var$fromUtf8 = typeof $8822852d5a74151e$require$Buffer !== "undefined" && $8822852d5a74151e$require$Buffer.from ? function(input) {
    return $8822852d5a74151e$require$Buffer.from(input, "utf8");
} : $5Dq42.fromUtf8;
function $8822852d5a74151e$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $8822852d5a74151e$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $8822852d5a74151e$var$convertToBuffer;

});
parcelRegister("cjtBX", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $8f6e3a92a09d7476$export$a143d493d941bafc; }, function (v) { return $8f6e3a92a09d7476$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $8f6e3a92a09d7476$export$e4cf37d7f6fb9e0a; }, function (v) { return $8f6e3a92a09d7476$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $8f6e3a92a09d7476$export$f99ded8fe4b79145; }, function (v) { return $8f6e3a92a09d7476$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $8f6e3a92a09d7476$export$599f31c3813fae4d; }, function (v) { return $8f6e3a92a09d7476$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8f6e3a92a09d7476$export$a143d493d941bafc;
var $8f6e3a92a09d7476$export$e4cf37d7f6fb9e0a;
var $8f6e3a92a09d7476$export$f99ded8fe4b79145;
var $8f6e3a92a09d7476$export$599f31c3813fae4d;
"use strict";

var $kseYM = parcelRequire("kseYM");

var $3GaZX = parcelRequire("3GaZX");
const $8f6e3a92a09d7476$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$8f6e3a92a09d7476$export$a143d493d941bafc = $8f6e3a92a09d7476$var$Buffer;
$8f6e3a92a09d7476$export$e4cf37d7f6fb9e0a = $8f6e3a92a09d7476$var$SlowBuffer;
$8f6e3a92a09d7476$export$f99ded8fe4b79145 = 50;
const $8f6e3a92a09d7476$var$K_MAX_LENGTH = 0x7fffffff;
$8f6e3a92a09d7476$export$599f31c3813fae4d = $8f6e3a92a09d7476$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8f6e3a92a09d7476$var$Buffer.TYPED_ARRAY_SUPPORT = $8f6e3a92a09d7476$var$typedArraySupport();
if (!$8f6e3a92a09d7476$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8f6e3a92a09d7476$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8f6e3a92a09d7476$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$8f6e3a92a09d7476$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8f6e3a92a09d7476$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$8f6e3a92a09d7476$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8f6e3a92a09d7476$var$createBuffer(length) {
    if (length > $8f6e3a92a09d7476$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8f6e3a92a09d7476$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8f6e3a92a09d7476$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8f6e3a92a09d7476$var$allocUnsafe(arg);
    }
    return $8f6e3a92a09d7476$var$from(arg, encodingOrOffset, length);
}
$8f6e3a92a09d7476$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8f6e3a92a09d7476$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $8f6e3a92a09d7476$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8f6e3a92a09d7476$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8f6e3a92a09d7476$var$isInstance(value, ArrayBuffer) || value && $8f6e3a92a09d7476$var$isInstance(value.buffer, ArrayBuffer)) return $8f6e3a92a09d7476$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($8f6e3a92a09d7476$var$isInstance(value, SharedArrayBuffer) || value && $8f6e3a92a09d7476$var$isInstance(value.buffer, SharedArrayBuffer))) return $8f6e3a92a09d7476$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8f6e3a92a09d7476$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8f6e3a92a09d7476$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $8f6e3a92a09d7476$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8f6e3a92a09d7476$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8f6e3a92a09d7476$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8f6e3a92a09d7476$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8f6e3a92a09d7476$var$Buffer, Uint8Array);
function $8f6e3a92a09d7476$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8f6e3a92a09d7476$var$alloc(size, fill, encoding) {
    $8f6e3a92a09d7476$var$assertSize(size);
    if (size <= 0) return $8f6e3a92a09d7476$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $8f6e3a92a09d7476$var$createBuffer(size).fill(fill, encoding) : $8f6e3a92a09d7476$var$createBuffer(size).fill(fill);
    return $8f6e3a92a09d7476$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8f6e3a92a09d7476$var$Buffer.alloc = function(size, fill, encoding) {
    return $8f6e3a92a09d7476$var$alloc(size, fill, encoding);
};
function $8f6e3a92a09d7476$var$allocUnsafe(size) {
    $8f6e3a92a09d7476$var$assertSize(size);
    return $8f6e3a92a09d7476$var$createBuffer(size < 0 ? 0 : $8f6e3a92a09d7476$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8f6e3a92a09d7476$var$Buffer.allocUnsafe = function(size) {
    return $8f6e3a92a09d7476$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8f6e3a92a09d7476$var$Buffer.allocUnsafeSlow = function(size) {
    return $8f6e3a92a09d7476$var$allocUnsafe(size);
};
function $8f6e3a92a09d7476$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$8f6e3a92a09d7476$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $8f6e3a92a09d7476$var$byteLength(string, encoding) | 0;
    let buf = $8f6e3a92a09d7476$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8f6e3a92a09d7476$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8f6e3a92a09d7476$var$checked(array.length) | 0;
    const buf = $8f6e3a92a09d7476$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8f6e3a92a09d7476$var$fromArrayView(arrayView) {
    if ($8f6e3a92a09d7476$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8f6e3a92a09d7476$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8f6e3a92a09d7476$var$fromArrayLike(arrayView);
}
function $8f6e3a92a09d7476$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8f6e3a92a09d7476$var$Buffer.prototype);
    return buf;
}
function $8f6e3a92a09d7476$var$fromObject(obj) {
    if ($8f6e3a92a09d7476$var$Buffer.isBuffer(obj)) {
        const len = $8f6e3a92a09d7476$var$checked(obj.length) | 0;
        const buf = $8f6e3a92a09d7476$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $8f6e3a92a09d7476$var$numberIsNaN(obj.length)) return $8f6e3a92a09d7476$var$createBuffer(0);
        return $8f6e3a92a09d7476$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $8f6e3a92a09d7476$var$fromArrayLike(obj.data);
}
function $8f6e3a92a09d7476$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8f6e3a92a09d7476$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8f6e3a92a09d7476$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $8f6e3a92a09d7476$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8f6e3a92a09d7476$var$Buffer.alloc(+length);
}
$8f6e3a92a09d7476$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8f6e3a92a09d7476$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8f6e3a92a09d7476$var$Buffer.compare = function compare(a, b) {
    if ($8f6e3a92a09d7476$var$isInstance(a, Uint8Array)) a = $8f6e3a92a09d7476$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8f6e3a92a09d7476$var$isInstance(b, Uint8Array)) b = $8f6e3a92a09d7476$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8f6e3a92a09d7476$var$Buffer.isBuffer(a) || !$8f6e3a92a09d7476$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8f6e3a92a09d7476$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$8f6e3a92a09d7476$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8f6e3a92a09d7476$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8f6e3a92a09d7476$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8f6e3a92a09d7476$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8f6e3a92a09d7476$var$Buffer.isBuffer(buf)) buf = $8f6e3a92a09d7476$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8f6e3a92a09d7476$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8f6e3a92a09d7476$var$byteLength(string, encoding) {
    if ($8f6e3a92a09d7476$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8f6e3a92a09d7476$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $8f6e3a92a09d7476$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $8f6e3a92a09d7476$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8f6e3a92a09d7476$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8f6e3a92a09d7476$var$Buffer.byteLength = $8f6e3a92a09d7476$var$byteLength;
function $8f6e3a92a09d7476$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $8f6e3a92a09d7476$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $8f6e3a92a09d7476$var$utf8Slice(this, start, end);
        case "ascii":
            return $8f6e3a92a09d7476$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $8f6e3a92a09d7476$var$latin1Slice(this, start, end);
        case "base64":
            return $8f6e3a92a09d7476$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8f6e3a92a09d7476$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8f6e3a92a09d7476$var$Buffer.prototype._isBuffer = true;
function $8f6e3a92a09d7476$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8f6e3a92a09d7476$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$8f6e3a92a09d7476$var$swap(this, i, i + 1);
    return this;
};
$8f6e3a92a09d7476$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $8f6e3a92a09d7476$var$swap(this, i, i + 3);
        $8f6e3a92a09d7476$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8f6e3a92a09d7476$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $8f6e3a92a09d7476$var$swap(this, i, i + 7);
        $8f6e3a92a09d7476$var$swap(this, i + 1, i + 6);
        $8f6e3a92a09d7476$var$swap(this, i + 2, i + 5);
        $8f6e3a92a09d7476$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8f6e3a92a09d7476$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $8f6e3a92a09d7476$var$utf8Slice(this, 0, length);
    return $8f6e3a92a09d7476$var$slowToString.apply(this, arguments);
};
$8f6e3a92a09d7476$var$Buffer.prototype.toLocaleString = $8f6e3a92a09d7476$var$Buffer.prototype.toString;
$8f6e3a92a09d7476$var$Buffer.prototype.equals = function equals(b) {
    if (!$8f6e3a92a09d7476$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $8f6e3a92a09d7476$var$Buffer.compare(this, b) === 0;
};
$8f6e3a92a09d7476$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $8f6e3a92a09d7476$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($8f6e3a92a09d7476$var$customInspectSymbol) $8f6e3a92a09d7476$var$Buffer.prototype[$8f6e3a92a09d7476$var$customInspectSymbol] = $8f6e3a92a09d7476$var$Buffer.prototype.inspect;
$8f6e3a92a09d7476$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8f6e3a92a09d7476$var$isInstance(target, Uint8Array)) target = $8f6e3a92a09d7476$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8f6e3a92a09d7476$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8f6e3a92a09d7476$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8f6e3a92a09d7476$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $8f6e3a92a09d7476$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8f6e3a92a09d7476$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8f6e3a92a09d7476$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8f6e3a92a09d7476$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $8f6e3a92a09d7476$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8f6e3a92a09d7476$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8f6e3a92a09d7476$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8f6e3a92a09d7476$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8f6e3a92a09d7476$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8f6e3a92a09d7476$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8f6e3a92a09d7476$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8f6e3a92a09d7476$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8f6e3a92a09d7476$var$utf8Write(buf, string, offset, length) {
    return $8f6e3a92a09d7476$var$blitBuffer($8f6e3a92a09d7476$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8f6e3a92a09d7476$var$asciiWrite(buf, string, offset, length) {
    return $8f6e3a92a09d7476$var$blitBuffer($8f6e3a92a09d7476$var$asciiToBytes(string), buf, offset, length);
}
function $8f6e3a92a09d7476$var$base64Write(buf, string, offset, length) {
    return $8f6e3a92a09d7476$var$blitBuffer($8f6e3a92a09d7476$var$base64ToBytes(string), buf, offset, length);
}
function $8f6e3a92a09d7476$var$ucs2Write(buf, string, offset, length) {
    return $8f6e3a92a09d7476$var$blitBuffer($8f6e3a92a09d7476$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8f6e3a92a09d7476$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $8f6e3a92a09d7476$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $8f6e3a92a09d7476$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $8f6e3a92a09d7476$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $8f6e3a92a09d7476$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8f6e3a92a09d7476$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8f6e3a92a09d7476$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8f6e3a92a09d7476$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kseYM.fromByteArray(buf);
    else return $kseYM.fromByteArray(buf.slice(start, end));
}
function $8f6e3a92a09d7476$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8f6e3a92a09d7476$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8f6e3a92a09d7476$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8f6e3a92a09d7476$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8f6e3a92a09d7476$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8f6e3a92a09d7476$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8f6e3a92a09d7476$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8f6e3a92a09d7476$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8f6e3a92a09d7476$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $8f6e3a92a09d7476$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8f6e3a92a09d7476$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8f6e3a92a09d7476$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8f6e3a92a09d7476$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8f6e3a92a09d7476$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$8f6e3a92a09d7476$var$Buffer.prototype.readUintLE = $8f6e3a92a09d7476$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8f6e3a92a09d7476$var$Buffer.prototype.readUintBE = $8f6e3a92a09d7476$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8f6e3a92a09d7476$var$Buffer.prototype.readUint8 = $8f6e3a92a09d7476$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8f6e3a92a09d7476$var$Buffer.prototype.readUint16LE = $8f6e3a92a09d7476$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8f6e3a92a09d7476$var$Buffer.prototype.readUint16BE = $8f6e3a92a09d7476$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8f6e3a92a09d7476$var$Buffer.prototype.readUint32LE = $8f6e3a92a09d7476$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8f6e3a92a09d7476$var$Buffer.prototype.readUint32BE = $8f6e3a92a09d7476$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8f6e3a92a09d7476$var$Buffer.prototype.readBigUInt64LE = $8f6e3a92a09d7476$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8f6e3a92a09d7476$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8f6e3a92a09d7476$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8f6e3a92a09d7476$var$Buffer.prototype.readBigUInt64BE = $8f6e3a92a09d7476$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8f6e3a92a09d7476$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8f6e3a92a09d7476$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8f6e3a92a09d7476$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8f6e3a92a09d7476$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8f6e3a92a09d7476$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8f6e3a92a09d7476$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8f6e3a92a09d7476$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8f6e3a92a09d7476$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8f6e3a92a09d7476$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8f6e3a92a09d7476$var$Buffer.prototype.readBigInt64LE = $8f6e3a92a09d7476$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8f6e3a92a09d7476$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8f6e3a92a09d7476$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8f6e3a92a09d7476$var$Buffer.prototype.readBigInt64BE = $8f6e3a92a09d7476$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8f6e3a92a09d7476$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8f6e3a92a09d7476$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8f6e3a92a09d7476$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, 4, this.length);
    return $3GaZX.read(this, offset, true, 23, 4);
};
$8f6e3a92a09d7476$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, 4, this.length);
    return $3GaZX.read(this, offset, false, 23, 4);
};
$8f6e3a92a09d7476$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, 8, this.length);
    return $3GaZX.read(this, offset, true, 52, 8);
};
$8f6e3a92a09d7476$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkOffset(offset, 8, this.length);
    return $3GaZX.read(this, offset, false, 52, 8);
};
function $8f6e3a92a09d7476$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8f6e3a92a09d7476$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$8f6e3a92a09d7476$var$Buffer.prototype.writeUintLE = $8f6e3a92a09d7476$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8f6e3a92a09d7476$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8f6e3a92a09d7476$var$Buffer.prototype.writeUintBE = $8f6e3a92a09d7476$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8f6e3a92a09d7476$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8f6e3a92a09d7476$var$Buffer.prototype.writeUint8 = $8f6e3a92a09d7476$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8f6e3a92a09d7476$var$Buffer.prototype.writeUint16LE = $8f6e3a92a09d7476$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8f6e3a92a09d7476$var$Buffer.prototype.writeUint16BE = $8f6e3a92a09d7476$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8f6e3a92a09d7476$var$Buffer.prototype.writeUint32LE = $8f6e3a92a09d7476$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8f6e3a92a09d7476$var$Buffer.prototype.writeUint32BE = $8f6e3a92a09d7476$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8f6e3a92a09d7476$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8f6e3a92a09d7476$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8f6e3a92a09d7476$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8f6e3a92a09d7476$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8f6e3a92a09d7476$var$Buffer.prototype.writeBigUInt64LE = $8f6e3a92a09d7476$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8f6e3a92a09d7476$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$8f6e3a92a09d7476$var$Buffer.prototype.writeBigUInt64BE = $8f6e3a92a09d7476$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8f6e3a92a09d7476$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$8f6e3a92a09d7476$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8f6e3a92a09d7476$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8f6e3a92a09d7476$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8f6e3a92a09d7476$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8f6e3a92a09d7476$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8f6e3a92a09d7476$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8f6e3a92a09d7476$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8f6e3a92a09d7476$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8f6e3a92a09d7476$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8f6e3a92a09d7476$var$Buffer.prototype.writeBigInt64LE = $8f6e3a92a09d7476$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8f6e3a92a09d7476$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$8f6e3a92a09d7476$var$Buffer.prototype.writeBigInt64BE = $8f6e3a92a09d7476$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8f6e3a92a09d7476$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $8f6e3a92a09d7476$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $8f6e3a92a09d7476$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $3GaZX.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8f6e3a92a09d7476$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8f6e3a92a09d7476$var$writeFloat(this, value, offset, true, noAssert);
};
$8f6e3a92a09d7476$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8f6e3a92a09d7476$var$writeFloat(this, value, offset, false, noAssert);
};
function $8f6e3a92a09d7476$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8f6e3a92a09d7476$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $3GaZX.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8f6e3a92a09d7476$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8f6e3a92a09d7476$var$writeDouble(this, value, offset, true, noAssert);
};
$8f6e3a92a09d7476$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8f6e3a92a09d7476$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8f6e3a92a09d7476$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8f6e3a92a09d7476$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8f6e3a92a09d7476$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$8f6e3a92a09d7476$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8f6e3a92a09d7476$var$Buffer.isBuffer(val) ? val : $8f6e3a92a09d7476$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8f6e3a92a09d7476$var$errors = {};
function $8f6e3a92a09d7476$var$E(sym, getMessage, Base) {
    $8f6e3a92a09d7476$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8f6e3a92a09d7476$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$8f6e3a92a09d7476$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8f6e3a92a09d7476$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8f6e3a92a09d7476$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8f6e3a92a09d7476$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8f6e3a92a09d7476$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8f6e3a92a09d7476$var$checkBounds(buf, offset, byteLength) {
    $8f6e3a92a09d7476$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8f6e3a92a09d7476$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8f6e3a92a09d7476$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8f6e3a92a09d7476$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $8f6e3a92a09d7476$var$checkBounds(buf, offset, byteLength);
}
function $8f6e3a92a09d7476$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $8f6e3a92a09d7476$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $8f6e3a92a09d7476$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8f6e3a92a09d7476$var$validateNumber(value, type);
        throw new $8f6e3a92a09d7476$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $8f6e3a92a09d7476$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8f6e3a92a09d7476$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8f6e3a92a09d7476$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8f6e3a92a09d7476$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8f6e3a92a09d7476$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $8f6e3a92a09d7476$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $8f6e3a92a09d7476$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8f6e3a92a09d7476$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8f6e3a92a09d7476$var$base64ToBytes(str) {
    return $kseYM.toByteArray($8f6e3a92a09d7476$var$base64clean(str));
}
function $8f6e3a92a09d7476$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8f6e3a92a09d7476$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8f6e3a92a09d7476$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8f6e3a92a09d7476$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8f6e3a92a09d7476$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $8f6e3a92a09d7476$var$BufferBigIntNotDefined : fn;
}
function $8f6e3a92a09d7476$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kseYM", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $ee420abf9690894c$export$d622b2ad8d90c771; }, function (v) { return $ee420abf9690894c$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $ee420abf9690894c$export$6100ba28696e12de; }, function (v) { return $ee420abf9690894c$export$6100ba28696e12de = v; });
var $ee420abf9690894c$export$a48f0734ac7c2329;
var $ee420abf9690894c$export$d622b2ad8d90c771;
var $ee420abf9690894c$export$6100ba28696e12de;
"use strict";
$ee420abf9690894c$export$a48f0734ac7c2329 = $ee420abf9690894c$var$byteLength;
$ee420abf9690894c$export$d622b2ad8d90c771 = $ee420abf9690894c$var$toByteArray;
$ee420abf9690894c$export$6100ba28696e12de = $ee420abf9690894c$var$fromByteArray;
var $ee420abf9690894c$var$lookup = [];
var $ee420abf9690894c$var$revLookup = [];
var $ee420abf9690894c$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $ee420abf9690894c$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $ee420abf9690894c$var$i = 0, $ee420abf9690894c$var$len = $ee420abf9690894c$var$code.length; $ee420abf9690894c$var$i < $ee420abf9690894c$var$len; ++$ee420abf9690894c$var$i){
    $ee420abf9690894c$var$lookup[$ee420abf9690894c$var$i] = $ee420abf9690894c$var$code[$ee420abf9690894c$var$i];
    $ee420abf9690894c$var$revLookup[$ee420abf9690894c$var$code.charCodeAt($ee420abf9690894c$var$i)] = $ee420abf9690894c$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$ee420abf9690894c$var$revLookup["-".charCodeAt(0)] = 62;
$ee420abf9690894c$var$revLookup["_".charCodeAt(0)] = 63;
function $ee420abf9690894c$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $ee420abf9690894c$var$byteLength(b64) {
    var lens = $ee420abf9690894c$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ee420abf9690894c$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $ee420abf9690894c$var$toByteArray(b64) {
    var tmp;
    var lens = $ee420abf9690894c$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $ee420abf9690894c$var$Arr($ee420abf9690894c$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $ee420abf9690894c$var$revLookup[b64.charCodeAt(i)] << 18 | $ee420abf9690894c$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $ee420abf9690894c$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $ee420abf9690894c$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $ee420abf9690894c$var$revLookup[b64.charCodeAt(i)] << 2 | $ee420abf9690894c$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $ee420abf9690894c$var$revLookup[b64.charCodeAt(i)] << 10 | $ee420abf9690894c$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $ee420abf9690894c$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $ee420abf9690894c$var$tripletToBase64(num) {
    return $ee420abf9690894c$var$lookup[num >> 18 & 0x3F] + $ee420abf9690894c$var$lookup[num >> 12 & 0x3F] + $ee420abf9690894c$var$lookup[num >> 6 & 0x3F] + $ee420abf9690894c$var$lookup[num & 0x3F];
}
function $ee420abf9690894c$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($ee420abf9690894c$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $ee420abf9690894c$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($ee420abf9690894c$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($ee420abf9690894c$var$lookup[tmp >> 2] + $ee420abf9690894c$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($ee420abf9690894c$var$lookup[tmp >> 10] + $ee420abf9690894c$var$lookup[tmp >> 4 & 0x3F] + $ee420abf9690894c$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("3GaZX", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $2addd35ee95ddc87$export$aafa59e2e03f2942; }, function (v) { return $2addd35ee95ddc87$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $2addd35ee95ddc87$export$68d8715fc104d294; }, function (v) { return $2addd35ee95ddc87$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $2addd35ee95ddc87$export$aafa59e2e03f2942;
var $2addd35ee95ddc87$export$68d8715fc104d294;
$2addd35ee95ddc87$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$2addd35ee95ddc87$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("5Dq42", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $41a4d01439e21427$export$c7c5cef950a4d2fc; });

var $4zbhA = parcelRequire("4zbhA");

var $afEoP = parcelRequire("afEoP");
const $41a4d01439e21427$export$c7c5cef950a4d2fc = (input)=>typeof TextEncoder === "function" ? (0, $afEoP.fromUtf8)(input) : (0, $4zbhA.fromUtf8)(input);
const $41a4d01439e21427$export$b4b216764bb846eb = (input)=>typeof TextDecoder === "function" ? (0, $afEoP.toUtf8)(input) : (0, $4zbhA.toUtf8)(input);

});
parcelRegister("4zbhA", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $35332ecf6d58e397$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $35332ecf6d58e397$export$b4b216764bb846eb; });
const $35332ecf6d58e397$export$c7c5cef950a4d2fc = (input)=>{
    const bytes = [];
    for(let i = 0, len = input.length; i < len; i++){
        const value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            const surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
const $35332ecf6d58e397$export$b4b216764bb846eb = (input)=>{
    let decoded = "";
    for(let i = 0, len = input.length; i < len; i++){
        const byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            const nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            const surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            const encoded = "%" + surrogatePair.map((byteValue)=>byteValue.toString(16)).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRegister("afEoP", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $776aa49c8d4f966a$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $776aa49c8d4f966a$export$b4b216764bb846eb; });
function $776aa49c8d4f966a$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $776aa49c8d4f966a$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});



parcelRegister("HrFgl", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $082979dd97b6b596$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $082979dd97b6b596$var$isEmptyData;

});

parcelRegister("9K5kv", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $717c8b4b5b7b66f8$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $717c8b4b5b7b66f8$var$numToUint8;

});

parcelRegister("9J6AQ", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $714d6e53dff77cfe$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $714d6e53dff77cfe$var$uint32ArrayFrom;

});



parcelRegister("8xb7C", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $636a085b14507c10$export$2e2bcd8739ae039; });
function $636a085b14507c10$export$2e2bcd8739ae039(e, n) {
    return n = n || {}, new Promise(function(t, r) {
        var s = new XMLHttpRequest, o = [], u = [], i = {}, a = function() {
            return {
                ok: 2 == (s.status / 100 | 0),
                statusText: s.statusText,
                status: s.status,
                url: s.responseURL,
                text: function() {
                    return Promise.resolve(s.responseText);
                },
                json: function() {
                    return Promise.resolve(s.responseText).then(JSON.parse);
                },
                blob: function() {
                    return Promise.resolve(new Blob([
                        s.response
                    ]));
                },
                clone: a,
                headers: {
                    keys: function() {
                        return o;
                    },
                    entries: function() {
                        return u;
                    },
                    get: function(e) {
                        return i[e.toLowerCase()];
                    },
                    has: function(e) {
                        return e.toLowerCase() in i;
                    }
                }
            };
        };
        for(var l in s.open(n.method || "get", e, !0), s.onload = function() {
            s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(e, n, t) {
                o.push(n = n.toLowerCase()), u.push([
                    n,
                    t
                ]), i[n] = i[n] ? i[n] + "," + t : t;
            }), t(a());
        }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers)s.setRequestHeader(l, n.headers[l]);
        s.send(n.body || null);
    });
}

});

parcelRegister("adaeM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $76f30f3763c80a4e$var$assertString;
function $76f30f3763c80a4e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $76f30f3763c80a4e$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $76f30f3763c80a4e$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $76f30f3763c80a4e$var$_typeof(obj);
}
function $76f30f3763c80a4e$var$assertString(input) {
    var isString = typeof input === "string" || input instanceof String;
    if (!isString) {
        var invalidType = $76f30f3763c80a4e$var$_typeof(input);
        if (input === null) invalidType = "null";
        else if (invalidType === "object") invalidType = input.constructor.name;
        throw new TypeError("Expected a string but received a ".concat(invalidType));
    }
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("ihkUX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d4ea0a51a32c64b1$var$isByteLength;

var $d4ea0a51a32c64b1$var$_assertString = $d4ea0a51a32c64b1$var$_interopRequireDefault((parcelRequire("adaeM")));
function $d4ea0a51a32c64b1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d4ea0a51a32c64b1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d4ea0a51a32c64b1$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d4ea0a51a32c64b1$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d4ea0a51a32c64b1$var$_typeof(obj);
}
/* eslint-disable prefer-rest-params */ function $d4ea0a51a32c64b1$var$isByteLength(str, options) {
    (0, $d4ea0a51a32c64b1$var$_assertString.default)(str);
    var min;
    var max;
    if ($d4ea0a51a32c64b1$var$_typeof(options) === "object") {
        min = options.min || 0;
        max = options.max;
    } else {
        // backwards compatibility: isByteLength(str, min [, max])
        min = arguments[1];
        max = arguments[2];
    }
    var len = encodeURI(str).split(/%..|./).length - 1;
    return len >= min && (typeof max === "undefined" || len <= max);
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("2WRI2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $225aa91ee7fda444$var$isFQDN;

var $225aa91ee7fda444$var$_assertString = $225aa91ee7fda444$var$_interopRequireDefault((parcelRequire("adaeM")));

var $225aa91ee7fda444$var$_merge = $225aa91ee7fda444$var$_interopRequireDefault((parcelRequire("lgOyf")));
function $225aa91ee7fda444$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $225aa91ee7fda444$var$default_fqdn_options = {
    require_tld: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_numeric_tld: false,
    allow_wildcard: false,
    ignore_max_length: false
};
function $225aa91ee7fda444$var$isFQDN(str, options) {
    (0, $225aa91ee7fda444$var$_assertString.default)(str);
    options = (0, $225aa91ee7fda444$var$_merge.default)(options, $225aa91ee7fda444$var$default_fqdn_options);
    /* Remove the optional trailing dot before checking validity */ if (options.allow_trailing_dot && str[str.length - 1] === ".") str = str.substring(0, str.length - 1);
    /* Remove the optional wildcard before checking validity */ if (options.allow_wildcard === true && str.indexOf("*.") === 0) str = str.substring(2);
    var parts = str.split(".");
    var tld = parts[parts.length - 1];
    if (options.require_tld) {
        // disallow fqdns without tld
        if (parts.length < 2) return false;
        if (!options.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) return false;
         // disallow spaces
        if (/\s/.test(tld)) return false;
    } // reject numeric TLDs
    if (!options.allow_numeric_tld && /^\d+$/.test(tld)) return false;
    return parts.every(function(part) {
        if (part.length > 63 && !options.ignore_max_length) return false;
        if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) return false;
         // disallow full-width chars
        if (/[\uff01-\uff5e]/.test(part)) return false;
         // disallow parts starting or ending with hyphen
        if (/^-|-$/.test(part)) return false;
        if (!options.allow_underscores && /_/.test(part)) return false;
        return true;
    });
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("lgOyf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f7c24e0732d2a784$var$merge;
function $f7c24e0732d2a784$var$merge() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaults = arguments.length > 1 ? arguments[1] : undefined;
    for(var key in defaults)if (typeof obj[key] === "undefined") obj[key] = defaults[key];
    return obj;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("dyBf4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9deb56d04ce70e9a$var$isIP;

var $9deb56d04ce70e9a$var$_assertString = $9deb56d04ce70e9a$var$_interopRequireDefault((parcelRequire("adaeM")));
function $9deb56d04ce70e9a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
11.3.  Examples

   The following addresses

             fe80::1234 (on the 1st link of the node)
             ff02::5678 (on the 5th link of the node)
             ff08::9abc (on the 10th organization of the node)

   would be represented as follows:

             fe80::1234%1
             ff02::5678%5
             ff08::9abc%10

   (Here we assume a natural translation from a zone index to the
   <zone_id> part, where the Nth zone of any scope is translated into
   "N".)

   If we use interface names as <zone_id>, those addresses could also be
   represented as follows:

            fe80::1234%ne0
            ff02::5678%pvc1.3
            ff08::9abc%interface10

   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
   to the 5th link, and "interface10" belongs to the 10th organization.
 * * */ var $9deb56d04ce70e9a$var$IPv4SegmentFormat = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])";
var $9deb56d04ce70e9a$var$IPv4AddressFormat = "(".concat($9deb56d04ce70e9a$var$IPv4SegmentFormat, "[.]){3}").concat($9deb56d04ce70e9a$var$IPv4SegmentFormat);
var $9deb56d04ce70e9a$var$IPv4AddressRegExp = new RegExp("^".concat($9deb56d04ce70e9a$var$IPv4AddressFormat, "$"));
var $9deb56d04ce70e9a$var$IPv6SegmentFormat = "(?:[0-9a-fA-F]{1,4})";
var $9deb56d04ce70e9a$var$IPv6AddressRegExp = new RegExp("^(" + "(?:".concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, ":){7}(?:").concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, ":){6}(?:").concat($9deb56d04ce70e9a$var$IPv4AddressFormat, "|:").concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, ":){5}(?::").concat($9deb56d04ce70e9a$var$IPv4AddressFormat, "|(:").concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, ":){4}(?:(:").concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, "){0,1}:").concat($9deb56d04ce70e9a$var$IPv4AddressFormat, "|(:").concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, ":){3}(?:(:").concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, "){0,2}:").concat($9deb56d04ce70e9a$var$IPv4AddressFormat, "|(:").concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, ":){2}(?:(:").concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, "){0,3}:").concat($9deb56d04ce70e9a$var$IPv4AddressFormat, "|(:").concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, ":){1}(?:(:").concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, "){0,4}:").concat($9deb56d04ce70e9a$var$IPv4AddressFormat, "|(:").concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, "){0,5}:").concat($9deb56d04ce70e9a$var$IPv4AddressFormat, "|(?::").concat($9deb56d04ce70e9a$var$IPv6SegmentFormat, "){1,7}|:))") + ")(%[0-9a-zA-Z-.:]{1,})?$");
function $9deb56d04ce70e9a$var$isIP(str) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    (0, $9deb56d04ce70e9a$var$_assertString.default)(str);
    version = String(version);
    if (!version) return $9deb56d04ce70e9a$var$isIP(str, 4) || $9deb56d04ce70e9a$var$isIP(str, 6);
    if (version === "4") return $9deb56d04ce70e9a$var$IPv4AddressRegExp.test(str);
    if (version === "6") return $9deb56d04ce70e9a$var$IPv6AddressRegExp.test(str);
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("e5Kd4", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $a42560a0f82d7652$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $a42560a0f82d7652$export$2e2bcd8739ae039 = fn;

});

parcelRegister("d4mRi", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $983d614ddae4769c$export$306c0aa65ff9ec16; }, function (v) { return $983d614ddae4769c$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $983d614ddae4769c$export$306c0aa65ff9ec16;
"use strict";

var $1T1QG = parcelRequire("1T1QG");
function $983d614ddae4769c$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $983d614ddae4769c$var$k = "function" === typeof Object.is ? Object.is : $983d614ddae4769c$var$h, $983d614ddae4769c$var$l = $1T1QG.useState, $983d614ddae4769c$var$m = $1T1QG.useEffect, $983d614ddae4769c$var$n = $1T1QG.useLayoutEffect, $983d614ddae4769c$var$p = $1T1QG.useDebugValue;
function $983d614ddae4769c$var$q(a, b) {
    var d = b(), f = $983d614ddae4769c$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $983d614ddae4769c$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $983d614ddae4769c$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $983d614ddae4769c$var$m(function() {
        $983d614ddae4769c$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $983d614ddae4769c$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $983d614ddae4769c$var$p(d);
    return d;
}
function $983d614ddae4769c$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$983d614ddae4769c$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $983d614ddae4769c$var$t(a, b) {
    return b();
}
var $983d614ddae4769c$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $983d614ddae4769c$var$t : $983d614ddae4769c$var$q;
$983d614ddae4769c$export$306c0aa65ff9ec16 = void 0 !== $1T1QG.useSyncExternalStore ? $1T1QG.useSyncExternalStore : $983d614ddae4769c$var$u;

});

parcelRegister("eAFD6", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $a9f4b8484a255568$export$bf730a2d8bf68b42; }, function (v) { return $a9f4b8484a255568$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a9f4b8484a255568$export$bf730a2d8bf68b42;
"use strict";

var $1T1QG = parcelRequire("1T1QG");

var $3wB3x = parcelRequire("3wB3x");
function $a9f4b8484a255568$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a9f4b8484a255568$var$q = "function" === typeof Object.is ? Object.is : $a9f4b8484a255568$var$p, $a9f4b8484a255568$var$r = $3wB3x.useSyncExternalStore, $a9f4b8484a255568$var$t = $1T1QG.useRef, $a9f4b8484a255568$var$u = $1T1QG.useEffect, $a9f4b8484a255568$var$v = $1T1QG.useMemo, $a9f4b8484a255568$var$w = $1T1QG.useDebugValue;
$a9f4b8484a255568$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $a9f4b8484a255568$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $a9f4b8484a255568$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($a9f4b8484a255568$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $a9f4b8484a255568$var$r(a, c[0], c[1]);
    $a9f4b8484a255568$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $a9f4b8484a255568$var$w(d);
    return d;
};

});
parcelRegister("3wB3x", function(module, exports) {
"use strict";

module.exports = (parcelRequire("d4mRi"));

});


parcelRegister("dhnvT", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $9aaf1a24aa9f7a50$export$a7c73072b1a182ae; }, function (v) { return $9aaf1a24aa9f7a50$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $9aaf1a24aa9f7a50$export$9f27bc3417b4524d; }, function (v) { return $9aaf1a24aa9f7a50$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $9aaf1a24aa9f7a50$export$db77ccec0bb4ccac; }, function (v) { return $9aaf1a24aa9f7a50$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $9aaf1a24aa9f7a50$export$8392c0c9d3dcbd35; }, function (v) { return $9aaf1a24aa9f7a50$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $9aaf1a24aa9f7a50$export$ffb0004e005737fa; }, function (v) { return $9aaf1a24aa9f7a50$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $9aaf1a24aa9f7a50$export$b624eff549462981; }, function (v) { return $9aaf1a24aa9f7a50$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $9aaf1a24aa9f7a50$export$7897aa7841a5380c; }, function (v) { return $9aaf1a24aa9f7a50$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $9aaf1a24aa9f7a50$export$602eac185826482c; }, function (v) { return $9aaf1a24aa9f7a50$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $9aaf1a24aa9f7a50$export$e2c29f18771995cb; }, function (v) { return $9aaf1a24aa9f7a50$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $9aaf1a24aa9f7a50$export$5f8d39834fd61797; }, function (v) { return $9aaf1a24aa9f7a50$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $9aaf1a24aa9f7a50$export$74bf444e3cd11ea5; }, function (v) { return $9aaf1a24aa9f7a50$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $9aaf1a24aa9f7a50$export$998bcd577473dd93; }, function (v) { return $9aaf1a24aa9f7a50$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $9aaf1a24aa9f7a50$export$92387174baf9b227; }, function (v) { return $9aaf1a24aa9f7a50$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $9aaf1a24aa9f7a50$export$ec112efeb987d9c6; }, function (v) { return $9aaf1a24aa9f7a50$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $9aaf1a24aa9f7a50$export$b706b080d889d2c9; }, function (v) { return $9aaf1a24aa9f7a50$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $9aaf1a24aa9f7a50$export$5be5a87408f70ddc; }, function (v) { return $9aaf1a24aa9f7a50$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $9aaf1a24aa9f7a50$export$45a5e7f76e0caa8d; }, function (v) { return $9aaf1a24aa9f7a50$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $9aaf1a24aa9f7a50$export$455c2e768291efa6; }, function (v) { return $9aaf1a24aa9f7a50$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $9aaf1a24aa9f7a50$export$9522e17588c12572; }, function (v) { return $9aaf1a24aa9f7a50$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $9aaf1a24aa9f7a50$export$2110ac352bb060b9; }, function (v) { return $9aaf1a24aa9f7a50$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $9aaf1a24aa9f7a50$export$56885ab8b9c456ab; }, function (v) { return $9aaf1a24aa9f7a50$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $9aaf1a24aa9f7a50$export$d927fcb6adf8f9de; }, function (v) { return $9aaf1a24aa9f7a50$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $9aaf1a24aa9f7a50$export$b82d16f27459e05a; }, function (v) { return $9aaf1a24aa9f7a50$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $9aaf1a24aa9f7a50$export$522c17b4f5e123e8; }, function (v) { return $9aaf1a24aa9f7a50$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $9aaf1a24aa9f7a50$export$1aabd8a0274ecfd6; }, function (v) { return $9aaf1a24aa9f7a50$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $9aaf1a24aa9f7a50$export$3d6c20d97e46b957; }, function (v) { return $9aaf1a24aa9f7a50$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $9aaf1a24aa9f7a50$export$9b621391a187a31a; }, function (v) { return $9aaf1a24aa9f7a50$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $9aaf1a24aa9f7a50$export$f5bbd400c2f4426f; }, function (v) { return $9aaf1a24aa9f7a50$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9aaf1a24aa9f7a50$export$a7c73072b1a182ae;
var $9aaf1a24aa9f7a50$export$9f27bc3417b4524d;
var $9aaf1a24aa9f7a50$export$db77ccec0bb4ccac;
var $9aaf1a24aa9f7a50$export$8392c0c9d3dcbd35;
var $9aaf1a24aa9f7a50$export$ffb0004e005737fa;
var $9aaf1a24aa9f7a50$export$b624eff549462981;
var $9aaf1a24aa9f7a50$export$7897aa7841a5380c;
var $9aaf1a24aa9f7a50$export$602eac185826482c;
var $9aaf1a24aa9f7a50$export$e2c29f18771995cb;
var $9aaf1a24aa9f7a50$export$5f8d39834fd61797;
var $9aaf1a24aa9f7a50$export$74bf444e3cd11ea5;
var $9aaf1a24aa9f7a50$export$998bcd577473dd93;
var $9aaf1a24aa9f7a50$export$92387174baf9b227;
var $9aaf1a24aa9f7a50$export$ec112efeb987d9c6;
var $9aaf1a24aa9f7a50$export$b706b080d889d2c9;
var $9aaf1a24aa9f7a50$export$5be5a87408f70ddc;
var $9aaf1a24aa9f7a50$export$45a5e7f76e0caa8d;
var $9aaf1a24aa9f7a50$export$455c2e768291efa6;
var $9aaf1a24aa9f7a50$export$9522e17588c12572;
var $9aaf1a24aa9f7a50$export$2110ac352bb060b9;
var $9aaf1a24aa9f7a50$export$56885ab8b9c456ab;
var $9aaf1a24aa9f7a50$export$d927fcb6adf8f9de;
var $9aaf1a24aa9f7a50$export$b82d16f27459e05a;
var $9aaf1a24aa9f7a50$export$522c17b4f5e123e8;
var $9aaf1a24aa9f7a50$export$1aabd8a0274ecfd6;
var $9aaf1a24aa9f7a50$export$3d6c20d97e46b957;
var $9aaf1a24aa9f7a50$export$9b621391a187a31a;
var $9aaf1a24aa9f7a50$export$f5bbd400c2f4426f;
"use strict";
var $9aaf1a24aa9f7a50$var$b = Symbol.for("react.element"), $9aaf1a24aa9f7a50$var$c = Symbol.for("react.portal"), $9aaf1a24aa9f7a50$var$d = Symbol.for("react.fragment"), $9aaf1a24aa9f7a50$var$e = Symbol.for("react.strict_mode"), $9aaf1a24aa9f7a50$var$f = Symbol.for("react.profiler"), $9aaf1a24aa9f7a50$var$g = Symbol.for("react.provider"), $9aaf1a24aa9f7a50$var$h = Symbol.for("react.context"), $9aaf1a24aa9f7a50$var$k = Symbol.for("react.server_context"), $9aaf1a24aa9f7a50$var$l = Symbol.for("react.forward_ref"), $9aaf1a24aa9f7a50$var$m = Symbol.for("react.suspense"), $9aaf1a24aa9f7a50$var$n = Symbol.for("react.suspense_list"), $9aaf1a24aa9f7a50$var$p = Symbol.for("react.memo"), $9aaf1a24aa9f7a50$var$q = Symbol.for("react.lazy"), $9aaf1a24aa9f7a50$var$t = Symbol.for("react.offscreen"), $9aaf1a24aa9f7a50$var$u;
$9aaf1a24aa9f7a50$var$u = Symbol.for("react.module.reference");
function $9aaf1a24aa9f7a50$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $9aaf1a24aa9f7a50$var$b:
                switch(a = a.type, a){
                    case $9aaf1a24aa9f7a50$var$d:
                    case $9aaf1a24aa9f7a50$var$f:
                    case $9aaf1a24aa9f7a50$var$e:
                    case $9aaf1a24aa9f7a50$var$m:
                    case $9aaf1a24aa9f7a50$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9aaf1a24aa9f7a50$var$k:
                            case $9aaf1a24aa9f7a50$var$h:
                            case $9aaf1a24aa9f7a50$var$l:
                            case $9aaf1a24aa9f7a50$var$q:
                            case $9aaf1a24aa9f7a50$var$p:
                            case $9aaf1a24aa9f7a50$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $9aaf1a24aa9f7a50$var$c:
                return r;
        }
    }
}
$9aaf1a24aa9f7a50$export$a7c73072b1a182ae = $9aaf1a24aa9f7a50$var$h;
$9aaf1a24aa9f7a50$export$9f27bc3417b4524d = $9aaf1a24aa9f7a50$var$g;
$9aaf1a24aa9f7a50$export$db77ccec0bb4ccac = $9aaf1a24aa9f7a50$var$b;
$9aaf1a24aa9f7a50$export$8392c0c9d3dcbd35 = $9aaf1a24aa9f7a50$var$l;
$9aaf1a24aa9f7a50$export$ffb0004e005737fa = $9aaf1a24aa9f7a50$var$d;
$9aaf1a24aa9f7a50$export$b624eff549462981 = $9aaf1a24aa9f7a50$var$q;
$9aaf1a24aa9f7a50$export$7897aa7841a5380c = $9aaf1a24aa9f7a50$var$p;
$9aaf1a24aa9f7a50$export$602eac185826482c = $9aaf1a24aa9f7a50$var$c;
$9aaf1a24aa9f7a50$export$e2c29f18771995cb = $9aaf1a24aa9f7a50$var$f;
$9aaf1a24aa9f7a50$export$5f8d39834fd61797 = $9aaf1a24aa9f7a50$var$e;
$9aaf1a24aa9f7a50$export$74bf444e3cd11ea5 = $9aaf1a24aa9f7a50$var$m;
$9aaf1a24aa9f7a50$export$998bcd577473dd93 = $9aaf1a24aa9f7a50$var$n;
$9aaf1a24aa9f7a50$export$92387174baf9b227 = function() {
    return !1;
};
$9aaf1a24aa9f7a50$export$ec112efeb987d9c6 = function() {
    return !1;
};
$9aaf1a24aa9f7a50$export$b706b080d889d2c9 = function(a) {
    return $9aaf1a24aa9f7a50$var$v(a) === $9aaf1a24aa9f7a50$var$h;
};
$9aaf1a24aa9f7a50$export$5be5a87408f70ddc = function(a) {
    return $9aaf1a24aa9f7a50$var$v(a) === $9aaf1a24aa9f7a50$var$g;
};
$9aaf1a24aa9f7a50$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9aaf1a24aa9f7a50$var$b;
};
$9aaf1a24aa9f7a50$export$455c2e768291efa6 = function(a) {
    return $9aaf1a24aa9f7a50$var$v(a) === $9aaf1a24aa9f7a50$var$l;
};
$9aaf1a24aa9f7a50$export$9522e17588c12572 = function(a) {
    return $9aaf1a24aa9f7a50$var$v(a) === $9aaf1a24aa9f7a50$var$d;
};
$9aaf1a24aa9f7a50$export$2110ac352bb060b9 = function(a) {
    return $9aaf1a24aa9f7a50$var$v(a) === $9aaf1a24aa9f7a50$var$q;
};
$9aaf1a24aa9f7a50$export$56885ab8b9c456ab = function(a) {
    return $9aaf1a24aa9f7a50$var$v(a) === $9aaf1a24aa9f7a50$var$p;
};
$9aaf1a24aa9f7a50$export$d927fcb6adf8f9de = function(a) {
    return $9aaf1a24aa9f7a50$var$v(a) === $9aaf1a24aa9f7a50$var$c;
};
$9aaf1a24aa9f7a50$export$b82d16f27459e05a = function(a) {
    return $9aaf1a24aa9f7a50$var$v(a) === $9aaf1a24aa9f7a50$var$f;
};
$9aaf1a24aa9f7a50$export$522c17b4f5e123e8 = function(a) {
    return $9aaf1a24aa9f7a50$var$v(a) === $9aaf1a24aa9f7a50$var$e;
};
$9aaf1a24aa9f7a50$export$1aabd8a0274ecfd6 = function(a) {
    return $9aaf1a24aa9f7a50$var$v(a) === $9aaf1a24aa9f7a50$var$m;
};
$9aaf1a24aa9f7a50$export$3d6c20d97e46b957 = function(a) {
    return $9aaf1a24aa9f7a50$var$v(a) === $9aaf1a24aa9f7a50$var$n;
};
$9aaf1a24aa9f7a50$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9aaf1a24aa9f7a50$var$d || a === $9aaf1a24aa9f7a50$var$f || a === $9aaf1a24aa9f7a50$var$e || a === $9aaf1a24aa9f7a50$var$m || a === $9aaf1a24aa9f7a50$var$n || a === $9aaf1a24aa9f7a50$var$t || "object" === typeof a && null !== a && (a.$$typeof === $9aaf1a24aa9f7a50$var$q || a.$$typeof === $9aaf1a24aa9f7a50$var$p || a.$$typeof === $9aaf1a24aa9f7a50$var$g || a.$$typeof === $9aaf1a24aa9f7a50$var$h || a.$$typeof === $9aaf1a24aa9f7a50$var$l || a.$$typeof === $9aaf1a24aa9f7a50$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$9aaf1a24aa9f7a50$export$f5bbd400c2f4426f = $9aaf1a24aa9f7a50$var$v;

});

parcelRegister("2pESa", function(module, exports) {

var $fqPbb = parcelRequire("fqPbb");

var $iUW6c = parcelRequire("iUW6c");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $fqPbb.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $iUW6c;
module.exports = isBuffer;

});
parcelRegister("fqPbb", function(module, exports) {

var $3sxty = parcelRequire("3sxty");
/** Detect free variable `self`. */ var $b3c0fbdfd07d66d7$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $b3c0fbdfd07d66d7$var$root = $3sxty || $b3c0fbdfd07d66d7$var$freeSelf || Function("return this")();
module.exports = $b3c0fbdfd07d66d7$var$root;

});
parcelRegister("3sxty", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $284df430f0523a40$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $284df430f0523a40$var$freeGlobal;

});


parcelRegister("iUW6c", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $dc5a863a40d9540e$var$stubFalse() {
    return false;
}
module.exports = $dc5a863a40d9540e$var$stubFalse;

});


parcelRegister("4gXwB", function(module, exports) {

var $3sxty = parcelRequire("3sxty");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $3sxty.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("ggrDq", function(module, exports) {

var $fqPbb = parcelRequire("fqPbb");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $fqPbb.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("jJTzp", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $jdjLq.default;
    }
});

var $jdjLq = parcelRequire("jdjLq");

});
parcelRegister("jdjLq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfce8ff1b9346e78$export$2e2bcd8739ae039; });

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");

var $lCLan = parcelRequire("lCLan");

var $3Py8h = parcelRequire("3Py8h");
"use client";
function $dfce8ff1b9346e78$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $lCLan.default), (0, $ajTRS.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $lCLan.default).muiName;
    return /*#__PURE__*/ $1T1QG.memo(/*#__PURE__*/ $1T1QG.forwardRef(Component));
}

});
parcelRegister("ajTRS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $783703f395a3d0a8$export$2e2bcd8739ae039; });
function $783703f395a3d0a8$export$2e2bcd8739ae039() {
    $783703f395a3d0a8$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $783703f395a3d0a8$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("lCLan", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbe1bbd6832449eb$export$2e2bcd8739ae039; });

var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $5wtOU = parcelRequire("5wtOU");

var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $ghoWx = parcelRequire("ghoWx");

var $3Py8h = parcelRequire("3Py8h");
"use client";
const $fbe1bbd6832449eb$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $fbe1bbd6832449eb$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $5wtOU.default)(color)}`,
            `fontSize${(0, $5wtOU.default)(fontSize)}`
        ]
    };
    return (0, $iV85C.default)(slots, (0, $ghoWx.getSvgIconUtilityClass), classes);
};
const $fbe1bbd6832449eb$var$SvgIconRoot = (0, $npagc.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $5wtOU.default)(ownerState.color)}`],
            styles[`fontSize${(0, $5wtOU.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $fbe1bbd6832449eb$var$SvgIcon = /*#__PURE__*/ $1T1QG.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $iXdVf.default)(props, $fbe1bbd6832449eb$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $1T1QG.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $ajTRS.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $fbe1bbd6832449eb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($fbe1bbd6832449eb$var$SvgIconRoot, (0, $ajTRS.default)({
        as: component,
        className: (0, $aVXbR.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $3Py8h.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$fbe1bbd6832449eb$var$SvgIcon.muiName = "SvgIcon";
var $fbe1bbd6832449eb$export$2e2bcd8739ae039 = $fbe1bbd6832449eb$var$SvgIcon;

});
parcelRegister("iXdVf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcc8895f408a3cde$export$2e2bcd8739ae039; });
function $dcc8895f408a3cde$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("aVXbR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7b9bf27cfb834da$export$2e2bcd8739ae039; });
function $b7b9bf27cfb834da$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $b7b9bf27cfb834da$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $b7b9bf27cfb834da$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $b7b9bf27cfb834da$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $b7b9bf27cfb834da$export$2e2bcd8739ae039 = $b7b9bf27cfb834da$export$4f5d2d50c9deca37;

});

parcelRegister("iV85C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc63d3509e12b0b6$export$2e2bcd8739ae039; });
function $dc63d3509e12b0b6$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("5wtOU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4057129228d8360b$export$2e2bcd8739ae039; });

var $7ZhQx = parcelRequire("7ZhQx");
var $4057129228d8360b$export$2e2bcd8739ae039 = (0, $7ZhQx.default);

});
parcelRegister("7ZhQx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d0c12d96b94ae03$export$2e2bcd8739ae039; });

var $fxhNB = parcelRequire("fxhNB");
function $5d0c12d96b94ae03$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $fxhNB.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("fxhNB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4f7be97d343d5b0$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui-internal/babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $b4f7be97d343d5b0$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRegister("gADeF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c13e718392d4abfa$export$2e2bcd8739ae039; });

var $63vkt = parcelRequire("63vkt");

var $4Ydi5 = parcelRequire("4Ydi5");

var $557GP = parcelRequire("557GP");
"use client";
function $c13e718392d4abfa$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $63vkt.default)({
        props: props,
        name: name,
        defaultTheme: $4Ydi5.default,
        themeId: (0, $557GP.default)
    });
}

});
parcelRegister("63vkt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $468b5339c95e138b$export$2e2bcd8739ae039; });

var $f0MeF = parcelRequire("f0MeF");

var $5N3fo = parcelRequire("5N3fo");
"use client";
function $468b5339c95e138b$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $5N3fo.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $f0MeF.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("f0MeF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aedc45afc1b7536b$export$2e2bcd8739ae039; });

var $uu5Ws = parcelRequire("uu5Ws");
function $aedc45afc1b7536b$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $uu5Ws.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("uu5Ws", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05ba25aa1335236a$export$2e2bcd8739ae039; });

var $ajTRS = parcelRequire("ajTRS");
function $05ba25aa1335236a$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $ajTRS.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $ajTRS.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $ajTRS.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $05ba25aa1335236a$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("5N3fo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43740c384f25c709$export$2e2bcd8739ae039; });

var $3osRD = parcelRequire("3osRD");

var $6UrSi = parcelRequire("6UrSi");
"use client";
const $43740c384f25c709$export$35e57303dbd8a66 = (0, $3osRD.default)();
function $43740c384f25c709$var$useTheme(defaultTheme = $43740c384f25c709$export$35e57303dbd8a66) {
    return (0, $6UrSi.default)(defaultTheme);
}
var $43740c384f25c709$export$2e2bcd8739ae039 = $43740c384f25c709$var$useTheme;

});
parcelRegister("3osRD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $278a00d03c15b8a6$export$2e2bcd8739ae039; });

var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $3MwXn = parcelRequire("3MwXn");

var $dZF9G = parcelRequire("dZF9G");

var $bPmrV = parcelRequire("bPmrV");

var $alfxJ = parcelRequire("alfxJ");

var $lVN5Q = parcelRequire("lVN5Q");

var $h0eTu = parcelRequire("h0eTu");

var $lxwoB = parcelRequire("lxwoB");
const $278a00d03c15b8a6$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $278a00d03c15b8a6$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $iXdVf.default)(options, $278a00d03c15b8a6$var$_excluded);
    const breakpoints = (0, $dZF9G.default)(breakpointsInput);
    const spacing = (0, $alfxJ.default)(spacingInput);
    let muiTheme = (0, $3MwXn.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $ajTRS.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $ajTRS.default)({}, (0, $bPmrV.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $lxwoB.default);
    muiTheme = args.reduce((acc, argument)=>(0, $3MwXn.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $ajTRS.default)({}, (0, $h0eTu.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $lVN5Q.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $278a00d03c15b8a6$export$2e2bcd8739ae039 = $278a00d03c15b8a6$var$createTheme;

});
parcelRegister("3MwXn", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $2c0f6b4e70956fe5$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $2c0f6b4e70956fe5$export$2e2bcd8739ae039; });

var $ajTRS = parcelRequire("ajTRS");
function $2c0f6b4e70956fe5$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $2c0f6b4e70956fe5$var$deepClone(source) {
    if (!$2c0f6b4e70956fe5$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $2c0f6b4e70956fe5$var$deepClone(source[key]);
    });
    return output;
}
function $2c0f6b4e70956fe5$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $ajTRS.default)({}, target) : target;
    if ($2c0f6b4e70956fe5$export$53b83ca8eaab0383(target) && $2c0f6b4e70956fe5$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($2c0f6b4e70956fe5$export$53b83ca8eaab0383(source[key]) && key in target && $2c0f6b4e70956fe5$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $2c0f6b4e70956fe5$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $2c0f6b4e70956fe5$export$53b83ca8eaab0383(source[key]) ? $2c0f6b4e70956fe5$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("dZF9G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a300e569e4df76a9$export$2e2bcd8739ae039; });

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");
const $a300e569e4df76a9$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $a300e569e4df76a9$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $a300e569e4df76a9$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $ajTRS.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $a300e569e4df76a9$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $iXdVf.default)(breakpoints, $a300e569e4df76a9$var$_excluded);
    const sortedValues = $a300e569e4df76a9$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $ajTRS.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("bPmrV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89c5df233378efc7$export$2e2bcd8739ae039; });
const $89c5df233378efc7$var$shape = {
    borderRadius: 4
};
var $89c5df233378efc7$export$2e2bcd8739ae039 = $89c5df233378efc7$var$shape;

});

parcelRegister("alfxJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7877ec17408a8c64$export$2e2bcd8739ae039; });

var $crrI5 = parcelRequire("crrI5");
function $7877ec17408a8c64$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $crrI5.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("crrI5", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $0256694b7266516e$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $0256694b7266516e$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $0256694b7266516e$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $0256694b7266516e$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $0256694b7266516e$export$6f98e8eaf0be1996; });


var $leuQP = parcelRequire("leuQP");

var $6anZL = parcelRequire("6anZL");

var $fyY65 = parcelRequire("fyY65");

var $jZQrC = parcelRequire("jZQrC");
const $0256694b7266516e$var$properties = {
    m: "margin",
    p: "padding"
};
const $0256694b7266516e$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $0256694b7266516e$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $0256694b7266516e$var$getCssProperties = (0, $jZQrC.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($0256694b7266516e$var$aliases[prop]) prop = $0256694b7266516e$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $0256694b7266516e$var$properties[a];
    const direction = $0256694b7266516e$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $0256694b7266516e$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $0256694b7266516e$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $0256694b7266516e$var$spacingKeys = [
    ...$0256694b7266516e$export$aab52a0dde05ad8a,
    ...$0256694b7266516e$export$f8397d44f03ab6ad
];
function $0256694b7266516e$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $6anZL.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $0256694b7266516e$export$1def6f833384e3d1(theme) {
    return $0256694b7266516e$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $0256694b7266516e$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $0256694b7266516e$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $0256694b7266516e$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $0256694b7266516e$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $0256694b7266516e$var$getCssProperties(prop);
    const styleFromPropValue = $0256694b7266516e$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $leuQP.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $0256694b7266516e$var$style(props, keys) {
    const transformer = $0256694b7266516e$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$0256694b7266516e$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $fyY65.default), {});
}
function $0256694b7266516e$export$7ede87f9b603dd3c(props) {
    return $0256694b7266516e$var$style(props, $0256694b7266516e$export$aab52a0dde05ad8a);
}
$0256694b7266516e$export$7ede87f9b603dd3c.propTypes = {};
$0256694b7266516e$export$7ede87f9b603dd3c.filterProps = $0256694b7266516e$export$aab52a0dde05ad8a;
function $0256694b7266516e$export$6f98e8eaf0be1996(props) {
    return $0256694b7266516e$var$style(props, $0256694b7266516e$export$f8397d44f03ab6ad);
}
$0256694b7266516e$export$6f98e8eaf0be1996.propTypes = {};
$0256694b7266516e$export$6f98e8eaf0be1996.filterProps = $0256694b7266516e$export$f8397d44f03ab6ad;
function $0256694b7266516e$var$spacing(props) {
    return $0256694b7266516e$var$style(props, $0256694b7266516e$var$spacingKeys);
}
$0256694b7266516e$var$spacing.propTypes = {};
$0256694b7266516e$var$spacing.filterProps = $0256694b7266516e$var$spacingKeys;
var $0256694b7266516e$export$2e2bcd8739ae039 = $0256694b7266516e$var$spacing;

});
parcelRegister("leuQP", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $f752d628b82cee7a$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $f752d628b82cee7a$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $f752d628b82cee7a$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $f752d628b82cee7a$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $f752d628b82cee7a$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $f752d628b82cee7a$export$980e6a259d807490; });

var $ajTRS = parcelRequire("ajTRS");


var $3MwXn = parcelRequire("3MwXn");

var $fyY65 = parcelRequire("fyY65");
const $f752d628b82cee7a$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $f752d628b82cee7a$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$f752d628b82cee7a$export$68c286be0e7e55b7[key]}px)`
};
function $f752d628b82cee7a$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $f752d628b82cee7a$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $f752d628b82cee7a$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $f752d628b82cee7a$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $f752d628b82cee7a$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $f752d628b82cee7a$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $ajTRS.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $fyY65.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $f752d628b82cee7a$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $f752d628b82cee7a$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $f752d628b82cee7a$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $f752d628b82cee7a$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $3MwXn.default)(prev, next), {});
    return $f752d628b82cee7a$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $f752d628b82cee7a$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $f752d628b82cee7a$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $f752d628b82cee7a$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $f752d628b82cee7a$export$2e2bcd8739ae039 = $f752d628b82cee7a$var$breakpoints;

});
parcelRegister("fyY65", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b548a60905dab158$export$2e2bcd8739ae039; });

var $3MwXn = parcelRequire("3MwXn");
function $b548a60905dab158$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $3MwXn.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $b548a60905dab158$export$2e2bcd8739ae039 = $b548a60905dab158$var$merge;

});


parcelRegister("6anZL", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $47d64a2fbbec13b7$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $47d64a2fbbec13b7$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $47d64a2fbbec13b7$export$2e2bcd8739ae039; });

var $7ZhQx = parcelRequire("7ZhQx");


var $leuQP = parcelRequire("leuQP");
function $47d64a2fbbec13b7$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $47d64a2fbbec13b7$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $47d64a2fbbec13b7$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $47d64a2fbbec13b7$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $47d64a2fbbec13b7$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $47d64a2fbbec13b7$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $47d64a2fbbec13b7$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $7ZhQx.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $leuQP.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $47d64a2fbbec13b7$export$2e2bcd8739ae039 = $47d64a2fbbec13b7$var$style;

});

parcelRegister("jZQrC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8ec65307ce455bf$export$2e2bcd8739ae039; });
function $e8ec65307ce455bf$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("lVN5Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff7500bd4648a7dc$export$2e2bcd8739ae039; });

var $7ZhQx = parcelRequire("7ZhQx");

var $fyY65 = parcelRequire("fyY65");

var $6anZL = parcelRequire("6anZL");

var $leuQP = parcelRequire("leuQP");

var $h0eTu = parcelRequire("h0eTu");
function $ff7500bd4648a7dc$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $ff7500bd4648a7dc$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $ff7500bd4648a7dc$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $6anZL.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $6anZL.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $6anZL.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $7ZhQx.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $leuQP.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $h0eTu.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $leuQP.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $ff7500bd4648a7dc$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $fyY65.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $leuQP.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($ff7500bd4648a7dc$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $fyY65.default)(css, breakpointsValues);
                        }
                    } else css = (0, $fyY65.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $leuQP.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $ff7500bd4648a7dc$var$styleFunctionSx = $ff7500bd4648a7dc$export$7d53d8bf2911e013();
$ff7500bd4648a7dc$var$styleFunctionSx.filterProps = [
    "sx"
];
var $ff7500bd4648a7dc$export$2e2bcd8739ae039 = $ff7500bd4648a7dc$var$styleFunctionSx;

});
parcelRegister("h0eTu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c60dfd5f7ffc1033$export$2e2bcd8739ae039; });

var $crrI5 = parcelRequire("crrI5");

var $7wXQ8 = parcelRequire("7wXQ8");

var $2RXWj = parcelRequire("2RXWj");

var $aezRJ = parcelRequire("aezRJ");

var $2fsw0 = parcelRequire("2fsw0");
const $c60dfd5f7ffc1033$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $7wXQ8.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $7wXQ8.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $7wXQ8.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $7wXQ8.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $7wXQ8.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $7wXQ8.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $7wXQ8.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $aezRJ.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $aezRJ.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $aezRJ.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $crrI5.padding)
    },
    pt: {
        style: (0, $crrI5.padding)
    },
    pr: {
        style: (0, $crrI5.padding)
    },
    pb: {
        style: (0, $crrI5.padding)
    },
    pl: {
        style: (0, $crrI5.padding)
    },
    px: {
        style: (0, $crrI5.padding)
    },
    py: {
        style: (0, $crrI5.padding)
    },
    padding: {
        style: (0, $crrI5.padding)
    },
    paddingTop: {
        style: (0, $crrI5.padding)
    },
    paddingRight: {
        style: (0, $crrI5.padding)
    },
    paddingBottom: {
        style: (0, $crrI5.padding)
    },
    paddingLeft: {
        style: (0, $crrI5.padding)
    },
    paddingX: {
        style: (0, $crrI5.padding)
    },
    paddingY: {
        style: (0, $crrI5.padding)
    },
    paddingInline: {
        style: (0, $crrI5.padding)
    },
    paddingInlineStart: {
        style: (0, $crrI5.padding)
    },
    paddingInlineEnd: {
        style: (0, $crrI5.padding)
    },
    paddingBlock: {
        style: (0, $crrI5.padding)
    },
    paddingBlockStart: {
        style: (0, $crrI5.padding)
    },
    paddingBlockEnd: {
        style: (0, $crrI5.padding)
    },
    m: {
        style: (0, $crrI5.margin)
    },
    mt: {
        style: (0, $crrI5.margin)
    },
    mr: {
        style: (0, $crrI5.margin)
    },
    mb: {
        style: (0, $crrI5.margin)
    },
    ml: {
        style: (0, $crrI5.margin)
    },
    mx: {
        style: (0, $crrI5.margin)
    },
    my: {
        style: (0, $crrI5.margin)
    },
    margin: {
        style: (0, $crrI5.margin)
    },
    marginTop: {
        style: (0, $crrI5.margin)
    },
    marginRight: {
        style: (0, $crrI5.margin)
    },
    marginBottom: {
        style: (0, $crrI5.margin)
    },
    marginLeft: {
        style: (0, $crrI5.margin)
    },
    marginX: {
        style: (0, $crrI5.margin)
    },
    marginY: {
        style: (0, $crrI5.margin)
    },
    marginInline: {
        style: (0, $crrI5.margin)
    },
    marginInlineStart: {
        style: (0, $crrI5.margin)
    },
    marginInlineEnd: {
        style: (0, $crrI5.margin)
    },
    marginBlock: {
        style: (0, $crrI5.margin)
    },
    marginBlockStart: {
        style: (0, $crrI5.margin)
    },
    marginBlockEnd: {
        style: (0, $crrI5.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $2RXWj.gap)
    },
    rowGap: {
        style: (0, $2RXWj.rowGap)
    },
    columnGap: {
        style: (0, $2RXWj.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $2fsw0.sizingTransform)
    },
    maxWidth: {
        style: (0, $2fsw0.maxWidth)
    },
    minWidth: {
        transform: (0, $2fsw0.sizingTransform)
    },
    height: {
        transform: (0, $2fsw0.sizingTransform)
    },
    maxHeight: {
        transform: (0, $2fsw0.sizingTransform)
    },
    minHeight: {
        transform: (0, $2fsw0.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $c60dfd5f7ffc1033$export$2e2bcd8739ae039 = $c60dfd5f7ffc1033$var$defaultSxConfig;

});
parcelRegister("7wXQ8", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $57b9f0871ad92d16$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $57b9f0871ad92d16$export$7a57f79000377ca2; });


var $6anZL = parcelRequire("6anZL");

var $glIRy = parcelRequire("glIRy");

var $crrI5 = parcelRequire("crrI5");

var $leuQP = parcelRequire("leuQP");
function $57b9f0871ad92d16$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $57b9f0871ad92d16$var$createBorderStyle(prop, transform) {
    return (0, $6anZL.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $57b9f0871ad92d16$export$1edee58a52776cd9 = $57b9f0871ad92d16$var$createBorderStyle("border", $57b9f0871ad92d16$export$34e2febe53ae29cc);
const $57b9f0871ad92d16$export$f9a7b6bd24892946 = $57b9f0871ad92d16$var$createBorderStyle("borderTop", $57b9f0871ad92d16$export$34e2febe53ae29cc);
const $57b9f0871ad92d16$export$5abca33e6be905d2 = $57b9f0871ad92d16$var$createBorderStyle("borderRight", $57b9f0871ad92d16$export$34e2febe53ae29cc);
const $57b9f0871ad92d16$export$e2ce9f12a980a822 = $57b9f0871ad92d16$var$createBorderStyle("borderBottom", $57b9f0871ad92d16$export$34e2febe53ae29cc);
const $57b9f0871ad92d16$export$47658cca1a909427 = $57b9f0871ad92d16$var$createBorderStyle("borderLeft", $57b9f0871ad92d16$export$34e2febe53ae29cc);
const $57b9f0871ad92d16$export$e7fb0694ba2404fc = $57b9f0871ad92d16$var$createBorderStyle("borderColor");
const $57b9f0871ad92d16$export$126a92c968acdb85 = $57b9f0871ad92d16$var$createBorderStyle("borderTopColor");
const $57b9f0871ad92d16$export$85cc51cb8fbb8c0e = $57b9f0871ad92d16$var$createBorderStyle("borderRightColor");
const $57b9f0871ad92d16$export$340b0327727f6d1a = $57b9f0871ad92d16$var$createBorderStyle("borderBottomColor");
const $57b9f0871ad92d16$export$60beef91a985b4bf = $57b9f0871ad92d16$var$createBorderStyle("borderLeftColor");
const $57b9f0871ad92d16$export$f9258c55612cbed7 = $57b9f0871ad92d16$var$createBorderStyle("outline", $57b9f0871ad92d16$export$34e2febe53ae29cc);
const $57b9f0871ad92d16$export$621fe586efeb64b9 = $57b9f0871ad92d16$var$createBorderStyle("outlineColor");
const $57b9f0871ad92d16$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $crrI5.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $crrI5.getValue)(transformer, propValue)
            });
        return (0, $leuQP.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$57b9f0871ad92d16$export$7a57f79000377ca2.propTypes = {};
$57b9f0871ad92d16$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $57b9f0871ad92d16$var$borders = (0, $glIRy.default)($57b9f0871ad92d16$export$1edee58a52776cd9, $57b9f0871ad92d16$export$f9a7b6bd24892946, $57b9f0871ad92d16$export$5abca33e6be905d2, $57b9f0871ad92d16$export$e2ce9f12a980a822, $57b9f0871ad92d16$export$47658cca1a909427, $57b9f0871ad92d16$export$e7fb0694ba2404fc, $57b9f0871ad92d16$export$126a92c968acdb85, $57b9f0871ad92d16$export$85cc51cb8fbb8c0e, $57b9f0871ad92d16$export$340b0327727f6d1a, $57b9f0871ad92d16$export$60beef91a985b4bf, $57b9f0871ad92d16$export$7a57f79000377ca2, $57b9f0871ad92d16$export$f9258c55612cbed7, $57b9f0871ad92d16$export$621fe586efeb64b9);
var $57b9f0871ad92d16$export$2e2bcd8739ae039 = $57b9f0871ad92d16$var$borders;

});
parcelRegister("glIRy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be716851e12e424d$export$2e2bcd8739ae039; });

var $fyY65 = parcelRequire("fyY65");
function $be716851e12e424d$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $fyY65.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $be716851e12e424d$export$2e2bcd8739ae039 = $be716851e12e424d$var$compose;

});


parcelRegister("2RXWj", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $216f06bf15bba63f$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $216f06bf15bba63f$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $216f06bf15bba63f$export$8a833ffa5f5dbeda; });

var $6anZL = parcelRequire("6anZL");

var $glIRy = parcelRequire("glIRy");

var $crrI5 = parcelRequire("crrI5");

var $leuQP = parcelRequire("leuQP");

const $216f06bf15bba63f$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $crrI5.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $crrI5.getValue)(transformer, propValue)
            });
        return (0, $leuQP.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$216f06bf15bba63f$export$5df9adcb0db95e1e.propTypes = {};
$216f06bf15bba63f$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $216f06bf15bba63f$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $crrI5.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $crrI5.getValue)(transformer, propValue)
            });
        return (0, $leuQP.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$216f06bf15bba63f$export$ec60d70ff941a580.propTypes = {};
$216f06bf15bba63f$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $216f06bf15bba63f$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $crrI5.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $crrI5.getValue)(transformer, propValue)
            });
        return (0, $leuQP.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$216f06bf15bba63f$export$8a833ffa5f5dbeda.propTypes = {};
$216f06bf15bba63f$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $216f06bf15bba63f$export$baf44164ca3a34e8 = (0, $6anZL.default)({
    prop: "gridColumn"
});
const $216f06bf15bba63f$export$8f7213a1cd01e832 = (0, $6anZL.default)({
    prop: "gridRow"
});
const $216f06bf15bba63f$export$b0e0abbc49ba668 = (0, $6anZL.default)({
    prop: "gridAutoFlow"
});
const $216f06bf15bba63f$export$bcd8b929d4b4142 = (0, $6anZL.default)({
    prop: "gridAutoColumns"
});
const $216f06bf15bba63f$export$e5039a674e14c828 = (0, $6anZL.default)({
    prop: "gridAutoRows"
});
const $216f06bf15bba63f$export$42bd9088661ffb03 = (0, $6anZL.default)({
    prop: "gridTemplateColumns"
});
const $216f06bf15bba63f$export$920682ae05b999bc = (0, $6anZL.default)({
    prop: "gridTemplateRows"
});
const $216f06bf15bba63f$export$1b88fbdd482fd33a = (0, $6anZL.default)({
    prop: "gridTemplateAreas"
});
const $216f06bf15bba63f$export$bdb486e40d52d26f = (0, $6anZL.default)({
    prop: "gridArea"
});
const $216f06bf15bba63f$var$grid = (0, $glIRy.default)($216f06bf15bba63f$export$5df9adcb0db95e1e, $216f06bf15bba63f$export$ec60d70ff941a580, $216f06bf15bba63f$export$8a833ffa5f5dbeda, $216f06bf15bba63f$export$baf44164ca3a34e8, $216f06bf15bba63f$export$8f7213a1cd01e832, $216f06bf15bba63f$export$b0e0abbc49ba668, $216f06bf15bba63f$export$bcd8b929d4b4142, $216f06bf15bba63f$export$e5039a674e14c828, $216f06bf15bba63f$export$42bd9088661ffb03, $216f06bf15bba63f$export$920682ae05b999bc, $216f06bf15bba63f$export$1b88fbdd482fd33a, $216f06bf15bba63f$export$bdb486e40d52d26f);
var $216f06bf15bba63f$export$2e2bcd8739ae039 = $216f06bf15bba63f$var$grid;

});

parcelRegister("aezRJ", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $7737085f1797e7f5$export$dbaffd4420ea0ac6; });

var $6anZL = parcelRequire("6anZL");

var $glIRy = parcelRequire("glIRy");
function $7737085f1797e7f5$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $7737085f1797e7f5$export$35e9368ef982300f = (0, $6anZL.default)({
    prop: "color",
    themeKey: "palette",
    transform: $7737085f1797e7f5$export$dbaffd4420ea0ac6
});
const $7737085f1797e7f5$export$2506f56c10355b33 = (0, $6anZL.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $7737085f1797e7f5$export$dbaffd4420ea0ac6
});
const $7737085f1797e7f5$export$8c5a050822fd698c = (0, $6anZL.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $7737085f1797e7f5$export$dbaffd4420ea0ac6
});
const $7737085f1797e7f5$var$palette = (0, $glIRy.default)($7737085f1797e7f5$export$35e9368ef982300f, $7737085f1797e7f5$export$2506f56c10355b33, $7737085f1797e7f5$export$8c5a050822fd698c);
var $7737085f1797e7f5$export$2e2bcd8739ae039 = $7737085f1797e7f5$var$palette;

});

parcelRegister("2fsw0", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $1a331a0451722cb4$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $1a331a0451722cb4$export$488fda99655ff65a; });

var $6anZL = parcelRequire("6anZL");

var $glIRy = parcelRequire("glIRy");

var $leuQP = parcelRequire("leuQP");
function $1a331a0451722cb4$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $1a331a0451722cb4$export$7e3df82ee760448c = (0, $6anZL.default)({
    prop: "width",
    transform: $1a331a0451722cb4$export$8afece71750ec241
});
const $1a331a0451722cb4$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $leuQP.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $1a331a0451722cb4$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $leuQP.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$1a331a0451722cb4$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $1a331a0451722cb4$export$ee148fbbe8357dd2 = (0, $6anZL.default)({
    prop: "minWidth",
    transform: $1a331a0451722cb4$export$8afece71750ec241
});
const $1a331a0451722cb4$export$ac607276a8fe9f0a = (0, $6anZL.default)({
    prop: "height",
    transform: $1a331a0451722cb4$export$8afece71750ec241
});
const $1a331a0451722cb4$export$dc0d8bd0b94f8570 = (0, $6anZL.default)({
    prop: "maxHeight",
    transform: $1a331a0451722cb4$export$8afece71750ec241
});
const $1a331a0451722cb4$export$a43cf604e12f3b17 = (0, $6anZL.default)({
    prop: "minHeight",
    transform: $1a331a0451722cb4$export$8afece71750ec241
});
const $1a331a0451722cb4$export$ffed9f14fb65e276 = (0, $6anZL.default)({
    prop: "size",
    cssProperty: "width",
    transform: $1a331a0451722cb4$export$8afece71750ec241
});
const $1a331a0451722cb4$export$905076ed6620e671 = (0, $6anZL.default)({
    prop: "size",
    cssProperty: "height",
    transform: $1a331a0451722cb4$export$8afece71750ec241
});
const $1a331a0451722cb4$export$6ccc93f785106a58 = (0, $6anZL.default)({
    prop: "boxSizing"
});
const $1a331a0451722cb4$var$sizing = (0, $glIRy.default)($1a331a0451722cb4$export$7e3df82ee760448c, $1a331a0451722cb4$export$488fda99655ff65a, $1a331a0451722cb4$export$ee148fbbe8357dd2, $1a331a0451722cb4$export$ac607276a8fe9f0a, $1a331a0451722cb4$export$dc0d8bd0b94f8570, $1a331a0451722cb4$export$a43cf604e12f3b17, $1a331a0451722cb4$export$6ccc93f785106a58);
var $1a331a0451722cb4$export$2e2bcd8739ae039 = $1a331a0451722cb4$var$sizing;

});



parcelRegister("lxwoB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fae5cf28c3bdb6ff$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $fae5cf28c3bdb6ff$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("6UrSi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $507d9862d11cff7c$export$2e2bcd8739ae039; });

var $1T1QG = parcelRequire("1T1QG");
parcelRequire("aMdXx");
var $8WAsW = parcelRequire("8WAsW");
"use client";
function $507d9862d11cff7c$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $507d9862d11cff7c$var$useTheme(defaultTheme = null) {
    const contextTheme = $1T1QG.useContext((0, $8WAsW.T));
    return !contextTheme || $507d9862d11cff7c$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $507d9862d11cff7c$export$2e2bcd8739ae039 = $507d9862d11cff7c$var$useTheme;

});
parcelRegister("aMdXx", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $7d8937174f923d5a$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $7d8937174f923d5a$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $7d8937174f923d5a$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("8WAsW")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("8WAsW")).w; });

var $8WAsW = parcelRequire("8WAsW");

var $1T1QG = parcelRequire("1T1QG");

var $4BgOX = parcelRequire("4BgOX");

var $7vx2W = parcelRequire("7vx2W");

var $bhkCx = parcelRequire("bhkCx");
parcelRequire("4dzel");
parcelRequire("3nTK3");
parcelRequire("iimxS");

parcelRequire("3HlGj");
var $7d8937174f923d5a$var$pkg = {
    name: "@emotion/react",
    version: "11.11.3",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $7d8937174f923d5a$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $8WAsW.h).call(props, "css")) // $FlowFixMe
    return $1T1QG.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $8WAsW.E);
    createElementArgArray[1] = (0, $8WAsW.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $1T1QG.createElement.apply(null, createElementArgArray);
};
var $7d8937174f923d5a$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $7d8937174f923d5a$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $8WAsW.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $bhkCx.serializeStyles)([
        styles
    ], undefined, $1T1QG.useContext((0, $8WAsW.T)));
    if (!(0, $8WAsW.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $1T1QG.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $1T1QG.useRef();
    (0, $7vx2W.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $7vx2W.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $4BgOX.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $7d8937174f923d5a$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $bhkCx.serializeStyles)(args);
}
var $7d8937174f923d5a$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $7d8937174f923d5a$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $7d8937174f923d5a$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $7d8937174f923d5a$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $4BgOX.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $7d8937174f923d5a$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $7vx2W.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $4BgOX.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $7d8937174f923d5a$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $8WAsW.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $bhkCx.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $4BgOX.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $7d8937174f923d5a$var$merge(cache.registered, css, $7d8937174f923d5a$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $1T1QG.useContext((0, $8WAsW.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $1T1QG.createElement($1T1QG.Fragment, null, /*#__PURE__*/ $1T1QG.createElement($7d8937174f923d5a$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $7d8937174f923d5a$var$isBrowser, $7d8937174f923d5a$var$isTestEnv, $7d8937174f923d5a$var$globalContext, $7d8937174f923d5a$var$globalKey;

});
parcelRegister("8WAsW", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $683006df185e1ba3$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $683006df185e1ba3$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "w", function () { return $683006df185e1ba3$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $683006df185e1ba3$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $683006df185e1ba3$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $683006df185e1ba3$export$a9c23c6ac3fc3eca; });

var $1T1QG = parcelRequire("1T1QG");

var $4dzel = parcelRequire("4dzel");

var $5ljFx = parcelRequire("5ljFx");

var $iimxS = parcelRequire("iimxS");

var $lOOzm = parcelRequire("lOOzm");

var $4BgOX = parcelRequire("4BgOX");

var $bhkCx = parcelRequire("bhkCx");

var $7vx2W = parcelRequire("7vx2W");
var $683006df185e1ba3$export$23f2a1d2818174ef = true;
var $683006df185e1ba3$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $683006df185e1ba3$var$EmotionCacheContext = /* #__PURE__ */ $1T1QG.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $4dzel.default)({
    key: "css"
}) : null);
var $683006df185e1ba3$export$e7094788287c5e9b = $683006df185e1ba3$var$EmotionCacheContext.Provider;
var $683006df185e1ba3$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $1T1QG.useContext)($683006df185e1ba3$var$EmotionCacheContext);
};
var $683006df185e1ba3$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $1T1QG.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $1T1QG.useContext)($683006df185e1ba3$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$683006df185e1ba3$export$23f2a1d2818174ef) $683006df185e1ba3$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $1T1QG.useContext)($683006df185e1ba3$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $4dzel.default)({
                key: "css"
            });
            return /*#__PURE__*/ $1T1QG.createElement($683006df185e1ba3$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $683006df185e1ba3$export$971d5caa766a69d7 = /* #__PURE__ */ $1T1QG.createContext({});
var $683006df185e1ba3$export$3b14a55fb2447963 = function useTheme() {
    return $1T1QG.useContext($683006df185e1ba3$export$971d5caa766a69d7);
};
var $683006df185e1ba3$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $5ljFx.default)({}, outerTheme, theme);
};
var $683006df185e1ba3$var$createCacheWithTheme = /* #__PURE__ */ (0, $iimxS.default)(function(outerTheme) {
    return (0, $iimxS.default)(function(theme) {
        return $683006df185e1ba3$var$getTheme(outerTheme, theme);
    });
});
var $683006df185e1ba3$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $1T1QG.useContext($683006df185e1ba3$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $683006df185e1ba3$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $1T1QG.createElement($683006df185e1ba3$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $683006df185e1ba3$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $1T1QG.useContext($683006df185e1ba3$export$971d5caa766a69d7);
        return /*#__PURE__*/ $1T1QG.createElement(Component, (0, $5ljFx.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $1T1QG.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $lOOzm.default)(WithTheme, Component);
}
var $683006df185e1ba3$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $683006df185e1ba3$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $683006df185e1ba3$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $683006df185e1ba3$var$getLastPart(match[1]);
    return undefined;
};
var $683006df185e1ba3$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $683006df185e1ba3$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $683006df185e1ba3$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $683006df185e1ba3$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($683006df185e1ba3$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $683006df185e1ba3$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $683006df185e1ba3$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $683006df185e1ba3$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $683006df185e1ba3$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($683006df185e1ba3$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$683006df185e1ba3$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $683006df185e1ba3$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $4BgOX.registerStyles)(cache, serialized, isStringTag);
    (0, $7vx2W.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $4BgOX.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $683006df185e1ba3$var$Emotion = /* #__PURE__ */ $683006df185e1ba3$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$683006df185e1ba3$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $4BgOX.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $bhkCx.serializeStyles)(registeredStyles, undefined, $1T1QG.useContext($683006df185e1ba3$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($683006df185e1ba3$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $683006df185e1ba3$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $1T1QG.createElement($1T1QG.Fragment, null, /*#__PURE__*/ $1T1QG.createElement($683006df185e1ba3$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $1T1QG.createElement(WrappedComponent, newProps));
});
var $683006df185e1ba3$export$a9c23c6ac3fc3eca = $683006df185e1ba3$var$Emotion;

});
parcelRegister("4dzel", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3123b45c26dee076$export$2e2bcd8739ae039; });

var $3nQlK = parcelRequire("3nQlK");

var $9y5OB = parcelRequire("9y5OB");
parcelRequire("iimxS");
parcelRequire("k7Jom");
var $3123b45c26dee076$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $9y5OB.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $9y5OB.token)(character)) break;
        (0, $9y5OB.next)();
    }
    return (0, $9y5OB.slice)(begin, (0, $9y5OB.position));
};
var $3123b45c26dee076$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $9y5OB.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $9y5OB.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $3123b45c26dee076$var$identifierWithPointTracking((0, $9y5OB.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $9y5OB.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $9y5OB.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $9y5OB.from)(character);
    }
    while (character = (0, $9y5OB.next)());
    return parsed;
};
var $3123b45c26dee076$var$getRules = function getRules(value, points) {
    return (0, $9y5OB.dealloc)($3123b45c26dee076$var$toRules((0, $9y5OB.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $3123b45c26dee076$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $3123b45c26dee076$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$3123b45c26dee076$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $3123b45c26dee076$var$fixedElements.set(element, true);
    var points = [];
    var rules = $3123b45c26dee076$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $3123b45c26dee076$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $3123b45c26dee076$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $3123b45c26dee076$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($3123b45c26dee076$var$ignoreFlag) > -1;
};
var $3123b45c26dee076$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($3123b45c26dee076$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $3123b45c26dee076$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $3123b45c26dee076$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$3123b45c26dee076$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $3123b45c26dee076$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $3123b45c26dee076$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$3123b45c26dee076$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $3123b45c26dee076$var$nullifyElement(element);
    } else if ($3123b45c26dee076$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $3123b45c26dee076$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $3123b45c26dee076$var$prefix(value, length) {
    switch((0, $9y5OB.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $9y5OB.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $9y5OB.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $9y5OB.WEBKIT) + value + (0, $9y5OB.MOZ) + value + (0, $9y5OB.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $9y5OB.WEBKIT) + value + (0, $9y5OB.MS) + value + value;
        // order
        case 6165:
            return (0, $9y5OB.WEBKIT) + value + (0, $9y5OB.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $9y5OB.WEBKIT) + value + (0, $9y5OB.replace)(value, /(\w+).+(:[^]+)/, (0, $9y5OB.WEBKIT) + "box-$1$2" + (0, $9y5OB.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $9y5OB.WEBKIT) + value + (0, $9y5OB.MS) + "flex-item-" + (0, $9y5OB.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $9y5OB.WEBKIT) + value + (0, $9y5OB.MS) + "flex-line-pack" + (0, $9y5OB.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $9y5OB.WEBKIT) + value + (0, $9y5OB.MS) + (0, $9y5OB.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $9y5OB.WEBKIT) + value + (0, $9y5OB.MS) + (0, $9y5OB.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $9y5OB.WEBKIT) + "box-" + (0, $9y5OB.replace)(value, "-grow", "") + (0, $9y5OB.WEBKIT) + value + (0, $9y5OB.MS) + (0, $9y5OB.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $9y5OB.WEBKIT) + (0, $9y5OB.replace)(value, /([^-])(transform)/g, "$1" + (0, $9y5OB.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $9y5OB.replace)((0, $9y5OB.replace)((0, $9y5OB.replace)(value, /(zoom-|grab)/, (0, $9y5OB.WEBKIT) + "$1"), /(image-set)/, (0, $9y5OB.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $9y5OB.replace)(value, /(image-set\([^]*)/, (0, $9y5OB.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $9y5OB.replace)((0, $9y5OB.replace)(value, /(.+:)(flex-)?(.*)/, (0, $9y5OB.WEBKIT) + "box-pack:$3" + (0, $9y5OB.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $9y5OB.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $9y5OB.replace)(value, /(.+)-inline(.+)/, (0, $9y5OB.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $9y5OB.strlen)(value) - 1 - length > 6) switch((0, $9y5OB.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $9y5OB.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $9y5OB.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $9y5OB.WEBKIT) + "$2-$3" + "$1" + (0, $9y5OB.MOZ) + ((0, $9y5OB.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $9y5OB.indexof)(value, "stretch") ? $3123b45c26dee076$var$prefix((0, $9y5OB.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $9y5OB.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $9y5OB.charat)(value, (0, $9y5OB.strlen)(value) - 3 - (~(0, $9y5OB.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $9y5OB.replace)(value, ":", ":" + (0, $9y5OB.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $9y5OB.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $9y5OB.WEBKIT) + ((0, $9y5OB.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $9y5OB.WEBKIT) + "$2$3" + "$1" + (0, $9y5OB.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $9y5OB.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $9y5OB.WEBKIT) + value + (0, $9y5OB.MS) + (0, $9y5OB.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $9y5OB.WEBKIT) + value + (0, $9y5OB.MS) + (0, $9y5OB.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $9y5OB.WEBKIT) + value + (0, $9y5OB.MS) + (0, $9y5OB.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $9y5OB.WEBKIT) + value + (0, $9y5OB.MS) + value + value;
    }
    return value;
}
var $3123b45c26dee076$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $9y5OB.DECLARATION:
                element["return"] = $3123b45c26dee076$var$prefix(element.value, element.length);
                break;
            case 0, $9y5OB.KEYFRAMES:
                return (0, $9y5OB.serialize)([
                    (0, $9y5OB.copy)(element, {
                        value: (0, $9y5OB.replace)(element.value, "@", "@" + (0, $9y5OB.WEBKIT))
                    })
                ], callback);
            case 0, $9y5OB.RULESET:
                if (element.length) return (0, $9y5OB.combine)(element.props, function(value) {
                    switch((0, $9y5OB.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $9y5OB.serialize)([
                                (0, $9y5OB.copy)(element, {
                                    props: [
                                        (0, $9y5OB.replace)(value, /:(read-\w+)/, ":" + (0, $9y5OB.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $9y5OB.serialize)([
                                (0, $9y5OB.copy)(element, {
                                    props: [
                                        (0, $9y5OB.replace)(value, /:(plac\w+)/, ":" + (0, $9y5OB.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $9y5OB.copy)(element, {
                                    props: [
                                        (0, $9y5OB.replace)(value, /:(plac\w+)/, ":" + (0, $9y5OB.MOZ) + "$1")
                                    ]
                                }),
                                (0, $9y5OB.copy)(element, {
                                    props: [
                                        (0, $9y5OB.replace)(value, /:(plac\w+)/, (0, $9y5OB.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $3123b45c26dee076$var$defaultStylisPlugins = [
    $3123b45c26dee076$var$prefixer
];
var $3123b45c26dee076$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $3123b45c26dee076$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $3123b45c26dee076$var$compat,
        $3123b45c26dee076$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $9y5OB.stringify),
        (0, $9y5OB.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $9y5OB.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $9y5OB.serialize)((0, $9y5OB.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $3nQlK.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("3nQlK", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $276c20a3b0434dd4$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $276c20a3b0434dd4$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $276c20a3b0434dd4$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $276c20a3b0434dd4$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($276c20a3b0434dd4$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $276c20a3b0434dd4$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("9y5OB", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $5d97fdbbe2fad025$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $5d97fdbbe2fad025$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $5d97fdbbe2fad025$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $5d97fdbbe2fad025$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $5d97fdbbe2fad025$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $5d97fdbbe2fad025$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $5d97fdbbe2fad025$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $5d97fdbbe2fad025$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $5d97fdbbe2fad025$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $5d97fdbbe2fad025$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $5d97fdbbe2fad025$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $5d97fdbbe2fad025$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $5d97fdbbe2fad025$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $5d97fdbbe2fad025$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $5d97fdbbe2fad025$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $5d97fdbbe2fad025$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $5d97fdbbe2fad025$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $5d97fdbbe2fad025$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $5d97fdbbe2fad025$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $5d97fdbbe2fad025$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $5d97fdbbe2fad025$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $5d97fdbbe2fad025$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $5d97fdbbe2fad025$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $5d97fdbbe2fad025$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $5d97fdbbe2fad025$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $5d97fdbbe2fad025$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $5d97fdbbe2fad025$export$38bcb760f1d4871c; });
var $5d97fdbbe2fad025$export$71ad59f2e432cfe8 = "-ms-";
var $5d97fdbbe2fad025$export$2c0f367103c8d01c = "-moz-";
var $5d97fdbbe2fad025$export$39dfd62a25e0fe93 = "-webkit-";
var $5d97fdbbe2fad025$export$a29989082612d0d9 = "comm";
var $5d97fdbbe2fad025$export$aa3a2e812ca8570d = "rule";
var $5d97fdbbe2fad025$export$527d108ccf083c2b = "decl";
var $5d97fdbbe2fad025$export$d3d35020fa5b54f0 = "@page";
var $5d97fdbbe2fad025$export$500415a86c544f73 = "@media";
var $5d97fdbbe2fad025$export$a763edbf796b780a = "@import";
var $5d97fdbbe2fad025$export$2790aeb8b4e5c826 = "@charset";
var $5d97fdbbe2fad025$export$1cc683e23b84b133 = "@viewport";
var $5d97fdbbe2fad025$export$9447a5efea57e862 = "@supports";
var $5d97fdbbe2fad025$export$ef011b4e114b1fba = "@document";
var $5d97fdbbe2fad025$export$6aad947bda0f3f46 = "@namespace";
var $5d97fdbbe2fad025$export$b44a8529a35fcb60 = "@keyframes";
var $5d97fdbbe2fad025$export$2c16de31893252e6 = "@font-face";
var $5d97fdbbe2fad025$export$3d846dd52e150c6f = "@counter-style";
var $5d97fdbbe2fad025$export$22314bfbb57653fe = "@font-feature-values";
var $5d97fdbbe2fad025$export$d773506282b3cfe6 = "@layer";
var $5d97fdbbe2fad025$export$2335f513bbd82c6d = Math.abs;
var $5d97fdbbe2fad025$export$6788812c4e6611e6 = String.fromCharCode;
var $5d97fdbbe2fad025$export$e6e34fd1f2686227 = Object.assign;
function $5d97fdbbe2fad025$export$d6af199866bfb566(e, r) {
    return $5d97fdbbe2fad025$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $5d97fdbbe2fad025$export$a9db5e087081082d(e, 0)) << 2 ^ $5d97fdbbe2fad025$export$a9db5e087081082d(e, 1)) << 2 ^ $5d97fdbbe2fad025$export$a9db5e087081082d(e, 2)) << 2 ^ $5d97fdbbe2fad025$export$a9db5e087081082d(e, 3) : 0;
}
function $5d97fdbbe2fad025$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $5d97fdbbe2fad025$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $5d97fdbbe2fad025$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $5d97fdbbe2fad025$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $5d97fdbbe2fad025$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $5d97fdbbe2fad025$export$36776f635604f274(e) {
    return e.length;
}
function $5d97fdbbe2fad025$export$f9084667e487ed46(e) {
    return e.length;
}
function $5d97fdbbe2fad025$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $5d97fdbbe2fad025$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $5d97fdbbe2fad025$export$53f1d5ea8de3d7c = 1;
var $5d97fdbbe2fad025$export$4e0c71f277ca26b3 = 1;
var $5d97fdbbe2fad025$export$f24224f1c91d8156 = 0;
var $5d97fdbbe2fad025$export$5880b8b5730aff45 = 0;
var $5d97fdbbe2fad025$export$c0306caf338ac095 = 0;
var $5d97fdbbe2fad025$export$30a86d91af8ff6e6 = "";
function $5d97fdbbe2fad025$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $5d97fdbbe2fad025$export$53f1d5ea8de3d7c,
        column: $5d97fdbbe2fad025$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $5d97fdbbe2fad025$export$784d13d8ee351f07(e, r) {
    return $5d97fdbbe2fad025$export$e6e34fd1f2686227($5d97fdbbe2fad025$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $5d97fdbbe2fad025$export$eba6f6f03b0a92e7() {
    return $5d97fdbbe2fad025$export$c0306caf338ac095;
}
function $5d97fdbbe2fad025$export$232faf9add678146() {
    $5d97fdbbe2fad025$export$c0306caf338ac095 = $5d97fdbbe2fad025$export$5880b8b5730aff45 > 0 ? $5d97fdbbe2fad025$export$a9db5e087081082d($5d97fdbbe2fad025$export$30a86d91af8ff6e6, --$5d97fdbbe2fad025$export$5880b8b5730aff45) : 0;
    if ($5d97fdbbe2fad025$export$4e0c71f277ca26b3--, $5d97fdbbe2fad025$export$c0306caf338ac095 === 10) $5d97fdbbe2fad025$export$4e0c71f277ca26b3 = 1, $5d97fdbbe2fad025$export$53f1d5ea8de3d7c--;
    return $5d97fdbbe2fad025$export$c0306caf338ac095;
}
function $5d97fdbbe2fad025$export$48cfd1e771a65c4f() {
    $5d97fdbbe2fad025$export$c0306caf338ac095 = $5d97fdbbe2fad025$export$5880b8b5730aff45 < $5d97fdbbe2fad025$export$f24224f1c91d8156 ? $5d97fdbbe2fad025$export$a9db5e087081082d($5d97fdbbe2fad025$export$30a86d91af8ff6e6, $5d97fdbbe2fad025$export$5880b8b5730aff45++) : 0;
    if ($5d97fdbbe2fad025$export$4e0c71f277ca26b3++, $5d97fdbbe2fad025$export$c0306caf338ac095 === 10) $5d97fdbbe2fad025$export$4e0c71f277ca26b3 = 1, $5d97fdbbe2fad025$export$53f1d5ea8de3d7c++;
    return $5d97fdbbe2fad025$export$c0306caf338ac095;
}
function $5d97fdbbe2fad025$export$4d3fb11e950abb9e() {
    return $5d97fdbbe2fad025$export$a9db5e087081082d($5d97fdbbe2fad025$export$30a86d91af8ff6e6, $5d97fdbbe2fad025$export$5880b8b5730aff45);
}
function $5d97fdbbe2fad025$export$e88cb2efb12ae807() {
    return $5d97fdbbe2fad025$export$5880b8b5730aff45;
}
function $5d97fdbbe2fad025$export$58adb3bec8346d0f(e, r) {
    return $5d97fdbbe2fad025$export$2f35ab04d2335697($5d97fdbbe2fad025$export$30a86d91af8ff6e6, e, r);
}
function $5d97fdbbe2fad025$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $5d97fdbbe2fad025$export$2de70f21292aac9e(e) {
    return $5d97fdbbe2fad025$export$53f1d5ea8de3d7c = $5d97fdbbe2fad025$export$4e0c71f277ca26b3 = 1, $5d97fdbbe2fad025$export$f24224f1c91d8156 = $5d97fdbbe2fad025$export$36776f635604f274($5d97fdbbe2fad025$export$30a86d91af8ff6e6 = e), $5d97fdbbe2fad025$export$5880b8b5730aff45 = 0, [];
}
function $5d97fdbbe2fad025$export$45918ac1574455b1(e) {
    return $5d97fdbbe2fad025$export$30a86d91af8ff6e6 = "", e;
}
function $5d97fdbbe2fad025$export$410ac95b9ec204b8(e) {
    return $5d97fdbbe2fad025$export$87c2784dc9fc4ab($5d97fdbbe2fad025$export$58adb3bec8346d0f($5d97fdbbe2fad025$export$5880b8b5730aff45 - 1, $5d97fdbbe2fad025$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $5d97fdbbe2fad025$export$660b2ee2d4fb4eff(e) {
    return $5d97fdbbe2fad025$export$45918ac1574455b1($5d97fdbbe2fad025$export$5f8c09e3ae6f64e1($5d97fdbbe2fad025$export$2de70f21292aac9e(e)));
}
function $5d97fdbbe2fad025$export$7af1228ff777d175(e) {
    while($5d97fdbbe2fad025$export$c0306caf338ac095 = $5d97fdbbe2fad025$export$4d3fb11e950abb9e())if ($5d97fdbbe2fad025$export$c0306caf338ac095 < 33) $5d97fdbbe2fad025$export$48cfd1e771a65c4f();
    else break;
    return $5d97fdbbe2fad025$export$9e1725a4cfeada27(e) > 2 || $5d97fdbbe2fad025$export$9e1725a4cfeada27($5d97fdbbe2fad025$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $5d97fdbbe2fad025$export$5f8c09e3ae6f64e1(e) {
    while($5d97fdbbe2fad025$export$48cfd1e771a65c4f())switch($5d97fdbbe2fad025$export$9e1725a4cfeada27($5d97fdbbe2fad025$export$c0306caf338ac095)){
        case 0:
            $5d97fdbbe2fad025$export$10d8903dec122b9d($5d97fdbbe2fad025$export$c2ab62c7bf24634($5d97fdbbe2fad025$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $5d97fdbbe2fad025$export$10d8903dec122b9d($5d97fdbbe2fad025$export$410ac95b9ec204b8($5d97fdbbe2fad025$export$c0306caf338ac095), e);
            break;
        default:
            $5d97fdbbe2fad025$export$10d8903dec122b9d($5d97fdbbe2fad025$export$6788812c4e6611e6($5d97fdbbe2fad025$export$c0306caf338ac095), e);
    }
    return e;
}
function $5d97fdbbe2fad025$export$955ba06d119e085e(e, r) {
    while(--r && $5d97fdbbe2fad025$export$48cfd1e771a65c4f())if ($5d97fdbbe2fad025$export$c0306caf338ac095 < 48 || $5d97fdbbe2fad025$export$c0306caf338ac095 > 102 || $5d97fdbbe2fad025$export$c0306caf338ac095 > 57 && $5d97fdbbe2fad025$export$c0306caf338ac095 < 65 || $5d97fdbbe2fad025$export$c0306caf338ac095 > 70 && $5d97fdbbe2fad025$export$c0306caf338ac095 < 97) break;
    return $5d97fdbbe2fad025$export$58adb3bec8346d0f(e, $5d97fdbbe2fad025$export$e88cb2efb12ae807() + (r < 6 && $5d97fdbbe2fad025$export$4d3fb11e950abb9e() == 32 && $5d97fdbbe2fad025$export$48cfd1e771a65c4f() == 32));
}
function $5d97fdbbe2fad025$export$c889f2fcc19dbf12(e) {
    while($5d97fdbbe2fad025$export$48cfd1e771a65c4f())switch($5d97fdbbe2fad025$export$c0306caf338ac095){
        case e:
            return $5d97fdbbe2fad025$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $5d97fdbbe2fad025$export$c889f2fcc19dbf12($5d97fdbbe2fad025$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $5d97fdbbe2fad025$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $5d97fdbbe2fad025$export$48cfd1e771a65c4f();
            break;
    }
    return $5d97fdbbe2fad025$export$5880b8b5730aff45;
}
function $5d97fdbbe2fad025$export$4254d4e2b3745c4c(e, r) {
    while($5d97fdbbe2fad025$export$48cfd1e771a65c4f())if (e + $5d97fdbbe2fad025$export$c0306caf338ac095 === 57) break;
    else if (e + $5d97fdbbe2fad025$export$c0306caf338ac095 === 84 && $5d97fdbbe2fad025$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $5d97fdbbe2fad025$export$58adb3bec8346d0f(r, $5d97fdbbe2fad025$export$5880b8b5730aff45 - 1) + "*" + $5d97fdbbe2fad025$export$6788812c4e6611e6(e === 47 ? e : $5d97fdbbe2fad025$export$48cfd1e771a65c4f());
}
function $5d97fdbbe2fad025$export$c2ab62c7bf24634(e) {
    while(!$5d97fdbbe2fad025$export$9e1725a4cfeada27($5d97fdbbe2fad025$export$4d3fb11e950abb9e()))$5d97fdbbe2fad025$export$48cfd1e771a65c4f();
    return $5d97fdbbe2fad025$export$58adb3bec8346d0f(e, $5d97fdbbe2fad025$export$5880b8b5730aff45);
}
function $5d97fdbbe2fad025$export$ef7acd7185315e22(e) {
    return $5d97fdbbe2fad025$export$45918ac1574455b1($5d97fdbbe2fad025$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $5d97fdbbe2fad025$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $5d97fdbbe2fad025$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $5d97fdbbe2fad025$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $5d97fdbbe2fad025$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($5d97fdbbe2fad025$export$f8e21b1e77979a08(j += $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed($5d97fdbbe2fad025$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $5d97fdbbe2fad025$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $5d97fdbbe2fad025$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $5d97fdbbe2fad025$export$955ba06d119e085e($5d97fdbbe2fad025$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($5d97fdbbe2fad025$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $5d97fdbbe2fad025$export$10d8903dec122b9d($5d97fdbbe2fad025$export$4a34f930e789283c($5d97fdbbe2fad025$export$4254d4e2b3745c4c($5d97fdbbe2fad025$export$48cfd1e771a65c4f(), $5d97fdbbe2fad025$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $5d97fdbbe2fad025$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $5d97fdbbe2fad025$export$36776f635604f274(j) - l) $5d97fdbbe2fad025$export$10d8903dec122b9d(p > 32 ? $5d97fdbbe2fad025$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $5d97fdbbe2fad025$export$f8483753829ec8f3($5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $5d97fdbbe2fad025$export$10d8903dec122b9d(y = $5d97fdbbe2fad025$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $5d97fdbbe2fad025$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $5d97fdbbe2fad025$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $5d97fdbbe2fad025$export$98e6a39c04603d36(e, y, y, n && $5d97fdbbe2fad025$export$10d8903dec122b9d($5d97fdbbe2fad025$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $5d97fdbbe2fad025$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $5d97fdbbe2fad025$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $5d97fdbbe2fad025$export$232faf9add678146() == 125) continue;
            }
            switch(j += $5d97fdbbe2fad025$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($5d97fdbbe2fad025$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($5d97fdbbe2fad025$export$4d3fb11e950abb9e() === 45) j += $5d97fdbbe2fad025$export$410ac95b9ec204b8($5d97fdbbe2fad025$export$48cfd1e771a65c4f());
                    v = $5d97fdbbe2fad025$export$4d3fb11e950abb9e(), o = l = $5d97fdbbe2fad025$export$36776f635604f274(g = j += $5d97fdbbe2fad025$export$c2ab62c7bf24634($5d97fdbbe2fad025$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $5d97fdbbe2fad025$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $5d97fdbbe2fad025$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $5d97fdbbe2fad025$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $5d97fdbbe2fad025$export$2f35ab04d2335697(e, v + 1, v = $5d97fdbbe2fad025$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $5d97fdbbe2fad025$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $5d97fdbbe2fad025$export$35059013cd4a06db(e, r, a, s === 0 ? $5d97fdbbe2fad025$export$aa3a2e812ca8570d : i, f, o, l);
}
function $5d97fdbbe2fad025$export$4a34f930e789283c(e, r, a) {
    return $5d97fdbbe2fad025$export$35059013cd4a06db(e, r, a, $5d97fdbbe2fad025$export$a29989082612d0d9, $5d97fdbbe2fad025$export$6788812c4e6611e6($5d97fdbbe2fad025$export$eba6f6f03b0a92e7()), $5d97fdbbe2fad025$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $5d97fdbbe2fad025$export$f8483753829ec8f3(e, r, a, n) {
    return $5d97fdbbe2fad025$export$35059013cd4a06db(e, r, a, $5d97fdbbe2fad025$export$527d108ccf083c2b, $5d97fdbbe2fad025$export$2f35ab04d2335697(e, 0, n), $5d97fdbbe2fad025$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $5d97fdbbe2fad025$export$82e9f45cca5ba907(n, c, s) {
    switch($5d97fdbbe2fad025$export$d6af199866bfb566(n, c)){
        case 5103:
            return $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $5d97fdbbe2fad025$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + n + $5d97fdbbe2fad025$export$2c0f367103c8d01c + n + $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($5d97fdbbe2fad025$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + n + $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + n + $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + n + $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + n + $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + n + $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + n + $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + "box-$1$2" + $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + n + $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + "flex-item-" + $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$5d97fdbbe2fad025$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + "grid-row-" + $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + n + $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + "flex-line-pack" + $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + n + $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + n + $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + "box-" + $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, "-grow", "") + $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + n + $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed($5d97fdbbe2fad025$export$77ad94ebf1c2b9ed($5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed($5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + "box-pack:$3" + $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$5d97fdbbe2fad025$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + "grid-column-align" + $5d97fdbbe2fad025$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $5d97fdbbe2fad025$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$5d97fdbbe2fad025$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$5d97fdbbe2fad025$export$f8e21b1e77979a08(s, "span") ? $5d97fdbbe2fad025$export$4659b591c19bdf3d(s, /\d+/) : +$5d97fdbbe2fad025$export$4659b591c19bdf3d(s, /\d+/) - +$5d97fdbbe2fad025$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $5d97fdbbe2fad025$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed($5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($5d97fdbbe2fad025$export$36776f635604f274(n) - 1 - c > 6) switch($5d97fdbbe2fad025$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($5d97fdbbe2fad025$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $5d97fdbbe2fad025$export$2c0f367103c8d01c + ($5d97fdbbe2fad025$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$5d97fdbbe2fad025$export$f8e21b1e77979a08(n, "stretch") ? $5d97fdbbe2fad025$export$82e9f45cca5ba907($5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($5d97fdbbe2fad025$export$a9db5e087081082d(n, c + 6) === 121) return $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, ":", ":" + $5d97fdbbe2fad025$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($5d97fdbbe2fad025$export$a9db5e087081082d(n, $5d97fdbbe2fad025$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + ($5d97fdbbe2fad025$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, ":", ":" + $5d97fdbbe2fad025$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $5d97fdbbe2fad025$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $5d97fdbbe2fad025$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $5d97fdbbe2fad025$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $5d97fdbbe2fad025$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $5d97fdbbe2fad025$export$a763edbf796b780a:
        case $5d97fdbbe2fad025$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $5d97fdbbe2fad025$export$a29989082612d0d9:
            return "";
        case $5d97fdbbe2fad025$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $5d97fdbbe2fad025$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $5d97fdbbe2fad025$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $5d97fdbbe2fad025$export$36776f635604f274(a = $5d97fdbbe2fad025$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $5d97fdbbe2fad025$export$5a7767152ae0305f(e) {
    var r = $5d97fdbbe2fad025$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $5d97fdbbe2fad025$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $5d97fdbbe2fad025$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $5d97fdbbe2fad025$export$527d108ccf083c2b:
                n.return = $5d97fdbbe2fad025$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $5d97fdbbe2fad025$export$b44a8529a35fcb60:
                return $5d97fdbbe2fad025$export$dfdc1655ccc5b9cb([
                    $5d97fdbbe2fad025$export$784d13d8ee351f07(n, {
                        value: $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $5d97fdbbe2fad025$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $5d97fdbbe2fad025$export$aa3a2e812ca8570d:
                if (n.length) return $5d97fdbbe2fad025$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($5d97fdbbe2fad025$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $5d97fdbbe2fad025$export$dfdc1655ccc5b9cb([
                                $5d97fdbbe2fad025$export$784d13d8ee351f07(n, {
                                    props: [
                                        $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $5d97fdbbe2fad025$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $5d97fdbbe2fad025$export$dfdc1655ccc5b9cb([
                                $5d97fdbbe2fad025$export$784d13d8ee351f07(n, {
                                    props: [
                                        $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $5d97fdbbe2fad025$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $5d97fdbbe2fad025$export$784d13d8ee351f07(n, {
                                    props: [
                                        $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $5d97fdbbe2fad025$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $5d97fdbbe2fad025$export$784d13d8ee351f07(n, {
                                    props: [
                                        $5d97fdbbe2fad025$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $5d97fdbbe2fad025$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $5d97fdbbe2fad025$export$76a88f7de6507443(e) {
    switch(e.type){
        case $5d97fdbbe2fad025$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $5d97fdbbe2fad025$export$1be1fc439b849fdf($5d97fdbbe2fad025$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($5d97fdbbe2fad025$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $5d97fdbbe2fad025$export$2f35ab04d2335697(r, 1, $5d97fdbbe2fad025$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $5d97fdbbe2fad025$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $5d97fdbbe2fad025$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $5d97fdbbe2fad025$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iimxS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d51b657ccfe01f2a$export$2e2bcd8739ae039; });
var $d51b657ccfe01f2a$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("k7Jom", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea67abf59b895c0e$export$2e2bcd8739ae039; });
function $ea67abf59b895c0e$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("5ljFx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e3e2bc30311a73e$export$2e2bcd8739ae039; });
function $3e3e2bc30311a73e$export$2e2bcd8739ae039() {
    $3e3e2bc30311a73e$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3e3e2bc30311a73e$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("lOOzm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe257e86b67b3b15$export$2e2bcd8739ae039; });

var $3HlGj = parcelRequire("3HlGj");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $fe257e86b67b3b15$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3HlGj)))(targetComponent, sourceComponent);
};

});

parcelRegister("4BgOX", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $3597aa6657dba029$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $3597aa6657dba029$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $3597aa6657dba029$export$6f077d94b33a01aa; });
var $3597aa6657dba029$var$isBrowser = true;
function $3597aa6657dba029$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $3597aa6657dba029$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $3597aa6657dba029$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $3597aa6657dba029$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $3597aa6657dba029$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("bhkCx", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $8361470b12c4392c$export$6321afa313b251b5; });

var $5Y5Xa = parcelRequire("5Y5Xa");

var $9M6PR = parcelRequire("9M6PR");

var $k7Jom = parcelRequire("k7Jom");
var $8361470b12c4392c$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $8361470b12c4392c$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $8361470b12c4392c$var$hyphenateRegex = /[A-Z]|^ms/g;
var $8361470b12c4392c$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $8361470b12c4392c$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $8361470b12c4392c$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $8361470b12c4392c$var$processStyleName = /* #__PURE__ */ (0, $k7Jom.default)(function(styleName) {
    return $8361470b12c4392c$var$isCustomProperty(styleName) ? styleName : styleName.replace($8361470b12c4392c$var$hyphenateRegex, "-$&").toLowerCase();
});
var $8361470b12c4392c$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($8361470b12c4392c$var$animationRegex, function(match, p1, p2) {
                $8361470b12c4392c$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $8361470b12c4392c$var$cursor
                };
                return p1;
            });
    }
    if ((0, $9M6PR.default)[key] !== 1 && !$8361470b12c4392c$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $8361470b12c4392c$var$contentValuePattern, $8361470b12c4392c$var$contentValues, $8361470b12c4392c$var$oldProcessStyleValue, $8361470b12c4392c$var$msPattern, $8361470b12c4392c$var$hyphenPattern, $8361470b12c4392c$var$hyphenatedCache;
var $8361470b12c4392c$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $8361470b12c4392c$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $8361470b12c4392c$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $8361470b12c4392c$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $8361470b12c4392c$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $8361470b12c4392c$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $8361470b12c4392c$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $8361470b12c4392c$var$cursor;
                var result = interpolation(mergedProps);
                $8361470b12c4392c$var$cursor = previousCursor;
                return $8361470b12c4392c$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $8361470b12c4392c$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $8361470b12c4392c$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($8361470b12c4392c$var$isProcessableValue(value)) string += $8361470b12c4392c$var$processStyleName(_key) + ":" + $8361470b12c4392c$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($8361470b12c4392c$var$isProcessableValue(value[_i])) string += $8361470b12c4392c$var$processStyleName(_key) + ":" + $8361470b12c4392c$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $8361470b12c4392c$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $8361470b12c4392c$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $8361470b12c4392c$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $8361470b12c4392c$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $8361470b12c4392c$var$cursor;
var $8361470b12c4392c$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $8361470b12c4392c$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $8361470b12c4392c$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $8361470b12c4392c$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $8361470b12c4392c$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $8361470b12c4392c$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $5Y5Xa.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $8361470b12c4392c$var$cursor
    };
};

});
parcelRegister("5Y5Xa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45872c926d0c2cf6$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $45872c926d0c2cf6$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("9M6PR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71dde6285c1e1eff$export$2e2bcd8739ae039; });
var $71dde6285c1e1eff$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("7vx2W", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $57750ff9a5f30f3c$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $57750ff9a5f30f3c$export$811a713a7276cb9d; });

var $1T1QG = parcelRequire("1T1QG");
var $57750ff9a5f30f3c$var$syncFallback = function syncFallback(create) {
    return create();
};
var $57750ff9a5f30f3c$var$useInsertionEffect = $1T1QG.useInsertionEffect ? $1T1QG.useInsertionEffect : false;
var $57750ff9a5f30f3c$export$db21c7ffa21794e7 = $57750ff9a5f30f3c$var$useInsertionEffect || $57750ff9a5f30f3c$var$syncFallback;
var $57750ff9a5f30f3c$export$811a713a7276cb9d = $57750ff9a5f30f3c$var$useInsertionEffect || $1T1QG.useLayoutEffect;

});


parcelRegister("3nTK3", function(module, exports) {
function $276ec23a1fa12ca8$var$_extends() {
    module.exports = $276ec23a1fa12ca8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $276ec23a1fa12ca8$var$_extends.apply(this, arguments);
}
module.exports = $276ec23a1fa12ca8$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("4Ydi5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39e7134675966bee$export$2e2bcd8739ae039; });

var $9jP1l = parcelRequire("9jP1l");
"use client";
const $39e7134675966bee$var$defaultTheme = (0, $9jP1l.default)();
var $39e7134675966bee$export$2e2bcd8739ae039 = $39e7134675966bee$var$defaultTheme;

});
parcelRegister("9jP1l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c8d770bc65d380e$export$2e2bcd8739ae039; });

var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $fxhNB = parcelRequire("fxhNB");

var $3MwXn = parcelRequire("3MwXn");

var $3osRD = parcelRequire("3osRD");
var $h0eTu = parcelRequire("h0eTu");
var $lVN5Q = parcelRequire("lVN5Q");


var $2ODpC = parcelRequire("2ODpC");

var $8ICxy = parcelRequire("8ICxy");

var $bLxA6 = parcelRequire("bLxA6");

var $eR1MK = parcelRequire("eR1MK");

var $eN12j = parcelRequire("eN12j");

var $UqbLX = parcelRequire("UqbLX");
const $6c8d770bc65d380e$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $6c8d770bc65d380e$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $iXdVf.default)(options, $6c8d770bc65d380e$var$_excluded);
    if (options.vars) throw new Error((0, $fxhNB.default)(18));
    const palette = (0, $8ICxy.default)(paletteInput);
    const systemTheme = (0, $3osRD.default)(options);
    let muiTheme = (0, $3MwXn.default)(systemTheme, {
        mixins: (0, $2ODpC.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $eR1MK.default).slice(),
        typography: (0, $bLxA6.default)(palette, typographyInput),
        transitions: (0, $eN12j.default)(transitionsInput),
        zIndex: (0, $ajTRS.default)({}, (0, $UqbLX.default))
    });
    muiTheme = (0, $3MwXn.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3MwXn.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $ajTRS.default)({}, (0, $h0eTu.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $lVN5Q.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $6c8d770bc65d380e$var$warnedOnce = false;
function $6c8d770bc65d380e$export$c469355549431d9b(...args) {
    return $6c8d770bc65d380e$var$createTheme(...args);
}
var $6c8d770bc65d380e$export$2e2bcd8739ae039 = $6c8d770bc65d380e$var$createTheme;

});
parcelRegister("2ODpC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20ced2bbc65318b6$export$2e2bcd8739ae039; });

var $ajTRS = parcelRequire("ajTRS");
function $20ced2bbc65318b6$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $ajTRS.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("8ICxy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65905418390abca1$export$2e2bcd8739ae039; });

var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $fxhNB = parcelRequire("fxhNB");

var $3MwXn = parcelRequire("3MwXn");

var $7Etkp = parcelRequire("7Etkp");

var $15NGz = parcelRequire("15NGz");

var $fUVqW = parcelRequire("fUVqW");

var $fHNjY = parcelRequire("fHNjY");

var $lbQb2 = parcelRequire("lbQb2");

var $kUj69 = parcelRequire("kUj69");

var $7CXsN = parcelRequire("7CXsN");

var $beW77 = parcelRequire("beW77");

var $bBkKf = parcelRequire("bBkKf");
const $65905418390abca1$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $65905418390abca1$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $15NGz.default).white,
        default: (0, $15NGz.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $65905418390abca1$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $15NGz.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $15NGz.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $65905418390abca1$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $7Etkp.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $7Etkp.darken)(intent.main, tonalOffsetDark);
    }
}
function $65905418390abca1$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $7CXsN.default)[200],
        light: (0, $7CXsN.default)[50],
        dark: (0, $7CXsN.default)[400]
    };
    return {
        main: (0, $7CXsN.default)[700],
        light: (0, $7CXsN.default)[400],
        dark: (0, $7CXsN.default)[800]
    };
}
function $65905418390abca1$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $fHNjY.default)[200],
        light: (0, $fHNjY.default)[50],
        dark: (0, $fHNjY.default)[400]
    };
    return {
        main: (0, $fHNjY.default)[500],
        light: (0, $fHNjY.default)[300],
        dark: (0, $fHNjY.default)[700]
    };
}
function $65905418390abca1$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $lbQb2.default)[500],
        light: (0, $lbQb2.default)[300],
        dark: (0, $lbQb2.default)[700]
    };
    return {
        main: (0, $lbQb2.default)[700],
        light: (0, $lbQb2.default)[400],
        dark: (0, $lbQb2.default)[800]
    };
}
function $65905418390abca1$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $beW77.default)[400],
        light: (0, $beW77.default)[300],
        dark: (0, $beW77.default)[700]
    };
    return {
        main: (0, $beW77.default)[700],
        light: (0, $beW77.default)[500],
        dark: (0, $beW77.default)[900]
    };
}
function $65905418390abca1$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $bBkKf.default)[400],
        light: (0, $bBkKf.default)[300],
        dark: (0, $bBkKf.default)[700]
    };
    return {
        main: (0, $bBkKf.default)[800],
        light: (0, $bBkKf.default)[500],
        dark: (0, $bBkKf.default)[900]
    };
}
function $65905418390abca1$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $kUj69.default)[400],
        light: (0, $kUj69.default)[300],
        dark: (0, $kUj69.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $kUj69.default)[500],
        dark: (0, $kUj69.default)[900]
    };
}
function $65905418390abca1$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $iXdVf.default)(palette, $65905418390abca1$var$_excluded);
    const primary = palette.primary || $65905418390abca1$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $65905418390abca1$var$getDefaultSecondary(mode);
    const error = palette.error || $65905418390abca1$var$getDefaultError(mode);
    const info = palette.info || $65905418390abca1$var$getDefaultInfo(mode);
    const success = palette.success || $65905418390abca1$var$getDefaultSuccess(mode);
    const warning = palette.warning || $65905418390abca1$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $7Etkp.getContrastRatio)(background, $65905418390abca1$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $65905418390abca1$export$55ce6f3a06c59543.text.primary : $65905418390abca1$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $ajTRS.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $fxhNB.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $fxhNB.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $65905418390abca1$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $65905418390abca1$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $65905418390abca1$export$55ce6f3a06c59543,
        light: $65905418390abca1$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $3MwXn.default)((0, $ajTRS.default)({
        // A collection of common colors.
        common: (0, $ajTRS.default)({}, (0, $15NGz.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $fUVqW.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("7Etkp", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $592304cb682b3bf6$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $592304cb682b3bf6$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "darken", function () { return $592304cb682b3bf6$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $592304cb682b3bf6$export$c0816ed86df316af; });
$parcel$export(module.exports, "emphasize", function () { return $592304cb682b3bf6$export$e665714f76e581fd; });

var $fxhNB = parcelRequire("fxhNB");

var $iavQf = parcelRequire("iavQf");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $592304cb682b3bf6$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $iavQf.default)(value, min, max);
}
function $592304cb682b3bf6$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $592304cb682b3bf6$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $592304cb682b3bf6$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $592304cb682b3bf6$export$677b39864803984e($592304cb682b3bf6$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $fxhNB.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $fxhNB.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $592304cb682b3bf6$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $592304cb682b3bf6$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $592304cb682b3bf6$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $592304cb682b3bf6$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $592304cb682b3bf6$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $592304cb682b3bf6$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $592304cb682b3bf6$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$592304cb682b3bf6$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $592304cb682b3bf6$export$29fb7152bd3f781a(color) {
    color = $592304cb682b3bf6$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $592304cb682b3bf6$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $592304cb682b3bf6$export$c852d90bf7403b62(color) {
    color = $592304cb682b3bf6$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $592304cb682b3bf6$export$677b39864803984e($592304cb682b3bf6$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $592304cb682b3bf6$export$d061e26956a60b0a(foreground, background) {
    const lumA = $592304cb682b3bf6$export$c852d90bf7403b62(foreground);
    const lumB = $592304cb682b3bf6$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $592304cb682b3bf6$export$58f0f39f63f3cf42(color, value) {
    color = $592304cb682b3bf6$export$677b39864803984e(color);
    value = $592304cb682b3bf6$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $592304cb682b3bf6$export$211a73f2b8c10ce4(color);
}
function $592304cb682b3bf6$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $592304cb682b3bf6$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $592304cb682b3bf6$export$4b073707ff63303(color, coefficient) {
    color = $592304cb682b3bf6$export$677b39864803984e(color);
    coefficient = $592304cb682b3bf6$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $592304cb682b3bf6$export$211a73f2b8c10ce4(color);
}
function $592304cb682b3bf6$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $592304cb682b3bf6$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $592304cb682b3bf6$export$c0816ed86df316af(color, coefficient) {
    color = $592304cb682b3bf6$export$677b39864803984e(color);
    coefficient = $592304cb682b3bf6$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $592304cb682b3bf6$export$211a73f2b8c10ce4(color);
}
function $592304cb682b3bf6$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $592304cb682b3bf6$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $592304cb682b3bf6$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $592304cb682b3bf6$export$c852d90bf7403b62(color) > 0.5 ? $592304cb682b3bf6$export$4b073707ff63303(color, coefficient) : $592304cb682b3bf6$export$c0816ed86df316af(color, coefficient);
}
function $592304cb682b3bf6$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $592304cb682b3bf6$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}

});
parcelRegister("iavQf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3a1dc3db4fd3423$export$2e2bcd8739ae039; });
function $d3a1dc3db4fd3423$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $d3a1dc3db4fd3423$export$2e2bcd8739ae039 = $d3a1dc3db4fd3423$var$clamp;

});


parcelRegister("15NGz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cbccc988e38c461$export$2e2bcd8739ae039; });
const $0cbccc988e38c461$var$common = {
    black: "#000",
    white: "#fff"
};
var $0cbccc988e38c461$export$2e2bcd8739ae039 = $0cbccc988e38c461$var$common;

});

parcelRegister("fUVqW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b968a3159a732e1d$export$2e2bcd8739ae039; });
const $b968a3159a732e1d$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $b968a3159a732e1d$export$2e2bcd8739ae039 = $b968a3159a732e1d$var$grey;

});

parcelRegister("fHNjY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6f1215853aa97d6$export$2e2bcd8739ae039; });
const $b6f1215853aa97d6$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $b6f1215853aa97d6$export$2e2bcd8739ae039 = $b6f1215853aa97d6$var$purple;

});

parcelRegister("lbQb2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6d3194da3f2dd7e$export$2e2bcd8739ae039; });
const $f6d3194da3f2dd7e$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $f6d3194da3f2dd7e$export$2e2bcd8739ae039 = $f6d3194da3f2dd7e$var$red;

});

parcelRegister("kUj69", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f387da1b0a826ba2$export$2e2bcd8739ae039; });
const $f387da1b0a826ba2$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $f387da1b0a826ba2$export$2e2bcd8739ae039 = $f387da1b0a826ba2$var$orange;

});

parcelRegister("7CXsN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58da353a65498ecd$export$2e2bcd8739ae039; });
const $58da353a65498ecd$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $58da353a65498ecd$export$2e2bcd8739ae039 = $58da353a65498ecd$var$blue;

});

parcelRegister("beW77", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82ee14b78296bf29$export$2e2bcd8739ae039; });
const $82ee14b78296bf29$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $82ee14b78296bf29$export$2e2bcd8739ae039 = $82ee14b78296bf29$var$lightBlue;

});

parcelRegister("bBkKf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87233def337df473$export$2e2bcd8739ae039; });
const $87233def337df473$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $87233def337df473$export$2e2bcd8739ae039 = $87233def337df473$var$green;

});


parcelRegister("bLxA6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $890e220920ddd183$export$2e2bcd8739ae039; });

var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $3MwXn = parcelRequire("3MwXn");
const $890e220920ddd183$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $890e220920ddd183$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $890e220920ddd183$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $890e220920ddd183$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $890e220920ddd183$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $890e220920ddd183$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $iXdVf.default)(_ref, $890e220920ddd183$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $ajTRS.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $890e220920ddd183$var$defaultFontFamily ? {
            letterSpacing: `${$890e220920ddd183$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $890e220920ddd183$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $890e220920ddd183$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $3MwXn.default)((0, $ajTRS.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("eR1MK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad07666b77bdde0f$export$2e2bcd8739ae039; });
const $ad07666b77bdde0f$var$shadowKeyUmbraOpacity = 0.2;
const $ad07666b77bdde0f$var$shadowKeyPenumbraOpacity = 0.14;
const $ad07666b77bdde0f$var$shadowAmbientShadowOpacity = 0.12;
function $ad07666b77bdde0f$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$ad07666b77bdde0f$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$ad07666b77bdde0f$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$ad07666b77bdde0f$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $ad07666b77bdde0f$var$shadows = [
    "none",
    $ad07666b77bdde0f$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $ad07666b77bdde0f$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $ad07666b77bdde0f$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $ad07666b77bdde0f$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $ad07666b77bdde0f$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $ad07666b77bdde0f$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $ad07666b77bdde0f$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $ad07666b77bdde0f$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $ad07666b77bdde0f$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $ad07666b77bdde0f$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $ad07666b77bdde0f$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $ad07666b77bdde0f$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $ad07666b77bdde0f$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $ad07666b77bdde0f$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $ad07666b77bdde0f$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $ad07666b77bdde0f$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $ad07666b77bdde0f$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $ad07666b77bdde0f$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $ad07666b77bdde0f$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $ad07666b77bdde0f$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $ad07666b77bdde0f$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $ad07666b77bdde0f$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $ad07666b77bdde0f$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $ad07666b77bdde0f$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $ad07666b77bdde0f$export$2e2bcd8739ae039 = $ad07666b77bdde0f$var$shadows;

});

parcelRegister("eN12j", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $ac4672108d7ee74b$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $ac4672108d7ee74b$export$2e2bcd8739ae039; });

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");
const $ac4672108d7ee74b$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $ac4672108d7ee74b$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $ac4672108d7ee74b$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $ac4672108d7ee74b$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $ac4672108d7ee74b$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $ac4672108d7ee74b$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $ajTRS.default)({}, $ac4672108d7ee74b$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $ajTRS.default)({}, $ac4672108d7ee74b$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $iXdVf.default)(options, $ac4672108d7ee74b$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $ac4672108d7ee74b$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $ac4672108d7ee74b$var$formatMs(delay)}`).join(",");
    };
    return (0, $ajTRS.default)({
        getAutoHeightDuration: $ac4672108d7ee74b$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("UqbLX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a998ba49f8837c9$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $0a998ba49f8837c9$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $0a998ba49f8837c9$export$2e2bcd8739ae039 = $0a998ba49f8837c9$var$zIndex;

});



parcelRegister("557GP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b33626ecf5055e8$export$2e2bcd8739ae039; });
var $3b33626ecf5055e8$export$2e2bcd8739ae039 = "$$material";

});


parcelRegister("npagc", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", function () { return $0465ab3d8826a1bc$export$effb20ecdbf4d6aa; });
$parcel$export(module.exports, "slotShouldForwardProp", function () { return $0465ab3d8826a1bc$export$f10c5a10d27438e5; });
$parcel$export(module.exports, "default", function () { return $0465ab3d8826a1bc$export$2e2bcd8739ae039; });

var $ae0R6 = parcelRequire("ae0R6");

var $4Ydi5 = parcelRequire("4Ydi5");

var $557GP = parcelRequire("557GP");
"use client";
const $0465ab3d8826a1bc$export$effb20ecdbf4d6aa = (prop)=>(0, $ae0R6.shouldForwardProp)(prop) && prop !== "classes";
const $0465ab3d8826a1bc$export$f10c5a10d27438e5 = (0, $ae0R6.shouldForwardProp);
const $0465ab3d8826a1bc$var$styled = (0, $ae0R6.default)({
    themeId: (0, $557GP.default),
    defaultTheme: $4Ydi5.default,
    rootShouldForwardProp: $0465ab3d8826a1bc$export$effb20ecdbf4d6aa
});
var $0465ab3d8826a1bc$export$2e2bcd8739ae039 = $0465ab3d8826a1bc$var$styled;

});
parcelRegister("ae0R6", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $771be012ad3899c1$export$3ba67b570e26eea0; });
$parcel$export(module.exports, "default", function () { return $771be012ad3899c1$export$2e2bcd8739ae039; });

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $7n0B5 = parcelRequire("7n0B5");

var $3MwXn = parcelRequire("3MwXn");

var $3osRD = parcelRequire("3osRD");

var $afSed = parcelRequire("afSed");

var $lVN5Q = parcelRequire("lVN5Q");
const $771be012ad3899c1$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $771be012ad3899c1$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $771be012ad3899c1$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
const $771be012ad3899c1$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $771be012ad3899c1$var$transformVariants = (variants)=>{
    let numOfCallbacks = 0;
    const variantsStyles = {};
    if (variants) variants.forEach((definition)=>{
        let key = "";
        if (typeof definition.props === "function") {
            key = `callback${numOfCallbacks}`;
            numOfCallbacks += 1;
        } else key = (0, $afSed.default)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $771be012ad3899c1$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    return $771be012ad3899c1$var$transformVariants(variants);
};
const $771be012ad3899c1$var$variantsResolver = (props, styles, variants)=>{
    const { ownerState: ownerState = {} } = props;
    const variantsStyles = [];
    let numOfCallbacks = 0;
    if (variants) variants.forEach((variant)=>{
        let isMatch = true;
        if (typeof variant.props === "function") {
            const propsToCheck = (0, $ajTRS.default)({}, props, ownerState);
            isMatch = variant.props(propsToCheck);
        } else Object.keys(variant.props).forEach((key)=>{
            if (ownerState[key] !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
        });
        if (isMatch) {
            if (typeof variant.props === "function") variantsStyles.push(styles[`callback${numOfCallbacks}`]);
            else variantsStyles.push(styles[(0, $afSed.default)(variant.props)]);
        }
        if (typeof variant.props === "function") numOfCallbacks += 1;
    });
    return variantsStyles;
};
const $771be012ad3899c1$var$themeVariantsResolver = (props, styles, theme, name)=>{
    var _theme$components;
    const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[name]) == null ? void 0 : _theme$components.variants;
    return $771be012ad3899c1$var$variantsResolver(props, styles, themeVariants);
};
function $771be012ad3899c1$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $771be012ad3899c1$export$35e57303dbd8a66 = (0, $3osRD.default)();
const $771be012ad3899c1$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $771be012ad3899c1$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $771be012ad3899c1$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $771be012ad3899c1$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
const $771be012ad3899c1$var$muiStyledFunctionResolver = ({ styledArg: styledArg, props: props, defaultTheme: defaultTheme, themeId: themeId })=>{
    const resolvedStyles = styledArg((0, $ajTRS.default)({}, props, {
        theme: $771be012ad3899c1$var$resolveTheme((0, $ajTRS.default)({}, props, {
            defaultTheme: defaultTheme,
            themeId: themeId
        }))
    }));
    let optionalVariants;
    if (resolvedStyles && resolvedStyles.variants) {
        optionalVariants = resolvedStyles.variants;
        delete resolvedStyles.variants;
    }
    if (optionalVariants) {
        const variantsStyles = $771be012ad3899c1$var$variantsResolver(props, $771be012ad3899c1$var$transformVariants(optionalVariants), optionalVariants);
        return [
            resolvedStyles,
            ...variantsStyles
        ];
    }
    return resolvedStyles;
};
function $771be012ad3899c1$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $771be012ad3899c1$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $771be012ad3899c1$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $771be012ad3899c1$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $lVN5Q.default)((0, $ajTRS.default)({}, props, {
            theme: $771be012ad3899c1$var$resolveTheme((0, $ajTRS.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $7n0B5.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $771be012ad3899c1$var$defaultOverridesResolver($771be012ad3899c1$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $iXdVf.default)(inputOptions, $771be012ad3899c1$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $771be012ad3899c1$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($771be012ad3899c1$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $7n0B5.default)(tag, (0, $ajTRS.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg) return (props)=>$771be012ad3899c1$var$muiStyledFunctionResolver({
                        styledArg: stylesArg,
                        props: props,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    });
                if ((0, $3MwXn.isPlainObject)(stylesArg)) {
                    let transformedStylesArg = stylesArg;
                    let styledArgVariants;
                    if (stylesArg && stylesArg.variants) {
                        styledArgVariants = stylesArg.variants;
                        delete transformedStylesArg.variants;
                        transformedStylesArg = (props)=>{
                            let result = stylesArg;
                            const variantStyles = $771be012ad3899c1$var$variantsResolver(props, $771be012ad3899c1$var$transformVariants(styledArgVariants), styledArgVariants);
                            variantStyles.forEach((variantStyle)=>{
                                result = (0, $3MwXn.default)(result, variantStyle);
                            });
                            return result;
                        };
                    }
                    return transformedStylesArg;
                }
                return stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if ((0, $3MwXn.isPlainObject)(styleArg)) {
                let styledArgVariants;
                if (styleArg && styleArg.variants) {
                    styledArgVariants = styleArg.variants;
                    delete transformedStyleArg.variants;
                    transformedStyleArg = (props)=>{
                        let result = styleArg;
                        const variantStyles = $771be012ad3899c1$var$variantsResolver(props, $771be012ad3899c1$var$transformVariants(styledArgVariants), styledArgVariants);
                        variantStyles.forEach((variantStyle)=>{
                            result = (0, $3MwXn.default)(result, variantStyle);
                        });
                        return result;
                    };
                }
            } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (props)=>$771be012ad3899c1$var$muiStyledFunctionResolver({
                    styledArg: styleArg,
                    props: props,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $771be012ad3899c1$var$resolveTheme((0, $ajTRS.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const styleOverrides = $771be012ad3899c1$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $ajTRS.default)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $771be012ad3899c1$var$resolveTheme((0, $ajTRS.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                return $771be012ad3899c1$var$themeVariantsResolver(props, $771be012ad3899c1$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("7n0B5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55db24fa9794c3b0$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $55db24fa9794c3b0$export$e00380445f2b9e0c; });
/**
 * @mui/styled-engine v5.15.7
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $8WG3W = parcelRequire("8WG3W");

var $aMdXx = parcelRequire("aMdXx");
var $8WAsW = parcelRequire("8WAsW");


var $l0LpY = parcelRequire("l0LpY");
"use client";
function $55db24fa9794c3b0$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $8WG3W.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $55db24fa9794c3b0$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("8WG3W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68345e44c5a5e3b5$export$2e2bcd8739ae039; });

var $3bZXv = parcelRequire("3bZXv");
parcelRequire("3nTK3");
parcelRequire("1T1QG");
parcelRequire("6f2xg");

parcelRequire("4BgOX");
parcelRequire("bhkCx");
parcelRequire("7vx2W");
var $68345e44c5a5e3b5$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $68345e44c5a5e3b5$export$2e2bcd8739ae039 = (0, $3bZXv.default).bind();
$68345e44c5a5e3b5$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $68345e44c5a5e3b5$export$2e2bcd8739ae039[tagName] = $68345e44c5a5e3b5$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("3bZXv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $253275e41e8b7be3$export$2e2bcd8739ae039; });

var $5ljFx = parcelRequire("5ljFx");

var $1T1QG = parcelRequire("1T1QG");

var $6f2xg = parcelRequire("6f2xg");
parcelRequire("aMdXx");
var $8WAsW = parcelRequire("8WAsW");

var $4BgOX = parcelRequire("4BgOX");

var $bhkCx = parcelRequire("bhkCx");

var $7vx2W = parcelRequire("7vx2W");
var $253275e41e8b7be3$var$testOmitPropsOnStringTag = (0, $6f2xg.default);
var $253275e41e8b7be3$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $253275e41e8b7be3$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $253275e41e8b7be3$var$testOmitPropsOnStringTag : $253275e41e8b7be3$var$testOmitPropsOnComponent;
};
var $253275e41e8b7be3$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $253275e41e8b7be3$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $253275e41e8b7be3$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $4BgOX.registerStyles)(cache, serialized, isStringTag);
    (0, $7vx2W.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $4BgOX.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $253275e41e8b7be3$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $253275e41e8b7be3$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $253275e41e8b7be3$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $8WAsW.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $1T1QG.useContext((0, $8WAsW.T));
            }
            if (typeof props.className === "string") className = (0, $4BgOX.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $bhkCx.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $253275e41e8b7be3$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $1T1QG.createElement($1T1QG.Fragment, null, /*#__PURE__*/ $1T1QG.createElement($253275e41e8b7be3$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $1T1QG.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $5ljFx.default)({}, options, nextOptions, {
                shouldForwardProp: $253275e41e8b7be3$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("6f2xg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48b61c480ccf1be9$export$2e2bcd8739ae039; });

var $k7Jom = parcelRequire("k7Jom");
var $48b61c480ccf1be9$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $48b61c480ccf1be9$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $k7Jom.default)(function(prop) {
    return $48b61c480ccf1be9$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("l0LpY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4be61432dae6050$export$2e2bcd8739ae039; });
parcelRequire("1T1QG");


var $aMdXx = parcelRequire("aMdXx");

var $3Py8h = parcelRequire("3Py8h");
"use client";
function $f4be61432dae6050$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $f4be61432dae6050$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($f4be61432dae6050$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $aMdXx.Global), {
        styles: globalStyles
    });
}

});
parcelRegister("3Py8h", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ikwle"));

});



parcelRegister("afSed", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77755eb99b5e18e7$export$2e2bcd8739ae039; });

var $iXdVf = parcelRequire("iXdVf");

var $7ZhQx = parcelRequire("7ZhQx");
const $77755eb99b5e18e7$var$_excluded = [
    "variant"
];
function $77755eb99b5e18e7$var$isEmpty(string) {
    return string.length === 0;
}
function $77755eb99b5e18e7$export$2e2bcd8739ae039(props) {
    const { variant: variant } = props, other = (0, $iXdVf.default)(props, $77755eb99b5e18e7$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $77755eb99b5e18e7$var$isEmpty(classKey) ? props[key] : (0, $7ZhQx.default)(props[key]);
        else classKey += `${$77755eb99b5e18e7$var$isEmpty(classKey) ? key : (0, $7ZhQx.default)(key)}${(0, $7ZhQx.default)(props[key].toString())}`;
    });
    return classKey;
}

});



parcelRegister("ghoWx", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $bda1950d648013f8$export$c7c50641356bdfa5; });

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $bda1950d648013f8$export$c7c50641356bdfa5(slot) {
    return (0, $iNQht.default)("MuiSvgIcon", slot);
}
const $bda1950d648013f8$var$svgIconClasses = (0, $dfswM.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $bda1950d648013f8$export$2e2bcd8739ae039 = $bda1950d648013f8$var$svgIconClasses;

});
parcelRegister("dfswM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a52ce1b093a306c$export$2e2bcd8739ae039; });

var $iNQht = parcelRequire("iNQht");
function $9a52ce1b093a306c$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $iNQht.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("iNQht", function(module, exports) {

$parcel$export(module.exports, "globalStateClasses", function () { return $db055b7c8df1325d$export$9d6b9120de57c54; });
$parcel$export(module.exports, "default", function () { return $db055b7c8df1325d$export$2e2bcd8739ae039; });

var $cZKRr = parcelRequire("cZKRr");
const $db055b7c8df1325d$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $db055b7c8df1325d$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $db055b7c8df1325d$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $cZKRr.default).generate(componentName)}-${slot}`;
}
function $db055b7c8df1325d$export$34c0130b1f3e8ae3(slot) {
    return $db055b7c8df1325d$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("cZKRr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $975f88214b0328a4$export$2e2bcd8739ae039; });
const $975f88214b0328a4$var$defaultGenerator = (componentName)=>componentName;
const $975f88214b0328a4$var$createClassNameGenerator = ()=>{
    let generate = $975f88214b0328a4$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $975f88214b0328a4$var$defaultGenerator;
        }
    };
};
const $975f88214b0328a4$var$ClassNameGenerator = $975f88214b0328a4$var$createClassNameGenerator();
var $975f88214b0328a4$export$2e2bcd8739ae039 = $975f88214b0328a4$var$ClassNameGenerator;

});







parcelRegister("bVBOL", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $8af25a6387a1deed$export$a7c73072b1a182ae; }, function (v) { return $8af25a6387a1deed$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $8af25a6387a1deed$export$9f27bc3417b4524d; }, function (v) { return $8af25a6387a1deed$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $8af25a6387a1deed$export$db77ccec0bb4ccac; }, function (v) { return $8af25a6387a1deed$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $8af25a6387a1deed$export$8392c0c9d3dcbd35; }, function (v) { return $8af25a6387a1deed$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $8af25a6387a1deed$export$ffb0004e005737fa; }, function (v) { return $8af25a6387a1deed$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $8af25a6387a1deed$export$b624eff549462981; }, function (v) { return $8af25a6387a1deed$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $8af25a6387a1deed$export$7897aa7841a5380c; }, function (v) { return $8af25a6387a1deed$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $8af25a6387a1deed$export$602eac185826482c; }, function (v) { return $8af25a6387a1deed$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $8af25a6387a1deed$export$e2c29f18771995cb; }, function (v) { return $8af25a6387a1deed$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8af25a6387a1deed$export$5f8d39834fd61797; }, function (v) { return $8af25a6387a1deed$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $8af25a6387a1deed$export$74bf444e3cd11ea5; }, function (v) { return $8af25a6387a1deed$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $8af25a6387a1deed$export$998bcd577473dd93; }, function (v) { return $8af25a6387a1deed$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $8af25a6387a1deed$export$92387174baf9b227; }, function (v) { return $8af25a6387a1deed$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $8af25a6387a1deed$export$ec112efeb987d9c6; }, function (v) { return $8af25a6387a1deed$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $8af25a6387a1deed$export$b706b080d889d2c9; }, function (v) { return $8af25a6387a1deed$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $8af25a6387a1deed$export$5be5a87408f70ddc; }, function (v) { return $8af25a6387a1deed$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $8af25a6387a1deed$export$45a5e7f76e0caa8d; }, function (v) { return $8af25a6387a1deed$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $8af25a6387a1deed$export$455c2e768291efa6; }, function (v) { return $8af25a6387a1deed$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $8af25a6387a1deed$export$9522e17588c12572; }, function (v) { return $8af25a6387a1deed$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $8af25a6387a1deed$export$2110ac352bb060b9; }, function (v) { return $8af25a6387a1deed$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $8af25a6387a1deed$export$56885ab8b9c456ab; }, function (v) { return $8af25a6387a1deed$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $8af25a6387a1deed$export$d927fcb6adf8f9de; }, function (v) { return $8af25a6387a1deed$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $8af25a6387a1deed$export$b82d16f27459e05a; }, function (v) { return $8af25a6387a1deed$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $8af25a6387a1deed$export$522c17b4f5e123e8; }, function (v) { return $8af25a6387a1deed$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $8af25a6387a1deed$export$1aabd8a0274ecfd6; }, function (v) { return $8af25a6387a1deed$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $8af25a6387a1deed$export$3d6c20d97e46b957; }, function (v) { return $8af25a6387a1deed$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $8af25a6387a1deed$export$9b621391a187a31a; }, function (v) { return $8af25a6387a1deed$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $8af25a6387a1deed$export$f5bbd400c2f4426f; }, function (v) { return $8af25a6387a1deed$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8af25a6387a1deed$export$a7c73072b1a182ae;
var $8af25a6387a1deed$export$9f27bc3417b4524d;
var $8af25a6387a1deed$export$db77ccec0bb4ccac;
var $8af25a6387a1deed$export$8392c0c9d3dcbd35;
var $8af25a6387a1deed$export$ffb0004e005737fa;
var $8af25a6387a1deed$export$b624eff549462981;
var $8af25a6387a1deed$export$7897aa7841a5380c;
var $8af25a6387a1deed$export$602eac185826482c;
var $8af25a6387a1deed$export$e2c29f18771995cb;
var $8af25a6387a1deed$export$5f8d39834fd61797;
var $8af25a6387a1deed$export$74bf444e3cd11ea5;
var $8af25a6387a1deed$export$998bcd577473dd93;
var $8af25a6387a1deed$export$92387174baf9b227;
var $8af25a6387a1deed$export$ec112efeb987d9c6;
var $8af25a6387a1deed$export$b706b080d889d2c9;
var $8af25a6387a1deed$export$5be5a87408f70ddc;
var $8af25a6387a1deed$export$45a5e7f76e0caa8d;
var $8af25a6387a1deed$export$455c2e768291efa6;
var $8af25a6387a1deed$export$9522e17588c12572;
var $8af25a6387a1deed$export$2110ac352bb060b9;
var $8af25a6387a1deed$export$56885ab8b9c456ab;
var $8af25a6387a1deed$export$d927fcb6adf8f9de;
var $8af25a6387a1deed$export$b82d16f27459e05a;
var $8af25a6387a1deed$export$522c17b4f5e123e8;
var $8af25a6387a1deed$export$1aabd8a0274ecfd6;
var $8af25a6387a1deed$export$3d6c20d97e46b957;
var $8af25a6387a1deed$export$9b621391a187a31a;
var $8af25a6387a1deed$export$f5bbd400c2f4426f;
"use strict";
var $8af25a6387a1deed$var$b = Symbol.for("react.element"), $8af25a6387a1deed$var$c = Symbol.for("react.portal"), $8af25a6387a1deed$var$d = Symbol.for("react.fragment"), $8af25a6387a1deed$var$e = Symbol.for("react.strict_mode"), $8af25a6387a1deed$var$f = Symbol.for("react.profiler"), $8af25a6387a1deed$var$g = Symbol.for("react.provider"), $8af25a6387a1deed$var$h = Symbol.for("react.context"), $8af25a6387a1deed$var$k = Symbol.for("react.server_context"), $8af25a6387a1deed$var$l = Symbol.for("react.forward_ref"), $8af25a6387a1deed$var$m = Symbol.for("react.suspense"), $8af25a6387a1deed$var$n = Symbol.for("react.suspense_list"), $8af25a6387a1deed$var$p = Symbol.for("react.memo"), $8af25a6387a1deed$var$q = Symbol.for("react.lazy"), $8af25a6387a1deed$var$t = Symbol.for("react.offscreen"), $8af25a6387a1deed$var$u;
$8af25a6387a1deed$var$u = Symbol.for("react.module.reference");
function $8af25a6387a1deed$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $8af25a6387a1deed$var$b:
                switch(a = a.type, a){
                    case $8af25a6387a1deed$var$d:
                    case $8af25a6387a1deed$var$f:
                    case $8af25a6387a1deed$var$e:
                    case $8af25a6387a1deed$var$m:
                    case $8af25a6387a1deed$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8af25a6387a1deed$var$k:
                            case $8af25a6387a1deed$var$h:
                            case $8af25a6387a1deed$var$l:
                            case $8af25a6387a1deed$var$q:
                            case $8af25a6387a1deed$var$p:
                            case $8af25a6387a1deed$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $8af25a6387a1deed$var$c:
                return r;
        }
    }
}
$8af25a6387a1deed$export$a7c73072b1a182ae = $8af25a6387a1deed$var$h;
$8af25a6387a1deed$export$9f27bc3417b4524d = $8af25a6387a1deed$var$g;
$8af25a6387a1deed$export$db77ccec0bb4ccac = $8af25a6387a1deed$var$b;
$8af25a6387a1deed$export$8392c0c9d3dcbd35 = $8af25a6387a1deed$var$l;
$8af25a6387a1deed$export$ffb0004e005737fa = $8af25a6387a1deed$var$d;
$8af25a6387a1deed$export$b624eff549462981 = $8af25a6387a1deed$var$q;
$8af25a6387a1deed$export$7897aa7841a5380c = $8af25a6387a1deed$var$p;
$8af25a6387a1deed$export$602eac185826482c = $8af25a6387a1deed$var$c;
$8af25a6387a1deed$export$e2c29f18771995cb = $8af25a6387a1deed$var$f;
$8af25a6387a1deed$export$5f8d39834fd61797 = $8af25a6387a1deed$var$e;
$8af25a6387a1deed$export$74bf444e3cd11ea5 = $8af25a6387a1deed$var$m;
$8af25a6387a1deed$export$998bcd577473dd93 = $8af25a6387a1deed$var$n;
$8af25a6387a1deed$export$92387174baf9b227 = function() {
    return !1;
};
$8af25a6387a1deed$export$ec112efeb987d9c6 = function() {
    return !1;
};
$8af25a6387a1deed$export$b706b080d889d2c9 = function(a) {
    return $8af25a6387a1deed$var$v(a) === $8af25a6387a1deed$var$h;
};
$8af25a6387a1deed$export$5be5a87408f70ddc = function(a) {
    return $8af25a6387a1deed$var$v(a) === $8af25a6387a1deed$var$g;
};
$8af25a6387a1deed$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8af25a6387a1deed$var$b;
};
$8af25a6387a1deed$export$455c2e768291efa6 = function(a) {
    return $8af25a6387a1deed$var$v(a) === $8af25a6387a1deed$var$l;
};
$8af25a6387a1deed$export$9522e17588c12572 = function(a) {
    return $8af25a6387a1deed$var$v(a) === $8af25a6387a1deed$var$d;
};
$8af25a6387a1deed$export$2110ac352bb060b9 = function(a) {
    return $8af25a6387a1deed$var$v(a) === $8af25a6387a1deed$var$q;
};
$8af25a6387a1deed$export$56885ab8b9c456ab = function(a) {
    return $8af25a6387a1deed$var$v(a) === $8af25a6387a1deed$var$p;
};
$8af25a6387a1deed$export$d927fcb6adf8f9de = function(a) {
    return $8af25a6387a1deed$var$v(a) === $8af25a6387a1deed$var$c;
};
$8af25a6387a1deed$export$b82d16f27459e05a = function(a) {
    return $8af25a6387a1deed$var$v(a) === $8af25a6387a1deed$var$f;
};
$8af25a6387a1deed$export$522c17b4f5e123e8 = function(a) {
    return $8af25a6387a1deed$var$v(a) === $8af25a6387a1deed$var$e;
};
$8af25a6387a1deed$export$1aabd8a0274ecfd6 = function(a) {
    return $8af25a6387a1deed$var$v(a) === $8af25a6387a1deed$var$m;
};
$8af25a6387a1deed$export$3d6c20d97e46b957 = function(a) {
    return $8af25a6387a1deed$var$v(a) === $8af25a6387a1deed$var$n;
};
$8af25a6387a1deed$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8af25a6387a1deed$var$d || a === $8af25a6387a1deed$var$f || a === $8af25a6387a1deed$var$e || a === $8af25a6387a1deed$var$m || a === $8af25a6387a1deed$var$n || a === $8af25a6387a1deed$var$t || "object" === typeof a && null !== a && (a.$$typeof === $8af25a6387a1deed$var$q || a.$$typeof === $8af25a6387a1deed$var$p || a.$$typeof === $8af25a6387a1deed$var$g || a.$$typeof === $8af25a6387a1deed$var$h || a.$$typeof === $8af25a6387a1deed$var$l || a.$$typeof === $8af25a6387a1deed$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$8af25a6387a1deed$export$f5bbd400c2f4426f = $8af25a6387a1deed$var$v;

});

parcelRegister("3ZE5p", function(module, exports) {

$parcel$export(module.exports, "EOL", function () { return $2e8629e1fcb24727$export$266d3b9babd1fc45; }, function (v) { return $2e8629e1fcb24727$export$266d3b9babd1fc45 = v; });
var $2e8629e1fcb24727$export$edf525f30916fbb8;
var $2e8629e1fcb24727$export$640106f6dc7d2706;
var $2e8629e1fcb24727$export$3ea386628068cf62;
var $2e8629e1fcb24727$export$749d472264fad440;
var $2e8629e1fcb24727$export$8b931a48d9488767;
var $2e8629e1fcb24727$export$9123f37609399513;
var $2e8629e1fcb24727$export$9b60beb643db4d69;
var $2e8629e1fcb24727$export$bf9fb029d174d554;
var $2e8629e1fcb24727$export$23d3fad09dc44362;
var $2e8629e1fcb24727$export$d2f3c2f7e0c7dcf5;
var $2e8629e1fcb24727$export$3bf7c33313eba0fe;
var $2e8629e1fcb24727$export$7925d89f138dad5b;
var $2e8629e1fcb24727$export$722a64dea1b767dc;
var $2e8629e1fcb24727$export$9e6c06a7d47f9af7;
var $2e8629e1fcb24727$export$6b76988456c0292f;
var $2e8629e1fcb24727$export$266d3b9babd1fc45;
var $2e8629e1fcb24727$export$c1d46b5ea6262c0b;
$2e8629e1fcb24727$export$edf525f30916fbb8 = function() {
    return "LE";
};
$2e8629e1fcb24727$export$640106f6dc7d2706 = function() {
    if (typeof location !== "undefined") return location.hostname;
    else return "";
};
$2e8629e1fcb24727$export$3ea386628068cf62 = function() {
    return [];
};
$2e8629e1fcb24727$export$749d472264fad440 = function() {
    return 0;
};
$2e8629e1fcb24727$export$8b931a48d9488767 = function() {
    return Number.MAX_VALUE;
};
$2e8629e1fcb24727$export$9123f37609399513 = function() {
    return Number.MAX_VALUE;
};
$2e8629e1fcb24727$export$9b60beb643db4d69 = function() {
    return [];
};
$2e8629e1fcb24727$export$bf9fb029d174d554 = function() {
    return "Browser";
};
$2e8629e1fcb24727$export$23d3fad09dc44362 = function() {
    if (typeof navigator !== "undefined") return navigator.appVersion;
    return "";
};
$2e8629e1fcb24727$export$d2f3c2f7e0c7dcf5 = $2e8629e1fcb24727$export$3bf7c33313eba0fe = function() {
    return {};
};
$2e8629e1fcb24727$export$7925d89f138dad5b = function() {
    return "javascript";
};
$2e8629e1fcb24727$export$722a64dea1b767dc = function() {
    return "browser";
};
$2e8629e1fcb24727$export$9e6c06a7d47f9af7 = $2e8629e1fcb24727$export$6b76988456c0292f = function() {
    return "/tmp";
};
$2e8629e1fcb24727$export$266d3b9babd1fc45 = "\n";
$2e8629e1fcb24727$export$c1d46b5ea6262c0b = function() {
    return "/";
};

});

parcelRegister("f3yzx", function(module, exports) {
/* jshint node:true */ "use strict";
// Escape the textDelimiters contained in the field
/*(https://tools.ietf.org/html/rfc4180)
   7.  If double-quotes are used to enclose fields, then a double-quote
   appearing inside a field must be escaped by preceding it with
   another double quote.
   For example: "aaa","b""bb","ccc"
*/ module.exports = function escapedDelimiters(textDelimiter, rowDelimiter, forceTextDelimiter) {
    let endOfLine = "\n";
    if (typeof textDelimiter !== "string") throw new TypeError('Invalid param "textDelimiter", must be a string.');
    if (typeof rowDelimiter !== "string") throw new TypeError('Invalid param "rowDelimiter", must be a string.');
    let textDelimiterRegex = new RegExp("\\" + textDelimiter, "g");
    let escapedDelimiter = textDelimiter + textDelimiter;
    const enclosingCondition = textDelimiter === '"' ? (value)=>value.indexOf(rowDelimiter) >= 0 || value.indexOf(endOfLine) >= 0 || value.indexOf('"') >= 0 : (value)=>value.indexOf(rowDelimiter) >= 0 || value.indexOf(endOfLine) >= 0;
    return function(value) {
        if (forceTextDelimiter) value = "" + value;
        if (!value.replace) return value;
        // Escape the textDelimiters contained in the field
        value = value.replace(textDelimiterRegex, escapedDelimiter);
        // Escape the whole field if it contains a rowDelimiter or a linebreak or double quote
        if (forceTextDelimiter || enclosingCondition(value)) value = textDelimiter + value + textDelimiter;
        return value;
    };
};

});

parcelRegister("hTcvQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $d0614774e53bd111$var$R = typeof Reflect === "object" ? Reflect : null;
var $d0614774e53bd111$var$ReflectApply = $d0614774e53bd111$var$R && typeof $d0614774e53bd111$var$R.apply === "function" ? $d0614774e53bd111$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $d0614774e53bd111$var$ReflectOwnKeys;
if ($d0614774e53bd111$var$R && typeof $d0614774e53bd111$var$R.ownKeys === "function") $d0614774e53bd111$var$ReflectOwnKeys = $d0614774e53bd111$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $d0614774e53bd111$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $d0614774e53bd111$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $d0614774e53bd111$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $d0614774e53bd111$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $d0614774e53bd111$var$EventEmitter() {
    $d0614774e53bd111$var$EventEmitter.init.call(this);
}
module.exports = $d0614774e53bd111$var$EventEmitter;
module.exports.once = $d0614774e53bd111$var$once;
// Backwards-compat with node 0.10.x
$d0614774e53bd111$var$EventEmitter.EventEmitter = $d0614774e53bd111$var$EventEmitter;
$d0614774e53bd111$var$EventEmitter.prototype._events = undefined;
$d0614774e53bd111$var$EventEmitter.prototype._eventsCount = 0;
$d0614774e53bd111$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $d0614774e53bd111$var$defaultMaxListeners = 10;
function $d0614774e53bd111$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($d0614774e53bd111$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $d0614774e53bd111$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $d0614774e53bd111$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $d0614774e53bd111$var$defaultMaxListeners = arg;
    }
});
$d0614774e53bd111$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$d0614774e53bd111$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $d0614774e53bd111$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $d0614774e53bd111$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $d0614774e53bd111$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$d0614774e53bd111$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $d0614774e53bd111$var$_getMaxListeners(this);
};
$d0614774e53bd111$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $d0614774e53bd111$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $d0614774e53bd111$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$d0614774e53bd111$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $d0614774e53bd111$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $d0614774e53bd111$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $d0614774e53bd111$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $d0614774e53bd111$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$d0614774e53bd111$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $d0614774e53bd111$var$_addListener(this, type, listener, false);
};
$d0614774e53bd111$var$EventEmitter.prototype.on = $d0614774e53bd111$var$EventEmitter.prototype.addListener;
$d0614774e53bd111$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $d0614774e53bd111$var$_addListener(this, type, listener, true);
};
function $d0614774e53bd111$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $d0614774e53bd111$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $d0614774e53bd111$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$d0614774e53bd111$var$EventEmitter.prototype.once = function once(type, listener) {
    $d0614774e53bd111$var$checkListener(listener);
    this.on(type, $d0614774e53bd111$var$_onceWrap(this, type, listener));
    return this;
};
$d0614774e53bd111$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $d0614774e53bd111$var$checkListener(listener);
    this.prependListener(type, $d0614774e53bd111$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$d0614774e53bd111$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $d0614774e53bd111$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $d0614774e53bd111$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$d0614774e53bd111$var$EventEmitter.prototype.off = $d0614774e53bd111$var$EventEmitter.prototype.removeListener;
$d0614774e53bd111$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $d0614774e53bd111$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $d0614774e53bd111$var$unwrapListeners(evlistener) : $d0614774e53bd111$var$arrayClone(evlistener, evlistener.length);
}
$d0614774e53bd111$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $d0614774e53bd111$var$_listeners(this, type, true);
};
$d0614774e53bd111$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $d0614774e53bd111$var$_listeners(this, type, false);
};
$d0614774e53bd111$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $d0614774e53bd111$var$listenerCount.call(emitter, type);
};
$d0614774e53bd111$var$EventEmitter.prototype.listenerCount = $d0614774e53bd111$var$listenerCount;
function $d0614774e53bd111$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$d0614774e53bd111$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $d0614774e53bd111$var$ReflectOwnKeys(this._events) : [];
};
function $d0614774e53bd111$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $d0614774e53bd111$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $d0614774e53bd111$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $d0614774e53bd111$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $d0614774e53bd111$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $d0614774e53bd111$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $d0614774e53bd111$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $d0614774e53bd111$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $d0614774e53bd111$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("i4ovn", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("9YrrH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $7zvJK = parcelRequire("7zvJK");
"use strict";
module.exports = $742f01d5d4e336cb$var$Readable;
/*<replacement>*/ var $742f01d5d4e336cb$var$Duplex;
/*</replacement>*/ $742f01d5d4e336cb$var$Readable.ReadableState = $742f01d5d4e336cb$var$ReadableState;

var $hTcvQ = parcelRequire("hTcvQ");
var $742f01d5d4e336cb$require$EE = $hTcvQ.EventEmitter;
var $742f01d5d4e336cb$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $9k9mF = parcelRequire("9k9mF");

var $cjtBX = parcelRequire("cjtBX");
var $742f01d5d4e336cb$require$Buffer = $cjtBX.Buffer;
var $742f01d5d4e336cb$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $742f01d5d4e336cb$var$_uint8ArrayToBuffer(chunk) {
    return $742f01d5d4e336cb$require$Buffer.from(chunk);
}
function $742f01d5d4e336cb$var$_isUint8Array(obj) {
    return $742f01d5d4e336cb$require$Buffer.isBuffer(obj) || obj instanceof $742f01d5d4e336cb$var$OurUint8Array;
}

var $kEAqK = parcelRequire("kEAqK");
var $742f01d5d4e336cb$var$debug;
if ($kEAqK && $kEAqK.debuglog) $742f01d5d4e336cb$var$debug = $kEAqK.debuglog("stream");
else $742f01d5d4e336cb$var$debug = function debug() {};

var $c1djl = parcelRequire("c1djl");

var $cacpL = parcelRequire("cacpL");

var $dYaTC = parcelRequire("dYaTC");
var $742f01d5d4e336cb$var$getHighWaterMark = $dYaTC.getHighWaterMark;

var $4t2B7 = parcelRequire("4t2B7");
var $742f01d5d4e336cb$require$_require$codes = $4t2B7.codes;
var $742f01d5d4e336cb$var$ERR_INVALID_ARG_TYPE = $742f01d5d4e336cb$require$_require$codes.ERR_INVALID_ARG_TYPE, $742f01d5d4e336cb$var$ERR_STREAM_PUSH_AFTER_EOF = $742f01d5d4e336cb$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $742f01d5d4e336cb$var$ERR_METHOD_NOT_IMPLEMENTED = $742f01d5d4e336cb$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $742f01d5d4e336cb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $742f01d5d4e336cb$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $742f01d5d4e336cb$var$StringDecoder;
var $742f01d5d4e336cb$var$createReadableStreamAsyncIterator;
var $742f01d5d4e336cb$var$from;

(parcelRequire("i4ovn"))($742f01d5d4e336cb$var$Readable, $9k9mF);
var $742f01d5d4e336cb$var$errorOrDestroy = $cacpL.errorOrDestroy;
var $742f01d5d4e336cb$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $742f01d5d4e336cb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $742f01d5d4e336cb$var$ReadableState(options, stream, isDuplex) {
    $742f01d5d4e336cb$var$Duplex = $742f01d5d4e336cb$var$Duplex || (parcelRequire("Yy3ok"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $742f01d5d4e336cb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $742f01d5d4e336cb$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $c1djl();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$742f01d5d4e336cb$var$StringDecoder) $742f01d5d4e336cb$var$StringDecoder = (parcelRequire("9pmrZ")).StringDecoder;
        this.decoder = new $742f01d5d4e336cb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $742f01d5d4e336cb$var$Readable(options) {
    $742f01d5d4e336cb$var$Duplex = $742f01d5d4e336cb$var$Duplex || (parcelRequire("Yy3ok"));
    if (!(this instanceof $742f01d5d4e336cb$var$Readable)) return new $742f01d5d4e336cb$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $742f01d5d4e336cb$var$Duplex;
    this._readableState = new $742f01d5d4e336cb$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $9k9mF.call(this);
}
Object.defineProperty($742f01d5d4e336cb$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$742f01d5d4e336cb$var$Readable.prototype.destroy = $cacpL.destroy;
$742f01d5d4e336cb$var$Readable.prototype._undestroy = $cacpL.undestroy;
$742f01d5d4e336cb$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$742f01d5d4e336cb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $742f01d5d4e336cb$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $742f01d5d4e336cb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$742f01d5d4e336cb$var$Readable.prototype.unshift = function(chunk) {
    return $742f01d5d4e336cb$var$readableAddChunk(this, chunk, null, true, false);
};
function $742f01d5d4e336cb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $742f01d5d4e336cb$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $742f01d5d4e336cb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $742f01d5d4e336cb$var$chunkInvalid(state, chunk);
        if (er) $742f01d5d4e336cb$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $742f01d5d4e336cb$require$Buffer.prototype) chunk = $742f01d5d4e336cb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $742f01d5d4e336cb$var$errorOrDestroy(stream, new $742f01d5d4e336cb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $742f01d5d4e336cb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $742f01d5d4e336cb$var$errorOrDestroy(stream, new $742f01d5d4e336cb$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $742f01d5d4e336cb$var$addChunk(stream, state, chunk, false);
                    else $742f01d5d4e336cb$var$maybeReadMore(stream, state);
                } else $742f01d5d4e336cb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $742f01d5d4e336cb$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $742f01d5d4e336cb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $742f01d5d4e336cb$var$emitReadable(stream);
    }
    $742f01d5d4e336cb$var$maybeReadMore(stream, state);
}
function $742f01d5d4e336cb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$742f01d5d4e336cb$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $742f01d5d4e336cb$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$742f01d5d4e336cb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$742f01d5d4e336cb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$742f01d5d4e336cb$var$StringDecoder) $742f01d5d4e336cb$var$StringDecoder = (parcelRequire("9pmrZ")).StringDecoder;
    var decoder = new $742f01d5d4e336cb$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $742f01d5d4e336cb$var$MAX_HWM = 0x40000000;
function $742f01d5d4e336cb$var$computeNewHighWaterMark(n) {
    if (n >= $742f01d5d4e336cb$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $742f01d5d4e336cb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $742f01d5d4e336cb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $742f01d5d4e336cb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$742f01d5d4e336cb$var$Readable.prototype.read = function(n) {
    $742f01d5d4e336cb$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $742f01d5d4e336cb$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $742f01d5d4e336cb$var$endReadable(this);
        else $742f01d5d4e336cb$var$emitReadable(this);
        return null;
    }
    n = $742f01d5d4e336cb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $742f01d5d4e336cb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $742f01d5d4e336cb$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $742f01d5d4e336cb$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $742f01d5d4e336cb$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $742f01d5d4e336cb$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $742f01d5d4e336cb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $742f01d5d4e336cb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $742f01d5d4e336cb$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $742f01d5d4e336cb$var$onEofChunk(stream, state) {
    $742f01d5d4e336cb$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $742f01d5d4e336cb$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $742f01d5d4e336cb$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $742f01d5d4e336cb$var$emitReadable(stream) {
    var state = stream._readableState;
    $742f01d5d4e336cb$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $742f01d5d4e336cb$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $7zvJK.nextTick($742f01d5d4e336cb$var$emitReadable_, stream);
    }
}
function $742f01d5d4e336cb$var$emitReadable_(stream) {
    var state = stream._readableState;
    $742f01d5d4e336cb$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $742f01d5d4e336cb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $742f01d5d4e336cb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $7zvJK.nextTick($742f01d5d4e336cb$var$maybeReadMore_, stream, state);
    }
}
function $742f01d5d4e336cb$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $742f01d5d4e336cb$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$742f01d5d4e336cb$var$Readable.prototype._read = function(n) {
    $742f01d5d4e336cb$var$errorOrDestroy(this, new $742f01d5d4e336cb$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$742f01d5d4e336cb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $742f01d5d4e336cb$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $7zvJK.stdout && dest !== $7zvJK.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $7zvJK.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $742f01d5d4e336cb$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $742f01d5d4e336cb$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $742f01d5d4e336cb$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $742f01d5d4e336cb$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $742f01d5d4e336cb$var$debug("ondata");
        var ret = dest.write(chunk);
        $742f01d5d4e336cb$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $742f01d5d4e336cb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $742f01d5d4e336cb$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $742f01d5d4e336cb$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($742f01d5d4e336cb$var$EElistenerCount(dest, "error") === 0) $742f01d5d4e336cb$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $742f01d5d4e336cb$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $742f01d5d4e336cb$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $742f01d5d4e336cb$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $742f01d5d4e336cb$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $742f01d5d4e336cb$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $742f01d5d4e336cb$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $742f01d5d4e336cb$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $742f01d5d4e336cb$var$flow(src);
        }
    };
}
$742f01d5d4e336cb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $742f01d5d4e336cb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$742f01d5d4e336cb$var$Readable.prototype.on = function(ev, fn) {
    var res = $9k9mF.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $742f01d5d4e336cb$var$debug("on readable", state.length, state.reading);
            if (state.length) $742f01d5d4e336cb$var$emitReadable(this);
            else if (!state.reading) $7zvJK.nextTick($742f01d5d4e336cb$var$nReadingNextTick, this);
        }
    }
    return res;
};
$742f01d5d4e336cb$var$Readable.prototype.addListener = $742f01d5d4e336cb$var$Readable.prototype.on;
$742f01d5d4e336cb$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $9k9mF.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $7zvJK.nextTick($742f01d5d4e336cb$var$updateReadableListening, this);
    return res;
};
$742f01d5d4e336cb$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $9k9mF.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $7zvJK.nextTick($742f01d5d4e336cb$var$updateReadableListening, this);
    return res;
};
function $742f01d5d4e336cb$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $742f01d5d4e336cb$var$nReadingNextTick(self1) {
    $742f01d5d4e336cb$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$742f01d5d4e336cb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $742f01d5d4e336cb$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $742f01d5d4e336cb$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $742f01d5d4e336cb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $7zvJK.nextTick($742f01d5d4e336cb$var$resume_, stream, state);
    }
}
function $742f01d5d4e336cb$var$resume_(stream, state) {
    $742f01d5d4e336cb$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $742f01d5d4e336cb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$742f01d5d4e336cb$var$Readable.prototype.pause = function() {
    $742f01d5d4e336cb$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $742f01d5d4e336cb$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $742f01d5d4e336cb$var$flow(stream) {
    var state = stream._readableState;
    $742f01d5d4e336cb$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$742f01d5d4e336cb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $742f01d5d4e336cb$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $742f01d5d4e336cb$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $742f01d5d4e336cb$var$kProxyEvents.length; n++)stream.on($742f01d5d4e336cb$var$kProxyEvents[n], this.emit.bind(this, $742f01d5d4e336cb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $742f01d5d4e336cb$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $742f01d5d4e336cb$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($742f01d5d4e336cb$var$createReadableStreamAsyncIterator === undefined) $742f01d5d4e336cb$var$createReadableStreamAsyncIterator = (parcelRequire("b5MI8"));
    return $742f01d5d4e336cb$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($742f01d5d4e336cb$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($742f01d5d4e336cb$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($742f01d5d4e336cb$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$742f01d5d4e336cb$var$Readable._fromList = $742f01d5d4e336cb$var$fromList;
Object.defineProperty($742f01d5d4e336cb$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $742f01d5d4e336cb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $742f01d5d4e336cb$var$endReadable(stream) {
    var state = stream._readableState;
    $742f01d5d4e336cb$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $7zvJK.nextTick($742f01d5d4e336cb$var$endReadableNT, state, stream);
    }
}
function $742f01d5d4e336cb$var$endReadableNT(state, stream) {
    $742f01d5d4e336cb$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $742f01d5d4e336cb$var$Readable.from = function(iterable, opts) {
    if ($742f01d5d4e336cb$var$from === undefined) $742f01d5d4e336cb$var$from = (parcelRequire("7rsvZ"));
    return $742f01d5d4e336cb$var$from($742f01d5d4e336cb$var$Readable, iterable, opts);
};
function $742f01d5d4e336cb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("7zvJK", function(module, exports) {
// shim for using process in browser
var $58346b94217c2348$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $58346b94217c2348$var$cachedSetTimeout;
var $58346b94217c2348$var$cachedClearTimeout;
function $58346b94217c2348$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $58346b94217c2348$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $58346b94217c2348$var$cachedSetTimeout = setTimeout;
        else $58346b94217c2348$var$cachedSetTimeout = $58346b94217c2348$var$defaultSetTimout;
    } catch (e) {
        $58346b94217c2348$var$cachedSetTimeout = $58346b94217c2348$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $58346b94217c2348$var$cachedClearTimeout = clearTimeout;
        else $58346b94217c2348$var$cachedClearTimeout = $58346b94217c2348$var$defaultClearTimeout;
    } catch (e) {
        $58346b94217c2348$var$cachedClearTimeout = $58346b94217c2348$var$defaultClearTimeout;
    }
})();
function $58346b94217c2348$var$runTimeout(fun) {
    if ($58346b94217c2348$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($58346b94217c2348$var$cachedSetTimeout === $58346b94217c2348$var$defaultSetTimout || !$58346b94217c2348$var$cachedSetTimeout) && setTimeout) {
        $58346b94217c2348$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $58346b94217c2348$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $58346b94217c2348$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $58346b94217c2348$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $58346b94217c2348$var$runClearTimeout(marker) {
    if ($58346b94217c2348$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($58346b94217c2348$var$cachedClearTimeout === $58346b94217c2348$var$defaultClearTimeout || !$58346b94217c2348$var$cachedClearTimeout) && clearTimeout) {
        $58346b94217c2348$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $58346b94217c2348$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $58346b94217c2348$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $58346b94217c2348$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $58346b94217c2348$var$queue = [];
var $58346b94217c2348$var$draining = false;
var $58346b94217c2348$var$currentQueue;
var $58346b94217c2348$var$queueIndex = -1;
function $58346b94217c2348$var$cleanUpNextTick() {
    if (!$58346b94217c2348$var$draining || !$58346b94217c2348$var$currentQueue) return;
    $58346b94217c2348$var$draining = false;
    if ($58346b94217c2348$var$currentQueue.length) $58346b94217c2348$var$queue = $58346b94217c2348$var$currentQueue.concat($58346b94217c2348$var$queue);
    else $58346b94217c2348$var$queueIndex = -1;
    if ($58346b94217c2348$var$queue.length) $58346b94217c2348$var$drainQueue();
}
function $58346b94217c2348$var$drainQueue() {
    if ($58346b94217c2348$var$draining) return;
    var timeout = $58346b94217c2348$var$runTimeout($58346b94217c2348$var$cleanUpNextTick);
    $58346b94217c2348$var$draining = true;
    var len = $58346b94217c2348$var$queue.length;
    while(len){
        $58346b94217c2348$var$currentQueue = $58346b94217c2348$var$queue;
        $58346b94217c2348$var$queue = [];
        while(++$58346b94217c2348$var$queueIndex < len)if ($58346b94217c2348$var$currentQueue) $58346b94217c2348$var$currentQueue[$58346b94217c2348$var$queueIndex].run();
        $58346b94217c2348$var$queueIndex = -1;
        len = $58346b94217c2348$var$queue.length;
    }
    $58346b94217c2348$var$currentQueue = null;
    $58346b94217c2348$var$draining = false;
    $58346b94217c2348$var$runClearTimeout(timeout);
}
$58346b94217c2348$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $58346b94217c2348$var$queue.push(new $58346b94217c2348$var$Item(fun, args));
    if ($58346b94217c2348$var$queue.length === 1 && !$58346b94217c2348$var$draining) $58346b94217c2348$var$runTimeout($58346b94217c2348$var$drainQueue);
};
// v8 likes predictible objects
function $58346b94217c2348$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$58346b94217c2348$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$58346b94217c2348$var$process.title = "browser";
$58346b94217c2348$var$process.browser = true;
$58346b94217c2348$var$process.env = {};
$58346b94217c2348$var$process.argv = [];
$58346b94217c2348$var$process.version = ""; // empty string to avoid regexp issues
$58346b94217c2348$var$process.versions = {};
function $58346b94217c2348$var$noop() {}
$58346b94217c2348$var$process.on = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.addListener = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.once = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.off = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.removeListener = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.removeAllListeners = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.emit = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.prependListener = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.prependOnceListener = $58346b94217c2348$var$noop;
$58346b94217c2348$var$process.listeners = function(name) {
    return [];
};
$58346b94217c2348$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$58346b94217c2348$var$process.cwd = function() {
    return "/";
};
$58346b94217c2348$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$58346b94217c2348$var$process.umask = function() {
    return 0;
};

});

parcelRegister("9k9mF", function(module, exports) {

module.exports = (parcelRequire("hTcvQ")).EventEmitter;

});

parcelRegister("c1djl", function(module, exports) {
"use strict";
function $8bffe7577a0a12d5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8bffe7577a0a12d5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8bffe7577a0a12d5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8bffe7577a0a12d5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8bffe7577a0a12d5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8bffe7577a0a12d5$var$_defineProperty(obj, key, value) {
    key = $8bffe7577a0a12d5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8bffe7577a0a12d5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8bffe7577a0a12d5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $8bffe7577a0a12d5$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $8bffe7577a0a12d5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8bffe7577a0a12d5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8bffe7577a0a12d5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8bffe7577a0a12d5$var$_toPropertyKey(arg) {
    var key = $8bffe7577a0a12d5$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $8bffe7577a0a12d5$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $cjtBX = parcelRequire("cjtBX");
var $8bffe7577a0a12d5$var$Buffer = $cjtBX.Buffer;

var $kEAqK = parcelRequire("kEAqK");
var $8bffe7577a0a12d5$var$inspect = $kEAqK.inspect;
var $8bffe7577a0a12d5$var$custom = $8bffe7577a0a12d5$var$inspect && $8bffe7577a0a12d5$var$inspect.custom || "inspect";
function $8bffe7577a0a12d5$var$copyBuffer(src, target, offset) {
    $8bffe7577a0a12d5$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $8bffe7577a0a12d5$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $8bffe7577a0a12d5$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $8bffe7577a0a12d5$var$Buffer.alloc(0);
                var ret = $8bffe7577a0a12d5$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $8bffe7577a0a12d5$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $8bffe7577a0a12d5$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $8bffe7577a0a12d5$var$custom,
            value: function value(_, options) {
                return $8bffe7577a0a12d5$var$inspect(this, $8bffe7577a0a12d5$var$_objectSpread($8bffe7577a0a12d5$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("cacpL", function(module, exports) {

var $7zvJK = parcelRequire("7zvJK");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $8db00c8119e1a1c5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $7zvJK.nextTick($8db00c8119e1a1c5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $7zvJK.nextTick($8db00c8119e1a1c5$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $7zvJK.nextTick($8db00c8119e1a1c5$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $7zvJK.nextTick($8db00c8119e1a1c5$var$emitErrorAndCloseNT, _this, err);
            } else $7zvJK.nextTick($8db00c8119e1a1c5$var$emitCloseNT, _this);
        } else if (cb) {
            $7zvJK.nextTick($8db00c8119e1a1c5$var$emitCloseNT, _this);
            cb(err);
        } else $7zvJK.nextTick($8db00c8119e1a1c5$var$emitCloseNT, _this);
    });
    return this;
}
function $8db00c8119e1a1c5$var$emitErrorAndCloseNT(self, err) {
    $8db00c8119e1a1c5$var$emitErrorNT(self, err);
    $8db00c8119e1a1c5$var$emitCloseNT(self);
}
function $8db00c8119e1a1c5$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $8db00c8119e1a1c5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $8db00c8119e1a1c5$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $8db00c8119e1a1c5$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $8db00c8119e1a1c5$var$destroy,
    undestroy: $8db00c8119e1a1c5$var$undestroy,
    errorOrDestroy: $8db00c8119e1a1c5$var$errorOrDestroy
};

});

parcelRegister("dYaTC", function(module, exports) {
"use strict";

var $a2b954ab6dee51b7$var$ERR_INVALID_OPT_VALUE = (parcelRequire("4t2B7")).codes.ERR_INVALID_OPT_VALUE;
function $a2b954ab6dee51b7$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $a2b954ab6dee51b7$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $a2b954ab6dee51b7$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $a2b954ab6dee51b7$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $a2b954ab6dee51b7$var$getHighWaterMark
};

});
parcelRegister("4t2B7", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $340be2b0a6809ad2$export$e45cb6485273080e; }, function (v) { return $340be2b0a6809ad2$export$e45cb6485273080e = v; });
var $340be2b0a6809ad2$export$e45cb6485273080e;
"use strict";
function $340be2b0a6809ad2$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $340be2b0a6809ad2$var$codes = {};
function $340be2b0a6809ad2$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $340be2b0a6809ad2$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $340be2b0a6809ad2$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $340be2b0a6809ad2$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $340be2b0a6809ad2$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $340be2b0a6809ad2$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $340be2b0a6809ad2$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$340be2b0a6809ad2$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$340be2b0a6809ad2$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $340be2b0a6809ad2$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($340be2b0a6809ad2$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($340be2b0a6809ad2$var$oneOf(expected, "type"));
    else {
        var type = $340be2b0a6809ad2$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($340be2b0a6809ad2$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$340be2b0a6809ad2$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$340be2b0a6809ad2$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$340be2b0a6809ad2$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$340be2b0a6809ad2$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$340be2b0a6809ad2$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$340be2b0a6809ad2$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$340be2b0a6809ad2$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$340be2b0a6809ad2$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$340be2b0a6809ad2$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$340be2b0a6809ad2$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$340be2b0a6809ad2$export$e45cb6485273080e = $340be2b0a6809ad2$var$codes;

});


parcelRegister("Yy3ok", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $7zvJK = parcelRequire("7zvJK");
"use strict";
/*<replacement>*/ var $0b60051134450da3$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $0b60051134450da3$var$Duplex;

var $9YrrH = parcelRequire("9YrrH");

var $lwfyI = parcelRequire("lwfyI");

(parcelRequire("i4ovn"))($0b60051134450da3$var$Duplex, $9YrrH);
// Allow the keys array to be GC'ed.
var $0b60051134450da3$var$keys = $0b60051134450da3$var$objectKeys($lwfyI.prototype);
for(var $0b60051134450da3$var$v = 0; $0b60051134450da3$var$v < $0b60051134450da3$var$keys.length; $0b60051134450da3$var$v++){
    var $0b60051134450da3$var$method = $0b60051134450da3$var$keys[$0b60051134450da3$var$v];
    if (!$0b60051134450da3$var$Duplex.prototype[$0b60051134450da3$var$method]) $0b60051134450da3$var$Duplex.prototype[$0b60051134450da3$var$method] = $lwfyI.prototype[$0b60051134450da3$var$method];
}
function $0b60051134450da3$var$Duplex(options) {
    if (!(this instanceof $0b60051134450da3$var$Duplex)) return new $0b60051134450da3$var$Duplex(options);
    $9YrrH.call(this, options);
    $lwfyI.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $0b60051134450da3$var$onend);
        }
    }
}
Object.defineProperty($0b60051134450da3$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($0b60051134450da3$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($0b60051134450da3$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $0b60051134450da3$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $7zvJK.nextTick($0b60051134450da3$var$onEndNT, this);
}
function $0b60051134450da3$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($0b60051134450da3$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("lwfyI", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $7zvJK = parcelRequire("7zvJK");
"use strict";
module.exports = $faa8a7cd87a7a5e6$var$Writable;
/* <replacement> */ function $faa8a7cd87a7a5e6$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $faa8a7cd87a7a5e6$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $faa8a7cd87a7a5e6$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $faa8a7cd87a7a5e6$var$Duplex;
/*</replacement>*/ $faa8a7cd87a7a5e6$var$Writable.WritableState = $faa8a7cd87a7a5e6$var$WritableState;

/*<replacement>*/ var $faa8a7cd87a7a5e6$var$internalUtil = {
    deprecate: (parcelRequire("9FQPQ"))
};

var $9k9mF = parcelRequire("9k9mF");

var $cjtBX = parcelRequire("cjtBX");
var $faa8a7cd87a7a5e6$require$Buffer = $cjtBX.Buffer;
var $faa8a7cd87a7a5e6$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $faa8a7cd87a7a5e6$var$_uint8ArrayToBuffer(chunk) {
    return $faa8a7cd87a7a5e6$require$Buffer.from(chunk);
}
function $faa8a7cd87a7a5e6$var$_isUint8Array(obj) {
    return $faa8a7cd87a7a5e6$require$Buffer.isBuffer(obj) || obj instanceof $faa8a7cd87a7a5e6$var$OurUint8Array;
}

var $cacpL = parcelRequire("cacpL");

var $dYaTC = parcelRequire("dYaTC");
var $faa8a7cd87a7a5e6$var$getHighWaterMark = $dYaTC.getHighWaterMark;

var $4t2B7 = parcelRequire("4t2B7");
var $faa8a7cd87a7a5e6$require$_require$codes = $4t2B7.codes;
var $faa8a7cd87a7a5e6$var$ERR_INVALID_ARG_TYPE = $faa8a7cd87a7a5e6$require$_require$codes.ERR_INVALID_ARG_TYPE, $faa8a7cd87a7a5e6$var$ERR_METHOD_NOT_IMPLEMENTED = $faa8a7cd87a7a5e6$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $faa8a7cd87a7a5e6$var$ERR_MULTIPLE_CALLBACK = $faa8a7cd87a7a5e6$require$_require$codes.ERR_MULTIPLE_CALLBACK, $faa8a7cd87a7a5e6$var$ERR_STREAM_CANNOT_PIPE = $faa8a7cd87a7a5e6$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $faa8a7cd87a7a5e6$var$ERR_STREAM_DESTROYED = $faa8a7cd87a7a5e6$require$_require$codes.ERR_STREAM_DESTROYED, $faa8a7cd87a7a5e6$var$ERR_STREAM_NULL_VALUES = $faa8a7cd87a7a5e6$require$_require$codes.ERR_STREAM_NULL_VALUES, $faa8a7cd87a7a5e6$var$ERR_STREAM_WRITE_AFTER_END = $faa8a7cd87a7a5e6$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $faa8a7cd87a7a5e6$var$ERR_UNKNOWN_ENCODING = $faa8a7cd87a7a5e6$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $faa8a7cd87a7a5e6$var$errorOrDestroy = $cacpL.errorOrDestroy;

(parcelRequire("i4ovn"))($faa8a7cd87a7a5e6$var$Writable, $9k9mF);
function $faa8a7cd87a7a5e6$var$nop() {}

function $faa8a7cd87a7a5e6$var$WritableState(options, stream, isDuplex) {
    $faa8a7cd87a7a5e6$var$Duplex = $faa8a7cd87a7a5e6$var$Duplex || (parcelRequire("Yy3ok"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $faa8a7cd87a7a5e6$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $faa8a7cd87a7a5e6$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $faa8a7cd87a7a5e6$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $faa8a7cd87a7a5e6$var$CorkedRequest(this);
}
$faa8a7cd87a7a5e6$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($faa8a7cd87a7a5e6$var$WritableState.prototype, "buffer", {
            get: $faa8a7cd87a7a5e6$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $faa8a7cd87a7a5e6$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $faa8a7cd87a7a5e6$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($faa8a7cd87a7a5e6$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($faa8a7cd87a7a5e6$var$realHasInstance.call(this, object)) return true;
            if (this !== $faa8a7cd87a7a5e6$var$Writable) return false;
            return object && object._writableState instanceof $faa8a7cd87a7a5e6$var$WritableState;
        }
    });
} else $faa8a7cd87a7a5e6$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $faa8a7cd87a7a5e6$var$Writable(options) {
    $faa8a7cd87a7a5e6$var$Duplex = $faa8a7cd87a7a5e6$var$Duplex || (parcelRequire("Yy3ok"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $faa8a7cd87a7a5e6$var$Duplex;
    if (!isDuplex && !$faa8a7cd87a7a5e6$var$realHasInstance.call($faa8a7cd87a7a5e6$var$Writable, this)) return new $faa8a7cd87a7a5e6$var$Writable(options);
    this._writableState = new $faa8a7cd87a7a5e6$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $9k9mF.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$faa8a7cd87a7a5e6$var$Writable.prototype.pipe = function() {
    $faa8a7cd87a7a5e6$var$errorOrDestroy(this, new $faa8a7cd87a7a5e6$var$ERR_STREAM_CANNOT_PIPE());
};
function $faa8a7cd87a7a5e6$var$writeAfterEnd(stream, cb) {
    var er = new $faa8a7cd87a7a5e6$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $faa8a7cd87a7a5e6$var$errorOrDestroy(stream, er);
    $7zvJK.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $faa8a7cd87a7a5e6$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $faa8a7cd87a7a5e6$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $faa8a7cd87a7a5e6$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $faa8a7cd87a7a5e6$var$errorOrDestroy(stream, er);
        $7zvJK.nextTick(cb, er);
        return false;
    }
    return true;
}
$faa8a7cd87a7a5e6$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $faa8a7cd87a7a5e6$var$_isUint8Array(chunk);
    if (isBuf && !$faa8a7cd87a7a5e6$require$Buffer.isBuffer(chunk)) chunk = $faa8a7cd87a7a5e6$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $faa8a7cd87a7a5e6$var$nop;
    if (state.ending) $faa8a7cd87a7a5e6$var$writeAfterEnd(this, cb);
    else if (isBuf || $faa8a7cd87a7a5e6$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $faa8a7cd87a7a5e6$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$faa8a7cd87a7a5e6$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$faa8a7cd87a7a5e6$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $faa8a7cd87a7a5e6$var$clearBuffer(this, state);
    }
};
$faa8a7cd87a7a5e6$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $faa8a7cd87a7a5e6$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($faa8a7cd87a7a5e6$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $faa8a7cd87a7a5e6$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $faa8a7cd87a7a5e6$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($faa8a7cd87a7a5e6$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $faa8a7cd87a7a5e6$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $faa8a7cd87a7a5e6$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $faa8a7cd87a7a5e6$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $faa8a7cd87a7a5e6$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $faa8a7cd87a7a5e6$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $faa8a7cd87a7a5e6$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $7zvJK.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $7zvJK.nextTick($faa8a7cd87a7a5e6$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $faa8a7cd87a7a5e6$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $faa8a7cd87a7a5e6$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $faa8a7cd87a7a5e6$var$finishMaybe(stream, state);
    }
}
function $faa8a7cd87a7a5e6$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $faa8a7cd87a7a5e6$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $faa8a7cd87a7a5e6$var$ERR_MULTIPLE_CALLBACK();
    $faa8a7cd87a7a5e6$var$onwriteStateUpdate(state);
    if (er) $faa8a7cd87a7a5e6$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $faa8a7cd87a7a5e6$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $faa8a7cd87a7a5e6$var$clearBuffer(stream, state);
        if (sync) $7zvJK.nextTick($faa8a7cd87a7a5e6$var$afterWrite, stream, state, finished, cb);
        else $faa8a7cd87a7a5e6$var$afterWrite(stream, state, finished, cb);
    }
}
function $faa8a7cd87a7a5e6$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $faa8a7cd87a7a5e6$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $faa8a7cd87a7a5e6$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $faa8a7cd87a7a5e6$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $faa8a7cd87a7a5e6$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $faa8a7cd87a7a5e6$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $faa8a7cd87a7a5e6$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $faa8a7cd87a7a5e6$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$faa8a7cd87a7a5e6$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $faa8a7cd87a7a5e6$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$faa8a7cd87a7a5e6$var$Writable.prototype._writev = null;
$faa8a7cd87a7a5e6$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $faa8a7cd87a7a5e6$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($faa8a7cd87a7a5e6$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $faa8a7cd87a7a5e6$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $faa8a7cd87a7a5e6$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $faa8a7cd87a7a5e6$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $faa8a7cd87a7a5e6$var$finishMaybe(stream, state);
    });
}
function $faa8a7cd87a7a5e6$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $7zvJK.nextTick($faa8a7cd87a7a5e6$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $faa8a7cd87a7a5e6$var$finishMaybe(stream, state) {
    var need = $faa8a7cd87a7a5e6$var$needFinish(state);
    if (need) {
        $faa8a7cd87a7a5e6$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $faa8a7cd87a7a5e6$var$endWritable(stream, state, cb) {
    state.ending = true;
    $faa8a7cd87a7a5e6$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $7zvJK.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $faa8a7cd87a7a5e6$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($faa8a7cd87a7a5e6$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$faa8a7cd87a7a5e6$var$Writable.prototype.destroy = $cacpL.destroy;
$faa8a7cd87a7a5e6$var$Writable.prototype._undestroy = $cacpL.undestroy;
$faa8a7cd87a7a5e6$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("9FQPQ", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $70b0ed607f486664$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $70b0ed607f486664$var$deprecate(fn, msg) {
    if ($70b0ed607f486664$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($70b0ed607f486664$var$config("throwDeprecation")) throw new Error(msg);
            else if ($70b0ed607f486664$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $70b0ed607f486664$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("9pmrZ", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $6d97dd0d1f641d21$export$63a7aa211a91ed69; }, function (v) { return $6d97dd0d1f641d21$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $6d97dd0d1f641d21$export$63a7aa211a91ed69;
"use strict";

var $lQbpM = parcelRequire("lQbpM");
var $6d97dd0d1f641d21$require$Buffer = $lQbpM.Buffer;
/*</replacement>*/ var $6d97dd0d1f641d21$var$isEncoding = $6d97dd0d1f641d21$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $6d97dd0d1f641d21$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $6d97dd0d1f641d21$var$normalizeEncoding(enc) {
    var nenc = $6d97dd0d1f641d21$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($6d97dd0d1f641d21$require$Buffer.isEncoding === $6d97dd0d1f641d21$var$isEncoding || !$6d97dd0d1f641d21$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$6d97dd0d1f641d21$export$63a7aa211a91ed69 = $6d97dd0d1f641d21$var$StringDecoder;
function $6d97dd0d1f641d21$var$StringDecoder(encoding) {
    this.encoding = $6d97dd0d1f641d21$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $6d97dd0d1f641d21$var$utf16Text;
            this.end = $6d97dd0d1f641d21$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $6d97dd0d1f641d21$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $6d97dd0d1f641d21$var$base64Text;
            this.end = $6d97dd0d1f641d21$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $6d97dd0d1f641d21$var$simpleWrite;
            this.end = $6d97dd0d1f641d21$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $6d97dd0d1f641d21$require$Buffer.allocUnsafe(nb);
}
$6d97dd0d1f641d21$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$6d97dd0d1f641d21$var$StringDecoder.prototype.end = $6d97dd0d1f641d21$var$utf8End;
// Returns only complete characters in a Buffer
$6d97dd0d1f641d21$var$StringDecoder.prototype.text = $6d97dd0d1f641d21$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$6d97dd0d1f641d21$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $6d97dd0d1f641d21$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $6d97dd0d1f641d21$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $6d97dd0d1f641d21$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $6d97dd0d1f641d21$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $6d97dd0d1f641d21$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $6d97dd0d1f641d21$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $6d97dd0d1f641d21$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $6d97dd0d1f641d21$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $6d97dd0d1f641d21$var$utf8Text(buf, i) {
    var total = $6d97dd0d1f641d21$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $6d97dd0d1f641d21$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $6d97dd0d1f641d21$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $6d97dd0d1f641d21$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $6d97dd0d1f641d21$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $6d97dd0d1f641d21$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $6d97dd0d1f641d21$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $6d97dd0d1f641d21$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});
parcelRegister("lQbpM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $cjtBX = parcelRequire("cjtBX");
var $fe674f0903cbd387$var$Buffer = $cjtBX.Buffer;
// alternative to using Object.keys for old browsers
function $fe674f0903cbd387$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($fe674f0903cbd387$var$Buffer.from && $fe674f0903cbd387$var$Buffer.alloc && $fe674f0903cbd387$var$Buffer.allocUnsafe && $fe674f0903cbd387$var$Buffer.allocUnsafeSlow) module.exports = $cjtBX;
else {
    // Copy properties from require('buffer')
    $fe674f0903cbd387$var$copyProps($cjtBX, module.exports);
    module.exports.Buffer = $fe674f0903cbd387$var$SafeBuffer;
}
function $fe674f0903cbd387$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $fe674f0903cbd387$var$Buffer(arg, encodingOrOffset, length);
}
$fe674f0903cbd387$var$SafeBuffer.prototype = Object.create($fe674f0903cbd387$var$Buffer.prototype);
// Copy static methods from Buffer
$fe674f0903cbd387$var$copyProps($fe674f0903cbd387$var$Buffer, $fe674f0903cbd387$var$SafeBuffer);
$fe674f0903cbd387$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $fe674f0903cbd387$var$Buffer(arg, encodingOrOffset, length);
};
$fe674f0903cbd387$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $fe674f0903cbd387$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$fe674f0903cbd387$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $fe674f0903cbd387$var$Buffer(size);
};
$fe674f0903cbd387$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $cjtBX.SlowBuffer(size);
};

});


parcelRegister("b5MI8", function(module, exports) {

var $7zvJK = parcelRequire("7zvJK");
"use strict";
var $8135f24c2ead2d65$var$_Object$setPrototypeO;
function $8135f24c2ead2d65$var$_defineProperty(obj, key, value) {
    key = $8135f24c2ead2d65$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8135f24c2ead2d65$var$_toPropertyKey(arg) {
    var key = $8135f24c2ead2d65$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $8135f24c2ead2d65$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $1pOrD = parcelRequire("1pOrD");
var $8135f24c2ead2d65$var$kLastResolve = Symbol("lastResolve");
var $8135f24c2ead2d65$var$kLastReject = Symbol("lastReject");
var $8135f24c2ead2d65$var$kError = Symbol("error");
var $8135f24c2ead2d65$var$kEnded = Symbol("ended");
var $8135f24c2ead2d65$var$kLastPromise = Symbol("lastPromise");
var $8135f24c2ead2d65$var$kHandlePromise = Symbol("handlePromise");
var $8135f24c2ead2d65$var$kStream = Symbol("stream");
function $8135f24c2ead2d65$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $8135f24c2ead2d65$var$readAndResolve(iter) {
    var resolve = iter[$8135f24c2ead2d65$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$8135f24c2ead2d65$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$8135f24c2ead2d65$var$kLastPromise] = null;
            iter[$8135f24c2ead2d65$var$kLastResolve] = null;
            iter[$8135f24c2ead2d65$var$kLastReject] = null;
            resolve($8135f24c2ead2d65$var$createIterResult(data, false));
        }
    }
}
function $8135f24c2ead2d65$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $7zvJK.nextTick($8135f24c2ead2d65$var$readAndResolve, iter);
}
function $8135f24c2ead2d65$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$8135f24c2ead2d65$var$kEnded]) {
                resolve($8135f24c2ead2d65$var$createIterResult(undefined, true));
                return;
            }
            iter[$8135f24c2ead2d65$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $8135f24c2ead2d65$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $8135f24c2ead2d65$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($8135f24c2ead2d65$var$_Object$setPrototypeO = {
    get stream () {
        return this[$8135f24c2ead2d65$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$8135f24c2ead2d65$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$8135f24c2ead2d65$var$kEnded]) return Promise.resolve($8135f24c2ead2d65$var$createIterResult(undefined, true));
        if (this[$8135f24c2ead2d65$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $7zvJK.nextTick(function() {
                if (_this[$8135f24c2ead2d65$var$kError]) reject(_this[$8135f24c2ead2d65$var$kError]);
                else resolve($8135f24c2ead2d65$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$8135f24c2ead2d65$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($8135f24c2ead2d65$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$8135f24c2ead2d65$var$kStream].read();
            if (data !== null) return Promise.resolve($8135f24c2ead2d65$var$createIterResult(data, false));
            promise = new Promise(this[$8135f24c2ead2d65$var$kHandlePromise]);
        }
        this[$8135f24c2ead2d65$var$kLastPromise] = promise;
        return promise;
    }
}, $8135f24c2ead2d65$var$_defineProperty($8135f24c2ead2d65$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $8135f24c2ead2d65$var$_defineProperty($8135f24c2ead2d65$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$8135f24c2ead2d65$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($8135f24c2ead2d65$var$createIterResult(undefined, true));
        });
    });
}), $8135f24c2ead2d65$var$_Object$setPrototypeO), $8135f24c2ead2d65$var$AsyncIteratorPrototype);
var $8135f24c2ead2d65$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($8135f24c2ead2d65$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $8135f24c2ead2d65$var$_defineProperty(_Object$create, $8135f24c2ead2d65$var$kStream, {
        value: stream,
        writable: true
    }), $8135f24c2ead2d65$var$_defineProperty(_Object$create, $8135f24c2ead2d65$var$kLastResolve, {
        value: null,
        writable: true
    }), $8135f24c2ead2d65$var$_defineProperty(_Object$create, $8135f24c2ead2d65$var$kLastReject, {
        value: null,
        writable: true
    }), $8135f24c2ead2d65$var$_defineProperty(_Object$create, $8135f24c2ead2d65$var$kError, {
        value: null,
        writable: true
    }), $8135f24c2ead2d65$var$_defineProperty(_Object$create, $8135f24c2ead2d65$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $8135f24c2ead2d65$var$_defineProperty(_Object$create, $8135f24c2ead2d65$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$8135f24c2ead2d65$var$kStream].read();
            if (data) {
                iterator[$8135f24c2ead2d65$var$kLastPromise] = null;
                iterator[$8135f24c2ead2d65$var$kLastResolve] = null;
                iterator[$8135f24c2ead2d65$var$kLastReject] = null;
                resolve($8135f24c2ead2d65$var$createIterResult(data, false));
            } else {
                iterator[$8135f24c2ead2d65$var$kLastResolve] = resolve;
                iterator[$8135f24c2ead2d65$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$8135f24c2ead2d65$var$kLastPromise] = null;
    $1pOrD(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$8135f24c2ead2d65$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$8135f24c2ead2d65$var$kLastPromise] = null;
                iterator[$8135f24c2ead2d65$var$kLastResolve] = null;
                iterator[$8135f24c2ead2d65$var$kLastReject] = null;
                reject(err);
            }
            iterator[$8135f24c2ead2d65$var$kError] = err;
            return;
        }
        var resolve = iterator[$8135f24c2ead2d65$var$kLastResolve];
        if (resolve !== null) {
            iterator[$8135f24c2ead2d65$var$kLastPromise] = null;
            iterator[$8135f24c2ead2d65$var$kLastResolve] = null;
            iterator[$8135f24c2ead2d65$var$kLastReject] = null;
            resolve($8135f24c2ead2d65$var$createIterResult(undefined, true));
        }
        iterator[$8135f24c2ead2d65$var$kEnded] = true;
    });
    stream.on("readable", $8135f24c2ead2d65$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $8135f24c2ead2d65$var$createReadableStreamAsyncIterator;

});
parcelRegister("1pOrD", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $107f418663a7461f$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("4t2B7")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $107f418663a7461f$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $107f418663a7461f$var$noop() {}
function $107f418663a7461f$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $107f418663a7461f$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $107f418663a7461f$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $107f418663a7461f$var$once(callback || $107f418663a7461f$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $107f418663a7461f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $107f418663a7461f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($107f418663a7461f$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $107f418663a7461f$var$eos;

});


parcelRegister("7rsvZ", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("ib1Ma", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $d3baa1c084675a9c$var$Transform;

var $4t2B7 = parcelRequire("4t2B7");
var $d3baa1c084675a9c$require$_require$codes = $4t2B7.codes;
var $d3baa1c084675a9c$var$ERR_METHOD_NOT_IMPLEMENTED = $d3baa1c084675a9c$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $d3baa1c084675a9c$var$ERR_MULTIPLE_CALLBACK = $d3baa1c084675a9c$require$_require$codes.ERR_MULTIPLE_CALLBACK, $d3baa1c084675a9c$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $d3baa1c084675a9c$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $d3baa1c084675a9c$var$ERR_TRANSFORM_WITH_LENGTH_0 = $d3baa1c084675a9c$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $Yy3ok = parcelRequire("Yy3ok");

(parcelRequire("i4ovn"))($d3baa1c084675a9c$var$Transform, $Yy3ok);
function $d3baa1c084675a9c$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $d3baa1c084675a9c$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $d3baa1c084675a9c$var$Transform(options) {
    if (!(this instanceof $d3baa1c084675a9c$var$Transform)) return new $d3baa1c084675a9c$var$Transform(options);
    $Yy3ok.call(this, options);
    this._transformState = {
        afterTransform: $d3baa1c084675a9c$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $d3baa1c084675a9c$var$prefinish);
}
function $d3baa1c084675a9c$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $d3baa1c084675a9c$var$done(_this, er, data);
    });
    else $d3baa1c084675a9c$var$done(this, null, null);
}
$d3baa1c084675a9c$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $Yy3ok.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$d3baa1c084675a9c$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $d3baa1c084675a9c$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$d3baa1c084675a9c$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$d3baa1c084675a9c$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$d3baa1c084675a9c$var$Transform.prototype._destroy = function(err, cb) {
    $Yy3ok.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $d3baa1c084675a9c$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $d3baa1c084675a9c$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $d3baa1c084675a9c$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("fjWbN", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $b275c4871e775ec7$var$PassThrough;

var $ib1Ma = parcelRequire("ib1Ma");

(parcelRequire("i4ovn"))($b275c4871e775ec7$var$PassThrough, $ib1Ma);
function $b275c4871e775ec7$var$PassThrough(options) {
    if (!(this instanceof $b275c4871e775ec7$var$PassThrough)) return new $b275c4871e775ec7$var$PassThrough(options);
    $ib1Ma.call(this, options);
}
$b275c4871e775ec7$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("4IIQ6", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $36fe0da5c72d6737$var$eos;
function $36fe0da5c72d6737$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $4t2B7 = parcelRequire("4t2B7");
var $36fe0da5c72d6737$require$_require$codes = $4t2B7.codes;
var $36fe0da5c72d6737$var$ERR_MISSING_ARGS = $36fe0da5c72d6737$require$_require$codes.ERR_MISSING_ARGS, $36fe0da5c72d6737$var$ERR_STREAM_DESTROYED = $36fe0da5c72d6737$require$_require$codes.ERR_STREAM_DESTROYED;
function $36fe0da5c72d6737$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $36fe0da5c72d6737$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $36fe0da5c72d6737$var$destroyer(stream, reading, writing, callback) {
    callback = $36fe0da5c72d6737$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($36fe0da5c72d6737$var$eos === undefined) $36fe0da5c72d6737$var$eos = (parcelRequire("1pOrD"));
    $36fe0da5c72d6737$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($36fe0da5c72d6737$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $36fe0da5c72d6737$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $36fe0da5c72d6737$var$call(fn) {
    fn();
}
function $36fe0da5c72d6737$var$pipe(from, to) {
    return from.pipe(to);
}
function $36fe0da5c72d6737$var$popCallback(streams) {
    if (!streams.length) return $36fe0da5c72d6737$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $36fe0da5c72d6737$var$noop;
    return streams.pop();
}
function $36fe0da5c72d6737$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $36fe0da5c72d6737$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $36fe0da5c72d6737$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $36fe0da5c72d6737$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($36fe0da5c72d6737$var$call);
            if (reading) return;
            destroys.forEach($36fe0da5c72d6737$var$call);
            callback(error);
        });
    });
    return streams.reduce($36fe0da5c72d6737$var$pipe);
}
module.exports = $36fe0da5c72d6737$var$pipeline;

});

parcelRegister("1fSew", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $iD6fk = parcelRequire("iD6fk");

var $7zvJK = parcelRequire("7zvJK");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $iD6fk.isBrowserBundle)() && Object.prototype.toString.call(typeof $7zvJK !== "undefined" ? $7zvJK : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("iD6fk", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $d900b6e05392072d$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $d900b6e05392072d$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $d900b6e05392072d$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $d900b6e05392072d$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});


parcelRegister("ajKsV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $782fb8cea10556cf$var$ReactIs, $782fb8cea10556cf$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("8i6oL"))();

});


var $3Py8h = parcelRequire("3Py8h");


const $cb97a690af83ab73$var$consoleLogger = {
    type: "logger",
    log (args) {
        this.output("log", args);
    },
    warn (args) {
        this.output("warn", args);
    },
    error (args) {
        this.output("error", args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $cb97a690af83ab73$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || "i18next:";
        this.logger = concreteLogger || $cb97a690af83ab73$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, "log", "", true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, "warn", "", true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, "error", "");
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (typeof args[0] === "string") args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $cb97a690af83ab73$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $cb97a690af83ab73$var$Logger(this.logger, options);
    }
}
var $cb97a690af83ab73$var$baseLogger = new $cb97a690af83ab73$var$Logger();
class $cb97a690af83ab73$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(" ").forEach((event)=>{
            this.observers[event] = this.observers[event] || [];
            this.observers[event].push(listener);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event] = this.observers[event].filter((l)=>l !== listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = [].concat(this.observers[event]);
            cloned.forEach((observer)=>{
                observer(...args);
            });
        }
        if (this.observers["*"]) {
            const cloned = [].concat(this.observers["*"]);
            cloned.forEach((observer)=>{
                observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
function $cb97a690af83ab73$var$defer() {
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $cb97a690af83ab73$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $cb97a690af83ab73$var$copy(a, s, t) {
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
}
function $cb97a690af83ab73$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    const stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        const key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $cb97a690af83ab73$var$setPath(object, path, newValue) {
    const { obj: obj, k: k } = $cb97a690af83ab73$var$getLastOfPath(object, path, Object);
    obj[k] = newValue;
}
function $cb97a690af83ab73$var$pushPath(object, path, newValue, concat) {
    const { obj: obj, k: k } = $cb97a690af83ab73$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $cb97a690af83ab73$var$getPath(object, path) {
    const { obj: obj, k: k } = $cb97a690af83ab73$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
}
function $cb97a690af83ab73$var$getPathWithDefaults(data, defaultData, key) {
    const value = $cb97a690af83ab73$var$getPath(data, key);
    if (value !== undefined) return value;
    return $cb97a690af83ab73$var$getPath(defaultData, key);
}
function $cb97a690af83ab73$var$deepExtend(target, source, overwrite) {
    for(const prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $cb97a690af83ab73$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $cb97a690af83ab73$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $cb97a690af83ab73$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $cb97a690af83ab73$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, (s)=>$cb97a690af83ab73$var$_entityMap[s]);
    return data;
}
const $cb97a690af83ab73$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function $cb97a690af83ab73$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    const possibleChars = $cb97a690af83ab73$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = new RegExp(`(${possibleChars.map((c)=>c === "?" ? "\\?" : c).join("|")})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $cb97a690af83ab73$var$deepFind(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const paths = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            let j = 2;
            let p = paths.slice(i, i + j).join(keySeparator);
            let mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            const joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $cb97a690af83ab73$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function $cb97a690af83ab73$var$getCleanedCode(code) {
    if (code && code.indexOf("_") > 0) return code.replace("_", "-");
    return code;
}
class $cb97a690af83ab73$var$ResourceStore extends $cb97a690af83ab73$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path = [
            lng,
            ns
        ];
        if (key && typeof key !== "string") path = path.concat(key);
        if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) path = lng.split(".");
        const result = $cb97a690af83ab73$var$getPath(this.data, path);
        if (result || !ignoreJSONStructure || typeof key !== "string") return result;
        return $cb97a690af83ab73$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $cb97a690af83ab73$var$setPath(this.data, path, value);
        if (!options.silent) this.emit("added", lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $cb97a690af83ab73$var$getPath(this.data, path) || {};
        if (deep) $cb97a690af83ab73$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $cb97a690af83ab73$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit("removed", lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === "v1") return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $cb97a690af83ab73$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $cb97a690af83ab73$var$checkedLoadedFor = {};
class $cb97a690af83ab73$var$Translator extends $cb97a690af83ab73$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $cb97a690af83ab73$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        this.logger = $cb97a690af83ab73$var$baseLogger.create("translator");
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ":";
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$cb97a690af83ab73$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        return {
            key: key,
            namespaces: namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === "object") options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return "";
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === "cimode") {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            "[object Number]",
            "[object Function]",
            "[object RegExp]"
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = resType === "[object Array]";
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const hasDefaultValue = $cb97a690af83ab73$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : "";
            const defaultValue = options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit("missingKey", l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        this.pluralResolver.getSuffixes(language, options).forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && typeof options.replace !== "string" ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = typeof postProcess === "string" ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $cb97a690af83ab73$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: resolved,
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (typeof keys === "string") keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$cb97a690af83ab73$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $cb97a690af83ab73$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(", ")}" won't get resolved as namespace "${usedNS}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    static hasDefaultValue(options) {
        const prefix = "defaultValue";
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
function $cb97a690af83ab73$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
class $cb97a690af83ab73$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $cb97a690af83ab73$var$baseLogger.create("languageUtils");
    }
    getScriptPartFromCode(code) {
        code = $cb97a690af83ab73$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return null;
        const p = code.split("-");
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === "x") return null;
        return this.formatLanguageCode(p.join("-"));
    }
    getLanguagePartFromCode(code) {
        code = $cb97a690af83ab73$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return code;
        const p = code.split("-");
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (typeof code === "string" && code.indexOf("-") > -1) {
            const specialCases = [
                "hans",
                "hant",
                "latn",
                "cyrl",
                "cans",
                "mong",
                "arab"
            ];
            let p = code.split("-");
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $cb97a690af83ab73$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $cb97a690af83ab73$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $cb97a690af83ab73$var$capitalize(p[2].toLowerCase());
            }
            return p.join("-");
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === "function") fallbacks = fallbacks(code);
        if (typeof fallbacks === "string") fallbacks = [
            fallbacks
        ];
        if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (typeof code === "string" && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
            if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
            if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
        } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $cb97a690af83ab73$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $cb97a690af83ab73$var$_rulesPluralsTypes = {
    1: function(n) {
        return Number(n > 1);
    },
    2: function(n) {
        return Number(n != 1);
    },
    3: function(n) {
        return 0;
    },
    4: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function(n) {
        return Number(n >= 2);
    },
    10: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function(n) {
        return Number(n !== 0);
    },
    14: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
const $cb97a690af83ab73$var$nonIntlVersions = [
    "v1",
    "v2",
    "v3"
];
const $cb97a690af83ab73$var$intlVersions = [
    "v4"
];
const $cb97a690af83ab73$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $cb97a690af83ab73$var$createRules() {
    const rules = {};
    $cb97a690af83ab73$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $cb97a690af83ab73$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
class $cb97a690af83ab73$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $cb97a690af83ab73$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || $cb97a690af83ab73$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $cb97a690af83ab73$var$createRules();
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            return new Intl.PluralRules($cb97a690af83ab73$var$getCleanedCode(code), {
                type: options.ordinal ? "ordinal" : "cardinal"
            });
        } catch  {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$cb97a690af83ab73$var$suffixesOrder[pluralCategory1] - $cb97a690af83ab73$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return "";
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = "plural";
            else if (suffix === 1) suffix = "";
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === "v1") {
            if (suffix === 1) return "";
            if (typeof suffix === "number") return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$cb97a690af83ab73$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
function $cb97a690af83ab73$var$deepFindWithDefaults(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $cb97a690af83ab73$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = $cb97a690af83ab73$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $cb97a690af83ab73$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
class $cb97a690af83ab73$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $cb97a690af83ab73$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const iOpts = options.interpolation;
        this.escape = iOpts.escape !== undefined ? iOpts.escape : $cb97a690af83ab73$var$escape;
        this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
        this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
        this.prefix = iOpts.prefix ? $cb97a690af83ab73$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
        this.suffix = iOpts.suffix ? $cb97a690af83ab73$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
        this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
        this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
        this.nestingPrefix = iOpts.nestingPrefix ? $cb97a690af83ab73$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $cb97a690af83ab73$var$regexEscape("$t(");
        this.nestingSuffix = iOpts.nestingSuffix ? $cb97a690af83ab73$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $cb97a690af83ab73$var$regexEscape(")");
        this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
        this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
        this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const regexpStr = `${this.prefix}(.+?)${this.suffix}`;
        this.regexp = new RegExp(regexpStr, "g");
        const regexpUnescapeStr = `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`;
        this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
        const nestingRegexpStr = `${this.nestingPrefix}(.+?)${this.nestingSuffix}`;
        this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        function regexSafe(val) {
            return val.replace(/\$/g, "$$$$");
        }
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $cb97a690af83ab73$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($cb97a690af83ab73$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === "function") {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = typeof temp === "string" ? temp : "";
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = "";
                    }
                } else if (typeof value !== "string" && !this.useRawValueToEscape) value = $cb97a690af83ab73$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        function handleHasOptions(key, inheritedOptions) {
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            delete clonedOptions.defaultValue;
            return key;
        }
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && typeof value !== "string") return value;
            if (typeof value !== "string") value = $cb97a690af83ab73$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = "";
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
function $cb97a690af83ab73$var$parseFormatStr(formatStr) {
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        const p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(";");
            opts.forEach((opt)=>{
                if (!opt) return;
                const [key, ...rest] = opt.split(":");
                const val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $cb97a690af83ab73$var$createCachedFormatter(fn) {
    const cache = {};
    return function invokeFormatter(val, lng, options) {
        const key = lng + JSON.stringify(options);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($cb97a690af83ab73$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
class $cb97a690af83ab73$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $cb97a690af83ab73$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $cb97a690af83ab73$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $cb97a690af83ab73$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: "currency"
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $cb97a690af83ab73$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $cb97a690af83ab73$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || "day");
            }),
            list: $cb97a690af83ab73$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const iOpts = options.interpolation;
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $cb97a690af83ab73$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $cb97a690af83ab73$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
function $cb97a690af83ab73$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
class $cb97a690af83ab73$var$Connector extends $cb97a690af83ab73$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $cb97a690af83ab73$var$baseLogger.create("backendConnector");
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit("failedLoading", lng, ns, err);
        if (data) this.store.addResourceBundle(lng, ns, data);
        this.state[name] = err ? -1 : 2;
        const loaded = {};
        this.queue.forEach((q)=>{
            $cb97a690af83ab73$var$pushPath(q.loaded, [
                lng
            ], ns);
            $cb97a690af83ab73$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit("loaded", loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === "function") r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn("No backend was added via i18next.use. Will not load resources.");
            return callback && callback();
        }
        if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, "read", undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
            return;
        }
        if (key === undefined || key === null || key === "") return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === "function") r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
function $cb97a690af83ab73$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            let ret = {};
            if (typeof args[1] === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if (typeof args[2] === "object" || typeof args[3] === "object") {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value, format, lng, options)=>value,
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $cb97a690af83ab73$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $cb97a690af83ab73$var$noop() {}
function $cb97a690af83ab73$var$bindMemberFunctions(inst) {
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
class $cb97a690af83ab73$var$I18n extends $cb97a690af83ab73$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $cb97a690af83ab73$var$transformOptions(options);
        this.services = {};
        this.logger = $cb97a690af83ab73$var$baseLogger;
        this.modules = {
            external: []
        };
        $cb97a690af83ab73$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (typeof options.ns === "string") options.defaultNS = options.ns;
            else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $cb97a690af83ab73$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$cb97a690af83ab73$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== "v1") this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        function createClassOnDemand(ClassOrObject) {
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === "function") return new ClassOrObject();
            return ClassOrObject;
        }
        if (!this.options.isClone) {
            if (this.modules.logger) $cb97a690af83ab73$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $cb97a690af83ab73$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== "undefined") formatter = $cb97a690af83ab73$var$Formatter;
            const lu = new $cb97a690af83ab73$var$LanguageUtil(this.options);
            this.store = new $cb97a690af83ab73$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $cb97a690af83ab73$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $cb97a690af83ab73$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $cb97a690af83ab73$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $cb97a690af83ab73$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on("*", function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $cb97a690af83ab73$var$Translator(this.services, this.options);
            this.translator.on("*", function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $cb97a690af83ab73$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
        const storeApi = [
            "getResource",
            "hasResourceBundle",
            "getResourceBundle",
            "getDataByLanguage"
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            "addResource",
            "addResources",
            "addResourceBundle",
            "removeResourceBundle"
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $cb97a690af83ab73$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn("init: i18next is already initialized. You should call init just once!");
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log("initialized", this.options);
                this.emit("initialized", this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $cb97a690af83ab73$var$noop;
        let usedCallback = callback;
        const usedLng = typeof language === "string" ? language : this.language;
        if (typeof language === "function") usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === "cimode") return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === "cimode") return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $cb97a690af83ab73$var$defer();
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $cb97a690af83ab73$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
        if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
        if (module.type === "backend") this.modules.backend = module;
        if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === "languageDetector") this.modules.languageDetector = module;
        if (module.type === "i18nFormat") this.modules.i18nFormat = module;
        if (module.type === "postProcessor") $cb97a690af83ab73$var$postProcessor.addPostProcessor(module);
        if (module.type === "formatter") this.modules.formatter = module;
        if (module.type === "3rdParty") this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            "cimode",
            "dev"
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                "cimode",
                "dev"
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $cb97a690af83ab73$var$defer();
        this.emit("languageChanging", lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit("languageChanged", l);
                this.logger.log("languageChanged", l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = typeof lngs === "string" ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== "object") {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || ".";
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (typeof lng === "string") fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === "cimode") return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $cb97a690af83ab73$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (typeof ns === "string") ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $cb97a690af83ab73$var$defer();
        if (typeof lngs === "string") lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0);
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return "rtl";
        const rtlLngs = [
            "ar",
            "shu",
            "sqr",
            "ssh",
            "xaa",
            "yhd",
            "yud",
            "aao",
            "abh",
            "abv",
            "acm",
            "acq",
            "acw",
            "acx",
            "acy",
            "adf",
            "ads",
            "aeb",
            "aec",
            "afb",
            "ajp",
            "apc",
            "apd",
            "arb",
            "arq",
            "ars",
            "ary",
            "arz",
            "auz",
            "avl",
            "ayh",
            "ayl",
            "ayn",
            "ayp",
            "bbz",
            "pga",
            "he",
            "iw",
            "ps",
            "pbt",
            "pbu",
            "pst",
            "prp",
            "prd",
            "ug",
            "ur",
            "ydd",
            "yds",
            "yih",
            "ji",
            "yi",
            "hbo",
            "men",
            "xmn",
            "fa",
            "jpr",
            "peo",
            "pes",
            "prs",
            "dv",
            "sam",
            "ckb"
        ];
        const languageUtils = this.services && this.services.languageUtils || new $cb97a690af83ab73$var$LanguageUtil($cb97a690af83ab73$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $cb97a690af83ab73$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $cb97a690af83ab73$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $cb97a690af83ab73$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            "store",
            "services",
            "language"
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $cb97a690af83ab73$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $cb97a690af83ab73$var$Translator(clone.services, mergedOptions);
        clone.translator.on("*", function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $cb97a690af83ab73$export$2e2bcd8739ae039 = $cb97a690af83ab73$var$I18n.createInstance();
$cb97a690af83ab73$export$2e2bcd8739ae039.createInstance = $cb97a690af83ab73$var$I18n.createInstance;
const $cb97a690af83ab73$export$99152e8d49ca4e7d = $cb97a690af83ab73$export$2e2bcd8739ae039.createInstance;
const $cb97a690af83ab73$export$147ec2801e896265 = $cb97a690af83ab73$export$2e2bcd8739ae039.dir;
const $cb97a690af83ab73$export$2cd8252107eb640b = $cb97a690af83ab73$export$2e2bcd8739ae039.init;
const $cb97a690af83ab73$export$d3d08d944062d7e = $cb97a690af83ab73$export$2e2bcd8739ae039.loadResources;
const $cb97a690af83ab73$export$a5d9bf5d83fcab09 = $cb97a690af83ab73$export$2e2bcd8739ae039.reloadResources;
const $cb97a690af83ab73$export$1f96ae73734a86cc = $cb97a690af83ab73$export$2e2bcd8739ae039.use;
const $cb97a690af83ab73$export$61465194746e7fd2 = $cb97a690af83ab73$export$2e2bcd8739ae039.changeLanguage;
const $cb97a690af83ab73$export$f90d180fc7da3b3b = $cb97a690af83ab73$export$2e2bcd8739ae039.getFixedT;
const $cb97a690af83ab73$export$625550452a3fa3ec = $cb97a690af83ab73$export$2e2bcd8739ae039.t;
const $cb97a690af83ab73$export$f7e9f41ea797a17 = $cb97a690af83ab73$export$2e2bcd8739ae039.exists;
const $cb97a690af83ab73$export$2b4b218e406d2d00 = $cb97a690af83ab73$export$2e2bcd8739ae039.setDefaultNamespace;
const $cb97a690af83ab73$export$93d9ee97c1ad3f31 = $cb97a690af83ab73$export$2e2bcd8739ae039.hasLoadedNamespace;
const $cb97a690af83ab73$export$83be934b53fff43b = $cb97a690af83ab73$export$2e2bcd8739ae039.loadNamespaces;
const $cb97a690af83ab73$export$8cd7e7a54fa865bc = $cb97a690af83ab73$export$2e2bcd8739ae039.loadLanguages;



var $1T1QG = parcelRequire("1T1QG");

var $3nTK3 = parcelRequire("3nTK3");

var $1T1QG = parcelRequire("1T1QG");
var $d955874379f80d0c$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $d955874379f80d0c$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $942fbe398d28e2ca$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $942fbe398d28e2ca$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($d955874379f80d0c$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($942fbe398d28e2ca$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $942fbe398d28e2ca$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $942fbe398d28e2ca$var$i = /^\s*$/, $942fbe398d28e2ca$var$s = Object.create(null);
function $942fbe398d28e2ca$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($942fbe398d28e2ca$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $942fbe398d28e2ca$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $942fbe398d28e2ca$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($942fbe398d28e2ca$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $942fbe398d28e2ca$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $942fbe398d28e2ca$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $942fbe398d28e2ca$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $942fbe398d28e2ca$var$a("", t);
        }, "");
    }
};
var $942fbe398d28e2ca$export$2e2bcd8739ae039 = $942fbe398d28e2ca$var$c;


function $5628efa135deda5f$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const $5628efa135deda5f$var$alreadyWarned = {};
function $5628efa135deda5f$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $5628efa135deda5f$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $5628efa135deda5f$var$alreadyWarned[args[0]] = new Date();
    $5628efa135deda5f$export$c106dd0671a0fc2d(...args);
}
const $5628efa135deda5f$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
function $5628efa135deda5f$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $5628efa135deda5f$var$loadedClb(i18n, cb));
}
function $5628efa135deda5f$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $5628efa135deda5f$var$loadedClb(i18n, cb));
}
function $5628efa135deda5f$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $5628efa135deda5f$export$93d9ee97c1ad3f31(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $5628efa135deda5f$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $5628efa135deda5f$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $5628efa135deda5f$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}


const $eac57bec9bc9836a$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $eac57bec9bc9836a$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
};
const $eac57bec9bc9836a$var$unescapeHtmlEntity = (m)=>$eac57bec9bc9836a$var$htmlEntities[m];
const $eac57bec9bc9836a$export$e8bacd2802a88316 = (text)=>text.replace($eac57bec9bc9836a$var$matchHtmlEntity, $eac57bec9bc9836a$var$unescapeHtmlEntity);


let $b89bb56ddb15a49c$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: $eac57bec9bc9836a$export$e8bacd2802a88316
};
function $b89bb56ddb15a49c$export$2e2366488d12e20d() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $b89bb56ddb15a49c$var$defaultOptions = {
        ...$b89bb56ddb15a49c$var$defaultOptions,
        ...options
    };
}
function $b89bb56ddb15a49c$export$212bb2fc580a90a8() {
    return $b89bb56ddb15a49c$var$defaultOptions;
}


let $3ab9e43e4ac7eb81$var$i18nInstance;
function $3ab9e43e4ac7eb81$export$a039134f2fc7e0(instance) {
    $3ab9e43e4ac7eb81$var$i18nInstance = instance;
}
function $3ab9e43e4ac7eb81$export$64af334f494c2f47() {
    return $3ab9e43e4ac7eb81$var$i18nInstance;
}


function $104507f512dcc4a1$var$hasChildren(node, checkLength) {
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $104507f512dcc4a1$var$getChildren(node) {
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? $104507f512dcc4a1$var$getAsArray(children) : children;
}
function $104507f512dcc4a1$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every((child)=>(0, $1T1QG.isValidElement)(child));
}
function $104507f512dcc4a1$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $104507f512dcc4a1$var$mergeProps(source, target) {
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $104507f512dcc4a1$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    let stringNode = "";
    const childrenArray = $104507f512dcc4a1$var$getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if (typeof child === "string") stringNode += `${child}`;
        else if ((0, $1T1QG.isValidElement)(child)) {
            const childPropsCount = Object.keys(child.props).length;
            const shouldKeepChild = keepArray.indexOf(child.type) > -1;
            const childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += `<${child.type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += `<${childIndex}></${childIndex}>`;
            else if (child.props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += `<${child.type}>${childChildren}</${child.type}>`;
            else {
                const content = $104507f512dcc4a1$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $5628efa135deda5f$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if (typeof child === "object") {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $5628efa135deda5f$export$c106dd0671a0fc2d)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $5628efa135deda5f$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
}
function $104507f512dcc4a1$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    function getData(childs) {
        const childrenArray = $104507f512dcc4a1$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if (typeof child === "string") return;
            if ($104507f512dcc4a1$var$hasChildren(child)) getData($104507f512dcc4a1$var$getChildren(child));
            else if (typeof child === "object" && !(0, $1T1QG.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    const ast = (0, $942fbe398d28e2ca$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    function renderInner(child, node, rootReactNode) {
        const childs = $104507f512dcc4a1$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $104507f512dcc4a1$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $1T1QG.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $1T1QG.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(c.type, (0, (/*@__PURE__*/$parcel$interopDefault($3nTK3)))({}, props, {
                key: i,
                ref: c.ref
            }, isVoid ? {} : {
                children: inner
            }));
        }));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        const reactNodes = $104507f512dcc4a1$var$getAsArray(reactNode);
        const astNodes = $104507f512dcc4a1$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $104507f512dcc4a1$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $1T1QG.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $104507f512dcc4a1$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === "object" && child.dummy && !isElement;
                const isKnownComponent = typeof children === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($104507f512dcc4a1$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $1T1QG.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $1T1QG.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if (typeof child === "object" && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === "text") {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $1T1QG.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    }
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $104507f512dcc4a1$var$getAsArray(children || []));
    return $104507f512dcc4a1$var$getChildren(result[0]);
}
function $104507f512dcc4a1$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, $3ab9e43e4ac7eb81$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $5628efa135deda5f$export$5b28268982f175ba)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    if (context) tOptions.context = context;
    const reactI18nextOptions = {
        ...(0, $b89bb56ddb15a49c$export$212bb2fc580a90a8)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    const nodeAsString = $104507f512dcc4a1$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    const interpolationOverride = values ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: "#$?",
            suffix: "?$#"
        }
    };
    const combinedTOpts = {
        ...tOptions,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    const content = $104507f512dcc4a1$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $1T1QG.createElement)(useAsParent, additionalProps, content) : content;
}



var $1T1QG = parcelRequire("1T1QG");




const $e3c91a34ff524c8f$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init (instance) {
        (0, $b89bb56ddb15a49c$export$2e2366488d12e20d)(instance.options.react);
        (0, $3ab9e43e4ac7eb81$export$a039134f2fc7e0)(instance);
    }
};


const $d33d540a7c2378fc$export$5603ab5ced17ce64 = (0, $1T1QG.createContext)();
class $d33d540a7c2378fc$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
function $d33d540a7c2378fc$export$30ff0342ccf735a(ForComponent) {
    return (ctx)=>new Promise((resolve)=>{
            const i18nInitialProps = $d33d540a7c2378fc$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then((componentsInitialProps)=>{
                resolve({
                    ...componentsInitialProps,
                    ...i18nInitialProps
                });
            });
            else resolve(i18nInitialProps);
        });
}
function $d33d540a7c2378fc$export$704200e5d0b9e8f() {
    const i18n = (0, $3ab9e43e4ac7eb81$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $0eb11c700a37ecf6$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $1T1QG.useContext)((0, $d33d540a7c2378fc$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $3ab9e43e4ac7eb81$export$64af334f494c2f47)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $104507f512dcc4a1$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $1T1QG = parcelRequire("1T1QG");


const $c048800d0e6f5bc9$var$usePrevious = (value, ignore)=>{
    const ref = (0, $1T1QG.useRef)();
    (0, $1T1QG.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $c048800d0e6f5bc9$export$9fc83ad70ead8663(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $1T1QG.useContext)((0, $d33d540a7c2378fc$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $3ab9e43e4ac7eb81$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $d33d540a7c2378fc$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $5628efa135deda5f$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        const notReadyT = (k, optsOrDefaultValue)=>{
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && typeof optsOrDefaultValue === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $5628efa135deda5f$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    const i18nOptions = {
        ...(0, $b89bb56ddb15a49c$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $5628efa135deda5f$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    const [t, setT] = (0, $1T1QG.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $c048800d0e6f5bc9$var$usePrevious(joinedNS);
    const isMounted = (0, $1T1QG.useRef)(true);
    (0, $1T1QG.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $5628efa135deda5f$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
            else (0, $5628efa135deda5f$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    const isInitial = (0, $1T1QG.useRef)(true);
    (0, $1T1QG.useEffect)(()=>{
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $5628efa135deda5f$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $5628efa135deda5f$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
}



var $1T1QG = parcelRequire("1T1QG");


function $2ca66d5d37fda705$export$2dcb0053efd21124(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef: forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, $c048800d0e6f5bc9$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $1T1QG.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $5628efa135deda5f$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $1T1QG.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $1T1QG.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}



function $70fe6c8ce4cdc0aa$export$b63289fbda65eed1(props) {
    const { ns: ns, children: children, ...options } = props;
    const [t, i18n, ready] = (0, $c048800d0e6f5bc9$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $1T1QG = parcelRequire("1T1QG");

function $a1ef6cf3886ce88e$export$1325e8699caa160f(_ref) {
    let { i18n: i18n, defaultNS: defaultNS, children: children } = _ref;
    const value = (0, $1T1QG.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $1T1QG.createElement)((0, $d33d540a7c2378fc$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");

function $1b390901db8bf223$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $1T1QG.useContext)((0, $d33d540a7c2378fc$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $3ab9e43e4ac7eb81$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}




function $b459d8d5841a8d51$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest } = _ref;
            (0, $1b390901db8bf223$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $1T1QG.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $d33d540a7c2378fc$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $5628efa135deda5f$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}







const $c80f0430833718ef$export$324d90190a8b822a = ()=>"";
const $c80f0430833718ef$export$2da9be4cfdb689b1 = ()=>"";
const $c80f0430833718ef$export$98e628dec113755e = ()=>"";
const $c80f0430833718ef$export$2e6c959c16ff56b8 = ()=>"";
const $c80f0430833718ef$export$4e35d5c922a95490 = ()=>"";
const $c80f0430833718ef$export$720a3b9db04b7a0f = ()=>"";


var $97aaded26ba6aa05$exports = {};
$97aaded26ba6aa05$exports = JSON.parse('{"common.yes":"yes","common.no":"no","common.ok":"ok","common.buttons.yes":"Yes","common.buttons.add":"Add","common.buttons.save":"Save","common.buttons.edit":"Edit","common.buttons.next":"Next","common.buttons.complete":"Compelete","common.buttons.cancel":"Cancel","common.buttons.remove":"Remove","common.buttons.update":"Update","common.buttons.terminate":"Terminate","common.buttons.back":"Back","common.buttons.clear":"Clear","common.actions.error":"An error occurred","common.actions.add.error":"Adding failed","common.actions.update.error":"Updating failed","common.actions.get.error":"Failed to get data","common.actions.remove.error":"Failed to remove data","common.form.errors.empty":"The field cannot be empty.","common.form.errors.email":"Enter a valid email.","common.form.errors.phoneNumber":"Enter a valid phone number with country code.","common.form.errors.licensePlate":"Enter a valid vehicle license plate.","common.form.errors.businessId":"Enter a valid Business ID.","common.form.errors.number":"Only numbers can be entered in the field.","common.form.errors.invalidDateTime":"Enter a valid date and time","common.text.licensePlate":"License plate","common.text.email":"Email","common.text.project":"Project","common.text.costCenter":"Cost center","common.text.validityStart":"Start","common.text.validityEnd":"End","menu.invitations":"Invite a customer","menu.allPlaces":"All locations","menu.places":"Location & Rights","menu.customer":"Customer details","menu.reports":"Reports","menu.user.detail":"Own details","menu.user.logout":"Sign out","menu.user.fi":"In Finnish","menu.user.en":"In English","menu.subHeader.moovyAdmin":"Moovy Admin","appMenuTop.button.menu":"Menu","appMenuTop.button.closeMenu":"Close menu","validation.code.NOT_EMPTY":"{field, plural, one {Field cannot be empty.} other {{field} field cannot be empty.}}","validation.code.MAX_LENGTH":"{field, plural, one {Too many characters} other {There are too many characters in the field {field}.}}","validation.code.MIN_LENGTH":"{field, plural, one {There are no enough characters.} other {There are no enough characters in the field {field}.}}","validation.code.BUSINESS_ID_FORMAT":"{field, plural, one {Input content is not in a valid format.} other {The field {field} content is not a valid format.}}","validation.code.generic":"Filled values are not valid. Please check them.","validation.field.name":"Name","validation.field.streetAddress":"Address","validation.field.city":"City","validation.field.postalCode":"Postal code","validation.field.businessId":"Business ID","validation.field.costCenter":"Cost center","validation.field.project":"Project","sort.PLACES.NAME":"Name","sort.PLACES.CITY":"City","sort.PLACES.CAPACITY":"Capacity","sort.PLACES.CUSTOMER_ID":"Customer","sort.INVITATIONS.NAME":"Name","sort.INVITATIONS.EMAIL":"Email","sort.INVITATIONS.CREATED_AT":"Invited","sort.INVITATIONS.USED":"Registered in","sort.ACTIVE_RIGHTS.INDIVIDUAL":"Name","sort.ACTIVE_RIGHTS.VEHICLE":"License plate","sort.ACTIVE_RIGHTS.VALIDITY_START":"Valid from","sort.ACTIVE_RIGHTS.VALIDITY_END":"Valid until","sort.CATALOGUES.CUSTOMER_ID":"Customer","sort.CATALOGUES.CREATED_AT":"Created","sort.CATALOGUES.UPDATED_AT":"Updated","sort.CATALOGUES.AMOUNT":"Amount","api.error.code.OFFERING_AMOUNT_EXCEEDED_ERROR":"The offering must be at least the number of distributed rights.","api.error.code.CUSTOMER_ALREADY_EXISTS":"A customer with the same name already exists in the system.","api.error.code.INVITATION_ALREADY_EXISTS":"An invitation already exists for the same person.","api.error.code.CATALOGUE_AMOUNT_EXCEEDED":"The amount is too large. The number of rights to be granted may not exceed the total number of rights for the product.","api.error.code.CATALOGUE_AMOUNT_TOO_SMALL":"The amount is too small. The number of rights to be granted must be at least the same as the number of rights distributed.","api.error.code.CATALOGUE_DOES_NOT_ALLOW_VEHICLE_GRANTING":"Catalogue doesn\'t allow granting rights to vehicles","api.error.code.EMAIL_ALREADY_TAKEN":"The email is already in use.","api.error.code.TOO_MANY_CATALOGUES_IN_REPORT":"The report includes too many catalogues. Change search filters and try again.","api.error.code.TOO_MANY_RIGHTS_IN_REPORT":"The report includes too many rights. Change search filters and try again.","api.error.code.RIGHT_HOLDER_EXCEEDS_CATALOGUE_AMOUNT":"Number of requested rights plus number of existing active rights must not exceed catalogue\'s limit","api.error.code.generic":"An error occurred","moovyErrorPage.oops":"Oops!","moovyErrorPage.message":"Sorry, an unexpected error has occurred. Please, check the url and try to refresh the view again.","components.modalSubPlace.actions.error.added":"Failed to add the location","components.modalSubPlace.actions.added":"The location has been added.","components.modalSubPlace.title":"Add sublocation","components.modalSubPlace.button.add":"Add sublocation","components.tableSubPlaces.header.name":"Name","components.tableSubPlaces.header.customer":"Customer","components.tableSubPlaces.header.streetAddress":"Street address","components.tableSubPlaces.header.postalCode":"Postal code","components.tableSubPlaces.header.city":"City","components.tableSubPlaces.header.capacity":"Capacity","components.tableSubPlaces.action.empty":"There are no locations","components.tableSubPlaces.action.failed":"Failed to get locations","page.steps.bar.landlord.title":"Landlord details","page.steps.bar.landlord.description":"Fill landlord details","page.steps.bar.place.title":"Location details","page.steps.bar.place.description":"Fill location details","page.steps.landlord.title":"Landlord details","page.steps.landlord.info":"Create a company in Moovy by entering the company information. Company and its representatives are responsible for the parking facility to be created.","page.steps.landlord.actions.added":"The landlord {name} has been added.","page.steps.place.title":"Location details","page.steps.place.info":"Please fill in the basic information of the object. The information is mandatory, as it is used in Moovy, for example, to manage parking permits. You can later change and complete the item\'s information","page.steps.place.actions.added":"The location {name} has been added.","page.steps.noRights.header":"User account has no rights to use Lupapalvelu","page.steps.noRights.content":"To use Lupapalvelu you need to have rights to manage locations.","page.invitations.modalAddInvitation.landlord.title":"Invite a customer","page.invitations.modalAddInvitation.tenant.title":"Add and invite an administrator","page.invitations.invitation.actions.updated":"Invitation link {name} has been updated.","page.invitations.formInvitation.label.firstName":"First name","page.invitations.formInvitation.label.lastName":"Last name","page.invitations.list.button.landlord.newInvitation":"Invite a customer","page.invitations.list.button.tenant.newInvitation":"Invite an administrator","page.invitations.list.button.remove":"Remove invitation","page.invitations.list.title":"Invite new customers","page.invitations.list.actions.added":"New invitation {name} has been added.","page.invitations.list.actions.removed":"The invitation {name} has been removed.","page.invitations.list.table.header.name":"Name","page.invitations.list.table.header.invited":"Invited","page.invitations.list.table.header.registeredIn":"Registered in","page.invitations.list.table.action.empty":"There are no invitation links.","page.invitations.list.table.action.failed":"Failed to get invitation links.","page.invitations.list.card.header.registeredIn":"Registered in","page.invitations.modalRemove.header":"Remove the invitation?","page.invitations.modalRemove.content":"Are you sure you want to remove the invitation from the user {name}?","page.catalogues.modalAddRightHolder.title":"Add right holder","page.catalogues.modalAddRightHolder.button.add":"Add right holder","page.catalogues.modalAddRightHolder.steps.bar.email":"Email","page.catalogues.modalAddRightHolder.steps.bar.rightHolder":"Right holder details","page.catalogues.modalAddVehicleRightHolder.title":"Add vehicle","page.catalogues.tabCatalogue.formIndividualRightHolder.label.customerDetails":"Customer details","page.catalogues.tabCatalogue.formIndividualRightHolder.label.firstName":"First name","page.catalogues.tabCatalogue.formIndividualRightHolder.label.lastName":"Last name","page.catalogues.tabCatalogue.formIndividualRightHolder.label.phoneNumber":"Phone number","page.catalogues.tabCatalogue.formIndividualRightHolder.label.productDetails":"Product details","page.catalogues.tabCatalogue.formIndividualRightHolder.label.licensePlateDetails":"A vehicle license plate","page.catalogues.tabCatalogue.formIndividualRightHolder.label.validity":"Validity","page.catalogues.tabCatalogue.modalFindRightHolder.info":"Enter an email address to create a new right holder or to check if the right holder already has a Moovy account.","page.catalogues.tabCatalogue.modalFindRightHolder.form.label.email":"Email","page.catalogues.tabCatalogue.modalFindRightHolder.actions.added":"New right holder {name} has been added.","page.catalogues.tabCatalogue.formVehicleRightHolder.label.vehicleDetails":"A license plate of the vehicle","page.catalogues.tabCatalogue.formVehicleRightHolder.label.validity":"Right validity","page.catalogues.tabCatalogue.title.rightHolder":"Right holders","page.catalogues.tabCatalogue.search.label":"Search right holders","page.catalogues.tabCatalogue.search.invalid":"Please enter at least 3 characters","page.catalogues.tabCatalogue.button.addIndividual":"Add a right holder","page.catalogues.tabCatalogue.button.addVehicle":"Add a vehicle","page.catalogues.tabCatalogue.rightHolders.card.header.place":"Location","page.catalogues.tabCatalogue.rightHolders.card.header.validUntil":"Valid until","page.catalogues.tabCatalogue.rightHolders.table.header.name":"Name","page.catalogues.tabCatalogue.rightHolders.table.header.place":"Location","page.catalogues.tabCatalogue.rightHolders.table.header.validFrom":"Valid from","page.catalogues.tabCatalogue.rightHolders.table.header.validUntil":"Valid until","page.catalogues.tabCatalogue.rightHolders.table.action.empty":"There are no right holders here.","page.catalogues.tabCatalogue.rightHolders.table.action.failed":"Failed to read right holders.","page.rightHolders.rightHolder.title":"Right holder details","page.rightHolders.rightHolder.button.edit":"Edit right holder","page.rightHolders.rightHolder.modalEditRightHolder.title.individual":"Edit right holder","page.rightHolders.rightHolder.modalEditRightHolder.title.vehicle":"Edit license plate","page.rightHolders.rightHolder.modalEditRightHolder.actions.update":"Right holder {name} has been updated.","page.rightHolders.rightHolder.formEditRightHolder.label.firstName":"First name","page.rightHolders.rightHolder.formEditRightHolder.label.lastName":"Last name","page.rightHolders.rightHolder.formEditRightHolder.label.phoneNumber":"Phone number","page.rightHolders.rightHolder.formEditRightHolder.info.product":"A parking permit is automatically added to the user:","page.rightHolders.rightHolder.tab.rightsAndVehicles.title":"Rights and vehicles","page.rightHolders.rightHolder.tab.vehicles.table.header.createdAt":"Created","page.rightHolders.rightHolder.tab.vehicles.table.header.right":"Right","page.rightHolders.rightHolder.tab.vehicles.table.header.place":"Location","page.rightHolders.rightHolder.tab.vehicles.table.header.validFrom":"Valid from","page.rightHolders.rightHolder.tab.vehicles.table.header.validUntil":"Valid until","page.rightHolders.rightHolder.tab.vehicles.table.item.permanent":"Permanent","page.rightHolders.rightHolder.tab.vehicles.table.action.empty":"There are no vehicles here.","page.rightHolders.rightHolder.tab.vehicles.table.action.failed":"Failed to read vehicles.","page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.location":"Location:","page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.right":"Right:","page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.startRight":"Valid from:","page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.endRight":"Valid until:","page.places.modalAddPlace.title":"Add location","page.places.modalAddPlace.button.add":"Add location","page.places.formPlace.contentTitle":"Location details","page.places.formPlace.label.customer":"Customer","page.places.formPlace.label.name":"Name","page.places.formPlace.label.streetAddress":"Street address","page.places.formPlace.label.postalCode":"Postal code","page.places.formPlace.label.city":"City","page.places.formPlace.label.capacity":"Capacity","page.places.list.button.newPlace":"New location","page.places.list.title":"Locations","page.places.list.actions.added":"The new location {name} has been added.","page.places.list.table.header.name":"Name","page.places.list.table.header.streetAddress":"Street address","page.places.list.table.header.postalCode":"Postal code","page.places.list.table.header.city":"City","page.places.list.table.header.capacity":"Capacity","page.places.list.table.header.customer":"Customer","page.places.list.table.action.empty":"There are no locations.","page.places.list.table.action.failed":"Failed to get locations.","page.places.catalogueTabs.catalogue.header":"Rights","page.places.catalogueTabs.invitations.header":"Invitations","page.places.catalogueTabs.administrators.header":"Administrators","page.catalogues.tabCatalogue.cataloguePlaceInfo.title":"Location details","page.catalogues.tabCatalogue.cataloguePlaceInfo.name":"Name","page.catalogues.tabCatalogue.cataloguePlaceInfo.street":"Street address","page.catalogues.tabCatalogue.cataloguePlaceInfo.capacity":"Spots","page.catalogues.tabCatalogue.catalogueStatusInfo.title":"Snapshot","page.catalogues.tabCatalogue.catalogueStatusInfo.grantAmount":"Rights to be granted","page.catalogues.tabCatalogue.catalogueStatusInfo.grantedAmount":"Granted rights","page.catalogues.tabCatalogue.catalogueStatusInfo.costCenter":"Cost center","page.catalogues.tabCatalogue.catalogueStatusInfo.project":"Project","page.place.offeringsTab.header":"Rights","page.place.offeringsTab.infoText1":"The table shows offerings overview.","page.place.offeringsTab.table.empty":"Place has no offerings","page.place.offeringsTab.table.error":"Failed to load offerings.","page.place.offeringsTab.table.overview":"Overview","page.place.offeringsTab.table.timestamps":"Timestamps","page.place.offeringsTab.table.product":"Product","page.place.offeringsTab.table.catalogue.amount":"Rights granted:","page.place.offeringsTab.table.offering.edit":"Edit offering","page.place.actions.updated":"The location {name} has been updated.","page.place.modalEditPlace.title":"Edit location","page.placeRights.placeInformation.header":"Location Details","page.placeRights.placeInformation.button.edit":"Edit location","page.placeRights.placeInformation.address":"Address","page.placeRights.placeInformation.capacity":"Capacity","page.placeRights.placeInformation.offeringAmount":"Total rights","page.placeRights.situationOverview.header":"Situation Overview","page.placeRights.situationOverview.totalAmount":"Granted to customers","page.placeRights.situationOverview.parkingEnforcement":"Parking enforcement","page.customer.formSubPlace.title.location":"Location details","page.customer.formSubPlace.title.space":"Amount of parking spots","page.customer.formSubPlace.label.name":"Location name","page.customer.formSubPlace.label.spots":"Amount of spots","page.customer.formSubPlace.label.city":"City","page.customer.formSubPlace.label.postalCode":"Postal code","page.customer.formSubPlace.label.streetAddress":"Street address","page.customers.formCustomer.contentTitle":"Customer details","page.customers.formCustomer.label.name":"Customer name","page.customers.formCustomer.label.businessId":"Finnish business ID","page.customers.formCustomer.label.streetAddress":"Street address","page.customers.formCustomer.label.postalCode":"Postal code","page.customers.formCustomer.label.city":"City","page.customers.formCustomer.errors.businessId":"The field has to contain a valid Finnish business ID.","page.customers.customersInformation.name":"Name","page.customers.customersInformation.streetAddress":"Street address","page.customers.customersInformation.postalCodeAndCity":"Postal code and post office","page.customers.customersInformation.businessId":"Finnish business ID","page.customers.customersInformation.customerNumber":"Customer number","page.customers.tabAdministrators.infoText":"Add organisation admin.","page.customers.tabAdministrators.button.newAdminInvitation":"Add and invite admin","page.customers.tabAdministrators.actions.added":"New invitation {name} has been added.","page.customers.tabAdministrators.invitationsOngoing.link":"{count, plural, one {One waiting invitation.} other {{count} waiting invitations.}}","page.customers.tabAdministrators.tableAdministrators.header.name":"Name","page.customers.tabAdministrators.tableAdministrators.header.registeredIn":"Registered in","page.customers.tabAdministrators.tableAdministrators.button.remove":"Remove admin","page.customers.tabAdministrators.tableAdministrators.action.empty":"There are no other admins in this account.","page.customers.tabAdministrators.tableAdministrators.action.failed":"Failed to get admins.","page.customers.tabAdministrators.modalAdminInvitations.title":"Awaiting invitations","page.customers.tabAdministrators.modalRemove.header":"Remove admin?","page.customers.tabAdministrators.modalRemove.content":"Do you want to remove admin {name}?","page.customers.tabAdministrators.modalRemove.actions.removed":"Admin has been removed.","page.customer.actions.updated":"The customer {name} has been updated.","page.customer.title":"Organization details","page.customer.button.edit":"Edit customer","page.customer.modalEditCustomer.title":"Edit customer","page.customer.customerTabs.locations.header":"Locations","page.customer.customerTabs.admins.header":"Admins","page.offering.button.edit":"Edit offering","page.offering.cataloguesTab.table.error":"Failed to load catalogues","page.offering.cataloguesTab.header":"Catalogues","page.offering.cataloguesTab.infoText1":"The table shows the total number of permits issued for the location.","page.offering.cataloguesTab.infoText2":"You can issue permits to new customers by clicking on the \\"Create catalogue\\" button.","page.offering.cataloguesTab.createCatalogue":"Create catalogue","page.offering.cataloguesTab.table.catalogue.edit":"Edit catalogue","page.offering.cataloguesTab.table.name":"Name","page.offering.cataloguesTab.table.customer":"Customer","page.offering.cataloguesTab.table.overview":"Overview","page.offering.cataloguesTab.table.timestamps":"Timestamps","page.offering.cataloguesTab.table.empty":"There are no catalogues there.","page.offering.rightHoldersTab.header":"Search from catalogues","page.offering.rightHoldersTab.table.search.empty":"Please input search term","page.offering.rightHoldersTab.table.empty":"No right holders found","page.offering.rightHoldersTab.table.error":"Failed to load right holders","page.offering.rightHoldersTab.table.header.customer":"Customer","page.offering.offeringInfo.title":"Details","page.offering.offeringInfo.name":"Permit","page.offering.offeringInfo.location":"Location","page.offering.offeringInfo.catalogues.amount":"Granted permits for customers","page.offering.offeringInfo.maximumAmount":"Maximum permits","page.offering.offeringInfo.ignoreAmountLimits":"Unlimited","page.reports.title":"Reports","page.reports.type.radioGroup.title":"Choose report type","page.reports.type.radioGroup.landlord":"Catalogues","page.reports.type.radioGroup.tenant":"Rights","page.reports.customer.title":"Choose customer","page.reports.customer.label":"Customer","page.reports.customer.all":"All","page.reports.range.title":"Choose date range","page.reports.submit.button":"Download CSV report","page.reports.toast.error.emptyReport":"No report found by search criteria.","page.reports.toast.error.csvFailed":"Failed to generate report.","page.reports.daterange.start":"Start","page.reports.daterange.end":"End","page.users.title":"User","page.users.button.edit":"Edit user","page.users.label.user":"Logged user","page.users.label.emailConfirmed":"Email confirmed","page.users.modalChangePassword.title":"Update password","page.users.modalChangePassword.button.add":"Update","page.users.modalChangePassword.action.changed":"The password has been updated.","page.users.formPassword.errors.password":"New and confirmed passwords need to be the same.","page.users.formPassword.label.oldPassword":"Current password","page.users.formPassword.label.newPassword":"New password","page.users.formPassword.label.confirmNewPassword":"Confirm new password","moovyParkingEnforcementStatus.yes":"Enforced","moovyParkingEnforcementStatus.no":"Not enforced","timeStampItems.createdAt":"Created at:","timeStampItems.updatedAt":"Updated at:","page.offering.modalCreateCatalogue.title":"Create catalogue","page.offering.modalCreateCatalogue.grantedTo":"Who are rights granted to?","page.offering.modalCreateCatalogue.grantedTo.customer":"Customer","page.offering.modalCreateCatalogue.grantedTo.self":"Own company","page.offering.modalCreateCatalogue.customerLabel":"Customer information","page.offering.modalCreateCatalogue.customerName":"Organization name","page.offering.modalCreateCatalogue.businessId":"Business ID","page.offering.modalCreateCatalogue.project":"Project","page.offering.modalCreateCatalogue.costCenter":"Cost center","page.offering.modalCreateCatalogue.streetAddress":"Street address","page.offering.modalCreateCatalogue.postalCode":"Postal code","page.offering.modalCreateCatalogue.city":"City","page.offering.modalCreateCatalogue.offering":"Granted offering","page.offering.modalCreateCatalogue.catalogueName":"Catalogue name","page.offering.modalCreateCatalogue.name":"Name","page.offering.modalCreateCatalogue.amount":"Amount","page.offering.modalCreateCatalogue.amount.minimum":"Amount must be 0 or greater","page.offering.modalCreateCatalogue.allowVehicleGrant":"Allow to grant permission for vehicles","page.offering.modalCreateCatalogue.mutation.success":"Catalogue creation succeeded","page.offering.modalCreateCatalogue.mutation.conflict":"The number of granted rights cannot exceed the total number of rights for the product.","page.offering.modalEditOffering.title":"Edit offering","page.offering.modalEditOffering.product":"Product","page.offering.modalEditOffering.amountLabel":"Amount","page.offering.modalEditOffering.amount.minimum":"Amount must be 0 or greater","page.offering.modalEditOffering.mutation.success":"Offering update succeeded","page.offering.modalEditCatalogue.title":"Edit catalogue","page.offering.modalEditCatalogue.catalogueName":"Catalogue name","page.offering.modalEditCatalogue.customer":"Customer","page.offering.modalEditCatalogue.offering":"Granted offering","page.offering.modalEditCatalogue.amountLabel":"Amount of rights to grant","page.offering.modalEditCatalogue.amount.minimum":"Amount must be 0 or greater","page.offering.modalEditCatalogue.mutation.success":"Catalogue update succeeded","modalEditVehicle.title":"Edit the vehicle\'s parking right","modalEditVehicle.webshopWarning":"Parking right cannot be edited for webshop catalogues","modalEditVehicle.actions.change":"The vehicle license plate has been changed.","modalEditVehicle.actions.rightEnded":"The right has been terminated.","modalEditVehicle.actions.error.end":"Failed to terminate the right.","modalEditVehicle.modalRemove.header":"Terminate right?","modalEditVehicle.modalRemove.content":"Are you sure you want to terminate the right from the vehicle {licensePlate}?","modalEditVehicle.modalRemove.content.endReason":"Reason","modalEditVehicle.modalRemove.content.endReason.placeholder":"Reason for termination","moovySortAndFilter.sortingCriteria":"Sort","allocatedRights.available":"Available:","allocatedRights.rightsGranted":"Rights granted:","allocatedRights.rightsShared":"Rights shared:","allocatedRights.rightsTotal":"Total rights:","page.right.title":"Right","page.right.container.title":"Right information","page.right.start":"Start","page.right.end":"End","page.right.licensePlate":"License plate","page.right.place":"Place","page.right.catalogue":"Catalogue","page.right.individual":"Individual","page.right.costCenter":"Cost center","page.right.project":"Project","page.right.endReason":"End reason","page.right.active":"Active"}');


var $8b533e8983d1c054$exports = {};
$8b533e8983d1c054$exports = JSON.parse('{"common.yes":"kyll\xe4","common.no":"ei","common.ok":"ok","common.buttons.yes":"Kyll\xe4","common.buttons.add":"Lis\xe4\xe4","common.buttons.save":"Tallenna","common.buttons.edit":"Muokkaa","common.buttons.next":"Seuraava","common.buttons.complete":"Valmis","common.buttons.cancel":"Peruuta","common.buttons.remove":"Poista","common.buttons.update":"P\xe4ivit\xe4","common.buttons.terminate":"Irtisano","common.buttons.back":"Takaisin","common.buttons.clear":"Tyhjenn\xe4","common.actions.error":"Tapahtui virhe","common.actions.add.error":"Lis\xe4ys ep\xe4onnistui","common.actions.update.error":"P\xe4ivitys ep\xe4onnistui","common.actions.get.error":"Tietojen haku ep\xe4onnistui","common.actions.remove.error":"Poisto ep\xe4onnistui","common.form.errors.empty":"Kentt\xe4 ei voi olla tyhj\xe4.","common.form.errors.email":"Sy\xf6t\xe4 kelvollinen s\xe4hk\xf6postiosoite.","common.form.errors.phoneNumber":"Sy\xf6t\xe4 kelvollinen puhelinnumero maatunnuksella.","common.form.errors.licensePlate":"Sy\xf6t\xe4 kelvollinen ajoneuvon rekisteritunnus.","common.form.errors.businessId":"Sy\xf6t\xe4 kelvollinen Y-tunnus.","common.form.errors.number":"Kentt\xe4\xe4n voi sy\xf6tt\xe4\xe4 vain numeroita.","common.form.errors.invalidDateTime":"Sy\xf6t\xe4 kelvollinen p\xe4iv\xe4m\xe4\xe4r\xe4 sek\xe4 aika","common.text.licensePlate":"Rekisteritunnus","common.text.email":"S\xe4hk\xf6posti","common.text.project":"Projekti","common.text.costCenter":"Kustannuspaikka","common.text.validityStart":"Alkaa","common.text.validityEnd":"P\xe4\xe4ttyy","menu.invitations":"Kutsu asiakas","menu.allPlaces":"Kohdelistaus","menu.places":"Kohde & Luvat","menu.customer":"Omistajan tiedot","menu.reports":"Raportit","menu.user.detail":"Omat tiedot","menu.user.logout":"Kirjaudu ulos","menu.user.fi":"Suomeksi","menu.user.en":"Englanniksi","menu.subHeader.moovyAdmin":"Moovy Admin","appMenuTop.button.menu":"Valikko","appMenuTop.button.closeMenu":"Sulje menu","validation.code.NOT_EMPTY":"{field, plural, one {Kentt\xe4 ei voi olla tyhj\xe4.} other {{field}-kentt\xe4 ei voi olla tyhj\xe4.}}","validation.code.MAX_LENGTH":"{field, plural, one {Merkkej\xe4 on liikaa.} other {{field}-kent\xe4ss\xe4 on liikaa merkkej\xe4.}}","validation.code.MIN_LENGTH":"{field, plural, one {Sy\xf6tetty merkkim\xe4\xe4r\xe4 ei ole riitt\xe4v\xe4.} other {{field}-kent\xe4ss\xe4 ei ole riitt\xe4v\xe4sti merkkej\xe4.}}","validation.code.BUSINESS_ID_FORMAT":"{field, plural, one {Sy\xf6tteen muoto on virheellinen.} other {{field}-kent\xe4n sy\xf6te on virheellisess\xe4 muodossa.}}","validation.code.generic":"Tarkista sy\xf6tt\xe4m\xe4si arvot.","validation.field.name":"Nimi","validation.field.streetAddress":"Osoite","validation.field.city":"Kaupunki","validation.field.postalCode":"Postinumero","validation.field.businessId":"Y-tunnus","validation.field.costCenter":"Kustannuspaikka","validation.field.project":"Projekti","sort.PLACES.NAME":"Nimi","sort.PLACES.CITY":"Postitoimipaikka","sort.PLACES.CAPACITY":"Ruutujen m\xe4\xe4r\xe4","sort.PLACES.CUSTOMER_ID":"Asiakas","sort.INVITATIONS.NAME":"Nimi","sort.INVITATIONS.EMAIL":"S\xe4hk\xf6posti","sort.INVITATIONS.CREATED_AT":"Kutsuttu","sort.INVITATIONS.USED":"Rekister\xf6itynyt","sort.ACTIVE_RIGHTS.INDIVIDUAL":"Nimi","sort.ACTIVE_RIGHTS.VEHICLE":"Rekisteritunnus","sort.ACTIVE_RIGHTS.VALIDITY_START":"Voimassa alkaen","sort.ACTIVE_RIGHTS.VALIDITY_END":"P\xe4\xe4ttyy","sort.CATALOGUES.CUSTOMER_ID":"Asiakas","sort.CATALOGUES.CREATED_AT":"Luotu","sort.CATALOGUES.UPDATED_AT":"P\xe4ivitetty","sort.CATALOGUES.AMOUNT":"M\xe4\xe4r\xe4","api.error.code.OFFERING_AMOUNT_EXCEEDED_ERROR":"Tarjooman pit\xe4\xe4 olla v\xe4hint\xe4\xe4n jaettujen lupien m\xe4\xe4r\xe4.","api.error.code.CUSTOMER_ALREADY_EXISTS":"Samanniminen asiakas on jo j\xe4rjestelm\xe4ss\xe4.","api.error.code.INVITATION_ALREADY_EXISTS":"Kutsu on jo olemassa samalle henkil\xf6lle.","api.error.code.CATALOGUE_AMOUNT_EXCEEDED":"Lupam\xe4\xe4r\xe4 liian suuri. My\xf6nnett\xe4vien lupien m\xe4\xe4r\xe4 ei saa ylitt\xe4\xe4 tuotteen lupien kokonaism\xe4\xe4r\xe4\xe4.","api.error.code.CATALOGUE_AMOUNT_TOO_SMALL":"Lupam\xe4\xe4r\xe4 liian pieni. My\xf6nnett\xe4vien lupien m\xe4\xe4r\xe4 t\xe4ytyy olla v\xe4hint\xe4\xe4n sama kuin jaettujen lupien m\xe4\xe4r\xe4.","api.error.code.CATALOGUE_DOES_NOT_ALLOW_VEHICLE_GRANTING":"Lupasopimus ei salli lupien my\xf6nt\xe4mist\xe4 ajoneuvolle.","api.error.code.EMAIL_ALREADY_TAKEN":"S\xe4hk\xf6postiosoite on jo k\xe4yt\xf6ss\xe4.","api.error.code.TOO_MANY_CATALOGUES_IN_REPORT":"Raporttiin sis\xe4ltyy liian monta lupasopimusta. Vaihda hakukriteereit\xe4 ja yrit\xe4 uudelleen.","api.error.code.TOO_MANY_RIGHTS_IN_REPORT":"Raporttiin sis\xe4ltyy liian monta lupaa. Vaihda hakukriteereit\xe4 ja yrit\xe4 uudelleen.","api.error.code.RIGHT_HOLDER_EXCEEDS_CATALOGUE_AMOUNT":"Lupam\xe4\xe4r\xe4 liian suuri. My\xf6nnett\xe4vien lupien m\xe4\xe4r\xe4 ei saa ylitt\xe4\xe4 lupasopimuksen lupien kokonaism\xe4\xe4r\xe4\xe4.","api.error.code.generic":"Tapahtui virhe","moovyErrorPage.oops":"Hups!","moovyErrorPage.message":"Pahoittelut, sivua ei voi ladata. Tarkista osoite ja yrit\xe4 ladata sivu uudestaan.","components.modalSubPlace.actions.error.added":"Asiakaskohteen lis\xe4ys ep\xe4onnistui","components.modalSubPlace.actions.added":"Asiakaskohteen lis\xe4ys onnistui","components.modalSubPlace.title":"Lis\xe4\xe4 asiakaskohde","components.modalSubPlace.button.add":"Lis\xe4\xe4 asiakaskohde","components.tableSubPlaces.header.name":"Nimi","components.tableSubPlaces.header.customer":"Asiakas","components.tableSubPlaces.header.streetAddress":"Postiosoite","components.tableSubPlaces.header.postalCode":"Postinumero","components.tableSubPlaces.header.city":"Postitoimipaikka","components.tableSubPlaces.header.capacity":"Ruutujen m\xe4\xe4r\xe4","components.tableSubPlaces.action.empty":"Kohteita ei ole","components.tableSubPlaces.action.failed":"Kohteiden haku ep\xe4onnistui","page.steps.bar.landlord.title":"Kohteen omistajan tiedot","page.steps.bar.landlord.description":"T\xe4yt\xe4 omistajan tiedot","page.steps.bar.place.title":"Kohteen tiedot","page.steps.bar.place.description":"T\xe4yt\xe4 kohteen tarvittavat tiedot","page.steps.landlord.title":"Kohteen omistajan tiedot","page.steps.landlord.info":"Perusta Moovyn organisaatiosi, sy\xf6tt\xe4m\xe4ll\xe4 vaaditut tiedot. Organisaatio ja sen edustajat ovat vastuussa luotavasta pys\xe4k\xf6intikohteesta.","page.steps.landlord.actions.added":"Uusi yritys {name} lis\xe4tty.","page.steps.place.title":"Kohteen tiedot","page.steps.place.info":"Ole hyv\xe4 ja t\xe4yt\xe4 kohteen perustiedot. Tiedot ovat pakollisia, sill\xe4 niit\xe4 k\xe4ytet\xe4\xe4n Moovyssa esimerkiksi pys\xe4k\xf6intilupien hallintaan. Voit my\xf6hemmin muuttaa ja t\xe4ydent\xe4\xe4 kohteen tietoja","page.steps.place.actions.added":"Uusi kohde {name} lis\xe4tty.","page.steps.noRights.header":"K\xe4ytt\xe4j\xe4tunnuksella ei ole hallinnointioikeuksia Lupapalvelun k\xe4ytt\xf6\xf6n","page.steps.noRights.content":"Lupapalvelun k\xe4ytt\xf6\xf6n tarvitset oikeuden hallinnoida kohteita.","page.invitations.modalAddInvitation.landlord.title":"Kutsu asiakas","page.invitations.modalAddInvitation.tenant.title":"Lis\xe4\xe4 ja kutsu hallinnoija","page.invitations.invitation.actions.updated":"Kutsulinkki {name} p\xe4ivitetty.","page.invitations.formInvitation.label.firstName":"Etunimi","page.invitations.formInvitation.label.lastName":"Sukunimi","page.invitations.list.button.landlord.newInvitation":"Kutsu asiakas","page.invitations.list.button.tenant.newInvitation":"Kutsu hallinnoija","page.invitations.list.button.remove":"Poista kutsu","page.invitations.list.title":"Kutsu uusia asiakkaita","page.invitations.list.actions.added":"Uusi kutsu {name} lis\xe4tty.","page.invitations.list.actions.removed":"Kutsu {name} poistettu.","page.invitations.list.table.header.name":"Nimi","page.invitations.list.table.header.invited":"Kutsuttu","page.invitations.list.table.header.registeredIn":"Rekister\xf6itynyt","page.invitations.list.table.action.empty":"Kutsulinkkej\xe4 ei ole","page.invitations.list.table.action.failed":"Kutsulinkkien haku ep\xe4onnistui","page.invitations.list.card.header.registeredIn":"Rekister\xf6itynyt","page.invitations.modalRemove.header":"Poista kutsu?","page.invitations.modalRemove.content":"Haluatko varmasti poistaa kutsun k\xe4ytt\xe4j\xe4lt\xe4 {name}?","page.catalogues.modalAddRightHolder.title":"Lis\xe4\xe4 luvanhaltija","page.catalogues.modalAddRightHolder.button.add":"Lis\xe4\xe4 luvanhaltija","page.catalogues.modalAddRightHolder.steps.bar.email":"S\xe4hk\xf6postiosoite","page.catalogues.modalAddRightHolder.steps.bar.rightHolder":"Luvanhaltijan tiedot","page.catalogues.modalAddVehicleRightHolder.title":"Lis\xe4\xe4 ajoneuvo","page.catalogues.tabCatalogue.formIndividualRightHolder.label.customerDetails":"Asiakkaan tiedot","page.catalogues.tabCatalogue.formIndividualRightHolder.label.firstName":"Etunimi","page.catalogues.tabCatalogue.formIndividualRightHolder.label.lastName":"Sukunimi","page.catalogues.tabCatalogue.formIndividualRightHolder.label.phoneNumber":"Puhelinnumero","page.catalogues.tabCatalogue.formIndividualRightHolder.label.productDetails":"My\xf6nnett\xe4v\xe4 lupatuote","page.catalogues.tabCatalogue.formIndividualRightHolder.label.licensePlateDetails":"Ajoneuvon rekisteritunnus","page.catalogues.tabCatalogue.formIndividualRightHolder.label.validity":"Voimassaoloaika","page.catalogues.tabCatalogue.modalFindRightHolder.info":"Kirjoita s\xe4hk\xf6postiosoite luodaksesi uuden luvanhaltijan tai tarkistaaksesi l\xf6ytyyk\xf6 luvanhaltijalta jo Moovy-tili.","page.catalogues.tabCatalogue.modalFindRightHolder.form.label.email":"S\xe4hk\xf6postiosoite","page.catalogues.tabCatalogue.modalFindRightHolder.actions.added":"Uusi luvanhaltija {name} lis\xe4tty.","page.catalogues.tabCatalogue.formVehicleRightHolder.label.vehicleDetails":"Ajoneuvon rekisteritunnus","page.catalogues.tabCatalogue.formVehicleRightHolder.label.validity":"Luvan voimassaoloaika","page.catalogues.tabCatalogue.title.rightHolder":"Luvanhaltijat","page.catalogues.tabCatalogue.search.label":"Hae luvanhaltijoita","page.catalogues.tabCatalogue.search.invalid":"Sy\xf6t\xe4 v\xe4hint\xe4\xe4n kolme merkki\xe4","page.catalogues.tabCatalogue.button.addIndividual":"Lis\xe4\xe4 luvanhaltija","page.catalogues.tabCatalogue.button.addVehicle":"Lis\xe4\xe4 ajoneuvo","page.catalogues.tabCatalogue.rightHolders.card.header.place":"Kohde","page.catalogues.tabCatalogue.rightHolders.card.header.validUntil":"P\xe4\xe4ttyy","page.catalogues.tabCatalogue.rightHolders.table.header.name":"Nimi","page.catalogues.tabCatalogue.rightHolders.table.header.place":"Kohde","page.catalogues.tabCatalogue.rightHolders.table.header.validFrom":"Voimassa alkaen","page.catalogues.tabCatalogue.rightHolders.table.header.validUntil":"P\xe4\xe4ttyy","page.catalogues.tabCatalogue.rightHolders.table.action.empty":"Luvanhaltijoita ei ole","page.catalogues.tabCatalogue.rightHolders.table.action.failed":"Luvanhaltijoiden haku ep\xe4onnistui","page.rightHolders.rightHolder.title":"Luvanhaltijan tiedot","page.rightHolders.rightHolder.button.edit":"Muokkaa luvanhaltijaa","page.rightHolders.rightHolder.modalEditRightHolder.title.individual":"Muokkaa luvanhaltijaa","page.rightHolders.rightHolder.modalEditRightHolder.title.vehicle":"Muokkaa rekisteritunnusta","page.rightHolders.rightHolder.modalEditRightHolder.actions.update":"Luvanhaltija {name} p\xe4ivitetty.","page.rightHolders.rightHolder.formEditRightHolder.label.firstName":"Etunimi","page.rightHolders.rightHolder.formEditRightHolder.label.lastName":"Sukunimi","page.rightHolders.rightHolder.formEditRightHolder.label.phoneNumber":"Puhelinnumero","page.rightHolders.rightHolder.formEditRightHolder.info.product":"K\xe4ytt\xe4j\xe4lle lis\xe4t\xe4\xe4n automaattisesti pys\xe4k\xf6intilupa:","page.rightHolders.rightHolder.tab.rightsAndVehicles.title":"Ajoneuvot ja luvat","page.rightHolders.rightHolder.tab.vehicles.table.header.createdAt":"Luotu","page.rightHolders.rightHolder.tab.vehicles.table.header.right":"Lupa","page.rightHolders.rightHolder.tab.vehicles.table.header.place":"Kohde","page.rightHolders.rightHolder.tab.vehicles.table.header.validFrom":"Voimassa alkaen","page.rightHolders.rightHolder.tab.vehicles.table.header.validUntil":"P\xe4\xe4ttyy","page.rightHolders.rightHolder.tab.vehicles.table.item.permanent":"Toistaiseksi","page.rightHolders.rightHolder.tab.vehicles.table.action.empty":"Ajoneuvoja ei ole","page.rightHolders.rightHolder.tab.vehicles.table.action.failed":"Ajoneuvojen haku ep\xe4onnistui.","page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.location":"Kohde:","page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.right":"Lupa:","page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.startRight":"Alkaen:","page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.endRight":"P\xe4\xe4ttyy:","page.places.modalAddPlace.title":"Lis\xe4\xe4 kohde","page.places.modalAddPlace.button.add":"Lis\xe4\xe4 kohde","page.places.formPlace.contentTitle":"Kohteen tiedot","page.places.formPlace.label.customer":"Asiakas","page.places.formPlace.label.name":"Nimi","page.places.formPlace.label.streetAddress":"Postiosoite","page.places.formPlace.label.postalCode":"Postinumero","page.places.formPlace.label.city":"Postitoimipaikka","page.places.formPlace.label.capacity":"Ruutujen m\xe4\xe4r\xe4","page.places.list.button.newPlace":"Uusi kohde","page.places.list.title":"Kohteet","page.places.list.actions.added":"Uusi kohde {name} lis\xe4tty.","page.places.list.table.header.name":"Nimi","page.places.list.table.header.streetAddress":"Postiosoite","page.places.list.table.header.postalCode":"Postinumero","page.places.list.table.header.city":"Postitoimipaikka","page.places.list.table.header.capacity":"Ruutujen m\xe4\xe4r\xe4","page.places.list.table.header.customer":"Asiakas","page.places.list.table.action.empty":"Kohteita ei ole","page.places.list.table.action.failed":"Kohteiden haku ep\xe4onnistui","page.places.catalogueTabs.catalogue.header":"Luvat","page.places.catalogueTabs.invitations.header":"Kutsut","page.places.catalogueTabs.administrators.header":"Hallinnoijat","page.catalogues.tabCatalogue.cataloguePlaceInfo.title":"Kohteen tiedot","page.catalogues.tabCatalogue.cataloguePlaceInfo.name":"Nimi","page.catalogues.tabCatalogue.cataloguePlaceInfo.street":"Osoite","page.catalogues.tabCatalogue.cataloguePlaceInfo.capacity":"Ruudut","page.catalogues.tabCatalogue.catalogueStatusInfo.title":"Tilannekuva","page.catalogues.tabCatalogue.catalogueStatusInfo.grantAmount":"Jaettavien lupien m\xe4\xe4r\xe4","page.catalogues.tabCatalogue.catalogueStatusInfo.grantedAmount":"Lupia jaettu","page.catalogues.tabCatalogue.catalogueStatusInfo.costCenter":"Kustannuspaikka","page.catalogues.tabCatalogue.catalogueStatusInfo.project":"Projekti","page.place.offeringsTab.header":"Luvat","page.place.offeringsTab.infoText1":"Taulukosta n\xe4et kohteen lupien kokonaiskuvan.","page.place.offeringsTab.table.empty":"Kohteella ei ole tarjoomaa","page.place.offeringsTab.table.error":"Lupasopimusten lataamisessa tapahtui virhe.","page.place.offeringsTab.table.overview":"Tilannekuva","page.place.offeringsTab.table.timestamps":"Aikaleimat","page.place.offeringsTab.table.product":"Tuote","page.place.offeringsTab.table.catalogue.amount":"Lupia my\xf6nnetty:","page.place.offeringsTab.table.offering.edit":"Muokkaa tarjoomaa","page.place.actions.updated":"Kohde {name} p\xe4ivitetty.","page.place.modalEditPlace.title":"Muokkaa kohdetta","page.placeRights.placeInformation.header":"Kohteen tiedot","page.placeRights.placeInformation.button.edit":"Muokkaa kohdetta","page.placeRights.placeInformation.address":"Osoite","page.placeRights.placeInformation.capacity":"Ruutujen m\xe4\xe4r\xe4","page.placeRights.placeInformation.offeringAmount":"Lupia yhteens\xe4","page.placeRights.situationOverview.header":"Tilannekuva","page.placeRights.situationOverview.totalAmount":"Asiakkaille my\xf6nnetyt luvat","page.placeRights.situationOverview.parkingEnforcement":"Pys\xe4k\xf6inninvalvonta","page.customer.formSubPlace.title.location":"Kohteen tiedot","page.customer.formSubPlace.title.space":"My\xf6nnett\xe4vien pys\xe4k\xf6intiruutujen m\xe4\xe4r\xe4","page.customer.formSubPlace.label.name":"Kohteen nimi","page.customer.formSubPlace.label.spots":"Ruutujen m\xe4\xe4r\xe4","page.customer.formSubPlace.label.city":"Postitoimipaikka","page.customer.formSubPlace.label.postalCode":"Postinumero","page.customer.formSubPlace.label.streetAddress":"Postiosoite","page.customers.formCustomer.contentTitle":"Asiakkaan tiedot","page.customers.formCustomer.label.name":"Organisaation nimi","page.customers.formCustomer.label.businessId":"Y-tunnus","page.customers.formCustomer.label.streetAddress":"Postiosoite","page.customers.formCustomer.label.postalCode":"Postinumero","page.customers.formCustomer.label.city":"Postitoimipaikka","page.customers.formCustomer.errors.businessId":"Kent\xe4n t\xe4ytyy sis\xe4lt\xe4\xe4 oikea Y-tunnus.","page.customers.customersInformation.name":"Nimi","page.customers.customersInformation.streetAddress":"Osoite","page.customers.customersInformation.postalCodeAndCity":"Postinumero ja -toimipaikka","page.customers.customersInformation.businessId":"Y-tunnus","page.customers.customersInformation.customerNumber":"Asiakasnumero","page.customers.tabAdministrators.infoText":"Lis\xe4\xe4 organisaation hallinnoija.","page.customers.tabAdministrators.button.newAdminInvitation":"Lis\xe4\xe4 ja kutsu hallinnoija","page.customers.tabAdministrators.actions.added":"Uusi kutsu {name} lis\xe4tty.","page.customers.tabAdministrators.invitationsOngoing.link":"{count, plural, one {Yksi odottava kutsu.} other {{count} odottavaa kutsua.}}","page.customers.tabAdministrators.tableAdministrators.header.name":"Nimi","page.customers.tabAdministrators.tableAdministrators.header.registeredIn":"Rekister\xf6itynyt","page.customers.tabAdministrators.tableAdministrators.button.remove":"Poista hallinnoija","page.customers.tabAdministrators.tableAdministrators.action.empty":"Tilill\xe4 ei ole muita hallinnoijia.","page.customers.tabAdministrators.tableAdministrators.action.failed":"Tilin hallinnoijien haku ep\xe4onnistui.","page.customers.tabAdministrators.modalAdminInvitations.title":"Odottavat kutsut","page.customers.tabAdministrators.modalRemove.header":"Poista hallinnoija?","page.customers.tabAdministrators.modalRemove.content":"Haluatko poistaa hallinnoijan {name}?","page.customers.tabAdministrators.modalRemove.actions.removed":"Hallinnoija poistettu.","page.customer.actions.updated":"Asiakas {name} p\xe4ivitetty.","page.customer.title":"Organisaation tiedot","page.customer.button.edit":"Muokkaa asiakasta","page.customer.modalEditCustomer.title":"Muokkaa asiakasta","page.customer.customerTabs.locations.header":"Kohteet","page.customer.customerTabs.admins.header":"Hallinnoijat","page.offering.button.edit":"Muokkaa lupaa","page.offering.cataloguesTab.table.error":"Katalogien lataamisessa tapahtui virhe","page.offering.cataloguesTab.header":"Lupasopimukset","page.offering.cataloguesTab.infoText1":"Taulukosta n\xe4et kohteen lupien kokonaiskuvan my\xf6nnettyjen lupien osalta.","page.offering.cataloguesTab.infoText2":"Voit my\xf6nt\xe4\xe4 lupia uusille asiakkaille painikkeesta \\"Luo lupasopimus\\".","page.offering.cataloguesTab.createCatalogue":"Luo lupasopimus","page.offering.cataloguesTab.table.catalogue.edit":"Muokkaa sopimusta","page.offering.cataloguesTab.table.name":"Nimi","page.offering.cataloguesTab.table.customer":"Asiakas","page.offering.cataloguesTab.table.overview":"Tilannekuva","page.offering.cataloguesTab.table.timestamps":"Aikaleimat","page.offering.cataloguesTab.table.empty":"Lupasopimuksia ei ole.","page.offering.rightHoldersTab.header":"Hae lupasopimuksista","page.offering.rightHoldersTab.table.search.empty":"Sy\xf6t\xe4 ensin hakuehto","page.offering.rightHoldersTab.table.empty":"Ei tuloksia","page.offering.rightHoldersTab.table.error":"Lupien haku ep\xe4onnistui","page.offering.rightHoldersTab.table.header.customer":"Asiakas","page.offering.offeringInfo.title":"Luvan tiedot","page.offering.offeringInfo.name":"Lupa","page.offering.offeringInfo.location":"Kohde","page.offering.offeringInfo.catalogues.amount":"Asiakkaille my\xf6nnetyt luvat","page.offering.offeringInfo.maximumAmount":"Lupien maksimim\xe4\xe4r\xe4","page.offering.offeringInfo.ignoreAmountLimits":"Rajoittamaton","page.reports.title":"Raportit","page.reports.type.radioGroup.title":"Valitse raporttityyppi","page.reports.type.radioGroup.landlord":"Lupasopimukset","page.reports.type.radioGroup.tenant":"Luvat","page.reports.customer.title":"Valitse asiakas","page.reports.customer.label":"Asiakas","page.reports.customer.all":"Kaikki","page.reports.range.title":"Valitse aikav\xe4li","page.reports.submit.button":"Lataa CSV-raportti","page.reports.toast.error.emptyReport":"Raporttia ei l\xf6ydy valituilla hakuehdoilla.","page.reports.toast.error.csvFailed":"Raportin muodostus ep\xe4onnistui.","page.reports.daterange.start":"Alku","page.reports.daterange.end":"Loppu","page.users.title":"K\xe4ytt\xe4j\xe4","page.users.button.edit":"Muokkaa k\xe4ytt\xe4j\xe4\xe4","page.users.label.user":"Kirjautunut k\xe4ytt\xe4j\xe4","page.users.label.emailConfirmed":"S\xe4hk\xf6posti vahvistettu","page.users.modalChangePassword.title":"Vaihda salasana","page.users.modalChangePassword.button.add":"Vaihda","page.users.modalChangePassword.action.changed":"Salasana vaihdettu.","page.users.formPassword.errors.password":"Uusi ja vahvistettu salasana pit\xe4\xe4 olla sama.","page.users.formPassword.label.oldPassword":"Nykyinen salasana","page.users.formPassword.label.newPassword":"Uusi salasana","page.users.formPassword.label.confirmNewPassword":"Vahvista uusi salasana","moovyParkingEnforcementStatus.no":"Ei valvontaa","moovyParkingEnforcementStatus.yes":"Valvonnan piiriss\xe4","timeStampItems.createdAt":"Luotu:","timeStampItems.updatedAt":"P\xe4ivitetty:","page.offering.modalCreateCatalogue.title":"Luo lupasopimus","page.offering.modalCreateCatalogue.grantedTo":"Kenelle luvat my\xf6nnet\xe4\xe4n?","page.offering.modalCreateCatalogue.grantedTo.customer":"Asiakkaalle","page.offering.modalCreateCatalogue.grantedTo.self":"Omalle yritykselle","page.offering.modalCreateCatalogue.customerLabel":"Asiakkaan tiedot","page.offering.modalCreateCatalogue.customerName":"Organisaation nimi","page.offering.modalCreateCatalogue.businessId":"Y-tunnus","page.offering.modalCreateCatalogue.project":"Projekti","page.offering.modalCreateCatalogue.costCenter":"Kustannuspaikka","page.offering.modalCreateCatalogue.streetAddress":"Postiosoite","page.offering.modalCreateCatalogue.postalCode":"Postinumero","page.offering.modalCreateCatalogue.city":"Postitoimipaikka","page.offering.modalCreateCatalogue.offering":"My\xf6nnett\xe4v\xe4 lupatuote","page.offering.modalCreateCatalogue.catalogueName":"Lupasopimuksen nimi","page.offering.modalCreateCatalogue.name":"Nimi","page.offering.modalCreateCatalogue.amount":"M\xe4\xe4r\xe4","page.offering.modalCreateCatalogue.amount.minimum":"Arvon on oltava 0 tai suurempi","page.offering.modalCreateCatalogue.allowVehicleGrant":"Salli luvan my\xf6nt\xe4minen ajoneuvoille","page.offering.modalCreateCatalogue.mutation.success":"Lupasopimuksen lis\xe4ys onnistui","page.offering.modalCreateCatalogue.mutation.conflict":"My\xf6nnett\xe4vien lupien m\xe4\xe4r\xe4 ei voi ylitt\xe4\xe4 tuotteen kokonaislupam\xe4\xe4r\xe4\xe4.","page.offering.modalEditOffering.title":"Muokkaa tarjoomaa","page.offering.modalEditOffering.product":"Tuote","page.offering.modalEditOffering.amountLabel":"Tarjooma yhteens\xe4","page.offering.modalEditOffering.amount.minimum":"Arvon on oltava 0 tai suurempi","page.offering.modalEditOffering.mutation.success":"Tarjooman p\xe4ivitys onnistui","page.offering.modalEditCatalogue.title":"Muokkaa sopimusta","page.offering.modalEditCatalogue.catalogueName":"Lupasopimuksen nimi","page.offering.modalEditCatalogue.customer":"Asiakas","page.offering.modalEditCatalogue.offering":"My\xf6nnett\xe4v\xe4 lupatuote","page.offering.modalEditCatalogue.amountLabel":"My\xf6nnett\xe4vien lupien m\xe4\xe4r\xe4","page.offering.modalEditCatalogue.amount.minimum":"Arvon on oltava 0 tai suurempi","page.offering.modalEditCatalogue.mutation.success":"Sopimuksen p\xe4ivitys onnistui","modalEditVehicle.title":"Muokkaa luvan ajoneuvoa","modalEditVehicle.webshopWarning":"Verkkokauppasopimuksen lupaa ei voi muokata","modalEditVehicle.actions.change":"Ajoneuvon rekisteritunnus vaihdettu","modalEditVehicle.actions.rightEnded":"Lupa irtisanottu","modalEditVehicle.actions.error.end":"Irtisanominen ep\xe4onnistui","modalEditVehicle.modalRemove.header":"Irtisano lupa?","modalEditVehicle.modalRemove.content":"Haluatko varmasti irtisanoa luvan ajoneuvolta {licensePlate}?","modalEditVehicle.modalRemove.content.endReason":"Kommentti","modalEditVehicle.modalRemove.content.endReason.placeholder":"Kommentti irtisanomisen syyst\xe4","moovySortAndFilter.sortingCriteria":"Lajittele","allocatedRights.available":"My\xf6nnett\xe4viss\xe4:","allocatedRights.rightsGranted":"Lupia my\xf6nnetty:","allocatedRights.rightsShared":"Lupia jaettu:","allocatedRights.rightsTotal":"Lupia yhteens\xe4:","page.right.title":"Pys\xe4k\xf6intilupa","page.right.container.title":"Luvan tiedot","page.right.start":"Alkoi","page.right.end":"P\xe4\xe4ttyi","page.right.licensePlate":"Rekisteritunnus","page.right.place":"Kohde","page.right.catalogue":"Lupasopimus","page.right.individual":"Luvanhaltija","page.right.costCenter":"Kustannuspaikka","page.right.project":"Projekti","page.right.endReason":"Irtisanomisen kommentti","page.right.active":"Aktiivinen"}');


var $04160ba6444a8781$exports = {};
$04160ba6444a8781$exports = JSON.parse('{"Account recovery requires verified contact information":"Account recovery requires verified contact information","Add your Profile":"Add your Profile","Add your Website":"Add your Website","Back to Sign In":"Back to Sign In","Change Password":"Change Password","Changing":"Changing","Code":"Code","Confirm Password":"Confirm Password","Confirm Sign Up":"Confirm Sign Up","Confirm SMS Code":"Confirm SMS Code","Confirm TOTP Code":"Confirm TOTP Code","Confirm":"Confirm","Confirmation Code":"Confirmation Code","Confirming":"Confirming","Create a new account":"Create a new account","Create Account":"Create Account","Creating Account":"Creating Account","Dismiss alert":"Dismiss alert","Given Name":"First Name","Family Name":"Last Name","Name":"Name","Email":"Email","Enter your Birthdate":"Enter your Birthdate","Enter your code":"Enter your code","Enter your Confirmation Code":"Enter your Confirmation Code","Enter your Email":"Enter your Email","Enter your Family Name":"Enter your Family Name","Enter your Given Name":"Enter your Given Name","Enter your Middle Name":"Enter your Middle Name","Enter your Name":"Enter your Name","Enter your Nickname":"Enter your Nickname","Enter your Password":"Enter your Password","Enter your phone number":"Enter your phone number","Enter your Preferred Username":"Enter your Preferred Username","Enter your username":"Enter your username","Forgot password?":"Forgot password?","Forgot your password?":"Forgot your password?","Hide password":"Hide password","It may take a minute to arrive":"It may take a minute to arrive","Loading":"Loading","New password":"New password","New Password":"New Password","or":"or","Password":"Password","Phone Number":"Phone Number","Please confirm your Password":"Please confirm your Password","Resend Code":"Resend Code","Reset your password":"Reset your password","Reset your Password":"Reset your Password","Reset Password":"Reset password","Enter your email":"Enter your email","Code *":"Code *","Send code":"Send code","Send Code":"Send Code","Sending":"Sending","Setup TOTP":"Setup TOTP","Show password":"Show password","Sign in to your account":"Sign in to your account","Sign In with Amazon":"Sign In with Amazon","Sign In with Apple":"Sign In with Apple","Sign In with Facebook":"Sign In with Facebook","Sign In with Google":"Sign In with Google","Sign in":"Sign in","Sign In":"Sign in","Signing in":"Signing in","Skip":"Skip","Submit":"Submit","Submitting":"Submitting","Username":"Username","Verify Contact":"Verify Contact","Verify":"Verify","We Emailed You":"We Emailed You","We Sent A Code":"We Sent A Code","We Texted You":"We Texted You","Your code is on the way. To log in, enter the code we emailed to":"Your code is on the way. To log in, enter the code we emailed to","Your code is on the way. To log in, enter the code we sent you":"Your code is on the way. To log in, enter the code we sent you","Your code is on the way. To log in, enter the code we texted to":"Your code is on the way. To log in, enter the code we texted to","User does not exist.":"User does not exist.","Incorrect username or password.":"Incorrect username or password.","Your passwords must match":"Your passwords must match.","Password must have at least 8 characters":"Password must have at least 8 characters.","An account with the given email already exists.":"An account with the given email already exists.","Invalid verification code provided, please try again.":"Invalid verification code provided, please try again.","Password does not conform to policy: Password must have uppercase characters":"Password does not conform to policy: Password must have uppercase characters.","Attempt limit exceeded, please try after some time.":"Attempt limit exceeded, please try after some time.","Username/client id combination not found.":"Username or password is invalid."}');


var $12dcb28924c77558$exports = {};
$12dcb28924c77558$exports = JSON.parse('{"Account recovery requires verified contact information":"Tilin palauttaminen vaatii vahvistetut yhteystiedot","Add your Profile":"Lis\xe4\xe4 profiili","Add your Website":"Lis\xe4\xe4 www-sivu","Back to Sign In":"Takaisin kirjautumiseen","Change Password":"Vaihda salasana","Changing":"Vaihdetaan","Code":"Koodi","Confirm Password":"Vahvista salasana","Confirm Sign Up":"Vahvista tilin luonti","Confirm SMS Code":"Vahvista SMS -koodi","Confirm TOTP Code":"Vahvista TOTP -koodi","Confirm":"Vahvista","Confirmation Code":"Vahvistuskoodi","Confirming":"Vahvistetaan","Create a new account":"Luo uusi tili","Create Account":"Luo tili","Creating Account":"Tili\xe4 luodaan","Dismiss alert":"Hylk\xe4\xe4 ilmoitukset","Given Name":"Etunimi","Family Name":"Sukunimi","Name":"Nimi","Email":"S\xe4hk\xf6posti","Enter your Birthdate":"Sy\xf6t\xe4 syntym\xe4p\xe4iv\xe4","Enter your code":"Sy\xf6t\xe4 koodi","Enter your Confirmation Code":"Sy\xf6t\xe4 vahvistuskoodi","Enter your Email":"Sy\xf6t\xe4 s\xe4hk\xf6posti","Enter your Family Name":"Sy\xf6t\xe4 sukunimi","Enter your Given Name":"Sy\xf6t\xe4 nimi","Enter your Middle Name":"Sy\xf6t\xe4 toinen nimi","Enter your Name":"Sy\xf6t\xe4 nimi","Enter your Nickname":"Sy\xf6t\xe4 lempinimi","Enter your Password":"Sy\xf6t\xe4 salasana","Enter your phone number":"Sy\xf6t\xe4 puhelinnumero","Enter your Preferred Username":"Sy\xf6t\xe4 ensisijainen k\xe4ytt\xe4j\xe4nimi","Enter your username":"Sy\xf6t\xe4 k\xe4ytt\xe4j\xe4nimi","Forgot password?":"Unohtuiko salasana?","Forgot your password?":"Unohtuiko salasana?","Hide password":"Piilota salasana","It may take a minute to arrive":"Saapuminen voi kest\xe4\xe4 minuutin","Loading":"Ladataan","New password":"Uusi salasana","New Password":"Uusi salasana","or":"tai","Password":"Salasana","Phone Number":"Puhelinnumero","Please confirm your Password":"Vahvista salasana","Resend Code":"L\xe4het\xe4 koodi uudestaan","Reset your password":"Nollaa salasana","Reset your Password":"Nollaa salasana","Reset Password":"Nollaa salasana","Enter your email":"Sy\xf6t\xe4 s\xe4hk\xf6postiosoite","Code *":"Koodi *","Send code":"L\xe4het\xe4 koodi","Send Code":"L\xe4het\xe4 koodi","Sending":"L\xe4hetet\xe4\xe4n","Setup TOTP":"Aseta TOTP","Show password":"N\xe4yt\xe4 salasana","Sign in to your account":"Kirjaudu tiliin","Sign In with Amazon":"Kirjaudu Amazon -tilill\xe4","Sign In with Apple":"Kirjaudu Apple -tilill\xe4","Sign In with Facebook":"Kirjaudu Facebook -tilill\xe4","Sign In with Google":"Kirjaudu Google -tilill\xe4","Sign in":"Kirjaudu sis\xe4\xe4n","Sign In":"Kirjaudu sis\xe4\xe4n","Signing in":"Kirjaudutaan sis\xe4\xe4n","Skip":"Ohita","Submit":"Hyv\xe4ksy","Submitting":"Hyv\xe4ksyt\xe4\xe4n","Username":"K\xe4ytt\xe4j\xe4nimi","Verify Contact":"Vahvista yhteystieto","Verify":"Vahvista","We Emailed You":"L\xe4hetimme sinulle s\xe4hk\xf6postia","We Sent A Code":"L\xe4hetimme sinulle koodin","We Texted You":"L\xe4hetimme sinulle viestin","Your code is on the way. To log in, enter the code we emailed to":"Koodisi on matkalla sinulle. Kirjaudu sis\xe4\xe4n s\xe4hk\xf6postiisi l\xe4hetetyll\xe4 koodilla","Your code is on the way. To log in, enter the code we sent you":"Koodisi on matkalla sinulle. Kirjaudu sis\xe4\xe4n sinulle l\xe4hetetyll\xe4 koodilla","Your code is on the way. To log in, enter the code we texted to":"Koodisi on matkalla sinulle. Kirjaudu sis\xe4\xe4n sinulle l\xe4hetetyll\xe4 koodilla","User does not exist.":"K\xe4ytt\xe4j\xe4\xe4 ei ole olemassa.","Incorrect username or password.":"Virheellinen k\xe4ytt\xe4j\xe4nimi tai salasana.","Your passwords must match":"Salasanojen pit\xe4\xe4 olla samoja.","Password must have at least 8 characters":"Salasanassa pit\xe4\xe4 olla v\xe4hint\xe4\xe4n 8 merkki\xe4.","An account with the given email already exists.":"Samalla s\xe4hk\xf6postilla on jo tili olemassa.","Invalid verification code provided, please try again.":"Virheellinen vahvistuskoodi, yrit\xe4 uudelleen.","Password does not conform to policy: Password must have uppercase characters":"Salasana ei t\xe4yt\xe4 vaatimuksia. Salasanassa on oltava erikoismerkkej\xe4.","Attempt limit exceeded, please try after some time.":"Maksimim\xe4\xe4r\xe4 yrityksi\xe4 saavutettu, yrit\xe4 uudelleen hetken kuluttua.","Username/client id combination not found.":"K\xe4ytt\xe4j\xe4nimi tai salasana on virheellinen."}');


const $8dd6473b0029aaad$export$bc99aaabaf7b70a7 = {
    en: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($97aaded26ba6aa05$exports)))
    },
    fi: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($8b533e8983d1c054$exports)))
    }
};
const $8dd6473b0029aaad$export$d2223424998443a9 = {
    en: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($04160ba6444a8781$exports)))
    },
    fi: {
        translation: (0, (/*@__PURE__*/$parcel$interopDefault($12dcb28924c77558$exports)))
    }
};
const $8dd6473b0029aaad$var$localizationResources = {
    resources: $8dd6473b0029aaad$export$bc99aaabaf7b70a7,
    loginResources: $8dd6473b0029aaad$export$d2223424998443a9
};
var $8dd6473b0029aaad$export$2e2bcd8739ae039 = $8dd6473b0029aaad$var$localizationResources;


const $5ce8806ad70988a5$export$864b6a9fa5df87b6 = "moovyLocale";
const $5ce8806ad70988a5$export$cb43794bb023e720 = "moovyAuthToken";
const $5ce8806ad70988a5$export$85978fd627e990d0 = "moovyType";
const $5ce8806ad70988a5$export$464bac997a211baf = "moovyCustomerInit";
const $5ce8806ad70988a5$export$fbb0f21f223dce54 = "moovyCustomerId";
const $5ce8806ad70988a5$export$ad6b2753bfb86074 = "moovyCustomerName";
const $5ce8806ad70988a5$export$7590792a37b51514 = "moovyPlaceId";
const $5ce8806ad70988a5$export$fa52eabe6f966a70 = "moovyPlaceName";
const $5ce8806ad70988a5$export$738e7ce102bdae66 = "moovyCatalogueId";


// Use same localStorage key as Redux to ensure consistent initialization
const $78378c3af696644c$var$storedLocale = localStorage.getItem((0, $5ce8806ad70988a5$export$864b6a9fa5df87b6)) || "fi";
(0, $cb97a690af83ab73$export$2e2bcd8739ae039).use((0, $e3c91a34ff524c8f$export$ae7e14d40d89f296)).init({
    debug: false,
    lng: $78378c3af696644c$var$storedLocale,
    fallbackLng: "fi",
    interpolation: {
        escapeValue: false // not needed for react as it escapes by default
    },
    resources: $8dd6473b0029aaad$export$bc99aaabaf7b70a7
});
var $78378c3af696644c$export$2e2bcd8739ae039 = (0, $cb97a690af83ab73$export$2e2bcd8739ae039);


function $2366596acf6620df$export$b007d77a962aa175({ expiresAt: expiresAt, clockDrift: clockDrift }) {
    const currentTime = Date.now();
    return currentTime + clockDrift > expiresAt;
}
class $2366596acf6620df$export$eeff9d1a8b8c057b {
    constructor(){}
    /**
     * Configure Auth category
     *
     * @internal
     *
     * @param authResourcesConfig - Resources configurations required by Auth providers.
     * @param authOptions - Client options used by library
     *
     * @returns void
     */ configure(authResourcesConfig, authOptions) {
        this.authConfig = authResourcesConfig;
        this.authOptions = authOptions;
    }
    async fetchAuthSession(options = {}) {
        let tokens;
        let credentialsAndIdentityId;
        let userSub;
        // Get tokens will throw if session cannot be refreshed (network or service error) or return null if not available
        tokens = await this.getTokens(options);
        if (tokens) {
            userSub = tokens.accessToken?.payload?.sub;
            // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
            credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
                authConfig: this.authConfig,
                tokens: tokens,
                authenticated: true,
                forceRefresh: options.forceRefresh
            });
        } else // getCredentialsAndIdentityId will throw if cannot get credentials (network or service error)
        credentialsAndIdentityId = await this.authOptions?.credentialsProvider?.getCredentialsAndIdentityId({
            authConfig: this.authConfig,
            authenticated: false,
            forceRefresh: options.forceRefresh
        });
        return {
            tokens: tokens,
            credentials: credentialsAndIdentityId?.credentials,
            identityId: credentialsAndIdentityId?.identityId,
            userSub: userSub
        };
    }
    async clearCredentials() {
        if (this.authOptions?.credentialsProvider) return await this.authOptions.credentialsProvider.clearCredentialsAndIdentityId();
    }
    async getTokens(options) {
        return await this.authOptions?.tokenProvider?.getTokens(options) ?? undefined;
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $67b136e3c96d1dfb$export$a0472aa3a356446c;
(function(LogType) {
    LogType["DEBUG"] = "DEBUG";
    LogType["ERROR"] = "ERROR";
    LogType["INFO"] = "INFO";
    LogType["WARN"] = "WARN";
    LogType["VERBOSE"] = "VERBOSE";
})($67b136e3c96d1dfb$export$a0472aa3a356446c || ($67b136e3c96d1dfb$export$a0472aa3a356446c = {}));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Logging constants
const $c041c09c03ca0a16$export$13470c6f1642bbce = "Logging";
const $c041c09c03ca0a16$export$16032fc466434892 = "x-amz-user-agent";
// Error exception code constants
const $c041c09c03ca0a16$export$86d53207c3c20049 = "NoHubcallbackProvidedException";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $b5731988345712b1$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5
};
/**
 * Write logs
 * @class Logger
 */ class $b5731988345712b1$export$ba6a9c7ac8291f7f {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ constructor(name, level = (0, $67b136e3c96d1dfb$export$a0472aa3a356446c).WARN){
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    _padding(n) {
        return n < 10 ? "0" + n : "" + n;
    }
    _ts() {
        const dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(":") + "." + dt.getMilliseconds();
    }
    configure(config) {
        if (!config) return this._config;
        this._config = config;
        return this._config;
    }
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LogType|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ _log(type, ...msg) {
        let logger_level_name = this.level;
        if ($b5731988345712b1$export$ba6a9c7ac8291f7f.LOG_LEVEL) logger_level_name = $b5731988345712b1$export$ba6a9c7ac8291f7f.LOG_LEVEL;
        if (typeof window !== "undefined" && window.LOG_LEVEL) logger_level_name = window.LOG_LEVEL;
        const logger_level = $b5731988345712b1$var$LOG_LEVELS[logger_level_name];
        const type_level = $b5731988345712b1$var$LOG_LEVELS[type];
        if (!(type_level >= logger_level)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        let log = console.log.bind(console);
        if (type === (0, $67b136e3c96d1dfb$export$a0472aa3a356446c).ERROR && console.error) log = console.error.bind(console);
        if (type === (0, $67b136e3c96d1dfb$export$a0472aa3a356446c).WARN && console.warn) log = console.warn.bind(console);
        const prefix = `[${type}] ${this._ts()} ${this.name}`;
        let message = "";
        if (msg.length === 1 && typeof msg[0] === "string") {
            message = `${prefix} - ${msg[0]}`;
            log(message);
        } else if (msg.length === 1) {
            message = `${prefix} ${msg[0]}`;
            log(prefix, msg[0]);
        } else if (typeof msg[0] === "string") {
            let obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            message = `${prefix} - ${msg[0]} ${obj}`;
            log(`${prefix} - ${msg[0]}`, obj);
        } else {
            message = `${prefix} ${msg}`;
            log(prefix, msg);
        }
        for (const plugin of this._pluggables){
            const logEvent = {
                message: message,
                timestamp: Date.now()
            };
            plugin.pushLogs([
                logEvent
            ]);
        }
    }
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ log(...msg) {
        this._log((0, $67b136e3c96d1dfb$export$a0472aa3a356446c).INFO, ...msg);
    }
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ info(...msg) {
        this._log((0, $67b136e3c96d1dfb$export$a0472aa3a356446c).INFO, ...msg);
    }
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ warn(...msg) {
        this._log((0, $67b136e3c96d1dfb$export$a0472aa3a356446c).WARN, ...msg);
    }
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ error(...msg) {
        this._log((0, $67b136e3c96d1dfb$export$a0472aa3a356446c).ERROR, ...msg);
    }
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ debug(...msg) {
        this._log((0, $67b136e3c96d1dfb$export$a0472aa3a356446c).DEBUG, ...msg);
    }
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ verbose(...msg) {
        this._log((0, $67b136e3c96d1dfb$export$a0472aa3a356446c).VERBOSE, ...msg);
    }
    addPluggable(pluggable) {
        if (pluggable && pluggable.getCategoryName() === (0, $c041c09c03ca0a16$export$13470c6f1642bbce)) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    }
    listPluggables() {
        return this._pluggables;
    }
}
$b5731988345712b1$export$ba6a9c7ac8291f7f.LOG_LEVEL = null;



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $b4bc1e3f37fada93$export$37321a6dace1881c extends Error {
    /**
     *  Constructs an AmplifyError.
     *
     * @param message text that describes the main problem.
     * @param underlyingError the underlying cause of the error.
     * @param recoverySuggestion suggestion to recover from the error.
     *
     */ constructor({ message: message, name: name, recoverySuggestion: recoverySuggestion, underlyingError: underlyingError }){
        super(message);
        this.name = name;
        this.underlyingError = underlyingError;
        this.recoverySuggestion = recoverySuggestion;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $b4bc1e3f37fada93$export$37321a6dace1881c;
        Object.setPrototypeOf(this, $b4bc1e3f37fada93$export$37321a6dace1881c.prototype);
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2f4552e504bc473c$export$aadf71dd9875dd20 = typeof Symbol !== "undefined" ? Symbol("amplify_default") : "@@amplify_default";
const $2f4552e504bc473c$var$logger = new (0, $b5731988345712b1$export$ba6a9c7ac8291f7f)("Hub");
class $2f4552e504bc473c$export$6b38ef2be9abbbb9 {
    constructor(name){
        this.listeners = new Map();
        this.protectedChannels = [
            "core",
            "auth",
            "api",
            "analytics",
            "interactions",
            "pubsub",
            "storage",
            "ui",
            "xr"
        ];
        this.name = name;
    }
    /**
     * Used internally to remove a Hub listener.
     *
     * @remarks
     * This private method is for internal use only. Instead of calling Hub.remove, call the result of Hub.listen.
     */ _remove(channel, listener) {
        const holder = this.listeners.get(channel);
        if (!holder) {
            $2f4552e504bc473c$var$logger.warn(`No listeners for ${channel}`);
            return;
        }
        this.listeners.set(channel, [
            ...holder.filter(({ callback: callback })=>callback !== listener)
        ]);
    }
    dispatch(channel, payload, source, ampSymbol) {
        if (typeof channel === "string" && this.protectedChannels.indexOf(channel) > -1) {
            const hasAccess = ampSymbol === $2f4552e504bc473c$export$aadf71dd9875dd20;
            if (!hasAccess) $2f4552e504bc473c$var$logger.warn(`WARNING: ${channel} is protected and dispatching on it can have unintended consequences`);
        }
        const capsule = {
            channel: channel,
            payload: {
                ...payload
            },
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $2f4552e504bc473c$var$logger.error(e);
        }
    }
    listen(channel, callback, listenerName = "noname") {
        let cb;
        if (typeof callback !== "function") throw new (0, $b4bc1e3f37fada93$export$37321a6dace1881c)({
            name: (0, $c041c09c03ca0a16$export$86d53207c3c20049),
            message: "No callback supplied to Hub"
        });
        else // Needs to be casted as a more generic type
        cb = callback;
        let holder = this.listeners.get(channel);
        if (!holder) {
            holder = [];
            this.listeners.set(channel, holder);
        }
        holder.push({
            name: listenerName,
            callback: cb
        });
        return ()=>{
            this._remove(channel, cb);
        };
    }
    _toListeners(capsule) {
        const { channel: channel, payload: payload } = capsule;
        const holder = this.listeners.get(channel);
        if (holder) holder.forEach((listener)=>{
            $2f4552e504bc473c$var$logger.debug(`Dispatching to ${channel} with `, payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $2f4552e504bc473c$var$logger.error(e);
            }
        });
    }
}
/*We export a __default__ instance of HubClass to use it as a
pseudo Singleton for the main messaging bus, however you can still create
your own instance of HubClass() for a separate "private bus" of events.*/ const $2f4552e504bc473c$export$8c41bb232f1008b1 = new $2f4552e504bc473c$export$6b38ef2be9abbbb9("__default__");
/**
 * @internal
 *
 * Internal hub used for core Amplify functionality. Not intended for use outside of Amplify.
 *
 */ const $2f4552e504bc473c$export$45dde0743a4c8d6e = new $2f4552e504bc473c$export$6b38ef2be9abbbb9("internal-hub");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0f9580331e403073$var$logger = new (0, $b5731988345712b1$export$ba6a9c7ac8291f7f)("parseAWSExports");
const $0f9580331e403073$var$authTypeMapping = {
    API_KEY: "apiKey",
    AWS_IAM: "iam",
    AMAZON_COGNITO_USER_POOLS: "userPool",
    OPENID_CONNECT: "oidc",
    NONE: "none",
    LAMBDA: "lambda"
};
/**
 * This utility converts the `aws-exports.js` file generated by the Amplify CLI into a {@link ResourcesConfig} object
 * consumable by Amplify.
 *
 * @param config A configuration object from `aws-exports.js`.
 *
 * @returns A {@link ResourcesConfig} object.
 */ const $0f9580331e403073$export$1ef2e9c2da492d = (config = {})=>{
    const { aws_appsync_apiKey: aws_appsync_apiKey, aws_appsync_authenticationType: aws_appsync_authenticationType, aws_appsync_graphqlEndpoint: aws_appsync_graphqlEndpoint, aws_appsync_region: aws_appsync_region, aws_bots: aws_bots, aws_bots_config: aws_bots_config, aws_cognito_identity_pool_id: aws_cognito_identity_pool_id, aws_cognito_sign_up_verification_method: aws_cognito_sign_up_verification_method, aws_cognito_mfa_configuration: aws_cognito_mfa_configuration, aws_cognito_mfa_types: aws_cognito_mfa_types, aws_cognito_password_protection_settings: aws_cognito_password_protection_settings, aws_cognito_verification_mechanisms: aws_cognito_verification_mechanisms, aws_cognito_signup_attributes: aws_cognito_signup_attributes, aws_cognito_social_providers: aws_cognito_social_providers, aws_cognito_username_attributes: aws_cognito_username_attributes, aws_mandatory_sign_in: aws_mandatory_sign_in, aws_mobile_analytics_app_id: aws_mobile_analytics_app_id, aws_mobile_analytics_app_region: aws_mobile_analytics_app_region, aws_user_files_s3_bucket: aws_user_files_s3_bucket, aws_user_files_s3_bucket_region: aws_user_files_s3_bucket_region, aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing, aws_user_pools_id: aws_user_pools_id, aws_user_pools_web_client_id: aws_user_pools_web_client_id, geo: geo, oauth: oauth, predictions: predictions, aws_cloud_logic_custom: aws_cloud_logic_custom, Notifications: Notifications, modelIntrospection: modelIntrospection } = config;
    const amplifyConfig = {};
    // Analytics
    if (aws_mobile_analytics_app_id) amplifyConfig.Analytics = {
        Pinpoint: {
            appId: aws_mobile_analytics_app_id,
            region: aws_mobile_analytics_app_region
        }
    };
    // Notifications
    const { InAppMessaging: InAppMessaging, Push: Push } = Notifications ?? {};
    if (InAppMessaging?.AWSPinpoint || Push?.AWSPinpoint) {
        if (InAppMessaging?.AWSPinpoint) {
            const { appId: appId, region: region } = InAppMessaging.AWSPinpoint;
            amplifyConfig.Notifications = {
                InAppMessaging: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
        if (Push?.AWSPinpoint) {
            const { appId: appId, region: region } = Push.AWSPinpoint;
            amplifyConfig.Notifications = {
                PushNotification: {
                    Pinpoint: {
                        appId: appId,
                        region: region
                    }
                }
            };
        }
    }
    // Interactions
    if (Array.isArray(aws_bots_config)) amplifyConfig.Interactions = {
        LexV1: Object.fromEntries(aws_bots_config.map((bot)=>[
                bot.name,
                bot
            ]))
    };
    // API
    if (aws_appsync_graphqlEndpoint) {
        const defaultAuthMode = $0f9580331e403073$var$authTypeMapping[aws_appsync_authenticationType];
        if (!defaultAuthMode) $0f9580331e403073$var$logger.debug(`Invalid authentication type ${aws_appsync_authenticationType}. Falling back to IAM.`);
        amplifyConfig.API = {
            GraphQL: {
                endpoint: aws_appsync_graphqlEndpoint,
                apiKey: aws_appsync_apiKey,
                region: aws_appsync_region,
                defaultAuthMode: defaultAuthMode ?? "iam"
            }
        };
        if (modelIntrospection) amplifyConfig.API.GraphQL.modelIntrospection = modelIntrospection;
    }
    // Auth
    const mfaConfig = aws_cognito_mfa_configuration ? {
        status: aws_cognito_mfa_configuration && aws_cognito_mfa_configuration.toLowerCase(),
        totpEnabled: aws_cognito_mfa_types?.includes("TOTP") ?? false,
        smsEnabled: aws_cognito_mfa_types?.includes("SMS") ?? false
    } : undefined;
    const passwordFormatConfig = aws_cognito_password_protection_settings ? {
        minLength: aws_cognito_password_protection_settings.passwordPolicyMinLength,
        requireLowercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_LOWERCASE") ?? false,
        requireUppercase: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_UPPERCASE") ?? false,
        requireNumbers: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_NUMBERS") ?? false,
        requireSpecialCharacters: aws_cognito_password_protection_settings.passwordPolicyCharacters?.includes("REQUIRES_SYMBOLS") ?? false
    } : undefined;
    const mergedUserAttributes = Array.from(new Set([
        ...aws_cognito_verification_mechanisms ?? [],
        ...aws_cognito_signup_attributes ?? []
    ]));
    const userAttributesConfig = mergedUserAttributes.map((s)=>({
            [s.toLowerCase()]: {
                required: true
            }
        }));
    const loginWithEmailEnabled = aws_cognito_username_attributes?.includes("EMAIL") ?? false;
    const loginWithPhoneEnabled = aws_cognito_username_attributes?.includes("PHONE_NUMBER") ?? false;
    if (aws_cognito_identity_pool_id || aws_user_pools_id) amplifyConfig.Auth = {
        Cognito: {
            identityPoolId: aws_cognito_identity_pool_id,
            allowGuestAccess: aws_mandatory_sign_in !== "enable",
            signUpVerificationMethod: aws_cognito_sign_up_verification_method,
            userAttributes: userAttributesConfig,
            userPoolClientId: aws_user_pools_web_client_id,
            userPoolId: aws_user_pools_id,
            mfa: mfaConfig,
            passwordFormat: passwordFormatConfig,
            loginWith: {
                username: loginWithEmailEnabled || loginWithPhoneEnabled ? false : true,
                email: loginWithEmailEnabled,
                phone: loginWithPhoneEnabled
            }
        }
    };
    const hasOAuthConfig = oauth ? Object.keys(oauth).length > 0 : false;
    const hasSocialProviderConfig = aws_cognito_social_providers ? aws_cognito_social_providers.length > 0 : false;
    if (amplifyConfig.Auth && hasOAuthConfig) amplifyConfig.Auth.Cognito.loginWith = {
        ...amplifyConfig.Auth.Cognito.loginWith,
        oauth: {
            ...$0f9580331e403073$var$getOAuthConfig(oauth),
            ...hasSocialProviderConfig && {
                providers: $0f9580331e403073$var$parseSocialProviders(aws_cognito_social_providers)
            }
        }
    };
    // Storage
    if (aws_user_files_s3_bucket) amplifyConfig.Storage = {
        S3: {
            bucket: aws_user_files_s3_bucket,
            region: aws_user_files_s3_bucket_region,
            dangerouslyConnectToHttpEndpointForTesting: aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing
        }
    };
    // Geo
    if (geo) {
        const { amazon_location_service: amazon_location_service } = geo;
        amplifyConfig.Geo = amazon_location_service ? {
            LocationService: {
                ...amazon_location_service,
                searchIndices: amazon_location_service.search_indices,
                region: amazon_location_service.region
            }
        } : {
            ...geo
        };
    }
    // REST API
    if (aws_cloud_logic_custom) amplifyConfig.API = {
        ...amplifyConfig.API,
        REST: aws_cloud_logic_custom.reduce((acc, api)=>{
            const { name: name, endpoint: endpoint, region: region, service: service } = api;
            return {
                ...acc,
                [name]: {
                    endpoint: endpoint,
                    ...service ? {
                        service: service
                    } : undefined,
                    ...region ? {
                        region: region
                    } : undefined
                }
            };
        }, {})
    };
    // Predictions
    if (predictions) {
        // map VoiceId from speechGenerator defaults to voiceId
        const { VoiceId: voiceId } = predictions?.convert?.speechGenerator?.defaults ?? {};
        amplifyConfig.Predictions = voiceId ? {
            ...predictions,
            convert: {
                ...predictions.convert,
                speechGenerator: {
                    ...predictions.convert.speechGenerator,
                    defaults: {
                        voiceId: voiceId
                    }
                }
            }
        } : predictions;
    }
    return amplifyConfig;
};
const $0f9580331e403073$var$getRedirectUrl = (redirectStr)=>redirectStr?.split(",") ?? [];
const $0f9580331e403073$var$getOAuthConfig = ({ domain: domain, scope: scope, redirectSignIn: redirectSignIn, redirectSignOut: redirectSignOut, responseType: responseType })=>({
        domain: domain,
        scopes: scope,
        redirectSignIn: $0f9580331e403073$var$getRedirectUrl(redirectSignIn),
        redirectSignOut: $0f9580331e403073$var$getRedirectUrl(redirectSignOut),
        responseType: responseType
    });
const $0f9580331e403073$var$parseSocialProviders = (aws_cognito_social_providers)=>{
    return aws_cognito_social_providers.map((provider)=>{
        const updatedProvider = provider.toLowerCase();
        return updatedProvider.charAt(0).toUpperCase() + updatedProvider.slice(1);
    });
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $52168d7636f79904$export$7e32b29e1cb162e1 = (object)=>{
    const propNames = Reflect.ownKeys(object);
    for (const name of propNames){
        const value = object[name];
        if (value && typeof value === "object" || typeof value === "function") $52168d7636f79904$export$7e32b29e1cb162e1(value);
    }
    return Object.freeze(object);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $623ac757f0e7ef86$export$b412d755cfa0136 {
    constructor(){
        this.resourcesConfig = {};
        this.libraryOptions = {};
        this.Auth = new (0, $2366596acf6620df$export$eeff9d1a8b8c057b)();
    }
    /**
     * Configures Amplify for use with your back-end resources.
     *
     * @remarks
     * This API does not perform any merging of either `resourcesConfig` or `libraryOptions`. The most recently
     * provided values will be used after configuration.
     *
     * @remarks
     * `configure` can be used to specify additional library options where available for supported categories.
     *
     * @param resourceConfig - Back-end resource configuration. Typically provided via the `aws-exports.js` file.
     * @param libraryOptions - Additional options for customizing the behavior of the library.
     */ configure(resourcesConfig, libraryOptions) {
        let resolvedResourceConfig;
        if (Object.keys(resourcesConfig).some((key)=>key.startsWith("aws_"))) resolvedResourceConfig = (0, $0f9580331e403073$export$1ef2e9c2da492d)(resourcesConfig);
        else resolvedResourceConfig = resourcesConfig;
        this.resourcesConfig = resolvedResourceConfig;
        if (libraryOptions) this.libraryOptions = libraryOptions;
        // Make resource config immutable
        this.resourcesConfig = (0, $52168d7636f79904$export$7e32b29e1cb162e1)(this.resourcesConfig);
        this.Auth.configure(this.resourcesConfig.Auth, this.libraryOptions.Auth);
        (0, $2f4552e504bc473c$export$8c41bb232f1008b1).dispatch("core", {
            event: "configure",
            data: resourcesConfig
        }, "Configure", (0, $2f4552e504bc473c$export$aadf71dd9875dd20));
    }
    /**
     * Provides access to the current back-end resource configuration for the Library.
     *
     * @returns Returns the immutable back-end resource configuration.
     */ getConfig() {
        return this.resourcesConfig;
    }
}
/**
 * The `Amplify` utility is used to configure the library.
 *
 * @remarks
 * `Amplify` is responsible for orchestrating cross-category communication within the library.
 */ const $623ac757f0e7ef86$export$a3858a9a153cffc7 = new $623ac757f0e7ef86$export$b412d755cfa0136();

var $c9d61dbc78867beb$exports = {};
(function(global, factory) {
    $c9d61dbc78867beb$exports = factory();
})($c9d61dbc78867beb$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $c5e12087ef38fe79$export$dae7d845015939d5 {
    constructor(data = {}){
        const { path: path, domain: domain, expires: expires, sameSite: sameSite, secure: secure } = data;
        this.domain = domain;
        this.path = path ? path : "/";
        this.expires = data.hasOwnProperty("expires") ? expires : 365;
        this.secure = data.hasOwnProperty("secure") ? secure : true;
        if (data.hasOwnProperty("sameSite")) {
            if (!sameSite || ![
                "strict",
                "lax",
                "none"
            ].includes(sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = sameSite;
        }
    }
    async setItem(key, value) {
        (0, (/*@__PURE__*/$parcel$interopDefault($c9d61dbc78867beb$exports))).set(key, value, this.getData());
    }
    async getItem(key) {
        const item = (0, (/*@__PURE__*/$parcel$interopDefault($c9d61dbc78867beb$exports))).get(key);
        return item ?? null;
    }
    async removeItem(key) {
        (0, (/*@__PURE__*/$parcel$interopDefault($c9d61dbc78867beb$exports))).remove(key, this.getData());
    }
    async clear() {
        const cookie = (0, (/*@__PURE__*/$parcel$interopDefault($c9d61dbc78867beb$exports))).get();
        const promises = Object.keys(cookie).map((key)=>this.removeItem(key));
        await Promise.all(promises);
    }
    getData() {
        return {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure,
            ...this.sameSite && {
                sameSite: this.sameSite
            }
        };
    }
}

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $2cba3f44341f04f9$export$4e712df6b850c8d0;
(function(AmplifyErrorCode) {
    AmplifyErrorCode["NoEndpointId"] = "NoEndpointId";
    AmplifyErrorCode["PlatformNotSupported"] = "PlatformNotSupported";
    AmplifyErrorCode["Unknown"] = "Unknown";
})($2cba3f44341f04f9$export$4e712df6b850c8d0 || ($2cba3f44341f04f9$export$4e712df6b850c8d0 = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $a13939079a1b8b7e$export$f5362e8a6666a455 extends (0, $b4bc1e3f37fada93$export$37321a6dace1881c) {
    constructor(){
        super({
            name: (0, $2cba3f44341f04f9$export$4e712df6b850c8d0).PlatformNotSupported,
            message: "Function not supported on current platform"
        });
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $c8e72b3fda53153e$export$8536778e426ddf92 {
    constructor(storage){
        this.storage = storage;
    }
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ async setItem(key, value) {
        if (!this.storage) throw new (0, $a13939079a1b8b7e$export$f5362e8a6666a455)();
        this.storage.setItem(key, value);
    }
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ async getItem(key) {
        if (!this.storage) throw new (0, $a13939079a1b8b7e$export$f5362e8a6666a455)();
        return this.storage.getItem(key);
    }
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ async removeItem(key) {
        if (!this.storage) throw new (0, $a13939079a1b8b7e$export$f5362e8a6666a455)();
        this.storage.removeItem(key);
    }
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ async clear() {
        if (!this.storage) throw new (0, $a13939079a1b8b7e$export$f5362e8a6666a455)();
        this.storage.clear();
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $be8fcf03b75e4ab7$export$e4315e25b840a0ea {
    constructor(){
        this.storage = new Map();
    }
    get length() {
        return this.storage.size;
    }
    key(index) {
        if (index > this.length - 1) return null;
        return Array.from(this.storage.keys())[index];
    }
    setItem(key, value) {
        this.storage.set(key, value);
    }
    getItem(key) {
        return this.storage.get(key) ?? null;
    }
    removeItem(key) {
        this.storage.delete(key);
    }
    clear() {
        this.storage.clear();
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 * @returns Either a reference to window.localStorage or an in-memory storage as fallback
 */ const $027ea888e0ef038b$export$5d9abaf8ff62cd65 = ()=>typeof window !== "undefined" && window.localStorage ? window.localStorage : new (0, $be8fcf03b75e4ab7$export$e4315e25b840a0ea)();
/**
 * @internal
 * @returns Either a reference to window.sessionStorage or an in-memory storage as fallback
 */ const $027ea888e0ef038b$export$518dcc1598f87b = ()=>typeof window !== "undefined" && window.sessionStorage ? window.sessionStorage : new (0, $be8fcf03b75e4ab7$export$e4315e25b840a0ea)();


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $677ca08ed9accd87$export$bec45e7703e93690 extends (0, $c8e72b3fda53153e$export$8536778e426ddf92) {
    constructor(){
        super((0, $027ea888e0ef038b$export$5d9abaf8ff62cd65)());
    }
}






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ class $835055e14be4b3a5$export$2c4b17e1c2e0931 extends (0, $c8e72b3fda53153e$export$8536778e426ddf92) {
    constructor(){
        super((0, $027ea888e0ef038b$export$518dcc1598f87b)());
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $68ccea2c33038f88$export$586b30dcaeecb901 = new (0, $677ca08ed9accd87$export$bec45e7703e93690)();
const $68ccea2c33038f88$export$f119d83aa936d634 = new (0, $835055e14be4b3a5$export$2c4b17e1c2e0931)();
const $68ccea2c33038f88$export$41feb988b3a84f03 = new (0, $c8e72b3fda53153e$export$8536778e426ddf92)(new (0, $be8fcf03b75e4ab7$export$e4315e25b840a0ea)());





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $23ab74116aa7b356$export$5cb8fc27ccbe9d40 = (errorMap, AssertionError = (0, $b4bc1e3f37fada93$export$37321a6dace1881c))=>(assertion, name, additionalContext)=>{
        const { message: message, recoverySuggestion: recoverySuggestion } = errorMap[name];
        if (!assertion) throw new AssertionError({
            name: name,
            message: additionalContext ? `${message} ${additionalContext}` : message,
            recoverySuggestion: recoverySuggestion
        });
    };




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $b8c9f54d4b82e08b$export$7b5c8b570ea8407;
(function(AuthConfigurationErrorCode) {
    AuthConfigurationErrorCode["AuthTokenConfigException"] = "AuthTokenConfigException";
    AuthConfigurationErrorCode["AuthUserPoolAndIdentityPoolException"] = "AuthUserPoolAndIdentityPoolException";
    AuthConfigurationErrorCode["AuthUserPoolException"] = "AuthUserPoolException";
    AuthConfigurationErrorCode["InvalidIdentityPoolIdException"] = "InvalidIdentityPoolIdException";
    AuthConfigurationErrorCode["OAuthNotConfigureException"] = "OAuthNotConfigureException";
})($b8c9f54d4b82e08b$export$7b5c8b570ea8407 || ($b8c9f54d4b82e08b$export$7b5c8b570ea8407 = {}));
const $b8c9f54d4b82e08b$var$authConfigurationErrorMap = {
    [$b8c9f54d4b82e08b$export$7b5c8b570ea8407.AuthTokenConfigException]: {
        message: "Auth Token Provider not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app."
    },
    [$b8c9f54d4b82e08b$export$7b5c8b570ea8407.AuthUserPoolAndIdentityPoolException]: {
        message: "Auth UserPool or IdentityPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with UserPoolId and IdentityPoolId."
    },
    [$b8c9f54d4b82e08b$export$7b5c8b570ea8407.AuthUserPoolException]: {
        message: "Auth UserPool not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure in your app with userPoolId and userPoolClientId."
    },
    [$b8c9f54d4b82e08b$export$7b5c8b570ea8407.InvalidIdentityPoolIdException]: {
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    },
    [$b8c9f54d4b82e08b$export$7b5c8b570ea8407.OAuthNotConfigureException]: {
        message: "oauth param not configured.",
        recoverySuggestion: "Make sure to call Amplify.configure with oauth parameter in your app."
    }
};
const $b8c9f54d4b82e08b$export$a7a9523472993e97 = (0, $23ab74116aa7b356$export$5cb8fc27ccbe9d40)($b8c9f54d4b82e08b$var$authConfigurationErrorMap);





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ad119da6003ad7dd$export$e003cc239f955cb6 = ()=>{
    if (typeof window === "object" && typeof window.crypto === "object") return window.crypto;
    // Next.js global polyfill
    if (typeof crypto === "object") return crypto;
    throw new (0, $b4bc1e3f37fada93$export$37321a6dace1881c)({
        name: "MissingPolyfill",
        message: "Cannot resolve the `crypto` function from the environment."
    });
};
const $ad119da6003ad7dd$export$94f295707b435c6d = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.btoa === "function") return window.btoa;
    // Next.js global polyfill
    if (typeof btoa === "function") return btoa;
    throw new (0, $b4bc1e3f37fada93$export$37321a6dace1881c)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `btoa` function from the environment."
    });
};
const $ad119da6003ad7dd$export$ea737e7700106b27 = ()=>{
    // browser
    if (typeof window !== "undefined" && typeof window.atob === "function") return window.atob;
    // Next.js global polyfill
    if (typeof atob === "function") return atob;
    throw new (0, $b4bc1e3f37fada93$export$37321a6dace1881c)({
        name: "Base64EncoderError",
        message: "Cannot resolve the `atob` function from the environment."
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $fd3cc728f3bcf7d6$export$1e303d38dab7b376 = {
    convert (input) {
        return (0, $ad119da6003ad7dd$export$ea737e7700106b27)()(input);
    }
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $a6de0542b1980a7d$export$80c92581e59ed502(cognitoConfig) {
    let assertionValid = true; // assume valid until otherwise proveed
    if (!cognitoConfig) assertionValid = false;
    else assertionValid = !!cognitoConfig.userPoolId && !!cognitoConfig.userPoolClientId;
    return (0, $b8c9f54d4b82e08b$export$a7a9523472993e97)(assertionValid, (0, $b8c9f54d4b82e08b$export$7b5c8b570ea8407).AuthUserPoolException);
}
function $a6de0542b1980a7d$export$c13e6dbaf90a8e5f(cognitoConfig) {
    const validOAuthConfig = !!cognitoConfig?.loginWith?.oauth?.domain && !!cognitoConfig?.loginWith?.oauth?.redirectSignOut && !!cognitoConfig?.loginWith?.oauth?.redirectSignIn && !!cognitoConfig?.loginWith?.oauth?.responseType;
    return (0, $b8c9f54d4b82e08b$export$a7a9523472993e97)(validOAuthConfig, (0, $b8c9f54d4b82e08b$export$7b5c8b570ea8407).OAuthNotConfigureException);
}
function $a6de0542b1980a7d$export$8a2f5318ea3215e3(cognitoConfig) {
    const validConfig = !!cognitoConfig?.identityPoolId;
    return (0, $b8c9f54d4b82e08b$export$a7a9523472993e97)(validConfig, (0, $b8c9f54d4b82e08b$export$7b5c8b570ea8407).InvalidIdentityPoolIdException);
}
function $a6de0542b1980a7d$export$9a62e6c0a30e00bc(token) {
    const tokenParts = token.split(".");
    if (tokenParts.length !== 3) throw new Error("Invalid token");
    try {
        const base64WithUrlSafe = tokenParts[1];
        const base64 = base64WithUrlSafe.replace(/-/g, "+").replace(/_/g, "/");
        const jsonStr = decodeURIComponent((0, $fd3cc728f3bcf7d6$export$1e303d38dab7b376).convert(base64).split("").map((char)=>`%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`).join(""));
        const payload = JSON.parse(jsonStr);
        return {
            toString: ()=>token,
            payload: payload
        };
    } catch (err) {
        throw new Error("Invalid token payload");
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3dba1c13ad628da6$export$dad1700b96c3a835 = {
    identityId: "identityId"
};



const $5a6742e3c9584e8e$export$b8429d1428aad8ba = {
    accessToken: "accessToken",
    idToken: "idToken",
    oidcProvider: "oidcProvider",
    clockDrift: "clockDrift",
    refreshToken: "refreshToken",
    deviceKey: "deviceKey",
    randomPasswordKey: "randomPasswordKey",
    deviceGroupKey: "deviceGroupKey",
    signInDetails: "signInDetails"
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $f3f3005c274c9374$export$145273558d58e0ac extends (0, $b4bc1e3f37fada93$export$37321a6dace1881c) {
    constructor(params){
        super(params);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $f3f3005c274c9374$export$145273558d58e0ac;
        Object.setPrototypeOf(this, $f3f3005c274c9374$export$145273558d58e0ac.prototype);
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $d7b749d70ce64616$export$cc5909720f29144;
(function(TokenProviderErrorCode) {
    TokenProviderErrorCode["InvalidAuthTokens"] = "InvalidAuthTokens";
})($d7b749d70ce64616$export$cc5909720f29144 || ($d7b749d70ce64616$export$cc5909720f29144 = {}));
const $d7b749d70ce64616$var$tokenValidationErrorMap = {
    [$d7b749d70ce64616$export$cc5909720f29144.InvalidAuthTokens]: {
        message: "Invalid tokens.",
        recoverySuggestion: "Make sure the tokens are valid."
    }
};
const $d7b749d70ce64616$export$a7a9523472993e97 = (0, $23ab74116aa7b356$export$5cb8fc27ccbe9d40)($d7b749d70ce64616$var$tokenValidationErrorMap);


class $bf28e6bdff0fcfed$export$a36be852d43d512 {
    constructor(){
        this.name = "CognitoIdentityServiceProvider"; // To be backwards compatible with V5, no migration needed
    }
    getKeyValueStorage() {
        if (!this.keyValueStorage) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
            name: "KeyValueStorageNotFoundException",
            message: "KeyValueStorage was not found in TokenStore"
        });
        return this.keyValueStorage;
    }
    setKeyValueStorage(keyValueStorage) {
        this.keyValueStorage = keyValueStorage;
    }
    setAuthConfig(authConfig) {
        this.authConfig = authConfig;
    }
    async loadTokens() {
        // TODO(v6): migration logic should be here
        // Reading V5 tokens old format
        try {
            const authKeys = await this.getAuthKeys();
            const accessTokenString = await this.getKeyValueStorage().getItem(authKeys.accessToken);
            if (!accessTokenString) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
                name: "NoSessionFoundException",
                message: "Auth session was not found. Make sure to call signIn."
            });
            const accessToken = (0, $a6de0542b1980a7d$export$9a62e6c0a30e00bc)(accessTokenString);
            const itString = await this.getKeyValueStorage().getItem(authKeys.idToken);
            const idToken = itString ? (0, $a6de0542b1980a7d$export$9a62e6c0a30e00bc)(itString) : undefined;
            const refreshToken = await this.getKeyValueStorage().getItem(authKeys.refreshToken) ?? undefined;
            const clockDriftString = await this.getKeyValueStorage().getItem(authKeys.clockDrift) ?? "0";
            const clockDrift = Number.parseInt(clockDriftString);
            const signInDetails = await this.getKeyValueStorage().getItem(authKeys.signInDetails);
            const tokens = {
                accessToken: accessToken,
                idToken: idToken,
                refreshToken: refreshToken,
                deviceMetadata: await this.getDeviceMetadata() ?? undefined,
                clockDrift: clockDrift,
                username: await this.getLastAuthUser()
            };
            if (signInDetails) tokens.signInDetails = JSON.parse(signInDetails);
            return tokens;
        } catch (err) {
            return null;
        }
    }
    async storeTokens(tokens) {
        (0, $d7b749d70ce64616$export$a7a9523472993e97)(tokens !== undefined, (0, $d7b749d70ce64616$export$cc5909720f29144).InvalidAuthTokens);
        await this.clearTokens();
        const lastAuthUser = tokens.username;
        await this.getKeyValueStorage().setItem(this.getLastAuthUserKey(), lastAuthUser);
        const authKeys = await this.getAuthKeys();
        await this.getKeyValueStorage().setItem(authKeys.accessToken, tokens.accessToken.toString());
        if (!!tokens.idToken) await this.getKeyValueStorage().setItem(authKeys.idToken, tokens.idToken.toString());
        if (!!tokens.refreshToken) await this.getKeyValueStorage().setItem(authKeys.refreshToken, tokens.refreshToken);
        if (!!tokens.deviceMetadata) {
            if (tokens.deviceMetadata.deviceKey) await this.getKeyValueStorage().setItem(authKeys.deviceKey, tokens.deviceMetadata.deviceKey);
            if (tokens.deviceMetadata.deviceGroupKey) await this.getKeyValueStorage().setItem(authKeys.deviceGroupKey, tokens.deviceMetadata.deviceGroupKey);
            await this.getKeyValueStorage().setItem(authKeys.randomPasswordKey, tokens.deviceMetadata.randomPassword);
        }
        if (!!tokens.signInDetails) await this.getKeyValueStorage().setItem(authKeys.signInDetails, JSON.stringify(tokens.signInDetails));
        await this.getKeyValueStorage().setItem(authKeys.clockDrift, `${tokens.clockDrift}`);
    }
    async clearTokens() {
        const authKeys = await this.getAuthKeys();
        // Not calling clear because it can remove data that is not managed by AuthTokenStore
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.accessToken),
            this.getKeyValueStorage().removeItem(authKeys.idToken),
            this.getKeyValueStorage().removeItem(authKeys.clockDrift),
            this.getKeyValueStorage().removeItem(authKeys.refreshToken),
            this.getKeyValueStorage().removeItem(authKeys.signInDetails),
            this.getKeyValueStorage().removeItem(this.getLastAuthUserKey())
        ]);
    }
    async getDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        const deviceKey = await this.getKeyValueStorage().getItem(authKeys.deviceKey);
        const deviceGroupKey = await this.getKeyValueStorage().getItem(authKeys.deviceGroupKey);
        const randomPassword = await this.getKeyValueStorage().getItem(authKeys.randomPasswordKey);
        return !!randomPassword ? {
            deviceKey: deviceKey ?? undefined,
            deviceGroupKey: deviceGroupKey ?? undefined,
            randomPassword: randomPassword
        } : null;
    }
    async clearDeviceMetadata(username) {
        const authKeys = await this.getAuthKeys(username);
        await Promise.all([
            this.getKeyValueStorage().removeItem(authKeys.deviceKey),
            this.getKeyValueStorage().removeItem(authKeys.deviceGroupKey),
            this.getKeyValueStorage().removeItem(authKeys.randomPasswordKey)
        ]);
    }
    async getAuthKeys(username) {
        (0, $a6de0542b1980a7d$export$80c92581e59ed502)(this.authConfig?.Cognito);
        const lastAuthUser = username ?? await this.getLastAuthUser();
        return $bf28e6bdff0fcfed$export$4647c72f6828a74d(this.name, `${this.authConfig.Cognito.userPoolClientId}.${lastAuthUser}`);
    }
    getLastAuthUserKey() {
        (0, $a6de0542b1980a7d$export$80c92581e59ed502)(this.authConfig?.Cognito);
        const identifier = this.authConfig.Cognito.userPoolClientId;
        return `${this.name}.${identifier}.LastAuthUser`;
    }
    async getLastAuthUser() {
        const lastAuthUser = await this.getKeyValueStorage().getItem(this.getLastAuthUserKey()) ?? "username";
        return lastAuthUser;
    }
}
const $bf28e6bdff0fcfed$export$4647c72f6828a74d = (provider, identifier)=>{
    return $bf28e6bdff0fcfed$export$dfb8da757ca62eed((0, $5a6742e3c9584e8e$export$b8429d1428aad8ba))(`${provider}`, identifier);
};
function $bf28e6bdff0fcfed$export$dfb8da757ca62eed(authKeys) {
    const keys = Object.values({
        ...authKeys
    });
    return (prefix, identifier)=>keys.reduce((acc, authKey)=>({
                ...acc,
                [authKey]: `${prefix}.${identifier}.${authKey}`
            }), {});
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $da1e6f27f874c7b8$var$logger = new (0, $b5731988345712b1$export$ba6a9c7ac8291f7f)("DefaultIdentityIdStore");
class $da1e6f27f874c7b8$export$3e97b78667a539a0 {
    setAuthConfig(authConfigParam) {
        (0, $a6de0542b1980a7d$export$8a2f5318ea3215e3)(authConfigParam.Cognito);
        this.authConfig = authConfigParam;
        this._authKeys = $da1e6f27f874c7b8$var$createKeysForAuthStorage("Cognito", authConfigParam.Cognito.identityPoolId);
        return;
    }
    constructor(keyValueStorage){
        this._authKeys = {};
        this.keyValueStorage = keyValueStorage;
    }
    async loadIdentityId() {
        (0, $a6de0542b1980a7d$export$8a2f5318ea3215e3)(this.authConfig?.Cognito);
        try {
            if (!!this._primaryIdentityId) return {
                id: this._primaryIdentityId,
                type: "primary"
            };
            else {
                const storedIdentityId = await this.keyValueStorage.getItem(this._authKeys.identityId);
                if (!!storedIdentityId) return {
                    id: storedIdentityId,
                    type: "guest"
                };
                return null;
            }
        } catch (err) {
            $da1e6f27f874c7b8$var$logger.log("Error getting stored IdentityId.", err);
            return null;
        }
    }
    async storeIdentityId(identity) {
        (0, $a6de0542b1980a7d$export$8a2f5318ea3215e3)(this.authConfig?.Cognito);
        if (identity.type === "guest") {
            this.keyValueStorage.setItem(this._authKeys.identityId, identity.id);
            // Clear in-memory storage of primary identityId
            this._primaryIdentityId = undefined;
        } else {
            this._primaryIdentityId = identity.id;
            // Clear locally stored guest id
            this.keyValueStorage.removeItem(this._authKeys.identityId);
        }
    }
    async clearIdentityId() {
        this._primaryIdentityId = undefined;
        await this.keyValueStorage.removeItem(this._authKeys.identityId);
    }
}
const $da1e6f27f874c7b8$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $bf28e6bdff0fcfed$export$dfb8da757ca62eed)((0, $3dba1c13ad628da6$export$dad1700b96c3a835))(`com.amplify.${provider}`, identifier);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Default partition for AWS services. This is used when the region is not provided or the region is not recognized.
 *
 * @internal
 */ const $42d649d11a8dedca$export$72f3cee421ee8a74 = {
    id: "aws",
    outputs: {
        dnsSuffix: "amazonaws.com"
    },
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    regions: [
        "aws-global"
    ]
};
/**
 * This data is adapted from the partition file from AWS SDK shared utilities but remove some contents for bundle size
 * concern. Information removed are `dualStackDnsSuffix`, `supportDualStack`, `supportFIPS`, restricted partitions, and
 * list of regions for each partition other than global regions.
 *
 * * Ref: https://docs.aws.amazon.com/general/latest/gr/rande.html#regional-endpoints
 * * Ref: https://github.com/aws/aws-sdk-js-v3/blob/0201baef03c2379f1f6f7150b9d401d4b230d488/packages/util-endpoints/src/lib/aws/partitions.json#L1
 *
 * @internal
 */ const $42d649d11a8dedca$export$d7c12af0c0f12206 = {
    partitions: [
        $42d649d11a8dedca$export$72f3cee421ee8a74,
        {
            id: "aws-cn",
            outputs: {
                dnsSuffix: "amazonaws.com.cn"
            },
            regionRegex: "^cn\\-\\w+\\-\\d+$",
            regions: [
                "aws-cn-global"
            ]
        }
    ]
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get the AWS Services endpoint URL's DNS suffix for a given region. A typical AWS regional service endpoint URL will
 * follow this pattern: {endpointPrefix}.{region}.{dnsSuffix}. For example, the endpoint URL for Cognito Identity in
 * us-east-1 will be cognito-identity.us-east-1.amazonaws.com. Here the DnsSuffix is `amazonaws.com`.
 *
 * @param region
 * @returns The DNS suffix
 *
 * @internal
 */ const $69b277fb5751e237$export$1c28e37cdcc37f6d = (region)=>{
    const { partitions: partitions } = (0, $42d649d11a8dedca$export$d7c12af0c0f12206);
    for (const { regions: regions, outputs: outputs, regionRegex: regionRegex } of partitions){
        const regex = new RegExp(regionRegex);
        if (regions.includes(region) || regex.test(region)) return outputs.dnsSuffix;
    }
    return (0, $42d649d11a8dedca$export$72f3cee421ee8a74).outputs.dnsSuffix;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c2537cb748d5c96a$var$DEFAULT_RETRY_ATTEMPTS = 3;
/**
 * Retry middleware
 */ const $c2537cb748d5c96a$export$a3922aa5f87bae85 = ({ maxAttempts: maxAttempts = $c2537cb748d5c96a$var$DEFAULT_RETRY_ATTEMPTS, retryDecider: retryDecider, computeDelay: computeDelay, abortSignal: abortSignal })=>{
    if (maxAttempts < 1) throw new Error("maxAttempts must be greater than 0");
    return (next, context)=>async function retryMiddleware(request) {
            let error;
            let attemptsCount = context.attemptsCount ?? 0;
            let response;
            // When retry is not needed or max attempts is reached, either error or response will be set. This function handles either cases.
            const handleTerminalErrorOrResponse = ()=>{
                if (response) {
                    $c2537cb748d5c96a$var$addOrIncrementMetadataAttempts(response, attemptsCount);
                    return response;
                } else {
                    $c2537cb748d5c96a$var$addOrIncrementMetadataAttempts(error, attemptsCount);
                    throw error;
                }
            };
            while(!abortSignal?.aborted && attemptsCount < maxAttempts){
                try {
                    response = await next(request);
                    error = undefined;
                } catch (e) {
                    error = e;
                    response = undefined;
                }
                // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                attemptsCount = (context.attemptsCount ?? 0) > attemptsCount ? context.attemptsCount ?? 0 : attemptsCount + 1;
                context.attemptsCount = attemptsCount;
                if (await retryDecider(response, error)) {
                    if (!abortSignal?.aborted && attemptsCount < maxAttempts) {
                        // prevent sleep for last attempt or cancelled request;
                        const delay = computeDelay(attemptsCount);
                        await $c2537cb748d5c96a$var$cancellableSleep(delay, abortSignal);
                    }
                    continue;
                } else return handleTerminalErrorOrResponse();
            }
            if (abortSignal?.aborted) throw new Error("Request aborted.");
            else return handleTerminalErrorOrResponse();
        };
};
const $c2537cb748d5c96a$var$cancellableSleep = (timeoutMs, abortSignal)=>{
    if (abortSignal?.aborted) return Promise.resolve();
    let timeoutId;
    let sleepPromiseResolveFn;
    const sleepPromise = new Promise((resolve)=>{
        sleepPromiseResolveFn = resolve;
        timeoutId = setTimeout(resolve, timeoutMs);
    });
    abortSignal?.addEventListener("abort", function cancelSleep(event) {
        clearTimeout(timeoutId);
        abortSignal?.removeEventListener("abort", cancelSleep);
        sleepPromiseResolveFn();
    });
    return sleepPromise;
};
const $c2537cb748d5c96a$var$addOrIncrementMetadataAttempts = (nextHandlerOutput, attempts)=>{
    if (Object.prototype.toString.call(nextHandlerOutput) !== "[object Object]") return;
    nextHandlerOutput["$metadata"] = {
        ...nextHandlerOutput["$metadata"] ?? {},
        attempts: attempts
    };
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Middleware injects user agent string to specified header(default to 'x-amz-user-agent'),
 * if the header is not set already.
 *
 * TODO: incorporate new user agent design
 */ const $e622f7fe080565ab$export$62c460923941c0b0 = ({ userAgentHeader: userAgentHeader = "x-amz-user-agent", userAgentValue: userAgentValue = "" })=>(next)=>{
        return async function userAgentMiddleware(request) {
            if (userAgentValue.trim().length === 0) {
                const result = await next(request);
                return result;
            } else {
                const headerName = userAgentHeader.toLowerCase();
                request.headers[headerName] = request.headers[headerName] ? `${request.headers[headerName]} ${userAgentValue}` : userAgentValue;
                const response = await next(request);
                return response;
            }
        };
    };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Compose a transfer handler with a core transfer handler and a list of middleware.
 * @param coreHandler Core transfer handler
 * @param middleware	List of middleware
 * @returns A transfer handler whose option type is the union of the core
 * 	transfer handler's option type and the middleware's option type.
 * @internal
 */ const $d788a4476fee6b12$export$f074d76e52925468 = (coreHandler, middleware)=>(request, options)=>{
        const context = {};
        let composedHandler = (request)=>coreHandler(request, options);
        for(let i = middleware.length - 1; i >= 0; i--){
            const m = middleware[i];
            const resolvedMiddleware = m(options);
            composedHandler = resolvedMiddleware(composedHandler, context);
        }
        return composedHandler(request);
    };


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cache the payload of a response body. It allows multiple calls to the body,
 * for example, when reading the body in both retry decider and error deserializer.
 * Caching body is allowed here because we call the body accessor(blob(), json(),
 * etc.) when body is small or streaming implementation is not available(RN).
 *
 * @internal
 */ const $e01c0826b5128c54$export$580ad1ce15092b15 = (payloadAccessor)=>{
    let cached;
    return ()=>{
        if (!cached) // Explicitly not awaiting. Intermediate await would add overhead and
        // introduce a possible race in the event that this wrapper is called
        // again before the first `payloadAccessor` call resolves.
        cached = payloadAccessor();
        return cached;
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $85f8ce52e1517aec$var$shouldSendBody = (method)=>![
        "HEAD",
        "GET",
        "DELETE"
    ].includes(method.toUpperCase());
// TODO[AllanZhengYP]: we need to provide isCanceledError utility
const $85f8ce52e1517aec$export$d2573baf35521e4c = async ({ url: url, method: method, headers: headers, body: body }, { abortSignal: abortSignal, cache: cache, withCrossDomainCredentials: withCrossDomainCredentials })=>{
    let resp;
    try {
        resp = await fetch(url, {
            method: method,
            headers: headers,
            body: $85f8ce52e1517aec$var$shouldSendBody(method) ? body : undefined,
            signal: abortSignal,
            cache: cache,
            credentials: withCrossDomainCredentials ? "include" : "same-origin"
        });
    } catch (e) {
        // TODO: needs to revise error handling in v6
        // For now this is a thin wrapper over original fetch error similar to cognito-identity-js package.
        // Ref: https://github.com/aws-amplify/amplify-js/blob/4fbc8c0a2be7526aab723579b4c95b552195a80b/packages/amazon-cognito-identity-js/src/Client.js#L103-L108
        if (e instanceof TypeError) throw new Error("Network error");
        throw e;
    }
    const responseHeaders = {};
    resp.headers?.forEach((value, key)=>{
        responseHeaders[key.toLowerCase()] = value;
    });
    const httpResponse = {
        statusCode: resp.status,
        headers: responseHeaders,
        body: null
    };
    // resp.body is a ReadableStream according to Fetch API spec, but React Native
    // does not implement it.
    const bodyWithMixin = Object.assign(resp.body ?? {}, {
        text: (0, $e01c0826b5128c54$export$580ad1ce15092b15)(()=>resp.text()),
        blob: (0, $e01c0826b5128c54$export$580ad1ce15092b15)(()=>resp.blob()),
        json: (0, $e01c0826b5128c54$export$580ad1ce15092b15)(()=>resp.json())
    });
    return {
        ...httpResponse,
        body: bodyWithMixin
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $4421e2658594d439$export$ed7e1ccf00f39c4a = (0, $d788a4476fee6b12$export$f074d76e52925468)((0, $85f8ce52e1517aec$export$d2573baf35521e4c), [
    (0, $e622f7fe080565ab$export$62c460923941c0b0),
    (0, $c2537cb748d5c96a$export$a3922aa5f87bae85)
]);



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $32c86e6697fb61df$export$76041b1400befb8b = 300000;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @private
 * Internal use of Amplify only
 */ function $232e9c4a0d04cbf0$export$caea50bde345f648(maxDelayMs = (0, $32c86e6697fb61df$export$76041b1400befb8b)) {
    const BASE_TIME_MS = 100;
    const JITTER_FACTOR = 100;
    return (attempt)=>{
        const delay = 2 ** attempt * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: [v6] The separate retry utility is used by Data packages now and will replaced by retry middleware.
const $3ffa800d030e0eeb$var$DEFAULT_MAX_DELAY_MS = 300000;
const $3ffa800d030e0eeb$export$caea50bde345f648 = (attempt)=>{
    const delayFunction = (0, $232e9c4a0d04cbf0$export$caea50bde345f648)($3ffa800d030e0eeb$var$DEFAULT_MAX_DELAY_MS);
    const delay = delayFunction(attempt);
    // The delayFunction returns false when the delay is greater than the max delay(5 mins).
    // In this case, the retry middleware will delay 5 mins instead, as a ceiling of the delay.
    return delay === false ? $3ffa800d030e0eeb$var$DEFAULT_MAX_DELAY_MS : delay;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// via https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L8
const $00bb45e811bdf82a$var$CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch",
    "BadRequestException"
];
/**
 * Given an error code, returns true if it is related to a clock skew error.
 *
 * @param errorCode String representation of some error.
 * @returns True if given error is present in `CLOCK_SKEW_ERROR_CODES`, false otherwise.
 *
 * @internal
 */ const $00bb45e811bdf82a$export$7b87435661177a94 = (errorCode)=>!!errorCode && $00bb45e811bdf82a$var$CLOCK_SKEW_ERROR_CODES.includes(errorCode);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Get retry decider function
 * @param errorParser Function to load JavaScript error from HTTP response
 */ const $56e16fa9d36ecd04$export$b919d98317a7685f = (errorParser)=>async (response, error)=>{
        const parsedError = error ?? await errorParser(response) ?? undefined;
        const errorCode = parsedError?.["code"];
        const statusCode = response?.statusCode;
        return $56e16fa9d36ecd04$var$isConnectionError(error) || $56e16fa9d36ecd04$var$isThrottlingError(statusCode, errorCode) || (0, $00bb45e811bdf82a$export$7b87435661177a94)(errorCode) || $56e16fa9d36ecd04$var$isServerSideError(statusCode, errorCode);
    };
// reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37
const $56e16fa9d36ecd04$var$THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException"
];
const $56e16fa9d36ecd04$var$TIMEOUT_ERROR_CODES = [
    "TimeoutError",
    "RequestTimeout",
    "RequestTimeoutException"
];
const $56e16fa9d36ecd04$var$isThrottlingError = (statusCode, errorCode)=>statusCode === 429 || !!errorCode && $56e16fa9d36ecd04$var$THROTTLING_ERROR_CODES.includes(errorCode);
const $56e16fa9d36ecd04$var$isConnectionError = (error)=>error?.["name"] === "Network error";
const $56e16fa9d36ecd04$var$isServerSideError = (statusCode, errorCode)=>!!statusCode && [
        500,
        502,
        503,
        504
    ].includes(statusCode) || !!errorCode && $56e16fa9d36ecd04$var$TIMEOUT_ERROR_CODES.includes(errorCode);



var $aVicc = parcelRequire("aVicc");
/**
 * @internal
 */ var $7f7e0105fc4d9754$export$b2e3d6d444266a5c = 64;
var $7f7e0105fc4d9754$export$d7bd469488748c5f = 32;
var $7f7e0105fc4d9754$export$7167c830cefcb6b5 = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var $7f7e0105fc4d9754$export$d788bc089976c004 = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var $7f7e0105fc4d9754$export$856b3d11dc447b50 = Math.pow(2, 53) - 1;



/**
 * @internal
 */ var $3ea67375617d01f8$export$aab6bc1ad3c77a42 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from((0, $7f7e0105fc4d9754$export$d788bc089976c004));
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > (0, $7f7e0105fc4d9754$export$856b3d11dc447b50)) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === (0, $7f7e0105fc4d9754$export$b2e3d6d444266a5c)) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % (0, $7f7e0105fc4d9754$export$b2e3d6d444266a5c) >= (0, $7f7e0105fc4d9754$export$b2e3d6d444266a5c) - 8) {
                for(var i = this.bufferLength; i < (0, $7f7e0105fc4d9754$export$b2e3d6d444266a5c); i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < (0, $7f7e0105fc4d9754$export$b2e3d6d444266a5c) - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32((0, $7f7e0105fc4d9754$export$b2e3d6d444266a5c) - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32((0, $7f7e0105fc4d9754$export$b2e3d6d444266a5c) - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array((0, $7f7e0105fc4d9754$export$d7bd469488748c5f));
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < (0, $7f7e0105fc4d9754$export$b2e3d6d444266a5c); i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ((0, $7f7e0105fc4d9754$export$7167c830cefcb6b5)[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c180989923b0465e$export$c7c5cef950a4d2fc = (input)=>new TextEncoder().encode(input);



const $fba2ce9079a2d245$export$73470fd2221e6aef = (data)=>{
    if (typeof data === "string") return (0, $c180989923b0465e$export$c7c5cef950a4d2fc)(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
};


const $5672648b555239e4$export$b4b216764bb846eb = (input)=>new TextDecoder("utf-8").decode(input);





var $cjtBX = parcelRequire("cjtBX");
var $b4ed8ae1b6470270$require$Buffer = $cjtBX.Buffer;
// Quick polyfill
var $b4ed8ae1b6470270$var$fromUtf8 = typeof $b4ed8ae1b6470270$require$Buffer !== "undefined" && $b4ed8ae1b6470270$require$Buffer.from ? function(input) {
    return $b4ed8ae1b6470270$require$Buffer.from(input, "utf8");
} : (0, $c180989923b0465e$export$c7c5cef950a4d2fc);
function $b4ed8ae1b6470270$export$4f21f20c2f1a9063(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $b4ed8ae1b6470270$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $a2f14318591a9ae8$export$ea55f474a468804e(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $f0c548c73ba55e39$export$2527dfa2a193fcfa(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}


// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// IE 11 does not support Array.from, so we do it manually
function $ef6d8fcc807c4176$export$b6739cd5a63159f9(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length){
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}




var $56754fea12aa1c8a$export$3b58ea8124ac5e28 = /** @class */ function() {
    function Sha256(secret) {
        this.secret = secret;
        this.hash = new (0, $3ea67375617d01f8$export$aab6bc1ad3c77a42)();
        this.reset();
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $a2f14318591a9ae8$export$ea55f474a468804e)(toHash) || this.error) return;
        try {
            this.hash.update((0, $b4ed8ae1b6470270$export$4f21f20c2f1a9063)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $aVicc.__awaiter)(this, void 0, void 0, function() {
            return (0, $aVicc.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    Sha256.prototype.reset = function() {
        this.hash = new (0, $3ea67375617d01f8$export$aab6bc1ad3c77a42)();
        if (this.secret) {
            this.outer = new (0, $3ea67375617d01f8$export$aab6bc1ad3c77a42)();
            var inner = $56754fea12aa1c8a$var$bufferFromSecret(this.secret);
            var outer = new Uint8Array((0, $7f7e0105fc4d9754$export$b2e3d6d444266a5c));
            outer.set(inner);
            for(var i = 0; i < (0, $7f7e0105fc4d9754$export$b2e3d6d444266a5c); i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    };
    return Sha256;
}();
function $56754fea12aa1c8a$var$bufferFromSecret(secret) {
    var input = (0, $b4ed8ae1b6470270$export$4f21f20c2f1a9063)(secret);
    if (input.byteLength > (0, $7f7e0105fc4d9754$export$b2e3d6d444266a5c)) {
        var bufferHash = new (0, $3ea67375617d01f8$export$aab6bc1ad3c77a42)();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array((0, $7f7e0105fc4d9754$export$b2e3d6d444266a5c));
    buffer.set(input);
    return buffer;
}




const $8a7a3b22c8063b66$var$SHORT_TO_HEX = {};
const $8a7a3b22c8063b66$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $8a7a3b22c8063b66$var$SHORT_TO_HEX[i] = encodedByte;
    $8a7a3b22c8063b66$var$HEX_TO_SHORT[encodedByte] = i;
}
function $8a7a3b22c8063b66$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $8a7a3b22c8063b66$var$HEX_TO_SHORT) out[i / 2] = $8a7a3b22c8063b66$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $8a7a3b22c8063b66$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $8a7a3b22c8063b66$var$SHORT_TO_HEX[bytes[i]];
    return out;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3d238183541c5736$export$beb82d9d9136c16e = URL;
const $3d238183541c5736$export$4ea7bbdac595b5fb = URLSearchParams;



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $60ffc89c13d099ad$export$978f9418fe0cb26c = (response)=>{
    const { headers: headers, statusCode: statusCode } = response;
    return {
        ...$60ffc89c13d099ad$var$isMetadataBearer(response) ? response.$metadata : {},
        httpStatusCode: statusCode,
        requestId: headers["x-amzn-requestid"] ?? headers["x-amzn-request-id"] ?? headers["x-amz-request-id"],
        extendedRequestId: headers["x-amz-id-2"],
        cfId: headers["x-amz-cf-id"]
    };
};
const $60ffc89c13d099ad$var$isMetadataBearer = (response)=>typeof response?.$metadata === "object";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Utility functions for serializing and deserializing of JSON protocol in general(including: REST-JSON, JSON-RPC, etc.)
 */ /**
 * Error parser for AWS JSON protocol.
 */ const $058833fc00397105$export$be467dfcc0538e25 = async (response)=>{
    if (!response || response.statusCode < 300) return;
    const body = await $058833fc00397105$export$759bcb35b0d1bf81(response);
    const sanitizeErrorCode = (rawValue)=>{
        const [cleanValue] = rawValue.toString().split(/[\,\:]+/);
        if (cleanValue.includes("#")) return cleanValue.split("#")[1];
        return cleanValue;
    };
    const code = sanitizeErrorCode(response.headers["x-amzn-errortype"] ?? body.code ?? body.__type ?? "UnknownError");
    const message = body.message ?? body.Message ?? "Unknown error";
    const error = new Error(message);
    return Object.assign(error, {
        name: code,
        $metadata: (0, $60ffc89c13d099ad$export$978f9418fe0cb26c)(response)
    });
};
/**
 * Parse JSON response body to JavaScript object.
 */ const $058833fc00397105$export$759bcb35b0d1bf81 = async (response)=>{
    if (!response.body) throw new Error("Missing response payload");
    const output = await response.body.json();
    return Object.assign(output, {
        $metadata: (0, $60ffc89c13d099ad$export$978f9418fe0cb26c)(response)
    });
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $46bbfb42d61f6c30$export$638889172ebce0c4;
(function(Framework) {
    // < 100 - Web frameworks
    Framework["WebUnknown"] = "0";
    Framework["React"] = "1";
    Framework["NextJs"] = "2";
    Framework["Angular"] = "3";
    Framework["VueJs"] = "4";
    Framework["Nuxt"] = "5";
    Framework["Svelte"] = "6";
    // 100s - Server side frameworks
    Framework["ServerSideUnknown"] = "100";
    Framework["ReactSSR"] = "101";
    Framework["NextJsSSR"] = "102";
    Framework["AngularSSR"] = "103";
    Framework["VueJsSSR"] = "104";
    Framework["NuxtSSR"] = "105";
    Framework["SvelteSSR"] = "106";
    // 200s - Mobile framework
    Framework["ReactNative"] = "201";
    Framework["Expo"] = "202";
})($46bbfb42d61f6c30$export$638889172ebce0c4 || ($46bbfb42d61f6c30$export$638889172ebce0c4 = {}));
var $46bbfb42d61f6c30$export$3a8840c5b2ecf003;
(function(Category) {
    Category["API"] = "api";
    Category["Auth"] = "auth";
    Category["Analytics"] = "analytics";
    Category["DataStore"] = "datastore";
    Category["Geo"] = "geo";
    Category["InAppMessaging"] = "inappmessaging";
    Category["Interactions"] = "interactions";
    Category["Predictions"] = "predictions";
    Category["PubSub"] = "pubsub";
    Category["PushNotification"] = "pushnotification";
    Category["Storage"] = "storage";
})($46bbfb42d61f6c30$export$3a8840c5b2ecf003 || ($46bbfb42d61f6c30$export$3a8840c5b2ecf003 = {}));
var $46bbfb42d61f6c30$export$30c16f5c43437fd7;
(function(AnalyticsAction) {
    AnalyticsAction["Record"] = "1";
    AnalyticsAction["IdentifyUser"] = "2";
})($46bbfb42d61f6c30$export$30c16f5c43437fd7 || ($46bbfb42d61f6c30$export$30c16f5c43437fd7 = {}));
var $46bbfb42d61f6c30$export$126e20fdc0f0d34b;
(function(ApiAction) {
    ApiAction["GraphQl"] = "1";
    ApiAction["Get"] = "2";
    ApiAction["Post"] = "3";
    ApiAction["Put"] = "4";
    ApiAction["Patch"] = "5";
    ApiAction["Del"] = "6";
    ApiAction["Head"] = "7";
})($46bbfb42d61f6c30$export$126e20fdc0f0d34b || ($46bbfb42d61f6c30$export$126e20fdc0f0d34b = {}));
var $46bbfb42d61f6c30$export$900b1436d7e65f4;
(function(AuthAction) {
    AuthAction["SignUp"] = "1";
    AuthAction["ConfirmSignUp"] = "2";
    AuthAction["ResendSignUpCode"] = "3";
    AuthAction["SignIn"] = "4";
    AuthAction["FetchMFAPreference"] = "6";
    AuthAction["UpdateMFAPreference"] = "7";
    AuthAction["SetUpTOTP"] = "10";
    AuthAction["VerifyTOTPSetup"] = "11";
    AuthAction["ConfirmSignIn"] = "12";
    AuthAction["DeleteUserAttributes"] = "15";
    AuthAction["DeleteUser"] = "16";
    AuthAction["UpdateUserAttributes"] = "17";
    AuthAction["FetchUserAttributes"] = "18";
    AuthAction["ConfirmUserAttribute"] = "22";
    AuthAction["SignOut"] = "26";
    AuthAction["UpdatePassword"] = "27";
    AuthAction["ResetPassword"] = "28";
    AuthAction["ConfirmResetPassword"] = "29";
    AuthAction["FederatedSignIn"] = "30";
    AuthAction["RememberDevice"] = "32";
    AuthAction["ForgetDevice"] = "33";
    AuthAction["FetchDevices"] = "34";
    AuthAction["SendUserAttributeVerificationCode"] = "35";
    AuthAction["SignInWithRedirect"] = "36";
})($46bbfb42d61f6c30$export$900b1436d7e65f4 || ($46bbfb42d61f6c30$export$900b1436d7e65f4 = {}));
var $46bbfb42d61f6c30$export$2f5a715aba4cde93;
(function(DataStoreAction) {
    DataStoreAction["Subscribe"] = "1";
    DataStoreAction["GraphQl"] = "2";
})($46bbfb42d61f6c30$export$2f5a715aba4cde93 || ($46bbfb42d61f6c30$export$2f5a715aba4cde93 = {}));
var $46bbfb42d61f6c30$export$afafab3eb8fc6fef;
(function(GeoAction) {
    GeoAction["SearchByText"] = "0";
    GeoAction["SearchByCoordinates"] = "1";
    GeoAction["SearchForSuggestions"] = "2";
    GeoAction["SearchByPlaceId"] = "3";
    GeoAction["SaveGeofences"] = "4";
    GeoAction["GetGeofence"] = "5";
    GeoAction["ListGeofences"] = "6";
    GeoAction["DeleteGeofences"] = "7";
})($46bbfb42d61f6c30$export$afafab3eb8fc6fef || ($46bbfb42d61f6c30$export$afafab3eb8fc6fef = {}));
var $46bbfb42d61f6c30$export$c01a8c16ffda791e;
(function(InAppMessagingAction) {
    InAppMessagingAction["SyncMessages"] = "1";
    InAppMessagingAction["IdentifyUser"] = "2";
    InAppMessagingAction["NotifyMessageInteraction"] = "3";
})($46bbfb42d61f6c30$export$c01a8c16ffda791e || ($46bbfb42d61f6c30$export$c01a8c16ffda791e = {}));
var $46bbfb42d61f6c30$export$68e0695a774ab7fa;
(function(InteractionsAction) {
    InteractionsAction["None"] = "0";
})($46bbfb42d61f6c30$export$68e0695a774ab7fa || ($46bbfb42d61f6c30$export$68e0695a774ab7fa = {}));
var $46bbfb42d61f6c30$export$aa89b4c447a07cee;
(function(PredictionsAction) {
    PredictionsAction["Convert"] = "1";
    PredictionsAction["Identify"] = "2";
    PredictionsAction["Interpret"] = "3";
})($46bbfb42d61f6c30$export$aa89b4c447a07cee || ($46bbfb42d61f6c30$export$aa89b4c447a07cee = {}));
var $46bbfb42d61f6c30$export$ade48b30f1e78672;
(function(PubSubAction) {
    PubSubAction["Subscribe"] = "1";
})($46bbfb42d61f6c30$export$ade48b30f1e78672 || ($46bbfb42d61f6c30$export$ade48b30f1e78672 = {}));
var $46bbfb42d61f6c30$export$2c5ee06ab9fa5040;
(function(PushNotificationAction) {
    PushNotificationAction["InitializePushNotifications"] = "1";
    PushNotificationAction["IdentifyUser"] = "2";
})($46bbfb42d61f6c30$export$2c5ee06ab9fa5040 || ($46bbfb42d61f6c30$export$2c5ee06ab9fa5040 = {}));
var $46bbfb42d61f6c30$export$d4f3c54b808b00ce;
(function(StorageAction) {
    StorageAction["UploadData"] = "1";
    StorageAction["DownloadData"] = "2";
    StorageAction["List"] = "3";
    StorageAction["Copy"] = "4";
    StorageAction["Remove"] = "5";
    StorageAction["GetProperties"] = "6";
    StorageAction["GetUrl"] = "7";
})($46bbfb42d61f6c30$export$d4f3c54b808b00ce || ($46bbfb42d61f6c30$export$d4f3c54b808b00ce = {}));


// generated by genversion
const $7166750678680fba$export$83d89fbfd8236492 = "6.0.5";




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var $7zvJK = parcelRequire("7zvJK");
const $5779acb9ee1955aa$export$a15eed0e463030a9 = ()=>{
    return typeof $parcel$global !== "undefined";
};
const $5779acb9ee1955aa$export$a5e7eb32e5221222 = ()=>{
    return typeof globalThis !== "undefined";
};
const $5779acb9ee1955aa$export$daba2802a1a41c1f = ()=>{
    return typeof window !== "undefined";
};
const $5779acb9ee1955aa$export$b949ebcb877faa59 = ()=>{
    return typeof document !== "undefined";
};
const $5779acb9ee1955aa$export$ba10401363d0f7f6 = ()=>{
    return typeof $7zvJK !== "undefined";
};
const $5779acb9ee1955aa$export$252f88727cff70c7 = (object, prefix)=>{
    return !!Object.keys(object).find((key)=>key.startsWith(prefix));
};



var $7zvJK = parcelRequire("7zvJK");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react 18.2 - built using Vite
function $e5cc3457346992dd$export$ba3f37c54f0f7805() {
    const elementKeyPrefixedWithReact = (key)=>{
        return key.startsWith("_react") || key.startsWith("__react");
    };
    const elementIsReactEnabled = (element)=>{
        return Object.keys(element).find(elementKeyPrefixedWithReact);
    };
    const allElementsWithId = ()=>Array.from(document.querySelectorAll("[id]"));
    return (0, $5779acb9ee1955aa$export$b949ebcb877faa59)() && allElementsWithId().some(elementIsReactEnabled);
}
function $e5cc3457346992dd$export$86269c582305790() {
    return (0, $5779acb9ee1955aa$export$ba10401363d0f7f6)() && typeof $7zvJK.env !== "undefined" && !!Object.keys($7zvJK.env).find((key)=>key.includes("react"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with vue 3.3.2
function $72652e7f75c458e3$export$d91d90d62b78936d() {
    return (0, $5779acb9ee1955aa$export$daba2802a1a41c1f)() && (0, $5779acb9ee1955aa$export$252f88727cff70c7)(window, "__VUE");
}
function $72652e7f75c458e3$export$257a4c0f8294a101() {
    return (0, $5779acb9ee1955aa$export$a15eed0e463030a9)() && (0, $5779acb9ee1955aa$export$252f88727cff70c7)($parcel$global, "__VUE");
}




var $7zvJK = parcelRequire("7zvJK");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with svelte 3.59
function $60cfe4795a234be8$export$6dafc32a94edaed3() {
    return (0, $5779acb9ee1955aa$export$daba2802a1a41c1f)() && (0, $5779acb9ee1955aa$export$252f88727cff70c7)(window, "__SVELTE");
}
function $60cfe4795a234be8$export$819dcb7fe144d8b0() {
    return (0, $5779acb9ee1955aa$export$ba10401363d0f7f6)() && typeof $7zvJK.env !== "undefined" && !!Object.keys($7zvJK.env).find((key)=>key.includes("svelte"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with next 13.4 / react 18.2
function $a4150f1cbb8633ac$export$f8462bcf03110eff() {
    // @ts-ignore
    return (0, $5779acb9ee1955aa$export$daba2802a1a41c1f)() && window["next"] && typeof window["next"] === "object";
}
function $a4150f1cbb8633ac$export$61c08ed144a5d4ca() {
    return (0, $5779acb9ee1955aa$export$a15eed0e463030a9)() && ((0, $5779acb9ee1955aa$export$252f88727cff70c7)($parcel$global, "__next") || (0, $5779acb9ee1955aa$export$252f88727cff70c7)($parcel$global, "__NEXT"));
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with nuxt 2.15 / vue 2.7
function $8640f2a93911c381$export$bed54a4e6d9d25fb() {
    return (0, $5779acb9ee1955aa$export$daba2802a1a41c1f)() && // @ts-ignore
    (window["__NUXT__"] !== undefined || window["$nuxt"] !== undefined);
}
function $8640f2a93911c381$export$fb3ce982948d27e8() {
    // @ts-ignore
    return (0, $5779acb9ee1955aa$export$a15eed0e463030a9)() && typeof $parcel$global["__NUXT_PATHS__"] !== "undefined";
}




var $7zvJK = parcelRequire("7zvJK");
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with @angular/core 16.0.0
function $9d84a79f4ae84c54$export$b5a20bd39eb02ba0() {
    const angularVersionSetInDocument = Boolean((0, $5779acb9ee1955aa$export$b949ebcb877faa59)() && document.querySelector("[ng-version]"));
    const angularContentSetInWindow = Boolean(// @ts-ignore
    (0, $5779acb9ee1955aa$export$daba2802a1a41c1f)() && typeof window["ng"] !== "undefined");
    return angularVersionSetInDocument || angularContentSetInWindow;
}
function $9d84a79f4ae84c54$export$8ab518c8987c870f() {
    return (0, $5779acb9ee1955aa$export$ba10401363d0f7f6)() && typeof $7zvJK.env === "object" && undefined?.startsWith("ng ") || false;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
function $942155eadac4d816$export$1c8414c1859e3748() {
    return typeof navigator !== "undefined" && typeof navigator.product !== "undefined" && navigator.product === "ReactNative";
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with expo 48 / react-native 0.71.3
function $10d72165c0a5f9de$export$85fd46d5e29a4f7e() {
    // @ts-ignore
    return (0, $5779acb9ee1955aa$export$a15eed0e463030a9)() && typeof $parcel$global["expo"] !== "undefined";
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $423d7369bf79890d$export$41b1270b988065fb() {
    return (0, $5779acb9ee1955aa$export$daba2802a1a41c1f)();
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// These are in the order of detection where when both are detectable, the early Framework will be reported
const $a390a375c24d5543$var$detectionMap = [
    // First, detect mobile
    {
        platform: (0, $46bbfb42d61f6c30$export$638889172ebce0c4).Expo,
        detectionMethod: (0, $10d72165c0a5f9de$export$85fd46d5e29a4f7e)
    },
    {
        platform: (0, $46bbfb42d61f6c30$export$638889172ebce0c4).ReactNative,
        detectionMethod: (0, $942155eadac4d816$export$1c8414c1859e3748)
    },
    // Next, detect web frameworks
    {
        platform: (0, $46bbfb42d61f6c30$export$638889172ebce0c4).NextJs,
        detectionMethod: (0, $a4150f1cbb8633ac$export$f8462bcf03110eff)
    },
    {
        platform: (0, $46bbfb42d61f6c30$export$638889172ebce0c4).Nuxt,
        detectionMethod: (0, $8640f2a93911c381$export$bed54a4e6d9d25fb)
    },
    {
        platform: (0, $46bbfb42d61f6c30$export$638889172ebce0c4).Angular,
        detectionMethod: (0, $9d84a79f4ae84c54$export$b5a20bd39eb02ba0)
    },
    {
        platform: (0, $46bbfb42d61f6c30$export$638889172ebce0c4).React,
        detectionMethod: (0, $e5cc3457346992dd$export$ba3f37c54f0f7805)
    },
    {
        platform: (0, $46bbfb42d61f6c30$export$638889172ebce0c4).VueJs,
        detectionMethod: (0, $72652e7f75c458e3$export$d91d90d62b78936d)
    },
    {
        platform: (0, $46bbfb42d61f6c30$export$638889172ebce0c4).Svelte,
        detectionMethod: (0, $60cfe4795a234be8$export$6dafc32a94edaed3)
    },
    {
        platform: (0, $46bbfb42d61f6c30$export$638889172ebce0c4).WebUnknown,
        detectionMethod: (0, $423d7369bf79890d$export$41b1270b988065fb)
    },
    // Last, detect ssr frameworks
    {
        platform: (0, $46bbfb42d61f6c30$export$638889172ebce0c4).NextJsSSR,
        detectionMethod: (0, $a4150f1cbb8633ac$export$61c08ed144a5d4ca)
    },
    {
        platform: (0, $46bbfb42d61f6c30$export$638889172ebce0c4).NuxtSSR,
        detectionMethod: (0, $8640f2a93911c381$export$fb3ce982948d27e8)
    },
    {
        platform: (0, $46bbfb42d61f6c30$export$638889172ebce0c4).ReactSSR,
        detectionMethod: (0, $e5cc3457346992dd$export$86269c582305790)
    },
    {
        platform: (0, $46bbfb42d61f6c30$export$638889172ebce0c4).VueJsSSR,
        detectionMethod: (0, $72652e7f75c458e3$export$257a4c0f8294a101)
    },
    {
        platform: (0, $46bbfb42d61f6c30$export$638889172ebce0c4).AngularSSR,
        detectionMethod: (0, $9d84a79f4ae84c54$export$8ab518c8987c870f)
    },
    {
        platform: (0, $46bbfb42d61f6c30$export$638889172ebce0c4).SvelteSSR,
        detectionMethod: (0, $60cfe4795a234be8$export$819dcb7fe144d8b0)
    }
];
function $a390a375c24d5543$export$17b446b869dad473() {
    return $a390a375c24d5543$var$detectionMap.find((detectionEntry)=>detectionEntry.detectionMethod())?.platform || (0, $46bbfb42d61f6c30$export$638889172ebce0c4).ServerSideUnknown;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// We want to cache detection since the framework won't change
let $1aea29c5836b8523$var$frameworkCache;
const $1aea29c5836b8523$export$d56891f33aa26edc = [];
// Setup the detection reset tracking / timeout delays
let $1aea29c5836b8523$var$resetTriggered = false;
const $1aea29c5836b8523$var$SSR_RESET_TIMEOUT = 10; // ms
const $1aea29c5836b8523$var$WEB_RESET_TIMEOUT = 10; // ms
const $1aea29c5836b8523$var$PRIME_FRAMEWORK_DELAY = 1000; // ms
const $1aea29c5836b8523$export$9ce73e459ec93b6a = ()=>{
    if (!$1aea29c5836b8523$var$frameworkCache) {
        $1aea29c5836b8523$var$frameworkCache = (0, $a390a375c24d5543$export$17b446b869dad473)();
        if ($1aea29c5836b8523$var$resetTriggered) // The final run of detectFramework:
        // Starting from this point, the `frameworkCache` becomes "final".
        // So we don't need to notify the observers again so the observer
        // can be removed after the final notice.
        while($1aea29c5836b8523$export$d56891f33aa26edc.length)$1aea29c5836b8523$export$d56891f33aa26edc.pop()?.();
        else // The first run of detectFramework:
        // Every time we update the cache, call each observer function
        $1aea29c5836b8523$export$d56891f33aa26edc.forEach((fcn)=>fcn());
        // Retry once for either Unknown type after a delay (explained below)
        $1aea29c5836b8523$var$resetTimeout((0, $46bbfb42d61f6c30$export$638889172ebce0c4).ServerSideUnknown, $1aea29c5836b8523$var$SSR_RESET_TIMEOUT);
        $1aea29c5836b8523$var$resetTimeout((0, $46bbfb42d61f6c30$export$638889172ebce0c4).WebUnknown, $1aea29c5836b8523$var$WEB_RESET_TIMEOUT);
    }
    return $1aea29c5836b8523$var$frameworkCache;
};
/**
 * @internal Setup observer callback that will be called everytime the framework changes
 */ const $1aea29c5836b8523$export$5d5c467ce0b213f = (fcn)=>{
    // When the `frameworkCache` won't be updated again, we ignore all incoming
    // observers.
    if ($1aea29c5836b8523$var$resetTriggered) return;
    $1aea29c5836b8523$export$d56891f33aa26edc.push(fcn);
};
function $1aea29c5836b8523$export$d2adf65b87e47523() {
    $1aea29c5836b8523$var$frameworkCache = undefined;
}
// For a framework type and a delay amount, setup the event to re-detect
//   During the runtime boot, it is possible that framework detection will
//   be triggered before the framework has made modifications to the
//   global/window/etc needed for detection. When no framework is detected
//   we will reset and try again to ensure we don't use a cached
//   non-framework detection result for all requests.
function $1aea29c5836b8523$var$resetTimeout(framework, delay) {
    if ($1aea29c5836b8523$var$frameworkCache === framework && !$1aea29c5836b8523$var$resetTriggered) setTimeout(()=>{
        $1aea29c5836b8523$export$d2adf65b87e47523();
        $1aea29c5836b8523$var$resetTriggered = true;
        setTimeout($1aea29c5836b8523$export$9ce73e459ec93b6a, $1aea29c5836b8523$var$PRIME_FRAMEWORK_DELAY);
    }, delay);
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Maintains custom user-agent state set by external consumers.
const $249caee721b519ba$var$customUserAgentState = {};
/**
 * Sets custom user agent state which will be appended to applicable requests. Returns a function that can be used to
 * clean up any custom state set with this API.
 *
 * @note
 * This API operates globally. Calling this API multiple times will result in the most recently set values for a
 * particular API being used.
 *
 * @note
 * This utility IS NOT compatible with SSR.
 *
 * @param input - SetCustomUserAgentInput that defines custom state to apply to the specified APIs.
 */ const $249caee721b519ba$export$20cd2fa9001e90da = (input)=>{
    // Save custom user-agent state & increment reference counter
    // TODO Remove `any` when we upgrade to TypeScript 5.2, see: https://github.com/microsoft/TypeScript/issues/44373
    $249caee721b519ba$var$customUserAgentState[input.category] = input.apis.reduce((acc, api)=>({
            ...acc,
            [api]: {
                refCount: acc[api]?.refCount ? acc[api].refCount + 1 : 1,
                additionalDetails: input.additionalDetails
            }
        }), $249caee721b519ba$var$customUserAgentState[input.category] ?? {});
    // Callback that cleans up state for APIs recorded by this call
    let cleanUpCallbackCalled = false;
    const cleanUpCallback = ()=>{
        // Only allow the cleanup callback to be called once
        if (cleanUpCallbackCalled) return;
        cleanUpCallbackCalled = true;
        input.apis.forEach((api)=>{
            const apiRefCount = $249caee721b519ba$var$customUserAgentState[input.category][api].refCount;
            if (apiRefCount > 1) $249caee721b519ba$var$customUserAgentState[input.category][api].refCount = apiRefCount - 1;
            else {
                delete $249caee721b519ba$var$customUserAgentState[input.category][api];
                // Clean up category if no more APIs set
                if (!Object.keys($249caee721b519ba$var$customUserAgentState[input.category]).length) delete $249caee721b519ba$var$customUserAgentState[input.category];
            }
        });
    };
    return cleanUpCallback;
};
const $249caee721b519ba$export$e399dbcfd99a2928 = (category, api)=>$249caee721b519ba$var$customUserAgentState[category]?.[api]?.additionalDetails;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $168115e008576aa6$var$BASE_USER_AGENT = `aws-amplify`;
class $168115e008576aa6$var$PlatformBuilder {
    constructor(){
        this.userAgent = `${$168115e008576aa6$var$BASE_USER_AGENT}/${0, $7166750678680fba$export$83d89fbfd8236492}`;
    }
    get framework() {
        return (0, $1aea29c5836b8523$export$9ce73e459ec93b6a)();
    }
    get isReactNative() {
        return this.framework === (0, $46bbfb42d61f6c30$export$638889172ebce0c4).ReactNative || this.framework === (0, $46bbfb42d61f6c30$export$638889172ebce0c4).Expo;
    }
    observeFrameworkChanges(fcn) {
        (0, $1aea29c5836b8523$export$5d5c467ce0b213f)(fcn);
    }
}
const $168115e008576aa6$export$2dffd0b5373a4389 = new $168115e008576aa6$var$PlatformBuilder();
const $168115e008576aa6$export$7d201307d8979e21 = ({ category: category, action: action, framework: framework } = {})=>{
    const userAgent = [
        [
            $168115e008576aa6$var$BASE_USER_AGENT,
            (0, $7166750678680fba$export$83d89fbfd8236492)
        ]
    ];
    if (category) userAgent.push([
        category,
        action
    ]);
    userAgent.push([
        "framework",
        (0, $1aea29c5836b8523$export$9ce73e459ec93b6a)()
    ]);
    if (category && action) {
        const customState = (0, $249caee721b519ba$export$e399dbcfd99a2928)(category, action);
        if (customState) customState.forEach((state)=>{
            userAgent.push(state);
        });
    }
    return userAgent;
};
const $168115e008576aa6$export$ede38edb26c0bfdf = (customUserAgentDetails)=>{
    const userAgent = $168115e008576aa6$export$7d201307d8979e21(customUserAgentDetails);
    const userAgentString = userAgent.map(([agentKey, agentValue])=>agentKey && agentValue ? `${agentKey}/${agentValue}` : agentKey).join(" ");
    return userAgentString;
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $d2a71a2354345443$var$SERVICE_NAME = "cognito-identity";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ const $d2a71a2354345443$var$endpointResolver = ({ region: region })=>({
        url: new (0, $3d238183541c5736$export$beb82d9d9136c16e)(`https://cognito-identity.${region}.${(0, $69b277fb5751e237$export$1c28e37cdcc37f6d)(region)}`)
    });
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $d2a71a2354345443$var$disableCacheMiddleware = ()=>(next, context)=>async function disableCacheMiddleware(request) {
            request.headers["cache-control"] = "no-store";
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $d2a71a2354345443$export$8029646671d2c482 = (0, $d788a4476fee6b12$export$f074d76e52925468)((0, $4421e2658594d439$export$ed7e1ccf00f39c4a), [
    $d2a71a2354345443$var$disableCacheMiddleware
]);
/**
 * @internal
 */ const $d2a71a2354345443$export$f84bd70098573c5c = {
    service: $d2a71a2354345443$var$SERVICE_NAME,
    endpointResolver: $d2a71a2354345443$var$endpointResolver,
    retryDecider: (0, $56e16fa9d36ecd04$export$b919d98317a7685f)((0, $058833fc00397105$export$be467dfcc0538e25)),
    computeDelay: (0, $3ffa800d030e0eeb$export$caea50bde345f648),
    userAgentValue: (0, $168115e008576aa6$export$ede38edb26c0bfdf)(),
    cache: "no-store"
};
(0, $1aea29c5836b8523$export$5d5c467ce0b213f)(()=>{
    $d2a71a2354345443$export$f84bd70098573c5c.userAgentValue = (0, $168115e008576aa6$export$ede38edb26c0bfdf)();
});
/**
 * @internal
 */ const $d2a71a2354345443$export$a46bbeaba09f7285 = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityService.${operation}`
    });
/**
 * @internal
 */ const $d2a71a2354345443$export$a692bdb7eb624f96 = ({ url: url }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $777e4d0f6d28dad9$export$880429a8ae983d4d = (transferHandler, serializer, deserializer, defaultConfig)=>{
    return async (config, input)=>{
        const resolvedConfig = {
            ...defaultConfig,
            ...config
        };
        // We may want to allow different endpoints from given config(other than region) and input.
        // Currently S3 supports additional `useAccelerateEndpoint` option to use accelerate endpoint.
        const endpoint = await resolvedConfig.endpointResolver(resolvedConfig, input);
        // Unlike AWS SDK clients, a serializer should NOT populate the `host` or `content-length` headers.
        // Both of these headers are prohibited per Spec(https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name).
        // They will be populated automatically by browser, or node-fetch polyfill.
        const request = await serializer(input, endpoint);
        const response = await transferHandler(request, {
            ...resolvedConfig
        });
        return await deserializer(response);
    };
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c001946b7ae88541$var$getIdSerializer = (input, endpoint)=>{
    const headers = (0, $d2a71a2354345443$export$a46bbeaba09f7285)("GetId");
    const body = JSON.stringify(input);
    return (0, $d2a71a2354345443$export$a692bdb7eb624f96)(endpoint, headers, body);
};
const $c001946b7ae88541$var$getIdDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $058833fc00397105$export$be467dfcc0538e25)(response);
        throw error;
    } else {
        const body = await (0, $058833fc00397105$export$759bcb35b0d1bf81)(response);
        return {
            IdentityId: body.IdentityId,
            $metadata: (0, $60ffc89c13d099ad$export$978f9418fe0cb26c)(response)
        };
    }
};
/**
 * @internal
 */ const $c001946b7ae88541$export$218c8c3169c024d2 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d2a71a2354345443$export$8029646671d2c482), $c001946b7ae88541$var$getIdSerializer, $c001946b7ae88541$var$getIdDeserializer, (0, $d2a71a2354345443$export$f84bd70098573c5c));




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $02a1ee431875bfed$export$d4a625cede2da71b(userPoolId) {
    const region = userPoolId?.split("_")[0];
    if (!userPoolId || userPoolId.indexOf("_") < 0 || !region || typeof region !== "string") throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: "InvalidUserPoolId",
        message: "Invalid user pool id provided."
    });
    return region;
}
function $02a1ee431875bfed$export$8fb32fba519c460(identityPoolId) {
    if (!identityPoolId || !identityPoolId.includes(":")) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: "InvalidIdentityPoolIdException",
        message: "Invalid identity pool id provided.",
        recoverySuggestion: "Make sure a valid identityPoolId is given in the config."
    });
    return identityPoolId.split(":")[0];
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $d62edd5877abeae2$export$edfb13e85a2c0dc4(idToken) {
    const issuer = (0, $a6de0542b1980a7d$export$9a62e6c0a30e00bc)(idToken).payload.iss;
    const res = {};
    if (!issuer) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: "InvalidIdTokenException",
        message: "Invalid Idtoken."
    });
    let domainName = issuer.replace(/(^\w+:|^)\/\//, "");
    res[domainName] = idToken;
    return res;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $69a8e7b99c952343$var$logger = new (0, $b5731988345712b1$export$ba6a9c7ac8291f7f)("CognitoIdentityIdProvider");
/**
 * Provides a Cognito identityId
 *
 * @param tokens - The AuthTokens received after SignIn
 * @returns string
 * @throws configuration excpetions: {@link InvalidIdentityPoolIdException }
 *  - Auth errors that may arise from misconfiguration.
 * @throws service excpetions: {@link GetIdException }
 */ async function $69a8e7b99c952343$export$7c3e576630d5e301({ tokens: tokens, authConfig: authConfig, identityIdStore: identityIdStore }) {
    identityIdStore.setAuthConfig({
        Cognito: authConfig
    });
    // will return null only if there is no identityId cached or if there is an error retrieving it
    let identityId = await identityIdStore.loadIdentityId();
    // Tokens are available so return primary identityId
    if (tokens) {
        // If there is existing primary identityId in-memory return that
        if (identityId && identityId.type === "primary") return identityId.id;
        else {
            const logins = tokens.idToken ? (0, $d62edd5877abeae2$export$edfb13e85a2c0dc4)(tokens.idToken.toString()) : {};
            const generatedIdentityId = await $69a8e7b99c952343$var$generateIdentityId(logins, authConfig);
            if (identityId && identityId.id === generatedIdentityId) $69a8e7b99c952343$var$logger.debug(`The guest identity ${identityId.id} has become the primary identity.`);
            identityId = {
                id: generatedIdentityId,
                type: "primary"
            };
        }
    } else {
        // If there is existing guest identityId cached return that
        if (identityId && identityId.type === "guest") return identityId.id;
        else identityId = {
            id: await $69a8e7b99c952343$var$generateIdentityId({}, authConfig),
            type: "guest"
        };
    }
    // Store in-memory or local storage depending on guest or primary identityId
    identityIdStore.storeIdentityId(identityId);
    return identityId.id;
}
async function $69a8e7b99c952343$var$generateIdentityId(logins, authConfig) {
    const identityPoolId = authConfig?.identityPoolId;
    const region = (0, $02a1ee431875bfed$export$8fb32fba519c460)(identityPoolId);
    // IdentityId is absent so get it using IdentityPoolId with Cognito's GetId API
    const idResult = // for a first-time user, this will return a brand new identity
    // for a returning user, this will retrieve the previous identity assocaited with the logins
    (await (0, $c001946b7ae88541$export$218c8c3169c024d2)({
        region: region
    }, {
        IdentityPoolId: identityPoolId,
        Logins: logins
    })).IdentityId;
    if (!idResult) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: "GetIdResponseException",
        message: "Received undefined response from getId operation",
        recoverySuggestion: "Make sure to pass a valid identityPoolId in the configuration."
    });
    return idResult;
}










// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $44298f3de76dbbb6$var$getCredentialsForIdentitySerializer = (input, endpoint)=>{
    const headers = (0, $d2a71a2354345443$export$a46bbeaba09f7285)("GetCredentialsForIdentity");
    const body = JSON.stringify(input);
    return (0, $d2a71a2354345443$export$a692bdb7eb624f96)(endpoint, headers, body);
};
const $44298f3de76dbbb6$var$getCredentialsForIdentityDeserializer = async (response)=>{
    if (response.statusCode >= 300) {
        const error = await (0, $058833fc00397105$export$be467dfcc0538e25)(response);
        throw error;
    } else {
        const body = await (0, $058833fc00397105$export$759bcb35b0d1bf81)(response);
        return {
            IdentityId: body.IdentityId,
            Credentials: $44298f3de76dbbb6$var$deserializeCredentials(body.Credentials),
            $metadata: (0, $60ffc89c13d099ad$export$978f9418fe0cb26c)(response)
        };
    }
};
const $44298f3de76dbbb6$var$deserializeCredentials = ({ AccessKeyId: AccessKeyId, SecretKey: SecretKey, SessionToken: SessionToken, Expiration: Expiration } = {})=>{
    return {
        AccessKeyId: AccessKeyId,
        SecretKey: SecretKey,
        SessionToken: SessionToken,
        Expiration: Expiration && new Date(Expiration * 1000)
    };
};
/**
 * @internal
 */ const $44298f3de76dbbb6$export$a49c1c173ab96b58 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d2a71a2354345443$export$8029646671d2c482), $44298f3de76dbbb6$var$getCredentialsForIdentitySerializer, $44298f3de76dbbb6$var$getCredentialsForIdentityDeserializer, (0, $d2a71a2354345443$export$f84bd70098573c5c));







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7674474451b5177a$export$d29d1996d6b6f5e3 = "UserUnAuthenticatedException";
const $7674474451b5177a$export$bdd0e7e9babcd5c8 = "UserAlreadyAuthenticatedException";
const $7674474451b5177a$export$740e7000ac27ebf3 = "DeviceMetadataNotFoundException";
const $7674474451b5177a$export$fe46a12932d2550a = "AutoSignInException";
const $7674474451b5177a$export$36f9d08d6bc647dd = "InvalidRedirectException";
const $7674474451b5177a$export$60b68b138a52e5ae = new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
    name: $7674474451b5177a$export$36f9d08d6bc647dd,
    message: "signInRedirect or signOutRedirect had an invalid format or was not found.",
    recoverySuggestion: "Please make sure the signIn/Out redirect in your oauth config is valid."
});
const $7674474451b5177a$export$27ddc47447101bcf = "InvalidOriginException";
const $7674474451b5177a$export$c01b4acd6291e035 = new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
    name: $7674474451b5177a$export$27ddc47447101bcf,
    message: "redirect is coming from a different origin. The oauth flow needs to be initiated from the same origin",
    recoverySuggestion: "Please call signInWithRedirect from the same origin."
});
const $7674474451b5177a$export$625255707e22459c = "OAuthSignOutException";


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $627294a07e5270d4$export$d76f9f8544dc304d(authConfig) {
    if (authConfig && authConfig.Cognito.userPoolId && authConfig.Cognito.userPoolClientId) return true;
    return false;
}
function $627294a07e5270d4$export$77712ea5882cac9f(tokens) {
    if (!tokens || !tokens.accessToken) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: (0, $7674474451b5177a$export$d29d1996d6b6f5e3),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
function $627294a07e5270d4$export$f4d99632f0717a4b(tokens) {
    if (!tokens || !tokens.idToken) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: (0, $7674474451b5177a$export$d29d1996d6b6f5e3),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
function $627294a07e5270d4$export$be38b2d22222d505(tokens) {
    if (!tokens || !tokens.accessToken || !tokens.refreshToken) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: (0, $7674474451b5177a$export$d29d1996d6b6f5e3),
        message: "User needs to be authenticated to call this API.",
        recoverySuggestion: "Sign in before calling this API again."
    });
}
function $627294a07e5270d4$export$b6f03be79626ab0f(deviceMetadata) {
    if (!deviceMetadata || !deviceMetadata.deviceKey || !deviceMetadata.deviceGroupKey || !deviceMetadata.randomPassword) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: (0, $7674474451b5177a$export$740e7000ac27ebf3),
        message: "Either deviceKey, deviceGroupKey or secretPassword were not found during the sign-in process.",
        recoverySuggestion: "Make sure to not clear storage after calling the signIn API."
    });
}
const $627294a07e5270d4$export$3820b4ff343394ea = {
    inflightOAuth: "inflightOAuth",
    oauthSignIn: "oauthSignIn",
    oauthPKCE: "oauthPKCE",
    oauthState: "oauthState"
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $963364a545dc0879$var$logger = new (0, $b5731988345712b1$export$ba6a9c7ac8291f7f)("CognitoCredentialsProvider");
const $963364a545dc0879$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
class $963364a545dc0879$export$be6550e37264dc26 {
    constructor(identityIdStore){
        this._nextCredentialsRefresh = 0;
        this._identityIdStore = identityIdStore;
    }
    async clearCredentialsAndIdentityId() {
        $963364a545dc0879$var$logger.debug("Clearing out credentials and identityId");
        this._credentialsAndIdentityId = undefined;
        await this._identityIdStore.clearIdentityId();
    }
    async clearCredentials() {
        $963364a545dc0879$var$logger.debug("Clearing out in-memory credentials");
        this._credentialsAndIdentityId = undefined;
    }
    async getCredentialsAndIdentityId(getCredentialsOptions) {
        const isAuthenticated = getCredentialsOptions.authenticated;
        const tokens = getCredentialsOptions.tokens;
        const authConfig = getCredentialsOptions.authConfig;
        try {
            (0, $a6de0542b1980a7d$export$8a2f5318ea3215e3)(authConfig?.Cognito);
        } catch  {
            // No identity pool configured, skipping
            return;
        }
        if (!isAuthenticated && !authConfig.Cognito.allowGuestAccess) // TODO(V6): return partial result like Native platforms
        return;
        const forceRefresh = getCredentialsOptions.forceRefresh;
        const tokenHasChanged = this.hasTokenChanged(tokens);
        const identityId = await (0, $69a8e7b99c952343$export$7c3e576630d5e301)({
            tokens: tokens,
            authConfig: authConfig.Cognito,
            identityIdStore: this._identityIdStore
        });
        // Clear cached credentials when forceRefresh is true OR the cache token has changed
        if (forceRefresh || tokenHasChanged) this.clearCredentials();
        if (!isAuthenticated) return this.getGuestCredentials(identityId, authConfig.Cognito);
        else {
            (0, $627294a07e5270d4$export$f4d99632f0717a4b)(tokens);
            return this.credsForOIDCTokens(authConfig.Cognito, tokens, identityId);
        }
    }
    async getGuestCredentials(identityId, authConfig) {
        // Return existing in-memory cached credentials only if it exists, is not past it's lifetime and is unauthenticated credentials
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === false) {
            $963364a545dc0879$var$logger.info("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any authenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const region = (0, $02a1ee431875bfed$export$8fb32fba519c460)(authConfig.identityPoolId);
        // use identityId to obtain guest credentials
        // save credentials in-memory
        // No logins params should be passed for guest creds:
        // https://docs.aws.amazon.com/cognitoidentity/latest/APIReference/API_GetCredentialsForIdentity.html
        const clientResult = await (0, $44298f3de76dbbb6$export$a49c1c173ab96b58)({
            region: region
        }, {
            IdentityId: identityId
        });
        if (clientResult.Credentials && clientResult.Credentials.AccessKeyId && clientResult.Credentials.SecretKey) {
            this._nextCredentialsRefresh = new Date().getTime() + $963364a545dc0879$var$CREDENTIALS_TTL;
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            const identityIdRes = clientResult.IdentityId;
            if (identityIdRes) {
                res.identityId = identityIdRes;
                this._identityIdStore.storeIdentityId({
                    id: identityIdRes,
                    type: "guest"
                });
            }
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: false
            };
            return res;
        } else throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
            name: "CredentialsNotFoundException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    async credsForOIDCTokens(authConfig, authTokens, identityId) {
        if (this._credentialsAndIdentityId && !this.isPastTTL() && this._credentialsAndIdentityId.isAuthenticatedCreds === true) {
            $963364a545dc0879$var$logger.debug("returning stored credentials as they neither past TTL nor expired.");
            return this._credentialsAndIdentityId;
        }
        // Clear to discard if any unauthenticated credentials are set and start with a clean slate
        this.clearCredentials();
        const logins = authTokens.idToken ? (0, $d62edd5877abeae2$export$edfb13e85a2c0dc4)(authTokens.idToken.toString()) : {};
        const region = (0, $02a1ee431875bfed$export$8fb32fba519c460)(authConfig.identityPoolId);
        const clientResult = await (0, $44298f3de76dbbb6$export$a49c1c173ab96b58)({
            region: region
        }, {
            IdentityId: identityId,
            Logins: logins
        });
        if (clientResult.Credentials && clientResult.Credentials.AccessKeyId && clientResult.Credentials.SecretKey) {
            const res = {
                credentials: {
                    accessKeyId: clientResult.Credentials.AccessKeyId,
                    secretAccessKey: clientResult.Credentials.SecretKey,
                    sessionToken: clientResult.Credentials.SessionToken,
                    expiration: clientResult.Credentials.Expiration
                },
                identityId: identityId
            };
            // Store the credentials in-memory along with the expiration
            this._credentialsAndIdentityId = {
                ...res,
                isAuthenticatedCreds: true,
                associatedIdToken: authTokens.idToken?.toString()
            };
            this._nextCredentialsRefresh = new Date().getTime() + $963364a545dc0879$var$CREDENTIALS_TTL;
            const identityIdRes = clientResult.IdentityId;
            if (identityIdRes) {
                res.identityId = identityIdRes;
                this._identityIdStore.storeIdentityId({
                    id: identityIdRes,
                    type: "primary"
                });
            }
            return res;
        } else throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
            name: "CredentialsException",
            message: `Cognito did not respond with either Credentials, AccessKeyId or SecretKey.`
        });
    }
    isPastTTL() {
        return this._nextCredentialsRefresh === undefined ? true : this._nextCredentialsRefresh <= Date.now();
    }
    hasTokenChanged(tokens) {
        return !!tokens && !!this._credentialsAndIdentityId?.associatedIdToken && tokens.idToken?.toString() !== this._credentialsAndIdentityId.associatedIdToken;
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Cognito specific implmentation of the CredentialsProvider interface
 * that manages setting and getting of AWS Credentials.
 *
 * @throws configuration expections: {@link InvalidIdentityPoolIdException }
 *  - Auth errors that may arise from misconfiguration.
 * @throws service expections: {@link GetCredentialsForIdentityException}, {@link GetIdException}
 *
 */ const $157283527480dee8$export$be43b753aec531e2 = new (0, $963364a545dc0879$export$be6550e37264dc26)(new (0, $da1e6f27f874c7b8$export$3e97b78667a539a0)((0, $68ccea2c33038f88$export$586b30dcaeecb901)));








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The service name used to sign requests if the API requires authentication.
 */ const $d9c14f2b3f9d0970$var$SERVICE_NAME = "cognito-idp";
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */ const $d9c14f2b3f9d0970$var$endpointResolver = ({ region: region })=>{
    const authConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const customURL = authConfig?.userPoolEndpoint;
    const defaultURL = new (0, $3d238183541c5736$export$beb82d9d9136c16e)(`https://${$d9c14f2b3f9d0970$var$SERVICE_NAME}.${region}.${(0, $69b277fb5751e237$export$1c28e37cdcc37f6d)(region)}`);
    return {
        url: customURL ? new (0, $3d238183541c5736$export$beb82d9d9136c16e)(customURL) : defaultURL
    };
};
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */ const $d9c14f2b3f9d0970$var$disableCacheMiddleware = ()=>(next, context)=>async function disableCacheMiddleware(request) {
            request.headers["cache-control"] = "no-store";
            return next(request);
        };
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */ const $d9c14f2b3f9d0970$export$10f11e95d7a96f7b = (0, $d788a4476fee6b12$export$f074d76e52925468)((0, $4421e2658594d439$export$ed7e1ccf00f39c4a), [
    $d9c14f2b3f9d0970$var$disableCacheMiddleware
]);
/**
 * @internal
 */ const $d9c14f2b3f9d0970$export$f84bd70098573c5c = {
    service: $d9c14f2b3f9d0970$var$SERVICE_NAME,
    endpointResolver: $d9c14f2b3f9d0970$var$endpointResolver,
    retryDecider: (0, $56e16fa9d36ecd04$export$b919d98317a7685f)((0, $058833fc00397105$export$be467dfcc0538e25)),
    computeDelay: (0, $3ffa800d030e0eeb$export$caea50bde345f648),
    userAgentValue: (0, $168115e008576aa6$export$ede38edb26c0bfdf)(),
    cache: "no-store"
};
/**
 * @internal
 */ const $d9c14f2b3f9d0970$export$a46bbeaba09f7285 = (operation)=>({
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `AWSCognitoIdentityProviderService.${operation}`
    });
/**
 * @internal
 */ const $d9c14f2b3f9d0970$export$a692bdb7eb624f96 = ({ url: url }, headers, body)=>({
        headers: headers,
        url: url,
        body: body,
        method: "POST"
    });





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $76ca3faab5b9192a$export$5b3890f50cd4853f(error) {
    if (!error || error.name === "Error" || error instanceof TypeError) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: (0, $2cba3f44341f04f9$export$4e712df6b850c8d0).Unknown,
        message: "An unknown error has ocurred.",
        underlyingError: error
    });
}



const $c845c6a72bc4ff0c$var$buildUserPoolSerializer = (operation)=>(input, endpoint)=>{
        const headers = (0, $d9c14f2b3f9d0970$export$a46bbeaba09f7285)(operation);
        const body = JSON.stringify(input);
        return (0, $d9c14f2b3f9d0970$export$a692bdb7eb624f96)(endpoint, headers, body);
    };
const $c845c6a72bc4ff0c$var$buildUserPoolDeserializer = ()=>{
    return async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $058833fc00397105$export$be467dfcc0538e25)(response);
            (0, $76ca3faab5b9192a$export$5b3890f50cd4853f)(error);
            throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
                name: error.name,
                message: error.message
            });
        } else {
            const body = await (0, $058833fc00397105$export$759bcb35b0d1bf81)(response);
            return body;
        }
    };
};
const $c845c6a72bc4ff0c$var$handleEmptyResponseDeserializer = ()=>{
    return async (response)=>{
        if (response.statusCode >= 300) {
            const error = await (0, $058833fc00397105$export$be467dfcc0538e25)(response);
            (0, $76ca3faab5b9192a$export$5b3890f50cd4853f)(error);
            throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
                name: error.name,
                message: error.message
            });
        } else return undefined;
    };
};
const $c845c6a72bc4ff0c$export$567b0d5ec943f827 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("InitiateAuth"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$2428f6ba65615593 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("RevokeToken"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$cf64224bcd829024 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("SignUp"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$2ce39ab6662e8c24 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("ConfirmSignUp"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$66791fb2cfeec3e = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("ForgotPassword"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$c7a5d0826ce3a2b2 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("ConfirmForgotPassword"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$b196467a22b300ec = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("RespondToAuthChallenge"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$f24137cafeaef1a1 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("ResendConfirmationCode"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$72b1124e126ff51c = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("VerifySoftwareToken"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$4531a27964554be8 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("AssociateSoftwareToken"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$b6a1b2cc7e7e6b1e = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("SetUserMFAPreference"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$7cbf767827cd68ba = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("GetUser"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$99d837dc30eb1ef7 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("ChangePassword"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$3a7ad63dc35b752f = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("ConfirmDevice"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$d0b7632b5e5fb312 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("ForgetDevice"), $c845c6a72bc4ff0c$var$handleEmptyResponseDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$7d0f10f273c0438a = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("DeleteUser"), $c845c6a72bc4ff0c$var$handleEmptyResponseDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$3a9721eaccd0e7b3 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("GetUserAttributeVerificationCode"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$a92c2ab9b6303723 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("GlobalSignOut"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$16ff8cb4f547be0 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("UpdateUserAttributes"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$40fc6c986f86e9a5 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("VerifyUserAttribute"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$e1c4af6b7c9755a8 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("UpdateDeviceStatus"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$11154f886a75108 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("ListDevices"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));
const $c845c6a72bc4ff0c$export$a97f0f1c87d00e1 = (0, $777e4d0f6d28dad9$export$880429a8ae983d4d)((0, $d9c14f2b3f9d0970$export$10f11e95d7a96f7b), $c845c6a72bc4ff0c$var$buildUserPoolSerializer("DeleteUserAttributes"), $c845c6a72bc4ff0c$var$buildUserPoolDeserializer(), (0, $d9c14f2b3f9d0970$export$f84bd70098573c5c));





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $30f7d7d7c5349180$export$b6e6cdd1f90faa62({ username: username, userPoolId: userPoolId, userPoolClientId: userPoolClientId }) {
    if (typeof window === "undefined") return undefined;
    const amazonCognitoAdvancedSecurityData = window.AmazonCognitoAdvancedSecurityData;
    if (typeof amazonCognitoAdvancedSecurityData === "undefined") return undefined;
    const advancedSecurityData = amazonCognitoAdvancedSecurityData.getData(username, userPoolId, userPoolClientId);
    if (advancedSecurityData) {
        const userContextData = {
            EncodedData: advancedSecurityData
        };
        return userContextData;
    }
    return {};
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $951ce68e55c4d6b3$export$ab413c2cb4a135d9 = async ({ tokens: tokens, authConfig: authConfig, username: username })=>{
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig?.Cognito);
    const region = (0, $02a1ee431875bfed$export$d4a625cede2da71b)(authConfig.Cognito.userPoolId);
    (0, $627294a07e5270d4$export$be38b2d22222d505)(tokens);
    const refreshTokenString = tokens.refreshToken;
    const AuthParameters = {
        REFRESH_TOKEN: refreshTokenString
    };
    if (tokens.deviceMetadata?.deviceKey) AuthParameters["DEVICE_KEY"] = tokens.deviceMetadata.deviceKey;
    const UserContextData = (0, $30f7d7d7c5349180$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: authConfig.Cognito.userPoolId,
        userPoolClientId: authConfig.Cognito.userPoolClientId
    });
    const { AuthenticationResult: AuthenticationResult } = await (0, $c845c6a72bc4ff0c$export$567b0d5ec943f827)({
        region: region
    }, {
        ClientId: authConfig?.Cognito?.userPoolClientId,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: AuthParameters,
        UserContextData: UserContextData
    });
    const accessToken = (0, $a6de0542b1980a7d$export$9a62e6c0a30e00bc)(AuthenticationResult?.AccessToken ?? "");
    const idToken = AuthenticationResult?.IdToken ? (0, $a6de0542b1980a7d$export$9a62e6c0a30e00bc)(AuthenticationResult.IdToken) : undefined;
    const iat = accessToken.payload.iat;
    // This should never happen. If it does, it's a bug from the service.
    if (!iat) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: "iatNotFoundException",
        message: "iat not found in access token"
    });
    const clockDrift = iat * 1000 - new Date().getTime();
    return {
        accessToken: accessToken,
        idToken: idToken,
        clockDrift: clockDrift,
        refreshToken: refreshTokenString,
        username: username
    };
};







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $a56b24d68d9caa90$export$ba2f3fbc8979d2e6 {
    constructor(){
        this.waitForInflightOAuth = async ()=>{};
    }
    setAuthConfig(authConfig) {
        this.authConfig = authConfig;
    }
    setTokenRefresher(tokenRefresher) {
        this.tokenRefresher = tokenRefresher;
    }
    setAuthTokenStore(tokenStore) {
        this.tokenStore = tokenStore;
    }
    setWaitForInflightOAuth(waitForInflightOAuth) {
        this.waitForInflightOAuth = waitForInflightOAuth;
    }
    getTokenStore() {
        if (!this.tokenStore) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
            name: "EmptyTokenStoreException",
            message: "TokenStore not set"
        });
        return this.tokenStore;
    }
    getTokenRefresher() {
        if (!this.tokenRefresher) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
            name: "EmptyTokenRefresherException",
            message: "TokenRefresher not set"
        });
        return this.tokenRefresher;
    }
    async getTokens(options) {
        let tokens;
        try {
            (0, $a6de0542b1980a7d$export$80c92581e59ed502)(this.authConfig?.Cognito);
        } catch (_err) {
            // Token provider not configured
            return null;
        }
        await this.waitForInflightOAuth();
        tokens = await this.getTokenStore().loadTokens();
        const username = await this.getTokenStore().getLastAuthUser();
        if (tokens === null) return null;
        const idTokenExpired = !!tokens?.idToken && (0, $2366596acf6620df$export$b007d77a962aa175)({
            expiresAt: (tokens.idToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        const accessTokenExpired = (0, $2366596acf6620df$export$b007d77a962aa175)({
            expiresAt: (tokens.accessToken?.payload?.exp ?? 0) * 1000,
            clockDrift: tokens.clockDrift ?? 0
        });
        if (options?.forceRefresh || idTokenExpired || accessTokenExpired) {
            tokens = await this.refreshTokens({
                tokens: tokens,
                username: username
            });
            if (tokens === null) return null;
        }
        return {
            accessToken: tokens?.accessToken,
            idToken: tokens?.idToken,
            signInDetails: tokens?.signInDetails
        };
    }
    async refreshTokens({ tokens: tokens, username: username }) {
        try {
            const newTokens = await this.getTokenRefresher()({
                tokens: tokens,
                authConfig: this.authConfig,
                username: username
            });
            await this.setTokens({
                tokens: newTokens
            });
            (0, $2f4552e504bc473c$export$8c41bb232f1008b1).dispatch("auth", {
                event: "tokenRefresh"
            }, "Auth", (0, $2f4552e504bc473c$export$aadf71dd9875dd20));
            return newTokens;
        } catch (err) {
            return this.handleErrors(err);
        }
    }
    handleErrors(err) {
        (0, $76ca3faab5b9192a$export$5b3890f50cd4853f)(err);
        if (err.message !== "Network error") // TODO(v6): Check errors on client
        this.clearTokens();
        if (err.name.startsWith("NotAuthorizedException")) return null;
        else {
            (0, $2f4552e504bc473c$export$8c41bb232f1008b1).dispatch("auth", {
                event: "tokenRefresh_failure"
            }, "Auth", (0, $2f4552e504bc473c$export$aadf71dd9875dd20));
            throw err;
        }
    }
    async setTokens({ tokens: tokens }) {
        return this.getTokenStore().storeTokens(tokens);
    }
    async clearTokens() {
        return this.getTokenStore().clearTokens();
    }
    getDeviceMetadata(username) {
        return this.getTokenStore().getDeviceMetadata(username);
    }
    clearDeviceMetadata(username) {
        return this.getTokenStore().clearDeviceMetadata(username);
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
class $c6bbd61934ed7f36$var$CognitoUserPoolsTokenProviderClass {
    constructor(){
        this.authTokenStore = new (0, $bf28e6bdff0fcfed$export$a36be852d43d512)();
        this.authTokenStore.setKeyValueStorage((0, $68ccea2c33038f88$export$586b30dcaeecb901));
        this.tokenOrchestrator = new (0, $a56b24d68d9caa90$export$ba2f3fbc8979d2e6)();
        this.tokenOrchestrator.setAuthTokenStore(this.authTokenStore);
        this.tokenOrchestrator.setTokenRefresher((0, $951ce68e55c4d6b3$export$ab413c2cb4a135d9));
    }
    getTokens({ forceRefresh: forceRefresh } = {
        forceRefresh: false
    }) {
        return this.tokenOrchestrator.getTokens({
            forceRefresh: forceRefresh
        });
    }
    setKeyValueStorage(keyValueStorage) {
        this.authTokenStore.setKeyValueStorage(keyValueStorage);
    }
    setWaitForInflightOAuth(waitForInflightOAuth) {
        this.tokenOrchestrator.setWaitForInflightOAuth(waitForInflightOAuth);
    }
    setAuthConfig(authConfig) {
        this.authTokenStore.setAuthConfig(authConfig);
        this.tokenOrchestrator.setAuthConfig(authConfig);
    }
}
const $c6bbd61934ed7f36$export$18e158b80aac31a7 = new $c6bbd61934ed7f36$var$CognitoUserPoolsTokenProviderClass();
const $c6bbd61934ed7f36$export$66561e66d62991d0 = $c6bbd61934ed7f36$export$18e158b80aac31a7.tokenOrchestrator;


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $657101dca2c3f08b$export$11ac3725994bec7b = {
    configure (resourceConfig, libraryOptions) {
        let resolvedResourceConfig;
        if (Object.keys(resourceConfig).some((key)=>key.startsWith("aws_"))) resolvedResourceConfig = (0, $0f9580331e403073$export$1ef2e9c2da492d)(resourceConfig);
        else resolvedResourceConfig = resourceConfig;
        // If no Auth config is provided, no special handling will be required, configure as is.
        // Otherwise, we can assume an Auth config is provided from here on.
        if (!resolvedResourceConfig.Auth) return (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).configure(resolvedResourceConfig, libraryOptions);
        // If Auth options are provided, always just configure as is.
        // Otherwise, we can assume no Auth libraryOptions were provided from here on.
        if (libraryOptions?.Auth) return (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).configure(resolvedResourceConfig, libraryOptions);
        // If no Auth libraryOptions were previously configured, then always add default providers.
        if (!(0, $623ac757f0e7ef86$export$a3858a9a153cffc7).libraryOptions.Auth) {
            (0, $c6bbd61934ed7f36$export$18e158b80aac31a7).setAuthConfig(resolvedResourceConfig.Auth);
            (0, $c6bbd61934ed7f36$export$18e158b80aac31a7).setKeyValueStorage(// TODO: allow configure with a public interface
            libraryOptions?.ssr ? new (0, $c5e12087ef38fe79$export$dae7d845015939d5)({
                sameSite: "lax"
            }) : (0, $68ccea2c33038f88$export$586b30dcaeecb901));
            return (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).configure(resolvedResourceConfig, {
                ...libraryOptions,
                Auth: {
                    tokenProvider: (0, $c6bbd61934ed7f36$export$18e158b80aac31a7),
                    credentialsProvider: (0, $157283527480dee8$export$be43b753aec531e2)
                }
            });
        }
        // At this point, Auth libraryOptions would have been previously configured and no overriding
        // Auth options were given, so we should preserve the currently configured Auth libraryOptions.
        if (libraryOptions) {
            // If ssr is provided through libraryOptions, we should respect the intentional reconfiguration.
            if (libraryOptions.ssr !== undefined) (0, $c6bbd61934ed7f36$export$18e158b80aac31a7).setKeyValueStorage(// TODO: allow configure with a public interface
            libraryOptions.ssr ? new (0, $c5e12087ef38fe79$export$dae7d845015939d5)({
                sameSite: "lax"
            }) : (0, $68ccea2c33038f88$export$586b30dcaeecb901));
            return (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).configure(resolvedResourceConfig, {
                Auth: (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).libraryOptions.Auth,
                ...libraryOptions
            });
        }
        // Finally, if there were no libraryOptions given at all, we should simply not touch the currently
        // configured libraryOptions.
        (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).configure(resolvedResourceConfig);
    },
    getConfig () {
        return (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig();
    }
};



var $3Py8h = parcelRequire("3Py8h");


var $61ffe96bb93d2a02$export$f86ab2f69f02b2d9;
(function(MoovyPalette) {
    MoovyPalette.primaryMain = "#0098d8";
    MoovyPalette.secondaryMain = "#085171";
    MoovyPalette.errorMain = "#ff4848";
    MoovyPalette.warningMain = "#E0732C";
    MoovyPalette.infoMain = MoovyPalette.primaryMain;
    MoovyPalette.successMain = "#0BCD61";
    MoovyPalette.commonBlue = "#555";
    MoovyPalette.commonBlack = "#555";
    MoovyPalette.commonWhite = "white";
    MoovyPalette.commonRed = "#ff4848";
    // TODO Antti: Should be change to be used via theme instead?
    MoovyPalette.colorMainBackground = "#f9fafb";
    MoovyPalette.colorTableHeader = "#efefef";
    // TODO Antti: Should be change to be used via theme instead?
    MoovyPalette.colorMenuUnderline = MoovyPalette.commonWhite;
    // TODO Antti: Should be change to be used via theme instead?
    MoovyPalette.progressBlockContentColor = "white";
    MoovyPalette.colorMenuBackgroundGradient = "linear-gradient(135deg, #08cbef 0%, #0098d8 99.43%);";
})($61ffe96bb93d2a02$export$f86ab2f69f02b2d9 || ($61ffe96bb93d2a02$export$f86ab2f69f02b2d9 = {}));
var $61ffe96bb93d2a02$export$6039b89271c3de71;
(function(MoovyStyle) {
    MoovyStyle.fontFamily = "Fira Sans, sans-serif";
    MoovyStyle.menuFontSize = "17px";
    MoovyStyle.menuFontWeight = 500;
    MoovyStyle.buttonFontWeight = 700;
    MoovyStyle.tableHeadFontWeight = 700;
})($61ffe96bb93d2a02$export$6039b89271c3de71 || ($61ffe96bb93d2a02$export$6039b89271c3de71 = {}));


var $783f6097b351748f$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $783f6097b351748f$export$18a094aefa070634 = (obj, member, getter)=>{
    $783f6097b351748f$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $783f6097b351748f$export$addf369becd23283 = (obj, member, value1)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
};
var $783f6097b351748f$export$42432efe6614d3b4 = (obj, member, value1, setter)=>{
    $783f6097b351748f$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value1) : member.set(obj, value1);
    return value1;
};
var $783f6097b351748f$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $783f6097b351748f$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $783f6097b351748f$export$18a094aefa070634(obj, member, getter);
        }
    });
var $783f6097b351748f$export$fa92d15b718fce20 = (obj, member, method)=>{
    $783f6097b351748f$var$__accessCheck(obj, member, "access private method");
    return method;
};



// src/utils.ts
var $c87861fcdbb7b7dc$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in window;
function $c87861fcdbb7b7dc$export$8793edee2d425525() {
    return void 0;
}
function $c87861fcdbb7b7dc$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $c87861fcdbb7b7dc$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $c87861fcdbb7b7dc$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $c87861fcdbb7b7dc$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $c87861fcdbb7b7dc$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$c87861fcdbb7b7dc$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $c87861fcdbb7b7dc$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($c87861fcdbb7b7dc$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $c87861fcdbb7b7dc$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$c87861fcdbb7b7dc$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $c87861fcdbb7b7dc$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $c87861fcdbb7b7dc$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $c87861fcdbb7b7dc$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$c87861fcdbb7b7dc$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $c87861fcdbb7b7dc$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$c87861fcdbb7b7dc$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $c87861fcdbb7b7dc$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $c87861fcdbb7b7dc$export$7a8558113332b71e(a) && $c87861fcdbb7b7dc$export$7a8558113332b71e(b);
    if (array || $c87861fcdbb7b7dc$export$53b83ca8eaab0383(a) && $c87861fcdbb7b7dc$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if (!array && a[key] === void 0 && b[key] === void 0 && aItems.includes(key)) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $c87861fcdbb7b7dc$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $c87861fcdbb7b7dc$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $c87861fcdbb7b7dc$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $c87861fcdbb7b7dc$export$53b83ca8eaab0383(o) {
    if (!$c87861fcdbb7b7dc$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
    const prot = ctor.prototype;
    if (!$c87861fcdbb7b7dc$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    return true;
}
function $c87861fcdbb7b7dc$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $c87861fcdbb7b7dc$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $c87861fcdbb7b7dc$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) return $c87861fcdbb7b7dc$export$77a71fc411098696(prevData, data);
    return data;
}
function $c87861fcdbb7b7dc$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $c87861fcdbb7b7dc$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $c87861fcdbb7b7dc$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}







// src/notifyManager.ts
function $8f286f9abfc2c252$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = (cb)=>setTimeout(cb, 0);
    const setScheduler = (fn)=>{
        scheduleFn = fn;
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction,
        setScheduler: setScheduler
    };
}
var $8f286f9abfc2c252$export$520687f44db6e1ab = $8f286f9abfc2c252$export$316a8efd03cd1458();





// src/subscribable.ts
var $3797a5406d67bffa$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $f0a8743d916c8b49$var$_focused, $f0a8743d916c8b49$var$_cleanup, $f0a8743d916c8b49$var$_setup;
var $f0a8743d916c8b49$export$86f1af424b2ca4de = class extends (0, $3797a5406d67bffa$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $783f6097b351748f$export$addf369becd23283)(this, $f0a8743d916c8b49$var$_focused, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $f0a8743d916c8b49$var$_cleanup, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $f0a8743d916c8b49$var$_setup, void 0);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $f0a8743d916c8b49$var$_setup, (onFocus)=>{
            if (!(0, $c87861fcdbb7b7dc$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $783f6097b351748f$export$18a094aefa070634)(this, $f0a8743d916c8b49$var$_cleanup)) this.setEventListener((0, $783f6097b351748f$export$18a094aefa070634)(this, $f0a8743d916c8b49$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $f0a8743d916c8b49$var$_cleanup)) == null || _a.call(this);
            (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $f0a8743d916c8b49$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $f0a8743d916c8b49$var$_setup, setup);
        (_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $f0a8743d916c8b49$var$_cleanup)) == null || _a.call(this);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $f0a8743d916c8b49$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $783f6097b351748f$export$18a094aefa070634)(this, $f0a8743d916c8b49$var$_focused) !== focused;
        if (changed) {
            (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $f0a8743d916c8b49$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach((listener)=>{
            listener();
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $783f6097b351748f$export$18a094aefa070634)(this, $f0a8743d916c8b49$var$_focused) === "boolean") return (0, $783f6097b351748f$export$18a094aefa070634)(this, $f0a8743d916c8b49$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$f0a8743d916c8b49$var$_focused = new WeakMap();
$f0a8743d916c8b49$var$_cleanup = new WeakMap();
$f0a8743d916c8b49$var$_setup = new WeakMap();
var $f0a8743d916c8b49$export$6bf54661be5b02cf = new $f0a8743d916c8b49$export$86f1af424b2ca4de();





var $1e0a508d8bcc0a38$var$_online, $1e0a508d8bcc0a38$var$_cleanup, $1e0a508d8bcc0a38$var$_setup;
var $1e0a508d8bcc0a38$export$58774fb55d5ff7fc = class extends (0, $3797a5406d67bffa$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $783f6097b351748f$export$addf369becd23283)(this, $1e0a508d8bcc0a38$var$_online, true);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $1e0a508d8bcc0a38$var$_cleanup, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $1e0a508d8bcc0a38$var$_setup, void 0);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $1e0a508d8bcc0a38$var$_setup, (onOnline)=>{
            if (!(0, $c87861fcdbb7b7dc$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $783f6097b351748f$export$18a094aefa070634)(this, $1e0a508d8bcc0a38$var$_cleanup)) this.setEventListener((0, $783f6097b351748f$export$18a094aefa070634)(this, $1e0a508d8bcc0a38$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $1e0a508d8bcc0a38$var$_cleanup)) == null || _a.call(this);
            (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $1e0a508d8bcc0a38$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $1e0a508d8bcc0a38$var$_setup, setup);
        (_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $1e0a508d8bcc0a38$var$_cleanup)) == null || _a.call(this);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $1e0a508d8bcc0a38$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $783f6097b351748f$export$18a094aefa070634)(this, $1e0a508d8bcc0a38$var$_online) !== online;
        if (changed) {
            (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $1e0a508d8bcc0a38$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $1e0a508d8bcc0a38$var$_online);
    }
};
$1e0a508d8bcc0a38$var$_online = new WeakMap();
$1e0a508d8bcc0a38$var$_cleanup = new WeakMap();
$1e0a508d8bcc0a38$var$_setup = new WeakMap();
var $1e0a508d8bcc0a38$export$b113e788b2dd3fdc = new $1e0a508d8bcc0a38$export$58774fb55d5ff7fc();



function $9bc3659d53db0b0e$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $9bc3659d53db0b0e$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $1e0a508d8bcc0a38$export$b113e788b2dd3fdc).isOnline() : true;
}
var $9bc3659d53db0b0e$export$a8430ed4188f35a9 = class {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $9bc3659d53db0b0e$export$986cc6445c1d323(value) {
    return value instanceof $9bc3659d53db0b0e$export$a8430ed4188f35a9;
}
function $9bc3659d53db0b0e$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved) {
            reject(new $9bc3659d53db0b0e$export$a8430ed4188f35a9(cancelOptions));
            (_a = config.abort) == null || _a.call(config);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $f0a8743d916c8b49$export$6bf54661be5b02cf).isFocused() || config.networkMode !== "always" && !(0, $1e0a508d8bcc0a38$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onSuccess) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onError) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved) return;
            const retry = config.retry ?? ((0, $c87861fcdbb7b7dc$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $9bc3659d53db0b0e$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $c87861fcdbb7b7dc$export$e772c8ff12451969)(delay).then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    if ($9bc3659d53db0b0e$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}




var $7496e3581eead2f9$var$_gcTimeout;
var $7496e3581eead2f9$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $783f6097b351748f$export$addf369becd23283)(this, $7496e3581eead2f9$var$_gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $c87861fcdbb7b7dc$export$e539f754e934e270)(this.gcTime)) (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $7496e3581eead2f9$var$_gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $c87861fcdbb7b7dc$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $783f6097b351748f$export$18a094aefa070634)(this, $7496e3581eead2f9$var$_gcTimeout)) {
            clearTimeout((0, $783f6097b351748f$export$18a094aefa070634)(this, $7496e3581eead2f9$var$_gcTimeout));
            (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $7496e3581eead2f9$var$_gcTimeout, void 0);
        }
    }
};
$7496e3581eead2f9$var$_gcTimeout = new WeakMap();


var $7fe1f3bf3d40ed66$var$_initialState, $7fe1f3bf3d40ed66$var$_revertState, $7fe1f3bf3d40ed66$var$_cache, $7fe1f3bf3d40ed66$var$_promise, $7fe1f3bf3d40ed66$var$_retryer, $7fe1f3bf3d40ed66$var$_observers, $7fe1f3bf3d40ed66$var$_defaultOptions, $7fe1f3bf3d40ed66$var$_abortSignalConsumed, $7fe1f3bf3d40ed66$var$_setOptions, $7fe1f3bf3d40ed66$var$setOptions_fn, $7fe1f3bf3d40ed66$var$_dispatch, $7fe1f3bf3d40ed66$var$dispatch_fn;
var $7fe1f3bf3d40ed66$export$62297b13309008b2 = class extends (0, $7496e3581eead2f9$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $783f6097b351748f$export$addf369becd23283)(this, $7fe1f3bf3d40ed66$var$_setOptions);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $7fe1f3bf3d40ed66$var$_dispatch);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $7fe1f3bf3d40ed66$var$_initialState, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $7fe1f3bf3d40ed66$var$_revertState, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $7fe1f3bf3d40ed66$var$_cache, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $7fe1f3bf3d40ed66$var$_promise, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $7fe1f3bf3d40ed66$var$_retryer, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $7fe1f3bf3d40ed66$var$_observers, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $7fe1f3bf3d40ed66$var$_defaultOptions, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $7fe1f3bf3d40ed66$var$_abortSignalConsumed, void 0);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $7fe1f3bf3d40ed66$var$_abortSignalConsumed, false);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $7fe1f3bf3d40ed66$var$_defaultOptions, config.defaultOptions);
        (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $7fe1f3bf3d40ed66$var$_setOptions, $7fe1f3bf3d40ed66$var$setOptions_fn).call(this, config.options);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $7fe1f3bf3d40ed66$var$_observers, []);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $7fe1f3bf3d40ed66$var$_cache, config.cache);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $7fe1f3bf3d40ed66$var$_initialState, config.state || $7fe1f3bf3d40ed66$var$getDefaultState(this.options));
        this.state = (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    optionalRemove() {
        if (!(0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_observers).length && this.state.fetchStatus === "idle") (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $c87861fcdbb7b7dc$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $7fe1f3bf3d40ed66$var$_dispatch, $7fe1f3bf3d40ed66$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $7fe1f3bf3d40ed66$var$_dispatch, $7fe1f3bf3d40ed66$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a;
        const promise = (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_promise);
        (_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_retryer)) == null || _a.cancel(options);
        return promise ? promise.then((0, $c87861fcdbb7b7dc$export$8793edee2d425525)).catch((0, $c87861fcdbb7b7dc$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_initialState));
    }
    isActive() {
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_observers).some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_observers).some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $c87861fcdbb7b7dc$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_observers).find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_observers).find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!(0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_observers).includes(observer)) {
            (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if ((0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_observers).includes(observer)) {
            (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $7fe1f3bf3d40ed66$var$_observers, (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_observers).filter((x)=>x !== observer));
            if (!(0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_observers).length) {
                if ((0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_retryer)) {
                    if ((0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_abortSignalConsumed)) (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_observers).length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $7fe1f3bf3d40ed66$var$_dispatch, $7fe1f3bf3d40ed66$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _a, _b, _c, _d;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_promise)) {
                (_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_retryer)) == null || _a.continueRetry();
                return (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_promise);
            }
        }
        if (options) (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $7fe1f3bf3d40ed66$var$_setOptions, $7fe1f3bf3d40ed66$var$setOptions_fn).call(this, options);
        if (!this.options.queryFn) {
            const observer = (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_observers).find((x)=>x.options.queryFn);
            if (observer) (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $7fe1f3bf3d40ed66$var$_setOptions, $7fe1f3bf3d40ed66$var$setOptions_fn).call(this, observer.options);
        }
        const abortController = new AbortController();
        const queryFnContext = {
            queryKey: this.queryKey,
            meta: this.meta
        };
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $7fe1f3bf3d40ed66$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        addSignalProperty(queryFnContext);
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject(new Error(`Missing queryFn: '${this.options.queryHash}'`));
            (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $7fe1f3bf3d40ed66$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(this.options.queryFn, queryFnContext, this);
            return this.options.queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_b = this.options.behavior) == null || _b.onFetch(context, this);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $7fe1f3bf3d40ed66$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_c = context.fetchOptions) == null ? void 0 : _c.meta)) (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $7fe1f3bf3d40ed66$var$_dispatch, $7fe1f3bf3d40ed66$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_d = context.fetchOptions) == null ? void 0 : _d.meta
        });
        const onError = (error)=>{
            var _a2, _b2, _c2, _d2;
            if (!((0, $9bc3659d53db0b0e$export$986cc6445c1d323)(error) && error.silent)) (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $7fe1f3bf3d40ed66$var$_dispatch, $7fe1f3bf3d40ed66$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            if (!(0, $9bc3659d53db0b0e$export$986cc6445c1d323)(error)) {
                (_b2 = (_a2 = (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_cache).config).onError) == null || _b2.call(_a2, error, this);
                (_d2 = (_c2 = (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_cache).config).onSettled) == null || _d2.call(_c2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) this.scheduleGc();
            this.isFetchingOptimistic = false;
        };
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $7fe1f3bf3d40ed66$var$_retryer, (0, $9bc3659d53db0b0e$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _a2, _b2, _c2, _d2;
                if (typeof data === "undefined") {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                this.setData(data);
                (_b2 = (_a2 = (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_cache).config).onSuccess) == null || _b2.call(_a2, data, this);
                (_d2 = (_c2 = (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_cache).config).onSettled) == null || _d2.call(_c2, data, this.state.error, this);
                if (!this.isFetchingOptimistic) this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $7fe1f3bf3d40ed66$var$_dispatch, $7fe1f3bf3d40ed66$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $7fe1f3bf3d40ed66$var$_dispatch, $7fe1f3bf3d40ed66$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $7fe1f3bf3d40ed66$var$_dispatch, $7fe1f3bf3d40ed66$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        }));
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $7fe1f3bf3d40ed66$var$_promise, (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_retryer).promise);
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_promise);
    }
};
$7fe1f3bf3d40ed66$var$_initialState = new WeakMap();
$7fe1f3bf3d40ed66$var$_revertState = new WeakMap();
$7fe1f3bf3d40ed66$var$_cache = new WeakMap();
$7fe1f3bf3d40ed66$var$_promise = new WeakMap();
$7fe1f3bf3d40ed66$var$_retryer = new WeakMap();
$7fe1f3bf3d40ed66$var$_observers = new WeakMap();
$7fe1f3bf3d40ed66$var$_defaultOptions = new WeakMap();
$7fe1f3bf3d40ed66$var$_abortSignalConsumed = new WeakMap();
$7fe1f3bf3d40ed66$var$_setOptions = new WeakSet();
$7fe1f3bf3d40ed66$var$setOptions_fn = function(options) {
    this.options = {
        ...(0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_defaultOptions),
        ...options
    };
    this.updateGcTime(this.options.gcTime);
};
$7fe1f3bf3d40ed66$var$_dispatch = new WeakSet();
$7fe1f3bf3d40ed66$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    fetchFailureCount: 0,
                    fetchFailureReason: null,
                    fetchMeta: action.meta ?? null,
                    fetchStatus: (0, $9bc3659d53db0b0e$export$61b92f63f30245cf)(this.options.networkMode) ? "fetching" : "paused",
                    ...!state.dataUpdatedAt && {
                        error: null,
                        status: "pending"
                    }
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
            case "error":
                const error = action.error;
                if ((0, $9bc3659d53db0b0e$export$986cc6445c1d323)(error) && error.revert && (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_revertState)) return {
                    ...(0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_revertState),
                    fetchStatus: "idle"
                };
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $8f286f9abfc2c252$export$520687f44db6e1ab).batch(()=>{
        (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_observers).forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $783f6097b351748f$export$18a094aefa070634)(this, $7fe1f3bf3d40ed66$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $7fe1f3bf3d40ed66$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $cc670f0a235fa3b3$var$_queries;
var $cc670f0a235fa3b3$export$5dde0cd941da8468 = class extends (0, $3797a5406d67bffa$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $783f6097b351748f$export$addf369becd23283)(this, $cc670f0a235fa3b3$var$_queries, void 0);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $cc670f0a235fa3b3$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $c87861fcdbb7b7dc$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $7fe1f3bf3d40ed66$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $783f6097b351748f$export$18a094aefa070634)(this, $cc670f0a235fa3b3$var$_queries).has(query.queryHash)) {
            (0, $783f6097b351748f$export$18a094aefa070634)(this, $cc670f0a235fa3b3$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $783f6097b351748f$export$18a094aefa070634)(this, $cc670f0a235fa3b3$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $783f6097b351748f$export$18a094aefa070634)(this, $cc670f0a235fa3b3$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $8f286f9abfc2c252$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $cc670f0a235fa3b3$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $783f6097b351748f$export$18a094aefa070634)(this, $cc670f0a235fa3b3$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $c87861fcdbb7b7dc$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $c87861fcdbb7b7dc$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $8f286f9abfc2c252$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $8f286f9abfc2c252$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $8f286f9abfc2c252$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$cc670f0a235fa3b3$var$_queries = new WeakMap();








var $1c268a57e7f9e99c$var$_observers, $1c268a57e7f9e99c$var$_defaultOptions, $1c268a57e7f9e99c$var$_mutationCache, $1c268a57e7f9e99c$var$_retryer, $1c268a57e7f9e99c$var$_dispatch, $1c268a57e7f9e99c$var$dispatch_fn;
var $1c268a57e7f9e99c$export$17b8b19c814bcf56 = class extends (0, $7496e3581eead2f9$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $783f6097b351748f$export$addf369becd23283)(this, $1c268a57e7f9e99c$var$_dispatch);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $1c268a57e7f9e99c$var$_observers, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $1c268a57e7f9e99c$var$_defaultOptions, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $1c268a57e7f9e99c$var$_mutationCache, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $1c268a57e7f9e99c$var$_retryer, void 0);
        this.mutationId = config.mutationId;
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $1c268a57e7f9e99c$var$_defaultOptions, config.defaultOptions);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $1c268a57e7f9e99c$var$_mutationCache, config.mutationCache);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $1c268a57e7f9e99c$var$_observers, []);
        this.state = config.state || $1c268a57e7f9e99c$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...(0, $783f6097b351748f$export$18a094aefa070634)(this, $1c268a57e7f9e99c$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $783f6097b351748f$export$18a094aefa070634)(this, $1c268a57e7f9e99c$var$_observers).includes(observer)) {
            (0, $783f6097b351748f$export$18a094aefa070634)(this, $1c268a57e7f9e99c$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $783f6097b351748f$export$18a094aefa070634)(this, $1c268a57e7f9e99c$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $1c268a57e7f9e99c$var$_observers, (0, $783f6097b351748f$export$18a094aefa070634)(this, $1c268a57e7f9e99c$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $783f6097b351748f$export$18a094aefa070634)(this, $1c268a57e7f9e99c$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $783f6097b351748f$export$18a094aefa070634)(this, $1c268a57e7f9e99c$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $783f6097b351748f$export$18a094aefa070634)(this, $1c268a57e7f9e99c$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $1c268a57e7f9e99c$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        const executeMutation = ()=>{
            (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $1c268a57e7f9e99c$var$_retryer, (0, $9bc3659d53db0b0e$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                    return this.options.mutationFn(variables);
                },
                onFail: (failureCount, error)=>{
                    (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $1c268a57e7f9e99c$var$_dispatch, $1c268a57e7f9e99c$var$dispatch_fn).call(this, {
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $1c268a57e7f9e99c$var$_dispatch, $1c268a57e7f9e99c$var$dispatch_fn).call(this, {
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $1c268a57e7f9e99c$var$_dispatch, $1c268a57e7f9e99c$var$dispatch_fn).call(this, {
                        type: "continue"
                    });
                },
                retry: this.options.retry ?? 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            }));
            return (0, $783f6097b351748f$export$18a094aefa070634)(this, $1c268a57e7f9e99c$var$_retryer).promise;
        };
        const restored = this.state.status === "pending";
        try {
            if (!restored) {
                (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $1c268a57e7f9e99c$var$_dispatch, $1c268a57e7f9e99c$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables
                });
                await ((_b = (_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $1c268a57e7f9e99c$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $1c268a57e7f9e99c$var$_dispatch, $1c268a57e7f9e99c$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables
                });
            }
            const data = await executeMutation();
            await ((_f = (_e = (0, $783f6097b351748f$export$18a094aefa070634)(this, $1c268a57e7f9e99c$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, $783f6097b351748f$export$18a094aefa070634)(this, $1c268a57e7f9e99c$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $1c268a57e7f9e99c$var$_dispatch, $1c268a57e7f9e99c$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $783f6097b351748f$export$18a094aefa070634)(this, $1c268a57e7f9e99c$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, $783f6097b351748f$export$18a094aefa070634)(this, $1c268a57e7f9e99c$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $1c268a57e7f9e99c$var$_dispatch, $1c268a57e7f9e99c$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        }
    }
};
$1c268a57e7f9e99c$var$_observers = new WeakMap();
$1c268a57e7f9e99c$var$_defaultOptions = new WeakMap();
$1c268a57e7f9e99c$var$_mutationCache = new WeakMap();
$1c268a57e7f9e99c$var$_retryer = new WeakMap();
$1c268a57e7f9e99c$var$_dispatch = new WeakSet();
$1c268a57e7f9e99c$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: !(0, $9bc3659d53db0b0e$export$61b92f63f30245cf)(this.options.networkMode),
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $8f286f9abfc2c252$export$520687f44db6e1ab).batch(()=>{
        (0, $783f6097b351748f$export$18a094aefa070634)(this, $1c268a57e7f9e99c$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $783f6097b351748f$export$18a094aefa070634)(this, $1c268a57e7f9e99c$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $1c268a57e7f9e99c$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $eb2d2e02c7a26f43$var$_mutations, $eb2d2e02c7a26f43$var$_mutationId, $eb2d2e02c7a26f43$var$_resuming;
var $eb2d2e02c7a26f43$export$1fcfd9a244434844 = class extends (0, $3797a5406d67bffa$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $783f6097b351748f$export$addf369becd23283)(this, $eb2d2e02c7a26f43$var$_mutations, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $eb2d2e02c7a26f43$var$_mutationId, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $eb2d2e02c7a26f43$var$_resuming, void 0);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $eb2d2e02c7a26f43$var$_mutations, []);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $eb2d2e02c7a26f43$var$_mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, $1c268a57e7f9e99c$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++(0, $783f6097b351748f$export$b1fe7cbb4502036b)(this, $eb2d2e02c7a26f43$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $783f6097b351748f$export$18a094aefa070634)(this, $eb2d2e02c7a26f43$var$_mutations).push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $eb2d2e02c7a26f43$var$_mutations, (0, $783f6097b351748f$export$18a094aefa070634)(this, $eb2d2e02c7a26f43$var$_mutations).filter((x)=>x !== mutation));
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $8f286f9abfc2c252$export$520687f44db6e1ab).batch(()=>{
            (0, $783f6097b351748f$export$18a094aefa070634)(this, $eb2d2e02c7a26f43$var$_mutations).forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $eb2d2e02c7a26f43$var$_mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $eb2d2e02c7a26f43$var$_mutations).find((mutation)=>(0, $c87861fcdbb7b7dc$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $eb2d2e02c7a26f43$var$_mutations).filter((mutation)=>(0, $c87861fcdbb7b7dc$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $8f286f9abfc2c252$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $eb2d2e02c7a26f43$var$_resuming, ((0, $783f6097b351748f$export$18a094aefa070634)(this, $eb2d2e02c7a26f43$var$_resuming) ?? Promise.resolve()).then(()=>{
            const pausedMutations = (0, $783f6097b351748f$export$18a094aefa070634)(this, $eb2d2e02c7a26f43$var$_mutations).filter((x)=>x.state.isPaused);
            return (0, $8f286f9abfc2c252$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $c87861fcdbb7b7dc$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $eb2d2e02c7a26f43$var$_resuming, void 0);
        }));
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $eb2d2e02c7a26f43$var$_resuming);
    }
};
$eb2d2e02c7a26f43$var$_mutations = new WeakMap();
$eb2d2e02c7a26f43$var$_mutationId = new WeakMap();
$eb2d2e02c7a26f43$var$_resuming = new WeakMap();







function $d09061833cb86227$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const fetchFn = async ()=>{
                var _a, _b, _c, _d, _e;
                const options = context.options;
                const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
                const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
                const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
                const empty = {
                    pages: [],
                    pageParams: []
                };
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = context.options.queryFn || (()=>Promise.reject(new Error(`Missing queryFn: '${context.options.queryHash}'`)));
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $c87861fcdbb7b7dc$export$8c6246b73dd61f4a) : (0, $c87861fcdbb7b7dc$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                let result;
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $d09061833cb86227$var$getPreviousPageParam : $d09061833cb86227$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    result = await fetchPage(empty, oldPageParams[0] ?? options.initialPageParam);
                    const remainingPages = pages ?? oldPages.length;
                    for(let i = 1; i < remainingPages; i++){
                        const param = $d09061833cb86227$var$getNextPageParam(options, result);
                        result = await fetchPage(result, param);
                    }
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a, _b;
                return (_b = (_a = context.options).persister) == null ? void 0 : _b.call(_a, fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $d09061833cb86227$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams);
}
function $d09061833cb86227$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams);
}
function $d09061833cb86227$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $d09061833cb86227$var$getNextPageParam(options, data) != null;
}
function $d09061833cb86227$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $d09061833cb86227$var$getPreviousPageParam(options, data) != null;
}


var $22d1ff11c1be2a75$var$_queryCache, $22d1ff11c1be2a75$var$_mutationCache, $22d1ff11c1be2a75$var$_defaultOptions, $22d1ff11c1be2a75$var$_queryDefaults, $22d1ff11c1be2a75$var$_mutationDefaults, $22d1ff11c1be2a75$var$_mountCount, $22d1ff11c1be2a75$var$_unsubscribeFocus, $22d1ff11c1be2a75$var$_unsubscribeOnline;
var $22d1ff11c1be2a75$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $783f6097b351748f$export$addf369becd23283)(this, $22d1ff11c1be2a75$var$_queryCache, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $22d1ff11c1be2a75$var$_mutationCache, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $22d1ff11c1be2a75$var$_defaultOptions, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $22d1ff11c1be2a75$var$_queryDefaults, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $22d1ff11c1be2a75$var$_mutationDefaults, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $22d1ff11c1be2a75$var$_mountCount, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $22d1ff11c1be2a75$var$_unsubscribeFocus, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $22d1ff11c1be2a75$var$_unsubscribeOnline, void 0);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $22d1ff11c1be2a75$var$_queryCache, config.queryCache || new (0, $cc670f0a235fa3b3$export$5dde0cd941da8468)());
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $22d1ff11c1be2a75$var$_mutationCache, config.mutationCache || new (0, $eb2d2e02c7a26f43$export$1fcfd9a244434844)());
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $22d1ff11c1be2a75$var$_defaultOptions, config.defaultOptions || {});
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $22d1ff11c1be2a75$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $22d1ff11c1be2a75$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $22d1ff11c1be2a75$var$_mountCount, 0);
    }
    mount() {
        (0, $783f6097b351748f$export$b1fe7cbb4502036b)(this, $22d1ff11c1be2a75$var$_mountCount)._++;
        if ((0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_mountCount) !== 1) return;
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $22d1ff11c1be2a75$var$_unsubscribeFocus, (0, $f0a8743d916c8b49$export$6bf54661be5b02cf).subscribe(()=>{
            if ((0, $f0a8743d916c8b49$export$6bf54661be5b02cf).isFocused()) {
                this.resumePausedMutations();
                (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_queryCache).onFocus();
            }
        }));
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $22d1ff11c1be2a75$var$_unsubscribeOnline, (0, $1e0a508d8bcc0a38$export$b113e788b2dd3fdc).subscribe(()=>{
            if ((0, $1e0a508d8bcc0a38$export$b113e788b2dd3fdc).isOnline()) {
                this.resumePausedMutations();
                (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $783f6097b351748f$export$b1fe7cbb4502036b)(this, $22d1ff11c1be2a75$var$_mountCount)._--;
        if ((0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_mountCount) !== 0) return;
        (_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $22d1ff11c1be2a75$var$_unsubscribeFocus, void 0);
        (_b = (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $22d1ff11c1be2a75$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        var _a;
        return (_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_queryCache).find({
            queryKey: queryKey
        })) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const cachedData = this.getQueryData(options.queryKey);
        return cachedData !== void 0 ? Promise.resolve(cachedData) : this.fetchQuery(options);
    }
    getQueriesData(filters) {
        return this.getQueryCache().findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_queryCache).find({
            queryKey: queryKey
        });
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $c87861fcdbb7b7dc$export$7f095f455ad5af3f)(updater, prevData);
        if (typeof data === "undefined") return void 0;
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $8f286f9abfc2c252$export$520687f44db6e1ab).batch(()=>this.getQueryCache().findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        return (_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_queryCache).find({
            queryKey: queryKey
        })) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_queryCache);
        (0, $8f286f9abfc2c252$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_queryCache);
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $8f286f9abfc2c252$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters = {}, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $8f286f9abfc2c252$export$520687f44db6e1ab).batch(()=>(0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $c87861fcdbb7b7dc$export$8793edee2d425525)).catch((0, $c87861fcdbb7b7dc$export$8793edee2d425525));
    }
    invalidateQueries(filters = {}, options = {}) {
        return (0, $8f286f9abfc2c252$export$520687f44db6e1ab).batch(()=>{
            (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: filters.refetchType ?? filters.type ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters = {}, options) {
        const fetchOptions = {
            ...options,
            cancelRefetch: (options == null ? void 0 : options.cancelRefetch) ?? true
        };
        const promises = (0, $8f286f9abfc2c252$export$520687f44db6e1ab).batch(()=>(0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $c87861fcdbb7b7dc$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $c87861fcdbb7b7dc$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $c87861fcdbb7b7dc$export$8793edee2d425525)).catch((0, $c87861fcdbb7b7dc$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $d09061833cb86227$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $c87861fcdbb7b7dc$export$8793edee2d425525)).catch((0, $c87861fcdbb7b7dc$export$8793edee2d425525));
    }
    resumePausedMutations() {
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_mutationCache).resumePausedMutations();
    }
    getQueryCache() {
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_queryCache);
    }
    getMutationCache() {
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $22d1ff11c1be2a75$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_queryDefaults).set((0, $c87861fcdbb7b7dc$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_queryDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $c87861fcdbb7b7dc$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_mutationDefaults).set((0, $c87861fcdbb7b7dc$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_mutationDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $c87861fcdbb7b7dc$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_defaultOptions).queries,
            ...(options == null ? void 0 : options.queryKey) && this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $c87861fcdbb7b7dc$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.throwOnError === "undefined") defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (typeof defaultedOptions.networkMode === "undefined" && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_queryCache).clear();
        (0, $783f6097b351748f$export$18a094aefa070634)(this, $22d1ff11c1be2a75$var$_mutationCache).clear();
    }
};
$22d1ff11c1be2a75$var$_queryCache = new WeakMap();
$22d1ff11c1be2a75$var$_mutationCache = new WeakMap();
$22d1ff11c1be2a75$var$_defaultOptions = new WeakMap();
$22d1ff11c1be2a75$var$_queryDefaults = new WeakMap();
$22d1ff11c1be2a75$var$_mutationDefaults = new WeakMap();
$22d1ff11c1be2a75$var$_mountCount = new WeakMap();
$22d1ff11c1be2a75$var$_unsubscribeFocus = new WeakMap();
$22d1ff11c1be2a75$var$_unsubscribeOnline = new WeakMap();


var $1T1QG = parcelRequire("1T1QG");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $9c3a537718ea5f59$export$da112d31b0149f31 = $1T1QG.createContext(void 0);
var $9c3a537718ea5f59$export$22e77b9572c4fded = (queryClient)=>{
    const client = $1T1QG.useContext($9c3a537718ea5f59$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $9c3a537718ea5f59$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $1T1QG.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $3Py8h.jsx)($9c3a537718ea5f59$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};



var $1T1QG = parcelRequire("1T1QG");

var $9jP1l = parcelRequire("9jP1l");
var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");
parcelRequire("1T1QG");


var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");



var $1T1QG = parcelRequire("1T1QG");
const $f815e43a2ccfa615$var$ThemeContext = /*#__PURE__*/ $1T1QG.createContext(null);
var $f815e43a2ccfa615$export$2e2bcd8739ae039 = $f815e43a2ccfa615$var$ThemeContext;



var $1T1QG = parcelRequire("1T1QG");

function $4e6fadd43ef8a459$export$2e2bcd8739ae039() {
    const theme = $1T1QG.useContext((0, $f815e43a2ccfa615$export$2e2bcd8739ae039));
    return theme;
}


const $f2f3f976fa88796a$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $f2f3f976fa88796a$export$2e2bcd8739ae039 = $f2f3f976fa88796a$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $3Py8h = parcelRequire("3Py8h");
function $d9ce797502629134$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $ajTRS.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $d9ce797502629134$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $4e6fadd43ef8a459$export$2e2bcd8739ae039)();
    const theme = $1T1QG.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $d9ce797502629134$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $f2f3f976fa88796a$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f815e43a2ccfa615$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $d9ce797502629134$export$2e2bcd8739ae039 = $d9ce797502629134$var$ThemeProvider;



parcelRequire("aMdXx");
var $8WAsW = parcelRequire("8WAsW");

var $6UrSi = parcelRequire("6UrSi");

var $3Py8h = parcelRequire("3Py8h");
"use client";
const $89137a5c70f7b840$var$EMPTY_THEME = {};
function $89137a5c70f7b840$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $1T1QG.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $ajTRS.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $ajTRS.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $ajTRS.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $89137a5c70f7b840$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $6UrSi.default)($89137a5c70f7b840$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $4e6fadd43ef8a459$export$2e2bcd8739ae039)() || $89137a5c70f7b840$var$EMPTY_THEME;
    const engineTheme = $89137a5c70f7b840$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $89137a5c70f7b840$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $d9ce797502629134$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8WAsW.T).Provider, {
            value: engineTheme,
            children: children
        })
    });
}
var $89137a5c70f7b840$export$2e2bcd8739ae039 = $89137a5c70f7b840$var$ThemeProvider;



var $557GP = parcelRequire("557GP");

var $3Py8h = parcelRequire("3Py8h");
"use client";
const $eeaa49d647eade80$var$_excluded = [
    "theme"
];
function $eeaa49d647eade80$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $iXdVf.default)(_ref, $eeaa49d647eade80$var$_excluded);
    const scopedTheme = themeInput[0, $557GP.default];
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $89137a5c70f7b840$export$2e2bcd8739ae039), (0, $ajTRS.default)({}, props, {
        themeId: scopedTheme ? (0, $557GP.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}



function $c73b223a8889eea2$export$2e2bcd8739ae039() {
    return $c73b223a8889eea2$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c73b223a8889eea2$export$2e2bcd8739ae039.apply(null, arguments);
}


var $51c4c2d07d14dea7$exports = {};
"use strict";
Object.defineProperty($51c4c2d07d14dea7$exports, "__esModule", {
    value: true
});
function $51c4c2d07d14dea7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $51c4c2d07d14dea7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $51c4c2d07d14dea7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $51c4c2d07d14dea7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $51c4c2d07d14dea7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $51c4c2d07d14dea7$var$_extends() {
    $51c4c2d07d14dea7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $51c4c2d07d14dea7$var$_extends.apply(this, arguments);
}
function $51c4c2d07d14dea7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $51c4c2d07d14dea7$var$_setPrototypeOf(subClass, superClass);
}
function $51c4c2d07d14dea7$var$_getPrototypeOf(o) {
    $51c4c2d07d14dea7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $51c4c2d07d14dea7$var$_getPrototypeOf(o);
}
function $51c4c2d07d14dea7$var$_setPrototypeOf(o, p) {
    $51c4c2d07d14dea7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $51c4c2d07d14dea7$var$_setPrototypeOf(o, p);
}
function $51c4c2d07d14dea7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $51c4c2d07d14dea7$var$_construct(Parent, args, Class) {
    if ($51c4c2d07d14dea7$var$_isNativeReflectConstruct()) $51c4c2d07d14dea7$var$_construct = Reflect.construct.bind();
    else $51c4c2d07d14dea7$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $51c4c2d07d14dea7$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $51c4c2d07d14dea7$var$_construct.apply(null, arguments);
}
function $51c4c2d07d14dea7$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $51c4c2d07d14dea7$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $51c4c2d07d14dea7$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$51c4c2d07d14dea7$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $51c4c2d07d14dea7$var$_construct(Class, arguments, $51c4c2d07d14dea7$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $51c4c2d07d14dea7$var$_setPrototypeOf(Wrapper, Class);
    };
    return $51c4c2d07d14dea7$var$_wrapNativeSuper(Class);
}
function $51c4c2d07d14dea7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $51c4c2d07d14dea7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $51c4c2d07d14dea7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $51c4c2d07d14dea7$var$_arrayLikeToArray(o, minLen);
}
function $51c4c2d07d14dea7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $51c4c2d07d14dea7$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $51c4c2d07d14dea7$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $51c4c2d07d14dea7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $51c4c2d07d14dea7$var$_toPropertyKey(arg) {
    var key = $51c4c2d07d14dea7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $51c4c2d07d14dea7$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $51c4c2d07d14dea7$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $51c4c2d07d14dea7$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $51c4c2d07d14dea7$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $51c4c2d07d14dea7$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($51c4c2d07d14dea7$var$LuxonError);
/**
 * @private
 */ var $51c4c2d07d14dea7$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $51c4c2d07d14dea7$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($51c4c2d07d14dea7$var$LuxonError);
/**
 * @private
 */ var $51c4c2d07d14dea7$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $51c4c2d07d14dea7$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($51c4c2d07d14dea7$var$LuxonError);
/**
 * @private
 */ var $51c4c2d07d14dea7$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $51c4c2d07d14dea7$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($51c4c2d07d14dea7$var$LuxonError);
/**
 * @private
 */ var $51c4c2d07d14dea7$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $51c4c2d07d14dea7$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($51c4c2d07d14dea7$var$LuxonError);
/**
 * @private
 */ var $51c4c2d07d14dea7$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $51c4c2d07d14dea7$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($51c4c2d07d14dea7$var$LuxonError);
/**
 * @private
 */ var $51c4c2d07d14dea7$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $51c4c2d07d14dea7$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($51c4c2d07d14dea7$var$LuxonError);
/**
 * @private
 */ var $51c4c2d07d14dea7$var$n = "numeric", $51c4c2d07d14dea7$var$s = "short", $51c4c2d07d14dea7$var$l = "long";
var $51c4c2d07d14dea7$var$DATE_SHORT = {
    year: $51c4c2d07d14dea7$var$n,
    month: $51c4c2d07d14dea7$var$n,
    day: $51c4c2d07d14dea7$var$n
};
var $51c4c2d07d14dea7$var$DATE_MED = {
    year: $51c4c2d07d14dea7$var$n,
    month: $51c4c2d07d14dea7$var$s,
    day: $51c4c2d07d14dea7$var$n
};
var $51c4c2d07d14dea7$var$DATE_MED_WITH_WEEKDAY = {
    year: $51c4c2d07d14dea7$var$n,
    month: $51c4c2d07d14dea7$var$s,
    day: $51c4c2d07d14dea7$var$n,
    weekday: $51c4c2d07d14dea7$var$s
};
var $51c4c2d07d14dea7$var$DATE_FULL = {
    year: $51c4c2d07d14dea7$var$n,
    month: $51c4c2d07d14dea7$var$l,
    day: $51c4c2d07d14dea7$var$n
};
var $51c4c2d07d14dea7$var$DATE_HUGE = {
    year: $51c4c2d07d14dea7$var$n,
    month: $51c4c2d07d14dea7$var$l,
    day: $51c4c2d07d14dea7$var$n,
    weekday: $51c4c2d07d14dea7$var$l
};
var $51c4c2d07d14dea7$var$TIME_SIMPLE = {
    hour: $51c4c2d07d14dea7$var$n,
    minute: $51c4c2d07d14dea7$var$n
};
var $51c4c2d07d14dea7$var$TIME_WITH_SECONDS = {
    hour: $51c4c2d07d14dea7$var$n,
    minute: $51c4c2d07d14dea7$var$n,
    second: $51c4c2d07d14dea7$var$n
};
var $51c4c2d07d14dea7$var$TIME_WITH_SHORT_OFFSET = {
    hour: $51c4c2d07d14dea7$var$n,
    minute: $51c4c2d07d14dea7$var$n,
    second: $51c4c2d07d14dea7$var$n,
    timeZoneName: $51c4c2d07d14dea7$var$s
};
var $51c4c2d07d14dea7$var$TIME_WITH_LONG_OFFSET = {
    hour: $51c4c2d07d14dea7$var$n,
    minute: $51c4c2d07d14dea7$var$n,
    second: $51c4c2d07d14dea7$var$n,
    timeZoneName: $51c4c2d07d14dea7$var$l
};
var $51c4c2d07d14dea7$var$TIME_24_SIMPLE = {
    hour: $51c4c2d07d14dea7$var$n,
    minute: $51c4c2d07d14dea7$var$n,
    hourCycle: "h23"
};
var $51c4c2d07d14dea7$var$TIME_24_WITH_SECONDS = {
    hour: $51c4c2d07d14dea7$var$n,
    minute: $51c4c2d07d14dea7$var$n,
    second: $51c4c2d07d14dea7$var$n,
    hourCycle: "h23"
};
var $51c4c2d07d14dea7$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $51c4c2d07d14dea7$var$n,
    minute: $51c4c2d07d14dea7$var$n,
    second: $51c4c2d07d14dea7$var$n,
    hourCycle: "h23",
    timeZoneName: $51c4c2d07d14dea7$var$s
};
var $51c4c2d07d14dea7$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $51c4c2d07d14dea7$var$n,
    minute: $51c4c2d07d14dea7$var$n,
    second: $51c4c2d07d14dea7$var$n,
    hourCycle: "h23",
    timeZoneName: $51c4c2d07d14dea7$var$l
};
var $51c4c2d07d14dea7$var$DATETIME_SHORT = {
    year: $51c4c2d07d14dea7$var$n,
    month: $51c4c2d07d14dea7$var$n,
    day: $51c4c2d07d14dea7$var$n,
    hour: $51c4c2d07d14dea7$var$n,
    minute: $51c4c2d07d14dea7$var$n
};
var $51c4c2d07d14dea7$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $51c4c2d07d14dea7$var$n,
    month: $51c4c2d07d14dea7$var$n,
    day: $51c4c2d07d14dea7$var$n,
    hour: $51c4c2d07d14dea7$var$n,
    minute: $51c4c2d07d14dea7$var$n,
    second: $51c4c2d07d14dea7$var$n
};
var $51c4c2d07d14dea7$var$DATETIME_MED = {
    year: $51c4c2d07d14dea7$var$n,
    month: $51c4c2d07d14dea7$var$s,
    day: $51c4c2d07d14dea7$var$n,
    hour: $51c4c2d07d14dea7$var$n,
    minute: $51c4c2d07d14dea7$var$n
};
var $51c4c2d07d14dea7$var$DATETIME_MED_WITH_SECONDS = {
    year: $51c4c2d07d14dea7$var$n,
    month: $51c4c2d07d14dea7$var$s,
    day: $51c4c2d07d14dea7$var$n,
    hour: $51c4c2d07d14dea7$var$n,
    minute: $51c4c2d07d14dea7$var$n,
    second: $51c4c2d07d14dea7$var$n
};
var $51c4c2d07d14dea7$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $51c4c2d07d14dea7$var$n,
    month: $51c4c2d07d14dea7$var$s,
    day: $51c4c2d07d14dea7$var$n,
    weekday: $51c4c2d07d14dea7$var$s,
    hour: $51c4c2d07d14dea7$var$n,
    minute: $51c4c2d07d14dea7$var$n
};
var $51c4c2d07d14dea7$var$DATETIME_FULL = {
    year: $51c4c2d07d14dea7$var$n,
    month: $51c4c2d07d14dea7$var$l,
    day: $51c4c2d07d14dea7$var$n,
    hour: $51c4c2d07d14dea7$var$n,
    minute: $51c4c2d07d14dea7$var$n,
    timeZoneName: $51c4c2d07d14dea7$var$s
};
var $51c4c2d07d14dea7$var$DATETIME_FULL_WITH_SECONDS = {
    year: $51c4c2d07d14dea7$var$n,
    month: $51c4c2d07d14dea7$var$l,
    day: $51c4c2d07d14dea7$var$n,
    hour: $51c4c2d07d14dea7$var$n,
    minute: $51c4c2d07d14dea7$var$n,
    second: $51c4c2d07d14dea7$var$n,
    timeZoneName: $51c4c2d07d14dea7$var$s
};
var $51c4c2d07d14dea7$var$DATETIME_HUGE = {
    year: $51c4c2d07d14dea7$var$n,
    month: $51c4c2d07d14dea7$var$l,
    day: $51c4c2d07d14dea7$var$n,
    weekday: $51c4c2d07d14dea7$var$l,
    hour: $51c4c2d07d14dea7$var$n,
    minute: $51c4c2d07d14dea7$var$n,
    timeZoneName: $51c4c2d07d14dea7$var$l
};
var $51c4c2d07d14dea7$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $51c4c2d07d14dea7$var$n,
    month: $51c4c2d07d14dea7$var$l,
    day: $51c4c2d07d14dea7$var$n,
    weekday: $51c4c2d07d14dea7$var$l,
    hour: $51c4c2d07d14dea7$var$n,
    minute: $51c4c2d07d14dea7$var$n,
    second: $51c4c2d07d14dea7$var$n,
    timeZoneName: $51c4c2d07d14dea7$var$l
};
/**
 * @interface
 */ var $51c4c2d07d14dea7$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $51c4c2d07d14dea7$var$ZoneIsAbstractError();
    } /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ ;
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $51c4c2d07d14dea7$var$ZoneIsAbstractError();
    } /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ ;
    _proto.offset = function offset(ts) {
        throw new $51c4c2d07d14dea7$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ ;
    _proto.equals = function equals(otherZone) {
        throw new $51c4c2d07d14dea7$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */ ;
    $51c4c2d07d14dea7$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $51c4c2d07d14dea7$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $51c4c2d07d14dea7$var$ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $51c4c2d07d14dea7$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $51c4c2d07d14dea7$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $51c4c2d07d14dea7$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $51c4c2d07d14dea7$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $51c4c2d07d14dea7$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $51c4c2d07d14dea7$var$parseZoneInfo(ts, format, locale);
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $51c4c2d07d14dea7$var$formatOffset(this.offset(ts), format);
    } /** @override **/ ;
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    } /** @override **/ ;
    $51c4c2d07d14dea7$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($51c4c2d07d14dea7$var$singleton$1 === null) $51c4c2d07d14dea7$var$singleton$1 = new SystemZone();
                return $51c4c2d07d14dea7$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($51c4c2d07d14dea7$var$Zone);
var $51c4c2d07d14dea7$var$dtfCache = {};
function $51c4c2d07d14dea7$var$makeDTF(zone) {
    if (!$51c4c2d07d14dea7$var$dtfCache[zone]) $51c4c2d07d14dea7$var$dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
        hour12: false,
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        era: "short"
    });
    return $51c4c2d07d14dea7$var$dtfCache[zone];
}
var $51c4c2d07d14dea7$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $51c4c2d07d14dea7$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $51c4c2d07d14dea7$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = $51c4c2d07d14dea7$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$51c4c2d07d14dea7$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $51c4c2d07d14dea7$var$ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $51c4c2d07d14dea7$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $51c4c2d07d14dea7$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        if (!$51c4c2d07d14dea7$var$ianaZoneCache[name]) $51c4c2d07d14dea7$var$ianaZoneCache[name] = new IANAZone(name);
        return $51c4c2d07d14dea7$var$ianaZoneCache[name];
    } /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ ;
    IANAZone.resetCache = function resetCache() {
        $51c4c2d07d14dea7$var$ianaZoneCache = {};
        $51c4c2d07d14dea7$var$dtfCache = {};
    } /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */ ;
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    } /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */ ;
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /** @override **/ var _proto = IANAZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $51c4c2d07d14dea7$var$parseZoneInfo(ts, format, locale, this.name);
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $51c4c2d07d14dea7$var$formatOffset(this.offset(ts), format);
    } /** @override **/ ;
    _proto.offset = function offset(ts) {
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $51c4c2d07d14dea7$var$makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? $51c4c2d07d14dea7$var$partsOffset(dtf, date) : $51c4c2d07d14dea7$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $51c4c2d07d14dea7$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    } /** @override **/ ;
    $51c4c2d07d14dea7$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($51c4c2d07d14dea7$var$Zone);
var $51c4c2d07d14dea7$var$_excluded = [
    "base"
], $51c4c2d07d14dea7$var$_excluded2 = [
    "padTo",
    "floor"
];
// todo - remap caching
var $51c4c2d07d14dea7$var$intlLFCache = {};
function $51c4c2d07d14dea7$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $51c4c2d07d14dea7$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $51c4c2d07d14dea7$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $51c4c2d07d14dea7$var$intlDTCache = {};
function $51c4c2d07d14dea7$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $51c4c2d07d14dea7$var$intlDTCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $51c4c2d07d14dea7$var$intlDTCache[key] = dtf;
    }
    return dtf;
}
var $51c4c2d07d14dea7$var$intlNumCache = {};
function $51c4c2d07d14dea7$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $51c4c2d07d14dea7$var$intlNumCache[key];
    if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        $51c4c2d07d14dea7$var$intlNumCache[key] = inf;
    }
    return inf;
}
var $51c4c2d07d14dea7$var$intlRelCache = {};
function $51c4c2d07d14dea7$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $51c4c2d07d14dea7$var$_objectWithoutPropertiesLoose(_opts, $51c4c2d07d14dea7$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $51c4c2d07d14dea7$var$intlRelCache[key];
    if (!inf) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $51c4c2d07d14dea7$var$intlRelCache[key] = inf;
    }
    return inf;
}
var $51c4c2d07d14dea7$var$sysLocaleCache = null;
function $51c4c2d07d14dea7$var$systemLocale() {
    if ($51c4c2d07d14dea7$var$sysLocaleCache) return $51c4c2d07d14dea7$var$sysLocaleCache;
    else {
        $51c4c2d07d14dea7$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $51c4c2d07d14dea7$var$sysLocaleCache;
    }
}
function $51c4c2d07d14dea7$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    var xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var selectedStr;
        try {
            options = $51c4c2d07d14dea7$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            var smaller = localeStr.substring(0, uIndex);
            options = $51c4c2d07d14dea7$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $51c4c2d07d14dea7$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $51c4c2d07d14dea7$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $51c4c2d07d14dea7$var$DateTime.utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $51c4c2d07d14dea7$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $51c4c2d07d14dea7$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $51c4c2d07d14dea7$var$listStuff(loc, length, englishFn, intlFn) {
    var mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $51c4c2d07d14dea7$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
}
/**
 * @private
 */ var $51c4c2d07d14dea7$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $51c4c2d07d14dea7$var$_objectWithoutPropertiesLoose(opts, $51c4c2d07d14dea7$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $51c4c2d07d14dea7$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $51c4c2d07d14dea7$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $51c4c2d07d14dea7$var$roundTo(i, 3);
            return $51c4c2d07d14dea7$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $51c4c2d07d14dea7$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.originalZone = undefined;
        var z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $51c4c2d07d14dea7$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        var intlOpts = $51c4c2d07d14dea7$var$_extends({}, this.opts);
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $51c4c2d07d14dea7$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(function(_ref) {
            var value = _ref.value;
            return value;
        }).join("");
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        var _this = this;
        var parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map(function(part) {
            if (part.type === "timeZoneName") {
                var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
                    locale: _this.dt.locale,
                    format: _this.opts.timeZoneName
                });
                return $51c4c2d07d14dea7$var$_extends({}, part, {
                    value: offsetName
                });
            } else return part;
        });
        return parts;
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $51c4c2d07d14dea7$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $51c4c2d07d14dea7$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $51c4c2d07d14dea7$var$hasRelative()) this.rtf = $51c4c2d07d14dea7$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $51c4c2d07d14dea7$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
/**
 * @private
 */ var $51c4c2d07d14dea7$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $51c4c2d07d14dea7$var$Settings.defaultLocale;
        // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $51c4c2d07d14dea7$var$systemLocale());
        var numberingSystemR = numberingSystem || $51c4c2d07d14dea7$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $51c4c2d07d14dea7$var$Settings.defaultOutputCalendar;
        return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $51c4c2d07d14dea7$var$sysLocaleCache = null;
        $51c4c2d07d14dea7$var$intlDTCache = {};
        $51c4c2d07d14dea7$var$intlNumCache = {};
        $51c4c2d07d14dea7$var$intlRelCache = {};
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, locale = _ref2.locale, numberingSystem = _ref2.numberingSystem, outputCalendar = _ref2.outputCalendar;
        return Locale.create(locale, numberingSystem, outputCalendar);
    };
    function Locale(locale, numbering, outputCalendar, specifiedLocale) {
        var _parseLocaleString = $51c4c2d07d14dea7$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.intl = $51c4c2d07d14dea7$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($51c4c2d07d14dea7$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($51c4c2d07d14dea7$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format) {
        var _this2 = this;
        if (format === void 0) format = false;
        return $51c4c2d07d14dea7$var$listStuff(this, length, $51c4c2d07d14dea7$var$months, function() {
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.monthsCache[formatStr][length]) _this2.monthsCache[formatStr][length] = $51c4c2d07d14dea7$var$mapMonths(function(dt) {
                return _this2.extract(dt, intl, "month");
            });
            return _this2.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format) {
        var _this3 = this;
        if (format === void 0) format = false;
        return $51c4c2d07d14dea7$var$listStuff(this, length, $51c4c2d07d14dea7$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this3.weekdaysCache[formatStr][length]) _this3.weekdaysCache[formatStr][length] = $51c4c2d07d14dea7$var$mapWeekdays(function(dt) {
                return _this3.extract(dt, intl, "weekday");
            });
            return _this3.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1() {
        var _this4 = this;
        return $51c4c2d07d14dea7$var$listStuff(this, undefined, function() {
            return $51c4c2d07d14dea7$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this4.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this4.meridiemCache = [
                    $51c4c2d07d14dea7$var$DateTime.utc(2016, 11, 13, 9),
                    $51c4c2d07d14dea7$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this4.extract(dt, intl, "dayperiod");
                });
            }
            return _this4.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length) {
        var _this5 = this;
        return $51c4c2d07d14dea7$var$listStuff(this, length, $51c4c2d07d14dea7$var$eras, function() {
            var intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this5.eraCache[length]) _this5.eraCache[length] = [
                $51c4c2d07d14dea7$var$DateTime.utc(-40, 1, 1),
                $51c4c2d07d14dea7$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this5.extract(dt, intl, "era");
            });
            return _this5.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $51c4c2d07d14dea7$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $51c4c2d07d14dea7$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $51c4c2d07d14dea7$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $51c4c2d07d14dea7$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    $51c4c2d07d14dea7$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $51c4c2d07d14dea7$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
var $51c4c2d07d14dea7$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $51c4c2d07d14dea7$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $51c4c2d07d14dea7$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    } /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */ ;
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($51c4c2d07d14dea7$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /** @override **/ var _proto = FixedOffsetZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return this.name;
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $51c4c2d07d14dea7$var$formatOffset(this.fixed, format);
    } /** @override **/ ;
    /** @override **/ _proto.offset = function offset() {
        return this.fixed;
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    } /** @override **/ ;
    $51c4c2d07d14dea7$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $51c4c2d07d14dea7$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + $51c4c2d07d14dea7$var$formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($51c4c2d07d14dea7$var$singleton === null) $51c4c2d07d14dea7$var$singleton = new FixedOffsetZone(0);
                return $51c4c2d07d14dea7$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($51c4c2d07d14dea7$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $51c4c2d07d14dea7$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $51c4c2d07d14dea7$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset() {
        return "";
    } /** @override **/ ;
    _proto.offset = function offset() {
        return NaN;
    } /** @override **/ ;
    _proto.equals = function equals() {
        return false;
    } /** @override **/ ;
    $51c4c2d07d14dea7$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($51c4c2d07d14dea7$var$Zone);
/**
 * @private
 */ function $51c4c2d07d14dea7$var$normalizeZone(input, defaultZone) {
    if ($51c4c2d07d14dea7$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $51c4c2d07d14dea7$var$Zone) return input;
    else if ($51c4c2d07d14dea7$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return $51c4c2d07d14dea7$var$SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return $51c4c2d07d14dea7$var$FixedOffsetZone.utcInstance;
        else return $51c4c2d07d14dea7$var$FixedOffsetZone.parseSpecifier(lowered) || $51c4c2d07d14dea7$var$IANAZone.create(input);
    } else if ($51c4c2d07d14dea7$var$isNumber(input)) return $51c4c2d07d14dea7$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $51c4c2d07d14dea7$var$InvalidZone(input);
}
var $51c4c2d07d14dea7$var$now = function now() {
    return Date.now();
}, $51c4c2d07d14dea7$var$defaultZone = "system", $51c4c2d07d14dea7$var$defaultLocale = null, $51c4c2d07d14dea7$var$defaultNumberingSystem = null, $51c4c2d07d14dea7$var$defaultOutputCalendar = null, $51c4c2d07d14dea7$var$twoDigitCutoffYear = 60, $51c4c2d07d14dea7$var$throwOnInvalid;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $51c4c2d07d14dea7$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $51c4c2d07d14dea7$var$Locale.resetCache();
        $51c4c2d07d14dea7$var$IANAZone.resetCache();
    };
    $51c4c2d07d14dea7$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $51c4c2d07d14dea7$var$now;
            },
            set: function set(n) {
                $51c4c2d07d14dea7$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $51c4c2d07d14dea7$var$normalizeZone($51c4c2d07d14dea7$var$defaultZone, $51c4c2d07d14dea7$var$SystemZone.instance);
            },
            set: function set(zone) {
                $51c4c2d07d14dea7$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $51c4c2d07d14dea7$var$defaultLocale;
            },
            set: function set(locale) {
                $51c4c2d07d14dea7$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $51c4c2d07d14dea7$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $51c4c2d07d14dea7$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $51c4c2d07d14dea7$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $51c4c2d07d14dea7$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "twoDigitCutoffYear",
            get: function get() {
                return $51c4c2d07d14dea7$var$twoDigitCutoffYear;
            },
            set: function set(cutoffYear) {
                $51c4c2d07d14dea7$var$twoDigitCutoffYear = cutoffYear % 100;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $51c4c2d07d14dea7$var$throwOnInvalid;
            },
            set: function set(t) {
                $51c4c2d07d14dea7$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
/**
 * @private
 */ // TYPES
function $51c4c2d07d14dea7$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $51c4c2d07d14dea7$var$isNumber(o) {
    return typeof o === "number";
}
function $51c4c2d07d14dea7$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $51c4c2d07d14dea7$var$isString(o) {
    return typeof o === "string";
}
function $51c4c2d07d14dea7$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function $51c4c2d07d14dea7$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function $51c4c2d07d14dea7$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $51c4c2d07d14dea7$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $51c4c2d07d14dea7$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $51c4c2d07d14dea7$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
// NUMBERS AND STRINGS
function $51c4c2d07d14dea7$var$integerBetween(thing, bottom, top) {
    return $51c4c2d07d14dea7$var$isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function $51c4c2d07d14dea7$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $51c4c2d07d14dea7$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $51c4c2d07d14dea7$var$parseInteger(string) {
    if ($51c4c2d07d14dea7$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $51c4c2d07d14dea7$var$parseFloating(string) {
    if ($51c4c2d07d14dea7$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $51c4c2d07d14dea7$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($51c4c2d07d14dea7$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $51c4c2d07d14dea7$var$roundTo(number, digits, towardZero) {
    if (towardZero === void 0) towardZero = false;
    var factor = Math.pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
}
// DATE BASICS
function $51c4c2d07d14dea7$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $51c4c2d07d14dea7$var$daysInYear(year) {
    return $51c4c2d07d14dea7$var$isLeapYear(year) ? 366 : 365;
}
function $51c4c2d07d14dea7$var$daysInMonth(year, month) {
    var modMonth = $51c4c2d07d14dea7$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $51c4c2d07d14dea7$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $51c4c2d07d14dea7$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
function $51c4c2d07d14dea7$var$weeksInWeekYear(weekYear) {
    var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7, last = weekYear - 1, p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
    return p1 === 4 || p2 === 3 ? 53 : 52;
}
function $51c4c2d07d14dea7$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > $51c4c2d07d14dea7$var$Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function $51c4c2d07d14dea7$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $51c4c2d07d14dea7$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function $51c4c2d07d14dea7$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function $51c4c2d07d14dea7$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new $51c4c2d07d14dea7$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $51c4c2d07d14dea7$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($51c4c2d07d14dea7$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $51c4c2d07d14dea7$var$asNumber(v);
    }
    return normalized;
}
function $51c4c2d07d14dea7$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $51c4c2d07d14dea7$var$padStart(hours, 2) + ":" + $51c4c2d07d14dea7$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $51c4c2d07d14dea7$var$padStart(hours, 2) + $51c4c2d07d14dea7$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $51c4c2d07d14dea7$var$timeObject(obj) {
    return $51c4c2d07d14dea7$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ var $51c4c2d07d14dea7$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $51c4c2d07d14dea7$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $51c4c2d07d14dea7$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $51c4c2d07d14dea7$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($51c4c2d07d14dea7$var$monthsNarrow);
        case "short":
            return [].concat($51c4c2d07d14dea7$var$monthsShort);
        case "long":
            return [].concat($51c4c2d07d14dea7$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $51c4c2d07d14dea7$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $51c4c2d07d14dea7$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $51c4c2d07d14dea7$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $51c4c2d07d14dea7$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($51c4c2d07d14dea7$var$weekdaysNarrow);
        case "short":
            return [].concat($51c4c2d07d14dea7$var$weekdaysShort);
        case "long":
            return [].concat($51c4c2d07d14dea7$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $51c4c2d07d14dea7$var$meridiems = [
    "AM",
    "PM"
];
var $51c4c2d07d14dea7$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $51c4c2d07d14dea7$var$erasShort = [
    "BC",
    "AD"
];
var $51c4c2d07d14dea7$var$erasNarrow = [
    "B",
    "A"
];
function $51c4c2d07d14dea7$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($51c4c2d07d14dea7$var$erasNarrow);
        case "short":
            return [].concat($51c4c2d07d14dea7$var$erasShort);
        case "long":
            return [].concat($51c4c2d07d14dea7$var$erasLong);
        default:
            return null;
    }
}
function $51c4c2d07d14dea7$var$meridiemForDateTime(dt) {
    return $51c4c2d07d14dea7$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $51c4c2d07d14dea7$var$weekdayForDateTime(dt, length) {
    return $51c4c2d07d14dea7$var$weekdays(length)[dt.weekday - 1];
}
function $51c4c2d07d14dea7$var$monthForDateTime(dt, length) {
    return $51c4c2d07d14dea7$var$months(length)[dt.month - 1];
}
function $51c4c2d07d14dea7$var$eraForDateTime(dt, length) {
    return $51c4c2d07d14dea7$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $51c4c2d07d14dea7$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $51c4c2d07d14dea7$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $51c4c2d07d14dea7$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $51c4c2d07d14dea7$var$_macroTokenToFormatOpts = {
    D: $51c4c2d07d14dea7$var$DATE_SHORT,
    DD: $51c4c2d07d14dea7$var$DATE_MED,
    DDD: $51c4c2d07d14dea7$var$DATE_FULL,
    DDDD: $51c4c2d07d14dea7$var$DATE_HUGE,
    t: $51c4c2d07d14dea7$var$TIME_SIMPLE,
    tt: $51c4c2d07d14dea7$var$TIME_WITH_SECONDS,
    ttt: $51c4c2d07d14dea7$var$TIME_WITH_SHORT_OFFSET,
    tttt: $51c4c2d07d14dea7$var$TIME_WITH_LONG_OFFSET,
    T: $51c4c2d07d14dea7$var$TIME_24_SIMPLE,
    TT: $51c4c2d07d14dea7$var$TIME_24_WITH_SECONDS,
    TTT: $51c4c2d07d14dea7$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $51c4c2d07d14dea7$var$TIME_24_WITH_LONG_OFFSET,
    f: $51c4c2d07d14dea7$var$DATETIME_SHORT,
    ff: $51c4c2d07d14dea7$var$DATETIME_MED,
    fff: $51c4c2d07d14dea7$var$DATETIME_FULL,
    ffff: $51c4c2d07d14dea7$var$DATETIME_HUGE,
    F: $51c4c2d07d14dea7$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $51c4c2d07d14dea7$var$DATETIME_MED_WITH_SECONDS,
    FFF: $51c4c2d07d14dea7$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $51c4c2d07d14dea7$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $51c4c2d07d14dea7$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $51c4c2d07d14dea7$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $51c4c2d07d14dea7$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.dtFormatter = function dtFormatter(dt, opts) {
        if (opts === void 0) opts = {};
        return this.loc.dtFormatter(dt, $51c4c2d07d14dea7$var$_extends({}, this.opts, opts));
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    };
    _proto.formatInterval = function formatInterval(interval, opts) {
        var df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    };
    _proto.num = function num(n, p) {
        if (p === void 0) p = 0;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $51c4c2d07d14dea7$var$padStart(n, p);
        var opts = $51c4c2d07d14dea7$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $51c4c2d07d14dea7$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $51c4c2d07d14dea7$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $51c4c2d07d14dea7$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $51c4c2d07d14dea7$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $51c4c2d07d14dea7$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "w":
                    return "week";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) return _this2.num(lildur.get(mapped), token.length);
                else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        }));
        return $51c4c2d07d14dea7$var$stringifyTokens(tokens, tokenToString(collapsed));
    };
    return Formatter;
}();
var $51c4c2d07d14dea7$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ var $51c4c2d07d14dea7$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $51c4c2d07d14dea7$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $51c4c2d07d14dea7$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $51c4c2d07d14dea7$var$_extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $51c4c2d07d14dea7$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $51c4c2d07d14dea7$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $51c4c2d07d14dea7$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
var $51c4c2d07d14dea7$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
var $51c4c2d07d14dea7$var$isoExtendedZone = "(?:" + $51c4c2d07d14dea7$var$offsetRegex.source + "?(?:\\[(" + $51c4c2d07d14dea7$var$ianaRegex.source + ")\\])?)?";
var $51c4c2d07d14dea7$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var $51c4c2d07d14dea7$var$isoTimeRegex = RegExp("" + $51c4c2d07d14dea7$var$isoTimeBaseRegex.source + $51c4c2d07d14dea7$var$isoExtendedZone);
var $51c4c2d07d14dea7$var$isoTimeExtensionRegex = RegExp("(?:T" + $51c4c2d07d14dea7$var$isoTimeRegex.source + ")?");
var $51c4c2d07d14dea7$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var $51c4c2d07d14dea7$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var $51c4c2d07d14dea7$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var $51c4c2d07d14dea7$var$extractISOWeekData = $51c4c2d07d14dea7$var$simpleParse("weekYear", "weekNumber", "weekDay");
var $51c4c2d07d14dea7$var$extractISOOrdinalData = $51c4c2d07d14dea7$var$simpleParse("year", "ordinal");
var $51c4c2d07d14dea7$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var $51c4c2d07d14dea7$var$sqlTimeRegex = RegExp($51c4c2d07d14dea7$var$isoTimeBaseRegex.source + " ?(?:" + $51c4c2d07d14dea7$var$offsetRegex.source + "|(" + $51c4c2d07d14dea7$var$ianaRegex.source + "))?");
var $51c4c2d07d14dea7$var$sqlTimeExtensionRegex = RegExp("(?: " + $51c4c2d07d14dea7$var$sqlTimeRegex.source + ")?");
function $51c4c2d07d14dea7$var$int(match, pos, fallback) {
    var m = match[pos];
    return $51c4c2d07d14dea7$var$isUndefined(m) ? fallback : $51c4c2d07d14dea7$var$parseInteger(m);
}
function $51c4c2d07d14dea7$var$extractISOYmd(match, cursor) {
    var item = {
        year: $51c4c2d07d14dea7$var$int(match, cursor),
        month: $51c4c2d07d14dea7$var$int(match, cursor + 1, 1),
        day: $51c4c2d07d14dea7$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $51c4c2d07d14dea7$var$extractISOTime(match, cursor) {
    var item = {
        hours: $51c4c2d07d14dea7$var$int(match, cursor, 0),
        minutes: $51c4c2d07d14dea7$var$int(match, cursor + 1, 0),
        seconds: $51c4c2d07d14dea7$var$int(match, cursor + 2, 0),
        milliseconds: $51c4c2d07d14dea7$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $51c4c2d07d14dea7$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $51c4c2d07d14dea7$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $51c4c2d07d14dea7$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $51c4c2d07d14dea7$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $51c4c2d07d14dea7$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
var $51c4c2d07d14dea7$var$isoTimeOnly = RegExp("^T?" + $51c4c2d07d14dea7$var$isoTimeBaseRegex.source + "$");
// ISO duration parsing
var $51c4c2d07d14dea7$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $51c4c2d07d14dea7$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($51c4c2d07d14dea7$var$parseFloating(yearStr)),
            months: maybeNegate($51c4c2d07d14dea7$var$parseFloating(monthStr)),
            weeks: maybeNegate($51c4c2d07d14dea7$var$parseFloating(weekStr)),
            days: maybeNegate($51c4c2d07d14dea7$var$parseFloating(dayStr)),
            hours: maybeNegate($51c4c2d07d14dea7$var$parseFloating(hourStr)),
            minutes: maybeNegate($51c4c2d07d14dea7$var$parseFloating(minuteStr)),
            seconds: maybeNegate($51c4c2d07d14dea7$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($51c4c2d07d14dea7$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $51c4c2d07d14dea7$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $51c4c2d07d14dea7$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $51c4c2d07d14dea7$var$untruncateYear($51c4c2d07d14dea7$var$parseInteger(yearStr)) : $51c4c2d07d14dea7$var$parseInteger(yearStr),
        month: $51c4c2d07d14dea7$var$monthsShort.indexOf(monthStr) + 1,
        day: $51c4c2d07d14dea7$var$parseInteger(dayStr),
        hour: $51c4c2d07d14dea7$var$parseInteger(hourStr),
        minute: $51c4c2d07d14dea7$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $51c4c2d07d14dea7$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $51c4c2d07d14dea7$var$weekdaysLong.indexOf(weekdayStr) + 1 : $51c4c2d07d14dea7$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
var $51c4c2d07d14dea7$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $51c4c2d07d14dea7$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $51c4c2d07d14dea7$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $51c4c2d07d14dea7$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $51c4c2d07d14dea7$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $51c4c2d07d14dea7$var$FixedOffsetZone(offset)
    ];
}
function $51c4c2d07d14dea7$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
var $51c4c2d07d14dea7$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $51c4c2d07d14dea7$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $51c4c2d07d14dea7$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $51c4c2d07d14dea7$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $51c4c2d07d14dea7$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $51c4c2d07d14dea7$var$FixedOffsetZone.utcInstance
    ];
}
function $51c4c2d07d14dea7$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $51c4c2d07d14dea7$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $51c4c2d07d14dea7$var$FixedOffsetZone.utcInstance
    ];
}
var $51c4c2d07d14dea7$var$isoYmdWithTimeExtensionRegex = $51c4c2d07d14dea7$var$combineRegexes($51c4c2d07d14dea7$var$isoYmdRegex, $51c4c2d07d14dea7$var$isoTimeExtensionRegex);
var $51c4c2d07d14dea7$var$isoWeekWithTimeExtensionRegex = $51c4c2d07d14dea7$var$combineRegexes($51c4c2d07d14dea7$var$isoWeekRegex, $51c4c2d07d14dea7$var$isoTimeExtensionRegex);
var $51c4c2d07d14dea7$var$isoOrdinalWithTimeExtensionRegex = $51c4c2d07d14dea7$var$combineRegexes($51c4c2d07d14dea7$var$isoOrdinalRegex, $51c4c2d07d14dea7$var$isoTimeExtensionRegex);
var $51c4c2d07d14dea7$var$isoTimeCombinedRegex = $51c4c2d07d14dea7$var$combineRegexes($51c4c2d07d14dea7$var$isoTimeRegex);
var $51c4c2d07d14dea7$var$extractISOYmdTimeAndOffset = $51c4c2d07d14dea7$var$combineExtractors($51c4c2d07d14dea7$var$extractISOYmd, $51c4c2d07d14dea7$var$extractISOTime, $51c4c2d07d14dea7$var$extractISOOffset, $51c4c2d07d14dea7$var$extractIANAZone);
var $51c4c2d07d14dea7$var$extractISOWeekTimeAndOffset = $51c4c2d07d14dea7$var$combineExtractors($51c4c2d07d14dea7$var$extractISOWeekData, $51c4c2d07d14dea7$var$extractISOTime, $51c4c2d07d14dea7$var$extractISOOffset, $51c4c2d07d14dea7$var$extractIANAZone);
var $51c4c2d07d14dea7$var$extractISOOrdinalDateAndTime = $51c4c2d07d14dea7$var$combineExtractors($51c4c2d07d14dea7$var$extractISOOrdinalData, $51c4c2d07d14dea7$var$extractISOTime, $51c4c2d07d14dea7$var$extractISOOffset, $51c4c2d07d14dea7$var$extractIANAZone);
var $51c4c2d07d14dea7$var$extractISOTimeAndOffset = $51c4c2d07d14dea7$var$combineExtractors($51c4c2d07d14dea7$var$extractISOTime, $51c4c2d07d14dea7$var$extractISOOffset, $51c4c2d07d14dea7$var$extractIANAZone);
/*
 * @private
 */ function $51c4c2d07d14dea7$var$parseISODate(s) {
    return $51c4c2d07d14dea7$var$parse(s, [
        $51c4c2d07d14dea7$var$isoYmdWithTimeExtensionRegex,
        $51c4c2d07d14dea7$var$extractISOYmdTimeAndOffset
    ], [
        $51c4c2d07d14dea7$var$isoWeekWithTimeExtensionRegex,
        $51c4c2d07d14dea7$var$extractISOWeekTimeAndOffset
    ], [
        $51c4c2d07d14dea7$var$isoOrdinalWithTimeExtensionRegex,
        $51c4c2d07d14dea7$var$extractISOOrdinalDateAndTime
    ], [
        $51c4c2d07d14dea7$var$isoTimeCombinedRegex,
        $51c4c2d07d14dea7$var$extractISOTimeAndOffset
    ]);
}
function $51c4c2d07d14dea7$var$parseRFC2822Date(s) {
    return $51c4c2d07d14dea7$var$parse($51c4c2d07d14dea7$var$preprocessRFC2822(s), [
        $51c4c2d07d14dea7$var$rfc2822,
        $51c4c2d07d14dea7$var$extractRFC2822
    ]);
}
function $51c4c2d07d14dea7$var$parseHTTPDate(s) {
    return $51c4c2d07d14dea7$var$parse(s, [
        $51c4c2d07d14dea7$var$rfc1123,
        $51c4c2d07d14dea7$var$extractRFC1123Or850
    ], [
        $51c4c2d07d14dea7$var$rfc850,
        $51c4c2d07d14dea7$var$extractRFC1123Or850
    ], [
        $51c4c2d07d14dea7$var$ascii,
        $51c4c2d07d14dea7$var$extractASCII
    ]);
}
function $51c4c2d07d14dea7$var$parseISODuration(s) {
    return $51c4c2d07d14dea7$var$parse(s, [
        $51c4c2d07d14dea7$var$isoDuration,
        $51c4c2d07d14dea7$var$extractISODuration
    ]);
}
var $51c4c2d07d14dea7$var$extractISOTimeOnly = $51c4c2d07d14dea7$var$combineExtractors($51c4c2d07d14dea7$var$extractISOTime);
function $51c4c2d07d14dea7$var$parseISOTimeOnly(s) {
    return $51c4c2d07d14dea7$var$parse(s, [
        $51c4c2d07d14dea7$var$isoTimeOnly,
        $51c4c2d07d14dea7$var$extractISOTimeOnly
    ]);
}
var $51c4c2d07d14dea7$var$sqlYmdWithTimeExtensionRegex = $51c4c2d07d14dea7$var$combineRegexes($51c4c2d07d14dea7$var$sqlYmdRegex, $51c4c2d07d14dea7$var$sqlTimeExtensionRegex);
var $51c4c2d07d14dea7$var$sqlTimeCombinedRegex = $51c4c2d07d14dea7$var$combineRegexes($51c4c2d07d14dea7$var$sqlTimeRegex);
var $51c4c2d07d14dea7$var$extractISOTimeOffsetAndIANAZone = $51c4c2d07d14dea7$var$combineExtractors($51c4c2d07d14dea7$var$extractISOTime, $51c4c2d07d14dea7$var$extractISOOffset, $51c4c2d07d14dea7$var$extractIANAZone);
function $51c4c2d07d14dea7$var$parseSQL(s) {
    return $51c4c2d07d14dea7$var$parse(s, [
        $51c4c2d07d14dea7$var$sqlYmdWithTimeExtensionRegex,
        $51c4c2d07d14dea7$var$extractISOYmdTimeAndOffset
    ], [
        $51c4c2d07d14dea7$var$sqlTimeCombinedRegex,
        $51c4c2d07d14dea7$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $51c4c2d07d14dea7$var$INVALID$2 = "Invalid Duration";
// unit conversion constants
var $51c4c2d07d14dea7$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $51c4c2d07d14dea7$var$casualMatrix = $51c4c2d07d14dea7$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $51c4c2d07d14dea7$var$lowOrderMatrix), $51c4c2d07d14dea7$var$daysInYearAccurate = 365.2425, $51c4c2d07d14dea7$var$daysInMonthAccurate = 30.436875, $51c4c2d07d14dea7$var$accurateMatrix = $51c4c2d07d14dea7$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $51c4c2d07d14dea7$var$daysInYearAccurate / 7,
        days: $51c4c2d07d14dea7$var$daysInYearAccurate,
        hours: $51c4c2d07d14dea7$var$daysInYearAccurate * 24,
        minutes: $51c4c2d07d14dea7$var$daysInYearAccurate * 1440,
        seconds: $51c4c2d07d14dea7$var$daysInYearAccurate * 86400,
        milliseconds: $51c4c2d07d14dea7$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $51c4c2d07d14dea7$var$daysInYearAccurate / 28,
        days: $51c4c2d07d14dea7$var$daysInYearAccurate / 4,
        hours: $51c4c2d07d14dea7$var$daysInYearAccurate * 24 / 4,
        minutes: $51c4c2d07d14dea7$var$daysInYearAccurate * 1440 / 4,
        seconds: $51c4c2d07d14dea7$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $51c4c2d07d14dea7$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $51c4c2d07d14dea7$var$daysInMonthAccurate / 7,
        days: $51c4c2d07d14dea7$var$daysInMonthAccurate,
        hours: $51c4c2d07d14dea7$var$daysInMonthAccurate * 24,
        minutes: $51c4c2d07d14dea7$var$daysInMonthAccurate * 1440,
        seconds: $51c4c2d07d14dea7$var$daysInMonthAccurate * 86400,
        milliseconds: $51c4c2d07d14dea7$var$daysInMonthAccurate * 86400000
    }
}, $51c4c2d07d14dea7$var$lowOrderMatrix);
// units ordered by size
var $51c4c2d07d14dea7$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $51c4c2d07d14dea7$var$reverseUnits = $51c4c2d07d14dea7$var$orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $51c4c2d07d14dea7$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $51c4c2d07d14dea7$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $51c4c2d07d14dea7$var$Duration(conf);
}
function $51c4c2d07d14dea7$var$durationToMillis(matrix, vals) {
    var _vals$milliseconds;
    var sum = (_vals$milliseconds = vals.milliseconds) != null ? _vals$milliseconds : 0;
    for(var _iterator = $51c4c2d07d14dea7$var$_createForOfIteratorHelperLoose($51c4c2d07d14dea7$var$reverseUnits.slice(1)), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    }
    return sum;
}
// NB: mutates parameters
function $51c4c2d07d14dea7$var$normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    var factor = $51c4c2d07d14dea7$var$durationToMillis(matrix, vals) < 0 ? -1 : 1;
    $51c4c2d07d14dea7$var$orderedUnits$1.reduceRight(function(previous, current) {
        if (!$51c4c2d07d14dea7$var$isUndefined(vals[current])) {
            if (previous) {
                var previousVal = vals[previous] * factor;
                var conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                var rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    $51c4c2d07d14dea7$var$orderedUnits$1.reduce(function(previous, current) {
        if (!$51c4c2d07d14dea7$var$isUndefined(vals[current])) {
            if (previous) {
                var fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $51c4c2d07d14dea7$var$removeZeroes(vals) {
    var newVals = {};
    for(var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value !== 0) newVals[key] = value;
    }
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $51c4c2d07d14dea7$var$Duration = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        var matrix = accurate ? $51c4c2d07d14dea7$var$accurateMatrix : $51c4c2d07d14dea7$var$casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $51c4c2d07d14dea7$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    } /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */ ;
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $51c4c2d07d14dea7$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $51c4c2d07d14dea7$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $51c4c2d07d14dea7$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    } /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */ ;
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($51c4c2d07d14dea7$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $51c4c2d07d14dea7$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    } /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */ ;
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $51c4c2d07d14dea7$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */ ;
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $51c4c2d07d14dea7$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */ ;
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $51c4c2d07d14dea7$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $51c4c2d07d14dea7$var$Invalid ? reason : new $51c4c2d07d14dea7$var$Invalid(reason, explanation);
        if ($51c4c2d07d14dea7$var$Settings.throwOnInvalid) throw new $51c4c2d07d14dea7$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    } /**
   * @private
   */ ;
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $51c4c2d07d14dea7$var$InvalidUnitError(unit);
        return normalized;
    } /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    } /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */ ;
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $51c4c2d07d14dea7$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $51c4c2d07d14dea7$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $51c4c2d07d14dea7$var$INVALID$2;
    } /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior use the `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
   * @param opts - On option object to override the formatting. Accepts the same keys as the options parameter of the native `Int.NumberFormat` constructor, as well as `listStyle`.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */ ;
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        if (!this.isValid) return $51c4c2d07d14dea7$var$INVALID$2;
        var l = $51c4c2d07d14dea7$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($51c4c2d07d14dea7$var$isUndefined(val)) return null;
            return _this.loc.numberFormatter($51c4c2d07d14dea7$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($51c4c2d07d14dea7$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    } /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $51c4c2d07d14dea7$var$_extends({}, this.values);
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */ ;
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $51c4c2d07d14dea7$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $51c4c2d07d14dea7$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts, {
            includeOffset: false
        });
        var dateTime = $51c4c2d07d14dea7$var$DateTime.fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.toISO();
    } /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        if (!this.isValid) return NaN;
        return $51c4c2d07d14dea7$var$durationToMillis(this.matrix, this.values);
    } /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _i2 = 0, _orderedUnits = $51c4c2d07d14dea7$var$orderedUnits$1; _i2 < _orderedUnits.length; _i2++){
            var k = _orderedUnits[_i2];
            if ($51c4c2d07d14dea7$var$hasOwnProperty(dur.values, k) || $51c4c2d07d14dea7$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $51c4c2d07d14dea7$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    } /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */ ;
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++){
            var k = _Object$keys[_i3];
            result[k] = $51c4c2d07d14dea7$var$asNumber(fn(this.values[k], k));
        }
        return $51c4c2d07d14dea7$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */ ;
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    } /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $51c4c2d07d14dea7$var$_extends({}, this.values, $51c4c2d07d14dea7$var$normalizeObject(values, Duration.normalizeUnit));
        return $51c4c2d07d14dea7$var$clone$1(this, {
            values: mixed
        });
    } /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */ ;
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy, matrix = _ref.matrix;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        var opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $51c4c2d07d14dea7$var$clone$1(this, opts);
    } /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */ ;
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    } /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see second example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */ ;
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $51c4c2d07d14dea7$var$normalizeValues(this.matrix, vals);
        return $51c4c2d07d14dea7$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */ ;
    _proto.rescale = function rescale() {
        if (!this.isValid) return this;
        var vals = $51c4c2d07d14dea7$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $51c4c2d07d14dea7$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */ ;
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _i4 = 0, _orderedUnits2 = $51c4c2d07d14dea7$var$orderedUnits$1; _i4 < _orderedUnits2.length; _i4++){
            var k = _orderedUnits2[_i4];
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ($51c4c2d07d14dea7$var$isNumber(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if ($51c4c2d07d14dea7$var$isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        $51c4c2d07d14dea7$var$normalizeValues(this.matrix, built);
        return $51c4c2d07d14dea7$var$clone$1(this, {
            values: built
        }, true);
    } /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */ ;
    _proto.shiftToAll = function shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    } /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */ ;
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++){
            var k = _Object$keys2[_i5];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $51c4c2d07d14dea7$var$clone$1(this, {
            values: negated
        }, true);
    } /**
   * Get the years.
   * @type {number}
   */ ;
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _i6 = 0, _orderedUnits3 = $51c4c2d07d14dea7$var$orderedUnits$1; _i6 < _orderedUnits3.length; _i6++){
            var u = _orderedUnits3[_i6];
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $51c4c2d07d14dea7$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}();
var $51c4c2d07d14dea7$var$INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function $51c4c2d07d14dea7$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $51c4c2d07d14dea7$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $51c4c2d07d14dea7$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $51c4c2d07d14dea7$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $51c4c2d07d14dea7$var$Interval = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $51c4c2d07d14dea7$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $51c4c2d07d14dea7$var$Invalid ? reason : new $51c4c2d07d14dea7$var$Invalid(reason, explanation);
        if ($51c4c2d07d14dea7$var$Settings.throwOnInvalid) throw new $51c4c2d07d14dea7$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    } /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */ ;
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $51c4c2d07d14dea7$var$friendlyDateTime(start), builtEnd = $51c4c2d07d14dea7$var$friendlyDateTime(end);
        var validateError = $51c4c2d07d14dea7$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    } /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.after = function after(start, duration) {
        var dur = $51c4c2d07d14dea7$var$Duration.fromDurationLike(duration), dt = $51c4c2d07d14dea7$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    } /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.before = function before(end, duration) {
        var dur = $51c4c2d07d14dea7$var$Duration.fromDurationLike(duration), dt = $51c4c2d07d14dea7$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    } /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */ ;
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $51c4c2d07d14dea7$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $51c4c2d07d14dea7$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $51c4c2d07d14dea7$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $51c4c2d07d14dea7$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    } /**
   * Returns the start of the Interval
   * @type {DateTime}
   */ ;
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    } /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */ ;
    _proto.count = function count(unit) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit), end = this.end.startOf(unit);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    } /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    } /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */ ;
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    } /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    } /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    } /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    } /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */ ;
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    } /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */ ;
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($51c4c2d07d14dea7$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    } /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */ ;
    _proto.splitBy = function splitBy(duration) {
        var dur = $51c4c2d07d14dea7$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    } /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */ ;
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    } /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    } /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    } /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    } /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    } /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    } /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    } /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    } /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    } /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $51c4c2d07d14dea7$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    } /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */ ;
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    } /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        if (!this.isValid) return $51c4c2d07d14dea7$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    } /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $51c4c2d07d14dea7$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $51c4c2d07d14dea7$var$Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $51c4c2d07d14dea7$var$INVALID$1;
    } /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $51c4c2d07d14dea7$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    } /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $51c4c2d07d14dea7$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    } /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $51c4c2d07d14dea7$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    } /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $51c4c2d07d14dea7$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    } /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */ ;
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $51c4c2d07d14dea7$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    } /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */ ;
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $51c4c2d07d14dea7$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}();
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $51c4c2d07d14dea7$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $51c4c2d07d14dea7$var$Settings.defaultZone;
        var proto = $51c4c2d07d14dea7$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    } /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */ ;
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $51c4c2d07d14dea7$var$IANAZone.isValidZone(zone);
    } /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */ ;
    Info.normalizeZone = function normalizeZone$1(input) {
        return $51c4c2d07d14dea7$var$normalizeZone(input, $51c4c2d07d14dea7$var$Settings.defaultZone);
    } /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */ ;
    Info.months = function months(length, _temp) {
        if (length === void 0) length = "long";
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$numberingSystem = _ref.numberingSystem, numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj, _ref$outputCalendar = _ref.outputCalendar, outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;
        return (locObj || $51c4c2d07d14dea7$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    } /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */ ;
    Info.monthsFormat = function monthsFormat(length, _temp2) {
        if (length === void 0) length = "long";
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$numberingSystem = _ref2.numberingSystem, numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj, _ref2$outputCalendar = _ref2.outputCalendar, outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;
        return (locObj || $51c4c2d07d14dea7$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    } /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */ ;
    Info.weekdays = function weekdays(length, _temp3) {
        if (length === void 0) length = "long";
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$numberingSystem = _ref3.numberingSystem, numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        return (locObj || $51c4c2d07d14dea7$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    } /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */ ;
    Info.weekdaysFormat = function weekdaysFormat(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj;
        return (locObj || $51c4c2d07d14dea7$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    } /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */ ;
    Info.meridiems = function meridiems(_temp5) {
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale;
        return $51c4c2d07d14dea7$var$Locale.create(locale).meridiems();
    } /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */ ;
    Info.eras = function eras(length, _temp6) {
        if (length === void 0) length = "short";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale;
        return $51c4c2d07d14dea7$var$Locale.create(locale, null, "gregory").eras(length);
    } /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { relative: false }
   * @return {Object}
   */ ;
    Info.features = function features() {
        return {
            relative: $51c4c2d07d14dea7$var$hasRelative()
        };
    };
    return Info;
}();
function $51c4c2d07d14dea7$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($51c4c2d07d14dea7$var$Duration.fromMillis(ms).as("days"));
}
function $51c4c2d07d14dea7$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter + (b.year - a.year) * 4;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $51c4c2d07d14dea7$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $51c4c2d07d14dea7$var$dayDiff
        ]
    ];
    var results = {};
    var earlier = cursor;
    var lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            lowestOrder = unit;
            results[unit] = differ(cursor, later);
            highWater = earlier.plus(results);
            if (highWater > later) {
                // we overshot the end point, backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
                // if we are still overshooting now, we need to backtrack again
                // this happens in certain situations when diffing times in different zones,
                // because this calculation ignores time zones
                if (cursor > later) {
                    // keep the "overshot by 1" around as highWater
                    highWater = cursor;
                    // backtrack cursor by 1
                    results[unit]--;
                    cursor = earlier.plus(results);
                }
            } else cursor = highWater;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $51c4c2d07d14dea7$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $51c4c2d07d14dea7$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus;
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $51c4c2d07d14dea7$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $51c4c2d07d14dea7$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $51c4c2d07d14dea7$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $51c4c2d07d14dea7$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $51c4c2d07d14dea7$var$hanidecChars = $51c4c2d07d14dea7$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $51c4c2d07d14dea7$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($51c4c2d07d14dea7$var$numberingSystems.hanidec) !== -1) value += $51c4c2d07d14dea7$var$hanidecChars.indexOf(str[i]);
            else for(var key in $51c4c2d07d14dea7$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $51c4c2d07d14dea7$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
function $51c4c2d07d14dea7$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    return new RegExp("" + $51c4c2d07d14dea7$var$numberingSystems[numberingSystem || "latn"] + append);
}
var $51c4c2d07d14dea7$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $51c4c2d07d14dea7$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($51c4c2d07d14dea7$var$parseDigits(s));
        }
    };
}
var $51c4c2d07d14dea7$var$NBSP = String.fromCharCode(160);
var $51c4c2d07d14dea7$var$spaceOrNBSP = "[ " + $51c4c2d07d14dea7$var$NBSP + "]";
var $51c4c2d07d14dea7$var$spaceOrNBSPRegExp = new RegExp($51c4c2d07d14dea7$var$spaceOrNBSP, "g");
function $51c4c2d07d14dea7$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($51c4c2d07d14dea7$var$spaceOrNBSPRegExp, $51c4c2d07d14dea7$var$spaceOrNBSP);
}
function $51c4c2d07d14dea7$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($51c4c2d07d14dea7$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $51c4c2d07d14dea7$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($51c4c2d07d14dea7$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $51c4c2d07d14dea7$var$stripInsensitivities(s) === $51c4c2d07d14dea7$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $51c4c2d07d14dea7$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $51c4c2d07d14dea7$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $51c4c2d07d14dea7$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $51c4c2d07d14dea7$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function $51c4c2d07d14dea7$var$unitForToken(token, loc) {
    var one = $51c4c2d07d14dea7$var$digitRegex(loc), two = $51c4c2d07d14dea7$var$digitRegex(loc, "{2}"), three = $51c4c2d07d14dea7$var$digitRegex(loc, "{3}"), four = $51c4c2d07d14dea7$var$digitRegex(loc, "{4}"), six = $51c4c2d07d14dea7$var$digitRegex(loc, "{6}"), oneOrTwo = $51c4c2d07d14dea7$var$digitRegex(loc, "{1,2}"), oneToThree = $51c4c2d07d14dea7$var$digitRegex(loc, "{1,3}"), oneToSix = $51c4c2d07d14dea7$var$digitRegex(loc, "{1,6}"), oneToNine = $51c4c2d07d14dea7$var$digitRegex(loc, "{1,9}"), twoToFour = $51c4c2d07d14dea7$var$digitRegex(loc, "{2,4}"), fourToSix = $51c4c2d07d14dea7$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($51c4c2d07d14dea7$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $51c4c2d07d14dea7$var$oneOf(loc.eras("short"), 0);
            case "GG":
                return $51c4c2d07d14dea7$var$oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return $51c4c2d07d14dea7$var$intUnit(oneToSix);
            case "yy":
                return $51c4c2d07d14dea7$var$intUnit(twoToFour, $51c4c2d07d14dea7$var$untruncateYear);
            case "yyyy":
                return $51c4c2d07d14dea7$var$intUnit(four);
            case "yyyyy":
                return $51c4c2d07d14dea7$var$intUnit(fourToSix);
            case "yyyyyy":
                return $51c4c2d07d14dea7$var$intUnit(six);
            // months
            case "M":
                return $51c4c2d07d14dea7$var$intUnit(oneOrTwo);
            case "MM":
                return $51c4c2d07d14dea7$var$intUnit(two);
            case "MMM":
                return $51c4c2d07d14dea7$var$oneOf(loc.months("short", true), 1);
            case "MMMM":
                return $51c4c2d07d14dea7$var$oneOf(loc.months("long", true), 1);
            case "L":
                return $51c4c2d07d14dea7$var$intUnit(oneOrTwo);
            case "LL":
                return $51c4c2d07d14dea7$var$intUnit(two);
            case "LLL":
                return $51c4c2d07d14dea7$var$oneOf(loc.months("short", false), 1);
            case "LLLL":
                return $51c4c2d07d14dea7$var$oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return $51c4c2d07d14dea7$var$intUnit(oneOrTwo);
            case "dd":
                return $51c4c2d07d14dea7$var$intUnit(two);
            // ordinals
            case "o":
                return $51c4c2d07d14dea7$var$intUnit(oneToThree);
            case "ooo":
                return $51c4c2d07d14dea7$var$intUnit(three);
            // time
            case "HH":
                return $51c4c2d07d14dea7$var$intUnit(two);
            case "H":
                return $51c4c2d07d14dea7$var$intUnit(oneOrTwo);
            case "hh":
                return $51c4c2d07d14dea7$var$intUnit(two);
            case "h":
                return $51c4c2d07d14dea7$var$intUnit(oneOrTwo);
            case "mm":
                return $51c4c2d07d14dea7$var$intUnit(two);
            case "m":
                return $51c4c2d07d14dea7$var$intUnit(oneOrTwo);
            case "q":
                return $51c4c2d07d14dea7$var$intUnit(oneOrTwo);
            case "qq":
                return $51c4c2d07d14dea7$var$intUnit(two);
            case "s":
                return $51c4c2d07d14dea7$var$intUnit(oneOrTwo);
            case "ss":
                return $51c4c2d07d14dea7$var$intUnit(two);
            case "S":
                return $51c4c2d07d14dea7$var$intUnit(oneToThree);
            case "SSS":
                return $51c4c2d07d14dea7$var$intUnit(three);
            case "u":
                return $51c4c2d07d14dea7$var$simple(oneToNine);
            case "uu":
                return $51c4c2d07d14dea7$var$simple(oneOrTwo);
            case "uuu":
                return $51c4c2d07d14dea7$var$intUnit(one);
            // meridiem
            case "a":
                return $51c4c2d07d14dea7$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $51c4c2d07d14dea7$var$intUnit(four);
            case "kk":
                return $51c4c2d07d14dea7$var$intUnit(twoToFour, $51c4c2d07d14dea7$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $51c4c2d07d14dea7$var$intUnit(oneOrTwo);
            case "WW":
                return $51c4c2d07d14dea7$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $51c4c2d07d14dea7$var$intUnit(one);
            case "EEE":
                return $51c4c2d07d14dea7$var$oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return $51c4c2d07d14dea7$var$oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return $51c4c2d07d14dea7$var$oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return $51c4c2d07d14dea7$var$oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $51c4c2d07d14dea7$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $51c4c2d07d14dea7$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $51c4c2d07d14dea7$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $51c4c2d07d14dea7$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $51c4c2d07d14dea7$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $51c4c2d07d14dea7$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $51c4c2d07d14dea7$var$tokenForPart(part, formatOpts, resolvedOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") {
        var isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    var style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    var actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    var val = $51c4c2d07d14dea7$var$partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $51c4c2d07d14dea7$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $51c4c2d07d14dea7$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($51c4c2d07d14dea7$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $51c4c2d07d14dea7$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$51c4c2d07d14dea7$var$isUndefined(matches.z)) zone = $51c4c2d07d14dea7$var$IANAZone.create(matches.z);
    if (!$51c4c2d07d14dea7$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $51c4c2d07d14dea7$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$51c4c2d07d14dea7$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$51c4c2d07d14dea7$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$51c4c2d07d14dea7$var$isUndefined(matches.u)) matches.S = $51c4c2d07d14dea7$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $51c4c2d07d14dea7$var$dummyDateTimeCache = null;
function $51c4c2d07d14dea7$var$getDummyDateTime() {
    if (!$51c4c2d07d14dea7$var$dummyDateTimeCache) $51c4c2d07d14dea7$var$dummyDateTimeCache = $51c4c2d07d14dea7$var$DateTime.fromMillis(1555555555555);
    return $51c4c2d07d14dea7$var$dummyDateTimeCache;
}
function $51c4c2d07d14dea7$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $51c4c2d07d14dea7$var$Formatter.macroTokenToFormatOpts(token.val);
    var tokens = $51c4c2d07d14dea7$var$formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $51c4c2d07d14dea7$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $51c4c2d07d14dea7$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ function $51c4c2d07d14dea7$var$explainFromTokens(locale, input, format) {
    var tokens = $51c4c2d07d14dea7$var$expandMacroTokens($51c4c2d07d14dea7$var$Formatter.parseFormat(format), locale), units = tokens.map(function(t) {
        return $51c4c2d07d14dea7$var$unitForToken(t, locale);
    }), disqualifyingUnit = units.find(function(t) {
        return t.invalidReason;
    });
    if (disqualifyingUnit) return {
        input: input,
        tokens: tokens,
        invalidReason: disqualifyingUnit.invalidReason
    };
    else {
        var _buildRegex = $51c4c2d07d14dea7$var$buildRegex(units), regexString = _buildRegex[0], handlers = _buildRegex[1], regex = RegExp(regexString, "i"), _match = $51c4c2d07d14dea7$var$match(input, regex, handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $51c4c2d07d14dea7$var$dateTimeFromMatches(matches) : [
            null,
            null,
            undefined
        ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
        if ($51c4c2d07d14dea7$var$hasOwnProperty(matches, "a") && $51c4c2d07d14dea7$var$hasOwnProperty(matches, "H")) throw new $51c4c2d07d14dea7$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
        return {
            input: input,
            tokens: tokens,
            regex: regex,
            rawMatches: rawMatches,
            matches: matches,
            result: result,
            zone: zone,
            specificOffset: specificOffset
        };
    }
}
function $51c4c2d07d14dea7$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $51c4c2d07d14dea7$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $51c4c2d07d14dea7$var$formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    var formatter = $51c4c2d07d14dea7$var$Formatter.create(locale, formatOpts);
    var df = formatter.dtFormatter($51c4c2d07d14dea7$var$getDummyDateTime());
    var parts = df.formatToParts();
    var resolvedOpts = df.resolvedOptions();
    return parts.map(function(p) {
        return $51c4c2d07d14dea7$var$tokenForPart(p, formatOpts, resolvedOpts);
    });
}
var $51c4c2d07d14dea7$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $51c4c2d07d14dea7$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $51c4c2d07d14dea7$var$unitOutOfRange(unit, value) {
    return new $51c4c2d07d14dea7$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $51c4c2d07d14dea7$var$dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $51c4c2d07d14dea7$var$computeOrdinal(year, month, day) {
    return day + ($51c4c2d07d14dea7$var$isLeapYear(year) ? $51c4c2d07d14dea7$var$leapLadder : $51c4c2d07d14dea7$var$nonLeapLadder)[month - 1];
}
function $51c4c2d07d14dea7$var$uncomputeOrdinal(year, ordinal) {
    var table = $51c4c2d07d14dea7$var$isLeapYear(year) ? $51c4c2d07d14dea7$var$leapLadder : $51c4c2d07d14dea7$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
/**
 * @private
 */ function $51c4c2d07d14dea7$var$gregorianToWeek(gregObj) {
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $51c4c2d07d14dea7$var$computeOrdinal(year, month, day), weekday = $51c4c2d07d14dea7$var$dayOfWeek(year, month, day);
    var weekNumber = Math.floor((ordinal - weekday + 10) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $51c4c2d07d14dea7$var$weeksInWeekYear(weekYear);
    } else if (weekNumber > $51c4c2d07d14dea7$var$weeksInWeekYear(year)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $51c4c2d07d14dea7$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $51c4c2d07d14dea7$var$timeObject(gregObj));
}
function $51c4c2d07d14dea7$var$weekToGregorian(weekData) {
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $51c4c2d07d14dea7$var$dayOfWeek(weekYear, 1, 4), yearInDays = $51c4c2d07d14dea7$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $51c4c2d07d14dea7$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $51c4c2d07d14dea7$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $51c4c2d07d14dea7$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $51c4c2d07d14dea7$var$_extends({
        year: year,
        month: month,
        day: day
    }, $51c4c2d07d14dea7$var$timeObject(weekData));
}
function $51c4c2d07d14dea7$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $51c4c2d07d14dea7$var$computeOrdinal(year, month, day);
    return $51c4c2d07d14dea7$var$_extends({
        year: year,
        ordinal: ordinal
    }, $51c4c2d07d14dea7$var$timeObject(gregData));
}
function $51c4c2d07d14dea7$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $51c4c2d07d14dea7$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $51c4c2d07d14dea7$var$_extends({
        year: year,
        month: month,
        day: day
    }, $51c4c2d07d14dea7$var$timeObject(ordinalData));
}
function $51c4c2d07d14dea7$var$hasInvalidWeekData(obj) {
    var validYear = $51c4c2d07d14dea7$var$isInteger(obj.weekYear), validWeek = $51c4c2d07d14dea7$var$integerBetween(obj.weekNumber, 1, $51c4c2d07d14dea7$var$weeksInWeekYear(obj.weekYear)), validWeekday = $51c4c2d07d14dea7$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $51c4c2d07d14dea7$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $51c4c2d07d14dea7$var$unitOutOfRange("week", obj.week);
    else if (!validWeekday) return $51c4c2d07d14dea7$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $51c4c2d07d14dea7$var$hasInvalidOrdinalData(obj) {
    var validYear = $51c4c2d07d14dea7$var$isInteger(obj.year), validOrdinal = $51c4c2d07d14dea7$var$integerBetween(obj.ordinal, 1, $51c4c2d07d14dea7$var$daysInYear(obj.year));
    if (!validYear) return $51c4c2d07d14dea7$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $51c4c2d07d14dea7$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $51c4c2d07d14dea7$var$hasInvalidGregorianData(obj) {
    var validYear = $51c4c2d07d14dea7$var$isInteger(obj.year), validMonth = $51c4c2d07d14dea7$var$integerBetween(obj.month, 1, 12), validDay = $51c4c2d07d14dea7$var$integerBetween(obj.day, 1, $51c4c2d07d14dea7$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $51c4c2d07d14dea7$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $51c4c2d07d14dea7$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $51c4c2d07d14dea7$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $51c4c2d07d14dea7$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $51c4c2d07d14dea7$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $51c4c2d07d14dea7$var$integerBetween(minute, 0, 59), validSecond = $51c4c2d07d14dea7$var$integerBetween(second, 0, 59), validMillisecond = $51c4c2d07d14dea7$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $51c4c2d07d14dea7$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $51c4c2d07d14dea7$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $51c4c2d07d14dea7$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $51c4c2d07d14dea7$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
var $51c4c2d07d14dea7$var$INVALID = "Invalid DateTime";
var $51c4c2d07d14dea7$var$MAX_DATE = 8.64e15;
function $51c4c2d07d14dea7$var$unsupportedZone(zone) {
    return new $51c4c2d07d14dea7$var$Invalid("unsupported zone", 'the zone "' + zone.name + '" is not supported');
}
// we cache week data on the DT object and this intermediates the cache
function $51c4c2d07d14dea7$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $51c4c2d07d14dea7$var$gregorianToWeek(dt.c);
    return dt.weekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $51c4c2d07d14dea7$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $51c4c2d07d14dea7$var$DateTime($51c4c2d07d14dea7$var$_extends({}, current, alts, {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $51c4c2d07d14dea7$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $51c4c2d07d14dea7$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $51c4c2d07d14dea7$var$objToTS(obj, offset, zone) {
    return $51c4c2d07d14dea7$var$fixOffset($51c4c2d07d14dea7$var$objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $51c4c2d07d14dea7$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $51c4c2d07d14dea7$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $51c4c2d07d14dea7$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $51c4c2d07d14dea7$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $51c4c2d07d14dea7$var$objToLocalTS(c);
    var _fixOffset = $51c4c2d07d14dea7$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $51c4c2d07d14dea7$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        var interpretationZone = parsedZone || zone, inst = $51c4c2d07d14dea7$var$DateTime.fromObject(parsed, $51c4c2d07d14dea7$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $51c4c2d07d14dea7$var$DateTime.invalid(new $51c4c2d07d14dea7$var$Invalid("unparsable", 'the input "' + text + "\" can't be parsed as " + format));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $51c4c2d07d14dea7$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $51c4c2d07d14dea7$var$Formatter.create($51c4c2d07d14dea7$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $51c4c2d07d14dea7$var$_toISODate(o, extended) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $51c4c2d07d14dea7$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (extended) {
        c += "-";
        c += $51c4c2d07d14dea7$var$padStart(o.c.month);
        c += "-";
        c += $51c4c2d07d14dea7$var$padStart(o.c.day);
    } else {
        c += $51c4c2d07d14dea7$var$padStart(o.c.month);
        c += $51c4c2d07d14dea7$var$padStart(o.c.day);
    }
    return c;
}
function $51c4c2d07d14dea7$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
    var c = $51c4c2d07d14dea7$var$padStart(o.c.hour);
    if (extended) {
        c += ":";
        c += $51c4c2d07d14dea7$var$padStart(o.c.minute);
        if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) c += ":";
    } else c += $51c4c2d07d14dea7$var$padStart(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
        c += $51c4c2d07d14dea7$var$padStart(o.c.second);
        if (o.c.millisecond !== 0 || !suppressMilliseconds) {
            c += ".";
            c += $51c4c2d07d14dea7$var$padStart(o.c.millisecond, 3);
        }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $51c4c2d07d14dea7$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $51c4c2d07d14dea7$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $51c4c2d07d14dea7$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $51c4c2d07d14dea7$var$padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
var $51c4c2d07d14dea7$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $51c4c2d07d14dea7$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $51c4c2d07d14dea7$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
var $51c4c2d07d14dea7$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $51c4c2d07d14dea7$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $51c4c2d07d14dea7$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $51c4c2d07d14dea7$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $51c4c2d07d14dea7$var$InvalidUnitError(unit);
    return normalized;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $51c4c2d07d14dea7$var$quickDT(obj, opts) {
    var zone = $51c4c2d07d14dea7$var$normalizeZone(opts.zone, $51c4c2d07d14dea7$var$Settings.defaultZone), loc = $51c4c2d07d14dea7$var$Locale.fromObject(opts), tsNow = $51c4c2d07d14dea7$var$Settings.now();
    var ts, o;
    // assume we have the higher-order units
    if (!$51c4c2d07d14dea7$var$isUndefined(obj.year)) {
        for(var _i = 0, _orderedUnits = $51c4c2d07d14dea7$var$orderedUnits; _i < _orderedUnits.length; _i++){
            var u = _orderedUnits[_i];
            if ($51c4c2d07d14dea7$var$isUndefined(obj[u])) obj[u] = $51c4c2d07d14dea7$var$defaultUnitValues[u];
        }
        var invalid = $51c4c2d07d14dea7$var$hasInvalidGregorianData(obj) || $51c4c2d07d14dea7$var$hasInvalidTimeData(obj);
        if (invalid) return $51c4c2d07d14dea7$var$DateTime.invalid(invalid);
        var offsetProvis = zone.offset(tsNow);
        var _objToTS = $51c4c2d07d14dea7$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = tsNow;
    return new $51c4c2d07d14dea7$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $51c4c2d07d14dea7$var$diffRelative(start, end, opts) {
    var round = $51c4c2d07d14dea7$var$isUndefined(opts.round) ? true : opts.round, format = function format(c, unit) {
        c = $51c4c2d07d14dea7$var$roundTo(c, round || opts.calendary ? 0 : 2, true);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator = $51c4c2d07d14dea7$var$_createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $51c4c2d07d14dea7$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $51c4c2d07d14dea7$var$DateTime = /*#__PURE__*/ function() {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $51c4c2d07d14dea7$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $51c4c2d07d14dea7$var$Invalid("invalid input") : null) || (!zone.isValid ? $51c4c2d07d14dea7$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $51c4c2d07d14dea7$var$isUndefined(config.ts) ? $51c4c2d07d14dea7$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                var ot = zone.offset(this.ts);
                c = $51c4c2d07d14dea7$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $51c4c2d07d14dea7$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $51c4c2d07d14dea7$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    } /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */ ;
    DateTime.local = function local() {
        var _lastOpts = $51c4c2d07d14dea7$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $51c4c2d07d14dea7$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */ ;
    DateTime.utc = function utc() {
        var _lastOpts2 = $51c4c2d07d14dea7$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $51c4c2d07d14dea7$var$FixedOffsetZone.utcInstance;
        return $51c4c2d07d14dea7$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */ ;
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $51c4c2d07d14dea7$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $51c4c2d07d14dea7$var$normalizeZone(options.zone, $51c4c2d07d14dea7$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($51c4c2d07d14dea7$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $51c4c2d07d14dea7$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$51c4c2d07d14dea7$var$isNumber(milliseconds)) throw new $51c4c2d07d14dea7$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$51c4c2d07d14dea7$var$MAX_DATE || milliseconds > $51c4c2d07d14dea7$var$MAX_DATE) // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $51c4c2d07d14dea7$var$normalizeZone(options.zone, $51c4c2d07d14dea7$var$Settings.defaultZone),
            loc: $51c4c2d07d14dea7$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$51c4c2d07d14dea7$var$isNumber(seconds)) throw new $51c4c2d07d14dea7$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $51c4c2d07d14dea7$var$normalizeZone(options.zone, $51c4c2d07d14dea7$var$Settings.defaultZone),
            loc: $51c4c2d07d14dea7$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */ ;
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $51c4c2d07d14dea7$var$normalizeZone(opts.zone, $51c4c2d07d14dea7$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($51c4c2d07d14dea7$var$unsupportedZone(zoneToUse));
        var tsNow = $51c4c2d07d14dea7$var$Settings.now(), offsetProvis = !$51c4c2d07d14dea7$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), normalized = $51c4c2d07d14dea7$var$normalizeObject(obj, $51c4c2d07d14dea7$var$normalizeUnit), containsOrdinal = !$51c4c2d07d14dea7$var$isUndefined(normalized.ordinal), containsGregorYear = !$51c4c2d07d14dea7$var$isUndefined(normalized.year), containsGregorMD = !$51c4c2d07d14dea7$var$isUndefined(normalized.month) || !$51c4c2d07d14dea7$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber, loc = $51c4c2d07d14dea7$var$Locale.fromObject(opts);
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $51c4c2d07d14dea7$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $51c4c2d07d14dea7$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $51c4c2d07d14dea7$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $51c4c2d07d14dea7$var$orderedWeekUnits;
            defaultValues = $51c4c2d07d14dea7$var$defaultWeekUnitValues;
            objNow = $51c4c2d07d14dea7$var$gregorianToWeek(objNow);
        } else if (containsOrdinal) {
            units = $51c4c2d07d14dea7$var$orderedOrdinalUnits;
            defaultValues = $51c4c2d07d14dea7$var$defaultOrdinalUnitValues;
            objNow = $51c4c2d07d14dea7$var$gregorianToOrdinal(objNow);
        } else {
            units = $51c4c2d07d14dea7$var$orderedUnits;
            defaultValues = $51c4c2d07d14dea7$var$defaultUnitValues;
        }
        // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator2 = $51c4c2d07d14dea7$var$_createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;){
            var u = _step2.value;
            var v = normalized[u];
            if (!$51c4c2d07d14dea7$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $51c4c2d07d14dea7$var$hasInvalidWeekData(normalized) : containsOrdinal ? $51c4c2d07d14dea7$var$hasInvalidOrdinalData(normalized) : $51c4c2d07d14dea7$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $51c4c2d07d14dea7$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        var gregorian = useWeekData ? $51c4c2d07d14dea7$var$weekToGregorian(normalized) : containsOrdinal ? $51c4c2d07d14dea7$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $51c4c2d07d14dea7$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        return inst;
    } /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */ ;
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $51c4c2d07d14dea7$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $51c4c2d07d14dea7$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    } /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */ ;
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $51c4c2d07d14dea7$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $51c4c2d07d14dea7$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    } /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */ ;
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $51c4c2d07d14dea7$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $51c4c2d07d14dea7$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    } /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($51c4c2d07d14dea7$var$isUndefined(text) || $51c4c2d07d14dea7$var$isUndefined(fmt)) throw new $51c4c2d07d14dea7$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $51c4c2d07d14dea7$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $51c4c2d07d14dea7$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $51c4c2d07d14dea7$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    } /**
   * @deprecated use fromFormat instead
   */ ;
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    } /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */ ;
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $51c4c2d07d14dea7$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $51c4c2d07d14dea7$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    } /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */ ;
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $51c4c2d07d14dea7$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $51c4c2d07d14dea7$var$Invalid ? reason : new $51c4c2d07d14dea7$var$Invalid(reason, explanation);
        if ($51c4c2d07d14dea7$var$Settings.throwOnInvalid) throw new $51c4c2d07d14dea7$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    } /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    } /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var tokenList = $51c4c2d07d14dea7$var$formatOptsToTokens(formatOpts, $51c4c2d07d14dea7$var$Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map(function(t) {
            return t ? t.val : null;
        }).join("");
    } /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var expanded = $51c4c2d07d14dea7$var$expandMacroTokens($51c4c2d07d14dea7$var$Formatter.parseFormat(fmt), $51c4c2d07d14dea7$var$Locale.fromObject(localeOpts));
        return expanded.map(function(t) {
            return t.val;
        }).join("");
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */ ;
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    } /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */ ;
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ _proto.getPossibleOffsets = function getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        var dayMs = 86400000;
        var minuteMs = 60000;
        var localTS = $51c4c2d07d14dea7$var$objToLocalTS(this.c);
        var oEarlier = this.zone.offset(localTS - dayMs);
        var oLater = this.zone.offset(localTS + dayMs);
        var o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        var o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        var ts1 = localTS - o1 * minuteMs;
        var ts2 = localTS - o2 * minuteMs;
        var c1 = $51c4c2d07d14dea7$var$tsToObj(ts1, o1);
        var c2 = $51c4c2d07d14dea7$var$tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            $51c4c2d07d14dea7$var$clone(this, {
                ts: ts1
            }),
            $51c4c2d07d14dea7$var$clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    } /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */ ;
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $51c4c2d07d14dea7$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    } /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */ ;
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($51c4c2d07d14dea7$var$FixedOffsetZone.instance(offset), opts);
    } /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */ ;
    _proto.toLocal = function toLocal() {
        return this.setZone($51c4c2d07d14dea7$var$Settings.defaultZone);
    } /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */ ;
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $51c4c2d07d14dea7$var$normalizeZone(zone, $51c4c2d07d14dea7$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($51c4c2d07d14dea7$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $51c4c2d07d14dea7$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $51c4c2d07d14dea7$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    } /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */ ;
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $51c4c2d07d14dea7$var$clone(this, {
            loc: loc
        });
    } /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */ ;
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    } /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $51c4c2d07d14dea7$var$normalizeObject(values, $51c4c2d07d14dea7$var$normalizeUnit), settingWeekStuff = !$51c4c2d07d14dea7$var$isUndefined(normalized.weekYear) || !$51c4c2d07d14dea7$var$isUndefined(normalized.weekNumber) || !$51c4c2d07d14dea7$var$isUndefined(normalized.weekday), containsOrdinal = !$51c4c2d07d14dea7$var$isUndefined(normalized.ordinal), containsGregorYear = !$51c4c2d07d14dea7$var$isUndefined(normalized.year), containsGregorMD = !$51c4c2d07d14dea7$var$isUndefined(normalized.month) || !$51c4c2d07d14dea7$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $51c4c2d07d14dea7$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $51c4c2d07d14dea7$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $51c4c2d07d14dea7$var$weekToGregorian($51c4c2d07d14dea7$var$_extends({}, $51c4c2d07d14dea7$var$gregorianToWeek(this.c), normalized));
        else if (!$51c4c2d07d14dea7$var$isUndefined(normalized.ordinal)) mixed = $51c4c2d07d14dea7$var$ordinalToGregorian($51c4c2d07d14dea7$var$_extends({}, $51c4c2d07d14dea7$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $51c4c2d07d14dea7$var$_extends({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($51c4c2d07d14dea7$var$isUndefined(normalized.day)) mixed.day = Math.min($51c4c2d07d14dea7$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $51c4c2d07d14dea7$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $51c4c2d07d14dea7$var$clone(this, {
            ts: ts,
            o: o
        });
    } /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $51c4c2d07d14dea7$var$Duration.fromDurationLike(duration);
        return $51c4c2d07d14dea7$var$clone(this, $51c4c2d07d14dea7$var$adjustTime(this, dur));
    } /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $51c4c2d07d14dea7$var$Duration.fromDurationLike(duration).negate();
        return $51c4c2d07d14dea7$var$clone(this, $51c4c2d07d14dea7$var$adjustTime(this, dur));
    } /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */ ;
    _proto.startOf = function startOf(unit) {
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $51c4c2d07d14dea7$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") o.weekday = 1;
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    } /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */ ;
    _proto.endOf = function endOf(unit) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit).minus(1) : this;
    } /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $51c4c2d07d14dea7$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $51c4c2d07d14dea7$var$INVALID;
    } /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $51c4c2d07d14dea7$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $51c4c2d07d14dea7$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $51c4c2d07d14dea7$var$INVALID;
    } /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */ ;
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $51c4c2d07d14dea7$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */ ;
    _proto.toISO = function toISO(_temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$format = _ref4.format, format = _ref4$format === void 0 ? "extended" : _ref4$format, _ref4$suppressSeconds = _ref4.suppressSeconds, suppressSeconds = _ref4$suppressSeconds === void 0 ? false : _ref4$suppressSeconds, _ref4$suppressMillise = _ref4.suppressMilliseconds, suppressMilliseconds = _ref4$suppressMillise === void 0 ? false : _ref4$suppressMillise, _ref4$includeOffset = _ref4.includeOffset, includeOffset = _ref4$includeOffset === void 0 ? true : _ref4$includeOffset, _ref4$extendedZone = _ref4.extendedZone, extendedZone = _ref4$extendedZone === void 0 ? false : _ref4$extendedZone;
        if (!this.isValid) return null;
        var ext = format === "extended";
        var c = $51c4c2d07d14dea7$var$_toISODate(this, ext);
        c += "T";
        c += $51c4c2d07d14dea7$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
        return c;
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format;
        if (!this.isValid) return null;
        return $51c4c2d07d14dea7$var$_toISODate(this, format === "extended");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */ ;
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $51c4c2d07d14dea7$var$toTechFormat(this, "kkkk-'W'WW-c");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$suppressMillise = _ref6.suppressMilliseconds, suppressMilliseconds = _ref6$suppressMillise === void 0 ? false : _ref6$suppressMillise, _ref6$suppressSeconds = _ref6.suppressSeconds, suppressSeconds = _ref6$suppressSeconds === void 0 ? false : _ref6$suppressSeconds, _ref6$includeOffset = _ref6.includeOffset, includeOffset = _ref6$includeOffset === void 0 ? true : _ref6$includeOffset, _ref6$includePrefix = _ref6.includePrefix, includePrefix = _ref6$includePrefix === void 0 ? false : _ref6$includePrefix, _ref6$extendedZone = _ref6.extendedZone, extendedZone = _ref6$extendedZone === void 0 ? false : _ref6$extendedZone, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format;
        if (!this.isValid) return null;
        var c = includePrefix ? "T" : "";
        return c + $51c4c2d07d14dea7$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    } /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */ ;
    _proto.toRFC2822 = function toRFC2822() {
        return $51c4c2d07d14dea7$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    } /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */ ;
    _proto.toHTTP = function toHTTP() {
        return $51c4c2d07d14dea7$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */ ;
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $51c4c2d07d14dea7$var$_toISODate(this, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQLTime = function toSQLTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includeZone = _ref7.includeZone, includeZone = _ref7$includeZone === void 0 ? false : _ref7$includeZone, _ref7$includeOffsetSp = _ref7.includeOffsetSpace, includeOffsetSpace = _ref7$includeOffsetSp === void 0 ? true : _ref7$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $51c4c2d07d14dea7$var$toTechFormat(this, fmt, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    } /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $51c4c2d07d14dea7$var$INVALID;
    } /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    } /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    } /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */ ;
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    } /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    } /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $51c4c2d07d14dea7$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    } /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    } /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */ ;
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $51c4c2d07d14dea7$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $51c4c2d07d14dea7$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $51c4c2d07d14dea7$var$maybeArray(unit).map($51c4c2d07d14dea7$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $51c4c2d07d14dea7$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    } /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ ;
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    } /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */ ;
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $51c4c2d07d14dea7$var$Interval.fromDateTimes(this, otherDateTime) : this;
    } /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(otherDateTime, unit) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit) <= inputMs && inputMs <= adjustedToZone.endOf(unit);
    } /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    } /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */ ;
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $51c4c2d07d14dea7$var$diffRelative(base, this.plus(padding), $51c4c2d07d14dea7$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    } /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */ ;
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $51c4c2d07d14dea7$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $51c4c2d07d14dea7$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    } /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */ ;
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $51c4c2d07d14dea7$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $51c4c2d07d14dea7$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    } /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */ ;
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $51c4c2d07d14dea7$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $51c4c2d07d14dea7$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    } /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */ ;
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $51c4c2d07d14dea7$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $51c4c2d07d14dea7$var$explainFromTokens(localeToUse, text, fmt);
    } /**
   * @deprecated use fromFormatExplain instead
   */ ;
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    } /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */ ;
    $51c4c2d07d14dea7$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $51c4c2d07d14dea7$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $51c4c2d07d14dea7$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $51c4c2d07d14dea7$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $51c4c2d07d14dea7$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $51c4c2d07d14dea7$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $51c4c2d07d14dea7$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $51c4c2d07d14dea7$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $51c4c2d07d14dea7$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $51c4c2d07d14dea7$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $51c4c2d07d14dea7$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $51c4c2d07d14dea7$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $51c4c2d07d14dea7$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $51c4c2d07d14dea7$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $51c4c2d07d14dea7$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $51c4c2d07d14dea7$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $51c4c2d07d14dea7$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $51c4c2d07d14dea7$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $51c4c2d07d14dea7$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $51c4c2d07d14dea7$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $51c4c2d07d14dea7$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $51c4c2d07d14dea7$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $51c4c2d07d14dea7$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $51c4c2d07d14dea7$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $51c4c2d07d14dea7$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $51c4c2d07d14dea7$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $51c4c2d07d14dea7$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $51c4c2d07d14dea7$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $51c4c2d07d14dea7$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $51c4c2d07d14dea7$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $51c4c2d07d14dea7$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $51c4c2d07d14dea7$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $51c4c2d07d14dea7$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $51c4c2d07d14dea7$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $51c4c2d07d14dea7$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}();
function $51c4c2d07d14dea7$var$friendlyDateTime(dateTimeish) {
    if ($51c4c2d07d14dea7$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $51c4c2d07d14dea7$var$isNumber(dateTimeish.valueOf())) return $51c4c2d07d14dea7$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $51c4c2d07d14dea7$var$DateTime.fromObject(dateTimeish);
    else throw new $51c4c2d07d14dea7$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $51c4c2d07d14dea7$var$VERSION = "3.4.3";
$51c4c2d07d14dea7$exports.DateTime = $51c4c2d07d14dea7$var$DateTime;
$51c4c2d07d14dea7$exports.Duration = $51c4c2d07d14dea7$var$Duration;
$51c4c2d07d14dea7$exports.FixedOffsetZone = $51c4c2d07d14dea7$var$FixedOffsetZone;
$51c4c2d07d14dea7$exports.IANAZone = $51c4c2d07d14dea7$var$IANAZone;
$51c4c2d07d14dea7$exports.Info = $51c4c2d07d14dea7$var$Info;
$51c4c2d07d14dea7$exports.Interval = $51c4c2d07d14dea7$var$Interval;
$51c4c2d07d14dea7$exports.InvalidZone = $51c4c2d07d14dea7$var$InvalidZone;
$51c4c2d07d14dea7$exports.Settings = $51c4c2d07d14dea7$var$Settings;
$51c4c2d07d14dea7$exports.SystemZone = $51c4c2d07d14dea7$var$SystemZone;
$51c4c2d07d14dea7$exports.VERSION = $51c4c2d07d14dea7$var$VERSION;
$51c4c2d07d14dea7$exports.Zone = $51c4c2d07d14dea7$var$Zone;


const $a9251390360fca28$var$formatTokenMap = {
    // Year
    y: {
        sectionType: "year",
        contentType: "digit",
        maxLength: 4
    },
    yy: "year",
    yyyy: {
        sectionType: "year",
        contentType: "digit",
        maxLength: 4
    },
    // Month
    L: {
        sectionType: "month",
        contentType: "digit",
        maxLength: 2
    },
    LL: "month",
    LLL: {
        sectionType: "month",
        contentType: "letter"
    },
    LLLL: {
        sectionType: "month",
        contentType: "letter"
    },
    M: {
        sectionType: "month",
        contentType: "digit",
        maxLength: 2
    },
    MM: "month",
    MMM: {
        sectionType: "month",
        contentType: "letter"
    },
    MMMM: {
        sectionType: "month",
        contentType: "letter"
    },
    // Day of the month
    d: {
        sectionType: "day",
        contentType: "digit",
        maxLength: 2
    },
    dd: "day",
    // Day of the week
    c: {
        sectionType: "weekDay",
        contentType: "digit",
        maxLength: 1
    },
    ccc: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    cccc: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    E: {
        sectionType: "weekDay",
        contentType: "digit",
        maxLength: 2
    },
    EEE: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    EEEE: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    // Meridiem
    a: "meridiem",
    // Hours
    H: {
        sectionType: "hours",
        contentType: "digit",
        maxLength: 2
    },
    HH: "hours",
    h: {
        sectionType: "hours",
        contentType: "digit",
        maxLength: 2
    },
    hh: "hours",
    // Minutes
    m: {
        sectionType: "minutes",
        contentType: "digit",
        maxLength: 2
    },
    mm: "minutes",
    // Seconds
    s: {
        sectionType: "seconds",
        contentType: "digit",
        maxLength: 2
    },
    ss: "seconds"
};
const $a9251390360fca28$var$defaultFormats = {
    year: "yyyy",
    month: "LLLL",
    monthShort: "MMM",
    dayOfMonth: "d",
    // Full day of the month format (i.e. 3rd) is not supported
    // Falling back to regular format
    dayOfMonthFull: "d",
    weekday: "cccc",
    weekdayShort: "ccccc",
    hours24h: "HH",
    hours12h: "hh",
    meridiem: "a",
    minutes: "mm",
    seconds: "ss",
    fullDate: "DD",
    keyboardDate: "D",
    shortDate: "MMM d",
    normalDate: "d MMMM",
    normalDateWithWeekday: "EEE, MMM d",
    fullTime: "t",
    fullTime12h: "hh:mm a",
    fullTime24h: "HH:mm",
    keyboardDateTime: "D t",
    keyboardDateTime12h: "D hh:mm a",
    keyboardDateTime24h: "D T"
};
class $a9251390360fca28$export$e130a45610e3b3b2 {
    constructor({ locale: locale, formats: formats } = {}){
        this.isMUIAdapter = true;
        this.isTimezoneCompatible = true;
        this.lib = "luxon";
        this.locale = void 0;
        this.formats = void 0;
        this.escapedCharacters = {
            start: "'",
            end: "'"
        };
        this.formatTokenMap = $a9251390360fca28$var$formatTokenMap;
        this.setLocaleToValue = (value)=>{
            const expectedLocale = this.getCurrentLocaleCode();
            if (expectedLocale === value.locale) return value;
            return value.setLocale(expectedLocale);
        };
        this.date = (value, timezone = "default")=>{
            if (value === null) return null;
            if (typeof value === "undefined") // @ts-ignore
            return (0, $51c4c2d07d14dea7$exports.DateTime).fromJSDate(new Date(), {
                locale: this.locale,
                zone: timezone
            });
            // @ts-ignore
            return (0, $51c4c2d07d14dea7$exports.DateTime).fromISO(value, {
                locale: this.locale,
                zone: timezone
            });
        };
        this.getInvalidDate = ()=>(0, $51c4c2d07d14dea7$exports.DateTime).fromJSDate(new Date("Invalid Date"));
        this.getTimezone = (value)=>{
            // When using the system zone, we want to return "system", not something like "Europe/Paris"
            if (value.zone.type === "system") return "system";
            return value.zoneName;
        };
        this.setTimezone = (value, timezone)=>{
            if (!value.zone.equals((0, $51c4c2d07d14dea7$exports.Info).normalizeZone(timezone))) return value.setZone(timezone);
            return value;
        };
        this.toJsDate = (value)=>{
            return value.toJSDate();
        };
        this.parse = (value, formatString)=>{
            if (value === "") return null;
            return (0, $51c4c2d07d14dea7$exports.DateTime).fromFormat(value, formatString, {
                locale: this.locale
            });
        };
        this.getCurrentLocaleCode = ()=>{
            return this.locale;
        };
        /* istanbul ignore next */ this.is12HourCycleInCurrentLocale = ()=>{
            if (typeof Intl === "undefined" || typeof Intl.DateTimeFormat === "undefined") return true; // Luxon defaults to en-US if Intl not found
            return Boolean(new Intl.DateTimeFormat(this.locale, {
                hour: "numeric"
            })?.resolvedOptions()?.hour12);
        };
        this.expandFormat = (format)=>{
            // Extract escaped section to avoid extending them
            const catchEscapedSectionsRegexp = /''|'(''|[^'])+('|$)|[^']*/g;
            // This RegExp tests if a string is only mad of supported tokens
            const validTokens = [
                ...Object.keys(this.formatTokenMap),
                "yyyyy"
            ];
            const isWordComposedOfTokens = new RegExp(`^(${validTokens.join("|")})+$`);
            // Extract words to test if they are a token or a word to escape.
            const catchWordsRegexp = /(?:^|[^a-z])([a-z]+)(?:[^a-z]|$)|([a-z]+)/gi;
            return format.match(catchEscapedSectionsRegexp).map((token)=>{
                const firstCharacter = token[0];
                if (firstCharacter === "'") return token;
                const expandedToken = (0, $51c4c2d07d14dea7$exports.DateTime).expandFormat(token, {
                    locale: this.locale
                });
                return expandedToken.replace(catchWordsRegexp, (substring, g1, g2)=>{
                    const word = g1 || g2; // words are either in group 1 or group 2
                    if (isWordComposedOfTokens.test(word)) return substring;
                    return `'${substring}'`;
                });
            }).join("")// The returned format can contain `yyyyy` which means year between 4 and 6 digits.
            // This value is supported by luxon parser but not luxon formatter.
            // To avoid conflicts, we replace it by 4 digits which is enough for most use-cases.
            .replace("yyyyy", "yyyy");
        };
        this.isValid = (value)=>{
            if (value === null) return false;
            return value.isValid;
        };
        this.format = (value, formatKey)=>{
            return this.formatByString(value, this.formats[formatKey]);
        };
        this.formatByString = (value, format)=>{
            return value.setLocale(this.locale).toFormat(format);
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.isEqual = (value, comparing)=>{
            if (value === null && comparing === null) return true;
            if (value === null || comparing === null) return false;
            return +value === +comparing;
        };
        this.isSameYear = (value, comparing)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            return value.hasSame(comparingInValueTimezone, "year");
        };
        this.isSameMonth = (value, comparing)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            return value.hasSame(comparingInValueTimezone, "month");
        };
        this.isSameDay = (value, comparing)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            return value.hasSame(comparingInValueTimezone, "day");
        };
        this.isSameHour = (value, comparing)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            return value.hasSame(comparingInValueTimezone, "hour");
        };
        this.isAfter = (value, comparing)=>{
            return value > comparing;
        };
        this.isAfterYear = (value, comparing)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            const diff = value.diff(this.endOfYear(comparingInValueTimezone), "years").toObject();
            return diff.years > 0;
        };
        this.isAfterDay = (value, comparing)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            const diff = value.diff(this.endOfDay(comparingInValueTimezone), "days").toObject();
            return diff.days > 0;
        };
        this.isBefore = (value, comparing)=>{
            return value < comparing;
        };
        this.isBeforeYear = (value, comparing)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            const diff = value.diff(this.startOfYear(comparingInValueTimezone), "years").toObject();
            return diff.years < 0;
        };
        this.isBeforeDay = (value, comparing)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            const diff = value.diff(this.startOfDay(comparingInValueTimezone), "days").toObject();
            return diff.days < 0;
        };
        this.isWithinRange = (value, [start, end])=>{
            return this.isEqual(value, start) || this.isEqual(value, end) || this.isAfter(value, start) && this.isBefore(value, end);
        };
        this.startOfYear = (value)=>{
            return value.startOf("year");
        };
        this.startOfMonth = (value)=>{
            return value.startOf("month");
        };
        this.startOfWeek = (value)=>{
            return this.setLocaleToValue(value).startOf("week", {
                useLocaleWeeks: true
            });
        };
        this.startOfDay = (value)=>{
            return value.startOf("day");
        };
        this.endOfYear = (value)=>{
            return value.endOf("year");
        };
        this.endOfMonth = (value)=>{
            return value.endOf("month");
        };
        this.endOfWeek = (value)=>{
            return this.setLocaleToValue(value).endOf("week", {
                useLocaleWeeks: true
            });
        };
        this.endOfDay = (value)=>{
            return value.endOf("day");
        };
        this.addYears = (value, amount)=>{
            return value.plus({
                years: amount
            });
        };
        this.addMonths = (value, amount)=>{
            return value.plus({
                months: amount
            });
        };
        this.addWeeks = (value, amount)=>{
            return value.plus({
                weeks: amount
            });
        };
        this.addDays = (value, amount)=>{
            return value.plus({
                days: amount
            });
        };
        this.addHours = (value, amount)=>{
            return value.plus({
                hours: amount
            });
        };
        this.addMinutes = (value, amount)=>{
            return value.plus({
                minutes: amount
            });
        };
        this.addSeconds = (value, amount)=>{
            return value.plus({
                seconds: amount
            });
        };
        this.getYear = (value)=>{
            return value.get("year");
        };
        this.getMonth = (value)=>{
            // See https://github.com/moment/luxon/blob/master/docs/moment.md#major-functional-differences
            return value.get("month") - 1;
        };
        this.getDate = (value)=>{
            return value.get("day");
        };
        this.getHours = (value)=>{
            return value.get("hour");
        };
        this.getMinutes = (value)=>{
            return value.get("minute");
        };
        this.getSeconds = (value)=>{
            return value.get("second");
        };
        this.getMilliseconds = (value)=>{
            return value.get("millisecond");
        };
        this.setYear = (value, year)=>{
            return value.set({
                year: year
            });
        };
        this.setMonth = (value, month)=>{
            return value.set({
                month: month + 1
            });
        };
        this.setDate = (value, date)=>{
            return value.set({
                day: date
            });
        };
        this.setHours = (value, hours)=>{
            return value.set({
                hour: hours
            });
        };
        this.setMinutes = (value, minutes)=>{
            return value.set({
                minute: minutes
            });
        };
        this.setSeconds = (value, seconds)=>{
            return value.set({
                second: seconds
            });
        };
        this.setMilliseconds = (value, milliseconds)=>{
            return value.set({
                millisecond: milliseconds
            });
        };
        this.getDaysInMonth = (value)=>{
            return value.daysInMonth;
        };
        this.getWeekArray = (value)=>{
            const firstDay = this.startOfWeek(this.startOfMonth(value));
            const lastDay = this.endOfWeek(this.endOfMonth(value));
            const { days: days } = lastDay.diff(firstDay, "days").toObject();
            const weeks = [];
            new Array(Math.round(days)).fill(0).map((_, i)=>i).map((day)=>firstDay.plus({
                    days: day
                })).forEach((v, i)=>{
                if (i === 0 || i % 7 === 0 && i > 6) {
                    weeks.push([
                        v
                    ]);
                    return;
                }
                weeks[weeks.length - 1].push(v);
            });
            return weeks;
        };
        this.getWeekNumber = (value)=>{
            /* istanbul ignore next */ return value.localWeekNumber ?? value.weekNumber;
        };
        this.getDayOfWeek = (value)=>{
            return value.weekday;
        };
        this.getYearRange = ([start, end])=>{
            const startDate = this.startOfYear(start);
            const endDate = this.endOfYear(end);
            const years = [];
            let current = startDate;
            while(this.isBefore(current, endDate)){
                years.push(current);
                current = this.addYears(current, 1);
            }
            return years;
        };
        this.locale = locale || "en-US";
        this.formats = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, $a9251390360fca28$var$defaultFormats, formats);
    }
}



var $3Py8h = parcelRequire("3Py8h");
/**
 * React Router DOM v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $1T1QG = parcelRequire("1T1QG");
var $27f1df944e3d0485$exports = {};
"use strict";
function $27f1df944e3d0485$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($27f1df944e3d0485$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$27f1df944e3d0485$var$checkDCE();

$27f1df944e3d0485$exports = (parcelRequire("bAW23"));


/**
 * @remix-run/router v1.15.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $ab1356c645cbcf88$var$_extends() {
    $ab1356c645cbcf88$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ab1356c645cbcf88$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $ab1356c645cbcf88$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($ab1356c645cbcf88$export$e19cd5f9376f8cee || ($ab1356c645cbcf88$export$e19cd5f9376f8cee = {}));
const $ab1356c645cbcf88$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $ab1356c645cbcf88$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $ab1356c645cbcf88$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $ab1356c645cbcf88$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $ab1356c645cbcf88$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $ab1356c645cbcf88$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $ab1356c645cbcf88$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $ab1356c645cbcf88$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $ab1356c645cbcf88$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $ab1356c645cbcf88$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $ab1356c645cbcf88$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $ab1356c645cbcf88$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $ab1356c645cbcf88$export$fe53371bee54353d(to);
    }
    return $ab1356c645cbcf88$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $ab1356c645cbcf88$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $ab1356c645cbcf88$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $ab1356c645cbcf88$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $ab1356c645cbcf88$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $ab1356c645cbcf88$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $ab1356c645cbcf88$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $ab1356c645cbcf88$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $ab1356c645cbcf88$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $ab1356c645cbcf88$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $ab1356c645cbcf88$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $ab1356c645cbcf88$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $ab1356c645cbcf88$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $ab1356c645cbcf88$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $ab1356c645cbcf88$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $ab1356c645cbcf88$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $ab1356c645cbcf88$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $ab1356c645cbcf88$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $ab1356c645cbcf88$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($ab1356c645cbcf88$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $ab1356c645cbcf88$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $ab1356c645cbcf88$export$e19cd5f9376f8cee.Push;
        let location = $ab1356c645cbcf88$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $ab1356c645cbcf88$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $ab1356c645cbcf88$export$e19cd5f9376f8cee.Replace;
        let location = $ab1356c645cbcf88$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $ab1356c645cbcf88$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $ab1356c645cbcf88$export$fe53371bee54353d(to);
        $ab1356c645cbcf88$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($ab1356c645cbcf88$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($ab1356c645cbcf88$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $ab1356c645cbcf88$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($ab1356c645cbcf88$var$ResultType || ($ab1356c645cbcf88$var$ResultType = {}));
const $ab1356c645cbcf88$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $ab1356c645cbcf88$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $ab1356c645cbcf88$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $ab1356c645cbcf88$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $ab1356c645cbcf88$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($ab1356c645cbcf88$var$isIndexRoute(route)) {
            let indexRoute = $ab1356c645cbcf88$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $ab1356c645cbcf88$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $ab1356c645cbcf88$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $ab1356c645cbcf88$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $ab1356c645cbcf88$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $ab1356c645cbcf88$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $ab1356c645cbcf88$var$flattenRoutes(routes);
    $ab1356c645cbcf88$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $ab1356c645cbcf88$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $ab1356c645cbcf88$var$safelyDecodeURI(pathname));
    return matches;
}
function $ab1356c645cbcf88$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $ab1356c645cbcf88$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $ab1356c645cbcf88$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $ab1356c645cbcf88$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $ab1356c645cbcf88$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $ab1356c645cbcf88$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $ab1356c645cbcf88$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $ab1356c645cbcf88$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $ab1356c645cbcf88$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $ab1356c645cbcf88$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $ab1356c645cbcf88$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $ab1356c645cbcf88$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $ab1356c645cbcf88$var$paramRe = /^:[\w-]+$/;
const $ab1356c645cbcf88$var$dynamicSegmentValue = 3;
const $ab1356c645cbcf88$var$indexRouteValue = 2;
const $ab1356c645cbcf88$var$emptySegmentValue = 1;
const $ab1356c645cbcf88$var$staticSegmentValue = 10;
const $ab1356c645cbcf88$var$splatPenalty = -2;
const $ab1356c645cbcf88$var$isSplat = (s)=>s === "*";
function $ab1356c645cbcf88$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($ab1356c645cbcf88$var$isSplat)) initialScore += $ab1356c645cbcf88$var$splatPenalty;
    if (index) initialScore += $ab1356c645cbcf88$var$indexRouteValue;
    return segments.filter((s)=>!$ab1356c645cbcf88$var$isSplat(s)).reduce((score, segment)=>score + ($ab1356c645cbcf88$var$paramRe.test(segment) ? $ab1356c645cbcf88$var$dynamicSegmentValue : segment === "" ? $ab1356c645cbcf88$var$emptySegmentValue : $ab1356c645cbcf88$var$staticSegmentValue), initialScore);
}
function $ab1356c645cbcf88$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $ab1356c645cbcf88$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $ab1356c645cbcf88$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $ab1356c645cbcf88$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $ab1356c645cbcf88$export$a5c6d149b50c1d86($ab1356c645cbcf88$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $ab1356c645cbcf88$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $ab1356c645cbcf88$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $ab1356c645cbcf88$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $ab1356c645cbcf88$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $ab1356c645cbcf88$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $ab1356c645cbcf88$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $ab1356c645cbcf88$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $ab1356c645cbcf88$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $ab1356c645cbcf88$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $ab1356c645cbcf88$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $ab1356c645cbcf88$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $ab1356c645cbcf88$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $ab1356c645cbcf88$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $ab1356c645cbcf88$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $ab1356c645cbcf88$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $ab1356c645cbcf88$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $ab1356c645cbcf88$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $ab1356c645cbcf88$var$normalizeSearch(search),
        hash: $ab1356c645cbcf88$var$normalizeHash(hash)
    };
}
function $ab1356c645cbcf88$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $ab1356c645cbcf88$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $ab1356c645cbcf88$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $ab1356c645cbcf88$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $ab1356c645cbcf88$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $ab1356c645cbcf88$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $ab1356c645cbcf88$export$8ccf933b0513f8d0(toArg);
    else {
        to = $ab1356c645cbcf88$var$_extends({}, toArg);
        $ab1356c645cbcf88$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $ab1356c645cbcf88$var$getInvalidPathError("?", "pathname", "search", to));
        $ab1356c645cbcf88$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $ab1356c645cbcf88$var$getInvalidPathError("#", "pathname", "hash", to));
        $ab1356c645cbcf88$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $ab1356c645cbcf88$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $ab1356c645cbcf88$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $ab1356c645cbcf88$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $ab1356c645cbcf88$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $ab1356c645cbcf88$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $ab1356c645cbcf88$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $ab1356c645cbcf88$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $ab1356c645cbcf88$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $ab1356c645cbcf88$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $ab1356c645cbcf88$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $ab1356c645cbcf88$export$42a99a7a4bc0e76a extends Error {
}
class $ab1356c645cbcf88$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $ab1356c645cbcf88$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $ab1356c645cbcf88$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $ab1356c645cbcf88$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $ab1356c645cbcf88$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $ab1356c645cbcf88$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $ab1356c645cbcf88$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $ab1356c645cbcf88$var$unwrapTrackedPromise(value) {
    if (!$ab1356c645cbcf88$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $ab1356c645cbcf88$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $ab1356c645cbcf88$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $ab1356c645cbcf88$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $ab1356c645cbcf88$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $ab1356c645cbcf88$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $ab1356c645cbcf88$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $ab1356c645cbcf88$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $ab1356c645cbcf88$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $ab1356c645cbcf88$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $ab1356c645cbcf88$var$validMutationMethods = new Set($ab1356c645cbcf88$var$validMutationMethodsArr);
const $ab1356c645cbcf88$var$validRequestMethodsArr = [
    "get",
    ...$ab1356c645cbcf88$var$validMutationMethodsArr
];
const $ab1356c645cbcf88$var$validRequestMethods = new Set($ab1356c645cbcf88$var$validRequestMethodsArr);
const $ab1356c645cbcf88$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $ab1356c645cbcf88$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $ab1356c645cbcf88$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $ab1356c645cbcf88$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $ab1356c645cbcf88$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $ab1356c645cbcf88$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $ab1356c645cbcf88$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $ab1356c645cbcf88$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $ab1356c645cbcf88$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $ab1356c645cbcf88$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $ab1356c645cbcf88$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $ab1356c645cbcf88$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $ab1356c645cbcf88$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $ab1356c645cbcf88$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $ab1356c645cbcf88$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $ab1356c645cbcf88$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $ab1356c645cbcf88$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $ab1356c645cbcf88$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $ab1356c645cbcf88$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $ab1356c645cbcf88$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $ab1356c645cbcf88$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$ab1356c645cbcf88$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($ab1356c645cbcf88$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $ab1356c645cbcf88$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $ab1356c645cbcf88$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $ab1356c645cbcf88$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $ab1356c645cbcf88$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $ab1356c645cbcf88$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $ab1356c645cbcf88$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $ab1356c645cbcf88$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $ab1356c645cbcf88$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $ab1356c645cbcf88$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($ab1356c645cbcf88$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $ab1356c645cbcf88$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $ab1356c645cbcf88$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $ab1356c645cbcf88$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $ab1356c645cbcf88$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $ab1356c645cbcf88$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $ab1356c645cbcf88$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $ab1356c645cbcf88$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $ab1356c645cbcf88$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $ab1356c645cbcf88$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $ab1356c645cbcf88$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $ab1356c645cbcf88$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $ab1356c645cbcf88$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $ab1356c645cbcf88$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $ab1356c645cbcf88$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $ab1356c645cbcf88$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $ab1356c645cbcf88$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $ab1356c645cbcf88$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$ab1356c645cbcf88$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $ab1356c645cbcf88$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $ab1356c645cbcf88$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $ab1356c645cbcf88$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $ab1356c645cbcf88$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $ab1356c645cbcf88$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $ab1356c645cbcf88$var$ResultType.error,
            error: $ab1356c645cbcf88$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $ab1356c645cbcf88$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($ab1356c645cbcf88$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($ab1356c645cbcf88$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $ab1356c645cbcf88$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $ab1356c645cbcf88$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($ab1356c645cbcf88$var$isDeferredResult(result)) throw $ab1356c645cbcf88$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $ab1356c645cbcf88$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $ab1356c645cbcf88$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $ab1356c645cbcf88$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $ab1356c645cbcf88$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since iot's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $ab1356c645cbcf88$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($ab1356c645cbcf88$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $ab1356c645cbcf88$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $ab1356c645cbcf88$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $ab1356c645cbcf88$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $ab1356c645cbcf88$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $ab1356c645cbcf88$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $ab1356c645cbcf88$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $ab1356c645cbcf88$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $ab1356c645cbcf88$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $ab1356c645cbcf88$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $ab1356c645cbcf88$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $ab1356c645cbcf88$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $ab1356c645cbcf88$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $ab1356c645cbcf88$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($ab1356c645cbcf88$var$isRedirectResult(actionResult) || $ab1356c645cbcf88$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $ab1356c645cbcf88$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($ab1356c645cbcf88$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $ab1356c645cbcf88$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $ab1356c645cbcf88$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($ab1356c645cbcf88$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($ab1356c645cbcf88$var$isDeferredResult(actionResult)) throw $ab1356c645cbcf88$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $ab1356c645cbcf88$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $ab1356c645cbcf88$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $ab1356c645cbcf88$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $ab1356c645cbcf88$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $ab1356c645cbcf88$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $ab1356c645cbcf88$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $ab1356c645cbcf88$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $ab1356c645cbcf88$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $ab1356c645cbcf88$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $ab1356c645cbcf88$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $ab1356c645cbcf88$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $ab1356c645cbcf88$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $ab1356c645cbcf88$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $ab1356c645cbcf88$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($ab1356c645cbcf88$var$isDeferredResult(result)) result = await $ab1356c645cbcf88$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $ab1356c645cbcf88$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($ab1356c645cbcf88$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $ab1356c645cbcf88$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($ab1356c645cbcf88$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $ab1356c645cbcf88$export$3e9cee6b33872309(!$ab1356c645cbcf88$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $ab1356c645cbcf88$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $ab1356c645cbcf88$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $ab1356c645cbcf88$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($ab1356c645cbcf88$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $ab1356c645cbcf88$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $ab1356c645cbcf88$export$e19cd5f9376f8cee.Replace : $ab1356c645cbcf88$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $ab1356c645cbcf88$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($ab1356c645cbcf88$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $ab1356c645cbcf88$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $ab1356c645cbcf88$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $ab1356c645cbcf88$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$ab1356c645cbcf88$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $ab1356c645cbcf88$var$callLoaderOrAction("loader", $ab1356c645cbcf88$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $ab1356c645cbcf88$var$ResultType.error,
                        error: $ab1356c645cbcf88$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $ab1356c645cbcf88$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $ab1356c645cbcf88$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $ab1356c645cbcf88$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $ab1356c645cbcf88$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $ab1356c645cbcf88$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $ab1356c645cbcf88$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $ab1356c645cbcf88$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $ab1356c645cbcf88$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $ab1356c645cbcf88$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $ab1356c645cbcf88$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $ab1356c645cbcf88$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $ab1356c645cbcf88$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $ab1356c645cbcf88$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$ab1356c645cbcf88$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $ab1356c645cbcf88$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $ab1356c645cbcf88$export$4d0306f8f6a4585b = Symbol("deferred");
function $ab1356c645cbcf88$export$3336b097a6fbc59a(routes, opts) {
    $ab1356c645cbcf88$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $ab1356c645cbcf88$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $ab1356c645cbcf88$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $ab1356c645cbcf88$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $ab1356c645cbcf88$var$createLocation("", $ab1356c645cbcf88$export$fe53371bee54353d(url), null, "default");
        let matches = $ab1356c645cbcf88$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$ab1356c645cbcf88$var$isValidMethod(method) && method !== "HEAD") {
            let error = $ab1356c645cbcf88$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $ab1356c645cbcf88$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $ab1356c645cbcf88$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $ab1356c645cbcf88$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($ab1356c645cbcf88$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $ab1356c645cbcf88$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $ab1356c645cbcf88$var$createLocation("", $ab1356c645cbcf88$export$fe53371bee54353d(url), null, "default");
        let matches = $ab1356c645cbcf88$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$ab1356c645cbcf88$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $ab1356c645cbcf88$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $ab1356c645cbcf88$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $ab1356c645cbcf88$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $ab1356c645cbcf88$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $ab1356c645cbcf88$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($ab1356c645cbcf88$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$ab1356c645cbcf88$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $ab1356c645cbcf88$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($ab1356c645cbcf88$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $ab1356c645cbcf88$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $ab1356c645cbcf88$var$isResponse(result) ? result : $ab1356c645cbcf88$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($ab1356c645cbcf88$var$isQueryRouteResponse(e)) {
                if (e.type === $ab1356c645cbcf88$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($ab1356c645cbcf88$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $ab1356c645cbcf88$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $ab1356c645cbcf88$var$ResultType.error,
                error: error
            };
        } else {
            result = await $ab1356c645cbcf88$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $ab1356c645cbcf88$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($ab1356c645cbcf88$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($ab1356c645cbcf88$var$isDeferredResult(result)) {
            let error = $ab1356c645cbcf88$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $ab1356c645cbcf88$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($ab1356c645cbcf88$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($ab1356c645cbcf88$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $ab1356c645cbcf88$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $ab1356c645cbcf88$var$_extends({}, context, {
                statusCode: $ab1356c645cbcf88$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $ab1356c645cbcf88$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $ab1356c645cbcf88$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $ab1356c645cbcf88$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $ab1356c645cbcf88$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $ab1356c645cbcf88$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$ab1356c645cbcf88$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $ab1356c645cbcf88$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $ab1356c645cbcf88$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $ab1356c645cbcf88$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $ab1356c645cbcf88$export$fec11da027c70692(routes, context, error) {
    let newContext = $ab1356c645cbcf88$var$_extends({}, context, {
        statusCode: $ab1356c645cbcf88$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $ab1356c645cbcf88$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $ab1356c645cbcf88$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $ab1356c645cbcf88$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $ab1356c645cbcf88$export$cae722b0cc860f13(to ? to : ".", $ab1356c645cbcf88$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $ab1356c645cbcf88$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$ab1356c645cbcf88$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $ab1356c645cbcf88$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $ab1356c645cbcf88$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $ab1356c645cbcf88$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$ab1356c645cbcf88$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$ab1356c645cbcf88$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $ab1356c645cbcf88$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $ab1356c645cbcf88$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $ab1356c645cbcf88$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$ab1356c645cbcf88$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$ab1356c645cbcf88$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $ab1356c645cbcf88$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $ab1356c645cbcf88$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $ab1356c645cbcf88$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $ab1356c645cbcf88$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $ab1356c645cbcf88$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($ab1356c645cbcf88$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $ab1356c645cbcf88$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $ab1356c645cbcf88$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $ab1356c645cbcf88$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $ab1356c645cbcf88$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $ab1356c645cbcf88$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $ab1356c645cbcf88$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($ab1356c645cbcf88$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $ab1356c645cbcf88$var$shouldRevalidateLoader(match, $ab1356c645cbcf88$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $ab1356c645cbcf88$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $ab1356c645cbcf88$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $ab1356c645cbcf88$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $ab1356c645cbcf88$var$shouldRevalidateLoader(fetcherMatch, $ab1356c645cbcf88$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $ab1356c645cbcf88$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $ab1356c645cbcf88$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $ab1356c645cbcf88$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $ab1356c645cbcf88$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $ab1356c645cbcf88$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $ab1356c645cbcf88$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$ab1356c645cbcf88$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $ab1356c645cbcf88$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $ab1356c645cbcf88$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $ab1356c645cbcf88$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $ab1356c645cbcf88$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $ab1356c645cbcf88$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $ab1356c645cbcf88$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $ab1356c645cbcf88$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $ab1356c645cbcf88$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $ab1356c645cbcf88$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($ab1356c645cbcf88$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($ab1356c645cbcf88$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $ab1356c645cbcf88$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$ab1356c645cbcf88$var$ABSOLUTE_URL_REGEX.test(location)) location = $ab1356c645cbcf88$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $ab1356c645cbcf88$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $ab1356c645cbcf88$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $ab1356c645cbcf88$var$ResultType.error ? $ab1356c645cbcf88$var$ResultType.error : $ab1356c645cbcf88$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $ab1356c645cbcf88$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $ab1356c645cbcf88$var$ResultType.error) return {
            type: resultType,
            error: new $ab1356c645cbcf88$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $ab1356c645cbcf88$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $ab1356c645cbcf88$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($ab1356c645cbcf88$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $ab1356c645cbcf88$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $ab1356c645cbcf88$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $ab1356c645cbcf88$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($ab1356c645cbcf88$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $ab1356c645cbcf88$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $ab1356c645cbcf88$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $ab1356c645cbcf88$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $ab1356c645cbcf88$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $ab1356c645cbcf88$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $ab1356c645cbcf88$export$3e9cee6b33872309(!$ab1356c645cbcf88$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($ab1356c645cbcf88$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $ab1356c645cbcf88$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $ab1356c645cbcf88$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($ab1356c645cbcf88$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $ab1356c645cbcf88$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $ab1356c645cbcf88$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $ab1356c645cbcf88$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($ab1356c645cbcf88$var$isErrorResult(result)) {
            let boundaryMatch = $ab1356c645cbcf88$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $ab1356c645cbcf88$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($ab1356c645cbcf88$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $ab1356c645cbcf88$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($ab1356c645cbcf88$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $ab1356c645cbcf88$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $ab1356c645cbcf88$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $ab1356c645cbcf88$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $ab1356c645cbcf88$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $ab1356c645cbcf88$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $ab1356c645cbcf88$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $ab1356c645cbcf88$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $ab1356c645cbcf88$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $ab1356c645cbcf88$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($ab1356c645cbcf88$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $ab1356c645cbcf88$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $ab1356c645cbcf88$export$8ccf933b0513f8d0(path) : path;
    return $ab1356c645cbcf88$export$fe53371bee54353d($ab1356c645cbcf88$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $ab1356c645cbcf88$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $ab1356c645cbcf88$var$isDeferredResult(result) {
    return result.type === $ab1356c645cbcf88$var$ResultType.deferred;
}
function $ab1356c645cbcf88$var$isErrorResult(result) {
    return result.type === $ab1356c645cbcf88$var$ResultType.error;
}
function $ab1356c645cbcf88$var$isRedirectResult(result) {
    return (result && result.type) === $ab1356c645cbcf88$var$ResultType.redirect;
}
function $ab1356c645cbcf88$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $ab1356c645cbcf88$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $ab1356c645cbcf88$var$isRedirectResponse(result) {
    if (!$ab1356c645cbcf88$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $ab1356c645cbcf88$var$isQueryRouteResponse(obj) {
    return obj && $ab1356c645cbcf88$var$isResponse(obj.response) && (obj.type === $ab1356c645cbcf88$var$ResultType.data || obj.type === $ab1356c645cbcf88$var$ResultType.error);
}
function $ab1356c645cbcf88$var$isValidMethod(method) {
    return $ab1356c645cbcf88$var$validRequestMethods.has(method.toLowerCase());
}
function $ab1356c645cbcf88$var$isMutationMethod(method) {
    return $ab1356c645cbcf88$var$validMutationMethods.has(method.toLowerCase());
}
async function $ab1356c645cbcf88$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$ab1356c645cbcf88$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($ab1356c645cbcf88$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $ab1356c645cbcf88$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $ab1356c645cbcf88$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $ab1356c645cbcf88$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $ab1356c645cbcf88$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $ab1356c645cbcf88$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $ab1356c645cbcf88$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $ab1356c645cbcf88$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $ab1356c645cbcf88$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $ab1356c645cbcf88$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $ab1356c645cbcf88$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $ab1356c645cbcf88$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $ab1356c645cbcf88$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $ab1356c645cbcf88$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $ab1356c645cbcf88$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $ab1356c645cbcf88$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $ab1356c645cbcf88$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $ab1356c645cbcf88$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $ab1356c645cbcf88$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($ab1356c645cbcf88$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $ab1356c645cbcf88$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($ab1356c645cbcf88$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $ab1356c645cbcf88$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $1T1QG = parcelRequire("1T1QG");

function $e0cff2801449e77d$var$_extends() {
    $e0cff2801449e77d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e0cff2801449e77d$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $e0cff2801449e77d$export$3add0d5dce533e2e = /*#__PURE__*/ $1T1QG.createContext(null);
const $e0cff2801449e77d$export$145dfa71566a64dc = /*#__PURE__*/ $1T1QG.createContext(null);
const $e0cff2801449e77d$var$AwaitContext = /*#__PURE__*/ $1T1QG.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $e0cff2801449e77d$export$26749e8557646306 = /*#__PURE__*/ $1T1QG.createContext(null);
const $e0cff2801449e77d$export$c7914228fb69b0f5 = /*#__PURE__*/ $1T1QG.createContext(null);
const $e0cff2801449e77d$export$9072aa6dd1f93057 = /*#__PURE__*/ $1T1QG.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $e0cff2801449e77d$var$RouteErrorContext = /*#__PURE__*/ $1T1QG.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $e0cff2801449e77d$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$e0cff2801449e77d$export$9c954a9d03d32f4a() && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $1T1QG.useContext($e0cff2801449e77d$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $e0cff2801449e77d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $ab1356c645cbcf88$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $e0cff2801449e77d$export$9c954a9d03d32f4a() {
    return $1T1QG.useContext($e0cff2801449e77d$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $e0cff2801449e77d$export$45d76561a5302f2b() {
    !$e0cff2801449e77d$export$9c954a9d03d32f4a() && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    return $1T1QG.useContext($e0cff2801449e77d$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $e0cff2801449e77d$export$1b3f31771c5d07c() {
    return $1T1QG.useContext($e0cff2801449e77d$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $e0cff2801449e77d$export$6c330e8992e8a295(pattern) {
    !$e0cff2801449e77d$export$9c954a9d03d32f4a() && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $e0cff2801449e77d$export$45d76561a5302f2b();
    return $1T1QG.useMemo(()=>(0, $ab1356c645cbcf88$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $e0cff2801449e77d$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $e0cff2801449e77d$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $1T1QG.useContext($e0cff2801449e77d$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $1T1QG.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $e0cff2801449e77d$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $1T1QG.useContext($e0cff2801449e77d$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $e0cff2801449e77d$var$useNavigateStable() : $e0cff2801449e77d$var$useNavigateUnstable();
}
function $e0cff2801449e77d$var$useNavigateUnstable() {
    !$e0cff2801449e77d$export$9c954a9d03d32f4a() && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    let dataRouterContext = $1T1QG.useContext($e0cff2801449e77d$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $1T1QG.useContext($e0cff2801449e77d$export$26749e8557646306);
    let { matches: matches } = $1T1QG.useContext($e0cff2801449e77d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $e0cff2801449e77d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $ab1356c645cbcf88$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $1T1QG.useRef(false);
    $e0cff2801449e77d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $1T1QG.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $ab1356c645cbcf88$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $ab1356c645cbcf88$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $e0cff2801449e77d$var$OutletContext = /*#__PURE__*/ $1T1QG.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $e0cff2801449e77d$export$4138103a3ae699cc() {
    return $1T1QG.useContext($e0cff2801449e77d$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $e0cff2801449e77d$export$a3be3530d8e40d0b(context) {
    let outlet = $1T1QG.useContext($e0cff2801449e77d$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $e0cff2801449e77d$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $1T1QG.useContext($e0cff2801449e77d$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $e0cff2801449e77d$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $1T1QG.useContext($e0cff2801449e77d$export$26749e8557646306);
    let { matches: matches } = $1T1QG.useContext($e0cff2801449e77d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $e0cff2801449e77d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $ab1356c645cbcf88$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $1T1QG.useMemo(()=>(0, $ab1356c645cbcf88$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $e0cff2801449e77d$export$5d3fca4a98652595(routes, locationArg) {
    return $e0cff2801449e77d$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $e0cff2801449e77d$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$e0cff2801449e77d$export$9c954a9d03d32f4a() && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $1T1QG.useContext($e0cff2801449e77d$export$26749e8557646306);
    let { matches: parentMatches } = $1T1QG.useContext($e0cff2801449e77d$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $e0cff2801449e77d$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $ab1356c645cbcf88$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $ab1356c645cbcf88$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $e0cff2801449e77d$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $ab1356c645cbcf88$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $ab1356c645cbcf88$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $e0cff2801449e77d$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $ab1356c645cbcf88$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $e0cff2801449e77d$var$DefaultErrorComponent() {
    let error = $e0cff2801449e77d$export$ed527bf60f6e05f2();
    let message = (0, $ab1356c645cbcf88$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $1T1QG.createElement($1T1QG.Fragment, null, /*#__PURE__*/ $1T1QG.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $1T1QG.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $1T1QG.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $e0cff2801449e77d$var$defaultErrorElement = /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$var$DefaultErrorComponent, null);
class $e0cff2801449e77d$var$RenderErrorBoundary extends $1T1QG.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $e0cff2801449e77d$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $1T1QG.useContext($e0cff2801449e77d$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $e0cff2801449e77d$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $e0cff2801449e77d$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $e0cff2801449e77d$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $1T1QG.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $e0cff2801449e77d$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($e0cff2801449e77d$var$DataRouterHook || {});
var $e0cff2801449e77d$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($e0cff2801449e77d$var$DataRouterStateHook || {});
function $e0cff2801449e77d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $e0cff2801449e77d$var$useDataRouterContext(hookName) {
    let ctx = $1T1QG.useContext($e0cff2801449e77d$export$3add0d5dce533e2e);
    !ctx && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    return ctx;
}
function $e0cff2801449e77d$var$useDataRouterState(hookName) {
    let state = $1T1QG.useContext($e0cff2801449e77d$export$145dfa71566a64dc);
    !state && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    return state;
}
function $e0cff2801449e77d$var$useRouteContext(hookName) {
    let route = $1T1QG.useContext($e0cff2801449e77d$export$9072aa6dd1f93057);
    !route && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $e0cff2801449e77d$var$useCurrentRouteId(hookName) {
    let route = $e0cff2801449e77d$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $e0cff2801449e77d$export$5fc8298006ad9e58() {
    return $e0cff2801449e77d$var$useCurrentRouteId($e0cff2801449e77d$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $e0cff2801449e77d$export$d0fd4b7106de2769() {
    let state = $e0cff2801449e77d$var$useDataRouterState($e0cff2801449e77d$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $e0cff2801449e77d$export$600dc272ed516c15() {
    let dataRouterContext = $e0cff2801449e77d$var$useDataRouterContext($e0cff2801449e77d$var$DataRouterHook.UseRevalidator);
    let state = $e0cff2801449e77d$var$useDataRouterState($e0cff2801449e77d$var$DataRouterStateHook.UseRevalidator);
    return $1T1QG.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $e0cff2801449e77d$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $e0cff2801449e77d$var$useDataRouterState($e0cff2801449e77d$var$DataRouterStateHook.UseMatches);
    return $1T1QG.useMemo(()=>matches.map((m)=>(0, $ab1356c645cbcf88$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $e0cff2801449e77d$export$1448a5050d252c4d() {
    let state = $e0cff2801449e77d$var$useDataRouterState($e0cff2801449e77d$var$DataRouterStateHook.UseLoaderData);
    let routeId = $e0cff2801449e77d$var$useCurrentRouteId($e0cff2801449e77d$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $e0cff2801449e77d$export$fd5d37484eab868d(routeId) {
    let state = $e0cff2801449e77d$var$useDataRouterState($e0cff2801449e77d$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $e0cff2801449e77d$export$fdc00f3f26066d5e() {
    let state = $e0cff2801449e77d$var$useDataRouterState($e0cff2801449e77d$var$DataRouterStateHook.UseActionData);
    let routeId = $e0cff2801449e77d$var$useCurrentRouteId($e0cff2801449e77d$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $e0cff2801449e77d$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $1T1QG.useContext($e0cff2801449e77d$var$RouteErrorContext);
    let state = $e0cff2801449e77d$var$useDataRouterState($e0cff2801449e77d$var$DataRouterStateHook.UseRouteError);
    let routeId = $e0cff2801449e77d$var$useCurrentRouteId($e0cff2801449e77d$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $e0cff2801449e77d$export$78a72ddb39bdd145() {
    let value = $1T1QG.useContext($e0cff2801449e77d$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $e0cff2801449e77d$export$17f53340677d5831() {
    let value = $1T1QG.useContext($e0cff2801449e77d$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $e0cff2801449e77d$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $e0cff2801449e77d$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $e0cff2801449e77d$var$useDataRouterContext($e0cff2801449e77d$var$DataRouterHook.UseBlocker);
    let state = $e0cff2801449e77d$var$useDataRouterState($e0cff2801449e77d$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $1T1QG.useState("");
    let blockerFunction = $1T1QG.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $e0cff2801449e77d$var$_extends({}, currentLocation, {
                pathname: (0, $ab1356c645cbcf88$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $e0cff2801449e77d$var$_extends({}, nextLocation, {
                pathname: (0, $ab1356c645cbcf88$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $1T1QG.useEffect(()=>{
        let key = String(++$e0cff2801449e77d$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $1T1QG.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $ab1356c645cbcf88$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $e0cff2801449e77d$var$useNavigateStable() {
    let { router: router } = $e0cff2801449e77d$var$useDataRouterContext($e0cff2801449e77d$var$DataRouterHook.UseNavigateStable);
    let id = $e0cff2801449e77d$var$useCurrentRouteId($e0cff2801449e77d$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $1T1QG.useRef(false);
    $e0cff2801449e77d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $1T1QG.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $e0cff2801449e77d$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $e0cff2801449e77d$var$alreadyWarned = {};
function $e0cff2801449e77d$var$warningOnce(key, cond, message) {
    if (!cond && !$e0cff2801449e77d$var$alreadyWarned[key]) $e0cff2801449e77d$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $e0cff2801449e77d$var$START_TRANSITION = "startTransition";
const $e0cff2801449e77d$var$startTransitionImpl = $1T1QG[$e0cff2801449e77d$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $e0cff2801449e77d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $1T1QG.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1T1QG.useCallback((newState)=>{
        if (v7_startTransition && $e0cff2801449e77d$var$startTransitionImpl) $e0cff2801449e77d$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $1T1QG.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $1T1QG.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $1T1QG.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $1T1QG.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $1T1QG.createElement($1T1QG.Fragment, null, /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $e0cff2801449e77d$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $e0cff2801449e77d$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $e0cff2801449e77d$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $1T1QG.useRef();
    if (historyRef.current == null) historyRef.current = (0, $ab1356c645cbcf88$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $1T1QG.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1T1QG.useCallback((newState)=>{
        v7_startTransition && $e0cff2801449e77d$var$startTransitionImpl ? $e0cff2801449e77d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1T1QG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $e0cff2801449e77d$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$e0cff2801449e77d$export$9c954a9d03d32f4a() && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $1T1QG.useContext($e0cff2801449e77d$export$26749e8557646306);
    let { matches: matches } = $1T1QG.useContext($e0cff2801449e77d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $e0cff2801449e77d$export$45d76561a5302f2b();
    let navigate = $e0cff2801449e77d$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $ab1356c645cbcf88$export$cae722b0cc860f13)(to, (0, $ab1356c645cbcf88$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $1T1QG.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $e0cff2801449e77d$export$910ae8079b2c2852(props) {
    return $e0cff2801449e77d$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $e0cff2801449e77d$export$e7b0ac011bb776c6(_props) {
    (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $e0cff2801449e77d$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $ab1356c645cbcf88$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$e0cff2801449e77d$export$9c954a9d03d32f4a() && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $1T1QG.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $e0cff2801449e77d$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $ab1356c645cbcf88$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $1T1QG.useMemo(()=>{
        let trailingPathname = (0, $ab1356c645cbcf88$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $e0cff2801449e77d$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $e0cff2801449e77d$export$5d3fca4a98652595($e0cff2801449e77d$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $e0cff2801449e77d$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$var$ResolveAwait, null, children));
}
var $e0cff2801449e77d$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($e0cff2801449e77d$var$AwaitRenderStatus || {});
const $e0cff2801449e77d$var$neverSettledPromise = new Promise(()=>{});
class $e0cff2801449e77d$var$AwaitErrorBoundary extends $1T1QG.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $e0cff2801449e77d$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $e0cff2801449e77d$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $e0cff2801449e77d$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $e0cff2801449e77d$var$AwaitRenderStatus.error : promise._data !== undefined ? $e0cff2801449e77d$var$AwaitRenderStatus.success : $e0cff2801449e77d$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $e0cff2801449e77d$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $e0cff2801449e77d$var$AwaitRenderStatus.error && promise._error instanceof (0, $ab1356c645cbcf88$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $e0cff2801449e77d$var$neverSettledPromise;
        if (status === $e0cff2801449e77d$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $e0cff2801449e77d$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $e0cff2801449e77d$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $1T1QG.createElement($e0cff2801449e77d$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $e0cff2801449e77d$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $e0cff2801449e77d$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $1T1QG.createElement($1T1QG.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $e0cff2801449e77d$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $1T1QG.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $1T1QG.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $1T1QG.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $e0cff2801449e77d$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $e0cff2801449e77d$export$e7b0ac011bb776c6) && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $e0cff2801449e77d$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $e0cff2801449e77d$export$daf73786167a7f72(matches) {
    return $e0cff2801449e77d$var$_renderMatches(matches);
}
function $e0cff2801449e77d$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $1T1QG.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $1T1QG.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $1T1QG.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $e0cff2801449e77d$export$f30f7e456d254e83(routes, opts) {
    return (0, $ab1356c645cbcf88$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $e0cff2801449e77d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $ab1356c645cbcf88$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $e0cff2801449e77d$export$52b333d321859367
    }).initialize();
}



function $efa9cbb50e224d6a$var$_extends() {
    $efa9cbb50e224d6a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $efa9cbb50e224d6a$var$_extends.apply(this, arguments);
}
function $efa9cbb50e224d6a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $efa9cbb50e224d6a$var$defaultMethod = "get";
const $efa9cbb50e224d6a$var$defaultEncType = "application/x-www-form-urlencoded";
function $efa9cbb50e224d6a$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $efa9cbb50e224d6a$var$isButtonElement(object) {
    return $efa9cbb50e224d6a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $efa9cbb50e224d6a$var$isFormElement(object) {
    return $efa9cbb50e224d6a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $efa9cbb50e224d6a$var$isInputElement(object) {
    return $efa9cbb50e224d6a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $efa9cbb50e224d6a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $efa9cbb50e224d6a$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$efa9cbb50e224d6a$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $efa9cbb50e224d6a$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $efa9cbb50e224d6a$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $efa9cbb50e224d6a$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $efa9cbb50e224d6a$var$_formDataSupportsSubmitter = null;
function $efa9cbb50e224d6a$var$isFormDataSubmitterSupported() {
    if ($efa9cbb50e224d6a$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $efa9cbb50e224d6a$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $efa9cbb50e224d6a$var$_formDataSupportsSubmitter = true;
    }
    return $efa9cbb50e224d6a$var$_formDataSupportsSubmitter;
}
const $efa9cbb50e224d6a$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $efa9cbb50e224d6a$var$getFormEncType(encType) {
    if (encType != null && !$efa9cbb50e224d6a$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $efa9cbb50e224d6a$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($efa9cbb50e224d6a$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $ab1356c645cbcf88$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $efa9cbb50e224d6a$var$defaultMethod;
        encType = $efa9cbb50e224d6a$var$getFormEncType(target.getAttribute("enctype")) || $efa9cbb50e224d6a$var$defaultEncType;
        formData = new FormData(target);
    } else if ($efa9cbb50e224d6a$var$isButtonElement(target) || $efa9cbb50e224d6a$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $ab1356c645cbcf88$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $efa9cbb50e224d6a$var$defaultMethod;
        encType = $efa9cbb50e224d6a$var$getFormEncType(target.getAttribute("formenctype")) || $efa9cbb50e224d6a$var$getFormEncType(form.getAttribute("enctype")) || $efa9cbb50e224d6a$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$efa9cbb50e224d6a$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($efa9cbb50e224d6a$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $efa9cbb50e224d6a$var$defaultMethod;
        action = null;
        encType = $efa9cbb50e224d6a$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $efa9cbb50e224d6a$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $efa9cbb50e224d6a$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $efa9cbb50e224d6a$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $efa9cbb50e224d6a$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $efa9cbb50e224d6a$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $efa9cbb50e224d6a$export$1f3f55432a00e06d(routes, opts) {
    return (0, $ab1356c645cbcf88$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $efa9cbb50e224d6a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $ab1356c645cbcf88$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $efa9cbb50e224d6a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $e0cff2801449e77d$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $efa9cbb50e224d6a$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $ab1356c645cbcf88$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $efa9cbb50e224d6a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $ab1356c645cbcf88$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $efa9cbb50e224d6a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $e0cff2801449e77d$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $efa9cbb50e224d6a$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $efa9cbb50e224d6a$var$_extends({}, state, {
        errors: $efa9cbb50e224d6a$var$deserializeErrors(state.errors)
    });
    return state;
}
function $efa9cbb50e224d6a$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $ab1356c645cbcf88$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $efa9cbb50e224d6a$export$7ad602f0e94e62d1 = /*#__PURE__*/ $1T1QG.createContext({
    isTransitioning: false
});
const $efa9cbb50e224d6a$export$148fd98d095596d4 = /*#__PURE__*/ $1T1QG.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $efa9cbb50e224d6a$var$START_TRANSITION = "startTransition";
const $efa9cbb50e224d6a$var$startTransitionImpl = $1T1QG[$efa9cbb50e224d6a$var$START_TRANSITION];
const $efa9cbb50e224d6a$var$FLUSH_SYNC = "flushSync";
const $efa9cbb50e224d6a$var$flushSyncImpl = $27f1df944e3d0485$exports[$efa9cbb50e224d6a$var$FLUSH_SYNC];
const $efa9cbb50e224d6a$var$USE_ID = "useId";
const $efa9cbb50e224d6a$var$useIdImpl = $1T1QG[$efa9cbb50e224d6a$var$USE_ID];
function $efa9cbb50e224d6a$var$startTransitionSafe(cb) {
    if ($efa9cbb50e224d6a$var$startTransitionImpl) $efa9cbb50e224d6a$var$startTransitionImpl(cb);
    else cb();
}
function $efa9cbb50e224d6a$var$flushSyncSafe(cb) {
    if ($efa9cbb50e224d6a$var$flushSyncImpl) $efa9cbb50e224d6a$var$flushSyncImpl(cb);
    else cb();
}
class $efa9cbb50e224d6a$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $efa9cbb50e224d6a$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $1T1QG.useState(router.state);
    let [pendingState, setPendingState] = $1T1QG.useState();
    let [vtContext, setVtContext] = $1T1QG.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $1T1QG.useState();
    let [transition, setTransition] = $1T1QG.useState();
    let [interruption, setInterruption] = $1T1QG.useState();
    let fetcherData = $1T1QG.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $1T1QG.useCallback((cb)=>{
        if (v7_startTransition) $efa9cbb50e224d6a$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $1T1QG.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $efa9cbb50e224d6a$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $efa9cbb50e224d6a$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $efa9cbb50e224d6a$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $efa9cbb50e224d6a$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $efa9cbb50e224d6a$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $1T1QG.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $1T1QG.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $efa9cbb50e224d6a$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $1T1QG.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $1T1QG.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $1T1QG.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $1T1QG.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $1T1QG.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $1T1QG.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $1T1QG.createElement($1T1QG.Fragment, null, /*#__PURE__*/ $1T1QG.createElement((0, $e0cff2801449e77d$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $1T1QG.createElement((0, $e0cff2801449e77d$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $1T1QG.createElement($efa9cbb50e224d6a$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $1T1QG.createElement($efa9cbb50e224d6a$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $1T1QG.createElement((0, $e0cff2801449e77d$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $1T1QG.createElement($efa9cbb50e224d6a$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $efa9cbb50e224d6a$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $e0cff2801449e77d$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $efa9cbb50e224d6a$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $1T1QG.useRef();
    if (historyRef.current == null) historyRef.current = (0, $ab1356c645cbcf88$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $1T1QG.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1T1QG.useCallback((newState)=>{
        v7_startTransition && $efa9cbb50e224d6a$var$startTransitionImpl ? $efa9cbb50e224d6a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1T1QG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $1T1QG.createElement((0, $e0cff2801449e77d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $efa9cbb50e224d6a$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $1T1QG.useRef();
    if (historyRef.current == null) historyRef.current = (0, $ab1356c645cbcf88$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $1T1QG.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1T1QG.useCallback((newState)=>{
        v7_startTransition && $efa9cbb50e224d6a$var$startTransitionImpl ? $efa9cbb50e224d6a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1T1QG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $1T1QG.createElement((0, $e0cff2801449e77d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $efa9cbb50e224d6a$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $1T1QG.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $1T1QG.useCallback((newState)=>{
        v7_startTransition && $efa9cbb50e224d6a$var$startTransitionImpl ? $efa9cbb50e224d6a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $1T1QG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $1T1QG.createElement((0, $e0cff2801449e77d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $efa9cbb50e224d6a$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $efa9cbb50e224d6a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $efa9cbb50e224d6a$export$a6c7ac8248d6e38a = /*#__PURE__*/ $1T1QG.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $efa9cbb50e224d6a$var$_objectWithoutPropertiesLoose(_ref7, $efa9cbb50e224d6a$var$_excluded);
    let { basename: basename } = $1T1QG.useContext((0, $e0cff2801449e77d$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $efa9cbb50e224d6a$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($efa9cbb50e224d6a$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $ab1356c645cbcf88$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $e0cff2801449e77d$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $efa9cbb50e224d6a$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $1T1QG.createElement("a", $efa9cbb50e224d6a$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $efa9cbb50e224d6a$export$b0d92dbee9b5b60d = /*#__PURE__*/ $1T1QG.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $efa9cbb50e224d6a$var$_objectWithoutPropertiesLoose(_ref8, $efa9cbb50e224d6a$var$_excluded2);
    let path = (0, $e0cff2801449e77d$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $e0cff2801449e77d$export$45d76561a5302f2b)();
    let routerState = $1T1QG.useContext((0, $e0cff2801449e77d$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $1T1QG.useContext((0, $e0cff2801449e77d$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $efa9cbb50e224d6a$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $ab1356c645cbcf88$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $1T1QG.createElement($efa9cbb50e224d6a$export$a6c7ac8248d6e38a, $efa9cbb50e224d6a$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $efa9cbb50e224d6a$export$a7fed597f4b8afd8 = /*#__PURE__*/ $1T1QG.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $efa9cbb50e224d6a$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $efa9cbb50e224d6a$var$_objectWithoutPropertiesLoose(_ref9, $efa9cbb50e224d6a$var$_excluded3);
    let submit = $efa9cbb50e224d6a$export$47c85c6e3a081d3();
    let formAction = $efa9cbb50e224d6a$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $1T1QG.createElement("form", $efa9cbb50e224d6a$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $efa9cbb50e224d6a$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $efa9cbb50e224d6a$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $efa9cbb50e224d6a$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($efa9cbb50e224d6a$var$DataRouterHook || ($efa9cbb50e224d6a$var$DataRouterHook = {}));
var $efa9cbb50e224d6a$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($efa9cbb50e224d6a$var$DataRouterStateHook || ($efa9cbb50e224d6a$var$DataRouterStateHook = {}));
// Internal hooks
function $efa9cbb50e224d6a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $efa9cbb50e224d6a$var$useDataRouterContext(hookName) {
    let ctx = $1T1QG.useContext((0, $e0cff2801449e77d$export$3add0d5dce533e2e));
    !ctx && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    return ctx;
}
function $efa9cbb50e224d6a$var$useDataRouterState(hookName) {
    let state = $1T1QG.useContext((0, $e0cff2801449e77d$export$145dfa71566a64dc));
    !state && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $efa9cbb50e224d6a$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $e0cff2801449e77d$export$9770f232ac06a008)();
    let location = (0, $e0cff2801449e77d$export$45d76561a5302f2b)();
    let path = (0, $e0cff2801449e77d$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $1T1QG.useCallback((event)=>{
        if ($efa9cbb50e224d6a$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $ab1356c645cbcf88$export$fe53371bee54353d)(location) === (0, $ab1356c645cbcf88$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $efa9cbb50e224d6a$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $1T1QG.useRef($efa9cbb50e224d6a$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $1T1QG.useRef(false);
    let location = (0, $e0cff2801449e77d$export$45d76561a5302f2b)();
    let searchParams = $1T1QG.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $efa9cbb50e224d6a$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $e0cff2801449e77d$export$9770f232ac06a008)();
    let setSearchParams = $1T1QG.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $efa9cbb50e224d6a$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $efa9cbb50e224d6a$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $efa9cbb50e224d6a$var$fetcherId = 0;
let $efa9cbb50e224d6a$var$getUniqueFetcherId = ()=>"__" + String(++$efa9cbb50e224d6a$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $efa9cbb50e224d6a$export$47c85c6e3a081d3() {
    let { router: router } = $efa9cbb50e224d6a$var$useDataRouterContext($efa9cbb50e224d6a$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $1T1QG.useContext((0, $e0cff2801449e77d$export$26749e8557646306));
    let currentRouteId = (0, $e0cff2801449e77d$export$5fc8298006ad9e58)();
    return $1T1QG.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $efa9cbb50e224d6a$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $efa9cbb50e224d6a$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $efa9cbb50e224d6a$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $efa9cbb50e224d6a$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $1T1QG.useContext((0, $e0cff2801449e77d$export$26749e8557646306));
    let routeContext = $1T1QG.useContext((0, $e0cff2801449e77d$export$9072aa6dd1f93057));
    !routeContext && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $efa9cbb50e224d6a$var$_extends({}, (0, $e0cff2801449e77d$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $e0cff2801449e77d$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $ab1356c645cbcf88$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $ab1356c645cbcf88$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $efa9cbb50e224d6a$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $efa9cbb50e224d6a$var$useDataRouterContext($efa9cbb50e224d6a$var$DataRouterHook.UseFetcher);
    let state = $efa9cbb50e224d6a$var$useDataRouterState($efa9cbb50e224d6a$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $1T1QG.useContext($efa9cbb50e224d6a$export$148fd98d095596d4);
    let route = $1T1QG.useContext((0, $e0cff2801449e77d$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    !route && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $efa9cbb50e224d6a$var$useIdImpl ? $efa9cbb50e224d6a$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $1T1QG.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($efa9cbb50e224d6a$var$getUniqueFetcherId());
    // Registration/cleanup
    $1T1QG.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $1T1QG.useCallback((href, opts)=>{
        !routeId && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $efa9cbb50e224d6a$export$47c85c6e3a081d3();
    let submit = $1T1QG.useCallback((target, opts)=>{
        submitImpl(target, $efa9cbb50e224d6a$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $1T1QG.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $1T1QG.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $1T1QG.createElement($efa9cbb50e224d6a$export$a7fed597f4b8afd8, $efa9cbb50e224d6a$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $ab1356c645cbcf88$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $1T1QG.useMemo(()=>$efa9cbb50e224d6a$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $efa9cbb50e224d6a$export$fa996778a3a31087() {
    let state = $efa9cbb50e224d6a$var$useDataRouterState($efa9cbb50e224d6a$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $efa9cbb50e224d6a$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $efa9cbb50e224d6a$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $efa9cbb50e224d6a$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $efa9cbb50e224d6a$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $efa9cbb50e224d6a$var$useDataRouterContext($efa9cbb50e224d6a$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $efa9cbb50e224d6a$var$useDataRouterState($efa9cbb50e224d6a$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $1T1QG.useContext((0, $e0cff2801449e77d$export$26749e8557646306));
    let location = (0, $e0cff2801449e77d$export$45d76561a5302f2b)();
    let matches = (0, $e0cff2801449e77d$export$2378eb7f5ff86053)();
    let navigation = (0, $e0cff2801449e77d$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $1T1QG.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $efa9cbb50e224d6a$var$usePageHide($1T1QG.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $efa9cbb50e224d6a$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $efa9cbb50e224d6a$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($efa9cbb50e224d6a$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $1T1QG.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $efa9cbb50e224d6a$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $efa9cbb50e224d6a$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $1T1QG.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($efa9cbb50e224d6a$var$_extends({}, location, {
                    pathname: (0, $ab1356c645cbcf88$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($efa9cbb50e224d6a$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $1T1QG.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $efa9cbb50e224d6a$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $1T1QG.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $efa9cbb50e224d6a$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $1T1QG.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $efa9cbb50e224d6a$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $e0cff2801449e77d$export$b273b3273281a049)(when);
    $1T1QG.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $1T1QG.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $efa9cbb50e224d6a$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $1T1QG.useContext($efa9cbb50e224d6a$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $ab1356c645cbcf88$export$3e9cee6b33872309)(false);
    let { basename: basename } = $efa9cbb50e224d6a$var$useDataRouterContext($efa9cbb50e224d6a$var$DataRouterHook.useViewTransitionState);
    let path = (0, $e0cff2801449e77d$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $ab1356c645cbcf88$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $ab1356c645cbcf88$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $ab1356c645cbcf88$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $ab1356c645cbcf88$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $3Py8h = parcelRequire("3Py8h");

var $3Py8h = parcelRequire("3Py8h");
var $8e16b6ae5b8512e9$exports = {};
"use strict";
Object.defineProperty($8e16b6ae5b8512e9$exports, "__esModule", {
    value: true
});
$8e16b6ae5b8512e9$exports.FormattedListParts = $8e16b6ae5b8512e9$exports.FormattedNumberParts = $8e16b6ae5b8512e9$exports.FormattedTimeParts = $8e16b6ae5b8512e9$exports.FormattedDateParts = $8e16b6ae5b8512e9$exports.FormattedDisplayName = $8e16b6ae5b8512e9$exports.FormattedList = $8e16b6ae5b8512e9$exports.FormattedNumber = $8e16b6ae5b8512e9$exports.FormattedTime = $8e16b6ae5b8512e9$exports.FormattedDate = $8e16b6ae5b8512e9$exports.defineMessage = $8e16b6ae5b8512e9$exports.defineMessages = $8e16b6ae5b8512e9$exports.ReactIntlError = $8e16b6ae5b8512e9$exports.ReactIntlErrorCode = $8e16b6ae5b8512e9$exports.MissingTranslationError = $8e16b6ae5b8512e9$exports.MessageFormatError = $8e16b6ae5b8512e9$exports.MissingDataError = $8e16b6ae5b8512e9$exports.InvalidConfigError = $8e16b6ae5b8512e9$exports.UnsupportedFormatterError = $8e16b6ae5b8512e9$exports.createIntlCache = $8e16b6ae5b8512e9$exports.useIntl = $8e16b6ae5b8512e9$exports.injectIntl = $8e16b6ae5b8512e9$exports.createIntl = $8e16b6ae5b8512e9$exports.RawIntlProvider = $8e16b6ae5b8512e9$exports.IntlProvider = $8e16b6ae5b8512e9$exports.IntlContext = $8e16b6ae5b8512e9$exports.FormattedRelativeTime = $8e16b6ae5b8512e9$exports.FormattedPlural = $8e16b6ae5b8512e9$exports.FormattedMessage = $8e16b6ae5b8512e9$exports.FormattedDateTimeRange = void 0;

var $aVicc = parcelRequire("aVicc");
var $2a818553d9dc4262$exports = {};
"use strict";
Object.defineProperty($2a818553d9dc4262$exports, "__esModule", {
    value: true
});
$2a818553d9dc4262$exports.createFormattedComponent = $2a818553d9dc4262$exports.createFormattedDateTimePartsComponent = $2a818553d9dc4262$exports.FormattedListParts = $2a818553d9dc4262$exports.FormattedNumberParts = void 0;

var $aVicc = parcelRequire("aVicc");

var $2a818553d9dc4262$var$React = $aVicc.__importStar((parcelRequire("1T1QG")));

var $2a818553d9dc4262$var$useIntl_1 = $aVicc.__importDefault((parcelRequire("cEK7I")));
var $2a818553d9dc4262$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($2a818553d9dc4262$var$DisplayName || ($2a818553d9dc4262$var$DisplayName = {}));
var $2a818553d9dc4262$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($2a818553d9dc4262$var$DisplayNameParts || ($2a818553d9dc4262$var$DisplayNameParts = {}));
var $2a818553d9dc4262$var$FormattedNumberParts = function(props) {
    var intl = (0, $2a818553d9dc4262$var$useIntl_1.default)();
    var value = props.value, children = props.children, formatProps = $aVicc.__rest(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$2a818553d9dc4262$exports.FormattedNumberParts = $2a818553d9dc4262$var$FormattedNumberParts;
$2a818553d9dc4262$exports.FormattedNumberParts.displayName = "FormattedNumberParts";
var $2a818553d9dc4262$var$FormattedListParts = function(props) {
    var intl = (0, $2a818553d9dc4262$var$useIntl_1.default)();
    var value = props.value, children = props.children, formatProps = $aVicc.__rest(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$2a818553d9dc4262$exports.FormattedListParts = $2a818553d9dc4262$var$FormattedListParts;
$2a818553d9dc4262$exports.FormattedNumberParts.displayName = "FormattedNumberParts";
function $2a818553d9dc4262$var$createFormattedDateTimePartsComponent(name) {
    var ComponentParts = function(props) {
        var intl = (0, $2a818553d9dc4262$var$useIntl_1.default)();
        var value = props.value, children = props.children, formatProps = $aVicc.__rest(props, [
            "value",
            "children"
        ]);
        var date = typeof value === "string" ? new Date(value || 0) : value;
        var formattedParts = name === "formatDate" ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $2a818553d9dc4262$var$DisplayNameParts[name];
    return ComponentParts;
}
$2a818553d9dc4262$exports.createFormattedDateTimePartsComponent = $2a818553d9dc4262$var$createFormattedDateTimePartsComponent;
function $2a818553d9dc4262$var$createFormattedComponent(name) {
    var Component = function(props) {
        var intl = (0, $2a818553d9dc4262$var$useIntl_1.default)();
        var value = props.value, children = props.children, formatProps = $aVicc.__rest(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === "function") return children(formattedValue);
        var Text = intl.textComponent || $2a818553d9dc4262$var$React.Fragment;
        return $2a818553d9dc4262$var$React.createElement(Text, null, formattedValue);
    };
    Component.displayName = $2a818553d9dc4262$var$DisplayName[name];
    return Component;
}
$2a818553d9dc4262$exports.createFormattedComponent = $2a818553d9dc4262$var$createFormattedComponent;



var $8e16b6ae5b8512e9$var$injectIntl_1 = $aVicc.__importStar((parcelRequire("9hkJK")));
$8e16b6ae5b8512e9$exports.injectIntl = $8e16b6ae5b8512e9$var$injectIntl_1.default;
Object.defineProperty($8e16b6ae5b8512e9$exports, "RawIntlProvider", {
    enumerable: true,
    get: function() {
        return $8e16b6ae5b8512e9$var$injectIntl_1.Provider;
    }
});
Object.defineProperty($8e16b6ae5b8512e9$exports, "IntlContext", {
    enumerable: true,
    get: function() {
        return $8e16b6ae5b8512e9$var$injectIntl_1.Context;
    }
});

var $8e16b6ae5b8512e9$var$useIntl_1 = $aVicc.__importDefault((parcelRequire("cEK7I")));
$8e16b6ae5b8512e9$exports.useIntl = $8e16b6ae5b8512e9$var$useIntl_1.default;

var $8e16b6ae5b8512e9$var$provider_1 = $aVicc.__importStar((parcelRequire("bl6fg")));
$8e16b6ae5b8512e9$exports.IntlProvider = $8e16b6ae5b8512e9$var$provider_1.default;
Object.defineProperty($8e16b6ae5b8512e9$exports, "createIntl", {
    enumerable: true,
    get: function() {
        return $8e16b6ae5b8512e9$var$provider_1.createIntl;
    }
});

var $8e16b6ae5b8512e9$var$relative_1 = $aVicc.__importDefault((parcelRequire("gDR78")));
$8e16b6ae5b8512e9$exports.FormattedRelativeTime = $8e16b6ae5b8512e9$var$relative_1.default;

var $8e16b6ae5b8512e9$var$plural_1 = $aVicc.__importDefault((parcelRequire("4sMkT")));
$8e16b6ae5b8512e9$exports.FormattedPlural = $8e16b6ae5b8512e9$var$plural_1.default;

var $8e16b6ae5b8512e9$var$message_1 = $aVicc.__importDefault((parcelRequire("9vfuB")));
$8e16b6ae5b8512e9$exports.FormattedMessage = $8e16b6ae5b8512e9$var$message_1.default;

var $8e16b6ae5b8512e9$var$dateTimeRange_1 = $aVicc.__importDefault((parcelRequire("60Prr")));
$8e16b6ae5b8512e9$exports.FormattedDateTimeRange = $8e16b6ae5b8512e9$var$dateTimeRange_1.default;

var $stxzp = parcelRequire("stxzp");
Object.defineProperty($8e16b6ae5b8512e9$exports, "createIntlCache", {
    enumerable: true,
    get: function() {
        return $stxzp.createIntlCache;
    }
});
Object.defineProperty($8e16b6ae5b8512e9$exports, "UnsupportedFormatterError", {
    enumerable: true,
    get: function() {
        return $stxzp.UnsupportedFormatterError;
    }
});
Object.defineProperty($8e16b6ae5b8512e9$exports, "InvalidConfigError", {
    enumerable: true,
    get: function() {
        return $stxzp.InvalidConfigError;
    }
});
Object.defineProperty($8e16b6ae5b8512e9$exports, "MissingDataError", {
    enumerable: true,
    get: function() {
        return $stxzp.MissingDataError;
    }
});
Object.defineProperty($8e16b6ae5b8512e9$exports, "MessageFormatError", {
    enumerable: true,
    get: function() {
        return $stxzp.MessageFormatError;
    }
});
Object.defineProperty($8e16b6ae5b8512e9$exports, "MissingTranslationError", {
    enumerable: true,
    get: function() {
        return $stxzp.MissingTranslationError;
    }
});
Object.defineProperty($8e16b6ae5b8512e9$exports, "ReactIntlErrorCode", {
    enumerable: true,
    get: function() {
        return $stxzp.IntlErrorCode;
    }
});
Object.defineProperty($8e16b6ae5b8512e9$exports, "ReactIntlError", {
    enumerable: true,
    get: function() {
        return $stxzp.IntlError;
    }
});
function $8e16b6ae5b8512e9$var$defineMessages(msgs) {
    return msgs;
}
$8e16b6ae5b8512e9$exports.defineMessages = $8e16b6ae5b8512e9$var$defineMessages;
function $8e16b6ae5b8512e9$var$defineMessage(msg) {
    return msg;
}
$8e16b6ae5b8512e9$exports.defineMessage = $8e16b6ae5b8512e9$var$defineMessage;
// IMPORTANT: Explicit here to prevent api-extractor from outputing `import('./src/types').CustomFormatConfig`
$8e16b6ae5b8512e9$exports.FormattedDate = (0, $2a818553d9dc4262$exports.createFormattedComponent)("formatDate");
$8e16b6ae5b8512e9$exports.FormattedTime = (0, $2a818553d9dc4262$exports.createFormattedComponent)("formatTime");
$8e16b6ae5b8512e9$exports.FormattedNumber = (0, $2a818553d9dc4262$exports.createFormattedComponent)("formatNumber");
$8e16b6ae5b8512e9$exports.FormattedList = (0, $2a818553d9dc4262$exports.createFormattedComponent)("formatList");
$8e16b6ae5b8512e9$exports.FormattedDisplayName = (0, $2a818553d9dc4262$exports.createFormattedComponent)("formatDisplayName");
$8e16b6ae5b8512e9$exports.FormattedDateParts = (0, $2a818553d9dc4262$exports.createFormattedDateTimePartsComponent)("formatDate");
$8e16b6ae5b8512e9$exports.FormattedTimeParts = (0, $2a818553d9dc4262$exports.createFormattedDateTimePartsComponent)("formatTime");

Object.defineProperty($8e16b6ae5b8512e9$exports, "FormattedNumberParts", {
    enumerable: true,
    get: function() {
        return $2a818553d9dc4262$exports.FormattedNumberParts;
    }
});
Object.defineProperty($8e16b6ae5b8512e9$exports, "FormattedListParts", {
    enumerable: true,
    get: function() {
        return $2a818553d9dc4262$exports.FormattedListParts;
    }
});



var $npagc = parcelRequire("npagc");
const $a62210b286c7b014$export$b9fbdb7fc0d3e1c0 = ({ labelText: labelText, value: value, color: color })=>{
    const ColoredValue = (0, $npagc.default)("span")(({ theme: theme })=>`
    font-weight: bold;
    ${color === "GREEN" ? `color: ${theme.palette.success.main};` : ""}
    ${color === "RED" ? `color: ${theme.palette.error.main};` : ""}
  `);
    const Item = (0, $npagc.default)("span")`
    display: block;
    margin: 0;
  `;
    const Value = (0, $npagc.default)("span")`
    font-weight: bold;
  `;
    const StyledLabel = (0, $npagc.default)("span")`
    margin-right: 0.3rem;
  `;
    return /*#__PURE__*/ (0, $3Py8h.jsxs)(Item, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)(StyledLabel, {
                children: labelText
            }),
            color ? /*#__PURE__*/ (0, $3Py8h.jsx)(ColoredValue, {
                children: value
            }) : /*#__PURE__*/ (0, $3Py8h.jsx)(Value, {
                children: value
            })
        ]
    });
};
const $a62210b286c7b014$export$5fc72c219969b0e6 = ({ amount: amount, activeRights: activeRights })=>{
    const availableRights = activeRights;
    const percentage = availableRights > 0 && amount > 0 ? Math.round(availableRights / amount * 100) : 0;
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)($a62210b286c7b014$export$b9fbdb7fc0d3e1c0, {
                labelText: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "allocatedRights.rightsGranted"
                }),
                value: amount
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)($a62210b286c7b014$export$b9fbdb7fc0d3e1c0, {
                labelText: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "allocatedRights.rightsShared"
                }),
                value: `${availableRights > 0 ? availableRights : 0} (${percentage} %)`,
                color: percentage > 100 ? "RED" : undefined
            })
        ]
    });
};
const $a62210b286c7b014$export$4421fe64f84f2e51 = ({ offering: offering })=>{
    if (offering.type === "WHITELIST") return /*#__PURE__*/ (0, $3Py8h.jsx)($a62210b286c7b014$export$b9fbdb7fc0d3e1c0, {
        labelText: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
            id: "page.place.offeringsTab.table.catalogue.amount"
        }),
        value: offering.summary.activeRights
    });
    if (offering.ignoreAmountForCatalogue) {
        const { activeRights: activeRights, cataloguesTotalAmount: cataloguesTotalAmount } = offering.summary;
        const availableRights = cataloguesTotalAmount - activeRights;
        const percentage = availableRights > 0 && cataloguesTotalAmount > 0 ? Math.round(availableRights / cataloguesTotalAmount * 100) : 0;
        const valueText = `${activeRights} / ${cataloguesTotalAmount}  (${100 - percentage} %)`;
        return /*#__PURE__*/ (0, $3Py8h.jsx)($a62210b286c7b014$export$b9fbdb7fc0d3e1c0, {
            labelText: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "allocatedRights.rightsGranted"
            }),
            value: valueText
        });
    }
    const amount = offering.ignoreAmountForCatalogue ? offering.summary.cataloguesTotalAmount : offering.amount;
    const activeRights = offering.ignoreAmountForCatalogue ? offering.summary.activeRights : offering.summary.cataloguesTotalAmount;
    const availableRights = amount - activeRights;
    const percentage = availableRights > 0 && amount > 0 ? Math.round(availableRights / amount * 100) : 0;
    const greenText = percentage && percentage <= 100;
    const redText = availableRights <= 0;
    const availableText = `${availableRights > 0 ? availableRights : 0} (${percentage} %)`;
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)($a62210b286c7b014$export$b9fbdb7fc0d3e1c0, {
                labelText: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "allocatedRights.rightsTotal"
                }),
                value: amount
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)($a62210b286c7b014$export$b9fbdb7fc0d3e1c0, {
                labelText: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "allocatedRights.available"
                }),
                value: availableText,
                color: greenText || redText ? greenText ? "GREEN" : "RED" : undefined
            })
        ]
    });
};



var $3Py8h = parcelRequire("3Py8h");
const $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc = 300000;
const $ec0c9d75a0d3a81a$export$136d5c9516c6d4cd = "getAuthSession";
const $ec0c9d75a0d3a81a$export$93e1682d8eaccc31 = "getCataloguesByRef";
const $ec0c9d75a0d3a81a$export$5ff0e82f48d2f8dc = "getCatalogues";
const $ec0c9d75a0d3a81a$export$7cf5b9f73b9b2f2d = "getCataloguesByOffering";
const $ec0c9d75a0d3a81a$export$90904af181961b2 = "getCataloguesForLogin";
const $ec0c9d75a0d3a81a$export$e94a35ab41f6d829 = "getCataloguesActiveRights";
const $ec0c9d75a0d3a81a$export$6efe1800fcda6819 = "getCustomers";
const $ec0c9d75a0d3a81a$export$b3c26f5832e8795f = "getCustomerByRef";
const $ec0c9d75a0d3a81a$export$248423ad5d5be84a = "getIndividuals";
const $ec0c9d75a0d3a81a$export$9f074a658d5580d = "getIndividualsByEmail";
const $ec0c9d75a0d3a81a$export$96f07f442214aab = "getAdminInvitationsById";
const $ec0c9d75a0d3a81a$export$7a161aff508d2cb1 = "getLandlordInvitationsById";
const $ec0c9d75a0d3a81a$export$415ddc16ccdc9af1 = "getTenantInvitationsById";
const $ec0c9d75a0d3a81a$export$a10de6d4556ab62e = "getUserInvitations";
const $ec0c9d75a0d3a81a$export$a8e0fd0e2c725bd = "getLandlordsForLogin";
const $ec0c9d75a0d3a81a$export$70a73d059c6beff0 = "getOfferingsByPlace";
const $ec0c9d75a0d3a81a$export$79b5a04d4c49a4e2 = "getOfferingsById";
const $ec0c9d75a0d3a81a$export$d6da98a467d609dc = "getPlaces";
const $ec0c9d75a0d3a81a$export$823cd27a3f5f229e = "getPlaceByRef";
const $ec0c9d75a0d3a81a$export$9e8d1e7efde0f0d3 = "getPlacesForLogin";
const $ec0c9d75a0d3a81a$export$995d68b6ebb26447 = "getPlacesByCustomer";
const $ec0c9d75a0d3a81a$export$475c1d76a7297be4 = "getRightHolderByRef";
const $ec0c9d75a0d3a81a$export$d1676135628eec72 = "getRightByRef";
const $ec0c9d75a0d3a81a$export$6d14da40fa4f1ffe = "getAdminUsersByRef";
const $ec0c9d75a0d3a81a$export$9eb9aa3283b45cff = "getOfferingRightHolders";
const $ec0c9d75a0d3a81a$export$9512f33c9b8e71c5 = "moovyOfferingRightHoldersPaging";
const $ec0c9d75a0d3a81a$export$209a8ef612aeedd2 = "moovyOfferingRightHoldersSorting";





var $3Py8h = parcelRequire("3Py8h");

var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");

var $aVXbR = parcelRequire("aVXbR");

var $7n0B5 = parcelRequire("7n0B5");

var $lVN5Q = parcelRequire("lVN5Q");
var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $3MwXn = parcelRequire("3MwXn");

var $h0eTu = parcelRequire("h0eTu");
const $a5c864e19e03ba63$var$_excluded = [
    "sx"
];
const $a5c864e19e03ba63$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $h0eTu.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $a5c864e19e03ba63$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $iXdVf.default)(props, $a5c864e19e03ba63$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $a5c864e19e03ba63$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $3MwXn.isPlainObject)(result)) return systemProps;
        return (0, $ajTRS.default)({}, systemProps, result);
    };
    else finalSx = (0, $ajTRS.default)({}, systemProps, inSx);
    return (0, $ajTRS.default)({}, otherProps, {
        sx: finalSx
    });
}



var $5N3fo = parcelRequire("5N3fo");

var $3Py8h = parcelRequire("3Py8h");
"use client";
const $06ef5ada97e86660$var$_excluded = [
    "className",
    "component"
];
function $06ef5ada97e86660$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $7n0B5.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $lVN5Q.default));
    const Box = /*#__PURE__*/ $1T1QG.forwardRef(function Box(inProps, ref) {
        const theme = (0, $5N3fo.default)(defaultTheme);
        const _extendSxProp = (0, $a5c864e19e03ba63$export$2e2bcd8739ae039)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $iXdVf.default)(_extendSxProp, $06ef5ada97e86660$var$_excluded);
        return /*#__PURE__*/ (0, $3Py8h.jsx)(BoxRoot, (0, $ajTRS.default)({
            as: component,
            ref: ref,
            className: (0, $aVXbR.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $cZKRr = parcelRequire("cZKRr");

var $9jP1l = parcelRequire("9jP1l");

var $557GP = parcelRequire("557GP");

var $dfswM = parcelRequire("dfswM");
const $c0fd8eb3945fc5e2$var$boxClasses = (0, $dfswM.default)("MuiBox", [
    "root"
]);
var $c0fd8eb3945fc5e2$export$2e2bcd8739ae039 = $c0fd8eb3945fc5e2$var$boxClasses;


"use client";
const $4edd6b1e774baeef$var$defaultTheme = (0, $9jP1l.default)();
const $4edd6b1e774baeef$var$Box = (0, $06ef5ada97e86660$export$2e2bcd8739ae039)({
    themeId: (0, $557GP.default),
    defaultTheme: $4edd6b1e774baeef$var$defaultTheme,
    defaultClassName: (0, $c0fd8eb3945fc5e2$export$2e2bcd8739ae039).root,
    generateClassName: (0, $cZKRr.default).generate
});
var $4edd6b1e774baeef$export$2e2bcd8739ae039 = $4edd6b1e774baeef$var$Box;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $leuQP = parcelRequire("leuQP");

var $iV85C = parcelRequire("iV85C");


var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");
parcelRequire("1T1QG");

var $5N3fo = parcelRequire("5N3fo");

var $4Ydi5 = parcelRequire("4Ydi5");

var $557GP = parcelRequire("557GP");
"use client";
function $b326beddb66cbd82$export$2e2bcd8739ae039() {
    const theme = (0, $5N3fo.default)((0, $4Ydi5.default));
    return theme[0, $557GP.default] || theme;
}



var $1T1QG = parcelRequire("1T1QG");
"use client";
/**
 * @ignore - internal component.
 */ const $a92a7f09e60f9db5$var$GridContext = /*#__PURE__*/ $1T1QG.createContext();
var $a92a7f09e60f9db5$export$2e2bcd8739ae039 = $a92a7f09e60f9db5$var$GridContext;



var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $81b073b394dfb423$export$9973ac5fd0181f33(slot) {
    return (0, $iNQht.default)("MuiGrid", slot);
}
const $81b073b394dfb423$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $81b073b394dfb423$var$DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const $81b073b394dfb423$var$WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const $81b073b394dfb423$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $81b073b394dfb423$var$gridClasses = (0, $dfswM.default)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    // spacings
    ...$81b073b394dfb423$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$81b073b394dfb423$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$81b073b394dfb423$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$81b073b394dfb423$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$81b073b394dfb423$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$81b073b394dfb423$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$81b073b394dfb423$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$81b073b394dfb423$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $81b073b394dfb423$export$2e2bcd8739ae039 = $81b073b394dfb423$var$gridClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $f39a5c039f44d345$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $f39a5c039f44d345$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function $f39a5c039f44d345$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, $leuQP.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${$f39a5c039f44d345$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $ajTRS.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $f39a5c039f44d345$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $leuQP.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $leuQP.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, $81b073b394dfb423$export$2e2bcd8739ae039).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $f39a5c039f44d345$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = "";
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== "") return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $f39a5c039f44d345$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $leuQP.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === "object") zeroValueBreakpointKeys = $f39a5c039f44d345$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $leuQP.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${$f39a5c039f44d345$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $81b073b394dfb423$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $f39a5c039f44d345$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $81b073b394dfb423$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $f39a5c039f44d345$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $leuQP.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === "object") zeroValueBreakpointKeys = $f39a5c039f44d345$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $leuQP.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${$f39a5c039f44d345$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$f39a5c039f44d345$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $81b073b394dfb423$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $f39a5c039f44d345$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: "100%",
                marginLeft: 0,
                [`& > .${(0, $81b073b394dfb423$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $f39a5c039f44d345$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $f39a5c039f44d345$var$GridRoot = (0, $npagc.default)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $f39a5c039f44d345$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), $f39a5c039f44d345$export$71d4225eeb1bc13e, $f39a5c039f44d345$export$380604d7c79f9e8f, $f39a5c039f44d345$export$4315fba5128fb4a1, $f39a5c039f44d345$export$ca2a698f6020fda);
function $f39a5c039f44d345$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $f39a5c039f44d345$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $f39a5c039f44d345$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...spacingClasses,
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $iV85C.default)(slots, (0, $81b073b394dfb423$export$9973ac5fd0181f33), classes);
};
const $f39a5c039f44d345$var$Grid = /*#__PURE__*/ $1T1QG.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $gADeF.default)({
        props: inProps,
        name: "MuiGrid"
    });
    const { breakpoints: breakpoints } = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const props = (0, $a5c864e19e03ba63$export$2e2bcd8739ae039)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = "div", container: container = false, direction: direction = "row", item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = "wrap", zeroMinWidth: zeroMinWidth = false } = props, other = (0, $iXdVf.default)(props, $f39a5c039f44d345$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $1T1QG.useContext((0, $a92a7f09e60f9db5$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $ajTRS.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $ajTRS.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $f39a5c039f44d345$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a92a7f09e60f9db5$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($f39a5c039f44d345$var$GridRoot, (0, $ajTRS.default)({
            ownerState: ownerState,
            className: (0, $aVXbR.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $f39a5c039f44d345$export$2e2bcd8739ae039 = $f39a5c039f44d345$var$Grid;


var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");


var $gADeF = parcelRequire("gADeF");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $332e8470e2bc8a1d$export$427f1c1e2e839f85(slot) {
    return (0, $iNQht.default)("MuiPagination", slot);
}
const $332e8470e2bc8a1d$var$paginationClasses = (0, $dfswM.default)("MuiPagination", [
    "root",
    "ul",
    "outlined",
    "text"
]);
var $332e8470e2bc8a1d$export$2e2bcd8739ae039 = $332e8470e2bc8a1d$var$paginationClasses;



var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");
"use client";
function $328d428125b56996$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $1T1QG.useRef(controlled !== undefined);
    const [valueState, setValue] = $1T1QG.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $1T1QG.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


"use client";
const $24de3a033d1a4e7e$var$_excluded = [
    "boundaryCount",
    "componentName",
    "count",
    "defaultPage",
    "disabled",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "showFirstButton",
    "showLastButton",
    "siblingCount"
];
function $24de3a033d1a4e7e$export$2e2bcd8739ae039(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount: boundaryCount = 1, componentName: componentName = "usePagination", count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1 } = props, other = (0, $iXdVf.default)(props, $24de3a033d1a4e7e$var$_excluded);
    const [page, setPageState] = (0, $328d428125b56996$export$2e2bcd8739ae039)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: "page"
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length: length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    endPages.length > 0 ? endPages[0] - 2 : count - 1);
    // Basic list of items to render
    // e.g. itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            "first"
        ] : [],
        ...hidePrevButton ? [] : [
            "previous"
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            "start-ellipsis"
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            "end-ellipsis"
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            "next"
        ],
        ...showLastButton ? [
            "last"
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case "first":
                return 1;
            case "previous":
                return page - 1;
            case "next":
                return page + 1;
            case "last":
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === "number" ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: "page",
            page: item,
            selected: item === page,
            disabled: disabled,
            "aria-current": item === page ? "true" : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || item.indexOf("ellipsis") === -1 && (item === "next" || item === "last" ? page >= count : page <= 1)
        };
    });
    return (0, $ajTRS.default)({
        items: items
    }, other);
}



var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $7Etkp = parcelRequire("7Etkp");

var $gADeF = parcelRequire("gADeF");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $e436e4f3f86fe0d0$export$e4ce0a775adf2f74(slot) {
    return (0, $iNQht.default)("MuiPaginationItem", slot);
}
const $e436e4f3f86fe0d0$var$paginationItemClasses = (0, $dfswM.default)("MuiPaginationItem", [
    "root",
    "page",
    "sizeSmall",
    "sizeLarge",
    "text",
    "textPrimary",
    "textSecondary",
    "outlined",
    "outlinedPrimary",
    "outlinedSecondary",
    "rounded",
    "ellipsis",
    "firstLast",
    "previousNext",
    "focusVisible",
    "disabled",
    "selected",
    "icon",
    "colorPrimary",
    "colorSecondary"
]);
var $e436e4f3f86fe0d0$export$2e2bcd8739ae039 = $e436e4f3f86fe0d0$var$paginationItemClasses;




var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $1T1QG = parcelRequire("1T1QG");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $2c32707bf1e7228d$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $d2fee4866c2743fb$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $1T1QG.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $2c32707bf1e7228d$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


"use client";
var $147755cb84aa0994$export$2e2bcd8739ae039 = (0, $d2fee4866c2743fb$export$2e2bcd8739ae039);



var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $ac1861e6d86aa648$var$useEnhancedEffect = typeof window !== "undefined" ? $1T1QG.useLayoutEffect : $1T1QG.useEffect;
var $ac1861e6d86aa648$export$2e2bcd8739ae039 = $ac1861e6d86aa648$var$useEnhancedEffect;


"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $f10dd87bccb0014d$var$useEventCallback(fn) {
    const ref = $1T1QG.useRef(fn);
    (0, $ac1861e6d86aa648$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $1T1QG.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $f10dd87bccb0014d$export$2e2bcd8739ae039 = $f10dd87bccb0014d$var$useEventCallback;


"use client";
var $788a24ad2efceaa4$export$2e2bcd8739ae039 = (0, $f10dd87bccb0014d$export$2e2bcd8739ae039);



var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");
"use client";
const $966d2381f594ccff$var$UNINITIALIZED = {};
function $966d2381f594ccff$export$2e2bcd8739ae039(init, initArg) {
    const ref = $1T1QG.useRef($966d2381f594ccff$var$UNINITIALIZED);
    if (ref.current === $966d2381f594ccff$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $1T1QG = parcelRequire("1T1QG");
"use client";
const $b3374184834caf43$var$EMPTY = [];
function $b3374184834caf43$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $1T1QG.useEffect(fn, $b3374184834caf43$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


"use client";
class $b17443dc4e529ae6$export$786b4da70f00938b {
    constructor(){
        this.currentId = 0;
        this.clear = ()=>{
            if (this.currentId !== 0) {
                clearTimeout(this.currentId);
                this.currentId = 0;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $b17443dc4e529ae6$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = 0;
            fn();
        }, delay);
    }
}
function $b17443dc4e529ae6$export$2e2bcd8739ae039() {
    const timeout = (0, $966d2381f594ccff$export$2e2bcd8739ae039)($b17443dc4e529ae6$export$786b4da70f00938b.create).current;
    (0, $b3374184834caf43$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


"use client";
let $44f9b5edfb0b2031$var$hadKeyboardEvent = true;
let $44f9b5edfb0b2031$var$hadFocusVisibleRecently = false;
const $44f9b5edfb0b2031$var$hadFocusVisibleRecentlyTimeout = new (0, $b17443dc4e529ae6$export$786b4da70f00938b)();
const $44f9b5edfb0b2031$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $44f9b5edfb0b2031$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $44f9b5edfb0b2031$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $44f9b5edfb0b2031$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $44f9b5edfb0b2031$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $44f9b5edfb0b2031$var$handlePointerDown() {
    $44f9b5edfb0b2031$var$hadKeyboardEvent = false;
}
function $44f9b5edfb0b2031$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($44f9b5edfb0b2031$var$hadFocusVisibleRecently) $44f9b5edfb0b2031$var$hadKeyboardEvent = true;
    }
}
function $44f9b5edfb0b2031$var$prepare(doc) {
    doc.addEventListener("keydown", $44f9b5edfb0b2031$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $44f9b5edfb0b2031$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $44f9b5edfb0b2031$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $44f9b5edfb0b2031$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $44f9b5edfb0b2031$var$handleVisibilityChange, true);
}
function $44f9b5edfb0b2031$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $44f9b5edfb0b2031$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $44f9b5edfb0b2031$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $44f9b5edfb0b2031$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $44f9b5edfb0b2031$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $44f9b5edfb0b2031$var$handleVisibilityChange, true);
}
function $44f9b5edfb0b2031$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $44f9b5edfb0b2031$var$hadKeyboardEvent || $44f9b5edfb0b2031$var$focusTriggersKeyboardModality(target);
}
function $44f9b5edfb0b2031$export$2e2bcd8739ae039() {
    const ref = $1T1QG.useCallback((node)=>{
        if (node != null) $44f9b5edfb0b2031$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $1T1QG.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $44f9b5edfb0b2031$var$hadFocusVisibleRecently = true;
            $44f9b5edfb0b2031$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $44f9b5edfb0b2031$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($44f9b5edfb0b2031$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


"use client";
var $4a2f2e3ed2159cdf$export$2e2bcd8739ae039 = (0, $44f9b5edfb0b2031$export$2e2bcd8739ae039);



var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");
function $af9a87c3d955b52d$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $c47a26320f24aca3$export$2e2bcd8739ae039(o, p) {
    $c47a26320f24aca3$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c47a26320f24aca3$export$2e2bcd8739ae039(o, p);
}


function $2068d65b9cbba68b$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $c47a26320f24aca3$export$2e2bcd8739ae039)(subClass, superClass);
}




var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");
var $11067877488353c4$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createContext(null);



var $1T1QG = parcelRequire("1T1QG");
function $3d73187bed1a7a6b$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $1T1QG.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $1T1QG.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $3d73187bed1a7a6b$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $3d73187bed1a7a6b$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $3d73187bed1a7a6b$export$fa71e2345c31d7a2(props, onExited) {
    return $3d73187bed1a7a6b$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $1T1QG.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $3d73187bed1a7a6b$var$getProp(child, "appear", props),
            enter: $3d73187bed1a7a6b$var$getProp(child, "enter", props),
            exit: $3d73187bed1a7a6b$var$getProp(child, "exit", props)
        });
    });
}
function $3d73187bed1a7a6b$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $3d73187bed1a7a6b$export$bbc8a025727ea824(nextProps.children);
    var children = $3d73187bed1a7a6b$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $1T1QG.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $1T1QG.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $1T1QG.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $3d73187bed1a7a6b$var$getProp(child, "exit", nextProps),
            enter: $3d73187bed1a7a6b$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $1T1QG.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $1T1QG.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $1T1QG.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $3d73187bed1a7a6b$var$getProp(child, "exit", nextProps),
            enter: $3d73187bed1a7a6b$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $fe45668052bb8991$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $fe45668052bb8991$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $fe45668052bb8991$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $2068d65b9cbba68b$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $af9a87c3d955b52d$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $3d73187bed1a7a6b$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $3d73187bed1a7a6b$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $3d73187bed1a7a6b$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $ajTRS.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $iXdVf.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $fe45668052bb8991$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $11067877488353c4$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $11067877488353c4$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Component);
$fe45668052bb8991$var$TransitionGroup.propTypes = {};
$fe45668052bb8991$var$TransitionGroup.defaultProps = $fe45668052bb8991$var$defaultProps;
var $fe45668052bb8991$export$2e2bcd8739ae039 = $fe45668052bb8991$var$TransitionGroup;



var $aVXbR = parcelRequire("aVXbR");

var $aMdXx = parcelRequire("aMdXx");


var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $3Py8h = parcelRequire("3Py8h");
"use client";
function $9bf803a30b32117e$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $1T1QG.useState(false);
    const rippleClassName = (0, $aVXbR.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $aVXbR.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $1T1QG.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)("span", {
            className: childClassName
        })
    });
}
var $9bf803a30b32117e$export$2e2bcd8739ae039 = $9bf803a30b32117e$var$Ripple;



var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $eb5a564c38864371$export$b464606f735ab902(slot) {
    return (0, $iNQht.default)("MuiTouchRipple", slot);
}
const $eb5a564c38864371$var$touchRippleClasses = (0, $dfswM.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $eb5a564c38864371$export$2e2bcd8739ae039 = $eb5a564c38864371$var$touchRippleClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $61d25cdfcf40fb33$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $61d25cdfcf40fb33$var$_ = (t)=>t, $61d25cdfcf40fb33$var$_t, $61d25cdfcf40fb33$var$_t2, $61d25cdfcf40fb33$var$_t3, $61d25cdfcf40fb33$var$_t4;
const $61d25cdfcf40fb33$var$DURATION = 550;
const $61d25cdfcf40fb33$export$95d0c9356b2231a3 = 80;
const $61d25cdfcf40fb33$var$enterKeyframe = (0, $aMdXx.keyframes)($61d25cdfcf40fb33$var$_t || ($61d25cdfcf40fb33$var$_t = $61d25cdfcf40fb33$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $61d25cdfcf40fb33$var$exitKeyframe = (0, $aMdXx.keyframes)($61d25cdfcf40fb33$var$_t2 || ($61d25cdfcf40fb33$var$_t2 = $61d25cdfcf40fb33$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $61d25cdfcf40fb33$var$pulsateKeyframe = (0, $aMdXx.keyframes)($61d25cdfcf40fb33$var$_t3 || ($61d25cdfcf40fb33$var$_t3 = $61d25cdfcf40fb33$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $61d25cdfcf40fb33$export$f6b7418508c72c25 = (0, $npagc.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $61d25cdfcf40fb33$export$676cfe7b12693c4b = (0, $npagc.default)((0, $9bf803a30b32117e$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($61d25cdfcf40fb33$var$_t4 || ($61d25cdfcf40fb33$var$_t4 = $61d25cdfcf40fb33$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $eb5a564c38864371$export$2e2bcd8739ae039).rippleVisible, $61d25cdfcf40fb33$var$enterKeyframe, $61d25cdfcf40fb33$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $eb5a564c38864371$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $eb5a564c38864371$export$2e2bcd8739ae039).child, (0, $eb5a564c38864371$export$2e2bcd8739ae039).childLeaving, $61d25cdfcf40fb33$var$exitKeyframe, $61d25cdfcf40fb33$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $eb5a564c38864371$export$2e2bcd8739ae039).childPulsate, $61d25cdfcf40fb33$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $61d25cdfcf40fb33$var$TouchRipple = /*#__PURE__*/ $1T1QG.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $iXdVf.default)(props, $61d25cdfcf40fb33$var$_excluded);
    const [ripples, setRipples] = $1T1QG.useState([]);
    const nextKey = $1T1QG.useRef(0);
    const rippleCallback = $1T1QG.useRef(null);
    $1T1QG.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $1T1QG.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $b17443dc4e529ae6$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $1T1QG.useRef(null);
    const container = $1T1QG.useRef(null);
    const startCommit = $1T1QG.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $3Py8h.jsx)($61d25cdfcf40fb33$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $aVXbR.default)(classes.ripple, (0, $eb5a564c38864371$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $aVXbR.default)(classes.rippleVisible, (0, $eb5a564c38864371$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $aVXbR.default)(classes.ripplePulsate, (0, $eb5a564c38864371$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $aVXbR.default)(classes.child, (0, $eb5a564c38864371$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $aVXbR.default)(classes.childLeaving, (0, $eb5a564c38864371$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $aVXbR.default)(classes.childPulsate, (0, $eb5a564c38864371$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $61d25cdfcf40fb33$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $1T1QG.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($61d25cdfcf40fb33$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $1T1QG.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $1T1QG.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $1T1QG.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($61d25cdfcf40fb33$export$f6b7418508c72c25, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)((0, $eb5a564c38864371$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $fe45668052bb8991$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $61d25cdfcf40fb33$export$2e2bcd8739ae039 = $61d25cdfcf40fb33$var$TouchRipple;



var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $f60760453eacc942$export$fccb0498dcd99783(slot) {
    return (0, $iNQht.default)("MuiButtonBase", slot);
}
const $f60760453eacc942$var$buttonBaseClasses = (0, $dfswM.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $f60760453eacc942$export$2e2bcd8739ae039 = $f60760453eacc942$var$buttonBaseClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $ecc40a2d226ef234$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $ecc40a2d226ef234$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $iV85C.default)(slots, (0, $f60760453eacc942$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $ecc40a2d226ef234$export$7ec0dcc5e3cdcd36 = (0, $npagc.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $f60760453eacc942$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $ecc40a2d226ef234$var$ButtonBase = /*#__PURE__*/ $1T1QG.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $iXdVf.default)(props, $ecc40a2d226ef234$var$_excluded);
    const buttonRef = $1T1QG.useRef(null);
    const rippleRef = $1T1QG.useRef(null);
    const handleRippleRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $4a2f2e3ed2159cdf$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $1T1QG.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $1T1QG.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $1T1QG.useState(false);
    $1T1QG.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $1T1QG.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $788a24ad2efceaa4$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $788a24ad2efceaa4$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $1T1QG.useRef(false);
    const handleKeyDown = (0, $788a24ad2efceaa4$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $788a24ad2efceaa4$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $ajTRS.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $ecc40a2d226ef234$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($ecc40a2d226ef234$export$7ec0dcc5e3cdcd36, (0, $ajTRS.default)({
        as: ComponentProp,
        className: (0, $aVXbR.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $3Py8h.jsx)((0, $61d25cdfcf40fb33$export$2e2bcd8739ae039), (0, $ajTRS.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $ecc40a2d226ef234$export$2e2bcd8739ae039 = $ecc40a2d226ef234$var$ButtonBase;



var $5wtOU = parcelRequire("5wtOU");
parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $bb561e761b0c39ff$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage");


parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $71b9752014815449$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage");


parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $3443ad339e8689b0$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore");


parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $016b23f9347fa8ba$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext");



var $npagc = parcelRequire("npagc");

var $3Py8h = parcelRequire("3Py8h");
"use client";
const $889af25983d0fdb2$var$_excluded = [
    "className",
    "color",
    "component",
    "components",
    "disabled",
    "page",
    "selected",
    "shape",
    "size",
    "slots",
    "type",
    "variant"
];
const $889af25983d0fdb2$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, $5wtOU.default)(ownerState.size)}`],
        ownerState.variant === "text" && styles[`text${(0, $5wtOU.default)(ownerState.color)}`],
        ownerState.variant === "outlined" && styles[`outlined${(0, $5wtOU.default)(ownerState.color)}`],
        ownerState.shape === "rounded" && styles.rounded,
        ownerState.type === "page" && styles.page,
        (ownerState.type === "start-ellipsis" || ownerState.type === "end-ellipsis") && styles.ellipsis,
        (ownerState.type === "previous" || ownerState.type === "next") && styles.previousNext,
        (ownerState.type === "first" || ownerState.type === "last") && styles.firstLast
    ];
};
const $889af25983d0fdb2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, selected: selected, size: size, shape: shape, type: type, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            `size${(0, $5wtOU.default)(size)}`,
            variant,
            shape,
            color !== "standard" && `color${(0, $5wtOU.default)(color)}`,
            color !== "standard" && `${variant}${(0, $5wtOU.default)(color)}`,
            disabled && "disabled",
            selected && "selected",
            {
                page: "page",
                first: "firstLast",
                last: "firstLast",
                "start-ellipsis": "ellipsis",
                "end-ellipsis": "ellipsis",
                previous: "previousNext",
                next: "previousNext"
            }[type]
        ],
        icon: [
            "icon"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $e436e4f3f86fe0d0$export$e4ce0a775adf2f74), classes);
};
const $889af25983d0fdb2$var$PaginationItemEllipsis = (0, $npagc.default)("div", {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver: $889af25983d0fdb2$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: "center",
        boxSizing: "border-box",
        minWidth: 32,
        padding: "0 6px",
        margin: "0 3px",
        color: (theme.vars || theme).palette.text.primary,
        height: "auto",
        [`&.${(0, $e436e4f3f86fe0d0$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.size === "small" && {
        minWidth: 26,
        borderRadius: 13,
        margin: "0 1px",
        padding: "0 4px"
    }, ownerState.size === "large" && {
        minWidth: 40,
        borderRadius: 20,
        padding: "0 10px",
        fontSize: theme.typography.pxToRem(15)
    }));
const $889af25983d0fdb2$var$PaginationItemPage = (0, $npagc.default)((0, $ecc40a2d226ef234$export$2e2bcd8739ae039), {
    name: "MuiPaginationItem",
    slot: "Root",
    overridesResolver: $889af25983d0fdb2$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: "center",
        boxSizing: "border-box",
        minWidth: 32,
        height: 32,
        padding: "0 6px",
        margin: "0 3px",
        color: (theme.vars || theme).palette.text.primary,
        [`&.${(0, $e436e4f3f86fe0d0$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $e436e4f3f86fe0d0$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            "color",
            "background-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $e436e4f3f86fe0d0$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7Etkp.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${(0, $e436e4f3f86fe0d0$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7Etkp.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            },
            [`&.${(0, $e436e4f3f86fe0d0$export$2e2bcd8739ae039).disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        }
    }, ownerState.size === "small" && {
        minWidth: 26,
        height: 26,
        borderRadius: 13,
        margin: "0 1px",
        padding: "0 4px"
    }, ownerState.size === "large" && {
        minWidth: 40,
        height: 40,
        borderRadius: 20,
        padding: "0 10px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.shape === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }), ({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({}, ownerState.variant === "text" && {
        [`&.${(0, $e436e4f3f86fe0d0$export$2e2bcd8739ae039).selected}`]: (0, $ajTRS.default)({}, ownerState.color !== "standard" && {
            color: (theme.vars || theme).palette[ownerState.color].contrastText,
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
                }
            },
            [`&.${(0, $e436e4f3f86fe0d0$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
            }
        }, {
            [`&.${(0, $e436e4f3f86fe0d0$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }, ownerState.variant === "outlined" && {
        border: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${(0, $e436e4f3f86fe0d0$export$2e2bcd8739ae039).selected}`]: (0, $ajTRS.default)({}, ownerState.color !== "standard" && {
            color: (theme.vars || theme).palette[ownerState.color].main,
            border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $7Etkp.alpha)(theme.palette[ownerState.color].main, 0.5)}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.activatedOpacity})` : (0, $7Etkp.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7Etkp.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, $e436e4f3f86fe0d0$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7Etkp.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
            }
        }, {
            [`&.${(0, $e436e4f3f86fe0d0$export$2e2bcd8739ae039).disabled}`]: {
                borderColor: (theme.vars || theme).palette.action.disabledBackground,
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }));
const $889af25983d0fdb2$var$PaginationItemPageIcon = (0, $npagc.default)("div", {
    name: "MuiPaginationItem",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        fontSize: theme.typography.pxToRem(20),
        margin: "0 -8px"
    }, ownerState.size === "small" && {
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        fontSize: theme.typography.pxToRem(22)
    }));
const $889af25983d0fdb2$var$PaginationItem = /*#__PURE__*/ $1T1QG.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPaginationItem"
    });
    const { className: className, color: color = "standard", component: component, components: components = {}, disabled: disabled = false, page: page, selected: selected = false, shape: shape = "circular", size: size = "medium", slots: slots = {}, type: type = "page", variant: variant = "text" } = props, other = (0, $iXdVf.default)(props, $889af25983d0fdb2$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        color: color,
        disabled: disabled,
        selected: selected,
        shape: shape,
        size: size,
        type: type,
        variant: variant
    });
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const classes = $889af25983d0fdb2$var$useUtilityClasses(ownerState);
    const normalizedIcons = theme.direction === "rtl" ? {
        previous: slots.next || components.next || (0, $016b23f9347fa8ba$export$2e2bcd8739ae039),
        next: slots.previous || components.previous || (0, $3443ad339e8689b0$export$2e2bcd8739ae039),
        last: slots.first || components.first || (0, $bb561e761b0c39ff$export$2e2bcd8739ae039),
        first: slots.last || components.last || (0, $71b9752014815449$export$2e2bcd8739ae039)
    } : {
        previous: slots.previous || components.previous || (0, $3443ad339e8689b0$export$2e2bcd8739ae039),
        next: slots.next || components.next || (0, $016b23f9347fa8ba$export$2e2bcd8739ae039),
        first: slots.first || components.first || (0, $bb561e761b0c39ff$export$2e2bcd8739ae039),
        last: slots.last || components.last || (0, $71b9752014815449$export$2e2bcd8739ae039)
    };
    const Icon = normalizedIcons[type];
    return type === "start-ellipsis" || type === "end-ellipsis" ? /*#__PURE__*/ (0, $3Py8h.jsx)($889af25983d0fdb2$var$PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, $aVXbR.default)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, $3Py8h.jsxs)($889af25983d0fdb2$var$PaginationItemPage, (0, $ajTRS.default)({
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, $aVXbR.default)(classes.root, className)
    }, other, {
        children: [
            type === "page" && page,
            Icon ? /*#__PURE__*/ (0, $3Py8h.jsx)($889af25983d0fdb2$var$PaginationItemPageIcon, {
                as: Icon,
                ownerState: ownerState,
                className: classes.icon
            }) : null
        ]
    }));
});
var $889af25983d0fdb2$export$2e2bcd8739ae039 = $889af25983d0fdb2$var$PaginationItem;



var $npagc = parcelRequire("npagc");

var $3Py8h = parcelRequire("3Py8h");
"use client";
const $54ae6b4badf4080d$var$_excluded = [
    "boundaryCount",
    "className",
    "color",
    "count",
    "defaultPage",
    "disabled",
    "getItemAriaLabel",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "renderItem",
    "shape",
    "showFirstButton",
    "showLastButton",
    "siblingCount",
    "size",
    "variant"
];
const $54ae6b4badf4080d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant
        ],
        ul: [
            "ul"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $332e8470e2bc8a1d$export$427f1c1e2e839f85), classes);
};
const $54ae6b4badf4080d$var$PaginationRoot = (0, $npagc.default)("nav", {
    name: "MuiPagination",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const $54ae6b4badf4080d$var$PaginationUl = (0, $npagc.default)("ul", {
    name: "MuiPagination",
    slot: "Ul",
    overridesResolver: (props, styles)=>styles.ul
})({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
});
function $54ae6b4badf4080d$var$defaultGetAriaLabel(type, page, selected) {
    if (type === "page") return `${selected ? "" : "Go to "}page ${page}`;
    return `Go to ${type} page`;
}
const $54ae6b4badf4080d$var$Pagination = /*#__PURE__*/ $1T1QG.forwardRef(function Pagination(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPagination"
    });
    const { boundaryCount: boundaryCount = 1, className: className, color: color = "standard", count: count = 1, defaultPage: defaultPage = 1, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $54ae6b4badf4080d$var$defaultGetAriaLabel, hideNextButton: hideNextButton = false, hidePrevButton: hidePrevButton = false, renderItem: renderItem = (item)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $889af25983d0fdb2$export$2e2bcd8739ae039), (0, $ajTRS.default)({}, item)), shape: shape = "circular", showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, siblingCount: siblingCount = 1, size: size = "medium", variant: variant = "text" } = props, other = (0, $iXdVf.default)(props, $54ae6b4badf4080d$var$_excluded);
    const { items: items } = (0, $24de3a033d1a4e7e$export$2e2bcd8739ae039)((0, $ajTRS.default)({}, props, {
        componentName: "Pagination"
    }));
    const ownerState = (0, $ajTRS.default)({}, props, {
        boundaryCount: boundaryCount,
        color: color,
        count: count,
        defaultPage: defaultPage,
        disabled: disabled,
        getItemAriaLabel: getItemAriaLabel,
        hideNextButton: hideNextButton,
        hidePrevButton: hidePrevButton,
        renderItem: renderItem,
        shape: shape,
        showFirstButton: showFirstButton,
        showLastButton: showLastButton,
        siblingCount: siblingCount,
        size: size,
        variant: variant
    });
    const classes = $54ae6b4badf4080d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($54ae6b4badf4080d$var$PaginationRoot, (0, $ajTRS.default)({
        "aria-label": "pagination navigation",
        className: (0, $aVXbR.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($54ae6b4badf4080d$var$PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, $3Py8h.jsx)("li", {
                    children: renderItem((0, $ajTRS.default)({}, item, {
                        color: color,
                        "aria-label": getItemAriaLabel(item.type, item.page, item.selected),
                        shape: shape,
                        size: size,
                        variant: variant
                    }))
                }, index))
        })
    }));
});
var $54ae6b4badf4080d$export$2e2bcd8739ae039 = $54ae6b4badf4080d$var$Pagination;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $5wtOU = parcelRequire("5wtOU");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $756d594fc5672b45$export$24c1f8f60cbac79e(slot) {
    return (0, $iNQht.default)("MuiTypography", slot);
}
const $756d594fc5672b45$var$typographyClasses = (0, $dfswM.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $756d594fc5672b45$export$2e2bcd8739ae039 = $756d594fc5672b45$var$typographyClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $a386176d6ca21602$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $a386176d6ca21602$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $5wtOU.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $756d594fc5672b45$export$24c1f8f60cbac79e), classes);
};
const $a386176d6ca21602$export$140e2f5526d3cad8 = (0, $npagc.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $5wtOU.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $a386176d6ca21602$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $a386176d6ca21602$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $a386176d6ca21602$var$transformDeprecatedColors = (color)=>{
    return $a386176d6ca21602$var$colorTransformations[color] || color;
};
const $a386176d6ca21602$var$Typography = /*#__PURE__*/ $1T1QG.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $gADeF.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $a386176d6ca21602$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $a5c864e19e03ba63$export$2e2bcd8739ae039)((0, $ajTRS.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $a386176d6ca21602$var$defaultVariantMapping } = props, other = (0, $iXdVf.default)(props, $a386176d6ca21602$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $a386176d6ca21602$var$defaultVariantMapping[variant]) || "span";
    const classes = $a386176d6ca21602$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($a386176d6ca21602$export$140e2f5526d3cad8, (0, $ajTRS.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $aVXbR.default)(classes.root, className)
    }, other));
});
var $a386176d6ca21602$export$2e2bcd8739ae039 = $a386176d6ca21602$var$Typography;


var $1T1QG = parcelRequire("1T1QG");

var $f0MeF = parcelRequire("f0MeF");
var $6UrSi = parcelRequire("6UrSi");

"use client";
var $675d87943b3ee26a$export$2e2bcd8739ae039 = (0, $ac1861e6d86aa648$export$2e2bcd8739ae039);


"use client";
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $ffad103d3c7e3bc8$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $1T1QG.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $675d87943b3ee26a$export$2e2bcd8739ae039)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $ffad103d3c7e3bc8$var$maybeReactUseSyncExternalStore = $1T1QG.useSyncExternalStore;
function $ffad103d3c7e3bc8$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $1T1QG.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $1T1QG.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $1T1QG.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $ffad103d3c7e3bc8$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $ffad103d3c7e3bc8$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $6UrSi.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $f0MeF.default)({
        name: "MuiUseMediaQuery",
        props: options,
        theme: theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $ffad103d3c7e3bc8$var$maybeReactUseSyncExternalStore !== undefined ? $ffad103d3c7e3bc8$var$useMediaQueryNew : $ffad103d3c7e3bc8$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}



var $eUHG3 = parcelRequire("eUHG3");
const $55d02d7b1a5c4f16$export$e8b67cc4f4c44ec6 = (pagination)=>{
    if (!pagination || !pagination.page || pagination.page <= 1) return undefined;
    const totalNumberOfPages = pagination.limit > 0 ? Math.ceil(pagination.total / pagination.limit) : 0;
    if (totalNumberOfPages <= 1) return undefined;
    const lastItems = pagination.total % pagination.limit || pagination.limit;
    if (lastItems !== 1) return undefined;
    if (pagination.page === totalNumberOfPages) return pagination.page - 1;
    return undefined;
};
const $55d02d7b1a5c4f16$export$4bec99d256114e49 = (sort, direction)=>{
    return {
        page: "1",
        limit: "20",
        sort: sort,
        direction: direction ?? "ASC"
    };
};
const $55d02d7b1a5c4f16$export$f381863f4c1c052a = (values)=>{
    const { page: page, limit: limit, sort: sort, direction: direction } = values;
    return {
        page: (0, $eUHG3.isInteger)(page) ? page.toString() : page.toString(),
        limit: (0, $eUHG3.isInteger)(limit) ? limit.toString() : limit.toString(),
        sort: sort,
        direction: direction
    };
};
const $55d02d7b1a5c4f16$var$MoovyPagination = ({ page: page, total: total, limit: limit, onNextPage: onNextPage })=>{
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const isMobile = (0, $ffad103d3c7e3bc8$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    const totalNumberOfPages = total > 0 && limit > 0 ? Math.ceil(total / limit) : 0;
    const start = page ? page * limit - limit + 1 : 0;
    const end = Math.min(start + limit - 1, total);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
        container: true,
        direction: "row",
        paddingTop: 2,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                item: true,
                pl: 2,
                xs: 12,
                md: true,
                sx: {
                    pb: {
                        xs: 2,
                        md: 0
                    }
                },
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                    sx: {
                        justifyContent: {
                            xs: "center",
                            md: "left"
                        }
                    },
                    display: "flex",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a386176d6ca21602$export$2e2bcd8739ae039), {
                        color: "text.secondary",
                        children: `${start} - ${end} / ${total}`
                    })
                })
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                item: true,
                md: true,
                sx: {
                    pb: {
                        xs: 1,
                        md: 0
                    }
                },
                xs: 12,
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                    sx: {
                        justifyContent: {
                            xs: "center",
                            md: "right"
                        }
                    },
                    display: "flex",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $54ae6b4badf4080d$export$2e2bcd8739ae039), {
                        page: page,
                        siblingCount: 1,
                        boundaryCount: 0,
                        count: totalNumberOfPages,
                        shape: "rounded",
                        showFirstButton: !isMobile,
                        showLastButton: !isMobile,
                        onChange: (event, page)=>onNextPage(page)
                    })
                })
            })
        ]
    });
};
var $55d02d7b1a5c4f16$export$2e2bcd8739ae039 = $55d02d7b1a5c4f16$var$MoovyPagination;



var $1T1QG = parcelRequire("1T1QG");
const $5f8ca62b06e02682$export$add10c4cb4cd7fd0 = "moovyBackdropAnimation";
const $5f8ca62b06e02682$export$60dd4bbd6d459f57 = "moovyCatalogueRightsPaging";
const $5f8ca62b06e02682$export$70568e7be1b89dff = "moovyCatalogueRightsSorting";
const $5f8ca62b06e02682$export$2b74872b9eccd572 = "moovyCataloguesPaging";
const $5f8ca62b06e02682$export$dd6ef14bcd36b902 = "moovyCataloguesSorting";
const $5f8ca62b06e02682$export$d40389383c97912 = "moovyInvitationAdmingPaging";
const $5f8ca62b06e02682$export$5cbc2ff09ff3e0 = "moovyInvitationLandlordPaging";
const $5f8ca62b06e02682$export$1ef7c9c6b17b6642 = "moovyInvitationLandlordSorting";
const $5f8ca62b06e02682$export$52484cb0e4bee674 = "moovyOfferingsTabCatalogues";
const $5f8ca62b06e02682$export$fc22b6fdc7ebba93 = "moovyPlacesPaging";
const $5f8ca62b06e02682$export$a9c7fdd2cd34e65d = "moovyPlacesSort";
const $5f8ca62b06e02682$export$bf153b52ae22c83c = "moovyPlacesTabOfferings";
const $5f8ca62b06e02682$export$50da30c0967674ee = "moovyRightHoldersTabVehicles";


const $1a49c6a526fe14f2$export$88b06990067e1fdb = (intl, sortType)=>{
    const getLocalizedItems = (sortType, keys)=>{
        return keys.map((key)=>{
            return {
                key: key.toString(),
                value: intl.formatMessage({
                    id: `sort.${sortType}.${key}`
                })
            };
        });
    };
    switch(sortType){
        case "PLACES":
            {
                const keys = [
                    "NAME",
                    "CITY",
                    "CAPACITY",
                    "CUSTOMER_ID"
                ];
                return getLocalizedItems(sortType, keys);
            }
        case "INVITATIONS":
            {
                const keys = [
                    "NAME",
                    "EMAIL",
                    "CREATED_AT",
                    "USED"
                ];
                return getLocalizedItems(sortType, keys);
            }
        case "ACTIVE_RIGHTS":
            {
                const keys = [
                    "INDIVIDUAL",
                    "VEHICLE",
                    "VALIDITY_START",
                    "VALIDITY_END"
                ];
                return getLocalizedItems(sortType, keys);
            }
        case "CATALOGUES":
            {
                const keys = [
                    "CUSTOMER_ID",
                    "CREATED_AT",
                    "UPDATED_AT",
                    "AMOUNT"
                ];
                return getLocalizedItems(sortType, keys);
            }
        default:
            return [];
    }
};
const $1a49c6a526fe14f2$export$fcce7887255d1c69 = (sortKey)=>{
    const invitationDescKeys = [
        "CREATED_AT",
        "USED"
    ];
    const placeDescKeys = [
        "CAPACITY"
    ];
    const activeRightDescKeys = [
        "VALIDITY_START",
        "VALIDITY_END"
    ];
    const catalogueDescKeys = [
        "CREATED_AT",
        "UPDATED_AT",
        "AMOUNT"
    ];
    if (invitationDescKeys.includes(sortKey) || placeDescKeys.includes(sortKey) || activeRightDescKeys.includes(sortKey) || catalogueDescKeys.includes(sortKey)) return "DESC";
    return "ASC";
};








var $df5a5c239122d5cf$var$_client, $df5a5c239122d5cf$var$_currentQuery, $df5a5c239122d5cf$var$_currentQueryInitialState, $df5a5c239122d5cf$var$_currentResult, $df5a5c239122d5cf$var$_currentResultState, $df5a5c239122d5cf$var$_currentResultOptions, $df5a5c239122d5cf$var$_selectError, $df5a5c239122d5cf$var$_selectFn, $df5a5c239122d5cf$var$_selectResult, $df5a5c239122d5cf$var$_lastQueryWithDefinedData, $df5a5c239122d5cf$var$_staleTimeoutId, $df5a5c239122d5cf$var$_refetchIntervalId, $df5a5c239122d5cf$var$_currentRefetchInterval, $df5a5c239122d5cf$var$_trackedProps, $df5a5c239122d5cf$var$_executeFetch, $df5a5c239122d5cf$var$executeFetch_fn, $df5a5c239122d5cf$var$_updateStaleTimeout, $df5a5c239122d5cf$var$updateStaleTimeout_fn, $df5a5c239122d5cf$var$_computeRefetchInterval, $df5a5c239122d5cf$var$computeRefetchInterval_fn, $df5a5c239122d5cf$var$_updateRefetchInterval, $df5a5c239122d5cf$var$updateRefetchInterval_fn, $df5a5c239122d5cf$var$_updateTimers, $df5a5c239122d5cf$var$updateTimers_fn, $df5a5c239122d5cf$var$_clearStaleTimeout, $df5a5c239122d5cf$var$clearStaleTimeout_fn, $df5a5c239122d5cf$var$_clearRefetchInterval, $df5a5c239122d5cf$var$clearRefetchInterval_fn, $df5a5c239122d5cf$var$_updateQuery, $df5a5c239122d5cf$var$updateQuery_fn, $df5a5c239122d5cf$var$_notify, $df5a5c239122d5cf$var$notify_fn;
var $df5a5c239122d5cf$export$a06cf8c0066f0d4c = class extends (0, $3797a5406d67bffa$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_executeFetch);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_updateStaleTimeout);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_computeRefetchInterval);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_updateRefetchInterval);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_updateTimers);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_clearStaleTimeout);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_clearRefetchInterval);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_updateQuery);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_notify);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_client, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_currentQuery, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_currentQueryInitialState, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_currentResult, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_currentResultState, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_currentResultOptions, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_selectError, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_selectFn, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_selectResult, void 0);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_lastQueryWithDefinedData, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_staleTimeoutId, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_refetchIntervalId, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_currentRefetchInterval, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $df5a5c239122d5cf$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_client, client);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_selectError, null);
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery).addObserver(this);
            if ($df5a5c239122d5cf$var$shouldFetchOnMount((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery), this.options)) (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_executeFetch, $df5a5c239122d5cf$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_updateTimers, $df5a5c239122d5cf$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $df5a5c239122d5cf$var$shouldFetchOn((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $df5a5c239122d5cf$var$shouldFetchOn((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_clearStaleTimeout, $df5a5c239122d5cf$var$clearStaleTimeout_fn).call(this);
        (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_clearRefetchInterval, $df5a5c239122d5cf$var$clearRefetchInterval_fn).call(this);
        (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery).removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery);
        this.options = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_client).defaultQueryOptions(options);
        if (!(0, $c87861fcdbb7b7dc$export$3e67810a3f0e9f1c)(prevOptions, this.options)) (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery),
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_updateQuery, $df5a5c239122d5cf$var$updateQuery_fn).call(this);
        const mounted = this.hasListeners();
        if (mounted && $df5a5c239122d5cf$var$shouldFetchOptionally((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_executeFetch, $df5a5c239122d5cf$var$executeFetch_fn).call(this);
        this.updateResult(notifyOptions);
        if (mounted && ((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_updateStaleTimeout, $df5a5c239122d5cf$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_computeRefetchInterval, $df5a5c239122d5cf$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentRefetchInterval))) (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_updateRefetchInterval, $df5a5c239122d5cf$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_client).getQueryCache().build((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_client), options);
        const result = this.createResult(query, options);
        if ($df5a5c239122d5cf$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_currentResult, result);
            (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_currentResultOptions, this.options);
            (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_currentResultState, (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentResult);
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_trackedProps).add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_client).defaultQueryOptions(options);
        const query = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_client).getQueryCache().build((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_client), defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_executeFetch, $df5a5c239122d5cf$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentResult);
        const prevResultState = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentResultState);
        const prevResultOptions = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQueryInitialState);
        const { state: state } = query;
        let { error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $df5a5c239122d5cf$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $df5a5c239122d5cf$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $9bc3659d53db0b0e$export$61b92f63f30245cf)(query.options.networkMode) ? "fetching" : "paused";
                if (!state.dataUpdatedAt) status = "pending";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        }
        if (options.select && typeof state.data !== "undefined") {
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_selectFn)) data = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_selectResult);
            else try {
                (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_selectFn, options.select);
                data = options.select(state.data);
                data = (0, $c87861fcdbb7b7dc$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_selectResult, data);
                (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_selectError, null);
            } catch (selectError) {
                (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_selectError, selectError);
            }
        } else data = state.data;
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_lastQueryWithDefinedData)) : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_selectError, null);
                } catch (selectError) {
                    (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_selectError, selectError);
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, $c87861fcdbb7b7dc$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if ((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_selectError)) {
            error = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_selectError);
            data = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: state.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $df5a5c239122d5cf$var$isStale(query, options),
            refetch: this.refetch
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentResult);
        const nextResult = this.createResult((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery), this.options);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_currentResultState, (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery).state);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_currentResultOptions, this.options);
        if ((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentResultState).data !== void 0) (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_lastQueryWithDefinedData, (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery));
        if ((0, $c87861fcdbb7b7dc$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_currentResult, nextResult);
        const defaultNotifyOptions = {};
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_notify, $df5a5c239122d5cf$var$notify_fn).call(this, {
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_updateTimers, $df5a5c239122d5cf$var$updateTimers_fn).call(this);
    }
};
$df5a5c239122d5cf$var$_client = new WeakMap();
$df5a5c239122d5cf$var$_currentQuery = new WeakMap();
$df5a5c239122d5cf$var$_currentQueryInitialState = new WeakMap();
$df5a5c239122d5cf$var$_currentResult = new WeakMap();
$df5a5c239122d5cf$var$_currentResultState = new WeakMap();
$df5a5c239122d5cf$var$_currentResultOptions = new WeakMap();
$df5a5c239122d5cf$var$_selectError = new WeakMap();
$df5a5c239122d5cf$var$_selectFn = new WeakMap();
$df5a5c239122d5cf$var$_selectResult = new WeakMap();
$df5a5c239122d5cf$var$_lastQueryWithDefinedData = new WeakMap();
$df5a5c239122d5cf$var$_staleTimeoutId = new WeakMap();
$df5a5c239122d5cf$var$_refetchIntervalId = new WeakMap();
$df5a5c239122d5cf$var$_currentRefetchInterval = new WeakMap();
$df5a5c239122d5cf$var$_trackedProps = new WeakMap();
$df5a5c239122d5cf$var$_executeFetch = new WeakSet();
$df5a5c239122d5cf$var$executeFetch_fn = function(fetchOptions) {
    (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_updateQuery, $df5a5c239122d5cf$var$updateQuery_fn).call(this);
    let promise = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $c87861fcdbb7b7dc$export$8793edee2d425525));
    return promise;
};
$df5a5c239122d5cf$var$_updateStaleTimeout = new WeakSet();
$df5a5c239122d5cf$var$updateStaleTimeout_fn = function() {
    (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_clearStaleTimeout, $df5a5c239122d5cf$var$clearStaleTimeout_fn).call(this);
    if ((0, $c87861fcdbb7b7dc$export$6acf61af03e62db) || (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentResult).isStale || !(0, $c87861fcdbb7b7dc$export$e539f754e934e270)(this.options.staleTime)) return;
    const time = (0, $c87861fcdbb7b7dc$export$811b83d62bcf47f0)((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentResult).dataUpdatedAt, this.options.staleTime);
    const timeout = time + 1;
    (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_staleTimeoutId, setTimeout(()=>{
        if (!(0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$df5a5c239122d5cf$var$_computeRefetchInterval = new WeakSet();
$df5a5c239122d5cf$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$df5a5c239122d5cf$var$_updateRefetchInterval = new WeakSet();
$df5a5c239122d5cf$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_clearRefetchInterval, $df5a5c239122d5cf$var$clearRefetchInterval_fn).call(this);
    (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_currentRefetchInterval, nextInterval);
    if ((0, $c87861fcdbb7b7dc$export$6acf61af03e62db) || this.options.enabled === false || !(0, $c87861fcdbb7b7dc$export$e539f754e934e270)((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentRefetchInterval)) || (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentRefetchInterval) === 0) return;
    (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_refetchIntervalId, setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $f0a8743d916c8b49$export$6bf54661be5b02cf).isFocused()) (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_executeFetch, $df5a5c239122d5cf$var$executeFetch_fn).call(this);
    }, (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentRefetchInterval)));
};
$df5a5c239122d5cf$var$_updateTimers = new WeakSet();
$df5a5c239122d5cf$var$updateTimers_fn = function() {
    (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_updateStaleTimeout, $df5a5c239122d5cf$var$updateStaleTimeout_fn).call(this);
    (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_updateRefetchInterval, $df5a5c239122d5cf$var$updateRefetchInterval_fn).call(this, (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $df5a5c239122d5cf$var$_computeRefetchInterval, $df5a5c239122d5cf$var$computeRefetchInterval_fn).call(this));
};
$df5a5c239122d5cf$var$_clearStaleTimeout = new WeakSet();
$df5a5c239122d5cf$var$clearStaleTimeout_fn = function() {
    if ((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_staleTimeoutId)) {
        clearTimeout((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_staleTimeoutId));
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_staleTimeoutId, void 0);
    }
};
$df5a5c239122d5cf$var$_clearRefetchInterval = new WeakSet();
$df5a5c239122d5cf$var$clearRefetchInterval_fn = function() {
    if ((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_refetchIntervalId)) {
        clearInterval((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_refetchIntervalId));
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_refetchIntervalId, void 0);
    }
};
$df5a5c239122d5cf$var$_updateQuery = new WeakSet();
$df5a5c239122d5cf$var$updateQuery_fn = function() {
    const query = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_client).getQueryCache().build((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_client), this.options);
    if (query === (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery)) return;
    const prevQuery = (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery);
    (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_currentQuery, query);
    (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $df5a5c239122d5cf$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$df5a5c239122d5cf$var$_notify = new WeakSet();
$df5a5c239122d5cf$var$notify_fn = function(notifyOptions) {
    (0, $8f286f9abfc2c252$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentResult));
        });
        (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_client).getQueryCache().notify({
            query: (0, $783f6097b351748f$export$18a094aefa070634)(this, $df5a5c239122d5cf$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $df5a5c239122d5cf$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $df5a5c239122d5cf$var$shouldFetchOnMount(query, options) {
    return $df5a5c239122d5cf$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $df5a5c239122d5cf$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $df5a5c239122d5cf$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $df5a5c239122d5cf$var$isStale(query, options);
    }
    return false;
}
function $df5a5c239122d5cf$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $df5a5c239122d5cf$var$isStale(query, options);
}
function $df5a5c239122d5cf$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}
function $df5a5c239122d5cf$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $c87861fcdbb7b7dc$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $1T1QG = parcelRequire("1T1QG");


var $1T1QG = parcelRequire("1T1QG");

var $3Py8h = parcelRequire("3Py8h");
"use client";
function $87e1a1dcca276850$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $87e1a1dcca276850$var$QueryErrorResetBoundaryContext = $1T1QG.createContext($87e1a1dcca276850$var$createValue());
var $87e1a1dcca276850$export$50dfac555130cafd = ()=>$1T1QG.useContext($87e1a1dcca276850$var$QueryErrorResetBoundaryContext);
var $87e1a1dcca276850$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $1T1QG.useState(()=>$87e1a1dcca276850$var$createValue());
    return /* @__PURE__ */ (0, $3Py8h.jsx)($87e1a1dcca276850$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};




var $1T1QG = parcelRequire("1T1QG");
"use client";
var $09f9d9d1968f16e8$var$IsRestoringContext = $1T1QG.createContext(false);
var $09f9d9d1968f16e8$export$4da0178d6b5f553 = ()=>$1T1QG.useContext($09f9d9d1968f16e8$var$IsRestoringContext);
var $09f9d9d1968f16e8$export$593807d4e94f9621 = $09f9d9d1968f16e8$var$IsRestoringContext.Provider;



var $1T1QG = parcelRequire("1T1QG");
// src/utils.ts
function $c0dcc8dd94b1fd70$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}


"use client";
var $5298fce18a7ce555$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $5298fce18a7ce555$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $1T1QG.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $5298fce18a7ce555$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (0, $c0dcc8dd94b1fd70$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]);
};


// src/suspense.ts
var $e9bd740f860bf682$export$8bed2f8d02206063 = (_error, query)=>typeof query.state.data === "undefined";
var $e9bd740f860bf682$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1e3;
    }
};
var $e9bd740f860bf682$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $e9bd740f860bf682$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var $e9bd740f860bf682$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $126fc0cae9b634d7$export$fff0865807e996c5(options, Observer, queryClient) {
    const client = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)(queryClient);
    const isRestoring = (0, $09f9d9d1968f16e8$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $87e1a1dcca276850$export$50dfac555130cafd)();
    const defaultedOptions = client.defaultQueryOptions(options);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $e9bd740f860bf682$export$2c40a591ad2dafb1)(defaultedOptions);
    (0, $5298fce18a7ce555$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $5298fce18a7ce555$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $1T1QG.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    $1T1QG.useSyncExternalStore($1T1QG.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>void 0 : observer.subscribe((0, $8f286f9abfc2c252$export$520687f44db6e1ab).batchCalls(onStoreChange));
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $1T1QG.useEffect(()=>{
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $e9bd740f860bf682$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $e9bd740f860bf682$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $5298fce18a7ce555$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash)
    })) throw result.error;
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $16bfa3cce9e56cee$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $126fc0cae9b634d7$export$fff0865807e996c5)(options, (0, $df5a5c239122d5cf$export$a06cf8c0066f0d4c), queryClient);
}



var $3Py8h = parcelRequire("3Py8h");



var $1T1QG = parcelRequire("1T1QG");

var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $1T1QG = parcelRequire("1T1QG");
/**
 * @ignore - internal component.
 */ const $80af7f557c9d946c$var$Tablelvl2Context = /*#__PURE__*/ $1T1QG.createContext();
var $80af7f557c9d946c$export$2e2bcd8739ae039 = $80af7f557c9d946c$var$Tablelvl2Context;



var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $8d9cbff883b14857$export$98bd2a9b566ec665(slot) {
    return (0, $iNQht.default)("MuiTableBody", slot);
}
const $8d9cbff883b14857$var$tableBodyClasses = (0, $dfswM.default)("MuiTableBody", [
    "root"
]);
var $8d9cbff883b14857$export$2e2bcd8739ae039 = $8d9cbff883b14857$var$tableBodyClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $a3b5a93a68cc46b9$var$_excluded = [
    "className",
    "component"
];
const $a3b5a93a68cc46b9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $8d9cbff883b14857$export$98bd2a9b566ec665), classes);
};
const $a3b5a93a68cc46b9$var$TableBodyRoot = (0, $npagc.default)("tbody", {
    name: "MuiTableBody",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-row-group"
});
const $a3b5a93a68cc46b9$var$tablelvl2 = {
    variant: "body"
};
const $a3b5a93a68cc46b9$var$defaultComponent = "tbody";
const $a3b5a93a68cc46b9$var$TableBody = /*#__PURE__*/ $1T1QG.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiTableBody"
    });
    const { className: className, component: component = $a3b5a93a68cc46b9$var$defaultComponent } = props, other = (0, $iXdVf.default)(props, $a3b5a93a68cc46b9$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        component: component
    });
    const classes = $a3b5a93a68cc46b9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $80af7f557c9d946c$export$2e2bcd8739ae039).Provider, {
        value: $a3b5a93a68cc46b9$var$tablelvl2,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($a3b5a93a68cc46b9$var$TableBodyRoot, (0, $ajTRS.default)({
            className: (0, $aVXbR.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $a3b5a93a68cc46b9$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
var $a3b5a93a68cc46b9$export$2e2bcd8739ae039 = $a3b5a93a68cc46b9$var$TableBody;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $7Etkp = parcelRequire("7Etkp");

var $5wtOU = parcelRequire("5wtOU");

var $1T1QG = parcelRequire("1T1QG");
"use client";
/**
 * @ignore - internal component.
 */ const $0f6394a893d81a39$var$TableContext = /*#__PURE__*/ $1T1QG.createContext();
var $0f6394a893d81a39$export$2e2bcd8739ae039 = $0f6394a893d81a39$var$TableContext;




var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $053cb294932c7b93$export$33a0f07a16a10b1b(slot) {
    return (0, $iNQht.default)("MuiTableCell", slot);
}
const $053cb294932c7b93$var$tableCellClasses = (0, $dfswM.default)("MuiTableCell", [
    "root",
    "head",
    "body",
    "footer",
    "sizeSmall",
    "sizeMedium",
    "paddingCheckbox",
    "paddingNone",
    "alignLeft",
    "alignCenter",
    "alignRight",
    "alignJustify",
    "stickyHeader"
]);
var $053cb294932c7b93$export$2e2bcd8739ae039 = $053cb294932c7b93$var$tableCellClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $e274ae4234486f8c$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $e274ae4234486f8c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            stickyHeader && "stickyHeader",
            align !== "inherit" && `align${(0, $5wtOU.default)(align)}`,
            padding !== "normal" && `padding${(0, $5wtOU.default)(padding)}`,
            `size${(0, $5wtOU.default)(size)}`
        ]
    };
    return (0, $iV85C.default)(slots, (0, $053cb294932c7b93$export$33a0f07a16a10b1b), classes);
};
const $e274ae4234486f8c$var$TableCellRoot = (0, $npagc.default)("td", {
    name: "MuiTableCell",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $5wtOU.default)(ownerState.size)}`],
            ownerState.padding !== "normal" && styles[`padding${(0, $5wtOU.default)(ownerState.padding)}`],
            ownerState.align !== "inherit" && styles[`align${(0, $5wtOU.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({}, theme.typography.body2, {
        display: "table-cell",
        verticalAlign: "inherit",
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === "light" ? (0, $7Etkp.lighten)((0, $7Etkp.alpha)(theme.palette.divider, 1), 0.88) : (0, $7Etkp.darken)((0, $7Etkp.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: "left",
        padding: 16
    }, ownerState.variant === "head" && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === "body" && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === "footer" && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === "small" && {
        padding: "6px 16px",
        [`&.${(0, $053cb294932c7b93$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: "0 12px 0 16px",
            "& > *": {
                padding: 0
            }
        }
    }, ownerState.padding === "checkbox" && {
        width: 48,
        // prevent the checkbox column from growing
        padding: "0 0 0 4px"
    }, ownerState.padding === "none" && {
        padding: 0
    }, ownerState.align === "left" && {
        textAlign: "left"
    }, ownerState.align === "center" && {
        textAlign: "center"
    }, ownerState.align === "right" && {
        textAlign: "right",
        flexDirection: "row-reverse"
    }, ownerState.align === "justify" && {
        textAlign: "justify"
    }, ownerState.stickyHeader && {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $e274ae4234486f8c$var$TableCell = /*#__PURE__*/ $1T1QG.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiTableCell"
    });
    const { align: align = "inherit", className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $iXdVf.default)(props, $e274ae4234486f8c$var$_excluded);
    const table = $1T1QG.useContext((0, $0f6394a893d81a39$export$2e2bcd8739ae039));
    const tablelvl2 = $1T1QG.useContext((0, $80af7f557c9d946c$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === "head";
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? "th" : "td";
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === "td") scope = undefined;
    else if (!scope && isHeadCell) scope = "col";
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $ajTRS.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : "normal"),
        size: sizeProp || (table && table.size ? table.size : "medium"),
        sortDirection: sortDirection,
        stickyHeader: variant === "head" && table && table.stickyHeader,
        variant: variant
    });
    const classes = $e274ae4234486f8c$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
    return /*#__PURE__*/ (0, $3Py8h.jsx)($e274ae4234486f8c$var$TableCellRoot, (0, $ajTRS.default)({
        as: component,
        ref: ref,
        className: (0, $aVXbR.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $e274ae4234486f8c$export$2e2bcd8739ae039 = $e274ae4234486f8c$var$TableCell;


var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");


var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $7951cda7d56bc881$export$2e731cea2d1c2392(slot) {
    return (0, $iNQht.default)("MuiTableHead", slot);
}
const $7951cda7d56bc881$var$tableHeadClasses = (0, $dfswM.default)("MuiTableHead", [
    "root"
]);
var $7951cda7d56bc881$export$2e2bcd8739ae039 = $7951cda7d56bc881$var$tableHeadClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $b52028b37ea87ec4$var$_excluded = [
    "className",
    "component"
];
const $b52028b37ea87ec4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $7951cda7d56bc881$export$2e731cea2d1c2392), classes);
};
const $b52028b37ea87ec4$var$TableHeadRoot = (0, $npagc.default)("thead", {
    name: "MuiTableHead",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-header-group"
});
const $b52028b37ea87ec4$var$tablelvl2 = {
    variant: "head"
};
const $b52028b37ea87ec4$var$defaultComponent = "thead";
const $b52028b37ea87ec4$var$TableHead = /*#__PURE__*/ $1T1QG.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiTableHead"
    });
    const { className: className, component: component = $b52028b37ea87ec4$var$defaultComponent } = props, other = (0, $iXdVf.default)(props, $b52028b37ea87ec4$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        component: component
    });
    const classes = $b52028b37ea87ec4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $80af7f557c9d946c$export$2e2bcd8739ae039).Provider, {
        value: $b52028b37ea87ec4$var$tablelvl2,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($b52028b37ea87ec4$var$TableHeadRoot, (0, $ajTRS.default)({
            as: component,
            className: (0, $aVXbR.default)(classes.root, className),
            ref: ref,
            role: component === $b52028b37ea87ec4$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
var $b52028b37ea87ec4$export$2e2bcd8739ae039 = $b52028b37ea87ec4$var$TableHead;


var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $7Etkp = parcelRequire("7Etkp");


var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $172ceacd6bf44a68$export$ba0a6d6c28940107(slot) {
    return (0, $iNQht.default)("MuiTableRow", slot);
}
const $172ceacd6bf44a68$var$tableRowClasses = (0, $dfswM.default)("MuiTableRow", [
    "root",
    "selected",
    "hover",
    "head",
    "footer"
]);
var $172ceacd6bf44a68$export$2e2bcd8739ae039 = $172ceacd6bf44a68$var$tableRowClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $d09e02ed62af0fe1$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $d09e02ed62af0fe1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            hover && "hover",
            head && "head",
            footer && "footer"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $172ceacd6bf44a68$export$ba0a6d6c28940107), classes);
};
const $d09e02ed62af0fe1$var$TableRowRoot = (0, $npagc.default)("tr", {
    name: "MuiTableRow",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: "inherit",
        display: "table-row",
        verticalAlign: "middle",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $172ceacd6bf44a68$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $172ceacd6bf44a68$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $d09e02ed62af0fe1$var$defaultComponent = "tr";
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $d09e02ed62af0fe1$var$TableRow = /*#__PURE__*/ $1T1QG.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiTableRow"
    });
    const { className: className, component: component = $d09e02ed62af0fe1$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $iXdVf.default)(props, $d09e02ed62af0fe1$var$_excluded);
    const tablelvl2 = $1T1QG.useContext((0, $80af7f557c9d946c$export$2e2bcd8739ae039));
    const ownerState = (0, $ajTRS.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === "head",
        footer: tablelvl2 && tablelvl2.variant === "footer"
    });
    const classes = $d09e02ed62af0fe1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($d09e02ed62af0fe1$var$TableRowRoot, (0, $ajTRS.default)({
        as: component,
        ref: ref,
        className: (0, $aVXbR.default)(classes.root, className),
        role: component === $d09e02ed62af0fe1$var$defaultComponent ? null : "row",
        ownerState: ownerState
    }, other));
});
var $d09e02ed62af0fe1$export$2e2bcd8739ae039 = $d09e02ed62af0fe1$var$TableRow;



var $1T1QG = parcelRequire("1T1QG");





var $4c44ce6df5a4f4fd$var$_client, $4c44ce6df5a4f4fd$var$_currentResult, $4c44ce6df5a4f4fd$var$_currentMutation, $4c44ce6df5a4f4fd$var$_mutateOptions, $4c44ce6df5a4f4fd$var$_updateResult, $4c44ce6df5a4f4fd$var$updateResult_fn, $4c44ce6df5a4f4fd$var$_notify, $4c44ce6df5a4f4fd$var$notify_fn;
var $4c44ce6df5a4f4fd$export$d3c1860ee66f291a = class extends (0, $3797a5406d67bffa$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $783f6097b351748f$export$addf369becd23283)(this, $4c44ce6df5a4f4fd$var$_updateResult);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $4c44ce6df5a4f4fd$var$_notify);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $4c44ce6df5a4f4fd$var$_client, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $4c44ce6df5a4f4fd$var$_currentResult, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $4c44ce6df5a4f4fd$var$_currentMutation, void 0);
        (0, $783f6097b351748f$export$addf369becd23283)(this, $4c44ce6df5a4f4fd$var$_mutateOptions, void 0);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $4c44ce6df5a4f4fd$var$_client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $4c44ce6df5a4f4fd$var$_updateResult, $4c44ce6df5a4f4fd$var$updateResult_fn).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _a;
        const prevOptions = this.options;
        this.options = (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_client).defaultMutationOptions(options);
        if (!(0, $c87861fcdbb7b7dc$export$3e67810a3f0e9f1c)(prevOptions, this.options)) (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_currentMutation),
            observer: this
        });
        if ((prevOptions == null ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, $c87861fcdbb7b7dc$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $c87861fcdbb7b7dc$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else (_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_currentMutation)) == null || _a.setOptions(this.options);
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) (_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_currentMutation)) == null || _a.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $4c44ce6df5a4f4fd$var$_updateResult, $4c44ce6df5a4f4fd$var$updateResult_fn).call(this);
        (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $4c44ce6df5a4f4fd$var$_notify, $4c44ce6df5a4f4fd$var$notify_fn).call(this, action);
    }
    getCurrentResult() {
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_currentResult);
    }
    reset() {
        var _a;
        (_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $4c44ce6df5a4f4fd$var$_currentMutation, void 0);
        (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $4c44ce6df5a4f4fd$var$_updateResult, $4c44ce6df5a4f4fd$var$updateResult_fn).call(this);
        (0, $783f6097b351748f$export$fa92d15b718fce20)(this, $4c44ce6df5a4f4fd$var$_notify, $4c44ce6df5a4f4fd$var$notify_fn).call(this);
    }
    mutate(variables, options) {
        var _a;
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $4c44ce6df5a4f4fd$var$_mutateOptions, options);
        (_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $4c44ce6df5a4f4fd$var$_currentMutation, (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_client).getMutationCache().build((0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_client), this.options));
        (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_currentMutation).addObserver(this);
        return (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_currentMutation).execute(variables);
    }
};
$4c44ce6df5a4f4fd$var$_client = new WeakMap();
$4c44ce6df5a4f4fd$var$_currentResult = new WeakMap();
$4c44ce6df5a4f4fd$var$_currentMutation = new WeakMap();
$4c44ce6df5a4f4fd$var$_mutateOptions = new WeakMap();
$4c44ce6df5a4f4fd$var$_updateResult = new WeakSet();
$4c44ce6df5a4f4fd$var$updateResult_fn = function() {
    var _a;
    const state = ((_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_currentMutation)) == null ? void 0 : _a.state) ?? (0, $1c268a57e7f9e99c$export$a1659b54bac3252a)();
    (0, $783f6097b351748f$export$42432efe6614d3b4)(this, $4c44ce6df5a4f4fd$var$_currentResult, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
};
$4c44ce6df5a4f4fd$var$_notify = new WeakSet();
$4c44ce6df5a4f4fd$var$notify_fn = function(action) {
    (0, $8f286f9abfc2c252$export$520687f44db6e1ab).batch(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_mutateOptions) && this.hasListeners()) {
            const variables = (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_currentResult).variables;
            const context = (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_currentResult).context;
            if ((action == null ? void 0 : action.type) === "success") {
                (_b = (_a = (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_mutateOptions)).onSuccess) == null || _b.call(_a, action.data, variables, context);
                (_d = (_c = (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_mutateOptions)).onSettled) == null || _d.call(_c, action.data, null, variables, context);
            } else if ((action == null ? void 0 : action.type) === "error") {
                (_f = (_e = (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_mutateOptions)).onError) == null || _f.call(_e, action.error, variables, context);
                (_h = (_g = (0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_mutateOptions)).onSettled) == null || _h.call(_g, void 0, action.error, variables, context);
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $783f6097b351748f$export$18a094aefa070634)(this, $4c44ce6df5a4f4fd$var$_currentResult));
        });
    });
};




"use client";
function $65bd1d1c1af02cf0$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)(queryClient);
    const [observer] = $1T1QG.useState(()=>new (0, $4c44ce6df5a4f4fd$export$d3c1860ee66f291a)(client, options));
    $1T1QG.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $1T1QG.useSyncExternalStore($1T1QG.useCallback((onStoreChange)=>observer.subscribe((0, $8f286f9abfc2c252$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $1T1QG.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch($65bd1d1c1af02cf0$var$noop);
    }, [
        observer
    ]);
    if (result.error && (0, $c0dcc8dd94b1fd70$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}
function $65bd1d1c1af02cf0$var$noop() {}


"use strict";
function $21d5b86afa2bb68f$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $15ed691fed91cd59$var$toString } = Object.prototype;
const { getPrototypeOf: $15ed691fed91cd59$var$getPrototypeOf } = Object;
const $15ed691fed91cd59$var$kindOf = ((cache)=>(thing)=>{
        const str = $15ed691fed91cd59$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $15ed691fed91cd59$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$15ed691fed91cd59$var$kindOf(thing) === type;
};
const $15ed691fed91cd59$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $15ed691fed91cd59$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $15ed691fed91cd59$var$isUndefined = $15ed691fed91cd59$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $15ed691fed91cd59$var$isBuffer(val) {
    return val !== null && !$15ed691fed91cd59$var$isUndefined(val) && val.constructor !== null && !$15ed691fed91cd59$var$isUndefined(val.constructor) && $15ed691fed91cd59$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $15ed691fed91cd59$var$isArrayBuffer = $15ed691fed91cd59$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $15ed691fed91cd59$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $15ed691fed91cd59$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $15ed691fed91cd59$var$isString = $15ed691fed91cd59$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $15ed691fed91cd59$var$isFunction = $15ed691fed91cd59$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $15ed691fed91cd59$var$isNumber = $15ed691fed91cd59$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $15ed691fed91cd59$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $15ed691fed91cd59$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $15ed691fed91cd59$var$isPlainObject = (val)=>{
    if ($15ed691fed91cd59$var$kindOf(val) !== "object") return false;
    const prototype = $15ed691fed91cd59$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $15ed691fed91cd59$var$isDate = $15ed691fed91cd59$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $15ed691fed91cd59$var$isFile = $15ed691fed91cd59$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $15ed691fed91cd59$var$isBlob = $15ed691fed91cd59$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $15ed691fed91cd59$var$isFileList = $15ed691fed91cd59$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $15ed691fed91cd59$var$isStream = (val)=>$15ed691fed91cd59$var$isObject(val) && $15ed691fed91cd59$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $15ed691fed91cd59$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $15ed691fed91cd59$var$isFunction(thing.append) && ((kind = $15ed691fed91cd59$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $15ed691fed91cd59$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $15ed691fed91cd59$var$isURLSearchParams = $15ed691fed91cd59$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $15ed691fed91cd59$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $15ed691fed91cd59$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($15ed691fed91cd59$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $15ed691fed91cd59$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $15ed691fed91cd59$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $15ed691fed91cd59$var$isContextDefined = (context)=>!$15ed691fed91cd59$var$isUndefined(context) && context !== $15ed691fed91cd59$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $15ed691fed91cd59$var$merge() {
    const { caseless: caseless } = $15ed691fed91cd59$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $15ed691fed91cd59$var$findKey(result, key) || key;
        if ($15ed691fed91cd59$var$isPlainObject(result[targetKey]) && $15ed691fed91cd59$var$isPlainObject(val)) result[targetKey] = $15ed691fed91cd59$var$merge(result[targetKey], val);
        else if ($15ed691fed91cd59$var$isPlainObject(val)) result[targetKey] = $15ed691fed91cd59$var$merge({}, val);
        else if ($15ed691fed91cd59$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $15ed691fed91cd59$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $15ed691fed91cd59$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $15ed691fed91cd59$var$forEach(b, (val, key)=>{
        if (thisArg && $15ed691fed91cd59$var$isFunction(val)) a[key] = (0, $21d5b86afa2bb68f$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $15ed691fed91cd59$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $15ed691fed91cd59$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $15ed691fed91cd59$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $15ed691fed91cd59$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $15ed691fed91cd59$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $15ed691fed91cd59$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($15ed691fed91cd59$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$15ed691fed91cd59$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $15ed691fed91cd59$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $15ed691fed91cd59$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $15ed691fed91cd59$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $15ed691fed91cd59$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $15ed691fed91cd59$var$isHTMLForm = $15ed691fed91cd59$var$kindOfTest("HTMLFormElement");
const $15ed691fed91cd59$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $15ed691fed91cd59$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $15ed691fed91cd59$var$isRegExp = $15ed691fed91cd59$var$kindOfTest("RegExp");
const $15ed691fed91cd59$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $15ed691fed91cd59$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $15ed691fed91cd59$var$freezeMethods = (obj)=>{
    $15ed691fed91cd59$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($15ed691fed91cd59$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$15ed691fed91cd59$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $15ed691fed91cd59$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $15ed691fed91cd59$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $15ed691fed91cd59$var$noop = ()=>{};
const $15ed691fed91cd59$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $15ed691fed91cd59$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $15ed691fed91cd59$var$DIGIT = "0123456789";
const $15ed691fed91cd59$var$ALPHABET = {
    DIGIT: $15ed691fed91cd59$var$DIGIT,
    ALPHA: $15ed691fed91cd59$var$ALPHA,
    ALPHA_DIGIT: $15ed691fed91cd59$var$ALPHA + $15ed691fed91cd59$var$ALPHA.toUpperCase() + $15ed691fed91cd59$var$DIGIT
};
const $15ed691fed91cd59$var$generateString = (size = 16, alphabet = $15ed691fed91cd59$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $15ed691fed91cd59$var$isSpecCompliantForm(thing) {
    return !!(thing && $15ed691fed91cd59$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $15ed691fed91cd59$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($15ed691fed91cd59$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $15ed691fed91cd59$var$isArray(source) ? [] : {};
                $15ed691fed91cd59$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$15ed691fed91cd59$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $15ed691fed91cd59$var$isAsyncFn = $15ed691fed91cd59$var$kindOfTest("AsyncFunction");
const $15ed691fed91cd59$var$isThenable = (thing)=>thing && ($15ed691fed91cd59$var$isObject(thing) || $15ed691fed91cd59$var$isFunction(thing)) && $15ed691fed91cd59$var$isFunction(thing.then) && $15ed691fed91cd59$var$isFunction(thing.catch);
var $15ed691fed91cd59$export$2e2bcd8739ae039 = {
    isArray: $15ed691fed91cd59$var$isArray,
    isArrayBuffer: $15ed691fed91cd59$var$isArrayBuffer,
    isBuffer: $15ed691fed91cd59$var$isBuffer,
    isFormData: $15ed691fed91cd59$var$isFormData,
    isArrayBufferView: $15ed691fed91cd59$var$isArrayBufferView,
    isString: $15ed691fed91cd59$var$isString,
    isNumber: $15ed691fed91cd59$var$isNumber,
    isBoolean: $15ed691fed91cd59$var$isBoolean,
    isObject: $15ed691fed91cd59$var$isObject,
    isPlainObject: $15ed691fed91cd59$var$isPlainObject,
    isUndefined: $15ed691fed91cd59$var$isUndefined,
    isDate: $15ed691fed91cd59$var$isDate,
    isFile: $15ed691fed91cd59$var$isFile,
    isBlob: $15ed691fed91cd59$var$isBlob,
    isRegExp: $15ed691fed91cd59$var$isRegExp,
    isFunction: $15ed691fed91cd59$var$isFunction,
    isStream: $15ed691fed91cd59$var$isStream,
    isURLSearchParams: $15ed691fed91cd59$var$isURLSearchParams,
    isTypedArray: $15ed691fed91cd59$var$isTypedArray,
    isFileList: $15ed691fed91cd59$var$isFileList,
    forEach: $15ed691fed91cd59$var$forEach,
    merge: $15ed691fed91cd59$var$merge,
    extend: $15ed691fed91cd59$var$extend,
    trim: $15ed691fed91cd59$var$trim,
    stripBOM: $15ed691fed91cd59$var$stripBOM,
    inherits: $15ed691fed91cd59$var$inherits,
    toFlatObject: $15ed691fed91cd59$var$toFlatObject,
    kindOf: $15ed691fed91cd59$var$kindOf,
    kindOfTest: $15ed691fed91cd59$var$kindOfTest,
    endsWith: $15ed691fed91cd59$var$endsWith,
    toArray: $15ed691fed91cd59$var$toArray,
    forEachEntry: $15ed691fed91cd59$var$forEachEntry,
    matchAll: $15ed691fed91cd59$var$matchAll,
    isHTMLForm: $15ed691fed91cd59$var$isHTMLForm,
    hasOwnProperty: $15ed691fed91cd59$var$hasOwnProperty,
    hasOwnProp: $15ed691fed91cd59$var$hasOwnProperty,
    reduceDescriptors: $15ed691fed91cd59$var$reduceDescriptors,
    freezeMethods: $15ed691fed91cd59$var$freezeMethods,
    toObjectSet: $15ed691fed91cd59$var$toObjectSet,
    toCamelCase: $15ed691fed91cd59$var$toCamelCase,
    noop: $15ed691fed91cd59$var$noop,
    toFiniteNumber: $15ed691fed91cd59$var$toFiniteNumber,
    findKey: $15ed691fed91cd59$var$findKey,
    global: $15ed691fed91cd59$var$_global,
    isContextDefined: $15ed691fed91cd59$var$isContextDefined,
    ALPHABET: $15ed691fed91cd59$var$ALPHABET,
    generateString: $15ed691fed91cd59$var$generateString,
    isSpecCompliantForm: $15ed691fed91cd59$var$isSpecCompliantForm,
    toJSONObject: $15ed691fed91cd59$var$toJSONObject,
    isAsyncFn: $15ed691fed91cd59$var$isAsyncFn,
    isThenable: $15ed691fed91cd59$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $5af1d0b2b502f45f$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $15ed691fed91cd59$export$2e2bcd8739ae039).inherits($5af1d0b2b502f45f$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $15ed691fed91cd59$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $5af1d0b2b502f45f$var$prototype = $5af1d0b2b502f45f$var$AxiosError.prototype;
const $5af1d0b2b502f45f$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $5af1d0b2b502f45f$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($5af1d0b2b502f45f$var$AxiosError, $5af1d0b2b502f45f$var$descriptors);
Object.defineProperty($5af1d0b2b502f45f$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$5af1d0b2b502f45f$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($5af1d0b2b502f45f$var$prototype);
    (0, $15ed691fed91cd59$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $5af1d0b2b502f45f$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $5af1d0b2b502f45f$export$2e2bcd8739ae039 = $5af1d0b2b502f45f$var$AxiosError;


// eslint-disable-next-line strict
var $708aa95d7793048e$export$2e2bcd8739ae039 = null;



var $cjtBX = parcelRequire("cjtBX");
var $02e0e79fb0188e9b$require$Buffer = $cjtBX.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $02e0e79fb0188e9b$var$isVisitable(thing) {
    return (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $02e0e79fb0188e9b$var$removeBrackets(key) {
    return (0, $15ed691fed91cd59$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $02e0e79fb0188e9b$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $02e0e79fb0188e9b$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $02e0e79fb0188e9b$var$isFlatArray(arr) {
    return (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isArray(arr) && !arr.some($02e0e79fb0188e9b$var$isVisitable);
}
const $02e0e79fb0188e9b$var$predicates = (0, $15ed691fed91cd59$export$2e2bcd8739ae039).toFlatObject((0, $15ed691fed91cd59$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $02e0e79fb0188e9b$var$toFormData(obj, formData, options) {
    if (!(0, $15ed691fed91cd59$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $708aa95d7793048e$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $15ed691fed91cd59$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $15ed691fed91cd59$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $15ed691fed91cd59$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $02e0e79fb0188e9b$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isArray(value) && $02e0e79fb0188e9b$var$isFlatArray(value) || ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isFileList(value) || (0, $15ed691fed91cd59$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $15ed691fed91cd59$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $02e0e79fb0188e9b$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $02e0e79fb0188e9b$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($02e0e79fb0188e9b$var$isVisitable(value)) return true;
        formData.append($02e0e79fb0188e9b$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($02e0e79fb0188e9b$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $02e0e79fb0188e9b$var$isVisitable
    });
    function build(value, path) {
        if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $15ed691fed91cd59$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $15ed691fed91cd59$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $02e0e79fb0188e9b$export$2e2bcd8739ae039 = $02e0e79fb0188e9b$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $b0cf34c18b725d1a$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $b0cf34c18b725d1a$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $02e0e79fb0188e9b$export$2e2bcd8739ae039)(params, this, options);
}
const $b0cf34c18b725d1a$var$prototype = $b0cf34c18b725d1a$var$AxiosURLSearchParams.prototype;
$b0cf34c18b725d1a$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$b0cf34c18b725d1a$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $b0cf34c18b725d1a$var$encode);
    } : $b0cf34c18b725d1a$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $b0cf34c18b725d1a$export$2e2bcd8739ae039 = $b0cf34c18b725d1a$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $957f977469375726$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $957f977469375726$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $957f977469375726$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $b0cf34c18b725d1a$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $b5190cccaa3732a7$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $15ed691fed91cd59$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $b5190cccaa3732a7$export$2e2bcd8739ae039 = $b5190cccaa3732a7$var$InterceptorManager;





"use strict";
var $4551bc1747f78773$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $973bd039cacee297$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $b0cf34c18b725d1a$export$2e2bcd8739ae039);


"use strict";
var $0ec8a7e7eddf9dff$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $783ed3a4607b4d7e$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $ef1f32ac2470772c$var$isStandardBrowserEnv = (()=>{
    let product;
    if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
})();
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $ef1f32ac2470772c$var$isStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
var $ef1f32ac2470772c$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $973bd039cacee297$export$2e2bcd8739ae039,
        FormData: $0ec8a7e7eddf9dff$export$2e2bcd8739ae039,
        Blob: $783ed3a4607b4d7e$export$2e2bcd8739ae039
    },
    isStandardBrowserEnv: $ef1f32ac2470772c$var$isStandardBrowserEnv,
    isStandardBrowserWebWorkerEnv: $ef1f32ac2470772c$var$isStandardBrowserWebWorkerEnv,
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


"use strict";
function $fb47145257d41c1b$export$2e2bcd8739ae039(data, options) {
    return (0, $02e0e79fb0188e9b$export$2e2bcd8739ae039)(data, new (0, $ef1f32ac2470772c$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $ef1f32ac2470772c$export$2e2bcd8739ae039).isNode && (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $ed13511675cc55e1$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $15ed691fed91cd59$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $ed13511675cc55e1$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $ed13511675cc55e1$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $15ed691fed91cd59$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $ed13511675cc55e1$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isFormData(formData) && (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $15ed691fed91cd59$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($ed13511675cc55e1$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $ed13511675cc55e1$export$2e2bcd8739ae039 = $ed13511675cc55e1$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $d0e07b96f33367c5$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $15ed691fed91cd59$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $d0e07b96f33367c5$var$defaults = {
    transitional: (0, $4551bc1747f78773$export$2e2bcd8739ae039),
    adapter: (0, $ef1f32ac2470772c$export$2e2bcd8739ae039).isNode ? "http" : "xhr",
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $ed13511675cc55e1$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isBuffer(data) || (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isStream(data) || (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isFile(data) || (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $fb47145257d41c1b$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $02e0e79fb0188e9b$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $d0e07b96f33367c5$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $d0e07b96f33367c5$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039).from(e, (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $ef1f32ac2470772c$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $ef1f32ac2470772c$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $15ed691fed91cd59$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $d0e07b96f33367c5$var$defaults.headers[method] = {};
});
var $d0e07b96f33367c5$export$2e2bcd8739ae039 = $d0e07b96f33367c5$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $faf4b23e3d579e76$var$ignoreDuplicateOf = (0, $15ed691fed91cd59$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $faf4b23e3d579e76$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $faf4b23e3d579e76$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $d441bda08cc533c3$var$$internals = Symbol("internals");
function $d441bda08cc533c3$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $d441bda08cc533c3$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isArray(value) ? value.map($d441bda08cc533c3$var$normalizeValue) : String(value);
}
function $d441bda08cc533c3$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $d441bda08cc533c3$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $d441bda08cc533c3$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $15ed691fed91cd59$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $d441bda08cc533c3$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $d441bda08cc533c3$var$buildAccessors(obj, header) {
    const accessorName = (0, $15ed691fed91cd59$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $d441bda08cc533c3$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $d441bda08cc533c3$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $15ed691fed91cd59$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $d441bda08cc533c3$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $15ed691fed91cd59$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$d441bda08cc533c3$var$isValidHeaderName(header)) setHeaders((0, $faf4b23e3d579e76$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $d441bda08cc533c3$var$normalizeHeader(header);
        if (header) {
            const key = (0, $15ed691fed91cd59$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $d441bda08cc533c3$var$parseTokens(value);
                if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $d441bda08cc533c3$var$normalizeHeader(header);
        if (header) {
            const key = (0, $15ed691fed91cd59$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $d441bda08cc533c3$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $d441bda08cc533c3$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $15ed691fed91cd59$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $d441bda08cc533c3$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $d441bda08cc533c3$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $15ed691fed91cd59$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $15ed691fed91cd59$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $d441bda08cc533c3$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $d441bda08cc533c3$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $d441bda08cc533c3$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $15ed691fed91cd59$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$d441bda08cc533c3$var$$internals] = this[$d441bda08cc533c3$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $d441bda08cc533c3$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $d441bda08cc533c3$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$d441bda08cc533c3$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $15ed691fed91cd59$export$2e2bcd8739ae039).reduceDescriptors($d441bda08cc533c3$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $15ed691fed91cd59$export$2e2bcd8739ae039).freezeMethods($d441bda08cc533c3$var$AxiosHeaders);
var $d441bda08cc533c3$export$2e2bcd8739ae039 = $d441bda08cc533c3$var$AxiosHeaders;


"use strict";
function $c8f23a02e09d78f7$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $d0e07b96f33367c5$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $d441bda08cc533c3$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $15ed691fed91cd59$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $7cafad3148b14853$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $48dd9e2274ecf13a$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $15ed691fed91cd59$export$2e2bcd8739ae039).inherits($48dd9e2274ecf13a$var$CanceledError, (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $48dd9e2274ecf13a$export$2e2bcd8739ae039 = $48dd9e2274ecf13a$var$CanceledError;







"use strict";
function $442a576499de419c$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




"use strict";
var $cb10fc8e48a44dda$export$2e2bcd8739ae039 = (0, $ef1f32ac2470772c$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            const cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isString(path)) cookie.push("path=" + path);
            if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();



"use strict";
function $e15524e1a4cd3e11$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $463cefe7e30fa0e7$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $bc51d722a80510f8$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $e15524e1a4cd3e11$export$2e2bcd8739ae039)(requestedURL)) return (0, $463cefe7e30fa0e7$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $33b073aa7192444d$export$2e2bcd8739ae039 = (0, $ef1f32ac2470772c$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $864dcbe8bd47be95$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $04db150983788c61$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $04db150983788c61$export$2e2bcd8739ae039 = $04db150983788c61$var$speedometer;


"use strict";
function $9aa074a822aa3422$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $04db150983788c61$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $9aa074a822aa3422$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $9aa074a822aa3422$export$2e2bcd8739ae039 = $9aa074a822aa3422$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $d441bda08cc533c3$export$2e2bcd8739ae039).from(config.headers).normalize();
        const responseType = config.responseType;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $ef1f32ac2470772c$export$2e2bcd8739ae039).isStandardBrowserEnv || (0, $ef1f32ac2470772c$export$2e2bcd8739ae039).isStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else requestHeaders.setContentType("multipart/form-data;", false); // mobile/desktop app frameworks
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $bc51d722a80510f8$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $957f977469375726$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $d441bda08cc533c3$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $442a576499de419c$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039)("Request aborted", (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039)("Network Error", (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $4551bc1747f78773$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039).ETIMEDOUT : (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $ef1f32ac2470772c$export$2e2bcd8739ae039).isStandardBrowserEnv) {
            // Add xsrf header
            const xsrfValue = (config.withCredentials || (0, $33b073aa7192444d$export$2e2bcd8739ae039)(fullPath)) && config.xsrfCookieName && (0, $cb10fc8e48a44dda$export$2e2bcd8739ae039).read(config.xsrfCookieName);
            if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $15ed691fed91cd59$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $15ed691fed91cd59$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $9aa074a822aa3422$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $9aa074a822aa3422$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $48dd9e2274ecf13a$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $864dcbe8bd47be95$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $ef1f32ac2470772c$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $27d93b810e68847b$var$knownAdapters = {
    http: (0, $708aa95d7793048e$export$2e2bcd8739ae039),
    xhr: (0, $9aa074a822aa3422$export$2e2bcd8739ae039)
};
(0, $15ed691fed91cd59$export$2e2bcd8739ae039).forEach($27d93b810e68847b$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
var $27d93b810e68847b$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            if (adapter = (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isString(nameOrAdapter) ? $27d93b810e68847b$var$knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter) break;
        }
        if (!adapter) {
            if (adapter === false) throw new (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039)(`Adapter ${nameOrAdapter} is not supported by the environment`, "ERR_NOT_SUPPORT");
            throw new Error((0, $15ed691fed91cd59$export$2e2bcd8739ae039).hasOwnProp($27d93b810e68847b$var$knownAdapters, nameOrAdapter) ? `Adapter '${nameOrAdapter}' is not available in the build` : `Unknown adapter '${nameOrAdapter}'`);
        }
        if (!(0, $15ed691fed91cd59$export$2e2bcd8739ae039).isFunction(adapter)) throw new TypeError("adapter is not a function");
        return adapter;
    },
    adapters: $27d93b810e68847b$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $05adfb2bb4f86b64$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $48dd9e2274ecf13a$export$2e2bcd8739ae039)(null, config);
}
function $05adfb2bb4f86b64$export$2e2bcd8739ae039(config) {
    $05adfb2bb4f86b64$var$throwIfCancellationRequested(config);
    config.headers = (0, $d441bda08cc533c3$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $c8f23a02e09d78f7$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $27d93b810e68847b$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $d0e07b96f33367c5$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $05adfb2bb4f86b64$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $c8f23a02e09d78f7$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $d441bda08cc533c3$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7cafad3148b14853$export$2e2bcd8739ae039)(reason)) {
            $05adfb2bb4f86b64$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $c8f23a02e09d78f7$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $d441bda08cc533c3$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $877ac1d0805ccfe2$var$headersToObject = (thing)=>thing instanceof (0, $d441bda08cc533c3$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $877ac1d0805ccfe2$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isPlainObject(target) && (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $15ed691fed91cd59$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $15ed691fed91cd59$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $15ed691fed91cd59$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $15ed691fed91cd59$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $15ed691fed91cd59$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $15ed691fed91cd59$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $15ed691fed91cd59$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($877ac1d0805ccfe2$var$headersToObject(a), $877ac1d0805ccfe2$var$headersToObject(b), true)
    };
    (0, $15ed691fed91cd59$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $b9f4fd3e383034ac$export$a4ad2735b021c132 = "1.5.0";



"use strict";
const $6fc7f3992cb15a20$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $6fc7f3992cb15a20$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $6fc7f3992cb15a20$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $6fc7f3992cb15a20$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $b9f4fd3e383034ac$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$6fc7f3992cb15a20$var$deprecatedWarnings[opt]) {
            $6fc7f3992cb15a20$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $6fc7f3992cb15a20$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039)("options must be an object", (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $6fc7f3992cb15a20$export$2e2bcd8739ae039 = {
    assertOptions: $6fc7f3992cb15a20$var$assertOptions,
    validators: $6fc7f3992cb15a20$var$validators
};



"use strict";
const $b7951cc539a124eb$var$validators = (0, $6fc7f3992cb15a20$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $b7951cc539a124eb$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $b5190cccaa3732a7$export$2e2bcd8739ae039)(),
            response: new (0, $b5190cccaa3732a7$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $877ac1d0805ccfe2$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $6fc7f3992cb15a20$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $b7951cc539a124eb$var$validators.transitional($b7951cc539a124eb$var$validators.boolean),
            forcedJSONParsing: $b7951cc539a124eb$var$validators.transitional($b7951cc539a124eb$var$validators.boolean),
            clarifyTimeoutError: $b7951cc539a124eb$var$validators.transitional($b7951cc539a124eb$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $6fc7f3992cb15a20$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $b7951cc539a124eb$var$validators.function,
                serialize: $b7951cc539a124eb$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $15ed691fed91cd59$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $15ed691fed91cd59$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $d441bda08cc533c3$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $05adfb2bb4f86b64$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $05adfb2bb4f86b64$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $877ac1d0805ccfe2$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $bc51d722a80510f8$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $957f977469375726$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $15ed691fed91cd59$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $b7951cc539a124eb$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $877ac1d0805ccfe2$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $15ed691fed91cd59$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $877ac1d0805ccfe2$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $b7951cc539a124eb$var$Axios.prototype[method] = generateHTTPMethod();
    $b7951cc539a124eb$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $b7951cc539a124eb$export$2e2bcd8739ae039 = $b7951cc539a124eb$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $ab264d5a435254b9$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $48dd9e2274ecf13a$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $ab264d5a435254b9$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $ab264d5a435254b9$export$2e2bcd8739ae039 = $ab264d5a435254b9$var$CancelToken;






"use strict";
function $52cb636c62844e3b$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $2985abe1176d7b43$export$2e2bcd8739ae039(payload) {
    return (0, $15ed691fed91cd59$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $206291aebab0a43f$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($206291aebab0a43f$var$HttpStatusCode).forEach(([key, value])=>{
    $206291aebab0a43f$var$HttpStatusCode[value] = key;
});
var $206291aebab0a43f$export$2e2bcd8739ae039 = $206291aebab0a43f$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $86c4afe1b01fac23$var$createInstance(defaultConfig) {
    const context = new (0, $b7951cc539a124eb$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $21d5b86afa2bb68f$export$2e2bcd8739ae039)((0, $b7951cc539a124eb$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $15ed691fed91cd59$export$2e2bcd8739ae039).extend(instance, (0, $b7951cc539a124eb$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $15ed691fed91cd59$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $86c4afe1b01fac23$var$createInstance((0, $877ac1d0805ccfe2$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $86c4afe1b01fac23$var$axios = $86c4afe1b01fac23$var$createInstance((0, $d0e07b96f33367c5$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$86c4afe1b01fac23$var$axios.Axios = (0, $b7951cc539a124eb$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$86c4afe1b01fac23$var$axios.CanceledError = (0, $48dd9e2274ecf13a$export$2e2bcd8739ae039);
$86c4afe1b01fac23$var$axios.CancelToken = (0, $ab264d5a435254b9$export$2e2bcd8739ae039);
$86c4afe1b01fac23$var$axios.isCancel = (0, $7cafad3148b14853$export$2e2bcd8739ae039);
$86c4afe1b01fac23$var$axios.VERSION = (0, $b9f4fd3e383034ac$export$a4ad2735b021c132);
$86c4afe1b01fac23$var$axios.toFormData = (0, $02e0e79fb0188e9b$export$2e2bcd8739ae039);
// Expose AxiosError class
$86c4afe1b01fac23$var$axios.AxiosError = (0, $5af1d0b2b502f45f$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$86c4afe1b01fac23$var$axios.Cancel = $86c4afe1b01fac23$var$axios.CanceledError;
// Expose all/spread
$86c4afe1b01fac23$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$86c4afe1b01fac23$var$axios.spread = (0, $52cb636c62844e3b$export$2e2bcd8739ae039);
// Expose isAxiosError
$86c4afe1b01fac23$var$axios.isAxiosError = (0, $2985abe1176d7b43$export$2e2bcd8739ae039);
// Expose mergeConfig
$86c4afe1b01fac23$var$axios.mergeConfig = (0, $877ac1d0805ccfe2$export$2e2bcd8739ae039);
$86c4afe1b01fac23$var$axios.AxiosHeaders = (0, $d441bda08cc533c3$export$2e2bcd8739ae039);
$86c4afe1b01fac23$var$axios.formToJSON = (thing)=>(0, $ed13511675cc55e1$export$2e2bcd8739ae039)((0, $15ed691fed91cd59$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$86c4afe1b01fac23$var$axios.getAdapter = (0, $27d93b810e68847b$export$2e2bcd8739ae039).getAdapter;
$86c4afe1b01fac23$var$axios.HttpStatusCode = (0, $206291aebab0a43f$export$2e2bcd8739ae039);
$86c4afe1b01fac23$var$axios.default = $86c4afe1b01fac23$var$axios;
var // this module should only have a default export
$86c4afe1b01fac23$export$2e2bcd8739ae039 = $86c4afe1b01fac23$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $62d90a6d075f964d$export$1c00760e9e5a4e95, AxiosError: $62d90a6d075f964d$export$c1fbed17c2f6a328, CanceledError: $62d90a6d075f964d$export$1ab0c6b20d94fa14, isCancel: $62d90a6d075f964d$export$3b22524397b493c6, CancelToken: $62d90a6d075f964d$export$fd08e3cb425f0d61, VERSION: $62d90a6d075f964d$export$a4ad2735b021c132, all: $62d90a6d075f964d$export$84bf76cd7afc7469, Cancel: $62d90a6d075f964d$export$848c9b7ead0df967, isAxiosError: $62d90a6d075f964d$export$fbafdbe06a5b5a9a, spread: $62d90a6d075f964d$export$3ae0fd4797ed47c8, toFormData: $62d90a6d075f964d$export$10ae0d317ea97f8b, AxiosHeaders: $62d90a6d075f964d$export$4e7d6ff0f3e6520, HttpStatusCode: $62d90a6d075f964d$export$a972f69c851492b3, formToJSON: $62d90a6d075f964d$export$86d7c59254d6a2c9, getAdapter: $62d90a6d075f964d$export$17ddc20a97d669e2, mergeConfig: $62d90a6d075f964d$export$7ec1ebcfa9d8bd6a } = (0, $86c4afe1b01fac23$export$2e2bcd8739ae039);



// only allow these values for ENVIRONMENT, otherwise abort
const $01207a025fc0a048$var$allowedEnvironmentValues = [
    "development",
    "sales",
    "production"
];
const $01207a025fc0a048$var$rawEnvironment = "development"?.trim().toLowerCase();
if (!$01207a025fc0a048$var$rawEnvironment || !$01207a025fc0a048$var$allowedEnvironmentValues.includes($01207a025fc0a048$var$rawEnvironment || "")) throw new Error(`Invalid environment value: ${"development"}. Must be one of ${$01207a025fc0a048$var$allowedEnvironmentValues.join(", ")}`);
const $01207a025fc0a048$export$be46596bc6608f3b = $01207a025fc0a048$var$rawEnvironment;
const $01207a025fc0a048$export$a743660edcdb697b = $01207a025fc0a048$var$rawEnvironment === "development";
const $01207a025fc0a048$export$c87012121925caf1 = false;
const $01207a025fc0a048$export$51eee90b2075d4e1 = "eu-west-1_Mfqaiqlri";
const $01207a025fc0a048$export$1c5434afbe5b51 = "5rg307931i41dtlrmsrsjk6kj0";
const $01207a025fc0a048$export$c3ee1e672e1e24e7 = "/api";
const $01207a025fc0a048$export$c1914de753539b0b = undefined;
const $01207a025fc0a048$export$6faa4a850bc4d0ce = "https://0ba9119458a5d85d26f53d8463323bbc@o454086.ingest.us.sentry.io/4506970386268160";
const $01207a025fc0a048$export$d2c893bfac1da9a1 = "52ac0243";
const $01207a025fc0a048$export$934e799b0e87def5 = parseFloat("0.2");
const $01207a025fc0a048$var$sentryTracePropagationTargets = undefined?.split(",").map((target)=>{
    return new RegExp(target.trim());
});
const $01207a025fc0a048$export$6229fa3b56a23727 = $01207a025fc0a048$var$sentryTracePropagationTargets;
const $01207a025fc0a048$export$d991ba28bdd15482 = parseFloat("0.0");
const $01207a025fc0a048$export$6d698ff2c1f4a0ca = parseFloat("0.0");
const $01207a025fc0a048$export$e987ec915f285263 = false;



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e869a466bd0889a3$export$39430dfe49142ae = (amplify, options)=>{
    return amplify.Auth.fetchAuthSession(options);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $134e0c98154db662$export$39430dfe49142ae = (options)=>{
    return (0, $e869a466bd0889a3$export$39430dfe49142ae)((0, $623ac757f0e7ef86$export$a3858a9a153cffc7), options);
};

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $1a8aa0bd1b5b8783$export$12d5c695b2213c4a;
(function(AuthValidationErrorCode) {
    AuthValidationErrorCode["EmptySignInUsername"] = "EmptySignInUsername";
    AuthValidationErrorCode["EmptySignInPassword"] = "EmptySignInPassword";
    AuthValidationErrorCode["CustomAuthSignInPassword"] = "CustomAuthSignInPassword";
    AuthValidationErrorCode["EmptySignUpUsername"] = "EmptySignUpUsername";
    AuthValidationErrorCode["EmptySignUpPassword"] = "EmptySignUpPassword";
    AuthValidationErrorCode["EmptyConfirmSignUpUsername"] = "EmptyConfirmSignUpUsername";
    AuthValidationErrorCode["EmptyConfirmSignUpCode"] = "EmptyConfirmSignUpCode";
    AuthValidationErrorCode["EmptyResendSignUpCodeUsername"] = "EmptyresendSignUpCodeUsername";
    AuthValidationErrorCode["EmptyChallengeResponse"] = "EmptyChallengeResponse";
    AuthValidationErrorCode["EmptyConfirmResetPasswordUsername"] = "EmptyConfirmResetPasswordUsername";
    AuthValidationErrorCode["EmptyConfirmResetPasswordNewPassword"] = "EmptyConfirmResetPasswordNewPassword";
    AuthValidationErrorCode["EmptyConfirmResetPasswordConfirmationCode"] = "EmptyConfirmResetPasswordConfirmationCode";
    AuthValidationErrorCode["EmptyResetPasswordUsername"] = "EmptyResetPasswordUsername";
    AuthValidationErrorCode["EmptyVerifyTOTPSetupCode"] = "EmptyVerifyTOTPSetupCode";
    AuthValidationErrorCode["EmptyConfirmUserAttributeCode"] = "EmptyConfirmUserAttributeCode";
    AuthValidationErrorCode["IncorrectMFAMethod"] = "IncorrectMFAMethod";
    AuthValidationErrorCode["EmptyUpdatePassword"] = "EmptyUpdatePassword";
})($1a8aa0bd1b5b8783$export$12d5c695b2213c4a || ($1a8aa0bd1b5b8783$export$12d5c695b2213c4a = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $108fcfdf7ca8fb61$export$195137955146d376 = {
    [(0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyChallengeResponse]: {
        message: "challengeResponse is required to confirmSignIn"
    },
    [(0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyConfirmResetPasswordUsername]: {
        message: "username is required to confirmResetPassword"
    },
    [(0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyConfirmSignUpCode]: {
        message: "code is required to confirmSignUp"
    },
    [(0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyConfirmSignUpUsername]: {
        message: "username is required to confirmSignUp"
    },
    [(0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyConfirmResetPasswordConfirmationCode]: {
        message: "confirmationCode is required to confirmResetPassword"
    },
    [(0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyConfirmResetPasswordNewPassword]: {
        message: "newPassword is required to confirmResetPassword"
    },
    [(0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyResendSignUpCodeUsername]: {
        message: "username is required to confirmSignUp"
    },
    [(0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyResetPasswordUsername]: {
        message: "username is required to resetPassword"
    },
    [(0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptySignInPassword]: {
        message: "password is required to signIn"
    },
    [(0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptySignInUsername]: {
        message: "username is required to signIn"
    },
    [(0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptySignUpPassword]: {
        message: "password is required to signUp"
    },
    [(0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptySignUpUsername]: {
        message: "username is required to signUp"
    },
    [(0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).CustomAuthSignInPassword]: {
        message: "A password is not needed when signing in with CUSTOM_WITHOUT_SRP",
        recoverySuggestion: "Do not include a password in your signIn call."
    },
    [(0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).IncorrectMFAMethod]: {
        message: "Incorrect MFA method was chosen. It should be either SMS or TOTP",
        recoverySuggestion: "Try to pass TOTP or SMS as the challengeResponse"
    },
    [(0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyVerifyTOTPSetupCode]: {
        message: "code is required to verifyTotpSetup"
    },
    [(0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyUpdatePassword]: {
        message: "oldPassword and newPassword are required to changePassword"
    },
    [(0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyConfirmUserAttributeCode]: {
        message: "confirmation code is required to confirmUserAttribute"
    }
};
// TODO: delete this code when the Auth class is removed.
var $108fcfdf7ca8fb61$export$c3070468b9d65120;
(function(AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
    AuthErrorStrings["OAUTH_ERROR"] = "Couldn't finish OAuth flow, check your User Pool HostedUI settings";
})($108fcfdf7ca8fb61$export$c3070468b9d65120 || ($108fcfdf7ca8fb61$export$c3070468b9d65120 = {}));
var $108fcfdf7ca8fb61$export$473ab0b56598aacd;
(function(AuthErrorCodes) {
    AuthErrorCodes["SignInException"] = "SignInException";
    AuthErrorCodes["OAuthSignInError"] = "OAuthSignInException";
})($108fcfdf7ca8fb61$export$473ab0b56598aacd || ($108fcfdf7ca8fb61$export$473ab0b56598aacd = {}));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $a8815436fa0c8e22$export$45936001d12f9b53(assertion, name) {
    const { message: message, recoverySuggestion: recoverySuggestion } = (0, $108fcfdf7ca8fb61$export$195137955146d376)[name];
    if (!assertion) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: name,
        message: message,
        recoverySuggestion: recoverySuggestion
    });
}








// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $e83a7063f99da276$export$d6cd780379f37dae = (action, customUserAgentDetails)=>(0, $168115e008576aa6$export$ede38edb26c0bfdf)({
        category: (0, $46bbfb42d61f6c30$export$3a8840c5b2ecf003).Auth,
        action: action,
        ...customUserAgentDetails
    });


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Updates user's password while authenticated.
 *
 * @param input - The UpdatePasswordInput object.
 * @throws - {@link ChangePasswordException} - Cognito service errors thrown when updating a password.
 * @throws - {@link AuthValidationErrorCode} - Validation errors thrown when oldPassword or newPassword are empty.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $0a4c1c7f2daff579$export$e2853351e15b7895(input) {
    const authConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
    const { oldPassword: oldPassword, newPassword: newPassword } = input;
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!oldPassword, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyUpdatePassword);
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!newPassword, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyUpdatePassword);
    const { tokens: tokens } = await (0, $134e0c98154db662$export$39430dfe49142ae)({
        forceRefresh: false
    });
    (0, $627294a07e5270d4$export$77712ea5882cac9f)(tokens);
    await (0, $c845c6a72bc4ff0c$export$99d837dc30eb1ef7)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).UpdatePassword)
    }, {
        AccessToken: tokens.accessToken.toString(),
        PreviousPassword: oldPassword,
        ProposedPassword: newPassword
    });
}


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $bd95d0a527231987$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */ function AuthenticationDetails(data) {
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
   * @returns {string} the record's username
   */ var _proto = AuthenticationDetails.prototype;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {string} the record's password
   */ ;
    _proto.getPassword = function getPassword() {
        return this.password;
    } /**
   * @returns {Array} the record's validationData
   */ ;
    _proto.getValidationData = function getValidationData() {
        return this.validationData;
    } /**
   * @returns {Array} the record's authParameters
   */ ;
    _proto.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    } /**
   * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
   */ ;
    _proto.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $94050878607e2079$export$a143d493d941bafc;
var $94050878607e2079$export$e4cf37d7f6fb9e0a;
var $94050878607e2079$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $94050878607e2079$export$599f31c3813fae4d;
"use strict";

var $kseYM = parcelRequire("kseYM");

var $3GaZX = parcelRequire("3GaZX");
var $db2e182a2558e1f1$exports = {};
var $db2e182a2558e1f1$var$toString = {}.toString;
$db2e182a2558e1f1$exports = Array.isArray || function(arr) {
    return $db2e182a2558e1f1$var$toString.call(arr) == "[object Array]";
};


$94050878607e2079$export$a143d493d941bafc = $94050878607e2079$var$Buffer;
$94050878607e2079$export$e4cf37d7f6fb9e0a = $94050878607e2079$var$SlowBuffer;
$94050878607e2079$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $94050878607e2079$var$typedArraySupport();
$94050878607e2079$export$599f31c3813fae4d = $94050878607e2079$var$kMaxLength();
function $94050878607e2079$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $94050878607e2079$var$kMaxLength() {
    return $94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $94050878607e2079$var$createBuffer(that, length) {
    if ($94050878607e2079$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $94050878607e2079$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $94050878607e2079$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $94050878607e2079$var$Buffer(arg, encodingOrOffset, length) {
    if (!$94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $94050878607e2079$var$Buffer)) return new $94050878607e2079$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $94050878607e2079$var$allocUnsafe(this, arg);
    }
    return $94050878607e2079$var$from(this, arg, encodingOrOffset, length);
}
$94050878607e2079$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$94050878607e2079$var$Buffer._augment = function(arr) {
    arr.__proto__ = $94050878607e2079$var$Buffer.prototype;
    return arr;
};
function $94050878607e2079$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $94050878607e2079$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $94050878607e2079$var$fromString(that, value, encodingOrOffset);
    return $94050878607e2079$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $94050878607e2079$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $94050878607e2079$var$from(null, value, encodingOrOffset, length);
};
if ($94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $94050878607e2079$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $94050878607e2079$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $94050878607e2079$var$Buffer[Symbol.species] === $94050878607e2079$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($94050878607e2079$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $94050878607e2079$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $94050878607e2079$var$alloc(that, size, fill, encoding) {
    $94050878607e2079$var$assertSize(size);
    if (size <= 0) return $94050878607e2079$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $94050878607e2079$var$createBuffer(that, size).fill(fill, encoding) : $94050878607e2079$var$createBuffer(that, size).fill(fill);
    return $94050878607e2079$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $94050878607e2079$var$Buffer.alloc = function(size, fill, encoding) {
    return $94050878607e2079$var$alloc(null, size, fill, encoding);
};
function $94050878607e2079$var$allocUnsafe(that, size) {
    $94050878607e2079$var$assertSize(size);
    that = $94050878607e2079$var$createBuffer(that, size < 0 ? 0 : $94050878607e2079$var$checked(size) | 0);
    if (!$94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $94050878607e2079$var$Buffer.allocUnsafe = function(size) {
    return $94050878607e2079$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $94050878607e2079$var$Buffer.allocUnsafeSlow = function(size) {
    return $94050878607e2079$var$allocUnsafe(null, size);
};
function $94050878607e2079$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$94050878607e2079$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $94050878607e2079$var$byteLength(string, encoding) | 0;
    that = $94050878607e2079$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $94050878607e2079$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $94050878607e2079$var$checked(array.length) | 0;
    that = $94050878607e2079$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $94050878607e2079$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $94050878607e2079$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $94050878607e2079$var$fromArrayLike(that, array);
    return that;
}
function $94050878607e2079$var$fromObject(that, obj) {
    if ($94050878607e2079$var$Buffer.isBuffer(obj)) {
        var len = $94050878607e2079$var$checked(obj.length) | 0;
        that = $94050878607e2079$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $94050878607e2079$var$isnan(obj.length)) return $94050878607e2079$var$createBuffer(that, 0);
            return $94050878607e2079$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $db2e182a2558e1f1$exports(obj.data)) return $94050878607e2079$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $94050878607e2079$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $94050878607e2079$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $94050878607e2079$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $94050878607e2079$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $94050878607e2079$var$Buffer.alloc(+length);
}
$94050878607e2079$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$94050878607e2079$var$Buffer.compare = function compare(a, b) {
    if (!$94050878607e2079$var$Buffer.isBuffer(a) || !$94050878607e2079$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$94050878607e2079$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$94050878607e2079$var$Buffer.concat = function concat(list, length) {
    if (!$db2e182a2558e1f1$exports(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $94050878607e2079$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $94050878607e2079$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$94050878607e2079$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $94050878607e2079$var$byteLength(string, encoding) {
    if ($94050878607e2079$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $94050878607e2079$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $94050878607e2079$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $94050878607e2079$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$94050878607e2079$var$Buffer.byteLength = $94050878607e2079$var$byteLength;
function $94050878607e2079$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $94050878607e2079$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $94050878607e2079$var$utf8Slice(this, start, end);
        case "ascii":
            return $94050878607e2079$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $94050878607e2079$var$latin1Slice(this, start, end);
        case "base64":
            return $94050878607e2079$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $94050878607e2079$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$94050878607e2079$var$Buffer.prototype._isBuffer = true;
function $94050878607e2079$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$94050878607e2079$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$94050878607e2079$var$swap(this, i, i + 1);
    return this;
};
$94050878607e2079$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $94050878607e2079$var$swap(this, i, i + 3);
        $94050878607e2079$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$94050878607e2079$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $94050878607e2079$var$swap(this, i, i + 7);
        $94050878607e2079$var$swap(this, i + 1, i + 6);
        $94050878607e2079$var$swap(this, i + 2, i + 5);
        $94050878607e2079$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$94050878607e2079$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $94050878607e2079$var$utf8Slice(this, 0, length);
    return $94050878607e2079$var$slowToString.apply(this, arguments);
};
$94050878607e2079$var$Buffer.prototype.equals = function equals(b) {
    if (!$94050878607e2079$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $94050878607e2079$var$Buffer.compare(this, b) === 0;
};
$94050878607e2079$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $94050878607e2079$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$94050878607e2079$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$94050878607e2079$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $94050878607e2079$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $94050878607e2079$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($94050878607e2079$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $94050878607e2079$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $94050878607e2079$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $94050878607e2079$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$94050878607e2079$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$94050878607e2079$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $94050878607e2079$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$94050878607e2079$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $94050878607e2079$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $94050878607e2079$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $94050878607e2079$var$utf8Write(buf, string, offset, length) {
    return $94050878607e2079$var$blitBuffer($94050878607e2079$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $94050878607e2079$var$asciiWrite(buf, string, offset, length) {
    return $94050878607e2079$var$blitBuffer($94050878607e2079$var$asciiToBytes(string), buf, offset, length);
}
function $94050878607e2079$var$latin1Write(buf, string, offset, length) {
    return $94050878607e2079$var$asciiWrite(buf, string, offset, length);
}
function $94050878607e2079$var$base64Write(buf, string, offset, length) {
    return $94050878607e2079$var$blitBuffer($94050878607e2079$var$base64ToBytes(string), buf, offset, length);
}
function $94050878607e2079$var$ucs2Write(buf, string, offset, length) {
    return $94050878607e2079$var$blitBuffer($94050878607e2079$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$94050878607e2079$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $94050878607e2079$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $94050878607e2079$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $94050878607e2079$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $94050878607e2079$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $94050878607e2079$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $94050878607e2079$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$94050878607e2079$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $94050878607e2079$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kseYM.fromByteArray(buf);
    else return $kseYM.fromByteArray(buf.slice(start, end));
}
function $94050878607e2079$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $94050878607e2079$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $94050878607e2079$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $94050878607e2079$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $94050878607e2079$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $94050878607e2079$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $94050878607e2079$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $94050878607e2079$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $94050878607e2079$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $94050878607e2079$var$toHex(buf[i]);
    return out;
}
function $94050878607e2079$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$94050878607e2079$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $94050878607e2079$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $94050878607e2079$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $94050878607e2079$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$94050878607e2079$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$94050878607e2079$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$94050878607e2079$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$94050878607e2079$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$94050878607e2079$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$94050878607e2079$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$94050878607e2079$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$94050878607e2079$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$94050878607e2079$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$94050878607e2079$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$94050878607e2079$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$94050878607e2079$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$94050878607e2079$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$94050878607e2079$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$94050878607e2079$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, 4, this.length);
    return $3GaZX.read(this, offset, true, 23, 4);
};
$94050878607e2079$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, 4, this.length);
    return $3GaZX.read(this, offset, false, 23, 4);
};
$94050878607e2079$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, 8, this.length);
    return $3GaZX.read(this, offset, true, 52, 8);
};
$94050878607e2079$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $94050878607e2079$var$checkOffset(offset, 8, this.length);
    return $3GaZX.read(this, offset, false, 52, 8);
};
function $94050878607e2079$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$94050878607e2079$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$94050878607e2079$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $94050878607e2079$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$94050878607e2079$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $94050878607e2079$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$94050878607e2079$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $94050878607e2079$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $94050878607e2079$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$94050878607e2079$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $94050878607e2079$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $94050878607e2079$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$94050878607e2079$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $94050878607e2079$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $94050878607e2079$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $94050878607e2079$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$94050878607e2079$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $94050878607e2079$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $94050878607e2079$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$94050878607e2079$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $94050878607e2079$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $94050878607e2079$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$94050878607e2079$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $94050878607e2079$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$94050878607e2079$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $94050878607e2079$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$94050878607e2079$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $94050878607e2079$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$94050878607e2079$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $94050878607e2079$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $94050878607e2079$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$94050878607e2079$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $94050878607e2079$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $94050878607e2079$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$94050878607e2079$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $94050878607e2079$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $94050878607e2079$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$94050878607e2079$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $94050878607e2079$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $94050878607e2079$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $94050878607e2079$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $94050878607e2079$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $94050878607e2079$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $3GaZX.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$94050878607e2079$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $94050878607e2079$var$writeFloat(this, value, offset, true, noAssert);
};
$94050878607e2079$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $94050878607e2079$var$writeFloat(this, value, offset, false, noAssert);
};
function $94050878607e2079$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $94050878607e2079$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $3GaZX.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$94050878607e2079$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $94050878607e2079$var$writeDouble(this, value, offset, true, noAssert);
};
$94050878607e2079$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $94050878607e2079$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$94050878607e2079$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$94050878607e2079$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$94050878607e2079$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$94050878607e2079$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $94050878607e2079$var$Buffer.isBuffer(val) ? val : $94050878607e2079$var$utf8ToBytes(new $94050878607e2079$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $94050878607e2079$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $94050878607e2079$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $94050878607e2079$var$stringtrim(str).replace($94050878607e2079$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $94050878607e2079$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $94050878607e2079$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $94050878607e2079$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $94050878607e2079$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $94050878607e2079$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $94050878607e2079$var$base64ToBytes(str) {
    return $kseYM.toByteArray($94050878607e2079$var$base64clean(str));
}
function $94050878607e2079$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $94050878607e2079$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}


var $29efb91e14190404$var$crypto;
// Native crypto from window (Browser)
if (typeof window !== "undefined" && window.crypto) $29efb91e14190404$var$crypto = window.crypto;
// Native (experimental IE 11) crypto from window (Browser)
if (!$29efb91e14190404$var$crypto && typeof window !== "undefined" && window.msCrypto) $29efb91e14190404$var$crypto = window.msCrypto;
// Native crypto from global (NodeJS)
if (!$29efb91e14190404$var$crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) $29efb91e14190404$var$crypto = $parcel$global.crypto;

// Native crypto import via require (NodeJS)
if (!$29efb91e14190404$var$crypto && true) try {
    $29efb91e14190404$var$crypto = (parcelRequire("kEAqK"));
} catch (err) {}
function $29efb91e14190404$export$2e2bcd8739ae039() {
    if ($29efb91e14190404$var$crypto) {
        // Use getRandomValues method (Browser)
        if (typeof $29efb91e14190404$var$crypto.getRandomValues === "function") try {
            return $29efb91e14190404$var$crypto.getRandomValues(new Uint32Array(1))[0];
        } catch (err) {}
        // Use randomBytes method (NodeJS)
        if (typeof $29efb91e14190404$var$crypto.randomBytes === "function") try {
            return $29efb91e14190404$var$crypto.randomBytes(4).readInt32LE();
        } catch (err) {}
    }
    throw new Error("Native crypto module could not be used to get secure random number.");
}


/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $1d5d7e2c2cbb0453$var$hexStringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes;
    // Convert
    var hexChars = [];
    for(var i = 0; i < sigBytes; i++){
        var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
var $1d5d7e2c2cbb0453$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WordArray(words, sigBytes) {
        words = this.words = words || [];
        if (sigBytes != undefined) this.sigBytes = sigBytes;
        else this.sigBytes = words.length * 4;
    }
    var _proto = WordArray.prototype;
    _proto.random = function random(nBytes) {
        var words = [];
        for(var i = 0; i < nBytes; i += 4)words.push((0, $29efb91e14190404$export$2e2bcd8739ae039)());
        return new WordArray(words, nBytes);
    };
    _proto.toString = function toString() {
        return $1d5d7e2c2cbb0453$var$hexStringify(this);
    };
    return WordArray;
}();


var $97f07a059ffc5910$exports = {};
"use strict";
Object.defineProperty($97f07a059ffc5910$exports, "__esModule", {
    value: true
});

var $lMhFs = parcelRequire("lMhFs");

(0, $lMhFs.__exportStar)((parcelRequire("e1j1e")), $97f07a059ffc5910$exports);


// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var $0028df9a1741000e$export$2e2bcd8739ae039 = $0028df9a1741000e$var$BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $0028df9a1741000e$var$BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $0028df9a1741000e$var$nbi() {
    return new $0028df9a1741000e$var$BigInteger(null);
}
// Bits per digit
var $0028df9a1741000e$var$dbits;
// JavaScript engine analysis
var $0028df9a1741000e$var$canary = 0xdeadbeefcafe;
var $0028df9a1741000e$var$j_lm = ($0028df9a1741000e$var$canary & 0xffffff) == 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $0028df9a1741000e$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $0028df9a1741000e$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $0028df9a1741000e$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var $0028df9a1741000e$var$inBrowser = typeof navigator !== "undefined";
if ($0028df9a1741000e$var$inBrowser && $0028df9a1741000e$var$j_lm && navigator.appName == "Microsoft Internet Explorer") {
    $0028df9a1741000e$var$BigInteger.prototype.am = $0028df9a1741000e$var$am2;
    $0028df9a1741000e$var$dbits = 30;
} else if ($0028df9a1741000e$var$inBrowser && $0028df9a1741000e$var$j_lm && navigator.appName != "Netscape") {
    $0028df9a1741000e$var$BigInteger.prototype.am = $0028df9a1741000e$var$am1;
    $0028df9a1741000e$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $0028df9a1741000e$var$BigInteger.prototype.am = $0028df9a1741000e$var$am3;
    $0028df9a1741000e$var$dbits = 28;
}
$0028df9a1741000e$var$BigInteger.prototype.DB = $0028df9a1741000e$var$dbits;
$0028df9a1741000e$var$BigInteger.prototype.DM = (1 << $0028df9a1741000e$var$dbits) - 1;
$0028df9a1741000e$var$BigInteger.prototype.DV = 1 << $0028df9a1741000e$var$dbits;
var $0028df9a1741000e$var$BI_FP = 52;
$0028df9a1741000e$var$BigInteger.prototype.FV = Math.pow(2, $0028df9a1741000e$var$BI_FP);
$0028df9a1741000e$var$BigInteger.prototype.F1 = $0028df9a1741000e$var$BI_FP - $0028df9a1741000e$var$dbits;
$0028df9a1741000e$var$BigInteger.prototype.F2 = 2 * $0028df9a1741000e$var$dbits - $0028df9a1741000e$var$BI_FP;
// Digit conversions
var $0028df9a1741000e$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $0028df9a1741000e$var$BI_RC = new Array();
var $0028df9a1741000e$var$rr, $0028df9a1741000e$var$vv;
$0028df9a1741000e$var$rr = "0".charCodeAt(0);
for($0028df9a1741000e$var$vv = 0; $0028df9a1741000e$var$vv <= 9; ++$0028df9a1741000e$var$vv)$0028df9a1741000e$var$BI_RC[$0028df9a1741000e$var$rr++] = $0028df9a1741000e$var$vv;
$0028df9a1741000e$var$rr = "a".charCodeAt(0);
for($0028df9a1741000e$var$vv = 10; $0028df9a1741000e$var$vv < 36; ++$0028df9a1741000e$var$vv)$0028df9a1741000e$var$BI_RC[$0028df9a1741000e$var$rr++] = $0028df9a1741000e$var$vv;
$0028df9a1741000e$var$rr = "A".charCodeAt(0);
for($0028df9a1741000e$var$vv = 10; $0028df9a1741000e$var$vv < 36; ++$0028df9a1741000e$var$vv)$0028df9a1741000e$var$BI_RC[$0028df9a1741000e$var$rr++] = $0028df9a1741000e$var$vv;
function $0028df9a1741000e$var$int2char(n) {
    return $0028df9a1741000e$var$BI_RM.charAt(n);
}
function $0028df9a1741000e$var$intAt(s, i) {
    var c = $0028df9a1741000e$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $0028df9a1741000e$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $0028df9a1741000e$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $0028df9a1741000e$var$nbv(i) {
    var r = $0028df9a1741000e$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $0028df9a1741000e$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = $0028df9a1741000e$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $0028df9a1741000e$var$BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $0028df9a1741000e$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $0028df9a1741000e$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $0028df9a1741000e$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $0028df9a1741000e$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $0028df9a1741000e$var$bnNegate() {
    var r = $0028df9a1741000e$var$nbi();
    $0028df9a1741000e$var$BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $0028df9a1741000e$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $0028df9a1741000e$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $0028df9a1741000e$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $0028df9a1741000e$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $0028df9a1741000e$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $0028df9a1741000e$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $0028df9a1741000e$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $0028df9a1741000e$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $0028df9a1741000e$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $0028df9a1741000e$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $0028df9a1741000e$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $0028df9a1741000e$var$BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $0028df9a1741000e$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $0028df9a1741000e$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $0028df9a1741000e$var$nbi();
    var y = $0028df9a1741000e$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $0028df9a1741000e$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $0028df9a1741000e$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $0028df9a1741000e$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $0028df9a1741000e$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $0028df9a1741000e$var$BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function $0028df9a1741000e$var$bnMod(a) {
    var r = $0028df9a1741000e$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($0028df9a1741000e$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $0028df9a1741000e$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $0028df9a1741000e$var$bnEquals(a) {
    return this.compareTo(a) == 0;
}
// (protected) r = this + a
function $0028df9a1741000e$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $0028df9a1741000e$var$bnAdd(a) {
    var r = $0028df9a1741000e$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $0028df9a1741000e$var$bnSubtract(a) {
    var r = $0028df9a1741000e$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $0028df9a1741000e$var$bnMultiply(a) {
    var r = $0028df9a1741000e$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $0028df9a1741000e$var$bnDivide(a) {
    var r = $0028df9a1741000e$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $0028df9a1741000e$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $0028df9a1741000e$var$montConvert(x) {
    var r = $0028df9a1741000e$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($0028df9a1741000e$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $0028df9a1741000e$var$montRevert(x) {
    var r = $0028df9a1741000e$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $0028df9a1741000e$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $0028df9a1741000e$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $0028df9a1741000e$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$0028df9a1741000e$var$Montgomery.prototype.convert = $0028df9a1741000e$var$montConvert;
$0028df9a1741000e$var$Montgomery.prototype.revert = $0028df9a1741000e$var$montRevert;
$0028df9a1741000e$var$Montgomery.prototype.reduce = $0028df9a1741000e$var$montReduce;
$0028df9a1741000e$var$Montgomery.prototype.mulTo = $0028df9a1741000e$var$montMulTo;
$0028df9a1741000e$var$Montgomery.prototype.sqrTo = $0028df9a1741000e$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $0028df9a1741000e$var$bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = $0028df9a1741000e$var$nbv(1), z = new $0028df9a1741000e$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $0028df9a1741000e$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $0028df9a1741000e$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $0028df9a1741000e$var$nbi(), t;
    i = $0028df9a1741000e$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$0028df9a1741000e$var$BigInteger.prototype.copyTo = $0028df9a1741000e$var$bnpCopyTo;
$0028df9a1741000e$var$BigInteger.prototype.fromInt = $0028df9a1741000e$var$bnpFromInt;
$0028df9a1741000e$var$BigInteger.prototype.fromString = $0028df9a1741000e$var$bnpFromString;
$0028df9a1741000e$var$BigInteger.prototype.clamp = $0028df9a1741000e$var$bnpClamp;
$0028df9a1741000e$var$BigInteger.prototype.dlShiftTo = $0028df9a1741000e$var$bnpDLShiftTo;
$0028df9a1741000e$var$BigInteger.prototype.drShiftTo = $0028df9a1741000e$var$bnpDRShiftTo;
$0028df9a1741000e$var$BigInteger.prototype.lShiftTo = $0028df9a1741000e$var$bnpLShiftTo;
$0028df9a1741000e$var$BigInteger.prototype.rShiftTo = $0028df9a1741000e$var$bnpRShiftTo;
$0028df9a1741000e$var$BigInteger.prototype.subTo = $0028df9a1741000e$var$bnpSubTo;
$0028df9a1741000e$var$BigInteger.prototype.multiplyTo = $0028df9a1741000e$var$bnpMultiplyTo;
$0028df9a1741000e$var$BigInteger.prototype.squareTo = $0028df9a1741000e$var$bnpSquareTo;
$0028df9a1741000e$var$BigInteger.prototype.divRemTo = $0028df9a1741000e$var$bnpDivRemTo;
$0028df9a1741000e$var$BigInteger.prototype.invDigit = $0028df9a1741000e$var$bnpInvDigit;
$0028df9a1741000e$var$BigInteger.prototype.addTo = $0028df9a1741000e$var$bnpAddTo;
// public
$0028df9a1741000e$var$BigInteger.prototype.toString = $0028df9a1741000e$var$bnToString;
$0028df9a1741000e$var$BigInteger.prototype.negate = $0028df9a1741000e$var$bnNegate;
$0028df9a1741000e$var$BigInteger.prototype.abs = $0028df9a1741000e$var$bnAbs;
$0028df9a1741000e$var$BigInteger.prototype.compareTo = $0028df9a1741000e$var$bnCompareTo;
$0028df9a1741000e$var$BigInteger.prototype.bitLength = $0028df9a1741000e$var$bnBitLength;
$0028df9a1741000e$var$BigInteger.prototype.mod = $0028df9a1741000e$var$bnMod;
$0028df9a1741000e$var$BigInteger.prototype.equals = $0028df9a1741000e$var$bnEquals;
$0028df9a1741000e$var$BigInteger.prototype.add = $0028df9a1741000e$var$bnAdd;
$0028df9a1741000e$var$BigInteger.prototype.subtract = $0028df9a1741000e$var$bnSubtract;
$0028df9a1741000e$var$BigInteger.prototype.multiply = $0028df9a1741000e$var$bnMultiply;
$0028df9a1741000e$var$BigInteger.prototype.divide = $0028df9a1741000e$var$bnDivide;
$0028df9a1741000e$var$BigInteger.prototype.modPow = $0028df9a1741000e$var$bnModPow;
// "constants"
$0028df9a1741000e$var$BigInteger.ZERO = $0028df9a1741000e$var$nbv(0);
$0028df9a1741000e$var$BigInteger.ONE = $0028df9a1741000e$var$nbv(1);


/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */ function $e3dc24fa3d8d26af$var$randomBytes(nBytes) {
    return (0, $94050878607e2079$export$a143d493d941bafc).from(new (0, $1d5d7e2c2cbb0453$export$2e2bcd8739ae039)().random(nBytes).toString(), "hex");
}
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ var $e3dc24fa3d8d26af$var$HEX_MSB_REGEX = /^[89a-f]/i;
var $e3dc24fa3d8d26af$var$initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var $e3dc24fa3d8d26af$var$newPasswordRequiredChallengeUserAttributePrefix = "userAttributes.";
/** @class */ var $e3dc24fa3d8d26af$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */ function AuthenticationHelper(PoolName) {
        this.N = new (0, $0028df9a1741000e$export$2e2bcd8739ae039)($e3dc24fa3d8d26af$var$initN, 16);
        this.g = new (0, $0028df9a1741000e$export$2e2bcd8739ae039)("2", 16);
        this.k = new (0, $0028df9a1741000e$export$2e2bcd8739ae039)(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, $94050878607e2079$export$a143d493d941bafc).from("Caldera Derived Key", "utf8");
        this.poolName = PoolName;
    }
    /**
   * @returns {BigInteger} small A, a random number
   */ var _proto = AuthenticationHelper.prototype;
    _proto.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    } /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */ ;
    _proto.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    } /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */ ;
    _proto.generateRandomSmallA = function generateRandomSmallA() {
        // This will be interpreted as a postive 128-bit integer
        var hexRandom = $e3dc24fa3d8d26af$var$randomBytes(128).toString("hex");
        var randomBigInt = new (0, $0028df9a1741000e$export$2e2bcd8739ae039)(hexRandom, 16);
        // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
        return randomBigInt;
    } /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */ ;
    _proto.generateRandomString = function generateRandomString() {
        return $e3dc24fa3d8d26af$var$randomBytes(40).toString("base64");
    } /**
   * @returns {string} Generated random value included in password hash.
   */ ;
    _proto.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    } /**
   * @returns {string} Generated random value included in devices hash.
   */ ;
    _proto.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    } /**
   * @returns {string} Value used to verify devices.
   */ ;
    _proto.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    } /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */ ;
    _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = $e3dc24fa3d8d26af$var$randomBytes(16).toString("hex");
        // The random hex will be unambiguously represented as a postive integer
        this.SaltToHashDevices = this.padHex(new (0, $0028df9a1741000e$export$2e2bcd8739ae039)(hexRandom, 16));
        this.g.modPow(new (0, $0028df9a1741000e$export$2e2bcd8739ae039)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    } /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */ ;
    _proto.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, $0028df9a1741000e$export$2e2bcd8739ae039).ZERO)) callback(new Error("Illegal paramater. A mod N cannot be 0."), null);
            callback(null, A);
        });
    } /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */ ;
    _proto.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, $0028df9a1741000e$export$2e2bcd8739ae039)(this.UHexHash, 16);
        return finalU;
    } /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hash = function hash(buf) {
        var awsCryptoHash = new (0, $97f07a059ffc5910$exports.Sha256)();
        awsCryptoHash.update(buf);
        var resultFromAWSCrypto = awsCryptoHash.digestSync();
        var hashHex = (0, $94050878607e2079$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("hex");
        return new Array(64 - hashHex.length).join("0") + hashHex;
    } /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */ ;
    _proto.hexHash = function hexHash(hexStr) {
        return this.hash((0, $94050878607e2079$export$a143d493d941bafc).from(hexStr, "hex"));
    } /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */ ;
    _proto.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsBuffer = (0, $94050878607e2079$export$a143d493d941bafc).concat([
            this.infoBits,
            (0, $94050878607e2079$export$a143d493d941bafc).from(String.fromCharCode(1), "utf8")
        ]);
        var awsCryptoHash = new (0, $97f07a059ffc5910$exports.Sha256)(salt);
        awsCryptoHash.update(ikm);
        var resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
        var awsCryptoHashHmac = new (0, $97f07a059ffc5910$exports.Sha256)(resultFromAWSCryptoPrk);
        awsCryptoHashHmac.update(infoBitsBuffer);
        var resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
        var hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
        var currentHex = hashHexFromAWSCrypto.slice(0, 16);
        return currentHex;
    } /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */ ;
    _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, $0028df9a1741000e$export$2e2bcd8739ae039).ZERO)) throw new Error("B cannot be zero.");
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, $0028df9a1741000e$export$2e2bcd8739ae039).ZERO)) throw new Error("U cannot be zero.");
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, $0028df9a1741000e$export$2e2bcd8739ae039)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, $94050878607e2079$export$a143d493d941bafc).from(_this4.padHex(sValue), "hex"), (0, $94050878607e2079$export$a143d493d941bafc).from(_this4.padHex(_this4.UValue), "hex"));
            callback(null, hkdf);
        });
    } /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    } /**
   * Return constant newPasswordRequiredChallengeUserAttributePrefix
   * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
   */ ;
    _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return $e3dc24fa3d8d26af$var$newPasswordRequiredChallengeUserAttributePrefix;
    } /**
   * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
   *
   * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
   * byte array containing the two's-complement representation of a BigInteger. The array contains
   * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
   *
   * Examples showing how ambiguity is avoided by left padding with:
   * 	"00" (for positive values where the most-significant-bit is set)
   *  "FF" (for negative values where the most-significant-bit is set)
   *
   * padHex(bigInteger.fromInt(-236))  === "FF14"
   * padHex(bigInteger.fromInt(20))    === "14"
   *
   * padHex(bigInteger.fromInt(-200))  === "FF38"
   * padHex(bigInteger.fromInt(56))    === "38"
   *
   * padHex(bigInteger.fromInt(-20))   === "EC"
   * padHex(bigInteger.fromInt(236))   === "00EC"
   *
   * padHex(bigInteger.fromInt(-56))   === "C8"
   * padHex(bigInteger.fromInt(200))   === "00C8"
   *
   * @param {BigInteger} bigInt Number to encode.
   * @returns {String} even-length hex string of the two's complement encoding.
   */ ;
    _proto.padHex = function padHex(bigInt) {
        if (!(bigInt instanceof (0, $0028df9a1741000e$export$2e2bcd8739ae039))) throw new Error("Not a BigInteger");
        var isNegative = bigInt.compareTo((0, $0028df9a1741000e$export$2e2bcd8739ae039).ZERO) < 0;
        /* Get a hex string for abs(bigInt) */ var hexStr = bigInt.abs().toString(16);
        /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
        /* Prepend "00" if the most significant bit is set */ hexStr = $e3dc24fa3d8d26af$var$HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;
        if (isNegative) {
            /* Flip the bits of the representation */ var invertedNibbles = hexStr.split("").map(function(x) {
                var invertedNibble = ~parseInt(x, 16) & 0xf;
                return "0123456789ABCDEF".charAt(invertedNibble);
            }).join("");
            /* After flipping the bits, add one to get the 2's complement representation */ var flippedBitsBI = new (0, $0028df9a1741000e$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $0028df9a1741000e$export$2e2bcd8739ae039).ONE);
            hexStr = flippedBitsBI.toString(16);
            /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
        }
        return hexStr;
    };
    return AuthenticationHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 
/** @class */ var $4a42ca6538d7c0ea$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */ function CognitoJwtToken(token) {
        // Assign object
        this.jwtToken = token || "";
        this.payload = this.decodePayload();
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoJwtToken.prototype;
    _proto.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    } /**
   * @returns {int} the token's expiration (exp member).
   */ ;
    _proto.getExpiration = function getExpiration() {
        return this.payload.exp;
    } /**
   * @returns {int} the token's "issued at" (iat member).
   */ ;
    _proto.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    } /**
   * @returns {object} the token's payload.
   */ ;
    _proto.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split(".")[1];
        try {
            return JSON.parse((0, $94050878607e2079$export$a143d493d941bafc).from(payload, "base64").toString("utf8"));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();


function $cf4fee1e094bf6bb$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $cf4fee1e094bf6bb$var$_setPrototypeOf(subClass, superClass);
}
function $cf4fee1e094bf6bb$var$_setPrototypeOf(o, p) {
    $cf4fee1e094bf6bb$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cf4fee1e094bf6bb$var$_setPrototypeOf(o, p);
}
/** @class */ var $cf4fee1e094bf6bb$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $cf4fee1e094bf6bb$var$_inheritsLoose(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, AccessToken = _ref.AccessToken;
        return _CognitoJwtToken.call(this, AccessToken || "") || this;
    }
    return CognitoAccessToken;
}((0, $4a42ca6538d7c0ea$export$2e2bcd8739ae039));



function $fd1d692927779c17$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $fd1d692927779c17$var$_setPrototypeOf(subClass, superClass);
}
function $fd1d692927779c17$var$_setPrototypeOf(o, p) {
    $fd1d692927779c17$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fd1d692927779c17$var$_setPrototypeOf(o, p);
}
/** @class */ var $fd1d692927779c17$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_CognitoJwtToken) {
    $fd1d692927779c17$var$_inheritsLoose(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken;
        return _CognitoJwtToken.call(this, IdToken || "") || this;
    }
    return CognitoIdToken;
}((0, $4a42ca6538d7c0ea$export$2e2bcd8739ae039));


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $f0cd139c23a83ed9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, RefreshToken = _ref.RefreshToken;
        // Assign object
        this.token = RefreshToken || "";
    }
    /**
   * @returns {string} the record's token.
   */ var _proto = CognitoRefreshToken.prototype;
    _proto.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ 

/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ // generated by genversion
var $66a77a6df13a9ed2$export$83d89fbfd8236492 = "5.0.4";


var $94d2c46924dceac1$var$BASE_USER_AGENT = "aws-amplify/" + (0, $66a77a6df13a9ed2$export$83d89fbfd8236492);
var $94d2c46924dceac1$export$2dffd0b5373a4389 = {
    userAgent: $94d2c46924dceac1$var$BASE_USER_AGENT,
    isReactNative: typeof navigator !== "undefined" && navigator.product === "ReactNative"
};
var $94d2c46924dceac1$export$7935961ef7719cb0 = function getUserAgent() {
    return $94d2c46924dceac1$export$2dffd0b5373a4389.userAgent;
};
var /**
 * @deprecated use named import
 */ $94d2c46924dceac1$export$2e2bcd8739ae039 = $94d2c46924dceac1$export$2dffd0b5373a4389;







/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $d63747b74a919731$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */ function CognitoUserSession(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        if (AccessToken == null || IdToken == null) throw new Error("Id token and Access Token must be present.");
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
   * @returns {CognitoIdToken} the session's Id token
   */ var _proto = CognitoUserSession.prototype;
    _proto.getIdToken = function getIdToken() {
        return this.idToken;
    } /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */ ;
    _proto.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    } /**
   * @returns {CognitoAccessToken} the session's access token
   */ ;
    _proto.getAccessToken = function getAccessToken() {
        return this.accessToken;
    } /**
   * @returns {int} the session's clock drift
   */ ;
    _proto.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    } /**
   * @returns {int} the computer's clock drift
   */ ;
    _proto.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    } /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */ ;
    _proto.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $c354a8d8749d4eb9$var$monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $c354a8d8749d4eb9$var$weekNames = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
/** @class */ var $c354a8d8749d4eb9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DateHelper() {}
    var _proto = DateHelper.prototype;
    /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */ _proto.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = $c354a8d8749d4eb9$var$weekNames[now.getUTCDay()];
        var month = $c354a8d8749d4eb9$var$monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear();
        // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ /** @class */ var $d6b6de1f41ceeca7$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */ function CognitoUserAttribute(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, Name = _ref.Name, Value = _ref.Value;
        this.Name = Name || "";
        this.Value = Value || "";
    }
    /**
   * @returns {string} the record's value.
   */ var _proto = CognitoUserAttribute.prototype;
    _proto.getValue = function getValue() {
        return this.Value;
    } /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setValue = function setValue(value) {
        this.Value = value;
        return this;
    } /**
   * @returns {string} the record's name.
   */ ;
    _proto.getName = function getName() {
        return this.Name;
    } /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */ ;
    _proto.setName = function setName(name) {
        this.Name = name;
        return this;
    } /**
   * @returns {string} a string representation of the record.
   */ ;
    _proto.toString = function toString() {
        return JSON.stringify(this);
    } /**
   * @returns {object} a flat object representing the record.
   */ ;
    _proto.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();


/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $36ad5e47383174b3$var$dataMemory = {};
var $36ad5e47383174b3$export$d7392285c701ecf5 = /*#__PURE__*/ function() {
    function MemoryStorage() {}
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ MemoryStorage.setItem = function setItem(key, value) {
        $36ad5e47383174b3$var$dataMemory[key] = value;
        return $36ad5e47383174b3$var$dataMemory[key];
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call($36ad5e47383174b3$var$dataMemory, key) ? $36ad5e47383174b3$var$dataMemory[key] : undefined;
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {boolean} return true
   */ ;
    MemoryStorage.removeItem = function removeItem(key) {
        return delete $36ad5e47383174b3$var$dataMemory[key];
    } /**
   * This is used to clear the storage
   * @returns {string} nothing
   */ ;
    MemoryStorage.clear = function clear() {
        $36ad5e47383174b3$var$dataMemory = {};
        return $36ad5e47383174b3$var$dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var $36ad5e47383174b3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * This is used to get a storage object
   * @returns {object} the storage
   */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.cognito.test-ls", 1);
            this.storageWindow.removeItem("aws.cognito.test-ls");
        } catch (exception) {
            this.storageWindow = $36ad5e47383174b3$export$d7392285c701ecf5;
        }
    }
    /**
   * This is used to return the storage
   * @returns {object} the storage
   */ var _proto = StorageHelper.prototype;
    _proto.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();


/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ var $55c4bc3af10cedfb$var$isNavigatorAvailable = typeof navigator !== "undefined";
var $55c4bc3af10cedfb$var$userAgent = $55c4bc3af10cedfb$var$isNavigatorAvailable ? (0, $94d2c46924dceac1$export$2dffd0b5373a4389).isReactNative ? "react-native" : navigator.userAgent : "nodejs";
/** @class */ var $55c4bc3af10cedfb$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */ function CognitoUser(data) {
        if (data == null || data.Username == null || data.Pool == null) throw new Error("Username and Pool information are required.");
        this.username = data.Username || "";
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = "USER_SRP_AUTH";
        this.storage = data.Storage || new (0, $36ad5e47383174b3$export$2e2bcd8739ae039)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */ var _proto = CognitoUser.prototype;
    _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    } /**
   * @returns {CognitoUserSession} the current session for this user
   */ ;
    _proto.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    } /**
   * @returns {string} the user's username
   */ ;
    _proto.getUsername = function getUsername() {
        return this.username;
    } /**
   * @returns {String} the authentication flow type
   */ ;
    _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    } /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */ ;
    _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    } /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "CUSTOM_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === "CUSTOM_CHALLENGE") {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    } /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === "USER_PASSWORD_AUTH") return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH") return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error("Authentication flow type is invalid."));
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * It calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, $e3dc24fa3d8d26af$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var dateHelper = new (0, $c354a8d8749d4eb9$export$2e2bcd8739ae039)();
        var serverBValue;
        var salt;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === "CUSTOM_AUTH") authParameters.CHALLENGE_NAME = "SRP_A";
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request("InitiateAuth", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
                serverBValue = new (0, $0028df9a1741000e$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                salt = new (0, $0028df9a1741000e$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, $94050878607e2079$export$a143d493d941bafc).concat([
                        (0, $94050878607e2079$export$a143d493d941bafc).from(_this2.pool.getUserPoolName(), "utf8"),
                        (0, $94050878607e2079$export$a143d493d941bafc).from(_this2.username, "utf8"),
                        (0, $94050878607e2079$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $94050878607e2079$export$a143d493d941bafc).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, $97f07a059ffc5910$exports.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, $94050878607e2079$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request("RespondToAuthChallenge", challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === "ResourceNotFoundException" && errChallenge.message.toLowerCase().indexOf("device") !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: "PASSWORD_VERIFIER",
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {AuthenticationDetails} authDetails Contains the authentication data.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */ ;
    _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error("PASSWORD parameter is required"));
            return;
        }
        var authenticationHelper = new (0, $e3dc24fa3d8d26af$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "USER_PASSWORD_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
        // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {object} dataAuthenticate authentication data
   * @param {object} authenticationHelper helper created
   * @param {callback} callback passed on from caller
   * @returns {void}
   */ ;
    _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === "SMS_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === "SELECT_MFA_TYPE") {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === "MFA_SETUP") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === "SOFTWARE_TOKEN_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === "CUSTOM_CHALLENGE") {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === "NEW_PASSWORD_REQUIRED") {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === "DEVICE_SRP_AUTH") {
            this.Session = dataAuthenticate.Session;
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, $94050878607e2079$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                PasswordVerifier: (0, $94050878607e2079$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request("ConfirmDevice", {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: $55c4bc3af10cedfb$var$userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    } /**
   * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
   * Pass the new password with any new user attributes to be updated.
   * User attribute keys must be of format userAttributes.<attribute_name>.
   * @param {string} newPassword new password for this user
   * @param {object} requiredAttributeData map with values for all required attributes
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *         response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error("New password is required."));
        var authenticationHelper = new (0, $e3dc24fa3d8d26af$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: "NEW_PASSWORD_REQUIRED",
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    } /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   * @private
   */ ;
    _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, $e3dc24fa3d8d26af$export$2e2bcd8739ae039)(this.deviceGroupKey);
        var dateHelper = new (0, $c354a8d8749d4eb9$export$2e2bcd8739ae039)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: "DEVICE_SRP_AUTH",
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata,
                Session: _this6.Session
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, $0028df9a1741000e$export$2e2bcd8739ae039)(challengeParameters.SRP_B, 16);
                var salt = new (0, $0028df9a1741000e$export$2e2bcd8739ae039)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var concatBuffer = (0, $94050878607e2079$export$a143d493d941bafc).concat([
                        (0, $94050878607e2079$export$a143d493d941bafc).from(_this6.deviceGroupKey, "utf8"),
                        (0, $94050878607e2079$export$a143d493d941bafc).from(_this6.deviceKey, "utf8"),
                        (0, $94050878607e2079$export$a143d493d941bafc).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $94050878607e2079$export$a143d493d941bafc).from(dateNow, "utf8")
                    ]);
                    var awsCryptoHash = new (0, $97f07a059ffc5910$exports.Sha256)(hkdf);
                    awsCryptoHash.update(concatBuffer);
                    var resultFromAWSCrypto = awsCryptoHash.digestSync();
                    var signatureString = (0, $94050878607e2079$export$a143d493d941bafc).from(resultFromAWSCrypto).toString("base64");
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request("RespondToAuthChallenge", jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    } /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmSignUp", jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
    } /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challenge answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, $e3dc24fa3d8d26af$export$2e2bcd8739ae039)(this.pool.getUserPoolName());
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: "CUSTOM_CHALLENGE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    } /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || "SMS_MFA";
        if (mfaTypeSelection === "SOFTWARE_TOKEN_MFA") challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === "DEVICE_SRP_AUTH") {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, $e3dc24fa3d8d26af$export$2e2bcd8739ae039)(_this8.pool.getUserPoolName());
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, $94050878607e2079$export$a143d493d941bafc).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                    PasswordVerifier: (0, $94050878607e2079$export$a143d493d941bafc).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request("ConfirmDevice", {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: $55c4bc3af10cedfb$var$userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    } /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("ChangePassword", {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: "SMS",
            AttributeName: "phone_number"
        };
        mfaOptions.push(mfaEnabled);
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to enable MFA for itself
   * @param {IMfaSettings} smsMfaSettings the sms mfa settings
   * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("SetUserMFAPreference", {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to disable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to delete itself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, "SUCCESS");
        });
        return undefined;
    } /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        var _this10 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("UpdateUserAttributes", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err, result) {
            if (err) return callback(err, null);
            // update cached user
            return _this10.getUserData(function() {
                return callback(null, "SUCCESS", result);
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, $d6b6de1f41ceeca7$export$2e2bcd8739ae039)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    } /**
   * This was previously used by an authenticated user to get MFAOptions,
   * but no longer returns a meaningful response. Refer to the documentation for
   * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
   * @deprecated
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.createGetUserRequest = function createGetUserRequest() {
        return this.client.promisifyRequest("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        });
    } /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
        var _this11 = this;
        if (options === void 0) options = {};
        // best effort, if not possible
        return new Promise(function(resolve) {
            var refresh = _this11.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this11.refreshSession(refresh, resolve, options.clientMetadata);
            else resolve();
        });
    } /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @param {GetUserDataOptions} params
   * @returns {void}
   */ ;
    _proto.getUserData = function getUserData(callback, params) {
        var _this12 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error("User is not authenticated"), null);
        }
        var userData = this.getUserDataFromCache();
        if (!userData) {
            this.fetchUserData().then(function(data) {
                callback(null, data);
            })["catch"](callback);
            return;
        }
        if (this.isFetchUserDataAndTokenRequired(params)) {
            this.fetchUserData().then(function(data) {
                return _this12.refreshSessionIfPossible(params).then(function() {
                    return data;
                });
            }).then(function(data) {
                return callback(null, data);
            })["catch"](callback);
            return;
        }
        try {
            callback(null, JSON.parse(userData));
            return;
        } catch (err) {
            this.clearCachedUserData();
            callback(err, null);
            return;
        }
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.getUserDataFromCache = function getUserDataFromCache() {
        var userData = this.storage.getItem(this.userDataKey);
        return userData;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
        var _ref = params || {}, _ref$bypassCache = _ref.bypassCache, bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;
        return bypassCache;
    } /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */ ;
    _proto.fetchUserData = function fetchUserData() {
        var _this13 = this;
        return this.createGetUserRequest().then(function(data) {
            _this13.cacheUserData(data);
            return data;
        });
    } /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
        var _this14 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUserAttributes", {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            // update cached user
            return _this14.getUserData(function() {
                return callback(null, "SUCCESS");
            }, {
                bypassCache: true
            });
        });
        return undefined;
    } /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request("ResendConfirmationCode", jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    } /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {GetSessionOptions} options
   * @returns {void}
   */ ;
    _proto.getSession = function getSession(callback, options) {
        if (options === void 0) options = {};
        if (this.username == null) return callback(new Error("Username is null. Cannot retrieve a new session"), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, $fd1d692927779c17$export$2e2bcd8739ae039)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, $cf4fee1e094bf6bb$export$2e2bcd8739ae039)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, $f0cd139c23a83ed9$export$2e2bcd8739ae039)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, $d63747b74a919731$export$2e2bcd8739ae039)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error("Cannot retrieve a new session. Please authenticate."), null);
            this.refreshSession(refreshToken, callback, options.clientMetadata);
        } else callback(new Error("Local storage is missing an ID Token, Please authenticate"), null);
        return undefined;
    } /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this15 = this;
        var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: "REFRESH_TOKEN_AUTH",
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === "NotAuthorizedException") _this15.clearCachedUser();
                return wrappedCallback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, "RefreshToken")) authenticationResult.RefreshToken = refreshToken.getToken();
                _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);
                _this15.cacheTokens();
                return wrappedCallback(null, _this15.signInUserSession);
            }
            return undefined;
        });
    } /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */ ;
    _proto.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    } /**
   * This is to cache user data
   */ ;
    _proto.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    } /**
   * This is to remove cached user data
   */ ;
    _proto.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    _proto.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    } /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */ ;
    _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    } /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */ ;
    _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    } /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    } /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */ ;
    _proto.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    } /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */ ;
    _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, $fd1d692927779c17$export$2e2bcd8739ae039)(authResult);
        var accessToken = new (0, $cf4fee1e094bf6bb$export$2e2bcd8739ae039)(authResult);
        var refreshToken = new (0, $f0cd139c23a83ed9$export$2e2bcd8739ae039)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, $d63747b74a919731$export$2e2bcd8739ae039)(sessionData);
    } /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ForgotPassword", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    } /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmForgotPassword", jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
    } /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetUserAttributeVerificationCode", {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("VerifyUserAttribute", {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */ ;
    _proto.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("ForgetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.forgetDevice = function forgetDevice(callback) {
        var _this16 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this16.deviceKey = null;
                _this16.deviceGroupKey = null;
                _this16.randomPassword = null;
                _this16.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    } /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "not_remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string | null} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */ ;
    _proto.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        var requestParams = {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit
        };
        if (paginationToken) requestParams.PaginationToken = paginationToken;
        this.client.request("ListDevices", requestParams, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    } /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */ ;
    _proto.globalSignOut = function globalSignOut(callback) {
        var _this17 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GlobalSignOut", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this17.clearCachedUser();
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    } /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */ ;
    _proto.signOut = function signOut(revokeTokenCallback) {
        var _this18 = this;
        // If tokens won't be revoked, we just clean the client data.
        if (!revokeTokenCallback || typeof revokeTokenCallback !== "function") {
            this.cleanClientData();
            return;
        }
        this.getSession(function(error, _session) {
            if (error) return revokeTokenCallback(error);
            _this18.revokeTokens(function(err) {
                _this18.cleanClientData();
                revokeTokenCallback(err);
            });
        });
    };
    _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
        if (revokeTokenCallback === void 0) revokeTokenCallback = function revokeTokenCallback() {};
        if (typeof revokeTokenCallback !== "function") throw new Error("Invalid revokeTokenCallback. It should be a function.");
        var tokensToBeRevoked = [];
        if (!this.signInUserSession) {
            var error = new Error("User is not authenticated");
            return revokeTokenCallback(error);
        }
        if (!this.signInUserSession.getAccessToken()) {
            var _error = new Error("No Access token available");
            return revokeTokenCallback(_error);
        }
        var refreshToken = this.signInUserSession.getRefreshToken().getToken();
        var accessToken = this.signInUserSession.getAccessToken();
        if (this.isSessionRevocable(accessToken)) {
            if (refreshToken) return this.revokeToken({
                token: refreshToken,
                callback: revokeTokenCallback
            });
        }
        revokeTokenCallback();
    };
    _proto.isSessionRevocable = function isSessionRevocable(token) {
        if (token && typeof token.decodePayload === "function") try {
            var _token$decodePayload = token.decodePayload(), origin_jti = _token$decodePayload.origin_jti;
            return !!origin_jti;
        } catch (err) {
        // Nothing to do, token doesnt have origin_jti claim
        }
        return false;
    };
    _proto.cleanClientData = function cleanClientData() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    _proto.revokeToken = function revokeToken(_ref2) {
        var token = _ref2.token, callback = _ref2.callback;
        this.client.requestWithRetry("RevokeToken", {
            Token: token,
            ClientId: this.pool.getClientId()
        }, function(err) {
            if (err) return callback(err);
            callback();
        });
    } /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this19 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: "SELECT_MFA_TYPE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this19.Session = data.Session;
            if (answerChallenge === "SMS_MFA") return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
            if (answerChallenge === "SOFTWARE_TOKEN_MFA") return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
            return undefined;
        });
    } /**
   * This returns the user context data for advanced security feature.
   * @returns {string} the user context data from CognitoUserPool
   */ ;
    _proto.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    } /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this20 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("AssociateSoftwareToken", {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this20.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request("AssociateSoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    } /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */ ;
    _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this21 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("VerifySoftwareToken", {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this21.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this21.username;
            var jsonReq = {
                ChallengeName: "MFA_SETUP",
                ClientId: _this21.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this21.Session
            };
            if (_this21.getUserContextData()) jsonReq.UserContextData = _this21.getUserContextData();
            _this21.client.request("RespondToAuthChallenge", jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this21.cacheTokens();
                return callback.onSuccess(_this21.signInUserSession);
            });
            return undefined;
        });
        else this.client.request("VerifySoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();



/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ var $8f790859656140e2$exports = {};


$8f790859656140e2$exports = self.fetch || (self.fetch = (parcelRequire("8xb7C")).default || (parcelRequire("8xb7C")));



var $c16213a8840f68d0$export$c388c654f0be37f3 = {
    None: "0",
    ReactNative: "1"
};
var $c16213a8840f68d0$export$2ef00488675027c = "auth";


// constructor
function $0969c81bf4fe3f0e$var$UserAgent() {}
// public
$0969c81bf4fe3f0e$var$UserAgent.prototype.userAgent = (0, $94d2c46924dceac1$export$7935961ef7719cb0)();
var $0969c81bf4fe3f0e$export$ad34c5a3baecdb02 = function appendToCognitoUserAgent(content) {
    if (!content) return;
    if ($0969c81bf4fe3f0e$var$UserAgent.prototype.userAgent && !$0969c81bf4fe3f0e$var$UserAgent.prototype.userAgent.includes(content)) $0969c81bf4fe3f0e$var$UserAgent.prototype.userAgent = $0969c81bf4fe3f0e$var$UserAgent.prototype.userAgent.concat(" ", content);
    if (!$0969c81bf4fe3f0e$var$UserAgent.prototype.userAgent || $0969c81bf4fe3f0e$var$UserAgent.prototype.userAgent === "") $0969c81bf4fe3f0e$var$UserAgent.prototype.userAgent = content;
};
var $0969c81bf4fe3f0e$export$523857f9fc06cb0d = function addAuthCategoryToCognitoUserAgent() {
    $0969c81bf4fe3f0e$var$UserAgent.category = (0, $c16213a8840f68d0$export$2ef00488675027c);
};
var $0969c81bf4fe3f0e$export$972f94ce7a888cac = function addFrameworkToCognitoUserAgent(framework) {
    $0969c81bf4fe3f0e$var$UserAgent.framework = framework;
};
var $0969c81bf4fe3f0e$export$ede38edb26c0bfdf = function getAmplifyUserAgent(action) {
    var uaCategoryAction = $0969c81bf4fe3f0e$var$UserAgent.category ? " " + $0969c81bf4fe3f0e$var$UserAgent.category : "";
    var uaFramework = $0969c81bf4fe3f0e$var$UserAgent.framework ? " framework/" + $0969c81bf4fe3f0e$var$UserAgent.framework : "";
    var userAgent = "" + $0969c81bf4fe3f0e$var$UserAgent.prototype.userAgent + uaCategoryAction + uaFramework;
    return userAgent;
};
var // class for defining the amzn user-agent
$0969c81bf4fe3f0e$export$2e2bcd8739ae039 = $0969c81bf4fe3f0e$var$UserAgent;


function $3823c57557d2932e$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $3823c57557d2932e$var$_setPrototypeOf(subClass, superClass);
}
function $3823c57557d2932e$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $3823c57557d2932e$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$3823c57557d2932e$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $3823c57557d2932e$var$_construct(Class, arguments, $3823c57557d2932e$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $3823c57557d2932e$var$_setPrototypeOf(Wrapper, Class);
    };
    return $3823c57557d2932e$var$_wrapNativeSuper(Class);
}
function $3823c57557d2932e$var$_construct(Parent, args, Class) {
    if ($3823c57557d2932e$var$_isNativeReflectConstruct()) $3823c57557d2932e$var$_construct = Reflect.construct.bind();
    else $3823c57557d2932e$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $3823c57557d2932e$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $3823c57557d2932e$var$_construct.apply(null, arguments);
}
function $3823c57557d2932e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3823c57557d2932e$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $3823c57557d2932e$var$_setPrototypeOf(o, p) {
    $3823c57557d2932e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3823c57557d2932e$var$_setPrototypeOf(o, p);
}
function $3823c57557d2932e$var$_getPrototypeOf(o) {
    $3823c57557d2932e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3823c57557d2932e$var$_getPrototypeOf(o);
}
var $3823c57557d2932e$var$CognitoError = /*#__PURE__*/ function(_Error) {
    $3823c57557d2932e$var$_inheritsLoose(CognitoError, _Error);
    function CognitoError(message, code, name, statusCode) {
        var _this;
        _this = _Error.call(this, message) || this;
        _this.code = code;
        _this.name = name;
        _this.statusCode = statusCode;
        return _this;
    }
    return CognitoError;
}(/*#__PURE__*/ $3823c57557d2932e$var$_wrapNativeSuper(Error));
/** @class */ var $3823c57557d2932e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */ function Client(region, endpoint, fetchOptions) {
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        var _ref = fetchOptions || {}, credentials = _ref.credentials;
        this.fetchOptions = credentials ? {
            credentials: credentials
        } : {};
    }
    /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */ var _proto = Client.prototype;
    _proto.promisifyRequest = function promisifyRequest(operation, params) {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2.request(operation, params, function(err, data) {
                if (err) reject(new $3823c57557d2932e$var$CognitoError(err.message, err.code, err.name, err.statusCode));
                else resolve(data);
            });
        });
    };
    _proto.requestWithRetry = function requestWithRetry(operation, params, callback) {
        var _this3 = this;
        var MAX_DELAY_IN_MILLIS = 5000;
        $3823c57557d2932e$var$jitteredExponentialRetry(function(p) {
            return new Promise(function(res, rej) {
                _this3.request(operation, p, function(error, result) {
                    if (error) rej(error);
                    else res(result);
                });
            });
        }, [
            params
        ], MAX_DELAY_IN_MILLIS).then(function(result) {
            return callback(null, result);
        })["catch"](function(error) {
            return callback(error);
        });
    } /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @param {function} callback Callback called when a response is returned
   * @returns {void}
   */ ;
    _proto.request = function request(operation, params, callback) {
        var headers = {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target": "AWSCognitoIdentityProviderService." + operation,
            "X-Amz-User-Agent": (0, $0969c81bf4fe3f0e$export$ede38edb26c0bfdf)(),
            "Cache-Control": "no-store"
        };
        var options = Object.assign({}, this.fetchOptions, {
            headers: headers,
            method: "POST",
            mode: "cors",
            body: JSON.stringify(params)
        });
        var response;
        var responseJsonData;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error("Network error");
            throw err;
        }).then(function(resp) {
            return resp.json()["catch"](function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data;
            // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split("#").pop();
            var error = new Error(data.message || data.Message || null);
            error.name = code;
            error.code = code;
            return callback(error);
        })["catch"](function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get("x-amzn-errortype")) try {
                var code = response.headers.get("x-amzn-errortype").split(":")[0];
                var error = new Error(response.status ? response.status.toString() : null);
                error.code = code;
                error.name = code;
                error.statusCode = response.status;
                return callback(error);
            } catch (ex) {
                return callback(err);
            }
            else if (err instanceof Error && err.message === "Network error") err.code = "NetworkError";
            return callback(err);
        });
    };
    return Client;
}();
var $3823c57557d2932e$var$logger = {
    debug: function debug() {
    // Intentionally blank. This package doesn't have logging
    }
};
/**
 * For now, all errors are retryable.
 */ var $3823c57557d2932e$var$NonRetryableError = /*#__PURE__*/ function(_Error2) {
    $3823c57557d2932e$var$_inheritsLoose(NonRetryableError, _Error2);
    function NonRetryableError(message) {
        var _this4;
        _this4 = _Error2.call(this, message) || this;
        _this4.nonRetryable = true;
        return _this4;
    }
    return NonRetryableError;
}(/*#__PURE__*/ $3823c57557d2932e$var$_wrapNativeSuper(Error));
var $3823c57557d2932e$var$isNonRetryableError = function isNonRetryableError(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function $3823c57557d2932e$var$retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
    $3823c57557d2932e$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
    return functionToRetry.apply(void 0, args)["catch"](function(err) {
        $3823c57557d2932e$var$logger.debug("error on " + functionToRetry.name, err);
        if ($3823c57557d2932e$var$isNonRetryableError(err)) {
            $3823c57557d2932e$var$logger.debug(functionToRetry.name + " non retryable error", err);
            throw err;
        }
        var retryIn = delayFn(attempt, args, err);
        $3823c57557d2932e$var$logger.debug(functionToRetry.name + " retrying in " + retryIn + " ms");
        if (retryIn !== false) return new Promise(function(res) {
            return setTimeout(res, retryIn);
        }).then(function() {
            return $3823c57557d2932e$var$retry(functionToRetry, args, delayFn, attempt + 1);
        });
        else throw err;
    });
}
function $3823c57557d2932e$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $3823c57557d2932e$var$MAX_DELAY_MS = 300000;
function $3823c57557d2932e$var$jitteredExponentialRetry(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $3823c57557d2932e$var$MAX_DELAY_MS;
    return $3823c57557d2932e$var$retry(functionToRetry, args, $3823c57557d2932e$var$jitteredBackoff(maxDelayMs));
}




var $bf50b03d5e9cc78c$var$USER_POOL_ID_MAX_LENGTH = 55;
/** @class */ var $bf50b03d5e9cc78c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */ function CognitoUserPool(data, wrapRefreshSessionCallback) {
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, fetchOptions = _ref.fetchOptions, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error("Both UserPoolId and ClientId are required.");
        if (UserPoolId.length > $bf50b03d5e9cc78c$var$USER_POOL_ID_MAX_LENGTH || !/^[\w-]+_[0-9a-zA-Z]+$/.test(UserPoolId)) throw new Error("Invalid UserPoolId format.");
        var region = UserPoolId.split("_")[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, $3823c57557d2932e$export$2e2bcd8739ae039)(region, endpoint, fetchOptions);
        /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, $36ad5e47383174b3$export$2e2bcd8739ae039)().getStorage();
        if (wrapRefreshSessionCallback) this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
    /**
   * @returns {string} the user pool id
   */ var _proto = CognitoUserPool.prototype;
    _proto.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    } /**
   * @returns {string} the user pool name
   */ ;
    _proto.getUserPoolName = function getUserPoolName() {
        return this.getUserPoolId().split("_")[1];
    } /**
   * @returns {string} the client id
   */ ;
    _proto.getClientId = function getClientId() {
        return this.clientId;
    } /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {(AttributeArg[])=} clientMetadata Client metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */ ;
    _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request("SignUp", jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, $55c4bc3af10cedfb$export$2e2bcd8739ae039)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    } /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */ ;
    _proto.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, $55c4bc3af10cedfb$export$2e2bcd8739ae039)(cognitoUser);
        }
        return null;
    } /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/ ;
    _proto.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === "undefined") return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();



var $94373d87f0a21e03$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $94373d87f0a21e03$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});


/** @class */ var $d734eccbb7473b93$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (default: domain of the page
   * 				where the cookie was created, excluding subdomains)
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behavior (default: null)
   */ function CookieStorage(data) {
        if (data === void 0) data = {};
        if (data.domain) this.domain = data.domain;
        if (data.path) this.path = data.path;
        else this.path = "/";
        if (Object.prototype.hasOwnProperty.call(data, "expires")) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, "secure")) this.secure = data.secure;
        else this.secure = true;
        if (Object.prototype.hasOwnProperty.call(data, "sameSite")) {
            if (![
                "strict",
                "lax",
                "none"
            ].includes(data.sameSite)) throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
            if (data.sameSite === "none" && !this.secure) throw new Error("sameSite = None requires the Secure attribute in latest browser versions.");
            this.sameSite = data.sameSite;
        } else this.sameSite = null;
    }
    /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */ var _proto = CookieStorage.prototype;
    _proto.setItem = function setItem(key, value) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        $94373d87f0a21e03$exports.set(key, value, options);
        return $94373d87f0a21e03$exports.get(key);
    } /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */ ;
    _proto.getItem = function getItem(key) {
        return $94373d87f0a21e03$exports.get(key);
    } /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */ ;
    _proto.removeItem = function removeItem(key) {
        var options = {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        };
        if (this.sameSite) options.sameSite = this.sameSite;
        return $94373d87f0a21e03$exports.remove(key, options);
    } /**
   * This is used to clear the storage of optional
   * items that were previously set
   * @returns {} an empty object
   */ ;
    _proto.clear = function clear() {
        var cookies = $94373d87f0a21e03$exports.get();
        var numKeys = Object.keys(cookies).length;
        for(var index = 0; index < numKeys; ++index)this.removeItem(Object.keys(cookies)[index]);
        return {};
    };
    return CookieStorage;
}();








const $52b5c03fcac52569$var$poolData = {
    UserPoolId: (0, $01207a025fc0a048$export$51eee90b2075d4e1),
    ClientId: (0, $01207a025fc0a048$export$1c5434afbe5b51)
};
var $52b5c03fcac52569$export$2e2bcd8739ae039 = new (0, $bf50b03d5e9cc78c$export$2e2bcd8739ae039)($52b5c03fcac52569$var$poolData);


const $5d4b99a1a33ba093$export$ff0725f0ea898f41 = "/v1";
const $5d4b99a1a33ba093$export$662364dbe336d1ec = "/admin/v1";
const $5d4b99a1a33ba093$export$f654b28f82155665 = (admin)=>admin ? $5d4b99a1a33ba093$export$662364dbe336d1ec : $5d4b99a1a33ba093$export$ff0725f0ea898f41;



const $c5bdd8e1d814380c$var$logout = ()=>{
    if (0, $01207a025fc0a048$export$c87012121925caf1) {
        (0, $3b00cda3143fd0d7$export$e8df664d4863167e)();
        return Promise.resolve();
    }
    return new Promise((success, reject)=>{
        const user = (0, $52b5c03fcac52569$export$2e2bcd8739ae039).getCurrentUser();
        if (!user) reject("Failed to get user");
        user?.signOut();
        (0, $3b00cda3143fd0d7$export$e8df664d4863167e)();
        success(true);
    });
};
const $c5bdd8e1d814380c$var$setTokenToInterceptor = (jwtToken)=>{
    (0, $3b00cda3143fd0d7$export$f2561ccb0f636d32)((0, $3b00cda3143fd0d7$export$388e0302ca0d9a41), jwtToken);
};
const $c5bdd8e1d814380c$var$getAuthSession = ()=>{
    return (0, $134e0c98154db662$export$39430dfe49142ae)();
};
const $c5bdd8e1d814380c$var$getJWTToken = (authSession)=>{
    return authSession.tokens?.idToken?.toString();
};
const $c5bdd8e1d814380c$var$getUserGroups = (authSession)=>{
    return authSession.tokens?.accessToken?.payload["cognito:groups"]?.join(",");
};
const $c5bdd8e1d814380c$var$changePassword = (oldPassword, newPassword)=>{
    return (0, $0a4c1c7f2daff579$export$e2853351e15b7895)({
        oldPassword: oldPassword,
        newPassword: newPassword
    });
};
const $c5bdd8e1d814380c$var$devLogin = (email)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${(0, $5d4b99a1a33ba093$export$f654b28f82155665)(false)}/dev/get-token`, {
        params: {
            email: email
        }
    }).then((response)=>response.data.token);
};
const $c5bdd8e1d814380c$var$LoginAPI = {
    logout: $c5bdd8e1d814380c$var$logout,
    setTokenToInterceptor: $c5bdd8e1d814380c$var$setTokenToInterceptor,
    getAuthSession: $c5bdd8e1d814380c$var$getAuthSession,
    getJWTToken: $c5bdd8e1d814380c$var$getJWTToken,
    changePassword: $c5bdd8e1d814380c$var$changePassword,
    getUserGroups: $c5bdd8e1d814380c$var$getUserGroups,
    devLogin: $c5bdd8e1d814380c$var$devLogin
};
var $c5bdd8e1d814380c$export$2e2bcd8739ae039 = $c5bdd8e1d814380c$var$LoginAPI;


let $3b00cda3143fd0d7$var$failedQueue = [];
let $3b00cda3143fd0d7$var$isRefreshing = false;
const $3b00cda3143fd0d7$var$processQueue = (error)=>{
    $3b00cda3143fd0d7$var$failedQueue.forEach((prom)=>{
        if (error) prom.reject(error);
        else prom.resolve();
    });
    $3b00cda3143fd0d7$var$failedQueue = [];
};
const $3b00cda3143fd0d7$var$setJwtToken = (jwtToken)=>{
    sessionStorage.setItem((0, $5ce8806ad70988a5$export$cb43794bb023e720), jwtToken);
    $3b00cda3143fd0d7$export$f2561ccb0f636d32($3b00cda3143fd0d7$export$388e0302ca0d9a41, jwtToken);
};
const $3b00cda3143fd0d7$export$e8df664d4863167e = ()=>{
    sessionStorage.setItem((0, $5ce8806ad70988a5$export$cb43794bb023e720), "");
    sessionStorage.setItem((0, $5ce8806ad70988a5$export$fbb0f21f223dce54), "");
    sessionStorage.setItem((0, $5ce8806ad70988a5$export$ad6b2753bfb86074), "");
    sessionStorage.setItem((0, $5ce8806ad70988a5$export$7590792a37b51514), "");
    sessionStorage.setItem((0, $5ce8806ad70988a5$export$fa52eabe6f966a70), "");
    sessionStorage.setItem((0, $5ce8806ad70988a5$export$85978fd627e990d0), "");
    sessionStorage.setItem((0, $5ce8806ad70988a5$export$464bac997a211baf), "");
};
const $3b00cda3143fd0d7$export$388e0302ca0d9a41 = $3b00cda3143fd0d7$var$createAxiosClient({
    options: {
        baseURL: (0, $01207a025fc0a048$export$c3ee1e672e1e24e7),
        timeout: 300000
    },
    logout: $3b00cda3143fd0d7$export$e8df664d4863167e,
    setJwtToken: $3b00cda3143fd0d7$var$setJwtToken
});
const $3b00cda3143fd0d7$export$f2561ccb0f636d32 = (client, jwtToken)=>{
    client.interceptors.request.clear();
    client.interceptors.request.use((config)=>{
        config.headers.Authorization = "Bearer " + jwtToken;
        return config;
    }, (error)=>{
        return Promise.reject(error);
    });
};
function $3b00cda3143fd0d7$var$createAxiosClient({ options: options, logout: logout, setJwtToken: setJwtToken }) {
    const client = (0, $86c4afe1b01fac23$export$2e2bcd8739ae039).create(options);
    const token = sessionStorage.getItem((0, $5ce8806ad70988a5$export$cb43794bb023e720));
    if (token) client.interceptors.request.use((config)=>{
        config.headers.Authorization = "Bearer " + token;
        return config;
    }, (error)=>{
        return Promise.reject(error);
    });
    client.interceptors.response.use((response)=>{
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    }, (error)=>{
        const originalRequest = error.config;
        // If error, process all the requests in the queue and logout the user.
        const handleError = (error)=>{
            $3b00cda3143fd0d7$var$processQueue(error);
            logout();
            return Promise.reject(error);
        };
        // Refresh token conditions
        if (error.response?.status === 401 && error.response.data.error === "Token is not valid or has expired" && originalRequest?._retry !== true) {
            if ($3b00cda3143fd0d7$var$isRefreshing) return new Promise(function(resolve, reject) {
                $3b00cda3143fd0d7$var$failedQueue.push({
                    resolve: resolve,
                    reject: reject
                });
            }).then(()=>{
                return client(originalRequest);
            }).catch((err)=>{
                return Promise.reject(err);
            });
            $3b00cda3143fd0d7$var$isRefreshing = true;
            originalRequest._retry = true;
            (0, $c5bdd8e1d814380c$export$2e2bcd8739ae039).getAuthSession().then((authSession)=>{
                setJwtToken(authSession.tokens?.idToken?.toString() || "");
                $3b00cda3143fd0d7$var$processQueue(null);
                return client(originalRequest);
            }, handleError).finally(()=>{
                $3b00cda3143fd0d7$var$isRefreshing = false;
            });
        }
        // Refresh token missing or expired => logout user...
        if (error.response?.status === 401 && error.response.data.error === "Token is not valid or has expired") return handleError(error);
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    });
    return client;
}



const $9f8b36004207981d$var$BASE_URL = `invitations`;
const $9f8b36004207981d$var$getUrl = (admin)=>`${(0, $5d4b99a1a33ba093$export$f654b28f82155665)(admin)}/${$9f8b36004207981d$var$BASE_URL}`;
const $9f8b36004207981d$var$createLandlordInvitation = (admin, invitation)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).post($9f8b36004207981d$var$getUrl(admin), invitation);
};
const $9f8b36004207981d$var$createTenantWithCatalogueInvitation = (invitation)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).post($9f8b36004207981d$var$getUrl(false), invitation);
};
const $9f8b36004207981d$var$removeInvitation = (invitationId)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).delete(`${$9f8b36004207981d$var$getUrl(false)}/${invitationId}`);
};
const $9f8b36004207981d$var$getInvitationsByCustomerId = (admin, id, includeUsed = false)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${$9f8b36004207981d$var$getUrl(admin)}`, {
        params: {
            customerId: id,
            includeUsed: includeUsed
        }
    }).then((response)=>response.data);
};
const $9f8b36004207981d$var$getInvitations = (admin, queryParams)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get($9f8b36004207981d$var$getUrl(admin), queryParams ? {
        params: {
            ...queryParams
        }
    } : undefined).then((response)=>response.data);
};
const $9f8b36004207981d$var$getUserInvitations = ()=>(0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${(0, $5d4b99a1a33ba093$export$f654b28f82155665)(false)}/user/invitations`).then((response)=>response.data);
const $9f8b36004207981d$var$InvitationsAPI = {
    createTenantWithCatalogueInvitation: $9f8b36004207981d$var$createTenantWithCatalogueInvitation,
    createLandlordInvitation: $9f8b36004207981d$var$createLandlordInvitation,
    removeInvitation: $9f8b36004207981d$var$removeInvitation,
    getInvitationsByCustomerId: $9f8b36004207981d$var$getInvitationsByCustomerId,
    getInvitations: $9f8b36004207981d$var$getInvitations,
    getUserInvitations: $9f8b36004207981d$var$getUserInvitations
};
var $9f8b36004207981d$export$2e2bcd8739ae039 = $9f8b36004207981d$var$InvitationsAPI;



var $3Py8h = parcelRequire("3Py8h");

var $3Py8h = parcelRequire("3Py8h");
var $1b3410630a0cc241$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $1b3410630a0cc241$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$1b3410630a0cc241$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$1b3410630a0cc241$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$1b3410630a0cc241$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $1b3410630a0cc241$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $1b3410630a0cc241$var$DIGIT_REGEX = /^\d+$/, $1b3410630a0cc241$var$LEAD_DIGIT_REGEX = /^\d/, $1b3410630a0cc241$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $1b3410630a0cc241$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $1b3410630a0cc241$var$MAX_CACHE_SIZE = 512;
var $1b3410630a0cc241$var$pathCache = new $1b3410630a0cc241$var$Cache($1b3410630a0cc241$var$MAX_CACHE_SIZE), $1b3410630a0cc241$var$setCache = new $1b3410630a0cc241$var$Cache($1b3410630a0cc241$var$MAX_CACHE_SIZE), $1b3410630a0cc241$var$getCache = new $1b3410630a0cc241$var$Cache($1b3410630a0cc241$var$MAX_CACHE_SIZE);
var $1b3410630a0cc241$var$config;
$1b3410630a0cc241$exports = {
    Cache: $1b3410630a0cc241$var$Cache,
    split: $1b3410630a0cc241$var$split,
    normalizePath: $1b3410630a0cc241$var$normalizePath,
    setter: function(path) {
        var parts = $1b3410630a0cc241$var$normalizePath(path);
        return $1b3410630a0cc241$var$setCache.get(path) || $1b3410630a0cc241$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $1b3410630a0cc241$var$normalizePath(path);
        return $1b3410630a0cc241$var$getCache.get(path) || $1b3410630a0cc241$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($1b3410630a0cc241$var$isQuoted(part) || $1b3410630a0cc241$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $1b3410630a0cc241$var$forEach(Array.isArray(path) ? path : $1b3410630a0cc241$var$split(path), cb, thisArg);
    }
};
function $1b3410630a0cc241$var$normalizePath(path) {
    return $1b3410630a0cc241$var$pathCache.get(path) || $1b3410630a0cc241$var$pathCache.set(path, $1b3410630a0cc241$var$split(path).map(function(part) {
        return part.replace($1b3410630a0cc241$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $1b3410630a0cc241$var$split(path) {
    return path.match($1b3410630a0cc241$var$SPLIT_REGEX) || [
        ""
    ];
}
function $1b3410630a0cc241$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($1b3410630a0cc241$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $1b3410630a0cc241$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $1b3410630a0cc241$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $1b3410630a0cc241$var$hasLeadingNumber(part) {
    return part.match($1b3410630a0cc241$var$LEAD_DIGIT_REGEX) && !part.match($1b3410630a0cc241$var$DIGIT_REGEX);
}
function $1b3410630a0cc241$var$hasSpecialChars(part) {
    return $1b3410630a0cc241$var$SPEC_CHAR_REGEX.test(part);
}
function $1b3410630a0cc241$var$shouldBeQuoted(part) {
    return !$1b3410630a0cc241$var$isQuoted(part) && ($1b3410630a0cc241$var$hasLeadingNumber(part) || $1b3410630a0cc241$var$hasSpecialChars(part));
}


var $99c126c0f4c279c1$exports = {};
const $99c126c0f4c279c1$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $99c126c0f4c279c1$var$words = (str)=>str.match($99c126c0f4c279c1$var$reWords) || [];
const $99c126c0f4c279c1$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $99c126c0f4c279c1$var$join = (str, d)=>$99c126c0f4c279c1$var$words(str).join(d).toLowerCase();
const $99c126c0f4c279c1$var$camelCase = (str)=>$99c126c0f4c279c1$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, "");
const $99c126c0f4c279c1$var$pascalCase = (str)=>$99c126c0f4c279c1$var$upperFirst($99c126c0f4c279c1$var$camelCase(str));
const $99c126c0f4c279c1$var$snakeCase = (str)=>$99c126c0f4c279c1$var$join(str, "_");
const $99c126c0f4c279c1$var$kebabCase = (str)=>$99c126c0f4c279c1$var$join(str, "-");
const $99c126c0f4c279c1$var$sentenceCase = (str)=>$99c126c0f4c279c1$var$upperFirst($99c126c0f4c279c1$var$join(str, " "));
const $99c126c0f4c279c1$var$titleCase = (str)=>$99c126c0f4c279c1$var$words(str).map($99c126c0f4c279c1$var$upperFirst).join(" ");
$99c126c0f4c279c1$exports = {
    words: $99c126c0f4c279c1$var$words,
    upperFirst: $99c126c0f4c279c1$var$upperFirst,
    camelCase: $99c126c0f4c279c1$var$camelCase,
    pascalCase: $99c126c0f4c279c1$var$pascalCase,
    snakeCase: $99c126c0f4c279c1$var$snakeCase,
    kebabCase: $99c126c0f4c279c1$var$kebabCase,
    sentenceCase: $99c126c0f4c279c1$var$sentenceCase,
    titleCase: $99c126c0f4c279c1$var$titleCase
};


var $ce0d32d78faeeaac$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $ce0d32d78faeeaac$exports = function(edges) {
    return $ce0d32d78faeeaac$var$toposort($ce0d32d78faeeaac$var$uniqueNodes(edges), edges);
};
$ce0d32d78faeeaac$exports.array = $ce0d32d78faeeaac$var$toposort;
function $ce0d32d78faeeaac$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $ce0d32d78faeeaac$var$makeOutgoingEdges(edges), nodesHash = $ce0d32d78faeeaac$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $ce0d32d78faeeaac$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $ce0d32d78faeeaac$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $ce0d32d78faeeaac$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $d7c41ae3ced691f5$var$toString = Object.prototype.toString;
const $d7c41ae3ced691f5$var$errorToString = Error.prototype.toString;
const $d7c41ae3ced691f5$var$regExpToString = RegExp.prototype.toString;
const $d7c41ae3ced691f5$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $d7c41ae3ced691f5$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $d7c41ae3ced691f5$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $d7c41ae3ced691f5$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $d7c41ae3ced691f5$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $d7c41ae3ced691f5$var$symbolToString.call(val).replace($d7c41ae3ced691f5$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $d7c41ae3ced691f5$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $d7c41ae3ced691f5$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $d7c41ae3ced691f5$var$regExpToString.call(val);
    return null;
}
function $d7c41ae3ced691f5$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $d7c41ae3ced691f5$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $d7c41ae3ced691f5$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $d7c41ae3ced691f5$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $d7c41ae3ced691f5$var$_Symbol$toStringTag;
let $d7c41ae3ced691f5$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$d7c41ae3ced691f5$var$_Symbol$toStringTag = Symbol.toStringTag;
class $d7c41ae3ced691f5$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || "this";
        if (path !== params.path) params = Object.assign({}, params, {
            path: path
        });
        if (typeof message === "string") return message.replace($d7c41ae3ced691f5$var$strReg, (_, key)=>$d7c41ae3ced691f5$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this[$d7c41ae3ced691f5$var$_Symbol$toStringTag] = "Error";
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $d7c41ae3ced691f5$var$toArray(errorOrErrors).forEach((err)=>{
            if ($d7c41ae3ced691f5$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (!disableStack && Error.captureStackTrace) Error.captureStackTrace(this, $d7c41ae3ced691f5$export$2191b9da168c6cf0);
    }
}
let $d7c41ae3ced691f5$var$mixed = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    defined: "${path} must be defined",
    notNull: "${path} cannot be null",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$d7c41ae3ced691f5$export$5790025c6e6c2ba6(originalValue, true)}\`).` : ".";
        return type !== "mixed" ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$d7c41ae3ced691f5$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$d7c41ae3ced691f5$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $d7c41ae3ced691f5$var$string = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $d7c41ae3ced691f5$var$number = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $d7c41ae3ced691f5$var$date = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $d7c41ae3ced691f5$var$boolean = {
    isValue: "${path} field must be ${value}"
};
let $d7c41ae3ced691f5$var$object = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let $d7c41ae3ced691f5$var$array = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
let $d7c41ae3ced691f5$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$d7c41ae3ced691f5$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$d7c41ae3ced691f5$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $d7c41ae3ced691f5$export$2191b9da168c6cf0.formatError($d7c41ae3ced691f5$var$mixed.notType, params);
    }
};
var $d7c41ae3ced691f5$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $d7c41ae3ced691f5$var$mixed,
    string: $d7c41ae3ced691f5$var$string,
    number: $d7c41ae3ced691f5$var$number,
    date: $d7c41ae3ced691f5$var$date,
    object: $d7c41ae3ced691f5$var$object,
    array: $d7c41ae3ced691f5$var$array,
    boolean: $d7c41ae3ced691f5$var$boolean,
    tuple: $d7c41ae3ced691f5$var$tuple
});
const $d7c41ae3ced691f5$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $d7c41ae3ced691f5$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        return new $d7c41ae3ced691f5$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$d7c41ae3ced691f5$export$213e2a3e7c4f326e(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
}
const $d7c41ae3ced691f5$var$prefixes = {
    context: "$",
    value: "."
};
function $d7c41ae3ced691f5$export$eff4d24c3ff7876e(key, options) {
    return new $d7c41ae3ced691f5$var$Reference(key, options);
}
class $d7c41ae3ced691f5$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $d7c41ae3ced691f5$var$prefixes.context;
        this.isValue = this.key[0] === $d7c41ae3ced691f5$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $d7c41ae3ced691f5$var$prefixes.context : this.isValue ? $d7c41ae3ced691f5$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $1b3410630a0cc241$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$d7c41ae3ced691f5$var$Reference.prototype.__isYupRef = true;
const $d7c41ae3ced691f5$var$isAbsent = (value)=>value == null;
function $d7c41ae3ced691f5$var$createValidation(config) {
    function validate({ value: value, path: path = "", options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $d7c41ae3ced691f5$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            var _overrides$disableSta;
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $d7c41ae3ced691f5$export$2191b9da168c6cf0($d7c41ae3ced691f5$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, (_overrides$disableSta = overrides.disableStackTrace) != null ? _overrides$disableSta : disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($d7c41ae3ced691f5$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($d7c41ae3ced691f5$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $d7c41ae3ced691f5$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === "function") {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $d7c41ae3ced691f5$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $1b3410630a0cc241$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === "tuple";
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $d7c41ae3ced691f5$export$cfedb76369cc7782(obj, path, value, context) {
    return $d7c41ae3ced691f5$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $d7c41ae3ced691f5$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($d7c41ae3ced691f5$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $d7c41ae3ced691f5$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $d7c41ae3ced691f5$var$clone(src, seen = new Map()) {
    if ($d7c41ae3ced691f5$export$213e2a3e7c4f326e(src) || !src || typeof src !== "object") return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $d7c41ae3ced691f5$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $d7c41ae3ced691f5$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($d7c41ae3ced691f5$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $d7c41ae3ced691f5$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $d7c41ae3ced691f5$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $d7c41ae3ced691f5$var$ReferenceSet();
        this._blacklist = new $d7c41ae3ced691f5$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($d7c41ae3ced691f5$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $d7c41ae3ced691f5$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === "ignore-optionality";
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $d7c41ae3ced691f5$var$isAbsent(result)) return result;
            let formattedValue = $d7c41ae3ced691f5$export$5790025c6e6c2ba6(value);
            let formattedResult = $d7c41ae3ced691f5$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError("Must include `key` or `index` for nested validations");
        const isIndex = typeof k === "number";
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? "index" : "key"]: k,
            path: isIndex || k.includes(".") ? `${parentPath || ""}[${value ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : "") + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($d7c41ae3ced691f5$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $d7c41ae3ced691f5$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($d7c41ae3ced691f5$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $d7c41ae3ced691f5$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($d7c41ae3ced691f5$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($d7c41ae3ced691f5$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this, options) : $d7c41ae3ced691f5$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $d7c41ae3ced691f5$var$createValidation({
            message: message,
            name: "nullable",
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $d7c41ae3ced691f5$var$createValidation({
            message: message,
            name: "optionality",
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $d7c41ae3ced691f5$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $d7c41ae3ced691f5$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $d7c41ae3ced691f5$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $d7c41ae3ced691f5$var$mixed.default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = $d7c41ae3ced691f5$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = $d7c41ae3ced691f5$var$toArray(keys).map((key)=>new $d7c41ae3ced691f5$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === "function" ? new $d7c41ae3ced691f5$var$Condition(deps, options) : $d7c41ae3ced691f5$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $d7c41ae3ced691f5$var$createValidation({
            message: message,
            name: "typeError",
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $d7c41ae3ced691f5$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $d7c41ae3ced691f5$var$createValidation({
            message: message,
            name: "oneOf",
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $d7c41ae3ced691f5$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $d7c41ae3ced691f5$var$createValidation({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
}
// @ts-expect-error
$d7c41ae3ced691f5$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$d7c41ae3ced691f5$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $d7c41ae3ced691f5$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$d7c41ae3ced691f5$export$19342e026b58ebb7.prototype[alias] = $d7c41ae3ced691f5$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$d7c41ae3ced691f5$export$19342e026b58ebb7.prototype[alias] = $d7c41ae3ced691f5$export$19342e026b58ebb7.prototype.notOneOf;
const $d7c41ae3ced691f5$var$returnsTrue = ()=>true;
function $d7c41ae3ced691f5$export$9b30b6294c1449a8(spec) {
    return new $d7c41ae3ced691f5$export$1e88358c94ddec71(spec);
}
class $d7c41ae3ced691f5$export$1e88358c94ddec71 extends $d7c41ae3ced691f5$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === "function" ? {
            type: "mixed",
            check: spec
        } : Object.assign({
            type: "mixed",
            check: $d7c41ae3ced691f5$var$returnsTrue
        }, spec));
    }
}
$d7c41ae3ced691f5$export$9b30b6294c1449a8.prototype = $d7c41ae3ced691f5$export$1e88358c94ddec71.prototype;
function $d7c41ae3ced691f5$export$87b259aa03e3d267() {
    return new $d7c41ae3ced691f5$export$c7980688f11e1f49();
}
class $d7c41ae3ced691f5$export$c7980688f11e1f49 extends $d7c41ae3ced691f5$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "boolean",
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === "boolean";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $d7c41ae3ced691f5$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return $d7c41ae3ced691f5$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $d7c41ae3ced691f5$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return $d7c41ae3ced691f5$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$d7c41ae3ced691f5$export$87b259aa03e3d267.prototype = $d7c41ae3ced691f5$export$c7980688f11e1f49.prototype;
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $d7c41ae3ced691f5$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $d7c41ae3ced691f5$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $d7c41ae3ced691f5$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $d7c41ae3ced691f5$var$isTrimmed = (value)=>$d7c41ae3ced691f5$var$isAbsent(value) || value === value.trim();
let $d7c41ae3ced691f5$var$objStringTag = ({}).toString();
function $d7c41ae3ced691f5$export$22b082955e083ec3() {
    return new $d7c41ae3ced691f5$export$49bf8b2ede5138eb();
}
class $d7c41ae3ced691f5$export$49bf8b2ede5138eb extends $d7c41ae3ced691f5$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "string",
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === "string";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $d7c41ae3ced691f5$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $d7c41ae3ced691f5$var$mixed.required,
                name: "required",
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== "required");
            return schema;
        });
    }
    length(length, message = $d7c41ae3ced691f5$var$string.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $d7c41ae3ced691f5$var$string.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $d7c41ae3ced691f5$var$string.max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || $d7c41ae3ced691f5$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $d7c41ae3ced691f5$var$string.email) {
        return this.matches($d7c41ae3ced691f5$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $d7c41ae3ced691f5$var$string.url) {
        return this.matches($d7c41ae3ced691f5$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $d7c41ae3ced691f5$var$string.uuid) {
        return this.matches($d7c41ae3ced691f5$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    //-- transforms --
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = $d7c41ae3ced691f5$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $d7c41ae3ced691f5$var$isTrimmed
        });
    }
    lowercase(message = $d7c41ae3ced691f5$var$string.lowercase) {
        return this.transform((value)=>!$d7c41ae3ced691f5$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$d7c41ae3ced691f5$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $d7c41ae3ced691f5$var$string.uppercase) {
        return this.transform((value)=>!$d7c41ae3ced691f5$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$d7c41ae3ced691f5$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$d7c41ae3ced691f5$export$22b082955e083ec3.prototype = $d7c41ae3ced691f5$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $d7c41ae3ced691f5$var$isNaN$1 = (value)=>value != +value;
function $d7c41ae3ced691f5$export$98e628dec113755e() {
    return new $d7c41ae3ced691f5$export$f192ec5e9228ab19();
}
class $d7c41ae3ced691f5$export$f192ec5e9228ab19 extends $d7c41ae3ced691f5$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "number",
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === "number" && !$d7c41ae3ced691f5$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $d7c41ae3ced691f5$var$number.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $d7c41ae3ced691f5$var$number.max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $d7c41ae3ced691f5$var$number.lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $d7c41ae3ced691f5$var$number.moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $d7c41ae3ced691f5$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $d7c41ae3ced691f5$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $d7c41ae3ced691f5$var$number.integer) {
        return this.test({
            name: "integer",
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$d7c41ae3ced691f5$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round";
        // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!$d7c41ae3ced691f5$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$d7c41ae3ced691f5$export$98e628dec113755e.prototype = $d7c41ae3ced691f5$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $d7c41ae3ced691f5$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $d7c41ae3ced691f5$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
function $d7c41ae3ced691f5$var$parseIsoDate(date) {
    const regexResult = $d7c41ae3ced691f5$var$isoReg.exec(date);
    if (!regexResult) return Date.parse ? Date.parse(date) : Number.NaN;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    const struct = {
        year: $d7c41ae3ced691f5$var$toNumber(regexResult[1]),
        month: $d7c41ae3ced691f5$var$toNumber(regexResult[2], 1) - 1,
        day: $d7c41ae3ced691f5$var$toNumber(regexResult[3], 1),
        hour: $d7c41ae3ced691f5$var$toNumber(regexResult[4]),
        minute: $d7c41ae3ced691f5$var$toNumber(regexResult[5]),
        second: $d7c41ae3ced691f5$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $d7c41ae3ced691f5$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $d7c41ae3ced691f5$var$toNumber(regexResult[10]),
        minuteOffset: $d7c41ae3ced691f5$var$toNumber(regexResult[11])
    };
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== "Z" && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === "+") totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
let $d7c41ae3ced691f5$var$invalidDate = new Date("");
let $d7c41ae3ced691f5$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $d7c41ae3ced691f5$export$324d90190a8b822a() {
    return new $d7c41ae3ced691f5$export$18ec3cc5a157503f();
}
class $d7c41ae3ced691f5$export$18ec3cc5a157503f extends $d7c41ae3ced691f5$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "date",
            check (v) {
                return $d7c41ae3ced691f5$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $d7c41ae3ced691f5$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $d7c41ae3ced691f5$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$d7c41ae3ced691f5$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $d7c41ae3ced691f5$var$date.min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $d7c41ae3ced691f5$var$date.max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$d7c41ae3ced691f5$export$18ec3cc5a157503f.INVALID_DATE = $d7c41ae3ced691f5$var$invalidDate;
$d7c41ae3ced691f5$export$324d90190a8b822a.prototype = $d7c41ae3ced691f5$export$18ec3cc5a157503f.prototype;
$d7c41ae3ced691f5$export$324d90190a8b822a.INVALID_DATE = $d7c41ae3ced691f5$var$invalidDate;
// @ts-expect-error
function $d7c41ae3ced691f5$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $1b3410630a0cc241$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($d7c41ae3ced691f5$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($d7c41ae3ced691f5$export$213e2a3e7c4f326e(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($ce0d32d78faeeaac$exports))).array(Array.from(nodes), edges).reverse();
}
function $d7c41ae3ced691f5$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $d7c41ae3ced691f5$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $d7c41ae3ced691f5$var$findIndex(keys, a) - $d7c41ae3ced691f5$var$findIndex(keys, b);
    };
}
const $d7c41ae3ced691f5$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== "string") return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $d7c41ae3ced691f5$var$deepPartial(schema) {
    if ("fields" in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $d7c41ae3ced691f5$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === "array") {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $d7c41ae3ced691f5$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === "tuple") return schema.optional().clone({
        types: schema.spec.types.map($d7c41ae3ced691f5$var$deepPartial)
    });
    if ("optional" in schema) return schema.optional();
    return schema;
}
const $d7c41ae3ced691f5$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $1b3410630a0cc241$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $1b3410630a0cc241$exports.getter)((0, $1b3410630a0cc241$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $d7c41ae3ced691f5$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $d7c41ae3ced691f5$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $d7c41ae3ced691f5$var$defaultSort = $d7c41ae3ced691f5$var$sortByKeyOrder([]);
function $d7c41ae3ced691f5$export$be5493f9613cbbe(spec) {
    return new $d7c41ae3ced691f5$export$18b4fc70ec7eccf8(spec);
}
class $d7c41ae3ced691f5$export$18b4fc70ec7eccf8 extends $d7c41ae3ced691f5$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: "object",
            check (value) {
                return $d7c41ae3ced691f5$var$isObject(value) || typeof value === "function";
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $d7c41ae3ced691f5$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $d7c41ae3ced691f5$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$d7c41ae3ced691f5$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $d7c41ae3ced691f5$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ("default" in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && "getDefault" in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $d7c41ae3ced691f5$var$sortFields(shape, excludedEdges);
        next._sortErrors = $d7c41ae3ced691f5$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = "optional" in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $d7c41ae3ced691f5$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $1b3410630a0cc241$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($d7c41ae3ced691f5$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($d7c41ae3ced691f5$var$parseJson);
    }
    noUnknown(noAllow = true, message = $d7c41ae3ced691f5$var$object.noUnknown) {
        if (typeof noAllow !== "boolean") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $d7c41ae3ced691f5$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $d7c41ae3ced691f5$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $99c126c0f4c279c1$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $99c126c0f4c279c1$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $99c126c0f4c279c1$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$d7c41ae3ced691f5$export$be5493f9613cbbe.prototype = $d7c41ae3ced691f5$export$18b4fc70ec7eccf8.prototype;
function $d7c41ae3ced691f5$export$2f23118c22fb2630(type) {
    return new $d7c41ae3ced691f5$export$4347112b8447a7d(type);
}
class $d7c41ae3ced691f5$export$4347112b8447a7d extends $d7c41ae3ced691f5$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: "array",
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($d7c41ae3ced691f5$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$d7c41ae3ced691f5$export$213e2a3e7c4f326e(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + $d7c41ae3ced691f5$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $d7c41ae3ced691f5$var$array.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $d7c41ae3ced691f5$var$array.min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $d7c41ae3ced691f5$var$array.max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$d7c41ae3ced691f5$export$2f23118c22fb2630.prototype = $d7c41ae3ced691f5$export$4347112b8447a7d.prototype;
// @ts-ignore
function $d7c41ae3ced691f5$export$65e3907585753458(schemas) {
    return new $d7c41ae3ced691f5$export$411c3b3687e8ecc8(schemas);
}
class $d7c41ae3ced691f5$export$411c3b3687e8ecc8 extends $d7c41ae3ced691f5$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: "tuple",
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($d7c41ae3ced691f5$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ""}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$d7c41ae3ced691f5$export$65e3907585753458.prototype = $d7c41ae3ced691f5$export$411c3b3687e8ecc8.prototype;
function $d7c41ae3ced691f5$export$488013bae63b21da(builder) {
    return new $d7c41ae3ced691f5$var$Lazy(builder);
}
class $d7c41ae3ced691f5$var$Lazy {
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$d7c41ae3ced691f5$export$213e2a3e7c4f326e(schema)) throw new TypeError("lazy() functions must return a valid schema");
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $d7c41ae3ced691f5$var$Lazy(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return this._resolve(value, options).validate(value, options);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: "lazy",
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
}
function $d7c41ae3ced691f5$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $d7c41ae3ced691f5$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $d7c41ae3ced691f5$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$d7c41ae3ced691f5$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}




var $1T1QG = parcelRequire("1T1QG");

var $eUHG3 = parcelRequire("eUHG3");

// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $646b4ee1ea347ff8$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|22"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "[24-689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|31)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[56]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[4-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "8 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(8-$1)",
                    1
                ]
            ],
            "8",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)",
                        "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "596\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[047]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|80\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "800\\d{4}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-8]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|77|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "[1-6]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:472[24]|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "810",
            "(?:20|33|[5-79]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


function $46b158b59d2caec8$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $646b4ee1ea347ff8$export$2e2bcd8739ae039));
    return func.apply(this, args);
}


var $a823bed2e2fc3295$var$objectConstructor = {}.constructor;
function $a823bed2e2fc3295$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $a823bed2e2fc3295$var$objectConstructor;
}


function $bafc16bc21560d5e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bafc16bc21560d5e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bafc16bc21560d5e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bafc16bc21560d5e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bafc16bc21560d5e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bafc16bc21560d5e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bafc16bc21560d5e$var$_slicedToArray(arr, i) {
    return $bafc16bc21560d5e$var$_arrayWithHoles(arr) || $bafc16bc21560d5e$var$_iterableToArrayLimit(arr, i) || $bafc16bc21560d5e$var$_unsupportedIterableToArray(arr, i) || $bafc16bc21560d5e$var$_nonIterableRest();
}
function $bafc16bc21560d5e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bafc16bc21560d5e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bafc16bc21560d5e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bafc16bc21560d5e$var$_arrayLikeToArray(o, minLen);
}
function $bafc16bc21560d5e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bafc16bc21560d5e$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $bafc16bc21560d5e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $bafc16bc21560d5e$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $bafc16bc21560d5e$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === "string") text = arg_1;
    else throw new TypeError("A text for parsing must be a string."); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === "string") {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $bafc16bc21560d5e$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $a823bed2e2fc3295$export$2e2bcd8739ae039)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// The minimum length of the national significant number.
var $9870a0cd86dda0a6$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $9870a0cd86dda0a6$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $9870a0cd86dda0a6$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $9870a0cd86dda0a6$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $9870a0cd86dda0a6$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $9870a0cd86dda0a6$var$SLASHES = "\uFF0F/";
var $9870a0cd86dda0a6$var$DOTS = "\uFF0E.";
var $9870a0cd86dda0a6$export$20542845033f576e = " \xa0\xad\u200B\u2060\u3000";
var $9870a0cd86dda0a6$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $9870a0cd86dda0a6$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $9870a0cd86dda0a6$export$7f01587e28f9194 = "".concat($9870a0cd86dda0a6$var$DASHES).concat($9870a0cd86dda0a6$var$SLASHES).concat($9870a0cd86dda0a6$var$DOTS).concat($9870a0cd86dda0a6$export$20542845033f576e).concat($9870a0cd86dda0a6$var$BRACKETS).concat($9870a0cd86dda0a6$var$TILDES);
var $9870a0cd86dda0a6$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')


function $8b92a0906d4c0722$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8b92a0906d4c0722$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8b92a0906d4c0722$var$_typeof(obj);
}
function $8b92a0906d4c0722$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8b92a0906d4c0722$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8b92a0906d4c0722$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8b92a0906d4c0722$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8b92a0906d4c0722$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8b92a0906d4c0722$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $8b92a0906d4c0722$var$_setPrototypeOf(subClass, superClass);
}
function $8b92a0906d4c0722$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8b92a0906d4c0722$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8b92a0906d4c0722$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8b92a0906d4c0722$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8b92a0906d4c0722$var$_possibleConstructorReturn(this, result);
    };
}
function $8b92a0906d4c0722$var$_possibleConstructorReturn(self, call) {
    if (call && ($8b92a0906d4c0722$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $8b92a0906d4c0722$var$_assertThisInitialized(self);
}
function $8b92a0906d4c0722$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8b92a0906d4c0722$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $8b92a0906d4c0722$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$8b92a0906d4c0722$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $8b92a0906d4c0722$var$_construct(Class, arguments, $8b92a0906d4c0722$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $8b92a0906d4c0722$var$_setPrototypeOf(Wrapper, Class);
    };
    return $8b92a0906d4c0722$var$_wrapNativeSuper(Class);
}
function $8b92a0906d4c0722$var$_construct(Parent, args, Class) {
    if ($8b92a0906d4c0722$var$_isNativeReflectConstruct()) $8b92a0906d4c0722$var$_construct = Reflect.construct;
    else $8b92a0906d4c0722$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $8b92a0906d4c0722$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $8b92a0906d4c0722$var$_construct.apply(null, arguments);
}
function $8b92a0906d4c0722$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8b92a0906d4c0722$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $8b92a0906d4c0722$var$_setPrototypeOf(o, p) {
    $8b92a0906d4c0722$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8b92a0906d4c0722$var$_setPrototypeOf(o, p);
}
function $8b92a0906d4c0722$var$_getPrototypeOf(o) {
    $8b92a0906d4c0722$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8b92a0906d4c0722$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $8b92a0906d4c0722$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $8b92a0906d4c0722$var$_inherits(ParseError, _Error);
    var _super = $8b92a0906d4c0722$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $8b92a0906d4c0722$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($8b92a0906d4c0722$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $8b92a0906d4c0722$var$_createClass(ParseError);
}(/*#__PURE__*/ $8b92a0906d4c0722$var$_wrapNativeSuper(Error));


// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $ab88de6cb2a2b522$export$2e2bcd8739ae039(a, b) {
    a = a.split("-");
    b = b.split("-");
    var pa = a[0].split(".");
    var pb = b[0].split(".");
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}



function $437fabe0ee4b5fe4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $437fabe0ee4b5fe4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $437fabe0ee4b5fe4$var$_typeof(obj);
}
function $437fabe0ee4b5fe4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $437fabe0ee4b5fe4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $437fabe0ee4b5fe4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $437fabe0ee4b5fe4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $437fabe0ee4b5fe4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $437fabe0ee4b5fe4$var$V2 = "1.0.18"; // Added "idd_prefix" and "default_idd_prefix".
var $437fabe0ee4b5fe4$var$V3 = "1.2.0"; // Moved `001` country code to "nonGeographic" section of metadata.
var $437fabe0ee4b5fe4$var$V4 = "1.7.35";
var $437fabe0ee4b5fe4$var$DEFAULT_EXT_PREFIX = " ext. ";
var $437fabe0ee4b5fe4$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $437fabe0ee4b5fe4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $437fabe0ee4b5fe4$var$_classCallCheck(this, Metadata);
        $437fabe0ee4b5fe4$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $437fabe0ee4b5fe4$var$setVersion.call(this, metadata);
    }
    $437fabe0ee4b5fe4$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== "001";
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $437fabe0ee4b5fe4$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== "001") {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $437fabe0ee4b5fe4$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $437fabe0ee4b5fe4$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return this.metadata.countries["001"];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $437fabe0ee4b5fe4$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $437fabe0ee4b5fe4$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $437fabe0ee4b5fe4$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $437fabe0ee4b5fe4$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $437fabe0ee4b5fe4$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $437fabe0ee4b5fe4$var$getType(this.types(), _type2)) return new $437fabe0ee4b5fe4$var$Type($437fabe0ee4b5fe4$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $437fabe0ee4b5fe4$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $437fabe0ee4b5fe4$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $437fabe0ee4b5fe4$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $437fabe0ee4b5fe4$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $437fabe0ee4b5fe4$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$437fabe0ee4b5fe4$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $437fabe0ee4b5fe4$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $437fabe0ee4b5fe4$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $437fabe0ee4b5fe4$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $437fabe0ee4b5fe4$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $437fabe0ee4b5fe4$var$getType(types, type) {
    switch(type){
        case "FIXED_LINE":
            return types[0];
        case "MOBILE":
            return types[1];
        case "TOLL_FREE":
            return types[2];
        case "PREMIUM_RATE":
            return types[3];
        case "PERSONAL_NUMBER":
            return types[4];
        case "VOICEMAIL":
            return types[5];
        case "UAN":
            return types[6];
        case "PAGER":
            return types[7];
        case "VOIP":
            return types[8];
        case "SHARED_COST":
            return types[9];
    }
}
function $437fabe0ee4b5fe4$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
     // `country_phone_code_to_countries` was renamed to
    // `country_calling_codes` in `1.0.18`.
    if (!(0, $a823bed2e2fc3295$export$2e2bcd8739ae039)(metadata) || !(0, $a823bed2e2fc3295$export$2e2bcd8739ae039)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $a823bed2e2fc3295$export$2e2bcd8739ae039)(metadata) ? "an object of shape: { " + Object.keys(metadata).join(", ") + " }" : "a " + $437fabe0ee4b5fe4$var$typeOf(metadata) + ": " + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $437fabe0ee4b5fe4$var$typeOf = function typeOf(_) {
    return $437fabe0ee4b5fe4$var$_typeof(_);
};
function $437fabe0ee4b5fe4$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $437fabe0ee4b5fe4$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $437fabe0ee4b5fe4$var$DEFAULT_EXT_PREFIX;
}
function $437fabe0ee4b5fe4$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $437fabe0ee4b5fe4$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $437fabe0ee4b5fe4$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $437fabe0ee4b5fe4$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === "number") {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $ab88de6cb2a2b522$export$2e2bcd8739ae039)(version, $437fabe0ee4b5fe4$var$V3) === -1) this.v2 = true;
        else if ((0, $ab88de6cb2a2b522$export$2e2bcd8739ae039)(version, $437fabe0ee4b5fe4$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }




var $0e194004c92dba83$var$RFC3966_EXTN_PREFIX = ";ext=";
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $0e194004c92dba83$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $9870a0cd86dda0a6$export$852d1d4a47329634), "]{1,").concat(maxLength, "})");
};
function $0e194004c92dba83$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = "20";
    /** @type {string} */ var extLimitAfterLikelyLabel = "15";
    /** @type {string} */ var extLimitAfterAmbiguousChar = "9";
    /** @type {string} */ var extLimitWhenNotSure = "6";
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xa0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xa0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xf3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xa0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $0e194004c92dba83$var$RFC3966_EXTN_PREFIX + $0e194004c92dba83$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $0e194004c92dba83$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $0e194004c92dba83$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $0e194004c92dba83$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $0e194004c92dba83$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $0e194004c92dba83$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}


//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $ab50103eb64c23f8$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + (0, $9870a0cd86dda0a6$export$852d1d4a47329634) + "]{" + (0, $9870a0cd86dda0a6$export$cd8355bcbe13154) + "}"; //
var $ab50103eb64c23f8$export$a77dd7471651eee = "[" + (0, $9870a0cd86dda0a6$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $9870a0cd86dda0a6$export$7f01587e28f9194) + "]*" + "[" + (0, $9870a0cd86dda0a6$export$852d1d4a47329634) + "]" + "){3,}" + "[" + (0, $9870a0cd86dda0a6$export$7f01587e28f9194) + (0, $9870a0cd86dda0a6$export$852d1d4a47329634) + "]*"; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $ab50103eb64c23f8$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $9870a0cd86dda0a6$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $9870a0cd86dda0a6$export$7f01587e28f9194) + "]*" + "[" + (0, $9870a0cd86dda0a6$export$852d1d4a47329634) + "]" + "){1,2}" + "$", "i");
var $ab50103eb64c23f8$export$a2d12a04749c087d = $ab50103eb64c23f8$export$a77dd7471651eee + // Phone number extensions
"(?:" + (0, $0e194004c92dba83$export$2e2bcd8739ae039)() + ")?"; // The combined regular expression for valid phone numbers:
//
var $ab50103eb64c23f8$var$VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + $ab50103eb64c23f8$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + "$" + "|" + // Or a longer fully parsed phone number (min 3 characters)
"^" + $ab50103eb64c23f8$export$a2d12a04749c087d + "$", "i"); // Checks to see if the string of characters could possibly be a phone number at
function $ab50103eb64c23f8$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $9870a0cd86dda0a6$export$cd8355bcbe13154) && $ab50103eb64c23f8$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $ab50103eb64c23f8$export$4c3f76c95c05197c(number) {
    return $ab50103eb64c23f8$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}



// 1 or more valid digits, for use when parsing.
var $33af637d0ae69bad$var$EXTN_PATTERN = new RegExp("(?:" + (0, $0e194004c92dba83$export$2e2bcd8739ae039)() + ")$", "i"); // Strips any extension (as in, the part of the number dialled after the call is
function $33af637d0ae69bad$export$2e2bcd8739ae039(number) {
    var start = number.search($33af637d0ae69bad$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($33af637d0ae69bad$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}


function $6e7211182faaca28$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $6e7211182faaca28$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6e7211182faaca28$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6e7211182faaca28$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6e7211182faaca28$var$_arrayLikeToArray(o, minLen);
}
function $6e7211182faaca28$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $6e7211182faaca28$export$2848f3d68c08fe69 = {
    "0": "0",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "\uFF10": "0",
    // Fullwidth digit 0
    "\uFF11": "1",
    // Fullwidth digit 1
    "\uFF12": "2",
    // Fullwidth digit 2
    "\uFF13": "3",
    // Fullwidth digit 3
    "\uFF14": "4",
    // Fullwidth digit 4
    "\uFF15": "5",
    // Fullwidth digit 5
    "\uFF16": "6",
    // Fullwidth digit 6
    "\uFF17": "7",
    // Fullwidth digit 7
    "\uFF18": "8",
    // Fullwidth digit 8
    "\uFF19": "9",
    // Fullwidth digit 9
    "\u0660": "0",
    // Arabic-indic digit 0
    "\u0661": "1",
    // Arabic-indic digit 1
    "\u0662": "2",
    // Arabic-indic digit 2
    "\u0663": "3",
    // Arabic-indic digit 3
    "\u0664": "4",
    // Arabic-indic digit 4
    "\u0665": "5",
    // Arabic-indic digit 5
    "\u0666": "6",
    // Arabic-indic digit 6
    "\u0667": "7",
    // Arabic-indic digit 7
    "\u0668": "8",
    // Arabic-indic digit 8
    "\u0669": "9",
    // Arabic-indic digit 9
    "\u06F0": "0",
    // Eastern-Arabic digit 0
    "\u06F1": "1",
    // Eastern-Arabic digit 1
    "\u06F2": "2",
    // Eastern-Arabic digit 2
    "\u06F3": "3",
    // Eastern-Arabic digit 3
    "\u06F4": "4",
    // Eastern-Arabic digit 4
    "\u06F5": "5",
    // Eastern-Arabic digit 5
    "\u06F6": "6",
    // Eastern-Arabic digit 6
    "\u06F7": "7",
    // Eastern-Arabic digit 7
    "\u06F8": "8",
    // Eastern-Arabic digit 8
    "\u06F9": "9" // Eastern-Arabic digit 9
};
function $6e7211182faaca28$export$1d16fddea1437169(character) {
    return $6e7211182faaca28$export$2848f3d68c08fe69[character];
}
function $6e7211182faaca28$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $6e7211182faaca28$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $6e7211182faaca28$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}


function $6d5b0d1c318400f4$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $6d5b0d1c318400f4$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6d5b0d1c318400f4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6d5b0d1c318400f4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6d5b0d1c318400f4$var$_arrayLikeToArray(o, minLen);
}
function $6d5b0d1c318400f4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6d5b0d1c318400f4$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $6d5b0d1c318400f4$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $6d5b0d1c318400f4$export$13d8790d7fb84c28(character, result) || "";
    }
    return result;
}
function $6d5b0d1c318400f4$export$13d8790d7fb84c28(character, prevParsedCharacters, emitEvent) {
    // Only allow a leading `+`.
    if (character === "+") {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) {
            // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
            // Any 3rd-party code that used to `import` and call this function before that
            // won't be passing any `emitEvent` argument.
            //
            // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
            // of parsing an input string when the user inputs something like `"2+7"
            // https://github.com/catamphetamine/react-phone-number-input/issues/437
            //
            // If the parser encounters an unexpected `+` in a string being parsed
            // then it simply discards that out-of-place `+` and any following characters.
            //
            if (typeof emitEvent === "function") emitEvent("end");
            return;
        }
        return "+";
    } // Allow digits.
    return (0, $6e7211182faaca28$export$1d16fddea1437169)(character);
}




function $116abea6354f5831$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $116abea6354f5831$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $116abea6354f5831$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $116abea6354f5831$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $116abea6354f5831$var$_arrayLikeToArray(o, minLen);
}
function $116abea6354f5831$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $116abea6354f5831$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $116abea6354f5831$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}


function $f031e8917722175c$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $f031e8917722175c$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $f031e8917722175c$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return "IS_POSSIBLE";
    if (type === "FIXED_LINE_OR_MOBILE") {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type("FIXED_LINE")) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $f031e8917722175c$export$69333f603c7d5931(nationalNumber, "MOBILE", metadata);
        var mobile_type = metadata.type("MOBILE");
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $116abea6354f5831$export$2e2bcd8739ae039)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return "INVALID_LENGTH";
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return "IS_POSSIBLE";
    if (minimum_length > actual_length) return "TOO_SHORT";
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return "TOO_LONG";
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}


function $a26a70443a9867d6$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $437fabe0ee4b5fe4$export$2e2bcd8739ae039)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $a26a70443a9867d6$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $a26a70443a9867d6$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $f031e8917722175c$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "IS_POSSIBLE":
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}





/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $de03b8f9eef57f55$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || "";
    return new RegExp("^(?:" + regular_expression + ")$").test(text);
}




function $2cc569299d302bd9$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $2cc569299d302bd9$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2cc569299d302bd9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2cc569299d302bd9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2cc569299d302bd9$var$_arrayLikeToArray(o, minLen);
}
function $2cc569299d302bd9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $2cc569299d302bd9$var$NON_FIXED_LINE_PHONE_TYPES = [
    "MOBILE",
    "PREMIUM_RATE",
    "TOLL_FREE",
    "SHARED_COST",
    "VOIP",
    "PERSONAL_NUMBER",
    "PAGER",
    "UAN",
    "VOICEMAIL"
]; // Finds out national phone number type (fixed line, mobile, etc)
function $2cc569299d302bd9$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $437fabe0ee4b5fe4$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $de03b8f9eef57f55$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($2cc569299d302bd9$export$7bd37b39ade0214d(nationalNumber, "FIXED_LINE", metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type("MOBILE") && metadata.type("MOBILE").pattern() === "") return "FIXED_LINE_OR_MOBILE";
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type("MOBILE")) return "FIXED_LINE_OR_MOBILE";
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($2cc569299d302bd9$export$7bd37b39ade0214d(nationalNumber, "MOBILE", metadata)) return "FIXED_LINE_OR_MOBILE";
        return "FIXED_LINE";
    }
    for(var _iterator = $2cc569299d302bd9$var$_createForOfIteratorHelperLoose($2cc569299d302bd9$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($2cc569299d302bd9$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $2cc569299d302bd9$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $de03b8f9eef57f55$export$2e2bcd8739ae039)(nationalNumber, type.pattern());
}


function $23b02aa984be69b8$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $437fabe0ee4b5fe4$export$2e2bcd8739ae039)(metadata);
    /**
   * Checks if a phone number is "possible" (basically just checks its length).
   *
   * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
   * @param  {object} [options]
   * @param  {object} metadata
   * @return {string}
   */ metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $2cc569299d302bd9$export$2e2bcd8739ae039)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $de03b8f9eef57f55$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern());
}




function $be1400f9fd50443f$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $437fabe0ee4b5fe4$export$2e2bcd8739ae039)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $be1400f9fd50443f$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $be1400f9fd50443f$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $437fabe0ee4b5fe4$export$2e2bcd8739ae039)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}




function $9fea3a0bcfcfbda6$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $9870a0cd86dda0a6$export$7f01587e28f9194), "]+"), "g"), " ").trim();
}


var $381510648558703d$export$4f32ad1c51a7a6be = /(\$\d)/;
function $381510648558703d$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($381510648558703d$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $9fea3a0bcfcfbda6$export$2e2bcd8739ae039)(formattedNumber);
    return formattedNumber;
}




/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $f599de2740c74448$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $f599de2740c74448$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $437fabe0ee4b5fe4$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($f599de2740c74448$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}



function $251c394264bdd0e0$var$_slicedToArray(arr, i) {
    return $251c394264bdd0e0$var$_arrayWithHoles(arr) || $251c394264bdd0e0$var$_iterableToArrayLimit(arr, i) || $251c394264bdd0e0$var$_unsupportedIterableToArray(arr, i) || $251c394264bdd0e0$var$_nonIterableRest();
}
function $251c394264bdd0e0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $251c394264bdd0e0$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $251c394264bdd0e0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $251c394264bdd0e0$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $251c394264bdd0e0$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $251c394264bdd0e0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $251c394264bdd0e0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $251c394264bdd0e0$var$_arrayLikeToArray(o, minLen);
}
function $251c394264bdd0e0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $251c394264bdd0e0$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, "tel=");
    for(var _iterator = $251c394264bdd0e0$var$_createForOfIteratorHelperLoose(text.split(";")), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split("="), _part$split2 = $251c394264bdd0e0$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case "tel":
                number = value;
                break;
            case "ext":
                ext = value;
                break;
            case "phone-context":
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === "+") number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $ab50103eb64c23f8$export$2e2bcd8739ae039)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $251c394264bdd0e0$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return "";
    if (number[0] !== "+") throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
    return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}


function $0629792503a00dcd$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $0629792503a00dcd$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0629792503a00dcd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0629792503a00dcd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0629792503a00dcd$var$_arrayLikeToArray(o, minLen);
}
function $0629792503a00dcd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0629792503a00dcd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0629792503a00dcd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0629792503a00dcd$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0629792503a00dcd$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0629792503a00dcd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0629792503a00dcd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $0629792503a00dcd$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $0629792503a00dcd$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $0629792503a00dcd$var$_objectSpread($0629792503a00dcd$var$_objectSpread({}, $0629792503a00dcd$var$DEFAULT_OPTIONS), options);
    else options = $0629792503a00dcd$var$DEFAULT_OPTIONS;
    metadata = new (0, $437fabe0ee4b5fe4$export$2e2bcd8739ae039)(metadata);
    if (input.country && input.country !== "001") {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || "";
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case "NATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "";
            number = $0629792503a00dcd$var$formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata, options);
            return $0629792503a00dcd$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "INTERNATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $0629792503a00dcd$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $0629792503a00dcd$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "E.164":
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case "RFC3966":
            return (0, $251c394264bdd0e0$export$d4f2d2bc1159d115)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case "IDD":
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $0629792503a00dcd$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $0629792503a00dcd$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
    }
}
function $0629792503a00dcd$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $0629792503a00dcd$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $381510648558703d$export$2e2bcd8739ae039)(number, format, {
        useInternationalFormat: formatAs === "INTERNATIONAL",
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $0629792503a00dcd$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $0629792503a00dcd$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $de03b8f9eef57f55$export$2e2bcd8739ae039)(nationalNnumber, format.pattern())) return format;
    }
}
function $0629792503a00dcd$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $0629792503a00dcd$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $437fabe0ee4b5fe4$export$32876ca2f1919cf0)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $0629792503a00dcd$var$formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === "1") return countryCallingCode + " " + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $f599de2740c74448$export$2e2bcd8739ae039)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($0629792503a00dcd$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata));
}


function $faab2985adcbb806$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $faab2985adcbb806$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $faab2985adcbb806$var$ownKeys(Object(source), !0).forEach(function(key) {
            $faab2985adcbb806$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $faab2985adcbb806$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $faab2985adcbb806$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $faab2985adcbb806$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $faab2985adcbb806$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $faab2985adcbb806$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $faab2985adcbb806$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $faab2985adcbb806$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $faab2985adcbb806$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $faab2985adcbb806$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $faab2985adcbb806$var$_classCallCheck(this, PhoneNumber);
        if (!countryOrCountryCallingCode) throw new TypeError("`country` or `countryCallingCode` not passed");
        if (!nationalNumber) throw new TypeError("`nationalNumber` not passed");
        if (!metadata) throw new TypeError("`metadata` not passed");
        var _getCountryAndCountry = $faab2985adcbb806$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = "+" + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $faab2985adcbb806$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $be1400f9fd50443f$export$2e2bcd8739ae039)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $a26a70443a9867d6$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $23b02aa984be69b8$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $437fabe0ee4b5fe4$export$2e2bcd8739ae039)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $2cc569299d302bd9$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $0629792503a00dcd$export$2e2bcd8739ae039)(this, _format, options ? $faab2985adcbb806$var$_objectSpread($faab2985adcbb806$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format("NATIONAL", options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format("INTERNATIONAL", options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format("RFC3966", options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $faab2985adcbb806$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $faab2985adcbb806$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $437fabe0ee4b5fe4$export$2e2bcd8739ae039)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($faab2985adcbb806$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($faab2985adcbb806$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = "001";
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}





var $550332ba79837743$var$CAPTURING_DIGIT_PATTERN = new RegExp("([" + (0, $9870a0cd86dda0a6$export$852d1d4a47329634) + "])");
function $550332ba79837743$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $437fabe0ee4b5fe4$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($550332ba79837743$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === "0") return;
    }
    return number;
}




/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $4f857945f361a32b$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp("^(?:" + metadata.numberingPlan.nationalPrefixForParsing() + ")");
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}




function $09728d685f50b325$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $4f857945f361a32b$export$2e2bcd8739ae039)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$09728d685f50b325$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$09728d685f50b325$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $09728d685f50b325$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $de03b8f9eef57f55$export$2e2bcd8739ae039)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $de03b8f9eef57f55$export$2e2bcd8739ae039)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $09728d685f50b325$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $f031e8917722175c$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "TOO_SHORT":
        case "INVALID_LENGTH":
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}




function $aeb3261f3ae86479$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $437fabe0ee4b5fe4$export$32876ca2f1919cf0)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $437fabe0ee4b5fe4$export$2e2bcd8739ae039)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $09728d685f50b325$export$2e2bcd8739ae039)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $09728d685f50b325$export$2e2bcd8739ae039)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $de03b8f9eef57f55$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) && (0, $de03b8f9eef57f55$export$2e2bcd8739ae039)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $f031e8917722175c$export$2e2bcd8739ae039)(nationalNumber, metadata) === "TOO_LONG") return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}




function $4731703ada071864$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== "+") {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $550332ba79837743$export$2e2bcd8739ae039)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = "+" + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $aeb3261f3ae86479$export$2e2bcd8739ae039)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === "0") return {};
    metadata = new (0, $437fabe0ee4b5fe4$export$2e2bcd8739ae039)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $9870a0cd86dda0a6$export$514717690676fb4a) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }






function $c931368f432123a4$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $c931368f432123a4$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c931368f432123a4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c931368f432123a4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c931368f432123a4$var$_arrayLikeToArray(o, minLen);
}
function $c931368f432123a4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c931368f432123a4$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $437fabe0ee4b5fe4$export$2e2bcd8739ae039)(metadata);
    var matchingCountries = [];
    for(var _iterator = $c931368f432123a4$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $2cc569299d302bd9$export$2e2bcd8739ae039)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) {
            // If the `defaultCountry` is among the `matchingCountries` then return it.
            if (defaultCountry) {
                if (country === defaultCountry) return country;
                matchingCountries.push(country);
            } else return country;
        }
    } // Return the first ("main") one of the `matchingCountries`.
    if (matchingCountries.length > 0) return matchingCountries[0];
}


var $fd48aed919335e3a$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $fd48aed919335e3a$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($fd48aed919335e3a$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return "001";
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $c931368f432123a4$export$2e2bcd8739ae039)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}


// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $a7afe69ed5eb2f37$export$1ddc7eed78155f68 = "+";
var $a7afe69ed5eb2f37$var$RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var $a7afe69ed5eb2f37$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $9870a0cd86dda0a6$export$852d1d4a47329634) + "]" + "|" + $a7afe69ed5eb2f37$var$RFC3966_VISUAL_SEPARATOR_ + ")";
var $a7afe69ed5eb2f37$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $a7afe69ed5eb2f37$export$1ddc7eed78155f68 + $a7afe69ed5eb2f37$var$RFC3966_PHONE_DIGIT_ + "*" + "[" + (0, $9870a0cd86dda0a6$export$852d1d4a47329634) + "]" + $a7afe69ed5eb2f37$var$RFC3966_PHONE_DIGIT_ + "*" + "$";
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $a7afe69ed5eb2f37$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($a7afe69ed5eb2f37$var$RFC3966_GLOBAL_NUMBER_DIGITS_, "g"); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $a7afe69ed5eb2f37$var$ALPHANUM_ = (0, $9870a0cd86dda0a6$export$852d1d4a47329634);
var $a7afe69ed5eb2f37$var$RFC3966_DOMAINLABEL_ = "[" + $a7afe69ed5eb2f37$var$ALPHANUM_ + "]+((\\-)*[" + $a7afe69ed5eb2f37$var$ALPHANUM_ + "])*";
var $a7afe69ed5eb2f37$var$VALID_ALPHA_ = "a-zA-Z";
var $a7afe69ed5eb2f37$var$RFC3966_TOPLABEL_ = "[" + $a7afe69ed5eb2f37$var$VALID_ALPHA_ + "]+((\\-)*[" + $a7afe69ed5eb2f37$var$ALPHANUM_ + "])*";
var $a7afe69ed5eb2f37$var$RFC3966_DOMAINNAME_ = "^(" + $a7afe69ed5eb2f37$var$RFC3966_DOMAINLABEL_ + "\\.)*" + $a7afe69ed5eb2f37$var$RFC3966_TOPLABEL_ + "\\.?$";
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $a7afe69ed5eb2f37$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($a7afe69ed5eb2f37$var$RFC3966_DOMAINNAME_, "g");
var $a7afe69ed5eb2f37$export$70d485ce3f6de783 = "tel:";
var $a7afe69ed5eb2f37$export$f6d5879d582c3a27 = ";phone-context=";
var $a7afe69ed5eb2f37$export$9e356e12edb00a81 = ";isub=";
function $a7afe69ed5eb2f37$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($a7afe69ed5eb2f37$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $a7afe69ed5eb2f37$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return "";
    var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $a7afe69ed5eb2f37$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $a7afe69ed5eb2f37$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $a7afe69ed5eb2f37$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}



function $aa2128c54f101020$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $a7afe69ed5eb2f37$export$2e2bcd8739ae039)(numberToParse);
    if (!(0, $a7afe69ed5eb2f37$export$474a4aa22ad6959a)(phoneContext)) throw new (0, $8b92a0906d4c0722$export$2e2bcd8739ae039)("NOT_A_NUMBER");
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
    else {
        phoneNumberString = ""; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $a7afe69ed5eb2f37$export$1ddc7eed78155f68)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $a7afe69ed5eb2f37$export$70d485ce3f6de783));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $a7afe69ed5eb2f37$export$70d485ce3f6de783).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $a7afe69ed5eb2f37$export$f6d5879d582c3a27));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $a7afe69ed5eb2f37$export$9e356e12edb00a81));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== "") return phoneNumberString;
}


// This prevents malicious input from consuming CPU.
var $d24565a0760f287d$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $d24565a0760f287d$var$PHONE_NUMBER_START_PATTERN = new RegExp("[" + (0, $9870a0cd86dda0a6$export$207c99ccf3902df8) + (0, $9870a0cd86dda0a6$export$852d1d4a47329634) + "]"); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $d24565a0760f287d$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + (0, $9870a0cd86dda0a6$export$852d1d4a47329634) + "#" + "]+$");
var $d24565a0760f287d$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $d24565a0760f287d$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $437fabe0ee4b5fe4$export$2e2bcd8739ae039)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $8b92a0906d4c0722$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $d24565a0760f287d$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === "TOO_SHORT") throw new (0, $8b92a0906d4c0722$export$2e2bcd8739ae039)("TOO_SHORT");
            throw new (0, $8b92a0906d4c0722$export$2e2bcd8739ae039)("NOT_A_NUMBER");
        }
        return {};
    }
    var _parsePhoneNumber = $d24565a0760f287d$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $8b92a0906d4c0722$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $9870a0cd86dda0a6$export$cd8355bcbe13154)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $8b92a0906d4c0722$export$2e2bcd8739ae039)("TOO_SHORT");
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $9870a0cd86dda0a6$export$85ddd8c9b243679b)) {
        if (options.v2) throw new (0, $8b92a0906d4c0722$export$2e2bcd8739ae039)("TOO_LONG");
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $faab2985adcbb806$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $de03b8f9eef57f55$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $d24565a0760f287d$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $a26a70443a9867d6$export$4f8890cedf1e0497)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $d24565a0760f287d$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $d24565a0760f287d$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $8b92a0906d4c0722$export$2e2bcd8739ae039)("TOO_LONG");
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($d24565a0760f287d$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($d24565a0760f287d$var$AFTER_PHONE_NUMBER_END_PATTERN, "");
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $d24565a0760f287d$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $aa2128c54f101020$export$2e2bcd8739ae039)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $d24565a0760f287d$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $ab50103eb64c23f8$export$2e2bcd8739ae039)(number)) {
        if ((0, $ab50103eb64c23f8$export$4c3f76c95c05197c)(number)) return {
            error: "TOO_SHORT"
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $33af637d0ae69bad$export$2e2bcd8739ae039)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $d24565a0760f287d$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $d24565a0760f287d$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $4731703ada071864$export$2e2bcd8739ae039)((0, $6d5b0d1c318400f4$export$2e2bcd8739ae039)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($d24565a0760f287d$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = "001";
            }
        }
        countryCallingCode = defaultCallingCode || (0, $437fabe0ee4b5fe4$export$32876ca2f1919cf0)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $09728d685f50b325$export$2e2bcd8739ae039)((0, $6d5b0d1c318400f4$export$2e2bcd8739ae039)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $fd48aed919335e3a$export$2e2bcd8739ae039)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === "001") ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}


function $2d51b02dfa34243b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2d51b02dfa34243b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2d51b02dfa34243b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $2d51b02dfa34243b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2d51b02dfa34243b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2d51b02dfa34243b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2d51b02dfa34243b$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $d24565a0760f287d$export$2e2bcd8739ae039)(text, $2d51b02dfa34243b$var$_objectSpread($2d51b02dfa34243b$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}




function $8b6978b6162341cc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8b6978b6162341cc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8b6978b6162341cc$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8b6978b6162341cc$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8b6978b6162341cc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8b6978b6162341cc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8b6978b6162341cc$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $437fabe0ee4b5fe4$export$bd9e113b8b17202a)(options.defaultCountry, metadata)) options = $8b6978b6162341cc$var$_objectSpread($8b6978b6162341cc$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $2d51b02dfa34243b$export$2e2bcd8739ae039)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $8b92a0906d4c0722$export$2e2bcd8739ae039)) ;
        else throw error;
    }
}


function $f94136d43bdbc429$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f94136d43bdbc429$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f94136d43bdbc429$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f94136d43bdbc429$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f94136d43bdbc429$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f94136d43bdbc429$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f94136d43bdbc429$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $bafc16bc21560d5e$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $f94136d43bdbc429$var$_objectSpread($f94136d43bdbc429$var$_objectSpread({}, options), {}, {
        extract: false
    });
    var phoneNumber = (0, $8b6978b6162341cc$export$2e2bcd8739ae039)(text, options, metadata);
    return phoneNumber && phoneNumber.isValid() || false;
}


function $73c4811e9a17efad$export$992e2df24bec72ba() {
    return (0, $46b158b59d2caec8$export$2e2bcd8739ae039)((0, $f94136d43bdbc429$export$2e2bcd8739ae039), arguments);
}


var $f989e98d45efceaa$export$32ea325d92ea6082;
(function(MoovyConstantNames) {
    MoovyConstantNames.APP_FULLNAME = "LUPAPALVELU";
    MoovyConstantNames.PHONE_FI_COUNTRY_CODE = "+358";
})($f989e98d45efceaa$export$32ea325d92ea6082 || ($f989e98d45efceaa$export$32ea325d92ea6082 = {}));
var $f989e98d45efceaa$export$4b65f495352b3bd3;
(function(MoovyConstantDOMIds) {
    MoovyConstantDOMIds.MOOVY_BACKDROP_ANIMATION = "moovy-backdrop-animation";
})($f989e98d45efceaa$export$4b65f495352b3bd3 || ($f989e98d45efceaa$export$4b65f495352b3bd3 = {}));


var $b83b78063754cf87$exports = {};
"use strict";
Object.defineProperty($b83b78063754cf87$exports, "__esModule", {
    value: true
});
$b83b78063754cf87$exports.default = $b83b78063754cf87$var$isEmail;

var $b83b78063754cf87$var$_assertString = $b83b78063754cf87$var$_interopRequireDefault((parcelRequire("adaeM")));

var $b83b78063754cf87$var$_isByteLength = $b83b78063754cf87$var$_interopRequireDefault((parcelRequire("ihkUX")));

var $b83b78063754cf87$var$_isFQDN = $b83b78063754cf87$var$_interopRequireDefault((parcelRequire("2WRI2")));

var $b83b78063754cf87$var$_isIP = $b83b78063754cf87$var$_interopRequireDefault((parcelRequire("dyBf4")));

var $b83b78063754cf87$var$_merge = $b83b78063754cf87$var$_interopRequireDefault((parcelRequire("lgOyf")));
function $b83b78063754cf87$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b83b78063754cf87$var$default_email_options = {
    allow_display_name: false,
    allow_underscores: false,
    require_display_name: false,
    allow_utf8_local_part: true,
    require_tld: true,
    blacklisted_chars: "",
    ignore_max_length: false,
    host_blacklist: [],
    host_whitelist: []
};
/* eslint-disable max-len */ /* eslint-disable no-control-regex */ var $b83b78063754cf87$var$splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
var $b83b78063754cf87$var$emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var $b83b78063754cf87$var$gmailUserPart = /^[a-z\d]+$/;
var $b83b78063754cf87$var$quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var $b83b78063754cf87$var$emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var $b83b78063754cf87$var$quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
var $b83b78063754cf87$var$defaultMaxEmailLength = 254;
/* eslint-enable max-len */ /* eslint-enable no-control-regex */ /**
 * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
 * @param {String} display_name
 */ function $b83b78063754cf87$var$validateDisplayName(display_name) {
    var display_name_without_quotes = display_name.replace(/^"(.+)"$/, "$1"); // display name with only spaces is not valid
    if (!display_name_without_quotes.trim()) return false;
     // check whether display name contains illegal character
    var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
    if (contains_illegal) {
        // if contains illegal characters,
        // must to be enclosed in double-quotes, otherwise it's not a valid display name
        if (display_name_without_quotes === display_name) return false;
         // the quotes in display name must start with character symbol \
        var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
        if (!all_start_with_back_slash) return false;
    }
    return true;
}
function $b83b78063754cf87$var$isEmail(str, options) {
    (0, $b83b78063754cf87$var$_assertString.default)(str);
    options = (0, $b83b78063754cf87$var$_merge.default)(options, $b83b78063754cf87$var$default_email_options);
    if (options.require_display_name || options.allow_display_name) {
        var display_email = str.match($b83b78063754cf87$var$splitNameAddress);
        if (display_email) {
            var display_name = display_email[1]; // Remove display name and angle brackets to get email address
            // Can be done in the regex but will introduce a ReDOS (See  #1597 for more info)
            str = str.replace(display_name, "").replace(/(^<|>$)/g, ""); // sometimes need to trim the last space to get the display name
            // because there may be a space between display name and email address
            // eg. myname <address@gmail.com>
            // the display name is `myname` instead of `myname `, so need to trim the last space
            if (display_name.endsWith(" ")) display_name = display_name.slice(0, -1);
            if (!$b83b78063754cf87$var$validateDisplayName(display_name)) return false;
        } else if (options.require_display_name) return false;
    }
    if (!options.ignore_max_length && str.length > $b83b78063754cf87$var$defaultMaxEmailLength) return false;
    var parts = str.split("@");
    var domain = parts.pop();
    var lower_domain = domain.toLowerCase();
    if (options.host_blacklist.includes(lower_domain)) return false;
    if (options.host_whitelist.length > 0 && !options.host_whitelist.includes(lower_domain)) return false;
    var user = parts.join("@");
    if (options.domain_specific_validation && (lower_domain === "gmail.com" || lower_domain === "googlemail.com")) {
        /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */ user = user.toLowerCase(); // Removing sub-address from username before gmail validation
        var username = user.split("+")[0]; // Dots are not included in gmail length restriction
        if (!(0, $b83b78063754cf87$var$_isByteLength.default)(username.replace(/\./g, ""), {
            min: 6,
            max: 30
        })) return false;
        var _user_parts = username.split(".");
        for(var i = 0; i < _user_parts.length; i++){
            if (!$b83b78063754cf87$var$gmailUserPart.test(_user_parts[i])) return false;
        }
    }
    if (options.ignore_max_length === false && (!(0, $b83b78063754cf87$var$_isByteLength.default)(user, {
        max: 64
    }) || !(0, $b83b78063754cf87$var$_isByteLength.default)(domain, {
        max: 254
    }))) return false;
    if (!(0, $b83b78063754cf87$var$_isFQDN.default)(domain, {
        require_tld: options.require_tld,
        ignore_max_length: options.ignore_max_length,
        allow_underscores: options.allow_underscores
    })) {
        if (!options.allow_ip_domain) return false;
        if (!(0, $b83b78063754cf87$var$_isIP.default)(domain)) {
            if (!domain.startsWith("[") || !domain.endsWith("]")) return false;
            var noBracketdomain = domain.slice(1, -1);
            if (noBracketdomain.length === 0 || !(0, $b83b78063754cf87$var$_isIP.default)(noBracketdomain)) return false;
        }
    }
    if (user[0] === '"') {
        user = user.slice(1, user.length - 1);
        return options.allow_utf8_local_part ? $b83b78063754cf87$var$quotedEmailUserUtf8.test(user) : $b83b78063754cf87$var$quotedEmailUser.test(user);
    }
    var pattern = options.allow_utf8_local_part ? $b83b78063754cf87$var$emailUserUtf8Part : $b83b78063754cf87$var$emailUserPart;
    var user_parts = user.split(".");
    for(var _i = 0; _i < user_parts.length; _i++){
        if (!pattern.test(user_parts[_i])) return false;
    }
    if (options.blacklisted_chars) {
        if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), "g")) !== -1) return false;
    }
    return true;
}
$b83b78063754cf87$exports = $b83b78063754cf87$exports.default;
$b83b78063754cf87$exports.default = $b83b78063754cf87$exports.default;


var $5ed07630ed21dadb$export$85ea93c7f196b8c3;
(function(MoovyFormRestrictions) {
    MoovyFormRestrictions.INPUT_MAX_CHARS = 255;
})($5ed07630ed21dadb$export$85ea93c7f196b8c3 || ($5ed07630ed21dadb$export$85ea93c7f196b8c3 = {}));
const $5ed07630ed21dadb$export$dda1dcb0216445cd = (phoneNumber)=>{
    if (!phoneNumber?.trim() || phoneNumber === (0, $f989e98d45efceaa$export$32ea325d92ea6082).PHONE_FI_COUNTRY_CODE) return true;
    return (0, $73c4811e9a17efad$export$992e2df24bec72ba)(phoneNumber);
};
const $5ed07630ed21dadb$export$dddb845077defee2 = (licensePlateNumber)=>{
    const pattern = /^[A-ZÅÄÖa-zåäö0-9\\s-]{2,10}$/;
    return !!licensePlateNumber && pattern.test(licensePlateNumber);
};
const $5ed07630ed21dadb$export$371e338370561054 = (email)=>{
    if (!email) return false;
    return (0, (/*@__PURE__*/$parcel$interopDefault($b83b78063754cf87$exports)))(email, {
        allow_utf8_local_part: false
    });
};


const $9ad25775b116f7f9$var$FormInvitation = (props)=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const getFormDefaultValues = ()=>{
        return {
            firstName: props.defaultValues?.firstName || "",
            lastName: props.defaultValues?.lastName || "",
            email: props.defaultValues?.email || ""
        };
    };
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $1T1QG.useState)(false);
    const [defaultValues, setDefaultValues] = (0, $1T1QG.useState)(getFormDefaultValues());
    (0, $1T1QG.useEffect)(()=>{
        setDefaultValues(getFormDefaultValues());
    }, [
        props.defaultValues?.firstName,
        props.defaultValues?.lastName,
        props.defaultValues?.email
    ]);
    const invitationSchema = ()=>{
        return $d7c41ae3ced691f5$export$be5493f9613cbbe().shape({
            firstName: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            lastName: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            email: $d7c41ae3ced691f5$export$22b082955e083ec3().test("email", intl.formatMessage({
                id: "common.form.errors.email"
            }), function(email) {
                return (0, $5ed07630ed21dadb$export$371e338370561054)(email);
            })
        });
    };
    const onSubmitFormValues = (values)=>{
        const { firstName: firstName, lastName: lastName, email: email } = values;
        props.onSubmit({
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            email: email.trim()
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $eUHG3.Formik), {
            validate: ()=>setFormikValidateOnChange(true),
            validationSchema: invitationSchema(),
            enableReinitialize: true,
            initialValues: defaultValues,
            validateOnChange: formikValidateOnChange,
            onSubmit: (values)=>{
                onSubmitFormValues(values);
            },
            children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $3Py8h.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: props.formReference,
                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                name: "firstName",
                                "data-testid": "firstName",
                                value: values.firstName,
                                autoFocus: true,
                                label: intl.formatMessage({
                                    id: "page.invitations.formInvitation.label.firstName"
                                }),
                                placeholder: intl.formatMessage({
                                    id: "page.invitations.formInvitation.label.firstName"
                                }),
                                onChange: handleChange,
                                error: !!errors.firstName,
                                errorText: errors.firstName
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                name: "lastName",
                                "data-testid": "lastName",
                                value: values.lastName,
                                label: intl.formatMessage({
                                    id: "page.invitations.formInvitation.label.lastName"
                                }),
                                placeholder: intl.formatMessage({
                                    id: "page.invitations.formInvitation.label.lastName"
                                }),
                                onChange: handleChange,
                                error: !!errors.lastName,
                                errorText: errors.lastName
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                name: "email",
                                "data-testid": "email",
                                value: values.email,
                                label: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "common.text.email"
                                }),
                                placeholder: intl.formatMessage({
                                    id: "common.text.email"
                                }),
                                onChange: handleChange,
                                error: !!errors.email,
                                errorText: errors.email
                            })
                        ]
                    })
                })
        })
    });
};
var $9ad25775b116f7f9$export$2e2bcd8739ae039 = $9ad25775b116f7f9$var$FormInvitation;




function $fb47a354e391b3c4$export$16bf6fe03653420f(value, message = "Reached unexpected case in exhaustive switch") {
    throw new Error(message);
}
const $fb47a354e391b3c4$export$8f98ff223296ded9 = (obj)=>{
    return obj && Object.keys(obj).some((key)=>obj[key] !== undefined);
};
const $fb47a354e391b3c4$export$b9d2d3b623c012b1 = (value, original)=>{
    if (!value) return undefined;
    if (!original) return value?.toString();
    if (typeof value === "number" && typeof original === "number") return value != original ? value.toString() : undefined;
    if (typeof value === "string" && typeof original === "string") return original.localeCompare(value.trim()) != 0 ? value : undefined;
    return undefined;
};
const $fb47a354e391b3c4$export$6d1c4f83343cbd5d = (avatarName)=>{
    if (!avatarName) return "";
    const spaceIndex = avatarName.lastIndexOf(" ");
    const secondIndex = spaceIndex === -1 ? avatarName.lastIndexOf("-") : spaceIndex;
    const firstChar = avatarName.substring(0, 1);
    const secondChar = avatarName.length > 1 ? avatarName.substring(secondIndex === -1 ? 1 : secondIndex + 1, secondIndex === -1 ? 2 : secondIndex + 2) : "";
    return `${firstChar}${secondChar}`.toUpperCase();
};
const $fb47a354e391b3c4$export$ec6ba75237411d31 = (jwtToken)=>{
    if (!jwtToken) return "";
    if (!jwtToken?.given_name && !jwtToken?.family_name) return jwtToken.name || "";
    else return jwtToken?.given_name ? `${jwtToken?.given_name} ${jwtToken?.family_name || ""}` : `${jwtToken?.family_name || ""}`;
};
const $fb47a354e391b3c4$export$ff20516246215bf = (first, second, separator = " ")=>{
    if (first) return second ? `${first}${separator}${second}` : first;
    else return second ? second : "";
};
const $fb47a354e391b3c4$export$ec9646ddc27ee461 = (totalCount, count, showTotal)=>{
    const slashPlusTotal = showTotal ? ` / ${totalCount} ` : " ";
    return `${count}${slashPlusTotal}${totalCount > 0 ? `(${Math.round(count / totalCount * 100)} %)` : "(0 %)"}`;
};
const $fb47a354e391b3c4$export$b34d9e7bbdff763e = (phoneNumber)=>{
    if (!phoneNumber?.trim()) return undefined;
    const trimmed = phoneNumber.trim();
    return trimmed !== (0, $f989e98d45efceaa$export$32ea325d92ea6082).PHONE_FI_COUNTRY_CODE ? trimmed : undefined;
};




class $ee8f4a42aaf5c361$export$b9721ef022f71a68 extends Error {
}
$ee8f4a42aaf5c361$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $ee8f4a42aaf5c361$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $ee8f4a42aaf5c361$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $ee8f4a42aaf5c361$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $ee8f4a42aaf5c361$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $ee8f4a42aaf5c361$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $ee8f4a42aaf5c361$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $ee8f4a42aaf5c361$var$base64UrlDecode(part);
    } catch (e) {
        throw new $ee8f4a42aaf5c361$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $ee8f4a42aaf5c361$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}


const $e88b4657ea1cb9ec$export$f023ae853add2e3e = (userPermissions, action, resource)=>{
    const userPermission = userPermissions.find((item)=>item.resource === resource);
    return userPermission?.action?.includes(action) || false;
};
const $e88b4657ea1cb9ec$var$getPermission = (actions, resource)=>{
    if (actions.includes("ALL")) return {
        action: [
            "READ",
            "CREATE",
            "EDIT",
            "DELETE"
        ],
        resource: resource
    };
    else return {
        action: actions,
        resource: resource
    };
};
const $e88b4657ea1cb9ec$var$getUserGroups = (userGroups)=>{
    const mapToUserGroups = (backendGroups)=>{
        return backendGroups.reduce((mappedGroups, group)=>{
            if ([
                "ADMIN",
                "SALE",
                "LANDLORD"
            ].includes(group)) mappedGroups.push(group);
            return mappedGroups;
        }, []);
    };
    const stringGroups = userGroups ? userGroups.split(",").map((item)=>item.toLocaleUpperCase()) : [];
    return mapToUserGroups(stringGroups);
};
const $e88b4657ea1cb9ec$export$fc970ed23da99565 = (userGroups)=>{
    const moovyUserGroups = $e88b4657ea1cb9ec$var$getUserGroups(userGroups);
    return moovyUserGroups.includes("ADMIN");
};
const $e88b4657ea1cb9ec$export$2571671736faa60a = (customerType)=>{
    return customerType === "T";
};
const $e88b4657ea1cb9ec$export$bd8b61dab9d38dea = (customerType, userGroups)=>{
    const moovyUserGroups = $e88b4657ea1cb9ec$var$getUserGroups(userGroups);
    // User belongs to admin user group
    if (moovyUserGroups.includes("ADMIN")) return [
        $e88b4657ea1cb9ec$var$getPermission([
            "READ",
            "EDIT",
            "DELETE"
        ], "ADMIN_PLACES"),
        $e88b4657ea1cb9ec$var$getPermission([
            "ALL"
        ], "LANDLORD_INVITATIONS"),
        $e88b4657ea1cb9ec$var$getPermission([
            "READ"
        ], "ADMIN_INVITATIONS"),
        $e88b4657ea1cb9ec$var$getPermission([
            "READ",
            "EDIT"
        ], "TENANT_INVITATIONS"),
        $e88b4657ea1cb9ec$var$getPermission([
            "READ",
            "EDIT",
            "DELETE"
        ], "PLACES"),
        $e88b4657ea1cb9ec$var$getPermission([
            "READ",
            "EDIT",
            "DELETE"
        ], "RIGHT_HOLDERS"),
        $e88b4657ea1cb9ec$var$getPermission([
            "READ",
            "EDIT",
            "DELETE"
        ], "CUSTOMER"),
        $e88b4657ea1cb9ec$var$getPermission([
            "READ",
            "EDIT",
            "DELETE"
        ], "RIGHTS"),
        $e88b4657ea1cb9ec$var$getPermission([
            "READ",
            "EDIT",
            "DELETE"
        ], "CATALOGUES"),
        $e88b4657ea1cb9ec$var$getPermission([
            "READ",
            "EDIT",
            "DELETE"
        ], "OFFERING"),
        $e88b4657ea1cb9ec$var$getPermission([
            "READ"
        ], "USERS")
    ];
    else if (customerType === "L") return [
        $e88b4657ea1cb9ec$var$getPermission([
            "ALL"
        ], "PLACES"),
        $e88b4657ea1cb9ec$var$getPermission([
            "ALL"
        ], "RIGHT_HOLDERS"),
        $e88b4657ea1cb9ec$var$getPermission([
            "ALL"
        ], "ADMIN_INVITATIONS"),
        $e88b4657ea1cb9ec$var$getPermission([
            "ALL"
        ], "TENANT_INVITATIONS"),
        $e88b4657ea1cb9ec$var$getPermission([
            "READ",
            "EDIT"
        ], "CUSTOMER"),
        $e88b4657ea1cb9ec$var$getPermission([
            "ALL"
        ], "RIGHTS"),
        $e88b4657ea1cb9ec$var$getPermission([
            "ALL"
        ], "CATALOGUES"),
        $e88b4657ea1cb9ec$var$getPermission([
            "ALL"
        ], "OFFERING"),
        $e88b4657ea1cb9ec$var$getPermission([
            "READ",
            "CREATE",
            "EDIT",
            "DELETE"
        ], "USERS"),
        $e88b4657ea1cb9ec$var$getPermission([
            "ALL"
        ], "CATALOGUE_REPORTS"),
        $e88b4657ea1cb9ec$var$getPermission([
            "ALL"
        ], "RIGHT_REPORTS")
    ];
    // These are the default permissions for all other logged users like Tenant customer
    return [
        $e88b4657ea1cb9ec$var$getPermission([
            "ALL"
        ], "RIGHT_HOLDERS"),
        $e88b4657ea1cb9ec$var$getPermission([
            "ALL"
        ], "ADMIN_INVITATIONS"),
        $e88b4657ea1cb9ec$var$getPermission([
            "READ",
            "EDIT"
        ], "CUSTOMER"),
        $e88b4657ea1cb9ec$var$getPermission([
            "ALL"
        ], "RIGHTS"),
        $e88b4657ea1cb9ec$var$getPermission([
            "ALL"
        ], "CATALOGUES"),
        $e88b4657ea1cb9ec$var$getPermission([
            "READ",
            "CREATE",
            "EDIT",
            "DELETE"
        ], "USERS"),
        $e88b4657ea1cb9ec$var$getPermission([
            "ALL"
        ], "RIGHT_REPORTS")
    ];
};
const $e88b4657ea1cb9ec$export$61147a57d3c24ac8 = {
    ROOT: "/",
    LOGIN_STEPS: "/login-steps",
    INVITATIONS: "/invitations",
    RIGHT_HOLDERS: "/right-holders",
    PLACES: "/places",
    CUSTOMERS: "/customers",
    REPORTS: "/reports",
    USERS: "/users",
    OFFERINGS: "/offerings",
    CATALOGUES: "/catalogues",
    RIGHTS: "/rights"
};
const $e88b4657ea1cb9ec$export$25c4819f1669a599 = {
    SUB_PLACES: "/sub-places"
};
const $e88b4657ea1cb9ec$var$Permissions = {
    appRoutes: $e88b4657ea1cb9ec$export$61147a57d3c24ac8,
    isAllowed: $e88b4657ea1cb9ec$export$f023ae853add2e3e,
    getUserPermission: $e88b4657ea1cb9ec$export$bd8b61dab9d38dea
};
var $e88b4657ea1cb9ec$export$2e2bcd8739ae039 = $e88b4657ea1cb9ec$var$Permissions;






var $e5Kd4 = parcelRequire("e5Kd4");
function $aec9cb90609a721c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $aec9cb90609a721c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $aec9cb90609a721c$export$2e2bcd8739ae039(o);
}



function $d15beb72c5107dec$export$2e2bcd8739ae039(input, hint) {
    if ((0, $aec9cb90609a721c$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $aec9cb90609a721c$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $72077ba063a1f0c8$export$2e2bcd8739ae039(arg) {
    var key = (0, $d15beb72c5107dec$export$2e2bcd8739ae039)(arg, "string");
    return (0, $aec9cb90609a721c$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $f189eff76c3cae99$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $72077ba063a1f0c8$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $30269af215bfdb7e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $30269af215bfdb7e$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $30269af215bfdb7e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f189eff76c3cae99$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $30269af215bfdb7e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $66da7c30c4e00e74$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $66da7c30c4e00e74$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $66da7c30c4e00e74$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $66da7c30c4e00e74$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $66da7c30c4e00e74$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $66da7c30c4e00e74$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $66da7c30c4e00e74$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $66da7c30c4e00e74$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $66da7c30c4e00e74$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($66da7c30c4e00e74$var$isDate(val)) return "date";
    if ($66da7c30c4e00e74$var$isError(val)) return "error";
    var constructorName = $66da7c30c4e00e74$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $66da7c30c4e00e74$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $66da7c30c4e00e74$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $66da7c30c4e00e74$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $66da7c30c4e00e74$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $66da7c30c4e00e74$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($66da7c30c4e00e74$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($66da7c30c4e00e74$var$formatProdErrorMessage(1));
        return enhancer($66da7c30c4e00e74$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($66da7c30c4e00e74$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($66da7c30c4e00e74$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($66da7c30c4e00e74$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($66da7c30c4e00e74$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($66da7c30c4e00e74$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$66da7c30c4e00e74$var$isPlainObject(action)) throw new Error($66da7c30c4e00e74$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($66da7c30c4e00e74$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($66da7c30c4e00e74$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($66da7c30c4e00e74$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $66da7c30c4e00e74$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($66da7c30c4e00e74$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$66da7c30c4e00e74$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $66da7c30c4e00e74$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$66da7c30c4e00e74$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $66da7c30c4e00e74$export$8928921ea2d3b126 = $66da7c30c4e00e74$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $66da7c30c4e00e74$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $66da7c30c4e00e74$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $66da7c30c4e00e74$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$66da7c30c4e00e74$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $66da7c30c4e00e74$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $66da7c30c4e00e74$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $66da7c30c4e00e74$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $66da7c30c4e00e74$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($66da7c30c4e00e74$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $66da7c30c4e00e74$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($66da7c30c4e00e74$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $66da7c30c4e00e74$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $66da7c30c4e00e74$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($66da7c30c4e00e74$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $66da7c30c4e00e74$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $66da7c30c4e00e74$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $66da7c30c4e00e74$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($66da7c30c4e00e74$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $66da7c30c4e00e74$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $66da7c30c4e00e74$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $66da7c30c4e00e74$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($66da7c30c4e00e74$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $66da7c30c4e00e74$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $30269af215bfdb7e$export$2e2bcd8739ae039)((0, $30269af215bfdb7e$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $0f6671734efafbe5$var$NOT_FOUND = "NOT_FOUND";
function $0f6671734efafbe5$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $0f6671734efafbe5$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $0f6671734efafbe5$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $0f6671734efafbe5$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $0f6671734efafbe5$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $0f6671734efafbe5$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $0f6671734efafbe5$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $0f6671734efafbe5$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $0f6671734efafbe5$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $0f6671734efafbe5$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $0f6671734efafbe5$var$createSingletonCache(comparator) : $0f6671734efafbe5$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $0f6671734efafbe5$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}


function $7ea0ccabdac12e74$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $7ea0ccabdac12e74$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $7ea0ccabdac12e74$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $7ea0ccabdac12e74$export$595d22ed68ca2841 = /* #__PURE__ */ $7ea0ccabdac12e74$export$5943f4447f6ef248((0, $0f6671734efafbe5$export$281bff7f05488aa2));
var $7ea0ccabdac12e74$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $7ea0ccabdac12e74$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $05e5ea7659e7e80b$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $05e5ea7659e7e80b$var$thunk = $05e5ea7659e7e80b$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$05e5ea7659e7e80b$var$thunk.withExtraArgument = $05e5ea7659e7e80b$var$createThunkMiddleware;
var $05e5ea7659e7e80b$export$2e2bcd8739ae039 = $05e5ea7659e7e80b$var$thunk;



var $7zvJK = parcelRequire("7zvJK");
var $5d190961bb0838a0$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5d190961bb0838a0$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5d190961bb0838a0$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $5d190961bb0838a0$var$__defProp = Object.defineProperty;
var $5d190961bb0838a0$var$__defProps = Object.defineProperties;
var $5d190961bb0838a0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $5d190961bb0838a0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5d190961bb0838a0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5d190961bb0838a0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5d190961bb0838a0$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $5d190961bb0838a0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $5d190961bb0838a0$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($5d190961bb0838a0$var$__hasOwnProp.call(b, prop)) $5d190961bb0838a0$var$__defNormalProp(a, prop, b[prop]);
    if ($5d190961bb0838a0$var$__getOwnPropSymbols) for(var _i = 0, _c = $5d190961bb0838a0$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($5d190961bb0838a0$var$__propIsEnum.call(b, prop)) $5d190961bb0838a0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5d190961bb0838a0$var$__spreadProps = function(a, b) {
    return $5d190961bb0838a0$var$__defProps(a, $5d190961bb0838a0$var$__getOwnPropDescs(b));
};
var $5d190961bb0838a0$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $5d190961bb0838a0$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $7ea0ccabdac12e74$export$595d22ed68ca2841).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $5d190961bb0838a0$var$__spreadArray([
            (0, $e5Kd4.isDraft)(value) ? (0, $e5Kd4.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $5d190961bb0838a0$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $66da7c30c4e00e74$export$f672e0b6f7222cd7;
    return (0, $66da7c30c4e00e74$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $5d190961bb0838a0$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $5d190961bb0838a0$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $5d190961bb0838a0$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $5d190961bb0838a0$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $5d190961bb0838a0$var$__spreadValues($5d190961bb0838a0$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $5d190961bb0838a0$export$b956e38827fca970(action) {
    return $5d190961bb0838a0$export$53b83ca8eaab0383(action) && "type" in action;
}
function $5d190961bb0838a0$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $5d190961bb0838a0$var$hasMatchFunction(action);
}
function $5d190961bb0838a0$export$ebd532f9034651f3(action) {
    return $5d190961bb0838a0$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($5d190961bb0838a0$var$isValidKey);
}
function $5d190961bb0838a0$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $5d190961bb0838a0$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $5d190961bb0838a0$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "' + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $5d190961bb0838a0$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $5d190961bb0838a0$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $5d190961bb0838a0$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $5d190961bb0838a0$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $5d190961bb0838a0$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $5d190961bb0838a0$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $5d190961bb0838a0$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $5d190961bb0838a0$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $5d190961bb0838a0$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $5d190961bb0838a0$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $5d190961bb0838a0$var$freezeDraftable(val) {
    return (0, $e5Kd4.isDraftable)(val) ? (0, $e5Kd4.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $5d190961bb0838a0$var$isProduction = true;
var $5d190961bb0838a0$var$prefix = "Invariant failed";
function $5d190961bb0838a0$var$invariant(condition, message) {
    if (condition) return;
    if ($5d190961bb0838a0$var$isProduction) throw new Error($5d190961bb0838a0$var$prefix);
    throw new Error($5d190961bb0838a0$var$prefix + ": " + (message || ""));
}
function $5d190961bb0838a0$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $5d190961bb0838a0$var$getSerialize(serializer, decycler), indent);
}
function $5d190961bb0838a0$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $5d190961bb0838a0$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $5d190961bb0838a0$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $5d190961bb0838a0$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $5d190961bb0838a0$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $5d190961bb0838a0$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $5d190961bb0838a0$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $5d190961bb0838a0$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $5d190961bb0838a0$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $5d190961bb0838a0$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $5d190961bb0838a0$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $5d190961bb0838a0$export$53b83ca8eaab0383(val);
}
function $5d190961bb0838a0$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $5d190961bb0838a0$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $5d190961bb0838a0$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $5d190961bb0838a0$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $5d190961bb0838a0$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$5d190961bb0838a0$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $5d190961bb0838a0$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $5d190961bb0838a0$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $5d190961bb0838a0$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $5d190961bb0838a0$export$36c1185aeee5b0a6(options);
    };
}
function $5d190961bb0838a0$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $5d190961bb0838a0$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($5d190961bb0838a0$var$isBoolean(thunk)) middlewareArray.push((0, $05e5ea7659e7e80b$export$2e2bcd8739ae039));
        else middlewareArray.push((0, $05e5ea7659e7e80b$export$2e2bcd8739ae039).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $5d190961bb0838a0$var$IS_PRODUCTION = true;
function $5d190961bb0838a0$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $5d190961bb0838a0$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($5d190961bb0838a0$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $66da7c30c4e00e74$export$66e4520cdb265d18)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$5d190961bb0838a0$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$5d190961bb0838a0$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $66da7c30c4e00e74$export$9ff26e0402cc7b7).apply(void 0, finalMiddleware);
    var finalCompose = (0, $66da7c30c4e00e74$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $5d190961bb0838a0$var$composeWithDevTools($5d190961bb0838a0$var$__spreadValues({
        trace: !$5d190961bb0838a0$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $5d190961bb0838a0$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $5d190961bb0838a0$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $66da7c30c4e00e74$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $5d190961bb0838a0$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $5d190961bb0838a0$var$isStateFunction(x) {
    return typeof x === "function";
}
var $5d190961bb0838a0$var$hasWarnedAboutObjectNotation = false;
function $5d190961bb0838a0$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $5d190961bb0838a0$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($5d190961bb0838a0$var$isStateFunction(initialState)) getInitialState = function() {
        return $5d190961bb0838a0$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $5d190961bb0838a0$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $5d190961bb0838a0$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $e5Kd4.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $e5Kd4.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $e5Kd4.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $5d190961bb0838a0$var$hasWarnedAboutObjectNotation2 = false;
function $5d190961bb0838a0$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $5d190961bb0838a0$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $7zvJK;
    var initialState = typeof options.initialState == "function" ? options.initialState : $5d190961bb0838a0$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $5d190961bb0838a0$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $5d190961bb0838a0$export$309c7a02b0b0bc62(type, prepareCallback) : $5d190961bb0838a0$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $5d190961bb0838a0$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $5d190961bb0838a0$var$__spreadValues($5d190961bb0838a0$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $5d190961bb0838a0$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $5d190961bb0838a0$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $5d190961bb0838a0$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($5d190961bb0838a0$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $5d190961bb0838a0$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $5d190961bb0838a0$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $5d190961bb0838a0$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $5d190961bb0838a0$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $5d190961bb0838a0$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $5d190961bb0838a0$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $5d190961bb0838a0$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $5d190961bb0838a0$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $5d190961bb0838a0$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $5d190961bb0838a0$var$createSingleArgumentStateOperator(mutator) {
    var operator = $5d190961bb0838a0$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $5d190961bb0838a0$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $5d190961bb0838a0$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $e5Kd4.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $e5Kd4.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $5d190961bb0838a0$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $5d190961bb0838a0$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $5d190961bb0838a0$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $5d190961bb0838a0$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $5d190961bb0838a0$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $5d190961bb0838a0$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $5d190961bb0838a0$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $5d190961bb0838a0$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $5d190961bb0838a0$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $5d190961bb0838a0$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $5d190961bb0838a0$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $5d190961bb0838a0$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $5d190961bb0838a0$var$__spreadValues($5d190961bb0838a0$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $5d190961bb0838a0$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $5d190961bb0838a0$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $5d190961bb0838a0$var$createStateOperator(addOneMutably),
        addMany: $5d190961bb0838a0$var$createStateOperator(addManyMutably),
        setOne: $5d190961bb0838a0$var$createStateOperator(setOneMutably),
        setMany: $5d190961bb0838a0$var$createStateOperator(setManyMutably),
        setAll: $5d190961bb0838a0$var$createStateOperator(setAllMutably),
        updateOne: $5d190961bb0838a0$var$createStateOperator(updateOneMutably),
        updateMany: $5d190961bb0838a0$var$createStateOperator(updateManyMutably),
        upsertOne: $5d190961bb0838a0$var$createStateOperator(upsertOneMutably),
        upsertMany: $5d190961bb0838a0$var$createStateOperator(upsertManyMutably),
        removeOne: $5d190961bb0838a0$var$createStateOperator(removeOneMutably),
        removeMany: $5d190961bb0838a0$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $5d190961bb0838a0$var$createSortedStateAdapter(selectId, sort) {
    var _c = $5d190961bb0838a0$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $5d190961bb0838a0$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($5d190961bb0838a0$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $5d190961bb0838a0$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $5d190961bb0838a0$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $5d190961bb0838a0$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $5d190961bb0838a0$var$createStateOperator(addOneMutably),
        updateOne: $5d190961bb0838a0$var$createStateOperator(updateOneMutably),
        upsertOne: $5d190961bb0838a0$var$createStateOperator(upsertOneMutably),
        setOne: $5d190961bb0838a0$var$createStateOperator(setOneMutably),
        setMany: $5d190961bb0838a0$var$createStateOperator(setManyMutably),
        setAll: $5d190961bb0838a0$var$createStateOperator(setAllMutably),
        addMany: $5d190961bb0838a0$var$createStateOperator(addManyMutably),
        updateMany: $5d190961bb0838a0$var$createStateOperator(updateManyMutably),
        upsertMany: $5d190961bb0838a0$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $5d190961bb0838a0$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $5d190961bb0838a0$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $5d190961bb0838a0$var$createInitialStateFactory();
    var selectorsFactory = $5d190961bb0838a0$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $5d190961bb0838a0$var$createSortedStateAdapter(selectId, sortComparer) : $5d190961bb0838a0$var$createUnsortedStateAdapter(selectId);
    return $5d190961bb0838a0$var$__spreadValues($5d190961bb0838a0$var$__spreadValues($5d190961bb0838a0$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $5d190961bb0838a0$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $5d190961bb0838a0$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $5d190961bb0838a0$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $5d190961bb0838a0$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $5d190961bb0838a0$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $5d190961bb0838a0$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $5d190961bb0838a0$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $5d190961bb0838a0$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $5d190961bb0838a0$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $5d190961bb0838a0$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $5d190961bb0838a0$var$__spreadProps($5d190961bb0838a0$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $5d190961bb0838a0$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $5d190961bb0838a0$var$__spreadProps($5d190961bb0838a0$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $5d190961bb0838a0$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $5d190961bb0838a0$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $5d190961bb0838a0$var$__spreadProps($5d190961bb0838a0$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $5d190961bb0838a0$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $5d190961bb0838a0$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $5d190961bb0838a0$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$5d190961bb0838a0$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $5d190961bb0838a0$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $5d190961bb0838a0$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $5d190961bb0838a0$var$RejectWithValue) throw result;
                                                if (result instanceof $5d190961bb0838a0$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $5d190961bb0838a0$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($5d190961bb0838a0$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $5d190961bb0838a0$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $5d190961bb0838a0$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $5d190961bb0838a0$var$matches = function(matcher, action) {
    if ($5d190961bb0838a0$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $5d190961bb0838a0$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $5d190961bb0838a0$var$matches(matcher, action);
        });
    };
}
function $5d190961bb0838a0$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $5d190961bb0838a0$var$matches(matcher, action);
        });
    };
}
function $5d190961bb0838a0$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $5d190961bb0838a0$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $5d190961bb0838a0$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $5d190961bb0838a0$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$5d190961bb0838a0$var$isAsyncThunkArray(asyncThunks)) return $5d190961bb0838a0$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $5d190961bb0838a0$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $5d190961bb0838a0$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $5d190961bb0838a0$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$5d190961bb0838a0$var$isAsyncThunkArray(asyncThunks)) return $5d190961bb0838a0$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $5d190961bb0838a0$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $5d190961bb0838a0$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $5d190961bb0838a0$export$9dd1fb32974da385($5d190961bb0838a0$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$5d190961bb0838a0$var$isAsyncThunkArray(asyncThunks)) return $5d190961bb0838a0$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $5d190961bb0838a0$export$9dd1fb32974da385($5d190961bb0838a0$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $5d190961bb0838a0$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $5d190961bb0838a0$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$5d190961bb0838a0$var$isAsyncThunkArray(asyncThunks)) return $5d190961bb0838a0$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $5d190961bb0838a0$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $5d190961bb0838a0$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $5d190961bb0838a0$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$5d190961bb0838a0$var$isAsyncThunkArray(asyncThunks)) return $5d190961bb0838a0$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $5d190961bb0838a0$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $5d190961bb0838a0$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $5d190961bb0838a0$var$noop = function() {};
var $5d190961bb0838a0$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $5d190961bb0838a0$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $5d190961bb0838a0$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $5d190961bb0838a0$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $5d190961bb0838a0$var$task = "task";
var $5d190961bb0838a0$var$listener = "listener";
var $5d190961bb0838a0$var$completed = "completed";
var $5d190961bb0838a0$var$cancelled = "cancelled";
var $5d190961bb0838a0$var$taskCancelled = "task-" + $5d190961bb0838a0$var$cancelled;
var $5d190961bb0838a0$var$taskCompleted = "task-" + $5d190961bb0838a0$var$completed;
var $5d190961bb0838a0$var$listenerCancelled = $5d190961bb0838a0$var$listener + "-" + $5d190961bb0838a0$var$cancelled;
var $5d190961bb0838a0$var$listenerCompleted = $5d190961bb0838a0$var$listener + "-" + $5d190961bb0838a0$var$completed;
var $5d190961bb0838a0$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $5d190961bb0838a0$var$task + " " + $5d190961bb0838a0$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $5d190961bb0838a0$var$validateActive = function(signal) {
    if (signal.aborted) throw new $5d190961bb0838a0$export$cb1bdac908fed7f(signal.reason);
};
function $5d190961bb0838a0$var$raceWithSignal(signal, promise2) {
    var cleanup = $5d190961bb0838a0$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $5d190961bb0838a0$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $5d190961bb0838a0$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $5d190961bb0838a0$var$noop;
    });
}
var $5d190961bb0838a0$var$runTask = function(task2, cleanUp) {
    return $5d190961bb0838a0$var$__async(void 0, null, function() {
        var value, error_1;
        return $5d190961bb0838a0$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $5d190961bb0838a0$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $5d190961bb0838a0$var$createPause = function(signal) {
    return function(promise2) {
        return $5d190961bb0838a0$var$catchRejection($5d190961bb0838a0$var$raceWithSignal(signal, promise2).then(function(output) {
            $5d190961bb0838a0$var$validateActive(signal);
            return output;
        }));
    };
};
var $5d190961bb0838a0$var$createDelay = function(signal) {
    var pause = $5d190961bb0838a0$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $5d190961bb0838a0$var$assign = Object.assign;
var $5d190961bb0838a0$var$INTERNAL_NIL_TOKEN = {};
var $5d190961bb0838a0$var$alm = "listenerMiddleware";
var $5d190961bb0838a0$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $5d190961bb0838a0$var$addAbortSignalListener(parentAbortSignal, function() {
            return $5d190961bb0838a0$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $5d190961bb0838a0$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $5d190961bb0838a0$var$runTask(function() {
            return $5d190961bb0838a0$var$__async(void 0, null, function() {
                var result2;
                return $5d190961bb0838a0$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $5d190961bb0838a0$var$validateActive(parentAbortSignal);
                            $5d190961bb0838a0$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $5d190961bb0838a0$var$createPause(childAbortController.signal),
                                    delay: $5d190961bb0838a0$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $5d190961bb0838a0$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $5d190961bb0838a0$var$abortControllerWithReason(childAbortController, $5d190961bb0838a0$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $5d190961bb0838a0$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $5d190961bb0838a0$var$abortControllerWithReason(childAbortController, $5d190961bb0838a0$var$taskCancelled);
            }
        };
    };
};
var $5d190961bb0838a0$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $5d190961bb0838a0$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $5d190961bb0838a0$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $5d190961bb0838a0$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $5d190961bb0838a0$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $5d190961bb0838a0$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $5d190961bb0838a0$var$catchRejection(take(predicate, timeout));
    };
};
var $5d190961bb0838a0$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $5d190961bb0838a0$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $5d190961bb0838a0$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $5d190961bb0838a0$var$createListenerEntry = function(options) {
    var _c = $5d190961bb0838a0$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $5d190961bb0838a0$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $5d190961bb0838a0$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $5d190961bb0838a0$var$abortControllerWithReason(controller, $5d190961bb0838a0$var$listenerCancelled);
    });
};
var $5d190961bb0838a0$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($5d190961bb0838a0$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $5d190961bb0838a0$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $5d190961bb0838a0$export$f03a6b845d3fb58b = $5d190961bb0838a0$export$309c7a02b0b0bc62($5d190961bb0838a0$var$alm + "/add");
var $5d190961bb0838a0$export$b1b8022855fb2b71 = $5d190961bb0838a0$export$309c7a02b0b0bc62($5d190961bb0838a0$var$alm + "/removeAll");
var $5d190961bb0838a0$export$b03e9483f936dccb = $5d190961bb0838a0$export$309c7a02b0b0bc62($5d190961bb0838a0$var$alm + "/remove");
var $5d190961bb0838a0$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $5d190961bb0838a0$var$__spreadArray([
        $5d190961bb0838a0$var$alm + "/error"
    ], args));
};
function $5d190961bb0838a0$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $5d190961bb0838a0$var$defaultErrorHandler : _c;
    $5d190961bb0838a0$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $5d190961bb0838a0$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $5d190961bb0838a0$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $5d190961bb0838a0$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $5d190961bb0838a0$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $5d190961bb0838a0$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $5d190961bb0838a0$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $5d190961bb0838a0$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $5d190961bb0838a0$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $5d190961bb0838a0$var$createDelay(internalTaskController.signal),
                                pause: $5d190961bb0838a0$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $5d190961bb0838a0$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $5d190961bb0838a0$var$abortControllerWithReason(controller, $5d190961bb0838a0$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $5d190961bb0838a0$export$cb1bdac908fed7f)) $5d190961bb0838a0$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $5d190961bb0838a0$var$abortControllerWithReason(internalTaskController, $5d190961bb0838a0$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $5d190961bb0838a0$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$5d190961bb0838a0$export$b956e38827fca970(action)) return next(action);
                if ($5d190961bb0838a0$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($5d190961bb0838a0$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($5d190961bb0838a0$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $5d190961bb0838a0$var$INTERNAL_NIL_TOKEN) throw new Error($5d190961bb0838a0$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $5d190961bb0838a0$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $5d190961bb0838a0$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $5d190961bb0838a0$export$8fb31c0f05df007b = "RTK_autoBatch";
var $5d190961bb0838a0$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$5d190961bb0838a0$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $5d190961bb0838a0$var$promise;
var $5d190961bb0838a0$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($5d190961bb0838a0$var$promise || ($5d190961bb0838a0$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $5d190961bb0838a0$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $5d190961bb0838a0$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $5d190961bb0838a0$var$createQueueWithTimer(10);
var $5d190961bb0838a0$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $5d190961bb0838a0$var$queueMicrotaskShim : options.type === "raf" ? $5d190961bb0838a0$var$rAF : options.type === "callback" ? options.queueNotification : $5d190961bb0838a0$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$5d190961bb0838a0$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $e5Kd4.enableES5)();


const $1b8d920c7c0aec35$var$stateKey = "moovyAuth";
const $1b8d920c7c0aec35$var$initialState = {
    token: sessionStorage.getItem((0, $5ce8806ad70988a5$export$cb43794bb023e720)) || "",
    roles: [],
    userGroups: undefined,
    customerType: sessionStorage.getItem((0, $5ce8806ad70988a5$export$85978fd627e990d0)) || ""
};
const $1b8d920c7c0aec35$var$slice = (0, $5d190961bb0838a0$export$4d8d9bd83c24ae8b)({
    name: $1b8d920c7c0aec35$var$stateKey,
    initialState: $1b8d920c7c0aec35$var$initialState,
    reducers: {
        setAuthentication (state, action) {
            sessionStorage.setItem((0, $5ce8806ad70988a5$export$cb43794bb023e720), action.payload.token);
            state.token = action.payload.token;
            state.userGroups = action.payload.userGroups || "";
        },
        setToken (state, action) {
            const token = action.payload;
            sessionStorage.setItem((0, $5ce8806ad70988a5$export$cb43794bb023e720), token);
            state.token = token;
        },
        setCustomerType (state, action) {
            const customerType = action.payload;
            sessionStorage.setItem((0, $5ce8806ad70988a5$export$85978fd627e990d0), customerType);
            state.customerType = customerType;
        }
    }
});
var $1b8d920c7c0aec35$export$2e2bcd8739ae039 = $1b8d920c7c0aec35$var$slice.reducer;
const { setAuthentication: $1b8d920c7c0aec35$export$f10e7701d84a9c6, setToken: $1b8d920c7c0aec35$export$57e714f81a2c3d86, setCustomerType: $1b8d920c7c0aec35$export$246c2e82063be8d6 } = $1b8d920c7c0aec35$var$slice.actions;
const $1b8d920c7c0aec35$export$4cea0d77065449b7 = (payload)=>{
    return $1b8d920c7c0aec35$export$f10e7701d84a9c6(payload);
};
const $1b8d920c7c0aec35$export$518555436e9546c = (payload)=>{
    return $1b8d920c7c0aec35$export$57e714f81a2c3d86(payload);
};
const $1b8d920c7c0aec35$export$3160f67d8720ec42 = (payload)=>{
    return $1b8d920c7c0aec35$export$246c2e82063be8d6(payload);
};
const $1b8d920c7c0aec35$export$196bba85bc5ca29e = {
    getShortUsername: (state)=>{
        const decodedToken = state[$1b8d920c7c0aec35$var$stateKey]?.token && (0, $ee8f4a42aaf5c361$export$fa1e2fb699b7861e)(state[$1b8d920c7c0aec35$var$stateKey]?.token);
        return (0, $fb47a354e391b3c4$export$6d1c4f83343cbd5d)((0, $fb47a354e391b3c4$export$ec6ba75237411d31)(decodedToken));
    },
    getToken: (state)=>state[$1b8d920c7c0aec35$var$stateKey]?.token,
    getCustomerType: (state)=>state[$1b8d920c7c0aec35$var$stateKey]?.customerType,
    getUserGroups: (state)=>state[$1b8d920c7c0aec35$var$stateKey]?.userGroups,
    getRoles: (state)=>state[$1b8d920c7c0aec35$var$stateKey]?.roles,
    isAuthenticated: (state)=>{
        return !!state[$1b8d920c7c0aec35$var$stateKey]?.token;
    }
};


// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $3wB3x = parcelRequire("3wB3x");
var $719e376fd7bf7a88$exports = {};
"use strict";

$719e376fd7bf7a88$exports = (parcelRequire("eAFD6"));





// Default to a dummy "batch" implementation that just runs the callback
function $3940035e46495c18$var$defaultNoopBatch(callback) {
    callback();
}
let $3940035e46495c18$var$batch = $3940035e46495c18$var$defaultNoopBatch; // Allow injecting another batching function later
const $3940035e46495c18$export$4b9874722d0da7bc = (newBatch)=>$3940035e46495c18$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $3940035e46495c18$export$fc47d4c0ba3bd2c6 = ()=>$3940035e46495c18$var$batch;



var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");
const $f621653964eaafdf$var$ContextKey = Symbol.for(`react-redux-context`);
const $f621653964eaafdf$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $f621653964eaafdf$var$getContext() {
    var _gT$ContextKey;
    if (!$1T1QG.createContext) return {};
    const contextMap = (_gT$ContextKey = $f621653964eaafdf$var$gT[$f621653964eaafdf$var$ContextKey]) != null ? _gT$ContextKey : $f621653964eaafdf$var$gT[$f621653964eaafdf$var$ContextKey] = new Map();
    let realContext = contextMap.get($1T1QG.createContext);
    if (!realContext) {
        realContext = $1T1QG.createContext(null);
        contextMap.set($1T1QG.createContext, realContext);
    }
    return realContext;
}
const $f621653964eaafdf$export$cc80c08dc91f1c00 = /*#__PURE__*/ $f621653964eaafdf$var$getContext();
var $f621653964eaafdf$export$2e2bcd8739ae039 = $f621653964eaafdf$export$cc80c08dc91f1c00;


function $a887eeb8c389361f$export$d4d6226d5fc61558(context = (0, $f621653964eaafdf$export$cc80c08dc91f1c00)) {
    return function useReduxContext() {
        const contextValue = (0, $1T1QG.useContext)(context);
        return contextValue;
    };
}
const $a887eeb8c389361f$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $a887eeb8c389361f$export$d4d6226d5fc61558();



const $a01158e3fdfd2cd6$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};


let $c354137c2cb06a61$var$useSyncExternalStoreWithSelector = (0, $a01158e3fdfd2cd6$export$20656a4825650bd0);
const $c354137c2cb06a61$export$e2e6e3f3f3b782e3 = (fn)=>{
    $c354137c2cb06a61$var$useSyncExternalStoreWithSelector = fn;
};
const $c354137c2cb06a61$var$refEquality = (a, b)=>a === b;
function $c354137c2cb06a61$export$2b53f90d2bd1cbfb(context = (0, $f621653964eaafdf$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $f621653964eaafdf$export$cc80c08dc91f1c00) ? (0, $a887eeb8c389361f$export$c1275ca9a6fd3ec5) : (0, $a887eeb8c389361f$export$d4d6226d5fc61558)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $c354137c2cb06a61$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $1T1QG.useRef)(true);
        const wrappedSelector = (0, $1T1QG.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $c354137c2cb06a61$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $1T1QG.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $c354137c2cb06a61$export$2105062e25df4afe = /*#__PURE__*/ $c354137c2cb06a61$export$2b53f90d2bd1cbfb();



var $5ljFx = parcelRequire("5ljFx");
function $272f806d4de5052e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $3HlGj = parcelRequire("3HlGj");

var $1T1QG = parcelRequire("1T1QG");
var $3468aa03708ccf6e$exports = {};
"use strict";

$3468aa03708ccf6e$exports = (parcelRequire("dhnvT"));



/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $1af2fcdce2ed6c1f$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $6980ab004284ca07$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $1af2fcdce2ed6c1f$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $6980ab004284ca07$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $6980ab004284ca07$var$verify(mapStateToProps, "mapStateToProps");
    $6980ab004284ca07$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $6980ab004284ca07$var$verify(mergeProps, "mergeProps");
}


const $22fa7287586502ac$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $22fa7287586502ac$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $22fa7287586502ac$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $272f806d4de5052e$export$2e2bcd8739ae039)(_ref, $22fa7287586502ac$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $22fa7287586502ac$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $9eaf996c14a2ef37$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $c7dda336e7cf1e5e$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $d30861de9deeb060$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $c7dda336e7cf1e5e$export$2e2bcd8739ae039)(value)) (0, $1af2fcdce2ed6c1f$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $ba7088a98713c327$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $ba7088a98713c327$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $ba7088a98713c327$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $ba7088a98713c327$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $ba7088a98713c327$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $0210116fb454e3eb$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $d110739acc10261e$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $ba7088a98713c327$export$710f7c60f68acd3e)((dispatch)=>(0, $9eaf996c14a2ef37$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $ba7088a98713c327$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $ba7088a98713c327$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : (0, $0210116fb454e3eb$export$19ef7b929f7e2559)(mapDispatchToProps, "mapDispatchToProps");
}




function $2a74e2ecbcd163cf$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $ba7088a98713c327$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === "function" ? (0, $ba7088a98713c327$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : (0, $0210116fb454e3eb$export$19ef7b929f7e2559)(mapStateToProps, "mapStateToProps");
}



var $5ljFx = parcelRequire("5ljFx");


function $ea86c64c039e81b6$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $5ljFx.default)({}, ownProps, stateProps, dispatchProps);
}
function $ea86c64c039e81b6$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $ea86c64c039e81b6$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$ea86c64c039e81b6$export$691c327fc30bc857 : typeof mergeProps === "function" ? $ea86c64c039e81b6$export$5b105939c84b5234(mergeProps) : (0, $0210116fb454e3eb$export$19ef7b929f7e2559)(mergeProps, "mergeProps");
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $fcdb9f4f2c232f65$var$createListenerCollection() {
    const batch = (0, $3940035e46495c18$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $fcdb9f4f2c232f65$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $fcdb9f4f2c232f65$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $fcdb9f4f2c232f65$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $fcdb9f4f2c232f65$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $fcdb9f4f2c232f65$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $1T1QG = parcelRequire("1T1QG");
const $d5c3b1525df95353$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $d5c3b1525df95353$export$700979bc83e7db82 = $d5c3b1525df95353$export$71594e8a50f746f4 ? $1T1QG.useLayoutEffect : $1T1QG.useEffect;


function $fa23b58c2a4170cf$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $fa23b58c2a4170cf$export$2e2bcd8739ae039(objA, objB) {
    if ($fa23b58c2a4170cf$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$fa23b58c2a4170cf$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $6a323ced4db94efb$var$_excluded = [
    "reactReduxForwardedRef"
];
let $6a323ced4db94efb$var$useSyncExternalStore = (0, $a01158e3fdfd2cd6$export$20656a4825650bd0);
const $6a323ced4db94efb$export$36d45daa6a4925b8 = (fn)=>{
    $6a323ced4db94efb$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $6a323ced4db94efb$var$EMPTY_ARRAY = [
    null,
    0
];
const $6a323ced4db94efb$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $6a323ced4db94efb$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $6a323ced4db94efb$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $d5c3b1525df95353$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $6a323ced4db94efb$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $6a323ced4db94efb$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $6a323ced4db94efb$var$initStateUpdates = ()=>$6a323ced4db94efb$var$EMPTY_ARRAY;
function $6a323ced4db94efb$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $6a323ced4db94efb$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $6a323ced4db94efb$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $6a323ced4db94efb$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $fa23b58c2a4170cf$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $fa23b58c2a4170cf$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $fa23b58c2a4170cf$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $f621653964eaafdf$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $2a74e2ecbcd163cf$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $d110739acc10261e$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $ea86c64c039e81b6$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $1T1QG.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $272f806d4de5052e$export$2e2bcd8739ae039)(props, $6a323ced4db94efb$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $1T1QG.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $3468aa03708ccf6e$exports.isContextConsumer)(/*#__PURE__*/ $1T1QG.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $1T1QG.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $1T1QG.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $22fa7287586502ac$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $1T1QG.useMemo(()=>{
                if (!shouldHandleStateChanges) return $6a323ced4db94efb$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $fcdb9f4f2c232f65$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $1T1QG.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $5ljFx.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $1T1QG.useRef();
            const lastWrapperProps = $1T1QG.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $1T1QG.useRef();
            const renderIsScheduled = $1T1QG.useRef(false);
            const isProcessingDispatch = $1T1QG.useRef(false);
            const isMounted = $1T1QG.useRef(false);
            const latestSubscriptionCallbackError = $1T1QG.useRef();
            (0, $d5c3b1525df95353$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $1T1QG.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $1T1QG.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $6a323ced4db94efb$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $6a323ced4db94efb$var$useIsomorphicLayoutEffectWithArgs($6a323ced4db94efb$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $6a323ced4db94efb$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $d5c3b1525df95353$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $1T1QG.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $1T1QG.createElement(WrappedComponent, (0, $5ljFx.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $1T1QG.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $1T1QG.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $1T1QG.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $1T1QG.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $1T1QG.createElement(Connect, (0, $5ljFx.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($3HlGj)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($3HlGj)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $6a323ced4db94efb$export$2e2bcd8739ae039 = $6a323ced4db94efb$var$connect;



var $1T1QG = parcelRequire("1T1QG");



function $c0f5ae171f734a84$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = $1T1QG.useMemo(()=>{
        const subscription = (0, $fcdb9f4f2c232f65$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $1T1QG.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $d5c3b1525df95353$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $f621653964eaafdf$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $1T1QG.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $c0f5ae171f734a84$export$2e2bcd8739ae039 = $c0f5ae171f734a84$var$Provider;







function $3333455ae780049a$export$671dba69185d0304(context = (0, $f621653964eaafdf$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $f621653964eaafdf$export$cc80c08dc91f1c00) ? (0, $a887eeb8c389361f$export$c1275ca9a6fd3ec5) : (0, $a887eeb8c389361f$export$d4d6226d5fc61558)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $3333455ae780049a$export$6ccbb43953eebf8 = /*#__PURE__*/ $3333455ae780049a$export$671dba69185d0304();


function $4a938932ca693376$export$bc9b55530897c558(context = (0, $f621653964eaafdf$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $f621653964eaafdf$export$cc80c08dc91f1c00) ? (0, $3333455ae780049a$export$6ccbb43953eebf8) : (0, $3333455ae780049a$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $4a938932ca693376$export$8ad76b76a4c905f8 = /*#__PURE__*/ $4a938932ca693376$export$bc9b55530897c558();









(0, $c354137c2cb06a61$export$e2e6e3f3f3b782e3)((0, $719e376fd7bf7a88$exports.useSyncExternalStoreWithSelector));
(0, $6a323ced4db94efb$export$36d45daa6a4925b8)((0, $3wB3x.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $3940035e46495c18$export$4b9874722d0da7bc)((0, $27f1df944e3d0485$exports.unstable_batchedUpdates));


function $e39fe3a403501733$export$2e2bcd8739ae039() {
    const dispatch = (0, $4a938932ca693376$export$8ad76b76a4c905f8)();
    const setAuthentication = (value)=>dispatch((0, $1b8d920c7c0aec35$export$4cea0d77065449b7)(value));
    const setToken = (value)=>dispatch((0, $1b8d920c7c0aec35$export$518555436e9546c)(value));
    const setCustomerType = (value)=>dispatch((0, $1b8d920c7c0aec35$export$3160f67d8720ec42)(value));
    const customerType = (0, $c354137c2cb06a61$export$2105062e25df4afe)((0, $1b8d920c7c0aec35$export$196bba85bc5ca29e).getCustomerType);
    const tenant = (0, $e88b4657ea1cb9ec$export$2571671736faa60a)(customerType);
    const isAuthenticated = (0, $c354137c2cb06a61$export$2105062e25df4afe)((0, $1b8d920c7c0aec35$export$196bba85bc5ca29e).isAuthenticated);
    const roles = (0, $c354137c2cb06a61$export$2105062e25df4afe)((0, $1b8d920c7c0aec35$export$196bba85bc5ca29e).getRoles);
    const userGroups = (0, $c354137c2cb06a61$export$2105062e25df4afe)((0, $1b8d920c7c0aec35$export$196bba85bc5ca29e).getUserGroups);
    const admin = (0, $e88b4657ea1cb9ec$export$fc970ed23da99565)(userGroups);
    const token = (0, $c354137c2cb06a61$export$2105062e25df4afe)((0, $1b8d920c7c0aec35$export$196bba85bc5ca29e).getToken);
    const decodedToken = token ? (0, $ee8f4a42aaf5c361$export$fa1e2fb699b7861e)(token) : null;
    const usernameShort = (0, $c354137c2cb06a61$export$2105062e25df4afe)((0, $1b8d920c7c0aec35$export$196bba85bc5ca29e).getShortUsername);
    const isPermission = (action, resource)=>{
        const userPermissions = (0, $e88b4657ea1cb9ec$export$bd8b61dab9d38dea)(customerType, userGroups);
        return userPermissions.length > 0 && (0, $e88b4657ea1cb9ec$export$f023ae853add2e3e)(userPermissions, action, resource);
    };
    return {
        setAuthentication: setAuthentication,
        setToken: setToken,
        setCustomerType: setCustomerType,
        isAuthenticated: isAuthenticated,
        customerType: customerType,
        roles: roles,
        token: token,
        decodedToken: decodedToken,
        isPermission: isPermission,
        userGroups: userGroups,
        tenant: tenant,
        admin: admin,
        usernameShort: usernameShort
    };
}



const $0444d6d626e783e4$var$ModalAddInvitation = ({ open: open, addingInvitationParams: addingInvitationParams, onSubmit: onSubmit, onCancel: onCancel })=>{
    const FORM_REFERENCE = "formAddInvitation";
    const { admin: admin } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const createLandlordInvitationMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $9f8b36004207981d$export$2e2bcd8739ae039).createLandlordInvitation(admin, dto),
        onSuccess: (response)=>{
            const invitation = response.data || {};
            onSubmit(invitation);
        }
    });
    const createTenantInvitationMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $9f8b36004207981d$export$2e2bcd8739ae039).createTenantWithCatalogueInvitation(dto),
        onSuccess: (response)=>{
            const invitation = response.data || {};
            onSubmit(invitation);
        }
    });
    const createInvitation = (values)=>{
        const { firstName: firstName, lastName: lastName, email: email } = values;
        const name = (0, $fb47a354e391b3c4$export$ff20516246215bf)(firstName, lastName);
        const { invitationType: invitationType, landlordId: landlordId, tenantId: tenantId, catalogueId: catalogueId } = addingInvitationParams;
        switch(invitationType){
            case "TENANT":
                if (landlordId && tenantId && catalogueId) {
                    const dtoTenant = {
                        type: "TENANT_WITH_CATALOGUE",
                        name: name,
                        email: email,
                        landlordId: landlordId,
                        tenantId: tenantId,
                        catalogueId: catalogueId
                    };
                    createTenantInvitationMutation.mutate(dtoTenant);
                }
                break;
            case "LANDLORD":
                const dtoLandlord = {
                    name: name,
                    email: email
                };
                createLandlordInvitationMutation.mutate(dtoLandlord);
                break;
            case "ADMIN":
                if (landlordId) {
                    const dtoAdmin = {
                        type: "LANDLORD",
                        name: name,
                        email: email,
                        landlordId: landlordId
                    };
                    createLandlordInvitationMutation.mutate(dtoAdmin);
                }
                break;
            default:
                (0, $fb47a354e391b3c4$export$16bf6fe03653420f)(invitationType);
        }
    };
    const cancel = ()=>{
        createLandlordInvitationMutation.reset();
        createTenantInvitationMutation.reset();
        onCancel();
    };
    const TitleText = ()=>{
        const { invitationType: invitationType } = addingInvitationParams;
        switch(invitationType){
            case "TENANT":
                return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "page.invitations.modalAddInvitation.tenant.title"
                });
            case "LANDLORD":
                return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "page.invitations.modalAddInvitation.landlord.title"
                });
            case "ADMIN":
                return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "page.invitations.modalAddInvitation.tenant.title"
                });
            default:
                return "";
        }
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $259d9dbb3544503a$export$2e2bcd8739ae039), {
            open: open,
            onCancel: cancel,
            formReference: FORM_REFERENCE,
            errorTitleKey: "common.actions.add.error",
            modalTitle: /*#__PURE__*/ (0, $3Py8h.jsx)(TitleText, {}),
            submitButtonContent: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "common.buttons.add"
            }),
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsxs)("div", {
                    style: {
                        marginBottom: createLandlordInvitationMutation?.error || createTenantInvitationMutation?.error ? "1rem" : undefined
                    },
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $019112675a75b38b$export$2e2bcd8739ae039), {
                            mutation: createLandlordInvitationMutation,
                            errorTitleKey: "common.actions.add.error"
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $019112675a75b38b$export$2e2bcd8739ae039), {
                            mutation: createTenantInvitationMutation,
                            errorTitleKey: "common.actions.add.error"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $9ad25775b116f7f9$export$2e2bcd8739ae039), {
                    onSubmit: (values)=>createInvitation(values),
                    formReference: FORM_REFERENCE
                })
            ]
        })
    });
};
var $0444d6d626e783e4$export$2e2bcd8739ae039 = $0444d6d626e783e4$var$ModalAddInvitation;



var $1T1QG = parcelRequire("1T1QG");

var $aVXbR = parcelRequire("aVXbR");
"use client";
const $88e7937026fbdb30$var$c = (e)=>"number" == typeof e && !isNaN(e), $88e7937026fbdb30$var$d = (e)=>"string" == typeof e, $88e7937026fbdb30$var$u = (e)=>"function" == typeof e, $88e7937026fbdb30$var$p = (e)=>$88e7937026fbdb30$var$d(e) || $88e7937026fbdb30$var$u(e) ? e : null, $88e7937026fbdb30$var$m = (e)=>(0, $1T1QG.isValidElement)(e) || $88e7937026fbdb30$var$d(e) || $88e7937026fbdb30$var$u(e) || $88e7937026fbdb30$var$c(e);
function $88e7937026fbdb30$export$184cca501f1aed7f(e, t, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o, style: s } = e;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(t, n);
        });
    });
}
function $88e7937026fbdb30$export$3ff7dc44d332d222(t) {
    let { enter: a, exit: r, appendPosition: i = !1, collapse: l = !0, collapseDuration: c = 300 } = t;
    return function(t) {
        let { children: d, position: u, preventExitTransition: p, done: m, nodeRef: g, isIn: y, playToast: v } = t;
        const h = i ? `${a}--${u}` : a, T = i ? `${r}--${u}` : r, E = (0, $1T1QG.useRef)(0);
        return (0, $1T1QG.useLayoutEffect)(()=>{
            const e = g.current, t = h.split(" "), n = (o)=>{
                o.target === g.current && (v(), e.removeEventListener("animationend", n), e.removeEventListener("animationcancel", n), 0 === E.current && "animationcancel" !== o.type && e.classList.remove(...t));
            };
            e.classList.add(...t), e.addEventListener("animationend", n), e.addEventListener("animationcancel", n);
        }, []), (0, $1T1QG.useEffect)(()=>{
            const e = g.current, t = ()=>{
                e.removeEventListener("animationend", t), l ? $88e7937026fbdb30$export$184cca501f1aed7f(e, m, c) : m();
            };
            y || (p ? t() : (E.current = 1, e.className += ` ${T}`, e.addEventListener("animationend", t)));
        }, [
            y
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, null, d);
    };
}
function $88e7937026fbdb30$var$y(e, t) {
    return null != e ? {
        content: e.content,
        containerId: e.props.containerId,
        id: e.props.toastId,
        theme: e.props.theme,
        type: e.props.type,
        data: e.props.data || {},
        isLoading: e.props.isLoading,
        icon: e.props.icon,
        status: t
    } : {};
}
const $88e7937026fbdb30$var$v = new Map;
let $88e7937026fbdb30$var$h = [];
const $88e7937026fbdb30$var$T = new Set, $88e7937026fbdb30$var$E = (e)=>$88e7937026fbdb30$var$T.forEach((t)=>t(e)), $88e7937026fbdb30$var$b = ()=>$88e7937026fbdb30$var$v.size > 0;
function $88e7937026fbdb30$var$I(e, t) {
    var n;
    if (t) return !(null == (n = $88e7937026fbdb30$var$v.get(t)) || !n.isToastActive(e));
    let o = !1;
    return $88e7937026fbdb30$var$v.forEach((t)=>{
        t.isToastActive(e) && (o = !0);
    }), o;
}
function $88e7937026fbdb30$var$_(e, t) {
    $88e7937026fbdb30$var$m(e) && ($88e7937026fbdb30$var$b() || $88e7937026fbdb30$var$h.push({
        content: e,
        options: t
    }), $88e7937026fbdb30$var$v.forEach((n)=>{
        n.buildToast(e, t);
    }));
}
function $88e7937026fbdb30$var$C(e, t) {
    $88e7937026fbdb30$var$v.forEach((n)=>{
        null != t && null != t && t.containerId ? (null == t ? void 0 : t.containerId) === n.id && n.toggle(e, null == t ? void 0 : t.id) : n.toggle(e, null == t ? void 0 : t.id);
    });
}
function $88e7937026fbdb30$export$b262e13ca2dd2381(e) {
    const { subscribe: o, getSnapshot: s, setProps: i } = (0, $1T1QG.useRef)(function(e) {
        const n = e.containerId || 1;
        return {
            subscribe (o) {
                const s = function(e, n, o) {
                    let s = 1, r = 0, i = [], l = [], f = [], g = n;
                    const v = new Map, h = new Set, T = ()=>{
                        f = Array.from(v.values()), h.forEach((e)=>e());
                    }, E = (e)=>{
                        l = null == e ? [] : l.filter((t)=>t !== e), T();
                    }, b = (e)=>{
                        const { toastId: n, onOpen: s, updateId: a, children: r } = e.props, i = null == a;
                        e.staleId && v.delete(e.staleId), v.set(n, e), l = [
                            ...l,
                            e.props.toastId
                        ].filter((t)=>t !== e.staleId), T(), o($88e7937026fbdb30$var$y(e, i ? "added" : "updated")), i && $88e7937026fbdb30$var$u(s) && s((0, $1T1QG.isValidElement)(r) && r.props);
                    };
                    return {
                        id: e,
                        props: g,
                        observe: (e)=>(h.add(e), ()=>h.delete(e)),
                        toggle: (e, t)=>{
                            v.forEach((n)=>{
                                null != t && t !== n.props.toastId || $88e7937026fbdb30$var$u(n.toggle) && n.toggle(e);
                            });
                        },
                        removeToast: E,
                        toasts: v,
                        clearQueue: ()=>{
                            r -= i.length, i = [];
                        },
                        buildToast: (n, l)=>{
                            if (((t)=>{
                                let { containerId: n, toastId: o, updateId: s } = t;
                                const a = n ? n !== e : 1 !== e, r = v.has(o) && null == s;
                                return a || r;
                            })(l)) return;
                            const { toastId: f, updateId: h, data: I, staleId: _, delay: C } = l, L = ()=>{
                                E(f);
                            }, N = null == h;
                            N && r++;
                            const $ = {
                                ...g,
                                style: g.toastStyle,
                                key: s++,
                                ...Object.fromEntries(Object.entries(l).filter((e)=>{
                                    let [t, n] = e;
                                    return null != n;
                                })),
                                toastId: f,
                                updateId: h,
                                data: I,
                                closeToast: L,
                                isIn: !1,
                                className: $88e7937026fbdb30$var$p(l.className || g.toastClassName),
                                bodyClassName: $88e7937026fbdb30$var$p(l.bodyClassName || g.bodyClassName),
                                progressClassName: $88e7937026fbdb30$var$p(l.progressClassName || g.progressClassName),
                                autoClose: !l.isLoading && (w = l.autoClose, k = g.autoClose, !1 === w || $88e7937026fbdb30$var$c(w) && w > 0 ? w : k),
                                deleteToast () {
                                    const e = v.get(f), { onClose: n, children: s } = e.props;
                                    $88e7937026fbdb30$var$u(n) && n((0, $1T1QG.isValidElement)(s) && s.props), o($88e7937026fbdb30$var$y(e, "removed")), v.delete(f), r--, r < 0 && (r = 0), i.length > 0 ? b(i.shift()) : T();
                                }
                            };
                            var w, k;
                            $.closeButton = g.closeButton, !1 === l.closeButton || $88e7937026fbdb30$var$m(l.closeButton) ? $.closeButton = l.closeButton : !0 === l.closeButton && ($.closeButton = !$88e7937026fbdb30$var$m(g.closeButton) || g.closeButton);
                            let P = n;
                            (0, $1T1QG.isValidElement)(n) && !$88e7937026fbdb30$var$d(n.type) ? P = (0, $1T1QG.cloneElement)(n, {
                                closeToast: L,
                                toastProps: $,
                                data: I
                            }) : $88e7937026fbdb30$var$u(n) && (P = n({
                                closeToast: L,
                                toastProps: $,
                                data: I
                            }));
                            const M = {
                                content: P,
                                props: $,
                                staleId: _
                            };
                            g.limit && g.limit > 0 && r > g.limit && N ? i.push(M) : $88e7937026fbdb30$var$c(C) ? setTimeout(()=>{
                                b(M);
                            }, C) : b(M);
                        },
                        setProps (e) {
                            g = e;
                        },
                        setToggle: (e, t)=>{
                            v.get(e).toggle = t;
                        },
                        isToastActive: (e)=>l.some((t)=>t === e),
                        getSnapshot: ()=>g.newestOnTop ? f.reverse() : f
                    };
                }(n, e, $88e7937026fbdb30$var$E);
                $88e7937026fbdb30$var$v.set(n, s);
                const r = s.observe(o);
                return $88e7937026fbdb30$var$h.forEach((e)=>$88e7937026fbdb30$var$_(e.content, e.options)), $88e7937026fbdb30$var$h = [], ()=>{
                    r(), $88e7937026fbdb30$var$v.delete(n);
                };
            },
            setProps (e) {
                var t;
                null == (t = $88e7937026fbdb30$var$v.get(n)) || t.setProps(e);
            },
            getSnapshot () {
                var e;
                return null == (e = $88e7937026fbdb30$var$v.get(n)) ? void 0 : e.getSnapshot();
            }
        };
    }(e)).current;
    i(e);
    const l = (0, $1T1QG.useSyncExternalStore)(o, s, s);
    return {
        getToastToRender: function(e) {
            if (!l) return [];
            const t = new Map;
            return l.forEach((e)=>{
                const { position: n } = e.props;
                t.has(n) || t.set(n, []), t.get(n).push(e);
            }), Array.from(t, (t)=>e(t[0], t[1]));
        },
        isToastActive: $88e7937026fbdb30$var$I,
        count: null == l ? void 0 : l.length
    };
}
function $88e7937026fbdb30$export$a407b657d3044108(e) {
    const [t, o] = (0, $1T1QG.useState)(!1), [a, r] = (0, $1T1QG.useState)(!1), l = (0, $1T1QG.useRef)(null), c = (0, $1T1QG.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: d, pauseOnHover: u, closeToast: p, onClick: m, closeOnClick: f } = e;
    var g, y;
    function h() {
        o(!0);
    }
    function T() {
        o(!1);
    }
    function E(n) {
        const o = l.current;
        c.canDrag && o && (c.didMove = !0, t && T(), c.delta = "x" === e.draggableDirection ? n.clientX - c.start : n.clientY - c.start, c.start !== n.clientX && (c.canCloseOnClick = !1), o.style.transform = `translate3d(${"x" === e.draggableDirection ? `${c.delta}px, var(--y)` : `0, calc(${c.delta}px + var(--y))`},0)`, o.style.opacity = "" + (1 - Math.abs(c.delta / c.removalDistance)));
    }
    function b() {
        document.removeEventListener("pointermove", E), document.removeEventListener("pointerup", b);
        const t = l.current;
        if (c.canDrag && c.didMove && t) {
            if (c.canDrag = !1, Math.abs(c.delta) > c.removalDistance) return r(!0), e.closeToast(), void e.collapseAll();
            t.style.transition = "transform 0.2s, opacity 0.2s", t.style.removeProperty("transform"), t.style.removeProperty("opacity");
        }
    }
    null == (y = $88e7937026fbdb30$var$v.get((g = {
        id: e.toastId,
        containerId: e.containerId,
        fn: o
    }).containerId || 1)) || y.setToggle(g.id, g.fn), (0, $1T1QG.useEffect)(()=>{
        if (e.pauseOnFocusLoss) return document.hasFocus() || T(), window.addEventListener("focus", h), window.addEventListener("blur", T), ()=>{
            window.removeEventListener("focus", h), window.removeEventListener("blur", T);
        };
    }, [
        e.pauseOnFocusLoss
    ]);
    const I = {
        onPointerDown: function(t) {
            if (!0 === e.draggable || e.draggable === t.pointerType) {
                c.didMove = !1, document.addEventListener("pointermove", E), document.addEventListener("pointerup", b);
                const n = l.current;
                c.canCloseOnClick = !0, c.canDrag = !0, n.style.transition = "none", "x" === e.draggableDirection ? (c.start = t.clientX, c.removalDistance = n.offsetWidth * (e.draggablePercent / 100)) : (c.start = t.clientY, c.removalDistance = n.offsetHeight * (80 === e.draggablePercent ? 1.5 * e.draggablePercent : e.draggablePercent) / 100);
            }
        },
        onPointerUp: function(t) {
            const { top: n, bottom: o, left: s, right: a } = l.current.getBoundingClientRect();
            "touchend" !== t.nativeEvent.type && e.pauseOnHover && t.clientX >= s && t.clientX <= a && t.clientY >= n && t.clientY <= o ? T() : h();
        }
    };
    return d && u && (I.onMouseEnter = T, e.stacked || (I.onMouseLeave = h)), f && (I.onClick = (e)=>{
        m && m(e), c.canCloseOnClick && p();
    }), {
        playToast: h,
        pauseToast: T,
        isRunning: t,
        preventExitTransition: a,
        toastRef: l,
        eventHandlers: I
    };
}
function $88e7937026fbdb30$var$$(t) {
    let { delay: n, isRunning: o, closeToast: s, type: a = "default", hide: r, className: i, style: c, controlledProgress: d, progress: p, rtl: m, isIn: f, theme: g } = t;
    const y = r || d && 0 === p, v = {
        ...c,
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    d && (v.transform = `scaleX(${p})`);
    const h = (0, $aVXbR.default)("Toastify__progress-bar", d ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = $88e7937026fbdb30$var$u(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: h
    }) : (0, $aVXbR.default)(h, i), E = {
        [d && p >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: d && p < 1 ? null : ()=>{
            f && s();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": y
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${a}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("div", {
        role: "progressbar",
        "aria-hidden": y ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: v,
        ...E
    }));
}
let $88e7937026fbdb30$var$w = 1;
const $88e7937026fbdb30$var$k = ()=>"" + $88e7937026fbdb30$var$w++;
function $88e7937026fbdb30$var$P(e) {
    return e && ($88e7937026fbdb30$var$d(e.toastId) || $88e7937026fbdb30$var$c(e.toastId)) ? e.toastId : $88e7937026fbdb30$var$k();
}
function $88e7937026fbdb30$var$M(e, t) {
    return $88e7937026fbdb30$var$_(e, t), t.toastId;
}
function $88e7937026fbdb30$var$x(e, t) {
    return {
        ...t,
        type: t && t.type || e,
        toastId: $88e7937026fbdb30$var$P(t)
    };
}
function $88e7937026fbdb30$var$A(e) {
    return (t, n)=>$88e7937026fbdb30$var$M(t, $88e7937026fbdb30$var$x(e, n));
}
function $88e7937026fbdb30$export$b410431fab84fa58(e, t) {
    return $88e7937026fbdb30$var$M(e, $88e7937026fbdb30$var$x("default", t));
}
$88e7937026fbdb30$export$b410431fab84fa58.loading = (e, t)=>$88e7937026fbdb30$var$M(e, $88e7937026fbdb30$var$x("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...t
    })), $88e7937026fbdb30$export$b410431fab84fa58.promise = function(e, t, n) {
    let o, { pending: s, error: a, success: r } = t;
    s && (o = $88e7937026fbdb30$var$d(s) ? $88e7937026fbdb30$export$b410431fab84fa58.loading(s, n) : $88e7937026fbdb30$export$b410431fab84fa58.loading(s.render, {
        ...n,
        ...s
    }));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (e, t, s)=>{
        if (null == t) return void $88e7937026fbdb30$export$b410431fab84fa58.dismiss(o);
        const a = {
            type: e,
            ...i,
            ...n,
            data: s
        }, r = $88e7937026fbdb30$var$d(t) ? {
            render: t
        } : t;
        return o ? $88e7937026fbdb30$export$b410431fab84fa58.update(o, {
            ...a,
            ...r
        }) : $88e7937026fbdb30$export$b410431fab84fa58(r.render, {
            ...a,
            ...r
        }), s;
    }, c = $88e7937026fbdb30$var$u(e) ? e() : e;
    return c.then((e)=>l("success", r, e)).catch((e)=>l("error", a, e)), c;
}, $88e7937026fbdb30$export$b410431fab84fa58.success = $88e7937026fbdb30$var$A("success"), $88e7937026fbdb30$export$b410431fab84fa58.info = $88e7937026fbdb30$var$A("info"), $88e7937026fbdb30$export$b410431fab84fa58.error = $88e7937026fbdb30$var$A("error"), $88e7937026fbdb30$export$b410431fab84fa58.warning = $88e7937026fbdb30$var$A("warning"), $88e7937026fbdb30$export$b410431fab84fa58.warn = $88e7937026fbdb30$export$b410431fab84fa58.warning, $88e7937026fbdb30$export$b410431fab84fa58.dark = (e, t)=>$88e7937026fbdb30$var$M(e, $88e7937026fbdb30$var$x("default", {
        theme: "dark",
        ...t
    })), $88e7937026fbdb30$export$b410431fab84fa58.dismiss = function(e) {
    !function(e) {
        var t;
        if ($88e7937026fbdb30$var$b()) {
            if (null == e || $88e7937026fbdb30$var$d(t = e) || $88e7937026fbdb30$var$c(t)) $88e7937026fbdb30$var$v.forEach((t)=>{
                t.removeToast(e);
            });
            else if (e && ("containerId" in e || "id" in e)) {
                var n;
                (null == (n = $88e7937026fbdb30$var$v.get(e.containerId)) ? void 0 : n.removeToast(e.id)) || $88e7937026fbdb30$var$v.forEach((t)=>{
                    t.removeToast(e.id);
                });
            }
        } else $88e7937026fbdb30$var$h = $88e7937026fbdb30$var$h.filter((t)=>null != e && t.options.toastId !== e);
    }(e);
}, $88e7937026fbdb30$export$b410431fab84fa58.clearWaitingQueue = function(e) {
    void 0 === e && (e = {}), $88e7937026fbdb30$var$v.forEach((t)=>{
        !t.props.limit || e.containerId && t.id !== e.containerId || t.clearQueue();
    });
}, $88e7937026fbdb30$export$b410431fab84fa58.isActive = $88e7937026fbdb30$var$I, $88e7937026fbdb30$export$b410431fab84fa58.update = function(e, t) {
    void 0 === t && (t = {});
    const n = ((e, t)=>{
        var n;
        let { containerId: o } = t;
        return null == (n = $88e7937026fbdb30$var$v.get(o || 1)) ? void 0 : n.toasts.get(e);
    })(e, t);
    if (n) {
        const { props: o, content: s } = n, a = {
            delay: 100,
            ...o,
            ...t,
            toastId: t.toastId || e,
            updateId: $88e7937026fbdb30$var$k()
        };
        a.toastId !== e && (a.staleId = e);
        const r = a.render || s;
        delete a.render, $88e7937026fbdb30$var$M(r, a);
    }
}, $88e7937026fbdb30$export$b410431fab84fa58.done = (e)=>{
    $88e7937026fbdb30$export$b410431fab84fa58.update(e, {
        progress: 1
    });
}, $88e7937026fbdb30$export$b410431fab84fa58.onChange = function(e) {
    return $88e7937026fbdb30$var$T.add(e), ()=>{
        $88e7937026fbdb30$var$T.delete(e);
    };
}, $88e7937026fbdb30$export$b410431fab84fa58.play = (e)=>$88e7937026fbdb30$var$C(!0, e), $88e7937026fbdb30$export$b410431fab84fa58.pause = (e)=>$88e7937026fbdb30$var$C(!1, e);
const $88e7937026fbdb30$var$O = "undefined" != typeof window ? (0, $1T1QG.useLayoutEffect) : (0, $1T1QG.useEffect), $88e7937026fbdb30$var$D = (t)=>{
    let { theme: n, type: o, isLoading: s, ...a } = t;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...a
    });
}, $88e7937026fbdb30$export$4f13f83fd8bb1dac = {
    info: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement($88e7937026fbdb30$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement($88e7937026fbdb30$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement($88e7937026fbdb30$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(t) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement($88e7937026fbdb30$var$D, {
            ...t
        }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
}, $88e7937026fbdb30$var$R = (n)=>{
    const { isRunning: o, preventExitTransition: s, toastRef: r, eventHandlers: i, playToast: c } = $88e7937026fbdb30$export$a407b657d3044108(n), { closeButton: d, children: p, autoClose: m, onClick: f, type: g, hideProgressBar: y, closeToast: v, transition: h, position: T, className: E, style: b, bodyClassName: I, bodyStyle: _, progressClassName: C, progressStyle: L, updateId: w, role: k, progress: P, rtl: M, toastId: x, deleteToast: A, isIn: B, isLoading: O, closeOnClick: D, theme: R } = n, S = (0, $aVXbR.default)("Toastify__toast", `Toastify__toast-theme--${R}`, `Toastify__toast--${g}`, {
        "Toastify__toast--rtl": M
    }, {
        "Toastify__toast--close-on-click": D
    }), H = $88e7937026fbdb30$var$u(E) ? E({
        rtl: M,
        position: T,
        type: g,
        defaultClassName: S
    }) : (0, $aVXbR.default)(S, E), F = function(e) {
        let { theme: n, type: o, isLoading: s, icon: r } = e, i = null;
        const l = {
            theme: n,
            type: o
        };
        return !1 === r || ($88e7937026fbdb30$var$u(r) ? i = r({
            ...l,
            isLoading: s
        }) : (0, $1T1QG.isValidElement)(r) ? i = (0, $1T1QG.cloneElement)(r, l) : s ? i = $88e7937026fbdb30$export$4f13f83fd8bb1dac.spinner() : ((e)=>e in $88e7937026fbdb30$export$4f13f83fd8bb1dac)(o) && (i = $88e7937026fbdb30$export$4f13f83fd8bb1dac[o](l))), i;
    }(n), X = !!P || !m, Y = {
        closeToast: v,
        type: g,
        theme: R
    };
    let q = null;
    return !1 === d || (q = $88e7937026fbdb30$var$u(d) ? d(Y) : (0, $1T1QG.isValidElement)(d) ? (0, $1T1QG.cloneElement)(d, Y) : function(t) {
        let { closeToast: n, theme: o, ariaLabel: s = "close" } = t;
        return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("button", {
            className: `Toastify__close-button Toastify__close-button--${o}`,
            type: "button",
            onClick: (e)=>{
                e.stopPropagation(), n(e);
            },
            "aria-label": s
        }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("svg", {
            "aria-hidden": "true",
            viewBox: "0 0 14 16"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("path", {
            fillRule: "evenodd",
            d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
        })));
    }(Y)), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(h, {
        isIn: B,
        done: A,
        position: T,
        preventExitTransition: s,
        nodeRef: r,
        playToast: c
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("div", {
        id: x,
        onClick: f,
        "data-in": B,
        className: H,
        ...i,
        style: b,
        ref: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("div", {
        ...B && {
            role: k
        },
        className: $88e7937026fbdb30$var$u(I) ? I({
            type: g
        }) : (0, $aVXbR.default)("Toastify__toast-body", I),
        style: _
    }, null != F && (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("div", {
        className: (0, $aVXbR.default)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !O
        })
    }, F), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("div", null, p)), q, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement($88e7937026fbdb30$var$$, {
        ...w && !X ? {
            key: `pb-${w}`
        } : {},
        rtl: M,
        theme: R,
        delay: m,
        isRunning: o,
        isIn: B,
        closeToast: v,
        hide: y,
        type: g,
        style: L,
        className: C,
        controlledProgress: X,
        progress: P || 0
    })));
}, $88e7937026fbdb30$var$S = function(e, t) {
    return void 0 === t && (t = !1), {
        enter: `Toastify--animate Toastify__${e}-enter`,
        exit: `Toastify--animate Toastify__${e}-exit`,
        appendPosition: t
    };
}, $88e7937026fbdb30$export$d20e79fdc3899e95 = $88e7937026fbdb30$export$3ff7dc44d332d222($88e7937026fbdb30$var$S("bounce", !0)), $88e7937026fbdb30$export$d8dc01b5c85a37b9 = $88e7937026fbdb30$export$3ff7dc44d332d222($88e7937026fbdb30$var$S("slide", !0)), $88e7937026fbdb30$export$65cfd44a2050f99 = $88e7937026fbdb30$export$3ff7dc44d332d222($88e7937026fbdb30$var$S("zoom")), $88e7937026fbdb30$export$4d2fae537bd90431 = $88e7937026fbdb30$export$3ff7dc44d332d222($88e7937026fbdb30$var$S("flip")), $88e7937026fbdb30$var$q = {
    position: "top-right",
    transition: $88e7937026fbdb30$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
function $88e7937026fbdb30$export$f2815235e76a62b9(t) {
    let o = {
        ...$88e7937026fbdb30$var$q,
        ...t
    };
    const s = t.stacked, [a, r] = (0, $1T1QG.useState)(!0), c = (0, $1T1QG.useRef)(null), { getToastToRender: d, isToastActive: m, count: f } = $88e7937026fbdb30$export$b262e13ca2dd2381(o), { className: g, style: y, rtl: v, containerId: h } = o;
    function T(e) {
        const t = (0, $aVXbR.default)("Toastify__toast-container", `Toastify__toast-container--${e}`, {
            "Toastify__toast-container--rtl": v
        });
        return $88e7937026fbdb30$var$u(g) ? g({
            position: e,
            rtl: v,
            defaultClassName: t
        }) : (0, $aVXbR.default)(t, $88e7937026fbdb30$var$p(g));
    }
    function E() {
        s && (r(!0), $88e7937026fbdb30$export$b410431fab84fa58.play());
    }
    return $88e7937026fbdb30$var$O(()=>{
        if (s) {
            var e;
            const t = c.current.querySelectorAll('[data-in="true"]'), n = 12, s = null == (e = o.position) ? void 0 : e.includes("top");
            let r = 0, i = 0;
            Array.from(t).reverse().forEach((e, t)=>{
                const o = e;
                o.classList.add("Toastify__toast--stacked"), t > 0 && (o.dataset.collapsed = `${a}`), o.dataset.pos || (o.dataset.pos = s ? "top" : "bot");
                const l = r * (a ? .2 : 1) + (a ? 0 : n * t);
                o.style.setProperty("--y", `${s ? l : -1 * l}px`), o.style.setProperty("--g", `${n}`), o.style.setProperty("--s", "" + (1 - (a ? i : 0))), r += o.offsetHeight, i += .025;
            });
        }
    }, [
        a,
        f,
        s
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("div", {
        ref: c,
        className: "Toastify",
        id: h,
        onMouseEnter: ()=>{
            s && (r(!1), $88e7937026fbdb30$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E
    }, d((t, n)=>{
        const o = n.length ? {
            ...y
        } : {
            ...y,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("div", {
            className: T(t),
            style: o,
            key: `container-${t}`
        }, n.map((t)=>{
            let { content: n, props: o } = t;
            return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement($88e7937026fbdb30$var$R, {
                ...o,
                stacked: s,
                collapseAll: E,
                isIn: m(o.toastId, o.containerId),
                style: o.style,
                key: `toast-${o.key}`
            }, n);
        }));
    }));
}


var $8c70bc2b53ae34cc$export$266cbe012f0ab791;
(function(MoovyToast) {
    MoovyToast.showToast = (message, success = true)=>{
        success ? (0, $88e7937026fbdb30$export$b410431fab84fa58).success(message) : (0, $88e7937026fbdb30$export$b410431fab84fa58).error(message);
    };
})($8c70bc2b53ae34cc$export$266cbe012f0ab791 || ($8c70bc2b53ae34cc$export$266cbe012f0ab791 = {}));



const $b34a9598b5f97a22$var$Invitations = ({ queryInvitations: queryInvitations, permissionAccess: permissionAccess, showModalAdd: showModalAdd, addingInvitationParams: addingInvitationParams, setShowModalAdd: setShowModalAdd, pagination: pagination, onInvitationAdded: onInvitationAdded, onInvitationRemoved: onInvitationRemoved, visibleColumns: visibleColumns = [
    "NAME",
    "EMAIL",
    "INVITED",
    "REGISTERED_IN",
    "REMOVE"
] })=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const { isPermission: isPermission } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const [showModalRemove, setShowModalRemove] = (0, $1T1QG.useState)(null);
    const invitations = addingInvitationParams.invitationType === "LANDLORD" ? queryInvitations?.data?.data || [] : queryInvitations?.data || [];
    const removeInvitationMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (invitationId)=>(0, $9f8b36004207981d$export$2e2bcd8739ae039).removeInvitation(invitationId),
        onSuccess: (response)=>{
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.invitations.list.actions.removed",
                values: {
                    name: showModalRemove?.name
                }
            }));
            setShowModalRemove(null);
            onInvitationRemoved();
        }
    });
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8002a2b5b87a23eb$export$2e2bcd8739ae039), {
                emptyTextId: "page.invitations.list.table.action.empty",
                errorTextId: "page.invitations.list.table.action.failed",
                query: queryInvitations,
                pagination: pagination,
                children: invitations.map((row)=>{
                    let cardContentList = [];
                    if (visibleColumns.includes("EMAIL")) {
                        cardContentList.push(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "common.text.email"
                        }));
                        cardContentList.push(/*#__PURE__*/ (0, $3Py8h.jsx)("b", {
                            children: row.email
                        }));
                    }
                    if (visibleColumns.includes("REGISTERED_IN")) {
                        cardContentList.push(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "page.invitations.list.card.header.registeredIn"
                        }));
                        cardContentList.push(/*#__PURE__*/ (0, $3Py8h.jsx)("b", {
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                                utcDateTime: row.used,
                                emptyText: "-"
                            })
                        }));
                    }
                    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0829f6a75e4b5e7$export$2e2bcd8739ae039), {
                        cardTitle: row.name,
                        cardSecondaryTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                            utcDateTime: row.createdAt
                        }),
                        cardContentList: cardContentList,
                        cardMenuActions: isPermission(permissionAccess.action, permissionAccess.resource) ? [
                            {
                                itemText: intl.formatMessage({
                                    id: "page.invitations.list.button.remove"
                                }),
                                onClick: ()=>setShowModalRemove({
                                        name: row.name,
                                        id: row.id
                                    })
                            }
                        ] : undefined
                    }, row.id);
                })
            }),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $c6e866c0d03fba92$export$2e2bcd8739ae039), {
                items: invitations,
                emptyTextId: "page.invitations.list.table.action.empty",
                errorTextId: "page.invitations.list.table.action.failed",
                query: queryInvitations,
                pagination: pagination,
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b52028b37ea87ec4$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                            children: [
                                visibleColumns.includes("NAME") && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "page.invitations.list.table.header.name"
                                    })
                                }),
                                visibleColumns.includes("EMAIL") && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "common.text.email"
                                    })
                                }),
                                visibleColumns.includes("INVITED") && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "page.invitations.list.table.header.invited"
                                    })
                                }),
                                visibleColumns.includes("REGISTERED_IN") && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "page.invitations.list.table.header.registeredIn"
                                    })
                                }),
                                visibleColumns.includes("REMOVE") && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $15827f0d92c5ff99$export$2e2bcd8739ae039), {
                                    action: permissionAccess.action,
                                    resource: permissionAccess.resource,
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a3b5a93a68cc46b9$export$2e2bcd8739ae039), {
                        "data-testid": "invitations-table-body",
                        children: invitations.map((row)=>/*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                                children: [
                                    visibleColumns.includes("NAME") && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: row.name
                                    }),
                                    visibleColumns.includes("EMAIL") && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: row.email
                                    }),
                                    visibleColumns.includes("INVITED") && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                                            utcDateTime: row.createdAt
                                        })
                                    }),
                                    visibleColumns.includes("REGISTERED_IN") && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                                            utcDateTime: row.used
                                        })
                                    }),
                                    visibleColumns.includes("REMOVE") && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $15827f0d92c5ff99$export$2e2bcd8739ae039), {
                                            action: permissionAccess.action,
                                            resource: permissionAccess.resource,
                                            visibility: !row.used,
                                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $041febe0dbc86e0a$export$2e2bcd8739ae039), {
                                                red: true,
                                                bold: true,
                                                onClick: ()=>setShowModalRemove({
                                                        name: row.name,
                                                        id: row.id
                                                    }),
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                    id: "page.invitations.list.button.remove"
                                                })
                                            })
                                        })
                                    })
                                ]
                            }, row.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $0444d6d626e783e4$export$2e2bcd8739ae039), {
                open: showModalAdd,
                addingInvitationParams: addingInvitationParams,
                onSubmit: (response)=>{
                    setShowModalAdd(false);
                    (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                        id: "page.invitations.list.actions.added",
                        values: {
                            name: response.name
                        }
                    }));
                    onInvitationAdded();
                },
                onCancel: ()=>setShowModalAdd(false)
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $7f916474711491ea$export$2e2bcd8739ae039), {
                open: !!showModalRemove,
                lang: {
                    confirmButton: "common.buttons.yes",
                    error: "common.actions.remove.error"
                },
                header: intl.formatMessage({
                    id: "page.invitations.modalRemove.header"
                }),
                content: intl.formatMessage({
                    id: "page.invitations.modalRemove.content"
                }, {
                    name: showModalRemove?.name
                }),
                onCancel: ()=>setShowModalRemove(null),
                onConfirm: ()=>showModalRemove?.id && removeInvitationMutation.mutate(showModalRemove.id),
                mutation: removeInvitationMutation
            })
        ]
    });
};
var $b34a9598b5f97a22$export$2e2bcd8739ae039 = $b34a9598b5f97a22$var$Invitations;






const $455a74580fe95862$var$stateKey = "moovyUi";
const $455a74580fe95862$var$initialState = {
    locale: localStorage.getItem((0, $5ce8806ad70988a5$export$864b6a9fa5df87b6)) || "fi",
    initialized: sessionStorage.getItem((0, $5ce8806ad70988a5$export$464bac997a211baf)) || "",
    landlord: {
        id: sessionStorage.getItem((0, $5ce8806ad70988a5$export$fbb0f21f223dce54)) || "",
        name: sessionStorage.getItem((0, $5ce8806ad70988a5$export$ad6b2753bfb86074)) || ""
    },
    place: {
        id: sessionStorage.getItem((0, $5ce8806ad70988a5$export$7590792a37b51514)) || "",
        name: sessionStorage.getItem((0, $5ce8806ad70988a5$export$fa52eabe6f966a70)) || ""
    },
    catalogueId: sessionStorage.getItem((0, $5ce8806ad70988a5$export$738e7ce102bdae66)) || ""
};
const $455a74580fe95862$var$slice = (0, $5d190961bb0838a0$export$4d8d9bd83c24ae8b)({
    name: $455a74580fe95862$var$stateKey,
    initialState: $455a74580fe95862$var$initialState,
    reducers: {
        setUI (state, action) {
            const newState = {
                ...state,
                [action.payload.key]: action.payload.value
            };
            return newState;
        },
        setLocale (state, action) {
            localStorage.setItem((0, $5ce8806ad70988a5$export$864b6a9fa5df87b6), action.payload);
            state.locale = action.payload;
        },
        setInitialized (state, action) {
            sessionStorage.setItem((0, $5ce8806ad70988a5$export$464bac997a211baf), action.payload);
            state.initialized = action.payload;
        },
        setCustomer (state, action) {
            sessionStorage.setItem((0, $5ce8806ad70988a5$export$fbb0f21f223dce54), action.payload.id);
            sessionStorage.setItem((0, $5ce8806ad70988a5$export$ad6b2753bfb86074), action.payload.name);
            state.landlord = {
                ...action.payload
            };
        },
        setPlace (state, action) {
            sessionStorage.setItem((0, $5ce8806ad70988a5$export$7590792a37b51514), action.payload.id);
            sessionStorage.setItem((0, $5ce8806ad70988a5$export$fa52eabe6f966a70), action.payload.name);
            state.place = {
                ...action.payload
            };
        },
        setCatalogueId (state, action) {
            sessionStorage.setItem((0, $5ce8806ad70988a5$export$738e7ce102bdae66), action.payload);
            state.catalogueId = action.payload;
        }
    }
});
var $455a74580fe95862$export$2e2bcd8739ae039 = $455a74580fe95862$var$slice.reducer;
const { setUI: $455a74580fe95862$export$32af90104174043f, setLocale: $455a74580fe95862$export$c8aadf3621e41efb, setCustomer: $455a74580fe95862$export$17f90c60f0971ba8, setPlace: $455a74580fe95862$export$5a0d5937f9d14ce6, setInitialized: $455a74580fe95862$export$e311492ce45a8298, setCatalogueId: $455a74580fe95862$export$14203ab318469323 } = $455a74580fe95862$var$slice.actions;
const $455a74580fe95862$export$dad57afd7b5a98f5 = (key, payload)=>{
    return $455a74580fe95862$export$32af90104174043f({
        key: key,
        value: payload
    });
};
const $455a74580fe95862$export$7389484a7f69e71d = (payload)=>{
    return $455a74580fe95862$export$c8aadf3621e41efb(payload);
};
const $455a74580fe95862$export$bbe1eb340cdbd464 = (payload)=>{
    return $455a74580fe95862$export$e311492ce45a8298(payload);
};
const $455a74580fe95862$export$ae66d5a6ca962c9a = (payload)=>{
    return $455a74580fe95862$export$17f90c60f0971ba8(payload);
};
const $455a74580fe95862$export$2f52b3443c11c15a = (payload)=>{
    return $455a74580fe95862$export$5a0d5937f9d14ce6(payload);
};
const $455a74580fe95862$export$12af370a2d55934d = (payload)=>{
    return $455a74580fe95862$export$14203ab318469323(payload);
};
const $455a74580fe95862$export$1c46e3decb4a80c2 = {
    keyExists (state, uiKey) {
        return state[$455a74580fe95862$var$stateKey]?.[uiKey] !== undefined;
    },
    getUiState (state, uiKey) {
        return state[$455a74580fe95862$var$stateKey]?.[uiKey];
    },
    getLocale (state) {
        return state[$455a74580fe95862$var$stateKey]?.locale;
    },
    getInitialized (state) {
        return state[$455a74580fe95862$var$stateKey]?.initialized;
    },
    getCustomer (state) {
        return state[$455a74580fe95862$var$stateKey]?.landlord;
    },
    getPlace (state) {
        return state[$455a74580fe95862$var$stateKey]?.place;
    },
    getCatalogueId (state) {
        return state[$455a74580fe95862$var$stateKey]?.catalogueId;
    }
};



function $adb860d4c4948aea$export$2e2bcd8739ae039(options) {
    const dispatch = (0, $4a938932ca693376$export$8ad76b76a4c905f8)();
    const { key: key, initialValue: initialValue } = options;
    const updateFunction = (value)=>dispatch((0, $455a74580fe95862$export$dad57afd7b5a98f5)(key, value));
    const exists = (0, $c354137c2cb06a61$export$2105062e25df4afe)((state)=>(0, $455a74580fe95862$export$1c46e3decb4a80c2).keyExists(state, key));
    const selector = (0, $c354137c2cb06a61$export$2105062e25df4afe)((state)=>(0, $455a74580fe95862$export$1c46e3decb4a80c2).getUiState(state, key));
    // Value in Redux, function to update value
    return [
        exists ? selector : initialValue,
        updateFunction
    ];
}


const $b463aef7f528c97c$var$InvitationsLandlord = ()=>{
    const { admin: admin } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const queryClient = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)();
    const [showModalAdd, setShowModalAdd] = (0, $1T1QG.useState)(false);
    const [pagingAndSortValues, setPagingAndSortValues] = (0, $adb860d4c4948aea$export$2e2bcd8739ae039)({
        key: (0, $5f8ca62b06e02682$export$5cbc2ff09ff3e0),
        initialValue: (0, $55d02d7b1a5c4f16$export$4bec99d256114e49)("CREATED_AT", "DESC")
    });
    const queryInvitations = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$7a161aff508d2cb1),
            pagingAndSortValues.page,
            pagingAndSortValues.sort
        ],
        queryFn: ()=>{
            const { page: page, limit: limit, sort: sort, direction: direction } = (0, $55d02d7b1a5c4f16$export$f381863f4c1c052a)(pagingAndSortValues);
            return (0, $9f8b36004207981d$export$2e2bcd8739ae039).getInvitations(admin, {
                page: page,
                limit: limit,
                sort: sort,
                direction: direction
            });
        },
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const pagination = queryInvitations.data?.pageable ? {
        page: queryInvitations.data.pageable.page,
        total: queryInvitations.data.pageable.total,
        limit: queryInvitations.data.pageable.limit,
        onNextPage: (page)=>setPagingAndSortValues({
                ...pagingAndSortValues,
                page: page.toString()
            })
    } : undefined;
    const items = (0, $1a49c6a526fe14f2$export$88b06990067e1fdb)(intl, "INVITATIONS");
    const onInvitationRemoved = ()=>{
        const newPage = (0, $55d02d7b1a5c4f16$export$e8b67cc4f4c44ec6)(pagination);
        if (newPage) setPagingAndSortValues({
            ...pagingAndSortValues,
            page: newPage
        });
        onRefreshView();
    };
    const onRefreshView = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $ec0c9d75a0d3a81a$export$7a161aff508d2cb1)
            ]
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c9560da3d4f68f59$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
                loading: queryInvitations.isPending,
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $d853676d11a33bb6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "page.invitations.list.title"
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {
                        description: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $2e40821b62a7b9dd$export$2e2bcd8739ae039), {
                            filterKey: (0, $5f8ca62b06e02682$export$1ef7c9c6b17b6642),
                            items: items,
                            value: pagingAndSortValues.sort,
                            onChange: (value)=>{
                                pagingAndSortValues.sort !== value && setPagingAndSortValues({
                                    ...pagingAndSortValues,
                                    sort: value,
                                    direction: (0, $1a49c6a526fe14f2$export$fcce7887255d1c69)(value)
                                });
                            }
                        }),
                        button: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $15827f0d92c5ff99$export$2e2bcd8739ae039), {
                            action: "CREATE",
                            resource: "LANDLORD_INVITATIONS",
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                                onClick: ()=>setShowModalAdd(true),
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.invitations.list.button.landlord.newInvitation"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b34a9598b5f97a22$export$2e2bcd8739ae039), {
                            queryInvitations: queryInvitations,
                            permissionAccess: {
                                action: "DELETE",
                                resource: "LANDLORD_INVITATIONS"
                            },
                            addingInvitationParams: {
                                invitationType: "LANDLORD"
                            },
                            showModalAdd: showModalAdd,
                            setShowModalAdd: setShowModalAdd,
                            pagination: pagination,
                            onInvitationRemoved: onInvitationRemoved,
                            onInvitationAdded: onRefreshView
                        })
                    })
                ]
            })
        ]
    });
};
var $b463aef7f528c97c$export$2e2bcd8739ae039 = $b463aef7f528c97c$var$InvitationsLandlord;



var $3Py8h = parcelRequire("3Py8h");



var $1T1QG = parcelRequire("1T1QG");





const $429e38326d2bbab8$var$InvitationsTenant = ({ tenantId: tenantId, landlordId: landlordId, catalogueId: catalogueId })=>{
    const { admin: admin } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const queryClient = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)();
    const [showModalAdd, setShowModalAdd] = (0, $1T1QG.useState)(false);
    const queryInvitations = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$415ddc16ccdc9af1),
            tenantId
        ],
        queryFn: ()=>(0, $9f8b36004207981d$export$2e2bcd8739ae039).getInvitationsByCustomerId(admin, tenantId, true),
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const onRefreshView = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $ec0c9d75a0d3a81a$export$415ddc16ccdc9af1)
            ]
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c9560da3d4f68f59$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
                loading: queryInvitations.isPending,
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {
                        button: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $15827f0d92c5ff99$export$2e2bcd8739ae039), {
                            action: "CREATE",
                            resource: "TENANT_INVITATIONS",
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                                onClick: ()=>setShowModalAdd(true),
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.invitations.list.button.tenant.newInvitation"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b34a9598b5f97a22$export$2e2bcd8739ae039), {
                            queryInvitations: queryInvitations,
                            addingInvitationParams: {
                                invitationType: "TENANT",
                                landlordId: landlordId,
                                tenantId: tenantId,
                                catalogueId: catalogueId
                            },
                            permissionAccess: {
                                action: "DELETE",
                                resource: "TENANT_INVITATIONS"
                            },
                            showModalAdd: showModalAdd,
                            setShowModalAdd: setShowModalAdd,
                            onInvitationRemoved: onRefreshView,
                            onInvitationAdded: onRefreshView
                        })
                    })
                ]
            })
        ]
    });
};
var $429e38326d2bbab8$export$2e2bcd8739ae039 = $429e38326d2bbab8$var$InvitationsTenant;



var $3Py8h = parcelRequire("3Py8h");


var $1T1QG = parcelRequire("1T1QG");





const $04dfc7c14f9267b3$var$InvitationsAdmin = ({ queryInvitations: queryInvitations, customerId: customerId })=>{
    const [showModalAdd, setShowModalAdd] = (0, $1T1QG.useState)(false);
    const queryClient = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)();
    const { isPermission: isPermission } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    /*
  // TODO Antti: Paging is missing from backend implementation
  const [pagingAndSortValues, setPagingAndSortValues] = useGlobalUI({
    key: SS_INVITATIONS_ADMIN_PAGING,
    initialValue: getPagingAndSortInitValues<InvitationSortType>('USED')
  })

  const pagination: MoovyPaginationProps | undefined = queryInvitations.data
    ?.pageable
    ? {
        page: queryInvitations.data.pageable.page,
        total: queryInvitations.data.pageable.total,
        limit: queryInvitations.data.pageable.limit,
        onNextPage: (page) =>
          setPagingAndSortValues({
            ...pagingAndSortValues,
            page: page.toString()
          })
      }
    : undefined
*/ const onInvitationRemoved = ()=>{
        /*
    // TODO Antti: Paging is missing from backend implementation
    const newPage = getNewPageAfterItemDeletion(pagination)
    if (newPage) {
      setPagingAndSortValues({
        ...pagingAndSortValues,
        page: newPage
      })
    }
*/ onRefreshView();
    };
    const onRefreshView = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $ec0c9d75a0d3a81a$export$96f07f442214aab),
                customerId
            ]
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
        sx: {
            paddingTop: 2
        },
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
            loading: queryInvitations.isPending,
            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b34a9598b5f97a22$export$2e2bcd8739ae039), {
                    queryInvitations: queryInvitations,
                    permissionAccess: {
                        action: "DELETE",
                        resource: "ADMIN_INVITATIONS"
                    },
                    addingInvitationParams: {
                        invitationType: "ADMIN",
                        landlordId: customerId
                    },
                    showModalAdd: showModalAdd,
                    setShowModalAdd: setShowModalAdd,
                    onInvitationRemoved: onInvitationRemoved,
                    onInvitationAdded: onRefreshView,
                    visibleColumns: isPermission("DELETE", "ADMIN_INVITATIONS") ? [
                        "NAME",
                        "EMAIL",
                        "INVITED",
                        "REMOVE"
                    ] : [
                        "NAME",
                        "EMAIL",
                        "INVITED"
                    ]
                })
            })
        })
    });
};
var $04dfc7c14f9267b3$export$2e2bcd8739ae039 = $04dfc7c14f9267b3$var$InvitationsAdmin;



var $3Py8h = parcelRequire("3Py8h");



var $8cd8f065b47158d9$export$6ef9dbcccbc4ed7d;
(function(BackendDatetime) {
    BackendDatetime.nowToUTC = ()=>{
        return BackendDatetime.toUTC((0, $51c4c2d07d14dea7$exports.DateTime).local());
    };
    BackendDatetime.toUTC = (datetime)=>{
        if (!datetime.isValid) {
            console.error("Invalid datetime was given. ", datetime);
            return "";
        }
        return datetime.toUTC().toISO() || "";
    };
    BackendDatetime.fromUTC = (utcDatetime, locale)=>{
        return (0, $51c4c2d07d14dea7$exports.DateTime).fromISO(utcDatetime || "").setLocale(locale);
    };
})($8cd8f065b47158d9$export$6ef9dbcccbc4ed7d || ($8cd8f065b47158d9$export$6ef9dbcccbc4ed7d = {}));
var $8cd8f065b47158d9$export$59110d836eb073ac;
(function(UIDatetime) {
    UIDatetime.toString = (datetime)=>{
        return datetime.toLocaleString((0, $51c4c2d07d14dea7$exports.DateTime).DATETIME_SHORT);
    };
})($8cd8f065b47158d9$export$59110d836eb073ac || ($8cd8f065b47158d9$export$59110d836eb073ac = {}));
var $8cd8f065b47158d9$export$6c3b6c09c58d6bc3;
(function(UIDate) {
    UIDate.toString = (datetime)=>{
        return datetime.toLocaleString((0, $51c4c2d07d14dea7$exports.DateTime).DATE_SHORT);
    };
    UIDate.toCustomString = (datetime, format = "yyyyMMdd")=>{
        return datetime.toFormat(format);
    };
})($8cd8f065b47158d9$export$6c3b6c09c58d6bc3 || ($8cd8f065b47158d9$export$6c3b6c09c58d6bc3 = {}));



var $3Py8h = parcelRequire("3Py8h");


var $1T1QG = parcelRequire("1T1QG");

var $eUHG3 = parcelRequire("eUHG3");



const $6c8c4cb3262db140$var$FormEditVehicle = (props)=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const getFormDefaultValues = ()=>{
        return {
            licensePlate: props.licensePlate
        };
    };
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $1T1QG.useState)(false);
    const schemaValidator = ()=>{
        return $d7c41ae3ced691f5$export$be5493f9613cbbe().shape({
            licensePlate: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().test("licensePlate", intl.formatMessage({
                id: "common.form.errors.licensePlate"
            }), function(licensePlate) {
                return (0, $5ed07630ed21dadb$export$dddb845077defee2)(licensePlate);
            })
        });
    };
    const onSubmitFormValues = (values)=>{
        const { licensePlate: licensePlate } = values;
        props.onSubmit(licensePlate.trim().toLocaleUpperCase());
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $eUHG3.Formik), {
        validate: ()=>setFormikValidateOnChange(true),
        validationSchema: schemaValidator(),
        enableReinitialize: true,
        initialValues: getFormDefaultValues(),
        validateOnChange: formikValidateOnChange,
        onSubmit: (values)=>{
            onSubmitFormValues(values);
        },
        children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $3Py8h.jsx)("form", {
                onSubmit: handleSubmit,
                id: props.formReference,
                children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormContainer, {
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                            name: "licensePlate",
                            "data-testid": "licensePlate",
                            value: values.licensePlate,
                            label: intl.formatMessage({
                                id: "common.text.licensePlate"
                            }),
                            placeholder: intl.formatMessage({
                                id: "common.text.licensePlate"
                            }),
                            onChange: handleChange,
                            error: !!errors.licensePlate,
                            errorText: errors.licensePlate
                        }),
                        props.showAccountingFields && /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                    name: "costCenter",
                                    "data-testid": "costCenter",
                                    disabled: true,
                                    value: props.costCenter,
                                    label: intl.formatMessage({
                                        id: "common.text.costCenter"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                    name: "project",
                                    "data-testid": "project",
                                    value: props.project,
                                    disabled: true,
                                    label: intl.formatMessage({
                                        id: "common.text.project"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
    });
};
var $6c8c4cb3262db140$export$2e2bcd8739ae039 = $6c8c4cb3262db140$var$FormEditVehicle;





const $7d92f70a64e5af9d$var$BASE_URL = `${(0, $5d4b99a1a33ba093$export$ff0725f0ea898f41)}/rights`;
const $7d92f70a64e5af9d$var$getRightByRef = async (ref)=>{
    const response = await (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${$7d92f70a64e5af9d$var$BASE_URL}/${ref}`);
    return response.data;
};
const $7d92f70a64e5af9d$var$changeLicensePlate = (rightHolderRef, rightLicensePlateChange)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).post(`${$7d92f70a64e5af9d$var$BASE_URL}/${rightHolderRef}/change-license-plate`, rightLicensePlateChange);
};
const $7d92f70a64e5af9d$var$endRight = (rightHolderRef, right)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).post(`${$7d92f70a64e5af9d$var$BASE_URL}/${rightHolderRef}/end`, right);
};
const $7d92f70a64e5af9d$var$RightsAPI = {
    getRightByRef: $7d92f70a64e5af9d$var$getRightByRef,
    changeLicensePlate: $7d92f70a64e5af9d$var$changeLicensePlate,
    endRight: $7d92f70a64e5af9d$var$endRight
};
var $7d92f70a64e5af9d$export$2e2bcd8739ae039 = $7d92f70a64e5af9d$var$RightsAPI;





var $1T1QG = parcelRequire("1T1QG");



const $7499271e3a060909$var$BASE_URL = "catalogues";
const $7499271e3a060909$var$getCataloguesByRef = (ref)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${(0, $5d4b99a1a33ba093$export$f654b28f82155665)(false)}/${$7499271e3a060909$var$BASE_URL}/${ref}`).then((response)=>response.data);
};
const $7499271e3a060909$var$getCataloguesByCustomer = (ref)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${(0, $5d4b99a1a33ba093$export$f654b28f82155665)(false)}/${$7499271e3a060909$var$BASE_URL}/by-customer-id/${ref}`).then((response)=>response.data);
};
const $7499271e3a060909$var$getActiveRightsById = (catalogueId, queryParams)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${(0, $5d4b99a1a33ba093$export$f654b28f82155665)(false)}/${$7499271e3a060909$var$BASE_URL}/${catalogueId}/active-rights`, queryParams ? {
        params: {
            ...queryParams
        }
    } : undefined).then((response)=>response.data);
};
const $7499271e3a060909$var$createCatalogue = (catalogue)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).post(`${(0, $5d4b99a1a33ba093$export$f654b28f82155665)(false)}/${$7499271e3a060909$var$BASE_URL}`, catalogue);
};
const $7499271e3a060909$var$updateCatalogue = (catalogueRef, catalogue)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).put(`${(0, $5d4b99a1a33ba093$export$f654b28f82155665)(false)}/${$7499271e3a060909$var$BASE_URL}/${catalogueRef}`, catalogue);
};
const $7499271e3a060909$var$getByOffering = (offeringRef, queryParams)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${(0, $5d4b99a1a33ba093$export$f654b28f82155665)(false)}/offerings/${offeringRef}/${$7499271e3a060909$var$BASE_URL}`, queryParams ? {
        params: {
            ...queryParams
        }
    } : undefined).then((response)=>response.data);
};
const $7499271e3a060909$export$25753268427e50ea = {
    getCataloguesByRef: $7499271e3a060909$var$getCataloguesByRef,
    getCataloguesByCustomer: $7499271e3a060909$var$getCataloguesByCustomer,
    getActiveRightsById: $7499271e3a060909$var$getActiveRightsById,
    createCatalogue: $7499271e3a060909$var$createCatalogue,
    getByOffering: $7499271e3a060909$var$getByOffering,
    updateCatalogue: $7499271e3a060909$var$updateCatalogue
};



var $3Py8h = parcelRequire("3Py8h");

var $1T1QG = parcelRequire("1T1QG");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $7Etkp = parcelRequire("7Etkp");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $5wtOU = parcelRequire("5wtOU");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");

var $7Etkp = parcelRequire("7Etkp");

var $npagc = parcelRequire("npagc");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $9a32c192f300f32d$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $9a32c192f300f32d$export$2e2bcd8739ae039 = $9a32c192f300f32d$var$getOverlayAlpha;



var $gADeF = parcelRequire("gADeF");


var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $27defff51d46def7$export$29cdb466b9b6f20b(slot) {
    return (0, $iNQht.default)("MuiPaper", slot);
}
const $27defff51d46def7$var$paperClasses = (0, $dfswM.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $27defff51d46def7$export$2e2bcd8739ae039 = $27defff51d46def7$var$paperClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $0a163fcc25046a25$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $0a163fcc25046a25$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $iV85C.default)(slots, (0, $27defff51d46def7$export$29cdb466b9b6f20b), classes);
};
const $0a163fcc25046a25$var$PaperRoot = (0, $npagc.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $ajTRS.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $ajTRS.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $7Etkp.alpha)("#fff", (0, $9a32c192f300f32d$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $7Etkp.alpha)("#fff", (0, $9a32c192f300f32d$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $0a163fcc25046a25$var$Paper = /*#__PURE__*/ $1T1QG.forwardRef(function Paper(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $iXdVf.default)(props, $0a163fcc25046a25$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $0a163fcc25046a25$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($0a163fcc25046a25$var$PaperRoot, (0, $ajTRS.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $aVXbR.default)(classes.root, className),
        ref: ref
    }, other));
});
var $0a163fcc25046a25$export$2e2bcd8739ae039 = $0a163fcc25046a25$var$Paper;



var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $c0ff155c8ccf70e2$export$69aecd24bc2cf7e3(slot) {
    return (0, $iNQht.default)("MuiAlert", slot);
}
const $c0ff155c8ccf70e2$var$alertClasses = (0, $dfswM.default)("MuiAlert", [
    "root",
    "action",
    "icon",
    "message",
    "filled",
    "filledSuccess",
    "filledInfo",
    "filledWarning",
    "filledError",
    "outlined",
    "outlinedSuccess",
    "outlinedInfo",
    "outlinedWarning",
    "outlinedError",
    "standard",
    "standardSuccess",
    "standardInfo",
    "standardWarning",
    "standardError"
]);
var $c0ff155c8ccf70e2$export$2e2bcd8739ae039 = $c0ff155c8ccf70e2$var$alertClasses;



var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");

var $7Etkp = parcelRequire("7Etkp");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");


var $5wtOU = parcelRequire("5wtOU");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $af38d06db724995f$export$5e8702d71474f093(slot) {
    return (0, $iNQht.default)("MuiIconButton", slot);
}
const $af38d06db724995f$var$iconButtonClasses = (0, $dfswM.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $af38d06db724995f$export$2e2bcd8739ae039 = $af38d06db724995f$var$iconButtonClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $5c784366741908ee$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $5c784366741908ee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $5wtOU.default)(color)}`,
            edge && `edge${(0, $5wtOU.default)(edge)}`,
            `size${(0, $5wtOU.default)(size)}`
        ]
    };
    return (0, $iV85C.default)(slots, (0, $af38d06db724995f$export$5e8702d71474f093), classes);
};
const $5c784366741908ee$var$IconButtonRoot = (0, $npagc.default)((0, $ecc40a2d226ef234$export$2e2bcd8739ae039), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $5wtOU.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $5wtOU.default)(ownerState.edge)}`],
            styles[`size${(0, $5wtOU.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7Etkp.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $ajTRS.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $ajTRS.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $ajTRS.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7Etkp.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $af38d06db724995f$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $5c784366741908ee$var$IconButton = /*#__PURE__*/ $1T1QG.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $iXdVf.default)(props, $5c784366741908ee$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $5c784366741908ee$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($5c784366741908ee$var$IconButtonRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $5c784366741908ee$export$2e2bcd8739ae039 = $5c784366741908ee$var$IconButton;


parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $bb7bbf5f170e177e$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined");


parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $02e2f537a6c61b56$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined");


parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $8575e0b177139752$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");


parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $f8f2d5a7ab3f2ff2$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");


parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $544593ea7d4730e2$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $7b8826fb1a00e789$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $7b8826fb1a00e789$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${variant}${(0, $5wtOU.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            "icon"
        ],
        message: [
            "message"
        ],
        action: [
            "action"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $c0ff155c8ccf70e2$export$69aecd24bc2cf7e3), classes);
};
const $7b8826fb1a00e789$var$AlertRoot = (0, $npagc.default)((0, $0a163fcc25046a25$export$2e2bcd8739ae039), {
    name: "MuiAlert",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $5wtOU.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const getColor = theme.palette.mode === "light" ? (0, $7Etkp.darken) : (0, $7Etkp.lighten);
    const getBackgroundColor = theme.palette.mode === "light" ? (0, $7Etkp.lighten) : (0, $7Etkp.darken);
    const color = ownerState.color || ownerState.severity;
    return (0, $ajTRS.default)({}, theme.typography.body2, {
        backgroundColor: "transparent",
        display: "flex",
        padding: "6px 16px"
    }, color && ownerState.variant === "standard" && {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
        [`& .${(0, $c0ff155c8ccf70e2$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
            color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
            color: theme.palette[color].main
        }
    }, color && ownerState.variant === "outlined" && {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
        [`& .${(0, $c0ff155c8ccf70e2$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
            color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
            color: theme.palette[color].main
        }
    }, color && ownerState.variant === "filled" && (0, $ajTRS.default)({
        fontWeight: theme.typography.fontWeightMedium
    }, theme.vars ? {
        color: theme.vars.palette.Alert[`${color}FilledColor`],
        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
    } : {
        backgroundColor: theme.palette.mode === "dark" ? theme.palette[color].dark : theme.palette[color].main,
        color: theme.palette.getContrastText(theme.palette[color].main)
    }));
});
const $7b8826fb1a00e789$var$AlertIcon = (0, $npagc.default)("div", {
    name: "MuiAlert",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: "7px 0",
    display: "flex",
    fontSize: 22,
    opacity: 0.9
});
const $7b8826fb1a00e789$var$AlertMessage = (0, $npagc.default)("div", {
    name: "MuiAlert",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0",
    minWidth: 0,
    overflow: "auto"
});
const $7b8826fb1a00e789$var$AlertAction = (0, $npagc.default)("div", {
    name: "MuiAlert",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "flex-start",
    padding: "4px 0 0 16px",
    marginLeft: "auto",
    marginRight: -8
});
const $7b8826fb1a00e789$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $bb7bbf5f170e177e$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $02e2f537a6c61b56$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8575e0b177139752$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f8f2d5a7ab3f2ff2$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $7b8826fb1a00e789$var$Alert = /*#__PURE__*/ $1T1QG.forwardRef(function Alert(inProps, ref) {
    var _ref, _slots$closeButton, _ref2, _slots$closeIcon, _slotProps$closeButto, _slotProps$closeIcon;
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiAlert"
    });
    const { action: action, children: children, className: className, closeText: closeText = "Close", color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $7b8826fb1a00e789$var$defaultIconMapping, onClose: onClose, role: role = "alert", severity: severity = "success", slotProps: slotProps = {}, slots: slots = {}, variant: variant = "standard" } = props, other = (0, $iXdVf.default)(props, $7b8826fb1a00e789$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant
    });
    const classes = $7b8826fb1a00e789$var$useUtilityClasses(ownerState);
    const AlertCloseButton = (_ref = (_slots$closeButton = slots.closeButton) != null ? _slots$closeButton : components.CloseButton) != null ? _ref : (0, $5c784366741908ee$export$2e2bcd8739ae039);
    const AlertCloseIcon = (_ref2 = (_slots$closeIcon = slots.closeIcon) != null ? _slots$closeIcon : components.CloseIcon) != null ? _ref2 : (0, $544593ea7d4730e2$export$2e2bcd8739ae039);
    const closeButtonProps = (_slotProps$closeButto = slotProps.closeButton) != null ? _slotProps$closeButto : componentsProps.closeButton;
    const closeIconProps = (_slotProps$closeIcon = slotProps.closeIcon) != null ? _slotProps$closeIcon : componentsProps.closeIcon;
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($7b8826fb1a00e789$var$AlertRoot, (0, $ajTRS.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $aVXbR.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $3Py8h.jsx)($7b8826fb1a00e789$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $7b8826fb1a00e789$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $3Py8h.jsx)($7b8826fb1a00e789$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $3Py8h.jsx)($7b8826fb1a00e789$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $3Py8h.jsx)($7b8826fb1a00e789$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $3Py8h.jsx)(AlertCloseButton, (0, $ajTRS.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)(AlertCloseIcon, (0, $ajTRS.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $7b8826fb1a00e789$export$2e2bcd8739ae039 = $7b8826fb1a00e789$var$Alert;


var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");


var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $6e3a3120323b0517$export$5269a5bce2c2f987(slot) {
    return (0, $iNQht.default)("MuiAlertTitle", slot);
}
const $6e3a3120323b0517$var$alertTitleClasses = (0, $dfswM.default)("MuiAlertTitle", [
    "root"
]);
var $6e3a3120323b0517$export$2e2bcd8739ae039 = $6e3a3120323b0517$var$alertTitleClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $5b72502b9c34cc47$var$_excluded = [
    "className"
];
const $5b72502b9c34cc47$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $6e3a3120323b0517$export$5269a5bce2c2f987), classes);
};
const $5b72502b9c34cc47$var$AlertTitleRoot = (0, $npagc.default)((0, $a386176d6ca21602$export$2e2bcd8739ae039), {
    name: "MuiAlertTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
});
const $5b72502b9c34cc47$var$AlertTitle = /*#__PURE__*/ $1T1QG.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiAlertTitle"
    });
    const { className: className } = props, other = (0, $iXdVf.default)(props, $5b72502b9c34cc47$var$_excluded);
    const ownerState = props;
    const classes = $5b72502b9c34cc47$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($5b72502b9c34cc47$var$AlertTitleRoot, (0, $ajTRS.default)({
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $aVXbR.default)(classes.root, className)
    }, other));
});
var $5b72502b9c34cc47$export$2e2bcd8739ae039 = $5b72502b9c34cc47$var$AlertTitle;


const $35d1b3ff9fe5891a$export$1da928963a217e70 = ({ title: title, children: children, severity: severity = "error", style: style })=>{
    const isChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).isValidElement(children);
    const RenderOnlyTitle = ()=>{
        return /*#__PURE__*/ (0, $3Py8h.jsx)("b", {
            children: title
        });
    };
    const RenderOnlyDescription = ()=>{
        return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
            children: children
        });
    };
    const RenderAll = ()=>{
        return /*#__PURE__*/ (0, $3Py8h.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $5b72502b9c34cc47$export$2e2bcd8739ae039), {
                    children: title
                }),
                children
            ]
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $7b8826fb1a00e789$export$2e2bcd8739ae039), {
        severity: severity,
        style: style,
        children: title && isChildren ? /*#__PURE__*/ (0, $3Py8h.jsx)(RenderAll, {}) : title ? /*#__PURE__*/ (0, $3Py8h.jsx)(RenderOnlyTitle, {}) : /*#__PURE__*/ (0, $3Py8h.jsx)(RenderOnlyDescription, {})
    });
};


const $362423ed72ac6e25$var$ModalEditVehicle = ({ open: open, rightId: rightId, catalogueId: catalogueId, licensePlate: licensePlate, costCenter: costCenter, project: project, onTerminated: onTerminated, onSubmit: onSubmit, onCancel: onCancel, showAccountingFields: showAccountingFields })=>{
    const FORM_REFERENCE = "formEditVehicle";
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const { isPermission: isPermission } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const [confirmationTerminateRight, setConfirmationTerminateRight] = (0, $1T1QG.useState)(false);
    const [endReason, setEndReason] = (0, $1T1QG.useState)("");
    const [endReasonMissing, setEndReasonMissing] = (0, $1T1QG.useState)(false);
    const queryCatalog = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$93e1682d8eaccc31),
            catalogueId
        ],
        queryFn: ()=>(0, $7499271e3a060909$export$25753268427e50ea).getCataloguesByRef(catalogueId),
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc),
        enabled: !!catalogueId
    });
    const isWebshopCatalogue = queryCatalog.data?.type === "WEBSHOP";
    const changeRightMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $7d92f70a64e5af9d$export$2e2bcd8739ae039).changeLicensePlate(rightId, dto),
        onSuccess: (response)=>{
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "modalEditVehicle.actions.change"
            }));
            onSubmit(response.data);
        }
    });
    const updateRightHolder = (licensePlate)=>{
        const dto = {
            licensePlate: licensePlate ? licensePlate.trim().toLocaleUpperCase() : ""
        };
        if (dto.licensePlate) changeRightMutation.mutate(dto);
    };
    const terminateRightMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (endRight)=>(0, $7d92f70a64e5af9d$export$2e2bcd8739ae039).endRight(rightId, endRight),
        onSuccess: (response)=>{
            setConfirmationTerminateRight(false);
            setEndReason("");
            setEndReasonMissing(false);
            onTerminated();
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "modalEditVehicle.actions.rightEnded"
            }));
        }
    });
    const cancel = ()=>{
        changeRightMutation.reset();
        onCancel();
    };
    const cancelConfirmation = ()=>{
        setConfirmationTerminateRight(false);
        setEndReasonMissing(false);
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $259d9dbb3544503a$export$2e2bcd8739ae039), {
                open: open,
                onCancel: cancel,
                formReference: FORM_REFERENCE,
                mutation: changeRightMutation,
                errorTitleKey: "common.actions.update.error",
                modalTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "modalEditVehicle.title"
                }),
                submitButtonContent: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "common.buttons.update"
                }),
                disableSubmit: isWebshopCatalogue,
                leftSideButtons: isPermission("DELETE", "RIGHTS") ? [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                        color: "error",
                        onClick: ()=>{
                            setConfirmationTerminateRight(true);
                        },
                        variant: "text",
                        disabled: isWebshopCatalogue,
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "common.buttons.terminate"
                        })
                    }, "terminate")
                ] : undefined,
                children: [
                    isWebshopCatalogue && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $35d1b3ff9fe5891a$export$1da928963a217e70), {
                        title: intl.formatMessage({
                            id: "modalEditVehicle.webshopWarning"
                        }),
                        severity: "warning",
                        style: {
                            marginBottom: "1rem"
                        }
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $6c8c4cb3262db140$export$2e2bcd8739ae039), {
                        formReference: FORM_REFERENCE,
                        licensePlate: licensePlate,
                        costCenter: costCenter,
                        project: project,
                        onSubmit: updateRightHolder,
                        showAccountingFields: showAccountingFields
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $7f916474711491ea$export$2e2bcd8739ae039), {
                open: confirmationTerminateRight,
                lang: {
                    confirmButton: "common.buttons.yes",
                    error: "modalEditVehicle.actions.error.end"
                },
                header: intl.formatMessage({
                    id: "modalEditVehicle.modalRemove.header"
                }),
                content: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                            style: {
                                marginBottom: "1em"
                            },
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                id: "modalEditVehicle.modalRemove.content",
                                values: {
                                    licensePlate: licensePlate
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormContainer, {
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                name: "endReason",
                                "data-testid": "endReason",
                                value: endReason,
                                autoFocus: true,
                                multiline: true,
                                error: endReasonMissing,
                                errorText: endReasonMissing ? intl.formatMessage({
                                    id: "common.form.errors.empty"
                                }) : "",
                                label: intl.formatMessage({
                                    id: "modalEditVehicle.modalRemove.content.endReason"
                                }),
                                placeholder: intl.formatMessage({
                                    id: "modalEditVehicle.modalRemove.content.endReason.placeholder"
                                }),
                                onChange: (evt)=>{
                                    setEndReason(evt.target.value);
                                    setEndReasonMissing(false);
                                }
                            })
                        })
                    ]
                }),
                onCancel: cancelConfirmation,
                onConfirm: ()=>{
                    if (endReason) terminateRightMutation.mutate({
                        validityEnd: (0, $8cd8f065b47158d9$export$6ef9dbcccbc4ed7d).nowToUTC(),
                        endReason: endReason
                    });
                    else setEndReasonMissing(true);
                },
                mutation: terminateRightMutation
            })
        ]
    });
};
var $362423ed72ac6e25$export$2e2bcd8739ae039 = $362423ed72ac6e25$var$ModalEditVehicle;



var $3Py8h = parcelRequire("3Py8h");


var $3Py8h = parcelRequire("3Py8h");


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $7Etkp = parcelRequire("7Etkp");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $1T1QG = parcelRequire("1T1QG");
"use client";
/**
 * @ignore - internal component.
 */ const $be3ac30bfa71c06e$var$ListContext = /*#__PURE__*/ $1T1QG.createContext({});
var $be3ac30bfa71c06e$export$2e2bcd8739ae039 = $be3ac30bfa71c06e$var$ListContext;






var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $421323354d856804$export$46f01d01378ec5a2(slot) {
    return (0, $iNQht.default)("MuiDivider", slot);
}
const $421323354d856804$var$dividerClasses = (0, $dfswM.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $421323354d856804$export$2e2bcd8739ae039 = $421323354d856804$var$dividerClasses;



var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $f79b291cce78cf4e$export$81478e24460c57f2(slot) {
    return (0, $iNQht.default)("MuiListItemIcon", slot);
}
const $f79b291cce78cf4e$var$listItemIconClasses = (0, $dfswM.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $f79b291cce78cf4e$export$2e2bcd8739ae039 = $f79b291cce78cf4e$var$listItemIconClasses;



var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $980fee846c99659e$export$1061006a0db3aeb5(slot) {
    return (0, $iNQht.default)("MuiListItemText", slot);
}
const $980fee846c99659e$var$listItemTextClasses = (0, $dfswM.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $980fee846c99659e$export$2e2bcd8739ae039 = $980fee846c99659e$var$listItemTextClasses;



var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $19cc897f3476ea1e$export$515f8c67b5305377(slot) {
    return (0, $iNQht.default)("MuiMenuItem", slot);
}
const $19cc897f3476ea1e$var$menuItemClasses = (0, $dfswM.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $19cc897f3476ea1e$export$2e2bcd8739ae039 = $19cc897f3476ea1e$var$menuItemClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $450c65ee2dafa292$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $450c65ee2dafa292$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $450c65ee2dafa292$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $iV85C.default)(slots, (0, $19cc897f3476ea1e$export$515f8c67b5305377), classes);
    return (0, $ajTRS.default)({}, classes, composedClasses);
};
const $450c65ee2dafa292$var$MenuItemRoot = (0, $npagc.default)((0, $ecc40a2d226ef234$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $npagc.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $450c65ee2dafa292$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $19cc897f3476ea1e$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $19cc897f3476ea1e$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $19cc897f3476ea1e$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $19cc897f3476ea1e$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $19cc897f3476ea1e$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $421323354d856804$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $421323354d856804$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $980fee846c99659e$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $980fee846c99659e$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $f79b291cce78cf4e$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $ajTRS.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $f79b291cce78cf4e$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $450c65ee2dafa292$var$MenuItem = /*#__PURE__*/ $1T1QG.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className } = props, other = (0, $iXdVf.default)(props, $450c65ee2dafa292$var$_excluded);
    const context = $1T1QG.useContext((0, $be3ac30bfa71c06e$export$2e2bcd8739ae039));
    const childContext = $1T1QG.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $1T1QG.useRef(null);
    (0, $675d87943b3ee26a$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $ajTRS.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $450c65ee2dafa292$var$useUtilityClasses(props);
    const handleRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $be3ac30bfa71c06e$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($450c65ee2dafa292$var$MenuItemRoot, (0, $ajTRS.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $aVXbR.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $aVXbR.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $450c65ee2dafa292$export$2e2bcd8739ae039 = $450c65ee2dafa292$var$MenuItem;




var $1T1QG = parcelRequire("1T1QG");

var $eUHG3 = parcelRequire("eUHG3");




function $a48e808e68b0e5f9$export$2e2bcd8739ae039() {
    const dispatch = (0, $4a938932ca693376$export$8ad76b76a4c905f8)();
    const setInitialized = (initialized)=>{
        dispatch((0, $455a74580fe95862$export$bbe1eb340cdbd464)(initialized));
    };
    const setCustomer = (customer, defineCustomType = false)=>{
        let customerToBeSet = {
            id: "",
            name: ""
        };
        let customerTypeToBeSet = "";
        if (!customer) {
            if (defineCustomType) dispatch((0, $1b8d920c7c0aec35$export$3160f67d8720ec42)(customerTypeToBeSet));
            dispatch((0, $455a74580fe95862$export$ae66d5a6ca962c9a)(customerToBeSet));
            return;
        }
        customerToBeSet = {
            id: customer.id,
            name: customer.name
        };
        customerTypeToBeSet = customer.type;
        if (defineCustomType) dispatch((0, $1b8d920c7c0aec35$export$3160f67d8720ec42)(customerTypeToBeSet?.charAt(0)));
        dispatch((0, $455a74580fe95862$export$ae66d5a6ca962c9a)(customerToBeSet));
    };
    const setCustomerFromArray = (customers, defineCustomType = false)=>{
        // At first, try to find landlord user
        let firstCustomer = customers.find((item)=>!item.parentId && item.type === "LANDLORD");
        // If not, use the first tenant
        if (!firstCustomer) firstCustomer = customers.find((item)=>item.type === "TENANT");
        setCustomer(firstCustomer, defineCustomType);
    };
    const place = (0, $c354137c2cb06a61$export$2105062e25df4afe)((0, $455a74580fe95862$export$1c46e3decb4a80c2).getPlace);
    const setPlace = (newPlace)=>{
        let placeToBeSet = {
            id: "",
            name: ""
        };
        if (!newPlace) {
            if (!place || !place.id || !place.name) dispatch((0, $455a74580fe95862$export$2f52b3443c11c15a)(placeToBeSet));
            return;
        }
        placeToBeSet = {
            id: newPlace.id,
            name: newPlace.name
        };
        if (place.id != placeToBeSet.id || place.name.localeCompare(newPlace.name)) dispatch((0, $455a74580fe95862$export$2f52b3443c11c15a)(placeToBeSet));
    };
    const setPlaceFromArray = (places)=>{
        const firstPlace = places?.find((item)=>!item.parentId);
        setPlace(firstPlace);
        setInitialized(true);
    };
    const setPlaceFromCatalogue = (catalogue)=>{
        setPlace({
            id: catalogue.place?.id,
            name: catalogue.place?.name
        });
        setCatalogueId(catalogue.id);
        setInitialized(true);
    };
    const setCatalogueId = (catalogueId)=>{
        dispatch((0, $455a74580fe95862$export$12af370a2d55934d)(catalogueId));
    };
    const catalogueId = (0, $c354137c2cb06a61$export$2105062e25df4afe)((0, $455a74580fe95862$export$1c46e3decb4a80c2).getCatalogueId);
    const customer = (0, $c354137c2cb06a61$export$2105062e25df4afe)((0, $455a74580fe95862$export$1c46e3decb4a80c2).getCustomer);
    const customerConfigured = !!place.id && !!customer.id;
    const initialized = (0, $c354137c2cb06a61$export$2105062e25df4afe)((0, $455a74580fe95862$export$1c46e3decb4a80c2).getInitialized);
    return {
        setPlace: setPlace,
        setPlaceFromArray: setPlaceFromArray,
        setPlaceFromCatalogue: setPlaceFromCatalogue,
        place: place,
        setCustomer: setCustomer,
        setCustomerFromArray: setCustomerFromArray,
        customer: customer,
        setInitialized: setInitialized,
        initialized: initialized,
        customerConfigured: customerConfigured,
        setCatalogueId: setCatalogueId,
        catalogueId: catalogueId
    };
}


const $c467760e4a7cc791$var$FormSubPlace = (props)=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const { customer: customer } = (0, $a48e808e68b0e5f9$export$2e2bcd8739ae039)();
    const customerOptions = props.customers.map((item)=>{
        return {
            key: item.id,
            value: item.name
        };
    });
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $1T1QG.useState)(false);
    const SubPlaceSchema = ()=>{
        return $d7c41ae3ced691f5$export$be5493f9613cbbe().shape({
            name: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            capacity: $d7c41ae3ced691f5$export$98e628dec113755e().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })).typeError(intl.formatMessage({
                id: "common.form.errors.number"
            })),
            streetAddress: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            postalCode: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            city: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            }))
        });
    };
    const getFormDefaultValues = ()=>{
        return {
            name: props.defaultValues?.name || "",
            capacity: props.defaultValues?.capacity || "",
            streetAddress: props.defaultValues?.streetAddress || "",
            postalCode: props.defaultValues?.postalCode || "",
            city: props.defaultValues?.city || "",
            customerId: props.defaultValues?.customerId || customer.id
        };
    };
    const [defaultValues, setDefaultValues] = (0, $1T1QG.useState)(getFormDefaultValues());
    (0, $1T1QG.useEffect)(()=>{
        setDefaultValues(getFormDefaultValues());
    }, [
        props.defaultValues?.name,
        props.defaultValues?.capacity
    ]);
    const onSubmitFormValues = (values)=>{
        const { name: name, capacity: capacity, streetAddress: streetAddress, postalCode: postalCode, city: city, customerId: customerId } = values;
        props.onSubmit({
            name: name.trim(),
            capacity: capacity.trim(),
            streetAddress: streetAddress.trim(),
            postalCode: postalCode.trim(),
            city: city.trim(),
            customerId: customerId
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $eUHG3.Formik), {
            enableReinitialize: true,
            validate: ()=>setFormikValidateOnChange(true),
            validateOnChange: formikValidateOnChange,
            initialValues: defaultValues,
            validationSchema: SubPlaceSchema(),
            onSubmit: (values)=>{
                onSubmitFormValues(values);
            },
            children: ({ handleSubmit: handleSubmit, handleChange: handleChange, values: values, errors: errors })=>/*#__PURE__*/ (0, $3Py8h.jsxs)("form", {
                    onSubmit: handleSubmit,
                    id: props.formReference,
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)("h4", {
                            style: {
                                marginTop: "5px"
                            },
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                id: "page.customer.formSubPlace.title.location"
                            })
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                            gap: 2,
                            display: "flex",
                            flexDirection: {
                                xs: "column"
                            },
                            children: [
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormSelect, {
                                        name: "customerId",
                                        label: intl.formatMessage({
                                            id: "page.places.formPlace.label.customer"
                                        }),
                                        value: values.customerId,
                                        onChange: handleChange,
                                        error: !!errors.customerId,
                                        children: customerOptions.map((item)=>{
                                            return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $450c65ee2dafa292$export$2e2bcd8739ae039), {
                                                value: item.key,
                                                children: item.value
                                            }, item.key);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                    flexDirection: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                            fullWidth: true,
                                            name: "name",
                                            "data-testid": "name",
                                            value: values.name,
                                            label: intl.formatMessage({
                                                id: "page.customer.formSubPlace.label.name"
                                            }),
                                            placeholder: intl.formatMessage({
                                                id: "page.customer.formSubPlace.label.name"
                                            }),
                                            onChange: handleChange,
                                            error: !!errors.name,
                                            errorText: errors.name
                                        }),
                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                            name: "streetAddress",
                                            "data-testid": "streetAddress",
                                            value: values.streetAddress,
                                            label: intl.formatMessage({
                                                id: "page.customer.formSubPlace.label.streetAddress"
                                            }),
                                            placeholder: intl.formatMessage({
                                                id: "page.customer.formSubPlace.label.streetAddress"
                                            }),
                                            onChange: handleChange,
                                            error: !!errors.streetAddress,
                                            errorText: errors.streetAddress
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                    flexDirection: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                            name: "postalCode",
                                            "data-testid": "postalCode",
                                            value: values.postalCode,
                                            label: intl.formatMessage({
                                                id: "page.customer.formSubPlace.label.postalCode"
                                            }),
                                            placeholder: intl.formatMessage({
                                                id: "page.customer.formSubPlace.label.postalCode"
                                            }),
                                            onChange: handleChange,
                                            error: !!errors.postalCode,
                                            errorText: errors.postalCode
                                        }),
                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                            name: "city",
                                            "data-testid": "city",
                                            value: values.city,
                                            label: intl.formatMessage({
                                                id: "page.customer.formSubPlace.label.city"
                                            }),
                                            placeholder: intl.formatMessage({
                                                id: "page.customer.formSubPlace.label.city"
                                            }),
                                            onChange: handleChange,
                                            error: !!errors.city,
                                            errorText: errors.city
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)("h4", {
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                id: "page.customer.formSubPlace.title.space"
                            })
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                name: "capacity",
                                "data-testid": "capacity",
                                value: values.capacity,
                                label: intl.formatMessage({
                                    id: "page.customer.formSubPlace.label.spots"
                                }),
                                placeholder: intl.formatMessage({
                                    id: "page.customer.formSubPlace.label.spots"
                                }),
                                onChange: handleChange,
                                error: !!errors.capacity,
                                errorText: errors.capacity
                            })
                        })
                    ]
                })
        })
    });
};
var $c467760e4a7cc791$export$2e2bcd8739ae039 = $c467760e4a7cc791$var$FormSubPlace;





const $3af058eac12e21cb$var$BASE_URL = `customers`;
const $3af058eac12e21cb$var$getUrl = (admin)=>`${(0, $5d4b99a1a33ba093$export$f654b28f82155665)(admin)}/${$3af058eac12e21cb$var$BASE_URL}`;
const $3af058eac12e21cb$var$createCustomer = (customer)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).post($3af058eac12e21cb$var$getUrl(false), customer);
};
const $3af058eac12e21cb$var$updateCustomer = (ref, customer)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).put(`${$3af058eac12e21cb$var$getUrl(false)}/${ref}`, customer);
};
const $3af058eac12e21cb$var$getCustomerByRef = (ref)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${$3af058eac12e21cb$var$getUrl(false)}/${ref}`).then((response)=>response.data);
};
const $3af058eac12e21cb$var$getCustomers = (admin, queryParams)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get($3af058eac12e21cb$var$getUrl(admin), queryParams ? {
        params: {
            ...queryParams
        }
    } : undefined).then((response)=>response.data);
};
const $3af058eac12e21cb$var$getLandlords = (admin, queryParams)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${$3af058eac12e21cb$var$getUrl(admin)}/landlords`, queryParams ? {
        params: {
            ...queryParams
        }
    } : undefined).then((response)=>response.data);
};
const $3af058eac12e21cb$var$getIndividualsByCustomer = (admin, ref)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${$3af058eac12e21cb$var$getUrl(false)}/${ref}/right-holders/individuals`).then((response)=>response.data);
};
const $3af058eac12e21cb$var$getPlacesByCustomer = (admin, ref)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${$3af058eac12e21cb$var$getUrl(admin)}/${ref}/places`).then((response)=>response.data);
};
const $3af058eac12e21cb$var$getUsersByCustomer = (ref)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${$3af058eac12e21cb$var$getUrl(false)}/${ref}/users`).then((response)=>response.data);
};
const $3af058eac12e21cb$var$removeUser = (customerId, userId)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).delete(`${(0, $5d4b99a1a33ba093$export$ff0725f0ea898f41)}/${$3af058eac12e21cb$var$BASE_URL}/${customerId}/users/${userId}`);
};
const $3af058eac12e21cb$var$CustomersAPI = {
    createCustomer: $3af058eac12e21cb$var$createCustomer,
    updateCustomer: $3af058eac12e21cb$var$updateCustomer,
    getCustomerByRef: $3af058eac12e21cb$var$getCustomerByRef,
    getCustomers: $3af058eac12e21cb$var$getCustomers,
    getLandlords: $3af058eac12e21cb$var$getLandlords,
    getIndividualsByCustomer: $3af058eac12e21cb$var$getIndividualsByCustomer,
    getPlacesByCustomer: $3af058eac12e21cb$var$getPlacesByCustomer,
    removeUser: $3af058eac12e21cb$var$removeUser,
    getUsersByCustomer: $3af058eac12e21cb$var$getUsersByCustomer
};
var $3af058eac12e21cb$export$2e2bcd8739ae039 = $3af058eac12e21cb$var$CustomersAPI;







const $f7802c761d4f9d37$var$BASE_URL = `${(0, $5d4b99a1a33ba093$export$ff0725f0ea898f41)}/places`;
const $f7802c761d4f9d37$var$BASE_ADMIN_URL = `${(0, $5d4b99a1a33ba093$export$662364dbe336d1ec)}/places`;
const $f7802c761d4f9d37$var$createPlaceWithDefaultOffering = (place)=>{
    place.createDefaultOffering = true;
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).post($f7802c761d4f9d37$var$BASE_URL, place);
};
const $f7802c761d4f9d37$var$updatePlace = (ref, place)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).put(`${$f7802c761d4f9d37$var$BASE_URL}/${ref}`, place);
};
const $f7802c761d4f9d37$var$getPlaceByRef = (ref)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${$f7802c761d4f9d37$var$BASE_URL}/${ref}`).then((response)=>response.data);
};
const $f7802c761d4f9d37$var$getOfferingsByPlace = (ref)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${$f7802c761d4f9d37$var$BASE_URL}/${ref}/offering`).then((response)=>response.data);
};
const $f7802c761d4f9d37$var$getPlaces = (queryParams)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get($f7802c761d4f9d37$var$BASE_ADMIN_URL, queryParams ? {
        params: {
            ...queryParams
        }
    } : undefined).then((response)=>response.data);
};
const $f7802c761d4f9d37$export$2bffccb0f948be1f = {
    createPlaceWithDefaultOffering: $f7802c761d4f9d37$var$createPlaceWithDefaultOffering,
    updatePlace: $f7802c761d4f9d37$var$updatePlace,
    getPlaceByRef: $f7802c761d4f9d37$var$getPlaceByRef,
    getPlaces: $f7802c761d4f9d37$var$getPlaces,
    getOfferingsByPlace: $f7802c761d4f9d37$var$getOfferingsByPlace
};
const $f7802c761d4f9d37$export$17a026f5eed4231 = {
    getPlaces: $f7802c761d4f9d37$var$getPlaces
};




const $4a501defb6a96d4b$var$ModalSubPlace = (props)=>{
    const FORM_REFERENCE = "formSubPlace";
    const { place: place } = (0, $a48e808e68b0e5f9$export$2e2bcd8739ae039)();
    const { admin: admin } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const queryCustomers = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$6efe1800fcda6819)
        ],
        // TODO Antti: Should be fixed later because there might be more than 500 customers.
        // Anyway, this code is not in use so far because UI does not support adding sub places
        queryFn: ()=>(0, $3af058eac12e21cb$export$2e2bcd8739ae039).getCustomers(admin, {
                limit: 500,
                sort: "TYPE",
                direction: "ASC"
            }),
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const customers = queryCustomers.data?.data || [];
    const queryPlace = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$823cd27a3f5f229e),
            place.id
        ],
        queryFn: ()=>(0, $f7802c761d4f9d37$export$2bffccb0f948be1f).getPlaceByRef(place.id || ""),
        enabled: !!place.id
    });
    const defaultValues = {
        name: "",
        streetAddress: queryPlace.data?.streetAddress || "",
        postalCode: queryPlace.data?.postalCode || "",
        city: queryPlace.data?.city || "",
        capacity: "",
        customerId: queryPlace.data?.customer?.id || props.customerId
    };
    const subPlaceMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $f7802c761d4f9d37$export$2bffccb0f948be1f).createPlaceWithDefaultOffering(dto),
        onSuccess: (response)=>{
            const place = response.data || {};
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "components.modalSubPlace.actions.added"
            }));
            props.onSubmit(place);
        }
    });
    const addSubPlace = (values)=>{
        const { name: name, capacity: capacity, streetAddress: streetAddress, postalCode: postalCode, city: city, customerId: customerId } = values;
        const dto = {
            name: name,
            streetAddress: streetAddress,
            postalCode: postalCode,
            city: city,
            customerId: customerId,
            parentId: place.id,
            capacity: Number.parseInt(capacity)
        };
        subPlaceMutation.mutate(dto);
    };
    const cancel = ()=>{
        subPlaceMutation.reset();
        props.onCancel();
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $259d9dbb3544503a$export$2e2bcd8739ae039), {
            open: props.open,
            onCancel: cancel,
            formReference: FORM_REFERENCE,
            mutation: subPlaceMutation,
            errorTitleKey: "components.modalSubPlace.actions.error.added",
            modalTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "components.modalSubPlace.title"
            }),
            submitButtonContent: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "components.modalSubPlace.button.add"
            }),
            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c467760e4a7cc791$export$2e2bcd8739ae039), {
                formReference: FORM_REFERENCE,
                onSubmit: addSubPlace,
                defaultValues: defaultValues,
                customers: customers
            })
        })
    });
};
var $4a501defb6a96d4b$export$2e2bcd8739ae039 = $4a501defb6a96d4b$var$ModalSubPlace;



var $3Py8h = parcelRequire("3Py8h");





const $fec9f563e701e087$var$TableSubPlaces = (props)=>{
    const navigate = (0, $e0cff2801449e77d$export$9770f232ac06a008)();
    const { queryPlaces: queryPlaces, places: places } = props;
    const onClickRow = (placeRef, parentPlaceRef)=>{
        !!parentPlaceRef ? navigate(`${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES}/${parentPlaceRef}${(0, $e88b4657ea1cb9ec$export$25c4819f1669a599).SUB_PLACES}/${placeRef}`) : navigate(`${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES}/${placeRef}`);
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8002a2b5b87a23eb$export$2e2bcd8739ae039), {
                emptyTextId: "components.tableSubPlaces.action.empty",
                errorTextId: "components.tableSubPlaces.action.failed",
                query: queryPlaces,
                children: places.map((row)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0829f6a75e4b5e7$export$2e2bcd8739ae039), {
                        cardTitle: row.name,
                        cardSecondaryTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                            utcDateTime: row.updatedAt
                        }),
                        cardContentList: [
                            row.streetAddress,
                            row.postalCode,
                            row.city
                        ],
                        onCardClicked: ()=>onClickRow(row.id, row.parentId)
                    }, row.id))
            }),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $c6e866c0d03fba92$export$2e2bcd8739ae039), {
                items: places,
                emptyTextId: "components.tableSubPlaces.action.empty",
                errorTextId: "components.tableSubPlaces.action.failed",
                query: queryPlaces,
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b52028b37ea87ec4$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "components.tableSubPlaces.header.name"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "components.tableSubPlaces.header.customer"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "components.tableSubPlaces.header.streetAddress"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "components.tableSubPlaces.header.postalCode"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "components.tableSubPlaces.header.city"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "components.tableSubPlaces.header.capacity"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a3b5a93a68cc46b9$export$2e2bcd8739ae039), {
                        "data-testid": "places-table-body",
                        children: places.map((row)=>/*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                                hover: true,
                                sx: {
                                    cursor: "pointer"
                                },
                                onClick: ()=>onClickRow(row.id, row.parentId),
                                children: [
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $041febe0dbc86e0a$export$2e2bcd8739ae039), {
                                            bold: true,
                                            children: row.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: row.customer?.name
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: row.streetAddress
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: row.postalCode
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: row.city
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: row.capacity
                                    })
                                ]
                            }, row.id))
                    })
                ]
            })
        ]
    });
};
var $fec9f563e701e087$export$2e2bcd8739ae039 = $fec9f563e701e087$var$TableSubPlaces;



var $3Py8h = parcelRequire("3Py8h");



var $npagc = parcelRequire("npagc");
const $601f8b5eb9aad27b$var$TimeStampItems = ({ createdAt: createdAt, updatedAt: updatedAt, createdText: createdText, dateOnly: dateOnly })=>{
    const Item = (0, $npagc.default)("span")`
    display: block;
    margin: 0;
  `;
    const StyledLabel = (0, $npagc.default)("span")`
    margin-right: 0.3rem;
  `;
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsxs)(Item, {
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)(StyledLabel, {
                        children: createdText ? createdText : /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "timeStampItems.createdAt"
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                        utcDateTime: createdAt,
                        emptyText: "-",
                        dateOnly: dateOnly
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3Py8h.jsxs)(Item, {
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)(StyledLabel, {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "timeStampItems.updatedAt"
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                        utcDateTime: updatedAt,
                        emptyText: "-",
                        dateOnly: dateOnly
                    })
                ]
            })
        ]
    });
};
var $601f8b5eb9aad27b$export$2e2bcd8739ae039 = $601f8b5eb9aad27b$var$TimeStampItems;



var $3Py8h = parcelRequire("3Py8h");

var $1T1QG = parcelRequire("1T1QG");
/**
 * Some libraries may not follow Node ES module spec and could be loaded as CommonJS modules,
 * To ensure the interoperability between ESM and CJS, modules from those libraries have to be loaded via namespace import
 * And sanitized by the function below because unlike ESM namespace, CJS namespace set `module.exports` object on the `default` key
 * https://nodejs.org/api/esm.html#interoperability-with-commonjs
 */ const $697901644f774aa4$export$fa356a32a7b5bee2 = (namespaceModule)=>{
    const sanitizedNamespaceModule = {
        default: undefined,
        ...namespaceModule
    };
    return sanitizedNamespaceModule.default ?? sanitizedNamespaceModule;
};
/**
 * Checks if `value` is an Object (non-primitive, non-array, non-function)
 * Will return false for Arrays and functions
 *
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is an object, `false` otherwise
 */ function $697901644f774aa4$export$a6cdc56e425d0d0a(value) {
    return value != null && !Array.isArray(value) && typeof value === "object";
}
/**
 * Checks if `value` is a string primitive or object
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is a string, `false` otherwise
 */ function $697901644f774aa4$export$844ec244b1367d54(value) {
    return typeof value === "string" || typeof value === "object" && Object.prototype.toString.call(value) === "[object String]";
}
/**
 * Checks if `value` is a Map
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is a Map, `false` otherwise
 */ function $697901644f774aa4$export$5c90113a285f2241(value) {
    return $697901644f774aa4$export$a6cdc56e425d0d0a(value) && Object.prototype.toString.call(value) === "[object Map]";
}
/**
 * Checks if `value` is a Set
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is a Set, `false` otherwise
 */ function $697901644f774aa4$export$6750766a7c7ec627(value) {
    return $697901644f774aa4$export$a6cdc56e425d0d0a(value) && Object.prototype.toString.call(value) === "[object Set]";
}
/**
 * Checks if `value` is undefined
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is undefined, `false` otherwise
 */ function $697901644f774aa4$export$fce6876652108ab(value) {
    return value === undefined;
}
/**
 * Checks if `value` is nullish
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is nullish, `false` otherwise
 */ function $697901644f774aa4$export$984f70f9382f5d27(value) {
    return value == null;
}
/**
 * Checks if `value` is empty
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is empty, `false` otherwise
 */ function $697901644f774aa4$export$dd1bc94b04021eeb(value) {
    if (value === null || value === undefined) return true;
    if ($697901644f774aa4$export$a6cdc56e425d0d0a(value) && ($697901644f774aa4$export$5c90113a285f2241(value) || $697901644f774aa4$export$6750766a7c7ec627(value))) return !value.size;
    if ($697901644f774aa4$export$a6cdc56e425d0d0a(value) && ($697901644f774aa4$export$844ec244b1367d54(value) || Array.isArray(value))) return !value.length;
    for(const key in value){
        if ($697901644f774aa4$export$a4f4bb6b1453fff5(value, key)) return false;
    }
    return true;
}
/**
 * Checks if `value` is an empty array
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is a empty, `false` otherwise
 */ function $697901644f774aa4$var$isEmptyArray(value) {
    return Array.isArray(value) && $697901644f774aa4$export$dd1bc94b04021eeb(value);
}
/**
 * Checks if all members of the `values` param are empty arrays
 *
 * @param {unknown} value The values to check
 * @returns {boolean} Returns `true` if all members of `values` are empty, `false` otherwise
 */ function $697901644f774aa4$export$2c02be4a78959098(...values) {
    return values.every($697901644f774aa4$var$isEmptyArray);
}
/**
 * Checks if `value` is an empty object
 *
 * @param {unknown} value The value to check
 * @returns {boolean} Returns `true` if `value` is empty, `false` otherwise
 */ function $697901644f774aa4$export$83b788b1a3698c03(value) {
    return $697901644f774aa4$export$a6cdc56e425d0d0a(value) && $697901644f774aa4$export$dd1bc94b04021eeb(value);
}
/**
 * Checks if all members of the `values` param are empty objects
 *
 * @param {unknown} values The values to check
 * @returns {boolean} Returns `true` if all members of the `values` param are empty, `false` otherwise
 */ function $697901644f774aa4$export$d6708a3543c32fe4(...values) {
    return values.every($697901644f774aa4$export$83b788b1a3698c03);
}
/**
 * Capitalizes `value` and its return type
 *
 * @param {string} value string to capitalize
 * @returns {string} capitalized string
 */ function $697901644f774aa4$export$9a00dee1beb8f576(value) {
    return $697901644f774aa4$export$844ec244b1367d54(value) ? value.charAt(0).toUpperCase() + value.slice(1) : "";
}
/**
 * Checks if `key` is a direct property of `value`
 *
 * @param {unknown} value `object` potentially containing property
 * @param {string} key property key
 * @returns whether `key` param is a property of the `obj` param
 */ function $697901644f774aa4$export$a4f4bb6b1453fff5(value, key) {
    return value != null && Object.prototype.hasOwnProperty.call(value, key);
}
/**
 * Checks if `value` is a function
 *
 * @param {unknown} value param to check
 * @returns {boolean} whether `value` is a function
 */ function $697901644f774aa4$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
/**
 * This helper function creates modifier class names that are used for our flat BEM styling
 * it takes in a base and modifier and returns the modified class if a modifier was passed in and null otherwise
 * @param base The base class of the output
 * @param modifier The modifier to add onto the base
 * @returns the modified class name or empty string
 */ const $697901644f774aa4$export$1d6fb99b5e148be8 = (base, modifier)=>{
    return modifier ? `${base}--${modifier}` : "";
};
/**
 * This helper function creates modified class names that are used for our flat BEM styling
 * it takes in a base, modifier, and flag and returns the modified class name if the flag is true and null if the flag is false
 * @param base
 * @param modifier
 * @param flag
 * @returns the modified class name or empty string
 */ const $697901644f774aa4$export$3c152e7b97c7496c = (base, modifier, flag)=>{
    return flag ? `${base}--${modifier}` : "";
};
/**
 * `isFunction` but types the param with its function signature
 *
 * @param {unknown} value param to check
 * @returns {boolean} whether `value` is a function
 */ function $697901644f774aa4$export$669248cdfeac1c30(value) {
    return $697901644f774aa4$export$f6e2535fb5126e54(value);
}
/**
 * Similar to `Array.join`, with an optional callback/template param
 * for formatting returned string values
 *
 * @param {string[]} values string array
 * @param {(value: string) => string} template callback format param
 * @returns formatted string array
 */ function $697901644f774aa4$export$41f379f522580228(values, template) {
    return values.reduce((acc, curr)=>`${acc}${$697901644f774aa4$export$844ec244b1367d54(curr) ? template(curr) : ""}`, "");
}
/**
 * A function that does nothing
 *
 * @param {any[]} _ accepts any parameters
 * @returns nothing
 */ function $697901644f774aa4$export$8793edee2d425525(..._) {
    return;
}
/**
 * @param {string} groupName name of group
 * @param events string values related to group
 */ function $697901644f774aa4$export$c35e244fdf72907e(groupName, ...events) {
    const hasEvents = !!events?.length;
    if (hasEvents) {
        // eslint-disable-next-line no-console
        console.groupCollapsed(groupName);
        events?.forEach((event)=>{
            // eslint-disable-next-line no-console
            console.log(event);
        });
        // eslint-disable-next-line no-console
        console.groupEnd();
    } else // eslint-disable-next-line no-console
    console.log(groupName);
}



var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");
var $967c055100ba8eae$var$index = (0, $1T1QG.useLayoutEffect);
var $967c055100ba8eae$export$2e2bcd8739ae039 = $967c055100ba8eae$var$index;


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $4cf25e58c00f7601$export$18ce0697a983be9b = function() {
    $4cf25e58c00f7601$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4cf25e58c00f7601$export$18ce0697a983be9b.apply(this, arguments);
};
function $4cf25e58c00f7601$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4cf25e58c00f7601$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4cf25e58c00f7601$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4cf25e58c00f7601$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}


var $38650ffb13df1a95$export$1385d81a6c6bbcd4;
(function(ActionTypes) {
    ActionTypes["Start"] = "xstate.start";
    ActionTypes["Stop"] = "xstate.stop";
    ActionTypes["Raise"] = "xstate.raise";
    ActionTypes["Send"] = "xstate.send";
    ActionTypes["Cancel"] = "xstate.cancel";
    ActionTypes["NullEvent"] = "";
    ActionTypes["Assign"] = "xstate.assign";
    ActionTypes["After"] = "xstate.after";
    ActionTypes["DoneState"] = "done.state";
    ActionTypes["DoneInvoke"] = "done.invoke";
    ActionTypes["Log"] = "xstate.log";
    ActionTypes["Init"] = "xstate.init";
    ActionTypes["Invoke"] = "xstate.invoke";
    ActionTypes["ErrorExecution"] = "error.execution";
    ActionTypes["ErrorCommunication"] = "error.communication";
    ActionTypes["ErrorPlatform"] = "error.platform";
    ActionTypes["ErrorCustom"] = "xstate.error";
    ActionTypes["Update"] = "xstate.update";
    ActionTypes["Pure"] = "xstate.pure";
    ActionTypes["Choose"] = "xstate.choose";
})($38650ffb13df1a95$export$1385d81a6c6bbcd4 || ($38650ffb13df1a95$export$1385d81a6c6bbcd4 = {}));
var $38650ffb13df1a95$export$79f5baa747fbdd45;
(function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
})($38650ffb13df1a95$export$79f5baa747fbdd45 || ($38650ffb13df1a95$export$79f5baa747fbdd45 = {}));



var $b33947b250ecf0ef$export$b060f3cec92ef5c9 = ".";
var $b33947b250ecf0ef$export$505a390a702f4a23 = {};
var $b33947b250ecf0ef$export$656461011b562379 = "xstate.guard";
var $b33947b250ecf0ef$export$31935b4577455331 = "";




var $201d8d6869df8176$exports = {};

$parcel$export($201d8d6869df8176$exports, "start", function () { return $201d8d6869df8176$export$b3571188c770cc5a; });
$parcel$export($201d8d6869df8176$exports, "stop", function () { return $201d8d6869df8176$export$fa6813432f753b0d; });
$parcel$export($201d8d6869df8176$exports, "raise", function () { return $201d8d6869df8176$export$66313c302b2ea154; });
$parcel$export($201d8d6869df8176$exports, "send", function () { return $201d8d6869df8176$export$89db4734f6c919c4; });
$parcel$export($201d8d6869df8176$exports, "cancel", function () { return $201d8d6869df8176$export$70b61ad426ddbe54; });
$parcel$export($201d8d6869df8176$exports, "nullEvent", function () { return $201d8d6869df8176$export$9477ceca5dcd796a; });
$parcel$export($201d8d6869df8176$exports, "assign", function () { return $201d8d6869df8176$export$e6e34fd1f2686227; });
$parcel$export($201d8d6869df8176$exports, "after", function () { return $201d8d6869df8176$export$742acabee3dd6465; });
$parcel$export($201d8d6869df8176$exports, "doneState", function () { return $201d8d6869df8176$export$de2557b5933c9ac6; });
$parcel$export($201d8d6869df8176$exports, "log", function () { return $201d8d6869df8176$export$bef1f36f5486a6a3; });
$parcel$export($201d8d6869df8176$exports, "init", function () { return $201d8d6869df8176$export$2cd8252107eb640b; });
$parcel$export($201d8d6869df8176$exports, "invoke", function () { return $201d8d6869df8176$export$468cda29b159ee5d; });
$parcel$export($201d8d6869df8176$exports, "errorExecution", function () { return $201d8d6869df8176$export$aca059ee6fbf94e8; });
$parcel$export($201d8d6869df8176$exports, "errorPlatform", function () { return $201d8d6869df8176$export$503a23d0e5cd1226; });
$parcel$export($201d8d6869df8176$exports, "error", function () { return $201d8d6869df8176$export$a3bc9b8ed74fc; });
$parcel$export($201d8d6869df8176$exports, "update", function () { return $201d8d6869df8176$export$722fbec263ad908a; });
$parcel$export($201d8d6869df8176$exports, "choose", function () { return $201d8d6869df8176$export$7877a478dd30fd3d; });
$parcel$export($201d8d6869df8176$exports, "pure", function () { return $201d8d6869df8176$export$48ec4a2b1cfc6557; });

var $201d8d6869df8176$export$b3571188c770cc5a = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Start;
var $201d8d6869df8176$export$fa6813432f753b0d = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Stop;
var $201d8d6869df8176$export$66313c302b2ea154 = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Raise;
var $201d8d6869df8176$export$89db4734f6c919c4 = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Send;
var $201d8d6869df8176$export$70b61ad426ddbe54 = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Cancel;
var $201d8d6869df8176$export$9477ceca5dcd796a = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).NullEvent;
var $201d8d6869df8176$export$e6e34fd1f2686227 = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Assign;
var $201d8d6869df8176$export$742acabee3dd6465 = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).After;
var $201d8d6869df8176$export$de2557b5933c9ac6 = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).DoneState;
var $201d8d6869df8176$export$bef1f36f5486a6a3 = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Log;
var $201d8d6869df8176$export$2cd8252107eb640b = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Init;
var $201d8d6869df8176$export$468cda29b159ee5d = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Invoke;
var $201d8d6869df8176$export$aca059ee6fbf94e8 = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).ErrorExecution;
var $201d8d6869df8176$export$503a23d0e5cd1226 = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).ErrorPlatform;
var $201d8d6869df8176$export$a3bc9b8ed74fc = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).ErrorCustom;
var $201d8d6869df8176$export$722fbec263ad908a = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Update;
var $201d8d6869df8176$export$7877a478dd30fd3d = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Choose;
var $201d8d6869df8176$export$48ec4a2b1cfc6557 = (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Pure;



var $60fd28bf0891da6e$export$9b5f2e1c20ef6571 = true;


var $bfc72234dd195a09$var$_a;
function $bfc72234dd195a09$export$ed97f33186d4b816(value) {
    return Object.keys(value);
}
function $bfc72234dd195a09$export$2870710bf0eac88e(parentStateId, childStateId, delimiter) {
    if (delimiter === void 0) delimiter = (0, $b33947b250ecf0ef$export$b060f3cec92ef5c9);
    var parentStateValue = $bfc72234dd195a09$export$fb3aecd1d93744e3(parentStateId, delimiter);
    var childStateValue = $bfc72234dd195a09$export$fb3aecd1d93744e3(childStateId, delimiter);
    if ($bfc72234dd195a09$export$844ec244b1367d54(childStateValue)) {
        if ($bfc72234dd195a09$export$844ec244b1367d54(parentStateValue)) return childStateValue === parentStateValue;
         // Parent more specific than child
        return false;
    }
    if ($bfc72234dd195a09$export$844ec244b1367d54(parentStateValue)) return parentStateValue in childStateValue;
    return Object.keys(parentStateValue).every(function(key) {
        if (!(key in childStateValue)) return false;
        return $bfc72234dd195a09$export$2870710bf0eac88e(parentStateValue[key], childStateValue[key]);
    });
}
function $bfc72234dd195a09$export$7193fc8c8cd445e9(event) {
    try {
        return $bfc72234dd195a09$export$844ec244b1367d54(event) || typeof event === "number" ? "".concat(event) : event.type;
    } catch (e) {
        throw new Error("Events must be strings or objects with a string event.type property.");
    }
}
function $bfc72234dd195a09$export$e303144c5506946a(action) {
    try {
        return $bfc72234dd195a09$export$844ec244b1367d54(action) || typeof action === "number" ? "".concat(action) : $bfc72234dd195a09$export$f6e2535fb5126e54(action) ? action.name : action.type;
    } catch (e) {
        throw new Error("Actions must be strings or objects with a string action.type property.");
    }
}
function $bfc72234dd195a09$export$304cde62ecda7af8(stateId, delimiter) {
    try {
        if ($bfc72234dd195a09$export$43bee75e5e14138e(stateId)) return stateId;
        return stateId.toString().split(delimiter);
    } catch (e) {
        throw new Error("'".concat(stateId, "' is not a valid state path."));
    }
}
function $bfc72234dd195a09$export$e080e3931a079c9b(state) {
    return typeof state === "object" && "value" in state && "context" in state && "event" in state && "_event" in state;
}
function $bfc72234dd195a09$export$fb3aecd1d93744e3(stateValue, delimiter) {
    if ($bfc72234dd195a09$export$e080e3931a079c9b(stateValue)) return stateValue.value;
    if ($bfc72234dd195a09$export$43bee75e5e14138e(stateValue)) return $bfc72234dd195a09$export$f2ee84fc53c45e74(stateValue);
    if (typeof stateValue !== "string") return stateValue;
    var statePath = $bfc72234dd195a09$export$304cde62ecda7af8(stateValue, delimiter);
    return $bfc72234dd195a09$export$f2ee84fc53c45e74(statePath);
}
function $bfc72234dd195a09$export$f2ee84fc53c45e74(statePath) {
    if (statePath.length === 1) return statePath[0];
    var value = {};
    var marker = value;
    for(var i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        marker[statePath[i]] = {};
        marker = marker[statePath[i]];
    }
    return value;
}
function $bfc72234dd195a09$export$825e789796ab7275(collection, iteratee) {
    var result = {};
    var collectionKeys = Object.keys(collection);
    for(var i = 0; i < collectionKeys.length; i++){
        var key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $bfc72234dd195a09$export$2d4204fe9b34204e(collection, iteratee, predicate) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var item = collection[key];
            if (!predicate(item)) continue;
            result[key] = iteratee(item, key, collection);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
}
/**
 * Retrieves a value at the given path.
 * @param props The deep path to the prop of the desired value
 */ var $bfc72234dd195a09$export$bb654e07daaf8c3a = function(props) {
    return function(object) {
        var e_2, _a;
        var result = object;
        try {
            for(var props_1 = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                var prop = props_1_1.value;
                result = result[prop];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return result;
    };
};
/**
 * Retrieves a value at the given path via the nested accessor prop.
 * @param props The deep path to the prop of the desired value
 */ function $bfc72234dd195a09$export$314d0a1a7c835392(props, accessorProp) {
    return function(object) {
        var e_3, _a;
        var result = object;
        try {
            for(var props_2 = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()){
                var prop = props_2_1.value;
                result = result[accessorProp][prop];
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return result;
    };
}
function $bfc72234dd195a09$export$a2618e9e89698dd6(stateValue) {
    if (!stateValue) return [
        []
    ];
    if ($bfc72234dd195a09$export$844ec244b1367d54(stateValue)) return [
        [
            stateValue
        ]
    ];
    var result = $bfc72234dd195a09$export$bffa455ba8c619a6(Object.keys(stateValue).map(function(key) {
        var subStateValue = stateValue[key];
        if (typeof subStateValue !== "string" && (!subStateValue || !Object.keys(subStateValue).length)) return [
            [
                key
            ]
        ];
        return $bfc72234dd195a09$export$a2618e9e89698dd6(stateValue[key]).map(function(subPath) {
            return [
                key
            ].concat(subPath);
        });
    }));
    return result;
}
function $bfc72234dd195a09$export$c9d3abe59e55cae0(paths) {
    var e_4, _a;
    var result = {};
    if (paths && paths.length === 1 && paths[0].length === 1) return paths[0][0];
    try {
        for(var paths_1 = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
            var currentPath = paths_1_1.value;
            var marker = result; // tslint:disable-next-line:prefer-for-of
            for(var i = 0; i < currentPath.length; i++){
                var subPath = currentPath[i];
                if (i === currentPath.length - 2) {
                    marker[subPath] = currentPath[i + 1];
                    break;
                }
                marker[subPath] = marker[subPath] || {};
                marker = marker[subPath];
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return result;
}
function $bfc72234dd195a09$export$bffa455ba8c619a6(array) {
    var _a;
    return (_a = []).concat.apply(_a, (0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)(array), false));
}
function $bfc72234dd195a09$export$2c0b6b2f4faf21e1(value) {
    if ($bfc72234dd195a09$export$43bee75e5e14138e(value)) return value;
    return [
        value
    ];
}
function $bfc72234dd195a09$export$45b10814cc054894(value) {
    if (value === undefined) return [];
    return $bfc72234dd195a09$export$2c0b6b2f4faf21e1(value);
}
function $bfc72234dd195a09$export$e756e60189cc2351(mapper, context, _event) {
    var e_5, _a;
    if ($bfc72234dd195a09$export$f6e2535fb5126e54(mapper)) return mapper(context, _event.data);
    var result = {};
    try {
        for(var _b = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var subMapper = mapper[key];
            if ($bfc72234dd195a09$export$f6e2535fb5126e54(subMapper)) result[key] = subMapper(context, _event.data);
            else result[key] = subMapper;
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return result;
}
function $bfc72234dd195a09$export$479b1b8942fd0b8d(eventType) {
    return /^(done|error)\./.test(eventType);
}
function $bfc72234dd195a09$export$ae936b9d47e5870e(value) {
    if (value instanceof Promise) return true;
     // Check if shape matches the Promise/A+ specification for a "thenable".
    if (value !== null && ($bfc72234dd195a09$export$f6e2535fb5126e54(value) || typeof value === "object") && $bfc72234dd195a09$export$f6e2535fb5126e54(value.then)) return true;
    return false;
}
function $bfc72234dd195a09$export$42749ebe1e7fdef7(value) {
    return value !== null && typeof value === "object" && "transition" in value && typeof value.transition === "function";
}
function $bfc72234dd195a09$export$b29f828819edca8d(items, predicate) {
    var e_6, _a;
    var _b = (0, $4cf25e58c00f7601$export$8d051b38c9118094)([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_6_1) {
        e_6 = {
            error: e_6_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_6) throw e_6.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function $bfc72234dd195a09$export$3737909a0074eb1(hist, stateValue) {
    return $bfc72234dd195a09$export$825e789796ab7275(hist.states, function(subHist, key) {
        if (!subHist) return undefined;
        var subStateValue = ($bfc72234dd195a09$export$844ec244b1367d54(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);
        if (!subStateValue) return undefined;
        return {
            current: subStateValue,
            states: $bfc72234dd195a09$export$3737909a0074eb1(subHist, subStateValue)
        };
    });
}
function $bfc72234dd195a09$export$240d7cdd99ccb95a(hist, stateValue) {
    return {
        current: stateValue,
        states: $bfc72234dd195a09$export$3737909a0074eb1(hist, stateValue)
    };
}
function $bfc72234dd195a09$export$d84706064a6e6c1c(context, _event, assignActions, state) {
    if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) $bfc72234dd195a09$export$c106dd0671a0fc2d(!!context, "Attempting to update undefined context");
    var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
        var e_7, _a;
        var assignment = assignAction.assignment;
        var meta = {
            state: state,
            action: assignAction,
            _event: _event
        };
        var partialUpdate = {};
        if ($bfc72234dd195a09$export$f6e2535fb5126e54(assignment)) partialUpdate = assignment(acc, _event.data, meta);
        else try {
            for(var _b = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                var propAssignment = assignment[key];
                partialUpdate[key] = $bfc72234dd195a09$export$f6e2535fb5126e54(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return Object.assign({}, acc, partialUpdate);
    }, context) : context;
    return updatedContext;
} // tslint:disable-next-line:no-empty
var $bfc72234dd195a09$export$c106dd0671a0fc2d = function() {};
if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) $bfc72234dd195a09$export$c106dd0671a0fc2d = function(condition, message) {
    var error = condition instanceof Error ? condition : undefined;
    if (!error && condition) return;
    if (console !== undefined) {
        var args = [
            "Warning: ".concat(message)
        ];
        if (error) args.push(error);
         // tslint:disable-next-line:no-console
        console.warn.apply(console, args);
    }
};
function $bfc72234dd195a09$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
} // tslint:disable-next-line:ban-types
function $bfc72234dd195a09$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $bfc72234dd195a09$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
function $bfc72234dd195a09$export$b0f5a08e0ca47933(condition, guardMap) {
    if (!condition) return undefined;
    if ($bfc72234dd195a09$export$844ec244b1367d54(condition)) return {
        type: (0, $b33947b250ecf0ef$export$656461011b562379),
        name: condition,
        predicate: guardMap ? guardMap[condition] : undefined
    };
    if ($bfc72234dd195a09$export$f6e2535fb5126e54(condition)) return {
        type: (0, $b33947b250ecf0ef$export$656461011b562379),
        name: condition.name,
        predicate: condition
    };
    return condition;
}
function $bfc72234dd195a09$export$5cd057a6046189f9(value) {
    try {
        return "subscribe" in value && $bfc72234dd195a09$export$f6e2535fb5126e54(value.subscribe);
    } catch (e) {
        return false;
    }
}
var $bfc72234dd195a09$export$c45ebe72e3b2885 = /*#__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}(); // TODO: to be removed in v5, left it out just to minimize the scope of the change and maintain compatibility with older versions of integration paackages
var $bfc72234dd195a09$export$a6273dafbee7f61e = ($bfc72234dd195a09$var$_a = {}, $bfc72234dd195a09$var$_a[$bfc72234dd195a09$export$c45ebe72e3b2885] = function() {
    return this;
}, $bfc72234dd195a09$var$_a[Symbol.observable] = function() {
    return this;
}, $bfc72234dd195a09$var$_a);
function $bfc72234dd195a09$export$2163e7903738b5df(value) {
    return !!value && "__xstatenode" in value;
}
function $bfc72234dd195a09$export$e769f6913f14f1b7(value) {
    return !!value && typeof value.send === "function";
}
var $bfc72234dd195a09$export$8b15d37bc3f197d4 = /*#__PURE__*/ function() {
    var currentId = 0;
    return function() {
        currentId++;
        return currentId.toString(16);
    };
}();
function $bfc72234dd195a09$export$5a4ea50826a01d14(event, payload // id?: TEvent['type']
) {
    if ($bfc72234dd195a09$export$844ec244b1367d54(event) || typeof event === "number") return (0, $4cf25e58c00f7601$export$18ce0697a983be9b)({
        type: event
    }, payload);
    return event;
}
function $bfc72234dd195a09$export$eaf22249b410f633(event, scxmlEvent) {
    if (!$bfc72234dd195a09$export$844ec244b1367d54(event) && "$$type" in event && event.$$type === "scxml") return event;
    var eventObject = $bfc72234dd195a09$export$5a4ea50826a01d14(event);
    return (0, $4cf25e58c00f7601$export$18ce0697a983be9b)({
        name: eventObject.type,
        data: eventObject,
        $$type: "scxml",
        type: "external"
    }, scxmlEvent);
}
function $bfc72234dd195a09$export$3822a36ea084a4d5(event, configLike) {
    var transitions = $bfc72234dd195a09$export$2c0b6b2f4faf21e1(configLike).map(function(transitionLike) {
        if (typeof transitionLike === "undefined" || typeof transitionLike === "string" || $bfc72234dd195a09$export$2163e7903738b5df(transitionLike)) return {
            target: transitionLike,
            event: event
        };
        return (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, transitionLike), {
            event: event
        });
    });
    return transitions;
}
function $bfc72234dd195a09$export$2a4fe5c3c80e3288(target) {
    if (target === undefined || target === (0, $b33947b250ecf0ef$export$31935b4577455331)) return undefined;
    return $bfc72234dd195a09$export$45b10814cc054894(target);
}
function $bfc72234dd195a09$export$b240b9b7a78b5f3e(originalError, currentError, id) {
    if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) {
        var originalStackTrace = originalError.stack ? " Stacktrace was '".concat(originalError.stack, "'") : "";
        if (originalError === currentError) // tslint:disable-next-line:no-console
        console.error("Missing onError handler for invocation '".concat(id, "', error was '").concat(originalError, "'.").concat(originalStackTrace));
        else {
            var stackTrace = currentError.stack ? " Stacktrace was '".concat(currentError.stack, "'") : ""; // tslint:disable-next-line:no-console
            console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(id, "'. ") + "Original error: '".concat(originalError, "'. ").concat(originalStackTrace, " Current error is '").concat(currentError, "'.").concat(stackTrace));
        }
    }
}
function $bfc72234dd195a09$export$91646ab912d254e8(machine, guard, context, _event, state) {
    var guards = machine.options.guards;
    var guardMeta = {
        state: state,
        cond: guard,
        _event: _event
    }; // TODO: do not hardcode!
    if (guard.type === (0, $b33947b250ecf0ef$export$656461011b562379)) return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
    var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];
    if (!condFn) throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
    return condFn(context, _event.data, guardMeta);
}
function $bfc72234dd195a09$export$436e852aa2feda95(src) {
    if (typeof src === "string") return {
        type: src
    };
    return src;
}
function $bfc72234dd195a09$export$75b67481063f2f98(nextHandler, errorHandler, completionHandler) {
    var noop = function() {};
    var isObserver = typeof nextHandler === "object";
    var self = isObserver ? nextHandler : null;
    return {
        next: ((isObserver ? nextHandler.next : nextHandler) || noop).bind(self),
        error: ((isObserver ? nextHandler.error : errorHandler) || noop).bind(self),
        complete: ((isObserver ? nextHandler.complete : completionHandler) || noop).bind(self)
    };
}
function $bfc72234dd195a09$export$107b54c5097f9157(stateNodeId, index) {
    return "".concat(stateNodeId, ":invocation[").concat(index, "]");
}
function $bfc72234dd195a09$export$37dc2eda56cb25a5(action) {
    return (action.type === (0, $201d8d6869df8176$export$66313c302b2ea154) || action.type === (0, $201d8d6869df8176$export$89db4734f6c919c4) && action.to === (0, $38650ffb13df1a95$export$79f5baa747fbdd45).Internal) && typeof action.delay !== "number";
}




var $8ab3728758ad7bb1$export$335db82b86111fd1 = function(stateNode) {
    return stateNode.type === "atomic" || stateNode.type === "final";
};
function $8ab3728758ad7bb1$export$ad3d2e38d4deaf6d(stateNode) {
    return Object.keys(stateNode.states).map(function(key) {
        return stateNode.states[key];
    });
}
function $8ab3728758ad7bb1$export$f8cf48ee793b41be(stateNode) {
    return $8ab3728758ad7bb1$export$ad3d2e38d4deaf6d(stateNode).filter(function(sn) {
        return sn.type !== "history";
    });
}
function $8ab3728758ad7bb1$export$3de19bba299e3801(stateNode) {
    var stateNodes = [
        stateNode
    ];
    if ($8ab3728758ad7bb1$export$335db82b86111fd1(stateNode)) return stateNodes;
    return stateNodes.concat((0, $bfc72234dd195a09$export$bffa455ba8c619a6)($8ab3728758ad7bb1$export$f8cf48ee793b41be(stateNode).map($8ab3728758ad7bb1$export$3de19bba299e3801)));
}
function $8ab3728758ad7bb1$export$3de01744a82b21a4(prevStateNodes, stateNodes) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    var prevConfiguration = new Set(prevStateNodes);
    var prevAdjList = $8ab3728758ad7bb1$export$b837d8c2d0189d63(prevConfiguration);
    var configuration = new Set(stateNodes);
    try {
        // add all ancestors
        for(var configuration_1 = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()){
            var s = configuration_1_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (configuration_1_1 && !configuration_1_1.done && (_a = configuration_1.return)) _a.call(configuration_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    var adjList = $8ab3728758ad7bb1$export$b837d8c2d0189d63(configuration);
    try {
        // add descendants
        for(var configuration_2 = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()){
            var s = configuration_2_1.value; // if previously active, add existing child nodes
            if (s.type === "compound" && (!adjList.get(s) || !adjList.get(s).length)) {
                if (prevAdjList.get(s)) prevAdjList.get(s).forEach(function(sn) {
                    return configuration.add(sn);
                });
                else s.initialStateNodes.forEach(function(sn) {
                    return configuration.add(sn);
                });
            } else {
                if (s.type === "parallel") try {
                    for(var _e = (e_3 = void 0, (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)($8ab3728758ad7bb1$export$f8cf48ee793b41be(s))), _f = _e.next(); !_f.done; _f = _e.next()){
                        var child = _f.value;
                        if (!configuration.has(child)) {
                            configuration.add(child);
                            if (prevAdjList.get(child)) prevAdjList.get(child).forEach(function(sn) {
                                return configuration.add(sn);
                            });
                            else child.initialStateNodes.forEach(function(sn) {
                                return configuration.add(sn);
                            });
                        }
                    }
                } catch (e_3_1) {
                    e_3 = {
                        error: e_3_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                }
            }
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return)) _b.call(configuration_2);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    try {
        // add all ancestors
        for(var configuration_3 = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()){
            var s = configuration_3_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return)) _d.call(configuration_3);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return configuration;
}
function $8ab3728758ad7bb1$var$getValueFromAdj(baseNode, adjList) {
    var childStateNodes = adjList.get(baseNode);
    if (!childStateNodes) return {}; // todo: fix?
    if (baseNode.type === "compound") {
        var childStateNode = childStateNodes[0];
        if (childStateNode) {
            if ($8ab3728758ad7bb1$export$335db82b86111fd1(childStateNode)) return childStateNode.key;
        } else return {};
    }
    var stateValue = {};
    childStateNodes.forEach(function(csn) {
        stateValue[csn.key] = $8ab3728758ad7bb1$var$getValueFromAdj(csn, adjList);
    });
    return stateValue;
}
function $8ab3728758ad7bb1$export$b837d8c2d0189d63(configuration) {
    var e_5, _a;
    var adjList = new Map();
    try {
        for(var configuration_4 = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()){
            var s = configuration_4_1.value;
            if (!adjList.has(s)) adjList.set(s, []);
            if (s.parent) {
                if (!adjList.has(s.parent)) adjList.set(s.parent, []);
                adjList.get(s.parent).push(s);
            }
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (configuration_4_1 && !configuration_4_1.done && (_a = configuration_4.return)) _a.call(configuration_4);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return adjList;
}
function $8ab3728758ad7bb1$export$bf7199a9ebcb84a9(rootNode, configuration) {
    var config = $8ab3728758ad7bb1$export$3de01744a82b21a4([
        rootNode
    ], configuration);
    return $8ab3728758ad7bb1$var$getValueFromAdj(rootNode, $8ab3728758ad7bb1$export$b837d8c2d0189d63(config));
}
function $8ab3728758ad7bb1$export$a4f4bb6b1453fff5(iterable, item) {
    if (Array.isArray(iterable)) return iterable.some(function(member) {
        return member === item;
    });
    if (iterable instanceof Set) return iterable.has(item);
    return false; // TODO: fix
}
function $8ab3728758ad7bb1$export$c661ab6895e3ed73(configuration) {
    return (0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)(new Set((0, $bfc72234dd195a09$export$bffa455ba8c619a6)((0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)(configuration.map(function(sn) {
        return sn.ownEvents;
    })), false)))), false);
}
function $8ab3728758ad7bb1$export$cf3d5dae927fcf63(configuration, stateNode) {
    if (stateNode.type === "compound") return $8ab3728758ad7bb1$export$f8cf48ee793b41be(stateNode).some(function(s) {
        return s.type === "final" && $8ab3728758ad7bb1$export$a4f4bb6b1453fff5(configuration, s);
    });
    if (stateNode.type === "parallel") return $8ab3728758ad7bb1$export$f8cf48ee793b41be(stateNode).every(function(sn) {
        return $8ab3728758ad7bb1$export$cf3d5dae927fcf63(configuration, sn);
    });
    return false;
}
function $8ab3728758ad7bb1$export$c47913ca32a5c6f7(configuration) {
    if (configuration === void 0) configuration = [];
    return configuration.reduce(function(acc, stateNode) {
        if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
        return acc;
    }, {});
}
function $8ab3728758ad7bb1$export$5301196121335ca0(configuration) {
    return new Set((0, $bfc72234dd195a09$export$bffa455ba8c619a6)(configuration.map(function(sn) {
        return sn.tags;
    })));
}


var $f9b2d12db4f71f3e$exports = {};

$parcel$export($f9b2d12db4f71f3e$exports, "initEvent", function () { return $f9b2d12db4f71f3e$export$163c566c60ed2ec9; });
$parcel$export($f9b2d12db4f71f3e$exports, "getActionFunction", function () { return $f9b2d12db4f71f3e$export$c7e5ca927bd4567; });
$parcel$export($f9b2d12db4f71f3e$exports, "toActionObject", function () { return $f9b2d12db4f71f3e$export$b38b66cc2da3ede7; });
$parcel$export($f9b2d12db4f71f3e$exports, "toActionObjects", function () { return $f9b2d12db4f71f3e$export$aa68691f32e6c459; });
$parcel$export($f9b2d12db4f71f3e$exports, "toActivityDefinition", function () { return $f9b2d12db4f71f3e$export$e81fdd8937d44864; });
$parcel$export($f9b2d12db4f71f3e$exports, "raise", function () { return $f9b2d12db4f71f3e$export$66313c302b2ea154; });
$parcel$export($f9b2d12db4f71f3e$exports, "resolveRaise", function () { return $f9b2d12db4f71f3e$export$ed3daf8e935ede01; });
$parcel$export($f9b2d12db4f71f3e$exports, "send", function () { return $f9b2d12db4f71f3e$export$89db4734f6c919c4; });
$parcel$export($f9b2d12db4f71f3e$exports, "resolveSend", function () { return $f9b2d12db4f71f3e$export$f43e8cbb721d72d5; });
$parcel$export($f9b2d12db4f71f3e$exports, "sendParent", function () { return $f9b2d12db4f71f3e$export$408d8d51fa351f53; });
$parcel$export($f9b2d12db4f71f3e$exports, "sendTo", function () { return $f9b2d12db4f71f3e$export$daa976aaff721e41; });
$parcel$export($f9b2d12db4f71f3e$exports, "sendUpdate", function () { return $f9b2d12db4f71f3e$export$7f8b724299523eb6; });
$parcel$export($f9b2d12db4f71f3e$exports, "respond", function () { return $f9b2d12db4f71f3e$export$72b816ae90496f19; });
$parcel$export($f9b2d12db4f71f3e$exports, "log", function () { return $f9b2d12db4f71f3e$export$bef1f36f5486a6a3; });
$parcel$export($f9b2d12db4f71f3e$exports, "resolveLog", function () { return $f9b2d12db4f71f3e$export$12cba28d36be4946; });
$parcel$export($f9b2d12db4f71f3e$exports, "cancel", function () { return $f9b2d12db4f71f3e$export$70b61ad426ddbe54; });
$parcel$export($f9b2d12db4f71f3e$exports, "start", function () { return $f9b2d12db4f71f3e$export$b3571188c770cc5a; });
$parcel$export($f9b2d12db4f71f3e$exports, "stop", function () { return $f9b2d12db4f71f3e$export$fa6813432f753b0d; });
$parcel$export($f9b2d12db4f71f3e$exports, "resolveStop", function () { return $f9b2d12db4f71f3e$export$21aa461f4eb8e82; });
$parcel$export($f9b2d12db4f71f3e$exports, "assign", function () { return $f9b2d12db4f71f3e$export$e6e34fd1f2686227; });
$parcel$export($f9b2d12db4f71f3e$exports, "isActionObject", function () { return $f9b2d12db4f71f3e$export$6e816592f80fc079; });
$parcel$export($f9b2d12db4f71f3e$exports, "after", function () { return $f9b2d12db4f71f3e$export$742acabee3dd6465; });
$parcel$export($f9b2d12db4f71f3e$exports, "done", function () { return $f9b2d12db4f71f3e$export$3df11c9c20e7b288; });
$parcel$export($f9b2d12db4f71f3e$exports, "doneInvoke", function () { return $f9b2d12db4f71f3e$export$c105e588793f70b4; });
$parcel$export($f9b2d12db4f71f3e$exports, "error", function () { return $f9b2d12db4f71f3e$export$a3bc9b8ed74fc; });
$parcel$export($f9b2d12db4f71f3e$exports, "pure", function () { return $f9b2d12db4f71f3e$export$48ec4a2b1cfc6557; });
$parcel$export($f9b2d12db4f71f3e$exports, "forwardTo", function () { return $f9b2d12db4f71f3e$export$eb147b7589db8e8a; });
$parcel$export($f9b2d12db4f71f3e$exports, "escalate", function () { return $f9b2d12db4f71f3e$export$f514678a4137c4d6; });
$parcel$export($f9b2d12db4f71f3e$exports, "choose", function () { return $f9b2d12db4f71f3e$export$7877a478dd30fd3d; });
$parcel$export($f9b2d12db4f71f3e$exports, "resolveActions", function () { return $f9b2d12db4f71f3e$export$b8b9e7ba5b8c7b3e; });
$parcel$export($f9b2d12db4f71f3e$exports, "actionTypes", function () { return $201d8d6869df8176$exports; });





var $f9b2d12db4f71f3e$export$163c566c60ed2ec9 = /*#__PURE__*/ (0, $bfc72234dd195a09$export$eaf22249b410f633)({
    type: (0, $201d8d6869df8176$export$2cd8252107eb640b)
});
function $f9b2d12db4f71f3e$export$c7e5ca927bd4567(actionType, actionFunctionMap) {
    return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
}
function $f9b2d12db4f71f3e$export$b38b66cc2da3ede7(action, actionFunctionMap) {
    var actionObject;
    if ((0, $bfc72234dd195a09$export$844ec244b1367d54)(action) || typeof action === "number") {
        var exec = $f9b2d12db4f71f3e$export$c7e5ca927bd4567(action, actionFunctionMap);
        if ((0, $bfc72234dd195a09$export$f6e2535fb5126e54)(exec)) actionObject = {
            type: action,
            exec: exec
        };
        else if (exec) actionObject = exec;
        else actionObject = {
            type: action,
            exec: undefined
        };
    } else if ((0, $bfc72234dd195a09$export$f6e2535fb5126e54)(action)) actionObject = {
        // Convert action to string if unnamed
        type: action.name || action.toString(),
        exec: action
    };
    else {
        var exec = $f9b2d12db4f71f3e$export$c7e5ca927bd4567(action.type, actionFunctionMap);
        if ((0, $bfc72234dd195a09$export$f6e2535fb5126e54)(exec)) actionObject = (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, action), {
            exec: exec
        });
        else if (exec) {
            var actionType = exec.type || action.type;
            actionObject = (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, exec), action), {
                type: actionType
            });
        } else actionObject = action;
    }
    return actionObject;
}
var $f9b2d12db4f71f3e$export$aa68691f32e6c459 = function(action, actionFunctionMap) {
    if (!action) return [];
    var actions = (0, $bfc72234dd195a09$export$43bee75e5e14138e)(action) ? action : [
        action
    ];
    return actions.map(function(subAction) {
        return $f9b2d12db4f71f3e$export$b38b66cc2da3ede7(subAction, actionFunctionMap);
    });
};
function $f9b2d12db4f71f3e$export$e81fdd8937d44864(action) {
    var actionObject = $f9b2d12db4f71f3e$export$b38b66cc2da3ede7(action);
    return (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({
        id: (0, $bfc72234dd195a09$export$844ec244b1367d54)(action) ? action : actionObject.id
    }, actionObject), {
        type: actionObject.type
    });
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $f9b2d12db4f71f3e$export$66313c302b2ea154(event, options) {
    return {
        type: (0, $201d8d6869df8176$export$66313c302b2ea154),
        event: typeof event === "function" ? event : (0, $bfc72234dd195a09$export$5a4ea50826a01d14)(event),
        delay: options ? options.delay : undefined,
        id: options === null || options === void 0 ? void 0 : options.id
    };
}
function $f9b2d12db4f71f3e$export$ed3daf8e935ede01(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    };
    var resolvedEvent = (0, $bfc72234dd195a09$export$eaf22249b410f633)((0, $bfc72234dd195a09$export$f6e2535fb5126e54)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, $bfc72234dd195a09$export$844ec244b1367d54)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, $bfc72234dd195a09$export$f6e2535fb5126e54)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, $bfc72234dd195a09$export$f6e2535fb5126e54)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    return (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, action), {
        type: (0, $201d8d6869df8176$export$66313c302b2ea154),
        _event: resolvedEvent,
        delay: resolvedDelay
    });
}
/**
 * Sends an event. This returns an action that will be read by an interpreter to
 * send the event in the next step, after the current step is finished executing.
 *
 * @deprecated Use the `sendTo(...)` action creator instead.
 *
 * @param event The event to send.
 * @param options Options to pass into the send event:
 *  - `id` - The unique send event identifier (used with `cancel()`).
 *  - `delay` - The number of milliseconds to delay the sending of the event.
 *  - `to` - The target of this event (by default, the machine the event was sent from).
 */ function $f9b2d12db4f71f3e$export$89db4734f6c919c4(event, options) {
    return {
        to: options ? options.to : undefined,
        type: (0, $201d8d6869df8176$export$89db4734f6c919c4),
        event: (0, $bfc72234dd195a09$export$f6e2535fb5126e54)(event) ? event : (0, $bfc72234dd195a09$export$5a4ea50826a01d14)(event),
        delay: options ? options.delay : undefined,
        // TODO: don't auto-generate IDs here like that
        // there is too big chance of the ID collision
        id: options && options.id !== undefined ? options.id : (0, $bfc72234dd195a09$export$f6e2535fb5126e54)(event) ? event.name : (0, $bfc72234dd195a09$export$7193fc8c8cd445e9)(event)
    };
}
function $f9b2d12db4f71f3e$export$f43e8cbb721d72d5(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    }; // TODO: helper function for resolving Expr
    var resolvedEvent = (0, $bfc72234dd195a09$export$eaf22249b410f633)((0, $bfc72234dd195a09$export$f6e2535fb5126e54)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, $bfc72234dd195a09$export$844ec244b1367d54)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, $bfc72234dd195a09$export$f6e2535fb5126e54)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, $bfc72234dd195a09$export$f6e2535fb5126e54)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    var resolvedTarget = (0, $bfc72234dd195a09$export$f6e2535fb5126e54)(action.to) ? action.to(ctx, _event.data, meta) : action.to;
    return (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, action), {
        to: resolvedTarget,
        _event: resolvedEvent,
        event: resolvedEvent.data,
        delay: resolvedDelay
    });
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $f9b2d12db4f71f3e$export$408d8d51fa351f53(event, options) {
    return $f9b2d12db4f71f3e$export$89db4734f6c919c4(event, (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, options), {
        to: (0, $38650ffb13df1a95$export$79f5baa747fbdd45).Parent
    }));
}
/**
 * Sends an event to an actor.
 *
 * @param actor The `ActorRef` to send the event to.
 * @param event The event to send, or an expression that evaluates to the event to send
 * @param options Send action options
 * @returns An XState send action object
 */ function $f9b2d12db4f71f3e$export$daa976aaff721e41(actor, event, options) {
    return $f9b2d12db4f71f3e$export$89db4734f6c919c4(event, (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, options), {
        to: actor
    }));
}
/**
 * Sends an update event to this machine's parent.
 */ function $f9b2d12db4f71f3e$export$7f8b724299523eb6() {
    return $f9b2d12db4f71f3e$export$408d8d51fa351f53((0, $201d8d6869df8176$export$722fbec263ad908a));
}
/**
 * Sends an event back to the sender of the original event.
 *
 * @param event The event to send back to the sender
 * @param options Options to pass into the send event
 */ function $f9b2d12db4f71f3e$export$72b816ae90496f19(event, options) {
    return $f9b2d12db4f71f3e$export$89db4734f6c919c4(event, (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, options), {
        to: function(_, __, _a) {
            var _event = _a._event;
            return _event.origin; // TODO: handle when _event.origin is undefined
        }
    }));
}
var $f9b2d12db4f71f3e$var$defaultLogExpr = function(context, event) {
    return {
        context: context,
        event: event
    };
};
/**
 *
 * @param expr The expression function to evaluate which will be logged.
 *  Takes in 2 arguments:
 *  - `ctx` - the current state context
 *  - `event` - the event that caused this action to be executed.
 * @param label The label to give to the logged expression.
 */ function $f9b2d12db4f71f3e$export$bef1f36f5486a6a3(expr, label) {
    if (expr === void 0) expr = $f9b2d12db4f71f3e$var$defaultLogExpr;
    return {
        type: (0, $201d8d6869df8176$export$bef1f36f5486a6a3),
        label: label,
        expr: expr
    };
}
var $f9b2d12db4f71f3e$export$12cba28d36be4946 = function(action, ctx, _event) {
    return (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, action), {
        value: (0, $bfc72234dd195a09$export$844ec244b1367d54)(action.expr) ? action.expr : action.expr(ctx, _event.data, {
            _event: _event
        })
    });
};
/**
 * Cancels an in-flight `send(...)` action. A canceled sent action will not
 * be executed, nor will its event be sent, unless it has already been sent
 * (e.g., if `cancel(...)` is called after the `send(...)` action's `delay`).
 *
 * @param sendId The `id` of the `send(...)` action to cancel.
 */ var $f9b2d12db4f71f3e$export$70b61ad426ddbe54 = function(sendId) {
    return {
        type: (0, $201d8d6869df8176$export$70b61ad426ddbe54),
        sendId: sendId
    };
};
/**
 * Starts an activity.
 *
 * @param activity The activity to start.
 */ function $f9b2d12db4f71f3e$export$b3571188c770cc5a(activity) {
    var activityDef = $f9b2d12db4f71f3e$export$e81fdd8937d44864(activity);
    return {
        type: (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Start,
        activity: activityDef,
        exec: undefined
    };
}
/**
 * Stops an activity.
 *
 * @param actorRef The activity to stop.
 */ function $f9b2d12db4f71f3e$export$fa6813432f753b0d(actorRef) {
    var activity = (0, $bfc72234dd195a09$export$f6e2535fb5126e54)(actorRef) ? actorRef : $f9b2d12db4f71f3e$export$e81fdd8937d44864(actorRef);
    return {
        type: (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Stop,
        activity: activity,
        exec: undefined
    };
}
function $f9b2d12db4f71f3e$export$21aa461f4eb8e82(action, context, _event) {
    var actorRefOrString = (0, $bfc72234dd195a09$export$f6e2535fb5126e54)(action.activity) ? action.activity(context, _event.data) : action.activity;
    var resolvedActorRef = typeof actorRefOrString === "string" ? {
        id: actorRefOrString
    } : actorRefOrString;
    var actionObject = {
        type: (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Stop,
        activity: resolvedActorRef
    };
    return actionObject;
}
/**
 * Updates the current context of the machine.
 *
 * @param assignment An object that represents the partial context to update.
 */ var $f9b2d12db4f71f3e$export$e6e34fd1f2686227 = function(assignment) {
    return {
        type: (0, $201d8d6869df8176$export$e6e34fd1f2686227),
        assignment: assignment
    };
};
function $f9b2d12db4f71f3e$export$6e816592f80fc079(action) {
    return typeof action === "object" && "type" in action;
}
/**
 * Returns an event type that represents an implicit event that
 * is sent after the specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $f9b2d12db4f71f3e$export$742acabee3dd6465(delayRef, id) {
    var idSuffix = id ? "#".concat(id) : "";
    return "".concat((0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).After, "(").concat(delayRef, ")").concat(idSuffix);
}
/**
 * Returns an event that represents that a final state node
 * has been reached in the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param data The data to pass into the event
 */ function $f9b2d12db4f71f3e$export$3df11c9c20e7b288(id, data) {
    var type = "".concat((0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).DoneState, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state node,
 * but not when it is canceled.
 *
 * @param id The final state node ID
 * @param data The data to pass into the event
 */ function $f9b2d12db4f71f3e$export$c105e588793f70b4(id, data) {
    var type = "".concat((0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).DoneInvoke, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $f9b2d12db4f71f3e$export$a3bc9b8ed74fc(id, data) {
    var type = "".concat((0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).ErrorPlatform, ".").concat(id);
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $f9b2d12db4f71f3e$export$48ec4a2b1cfc6557(getActions) {
    return {
        type: (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Pure,
        get: getActions
    };
}
/**
 * Forwards (sends) an event to a specified service.
 *
 * @param target The target service to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $f9b2d12db4f71f3e$export$eb147b7589db8e8a(target, options) {
    if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571) && (!target || typeof target === "function")) {
        var originalTarget_1 = target;
        target = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var resolvedTarget = typeof originalTarget_1 === "function" ? originalTarget_1.apply(void 0, (0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)(args), false)) : originalTarget_1;
            if (!resolvedTarget) throw new Error("Attempted to forward event to undefined actor. This risks an infinite loop in the sender.");
            return resolvedTarget;
        };
    }
    return $f9b2d12db4f71f3e$export$89db4734f6c919c4(function(_, event) {
        return event;
    }, (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, options), {
        to: target
    }));
}
/**
 * Escalates an error by sending it as an event to this machine's parent.
 *
 * @param errorData The error data to send, or the expression function that
 * takes in the `context`, `event`, and `meta`, and returns the error data to send.
 * @param options Options to pass into the send action creator.
 */ function $f9b2d12db4f71f3e$export$f514678a4137c4d6(errorData, options) {
    return $f9b2d12db4f71f3e$export$408d8d51fa351f53(function(context, event, meta) {
        return {
            type: (0, $201d8d6869df8176$export$a3bc9b8ed74fc),
            data: (0, $bfc72234dd195a09$export$f6e2535fb5126e54)(errorData) ? errorData(context, event, meta) : errorData
        };
    }, (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, options), {
        to: (0, $38650ffb13df1a95$export$79f5baa747fbdd45).Parent
    }));
}
function $f9b2d12db4f71f3e$export$7877a478dd30fd3d(conds) {
    return {
        type: (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Choose,
        conds: conds
    };
}
var $f9b2d12db4f71f3e$var$pluckAssigns = function(actionBlocks) {
    var e_1, _a;
    var assignActions = [];
    try {
        for(var actionBlocks_1 = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
            var block = actionBlocks_1_1.value;
            var i = 0;
            while(i < block.actions.length){
                if (block.actions[i].type === (0, $201d8d6869df8176$export$e6e34fd1f2686227)) {
                    assignActions.push(block.actions[i]);
                    block.actions.splice(i, 1);
                    continue;
                }
                i++;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return assignActions;
};
function $f9b2d12db4f71f3e$export$b8b9e7ba5b8c7b3e(machine, currentState, currentContext, _event, actionBlocks, predictableExec, preserveActionOrder) {
    if (preserveActionOrder === void 0) preserveActionOrder = false;
    var assignActions = preserveActionOrder ? [] : $f9b2d12db4f71f3e$var$pluckAssigns(actionBlocks);
    var updatedContext = assignActions.length ? (0, $bfc72234dd195a09$export$d84706064a6e6c1c)(currentContext, _event, assignActions, currentState) : currentContext;
    var preservedContexts = preserveActionOrder ? [
        currentContext
    ] : undefined;
    var deferredToBlockEnd = [];
    function handleAction(blockType, actionObject) {
        var _a;
        switch(actionObject.type){
            case 0, $201d8d6869df8176$export$66313c302b2ea154:
                var raisedAction = $f9b2d12db4f71f3e$export$ed3daf8e935ede01(actionObject, updatedContext, _event, machine.options.delays);
                if (predictableExec && typeof raisedAction.delay === "number") predictableExec(raisedAction, updatedContext, _event);
                return raisedAction;
            case 0, $201d8d6869df8176$export$89db4734f6c919c4:
                var sendAction = $f9b2d12db4f71f3e$export$f43e8cbb721d72d5(actionObject, updatedContext, _event, machine.options.delays); // TODO: fix ActionTypes.Init
                if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) {
                    var configuredDelay = actionObject.delay; // warn after resolving as we can create better contextual message here
                    (0, $bfc72234dd195a09$export$c106dd0671a0fc2d)(!(0, $bfc72234dd195a09$export$844ec244b1367d54)(configuredDelay) || typeof sendAction.delay === "number", "No delay reference for delay expression '".concat(configuredDelay, "' was found on machine '").concat(machine.id, "'"));
                }
                if (predictableExec && sendAction.to !== (0, $38650ffb13df1a95$export$79f5baa747fbdd45).Internal) {
                    if (blockType === "entry") deferredToBlockEnd.push(sendAction);
                    else predictableExec(sendAction, updatedContext, _event);
                }
                return sendAction;
            case 0, $201d8d6869df8176$export$bef1f36f5486a6a3:
                var resolved = $f9b2d12db4f71f3e$export$12cba28d36be4946(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, updatedContext, _event);
                return resolved;
            case 0, $201d8d6869df8176$export$7877a478dd30fd3d:
                var chooseAction = actionObject;
                var matchedActions = (_a = chooseAction.conds.find(function(condition) {
                    var guard = (0, $bfc72234dd195a09$export$b0f5a08e0ca47933)(condition.cond, machine.options.guards);
                    return !guard || (0, $bfc72234dd195a09$export$91646ab912d254e8)(machine, guard, updatedContext, _event, !predictableExec ? currentState : undefined);
                })) === null || _a === void 0 ? void 0 : _a.actions;
                if (!matchedActions) return [];
                var _b = (0, $4cf25e58c00f7601$export$8d051b38c9118094)($f9b2d12db4f71f3e$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $f9b2d12db4f71f3e$export$aa68691f32e6c459((0, $bfc72234dd195a09$export$45b10814cc054894)(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromChoose = _b[0], resolvedContextFromChoose = _b[1];
                updatedContext = resolvedContextFromChoose;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromChoose;
            case 0, $201d8d6869df8176$export$48ec4a2b1cfc6557:
                var matchedActions = actionObject.get(updatedContext, _event.data);
                if (!matchedActions) return [];
                var _c = (0, $4cf25e58c00f7601$export$8d051b38c9118094)($f9b2d12db4f71f3e$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, [
                    {
                        type: blockType,
                        actions: $f9b2d12db4f71f3e$export$aa68691f32e6c459((0, $bfc72234dd195a09$export$45b10814cc054894)(matchedActions), machine.options.actions)
                    }
                ], predictableExec, preserveActionOrder), 2), resolvedActionsFromPure = _c[0], resolvedContext = _c[1];
                updatedContext = resolvedContext;
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                return resolvedActionsFromPure;
            case 0, $201d8d6869df8176$export$fa6813432f753b0d:
                var resolved = $f9b2d12db4f71f3e$export$21aa461f4eb8e82(actionObject, updatedContext, _event);
                predictableExec === null || predictableExec === void 0 || predictableExec(resolved, currentContext, _event);
                return resolved;
            case 0, $201d8d6869df8176$export$e6e34fd1f2686227:
                updatedContext = (0, $bfc72234dd195a09$export$d84706064a6e6c1c)(updatedContext, _event, [
                    actionObject
                ], !predictableExec ? currentState : undefined);
                preservedContexts === null || preservedContexts === void 0 || preservedContexts.push(updatedContext);
                break;
            default:
                var resolvedActionObject = $f9b2d12db4f71f3e$export$b38b66cc2da3ede7(actionObject, machine.options.actions);
                var exec_1 = resolvedActionObject.exec;
                if (predictableExec) predictableExec(resolvedActionObject, updatedContext, _event);
                else if (exec_1 && preservedContexts) {
                    var contextIndex_1 = preservedContexts.length - 1;
                    var wrapped = (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, resolvedActionObject), {
                        exec: function(_ctx) {
                            var args = [];
                            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                            exec_1.apply(void 0, (0, $4cf25e58c00f7601$export$1216008129fb82ed)([
                                preservedContexts[contextIndex_1]
                            ], (0, $4cf25e58c00f7601$export$8d051b38c9118094)(args), false));
                        }
                    });
                    resolvedActionObject = wrapped;
                }
                return resolvedActionObject;
        }
    }
    function processBlock(block) {
        var e_2, _a;
        var resolvedActions = [];
        try {
            for(var _b = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(block.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                var resolved = handleAction(block.type, action);
                if (resolved) resolvedActions = resolvedActions.concat(resolved);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        deferredToBlockEnd.forEach(function(action) {
            predictableExec(action, updatedContext, _event);
        });
        deferredToBlockEnd.length = 0;
        return resolvedActions;
    }
    var resolvedActions = (0, $bfc72234dd195a09$export$bffa455ba8c619a6)(actionBlocks.map(processBlock));
    return [
        resolvedActions,
        updatedContext
    ];
}



function $9f85080534c7efcc$export$3a6d15eeb5fb214c(a, b) {
    if (a === b) return true;
    if (a === undefined || b === undefined) return false;
    if ((0, $bfc72234dd195a09$export$844ec244b1367d54)(a) || (0, $bfc72234dd195a09$export$844ec244b1367d54)(b)) return a === b;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    return aKeys.length === bKeys.length && aKeys.every(function(key) {
        return $9f85080534c7efcc$export$3a6d15eeb5fb214c(a[key], b[key]);
    });
}
function $9f85080534c7efcc$export$4c86eb6450eda77a(state) {
    if (typeof state !== "object" || state === null) return false;
    return "value" in state && "_event" in state;
}
/**
 * @deprecated Use `isStateConfig(object)` or `state instanceof State` instead.
 */ var $9f85080534c7efcc$export$e5d60a6bbabd36f = $9f85080534c7efcc$export$4c86eb6450eda77a;
function $9f85080534c7efcc$export$e42513ad58964418(action, state) {
    var exec = action.exec;
    var boundAction = (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, action), {
        exec: exec !== undefined ? function() {
            return exec(state.context, state.event, {
                action: action,
                state: state,
                _event: state._event
            });
        } : undefined
    });
    return boundAction;
}
var $9f85080534c7efcc$export$7254cc27399e90bd = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new State instance.
   * @param value The state value
   * @param context The extended state
   * @param historyValue The tree representing historical values of the state nodes
   * @param history The previous state
   * @param actions An array of action objects to execute as side-effects
   * @param activities A mapping of activities and whether they are started (`true`) or stopped (`false`).
   * @param meta
   * @param events Internal event queue. Should be empty with run-to-completion semantics.
   * @param configuration
   */ function State(config) {
        var _this = this;
        var _a;
        this.actions = [];
        this.activities = (0, $b33947b250ecf0ef$export$505a390a702f4a23);
        this.meta = {};
        this.events = [];
        this.value = config.value;
        this.context = config.context;
        this._event = config._event;
        this._sessionid = config._sessionid;
        this.event = this._event.data;
        this.historyValue = config.historyValue;
        this.history = config.history;
        this.actions = config.actions || [];
        this.activities = config.activities || (0, $b33947b250ecf0ef$export$505a390a702f4a23);
        this.meta = (0, $8ab3728758ad7bb1$export$c47913ca32a5c6f7)(config.configuration);
        this.events = config.events || [];
        this.matches = this.matches.bind(this);
        this.toStrings = this.toStrings.bind(this);
        this.configuration = config.configuration;
        this.transitions = config.transitions;
        this.children = config.children;
        this.done = !!config.done;
        this.tags = (_a = Array.isArray(config.tags) ? new Set(config.tags) : config.tags) !== null && _a !== void 0 ? _a : new Set();
        this.machine = config.machine;
        Object.defineProperty(this, "nextEvents", {
            get: function() {
                return (0, $8ab3728758ad7bb1$export$c661ab6895e3ed73)(_this.configuration);
            }
        });
    }
    /**
   * Creates a new State instance for the given `stateValue` and `context`.
   * @param stateValue
   * @param context
   */ State.from = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (stateValue.context !== context) return new State({
                value: stateValue.value,
                context: context,
                _event: stateValue._event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                actions: [],
                activities: stateValue.activities,
                meta: {},
                events: [],
                configuration: [],
                transitions: [],
                children: {}
            });
            return stateValue;
        }
        var _event = (0, $f9b2d12db4f71f3e$export$163c566c60ed2ec9);
        return new State({
            value: stateValue,
            context: context,
            _event: _event,
            _sessionid: null,
            historyValue: undefined,
            history: undefined,
            actions: [],
            activities: undefined,
            meta: undefined,
            events: [],
            configuration: [],
            transitions: [],
            children: {}
        });
    };
    /**
   * Creates a new State instance for the given `config`.
   * @param config The state config
   */ State.create = function(config) {
        return new State(config);
    };
    /**
   * Creates a new `State` instance for the given `stateValue` and `context` with no actions (side-effects).
   * @param stateValue
   * @param context
   */ State.inert = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (!stateValue.actions.length) return stateValue;
            var _event = (0, $f9b2d12db4f71f3e$export$163c566c60ed2ec9);
            return new State({
                value: stateValue.value,
                context: context,
                _event: _event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                activities: stateValue.activities,
                configuration: stateValue.configuration,
                transitions: [],
                children: {}
            });
        }
        return State.from(stateValue, context);
    };
    /**
   * Returns an array of all the string leaf state node paths.
   * @param stateValue
   * @param delimiter The character(s) that separate each subpath in the string state node path.
   */ State.prototype.toStrings = function(stateValue, delimiter) {
        var _this = this;
        if (stateValue === void 0) stateValue = this.value;
        if (delimiter === void 0) delimiter = ".";
        if ((0, $bfc72234dd195a09$export$844ec244b1367d54)(stateValue)) return [
            stateValue
        ];
        var valueKeys = Object.keys(stateValue);
        return valueKeys.concat.apply(valueKeys, (0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)(valueKeys.map(function(key) {
            return _this.toStrings(stateValue[key], delimiter).map(function(s) {
                return key + delimiter + s;
            });
        })), false));
    };
    State.prototype.toJSON = function() {
        var _a = this;
        _a.configuration;
        _a.transitions;
        var tags = _a.tags;
        _a.machine;
        var jsonValues = (0, $4cf25e58c00f7601$export$3c9a16f847548506)(_a, [
            "configuration",
            "transitions",
            "tags",
            "machine"
        ]);
        return (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, jsonValues), {
            tags: Array.from(tags)
        });
    };
    State.prototype.matches = function(parentStateValue) {
        return (0, $bfc72234dd195a09$export$2870710bf0eac88e)(parentStateValue, this.value);
    };
    /**
   * Whether the current state configuration has a state node with the specified `tag`.
   * @param tag
   */ State.prototype.hasTag = function(tag) {
        return this.tags.has(tag);
    };
    /**
   * Determines whether sending the `event` will cause a non-forbidden transition
   * to be selected, even if the transitions have no actions nor
   * change the state value.
   *
   * @param event The event to test
   * @returns Whether the event will cause a transition
   */ State.prototype.can = function(event) {
        var _a;
        if (0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571) (0, $bfc72234dd195a09$export$c106dd0671a0fc2d)(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
        var transitionData = (_a = this.machine) === null || _a === void 0 ? void 0 : _a.getTransitionData(this, event);
        return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.transitions.length) && // Check that at least one transition is not forbidden
        transitionData.transitions.some(function(t) {
            return t.target !== undefined || t.actions.length;
        });
    };
    return State;
}();







var $0b9a6b5033262ff9$var$defaultOptions = {
    deferEvents: false
};
var $0b9a6b5033262ff9$export$d3e54bb8584cda7c = /*#__PURE__*/ /** @class */ function() {
    function Scheduler(options) {
        this.processingEvent = false;
        this.queue = [];
        this.initialized = false;
        this.options = (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, $0b9a6b5033262ff9$var$defaultOptions), options);
    }
    Scheduler.prototype.initialize = function(callback) {
        this.initialized = true;
        if (callback) {
            if (!this.options.deferEvents) {
                this.schedule(callback);
                return;
            }
            this.process(callback);
        }
        this.flushEvents();
    };
    Scheduler.prototype.schedule = function(task) {
        if (!this.initialized || this.processingEvent) {
            this.queue.push(task);
            return;
        }
        if (this.queue.length !== 0) throw new Error("Event queue should be empty when it is not processing events");
        this.process(task);
        this.flushEvents();
    };
    Scheduler.prototype.clear = function() {
        this.queue = [];
    };
    Scheduler.prototype.flushEvents = function() {
        var nextCallback = this.queue.shift();
        while(nextCallback){
            this.process(nextCallback);
            nextCallback = this.queue.shift();
        }
    };
    Scheduler.prototype.process = function(callback) {
        this.processingEvent = true;
        try {
            callback();
        } catch (e) {
            // there is no use to keep the future events
            // as the situation is not anymore the same
            this.clear();
            throw e;
        } finally{
            this.processingEvent = false;
        }
    };
    return Scheduler;
}();




/**
 * Maintains a stack of the current service in scope.
 * This is used to provide the correct service to spawn().
 */ var $5d9d4f30877509a6$var$serviceStack = [];
var $5d9d4f30877509a6$export$abe1e183e22e10ad = function(service, fn) {
    $5d9d4f30877509a6$var$serviceStack.push(service);
    var result = fn(service);
    $5d9d4f30877509a6$var$serviceStack.pop();
    return result;
};
var $5d9d4f30877509a6$export$e11e6a155c5c4d9d = function(fn) {
    return fn($5d9d4f30877509a6$var$serviceStack[$5d9d4f30877509a6$var$serviceStack.length - 1]);
};


function $57d5321825fc99ce$export$8998449b468dcdad(id) {
    var _a;
    return _a = {
        id: id,
        send: function() {
            return void 0;
        },
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        getSnapshot: function() {
            return undefined;
        },
        toJSON: function() {
            return {
                id: id
            };
        }
    }, _a[0, $bfc72234dd195a09$export$c45ebe72e3b2885] = function() {
        return this;
    }, _a;
}
/**
 * Creates a deferred actor that is able to be invoked given the provided
 * invocation information in its `.meta` value.
 *
 * @param invokeDefinition The meta information needed to invoke the actor.
 */ function $57d5321825fc99ce$export$78b4a98dcb5ac328(invokeDefinition, machine, context, _event) {
    var _a;
    var invokeSrc = (0, $bfc72234dd195a09$export$436e852aa2feda95)(invokeDefinition.src);
    var serviceCreator = (_a = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a === void 0 ? void 0 : _a[invokeSrc.type];
    var resolvedData = invokeDefinition.data ? (0, $bfc72234dd195a09$export$e756e60189cc2351)(invokeDefinition.data, context, _event) : undefined;
    var tempActor = serviceCreator ? $57d5321825fc99ce$export$59bcb51d8e40ed48(serviceCreator, invokeDefinition.id, resolvedData) : $57d5321825fc99ce$export$8998449b468dcdad(invokeDefinition.id); // @ts-ignore
    tempActor.meta = invokeDefinition;
    return tempActor;
}
function $57d5321825fc99ce$export$59bcb51d8e40ed48(entity, id, data) {
    var tempActor = $57d5321825fc99ce$export$8998449b468dcdad(id); // @ts-ignore
    tempActor.deferred = true;
    if ((0, $bfc72234dd195a09$export$2163e7903738b5df)(entity)) {
        // "mute" the existing service scope so potential spawned actors within the `.initialState` stay deferred here
        var initialState_1 = tempActor.state = (0, $5d9d4f30877509a6$export$abe1e183e22e10ad)(undefined, function() {
            return (data ? entity.withContext(data) : entity).initialState;
        });
        tempActor.getSnapshot = function() {
            return initialState_1;
        };
    }
    return tempActor;
}
function $57d5321825fc99ce$export$e769f6913f14f1b7(item) {
    try {
        return typeof item.send === "function";
    } catch (e) {
        return false;
    }
}
function $57d5321825fc99ce$export$b0f989039dc164f9(item) {
    return $57d5321825fc99ce$export$e769f6913f14f1b7(item) && "id" in item;
} // TODO: refactor the return type, this could be written in a better way but it's best to avoid unneccessary breaking changes now
function $57d5321825fc99ce$export$ccadea5f6b9e9b4e(actorRefLike) {
    var _a;
    return (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((_a = {
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        id: "anonymous",
        getSnapshot: function() {
            return undefined;
        }
    }, _a[0, $bfc72234dd195a09$export$c45ebe72e3b2885] = function() {
        return this;
    }, _a), actorRefLike);
}


var $6d0e299a33740e58$var$children = /*#__PURE__*/ new Map();
var $6d0e299a33740e58$var$sessionIdIndex = 0;
var $6d0e299a33740e58$export$4bb7493d241fd8a5 = {
    bookId: function() {
        return "x:".concat($6d0e299a33740e58$var$sessionIdIndex++);
    },
    register: function(id, actor) {
        $6d0e299a33740e58$var$children.set(id, actor);
        return id;
    },
    get: function(id) {
        return $6d0e299a33740e58$var$children.get(id);
    },
    free: function(id) {
        $6d0e299a33740e58$var$children.delete(id);
    }
};



function $f5ac6fd54f392c5a$export$a4e55266d2135a7f() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) console.warn("XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues");
}
function $f5ac6fd54f392c5a$var$getDevTools() {
    var global1 = $f5ac6fd54f392c5a$export$a4e55266d2135a7f();
    if (global1 && "__xstate__" in global1) return global1.__xstate__;
    return undefined;
}
function $f5ac6fd54f392c5a$export$4d7a7d14704ebc13(service) {
    if (!$f5ac6fd54f392c5a$export$a4e55266d2135a7f()) return;
    var devTools = $f5ac6fd54f392c5a$var$getDevTools();
    if (devTools) devTools.register(service);
}






/**
 * Returns an actor behavior from a reducer and its initial state.
 *
 * @param transition The pure reducer that returns the next state given the current state and event.
 * @param initialState The initial state of the reducer.
 * @returns An actor behavior
 */ function $5d2fdb9150a7e5ed$export$fe581ffd4962847b(transition, initialState) {
    return {
        transition: transition,
        initialState: initialState
    };
}
function $5d2fdb9150a7e5ed$export$60f45028237c39d1(promiseFn) {
    var initialState = {
        error: undefined,
        data: undefined,
        status: "pending"
    };
    return {
        transition: function(state, event, _a) {
            var parent = _a.parent, id = _a.id, observers = _a.observers;
            switch(event.type){
                case "fulfill":
                    parent === null || parent === void 0 || parent.send((0, $f9b2d12db4f71f3e$export$c105e588793f70b4)(id, event.data));
                    return {
                        error: undefined,
                        data: event.data,
                        status: "fulfilled"
                    };
                case "reject":
                    parent === null || parent === void 0 || parent.send((0, $f9b2d12db4f71f3e$export$a3bc9b8ed74fc)(id, event.error));
                    observers.forEach(function(observer) {
                        observer.error(event.error);
                    });
                    return {
                        error: event.error,
                        data: undefined,
                        status: "rejected"
                    };
                default:
                    return state;
            }
        },
        initialState: initialState,
        start: function(_a) {
            var self = _a.self;
            promiseFn().then(function(data) {
                self.send({
                    type: "fulfill",
                    data: data
                });
            }, function(reason) {
                self.send({
                    type: "reject",
                    error: reason
                });
            });
            return initialState;
        }
    };
}
function $5d2fdb9150a7e5ed$export$cc3859917b3feaf8(behavior, options) {
    if (options === void 0) options = {};
    var state = behavior.initialState;
    var observers = new Set();
    var mailbox = [];
    var flushing = false;
    var flush = function() {
        if (flushing) return;
        flushing = true;
        while(mailbox.length > 0){
            var event_1 = mailbox.shift();
            state = behavior.transition(state, event_1, actorCtx);
            observers.forEach(function(observer) {
                return observer.next(state);
            });
        }
        flushing = false;
    };
    var actor = (0, $57d5321825fc99ce$export$ccadea5f6b9e9b4e)({
        id: options.id,
        send: function(event) {
            mailbox.push(event);
            flush();
        },
        getSnapshot: function() {
            return state;
        },
        subscribe: function(next, handleError, complete) {
            var observer = (0, $bfc72234dd195a09$export$75b67481063f2f98)(next, handleError, complete);
            observers.add(observer);
            observer.next(state);
            return {
                unsubscribe: function() {
                    observers.delete(observer);
                }
            };
        }
    });
    var actorCtx = {
        parent: options.parent,
        self: actor,
        id: options.id || "anonymous",
        observers: observers
    };
    state = behavior.start ? behavior.start(actorCtx) : state;
    return actor;
}


var $0a71063706b576da$var$DEFAULT_SPAWN_OPTIONS = {
    sync: false,
    autoForward: false
};
var $0a71063706b576da$export$7a567c9c5088a551;
(function(InterpreterStatus) {
    InterpreterStatus[InterpreterStatus["NotStarted"] = 0] = "NotStarted";
    InterpreterStatus[InterpreterStatus["Running"] = 1] = "Running";
    InterpreterStatus[InterpreterStatus["Stopped"] = 2] = "Stopped";
})($0a71063706b576da$export$7a567c9c5088a551 || ($0a71063706b576da$export$7a567c9c5088a551 = {}));
var $0a71063706b576da$export$e5b52c46a548ff03 = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new Interpreter instance (i.e., service) for the given machine with the provided options, if any.
   *
   * @param machine The machine to be interpreted
   * @param options Interpreter options
   */ function Interpreter(machine, options) {
        if (options === void 0) options = Interpreter.defaultOptions;
        var _this = this;
        this.machine = machine;
        this.delayedEventsMap = {};
        this.listeners = new Set();
        this.contextListeners = new Set();
        this.stopListeners = new Set();
        this.doneListeners = new Set();
        this.eventListeners = new Set();
        this.sendListeners = new Set();
        /**
     * Whether the service is started.
     */ this.initialized = false;
        this.status = $0a71063706b576da$export$7a567c9c5088a551.NotStarted;
        this.children = new Map();
        this.forwardTo = new Set();
        this._outgoingQueue = [];
        /**
     * Alias for Interpreter.prototype.start
     */ this.init = this.start;
        /**
     * Sends an event to the running interpreter to trigger a transition.
     *
     * An array of events (batched) can be sent as well, which will send all
     * batched events to the running interpreter. The listeners will be
     * notified only **once** when all events are processed.
     *
     * @param event The event(s) to send
     */ this.send = function(event1, payload) {
            if ((0, $bfc72234dd195a09$export$43bee75e5e14138e)(event1)) {
                _this.batch(event1);
                return _this.state;
            }
            var _event = (0, $bfc72234dd195a09$export$eaf22249b410f633)((0, $bfc72234dd195a09$export$5a4ea50826a01d14)(event1, payload));
            if (_this.status === $0a71063706b576da$export$7a567c9c5088a551.Stopped) {
                // do nothing
                if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) (0, $bfc72234dd195a09$export$c106dd0671a0fc2d)(false, 'Event "'.concat(_event.name, '" was sent to stopped service "').concat(_this.machine.id, '". This service has already reached its final state, and will not transition.\nEvent: ').concat(JSON.stringify(_event.data)));
                return _this.state;
            }
            if (_this.status !== $0a71063706b576da$export$7a567c9c5088a551.Running && !_this.options.deferEvents) throw new Error('Event "'.concat(_event.name, '" was sent to uninitialized service "').concat(_this.machine.id // tslint:disable-next-line:max-line-length
            , '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: ').concat(JSON.stringify(_event.data)));
            _this.scheduler.schedule(function() {
                // Forward copy of event to child actors
                _this.forward(_event);
                var nextState = _this._nextState(_event);
                _this.update(nextState, _event);
            });
            return _this._state; // TODO: deprecate (should return void)
        // tslint:disable-next-line:semicolon
        };
        this.sendTo = function(event1, to, immediate) {
            var isParent = _this.parent && (to === (0, $38650ffb13df1a95$export$79f5baa747fbdd45).Parent || _this.parent.id === to);
            var target = isParent ? _this.parent : (0, $bfc72234dd195a09$export$844ec244b1367d54)(to) ? to === (0, $38650ffb13df1a95$export$79f5baa747fbdd45).Internal ? _this : _this.children.get(to) || (0, $6d0e299a33740e58$export$4bb7493d241fd8a5).get(to) : (0, $bfc72234dd195a09$export$e769f6913f14f1b7)(to) ? to : undefined;
            if (!target) {
                if (!isParent) throw new Error("Unable to send event to child '".concat(to, "' from service '").concat(_this.id, "'."));
                 // tslint:disable-next-line:no-console
                if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) (0, $bfc72234dd195a09$export$c106dd0671a0fc2d)(false, "Service '".concat(_this.id, "' has no parent: unable to send event ").concat(event1.type));
                return;
            }
            if ("machine" in target) // perhaps those events should be rejected in the parent
            // but atm it doesn't have easy access to all of the information that is required to do it reliably
            {
                if (_this.status !== $0a71063706b576da$export$7a567c9c5088a551.Stopped || _this.parent !== target || // we need to send events to the parent from exit handlers of a machine that reached its final state
                _this.state.done) {
                    // Send SCXML events to machines
                    var scxmlEvent = (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, event1), {
                        name: event1.name === (0, $201d8d6869df8176$export$a3bc9b8ed74fc) ? "".concat((0, $f9b2d12db4f71f3e$export$a3bc9b8ed74fc)(_this.id)) : event1.name,
                        origin: _this.sessionId
                    });
                    if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                        target,
                        scxmlEvent
                    ]);
                    else target.send(scxmlEvent);
                }
            } else // Send normal events to other targets
            if (!immediate && _this.machine.config.predictableActionArguments) _this._outgoingQueue.push([
                target,
                event1.data
            ]);
            else target.send(event1.data);
        };
        this._exec = function(action, context, _event, actionFunctionMap) {
            if (actionFunctionMap === void 0) actionFunctionMap = _this.machine.options.actions;
            var actionOrExec = action.exec || (0, $f9b2d12db4f71f3e$export$c7e5ca927bd4567)(action.type, actionFunctionMap);
            var exec = (0, $bfc72234dd195a09$export$f6e2535fb5126e54)(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;
            if (exec) try {
                return exec(context, _event.data, !_this.machine.config.predictableActionArguments ? {
                    action: action,
                    state: _this.state,
                    _event: _event
                } : {
                    action: action,
                    _event: _event
                });
            } catch (err) {
                if (_this.parent) _this.parent.send({
                    type: "xstate.error",
                    data: err
                });
                throw err;
            }
            switch(action.type){
                case 0, $201d8d6869df8176$export$66313c302b2ea154:
                    // if raise action reached the interpreter then it's a delayed one
                    var sendAction_1 = action;
                    _this.defer(sendAction_1);
                    break;
                case 0, $201d8d6869df8176$export$89db4734f6c919c4:
                    var sendAction = action;
                    if (typeof sendAction.delay === "number") {
                        _this.defer(sendAction);
                        return;
                    } else if (sendAction.to) _this.sendTo(sendAction._event, sendAction.to, _event === (0, $f9b2d12db4f71f3e$export$163c566c60ed2ec9));
                    else _this.send(sendAction._event);
                    break;
                case 0, $201d8d6869df8176$export$70b61ad426ddbe54:
                    _this.cancel(action.sendId);
                    break;
                case 0, $201d8d6869df8176$export$b3571188c770cc5a:
                    if (_this.status !== $0a71063706b576da$export$7a567c9c5088a551.Running) return;
                    var activity = action.activity; // If the activity will be stopped right after it's started
                    // (such as in transient states)
                    // don't bother starting the activity.
                    if (!_this.machine.config.predictableActionArguments && !_this.state.activities[activity.id || activity.type]) break;
                     // Invoked services
                    if (activity.type === (0, $38650ffb13df1a95$export$1385d81a6c6bbcd4).Invoke) {
                        var invokeSource = (0, $bfc72234dd195a09$export$436e852aa2feda95)(activity.src);
                        var serviceCreator = _this.machine.options.services ? _this.machine.options.services[invokeSource.type] : undefined;
                        var id = activity.id, data = activity.data;
                        if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) (0, $bfc72234dd195a09$export$c106dd0671a0fc2d)(!("forward" in activity), "`forward` property is deprecated (found in invocation of '".concat(activity.src, "' in in machine '").concat(_this.machine.id, "'). ") + "Please use `autoForward` instead.");
                        var autoForward = "autoForward" in activity ? activity.autoForward : !!activity.forward;
                        if (!serviceCreator) {
                            // tslint:disable-next-line:no-console
                            if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) (0, $bfc72234dd195a09$export$c106dd0671a0fc2d)(false, "No service found for invocation '".concat(activity.src, "' in machine '").concat(_this.machine.id, "'."));
                            return;
                        }
                        var resolvedData = data ? (0, $bfc72234dd195a09$export$e756e60189cc2351)(data, context, _event) : undefined;
                        if (typeof serviceCreator === "string") // TODO: warn
                        return;
                        var source = (0, $bfc72234dd195a09$export$f6e2535fb5126e54)(serviceCreator) ? serviceCreator(context, _event.data, {
                            data: resolvedData,
                            src: invokeSource,
                            meta: activity.meta
                        }) : serviceCreator;
                        if (!source) // TODO: warn?
                        return;
                        var options = void 0;
                        if ((0, $bfc72234dd195a09$export$2163e7903738b5df)(source)) {
                            source = resolvedData ? source.withContext(resolvedData) : source;
                            options = {
                                autoForward: autoForward
                            };
                        }
                        _this.spawn(source, id, options);
                    } else _this.spawnActivity(activity);
                    break;
                case 0, $201d8d6869df8176$export$fa6813432f753b0d:
                    _this.stopChild(action.activity.id);
                    break;
                case 0, $201d8d6869df8176$export$bef1f36f5486a6a3:
                    var _a = action, label = _a.label, value = _a.value;
                    if (label) _this.logger(label, value);
                    else _this.logger(value);
                    break;
                default:
                    if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) (0, $bfc72234dd195a09$export$c106dd0671a0fc2d)(false, "No implementation found for action type '".concat(action.type, "'"));
                    break;
            }
        };
        var resolvedOptions = (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, Interpreter.defaultOptions), options);
        var clock = resolvedOptions.clock, logger = resolvedOptions.logger, parent = resolvedOptions.parent, id = resolvedOptions.id;
        var resolvedId = id !== undefined ? id : machine.id;
        this.id = resolvedId;
        this.logger = logger;
        this.clock = clock;
        this.parent = parent;
        this.options = resolvedOptions;
        this.scheduler = new (0, $0b9a6b5033262ff9$export$d3e54bb8584cda7c)({
            deferEvents: this.options.deferEvents
        });
        this.sessionId = (0, $6d0e299a33740e58$export$4bb7493d241fd8a5).bookId();
    }
    Object.defineProperty(Interpreter.prototype, "initialState", {
        get: function() {
            var _this = this;
            if (this._initialState) return this._initialState;
            return (0, $5d9d4f30877509a6$export$abe1e183e22e10ad)(this, function() {
                _this._initialState = _this.machine.initialState;
                return _this._initialState;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Interpreter.prototype, "state", {
        /**
     * @deprecated Use `.getSnapshot()` instead.
     */ get: function() {
            if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) (0, $bfc72234dd195a09$export$c106dd0671a0fc2d)(this.status !== $0a71063706b576da$export$7a567c9c5088a551.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first."));
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Executes the actions of the given state, with that state's `context` and `event`.
   *
   * @param state The state whose actions will be executed
   * @param actionsConfig The action implementations to use
   */ Interpreter.prototype.execute = function(state, actionsConfig) {
        var e_1, _a;
        try {
            for(var _b = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(state.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                this.exec(action, state, actionsConfig);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    Interpreter.prototype.update = function(state, _event) {
        var e_2, _a, e_3, _b, e_4, _c, e_5, _d;
        var _this = this; // Attach session ID to state
        state._sessionid = this.sessionId; // Update state
        this._state = state; // Execute actions
        if ((!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
        // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
        _event === (0, $f9b2d12db4f71f3e$export$163c566c60ed2ec9)) && this.options.execute) this.execute(this.state);
        else {
            var item = void 0;
            while(item = this._outgoingQueue.shift())item[0].send(item[1]);
        } // Update children
        this.children.forEach(function(child) {
            _this.state.children[child.id] = child;
        }); // Dev tools
        if (this.devTools) this.devTools.send(_event.data, state);
         // Execute listeners
        if (state.event) try {
            for(var _e = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()){
                var listener = _f.value;
                listener(state.event);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        try {
            for(var _g = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()){
                var listener = _h.value;
                listener(state, state.event);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        try {
            for(var _j = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()){
                var contextListener = _k.value;
                contextListener(this.state.context, this.state.history ? this.state.history.context : undefined);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        if (this.state.done) {
            // get final child state node
            var finalChildStateNode = state.configuration.find(function(sn) {
                return sn.type === "final" && sn.parent === _this.machine;
            });
            var doneData = finalChildStateNode && finalChildStateNode.doneData ? (0, $bfc72234dd195a09$export$e756e60189cc2351)(finalChildStateNode.doneData, state.context, _event) : undefined;
            this._doneEvent = (0, $f9b2d12db4f71f3e$export$c105e588793f70b4)(this.id, doneData);
            try {
                for(var _l = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()){
                    var listener = _m.value;
                    listener(this._doneEvent);
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            this._stop();
            this._stopChildren();
            (0, $6d0e299a33740e58$export$4bb7493d241fd8a5).free(this.sessionId);
        }
    };
    /*
   * Adds a listener that is notified whenever a state transition happens. The listener is called with
   * the next state and the event object that caused the state transition.
   *
   * @param listener The state listener
   */ Interpreter.prototype.onTransition = function(listener) {
        this.listeners.add(listener); // Send current state to listener
        if (this.status === $0a71063706b576da$export$7a567c9c5088a551.Running) listener(this.state, this.state.event);
        return this;
    };
    Interpreter.prototype.subscribe = function(nextListenerOrObserver, _, completeListener) {
        var _this = this;
        var observer = (0, $bfc72234dd195a09$export$75b67481063f2f98)(nextListenerOrObserver, _, completeListener);
        this.listeners.add(observer.next); // Send current state to listener
        if (this.status !== $0a71063706b576da$export$7a567c9c5088a551.NotStarted) observer.next(this.state);
        var completeOnce = function() {
            _this.doneListeners.delete(completeOnce);
            _this.stopListeners.delete(completeOnce);
            observer.complete();
        };
        if (this.status === $0a71063706b576da$export$7a567c9c5088a551.Stopped) observer.complete();
        else {
            this.onDone(completeOnce);
            this.onStop(completeOnce);
        }
        return {
            unsubscribe: function() {
                _this.listeners.delete(observer.next);
                _this.doneListeners.delete(completeOnce);
                _this.stopListeners.delete(completeOnce);
            }
        };
    };
    /**
   * Adds an event listener that is notified whenever an event is sent to the running interpreter.
   * @param listener The event listener
   */ Interpreter.prototype.onEvent = function(listener) {
        this.eventListeners.add(listener);
        return this;
    };
    /**
   * Adds an event listener that is notified whenever a `send` event occurs.
   * @param listener The event listener
   */ Interpreter.prototype.onSend = function(listener) {
        this.sendListeners.add(listener);
        return this;
    };
    /**
   * Adds a context listener that is notified whenever the state context changes.
   * @param listener The context listener
   */ Interpreter.prototype.onChange = function(listener) {
        this.contextListeners.add(listener);
        return this;
    };
    /**
   * Adds a listener that is notified when the machine is stopped.
   * @param listener The listener
   */ Interpreter.prototype.onStop = function(listener) {
        this.stopListeners.add(listener);
        return this;
    };
    /**
   * Adds a state listener that is notified when the statechart has reached its final state.
   * @param listener The state listener
   */ Interpreter.prototype.onDone = function(listener) {
        if (this.status === $0a71063706b576da$export$7a567c9c5088a551.Stopped && this._doneEvent) listener(this._doneEvent);
        else this.doneListeners.add(listener);
        return this;
    };
    /**
   * Removes a listener.
   * @param listener The listener to remove
   */ Interpreter.prototype.off = function(listener) {
        this.listeners.delete(listener);
        this.eventListeners.delete(listener);
        this.sendListeners.delete(listener);
        this.stopListeners.delete(listener);
        this.doneListeners.delete(listener);
        this.contextListeners.delete(listener);
        return this;
    };
    /**
   * Starts the interpreter from the given state, or the initial state.
   * @param initialState The state to start the statechart from
   */ Interpreter.prototype.start = function(initialState) {
        var _this = this;
        if (this.status === $0a71063706b576da$export$7a567c9c5088a551.Running) // Do not restart the service if it is already started
        return this;
         // yes, it's a hack but we need the related cache to be populated for some things to work (like delayed transitions)
        // this is usually called by `machine.getInitialState` but if we rehydrate from a state we might bypass this call
        // we also don't want to call this method here as it resolves the full initial state which might involve calling assign actions
        // and that could potentially lead to some unwanted side-effects (even such as creating some rogue actors)
        this.machine._init();
        (0, $6d0e299a33740e58$export$4bb7493d241fd8a5).register(this.sessionId, this);
        this.initialized = true;
        this.status = $0a71063706b576da$export$7a567c9c5088a551.Running;
        var resolvedState = initialState === undefined ? this.initialState : (0, $5d9d4f30877509a6$export$abe1e183e22e10ad)(this, function() {
            return (0, $9f85080534c7efcc$export$4c86eb6450eda77a)(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState((0, $9f85080534c7efcc$export$7254cc27399e90bd).from(initialState, _this.machine.context));
        });
        if (this.options.devTools) this.attachDev();
        this.scheduler.initialize(function() {
            _this.update(resolvedState, (0, $f9b2d12db4f71f3e$export$163c566c60ed2ec9));
        });
        return this;
    };
    Interpreter.prototype._stopChildren = function() {
        // TODO: think about converting those to actions
        this.children.forEach(function(child) {
            if ((0, $bfc72234dd195a09$export$f6e2535fb5126e54)(child.stop)) child.stop();
        });
        this.children.clear();
    };
    Interpreter.prototype._stop = function() {
        var e_6, _a, e_7, _b, e_8, _c, e_9, _d, e_10, _e;
        try {
            for(var _f = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()){
                var listener = _g.value;
                this.listeners.delete(listener);
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        try {
            for(var _h = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()){
                var listener = _j.value; // call listener, then remove
                listener();
                this.stopListeners.delete(listener);
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        try {
            for(var _k = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()){
                var listener = _l.value;
                this.contextListeners.delete(listener);
            }
        } catch (e_8_1) {
            e_8 = {
                error: e_8_1
            };
        } finally{
            try {
                if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
            } finally{
                if (e_8) throw e_8.error;
            }
        }
        try {
            for(var _m = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()){
                var listener = _o.value;
                this.doneListeners.delete(listener);
            }
        } catch (e_9_1) {
            e_9 = {
                error: e_9_1
            };
        } finally{
            try {
                if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
            } finally{
                if (e_9) throw e_9.error;
            }
        }
        if (!this.initialized) // Interpreter already stopped; do nothing
        return this;
        this.initialized = false;
        this.status = $0a71063706b576da$export$7a567c9c5088a551.Stopped;
        this._initialState = undefined;
        try {
            // we are going to stop within the current sync frame
            // so we can safely just cancel this here as nothing async should be fired anyway
            for(var _p = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(Object.keys(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()){
                var key = _q.value;
                this.clock.clearTimeout(this.delayedEventsMap[key]);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
            } finally{
                if (e_10) throw e_10.error;
            }
        } // clear everything that might be enqueued
        this.scheduler.clear();
        this.scheduler = new (0, $0b9a6b5033262ff9$export$d3e54bb8584cda7c)({
            deferEvents: this.options.deferEvents
        });
    };
    /**
   * Stops the interpreter and unsubscribe all listeners.
   *
   * This will also notify the `onStop` listeners.
   */ Interpreter.prototype.stop = function() {
        // TODO: add warning for stopping non-root interpreters
        var _this = this; // grab the current scheduler as it will be replaced in _stop
        var scheduler = this.scheduler;
        this._stop(); // let what is currently processed to be finished
        scheduler.schedule(function() {
            var _a;
            if ((_a = _this._state) === null || _a === void 0 ? void 0 : _a.done) return;
             // it feels weird to handle this here but we need to handle this even slightly "out of band"
            var _event = (0, $bfc72234dd195a09$export$eaf22249b410f633)({
                type: "xstate.stop"
            });
            var nextState = (0, $5d9d4f30877509a6$export$abe1e183e22e10ad)(_this, function() {
                var exitActions = (0, $bfc72234dd195a09$export$bffa455ba8c619a6)((0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)(_this.state.configuration), false).sort(function(a, b) {
                    return b.order - a.order;
                }).map(function(stateNode) {
                    return (0, $f9b2d12db4f71f3e$export$aa68691f32e6c459)(stateNode.onExit, _this.machine.options.actions);
                }));
                var _a = (0, $4cf25e58c00f7601$export$8d051b38c9118094)((0, $f9b2d12db4f71f3e$export$b8b9e7ba5b8c7b3e)(_this.machine, _this.state, _this.state.context, _event, [
                    {
                        type: "exit",
                        actions: exitActions
                    }
                ], _this.machine.config.predictableActionArguments ? _this._exec : undefined, _this.machine.config.predictableActionArguments || _this.machine.config.preserveActionOrder), 2), resolvedActions = _a[0], updatedContext = _a[1];
                var newState = new (0, $9f85080534c7efcc$export$7254cc27399e90bd)({
                    value: _this.state.value,
                    context: updatedContext,
                    _event: _event,
                    _sessionid: _this.sessionId,
                    historyValue: undefined,
                    history: _this.state,
                    actions: resolvedActions.filter(function(action) {
                        return !(0, $bfc72234dd195a09$export$37dc2eda56cb25a5)(action);
                    }),
                    activities: {},
                    events: [],
                    configuration: [],
                    transitions: [],
                    children: {},
                    done: _this.state.done,
                    tags: _this.state.tags,
                    machine: _this.machine
                });
                newState.changed = true;
                return newState;
            });
            _this.update(nextState, _event);
            _this._stopChildren();
            (0, $6d0e299a33740e58$export$4bb7493d241fd8a5).free(_this.sessionId);
        });
        return this;
    };
    Interpreter.prototype.batch = function(events) {
        var _this = this;
        if (this.status === $0a71063706b576da$export$7a567c9c5088a551.NotStarted && this.options.deferEvents) // tslint:disable-next-line:no-console
        {
            if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) (0, $bfc72234dd195a09$export$c106dd0671a0fc2d)(false, "".concat(events.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '" and are deferred. Make sure .start() is called for this service.\nEvent: ').concat(JSON.stringify(event)));
        } else if (this.status !== $0a71063706b576da$export$7a567c9c5088a551.Running) throw new Error("".concat(events.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.'));
        if (!events.length) return;
        var exec = !!this.machine.config.predictableActionArguments && this._exec;
        this.scheduler.schedule(function() {
            var e_11, _a;
            var nextState = _this.state;
            var batchChanged = false;
            var batchedActions = [];
            var _loop_1 = function(event_1) {
                var _event = (0, $bfc72234dd195a09$export$eaf22249b410f633)(event_1);
                _this.forward(_event);
                nextState = (0, $5d9d4f30877509a6$export$abe1e183e22e10ad)(_this, function() {
                    return _this.machine.transition(nextState, _event, undefined, exec || undefined);
                });
                batchedActions.push.apply(batchedActions, (0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)(_this.machine.config.predictableActionArguments ? nextState.actions : nextState.actions.map(function(a) {
                    return (0, $9f85080534c7efcc$export$e42513ad58964418)(a, nextState);
                })), false));
                batchChanged = batchChanged || !!nextState.changed;
            };
            try {
                for(var events_1 = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()){
                    var event_1 = events_1_1.value;
                    _loop_1(event_1);
                }
            } catch (e_11_1) {
                e_11 = {
                    error: e_11_1
                };
            } finally{
                try {
                    if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
                } finally{
                    if (e_11) throw e_11.error;
                }
            }
            nextState.changed = batchChanged;
            nextState.actions = batchedActions;
            _this.update(nextState, (0, $bfc72234dd195a09$export$eaf22249b410f633)(events[events.length - 1]));
        });
    };
    /**
   * Returns a send function bound to this interpreter instance.
   *
   * @param event The event to be sent by the sender.
   */ Interpreter.prototype.sender = function(event1) {
        return this.send.bind(this, event1);
    };
    Interpreter.prototype._nextState = function(event1, exec) {
        var _this = this;
        if (exec === void 0) exec = !!this.machine.config.predictableActionArguments && this._exec;
        var _event = (0, $bfc72234dd195a09$export$eaf22249b410f633)(event1);
        if (_event.name.indexOf((0, $201d8d6869df8176$export$503a23d0e5cd1226)) === 0 && !this.state.nextEvents.some(function(nextEvent) {
            return nextEvent.indexOf((0, $201d8d6869df8176$export$503a23d0e5cd1226)) === 0;
        })) throw _event.data.data;
        var nextState = (0, $5d9d4f30877509a6$export$abe1e183e22e10ad)(this, function() {
            return _this.machine.transition(_this.state, _event, undefined, exec || undefined);
        });
        return nextState;
    };
    /**
   * Returns the next state given the interpreter's current state and the event.
   *
   * This is a pure method that does _not_ update the interpreter's state.
   *
   * @param event The event to determine the next state
   */ Interpreter.prototype.nextState = function(event1) {
        return this._nextState(event1, false);
    };
    Interpreter.prototype.forward = function(event1) {
        var e_12, _a;
        try {
            for(var _b = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()){
                var id = _c.value;
                var child = this.children.get(id);
                if (!child) throw new Error("Unable to forward event '".concat(event1, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(id, "'."));
                child.send(event1);
            }
        } catch (e_12_1) {
            e_12 = {
                error: e_12_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_12) throw e_12.error;
            }
        }
    };
    Interpreter.prototype.defer = function(sendAction) {
        var _this = this;
        var timerId = this.clock.setTimeout(function() {
            if ("to" in sendAction && sendAction.to) _this.sendTo(sendAction._event, sendAction.to, true);
            else _this.send(sendAction._event);
        }, sendAction.delay);
        if (sendAction.id) this.delayedEventsMap[sendAction.id] = timerId;
    };
    Interpreter.prototype.cancel = function(sendId) {
        this.clock.clearTimeout(this.delayedEventsMap[sendId]);
        delete this.delayedEventsMap[sendId];
    };
    Interpreter.prototype.exec = function(action, state, actionFunctionMap) {
        if (actionFunctionMap === void 0) actionFunctionMap = this.machine.options.actions;
        this._exec(action, state.context, state._event, actionFunctionMap);
    };
    Interpreter.prototype.removeChild = function(childId) {
        var _a;
        this.children.delete(childId);
        this.forwardTo.delete(childId); // this.state might not exist at the time this is called,
        // such as when a child is added then removed while initializing the state
        (_a = this.state) === null || _a === void 0 || delete _a.children[childId];
    };
    Interpreter.prototype.stopChild = function(childId) {
        var child = this.children.get(childId);
        if (!child) return;
        this.removeChild(childId);
        if ((0, $bfc72234dd195a09$export$f6e2535fb5126e54)(child.stop)) child.stop();
    };
    Interpreter.prototype.spawn = function(entity, name, options) {
        if (this.status !== $0a71063706b576da$export$7a567c9c5088a551.Running) return (0, $57d5321825fc99ce$export$59bcb51d8e40ed48)(entity, name);
        if ((0, $bfc72234dd195a09$export$ae936b9d47e5870e)(entity)) return this.spawnPromise(Promise.resolve(entity), name);
        else if ((0, $bfc72234dd195a09$export$f6e2535fb5126e54)(entity)) return this.spawnCallback(entity, name);
        else if ((0, $57d5321825fc99ce$export$b0f989039dc164f9)(entity)) return this.spawnActor(entity, name);
        else if ((0, $bfc72234dd195a09$export$5cd057a6046189f9)(entity)) return this.spawnObservable(entity, name);
        else if ((0, $bfc72234dd195a09$export$2163e7903738b5df)(entity)) return this.spawnMachine(entity, (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, options), {
            id: name
        }));
        else if ((0, $bfc72234dd195a09$export$42749ebe1e7fdef7)(entity)) return this.spawnBehavior(entity, name);
        else throw new Error('Unable to spawn entity "'.concat(name, '" of type "').concat(typeof entity, '".'));
    };
    Interpreter.prototype.spawnMachine = function(machine, options) {
        var _this = this;
        if (options === void 0) options = {};
        var childService = new Interpreter(machine, (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, this.options), {
            parent: this,
            id: options.id || machine.id
        }));
        var resolvedOptions = (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, $0a71063706b576da$var$DEFAULT_SPAWN_OPTIONS), options);
        if (resolvedOptions.sync) childService.onTransition(function(state) {
            _this.send((0, $201d8d6869df8176$export$722fbec263ad908a), {
                state: state,
                id: childService.id
            });
        });
        var actor = childService;
        this.children.set(childService.id, actor);
        if (resolvedOptions.autoForward) this.forwardTo.add(childService.id);
        childService.onDone(function(doneEvent) {
            _this.removeChild(childService.id);
            _this.send((0, $bfc72234dd195a09$export$eaf22249b410f633)(doneEvent, {
                origin: childService.id
            }));
        }).start();
        return actor;
    };
    Interpreter.prototype.spawnBehavior = function(behavior, id) {
        var actorRef = (0, $5d2fdb9150a7e5ed$export$cc3859917b3feaf8)(behavior, {
            id: id,
            parent: this
        });
        this.children.set(id, actorRef);
        return actorRef;
    };
    Interpreter.prototype.spawnPromise = function(promise, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var resolvedData;
        promise.then(function(response) {
            if (!canceled) {
                resolvedData = response;
                _this.removeChild(id);
                _this.send((0, $bfc72234dd195a09$export$eaf22249b410f633)((0, $f9b2d12db4f71f3e$export$c105e588793f70b4)(id, response), {
                    origin: id
                }));
            }
        }, function(errorData) {
            if (!canceled) {
                _this.removeChild(id);
                var errorEvent = (0, $f9b2d12db4f71f3e$export$a3bc9b8ed74fc)(id, errorData);
                try {
                    // Send "error.platform.id" to this (parent).
                    _this.send((0, $bfc72234dd195a09$export$eaf22249b410f633)(errorEvent, {
                        origin: id
                    }));
                } catch (error) {
                    (0, $bfc72234dd195a09$export$b240b9b7a78b5f3e)(errorData, error, id);
                    if (_this.devTools) _this.devTools.send(errorEvent, _this.state);
                    if (_this.machine.strict) // it would be better to always stop the state machine if unhandled
                    // exception/promise rejection happens but because we don't want to
                    // break existing code so enforce it on strict mode only especially so
                    // because documentation says that onError is optional
                    _this.stop();
                }
            }
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                var observer = (0, $bfc72234dd195a09$export$75b67481063f2f98)(next, handleError, complete);
                var unsubscribed = false;
                promise.then(function(response) {
                    if (unsubscribed) return;
                    observer.next(response);
                    if (unsubscribed) return;
                    observer.complete();
                }, function(err) {
                    if (unsubscribed) return;
                    observer.error(err);
                });
                return {
                    unsubscribe: function() {
                        return unsubscribed = true;
                    }
                };
            },
            stop: function() {
                canceled = true;
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return resolvedData;
            }
        }, _a[0, $bfc72234dd195a09$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnCallback = function(callback, id) {
        var _a;
        var _this = this;
        var canceled = false;
        var receivers = new Set();
        var listeners = new Set();
        var emitted;
        var receive = function(e) {
            emitted = e;
            listeners.forEach(function(listener) {
                return listener(e);
            });
            if (canceled) return;
            _this.send((0, $bfc72234dd195a09$export$eaf22249b410f633)(e, {
                origin: id
            }));
        };
        var callbackStop;
        try {
            callbackStop = callback(receive, function(newListener) {
                receivers.add(newListener);
            });
        } catch (err) {
            this.send((0, $f9b2d12db4f71f3e$export$a3bc9b8ed74fc)(id, err));
        }
        if ((0, $bfc72234dd195a09$export$ae936b9d47e5870e)(callbackStop)) // it turned out to be an async function, can't reliably check this before calling `callback`
        // because transpiled async functions are not recognizable
        return this.spawnPromise(callbackStop, id);
        var actor = (_a = {
            id: id,
            send: function(event1) {
                return receivers.forEach(function(receiver) {
                    return receiver(event1);
                });
            },
            subscribe: function(next) {
                var observer = (0, $bfc72234dd195a09$export$75b67481063f2f98)(next);
                listeners.add(observer.next);
                return {
                    unsubscribe: function() {
                        listeners.delete(observer.next);
                    }
                };
            },
            stop: function() {
                canceled = true;
                if ((0, $bfc72234dd195a09$export$f6e2535fb5126e54)(callbackStop)) callbackStop();
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return emitted;
            }
        }, _a[0, $bfc72234dd195a09$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnObservable = function(source, id) {
        var _a;
        var _this = this;
        var emitted;
        var subscription = source.subscribe(function(value) {
            emitted = value;
            _this.send((0, $bfc72234dd195a09$export$eaf22249b410f633)(value, {
                origin: id
            }));
        }, function(err) {
            _this.removeChild(id);
            _this.send((0, $bfc72234dd195a09$export$eaf22249b410f633)((0, $f9b2d12db4f71f3e$export$a3bc9b8ed74fc)(id, err), {
                origin: id
            }));
        }, function() {
            _this.removeChild(id);
            _this.send((0, $bfc72234dd195a09$export$eaf22249b410f633)((0, $f9b2d12db4f71f3e$export$c105e588793f70b4)(id), {
                origin: id
            }));
        });
        var actor = (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                return source.subscribe(next, handleError, complete);
            },
            stop: function() {
                return subscription.unsubscribe();
            },
            getSnapshot: function() {
                return emitted;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, $bfc72234dd195a09$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a);
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnActor = function(actor, name) {
        this.children.set(name, actor);
        return actor;
    };
    Interpreter.prototype.spawnActivity = function(activity) {
        var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : undefined;
        if (!implementation) {
            if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) (0, $bfc72234dd195a09$export$c106dd0671a0fc2d)(false, "No implementation found for activity '".concat(activity.type, "'"));
             // tslint:disable-next-line:no-console
            return;
        } // Start implementation
        var dispose = implementation(this.state.context, activity);
        this.spawnEffect(activity.id, dispose);
    };
    Interpreter.prototype.spawnEffect = function(id, dispose) {
        var _a;
        this.children.set(id, (_a = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function() {
                return {
                    unsubscribe: function() {
                        return void 0;
                    }
                };
            },
            stop: dispose || undefined,
            getSnapshot: function() {
                return undefined;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        }, _a[0, $bfc72234dd195a09$export$c45ebe72e3b2885] = function() {
            return this;
        }, _a));
    };
    Interpreter.prototype.attachDev = function() {
        var global = (0, $f5ac6fd54f392c5a$export$a4e55266d2135a7f)();
        if (this.options.devTools && global) {
            if (global.__REDUX_DEVTOOLS_EXTENSION__) {
                var devToolsOptions = typeof this.options.devTools === "object" ? this.options.devTools : undefined;
                this.devTools = global.__REDUX_DEVTOOLS_EXTENSION__.connect((0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({
                    name: this.id,
                    autoPause: true,
                    stateSanitizer: function(state) {
                        return {
                            value: state.value,
                            context: state.context,
                            actions: state.actions
                        };
                    }
                }, devToolsOptions), {
                    features: (0, $4cf25e58c00f7601$export$18ce0697a983be9b)({
                        jump: false,
                        skip: false
                    }, devToolsOptions ? devToolsOptions.features : undefined)
                }), this.machine);
                this.devTools.init(this.state);
            } // add XState-specific dev tooling hook
            (0, $f5ac6fd54f392c5a$export$4d7a7d14704ebc13)(this);
        }
    };
    Interpreter.prototype.toJSON = function() {
        return {
            id: this.id
        };
    };
    Interpreter.prototype[0, $bfc72234dd195a09$export$c45ebe72e3b2885] = function() {
        return this;
    };
    Interpreter.prototype.getSnapshot = function() {
        if (this.status === $0a71063706b576da$export$7a567c9c5088a551.NotStarted) return this.initialState;
        return this._state;
    };
    /**
   * The default interpreter options:
   *
   * - `clock` uses the global `setTimeout` and `clearTimeout` functions
   * - `logger` uses the global `console.log()` method
   */ Interpreter.defaultOptions = {
        execute: true,
        deferEvents: true,
        clock: {
            setTimeout: function(fn, ms) {
                return setTimeout(fn, ms);
            },
            clearTimeout: function(id) {
                return clearTimeout(id);
            }
        },
        logger: /*#__PURE__*/ console.log.bind(console),
        devTools: false
    };
    Interpreter.interpret = $0a71063706b576da$export$67beed298888a38b;
    return Interpreter;
}();
var $0a71063706b576da$var$resolveSpawnOptions = function(nameOrOptions) {
    if ((0, $bfc72234dd195a09$export$844ec244b1367d54)(nameOrOptions)) return (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, $0a71063706b576da$var$DEFAULT_SPAWN_OPTIONS), {
        name: nameOrOptions
    });
    return (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, $0a71063706b576da$var$DEFAULT_SPAWN_OPTIONS), {
        name: (0, $bfc72234dd195a09$export$8b15d37bc3f197d4)()
    }), nameOrOptions);
};
function $0a71063706b576da$export$1713f5ac2bf0caf5(entity, nameOrOptions) {
    var resolvedOptions = $0a71063706b576da$var$resolveSpawnOptions(nameOrOptions);
    return (0, $5d9d4f30877509a6$export$e11e6a155c5c4d9d)(function(service) {
        if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) {
            var isLazyEntity = (0, $bfc72234dd195a09$export$2163e7903738b5df)(entity) || (0, $bfc72234dd195a09$export$f6e2535fb5126e54)(entity);
            (0, $bfc72234dd195a09$export$c106dd0671a0fc2d)(!!service || isLazyEntity, 'Attempted to spawn an Actor (ID: "'.concat((0, $bfc72234dd195a09$export$2163e7903738b5df)(entity) ? entity.id : "undefined", '") outside of a service. This will have no effect.'));
        }
        if (service) return service.spawn(entity, resolvedOptions.name, resolvedOptions);
        else return (0, $57d5321825fc99ce$export$59bcb51d8e40ed48)(entity, resolvedOptions.name);
    });
}
/**
 * Creates a new Interpreter instance for the given machine with the provided options, if any.
 *
 * @param machine The machine to interpret
 * @param options Interpreter options
 */ function $0a71063706b576da$export$67beed298888a38b(machine, options) {
    var interpreter = new $0a71063706b576da$export$e5b52c46a548ff03(machine, options);
    return interpreter;
}



var $1T1QG = parcelRequire("1T1QG");
function $a6e97c19456b97eb$export$2e2bcd8739ae039(fn) {
    var ref = $1T1QG.useRef();
    if (!ref.current) ref.current = {
        v: fn()
    };
    return ref.current.v;
}


var $8a3e5c8197e5795e$var$__assign = undefined && undefined.__assign || function() {
    $8a3e5c8197e5795e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8a3e5c8197e5795e$var$__assign.apply(this, arguments);
};
var $8a3e5c8197e5795e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8a3e5c8197e5795e$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $8a3e5c8197e5795e$export$d09836c9e303db57(getMachine, options) {
    var machine = (0, $a6e97c19456b97eb$export$2e2bcd8739ae039)(function() {
        return typeof getMachine === "function" ? getMachine() : getMachine;
    });
    var _a, initialMachine;
    var context = options.context, guards = options.guards, actions = options.actions, activities = options.activities, services = options.services, delays = options.delays, rehydratedState = options.state, interpreterOptions = $8a3e5c8197e5795e$var$__rest(options, [
        "context",
        "guards",
        "actions",
        "activities",
        "services",
        "delays",
        "state"
    ]);
    var service = (0, $a6e97c19456b97eb$export$2e2bcd8739ae039)(function() {
        var machineConfig = {
            context: context,
            guards: guards,
            actions: actions,
            activities: activities,
            services: services,
            delays: delays
        };
        var machineWithConfig = machine.withConfig(machineConfig, function() {
            return $8a3e5c8197e5795e$var$__assign($8a3e5c8197e5795e$var$__assign({}, machine.context), context);
        });
        return (0, $0a71063706b576da$export$67beed298888a38b)(machineWithConfig, interpreterOptions);
    });
    // Make sure options are kept updated when they change.
    // This mutation assignment is safe because the service instance is only used
    // in one place -- this hook's caller.
    (0, $967c055100ba8eae$export$2e2bcd8739ae039)(function() {
        Object.assign(service.machine.options.actions, actions);
        Object.assign(service.machine.options.guards, guards);
        Object.assign(service.machine.options.activities, activities);
        Object.assign(service.machine.options.services, services);
        Object.assign(service.machine.options.delays, delays);
    }, [
        actions,
        guards,
        activities,
        services,
        delays
    ]);
    return service;
}
function $8a3e5c8197e5795e$export$d9e9b060fbbae528(getMachine) {
    var _a = [];
    for(var _i = 1; _i < arguments.length; _i++)_a[_i - 1] = arguments[_i];
    var _b = $8a3e5c8197e5795e$var$__read(_a, 2), _c = _b[0], options = _c === void 0 ? {} : _c, observerOrListener = _b[1];
    var service = $8a3e5c8197e5795e$export$d09836c9e303db57(getMachine, options);
    (0, $1T1QG.useEffect)(function() {
        if (!observerOrListener) return;
        var sub = service.subscribe((0, $bfc72234dd195a09$export$75b67481063f2f98)(observerOrListener));
        return function() {
            sub.unsubscribe();
        };
    }, [
        observerOrListener
    ]);
    (0, $1T1QG.useEffect)(function() {
        var rehydratedState = options.state;
        service.start(rehydratedState ? (0, $9f85080534c7efcc$export$7254cc27399e90bd).create(rehydratedState) : undefined);
        return function() {
            service.stop();
            service.status = (0, $0a71063706b576da$export$7a567c9c5088a551).NotStarted;
        };
    }, []);
    return service;
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f81a56aa40a8c8c9$export$e5432d4c8eb97ea7 = async (amplify)=>{
    const authConfig = amplify.getConfig().Auth?.Cognito;
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
    const tokens = await amplify.Auth.getTokens({
        forceRefresh: false
    });
    (0, $627294a07e5270d4$export$77712ea5882cac9f)(tokens);
    const { "cognito:username": username, sub: sub } = tokens.idToken?.payload ?? {};
    const authUser = {
        username: username,
        userId: sub
    };
    const signInDetails = $f81a56aa40a8c8c9$var$getSignInDetailsFromTokens(tokens);
    if (signInDetails) authUser.signInDetails = signInDetails;
    return authUser;
};
function $f81a56aa40a8c8c9$var$getSignInDetailsFromTokens(tokens) {
    return tokens?.signInDetails;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Gets the current user from the idToken.
 *
 * @param input -  The GetCurrentUserInput object.
 * @returns GetCurrentUserOutput
 * @throws - {@link InitiateAuthException} - Thrown when the service fails to refresh the tokens.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $95f3b5487ad3e06b$export$e5432d4c8eb97ea7 = async ()=>{
    return (0, $f81a56aa40a8c8c9$export$e5432d4c8eb97ea7)((0, $623ac757f0e7ef86$export$a3858a9a153cffc7));
};



















function $5b311985cfd80d23$export$436e852aa2feda95(src) {
    if (typeof src === "string") {
        var simpleSrc = {
            type: src
        };
        simpleSrc.toString = function() {
            return src;
        }; // v4 compat - TODO: remove in v5
        return simpleSrc;
    }
    return src;
}
function $5b311985cfd80d23$export$4c73f685ba879446(invokeConfig) {
    return (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({
        type: (0, $201d8d6869df8176$export$468cda29b159ee5d)
    }, invokeConfig), {
        toJSON: function() {
            invokeConfig.onDone;
            invokeConfig.onError;
            var invokeDef = (0, $4cf25e58c00f7601$export$3c9a16f847548506)(invokeConfig, [
                "onDone",
                "onError"
            ]);
            return (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, invokeDef), {
                type: (0, $201d8d6869df8176$export$468cda29b159ee5d),
                src: $5b311985cfd80d23$export$436e852aa2feda95(invokeConfig.src)
            });
        }
    });
}


var $9e78221b10855d63$var$NULL_EVENT = "";
var $9e78221b10855d63$var$STATE_IDENTIFIER = "#";
var $9e78221b10855d63$var$WILDCARD = "*";
var $9e78221b10855d63$var$EMPTY_OBJECT = {};
var $9e78221b10855d63$var$isStateId = function(str) {
    return str[0] === $9e78221b10855d63$var$STATE_IDENTIFIER;
};
var $9e78221b10855d63$var$createDefaultOptions = function() {
    return {
        actions: {},
        guards: {},
        services: {},
        activities: {},
        delays: {}
    };
};
var $9e78221b10855d63$var$validateArrayifiedTransitions = function(stateNode, event, transitions) {
    var hasNonLastUnguardedTarget = transitions.slice(0, -1).some(function(transition) {
        return !("cond" in transition) && !("in" in transition) && ((0, $bfc72234dd195a09$export$844ec244b1367d54)(transition.target) || (0, $bfc72234dd195a09$export$2163e7903738b5df)(transition.target));
    });
    var eventText = event === $9e78221b10855d63$var$NULL_EVENT ? "the transient event" : "event '".concat(event, "'");
    (0, $bfc72234dd195a09$export$c106dd0671a0fc2d)(!hasNonLastUnguardedTarget, "One or more transitions for ".concat(eventText, " on state '").concat(stateNode.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
};
var $9e78221b10855d63$export$342f24f5edd47b1 = /*#__PURE__*/ /** @class */ function() {
    function StateNode(/**
   * The raw config used to create the machine.
   */ config, options, /**
   * The initial extended state
   */ _context, _stateInfo) {
        if (_context === void 0) _context = "context" in config ? config.context : undefined;
        var _this = this;
        var _a;
        this.config = config;
        this._context = _context;
        /**
     * The order this state node appears. Corresponds to the implicit SCXML document order.
     */ this.order = -1;
        this.__xstatenode = true;
        this.__cache = {
            events: undefined,
            relativeValue: new Map(),
            initialStateValue: undefined,
            initialState: undefined,
            on: undefined,
            transitions: undefined,
            candidates: {},
            delayedTransitions: undefined
        };
        this.idMap = {};
        this.tags = [];
        this.options = Object.assign($9e78221b10855d63$var$createDefaultOptions(), options);
        this.parent = _stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.parent;
        this.key = this.config.key || (_stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.key) || this.config.id || "(machine)";
        this.machine = this.parent ? this.parent.machine : this;
        this.path = this.parent ? this.parent.path.concat(this.key) : [];
        this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : (0, $b33947b250ecf0ef$export$b060f3cec92ef5c9));
        this.id = this.config.id || (0, $4cf25e58c00f7601$export$1216008129fb82ed)([
            this.machine.key
        ], (0, $4cf25e58c00f7601$export$8d051b38c9118094)(this.path), false).join(this.delimiter);
        this.version = this.parent ? this.parent.version : this.config.version;
        this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic");
        this.schema = this.parent ? this.machine.schema : (_a = this.config.schema) !== null && _a !== void 0 ? _a : {};
        this.description = this.config.description;
        if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) (0, $bfc72234dd195a09$export$c106dd0671a0fc2d)(!("parallel" in this.config), 'The "parallel" property is deprecated and will be removed in version 4.1. '.concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead."));
        this.initial = this.config.initial;
        this.states = this.config.states ? (0, $bfc72234dd195a09$export$825e789796ab7275)(this.config.states, function(stateConfig, key) {
            var _a;
            var stateNode = new StateNode(stateConfig, {}, undefined, {
                parent: _this,
                key: key
            });
            Object.assign(_this.idMap, (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((_a = {}, _a[stateNode.id] = stateNode, _a), stateNode.idMap));
            return stateNode;
        }) : $9e78221b10855d63$var$EMPTY_OBJECT; // Document order
        var order = 0;
        function dfs(stateNode) {
            var e_1, _a;
            stateNode.order = order++;
            try {
                for(var _b = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)((0, $8ab3728758ad7bb1$export$ad3d2e38d4deaf6d)(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var child = _c.value;
                    dfs(child);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        dfs(this); // History config
        this.history = this.config.history === true ? "shallow" : this.config.history || false;
        this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function(_a) {
            var event = _a.event;
            return event === $9e78221b10855d63$var$NULL_EVENT;
        }) : $9e78221b10855d63$var$NULL_EVENT in this.config.on);
        this.strict = !!this.config.strict; // TODO: deprecate (entry)
        this.onEntry = (0, $bfc72234dd195a09$export$45b10814cc054894)(this.config.entry || this.config.onEntry).map(function(action) {
            return (0, $f9b2d12db4f71f3e$export$b38b66cc2da3ede7)(action);
        }); // TODO: deprecate (exit)
        this.onExit = (0, $bfc72234dd195a09$export$45b10814cc054894)(this.config.exit || this.config.onExit).map(function(action) {
            return (0, $f9b2d12db4f71f3e$export$b38b66cc2da3ede7)(action);
        });
        this.meta = this.config.meta;
        this.doneData = this.type === "final" ? this.config.data : undefined;
        this.invoke = (0, $bfc72234dd195a09$export$45b10814cc054894)(this.config.invoke).map(function(invokeConfig, i) {
            var _a, _b;
            if ((0, $bfc72234dd195a09$export$2163e7903738b5df)(invokeConfig)) {
                var invokeId = (0, $bfc72234dd195a09$export$107b54c5097f9157)(_this.id, i);
                _this.machine.options.services = (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((_a = {}, _a[invokeId] = invokeConfig, _a), _this.machine.options.services);
                return (0, $5b311985cfd80d23$export$4c73f685ba879446)({
                    src: invokeId,
                    id: invokeId
                });
            } else if ((0, $bfc72234dd195a09$export$844ec244b1367d54)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, $bfc72234dd195a09$export$107b54c5097f9157)(_this.id, i);
                return (0, $5b311985cfd80d23$export$4c73f685ba879446)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, invokeConfig), {
                    id: invokeId,
                    src: invokeConfig.src
                }));
            } else if ((0, $bfc72234dd195a09$export$2163e7903738b5df)(invokeConfig.src) || (0, $bfc72234dd195a09$export$f6e2535fb5126e54)(invokeConfig.src)) {
                var invokeId = invokeConfig.id || (0, $bfc72234dd195a09$export$107b54c5097f9157)(_this.id, i);
                _this.machine.options.services = (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((_b = {}, _b[invokeId] = invokeConfig.src, _b), _this.machine.options.services);
                return (0, $5b311985cfd80d23$export$4c73f685ba879446)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({
                    id: invokeId
                }, invokeConfig), {
                    src: invokeId
                }));
            } else {
                var invokeSource = invokeConfig.src;
                return (0, $5b311985cfd80d23$export$4c73f685ba879446)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({
                    id: (0, $bfc72234dd195a09$export$107b54c5097f9157)(_this.id, i)
                }, invokeConfig), {
                    src: invokeSource
                }));
            }
        });
        this.activities = (0, $bfc72234dd195a09$export$45b10814cc054894)(this.config.activities).concat(this.invoke).map(function(activity) {
            return (0, $f9b2d12db4f71f3e$export$e81fdd8937d44864)(activity);
        });
        this.transition = this.transition.bind(this);
        this.tags = (0, $bfc72234dd195a09$export$45b10814cc054894)(this.config.tags); // TODO: this is the real fix for initialization once
    // state node getters are deprecated
    // if (!this.parent) {
    //   this._init();
    // }
    }
    StateNode.prototype._init = function() {
        if (this.__cache.transitions) return;
        (0, $8ab3728758ad7bb1$export$3de19bba299e3801)(this).forEach(function(stateNode) {
            return stateNode.on;
        });
    };
    /**
   * Clones this state machine with custom options and context.
   *
   * @param options Options (actions, guards, activities, services) to recursively merge with the existing options.
   * @param context Custom context (will override predefined context)
   */ StateNode.prototype.withConfig = function(options, context) {
        var _a = this.options, actions = _a.actions, activities = _a.activities, guards = _a.guards, services = _a.services, delays = _a.delays;
        return new StateNode(this.config, {
            actions: (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, actions), options.actions),
            activities: (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, activities), options.activities),
            guards: (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, guards), options.guards),
            services: (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, services), options.services),
            delays: (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, delays), options.delays)
        }, context !== null && context !== void 0 ? context : this.context);
    };
    /**
   * Clones this state machine with custom context.
   *
   * @param context Custom context (will override predefined context, not recursive)
   */ StateNode.prototype.withContext = function(context) {
        return new StateNode(this.config, this.options, context);
    };
    Object.defineProperty(StateNode.prototype, "context", {
        get: function() {
            return (0, $bfc72234dd195a09$export$f6e2535fb5126e54)(this._context) ? this._context() : this._context;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "definition", {
        /**
     * The well-structured state node definition.
     */ get: function() {
            return {
                id: this.id,
                key: this.key,
                version: this.version,
                context: this.context,
                type: this.type,
                initial: this.initial,
                history: this.history,
                states: (0, $bfc72234dd195a09$export$825e789796ab7275)(this.states, function(state) {
                    return state.definition;
                }),
                on: this.on,
                transitions: this.transitions,
                entry: this.onEntry,
                exit: this.onExit,
                activities: this.activities || [],
                meta: this.meta,
                order: this.order || -1,
                data: this.doneData,
                invoke: this.invoke,
                description: this.description,
                tags: this.tags
            };
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.toJSON = function() {
        return this.definition;
    };
    Object.defineProperty(StateNode.prototype, "on", {
        /**
     * The mapping of events to transitions.
     */ get: function() {
            if (this.__cache.on) return this.__cache.on;
            var transitions = this.transitions;
            return this.__cache.on = transitions.reduce(function(map, transition) {
                map[transition.eventType] = map[transition.eventType] || [];
                map[transition.eventType].push(transition);
                return map;
            }, {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "after", {
        get: function() {
            return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "transitions", {
        /**
     * All the transitions that can be taken from this state node.
     */ get: function() {
            return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getCandidates = function(eventName) {
        if (this.__cache.candidates[eventName]) return this.__cache.candidates[eventName];
        var transient = eventName === $9e78221b10855d63$var$NULL_EVENT;
        var candidates = this.transitions.filter(function(transition) {
            var sameEventType = transition.eventType === eventName; // null events should only match against eventless transitions
            return transient ? sameEventType : sameEventType || transition.eventType === $9e78221b10855d63$var$WILDCARD;
        });
        this.__cache.candidates[eventName] = candidates;
        return candidates;
    };
    /**
   * All delayed transitions from the config.
   */ StateNode.prototype.getDelayedTransitions = function() {
        var _this = this;
        var afterConfig = this.config.after;
        if (!afterConfig) return [];
        var mutateEntryExit = function(delay, i) {
            var delayRef = (0, $bfc72234dd195a09$export$f6e2535fb5126e54)(delay) ? "".concat(_this.id, ":delay[").concat(i, "]") : delay;
            var eventType = (0, $f9b2d12db4f71f3e$export$742acabee3dd6465)(delayRef, _this.id);
            _this.onEntry.push((0, $f9b2d12db4f71f3e$export$89db4734f6c919c4)(eventType, {
                delay: delay
            }));
            _this.onExit.push((0, $f9b2d12db4f71f3e$export$70b61ad426ddbe54)(eventType));
            return eventType;
        };
        var delayedTransitions = (0, $bfc72234dd195a09$export$43bee75e5e14138e)(afterConfig) ? afterConfig.map(function(transition, i) {
            var eventType = mutateEntryExit(transition.delay, i);
            return (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, transition), {
                event: eventType
            });
        }) : (0, $bfc72234dd195a09$export$bffa455ba8c619a6)(Object.keys(afterConfig).map(function(delay, i) {
            var configTransition = afterConfig[delay];
            var resolvedTransition = (0, $bfc72234dd195a09$export$844ec244b1367d54)(configTransition) ? {
                target: configTransition
            } : configTransition;
            var resolvedDelay = !isNaN(+delay) ? +delay : delay;
            var eventType = mutateEntryExit(resolvedDelay, i);
            return (0, $bfc72234dd195a09$export$45b10814cc054894)(resolvedTransition).map(function(transition) {
                return (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, transition), {
                    event: eventType,
                    delay: resolvedDelay
                });
            });
        }));
        return delayedTransitions.map(function(delayedTransition) {
            var delay = delayedTransition.delay;
            return (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, _this.formatTransition(delayedTransition)), {
                delay: delay
            });
        });
    };
    /**
   * Returns the state nodes represented by the current state value.
   *
   * @param state The state value or State instance
   */ StateNode.prototype.getStateNodes = function(state) {
        var _a;
        var _this = this;
        if (!state) return [];
        var stateValue = state instanceof (0, $9f85080534c7efcc$export$7254cc27399e90bd) ? state.value : (0, $bfc72234dd195a09$export$fb3aecd1d93744e3)(state, this.delimiter);
        if ((0, $bfc72234dd195a09$export$844ec244b1367d54)(stateValue)) {
            var initialStateValue = this.getStateNode(stateValue).initial;
            return initialStateValue !== undefined ? this.getStateNodes((_a = {}, _a[stateValue] = initialStateValue, _a)) : [
                this,
                this.states[stateValue]
            ];
        }
        var subStateKeys = Object.keys(stateValue);
        var subStateNodes = [
            this
        ];
        subStateNodes.push.apply(subStateNodes, (0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)((0, $bfc72234dd195a09$export$bffa455ba8c619a6)(subStateKeys.map(function(subStateKey) {
            return _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
        }))), false));
        return subStateNodes;
    };
    /**
   * Returns `true` if this state node explicitly handles the given event.
   *
   * @param event The event in question
   */ StateNode.prototype.handles = function(event) {
        var eventType = (0, $bfc72234dd195a09$export$7193fc8c8cd445e9)(event);
        return this.events.includes(eventType);
    };
    /**
   * Resolves the given `state` to a new `State` instance relative to this machine.
   *
   * This ensures that `.events` and `.nextEvents` represent the correct values.
   *
   * @param state The state to resolve
   */ StateNode.prototype.resolveState = function(state) {
        var stateFromConfig = state instanceof (0, $9f85080534c7efcc$export$7254cc27399e90bd) ? state : (0, $9f85080534c7efcc$export$7254cc27399e90bd).create(state);
        var configuration = Array.from((0, $8ab3728758ad7bb1$export$3de01744a82b21a4)([], this.getStateNodes(stateFromConfig.value)));
        return new (0, $9f85080534c7efcc$export$7254cc27399e90bd)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, stateFromConfig), {
            value: this.resolve(stateFromConfig.value),
            configuration: configuration,
            done: (0, $8ab3728758ad7bb1$export$cf3d5dae927fcf63)(configuration, this),
            tags: (0, $8ab3728758ad7bb1$export$5301196121335ca0)(configuration),
            machine: this.machine
        }));
    };
    StateNode.prototype.transitionLeafNode = function(stateValue, state, _event) {
        var stateNode = this.getStateNode(stateValue);
        var next = stateNode.next(state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionCompoundNode = function(stateValue, state, _event) {
        var subStateKeys = Object.keys(stateValue);
        var stateNode = this.getStateNode(subStateKeys[0]);
        var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionParallelNode = function(stateValue, state, _event) {
        var e_2, _a;
        var transitionMap = {};
        try {
            for(var _b = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(Object.keys(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()){
                var subStateKey = _c.value;
                var subStateValue = stateValue[subStateKey];
                if (!subStateValue) continue;
                var subStateNode = this.getStateNode(subStateKey);
                var next = subStateNode._transition(subStateValue, state, _event);
                if (next) transitionMap[subStateKey] = next;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var stateTransitions = Object.keys(transitionMap).map(function(key) {
            return transitionMap[key];
        });
        var enabledTransitions = (0, $bfc72234dd195a09$export$bffa455ba8c619a6)(stateTransitions.map(function(st) {
            return st.transitions;
        }));
        var willTransition = stateTransitions.some(function(st) {
            return st.transitions.length > 0;
        });
        if (!willTransition) return this.next(state, _event);
        var configuration = (0, $bfc72234dd195a09$export$bffa455ba8c619a6)(Object.keys(transitionMap).map(function(key) {
            return transitionMap[key].configuration;
        }));
        return {
            transitions: enabledTransitions,
            exitSet: (0, $bfc72234dd195a09$export$bffa455ba8c619a6)(stateTransitions.map(function(t) {
                return t.exitSet;
            })),
            configuration: configuration,
            source: state,
            actions: (0, $bfc72234dd195a09$export$bffa455ba8c619a6)(Object.keys(transitionMap).map(function(key) {
                return transitionMap[key].actions;
            }))
        };
    };
    StateNode.prototype._transition = function(stateValue, state, _event) {
        // leaf node
        if ((0, $bfc72234dd195a09$export$844ec244b1367d54)(stateValue)) return this.transitionLeafNode(stateValue, state, _event);
         // hierarchical node
        if (Object.keys(stateValue).length === 1) return this.transitionCompoundNode(stateValue, state, _event);
         // orthogonal node
        return this.transitionParallelNode(stateValue, state, _event);
    };
    StateNode.prototype.getTransitionData = function(state, event) {
        return this._transition(state.value, state, (0, $bfc72234dd195a09$export$eaf22249b410f633)(event));
    };
    StateNode.prototype.next = function(state, _event) {
        var e_3, _a;
        var _this = this;
        var eventName = _event.name;
        var actions = [];
        var nextStateNodes = [];
        var selectedTransition;
        try {
            for(var _b = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()){
                var candidate = _c.value;
                var cond = candidate.cond, stateIn = candidate.in;
                var resolvedContext = state.context;
                var isInState = stateIn ? (0, $bfc72234dd195a09$export$844ec244b1367d54)(stateIn) && $9e78221b10855d63$var$isStateId(stateIn) ? state.matches((0, $bfc72234dd195a09$export$fb3aecd1d93744e3)(this.getStateNodeById(stateIn).path, this.delimiter)) : (0, $bfc72234dd195a09$export$2870710bf0eac88e)((0, $bfc72234dd195a09$export$fb3aecd1d93744e3)(stateIn, this.delimiter), (0, $bfc72234dd195a09$export$bb654e07daaf8c3a)(this.path.slice(0, -2))(state.value)) : true;
                var guardPassed = false;
                try {
                    guardPassed = !cond || (0, $bfc72234dd195a09$export$91646ab912d254e8)(this.machine, cond, resolvedContext, _event, state);
                } catch (err) {
                    throw new Error("Unable to evaluate guard '".concat(cond.name || cond.type, "' in transition for event '").concat(eventName, "' in state node '").concat(this.id, "':\n").concat(err.message));
                }
                if (guardPassed && isInState) {
                    if (candidate.target !== undefined) nextStateNodes = candidate.target;
                    actions.push.apply(actions, (0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)(candidate.actions), false));
                    selectedTransition = candidate;
                    break;
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (!selectedTransition) return undefined;
        if (!nextStateNodes.length) return {
            transitions: [
                selectedTransition
            ],
            exitSet: [],
            configuration: state.value ? [
                this
            ] : [],
            source: state,
            actions: actions
        };
        var allNextStateNodes = (0, $bfc72234dd195a09$export$bffa455ba8c619a6)(nextStateNodes.map(function(stateNode) {
            return _this.getRelativeStateNodes(stateNode, state.historyValue);
        }));
        var isInternal = !!selectedTransition.internal;
        return {
            transitions: [
                selectedTransition
            ],
            exitSet: isInternal ? [] : (0, $bfc72234dd195a09$export$bffa455ba8c619a6)(nextStateNodes.map(function(targetNode) {
                return _this.getPotentiallyReenteringNodes(targetNode);
            })),
            configuration: allNextStateNodes,
            source: state,
            actions: actions
        };
    }; // even though the name of this function mentions reentry nodes
    // we are pushing its result into `exitSet`
    // that's because what we exit might be reentered (it's an invariant of reentrancy)
    StateNode.prototype.getPotentiallyReenteringNodes = function(targetNode) {
        if (this.order < targetNode.order) return [
            this
        ];
        var nodes = [];
        var marker = this;
        var possibleAncestor = targetNode;
        while(marker && marker !== possibleAncestor){
            nodes.push(marker);
            marker = marker.parent;
        }
        if (marker !== possibleAncestor) // we never got to `possibleAncestor`, therefore the initial `marker` "escapes" it
        // it's in a different part of the tree so no states will be reentered for such an external transition
        return [];
        nodes.push(possibleAncestor);
        return nodes;
    };
    StateNode.prototype.getActions = function(resolvedConfig, isDone, transition, currentContext, _event, prevState, predictableExec) {
        var e_4, _a, e_5, _b;
        var _this = this;
        var prevConfig = prevState ? (0, $8ab3728758ad7bb1$export$3de01744a82b21a4)([], this.getStateNodes(prevState.value)) : [];
        var entrySet = new Set();
        try {
            for(var _c = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(Array.from(resolvedConfig).sort(function(a, b) {
                return a.order - b.order;
            })), _d = _c.next(); !_d.done; _d = _c.next()){
                var sn = _d.value;
                if (!(0, $8ab3728758ad7bb1$export$a4f4bb6b1453fff5)(prevConfig, sn) || (0, $8ab3728758ad7bb1$export$a4f4bb6b1453fff5)(transition.exitSet, sn) || sn.parent && entrySet.has(sn.parent)) entrySet.add(sn);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        try {
            for(var prevConfig_1 = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()){
                var sn = prevConfig_1_1.value;
                if (!(0, $8ab3728758ad7bb1$export$a4f4bb6b1453fff5)(resolvedConfig, sn) || (0, $8ab3728758ad7bb1$export$a4f4bb6b1453fff5)(transition.exitSet, sn.parent)) transition.exitSet.push(sn);
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return)) _b.call(prevConfig_1);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        transition.exitSet.sort(function(a, b) {
            return b.order - a.order;
        });
        var entryStates = Array.from(entrySet).sort(function(a, b) {
            return a.order - b.order;
        });
        var exitStates = new Set(transition.exitSet);
        var doneEvents = (0, $bfc72234dd195a09$export$bffa455ba8c619a6)(entryStates.map(function(sn) {
            var events = [];
            if (sn.type !== "final") return events;
            var parent = sn.parent;
            if (!parent.parent) return events;
            events.push((0, $f9b2d12db4f71f3e$export$3df11c9c20e7b288)(sn.id, sn.doneData), (0, $f9b2d12db4f71f3e$export$3df11c9c20e7b288)(parent.id, sn.doneData ? (0, $bfc72234dd195a09$export$e756e60189cc2351)(sn.doneData, currentContext, _event) : undefined));
            var grandparent = parent.parent;
            if (grandparent.type === "parallel") {
                if ((0, $8ab3728758ad7bb1$export$f8cf48ee793b41be)(grandparent).every(function(parentNode) {
                    return (0, $8ab3728758ad7bb1$export$cf3d5dae927fcf63)(transition.configuration, parentNode);
                })) events.push((0, $f9b2d12db4f71f3e$export$3df11c9c20e7b288)(grandparent.id));
            }
            return events;
        }));
        var entryActions = entryStates.map(function(stateNode) {
            var entryActions = stateNode.onEntry;
            var invokeActions = stateNode.activities.map(function(activity) {
                return (0, $f9b2d12db4f71f3e$export$b3571188c770cc5a)(activity);
            });
            return {
                type: "entry",
                actions: (0, $f9b2d12db4f71f3e$export$aa68691f32e6c459)(predictableExec ? (0, $4cf25e58c00f7601$export$1216008129fb82ed)((0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)(entryActions), false), (0, $4cf25e58c00f7601$export$8d051b38c9118094)(invokeActions), false) : (0, $4cf25e58c00f7601$export$1216008129fb82ed)((0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)(invokeActions), false), (0, $4cf25e58c00f7601$export$8d051b38c9118094)(entryActions), false), _this.machine.options.actions)
            };
        }).concat({
            type: "state_done",
            actions: doneEvents.map(function(event) {
                return (0, $f9b2d12db4f71f3e$export$66313c302b2ea154)(event);
            })
        });
        var exitActions = Array.from(exitStates).map(function(stateNode) {
            return {
                type: "exit",
                actions: (0, $f9b2d12db4f71f3e$export$aa68691f32e6c459)((0, $4cf25e58c00f7601$export$1216008129fb82ed)((0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)(stateNode.onExit), false), (0, $4cf25e58c00f7601$export$8d051b38c9118094)(stateNode.activities.map(function(activity) {
                    return (0, $f9b2d12db4f71f3e$export$fa6813432f753b0d)(activity);
                })), false), _this.machine.options.actions)
            };
        });
        var actions = exitActions.concat({
            type: "transition",
            actions: (0, $f9b2d12db4f71f3e$export$aa68691f32e6c459)(transition.actions, this.machine.options.actions)
        }).concat(entryActions);
        if (isDone) {
            var stopActions = (0, $f9b2d12db4f71f3e$export$aa68691f32e6c459)((0, $bfc72234dd195a09$export$bffa455ba8c619a6)((0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)(resolvedConfig), false).sort(function(a, b) {
                return b.order - a.order;
            }).map(function(stateNode) {
                return stateNode.onExit;
            })), this.machine.options.actions).filter(function(action) {
                return !(0, $bfc72234dd195a09$export$37dc2eda56cb25a5)(action);
            });
            return actions.concat({
                type: "stop",
                actions: stopActions
            });
        }
        return actions;
    };
    /**
   * Determines the next state given the current `state` and sent `event`.
   *
   * @param state The current State instance or state value
   * @param event The event that was sent at the current state
   * @param context The current context (extended state) of the current state
   */ StateNode.prototype.transition = function(state, event, context, exec) {
        if (state === void 0) state = this.initialState;
        var _event = (0, $bfc72234dd195a09$export$eaf22249b410f633)(event);
        var currentState;
        if (state instanceof (0, $9f85080534c7efcc$export$7254cc27399e90bd)) currentState = context === undefined ? state : this.resolveState((0, $9f85080534c7efcc$export$7254cc27399e90bd).from(state, context));
        else {
            var resolvedStateValue = (0, $bfc72234dd195a09$export$844ec244b1367d54)(state) ? this.resolve((0, $bfc72234dd195a09$export$f2ee84fc53c45e74)(this.getResolvedPath(state))) : this.resolve(state);
            var resolvedContext = context !== null && context !== void 0 ? context : this.machine.context;
            currentState = this.resolveState((0, $9f85080534c7efcc$export$7254cc27399e90bd).from(resolvedStateValue, resolvedContext));
        }
        if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571) && _event.name === $9e78221b10855d63$var$WILDCARD) throw new Error("An event cannot have the wildcard type ('".concat($9e78221b10855d63$var$WILDCARD, "')"));
        if (this.strict) {
            if (!this.events.includes(_event.name) && !(0, $bfc72234dd195a09$export$479b1b8942fd0b8d)(_event.name)) throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(_event.name, "'"));
        }
        var stateTransition = this._transition(currentState.value, currentState, _event) || {
            transitions: [],
            configuration: [],
            exitSet: [],
            source: currentState,
            actions: []
        };
        var prevConfig = (0, $8ab3728758ad7bb1$export$3de01744a82b21a4)([], this.getStateNodes(currentState.value));
        var resolvedConfig = stateTransition.configuration.length ? (0, $8ab3728758ad7bb1$export$3de01744a82b21a4)(prevConfig, stateTransition.configuration) : prevConfig;
        stateTransition.configuration = (0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)(resolvedConfig), false);
        return this.resolveTransition(stateTransition, currentState, currentState.context, exec, _event);
    };
    StateNode.prototype.resolveRaisedTransition = function(state, _event, originalEvent, predictableExec) {
        var _a;
        var currentActions = state.actions;
        state = this.transition(state, _event, undefined, predictableExec); // Save original event to state
        // TODO: this should be the raised event! Delete in V5 (breaking)
        state._event = originalEvent;
        state.event = originalEvent.data;
        (_a = state.actions).unshift.apply(_a, (0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)(currentActions), false));
        return state;
    };
    StateNode.prototype.resolveTransition = function(stateTransition, currentState, context, predictableExec, _event) {
        var e_6, _a, e_7, _b;
        var _this = this;
        if (_event === void 0) _event = (0, $f9b2d12db4f71f3e$export$163c566c60ed2ec9);
        var configuration = stateTransition.configuration; // Transition will "apply" if:
        // - this is the initial state (there is no current state)
        // - OR there are transitions
        var willTransition = !currentState || stateTransition.transitions.length > 0;
        var resolvedConfiguration = willTransition ? stateTransition.configuration : currentState ? currentState.configuration : [];
        var isDone = (0, $8ab3728758ad7bb1$export$cf3d5dae927fcf63)(resolvedConfiguration, this);
        var resolvedStateValue = willTransition ? (0, $8ab3728758ad7bb1$export$bf7199a9ebcb84a9)(this.machine, configuration) : undefined;
        var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : undefined : undefined;
        var actionBlocks = this.getActions(new Set(resolvedConfiguration), isDone, stateTransition, context, _event, currentState, predictableExec);
        var activities = currentState ? (0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, currentState.activities) : {};
        try {
            for(var actionBlocks_1 = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()){
                var block = actionBlocks_1_1.value;
                try {
                    for(var _c = (e_7 = void 0, (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(block.actions)), _d = _c.next(); !_d.done; _d = _c.next()){
                        var action = _d.value;
                        if (action.type === (0, $201d8d6869df8176$export$b3571188c770cc5a)) activities[action.activity.id || action.activity.type] = action;
                        else if (action.type === (0, $201d8d6869df8176$export$fa6813432f753b0d)) activities[action.activity.id || action.activity.type] = false;
                    }
                } catch (e_7_1) {
                    e_7 = {
                        error: e_7_1
                    };
                } finally{
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    } finally{
                        if (e_7) throw e_7.error;
                    }
                }
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a = actionBlocks_1.return)) _a.call(actionBlocks_1);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        var _e = (0, $4cf25e58c00f7601$export$8d051b38c9118094)((0, $f9b2d12db4f71f3e$export$b8b9e7ba5b8c7b3e)(this, currentState, context, _event, actionBlocks, predictableExec, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2), resolvedActions = _e[0], updatedContext = _e[1];
        var _f = (0, $4cf25e58c00f7601$export$8d051b38c9118094)((0, $bfc72234dd195a09$export$b29f828819edca8d)(resolvedActions, (0, $bfc72234dd195a09$export$37dc2eda56cb25a5)), 2), raisedEvents = _f[0], nonRaisedActions = _f[1];
        var invokeActions = resolvedActions.filter(function(action) {
            var _a;
            return action.type === (0, $201d8d6869df8176$export$b3571188c770cc5a) && ((_a = action.activity) === null || _a === void 0 ? void 0 : _a.type) === (0, $201d8d6869df8176$export$468cda29b159ee5d);
        });
        var children = invokeActions.reduce(function(acc, action) {
            acc[action.activity.id] = (0, $57d5321825fc99ce$export$78b4a98dcb5ac328)(action.activity, _this.machine, updatedContext, _event);
            return acc;
        }, currentState ? (0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, currentState.children) : {});
        var nextState = new (0, $9f85080534c7efcc$export$7254cc27399e90bd)({
            value: resolvedStateValue || currentState.value,
            context: updatedContext,
            _event: _event,
            // Persist _sessionid between states
            _sessionid: currentState ? currentState._sessionid : null,
            historyValue: resolvedStateValue ? historyValue ? (0, $bfc72234dd195a09$export$240d7cdd99ccb95a)(historyValue, resolvedStateValue) : undefined : currentState ? currentState.historyValue : undefined,
            history: !resolvedStateValue || stateTransition.source ? currentState : undefined,
            actions: resolvedStateValue ? nonRaisedActions : [],
            activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
            events: [],
            configuration: resolvedConfiguration,
            transitions: stateTransition.transitions,
            children: children,
            done: isDone,
            tags: (0, $8ab3728758ad7bb1$export$5301196121335ca0)(resolvedConfiguration),
            machine: this
        });
        var didUpdateContext = context !== updatedContext;
        nextState.changed = _event.name === (0, $201d8d6869df8176$export$722fbec263ad908a) || didUpdateContext; // Dispose of penultimate histories to prevent memory leaks
        var history = nextState.history;
        if (history) delete history.history;
         // There are transient transitions if the machine is not in a final state
        // and if some of the state nodes have transient ("always") transitions.
        var hasAlwaysTransitions = !isDone && (this._transient || configuration.some(function(stateNode) {
            return stateNode._transient;
        })); // If there are no enabled transitions, check if there are transient transitions.
        // If there are transient transitions, continue checking for more transitions
        // because an transient transition should be triggered even if there are no
        // enabled transitions.
        //
        // If we're already working on an transient transition then stop to prevent an infinite loop.
        //
        // Otherwise, if there are no enabled nor transient transitions, we are done.
        if (!willTransition && (!hasAlwaysTransitions || _event.name === $9e78221b10855d63$var$NULL_EVENT)) return nextState;
        var maybeNextState = nextState;
        if (!isDone) {
            if (hasAlwaysTransitions) maybeNextState = this.resolveRaisedTransition(maybeNextState, {
                type: (0, $201d8d6869df8176$export$9477ceca5dcd796a)
            }, _event, predictableExec);
            while(raisedEvents.length){
                var raisedEvent = raisedEvents.shift();
                maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event, predictableExec);
            }
        } // Detect if state changed
        var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !(0, $9f85080534c7efcc$export$3a6d15eeb5fb214c)(maybeNextState.value, history.value) : undefined);
        maybeNextState.changed = changed; // Preserve original history after raised events
        maybeNextState.history = history;
        return maybeNextState;
    };
    /**
   * Returns the child state node from its relative `stateKey`, or throws.
   */ StateNode.prototype.getStateNode = function(stateKey) {
        if ($9e78221b10855d63$var$isStateId(stateKey)) return this.machine.getStateNodeById(stateKey);
        if (!this.states) throw new Error("Unable to retrieve child state '".concat(stateKey, "' from '").concat(this.id, "'; no child states exist."));
        var result = this.states[stateKey];
        if (!result) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return result;
    };
    /**
   * Returns the state node with the given `stateId`, or throws.
   *
   * @param stateId The state ID. The prefix "#" is removed.
   */ StateNode.prototype.getStateNodeById = function(stateId) {
        var resolvedStateId = $9e78221b10855d63$var$isStateId(stateId) ? stateId.slice($9e78221b10855d63$var$STATE_IDENTIFIER.length) : stateId;
        if (resolvedStateId === this.id) return this;
        var stateNode = this.machine.idMap[resolvedStateId];
        if (!stateNode) throw new Error("Child state node '#".concat(resolvedStateId, "' does not exist on machine '").concat(this.id, "'"));
        return stateNode;
    };
    /**
   * Returns the relative state node from the given `statePath`, or throws.
   *
   * @param statePath The string or string array relative path to the state node.
   */ StateNode.prototype.getStateNodeByPath = function(statePath) {
        if (typeof statePath === "string" && $9e78221b10855d63$var$isStateId(statePath)) try {
            return this.getStateNodeById(statePath.slice(1));
        } catch (e) {
        // throw e;
        }
        var arrayStatePath = (0, $bfc72234dd195a09$export$304cde62ecda7af8)(statePath, this.delimiter).slice();
        var currentStateNode = this;
        while(arrayStatePath.length){
            var key = arrayStatePath.shift();
            if (!key.length) break;
            currentStateNode = currentStateNode.getStateNode(key);
        }
        return currentStateNode;
    };
    /**
   * Resolves a partial state value with its full representation in this machine.
   *
   * @param stateValue The partial state value to resolve.
   */ StateNode.prototype.resolve = function(stateValue) {
        var _a;
        var _this = this;
        if (!stateValue) return this.initialStateValue || $9e78221b10855d63$var$EMPTY_OBJECT; // TODO: type-specific properties
        switch(this.type){
            case "parallel":
                return (0, $bfc72234dd195a09$export$825e789796ab7275)(this.initialStateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : $9e78221b10855d63$var$EMPTY_OBJECT;
                });
            case "compound":
                if ((0, $bfc72234dd195a09$export$844ec244b1367d54)(stateValue)) {
                    var subStateNode = this.getStateNode(stateValue);
                    if (subStateNode.type === "parallel" || subStateNode.type === "compound") return _a = {}, _a[stateValue] = subStateNode.initialStateValue, _a;
                    return stateValue;
                }
                if (!Object.keys(stateValue).length) return this.initialStateValue || {};
                return (0, $bfc72234dd195a09$export$825e789796ab7275)(stateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : $9e78221b10855d63$var$EMPTY_OBJECT;
                });
            default:
                return stateValue || $9e78221b10855d63$var$EMPTY_OBJECT;
        }
    };
    StateNode.prototype.getResolvedPath = function(stateIdentifier) {
        if ($9e78221b10855d63$var$isStateId(stateIdentifier)) {
            var stateNode = this.machine.idMap[stateIdentifier.slice($9e78221b10855d63$var$STATE_IDENTIFIER.length)];
            if (!stateNode) throw new Error("Unable to find state node '".concat(stateIdentifier, "'"));
            return stateNode.path;
        }
        return (0, $bfc72234dd195a09$export$304cde62ecda7af8)(stateIdentifier, this.delimiter);
    };
    Object.defineProperty(StateNode.prototype, "initialStateValue", {
        get: function() {
            var _a;
            if (this.__cache.initialStateValue) return this.__cache.initialStateValue;
            var initialStateValue;
            if (this.type === "parallel") initialStateValue = (0, $bfc72234dd195a09$export$2d4204fe9b34204e)(this.states, function(state) {
                return state.initialStateValue || $9e78221b10855d63$var$EMPTY_OBJECT;
            }, function(stateNode) {
                return !(stateNode.type === "history");
            });
            else if (this.initial !== undefined) {
                if (!this.states[this.initial]) throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
                initialStateValue = (0, $8ab3728758ad7bb1$export$335db82b86111fd1)(this.states[this.initial]) ? this.initial : (_a = {}, _a[this.initial] = this.states[this.initial].initialStateValue, _a);
            } else // The finite state value of a machine without child states is just an empty object
            initialStateValue = {};
            this.__cache.initialStateValue = initialStateValue;
            return this.__cache.initialStateValue;
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getInitialState = function(stateValue, context) {
        this._init(); // TODO: this should be in the constructor (see note in constructor)
        var configuration = this.getStateNodes(stateValue);
        return this.resolveTransition({
            configuration: configuration,
            exitSet: [],
            transitions: [],
            source: undefined,
            actions: []
        }, undefined, context !== null && context !== void 0 ? context : this.machine.context, undefined);
    };
    Object.defineProperty(StateNode.prototype, "initialState", {
        /**
     * The initial State instance, which includes all actions to be executed from
     * entering the initial state.
     */ get: function() {
            var initialStateValue = this.initialStateValue;
            if (!initialStateValue) throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
            return this.getInitialState(initialStateValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "target", {
        /**
     * The target state value of the history state node, if it exists. This represents the
     * default state value to transition to if no history value exists yet.
     */ get: function() {
            var target;
            if (this.type === "history") {
                var historyConfig = this.config;
                if ((0, $bfc72234dd195a09$export$844ec244b1367d54)(historyConfig.target)) target = $9e78221b10855d63$var$isStateId(historyConfig.target) ? (0, $bfc72234dd195a09$export$f2ee84fc53c45e74)(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
                else target = historyConfig.target;
            }
            return target;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Returns the leaf nodes from a state path relative to this state node.
   *
   * @param relativeStateId The relative state path to retrieve the state nodes
   * @param history The previous state to retrieve history
   * @param resolve Whether state nodes should resolve to initial child state nodes
   */ StateNode.prototype.getRelativeStateNodes = function(relativeStateId, historyValue, resolve) {
        if (resolve === void 0) resolve = true;
        return resolve ? relativeStateId.type === "history" ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [
            relativeStateId
        ];
    };
    Object.defineProperty(StateNode.prototype, "initialStateNodes", {
        get: function() {
            var _this = this;
            if ((0, $8ab3728758ad7bb1$export$335db82b86111fd1)(this)) return [
                this
            ];
             // Case when state node is compound but no initial state is defined
            if (this.type === "compound" && !this.initial) {
                if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) (0, $bfc72234dd195a09$export$c106dd0671a0fc2d)(false, "Compound state node '".concat(this.id, "' has no initial state."));
                return [
                    this
                ];
            }
            var initialStateNodePaths = (0, $bfc72234dd195a09$export$a2618e9e89698dd6)(this.initialStateValue);
            return (0, $bfc72234dd195a09$export$bffa455ba8c619a6)(initialStateNodePaths.map(function(initialPath) {
                return _this.getFromRelativePath(initialPath);
            }));
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Retrieves state nodes from a relative path to this state node.
   *
   * @param relativePath The relative path from this state node
   * @param historyValue
   */ StateNode.prototype.getFromRelativePath = function(relativePath) {
        if (!relativePath.length) return [
            this
        ];
        var _a = (0, $4cf25e58c00f7601$export$8d051b38c9118094)(relativePath), stateKey = _a[0], childStatePath = _a.slice(1);
        if (!this.states) throw new Error("Cannot retrieve subPath '".concat(stateKey, "' from node with no states"));
        var childStateNode = this.getStateNode(stateKey);
        if (childStateNode.type === "history") return childStateNode.resolveHistory();
        if (!this.states[stateKey]) throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
        return this.states[stateKey].getFromRelativePath(childStatePath);
    };
    StateNode.prototype.historyValue = function(relativeStateValue) {
        if (!Object.keys(this.states).length) return undefined;
        return {
            current: relativeStateValue || this.initialStateValue,
            states: (0, $bfc72234dd195a09$export$2d4204fe9b34204e)(this.states, function(stateNode, key) {
                if (!relativeStateValue) return stateNode.historyValue();
                var subStateValue = (0, $bfc72234dd195a09$export$844ec244b1367d54)(relativeStateValue) ? undefined : relativeStateValue[key];
                return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
            }, function(stateNode) {
                return !stateNode.history;
            })
        };
    };
    /**
   * Resolves to the historical value(s) of the parent state node,
   * represented by state nodes.
   *
   * @param historyValue
   */ StateNode.prototype.resolveHistory = function(historyValue) {
        var _this = this;
        if (this.type !== "history") return [
            this
        ];
        var parent = this.parent;
        if (!historyValue) {
            var historyTarget = this.target;
            return historyTarget ? (0, $bfc72234dd195a09$export$bffa455ba8c619a6)((0, $bfc72234dd195a09$export$a2618e9e89698dd6)(historyTarget).map(function(relativeChildPath) {
                return parent.getFromRelativePath(relativeChildPath);
            })) : parent.initialStateNodes;
        }
        var subHistoryValue = (0, $bfc72234dd195a09$export$314d0a1a7c835392)(parent.path, "states")(historyValue).current;
        if ((0, $bfc72234dd195a09$export$844ec244b1367d54)(subHistoryValue)) return [
            parent.getStateNode(subHistoryValue)
        ];
        return (0, $bfc72234dd195a09$export$bffa455ba8c619a6)((0, $bfc72234dd195a09$export$a2618e9e89698dd6)(subHistoryValue).map(function(subStatePath) {
            return _this.history === "deep" ? parent.getFromRelativePath(subStatePath) : [
                parent.states[subStatePath[0]]
            ];
        }));
    };
    Object.defineProperty(StateNode.prototype, "stateIds", {
        /**
     * All the state node IDs of this state node and its descendant state nodes.
     */ get: function() {
            var _this = this;
            var childStateIds = (0, $bfc72234dd195a09$export$bffa455ba8c619a6)(Object.keys(this.states).map(function(stateKey) {
                return _this.states[stateKey].stateIds;
            }));
            return [
                this.id
            ].concat(childStateIds);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "events", {
        /**
     * All the event types accepted by this state node and its descendants.
     */ get: function() {
            var e_8, _a, e_9, _b;
            if (this.__cache.events) return this.__cache.events;
            var states = this.states;
            var events = new Set(this.ownEvents);
            if (states) try {
                for(var _c = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(Object.keys(states)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var stateId = _d.value;
                    var state = states[stateId];
                    if (state.states) try {
                        for(var _e = (e_9 = void 0, (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(state.events)), _f = _e.next(); !_f.done; _f = _e.next()){
                            var event_1 = _f.value;
                            events.add("".concat(event_1));
                        }
                    } catch (e_9_1) {
                        e_9 = {
                            error: e_9_1
                        };
                    } finally{
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        } finally{
                            if (e_9) throw e_9.error;
                        }
                    }
                }
            } catch (e_8_1) {
                e_8 = {
                    error: e_8_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_8) throw e_8.error;
                }
            }
            return this.__cache.events = Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "ownEvents", {
        /**
     * All the events that have transitions directly from this state node.
     *
     * Excludes any inert events.
     */ get: function() {
            var events = new Set(this.transitions.filter(function(transition) {
                return !(!transition.target && !transition.actions.length && transition.internal);
            }).map(function(transition) {
                return transition.eventType;
            }));
            return Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.resolveTarget = function(_target) {
        var _this = this;
        if (_target === undefined) // an undefined target signals that the state node should not transition from that state when receiving that event
        return undefined;
        return _target.map(function(target) {
            if (!(0, $bfc72234dd195a09$export$844ec244b1367d54)(target)) return target;
            var isInternalTarget = target[0] === _this.delimiter; // If internal target is defined on machine,
            // do not include machine key on target
            if (isInternalTarget && !_this.parent) return _this.getStateNodeByPath(target.slice(1));
            var resolvedTarget = isInternalTarget ? _this.key + target : target;
            if (_this.parent) try {
                var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);
                return targetStateNode;
            } catch (err) {
                throw new Error("Invalid transition definition for state node '".concat(_this.id, "':\n").concat(err.message));
            }
            else return _this.getStateNodeByPath(resolvedTarget);
        });
    };
    StateNode.prototype.formatTransition = function(transitionConfig) {
        var _this = this;
        var normalizedTarget = (0, $bfc72234dd195a09$export$2a4fe5c3c80e3288)(transitionConfig.target);
        var internal = "internal" in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function(_target) {
            return (0, $bfc72234dd195a09$export$844ec244b1367d54)(_target) && _target[0] === _this.delimiter;
        }) : true;
        var guards = this.machine.options.guards;
        var target = this.resolveTarget(normalizedTarget);
        var transition = (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, transitionConfig), {
            actions: (0, $f9b2d12db4f71f3e$export$aa68691f32e6c459)((0, $bfc72234dd195a09$export$45b10814cc054894)(transitionConfig.actions)),
            cond: (0, $bfc72234dd195a09$export$b0f5a08e0ca47933)(transitionConfig.cond, guards),
            target: target,
            source: this,
            internal: internal,
            eventType: transitionConfig.event,
            toJSON: function() {
                return (0, $4cf25e58c00f7601$export$18ce0697a983be9b)((0, $4cf25e58c00f7601$export$18ce0697a983be9b)({}, transition), {
                    target: transition.target ? transition.target.map(function(t) {
                        return "#".concat(t.id);
                    }) : undefined,
                    source: "#".concat(_this.id)
                });
            }
        });
        return transition;
    };
    StateNode.prototype.formatTransitions = function() {
        var e_10, _a;
        var _this = this;
        var onConfig;
        if (!this.config.on) onConfig = [];
        else if (Array.isArray(this.config.on)) onConfig = this.config.on;
        else {
            var _b = this.config.on, _c = $9e78221b10855d63$var$WILDCARD, _d = _b[_c], wildcardConfigs = _d === void 0 ? [] : _d, strictTransitionConfigs_1 = (0, $4cf25e58c00f7601$export$3c9a16f847548506)(_b, [
                typeof _c === "symbol" ? _c : _c + ""
            ]);
            onConfig = (0, $bfc72234dd195a09$export$bffa455ba8c619a6)(Object.keys(strictTransitionConfigs_1).map(function(key) {
                if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571) && key === $9e78221b10855d63$var$NULL_EVENT) (0, $bfc72234dd195a09$export$c106dd0671a0fc2d)(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + 'Please check the `on` configuration for "#'.concat(_this.id, '".'));
                var transitionConfigArray = (0, $bfc72234dd195a09$export$3822a36ea084a4d5)(key, strictTransitionConfigs_1[key]);
                if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) $9e78221b10855d63$var$validateArrayifiedTransitions(_this, key, transitionConfigArray);
                return transitionConfigArray;
            }).concat((0, $bfc72234dd195a09$export$3822a36ea084a4d5)($9e78221b10855d63$var$WILDCARD, wildcardConfigs)));
        }
        var eventlessConfig = this.config.always ? (0, $bfc72234dd195a09$export$3822a36ea084a4d5)("", this.config.always) : [];
        var doneConfig = this.config.onDone ? (0, $bfc72234dd195a09$export$3822a36ea084a4d5)(String((0, $f9b2d12db4f71f3e$export$3df11c9c20e7b288)(this.id)), this.config.onDone) : [];
        if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571)) (0, $bfc72234dd195a09$export$c106dd0671a0fc2d)(!(this.config.onDone && !this.parent), 'Root nodes cannot have an ".onDone" transition. Please check the config of "'.concat(this.id, '".'));
        var invokeConfig = (0, $bfc72234dd195a09$export$bffa455ba8c619a6)(this.invoke.map(function(invokeDef) {
            var settleTransitions = [];
            if (invokeDef.onDone) settleTransitions.push.apply(settleTransitions, (0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)((0, $bfc72234dd195a09$export$3822a36ea084a4d5)(String((0, $f9b2d12db4f71f3e$export$c105e588793f70b4)(invokeDef.id)), invokeDef.onDone)), false));
            if (invokeDef.onError) settleTransitions.push.apply(settleTransitions, (0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)((0, $bfc72234dd195a09$export$3822a36ea084a4d5)(String((0, $f9b2d12db4f71f3e$export$a3bc9b8ed74fc)(invokeDef.id)), invokeDef.onError)), false));
            return settleTransitions;
        }));
        var delayedTransitions = this.after;
        var formattedTransitions = (0, $bfc72234dd195a09$export$bffa455ba8c619a6)((0, $4cf25e58c00f7601$export$1216008129fb82ed)((0, $4cf25e58c00f7601$export$1216008129fb82ed)((0, $4cf25e58c00f7601$export$1216008129fb82ed)((0, $4cf25e58c00f7601$export$1216008129fb82ed)([], (0, $4cf25e58c00f7601$export$8d051b38c9118094)(doneConfig), false), (0, $4cf25e58c00f7601$export$8d051b38c9118094)(invokeConfig), false), (0, $4cf25e58c00f7601$export$8d051b38c9118094)(onConfig), false), (0, $4cf25e58c00f7601$export$8d051b38c9118094)(eventlessConfig), false).map(function(transitionConfig) {
            return (0, $bfc72234dd195a09$export$45b10814cc054894)(transitionConfig).map(function(transition) {
                return _this.formatTransition(transition);
            });
        }));
        try {
            for(var delayedTransitions_1 = (0, $4cf25e58c00f7601$export$19a8beecd37a4c45)(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()){
                var delayedTransition = delayedTransitions_1_1.value;
                formattedTransitions.push(delayedTransition);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a = delayedTransitions_1.return)) _a.call(delayedTransitions_1);
            } finally{
                if (e_10) throw e_10.error;
            }
        }
        return formattedTransitions;
    };
    return StateNode;
}();



var $66ceff3818583d23$var$warned = false;
function $66ceff3818583d23$export$f391db14ff2d9279(config, options, initialContext) {
    if (initialContext === void 0) initialContext = config.context;
    return new (0, $9e78221b10855d63$export$342f24f5edd47b1)(config, options, initialContext);
}
function $66ceff3818583d23$export$aaa7fa18f8e9b2e8(config, options) {
    if (!(0, $60fd28bf0891da6e$export$9b5f2e1c20ef6571) && !("predictableActionArguments" in config) && !$66ceff3818583d23$var$warned) {
        $66ceff3818583d23$var$warned = true;
        console.warn("It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html");
    }
    return new (0, $9e78221b10855d63$export$342f24f5edd47b1)(config, options);
}










var $54ea967ad60a4c8d$export$e6e34fd1f2686227 = (0, $f9b2d12db4f71f3e$export$e6e34fd1f2686227), $54ea967ad60a4c8d$export$70b61ad426ddbe54 = (0, $f9b2d12db4f71f3e$export$70b61ad426ddbe54), $54ea967ad60a4c8d$export$89db4734f6c919c4 = (0, $f9b2d12db4f71f3e$export$89db4734f6c919c4), $54ea967ad60a4c8d$export$daa976aaff721e41 = (0, $f9b2d12db4f71f3e$export$daa976aaff721e41), $54ea967ad60a4c8d$export$408d8d51fa351f53 = (0, $f9b2d12db4f71f3e$export$408d8d51fa351f53), $54ea967ad60a4c8d$export$7f8b724299523eb6 = (0, $f9b2d12db4f71f3e$export$7f8b724299523eb6), $54ea967ad60a4c8d$export$eb147b7589db8e8a = (0, $f9b2d12db4f71f3e$export$eb147b7589db8e8a), $54ea967ad60a4c8d$export$c105e588793f70b4 = (0, $f9b2d12db4f71f3e$export$c105e588793f70b4), $54ea967ad60a4c8d$export$66313c302b2ea154 = (0, $f9b2d12db4f71f3e$export$66313c302b2ea154), $54ea967ad60a4c8d$export$bef1f36f5486a6a3 = (0, $f9b2d12db4f71f3e$export$bef1f36f5486a6a3), $54ea967ad60a4c8d$export$48ec4a2b1cfc6557 = (0, $f9b2d12db4f71f3e$export$48ec4a2b1cfc6557), $54ea967ad60a4c8d$export$7877a478dd30fd3d = (0, $f9b2d12db4f71f3e$export$7877a478dd30fd3d), $54ea967ad60a4c8d$export$fa6813432f753b0d = (0, $f9b2d12db4f71f3e$export$fa6813432f753b0d);











const $48c93fa42a87ef95$export$a51e8cda1526c737 = [
    "+1",
    "+7",
    "+20",
    "+27",
    "+30",
    "+31",
    "+32",
    "+33",
    "+34",
    "+36",
    "+39",
    "+40",
    "+41",
    "+43",
    "+44",
    "+45",
    "+46",
    "+47",
    "+48",
    "+49",
    "+51",
    "+52",
    "+53",
    "+54",
    "+55",
    "+56",
    "+57",
    "+58",
    "+60",
    "+61",
    "+62",
    "+63",
    "+64",
    "+65",
    "+66",
    "+81",
    "+82",
    "+84",
    "+86",
    "+90",
    "+91",
    "+92",
    "+93",
    "+94",
    "+95",
    "+98",
    "+212",
    "+213",
    "+216",
    "+218",
    "+220",
    "+221",
    "+222",
    "+223",
    "+224",
    "+225",
    "+226",
    "+227",
    "+228",
    "+229",
    "+230",
    "+231",
    "+232",
    "+233",
    "+234",
    "+235",
    "+236",
    "+237",
    "+238",
    "+239",
    "+240",
    "+241",
    "+242",
    "+243",
    "+244",
    "+245",
    "+246",
    "+248",
    "+249",
    "+250",
    "+251",
    "+252",
    "+253",
    "+254",
    "+255",
    "+256",
    "+257",
    "+258",
    "+260",
    "+261",
    "+262",
    "+263",
    "+264",
    "+265",
    "+266",
    "+267",
    "+268",
    "+269",
    "+290",
    "+291",
    "+297",
    "+298",
    "+299",
    "+345",
    "+350",
    "+351",
    "+352",
    "+353",
    "+354",
    "+355",
    "+356",
    "+357",
    "+358",
    "+359",
    "+370",
    "+371",
    "+372",
    "+373",
    "+374",
    "+375",
    "+376",
    "+377",
    "+378",
    "+379",
    "+380",
    "+381",
    "+382",
    "+385",
    "+386",
    "+387",
    "+389",
    "+420",
    "+421",
    "+423",
    "+500",
    "+501",
    "+502",
    "+503",
    "+504",
    "+505",
    "+506",
    "+507",
    "+508",
    "+509",
    "+537",
    "+590",
    "+591",
    "+593",
    "+594",
    "+595",
    "+596",
    "+597",
    "+598",
    "+599",
    "+670",
    "+672",
    "+673",
    "+674",
    "+675",
    "+676",
    "+677",
    "+678",
    "+679",
    "+680",
    "+681",
    "+682",
    "+683",
    "+685",
    "+686",
    "+687",
    "+688",
    "+689",
    "+690",
    "+691",
    "+692",
    "+850",
    "+852",
    "+853",
    "+855",
    "+856",
    "+872",
    "+880",
    "+886",
    "+960",
    "+961",
    "+962",
    "+963",
    "+964",
    "+965",
    "+966",
    "+967",
    "+968",
    "+970",
    "+971",
    "+972",
    "+973",
    "+974",
    "+975",
    "+976",
    "+977",
    "+992",
    "+993",
    "+994",
    "+995",
    "+996",
    "+998"
];



/**
 * This file contains helpers related to forms and input attributes.
 */ const $25b29aa90ff40796$export$1222d357a3c2c47f = {
    birthdate: {
        label: "Birthdate",
        placeholder: "Enter your Birthdate",
        type: "date",
        autocomplete: "bday",
        isRequired: true
    },
    confirmation_code: {
        label: "Confirmation Code",
        placeholder: "Enter your Confirmation Code",
        type: "text",
        autocomplete: "one-time-code",
        isRequired: true
    },
    confirm_password: {
        label: "Confirm Password",
        placeholder: "Please confirm your Password",
        type: "password",
        autocomplete: "new-password",
        isRequired: true
    },
    email: {
        label: "Email",
        placeholder: "Enter your Email",
        type: "email",
        autocomplete: "username",
        isRequired: true
    },
    family_name: {
        label: "Family Name",
        placeholder: "Enter your Family Name",
        type: "text",
        autocomplete: "family-name",
        isRequired: true
    },
    given_name: {
        label: "Given Name",
        placeholder: "Enter your Given Name",
        type: "text",
        autocomplete: "given-name",
        isRequired: true
    },
    middle_name: {
        label: "Middle Name",
        placeholder: "Enter your Middle Name",
        type: "text",
        autocomplete: "additional-name",
        isRequired: true
    },
    name: {
        label: "Name",
        placeholder: "Enter your Name",
        type: "text",
        autocomplete: "name",
        isRequired: true
    },
    nickname: {
        label: "Nickname",
        placeholder: "Enter your Nickname",
        type: "text",
        autocomplete: "tel",
        isRequired: true
    },
    password: {
        label: "Password",
        placeholder: "Enter your Password",
        type: "password",
        autocomplete: "new-password",
        isRequired: true
    },
    phone_number: {
        label: "Phone Number",
        placeholder: "Enter your Phone Number",
        type: "tel",
        autocomplete: "tel",
        dialCode: "+1",
        dialCodeList: (0, $48c93fa42a87ef95$export$a51e8cda1526c737),
        isRequired: true
    },
    preferred_username: {
        label: "Preferred Username",
        placeholder: "Enter your Preferred Username",
        type: "text",
        isRequired: true
    },
    profile: {
        label: "Profile",
        placeholder: "Add your Profile",
        type: "url",
        autocomplete: "url",
        isRequired: true
    },
    website: {
        label: "Website",
        placeholder: "Add your Website",
        type: "url",
        autocomplete: "url",
        isRequired: true
    },
    username: {
        label: "Username",
        placeholder: "Enter your Username",
        type: "text",
        autocomplete: "username",
        isRequired: true
    }
};
/**
 * List of special characters that Cognito allows.
 *
 * Adapted from https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
 */ // prettier-ignore
const $25b29aa90ff40796$export$4223938282102ea7 = [
    "^",
    "$",
    "*",
    ".",
    "[",
    "]",
    "{",
    "}",
    "(",
    ")",
    "?",
    '"',
    "!",
    "@",
    "#",
    "%",
    "&",
    "/",
    "\\",
    ",",
    ">",
    "<",
    "'",
    ":",
    ";",
    "|",
    "_",
    "~",
    "`",
    "=",
    "+",
    "-",
    " "
];
/**
 * Email validation regex
 *
 * source: HTML5 spec https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
 */ const $25b29aa90ff40796$export$976c37132e9c6a10 = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
/**
+ * map navigable route keys to auth event names
+ */ const $25b29aa90ff40796$export$7ccc20c5f9bc8a70 = {
    forgotPassword: "FORGOT_PASSWORD",
    signIn: "SIGN_IN",
    signUp: "SIGN_UP"
};


// replaces all characters in a string with '*', except for the first and last char
const $3bd7d334512b2bcd$export$655775443891f2b8 = (value)=>{
    const split = value.trim().split("");
    for(let i = 0; i < split.length; i++)if (i > 0 && i < split.length - 1) split[i] = "*";
    return split.join("");
};
// censors all but the last four characters of a phone number
const $3bd7d334512b2bcd$export$72b2b64445441bf7 = (val)=>{
    if (val.length < 4) return val;
    const split = val.split("");
    for(let i = 0; i < split.length - 4; i++)split[i] = "*";
    return split.join("");
};
const $3bd7d334512b2bcd$export$1ec93875315f071d = (password)=>(0, $25b29aa90ff40796$export$4223938282102ea7).some((char)=>password.includes(char));
const $3bd7d334512b2bcd$export$f1f323074be5cac0 = (issuer, username, secret)=>encodeURI(`otpauth://totp/${issuer}:${username}?secret=${secret}&issuer=${issuer}`);
function $3bd7d334512b2bcd$export$205c000fb676adf6(values, ...ignored) {
    return Object.entries(values).reduce((acc, [name, value])=>({
            ...acc,
            [name]: ignored.includes(name) ? value : value?.trim()
        }), {});
}
const $3bd7d334512b2bcd$export$371e338370561054 = (value)=>{
    if (!value) return false;
    return (0, $25b29aa90ff40796$export$976c37132e9c6a10).test(value);
};




var $7608d14a9cea7e55$exports = {};
var $a76fdaeea17a0bf1$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $a76fdaeea17a0bf1$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$a76fdaeea17a0bf1$exports = $a76fdaeea17a0bf1$var$arrayMap;


var $381dbab245c93f61$exports = {};
var $00554a9c69f6d8dc$exports = {};
var $2f47a2a76adfcc0c$exports = {};
var $86017fac3b58a763$exports = {};
var $0b7ee66329b5ea90$exports = {};
var $4277868280d24097$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $4277868280d24097$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$4277868280d24097$exports = $4277868280d24097$var$listCacheClear;


var $7d5e8e1562f02a5b$exports = {};
var $8d6aff9dfc4c86da$exports = {};
var $69a6288411d50f7e$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $69a6288411d50f7e$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$69a6288411d50f7e$exports = $69a6288411d50f7e$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $8d6aff9dfc4c86da$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($69a6288411d50f7e$exports(array[length][0], key)) return length;
    }
    return -1;
}
$8d6aff9dfc4c86da$exports = $8d6aff9dfc4c86da$var$assocIndexOf;


/** Used for built-in method references. */ var $7d5e8e1562f02a5b$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $7d5e8e1562f02a5b$var$splice = $7d5e8e1562f02a5b$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7d5e8e1562f02a5b$var$listCacheDelete(key) {
    var data = this.__data__, index = $8d6aff9dfc4c86da$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $7d5e8e1562f02a5b$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$7d5e8e1562f02a5b$exports = $7d5e8e1562f02a5b$var$listCacheDelete;


var $a8dce9d30e8d1f88$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a8dce9d30e8d1f88$var$listCacheGet(key) {
    var data = this.__data__, index = $8d6aff9dfc4c86da$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$a8dce9d30e8d1f88$exports = $a8dce9d30e8d1f88$var$listCacheGet;


var $fd40c6651b6bc77f$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fd40c6651b6bc77f$var$listCacheHas(key) {
    return $8d6aff9dfc4c86da$exports(this.__data__, key) > -1;
}
$fd40c6651b6bc77f$exports = $fd40c6651b6bc77f$var$listCacheHas;


var $3cfbb1f38630fc43$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $3cfbb1f38630fc43$var$listCacheSet(key, value) {
    var data = this.__data__, index = $8d6aff9dfc4c86da$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$3cfbb1f38630fc43$exports = $3cfbb1f38630fc43$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0b7ee66329b5ea90$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$0b7ee66329b5ea90$var$ListCache.prototype.clear = $4277868280d24097$exports;
$0b7ee66329b5ea90$var$ListCache.prototype["delete"] = $7d5e8e1562f02a5b$exports;
$0b7ee66329b5ea90$var$ListCache.prototype.get = $a8dce9d30e8d1f88$exports;
$0b7ee66329b5ea90$var$ListCache.prototype.has = $fd40c6651b6bc77f$exports;
$0b7ee66329b5ea90$var$ListCache.prototype.set = $3cfbb1f38630fc43$exports;
$0b7ee66329b5ea90$exports = $0b7ee66329b5ea90$var$ListCache;


var $6eae15e42a140b03$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $6eae15e42a140b03$var$stackClear() {
    this.__data__ = new $0b7ee66329b5ea90$exports;
    this.size = 0;
}
$6eae15e42a140b03$exports = $6eae15e42a140b03$var$stackClear;


var $2e8de8e1a89f2a29$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2e8de8e1a89f2a29$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$2e8de8e1a89f2a29$exports = $2e8de8e1a89f2a29$var$stackDelete;


var $364fbc9f64e6d44d$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $364fbc9f64e6d44d$var$stackGet(key) {
    return this.__data__.get(key);
}
$364fbc9f64e6d44d$exports = $364fbc9f64e6d44d$var$stackGet;


var $fe24b4ae9659dbc2$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fe24b4ae9659dbc2$var$stackHas(key) {
    return this.__data__.has(key);
}
$fe24b4ae9659dbc2$exports = $fe24b4ae9659dbc2$var$stackHas;


var $895fcf617b208138$exports = {};

var $360fd4b3be530280$exports = {};
var $64956676ecb25347$exports = {};
var $c98a110822b96ea1$exports = {};
var $42795a6abdb31608$exports = {};
var $3699efeb64f9313e$exports = {};
var $f47d208f8f64d4b7$exports = {};

var $fqPbb = parcelRequire("fqPbb");
/** Built-in value references. */ var $f47d208f8f64d4b7$var$Symbol = $fqPbb.Symbol;
$f47d208f8f64d4b7$exports = $f47d208f8f64d4b7$var$Symbol;


var $68a668fcfaee0792$exports = {};

/** Used for built-in method references. */ var $68a668fcfaee0792$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $68a668fcfaee0792$var$hasOwnProperty = $68a668fcfaee0792$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $68a668fcfaee0792$var$nativeObjectToString = $68a668fcfaee0792$var$objectProto.toString;
/** Built-in value references. */ var $68a668fcfaee0792$var$symToStringTag = $f47d208f8f64d4b7$exports ? $f47d208f8f64d4b7$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $68a668fcfaee0792$var$getRawTag(value) {
    var isOwn = $68a668fcfaee0792$var$hasOwnProperty.call(value, $68a668fcfaee0792$var$symToStringTag), tag = value[$68a668fcfaee0792$var$symToStringTag];
    try {
        value[$68a668fcfaee0792$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $68a668fcfaee0792$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$68a668fcfaee0792$var$symToStringTag] = tag;
        else delete value[$68a668fcfaee0792$var$symToStringTag];
    }
    return result;
}
$68a668fcfaee0792$exports = $68a668fcfaee0792$var$getRawTag;


var $f9546df8ac84cb11$exports = {};
/** Used for built-in method references. */ var $f9546df8ac84cb11$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f9546df8ac84cb11$var$nativeObjectToString = $f9546df8ac84cb11$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $f9546df8ac84cb11$var$objectToString(value) {
    return $f9546df8ac84cb11$var$nativeObjectToString.call(value);
}
$f9546df8ac84cb11$exports = $f9546df8ac84cb11$var$objectToString;


/** `Object#toString` result references. */ var $3699efeb64f9313e$var$nullTag = "[object Null]", $3699efeb64f9313e$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $3699efeb64f9313e$var$symToStringTag = $f47d208f8f64d4b7$exports ? $f47d208f8f64d4b7$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $3699efeb64f9313e$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $3699efeb64f9313e$var$undefinedTag : $3699efeb64f9313e$var$nullTag;
    return $3699efeb64f9313e$var$symToStringTag && $3699efeb64f9313e$var$symToStringTag in Object(value) ? $68a668fcfaee0792$exports(value) : $f9546df8ac84cb11$exports(value);
}
$3699efeb64f9313e$exports = $3699efeb64f9313e$var$baseGetTag;


var $6f2119b160786e16$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $6f2119b160786e16$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$6f2119b160786e16$exports = $6f2119b160786e16$var$isObject;


/** `Object#toString` result references. */ var $42795a6abdb31608$var$asyncTag = "[object AsyncFunction]", $42795a6abdb31608$var$funcTag = "[object Function]", $42795a6abdb31608$var$genTag = "[object GeneratorFunction]", $42795a6abdb31608$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $42795a6abdb31608$var$isFunction(value) {
    if (!$6f2119b160786e16$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $3699efeb64f9313e$exports(value);
    return tag == $42795a6abdb31608$var$funcTag || tag == $42795a6abdb31608$var$genTag || tag == $42795a6abdb31608$var$asyncTag || tag == $42795a6abdb31608$var$proxyTag;
}
$42795a6abdb31608$exports = $42795a6abdb31608$var$isFunction;


var $a78e583db5b60423$exports = {};
var $8be4b4e1fd6f3d8a$exports = {};

var $fqPbb = parcelRequire("fqPbb");
/** Used to detect overreaching core-js shims. */ var $8be4b4e1fd6f3d8a$var$coreJsData = $fqPbb["__core-js_shared__"];
$8be4b4e1fd6f3d8a$exports = $8be4b4e1fd6f3d8a$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $a78e583db5b60423$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($8be4b4e1fd6f3d8a$exports && $8be4b4e1fd6f3d8a$exports.keys && $8be4b4e1fd6f3d8a$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $a78e583db5b60423$var$isMasked(func) {
    return !!$a78e583db5b60423$var$maskSrcKey && $a78e583db5b60423$var$maskSrcKey in func;
}
$a78e583db5b60423$exports = $a78e583db5b60423$var$isMasked;



var $0974c06596c50cf8$exports = {};
/** Used for built-in method references. */ var $0974c06596c50cf8$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $0974c06596c50cf8$var$funcToString = $0974c06596c50cf8$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $0974c06596c50cf8$var$toSource(func) {
    if (func != null) {
        try {
            return $0974c06596c50cf8$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$0974c06596c50cf8$exports = $0974c06596c50cf8$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $c98a110822b96ea1$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $c98a110822b96ea1$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $c98a110822b96ea1$var$funcProto = Function.prototype, $c98a110822b96ea1$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $c98a110822b96ea1$var$funcToString = $c98a110822b96ea1$var$funcProto.toString;
/** Used to check objects for own properties. */ var $c98a110822b96ea1$var$hasOwnProperty = $c98a110822b96ea1$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $c98a110822b96ea1$var$reIsNative = RegExp("^" + $c98a110822b96ea1$var$funcToString.call($c98a110822b96ea1$var$hasOwnProperty).replace($c98a110822b96ea1$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $c98a110822b96ea1$var$baseIsNative(value) {
    if (!$6f2119b160786e16$exports(value) || $a78e583db5b60423$exports(value)) return false;
    var pattern = $42795a6abdb31608$exports(value) ? $c98a110822b96ea1$var$reIsNative : $c98a110822b96ea1$var$reIsHostCtor;
    return pattern.test($0974c06596c50cf8$exports(value));
}
$c98a110822b96ea1$exports = $c98a110822b96ea1$var$baseIsNative;


var $e9e8f3ca4655386c$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $e9e8f3ca4655386c$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$e9e8f3ca4655386c$exports = $e9e8f3ca4655386c$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $64956676ecb25347$var$getNative(object, key) {
    var value = $e9e8f3ca4655386c$exports(object, key);
    return $c98a110822b96ea1$exports(value) ? value : undefined;
}
$64956676ecb25347$exports = $64956676ecb25347$var$getNative;



var $fqPbb = parcelRequire("fqPbb");
/* Built-in method references that are verified to be native. */ var $360fd4b3be530280$var$Map = $64956676ecb25347$exports($fqPbb, "Map");
$360fd4b3be530280$exports = $360fd4b3be530280$var$Map;


var $57e0c604ba32c39b$exports = {};
var $d2d890294a0468e9$exports = {};
var $4047820d6813a27f$exports = {};
var $57a7a6c756481249$exports = {};
var $ab8212207679f98f$exports = {};

/* Built-in method references that are verified to be native. */ var $ab8212207679f98f$var$nativeCreate = $64956676ecb25347$exports(Object, "create");
$ab8212207679f98f$exports = $ab8212207679f98f$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $57a7a6c756481249$var$hashClear() {
    this.__data__ = $ab8212207679f98f$exports ? $ab8212207679f98f$exports(null) : {};
    this.size = 0;
}
$57a7a6c756481249$exports = $57a7a6c756481249$var$hashClear;


var $e5c702cbbc4880a7$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e5c702cbbc4880a7$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$e5c702cbbc4880a7$exports = $e5c702cbbc4880a7$var$hashDelete;


var $02794b854aab939a$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $02794b854aab939a$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $02794b854aab939a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $02794b854aab939a$var$hasOwnProperty = $02794b854aab939a$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $02794b854aab939a$var$hashGet(key) {
    var data = this.__data__;
    if ($ab8212207679f98f$exports) {
        var result = data[key];
        return result === $02794b854aab939a$var$HASH_UNDEFINED ? undefined : result;
    }
    return $02794b854aab939a$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$02794b854aab939a$exports = $02794b854aab939a$var$hashGet;


var $750fa6cd073beb91$exports = {};

/** Used for built-in method references. */ var $750fa6cd073beb91$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $750fa6cd073beb91$var$hasOwnProperty = $750fa6cd073beb91$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $750fa6cd073beb91$var$hashHas(key) {
    var data = this.__data__;
    return $ab8212207679f98f$exports ? data[key] !== undefined : $750fa6cd073beb91$var$hasOwnProperty.call(data, key);
}
$750fa6cd073beb91$exports = $750fa6cd073beb91$var$hashHas;


var $0b441cc124da1656$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $0b441cc124da1656$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $0b441cc124da1656$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $ab8212207679f98f$exports && value === undefined ? $0b441cc124da1656$var$HASH_UNDEFINED : value;
    return this;
}
$0b441cc124da1656$exports = $0b441cc124da1656$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4047820d6813a27f$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$4047820d6813a27f$var$Hash.prototype.clear = $57a7a6c756481249$exports;
$4047820d6813a27f$var$Hash.prototype["delete"] = $e5c702cbbc4880a7$exports;
$4047820d6813a27f$var$Hash.prototype.get = $02794b854aab939a$exports;
$4047820d6813a27f$var$Hash.prototype.has = $750fa6cd073beb91$exports;
$4047820d6813a27f$var$Hash.prototype.set = $0b441cc124da1656$exports;
$4047820d6813a27f$exports = $4047820d6813a27f$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $d2d890294a0468e9$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $4047820d6813a27f$exports,
        "map": new ($360fd4b3be530280$exports || $0b7ee66329b5ea90$exports),
        "string": new $4047820d6813a27f$exports
    };
}
$d2d890294a0468e9$exports = $d2d890294a0468e9$var$mapCacheClear;


var $ed18e47265669962$exports = {};
var $ceb37a4c299de532$exports = {};
var $67a17d06e2d4771d$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $67a17d06e2d4771d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$67a17d06e2d4771d$exports = $67a17d06e2d4771d$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $ceb37a4c299de532$var$getMapData(map, key) {
    var data = map.__data__;
    return $67a17d06e2d4771d$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$ceb37a4c299de532$exports = $ceb37a4c299de532$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ed18e47265669962$var$mapCacheDelete(key) {
    var result = $ceb37a4c299de532$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$ed18e47265669962$exports = $ed18e47265669962$var$mapCacheDelete;


var $cb234526c7d95a3f$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $cb234526c7d95a3f$var$mapCacheGet(key) {
    return $ceb37a4c299de532$exports(this, key).get(key);
}
$cb234526c7d95a3f$exports = $cb234526c7d95a3f$var$mapCacheGet;


var $72f0b25e44e2d5ae$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $72f0b25e44e2d5ae$var$mapCacheHas(key) {
    return $ceb37a4c299de532$exports(this, key).has(key);
}
$72f0b25e44e2d5ae$exports = $72f0b25e44e2d5ae$var$mapCacheHas;


var $3515bd091736a69c$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $3515bd091736a69c$var$mapCacheSet(key, value) {
    var data = $ceb37a4c299de532$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$3515bd091736a69c$exports = $3515bd091736a69c$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $57e0c604ba32c39b$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$57e0c604ba32c39b$var$MapCache.prototype.clear = $d2d890294a0468e9$exports;
$57e0c604ba32c39b$var$MapCache.prototype["delete"] = $ed18e47265669962$exports;
$57e0c604ba32c39b$var$MapCache.prototype.get = $cb234526c7d95a3f$exports;
$57e0c604ba32c39b$var$MapCache.prototype.has = $72f0b25e44e2d5ae$exports;
$57e0c604ba32c39b$var$MapCache.prototype.set = $3515bd091736a69c$exports;
$57e0c604ba32c39b$exports = $57e0c604ba32c39b$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $895fcf617b208138$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $895fcf617b208138$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $0b7ee66329b5ea90$exports) {
        var pairs = data.__data__;
        if (!$360fd4b3be530280$exports || pairs.length < $895fcf617b208138$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $57e0c604ba32c39b$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$895fcf617b208138$exports = $895fcf617b208138$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $86017fac3b58a763$var$Stack(entries) {
    var data = this.__data__ = new $0b7ee66329b5ea90$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$86017fac3b58a763$var$Stack.prototype.clear = $6eae15e42a140b03$exports;
$86017fac3b58a763$var$Stack.prototype["delete"] = $2e8de8e1a89f2a29$exports;
$86017fac3b58a763$var$Stack.prototype.get = $364fbc9f64e6d44d$exports;
$86017fac3b58a763$var$Stack.prototype.has = $fe24b4ae9659dbc2$exports;
$86017fac3b58a763$var$Stack.prototype.set = $895fcf617b208138$exports;
$86017fac3b58a763$exports = $86017fac3b58a763$var$Stack;


var $a786eb20194fec40$exports = {};
var $dc7c314dad6455cc$exports = {};

var $8c1e19bd833f71a4$exports = {};
var $92487d9f351cd90a$exports = {};

var $75fe756c66c79801$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $75fe756c66c79801$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $75fe756c66c79801$var$setCacheAdd(value) {
    this.__data__.set(value, $75fe756c66c79801$var$HASH_UNDEFINED);
    return this;
}
$75fe756c66c79801$exports = $75fe756c66c79801$var$setCacheAdd;


var $5794b8ee605dc954$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $5794b8ee605dc954$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$5794b8ee605dc954$exports = $5794b8ee605dc954$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $92487d9f351cd90a$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $57e0c604ba32c39b$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$92487d9f351cd90a$var$SetCache.prototype.add = $92487d9f351cd90a$var$SetCache.prototype.push = $75fe756c66c79801$exports;
$92487d9f351cd90a$var$SetCache.prototype.has = $5794b8ee605dc954$exports;
$92487d9f351cd90a$exports = $92487d9f351cd90a$var$SetCache;


var $eb1244f8f89497ab$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $eb1244f8f89497ab$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$eb1244f8f89497ab$exports = $eb1244f8f89497ab$var$arraySome;


var $baae7d4eb9cf9638$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $baae7d4eb9cf9638$var$cacheHas(cache, key) {
    return cache.has(key);
}
$baae7d4eb9cf9638$exports = $baae7d4eb9cf9638$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $8c1e19bd833f71a4$var$COMPARE_PARTIAL_FLAG = 1, $8c1e19bd833f71a4$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $8c1e19bd833f71a4$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $8c1e19bd833f71a4$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $8c1e19bd833f71a4$var$COMPARE_UNORDERED_FLAG ? new $92487d9f351cd90a$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$eb1244f8f89497ab$exports(other, function(othValue, othIndex) {
                if (!$baae7d4eb9cf9638$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$8c1e19bd833f71a4$exports = $8c1e19bd833f71a4$var$equalArrays;


var $7eb8d1be0877adcd$exports = {};

var $c4966b7220692846$exports = {};

var $fqPbb = parcelRequire("fqPbb");
/** Built-in value references. */ var $c4966b7220692846$var$Uint8Array = $fqPbb.Uint8Array;
$c4966b7220692846$exports = $c4966b7220692846$var$Uint8Array;




var $1164942a1ebfa1b1$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $1164942a1ebfa1b1$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$1164942a1ebfa1b1$exports = $1164942a1ebfa1b1$var$mapToArray;


var $5faf7f5d6f112c37$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $5faf7f5d6f112c37$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$5faf7f5d6f112c37$exports = $5faf7f5d6f112c37$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $7eb8d1be0877adcd$var$COMPARE_PARTIAL_FLAG = 1, $7eb8d1be0877adcd$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $7eb8d1be0877adcd$var$boolTag = "[object Boolean]", $7eb8d1be0877adcd$var$dateTag = "[object Date]", $7eb8d1be0877adcd$var$errorTag = "[object Error]", $7eb8d1be0877adcd$var$mapTag = "[object Map]", $7eb8d1be0877adcd$var$numberTag = "[object Number]", $7eb8d1be0877adcd$var$regexpTag = "[object RegExp]", $7eb8d1be0877adcd$var$setTag = "[object Set]", $7eb8d1be0877adcd$var$stringTag = "[object String]", $7eb8d1be0877adcd$var$symbolTag = "[object Symbol]";
var $7eb8d1be0877adcd$var$arrayBufferTag = "[object ArrayBuffer]", $7eb8d1be0877adcd$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $7eb8d1be0877adcd$var$symbolProto = $f47d208f8f64d4b7$exports ? $f47d208f8f64d4b7$exports.prototype : undefined, $7eb8d1be0877adcd$var$symbolValueOf = $7eb8d1be0877adcd$var$symbolProto ? $7eb8d1be0877adcd$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $7eb8d1be0877adcd$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $7eb8d1be0877adcd$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $7eb8d1be0877adcd$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $c4966b7220692846$exports(object), new $c4966b7220692846$exports(other))) return false;
            return true;
        case $7eb8d1be0877adcd$var$boolTag:
        case $7eb8d1be0877adcd$var$dateTag:
        case $7eb8d1be0877adcd$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $69a6288411d50f7e$exports(+object, +other);
        case $7eb8d1be0877adcd$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $7eb8d1be0877adcd$var$regexpTag:
        case $7eb8d1be0877adcd$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $7eb8d1be0877adcd$var$mapTag:
            var convert = $1164942a1ebfa1b1$exports;
        case $7eb8d1be0877adcd$var$setTag:
            var isPartial = bitmask & $7eb8d1be0877adcd$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $5faf7f5d6f112c37$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $7eb8d1be0877adcd$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $8c1e19bd833f71a4$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $7eb8d1be0877adcd$var$symbolTag:
            if ($7eb8d1be0877adcd$var$symbolValueOf) return $7eb8d1be0877adcd$var$symbolValueOf.call(object) == $7eb8d1be0877adcd$var$symbolValueOf.call(other);
    }
    return false;
}
$7eb8d1be0877adcd$exports = $7eb8d1be0877adcd$var$equalByTag;


var $78fa91e8d13efe1e$exports = {};
var $0700af7499885de6$exports = {};
var $17ae493e3e75d194$exports = {};
var $31ec8cc14b082512$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $31ec8cc14b082512$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$31ec8cc14b082512$exports = $31ec8cc14b082512$var$arrayPush;


var $7d5354e451843f1d$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $7d5354e451843f1d$var$isArray = Array.isArray;
$7d5354e451843f1d$exports = $7d5354e451843f1d$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $17ae493e3e75d194$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $7d5354e451843f1d$exports(object) ? result : $31ec8cc14b082512$exports(result, symbolsFunc(object));
}
$17ae493e3e75d194$exports = $17ae493e3e75d194$var$baseGetAllKeys;


var $c3675a078d63e88d$exports = {};
var $7c98da50d815d796$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $7c98da50d815d796$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$7c98da50d815d796$exports = $7c98da50d815d796$var$arrayFilter;


var $2dc0276a364517b5$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $2dc0276a364517b5$var$stubArray() {
    return [];
}
$2dc0276a364517b5$exports = $2dc0276a364517b5$var$stubArray;


/** Used for built-in method references. */ var $c3675a078d63e88d$var$objectProto = Object.prototype;
/** Built-in value references. */ var $c3675a078d63e88d$var$propertyIsEnumerable = $c3675a078d63e88d$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c3675a078d63e88d$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $c3675a078d63e88d$var$getSymbols = !$c3675a078d63e88d$var$nativeGetSymbols ? $2dc0276a364517b5$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $7c98da50d815d796$exports($c3675a078d63e88d$var$nativeGetSymbols(object), function(symbol) {
        return $c3675a078d63e88d$var$propertyIsEnumerable.call(object, symbol);
    });
};
$c3675a078d63e88d$exports = $c3675a078d63e88d$var$getSymbols;


var $c2929eb7d9ea5a51$exports = {};
var $a0f1fb4798eaf16b$exports = {};
var $afa3c6ede59d2cfc$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $afa3c6ede59d2cfc$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$afa3c6ede59d2cfc$exports = $afa3c6ede59d2cfc$var$baseTimes;


var $2a992d08adb74504$exports = {};
var $8bb9287078a55e0e$exports = {};

var $0e1bd538c3d56ef7$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $0e1bd538c3d56ef7$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$0e1bd538c3d56ef7$exports = $0e1bd538c3d56ef7$var$isObjectLike;


/** `Object#toString` result references. */ var $8bb9287078a55e0e$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $8bb9287078a55e0e$var$baseIsArguments(value) {
    return $0e1bd538c3d56ef7$exports(value) && $3699efeb64f9313e$exports(value) == $8bb9287078a55e0e$var$argsTag;
}
$8bb9287078a55e0e$exports = $8bb9287078a55e0e$var$baseIsArguments;



/** Used for built-in method references. */ var $2a992d08adb74504$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2a992d08adb74504$var$hasOwnProperty = $2a992d08adb74504$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $2a992d08adb74504$var$propertyIsEnumerable = $2a992d08adb74504$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $2a992d08adb74504$var$isArguments = $8bb9287078a55e0e$exports(function() {
    return arguments;
}()) ? $8bb9287078a55e0e$exports : function(value) {
    return $0e1bd538c3d56ef7$exports(value) && $2a992d08adb74504$var$hasOwnProperty.call(value, "callee") && !$2a992d08adb74504$var$propertyIsEnumerable.call(value, "callee");
};
$2a992d08adb74504$exports = $2a992d08adb74504$var$isArguments;




var $2pESa = parcelRequire("2pESa");
var $4dbd64d4a35a0a45$exports = {};
/** Used as references for various `Number` constants. */ var $4dbd64d4a35a0a45$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $4dbd64d4a35a0a45$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $4dbd64d4a35a0a45$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $4dbd64d4a35a0a45$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $4dbd64d4a35a0a45$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$4dbd64d4a35a0a45$exports = $4dbd64d4a35a0a45$var$isIndex;


var $ea52468f59c64b85$exports = {};
var $0feaa2d0af8bbb51$exports = {};

var $82eb5b2683d32ca2$exports = {};
/** Used as references for various `Number` constants. */ var $82eb5b2683d32ca2$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $82eb5b2683d32ca2$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $82eb5b2683d32ca2$var$MAX_SAFE_INTEGER;
}
$82eb5b2683d32ca2$exports = $82eb5b2683d32ca2$var$isLength;



/** `Object#toString` result references. */ var $0feaa2d0af8bbb51$var$argsTag = "[object Arguments]", $0feaa2d0af8bbb51$var$arrayTag = "[object Array]", $0feaa2d0af8bbb51$var$boolTag = "[object Boolean]", $0feaa2d0af8bbb51$var$dateTag = "[object Date]", $0feaa2d0af8bbb51$var$errorTag = "[object Error]", $0feaa2d0af8bbb51$var$funcTag = "[object Function]", $0feaa2d0af8bbb51$var$mapTag = "[object Map]", $0feaa2d0af8bbb51$var$numberTag = "[object Number]", $0feaa2d0af8bbb51$var$objectTag = "[object Object]", $0feaa2d0af8bbb51$var$regexpTag = "[object RegExp]", $0feaa2d0af8bbb51$var$setTag = "[object Set]", $0feaa2d0af8bbb51$var$stringTag = "[object String]", $0feaa2d0af8bbb51$var$weakMapTag = "[object WeakMap]";
var $0feaa2d0af8bbb51$var$arrayBufferTag = "[object ArrayBuffer]", $0feaa2d0af8bbb51$var$dataViewTag = "[object DataView]", $0feaa2d0af8bbb51$var$float32Tag = "[object Float32Array]", $0feaa2d0af8bbb51$var$float64Tag = "[object Float64Array]", $0feaa2d0af8bbb51$var$int8Tag = "[object Int8Array]", $0feaa2d0af8bbb51$var$int16Tag = "[object Int16Array]", $0feaa2d0af8bbb51$var$int32Tag = "[object Int32Array]", $0feaa2d0af8bbb51$var$uint8Tag = "[object Uint8Array]", $0feaa2d0af8bbb51$var$uint8ClampedTag = "[object Uint8ClampedArray]", $0feaa2d0af8bbb51$var$uint16Tag = "[object Uint16Array]", $0feaa2d0af8bbb51$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $0feaa2d0af8bbb51$var$typedArrayTags = {};
$0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$float32Tag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$float64Tag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$int8Tag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$int16Tag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$int32Tag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$uint8Tag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$uint8ClampedTag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$uint16Tag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$uint32Tag] = true;
$0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$argsTag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$arrayTag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$arrayBufferTag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$boolTag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$dataViewTag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$dateTag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$errorTag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$funcTag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$mapTag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$numberTag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$objectTag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$regexpTag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$setTag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$stringTag] = $0feaa2d0af8bbb51$var$typedArrayTags[$0feaa2d0af8bbb51$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $0feaa2d0af8bbb51$var$baseIsTypedArray(value) {
    return $0e1bd538c3d56ef7$exports(value) && $82eb5b2683d32ca2$exports(value.length) && !!$0feaa2d0af8bbb51$var$typedArrayTags[$3699efeb64f9313e$exports(value)];
}
$0feaa2d0af8bbb51$exports = $0feaa2d0af8bbb51$var$baseIsTypedArray;


var $6281b33e10b79621$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $6281b33e10b79621$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$6281b33e10b79621$exports = $6281b33e10b79621$var$baseUnary;



var $4gXwB = parcelRequire("4gXwB");
/* Node.js helper references. */ var $ea52468f59c64b85$var$nodeIsTypedArray = $4gXwB && $4gXwB.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $ea52468f59c64b85$var$isTypedArray = $ea52468f59c64b85$var$nodeIsTypedArray ? $6281b33e10b79621$exports($ea52468f59c64b85$var$nodeIsTypedArray) : $0feaa2d0af8bbb51$exports;
$ea52468f59c64b85$exports = $ea52468f59c64b85$var$isTypedArray;


/** Used for built-in method references. */ var $a0f1fb4798eaf16b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a0f1fb4798eaf16b$var$hasOwnProperty = $a0f1fb4798eaf16b$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $a0f1fb4798eaf16b$var$arrayLikeKeys(value, inherited) {
    var isArr = $7d5354e451843f1d$exports(value), isArg = !isArr && $2a992d08adb74504$exports(value), isBuff = !isArr && !isArg && $2pESa(value), isType = !isArr && !isArg && !isBuff && $ea52468f59c64b85$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $afa3c6ede59d2cfc$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $a0f1fb4798eaf16b$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $4dbd64d4a35a0a45$exports(key, length)))) result.push(key);
    return result;
}
$a0f1fb4798eaf16b$exports = $a0f1fb4798eaf16b$var$arrayLikeKeys;


var $ec50d63bdc52004e$exports = {};
var $2ff1b10cf0463722$exports = {};
/** Used for built-in method references. */ var $2ff1b10cf0463722$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $2ff1b10cf0463722$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $2ff1b10cf0463722$var$objectProto;
    return value === proto;
}
$2ff1b10cf0463722$exports = $2ff1b10cf0463722$var$isPrototype;


var $164416b42ae696ce$exports = {};
var $6cf5ddb884802d28$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $6cf5ddb884802d28$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$6cf5ddb884802d28$exports = $6cf5ddb884802d28$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $164416b42ae696ce$var$nativeKeys = $6cf5ddb884802d28$exports(Object.keys, Object);
$164416b42ae696ce$exports = $164416b42ae696ce$var$nativeKeys;


/** Used for built-in method references. */ var $ec50d63bdc52004e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ec50d63bdc52004e$var$hasOwnProperty = $ec50d63bdc52004e$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ec50d63bdc52004e$var$baseKeys(object) {
    if (!$2ff1b10cf0463722$exports(object)) return $164416b42ae696ce$exports(object);
    var result = [];
    for(var key in Object(object))if ($ec50d63bdc52004e$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$ec50d63bdc52004e$exports = $ec50d63bdc52004e$var$baseKeys;


var $ad01483b32f9b58b$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ad01483b32f9b58b$var$isArrayLike(value) {
    return value != null && $82eb5b2683d32ca2$exports(value.length) && !$42795a6abdb31608$exports(value);
}
$ad01483b32f9b58b$exports = $ad01483b32f9b58b$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $c2929eb7d9ea5a51$var$keys(object) {
    return $ad01483b32f9b58b$exports(object) ? $a0f1fb4798eaf16b$exports(object) : $ec50d63bdc52004e$exports(object);
}
$c2929eb7d9ea5a51$exports = $c2929eb7d9ea5a51$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $0700af7499885de6$var$getAllKeys(object) {
    return $17ae493e3e75d194$exports(object, $c2929eb7d9ea5a51$exports, $c3675a078d63e88d$exports);
}
$0700af7499885de6$exports = $0700af7499885de6$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $78fa91e8d13efe1e$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $78fa91e8d13efe1e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $78fa91e8d13efe1e$var$hasOwnProperty = $78fa91e8d13efe1e$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $78fa91e8d13efe1e$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $78fa91e8d13efe1e$var$COMPARE_PARTIAL_FLAG, objProps = $0700af7499885de6$exports(object), objLength = objProps.length, othProps = $0700af7499885de6$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $78fa91e8d13efe1e$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$78fa91e8d13efe1e$exports = $78fa91e8d13efe1e$var$equalObjects;


var $d7927f924e9799ef$exports = {};
var $1ee2433027a341a8$exports = {};


var $fqPbb = parcelRequire("fqPbb");
/* Built-in method references that are verified to be native. */ var $1ee2433027a341a8$var$DataView = $64956676ecb25347$exports($fqPbb, "DataView");
$1ee2433027a341a8$exports = $1ee2433027a341a8$var$DataView;



var $92f1d8c4f407cc29$exports = {};


var $fqPbb = parcelRequire("fqPbb");
/* Built-in method references that are verified to be native. */ var $92f1d8c4f407cc29$var$Promise = $64956676ecb25347$exports($fqPbb, "Promise");
$92f1d8c4f407cc29$exports = $92f1d8c4f407cc29$var$Promise;


var $718a55cd9b59ef8e$exports = {};


var $fqPbb = parcelRequire("fqPbb");
/* Built-in method references that are verified to be native. */ var $718a55cd9b59ef8e$var$Set = $64956676ecb25347$exports($fqPbb, "Set");
$718a55cd9b59ef8e$exports = $718a55cd9b59ef8e$var$Set;


var $93294548d7238b6f$exports = {};


var $fqPbb = parcelRequire("fqPbb");
/* Built-in method references that are verified to be native. */ var $93294548d7238b6f$var$WeakMap = $64956676ecb25347$exports($fqPbb, "WeakMap");
$93294548d7238b6f$exports = $93294548d7238b6f$var$WeakMap;




/** `Object#toString` result references. */ var $d7927f924e9799ef$var$mapTag = "[object Map]", $d7927f924e9799ef$var$objectTag = "[object Object]", $d7927f924e9799ef$var$promiseTag = "[object Promise]", $d7927f924e9799ef$var$setTag = "[object Set]", $d7927f924e9799ef$var$weakMapTag = "[object WeakMap]";
var $d7927f924e9799ef$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $d7927f924e9799ef$var$dataViewCtorString = $0974c06596c50cf8$exports($1ee2433027a341a8$exports), $d7927f924e9799ef$var$mapCtorString = $0974c06596c50cf8$exports($360fd4b3be530280$exports), $d7927f924e9799ef$var$promiseCtorString = $0974c06596c50cf8$exports($92f1d8c4f407cc29$exports), $d7927f924e9799ef$var$setCtorString = $0974c06596c50cf8$exports($718a55cd9b59ef8e$exports), $d7927f924e9799ef$var$weakMapCtorString = $0974c06596c50cf8$exports($93294548d7238b6f$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $d7927f924e9799ef$var$getTag = $3699efeb64f9313e$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($1ee2433027a341a8$exports && $d7927f924e9799ef$var$getTag(new $1ee2433027a341a8$exports(new ArrayBuffer(1))) != $d7927f924e9799ef$var$dataViewTag || $360fd4b3be530280$exports && $d7927f924e9799ef$var$getTag(new $360fd4b3be530280$exports) != $d7927f924e9799ef$var$mapTag || $92f1d8c4f407cc29$exports && $d7927f924e9799ef$var$getTag($92f1d8c4f407cc29$exports.resolve()) != $d7927f924e9799ef$var$promiseTag || $718a55cd9b59ef8e$exports && $d7927f924e9799ef$var$getTag(new $718a55cd9b59ef8e$exports) != $d7927f924e9799ef$var$setTag || $93294548d7238b6f$exports && $d7927f924e9799ef$var$getTag(new $93294548d7238b6f$exports) != $d7927f924e9799ef$var$weakMapTag) $d7927f924e9799ef$var$getTag = function(value) {
    var result = $3699efeb64f9313e$exports(value), Ctor = result == $d7927f924e9799ef$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $0974c06596c50cf8$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $d7927f924e9799ef$var$dataViewCtorString:
            return $d7927f924e9799ef$var$dataViewTag;
        case $d7927f924e9799ef$var$mapCtorString:
            return $d7927f924e9799ef$var$mapTag;
        case $d7927f924e9799ef$var$promiseCtorString:
            return $d7927f924e9799ef$var$promiseTag;
        case $d7927f924e9799ef$var$setCtorString:
            return $d7927f924e9799ef$var$setTag;
        case $d7927f924e9799ef$var$weakMapCtorString:
            return $d7927f924e9799ef$var$weakMapTag;
    }
    return result;
};
$d7927f924e9799ef$exports = $d7927f924e9799ef$var$getTag;




var $2pESa = parcelRequire("2pESa");

/** Used to compose bitmasks for value comparisons. */ var $dc7c314dad6455cc$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $dc7c314dad6455cc$var$argsTag = "[object Arguments]", $dc7c314dad6455cc$var$arrayTag = "[object Array]", $dc7c314dad6455cc$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $dc7c314dad6455cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dc7c314dad6455cc$var$hasOwnProperty = $dc7c314dad6455cc$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $dc7c314dad6455cc$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $7d5354e451843f1d$exports(object), othIsArr = $7d5354e451843f1d$exports(other), objTag = objIsArr ? $dc7c314dad6455cc$var$arrayTag : $d7927f924e9799ef$exports(object), othTag = othIsArr ? $dc7c314dad6455cc$var$arrayTag : $d7927f924e9799ef$exports(other);
    objTag = objTag == $dc7c314dad6455cc$var$argsTag ? $dc7c314dad6455cc$var$objectTag : objTag;
    othTag = othTag == $dc7c314dad6455cc$var$argsTag ? $dc7c314dad6455cc$var$objectTag : othTag;
    var objIsObj = objTag == $dc7c314dad6455cc$var$objectTag, othIsObj = othTag == $dc7c314dad6455cc$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $2pESa(object)) {
        if (!$2pESa(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $86017fac3b58a763$exports);
        return objIsArr || $ea52468f59c64b85$exports(object) ? $8c1e19bd833f71a4$exports(object, other, bitmask, customizer, equalFunc, stack) : $7eb8d1be0877adcd$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $dc7c314dad6455cc$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $dc7c314dad6455cc$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $dc7c314dad6455cc$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $86017fac3b58a763$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $86017fac3b58a763$exports);
    return $78fa91e8d13efe1e$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$dc7c314dad6455cc$exports = $dc7c314dad6455cc$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $a786eb20194fec40$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$0e1bd538c3d56ef7$exports(value) && !$0e1bd538c3d56ef7$exports(other)) return value !== value && other !== other;
    return $dc7c314dad6455cc$exports(value, other, bitmask, customizer, $a786eb20194fec40$var$baseIsEqual, stack);
}
$a786eb20194fec40$exports = $a786eb20194fec40$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $2f47a2a76adfcc0c$var$COMPARE_PARTIAL_FLAG = 1, $2f47a2a76adfcc0c$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $2f47a2a76adfcc0c$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $86017fac3b58a763$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $a786eb20194fec40$exports(srcValue, objValue, $2f47a2a76adfcc0c$var$COMPARE_PARTIAL_FLAG | $2f47a2a76adfcc0c$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$2f47a2a76adfcc0c$exports = $2f47a2a76adfcc0c$var$baseIsMatch;


var $d2c1af5dcc6478c9$exports = {};
var $16c8f7c32022d896$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $16c8f7c32022d896$var$isStrictComparable(value) {
    return value === value && !$6f2119b160786e16$exports(value);
}
$16c8f7c32022d896$exports = $16c8f7c32022d896$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $d2c1af5dcc6478c9$var$getMatchData(object) {
    var result = $c2929eb7d9ea5a51$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $16c8f7c32022d896$exports(value)
        ];
    }
    return result;
}
$d2c1af5dcc6478c9$exports = $d2c1af5dcc6478c9$var$getMatchData;


var $26ebc60994bf8f43$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $26ebc60994bf8f43$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$26ebc60994bf8f43$exports = $26ebc60994bf8f43$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $00554a9c69f6d8dc$var$baseMatches(source) {
    var matchData = $d2c1af5dcc6478c9$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $26ebc60994bf8f43$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $2f47a2a76adfcc0c$exports(object, source, matchData);
    };
}
$00554a9c69f6d8dc$exports = $00554a9c69f6d8dc$var$baseMatches;


var $a63b67be4c89a570$exports = {};

var $0074ee0d4251cf7b$exports = {};
var $dc7a64ba824ec671$exports = {};
var $860ef9e9d226448b$exports = {};

var $01c6014d33f54fa7$exports = {};

var $f23a252e5df6e93a$exports = {};


/** `Object#toString` result references. */ var $f23a252e5df6e93a$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $f23a252e5df6e93a$var$isSymbol(value) {
    return typeof value == "symbol" || $0e1bd538c3d56ef7$exports(value) && $3699efeb64f9313e$exports(value) == $f23a252e5df6e93a$var$symbolTag;
}
$f23a252e5df6e93a$exports = $f23a252e5df6e93a$var$isSymbol;


/** Used to match property names within property paths. */ var $01c6014d33f54fa7$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $01c6014d33f54fa7$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $01c6014d33f54fa7$var$isKey(value, object) {
    if ($7d5354e451843f1d$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $f23a252e5df6e93a$exports(value)) return true;
    return $01c6014d33f54fa7$var$reIsPlainProp.test(value) || !$01c6014d33f54fa7$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$01c6014d33f54fa7$exports = $01c6014d33f54fa7$var$isKey;


var $bc743ef321ab6e77$exports = {};
var $090e0be495844e15$exports = {};
var $53cf88cc9ff3d086$exports = {};

/** Error message constants. */ var $53cf88cc9ff3d086$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $53cf88cc9ff3d086$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($53cf88cc9ff3d086$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($53cf88cc9ff3d086$var$memoize.Cache || $57e0c604ba32c39b$exports);
    return memoized;
}
// Expose `MapCache`.
$53cf88cc9ff3d086$var$memoize.Cache = $57e0c604ba32c39b$exports;
$53cf88cc9ff3d086$exports = $53cf88cc9ff3d086$var$memoize;


/** Used as the maximum memoize cache size. */ var $090e0be495844e15$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $090e0be495844e15$var$memoizeCapped(func) {
    var result = $53cf88cc9ff3d086$exports(func, function(key) {
        if (cache.size === $090e0be495844e15$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$090e0be495844e15$exports = $090e0be495844e15$var$memoizeCapped;


/** Used to match property names within property paths. */ var $bc743ef321ab6e77$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $bc743ef321ab6e77$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $bc743ef321ab6e77$var$stringToPath = $090e0be495844e15$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($bc743ef321ab6e77$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($bc743ef321ab6e77$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$bc743ef321ab6e77$exports = $bc743ef321ab6e77$var$stringToPath;


var $4fe749c4b1591f12$exports = {};
var $cb93d73aece24052$exports = {};




/** Used as references for various `Number` constants. */ var $cb93d73aece24052$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $cb93d73aece24052$var$symbolProto = $f47d208f8f64d4b7$exports ? $f47d208f8f64d4b7$exports.prototype : undefined, $cb93d73aece24052$var$symbolToString = $cb93d73aece24052$var$symbolProto ? $cb93d73aece24052$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $cb93d73aece24052$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($7d5354e451843f1d$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $a76fdaeea17a0bf1$exports(value, $cb93d73aece24052$var$baseToString) + "";
    if ($f23a252e5df6e93a$exports(value)) return $cb93d73aece24052$var$symbolToString ? $cb93d73aece24052$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$cb93d73aece24052$var$INFINITY ? "-0" : result;
}
$cb93d73aece24052$exports = $cb93d73aece24052$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $4fe749c4b1591f12$var$toString(value) {
    return value == null ? "" : $cb93d73aece24052$exports(value);
}
$4fe749c4b1591f12$exports = $4fe749c4b1591f12$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $860ef9e9d226448b$var$castPath(value, object) {
    if ($7d5354e451843f1d$exports(value)) return value;
    return $01c6014d33f54fa7$exports(value, object) ? [
        value
    ] : $bc743ef321ab6e77$exports($4fe749c4b1591f12$exports(value));
}
$860ef9e9d226448b$exports = $860ef9e9d226448b$var$castPath;


var $01b52b5abcf3750d$exports = {};

/** Used as references for various `Number` constants. */ var $01b52b5abcf3750d$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $01b52b5abcf3750d$var$toKey(value) {
    if (typeof value == "string" || $f23a252e5df6e93a$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$01b52b5abcf3750d$var$INFINITY ? "-0" : result;
}
$01b52b5abcf3750d$exports = $01b52b5abcf3750d$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $dc7a64ba824ec671$var$baseGet(object, path) {
    path = $860ef9e9d226448b$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$01b52b5abcf3750d$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$dc7a64ba824ec671$exports = $dc7a64ba824ec671$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $0074ee0d4251cf7b$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $dc7a64ba824ec671$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$0074ee0d4251cf7b$exports = $0074ee0d4251cf7b$var$get;


var $ea080b2957fd2ca0$exports = {};
var $3f2cd5947688270f$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $3f2cd5947688270f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$3f2cd5947688270f$exports = $3f2cd5947688270f$var$baseHasIn;


var $2d26dda3193f22f8$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $2d26dda3193f22f8$var$hasPath(object, path, hasFunc) {
    path = $860ef9e9d226448b$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $01b52b5abcf3750d$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $82eb5b2683d32ca2$exports(length) && $4dbd64d4a35a0a45$exports(key, length) && ($7d5354e451843f1d$exports(object) || $2a992d08adb74504$exports(object));
}
$2d26dda3193f22f8$exports = $2d26dda3193f22f8$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $ea080b2957fd2ca0$var$hasIn(object, path) {
    return object != null && $2d26dda3193f22f8$exports(object, path, $3f2cd5947688270f$exports);
}
$ea080b2957fd2ca0$exports = $ea080b2957fd2ca0$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $a63b67be4c89a570$var$COMPARE_PARTIAL_FLAG = 1, $a63b67be4c89a570$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $a63b67be4c89a570$var$baseMatchesProperty(path, srcValue) {
    if ($01c6014d33f54fa7$exports(path) && $16c8f7c32022d896$exports(srcValue)) return $26ebc60994bf8f43$exports($01b52b5abcf3750d$exports(path), srcValue);
    return function(object) {
        var objValue = $0074ee0d4251cf7b$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $ea080b2957fd2ca0$exports(object, path) : $a786eb20194fec40$exports(srcValue, objValue, $a63b67be4c89a570$var$COMPARE_PARTIAL_FLAG | $a63b67be4c89a570$var$COMPARE_UNORDERED_FLAG);
    };
}
$a63b67be4c89a570$exports = $a63b67be4c89a570$var$baseMatchesProperty;


var $c5a99c09046ca432$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $c5a99c09046ca432$var$identity(value) {
    return value;
}
$c5a99c09046ca432$exports = $c5a99c09046ca432$var$identity;



var $b4526ce7aa07dda5$exports = {};
var $8a9f5cec7998b1fe$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $8a9f5cec7998b1fe$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$8a9f5cec7998b1fe$exports = $8a9f5cec7998b1fe$var$baseProperty;


var $1644e3bf9e58b7fc$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $1644e3bf9e58b7fc$var$basePropertyDeep(path) {
    return function(object) {
        return $dc7a64ba824ec671$exports(object, path);
    };
}
$1644e3bf9e58b7fc$exports = $1644e3bf9e58b7fc$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $b4526ce7aa07dda5$var$property(path) {
    return $01c6014d33f54fa7$exports(path) ? $8a9f5cec7998b1fe$exports($01b52b5abcf3750d$exports(path)) : $1644e3bf9e58b7fc$exports(path);
}
$b4526ce7aa07dda5$exports = $b4526ce7aa07dda5$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $381dbab245c93f61$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $c5a99c09046ca432$exports;
    if (typeof value == "object") return $7d5354e451843f1d$exports(value) ? $a63b67be4c89a570$exports(value[0], value[1]) : $00554a9c69f6d8dc$exports(value);
    return $b4526ce7aa07dda5$exports(value);
}
$381dbab245c93f61$exports = $381dbab245c93f61$var$baseIteratee;


var $5b29c068356087e5$exports = {};

var $2eeabb25b8f9a473$exports = {};
var $28d085c853acdf7a$exports = {};
var $fb75eae4af0d74a9$exports = {};
var $abe415c5586c5a6e$exports = {};

var $abe415c5586c5a6e$var$defineProperty = function() {
    try {
        var func = $64956676ecb25347$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$abe415c5586c5a6e$exports = $abe415c5586c5a6e$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $fb75eae4af0d74a9$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $abe415c5586c5a6e$exports) $abe415c5586c5a6e$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$fb75eae4af0d74a9$exports = $fb75eae4af0d74a9$var$baseAssignValue;



/** Used for built-in method references. */ var $28d085c853acdf7a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $28d085c853acdf7a$var$hasOwnProperty = $28d085c853acdf7a$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $28d085c853acdf7a$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($28d085c853acdf7a$var$hasOwnProperty.call(object, key) && $69a6288411d50f7e$exports(objValue, value)) || value === undefined && !(key in object)) $fb75eae4af0d74a9$exports(object, key, value);
}
$28d085c853acdf7a$exports = $28d085c853acdf7a$var$assignValue;






/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $2eeabb25b8f9a473$var$baseSet(object, path, value, customizer) {
    if (!$6f2119b160786e16$exports(object)) return object;
    path = $860ef9e9d226448b$exports(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $01b52b5abcf3750d$exports(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $6f2119b160786e16$exports(objValue) ? objValue : $4dbd64d4a35a0a45$exports(path[index + 1]) ? [] : {};
        }
        $28d085c853acdf7a$exports(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
$2eeabb25b8f9a473$exports = $2eeabb25b8f9a473$var$baseSet;



/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $5b29c068356087e5$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $dc7a64ba824ec671$exports(object, path);
        if (predicate(value, path)) $2eeabb25b8f9a473$exports(result, $860ef9e9d226448b$exports(path, object), value);
    }
    return result;
}
$5b29c068356087e5$exports = $5b29c068356087e5$var$basePickBy;


var $db008ec8512f531c$exports = {};

var $69290033e5ac5962$exports = {};

var $7c6a7b8d23234366$exports = {};

/** Built-in value references. */ var $7c6a7b8d23234366$var$getPrototype = $6cf5ddb884802d28$exports(Object.getPrototypeOf, Object);
$7c6a7b8d23234366$exports = $7c6a7b8d23234366$var$getPrototype;




/* Built-in method references for those with the same name as other `lodash` methods. */ var $69290033e5ac5962$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $69290033e5ac5962$var$getSymbolsIn = !$69290033e5ac5962$var$nativeGetSymbols ? $2dc0276a364517b5$exports : function(object) {
    var result = [];
    while(object){
        $31ec8cc14b082512$exports(result, $c3675a078d63e88d$exports(object));
        object = $7c6a7b8d23234366$exports(object);
    }
    return result;
};
$69290033e5ac5962$exports = $69290033e5ac5962$var$getSymbolsIn;


var $e815534874ee0440$exports = {};

var $909d044b290f5e86$exports = {};


var $2ae819efb1377e77$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $2ae819efb1377e77$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$2ae819efb1377e77$exports = $2ae819efb1377e77$var$nativeKeysIn;


/** Used for built-in method references. */ var $909d044b290f5e86$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $909d044b290f5e86$var$hasOwnProperty = $909d044b290f5e86$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $909d044b290f5e86$var$baseKeysIn(object) {
    if (!$6f2119b160786e16$exports(object)) return $2ae819efb1377e77$exports(object);
    var isProto = $2ff1b10cf0463722$exports(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$909d044b290f5e86$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$909d044b290f5e86$exports = $909d044b290f5e86$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $e815534874ee0440$var$keysIn(object) {
    return $ad01483b32f9b58b$exports(object) ? $a0f1fb4798eaf16b$exports(object, true) : $909d044b290f5e86$exports(object);
}
$e815534874ee0440$exports = $e815534874ee0440$var$keysIn;


/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $db008ec8512f531c$var$getAllKeysIn(object) {
    return $17ae493e3e75d194$exports(object, $e815534874ee0440$exports, $69290033e5ac5962$exports);
}
$db008ec8512f531c$exports = $db008ec8512f531c$var$getAllKeysIn;


/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $7608d14a9cea7e55$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $a76fdaeea17a0bf1$exports($db008ec8512f531c$exports(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $381dbab245c93f61$exports(predicate);
    return $5b29c068356087e5$exports(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
$7608d14a9cea7e55$exports = $7608d14a9cea7e55$var$pickBy;





// default `autoSignIn` flag is `true`
const $3ed0b9573b469d61$var$DEFAULT_AUTO_SIGN_IN = true;
const $3ed0b9573b469d61$var$EMPTY_STRING = "";
const $3ed0b9573b469d61$export$bdf2363efaa77dc8 = (dialCode, phoneNumber)=>`${dialCode}${phoneNumber}`.replace(/[^A-Z0-9+]/gi, "");
const $3ed0b9573b469d61$var$selectUserAttributes = (_, key)=>{
    // Allowlist of Cognito User Pool Attributes (from OpenID Connect specification)
    // See: https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-attributes.html
    switch(key){
        case "address":
        case "birthdate":
        case "email":
        case "family_name":
        case "gender":
        case "given_name":
        case "locale":
        case "middle_name":
        case "name":
        case "nickname":
        case "phone_number":
        case "picture":
        case "preferred_username":
        case "profile":
        case "updated_at":
        case "website":
        case "zoneinfo":
            return true;
        // Otherwise, it's a custom attribute
        default:
            return key.startsWith("custom:");
    }
};
const $3ed0b9573b469d61$export$e741ea695767fdb4 = (formValues)=>{
    const { phone_number: phone_number, ...userAttributes } = (0, (/*@__PURE__*/$parcel$interopDefault($7608d14a9cea7e55$exports)))(formValues, $3ed0b9573b469d61$var$selectUserAttributes);
    // only include `phone_number` attribute in `userAttributes` if it has a value
    if ((0, $697901644f774aa4$export$844ec244b1367d54)(phone_number) && phone_number !== $3ed0b9573b469d61$var$EMPTY_STRING) {
        const { country_code: country_code } = formValues;
        return {
            ...userAttributes,
            phone_number: $3ed0b9573b469d61$export$bdf2363efaa77dc8(country_code, phone_number)
        };
    }
    return userAttributes;
};
const $3ed0b9573b469d61$export$6bc605b0b68c7601 = (username, formValues, loginMechanism)=>{
    const { password: password, ...values } = formValues;
    const attributes = $3ed0b9573b469d61$export$e741ea695767fdb4(values);
    const options = {
        autoSignIn: $3ed0b9573b469d61$var$DEFAULT_AUTO_SIGN_IN,
        userAttributes: {
            // use `username` value for `phone_number`
            ...loginMechanism === "phone_number" ? {
                ...attributes,
                phone_number: username
            } : attributes
        }
    };
    return {
        username: username,
        password: password,
        options: options
    };
};
const $3ed0b9573b469d61$export$4ff49060fec3afdc = ({ formValues: formValues, loginMechanisms: loginMechanisms })=>{
    const loginMechanism = loginMechanisms[0];
    if (loginMechanism === "phone_number") {
        const { country_code: country_code, phone_number: phone_number } = formValues;
        return $3ed0b9573b469d61$export$bdf2363efaa77dc8(country_code, phone_number);
    }
    return formValues[loginMechanism];
};


const { assign: $86bd895eb2ae87a7$var$assign } = (0, $f9b2d12db4f71f3e$exports);
const $86bd895eb2ae87a7$var$clearActorDoneData = $86bd895eb2ae87a7$var$assign({
    actorDoneData: undefined
});
const $86bd895eb2ae87a7$var$clearChallengeName = $86bd895eb2ae87a7$var$assign({
    challengeName: undefined
});
const $86bd895eb2ae87a7$var$clearMissingAttributes = $86bd895eb2ae87a7$var$assign({
    missingAttributes: undefined
});
const $86bd895eb2ae87a7$var$clearError = $86bd895eb2ae87a7$var$assign({
    remoteError: undefined
});
const $86bd895eb2ae87a7$var$clearFormValues = $86bd895eb2ae87a7$var$assign({
    formValues: {}
});
const $86bd895eb2ae87a7$var$clearTouched = $86bd895eb2ae87a7$var$assign({
    touched: {}
});
const $86bd895eb2ae87a7$var$clearUser = $86bd895eb2ae87a7$var$assign({
    user: undefined
});
const $86bd895eb2ae87a7$var$clearValidationError = $86bd895eb2ae87a7$var$assign({
    validationError: {}
});
/**
 * "set" actions
 */ const $86bd895eb2ae87a7$var$setTotpSecretCode = $86bd895eb2ae87a7$var$assign({
    totpSecretCode: (_, { data: data })=>{
        const { sharedSecret: sharedSecret } = data.nextStep?.totpSetupDetails ?? {};
        return sharedSecret;
    }
});
const $86bd895eb2ae87a7$var$setSignInStep = $86bd895eb2ae87a7$var$assign({
    step: "SIGN_IN"
});
const $86bd895eb2ae87a7$var$setShouldVerifyUserAttributeStep = $86bd895eb2ae87a7$var$assign({
    step: "SHOULD_CONFIRM_USER_ATTRIBUTE"
});
const $86bd895eb2ae87a7$var$setConfirmAttributeCompleteStep = $86bd895eb2ae87a7$var$assign({
    step: "CONFIRM_ATTRIBUTE_COMPLETE"
});
// map v6 `signInStep` to v5 `challengeName`
const $86bd895eb2ae87a7$var$setChallengeName = $86bd895eb2ae87a7$var$assign({
    challengeName: (_, { data: data })=>{
        const { signInStep: signInStep } = data.nextStep;
        return signInStep === "CONFIRM_SIGN_IN_WITH_SMS_CODE" ? "SMS_MFA" : signInStep === "CONFIRM_SIGN_IN_WITH_TOTP_CODE" ? "SOFTWARE_TOKEN_MFA" : undefined;
    }
});
const $86bd895eb2ae87a7$var$setUsernameForgotPassword = $86bd895eb2ae87a7$var$assign({
    username: ({ formValues: formValues, loginMechanisms: loginMechanisms })=>{
        const loginMechanism = loginMechanisms[0];
        const { username: username, country_code: country_code } = formValues;
        if (loginMechanism === "phone_number") // forgot password `formValues` uses `username` for base phone number value
        // prefix `country_code` for full `username`
        return (0, $3ed0b9573b469d61$export$bdf2363efaa77dc8)(country_code, username);
        // default username field for loginMechanism === 'email' is "username" for SignIn
        return username;
    }
});
const $86bd895eb2ae87a7$var$setUsernameSignUp = $86bd895eb2ae87a7$var$assign({
    username: (0, $3ed0b9573b469d61$export$4ff49060fec3afdc)
});
const $86bd895eb2ae87a7$var$setUsernameSignIn = $86bd895eb2ae87a7$var$assign({
    username: ({ formValues: formValues, loginMechanisms: loginMechanisms })=>{
        const loginMechanism = loginMechanisms[0];
        const { username: username, country_code: country_code } = formValues;
        if (loginMechanism === "phone_number") // sign in `formValues` uses `username` for base phone number value
        // prefix `country_code` for full `username`
        return (0, $3ed0b9573b469d61$export$bdf2363efaa77dc8)(country_code, username);
        // return `email` and `username`
        return username;
    }
});
const $86bd895eb2ae87a7$var$setNextSignInStep = $86bd895eb2ae87a7$var$assign({
    step: (_, { data: data })=>data.nextStep.signInStep === "DONE" ? "SIGN_IN_COMPLETE" : data.nextStep.signInStep
});
const $86bd895eb2ae87a7$var$setNextSignUpStep = $86bd895eb2ae87a7$var$assign({
    step: (_, { data: data })=>data.nextStep.signUpStep === "DONE" ? "SIGN_UP_COMPLETE" : data.nextStep.signUpStep
});
const $86bd895eb2ae87a7$var$setNextResetPasswordStep = $86bd895eb2ae87a7$var$assign({
    step: (_, { data: data })=>data.nextStep.resetPasswordStep === "DONE" ? "RESET_PASSWORD_COMPLETE" : data.nextStep.resetPasswordStep
});
const $86bd895eb2ae87a7$var$setMissingAttributes = $86bd895eb2ae87a7$var$assign({
    missingAttributes: (_, { data: data })=>data.nextStep?.missingAttributes
});
const $86bd895eb2ae87a7$var$setFieldErrors = $86bd895eb2ae87a7$var$assign({
    validationError: (_, { data: data })=>data
});
const $86bd895eb2ae87a7$var$setRemoteError = $86bd895eb2ae87a7$var$assign({
    remoteError: (_, { data: data })=>{
        if (data.name === "NoUserPoolError") return `Configuration error (see console) \u{2013} please contact the administrator`;
        return data?.message || data;
    }
});
const $86bd895eb2ae87a7$var$setUser = $86bd895eb2ae87a7$var$assign({
    user: (_, { data: data })=>data
});
const $86bd895eb2ae87a7$var$resolveCodeDeliveryDetails = (details)=>({
        Destination: details.destination,
        DeliveryMedium: details.deliveryMedium,
        AttributeName: details.attributName
    });
const $86bd895eb2ae87a7$var$setCodeDeliveryDetails = $86bd895eb2ae87a7$var$assign({
    codeDeliveryDetails: (_, { data: data })=>{
        if (data?.nextStep?.codeDeliveryDetails) return $86bd895eb2ae87a7$var$resolveCodeDeliveryDetails(data.nextStep.codeDeliveryDetails);
        return $86bd895eb2ae87a7$var$resolveCodeDeliveryDetails(data);
    }
});
const $86bd895eb2ae87a7$var$handleInput = $86bd895eb2ae87a7$var$assign({
    formValues: (context, { data: data })=>{
        const { name: name, value: value } = data;
        return {
            ...context["formValues"],
            [name]: value
        };
    }
});
const $86bd895eb2ae87a7$var$handleSubmit = $86bd895eb2ae87a7$var$assign({
    formValues: (context, { data: data })=>// do not trim password
        (0, $3bd7d334512b2bcd$export$205c000fb676adf6)({
            ...context["formValues"],
            ...data
        }, "password")
});
const $86bd895eb2ae87a7$var$handleBlur = $86bd895eb2ae87a7$var$assign({
    touched: (context, { data: data })=>({
            ...context["touched"],
            [data.name]: true
        })
});
const $86bd895eb2ae87a7$var$setUnverifiedUserAttributes = $86bd895eb2ae87a7$var$assign({
    unverifiedUserAttributes: (_, { data: data })=>{
        const { email: email, phone_number: phone_number } = data;
        const unverifiedUserAttributes = {
            ...email && {
                email: email
            },
            ...phone_number && {
                phone_number: phone_number
            }
        };
        return unverifiedUserAttributes;
    }
});
const $86bd895eb2ae87a7$var$clearSelectedUserAttribute = $86bd895eb2ae87a7$var$assign({
    selectedUserAttribute: undefined
});
const $86bd895eb2ae87a7$var$setSelectedUserAttribute = $86bd895eb2ae87a7$var$assign({
    selectedUserAttribute: (context)=>context.formValues?.unverifiedAttr
});
// Maps to unexposed `ConfirmSignUpSignUpStep`
const $86bd895eb2ae87a7$var$setConfirmSignUpSignUpStep = $86bd895eb2ae87a7$var$assign({
    step: "CONFIRM_SIGN_UP"
});
const $86bd895eb2ae87a7$export$2e2bcd8739ae039 = {
    clearActorDoneData: $86bd895eb2ae87a7$var$clearActorDoneData,
    clearChallengeName: $86bd895eb2ae87a7$var$clearChallengeName,
    clearError: $86bd895eb2ae87a7$var$clearError,
    clearFormValues: $86bd895eb2ae87a7$var$clearFormValues,
    clearMissingAttributes: $86bd895eb2ae87a7$var$clearMissingAttributes,
    clearSelectedUserAttribute: $86bd895eb2ae87a7$var$clearSelectedUserAttribute,
    clearTouched: $86bd895eb2ae87a7$var$clearTouched,
    clearUser: $86bd895eb2ae87a7$var$clearUser,
    clearValidationError: $86bd895eb2ae87a7$var$clearValidationError,
    handleBlur: $86bd895eb2ae87a7$var$handleBlur,
    handleInput: $86bd895eb2ae87a7$var$handleInput,
    handleSubmit: $86bd895eb2ae87a7$var$handleSubmit,
    setChallengeName: $86bd895eb2ae87a7$var$setChallengeName,
    setCodeDeliveryDetails: $86bd895eb2ae87a7$var$setCodeDeliveryDetails,
    setFieldErrors: $86bd895eb2ae87a7$var$setFieldErrors,
    setMissingAttributes: $86bd895eb2ae87a7$var$setMissingAttributes,
    setNextResetPasswordStep: $86bd895eb2ae87a7$var$setNextResetPasswordStep,
    setNextSignInStep: $86bd895eb2ae87a7$var$setNextSignInStep,
    setNextSignUpStep: $86bd895eb2ae87a7$var$setNextSignUpStep,
    setRemoteError: $86bd895eb2ae87a7$var$setRemoteError,
    setConfirmAttributeCompleteStep: $86bd895eb2ae87a7$var$setConfirmAttributeCompleteStep,
    setConfirmSignUpSignUpStep: $86bd895eb2ae87a7$var$setConfirmSignUpSignUpStep,
    setShouldVerifyUserAttributeStep: $86bd895eb2ae87a7$var$setShouldVerifyUserAttributeStep,
    setSelectedUserAttribute: $86bd895eb2ae87a7$var$setSelectedUserAttribute,
    setSignInStep: $86bd895eb2ae87a7$var$setSignInStep,
    setTotpSecretCode: $86bd895eb2ae87a7$var$setTotpSecretCode,
    setUser: $86bd895eb2ae87a7$var$setUser,
    setUnverifiedUserAttributes: $86bd895eb2ae87a7$var$setUnverifiedUserAttributes,
    setUsernameForgotPassword: $86bd895eb2ae87a7$var$setUsernameForgotPassword,
    setUsernameSignIn: $86bd895eb2ae87a7$var$setUsernameSignIn,
    setUsernameSignUp: $86bd895eb2ae87a7$var$setUsernameSignUp
};


const $6390b9cb027d73c6$var$SIGN_IN_STEP_MFA_CONFIRMATION = [
    "CONFIRM_SIGN_IN_WITH_SMS_CODE",
    "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
];
// response next step guards
const $6390b9cb027d73c6$var$shouldConfirmSignInWithNewPassword = (_, { data: data })=>data?.nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED";
const $6390b9cb027d73c6$var$shouldResetPasswordFromSignIn = (_, { data: data })=>data?.nextStep?.signInStep === "RESET_PASSWORD";
const $6390b9cb027d73c6$var$shouldConfirmSignUpFromSignIn = (_, { data: data })=>data?.nextStep.signInStep === "CONFIRM_SIGN_UP";
const $6390b9cb027d73c6$var$shouldAutoSignIn = (_, { data: data })=>data?.nextStep.signUpStep === "COMPLETE_AUTO_SIGN_IN";
const $6390b9cb027d73c6$var$hasCompletedSignIn = (_, { data: data })=>data?.nextStep.signInStep === "DONE";
const $6390b9cb027d73c6$var$hasCompletedSignUp = (_, { data: data })=>data?.nextStep.signUpStep === "DONE";
const $6390b9cb027d73c6$var$hasCompletedResetPassword = (_, { data: data })=>data?.nextStep.resetPasswordStep === "DONE";
// actor done guards read `step` from actor exit event
const $6390b9cb027d73c6$var$hasCompletedAttributeConfirmation = (_, { data: data })=>data?.step === "CONFIRM_ATTRIBUTE_COMPLETE";
const $6390b9cb027d73c6$var$isConfirmUserAttributeStep = (_, { data: data })=>data?.step === "CONFIRM_ATTRIBUTE_WITH_CODE";
const $6390b9cb027d73c6$var$isShouldConfirmUserAttributeStep = (_, { data: data })=>data?.step === "SHOULD_CONFIRM_USER_ATTRIBUTE";
const $6390b9cb027d73c6$var$isResetPasswordStep = (_, { data: data })=>data?.step === "RESET_PASSWORD";
const $6390b9cb027d73c6$var$isConfirmSignUpStep = (_, { data: data })=>data?.step === "CONFIRM_SIGN_UP";
// actor entry guards read `step` from actor context
const $6390b9cb027d73c6$var$shouldConfirmSignIn = ({ step: step })=>$6390b9cb027d73c6$var$SIGN_IN_STEP_MFA_CONFIRMATION.includes(step);
const $6390b9cb027d73c6$var$shouldSetupTotp = ({ step: step })=>step === "CONTINUE_SIGN_IN_WITH_TOTP_SETUP";
const $6390b9cb027d73c6$var$shouldResetPassword = ({ step: step })=>step === "RESET_PASSWORD";
const $6390b9cb027d73c6$var$shouldConfirmResetPassword = ({ step: step })=>step === "CONFIRM_RESET_PASSWORD_WITH_CODE";
const $6390b9cb027d73c6$var$shouldConfirmSignUp = ({ step: step })=>step === "CONFIRM_SIGN_UP";
// miscellaneous guards
const $6390b9cb027d73c6$var$shouldVerifyAttribute = (_, { data: data })=>{
    const { phone_number_verified: phone_number_verified, email_verified: email_verified } = data;
    // email/phone_verified is returned as a string
    const emailNotVerified = email_verified === undefined || email_verified === "false";
    const phoneNotVerified = phone_number_verified === undefined || phone_number_verified === "false";
    // only request verification if both email and phone are not verified
    return emailNotVerified && phoneNotVerified;
};
/**
 * This guard covers an edge case that exists in the current state of the UI.
 * As of now, our ConfirmSignUp screen only supports showing an input for a
 * confirmation code. However, a Cognito UserPool can instead verify users
 * through a link that gets emailed to them. If a user verifies through the
 * link and then they click on the "Resend Code" button, they will get an error
 * saying that the user has already been confirmed. If we encounter that error,
 * we want to just funnel them through the rest of the flow. In the future, we will
 * want to update our UI to support both confirmation codes and links.
 *
 * https://github.com/aws-amplify/amplify-ui/issues/219
 */ const $6390b9cb027d73c6$var$isUserAlreadyConfirmed = (_, { data: data })=>data.message === "User is already confirmed.";
const $6390b9cb027d73c6$export$2e2bcd8739ae039 = {
    hasCompletedAttributeConfirmation: $6390b9cb027d73c6$var$hasCompletedAttributeConfirmation,
    hasCompletedResetPassword: $6390b9cb027d73c6$var$hasCompletedResetPassword,
    hasCompletedSignIn: $6390b9cb027d73c6$var$hasCompletedSignIn,
    hasCompletedSignUp: $6390b9cb027d73c6$var$hasCompletedSignUp,
    isConfirmSignUpStep: $6390b9cb027d73c6$var$isConfirmSignUpStep,
    isConfirmUserAttributeStep: $6390b9cb027d73c6$var$isConfirmUserAttributeStep,
    isResetPasswordStep: $6390b9cb027d73c6$var$isResetPasswordStep,
    isShouldConfirmUserAttributeStep: $6390b9cb027d73c6$var$isShouldConfirmUserAttributeStep,
    isUserAlreadyConfirmed: $6390b9cb027d73c6$var$isUserAlreadyConfirmed,
    shouldAutoSignIn: $6390b9cb027d73c6$var$shouldAutoSignIn,
    shouldConfirmResetPassword: $6390b9cb027d73c6$var$shouldConfirmResetPassword,
    shouldConfirmSignIn: $6390b9cb027d73c6$var$shouldConfirmSignIn,
    shouldConfirmSignInWithNewPassword: $6390b9cb027d73c6$var$shouldConfirmSignInWithNewPassword,
    shouldConfirmSignUp: $6390b9cb027d73c6$var$shouldConfirmSignUp,
    shouldConfirmSignUpFromSignIn: $6390b9cb027d73c6$var$shouldConfirmSignUpFromSignIn,
    shouldResetPassword: $6390b9cb027d73c6$var$shouldResetPassword,
    shouldResetPasswordFromSignIn: $6390b9cb027d73c6$var$shouldResetPasswordFromSignIn,
    shouldSetupTotp: $6390b9cb027d73c6$var$shouldSetupTotp,
    shouldVerifyAttribute: $6390b9cb027d73c6$var$shouldVerifyAttribute
};



var $a181903b403893b3$exports = {};
var $041add459e9937c2$exports = {};

var $783c468bb18c4478$exports = {};


/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $783c468bb18c4478$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$69a6288411d50f7e$exports(object[key], value) || value === undefined && !(key in object)) $fb75eae4af0d74a9$exports(object, key, value);
}
$783c468bb18c4478$exports = $783c468bb18c4478$var$assignMergeValue;


var $15531ab7b0896188$exports = {};
var $632087f1461d0c3f$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $632087f1461d0c3f$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$632087f1461d0c3f$exports = $632087f1461d0c3f$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $15531ab7b0896188$var$baseFor = $632087f1461d0c3f$exports();
$15531ab7b0896188$exports = $15531ab7b0896188$var$baseFor;


var $cebf749a34ba7105$exports = {};


var $ggrDq = parcelRequire("ggrDq");
var $dd9fe2060bdf34c9$exports = {};
var $c483b0e315c9ea24$exports = {};

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $c483b0e315c9ea24$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $c4966b7220692846$exports(result).set(new $c4966b7220692846$exports(arrayBuffer));
    return result;
}
$c483b0e315c9ea24$exports = $c483b0e315c9ea24$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $dd9fe2060bdf34c9$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $c483b0e315c9ea24$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$dd9fe2060bdf34c9$exports = $dd9fe2060bdf34c9$var$cloneTypedArray;


var $db8c02d917e43dbc$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $db8c02d917e43dbc$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$db8c02d917e43dbc$exports = $db8c02d917e43dbc$var$copyArray;


var $921eddef33852972$exports = {};
var $c25e7861c7b48a8a$exports = {};

/** Built-in value references. */ var $c25e7861c7b48a8a$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $c25e7861c7b48a8a$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$6f2119b160786e16$exports(proto)) return {};
        if ($c25e7861c7b48a8a$var$objectCreate) return $c25e7861c7b48a8a$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$c25e7861c7b48a8a$exports = $c25e7861c7b48a8a$var$baseCreate;




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $921eddef33852972$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$2ff1b10cf0463722$exports(object) ? $c25e7861c7b48a8a$exports($7c6a7b8d23234366$exports(object)) : {};
}
$921eddef33852972$exports = $921eddef33852972$var$initCloneObject;




var $987380d21465e517$exports = {};


/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $987380d21465e517$var$isArrayLikeObject(value) {
    return $0e1bd538c3d56ef7$exports(value) && $ad01483b32f9b58b$exports(value);
}
$987380d21465e517$exports = $987380d21465e517$var$isArrayLikeObject;



var $2pESa = parcelRequire("2pESa");


var $0ef4c8e552207a33$exports = {};



/** `Object#toString` result references. */ var $0ef4c8e552207a33$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $0ef4c8e552207a33$var$funcProto = Function.prototype, $0ef4c8e552207a33$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0ef4c8e552207a33$var$funcToString = $0ef4c8e552207a33$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0ef4c8e552207a33$var$hasOwnProperty = $0ef4c8e552207a33$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0ef4c8e552207a33$var$objectCtorString = $0ef4c8e552207a33$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0ef4c8e552207a33$var$isPlainObject(value) {
    if (!$0e1bd538c3d56ef7$exports(value) || $3699efeb64f9313e$exports(value) != $0ef4c8e552207a33$var$objectTag) return false;
    var proto = $7c6a7b8d23234366$exports(value);
    if (proto === null) return true;
    var Ctor = $0ef4c8e552207a33$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $0ef4c8e552207a33$var$funcToString.call(Ctor) == $0ef4c8e552207a33$var$objectCtorString;
}
$0ef4c8e552207a33$exports = $0ef4c8e552207a33$var$isPlainObject;



var $3e6e84ac2bed5fd3$exports = {};
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $3e6e84ac2bed5fd3$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
$3e6e84ac2bed5fd3$exports = $3e6e84ac2bed5fd3$var$safeGet;


var $dc5d4a79a16e9551$exports = {};
var $e887e6d4cb855150$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $e887e6d4cb855150$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $fb75eae4af0d74a9$exports(object, key, newValue);
        else $28d085c853acdf7a$exports(object, key, newValue);
    }
    return object;
}
$e887e6d4cb855150$exports = $e887e6d4cb855150$var$copyObject;



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $dc5d4a79a16e9551$var$toPlainObject(value) {
    return $e887e6d4cb855150$exports(value, $e815534874ee0440$exports(value));
}
$dc5d4a79a16e9551$exports = $dc5d4a79a16e9551$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $cebf749a34ba7105$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $3e6e84ac2bed5fd3$exports(object, key), srcValue = $3e6e84ac2bed5fd3$exports(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $783c468bb18c4478$exports(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $7d5354e451843f1d$exports(srcValue), isBuff = !isArr && $2pESa(srcValue), isTyped = !isArr && !isBuff && $ea52468f59c64b85$exports(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($7d5354e451843f1d$exports(objValue)) newValue = objValue;
            else if ($987380d21465e517$exports(objValue)) newValue = $db8c02d917e43dbc$exports(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $ggrDq(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $dd9fe2060bdf34c9$exports(srcValue, true);
            } else newValue = [];
        } else if ($0ef4c8e552207a33$exports(srcValue) || $2a992d08adb74504$exports(srcValue)) {
            newValue = objValue;
            if ($2a992d08adb74504$exports(objValue)) newValue = $dc5d4a79a16e9551$exports(objValue);
            else if (!$6f2119b160786e16$exports(objValue) || $42795a6abdb31608$exports(objValue)) newValue = $921eddef33852972$exports(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    $783c468bb18c4478$exports(object, key, newValue);
}
$cebf749a34ba7105$exports = $cebf749a34ba7105$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $041add459e9937c2$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $15531ab7b0896188$exports(source, function(srcValue, key) {
        stack || (stack = new $86017fac3b58a763$exports);
        if ($6f2119b160786e16$exports(srcValue)) $cebf749a34ba7105$exports(object, source, key, srcIndex, $041add459e9937c2$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($3e6e84ac2bed5fd3$exports(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $783c468bb18c4478$exports(object, key, newValue);
        }
    }, $e815534874ee0440$exports);
}
$041add459e9937c2$exports = $041add459e9937c2$var$baseMerge;


var $dd41f55979c902c9$exports = {};
var $bd39470296f5a7b1$exports = {};

var $99cc1b2986c8e512$exports = {};
var $932784c12e0318b3$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $932784c12e0318b3$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$932784c12e0318b3$exports = $932784c12e0318b3$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $99cc1b2986c8e512$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $99cc1b2986c8e512$var$overRest(func, start, transform) {
    start = $99cc1b2986c8e512$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $99cc1b2986c8e512$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $932784c12e0318b3$exports(func, this, otherArgs);
    };
}
$99cc1b2986c8e512$exports = $99cc1b2986c8e512$var$overRest;


var $405ff6f17b6c8937$exports = {};
var $5f25e258ebe25a23$exports = {};
var $80a51911190686a4$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $80a51911190686a4$var$constant(value) {
    return function() {
        return value;
    };
}
$80a51911190686a4$exports = $80a51911190686a4$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $5f25e258ebe25a23$var$baseSetToString = !$abe415c5586c5a6e$exports ? $c5a99c09046ca432$exports : function(func, string) {
    return $abe415c5586c5a6e$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $80a51911190686a4$exports(string),
        "writable": true
    });
};
$5f25e258ebe25a23$exports = $5f25e258ebe25a23$var$baseSetToString;


var $32147df72a112bff$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $32147df72a112bff$var$HOT_COUNT = 800, $32147df72a112bff$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $32147df72a112bff$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $32147df72a112bff$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $32147df72a112bff$var$nativeNow(), remaining = $32147df72a112bff$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $32147df72a112bff$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$32147df72a112bff$exports = $32147df72a112bff$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $405ff6f17b6c8937$var$setToString = $32147df72a112bff$exports($5f25e258ebe25a23$exports);
$405ff6f17b6c8937$exports = $405ff6f17b6c8937$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $bd39470296f5a7b1$var$baseRest(func, start) {
    return $405ff6f17b6c8937$exports($99cc1b2986c8e512$exports(func, start, $c5a99c09046ca432$exports), func + "");
}
$bd39470296f5a7b1$exports = $bd39470296f5a7b1$var$baseRest;


var $ae18a6e756c676bd$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $ae18a6e756c676bd$var$isIterateeCall(value, index, object) {
    if (!$6f2119b160786e16$exports(object)) return false;
    var type = typeof index;
    if (type == "number" ? $ad01483b32f9b58b$exports(object) && $4dbd64d4a35a0a45$exports(index, object.length) : type == "string" && index in object) return $69a6288411d50f7e$exports(object[index], value);
    return false;
}
$ae18a6e756c676bd$exports = $ae18a6e756c676bd$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $dd41f55979c902c9$var$createAssigner(assigner) {
    return $bd39470296f5a7b1$exports(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $ae18a6e756c676bd$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
$dd41f55979c902c9$exports = $dd41f55979c902c9$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $a181903b403893b3$var$merge = $dd41f55979c902c9$exports(function(object, source, srcIndex) {
    $041add459e9937c2$exports(object, source, srcIndex);
});
$a181903b403893b3$exports = $a181903b403893b3$var$merge;





// Runs all validators given. Resolves if there are no error. Rejects otherwise.
const $e381f49dc6978a71$export$59e2b39f02edfada = async (formData, touchData, passwordSettings, validators)=>{
    const errors = await Promise.all(validators.map((validator)=>validator(formData, touchData, passwordSettings)));
    const mergedError = (0, (/*@__PURE__*/$parcel$interopDefault($a181903b403893b3$exports)))({}, ...errors);
    if ((0, $697901644f774aa4$export$dd1bc94b04021eeb)(mergedError)) // no errors were found
    return Promise.resolve();
    else return Promise.reject(mergedError);
};













// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms the new password and verification code to reset the password.
 *
 * @param input -  The ConfirmResetPasswordInput object.
 * @throws -{@link ConfirmForgotPasswordException }
 * Thrown due to an invalid confirmation code or password.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty confirmation code, password or username.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $cd0ed4d73f618c9e$export$890261705c8ce36b(input) {
    const authConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId } = authConfig;
    const { username: username, newPassword: newPassword } = input;
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!username, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyConfirmResetPasswordUsername);
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!newPassword, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyConfirmResetPasswordNewPassword);
    const code = input.confirmationCode;
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!code, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyConfirmResetPasswordConfirmationCode);
    const metadata = input.options?.clientMetadata;
    const UserContextData = (0, $30f7d7d7c5349180$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    await (0, $c845c6a72bc4ff0c$export$c7a5d0826ce3a2b2)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).ConfirmResetPassword)
    }, {
        Username: username,
        ConfirmationCode: code,
        Password: newPassword,
        ClientMetadata: metadata,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
}

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f136ba74979ac757$var$signInReducer = (state, action)=>{
    switch(action.type){
        case "SET_SIGN_IN_SESSION":
            return {
                ...state,
                signInSession: action.value
            };
        case "SET_SIGN_IN_STATE":
            return {
                ...action.value
            };
        case "SET_CHALLENGE_NAME":
            return {
                ...state,
                challengeName: action.value
            };
        case "SET_USERNAME":
            return {
                ...state,
                username: action.value
            };
        case "SET_INITIAL_STATE":
            return $f136ba74979ac757$var$defaultState();
        default:
            return state;
    }
};
function $f136ba74979ac757$var$defaultState() {
    return {
        username: undefined,
        challengeName: undefined,
        signInSession: undefined
    };
}
const $f136ba74979ac757$var$createStore = (reducer)=>{
    let currentState = reducer($f136ba74979ac757$var$defaultState(), {
        type: "SET_INITIAL_STATE"
    });
    return {
        getState: ()=>currentState,
        dispatch: (action)=>{
            currentState = reducer(currentState, action);
        }
    };
};
const $f136ba74979ac757$export$390d5da4c63a4a41 = $f136ba74979ac757$var$createStore($f136ba74979ac757$var$signInReducer);
function $f136ba74979ac757$export$bae72361b690e075(state) {
    $f136ba74979ac757$export$390d5da4c63a4a41.dispatch({
        type: "SET_SIGN_IN_STATE",
        value: state
    });
}
function $f136ba74979ac757$export$f3dfaa7234c98dc0() {
    $f136ba74979ac757$export$390d5da4c63a4a41.dispatch({
        type: "SET_INITIAL_STATE"
    });
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $c71401e5fcd1f4bc$export$7c746b75f47c9c7d(input) {
    return Array.from(input, (byte)=>String.fromCodePoint(byte)).join("");
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $45965b0c21473608$export$695b149896bd3e2a = {
    convert (input, { urlSafe: urlSafe } = {
        urlSafe: false
    }) {
        const inputStr = typeof input === "string" ? input : (0, $c71401e5fcd1f4bc$export$7c746b75f47c9c7d)(input);
        const encodedStr = (0, $ad119da6003ad7dd$export$94f295707b435c6d)()(inputStr);
        // see details about the char replacing at https://datatracker.ietf.org/doc/html/rfc4648#section-5
        return urlSafe ? encodedStr.replace(/\+/g, "-").replace(/\//g, "_") : encodedStr;
    }
};


/* tslint:disable */ // @ts-nocheck -> BigInteger is already a vended utility
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $60cae906d2aae07c$export$2e2bcd8739ae039(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $60cae906d2aae07c$var$nbi() {
    return new $60cae906d2aae07c$export$2e2bcd8739ae039(null, null);
}
// Bits per digit
let $60cae906d2aae07c$var$dbits;
// JavaScript engine analysis
const $60cae906d2aae07c$var$canary = 0xdeadbeefcafe;
const $60cae906d2aae07c$var$j_lm = ($60cae906d2aae07c$var$canary & 0xffffff) === 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $60cae906d2aae07c$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        const v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $60cae906d2aae07c$var$am2(i, x, w, j, c, n) {
    const xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        let l = this[i] & 0x7fff;
        const h = this[i++] >> 15;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $60cae906d2aae07c$var$am3(i, x, w, j, c, n) {
    const xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        let l = this[i] & 0x3fff;
        const h = this[i++] >> 14;
        const m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
const $60cae906d2aae07c$var$inBrowser = typeof navigator !== "undefined";
if ($60cae906d2aae07c$var$inBrowser && $60cae906d2aae07c$var$j_lm && navigator.appName === "Microsoft Internet Explorer") {
    $60cae906d2aae07c$export$2e2bcd8739ae039.prototype.am = $60cae906d2aae07c$var$am2;
    $60cae906d2aae07c$var$dbits = 30;
} else if ($60cae906d2aae07c$var$inBrowser && $60cae906d2aae07c$var$j_lm && navigator.appName !== "Netscape") {
    $60cae906d2aae07c$export$2e2bcd8739ae039.prototype.am = $60cae906d2aae07c$var$am1;
    $60cae906d2aae07c$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $60cae906d2aae07c$export$2e2bcd8739ae039.prototype.am = $60cae906d2aae07c$var$am3;
    $60cae906d2aae07c$var$dbits = 28;
}
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.DB = $60cae906d2aae07c$var$dbits;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.DM = (1 << $60cae906d2aae07c$var$dbits) - 1;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.DV = 1 << $60cae906d2aae07c$var$dbits;
const $60cae906d2aae07c$var$BI_FP = 52;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.FV = Math.pow(2, $60cae906d2aae07c$var$BI_FP);
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.F1 = $60cae906d2aae07c$var$BI_FP - $60cae906d2aae07c$var$dbits;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.F2 = 2 * $60cae906d2aae07c$var$dbits - $60cae906d2aae07c$var$BI_FP;
// Digit conversions
const $60cae906d2aae07c$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
const $60cae906d2aae07c$var$BI_RC = new Array();
let $60cae906d2aae07c$var$rr, $60cae906d2aae07c$var$vv;
$60cae906d2aae07c$var$rr = "0".charCodeAt(0);
for($60cae906d2aae07c$var$vv = 0; $60cae906d2aae07c$var$vv <= 9; ++$60cae906d2aae07c$var$vv)$60cae906d2aae07c$var$BI_RC[$60cae906d2aae07c$var$rr++] = $60cae906d2aae07c$var$vv;
$60cae906d2aae07c$var$rr = "a".charCodeAt(0);
for($60cae906d2aae07c$var$vv = 10; $60cae906d2aae07c$var$vv < 36; ++$60cae906d2aae07c$var$vv)$60cae906d2aae07c$var$BI_RC[$60cae906d2aae07c$var$rr++] = $60cae906d2aae07c$var$vv;
$60cae906d2aae07c$var$rr = "A".charCodeAt(0);
for($60cae906d2aae07c$var$vv = 10; $60cae906d2aae07c$var$vv < 36; ++$60cae906d2aae07c$var$vv)$60cae906d2aae07c$var$BI_RC[$60cae906d2aae07c$var$rr++] = $60cae906d2aae07c$var$vv;
function $60cae906d2aae07c$var$int2char(n) {
    return $60cae906d2aae07c$var$BI_RM.charAt(n);
}
function $60cae906d2aae07c$var$intAt(s, i) {
    var c = $60cae906d2aae07c$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $60cae906d2aae07c$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $60cae906d2aae07c$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $60cae906d2aae07c$var$nbv(i) {
    var r = $60cae906d2aae07c$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $60cae906d2aae07c$var$bnpFromString(s, b) {
    let k;
    if (b === 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    let i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        const x = $60cae906d2aae07c$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) === "-") mi = true;
            continue;
        }
        mi = false;
        if (sh === 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $60cae906d2aae07c$export$2e2bcd8739ae039.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $60cae906d2aae07c$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $60cae906d2aae07c$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b === 8) k = 3;
    else if (b === 2) k = 1;
    else if (b === 32) k = 5;
    else if (b === 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    let km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    let p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $60cae906d2aae07c$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $60cae906d2aae07c$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $60cae906d2aae07c$var$bnNegate() {
    var r = $60cae906d2aae07c$var$nbi();
    $60cae906d2aae07c$export$2e2bcd8739ae039.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $60cae906d2aae07c$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $60cae906d2aae07c$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $60cae906d2aae07c$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) !== 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) !== 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) !== 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) !== 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) !== 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $60cae906d2aae07c$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $60cae906d2aae07c$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $60cae906d2aae07c$var$bnpDLShiftTo(n, r) {
    let i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $60cae906d2aae07c$var$bnpDRShiftTo(n, r) {
    for(let i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $60cae906d2aae07c$var$bnpLShiftTo(n, r) {
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << cbs) - 1;
    let ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $60cae906d2aae07c$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    const ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    const bs = n % this.DB;
    const cbs = this.DB - bs;
    const bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(let i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $60cae906d2aae07c$var$bnpSubTo(a, r) {
    let i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $60cae906d2aae07c$var$bnpMultiplyTo(a, r) {
    const x = this.abs(), y = a.abs();
    let i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s !== a.s) $60cae906d2aae07c$export$2e2bcd8739ae039.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $60cae906d2aae07c$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $60cae906d2aae07c$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r === null) r = $60cae906d2aae07c$var$nbi();
    var y = $60cae906d2aae07c$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $60cae906d2aae07c$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    const ys = y.t;
    const y0 = y[ys - 1];
    if (y0 === 0) return;
    const yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    const d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    let i = r.t, j = i - ys, t = q === null ? $60cae906d2aae07c$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $60cae906d2aae07c$export$2e2bcd8739ae039.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] === y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q !== null) {
        r.drShiftTo(ys, q);
        if (ts !== ms) $60cae906d2aae07c$export$2e2bcd8739ae039.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $60cae906d2aae07c$export$2e2bcd8739ae039.ZERO.subTo(r, r);
}
// (public) this mod a
function $60cae906d2aae07c$var$bnMod(a) {
    var r = $60cae906d2aae07c$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($60cae906d2aae07c$export$2e2bcd8739ae039.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $60cae906d2aae07c$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) === 0) return 0;
    var y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $60cae906d2aae07c$var$bnEquals(a) {
    return this.compareTo(a) === 0;
}
// (protected) r = this + a
function $60cae906d2aae07c$var$bnpAddTo(a, r) {
    let i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $60cae906d2aae07c$var$bnAdd(a) {
    var r = $60cae906d2aae07c$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $60cae906d2aae07c$var$bnSubtract(a) {
    var r = $60cae906d2aae07c$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $60cae906d2aae07c$var$bnMultiply(a) {
    var r = $60cae906d2aae07c$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $60cae906d2aae07c$var$bnDivide(a) {
    var r = $60cae906d2aae07c$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $60cae906d2aae07c$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $60cae906d2aae07c$var$montConvert(x) {
    var r = $60cae906d2aae07c$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($60cae906d2aae07c$export$2e2bcd8739ae039.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $60cae906d2aae07c$var$montRevert(x) {
    var r = $60cae906d2aae07c$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $60cae906d2aae07c$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $60cae906d2aae07c$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $60cae906d2aae07c$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$60cae906d2aae07c$var$Montgomery.prototype.convert = $60cae906d2aae07c$var$montConvert;
$60cae906d2aae07c$var$Montgomery.prototype.revert = $60cae906d2aae07c$var$montRevert;
$60cae906d2aae07c$var$Montgomery.prototype.reduce = $60cae906d2aae07c$var$montReduce;
$60cae906d2aae07c$var$Montgomery.prototype.mulTo = $60cae906d2aae07c$var$montMulTo;
$60cae906d2aae07c$var$Montgomery.prototype.sqrTo = $60cae906d2aae07c$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $60cae906d2aae07c$var$bnModPow(e, m, callback) {
    let i = e.bitLength(), k, r = $60cae906d2aae07c$var$nbv(1), z = new $60cae906d2aae07c$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    let g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        const g2 = $60cae906d2aae07c$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $60cae906d2aae07c$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    let j = e.t - 1, w, is1 = true, r2 = $60cae906d2aae07c$var$nbi(), t;
    i = $60cae906d2aae07c$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) === 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) === 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.copyTo = $60cae906d2aae07c$var$bnpCopyTo;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.fromInt = $60cae906d2aae07c$var$bnpFromInt;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.fromString = $60cae906d2aae07c$var$bnpFromString;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.clamp = $60cae906d2aae07c$var$bnpClamp;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.dlShiftTo = $60cae906d2aae07c$var$bnpDLShiftTo;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.drShiftTo = $60cae906d2aae07c$var$bnpDRShiftTo;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.lShiftTo = $60cae906d2aae07c$var$bnpLShiftTo;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.rShiftTo = $60cae906d2aae07c$var$bnpRShiftTo;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.subTo = $60cae906d2aae07c$var$bnpSubTo;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.multiplyTo = $60cae906d2aae07c$var$bnpMultiplyTo;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.squareTo = $60cae906d2aae07c$var$bnpSquareTo;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.divRemTo = $60cae906d2aae07c$var$bnpDivRemTo;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.invDigit = $60cae906d2aae07c$var$bnpInvDigit;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.addTo = $60cae906d2aae07c$var$bnpAddTo;
// public
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.toString = $60cae906d2aae07c$var$bnToString;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.negate = $60cae906d2aae07c$var$bnNegate;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.abs = $60cae906d2aae07c$var$bnAbs;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.compareTo = $60cae906d2aae07c$var$bnCompareTo;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.bitLength = $60cae906d2aae07c$var$bnBitLength;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.mod = $60cae906d2aae07c$var$bnMod;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.equals = $60cae906d2aae07c$var$bnEquals;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.add = $60cae906d2aae07c$var$bnAdd;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.subtract = $60cae906d2aae07c$var$bnSubtract;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.multiply = $60cae906d2aae07c$var$bnMultiply;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.divide = $60cae906d2aae07c$var$bnDivide;
$60cae906d2aae07c$export$2e2bcd8739ae039.prototype.modPow = $60cae906d2aae07c$var$bnModPow;
// "constants"
$60cae906d2aae07c$export$2e2bcd8739ae039.ZERO = $60cae906d2aae07c$var$nbv(0);
$60cae906d2aae07c$export$2e2bcd8739ae039.ONE = $60cae906d2aae07c$var$nbv(1);



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $9043d8ea4df565b2$export$f5d75491a17f02c = {
    convert (input) {
        return new TextEncoder().encode(input);
    }
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $48eb5473563f06c9$export$f7340100dd3acd38 = async ({ a: a, g: g, k: k, x: x, B: B, N: N, U: U })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(x, N, (outerErr, outerResult)=>{
            if (outerErr) {
                reject(outerErr);
                return;
            }
            B.subtract(k.multiply(outerResult)).modPow(a.add(U.multiply(x)), N, (innerErr, innerResult)=>{
                if (innerErr) {
                    reject(innerErr);
                    return;
                }
                resolve(innerResult.mod(N));
            });
        });
    });
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $957db4cb997ca14f$export$baab4dd8c7240846 = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
const $957db4cb997ca14f$export$a0f75f7d2f3bd702 = {};
const $957db4cb997ca14f$export$fcb552daf117d7e3 = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $957db4cb997ca14f$export$a0f75f7d2f3bd702[i] = encodedByte;
    $957db4cb997ca14f$export$fcb552daf117d7e3[encodedByte] = i;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a hexadecimal encoded string to a Uint8Array of bytes.
 *
 * @param encoded The hexadecimal encoded string
 */ const $29691db684a6f942$export$b772e43c3daf2e7a = (encoded)=>{
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in (0, $957db4cb997ca14f$export$fcb552daf117d7e3)) out[i / 2] = (0, $957db4cb997ca14f$export$fcb552daf117d7e3)[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Converts a Uint8Array of binary data to a hexadecimal encoded string.
 *
 * @param bytes The binary data to encode
 */ const $b9a6fcb07235ba3b$export$22a20ab34c1d7a2b = (bytes)=>{
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += (0, $957db4cb997ca14f$export$a0f75f7d2f3bd702)[bytes[i]];
    return out;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a `SourceData`
 * @param {SourceData} data Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const $0dd87573d0beed51$export$629ee8d7d3ebacd1 = (data)=>{
    const sha256 = new (0, $97f07a059ffc5910$exports.Sha256)();
    sha256.update(data);
    const hashedData = sha256.digestSync();
    const hashHexFromUint8 = (0, $b9a6fcb07235ba3b$export$22a20ab34c1d7a2b)(hashedData);
    return new Array(64 - hashHexFromUint8.length).join("0") + hashHexFromUint8;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Calculate a hash from a hex string
 * @param {string} hexStr Value to hash.
 * @returns {string} Hex-encoded hash.
 * @private
 */ const $f0c79d6315abcc6b$export$8b112e065a8843a = (hexStr)=>(0, $0dd87573d0beed51$export$629ee8d7d3ebacd1)((0, $29691db684a6f942$export$b772e43c3daf2e7a)(hexStr));



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */ const $089139148dfabfe1$var$HEX_MSB_REGEX = /^[89a-f]/i;
/**
 * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
 *
 * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
 * byte array containing the two's-complement representation of a BigInteger. The array contains
 * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
 *
 * Examples showing how ambiguity is avoided by left padding with:
 * 	"00" (for positive values where the most-significant-bit is set)
 *  "FF" (for negative values where the most-significant-bit is set)
 *
 * padHex(bigInteger.fromInt(-236))  === "FF14"
 * padHex(bigInteger.fromInt(20))    === "14"
 *
 * padHex(bigInteger.fromInt(-200))  === "FF38"
 * padHex(bigInteger.fromInt(56))    === "38"
 *
 * padHex(bigInteger.fromInt(-20))   === "EC"
 * padHex(bigInteger.fromInt(236))   === "00EC"
 *
 * padHex(bigInteger.fromInt(-56))   === "C8"
 * padHex(bigInteger.fromInt(200))   === "00C8"
 *
 * @param {AuthBigInteger} bigInt Number to encode.
 * @returns {String} even-length hex string of the two's complement encoding.
 */ const $089139148dfabfe1$export$35d4ea07514a0402 = (bigInt)=>{
    if (!(bigInt instanceof (0, $60cae906d2aae07c$export$2e2bcd8739ae039))) throw new Error("Not a BigInteger");
    const isNegative = bigInt.compareTo((0, $60cae906d2aae07c$export$2e2bcd8739ae039).ZERO) < 0;
    /* Get a hex string for abs(bigInt) */ let hexStr = bigInt.abs().toString(16);
    /* Pad hex to even length if needed */ hexStr = hexStr.length % 2 !== 0 ? `0${hexStr}` : hexStr;
    /* Prepend "00" if the most significant bit is set */ hexStr = $089139148dfabfe1$var$HEX_MSB_REGEX.test(hexStr) ? `00${hexStr}` : hexStr;
    if (isNegative) {
        /* Flip the bits of the representation */ const invertedNibbles = hexStr.split("").map((x)=>{
            const invertedNibble = ~parseInt(x, 16) & 0xf;
            return "0123456789ABCDEF".charAt(invertedNibble);
        }).join("");
        /* After flipping the bits, add one to get the 2's complement representation */ const flippedBitsBI = new (0, $60cae906d2aae07c$export$2e2bcd8739ae039)(invertedNibbles, 16).add((0, $60cae906d2aae07c$export$2e2bcd8739ae039).ONE);
        hexStr = flippedBitsBI.toString(16);
        /*
        For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128

        Any sequence of '1' bits on the left can always be substituted with a single '1' bit
        without changing the represented value.

        This only happens in the case when the input is 80...00
        */ if (hexStr.toUpperCase().startsWith("FF8")) hexStr = hexStr.substring(2);
    }
    return hexStr;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $4298ef47de51a437$export$e2f40082638513e7 = ({ A: A, B: B })=>{
    const U = new (0, $60cae906d2aae07c$export$2e2bcd8739ae039)((0, $f0c79d6315abcc6b$export$8b112e065a8843a)((0, $089139148dfabfe1$export$35d4ea07514a0402)(A) + (0, $089139148dfabfe1$export$35d4ea07514a0402)(B)), 16);
    if (U.equals((0, $60cae906d2aae07c$export$2e2bcd8739ae039).ZERO)) throw new Error("U cannot be zero.");
    return U;
};







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Standard HKDF algorithm.
 *
 * @param {Uint8Array} ikm Input key material.
 * @param {Uint8Array} salt Salt value.
 * @param {Uint8Array} info Context and application specific info.
 *
 * @returns {Uint8Array} Strong key material.
 *
 * @internal
 */ const $73acb9dde6e71948$export$295a0a5429217d03 = (ikm, salt, info)=>{
    const awsCryptoHash = new (0, $97f07a059ffc5910$exports.Sha256)(salt);
    awsCryptoHash.update(ikm);
    const resultFromAWSCryptoPrk = awsCryptoHash.digestSync();
    const awsCryptoHashHmac = new (0, $97f07a059ffc5910$exports.Sha256)(resultFromAWSCryptoPrk);
    awsCryptoHashHmac.update(info);
    const resultFromAWSCryptoHmac = awsCryptoHashHmac.digestSync();
    const hashHexFromAWSCrypto = resultFromAWSCryptoHmac;
    return hashHexFromAWSCrypto.slice(0, 16);
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/*
 * Cryptographically secure pseudorandom number generator
 * As Math.random() is cryptographically not safe to use
 */ function $cb190bea633ac095$export$d265930babe23ca5() {
    const crypto = (0, $ad119da6003ad7dd$export$e003cc239f955cb6)();
    const randomResult = crypto.getRandomValues(new Uint32Array(1))[0];
    return randomResult;
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */ function $eaafc80ba29c3c98$var$hexStringify(wordArray) {
    // Shortcuts
    const words = wordArray.words;
    const sigBytes = wordArray.sigBytes;
    // Convert
    const hexChars = [];
    for(let i = 0; i < sigBytes; i++){
        const bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
        hexChars.push((bite >>> 4).toString(16));
        hexChars.push((bite & 0x0f).toString(16));
    }
    return hexChars.join("");
}
class $eaafc80ba29c3c98$export$2e2bcd8739ae039 {
    constructor(words, sigBytes){
        this.words = [];
        let Words = words;
        Words = this.words = Words || [];
        if (sigBytes !== undefined) this.sigBytes = sigBytes;
        else this.sigBytes = Words.length * 4;
    }
    random(nBytes) {
        const words = [];
        for(let i = 0; i < nBytes; i += 4)words.push((0, $cb190bea633ac095$export$d265930babe23ca5)());
        return new $eaafc80ba29c3c98$export$2e2bcd8739ae039(words, nBytes);
    }
    toString() {
        return $eaafc80ba29c3c98$var$hexStringify(this);
    }
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a Uint8Array with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Uint8Array} fixed-length sequence of random bytes
 */ const $186f8f6a68fd7f03$export$763d6fc7c4b5dc52 = (nBytes)=>{
    const str = new (0, $eaafc80ba29c3c98$export$2e2bcd8739ae039)().random(nBytes).toString();
    return (0, $29691db684a6f942$export$b772e43c3daf2e7a)(str);
};




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Helper function to generate a random string
 * @returns {string} a random value.
 *
 * @internal
 */ const $655c0a5e43448344$export$8c487394e1c35fbe = ()=>(0, $45965b0c21473608$export$695b149896bd3e2a).convert((0, $186f8f6a68fd7f03$export$763d6fc7c4b5dc52)(40));


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @class */ class $5b00711f74abd6aa$export$2e2bcd8739ae039 {
    constructor({ userPoolName: userPoolName, a: a, g: g, A: A, N: N }){
        this.encoder = (0, $9043d8ea4df565b2$export$f5d75491a17f02c);
        this.userPoolName = userPoolName;
        this.a = a;
        this.g = g;
        this.A = A;
        this.N = N;
        this.k = new (0, $60cae906d2aae07c$export$2e2bcd8739ae039)((0, $f0c79d6315abcc6b$export$8b112e065a8843a)(`${(0, $089139148dfabfe1$export$35d4ea07514a0402)(N)}${(0, $089139148dfabfe1$export$35d4ea07514a0402)(g)}`), 16);
    }
    /**
     * @returns {string} Generated random value included in password hash.
     */ getRandomPassword() {
        if (!this.randomPassword) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
            name: "EmptyBigIntegerRandomPassword",
            message: "random password is empty"
        });
        return this.randomPassword;
    }
    /**
     * @returns {string} Generated random value included in devices hash.
     */ getSaltToHashDevices() {
        if (!this.saltToHashDevices) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
            name: "EmptyBigIntegersaltToHashDevices",
            message: "saltToHashDevices is empty"
        });
        return this.saltToHashDevices;
    }
    /**
     * @returns {string} Value used to verify devices.
     */ getVerifierDevices() {
        if (!this.verifierDevices) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
            name: "EmptyBigIntegerVerifierDevices",
            message: "verifyDevices is empty"
        });
        return this.verifierDevices;
    }
    /**
     * Generate salts and compute verifier.
     *
     * @param {string} deviceGroupKey Devices to generate verifier for.
     * @param {string} username User to generate verifier for.
     *
     * @returns {Promise<void>}
     */ async generateHashDevice(deviceGroupKey, username) {
        this.randomPassword = (0, $655c0a5e43448344$export$8c487394e1c35fbe)();
        const combinedString = `${deviceGroupKey}${username}:${this.randomPassword}`;
        const hashedString = (0, $0dd87573d0beed51$export$629ee8d7d3ebacd1)(combinedString);
        const hexRandom = (0, $b9a6fcb07235ba3b$export$22a20ab34c1d7a2b)((0, $186f8f6a68fd7f03$export$763d6fc7c4b5dc52)(16));
        // The random hex will be unambiguously represented as a postive integer
        this.saltToHashDevices = (0, $089139148dfabfe1$export$35d4ea07514a0402)(new (0, $60cae906d2aae07c$export$2e2bcd8739ae039)(hexRandom, 16));
        return new Promise((resolve, reject)=>{
            this.g.modPow(new (0, $60cae906d2aae07c$export$2e2bcd8739ae039)((0, $f0c79d6315abcc6b$export$8b112e065a8843a)(this.saltToHashDevices + hashedString), 16), this.N, (err, result)=>{
                if (err) {
                    reject(err);
                    return;
                }
                this.verifierDevices = (0, $089139148dfabfe1$export$35d4ea07514a0402)(result);
                resolve();
            });
        });
    }
    /**
     * Calculates the final HKDF key based on computed S value, computed U value and the key
     *
     * @param {String} username Username.
     * @param {String} password Password.
     * @param {AuthBigInteger} B Server B value.
     * @param {AuthBigInteger} salt Generated salt.
     */ async getPasswordAuthenticationKey({ username: username, password: password, serverBValue: serverBValue, salt: salt }) {
        if (serverBValue.mod(this.N).equals((0, $60cae906d2aae07c$export$2e2bcd8739ae039).ZERO)) throw new Error("B cannot be zero.");
        const U = (0, $4298ef47de51a437$export$e2f40082638513e7)({
            A: this.A,
            B: serverBValue
        });
        const usernamePassword = `${this.userPoolName}${username}:${password}`;
        const usernamePasswordHash = (0, $0dd87573d0beed51$export$629ee8d7d3ebacd1)(usernamePassword);
        const x = new (0, $60cae906d2aae07c$export$2e2bcd8739ae039)((0, $f0c79d6315abcc6b$export$8b112e065a8843a)((0, $089139148dfabfe1$export$35d4ea07514a0402)(salt) + usernamePasswordHash), 16);
        const S = await (0, $48eb5473563f06c9$export$f7340100dd3acd38)({
            a: this.a,
            g: this.g,
            k: this.k,
            x: x,
            B: serverBValue,
            N: this.N,
            U: U
        });
        const context = this.encoder.convert("Caldera Derived Key");
        const spacer = this.encoder.convert(String.fromCharCode(1));
        const info = new Uint8Array(context.byteLength + spacer.byteLength);
        info.set(context, 0);
        info.set(spacer, context.byteLength);
        const hkdfKey = (0, $73acb9dde6e71948$export$295a0a5429217d03)((0, $29691db684a6f942$export$b772e43c3daf2e7a)((0, $089139148dfabfe1$export$35d4ea07514a0402)(S)), (0, $29691db684a6f942$export$b772e43c3daf2e7a)((0, $089139148dfabfe1$export$35d4ea07514a0402)(U)), info);
        return hkdfKey;
    }
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * @internal
 */ const $6e1abe6e8029eb8d$export$53a55138f9e96c65 = async ({ a: a, g: g, N: N })=>{
    return new Promise((resolve, reject)=>{
        g.modPow(a, N, (err, A)=>{
            if (err) {
                reject(err);
                return;
            }
            if (A.mod(N).equals((0, $60cae906d2aae07c$export$2e2bcd8739ae039).ZERO)) {
                reject(new Error("Illegal parameter. A mod N cannot be 0."));
                return;
            }
            resolve(A);
        });
    });
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a new {@link AuthenticationHelper} instance with randomly generated BigInteger seed
 *
 * @param userPoolName Cognito user pool name.
 * @returns An {@link AuthenticationHelper} instance.
 *
 * @internal
 */ const $5c06437bc80c5efc$export$47560e2dc89f678c = async (userPoolName)=>{
    const N = new (0, $60cae906d2aae07c$export$2e2bcd8739ae039)((0, $957db4cb997ca14f$export$baab4dd8c7240846), 16);
    const g = new (0, $60cae906d2aae07c$export$2e2bcd8739ae039)("2", 16);
    const a = $5c06437bc80c5efc$var$generateRandomBigInteger();
    const A = await (0, $6e1abe6e8029eb8d$export$53a55138f9e96c65)({
        a: a,
        g: g,
        N: N
    });
    return new (0, $5b00711f74abd6aa$export$2e2bcd8739ae039)({
        userPoolName: userPoolName,
        a: a,
        g: g,
        A: A,
        N: N
    });
};
/**
 * Generates a random BigInteger.
 *
 * @returns {BigInteger} a random value.
 */ const $5c06437bc80c5efc$var$generateRandomBigInteger = ()=>{
    // This will be interpreted as a postive 128-bit integer
    const hexRandom = (0, $b9a6fcb07235ba3b$export$22a20ab34c1d7a2b)((0, $186f8f6a68fd7f03$export$763d6fc7c4b5dc52)(128));
    // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)
    return new (0, $60cae906d2aae07c$export$2e2bcd8739ae039)(hexRandom, 16);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8421d1c3e611515b$var$MONTH_NAMES = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $8421d1c3e611515b$var$WEEK_NAMES = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $8421d1c3e611515b$export$218a6e05f05aec48 = ()=>{
    const now = new Date();
    const weekDay = $8421d1c3e611515b$var$WEEK_NAMES[now.getUTCDay()];
    const month = $8421d1c3e611515b$var$MONTH_NAMES[now.getUTCMonth()];
    const day = now.getUTCDate();
    let hours = now.getUTCHours();
    if (hours < 10) hours = `0${hours}`;
    let minutes = now.getUTCMinutes();
    if (minutes < 10) minutes = `0${minutes}`;
    let seconds = now.getUTCSeconds();
    if (seconds < 10) seconds = `0${seconds}`;
    const year = now.getUTCFullYear();
    // ddd MMM D HH:mm:ss UTC YYYY
    const dateNow = `${weekDay} ${month} ${day} ${hours}:${minutes}:${seconds} UTC ${year}`;
    return dateNow;
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $070cfa915a96d92a$export$577b7d8a4f1b23fd = ({ userPoolName: userPoolName, username: username, challengeParameters: challengeParameters, dateNow: dateNow, hkdf: hkdf })=>{
    const bufUPIDaToB = (0, $9043d8ea4df565b2$export$f5d75491a17f02c).convert(userPoolName);
    const bufUNaToB = (0, $9043d8ea4df565b2$export$f5d75491a17f02c).convert(username);
    const bufSBaToB = $070cfa915a96d92a$var$urlB64ToUint8Array(challengeParameters.SECRET_BLOCK);
    const bufDNaToB = (0, $9043d8ea4df565b2$export$f5d75491a17f02c).convert(dateNow);
    const bufConcat = new Uint8Array(bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength + bufDNaToB.byteLength);
    bufConcat.set(bufUPIDaToB, 0);
    bufConcat.set(bufUNaToB, bufUPIDaToB.byteLength);
    bufConcat.set(bufSBaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength);
    bufConcat.set(bufDNaToB, bufUPIDaToB.byteLength + bufUNaToB.byteLength + bufSBaToB.byteLength);
    const awsCryptoHash = new (0, $97f07a059ffc5910$exports.Sha256)(hkdf);
    awsCryptoHash.update(bufConcat);
    const resultFromAWSCrypto = awsCryptoHash.digestSync();
    const signatureString = (0, $45965b0c21473608$export$695b149896bd3e2a).convert(resultFromAWSCrypto);
    return signatureString;
};
const $070cfa915a96d92a$var$urlB64ToUint8Array = (base64String)=>{
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
    const rawData = (0, $fd3cc728f3bcf7d6$export$1e303d38dab7b376).convert(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $b174d3658eafb14d$export$3cc5c71ef5f25e57;
(function(AssociateSoftwareTokenException) {
    AssociateSoftwareTokenException["ConcurrentModificationException"] = "ConcurrentModificationException";
    AssociateSoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    AssociateSoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    AssociateSoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    AssociateSoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    AssociateSoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    AssociateSoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
})($b174d3658eafb14d$export$3cc5c71ef5f25e57 || ($b174d3658eafb14d$export$3cc5c71ef5f25e57 = {}));
var $b174d3658eafb14d$export$4327725e8bb80c51;
(function(ChangePasswordException) {
    ChangePasswordException["ForbiddenException"] = "ForbiddenException";
    ChangePasswordException["InternalErrorException"] = "InternalErrorException";
    ChangePasswordException["InvalidParameterException"] = "InvalidParameterException";
    ChangePasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ChangePasswordException["LimitExceededException"] = "LimitExceededException";
    ChangePasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ChangePasswordException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ChangePasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ChangePasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ChangePasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ChangePasswordException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$4327725e8bb80c51 || ($b174d3658eafb14d$export$4327725e8bb80c51 = {}));
var $b174d3658eafb14d$export$87a956d0b1b725a1;
(function(ConfirmDeviceException) {
    ConfirmDeviceException["ForbiddenException"] = "ForbiddenException";
    ConfirmDeviceException["InternalErrorException"] = "InternalErrorException";
    ConfirmDeviceException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmDeviceException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ConfirmDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ConfirmDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmDeviceException["UsernameExistsException"] = "UsernameExistsException";
    ConfirmDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmDeviceException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$87a956d0b1b725a1 || ($b174d3658eafb14d$export$87a956d0b1b725a1 = {}));
var $b174d3658eafb14d$export$b86a388af82085af;
(function(ConfirmForgotPasswordException) {
    ConfirmForgotPasswordException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmForgotPasswordException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ConfirmForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ConfirmForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmForgotPasswordException["InvalidPasswordException"] = "InvalidPasswordException";
    ConfirmForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ConfirmForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmForgotPasswordException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmForgotPasswordException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ConfirmForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$b86a388af82085af || ($b174d3658eafb14d$export$b86a388af82085af = {}));
var $b174d3658eafb14d$export$2ec29642a27fd055;
(function(ConfirmSignUpException) {
    ConfirmSignUpException["AliasExistsException"] = "AliasExistsException";
    ConfirmSignUpException["CodeMismatchException"] = "CodeMismatchException";
    ConfirmSignUpException["ExpiredCodeException"] = "ExpiredCodeException";
    ConfirmSignUpException["ForbiddenException"] = "ForbiddenException";
    ConfirmSignUpException["InternalErrorException"] = "InternalErrorException";
    ConfirmSignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ConfirmSignUpException["InvalidParameterException"] = "InvalidParameterException";
    ConfirmSignUpException["LimitExceededException"] = "LimitExceededException";
    ConfirmSignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    ConfirmSignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ConfirmSignUpException["TooManyFailedAttemptsException"] = "TooManyFailedAttemptsException";
    ConfirmSignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    ConfirmSignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ConfirmSignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ConfirmSignUpException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$2ec29642a27fd055 || ($b174d3658eafb14d$export$2ec29642a27fd055 = {}));
var $b174d3658eafb14d$export$c6d546f0ab5ecb26;
(function(DeleteUserAttributesException) {
    DeleteUserAttributesException["ForbiddenException"] = "ForbiddenException";
    DeleteUserAttributesException["InternalErrorException"] = "InternalErrorException";
    DeleteUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$c6d546f0ab5ecb26 || ($b174d3658eafb14d$export$c6d546f0ab5ecb26 = {}));
var $b174d3658eafb14d$export$315864c77a135492;
(function(DeleteUserException) {
    DeleteUserException["ForbiddenException"] = "ForbiddenException";
    DeleteUserException["InternalErrorException"] = "InternalErrorException";
    DeleteUserException["InvalidParameterException"] = "InvalidParameterException";
    DeleteUserException["NotAuthorizedException"] = "NotAuthorizedException";
    DeleteUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    DeleteUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    DeleteUserException["TooManyRequestsException"] = "TooManyRequestsException";
    DeleteUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    DeleteUserException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$315864c77a135492 || ($b174d3658eafb14d$export$315864c77a135492 = {}));
var $b174d3658eafb14d$export$622cff54bc9a0bb0;
(function(ForgetDeviceException) {
    ForgetDeviceException["ForbiddenException"] = "ForbiddenException";
    ForgetDeviceException["InternalErrorException"] = "InternalErrorException";
    ForgetDeviceException["InvalidParameterException"] = "InvalidParameterException";
    ForgetDeviceException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ForgetDeviceException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgetDeviceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ForgetDeviceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgetDeviceException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgetDeviceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ForgetDeviceException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$622cff54bc9a0bb0 || ($b174d3658eafb14d$export$622cff54bc9a0bb0 = {}));
var $b174d3658eafb14d$export$cedaef1e1242f8be;
(function(ForgotPasswordException) {
    ForgotPasswordException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ForgotPasswordException["ForbiddenException"] = "ForbiddenException";
    ForgotPasswordException["InternalErrorException"] = "InternalErrorException";
    ForgotPasswordException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ForgotPasswordException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ForgotPasswordException["InvalidParameterException"] = "InvalidParameterException";
    ForgotPasswordException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ForgotPasswordException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ForgotPasswordException["LimitExceededException"] = "LimitExceededException";
    ForgotPasswordException["NotAuthorizedException"] = "NotAuthorizedException";
    ForgotPasswordException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ForgotPasswordException["TooManyRequestsException"] = "TooManyRequestsException";
    ForgotPasswordException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ForgotPasswordException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ForgotPasswordException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$cedaef1e1242f8be || ($b174d3658eafb14d$export$cedaef1e1242f8be = {}));
var $b174d3658eafb14d$export$8d5b6b7a140e0c94;
(function(GetUserException) {
    GetUserException["ForbiddenException"] = "ForbiddenException";
    GetUserException["InternalErrorException"] = "InternalErrorException";
    GetUserException["InvalidParameterException"] = "InvalidParameterException";
    GetUserException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$8d5b6b7a140e0c94 || ($b174d3658eafb14d$export$8d5b6b7a140e0c94 = {}));
var $b174d3658eafb14d$export$506f117795ed2bb2;
(function(GetIdException) {
    GetIdException["ExternalServiceException"] = "ExternalServiceException";
    GetIdException["InternalErrorException"] = "InternalErrorException";
    GetIdException["InvalidParameterException"] = "InvalidParameterException";
    GetIdException["LimitExceededException"] = "LimitExceededException";
    GetIdException["NotAuthorizedException"] = "NotAuthorizedException";
    GetIdException["ResourceConflictException"] = "ResourceConflictException";
    GetIdException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetIdException["TooManyRequestsException"] = "TooManyRequestsException";
})($b174d3658eafb14d$export$506f117795ed2bb2 || ($b174d3658eafb14d$export$506f117795ed2bb2 = {}));
var $b174d3658eafb14d$export$9bff15c85d75f437;
(function(GetCredentialsForIdentityException) {
    GetCredentialsForIdentityException["ExternalServiceException"] = "ExternalServiceException";
    GetCredentialsForIdentityException["InternalErrorException"] = "InternalErrorException";
    GetCredentialsForIdentityException["InvalidIdentityPoolConfigurationException"] = "InvalidIdentityPoolConfigurationException";
    GetCredentialsForIdentityException["InvalidParameterException"] = "InvalidParameterException";
    GetCredentialsForIdentityException["NotAuthorizedException"] = "NotAuthorizedException";
    GetCredentialsForIdentityException["ResourceConflictException"] = "ResourceConflictException";
    GetCredentialsForIdentityException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetCredentialsForIdentityException["TooManyRequestsException"] = "TooManyRequestsException";
})($b174d3658eafb14d$export$9bff15c85d75f437 || ($b174d3658eafb14d$export$9bff15c85d75f437 = {}));
var $b174d3658eafb14d$export$2a6bba23fbf84d1b;
(function(GetUserAttributeVerificationException) {
    GetUserAttributeVerificationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    GetUserAttributeVerificationException["ForbiddenException"] = "ForbiddenException";
    GetUserAttributeVerificationException["InternalErrorException"] = "InternalErrorException";
    GetUserAttributeVerificationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    GetUserAttributeVerificationException["InvalidParameterException"] = "InvalidParameterException";
    GetUserAttributeVerificationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    GetUserAttributeVerificationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    GetUserAttributeVerificationException["LimitExceededException"] = "LimitExceededException";
    GetUserAttributeVerificationException["NotAuthorizedException"] = "NotAuthorizedException";
    GetUserAttributeVerificationException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GetUserAttributeVerificationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GetUserAttributeVerificationException["TooManyRequestsException"] = "TooManyRequestsException";
    GetUserAttributeVerificationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    GetUserAttributeVerificationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    GetUserAttributeVerificationException["UserNotConfirmedException"] = "UserNotConfirmedException";
    GetUserAttributeVerificationException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$2a6bba23fbf84d1b || ($b174d3658eafb14d$export$2a6bba23fbf84d1b = {}));
var $b174d3658eafb14d$export$3f7e490ba4e0b71e;
(function(GlobalSignOutException) {
    GlobalSignOutException["ForbiddenException"] = "ForbiddenException";
    GlobalSignOutException["InternalErrorException"] = "InternalErrorException";
    GlobalSignOutException["InvalidParameterException"] = "InvalidParameterException";
    GlobalSignOutException["NotAuthorizedException"] = "NotAuthorizedException";
    GlobalSignOutException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    GlobalSignOutException["ResourceNotFoundException"] = "ResourceNotFoundException";
    GlobalSignOutException["TooManyRequestsException"] = "TooManyRequestsException";
    GlobalSignOutException["UserNotConfirmedException"] = "UserNotConfirmedException";
})($b174d3658eafb14d$export$3f7e490ba4e0b71e || ($b174d3658eafb14d$export$3f7e490ba4e0b71e = {}));
var $b174d3658eafb14d$export$43ac0110dfdad33b;
(function(InitiateAuthException) {
    InitiateAuthException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    InitiateAuthException["ForbiddenException"] = "ForbiddenException";
    InitiateAuthException["InternalErrorException"] = "InternalErrorException";
    InitiateAuthException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    InitiateAuthException["InvalidParameterException"] = "InvalidParameterException";
    InitiateAuthException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    InitiateAuthException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    InitiateAuthException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    InitiateAuthException["NotAuthorizedException"] = "NotAuthorizedException";
    InitiateAuthException["ResourceNotFoundException"] = "ResourceNotFoundException";
    InitiateAuthException["TooManyRequestsException"] = "TooManyRequestsException";
    InitiateAuthException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    InitiateAuthException["UserLambdaValidationException"] = "UserLambdaValidationException";
    InitiateAuthException["UserNotConfirmedException"] = "UserNotConfirmedException";
    InitiateAuthException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$43ac0110dfdad33b || ($b174d3658eafb14d$export$43ac0110dfdad33b = {}));
var $b174d3658eafb14d$export$8807b62ddb0e4d9d;
(function(ResendConfirmationException) {
    ResendConfirmationException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    ResendConfirmationException["ForbiddenException"] = "ForbiddenException";
    ResendConfirmationException["InternalErrorException"] = "InternalErrorException";
    ResendConfirmationException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    ResendConfirmationException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    ResendConfirmationException["InvalidParameterException"] = "InvalidParameterException";
    ResendConfirmationException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    ResendConfirmationException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    ResendConfirmationException["LimitExceededException"] = "LimitExceededException";
    ResendConfirmationException["NotAuthorizedException"] = "NotAuthorizedException";
    ResendConfirmationException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ResendConfirmationException["TooManyRequestsException"] = "TooManyRequestsException";
    ResendConfirmationException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    ResendConfirmationException["UserLambdaValidationException"] = "UserLambdaValidationException";
    ResendConfirmationException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$8807b62ddb0e4d9d || ($b174d3658eafb14d$export$8807b62ddb0e4d9d = {}));
var $b174d3658eafb14d$export$da9908386393628f;
(function(RespondToAuthChallengeException) {
    RespondToAuthChallengeException["AliasExistsException"] = "AliasExistsException";
    RespondToAuthChallengeException["CodeMismatchException"] = "CodeMismatchException";
    RespondToAuthChallengeException["ExpiredCodeException"] = "ExpiredCodeException";
    RespondToAuthChallengeException["ForbiddenException"] = "ForbiddenException";
    RespondToAuthChallengeException["InternalErrorException"] = "InternalErrorException";
    RespondToAuthChallengeException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    RespondToAuthChallengeException["InvalidParameterException"] = "InvalidParameterException";
    RespondToAuthChallengeException["InvalidPasswordException"] = "InvalidPasswordException";
    RespondToAuthChallengeException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    RespondToAuthChallengeException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    RespondToAuthChallengeException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    RespondToAuthChallengeException["MFAMethodNotFoundException"] = "MFAMethodNotFoundException";
    RespondToAuthChallengeException["NotAuthorizedException"] = "NotAuthorizedException";
    RespondToAuthChallengeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    RespondToAuthChallengeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    RespondToAuthChallengeException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    RespondToAuthChallengeException["TooManyRequestsException"] = "TooManyRequestsException";
    RespondToAuthChallengeException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    RespondToAuthChallengeException["UserLambdaValidationException"] = "UserLambdaValidationException";
    RespondToAuthChallengeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    RespondToAuthChallengeException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$da9908386393628f || ($b174d3658eafb14d$export$da9908386393628f = {}));
var $b174d3658eafb14d$export$23ea34859d89459d;
(function(SetUserMFAPreferenceException) {
    SetUserMFAPreferenceException["ForbiddenException"] = "ForbiddenException";
    SetUserMFAPreferenceException["InternalErrorException"] = "InternalErrorException";
    SetUserMFAPreferenceException["InvalidParameterException"] = "InvalidParameterException";
    SetUserMFAPreferenceException["NotAuthorizedException"] = "NotAuthorizedException";
    SetUserMFAPreferenceException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    SetUserMFAPreferenceException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SetUserMFAPreferenceException["UserNotConfirmedException"] = "UserNotConfirmedException";
    SetUserMFAPreferenceException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$23ea34859d89459d || ($b174d3658eafb14d$export$23ea34859d89459d = {}));
var $b174d3658eafb14d$export$d0816902ed99fce6;
(function(SignUpException) {
    SignUpException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    SignUpException["InternalErrorException"] = "InternalErrorException";
    SignUpException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    SignUpException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    SignUpException["InvalidParameterException"] = "InvalidParameterException";
    SignUpException["InvalidPasswordException"] = "InvalidPasswordException";
    SignUpException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    SignUpException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    SignUpException["NotAuthorizedException"] = "NotAuthorizedException";
    SignUpException["ResourceNotFoundException"] = "ResourceNotFoundException";
    SignUpException["TooManyRequestsException"] = "TooManyRequestsException";
    SignUpException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    SignUpException["UserLambdaValidationException"] = "UserLambdaValidationException";
    SignUpException["UsernameExistsException"] = "UsernameExistsException";
})($b174d3658eafb14d$export$d0816902ed99fce6 || ($b174d3658eafb14d$export$d0816902ed99fce6 = {}));
var $b174d3658eafb14d$export$44cb15f260897376;
(function(UpdateUserAttributesException) {
    UpdateUserAttributesException["AliasExistsException"] = "AliasExistsException";
    UpdateUserAttributesException["CodeDeliveryFailureException"] = "CodeDeliveryFailureException";
    UpdateUserAttributesException["CodeMismatchException"] = "CodeMismatchException";
    UpdateUserAttributesException["ExpiredCodeException"] = "ExpiredCodeException";
    UpdateUserAttributesException["ForbiddenException"] = "ForbiddenException";
    UpdateUserAttributesException["InternalErrorException"] = "InternalErrorException";
    UpdateUserAttributesException["InvalidEmailRoleAccessPolicyException"] = "InvalidEmailRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidLambdaResponseException"] = "InvalidLambdaResponseException";
    UpdateUserAttributesException["InvalidParameterException"] = "InvalidParameterException";
    UpdateUserAttributesException["InvalidSmsRoleAccessPolicyException"] = "InvalidSmsRoleAccessPolicyException";
    UpdateUserAttributesException["InvalidSmsRoleTrustRelationshipException"] = "InvalidSmsRoleTrustRelationshipException";
    UpdateUserAttributesException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateUserAttributesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateUserAttributesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateUserAttributesException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateUserAttributesException["UnexpectedLambdaException"] = "UnexpectedLambdaException";
    UpdateUserAttributesException["UserLambdaValidationException"] = "UserLambdaValidationException";
    UpdateUserAttributesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateUserAttributesException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$44cb15f260897376 || ($b174d3658eafb14d$export$44cb15f260897376 = {}));
var $b174d3658eafb14d$export$a974f64d24be573a;
(function(VerifySoftwareTokenException) {
    VerifySoftwareTokenException["CodeMismatchException"] = "CodeMismatchException";
    VerifySoftwareTokenException["EnableSoftwareTokenMFAException"] = "EnableSoftwareTokenMFAException";
    VerifySoftwareTokenException["ForbiddenException"] = "ForbiddenException";
    VerifySoftwareTokenException["InternalErrorException"] = "InternalErrorException";
    VerifySoftwareTokenException["InvalidParameterException"] = "InvalidParameterException";
    VerifySoftwareTokenException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    VerifySoftwareTokenException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifySoftwareTokenException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifySoftwareTokenException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifySoftwareTokenException["SoftwareTokenMFANotFoundException"] = "SoftwareTokenMFANotFoundException";
    VerifySoftwareTokenException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifySoftwareTokenException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifySoftwareTokenException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$a974f64d24be573a || ($b174d3658eafb14d$export$a974f64d24be573a = {}));
var $b174d3658eafb14d$export$527caabb62d14fe3;
(function(VerifyUserAttributeException) {
    VerifyUserAttributeException["AliasExistsException"] = "AliasExistsException";
    VerifyUserAttributeException["CodeMismatchException"] = "CodeMismatchException";
    VerifyUserAttributeException["ExpiredCodeException"] = "ExpiredCodeException";
    VerifyUserAttributeException["ForbiddenException"] = "ForbiddenException";
    VerifyUserAttributeException["InternalErrorException"] = "InternalErrorException";
    VerifyUserAttributeException["InvalidParameterException"] = "InvalidParameterException";
    VerifyUserAttributeException["LimitExceededException"] = "LimitExceededException";
    VerifyUserAttributeException["NotAuthorizedException"] = "NotAuthorizedException";
    VerifyUserAttributeException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    VerifyUserAttributeException["ResourceNotFoundException"] = "ResourceNotFoundException";
    VerifyUserAttributeException["TooManyRequestsException"] = "TooManyRequestsException";
    VerifyUserAttributeException["UserNotConfirmedException"] = "UserNotConfirmedException";
    VerifyUserAttributeException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$527caabb62d14fe3 || ($b174d3658eafb14d$export$527caabb62d14fe3 = {}));
var $b174d3658eafb14d$export$de57be1863bdb9d6;
(function(UpdateDeviceStatusException) {
    UpdateDeviceStatusException["ForbiddenException"] = "ForbiddenException";
    UpdateDeviceStatusException["InternalErrorException"] = "InternalErrorException";
    UpdateDeviceStatusException["InvalidParameterException"] = "InvalidParameterException";
    UpdateDeviceStatusException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    UpdateDeviceStatusException["NotAuthorizedException"] = "NotAuthorizedException";
    UpdateDeviceStatusException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    UpdateDeviceStatusException["ResourceNotFoundException"] = "ResourceNotFoundException";
    UpdateDeviceStatusException["TooManyRequestsException"] = "TooManyRequestsException";
    UpdateDeviceStatusException["UserNotConfirmedException"] = "UserNotConfirmedException";
    UpdateDeviceStatusException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$de57be1863bdb9d6 || ($b174d3658eafb14d$export$de57be1863bdb9d6 = {}));
var $b174d3658eafb14d$export$eb8cb06bdb07bf0c;
(function(ListDevicesException) {
    ListDevicesException["ForbiddenException"] = "ForbiddenException";
    ListDevicesException["InternalErrorException"] = "InternalErrorException";
    ListDevicesException["InvalidParameterException"] = "InvalidParameterException";
    ListDevicesException["InvalidUserPoolConfigurationException"] = "InvalidUserPoolConfigurationException";
    ListDevicesException["NotAuthorizedException"] = "NotAuthorizedException";
    ListDevicesException["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    ListDevicesException["ResourceNotFoundException"] = "ResourceNotFoundException";
    ListDevicesException["TooManyRequestsException"] = "TooManyRequestsException";
    ListDevicesException["UserNotConfirmedException"] = "UserNotConfirmedException";
    ListDevicesException["UserNotFoundException"] = "UserNotFoundException";
})($b174d3658eafb14d$export$eb8cb06bdb07bf0c || ($b174d3658eafb14d$export$eb8cb06bdb07bf0c = {}));
const $b174d3658eafb14d$export$ecd3eb1722b48d26 = "SetUpTOTPException";













// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $7063125feda4194a$var$USER_ATTRIBUTES = "userAttributes.";
async function $7063125feda4194a$export$6fe6331471b54d26({ challengeResponse: challengeResponse, clientMetadata: clientMetadata, session: session, username: username, config: config, tokenOrchestrator: tokenOrchestrator }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    const challengeResponses = {
        USERNAME: username,
        ANSWER: challengeResponse
    };
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses["DEVICE_KEY"] = deviceMetadata.deviceKey;
    const UserContextData = (0, $30f7d7d7c5349180$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "CUSTOM_CHALLENGE",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const response = await (0, $c845c6a72bc4ff0c$export$b196467a22b300ec)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $7063125feda4194a$var$handleDeviceSRPAuth({
        username: username,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $7063125feda4194a$export$9b78cd405a35bccd({ challengeResponse: challengeResponse, username: username, clientMetadata: clientMetadata, session: session, deviceName: deviceName, config: config }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    const challengeResponses = {
        USERNAME: username
    };
    const { Session: Session } = await (0, $c845c6a72bc4ff0c$export$72b1124e126ff51c)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).ConfirmSignIn)
    }, {
        UserCode: challengeResponse,
        Session: session,
        FriendlyDeviceName: deviceName
    });
    (0, $f136ba74979ac757$export$390d5da4c63a4a41).dispatch({
        type: "SET_SIGN_IN_SESSION",
        value: Session
    });
    const jsonReq = {
        ChallengeName: "MFA_SETUP",
        ChallengeResponses: challengeResponses,
        Session: Session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId
    };
    return (0, $c845c6a72bc4ff0c$export$b196467a22b300ec)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(userPoolId)
    }, jsonReq);
}
async function $7063125feda4194a$export$f0699fc2b71f49c0({ challengeResponse: challengeResponse, username: username, clientMetadata: clientMetadata, session: session, config: config }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(challengeResponse === "TOTP" || challengeResponse === "SMS", (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).IncorrectMFAMethod);
    const challengeResponses = {
        USERNAME: username,
        ANSWER: $7063125feda4194a$export$7e7902092e38fcff(challengeResponse)
    };
    const UserContextData = (0, $30f7d7d7c5349180$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "SELECT_MFA_TYPE",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    return (0, $c845c6a72bc4ff0c$export$b196467a22b300ec)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $7063125feda4194a$export$3eab958abdf5e22d({ challengeResponse: challengeResponse, clientMetadata: clientMetadata, session: session, username: username, config: config }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    const challengeResponses = {
        USERNAME: username,
        SMS_MFA_CODE: challengeResponse
    };
    const UserContextData = (0, $30f7d7d7c5349180$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "SMS_MFA",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    return (0, $c845c6a72bc4ff0c$export$b196467a22b300ec)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $7063125feda4194a$export$b89ff5a8f5e11286({ challengeResponse: challengeResponse, clientMetadata: clientMetadata, session: session, username: username, config: config }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    const challengeResponses = {
        USERNAME: username,
        SOFTWARE_TOKEN_MFA_CODE: challengeResponse
    };
    const UserContextData = (0, $30f7d7d7c5349180$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "SOFTWARE_TOKEN_MFA",
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    return (0, $c845c6a72bc4ff0c$export$b196467a22b300ec)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $7063125feda4194a$export$df3f8a8c68da6a2e({ challengeResponse: challengeResponse, clientMetadata: clientMetadata, session: session, username: username, requiredAttributes: requiredAttributes, config: config }) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    const challengeResponses = {
        ...$7063125feda4194a$export$c7c9603a6b1fd815(requiredAttributes),
        NEW_PASSWORD: challengeResponse,
        USERNAME: username
    };
    const UserContextData = (0, $30f7d7d7c5349180$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        ChallengeName: "NEW_PASSWORD_REQUIRED",
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    return (0, $c845c6a72bc4ff0c$export$b196467a22b300ec)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).ConfirmSignIn)
    }, jsonReq);
}
async function $7063125feda4194a$export$29fb48d356e16a7(username, password, clientMetadata, config, tokenOrchestrator) {
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId } = config;
    const authParameters = {
        USERNAME: username,
        PASSWORD: password
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters["DEVICE_KEY"] = deviceMetadata.deviceKey;
    const UserContextData = (0, $30f7d7d7c5349180$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "USER_PASSWORD_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const response = await (0, $c845c6a72bc4ff0c$export$567b0d5ec943f827)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = response.ChallengeParameters?.USERNAME ?? response.ChallengeParameters?.USER_ID_FOR_SRP ?? username;
    $7063125feda4194a$export$fecfbc200868d412(activeUsername);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $7063125feda4194a$var$handleDeviceSRPAuth({
        username: activeUsername,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $7063125feda4194a$export$13a3ef5ef8cac338(username, password, clientMetadata, config, tokenOrchestrator) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const authenticationHelper = await (0, $5c06437bc80c5efc$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16)
    };
    const UserContextData = (0, $30f7d7d7c5349180$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "USER_SRP_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const resp = await (0, $c845c6a72bc4ff0c$export$567b0d5ec943f827)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const { ChallengeParameters: challengeParameters, Session: session } = resp;
    const activeUsername = challengeParameters?.USERNAME ?? username;
    $7063125feda4194a$export$fecfbc200868d412(activeUsername);
    return $7063125feda4194a$export$30f932fe98713ccc($7063125feda4194a$export$7f7b64167822fe34, [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
}
async function $7063125feda4194a$export$1a654dcab55e0de5(username, clientMetadata, config, tokenOrchestrator) {
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId } = config;
    const authParameters = {
        USERNAME: username
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) authParameters["DEVICE_KEY"] = deviceMetadata.deviceKey;
    const UserContextData = (0, $30f7d7d7c5349180$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "CUSTOM_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const response = await (0, $c845c6a72bc4ff0c$export$567b0d5ec943f827)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = response.ChallengeParameters?.USERNAME ?? username;
    $7063125feda4194a$export$fecfbc200868d412(activeUsername);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $7063125feda4194a$var$handleDeviceSRPAuth({
        username: activeUsername,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $7063125feda4194a$export$9ce9dd351616104c(username, password, clientMetadata, config, tokenOrchestrator) {
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(config);
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const authenticationHelper = await (0, $5c06437bc80c5efc$export$47560e2dc89f678c)(userPoolName);
    const authParameters = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        CHALLENGE_NAME: "SRP_A"
    };
    const UserContextData = (0, $30f7d7d7c5349180$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReq = {
        AuthFlow: "CUSTOM_AUTH",
        AuthParameters: authParameters,
        ClientMetadata: clientMetadata,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const { ChallengeParameters: challengeParameters, Session: session } = await (0, $c845c6a72bc4ff0c$export$567b0d5ec943f827)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).SignIn)
    }, jsonReq);
    const activeUsername = challengeParameters?.USERNAME ?? username;
    $7063125feda4194a$export$fecfbc200868d412(activeUsername);
    return $7063125feda4194a$export$30f932fe98713ccc($7063125feda4194a$export$7f7b64167822fe34, [
        password,
        challengeParameters,
        clientMetadata,
        session,
        authenticationHelper,
        config,
        tokenOrchestrator
    ], activeUsername, tokenOrchestrator);
}
async function $7063125feda4194a$var$handleDeviceSRPAuth({ username: username, config: config, clientMetadata: clientMetadata, session: session, tokenOrchestrator: tokenOrchestrator }) {
    const userPoolId = config.userPoolId;
    const clientId = config.userPoolClientId;
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    (0, $627294a07e5270d4$export$b6f03be79626ab0f)(deviceMetadata);
    const authenticationHelper = await (0, $5c06437bc80c5efc$export$47560e2dc89f678c)(deviceMetadata.deviceGroupKey);
    const challengeResponses = {
        USERNAME: username,
        SRP_A: authenticationHelper.A.toString(16),
        DEVICE_KEY: deviceMetadata.deviceKey
    };
    const jsonReqResponseChallenge = {
        ChallengeName: "DEVICE_SRP_AUTH",
        ClientId: clientId,
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session
    };
    const { ChallengeParameters: ChallengeParameters, Session: Session } = await (0, $c845c6a72bc4ff0c$export$b196467a22b300ec)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(userPoolId)
    }, jsonReqResponseChallenge);
    return $7063125feda4194a$var$handleDevicePasswordVerifier(username, ChallengeParameters, clientMetadata, Session, authenticationHelper, config, tokenOrchestrator);
}
async function $7063125feda4194a$var$handleDevicePasswordVerifier(username, challengeParameters, clientMetadata, session, authenticationHelper, { userPoolId: userPoolId, userPoolClientId: userPoolClientId }, tokenOrchestrator) {
    const deviceMetadata = await tokenOrchestrator?.getDeviceMetadata(username);
    (0, $627294a07e5270d4$export$b6f03be79626ab0f)(deviceMetadata);
    const serverBValue = new (0, $60cae906d2aae07c$export$2e2bcd8739ae039)(challengeParameters?.SRP_B, 16);
    const salt = new (0, $60cae906d2aae07c$export$2e2bcd8739ae039)(challengeParameters?.SALT, 16);
    const deviceKey = deviceMetadata.deviceKey;
    const deviceGroupKey = deviceMetadata.deviceGroupKey;
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username: deviceMetadata.deviceKey,
        password: deviceMetadata.randomPassword,
        serverBValue: serverBValue,
        salt: salt
    });
    const dateNow = (0, $8421d1c3e611515b$export$218a6e05f05aec48)();
    const challengeResponses = {
        USERNAME: challengeParameters?.USERNAME ?? username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters?.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, $070cfa915a96d92a$export$577b7d8a4f1b23fd)({
            username: deviceKey,
            userPoolName: deviceGroupKey,
            challengeParameters: challengeParameters,
            dateNow: dateNow,
            hkdf: hkdf
        }),
        DEVICE_KEY: deviceKey
    };
    const UserContextData = (0, $30f7d7d7c5349180$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
        ClientId: userPoolClientId,
        ChallengeResponses: challengeResponses,
        Session: session,
        ClientMetadata: clientMetadata,
        UserContextData: UserContextData
    };
    return (0, $c845c6a72bc4ff0c$export$b196467a22b300ec)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(userPoolId)
    }, jsonReqResponseChallenge);
}
async function $7063125feda4194a$export$7f7b64167822fe34(password, challengeParameters, clientMetadata, session, authenticationHelper, config, tokenOrchestrator) {
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = config;
    const userPoolName = userPoolId?.split("_")[1] || "";
    const serverBValue = new (0, $60cae906d2aae07c$export$2e2bcd8739ae039)(challengeParameters?.SRP_B, 16);
    const salt = new (0, $60cae906d2aae07c$export$2e2bcd8739ae039)(challengeParameters?.SALT, 16);
    const username = challengeParameters?.USER_ID_FOR_SRP;
    if (!username) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: "EmptyUserIdForSRPException",
        message: "USER_ID_FOR_SRP was not found in challengeParameters"
    });
    const hkdf = await authenticationHelper.getPasswordAuthenticationKey({
        username: username,
        password: password,
        serverBValue: serverBValue,
        salt: salt
    });
    const dateNow = (0, $8421d1c3e611515b$export$218a6e05f05aec48)();
    const challengeResponses = {
        USERNAME: username,
        PASSWORD_CLAIM_SECRET_BLOCK: challengeParameters?.SECRET_BLOCK,
        TIMESTAMP: dateNow,
        PASSWORD_CLAIM_SIGNATURE: (0, $070cfa915a96d92a$export$577b7d8a4f1b23fd)({
            username: username,
            userPoolName: userPoolName,
            challengeParameters: challengeParameters,
            dateNow: dateNow,
            hkdf: hkdf
        })
    };
    const deviceMetadata = await tokenOrchestrator.getDeviceMetadata(username);
    if (deviceMetadata && deviceMetadata.deviceKey) challengeResponses["DEVICE_KEY"] = deviceMetadata.deviceKey;
    const UserContextData = (0, $30f7d7d7c5349180$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const jsonReqResponseChallenge = {
        ChallengeName: "PASSWORD_VERIFIER",
        ChallengeResponses: challengeResponses,
        ClientMetadata: clientMetadata,
        Session: session,
        ClientId: userPoolClientId,
        UserContextData: UserContextData
    };
    const response = await (0, $c845c6a72bc4ff0c$export$b196467a22b300ec)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(userPoolId)
    }, jsonReqResponseChallenge);
    if (response.ChallengeName === "DEVICE_SRP_AUTH") return $7063125feda4194a$var$handleDeviceSRPAuth({
        username: username,
        config: config,
        clientMetadata: clientMetadata,
        session: response.Session,
        tokenOrchestrator: tokenOrchestrator
    });
    return response;
}
async function $7063125feda4194a$export$cf152400b58b8e65(params) {
    const { challengeName: challengeName, challengeParameters: challengeParameters } = params;
    const authConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
    switch(challengeName){
        case "CUSTOM_CHALLENGE":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE",
                    additionalInfo: challengeParameters
                }
            };
        case "MFA_SETUP":
            const { signInSession: signInSession, username: username } = (0, $f136ba74979ac757$export$390d5da4c63a4a41).getState();
            if (!$7063125feda4194a$export$aac29c972ddf3e91(challengeParameters, "TOTP")) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
                name: (0, $108fcfdf7ca8fb61$export$473ab0b56598aacd).SignInException,
                message: `Cannot initiate MFA setup from available types: ${$7063125feda4194a$export$d70c792e078766ea($7063125feda4194a$export$4055ded9e78438ba(challengeParameters.MFAS_CAN_SETUP))}`
            });
            const { Session: Session, SecretCode: secretCode } = await (0, $c845c6a72bc4ff0c$export$4531a27964554be8)({
                region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(authConfig.userPoolId)
            }, {
                Session: signInSession
            });
            (0, $f136ba74979ac757$export$390d5da4c63a4a41).dispatch({
                type: "SET_SIGN_IN_SESSION",
                value: Session
            });
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONTINUE_SIGN_IN_WITH_TOTP_SETUP",
                    totpSetupDetails: $7063125feda4194a$export$b105c3e8e4f5ce91(secretCode, username)
                }
            };
        case "NEW_PASSWORD_REQUIRED":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
                    missingAttributes: $7063125feda4194a$export$fbe550151e406473(challengeParameters.requiredAttributes)
                }
            };
        case "SELECT_MFA_TYPE":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONTINUE_SIGN_IN_WITH_MFA_SELECTION",
                    allowedMFATypes: $7063125feda4194a$export$d70c792e078766ea($7063125feda4194a$export$4055ded9e78438ba(challengeParameters.MFAS_CAN_CHOOSE))
                }
            };
        case "SMS_MFA":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_SMS_CODE",
                    codeDeliveryDetails: {
                        deliveryMedium: challengeParameters.CODE_DELIVERY_DELIVERY_MEDIUM,
                        destination: challengeParameters.CODE_DELIVERY_DESTINATION
                    }
                }
            };
        case "SOFTWARE_TOKEN_MFA":
            return {
                isSignedIn: false,
                nextStep: {
                    signInStep: "CONFIRM_SIGN_IN_WITH_TOTP_CODE"
                }
            };
    }
    // TODO: remove this error message for production apps
    throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: (0, $108fcfdf7ca8fb61$export$473ab0b56598aacd).SignInException,
        message: "An error occurred during the sign in process. " + `${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function $7063125feda4194a$export$b105c3e8e4f5ce91(secretCode, username) {
    return {
        sharedSecret: secretCode,
        getSetupUri: (appName, accountName)=>{
            const totpUri = `otpauth://totp/${appName}:${accountName ?? username}?secret=${secretCode}&issuer=${appName}`;
            return new (0, $3d238183541c5736$export$beb82d9d9136c16e)(totpUri);
        }
    };
}
function $7063125feda4194a$export$cafe99bb44d49edb(errorName) {
    if (errorName === (0, $b174d3658eafb14d$export$43ac0110dfdad33b).PasswordResetRequiredException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: "RESET_PASSWORD"
        }
    };
    else if (errorName === (0, $b174d3658eafb14d$export$43ac0110dfdad33b).UserNotConfirmedException) return {
        isSignedIn: false,
        nextStep: {
            signInStep: "CONFIRM_SIGN_UP"
        }
    };
}
function $7063125feda4194a$export$fbe550151e406473(attributes) {
    if (!attributes) return [];
    const parsedAttributes = JSON.parse(attributes).map((att)=>att.includes($7063125feda4194a$var$USER_ATTRIBUTES) ? att.replace($7063125feda4194a$var$USER_ATTRIBUTES, "") : att);
    return parsedAttributes;
}
function $7063125feda4194a$export$c7c9603a6b1fd815(attributes) {
    if (!attributes) return {};
    const newAttributes = {};
    Object.entries(attributes).forEach(([key, value])=>{
        if (value) newAttributes[`${$7063125feda4194a$var$USER_ATTRIBUTES}${key}`] = value;
    });
    return newAttributes;
}
async function $7063125feda4194a$export$cfd8b50d0f78e4fa(username, challengeName, session, challengeResponse, config, tokenOrchestrator, clientMetadata, options) {
    const userAttributes = options?.userAttributes;
    const deviceName = options?.friendlyDeviceName;
    switch(challengeName){
        case "SMS_MFA":
            return $7063125feda4194a$export$3eab958abdf5e22d({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
        case "SELECT_MFA_TYPE":
            return $7063125feda4194a$export$f0699fc2b71f49c0({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
        case "MFA_SETUP":
            return $7063125feda4194a$export$9b78cd405a35bccd({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                deviceName: deviceName,
                config: config
            });
        case "NEW_PASSWORD_REQUIRED":
            return $7063125feda4194a$export$df3f8a8c68da6a2e({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                requiredAttributes: userAttributes,
                config: config
            });
        case "CUSTOM_CHALLENGE":
            return $7063125feda4194a$export$30f932fe98713ccc($7063125feda4194a$export$6fe6331471b54d26, [
                {
                    challengeResponse: challengeResponse,
                    clientMetadata: clientMetadata,
                    session: session,
                    username: username,
                    config: config,
                    tokenOrchestrator: tokenOrchestrator
                }
            ], username, tokenOrchestrator);
        case "SOFTWARE_TOKEN_MFA":
            return $7063125feda4194a$export$b89ff5a8f5e11286({
                challengeResponse: challengeResponse,
                clientMetadata: clientMetadata,
                session: session,
                username: username,
                config: config
            });
    }
    // TODO: remove this error message for production apps
    throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: (0, $108fcfdf7ca8fb61$export$473ab0b56598aacd).SignInException,
        message: `An error occurred during the sign in process. 
		${challengeName} challengeName returned by the underlying service was not addressed.`
    });
}
function $7063125feda4194a$export$7e7902092e38fcff(mfa) {
    let mfaType = "SMS_MFA";
    if (mfa === "TOTP") mfaType = "SOFTWARE_TOKEN_MFA";
    return mfaType;
}
function $7063125feda4194a$export$6ce04ce89055b1fe(type) {
    if (type === "SMS_MFA") return "SMS";
    if (type === "SOFTWARE_TOKEN_MFA") return "TOTP";
// TODO: log warning for unknown MFA type
}
function $7063125feda4194a$export$d70c792e078766ea(types) {
    if (!types) return undefined;
    return types.map($7063125feda4194a$export$6ce04ce89055b1fe).filter(Boolean);
}
function $7063125feda4194a$export$4055ded9e78438ba(mfa) {
    if (!mfa) return [];
    return JSON.parse(mfa);
}
function $7063125feda4194a$export$aac29c972ddf3e91(challengeParams, mfaType) {
    const { MFAS_CAN_SETUP: MFAS_CAN_SETUP } = challengeParams;
    const mfaTypes = $7063125feda4194a$export$d70c792e078766ea($7063125feda4194a$export$4055ded9e78438ba(MFAS_CAN_SETUP));
    if (!mfaTypes) return false;
    return mfaTypes.includes(mfaType);
}
async function $7063125feda4194a$export$8061cd07f982ef08() {
    let authUser;
    try {
        authUser = await (0, $95f3b5487ad3e06b$export$e5432d4c8eb97ea7)();
    } catch (error) {}
    if (authUser && authUser.userId && authUser.username) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: (0, $7674474451b5177a$export$bdd0e7e9babcd5c8),
        message: "There is already a signed in user.",
        recoverySuggestion: "Call signOut before calling signIn again."
    });
}
/**
 * This function is used to kick off the device management flow.
 *
 * If an error is thrown while generating a hash device or calling the `ConfirmDevice`
 * client, then this API will ignore the error and return undefined. Otherwise the authentication
 * flow will not complete and the user won't be able to be signed in.
 *
 * @returns DeviceMetadata | undefined
 */ async function $7063125feda4194a$export$5fd317fac33d34b1(userPoolId, newDeviceMetadata, accessToken) {
    if (!newDeviceMetadata) return undefined;
    const userPoolName = userPoolId.split("_")[1] || "";
    const authenticationHelper = await (0, $5c06437bc80c5efc$export$47560e2dc89f678c)(userPoolName);
    const deviceKey = newDeviceMetadata?.DeviceKey;
    const deviceGroupKey = newDeviceMetadata?.DeviceGroupKey;
    try {
        await authenticationHelper.generateHashDevice(deviceGroupKey ?? "", deviceKey ?? "");
    } catch (errGenHash) {
        // TODO: log error here
        return undefined;
    }
    const deviceSecretVerifierConfig = {
        Salt: (0, $45965b0c21473608$export$695b149896bd3e2a).convert((0, $29691db684a6f942$export$b772e43c3daf2e7a)(authenticationHelper.getSaltToHashDevices())),
        PasswordVerifier: (0, $45965b0c21473608$export$695b149896bd3e2a).convert((0, $29691db684a6f942$export$b772e43c3daf2e7a)(authenticationHelper.getVerifierDevices()))
    };
    const randomPassword = authenticationHelper.getRandomPassword();
    try {
        await (0, $c845c6a72bc4ff0c$export$3a7ad63dc35b752f)({
            region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(userPoolId)
        }, {
            AccessToken: accessToken,
            DeviceKey: newDeviceMetadata?.DeviceKey,
            DeviceSecretVerifierConfig: deviceSecretVerifierConfig
        });
        return {
            deviceKey: deviceKey,
            deviceGroupKey: deviceGroupKey,
            randomPassword: randomPassword
        };
    } catch (error) {
        // TODO: log error here
        return undefined;
    }
}
/**
 * It will retry the function if the error is a `ResourceNotFoundException` and
 * will clean the device keys stored in the storage mechanism.
 *
 */ async function $7063125feda4194a$export$30f932fe98713ccc(func, args, username, tokenOrchestrator) {
    try {
        return await func(...args);
    } catch (error) {
        if (error instanceof (0, $f3f3005c274c9374$export$145273558d58e0ac) && error.name === "ResourceNotFoundException" && error.message.includes("Device does not exist.")) {
            await tokenOrchestrator.clearDeviceMetadata(username);
            return await func(...args);
        }
        throw error;
    }
}
function $7063125feda4194a$export$fecfbc200868d412(username) {
    const { dispatch: dispatch } = (0, $f136ba74979ac757$export$390d5da4c63a4a41);
    dispatch({
        type: "SET_USERNAME",
        value: username
    });
}
function $7063125feda4194a$export$cc3585de146a51be(username) {
    const state = (0, $f136ba74979ac757$export$390d5da4c63a4a41).getState();
    return state.username ?? username;
}










// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
async function $18561e240f7cae15$export$729df6fdd19b8b0d(AuthenticationResult) {
    if (AuthenticationResult.AccessToken) {
        const accessToken = (0, $a6de0542b1980a7d$export$9a62e6c0a30e00bc)(AuthenticationResult.AccessToken);
        const accessTokenIssuedAtInMillis = (accessToken.payload.iat || 0) * 1000;
        const currentTime = new Date().getTime();
        const clockDrift = accessTokenIssuedAtInMillis > 0 ? accessTokenIssuedAtInMillis - currentTime : 0;
        let idToken;
        let refreshToken;
        let deviceMetadata;
        if (AuthenticationResult.RefreshToken) refreshToken = AuthenticationResult.RefreshToken;
        if (AuthenticationResult.IdToken) idToken = (0, $a6de0542b1980a7d$export$9a62e6c0a30e00bc)(AuthenticationResult.IdToken);
        if (AuthenticationResult?.NewDeviceMetadata) deviceMetadata = AuthenticationResult.NewDeviceMetadata;
        const tokens = {
            accessToken: accessToken,
            idToken: idToken,
            refreshToken: refreshToken,
            clockDrift: clockDrift,
            deviceMetadata: deviceMetadata,
            username: AuthenticationResult.username
        };
        if (AuthenticationResult?.signInDetails) tokens.signInDetails = AuthenticationResult.signInDetails;
        await (0, $c6bbd61934ed7f36$export$66561e66d62991d0).setTokens({
            tokens: tokens
        });
    } else // This would be a service error
    throw new (0, $b4bc1e3f37fada93$export$37321a6dace1881c)({
        message: "Invalid tokens",
        name: "InvalidTokens",
        recoverySuggestion: "Check Cognito UserPool settings"
    });
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Continues or completes the sign in process when required by the initial call to `signIn`.
 *
 * @param input -  The ConfirmSignInInput object
 * @returns ConfirmSignInOutput
 * @throws  -{@link VerifySoftwareTokenException }:
 * Thrown due to an invalid MFA token.
 * @throws  -{@link RespondToAuthChallengeException }:
 * Thrown due to an invalid auth challenge response.
 * @throws  -{@link AssociateSoftwareTokenException}:
 * Thrown due to a service error during the MFA setup process.
 * @throws  -{@link AuthValidationErrorCode }:
 * Thrown when `challengeResponse` is not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $e1fb4f4fbfe74169$export$a477d84c2f7b792a(input) {
    const { challengeResponse: challengeResponse, options: options } = input;
    const { username: username, challengeName: challengeName, signInSession: signInSession, signInDetails: signInDetails } = (0, $f136ba74979ac757$export$390d5da4c63a4a41).getState();
    const authConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
    const clientMetaData = options?.clientMetadata;
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!challengeResponse, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyChallengeResponse);
    if (!username || !challengeName || !signInSession) // TODO: remove this error message for production apps
    throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: (0, $108fcfdf7ca8fb61$export$473ab0b56598aacd).SignInException,
        message: `
			An error occurred during the sign in process. 
			
			This most likely occurred due to:
			1. signIn was not called before confirmSignIn.
			2. signIn threw an exception.
			3. page was refreshed during the sign in flow.
			`,
        recoverySuggestion: "Make sure a successful call to signIn is made before calling confirmSignInand that the page is not refreshed until the sign in process is done."
    });
    try {
        const { Session: Session, ChallengeName: ChallengeName, AuthenticationResult: AuthenticationResult, ChallengeParameters: ChallengeParameters } = await (0, $7063125feda4194a$export$cfd8b50d0f78e4fa)(username, challengeName, signInSession, challengeResponse, authConfig, (0, $c6bbd61934ed7f36$export$66561e66d62991d0), clientMetaData, options);
        // sets up local state used during the sign-in process
        (0, $f136ba74979ac757$export$bae72361b690e075)({
            signInSession: Session,
            username: username,
            challengeName: ChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            (0, $f136ba74979ac757$export$f3dfaa7234c98dc0)();
            await (0, $18561e240f7cae15$export$729df6fdd19b8b0d)({
                username: username,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $7063125feda4194a$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            (0, $2f4552e504bc473c$export$8c41bb232f1008b1).dispatch("auth", {
                event: "signedIn",
                data: await (0, $95f3b5487ad3e06b$export$e5432d4c8eb97ea7)()
            }, "Auth", (0, $2f4552e504bc473c$export$aadf71dd9875dd20));
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $7063125feda4194a$export$cf152400b58b8e65)({
            challengeName: ChallengeName,
            challengeParameters: ChallengeParameters
        });
    } catch (error) {
        (0, $76ca3faab5b9192a$export$5b3890f50cd4853f)(error);
        const result = (0, $7063125feda4194a$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}


















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow without password
 *
 * @param input -  The SignInWithCustomAuthInput object
 * @returns AuthSignInResult
 * @throws service: {@link InitiateAuthException } - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws SignInWithCustomAuthOutput - Thrown when the token provider config is invalid.
 */ async function $2b2799771b580fee$export$7f948971bcf643ff(input) {
    const authConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
    const { username: username, password: password, options: options } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: "CUSTOM_WITHOUT_SRP"
    };
    const metadata = options?.clientMetadata;
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!username, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!password, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).CustomAuthSignInPassword);
    try {
        const { ChallengeName: ChallengeName, ChallengeParameters: ChallengeParameters, AuthenticationResult: AuthenticationResult, Session: Session } = await (0, $7063125feda4194a$export$30f932fe98713ccc)((0, $7063125feda4194a$export$1a654dcab55e0de5), [
            username,
            metadata,
            authConfig,
            (0, $c6bbd61934ed7f36$export$66561e66d62991d0)
        ], username, (0, $c6bbd61934ed7f36$export$66561e66d62991d0));
        const activeUsername = (0, $7063125feda4194a$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $f136ba74979ac757$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: ChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            (0, $f136ba74979ac757$export$f3dfaa7234c98dc0)();
            await (0, $18561e240f7cae15$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $7063125feda4194a$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            (0, $2f4552e504bc473c$export$8c41bb232f1008b1).dispatch("auth", {
                event: "signedIn",
                data: await (0, $95f3b5487ad3e06b$export$e5432d4c8eb97ea7)()
            }, "Auth", (0, $2f4552e504bc473c$export$aadf71dd9875dd20));
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $7063125feda4194a$export$cf152400b58b8e65)({
            challengeName: ChallengeName,
            challengeParameters: ChallengeParameters
        });
    } catch (error) {
        (0, $f136ba74979ac757$export$f3dfaa7234c98dc0)();
        (0, $76ca3faab5b9192a$export$5b3890f50cd4853f)(error);
        const result = (0, $7063125feda4194a$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using a custom authentication flow with SRP
 *
 * @param input -  The SignInWithCustomSRPAuthInput object
 * @returns SignInWithCustomSRPAuthOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito
 * service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $d4e3d0f94d3436f2$export$2c0317ed1bbb0787(input) {
    const { username: username, password: password, options: options } = input;
    const signInDetails = {
        loginId: username,
        authFlowType: "CUSTOM_WITH_SRP"
    };
    const authConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
    const metadata = options?.clientMetadata;
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!username, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!password, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: ChallengeName, ChallengeParameters: ChallengeParameters, AuthenticationResult: AuthenticationResult, Session: Session } = await (0, $7063125feda4194a$export$9ce9dd351616104c)(username, password, metadata, authConfig, (0, $c6bbd61934ed7f36$export$66561e66d62991d0));
        const activeUsername = (0, $7063125feda4194a$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $f136ba74979ac757$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: ChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $18561e240f7cae15$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $7063125feda4194a$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            (0, $f136ba74979ac757$export$f3dfaa7234c98dc0)();
            (0, $2f4552e504bc473c$export$8c41bb232f1008b1).dispatch("auth", {
                event: "signedIn",
                data: await (0, $95f3b5487ad3e06b$export$e5432d4c8eb97ea7)()
            }, "Auth", (0, $2f4552e504bc473c$export$aadf71dd9875dd20));
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $7063125feda4194a$export$cf152400b58b8e65)({
            challengeName: ChallengeName,
            challengeParameters: ChallengeParameters
        });
    } catch (error) {
        (0, $f136ba74979ac757$export$f3dfaa7234c98dc0)();
        (0, $76ca3faab5b9192a$export$5b3890f50cd4853f)(error);
        const result = (0, $7063125feda4194a$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input - The SignInWithSRPInput object
 * @returns SignInWithSRPOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException } - Cognito service errors
 * thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $7f664eeb17fada72$export$728178cf826a5ab9(input) {
    const { username: username, password: password } = input;
    const authConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: "USER_SRP_AUTH"
    };
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
    const clientMetaData = input.options?.clientMetadata;
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!username, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!password, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: ChallengeName, ChallengeParameters: ChallengeParameters, AuthenticationResult: AuthenticationResult, Session: Session } = await (0, $7063125feda4194a$export$13a3ef5ef8cac338)(username, password, clientMetaData, authConfig, (0, $c6bbd61934ed7f36$export$66561e66d62991d0));
        const activeUsername = (0, $7063125feda4194a$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $f136ba74979ac757$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: ChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            (0, $f136ba74979ac757$export$f3dfaa7234c98dc0)();
            await (0, $18561e240f7cae15$export$729df6fdd19b8b0d)({
                username: activeUsername,
                ...AuthenticationResult,
                NewDeviceMetadata: await (0, $7063125feda4194a$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            (0, $2f4552e504bc473c$export$8c41bb232f1008b1).dispatch("auth", {
                event: "signedIn",
                data: await (0, $95f3b5487ad3e06b$export$e5432d4c8eb97ea7)()
            }, "Auth", (0, $2f4552e504bc473c$export$aadf71dd9875dd20));
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $7063125feda4194a$export$cf152400b58b8e65)({
            challengeName: ChallengeName,
            challengeParameters: ChallengeParameters
        });
    } catch (error) {
        (0, $f136ba74979ac757$export$f3dfaa7234c98dc0)();
        (0, $76ca3faab5b9192a$export$5b3890f50cd4853f)(error);
        const result = (0, $7063125feda4194a$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in using USER_PASSWORD_AUTH AuthFlowType
 *
 * @param input - The SignInWithUserPasswordInput object
 * @returns SignInWithUserPasswordOutput
 * @throws service: {@link InitiateAuthException } - Cognito service error thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $0cceb1642bcbc7d3$export$200af5a623414b2b(input) {
    const { username: username, password: password, options: options } = input;
    const authConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signInDetails = {
        loginId: username,
        authFlowType: "USER_PASSWORD_AUTH"
    };
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
    const metadata = options?.clientMetadata;
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!username, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptySignInUsername);
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!password, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptySignInPassword);
    try {
        const { ChallengeName: ChallengeName, ChallengeParameters: ChallengeParameters, AuthenticationResult: AuthenticationResult, Session: Session } = await (0, $7063125feda4194a$export$30f932fe98713ccc)((0, $7063125feda4194a$export$29fb48d356e16a7), [
            username,
            password,
            metadata,
            authConfig,
            (0, $c6bbd61934ed7f36$export$66561e66d62991d0)
        ], username, (0, $c6bbd61934ed7f36$export$66561e66d62991d0));
        const activeUsername = (0, $7063125feda4194a$export$cc3585de146a51be)(username);
        // sets up local state used during the sign-in process
        (0, $f136ba74979ac757$export$bae72361b690e075)({
            signInSession: Session,
            username: activeUsername,
            challengeName: ChallengeName,
            signInDetails: signInDetails
        });
        if (AuthenticationResult) {
            await (0, $18561e240f7cae15$export$729df6fdd19b8b0d)({
                ...AuthenticationResult,
                username: activeUsername,
                NewDeviceMetadata: await (0, $7063125feda4194a$export$5fd317fac33d34b1)(authConfig.userPoolId, AuthenticationResult.NewDeviceMetadata, AuthenticationResult.AccessToken),
                signInDetails: signInDetails
            });
            (0, $f136ba74979ac757$export$f3dfaa7234c98dc0)();
            (0, $2f4552e504bc473c$export$8c41bb232f1008b1).dispatch("auth", {
                event: "signedIn",
                data: await (0, $95f3b5487ad3e06b$export$e5432d4c8eb97ea7)()
            }, "Auth", (0, $2f4552e504bc473c$export$aadf71dd9875dd20));
            return {
                isSignedIn: true,
                nextStep: {
                    signInStep: "DONE"
                }
            };
        }
        return (0, $7063125feda4194a$export$cf152400b58b8e65)({
            challengeName: ChallengeName,
            challengeParameters: ChallengeParameters
        });
    } catch (error) {
        (0, $f136ba74979ac757$export$f3dfaa7234c98dc0)();
        (0, $76ca3faab5b9192a$export$5b3890f50cd4853f)(error);
        const result = (0, $7063125feda4194a$export$cafe99bb44d49edb)(error.name);
        if (result) return result;
        throw error;
    }
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs a user in
 *
 * @param input -  The SignInInput object
 * @returns SignInOutput
 * @throws service: {@link InitiateAuthException }, {@link RespondToAuthChallengeException }
 *  - Cognito service errors thrown during the sign-in process.
 * @throws validation: {@link AuthValidationErrorCode  } - Validation errors thrown when either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $97c7826f92aacae0$export$9670d83f11d4b64a(input) {
    const authFlowType = input.options?.authFlowType;
    await (0, $7063125feda4194a$export$8061cd07f982ef08)();
    switch(authFlowType){
        case "USER_SRP_AUTH":
            return (0, $7f664eeb17fada72$export$728178cf826a5ab9)(input);
        case "USER_PASSWORD_AUTH":
            return (0, $0cceb1642bcbc7d3$export$200af5a623414b2b)(input);
        case "CUSTOM_WITHOUT_SRP":
            return (0, $2b2799771b580fee$export$7f948971bcf643ff)(input);
        case "CUSTOM_WITH_SRP":
            return (0, $d4e3d0f94d3436f2$export$2c0317ed1bbb0787)(input);
        default:
            return (0, $7f664eeb17fada72$export$728178cf826a5ab9)(input);
    }
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $22082fbe5823304e$var$initialAutoSignIn = async ()=>{
    throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: (0, $7674474451b5177a$export$fe46a12932d2550a),
        message: "The autoSignIn flow has not started, or has been cancelled/completed.",
        recoverySuggestion: "Please try to use the signIn API or log out before starting a new autoSignIn flow."
    });
};
/**
 * Signs a user in automatically after finishing the sign-up process.
 *
 * This API will automatically sign a user in if the autoSignIn flow has been completed in the following cases:
 * - User confirmed their account with a verification code sent to their phone or email (default option).
 * - User confirmed their account with a verification link sent to their phone or email. In order to
 * enable this option you need to go to the Amazon Cognito [console](https://aws.amazon.com/pm/cognito),
 * look for your userpool, then go to the `Messaging` tab and enable `link` mode inside the `Verification message` option.
 * Finally you need to define the `signUpVerificationMethod` in your `Auth` config.
 *
 * @example
 * ```typescript
 *  Amplify.configure({
 *    Auth: {
 *     Cognito: {
 *    ...cognitoConfig,
 *    signUpVerificationMethod: "link" // the default value is "code"
 *   }
 *	}});
 * ```
 *
 * @throws AutoSignInException - Thrown when the autoSignIn flow has not started, or has been cancelled/completed.
 * @returns The signInOutput.
 *
 * @example
 * ```typescript
 *  // handleSignUp.ts
 * async function handleSignUp(
 *   username:string,
 *   password:string
 * ){
 *   try {
 *     const { nextStep } = await signUp({
 *       username,
 *       password,
 *       options: {
 *         userAttributes:{ email:'email@email.com'},
 *         autoSignIn: true // This enables the auto sign-in flow.
 *       },
 *     });
 *
 *     handleSignUpStep(nextStep);
 *
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // handleConfirmSignUp.ts
 * async function handleConfirmSignUp(username:string, confirmationCode:string) {
 *   try {
 *     const { nextStep } = await confirmSignUp({
 *       username,
 *       confirmationCode,
 *     });
 *
 *     handleSignUpStep(nextStep);
 *   } catch (error) {
 *     console.log(error);
 *   }
 * }
 *
 * // signUpUtils.ts
 * async function handleSignUpStep( step: SignUpOutput["nextStep"]) {
 * switch (step.signUpStep) {
 *   case "CONFIRM_SIGN_UP":
 *
 *    // Redirect end-user to confirm-sign up screen.
 *
 *   case "COMPLETE_AUTO_SIGN_IN":
 *	   const codeDeliveryDetails = step.codeDeliveryDetails;
 *     if (codeDeliveryDetails) {
 *      // Redirect user to confirm-sign-up with link screen.
 *     }
 *     const signInOutput = await autoSignIn();
 *   // handle sign-in steps
 * }
 *
 * ```
 */ let $22082fbe5823304e$export$c5378dc7d6787fa5 = $22082fbe5823304e$var$initialAutoSignIn;
/**
 * Sets the context of autoSignIn at run time.
 * @internal
 */ function $22082fbe5823304e$export$7dcbf67a23c27835(callback) {
    $22082fbe5823304e$export$c5378dc7d6787fa5 = callback;
}
/**
 * Resets the context
 *
 * @internal
 */ function $22082fbe5823304e$export$1ffa2742ce5c589b() {
    $22082fbe5823304e$export$c5378dc7d6787fa5 = $22082fbe5823304e$var$initialAutoSignIn;
}



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c17f80c2509d4207$var$MAX_AUTOSIGNIN_POLLING_MS = 180000;
function $c17f80c2509d4207$export$385d6b43f72ecccf(signInInput) {
    const stopHubListener = (0, $2f4552e504bc473c$export$45dde0743a4c8d6e).listen("auth-internal", async ({ payload: payload })=>{
        switch(payload.event){
            case "confirmSignUp":
                {
                    const response = payload.data;
                    if (response?.isSignUpComplete) {
                        (0, $2f4552e504bc473c$export$45dde0743a4c8d6e).dispatch("auth-internal", {
                            event: "autoSignIn"
                        });
                        (0, $22082fbe5823304e$export$7dcbf67a23c27835)($c17f80c2509d4207$var$autoSignInWithCode(signInInput));
                        stopHubListener();
                    }
                }
        }
    });
    // This will stop the listener if confirmSignUp is not resolved.
    const timeOutId = setTimeout(()=>{
        stopHubListener();
        $c17f80c2509d4207$export$be9e824afabf429b(false);
        clearTimeout(timeOutId);
        (0, $22082fbe5823304e$export$1ffa2742ce5c589b)();
    }, $c17f80c2509d4207$var$MAX_AUTOSIGNIN_POLLING_MS);
}
function $c17f80c2509d4207$var$debounce(fun, delay) {
    let timer;
    return function(args) {
        if (!timer) fun(...args);
        clearTimeout(timer);
        timer = setTimeout(()=>{
            timer = undefined;
        }, delay);
    };
}
function $c17f80c2509d4207$var$handleAutoSignInWithLink(signInInput, resolve, reject) {
    const start = Date.now();
    const autoSignInPollingIntervalId = setInterval(async ()=>{
        const elapsedTime = Date.now() - start;
        const maxTime = $c17f80c2509d4207$var$MAX_AUTOSIGNIN_POLLING_MS;
        if (elapsedTime > maxTime) {
            clearInterval(autoSignInPollingIntervalId);
            $c17f80c2509d4207$export$be9e824afabf429b(false);
            reject(new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
                name: (0, $7674474451b5177a$export$fe46a12932d2550a),
                message: "The account was not confirmed on time.",
                recoverySuggestion: "Try to verify your account by clicking the link sent your email or phone and then login manually."
            }));
            (0, $22082fbe5823304e$export$1ffa2742ce5c589b)();
            return;
        } else try {
            const signInOutput = await (0, $97c7826f92aacae0$export$9670d83f11d4b64a)(signInInput);
            if (signInOutput.nextStep.signInStep !== "CONFIRM_SIGN_UP") {
                resolve(signInOutput);
                clearInterval(autoSignInPollingIntervalId);
                $c17f80c2509d4207$export$be9e824afabf429b(false);
                (0, $22082fbe5823304e$export$1ffa2742ce5c589b)();
                return;
            }
        } catch (error) {
            clearInterval(autoSignInPollingIntervalId);
            $c17f80c2509d4207$export$be9e824afabf429b(false);
            reject(error);
            (0, $22082fbe5823304e$export$1ffa2742ce5c589b)();
        }
    }, 5000);
}
const $c17f80c2509d4207$var$debouncedAutoSignInWithLink = $c17f80c2509d4207$var$debounce($c17f80c2509d4207$var$handleAutoSignInWithLink, 300);
const $c17f80c2509d4207$var$debouncedAutoSignWithCodeOrUserConfirmed = $c17f80c2509d4207$var$debounce($c17f80c2509d4207$var$handleAutoSignInWithCodeOrUserConfirmed, 300);
let $c17f80c2509d4207$var$autoSignInStarted = false;
let $c17f80c2509d4207$var$usernameUsedForAutoSignIn;
function $c17f80c2509d4207$export$9542ecebf2267645(username) {
    $c17f80c2509d4207$var$usernameUsedForAutoSignIn = username;
}
function $c17f80c2509d4207$export$2eb7cf6e92e4b85f(username) {
    return $c17f80c2509d4207$var$usernameUsedForAutoSignIn === username;
}
function $c17f80c2509d4207$export$ae4fc21c931f7784() {
    return $c17f80c2509d4207$var$autoSignInStarted;
}
function $c17f80c2509d4207$export$be9e824afabf429b(value) {
    if (value === false) $c17f80c2509d4207$export$9542ecebf2267645(undefined);
    $c17f80c2509d4207$var$autoSignInStarted = value;
}
function $c17f80c2509d4207$export$9fd29532e325aae0(output) {
    return !!output.UserConfirmed;
}
function $c17f80c2509d4207$export$feaed4858b71e8a(signInInput) {
    return async ()=>{
        return new Promise(async (resolve, reject)=>{
            $c17f80c2509d4207$var$debouncedAutoSignInWithLink([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
async function $c17f80c2509d4207$var$handleAutoSignInWithCodeOrUserConfirmed(signInInput, resolve, reject) {
    try {
        const output = await (0, $97c7826f92aacae0$export$9670d83f11d4b64a)(signInInput);
        resolve(output);
        (0, $22082fbe5823304e$export$1ffa2742ce5c589b)();
    } catch (error) {
        reject(error);
        (0, $22082fbe5823304e$export$1ffa2742ce5c589b)();
    }
}
function $c17f80c2509d4207$var$autoSignInWithCode(signInInput) {
    return async ()=>{
        return new Promise(async (resolve, reject)=>{
            $c17f80c2509d4207$var$debouncedAutoSignWithCodeOrUserConfirmed([
                signInInput,
                resolve,
                reject
            ]);
        });
    };
}
const $c17f80c2509d4207$export$9ec2c3d010185172 = $c17f80c2509d4207$var$autoSignInWithCode;




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms a new user account.
 *
 * @param input -  The ConfirmSignUpInput object.
 * @returns ConfirmSignUpOutput
 * @throws -{@link ConfirmSignUpException }
 * Thrown due to an invalid confirmation code.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty confirmation code
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $a6371f81f1dbea41$export$2ce39ab6662e8c24(input) {
    const { username: username, confirmationCode: confirmationCode, options: options } = input;
    const authConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
    const { userPoolId: userPoolId, userPoolClientId: userPoolClientId } = authConfig;
    const clientMetadata = options?.clientMetadata;
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!username, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyConfirmSignUpUsername);
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!confirmationCode, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyConfirmSignUpCode);
    const UserContextData = (0, $30f7d7d7c5349180$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    await (0, $c845c6a72bc4ff0c$export$2ce39ab6662e8c24)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).ConfirmSignUp)
    }, {
        Username: username,
        ConfirmationCode: confirmationCode,
        ClientMetadata: clientMetadata,
        ForceAliasCreation: options?.forceAliasCreation,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
    return new Promise((resolve, reject)=>{
        try {
            const signUpOut = {
                isSignUpComplete: true,
                nextStep: {
                    signUpStep: "DONE"
                }
            };
            if (!(0, $c17f80c2509d4207$export$ae4fc21c931f7784)() || !(0, $c17f80c2509d4207$export$2eb7cf6e92e4b85f)(username)) return resolve(signUpOut);
            const stopListener = (0, $2f4552e504bc473c$export$45dde0743a4c8d6e).listen("auth-internal", ({ payload: payload })=>{
                switch(payload.event){
                    case "autoSignIn":
                        resolve({
                            isSignUpComplete: true,
                            nextStep: {
                                signUpStep: "COMPLETE_AUTO_SIGN_IN"
                            }
                        });
                        (0, $c17f80c2509d4207$export$be9e824afabf429b)(false);
                        stopListener();
                }
            });
            (0, $2f4552e504bc473c$export$45dde0743a4c8d6e).dispatch("auth-internal", {
                event: "confirmSignUp",
                data: signUpOut
            });
        } catch (error) {
            reject(error);
        }
    });
}









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resets a user's password.
 *
 * @param input -  The ResetPasswordInput object.
 * @returns ResetPasswordOutput
 * @throws -{@link ForgotPasswordException }
 * Thrown due to an invalid confirmation code or password.
 * @throws -{@link AuthValidationErrorCode }
 * Thrown due to an empty username.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 **/ async function $a8f5d50af40abab8$export$dc726c8e334dd814(input) {
    const username = input.username;
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!username, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyResetPasswordUsername);
    const authConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId } = authConfig;
    const clientMetadata = input.options?.clientMetadata;
    const UserContextData = (0, $30f7d7d7c5349180$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const res = await (0, $c845c6a72bc4ff0c$export$66791fb2cfeec3e)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).ResetPassword)
    }, {
        Username: username,
        ClientMetadata: clientMetadata,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
    const codeDeliveryDetails = res.CodeDeliveryDetails;
    return {
        isPasswordReset: false,
        nextStep: {
            resetPasswordStep: "CONFIRM_RESET_PASSWORD_WITH_CODE",
            codeDeliveryDetails: {
                deliveryMedium: codeDeliveryDetails?.DeliveryMedium,
                destination: codeDeliveryDetails?.Destination,
                attributeName: codeDeliveryDetails?.AttributeName
            }
        }
    };
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Transforms a user attributes object into an array of AttributeType objects.
 * @param attributes user attributes to be mapped to AttributeType objects.
 * @returns an array of AttributeType objects.
 */ function $fd2bc15d59edbd5e$export$720a7caa078a04b0(attributes) {
    return Object.entries(attributes).map(([key, value])=>({
            Name: key,
            Value: value
        }));
}
/**
 * Transforms an array of AttributeType objects into a user attributes object.
 *
 * @param attributes - an array of AttributeType objects.
 * @returns AuthUserAttributes object.
 */ function $fd2bc15d59edbd5e$export$1b975641d03f3b17(attributes) {
    const userAttributes = {};
    attributes?.forEach((attribute)=>{
        if (attribute.Name) userAttributes[attribute.Name] = attribute.Value;
    });
    return userAttributes;
}





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Creates a user
 *
 * @param input - The SignUpInput object
 * @returns SignUpOutput
 * @throws service: {@link SignUpException } - Cognito service errors thrown during the sign-up process.
 * @throws validation: {@link AuthValidationErrorCode } - Validation errors thrown either username or password
 *  are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $c838049269adee5b$export$cf64224bcd829024(input) {
    const { username: username, password: password, options: options } = input;
    const authConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const signUpVerificationMethod = authConfig?.signUpVerificationMethod ?? "code";
    const { clientMetadata: clientMetadata, validationData: validationData, autoSignIn: autoSignIn } = input.options ?? {};
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!username, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptySignUpUsername);
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!password, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptySignUpPassword);
    const signInServiceOptions = typeof autoSignIn !== "boolean" ? autoSignIn : undefined;
    const signInInput = {
        username: username,
        options: signInServiceOptions
    };
    // if the authFlowType is 'CUSTOM_WITHOUT_SRP' then we don't include the password
    if (signInServiceOptions?.authFlowType !== "CUSTOM_WITHOUT_SRP") signInInput["password"] = password;
    if (signInServiceOptions || autoSignIn === true) {
        (0, $c17f80c2509d4207$export$9542ecebf2267645)(username);
        (0, $c17f80c2509d4207$export$be9e824afabf429b)(true);
    }
    const clientOutput = await (0, $c845c6a72bc4ff0c$export$cf64224bcd829024)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).SignUp)
    }, {
        Username: username,
        Password: password,
        UserAttributes: options?.userAttributes && (0, $fd2bc15d59edbd5e$export$720a7caa078a04b0)(options?.userAttributes),
        ClientMetadata: clientMetadata,
        ValidationData: validationData && (0, $fd2bc15d59edbd5e$export$720a7caa078a04b0)(validationData),
        ClientId: authConfig.userPoolClientId
    });
    const { UserSub: UserSub, CodeDeliveryDetails: CodeDeliveryDetails } = clientOutput;
    if ((0, $c17f80c2509d4207$export$9fd29532e325aae0)(clientOutput) && (0, $c17f80c2509d4207$export$ae4fc21c931f7784)()) {
        (0, $22082fbe5823304e$export$7dcbf67a23c27835)((0, $c17f80c2509d4207$export$9ec2c3d010185172)(signInInput));
        return {
            isSignUpComplete: true,
            nextStep: {
                signUpStep: "COMPLETE_AUTO_SIGN_IN"
            }
        };
    } else if ((0, $c17f80c2509d4207$export$9fd29532e325aae0)(clientOutput) && !(0, $c17f80c2509d4207$export$ae4fc21c931f7784)()) return {
        isSignUpComplete: true,
        nextStep: {
            signUpStep: "DONE"
        }
    };
    else if (!(0, $c17f80c2509d4207$export$9fd29532e325aae0)(clientOutput) && (0, $c17f80c2509d4207$export$ae4fc21c931f7784)() && signUpVerificationMethod === "code") (0, $c17f80c2509d4207$export$385d6b43f72ecccf)(signInInput);
    else if (!(0, $c17f80c2509d4207$export$9fd29532e325aae0)(clientOutput) && (0, $c17f80c2509d4207$export$ae4fc21c931f7784)() && signUpVerificationMethod === "link") {
        (0, $22082fbe5823304e$export$7dcbf67a23c27835)((0, $c17f80c2509d4207$export$feaed4858b71e8a)(signInInput));
        return {
            isSignUpComplete: false,
            nextStep: {
                signUpStep: "COMPLETE_AUTO_SIGN_IN",
                codeDeliveryDetails: {
                    deliveryMedium: CodeDeliveryDetails?.DeliveryMedium,
                    destination: CodeDeliveryDetails?.Destination,
                    attributeName: CodeDeliveryDetails?.AttributeName
                }
            },
            userId: UserSub
        };
    }
    return {
        isSignUpComplete: false,
        nextStep: {
            signUpStep: "CONFIRM_SIGN_UP",
            codeDeliveryDetails: {
                deliveryMedium: CodeDeliveryDetails?.DeliveryMedium,
                destination: CodeDeliveryDetails?.Destination,
                attributeName: CodeDeliveryDetails?.AttributeName
            }
        },
        userId: UserSub
    };
}









// Cognito does not allow a password length less then 8 characters
const $33f526657d26fae3$var$DEFAULT_COGNITO_PASSWORD_MIN_LENGTH = 8;
const $33f526657d26fae3$export$7ae2d201ca9520b = {
    async getAmplifyConfig () {
        const result = (0, $657101dca2c3f08b$export$11ac3725994bec7b).getConfig();
        const cliConfig = result.Auth?.Cognito;
        const { loginWith: loginWith, userAttributes: userAttributes } = result.Auth?.Cognito ?? {};
        const parsedLoginMechanisms = loginWith ? Object.entries(loginWith).filter(([key, _value])=>key !== "oauth").filter(([_key, value])=>!!value).map((keyValueArray)=>{
            return keyValueArray[0] === "phone" // the key for phone_number is phone in getConfig but everywhere else we treat is as phone_number
             ? "phone_number" : keyValueArray[0];
        }) : undefined;
        const parsedSignupAttributes = userAttributes ? Object.entries(userAttributes).map(([_key, value])=>Object.keys(value)[0]) : undefined;
        const parsedSocialProviders = loginWith?.oauth?.providers ? loginWith.oauth.providers?.map((provider)=>provider.toString().toLowerCase()) : undefined;
        return {
            ...cliConfig,
            loginMechanisms: parsedLoginMechanisms,
            signUpAttributes: parsedSignupAttributes,
            socialProviders: parsedSocialProviders
        };
    },
    getCurrentUser: $95f3b5487ad3e06b$export$e5432d4c8eb97ea7,
    handleSignIn: (0, $97c7826f92aacae0$export$9670d83f11d4b64a),
    handleSignUp: (0, $c838049269adee5b$export$cf64224bcd829024),
    handleConfirmSignIn: (0, $e1fb4f4fbfe74169$export$a477d84c2f7b792a),
    handleConfirmSignUp: (0, $a6371f81f1dbea41$export$2ce39ab6662e8c24),
    handleForgotPasswordSubmit: (0, $cd0ed4d73f618c9e$export$890261705c8ce36b),
    handleForgotPassword: (0, $a8f5d50af40abab8$export$dc726c8e334dd814),
    // Validation hooks for overriding
    async validateCustomSignUp (formData, touchData) {},
    async validateFormPassword (formData, touchData, passwordSettings) {
        const { password: password } = formData;
        const { password: touched_password } = touchData;
        /**
         * If the password is not touched,
         * or if the password settings are not set, we don't need to validate it.
         */ if (!touched_password || !passwordSettings) return null;
        const password_complexity = [];
        const policyMinLength = passwordSettings.minLength ?? $33f526657d26fae3$var$DEFAULT_COGNITO_PASSWORD_MIN_LENGTH;
        if (password.length < policyMinLength) password_complexity.push(`Password must have at least ${policyMinLength} characters`);
        if (passwordSettings.requireLowercase && !/[a-z]/.test(password)) password_complexity.push("Password must have lower case letters");
        if (passwordSettings.requireUppercase && !/[A-Z]/.test(password)) password_complexity.push("Password must have upper case letters");
        if (passwordSettings.requireNumbers && !/[0-9]/.test(password)) password_complexity.push("Password must have numbers");
        // https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
        if (passwordSettings.requireSpecialCharacters && !(0, $3bd7d334512b2bcd$export$1ec93875315f071d)(password)) password_complexity.push("Password must have special characters");
        /**
         * Only return an error if there is at least one error.
         */ return password_complexity.length !== 0 ? {
            password: password_complexity
        } : null;
    },
    async validateConfirmPassword (formData, touchData) {
        const { password: password, confirm_password: confirm_password } = formData;
        const { confirm_password: touched_confirm_password, password: touched_password } = touchData;
        if (!password && !confirm_password) // these inputs are clean, don't complain yet
        return null;
        else if ((password || confirm_password) && password !== confirm_password && (touched_confirm_password && touched_password || password?.length >= 6 && confirm_password?.length >= 6)) // Only return an error if both fields have text entered,
        // the passwords do not match, and the fields have been
        // touched or the password and confirm password is longer then or equal to 6.
        return {
            confirm_password: "Your passwords must match"
        };
    },
    async validatePreferredUsername (formData, touchData) {}
};


function $1b886b1c1ef05fd6$export$d384478d1c0083d2({ services: services }) {
    return (0, $66ceff3818583d23$export$aaa7fa18f8e9b2e8)({
        id: "forgotPasswordActor",
        initial: "init",
        predictableActionArguments: true,
        states: {
            init: {
                always: [
                    {
                        cond: "shouldResetPassword",
                        target: "confirmResetPassword"
                    },
                    {
                        cond: "shouldConfirmResetPassword",
                        target: "confirmResetPassword"
                    },
                    {
                        target: "forgotPassword"
                    }
                ]
            },
            forgotPassword: {
                initial: "edit",
                entry: "sendUpdate",
                exit: [
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            CHANGE: {
                                actions: "handleInput"
                            },
                            BLUR: {
                                actions: "handleBlur"
                            }
                        }
                    },
                    submit: {
                        tags: "pending",
                        entry: [
                            "sendUpdate",
                            "clearError",
                            "setUsernameForgotPassword"
                        ],
                        invoke: {
                            src: "handleResetPassword",
                            onDone: {
                                actions: [
                                    "setCodeDeliveryDetails",
                                    "setNextResetPasswordStep"
                                ],
                                target: "#forgotPasswordActor.confirmResetPassword"
                            },
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    }
                }
            },
            confirmResetPassword: {
                type: "parallel",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    validation: {
                        initial: "pending",
                        states: {
                            pending: {
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "valid",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "invalid",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            valid: {
                                entry: "sendUpdate"
                            },
                            invalid: {
                                entry: "sendUpdate"
                            }
                        },
                        on: {
                            CHANGE: {
                                actions: "handleInput",
                                target: ".pending"
                            },
                            BLUR: {
                                actions: "handleBlur",
                                target: ".pending"
                            }
                        }
                    },
                    submission: {
                        initial: "idle",
                        states: {
                            idle: {
                                entry: "sendUpdate",
                                on: {
                                    SUBMIT: {
                                        actions: "handleSubmit",
                                        target: "validate"
                                    },
                                    RESEND: "resendCode",
                                    CHANGE: {
                                        actions: "handleInput"
                                    },
                                    BLUR: {
                                        actions: "handleBlur"
                                    }
                                }
                            },
                            validate: {
                                entry: "sendUpdate",
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "pending",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "idle",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            resendCode: {
                                tags: "pending",
                                entry: [
                                    "clearError",
                                    "sendUpdate"
                                ],
                                invoke: {
                                    src: "handleResetPassword",
                                    onDone: {
                                        target: "idle"
                                    },
                                    onError: {
                                        actions: "setRemoteError",
                                        target: "idle"
                                    }
                                }
                            },
                            pending: {
                                tags: "pending",
                                entry: [
                                    "clearError",
                                    "sendUpdate"
                                ],
                                invoke: {
                                    src: "handleConfirmResetPassword",
                                    onDone: [
                                        {
                                            cond: "hasCompletedResetPassword",
                                            actions: "setNextResetPasswordStep",
                                            target: "#forgotPasswordActor.resolved"
                                        },
                                        {
                                            actions: "setSignInStep",
                                            target: "#forgotPasswordActor.resolved"
                                        }
                                    ],
                                    onError: {
                                        actions: "setRemoteError",
                                        target: "idle"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            resolved: {
                type: "final",
                data: ({ step: step })=>({
                        step: step
                    })
            }
        }
    }, {
        // sendUpdate is a HOC
        actions: {
            ...(0, $86bd895eb2ae87a7$export$2e2bcd8739ae039),
            sendUpdate: (0, $54ea967ad60a4c8d$export$7f8b724299523eb6)()
        },
        guards: (0, $6390b9cb027d73c6$export$2e2bcd8739ae039),
        services: {
            handleResetPassword ({ username: username }) {
                return services.handleForgotPassword({
                    username: username
                });
            },
            handleConfirmResetPassword ({ formValues: formValues, username: username }) {
                const { confirmation_code: confirmationCode, password: newPassword } = formValues;
                return services.handleForgotPasswordSubmit({
                    confirmationCode: confirmationCode,
                    newPassword: newPassword,
                    username: username
                });
            },
            validateFields (context) {
                return (0, $e381f49dc6978a71$export$59e2b39f02edfada)(context.formValues, context.touched, context.passwordSettings, [
                    (0, $33f526657d26fae3$export$7ae2d201ca9520b).validateFormPassword,
                    (0, $33f526657d26fae3$export$7ae2d201ca9520b).validateConfirmPassword
                ]);
            }
        }
    });
}










// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $5c95de523f13da90$export$5dc95ecf3f16c6c9 = async (amplify)=>{
    const authConfig = amplify.getConfig().Auth?.Cognito;
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
    const { tokens: tokens } = await (0, $e869a466bd0889a3$export$39430dfe49142ae)(amplify, {
        forceRefresh: false
    });
    (0, $627294a07e5270d4$export$77712ea5882cac9f)(tokens);
    const { UserAttributes: UserAttributes } = await (0, $c845c6a72bc4ff0c$export$7cbf767827cd68ba)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).FetchUserAttributes)
    }, {
        AccessToken: tokens.accessToken.toString()
    });
    return (0, $fd2bc15d59edbd5e$export$1b975641d03f3b17)(UserAttributes);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Fetches the current user attributes while authenticated.
 *
 * @throws - {@link GetUserException} - Cognito service errors thrown when the service is not able to get the user.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $fb45c8ccae5d9e4c$export$5dc95ecf3f16c6c9 = ()=>{
    return (0, $5c95de523f13da90$export$5dc95ecf3f16c6c9)((0, $623ac757f0e7ef86$export$a3858a9a153cffc7));
};









// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resend the confirmation code while signing up
 *
 * @param input -  The ResendSignUpCodeInput object
 * @returns ResendSignUpCodeOutput
 * @throws service: {@link ResendConfirmationException } - Cognito service errors thrown when resending the code.
 * @throws validation: {@link AuthValidationErrorCode } - Validation errors thrown either username are not defined.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $e39de46791517062$export$b295e842f1d42d13(input) {
    const username = input.username;
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!username, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptySignUpUsername);
    const authConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
    const { userPoolClientId: userPoolClientId, userPoolId: userPoolId } = authConfig;
    const clientMetadata = input.options?.clientMetadata;
    const UserContextData = (0, $30f7d7d7c5349180$export$b6e6cdd1f90faa62)({
        username: username,
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId
    });
    const { CodeDeliveryDetails: CodeDeliveryDetails } = await (0, $c845c6a72bc4ff0c$export$f24137cafeaef1a1)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).ResendSignUpCode)
    }, {
        Username: username,
        ClientMetadata: clientMetadata,
        ClientId: authConfig.userPoolClientId,
        UserContextData: UserContextData
    });
    const { DeliveryMedium: DeliveryMedium, AttributeName: AttributeName, Destination: Destination } = {
        ...CodeDeliveryDetails
    };
    return {
        destination: Destination,
        deliveryMedium: DeliveryMedium,
        attributeName: AttributeName ? AttributeName : undefined
    };
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $15e9e6806eb9fbb6$export$4e09c449d6c407f7 = ()=>typeof window !== "undefined" && typeof window.document !== "undefined";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $61bf542dccf303f8$export$a7ea17e93539f9a5(hex) {
    const matchArr = hex.match(/.{2}/g) || [];
    return matchArr.map((char)=>String.fromCharCode(parseInt(char, 16))).join("");
}

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $d7a44600305c1c60$export$b855308a44508212(str) {
    return str.split("").map((char)=>char.charCodeAt(0).toString(16).padStart(2, "0")).join("");
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $18c17fce72612806$export$6893de5f4e1216c3 = {
    Google: "Google",
    Facebook: "Facebook",
    Amazon: "LoginWithAmazon",
    Apple: "SignInWithApple"
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $ba26f06a9401015f$var$V5_HOSTED_UI_KEY = "amplify-signin-with-hostedUI";
const $ba26f06a9401015f$var$name = "CognitoIdentityServiceProvider";
class $ba26f06a9401015f$export$9b2cef5d94f9b6e8 {
    constructor(keyValueStorage){
        this.keyValueStorage = keyValueStorage;
    }
    async clearOAuthInflightData() {
        (0, $a6de0542b1980a7d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $ba26f06a9401015f$var$createKeysForAuthStorage($ba26f06a9401015f$var$name, this.cognitoConfig.userPoolClientId);
        await Promise.all([
            this.keyValueStorage.removeItem(authKeys.inflightOAuth),
            this.keyValueStorage.removeItem(authKeys.oauthPKCE),
            this.keyValueStorage.removeItem(authKeys.oauthState)
        ]);
    }
    async clearOAuthData() {
        (0, $a6de0542b1980a7d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $ba26f06a9401015f$var$createKeysForAuthStorage($ba26f06a9401015f$var$name, this.cognitoConfig.userPoolClientId);
        await this.clearOAuthInflightData();
        await this.keyValueStorage.removeItem($ba26f06a9401015f$var$V5_HOSTED_UI_KEY); // remove in case a customer migrated an App from v5 to v6
        return this.keyValueStorage.removeItem(authKeys.oauthSignIn);
    }
    loadOAuthState() {
        (0, $a6de0542b1980a7d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $ba26f06a9401015f$var$createKeysForAuthStorage($ba26f06a9401015f$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthState);
    }
    storeOAuthState(state) {
        (0, $a6de0542b1980a7d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $ba26f06a9401015f$var$createKeysForAuthStorage($ba26f06a9401015f$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthState, state);
    }
    loadPKCE() {
        (0, $a6de0542b1980a7d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $ba26f06a9401015f$var$createKeysForAuthStorage($ba26f06a9401015f$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.getItem(authKeys.oauthPKCE);
    }
    storePKCE(pkce) {
        (0, $a6de0542b1980a7d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $ba26f06a9401015f$var$createKeysForAuthStorage($ba26f06a9401015f$var$name, this.cognitoConfig.userPoolClientId);
        return this.keyValueStorage.setItem(authKeys.oauthPKCE, pkce);
    }
    setAuthConfig(authConfigParam) {
        this.cognitoConfig = authConfigParam;
    }
    async loadOAuthInFlight() {
        (0, $a6de0542b1980a7d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $ba26f06a9401015f$var$createKeysForAuthStorage($ba26f06a9401015f$var$name, this.cognitoConfig.userPoolClientId);
        return await this.keyValueStorage.getItem(authKeys.inflightOAuth) === "true";
    }
    async storeOAuthInFlight(inflight) {
        (0, $a6de0542b1980a7d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $ba26f06a9401015f$var$createKeysForAuthStorage($ba26f06a9401015f$var$name, this.cognitoConfig.userPoolClientId);
        return await this.keyValueStorage.setItem(authKeys.inflightOAuth, `${inflight}`);
    }
    async loadOAuthSignIn() {
        (0, $a6de0542b1980a7d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $ba26f06a9401015f$var$createKeysForAuthStorage($ba26f06a9401015f$var$name, this.cognitoConfig.userPoolClientId);
        const isLegacyHostedUISignIn = await this.keyValueStorage.getItem($ba26f06a9401015f$var$V5_HOSTED_UI_KEY);
        const [isOAuthSignIn, preferPrivateSession] = (await this.keyValueStorage.getItem(authKeys.oauthSignIn))?.split(",") ?? [];
        return {
            isOAuthSignIn: isOAuthSignIn === "true" || isLegacyHostedUISignIn === "true",
            preferPrivateSession: preferPrivateSession === "true"
        };
    }
    async storeOAuthSignIn(oauthSignIn, preferPrivateSession = false) {
        (0, $a6de0542b1980a7d$export$80c92581e59ed502)(this.cognitoConfig);
        const authKeys = $ba26f06a9401015f$var$createKeysForAuthStorage($ba26f06a9401015f$var$name, this.cognitoConfig.userPoolClientId);
        return await this.keyValueStorage.setItem(authKeys.oauthSignIn, `${oauthSignIn},${preferPrivateSession}`);
    }
}
const $ba26f06a9401015f$var$createKeysForAuthStorage = (provider, identifier)=>{
    return (0, $bf28e6bdff0fcfed$export$dfb8da757ca62eed)((0, $627294a07e5270d4$export$3820b4ff343394ea))(provider, identifier);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Auth instance options
 */ // export interface AuthOptions {
// 	userPoolId?: string;
// 	userPoolWebClientId?: string;
// 	identityPoolId?: string;
// 	region?: string;
// 	mandatorySignIn?: boolean;
// 	cookieStorage?: ICookieStorageData;
// 	oauth?: OAuthOpts;
// 	refreshHandlers?: object;
// 	storage?: ICognitoStorage;
// 	authenticationFlowType?: string;
// 	identityPoolRegion?: string;
// 	clientMetadata?: any;
// 	endpoint?: string;
// 	signUpVerificationMethod?: 'code' | 'link';
// }
var $33fb8173b45e6162$export$eeb013770cb92342;
(function(CognitoHostedUIIdentityProvider) {
    CognitoHostedUIIdentityProvider["Cognito"] = "COGNITO";
    CognitoHostedUIIdentityProvider["Google"] = "Google";
    CognitoHostedUIIdentityProvider["Facebook"] = "Facebook";
    CognitoHostedUIIdentityProvider["Amazon"] = "LoginWithAmazon";
    CognitoHostedUIIdentityProvider["Apple"] = "SignInWithApple";
})($33fb8173b45e6162$export$eeb013770cb92342 || ($33fb8173b45e6162$export$eeb013770cb92342 = {}));
function $33fb8173b45e6162$export$9b905d6895bdc426(obj) {
    const keys = [
        "provider"
    ];
    return obj && !!keys.find((k)=>obj.hasOwnProperty(k));
}
function $33fb8173b45e6162$export$828f8efbdf71714b(obj) {
    const keys = [
        "customProvider"
    ];
    return obj && !!keys.find((k)=>obj.hasOwnProperty(k));
}
function $33fb8173b45e6162$export$6bae5520ca265d22(obj) {
    const keys = [
        "customState"
    ];
    return obj && !!keys.find((k)=>obj.hasOwnProperty(k));
}
function $33fb8173b45e6162$export$b380f8ec78ef17c8(oauth) {
    return oauth.redirectSignIn !== undefined;
}
var $33fb8173b45e6162$export$edb367c0a140d3db;
(function(AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
    AuthErrorTypes["DeviceConfig"] = "deviceConfig";
    AuthErrorTypes["NetworkError"] = "networkError";
    AuthErrorTypes["AutoSignInError"] = "autoSignInError";
    AuthErrorTypes["OAuthSignInError"] = "oauthSignInError";
})($33fb8173b45e6162$export$edb367c0a140d3db || ($33fb8173b45e6162$export$edb367c0a140d3db = {}));
function $33fb8173b45e6162$export$ad34f09783c4cb16(obj) {
    return !!obj.username;
}
var $33fb8173b45e6162$export$cfce9c15015bef96;
(function(GRAPHQL_AUTH_MODE) {
    GRAPHQL_AUTH_MODE["API_KEY"] = "API_KEY";
    GRAPHQL_AUTH_MODE["AWS_IAM"] = "AWS_IAM";
    GRAPHQL_AUTH_MODE["OPENID_CONNECT"] = "OPENID_CONNECT";
    GRAPHQL_AUTH_MODE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
    GRAPHQL_AUTH_MODE["AWS_LAMBDA"] = "AWS_LAMBDA";
})($33fb8173b45e6162$export$cfce9c15015bef96 || ($33fb8173b45e6162$export$cfce9c15015bef96 = {}));





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $c395a35590a99414$var$logger = new (0, $b5731988345712b1$export$ba6a9c7ac8291f7f)("AuthError");
class $c395a35590a99414$export$145273558d58e0ac extends Error {
    constructor(type){
        const { message: message, log: log } = $c395a35590a99414$export$d8113b8d790509a4[type];
        super(message);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $c395a35590a99414$export$145273558d58e0ac;
        Object.setPrototypeOf(this, $c395a35590a99414$export$145273558d58e0ac.prototype);
        this.name = "AuthError";
        this.log = log || message;
        $c395a35590a99414$var$logger.error(this.log);
    }
}
class $c395a35590a99414$export$71192787e041818c extends $c395a35590a99414$export$145273558d58e0ac {
    constructor(type){
        super(type);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = $c395a35590a99414$export$71192787e041818c;
        Object.setPrototypeOf(this, $c395a35590a99414$export$71192787e041818c.prototype);
        this.name = "NoUserPoolError";
    }
}
const $c395a35590a99414$export$d8113b8d790509a4 = {
    oauthSignInError: {
        message: (0, $108fcfdf7ca8fb61$export$c3070468b9d65120).OAUTH_ERROR,
        log: "Make sure Cognito Hosted UI has been configured correctly"
    },
    noConfig: {
        message: (0, $108fcfdf7ca8fb61$export$c3070468b9d65120).DEFAULT_MSG,
        log: `
            Error: Amplify has not been configured correctly.
            This error is typically caused by one of the following scenarios:

            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point
                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information
            
            2. There might be multiple conflicting versions of amplify packages in your node_modules.
				Refer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)
        `
    },
    missingAuthConfig: {
        message: (0, $108fcfdf7ca8fb61$export$c3070468b9d65120).DEFAULT_MSG,
        log: `
            Error: Amplify has not been configured correctly. 
            The configuration object is missing required auth properties.
            This error is typically caused by one of the following scenarios:

            1. Did you run \`amplify push\` after adding auth via \`amplify add auth\`?
                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information

            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.
        `
    },
    emptyUsername: {
        message: (0, $108fcfdf7ca8fb61$export$c3070468b9d65120).EMPTY_USERNAME
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: (0, $108fcfdf7ca8fb61$export$c3070468b9d65120).INVALID_USERNAME
    },
    emptyPassword: {
        message: (0, $108fcfdf7ca8fb61$export$c3070468b9d65120).EMPTY_PASSWORD
    },
    emptyCode: {
        message: (0, $108fcfdf7ca8fb61$export$c3070468b9d65120).EMPTY_CODE
    },
    signUpError: {
        message: (0, $108fcfdf7ca8fb61$export$c3070468b9d65120).SIGN_UP_ERROR,
        log: "The first parameter should either be non-null string or object"
    },
    noMFA: {
        message: (0, $108fcfdf7ca8fb61$export$c3070468b9d65120).NO_MFA
    },
    invalidMFA: {
        message: (0, $108fcfdf7ca8fb61$export$c3070468b9d65120).INVALID_MFA
    },
    emptyChallengeResponse: {
        message: (0, $108fcfdf7ca8fb61$export$c3070468b9d65120).EMPTY_CHALLENGE
    },
    noUserSession: {
        message: (0, $108fcfdf7ca8fb61$export$c3070468b9d65120).NO_USER_SESSION
    },
    deviceConfig: {
        message: (0, $108fcfdf7ca8fb61$export$c3070468b9d65120).DEVICE_CONFIG
    },
    networkError: {
        message: (0, $108fcfdf7ca8fb61$export$c3070468b9d65120).NETWORK_ERROR
    },
    autoSignInError: {
        message: (0, $108fcfdf7ca8fb61$export$c3070468b9d65120).AUTOSIGNIN_ERROR
    },
    default: {
        message: (0, $108fcfdf7ca8fb61$export$c3070468b9d65120).DEFAULT_MSG
    }
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $dbe5278864d048d9$export$a673d54799039714 = async (url)=>{
    if (!window?.location) return;
    // enforce HTTPS
    window.location.href = url.replace("http://", "https://");
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $247b3ba5eef049f3$var$CODE_VERIFIER_CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
/**
 *
 * @param length Desired length of the code verifier.
 *
 * **NOTE:** According to the [RFC 7636](https://datatracker.ietf.org/doc/html/rfc7636#section-4.1)
 * A code verifier must be with a length >= 43 and <= 128.
 *
 * @returns An object that contains the generated `codeVerifier` and a method
 * `toCodeChallenge` to generate the code challenge from the `codeVerifier`
 * following the spec of [RFC 7636](https://datatracker.ietf.org/doc/html/rfc7636#section-4.2).
 */ const $247b3ba5eef049f3$export$cf1891f923f5943a = (length)=>{
    const randomBytes = new Uint8Array(length);
    (0, $ad119da6003ad7dd$export$e003cc239f955cb6)().getRandomValues(randomBytes);
    let value = "";
    let codeChallenge;
    for (let byte of randomBytes)value += $247b3ba5eef049f3$var$CODE_VERIFIER_CHARSET.charAt(byte % $247b3ba5eef049f3$var$CODE_VERIFIER_CHARSET.length);
    return {
        value: value,
        method: "S256",
        toCodeChallenge () {
            if (codeChallenge) return codeChallenge;
            codeChallenge = $247b3ba5eef049f3$var$generateCodeChallenge(value);
            return codeChallenge;
        }
    };
};
function $247b3ba5eef049f3$var$generateCodeChallenge(codeVerifier) {
    const awsCryptoHash = new (0, $97f07a059ffc5910$exports.Sha256)();
    awsCryptoHash.update(codeVerifier);
    const codeChallenge = $247b3ba5eef049f3$var$removePaddingChar((0, $45965b0c21473608$export$695b149896bd3e2a).convert(awsCryptoHash.digestSync(), {
        urlSafe: true
    }));
    return codeChallenge;
}
function $247b3ba5eef049f3$var$removePaddingChar(base64Encoded) {
    return base64Encoded.replace(/=/g, "");
}


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $8a774e81683d5e31$export$9e15fb06e64c4810 = (length)=>{
    const STATE_CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for(let i = 0; i < length; i++)result += STATE_CHARSET.charAt(Math.floor(Math.random() * STATE_CHARSET.length));
    return result;
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $f9da28c9a38e4e74$export$9ccd2716e53a229b = ()=>{
    return (0, $8a774e81683d5e31$export$9e15fb06e64c4810)(32);
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/** @internal */ function $d5a2dafc9f8f58d8$export$93832c3affb240d3(redirects) {
    const redirectUrlFromTheSameOrigin = redirects?.find($d5a2dafc9f8f58d8$var$isSameOriginAndPathName) ?? redirects?.find($d5a2dafc9f8f58d8$var$isTheSameDomain);
    const redirectUrlFromDifferentOrigin = redirects?.find($d5a2dafc9f8f58d8$var$isHttps) ?? redirects?.find($d5a2dafc9f8f58d8$var$isHttp);
    if (redirectUrlFromTheSameOrigin) return redirectUrlFromTheSameOrigin;
    else if (redirectUrlFromDifferentOrigin) throw 0, $7674474451b5177a$export$c01b4acd6291e035;
    throw 0, $7674474451b5177a$export$60b68b138a52e5ae;
}
// origin + pathname => https://example.com/app
const $d5a2dafc9f8f58d8$var$isSameOriginAndPathName = (redirect)=>redirect.startsWith(String((window.location.origin + window.location.pathname) ?? "/"));
// domain => outlook.live.com, github.com
const $d5a2dafc9f8f58d8$var$isTheSameDomain = (redirect)=>redirect.includes(String(window.location.hostname));
const $d5a2dafc9f8f58d8$var$isHttp = (redirect)=>redirect.startsWith("http://");
const $d5a2dafc9f8f58d8$var$isHttps = (redirect)=>redirect.startsWith("https://");



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs in a user with OAuth. Redirects the application to an Identity Provider.
 *
 * @param input - The SignInWithRedirectInput object, if empty it will redirect to Cognito HostedUI
 *
 * @throws AuthTokenConfigException - Thrown when the userpool config is invalid.
 * @throws OAuthNotConfigureException - Thrown when the oauth config is invalid.
 */ async function $832f6c109a70d147$export$3d0a7d1372e866bb(input) {
    const authConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
    (0, $a6de0542b1980a7d$export$c13e6dbaf90a8e5f)(authConfig);
    $832f6c109a70d147$export$6f57813fe9f31bf9.setAuthConfig(authConfig);
    await (0, $7063125feda4194a$export$8061cd07f982ef08)();
    let provider = "COGNITO"; // Default
    if (typeof input?.provider === "string") provider = (0, $18c17fce72612806$export$6893de5f4e1216c3)[input.provider];
    else if (input?.provider?.custom) provider = input.provider.custom;
    return $832f6c109a70d147$export$9920513c105dd3a6({
        oauthConfig: authConfig.loginWith.oauth,
        clientId: authConfig.userPoolClientId,
        provider: provider,
        customState: input?.customState,
        preferPrivateSession: input?.options?.preferPrivateSession
    });
}
const $832f6c109a70d147$export$6f57813fe9f31bf9 = new (0, $ba26f06a9401015f$export$9b2cef5d94f9b6e8)((0, $68ccea2c33038f88$export$586b30dcaeecb901));
async function $832f6c109a70d147$export$9920513c105dd3a6({ oauthConfig: oauthConfig, provider: provider, clientId: clientId, customState: customState, preferPrivateSession: preferPrivateSession }) {
    const { domain: domain, redirectSignIn: redirectSignIn, responseType: responseType, scopes: scopes } = oauthConfig;
    const randomState = (0, $f9da28c9a38e4e74$export$9ccd2716e53a229b)();
    /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
    single-encodes/decodes url on first sign in and double-encodes/decodes url
    when user already signed in. Using encodeURIComponent, Base32, Base64 add
    characters % or = which on further encoding becomes unsafe. '=' create issue
    for parsing query params.
    Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */ const state = customState ? `${randomState}-${(0, $d7a44600305c1c60$export$b855308a44508212)(customState)}` : randomState;
    const { value: value, method: method, toCodeChallenge: toCodeChallenge } = (0, $247b3ba5eef049f3$export$cf1891f923f5943a)(128);
    $832f6c109a70d147$export$6f57813fe9f31bf9.storeOAuthInFlight(true);
    $832f6c109a70d147$export$6f57813fe9f31bf9.storeOAuthState(state);
    $832f6c109a70d147$export$6f57813fe9f31bf9.storePKCE(value);
    const queryString = Object.entries({
        redirect_uri: (0, $d5a2dafc9f8f58d8$export$93832c3affb240d3)(oauthConfig.redirectSignIn),
        response_type: responseType,
        client_id: clientId,
        identity_provider: provider,
        scope: scopes.join(" "),
        state: state,
        ...responseType === "code" && {
            code_challenge: toCodeChallenge(),
            code_challenge_method: method
        }
    }).map(([k, v])=>`${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join("&");
    // TODO(v6): use URL object instead
    const oAuthUrl = `https://${domain}/oauth2/authorize?${queryString}`;
    const { type: type, error: error, url: url } = await (0, $dbe5278864d048d9$export$a673d54799039714)(oAuthUrl) ?? {};
    if (type === "success" && url) // ensure the code exchange completion resolves the signInWithRedirect
    // returned promise in react-native
    await $832f6c109a70d147$var$handleAuthResponse({
        currentUrl: url,
        clientId: clientId,
        domain: domain,
        redirectUri: redirectSignIn[0],
        responseType: responseType,
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).SignInWithRedirect),
        preferPrivateSession: preferPrivateSession
    });
    if (type === "error") $832f6c109a70d147$var$handleFailure(String(error));
}
async function $832f6c109a70d147$var$handleCodeFlow({ currentUrl: currentUrl, userAgentValue: userAgentValue, clientId: clientId, redirectUri: redirectUri, domain: domain, preferPrivateSession: preferPrivateSession }) {
    /* Convert URL into an object with parameters as keys
{ redirect_uri: 'http://localhost:3000/', response_type: 'code', ...} */ const url = new (0, $3d238183541c5736$export$beb82d9d9136c16e)(currentUrl);
    let validatedState;
    try {
        validatedState = await $832f6c109a70d147$var$validateStateFromURL(url);
    } catch (err) {
        $832f6c109a70d147$var$invokeAndClearPromise();
        // clear temp values
        await $832f6c109a70d147$export$6f57813fe9f31bf9.clearOAuthInflightData();
        return;
    }
    const code = url.searchParams.get("code");
    if (!code) {
        await $832f6c109a70d147$export$6f57813fe9f31bf9.clearOAuthData();
        $832f6c109a70d147$var$invokeAndClearPromise();
        return;
    }
    const oAuthTokenEndpoint = "https://" + domain + "/oauth2/token";
    // TODO(v6): check hub events
    // dispatchAuthEvent(
    // 	'codeFlow',
    // 	{},
    // 	`Retrieving tokens from ${oAuthTokenEndpoint}`
    // );
    const codeVerifier = await $832f6c109a70d147$export$6f57813fe9f31bf9.loadPKCE();
    const oAuthTokenBody = {
        grant_type: "authorization_code",
        code: code,
        client_id: clientId,
        redirect_uri: redirectUri,
        ...codeVerifier ? {
            code_verifier: codeVerifier
        } : {}
    };
    const body = Object.entries(oAuthTokenBody).map(([k, v])=>`${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join("&");
    const { access_token: access_token, refresh_token: refresh_token, id_token: id_token, error: error, token_type: token_type, expires_in: expires_in } = await (await fetch(oAuthTokenEndpoint, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            [(0, $c041c09c03ca0a16$export$16032fc466434892)]: userAgentValue
        },
        body: body
    })).json();
    if (error) {
        $832f6c109a70d147$var$invokeAndClearPromise();
        $832f6c109a70d147$var$handleFailure(error);
    }
    await $832f6c109a70d147$export$6f57813fe9f31bf9.clearOAuthInflightData();
    const username = (access_token && (0, $a6de0542b1980a7d$export$9a62e6c0a30e00bc)(access_token).payload.username) ?? "username";
    await (0, $18561e240f7cae15$export$729df6fdd19b8b0d)({
        username: username,
        AccessToken: access_token,
        IdToken: id_token,
        RefreshToken: refresh_token,
        TokenType: token_type,
        ExpiresIn: expires_in
    });
    return $832f6c109a70d147$var$completeFlow({
        redirectUri: redirectUri,
        state: validatedState,
        preferPrivateSession: preferPrivateSession
    });
}
async function $832f6c109a70d147$var$handleImplicitFlow({ currentUrl: currentUrl, redirectUri: redirectUri, preferPrivateSession: preferPrivateSession }) {
    // hash is `null` if `#` doesn't exist on URL
    const url = new (0, $3d238183541c5736$export$beb82d9d9136c16e)(currentUrl);
    const { id_token: id_token, access_token: access_token, state: state, token_type: token_type, expires_in: expires_in } = (url.hash ?? "#").substring(1) // Remove # from returned code
    .split("&").map((pairings)=>pairings.split("=")).reduce((accum, [k, v])=>({
            ...accum,
            [k]: v
        }), {
        id_token: undefined,
        access_token: undefined,
        state: undefined,
        token_type: undefined,
        expires_in: undefined
    });
    if (!access_token) {
        await $832f6c109a70d147$export$6f57813fe9f31bf9.clearOAuthData();
        $832f6c109a70d147$var$invokeAndClearPromise();
        return;
    }
    try {
        $832f6c109a70d147$var$validateState(state);
    } catch (error) {
        $832f6c109a70d147$var$invokeAndClearPromise();
        return;
    }
    const username = (access_token && (0, $a6de0542b1980a7d$export$9a62e6c0a30e00bc)(access_token).payload.username) ?? "username";
    await (0, $18561e240f7cae15$export$729df6fdd19b8b0d)({
        username: username,
        AccessToken: access_token,
        IdToken: id_token,
        TokenType: token_type,
        ExpiresIn: expires_in
    });
    return $832f6c109a70d147$var$completeFlow({
        redirectUri: redirectUri,
        state: state,
        preferPrivateSession: preferPrivateSession
    });
}
async function $832f6c109a70d147$var$completeFlow({ redirectUri: redirectUri, state: state, preferPrivateSession: preferPrivateSession }) {
    await $832f6c109a70d147$export$6f57813fe9f31bf9.clearOAuthData();
    await $832f6c109a70d147$export$6f57813fe9f31bf9.storeOAuthSignIn(true, preferPrivateSession);
    if ($832f6c109a70d147$var$isCustomState(state)) (0, $2f4552e504bc473c$export$8c41bb232f1008b1).dispatch("auth", {
        event: "customOAuthState",
        data: (0, $61bf542dccf303f8$export$a7ea17e93539f9a5)($832f6c109a70d147$var$getCustomState(state))
    }, "Auth", (0, $2f4552e504bc473c$export$aadf71dd9875dd20));
    (0, $2f4552e504bc473c$export$8c41bb232f1008b1).dispatch("auth", {
        event: "signInWithRedirect"
    }, "Auth", (0, $2f4552e504bc473c$export$aadf71dd9875dd20));
    (0, $2f4552e504bc473c$export$8c41bb232f1008b1).dispatch("auth", {
        event: "signedIn",
        data: await (0, $95f3b5487ad3e06b$export$e5432d4c8eb97ea7)()
    }, "Auth", (0, $2f4552e504bc473c$export$aadf71dd9875dd20));
    $832f6c109a70d147$var$clearHistory(redirectUri);
    $832f6c109a70d147$var$invokeAndClearPromise();
}
async function $832f6c109a70d147$var$handleAuthResponse({ currentUrl: currentUrl, userAgentValue: userAgentValue, clientId: clientId, redirectUri: redirectUri, responseType: responseType, domain: domain, preferPrivateSession: preferPrivateSession }) {
    try {
        const urlParams = new (0, $3d238183541c5736$export$beb82d9d9136c16e)(currentUrl);
        const error = urlParams.searchParams.get("error");
        const errorMessage = urlParams.searchParams.get("error_description");
        if (error) $832f6c109a70d147$var$handleFailure(errorMessage);
        if (responseType === "code") return await $832f6c109a70d147$var$handleCodeFlow({
            currentUrl: currentUrl,
            userAgentValue: userAgentValue,
            clientId: clientId,
            redirectUri: redirectUri,
            domain: domain,
            preferPrivateSession: preferPrivateSession
        });
        else return await $832f6c109a70d147$var$handleImplicitFlow({
            currentUrl: currentUrl,
            redirectUri: redirectUri,
            preferPrivateSession: preferPrivateSession
        });
    } catch (e) {
        throw e;
    }
}
async function $832f6c109a70d147$var$validateStateFromURL(urlParams) {
    const returnedState = urlParams.searchParams.get("state");
    $832f6c109a70d147$var$validateState(returnedState);
    return returnedState;
}
function $832f6c109a70d147$var$validateState(state) {
    let savedState;
    $832f6c109a70d147$export$6f57813fe9f31bf9.loadOAuthState().then((resp)=>{
        savedState = resp;
    });
    // This is because savedState only exists if the flow was initiated by Amplify
    if (savedState && state && savedState !== state) throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        name: (0, $33fb8173b45e6162$export$edb367c0a140d3db).OAuthSignInError,
        message: "An error occurred while validating the state",
        recoverySuggestion: "Try to initiate an OAuth flow from Amplify"
    });
}
function $832f6c109a70d147$var$handleFailure(errorMessage) {
    (0, $2f4552e504bc473c$export$8c41bb232f1008b1).dispatch("auth", {
        event: "signInWithRedirect_failure"
    }, "Auth", (0, $2f4552e504bc473c$export$aadf71dd9875dd20));
    throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
        message: errorMessage ?? "",
        name: (0, $108fcfdf7ca8fb61$export$473ab0b56598aacd).OAuthSignInError,
        recoverySuggestion: (0, $c395a35590a99414$export$d8113b8d790509a4).oauthSignInError.log
    });
}
async function $832f6c109a70d147$var$parseRedirectURL() {
    const authConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    try {
        (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
        $832f6c109a70d147$export$6f57813fe9f31bf9.setAuthConfig(authConfig);
    } catch (_err) {
        // Token provider not configure nothing to do
        return;
    }
    // No OAuth inflight doesnt need to parse the url
    if (!await $832f6c109a70d147$export$6f57813fe9f31bf9.loadOAuthInFlight()) return;
    try {
        (0, $a6de0542b1980a7d$export$c13e6dbaf90a8e5f)(authConfig);
    } catch (err) {
        // TODO(v6): this should warn you have signInWithRedirect but is not configured
        return;
    }
    try {
        const currentUrl = window.location.href;
        const { loginWith: loginWith, userPoolClientId: userPoolClientId } = authConfig;
        const { domain: domain, redirectSignIn: redirectSignIn, responseType: responseType } = loginWith.oauth;
        $832f6c109a70d147$var$handleAuthResponse({
            currentUrl: currentUrl,
            clientId: userPoolClientId,
            domain: domain,
            redirectUri: redirectSignIn[0],
            responseType: responseType,
            userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).SignInWithRedirect)
        });
    } catch (err) {
    // is ok if there is not OAuthConfig
    }
}
function $832f6c109a70d147$var$urlListener() {
    // Listen configure to parse url
    $832f6c109a70d147$var$parseRedirectURL();
    (0, $2f4552e504bc473c$export$8c41bb232f1008b1).listen("core", (capsule)=>{
        if (capsule.payload.event === "configure") $832f6c109a70d147$var$parseRedirectURL();
    });
}
(0, $15e9e6806eb9fbb6$export$4e09c449d6c407f7)() && $832f6c109a70d147$var$urlListener();
// This has a reference for listeners that requires to be notified, TokenOrchestrator use this for load tokens
let $832f6c109a70d147$var$inflightPromiseResolvers = [];
const $832f6c109a70d147$var$invokeAndClearPromise = ()=>{
    for (const promiseResolver of $832f6c109a70d147$var$inflightPromiseResolvers)promiseResolver();
    $832f6c109a70d147$var$inflightPromiseResolvers = [];
};
(0, $15e9e6806eb9fbb6$export$4e09c449d6c407f7)() && (0, $c6bbd61934ed7f36$export$18e158b80aac31a7).setWaitForInflightOAuth(()=>new Promise(async (res, _rej)=>{
        if (!await $832f6c109a70d147$export$6f57813fe9f31bf9.loadOAuthInFlight()) res();
        else $832f6c109a70d147$var$inflightPromiseResolvers.push(res);
        return;
    }));
function $832f6c109a70d147$var$clearHistory(redirectUri) {
    if (typeof window !== "undefined" && typeof window.history !== "undefined") window.history.replaceState({}, "", redirectUri);
}
function $832f6c109a70d147$var$isCustomState(state) {
    return /-/.test(state);
}
function $832f6c109a70d147$var$getCustomState(state) {
    return state.split("-").splice(1).join("-");
}






const $a71026f654359fa5$var$handleSignInResponse = {
    onDone: [
        {
            cond: "hasCompletedSignIn",
            actions: "setNextSignInStep",
            target: "#signInActor.fetchUserAttributes"
        },
        {
            cond: "shouldConfirmSignInWithNewPassword",
            actions: [
                "setMissingAttributes",
                "setNextSignInStep"
            ],
            target: "#signInActor.forceChangePassword"
        },
        {
            cond: "shouldResetPasswordFromSignIn",
            actions: "setNextSignInStep",
            target: "#signInActor.resetPassword"
        },
        {
            cond: "shouldConfirmSignUpFromSignIn",
            actions: "setNextSignInStep",
            target: "#signInActor.resendSignUpCode"
        },
        {
            actions: [
                "setChallengeName",
                "setMissingAttributes",
                "setNextSignInStep",
                "setTotpSecretCode"
            ],
            target: "#signInActor.init"
        }
    ],
    onError: {
        actions: "setRemoteError",
        target: "edit"
    }
};
const $a71026f654359fa5$var$handleFetchUserAttributesResponse = {
    onDone: [
        {
            cond: "shouldVerifyAttribute",
            actions: [
                "setShouldVerifyUserAttributeStep",
                "setUnverifiedUserAttributes"
            ],
            target: "#signInActor.resolved"
        },
        {
            actions: "setConfirmAttributeCompleteStep",
            target: "#signInActor.resolved"
        }
    ],
    onError: {
        actions: "setConfirmAttributeCompleteStep",
        target: "#signInActor.resolved"
    }
};
function $a71026f654359fa5$export$f9c30eaa77191700({ services: services }) {
    return (0, $66ceff3818583d23$export$aaa7fa18f8e9b2e8)({
        id: "signInActor",
        initial: "init",
        predictableActionArguments: true,
        states: {
            init: {
                always: [
                    {
                        cond: "shouldConfirmSignIn",
                        target: "confirmSignIn"
                    },
                    {
                        cond: "shouldSetupTotp",
                        target: "setupTotp"
                    },
                    {
                        cond: ({ step: step })=>step === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
                        actions: "setActorDoneData",
                        target: "forceChangePassword"
                    },
                    {
                        target: "signIn"
                    }
                ]
            },
            federatedSignIn: {
                entry: [
                    "sendUpdate",
                    "clearError"
                ],
                invoke: {
                    src: "signInWithRedirect",
                    onError: {
                        actions: "setRemoteError"
                    }
                }
            },
            fetchUserAttributes: {
                invoke: {
                    src: "fetchUserAttributes",
                    ...$a71026f654359fa5$var$handleFetchUserAttributesResponse
                }
            },
            resendSignUpCode: {
                invoke: {
                    src: "handleResendSignUpCode",
                    onDone: {
                        actions: "setCodeDeliveryDetails",
                        target: "#signInActor.resolved"
                    },
                    onError: {
                        actions: "setRemoteError",
                        target: "#signInActor.signIn"
                    }
                }
            },
            resetPassword: {
                invoke: {
                    src: "resetPassword",
                    onDone: [
                        {
                            actions: "setCodeDeliveryDetails",
                            target: "#signInActor.resolved"
                        }
                    ],
                    onError: {
                        actions: [
                            "setRemoteError",
                            "sendUpdate"
                        ]
                    }
                }
            },
            signIn: {
                initial: "edit",
                exit: "clearTouched",
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            CHANGE: {
                                actions: "handleInput"
                            },
                            FEDERATED_SIGN_IN: {
                                target: "#signInActor.federatedSignIn"
                            },
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            }
                        }
                    },
                    submit: {
                        tags: "pending",
                        entry: [
                            "clearError",
                            "sendUpdate",
                            "setUsernameSignIn"
                        ],
                        exit: "clearFormValues",
                        invoke: {
                            src: "handleSignIn",
                            ...$a71026f654359fa5$var$handleSignInResponse
                        }
                    }
                }
            },
            confirmSignIn: {
                initial: "edit",
                exit: [
                    "clearChallengeName",
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SIGN_IN: "#signInActor.signIn",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: "pending",
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "confirmSignIn",
                            ...$a71026f654359fa5$var$handleSignInResponse
                        }
                    }
                }
            },
            forceChangePassword: {
                entry: "sendUpdate",
                type: "parallel",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    validation: {
                        initial: "pending",
                        states: {
                            pending: {
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        target: "valid",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        target: "invalid",
                                        actions: "setFieldErrors"
                                    }
                                }
                            },
                            valid: {
                                entry: "sendUpdate"
                            },
                            invalid: {
                                entry: "sendUpdate"
                            }
                        },
                        on: {
                            SIGN_IN: {
                                actions: "setSignInStep",
                                target: "#signInActor.resolved"
                            },
                            CHANGE: {
                                actions: "handleInput",
                                target: ".pending"
                            },
                            BLUR: {
                                actions: "handleBlur",
                                target: ".pending"
                            }
                        }
                    },
                    submit: {
                        initial: "edit",
                        entry: "clearError",
                        states: {
                            edit: {
                                entry: "sendUpdate",
                                on: {
                                    SUBMIT: {
                                        actions: "handleSubmit",
                                        target: "validate"
                                    }
                                }
                            },
                            validate: {
                                entry: "sendUpdate",
                                invoke: {
                                    src: "validateFields",
                                    onDone: {
                                        actions: "clearValidationError",
                                        target: "pending"
                                    },
                                    onError: {
                                        actions: "setFieldErrors",
                                        target: "edit"
                                    }
                                }
                            },
                            pending: {
                                tags: "pending",
                                entry: [
                                    "sendUpdate",
                                    "clearError"
                                ],
                                invoke: {
                                    src: "handleForceChangePassword",
                                    ...$a71026f654359fa5$var$handleSignInResponse
                                }
                            }
                        }
                    }
                }
            },
            setupTotp: {
                initial: "edit",
                exit: [
                    "clearFormValues",
                    "clearError",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SIGN_IN: "#signInActor.signIn",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: "pending",
                        entry: [
                            "sendUpdate",
                            "clearError"
                        ],
                        invoke: {
                            src: "confirmSignIn",
                            ...$a71026f654359fa5$var$handleSignInResponse
                        }
                    }
                }
            },
            resolved: {
                type: "final",
                data: (context)=>({
                        codeDeliveryDetails: context.codeDeliveryDetails,
                        remoteError: context.remoteError,
                        step: context.step,
                        unverifiedUserAttributes: context.unverifiedUserAttributes,
                        username: context.username
                    })
            }
        }
    }, {
        // sendUpdate is a HOC
        actions: {
            ...(0, $86bd895eb2ae87a7$export$2e2bcd8739ae039),
            sendUpdate: (0, $54ea967ad60a4c8d$export$7f8b724299523eb6)()
        },
        guards: (0, $6390b9cb027d73c6$export$2e2bcd8739ae039),
        services: {
            async fetchUserAttributes () {
                return (0, $fb45c8ccae5d9e4c$export$5dc95ecf3f16c6c9)();
            },
            resetPassword ({ username: username }) {
                return (0, $a8f5d50af40abab8$export$dc726c8e334dd814)({
                    username: username
                });
            },
            handleResendSignUpCode ({ username: username }) {
                return (0, $e39de46791517062$export$b295e842f1d42d13)({
                    username: username
                });
            },
            handleSignIn ({ formValues: formValues, username: username }) {
                const { password: password } = formValues;
                return services.handleSignIn({
                    username: username,
                    password: password
                });
            },
            confirmSignIn ({ formValues: formValues }) {
                const { confirmation_code: challengeResponse } = formValues;
                return services.handleConfirmSignIn({
                    challengeResponse: challengeResponse
                });
            },
            async handleForceChangePassword ({ formValues: formValues }) {
                let { password: challengeResponse, phone_number: phone_number, country_code: country_code, confirm_password: // destructure and toss UI confirm_password field
                // to prevent error from sending to confirmSignIn
                confirm_password, ...userAttributes } = formValues;
                let phoneNumberWithCountryCode;
                if (phone_number) {
                    phoneNumberWithCountryCode = `${country_code}${phone_number}`.replace(/[^A-Z0-9+]/gi, "");
                    userAttributes = {
                        ...userAttributes,
                        phone_number: phoneNumberWithCountryCode
                    };
                }
                const input = {
                    challengeResponse: challengeResponse,
                    options: {
                        userAttributes: userAttributes
                    }
                };
                return (0, $e1fb4f4fbfe74169$export$a477d84c2f7b792a)(input);
            },
            signInWithRedirect (_, { data: data }) {
                return (0, $832f6c109a70d147$export$3d0a7d1372e866bb)(data);
            },
            async validateFields (context) {
                return (0, $e381f49dc6978a71$export$59e2b39f02edfada)(context.formValues, context.touched, context.passwordSettings, [
                    (0, $33f526657d26fae3$export$7ae2d201ca9520b).validateFormPassword,
                    (0, $33f526657d26fae3$export$7ae2d201ca9520b).validateConfirmPassword
                ]);
            }
        }
    });
}








const $210ddd3b19ee4ec1$var$handleResetPasswordResponse = {
    onDone: [
        {
            actions: "setCodeDeliveryDetails",
            target: "#signUpActor.resolved"
        }
    ],
    onError: {
        actions: [
            "setRemoteError",
            "sendUpdate"
        ]
    }
};
const $210ddd3b19ee4ec1$var$handleAutoSignInResponse = {
    onDone: [
        {
            cond: "hasCompletedSignIn",
            actions: "setNextSignInStep",
            target: "#signUpActor.fetchUserAttributes"
        },
        {
            cond: "shouldConfirmSignInWithNewPassword",
            actions: "setNextSignInStep",
            target: "#signUpActor.resolved"
        },
        {
            cond: "shouldResetPasswordFromSignIn",
            actions: "setNextSignInStep",
            target: "#signUpActor.resetPassword"
        },
        {
            cond: "shouldConfirmSignUpFromSignIn",
            actions: "setNextSignInStep",
            target: "#signUpActor.resendSignUpCode"
        },
        {
            actions: [
                "setNextSignInStep",
                "setChallengeName",
                "setMissingAttributes",
                "setTotpSecretCode"
            ],
            target: "#signUpActor.resolved"
        }
    ],
    onError: {
        actions: "setRemoteError",
        target: "#signUpActor.resolved"
    }
};
const $210ddd3b19ee4ec1$var$handleFetchUserAttributesResponse = {
    onDone: [
        {
            cond: "shouldVerifyAttribute",
            actions: [
                "setShouldVerifyUserAttributeStep",
                "setUnverifiedUserAttributes"
            ],
            target: "#signUpActor.resolved"
        },
        {
            actions: "setConfirmAttributeCompleteStep",
            target: "#signUpActor.resolved"
        }
    ],
    onError: {
        actions: "setConfirmAttributeCompleteStep",
        target: "#signUpActor.resolved"
    }
};
function $210ddd3b19ee4ec1$export$6cf61434854181b4({ services: services }) {
    return (0, $66ceff3818583d23$export$aaa7fa18f8e9b2e8)({
        id: "signUpActor",
        initial: "init",
        predictableActionArguments: true,
        states: {
            init: {
                always: [
                    {
                        cond: "shouldConfirmSignUp",
                        target: "confirmSignUp"
                    },
                    {
                        target: "signUp"
                    }
                ]
            },
            autoSignIn: {
                tags: "pending",
                invoke: {
                    src: "autoSignIn",
                    ...$210ddd3b19ee4ec1$var$handleAutoSignInResponse
                }
            },
            fetchUserAttributes: {
                invoke: {
                    src: "fetchUserAttributes",
                    ...$210ddd3b19ee4ec1$var$handleFetchUserAttributesResponse
                }
            },
            resetPassword: {
                invoke: {
                    src: "resetPassword",
                    ...$210ddd3b19ee4ec1$var$handleResetPasswordResponse
                }
            },
            resendSignUpCode: {
                tags: "pending",
                entry: "sendUpdate",
                exit: "sendUpdate",
                invoke: {
                    src: "resendSignUpCode",
                    onDone: {
                        actions: [
                            "setCodeDeliveryDetails",
                            "sendUpdate"
                        ],
                        target: "#signUpActor.confirmSignUp"
                    },
                    onError: [
                        {
                            cond: "isUserAlreadyConfirmed",
                            target: "#signUpActor.resolved"
                        },
                        {
                            actions: [
                                "setRemoteError",
                                "sendUpdate"
                            ]
                        }
                    ]
                }
            },
            signUp: {
                type: "parallel",
                exit: "clearTouched",
                states: {
                    validation: {
                        initial: "pending",
                        states: {
                            pending: {
                                invoke: {
                                    src: "validateSignUp",
                                    onDone: {
                                        actions: "clearValidationError",
                                        target: "valid"
                                    },
                                    onError: {
                                        actions: "setFieldErrors",
                                        target: "invalid"
                                    }
                                }
                            },
                            valid: {
                                entry: "sendUpdate"
                            },
                            invalid: {
                                entry: "sendUpdate"
                            }
                        },
                        on: {
                            CHANGE: {
                                actions: "handleInput",
                                target: ".pending"
                            },
                            BLUR: {
                                actions: "handleBlur",
                                target: ".pending"
                            }
                        }
                    },
                    submission: {
                        initial: "idle",
                        states: {
                            idle: {
                                entry: [
                                    "sendUpdate"
                                ],
                                on: {
                                    SUBMIT: {
                                        actions: "handleSubmit",
                                        target: "validate"
                                    },
                                    FEDERATED_SIGN_IN: "federatedSignIn"
                                }
                            },
                            federatedSignIn: {
                                entry: [
                                    "sendUpdate",
                                    "clearError"
                                ],
                                invoke: {
                                    src: "federatedSignIn",
                                    onError: {
                                        actions: "setRemoteError"
                                    }
                                }
                            },
                            validate: {
                                entry: "sendUpdate",
                                invoke: {
                                    src: "validateSignUp",
                                    onDone: {
                                        target: "signUp",
                                        actions: "clearValidationError"
                                    },
                                    onError: {
                                        actions: "setFieldErrors",
                                        target: "idle"
                                    }
                                }
                            },
                            signUp: {
                                tags: "pending",
                                entry: [
                                    "setUsernameSignUp",
                                    "clearError"
                                ],
                                exit: "sendUpdate",
                                invoke: {
                                    src: "handleSignUp",
                                    onDone: [
                                        {
                                            cond: "hasCompletedSignUp",
                                            actions: "setNextSignUpStep",
                                            target: "#signUpActor.resolved"
                                        },
                                        {
                                            cond: "shouldAutoSignIn",
                                            actions: "setNextSignUpStep",
                                            target: "#signUpActor.autoSignIn"
                                        },
                                        {
                                            actions: [
                                                "setCodeDeliveryDetails",
                                                "setNextSignUpStep"
                                            ],
                                            target: "#signUpActor.init"
                                        }
                                    ],
                                    onError: {
                                        actions: [
                                            "sendUpdate",
                                            "setRemoteError"
                                        ],
                                        target: "idle"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            confirmSignUp: {
                initial: "edit",
                entry: "sendUpdate",
                states: {
                    edit: {
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            CHANGE: {
                                actions: "handleInput"
                            },
                            BLUR: {
                                actions: "handleBlur"
                            },
                            RESEND: "#signUpActor.resendSignUpCode"
                        }
                    },
                    submit: {
                        tags: "pending",
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "confirmSignUp",
                            onDone: [
                                {
                                    cond: "shouldAutoSignIn",
                                    actions: [
                                        "setNextSignUpStep",
                                        "clearFormValues"
                                    ],
                                    target: "#signUpActor.autoSignIn"
                                },
                                {
                                    actions: "setNextSignUpStep",
                                    target: "#signUpActor.init"
                                }
                            ],
                            onError: {
                                actions: [
                                    "setRemoteError",
                                    "sendUpdate"
                                ],
                                target: "edit"
                            }
                        }
                    }
                }
            },
            resolved: {
                type: "final",
                data: (context)=>({
                        challengeName: context.challengeName,
                        missingAttributes: context.missingAttributes,
                        remoteError: context.remoteError,
                        step: context.step,
                        totpSecretCode: context.totpSecretCode,
                        unverifiedUserAttributes: context.unverifiedUserAttributes
                    })
            }
        }
    }, {
        // sendUpdate is a HOC
        actions: {
            ...(0, $86bd895eb2ae87a7$export$2e2bcd8739ae039),
            sendUpdate: (0, $54ea967ad60a4c8d$export$7f8b724299523eb6)()
        },
        guards: (0, $6390b9cb027d73c6$export$2e2bcd8739ae039),
        services: {
            autoSignIn () {
                return (0, $22082fbe5823304e$export$c5378dc7d6787fa5)();
            },
            async fetchUserAttributes () {
                return (0, $fb45c8ccae5d9e4c$export$5dc95ecf3f16c6c9)();
            },
            confirmSignUp ({ formValues: formValues, username: username }) {
                const { confirmation_code: confirmationCode } = formValues;
                const input = {
                    username: username,
                    confirmationCode: confirmationCode
                };
                return services.handleConfirmSignUp(input);
            },
            resendSignUpCode ({ username: username }) {
                return (0, $e39de46791517062$export$b295e842f1d42d13)({
                    username: username
                });
            },
            async federatedSignIn (_, { data: data }) {
                return (0, $832f6c109a70d147$export$3d0a7d1372e866bb)(data);
            },
            async handleSignUp (context) {
                const { formValues: formValues, loginMechanisms: loginMechanisms, username: username } = context;
                const loginMechanism = loginMechanisms[0];
                const input = (0, $3ed0b9573b469d61$export$6bc605b0b68c7601)(username, formValues, loginMechanism);
                return services.handleSignUp(input);
            },
            async validateSignUp (context) {
                // This needs to exist in the machine to reference new `services`
                return (0, $e381f49dc6978a71$export$59e2b39f02edfada)(context.formValues, context.touched, context.passwordSettings, [
                    // Validation of password
                    services.validateFormPassword,
                    // Validation for default form fields
                    services.validateConfirmPassword,
                    services.validatePreferredUsername,
                    // Validation for any custom Sign Up fields
                    services.validateCustomSignUp
                ]);
            }
        }
    });
}




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function $400447448b66272d$export$d1b63878dfcc70a6() {
    return (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).Auth.clearCredentials();
}












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $2c079164b60623bc$export$f8a4fedaab76b065 = async (store)=>{
    await store.clearOAuthData();
    (0, $c6bbd61934ed7f36$export$66561e66d62991d0).clearTokens();
    await (0, $400447448b66272d$export$d1b63878dfcc70a6)();
    (0, $2f4552e504bc473c$export$8c41bb232f1008b1).dispatch("auth", {
        event: "signedOut"
    }, "Auth", (0, $2f4552e504bc473c$export$aadf71dd9875dd20));
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $b181273746230a66$export$a20426d3d43ad21f = async (authConfig, preferPrivateSession = false)=>{
    (0, $a6de0542b1980a7d$export$c13e6dbaf90a8e5f)(authConfig);
    const { loginWith: loginWith, userPoolClientId: userPoolClientId } = authConfig;
    const { domain: domain, redirectSignOut: redirectSignOut } = loginWith.oauth;
    const signoutUri = (0, $d5a2dafc9f8f58d8$export$93832c3affb240d3)(redirectSignOut);
    const oAuthLogoutEndpoint = `https://${domain}/logout?${Object.entries({
        client_id: userPoolClientId,
        logout_uri: encodeURIComponent(signoutUri)
    }).map(([k, v])=>`${k}=${v}`).join("&")}`;
    return (0, $dbe5278864d048d9$export$a673d54799039714)(oAuthLogoutEndpoint);
};


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $3a725df99cc0a67e$export$74290142c99a2f64 = async (cognitoConfig, store)=>{
    const { isOAuthSignIn: isOAuthSignIn } = await store.loadOAuthSignIn();
    // Clear everything before attempting to visted logout endpoint since the current application
    // state could be wiped away on redirect
    await (0, $2c079164b60623bc$export$f8a4fedaab76b065)(store);
    if (isOAuthSignIn) // On web, this will always end up being a void action
    return (0, $b181273746230a66$export$a20426d3d43ad21f)(cognitoConfig);
};





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $043a0866d6f8afd3$var$logger = new (0, $b5731988345712b1$export$ba6a9c7ac8291f7f)("Auth");
/**
 * Signs a user out
 *
 * @param input - The SignOutInput object
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $043a0866d6f8afd3$export$b0ac3a1c242cb1ea(input) {
    const cognitoConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(cognitoConfig);
    if (input?.global) await $043a0866d6f8afd3$var$globalSignOut(cognitoConfig);
    else await $043a0866d6f8afd3$var$clientSignOut(cognitoConfig);
    let hasOAuthConfig;
    try {
        (0, $a6de0542b1980a7d$export$c13e6dbaf90a8e5f)(cognitoConfig);
        hasOAuthConfig = true;
    } catch (err) {
        hasOAuthConfig = false;
    }
    if (hasOAuthConfig) {
        const oAuthStore = new (0, $ba26f06a9401015f$export$9b2cef5d94f9b6e8)((0, $68ccea2c33038f88$export$586b30dcaeecb901));
        oAuthStore.setAuthConfig(cognitoConfig);
        const { type: type } = await (0, $3a725df99cc0a67e$export$74290142c99a2f64)(cognitoConfig, oAuthStore) ?? {};
        if (type === "error") throw new (0, $f3f3005c274c9374$export$145273558d58e0ac)({
            name: (0, $7674474451b5177a$export$625255707e22459c),
            message: "An error occurred when attempting to log out from OAuth provider."
        });
    } else {
        // complete sign out
        (0, $c6bbd61934ed7f36$export$66561e66d62991d0).clearTokens();
        await (0, $400447448b66272d$export$d1b63878dfcc70a6)();
        (0, $2f4552e504bc473c$export$8c41bb232f1008b1).dispatch("auth", {
            event: "signedOut"
        }, "Auth", (0, $2f4552e504bc473c$export$aadf71dd9875dd20));
    }
}
async function $043a0866d6f8afd3$var$clientSignOut(cognitoConfig) {
    try {
        const authTokens = await (0, $c6bbd61934ed7f36$export$66561e66d62991d0).getTokenStore().loadTokens();
        (0, $627294a07e5270d4$export$be38b2d22222d505)(authTokens);
        if ($043a0866d6f8afd3$var$isSessionRevocable(authTokens.accessToken)) await (0, $c845c6a72bc4ff0c$export$2428f6ba65615593)({
            region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(cognitoConfig.userPoolId),
            userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).SignOut)
        }, {
            ClientId: cognitoConfig.userPoolClientId,
            Token: authTokens.refreshToken
        });
    } catch (err) {
        // this shouldn't throw
        $043a0866d6f8afd3$var$logger.debug("Client signOut error caught but will proceed with token removal");
    }
}
async function $043a0866d6f8afd3$var$globalSignOut(cognitoConfig) {
    try {
        const authTokens = await (0, $c6bbd61934ed7f36$export$66561e66d62991d0).getTokenStore().loadTokens();
        (0, $627294a07e5270d4$export$77712ea5882cac9f)(authTokens);
        await (0, $c845c6a72bc4ff0c$export$a92c2ab9b6303723)({
            region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(cognitoConfig.userPoolId),
            userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).SignOut)
        }, {
            AccessToken: authTokens.accessToken.toString()
        });
    } catch (err) {
        // it should not throw
        $043a0866d6f8afd3$var$logger.debug("Global signOut error caught but will proceed with token removal");
    }
}
const $043a0866d6f8afd3$var$isSessionRevocable = (token)=>!!token?.payload?.origin_jti;


const $5ad5af53c247e659$export$2f15f45f1f7b7787 = ()=>{
    return (0, $66ceff3818583d23$export$aaa7fa18f8e9b2e8)({
        initial: "pending",
        id: "signOutActor",
        predictableActionArguments: true,
        states: {
            pending: {
                tags: "pending",
                invoke: {
                    src: "signOut",
                    onDone: "resolved",
                    onError: "rejected"
                }
            },
            resolved: {
                type: "final"
            },
            rejected: {
                type: "final"
            }
        }
    }, {
        services: {
            signOut: ()=>(0, $043a0866d6f8afd3$export$b0ac3a1c242cb1ea)()
        }
    });
};











// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Confirms a user attribute with the confirmation code.
 *
 * @param input -  The ConfirmUserAttributeInput object
 * @throws  -{@link AuthValidationErrorCode } -
 * Thrown when `confirmationCode` is not defined.
 * @throws  -{@link VerifyUserAttributeException } - Thrown due to an invalid confirmation code or attribute.
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ async function $34b90e3b4c422598$export$db3262544786991c(input) {
    const authConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
    const { confirmationCode: confirmationCode, userAttributeKey: userAttributeKey } = input;
    (0, $a8815436fa0c8e22$export$45936001d12f9b53)(!!confirmationCode, (0, $1a8aa0bd1b5b8783$export$12d5c695b2213c4a).EmptyConfirmUserAttributeCode);
    const { tokens: tokens } = await (0, $134e0c98154db662$export$39430dfe49142ae)({
        forceRefresh: false
    });
    (0, $627294a07e5270d4$export$77712ea5882cac9f)(tokens);
    await (0, $c845c6a72bc4ff0c$export$40fc6c986f86e9a5)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).ConfirmUserAttribute)
    }, {
        AccessToken: tokens.accessToken.toString(),
        AttributeName: userAttributeKey,
        Code: confirmationCode
    });
}







// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Resends user's confirmation code when updating attributes while authenticated.
 *
 * @param input - The SendUserAttributeVerificationCodeInput object
 * @returns SendUserAttributeVerificationCodeOutput
 * @throws - {@link GetUserAttributeVerificationException}
 * @throws AuthTokenConfigException - Thrown when the token provider config is invalid.
 */ const $b450311a6f51bab6$export$fa66ca482758432e = async (input)=>{
    const { userAttributeKey: userAttributeKey, options: options } = input;
    const authConfig = (0, $623ac757f0e7ef86$export$a3858a9a153cffc7).getConfig().Auth?.Cognito;
    const clientMetadata = options?.clientMetadata;
    (0, $a6de0542b1980a7d$export$80c92581e59ed502)(authConfig);
    const { tokens: tokens } = await (0, $134e0c98154db662$export$39430dfe49142ae)({
        forceRefresh: false
    });
    (0, $627294a07e5270d4$export$77712ea5882cac9f)(tokens);
    const { CodeDeliveryDetails: CodeDeliveryDetails } = await (0, $c845c6a72bc4ff0c$export$3a9721eaccd0e7b3)({
        region: (0, $02a1ee431875bfed$export$d4a625cede2da71b)(authConfig.userPoolId),
        userAgentValue: (0, $e83a7063f99da276$export$d6cd780379f37dae)((0, $46bbfb42d61f6c30$export$900b1436d7e65f4).SendUserAttributeVerificationCode)
    }, {
        AccessToken: tokens.accessToken.toString(),
        ClientMetadata: clientMetadata,
        AttributeName: userAttributeKey
    });
    const { DeliveryMedium: DeliveryMedium, AttributeName: AttributeName, Destination: Destination } = {
        ...CodeDeliveryDetails
    };
    return {
        destination: Destination,
        deliveryMedium: DeliveryMedium,
        attributeName: AttributeName
    };
};





function $780b96750674877c$export$15cd9b2846733edf() {
    return (0, $66ceff3818583d23$export$aaa7fa18f8e9b2e8)({
        id: "verifyUserAttributesActor",
        initial: "selectUserAttributes",
        predictableActionArguments: true,
        states: {
            selectUserAttributes: {
                initial: "edit",
                exit: [
                    "clearError",
                    "clearTouched",
                    "sendUpdate"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SKIP: {
                                target: "#verifyUserAttributesActor.resolved"
                            },
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: "pending",
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "sendUserAttributeVerificationCode",
                            onDone: {
                                actions: [
                                    "setSelectedUserAttribute",
                                    "setCodeDeliveryDetails"
                                ],
                                target: "#verifyUserAttributesActor.confirmVerifyUserAttribute"
                            },
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    }
                }
            },
            confirmVerifyUserAttribute: {
                initial: "edit",
                exit: [
                    "clearError",
                    "clearFormValues",
                    "clearTouched"
                ],
                states: {
                    edit: {
                        entry: "sendUpdate",
                        on: {
                            SUBMIT: {
                                actions: "handleSubmit",
                                target: "submit"
                            },
                            SKIP: "#verifyUserAttributesActor.resolved",
                            CHANGE: {
                                actions: "handleInput"
                            }
                        }
                    },
                    submit: {
                        tags: "pending",
                        entry: [
                            "clearError",
                            "sendUpdate"
                        ],
                        invoke: {
                            src: "confirmVerifyUserAttribute",
                            onDone: {
                                actions: [
                                    "setConfirmAttributeCompleteStep",
                                    "clearSelectedUserAttribute"
                                ],
                                target: "#verifyUserAttributesActor.resolved"
                            },
                            onError: {
                                actions: "setRemoteError",
                                target: "edit"
                            }
                        }
                    }
                }
            },
            resolved: {
                type: "final",
                data: ({ step: step })=>({
                        step: step
                    })
            }
        }
    }, {
        // sendUpdate is a HOC
        actions: {
            ...(0, $86bd895eb2ae87a7$export$2e2bcd8739ae039),
            sendUpdate: (0, $54ea967ad60a4c8d$export$7f8b724299523eb6)()
        },
        services: {
            sendUserAttributeVerificationCode ({ formValues: { unverifiedAttr: unverifiedAttr } }) {
                const input = {
                    userAttributeKey: unverifiedAttr
                };
                return (0, $b450311a6f51bab6$export$fa66ca482758432e)(input);
            },
            async confirmVerifyUserAttribute ({ formValues: { confirmation_code: confirmationCode }, selectedUserAttribute: selectedUserAttribute }) {
                const input = {
                    confirmationCode: confirmationCode,
                    userAttributeKey: selectedUserAttribute
                };
                return (0, $34b90e3b4c422598$export$db3262544786991c)(input);
            },
            async validateFields (context) {
                return (0, $e381f49dc6978a71$export$59e2b39f02edfada)(context.formValues, context.touched, context.passwordSettings, [
                    (0, $33f526657d26fae3$export$7ae2d201ca9520b).validateFormPassword,
                    (0, $33f526657d26fae3$export$7ae2d201ca9520b).validateConfirmPassword
                ]);
            }
        }
    });
}



const $b3e9250a932361f5$var$getActorContext = (context, defaultStep)=>({
        ...context.actorDoneData,
        step: context?.actorDoneData?.step ?? defaultStep,
        // initialize empty objects on actor start
        formValues: {},
        touched: {},
        validationError: {},
        // values included on `context.config` that should be available in actors
        formFields: context.config?.formFields,
        loginMechanisms: context.config?.loginMechanisms,
        passwordSettings: context.config?.passwordSettings,
        signUpAttributes: context.config?.signUpAttributes,
        socialProviders: context.config?.socialProviders
    });
const { choose: $b3e9250a932361f5$var$choose, stop: $b3e9250a932361f5$var$stop } = (0, $f9b2d12db4f71f3e$exports);
const $b3e9250a932361f5$var$stopActor = (machineId)=>$b3e9250a932361f5$var$stop(machineId);
// setup step waits for ui to emit INIT action to proceed to configure
const $b3e9250a932361f5$var$LEGACY_WAIT_CONFIG = {
    on: {
        INIT: {
            actions: [
                "configure"
            ],
            target: "getConfig"
        },
        SIGN_OUT: "#authenticator.signOut"
    }
};
// setup step proceeds directly to configure
const $b3e9250a932361f5$var$NEXT_WAIT_CONFIG = {
    always: {
        actions: [
            "configure"
        ],
        target: "getConfig"
    }
};
function $b3e9250a932361f5$export$af98f08c6e0e0d4d(options) {
    const { useNextWaitConfig: useNextWaitConfig, ...overrideConfigServices } = options ?? {};
    const initConfig = useNextWaitConfig ? $b3e9250a932361f5$var$NEXT_WAIT_CONFIG : $b3e9250a932361f5$var$LEGACY_WAIT_CONFIG;
    return (0, $66ceff3818583d23$export$aaa7fa18f8e9b2e8)({
        id: "authenticator",
        initial: "idle",
        context: {
            user: undefined,
            config: {},
            services: (0, $33f526657d26fae3$export$7ae2d201ca9520b),
            actorRef: undefined,
            hasSetup: false
        },
        predictableActionArguments: true,
        states: {
            // See: https://xstate.js.org/docs/guides/communication.html#invoking-promises
            idle: {
                invoke: {
                    src: "handleGetCurrentUser",
                    onDone: {
                        actions: "setUser",
                        target: "setup"
                    },
                    onError: {
                        target: "setup"
                    }
                }
            },
            setup: {
                initial: "initConfig",
                states: {
                    initConfig: initConfig,
                    getConfig: {
                        invoke: {
                            src: "getAmplifyConfig",
                            onDone: [
                                {
                                    actions: [
                                        "applyAmplifyConfig",
                                        "setHasSetup"
                                    ],
                                    cond: "hasUser",
                                    target: "#authenticator.authenticated"
                                },
                                {
                                    actions: [
                                        "applyAmplifyConfig",
                                        "setHasSetup"
                                    ],
                                    target: "goToInitialState"
                                }
                            ]
                        }
                    },
                    goToInitialState: {
                        always: [
                            {
                                cond: "isInitialStateSignUp",
                                target: "#authenticator.signUpActor"
                            },
                            {
                                cond: "isInitialStateResetPassword",
                                target: "#authenticator.forgotPasswordActor"
                            },
                            {
                                target: "#authenticator.signInActor"
                            }
                        ]
                    }
                }
            },
            getCurrentUser: {
                invoke: {
                    src: "handleGetCurrentUser",
                    onDone: {
                        actions: "setUser",
                        target: "#authenticator.authenticated"
                    },
                    onError: {
                        target: "#authenticator.setup"
                    }
                }
            },
            signInActor: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnSignInActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: $b3e9250a932361f5$var$stopActor("signInActor")
                    }
                },
                on: {
                    FORGOT_PASSWORD: "forgotPasswordActor",
                    SIGN_IN: "signInActor",
                    SIGN_UP: "signUpActor",
                    "done.invoke.signInActor": [
                        {
                            cond: "hasCompletedAttributeConfirmation",
                            target: "#authenticator.getCurrentUser"
                        },
                        {
                            cond: "isShouldConfirmUserAttributeStep",
                            actions: "setActorDoneData",
                            target: "#authenticator.verifyUserAttributesActor"
                        },
                        {
                            cond: "isResetPasswordStep",
                            actions: "setActorDoneData",
                            target: "#authenticator.forgotPasswordActor"
                        },
                        {
                            cond: "isConfirmSignUpStep",
                            actions: "setActorDoneData",
                            target: "#authenticator.signUpActor"
                        }
                    ]
                }
            },
            signUpActor: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnSignUpActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: $b3e9250a932361f5$var$stopActor("signUpActor")
                    }
                },
                on: {
                    SIGN_IN: "signInActor",
                    "done.invoke.signUpActor": [
                        {
                            cond: "hasCompletedAttributeConfirmation",
                            target: "#authenticator.getCurrentUser"
                        },
                        {
                            cond: "isConfirmUserAttributeStep",
                            target: "#authenticator.verifyUserAttributesActor"
                        },
                        {
                            actions: "setActorDoneData",
                            target: "#authenticator.signInActor"
                        }
                    ]
                }
            },
            forgotPasswordActor: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnForgotPasswordActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: $b3e9250a932361f5$var$stopActor("forgotPasswordActor")
                    }
                },
                on: {
                    SIGN_IN: "signInActor",
                    "done.invoke.forgotPasswordActor": [
                        {
                            target: "#authenticator.signInActor"
                        }
                    ]
                }
            },
            verifyUserAttributesActor: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnVerifyUserAttributesActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: $b3e9250a932361f5$var$stopActor("verifyUserAttributesActor")
                    }
                },
                on: {
                    "done.invoke.verifyUserAttributesActor": [
                        {
                            actions: "setActorDoneData",
                            target: "#authenticator.getCurrentUser"
                        }
                    ]
                }
            },
            authenticated: {
                initial: "idle",
                states: {
                    idle: {
                        on: {
                            TOKEN_REFRESH: "refreshUser"
                        }
                    },
                    refreshUser: {
                        invoke: {
                            src: "#authenticator.getCurrentUser",
                            onDone: {
                                actions: "setUser",
                                target: "idle"
                            },
                            onError: {
                                target: "#authenticator.signOut"
                            }
                        }
                    }
                },
                on: {
                    SIGN_OUT: "signOut"
                }
            },
            signOut: {
                initial: "spawnActor",
                states: {
                    spawnActor: {
                        always: {
                            actions: "spawnSignOutActor",
                            target: "runActor"
                        }
                    },
                    runActor: {
                        entry: "clearActorDoneData",
                        exit: $b3e9250a932361f5$var$stopActor("signOutActor")
                    }
                },
                on: {
                    "done.invoke.signOutActor": {
                        actions: "clearUser",
                        target: "setup.getConfig"
                    }
                }
            }
        },
        on: {
            SIGN_IN_WITH_REDIRECT: {
                target: "#authenticator.getCurrentUser"
            },
            CHANGE: {
                actions: "forwardToActor"
            },
            BLUR: {
                actions: "forwardToActor"
            },
            SUBMIT: {
                actions: "forwardToActor"
            },
            FEDERATED_SIGN_IN: {
                actions: "forwardToActor"
            },
            RESEND: {
                actions: "forwardToActor"
            },
            SIGN_IN: {
                actions: "forwardToActor"
            },
            SKIP: {
                actions: "forwardToActor"
            }
        }
    }, {
        actions: {
            ...(0, $86bd895eb2ae87a7$export$2e2bcd8739ae039),
            forwardToActor: $b3e9250a932361f5$var$choose([
                {
                    cond: "hasActor",
                    actions: (0, $54ea967ad60a4c8d$export$eb147b7589db8e8a)(({ actorRef: actorRef })=>actorRef)
                }
            ]),
            setActorDoneData: (0, $54ea967ad60a4c8d$export$e6e34fd1f2686227)({
                actorDoneData: (context, event)=>({
                        codeDeliveryDetails: event.data.codeDeliveryDetails,
                        missingAttributes: event.data.missingAttributes,
                        remoteError: event.data.remoteError,
                        username: event.data.username,
                        step: event.data.step,
                        totpSecretCode: event.data.totpSecretCode,
                        unverifiedUserAttributes: event.data.unverifiedUserAttributes
                    })
            }),
            applyAmplifyConfig: (0, $54ea967ad60a4c8d$export$e6e34fd1f2686227)({
                config (context, { data: cliConfig }) {
                    // Prefer explicitly configured settings over default CLI values\
                    const { loginMechanisms: loginMechanisms = cliConfig.loginMechanisms ?? [], signUpAttributes: signUpAttributes = cliConfig.signUpAttributes ?? [], socialProviders: socialProviders = cliConfig.socialProviders ?? [], initialState: initialState, formFields: _formFields, passwordSettings: passwordSettings = cliConfig.passwordFormat ?? {} } = context.config;
                    // By default, Cognito assumes `username`, so there isn't a different username attribute like `email`.
                    // We explicitly add it as a login mechanism to be consistent with Admin UI's language.
                    if (loginMechanisms.length === 0) loginMechanisms.push("username");
                    const formFields = $b3e9250a932361f5$var$convertFormFields(_formFields) ?? {};
                    return {
                        formFields: formFields,
                        initialState: initialState,
                        loginMechanisms: loginMechanisms,
                        passwordSettings: passwordSettings,
                        signUpAttributes: signUpAttributes,
                        socialProviders: socialProviders
                    };
                }
            }),
            spawnSignInActor: (0, $54ea967ad60a4c8d$export$e6e34fd1f2686227)({
                actorRef: (context, _)=>{
                    const { services: services } = context;
                    const actor = (0, $a71026f654359fa5$export$f9c30eaa77191700)({
                        services: services
                    }).withContext($b3e9250a932361f5$var$getActorContext(context, "SIGN_IN"));
                    return (0, $0a71063706b576da$export$1713f5ac2bf0caf5)(actor, {
                        name: "signInActor"
                    });
                }
            }),
            spawnSignUpActor: (0, $54ea967ad60a4c8d$export$e6e34fd1f2686227)({
                actorRef: (context, _)=>{
                    const { services: services } = context;
                    const actor = (0, $210ddd3b19ee4ec1$export$6cf61434854181b4)({
                        services: services
                    }).withContext($b3e9250a932361f5$var$getActorContext(context, "SIGN_UP"));
                    return (0, $0a71063706b576da$export$1713f5ac2bf0caf5)(actor, {
                        name: "signUpActor"
                    });
                }
            }),
            spawnForgotPasswordActor: (0, $54ea967ad60a4c8d$export$e6e34fd1f2686227)({
                actorRef: (context, _)=>{
                    const { services: services } = context;
                    const actor = (0, $1b886b1c1ef05fd6$export$d384478d1c0083d2)({
                        services: services
                    }).withContext($b3e9250a932361f5$var$getActorContext(context, "FORGOT_PASSWORD"));
                    return (0, $0a71063706b576da$export$1713f5ac2bf0caf5)(actor, {
                        name: "forgotPasswordActor"
                    });
                }
            }),
            spawnVerifyUserAttributesActor: (0, $54ea967ad60a4c8d$export$e6e34fd1f2686227)({
                actorRef: (context)=>{
                    const actor = (0, $780b96750674877c$export$15cd9b2846733edf)().withContext($b3e9250a932361f5$var$getActorContext(context));
                    return (0, $0a71063706b576da$export$1713f5ac2bf0caf5)(actor, {
                        name: "verifyUserAttributesActor"
                    });
                }
            }),
            spawnSignOutActor: (0, $54ea967ad60a4c8d$export$e6e34fd1f2686227)({
                actorRef: (context)=>{
                    const actor = (0, $5ad5af53c247e659$export$2f15f45f1f7b7787)().withContext({
                        user: context?.user
                    });
                    return (0, $0a71063706b576da$export$1713f5ac2bf0caf5)(actor, {
                        name: "signOutActor"
                    });
                }
            }),
            configure: (0, $54ea967ad60a4c8d$export$e6e34fd1f2686227)((_, event)=>{
                const { services: customServices, ...config } = !(0, $697901644f774aa4$export$83b788b1a3698c03)(overrideConfigServices) ? overrideConfigServices : event.data ?? {};
                return {
                    services: {
                        ...(0, $33f526657d26fae3$export$7ae2d201ca9520b),
                        ...customServices
                    },
                    config: config
                };
            }),
            setHasSetup: (0, $54ea967ad60a4c8d$export$e6e34fd1f2686227)({
                hasSetup: true
            })
        },
        guards: {
            ...(0, $6390b9cb027d73c6$export$2e2bcd8739ae039),
            hasActor: ({ actorRef: actorRef })=>!!actorRef,
            isInitialStateSignUp: ({ config: config })=>config.initialState === "signUp",
            isInitialStateResetPassword: ({ config: config })=>config.initialState === "forgotPassword",
            shouldSetup: ({ hasSetup: hasSetup })=>!hasSetup,
            hasUser: ({ user: user })=>{
                return !!user;
            }
        },
        services: {
            getAmplifyConfig: ({ services: services })=>services.getAmplifyConfig(),
            handleGetCurrentUser: ({ services: services })=>services.getCurrentUser()
        }
    });
}
function $b3e9250a932361f5$var$convertFormFields(formFields) {
    if (formFields) Object.keys(formFields).forEach((component)=>{
        Object.keys(formFields[component]).forEach((inputName)=>{
            let ff = formFields[component][inputName];
            ff.required = ff.isRequired;
        });
    });
    return formFields;
}





/**
 * Handles Amplify JS Auth hub events, by forwarding hub events as appropriate
 * xstate events.
 */ const $68134900edbe6e80$export$f726708373635d8a = async ({ payload: payload }, service, options)=>{
    const { event: event } = payload;
    const { send: send } = service;
    const { onSignIn: onSignIn, onSignOut: onSignOut } = options ?? {};
    switch(event){
        case "signedIn":
            if ((0, $697901644f774aa4$export$f6e2535fb5126e54)(onSignIn)) onSignIn(payload);
            break;
        case "signInWithRedirect":
            send("SIGN_IN_WITH_REDIRECT");
            break;
        case "signedOut":
        case "tokenRefresh_failure":
            if (event === "signedOut" && (0, $697901644f774aa4$export$f6e2535fb5126e54)(onSignOut)) onSignOut();
            send("SIGN_OUT");
            break;
    }
};
const $68134900edbe6e80$var$getHubEventHandler = (service, handler)=>(data)=>{
        handler(data, service);
    };
/**
 * Listens to external auth Hub events and sends corresponding event to
 * the `authService` of interest
 *
 * @param send - `send` function associated with the `authService` of interest
 *
 * @returns function that unsubscribes to the hub evenmt
 */ const $68134900edbe6e80$export$4776c363cae9362c = (service, // angular passes its own `handler` param
handler = $68134900edbe6e80$export$f726708373635d8a)=>{
    return (0, $2f4552e504bc473c$export$8c41bb232f1008b1).listen("auth", $68134900edbe6e80$var$getHubEventHandler(service, handler), "authenticator-hub-handler");
};



var $1T1QG = parcelRequire("1T1QG");
/**
 * AuthenticatorContext serves static reference to the auth machine service.
 *
 * https://xstate.js.org/docs/recipes/react.html#context-provider
 */ const $67c19c14dd3378a0$export$2254a7bd02a5abf7 = (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createContext(null);


const $8f85b82cfd7bce86$var$createHubHandler = (options)=>async (data, service)=>{
        await (0, $68134900edbe6e80$export$f726708373635d8a)(data, service, options);
    };
function $8f85b82cfd7bce86$export$2e2bcd8739ae039({ children: children }) {
    // `authStatus` is exposed by `useAuthenticator` but should not be derived directly from the
    // state machine as the machine only updates on `Authenticator` initiated events, which
    // leads to scenarios where the state machine `authStatus` gets "stuck". For exmample,
    // if a user was to sign in using `Auth.signIn` directly rather than using `Authenticator`
    const [authStatus, setAuthStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).useState("configuring");
    // only run on first render
    (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).useEffect(()=>{
        (0, $95f3b5487ad3e06b$export$e5432d4c8eb97ea7)().then(()=>{
            setAuthStatus("authenticated");
        }).catch(()=>{
            setAuthStatus("unauthenticated");
        });
    }, []);
    /**
     * Based on use cases, developer might already have added another Provider
     * outside Authenticator. In that case, we sync the two providers by just
     * passing the parent value.
     *
     * TODO(BREAKING): enforce only one provider in App tree
     */ const parentProviderVal = (0, $1T1QG.useContext)((0, $67c19c14dd3378a0$export$2254a7bd02a5abf7));
    const service = (0, $8a3e5c8197e5795e$export$d9e9b060fbbae528)((0, $b3e9250a932361f5$export$af98f08c6e0e0d4d));
    const value = (0, $1T1QG.useMemo)(()=>!parentProviderVal ? {
            authStatus: authStatus,
            service: service
        } : parentProviderVal, [
        authStatus,
        parentProviderVal,
        service
    ]);
    const { service: activeService } = value;
    (0, $1T1QG.useEffect)(()=>{
        const onSignIn = ()=>{
            setAuthStatus("authenticated");
        };
        const onSignOut = ()=>{
            setAuthStatus("unauthenticated");
        };
        const unsubscribe = (0, $68134900edbe6e80$export$4776c363cae9362c)(activeService, $8f85b82cfd7bce86$var$createHubHandler({
            onSignIn: onSignIn,
            onSignOut: onSignOut
        }));
        return unsubscribe;
    }, [
        activeService
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $67c19c14dd3378a0$export$2254a7bd02a5abf7).Provider, {
        value: value
    }, children);
}


var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");


var $1T1QG = parcelRequire("1T1QG");




var $29435305db105520$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $29435305db105520$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function $29435305db105520$export$b29f828819edca8d(items, predicate) {
    var e_1, _a;
    var _b = $29435305db105520$var$__read([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = $29435305db105520$var$__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function $29435305db105520$export$2b6ccfda635c9803(service) {
    return service.status !== 0 ? service.getSnapshot() : service.machine.initialState;
}
// From https://github.com/reduxjs/react-redux/blob/master/src/utils/shallowEqual.ts
function $29435305db105520$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $29435305db105520$export$d36bdfa510afb180(objA, objB) {
    if ($29435305db105520$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$29435305db105520$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $29435305db105520$export$ab21a1e7bed2882e(actor) {
    return "state" in actor && "machine" in actor;
}
function $29435305db105520$export$3496c38320247757(service, prevState, nextState) {
    if (service.status === (0, $0a71063706b576da$export$7a567c9c5088a551).NotStarted) return true;
    // Only change the current state if:
    // - the incoming state is the "live" initial state (since it might have new actors)
    // - OR the incoming state actually changed.
    //
    // The "live" initial state will have .changed === undefined.
    var initialStateChanged = nextState.changed === undefined && (Object.keys(nextState.children).length > 0 || typeof prevState.changed === "boolean");
    return !(nextState.changed || initialStateChanged);
}


function $50be01da1a021125$var$identity(a) {
    return a;
}
function $50be01da1a021125$export$656eb38a7c1ce0b6(actorRef) {
    return "state" in actorRef;
}
function $50be01da1a021125$var$isDeferredActor(actorRef) {
    return "deferred" in actorRef;
}
function $50be01da1a021125$var$defaultGetSnapshot(actorRef) {
    return "getSnapshot" in actorRef ? (0, $29435305db105520$export$ab21a1e7bed2882e)(actorRef) ? (0, $29435305db105520$export$2b6ccfda635c9803)(actorRef) : actorRef.getSnapshot() : $50be01da1a021125$export$656eb38a7c1ce0b6(actorRef) ? actorRef.state : undefined;
}
function $50be01da1a021125$export$25c4ab29592aabd9(actorRef, getSnapshot) {
    if (getSnapshot === void 0) getSnapshot = $50be01da1a021125$var$defaultGetSnapshot;
    var actorRefRef = (0, $1T1QG.useRef)(actorRef);
    var deferredEventsRef = (0, $1T1QG.useRef)([]);
    var subscribe = (0, $1T1QG.useCallback)(function(handleStoreChange) {
        var unsubscribe = actorRef.subscribe(handleStoreChange).unsubscribe;
        return unsubscribe;
    }, [
        actorRef
    ]);
    var boundGetSnapshot = (0, $1T1QG.useCallback)(function() {
        return getSnapshot(actorRef);
    }, [
        actorRef,
        getSnapshot
    ]);
    var isEqual = (0, $1T1QG.useCallback)(function(prevState, nextState) {
        if ((0, $29435305db105520$export$ab21a1e7bed2882e)(actorRef)) return (0, $29435305db105520$export$3496c38320247757)(actorRef, prevState, nextState);
        return prevState === nextState;
    }, [
        actorRef
    ]);
    var storeSnapshot = (0, $719e376fd7bf7a88$exports.useSyncExternalStoreWithSelector)(subscribe, boundGetSnapshot, boundGetSnapshot, $50be01da1a021125$var$identity, isEqual);
    var send = (0, $a6e97c19456b97eb$export$2e2bcd8739ae039)(function() {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var event = args[0];
            var currentActorRef = actorRefRef.current;
            // If the previous actor is a deferred actor,
            // queue the events so that they can be replayed
            // on the non-deferred actor.
            if ($50be01da1a021125$var$isDeferredActor(currentActorRef) && currentActorRef.deferred) deferredEventsRef.current.push(event);
            else currentActorRef.send(event);
        };
    });
    (0, $967c055100ba8eae$export$2e2bcd8739ae039)(function() {
        actorRefRef.current = actorRef;
        // Dequeue deferred events from the previous deferred actorRef
        while(deferredEventsRef.current.length > 0){
            var deferredEvent = deferredEventsRef.current.shift();
            actorRef.send(deferredEvent);
        }
    }, [
        actorRef
    ]);
    return [
        storeSnapshot,
        send
    ];
}



var $898a36eb72506f2a$var$defaultCompare = function(a, b) {
    return a === b;
};
var $898a36eb72506f2a$var$defaultGetSnapshot = function(a, initialStateCacheRef) {
    if ((0, $29435305db105520$export$ab21a1e7bed2882e)(a)) {
        // A status of 0 = interpreter not started
        if (a.status === 0 && initialStateCacheRef.current) return initialStateCacheRef.current;
        var snapshot = (0, $29435305db105520$export$2b6ccfda635c9803)(a);
        initialStateCacheRef.current = a.status === 0 ? snapshot : null;
        return snapshot;
    }
    return (0, $50be01da1a021125$export$656eb38a7c1ce0b6)(a) ? a.state : undefined;
};
function $898a36eb72506f2a$export$2105062e25df4afe(actor, selector, compare, getSnapshot) {
    if (compare === void 0) compare = $898a36eb72506f2a$var$defaultCompare;
    var initialStateCacheRef = (0, $1T1QG.useRef)(null);
    var subscribe = (0, $1T1QG.useCallback)(function(handleStoreChange) {
        var unsubscribe = actor.subscribe(handleStoreChange).unsubscribe;
        return unsubscribe;
    }, [
        actor
    ]);
    var boundGetSnapshot = (0, $1T1QG.useCallback)(function() {
        if (getSnapshot) return getSnapshot(actor);
        return $898a36eb72506f2a$var$defaultGetSnapshot(actor, initialStateCacheRef);
    }, [
        actor,
        getSnapshot
    ]);
    var selectedSnapshot = (0, $719e376fd7bf7a88$exports.useSyncExternalStoreWithSelector)(subscribe, boundGetSnapshot, boundGetSnapshot, selector, compare);
    return selectedSnapshot;
}


/**
 * This file contains helpers that lets you easily access current actor's state
 * and context.
 */ /**
 * Get the state of current actor. This is useful for checking which screen
 * to render: e.g. `getActorState(state).matches('confirmSignUp.edit').
 */ const $e6ed0af0cac01aca$export$99a4282e2c3b772d = (state)=>{
    return state.context.actorRef?.getSnapshot();
};
/**
 * Get the context of current actor. Useful for getting any nested context
 * like remoteError.
 */ const $e6ed0af0cac01aca$export$c39505fa2700473f = (state)=>{
    return $e6ed0af0cac01aca$export$99a4282e2c3b772d(state)?.context;
};



const $913d5d43f078ee40$export$da6d2f7032b7150b = (state, actorState)=>{
    switch(true){
        case state.matches("idle"):
            return "idle";
        case state.matches("setup"):
            return "setup";
        case state.matches("signOut"):
            return "signOut";
        case state.matches("authenticated"):
            return "authenticated";
        case actorState?.matches("confirmSignUp"):
        case actorState?.matches("confirmSignUp.resendConfirmationCode"):
            return "confirmSignUp";
        case actorState?.matches("confirmSignIn"):
            return "confirmSignIn";
        case actorState?.matches("setupTotp.edit"):
        case actorState?.matches("setupTotp.submit"):
            return "setupTotp";
        case actorState?.matches("signIn"):
            return "signIn";
        case actorState?.matches("signUp"):
            return "signUp";
        case actorState?.matches("forceChangePassword"):
            return "forceNewPassword";
        case actorState?.matches("forgotPassword"):
            return "forgotPassword";
        case actorState?.matches("confirmResetPassword"):
            return "confirmResetPassword";
        case actorState?.matches("selectUserAttributes"):
            return "verifyUser";
        case actorState?.matches("confirmVerifyUserAttribute"):
            return "confirmVerifyUser";
        case state.matches("getCurrentUser"):
        case actorState.matches("fetchUserAttributes"):
            /**
             * This route is needed for autoSignIn to capture both the
             * autoSignIn.pending and the resolved states when the
             * signIn actor is running.
             */ return "transition";
        default:
            console.debug("Cannot infer `route` from Authenticator state:", state.value);
            return null;
    }
};


/**
 * This file contains helpers that translates xstate internals to more
 * understandable authenticator contexts. We provide these contexts with
 * `useAuthenticator` hook/composable/service.
 */ /**
 * Creates public facing auth helpers that abstracts out xstate implementation
 * detail. Each framework implementation can export these helpers so that
 * developers can send events without having to learn internals.
 *
 * ```
 * const [state, send] = useActor(...);
 * const { submit } = getSendEventAliases(send);
 * submit({ username, password})
 * ```
 */ const $449563f0d6e3e7c2$export$2def2023b76dbf7d = (send)=>{
    const sendToMachine = (type)=>{
        // TODO If these were created during the creation of the machine & provider,
        // then invalid transitions could be caught via https://xstate.js.org/docs/guides/states.html#state-can-event
        return (data)=>send({
                type: type,
                data: data
            });
    };
    return {
        initializeMachine: sendToMachine("INIT"),
        resendCode: sendToMachine("RESEND"),
        signOut: sendToMachine("SIGN_OUT"),
        submitForm: sendToMachine("SUBMIT"),
        updateForm: sendToMachine("CHANGE"),
        updateBlur: sendToMachine("BLUR"),
        // Actions that don't immediately invoke a service but instead transition to a screen
        // are prefixed with `to*`
        toFederatedSignIn: sendToMachine("FEDERATED_SIGN_IN"),
        toForgotPassword: sendToMachine("FORGOT_PASSWORD"),
        toSignIn: sendToMachine("SIGN_IN"),
        toSignUp: sendToMachine("SIGN_UP"),
        skipVerification: sendToMachine("SKIP")
    };
};
const $449563f0d6e3e7c2$var$getNextSendEventAliases = (send)=>{
    const { toFederatedSignIn: toFederatedSignIn, submitForm: submitForm, resendCode: resendCode, skipVerification: skipVerification } = $449563f0d6e3e7c2$export$2def2023b76dbf7d(send);
    return {
        handleSubmit: submitForm,
        resendConfirmationCode: resendCode,
        // manual "route" navigation
        setRoute: (route)=>send({
                type: (0, $25b29aa90ff40796$export$7ccc20c5f9bc8a70)[route]
            }),
        skipAttributeVerification: skipVerification,
        toFederatedSignIn: toFederatedSignIn
    };
};
const $449563f0d6e3e7c2$export$e6da373757d26435 = (state)=>{
    const actorContext = (0, $e6ed0af0cac01aca$export$c39505fa2700473f)(state) ?? {};
    const { challengeName: challengeName, codeDeliveryDetails: codeDeliveryDetails, remoteError: error, validationError: validationErrors, totpSecretCode: totpSecretCode = null, unverifiedUserAttributes: unverifiedUserAttributes, username: username } = actorContext;
    const { socialProviders: socialProviders = [] } = state.context?.config ?? {};
    // check for user in actorContext prior to state context. actorContext is more "up to date",
    // but is not available on all states
    const user = actorContext?.user ?? state.context?.user;
    const hasValidationErrors = !!(validationErrors && Object.keys(validationErrors).length > 0);
    const actorState = (0, $e6ed0af0cac01aca$export$99a4282e2c3b772d)(state);
    const isPending = state.hasTag("pending") || actorState?.hasTag("pending");
    const route = (0, $913d5d43f078ee40$export$da6d2f7032b7150b)(state, actorState);
    // Auth status represents the current state of the auth flow
    // The `configuring` state is used to indicate when the xState machine is loading
    const authStatus = ((route)=>{
        switch(route){
            case "idle":
            case "setup":
                return "configuring";
            case "authenticated":
                return "authenticated";
            default:
                return "unauthenticated";
        }
    })(route);
    const facade = {
        authStatus: authStatus,
        challengeName: challengeName,
        codeDeliveryDetails: codeDeliveryDetails,
        error: error,
        hasValidationErrors: hasValidationErrors,
        isPending: isPending,
        route: route,
        socialProviders: socialProviders,
        totpSecretCode: totpSecretCode,
        unverifiedUserAttributes: unverifiedUserAttributes,
        user: user,
        username: username,
        validationErrors: validationErrors
    };
    return facade;
};
const $449563f0d6e3e7c2$export$198a1c4c61f42650 = (state)=>{
    const actorContext = (0, $e6ed0af0cac01aca$export$c39505fa2700473f)(state) ?? {};
    const { challengeName: challengeName, codeDeliveryDetails: codeDeliveryDetails, remoteError: errorMessage, totpSecretCode: totpSecretCode, unverifiedUserAttributes: unverifiedUserAttributes, username: username } = actorContext;
    const { socialProviders: federatedProviders, loginMechanisms: loginMechanisms } = state.context?.config ?? {};
    const loginMechanism = loginMechanisms?.[0];
    const actorState = (0, $e6ed0af0cac01aca$export$99a4282e2c3b772d)(state);
    const isPending = state.hasTag("pending") || actorState?.hasTag("pending");
    // @todo-migration remove this cast for Authenticator.Next
    const route = (0, $913d5d43f078ee40$export$da6d2f7032b7150b)(state, actorState);
    return {
        challengeName: challengeName,
        codeDeliveryDetails: codeDeliveryDetails,
        errorMessage: errorMessage,
        federatedProviders: federatedProviders,
        isPending: isPending,
        loginMechanism: loginMechanism,
        route: route,
        totpSecretCode: totpSecretCode,
        unverifiedUserAttributes: unverifiedUserAttributes,
        username: username
    };
};
const $449563f0d6e3e7c2$export$5f925d5954b1c10b = ({ send: send, state: state })=>{
    const sendEventAliases = $449563f0d6e3e7c2$export$2def2023b76dbf7d(send);
    const serviceContext = $449563f0d6e3e7c2$export$e6da373757d26435(state);
    return {
        ...sendEventAliases,
        ...serviceContext
    };
};
const $449563f0d6e3e7c2$export$d158c470c375eb4d = ({ send: send, state: state })=>({
        ...$449563f0d6e3e7c2$var$getNextSendEventAliases(send),
        ...$449563f0d6e3e7c2$export$198a1c4c61f42650(state)
    });




const $902231e0cfebd97f$export$7e92b2e9f0809b11 = "`useAuthenticator` must be used inside an `Authenticator.Provider`.";



/** Array of auth fields that we supply defaults with */ const $bc9614d2c13cf9d8$export$43a753047a354e27 = [
    "birthdate",
    "email",
    "family_name",
    "given_name",
    "middle_name",
    "name",
    "nickname",
    "phone_number",
    "preferred_username",
    "profile",
    "website"
];
/** Array of auth fields that we do not supply defaults with */ const $bc9614d2c13cf9d8$export$a263a0ca54f86170 = [
    "address",
    "gender",
    "locale",
    "picture",
    "updated_at",
    "zoneinfo"
];
/** Array of known login mechanisms */ const $bc9614d2c13cf9d8$export$c3f13f1789f7946b = [
    "username",
    "email",
    "phone_number"
];
const $bc9614d2c13cf9d8$export$ee5f111526f572af = [
    ...$bc9614d2c13cf9d8$export$c3f13f1789f7946b,
    ...$bc9614d2c13cf9d8$export$43a753047a354e27,
    "confirmation_code",
    "password",
    "confirm_password"
];
const $bc9614d2c13cf9d8$export$fed672849e2dd0ad = (field)=>{
    return $bc9614d2c13cf9d8$export$ee5f111526f572af.includes(field);
};








const $52c3d4b500c29b83$export$e29bbbec84471f66 = (event)=>{
    const formData = new FormData(event.target);
    return Object.fromEntries(formData);
};
const $52c3d4b500c29b83$export$b5859dd113079414 = (formOverrides, fieldNames)=>{
    let orderedKeys = [];
    if (formOverrides) orderedKeys = Object.keys(formOverrides).reduce((prev, key)=>{
        // reduce to array that can be sorted
        prev.push([
            key,
            formOverrides[key]?.order
        ]);
        return prev;
    }, []).sort((a, b)=>//sort them based on order
        a[1] - b[1]) // returned just key
    .filter((a)=>a[1] !== undefined).map((a)=>a[0]);
    // remove duplicates
    return Array.from(new Set([
        ...orderedKeys,
        ...fieldNames
    ]));
};
const $52c3d4b500c29b83$export$3237178b1c616b9f = (field)=>{
    return (0, $bc9614d2c13cf9d8$export$ee5f111526f572af).includes(field);
};
const $52c3d4b500c29b83$var$isArray = (val)=>{
    return Array.isArray(val);
};
const $52c3d4b500c29b83$export$501239432719417d = (errors)=>{
    if (!errors) return null;
    if ($52c3d4b500c29b83$var$isArray(errors)) return errors;
    else return [
        errors
    ];
};



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $26e4510007706da3$var$logger = new (0, $b5731988345712b1$export$ba6a9c7ac8291f7f)("I18n");
/**
 * Language translation utility.
 */ let $26e4510007706da3$export$dbe3113d60765c1a = class I18n {
    /**
     * @constructor
     * Initialize with configurations
     * @param {Object} options
     */ constructor(){
        /**
         * @private
         */ this._options = null;
        /**
         * @private
         */ this._lang = null;
        /**
         * @private
         */ this._dict = {};
    }
    /**
     * Sets the default language from the configuration when required.
     */ setDefaultLanguage() {
        // Default to window language if not set in instance
        if (!this._lang && typeof window !== "undefined" && window && window.navigator) this._lang = window.navigator.language;
        $26e4510007706da3$var$logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */ setLanguage(lang) {
        this._lang = lang;
    }
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ get(key, defVal) {
        if (!this._lang) return typeof defVal !== "undefined" ? defVal : key;
        const lang = this._lang;
        let val = this.getByLanguage(key, lang);
        if (val) return val;
        if (lang.indexOf("-") > 0) val = this.getByLanguage(key, lang.split("-")[0]);
        if (val) return val;
        return typeof defVal !== "undefined" ? defVal : key;
    }
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */ getByLanguage(key, language, defVal = null) {
        if (!language) return defVal;
        const lang_dict = this._dict[language];
        if (!lang_dict) return defVal;
        return lang_dict[key];
    }
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ putVocabulariesForLanguage(language, vocabularies) {
        let lang_dict = this._dict[language];
        if (!lang_dict) lang_dict = this._dict[language] = {};
        this._dict[language] = {
            ...lang_dict,
            ...vocabularies
        };
    }
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ putVocabularies(vocabularies) {
        Object.keys(vocabularies).map((key)=>{
            this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    }
};






// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var $40db3dfb6235699d$export$6cc46f5977c4544e;
(function(I18nErrorCode) {
    I18nErrorCode["NotConfigured"] = "NotConfigured";
})($40db3dfb6235699d$export$6cc46f5977c4544e || ($40db3dfb6235699d$export$6cc46f5977c4544e = {}));
const $40db3dfb6235699d$var$i18nErrorMap = {
    [$40db3dfb6235699d$export$6cc46f5977c4544e.NotConfigured]: {
        message: "i18n is not configured."
    }
};
const $40db3dfb6235699d$export$a7a9523472993e97 = (0, $23ab74116aa7b356$export$5cb8fc27ccbe9d40)($40db3dfb6235699d$var$i18nErrorMap);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const $0fe07bf7356162c8$var$logger = new (0, $b5731988345712b1$export$ba6a9c7ac8291f7f)("I18n");
let $0fe07bf7356162c8$var$_config = {
    language: null
};
let $0fe07bf7356162c8$var$_i18n = null;
/**
 * Export I18n APIs
 */ class $0fe07bf7356162c8$export$dbe3113d60765c1a {
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */ static configure(config) {
        $0fe07bf7356162c8$var$logger.debug("configure I18n");
        if (!config) return $0fe07bf7356162c8$var$_config;
        $0fe07bf7356162c8$var$_config = Object.assign({}, $0fe07bf7356162c8$var$_config, config.I18n || config);
        $0fe07bf7356162c8$export$dbe3113d60765c1a.createInstance();
        return $0fe07bf7356162c8$var$_config;
    }
    static getModuleName() {
        return "I18n";
    }
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */ static createInstance() {
        $0fe07bf7356162c8$var$logger.debug("create I18n instance");
        if ($0fe07bf7356162c8$var$_i18n) return;
        $0fe07bf7356162c8$var$_i18n = new (0, $26e4510007706da3$export$dbe3113d60765c1a)();
    }
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */ static setLanguage(lang) {
        $0fe07bf7356162c8$export$dbe3113d60765c1a.checkConfig();
        (0, $40db3dfb6235699d$export$a7a9523472993e97)(!!$0fe07bf7356162c8$var$_i18n, (0, $40db3dfb6235699d$export$6cc46f5977c4544e).NotConfigured);
        return $0fe07bf7356162c8$var$_i18n.setLanguage(lang);
    }
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ static get(key, defVal) {
        if (!$0fe07bf7356162c8$export$dbe3113d60765c1a.checkConfig()) return typeof defVal === "undefined" ? key : defVal;
        (0, $40db3dfb6235699d$export$a7a9523472993e97)(!!$0fe07bf7356162c8$var$_i18n, (0, $40db3dfb6235699d$export$6cc46f5977c4544e).NotConfigured);
        return $0fe07bf7356162c8$var$_i18n.get(key, defVal);
    }
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ static putVocabulariesForLanguage(language, vocabularies) {
        $0fe07bf7356162c8$export$dbe3113d60765c1a.checkConfig();
        (0, $40db3dfb6235699d$export$a7a9523472993e97)(!!$0fe07bf7356162c8$var$_i18n, (0, $40db3dfb6235699d$export$6cc46f5977c4544e).NotConfigured);
        return $0fe07bf7356162c8$var$_i18n.putVocabulariesForLanguage(language, vocabularies);
    }
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ static putVocabularies(vocabularies) {
        $0fe07bf7356162c8$export$dbe3113d60765c1a.checkConfig();
        (0, $40db3dfb6235699d$export$a7a9523472993e97)(!!$0fe07bf7356162c8$var$_i18n, (0, $40db3dfb6235699d$export$6cc46f5977c4544e).NotConfigured);
        return $0fe07bf7356162c8$var$_i18n.putVocabularies(vocabularies);
    }
    static checkConfig() {
        if (!$0fe07bf7356162c8$var$_i18n) $0fe07bf7356162c8$export$dbe3113d60765c1a.createInstance();
        return true;
    }
}
// Create an instance of I18n in the static class
$0fe07bf7356162c8$export$dbe3113d60765c1a.createInstance();


const $949281bda546086b$export$cca4a41bdb910c51 = {
    "Account recovery requires verified contact information": "Zur\xfccksetzen des Account ben\xf6tigt einen verifizierten Account",
    "Back to Sign In": "Zur\xfcck zur Anmeldung",
    "Change Password": "Passwort \xe4ndern",
    Changing: "\xc4ndern von",
    Code: "Code",
    "Confirm Password": "Passwort best\xe4tigen",
    "Please confirm your Password": "Bitte best\xe4tigen Sie Ihr Passwort",
    "Confirm Sign Up": "Registrierung best\xe4tigen",
    "Confirm SMS Code": "SMS-Code best\xe4tigen",
    "Confirm TOTP Code": "TOTP-Code best\xe4tigen",
    Confirm: "Best\xe4tigen",
    "Confirmation Code": "Best\xe4tigungs-Code",
    Confirming: "Wird best\xe4tigt",
    "Create a new account": "Einen neuen Account erstellen",
    "Create Account": "Account erstellen",
    "Creating Account": "Account wird erstellt",
    "Dismiss alert": "Warnung verwerfen",
    Email: "Email",
    "Enter your code": "Geben Sie Ihren Code ein",
    "Enter your Email": "Geben Sie Ihre E-Mail ein",
    "Enter your phone number": "Geben Sie Ihre Telefonnummer ein",
    "Enter your username": "Geben Sie Ihren Benutzernamen ein",
    "Forgot your password?": "Passwort vergessen? ",
    "Hide password": "Passwort verbergen",
    "It may take a minute to arrive": "Es kann eine Minute dauern, bis er ankommt",
    Loading: "Wird geladen",
    "New password": "Neues Passwort",
    or: "oder",
    Password: "Passwort",
    "Phone Number": "Telefonnummer",
    "Resend Code": "Code erneut senden",
    "Reset your Password": "Zur\xfccksetzen des Passwort",
    "Reset your password": "Zur\xfccksetzen des passwort",
    "Send code": "Code senden",
    "Send Code": "Code senden",
    Sending: "Wird gesendet",
    "Setup TOTP": "TOTP einrichten",
    "Show password": "Passwort anzeigen",
    "Sign in to your account": "Melden Sie sich mit Ihrem Account an",
    "Sign In with Amazon": "Mit Amazon anmelden",
    "Sign In with Apple": "Mit Apple anmelden",
    "Sign In with Facebook": "Mit Facebook anmelden",
    "Sign In with Google": "Mit Google anmelden",
    "Sign in": "Anmelden",
    "Sign In": "Anmelden",
    "Signing in": "Wird angemeldet",
    Skip: "\xdcberspringen",
    Submit: "Abschicken",
    Submitting: "Wird gesendet",
    Username: "Benutzername",
    "Verify Contact": "Kontakt verifizieren",
    Verify: "Verifizieren",
    "We Sent A Code": "Wir haben einen Code gesendet",
    "We Texted You": "Wir haben Ihnen eine SMS gesendet",
    "Your code is on the way. To log in, enter the code we sent you": "Ihr Code ist unterwegs. Um sich anzumelden, geben Sie den Code ein, den wir Ihnen gesendet haben",
    // Additional translations provided by customers
    "An account with the given email already exists.": "Ein Account mit dieser Email existiert bereits.",
    "Confirm a Code": "Code best\xe4tigen",
    "Confirm Sign In": "Anmeldung best\xe4tigen",
    "Create account": "Hier registrieren",
    "Enter your password": "Geben Sie Ihr Passwort ein",
    "Enter your Password": "Geben Sie Ihr Passwort ein",
    "Sign Up with Facebook": "Mit Facebook registrieren",
    "Sign Up with Google": "Mit Google registrieren",
    "Forgot Password": "Passwort vergessen",
    "Have an account? ": "Schon registriert? ",
    "Incorrect username or password": "Falscher Benutzername oder falsches Passwort",
    "Invalid password format": "Ung\xfcltiges Passwort-Format",
    "Invalid phone number format": `Ung\xfcltiges Telefonummern-Format. Benutze eine Nummer im Format: +12345678900`,
    "It may take a minute to arrive.": "Es k\xf6nnte eine Minute dauern, bis der Code eintrifft.",
    "Lost your code? ": "Code verloren? ",
    "New Password": "Neues Passwort",
    "No account? ": "Kein Account? ",
    "Password attempts exceeded": "Die maximale Anzahl der fehlerhaften Anmeldeversuche wurde erreicht",
    "Reset password": "Passwort zur\xfccksetzen",
    "Sign Out": "Abmelden",
    "Sign Up": "Registrieren",
    "User already exists": "Dieser Benutzer existiert bereits",
    "User does not exist": "Dieser Benutzer existiert nicht",
    "Username cannot be empty": "Benutzername darf nicht leer sein",
    "We Emailed You": "Email wurde versendet",
    "Your code is on the way. To log in, enter the code we emailed to": "Ihr Best\xe4tigungscode ist unterwegs. Um sich einzuloggen geben Sie den Code ein, den wir verschickt haben an",
    "Your code is on the way. To log in, enter the code we texted to": "Ihr Best\xe4tigungscode ist unterwegs. Um sich einzuloggen geben Sie den Code ein, den wir verschickt haben an"
};


const $28d0399a987ec85f$export$eb91f595f110d703 = {
    "Account recovery requires verified contact information": "Account recovery requires verified contact information",
    "Add your Profile": "Add your Profile",
    "Add your Website": "Add your Website",
    "Back to Sign In": "Back to Sign In",
    "Change Password": "Change Password",
    Changing: "Changing",
    Code: "Code",
    "Confirm Password": "Confirm Password",
    "Confirm Sign Up": "Confirm Sign Up",
    "Confirm SMS Code": "Confirm SMS Code",
    "Confirm TOTP Code": "Confirm TOTP Code",
    Confirm: "Confirm",
    "Confirmation Code": "Confirmation Code",
    Confirming: "Confirming",
    "Create a new account": "Create a new account",
    "Create Account": "Create Account",
    "Creating Account": "Creating Account",
    "Dismiss alert": "Dismiss alert",
    Email: "Email",
    "Enter your Birthdate": "Enter your Birthdate",
    "Enter your code": "Enter your code",
    "Enter your Confirmation Code": "Enter your Confirmation Code",
    "Enter your Email": "Enter your Email",
    "Enter your Family Name": "Enter your Family Name",
    "Enter your Given Name": "Enter your Given Name",
    "Enter your Middle Name": "Enter your Middle Name",
    "Enter your Name": "Enter your Name",
    "Enter your Nickname": "Enter your Nickname",
    "Enter your Password": "Enter your Password",
    "Enter your phone number": "Enter your phone number",
    "Enter your Preferred Username": "Enter your Preferred Username",
    "Enter your username": "Enter your username",
    "Forgot password?": "Forgot password?",
    "Forgot your password?": "Forgot your password?",
    "Hide password": "Hide password",
    "It may take a minute to arrive": "It may take a minute to arrive",
    Loading: "Loading",
    "New password": "New password",
    or: "or",
    Password: "Password",
    "Phone Number": "Phone Number",
    "Please confirm your Password": "Please confirm your Password",
    "Resend Code": "Resend Code",
    "Reset your password": "Reset your password",
    "Reset your Password": "Reset your Password",
    "Send code": "Send code",
    "Send Code": "Send Code",
    Sending: "Sending",
    "Setup TOTP": "Setup TOTP",
    "Show password": "Show password",
    "Sign in to your account": "Sign in to your account",
    "Sign In with Amazon": "Sign In with Amazon",
    "Sign In with Apple": "Sign In with Apple",
    "Sign In with Facebook": "Sign In with Facebook",
    "Sign In with Google": "Sign In with Google",
    "Sign in": "Sign in",
    "Sign In": "Sign In",
    "Signing in": "Signing in",
    Skip: "Skip",
    Submit: "Submit",
    Submitting: "Submitting",
    Username: "Username",
    "Verify Contact": "Verify Contact",
    Verify: "Verify",
    "We Emailed You": "We Emailed You",
    "We Sent A Code": "We Sent A Code",
    "We Texted You": "We Texted You",
    "Your code is on the way. To log in, enter the code we emailed to": "Your code is on the way. To log in, enter the code we emailed to",
    "Your code is on the way. To log in, enter the code we sent you": "Your code is on the way. To log in, enter the code we sent you",
    "Your code is on the way. To log in, enter the code we texted to": "Your code is on the way. To log in, enter the code we texted to"
};


const $a55ced3cdf989f13$export$1d204a99f5862ba9 = {
    "Account recovery requires verified contact information": "La recuperaci\xf3n de la cuenta requiere informaci\xf3n de contacto verificada",
    "Back to Sign In": "Volver a inicio de sesi\xf3n",
    "Change Password": "Cambiar contrase\xf1a",
    Changing: "Cambiando",
    Code: "C\xf3digo",
    "Confirm Password": "Confirmar contrase\xf1a",
    "Confirm Sign Up": "Confirmar registro",
    "Confirm SMS Code": "Confirmar el c\xf3digo de SMS",
    "Confirm TOTP Code": "Confirmar c\xf3digo TOTP",
    Confirm: "Confirmar",
    "Confirmation Code": "C\xf3digo de confirmaci\xf3n",
    Confirming: "Confirmando",
    "Create a new account": "Crear una cuenta nueva",
    "Create Account": "Crear cuenta",
    "Creating Account": "Creando cuenta",
    "Dismiss alert": "Descartar alerta",
    Email: "Email",
    "Enter your code": "Ingrese el c\xf3digo",
    "Enter your Email": "Escriba su Email",
    "Enter your Password": "Escriba su Contrase\xf1a",
    "Enter your phone number": "Ingrese el n\xfamero de tel\xe9fono",
    "Enter your username": "Ingrese el nombre de usuario",
    "Forgot your password?": "\xbfOlvid\xf3 su contrase\xf1a?",
    "Hide password": "Ocultar contrase\xf1a",
    "It may take a minute to arrive": "Es posible que tarde un minuto en llegar",
    Loading: "Cargando",
    "New password": "Nueva contrase\xf1a",
    or: "o",
    Password: "Contrase\xf1a",
    "Phone Number": "N\xfamero de tel\xe9fono",
    "Resend Code": "Reenviar c\xf3digo",
    "Reset your password": "Restablecer su contrase\xf1a",
    "Reset your Password": "Restablecer su Contrase\xf1a",
    "Send code": "Enviar c\xf3digo",
    "Send Code": "Enviar c\xf3digo",
    Sending: "Enviando",
    "Setup TOTP": "Configurar TOTP",
    "Show password": "Mostrar contrase\xf1a",
    "Sign in to your account": "Iniciar sesi\xf3n en tu cuenta",
    "Sign In with Amazon": "Iniciar Sesi\xf3n con Amazon",
    "Sign In with Apple": "Iniciar Sesi\xf3n con Apple",
    "Sign In with Facebook": "Iniciar Sesi\xf3n con Facebook",
    "Sign In with Google": "Iniciar Sesi\xf3n con Google",
    "Sign in": "Iniciar sesi\xf3n",
    "Sign In": "Iniciar Sesi\xf3n",
    "Signing in": "Iniciando sesi\xf3n",
    Skip: "Omitir",
    Submit: "Enviar",
    Submitting: "Enviando",
    Username: "Nombre de usuario",
    "Verify Contact": "Verificar contacto",
    Verify: "Verificar",
    "We Emailed You": "Le hemos enviado un correo electr\xf3nico",
    "We Sent A Code": "Hemos enviado un c\xf3digo",
    "We Texted You": "Le hemos enviado un mensaje de texto",
    "Your code is on the way. To log in, enter the code we emailed to": "El c\xf3digo est\xe1 en camino. Para iniciar sesi\xf3n, escriba el c\xf3digo que hemos enviado por correo electr\xf3nico a",
    "Your code is on the way. To log in, enter the code we sent you": "El c\xf3digo est\xe1 en camino. Para iniciar sesi\xf3n, escriba el c\xf3digo que le hemos enviado",
    "Your code is on the way. To log in, enter the code we texted to": "El c\xf3digo est\xe1 en camino. Para iniciar sesi\xf3n, escriba el c\xf3digo que hemos enviado por mensaje de texto a",
    // Additional translations provided by customers
    "An account with the given email already exists.": "Ya existe una cuenta con el correo ingresado.",
    "Confirm a Code": "Confirmar un c\xf3digo",
    "Confirm Sign In": "Confirmar inicio de sesi\xf3n",
    "Forgot Password": "Olvid\xe9 mi contrase\xf1a",
    "Incorrect username or password.": "Nombre de usuario o contrase\xf1a incorrecta",
    "Invalid password format": "Formato de contrase\xf1a inv\xe1lido",
    "Invalid phone number format": "Formato de n\xfamero de tel\xe9fono inv\xe1lido",
    "Loading...": "Cargando...",
    "New Password": "Nueva contrase\xf1a",
    "Resend a Code": "Reenviar un c\xf3digo",
    "Sign Out": "Cerrar sesi\xf3n",
    "Sign Up with Amazon": "Crear cuenta con Amazon",
    "Sign Up with Apple": "Crear cuenta con Apple",
    "Sign Up with Facebook": "Crear cuenta con Facebook",
    "Sign Up with Google": "Crear cuenta con Google",
    "Sign Up": "Crear cuenta",
    "User already exists": "El usuario ya existe",
    "User does not exist": "El usuario no existe",
    "Username cannot be empty": "El nombre de usuario no puede estar vac\xedo",
    "Your passwords must match": "Las contrase\xf1as deben coincidir"
};


const $da787d2c2c7c5644$export$8cfa91bfcf8d11c8 = {
    "Account recovery requires verified contact information": "La r\xe9cup\xe9ration du compte n\xe9cessite des informations de contact v\xe9rifi\xe9es",
    "Back to Sign In": "Retour \xe0 la connexion",
    "Change Password": "Modifier le mot de passe",
    Changing: "Modification en cours",
    Code: "Code",
    "Confirm Password": "Confirmez le mot de passe",
    "Confirm Sign Up": "Confirmer l'inscription",
    "Confirm SMS Code": "Confirmer le code SMS",
    "Confirm TOTP Code": "Confirmer le code TOTP",
    Confirm: "Confirmer",
    "Confirmation Code": "Code de confirmation",
    Confirming: "Confirmation",
    "Create a new account": "Cr\xe9er un nouveau compte",
    "Create Account": "Cr\xe9er un compte",
    "Creating Account": `Cr\xe9ation d'un compte`,
    "Dismiss alert": `Supprimer l'alerte`,
    Email: "Email",
    "Enter your code": "Saisissez cotre code de confirmation",
    "Enter your Email": "Saisissez votre adresse email",
    "Enter your phone number": "Saisissez votre num\xe9ro de t\xe9l\xe9phone",
    "Enter your username": "Saisissez votre nom d'utilisateur",
    "Forgot your password?": "Mot de passe oubli\xe9 ? ",
    "Hide password": "Masquer le mot de passe",
    "It may take a minute to arrive": "Cela peut prendre une minute",
    Loading: "Chargement en cours",
    "New password": "Nouveau mot de passe",
    or: "ou",
    Password: "Mot de passe",
    "Phone Number": "Num\xe9ro de t\xe9l\xe9phone",
    "Resend Code": "Renvoyer le code",
    "Reset your Password": "R\xe9initialiser votre mot de passe",
    "Reset your password": "R\xe9initialisez votre mot de passe",
    "Send code": "Envoyer le code",
    "Send Code": "M'envoyer un code",
    Sending: "Envoi en cours",
    "Setup TOTP": "Configuration de TOTP",
    "Show password": "Afficher le mot de passe",
    "Sign in to your account": "Connexion \xe0 votre compte",
    "Sign In with Amazon": "Se connecter avec Amazon",
    "Sign In with Apple": "Se connecter avec Apple",
    "Sign In with Facebook": "Se connecter avec Facebook",
    "Sign In with Google": "Se connecter avec Google",
    "Sign in": "Se connecter",
    "Sign In": "Se connecter",
    "Signing in": "Connexion en cours",
    Skip: "Passer",
    Submit: "Soumettre",
    Submitting: "Envoi en cours",
    Username: "Nom d'utilisateur",
    "Verify Contact": "V\xe9rifier le contact",
    Verify: "V\xe9rifier",
    "We Sent A Code": "Nous avons envoy\xe9 un code",
    "We Texted You": "Nous vous avons envoy\xe9 un SMS",
    "Your code is on the way. To log in, enter the code we sent you": `Votre code est en cours d'envoi. Pour vous connecter, saisissez le code que nous vous avons envoy\xe9`,
    // Additional translations provided by customers
    "An account with the given email already exists.": "Un utilisateur avec cette adresse email existe d\xe9j\xe0.",
    Change: "Modifier",
    "Confirm a Code": "Confirmer un code",
    "Confirm Sign In": "Confirmer la connexion",
    "Create account": "Cr\xe9er un compte",
    "Enter your password": "Saisissez votre mot de passe",
    "Forgot Password": "Mot de passe oubli\xe9",
    "Have an account? ": "D\xe9j\xe0 un compte ? ",
    Hello: "Bonjour",
    "Incorrect username or password": "Identifiant ou mot de passe incorrect",
    "Invalid password format": "Format de mot de passe invalide",
    "Invalid phone number format": `Format de num\xe9ro de t\xe9l\xe9phone invalide. Veuillez utiliser un format +12345678900`,
    "Loading...": "Chargement...",
    "Lost your code? ": "Vous avez perdu votre code ? ",
    "Network error": "Erreur r\xe9seau",
    "New Password": "Nouveau mot de passe",
    "No account? ": "Pas de compte ? ",
    "Resend a Code": "Renvoyer un code",
    "Reset password": "R\xe9initialisez votre mot de passe",
    Send: "Envoyer",
    "Sign In with AWS": "Se connecter avec AWS",
    "Sign Out": "D\xe9connexion",
    "Sign Up": "S'inscrire",
    SMS: "SMS",
    "User already exists": "L'utilisateur existe d\xe9j\xe0",
    "User does not exist": "L'utilisateur n'existe pas",
    "Username cannot be empty": "Le nom d'utilisateur doit \xeatre renseign\xe9",
    "Username/client id combination not found.": "L'utilisateur n'existe pas",
    "We Emailed You": "Nous vous avons envoy\xe9 un code",
    "Your code is on the way. To log in, enter the code we emailed to": "Votre code est en route. Pour vous connecter entrez le code re\xe7u sur cette adresse email",
    "Your code is on the way. To log in, enter the code we texted to": "Votre code est en route. Pour vous connecter entrez le code re\xe7u sur ce num\xe9ro de t\xe9l\xe9phone",
    "Your passwords must match": "Vos mots de passe doivent \xeatre identiques",
    "It may take a minute to arrive.": "Cela peut prendre quelques minutes."
};


const $a52e8a8f52715173$export$5c8da73de176fccc = {
    "Account recovery requires verified contact information": "Il ripristino dell'account richiede informazioni di contatto verificate",
    "Back to Sign In": "Torna alla schermata di accesso",
    "Change Password": "Cambia la password",
    Changing: "Modifica in corso",
    Code: "Codice",
    "Confirm Password": "Conferma la password",
    "Confirm Sign Up": "Conferma registrazione",
    "Confirm SMS Code": "Conferma codice SMS",
    "Confirm TOTP Code": "Conferma codice TOTP",
    Confirm: "Conferma",
    "Confirmation Code": "Codice di verifica",
    Confirming: "Conferma in corso",
    "Create a new account": "Crea un nuovo account",
    "Create Account": "Crea Account",
    "Creating Account": "Creazione account in corso",
    "Dismiss alert": `Ignora l'avviso`,
    Email: "Email",
    "Enter your code": "Inserisci il tuo codice",
    "Enter your Email": "Inserisci la tua e-mail",
    "Enter your phone number": 'Inserisci il tuo numero di telefono"',
    "Enter your username": "Inserisci il tuo nome utente",
    "Forgot your password?": "Password dimenticata?",
    "Hide password": "Nascondi password",
    "It may take a minute to arrive": "L'arrivo potrebbe richiedere qualche minuto",
    Loading: "Caricamento in corso",
    "New password": "Nuova password",
    or: "oppure",
    Password: "Password",
    "Phone Number": "Numero di telefono",
    "Resend Code": "Invia nuovamente il codice",
    "Reset your Password": "Reimposta la tua Password",
    "Reset your password": "Reimposta la tua password",
    "Send code": "Invia codice",
    "Send Code": "Invia codice",
    Sending: "Invio in corso",
    "Setup TOTP": "Configura TOTP",
    "Show password": "Mostra password",
    "Sign in to your account": "Accedi al tuo account",
    "Sign In with Amazon": "Accedi con Amazon",
    "Sign In with Apple": "Accedi con Apple",
    "Sign In with Facebook": "Accedi con Facebook",
    "Sign In with Google": "Accedi con Google",
    "Sign in": "Accedi",
    "Sign In": "Accedi",
    "Signing in": "Accesso in corso",
    Skip: "Salta",
    Submit: "Invia",
    Submitting: "Invio in corso",
    Username: "Nome utente",
    "Verify Contact": "Verifica contatto",
    Verify: "Verifica",
    "We Emailed You": "Ti abbiamo inviato un'e-mail",
    "We Sent A Code": "Ti abbiamo inviato un codice",
    "We Texted You": "Ti abbiamo inviato un SMS",
    "Your code is on the way. To log in, enter the code we emailed to": "Il codice \xe8 in arrivo. Per effettuare l'accesso, immetti il codice che ti abbiamo inviato via e-mail",
    "Your code is on the way. To log in, enter the code we sent you": "Il codice \xe8 in arrivo. Per accedere, immetti il codice che ti abbiamo inviato",
    "Your code is on the way. To log in, enter the code we texted to": "Il codice \xe8 in arrivo. Per accedere, immetti il codice che abbiamo inviato tramite SMS",
    // Additional translations provided by customers
    "An account with the given email already exists.": "Questa email \xe8 gi\xe0 utilizzata da un altro account.",
    "Confirm a Code": "Conferma un codice",
    "Confirm Sign In": "Conferma l'accesso",
    "Create account": "Crea account",
    "Enter your password": "Inserisci la tua password",
    "Forgot Password?": "Password dimenticata?",
    "Have an account? ": "Gi\xe0 registrato?",
    "Incorrect username or password": "Nome utente o password errati",
    "Invalid password format": "Formato della password non valido",
    "Invalid phone number format": "Formato del numero di telefono non valido",
    "Lost your code?": "Codice smarrito?",
    "New Password": "Nuova password",
    "No account? ": "Non hai un account?",
    "Password attempts exceeded": "Il numero massimo di tentativi di accesso falliti \xe8 stato raggiunto",
    "Reset password": "Reimposta password",
    "Sign Out": "Esci",
    "Sign Up": "Registrati",
    "User already exists": "Utente gi\xe0 esistente",
    "User does not exist": "Utente inesistente",
    "Username cannot be empty": "Il nome utente non pu\xf2 essere vuoto"
};


const $2d261b7529ec3242$export$c416809cd76fbf21 = {
    "Account recovery requires verified contact information": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u5FA9\u65E7\u306B\u306F\u78BA\u8A8D\u6E08\u307F\u306E\u9023\u7D61\u5148\u304C\u5FC5\u8981\u3067\u3059",
    "Back to Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3\u306B\u623B\u308B",
    "Change Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u3048\u308B ",
    Changing: "\u5909\u66F4\u4E2D",
    Code: "\u30B3\u30FC\u30C9",
    "Confirm Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u78BA\u8A8D",
    "Confirm Sign Up": "\u767B\u9332\u3059\u308B",
    "Confirm SMS Code": "SMS \u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    "Confirm TOTP Code": "TOTP \u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    Confirm: "\u78BA\u5B9A",
    "Confirmation Code": "\u78BA\u8A8D\u30B3\u30FC\u30C9",
    Confirming: "\u78BA\u8A8D\u4E2D",
    "Create a new account": "\u65B0\u3057\u3044\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B",
    "Create Account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B",
    "Creating Account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u4F5C\u6210\u4E2D",
    "Dismiss alert": "\u30A2\u30E9\u30FC\u30C8\u3092\u9589\u3058\u308B",
    Email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
    "Enter your code": "\u30B3\u30FC\u30C9\u3092\u5165\u529B",
    "Enter your Email": "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B",
    "Enter your phone number": "\u96FB\u8A71\u756A\u53F7\u3092\u5165\u529B",
    "Enter your username": "\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u5165\u529B ",
    "Forgot your password?": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u307E\u3057\u305F\u304B\uFF1F ",
    "Hide password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u975E\u8868\u793A",
    "It may take a minute to arrive": "\u5230\u7740\u3059\u308B\u307E\u3067\u306B 1 \u5206\u304B\u304B\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002",
    Loading: "\u30ED\u30FC\u30C9\u4E2D",
    "New password": "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9",
    or: "\u53C8\u306F",
    Password: "\u30D1\u30B9\u30EF\u30FC\u30C9 ",
    "Phone Number": "\u96FB\u8A71\u756A\u53F7",
    "Resend Code": "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1",
    "Reset your Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8",
    "Reset your password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B",
    "Send code": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1",
    "Send Code": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1",
    Sending: "\u9001\u4FE1\u4E2D",
    "Setup TOTP": "TOTP \u3092\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7",
    "Show password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u8868\u793A",
    "Sign in to your account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30B5\u30A4\u30F3\u30A4\u30F3 ",
    "Sign In with Amazon": "Amazon\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In with Apple": "Apple \u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In with Facebook": "Facebook\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In with Google": "Google\u3067\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3 ",
    "Sign in": "\u30B5\u30A4\u30F3\u30A4\u30F3",
    "Signing in": "\u30B5\u30A4\u30F3\u30A4\u30F3\u4E2D",
    Skip: "\u30B9\u30AD\u30C3\u30D7",
    Submit: "\u9001\u4FE1",
    Submitting: "\u9001\u4FE1\u4E2D",
    Username: "\u30E6\u30FC\u30B6\u30FC\u540D ",
    "Verify Contact": "\u9023\u7D61\u5148\u3092\u78BA\u8A8D",
    Verify: "\u78BA\u8A8D",
    "We Sent A Code": "\u30B3\u30FC\u30C9\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F",
    "We Texted You": "\u30C6\u30AD\u30B9\u30C8\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F",
    "Your code is on the way. To log in, enter the code we sent you": "\u30B3\u30FC\u30C9\u304C\u9014\u4E2D\u3067\u3059\u3002\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u9001\u4FE1\u3057\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    // Additional translations provided by customers
    "An account with the given email already exists.": "\u5165\u529B\u3055\u308C\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059",
    "Confirm a Code": "\u30B3\u30FC\u30C9\u3092\u78BA\u8A8D",
    "Confirm Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3\u3059\u308B",
    "Create account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B ",
    "Enter your password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B ",
    "Enter your Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B",
    "Please confirm your Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B",
    "Forgot Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u305F ",
    "Have an account? ": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u6301\u3063\u3066\u3044\u307E\u3059\u304B\uFF1F",
    "Incorrect username or password": "\u30E6\u30FC\u30B6\u30FC\u540D\u304B\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u7570\u306A\u308A\u307E\u3059 ",
    "Invalid password format": "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u5F62\u5F0F\u304C\u7121\u52B9\u3067\u3059 ",
    "Invalid phone number format": "\u4E0D\u6B63\u306A\u96FB\u8A71\u756A\u53F7\u306E\u5F62\u5F0F\u3067\u3059\u3002\n+12345678900 \u306E\u5F62\u5F0F\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
    "It may take a minute to arrive.": "\u30B3\u30FC\u30C9\u3092\u53D7\u4FE1\u3059\u308B\u307E\u3067\u6570\u5206\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002",
    "Lost your code? ": "\u30B3\u30FC\u30C9\u3092\u5931\u304F\u3057\u307E\u3057\u305F\u304B\uFF1F",
    "New Password": "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9",
    "No account? ": "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u7121\u3044\u3068\u304D ",
    "Password attempts exceeded": "\u30B5\u30A4\u30F3\u30A4\u30F3\u306E\u8A66\u884C\u56DE\u6570\u304C\u4E0A\u9650\u306B\u9054\u3057\u307E\u3057\u305F",
    "Reset password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8 ",
    "Reset Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8",
    "Sign Out": "\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8 ",
    "Sign Up": "\u767B\u9332 ",
    "User already exists": "\u65E2\u306B\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u3066\u3044\u307E\u3059 ",
    "User does not exist": "\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u307E\u305B\u3093 ",
    "Username cannot be empty": "\u30E6\u30FC\u30B6\u30FC\u540D\u306F\u5165\u529B\u5FC5\u9808\u3067\u3059",
    "We Emailed You": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F",
    "Your code is on the way. To log in, enter the code we emailed to": "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u30E1\u30FC\u30EB\u306B\u8A18\u8F09\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9001\u4FE1\u5148:",
    "Your code is on the way. To log in, enter the code we texted to": "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u30C6\u30AD\u30B9\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8\u306B\u8A18\u8F09\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9001\u4FE1\u5148:"
};


const $e6593af80e9588eb$export$fb1930c2b96707b2 = {
    "Account recovery requires verified contact information": "\uACC4\uC815 \uBCF5\uAD6C\uB97C \uC704\uD574 \uC5F0\uB77D\uCC98 \uD655\uC778\uC774 \uD544\uC694\uD569\uB2C8\uB2E4",
    "Back to Sign In": "\uB85C\uADF8\uC778\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30",
    "Change Password": "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD\uD558\uAE30",
    Changing: "\uBCC0\uACBD\uC911",
    Code: "\uCF54\uB4DC",
    "Confirm Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uD655\uC778",
    "Confirm Sign Up": "\uD68C\uC6D0\uAC00\uC785 \uD655\uC778",
    "Confirm SMS Code": "\uD734\uB300\uD3F0 \uBCF8\uC778 \uD655\uC778",
    "Confirm TOTP Code": "TOTP \uC778\uC99D\uBC88\uD638 \uD655\uC778",
    Confirm: "\uD655\uC778",
    "Confirmation Code": "\uC778\uC99D\uBC88\uD638",
    Confirming: "\uD655\uC778\uC911",
    "Create a new account": "\uD68C\uC6D0\uAC00\uC785",
    "Create Account": "\uD68C\uC6D0\uAC00\uC785",
    "Creating Account": "\uD68C\uC6D0\uAC00\uC785\uC911",
    "Dismiss alert": "\uC54C\uB9BC \uBB34\uC2DC",
    Email: "\uC774\uBA54\uC77C",
    "Enter your code": "\uC778\uC99D\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
    "Enter your Email": "\uC774\uBA54\uC77C \uC785\uB825",
    "Enter your phone number": "\uC804\uD654\uBC88\uD638 \uC785\uB825",
    "Enter your username": "\uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
    "Hide password": "\uBE44\uBC00\uBC88\uD638 \uC228\uAE30\uAE30",
    "It may take a minute to arrive": "\uB3C4\uCC29\uD558\uB294 \uB370 1\uBD84 \uC815\uB3C4 \uAC78\uB9B4 \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    Loading: "\uB85C\uB529\uC911",
    "New password": "\uC0C8 \uBE44\uBC00\uBC88\uD638",
    or: "\uB610\uB294",
    Password: "\uBE44\uBC00\uBC88\uD638",
    "Phone Number": "\uC804\uD654\uBC88\uD638",
    "Resend Code": "\uC778\uC99D\uBC88\uD638 \uC7AC\uC804\uC1A1",
    "Reset your password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    "Reset your Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    "Send code": "\uC778\uC99D\uCF54\uB4DC \uBCF4\uB0B4\uAE30",
    "Send Code": "\uCF54\uB4DC \uC804\uC1A1",
    Sending: "\uC804\uC1A1\uC911",
    "Setup TOTP": "TOTP \uC124\uC815\uD558\uAE30",
    "Show password": "\uBE44\uBC00\uBC88\uD638 \uBCF4\uC774\uAE30",
    "Sign in to your account": "\uB85C\uADF8\uC778",
    "Sign In with Amazon": "Amazon \uB85C\uADF8\uC778",
    "Sign In with Apple": "Apple \uB85C\uADF8\uC778",
    "Sign In with Facebook": "Facebook \uB85C\uADF8\uC778",
    "Sign In with Google": "Google \uB85C\uADF8\uC778",
    "Sign in": "\uB85C\uADF8\uC778",
    "Sign In": "\uB85C\uADF8\uC778",
    "Signing in": "\uB85C\uADF8\uC778\uC911",
    Skip: "\uB2E4\uC74C\uC5D0 \uD558\uAE30",
    Submit: "\uD655\uC778",
    Submitting: "\uD655\uC778\uC911",
    Username: "\uC544\uC774\uB514",
    "Verify Contact": "\uC5F0\uB77D\uCC98 \uD655\uC778",
    Verify: "\uC778\uC99D",
    "We Emailed You": "\uC774\uBA54\uC77C\uC744 \uBCF4\uB0C4",
    "We Sent A Code": "\uCF54\uB4DC\uB97C \uBCF4\uB0C4",
    "We Texted You": "\uBB38\uC790 \uBA54\uC2DC\uC9C0\uB97C \uBCF4\uB0C4",
    "Your code is on the way. To log in, enter the code we emailed to": "\uCF54\uB4DC\uAC00 \uC804\uC1A1 \uC911\uC785\uB2C8\uB2E4. \uB85C\uADF8\uC778\uD558\uB824\uBA74 \uC774\uBA54\uC77C\uB85C \uC804\uC1A1\uD55C \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
    "Your code is on the way. To log in, enter the code we sent you": "\uCF54\uB4DC\uAC00 \uC804\uC1A1 \uC911\uC785\uB2C8\uB2E4. \uB85C\uADF8\uC778\uD558\uB824\uBA74 \uC804\uC1A1\uD55C \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
    "Your code is on the way. To log in, enter the code we texted to": "\uCF54\uB4DC\uAC00 \uC804\uC1A1 \uC911\uC785\uB2C8\uB2E4. \uB85C\uADF8\uC778\uD558\uB824\uBA74 \uBB38\uC790 \uBA54\uC2DC\uC9C0\uB85C \uC804\uC1A1\uD55C \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694",
    // Additional translations provided by customers
    Birthdate: "\uC0DD\uB144\uC6D4\uC77C",
    "Family Name": "\uC131",
    "Forgot your password?": "\uBE44\uBC00\uBC88\uD638\uB97C \uC78A\uC73C\uC168\uB098\uC694?",
    "Given Name": "\uC774\uB984",
    Name: "\uC131\uD568",
    Nickname: "\uB2C9\uB124\uC784",
    "Preferred Username": "\uB2C9\uB124\uC784",
    Profile: "\uD504\uB85C\uD544",
    "Reset Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815",
    Website: "\uC6F9\uC0AC\uC774\uD2B8"
};


const $f5ad9f9c93b4b97a$export$c27bce1749452052 = {
    "Account recovery requires verified contact information": "Gjenoppretting av konto krever verifisert kontaktinformajson",
    "Add your Profile": "Legg til profilen din",
    "Add your Website": "Legg til nettsiden din",
    "Back to Sign In": "Tilbake til innlogging",
    "Change Password": "Bytt passord",
    Changing: "Endre",
    Code: "Kode",
    "Confirm Password": "Bekreft passordet",
    "Confirm Sign Up": "Bekreft registrering",
    "Confirm SMS Code": "Bekreft SMS-kode",
    "Confirm TOTP Code": "Bekreft TOTP-kode",
    Confirm: "Bekreft",
    "Confirmation Code": "Bekreftelseskode",
    Confirming: "Bekrefter",
    "Create a new account": "Opprett en ny konto",
    "Create Account": "Opprett konto",
    "Creating Account": "Oppretter konto",
    "Dismiss alert": "Avvis varsel",
    Email: "E-post",
    "Enter your Birthdate": "Skriv inn f\xf8dselsdatoen din",
    "Enter your code": "Skriv inn koden din",
    "Enter your Confirmation Code": "Skriv inn bekreftelseskoden din",
    "Enter your Email": "Skriv inn e-postadressen din",
    "Enter your Family Name": "Skriv inn etternavnet ditt",
    "Enter your Given Name": "Skriv inn fornavnet ditt",
    "Enter your Middle Name": "Skriv inn mellomnavnet ditt",
    "Enter your Name": "Skriv inn navnet ditt",
    "Enter your Nickname": "Skriv inn kallenavnet ditt",
    "Enter your Password": "Skriv inn passordet ditt",
    "Enter your phone number": "Skriv inn telefonnummeret ditt",
    "Enter your Preferred Username": "Skriv inn det foretrukne brukernavnet ditt",
    "Enter your username": "Skriv inn brukernavnet ditt",
    "Forgot password?": "Glemt passord?",
    "Forgot your password?": "Glemt passordet ditt?",
    "Hide password": "Skjul passordet",
    "It may take a minute to arrive": "Det kan ta et minutt for \xe5 komme frem",
    Loading: "Laster inn",
    "New password": "Nytt passord",
    or: "eller",
    Password: "Passord",
    "Phone Number": "Telefonnummer",
    "Please confirm your Password": "Vennligst bekreft passordet ditt",
    "Resend Code": "Send koden p\xe5 nytt",
    "Reset your password": "Nullstill passordet ditt",
    "Reset your Password": "Nullstill passordet ditt",
    "Send code": "Send kode",
    "Send Code": "Send kode",
    Sending: "Sender",
    "Setup TOTP": "Konfigurer TOTP",
    "Show password": "Vis passordet",
    "Sign in to your account": "Logg inn p\xe5 kontoen din",
    "Sign In with Amazon": "Logg inn med Amazon",
    "Sign In with Apple": "Logg inn med Apple",
    "Sign In with Facebook": "Logg inn med Facebook",
    "Sign In with Google": "Logg inn med Google",
    "Sign in": "Logg inn",
    "Sign In": "Logg inn",
    "Signing in": "Logger inn",
    Skip: "Hopp over",
    Submit: "Send inn",
    Submitting: "Sender inn",
    Username: "Brukernavn",
    "Verify Contact": "Bekreft kontakt",
    Verify: "Bekreft",
    "We Emailed You": "Vi sendte deg en e-post",
    "We Sent A Code": "Vi sendte en kode",
    "We Texted You": "Vi sendte deg en tekstmelding",
    "Your code is on the way. To log in, enter the code we emailed to": "Koden din er p\xe5 vei. For \xe5 logge inn, skriv inn koden vi sendte e-post til",
    "Your code is on the way. To log in, enter the code we sent you": "Koden din er p\xe5 vei. For \xe5 logge inn, skriv inn koden vi sendte deg",
    "Your code is on the way. To log in, enter the code we texted to": "Koden din er p\xe5 vei. For \xe5 logge inn, skriv inn koden vi sendte tekstmelding til",
    // Additional translations provided by customers
    "An account with the given email already exists.": "Det finnes allerede en konto med denne e-postadressen",
    "Confirm a Code": "Bekreft koden",
    "Confirm Sign In": "Bekreft innlogging",
    "Create account": "Opprett konto",
    "Enter your password": "Skriv inn passordet ditt",
    "Forgot Password": "Glemt passordet",
    "Have an account? ": "Har en konto allerede? ",
    "Incorrect username or password": "Feil brukernavn eller passord",
    "Invalid password format": "Ugyldig passordformat",
    "Invalid phone number format": "Ugyldig telefonnummerformat",
    "Lost your code? ": "Mistet koden? ",
    "New Password": "Nytt passord",
    "No account? ": "Ingen konto? ",
    "Password attempts exceeded": "For mange mislykkede passordfors\xf8k",
    "Reset password": "Nullstill passord",
    "Sign Out": "Logg ut",
    "Sign Up": "Registrering",
    "User already exists": "Brukeren finnes allerede",
    "User does not exist": "Brukeren finnes ikke",
    "Username cannot be empty": "Brukernavnet kan ikke v\xe6re tomt"
};


const $3ca8e16c22a22216$export$8569df33fbaae243 = {
    "Account recovery requires verified contact information": "Accountherstel vereist geverifieerde contactgegevens",
    "Back to Sign In": "Terug naar inloggen",
    "Change Password": "Wachtwoord wijzigen",
    Changing: "Wordt aangepast",
    Code: "Code",
    "Confirm Password": "Bevestig Wachtwoord",
    "Confirm Sign Up": "Bevestig inschrijving",
    "Confirm SMS Code": "Bevestig SMS Code",
    "Confirm TOTP Code": "Bevestig TOTP Code",
    Confirm: "Bevestig",
    "Confirmation Code": "Bevestigingscode",
    Confirming: "Bevestigen",
    "Create a new account": "Nieuw account aanmaken",
    "Create Account": "Account aanmaken",
    "Creating Account": "Account wordt aangemaakt",
    "Dismiss alert": "Waarschuwing sluiten",
    Email: "E-mail",
    "Enter your code": "Vul je code in",
    "Enter your Email": "Vul je e-mail in",
    "Enter your Password": "Vul je wachtwoord in",
    "Enter your phone number": "Vul je telefoonnummer in",
    "Enter your username": "Vul je gebruikersnaam in",
    "Enter your Username": "Vul je gebruikersnaam in",
    "Forgot your password?": "Wachtwoord vergeten? ",
    "Hide password": "Verberg wachtwoord",
    "It may take a minute to arrive": "Het kan even duren voordat deze aankomt",
    Loading: "Laden",
    "New password": "Nieuw wachtwoord",
    "New Password": "Nieuw Wachtwoord",
    or: "of",
    Password: "Wachtwoord",
    "Phone Number": "Telefoonnummer",
    "Please confirm your Password": "Bevestig je wachtwoord",
    "Resend Code": "Verstuur code nogmaals",
    "Reset Password": "Wachtwoord resetten",
    "Reset your password": "Reset je wachtwoord",
    "Reset your Password": "Wachtwoord resetten",
    "Send code": "Verstuur code",
    "Send Code": "Verstuur Code",
    Sending: "Versturen",
    "Setup TOTP": "TOTP Instellingen",
    "Show password": "Toon wachtwoord",
    "Sign in to your account": "Inloggen op je account",
    "Sign In with Amazon": "Inloggen met Amazon",
    "Sign In with Apple": "Inloggen met Apple",
    "Sign In with Facebook": "Inloggen met Facebook",
    "Sign In with Google": "Inloggen met Google",
    "Sign in": "Inloggen",
    "Sign In": "Inloggen",
    "Signing in": "Inloggen",
    Skip: "Overslaan",
    Submit: "Versturen",
    Submitting: "Wordt verstuurd",
    Username: "Gebruikersnaam",
    "Verify Contact": "Verifieer Contact",
    Verify: "Verifieer",
    "We Emailed You": "We hebben u een e-mail gestuurd",
    "We Sent A Code": "We hebben een code gestuurd",
    "We Texted You": "We hebben u een sms gestuurd",
    "Your code is on the way. To log in, enter the code we emailed to": "Uw code is onderweg. Om in te loggen, voer de code in die we gemaild hebben naar",
    "Your code is on the way. To log in, enter the code we sent you": "Uw code is onderweg. Om in te loggen, voer de code in die we u hebben gestuurd",
    "Your code is on the way. To log in, enter the code we texted to": "Uw code is onderweg. Om in te loggen, voer de code in die we hebben gestuurd naar",
    "Your passwords must match": "Je wachtwoorden moeten overeenkomen"
};


const $5e42e1c7a431641b$export$6fb0e8139f7ef98d = {
    "Account recovery requires verified contact information": "Odzyskanie konta wymaga zweryfikowanych danych kontaktowych",
    "Back to Sign In": "Powr\xf3t do logowania",
    "Change Password": "Zmie\u0144 has\u0142o",
    Changing: "Zmienianie",
    Code: "Kod",
    "Confirm Password": "Potwierd\u017A Has\u0142o",
    "Confirm Sign Up": "Potwierd\u017A rejestracj\u0119",
    "Confirm SMS Code": "Potwierd\u017A kod SMS",
    "Confirm TOTP Code": "Potwierd\u017A has\u0142o jednorazowe",
    Confirm: "Potwierd\u017A",
    "Confirmation Code": "Kod potwierdzenia",
    Confirming: "Potwierdzanie",
    "Create a new account": "Utw\xf3rz nowe konto",
    "Create Account": "Utw\xf3rz konto",
    "Creating Account": "Tworzenie konta",
    "Dismiss alert": "Odrzu\u0107 alert",
    Email: "E-mail",
    "Enter your code": "Wprowad\u017A sw\xf3j kod",
    "Enter your Email": "Wpisz sw\xf3j adres e-mail",
    "Enter your phone number": "Wpisz sw\xf3j numer telefonu",
    "Enter your username": "Wprowad\u017A swoj\u0105 nazw\u0119 u\u017Cytkownika",
    "Forgot your password?": "Zapomnia\u0142e\u015B has\u0142a? ",
    "Hide password": "Ukryj has\u0142o",
    "It may take a minute to arrive": "Mo\u017Ce to chwil\u0119 potrwa\u0107",
    Loading: "\u0141adowanie",
    "New password": "Nowe has\u0142o",
    or: "albo",
    Password: "Has\u0142o",
    "Phone Number": "Numer telefonu",
    "Resend Code": "Wy\u015Blij kod ponownie",
    "Reset your password": "Zresetuj swoje has\u0142o",
    "Reset your Password": "Zresetuj swoje has\u0142o",
    "Send code": "Wy\u015Blij kod",
    "Send Code": "Zresetuj has\u0142o",
    Sending: "Wysy\u0142anie",
    "Setup TOTP": "Konfiguruj TOTP",
    "Show password": "Poka\u017C has\u0142o",
    "Sign in to your account": "Zaloguj si\u0119 na swoje konto",
    "Sign In with Amazon": "Zaloguj z Amazon",
    "Sign In with Apple": "Zaloguj z Apple",
    "Sign In with Facebook": "Zaloguj z Facebook",
    "Sign In with Google": "Zaloguj z Google",
    "Sign In": "Logowanie",
    "Sign in": "Zaloguj",
    "Signing in": "Logowanie",
    Skip: "Pomi\u0144",
    Submit: "Wy\u015Blij",
    Submitting: "Wysy\u0142anie",
    Username: "Nazwa u\u017Cytkownika",
    "Verify Contact": "Weryfikacja danych kontaktowych",
    Verify: "Zweryfikuj",
    // Additional translations provided by customers
    Birthdate: "Data urodzenia",
    "Family Name": "Nazwisko",
    "Given Name": "Pierwsze imi\u0119",
    "Middle Name": "Drugie imi\u0119",
    Name: "Imi\u0119 i nazwisko",
    Nickname: "Pseudonim",
    "Preferred Username": "Preferowana nazwa u\u017Cytkownika",
    Profile: "Profil",
    Website: "Strona internetowa",
    "We Emailed You": "Wys\u0142ali\u015Bmy Ci wiadomo\u015B\u0107 e-mail",
    "We Sent A Code": "Wys\u0142ali\u015Bmy kod",
    "We Texted You": "Wys\u0142ali\u015Bmy Ci wiadomo\u015B\u0107 SMS",
    "Your code is on the way. To log in, enter the code we emailed to": "Tw\xf3j kod zosta\u0142 wys\u0142any. Aby si\u0119 zalogowa\u0107, wprowad\u017A kod wys\u0142any na adres e-mail",
    "Your code is on the way. To log in, enter the code we sent you": "Tw\xf3j kod zosta\u0142 wys\u0142any. Aby si\u0119 zalogowa\u0107, wprowad\u017A wys\u0142any do Ciebie kod",
    "Your code is on the way. To log in, enter the code we texted to": "Tw\xf3j kod zosta\u0142 wys\u0142any. Aby si\u0119 zalogowa\u0107, wprowad\u017A kod wys\u0142any do Ciebie w wiadomo\u015Bci SMS pod numer"
};


const $9364c903fedc8336$export$c7dddbf179b434d1 = {
    "Account recovery requires verified contact information": "A recupera\xe7\xe3o da conta requer informa\xe7\xf5es de contato verificadas",
    "Back to Sign In": "Voltar para Entrar",
    "Change Password": "Mudar senha",
    Changing: "Mudando",
    Code: "C\xf3digo",
    "Confirm Password": "Confirme a Senha",
    "Confirm Sign Up": "Confirmar inscri\xe7\xe3o",
    "Confirm SMS Code": "Confirme o c\xf3digo SMS",
    "Confirm TOTP Code": "Confirme o c\xf3digo TOTP",
    Confirm: "confirme",
    "Confirmation Code": "C\xf3digo de confirma\xe7\xe3o",
    Confirming: "Confirmando",
    "Create a new account": "Criar uma nova conta",
    "Create Account": "Criar Conta",
    "Creating Account": "Criando conta",
    "Dismiss alert": "Descartar alerta",
    Email: "O email",
    "Enter your code": "Insira seu c\xf3digo",
    "Enter your Email": "Digite seu e-mail",
    "Enter your phone number": "Digite seu n\xfamero de telefone",
    "Enter your username": "entre com seu nome de usu\xe1rio",
    "Forgot your password?": "Esqueceu sua senha? ",
    "Hide password": "Esconder a senha",
    "It may take a minute to arrive": "Pode levar um minuto para chegar",
    Loading: "Carregando",
    "New password": "Nova Senha",
    or: "ou",
    Password: "Senha",
    "Phone Number": "N\xfamero de telefone",
    "Resend Code": "Reenviar c\xf3digo",
    "Reset your password": "Redefina sua senha",
    "Reset your Password": "Redefina sua senha",
    "Send code": "Enviar c\xf3digo",
    "Send Code": "Enviar c\xf3digo",
    Sending: "Enviando",
    "Setup TOTP": "Configurar TOTP",
    "Show password": "Mostrar senha",
    "Sign in to your account": "Fa\xe7a login em sua conta",
    "Sign In with Amazon": "Entrar com a Amazon",
    "Sign In with Apple": "Entrar com a Apple",
    "Sign In with Facebook": "Entrar com o Facebook",
    "Sign In with Google": "Fa\xe7a login no Google",
    "Sign in": "Entrar",
    "Sign In": "Entrar",
    "Signing in": "Entrando",
    Skip: "Pular",
    Submit: "Enviar",
    Submitting: "Enviando",
    Username: "Nome do usu\xe1rio",
    "Verify Contact": "Verificar contato",
    Verify: "Verificar",
    "We Emailed You": "Enviamos um e-mail para voc\xea",
    "We Sent A Code": "Enviamos um c\xf3digo",
    "We Texted You": "Enviamos um SMS para voc\xea",
    "Your code is on the way. To log in, enter the code we emailed to": "Seu c\xf3digo est\xe1 a caminho. Para fazer login, insira o c\xf3digo para o qual enviamos um e-mail",
    "Your code is on the way. To log in, enter the code we sent you": "Seu c\xf3digo est\xe1 a caminho. Para fazer login, insira o c\xf3digo que enviamos para voc\xea",
    "Your code is on the way. To log in, enter the code we texted to": "Seu c\xf3digo est\xe1 a caminho. Para fazer login, insira o c\xf3digo para o qual enviamos uma mensagem de texto"
};


const $ab0f63092fa060f9$export$2a86dc37ee9734c = {
    "Account recovery requires verified contact information": "\u8D26\u6237\u6062\u590D\u9700\u8981\u9A8C\u8BC1\u8FC7\u7684\u8054\u7CFB\u65B9\u5F0F",
    "Back to Sign In": "\u56DE\u5230\u767B\u5F55",
    "Change Password": "\u66F4\u6539\u5BC6\u7801",
    Changing: "\u6B63\u5728\u4FEE\u6539",
    Code: "\u786E\u8BA4\u7801",
    "Confirm Password": "\u786E\u8BA4\u5BC6\u7801",
    "Confirm Sign Up": "\u786E\u8BA4\u6CE8\u518C",
    "Confirm SMS Code": "\u786E\u8BA4\u77ED\u4FE1\u9A8C\u8BC1\u7801",
    "Confirm TOTP Code": "\u786E\u8BA4 TOTP \u4EE3\u7801",
    Confirm: "\u786E\u8BA4",
    "Confirmation Code": "\u786E\u8BA4\u7801",
    Confirming: "\u6B63\u5728\u786E\u8BA4",
    "Create a new account": "\u521B\u5EFA\u65B0\u8D26\u6237",
    "Create Account": "\u521B\u5EFA\u8D26\u6237",
    "Creating Account": "\u6B63\u5728\u521B\u5EFA\u8D26\u6237",
    "Dismiss alert": "\u5173\u95ED\u8B66\u62A5",
    Email: "\u90AE\u7BB1",
    "Enter your code": "\u8F93\u5165\u9A8C\u8BC1\u7801",
    "Enter your Email": "\u8F93\u5165\u7535\u5B50\u90AE\u4EF6",
    "Enter your phone number": "\u8F93\u5165\u7535\u8BDD\u53F7\u7801",
    "Enter your username": "\u8F93\u5165\u7528\u6237\u540D",
    "Forgot your password?": "\u5FD8\u8BB0\u5BC6\u7801\u4E86\uFF1F",
    "Hide password": "\u9690\u85CF\u5BC6\u7801",
    "It may take a minute to arrive": "\u53EF\u80FD\u9700\u8981\u4E00\u5206\u949F\u624D\u80FD\u5230\u8FBE",
    Loading: "\u6B63\u5728\u52A0\u8F7D",
    "New password": "\u65B0\u5BC6\u7801",
    or: "\u6216\u8005",
    Password: "\u5BC6\u7801",
    "Phone Number": "\u7535\u8BDD",
    "Resend Code": "\u91CD\u53D1\u9A8C\u8BC1\u7801",
    "Reset your password": "\u91CD\u7F6E\u5BC6\u7801",
    "Reset your Password": "\u91CD\u7F6E\u5BC6\u7801",
    "Send Code": "\u53D1\u9001\u786E\u8BA4\u7801",
    "Send code": "\u53D1\u9001\u9A8C\u8BC1\u7801",
    Sending: "\u6B63\u5728\u53D1\u9001",
    "Setup TOTP": "\u8BBE\u7F6E TOTP",
    "Show password": "\u663E\u793A\u5BC6\u7801",
    "Sign in to your account": "\u767B\u5F55\u8D26\u6237",
    "Sign In with Amazon": "\u901A\u8FC7 Amazon \u767B\u5F55",
    "Sign In with Apple": "\u901A\u8FC7 Apple \u767B\u5F55",
    "Sign In with Facebook": "\u901A\u8FC7 Facebook \u767B\u5F55",
    "Sign In with Google": "\u901A\u8FC7 Google \u767B\u5F55",
    "Sign in": "\u767B\u5F55",
    "Sign In": "\u767B\u5F55",
    "Signing in": "\u6B63\u5728\u767B\u5F55",
    Skip: "\u8DF3\u8FC7",
    Submit: "\u63D0\u4EA4",
    Submitting: "\u6B63\u5728\u63D0\u4EA4",
    Username: "\u7528\u6237\u540D",
    "Verify Contact": "\u9A8C\u8BC1\u8054\u7CFB\u65B9\u5F0F",
    Verify: "\u9A8C\u8BC1",
    "We Emailed You": "\u6211\u4EEC\u7ED9\u60A8\u53D1\u9001\u4E86\u7535\u5B50\u90AE\u4EF6",
    "We Sent A Code": "\u6211\u4EEC\u53D1\u9001\u4E86\u4EE3\u7801",
    "We Texted You": "\u6211\u4EEC\u7ED9\u60A8\u53D1\u9001\u4E86\u77ED\u4FE1",
    "Your code is on the way. To log in, enter the code we emailed to": "\u60A8\u7684\u4EE3\u7801\u6B63\u5728\u53D1\u9001\u4E2D\u3002\u8981\u767B\u5F55\uFF0C\u8BF7\u8F93\u5165\u6211\u4EEC\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u53D1\u9001\u7ED9\u4EE5\u4E0B\u4EBA\u5458\u7684\u4EE3\u7801\uFF1A",
    "Your code is on the way. To log in, enter the code we sent you": "\u60A8\u7684\u4EE3\u7801\u6B63\u5728\u53D1\u9001\u4E2D\u3002\u8981\u767B\u5F55\uFF0C\u8BF7\u8F93\u5165\u6211\u4EEC\u53D1\u9001\u7ED9\u60A8\u7684\u4EE3\u7801",
    "Your code is on the way. To log in, enter the code we texted to": "\u60A8\u7684\u4EE3\u7801\u6B63\u5728\u53D1\u9001\u4E2D\u3002\u8981\u767B\u5F55\uFF0C\u8BF7\u8F93\u5165\u6211\u4EEC\u901A\u8FC7\u77ED\u4FE1\u53D1\u9001\u7ED9\u4EE5\u4E0B\u4EBA\u5458\u7684\u4EE3\u7801\uFF1A",
    // Additional translations provided by customers
    "Confirm a Code": "\u786E\u8BA4\u7801",
    "Confirm Sign In": "\u786E\u8BA4\u767B\u5F55",
    "Forgot Password": "\u5FD8\u8BB0\u5BC6\u7801",
    "Incorrect username or password": "\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF",
    "Invalid password format": "\u5BC6\u7801\u683C\u5F0F\u9519\u8BEF",
    "Invalid phone number format": "\u7535\u8BDD\u683C\u5F0F\u9519\u8BEF\uFF0C\u8BF7\u4F7F\u7528\u683C\u5F0F +12345678900",
    "New Password": "\u65B0\u5BC6\u7801",
    "Resend a Code": "\u91CD\u53D1\u786E\u8BA4\u7801",
    "Sign Out": "\u9000\u51FA",
    "Sign Up": "\u6CE8\u518C",
    "User already exists": "\u7528\u6237\u5DF2\u7ECF\u5B58\u5728",
    "User does not exist": "\u7528\u6237\u4E0D\u5B58\u5728"
};


const $a66485d94301bbc3$export$9f1a61f9baaa2d2e = {
    "Account recovery requires verified contact information": "F\xf6r att \xe5terst\xe4lla kontot beh\xf6ver du ett verifierat konto",
    "Back to Sign In": "Tillbaka till inloggningen",
    "Change Password": "Byt l\xf6senord",
    Changing: "\xc4ndra",
    Code: "Kod",
    "Confirm Password": "Bekr\xe4fta l\xf6senord",
    "Confirm Sign Up": "Bekr\xe4fta registrering",
    "Confirm SMS Code": "Bekr\xe4fta SMS-kod",
    "Confirm TOTP Code": "Bekr\xe4fta TOTP-kod",
    Confirm: "Bekr\xe4fta",
    "Confirmation Code": "Verifikationskod",
    Confirming: "Bekr\xe4ftar",
    "Create a new account": "Skapa ett nytt konto",
    "Create Account": "Skapa konto",
    "Creating Account": "Skapar konto",
    "Dismiss alert": "Avvisa varning",
    Email: "E-post",
    "Enter your code": "Skriv din kod",
    "Enter your Email": "Fyll i din e-post",
    "Enter your phone number": "Ange ditt telefonnummer",
    "Enter your username": "Ange ditt anv\xe4ndarnamn",
    "Forgot your password?": "Gl\xf6mt ditt l\xf6senord? ",
    "Hide password": "D\xf6lj l\xf6senord",
    "It may take a minute to arrive": "Det kan ta en minut att komma fram",
    Loading: "Laddar",
    "New password": "Nytt l\xf6senord",
    or: "eller",
    Password: "L\xf6senord",
    "Phone Number": "Telefonnummer",
    "Resend Code": "Skicka koden igen",
    "Reset your password": "\xc5terst\xe4ll ditt l\xf6senord",
    "Reset your Password": "\xc5terst\xe4ll ditt l\xf6senord",
    "Send code": "Skicka kod",
    "Send Code": "Skicka kod",
    Sending: "Skickar",
    "Setup TOTP": "Konfigurera TOTP",
    "Show password": "Visa l\xf6senord",
    "Sign in to your account": "Logga in till ditt konto",
    "Sign In with Amazon": "Logga in med Amazon",
    "Sign In with Apple": "Logga in med Apple",
    "Sign In with Facebook": "Logga in med Facebook",
    "Sign In with Google": "Logga in med Google",
    "Sign in": "Logga in",
    "Sign In": "Logga in",
    "Signing in": "Loggar in",
    Skip: "Hoppa \xf6ver",
    Submit: "Skicka",
    Submitting: "Skickar in",
    Username: "Anv\xe4ndarnamn",
    "Verify Contact": "Verifiera kontakt",
    Verify: "Verifiera",
    "We Sent A Code": "Vi skickade en kod",
    "We Texted You": "Vi sms:ade dig",
    "Your code is on the way. To log in, enter the code we emailed to": "Din kod \xe4r p\xe5 v\xe4g. F\xf6r att logga in, ange koden vi mejlade till",
    "Your code is on the way. To log in, enter the code we sent you": "Din kod \xe4r p\xe5 v\xe4g. F\xf6r att logga in, ange koden vi skickade till dig",
    "Your code is on the way. To log in, enter the code we texted to": "Din kod \xe4r p\xe5 v\xe4g. F\xf6r att logga in, ange koden vi sms:ade till",
    // Additional translations provided by customers
    "An account with the given email already exists.": "Det finns redan ett konto med denna e-postadress",
    "Confirm a Code": "Bekr\xe4fta koden",
    "Confirm Sign In": "Bekr\xe4fta inloggning",
    "Create account": "Skapa konto",
    "Enter your password": "Ange ditt l\xf6senord",
    "Forgot Password": "Gl\xf6mt l\xf6senordet",
    "Have an account? ": "Redan registrerad? ",
    "Incorrect username or password": "Felaktigt anv\xe4ndarnamn eller l\xf6senord",
    "Invalid password format": "Ogiltigt l\xf6senordsformat",
    "Invalid phone number format": `Ogiltigt format f\xf6r telefonnummer`,
    "Lost your code? ": "F\xf6rlorat koden? ",
    "New Password": "Nytt l\xf6senord",
    "No account? ": "Inget konto? ",
    "Password attempts exceeded": "Maximalt antal felaktiga inloggningsf\xf6rs\xf6k har uppn\xe5tts",
    "Reset password": "\xc5terst\xe4ll l\xf6senord",
    "Sign Out": "Logga ut",
    "Sign Up": "Registrering",
    "User already exists": "Anv\xe4ndaren finns redan",
    "User does not exist": "Anv\xe4ndaren finns inte",
    "Username cannot be empty": "Anv\xe4ndarnamnet kan inte vara tomt",
    "We Emailed You": "Vi har skickat e-post till dig"
};


const $0a782ee75702b170$export$710642024bfcbd8f = {
    "Account recovery requires verified contact information": "Pemulihan akun memerlukan informasi kontak terverifikasi",
    "Back to Sign In": "Kembali ke Masuk",
    "Change Password": "Ubah kata sandi",
    Changing: "Mengubah",
    Code: "Kode",
    "Confirm Password": "Konfirmasi kata sandi",
    "Confirm Sign Up": "Konfirmasi Pendaftaran",
    "Confirm SMS Code": "Konfirmasi Kode SMS",
    "Confirm TOTP Code": "Konfirmasi Kode TOTP",
    Confirm: "Konfirmasi",
    "Confirmation Code": "Kode Konfirmasi",
    Confirming: "Mengkonfirmasi",
    "Create a new account": "Buat akun baru",
    "Create Account": "Buat Akun",
    "Creating Account": "Membuat Akun",
    "Dismiss alert": "Hentikan pemberitahuan",
    Email: "Email",
    "Enter your code": "Masukkan kode anda",
    "Enter your Email": "Masukkan email anda",
    "Enter your phone number": "Masukkan nomor telepon anda",
    "Enter your username": "Masukkan nama akun anda",
    "Forgot your password?": "Lupa kata sandi? ",
    "Hide password": "Sembunyikan kata sandi",
    "It may take a minute to arrive": "Mungkin perlu waktu satu menit untuk tiba",
    Loading: "Memuat",
    "New password": "Kata sandi baru",
    or: "atau",
    Password: "Kata sandi",
    "Phone Number": "Nomor telepon",
    "Resend Code": "Kirim ulang kodenya",
    "Reset your Password": "Reset Kata Sandi",
    "Reset your password": "Ubah kata sandi anda",
    "Send code": "Kirim kode",
    "Send Code": "Kirim Kode",
    Sending: "Mengirim",
    "Setup TOTP": "Siapkan TOTP",
    "Show password": "Tampilkan kata sandi",
    "Sign in to your account": "Masuk akun anda",
    "Sign In with Amazon": "Masuk dengan Amazon",
    "Sign In with Apple": "Masuk dengan Apple",
    "Sign In with Facebook": "Masuk dengan Facebook",
    "Sign In with Google": "Masuk dengan Google",
    "Sign in": "Masuk",
    "Sign In": "Masuk",
    "Signing in": "Memasuki",
    Skip: "Lewati",
    Submit: "Ajukan",
    Submitting: "Mengajukan",
    Username: "Nama akun",
    "Verify Contact": "Verifikasi Kontak",
    Verify: "Verifikasi",
    "We Sent A Code": "Kami Mengirim Kode",
    "We Texted You": "Kami mengirim SMS kepada Anda",
    "Your code is on the way. To log in, enter the code we sent you": "Kode Anda segera hadir. Untuk masuk, masukkan kode yang kami kirimkan kepada Anda",
    // Additional translations provided by customers
    "An account with the given email already exists.": "Akun dengan email tersebut sudah terdaftar.",
    "Attempt limit exceeded, please try after some time.": "Batas percobaan terlampaui, mohon coba lagi setelah beberapa waktu.",
    "Cannot reset password for the user as there is no registered/verified email or phone_number": "Tidak dapat mengatur ulang kata sandi karena tidak ada email terdaftar / terverifikasi atau nomor telepon",
    Change: "Ubah",
    "Confirm a Code": "Konfirmasi kode",
    "Create account": "Buat akun",
    "Enter your password": "Masukkan kata sandi anda",
    "Forgot Password": "Lupa kata sandi",
    "Have an account? ": "Sudah punya akun? ",
    Hello: "Halo",
    "Incorrect username or password.": "Nama akun atau kata sandi salah.",
    "Invalid phone number format": "Nomor telepon tidak sesuai dengan format.",
    "Invalid verification code provided, please try again.": "Kode verifikasi tidak sesuai, mohon coba lagi.",
    "It may take a minute to arrive.": "Mungkin perlu beberapa waktu untuk tiba.",
    "Lost your code? ": "Kode anda hilang?",
    Name: "Nama",
    "Network error": "Galat jaringan",
    "No account? ": "Tidak ada akun?",
    "Password did not conform with policy: Password not long enough": "Kata sandi tidak sesuai dengan aturan: Kata sandi kurang panjang",
    "Resend a Code": "Renvoyer un code",
    "Reset password": "Ubah kata sandi anda",
    Send: "Kirim",
    "Sign In with AWS": "Masuk dengan AWS",
    "Sign Up with Amazon": "Daftar dengan Amazon",
    "Sign Up with AWS": "Daftar dengan AWS",
    "Sign Up with Facebook": "Daftar dengan Facebook",
    "Sign Up with Google": "Daftar dengan Google",
    SMS: "SMS",
    "User already exists": "Akun sudah terdaftar",
    "User does not exist.": "Akun tidak terdaftar.",
    "User is disabled.": "Akun dinonaktifkan.",
    "Username cannot be empty": "Nama akun tidak boleh kosong",
    "Username/client id combination not found.": "Nama akun atau id tidak ditemukan.",
    "We Emailed You": "Kami mengirimkanmu email",
    "Your code is on the way. To log in, enter the code we emailed to": "Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami emailkan ke",
    "Your code is on the way. To log in, enter the code we texted to": "Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami tuliskan ke",
    "Your passwords must match": "Kata sandi harus sama"
};


const $a1b19d75b58dd5bf$export$6961fa2059aeacf0 = {
    "Account recovery requires verified contact information": "Hesap kurtarma, do\u011Frulanm\u0131\u015F ileti\u015Fim bilgilerini gerektirir",
    "Back to Sign In": "Oturum A\xe7maya Geri D\xf6n",
    "Change Password": "\u015Eifreyi De\u011Fi\u015Ftir",
    Changing: "De\u011Fi\u015Ftiriliyor",
    Code: "Kod",
    "Confirm Password": "\u015Eifreyi Do\u011Frula",
    "Confirm Sign Up": "Kay\u0131t \u0130\u015Flemini Do\u011Frula",
    "Confirm SMS Code": "SMS Kodunu Do\u011Frula",
    "Confirm TOTP Code": "Tek Kullan\u0131ml\u0131k \u015Eifreyi Do\u011Frula",
    Confirm: "Do\u011Frula",
    "Confirmation Code": "Do\u011Frulama Kodu",
    Confirming: "Do\u011Frulan\u0131yor",
    "Create a new account": "Yeni bir hesap olu\u015Ftur",
    "Create Account": "Hesap Olu\u015Ftur",
    "Creating Account": "Hesap Olu\u015Fturuluyor",
    "Dismiss alert": "Uyar\u0131y\u0131 reddet",
    Email: "E-posta",
    "Enter your code": "Kodu girin",
    "Enter your Email": "E-posta adresinizi girin",
    "Enter your phone number": "Telefon numaran\u0131z\u0131 girin",
    "Enter your username": "Kullan\u0131c\u0131 ad\u0131n\u0131z\u0131 girin",
    "Forgot your password?": "\u015Eifrenizi mi unuttunuz?",
    "Hide password": "\u015Eifreyi gizle",
    "It may take a minute to arrive": "Kodun gelmesi bir dakika s\xfcrebilir",
    Loading: "Y\xfckleniyor",
    "New password": "Yeni \u015Fifre",
    or: "veya",
    Password: "\u015Eifre",
    "Phone Number": "Telefon Numaras\u0131",
    "Resend Code": "Kodu Yeniden G\xf6nder",
    "Reset your password": "\u015Eifrenizi s\u0131f\u0131rlay\u0131n",
    "Reset your Password": "\u015Eifrenizi S\u0131f\u0131rlay\u0131n",
    "Send code": "Kod g\xf6nder",
    "Send Code": "Kod G\xf6nder",
    Sending: "G\xf6nderiliyor",
    "Setup TOTP": "Tek kullan\u0131ml\u0131k \u015Fifre kurulumu yap",
    "Show password": "\u015Eifreyi g\xf6ster",
    "Sign in to your account": "Hesab\u0131n\u0131zda oturum a\xe7\u0131n",
    "Sign In with Amazon": "Amazon ile Oturum A\xe7",
    "Sign In with Apple": "Apple ile Oturum A\xe7",
    "Sign In with Facebook": "Facebook ile Oturum A\xe7",
    "Sign In with Google": "Google ile Oturum A\xe7",
    "Sign in": "Oturum a\xe7",
    "Sign In": "Oturum A\xe7",
    "Signing in": "Oturum a\xe7\u0131l\u0131yor",
    Skip: "Atla",
    Submit: "G\xf6nder",
    Submitting: "G\xf6nderiliyor",
    Username: "Kullan\u0131c\u0131 ad\u0131",
    "Verify Contact": "Ki\u015Fiyi Do\u011Frula",
    Verify: "Do\u011Frula",
    "We Emailed You": "Size E-posta G\xf6nderdik",
    "We Sent A Code": "Bir Kod G\xf6nderdik",
    "We Texted You": "Size Mesaj G\xf6nderdik",
    "Your code is on the way. To log in, enter the code we emailed to": "Kodunuz yolda. Oturum a\xe7mak i\xe7in, g\xf6nderdi\u011Fimiz e-postadaki kodu girin",
    "Your code is on the way. To log in, enter the code we sent you": "Kodunuz yolda. Oturum a\xe7mak i\xe7in, size g\xf6nderdi\u011Fimiz kodu girin",
    "Your code is on the way. To log in, enter the code we texted to": "Kodunuz yolda. Oturum a\xe7mak i\xe7in, g\xf6nderdi\u011Fimiz mesajdaki kodu girin",
    // Additional translations provided by customers
    "An account with the given email already exists.": "Bu e-postaya ait zaten bir hesap var.",
    "Confirm Sign In": "Oturum A\xe7may\u0131 Do\u011Frula",
    "Have an account? ": "Hesab\u0131n\u0131z var m\u0131? ",
    "Incorrect username or password": "Yanl\u0131\u015F kullan\u0131c\u0131 ad\u0131 ya da \u015Fifre",
    "Invalid password format": "Ge\xe7ersiz parola format\u0131",
    "Invalid phone number format": "Ge\xe7ersiz telefon numaras\u0131 format\u0131",
    "Lost your code? ": "Kodu mu kaybettiniz? ",
    "No account? ": "Hesab\u0131n\u0131z yok mu? ",
    "Password attempts exceeded": "Maksimum oturum a\xe7ma giri\u015Fimi a\u015F\u0131ld\u0131",
    "Sign Out": "\xc7\u0131k\u0131\u015F yap",
    "Sign Up": "Kay\u0131t Ol",
    "User already exists": "Bu kullan\u0131c\u0131 zaten var",
    "User does not exist": "B\xf6yle bir kullan\u0131c\u0131 mevcut de\u011Fil",
    "Username cannot be empty": "Kullan\u0131c\u0131 ad\u0131 bo\u015F olamaz"
};


const $f57f2c6ec1aa2884$export$6240aeddf7c74bb8 = {
    "Account recovery requires verified contact information": "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438",
    "Back to Sign In": "\u041D\u0430\u0437\u0430\u0434, \u0447\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438",
    "Change Password": "\u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    Changing: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435",
    Code: "\u041A\u043E\u0434",
    "Confirm Password": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u0430\u0440\u043E\u043B\u044F",
    "Confirm Sign Up": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F",
    "Confirm SMS Code": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 CMC-\u041A\u043E\u0434",
    "Confirm TOTP Code": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 TOTP-\u041A\u043E\u0434",
    Confirm: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0442\u044C",
    "Confirmation Code": "\u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F",
    Confirming: "\u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435",
    "Create a new account": "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
    "Create Account": "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C",
    "Creating Account": "\u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C",
    "Dismiss alert": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0435",
    Email: "\u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    "Enter your code": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u041A\u043E\u0434",
    "Enter your Email": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    "Enter your phone number": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
    "Enter your username": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
    "Forgot your password?": "\u0417\u0430\u0431\u044B\u043B\u0438 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C?",
    "Hide password": "\u0421\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    "It may take a minute to arrive": "\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u043C\u043E\u0436\u0435\u0442 \u0437\u0430\u043D\u044F\u0442\u044C \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u0432\u0440\u0435\u043C\u044F",
    Loading: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430",
    "New password": "\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    or: "\u0438\u043B\u0438",
    Password: "\u041F\u0430\u0440\u043E\u043B\u044C",
    "Phone Number": "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430",
    "Resend Code": "\u041E\u0442\u043F\u0440\u0430\u0432\u044C \u0435\u0449\u0435 \u0440\u0430\u0437 \u041A\u043E\u0434",
    "Reset your password": "\u0441\u0431\u0440\u043E\u0441 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Reset your Password": "\u0441\u0431\u0440\u043E\u0441 \u0432\u0430\u0448 \u041F\u0430\u0440\u043E\u043B\u044C",
    "Send code": "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u041A\u043E\u0434",
    "Send Code": "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u041A\u043E\u0434",
    Sending: "\u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430",
    "Setup TOTP": "\u041D\u0430\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0442\u044C TOTP",
    "Show password": "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    "Sign in to your account": "\u0437\u043D\u0430\u043A \u0432 \u0441\u0432\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
    "Sign In with Amazon": "\u0437\u043D\u0430\u043A \u0432 \u0441 Amazon",
    "Sign In with Apple": "\u0437\u043D\u0430\u043A \u0432 \u0441 Apple",
    "Sign In with Facebook": "\u0437\u043D\u0430\u043A \u0432 \u0441 Facebook",
    "Sign In with Google": "\u0437\u043D\u0430\u043A \u0432 \u0441 Google",
    "Sign in": "\u0437\u043D\u0430\u043A \u0432",
    "Sign In": "\u0437\u043D\u0430\u043A \u0432",
    "Signing in": "\u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0432",
    Skip: "\u041F\u0440\u043E\u043F\u0443\u0441\u043A\u0430\u0442\u044C",
    Submit: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C \u043D\u0430 \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u0435",
    Submitting: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0432",
    Username: "\u0418\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
    "Verify Contact": "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u043A\u043E\u043D\u0442\u0430\u043A\u0442",
    Verify: "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C",
    "We Emailed You": "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0435 \u043F\u0438\u0441\u044C\u043C\u043E",
    "We Sent A Code": "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043A\u043E\u0434",
    "We Texted You": "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    "Your code is on the way. To log in, enter the code we emailed to": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D. \u0427\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435",
    "Your code is on the way. To log in, enter the code we sent you": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D. \u0427\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u044B \u043F\u043E\u0441\u043B\u0430\u043B\u0438 \u0432\u0430\u043C",
    "Your code is on the way. To log in, enter the code we texted to": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D. \u0427\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u043C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435\u043C"
};


const $0fa691dbac85542b$export$b2ba232c100e7a36 = {
    "Account recovery requires verified contact information": "\u05E9\u05D7\u05D6\u05D5\u05E8 \u05DC\u05E7\u05D5\u05D7 \u05D3\u05D5\u05E8\u05E9 \u05E2\u05D5\u05D3 \u05DE\u05D9\u05D3\u05E2",
    "Back to Sign In": "\u05D7\u05D6\u05D5\u05E8 \u05DC\u05D4\u05E8\u05E9\u05DE\u05D4",
    "Change Password": "\u05E2\u05D3\u05DB\u05D5\u05DF \u05E1\u05D9\u05E1\u05DE\u05D0",
    Changing: "\u05DE\u05E2\u05D3\u05DB\u05DF",
    Code: "\u05E7\u05D5\u05D3",
    "Confirm Password": "\u05D0\u05E9\u05E8 \u05E1\u05D9\u05E1\u05DE\u05D0",
    "Confirm Sign Up": "\u05D0\u05E9\u05E8 \u05D4\u05E8\u05E9\u05DE\u05D4",
    "Confirm SMS Code": "\u05D0\u05E9\u05E8 sms \u05E7\u05D5\u05D3",
    "Confirm TOTP Code": "\u05D0\u05E9\u05E8 totp \u05E7\u05D5\u05D3",
    Confirm: "\u05D0\u05D9\u05E9\u05D5\u05E8",
    "Confirmation Code": "\u05D0\u05D9\u05E9\u05D5\u05E8 \u05E7\u05D5\u05D3",
    Confirming: "\u05DE\u05D0\u05E9\u05E8",
    "Create a new account": "\u05E6\u05D5\u05E8 \u05DE\u05E9\u05EA\u05DE\u05E9 \u05D7\u05D3\u05E9",
    "Create Account": "\u05E6\u05D5\u05E8 \u05DE\u05E9\u05EA\u05DE\u05E9",
    "Creating Account": "\u05D9\u05E6\u05D9\u05E8\u05EA \u05DE\u05E9\u05EA\u05DE\u05E9",
    "Dismiss alert": "\u05D4\u05E1\u05E8 \u05D4\u05EA\u05E8\u05D0\u05D4",
    Email: "\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC",
    "Enter your code": "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05D4\u05E7\u05D5\u05D3",
    "Enter your Email": "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05D4\u05DE\u05D9\u05D9\u05DC \u05E9\u05DC\u05DA",
    "Enter your phone number": "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05DE\u05E1\u05E4\u05E8 \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05E9\u05DC\u05DA",
    "Enter your username": "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05E9\u05DD \u05D4\u05DE\u05EA\u05DE\u05E9 \u05E9\u05DC\u05DA",
    "Forgot your password?": "\u05E9\u05D7\u05DB\u05EA \u05E1\u05D9\u05E1\u05DE\u05D0 ?",
    "Hide password": "\u05D4\u05E1\u05EA\u05E8 \u05E1\u05D9\u05E1\u05DE\u05D0",
    Loading: "\u05D8\u05D5\u05E2\u05DF",
    "New password": "\u05E1\u05D9\u05E1\u05DE\u05D0 \u05D7\u05D3\u05E9\u05D4",
    or: "\u05D0\u05D5\u05B9",
    Password: "\u05E1\u05D9\u05E1\u05DE\u05D0",
    "Phone Number": "\u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF",
    "Resend Code": "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3 \u05E9\u05D5\u05D1",
    "Reset your password": "\u05D0\u05E4\u05E1 \u05E1\u05D9\u05E1\u05DE\u05D0",
    "Reset your Password": "\u05D0\u05E4\u05E1 \u05E1\u05D9\u05E1\u05DE\u05D0",
    "Send code": "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3",
    "Send Code": "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3",
    Sending: "\u05E9\u05D5\u05DC\u05D7",
    "Setup TOTP": "Setup TOTP",
    "Show password": "\u05D4\u05E6\u05D2 \u05E1\u05D9\u05E1\u05DE\u05D0",
    "Sign in to your account": "\u05D4\u05EA\u05D7\u05D1\u05E8 \u05DC\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA",
    "Sign In with Amazon": "Sign In with Amazon",
    "Sign In with Apple": "Sign In with Apple",
    "Sign In with Facebook": "Sign In with Facebook",
    "Sign In with Google": "Sign In with Google",
    "Sign in": "\u05D4\u05EA\u05D7\u05D1\u05E8",
    "Sign In": "\u05D4\u05EA\u05D7\u05D1\u05E8",
    "Signing in": "\u05DE\u05EA\u05D7\u05D1\u05E8",
    Skip: "\u05D3\u05DC\u05D2",
    Submit: "\u05E9\u05DC\u05D7",
    Submitting: "\u05E9\u05D5\u05DC\u05D7",
    Username: "\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9",
    "Verify Contact": "\u05D0\u05DE\u05EA \u05D0\u05D9\u05E9 \u05E7\u05E9\u05E8",
    Verify: "\u05D0\u05DE\u05EA"
};


const $3d8119e1564aa0ac$export$373d6304c6310960 = {
    "Account recovery requires verified contact information": "\u0412\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u0454 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u043E\u0457 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u0457",
    "Back to Sign In": "\u041D\u0430\u0437\u0430\u0434 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0432\u0445\u043E\u0434\u0443",
    "Change Password": "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    Changing: "\u0417\u043C\u0456\u043D\u044E\u0454\u043C\u043E",
    Code: "\u041A\u043E\u0434",
    "Confirm Password": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C",
    "Confirm Sign Up": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044E",
    "Confirm SMS Code": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C SMS \u043A\u043E\u0434",
    "Confirm TOTP Code": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C TOTP \u043A\u043E\u0434",
    Confirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
    "Confirmation Code": "\u041A\u043E\u0434 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F",
    Confirming: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0443\u0454\u043C\u043E",
    "Create a new account": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F",
    "Create Account": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F",
    "Creating Account": "\u0420\u0435\u0454\u0441\u0442\u0440\u0443\u0454\u043C\u043E",
    "Dismiss alert": "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F",
    Email: "Email",
    "Enter your code": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434",
    "Enter your Email": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0430\u0448 email",
    "Enter your phone number": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0430\u0448 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    "Enter your username": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0430\u0448\u0435 \u0456\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
    "Forgot password?": "\u0417\u0430\u0431\u0443\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?",
    "Forgot your password?": "\u0417\u0430\u0431\u0443\u043B\u0438 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C?",
    "Hide password": "\u0421\u0445\u043E\u0432\u0430\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "It may take a minute to arrive": "\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u043C\u043E\u0436\u0435 \u0442\u0440\u0438\u0432\u0430\u0442\u0438 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
    Loading: "\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0454\u043C\u043E",
    "New password": "\u041D\u043E\u0432\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    or: "\u0430\u0431\u043E",
    Password: "\u041F\u0430\u0440\u043E\u043B\u044C",
    "Phone Number": "\u041D\u043E\u043C\u0435\u0440 \u0422\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    "Resend Code": "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
    "Reset your password": "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Reset your Password": "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Send code": "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434",
    "Send Code": "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434",
    Sending: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u044F\u0454\u043C\u043E",
    "Setup TOTP": "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u0442\u0438 TOTP",
    "Show password": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Sign in to your account": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0443 \u0432\u0430\u0448 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441",
    "Sign In with Amazon": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Amazon",
    "Sign In with Apple": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Apple",
    "Sign In with Facebook": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Facebook",
    "Sign In with Google": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Google",
    "Sign in": "\u0423\u0432\u0456\u0439\u0442\u0438",
    "Sign In": "\u0423\u0432\u0456\u0439\u0442\u0438",
    "Signing in": "\u0412\u0445\u043E\u0434\u0438\u043C\u043E",
    Skip: "\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u0438",
    Submit: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438",
    Submitting: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u044F\u0454\u043C\u043E",
    Username: "\u0406\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
    "Verify Contact": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u041A\u043E\u043D\u0442\u0430\u043A\u0442",
    Verify: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
    "We Emailed You": "\u041C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C Email",
    "We Sent A Code": "\u041C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043A\u043E\u0434",
    "We Texted You": "\u041C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
    "Your code is on the way. To log in, enter the code we emailed to": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u0432\u0436\u0435 \u0432 \u0434\u043E\u0440\u043E\u0437\u0456. \u0429\u043E\u0431 \u0443\u0432\u0456\u0439\u0442\u0438, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434, \u0449\u043E \u043C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u043D\u0430 Email",
    "Your code is on the way. To log in, enter the code we sent you": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u0432\u0436\u0435 \u0432 \u0434\u043E\u0440\u043E\u0437\u0456. \u0429\u043E\u0431 \u0443\u0432\u0456\u0439\u0442\u0438, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434, \u0449\u043E \u043C\u0438 \u0432\u0430\u043C \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438",
    "Your code is on the way. To log in, enter the code we texted to": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u0432\u0436\u0435 \u0432 \u0434\u043E\u0440\u043E\u0437\u0456. \u0429\u043E\u0431 \u0443\u0432\u0456\u0439\u0442\u0438, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434, \u0449\u043E \u043C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u0438\u043C \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F\u043C",
    // Additional translations
    "An account with the given email already exists.": "\u041E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441 \u0437 \u0446\u0438\u043C Email \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454.",
    "Confirm a Code": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u043A\u043E\u0434",
    "Confirm Sign In": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u0432\u0445\u0456\u0434",
    "Forgot Password": "\u0417\u0430\u0431\u0443\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Incorrect username or password.": "\u041D\u0435\u0432\u0456\u0440\u043D\u0435 \u0456\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u0430\u0431\u043E \u043F\u0430\u0440\u043E\u043B\u044C",
    "Invalid password format": "\u041D\u0435\u0432\u0456\u0440\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043F\u0430\u0440\u043E\u043B\u044E",
    "Invalid phone number format": "\u041D\u0435\u0432\u0456\u0440\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043D\u043E\u043C\u0435\u0440\u0443 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
    "Loading...": "\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0454\u043C\u043E...",
    "New Password": "\u041D\u043E\u0432\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Resend a Code": "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
    "Reset Password": "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
    "Sign Out": "\u0412\u0438\u0439\u0442\u0438",
    "Sign Up with Amazon": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Amazon",
    "Sign Up with Apple": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Apple",
    "Sign Up with Facebook": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Facebook",
    "Sign Up with Google": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Google",
    "Sign Up": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F",
    "User already exists": "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454",
    "User does not exist": "\u0422\u0430\u043A\u0438\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u043D\u0435 \u0456\u0441\u043D\u0443\u0454",
    "Username cannot be empty": "\u0406\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u0443\u0441\u0442\u0438\u043C",
    "Your passwords must match": "\u041F\u0430\u0440\u043E\u043B\u0456 \u043C\u0430\u044E\u0442\u044C \u0437\u0431\u0456\u0433\u0430\u0442\u0438\u0441\u044F"
};


const $0517764235f6ce3b$export$320d289eca4cc695 = {
    ADD_PROFILE: "Add your Profile",
    ADD_WEBSITE: "Add your Website",
    BACK_SIGN_IN: "Back to Sign In",
    BIRTHDATE: "Birthdate",
    CHANGE_PASSWORD: "Change Password",
    CHANGING_PASSWORD: "Changing",
    CODE: "Code",
    CODE_ARRIVAL: "It may take a minute to arrive",
    CODE_EMAILED: "Your code is on the way. To log in, enter the code we emailed to",
    CODE_SENT: "Your code is on the way. To log in, enter the code we sent you",
    CODE_TEXTED: "Your code is on the way. To log in, enter the code we texted to",
    CONFIRM_PASSWORD: "Confirm Password",
    CONFIRM_PASSWORD_PLACEHOLDER: "Please confirm your Password",
    CONFIRM_RESET_PASSWORD_HEADING: "Reset your Password",
    CONFIRM_SIGNUP_HEADING: "Confirm Sign Up",
    CONFIRM_SMS: "Confirm SMS Code",
    CONFIRM_TOTP: "Confirm TOTP Code",
    CONFIRM: "Confirm",
    CONFIRMATION_CODE: "Confirmation Code",
    CONFIRMING: "Confirming",
    CREATE_ACCOUNT: "Create Account",
    CREATING_ACCOUNT: "Creating Account",
    EMAIL_ADDRESS: "Email",
    ENTER_BIRTHDATE: "Enter your Birthdate",
    ENTER_CODE: "Enter your code",
    ENTER_CONFIRMATION_CODE: "Enter your Confirmation Code",
    ENTER_EMAIL: "Enter your Email",
    ENTER_FAMILY_NAME: "Enter your Family Name",
    ENTER_GIVEN_NAME: "Enter your Given Name",
    ENTER_MIDDLE_NAME: "Enter your Middle Name",
    ENTER_NAME: "Enter your Name",
    ENTER_NICK_NAME: "Enter your Nickname",
    ENTER_PASSWORD: "Enter your Password",
    ENTER_PHONE_NUMBER: "Enter your Phone Number",
    ENTER_PREFERRED_USERNAME: "Enter your Preferred Username",
    ENTER_USERNAME: "Enter your username",
    FAMILY_NAME: "Family Name",
    GIVEN_NAME: "Given Name",
    FORGOT_PASSWORD: "Forgot Password?",
    FORGOT_YOUR_PASSWORD: "Forgot your password?",
    HIDE_PASSWORD: "Hide password",
    LOADING: "Loading",
    LOGIN_NAME: "Username",
    MIDDLE_NAME: "Middle Name",
    NAME: "Name",
    NICKNAME: "Nickname",
    NEW_PASSWORD: "New password",
    OR: "or",
    PASSWORD: "Password",
    PHONE_NUMBER: "Phone Number",
    PREFERRED_USERNAME: "Preferred Username",
    PROFILE: "Profile",
    RESEND_CODE: "Resend Code",
    RESET_PASSWORD_HEADING: "Reset your password",
    RESET_PASSWORD: "Reset Password",
    SEND_CODE: "Send code",
    SENDING: "Sending",
    SETUP_TOTP: "Setup TOTP",
    SHOW_PASSWORD: "Show password",
    SIGN_IN_BUTTON: "Sign in",
    SIGN_IN_TAB: "Sign In",
    SIGN_IN_WITH_AMAZON: "Sign In with Amazon",
    SIGN_IN_WITH_APPLE: "Sign In with Apple",
    SIGN_IN_WITH_FACEBOOK: "Sign In with Facebook",
    SIGN_IN_WITH_GOOGLE: "Sign In with Google",
    SIGN_IN: "Sign in to your account",
    SIGN_UP_BUTTON: "Create a new account",
    SIGNING_IN_BUTTON: "Signing in",
    SKIP: "Skip",
    SUBMIT: "Submit",
    SUBMITTING: "Submitting",
    UPPERCASE_COPY: "COPY",
    VERIFY_CONTACT: "Verify Contact",
    VERIFY_HEADING: "Account recovery requires verified contact information",
    VERIFY: "Verify",
    WE_EMAILED: "We Emailed You",
    WE_SENT_CODE: "We Sent A Code",
    WE_TEXTED: "We Texted You",
    WEBSITE: "Website"
};


//merge all the new module translations in respective locale constants
const $f07b116587857f7e$export$cca4a41bdb910c51 = {
    ...(0, $949281bda546086b$export$cca4a41bdb910c51)
};
const $f07b116587857f7e$export$eb91f595f110d703 = {
    ...(0, $28d0399a987ec85f$export$eb91f595f110d703)
};
const $f07b116587857f7e$export$1d204a99f5862ba9 = {
    ...(0, $a55ced3cdf989f13$export$1d204a99f5862ba9)
};
const $f07b116587857f7e$export$8cfa91bfcf8d11c8 = {
    ...(0, $da787d2c2c7c5644$export$8cfa91bfcf8d11c8)
};
const $f07b116587857f7e$export$5c8da73de176fccc = {
    ...(0, $a52e8a8f52715173$export$5c8da73de176fccc)
};
const $f07b116587857f7e$export$c416809cd76fbf21 = {
    ...(0, $2d261b7529ec3242$export$c416809cd76fbf21)
};
const $f07b116587857f7e$export$fb1930c2b96707b2 = {
    ...(0, $e6593af80e9588eb$export$fb1930c2b96707b2)
};
const $f07b116587857f7e$export$c27bce1749452052 = {
    ...(0, $f5ad9f9c93b4b97a$export$c27bce1749452052)
};
const $f07b116587857f7e$export$8569df33fbaae243 = {
    ...(0, $3ca8e16c22a22216$export$8569df33fbaae243)
};
const $f07b116587857f7e$export$6fb0e8139f7ef98d = {
    ...(0, $5e42e1c7a431641b$export$6fb0e8139f7ef98d)
};
const $f07b116587857f7e$export$c7dddbf179b434d1 = {
    ...(0, $9364c903fedc8336$export$c7dddbf179b434d1)
};
const $f07b116587857f7e$export$2a86dc37ee9734c = {
    ...(0, $ab0f63092fa060f9$export$2a86dc37ee9734c)
};
const $f07b116587857f7e$export$9f1a61f9baaa2d2e = {
    ...(0, $a66485d94301bbc3$export$9f1a61f9baaa2d2e)
};
const $f07b116587857f7e$export$710642024bfcbd8f = {
    ...(0, $0a782ee75702b170$export$710642024bfcbd8f)
};
const $f07b116587857f7e$export$6961fa2059aeacf0 = {
    ...(0, $a1b19d75b58dd5bf$export$6961fa2059aeacf0)
};
const $f07b116587857f7e$export$6240aeddf7c74bb8 = {
    ...(0, $f57f2c6ec1aa2884$export$6240aeddf7c74bb8)
};
const $f07b116587857f7e$export$b2ba232c100e7a36 = {
    ...(0, $0fa691dbac85542b$export$b2ba232c100e7a36)
};
const $f07b116587857f7e$export$373d6304c6310960 = {
    ...(0, $3d8119e1564aa0ac$export$373d6304c6310960)
};
const $f07b116587857f7e$export$320d289eca4cc695 = {
    ...(0, $0517764235f6ce3b$export$320d289eca4cc695)
};


/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /**
 * Contains translatable strings that authenticator provides by default. Customers
 * can use this to add custom vocabularies:
 *
 * ```
 * I18n.putVocabulariesForLanguage("en", {
 *  [DefaultTexts.SIGN_IN]: "Custom Sign In Text",
 *  [DefaultTexts.SIGN_IN_BUTTON]: "Custom Click Here to Sign In"
 * });
 * ```
 */ const $c4e69119c3aaed8b$export$6ba37fd455cdd594 = {
    ...(0, $f07b116587857f7e$export$320d289eca4cc695)
};
/**
 * This helper type checks that given phrase is one of the texts @aws-amplify/ui
 * provides by default. This enables vscode autocompletion to help catch typos
 * during development.
 *
 * You can also use translate<string> to handle custom strings or dynamic content.
 */ function $c4e69119c3aaed8b$export$d73ee8ef04f5226a(phrase) {
    return (0, $0fe07bf7356162c8$export$dbe3113d60765c1a).get(phrase);
}
/**
 * Whether I18n has a translation entry for given phrase
 */ function $c4e69119c3aaed8b$export$8a4bbd9646545970(phrase) {
    return (0, $0fe07bf7356162c8$export$dbe3113d60765c1a).get(phrase) !== phrase;
}
const $c4e69119c3aaed8b$export$150b732325d14d04 = {
    de: (0, $f07b116587857f7e$export$cca4a41bdb910c51),
    en: (0, $f07b116587857f7e$export$eb91f595f110d703),
    es: (0, $f07b116587857f7e$export$1d204a99f5862ba9),
    fr: (0, $f07b116587857f7e$export$8cfa91bfcf8d11c8),
    id: (0, $f07b116587857f7e$export$710642024bfcbd8f),
    it: (0, $f07b116587857f7e$export$5c8da73de176fccc),
    ja: (0, $f07b116587857f7e$export$c416809cd76fbf21),
    // TODO: remove kr in next major release
    kr: (0, $f07b116587857f7e$export$fb1930c2b96707b2),
    ko: (0, $f07b116587857f7e$export$fb1930c2b96707b2),
    nb: (0, $f07b116587857f7e$export$c27bce1749452052),
    nl: (0, $f07b116587857f7e$export$8569df33fbaae243),
    pl: (0, $f07b116587857f7e$export$6fb0e8139f7ef98d),
    pt: (0, $f07b116587857f7e$export$c7dddbf179b434d1),
    zh: (0, $f07b116587857f7e$export$2a86dc37ee9734c),
    sv: (0, $f07b116587857f7e$export$9f1a61f9baaa2d2e),
    tr: (0, $f07b116587857f7e$export$6961fa2059aeacf0),
    ru: (0, $f07b116587857f7e$export$6240aeddf7c74bb8),
    he: (0, $f07b116587857f7e$export$b2ba232c100e7a36),
    ua: (0, $f07b116587857f7e$export$373d6304c6310960)
};


const $893db1a7809c2294$export$65f2c683ca9e9a02 = (state)=>{
    const loginMechanisms = state?.context.config?.loginMechanisms;
    /**
     * @migration this is where we grab only the first index of `aws_cognito_username_attributes`
     */ const [primaryAlias] = loginMechanisms ?? [
        "username"
    ];
    return primaryAlias;
};
/** Applies translations to label and placeholder */ const $893db1a7809c2294$export$850c34c1087496e6 = (formFields)=>{
    const newFormFields = {
        ...formFields
    };
    for (const [name, options] of Object.entries(formFields)){
        const { label: label, placeholder: placeholder } = options;
        newFormFields[name] = {
            ...options,
            label: label ? (0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)(label) : undefined,
            placeholder: placeholder ? (0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)(placeholder) : undefined
        };
    }
    return newFormFields;
};
/** Sorts formFields according to their `order`.  */ const $893db1a7809c2294$export$c610ae674f32e5d9 = (formFields)=>{
    return Object.entries(formFields).sort((a, b)=>{
        const orderA = a[1].order || Number.MAX_VALUE;
        const orderB = b[1].order || Number.MAX_VALUE;
        return orderA - orderB;
    }).filter((formFieldEntry)=>formFieldEntry[1] !== undefined);
};


/**
 * This file contains helpers that generate default formFields for each screen
 */ const $6b44f2664c79771f$export$7baaffefa21dec1 = "+1";
/** Helper function that gets the default formField for given field name */ const $6b44f2664c79771f$var$getDefaultFormField = (fieldName)=>{
    let options = (0, $25b29aa90ff40796$export$1222d357a3c2c47f)[fieldName];
    const { type: type } = options;
    if (type === "tel") options = {
        ...options,
        dialCode: $6b44f2664c79771f$export$7baaffefa21dec1
    };
    return options;
};
// Helper function that returns default form field for configured primary alias
const $6b44f2664c79771f$export$447e18c20e391f9 = (state)=>{
    const primaryAlias = (0, $893db1a7809c2294$export$65f2c683ca9e9a02)(state);
    return {
        ...$6b44f2664c79771f$var$getDefaultFormField(primaryAlias),
        autocomplete: "username"
    };
};
/** Reusable confirmation code form fields. */ const $6b44f2664c79771f$var$getConfirmationCodeFormFields = (state)=>({
        confirmation_code: {
            ...$6b44f2664c79771f$var$getDefaultFormField("confirmation_code"),
            label: "Code *",
            placeholder: "Code"
        }
    });
const $6b44f2664c79771f$var$getSignInFormFields = (state)=>({
        username: {
            ...$6b44f2664c79771f$export$447e18c20e391f9(state)
        },
        password: {
            ...$6b44f2664c79771f$var$getDefaultFormField("password"),
            autocomplete: "current-password"
        }
    });
const $6b44f2664c79771f$var$getSignUpFormFields = (state)=>{
    const { loginMechanisms: loginMechanisms, signUpAttributes: signUpAttributes } = state.context.config;
    const primaryAlias = (0, $893db1a7809c2294$export$65f2c683ca9e9a02)(state);
    /**
     * @migration signUp Fields created here
     */ const fieldNames = Array.from(new Set([
        ...loginMechanisms,
        "password",
        "confirm_password",
        ...signUpAttributes
    ]));
    const formField = {};
    for (const fieldName of fieldNames)if ((0, $52c3d4b500c29b83$export$3237178b1c616b9f)(fieldName)) {
        const fieldAttrs = fieldName === primaryAlias ? $6b44f2664c79771f$export$447e18c20e391f9(state) : $6b44f2664c79771f$var$getDefaultFormField(fieldName);
        formField[fieldName] = {
            ...fieldAttrs
        };
    } else // There's a `custom:*` attribute or one we don't already have an implementation for
    console.debug(`Authenticator does not have a default implementation for ${fieldName}. Customize SignUp FormFields to add your own.`);
    return formField;
};
const $6b44f2664c79771f$var$getConfirmSignUpFormFields = (state)=>({
        confirmation_code: {
            ...$6b44f2664c79771f$var$getDefaultFormField("confirmation_code"),
            placeholder: "Enter your code"
        }
    });
const $6b44f2664c79771f$var$getForgotPasswordFormFields = (state)=>{
    const primaryAlias = (0, $893db1a7809c2294$export$65f2c683ca9e9a02)(state);
    const { label: label } = (0, $25b29aa90ff40796$export$1222d357a3c2c47f)[primaryAlias];
    return {
        username: {
            ...$6b44f2664c79771f$export$447e18c20e391f9(state),
            label: `Enter your ${label.toLowerCase()}`,
            placeholder: `Enter your ${label.toLowerCase()}`
        }
    };
};
const $6b44f2664c79771f$var$getConfirmResetPasswordFormFields = (state)=>({
        ...$6b44f2664c79771f$var$getConfirmationCodeFormFields(),
        password: {
            ...$6b44f2664c79771f$var$getDefaultFormField("password"),
            label: "New Password",
            placeholder: "New Password"
        },
        confirm_password: {
            ...$6b44f2664c79771f$var$getDefaultFormField("confirm_password"),
            label: "Confirm Password",
            placeholder: "Confirm Password"
        }
    });
const $6b44f2664c79771f$var$getForceNewPasswordFormFields = (state)=>{
    const actorState = (0, $e6ed0af0cac01aca$export$99a4282e2c3b772d)(state);
    const { missingAttributes: missingAttributes } = actorState.context;
    const fieldNames = Array.from(new Set([
        "password",
        "confirm_password",
        ...missingAttributes ?? []
    ]));
    const formField = {};
    for (const fieldName of fieldNames)if ((0, $52c3d4b500c29b83$export$3237178b1c616b9f)(fieldName)) formField[fieldName] = {
        ...$6b44f2664c79771f$var$getDefaultFormField(fieldName)
    };
    else // There's a `custom:*` attribute or one we don't already have an implementation for
    console.debug(`Authenticator does not have a default implementation for ${fieldName}. Customize ForceNewPassword FormFields to add your own.`);
    return formField;
};
/** Collect all the defaultFormFields getters */ const $6b44f2664c79771f$export$9bcaa03841470ad7 = {
    signIn: $6b44f2664c79771f$var$getSignInFormFields,
    signUp: $6b44f2664c79771f$var$getSignUpFormFields,
    confirmSignUp: $6b44f2664c79771f$var$getConfirmSignUpFormFields,
    confirmSignIn: $6b44f2664c79771f$var$getConfirmationCodeFormFields,
    forceNewPassword: $6b44f2664c79771f$var$getForceNewPasswordFormFields,
    forgotPassword: $6b44f2664c79771f$var$getForgotPasswordFormFields,
    confirmResetPassword: $6b44f2664c79771f$var$getConfirmResetPasswordFormFields,
    confirmVerifyUser: $6b44f2664c79771f$var$getConfirmationCodeFormFields,
    setupTotp: $6b44f2664c79771f$var$getConfirmationCodeFormFields
};



// Gets the default formFields for given route
const $0e8e4cc37a373675$export$bafc1c085dad2945 = (route, state)=>{
    const formFieldGetter = (0, $6b44f2664c79771f$export$9bcaa03841470ad7)[route];
    return formFieldGetter(state);
};
// Gets custom formFields, and applies default values
const $0e8e4cc37a373675$export$40c1faef715b9f52 = (route, state)=>{
    const customFormFields = (0, $e6ed0af0cac01aca$export$c39505fa2700473f)(state)?.formFields?.[route];
    if (!customFormFields || Object.keys(customFormFields).length === 0) return {};
    return Object.entries(customFormFields).reduce((acc, [fieldName, customOptions])=>{
        if ((route === "signIn" || route === "forgotPassword") && fieldName === "username") {
            // Unlike other screens, `signIn` and `forgotPassword` screens default login
            // alias field names to "username", even if it's a phone number or email.
            // In this case, we get the default formFieldOptions based on loginMechanism.
            const defaultOptions = (0, $6b44f2664c79771f$export$447e18c20e391f9)(state);
            // apply default to fill any gaps that are not present in customOptions
            const mergedOptions = {
                ...defaultOptions,
                ...customOptions
            };
            return {
                ...acc,
                [fieldName]: mergedOptions
            };
        } else if ((0, $bc9614d2c13cf9d8$export$fed672849e2dd0ad)(fieldName)) {
            // if this field is a known auth attribute that we have defaults for,
            // apply defaults to customOptions.
            const defaultOptions = (0, $25b29aa90ff40796$export$1222d357a3c2c47f)[fieldName];
            const mergedOptions = {
                ...defaultOptions,
                ...customOptions
            };
            return {
                ...acc,
                [fieldName]: mergedOptions
            };
        } else // if this is not a known field, use customOptions as is.
        return {
            ...acc,
            [fieldName]: customOptions
        };
    }, {});
};
const $0e8e4cc37a373675$export$5e097831852eb087 = (route, state)=>{
    const defaultFormFields = $0e8e4cc37a373675$export$bafc1c085dad2945(route, state);
    const customFormFields = $0e8e4cc37a373675$export$40c1faef715b9f52(route, state);
    const formFields = {
        ...defaultFormFields,
        ...customFormFields
    };
    delete formFields["QR"];
    return (0, $893db1a7809c2294$export$850c34c1087496e6)(formFields);
};
const $0e8e4cc37a373675$export$8f6c429ad9970441 = (formFields)=>formFields.map((field)=>{
        const key = field[0];
        // Drop order key to prevent passing to form field UI components
        const values = {
            ...field[1],
            order: undefined
        };
        return [
            key,
            values
        ];
    });
/** Calls `getFormFields` above, then sorts it into an indexed array */ const $0e8e4cc37a373675$export$2fcee3580f06a0ca = (route, state)=>{
    const formFields = $0e8e4cc37a373675$export$5e097831852eb087(route, state);
    return $0e8e4cc37a373675$export$8f6c429ad9970441((0, $893db1a7809c2294$export$c610ae674f32e5d9)(formFields));
};


const $2180df419f0aaab8$export$297d226dd86a0de7 = [
    "confirmResetPassword",
    "confirmSignIn",
    "confirmSignUp",
    "confirmVerifyUser",
    "forceNewPassword",
    "forgotPassword",
    "setupTotp",
    "signIn",
    "signUp",
    "verifyUser"
];
const $2180df419f0aaab8$export$8ccdb5ff21fda761 = [
    "ConfirmResetPassword",
    "ConfirmSignIn",
    "ConfirmSignUp",
    "ConfirmVerifyUser",
    "ForceNewPassword",
    "ForgotPassword",
    "SetupTotp",
    "SignIn",
    "SignUp",
    "VerifyUser"
];


const $5ce8d39e39d5d91f$export$65443658c81b32cc = (route)=>(0, $2180df419f0aaab8$export$297d226dd86a0de7).some((componentRoute)=>componentRoute === route);
function $5ce8d39e39d5d91f$export$a909c85e22b33d81(defaults, overrides) {
    if (!overrides) return defaults;
    return (0, $2180df419f0aaab8$export$8ccdb5ff21fda761).reduce((components, route)=>{
        const Default = defaults[route];
        const Override = overrides[route];
        if (typeof Override !== "function") return {
            ...components,
            [route]: Default
        };
        const { Footer: Footer, FormFields: FormFields, Header: Header } = Default;
        // cast to allow assigning of component slots
        const Component = Override;
        Component.Footer = Footer;
        Component.FormFields = FormFields;
        Component.Header = Header;
        return {
            ...components,
            [route]: Component
        };
    }, {});
}


const $30d2148c4d39f97e$export$6756c954b2014a15 = ()=>false;
/**
 * Does an ordering and shallow comparison of each array value,
 * plus a value equality check for empty objects and arrays.
 */ function $30d2148c4d39f97e$export$6d39b5fae5236692(currentDeps, nextDeps) {
    if (currentDeps.length !== nextDeps.length) return false;
    return currentDeps.every((currentDep, index)=>{
        const nextDep = nextDeps[index];
        if ((0, $697901644f774aa4$export$2c02be4a78959098)(currentDep, nextDep) || (0, $697901644f774aa4$export$d6708a3543c32fe4)(currentDep, nextDep)) return true;
        return currentDep === nextDep;
    });
}
const $30d2148c4d39f97e$export$1f14d6e84ea4650a = (selector)=>(currentFacade, nextFacade)=>{
        const currentSelectorDeps = selector(currentFacade);
        const nextSelectorDeps = selector(nextFacade);
        // Shallow compare the array values
        return $30d2148c4d39f97e$export$6d39b5fae5236692(currentSelectorDeps, nextSelectorDeps);
    };
const $30d2148c4d39f97e$export$4680a6e0cbf2b7d7 = (state)=>({
        ...(0, $e6ed0af0cac01aca$export$c39505fa2700473f)(state)?.formFields?.setupTotp?.QR
    });
const $30d2148c4d39f97e$var$flattenFormFields = (fields)=>fields.flatMap(([name, options])=>({
            name: name,
            ...options
        }));
const $30d2148c4d39f97e$var$convertContactMethodsToFields = (unverifiedUserAttributes)=>{
    return unverifiedUserAttributes && Object.entries(unverifiedUserAttributes).map(([name, value])=>{
        const valueIsString = (0, $697901644f774aa4$export$844ec244b1367d54)(value);
        if (!valueIsString || !name) return {};
        return {
            name: name,
            label: value,
            type: "radio",
            value: value
        };
    });
};
/**
 * Retrieves default and custom (RWA only, to be updated) form field values from state machine
 * for subcomponent routes that render fields
 */ const $30d2148c4d39f97e$export$e72db6842cb587a1 = (route, state, unverifiedUserAttributes)=>{
    if ((0, $5ce8d39e39d5d91f$export$65443658c81b32cc)(route)) return route === "verifyUser" ? $30d2148c4d39f97e$var$convertContactMethodsToFields(unverifiedUserAttributes) : $30d2148c4d39f97e$var$flattenFormFields((0, $0e8e4cc37a373675$export$2fcee3580f06a0ca)(route, state));
    return [];
};


/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/connected-components/authenticator/headless#useauthenticator-hook)
 */ function $61b5de0b744cce38$export$2e2bcd8739ae039(selector) {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).useContext((0, $67c19c14dd3378a0$export$2254a7bd02a5abf7));
    if (!context) throw new Error((0, $902231e0cfebd97f$export$7e92b2e9f0809b11));
    const { service: service } = context;
    const { send: send } = service;
    const xstateSelector = (0, $1T1QG.useCallback)((state)=>({
            ...(0, $449563f0d6e3e7c2$export$5f925d5954b1c10b)({
                send: send,
                state: state
            })
        }), [
        send
    ]);
    const comparator = selector ? (0, $30d2148c4d39f97e$export$1f14d6e84ea4650a)(selector) : (0, $30d2148c4d39f97e$export$6756c954b2014a15);
    // the purpose of `context.authStatus`is to intentionally override `facade.authStatus`. `facade.authStatus` does
    // not update on external sign in events (for example when a user is not using the `Authenticator`).
    const { authStatus: authStatus } = context;
    const facade = (0, $898a36eb72506f2a$export$2105062e25df4afe)(service, xstateSelector, comparator);
    const { route: route, totpSecretCode: totpSecretCode, unverifiedUserAttributes: unverifiedUserAttributes, user: user, ...rest } = facade;
    // do not memoize output. `service.getSnapshot` reference remains stable preventing
    // `fields` from updating with current form state on value changes
    const serviceSnapshot = service.getSnapshot();
    // legacy `QRFields` values only used for SetupTotp page to retrieve issuer information, will be removed in future
    const QRFields = route === "setupTotp" ? (0, $30d2148c4d39f97e$export$4680a6e0cbf2b7d7)(serviceSnapshot) : null;
    // legacy `formFields` values required until form state is removed from state machine
    const fields = (0, $30d2148c4d39f97e$export$e72db6842cb587a1)(route, serviceSnapshot, unverifiedUserAttributes);
    return {
        ...rest,
        authStatus: authStatus,
        route: route,
        totpSecretCode: totpSecretCode,
        unverifiedUserAttributes: unverifiedUserAttributes,
        user: user,
        fields: /** @deprecated For internal use only */ fields,
        QRFields: QRFields
    };
}


var $1T1QG = parcelRequire("1T1QG");

// only select `route` from machine context
const $98444ee845bd102f$export$55f632bbdf6d0e4 = ({ route: route })=>[
        route
    ];
function $98444ee845bd102f$export$2e2bcd8739ae039(data) {
    const { route: route, initializeMachine: initializeMachine } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)($98444ee845bd102f$export$55f632bbdf6d0e4);
    const hasInitialized = (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).useEffect(()=>{
        if (!hasInitialized.current && route === "setup") {
            initializeMachine(data);
            hasInitialized.current = true;
        }
    }, [
        initializeMachine,
        route,
        data
    ]);
}


var $1T1QG = parcelRequire("1T1QG");


const $0eef36f11780235e$export$f0e53cf2fcbe6801 = {
    apis: [
        (0, $46bbfb42d61f6c30$export$900b1436d7e65f4).DeleteUser,
        (0, $46bbfb42d61f6c30$export$900b1436d7e65f4).UpdatePassword
    ],
    category: (0, $46bbfb42d61f6c30$export$3a8840c5b2ecf003).Auth
};
const $0eef36f11780235e$export$b4592dada0e918ed = {
    apis: [
        (0, $46bbfb42d61f6c30$export$900b1436d7e65f4).SignUp,
        (0, $46bbfb42d61f6c30$export$900b1436d7e65f4).ConfirmSignUp,
        (0, $46bbfb42d61f6c30$export$900b1436d7e65f4).ResendSignUpCode,
        (0, $46bbfb42d61f6c30$export$900b1436d7e65f4).SignIn,
        (0, $46bbfb42d61f6c30$export$900b1436d7e65f4).ConfirmSignIn,
        (0, $46bbfb42d61f6c30$export$900b1436d7e65f4).FetchUserAttributes,
        (0, $46bbfb42d61f6c30$export$900b1436d7e65f4).SignOut,
        (0, $46bbfb42d61f6c30$export$900b1436d7e65f4).ResetPassword,
        (0, $46bbfb42d61f6c30$export$900b1436d7e65f4).ConfirmResetPassword,
        (0, $46bbfb42d61f6c30$export$900b1436d7e65f4).SignInWithRedirect
    ],
    category: (0, $46bbfb42d61f6c30$export$3a8840c5b2ecf003).Auth
};
const $0eef36f11780235e$export$9350eeaf9304c617 = {
    apis: [
        (0, $46bbfb42d61f6c30$export$c01a8c16ffda791e).NotifyMessageInteraction
    ],
    category: (0, $46bbfb42d61f6c30$export$3a8840c5b2ecf003).InAppMessaging
};
const $0eef36f11780235e$export$9ec4d9b90e0651f3 = {
    category: (0, $46bbfb42d61f6c30$export$3a8840c5b2ecf003).Geo,
    apis: [
        (0, $46bbfb42d61f6c30$export$afafab3eb8fc6fef).SearchByText,
        (0, $46bbfb42d61f6c30$export$afafab3eb8fc6fef).SearchForSuggestions,
        (0, $46bbfb42d61f6c30$export$afafab3eb8fc6fef).SearchByPlaceId
    ]
};
const $0eef36f11780235e$export$8b6b593c0f557e5e = {
    category: (0, $46bbfb42d61f6c30$export$3a8840c5b2ecf003).Geo,
    apis: []
};
const $0eef36f11780235e$export$5650166bd1af1e38 = {
    apis: [
        (0, $46bbfb42d61f6c30$export$d4f3c54b808b00ce).UploadData
    ],
    category: (0, $46bbfb42d61f6c30$export$3a8840c5b2ecf003).Storage
};



/**
 * @example
 * ```ts
 * // set user agent options
 * const clear = setUserAgent(input);
 *
 * // clear user agent options
 * clear();
 * ```
 */ const $ea85a7f5c1525c49$export$57d3cdb500cb5402 = ({ componentName: componentName, packageName: packageName, version: version })=>{
    const packageData = [
        `ui-${packageName}`,
        version
    ];
    switch(componentName){
        case "Authenticator":
            (0, $249caee721b519ba$export$20cd2fa9001e90da)({
                ...(0, $0eef36f11780235e$export$b4592dada0e918ed),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
        case "ChangePassword":
        case "DeleteUser":
            (0, $249caee721b519ba$export$20cd2fa9001e90da)({
                ...(0, $0eef36f11780235e$export$f0e53cf2fcbe6801),
                additionalDetails: [
                    [
                        "AccountSettings"
                    ],
                    packageData
                ]
            });
            break;
        case "InAppMessaging":
            (0, $249caee721b519ba$export$20cd2fa9001e90da)({
                ...(0, $0eef36f11780235e$export$9350eeaf9304c617),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
        case "LocationSearch":
            (0, $249caee721b519ba$export$20cd2fa9001e90da)({
                ...(0, $0eef36f11780235e$export$9ec4d9b90e0651f3),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
        case "MapView":
            (0, $249caee721b519ba$export$20cd2fa9001e90da)({
                ...(0, $0eef36f11780235e$export$8b6b593c0f557e5e),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
        case "StorageManager":
            (0, $249caee721b519ba$export$20cd2fa9001e90da)({
                ...(0, $0eef36f11780235e$export$5650166bd1af1e38),
                additionalDetails: [
                    [
                        componentName
                    ],
                    packageData
                ]
            });
            break;
    }
    return 0, $697901644f774aa4$export$8793edee2d425525;
};


function $64668a4425719fac$export$2e2bcd8739ae039({ componentName: componentName, packageName: packageName, version: version }) {
    (0, $1T1QG.useEffect)(()=>{
        const clearUserAgent = (0, $ea85a7f5c1525c49$export$57d3cdb500cb5402)({
            componentName: componentName,
            packageName: packageName,
            version: version
        });
        return clearUserAgent;
    }, [
        componentName,
        packageName,
        version
    ]);
}


const $b98b3b2c213c83ce$export$a4ad2735b021c132 = "6.0.5";



var $1T1QG = parcelRequire("1T1QG");
/**
 * Logs a deprecation warning message.
 *
 * @important Please use the React/React Native specific platform implementations.
 * This version of the hook is a base implementation that the others extend from due
 * to env differences between running in RN or the browser
 */ const $f38bbbd9ee1d6b42$export$2e2bcd8739ae039 = ({ shouldWarn: shouldWarn, message: message })=>{
    $1T1QG.useEffect(()=>{
        if (shouldWarn) // eslint-disable-next-line no-console
        console.warn(message);
    }, [
        shouldWarn,
        message
    ]);
};



var $7zvJK = parcelRequire("7zvJK");
/**
 * Logs a deprecation warning `message` to the console.
 */ const $0a6745a1edc09cca$export$406e4c8585b97b03 = ({ message: message, shouldWarn: _shouldWarn })=>{
    const shouldWarn = _shouldWarn && // show message on builds without Node `process` polyfill
    // or with process.env.NODE_ENV not production
    (typeof $7zvJK === "undefined" || $7zvJK && false);
    (0, $f38bbbd9ee1d6b42$export$2e2bcd8739ae039)({
        message: message,
        shouldWarn: shouldWarn
    });
};



var $1T1QG = parcelRequire("1T1QG");
const $568dae17aa196294$export$da5ac45a736a5880 = // @ts-ignore
$1T1QG.createContext(null);
const $568dae17aa196294$export$b0e9d19f717d0a5c = ()=>{
    const context = $1T1QG.useContext($568dae17aa196294$export$da5ac45a736a5880);
    if (!context) throw new Error("`useCustomComponents` cannot be used outside of a `CustomComponentsContext.Provider`");
    return context;
};




var $1T1QG = parcelRequire("1T1QG");


var $1T1QG = parcelRequire("1T1QG");

/**
 * ConfirmSignIn
 */ const $24044d7e72f9876b$var$getChallengeText = (challengeName)=>{
    switch(challengeName){
        case "SMS_MFA":
            return (0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).CONFIRM_SMS);
        case "SOFTWARE_TOKEN_MFA":
            return (0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).CONFIRM_TOTP);
        default:
            throw new Error(`${(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)("Unexpected challengeName encountered in ConfirmSignIn:")} ${challengeName}`);
    }
};
/**
 * ConfirmSignUp
 */ const $24044d7e72f9876b$var$getDeliveryMessageText = (codeDeliveryDetails)=>{
    const { DeliveryMedium: DeliveryMedium, Destination: Destination } = codeDeliveryDetails ?? {};
    const isEmailMessage = DeliveryMedium === "EMAIL";
    const isTextMessage = DeliveryMedium === "SMS";
    const arrivalMessage = (0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).CODE_ARRIVAL);
    if (!(isEmailMessage || isTextMessage)) return `${(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).CODE_SENT)}. ${arrivalMessage}.`;
    const instructionMessage = isEmailMessage ? (0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).CODE_EMAILED) : (0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).CODE_TEXTED);
    return `${instructionMessage} ${Destination}. ${arrivalMessage}.`;
};
const $24044d7e72f9876b$var$getDeliveryMethodText = (codeDeliveryDetails)=>{
    const { DeliveryMedium: DeliveryMedium } = codeDeliveryDetails ?? {};
    const isEmailMessage = DeliveryMedium === "EMAIL";
    const isTextMessage = DeliveryMedium === "SMS";
    if (!isEmailMessage && isTextMessage) return (0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).WE_SENT_CODE);
    return isEmailMessage ? (0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).WE_EMAILED) : (0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).WE_TEXTED);
};
/**
 * FederatedSignIn
 */ const $24044d7e72f9876b$var$providerNameMap = {
    amazon: "Amazon",
    apple: "Apple",
    facebook: "Facebook",
    google: "Google"
};
const $24044d7e72f9876b$var$getSignInWithFederationText = (route, provider)=>{
    const isSignIn = route === "signIn";
    return (0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)(`Sign ${isSignIn ? "In" : "Up"} with ${$24044d7e72f9876b$var$providerNameMap[provider]}`);
};
const $24044d7e72f9876b$export$34e9c32aebe14fbb = {
    /** Shared */ getBackToSignInText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).BACK_SIGN_IN),
    getChangePasswordText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).CHANGE_PASSWORD),
    getChangingText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).CHANGING_PASSWORD),
    getConfirmText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).CONFIRM),
    getConfirmingText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).CONFIRMING),
    getCopyText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).UPPERCASE_COPY),
    getHidePasswordText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).HIDE_PASSWORD),
    getLoadingText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).LOADING),
    getOrText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).OR),
    getResendCodeText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).RESEND_CODE),
    getSendCodeText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).SEND_CODE),
    getSendingText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).SENDING),
    getShowPasswordText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).SHOW_PASSWORD),
    getSubmitText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).SUBMIT),
    getSubmittingText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).SUBMITTING),
    /** SignInSignUpTabs */ getSignInTabText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).SIGN_IN_TAB),
    getSignUpTabText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).CREATE_ACCOUNT),
    /** SignIn */ getForgotPasswordText: (shortVersion)=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)(shortVersion ? (0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).FORGOT_PASSWORD : (0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).FORGOT_YOUR_PASSWORD),
    getSigningInText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).SIGNING_IN_BUTTON),
    getSignInText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).SIGN_IN_BUTTON),
    /** SignUp */ getCreatingAccountText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).CREATING_ACCOUNT),
    getCreateAccountText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).CREATE_ACCOUNT),
    getDeliveryMessageText: /** ConfirmSignUp */ $24044d7e72f9876b$var$getDeliveryMessageText,
    getDeliveryMethodText: $24044d7e72f9876b$var$getDeliveryMethodText,
    getChallengeText: /** ConfirmSignIn */ $24044d7e72f9876b$var$getChallengeText,
    /** ForgotPassword */ getResetYourPasswordText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).RESET_PASSWORD),
    /** SetupTotp */ getSetupTotpText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).SETUP_TOTP),
    // TODO: add defaultText for below
    getSetupTotpInstructionsText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)("Copy and paste the secret key below into an authenticator app and then enter the code in the text field below."),
    // TODO: add defaultText for "COPIED"
    getCopiedText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)("COPIED"),
    getSignInWithFederationText: /** FederatedSignIn */ $24044d7e72f9876b$var$getSignInWithFederationText,
    /** VerifyUser */ getSkipText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).SKIP),
    getVerifyText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).VERIFY),
    getVerifyContactText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).VERIFY_CONTACT),
    getAccountRecoveryInfoText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)((0, $c4e69119c3aaed8b$export$6ba37fd455cdd594).VERIFY_HEADING),
    /** Validations */ // TODO: add defaultText
    getInvalidEmailText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)("Please enter a valid email"),
    // TODO: add defaultText
    getRequiredFieldText: ()=>(0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)("This field is required")
}; // using `as const` so that keys are strongly typed



var $1T1QG = parcelRequire("1T1QG");

const $930ce2e103c789d9$export$ce4ab0c55987d1ff = (...args)=>{
    const classes = [];
    for (const arg of args){
        // skip falsey values
        if (!arg) continue;
        if ((0, $697901644f774aa4$export$844ec244b1367d54)(arg)) {
            classes.push(arg);
            continue;
        }
        if (typeof arg === "number") {
            classes.push(arg.toString());
            continue;
        }
        if (Array.isArray(arg)) {
            classes.push($930ce2e103c789d9$export$ce4ab0c55987d1ff(...arg));
            continue;
        }
        if ((0, $697901644f774aa4$export$a6cdc56e425d0d0a)(arg)) {
            // check if the object has a valid .toString() method
            if (arg.toString !== Object.prototype.toString && arg.toString() !== "[object Object]") {
                classes.push(arg.toString());
                continue;
            }
            for(const key in arg)if ((0, $697901644f774aa4$export$a4f4bb6b1453fff5)(arg, key) && arg[key]) classes.push(key);
        }
    }
    return classes.join(" ");
};

const $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6 = {
    Accordion: "amplify-accordion",
    AccordionItem: "amplify-accordion__item",
    AccordionItemTrigger: "amplify-accordion__item__trigger",
    AccordionItemContent: "amplify-accordion__item__content",
    AccordionItemIcon: "amplify-accordion__item__icon",
    Alert: "amplify-alert",
    AlertIcon: "amplify-alert__icon",
    AlertHeading: "amplify-alert__heading",
    AlertBody: "amplify-alert__body",
    AlertDismiss: "amplify-alert__dismiss",
    Autocomplete: "amplify-autocomplete",
    AutocompleteMenu: "amplify-autocomplete__menu",
    AutocompleteMenuEmpty: "amplify-autocomplete__menu--empty",
    AutocompleteMenuFooter: "amplify-autocomplete__menu__footer",
    AutocompleteMenuHeader: "amplify-autocomplete__menu__header",
    AutocompleteMenuLoading: "amplify-autocomplete__menu--loading",
    AutocompleteMenuOption: "amplify-autocomplete__menu__option",
    AutocompleteMenuOptions: "amplify-autocomplete__menu__options",
    Badge: "amplify-badge",
    Breadcrumbs: "amplify-breadcrumbs",
    BreadcrumbsList: "amplify-breadcrumbs__list",
    BreadcrumbsItem: "amplify-breadcrumbs__item",
    BreadcrumbsSeparator: "amplify-breadcrumbs__separator",
    BreadcrumbsLink: "amplify-breadcrumbs__link",
    Button: "amplify-button",
    ButtonGroup: "amplify-buttongroup",
    ButtonLoaderWrapper: "amplify-button__loader-wrapper",
    Card: "amplify-card",
    Checkbox: "amplify-checkbox",
    CheckboxButton: "amplify-checkbox__button",
    CheckboxIcon: "amplify-checkbox__icon",
    CheckboxInput: "amplify-checkbox__input",
    CheckboxLabel: "amplify-checkbox__label",
    CheckboxField: "amplify-checkboxfield",
    Collection: "amplify-collection",
    CollectionItems: "amplify-collection-items",
    CollectionSearch: "amplify-collection-search",
    CollectionPagination: "amplify-collection-pagination",
    CountryCodeSelect: "amplify-countrycodeselect",
    DialCodeSelect: "amplify-dialcodeselect",
    Divider: "amplify-divider",
    DividerLabel: "amplify-divider--label",
    DropZone: "amplify-dropzone",
    Field: "amplify-field",
    FieldDescription: "amplify-field__description",
    FieldErrorMessage: "amplify-field__error-message",
    FieldGroup: "amplify-field-group",
    FieldGroupControl: "amplify-field-group__control",
    FieldGroupOuterEnd: "amplify-field-group__outer-end",
    FieldGroupOuterStart: "amplify-field-group__outer-start",
    FieldGroupInnerEnd: "amplify-field-group__inner-end",
    FieldGroupInnerStart: "amplify-field-group__inner-start",
    FieldGroupIcon: "amplify-field-group__icon",
    FieldGroupIconButton: "amplify-field-group__icon-button",
    FieldGroupHasInnerEnd: "amplify-field-group--has-inner-end",
    FieldGroupHasInnerStart: "amplify-field-group--has-inner-start",
    FieldShowPassword: "amplify-field__show-password",
    FieldGroupFieldWrapper: "amplify-field-group__field-wrapper",
    Fieldset: "amplify-fieldset",
    FieldsetLegend: "amplify-fieldset__legend",
    Flex: "amplify-flex",
    Grid: "amplify-grid",
    Heading: "amplify-heading",
    HighlightMatch: "amplify-highlightmatch",
    HighlightMatchHighlighted: "amplify-highlightmatch__highlighted",
    Icon: "amplify-icon",
    Image: "amplify-image",
    Input: "amplify-input",
    Label: "amplify-label",
    Link: "amplify-link",
    Loader: "amplify-loader",
    LoaderLabel: "amplify-loader__label",
    MenuContent: "amplify-menu__content",
    MenuItem: "amplify-menu__content__item",
    MenuTrigger: "amplify-menu__trigger",
    MenuWrapper: "amplify-menu__wrapper",
    Message: "amplify-message",
    MessageIcon: "amplify-message__icon",
    MessageHeading: "amplify-message__heading",
    MessageBody: "amplify-message__body",
    MessageContent: "amplify-message__content",
    MessageDismiss: "amplify-message__dismiss",
    Pagination: "amplify-pagination",
    PaginationItem: "amplify-pagination__item",
    PasswordField: "amplify-passwordfield",
    PhoneNumberField: "amplify-phonenumberfield",
    Placeholder: "amplify-placeholder",
    Radio: "amplify-radio",
    RadioButton: "amplify-radio__button",
    RadioInput: "amplify-radio__input",
    RadioLabel: "amplify-radio__label",
    RadioGroupField: "amplify-radiogroupfield",
    RadioGroup: "amplify-radiogroup",
    Rating: "amplify-rating",
    RatingItem: "amplify-rating__item",
    RatingIcon: "amplify-rating__icon",
    RatingLabel: "amplify-rating__label",
    ScrollView: "amplify-scrollview",
    SearchField: "amplify-searchfield",
    SearchFieldClear: "amplify-searchfield__clear",
    SearchFieldSearch: "amplify-searchfield__search",
    Select: "amplify-select",
    SelectField: "amplify-selectfield",
    SelectWrapper: "amplify-select__wrapper",
    SelectIcon: "amplify-select__icon",
    SliderField: "amplify-sliderfield",
    SliderFieldGroup: "amplify-sliderfield__group",
    SliderFieldLabel: "amplify-sliderfield__label",
    SliderFieldRange: "amplify-sliderfield__range",
    SliderFieldRoot: "amplify-sliderfield__root",
    SliderFieldThumb: "amplify-sliderfield__thumb",
    SliderFieldTrack: "amplify-sliderfield__track",
    StepperField: "amplify-stepperfield",
    StepperFieldButtonDecrease: "amplify-stepperfield__button--decrease",
    StepperFieldButtonIncrease: "amplify-stepperfield__button--increase",
    StepperFieldInput: "amplify-stepperfield__input",
    StorageImage: "amplify-storageimage",
    StorageManager: "amplify-storagemanager",
    StorageManagerDropZone: "amplify-storagemanager__dropzone",
    StorageManagerDropZoneIcon: "amplify-storagemanager__dropzone__icon",
    StorageManagerDropZoneText: "amplify-storagemanager__dropzone__text",
    StorageManagerFilePicker: "amplify-storagemanager__file__picker",
    StorageManagerFile: "amplify-storagemanager__file",
    StorageManagerFileWrapper: "amplify-storagemanager__file__wrapper",
    StorageManagerFileList: "amplify-storagemanager__file__list",
    StorageManagerFileName: "amplify-storagemanager__file__name",
    StorageManagerFileSize: "amplify-storagemanager__file__size",
    StorageManagerFileInfo: "amplify-storagemanager__file__info",
    StorageManagerFileImage: "amplify-storagemanager__file__image",
    StorageManagerFileMain: "amplify-storagemanager__file__main",
    StorageManagerFileStatus: "amplify-storagemanager__file__status",
    StorageManagerLoader: "amplify-storagemanager__loader",
    StorageManagerPreviewer: "amplify-storagemanager__previewer",
    StorageManagerPreviewerText: "amplify-storagemanager__previewer__text",
    StorageManagerPreviewerActions: "amplify-storagemanager__previewer__actions",
    StorageManagerPreviewerFooter: "amplify-storagemanager__previewer__footer",
    SwitchField: "amplify-switchfield",
    SwitchLabel: "amplify-switch__label",
    SwitchThumb: "amplify-switch__thumb",
    SwitchTrack: "amplify-switch__track",
    SwitchWrapper: "amplify-switch__wrapper",
    Table: "amplify-table",
    TableCaption: "amplify-table__caption",
    TableBody: "amplify-table__body",
    TableTd: "amplify-table__td",
    TableTh: "amplify-table__th",
    TableFoot: "amplify-table__foot",
    TableHead: "amplify-table__head",
    TableRow: "amplify-table__row",
    Tabs: "amplify-tabs",
    TabsList: "amplify-tabs__list",
    TabsItem: "amplify-tabs__item",
    TabsPanel: "amplify-tabs__panel",
    Text: "amplify-text",
    Textarea: "amplify-textarea",
    TextAreaField: "amplify-textareafield",
    TextField: "amplify-textfield",
    ToggleButton: "amplify-togglebutton",
    ToggleButtonGroup: "amplify-togglebuttongroup",
    VisuallyHidden: "amplify-visually-hidden"
};



var $1T1QG = parcelRequire("1T1QG");
/**
 * Updates the return type for primitives wrapped in `React.forwardRef` to
 * `React.ReactElement`. In React 18 the return type of `React.ExoticComponent`
 * was changed from `React.ReactElement` to `React.ReactNode`, which breaks
 * clients using React 16 and 17.
 *
 * @param primitive UI Primitive to be wrapped with `React.forwardRef`
 * @returns ForwaredRef wrapped UI Primitive
 */ const $23e6fd8f9afedafa$export$44aa160b17c73194 = (primitive)=>$1T1QG.forwardRef(primitive);



var $1T1QG = parcelRequire("1T1QG");
const $b452cc20c9476a43$export$74e4d3bc6dc1117 = $1T1QG.createContext({
    isFieldsetDisabled: false
});
/**
 * @description Fieldsets in HTML can be disabled, which disables all child
 * fieldsets and input controls. `useFieldset` passes the disabled state down
 * via context.
 */ const $b452cc20c9476a43$export$b140571ec72925dd = ()=>$1T1QG.useContext($b452cc20c9476a43$export$74e4d3bc6dc1117);



var $1T1QG = parcelRequire("1T1QG");


var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");
var $c5565441dcbc1318$exports = {};
var $fcad49a118863f6e$exports = {};
var $42bf4fc29a31766e$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $42bf4fc29a31766e$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$42bf4fc29a31766e$exports = $42bf4fc29a31766e$var$arrayReduce;


var $9d02362038ee16cc$exports = {};
var $f97d6c21c4974c6a$exports = {};
var $b0c5d89fd3303230$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $b0c5d89fd3303230$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$b0c5d89fd3303230$exports = $b0c5d89fd3303230$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $f97d6c21c4974c6a$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $f97d6c21c4974c6a$var$deburrLetter = $b0c5d89fd3303230$exports($f97d6c21c4974c6a$var$deburredLetters);
$f97d6c21c4974c6a$exports = $f97d6c21c4974c6a$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $9d02362038ee16cc$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $9d02362038ee16cc$var$rsComboMarksRange = "\\u0300-\\u036f", $9d02362038ee16cc$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $9d02362038ee16cc$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $9d02362038ee16cc$var$rsComboRange = $9d02362038ee16cc$var$rsComboMarksRange + $9d02362038ee16cc$var$reComboHalfMarksRange + $9d02362038ee16cc$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $9d02362038ee16cc$var$rsCombo = "[" + $9d02362038ee16cc$var$rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $9d02362038ee16cc$var$reComboMark = RegExp($9d02362038ee16cc$var$rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $9d02362038ee16cc$var$deburr(string) {
    string = $4fe749c4b1591f12$exports(string);
    return string && string.replace($9d02362038ee16cc$var$reLatin, $f97d6c21c4974c6a$exports).replace($9d02362038ee16cc$var$reComboMark, "");
}
$9d02362038ee16cc$exports = $9d02362038ee16cc$var$deburr;


var $9ee05d1e380ae2a8$exports = {};
var $51738af51e48cbc1$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $51738af51e48cbc1$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $51738af51e48cbc1$var$asciiWords(string) {
    return string.match($51738af51e48cbc1$var$reAsciiWord) || [];
}
$51738af51e48cbc1$exports = $51738af51e48cbc1$var$asciiWords;


var $39319cd782faf558$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $39319cd782faf558$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $39319cd782faf558$var$hasUnicodeWord(string) {
    return $39319cd782faf558$var$reHasUnicodeWord.test(string);
}
$39319cd782faf558$exports = $39319cd782faf558$var$hasUnicodeWord;



var $830b4c9d98e5d3df$exports = {};
/** Used to compose unicode character classes. */ var $830b4c9d98e5d3df$var$rsAstralRange = "\ud800-\udfff", $830b4c9d98e5d3df$var$rsComboMarksRange = "\\u0300-\\u036f", $830b4c9d98e5d3df$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $830b4c9d98e5d3df$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $830b4c9d98e5d3df$var$rsComboRange = $830b4c9d98e5d3df$var$rsComboMarksRange + $830b4c9d98e5d3df$var$reComboHalfMarksRange + $830b4c9d98e5d3df$var$rsComboSymbolsRange, $830b4c9d98e5d3df$var$rsDingbatRange = "\\u2700-\\u27bf", $830b4c9d98e5d3df$var$rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", $830b4c9d98e5d3df$var$rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", $830b4c9d98e5d3df$var$rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $830b4c9d98e5d3df$var$rsPunctuationRange = "\\u2000-\\u206f", $830b4c9d98e5d3df$var$rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $830b4c9d98e5d3df$var$rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", $830b4c9d98e5d3df$var$rsVarRange = "\\ufe0e\\ufe0f", $830b4c9d98e5d3df$var$rsBreakRange = $830b4c9d98e5d3df$var$rsMathOpRange + $830b4c9d98e5d3df$var$rsNonCharRange + $830b4c9d98e5d3df$var$rsPunctuationRange + $830b4c9d98e5d3df$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $830b4c9d98e5d3df$var$rsApos = "['\u2019]", $830b4c9d98e5d3df$var$rsBreak = "[" + $830b4c9d98e5d3df$var$rsBreakRange + "]", $830b4c9d98e5d3df$var$rsCombo = "[" + $830b4c9d98e5d3df$var$rsComboRange + "]", $830b4c9d98e5d3df$var$rsDigits = "\\d+", $830b4c9d98e5d3df$var$rsDingbat = "[" + $830b4c9d98e5d3df$var$rsDingbatRange + "]", $830b4c9d98e5d3df$var$rsLower = "[" + $830b4c9d98e5d3df$var$rsLowerRange + "]", $830b4c9d98e5d3df$var$rsMisc = "[^" + $830b4c9d98e5d3df$var$rsAstralRange + $830b4c9d98e5d3df$var$rsBreakRange + $830b4c9d98e5d3df$var$rsDigits + $830b4c9d98e5d3df$var$rsDingbatRange + $830b4c9d98e5d3df$var$rsLowerRange + $830b4c9d98e5d3df$var$rsUpperRange + "]", $830b4c9d98e5d3df$var$rsFitz = "\ud83c[\udffb-\udfff]", $830b4c9d98e5d3df$var$rsModifier = "(?:" + $830b4c9d98e5d3df$var$rsCombo + "|" + $830b4c9d98e5d3df$var$rsFitz + ")", $830b4c9d98e5d3df$var$rsNonAstral = "[^" + $830b4c9d98e5d3df$var$rsAstralRange + "]", $830b4c9d98e5d3df$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $830b4c9d98e5d3df$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $830b4c9d98e5d3df$var$rsUpper = "[" + $830b4c9d98e5d3df$var$rsUpperRange + "]", $830b4c9d98e5d3df$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $830b4c9d98e5d3df$var$rsMiscLower = "(?:" + $830b4c9d98e5d3df$var$rsLower + "|" + $830b4c9d98e5d3df$var$rsMisc + ")", $830b4c9d98e5d3df$var$rsMiscUpper = "(?:" + $830b4c9d98e5d3df$var$rsUpper + "|" + $830b4c9d98e5d3df$var$rsMisc + ")", $830b4c9d98e5d3df$var$rsOptContrLower = "(?:" + $830b4c9d98e5d3df$var$rsApos + "(?:d|ll|m|re|s|t|ve))?", $830b4c9d98e5d3df$var$rsOptContrUpper = "(?:" + $830b4c9d98e5d3df$var$rsApos + "(?:D|LL|M|RE|S|T|VE))?", $830b4c9d98e5d3df$var$reOptMod = $830b4c9d98e5d3df$var$rsModifier + "?", $830b4c9d98e5d3df$var$rsOptVar = "[" + $830b4c9d98e5d3df$var$rsVarRange + "]?", $830b4c9d98e5d3df$var$rsOptJoin = "(?:" + $830b4c9d98e5d3df$var$rsZWJ + "(?:" + [
    $830b4c9d98e5d3df$var$rsNonAstral,
    $830b4c9d98e5d3df$var$rsRegional,
    $830b4c9d98e5d3df$var$rsSurrPair
].join("|") + ")" + $830b4c9d98e5d3df$var$rsOptVar + $830b4c9d98e5d3df$var$reOptMod + ")*", $830b4c9d98e5d3df$var$rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $830b4c9d98e5d3df$var$rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $830b4c9d98e5d3df$var$rsSeq = $830b4c9d98e5d3df$var$rsOptVar + $830b4c9d98e5d3df$var$reOptMod + $830b4c9d98e5d3df$var$rsOptJoin, $830b4c9d98e5d3df$var$rsEmoji = "(?:" + [
    $830b4c9d98e5d3df$var$rsDingbat,
    $830b4c9d98e5d3df$var$rsRegional,
    $830b4c9d98e5d3df$var$rsSurrPair
].join("|") + ")" + $830b4c9d98e5d3df$var$rsSeq;
/** Used to match complex or compound words. */ var $830b4c9d98e5d3df$var$reUnicodeWord = RegExp([
    $830b4c9d98e5d3df$var$rsUpper + "?" + $830b4c9d98e5d3df$var$rsLower + "+" + $830b4c9d98e5d3df$var$rsOptContrLower + "(?=" + [
        $830b4c9d98e5d3df$var$rsBreak,
        $830b4c9d98e5d3df$var$rsUpper,
        "$"
    ].join("|") + ")",
    $830b4c9d98e5d3df$var$rsMiscUpper + "+" + $830b4c9d98e5d3df$var$rsOptContrUpper + "(?=" + [
        $830b4c9d98e5d3df$var$rsBreak,
        $830b4c9d98e5d3df$var$rsUpper + $830b4c9d98e5d3df$var$rsMiscLower,
        "$"
    ].join("|") + ")",
    $830b4c9d98e5d3df$var$rsUpper + "?" + $830b4c9d98e5d3df$var$rsMiscLower + "+" + $830b4c9d98e5d3df$var$rsOptContrLower,
    $830b4c9d98e5d3df$var$rsUpper + "+" + $830b4c9d98e5d3df$var$rsOptContrUpper,
    $830b4c9d98e5d3df$var$rsOrdUpper,
    $830b4c9d98e5d3df$var$rsOrdLower,
    $830b4c9d98e5d3df$var$rsDigits,
    $830b4c9d98e5d3df$var$rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $830b4c9d98e5d3df$var$unicodeWords(string) {
    return string.match($830b4c9d98e5d3df$var$reUnicodeWord) || [];
}
$830b4c9d98e5d3df$exports = $830b4c9d98e5d3df$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $9ee05d1e380ae2a8$var$words(string, pattern, guard) {
    string = $4fe749c4b1591f12$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $39319cd782faf558$exports(string) ? $830b4c9d98e5d3df$exports(string) : $51738af51e48cbc1$exports(string);
    return string.match(pattern) || [];
}
$9ee05d1e380ae2a8$exports = $9ee05d1e380ae2a8$var$words;


/** Used to compose unicode capture groups. */ var $fcad49a118863f6e$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $fcad49a118863f6e$var$reApos = RegExp($fcad49a118863f6e$var$rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $fcad49a118863f6e$var$createCompounder(callback) {
    return function(string) {
        return $42bf4fc29a31766e$exports($9ee05d1e380ae2a8$exports($9d02362038ee16cc$exports(string).replace($fcad49a118863f6e$var$reApos, "")), callback, "");
    };
}
$fcad49a118863f6e$exports = $fcad49a118863f6e$var$createCompounder;


/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $c5565441dcbc1318$var$kebabCase = $fcad49a118863f6e$exports(function(result, word, index) {
    return result + (index ? "-" : "") + word.toLowerCase();
});
$c5565441dcbc1318$exports = $c5565441dcbc1318$var$kebabCase;


var $48eadb50903cda77$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $315354a154f0ea06$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $ca054bb34d01b6cc$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ const $ca054bb34d01b6cc$var$defaults = {
    opening_character: "{",
    closing_character: "}",
    separator: "."
};
$ca054bb34d01b6cc$exports = $ca054bb34d01b6cc$var$defaults;


function $315354a154f0ea06$var$createReferenceRegex(opts = {}) {
    const options = Object.assign({}, $ca054bb34d01b6cc$exports, opts);
    return new RegExp("\\" + options.opening_character + "([^" + options.closing_character + "]+)" + "\\" + options.closing_character, "g");
}
$315354a154f0ea06$exports = $315354a154f0ea06$var$createReferenceRegex;


/**
 * Checks if the value uses a value reference.
 * @memberof Dictionary
 * @param {string} value
 * @param {Object|RegExp} regexOrOptions
 * @returns {boolean} - True, if the value uses a value reference
 */ function $48eadb50903cda77$var$usesReference(value, regexOrOptions = {}) {
    const regex = regexOrOptions instanceof RegExp ? regexOrOptions : $315354a154f0ea06$exports(regexOrOptions);
    if (typeof value === "string") return regex.test(value);
    if (typeof value === "object") {
        let hasReference = false;
        // iterate over each property in the object,
        // if any element passes the regex test,
        // the whole thing should be true
        for(const key in value)if (value.hasOwnProperty(key)) {
            const element = value[key];
            let reference = $48eadb50903cda77$var$usesReference(element, regexOrOptions);
            if (reference) {
                hasReference = true;
                break;
            }
        }
        return hasReference;
    }
    return false;
}
$48eadb50903cda77$exports = $48eadb50903cda77$var$usesReference;





const $08d92a30c154d78f$export$f9ebafeabd662d32 = "amplify";
// Important: these properties should not be altered in
// order to maintain the expected order of the CSS `box-shadow` property
const $08d92a30c154d78f$var$SHADOW_PROPERTIES = [
    "offsetX",
    "offsetY",
    "blurRadius",
    "spreadRadius",
    "color"
];
function $08d92a30c154d78f$var$referenceValue(value) {
    if (!value) return "";
    if ((0, (/*@__PURE__*/$parcel$interopDefault($48eadb50903cda77$exports)))(value)) {
        const path = value.replace(/\{|\}/g, "").replace(".value", "").split(".");
        return `var(--${$08d92a30c154d78f$export$8658ddf1aae625a3({
            path: path
        })})`;
    }
    return value;
}
function $08d92a30c154d78f$export$55101aa37e5c1f8f(token) {
    const { value: value } = token;
    if ((0, $697901644f774aa4$export$844ec244b1367d54)(value)) return $08d92a30c154d78f$var$referenceValue(value);
    if ($08d92a30c154d78f$export$50306062f6ed54c(value)) return $08d92a30c154d78f$var$SHADOW_PROPERTIES.map((property)=>{
        return $08d92a30c154d78f$var$referenceValue(// lookup property against `token` first for custom non-nested value, then lookup
        // property against `value` for design token value
        $08d92a30c154d78f$export$50306062f6ed54c(token) ? token[property] : value[property]);
    }).join(" ");
    return value;
}
function $08d92a30c154d78f$export$8658ddf1aae625a3({ path: path = [] }) {
    return `${(0, (/*@__PURE__*/$parcel$interopDefault($c5565441dcbc1318$exports)))([
        $08d92a30c154d78f$export$f9ebafeabd662d32,
        ...path
    ].join(" "))}`;
}
/**
 * Helper function to test if something is a design token or not.
 * Used in the React component style props.
 *
 * @param value - thing to test if it is a design token or not
 * @returns boolean
 */ function $08d92a30c154d78f$export$daee9cd42beef6d1(value) {
    return (0, $697901644f774aa4$export$a6cdc56e425d0d0a)(value) && (0, $697901644f774aa4$export$a4f4bb6b1453fff5)(value, "value");
}
function $08d92a30c154d78f$export$50306062f6ed54c(value) {
    return (0, $697901644f774aa4$export$a6cdc56e425d0d0a)(value) && (0, $697901644f774aa4$export$a4f4bb6b1453fff5)(value, "offsetX");
}
/**
 * Recursive function that will walk down the token object
 * and perform the setupToken function on each token.
 * Similar to what Style Dictionary does.
 */ function $08d92a30c154d78f$export$4ae67d38aae8ca2e({ tokens: tokens, path: path = [], setupToken: setupToken }) {
    if ((0, $697901644f774aa4$export$a4f4bb6b1453fff5)(tokens, "value")) return setupToken({
        token: tokens,
        path: path
    });
    const output = {};
    for(const name in tokens)if ((0, $697901644f774aa4$export$a4f4bb6b1453fff5)(tokens, name)) {
        const value = tokens[name];
        const nextTokens = (0, $697901644f774aa4$export$a6cdc56e425d0d0a)(value) ? value : {
            value: value
        };
        output[name] = $08d92a30c154d78f$export$4ae67d38aae8ca2e({
            tokens: nextTokens,
            path: path.concat(name),
            setupToken: setupToken
        });
    }
    return output;
}


/**
 * @internal May be removed in a future version
 * Maps from component style props to React `style` props
 * Note: Primarily needed to map from component style props that don't match CSS Properties directly
 * such as wrap => flexWrap and direction => flexDirection
 */ const $4d74122378cfaa18$export$c69338bc7d797351 = {
    alignContent: "alignContent",
    alignItems: "alignItems",
    alignSelf: "alignSelf",
    area: "gridArea",
    aspectRatio: "aspectRatio",
    autoColumns: "gridAutoColumns",
    autoFlow: "gridAutoFlow",
    autoRows: "gridAutoRows",
    backgroundColor: "backgroundColor",
    backgroundImage: "backgroundImage",
    basis: "flexBasis",
    border: "border",
    borderRadius: "borderRadius",
    borderColor: "borderColor",
    borderWidth: "borderWidth",
    borderStyle: "borderStyle",
    bottom: "bottom",
    boxShadow: "boxShadow",
    color: "color",
    column: "gridColumn",
    columnEnd: "gridColumnEnd",
    columnGap: "columnGap",
    columnSpan: "gridColumn",
    columnStart: "gridColumnStart",
    direction: "flexDirection",
    display: "display",
    flex: "flex",
    fontFamily: "fontFamily",
    fontSize: "fontSize",
    fontStyle: "fontStyle",
    fontWeight: "fontWeight",
    gap: "gap",
    grow: "flexGrow",
    height: "height",
    justifyContent: "justifyContent",
    left: "left",
    letterSpacing: "letterSpacing",
    lineHeight: "lineHeight",
    margin: "margin",
    marginBlock: "marginBlock",
    marginBlockEnd: "marginBlockEnd",
    marginBlockStart: "marginBlockStart",
    marginBottom: "marginBlockEnd",
    marginInline: "marginInline",
    marginInlineEnd: "marginInlineEnd",
    marginInlineStart: "marginInlineStart",
    marginLeft: "marginInlineStart",
    marginRight: "marginInlineEnd",
    marginTop: "marginBlockStart",
    maxHeight: "maxHeight",
    maxWidth: "maxWidth",
    minHeight: "minHeight",
    minWidth: "minWidth",
    objectFit: "objectFit",
    objectPosition: "objectPosition",
    opacity: "opacity",
    order: "order",
    overflow: "overflow",
    padding: "padding",
    paddingBlock: "paddingBlock",
    paddingBlockEnd: "paddingBlockEnd",
    paddingBlockStart: "paddingBlockStart",
    paddingBottom: "paddingBlockEnd",
    paddingInline: "paddingInline",
    paddingInlineEnd: "paddingInlineEnd",
    paddingInlineStart: "paddingInlineStart",
    paddingLeft: "paddingInlineStart",
    paddingRight: "paddingInlineEnd",
    paddingTop: "paddingBlockStart",
    position: "position",
    resize: "resize",
    right: "right",
    row: "gridRow",
    rowEnd: "gridRowEnd",
    rowGap: "rowGap",
    rowSpan: "gridRow",
    rowStart: "gridRowStart",
    shrink: "flexShrink",
    templateAreas: "gridTemplateAreas",
    templateColumns: "gridTemplateColumns",
    templateRows: "gridTemplateRows",
    textAlign: "textAlign",
    textDecoration: "textDecoration",
    textTransform: "textTransform",
    top: "top",
    transform: "transform",
    transformOrigin: "transformOrigin",
    width: "width",
    whiteSpace: "whiteSpace",
    wrap: "flexWrap"
};
/**
 * @internal May be removed in a future version
 */ const $4d74122378cfaa18$export$885e0ebc08cdd9a0 = Object.keys($4d74122378cfaa18$export$c69338bc7d797351);


const $601a50b19cd5fef1$export$6f3cc5789c9e770e = {
    small: {
        value: "1px"
    },
    medium: {
        value: "2px"
    },
    large: {
        value: "3px"
    }
};


const $f36afbd21e8fb44b$export$8f45430ccf837300 = {
    red: {
        10: {
            value: "hsl(0, 75%, 95%)"
        },
        20: {
            value: "hsl(0, 75%, 85%)"
        },
        40: {
            value: "hsl(0, 75%, 75%)"
        },
        60: {
            value: "hsl(0, 50%, 50%)"
        },
        80: {
            value: "hsl(0, 95%, 30%)"
        },
        90: {
            value: "hsl(0, 100%, 20%)"
        },
        100: {
            value: "hsl(0, 100%, 15%)"
        }
    },
    orange: {
        10: {
            value: "hsl(30, 75%, 95%)"
        },
        20: {
            value: "hsl(30, 75%, 85%)"
        },
        40: {
            value: "hsl(30, 75%, 75%)"
        },
        60: {
            value: "hsl(30, 50%, 50%)"
        },
        80: {
            value: "hsl(30, 95%, 30%)"
        },
        90: {
            value: "hsl(30, 100%, 20%)"
        },
        100: {
            value: "hsl(30, 100%, 15%)"
        }
    },
    yellow: {
        10: {
            value: "hsl(60, 75%, 95%)"
        },
        20: {
            value: "hsl(60, 75%, 85%)"
        },
        40: {
            value: "hsl(60, 75%, 75%)"
        },
        60: {
            value: "hsl(60, 50%, 50%)"
        },
        80: {
            value: "hsl(60, 95%, 30%)"
        },
        90: {
            value: "hsl(60, 100%, 20%)"
        },
        100: {
            value: "hsl(60, 100%, 15%)"
        }
    },
    green: {
        10: {
            value: "hsl(130, 60%, 95%)"
        },
        20: {
            value: "hsl(130, 60%, 90%)"
        },
        40: {
            value: "hsl(130, 44%, 63%)"
        },
        60: {
            value: "hsl(130, 43%, 46%)"
        },
        80: {
            value: "hsl(130, 33%, 37%)"
        },
        90: {
            value: "hsl(130, 27%, 29%)"
        },
        100: {
            value: "hsl(130, 22%, 23%)"
        }
    },
    teal: {
        10: {
            value: "hsl(190, 75%, 95%)"
        },
        20: {
            value: "hsl(190, 75%, 85%)"
        },
        40: {
            value: "hsl(190, 70%, 70%)"
        },
        60: {
            value: "hsl(190, 50%, 50%)"
        },
        80: {
            value: "hsl(190, 95%, 30%)"
        },
        90: {
            value: "hsl(190, 100%, 20%)"
        },
        100: {
            value: "hsl(190, 100%, 15%)"
        }
    },
    blue: {
        10: {
            value: "hsl(220, 95%, 95%)"
        },
        20: {
            value: "hsl(220, 85%, 85%)"
        },
        40: {
            value: "hsl(220, 70%, 70%)"
        },
        60: {
            value: "hsl(220, 50%, 50%)"
        },
        80: {
            value: "hsl(220, 95%, 30%)"
        },
        90: {
            value: "hsl(220, 100%, 20%)"
        },
        100: {
            value: "hsl(220, 100%, 15%)"
        }
    },
    purple: {
        10: {
            value: "hsl(300, 95%, 95%)"
        },
        20: {
            value: "hsl(300, 85%, 85%)"
        },
        40: {
            value: "hsl(300, 70%, 70%)"
        },
        60: {
            value: "hsl(300, 50%, 50%)"
        },
        80: {
            value: "hsl(300, 95%, 30%)"
        },
        90: {
            value: "hsl(300, 100%, 20%)"
        },
        100: {
            value: "hsl(300, 100%, 15%)"
        }
    },
    pink: {
        10: {
            value: "hsl(340, 95%, 95%)"
        },
        20: {
            value: "hsl(340, 90%, 85%)"
        },
        40: {
            value: "hsl(340, 70%, 70%)"
        },
        60: {
            value: "hsl(340, 50%, 50%)"
        },
        80: {
            value: "hsl(340, 95%, 30%)"
        },
        90: {
            value: "hsl(340, 100%, 20%)"
        },
        100: {
            value: "hsl(340, 100%, 15%)"
        }
    },
    neutral: {
        10: {
            value: "hsl(210, 5%, 98%)"
        },
        20: {
            value: "hsl(210, 5%, 94%)"
        },
        40: {
            value: "hsl(210, 5%, 87%)"
        },
        60: {
            value: "hsl(210, 10%, 58%)"
        },
        80: {
            value: "hsl(210, 10%, 40%)"
        },
        90: {
            value: "hsl(210, 25%, 25%)"
        },
        100: {
            value: "hsl(210, 50%, 10%)"
        }
    },
    primary: {
        10: {
            value: "{colors.teal.10.value}"
        },
        20: {
            value: "{colors.teal.20.value}"
        },
        40: {
            value: "{colors.teal.40.value}"
        },
        60: {
            value: "{colors.teal.60.value}"
        },
        80: {
            value: "{colors.teal.80.value}"
        },
        90: {
            value: "{colors.teal.90.value}"
        },
        100: {
            value: "{colors.teal.100.value}"
        }
    },
    secondary: {
        10: {
            value: "{colors.purple.10.value}"
        },
        20: {
            value: "{colors.purple.20.value}"
        },
        40: {
            value: "{colors.purple.40.value}"
        },
        60: {
            value: "{colors.purple.60.value}"
        },
        80: {
            value: "{colors.purple.80.value}"
        },
        90: {
            value: "{colors.purple.90.value}"
        },
        100: {
            value: "{colors.purple.100.value}"
        }
    },
    font: {
        primary: {
            value: "{colors.neutral.100.value}"
        },
        secondary: {
            value: "{colors.neutral.90.value}"
        },
        tertiary: {
            value: "{colors.neutral.80.value}"
        },
        disabled: {
            value: "{colors.neutral.60.value}"
        },
        inverse: {
            value: "{colors.white.value}"
        },
        interactive: {
            value: "{colors.primary.80.value}"
        },
        // Hover and Focus colors are intentionally different colors.
        // This allows users to distinguish between the current keyboard focus
        // and the location of their pointer
        hover: {
            value: "{colors.primary.90.value}"
        },
        // Focus color is set to 100 to ensure enough contrast for accessibility
        focus: {
            value: "{colors.primary.100.value}"
        },
        active: {
            value: "{colors.primary.100.value}"
        },
        info: {
            value: "{colors.blue.90.value}"
        },
        warning: {
            value: "{colors.orange.90.value}"
        },
        error: {
            value: "{colors.red.90.value}"
        },
        success: {
            value: "{colors.green.90.value}"
        }
    },
    background: {
        primary: {
            value: "{colors.white.value}"
        },
        secondary: {
            value: "{colors.neutral.10.value}"
        },
        tertiary: {
            value: "{colors.neutral.20.value}"
        },
        quaternary: {
            value: "{colors.neutral.60.value}"
        },
        disabled: {
            value: "{colors.background.tertiary.value}"
        },
        info: {
            value: "{colors.blue.10.value}"
        },
        warning: {
            value: "{colors.orange.10.value}"
        },
        error: {
            value: "{colors.red.10.value}"
        },
        success: {
            value: "{colors.green.10.value}"
        }
    },
    border: {
        primary: {
            value: "{colors.neutral.60.value}"
        },
        secondary: {
            value: "{colors.neutral.40.value}"
        },
        tertiary: {
            value: "{colors.neutral.20.value}"
        },
        disabled: {
            value: "{colors.border.tertiary.value}"
        },
        pressed: {
            value: "{colors.primary.100.value}"
        },
        // Focus color is set to 100 to ensure enough contrast for accessibility
        focus: {
            value: "{colors.primary.100.value}"
        },
        error: {
            value: "{colors.red.80.value}"
        },
        info: {
            value: "{colors.blue.80.value}"
        },
        success: {
            value: "{colors.green.80.value}"
        },
        warning: {
            value: "{colors.orange.80.value}"
        }
    },
    shadow: {
        primary: {
            value: "hsla(210, 50%, 10%, 0.25)"
        },
        secondary: {
            value: "hsla(210, 50%, 10%, 0.15)"
        },
        tertiary: {
            value: "hsla(210, 50%, 10%, 0.05)"
        }
    },
    overlay: {
        5: {
            value: "hsla(0, 0%, 0%, 0.05)"
        },
        10: {
            value: "hsla(0, 0%, 0%, 0.1)"
        },
        20: {
            value: "hsla(0, 0%, 0%, 0.2)"
        },
        30: {
            value: "hsla(0, 0%, 0%, 0.3)"
        },
        40: {
            value: "hsla(0, 0%, 0%, 0.4)"
        },
        50: {
            value: "hsla(0, 0%, 0%, 0.5)"
        },
        60: {
            value: "hsla(0, 0%, 0%, 0.6)"
        },
        70: {
            value: "hsla(0, 0%, 0%, 0.7)"
        },
        80: {
            value: "hsla(0, 0%, 0%, 0.8)"
        },
        90: {
            value: "hsla(0, 0%, 0%, 0.9)"
        }
    },
    black: {
        value: "hsl(0, 0%, 0%)"
    },
    white: {
        value: "hsl(0, 0%, 100%)"
    },
    transparent: {
        value: "transparent"
    }
};


const $13df977a06165813$export$5ea928c9faf85bd3 = {
    // Default styles
    alignItems: {
        value: "center"
    },
    justifyContent: {
        value: "space-between"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    backgroundColor: {
        value: "{colors.background.tertiary.value}"
    },
    paddingBlock: {
        value: "{space.small.value}"
    },
    paddingInline: {
        value: "{space.medium.value}"
    },
    icon: {
        size: {
            value: "{fontSizes.xl.value}"
        }
    },
    heading: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        }
    },
    // Variations
    info: {
        color: {
            value: "{colors.font.info.value}"
        },
        backgroundColor: {
            value: "{colors.background.info.value}"
        }
    },
    error: {
        color: {
            value: "{colors.font.error.value}"
        },
        backgroundColor: {
            value: "{colors.background.error.value}"
        }
    },
    warning: {
        color: {
            value: "{colors.font.warning.value}"
        },
        backgroundColor: {
            value: "{colors.background.warning.value}"
        }
    },
    success: {
        color: {
            value: "{colors.font.success.value}"
        },
        backgroundColor: {
            value: "{colors.background.success.value}"
        }
    }
};


const $7e88ebc8544ce4a3$export$485ded5f26ebe08d = {
    menu: {
        width: {
            value: "100%"
        },
        marginBlockStart: {
            value: "{space.xxxs}"
        },
        backgroundColor: {
            value: "{colors.background.primary}"
        },
        borderColor: {
            value: "{colors.border.primary}"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        borderStyle: {
            value: "solid"
        },
        borderRadius: {
            value: "{radii.small}"
        },
        options: {
            display: {
                value: "flex"
            },
            flexDirection: {
                value: "column"
            },
            maxHeight: {
                value: "300px"
            }
        },
        option: {
            backgroundColor: {
                value: "{colors.background.primary}"
            },
            color: {
                value: "currentcolor"
            },
            cursor: {
                value: "pointer"
            },
            transitionDuration: {
                value: "{time.short}"
            },
            transitionProperty: {
                value: "background-color, color"
            },
            transitionTimingFunction: {
                value: "ease"
            },
            _active: {
                backgroundColor: {
                    value: "{colors.primary.80}"
                },
                color: {
                    value: "{colors.white}"
                }
            }
        },
        _empty: {
            display: {
                value: "flex"
            }
        },
        _loading: {
            alignItems: {
                value: "center"
            },
            display: {
                value: "flex"
            },
            gap: {
                value: "{space.xxxs}"
            }
        },
        spaceShared: {
            paddingBlock: {
                value: "{space.xs}"
            },
            paddingInline: {
                value: "{space.small}"
            }
        }
    }
};


const $ab16729f44aa3c63$export$d5cb6eef88ffbde2 = {
    maxWidth: {
        value: "60rem"
    },
    modal: {
        width: {
            value: "{space.relative.full}"
        },
        height: {
            value: "{space.relative.full}"
        },
        backgroundColor: {
            value: "{colors.overlay.50.value}"
        },
        top: {
            value: "{space.zero}"
        },
        left: {
            value: "{space.zero}"
        }
    },
    container: {
        widthMax: {
            value: "30rem"
        }
    },
    router: {
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        boxShadow: {
            value: "{shadows.medium.value}"
        }
    },
    footer: {
        paddingBottom: {
            value: "{space.medium.value}"
        }
    },
    form: {
        padding: {
            value: "{space.xl.value}"
        }
    },
    state: {
        inactive: {
            backgroundColor: {
                value: "{colors.background.secondary.value}"
            }
        }
    },
    orContainer: {
        color: {
            value: "{colors.neutral.80.value}"
        },
        orLine: {
            backgroundColor: {
                value: "{colors.background.primary.value}"
            }
        }
    }
};


const $63856cb27b0704ed$export$4aebd143f31d0c0d = {
    // Default styles
    color: {
        value: "{colors.font.primary.value}"
    },
    lineHeight: {
        value: 1
    },
    fontWeight: {
        value: "{fontWeights.semibold.value}"
    },
    fontSize: {
        value: "{fontSizes.small.value}"
    },
    textAlign: {
        value: "center"
    },
    paddingVertical: {
        value: "{space.xs.value}"
    },
    paddingHorizontal: {
        value: "{space.small.value}"
    },
    backgroundColor: {
        value: "{colors.background.tertiary.value}"
    },
    // An arbitrarily large value to ensure that the left and right sides of the badge are perfectly rounded for any size variation
    borderRadius: {
        value: "{radii.xl.value}"
    },
    // Variations
    info: {
        color: {
            value: "{colors.font.info.value}"
        },
        backgroundColor: {
            value: "{colors.background.info.value}"
        }
    },
    warning: {
        color: {
            value: "{colors.font.warning.value}"
        },
        backgroundColor: {
            value: "{colors.background.warning.value}"
        }
    },
    success: {
        color: {
            value: "{colors.font.success.value}"
        },
        backgroundColor: {
            value: "{colors.background.success.value}"
        }
    },
    error: {
        color: {
            value: "{colors.font.error.value}"
        },
        backgroundColor: {
            value: "{colors.background.error.value}"
        }
    },
    // Sizes
    small: {
        fontSize: {
            value: "{fontSizes.xs.value}"
        },
        paddingVertical: {
            value: "{space.xxs.value}"
        },
        paddingHorizontal: {
            value: "{space.xs.value}"
        }
    },
    // medium is the default size
    large: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        paddingVertical: {
            value: "{space.small.value}"
        },
        paddingHorizontal: {
            value: "{space.medium.value}"
        }
    }
};


const $86996efc4b0db584$export$515d2155aaad79e4 = {
    flexDirection: {
        value: "row"
    },
    flexWrap: {
        value: "wrap"
    },
    gap: {
        value: "0"
    },
    color: {
        value: "{colors.font.tertiary}"
    },
    item: {
        flexDirection: {
            value: "row"
        },
        color: {
            value: "inherit"
        },
        fontSize: {
            value: "inherit"
        },
        alignItems: {
            value: "center"
        },
        lineHeight: {
            value: "1"
        }
    },
    separator: {
        color: {
            value: "inherit"
        },
        fontSize: {
            value: "inherit"
        },
        paddingInline: {
            value: "{space.xxs}"
        }
    },
    link: {
        color: {
            value: "{components.link.color}"
        },
        fontSize: {
            value: "inherit"
        },
        fontWeight: {
            value: "normal"
        },
        textDecoration: {
            value: "none"
        },
        paddingInline: {
            value: "{space.xs}"
        },
        paddingBlock: {
            value: "{space.xxs}"
        },
        current: {
            color: {
                value: "inherit"
            },
            fontSize: {
                value: "inherit"
            },
            fontWeight: {
                value: "normal"
            },
            textDecoration: {
                value: "none"
            }
        }
    }
};


const $d57c4bc3f8164669$export$2ba01fb71ed41cb6 = {
    // shared styles
    fontWeight: {
        value: "{fontWeights.bold.value}"
    },
    transitionDuration: {
        value: "{components.fieldcontrol.transitionDuration.value}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize.value}"
    },
    lineHeight: {
        value: "{components.fieldcontrol.lineHeight.value}"
    },
    paddingBlockStart: {
        value: "{components.fieldcontrol.paddingBlockStart.value}"
    },
    paddingBlockEnd: {
        value: "{components.fieldcontrol.paddingBlockEnd.value}"
    },
    paddingInlineStart: {
        value: "{components.fieldcontrol.paddingInlineStart.value}"
    },
    paddingInlineEnd: {
        value: "{components.fieldcontrol.paddingInlineEnd.value}"
    },
    backgroundColor: {
        value: "transparent"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    borderWidth: {
        value: "{components.fieldcontrol.borderWidth.value}"
    },
    borderStyle: {
        value: "{components.fieldcontrol.borderStyle.value}"
    },
    borderRadius: {
        value: "{components.fieldcontrol.borderRadius.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    _hover: {
        color: {
            value: "{colors.font.focus.value}"
        },
        backgroundColor: {
            value: "{colors.primary.10.value}"
        },
        borderColor: {
            value: "{colors.primary.60.value}"
        }
    },
    _focus: {
        color: {
            value: "{colors.font.focus.value}"
        },
        backgroundColor: {
            value: "{colors.primary.10.value}"
        },
        borderColor: {
            value: "{colors.border.focus.value}"
        },
        boxShadow: {
            value: "{components.fieldcontrol._focus.boxShadow.value}"
        }
    },
    _active: {
        color: {
            value: "{colors.font.active.value}"
        },
        backgroundColor: {
            value: "{colors.primary.20.value}"
        },
        borderColor: {
            value: "{colors.primary.100.value}"
        }
    },
    _loading: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.border.tertiary.value}"
        }
    },
    _disabled: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.border.tertiary.value}"
        }
    },
    // variations
    outlined: {
        info: {
            borderColor: {
                value: "{colors.blue.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.blue.100}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.blue.60.value}"
                },
                backgroundColor: {
                    value: "{colors.blue.10.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.blue.100.value}"
                },
                backgroundColor: {
                    value: "{colors.blue.10.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.info._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.blue.100.value}"
                },
                backgroundColor: {
                    value: "{colors.blue.20.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                }
            }
        },
        warning: {
            borderColor: {
                value: "{colors.orange.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.orange.100}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.orange.60.value}"
                },
                backgroundColor: {
                    value: "{colors.orange.10.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.orange.100.value}"
                },
                backgroundColor: {
                    value: "{colors.orange.10.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.warning._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.orange.100.value}"
                },
                backgroundColor: {
                    value: "{colors.orange.20.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                }
            }
        },
        success: {
            borderColor: {
                value: "{colors.green.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.green.100}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.green.60.value}"
                },
                backgroundColor: {
                    value: "{colors.green.10.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.green.100.value}"
                },
                backgroundColor: {
                    value: "{colors.green.10.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.success._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.green.100.value}"
                },
                backgroundColor: {
                    value: "{colors.green.20.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                }
            }
        },
        error: {
            borderColor: {
                value: "{colors.red.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.red.100}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.red.60.value}"
                },
                backgroundColor: {
                    value: "{colors.red.10.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.red.100.value}"
                },
                backgroundColor: {
                    value: "{colors.red.10.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol._error._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.red.100.value}"
                },
                backgroundColor: {
                    value: "{colors.red.20.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                }
            }
        },
        overlay: {
            borderColor: {
                value: "{colors.overlay.60.value}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.primary.value}"
            },
            _hover: {
                borderColor: {
                    value: "{colors.overlay.60.value}"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                },
                color: {
                    value: "{colors.neutral.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.overlay.90.value}"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                },
                color: {
                    value: "{colors.neutral.90.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.overlay._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "{colors.overlay.90.value}"
                },
                backgroundColor: {
                    value: "{colors.overlay.10.value}"
                },
                color: {
                    value: "{colors.neutral.100.value}"
                }
            }
        }
    },
    primary: {
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        backgroundColor: {
            value: "{colors.primary.80.value}"
        },
        color: {
            value: "{colors.font.inverse.value}"
        },
        _disabled: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _loading: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _hover: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.primary.90.value}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            }
        },
        _focus: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.primary.90.value}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _active: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.primary.100.value}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            }
        },
        info: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.blue.80}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.info._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.100.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        },
        warning: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.orange.80}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.overlay._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.100.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        },
        error: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.red.80}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol._error._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.100.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        },
        success: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.green.80}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.success._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.100.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        },
        overlay: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.overlay.70}"
            },
            color: {
                value: "{colors.font.inverse.value}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.overlay._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.90.value}"
                },
                color: {
                    value: "{colors.font.inverse.value}"
                }
            }
        }
    },
    menu: {
        borderWidth: {
            value: "{space.zero.value}"
        },
        backgroundColor: {
            value: "transparent"
        },
        justifyContent: {
            value: "start"
        },
        // Focus and hover styles are identical for menu variation
        // because for Menu primitive, menu items are forced to be focused even
        // for mouse interactions, making it impossible to distinguish the two interactions
        _hover: {
            color: {
                value: "{colors.font.inverse.value}"
            },
            backgroundColor: {
                value: "{colors.primary.80.value}"
            }
        },
        _focus: {
            color: {
                value: "{colors.font.inverse.value}"
            },
            backgroundColor: {
                value: "{colors.primary.80.value}"
            }
        },
        _active: {
            color: {
                value: "{colors.font.inverse.value}"
            },
            backgroundColor: {
                value: "{colors.primary.90.value}"
            }
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    },
    link: {
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        color: {
            value: "{colors.font.interactive.value}"
        },
        _hover: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.primary.10.value}"
            },
            color: {
                value: "{colors.font.hover.value}"
            }
        },
        _focus: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.primary.10.value}"
            },
            color: {
                value: "{colors.font.focus.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _active: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.primary.20.value}"
            },
            color: {
                value: "{colors.font.active.value}"
            }
        },
        _disabled: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _loading: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        info: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.blue.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.10.value}"
                },
                color: {
                    value: "{colors.blue.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.10.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.info._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.blue.20.value}"
                },
                color: {
                    value: "{colors.blue.100.value}"
                }
            }
        },
        warning: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.orange.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.10.value}"
                },
                color: {
                    value: "{colors.orange.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.10.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.warning._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.orange.20.value}"
                },
                color: {
                    value: "{colors.orange.100.value}"
                }
            }
        },
        success: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.green.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.10.value}"
                },
                color: {
                    value: "{colors.green.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.10.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.success._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.green.20.value}"
                },
                color: {
                    value: "{colors.green.100.value}"
                }
            }
        },
        error: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.red.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.10.value}"
                },
                color: {
                    value: "{colors.red.90.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.10.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol._error._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.red.20.value}"
                },
                color: {
                    value: "{colors.red.100.value}"
                }
            }
        },
        overlay: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.neutral.100}"
            },
            _hover: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                },
                color: {
                    value: "{colors.overlay.80.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                },
                color: {
                    value: "{colors.overlay.90.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol.overlay._focus.boxShadow.value}"
                }
            },
            _active: {
                borderColor: {
                    value: "transparent"
                },
                backgroundColor: {
                    value: "{colors.overlay.10.value}"
                },
                color: {
                    value: "{colors.overlay.90.value}"
                }
            }
        }
    },
    warning: {
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.red.60}"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        color: {
            value: "{colors.red.60}"
        },
        _hover: {
            borderColor: {
                value: "{colors.red.80}"
            },
            backgroundColor: {
                value: "{colors.red.10}"
            },
            color: {
                value: "{colors.font.error}"
            }
        },
        _focus: {
            borderColor: {
                value: "{colors.red.80}"
            },
            backgroundColor: {
                value: "{colors.red.10}"
            },
            color: {
                value: "{colors.red.80}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._error._focus.boxShadow}"
            }
        },
        _active: {
            borderColor: {
                value: "{colors.red.100}"
            },
            backgroundColor: {
                value: "{colors.red.20}"
            },
            color: {
                value: "{colors.red.100}"
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.tertiary}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled}"
            }
        },
        _loading: {
            borderColor: {
                value: "{colors.border.tertiary}"
            },
            backgroundColor: {
                value: "transparent"
            },
            color: {
                value: "{colors.font.disabled}"
            }
        }
    },
    destructive: {
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        borderStyle: {
            value: "solid"
        },
        backgroundColor: {
            value: "{colors.red.60}"
        },
        color: {
            value: "{colors.font.inverse}"
        },
        _disabled: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled}"
            },
            color: {
                value: "{colors.font.disabled}"
            }
        },
        _loading: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.background.disabled}"
            },
            color: {
                value: "{colors.font.disabled}"
            }
        },
        _hover: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.red.80}"
            },
            color: {
                value: "{colors.font.inverse}"
            }
        },
        _focus: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.red.80}"
            },
            color: {
                value: "{colors.font.inverse}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._error._focus.boxShadow}"
            }
        },
        _active: {
            borderColor: {
                value: "transparent"
            },
            backgroundColor: {
                value: "{colors.red.100}"
            },
            color: {
                value: "{colors.font.inverse}"
            }
        }
    },
    // sizes
    small: {
        fontSize: {
            value: "{components.fieldcontrol.small.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{components.fieldcontrol.small.paddingBlockStart.value}"
        },
        paddingBlockEnd: {
            value: "{components.fieldcontrol.small.paddingBlockEnd.value}"
        },
        paddingInlineStart: {
            value: "{components.fieldcontrol.small.paddingInlineStart.value}"
        },
        paddingInlineEnd: {
            value: "{components.fieldcontrol.small.paddingInlineEnd.value}"
        }
    },
    large: {
        fontSize: {
            value: "{components.fieldcontrol.large.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{components.fieldcontrol.large.paddingBlockStart.value}"
        },
        paddingBlockEnd: {
            value: "{components.fieldcontrol.large.paddingBlockEnd.value}"
        },
        paddingInlineStart: {
            value: "{components.fieldcontrol.large.paddingInlineStart.value}"
        },
        paddingInlineEnd: {
            value: "{components.fieldcontrol.large.paddingInlineEnd.value}"
        }
    },
    loaderWrapper: {
        alignItems: {
            value: "center"
        },
        gap: {
            value: "{space.xs.value}"
        }
    }
};


const $308bff62c060e78b$export$aa3e815946b80764 = {
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    borderRadius: {
        value: "{radii.xs.value}"
    },
    borderWidth: {
        value: "0"
    },
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "transparent"
    },
    boxShadow: {
        value: "none"
    },
    padding: {
        value: "{space.medium.value}"
    },
    outlined: {
        backgroundColor: {
            value: "{components.card.backgroundColor.value}"
        },
        borderRadius: {
            value: "{radii.xs.value}"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        boxShadow: {
            value: "{components.card.boxShadow.value}"
        }
    },
    elevated: {
        backgroundColor: {
            value: "{components.card.backgroundColor.value}"
        },
        borderRadius: {
            value: "{radii.xs.value}"
        },
        borderWidth: {
            value: "0"
        },
        borderStyle: {
            value: "solid"
        },
        borderColor: {
            value: "transparent"
        },
        boxShadow: {
            value: "{shadows.medium.value}"
        }
    }
};


const $15649632a2a05b26$export$b07e517d22efa1ca = {
    cursor: {
        value: "pointer"
    },
    alignItems: {
        value: "center"
    },
    _disabled: {
        cursor: {
            value: "not-allowed"
        }
    },
    button: {
        position: {
            value: "relative"
        },
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "center"
        },
        color: {
            value: "{colors.font.inverse.value}"
        },
        before: {
            width: {
                value: "100%"
            },
            height: {
                value: "100%"
            },
            borderWidth: {
                value: "{borderWidths.medium.value}"
            },
            borderRadius: {
                value: "20%"
            },
            borderStyle: {
                value: "solid"
            },
            borderColor: {
                value: "{colors.border.primary.value}"
            }
        },
        _focus: {
            outlineColor: {
                value: "{colors.transparent.value}"
            },
            outlineStyle: {
                value: "solid"
            },
            outlineWidth: {
                value: "{outlineWidths.medium.value}"
            },
            outlineOffset: {
                value: "{outlineOffsets.medium.value}"
            },
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.disabled.value}"
            }
        },
        _error: {
            borderColor: {
                value: "{colors.border.error.value}"
            },
            _focus: {
                borderColor: {
                    value: "{colors.border.error.value}"
                },
                boxShadow: {
                    value: "{components.fieldcontrol._error._focus.boxShadow.value}"
                }
            }
        }
    },
    icon: {
        backgroundColor: {
            value: "{colors.primary.80.value}"
        },
        borderRadius: {
            value: "20%"
        },
        opacity: {
            value: "{opacities.0.value}"
        },
        transform: {
            value: "scale(0)"
        },
        transitionProperty: {
            value: "all"
        },
        transitionDuration: {
            value: "{time.short.value}"
        },
        transitionTimingFunction: {
            value: "ease-in-out"
        },
        _checked: {
            opacity: {
                value: "{opacities.100.value}"
            },
            transform: {
                value: "scale(1)"
            },
            _disabled: {
                backgroundColor: {
                    value: "{colors.background.disabled.value}"
                }
            }
        },
        _indeterminate: {
            opacity: {
                value: "{opacities.100.value}"
            },
            transform: {
                value: "scale(1)"
            },
            _disabled: {
                backgroundColor: {
                    value: "{colors.background.disabled.value}"
                }
            }
        }
    },
    label: {
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    }
};


const $44dde6f748ed9e44$export$282c9e915736aefa = {
    alignItems: {
        value: "flex-start"
    },
    alignContent: {
        value: "center"
    },
    flexDirection: {
        value: "column"
    },
    justifyContent: {
        value: "center"
    }
};


//we are reusing the types from the nested components but new tokens need to be created that reference the previous tokens so that they can inherit the needed values but can be overwritten and only effect the collection component.
//only a subset of the design tokens of the nested components are being exposed, this can be expanded later.
const $b98d27ee91683457$export$bf5175b0c24981cd = {
    pagination: {
        current: {
            color: {
                value: "{components.pagination.current.color}"
            },
            backgroundColor: {
                value: "{components.pagination.current.backgroundColor}"
            }
        },
        button: {
            color: {
                value: "{components.pagination.button.color}"
            },
            _hover: {
                backgroundColor: {
                    value: "{components.pagination.button.hover.backgroundColor}"
                },
                color: {
                    value: "{components.pagination.button.hover.color}"
                }
            },
            _disabled: {
                color: {
                    value: "{components.pagination.button.disabled.color}"
                }
            }
        }
    },
    search: {
        input: {
            color: {
                value: "{components.searchfield.color}"
            }
        },
        button: {
            color: {
                value: "{components.searchfield.button.color}"
            },
            _active: {
                backgroundColor: {
                    value: "{components.searchfield.button._active.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._active.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._active.color}"
                }
            },
            _disabled: {
                backgroundColor: {
                    value: "{components.searchfield.button._disabled.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._disabled.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._disabled.color}"
                }
            },
            _focus: {
                backgroundColor: {
                    value: "{components.searchfield.button._focus.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._focus.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._focus.color}"
                }
            },
            _hover: {
                backgroundColor: {
                    value: "{components.searchfield.button._hover.backgroundColor}"
                },
                borderColor: {
                    value: "{components.searchfield.button._hover.borderColor}"
                },
                color: {
                    value: "{components.searchfield.button._hover.color}"
                }
            }
        }
    }
};


const $4729658ec87c92d4$export$784d13d8ee351f07 = {
    fontSize: {
        value: "{fontSizes.xs}"
    },
    gap: {
        value: "{space.relative.medium}"
    },
    svg: {
        path: {
            fill: {
                value: "{colors.font.primary}"
            }
        }
    },
    toolTip: {
        bottom: {
            value: "{space.large}"
        },
        color: {
            value: "{colors.teal.100}"
        },
        fontSize: {
            value: "{fontSizes.xxs}"
        }
    }
};


const $26bfee4cb464d821$export$5a80fc6ecf647d64 = {
    height: {
        value: "{space.relative.full.value}"
    }
};


const $be165c9ec3c6e836$export$e8c9778bf415dd08 = {
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    borderWidth: {
        value: "{borderWidths.medium.value}"
    },
    label: {
        color: {
            value: "{colors.font.tertiary.value}"
        },
        paddingInline: {
            value: "{space.medium.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        }
    },
    small: {
        borderWidth: {
            value: "{borderWidths.small.value}"
        }
    },
    large: {
        borderWidth: {
            value: "{borderWidths.large.value}"
        }
    },
    opacity: {
        value: "{opacities.60.value}"
    }
};


const $e2a709987030359a$export$585d0a7a39ed94ea = {
    backgroundColor: {
        value: "{colors.background.primary}"
    },
    borderRadius: {
        value: "{radii.small}"
    },
    borderColor: {
        value: "{colors.border.primary}"
    },
    borderStyle: {
        value: "dashed"
    },
    borderWidth: {
        value: "{borderWidths.small}"
    },
    color: {
        value: "{colors.font.primary}"
    },
    gap: {
        value: "{space.small}"
    },
    paddingBlock: {
        value: "{space.xl}"
    },
    paddingInline: {
        value: "{space.large}"
    },
    textAlign: {
        value: "center"
    },
    _active: {
        backgroundColor: {
            value: "{colors.primary.10}"
        },
        borderRadius: {
            value: "{components.dropzone.borderRadius}"
        },
        borderColor: {
            value: "{colors.border.pressed}"
        },
        borderStyle: {
            value: "{components.dropzone.borderStyle}"
        },
        borderWidth: {
            value: "{components.dropzone.borderWidth}"
        },
        color: {
            value: "{colors.font.primary}"
        }
    },
    _disabled: {
        backgroundColor: {
            value: "{colors.background.disabled}"
        },
        borderRadius: {
            value: "{components.dropzone.borderRadius}"
        },
        borderColor: {
            value: "{colors.border.disabled}"
        },
        borderStyle: {
            value: "{components.dropzone.borderStyle}"
        },
        borderWidth: {
            value: "{components.dropzone.borderWidth}"
        },
        color: {
            value: "{colors.font.disabled}"
        }
    },
    accepted: {
        backgroundColor: {
            value: "{colors.background.success}"
        },
        borderRadius: {
            value: "{components.dropzone.borderRadius}"
        },
        borderColor: {
            value: "{colors.border.success}"
        },
        borderStyle: {
            value: "{components.dropzone.borderStyle}"
        },
        borderWidth: {
            value: "{components.dropzone.borderWidth}"
        },
        color: {
            value: "{colors.font.success}"
        }
    },
    rejected: {
        backgroundColor: {
            value: "{colors.background.error}"
        },
        borderRadius: {
            value: "{components.dropzone.borderRadius}"
        },
        borderColor: {
            value: "{colors.border.pressed}"
        },
        borderStyle: {
            value: "{components.dropzone.borderStyle}"
        },
        borderWidth: {
            value: "{components.dropzone.borderWidth}"
        },
        color: {
            value: "{colors.font.error}"
        }
    }
};


const $ade26c81fbc2509a$export$77f5744dadf9dca6 = {
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    item: {
        borderColor: {
            value: "{colors.border.secondary.value}"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderRadius: {
            value: "{radii.small.value}"
        },
        trigger: {
            alignItems: {
                value: "center"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            color: {
                value: "inherit"
            },
            gap: {
                value: "{space.small.value}"
            },
            justifyContent: {
                value: "space-between"
            },
            paddingBlock: {
                value: "{space.xs.value}"
            },
            paddingInline: {
                value: "{space.small.value}"
            },
            _hover: {
                color: {
                    value: "inherit"
                },
                backgroundColor: {
                    value: "{colors.overlay.5.value}"
                }
            },
            _focus: {
                borderColor: {
                    value: "{colors.border.focus.value}"
                },
                boxShadow: {
                    value: {
                        offsetX: "0",
                        offsetY: "0",
                        blurRadius: "0",
                        spreadRadius: "2px",
                        color: "{colors.border.focus.value}"
                    }
                }
            }
        },
        content: {
            color: {
                value: "inherit"
            },
            paddingInline: {
                value: "{space.small.value}"
            },
            paddingBlockEnd: {
                value: "{space.small.value}"
            },
            paddingBlockStart: {
                value: "{space.xxxs.value}"
            }
        },
        icon: {
            color: {
                value: "{colors.font.tertiary.value}"
            },
            transitionDuration: {
                value: "{time.medium.value}"
            },
            transitionTimingFunction: {
                value: "cubic-bezier(0.87, 0, 0.13, 1)"
            }
        }
    }
};


const $03fae1bdfd3fa337$export$e0f35d825088c098 = {
    // default styles
    gap: {
        value: "{space.xs.value}"
    },
    fontSize: {
        value: "{fontSizes.medium.value}"
    },
    flexDirection: {
        value: "column"
    },
    // Adjust base fontSize and gap for small and large sizes
    small: {
        gap: {
            value: "{space.xxxs.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    large: {
        gap: {
            value: "{space.small.value}"
        },
        fontSize: {
            value: "{fontSizes.large.value}"
        }
    },
    label: {
        color: {
            value: "{colors.font.secondary.value}"
        }
    }
};


const $98b38cee62d197fa$export$5ba822cdf6eca6d5 = {
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    borderWidth: {
        value: "{borderWidths.small.value}"
    },
    borderRadius: {
        value: "{radii.small.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    paddingBlockStart: {
        value: "{space.xs.value}"
    },
    paddingBlockEnd: {
        value: "{space.xs.value}"
    },
    paddingInlineStart: {
        value: "{space.medium.value}"
    },
    paddingInlineEnd: {
        value: "{space.medium.value}"
    },
    fontSize: {
        value: "{components.field.fontSize.value}"
    },
    lineHeight: {
        value: "{lineHeights.medium.value}"
    },
    transitionDuration: {
        value: "{time.medium.value}"
    },
    outlineColor: {
        value: "{colors.transparent.value}"
    },
    outlineStyle: {
        value: "solid"
    },
    outlineWidth: {
        value: "{outlineWidths.medium.value}"
    },
    outlineOffset: {
        value: "{outlineOffsets.medium.value}"
    },
    small: {
        fontSize: {
            value: "{components.field.small.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{space.xxs.value}"
        },
        paddingBlockEnd: {
            value: "{space.xxs.value}"
        },
        paddingInlineStart: {
            value: "{space.small.value}"
        },
        paddingInlineEnd: {
            value: "{space.small.value}"
        }
    },
    large: {
        fontSize: {
            value: "{components.field.large.fontSize.value}"
        },
        paddingBlockStart: {
            value: "{space.xs.value}"
        },
        paddingBlockEnd: {
            value: "{space.xs.value}"
        },
        paddingInlineStart: {
            value: "{space.medium.value}"
        },
        paddingInlineEnd: {
            value: "{space.medium.value}"
        }
    },
    quiet: {
        borderStyle: {
            value: "none"
        },
        borderInlineStart: {
            value: "none"
        },
        borderInlineEnd: {
            value: "none"
        },
        borderBlockStart: {
            value: "none"
        },
        borderRadius: {
            value: "0"
        },
        _focus: {
            borderBlockEndColor: {
                value: "transparent"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _error: {
            borderBlockEndColor: {
                value: "{colors.border.error.value}"
            },
            _focus: {
                borderBlockEndColor: {
                    value: "transparent"
                },
                boxShadow: {
                    value: "{components.fieldcontrol._error._focus.boxShadow.value}"
                }
            }
        }
    },
    _focus: {
        // These focus styles have been calibrated to create
        // a highly visible focus indicator per WCAG 2.2 guidlines:
        // See: https://www.w3.org/TR/WCAG22/#focus-appearance
        //
        // Key features:
        // * Focus indicator area is at least the 2 CSS px perimeter around the component.
        // * Contrast between focused and unfocused area of contrast has a ratio of 3:1
        //
        // IMPORTANT: Must recalibrate if `colors.border.focus` are changed
        borderColor: {
            value: "{colors.border.focus.value}"
        },
        boxShadow: {
            value: {
                offsetX: "0px",
                offsetY: "0px",
                blurRadius: "0px",
                spreadRadius: "2px",
                color: "{colors.border.focus.value}"
            }
        }
    },
    _disabled: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        cursor: {
            value: "not-allowed"
        },
        borderColor: {
            value: "{colors.transparent.value}"
        },
        backgroundColor: {
            value: "{colors.background.disabled.value}"
        }
    },
    _error: {
        borderColor: {
            value: "{colors.border.error.value}"
        },
        color: {
            value: "{colors.font.error.value}"
        },
        _focus: {
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "2px",
                    color: "{colors.border.error.value}"
                }
            }
        }
    },
    info: {
        _focus: {
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "2px",
                    color: "{colors.blue.100.value}"
                }
            }
        }
    },
    warning: {
        _focus: {
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "2px",
                    color: "{colors.orange.100.value}"
                }
            }
        }
    },
    success: {
        _focus: {
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "2px",
                    color: "{colors.green.100.value}"
                }
            }
        }
    },
    overlay: {
        _focus: {
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "2px",
                    color: "{colors.overlay.90.value}"
                }
            }
        }
    }
};


const $858984f810d31c60$export$886e4abc352a8403 = {
    gap: {
        value: "{space.zero.value}"
    },
    vertical: {
        alignItems: {
            value: "center"
        }
    },
    outer: {
        alignItems: {
            value: "center"
        }
    }
};


const $f65b2456eb2513a2$export$a38812d1aa1302d9 = {
    backgroundColor: {
        value: "transparent"
    },
    borderRadius: {
        value: "{radii.xs.value}"
    },
    flexDirection: {
        value: "column"
    },
    gap: {
        value: "{components.field.gap.value}"
    },
    legend: {
        color: {
            value: "{colors.font.primary.value}"
        },
        fontSize: {
            value: "{components.field.fontSize.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        },
        lineHeight: {
            value: "{lineHeights.medium.value}"
        },
        small: {
            fontSize: "{components.field.small.fontSize.value}"
        },
        large: {
            fontSize: "{components.field.large.fontSize.value}"
        }
    },
    outlined: {
        padding: "{space.medium.value}",
        borderColor: "{colors.neutral.40.value}",
        borderWidth: "{borderWidths.small.value}",
        borderStyle: "solid",
        small: {
            padding: "{space.small.value}"
        },
        large: {
            padding: "{space.large.value}"
        }
    },
    small: {
        gap: "{components.field.small.gap.value}"
    },
    large: {
        gap: "{components.field.large.gap.value}"
    }
};


const $0e2b67e28bbe45b8$export$b29676ca3eb575f7 = {
    error: {
        color: {
            value: "{colors.font.error.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    description: {
        color: {
            value: "{colors.font.secondary.value}"
        },
        fontStyle: {
            value: "italic"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    }
};


const $37361d9099acfc3f$export$97691fbb80847c19 = {
    gap: {
        value: "{space.medium.value}"
    },
    justifyContent: {
        value: "normal"
    },
    alignItems: {
        value: "stretch"
    },
    alignContent: {
        value: "normal"
    },
    flexWrap: {
        value: "nowrap"
    }
};


const $2a854077f8c8bd68$export$46e4a324ac90507f = {
    color: {
        value: "{colors.font.primary.value}"
    },
    lineHeight: {
        value: "{lineHeights.small.value}"
    },
    1: {
        fontSize: {
            value: "{fontSizes.xxxxl.value}"
        },
        fontWeight: {
            value: "{fontWeights.light.value}"
        }
    },
    2: {
        fontSize: {
            value: "{fontSizes.xxxl.value}"
        },
        fontWeight: {
            value: "{fontWeights.normal.value}"
        }
    },
    3: {
        fontSize: {
            value: "{fontSizes.xxl.value}"
        },
        fontWeight: {
            value: "{fontWeights.medium.value}"
        }
    },
    4: {
        fontSize: {
            value: "{fontSizes.xl.value}"
        },
        fontWeight: {
            value: "{fontWeights.semibold.value}"
        }
    },
    5: {
        fontSize: {
            value: "{fontSizes.large.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        }
    },
    6: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.extrabold.value}"
        }
    }
};


const $850263ca26b2c217$export$5340050496cd0f8f = {
    highlighted: {
        fontWeight: {
            value: "{fontWeights.bold}"
        }
    }
};


const $ab78a71e975133a2$export$1ca1ec8b29a4ce27 = {
    lineHeight: {
        value: 1
    },
    height: {
        value: "1em"
    }
};


const $56a572806ec0e05a$export$b7e3ae3d7c15e42e = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize.value}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor.value}"
        }
    }
};


const $bbca92e21b90107c$export$5c452ff88e35e47d = {
    maxWidth: {
        value: "100%"
    },
    height: {
        value: "auto"
    },
    objectFit: {
        value: "initial"
    },
    objectPosition: {
        value: "initial"
    }
};


const $28eb775d38ccd62e$export$be5f4c7eec37e17e = {
    banner: {
        height: {
            value: "150px "
        },
        width: {
            value: "400px "
        }
    },
    button: {
        backgroundColor: {
            value: "#e8e8e8"
        },
        borderRadius: {
            value: "5px"
        },
        color: {
            value: "black"
        }
    },
    dialog: {
        height: {
            value: "50vh"
        },
        minHeight: {
            value: "400px"
        },
        minWidth: {
            value: "400px"
        },
        width: {
            value: "30vw"
        }
    },
    header: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.extrabold.value}"
        }
    }
};


const $5c942e642e591541$export$9c30223ca0a664fb = {
    active: {
        color: {
            value: "{colors.font.active.value}"
        }
    },
    color: {
        value: "{colors.font.interactive.value}"
    },
    focus: {
        color: {
            value: "{colors.font.focus.value}"
        }
    },
    hover: {
        color: {
            value: "{colors.font.hover.value}"
        }
    },
    visited: {
        color: {
            value: "{colors.font.interactive.value}"
        }
    }
};


const $539ec312fad8cc88$export$674047c1a0a83243 = {
    cameraModule: {
        backgroundColor: {
            value: "{colors.black}"
        }
    }
};


const $52d09c99cf0e629d$export$f4c5de44377d2946 = {
    width: {
        value: "{fontSizes.medium.value}"
    },
    height: {
        value: "{fontSizes.medium.value}"
    },
    fontSize: {
        value: "{fontSizes.xs.value}"
    },
    strokeEmpty: {
        value: "{colors.neutral.20.value}"
    },
    strokeFilled: {
        value: "{colors.primary.80.value}"
    },
    strokeLinecap: {
        value: "round"
    },
    animationDuration: {
        value: "1s"
    },
    small: {
        width: {
            value: "{fontSizes.small.value}"
        },
        height: {
            value: "{fontSizes.small.value}"
        },
        fontSize: {
            value: "{fontSizes.xxs.value}"
        }
    },
    large: {
        width: {
            value: "{fontSizes.large.value}"
        },
        height: {
            value: "{fontSizes.large.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    linear: {
        width: {
            value: "100%"
        },
        minWidth: {
            value: "5rem"
        },
        fontSize: {
            value: "{fontSizes.xxs.value}"
        },
        strokeWidth: {
            value: "{fontSizes.xxs.value}"
        },
        strokeFilled: {
            value: "{colors.primary.80.value}"
        },
        strokeEmpty: {
            value: "{colors.neutral.20.value}"
        },
        strokeLinecap: {
            value: "round"
        },
        animationDuration: {
            value: "1s"
        },
        small: {
            strokeWidth: {
                value: "{fontSizes.xxxs.value}"
            },
            fontSize: {
                value: "{fontSizes.xxxs.value}"
            }
        },
        large: {
            strokeWidth: {
                value: "{fontSizes.xs.value}"
            },
            fontSize: {
                value: "{fontSizes.xs.value}"
            }
        }
    },
    text: {
        fill: {
            value: "{colors.font.primary.value}"
        }
    }
};


const $726698dda08ca16e$export$b1e5508a851be14d = {
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    borderRadius: {
        value: "{radii.medium.value}"
    },
    borderWidth: {
        value: "{borderWidths.small.value}"
    },
    borderStyle: {
        value: "solid"
    },
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    boxShadow: {
        value: "{shadows.large.value}"
    },
    flexDirection: {
        value: "column"
    },
    gap: {
        value: "{space.zero.value}"
    },
    maxWidth: {
        value: "30rem"
    },
    minWidth: {
        value: "14rem"
    },
    small: {
        width: {
            value: "{fontSizes.medium.value}"
        },
        height: {
            value: "{fontSizes.medium.value}"
        }
    },
    large: {
        width: {
            value: "{fontSizes.xxxl.value}"
        },
        height: {
            value: "{fontSizes.xxxl.value}"
        }
    },
    item: {
        minHeight: {
            value: "2.5rem"
        },
        paddingInlineStart: {
            value: "{space.medium.value}"
        },
        paddingInlineEnd: {
            value: "{space.medium.value}"
        }
    }
};


const $ebec8146d60d7073$export$a8ecead220dd38a6 = {
    // Default styles
    alignItems: {
        value: "center"
    },
    backgroundColor: {
        value: "{colors.background.tertiary.value}"
    },
    borderColor: {
        value: "transparent"
    },
    borderStyle: {
        value: "solid"
    },
    borderWidth: {
        value: "{borderWidths.small.value}"
    },
    borderRadius: {
        value: "{radii.xs.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    justifyContent: {
        value: "flex-start"
    },
    paddingBlock: {
        value: "{space.small.value}"
    },
    paddingInline: {
        value: "{space.medium.value}"
    },
    lineHeight: {
        value: "{lineHeights.small.value}"
    },
    icon: {
        size: {
            value: "{fontSizes.xl.value}"
        }
    },
    heading: {
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        }
    },
    dismiss: {
        gap: {
            value: "{space.xxs.value}"
        }
    },
    // Variations
    plain: {
        color: {
            value: "{colors.font.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        borderColor: {
            value: "transparent"
        },
        info: {
            color: {
                value: "{colors.font.info.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        error: {
            color: {
                value: "{colors.font.error.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        success: {
            color: {
                value: "{colors.font.success.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        warning: {
            color: {
                value: "{colors.font.warning.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "transparent"
            }
        }
    },
    outlined: {
        color: {
            value: "{colors.font.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        info: {
            color: {
                value: "{colors.font.info.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.info.value}"
            }
        },
        error: {
            color: {
                value: "{colors.font.error.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.error.value}"
            }
        },
        success: {
            color: {
                value: "{colors.font.success.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.success.value}"
            }
        },
        warning: {
            color: {
                value: "{colors.font.warning.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.warning.value}"
            }
        }
    },
    filled: {
        color: {
            value: "{colors.font.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.secondary.value}"
        },
        borderColor: {
            value: "transparent"
        },
        info: {
            color: {
                value: "{colors.font.info.value}"
            },
            backgroundColor: {
                value: "{colors.background.info.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        error: {
            color: {
                value: "{colors.font.error.value}"
            },
            backgroundColor: {
                value: "{colors.background.error.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        success: {
            color: {
                value: "{colors.font.success.value}"
            },
            backgroundColor: {
                value: "{colors.background.success.value}"
            },
            borderColor: {
                value: "transparent"
            }
        },
        warning: {
            color: {
                value: "{colors.font.warning.value}"
            },
            backgroundColor: {
                value: "{colors.background.warning.value}"
            },
            borderColor: {
                value: "transparent"
            }
        }
    }
};


const $2ac66cb390315301$export$22fa394f3ba39578 = {
    current: {
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "center"
        },
        color: {
            value: "{colors.font.inverse.value}"
        },
        fontSize: {
            value: "{fontSizes.small.value}"
        },
        backgroundColor: {
            value: "{colors.overlay.40.value}"
        }
    },
    button: {
        color: {
            value: "{colors.font.primary.value}"
        },
        paddingInlineStart: {
            value: "{space.xxs.value}"
        },
        paddingInlineEnd: {
            value: "{space.xxs.value}"
        },
        transitionProperty: {
            value: "background-color"
        },
        transitionDuration: {
            value: "{time.medium.value}"
        },
        hover: {
            backgroundColor: {
                value: "{colors.overlay.10.value}"
            },
            color: {
                value: "{colors.font.primary.value}"
            }
        },
        disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    },
    ellipsis: {
        alignItems: {
            value: "baseline"
        },
        justifyContent: {
            value: "center"
        },
        paddingInlineStart: {
            value: "{space.xs.value}"
        },
        paddingInlineEnd: {
            value: "{space.xs.value}"
        }
    },
    itemContainer: {
        marginLeft: {
            value: "{space.xxxs.value}"
        },
        marginRight: {
            value: "{space.xxxs.value}"
        }
    },
    itemShared: {
        height: {
            value: "{fontSizes.xxl.value}"
        },
        minWidth: {
            value: "{fontSizes.xxl.value}"
        },
        borderRadius: {
            value: "{fontSizes.medium.value}"
        }
    }
};


const $bd8cfe96ff1426bb$export$75dd6c0d8e7c7e6b = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    button: {
        color: {
            value: "{components.button.color.value}"
        },
        _active: {
            backgroundColor: {
                value: "{components.button._active.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._active.borderColor.value}"
            },
            color: {
                value: "{components.button._active.color.value}"
            }
        },
        _disabled: {
            backgroundColor: {
                value: "{components.button._disabled.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._disabled.borderColor.value}"
            },
            color: {
                value: "{components.button._disabled.color.value}"
            }
        },
        _focus: {
            backgroundColor: {
                value: "{components.button._focus.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._focus.borderColor.value}"
            },
            color: {
                value: "{components.button._focus.color.value}"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{components.button._hover.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._hover.borderColor.value}"
            },
            color: {
                value: "{components.button._hover.color.value}"
            }
        }
    }
};


const $21caf2a477c461fe$export$2b14d7973e978f83 = {
    color: {
        value: "{components.fieldcontrol.color}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor}"
        }
    }
};


const $de7407de890c2f24$export$c7187bbd1a7a9244 = {
    borderRadius: {
        value: "{radii.small.value}"
    },
    transitionDuration: {
        value: "{time.long.value}"
    },
    startColor: {
        value: "{colors.background.secondary.value}"
    },
    endColor: {
        value: "{colors.background.tertiary.value}"
    },
    // sizes
    small: {
        height: {
            value: "{space.small.value}"
        }
    },
    default: {
        height: {
            value: "{space.medium.value}"
        }
    },
    large: {
        height: {
            value: "{space.large.value}"
        }
    }
};


const $27e6103548484ca8$export$b56dc0f160585b86 = {
    alignItems: {
        value: "center"
    },
    justifyContent: {
        value: "flex-start"
    },
    gap: {
        value: "inherit"
    },
    _disabled: {
        cursor: {
            value: "not-allowed"
        }
    },
    button: {
        alignItems: {
            value: "center"
        },
        justifyContent: {
            value: "center"
        },
        width: {
            value: "{fontSizes.medium.value}"
        },
        height: {
            value: "{fontSizes.medium.value}"
        },
        boxSizing: {
            value: "border-box"
        },
        borderWidth: {
            value: "{borderWidths.medium.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderRadius: {
            value: "50%"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        color: {
            value: "{colors.background.primary.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        transitionProperty: {
            value: "all"
        },
        transitionDuration: {
            value: "{time.medium.value}"
        },
        outlineColor: {
            value: "{colors.transparent.value}"
        },
        outlineStyle: {
            value: "solid"
        },
        outlineWidth: {
            value: "{outlineWidths.medium.value}"
        },
        outlineOffset: {
            value: "{outlineOffsets.medium.value}"
        },
        // We want the dot inside the border to be a border-width from the border
        padding: {
            value: "{borderWidths.medium.value}"
        },
        small: {
            width: {
                value: "{fontSizes.small.value}"
            },
            height: {
                value: "{fontSizes.small.value}"
            }
        },
        large: {
            width: {
                value: "{fontSizes.large.value}"
            },
            height: {
                value: "{fontSizes.large.value}"
            }
        },
        _checked: {
            color: {
                value: "{colors.primary.80.value}"
            },
            _disabled: {
                color: {
                    value: "{colors.background.disabled.value}"
                }
            }
        },
        _focus: {
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        },
        _error: {
            borderColor: {
                value: "{colors.border.error.value}"
            },
            _focus: {
                boxShadow: {
                    value: "{components.fieldcontrol._error._focus.boxShadow.value}"
                }
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.disabled.value}"
            },
            backgroundColor: {
                value: "{colors.background.primary.value}"
            }
        }
    },
    label: {
        color: {
            value: "{components.text.color.value}"
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    }
};


const $9e25f8d0489ddfeb$export$19d611f01a2bdcee = {
    radio: {
        borderWidth: {
            value: "{components.radio.button.borderWidth}"
        },
        borderColor: {
            value: "{components.radio.button.borderColor}"
        },
        backgroundColor: {
            value: "{components.radio.button.backgroundColor}"
        },
        _checked: {
            color: {
                value: "{components.radio.button._checked.color}"
            }
        },
        label: {
            color: {
                value: "{components.radio.label.color}"
            }
        }
    },
    legend: {
        color: {
            value: "{components.fieldset.legend.color}"
        },
        fontWeight: {
            value: "{fontWeights.normal}"
        }
    }
};


const $9866aaf59d23285e$export$8121c87bde23d44 = {
    large: {
        size: {
            value: "{fontSizes.xxxl.value}"
        }
    },
    default: {
        size: {
            value: "{fontSizes.xl.value}"
        }
    },
    small: {
        size: {
            value: "{fontSizes.small.value}"
        }
    },
    filled: {
        color: {
            value: "{colors.secondary.80.value}"
        }
    },
    empty: {
        color: {
            value: "{colors.background.tertiary.value}"
        }
    }
};


const $16bd5a0e5f1e0433$export$20f8183d3857720a = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    button: {
        color: {
            value: "{components.button.color.value}"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        _active: {
            backgroundColor: {
                value: "{components.button._active.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._active.borderColor.value}"
            },
            color: {
                value: "{components.button._active.color.value}"
            }
        },
        _disabled: {
            backgroundColor: {
                value: "{components.button._disabled.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._disabled.borderColor.value}"
            },
            color: {
                value: "{components.button._disabled.color.value}"
            }
        },
        _focus: {
            backgroundColor: {
                value: "{components.button._focus.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._focus.borderColor.value}"
            },
            color: {
                value: "{components.button._focus.color.value}"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{components.button._hover.backgroundColor.value}"
            },
            borderColor: {
                value: "{components.button._hover.borderColor.value}"
            },
            color: {
                value: "{components.button._hover.color.value}"
            }
        }
    }
};


const $5bb238e1d2d7dd1c$export$2e6c959c16ff56b8 = {
    color: {
        value: "{components.fieldcontrol.color}"
    },
    backgroundColor: {
        value: "{colors.background.primary.value}"
    },
    paddingInlineEnd: {
        value: "{space.xxl.value}"
    },
    _disabled: {
        color: {
            value: "{colors.font.disabled.value}"
        },
        backgroundColor: {
            value: "{colors.background.disabled.value}"
        }
    },
    // wrappers
    wrapper: {
        flex: {
            value: "1"
        },
        display: {
            value: "block"
        },
        position: {
            value: "relative"
        },
        cursor: {
            value: "pointer"
        }
    },
    iconWrapper: {
        alignItems: {
            value: "center"
        },
        position: {
            value: "absolute"
        },
        top: {
            value: "50%"
        },
        right: {
            value: "{space.medium.value}"
        },
        transform: {
            value: "translateY(-50%)"
        },
        pointerEvents: {
            value: "none"
        },
        small: {
            right: {
                value: "{space.xs.value}"
            }
        },
        large: {
            right: {
                value: "{space.medium.value}"
            }
        }
    },
    // It's important to test these option values on Chrome/FireFox/Edge
    // on Windows because they allow styling of the option element.
    // Chrome/Safari/Firefox on Mac uses the system ui.
    option: {
        backgroundColor: {
            value: "transparent"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        _disabled: {
            color: {
                value: "{colors.font.disabled.value}"
            },
            backgroundColor: {
                value: "transparent"
            }
        }
    },
    whiteSpace: {
        value: "nowrap"
    },
    minWidth: {
        value: "6.5rem"
    },
    small: {
        minWidth: {
            value: "5.5rem"
        },
        paddingInlineEnd: {
            value: "{space.xl.value}"
        }
    },
    large: {
        minWidth: {
            value: "7.5rem"
        },
        paddingInlineEnd: {
            value: "{space.xxl.value}"
        }
    },
    expanded: {
        paddingBlock: {
            value: "{space.xs.value}"
        },
        paddingInline: {
            value: "{space.small.value}"
        },
        option: {
            paddingBlock: {
                value: "{space.xs.value}"
            },
            paddingInline: {
                value: "{space.small.value}"
            }
        }
    }
};


const $6a95b96ea47f15ae$export$43b12a9ec74e5c15 = {
    borderColor: {
        value: "{components.fieldcontrol.borderColor}"
    },
    color: {
        value: "{components.fieldcontrol.color}"
    },
    flexDirection: {
        value: "column"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor}"
        }
    },
    label: {
        color: {
            value: "{components.field.label.color}"
        }
    }
};


const $629b82b4034fbe1e$export$91a82c92775294e7 = {
    paddingBlock: {
        value: "{space.xs.value}"
    },
    // The track is the thin background of the slider
    track: {
        backgroundColor: {
            value: "{colors.background.quaternary.value}"
        },
        borderRadius: {
            value: "9999px"
        },
        height: {
            value: "0.375rem"
        },
        minWidth: {
            value: "10rem"
        }
    },
    // The range is the filled part of the track
    range: {
        backgroundColor: {
            value: "{colors.primary.80.value}"
        },
        borderRadius: {
            value: "9999px"
        },
        _disabled: {
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            }
        }
    },
    // The thumb is the circle above the track that the user drags
    thumb: {
        width: {
            value: "1.25rem"
        },
        height: {
            value: "1.25rem"
        },
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        boxShadow: {
            value: "{shadows.small.value}"
        },
        borderRadius: {
            value: "50%"
        },
        borderWidth: {
            value: "{borderWidths.medium.value}"
        },
        borderColor: {
            value: "{colors.border.primary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        _disabled: {
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            borderColor: {
                value: "transparent"
            },
            boxShadow: {
                value: "none"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{colors.background.primary.value}"
            },
            borderColor: {
                value: "{colors.border.focus.value}"
            }
        },
        _focus: {
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            }
        }
    },
    small: {
        track: {
            height: {
                value: "0.25rem"
            }
        },
        thumb: {
            width: {
                value: "1rem"
            },
            height: {
                value: "1rem"
            }
        }
    },
    large: {
        track: {
            height: {
                value: "0.625rem"
            }
        },
        thumb: {
            width: {
                value: "1.5rem"
            },
            height: {
                value: "1.5rem"
            }
        }
    }
};


const $4a219a940e454c92$export$2391ed8b13703124 = {
    borderColor: {
        value: "{components.fieldcontrol.borderColor}"
    },
    flexDirection: {
        value: "column"
    },
    input: {
        color: {
            value: "{components.fieldcontrol.color}"
        },
        fontSize: {
            value: "{components.fieldcontrol.fontSize}"
        },
        textAlign: {
            value: "center"
        }
    },
    button: {
        color: {
            value: "{components.button.color}"
        },
        backgroundColor: {
            value: "{colors.transparent}"
        },
        _active: {
            color: {
                value: "{components.button._active.color}"
            },
            backgroundColor: {
                value: "{components.button._active.backgroundColor}"
            }
        },
        _focus: {
            color: {
                value: "{components.button._focus.color}"
            },
            backgroundColor: {
                value: "{components.button._focus.backgroundColor}"
            }
        },
        _disabled: {
            color: {
                value: "{components.button._disabled.color}"
            },
            backgroundColor: {
                value: "{components.fieldcontrol._disabled.backgroundColor}"
            }
        },
        _hover: {
            color: {
                value: "{components.button._hover.color}"
            },
            backgroundColor: {
                value: "{components.button._hover.backgroundColor}"
            }
        }
    }
};


const $3931b547a4008fc8$export$38e5783f648ff5e4 = {
    dropzone: {
        backgroundColor: {
            value: "{colors.background.primary}"
        },
        borderRadius: {
            value: "{radii.small}"
        },
        borderColor: {
            value: "{colors.border.primary}"
        },
        borderStyle: {
            value: "dashed"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        gap: {
            value: "{space.small}"
        },
        paddingBlock: {
            value: "{space.xl}"
        },
        paddingInline: {
            value: "{space.large}"
        },
        textAlign: {
            value: "center"
        },
        _active: {
            backgroundColor: {
                value: "{colors.primary.10}"
            },
            borderRadius: {
                value: "{components.storagemanager.dropzone.borderRadius}"
            },
            borderColor: {
                value: "{colors.border.pressed}"
            },
            borderStyle: {
                value: "{components.storagemanager.dropzone.borderStyle}"
            },
            borderWidth: {
                value: "{borderWidths.medium}"
            }
        },
        icon: {
            color: {
                value: "{colors.border.primary}"
            },
            fontSize: {
                value: "{fontSizes.xxl}"
            }
        },
        text: {
            color: {
                value: "{colors.font.tertiary}"
            },
            fontSize: {
                value: "{fontSizes.medium}"
            },
            fontWeight: {
                value: "{fontWeights.bold}"
            }
        }
    },
    file: {
        backgroundColor: {
            value: "{colors.background.primary}"
        },
        borderRadius: {
            value: "{radii.small}"
        },
        borderColor: {
            value: "{colors.border.primary}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        paddingBlock: {
            value: "{space.xs}"
        },
        paddingInline: {
            value: "{space.small}"
        },
        gap: {
            value: "{space.small}"
        },
        alignItems: {
            value: "baseline"
        },
        name: {
            fontSize: {
                value: "{fontSizes.medium}"
            },
            fontWeight: {
                value: "{fontWeights.bold}"
            },
            color: {
                value: "{colors.font.primary}"
            }
        },
        size: {
            fontSize: {
                value: "{fontSizes.small}"
            },
            fontWeight: {
                value: "{fontWeights.normal}"
            },
            color: {
                value: "{colors.font.tertiary}"
            }
        },
        image: {
            width: {
                value: "{space.xxl}"
            },
            height: {
                value: "{space.xxl}"
            },
            backgroundColor: {
                value: "{colors.background.secondary}"
            },
            color: {
                value: "{colors.font.tertiary}"
            },
            borderRadius: {
                value: "{radii.small}"
            }
        }
    },
    filelist: {
        flexDirection: {
            value: "column"
        },
        gap: {
            value: "{space.small}"
        }
    },
    loader: {
        strokeLinecap: {
            value: "round"
        },
        strokeEmpty: {
            value: "{colors.border.secondary}"
        },
        strokeFilled: {
            value: "{components.loader.strokeFilled}"
        },
        strokeWidth: {
            value: "{borderWidths.large}"
        }
    },
    previewer: {
        backgroundColor: {
            value: "{colors.background.primary}"
        },
        borderColor: {
            value: "{colors.border.primary}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small}"
        },
        borderRadius: {
            value: "{radii.small}"
        },
        paddingBlock: {
            value: "{space.zero}"
        },
        paddingInline: {
            value: "{space.zero}"
        },
        maxHeight: {
            value: "40rem"
        },
        maxWidth: {
            value: "auto"
        },
        text: {
            fontSize: {
                value: "{fontSizes.medium}"
            },
            fontWeight: {
                value: "{fontWeights.bold}"
            },
            color: {
                value: "{colors.font.primary}"
            }
        },
        body: {
            paddingBlock: {
                value: "{space.medium}"
            },
            paddingInline: {
                value: "{space.medium}"
            },
            gap: {
                value: "{space.small}"
            }
        },
        footer: {
            justifyContent: {
                value: "flex-end"
            }
        }
    }
};


const $06e6ca7076db9889$export$3df77196ea7dd221 = {
    // States
    _disabled: {
        opacity: {
            value: "{opacities.60.value}"
        }
    },
    _focused: {
        shadow: {
            value: "{components.fieldcontrol._focus.boxShadow.value}"
        }
    },
    // Sizes
    fontSize: {
        value: "{fontSizes.medium.value}"
    },
    large: {
        fontSize: {
            value: "{fontSizes.large.value}"
        }
    },
    small: {
        fontSize: {
            value: "{fontSizes.small.value}"
        }
    },
    // Child elements
    label: {
        padding: {
            value: "{space.xs.value}"
        }
    },
    thumb: {
        backgroundColor: {
            value: "{colors.background.primary.value}"
        },
        borderColor: {
            value: "transparent"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderRadius: {
            value: "{radii.xxxl.value}"
        },
        checked: {
            transform: {
                value: "{transforms.slideX.medium.value}"
            }
        },
        transition: {
            duration: {
                value: "{time.medium.value}"
            }
        },
        width: {
            value: "{space.relative.medium.value}"
        }
    },
    track: {
        backgroundColor: {
            value: "{colors.background.quaternary.value}"
        },
        borderRadius: {
            value: "{radii.xxxl.value}"
        },
        checked: {
            backgroundColor: {
                value: "{colors.primary.80.value}"
            }
        },
        height: {
            value: "{space.relative.medium.value}"
        },
        padding: {
            value: "{outlineWidths.medium.value}"
        },
        transition: {
            duration: {
                value: "{time.short.value}"
            }
        },
        width: {
            value: "{space.relative.xl.value}"
        },
        _error: {
            backgroundColor: {
                value: "{colors.background.error.value}"
            }
        }
    }
};


const $eefe9b01f6ba93b1$export$9852986a3ec5f6a0 = {
    /**
     * Default table styles
     */ borderCollapse: {
        value: "collapse"
    },
    display: {
        value: "table"
    },
    width: {
        value: "100%"
    },
    /**
     * Default table head styles
     */ head: {
        display: {
            value: "table-header-group"
        },
        verticalAlign: {
            value: "middle"
        }
    },
    /**
     * Default table body styles
     */ body: {
        display: {
            value: "table-row-group"
        },
        verticalAlign: {
            value: "middle"
        }
    },
    /**
     * Default table foot styles
     */ foot: {
        display: {
            value: "table-footer-group"
        },
        verticalAlign: {
            value: "middle"
        }
    },
    /**
     * Default table row styles
     */ row: {
        display: {
            value: "table-row"
        },
        verticalAlign: {
            value: "middle"
        },
        hover: {
            backgroundColor: {
                value: "{colors.background.tertiary.value}"
            }
        },
        striped: {
            backgroundColor: {
                value: "{colors.background.secondary.value}"
            }
        }
    },
    /**
     * Default table header cell styles
     */ header: {
        borderColor: {
            value: "{colors.border.tertiary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        display: {
            value: "table-cell"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        },
        padding: {
            value: "{space.medium.value}"
        },
        verticalAlign: {
            value: "middle"
        },
        large: {
            fontSize: {
                value: "{fontSizes.large.value}"
            },
            padding: {
                value: "{space.large.value}"
            }
        },
        small: {
            fontSize: {
                value: "{fontSizes.small.value}"
            },
            padding: {
                value: "{space.xs.value}"
            }
        }
    },
    /**
     * Default table data cell styles
     */ data: {
        borderColor: {
            value: "{colors.border.tertiary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        display: {
            value: "table-cell"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.normal.value}"
        },
        padding: {
            value: "{space.medium.value}"
        },
        verticalAlign: {
            value: "middle"
        },
        large: {
            fontSize: {
                value: "{fontSizes.large.value}"
            },
            padding: {
                value: "{space.large.value}"
            }
        },
        small: {
            fontSize: {
                value: "{fontSizes.small.value}"
            },
            padding: {
                value: "{space.xs.value}"
            }
        }
    },
    /**
     * Default table caption styles
     */ caption: {
        captionSide: {
            value: "bottom"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        display: {
            value: "table-caption"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        textAlign: {
            value: "center"
        },
        wordBreak: {
            value: "break-all"
        },
        large: {
            fontSize: {
                value: "{fontSizes.large.value}"
            }
        },
        small: {
            fontSize: {
                value: "{fontSizes.small.value}"
            }
        }
    }
};


const $cc0e91f6b421aea1$export$39f5674517ec0000 = {
    backgroundColor: {
        value: "transparent"
    },
    borderColor: {
        value: "{colors.border.secondary.value}"
    },
    borderStyle: {
        value: "solid"
    },
    borderWidth: {
        value: "{borderWidths.medium.value}"
    },
    gap: {
        value: "0"
    },
    item: {
        backgroundColor: {
            value: "transparent"
        },
        borderColor: {
            value: "{colors.border.secondary.value}"
        },
        borderStyle: {
            value: "solid"
        },
        borderWidth: {
            value: "{borderWidths.medium.value}"
        },
        color: {
            value: "{colors.font.secondary.value}"
        },
        fontSize: {
            value: "{fontSizes.medium.value}"
        },
        fontWeight: {
            value: "{fontWeights.bold.value}"
        },
        paddingVertical: {
            value: "{space.small.value}"
        },
        paddingHorizontal: {
            value: "{space.medium.value}"
        },
        textAlign: {
            value: "center"
        },
        transitionDuration: {
            value: "{time.medium.value}"
        },
        _hover: {
            backgroundColor: {
                value: "transparent"
            },
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: "none"
            },
            color: {
                value: "{colors.font.hover.value}"
            }
        },
        _focus: {
            backgroundColor: {
                value: "transparent"
            },
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            boxShadow: {
                value: {
                    offsetX: "0px",
                    offsetY: "0px",
                    blurRadius: "0px",
                    spreadRadius: "{borderWidths.medium}",
                    color: "{colors.border.focus.value}"
                }
            },
            color: {
                value: "{colors.font.focus.value}"
            }
        },
        _active: {
            backgroundColor: {
                value: "transparent"
            },
            borderColor: {
                value: "{colors.font.interactive.value}"
            },
            boxShadow: {
                value: "none"
            },
            color: {
                value: "{colors.font.interactive.value}"
            }
        },
        _disabled: {
            backgroundColor: {
                value: "transparent"
            },
            borderColor: {
                value: "{colors.border.tertiary.value}"
            },
            boxShadow: {
                value: "none"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        }
    },
    panel: {
        backgroundColor: {
            value: "transparent"
        },
        paddingInline: {
            value: "0"
        },
        paddingBlock: {
            value: "{space.small.value}"
        }
    }
};


const $b69dc822fa291d6b$export$6f093cfa640b7166 = {
    // default styles
    color: {
        value: "{colors.font.primary.value}"
    },
    // variations
    primary: {
        color: {
            value: "{colors.font.primary.value}"
        }
    },
    secondary: {
        color: {
            value: "{colors.font.secondary.value}"
        }
    },
    tertiary: {
        color: {
            value: "{colors.font.tertiary.value}"
        }
    },
    error: {
        color: {
            value: "{colors.font.error.value}"
        }
    },
    warning: {
        color: {
            value: "{colors.font.warning.value}"
        }
    },
    success: {
        color: {
            value: "{colors.font.success.value}"
        }
    },
    info: {
        color: {
            value: "{colors.font.info.value}"
        }
    }
};


const $a434fffe906746df$export$a97649e9ae9088d4 = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor.value}"
        }
    }
};


const $73656e12a686e788$export$a0baff9279ccf6a1 = {
    color: {
        value: "{components.fieldcontrol.color.value}"
    },
    borderColor: {
        value: "{components.fieldcontrol.borderColor.value}"
    },
    fontSize: {
        value: "{components.fieldcontrol.fontSize.value}"
    },
    _focus: {
        borderColor: {
            value: "{components.fieldcontrol._focus.borderColor.value}"
        }
    }
};


const $5e7f858b65ff55ff$export$72f8a860416016a1 = {
    borderColor: {
        value: "{colors.border.primary.value}"
    },
    color: {
        value: "{colors.font.primary.value}"
    },
    _hover: {
        backgroundColor: {
            value: "{colors.overlay.10.value}"
        }
    },
    _focus: {
        borderColor: {
            value: "{colors.border.focus.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        }
    },
    _active: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        }
    },
    _disabled: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        },
        borderColor: {
            value: "{colors.border.disabled.value}"
        },
        color: {
            value: "{colors.font.disabled.value}"
        }
    },
    _pressed: {
        borderColor: {
            value: "{colors.border.pressed.value}"
        },
        color: {
            value: "{colors.font.primary.value}"
        },
        backgroundColor: {
            value: "{colors.overlay.20.value}"
        },
        _hover: {
            backgroundColor: {
                value: "{colors.overlay.30.value}"
            }
        }
    },
    primary: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        },
        borderWidth: {
            value: "{borderWidths.small.value}"
        },
        _focus: {
            borderColor: {
                value: "{colors.border.focus.value}"
            },
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            boxShadow: {
                value: "{components.fieldcontrol._focus.boxShadow.value}"
            },
            color: {
                value: "{colors.font.primary.value}"
            }
        },
        _hover: {
            backgroundColor: {
                value: "{colors.overlay.10.value}"
            },
            color: {
                value: "{colors.font.primary.value}"
            }
        },
        _disabled: {
            borderColor: {
                value: "{colors.border.disabled.value}"
            },
            backgroundColor: {
                value: "{colors.background.disabled.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _pressed: {
            backgroundColor: {
                value: "{colors.primary.80.value}"
            },
            borderColor: {
                value: "{colors.primary.80.value}"
            },
            color: {
                value: "{colors.background.primary.value}"
            },
            _focus: {
                backgroundColor: {
                    value: "{colors.border.focus.value}"
                },
                borderColor: {
                    value: "{colors.border.focus.value}"
                },
                color: {
                    value: "{colors.background.primary.value}"
                }
            },
            _hover: {
                borderColor: {
                    value: "{colors.primary.60.value}"
                },
                backgroundColor: {
                    value: "{colors.primary.60.value}"
                },
                boxShadow: {
                    value: "{colors.primary.60.value}"
                },
                color: {
                    value: "{colors.background.primary.value}"
                }
            }
        }
    },
    link: {
        backgroundColor: {
            value: "{colors.transparent.value}"
        },
        color: {
            value: "{colors.overlay.50.value}"
        },
        _hover: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.overlay.50.value}"
            }
        },
        _focus: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.overlay.50.value}"
            }
        },
        _disabled: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.font.disabled.value}"
            }
        },
        _pressed: {
            backgroundColor: {
                value: "{colors.transparent.value}"
            },
            color: {
                value: "{colors.overlay.90.value}"
            },
            _focus: {
                backgroundColor: {
                    value: "{colors.transparent.value}"
                },
                color: {
                    value: "{colors.overlay.90.value}"
                }
            },
            _hover: {
                color: {
                    value: "{colors.overlay.90.value}"
                },
                backgroundColor: {
                    value: "{colors.transparent.value}"
                }
            }
        }
    }
};


const $0f24ffe99f52ec9b$export$8f367359b07a0011 = {
    alignItems: {
        value: "center"
    },
    alignContent: {
        value: "center"
    },
    justifyContent: {
        value: "flex-start"
    }
};


const $1878e074e9dcd1ff$export$9b5ac10f59f76296 = {
    accordion: $ade26c81fbc2509a$export$77f5744dadf9dca6,
    alert: $13df977a06165813$export$5ea928c9faf85bd3,
    authenticator: $ab16729f44aa3c63$export$d5cb6eef88ffbde2,
    autocomplete: $7e88ebc8544ce4a3$export$485ded5f26ebe08d,
    badge: $63856cb27b0704ed$export$4aebd143f31d0c0d,
    breadcrumbs: $86996efc4b0db584$export$515d2155aaad79e4,
    button: $d57c4bc3f8164669$export$2ba01fb71ed41cb6,
    card: $308bff62c060e78b$export$aa3e815946b80764,
    checkbox: $15649632a2a05b26$export$b07e517d22efa1ca,
    checkboxfield: $44dde6f748ed9e44$export$282c9e915736aefa,
    collection: $b98d27ee91683457$export$bf5175b0c24981cd,
    copy: $4729658ec87c92d4$export$784d13d8ee351f07,
    countrycodeselect: (0, $26bfee4cb464d821$export$5a80fc6ecf647d64),
    divider: $be165c9ec3c6e836$export$e8c9778bf415dd08,
    dropzone: $e2a709987030359a$export$585d0a7a39ed94ea,
    field: $03fae1bdfd3fa337$export$e0f35d825088c098,
    fieldcontrol: $98b38cee62d197fa$export$5ba822cdf6eca6d5,
    fieldgroup: $858984f810d31c60$export$886e4abc352a8403,
    fieldmessages: $0e2b67e28bbe45b8$export$b29676ca3eb575f7,
    fieldset: $f65b2456eb2513a2$export$a38812d1aa1302d9,
    flex: $37361d9099acfc3f$export$97691fbb80847c19,
    heading: $2a854077f8c8bd68$export$46e4a324ac90507f,
    icon: $ab78a71e975133a2$export$1ca1ec8b29a4ce27,
    highlightmatch: $850263ca26b2c217$export$5340050496cd0f8f,
    image: $bbca92e21b90107c$export$5c452ff88e35e47d,
    inappmessaging: $28eb775d38ccd62e$export$be5f4c7eec37e17e,
    input: $56a572806ec0e05a$export$b7e3ae3d7c15e42e,
    link: $5c942e642e591541$export$9c30223ca0a664fb,
    liveness: $539ec312fad8cc88$export$674047c1a0a83243,
    loader: $52d09c99cf0e629d$export$f4c5de44377d2946,
    menu: $726698dda08ca16e$export$b1e5508a851be14d,
    message: $ebec8146d60d7073$export$a8ecead220dd38a6,
    pagination: $2ac66cb390315301$export$22fa394f3ba39578,
    passwordfield: $bd8cfe96ff1426bb$export$75dd6c0d8e7c7e6b,
    phonenumberfield: $21caf2a477c461fe$export$2b14d7973e978f83,
    placeholder: $de7407de890c2f24$export$c7187bbd1a7a9244,
    radio: $27e6103548484ca8$export$b56dc0f160585b86,
    radiogroup: $9e25f8d0489ddfeb$export$19d611f01a2bdcee,
    rating: $9866aaf59d23285e$export$8121c87bde23d44,
    searchfield: $16bd5a0e5f1e0433$export$20f8183d3857720a,
    select: $5bb238e1d2d7dd1c$export$2e6c959c16ff56b8,
    selectfield: $6a95b96ea47f15ae$export$43b12a9ec74e5c15,
    sliderfield: $629b82b4034fbe1e$export$91a82c92775294e7,
    stepperfield: $4a219a940e454c92$export$2391ed8b13703124,
    storagemanager: $3931b547a4008fc8$export$38e5783f648ff5e4,
    switchfield: $06e6ca7076db9889$export$3df77196ea7dd221,
    table: $eefe9b01f6ba93b1$export$9852986a3ec5f6a0,
    tabs: $cc0e91f6b421aea1$export$39f5674517ec0000,
    text: $b69dc822fa291d6b$export$6f093cfa640b7166,
    textareafield: $a434fffe906746df$export$a97649e9ae9088d4,
    textfield: $73656e12a686e788$export$a0baff9279ccf6a1,
    togglebutton: $5e7f858b65ff55ff$export$72f8a860416016a1,
    togglebuttongroup: $0f24ffe99f52ec9b$export$8f367359b07a0011
};


// TODO: update the design tokens to use an array
// export interface FontDesignToken {
//   value: Array<string>
// }
const $a03b59bcf57957e2$export$f45fbea8fe20ca8a = {
    default: {
        variable: {
            value: `'InterVariable', 'Inter var', 'Inter', -apple-system, BlinkMacSystemFont,
        'Helvetica Neue', 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans',
        sans-serif`
        },
        static: {
            value: `'Inter', -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
        'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans', sans-serif`
        }
    }
};


const $a59064bd26f0f97b$export$67baea80019ff381 = {
    xxxs: {
        value: "0.375rem"
    },
    xxs: {
        value: "0.5rem"
    },
    xs: {
        value: "0.75rem"
    },
    small: {
        value: "0.875rem"
    },
    medium: {
        value: "1rem"
    },
    large: {
        value: "1.25rem"
    },
    xl: {
        value: "1.5rem"
    },
    xxl: {
        value: "2rem"
    },
    xxxl: {
        value: "2.5rem"
    },
    xxxxl: {
        value: "3rem"
    }
};


const $3dc1ee6721a188bf$export$59230918eb9bd861 = {
    hairline: {
        value: 100
    },
    thin: {
        value: 200
    },
    light: {
        value: 300
    },
    normal: {
        value: 400
    },
    medium: {
        value: 500
    },
    semibold: {
        value: 600
    },
    bold: {
        value: 700
    },
    extrabold: {
        value: 800
    },
    black: {
        value: 900
    }
};


const $d614d491dc04c368$export$e646ed6b629bf51e = {
    small: {
        value: "1.25"
    },
    medium: {
        value: "1.5"
    },
    large: {
        value: "2"
    }
};


const $e88d82aea6fe0af2$export$da6c1b172b339805 = {
    0: {
        value: "0"
    },
    10: {
        value: "0.1"
    },
    20: {
        value: "0.2"
    },
    30: {
        value: "0.3"
    },
    40: {
        value: "0.4"
    },
    50: {
        value: "0.5"
    },
    60: {
        value: "0.6"
    },
    70: {
        value: "0.7"
    },
    80: {
        value: "0.8"
    },
    90: {
        value: "0.9"
    },
    100: {
        value: "1"
    }
};


const $f3dc5c2fee704b94$export$ef75ee03a03b44a8 = {
    small: {
        value: "1px"
    },
    medium: {
        value: "2px"
    },
    large: {
        value: "3px"
    }
};


const $a26e436418562c50$export$d532f76375153c47 = {
    small: {
        value: "1px"
    },
    medium: {
        value: "2px"
    },
    large: {
        value: "3px"
    }
};


const $e47e1a432edee40e$export$18f838d5aba6962a = {
    xs: {
        value: "0.125rem"
    },
    small: {
        value: "0.25rem"
    },
    medium: {
        value: "0.5rem"
    },
    large: {
        value: "1rem"
    },
    xl: {
        value: "2rem"
    },
    xxl: {
        value: "4rem"
    },
    xxxl: {
        value: "8rem"
    }
};


const $352f89d3cc284cf8$export$3eb26d38a832ce9a = {
    small: {
        value: {
            offsetX: "0px",
            offsetY: "2px",
            blurRadius: "4px",
            color: "{colors.shadow.tertiary.value}"
        }
    },
    medium: {
        value: {
            offsetX: "0px",
            offsetY: "2px",
            blurRadius: "6px",
            color: "{colors.shadow.secondary.value}"
        }
    },
    large: {
        value: {
            offsetX: "0px",
            offsetY: "4px",
            blurRadius: "12px",
            color: "{colors.shadow.primary.value}"
        }
    }
};


const $398bf787f11cb755$export$a941ed4b947d12f8 = {
    zero: {
        value: "0"
    },
    xxxs: {
        value: "0.25rem"
    },
    xxs: {
        value: "0.375rem"
    },
    xs: {
        value: "0.5rem"
    },
    small: {
        value: "0.75rem"
    },
    medium: {
        value: "1rem"
    },
    large: {
        value: "1.5rem"
    },
    xl: {
        value: "2.0rem"
    },
    xxl: {
        value: "3.0rem"
    },
    xxxl: {
        value: "4.5rem"
    },
    relative: {
        //creating a second set of sizes using em which will be sized relative to a parent instead of the root
        xxxs: {
            value: "0.25em"
        },
        xxs: {
            value: "0.375em"
        },
        xs: {
            value: "0.5em"
        },
        small: {
            value: "0.75em"
        },
        medium: {
            value: "1em"
        },
        large: {
            value: "1.5em"
        },
        xl: {
            value: "2.0em"
        },
        xxl: {
            value: "3.0em"
        },
        xxxl: {
            value: "4.5em"
        },
        full: {
            value: "100%"
        }
    }
};


const $21a0209179b4d95e$export$2da9be4cfdb689b1 = {
    short: {
        value: "100ms"
    },
    medium: {
        value: "250ms"
    },
    long: {
        value: "500ms"
    }
};


const $af9f8ddee6a051b0$export$63e4f03d302d3e40 = {
    // TODO: make this more generic and cross-platform
    slideX: {
        small: {
            value: "translateX(0.5em)"
        },
        medium: {
            value: "translateX(1em)"
        },
        large: {
            value: "translateX(2em)"
        }
    }
};


const $c80387f0f6661870$export$6ad93df59e712c43 = {
    components: $1878e074e9dcd1ff$export$9b5ac10f59f76296,
    borderWidths: $601a50b19cd5fef1$export$6f3cc5789c9e770e,
    colors: $f36afbd21e8fb44b$export$8f45430ccf837300,
    fonts: $a03b59bcf57957e2$export$f45fbea8fe20ca8a,
    fontSizes: $a59064bd26f0f97b$export$67baea80019ff381,
    fontWeights: $3dc1ee6721a188bf$export$59230918eb9bd861,
    lineHeights: $d614d491dc04c368$export$e646ed6b629bf51e,
    opacities: $e88d82aea6fe0af2$export$da6c1b172b339805,
    outlineOffsets: $f3dc5c2fee704b94$export$ef75ee03a03b44a8,
    outlineWidths: $a26e436418562c50$export$d532f76375153c47,
    radii: $e47e1a432edee40e$export$18f838d5aba6962a,
    shadows: $352f89d3cc284cf8$export$3eb26d38a832ce9a,
    space: $398bf787f11cb755$export$a941ed4b947d12f8,
    time: $21a0209179b4d95e$export$2da9be4cfdb689b1,
    transforms: $af9f8ddee6a051b0$export$63e4f03d302d3e40
};
const $c80387f0f6661870$export$166e3af4fe3ca756 = {
    colors: $f36afbd21e8fb44b$export$8f45430ccf837300,
    borderWidths: $601a50b19cd5fef1$export$6f3cc5789c9e770e,
    fontSizes: {
        xxs: (0, $a59064bd26f0f97b$export$67baea80019ff381).xxs,
        xs: (0, $a59064bd26f0f97b$export$67baea80019ff381).xs,
        small: (0, $a59064bd26f0f97b$export$67baea80019ff381).small,
        medium: (0, $a59064bd26f0f97b$export$67baea80019ff381).medium,
        large: (0, $a59064bd26f0f97b$export$67baea80019ff381).large,
        xl: (0, $a59064bd26f0f97b$export$67baea80019ff381).xl,
        xxl: (0, $a59064bd26f0f97b$export$67baea80019ff381).xxl,
        xxxl: (0, $a59064bd26f0f97b$export$67baea80019ff381).xxxl
    },
    fontWeights: $3dc1ee6721a188bf$export$59230918eb9bd861,
    opacities: $e88d82aea6fe0af2$export$da6c1b172b339805,
    // React Native doesn't need the relative space values
    space: {
        // use `space.xxxs` to output a value of `2` and avoid odd space numbers
        xxs: (0, $398bf787f11cb755$export$a941ed4b947d12f8).xxxs,
        xs: (0, $398bf787f11cb755$export$a941ed4b947d12f8).xs,
        small: (0, $398bf787f11cb755$export$a941ed4b947d12f8).small,
        medium: (0, $398bf787f11cb755$export$a941ed4b947d12f8).medium,
        large: (0, $398bf787f11cb755$export$a941ed4b947d12f8).large,
        xl: (0, $398bf787f11cb755$export$a941ed4b947d12f8).xl,
        xxl: (0, $398bf787f11cb755$export$a941ed4b947d12f8).xxl,
        xxxl: (0, $398bf787f11cb755$export$a941ed4b947d12f8).xxxl
    },
    radii: $e47e1a432edee40e$export$18f838d5aba6962a,
    time: $21a0209179b4d95e$export$2da9be4cfdb689b1
};


// Breakpoint unit is in pixels
const $066a1ca9861b133b$export$d07517a676ce386f = {
    values: {
        base: 0,
        small: 480,
        medium: 768,
        large: 992,
        xl: 1280,
        xxl: 1536
    },
    defaultBreakpoint: "base"
};


const $bb80f4d9bb18c481$export$164de7ab8df77ef0 = {
    tokens: $c80387f0f6661870$export$6ad93df59e712c43,
    breakpoints: $066a1ca9861b133b$export$d07517a676ce386f,
    name: "default-theme"
};



// For internal use, no need to export
const $9932198a76a9e84a$export$529e7eefcb1e2a4c = {
    Alert: {
        dismissButtonLabel: "Dismiss alert"
    },
    Autocomplete: {
        emptyText: "No options found",
        loadingText: "Loading options..."
    },
    Collection: {
        searchButtonLabel: "Search",
        searchNoResultsFound: "No results found"
    },
    Fields: {
        clearButtonLabel: "Clear input"
    },
    Message: {
        dismissLabel: "Dismiss message"
    },
    PaginationItem: {
        currentPageLabel: "Page",
        nextLabel: "Go to next page",
        pageLabel: "Go to page",
        previousLabel: "Go to previous page"
    },
    PhoneNumberField: {
        countryCodeLabel: "Country code"
    },
    SearchField: {
        searchButtonLabel: "Search"
    },
    PasswordField: {
        passwordIsHidden: "Password is hidden",
        passwordIsShown: "Password is shown",
        showPassword: "Show password"
    },
    StepperField: {
        increaseButtonLabel: "Increase to",
        decreaseButtonLabel: "Decrease to"
    }
};
const $9932198a76a9e84a$export$f486c23e21d151b2 = {
    backgroundColor: "colors",
    borderColor: "colors",
    borderWidth: "borderWidths",
    color: "colors",
    borderRadius: "radii",
    fontSize: "fontSizes",
    fontWeight: "fontWeights",
    fontFamily: "fonts",
    lineHeight: "lineHeights",
    opacity: "opacities",
    boxShadow: "shadows",
    transform: "transforms",
    left: "space",
    right: "space",
    top: "space",
    bottom: "space",
    height: "space",
    width: "space",
    letterSpacing: "space",
    margin: "space",
    marginBlock: "space",
    marginBlockEnd: "space",
    marginBlockStart: "space",
    marginInline: "space",
    marginInlineEnd: "space",
    marginInlineStart: "space",
    marginLeft: "space",
    marginRight: "space",
    marginTop: "space",
    marginBottom: "space",
    maxHeight: "space",
    maxWidth: "space",
    minHeight: "space",
    minWidth: "space",
    padding: "space",
    paddingBlock: "space",
    paddingBlockEnd: "space",
    paddingBlockStart: "space",
    paddingInline: "space",
    paddingInlineEnd: "space",
    paddingInlineStart: "space",
    paddingLeft: "space",
    paddingRight: "space",
    paddingTop: "space",
    paddingBottom: "space",
    gap: "space",
    columnGap: "space",
    rowGap: "space"
};
// key name
const $9932198a76a9e84a$export$728705b4513abbb5 = "Escape";
const $9932198a76a9e84a$export$4162dbd8c730437 = "Enter";
const $9932198a76a9e84a$export$8188339dbe6c99c4 = "ArrowUp";
const $9932198a76a9e84a$export$59f214baefff6196 = "ArrowDown";


const $a0d71a6be47e962c$export$2e3e72bc642e327 = (key)=>{
    return key in (0, $9932198a76a9e84a$export$f486c23e21d151b2);
};



const $8a99379749f08332$export$c6251bf2bc4bb464 = (str)=>typeof str === "string" && str.length > 0;
const $8a99379749f08332$export$78d1711480f95c3e = (value)=>typeof value === "string" && value.length === 0;
const $8a99379749f08332$export$68b32c1946a6b59c = (value)=>value == null || $8a99379749f08332$export$78d1711480f95c3e(value);
/**
 * Create a consecutive integer array from start value to end value.
 * @param start start value
 * @param end end value
 * @returns an integer array with elements from start to end consecutively
 */ const $8a99379749f08332$export$12cda49cb4509427 = (start, end)=>{
    const length = end - start + 1;
    return Array.from({
        length: length
    }, (_, idx)=>idx + start);
};
/**
 * TS helper function to make using Object.keys more typesafe
 */ const $8a99379749f08332$export$259b4dd69e654a7a = (obj)=>{
    return Object.keys(obj);
};
const $8a99379749f08332$export$b0c777ec01738e5b = (propKey, value, tokens)=>{
    if (typeof value !== "string") return value;
    // For shorthand properties like `padding` which can accept 1, 2, 3, or 4 values
    // run this function on each value. This would not work on CSS shorthands that
    // mix types, like border which is a composite of borderWidth, borderStyle, and
    // borderColor.
    if (value.includes(" ")) return value.split(" ").map((val)=>$8a99379749f08332$export$b0c777ec01738e5b(propKey, val, tokens)).join(" ");
    if ((0, $a0d71a6be47e962c$export$2e3e72bc642e327)(propKey)) {
        const path = value.split(".");
        const tokenKey = (0, $9932198a76a9e84a$export$f486c23e21d151b2)[propKey];
        let tokenProps = tokens[tokenKey];
        for(let i = 0; i < path.length; i++){
            if (tokenProps) {
                // overwrite tokenProps with next nested value of tokenProps
                tokenProps = tokenProps[path[i]];
                continue;
            }
            break;
        }
        return (0, $08d92a30c154d78f$export$daee9cd42beef6d1)(tokenProps) ? `var(--${(0, $08d92a30c154d78f$export$8658ddf1aae625a3)({
            path: [
                (0, $9932198a76a9e84a$export$f486c23e21d151b2)[propKey],
                ...path
            ]
        })})` : value;
    }
    return value;
};


const $009f8abb82bf5000$var$getClosestValueByBreakpoint = ({ breakpoint: breakpoint, breakpoints: breakpoints, values: values })=>{
    const value = values[breakpoint];
    // Check if breakpoint exists in values
    if (value !== undefined) return value;
    // Otherwise use a lower breakpoint value
    const breakpointsDesc = (0, $8a99379749f08332$export$259b4dd69e654a7a)(breakpoints).sort((a, b)=>breakpoints[b] - breakpoints[a]);
    const lowerBreakpoints = breakpointsDesc.slice(breakpointsDesc.indexOf(breakpoint));
    for (const breakpoint of lowerBreakpoints){
        // Check if breakpoint exists in values
        const value = values[breakpoint];
        if (value !== undefined) return value;
    }
    return null;
};
/**
 * This takes an object and will return an object that only has the
 * breakpoint keys
 * @param obj
 * @returns
 */ const $009f8abb82bf5000$var$valueObjToBreakpoints = (obj)=>{
    return (0, $8a99379749f08332$export$259b4dd69e654a7a)(obj).reduce((acc, key)=>key in (0, $bb80f4d9bb18c481$export$164de7ab8df77ef0).breakpoints.values ? {
            ...acc,
            [key]: obj[key]
        } : acc, {});
};
const $009f8abb82bf5000$export$7791b19c8f6fdbca = ({ breakpoint: breakpoint, breakpoints: breakpoints, values: values })=>{
    let breakpointCompatValues = {};
    const breakpointsAscending = (0, $8a99379749f08332$export$259b4dd69e654a7a)(breakpoints).sort((a, b)=>breakpoints[a] - breakpoints[b]);
    if (Array.isArray(values)) values.forEach((value, index)=>{
        breakpointCompatValues[breakpointsAscending[index]] = value;
    });
    else if (typeof values === "object") breakpointCompatValues = $009f8abb82bf5000$var$valueObjToBreakpoints(values);
    return $009f8abb82bf5000$var$getClosestValueByBreakpoint({
        breakpoint: breakpoint,
        breakpoints: breakpoints,
        values: breakpointCompatValues
    });
};



var $1T1QG = parcelRequire("1T1QG");

// Inspiration for getMediaQueries and useBreakpoint
const $75cbd98179be6405$export$872f03ff2a363331 = ({ breakpoints: breakpoints })=>{
    const sortedBreakpoints = (0, $8a99379749f08332$export$259b4dd69e654a7a)(breakpoints).sort((a, b)=>breakpoints[b] - breakpoints[a]);
    return sortedBreakpoints.map((breakpoint, index)=>{
        let query = "";
        const minWidth = breakpoints[breakpoint];
        const nextBreakpoint = sortedBreakpoints[index - 1];
        const maxWidth = nextBreakpoint ? breakpoints[nextBreakpoint] - 1 : null;
        if (minWidth >= 0) query = `(min-width: ${minWidth}px)`;
        if (maxWidth !== null) {
            if (query) query += " and ";
            query += `(max-width: ${maxWidth}px)`;
        }
        return {
            breakpoint: breakpoint,
            query: query,
            maxWidth: maxWidth,
            minWidth: minWidth
        };
    });
};


// Inspiration for getMediaQueries and useBreakpoint
const $2e812fd4d99aa7e5$var$useIsomorphicEffect = typeof window === "undefined" ? $1T1QG.useEffect : $1T1QG.useLayoutEffect;
const $2e812fd4d99aa7e5$export$199d6754bdf4e1e3 = ({ breakpoints: breakpoints, defaultBreakpoint: defaultBreakpoint })=>{
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const matchMedia = supportMatchMedia ? window.matchMedia : null;
    const mediaQueries = $1T1QG.useMemo(()=>(0, $75cbd98179be6405$export$872f03ff2a363331)({
            breakpoints: breakpoints
        }), [
        breakpoints
    ]);
    const [breakpoint, setBreakpoint] = $1T1QG.useState(defaultBreakpoint);
    const updateBreakpoint = $1T1QG.useCallback((matches, breakpoint)=>{
        if (matches) setBreakpoint(breakpoint);
    }, [
        setBreakpoint
    ]);
    $2e812fd4d99aa7e5$var$useIsomorphicEffect(()=>{
        if (!matchMedia) return;
        const unsubscribeList = mediaQueries.map(({ query: query, breakpoint: breakpoint })=>{
            const queryList = matchMedia(query);
            updateBreakpoint(queryList.matches, breakpoint);
            const handleMediaChange = (event)=>{
                if (event.matches) setBreakpoint(breakpoint);
            };
            queryList.addEventListener("change", handleMediaChange);
            return ()=>queryList.removeEventListener("change", handleMediaChange);
        });
        return ()=>{
            unsubscribeList.forEach((unsubscribe)=>unsubscribe());
        };
    }, [
        breakpoints,
        setBreakpoint,
        matchMedia,
        mediaQueries
    ]);
    /** Print a nice debug value for React Devtools */ $1T1QG.useDebugValue(breakpoint, (breakpoint)=>breakpoint);
    return breakpoint;
};



var $1T1QG = parcelRequire("1T1QG");
var $76867978931fa972$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $373310daccdd03b3$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $aVicc = parcelRequire("aVicc");

var $aVicc = parcelRequire("aVicc");
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ var $5470330ef1b8a6d8$var$SUPPORTED_LOCALE = {
    tr: {
        regexp: /\u0130|\u0049|\u0049\u0307/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    az: {
        regexp: /\u0130/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    lt: {
        regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
        map: {
            I: "i\u0307",
            J: "j\u0307",
            \u012E: "\u012F\u0307",
            "\xcc": "i\u0307\u0300",
            "\xcd": "i\u0307\u0301",
            \u0128: "i\u0307\u0303"
        }
    }
};
function $5470330ef1b8a6d8$export$206cd6ecad4fcdde(str, locale) {
    var lang = $5470330ef1b8a6d8$var$SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang) return $5470330ef1b8a6d8$export$61d6efbc6547e8eb(str.replace(lang.regexp, function(m) {
        return lang.map[m];
    }));
    return $5470330ef1b8a6d8$export$61d6efbc6547e8eb(str);
}
function $5470330ef1b8a6d8$export$61d6efbc6547e8eb(str) {
    return str.toLowerCase();
}


// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var $eb2e9f9a07889c2a$var$DEFAULT_SPLIT_REGEXP = [
    /([a-z0-9])([A-Z])/g,
    /([A-Z])([A-Z][a-z])/g
];
// Remove all non-word characters.
var $eb2e9f9a07889c2a$var$DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function $eb2e9f9a07889c2a$export$a596972587f860c8(input, options) {
    if (options === void 0) options = {};
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? $eb2e9f9a07889c2a$var$DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? $eb2e9f9a07889c2a$var$DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? (0, $5470330ef1b8a6d8$export$61d6efbc6547e8eb) : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = $eb2e9f9a07889c2a$var$replace($eb2e9f9a07889c2a$var$replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while(result.charAt(start) === "\0")start++;
    while(result.charAt(end - 1) === "\0")end--;
    // Transform each token independently.
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */ function $eb2e9f9a07889c2a$var$replace(input, re, value) {
    if (re instanceof RegExp) return input.replace(re, value);
    return re.reduce(function(input, re) {
        return input.replace(re, value);
    }, input);
}


function $224707a56a0fb00f$export$66a4dfea2695736(input, index) {
    var firstChar = input.charAt(0);
    var lowerChars = input.substr(1).toLowerCase();
    if (index > 0 && firstChar >= "0" && firstChar <= "9") return "_" + firstChar + lowerChars;
    return "" + firstChar.toUpperCase() + lowerChars;
}
function $224707a56a0fb00f$export$c27cf446dc44c0b9(input) {
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
function $224707a56a0fb00f$export$26c6f48841fe1a8a(input, options) {
    if (options === void 0) options = {};
    return (0, $eb2e9f9a07889c2a$export$a596972587f860c8)(input, (0, $aVicc.__assign)({
        delimiter: "",
        transform: $224707a56a0fb00f$export$66a4dfea2695736
    }, options));
}


function $f1a99741062798c7$export$1c6885769b2bad6f(input, index) {
    if (index === 0) return input.toLowerCase();
    return (0, $224707a56a0fb00f$export$66a4dfea2695736)(input, index);
}
function $f1a99741062798c7$export$f3c8e8146a7dbf93(input, index) {
    if (index === 0) return input.toLowerCase();
    return (0, $224707a56a0fb00f$export$c27cf446dc44c0b9)(input);
}
function $f1a99741062798c7$export$8a7688a96d852767(input, options) {
    if (options === void 0) options = {};
    return (0, $224707a56a0fb00f$export$26c6f48841fe1a8a)(input, (0, $aVicc.__assign)({
        transform: $f1a99741062798c7$export$1c6885769b2bad6f
    }, options));
}


var $aVicc = parcelRequire("aVicc");

var $aVicc = parcelRequire("aVicc");

function $322600a395a301e5$export$e1b697368b9a68f5(input, options) {
    if (options === void 0) options = {};
    return (0, $eb2e9f9a07889c2a$export$a596972587f860c8)(input, (0, $aVicc.__assign)({
        delimiter: "."
    }, options));
}


function $95aa7d2a1ed13cd9$export$c68d52815ae74c39(input, options) {
    if (options === void 0) options = {};
    return (0, $322600a395a301e5$export$e1b697368b9a68f5)(input, (0, $aVicc.__assign)({
        delimiter: "-"
    }, options));
}


var $aVicc = parcelRequire("aVicc");

function $2cd159e7d954e129$export$feae9a740c003485(input, options) {
    if (options === void 0) options = {};
    return (0, $322600a395a301e5$export$e1b697368b9a68f5)(input, (0, $aVicc.__assign)({
        delimiter: "_"
    }, options));
}


const $373310daccdd03b3$var$reduce = function(obj, f, accumulator_init) {
    return Object.keys(obj || {}).reduce((accumulator, key)=>{
        let value = obj[key];
        return f(accumulator, value, key, obj);
    }, accumulator_init);
};
const $373310daccdd03b3$var$forEach = function(obj, f) {
    Object.keys(obj || {}).forEach((key)=>{
        let value = obj[key];
        f(value, key);
    });
};
// Note: This is a crappy version to a certain extent... don't use with Strings, for example...
const $373310daccdd03b3$var$clone = function(object) {
    return Object.assign(new object.constructor(), object);
};
const $373310daccdd03b3$var$cloneDeep = function(obj) {
    if (obj === null || obj === undefined || typeof obj !== "object") return obj;
    if (obj instanceof Array) return obj.reduce((arr, item, i)=>{
        arr[i] = $373310daccdd03b3$var$cloneDeep(item);
        return arr;
    }, []);
    if (obj instanceof Object) return Object.keys(obj || {}).reduce((cpObj, key)=>{
        cpObj[key] = $373310daccdd03b3$var$cloneDeep(obj[key]);
        return cpObj;
    }, {});
};
const $373310daccdd03b3$var$isObject = function(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function");
};
const $373310daccdd03b3$var$isString = function(obj) {
    return typeof obj === "string" || obj instanceof String;
};
const $373310daccdd03b3$var$isArray = function(obj) {
    return Array.isArray(obj);
};
const $373310daccdd03b3$var$isEmpty = function(obj) {
    return [
        Object,
        Array
    ].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
};
function $373310daccdd03b3$var$isPlainObject(value) {
    if (typeof value !== "object" || value === null || Object.prototype.toString.call(value) !== "[object Object]") return false;
    if (Object.getPrototypeOf(value) === null) return true;
    let proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
}
const $373310daccdd03b3$var$filter = function(arr, filter) {
    if (typeof filter !== "function") throw "filter is not a function";
    if (typeof arr === "undefined") return [];
    return arr.filter(filter);
};
const $373310daccdd03b3$var$assign = function() {
    let args = Array.prototype.slice.call(arguments);
    args.unshift({});
    return Object.assign(...args);
};
/* global Set */ const $373310daccdd03b3$var$pull = function(arr, ...removeList) {
    var removeSet = new Set(removeList);
    for(let i = arr.length - 1; i >= 0; i--)if (removeSet.has(arr[i])) arr.splice(i, 1);
};
const $373310daccdd03b3$var$unique = function(arr) {
    return [
        ...new Set(arr)
    ];
};
const $373310daccdd03b3$var$upperFirst = function(str) {
    return str ? str[0].toUpperCase() + str.substr(1) : "";
};
const $373310daccdd03b3$var$matchFn = function(inputObj, testObj) {
    if ($373310daccdd03b3$var$isObject(testObj)) return Object.keys(testObj).every((key)=>$373310daccdd03b3$var$matchFn(inputObj[key], testObj[key]));
    else return inputObj == testObj;
};
const $373310daccdd03b3$var$matches = function(matchObj) {
    let cloneObj = $373310daccdd03b3$var$cloneDeep(matchObj);
    let matchesFn = (inputObj)=>$373310daccdd03b3$var$matchFn(inputObj, cloneObj);
    return matchesFn;
};
const $373310daccdd03b3$var$DEFAULT_OPTIONS = {
    transform: $f1a99741062798c7$export$f3c8e8146a7dbf93
};
const $373310daccdd03b3$var$changeDefaultCaseTransform = function(caseFunction, default_options) {
    return (caseToChange, options)=>caseFunction(caseToChange, Object.assign({}, $373310daccdd03b3$var$DEFAULT_OPTIONS, default_options, options));
};
$373310daccdd03b3$exports = {
    each: $373310daccdd03b3$var$forEach,
    forEach: $373310daccdd03b3$var$forEach,
    forIn: $373310daccdd03b3$var$forEach,
    keys: Object.keys,
    clone: $373310daccdd03b3$var$clone,
    cloneDeep: $373310daccdd03b3$var$cloneDeep,
    extend: Object.assign,
    isString: $373310daccdd03b3$var$isString,
    isArray: $373310daccdd03b3$var$isArray,
    isObject: $373310daccdd03b3$var$isObject,
    isPlainObject: $373310daccdd03b3$var$isPlainObject,
    isEmpty: $373310daccdd03b3$var$isEmpty,
    filter: $373310daccdd03b3$var$filter,
    reduce: $373310daccdd03b3$var$reduce,
    assign: $373310daccdd03b3$var$assign,
    upperFirst: $373310daccdd03b3$var$upperFirst,
    camelCase: $373310daccdd03b3$var$changeDefaultCaseTransform($f1a99741062798c7$export$8a7688a96d852767),
    snakeCase: $2cd159e7d954e129$export$feae9a740c003485,
    kebabCase: $95aa7d2a1ed13cd9$export$c68d52815ae74c39,
    pull: $373310daccdd03b3$var$pull,
    matches: $373310daccdd03b3$var$matches,
    unique: $373310daccdd03b3$var$unique
};


/**
 * Performs an deep extend on the objects, from right to left.
 * @private
 * @param {Object[]} objects - An array of JS objects
 * @param {Function} collision - A function to be called when a merge collision happens.
 * @param {string[]} path - (for internal use) An array of strings which is the current path down the object when this is called recursively.
 * @returns {Object}
 */ function $76867978931fa972$var$deepExtend(objects, collision, path) {
    if (objects == null) return {};
    var src, copyIsArray, copy, name, options, clone, target = objects[0] || {}, i = 1, length = objects.length;
    path = path || [];
    // Handle case when target is a string or something (possible in deep copy)
    if (typeof target !== "object") target = {};
    for(; i < length; i++){
        // Only deal with non-null/undefined values
        if ((options = objects[i]) != null) // Extend the base object
        for(name in options){
            if (!options.hasOwnProperty(name)) continue;
            if (name === "__proto__") continue;
            src = target[name];
            copy = options[name];
            // Prevent never-ending loop
            if (target === copy) continue;
            // Recurse if we're merging plain objects or arrays
            if (copy && ($373310daccdd03b3$exports.isPlainObject(copy) || (copyIsArray = $373310daccdd03b3$exports.isArray(copy)))) {
                if (copyIsArray) {
                    copyIsArray = false;
                    clone = src && $373310daccdd03b3$exports.isArray(src) ? src : [];
                } else clone = src && $373310daccdd03b3$exports.isPlainObject(src) ? src : {};
                var nextPath = path.slice(0);
                nextPath.push(name);
                // Never move original objects, clone them
                target[name] = $76867978931fa972$var$deepExtend([
                    clone,
                    copy
                ], collision, nextPath);
            // Don't bring in undefined values
            } else if (copy !== undefined) {
                if (src != null && typeof collision == "function") collision({
                    target: target,
                    copy: options,
                    path: path,
                    key: name
                });
                target[name] = copy;
            }
        }
    }
    return target;
}
$76867978931fa972$exports = $76867978931fa972$var$deepExtend;


var $7b55cbecc3a8cf8e$exports = {};
/*
 * Copyright 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
/**
 * Takes an plain javascript object and will make a flat array of all the leaf nodes.
 * A leaf node in this context has a 'value' property. Potentially refactor this to
 * be more generic.
 * @private
 * @param  {Object} properties - The plain object you want flattened into an array.
 * @param  {Array} [to_ret=[]] - Properties array. This function is recursive therefore this is what gets passed along.
 * @return {Array}
 */ function $7b55cbecc3a8cf8e$var$flattenProperties(properties, to_ret) {
    to_ret = to_ret || [];
    for(var name in properties)if (properties.hasOwnProperty(name)) {
        // TODO: this is a bit fragile and arbitrary to stop when we get to a 'value' property.
        if ($373310daccdd03b3$exports.isPlainObject(properties[name]) && "value" in properties[name]) to_ret.push(properties[name]);
        else if ($373310daccdd03b3$exports.isPlainObject(properties[name])) $7b55cbecc3a8cf8e$var$flattenProperties(properties[name], to_ret);
    }
    return to_ret;
}
$7b55cbecc3a8cf8e$exports = $7b55cbecc3a8cf8e$var$flattenProperties;







// Internal Style Dictionary methods
/**
 * This will take a design token and add some data to it for it
 * to be used in JS/CSS. It will create its CSS var name and update
 * the value to use a CSS var if it is a reference. It will also
 * add a `.toString()` method to make it easier to use in JS.
 *
 * We should see if there is a way to share this logic with style dictionary...
 */ const $9cc6eb5568d7900c$var$setupToken = ({ token: token, path: path })=>{
    const name = `--${(0, $08d92a30c154d78f$export$8658ddf1aae625a3)({
        path: path
    })}`;
    const { value: original } = token;
    const value = (0, $08d92a30c154d78f$export$55101aa37e5c1f8f)(token);
    return {
        name: name,
        original: original,
        path: path,
        value: value,
        toString: ()=>`var(${name})`
    };
};
/**
 * Takes a set of keys and a color name and returns an object of design tokens,
 * used for applying a primary color at the theme level to our tokens.
 *
 * createColorPalette({keys: ['10','20',...], value: 'red'})
 * returns {
 *   10: { value: '{colors.red.10.value}' },
 *   20: { value: '{colors.red.20.value}' },
 *   ...
 * }
 */ function $9cc6eb5568d7900c$var$createColorPalette({ keys: keys, value: value }) {
    return keys.reduce((acc, key)=>{
        return {
            ...acc,
            [key]: {
                value: `{colors.${value}.${key}.value}`
            }
        };
    }, {});
}
/**
 * This will be used like `const myTheme = createTheme({})`
 * `myTheme` can then be passed to a Provider or the generated CSS
 * can be passed to a stylesheet at build-time or run-time.
 * const myTheme = createTheme({})
 * const myOtherTheme = createTheme({}, myTheme);
 */ function $9cc6eb5568d7900c$export$25d302a5b900a763(theme, DefaultTheme = (0, $bb80f4d9bb18c481$export$164de7ab8df77ef0)) {
    // merge theme and DefaultTheme to get a complete theme
    // deepExtend is an internal Style Dictionary method
    // that performs a deep merge on n objects. We could change
    // this to another 3p deep merge solution too.
    const mergedTheme = (0, (/*@__PURE__*/$parcel$interopDefault($76867978931fa972$exports)))([
        {},
        DefaultTheme,
        theme
    ]);
    const { primaryColor: primaryColor, secondaryColor: secondaryColor } = mergedTheme;
    // apply primaryColor and secondaryColor if present
    if ((0, $697901644f774aa4$export$844ec244b1367d54)(primaryColor)) mergedTheme.tokens.colors.primary = $9cc6eb5568d7900c$var$createColorPalette({
        keys: Object.keys(mergedTheme.tokens.colors[primaryColor]),
        value: primaryColor
    });
    if ((0, $697901644f774aa4$export$844ec244b1367d54)(secondaryColor)) mergedTheme.tokens.colors.secondary = $9cc6eb5568d7900c$var$createColorPalette({
        keys: Object.keys(mergedTheme.tokens.colors[secondaryColor]),
        value: secondaryColor
    });
    // Setting up the tokens. This is similar to what Style Dictionary
    // does. At the end of this, each token should have:
    // - CSS variable name of itself
    // - its value (reference to another CSS variable or raw value)
    const tokens = (0, $08d92a30c154d78f$export$4ae67d38aae8ca2e)({
        tokens: mergedTheme.tokens,
        setupToken: $9cc6eb5568d7900c$var$setupToken
    }); // Setting the type here because setupTokens is recursive
    const { breakpoints: breakpoints, name: name } = mergedTheme;
    // flattenProperties is another internal Style Dictionary function
    // that creates an array of all tokens.
    let cssText = `[data-amplify-theme="${name}"] {\n` + (0, (/*@__PURE__*/$parcel$interopDefault($7b55cbecc3a8cf8e$exports)))(tokens).map((token)=>`${token.name}: ${token.value};`).join("\n") + `\n}\n`;
    let overrides = [];
    /**
     * For each override, we setup the tokens and then generate the CSS.
     * This allows us to have one single CSS string for all possible overrides
     * and avoid re-renders in React, but also support other frameworks as well.
     */ if (mergedTheme.overrides) overrides = mergedTheme.overrides.map((override)=>{
        const tokens = (0, $08d92a30c154d78f$export$4ae67d38aae8ca2e)({
            tokens: override.tokens,
            setupToken: $9cc6eb5568d7900c$var$setupToken
        });
        const customProperties = (0, (/*@__PURE__*/$parcel$interopDefault($7b55cbecc3a8cf8e$exports)))(tokens).map((token)=>`${token.name}: ${token.value};`).join("\n");
        // Overrides can have a selector, media query, breakpoint, or color mode
        // for creating the selector
        if ("selector" in override) cssText += `\n${override.selector} {\n${customProperties}\n}\n`;
        if ("mediaQuery" in override) cssText += `\n@media (${override.mediaQuery}) {
  [data-amplify-theme="${name}"] {
    ${customProperties}
  }
}\n`;
        if ("breakpoint" in override) {
            const breakpoint = mergedTheme.breakpoints.values[override.breakpoint];
            cssText += `\n@media (min-width: ${breakpoint}px) {
  [data-amplify-theme="${name}"] {
    ${customProperties}
  }
}\n`;
        }
        if ("colorMode" in override) {
            cssText += `\n@media (prefers-color-scheme: ${override.colorMode}) {
          [data-amplify-theme="${name}"][data-amplify-color-mode="system"] {
            ${customProperties}
            color-scheme: ${override.colorMode};
          }
        }\n`;
            cssText += `\n[data-amplify-theme="${name}"][data-amplify-color-mode="${override.colorMode}"] {
          ${customProperties}
          color-scheme: ${override.colorMode};
        }\n`;
        }
        return {
            ...override,
            tokens: tokens
        };
    });
    return {
        tokens: tokens,
        breakpoints: breakpoints,
        name: name,
        cssText: cssText,
        overrides: // keep overrides separate from base theme
        // this allows web platforms to use plain CSS scoped to a
        // selector and only override the CSS vars needed. This
        // means we could generate CSS at build-time in a postcss
        // plugin, or do it at runtime and inject the CSS into a
        // style tag.
        // This also allows RN to dynamically switch themes in a
        // provider.
        overrides
    };
}



var $1T1QG = parcelRequire("1T1QG");

const $7459dbaf8f127611$export$2c657da244d00bd6 = $1T1QG.createContext({
    theme: (0, $9cc6eb5568d7900c$export$25d302a5b900a763)(),
    colorMode: undefined
});


/**
 * Get current Theme object value from Amplify context.
 * Returns a default theme if context is not available
 */ const $506a2d9bc33e825f$export$1a3896b0420de28d = (context)=>{
    if (typeof context === "undefined" || typeof context.theme === "undefined") return (0, $9cc6eb5568d7900c$export$25d302a5b900a763)();
    return context.theme;
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/theming)
 */ const $506a2d9bc33e825f$export$93d4e7f90805808f = ()=>{
    const context = $1T1QG.useContext((0, $7459dbaf8f127611$export$2c657da244d00bd6));
    return $506a2d9bc33e825f$export$1a3896b0420de28d(context);
};
/**
 * Internal use only
 */ const $506a2d9bc33e825f$export$20f3076712c8dfa = ()=>{
    const context = $1T1QG.useContext((0, $7459dbaf8f127611$export$2c657da244d00bd6));
    return context.colorMode;
};




/**
 * This takes an unknown value, which could be a:
 * - design token: `color={tokens.colors.font.primary}`
 * - string, which could be a:
 *   - theme key: `color='font.primary'`
 *   - plain style: `color='red'`
 * - or a number: `padding={10}`
 * and returns the appropriate and resolved value
 */ const $3971d62165349457$export$741ad47189a64aa0 = ({ value: value, propKey: propKey, tokens: tokens })=>{
    if ((0, $08d92a30c154d78f$export$daee9cd42beef6d1)(value)) return value.toString();
    if ((0, $697901644f774aa4$export$844ec244b1367d54)(value)) return (0, $697901644f774aa4$export$844ec244b1367d54)(propKey) ? (0, $8a99379749f08332$export$b0c777ec01738e5b)(propKey, value, tokens) : value;
    return null;
};



const $8931b833f5ca2652$export$63d3b2476bc623b7 = (spanValue)=>{
    return spanValue === "auto" || typeof spanValue === "number" && !isNaN(spanValue) || typeof spanValue === "string" && !isNaN(parseFloat(spanValue));
};
const $8931b833f5ca2652$export$7a05ae144bf7b4de = (spanValue)=>{
    return spanValue === "auto" ? "auto" : `span ${spanValue}`;
};
const $8931b833f5ca2652$export$2289a9e09445ac09 = (spanValue)=>{
    // PropertyType
    if ($8931b833f5ca2652$export$63d3b2476bc623b7(spanValue)) return $8931b833f5ca2652$export$7a05ae144bf7b4de(spanValue);
    // PropertyType[]
    if (Array.isArray(spanValue)) return spanValue.map((value)=>$8931b833f5ca2652$export$7a05ae144bf7b4de(value));
    // ResponsiveObject<PropertyType>
    if (typeof spanValue === "object" && spanValue != null) return Object.entries(spanValue).reduce((acc, [key, value])=>({
            ...acc,
            [key]: $8931b833f5ca2652$export$7a05ae144bf7b4de(value)
        }), {});
    return null;
};
/**
 * Transforms style props to another target prop
 * where the original is a simpler API than the target.
 * This function will remove the original prop and
 * replace target prop values with calculated
 * E.g. rowSpan => row, columnSpan => column
 */ const $8931b833f5ca2652$export$708ec223603a550 = (props)=>{
    const { rowSpan: rowSpan, columnSpan: columnSpan, row: row, column: column, ...rest } = props;
    const { rowFromSpanValue: rowFromSpanValue, columnFromSpanValue: columnFromSpanValue } = $1T1QG.useMemo(()=>{
        return {
            rowFromSpanValue: $8931b833f5ca2652$export$2289a9e09445ac09(rowSpan),
            columnFromSpanValue: $8931b833f5ca2652$export$2289a9e09445ac09(columnSpan)
        };
    }, [
        rowSpan,
        columnSpan
    ]);
    return {
        row: !(0, $8a99379749f08332$export$68b32c1946a6b59c)(row) ? row : rowFromSpanValue,
        column: !(0, $8a99379749f08332$export$68b32c1946a6b59c)(column) ? column : columnFromSpanValue,
        ...rest
    };
};
const $8931b833f5ca2652$var$isComponentStyleProp = (key)=>{
    return key in (0, $4d74122378cfaa18$export$c69338bc7d797351);
};
/**
 * Convert style props to CSS variables for React style prop
 * Note: Will filter out undefined, null, and empty string prop values
 */ const $8931b833f5ca2652$export$2184e8c9a9308f34 = ({ props: props = {}, style: style = {}, breakpoint: breakpoint, breakpoints: breakpoints, tokens: tokens })=>{
    const nonStyleProps = {};
    Object.keys(props).filter((propKey)=>props[propKey] !== null).forEach((propKey)=>{
        if ($8931b833f5ca2652$var$isComponentStyleProp(propKey)) {
            const values = props[propKey];
            if (!values || (0, $8a99379749f08332$export$78d1711480f95c3e)(values)) return;
            const reactStyleProp = (0, $4d74122378cfaa18$export$c69338bc7d797351)[propKey];
            // short circuit the style prop here if it is a string or design token
            // so we don't have to call getValueAtCurrentBreakpoint every time
            let value = "";
            if ((0, $08d92a30c154d78f$export$daee9cd42beef6d1)(values)) value = values.toString();
            else if (typeof values === "string") value = (0, $8a99379749f08332$export$b0c777ec01738e5b)(propKey, values, tokens);
            else if (typeof values === "number") value = values;
            else if (typeof values === "object") // here values should be a responsive array or object
            value = (0, $3971d62165349457$export$741ad47189a64aa0)({
                propKey: propKey,
                tokens: tokens,
                value: (0, $009f8abb82bf5000$export$7791b19c8f6fdbca)({
                    values: values,
                    breakpoint: breakpoint,
                    breakpoints: breakpoints
                })
            });
            style = {
                ...style,
                [reactStyleProp]: value
            };
        } else if (typeof props[propKey] !== "undefined") nonStyleProps[propKey] = props[propKey];
    });
    return {
        propStyles: style,
        nonStyleProps: nonStyleProps
    };
};
const $8931b833f5ca2652$export$28e6b9b82ee883c = (props, style)=>{
    const { breakpoints: { values: breakpoints, defaultBreakpoint: defaultBreakpoint }, tokens: tokens } = (0, $506a2d9bc33e825f$export$93d4e7f90805808f)();
    const breakpoint = (0, $2e812fd4d99aa7e5$export$199d6754bdf4e1e3)({
        breakpoints: breakpoints,
        defaultBreakpoint: defaultBreakpoint
    });
    const propStyles = $8931b833f5ca2652$export$708ec223603a550(props);
    return $1T1QG.useMemo(()=>$8931b833f5ca2652$export$2184e8c9a9308f34({
            props: propStyles,
            style: style,
            breakpoint: breakpoint,
            breakpoints: breakpoints,
            tokens: tokens
        }), [
        propStyles,
        style,
        breakpoints,
        breakpoint,
        tokens
    ]);
};



const $b9892b8eefdea848$var$ViewPrimitive = ({ as: as = "div", children: children, testId: testId, ariaLabel: ariaLabel, isDisabled: isDisabled, style: style, inert: inert, ...rest }, ref)=>{
    const { propStyles: propStyles, nonStyleProps: nonStyleProps } = (0, $8931b833f5ca2652$export$28e6b9b82ee883c)(rest, style);
    return $1T1QG.createElement(as, {
        "aria-label": ariaLabel,
        "data-testid": testId,
        disabled: isDisabled,
        ref: ref,
        inert: inert ? "" : null,
        style: propStyles,
        ...nonStyleProps
    }, children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/view)
 */ const $b9892b8eefdea848$export$27a5bd065ad55220 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($b9892b8eefdea848$var$ViewPrimitive);
$b9892b8eefdea848$export$27a5bd065ad55220.displayName = "View";



const $a7adec5cc5c7ad96$var$FlexPrimitive = ({ className: className, children: children, ...rest }, ref)=>$1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Flex, className),
        ref: ref,
        ...rest
    }, children);
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/flex)
 */ const $a7adec5cc5c7ad96$export$f51f4c4ede09e011 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($a7adec5cc5c7ad96$var$FlexPrimitive);
$a7adec5cc5c7ad96$export$f51f4c4ede09e011.displayName = "Flex";



var $1T1QG = parcelRequire("1T1QG");



const $3575c5674d01f76e$export$c47c5262afb3a760 = "linear-empty";
const $3575c5674d01f76e$export$84e78a619b590ebb = "linear-filled";
const $3575c5674d01f76e$export$2dac697651a47d0c = "circular-empty";
const $3575c5674d01f76e$export$c6c37ac3a7f79d5a = "circular-filled";
// radius + strokeWidth = 50
const $3575c5674d01f76e$export$a2450a64b7863610 = 8;
const $3575c5674d01f76e$export$2d2c9be8b5b863f = 42;
// circumference = 2 * r * PI  (r = 42)
const $3575c5674d01f76e$export$d13f13f2833cdb46 = 2 * $3575c5674d01f76e$export$2d2c9be8b5b863f * Math.PI;
const $3575c5674d01f76e$var$LoaderPrimitive = ({ className: className, filledColor: filledColor, emptyColor: emptyColor, size: size, variation: variation, isDeterminate: isDeterminate = false, isPercentageTextHidden: isPercentageTextHidden = false, percentage: percentage = 0, ...rest }, ref)=>{
    percentage = Math.min(percentage, 100);
    percentage = Math.max(percentage, 0);
    const percent = `${percentage}%`;
    const componentClasses = (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Loader, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Loader, size), (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Loader, variation), (0, $697901644f774aa4$export$3c152e7b97c7496c)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Loader, "determinate", isDeterminate), className);
    const linearLoader = $1T1QG.createElement("g", null, $1T1QG.createElement("line", {
        x1: "0",
        x2: "100%",
        y1: "50%",
        y2: "50%",
        style: {
            stroke: String(emptyColor)
        },
        "data-testid": $3575c5674d01f76e$export$c47c5262afb3a760
    }), $1T1QG.createElement("line", {
        x1: "0",
        x2: isDeterminate ? percent : "100%",
        y1: "50%",
        y2: "50%",
        style: {
            // To get rid of the visible stroke linecap when percentage is 0
            stroke: isDeterminate && percentage === 0 ? "none" : filledColor ? String(filledColor) : undefined
        },
        "data-testid": $3575c5674d01f76e$export$84e78a619b590ebb
    }), isDeterminate ? $1T1QG.createElement("text", {
        "aria-live": "polite",
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).LoaderLabel, isPercentageTextHidden ? (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).VisuallyHidden : null),
        // -1% offset makes the text position look nicest
        x: `${-1 + percentage}%`,
        y: "200%"
    }, percent) : null);
    // r + stroke-width should add up to 50% to avoid overflow
    const circularLoader = $1T1QG.createElement("g", null, $1T1QG.createElement("circle", {
        cx: "50%",
        cy: "50%",
        r: `${$3575c5674d01f76e$export$2d2c9be8b5b863f}%`,
        strokeWidth: `${$3575c5674d01f76e$export$a2450a64b7863610}%`,
        style: {
            stroke: String(emptyColor)
        },
        "data-testid": $3575c5674d01f76e$export$2dac697651a47d0c
    }), $1T1QG.createElement("circle", {
        cx: "50%",
        cy: "50%",
        r: `${$3575c5674d01f76e$export$2d2c9be8b5b863f}%`,
        strokeWidth: `${$3575c5674d01f76e$export$a2450a64b7863610}%`,
        style: {
            stroke: String(filledColor),
            strokeDasharray: isDeterminate ? `${$3575c5674d01f76e$export$d13f13f2833cdb46}% ${$3575c5674d01f76e$export$d13f13f2833cdb46}%` : undefined,
            strokeDashoffset: isDeterminate ? `${$3575c5674d01f76e$export$d13f13f2833cdb46 - $3575c5674d01f76e$export$d13f13f2833cdb46 * percentage / 100}%` : undefined
        },
        "data-testid": $3575c5674d01f76e$export$c6c37ac3a7f79d5a
    }), isDeterminate ? $1T1QG.createElement("text", {
        "aria-live": "polite",
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).LoaderLabel, isPercentageTextHidden ? (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).VisuallyHidden : null),
        // this x and y make text position look nicest
        x: "130%",
        y: "80%"
    }, percent) : null);
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        as: "svg",
        className: componentClasses,
        ref: ref,
        role: "img",
        ...rest
    }, variation === "linear" ? linearLoader : circularLoader);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/loader)
 */ const $3575c5674d01f76e$export$3b0d6d7590275603 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($3575c5674d01f76e$var$LoaderPrimitive);
$3575c5674d01f76e$export$3b0d6d7590275603.displayName = "Loader";



// These variations support colorThemes. 'undefined' accounts for our
// 'default' variation which is not named.
const $5f03125e4b28b868$var$supportedVariations = [
    "link",
    "primary",
    undefined
];
const $5f03125e4b28b868$var$ButtonPrimitive = ({ className: className, children: children, colorTheme: colorTheme, isFullWidth: isFullWidth = false, isDisabled: isDisabled, isLoading: isLoading, loadingText: loadingText = "", size: size, type: type = "button", variation: variation, ...rest }, ref)=>{
    // Creates our colorTheme modifier string based on if the variation
    // supports colorThemes and a colorTheme is used.
    const colorThemeModifier = $5f03125e4b28b868$var$supportedVariations.includes(variation) && colorTheme ? `${variation ?? "outlined"}--${colorTheme}` : undefined;
    const { isFieldsetDisabled: isFieldsetDisabled } = (0, $b452cc20c9476a43$export$b140571ec72925dd)();
    const shouldBeDisabled = isFieldsetDisabled ? isFieldsetDisabled : isDisabled ?? isLoading ?? rest["disabled"];
    const componentClasses = (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Button, (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldGroupControl, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Button, variation), (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Button, colorThemeModifier), (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Button, size), (0, $697901644f774aa4$export$3c152e7b97c7496c)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Button, "disabled", shouldBeDisabled), (0, $697901644f774aa4$export$3c152e7b97c7496c)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Button, "loading", isLoading), (0, $697901644f774aa4$export$3c152e7b97c7496c)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Button, "fullwidth", isFullWidth), className);
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        ref: ref,
        as: "button",
        className: componentClasses,
        isDisabled: shouldBeDisabled,
        type: type,
        ...rest
    }, isLoading ? $1T1QG.createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        as: "span",
        className: (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).ButtonLoaderWrapper
    }, $1T1QG.createElement((0, $3575c5674d01f76e$export$3b0d6d7590275603), {
        size: size
    }), loadingText ? loadingText : null) : children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/button)
 */ const $5f03125e4b28b868$export$353f5b6fc5456de1 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($5f03125e4b28b868$var$ButtonPrimitive);
$5f03125e4b28b868$export$353f5b6fc5456de1.displayName = "Button";




var $1T1QG = parcelRequire("1T1QG");



const $bbc3d6a725e07173$var$headingLevels = {
    1: "h1",
    2: "h2",
    3: "h3",
    4: "h4",
    5: "h5",
    6: "h6"
};
const $bbc3d6a725e07173$var$HeadingPrimitive = ({ className: className, children: children, isTruncated: isTruncated, level: level = 6, ...rest }, ref)=>$1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        as: $bbc3d6a725e07173$var$headingLevels[level],
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Heading, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Heading, level), (0, $697901644f774aa4$export$3c152e7b97c7496c)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Heading, "truncated", isTruncated), className),
        ref: ref,
        ...rest
    }, children);
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/heading)
 */ const $bbc3d6a725e07173$export$a8a3e93435678ff9 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($bbc3d6a725e07173$var$HeadingPrimitive);
$bbc3d6a725e07173$export$a8a3e93435678ff9.displayName = "Heading";



var $1T1QG = parcelRequire("1T1QG");



const $c7c0980bb0c6b26c$var$TextPrimitive = ({ as: as = "p", className: className, children: children, isTruncated: isTruncated, variation: variation, ...rest }, ref)=>{
    const componentClasses = (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Text, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Text, variation), (0, $697901644f774aa4$export$3c152e7b97c7496c)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Text, "truncated", isTruncated), className);
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        as: as,
        className: componentClasses,
        ref: ref,
        ...rest
    }, children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/text)
 */ const $c7c0980bb0c6b26c$export$5f1af8db9871e1d6 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($c7c0980bb0c6b26c$var$TextPrimitive);
$c7c0980bb0c6b26c$export$5f1af8db9871e1d6.displayName = "Text";





var $1T1QG = parcelRequire("1T1QG");
const $35e794eaee6cfb92$export$e29bbbec84471f66 = (event)=>{
    const formData = new FormData(event.target);
    return Object.fromEntries(formData);
};



function $16a5ca7cf5bd8228$export$df6a82844cee724c() {
    const { submitForm: submitForm, updateBlur: updateBlur, updateForm: updateForm } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)((context)=>[
            context.submitForm,
            context.updateBlur,
            context.updateForm
        ]);
    const handleBlur = (0, $1T1QG.useCallback)(({ target: { name: name } })=>{
        updateBlur({
            name: name
        });
    }, [
        updateBlur
    ]);
    // @TODO: align multiple input type handling with react docs example for 3.0 release
    // example: https://reactjs.org/docs/forms.html#handling-multiple-inputs
    const handleChange = (0, $1T1QG.useCallback)(({ target: { checked: checked, name: name, type: type, value: value } })=>{
        const isUncheckedCheckbox = type === "checkbox" && !checked;
        updateForm({
            name: name,
            value: isUncheckedCheckbox ? undefined : value
        });
    }, [
        updateForm
    ]);
    const handleSubmit = (0, $1T1QG.useCallback)((event)=>{
        event.preventDefault();
        submitForm((0, $35e794eaee6cfb92$export$e29bbbec84471f66)(event));
    }, [
        submitForm
    ]);
    return {
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleSubmit: handleSubmit
    };
}



var $1T1QG = parcelRequire("1T1QG");



var $1T1QG = parcelRequire("1T1QG");







var $1T1QG = parcelRequire("1T1QG");




var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");
const $fc71a109cc7d61d7$export$5f8c516af44338bb = $1T1QG.createContext({});


function $0be5327249b09e5b$export$75b0b37acc90e887(component) {
    const context = $1T1QG.useContext((0, $fc71a109cc7d61d7$export$5f8c516af44338bb));
    if (component && context) return context[component];
    return undefined;
}




var $1T1QG = parcelRequire("1T1QG");


/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $1f3541a60fb17792$export$8fb9587943155ce3 = (props)=>{
    const { className: className, ...rest } = props;
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $1T1QG.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $1T1QG.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z",
        fill: "currentColor"
    })));
};




var $1T1QG = parcelRequire("1T1QG");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $a784e0c754c97550$export$66493327321323ad = (props)=>{
    const { className: className, ...rest } = props;
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $1T1QG.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $1T1QG.createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z",
        fill: "currentColor"
    })));
};




var $1T1QG = parcelRequire("1T1QG");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $e0825218b6f74d3c$export$340bfce9b4df026b = (props)=>{
    const { className: className, ...rest } = props;
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $1T1QG.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $1T1QG.createElement("path", {
        d: "M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
        fill: "currentColor"
    })));
};




var $1T1QG = parcelRequire("1T1QG");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $757eb5a1cbf583d5$export$5be70e40251e6f9b = (props)=>{
    const { className: className, ...rest } = props;
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $1T1QG.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $1T1QG.createElement("path", {
        d: "M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z",
        fill: "currentColor"
    })));
};


/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $b1f7a0bf5794eb7d$export$4a143c8822a09fb4 = ({ variation: variation, ariaHidden: ariaHidden })=>{
    const icons = (0, $0be5327249b09e5b$export$75b0b37acc90e887)("alert");
    let icon;
    switch(variation){
        case "info":
            icon = icons?.info ?? $1T1QG.createElement((0, $e0825218b6f74d3c$export$340bfce9b4df026b), {
                "aria-hidden": ariaHidden
            });
            break;
        case "error":
            icon = icons?.error ?? $1T1QG.createElement((0, $a784e0c754c97550$export$66493327321323ad), {
                "aria-hidden": ariaHidden
            });
            break;
        case "warning":
            icon = icons?.warning ?? $1T1QG.createElement((0, $757eb5a1cbf583d5$export$5be70e40251e6f9b), {
                "aria-hidden": ariaHidden
            });
            break;
        case "success":
            icon = icons?.success ?? $1T1QG.createElement((0, $1f3541a60fb17792$export$8fb9587943155ce3), {
                "aria-hidden": ariaHidden
            });
            break;
    }
    return icon ? $1T1QG.createElement("span", {
        className: (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).AlertIcon
    }, icon) : null;
};
$b1f7a0bf5794eb7d$export$4a143c8822a09fb4.displayName = "AlertIcon";







var $1T1QG = parcelRequire("1T1QG");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $5d89e75616963160$export$e04bcc6127e699bf = (props)=>{
    const { className: className, size: size, ...rest } = props;
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        as: "span",
        width: size ?? "1em",
        height: size ?? "1em",
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $1T1QG.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: size ? {
            width: size,
            height: size
        } : undefined
    }, $1T1QG.createElement("path", {
        d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
        fill: "currentColor"
    })));
};


const $016efa8509eb1e0c$var$AlertPrimitive = ({ buttonRef: buttonRef, children: children, className: className, dismissButtonLabel: dismissButtonLabel = (0, $9932198a76a9e84a$export$529e7eefcb1e2a4c).Alert.dismissButtonLabel, hasIcon: hasIcon = true, heading: heading, isDismissible: isDismissible = false, onDismiss: onDismiss, variation: variation, ...rest }, ref)=>{
    const [dismissed, setDismissed] = $1T1QG.useState(false);
    const icons = (0, $0be5327249b09e5b$export$75b0b37acc90e887)("alert");
    const dismissAlert = $1T1QG.useCallback(()=>{
        setDismissed(!dismissed);
        if ((0, $697901644f774aa4$export$f6e2535fb5126e54)(onDismiss)) onDismiss();
    }, [
        setDismissed,
        onDismiss,
        dismissed
    ]);
    return !dismissed ? $1T1QG.createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Alert, className, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Alert, variation)),
        ref: ref,
        role: "alert",
        ...rest
    }, hasIcon && $1T1QG.createElement((0, $b1f7a0bf5794eb7d$export$4a143c8822a09fb4), {
        variation: variation,
        ariaHidden: true
    }), $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        flex: "1"
    }, heading && $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        className: (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).AlertHeading
    }, heading), $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        className: (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).AlertBody
    }, children)), isDismissible && $1T1QG.createElement((0, $5f03125e4b28b868$export$353f5b6fc5456de1), {
        ariaLabel: dismissButtonLabel,
        variation: "link",
        className: (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).AlertDismiss,
        onClick: dismissAlert,
        ref: buttonRef
    }, icons?.close ?? $1T1QG.createElement((0, $5d89e75616963160$export$e04bcc6127e699bf), {
        "aria-hidden": "true"
    }))) : null;
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/alert)
 */ const $016efa8509eb1e0c$export$caec2af78bcc877f = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($016efa8509eb1e0c$var$AlertPrimitive);
$016efa8509eb1e0c$export$caec2af78bcc877f.displayName = "Alert";


const $7c0fbecde5c7131e$export$3caa4b6a8cb6c61a = ()=>{
    const { error: error } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)((context)=>[
            context.error
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, null, error ? (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $016efa8509eb1e0c$export$caec2af78bcc877f), {
        variation: "error",
        isDismissible: true
    }, (0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)(error)) : null);
};



var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");



var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");



var $1T1QG = parcelRequire("1T1QG");



const $bb7aa8a63591024b$var$VisuallyHiddenPrimitive = ({ as: as = "span", children: children, className: className, ...rest }, ref)=>$1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        as: as,
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).VisuallyHidden, className),
        ref: ref,
        ...rest
    }, children);
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/visuallyhidden)
 */ const $bb7aa8a63591024b$export$439d29a4e110a164 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($bb7aa8a63591024b$var$VisuallyHiddenPrimitive);
$bb7aa8a63591024b$export$439d29a4e110a164.displayName = "VisuallyHidden";









var $1T1QG = parcelRequire("1T1QG");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $a4d716b98a5daf4b$export$9ef36bcf05bb63d9 = (props)=>{
    const { className: className, ...rest } = props;
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $1T1QG.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $1T1QG.createElement("path", {
        d: "M12 6.0002C15.79 6.0002 19.17 8.1302 20.82 11.5002C20.23 12.7202 19.4 13.7702 18.41 14.6202L19.82 16.0302C21.21 14.8002 22.31 13.2602 23 11.5002C21.27 7.1102 17 4.0002 12 4.0002C10.73 4.0002 9.51 4.2002 8.36 4.5702L10.01 6.2202C10.66 6.0902 11.32 6.0002 12 6.0002ZM10.93 7.14019L13 9.2102C13.57 9.4602 14.03 9.9202 14.28 10.4902L16.35 12.5602C16.43 12.2202 16.49 11.8602 16.49 11.4902C16.5 9.0102 14.48 7.0002 12 7.0002C11.63 7.0002 11.28 7.05019 10.93 7.14019ZM2.01 3.8702L4.69 6.5502C3.06 7.8302 1.77 9.5302 1 11.5002C2.73 15.8902 7 19.0002 12 19.0002C13.52 19.0002 14.98 18.7102 16.32 18.1802L19.74 21.6002L21.15 20.1902L3.42 2.4502L2.01 3.8702ZM9.51 11.3702L12.12 13.9802C12.08 13.9902 12.04 14.0002 12 14.0002C10.62 14.0002 9.5 12.8802 9.5 11.5002C9.5 11.4502 9.51 11.4202 9.51 11.3702V11.3702ZM6.11 7.97019L7.86 9.7202C7.63 10.2702 7.5 10.8702 7.5 11.5002C7.5 13.9802 9.52 16.0002 12 16.0002C12.63 16.0002 13.23 15.8702 13.77 15.6402L14.75 16.6202C13.87 16.8602 12.95 17.0002 12 17.0002C8.21 17.0002 4.83 14.8702 3.18 11.5002C3.88 10.0702 4.9 8.89019 6.11 7.97019Z",
        fill: "currentColor"
    })));
};




var $1T1QG = parcelRequire("1T1QG");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $a071165ae6bc888a$export$e8b904c5d6d728c0 = (props)=>{
    const { className: className, ...rest } = props;
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $1T1QG.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $1T1QG.createElement("path", {
        d: "M12 6C15.79 6 19.17 8.13 20.82 11.5C19.17 14.87 15.79 17 12 17C8.21 17 4.83 14.87 3.18 11.5C4.83 8.13 8.21 6 12 6ZM12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 9C13.38 9 14.5 10.12 14.5 11.5C14.5 12.88 13.38 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 10.12 10.62 9 12 9ZM12 7C9.52 7 7.5 9.02 7.5 11.5C7.5 13.98 9.52 16 12 16C14.48 16 16.5 13.98 16.5 11.5C16.5 9.02 14.48 7 12 7Z",
        fill: "currentColor"
    })));
};



const { passwordIsHidden: $874d0ed850a12037$var$passwordIsHidden, passwordIsShown: $874d0ed850a12037$var$passwordIsShown, showPassword: $874d0ed850a12037$var$showPassword } = (0, $9932198a76a9e84a$export$529e7eefcb1e2a4c).PasswordField;
const $874d0ed850a12037$var$ShowPasswordButtonPrimitive = ({ fieldType: fieldType, passwordIsHiddenLabel: passwordIsHiddenLabel = $874d0ed850a12037$var$passwordIsHidden, passwordIsShownLabel: passwordIsShownLabel = $874d0ed850a12037$var$passwordIsShown, showPasswordButtonLabel: showPasswordButtonLabel = $874d0ed850a12037$var$showPassword, size: size, hasError: hasError, ...rest }, ref)=>{
    const icons = (0, $0be5327249b09e5b$export$75b0b37acc90e887)("passwordField");
    const showPasswordButtonClass = (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldShowPassword, (0, $697901644f774aa4$export$3c152e7b97c7496c)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldShowPassword, "error", hasError));
    const icon = fieldType === "password" ? icons?.visibility ?? $1T1QG.createElement((0, $a071165ae6bc888a$export$e8b904c5d6d728c0), {
        "aria-hidden": "true"
    }) : icons?.visibilityOff ?? $1T1QG.createElement((0, $a4d716b98a5daf4b$export$9ef36bcf05bb63d9), {
        "aria-hidden": "true"
    });
    return $1T1QG.createElement((0, $5f03125e4b28b868$export$353f5b6fc5456de1), {
        "aria-checked": fieldType !== "password",
        ariaLabel: showPasswordButtonLabel,
        className: showPasswordButtonClass,
        ref: ref,
        role: "switch",
        size: size,
        ...rest
    }, $1T1QG.createElement((0, $bb7aa8a63591024b$export$439d29a4e110a164), {
        "aria-live": "polite"
    }, fieldType === "password" ? passwordIsHiddenLabel : passwordIsShownLabel), icon);
};
const $874d0ed850a12037$export$c42f83a0ca8c8188 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($874d0ed850a12037$var$ShowPasswordButtonPrimitive);
$874d0ed850a12037$export$c42f83a0ca8c8188.displayName = "ShowPasswordButton";



var $1T1QG = parcelRequire("1T1QG");



var $1T1QG = parcelRequire("1T1QG");


const $3d5fc43d7e111c1f$export$806e181b7f4dca8a = "qa-field-description";
const $3d5fc43d7e111c1f$export$873ced4623a3149c = ({ descriptiveText: descriptiveText, labelHidden: labelHidden, ...rest })=>descriptiveText ? $1T1QG.createElement((0, $c7c0980bb0c6b26c$export$5f1af8db9871e1d6), {
        "data-testid": $3d5fc43d7e111c1f$export$806e181b7f4dca8a,
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldDescription, {
            [(0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).VisuallyHidden]: labelHidden
        }),
        ...rest
    }, descriptiveText) : null;
$3d5fc43d7e111c1f$export$873ced4623a3149c.displayName = "FieldDescription";



var $1T1QG = parcelRequire("1T1QG");


const $6b2b98e8fced570c$export$1c081951d49ad6f6 = ({ errorMessage: errorMessage, hasError: hasError, ...rest })=>{
    return hasError && errorMessage ? $1T1QG.createElement((0, $c7c0980bb0c6b26c$export$5f1af8db9871e1d6), {
        className: (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldErrorMessage,
        ...rest
    }, errorMessage) : null;
};
$6b2b98e8fced570c$export$1c081951d49ad6f6.displayName = "FieldErrorMessage";




var $1T1QG = parcelRequire("1T1QG");




const $3622742e60a8e492$var$FieldGroupPrimitive = ({ children: children, className: className, innerEndComponent: innerEndComponent, innerStartComponent: innerStartComponent, orientation: orientation = "horizontal", outerEndComponent: outerEndComponent, outerStartComponent: outerStartComponent, variation: variation, ...rest }, ref)=>{
    // Don't apply hasInner classnames unless a component was provided
    const hasInnerStartComponent = innerStartComponent != null;
    const hasInnerEndComponent = innerEndComponent != null;
    const fieldGroupHasInnerStartClassName = hasInnerStartComponent ? (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldGroupHasInnerStart : null;
    const fieldGroupHasInnerEndClassName = hasInnerEndComponent ? (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldGroupHasInnerEnd : null;
    const componentClasses = (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldGroup, fieldGroupHasInnerStartClassName, fieldGroupHasInnerEndClassName, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldGroup, orientation), className);
    return $1T1QG.createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        className: componentClasses,
        ref: ref,
        ...rest
    }, outerStartComponent && $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldGroupOuterStart, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldGroupOuterStart, variation))
    }, outerStartComponent), $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldGroupFieldWrapper, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldGroupFieldWrapper, orientation))
    }, innerStartComponent && $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        className: (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldGroupInnerStart
    }, innerStartComponent), children, innerEndComponent && $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        className: (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldGroupInnerEnd
    }, innerEndComponent)), outerEndComponent && $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldGroupOuterEnd, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldGroupOuterEnd, variation))
    }, outerEndComponent));
};
const $3622742e60a8e492$export$f0fe469072bc6950 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($3622742e60a8e492$var$FieldGroupPrimitive);
$3622742e60a8e492$export$f0fe469072bc6950.displayName = "FieldGroup";




var $1T1QG = parcelRequire("1T1QG");




const $2ef4aacb642dd7a5$var$InputPrimitive = ({ autoComplete: autoComplete, checked: checked, className: className, defaultChecked: defaultChecked, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isReadOnly: isReadOnly, isRequired: isRequired, size: size, type: type = "text", hasError: hasError = false, value: value, variation: variation, ...rest }, ref)=>{
    const componentClasses = (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Input, (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldGroupControl, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Input, variation), (0, $697901644f774aa4$export$3c152e7b97c7496c)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Input, "error", hasError), (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Input, size), className);
    const { isFieldsetDisabled: isFieldsetDisabled } = (0, $b452cc20c9476a43$export$b140571ec72925dd)();
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        "aria-invalid": hasError,
        as: "input",
        autoComplete: autoComplete,
        checked: checked,
        className: componentClasses,
        defaultChecked: defaultChecked,
        defaultValue: defaultValue,
        isDisabled: isFieldsetDisabled ? isFieldsetDisabled : isDisabled,
        id: id,
        readOnly: isReadOnly,
        ref: ref,
        required: isRequired,
        type: type,
        value: value,
        ...rest
    });
};
const $2ef4aacb642dd7a5$export$f5b8910cec6cf069 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($2ef4aacb642dd7a5$var$InputPrimitive);
$2ef4aacb642dd7a5$export$f5b8910cec6cf069.displayName = "Input";



var $1T1QG = parcelRequire("1T1QG");



const $5a2f4337d5e69706$var$LabelPrimitive = ({ children: children, className: className, visuallyHidden: visuallyHidden, ...rest }, ref)=>{
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        as: "label",
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Label, className, {
            [(0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).VisuallyHidden]: visuallyHidden
        }),
        ref: ref,
        ...rest
    }, children);
};
const $5a2f4337d5e69706$export$b04be29aa201d4f5 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($5a2f4337d5e69706$var$LabelPrimitive);
$5a2f4337d5e69706$export$b04be29aa201d4f5.displayName = "Label";



const $34e5f83d61c8e041$var$isStyleKey = (prop)=>{
    return prop in (0, $4d74122378cfaa18$export$c69338bc7d797351);
};
/**
 * This function splits props into style props and non-style props. This is used
 * on Field primitives so we can apply style props on the wrapper element and
 * the rest on the input.
 * @param props this should be a destructured `rest` from the component's props
 */ const $34e5f83d61c8e041$export$584a75f5facb0a5 = (props)=>{
    const splitProps = {
        styleProps: {},
        rest: {}
    };
    Object.keys(props).forEach((prop)=>{
        if ($34e5f83d61c8e041$var$isStyleKey(prop)) // we know it is a style key
        // so we know we can assign the key in styleProps
        splitProps.styleProps = {
            ...splitProps.styleProps,
            [prop]: props[prop]
        };
        else splitProps.rest = {
            ...splitProps.rest,
            [prop]: props[prop]
        };
    });
    return splitProps;
};



var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");
// Source: https://github.com/radix-ui/primitives/blob/7ae63b6cce6ea53ea5d65b6d411894c004b38f47/packages/react/use-layout-effect/src/useLayoutEffect.tsx
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $d0af3108b6c593b4$export$e5c5a5f917a5871c = globalThis?.document ? $1T1QG.useLayoutEffect : ()=>{};


// Adapted from https://github.com/radix-ui/primitives/blob/main/packages/react/id/src/id.tsx#L8
// Prefixed autogenerated id created by useStableId
const $73bd3b14086bef4c$export$766b2b49c9d08de4 = "amplify-id";
// Create a local version of React.useId which will reference React.useId for React 18
// and fallback to noop for React 17 and below
// Note: We use `toString()` to prevent bundlers from trying to `import { useId } from 'react';`
// since it doesn't exist in React 17 and below (prevents https://github.com/aws-amplify/amplify-ui/issues/1154)
const $73bd3b14086bef4c$var$useReactId = // disable eslint below to allow usage of casting React to `any`, which ensures that TS
// does not get confused about the existence of `useId` in React 17 and below
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
$1T1QG["useId".toString()] || (()=>undefined);
let $73bd3b14086bef4c$var$count = 0;
/**
 * Create a uuid to use with amplify fields unless
 * an id is provided
 * @param id user specified id
 * @returns string
 */ const $73bd3b14086bef4c$export$5c0b1cf3fea224ac = (id)=>{
    const [stableId, setStableId] = $1T1QG.useState($73bd3b14086bef4c$var$useReactId());
    // React versions older than 18 will have client-side ids only
    (0, $d0af3108b6c593b4$export$e5c5a5f917a5871c)(()=>{
        if (!id) setStableId((reactId)=>reactId ?? String($73bd3b14086bef4c$var$count++));
    }, [
        id
    ]);
    return id ?? (stableId ? `${$73bd3b14086bef4c$export$766b2b49c9d08de4}-${stableId}` : "");
};



const $3d84ddb602bfccc3$var$TextFieldPrimitive = (props, ref)=>{
    const { className: className, descriptiveText: descriptiveText, errorMessage: errorMessage, hasError: hasError = false, id: id, innerEndComponent: innerEndComponent, innerStartComponent: innerStartComponent, label: label, labelHidden: labelHidden = false, outerEndComponent: outerEndComponent, outerStartComponent: outerStartComponent, size: size, testId: testId, variation: variation, inputStyles: inputStyles, ..._rest } = props;
    const fieldId = (0, $73bd3b14086bef4c$export$5c0b1cf3fea224ac)(id);
    const descriptionId = (0, $73bd3b14086bef4c$export$5c0b1cf3fea224ac)();
    const ariaDescribedBy = descriptiveText ? descriptionId : undefined;
    const { styleProps: styleProps, rest: rest } = (0, $34e5f83d61c8e041$export$584a75f5facb0a5)(_rest);
    return $1T1QG.createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Field, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Field, size), (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).TextField, className),
        testId: testId,
        ...styleProps
    }, $1T1QG.createElement((0, $5a2f4337d5e69706$export$b04be29aa201d4f5), {
        htmlFor: fieldId,
        visuallyHidden: labelHidden
    }, label), $1T1QG.createElement((0, $3d5fc43d7e111c1f$export$873ced4623a3149c), {
        id: descriptionId,
        labelHidden: labelHidden,
        descriptiveText: descriptiveText
    }), $1T1QG.createElement((0, $3622742e60a8e492$export$f0fe469072bc6950), {
        outerStartComponent: outerStartComponent,
        outerEndComponent: outerEndComponent,
        innerStartComponent: innerStartComponent,
        innerEndComponent: innerEndComponent,
        variation: variation
    }, $1T1QG.createElement((0, $2ef4aacb642dd7a5$export$f5b8910cec6cf069), {
        "aria-describedby": ariaDescribedBy,
        hasError: hasError,
        id: fieldId,
        ref: ref,
        size: size,
        variation: variation,
        ...inputStyles,
        ...rest
    })), $1T1QG.createElement((0, $6b2b98e8fced570c$export$1c081951d49ad6f6), {
        hasError: hasError,
        errorMessage: errorMessage
    }));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/textfield)
 */ const $3d84ddb602bfccc3$export$2c73285ae9390cec = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($3d84ddb602bfccc3$var$TextFieldPrimitive);
$3d84ddb602bfccc3$export$2c73285ae9390cec.displayName = "TextField";



const $73c9b9cfa5620843$var$PasswordFieldPrimitive = ({ autoComplete: autoComplete = "current-password", label: label, className: className, hideShowPassword: hideShowPassword = false, passwordIsHiddenLabel: passwordIsHiddenLabel, passwordIsShownLabel: passwordIsShownLabel, showPasswordButtonLabel: showPasswordButtonLabel, showPasswordButtonRef: showPasswordButtonRef, size: size, hasError: hasError, ...rest }, ref)=>{
    const [type, setType] = $1T1QG.useState("password");
    const showPasswordOnClick = $1T1QG.useCallback(()=>{
        if (type === "password") setType("text");
        else setType("password");
    }, [
        setType,
        type
    ]);
    return $1T1QG.createElement((0, $3d84ddb602bfccc3$export$2c73285ae9390cec), {
        autoComplete: autoComplete,
        outerEndComponent: hideShowPassword ? null : $1T1QG.createElement((0, $874d0ed850a12037$export$c42f83a0ca8c8188), {
            fieldType: type,
            onClick: showPasswordOnClick,
            passwordIsHiddenLabel: passwordIsHiddenLabel,
            passwordIsShownLabel: passwordIsShownLabel,
            ref: showPasswordButtonRef,
            size: size,
            showPasswordButtonLabel: showPasswordButtonLabel,
            hasError: hasError
        }),
        size: size,
        type: type,
        label: label,
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).PasswordField, className),
        ref: ref,
        hasError: hasError,
        ...rest
    });
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/passwordfield)
 */ const $73c9b9cfa5620843$export$65ed9482db2257fa = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($73c9b9cfa5620843$var$PasswordFieldPrimitive);
$73c9b9cfa5620843$export$65ed9482db2257fa.displayName = "PasswordField";



var $1T1QG = parcelRequire("1T1QG");


var $1T1QG = parcelRequire("1T1QG");


var $1T1QG = parcelRequire("1T1QG");








var $1T1QG = parcelRequire("1T1QG");








var $1T1QG = parcelRequire("1T1QG");

/**
 * @internal For internal Amplify UI use only. May be removed in a future release.
 */ const $1cbea18c8ea6fbf4$export$e0c00b3c5102a294 = (props)=>{
    const { className: className, ...rest } = props;
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        as: "span",
        width: "1em",
        height: "1em",
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Icon, className),
        ...rest
    }, $1T1QG.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $1T1QG.createElement("path", {
        d: "M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z",
        fill: "currentColor"
    })));
};




const $3bfc9286c614a41f$var$SelectPrimitive = ({ autoComplete: autoComplete, className: className, size: size, variation: variation, value: value, defaultValue: defaultValue, hasError: hasError, icon: icon, iconColor: iconColor, children: children, placeholder: placeholder, isDisabled: isDisabled, isRequired: isRequired, isMultiple: isMultiple = false, selectSize: selectSize = 1, ...rest }, ref)=>{
    const DEFAULT_PLACEHOLDER_VALUE = "";
    // value === undefined is to make sure that component is used in uncontrolled way so that setting defaultValue is valid
    const shouldSetDefaultPlaceholderValue = value === undefined && defaultValue === undefined && placeholder;
    const isExpanded = isMultiple || selectSize > 1;
    const componentClasses = (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Select, (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldGroupControl, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Select, size), (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Select, variation), (0, $697901644f774aa4$export$3c152e7b97c7496c)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Select, "error", hasError), (0, $697901644f774aa4$export$3c152e7b97c7496c)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Select, "expanded", isExpanded), className);
    const icons = (0, $0be5327249b09e5b$export$75b0b37acc90e887)("select");
    const { isFieldsetDisabled: isFieldsetDisabled } = (0, $b452cc20c9476a43$export$b140571ec72925dd)();
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        className: (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).SelectWrapper
    }, $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        "aria-invalid": hasError,
        as: "select",
        autoComplete: autoComplete,
        value: value,
        defaultValue: shouldSetDefaultPlaceholderValue ? DEFAULT_PLACEHOLDER_VALUE : defaultValue,
        isDisabled: isFieldsetDisabled ? isFieldsetDisabled : isDisabled,
        multiple: isMultiple,
        size: selectSize,
        required: isRequired,
        className: componentClasses,
        ref: ref,
        ...rest
    }, placeholder && $1T1QG.createElement("option", {
        value: ""
    }, placeholder), children), isExpanded ? null : $1T1QG.createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).SelectIcon, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).SelectIcon, size)),
        color: iconColor
    }, icon ?? icons?.expand ?? $1T1QG.createElement((0, $1cbea18c8ea6fbf4$export$e0c00b3c5102a294), null)));
};
const $3bfc9286c614a41f$export$ef9b1a59e592288f = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($3bfc9286c614a41f$var$SelectPrimitive);
$3bfc9286c614a41f$export$ef9b1a59e592288f.displayName = "Select";





const $4d8b59fc1072401e$var$selectFieldChildren = ({ children: children, options: options })=>{
    if (children) {
        if (options?.length) // eslint-disable-next-line no-console
        console.warn("Amplify UI: <SelectField> component  defaults to rendering children over `options`. When using the `options` prop, omit children.");
        return children;
    }
    return options?.map((option, index)=>$1T1QG.createElement("option", {
            label: option,
            value: option,
            key: `${option}-${index}`
        }, option));
};
const $4d8b59fc1072401e$var$SelectFieldPrimitive = (props, ref)=>{
    const { children: children, className: className, descriptiveText: descriptiveText, errorMessage: errorMessage, hasError: hasError = false, id: id, label: label, labelHidden: labelHidden = false, options: options, size: size, testId: testId, inputStyles: inputStyles, ..._rest } = props;
    const fieldId = (0, $73bd3b14086bef4c$export$5c0b1cf3fea224ac)(id);
    const descriptionId = (0, $73bd3b14086bef4c$export$5c0b1cf3fea224ac)();
    const ariaDescribedBy = descriptiveText ? descriptionId : undefined;
    const { styleProps: styleProps, rest: rest } = (0, $34e5f83d61c8e041$export$584a75f5facb0a5)(_rest);
    return $1T1QG.createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Field, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Field, size), (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).SelectField, className),
        testId: testId,
        ...styleProps
    }, $1T1QG.createElement((0, $5a2f4337d5e69706$export$b04be29aa201d4f5), {
        htmlFor: fieldId,
        visuallyHidden: labelHidden
    }, label), $1T1QG.createElement((0, $3d5fc43d7e111c1f$export$873ced4623a3149c), {
        id: descriptionId,
        labelHidden: labelHidden,
        descriptiveText: descriptiveText
    }), $1T1QG.createElement((0, $3bfc9286c614a41f$export$ef9b1a59e592288f), {
        "aria-describedby": ariaDescribedBy,
        hasError: hasError,
        id: fieldId,
        ref: ref,
        size: size,
        ...rest,
        ...inputStyles
    }, $4d8b59fc1072401e$var$selectFieldChildren({
        children: children,
        options: options
    })), $1T1QG.createElement((0, $6b2b98e8fced570c$export$1c081951d49ad6f6), {
        hasError: hasError,
        errorMessage: errorMessage
    }));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/selectfield)
 */ const $4d8b59fc1072401e$export$d55b50a564d0b931 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($4d8b59fc1072401e$var$SelectFieldPrimitive);
$4d8b59fc1072401e$export$d55b50a564d0b931.displayName = "SelectField";



const $c1f2e5ee66a81655$var$DialCodeSelectPrimitive = ({ className: className, dialCodeList: dialCodeList, isReadOnly: isReadOnly, ...props }, ref)=>{
    const dialList = dialCodeList ?? (0, $48c93fa42a87ef95$export$a51e8cda1526c737);
    const dialCodeOptions = $1T1QG.useMemo(()=>dialList.map((dialCode)=>// Regarding the `disabled` attribute, see comment in SelectField below
            $1T1QG.createElement("option", {
                key: dialCode,
                value: dialCode,
                disabled: isReadOnly
            }, dialCode)), [
        dialList,
        isReadOnly
    ]);
    return $1T1QG.createElement((0, $4d8b59fc1072401e$export$d55b50a564d0b931), {
        "aria-disabled": isReadOnly,
        autoComplete: "tel-country-code",
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).CountryCodeSelect, (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).DialCodeSelect, className),
        labelHidden: true,
        ref: ref,
        ...props
    }, dialCodeOptions);
};
const $c1f2e5ee66a81655$export$5dbfe48f3829fce4 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($c1f2e5ee66a81655$var$DialCodeSelectPrimitive);
$c1f2e5ee66a81655$export$5dbfe48f3829fce4.displayName = "DialCodeSelect";





const $5c73e591be7ed5dc$var$PhoneNumberFieldPrimitive = ({ autoComplete: autoComplete = "tel-national", className: className, defaultDialCode: defaultDialCode, dialCodeLabel: dialCodeLabel = (0, $9932198a76a9e84a$export$529e7eefcb1e2a4c).PhoneNumberField.countryCodeLabel, dialCodeList: dialCodeList, dialCodeName: dialCodeName, dialCodeRef: dialCodeRef, hasError: hasError, isDisabled: isDisabled, isReadOnly: isReadOnly, onDialCodeChange: onDialCodeChange, onInput: onInput, size: size, variation: variation, ...rest }, ref)=>{
    return $1T1QG.createElement((0, $3d84ddb602bfccc3$export$2c73285ae9390cec), {
        outerStartComponent: $1T1QG.createElement((0, $c1f2e5ee66a81655$export$5dbfe48f3829fce4), {
            defaultValue: defaultDialCode,
            dialCodeList: dialCodeList,
            className: className,
            hasError: hasError,
            isDisabled: isDisabled,
            isReadOnly: isReadOnly,
            label: dialCodeLabel,
            name: dialCodeName,
            onChange: onDialCodeChange,
            ref: dialCodeRef,
            size: size,
            variation: variation
        }),
        autoComplete: autoComplete,
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).PhoneNumberField, className),
        hasError: hasError,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        onInput: onInput,
        ref: ref,
        size: size,
        type: "tel",
        variation: variation,
        ...rest
    });
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/phonenumberfield)
 */ const $5c73e591be7ed5dc$export$522a16be7a55e553 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($5c73e591be7ed5dc$var$PhoneNumberFieldPrimitive);
$5c73e591be7ed5dc$export$522a16be7a55e553.displayName = "PhoneNumberField";






var $1T1QG = parcelRequire("1T1QG");



const $15abe18f35c7a730$export$db10347ccaf03b65 = ({ errors: errors, id: id, dataAttr: dataAttr })=>{
    if (!(errors?.length > 0)) return null;
    const dataAttrProp = dataAttr ? {
        [dataAttr]: true
    } : {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        ...dataAttrProp,
        id: id
    }, errors.map((error)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $c7c0980bb0c6b26c$export$5f1af8db9871e1d6), {
            key: error,
            role: "alert",
            variation: "error"
        }, (0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)(error));
    }));
};


function $719cd21ba969a4bd$export$56e87bf42978147a({ autocomplete: autoComplete, dialCode: dialCode, name: name, type: type, ...props }) {
    const { validationErrors: validationErrors } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)(({ validationErrors: validationErrors })=>[
            validationErrors
        ]);
    const errors = $1T1QG.useMemo(()=>(0, $52c3d4b500c29b83$export$501239432719417d)(validationErrors[name]), [
        name,
        validationErrors
    ]);
    const hasError = errors?.length > 0;
    const errorId = (0, $73bd3b14086bef4c$export$5c0b1cf3fea224ac)();
    const ariaDescribedBy = hasError ? errorId : undefined;
    if (type === "tel") return $1T1QG.createElement($1T1QG.Fragment, null, $1T1QG.createElement((0, $5c73e591be7ed5dc$export$522a16be7a55e553), {
        ...props,
        name: name,
        defaultDialCode: dialCode,
        dialCodeName: "country_code",
        autoComplete: autoComplete,
        hasError: hasError,
        "aria-describedby": ariaDescribedBy
    }), $1T1QG.createElement((0, $15abe18f35c7a730$export$db10347ccaf03b65), {
        dataAttr: "data-amplify-sign-up-errors",
        errors: errors,
        id: errorId
    }));
    else if (type === "password") return $1T1QG.createElement($1T1QG.Fragment, null, $1T1QG.createElement((0, $73c9b9cfa5620843$export$65ed9482db2257fa), {
        ...props,
        name: name,
        autoComplete: autoComplete,
        hasError: hasError,
        "aria-describedby": ariaDescribedBy
    }), $1T1QG.createElement((0, $15abe18f35c7a730$export$db10347ccaf03b65), {
        dataAttr: "data-amplify-sign-up-errors",
        errors: errors,
        id: errorId
    }));
    else return $1T1QG.createElement($1T1QG.Fragment, null, $1T1QG.createElement((0, $3d84ddb602bfccc3$export$2c73285ae9390cec), {
        ...props,
        name: name,
        autoComplete: autoComplete,
        hasError: hasError,
        type: type,
        "aria-describedby": ariaDescribedBy
    }), $1T1QG.createElement((0, $15abe18f35c7a730$export$db10347ccaf03b65), {
        dataAttr: "data-amplify-sign-up-errors",
        errors: errors,
        id: errorId
    }));
}



function $6ad97cae0c983db3$export$125d0b248abd3e88() {
    const { fields: fields } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)(({ route: route })=>[
            route
        ]);
    const formFields = $1T1QG.useRef(fields.map((field, index)=>$1T1QG.createElement((0, $719cd21ba969a4bd$export$56e87bf42978147a), {
            // use index for key, field order is static
            key: index,
            ...field
        }))).current;
    return $1T1QG.createElement($1T1QG.Fragment, null, formFields);
}



var $1T1QG = parcelRequire("1T1QG");



// TODO replace usage of this util with the `isSignInOrSignUpRoute` util in v3.
// Currently `hasTabs` always returns `undefined` as the right condition always
// resolves to truthy. This prevents the "data-amplify-router-content" attribute
// from being applied below. Fixing it will cause consumer snapshot tests to break,
// so wait to update.
const $93c5572e64ae5637$var$hasTabs = (route)=>{
    return route === "signIn" || "signUp";
};
function $93c5572e64ae5637$export$253df7dc30f737bc({ children: children, className: className, variation: variation = "default" }) {
    const { route: route } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)(({ route: route })=>[
            route
        ]);
    const { // @ts-ignore
    components: { Header: Header, Footer: Footer } } = (0, $568dae17aa196294$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        className: className,
        "data-amplify-authenticator": "",
        "data-variation": variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        "data-amplify-container": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        "data-amplify-router": "",
        "data-amplify-router-content": $93c5572e64ae5637$var$hasTabs(route) ? undefined : ""
    }, children), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Footer, null)));
}


const { getDeliveryMessageText: $8e57433bacddc877$var$getDeliveryMessageText, getDeliveryMethodText: $8e57433bacddc877$var$getDeliveryMethodText, getConfirmingText: $8e57433bacddc877$var$getConfirmingText, getConfirmText: $8e57433bacddc877$var$getConfirmText, getResendCodeText: $8e57433bacddc877$var$getResendCodeText } = (0, $24044d7e72f9876b$export$34e9c32aebe14fbb);
function $8e57433bacddc877$export$649c708157e61c64({ className: className, variation: variation }) {
    const { isPending: isPending, resendCode: resendCode, codeDeliveryDetails: codeDeliveryDetails } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)((context)=>[
            context.isPending,
            context.resendCode,
            context.codeDeliveryDetails
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $16a5ca7cf5bd8228$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ConfirmSignUp: { Header: Header = $8e57433bacddc877$export$649c708157e61c64.Header, Footer: Footer = $8e57433bacddc877$export$649c708157e61c64.Footer } } } = (0, $568dae17aa196294$export$b0e9d19f717d0a5c)();
    return(// TODO Automatically add these namespaces again from `useAmplify`
    (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $93c5572e64ae5637$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmsignup": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $c7c0980bb0c6b26c$export$5f1af8db9871e1d6), {
        className: "amplify-authenticator__subtitle"
    }, $8e57433bacddc877$var$getDeliveryMessageText(codeDeliveryDetails)), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $6ad97cae0c983db3$export$125d0b248abd3e88), null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $7c0fbecde5c7131e$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $5f03125e4b28b868$export$353f5b6fc5456de1), {
        variation: "primary",
        isDisabled: isPending,
        type: "submit",
        loadingText: $8e57433bacddc877$var$getConfirmingText(),
        isLoading: isPending,
        fontWeight: "normal"
    }, $8e57433bacddc877$var$getConfirmText()), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $5f03125e4b28b868$export$353f5b6fc5456de1), {
        onClick: resendCode,
        type: "button",
        fontWeight: "normal"
    }, $8e57433bacddc877$var$getResendCodeText())), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Footer, null)))));
}
const $8e57433bacddc877$var$DefaultHeader = ()=>{
    const { codeDeliveryDetails: codeDeliveryDetails } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)((context)=>[
            context.codeDeliveryDetails
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $bbc3d6a725e07173$export$a8a3e93435678ff9), {
        level: 4
    }, $8e57433bacddc877$var$getDeliveryMethodText(codeDeliveryDetails));
};
$8e57433bacddc877$export$649c708157e61c64.Header = $8e57433bacddc877$var$DefaultHeader;
$8e57433bacddc877$export$649c708157e61c64.Footer = function Footer() {
    // @ts-ignore
    return null;
};



var $1T1QG = parcelRequire("1T1QG");










const { getChangePasswordText: $11ebedca26c7a168$var$getChangePasswordText, getChangingText: $11ebedca26c7a168$var$getChangingText, getBackToSignInText: $11ebedca26c7a168$var$getBackToSignInText } = (0, $24044d7e72f9876b$export$34e9c32aebe14fbb);
const $11ebedca26c7a168$export$b3aae0a112274a60 = ({ className: className, variation: variation })=>{
    const { isPending: isPending, toSignIn: toSignIn } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)((context)=>[
            context.isPending,
            context.toSignIn
        ]);
    const { handleBlur: handleBlur, handleChange: handleChange, handleSubmit: handleSubmit } = (0, $16a5ca7cf5bd8228$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ForceNewPassword: { FormFields: FormFields = $11ebedca26c7a168$export$b3aae0a112274a60.FormFields, Header: Header = $11ebedca26c7a168$export$b3aae0a112274a60.Header, Footer: Footer = $11ebedca26c7a168$export$b3aae0a112274a60.Footer } } } = (0, $568dae17aa196294$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $93c5572e64ae5637$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-forcenewpassword": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit,
        onBlur: handleBlur
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(FormFields, null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $7c0fbecde5c7131e$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $5f03125e4b28b868$export$353f5b6fc5456de1), {
        isDisabled: isPending,
        type: "submit",
        variation: "primary",
        isLoading: isPending,
        loadingText: $11ebedca26c7a168$var$getChangingText(),
        fontWeight: "normal"
    }, $11ebedca26c7a168$var$getChangePasswordText()), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $5f03125e4b28b868$export$353f5b6fc5456de1), {
        onClick: toSignIn,
        type: "button",
        fontWeight: "normal",
        variation: "link",
        size: "small"
    }, $11ebedca26c7a168$var$getBackToSignInText()), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Footer, null))));
};
$11ebedca26c7a168$export$b3aae0a112274a60.FormFields = function FormFields$1() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $6ad97cae0c983db3$export$125d0b248abd3e88), null);
};
$11ebedca26c7a168$export$b3aae0a112274a60.Header = function Header() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $bbc3d6a725e07173$export$a8a3e93435678ff9), {
        level: 4
    }, $11ebedca26c7a168$var$getChangePasswordText());
};
$11ebedca26c7a168$export$b3aae0a112274a60.Footer = function Footer() {
    return null;
};


var $8f1389dc04974748$exports = {};

$parcel$export($8f1389dc04974748$exports, "create", function () { return $8f1389dc04974748$export$185802fd694ee1f5; }, function (v) { return $8f1389dc04974748$export$185802fd694ee1f5 = v; });
$parcel$export($8f1389dc04974748$exports, "toCanvas", function () { return $8f1389dc04974748$export$f87f6982d1fd4f81; }, function (v) { return $8f1389dc04974748$export$f87f6982d1fd4f81 = v; });
$parcel$export($8f1389dc04974748$exports, "toDataURL", function () { return $8f1389dc04974748$export$723e4939e5a27c8; }, function (v) { return $8f1389dc04974748$export$723e4939e5a27c8 = v; });
$parcel$export($8f1389dc04974748$exports, "toString", function () { return $8f1389dc04974748$export$f84e8e69fd4488a5; }, function (v) { return $8f1389dc04974748$export$f84e8e69fd4488a5 = v; });
var $8f1389dc04974748$export$185802fd694ee1f5;
var $8f1389dc04974748$export$f87f6982d1fd4f81;
var $8f1389dc04974748$export$723e4939e5a27c8;
// only svg for now.
var $8f1389dc04974748$export$f84e8e69fd4488a5;
var $51c4ef165ae6f9a5$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$51c4ef165ae6f9a5$exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $d8a3c8722ed0e0d6$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $02eac0649904446e$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $02eac0649904446e$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $02eac0649904446e$export$ed1d66da50968976;
var $02eac0649904446e$export$6733b14783f975c2;
var $02eac0649904446e$export$ce5b1274f8597fa0;
var $02eac0649904446e$export$43dd553ecded716d;
let $02eac0649904446e$var$toSJISFunction;
const $02eac0649904446e$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$02eac0649904446e$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$02eac0649904446e$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $02eac0649904446e$var$CODEWORDS_COUNT[version];
};
$02eac0649904446e$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$02eac0649904446e$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $02eac0649904446e$var$toSJISFunction = f;
};
$02eac0649904446e$export$ce5b1274f8597fa0 = function() {
    return typeof $02eac0649904446e$var$toSJISFunction !== "undefined";
};
$02eac0649904446e$export$43dd553ecded716d = function toSJIS(kanji) {
    return $02eac0649904446e$var$toSJISFunction(kanji);
};


var $e4edf3f5410b4df3$export$61196ced6d74a310;
var $e4edf3f5410b4df3$export$3a1a48c8f6ef640e;
var $e4edf3f5410b4df3$export$3722cfe417b6ed86;
var $e4edf3f5410b4df3$export$7f8ddf7c7c20b3cd;
var $e4edf3f5410b4df3$export$1ea939691cdc45b8;
var $e4edf3f5410b4df3$export$6788812c4e6611e6;
$e4edf3f5410b4df3$export$61196ced6d74a310 = {
    bit: 1
};
$e4edf3f5410b4df3$export$3a1a48c8f6ef640e = {
    bit: 0
};
$e4edf3f5410b4df3$export$3722cfe417b6ed86 = {
    bit: 3
};
$e4edf3f5410b4df3$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $e4edf3f5410b4df3$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $e4edf3f5410b4df3$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $e4edf3f5410b4df3$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $e4edf3f5410b4df3$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $e4edf3f5410b4df3$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$e4edf3f5410b4df3$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$e4edf3f5410b4df3$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($e4edf3f5410b4df3$export$1ea939691cdc45b8(value)) return value;
    try {
        return $e4edf3f5410b4df3$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $b382da75802d16e5$exports = {};
function $b382da75802d16e5$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$b382da75802d16e5$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$b382da75802d16e5$exports = $b382da75802d16e5$var$BitBuffer;


var $85f3a944e32c4280$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $85f3a944e32c4280$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $85f3a944e32c4280$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $85f3a944e32c4280$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $85f3a944e32c4280$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $85f3a944e32c4280$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$85f3a944e32c4280$exports = $85f3a944e32c4280$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $163652fc1d34d1f4$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $163652fc1d34d1f4$export$c39457c570f2b189;

var $163652fc1d34d1f4$require$getSymbolSize = $02eac0649904446e$export$8d4a06d3facd414b;
$163652fc1d34d1f4$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $163652fc1d34d1f4$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$163652fc1d34d1f4$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $163652fc1d34d1f4$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $f480731417353cfd$export$c39457c570f2b189;

var $f480731417353cfd$require$getSymbolSize = $02eac0649904446e$export$8d4a06d3facd414b;
const $f480731417353cfd$var$FINDER_PATTERN_SIZE = 7;
$f480731417353cfd$export$c39457c570f2b189 = function getPositions(version) {
    const size = $f480731417353cfd$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $f480731417353cfd$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $f480731417353cfd$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $4cb3cc582d4d0708$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $4cb3cc582d4d0708$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $4cb3cc582d4d0708$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $4cb3cc582d4d0708$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $4cb3cc582d4d0708$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $4cb3cc582d4d0708$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $4cb3cc582d4d0708$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $4cb3cc582d4d0708$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $4cb3cc582d4d0708$export$fe9625aaceb0e563;
$4cb3cc582d4d0708$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $4cb3cc582d4d0708$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$4cb3cc582d4d0708$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$4cb3cc582d4d0708$export$6788812c4e6611e6 = function from(value) {
    return $4cb3cc582d4d0708$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$4cb3cc582d4d0708$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $4cb3cc582d4d0708$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $4cb3cc582d4d0708$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $4cb3cc582d4d0708$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $4cb3cc582d4d0708$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$4cb3cc582d4d0708$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $4cb3cc582d4d0708$var$PenaltyScores.N2;
};
$4cb3cc582d4d0708$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $4cb3cc582d4d0708$var$PenaltyScores.N3;
};
$4cb3cc582d4d0708$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $4cb3cc582d4d0708$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $4cb3cc582d4d0708$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $4cb3cc582d4d0708$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $4cb3cc582d4d0708$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $4cb3cc582d4d0708$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $4cb3cc582d4d0708$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $4cb3cc582d4d0708$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $4cb3cc582d4d0708$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $4cb3cc582d4d0708$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $4cb3cc582d4d0708$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$4cb3cc582d4d0708$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $4cb3cc582d4d0708$var$getMaskAt(pattern, row, col));
    }
};
$4cb3cc582d4d0708$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($4cb3cc582d4d0708$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $4cb3cc582d4d0708$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $4cb3cc582d4d0708$export$a5fd3a02c14d0b3e(data) + $4cb3cc582d4d0708$export$9a9385107a518e46(data) + $4cb3cc582d4d0708$export$ade754353f0dc75e(data) + $4cb3cc582d4d0708$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $4cb3cc582d4d0708$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $958b1742823b7df1$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $958b1742823b7df1$export$683d1b3e8a1a8438;

const $958b1742823b7df1$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $958b1742823b7df1$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$958b1742823b7df1$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $e4edf3f5410b4df3$export$61196ced6d74a310:
            return $958b1742823b7df1$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $e4edf3f5410b4df3$export$3a1a48c8f6ef640e:
            return $958b1742823b7df1$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $e4edf3f5410b4df3$export$3722cfe417b6ed86:
            return $958b1742823b7df1$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $e4edf3f5410b4df3$export$7f8ddf7c7c20b3cd:
            return $958b1742823b7df1$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$958b1742823b7df1$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $e4edf3f5410b4df3$export$61196ced6d74a310:
            return $958b1742823b7df1$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $e4edf3f5410b4df3$export$3a1a48c8f6ef640e:
            return $958b1742823b7df1$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $e4edf3f5410b4df3$export$3722cfe417b6ed86:
            return $958b1742823b7df1$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $e4edf3f5410b4df3$export$7f8ddf7c7c20b3cd:
            return $958b1742823b7df1$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $581427cfd277a216$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $c8a45e2ac995a5d8$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $c8a45e2ac995a5d8$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $c8a45e2ac995a5d8$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $c9b1a8c610c54e1b$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $c9b1a8c610c54e1b$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $c9b1a8c610c54e1b$export$6e3a27864ab166fe;
const $c9b1a8c610c54e1b$var$EXP_TABLE = new Uint8Array(512);
const $c9b1a8c610c54e1b$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $c9b1a8c610c54e1b$var$EXP_TABLE[i] = x;
        $c9b1a8c610c54e1b$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$c9b1a8c610c54e1b$var$EXP_TABLE[i] = $c9b1a8c610c54e1b$var$EXP_TABLE[i - 255];
})();
$c9b1a8c610c54e1b$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $c9b1a8c610c54e1b$var$LOG_TABLE[n];
};
$c9b1a8c610c54e1b$export$b310ec824aaee37f = function exp(n) {
    return $c9b1a8c610c54e1b$var$EXP_TABLE[n];
};
$c9b1a8c610c54e1b$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $c9b1a8c610c54e1b$var$EXP_TABLE[$c9b1a8c610c54e1b$var$LOG_TABLE[x] + $c9b1a8c610c54e1b$var$LOG_TABLE[y]];
};


$c8a45e2ac995a5d8$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $c9b1a8c610c54e1b$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$c8a45e2ac995a5d8$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $c9b1a8c610c54e1b$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$c8a45e2ac995a5d8$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $c8a45e2ac995a5d8$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $c9b1a8c610c54e1b$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $581427cfd277a216$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $581427cfd277a216$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $c8a45e2ac995a5d8$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $581427cfd277a216$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $c8a45e2ac995a5d8$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$581427cfd277a216$exports = $581427cfd277a216$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $e8e8afda159d0045$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $e8e8afda159d0045$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $e8e8afda159d0045$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $e8e8afda159d0045$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $4f5ff8a667983b4b$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $4f5ff8a667983b4b$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $4f5ff8a667983b4b$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $4f5ff8a667983b4b$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $4f5ff8a667983b4b$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $4f5ff8a667983b4b$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $4f5ff8a667983b4b$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $4f5ff8a667983b4b$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $4f5ff8a667983b4b$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $4f5ff8a667983b4b$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $9869fa66501c5cdb$export$1ea939691cdc45b8;
$9869fa66501c5cdb$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $2589326dad9daece$export$a4d452c2363c8e12;
var $2589326dad9daece$export$9df7c29d562bab83;
var $2589326dad9daece$export$8f4bf8f7eb581284;
var $2589326dad9daece$export$4d318981b5a83836;
var $2589326dad9daece$export$376a9ed239d6c1c8;
var $2589326dad9daece$export$175f16aef75a4569;
var $2589326dad9daece$export$50b7f9bf92c74274;
var $2589326dad9daece$export$4ba5f52893b4ac97;
const $2589326dad9daece$var$numeric = "[0-9]+";
const $2589326dad9daece$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $2589326dad9daece$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$2589326dad9daece$var$kanji = $2589326dad9daece$var$kanji.replace(/u/g, "\\u");
const $2589326dad9daece$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $2589326dad9daece$var$kanji + ")(?:.|[\r\n]))+";
$2589326dad9daece$export$a4d452c2363c8e12 = new RegExp($2589326dad9daece$var$kanji, "g");
$2589326dad9daece$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$2589326dad9daece$export$8f4bf8f7eb581284 = new RegExp($2589326dad9daece$var$byte, "g");
$2589326dad9daece$export$4d318981b5a83836 = new RegExp($2589326dad9daece$var$numeric, "g");
$2589326dad9daece$export$376a9ed239d6c1c8 = new RegExp($2589326dad9daece$var$alphanumeric, "g");
const $2589326dad9daece$var$TEST_KANJI = new RegExp("^" + $2589326dad9daece$var$kanji + "$");
const $2589326dad9daece$var$TEST_NUMERIC = new RegExp("^" + $2589326dad9daece$var$numeric + "$");
const $2589326dad9daece$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$2589326dad9daece$export$175f16aef75a4569 = function testKanji(str) {
    return $2589326dad9daece$var$TEST_KANJI.test(str);
};
$2589326dad9daece$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $2589326dad9daece$var$TEST_NUMERIC.test(str);
};
$2589326dad9daece$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $2589326dad9daece$var$TEST_ALPHANUMERIC.test(str);
};


$4f5ff8a667983b4b$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$4f5ff8a667983b4b$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$4f5ff8a667983b4b$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$4f5ff8a667983b4b$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$4f5ff8a667983b4b$export$bb410559a65d3418 = {
    bit: -1
};
$4f5ff8a667983b4b$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$9869fa66501c5cdb$export$1ea939691cdc45b8(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$4f5ff8a667983b4b$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($2589326dad9daece$export$50b7f9bf92c74274(dataStr)) return $4f5ff8a667983b4b$export$4d318981b5a83836;
    else if ($2589326dad9daece$export$4ba5f52893b4ac97(dataStr)) return $4f5ff8a667983b4b$export$376a9ed239d6c1c8;
    else if ($2589326dad9daece$export$175f16aef75a4569(dataStr)) return $4f5ff8a667983b4b$export$a4d452c2363c8e12;
    else return $4f5ff8a667983b4b$export$8f4bf8f7eb581284;
};
$4f5ff8a667983b4b$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$4f5ff8a667983b4b$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $4f5ff8a667983b4b$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $4f5ff8a667983b4b$export$4d318981b5a83836;
        case "alphanumeric":
            return $4f5ff8a667983b4b$export$376a9ed239d6c1c8;
        case "kanji":
            return $4f5ff8a667983b4b$export$a4d452c2363c8e12;
        case "byte":
            return $4f5ff8a667983b4b$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$4f5ff8a667983b4b$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($4f5ff8a667983b4b$export$1ea939691cdc45b8(value)) return value;
    try {
        return $4f5ff8a667983b4b$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $e8e8afda159d0045$var$G18 = 7973;
const $e8e8afda159d0045$var$G18_BCH = $02eac0649904446e$export$ed1d66da50968976($e8e8afda159d0045$var$G18);
function $e8e8afda159d0045$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $e8e8afda159d0045$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $e8e8afda159d0045$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $4f5ff8a667983b4b$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $e8e8afda159d0045$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $e8e8afda159d0045$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $e8e8afda159d0045$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $e8e8afda159d0045$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $e8e8afda159d0045$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $4f5ff8a667983b4b$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$e8e8afda159d0045$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($9869fa66501c5cdb$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$e8e8afda159d0045$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$9869fa66501c5cdb$export$1ea939691cdc45b8(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $4f5ff8a667983b4b$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $02eac0649904446e$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $958b1742823b7df1$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $4f5ff8a667983b4b$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $e8e8afda159d0045$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $4f5ff8a667983b4b$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $4f5ff8a667983b4b$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $4f5ff8a667983b4b$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $4f5ff8a667983b4b$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$e8e8afda159d0045$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $e4edf3f5410b4df3$export$6788812c4e6611e6(errorCorrectionLevel, $e4edf3f5410b4df3$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $e8e8afda159d0045$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $e8e8afda159d0045$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$e8e8afda159d0045$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$9869fa66501c5cdb$export$1ea939691cdc45b8(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($02eac0649904446e$export$ed1d66da50968976(d) - $e8e8afda159d0045$var$G18_BCH >= 0)d ^= $e8e8afda159d0045$var$G18 << $02eac0649904446e$export$ed1d66da50968976(d) - $e8e8afda159d0045$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $372e60fb82075745$export$eee5438974ef6f0e;

const $372e60fb82075745$var$G15 = 1335;
const $372e60fb82075745$var$G15_MASK = 21522;
const $372e60fb82075745$var$G15_BCH = $02eac0649904446e$export$ed1d66da50968976($372e60fb82075745$var$G15);
$372e60fb82075745$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($02eac0649904446e$export$ed1d66da50968976(d) - $372e60fb82075745$var$G15_BCH >= 0)d ^= $372e60fb82075745$var$G15 << $02eac0649904446e$export$ed1d66da50968976(d) - $372e60fb82075745$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $372e60fb82075745$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $0c228307588f215a$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $0c228307588f215a$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $0c228307588f215a$export$89ab1afb9839589b;

var $9209b42d07fa8eea$exports = {};

function $9209b42d07fa8eea$var$NumericData(data) {
    this.mode = $4f5ff8a667983b4b$export$4d318981b5a83836;
    this.data = data.toString();
}
$9209b42d07fa8eea$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$9209b42d07fa8eea$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$9209b42d07fa8eea$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $9209b42d07fa8eea$var$NumericData.getBitsLength(this.data.length);
};
$9209b42d07fa8eea$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$9209b42d07fa8eea$exports = $9209b42d07fa8eea$var$NumericData;


var $9f385ce55e9c6722$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $9f385ce55e9c6722$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $9f385ce55e9c6722$var$AlphanumericData(data) {
    this.mode = $4f5ff8a667983b4b$export$376a9ed239d6c1c8;
    this.data = data;
}
$9f385ce55e9c6722$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$9f385ce55e9c6722$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$9f385ce55e9c6722$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $9f385ce55e9c6722$var$AlphanumericData.getBitsLength(this.data.length);
};
$9f385ce55e9c6722$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $9f385ce55e9c6722$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $9f385ce55e9c6722$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($9f385ce55e9c6722$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$9f385ce55e9c6722$exports = $9f385ce55e9c6722$var$AlphanumericData;


var $cf01319bbb55b243$exports = {};
var $a0784623b63dbcdb$exports = {};
"use strict";
$a0784623b63dbcdb$exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};



function $cf01319bbb55b243$var$ByteData(data) {
    this.mode = $4f5ff8a667983b4b$export$8f4bf8f7eb581284;
    this.data = new Uint8Array($a0784623b63dbcdb$exports(data));
}
$cf01319bbb55b243$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$cf01319bbb55b243$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$cf01319bbb55b243$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $cf01319bbb55b243$var$ByteData.getBitsLength(this.data.length);
};
$cf01319bbb55b243$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$cf01319bbb55b243$exports = $cf01319bbb55b243$var$ByteData;


var $cc3dd2027d5d7dc4$exports = {};


function $cc3dd2027d5d7dc4$var$KanjiData(data) {
    this.mode = $4f5ff8a667983b4b$export$a4d452c2363c8e12;
    this.data = data;
}
$cc3dd2027d5d7dc4$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$cc3dd2027d5d7dc4$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$cc3dd2027d5d7dc4$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $cc3dd2027d5d7dc4$var$KanjiData.getBitsLength(this.data.length);
};
$cc3dd2027d5d7dc4$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $02eac0649904446e$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$cc3dd2027d5d7dc4$exports = $cc3dd2027d5d7dc4$var$KanjiData;




var $4dcfc155473c19e5$exports = {};
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $4dcfc155473c19e5$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $4dcfc155473c19e5$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $4dcfc155473c19e5$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $4dcfc155473c19e5$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $4dcfc155473c19e5$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$4dcfc155473c19e5$exports = $4dcfc155473c19e5$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $0c228307588f215a$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $0c228307588f215a$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $0c228307588f215a$var$getSegmentsFromString(dataStr) {
    const numSegs = $0c228307588f215a$var$getSegments($2589326dad9daece$export$4d318981b5a83836, $4f5ff8a667983b4b$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $0c228307588f215a$var$getSegments($2589326dad9daece$export$376a9ed239d6c1c8, $4f5ff8a667983b4b$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($02eac0649904446e$export$ce5b1274f8597fa0()) {
        byteSegs = $0c228307588f215a$var$getSegments($2589326dad9daece$export$8f4bf8f7eb581284, $4f5ff8a667983b4b$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $0c228307588f215a$var$getSegments($2589326dad9daece$export$a4d452c2363c8e12, $4f5ff8a667983b4b$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $0c228307588f215a$var$getSegments($2589326dad9daece$export$9df7c29d562bab83, $4f5ff8a667983b4b$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $0c228307588f215a$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $4f5ff8a667983b4b$export$4d318981b5a83836:
            return $9209b42d07fa8eea$exports.getBitsLength(length);
        case $4f5ff8a667983b4b$export$376a9ed239d6c1c8:
            return $9f385ce55e9c6722$exports.getBitsLength(length);
        case $4f5ff8a667983b4b$export$a4d452c2363c8e12:
            return $cc3dd2027d5d7dc4$exports.getBitsLength(length);
        case $4f5ff8a667983b4b$export$8f4bf8f7eb581284:
            return $cf01319bbb55b243$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $0c228307588f215a$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $0c228307588f215a$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $4f5ff8a667983b4b$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $4f5ff8a667983b4b$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $4f5ff8a667983b4b$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $4f5ff8a667983b4b$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $4f5ff8a667983b4b$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $4f5ff8a667983b4b$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $4f5ff8a667983b4b$export$8f4bf8f7eb581284,
                        length: $0c228307588f215a$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $4f5ff8a667983b4b$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $4f5ff8a667983b4b$export$8f4bf8f7eb581284,
                        length: $0c228307588f215a$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $0c228307588f215a$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $0c228307588f215a$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $0c228307588f215a$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $0c228307588f215a$var$getSegmentBitsLength(node.length, node.mode) + 4 + $4f5ff8a667983b4b$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $0c228307588f215a$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $4f5ff8a667983b4b$export$1bd4c93ffb42e55e(data);
    mode = $4f5ff8a667983b4b$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $4f5ff8a667983b4b$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $4f5ff8a667983b4b$export$f84e8e69fd4488a5(mode) + ".\n Suggested mode is: " + $4f5ff8a667983b4b$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $4f5ff8a667983b4b$export$a4d452c2363c8e12 && !$02eac0649904446e$export$ce5b1274f8597fa0()) mode = $4f5ff8a667983b4b$export$8f4bf8f7eb581284;
    switch(mode){
        case $4f5ff8a667983b4b$export$4d318981b5a83836:
            return new $9209b42d07fa8eea$exports(data);
        case $4f5ff8a667983b4b$export$376a9ed239d6c1c8:
            return new $9f385ce55e9c6722$exports(data);
        case $4f5ff8a667983b4b$export$a4d452c2363c8e12:
            return new $cc3dd2027d5d7dc4$exports(data);
        case $4f5ff8a667983b4b$export$8f4bf8f7eb581284:
            return new $cf01319bbb55b243$exports(data);
    }
}
$0c228307588f215a$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($0c228307588f215a$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($0c228307588f215a$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$0c228307588f215a$export$3004f64547af360e = function fromString(data, version) {
    const segs = $0c228307588f215a$var$getSegmentsFromString(data, $02eac0649904446e$export$ce5b1274f8597fa0());
    const nodes = $0c228307588f215a$var$buildNodes(segs);
    const graph = $0c228307588f215a$var$buildGraph(nodes, version);
    const path = $4dcfc155473c19e5$exports.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $0c228307588f215a$export$571d59b505e6bb4e($0c228307588f215a$var$mergeSegments(optimizedSegs));
};
$0c228307588f215a$export$89ab1afb9839589b = function rawSplit(data) {
    return $0c228307588f215a$export$571d59b505e6bb4e($0c228307588f215a$var$getSegmentsFromString(data, $02eac0649904446e$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $d8a3c8722ed0e0d6$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $f480731417353cfd$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $d8a3c8722ed0e0d6$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $d8a3c8722ed0e0d6$var$setupAlignmentPattern(matrix, version) {
    const pos = $163652fc1d34d1f4$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $d8a3c8722ed0e0d6$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $e8e8afda159d0045$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $d8a3c8722ed0e0d6$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $372e60fb82075745$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $d8a3c8722ed0e0d6$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $d8a3c8722ed0e0d6$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $b382da75802d16e5$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $4f5ff8a667983b4b$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $02eac0649904446e$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $958b1742823b7df1$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $d8a3c8722ed0e0d6$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $d8a3c8722ed0e0d6$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $02eac0649904446e$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $958b1742823b7df1$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $958b1742823b7df1$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $581427cfd277a216$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $d8a3c8722ed0e0d6$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $0c228307588f215a$export$571d59b505e6bb4e(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $0c228307588f215a$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $e8e8afda159d0045$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $0c228307588f215a$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $e8e8afda159d0045$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $d8a3c8722ed0e0d6$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $02eac0649904446e$export$8d4a06d3facd414b(version);
    const modules = new $85f3a944e32c4280$exports(moduleCount);
    // Add function modules
    $d8a3c8722ed0e0d6$var$setupFinderPattern(modules, version);
    $d8a3c8722ed0e0d6$var$setupTimingPattern(modules);
    $d8a3c8722ed0e0d6$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $d8a3c8722ed0e0d6$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $d8a3c8722ed0e0d6$var$setupVersionInfo(modules, version);
    // Add data codewords
    $d8a3c8722ed0e0d6$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $4cb3cc582d4d0708$export$fe9625aaceb0e563(modules, $d8a3c8722ed0e0d6$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $4cb3cc582d4d0708$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $d8a3c8722ed0e0d6$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$d8a3c8722ed0e0d6$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $e4edf3f5410b4df3$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $e4edf3f5410b4df3$export$6788812c4e6611e6(options.errorCorrectionLevel, $e4edf3f5410b4df3$export$3a1a48c8f6ef640e);
        version = $e8e8afda159d0045$export$6788812c4e6611e6(options.version);
        mask = $4cb3cc582d4d0708$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $02eac0649904446e$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $d8a3c8722ed0e0d6$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $e65de7a2a2bc75fa$export$b3890eb0ae9dca99;
var $e65de7a2a2bc75fa$export$c3e5526bbaf70a25;
var $9c7545eabda0e401$export$d2312e68e1f5ad00;
var $9c7545eabda0e401$export$5cdac61cf538712e;
var $9c7545eabda0e401$export$c3a1a1f268a8142b;
var $9c7545eabda0e401$export$83136f57c739c5f3;
function $9c7545eabda0e401$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$9c7545eabda0e401$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $9c7545eabda0e401$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $9c7545eabda0e401$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$9c7545eabda0e401$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$9c7545eabda0e401$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $9c7545eabda0e401$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$9c7545eabda0e401$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $9c7545eabda0e401$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $e65de7a2a2bc75fa$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $e65de7a2a2bc75fa$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$e65de7a2a2bc75fa$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $e65de7a2a2bc75fa$var$getCanvasElement();
    opts = $9c7545eabda0e401$export$d2312e68e1f5ad00(opts);
    const size = $9c7545eabda0e401$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $9c7545eabda0e401$export$83136f57c739c5f3(image.data, qrData, opts);
    $e65de7a2a2bc75fa$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$e65de7a2a2bc75fa$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $e65de7a2a2bc75fa$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $1599caa5d58ca0e0$export$b3890eb0ae9dca99;

function $1599caa5d58ca0e0$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $1599caa5d58ca0e0$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $1599caa5d58ca0e0$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $1599caa5d58ca0e0$var$svgCmd("M", col + margin, 0.5 + row + margin) : $1599caa5d58ca0e0$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $1599caa5d58ca0e0$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$1599caa5d58ca0e0$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $9c7545eabda0e401$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $1599caa5d58ca0e0$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $1599caa5d58ca0e0$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $1599caa5d58ca0e0$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};


function $8f1389dc04974748$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$51c4ef165ae6f9a5$exports()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $d8a3c8722ed0e0d6$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $d8a3c8722ed0e0d6$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$8f1389dc04974748$export$185802fd694ee1f5 = $d8a3c8722ed0e0d6$export$185802fd694ee1f5;
$8f1389dc04974748$export$f87f6982d1fd4f81 = $8f1389dc04974748$var$renderCanvas.bind(null, $e65de7a2a2bc75fa$export$b3890eb0ae9dca99);
$8f1389dc04974748$export$723e4939e5a27c8 = $8f1389dc04974748$var$renderCanvas.bind(null, $e65de7a2a2bc75fa$export$c3e5526bbaf70a25);
$8f1389dc04974748$export$f84e8e69fd4488a5 = $8f1389dc04974748$var$renderCanvas.bind(null, function(data, _, opts) {
    return $1599caa5d58ca0e0$export$b3890eb0ae9dca99(data, opts);
});



var $1T1QG = parcelRequire("1T1QG");








var $1T1QG = parcelRequire("1T1QG");




const { getConfirmText: $4d5795a614ccd27b$var$getConfirmText, getConfirmingText: $4d5795a614ccd27b$var$getConfirmingText, getBackToSignInText: $4d5795a614ccd27b$var$getBackToSignInText } = (0, $24044d7e72f9876b$export$34e9c32aebe14fbb);
const $4d5795a614ccd27b$export$76e9c0cec6811ff4 = ()=>{
    const { isPending: isPending, toSignIn: toSignIn } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)((context)=>[
            context.isPending,
            context.toSignIn
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $5f03125e4b28b868$export$353f5b6fc5456de1), {
        isDisabled: isPending,
        type: "submit",
        variation: "primary",
        fontWeight: "normal",
        isLoading: isPending,
        loadingText: $4d5795a614ccd27b$var$getConfirmingText()
    }, $4d5795a614ccd27b$var$getConfirmText()), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $5f03125e4b28b868$export$353f5b6fc5456de1), {
        onClick: toSignIn,
        type: "button",
        variation: "link",
        fontWeight: "normal",
        size: "small"
    }, $4d5795a614ccd27b$var$getBackToSignInText()));
};





const $dd73613a299919a5$var$logger = new (0, $b5731988345712b1$export$ba6a9c7ac8291f7f)("SetupTotp-logger");
const { getSetupTotpText: $dd73613a299919a5$var$getSetupTotpText, getCopiedText: $dd73613a299919a5$var$getCopiedText, getLoadingText: $dd73613a299919a5$var$getLoadingText } = (0, $24044d7e72f9876b$export$34e9c32aebe14fbb);
const $dd73613a299919a5$export$1f819652bce2948d = ({ className: className, variation: variation })=>{
    const { totpSecretCode: totpSecretCode, isPending: isPending, username: username, QRFields: QRFields } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)((context)=>[
            context.isPending,
            context.totpSecretCode,
            context.username
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $16a5ca7cf5bd8228$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    SetupTotp: { Header: Header = $dd73613a299919a5$export$1f819652bce2948d.Header, Footer: Footer = $dd73613a299919a5$export$1f819652bce2948d.Footer } } } = (0, $568dae17aa196294$export$b0e9d19f717d0a5c)();
    const [isLoading, setIsLoading] = $1T1QG.useState(true);
    const [qrCode, setQrCode] = $1T1QG.useState();
    const [copyTextLabel, setCopyTextLabel] = $1T1QG.useState("COPY");
    const { totpIssuer: totpIssuer = "AWSCognito", totpUsername: totpUsername = username } = QRFields ?? {};
    const generateQRCode = $1T1QG.useCallback(async ()=>{
        try {
            const totpCode = (0, $3bd7d334512b2bcd$export$f1f323074be5cac0)(totpIssuer, totpUsername, totpSecretCode);
            const qrCodeImageSource = await (0, (/*@__PURE__*/$parcel$interopDefault($8f1389dc04974748$exports))).toDataURL(totpCode);
            setQrCode(qrCodeImageSource);
        } catch (error) {
            $dd73613a299919a5$var$logger.error(error);
        } finally{
            setIsLoading(false);
        }
    }, [
        totpIssuer,
        totpUsername,
        totpSecretCode
    ]);
    $1T1QG.useEffect(()=>{
        if (!qrCode) generateQRCode();
    }, [
        generateQRCode,
        qrCode
    ]);
    const copyText = ()=>{
        navigator.clipboard.writeText(totpSecretCode);
        setCopyTextLabel($dd73613a299919a5$var$getCopiedText());
    };
    return $1T1QG.createElement((0, $93c5572e64ae5637$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, $1T1QG.createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-setup-totp": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, $1T1QG.createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, $1T1QG.createElement(Header, null), $1T1QG.createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        direction: "column"
    }, isLoading ? $1T1QG.createElement("p", null, $dd73613a299919a5$var$getLoadingText(), "\u2026") : $1T1QG.createElement("img", {
        "data-amplify-qrcode": true,
        src: qrCode,
        alt: "qr code",
        width: "228",
        height: "228"
    }), $1T1QG.createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        "data-amplify-copy": true
    }, $1T1QG.createElement("div", null, totpSecretCode), $1T1QG.createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        "data-amplify-copy-svg": true,
        onClick: copyText
    }, $1T1QG.createElement("div", {
        "data-amplify-copy-tooltip": true
    }, copyTextLabel), $1T1QG.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, $1T1QG.createElement("path", {
        d: "M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM15 5H8C6.9 5 6.01 5.9 6.01 7L6 21C6 22.1 6.89 23 7.99 23H19C20.1 23 21 22.1 21 21V11L15 5ZM8 21V7H14V12H19V21H8Z"
    })))), $1T1QG.createElement((0, $6ad97cae0c983db3$export$125d0b248abd3e88), null), $1T1QG.createElement((0, $7c0fbecde5c7131e$export$3caa4b6a8cb6c61a), null)), $1T1QG.createElement((0, $4d5795a614ccd27b$export$76e9c0cec6811ff4), null), $1T1QG.createElement(Footer, null))));
};
$dd73613a299919a5$export$1f819652bce2948d.Header = function Header() {
    return $1T1QG.createElement((0, $bbc3d6a725e07173$export$a8a3e93435678ff9), {
        level: 3
    }, $dd73613a299919a5$var$getSetupTotpText());
};
$dd73613a299919a5$export$1f819652bce2948d.Footer = function Footer() {
    // @ts-ignore
    return null;
};








var $1T1QG = parcelRequire("1T1QG");



var $1T1QG = parcelRequire("1T1QG");


var $1T1QG = parcelRequire("1T1QG");




var $1T1QG = parcelRequire("1T1QG");
const $fe1b800014c5293b$export$cfa7aa87c26e7d1f = $1T1QG.createContext({
    activeTab: "",
    setActiveTab: ()=>{}
});


const $e745a56051c6c299$var$TabsItemPrimitive = ({ className: className, value: value, children: children, onClick: onClick, as: as = "button", role: role = "tab", ...rest }, ref)=>{
    const { activeTab: activeTab, setActiveTab: setActiveTab } = $1T1QG.useContext((0, $fe1b800014c5293b$export$cfa7aa87c26e7d1f));
    const isActive = activeTab === value;
    const handleOnClick = (e)=>{
        if ((0, $697901644f774aa4$export$669248cdfeac1c30)(onClick)) onClick?.(e);
        setActiveTab(value);
    };
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        ...rest,
        role: role,
        as: as,
        id: `${value}-tab`,
        "aria-selected": isActive,
        "aria-controls": `${value}-panel`,
        tabIndex: !isActive ? -1 : undefined,
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).TabsItem, (0, $697901644f774aa4$export$3c152e7b97c7496c)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).TabsItem, "active", activeTab === value), className),
        ref: ref,
        onClick: handleOnClick
    }, children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/tabs)
 */ const $e745a56051c6c299$export$6d702cd3660ac20b = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($e745a56051c6c299$var$TabsItemPrimitive);
$e745a56051c6c299$export$6d702cd3660ac20b.displayName = "Tabs.Item";



var $1T1QG = parcelRequire("1T1QG");




const $89795a5afef2923b$var$isValidTab = (child)=>$1T1QG.isValidElement(child);
const $89795a5afef2923b$var$TabListPrimitive = ({ className: className, children: children, indicatorPosition: indicatorPosition, spacing: spacing, role: role = "tablist", ...rest }, ref)=>{
    const internalRef = $1T1QG.useRef(null);
    const { activeTab: activeTab, setActiveTab: setActiveTab } = $1T1QG.useContext((0, $fe1b800014c5293b$export$cfa7aa87c26e7d1f));
    $1T1QG.useImperativeHandle(ref, ()=>internalRef.current);
    const values = $1T1QG.useMemo(()=>$1T1QG.Children.toArray(children).map((child)=>{
            if (child && $89795a5afef2923b$var$isValidTab(child)) return child.props.value;
        }).filter((child)=>!!child), [
        children
    ]);
    const currentIndex = values.indexOf(activeTab);
    const nextTab = $1T1QG.useCallback(()=>{
        let nextIndex = currentIndex === values.length - 1 ? 0 : currentIndex + 1;
        const elems = internalRef.current?.querySelectorAll("button") ?? [];
        while(elems[nextIndex].disabled)if (nextIndex === values.length - 1) nextIndex = 0;
        else nextIndex++;
        const value = values[nextIndex];
        if (value) {
            setActiveTab(value);
            const elem = elems[nextIndex];
            elem?.focus();
            elem?.click();
        }
    }, [
        currentIndex,
        setActiveTab,
        values
    ]);
    const prevTab = $1T1QG.useCallback(()=>{
        let prevIndex = currentIndex === 0 ? values.length - 1 : currentIndex - 1;
        const elems = internalRef.current?.querySelectorAll("button") ?? [];
        while(elems[prevIndex].disabled)if (prevIndex === 0) prevIndex = values.length - 1;
        else prevIndex--;
        const value = values[prevIndex];
        if (value) {
            setActiveTab(value);
            const elem = elems[prevIndex];
            elem?.focus();
            elem?.click();
        }
    }, [
        currentIndex,
        setActiveTab,
        values
    ]);
    const onKeyDown = $1T1QG.useCallback((event)=>{
        switch(event.key){
            case "ArrowLeft":
                event.preventDefault();
                event.stopPropagation();
                prevTab();
                break;
            case "ArrowUp":
            case "ArrowRight":
                event.preventDefault();
                event.stopPropagation();
                nextTab();
                break;
        }
    }, [
        prevTab,
        nextTab
    ]);
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        ...rest,
        role: role,
        onKeyDown: onKeyDown,
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).TabsList, indicatorPosition ? (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).TabsList, indicatorPosition) : null, spacing ? (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).TabsList, spacing) : null, className),
        ref: internalRef
    }, children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/tabs)
 */ const $89795a5afef2923b$export$e51a686c67fdaa2d = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($89795a5afef2923b$var$TabListPrimitive);
$89795a5afef2923b$export$e51a686c67fdaa2d.displayName = "Tabs.List";



var $1T1QG = parcelRequire("1T1QG");




const $fbfceabf14762ecd$var$TabPanelPrimitive = ({ className: className, value: value, children: children, role: role = "tabpanel", ...rest }, ref)=>{
    const { activeTab: activeTab, isLazy: isLazy } = $1T1QG.useContext((0, $fe1b800014c5293b$export$cfa7aa87c26e7d1f));
    if (isLazy && activeTab !== value) return null;
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        ...rest,
        role: role,
        id: `${value}-panel`,
        "aria-labelledby": `${value}-tab`,
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).TabsPanel, (0, $697901644f774aa4$export$3c152e7b97c7496c)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).TabsPanel, "active", activeTab === value), className),
        ref: ref
    }, children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/tabs)
 */ const $fbfceabf14762ecd$export$3d96ec278d3efce4 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($fbfceabf14762ecd$var$TabPanelPrimitive);
$fbfceabf14762ecd$export$3d96ec278d3efce4.displayName = "Tabs.Panel";



var $1T1QG = parcelRequire("1T1QG");




const $11fcf749b788f8b7$var$TabsContainerPrimitive = ({ children: children, defaultValue: defaultValue, className: className, value: controlledValue, onValueChange: onValueChange, isLazy: isLazy, ...rest }, ref)=>{
    const isControlled = controlledValue !== undefined;
    const [localValue, setLocalValue] = $1T1QG.useState(()=>isControlled ? controlledValue : defaultValue);
    const activeTab = isControlled ? controlledValue : localValue ?? "";
    const setActiveTab = $1T1QG.useCallback((newValue)=>{
        if ((0, $697901644f774aa4$export$f6e2535fb5126e54)(onValueChange)) onValueChange(newValue);
        if (!isControlled) setLocalValue(newValue);
    }, [
        onValueChange,
        isControlled
    ]);
    const _value = $1T1QG.useMemo(()=>{
        return {
            activeTab: activeTab,
            isLazy: isLazy,
            setActiveTab: setActiveTab
        };
    }, [
        activeTab,
        setActiveTab,
        isLazy
    ]);
    return $1T1QG.createElement((0, $fe1b800014c5293b$export$cfa7aa87c26e7d1f).Provider, {
        value: _value
    }, $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        ...rest,
        ref: ref,
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)(className, (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Tabs)
    }, children));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/tabs)
 */ const $11fcf749b788f8b7$export$2206531ad8592d57 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($11fcf749b788f8b7$var$TabsContainerPrimitive);
$11fcf749b788f8b7$export$2206531ad8592d57.displayName = "Tabs.Container";


const $b8d8a56f802b745c$var$TabsPrimitive = ({ items: items, indicatorPosition: indicatorPosition, justifyContent: justifyContent, spacing: spacing, ...rest }, ref)=>{
    return $1T1QG.createElement((0, $11fcf749b788f8b7$export$2206531ad8592d57), {
        ...rest,
        ref: ref
    }, $1T1QG.createElement((0, $89795a5afef2923b$export$e51a686c67fdaa2d), {
        indicatorPosition: indicatorPosition,
        justifyContent: justifyContent,
        spacing: spacing
    }, items?.map(({ value: value, label: label, content: content, ...rest })=>$1T1QG.createElement((0, $e745a56051c6c299$export$6d702cd3660ac20b), {
            ...rest,
            key: value,
            value: value
        }, label))), items?.map(({ value: value, content: content, isDisabled: isDisabled })=>$1T1QG.createElement((0, $fbfceabf14762ecd$export$3d96ec278d3efce4), {
            key: value,
            value: value,
            isDisabled: isDisabled
        }, content)));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/tabs)
 */ const $b8d8a56f802b745c$export$b2539bed5023c21c = Object.assign((0, $23e6fd8f9afedafa$export$44aa160b17c73194)($b8d8a56f802b745c$var$TabsPrimitive), {
    Item: (0, $e745a56051c6c299$export$6d702cd3660ac20b),
    List: (0, $89795a5afef2923b$export$e51a686c67fdaa2d),
    Panel: (0, $fbfceabf14762ecd$export$3d96ec278d3efce4),
    Container: (0, $11fcf749b788f8b7$export$2206531ad8592d57)
});
$b8d8a56f802b745c$export$b2539bed5023c21c.displayName = "Tabs";




var $1T1QG = parcelRequire("1T1QG");






var $1T1QG = parcelRequire("1T1QG");
/** Federated IDPs that Authenticator supports */ var $4209fcd44511473f$export$4d240f091c25e146;
(function(FederatedIdentityProviders) {
    FederatedIdentityProviders["Apple"] = "Apple";
    FederatedIdentityProviders["Amazon"] = "Amazon";
    FederatedIdentityProviders["Facebook"] = "Facebook";
    FederatedIdentityProviders["Google"] = "Google";
})($4209fcd44511473f$export$4d240f091c25e146 || ($4209fcd44511473f$export$4d240f091c25e146 = {}));
/**
 * Cognito user contact method types that have not been verified as valid
 */ var $4209fcd44511473f$export$5733d30e1ebcb3c0;
(function(UnverifiedContactMethodType) {
    UnverifiedContactMethodType["Email"] = "email";
    UnverifiedContactMethodType["PhoneNumber"] = "phone_number";
})($4209fcd44511473f$export$5733d30e1ebcb3c0 || ($4209fcd44511473f$export$5733d30e1ebcb3c0 = {}));




var $1T1QG = parcelRequire("1T1QG");


const $06dbc7d57177467b$var$DividerPrimitive = ({ className: className, orientation: orientation = "horizontal", size: size, label: label, ...rest }, ref)=>{
    const componentClasses = (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Divider, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Divider, orientation), (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Divider, size), className);
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        "aria-orientation": orientation,
        as: "hr",
        className: componentClasses,
        "data-label": label,
        ref: ref,
        ...rest
    });
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/divider)
 */ const $06dbc7d57177467b$export$2e0a83ec2e27ecbb = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($06dbc7d57177467b$var$DividerPrimitive);
$06dbc7d57177467b$export$2e0a83ec2e27ecbb.displayName = "Divider";





var $1T1QG = parcelRequire("1T1QG");



var $1T1QG = parcelRequire("1T1QG");



const $f768339143cfa65a$var$defaultViewBox = {
    minX: 0,
    minY: 0,
    width: 24,
    height: 24
};
const $f768339143cfa65a$var$IconPrimitive = ({ className: className, as: // as can be used to render other icon react components too
as = "svg", fill: fill = "currentColor", pathData: pathData, viewBox: viewBox = $f768339143cfa65a$var$defaultViewBox, children: children, paths: paths, ...rest }, ref)=>{
    const minX = viewBox.minX ? viewBox.minX : $f768339143cfa65a$var$defaultViewBox.minX;
    const minY = viewBox.minY ? viewBox.minY : $f768339143cfa65a$var$defaultViewBox.minY;
    const width = viewBox.width ? viewBox.width : $f768339143cfa65a$var$defaultViewBox.width;
    const height = viewBox.height ? viewBox.height : $f768339143cfa65a$var$defaultViewBox.height;
    // An icon can be drawn in 3 ways:
    // 1. Pass it children which should be valid SVG elements
    // 2. Pass an array of path-like objects to `paths` prop
    // 3. Supply `pathData` for a simple icons
    let _children;
    if (children) _children = children;
    if (paths) _children = paths.map((path, index)=>$1T1QG.createElement("path", {
            ...path,
            key: index
        }));
    if (pathData) _children = $1T1QG.createElement("path", {
        d: pathData,
        fill: fill
    });
    return $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        as: as,
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Icon, className),
        ref: ref,
        viewBox: `${minX} ${minY} ${width} ${height}`,
        ...rest
    }, _children);
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/icon)
 */ const $f768339143cfa65a$export$f04a61298a47a40f = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($f768339143cfa65a$var$IconPrimitive);
$f768339143cfa65a$export$f04a61298a47a40f.displayName = "Icon";






const $71df75bc2df67de9$var$AppleIcon = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("svg", {
        "aria-label": "Apple icon",
        className: "amplify-icon federated-sign-in-icon",
        fill: "#000",
        preserveAspectRatio: "xMidYMid",
        stroke: "#000",
        strokeWidth: "0",
        viewBox: "0 0 1024 1024",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("path", {
        d: "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z"
    }));
};
const $71df75bc2df67de9$var$GoogleIcon = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("svg", {
        "aria-label": "Google icon",
        className: "amplify-icon federated-sign-in-icon",
        viewBox: "0 0 256 262",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("path", {
        d: "M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027",
        fill: "#4285F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("path", {
        d: "M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1",
        fill: "#34A853"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("path", {
        d: "M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782",
        fill: "#FBBC05"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("path", {
        d: "M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251",
        fill: "#EB4335"
    }));
};
const $71df75bc2df67de9$var$FacebookIcon = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $f768339143cfa65a$export$f04a61298a47a40f), {
        className: "federated-sign-in-icon",
        ariaLabel: "Facebook icon",
        viewBox: {
            minX: 0,
            minY: 0,
            width: 279,
            height: 538
        },
        pathData: "M82.3409742,538 L82.3409742,292.936652 L0,292.936652 L0,196.990154 L82.2410458,196.990154 L82.2410458,126.4295 C82.2410458,44.575144 132.205229,0 205.252865,0 C240.227794,0 270.306232,2.59855099 279,3.79788222 L279,89.2502322 L228.536175,89.2502322 C188.964542,89.2502322 181.270057,108.139699 181.270057,135.824262 L181.270057,196.89021 L276.202006,196.89021 L263.810888,292.836708 L181.16913,292.836708 L181.16913,538 L82.3409742,538 Z",
        fill: "#1877F2"
    });
};
const $71df75bc2df67de9$var$AmazonIcon = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("svg", {
        "aria-label": "Amazon icon",
        className: "amplify-icon federated-sign-in-icon",
        viewBox: "0 0 243 264",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("path", {
        d: "M230.826 208.039C227.468 203.683 208.551 205.982 200.056 206.998C197.471 207.321 197.076 205.042 199.407 203.405C214.475 192.665 239.201 195.766 242.082 199.364C244.966 202.982 241.337 228.071 227.173 240.049C225.001 241.888 222.93 240.904 223.898 238.468C227.077 230.431 234.205 212.419 230.826 208.039ZM123.769 264C71.0234 264 39.0764 241.955 14.7853 217.542C9.97339 212.706 3.71799 206.296 0.311513 200.691C-1.09773 198.372 2.59096 195.022 5.04421 196.844C35.239 219.268 79.1012 239.538 122.53 239.538C151.82 239.538 188.046 227.47 217.669 214.868C222.147 212.966 222.147 219.18 221.512 221.061C221.183 222.032 206.515 236.221 186.247 247.047C167.304 257.166 143.397 264 123.769 264Z",
        fill: "#F2541B"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M142.943 111.185C142.943 124.756 143.268 136.054 136.406 148.123C130.856 157.913 122.027 163.95 112.222 163.95C98.8288 163.95 90.9806 153.772 90.9806 138.693C90.9806 109.036 117.677 103.647 142.943 103.647V111.185ZM178.166 196.081C175.858 198.15 171.635 198.22 169.914 196.894C157.974 187.684 149.89 173.688 149.89 173.688C130.706 193.156 117.127 199 92.2879 199C62.8772 199 40 180.905 40 144.729C40 116.461 55.3552 97.2408 77.2563 87.823C96.2094 79.5256 122.684 78.0173 142.943 75.7517C142.943 75.7517 144.633 53.933 138.699 45.9806C134.098 39.8163 126.272 36.9329 119.089 36.9329C106.127 36.8829 93.61 43.9051 91.1262 57.4188C90.4136 61.2829 87.5533 64.5261 84.54 64.206L51.0823 60.5922C48.5156 60.2951 45.0381 57.6639 45.8636 53.3081C53.644 12.3684 90.7373 0 123.989 0C140.983 0 163.21 4.51651 176.608 17.3349C193.597 33.1648 191.969 54.2755 191.969 77.2722V131.51C191.969 147.835 198.768 154.987 205.151 163.775C207.376 166.953 207.886 170.714 205.04 173.032C197.902 178.999 178.166 196.081 178.166 196.081Z",
        fill: "#F2541B"
    }));
};
const $71df75bc2df67de9$export$66f93ed48923765d = (props)=>{
    const { icon: icon, provider: provider, text: text } = props;
    const { toFederatedSignIn: toFederatedSignIn } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)();
    const handleClick = (event)=>{
        event.preventDefault();
        toFederatedSignIn({
            provider: provider
        });
    };
    let iconComponent;
    if (icon === "facebook") iconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement($71df75bc2df67de9$var$FacebookIcon, null);
    else if (icon === "google") iconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement($71df75bc2df67de9$var$GoogleIcon, null);
    else if (icon === "amazon") iconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement($71df75bc2df67de9$var$AmazonIcon, null);
    else if (icon === "apple") iconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement($71df75bc2df67de9$var$AppleIcon, null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $5f03125e4b28b868$export$353f5b6fc5456de1), {
        onClick: handleClick,
        className: "federated-sign-in-button",
        fontWeight: "normal",
        gap: "1rem"
    }, iconComponent, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $c7c0980bb0c6b26c$export$5f1af8db9871e1d6), {
        as: "span"
    }, text));
};


const { getSignInWithFederationText: $3ce92625c3c535a6$var$getSignInWithFederationText, getOrText: $3ce92625c3c535a6$var$getOrText } = (0, $24044d7e72f9876b$export$34e9c32aebe14fbb);
function $3ce92625c3c535a6$export$558443b7244c6aa() {
    const { route: route, socialProviders: socialProviders } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)(({ route: route, socialProviders: socialProviders })=>[
            route,
            socialProviders
        ]);
    if (socialProviders.length === 0) // @ts-ignore
    return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        direction: "column",
        padding: `0 0 1rem 0`,
        className: "federated-sign-in-container"
    }, socialProviders.map((provider)=>{
        switch(provider){
            case "amazon":
                return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $71df75bc2df67de9$export$66f93ed48923765d), {
                    icon: "amazon",
                    key: provider,
                    provider: (0, $4209fcd44511473f$export$4d240f091c25e146).Amazon,
                    text: $3ce92625c3c535a6$var$getSignInWithFederationText(route, provider)
                });
            case "apple":
                return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $71df75bc2df67de9$export$66f93ed48923765d), {
                    icon: "apple",
                    key: provider,
                    provider: (0, $4209fcd44511473f$export$4d240f091c25e146).Apple,
                    text: $3ce92625c3c535a6$var$getSignInWithFederationText(route, provider)
                });
            case "facebook":
                return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $71df75bc2df67de9$export$66f93ed48923765d), {
                    icon: "facebook",
                    key: provider,
                    provider: (0, $4209fcd44511473f$export$4d240f091c25e146).Facebook,
                    text: $3ce92625c3c535a6$var$getSignInWithFederationText(route, provider)
                });
            case "google":
                return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $71df75bc2df67de9$export$66f93ed48923765d), {
                    icon: "google",
                    key: provider,
                    provider: (0, $4209fcd44511473f$export$4d240f091c25e146).Google,
                    text: $3ce92625c3c535a6$var$getSignInWithFederationText(route, provider)
                });
            default:
                // eslint-disable-next-line no-console
                console.error(`Authenticator does not support ${provider}. Please open an issue: https://github.com/aws-amplify/amplify-ui/issues/choose`);
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $06dbc7d57177467b$export$2e0a83ec2e27ecbb), {
        size: "small",
        label: $3ce92625c3c535a6$var$getOrText()
    }));
}







const { getSignInText: $0832deb9b7cee4a6$var$getSignInText, getSigningInText: $0832deb9b7cee4a6$var$getSigningInText, getForgotPasswordText: $0832deb9b7cee4a6$var$getForgotPasswordText } = (0, $24044d7e72f9876b$export$34e9c32aebe14fbb);
function $0832deb9b7cee4a6$export$b64708c6f1b3ed96() {
    const { isPending: isPending } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)((context)=>[
            context.isPending
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $16a5ca7cf5bd8228$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    SignIn: { Header: Header = $0832deb9b7cee4a6$export$b64708c6f1b3ed96.Header, Footer: Footer = $0832deb9b7cee4a6$export$b64708c6f1b3ed96.Footer } } } = (0, $568dae17aa196294$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), null, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-signin": "",
        method: "post",
        onSubmit: handleSubmit,
        onChange: handleChange
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $3ce92625c3c535a6$export$558443b7244c6aa), null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $bb7aa8a63591024b$export$439d29a4e110a164), null, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("legend", null, $0832deb9b7cee4a6$var$getSignInText())), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $6ad97cae0c983db3$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $7c0fbecde5c7131e$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $5f03125e4b28b868$export$353f5b6fc5456de1), {
        isDisabled: isPending,
        isFullWidth: true,
        type: "submit",
        variation: "primary",
        isLoading: isPending,
        loadingText: $0832deb9b7cee4a6$var$getSigningInText()
    }, $0832deb9b7cee4a6$var$getSignInText()))), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Footer, null));
}
const $0832deb9b7cee4a6$var$DefaultFooter = ()=>{
    const { toForgotPassword: toForgotPassword } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)((context)=>[
            context.toForgotPassword
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        "data-amplify-footer": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $5f03125e4b28b868$export$353f5b6fc5456de1), {
        fontWeight: "normal",
        onClick: toForgotPassword,
        size: "small",
        variation: "link"
    }, $0832deb9b7cee4a6$var$getForgotPasswordText()));
};
$0832deb9b7cee4a6$export$b64708c6f1b3ed96.Footer = $0832deb9b7cee4a6$var$DefaultFooter;
$0832deb9b7cee4a6$export$b64708c6f1b3ed96.Header = function Header() {
    // @ts-ignore
    return null;
};



var $1T1QG = parcelRequire("1T1QG");










const { getCreateAccountText: $b64ec7d0a58f7530$var$getCreateAccountText, getCreatingAccountText: $b64ec7d0a58f7530$var$getCreatingAccountText } = (0, $24044d7e72f9876b$export$34e9c32aebe14fbb);
function $b64ec7d0a58f7530$export$4ee457d816cea81a() {
    const { hasValidationErrors: hasValidationErrors, isPending: isPending } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)((context)=>[
            context.hasValidationErrors,
            context.isPending
        ]);
    const { handleChange: handleChange, handleBlur: handleBlur, handleSubmit: handleSubmit } = (0, $16a5ca7cf5bd8228$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    SignUp: { Header: Header = $b64ec7d0a58f7530$export$4ee457d816cea81a.Header, FormFields: FormFields = $b64ec7d0a58f7530$export$4ee457d816cea81a.FormFields, Footer: Footer = $b64ec7d0a58f7530$export$4ee457d816cea81a.Footer } } } = (0, $568dae17aa196294$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), null, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-signup": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit,
        onBlur: handleBlur
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $3ce92625c3c535a6$export$558443b7244c6aa), null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(FormFields, null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $7c0fbecde5c7131e$export$3caa4b6a8cb6c61a), null)), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $5f03125e4b28b868$export$353f5b6fc5456de1), {
        isDisabled: hasValidationErrors || isPending,
        isFullWidth: true,
        type: "submit",
        variation: "primary",
        isLoading: isPending,
        loadingText: $b64ec7d0a58f7530$var$getCreatingAccountText()
    }, $b64ec7d0a58f7530$var$getCreateAccountText()))), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Footer, null));
}
$b64ec7d0a58f7530$export$4ee457d816cea81a.Header = function Header() {
    // @ts-ignore
    return null;
};
$b64ec7d0a58f7530$export$4ee457d816cea81a.FormFields = function FormFields$1() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $6ad97cae0c983db3$export$125d0b248abd3e88), null);
};
$b64ec7d0a58f7530$export$4ee457d816cea81a.Footer = function Footer() {
    // @ts-ignore
    return null;
};



const { getSignInTabText: $65c55edc76a8c745$var$getSignInTabText, getSignUpTabText: $65c55edc76a8c745$var$getSignUpTabText } = (0, $24044d7e72f9876b$export$34e9c32aebe14fbb);
const $65c55edc76a8c745$export$6815ad73b98d75ed = ({ className: className, hideSignUp: hideSignUp, variation: variation })=>{
    const { route: route, toSignIn: toSignIn, toSignUp: toSignUp } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)((context)=>[
            context.route,
            context.toSignIn,
            context.toSignUp
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $93c5572e64ae5637$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, hideSignUp ? (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        "data-amplify-router-content": ""
    }, route === "signIn" && (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $0832deb9b7cee4a6$export$b64708c6f1b3ed96), null)) : (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $b8d8a56f802b745c$export$b2539bed5023c21c).Container, {
        value: route,
        isLazy: true,
        onValueChange: ()=>route === "signIn" ? toSignUp() : toSignIn()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $b8d8a56f802b745c$export$b2539bed5023c21c).List, {
        spacing: "equal",
        indicatorPosition: "top"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $b8d8a56f802b745c$export$b2539bed5023c21c).Item, {
        value: "signIn"
    }, $65c55edc76a8c745$var$getSignInTabText()), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $b8d8a56f802b745c$export$b2539bed5023c21c).Item, {
        value: "signUp"
    }, $65c55edc76a8c745$var$getSignUpTabText())), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $b8d8a56f802b745c$export$b2539bed5023c21c).Panel, {
        value: "signIn",
        "data-amplify-router-content": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $0832deb9b7cee4a6$export$b64708c6f1b3ed96), null)), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $b8d8a56f802b745c$export$b2539bed5023c21c).Panel, {
        value: "signUp",
        "data-amplify-router-content": ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $b64ec7d0a58f7530$export$4ee457d816cea81a), null))));
};



var $1T1QG = parcelRequire("1T1QG");








var $1T1QG = parcelRequire("1T1QG");




const { getSubmitText: $e2df08953c089f08$var$getSubmitText, getSubmittingText: $e2df08953c089f08$var$getSubmittingText } = (0, $24044d7e72f9876b$export$34e9c32aebe14fbb);
const $e2df08953c089f08$export$8311b872375357fe = (props)=>{
    const { cancelButtonSendType: cancelButtonSendType, cancelButtonText: cancelButtonText, submitButtonText: submitButtonText } = props;
    const { isPending: isPending, resendCode: resendCode, skipVerification: skipVerification, toSignIn: toSignIn } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)((context)=>[
            context.isPending
        ]);
    const onClick = ()=>{
        switch(cancelButtonSendType){
            case "SKIP":
                skipVerification();
                break;
            case "RESEND":
                resendCode();
                break;
            case "SIGN_IN":
                toSignIn();
                break;
            default:
                return;
        }
    };
    const defaultSubmitText = isPending ? (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, null, $e2df08953c089f08$var$getSubmittingText(), "\u2026") : (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, null, $e2df08953c089f08$var$getSubmitText());
    const submitText = submitButtonText ?? defaultSubmitText;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $5f03125e4b28b868$export$353f5b6fc5456de1), {
        fontWeight: "normal",
        variation: "primary",
        isDisabled: isPending,
        type: "submit"
    }, submitText), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $5f03125e4b28b868$export$353f5b6fc5456de1), {
        onClick: onClick,
        type: "button",
        variation: "link",
        fontWeight: "normal",
        size: "small"
    }, cancelButtonText));
};




const { getAccountRecoveryInfoText: $75befff39a4ee9c4$var$getAccountRecoveryInfoText, getSkipText: $75befff39a4ee9c4$var$getSkipText } = (0, $24044d7e72f9876b$export$34e9c32aebe14fbb);
const $75befff39a4ee9c4$export$79a17bba512ce899 = ({ className: className, variation: variation })=>{
    const { isPending: isPending } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)((context)=>[
            context.isPending
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $16a5ca7cf5bd8228$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ConfirmVerifyUser: { Header: Header = $75befff39a4ee9c4$export$79a17bba512ce899.Header, Footer: Footer = $75befff39a4ee9c4$export$79a17bba512ce899.Footer } } } = (0, $568dae17aa196294$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $93c5572e64ae5637$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmverifyuser": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $6ad97cae0c983db3$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $7c0fbecde5c7131e$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $e2df08953c089f08$export$8311b872375357fe), {
        cancelButtonText: $75befff39a4ee9c4$var$getSkipText(),
        cancelButtonSendType: "SKIP"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Footer, null))));
};
$75befff39a4ee9c4$export$79a17bba512ce899.Header = function Header() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $bbc3d6a725e07173$export$a8a3e93435678ff9), {
        level: 3
    }, $75befff39a4ee9c4$var$getAccountRecoveryInfoText());
};
$75befff39a4ee9c4$export$79a17bba512ce899.Footer = function Footer() {
    return null;
};



var $1T1QG = parcelRequire("1T1QG");




var $1T1QG = parcelRequire("1T1QG");





var $1T1QG = parcelRequire("1T1QG");
const $919a8f28d8c336db$var$defaultValue = {
    name: "default"
};
const $919a8f28d8c336db$export$a79eda4ff50e30b6 = (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createContext($919a8f28d8c336db$var$defaultValue);
const $919a8f28d8c336db$export$7bea016dc7ad2ddf = ()=>{
    return (0, $1T1QG.useContext)($919a8f28d8c336db$export$a79eda4ff50e30b6);
};




const $8ab7858b469ffa27$export$d493a8d66e90d1ca = ({ children: children, className: className, id: id, isDisabled: isDisabled = false, testId: testId, value: value, labelPosition: radioLabelPosition, ...rest }, ref)=>{
    const { currentValue: currentValue, defaultValue: defaultValue, name: name, hasError: hasError, isGroupDisabled: isGroupDisabled = false, isRequired: isRequired, isReadOnly: isReadOnly, onChange: onChange, size: size, labelPosition: groupLabelPosition } = (0, $919a8f28d8c336db$export$7bea016dc7ad2ddf)();
    const { isFieldsetDisabled: isFieldsetDisabled } = (0, $b452cc20c9476a43$export$b140571ec72925dd)();
    const shouldBeDisabled = isFieldsetDisabled ? isFieldsetDisabled : isGroupDisabled || isDisabled || isReadOnly && defaultValue !== value;
    // for controlled component
    const checked = currentValue !== undefined ? value === currentValue : undefined;
    // for uncontrolled component
    const defaultChecked = defaultValue !== undefined ? value === defaultValue : undefined;
    const labelPosition = radioLabelPosition ? radioLabelPosition : groupLabelPosition;
    return $1T1QG.createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        as: "label",
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Radio, (0, $697901644f774aa4$export$3c152e7b97c7496c)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Radio, `disabled`, shouldBeDisabled), labelPosition ? `amplify-label-${labelPosition}` : null, className)
    }, children && $1T1QG.createElement((0, $c7c0980bb0c6b26c$export$5f1af8db9871e1d6), {
        as: "span",
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).RadioLabel, (0, $697901644f774aa4$export$3c152e7b97c7496c)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).RadioLabel, `disabled`, shouldBeDisabled))
    }, children), $1T1QG.createElement((0, $2ef4aacb642dd7a5$export$f5b8910cec6cf069), {
        checked: checked,
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).VisuallyHidden, (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).RadioInput),
        defaultChecked: defaultChecked,
        hasError: hasError,
        id: id,
        isDisabled: shouldBeDisabled,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        onChange: onChange,
        ref: ref,
        type: "radio",
        name: name,
        value: value,
        ...rest
    }), $1T1QG.createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        "aria-hidden": "true",
        as: "span",
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).RadioButton, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).RadioButton, size)),
        testId: testId
    }));
};
const $8ab7858b469ffa27$export$d7b12c4107be0d61 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($8ab7858b469ffa27$export$d493a8d66e90d1ca);
$8ab7858b469ffa27$export$d7b12c4107be0d61.displayName = "Radio";



var $1T1QG = parcelRequire("1T1QG");






var $1T1QG = parcelRequire("1T1QG");






const $fa44bb3b6f6af953$var$FieldsetPrimitive = ({ children: children, className: className, isDisabled: isDisabled, legend: legend, legendHidden: legendHidden, size: size, testId: testId, variation: variation = "plain", ...rest }, ref)=>{
    const { isFieldsetDisabled: isFieldsetDisabled } = (0, $b452cc20c9476a43$export$b140571ec72925dd)();
    // Fieldsets that are nested within a disabled Fieldset should
    // also be disabled.
    const shouldBeDisabled = isFieldsetDisabled ? isFieldsetDisabled : isDisabled;
    const value = $1T1QG.useMemo(()=>({
            isFieldsetDisabled: shouldBeDisabled
        }), [
        shouldBeDisabled
    ]);
    const fieldsetClasses = (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Fieldset, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Fieldset, variation), (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Fieldset, size), className);
    const legendClasses = (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldsetLegend, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).FieldsetLegend, size), {
        [(0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).VisuallyHidden]: legendHidden
    });
    return $1T1QG.createElement((0, $b452cc20c9476a43$export$74e4d3bc6dc1117).Provider, {
        value: value
    }, $1T1QG.createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        as: "fieldset",
        className: fieldsetClasses,
        ref: ref,
        disabled: shouldBeDisabled,
        testId: testId,
        ...rest
    }, $1T1QG.createElement((0, $bb7aa8a63591024b$export$439d29a4e110a164), {
        as: "legend"
    }, legend), $1T1QG.createElement((0, $b9892b8eefdea848$export$27a5bd065ad55220), {
        as: "div",
        "aria-hidden": "true",
        className: legendClasses
    }, legend), children));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/fieldset)
 */ const $fa44bb3b6f6af953$export$e154be390aa0e14 = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($fa44bb3b6f6af953$var$FieldsetPrimitive);
$fa44bb3b6f6af953$export$e154be390aa0e14.displayName = "Fieldset";





const $446af65147caa4e6$export$ec17b125bc42c229 = (testId, component)=>testId && component ? `${testId}-${component}` : undefined;




const $b14f9b76a2d6c77d$var$RadioGroupFieldPrimitive = ({ children: children, className: className, defaultValue: defaultValue, descriptiveText: descriptiveText, errorMessage: errorMessage, hasError: hasError = false, id: id, isDisabled: isDisabled, isRequired: isRequired, isReadOnly: isReadOnly, legend: legend, legendHidden: legendHidden = false, labelPosition: labelPosition, onChange: onChange, name: name, size: size, testId: testId, value: value, variation: variation, ...rest }, ref)=>{
    const fieldId = (0, $73bd3b14086bef4c$export$5c0b1cf3fea224ac)(id);
    const descriptionId = (0, $73bd3b14086bef4c$export$5c0b1cf3fea224ac)();
    const ariaDescribedBy = descriptiveText ? descriptionId : undefined;
    const radioGroupTestId = (0, $446af65147caa4e6$export$ec17b125bc42c229)(testId, (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).RadioGroup);
    const radioGroupContextValue = $1T1QG.useMemo(()=>({
            currentValue: value,
            defaultValue: defaultValue,
            hasError: hasError,
            isRequired: isRequired,
            isReadOnly: isReadOnly,
            isGroupDisabled: isDisabled,
            onChange: onChange,
            size: size,
            name: name,
            labelPosition: labelPosition
        }), [
        defaultValue,
        hasError,
        isDisabled,
        isRequired,
        isReadOnly,
        onChange,
        size,
        name,
        value,
        labelPosition
    ]);
    return $1T1QG.createElement((0, $fa44bb3b6f6af953$export$e154be390aa0e14), {
        className: (0, $930ce2e103c789d9$export$ce4ab0c55987d1ff)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Field, (0, $697901644f774aa4$export$1d6fb99b5e148be8)((0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).Field, size), (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).RadioGroupField, className),
        isDisabled: isDisabled,
        legend: legend,
        legendHidden: legendHidden,
        ref: ref,
        role: "radiogroup",
        size: size,
        testId: testId,
        variation: variation,
        ...rest
    }, $1T1QG.createElement((0, $3d5fc43d7e111c1f$export$873ced4623a3149c), {
        id: descriptionId,
        labelHidden: legendHidden,
        descriptiveText: descriptiveText
    }), $1T1QG.createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        "aria-describedby": ariaDescribedBy,
        className: (0, $d1eb43fcab88ec45$export$a5e41a4bc3f9b1d6).RadioGroup,
        id: fieldId,
        testId: radioGroupTestId
    }, $1T1QG.createElement((0, $919a8f28d8c336db$export$a79eda4ff50e30b6).Provider, {
        value: radioGroupContextValue
    }, children)), $1T1QG.createElement((0, $6b2b98e8fced570c$export$1c081951d49ad6f6), {
        hasError: hasError,
        errorMessage: errorMessage
    }));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/radiogroupfield)
 */ const $b14f9b76a2d6c77d$export$a314277471067e8a = (0, $23e6fd8f9afedafa$export$44aa160b17c73194)($b14f9b76a2d6c77d$var$RadioGroupFieldPrimitive);
$b14f9b76a2d6c77d$export$a314277471067e8a.displayName = "RadioGroupField";








const { getSkipText: $c55546a19f89f77b$var$getSkipText, getVerifyText: $c55546a19f89f77b$var$getVerifyText, getVerifyContactText: $c55546a19f89f77b$var$getVerifyContactText, getAccountRecoveryInfoText: $c55546a19f89f77b$var$getAccountRecoveryInfoText } = (0, $24044d7e72f9876b$export$34e9c32aebe14fbb);
const $c55546a19f89f77b$var$censorContactInformation = (type, value)=>{
    const translated = (0, $c4e69119c3aaed8b$export$d73ee8ef04f5226a)(type);
    let newVal = value;
    if (type === "Phone Number") newVal = (0, $3bd7d334512b2bcd$export$72b2b64445441bf7)(value);
    else if (type === "Email") {
        const splitEmail = value.split("@");
        const censoredName = (0, $3bd7d334512b2bcd$export$655775443891f2b8)(splitEmail[0]);
        newVal = `${censoredName}@${splitEmail[1]}`;
    }
    return `${translated}: ${newVal}`;
};
const $c55546a19f89f77b$var$generateRadioGroup = (attributes)=>{
    return Object.entries(attributes).map(([key, value])=>(0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $8ab7858b469ffa27$export$d7b12c4107be0d61), {
            name: "unverifiedAttr",
            value: key,
            key: key
        }, $c55546a19f89f77b$var$censorContactInformation((0, $25b29aa90ff40796$export$1222d357a3c2c47f)[key].label, value)));
};
const $c55546a19f89f77b$export$da61eb776d8ee98b = ({ className: className, variation: variation })=>{
    const { components: { // @ts-ignore
    VerifyUser: { Header: Header = $c55546a19f89f77b$export$da61eb776d8ee98b.Header, Footer: Footer = $c55546a19f89f77b$export$da61eb776d8ee98b.Footer } } } = (0, $568dae17aa196294$export$b0e9d19f717d0a5c)();
    const { isPending: isPending, unverifiedUserAttributes: unverifiedUserAttributes } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)(({ isPending: isPending, unverifiedUserAttributes: unverifiedUserAttributes })=>[
            isPending,
            unverifiedUserAttributes
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $16a5ca7cf5bd8228$export$df6a82844cee724c)();
    const footerSubmitText = isPending ? (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, null, "Verifying\u2026") : (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, null, $c55546a19f89f77b$var$getVerifyText());
    const verificationRadioGroup = (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $b14f9b76a2d6c77d$export$a314277471067e8a), {
        legend: $c55546a19f89f77b$var$getVerifyContactText(),
        name: "verify_context",
        isDisabled: isPending,
        legendHidden: true
    }, $c55546a19f89f77b$var$generateRadioGroup(unverifiedUserAttributes));
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $93c5572e64ae5637$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-verifyuser": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Header, null), verificationRadioGroup, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $7c0fbecde5c7131e$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $e2df08953c089f08$export$8311b872375357fe), {
        cancelButtonText: $c55546a19f89f77b$var$getSkipText(),
        cancelButtonSendType: "SKIP",
        submitButtonText: footerSubmitText
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Footer, null))));
};
$c55546a19f89f77b$export$da61eb776d8ee98b.Header = function Header() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $bbc3d6a725e07173$export$a8a3e93435678ff9), {
        level: 3
    }, $c55546a19f89f77b$var$getAccountRecoveryInfoText());
};
$c55546a19f89f77b$export$da61eb776d8ee98b.Footer = function Footer() {
    // @ts-ignore
    return null;
};



var $1T1QG = parcelRequire("1T1QG");










const { getChallengeText: $21e072439d9ac9d0$var$getChallengeText } = (0, $24044d7e72f9876b$export$34e9c32aebe14fbb);
const $21e072439d9ac9d0$export$b8b09b30a5bdd893 = ({ className: className, variation: variation })=>{
    const { isPending: isPending } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)((context)=>[
            context.isPending
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $16a5ca7cf5bd8228$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ConfirmSignIn: { Header: Header = $21e072439d9ac9d0$export$b8b09b30a5bdd893.Header, Footer: Footer = $21e072439d9ac9d0$export$b8b09b30a5bdd893.Footer } } } = (0, $568dae17aa196294$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $93c5572e64ae5637$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmsignin": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $6ad97cae0c983db3$export$125d0b248abd3e88), null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $7c0fbecde5c7131e$export$3caa4b6a8cb6c61a), null)), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $4d5795a614ccd27b$export$76e9c0cec6811ff4), null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Footer, null))));
};
function $21e072439d9ac9d0$var$Header() {
    const { challengeName: challengeName } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)(({ challengeName: challengeName })=>[
            challengeName
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $bbc3d6a725e07173$export$a8a3e93435678ff9), {
        level: 3
    }, $21e072439d9ac9d0$var$getChallengeText(challengeName));
}
$21e072439d9ac9d0$export$b8b09b30a5bdd893.Header = $21e072439d9ac9d0$var$Header;
$21e072439d9ac9d0$export$b8b09b30a5bdd893.Footer = function Footer() {
    // @ts-ignore
    return null;
};



var $1T1QG = parcelRequire("1T1QG");










const { getResendCodeText: $26bbaa915a723b0d$var$getResendCodeText, getResetYourPasswordText: $26bbaa915a723b0d$var$getResetYourPasswordText } = (0, $24044d7e72f9876b$export$34e9c32aebe14fbb);
const $26bbaa915a723b0d$export$fb3a0d1a16180c0d = ({ className: className, variation: variation })=>{
    const { isPending: isPending } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)((context)=>[
            context.isPending
        ]);
    const { handleBlur: handleBlur, handleChange: handleChange, handleSubmit: handleSubmit } = (0, $16a5ca7cf5bd8228$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ConfirmResetPassword: { Header: Header = $26bbaa915a723b0d$export$fb3a0d1a16180c0d.Header, Footer: Footer = $26bbaa915a723b0d$export$fb3a0d1a16180c0d.Footer } } } = (0, $568dae17aa196294$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $93c5572e64ae5637$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-confirmresetpassword": "",
        method: "post",
        onSubmit: handleSubmit,
        onChange: handleChange,
        onBlur: handleBlur
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $6ad97cae0c983db3$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $7c0fbecde5c7131e$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $e2df08953c089f08$export$8311b872375357fe), {
        cancelButtonSendType: "RESEND",
        cancelButtonText: $26bbaa915a723b0d$var$getResendCodeText()
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Footer, null))));
};
$26bbaa915a723b0d$export$fb3a0d1a16180c0d.Header = function Header() {
    const headerText = $26bbaa915a723b0d$var$getResetYourPasswordText();
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $bbc3d6a725e07173$export$a8a3e93435678ff9), {
        level: 3
    }, headerText);
};
$26bbaa915a723b0d$export$fb3a0d1a16180c0d.Footer = function Footer() {
    // @ts-ignore
    return null;
};



var $1T1QG = parcelRequire("1T1QG");










const { getBackToSignInText: $325ecb7c11ab7176$var$getBackToSignInText, getSendingText: $325ecb7c11ab7176$var$getSendingText, getSendCodeText: $325ecb7c11ab7176$var$getSendCodeText, getResetYourPasswordText: $325ecb7c11ab7176$var$getResetYourPasswordText } = (0, $24044d7e72f9876b$export$34e9c32aebe14fbb);
const $325ecb7c11ab7176$export$b597ee422a3143dc = ({ className: className, variation: variation })=>{
    const { isPending: isPending } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)((context)=>[
            context.isPending
        ]);
    const { handleChange: handleChange, handleSubmit: handleSubmit } = (0, $16a5ca7cf5bd8228$export$df6a82844cee724c)();
    const { components: { // @ts-ignore
    ForgotPassword: { Header: Header = $325ecb7c11ab7176$export$b597ee422a3143dc.Header, Footer: Footer = $325ecb7c11ab7176$export$b597ee422a3143dc.Footer } } } = (0, $568dae17aa196294$export$b0e9d19f717d0a5c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $93c5572e64ae5637$export$253df7dc30f737bc), {
        className: className,
        variation: variation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement("form", {
        "data-amplify-form": "",
        "data-amplify-authenticator-forgotpassword": "",
        method: "post",
        onChange: handleChange,
        onSubmit: handleSubmit
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        as: "fieldset",
        direction: "column",
        isDisabled: isPending
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $a7adec5cc5c7ad96$export$f51f4c4ede09e011), {
        direction: "column"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $6ad97cae0c983db3$export$125d0b248abd3e88), null)), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $7c0fbecde5c7131e$export$3caa4b6a8cb6c61a), null), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $e2df08953c089f08$export$8311b872375357fe), {
        cancelButtonText: $325ecb7c11ab7176$var$getBackToSignInText(),
        cancelButtonSendType: "SIGN_IN",
        submitButtonText: isPending ? (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, null, $325ecb7c11ab7176$var$getSendingText(), "\u2026") : (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, null, $325ecb7c11ab7176$var$getSendCodeText())
    }), (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(Footer, null))));
};
$325ecb7c11ab7176$export$b597ee422a3143dc.Header = function Header() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $bbc3d6a725e07173$export$a8a3e93435678ff9), {
        level: 3
    }, $325ecb7c11ab7176$var$getResetYourPasswordText());
};
$325ecb7c11ab7176$export$b597ee422a3143dc.Footer = function Footer() {
    // @ts-ignore
    return null;
};


const $bb2722454957efe9$export$c92b4b399eea902a = (route)=>route === "signIn" || route === "signUp";


function $4580ac0162110f8e$var$RenderNothing() {
    // @ts-ignore
    return null;
}
const $4580ac0162110f8e$var$getRouteComponent = (route)=>{
    switch(route){
        case "authenticated":
        case "idle":
        case "setup":
        case "transition":
            return $4580ac0162110f8e$var$RenderNothing;
        case "confirmSignUp":
            return 0, $8e57433bacddc877$export$649c708157e61c64;
        case "confirmSignIn":
            return 0, $21e072439d9ac9d0$export$b8b09b30a5bdd893;
        case "setupTotp":
            return 0, $dd73613a299919a5$export$1f819652bce2948d;
        case "signIn":
        case "signUp":
            return 0, $65c55edc76a8c745$export$6815ad73b98d75ed;
        case "forceNewPassword":
            return 0, $11ebedca26c7a168$export$b3aae0a112274a60;
        case "forgotPassword":
            return 0, $325ecb7c11ab7176$export$b597ee422a3143dc;
        case "confirmResetPassword":
            return 0, $26bbaa915a723b0d$export$fb3a0d1a16180c0d;
        case "verifyUser":
            return 0, $c55546a19f89f77b$export$da61eb776d8ee98b;
        case "confirmVerifyUser":
            return 0, $75befff39a4ee9c4$export$79a17bba512ce899;
        default:
            // eslint-disable-next-line no-console
            console.warn(`Unhandled Authenticator route - please open an issue: ${route}`);
            return $4580ac0162110f8e$var$RenderNothing;
    }
};
function $4580ac0162110f8e$export$55185c17a0fcbe46({ className: className, hideSignUp: hideSignUp, variation: variation }) {
    const { route: route } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)(({ route: route })=>[
            route
        ]);
    const RouterChildren = (0, $1T1QG.useMemo)(()=>$4580ac0162110f8e$var$getRouteComponent(route), [
        route
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement(RouterChildren, {
        className: className,
        // @ts-ignore
        hideSignUp: (0, $bb2722454957efe9$export$c92b4b399eea902a)(route) ? hideSignUp : undefined,
        variation: variation
    });
}


















const $5e7a3eadc7d4207e$export$71abc632aa29e6fe = {
    // @ts-ignore
    Header: ()=>null,
    SignIn: {
        Header: (0, $0832deb9b7cee4a6$export$b64708c6f1b3ed96).Header,
        Footer: (0, $0832deb9b7cee4a6$export$b64708c6f1b3ed96).Footer
    },
    SignUp: {
        Header: (0, $b64ec7d0a58f7530$export$4ee457d816cea81a).Header,
        FormFields: (0, $b64ec7d0a58f7530$export$4ee457d816cea81a).FormFields,
        Footer: (0, $b64ec7d0a58f7530$export$4ee457d816cea81a).Footer
    },
    ConfirmSignUp: {
        Header: (0, $8e57433bacddc877$export$649c708157e61c64).Header,
        Footer: (0, $8e57433bacddc877$export$649c708157e61c64).Footer
    },
    SetupTotp: {
        Header: (0, $dd73613a299919a5$export$1f819652bce2948d).Header,
        Footer: (0, $dd73613a299919a5$export$1f819652bce2948d).Footer
    },
    ConfirmResetPassword: {
        Header: (0, $26bbaa915a723b0d$export$fb3a0d1a16180c0d).Header,
        Footer: (0, $26bbaa915a723b0d$export$fb3a0d1a16180c0d).Footer
    },
    ConfirmSignIn: {
        Header: (0, $21e072439d9ac9d0$export$b8b09b30a5bdd893).Header,
        Footer: (0, $21e072439d9ac9d0$export$b8b09b30a5bdd893).Footer
    },
    VerifyUser: {
        Header: (0, $c55546a19f89f77b$export$da61eb776d8ee98b).Header,
        Footer: (0, $c55546a19f89f77b$export$da61eb776d8ee98b).Footer
    },
    ConfirmVerifyUser: {
        Header: (0, $75befff39a4ee9c4$export$79a17bba512ce899).Header,
        // @ts-ignore
        Footer: (0, $75befff39a4ee9c4$export$79a17bba512ce899).Footer
    },
    ForceNewPassword: {
        Header: (0, $11ebedca26c7a168$export$b3aae0a112274a60).Header,
        Footer: (0, $11ebedca26c7a168$export$b3aae0a112274a60).Footer,
        FormFields: (0, $11ebedca26c7a168$export$b3aae0a112274a60).FormFields
    },
    ForgotPassword: {
        Header: (0, $325ecb7c11ab7176$export$b597ee422a3143dc).Header,
        Footer: (0, $325ecb7c11ab7176$export$b597ee422a3143dc).Footer
    },
    // @ts-ignore
    Footer: ()=>null
};


// `AuthenticatorInternal` exists to give access to the context returned via `useAuthenticator`,
// which allows the `Authenticator` to just return `children` if a user is authenticated.
// Once the `Provider` is removed from the `Authenticator` component and exported as
// `AuthenticatorProvider`, this component should be renamed to `Authenticator`.
function $192882e5bbaffa89$export$213d252991da224({ children: children, className: className, components: customComponents, formFields: formFields, hideSignUp: hideSignUp, initialState: initialState, loginMechanisms: loginMechanisms, passwordSettings: passwordSettings, signUpAttributes: signUpAttributes, services: services, socialProviders: socialProviders, variation: variation }) {
    (0, $0a6745a1edc09cca$export$406e4c8585b97b03)({
        message: "The `passwordSettings` prop has been deprecated and will be removed in a future major version of Amplify UI.",
        // shouldWarn: !!passwordSettings,
        /**
         * @migration turn off until getConfig returns zero config
         */ shouldWarn: false
    });
    const { route: route, signOut: signOut, user: user } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)(({ route: route, signOut: signOut, user: user })=>[
            route,
            signOut,
            user
        ]);
    (0, $98444ee845bd102f$export$2e2bcd8739ae039)({
        initialState: initialState,
        loginMechanisms: loginMechanisms,
        passwordSettings: passwordSettings,
        services: services,
        signUpAttributes: signUpAttributes,
        socialProviders: socialProviders,
        formFields: formFields
    });
    const value = $1T1QG.useMemo(()=>({
            components: {
                ...(0, $5e7a3eadc7d4207e$export$71abc632aa29e6fe),
                ...customComponents
            }
        }), [
        customComponents
    ]);
    const isAuthenticatedRoute = route === "authenticated" || route === "signOut";
    if (isAuthenticatedRoute) {
        // `Authenticator` might not have user defined `children` for non SPA use cases.
        if (!children) // @ts-ignore
        return null;
        return $1T1QG.createElement($1T1QG.Fragment, null, (0, $697901644f774aa4$export$f6e2535fb5126e54)(children) ? children({
            signOut: signOut,
            user: user
        }) // children is a render prop
         : children);
    }
    return $1T1QG.createElement((0, $568dae17aa196294$export$da5ac45a736a5880).Provider, {
        value: value
    }, $1T1QG.createElement((0, $4580ac0162110f8e$export$55185c17a0fcbe46), {
        className: className,
        hideSignUp: hideSignUp,
        variation: variation
    }));
}
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/connected-components/authenticator)
 */ function $192882e5bbaffa89$export$3d7a1e8452f884f3(props) {
    (0, $64668a4425719fac$export$2e2bcd8739ae039)({
        componentName: "Authenticator",
        packageName: "react",
        version: (0, $b98b3b2c213c83ce$export$a4ad2735b021c132)
    });
    return $1T1QG.createElement((0, $8f85b82cfd7bce86$export$2e2bcd8739ae039), null, $1T1QG.createElement($192882e5bbaffa89$export$213d252991da224, {
        ...props
    }));
}
$192882e5bbaffa89$export$3d7a1e8452f884f3.Provider = (0, $8f85b82cfd7bce86$export$2e2bcd8739ae039);
$192882e5bbaffa89$export$3d7a1e8452f884f3.ForgotPassword = (0, $325ecb7c11ab7176$export$b597ee422a3143dc);
$192882e5bbaffa89$export$3d7a1e8452f884f3.SetupTotp = (0, $dd73613a299919a5$export$1f819652bce2948d);
$192882e5bbaffa89$export$3d7a1e8452f884f3.SignIn = (0, $0832deb9b7cee4a6$export$b64708c6f1b3ed96);
$192882e5bbaffa89$export$3d7a1e8452f884f3.SignUp = (0, $b64ec7d0a58f7530$export$4ee457d816cea81a);
$192882e5bbaffa89$export$3d7a1e8452f884f3.ForceNewPassword = (0, $11ebedca26c7a168$export$b3aae0a112274a60);





var $1T1QG = parcelRequire("1T1QG");













var $1T1QG = parcelRequire("1T1QG");


const $560b76bc43b3f649$var$useAuthenticatorData = ({ customerId: customerId, queryCataloguesEnabled: queryCataloguesEnabled = false, queryPlacesEnabled: queryPlacesEnabled = false, queryCustomersEnabled: queryCustomersEnabled = false })=>{
    const navigate = (0, $e0cff2801449e77d$export$9770f232ac06a008)();
    const { admin: admin, customerType: customerType } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const { setCustomerFromArray: setCustomerFromArray, customer: customer, setPlaceFromArray: setPlaceFromArray, setPlaceFromCatalogue: setPlaceFromCatalogue, setInitialized: setInitialized } = (0, $a48e808e68b0e5f9$export$2e2bcd8739ae039)();
    const queryCatalogues = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$90904af181961b2),
            customerId
        ],
        queryFn: ()=>(0, $7499271e3a060909$export$25753268427e50ea).getCataloguesByCustomer(customerId),
        enabled: queryCataloguesEnabled && customerType === "T"
    });
    const queryPlaces = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$9e8d1e7efde0f0d3)
        ],
        queryFn: ()=>(0, $3af058eac12e21cb$export$2e2bcd8739ae039).getPlacesByCustomer(admin, customerId),
        enabled: queryPlacesEnabled && customerType === "L"
    });
    const queryCustomers = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$a8e0fd0e2c725bd)
        ],
        queryFn: ()=>admin ? (0, $3af058eac12e21cb$export$2e2bcd8739ae039).getLandlords(true, {
                limit: 10
            }) : (0, $3af058eac12e21cb$export$2e2bcd8739ae039).getCustomers(false, {
                limit: 10,
                sort: "TYPE",
                direction: "ASC"
            }),
        enabled: queryCustomersEnabled
    });
    (0, $1T1QG.useEffect)(()=>{
        if (queryCustomers.isSuccess) {
            const response = queryCustomers.data;
            if (response.data && response.data?.length > 0 && response.data[0]?.id && response.data[0]?.name) setCustomerFromArray(response.data, true);
            else {
                setInitialized(true);
                navigate((0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).LOGIN_STEPS, {
                    replace: true
                });
            }
        }
    }, [
        queryCustomers.isSuccess
    ]);
    (0, $1T1QG.useEffect)(()=>{
        if (queryCatalogues.isSuccess) {
            const response = queryCatalogues.data;
            if (response && response.length > 0 && response[0]?.place?.id && response[0]?.place?.name) setPlaceFromCatalogue(response[0]);
        }
    }, [
        queryCatalogues.isSuccess
    ]);
    (0, $1T1QG.useEffect)(()=>{
        if (queryPlaces.isSuccess) {
            const response = queryPlaces.data;
            if (response && response.length > 0 && response[0]?.id && response[0]?.name) setPlaceFromArray(response);
            else {
                setInitialized(true);
                navigate((0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).LOGIN_STEPS, {
                    replace: true
                });
            }
        }
    }, [
        queryPlaces.isSuccess
    ]);
    const waitingForCustomers = queryCustomers.isPending;
    const waitingForPlaces = customerType === "T" ? customer?.id && queryCatalogues.isPending : customer?.id && queryPlaces.isPending;
    return {
        queryCustomers: queryCustomers,
        queryCatalogues: queryCatalogues,
        queryPlaces: queryPlaces,
        waitingForCustomers: waitingForCustomers,
        waitingForPlaces: waitingForPlaces
    };
};
var $560b76bc43b3f649$export$2e2bcd8739ae039 = $560b76bc43b3f649$var$useAuthenticatorData;


const $e7beb9767bbe39d4$var$MoovyAuthenticator = ({ children: children })=>{
    const { user: user } = (0, $61b5de0b744cce38$export$2e2bcd8739ae039)((context)=>[
            context.user
        ]);
    const [searchParams] = (0, $efa9cbb50e224d6a$export$f1a78c17382fe22a)();
    const signUp = searchParams.get("signUp");
    const { isAuthenticated: isAuthenticated, setAuthentication: setAuthentication, userGroups: userGroups } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const { customer: customer } = (0, $a48e808e68b0e5f9$export$2e2bcd8739ae039)();
    const sessionQuery = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$136d5c9516c6d4cd)
        ],
        queryFn: ()=>(0, $c5bdd8e1d814380c$export$2e2bcd8739ae039).getAuthSession(),
        enabled: false
    });
    const { queryPlaces: queryPlaces, queryCustomers: queryCustomers, waitingForCustomers: waitingForCustomers, waitingForPlaces: waitingForPlaces } = (0, $560b76bc43b3f649$export$2e2bcd8739ae039)({
        customerId: customer?.id,
        queryCataloguesEnabled: sessionQuery.isSuccess,
        queryPlacesEnabled: sessionQuery.isSuccess,
        queryCustomersEnabled: sessionQuery.isSuccess
    });
    (0, $1T1QG.useEffect)(()=>{
        if (sessionQuery.isSuccess) {
            const jwtToken = (0, $c5bdd8e1d814380c$export$2e2bcd8739ae039).getJWTToken(sessionQuery.data);
            if (jwtToken) {
                setAuthentication({
                    userGroups: (0, $c5bdd8e1d814380c$export$2e2bcd8739ae039).getUserGroups(sessionQuery.data),
                    token: jwtToken
                });
                (0, $c5bdd8e1d814380c$export$2e2bcd8739ae039).setTokenToInterceptor(jwtToken);
            }
        }
    }, [
        sessionQuery.isSuccess
    ]);
    const waitingForSession = sessionQuery.isPending;
    const waitingForGroups = userGroups === undefined;
    // Login has happened, fetch session data to Redux state and Session storage
    (0, $1T1QG.useEffect)(()=>{
        user?.username && sessionQuery.refetch();
    }, [
        user?.username
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $192882e5bbaffa89$export$3d7a1e8452f884f3), {
            initialState: signUp ? "signUp" : "signIn",
            signUpAttributes: [
                "given_name",
                "family_name",
                "email"
            ],
            children: ({ signOut: signOut, user: user })=>{
                return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
                    children: !isAuthenticated || waitingForGroups || waitingForSession || waitingForCustomers || waitingForPlaces ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4cdfa78f7d1b8c19$export$2e2bcd8739ae039), {}) : sessionQuery.isError || queryPlaces.isError || queryCustomers.isError ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c338ce915869c7c0$export$2e2bcd8739ae039), {}) : children
                });
            }
        })
    });
};
var $e7beb9767bbe39d4$export$2e2bcd8739ae039 = $e7beb9767bbe39d4$var$MoovyAuthenticator;



var $3Py8h = parcelRequire("3Py8h");


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");


var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $0c4df44e6613c217$export$c6bd6795ed6e3203(slot) {
    return (0, $iNQht.default)("MuiList", slot);
}
const $0c4df44e6613c217$var$listClasses = (0, $dfswM.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $0c4df44e6613c217$export$2e2bcd8739ae039 = $0c4df44e6613c217$var$listClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $44769ad997f9918f$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $44769ad997f9918f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $0c4df44e6613c217$export$c6bd6795ed6e3203), classes);
};
const $44769ad997f9918f$var$ListRoot = (0, $npagc.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $44769ad997f9918f$var$List = /*#__PURE__*/ $1T1QG.forwardRef(function List(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $iXdVf.default)(props, $44769ad997f9918f$var$_excluded);
    const context = $1T1QG.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $ajTRS.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $44769ad997f9918f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $be3ac30bfa71c06e$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $3Py8h.jsxs)($44769ad997f9918f$var$ListRoot, (0, $ajTRS.default)({
            as: component,
            className: (0, $aVXbR.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $44769ad997f9918f$export$2e2bcd8739ae039 = $44769ad997f9918f$var$List;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");



var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");


var $3Py8h = parcelRequire("3Py8h");
"use client";
const $7308185c8ff27335$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $7308185c8ff27335$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $980fee846c99659e$export$1061006a0db3aeb5), classes);
};
const $7308185c8ff27335$var$ListItemTextRoot = (0, $npagc.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $980fee846c99659e$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $980fee846c99659e$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $7308185c8ff27335$var$ListItemText = /*#__PURE__*/ $1T1QG.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $iXdVf.default)(props, $7308185c8ff27335$var$_excluded);
    const { dense: dense } = $1T1QG.useContext((0, $be3ac30bfa71c06e$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $ajTRS.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $7308185c8ff27335$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $a386176d6ca21602$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a386176d6ca21602$export$2e2bcd8739ae039), (0, $ajTRS.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $a386176d6ca21602$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a386176d6ca21602$export$2e2bcd8739ae039), (0, $ajTRS.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($7308185c8ff27335$var$ListItemTextRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $7308185c8ff27335$export$2e2bcd8739ae039 = $7308185c8ff27335$var$ListItemText;



var $3Py8h = parcelRequire("3Py8h");

var $1T1QG = parcelRequire("1T1QG");

function $743613eeafeadd3a$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $3Py8h = parcelRequire("3Py8h");
"use client";
function $1663c797508dc868$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $1663c797508dc868$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/base-ui/react-click-away-listener/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/base-ui/react-click-away-listener/components-api/#click-away-listener)
 */ function $1663c797508dc868$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = "onClick", onClickAway: onClickAway, touchEvent: touchEvent = "onTouchEnd" } = props;
    const movedRef = $1T1QG.useRef(false);
    const nodeRef = $1T1QG.useRef(null);
    const activatedRef = $1T1QG.useRef(false);
    const syntheticEventRef = $1T1QG.useRef(false);
    $1T1QG.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $d2fee4866c2743fb$export$2e2bcd8739ae039)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $f10dd87bccb0014d$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $743613eeafeadd3a$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || "clientX" in event && $1663c797508dc868$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $1T1QG.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $1663c797508dc868$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $743613eeafeadd3a$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $1T1QG.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $1663c797508dc868$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $743613eeafeadd3a$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($1T1QG.Fragment, {
        children: /*#__PURE__*/ $1T1QG.cloneElement(children, childrenProps)
    });
}


var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");



var $iXdVf = parcelRequire("iXdVf");



var $1T1QG = parcelRequire("1T1QG");

var $c1231319f0b942f5$export$2e2bcd8739ae039 = {
    disabled: false
};




var $62cd2fb6df2fdc76$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $97e45c35ce24099f$export$bb38bb9a1161268 = "unmounted";
var $97e45c35ce24099f$export$84cbff306f539230 = "exited";
var $97e45c35ce24099f$export$df38205c966be359 = "entering";
var $97e45c35ce24099f$export$78e9e6e3e014d60a = "entered";
var $97e45c35ce24099f$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $97e45c35ce24099f$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $2068d65b9cbba68b$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $97e45c35ce24099f$export$84cbff306f539230;
                _this.appearStatus = $97e45c35ce24099f$export$df38205c966be359;
            } else initialStatus = $97e45c35ce24099f$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $97e45c35ce24099f$export$bb38bb9a1161268;
        else initialStatus = $97e45c35ce24099f$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $97e45c35ce24099f$export$bb38bb9a1161268) return {
            status: $97e45c35ce24099f$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $97e45c35ce24099f$export$df38205c966be359 && status !== $97e45c35ce24099f$export$78e9e6e3e014d60a) nextStatus = $97e45c35ce24099f$export$df38205c966be359;
            } else if (status === $97e45c35ce24099f$export$df38205c966be359 || status === $97e45c35ce24099f$export$78e9e6e3e014d60a) nextStatus = $97e45c35ce24099f$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $97e45c35ce24099f$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($27f1df944e3d0485$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $62cd2fb6df2fdc76$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $97e45c35ce24099f$export$84cbff306f539230) this.setState({
            status: $97e45c35ce24099f$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($27f1df944e3d0485$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $c1231319f0b942f5$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $97e45c35ce24099f$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $97e45c35ce24099f$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $97e45c35ce24099f$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($27f1df944e3d0485$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $c1231319f0b942f5$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $97e45c35ce24099f$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $97e45c35ce24099f$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $97e45c35ce24099f$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($27f1df944e3d0485$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $97e45c35ce24099f$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $iXdVf.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $11067877488353c4$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Component);
$97e45c35ce24099f$var$Transition.contextType = (0, $11067877488353c4$export$2e2bcd8739ae039);
$97e45c35ce24099f$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $97e45c35ce24099f$var$noop() {}
$97e45c35ce24099f$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $97e45c35ce24099f$var$noop,
    onEntering: $97e45c35ce24099f$var$noop,
    onEntered: $97e45c35ce24099f$var$noop,
    onExit: $97e45c35ce24099f$var$noop,
    onExiting: $97e45c35ce24099f$var$noop,
    onExited: $97e45c35ce24099f$var$noop
};
$97e45c35ce24099f$var$Transition.UNMOUNTED = $97e45c35ce24099f$export$bb38bb9a1161268;
$97e45c35ce24099f$var$Transition.EXITED = $97e45c35ce24099f$export$84cbff306f539230;
$97e45c35ce24099f$var$Transition.ENTERING = $97e45c35ce24099f$export$df38205c966be359;
$97e45c35ce24099f$var$Transition.ENTERED = $97e45c35ce24099f$export$78e9e6e3e014d60a;
$97e45c35ce24099f$var$Transition.EXITING = $97e45c35ce24099f$export$4aacc83d4d59139f;
var $97e45c35ce24099f$export$2e2bcd8739ae039 = $97e45c35ce24099f$var$Transition;



const $3c14342afe4d3400$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $3c14342afe4d3400$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $3Py8h = parcelRequire("3Py8h");
"use client";
const $e236f531d361181f$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $e236f531d361181f$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $e236f531d361181f$var$styles = {
    entering: {
        opacity: 1,
        transform: $e236f531d361181f$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $e236f531d361181f$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $e236f531d361181f$var$Grow = /*#__PURE__*/ $1T1QG.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $97e45c35ce24099f$export$2e2bcd8739ae039) } = props, other = (0, $iXdVf.default)(props, $e236f531d361181f$var$_excluded);
    const timer = (0, $b17443dc4e529ae6$export$2e2bcd8739ae039)();
    const autoTimeout = $1T1QG.useRef();
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const nodeRef = $1T1QG.useRef(null);
    const handleRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $3c14342afe4d3400$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $3c14342afe4d3400$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $e236f531d361181f$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $3c14342afe4d3400$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $e236f531d361181f$var$isWebKit154 ? duration : duration * 0.666,
                delay: $e236f531d361181f$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $e236f531d361181f$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)(TransitionComponent, (0, $ajTRS.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $1T1QG.cloneElement(children, (0, $ajTRS.default)({
                style: (0, $ajTRS.default)({
                    opacity: 0,
                    transform: $e236f531d361181f$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $e236f531d361181f$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$e236f531d361181f$var$Grow.muiSupportAuto = true;
var $e236f531d361181f$export$2e2bcd8739ae039 = $e236f531d361181f$var$Grow;


var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");



var $8c4927d8b7167c70$export$2e2bcd8739ae039 = (0, $743613eeafeadd3a$export$2e2bcd8739ae039);



// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $1f4ecd10afea7820$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $1f291ef3dd19b571$export$2e2bcd8739ae039 = (0, $1f4ecd10afea7820$export$2e2bcd8739ae039);





var $3Py8h = parcelRequire("3Py8h");
"use client";
const $0c6bdc89c1f59767$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $0c6bdc89c1f59767$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $0c6bdc89c1f59767$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $0c6bdc89c1f59767$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $0c6bdc89c1f59767$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$0c6bdc89c1f59767$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $0c6bdc89c1f59767$var$MenuList = /*#__PURE__*/ $1T1QG.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $iXdVf.default)(props, $0c6bdc89c1f59767$var$_excluded);
    const listRef = $1T1QG.useRef(null);
    const textCriteriaRef = $1T1QG.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $675d87943b3ee26a$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $1T1QG.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $1f291ef3dd19b571$export$2e2bcd8739ae039)((0, $8c4927d8b7167c70$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $8c4927d8b7167c70$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $0c6bdc89c1f59767$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $0c6bdc89c1f59767$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $0c6bdc89c1f59767$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $0c6bdc89c1f59767$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $0c6bdc89c1f59767$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $0c6bdc89c1f59767$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $0c6bdc89c1f59767$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $0c6bdc89c1f59767$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $0c6bdc89c1f59767$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $0c6bdc89c1f59767$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $0c6bdc89c1f59767$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $1T1QG.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $1T1QG.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $1T1QG.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $1T1QG.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $44769ad997f9918f$export$2e2bcd8739ae039), (0, $ajTRS.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $0c6bdc89c1f59767$export$2e2bcd8739ae039 = $0c6bdc89c1f59767$var$MenuList;


var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");

function $2b900c9ac5215f63$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $14c0aa94e6ad7d11$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $2b900c9ac5215f63$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $14c0aa94e6ad7d11$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $2b900c9ac5215f63$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $14c0aa94e6ad7d11$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $2b900c9ac5215f63$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3e0f6051afd83333$export$8960430cfd85939f = Math.max;
var $3e0f6051afd83333$export$96ec731ed4dcb222 = Math.min;
var $3e0f6051afd83333$export$2077e0241d6afd3c = Math.round;



function $69c672f84731bc6a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $33f5c04daf4a337e$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $69c672f84731bc6a$export$2e2bcd8739ae039)());
}


function $08ffec67e478eea1$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $14c0aa94e6ad7d11$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3e0f6051afd83333$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3e0f6051afd83333$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $14c0aa94e6ad7d11$export$45a5e7f76e0caa8d)(element) ? (0, $2b900c9ac5215f63$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $33f5c04daf4a337e$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $68e22fd0a7ea67aa$export$2e2bcd8739ae039(node) {
    var win = (0, $2b900c9ac5215f63$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $66bd9405983620f4$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $a0643983d92bb096$export$2e2bcd8739ae039(node) {
    if (node === (0, $2b900c9ac5215f63$export$2e2bcd8739ae039)(node) || !(0, $14c0aa94e6ad7d11$export$1b3bfaa9684536aa)(node)) return (0, $68e22fd0a7ea67aa$export$2e2bcd8739ae039)(node);
    else return (0, $66bd9405983620f4$export$2e2bcd8739ae039)(node);
}


function $db93b8f5cf2ace81$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $12372a4b94147033$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $14c0aa94e6ad7d11$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $4a303ba9ff26a37b$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $08ffec67e478eea1$export$2e2bcd8739ae039)((0, $12372a4b94147033$export$2e2bcd8739ae039)(element)).left + (0, $68e22fd0a7ea67aa$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $6f6aca9f5b7a0a50$export$2e2bcd8739ae039(element) {
    return (0, $2b900c9ac5215f63$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $7d5df98dfbb8f4cb$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $6f6aca9f5b7a0a50$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $e8c6908c15a364bf$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3e0f6051afd83333$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3e0f6051afd83333$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $e8c6908c15a364bf$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $14c0aa94e6ad7d11$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $14c0aa94e6ad7d11$export$1b3bfaa9684536aa)(offsetParent) && $e8c6908c15a364bf$var$isElementScaled(offsetParent);
    var documentElement = (0, $12372a4b94147033$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $08ffec67e478eea1$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $db93b8f5cf2ace81$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $7d5df98dfbb8f4cb$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $a0643983d92bb096$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $14c0aa94e6ad7d11$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $08ffec67e478eea1$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $4a303ba9ff26a37b$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $3a30edde69130a9d$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $08ffec67e478eea1$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $a35acfbfcb1a9833$export$2e2bcd8739ae039(element) {
    if ((0, $db93b8f5cf2ace81$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $14c0aa94e6ad7d11$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $12372a4b94147033$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $fd3f9f3869fa35a5$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $db93b8f5cf2ace81$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $14c0aa94e6ad7d11$export$1b3bfaa9684536aa)(node) && (0, $7d5df98dfbb8f4cb$export$2e2bcd8739ae039)(node)) return node;
    return $fd3f9f3869fa35a5$export$2e2bcd8739ae039((0, $a35acfbfcb1a9833$export$2e2bcd8739ae039)(node));
}





function $3211a4ac796e8f6b$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $fd3f9f3869fa35a5$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $2b900c9ac5215f63$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $7d5df98dfbb8f4cb$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($3211a4ac796e8f6b$export$2e2bcd8739ae039((0, $a35acfbfcb1a9833$export$2e2bcd8739ae039)(target)));
}







function $d8f5ae187f56603b$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $db93b8f5cf2ace81$export$2e2bcd8739ae039)(element)) >= 0;
}




function $ff1341f32f74c890$var$getTrueOffsetParent(element) {
    if (!(0, $14c0aa94e6ad7d11$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $6f6aca9f5b7a0a50$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $ff1341f32f74c890$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $69c672f84731bc6a$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $69c672f84731bc6a$export$2e2bcd8739ae039)());
    if (isIE && (0, $14c0aa94e6ad7d11$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $6f6aca9f5b7a0a50$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $a35acfbfcb1a9833$export$2e2bcd8739ae039)(element);
    if ((0, $14c0aa94e6ad7d11$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $14c0aa94e6ad7d11$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $db93b8f5cf2ace81$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $6f6aca9f5b7a0a50$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $ff1341f32f74c890$export$2e2bcd8739ae039(element) {
    var window = (0, $2b900c9ac5215f63$export$2e2bcd8739ae039)(element);
    var offsetParent = $ff1341f32f74c890$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $d8f5ae187f56603b$export$2e2bcd8739ae039)(offsetParent) && (0, $6f6aca9f5b7a0a50$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $ff1341f32f74c890$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $db93b8f5cf2ace81$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $db93b8f5cf2ace81$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $6f6aca9f5b7a0a50$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $ff1341f32f74c890$var$getContainingBlock(element) || window;
}


var $97d12055ae9c6ba2$export$1e95b668f3b82d = "top";
var $97d12055ae9c6ba2$export$40e543e69a8b3fbb = "bottom";
var $97d12055ae9c6ba2$export$79ffe56a765070d2 = "right";
var $97d12055ae9c6ba2$export$eabcd2c8791e7bf4 = "left";
var $97d12055ae9c6ba2$export$dfb5619354ba860 = "auto";
var $97d12055ae9c6ba2$export$aec2ce47c367b8c3 = [
    $97d12055ae9c6ba2$export$1e95b668f3b82d,
    $97d12055ae9c6ba2$export$40e543e69a8b3fbb,
    $97d12055ae9c6ba2$export$79ffe56a765070d2,
    $97d12055ae9c6ba2$export$eabcd2c8791e7bf4
];
var $97d12055ae9c6ba2$export$b3571188c770cc5a = "start";
var $97d12055ae9c6ba2$export$bd5df0f255a350f8 = "end";
var $97d12055ae9c6ba2$export$390fd549c5303b4d = "clippingParents";
var $97d12055ae9c6ba2$export$d7b7311ec04a3e8f = "viewport";
var $97d12055ae9c6ba2$export$ae5ab1c730825774 = "popper";
var $97d12055ae9c6ba2$export$ca50aac9f3ba507f = "reference";
var $97d12055ae9c6ba2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $97d12055ae9c6ba2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $97d12055ae9c6ba2$export$b3571188c770cc5a,
        placement + "-" + $97d12055ae9c6ba2$export$bd5df0f255a350f8
    ]);
}, []);
var $97d12055ae9c6ba2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($97d12055ae9c6ba2$export$aec2ce47c367b8c3, [
    $97d12055ae9c6ba2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $97d12055ae9c6ba2$export$b3571188c770cc5a,
        placement + "-" + $97d12055ae9c6ba2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $97d12055ae9c6ba2$export$421679a7c3d56e = "beforeRead";
var $97d12055ae9c6ba2$export$aafa59e2e03f2942 = "read";
var $97d12055ae9c6ba2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $97d12055ae9c6ba2$export$c65e99957a05207c = "beforeMain";
var $97d12055ae9c6ba2$export$f22da7240b7add18 = "main";
var $97d12055ae9c6ba2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $97d12055ae9c6ba2$export$8d4d2d70e7d46032 = "beforeWrite";
var $97d12055ae9c6ba2$export$68d8715fc104d294 = "write";
var $97d12055ae9c6ba2$export$70a6e5159acce2e6 = "afterWrite";
var $97d12055ae9c6ba2$export$d087d3878fdf71d5 = [
    $97d12055ae9c6ba2$export$421679a7c3d56e,
    $97d12055ae9c6ba2$export$aafa59e2e03f2942,
    $97d12055ae9c6ba2$export$6964f6c886723980,
    $97d12055ae9c6ba2$export$c65e99957a05207c,
    $97d12055ae9c6ba2$export$f22da7240b7add18,
    $97d12055ae9c6ba2$export$bab79516f2d662fe,
    $97d12055ae9c6ba2$export$8d4d2d70e7d46032,
    $97d12055ae9c6ba2$export$68d8715fc104d294,
    $97d12055ae9c6ba2$export$70a6e5159acce2e6
];


function $96e8b50851eda0c1$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $96e8b50851eda0c1$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $96e8b50851eda0c1$var$order(modifiers); // order based on phase
    return (0, $97d12055ae9c6ba2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $b3031e739a8d2e60$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $7ef1cb9bb2682e5a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $bd958311c69d9527$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $bd958311c69d9527$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $bd958311c69d9527$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $bd958311c69d9527$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $bd958311c69d9527$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $14c0aa94e6ad7d11$export$45a5e7f76e0caa8d)(reference) ? (0, $3211a4ac796e8f6b$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $3211a4ac796e8f6b$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $3211a4ac796e8f6b$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $96e8b50851eda0c1$export$2e2bcd8739ae039)((0, $7ef1cb9bb2682e5a$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$bd958311c69d9527$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $e8c6908c15a364bf$export$2e2bcd8739ae039)(reference, (0, $ff1341f32f74c890$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $3a30edde69130a9d$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $b3031e739a8d2e60$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$bd958311c69d9527$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $bd958311c69d9527$export$8f7491d57c8f97a9 = /*#__PURE__*/ $bd958311c69d9527$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $44723f91ce6b65d0$var$passive = {
    passive: true
};
function $44723f91ce6b65d0$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $2b900c9ac5215f63$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $44723f91ce6b65d0$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $44723f91ce6b65d0$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $44723f91ce6b65d0$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $44723f91ce6b65d0$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $44723f91ce6b65d0$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $44723f91ce6b65d0$var$effect,
    data: {}
};



function $8d0a457de0ad25dd$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $d0d0c904a806edb6$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $b4f0ebe2caa2491c$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $814654c8311ff0d5$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $8d0a457de0ad25dd$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $d0d0c904a806edb6$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $97d12055ae9c6ba2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $97d12055ae9c6ba2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $97d12055ae9c6ba2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $97d12055ae9c6ba2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $b4f0ebe2caa2491c$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $97d12055ae9c6ba2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $97d12055ae9c6ba2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $01837340a70324f5$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $814654c8311ff0d5$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $01837340a70324f5$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $01837340a70324f5$var$popperOffsets,
    data: {}
};










var $58344dc1545eabd1$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $58344dc1545eabd1$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3e0f6051afd83333$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3e0f6051afd83333$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $58344dc1545eabd1$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $97d12055ae9c6ba2$export$eabcd2c8791e7bf4);
    var sideY = (0, $97d12055ae9c6ba2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $ff1341f32f74c890$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $2b900c9ac5215f63$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $12372a4b94147033$export$2e2bcd8739ae039)(popper);
            if ((0, $6f6aca9f5b7a0a50$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $97d12055ae9c6ba2$export$1e95b668f3b82d) || (placement === (0, $97d12055ae9c6ba2$export$eabcd2c8791e7bf4) || placement === (0, $97d12055ae9c6ba2$export$79ffe56a765070d2)) && variation === (0, $97d12055ae9c6ba2$export$bd5df0f255a350f8)) {
            sideY = (0, $97d12055ae9c6ba2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $97d12055ae9c6ba2$export$eabcd2c8791e7bf4) || (placement === (0, $97d12055ae9c6ba2$export$1e95b668f3b82d) || placement === (0, $97d12055ae9c6ba2$export$40e543e69a8b3fbb)) && variation === (0, $97d12055ae9c6ba2$export$bd5df0f255a350f8)) {
            sideX = (0, $97d12055ae9c6ba2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $58344dc1545eabd1$var$unsetSides);
    var _ref4 = roundOffsets === true ? $58344dc1545eabd1$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $2b900c9ac5215f63$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $58344dc1545eabd1$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $8d0a457de0ad25dd$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $d0d0c904a806edb6$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $58344dc1545eabd1$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $58344dc1545eabd1$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $58344dc1545eabd1$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $58344dc1545eabd1$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $42c23b03017d1dc5$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $14c0aa94e6ad7d11$export$1b3bfaa9684536aa)(element) || !(0, $db93b8f5cf2ace81$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $42c23b03017d1dc5$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $14c0aa94e6ad7d11$export$1b3bfaa9684536aa)(element) || !(0, $db93b8f5cf2ace81$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $42c23b03017d1dc5$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $42c23b03017d1dc5$var$applyStyles,
    effect: $42c23b03017d1dc5$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $119fe3139c5f996a$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $8d0a457de0ad25dd$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $97d12055ae9c6ba2$export$eabcd2c8791e7bf4),
        (0, $97d12055ae9c6ba2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $97d12055ae9c6ba2$export$eabcd2c8791e7bf4),
        (0, $97d12055ae9c6ba2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $119fe3139c5f996a$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $97d12055ae9c6ba2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $119fe3139c5f996a$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $119fe3139c5f996a$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $119fe3139c5f996a$var$offset
};


var $1df2ce872d697c8c$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $1df2ce872d697c8c$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $1df2ce872d697c8c$var$hash[matched];
    });
}



var $b992c12384c36574$var$hash = {
    start: "end",
    end: "start"
};
function $b992c12384c36574$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $b992c12384c36574$var$hash[matched];
    });
}







function $bc920cb369b87e9d$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $2b900c9ac5215f63$export$2e2bcd8739ae039)(element);
    var html = (0, $12372a4b94147033$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $33f5c04daf4a337e$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $4a303ba9ff26a37b$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $213b3636b633ed11$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $12372a4b94147033$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $68e22fd0a7ea67aa$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3e0f6051afd83333$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3e0f6051afd83333$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $4a303ba9ff26a37b$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $6f6aca9f5b7a0a50$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3e0f6051afd83333$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $44e4a92db82004e2$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $14c0aa94e6ad7d11$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $a8b09078eded2af4$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $2c5330b8f0fd31d4$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $08ffec67e478eea1$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $2c5330b8f0fd31d4$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $97d12055ae9c6ba2$export$d7b7311ec04a3e8f) ? (0, $a8b09078eded2af4$export$2e2bcd8739ae039)((0, $bc920cb369b87e9d$export$2e2bcd8739ae039)(element, strategy)) : (0, $14c0aa94e6ad7d11$export$45a5e7f76e0caa8d)(clippingParent) ? $2c5330b8f0fd31d4$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $a8b09078eded2af4$export$2e2bcd8739ae039)((0, $213b3636b633ed11$export$2e2bcd8739ae039)((0, $12372a4b94147033$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $2c5330b8f0fd31d4$var$getClippingParents(element) {
    var clippingParents = (0, $3211a4ac796e8f6b$export$2e2bcd8739ae039)((0, $a35acfbfcb1a9833$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $6f6aca9f5b7a0a50$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $14c0aa94e6ad7d11$export$1b3bfaa9684536aa)(element) ? (0, $ff1341f32f74c890$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $14c0aa94e6ad7d11$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $14c0aa94e6ad7d11$export$45a5e7f76e0caa8d)(clippingParent) && (0, $44e4a92db82004e2$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $db93b8f5cf2ace81$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $2c5330b8f0fd31d4$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $2c5330b8f0fd31d4$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $2c5330b8f0fd31d4$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3e0f6051afd83333$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3e0f6051afd83333$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3e0f6051afd83333$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3e0f6051afd83333$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $2c5330b8f0fd31d4$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $1f9facfeef2189c6$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $346cdf87331a823c$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $1f9facfeef2189c6$export$2e2bcd8739ae039)(), paddingObject);
}


function $3c5bf7f6d8cd6612$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $bba86fbb8f0ab0e2$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $97d12055ae9c6ba2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $97d12055ae9c6ba2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $97d12055ae9c6ba2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $346cdf87331a823c$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $3c5bf7f6d8cd6612$export$2e2bcd8739ae039)(padding, (0, $97d12055ae9c6ba2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $97d12055ae9c6ba2$export$ae5ab1c730825774) ? (0, $97d12055ae9c6ba2$export$ca50aac9f3ba507f) : (0, $97d12055ae9c6ba2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $2c5330b8f0fd31d4$export$2e2bcd8739ae039)((0, $14c0aa94e6ad7d11$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $12372a4b94147033$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $08ffec67e478eea1$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $814654c8311ff0d5$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $a8b09078eded2af4$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $97d12055ae9c6ba2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $97d12055ae9c6ba2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $97d12055ae9c6ba2$export$79ffe56a765070d2),
                (0, $97d12055ae9c6ba2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $97d12055ae9c6ba2$export$1e95b668f3b82d),
                (0, $97d12055ae9c6ba2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $e92549c394496443$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $97d12055ae9c6ba2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $d0d0c904a806edb6$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $97d12055ae9c6ba2$export$368f9a87e87fa4e1) : (0, $97d12055ae9c6ba2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $d0d0c904a806edb6$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $97d12055ae9c6ba2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $bba86fbb8f0ab0e2$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $8d0a457de0ad25dd$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $d0b5c665a7c8b269$var$getExpandedFallbackPlacements(placement) {
    if ((0, $8d0a457de0ad25dd$export$2e2bcd8739ae039)(placement) === (0, $97d12055ae9c6ba2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $1df2ce872d697c8c$export$2e2bcd8739ae039)(placement);
    return [
        (0, $b992c12384c36574$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $b992c12384c36574$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $d0b5c665a7c8b269$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $8d0a457de0ad25dd$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $1df2ce872d697c8c$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $d0b5c665a7c8b269$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $8d0a457de0ad25dd$export$2e2bcd8739ae039)(placement) === (0, $97d12055ae9c6ba2$export$dfb5619354ba860) ? (0, $e92549c394496443$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $8d0a457de0ad25dd$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $d0d0c904a806edb6$export$2e2bcd8739ae039)(placement) === (0, $97d12055ae9c6ba2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $97d12055ae9c6ba2$export$1e95b668f3b82d),
            (0, $97d12055ae9c6ba2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $bba86fbb8f0ab0e2$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $97d12055ae9c6ba2$export$79ffe56a765070d2) : (0, $97d12055ae9c6ba2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $97d12055ae9c6ba2$export$40e543e69a8b3fbb) : (0, $97d12055ae9c6ba2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $1df2ce872d697c8c$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $1df2ce872d697c8c$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $d0b5c665a7c8b269$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $d0b5c665a7c8b269$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $4be9641278134366$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $b7d7303d46153e3f$export$f28d906d67a997f3(min, value, max) {
    return (0, $3e0f6051afd83333$export$8960430cfd85939f)(min, (0, $3e0f6051afd83333$export$96ec731ed4dcb222)(value, max));
}
function $b7d7303d46153e3f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b7d7303d46153e3f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $9e47e5d937b1fe90$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $bba86fbb8f0ab0e2$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $8d0a457de0ad25dd$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $d0d0c904a806edb6$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $b4f0ebe2caa2491c$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $4be9641278134366$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $97d12055ae9c6ba2$export$1e95b668f3b82d) : (0, $97d12055ae9c6ba2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $97d12055ae9c6ba2$export$40e543e69a8b3fbb) : (0, $97d12055ae9c6ba2$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $97d12055ae9c6ba2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $97d12055ae9c6ba2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $3a30edde69130a9d$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $1f9facfeef2189c6$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $b7d7303d46153e3f$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $ff1341f32f74c890$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $b7d7303d46153e3f$export$f28d906d67a997f3)(tether ? (0, $3e0f6051afd83333$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3e0f6051afd83333$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $97d12055ae9c6ba2$export$1e95b668f3b82d) : (0, $97d12055ae9c6ba2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $97d12055ae9c6ba2$export$40e543e69a8b3fbb) : (0, $97d12055ae9c6ba2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $97d12055ae9c6ba2$export$1e95b668f3b82d),
            (0, $97d12055ae9c6ba2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $b7d7303d46153e3f$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $b7d7303d46153e3f$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9e47e5d937b1fe90$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $9e47e5d937b1fe90$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $2e45db0e77e277b0$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $346cdf87331a823c$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $3c5bf7f6d8cd6612$export$2e2bcd8739ae039)(padding, (0, $97d12055ae9c6ba2$export$aec2ce47c367b8c3)));
};
function $2e45db0e77e277b0$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $8d0a457de0ad25dd$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $b4f0ebe2caa2491c$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $97d12055ae9c6ba2$export$eabcd2c8791e7bf4),
        (0, $97d12055ae9c6ba2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $2e45db0e77e277b0$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $3a30edde69130a9d$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $97d12055ae9c6ba2$export$1e95b668f3b82d) : (0, $97d12055ae9c6ba2$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $97d12055ae9c6ba2$export$40e543e69a8b3fbb) : (0, $97d12055ae9c6ba2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $ff1341f32f74c890$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $b7d7303d46153e3f$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $2e45db0e77e277b0$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $44e4a92db82004e2$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $2e45db0e77e277b0$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $2e45db0e77e277b0$var$arrow,
    effect: $2e45db0e77e277b0$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $5a814660cd38e2d0$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $5a814660cd38e2d0$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $97d12055ae9c6ba2$export$1e95b668f3b82d),
        (0, $97d12055ae9c6ba2$export$79ffe56a765070d2),
        (0, $97d12055ae9c6ba2$export$40e543e69a8b3fbb),
        (0, $97d12055ae9c6ba2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $5a814660cd38e2d0$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $bba86fbb8f0ab0e2$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $bba86fbb8f0ab0e2$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $5a814660cd38e2d0$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $5a814660cd38e2d0$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $5a814660cd38e2d0$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $5a814660cd38e2d0$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $5a814660cd38e2d0$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $5a814660cd38e2d0$var$hide
};




var $50c8dae517b500f3$export$d34966752335dd47 = [
    (0, $44723f91ce6b65d0$export$2e2bcd8739ae039),
    (0, $01837340a70324f5$export$2e2bcd8739ae039),
    (0, $58344dc1545eabd1$export$2e2bcd8739ae039),
    (0, $42c23b03017d1dc5$export$2e2bcd8739ae039),
    (0, $119fe3139c5f996a$export$2e2bcd8739ae039),
    (0, $d0b5c665a7c8b269$export$2e2bcd8739ae039),
    (0, $9e47e5d937b1fe90$export$2e2bcd8739ae039),
    (0, $2e45db0e77e277b0$export$2e2bcd8739ae039),
    (0, $5a814660cd38e2d0$export$2e2bcd8739ae039)
];
var $50c8dae517b500f3$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $bd958311c69d9527$export$ed5e13716264f202)({
    defaultModifiers: $50c8dae517b500f3$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $iV85C = parcelRequire("iV85C");

var $1T1QG = parcelRequire("1T1QG");




var $3Py8h = parcelRequire("3Py8h");
"use client";
function $23736008cbe3d7fa$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $23736008cbe3d7fa$export$602eac185826482c = /*#__PURE__*/ $1T1QG.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $1T1QG.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $d2fee4866c2743fb$export$2e2bcd8739ae039)(/*#__PURE__*/ $1T1QG.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $ac1861e6d86aa648$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($23736008cbe3d7fa$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $ac1861e6d86aa648$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $2c32707bf1e7228d$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $2c32707bf1e7228d$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $1T1QG.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $1T1QG.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $3Py8h.jsx)($1T1QG.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $3Py8h.jsx)($1T1QG.Fragment, {
        children: mountNode ? /*#__PURE__*/ $27f1df944e3d0485$exports.createPortal(children, mountNode) : mountNode
    });
});



var $iNQht = parcelRequire("iNQht");
const $25e98a8fa03778e5$var$GLOBAL_CLASS_PREFIX = "base";
function $25e98a8fa03778e5$var$buildStateClass(state) {
    return `${$25e98a8fa03778e5$var$GLOBAL_CLASS_PREFIX}--${state}`;
}
function $25e98a8fa03778e5$var$buildSlotClass(componentName, slot) {
    return `${$25e98a8fa03778e5$var$GLOBAL_CLASS_PREFIX}-${componentName}-${slot}`;
}
function $25e98a8fa03778e5$export$1d132570e11858b0(componentName, slot) {
    const globalStateClass = (0, $iNQht.globalStateClasses)[slot];
    return globalStateClass ? $25e98a8fa03778e5$var$buildStateClass(globalStateClass) : $25e98a8fa03778e5$var$buildSlotClass(componentName, slot);
}
function $25e98a8fa03778e5$export$34c0130b1f3e8ae3(slot) {
    return (0, $iNQht.globalStateClasses)[slot] !== undefined;
}



function $532a5e5f2bf0d4d2$export$de4f15803c389669(componentName, slots) {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $25e98a8fa03778e5$export$1d132570e11858b0)(componentName, slot);
    });
    return result;
}


const $9aa332133aabeede$var$COMPONENT_NAME = "Popper";
function $9aa332133aabeede$export$1b69b6cd0fa638a1(slot) {
    return (0, $25e98a8fa03778e5$export$1d132570e11858b0)($9aa332133aabeede$var$COMPONENT_NAME, slot);
}
const $9aa332133aabeede$export$b6aa214021e734b0 = (0, $532a5e5f2bf0d4d2$export$de4f15803c389669)($9aa332133aabeede$var$COMPONENT_NAME, [
    "root"
]);



var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");


var $ajTRS = parcelRequire("ajTRS");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $96ba78417123a6d2$export$e28348cc2430497(element) {
    return typeof element === "string";
}


function $c2acd4b78787ea6e$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $96ba78417123a6d2$export$e28348cc2430497)(elementType)) return otherProps;
    return (0, $ajTRS.default)({}, otherProps, {
        ownerState: (0, $ajTRS.default)({}, otherProps.ownerState, ownerState)
    });
}



var $ajTRS = parcelRequire("ajTRS");

var $aVXbR = parcelRequire("aVXbR");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $f63967d7c4f59bd9$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $acdcbd7aa44793a6$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $461e8b202b44feaa$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $aVXbR.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $ajTRS.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $ajTRS.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $f63967d7c4f59bd9$export$24d5698b57eff81c)((0, $ajTRS.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $acdcbd7aa44793a6$export$2ac0fa4d3a39be45)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $acdcbd7aa44793a6$export$2ac0fa4d3a39be45)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $aVXbR.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $ajTRS.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $ajTRS.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $67b423c9d0747a9c$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}


"use client";
const $3b38c2c568b5248d$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $3b38c2c568b5248d$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $iXdVf.default)(parameters, $3b38c2c568b5248d$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $67b423c9d0747a9c$export$308c24034cde71de)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $461e8b202b44feaa$export$b01d1e419b049226)((0, $ajTRS.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $d2fee4866c2743fb$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $c2acd4b78787ea6e$export$b089efb01a7bdf50)(elementType, (0, $ajTRS.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}



var $1T1QG = parcelRequire("1T1QG");

var $3Py8h = parcelRequire("3Py8h");
"use client";
const $a7d68263e0259ec2$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $a7d68263e0259ec2$var$ClassNameConfiguratorContext = /*#__PURE__*/ $1T1QG.createContext($a7d68263e0259ec2$var$defaultContextValue);
function $a7d68263e0259ec2$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $1T1QG.useContext($a7d68263e0259ec2$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $a7d68263e0259ec2$export$2efe1f5e70172ae9(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $1T1QG.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($a7d68263e0259ec2$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $ad18a8335fd555c9$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $ad18a8335fd555c9$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $ad18a8335fd555c9$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $ad18a8335fd555c9$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $ad18a8335fd555c9$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $ad18a8335fd555c9$var$isVirtualElement(element) {
    return !$ad18a8335fd555c9$var$isHTMLElement(element);
}
const $ad18a8335fd555c9$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $a7d68263e0259ec2$export$b0f7603cd2f9ee15)((0, $9aa332133aabeede$export$1b69b6cd0fa638a1)));
};
const $ad18a8335fd555c9$var$defaultPopperOptions = {};
const $ad18a8335fd555c9$var$PopperTooltip = /*#__PURE__*/ $1T1QG.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $iXdVf.default)(props, $ad18a8335fd555c9$var$_excluded);
    const tooltipRef = $1T1QG.useRef(null);
    const ownRef = (0, $d2fee4866c2743fb$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $1T1QG.useRef(null);
    const handlePopperRef = (0, $d2fee4866c2743fb$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $1T1QG.useRef(handlePopperRef);
    (0, $ac1861e6d86aa648$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $1T1QG.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $ad18a8335fd555c9$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $1T1QG.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $1T1QG.useState($ad18a8335fd555c9$var$resolveAnchorEl(anchorEl));
    $1T1QG.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $1T1QG.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($ad18a8335fd555c9$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $ac1861e6d86aa648$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $50c8dae517b500f3$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $ajTRS.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $ad18a8335fd555c9$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $3b38c2c568b5248d$export$1e5c9e6e4e15efe3)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)(Root, (0, $ajTRS.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */ const $ad18a8335fd555c9$export$badac9ada3a0bdf9 = /*#__PURE__*/ $1T1QG.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $ad18a8335fd555c9$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $iXdVf.default)(props, $ad18a8335fd555c9$var$_excluded2);
    const [exited, setExited] = $1T1QG.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $ad18a8335fd555c9$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $ad18a8335fd555c9$var$isHTMLElement(resolvedAnchorEl) ? (0, $743613eeafeadd3a$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $743613eeafeadd3a$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $23736008cbe3d7fa$export$602eac185826482c), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($ad18a8335fd555c9$var$PopperTooltip, (0, $ajTRS.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $ajTRS.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});



var $6UrSi = parcelRequire("6UrSi");



var $1T1QG = parcelRequire("1T1QG");

var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");

var $3Py8h = parcelRequire("3Py8h");
"use client";
const $9523926f49e29683$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $9523926f49e29683$var$PopperRoot = (0, $npagc.default)((0, $ad18a8335fd555c9$export$badac9ada3a0bdf9), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $9523926f49e29683$var$Popper = /*#__PURE__*/ $1T1QG.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, $6UrSi.default)();
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $iXdVf.default)(props, $9523926f49e29683$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $ajTRS.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($9523926f49e29683$var$PopperRoot, (0, $ajTRS.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $9523926f49e29683$export$2e2bcd8739ae039 = $9523926f49e29683$var$Popper;



var $1T1QG = parcelRequire("1T1QG");
const $60ef78cc62d0ba44$var$MoovyCardMenu = ({ open: open, setOpen: setOpen, anchorRef: anchorRef, menuItems: menuItems })=>{
    const handleClose = (event, onMenuItemClick)=>{
        if (anchorRef.current && anchorRef.current.contains(event.target)) return;
        setOpen(false);
        if (onMenuItemClick) {
            event.preventDefault();
            event.stopPropagation();
            onMenuItemClick();
        }
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === "Escape") setOpen(false);
    };
    const prevOpen = (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).useRef(open);
    (0, $1T1QG.useEffect)(()=>{
        if (prevOpen.current === true && open === false) anchorRef.current.focus();
        prevOpen.current = open;
    }, [
        open
    ]);
    const isMenu = menuItems && menuItems.length > 0;
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $9523926f49e29683$export$2e2bcd8739ae039), {
        open: open,
        anchorEl: anchorRef.current,
        role: undefined,
        placement: "bottom-start",
        transition: true,
        disablePortal: true,
        style: {
            zIndex: 1
        },
        children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $e236f531d361181f$export$2e2bcd8739ae039), {
                ...TransitionProps,
                style: {
                    transformOrigin: placement === "bottom-start" ? "left top" : "left bottom"
                },
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $0a163fcc25046a25$export$2e2bcd8739ae039), {
                    children: isMenu && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $1663c797508dc868$export$58385c17fee43f89), {
                        onClickAway: handleClose,
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $0c6bdc89c1f59767$export$2e2bcd8739ae039), {
                            autoFocusItem: open,
                            id: "composition-menu",
                            "aria-labelledby": "composition-button",
                            onKeyDown: handleListKeyDown,
                            children: menuItems.map((item, index)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $450c65ee2dafa292$export$2e2bcd8739ae039), {
                                    onClick: (event)=>handleClose(event, item.onClick),
                                    children: item.itemText
                                }, index))
                        })
                    })
                })
            })
    });
};
var $60ef78cc62d0ba44$export$2e2bcd8739ae039 = $60ef78cc62d0ba44$var$MoovyCardMenu;



var $1T1QG = parcelRequire("1T1QG");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");
parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $82c4d32ecd502239$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");



var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $8931c306c2f5b93b$export$ffd560f22c0ecf04(slot) {
    return (0, $iNQht.default)("MuiAvatar", slot);
}
const $8931c306c2f5b93b$var$avatarClasses = (0, $dfswM.default)("MuiAvatar", [
    "root",
    "colorDefault",
    "circular",
    "rounded",
    "square",
    "img",
    "fallback"
]);
var $8931c306c2f5b93b$export$2e2bcd8739ae039 = $8931c306c2f5b93b$var$avatarClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $8cb92c640591b070$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $8cb92c640591b070$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            colorDefault && "colorDefault"
        ],
        img: [
            "img"
        ],
        fallback: [
            "fallback"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $8931c306c2f5b93b$export$ffd560f22c0ecf04), classes);
};
const $8cb92c640591b070$var$AvatarRoot = (0, $npagc.default)("div", {
    name: "MuiAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme })=>({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: "50%",
        overflow: "hidden",
        userSelect: "none",
        variants: [
            {
                props: {
                    variant: "rounded"
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: "square"
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: (0, $ajTRS.default)({
                    color: (theme.vars || theme).palette.background.default
                }, theme.vars ? {
                    backgroundColor: theme.vars.palette.Avatar.defaultBg
                } : (0, $ajTRS.default)({
                    backgroundColor: theme.palette.grey[400]
                }, theme.applyStyles("dark", {
                    backgroundColor: theme.palette.grey[600]
                })))
            }
        ]
    }));
const $8cb92c640591b070$var$AvatarImg = (0, $npagc.default)("img", {
    name: "MuiAvatar",
    slot: "Img",
    overridesResolver: (props, styles)=>styles.img
})({
    width: "100%",
    height: "100%",
    textAlign: "center",
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: "cover",
    // Hide alt text.
    color: "transparent",
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $8cb92c640591b070$var$AvatarFallback = (0, $npagc.default)((0, $82c4d32ecd502239$export$2e2bcd8739ae039), {
    name: "MuiAvatar",
    slot: "Fallback",
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: "75%",
    height: "75%"
});
function $8cb92c640591b070$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $1T1QG.useState(false);
    $1T1QG.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded("error");
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $8cb92c640591b070$var$Avatar = /*#__PURE__*/ $1T1QG.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiAvatar"
    });
    const { alt: alt, children: childrenProp, className: className, component: component = "div", imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = "circular" } = props, other = (0, $iXdVf.default)(props, $8cb92c640591b070$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $8cb92c640591b070$var$useLoaded((0, $ajTRS.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== "error";
    const ownerState = (0, $ajTRS.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $8cb92c640591b070$var$useUtilityClasses(ownerState);
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $3Py8h.jsx)($8cb92c640591b070$var$AvatarImg, (0, $ajTRS.default)({
        alt: alt,
        srcSet: srcSet,
        src: src,
        sizes: sizes,
        ownerState: ownerState,
        className: classes.img
    }, imgProps));
    else if (childrenProp != null && childrenProp !== "" && typeof childrenProp !== "boolean") children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $3Py8h.jsx)($8cb92c640591b070$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)($8cb92c640591b070$var$AvatarRoot, (0, $ajTRS.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $aVXbR.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $8cb92c640591b070$export$2e2bcd8739ae039 = $8cb92c640591b070$var$Avatar;



var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");


var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $9936256d85589b79$export$f3b76d2cce458caa(slot) {
    return (0, $iNQht.default)("MuiCard", slot);
}
const $9936256d85589b79$var$cardClasses = (0, $dfswM.default)("MuiCard", [
    "root"
]);
var $9936256d85589b79$export$2e2bcd8739ae039 = $9936256d85589b79$var$cardClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $8e83154d5f3d7c64$var$_excluded = [
    "className",
    "raised"
];
const $8e83154d5f3d7c64$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $9936256d85589b79$export$f3b76d2cce458caa), classes);
};
const $8e83154d5f3d7c64$var$CardRoot = (0, $npagc.default)((0, $0a163fcc25046a25$export$2e2bcd8739ae039), {
    name: "MuiCard",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: "hidden"
    };
});
const $8e83154d5f3d7c64$var$Card = /*#__PURE__*/ $1T1QG.forwardRef(function Card(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiCard"
    });
    const { className: className, raised: raised = false } = props, other = (0, $iXdVf.default)(props, $8e83154d5f3d7c64$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        raised: raised
    });
    const classes = $8e83154d5f3d7c64$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($8e83154d5f3d7c64$var$CardRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $8e83154d5f3d7c64$export$2e2bcd8739ae039 = $8e83154d5f3d7c64$var$Card;



var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $70a3daf2ddf19800$export$2a5c27c211442e3c(slot) {
    return (0, $iNQht.default)("MuiCardActions", slot);
}
const $70a3daf2ddf19800$var$cardActionsClasses = (0, $dfswM.default)("MuiCardActions", [
    "root",
    "spacing"
]);
var $70a3daf2ddf19800$export$2e2bcd8739ae039 = $70a3daf2ddf19800$var$cardActionsClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $2084255b952e7030$var$_excluded = [
    "disableSpacing",
    "className"
];
const $2084255b952e7030$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $70a3daf2ddf19800$export$2a5c27c211442e3c), classes);
};
const $2084255b952e7030$var$CardActionsRoot = (0, $npagc.default)("div", {
    name: "MuiCardActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        display: "flex",
        alignItems: "center",
        padding: 8
    }, !ownerState.disableSpacing && {
        "& > :not(style) ~ :not(style)": {
            marginLeft: 8
        }
    }));
const $2084255b952e7030$var$CardActions = /*#__PURE__*/ $1T1QG.forwardRef(function CardActions(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiCardActions"
    });
    const { disableSpacing: disableSpacing = false, className: className } = props, other = (0, $iXdVf.default)(props, $2084255b952e7030$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $2084255b952e7030$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($2084255b952e7030$var$CardActionsRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $2084255b952e7030$export$2e2bcd8739ae039 = $2084255b952e7030$var$CardActions;



var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $b558da519153fa50$export$964336739a8c7119(slot) {
    return (0, $iNQht.default)("MuiCardContent", slot);
}
const $b558da519153fa50$var$cardContentClasses = (0, $dfswM.default)("MuiCardContent", [
    "root"
]);
var $b558da519153fa50$export$2e2bcd8739ae039 = $b558da519153fa50$var$cardContentClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $faeb0a5651a5f4e9$var$_excluded = [
    "className",
    "component"
];
const $faeb0a5651a5f4e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $b558da519153fa50$export$964336739a8c7119), classes);
};
const $faeb0a5651a5f4e9$var$CardContentRoot = (0, $npagc.default)("div", {
    name: "MuiCardContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        "&:last-child": {
            paddingBottom: 24
        }
    };
});
const $faeb0a5651a5f4e9$var$CardContent = /*#__PURE__*/ $1T1QG.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiCardContent"
    });
    const { className: className, component: component = "div" } = props, other = (0, $iXdVf.default)(props, $faeb0a5651a5f4e9$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        component: component
    });
    const classes = $faeb0a5651a5f4e9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($faeb0a5651a5f4e9$var$CardContentRoot, (0, $ajTRS.default)({
        as: component,
        className: (0, $aVXbR.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $faeb0a5651a5f4e9$export$2e2bcd8739ae039 = $faeb0a5651a5f4e9$var$CardContent;



var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");


var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $4259b2a36885c512$export$f54c8b0d04b67946(slot) {
    return (0, $iNQht.default)("MuiCardHeader", slot);
}
const $4259b2a36885c512$var$cardHeaderClasses = (0, $dfswM.default)("MuiCardHeader", [
    "root",
    "avatar",
    "action",
    "content",
    "title",
    "subheader"
]);
var $4259b2a36885c512$export$2e2bcd8739ae039 = $4259b2a36885c512$var$cardHeaderClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $b6406c4c4f8cccba$var$_excluded = [
    "action",
    "avatar",
    "className",
    "component",
    "disableTypography",
    "subheader",
    "subheaderTypographyProps",
    "title",
    "titleTypographyProps"
];
const $b6406c4c4f8cccba$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        avatar: [
            "avatar"
        ],
        action: [
            "action"
        ],
        content: [
            "content"
        ],
        title: [
            "title"
        ],
        subheader: [
            "subheader"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $4259b2a36885c512$export$f54c8b0d04b67946), classes);
};
const $b6406c4c4f8cccba$var$CardHeaderRoot = (0, $npagc.default)("div", {
    name: "MuiCardHeader",
    slot: "Root",
    overridesResolver: (props, styles)=>(0, $ajTRS.default)({
            [`& .${(0, $4259b2a36885c512$export$2e2bcd8739ae039).title}`]: styles.title,
            [`& .${(0, $4259b2a36885c512$export$2e2bcd8739ae039).subheader}`]: styles.subheader
        }, styles.root)
})({
    display: "flex",
    alignItems: "center",
    padding: 16
});
const $b6406c4c4f8cccba$var$CardHeaderAvatar = (0, $npagc.default)("div", {
    name: "MuiCardHeader",
    slot: "Avatar",
    overridesResolver: (props, styles)=>styles.avatar
})({
    display: "flex",
    flex: "0 0 auto",
    marginRight: 16
});
const $b6406c4c4f8cccba$var$CardHeaderAction = (0, $npagc.default)("div", {
    name: "MuiCardHeader",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    flex: "0 0 auto",
    alignSelf: "flex-start",
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
const $b6406c4c4f8cccba$var$CardHeaderContent = (0, $npagc.default)("div", {
    name: "MuiCardHeader",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})({
    flex: "1 1 auto"
});
const $b6406c4c4f8cccba$var$CardHeader = /*#__PURE__*/ $1T1QG.forwardRef(function CardHeader(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiCardHeader"
    });
    const { action: action, avatar: avatar, className: className, component: component = "div", disableTypography: disableTypography = false, subheader: subheaderProp, subheaderTypographyProps: subheaderTypographyProps, title: titleProp, titleTypographyProps: titleTypographyProps } = props, other = (0, $iXdVf.default)(props, $b6406c4c4f8cccba$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        component: component,
        disableTypography: disableTypography
    });
    const classes = $b6406c4c4f8cccba$var$useUtilityClasses(ownerState);
    let title = titleProp;
    if (title != null && title.type !== (0, $a386176d6ca21602$export$2e2bcd8739ae039) && !disableTypography) title = /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a386176d6ca21602$export$2e2bcd8739ae039), (0, $ajTRS.default)({
        variant: avatar ? "body2" : "h5",
        className: classes.title,
        component: "span",
        display: "block"
    }, titleTypographyProps, {
        children: title
    }));
    let subheader = subheaderProp;
    if (subheader != null && subheader.type !== (0, $a386176d6ca21602$export$2e2bcd8739ae039) && !disableTypography) subheader = /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a386176d6ca21602$export$2e2bcd8739ae039), (0, $ajTRS.default)({
        variant: avatar ? "body2" : "body1",
        className: classes.subheader,
        color: "text.secondary",
        component: "span",
        display: "block"
    }, subheaderTypographyProps, {
        children: subheader
    }));
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($b6406c4c4f8cccba$var$CardHeaderRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        as: component,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            avatar && /*#__PURE__*/ (0, $3Py8h.jsx)($b6406c4c4f8cccba$var$CardHeaderAvatar, {
                className: classes.avatar,
                ownerState: ownerState,
                children: avatar
            }),
            /*#__PURE__*/ (0, $3Py8h.jsxs)($b6406c4c4f8cccba$var$CardHeaderContent, {
                className: classes.content,
                ownerState: ownerState,
                children: [
                    title,
                    subheader
                ]
            }),
            action && /*#__PURE__*/ (0, $3Py8h.jsx)($b6406c4c4f8cccba$var$CardHeaderAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            })
        ]
    }));
});
var $b6406c4c4f8cccba$export$2e2bcd8739ae039 = $b6406c4c4f8cccba$var$CardHeader;



var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");

var $aVXbR = parcelRequire("aVXbR");




var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $eN12j = parcelRequire("eN12j");




var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $77623b1d9fcea402$export$5162da8f798e0959(slot) {
    return (0, $iNQht.default)("MuiCollapse", slot);
}
const $77623b1d9fcea402$var$collapseClasses = (0, $dfswM.default)("MuiCollapse", [
    "root",
    "horizontal",
    "vertical",
    "entered",
    "hidden",
    "wrapper",
    "wrapperInner"
]);
var $77623b1d9fcea402$export$2e2bcd8739ae039 = $77623b1d9fcea402$var$collapseClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $0eaedcef72a51b3a$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $0eaedcef72a51b3a$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${orientation}`
        ],
        entered: [
            "entered"
        ],
        hidden: [
            "hidden"
        ],
        wrapper: [
            "wrapper",
            `${orientation}`
        ],
        wrapperInner: [
            "wrapperInner",
            `${orientation}`
        ]
    };
    return (0, $iV85C.default)(slots, (0, $77623b1d9fcea402$export$5162da8f798e0959), classes);
};
const $0eaedcef72a51b3a$var$CollapseRoot = (0, $npagc.default)("div", {
    name: "MuiCollapse",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === "entered" && styles.entered,
            ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        height: 0,
        overflow: "hidden",
        transition: theme.transitions.create("height")
    }, ownerState.orientation === "horizontal" && {
        height: "auto",
        width: 0,
        transition: theme.transitions.create("width")
    }, ownerState.state === "entered" && (0, $ajTRS.default)({
        height: "auto",
        overflow: "visible"
    }, ownerState.orientation === "horizontal" && {
        width: "auto"
    }), ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && {
        visibility: "hidden"
    }));
const $0eaedcef72a51b3a$var$CollapseWrapper = (0, $npagc.default)("div", {
    name: "MuiCollapse",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: "flex",
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
const $0eaedcef72a51b3a$var$CollapseWrapperInner = (0, $npagc.default)("div", {
    name: "MuiCollapse",
    slot: "WrapperInner",
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $0eaedcef72a51b3a$var$Collapse = /*#__PURE__*/ $1T1QG.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiCollapse"
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = "0px", component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = "vertical", style: style, timeout: timeout = (0, $eN12j.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $97e45c35ce24099f$export$2e2bcd8739ae039) } = props, other = (0, $iXdVf.default)(props, $0eaedcef72a51b3a$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $0eaedcef72a51b3a$var$useUtilityClasses(ownerState);
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const timer = (0, $b17443dc4e529ae6$export$2e2bcd8739ae039)();
    const wrapperRef = $1T1QG.useRef(null);
    const autoTransitionDuration = $1T1QG.useRef();
    const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === "horizontal";
    const size = isHorizontal ? "width" : "height";
    const nodeRef = $1T1QG.useRef(null);
    const handleRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? "clientWidth" : "clientHeight"] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = "absolute";
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = "";
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $3c14342afe4d3400$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        if (timeout === "auto") {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $3c14342afe4d3400$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        if (timeout === "auto") {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)(TransitionComponent, (0, $ajTRS.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $3Py8h.jsx)($0eaedcef72a51b3a$var$CollapseRoot, (0, $ajTRS.default)({
                as: component,
                className: (0, $aVXbR.default)(classes.root, className, {
                    "entered": classes.entered,
                    "exited": !inProp && collapsedSize === "0px" && classes.hidden
                }[state]),
                style: (0, $ajTRS.default)({
                    [isHorizontal ? "minWidth" : "minHeight"]: collapsedSize
                }, style),
                ownerState: (0, $ajTRS.default)({}, ownerState, {
                    state: state
                }),
                ref: handleRef
            }, childProps, {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)($0eaedcef72a51b3a$var$CollapseWrapper, {
                    ownerState: (0, $ajTRS.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)($0eaedcef72a51b3a$var$CollapseWrapperInner, {
                        ownerState: (0, $ajTRS.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$0eaedcef72a51b3a$var$Collapse.muiSupportAuto = true;
var $0eaedcef72a51b3a$export$2e2bcd8739ae039 = $0eaedcef72a51b3a$var$Collapse;


var $c27564b4f3f6c249$exports = {};
"use strict";
"use client";
var $51a51f6e7d5620b8$exports = {};
function $51a51f6e7d5620b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$51a51f6e7d5620b8$exports = $51a51f6e7d5620b8$var$_interopRequireDefault, $51a51f6e7d5620b8$exports.__esModule = true, $51a51f6e7d5620b8$exports["default"] = $51a51f6e7d5620b8$exports;


Object.defineProperty($c27564b4f3f6c249$exports, "__esModule", {
    value: true
});
$c27564b4f3f6c249$exports.default = void 0;

var $c27564b4f3f6c249$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $c27564b4f3f6c249$var$_default = $c27564b4f3f6c249$exports.default = (0, $c27564b4f3f6c249$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");



var $3Py8h = parcelRequire("3Py8h");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $uu5Ws = parcelRequire("uu5Ws");

var $iV85C = parcelRequire("iV85C");

var $7Etkp = parcelRequire("7Etkp");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");


var $5wtOU = parcelRequire("5wtOU");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $6b5595cabcfe662d$export$5a6f9035944c8119(slot) {
    return (0, $iNQht.default)("MuiButton", slot);
}
const $6b5595cabcfe662d$var$buttonClasses = (0, $dfswM.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $6b5595cabcfe662d$export$2e2bcd8739ae039 = $6b5595cabcfe662d$var$buttonClasses;



var $1T1QG = parcelRequire("1T1QG");
/**
 * @ignore - internal component.
 */ const $5c1a9471ae395620$var$ButtonGroupContext = /*#__PURE__*/ $1T1QG.createContext({});
var $5c1a9471ae395620$export$2e2bcd8739ae039 = $5c1a9471ae395620$var$ButtonGroupContext;



var $1T1QG = parcelRequire("1T1QG");
/**
 * @ignore - internal component.
 */ const $56264f6f0db29c76$var$ButtonGroupButtonContext = /*#__PURE__*/ $1T1QG.createContext(undefined);
var $56264f6f0db29c76$export$2e2bcd8739ae039 = $56264f6f0db29c76$var$ButtonGroupButtonContext;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $c8008865d6db946f$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $c8008865d6db946f$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $5wtOU.default)(color)}`,
            `size${(0, $5wtOU.default)(size)}`,
            `${variant}Size${(0, $5wtOU.default)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $5wtOU.default)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $5wtOU.default)(size)}`
        ]
    };
    const composedClasses = (0, $iV85C.default)(slots, (0, $6b5595cabcfe662d$export$5a6f9035944c8119), classes);
    return (0, $ajTRS.default)({}, classes, composedClasses);
};
const $c8008865d6db946f$var$commonIconStyles = (ownerState)=>(0, $ajTRS.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $c8008865d6db946f$var$ButtonRoot = (0, $npagc.default)((0, $ecc40a2d226ef234$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $npagc.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $5wtOU.default)(ownerState.color)}`],
            styles[`size${(0, $5wtOU.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $5wtOU.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $ajTRS.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $ajTRS.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7Etkp.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7Etkp.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7Etkp.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $ajTRS.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $6b5595cabcfe662d$export$2e2bcd8739ae039).focusVisible}`]: (0, $ajTRS.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $6b5595cabcfe662d$export$2e2bcd8739ae039).disabled}`]: (0, $ajTRS.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $7Etkp.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $6b5595cabcfe662d$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $6b5595cabcfe662d$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $c8008865d6db946f$var$ButtonStartIcon = (0, $npagc.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $5wtOU.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $c8008865d6db946f$var$commonIconStyles(ownerState)));
const $c8008865d6db946f$var$ButtonEndIcon = (0, $npagc.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $5wtOU.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $c8008865d6db946f$var$commonIconStyles(ownerState)));
const $c8008865d6db946f$var$Button = /*#__PURE__*/ $1T1QG.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $1T1QG.useContext((0, $5c1a9471ae395620$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $1T1QG.useContext((0, $56264f6f0db29c76$export$2e2bcd8739ae039));
    const resolvedProps = (0, $uu5Ws.default)(contextProps, inProps);
    const props = (0, $gADeF.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $iXdVf.default)(props, $c8008865d6db946f$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $c8008865d6db946f$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $3Py8h.jsx)($c8008865d6db946f$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $3Py8h.jsx)($c8008865d6db946f$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($c8008865d6db946f$var$ButtonRoot, (0, $ajTRS.default)({
        ownerState: ownerState,
        className: (0, $aVXbR.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $aVXbR.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $c8008865d6db946f$export$2e2bcd8739ae039 = $c8008865d6db946f$var$Button;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");

var $aMdXx = parcelRequire("aMdXx");

var $5wtOU = parcelRequire("5wtOU");

var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $c3c98a7fcdb49950$export$29cad1383b3f235d(slot) {
    return (0, $iNQht.default)("MuiCircularProgress", slot);
}
const $c3c98a7fcdb49950$var$circularProgressClasses = (0, $dfswM.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $c3c98a7fcdb49950$export$2e2bcd8739ae039 = $c3c98a7fcdb49950$var$circularProgressClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $b658ddb442599731$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $b658ddb442599731$var$_ = (t)=>t, $b658ddb442599731$var$_t, $b658ddb442599731$var$_t2, $b658ddb442599731$var$_t3, $b658ddb442599731$var$_t4;
const $b658ddb442599731$var$SIZE = 44;
const $b658ddb442599731$var$circularRotateKeyframe = (0, $aMdXx.keyframes)($b658ddb442599731$var$_t || ($b658ddb442599731$var$_t = $b658ddb442599731$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $b658ddb442599731$var$circularDashKeyframe = (0, $aMdXx.keyframes)($b658ddb442599731$var$_t2 || ($b658ddb442599731$var$_t2 = $b658ddb442599731$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $b658ddb442599731$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $5wtOU.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $5wtOU.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $c3c98a7fcdb49950$export$29cad1383b3f235d), classes);
};
const $b658ddb442599731$var$CircularProgressRoot = (0, $npagc.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $5wtOU.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $ajTRS.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && (0, $aMdXx.css)($b658ddb442599731$var$_t3 || ($b658ddb442599731$var$_t3 = $b658ddb442599731$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $b658ddb442599731$var$circularRotateKeyframe));
const $b658ddb442599731$var$CircularProgressSVG = (0, $npagc.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $b658ddb442599731$var$CircularProgressCircle = (0, $npagc.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $5wtOU.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $ajTRS.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $aMdXx.css)($b658ddb442599731$var$_t4 || ($b658ddb442599731$var$_t4 = $b658ddb442599731$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $b658ddb442599731$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $b658ddb442599731$var$CircularProgress = /*#__PURE__*/ $1T1QG.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate" } = props, other = (0, $iXdVf.default)(props, $b658ddb442599731$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $b658ddb442599731$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($b658ddb442599731$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $3Py8h.jsx)($b658ddb442599731$var$CircularProgressRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        style: (0, $ajTRS.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($b658ddb442599731$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$b658ddb442599731$var$SIZE / 2} ${$b658ddb442599731$var$SIZE / 2} ${$b658ddb442599731$var$SIZE} ${$b658ddb442599731$var$SIZE}`,
            children: /*#__PURE__*/ (0, $3Py8h.jsx)($b658ddb442599731$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $b658ddb442599731$var$SIZE,
                cy: $b658ddb442599731$var$SIZE,
                r: ($b658ddb442599731$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $b658ddb442599731$export$2e2bcd8739ae039 = $b658ddb442599731$var$CircularProgress;


var $npagc = parcelRequire("npagc");
parcelRequire("1T1QG");
const $041febe0dbc86e0a$var$LinkButton = (0, $npagc.default)((0, $c8008865d6db946f$export$2e2bcd8739ae039))({
    textTransform: "none",
    padding: 0,
    minWidth: 0,
    "&:hover": {
        backgroundColor: "transparent" // Disable hover effect
    }
});
const $041febe0dbc86e0a$var$MoovyLink = (props)=>{
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)($041febe0dbc86e0a$var$LinkButton, {
                style: props.style,
                onClick: (event)=>{
                    if (props.onClick) {
                        if (props.disabled || props.loading) event.preventDefault();
                        else props.onClick(event);
                    }
                },
                color: props?.red ? "error" : undefined,
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
                    children: props.bold && /*#__PURE__*/ (0, $3Py8h.jsx)("b", {
                        children: props.children
                    }) || props.children
                })
            }),
            props.loading && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b658ddb442599731$export$2e2bcd8739ae039), {
                size: "mini"
            })
        ]
    });
};
var $041febe0dbc86e0a$export$2e2bcd8739ae039 = $041febe0dbc86e0a$var$MoovyLink;


var $824d769d2e3a0e2d$exports = {};
"use strict";
"use client";

Object.defineProperty($824d769d2e3a0e2d$exports, "__esModule", {
    value: true
});
$824d769d2e3a0e2d$exports.default = void 0;

var $824d769d2e3a0e2d$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $824d769d2e3a0e2d$var$_default = $824d769d2e3a0e2d$exports.default = (0, $824d769d2e3a0e2d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "MoreVert");




var $fUVqW = parcelRequire("fUVqW");

var $npagc = parcelRequire("npagc");
const $735a53468da95e8b$var$ExpandMore = (0, $npagc.default)((props)=>{
    const { expand: expand, ...other } = props;
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $5c784366741908ee$export$2e2bcd8739ae039), {
        ...other
    });
})(({ theme: theme, expand: expand })=>({
        transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
        marginLeft: "auto",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        })
    }));
const $735a53468da95e8b$var$MoovyCard = (props)=>{
    const [expanded, setExpanded] = (0, $1T1QG.useState)(false);
    const [open, setOpen] = (0, $1T1QG.useState)(false);
    const anchorRef = (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).useRef(null);
    const handleToggle = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        setOpen((prevOpen)=>!prevOpen);
    };
    const prevOpen = (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).useRef(open);
    (0, $1T1QG.useEffect)(()=>{
        if (prevOpen.current === true && open === false) anchorRef.current.focus();
        prevOpen.current = open;
    }, [
        open
    ]);
    const handleExpandClick = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        setExpanded(!expanded);
    };
    const expandList = props.cardExpandContentList;
    const avatarName = props.avatarName || (typeof props.cardTitle === "string" ? props.cardTitle : "");
    const shortAvatarName = (0, $fb47a354e391b3c4$export$6d1c4f83343cbd5d)(avatarName);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $8e83154d5f3d7c64$export$2e2bcd8739ae039), {
        sx: {
            minWidth: 200
        },
        onClick: (event)=>props.onCardClicked && props.onCardClicked(event),
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b6406c4c4f8cccba$export$2e2bcd8739ae039), {
                avatar: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8cb92c640591b070$export$2e2bcd8739ae039), {
                    sx: {
                        bgcolor: (0, $fUVqW.default)[500]
                    },
                    "aria-label": avatarName,
                    children: shortAvatarName
                }),
                action: props.cardMenuActions ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $5c784366741908ee$export$2e2bcd8739ae039), {
                    "aria-label": "settings",
                    ref: anchorRef,
                    "aria-controls": open ? "composition-menu" : undefined,
                    "aria-expanded": open ? "true" : undefined,
                    "aria-haspopup": "true",
                    onClick: handleToggle,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($824d769d2e3a0e2d$exports))), {})
                }) : undefined,
                title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $041febe0dbc86e0a$export$2e2bcd8739ae039), {
                    style: {
                        textAlign: "left"
                    },
                    children: props.cardTitle
                }),
                subheader: props.cardSecondaryTitle
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $faeb0a5651a5f4e9$export$2e2bcd8739ae039), {
                style: {
                    paddingBottom: props.cardContentList.length > 0 || expandList ? 12 : 0,
                    paddingTop: 0
                },
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $44769ad997f9918f$export$2e2bcd8739ae039), {
                    style: {
                        paddingBottom: 0,
                        paddingTop: 0
                    },
                    children: props.cardContentList.map((item, index)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $7308185c8ff27335$export$2e2bcd8739ae039), {
                            secondary: item,
                            style: {
                                wordBreak: "break-all"
                            }
                        }, index))
                })
            }),
            expandList && /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $2084255b952e7030$export$2e2bcd8739ae039), {
                        disableSpacing: true,
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)($735a53468da95e8b$var$ExpandMore, {
                            expand: expanded,
                            onClick: handleExpandClick,
                            "aria-expanded": expanded,
                            "aria-label": "show more",
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c27564b4f3f6c249$exports))), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $0eaedcef72a51b3a$export$2e2bcd8739ae039), {
                        in: expanded,
                        timeout: "auto",
                        unmountOnExit: true,
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $faeb0a5651a5f4e9$export$2e2bcd8739ae039), {
                            style: {
                                paddingBottom: 0,
                                paddingTop: 0
                            },
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $44769ad997f9918f$export$2e2bcd8739ae039), {
                                children: expandList.map((item, index)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $7308185c8ff27335$export$2e2bcd8739ae039), {
                                        secondary: item,
                                        style: {
                                            wordBreak: "break-all"
                                        }
                                    }, index))
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $60ef78cc62d0ba44$export$2e2bcd8739ae039), {
                open: open,
                setOpen: setOpen,
                anchorRef: anchorRef,
                menuItems: props.cardMenuActions
            })
        ]
    }, props.key);
};
var $735a53468da95e8b$export$2e2bcd8739ae039 = $735a53468da95e8b$var$MoovyCard;



var $3Py8h = parcelRequire("3Py8h");


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");



var $5wtOU = parcelRequire("5wtOU");
var $1T1QG = parcelRequire("1T1QG");
"use client";
let $9dc24b323e690fdf$var$globalId = 0;
function $9dc24b323e690fdf$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $1T1QG.useState(idOverride);
    const id = idOverride || defaultId;
    $1T1QG.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $9dc24b323e690fdf$var$globalId += 1;
            setDefaultId(`mui-${$9dc24b323e690fdf$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $9dc24b323e690fdf$var$maybeReactUseId = $1T1QG["useId".toString()];
function $9dc24b323e690fdf$export$2e2bcd8739ae039(idOverride) {
    if ($9dc24b323e690fdf$var$maybeReactUseId !== undefined) {
        const reactId = $9dc24b323e690fdf$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $9dc24b323e690fdf$var$useGlobalId(idOverride);
}


"use client";
var $71c1fc9cdce170b3$export$2e2bcd8739ae039 = (0, $9dc24b323e690fdf$export$2e2bcd8739ae039);



var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");




var $uu5Ws = parcelRequire("uu5Ws");

var $iNQht = parcelRequire("iNQht");

var $dfswM = parcelRequire("dfswM");
function $8a013c0bafcbf2a5$export$24fdd7c0683a4fed(slot) {
    return (0, $iNQht.default)("MuiLoadingButton", slot);
}
const $8a013c0bafcbf2a5$var$loadingButtonClasses = (0, $dfswM.default)("MuiLoadingButton", [
    "root",
    "loading",
    "loadingIndicator",
    "loadingIndicatorCenter",
    "loadingIndicatorStart",
    "loadingIndicatorEnd",
    "endIconLoadingEnd",
    "startIconLoadingStart"
]);
var $8a013c0bafcbf2a5$export$2e2bcd8739ae039 = $8a013c0bafcbf2a5$var$loadingButtonClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $a207b26911d2b46a$var$_excluded = [
    "children",
    "disabled",
    "id",
    "loading",
    "loadingIndicator",
    "loadingPosition",
    "variant"
];
const $a207b26911d2b46a$var$useUtilityClasses = (ownerState)=>{
    const { loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            loading && "loading"
        ],
        startIcon: [
            loading && `startIconLoading${(0, $5wtOU.default)(loadingPosition)}`
        ],
        endIcon: [
            loading && `endIconLoading${(0, $5wtOU.default)(loadingPosition)}`
        ],
        loadingIndicator: [
            "loadingIndicator",
            loading && `loadingIndicator${(0, $5wtOU.default)(loadingPosition)}`
        ]
    };
    const composedClasses = (0, $iV85C.default)(slots, (0, $8a013c0bafcbf2a5$export$24fdd7c0683a4fed), classes);
    return (0, $ajTRS.default)({}, classes, composedClasses);
};
// TODO use `import { rootShouldForwardProp } from '../styles/styled';` once move to core
const $a207b26911d2b46a$var$rootShouldForwardProp = (prop)=>prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as" && prop !== "classes";
const $a207b26911d2b46a$var$LoadingButtonRoot = (0, $npagc.default)((0, $c8008865d6db946f$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>$a207b26911d2b46a$var$rootShouldForwardProp(prop) || prop === "classes",
    name: "MuiLoadingButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        return [
            styles.root,
            styles.startIconLoadingStart && {
                [`& .${(0, $8a013c0bafcbf2a5$export$2e2bcd8739ae039).startIconLoadingStart}`]: styles.startIconLoadingStart
            },
            styles.endIconLoadingEnd && {
                [`& .${(0, $8a013c0bafcbf2a5$export$2e2bcd8739ae039).endIconLoadingEnd}`]: styles.endIconLoadingEnd
            }
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $ajTRS.default)({
        [`& .${(0, $8a013c0bafcbf2a5$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $8a013c0bafcbf2a5$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                "opacity"
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0
        }
    }, ownerState.loadingPosition === "center" && {
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        [`&.${(0, $8a013c0bafcbf2a5$export$2e2bcd8739ae039).loading}`]: {
            color: "transparent"
        }
    }, ownerState.loadingPosition === "start" && ownerState.fullWidth && {
        [`& .${(0, $8a013c0bafcbf2a5$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $8a013c0bafcbf2a5$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                "opacity"
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0,
            marginRight: -8
        }
    }, ownerState.loadingPosition === "end" && ownerState.fullWidth && {
        [`& .${(0, $8a013c0bafcbf2a5$export$2e2bcd8739ae039).startIconLoadingStart}, & .${(0, $8a013c0bafcbf2a5$export$2e2bcd8739ae039).endIconLoadingEnd}`]: {
            transition: theme.transitions.create([
                "opacity"
            ], {
                duration: theme.transitions.duration.short
            }),
            opacity: 0,
            marginLeft: -8
        }
    }));
const $a207b26911d2b46a$var$LoadingButtonLoadingIndicator = (0, $npagc.default)("span", {
    name: "MuiLoadingButton",
    slot: "LoadingIndicator",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.loadingIndicator,
            styles[`loadingIndicator${(0, $5wtOU.default)(ownerState.loadingPosition)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        position: "absolute",
        visibility: "visible",
        display: "flex"
    }, ownerState.loadingPosition === "start" && (ownerState.variant === "outlined" || ownerState.variant === "contained") && {
        left: ownerState.size === "small" ? 10 : 14
    }, ownerState.loadingPosition === "start" && ownerState.variant === "text" && {
        left: 6
    }, ownerState.loadingPosition === "center" && {
        left: "50%",
        transform: "translate(-50%)",
        color: (theme.vars || theme).palette.action.disabled
    }, ownerState.loadingPosition === "end" && (ownerState.variant === "outlined" || ownerState.variant === "contained") && {
        right: ownerState.size === "small" ? 10 : 14
    }, ownerState.loadingPosition === "end" && ownerState.variant === "text" && {
        right: 6
    }, ownerState.loadingPosition === "start" && ownerState.fullWidth && {
        position: "relative",
        left: -10
    }, ownerState.loadingPosition === "end" && ownerState.fullWidth && {
        position: "relative",
        right: -10
    }));
const $a207b26911d2b46a$var$LoadingButton = /*#__PURE__*/ $1T1QG.forwardRef(function LoadingButton(inProps, ref) {
    const contextProps = $1T1QG.useContext((0, $5c1a9471ae395620$export$2e2bcd8739ae039));
    const resolvedProps = (0, $uu5Ws.default)(contextProps, inProps);
    const props = (0, $gADeF.default)({
        props: resolvedProps,
        name: "MuiLoadingButton"
    });
    const { children: children, disabled: disabled = false, id: idProp, loading: loading = false, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = "center", variant: variant = "text" } = props, other = (0, $iXdVf.default)(props, $a207b26911d2b46a$var$_excluded);
    const id = (0, $71c1fc9cdce170b3$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp != null ? loadingIndicatorProp : /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b658ddb442599731$export$2e2bcd8739ae039), {
        "aria-labelledby": id,
        color: "inherit",
        size: 16
    });
    const ownerState = (0, $ajTRS.default)({}, props, {
        disabled: disabled,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        variant: variant
    });
    const classes = $a207b26911d2b46a$var$useUtilityClasses(ownerState);
    const loadingButtonLoadingIndicator = loading ? /*#__PURE__*/ (0, $3Py8h.jsx)($a207b26911d2b46a$var$LoadingButtonLoadingIndicator, {
        className: classes.loadingIndicator,
        ownerState: ownerState,
        children: loadingIndicator
    }) : null;
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($a207b26911d2b46a$var$LoadingButtonRoot, (0, $ajTRS.default)({
        disabled: disabled || loading,
        id: id,
        ref: ref
    }, other, {
        variant: variant,
        classes: classes,
        ownerState: ownerState,
        children: [
            ownerState.loadingPosition === "end" ? children : loadingButtonLoadingIndicator,
            ownerState.loadingPosition === "end" ? loadingButtonLoadingIndicator : children
        ]
    }));
});
var $a207b26911d2b46a$export$2e2bcd8739ae039 = $a207b26911d2b46a$var$LoadingButton;


parcelRequire("1T1QG");
const $971b877bb5a46eb0$var$MoovyButton = (props)=>{
    const { mutation: mutation, query: query, startIcon: startIcon, showAsIconButton: showAsIconButton, ...rest } = props;
    const isLoading = props?.mutation?.isPending || props?.query?.isFetching || props?.query?.isLoading;
    const NormalButton = ()=>{
        return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a207b26911d2b46a$export$2e2bcd8739ae039), {
            ...rest,
            disabled: isLoading || !!props.disabled,
            loading: isLoading,
            variant: props.variant || "contained",
            children: props?.children
        });
    };
    const IconOnlyButton = ()=>{
        return /*#__PURE__*/ (0, $3Py8h.jsxs)("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                visibility: rest.hidden ? "hidden" : undefined
            },
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $5c784366741908ee$export$2e2bcd8739ae039), {
                    disabled: isLoading || !!props.disabled,
                    ...rest,
                    children: startIcon
                }),
                isLoading && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b658ddb442599731$export$2e2bcd8739ae039), {
                    size: 24,
                    style: {
                        position: "absolute"
                    }
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: showAsIconButton ? /*#__PURE__*/ (0, $3Py8h.jsx)(IconOnlyButton, {}) : /*#__PURE__*/ (0, $3Py8h.jsx)(NormalButton, {})
    });
};
var $971b877bb5a46eb0$export$2e2bcd8739ae039 = $971b877bb5a46eb0$var$MoovyButton;



var $3Py8h = parcelRequire("3Py8h");

var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");



var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");
parcelRequire("1T1QG");


var $7Etkp = parcelRequire("7Etkp");

var $npagc = parcelRequire("npagc");
parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $49b78aaaeb26b90f$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz");




var $3Py8h = parcelRequire("3Py8h");
"use client";
const $de0c1cac044f4917$var$_excluded = [
    "slots",
    "slotProps"
];
const $de0c1cac044f4917$var$BreadcrumbCollapsedButton = (0, $npagc.default)((0, $ecc40a2d226ef234$export$2e2bcd8739ae039))(({ theme: theme })=>(0, $ajTRS.default)({
        display: "flex",
        marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
        marginRight: `calc(${theme.spacing(1)} * 0.5)`
    }, theme.palette.mode === "light" ? {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[700]
    } : {
        backgroundColor: theme.palette.grey[700],
        color: theme.palette.grey[100]
    }, {
        borderRadius: 2,
        "&:hover, &:focus": (0, $ajTRS.default)({}, theme.palette.mode === "light" ? {
            backgroundColor: theme.palette.grey[200]
        } : {
            backgroundColor: theme.palette.grey[600]
        }),
        "&:active": (0, $ajTRS.default)({
            boxShadow: theme.shadows[0]
        }, theme.palette.mode === "light" ? {
            backgroundColor: (0, $7Etkp.emphasize)(theme.palette.grey[200], 0.12)
        } : {
            backgroundColor: (0, $7Etkp.emphasize)(theme.palette.grey[600], 0.12)
        })
    }));
const $de0c1cac044f4917$var$BreadcrumbCollapsedIcon = (0, $npagc.default)((0, $49b78aaaeb26b90f$export$2e2bcd8739ae039))({
    width: 24,
    height: 16
});
/**
 * @ignore - internal component.
 */ function $de0c1cac044f4917$var$BreadcrumbCollapsed(props) {
    const { slots: slots = {}, slotProps: slotProps = {} } = props, otherProps = (0, $iXdVf.default)(props, $de0c1cac044f4917$var$_excluded);
    const ownerState = props;
    return /*#__PURE__*/ (0, $3Py8h.jsx)("li", {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($de0c1cac044f4917$var$BreadcrumbCollapsedButton, (0, $ajTRS.default)({
            focusRipple: true
        }, otherProps, {
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, $3Py8h.jsx)($de0c1cac044f4917$var$BreadcrumbCollapsedIcon, (0, $ajTRS.default)({
                as: slots.CollapsedIcon,
                ownerState: ownerState
            }, slotProps.collapsedIcon))
        }))
    });
}
var $de0c1cac044f4917$export$2e2bcd8739ae039 = $de0c1cac044f4917$var$BreadcrumbCollapsed;



var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $0216144de5d38269$export$17261110b18c8084(slot) {
    return (0, $iNQht.default)("MuiBreadcrumbs", slot);
}
const $0216144de5d38269$var$breadcrumbsClasses = (0, $dfswM.default)("MuiBreadcrumbs", [
    "root",
    "ol",
    "li",
    "separator"
]);
var $0216144de5d38269$export$2e2bcd8739ae039 = $0216144de5d38269$var$breadcrumbsClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $652cc3e9232526cb$var$_excluded = [
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "expandText",
    "itemsAfterCollapse",
    "itemsBeforeCollapse",
    "maxItems",
    "separator"
];
const $652cc3e9232526cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        li: [
            "li"
        ],
        ol: [
            "ol"
        ],
        separator: [
            "separator"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $0216144de5d38269$export$17261110b18c8084), classes);
};
const $652cc3e9232526cb$var$BreadcrumbsRoot = (0, $npagc.default)((0, $a386176d6ca21602$export$2e2bcd8739ae039), {
    name: "MuiBreadcrumbs",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${(0, $0216144de5d38269$export$2e2bcd8739ae039).li}`]: styles.li
            },
            styles.root
        ];
    }
})({});
const $652cc3e9232526cb$var$BreadcrumbsOl = (0, $npagc.default)("ol", {
    name: "MuiBreadcrumbs",
    slot: "Ol",
    overridesResolver: (props, styles)=>styles.ol
})({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
});
const $652cc3e9232526cb$var$BreadcrumbsSeparator = (0, $npagc.default)("li", {
    name: "MuiBreadcrumbs",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})({
    display: "flex",
    userSelect: "none",
    marginLeft: 8,
    marginRight: 8
});
function $652cc3e9232526cb$var$insertSeparators(items, className, separator, ownerState) {
    return items.reduce((acc, current, index)=>{
        if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ (0, $3Py8h.jsx)($652cc3e9232526cb$var$BreadcrumbsSeparator, {
            "aria-hidden": true,
            className: className,
            ownerState: ownerState,
            children: separator
        }, `separator-${index}`));
        else acc.push(current);
        return acc;
    }, []);
}
const $652cc3e9232526cb$var$Breadcrumbs = /*#__PURE__*/ $1T1QG.forwardRef(function Breadcrumbs(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiBreadcrumbs"
    });
    const { children: children, className: className, component: component = "nav", slots: slots = {}, slotProps: slotProps = {}, expandText: expandText = "Show path", itemsAfterCollapse: itemsAfterCollapse = 1, itemsBeforeCollapse: itemsBeforeCollapse = 1, maxItems: maxItems = 8, separator: separator = "/" } = props, other = (0, $iXdVf.default)(props, $652cc3e9232526cb$var$_excluded);
    const [expanded, setExpanded] = $1T1QG.useState(false);
    const ownerState = (0, $ajTRS.default)({}, props, {
        component: component,
        expanded: expanded,
        expandText: expandText,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        maxItems: maxItems,
        separator: separator
    });
    const classes = $652cc3e9232526cb$var$useUtilityClasses(ownerState);
    const collapsedIconSlotProps = (0, $3b38c2c568b5248d$export$1e5c9e6e4e15efe3)({
        elementType: slots.CollapsedIcon,
        externalSlotProps: slotProps.collapsedIcon,
        ownerState: ownerState
    });
    const listRef = $1T1QG.useRef(null);
    const renderItemsBeforeAndAfter = (allItems)=>{
        const handleClickExpand = ()=>{
            setExpanded(true);
            // The clicked element received the focus but gets removed from the DOM.
            // Let's keep the focus in the component after expanding.
            // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
            // By moving it to some link/button at least we have some announcement.
            const focusable = listRef.current.querySelector("a[href],button,[tabindex]");
            if (focusable) focusable.focus();
        };
        // This defends against someone passing weird input, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        return [
            ...allItems.slice(0, itemsBeforeCollapse),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $de0c1cac044f4917$export$2e2bcd8739ae039), {
                "aria-label": expandText,
                slots: {
                    CollapsedIcon: slots.CollapsedIcon
                },
                slotProps: {
                    collapsedIcon: collapsedIconSlotProps
                },
                onClick: handleClickExpand
            }, "ellipsis"),
            ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)
        ];
    };
    const allItems = $1T1QG.Children.toArray(children).filter((child)=>{
        return /*#__PURE__*/ $1T1QG.isValidElement(child);
    }).map((child, index)=>/*#__PURE__*/ (0, $3Py8h.jsx)("li", {
            className: classes.li,
            children: child
        }, `child-${index}`));
    return /*#__PURE__*/ (0, $3Py8h.jsx)($652cc3e9232526cb$var$BreadcrumbsRoot, (0, $ajTRS.default)({
        ref: ref,
        component: component,
        color: "text.secondary",
        className: (0, $aVXbR.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($652cc3e9232526cb$var$BreadcrumbsOl, {
            className: classes.ol,
            ref: listRef,
            ownerState: ownerState,
            children: $652cc3e9232526cb$var$insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
        })
    }));
});
var $652cc3e9232526cb$export$2e2bcd8739ae039 = $652cc3e9232526cb$var$Breadcrumbs;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");

var $5wtOU = parcelRequire("5wtOU");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");




var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $b76d23c49925eaf7$export$d6efab9620b78fec(slot) {
    return (0, $iNQht.default)("MuiLink", slot);
}
const $b76d23c49925eaf7$var$linkClasses = (0, $dfswM.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
var $b76d23c49925eaf7$export$2e2bcd8739ae039 = $b76d23c49925eaf7$var$linkClasses;



var $7Etkp = parcelRequire("7Etkp");
var $6anZL = parcelRequire("6anZL");
const $d49fe79f179bf2bc$export$c4e140d5d351182b = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $d49fe79f179bf2bc$var$transformDeprecatedColors = (color)=>{
    return $d49fe79f179bf2bc$export$c4e140d5d351182b[color] || color;
};
const $d49fe79f179bf2bc$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $d49fe79f179bf2bc$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $6anZL.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $6anZL.getPath)(theme, `palette.${transformedColor}Channel`);
    if ("vars" in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $7Etkp.alpha)(color, 0.4);
};
var $d49fe79f179bf2bc$export$2e2bcd8739ae039 = $d49fe79f179bf2bc$var$getTextDecoration;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $20ee4e07c5af013a$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $20ee4e07c5af013a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            "root",
            `underline${(0, $5wtOU.default)(underline)}`,
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $b76d23c49925eaf7$export$d6efab9620b78fec), classes);
};
const $20ee4e07c5af013a$var$LinkRoot = (0, $npagc.default)((0, $a386176d6ca21602$export$2e2bcd8739ae039), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $5wtOU.default)(ownerState.underline)}`],
            ownerState.component === "button" && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $ajTRS.default)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && (0, $ajTRS.default)({
        textDecoration: "underline"
    }, ownerState.color !== "inherit" && {
        textDecorationColor: (0, $d49fe79f179bf2bc$export$2e2bcd8739ae039)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }), ownerState.component === "button" && {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        [`&.${(0, $b76d23c49925eaf7$export$2e2bcd8739ae039).focusVisible}`]: {
            outline: "auto"
        }
    });
});
const $20ee4e07c5af013a$var$Link = /*#__PURE__*/ $1T1QG.forwardRef(function Link(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiLink"
    });
    const { className: className, color: color = "primary", component: component = "a", onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = "always", variant: variant = "inherit", sx: sx } = props, other = (0, $iXdVf.default)(props, $20ee4e07c5af013a$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $4a2f2e3ed2159cdf$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $1T1QG.useState(false);
    const handlerRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $ajTRS.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $20ee4e07c5af013a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($20ee4e07c5af013a$var$LinkRoot, (0, $ajTRS.default)({
        color: color,
        className: (0, $aVXbR.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $d49fe79f179bf2bc$export$c4e140d5d351182b)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $20ee4e07c5af013a$export$2e2bcd8739ae039 = $20ee4e07c5af013a$var$Link;


parcelRequire("1T1QG");
const $131e55989189bbc4$var$MoovyBreadcrumbs = (props)=>{
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const isMobile = (0, $ffad103d3c7e3bc8$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    const routes = props.customBreadcrumbs || [];
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $652cc3e9232526cb$export$2e2bcd8739ae039), {
        maxItems: isMobile ? 2 : undefined,
        "aria-label": "breadcrumb",
        style: {
            marginTop: "10px"
        },
        children: [
            routes.map((item, index)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $20ee4e07c5af013a$export$2e2bcd8739ae039), {
                    underline: "hover",
                    color: "inherit",
                    href: item?.route,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
                        children: item?.name
                    })
                }, index)),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a386176d6ca21602$export$2e2bcd8739ae039), {
                color: "text.primary",
                children: props.lastBreadcrumb
            })
        ]
    });
};
var $131e55989189bbc4$export$2e2bcd8739ae039 = $131e55989189bbc4$var$MoovyBreadcrumbs;



var $3Py8h = parcelRequire("3Py8h");



function $268b84bc693ec63f$export$2e2bcd8739ae039() {
    const dispatch = (0, $4a938932ca693376$export$8ad76b76a4c905f8)();
    const setLocale = (value)=>dispatch((0, $455a74580fe95862$export$7389484a7f69e71d)(value));
    const locale = (0, $c354137c2cb06a61$export$2105062e25df4afe)((0, $455a74580fe95862$export$1c46e3decb4a80c2).getLocale);
    return {
        setLocale: setLocale,
        locale: locale
    };
}


const $235dbade6cd3cffe$var$MoovyDateTime = (props)=>{
    if (!props.utcDateTime) return props?.emptyText || "";
    const { locale: locale } = (0, $268b84bc693ec63f$export$2e2bcd8739ae039)();
    const datetime = (0, $8cd8f065b47158d9$export$6ef9dbcccbc4ed7d).fromUTC(props.utcDateTime, locale);
    if (props.dateOnly) return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: (0, $8cd8f065b47158d9$export$6c3b6c09c58d6bc3).toString(datetime)
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: (0, $8cd8f065b47158d9$export$59110d836eb073ac).toString(datetime)
    });
};
var $235dbade6cd3cffe$export$2e2bcd8739ae039 = $235dbade6cd3cffe$var$MoovyDateTime;



var $3Py8h = parcelRequire("3Py8h");

const $c338ce915869c7c0$var$MoovyErrorPage = ()=>{
    return /*#__PURE__*/ (0, $3Py8h.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)("h1", {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "moovyErrorPage.oops"
                })
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)("p", {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "moovyErrorPage.message"
                })
            })
        ]
    });
};
var $c338ce915869c7c0$export$2e2bcd8739ae039 = $c338ce915869c7c0$var$MoovyErrorPage;



var $3Py8h = parcelRequire("3Py8h");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");
var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");
"use client";
const $085346fccf793183$var$usePreviousProps = (value)=>{
    const ref = $1T1QG.useRef({});
    $1T1QG.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $085346fccf793183$export$2e2bcd8739ae039 = $085346fccf793183$var$usePreviousProps;


"use client";
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $7adc4d7584341520$var$stripDiacritics(string) {
    return typeof string.normalize !== "undefined" ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : string;
}
function $7adc4d7584341520$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = "any", stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $7adc4d7584341520$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $7adc4d7584341520$var$stripDiacritics(candidate);
            return matchFrom === "start" ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $7adc4d7584341520$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $7adc4d7584341520$var$defaultFilterOptions = $7adc4d7584341520$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $7adc4d7584341520$var$pageSize = 5;
const $7adc4d7584341520$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
function $7adc4d7584341520$export$1e40b3ca02d92d21(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $7adc4d7584341520$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = "Mui", autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = "useAutocomplete", defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $7adc4d7584341520$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $9dc24b323e690fdf$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== "string") return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $1T1QG.useRef(false);
    const firstFocus = $1T1QG.useRef(true);
    const inputRef = $1T1QG.useRef(null);
    const listboxRef = $1T1QG.useRef(null);
    const [anchorEl, setAnchorEl] = $1T1QG.useState(null);
    const [focusedTag, setFocusedTag] = $1T1QG.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $1T1QG.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $328d428125b56996$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $328d428125b56996$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: "",
        name: componentName,
        state: "inputValue"
    });
    const [focused, setFocused] = $1T1QG.useState(false);
    const resetInputValue = $1T1QG.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = "";
        else if (newValue == null) newInputValue = "";
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === "string" ? optionLabel : "";
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, "reset");
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $328d428125b56996$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: "open"
    });
    const [inputPristine, setInputPristine] = $1T1QG.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? "" : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $085346fccf793183$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $1T1QG.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $f10dd87bccb0014d$export$2e2bcd8739ae039)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $1T1QG.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute("aria-disabled") === "true";
            if (option && option.hasAttribute("tabindex") && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === "next") nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $f10dd87bccb0014d$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason = "auto" })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute("aria-activedescendant");
        else inputRef.current.setAttribute("aria-activedescendant", `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute("role") !== "listbox") listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === "keyboard") option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== "mouse" && reason !== "touch") {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $f10dd87bccb0014d$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = "next", reason: reason = "auto" })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === "reset") return defaultHighlighted;
            if (diff === "start") return 0;
            if (diff === "end") return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== "reset") {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const checkHighlightedOptionExists = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : "";
            const label2 = value2 ? getOptionLabel(value2) : "";
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) {
                const previousHighlightedOptionExists = filteredOptions.some((option)=>{
                    return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
                });
                if (previousHighlightedOptionExists) return true;
            }
        }
        return false;
    };
    const syncHighlightedIndex = $1T1QG.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, return, otherwise continue execution
        if (checkHighlightedOptionExists()) return;
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: "reset"
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $7adc4d7584341520$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $7adc4d7584341520$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: "reset"
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $f10dd87bccb0014d$export$2e2bcd8739ae039)((node)=>{
        (0, $2c32707bf1e7228d$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $1T1QG.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $1T1QG.useRef(false);
    const selectNewValue = (event, option, reasonProp = "selectOption", origin = "options")=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $7adc4d7584341520$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== "freeSolo") {
                newValue.splice(itemIndex, 1);
                reason = "removeOption";
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === "touch" && isTouch.current || blurOnSelect === "mouse" && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === value.length || direction === "previous" && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute("tabindex") || option.disabled || option.getAttribute("aria-disabled") === "true") nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === "") handleClose(event, "toggleInput");
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === "" && direction === "previous") nextTag = value.length - 1;
        } else {
            nextTag += direction === "next" ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState("");
        if (onInputChange) onInputChange(event, "", "clear");
        handleValue(event, multiple ? [] : null, "clear");
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                "ArrowLeft",
                "ArrowRight"
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case "Home":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "start",
                            direction: "next",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "End":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "end",
                            direction: "previous",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "PageUp":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$7adc4d7584341520$var$pageSize,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "PageDown":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $7adc4d7584341520$var$pageSize,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowDown":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowUp":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowLeft":
                    handleFocusTag(event, "previous");
                    break;
                case "ArrowRight":
                    handleFocusTag(event, "next");
                    break;
                case "Enter":
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, "selectOption");
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== "" && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, "createOption", "freeSolo");
                    }
                    break;
                case "Escape":
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, "escape");
                    } else if (clearOnEscape && (inputValue !== "" || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case "Backspace":
                    if (multiple && !readOnly && inputValue === "" && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                case "Delete":
                    if (multiple && !readOnly && inputValue === "" && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], "blur");
        else if (autoSelect && freeSolo && inputValue !== "") selectNewValue(event, inputValue, "blur", "freeSolo");
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, "blur");
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, "input");
        }
        if (newValue === "") {
            if (!disableClearable && !multiple) handleValue(event, null, "clear");
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: "mouse"
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute("data-option-index")),
            reason: "touch"
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        selectNewValue(event, filteredOptions[index], "selectOption");
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, "removeOption", {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, "toggleInput");
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute("id") !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === "" || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $ajTRS.default)({
                "aria-owns": listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                "aria-activedescendant": popupOpen ? "" : null,
                "aria-autocomplete": autoComplete ? "both" : "list",
                "aria-controls": listboxAvailable ? `${id}-listbox` : undefined,
                "aria-expanded": listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: "off",
                ref: inputRef,
                autoCapitalize: "none",
                spellCheck: "false",
                role: "combobox",
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $ajTRS.default)({
                key: index,
                "data-tag-index": index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: "listbox",
                id: `${id}-listbox`,
                "aria-labelledby": `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            var _getOptionKey;
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: "option",
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                "data-option-index": index,
                "aria-disabled": disabled,
                "aria-selected": selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}



var $7Etkp = parcelRequire("7Etkp");


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $5wtOU = parcelRequire("5wtOU");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $cbaef5e665bf8ff0$export$6816d4fc0981ec7(slot) {
    return (0, $iNQht.default)("MuiListSubheader", slot);
}
const $cbaef5e665bf8ff0$var$listSubheaderClasses = (0, $dfswM.default)("MuiListSubheader", [
    "root",
    "colorPrimary",
    "colorInherit",
    "gutters",
    "inset",
    "sticky"
]);
var $cbaef5e665bf8ff0$export$2e2bcd8739ae039 = $cbaef5e665bf8ff0$var$listSubheaderClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $73bbeed63998f838$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $73bbeed63998f838$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "default" && `color${(0, $5wtOU.default)(color)}`,
            !disableGutters && "gutters",
            inset && "inset",
            !disableSticky && "sticky"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $cbaef5e665bf8ff0$export$6816d4fc0981ec7), classes);
};
const $73bbeed63998f838$var$ListSubheaderRoot = (0, $npagc.default)("li", {
    name: "MuiListSubheader",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $5wtOU.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        boxSizing: "border-box",
        lineHeight: "48px",
        listStyle: "none",
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === "primary" && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $73bbeed63998f838$var$ListSubheader = /*#__PURE__*/ $1T1QG.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiListSubheader"
    });
    const { className: className, color: color = "default", component: component = "li", disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $iXdVf.default)(props, $73bbeed63998f838$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $73bbeed63998f838$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($73bbeed63998f838$var$ListSubheaderRoot, (0, $ajTRS.default)({
        as: component,
        className: (0, $aVXbR.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$73bbeed63998f838$var$ListSubheader.muiSkipListHighlight = true;
var $73bbeed63998f838$export$2e2bcd8739ae039 = $73bbeed63998f838$var$ListSubheader;





var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $7Etkp = parcelRequire("7Etkp");
parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $503306692dce945a$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");





var $5wtOU = parcelRequire("5wtOU");


var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $f32edfa4f94c3447$export$31444911e4ee6fdd(slot) {
    return (0, $iNQht.default)("MuiChip", slot);
}
const $f32edfa4f94c3447$var$chipClasses = (0, $dfswM.default)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "filledPrimary",
    "filledSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "deleteIconFilledColorPrimary",
    "deleteIconFilledColorSecondary",
    "focusVisible"
]);
var $f32edfa4f94c3447$export$2e2bcd8739ae039 = $f32edfa4f94c3447$var$chipClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $6778801d3fbd7fc0$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $6778801d3fbd7fc0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, $5wtOU.default)(size)}`,
            `color${(0, $5wtOU.default)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, $5wtOU.default)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, $5wtOU.default)(color)}`,
            `${variant}${(0, $5wtOU.default)(color)}`
        ],
        label: [
            "label",
            `label${(0, $5wtOU.default)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, $5wtOU.default)(size)}`,
            `avatarColor${(0, $5wtOU.default)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, $5wtOU.default)(size)}`,
            `iconColor${(0, $5wtOU.default)(iconColor)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, $5wtOU.default)(size)}`,
            `deleteIconColor${(0, $5wtOU.default)(color)}`,
            `deleteIcon${(0, $5wtOU.default)(variant)}Color${(0, $5wtOU.default)(color)}`
        ]
    };
    return (0, $iV85C.default)(slots, (0, $f32edfa4f94c3447$export$31444911e4ee6fdd), classes);
};
const $6778801d3fbd7fc0$var$ChipRoot = (0, $npagc.default)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $5wtOU.default)(size)}`]
            },
            {
                [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $5wtOU.default)(color)}`]
            },
            {
                [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $5wtOU.default)(size)}`]
            },
            {
                [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $5wtOU.default)(iconColor)}`]
            },
            {
                [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $5wtOU.default)(size)}`]
            },
            {
                [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $5wtOU.default)(color)}`]
            },
            {
                [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $5wtOU.default)(variant)}Color${(0, $5wtOU.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $5wtOU.default)(size)}`],
            styles[`color${(0, $5wtOU.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, $5wtOU.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, $5wtOU.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $5wtOU.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $ajTRS.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: "unset",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).icon}`]: (0, $ajTRS.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $ajTRS.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== "default" && {
            color: "inherit"
        })),
        [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).deleteIcon}`]: (0, $ajTRS.default)({
            WebkitTapHighlightColor: "transparent",
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $7Etkp.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $7Etkp.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $7Etkp.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7Etkp.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7Etkp.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7Etkp.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $7Etkp.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7Etkp.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $7Etkp.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $f32edfa4f94c3447$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $7Etkp.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $6778801d3fbd7fc0$var$ChipLabel = (0, $npagc.default)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $5wtOU.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.variant === "outlined" && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $6778801d3fbd7fc0$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $6778801d3fbd7fc0$var$Chip = /*#__PURE__*/ $1T1QG.forwardRef(function Chip(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = "default", component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = "medium", variant: variant = "filled", tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $iXdVf.default)(props, $6778801d3fbd7fc0$var$_excluded);
    const chipRef = $1T1QG.useRef(null);
    const handleRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $6778801d3fbd7fc0$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $6778801d3fbd7fc0$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $ecc40a2d226ef234$export$2e2bcd8739ae039) : ComponentProp || "div";
    const ownerState = (0, $ajTRS.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $1T1QG.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $6778801d3fbd7fc0$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $ecc40a2d226ef234$export$2e2bcd8739ae039) ? (0, $ajTRS.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $1T1QG.isValidElement(deleteIconProp) ? /*#__PURE__*/ $1T1QG.cloneElement(deleteIconProp, {
        className: (0, $aVXbR.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $3Py8h.jsx)((0, $503306692dce945a$export$2e2bcd8739ae039), {
        className: (0, $aVXbR.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $1T1QG.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $1T1QG.cloneElement(avatarProp, {
        className: (0, $aVXbR.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $1T1QG.isValidElement(iconProp)) icon = /*#__PURE__*/ $1T1QG.cloneElement(iconProp, {
        className: (0, $aVXbR.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($6778801d3fbd7fc0$var$ChipRoot, (0, $ajTRS.default)({
        as: component,
        className: (0, $aVXbR.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $3Py8h.jsx)($6778801d3fbd7fc0$var$ChipLabel, {
                className: (0, $aVXbR.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $6778801d3fbd7fc0$export$2e2bcd8739ae039 = $6778801d3fbd7fc0$var$Chip;



var $ajTRS = parcelRequire("ajTRS");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $c2dea97f51686c9f$export$ef57d5c8ca2278f6(slot) {
    return (0, $iNQht.default)("MuiInputBase", slot);
}
const $c2dea97f51686c9f$var$inputBaseClasses = (0, $dfswM.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $c2dea97f51686c9f$export$2e2bcd8739ae039 = $c2dea97f51686c9f$var$inputBaseClasses;


function $cb8e517f1d05f7c2$export$cdb270390122322b(slot) {
    return (0, $iNQht.default)("MuiInput", slot);
}
const $cb8e517f1d05f7c2$var$inputClasses = (0, $ajTRS.default)({}, (0, $c2dea97f51686c9f$export$2e2bcd8739ae039), (0, $dfswM.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $cb8e517f1d05f7c2$export$2e2bcd8739ae039 = $cb8e517f1d05f7c2$var$inputClasses;




var $ajTRS = parcelRequire("ajTRS");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");

function $63f066b46e18ed3f$export$89922944c7227687(slot) {
    return (0, $iNQht.default)("MuiOutlinedInput", slot);
}
const $63f066b46e18ed3f$var$outlinedInputClasses = (0, $ajTRS.default)({}, (0, $c2dea97f51686c9f$export$2e2bcd8739ae039), (0, $dfswM.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $63f066b46e18ed3f$export$2e2bcd8739ae039 = $63f066b46e18ed3f$var$outlinedInputClasses;



var $ajTRS = parcelRequire("ajTRS");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");

function $5cf357f4d885f067$export$3331e419f1a48437(slot) {
    return (0, $iNQht.default)("MuiFilledInput", slot);
}
const $5cf357f4d885f067$var$filledInputClasses = (0, $ajTRS.default)({}, (0, $c2dea97f51686c9f$export$2e2bcd8739ae039), (0, $dfswM.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $5cf357f4d885f067$export$2e2bcd8739ae039 = $5cf357f4d885f067$var$filledInputClasses;



parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $db0bcc027518db01$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");



var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $018ccc2c6fba1eab$export$8ee01529667e66d9(slot) {
    return (0, $iNQht.default)("MuiAutocomplete", slot);
}
const $018ccc2c6fba1eab$var$autocompleteClasses = (0, $dfswM.default)("MuiAutocomplete", [
    "root",
    "expanded",
    "fullWidth",
    "focused",
    "focusVisible",
    "tag",
    "tagSizeSmall",
    "tagSizeMedium",
    "hasPopupIcon",
    "hasClearIcon",
    "inputRoot",
    "input",
    "inputFocused",
    "endAdornment",
    "clearIndicator",
    "popupIndicator",
    "popupIndicatorOpen",
    "popper",
    "popperDisablePortal",
    "paper",
    "listbox",
    "loading",
    "noOptions",
    "option",
    "groupLabel",
    "groupUl"
]);
var $018ccc2c6fba1eab$export$2e2bcd8739ae039 = $018ccc2c6fba1eab$var$autocompleteClasses;



var $5wtOU = parcelRequire("5wtOU");


var $3Py8h = parcelRequire("3Py8h");
"use client";
var $1a7eda2b3de6c330$var$_ClearIcon, $1a7eda2b3de6c330$var$_ArrowDropDownIcon;
const $1a7eda2b3de6c330$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionKey",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $1a7eda2b3de6c330$var$_excluded2 = [
    "ref"
], $1a7eda2b3de6c330$var$_excluded3 = [
    "key"
];
const $1a7eda2b3de6c330$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            expanded && "expanded",
            focused && "focused",
            fullWidth && "fullWidth",
            hasClearIcon && "hasClearIcon",
            hasPopupIcon && "hasPopupIcon"
        ],
        inputRoot: [
            "inputRoot"
        ],
        input: [
            "input",
            inputFocused && "inputFocused"
        ],
        tag: [
            "tag",
            `tagSize${(0, $5wtOU.default)(size)}`
        ],
        endAdornment: [
            "endAdornment"
        ],
        clearIndicator: [
            "clearIndicator"
        ],
        popupIndicator: [
            "popupIndicator",
            popupOpen && "popupIndicatorOpen"
        ],
        popper: [
            "popper",
            disablePortal && "popperDisablePortal"
        ],
        paper: [
            "paper"
        ],
        listbox: [
            "listbox"
        ],
        loading: [
            "loading"
        ],
        noOptions: [
            "noOptions"
        ],
        option: [
            "option"
        ],
        groupLabel: [
            "groupLabel"
        ],
        groupUl: [
            "groupUl"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $018ccc2c6fba1eab$export$8ee01529667e66d9), classes);
};
const $1a7eda2b3de6c330$var$AutocompleteRoot = (0, $npagc.default)("div", {
    name: "MuiAutocomplete",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $5wtOU.default)(size)}`]
            },
            {
                [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        [`&.${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).focused} .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: "visible"
        },
        /* Avoid double tap issue on iOS */ "@media (pointer: fine)": {
            [`&:hover .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).clearIndicator}`]: {
                visibility: "visible"
            }
        }
    }, ownerState.fullWidth && {
        width: "100%"
    }, {
        [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).tag}`]: (0, $ajTRS.default)({
            margin: 3,
            maxWidth: "calc(100% - 6px)"
        }, ownerState.size === "small" && {
            margin: 2,
            maxWidth: "calc(100% - 4px)"
        }),
        [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).inputRoot}`]: {
            flexWrap: "wrap",
            [`.${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 30
            },
            [`.${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 56
            },
            [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).input}`]: {
                width: 0,
                minWidth: 30
            }
        },
        [`& .${(0, $cb8e517f1d05f7c2$export$2e2bcd8739ae039).root}`]: {
            paddingBottom: 1,
            "& .MuiInput-input": {
                padding: "4px 4px 4px 0px"
            }
        },
        [`& .${(0, $cb8e517f1d05f7c2$export$2e2bcd8739ae039).root}.${(0, $c2dea97f51686c9f$export$2e2bcd8739ae039).sizeSmall}`]: {
            [`& .${(0, $cb8e517f1d05f7c2$export$2e2bcd8739ae039).input}`]: {
                padding: "2px 4px 3px 0"
            }
        },
        [`& .${(0, $63f066b46e18ed3f$export$2e2bcd8739ae039).root}`]: {
            padding: 9,
            [`.${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).input}`]: {
                padding: "7.5px 4px 7.5px 5px"
            },
            [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $63f066b46e18ed3f$export$2e2bcd8739ae039).root}.${(0, $c2dea97f51686c9f$export$2e2bcd8739ae039).sizeSmall}`]: {
            // Don't specify paddingRight, as it overrides the default value set when there is only
            // one of the popup or clear icon as the specificity is equal so the latter one wins
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).input}`]: {
                padding: "2.5px 4px 2.5px 8px"
            }
        },
        [`& .${(0, $5cf357f4d885f067$export$2e2bcd8739ae039).root}`]: {
            paddingTop: 19,
            paddingLeft: 8,
            [`.${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $5cf357f4d885f067$export$2e2bcd8739ae039).input}`]: {
                padding: "7px 4px"
            },
            [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $5cf357f4d885f067$export$2e2bcd8739ae039).root}.${(0, $c2dea97f51686c9f$export$2e2bcd8739ae039).sizeSmall}`]: {
            paddingBottom: 1,
            [`& .${(0, $5cf357f4d885f067$export$2e2bcd8739ae039).input}`]: {
                padding: "2.5px 4px"
            }
        },
        [`& .${(0, $c2dea97f51686c9f$export$2e2bcd8739ae039).hiddenLabel}`]: {
            paddingTop: 8
        },
        [`& .${(0, $5cf357f4d885f067$export$2e2bcd8739ae039).root}.${(0, $c2dea97f51686c9f$export$2e2bcd8739ae039).hiddenLabel}`]: {
            paddingTop: 0,
            paddingBottom: 0,
            [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).input}`]: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        [`& .${(0, $5cf357f4d885f067$export$2e2bcd8739ae039).root}.${(0, $c2dea97f51686c9f$export$2e2bcd8739ae039).hiddenLabel}.${(0, $c2dea97f51686c9f$export$2e2bcd8739ae039).sizeSmall}`]: {
            [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).input}`]: {
                paddingTop: 8,
                paddingBottom: 9
            }
        },
        [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).input}`]: (0, $ajTRS.default)({
            flexGrow: 1,
            textOverflow: "ellipsis",
            opacity: 0
        }, ownerState.inputFocused && {
            opacity: 1
        })
    }));
const $1a7eda2b3de6c330$var$AutocompleteEndAdornment = (0, $npagc.default)("div", {
    name: "MuiAutocomplete",
    slot: "EndAdornment",
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: "absolute",
    right: 0,
    top: "calc(50% - 14px)" // Center vertically
});
const $1a7eda2b3de6c330$var$AutocompleteClearIndicator = (0, $npagc.default)((0, $5c784366741908ee$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "ClearIndicator",
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: "hidden"
});
const $1a7eda2b3de6c330$var$AutocompletePopupIndicator = (0, $npagc.default)((0, $5c784366741908ee$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "PopupIndicator",
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $ajTRS.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        padding: 2,
        marginRight: -2
    }, ownerState.popupOpen && {
        transform: "rotate(180deg)"
    }));
const $1a7eda2b3de6c330$var$AutocompletePopper = (0, $npagc.default)((0, $9523926f49e29683$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        zIndex: (theme.vars || theme).zIndex.modal
    }, ownerState.disablePortal && {
        position: "absolute"
    }));
const $1a7eda2b3de6c330$var$AutocompletePaper = (0, $npagc.default)((0, $0a163fcc25046a25$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $ajTRS.default)({}, theme.typography.body1, {
        overflow: "auto"
    }));
const $1a7eda2b3de6c330$var$AutocompleteLoading = (0, $npagc.default)("div", {
    name: "MuiAutocomplete",
    slot: "Loading",
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $1a7eda2b3de6c330$var$AutocompleteNoOptions = (0, $npagc.default)("div", {
    name: "MuiAutocomplete",
    slot: "NoOptions",
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $1a7eda2b3de6c330$var$AutocompleteListbox = (0, $npagc.default)("div", {
    name: "MuiAutocomplete",
    slot: "Listbox",
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: "none",
        margin: 0,
        padding: "8px 0",
        maxHeight: "40vh",
        overflow: "auto",
        position: "relative",
        [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: "flex",
            overflow: "hidden",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: 6,
            boxSizing: "border-box",
            outline: "0",
            WebkitTapHighlightColor: "transparent",
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up("sm")]: {
                minHeight: "auto"
            },
            [`&.${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: "none"
            },
            [`&.${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $1a7eda2b3de6c330$var$AutocompleteGroupLabel = (0, $npagc.default)((0, $73bbeed63998f838$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "GroupLabel",
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $1a7eda2b3de6c330$var$AutocompleteGroupUl = (0, $npagc.default)("ul", {
    name: "MuiAutocomplete",
    slot: "GroupUl",
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $018ccc2c6fba1eab$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $1a7eda2b3de6c330$var$Autocomplete = /*#__PURE__*/ $1T1QG.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiAutocomplete"
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $1a7eda2b3de6c330$var$_ClearIcon || ($1a7eda2b3de6c330$var$_ClearIcon = /*#__PURE__*/ (0, $3Py8h.jsx)((0, $544593ea7d4730e2$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = "Clear", closeText: closeText = "Close", componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = "auto", freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = "ul", ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = "No options", openOnFocus: openOnFocus = false, openText: openText = "Open", PaperComponent: PaperComponent = (0, $0a163fcc25046a25$export$2e2bcd8739ae039), PopperComponent: PopperComponent = (0, $9523926f49e29683$export$2e2bcd8739ae039), popupIcon: popupIcon = $1a7eda2b3de6c330$var$_ArrowDropDownIcon || ($1a7eda2b3de6c330$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $3Py8h.jsx)((0, $db0bcc027518db01$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = "medium", slotProps: slotProps = {} } = props, other = (0, $iXdVf.default)(props, $1a7eda2b3de6c330$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $7adc4d7584341520$export$1e40b3ca02d92d21)((0, $ajTRS.default)({}, props, {
        componentName: "Autocomplete"
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $iXdVf.default)(_getListboxProps, $1a7eda2b3de6c330$var$_excluded2);
    const combinedListboxRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $ajTRS.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $1a7eda2b3de6c330$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $ajTRS.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $6778801d3fbd7fc0$export$2e2bcd8739ae039), (0, $ajTRS.default)({
                label: getOptionLabel(option),
                size: size
            }, getCustomizedTagProps({
                index: index
            }), ChipProps)));
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $3Py8h.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $3Py8h.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)($1a7eda2b3de6c330$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)($1a7eda2b3de6c330$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        const { key: key } = props2, otherProps = (0, $iXdVf.default)(props2, $1a7eda2b3de6c330$var$_excluded3);
        return /*#__PURE__*/ (0, $3Py8h.jsx)("li", (0, $ajTRS.default)({}, otherProps, {
            children: getOptionLabel(option)
        }), key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $ajTRS.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps["aria-selected"],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)($1a7eda2b3de6c330$var$AutocompleteRoot, (0, $ajTRS.default)({
                ref: ref,
                className: (0, $aVXbR.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === "small" ? "small" : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $ajTRS.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $3Py8h.jsxs)($1a7eda2b3de6c330$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $3Py8h.jsx)($1a7eda2b3de6c330$var$AutocompleteClearIndicator, (0, $ajTRS.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $aVXbR.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $3Py8h.jsx)($1a7eda2b3de6c330$var$AutocompletePopupIndicator, (0, $ajTRS.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $aVXbR.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $ajTRS.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? /*#__PURE__*/ (0, $3Py8h.jsx)($1a7eda2b3de6c330$var$AutocompletePopper, (0, $ajTRS.default)({
                as: PopperComponent,
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: popupOpen
            }, popperSlotProps, {
                className: (0, $aVXbR.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
                children: /*#__PURE__*/ (0, $3Py8h.jsxs)($1a7eda2b3de6c330$var$AutocompletePaper, (0, $ajTRS.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, paperSlotProps, {
                    className: (0, $aVXbR.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $3Py8h.jsx)($1a7eda2b3de6c330$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $3Py8h.jsx)($1a7eda2b3de6c330$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $3Py8h.jsx)($1a7eda2b3de6c330$var$AutocompleteListbox, (0, $ajTRS.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, otherListboxProps, ListboxProps, {
                            ref: combinedListboxRef,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            })) : null
        ]
    });
});
var $1a7eda2b3de6c330$export$2e2bcd8739ae039 = $1a7eda2b3de6c330$var$Autocomplete;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $be9b17d8e974e085$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $be9b17d8e974e085$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($be9b17d8e974e085$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $be9b17d8e974e085$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $be9b17d8e974e085$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $5wtOU = parcelRequire("5wtOU");

var $1T1QG = parcelRequire("1T1QG");
function $53078ccd586b1491$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $1T1QG.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $3a846aadfcffc110$export$2e2bcd8739ae039 = (0, $53078ccd586b1491$export$2e2bcd8739ae039);



var $1T1QG = parcelRequire("1T1QG");
/**
 * @ignore - internal component.
 */ const $c399561ca469fdec$var$FormControlContext = /*#__PURE__*/ $1T1QG.createContext(undefined);
var $c399561ca469fdec$export$2e2bcd8739ae039 = $c399561ca469fdec$var$FormControlContext;



var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $493390da3731fbda$export$149c8b8bab2289d1(slot) {
    return (0, $iNQht.default)("MuiFormControl", slot);
}
const $493390da3731fbda$var$formControlClasses = (0, $dfswM.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $493390da3731fbda$export$2e2bcd8739ae039 = $493390da3731fbda$var$formControlClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $7c26d84ab517f189$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $7c26d84ab517f189$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $5wtOU.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $493390da3731fbda$export$149c8b8bab2289d1), classes);
};
const $7c26d84ab517f189$var$FormControlRoot = (0, $npagc.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $ajTRS.default)({}, styles.root, styles[`margin${(0, $5wtOU.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $7c26d84ab517f189$var$FormControl = /*#__PURE__*/ $1T1QG.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $iXdVf.default)(props, $7c26d84ab517f189$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $7c26d84ab517f189$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $1T1QG.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $1T1QG.Children.forEach(children, (child)=>{
            if (!(0, $3a846aadfcffc110$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $3a846aadfcffc110$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $be9b17d8e974e085$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $1T1QG.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $1T1QG.Children.forEach(children, (child)=>{
            if (!(0, $3a846aadfcffc110$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $be9b17d8e974e085$export$d652b828d7fdeff8)(child.props, true) || (0, $be9b17d8e974e085$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $1T1QG.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $1T1QG.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c399561ca469fdec$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($7c26d84ab517f189$var$FormControlRoot, (0, $ajTRS.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $aVXbR.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $7c26d84ab517f189$export$2e2bcd8739ae039 = $7c26d84ab517f189$var$FormControl;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");

var $1T1QG = parcelRequire("1T1QG");

"use client";
function $83a17b5295da3528$export$2e2bcd8739ae039() {
    return $1T1QG.useContext((0, $c399561ca469fdec$export$2e2bcd8739ae039));
}




var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $3MwXn = parcelRequire("3MwXn");
var $iV85C = parcelRequire("iV85C");
var $iNQht = parcelRequire("iNQht");

var $ae0R6 = parcelRequire("ae0R6");
const $2058cdfdf1f50d42$var$styled = (0, $ae0R6.default)();
var $2058cdfdf1f50d42$export$2e2bcd8739ae039 = $2058cdfdf1f50d42$var$styled;



var $63vkt = parcelRequire("63vkt");


var $3osRD = parcelRequire("3osRD");

var $leuQP = parcelRequire("leuQP");

var $crrI5 = parcelRequire("crrI5");

var $3Py8h = parcelRequire("3Py8h");
const $f537a3568678efcc$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $f537a3568678efcc$var$defaultTheme = (0, $3osRD.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $f537a3568678efcc$var$defaultCreateStyledComponent = (0, $2058cdfdf1f50d42$export$2e2bcd8739ae039)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $f537a3568678efcc$var$useThemePropsDefault(props) {
    return (0, $63vkt.default)({
        props: props,
        name: "MuiStack",
        defaultTheme: $f537a3568678efcc$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $f537a3568678efcc$var$joinChildren(children, separator) {
    const childrenArray = $1T1QG.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $1T1QG.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $f537a3568678efcc$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $f537a3568678efcc$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $ajTRS.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $leuQP.handleBreakpoints)({
        theme: theme
    }, (0, $leuQP.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $crrI5.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $leuQP.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $leuQP.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $crrI5.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                "& > :not(style):not(style)": {
                    margin: 0
                },
                "& > :not(style) ~ :not(style)": {
                    [`margin${$f537a3568678efcc$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $crrI5.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $3MwXn.default)(styles, (0, $leuQP.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $leuQP.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $f537a3568678efcc$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $f537a3568678efcc$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $f537a3568678efcc$var$useThemePropsDefault, componentName: componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $iV85C.default)(slots, (slot)=>(0, $iNQht.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($f537a3568678efcc$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $1T1QG.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $a5c864e19e03ba63$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $iXdVf.default)(props, $f537a3568678efcc$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $3Py8h.jsx)(StackRoot, (0, $ajTRS.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $aVXbR.default)(classes.root, className)
        }, other, {
            children: divider ? $f537a3568678efcc$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");
"use client";
const $3fa3acfa795f4699$var$Stack = (0, $f537a3568678efcc$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $npagc.default)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $gADeF.default)({
            props: inProps,
            name: "MuiStack"
        })
});
var $3fa3acfa795f4699$export$2e2bcd8739ae039 = $3fa3acfa795f4699$var$Stack;




var $5wtOU = parcelRequire("5wtOU");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $944ea463c13ccae9$export$717666c39ec07e12(slot) {
    return (0, $iNQht.default)("MuiFormControlLabel", slot);
}
const $944ea463c13ccae9$var$formControlLabelClasses = (0, $dfswM.default)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error",
    "required",
    "asterisk"
]);
var $944ea463c13ccae9$export$2e2bcd8739ae039 = $944ea463c13ccae9$var$formControlLabelClasses;


function $5463d9638c422d7c$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $8a4dd1af00f66836$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $8a4dd1af00f66836$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, $5wtOU.default)(labelPlacement)}`,
            error && "error",
            required && "required"
        ],
        label: [
            "label",
            disabled && "disabled"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $944ea463c13ccae9$export$717666c39ec07e12), classes);
};
const $8a4dd1af00f66836$export$1b479270917a5676 = (0, $npagc.default)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $944ea463c13ccae9$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $5wtOU.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $944ea463c13ccae9$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.labelPlacement === "start" && {
        flexDirection: "row-reverse",
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === "top" && {
        flexDirection: "column-reverse",
        marginLeft: 16
    }, ownerState.labelPlacement === "bottom" && {
        flexDirection: "column",
        marginLeft: 16
    }, {
        [`& .${(0, $944ea463c13ccae9$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $944ea463c13ccae9$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $8a4dd1af00f66836$var$AsteriskComponent = (0, $npagc.default)("span", {
    name: "MuiFormControlLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $944ea463c13ccae9$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $8a4dd1af00f66836$var$FormControlLabel = /*#__PURE__*/ $1T1QG.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = "end", required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $iXdVf.default)(props, $8a4dd1af00f66836$var$_excluded);
    const muiFormControl = (0, $83a17b5295da3528$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, $5463d9638c422d7c$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $ajTRS.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $8a4dd1af00f66836$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $a386176d6ca21602$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a386176d6ca21602$export$2e2bcd8739ae039), (0, $ajTRS.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $aVXbR.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($8a4dd1af00f66836$export$1b479270917a5676, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $1T1QG.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3fa3acfa795f4699$export$2e2bcd8739ae039), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $3Py8h.jsxs)($8a4dd1af00f66836$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            "*"
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $8a4dd1af00f66836$export$2e2bcd8739ae039 = $8a4dd1af00f66836$var$FormControlLabel;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");



var $5wtOU = parcelRequire("5wtOU");

var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $9b2bcd5e7c10ea5a$export$f7d501e40371cd17(slot) {
    return (0, $iNQht.default)("MuiFormLabel", slot);
}
const $9b2bcd5e7c10ea5a$var$formLabelClasses = (0, $dfswM.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $9b2bcd5e7c10ea5a$export$2e2bcd8739ae039 = $9b2bcd5e7c10ea5a$var$formLabelClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $4d34a93ef05aacc5$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $4d34a93ef05aacc5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $5wtOU.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $9b2bcd5e7c10ea5a$export$f7d501e40371cd17), classes);
};
const $4d34a93ef05aacc5$export$aa5bc7f8a4705b27 = (0, $npagc.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $ajTRS.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $9b2bcd5e7c10ea5a$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $9b2bcd5e7c10ea5a$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $9b2bcd5e7c10ea5a$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $4d34a93ef05aacc5$var$AsteriskComponent = (0, $npagc.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $9b2bcd5e7c10ea5a$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $4d34a93ef05aacc5$var$FormLabel = /*#__PURE__*/ $1T1QG.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $iXdVf.default)(props, $4d34a93ef05aacc5$var$_excluded);
    const muiFormControl = (0, $83a17b5295da3528$export$2e2bcd8739ae039)();
    const fcs = (0, $5463d9638c422d7c$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $ajTRS.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $4d34a93ef05aacc5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($4d34a93ef05aacc5$export$aa5bc7f8a4705b27, (0, $ajTRS.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $aVXbR.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $3Py8h.jsxs)($4d34a93ef05aacc5$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
var $4d34a93ef05aacc5$export$2e2bcd8739ae039 = $4d34a93ef05aacc5$var$FormLabel;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $iV85C = parcelRequire("iV85C");

var $aVXbR = parcelRequire("aVXbR");




var $gADeF = parcelRequire("gADeF");

var $5wtOU = parcelRequire("5wtOU");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $d054bb04eb137252$export$c1c4b4545ad2ea5f(slot) {
    return (0, $iNQht.default)("MuiInputLabel", slot);
}
const $d054bb04eb137252$var$inputLabelClasses = (0, $dfswM.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $d054bb04eb137252$export$2e2bcd8739ae039 = $d054bb04eb137252$var$inputLabelClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $f4e04526214b55b7$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $f4e04526214b55b7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, $5wtOU.default)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $iV85C.default)(slots, (0, $d054bb04eb137252$export$c1c4b4545ad2ea5f), classes);
    return (0, $ajTRS.default)({}, classes, composedClasses);
};
const $f4e04526214b55b7$var$InputLabelRoot = (0, $npagc.default)((0, $4d34a93ef05aacc5$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $npagc.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $9b2bcd5e7c10ea5a$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $ajTRS.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $ajTRS.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $ajTRS.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $f4e04526214b55b7$var$InputLabel = /*#__PURE__*/ $1T1QG.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $gADeF.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $iXdVf.default)(props, $f4e04526214b55b7$var$_excluded);
    const muiFormControl = (0, $83a17b5295da3528$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $5463d9638c422d7c$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required",
            "focused"
        ]
    });
    const ownerState = (0, $ajTRS.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $f4e04526214b55b7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($f4e04526214b55b7$var$InputLabelRoot, (0, $ajTRS.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $aVXbR.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $f4e04526214b55b7$export$2e2bcd8739ae039 = $f4e04526214b55b7$var$InputLabel;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");

var $7Etkp = parcelRequire("7Etkp");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");

var $5wtOU = parcelRequire("5wtOU");

var $npagc = parcelRequire("npagc");

"use client";
var $d1acf12366a469be$export$2e2bcd8739ae039 = (0, $328d428125b56996$export$2e2bcd8739ae039);





var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $45df37188db3053f$export$baa0faa0c7ad8085(slot) {
    return (0, $iNQht.default)("PrivateSwitchBase", slot);
}
const $45df37188db3053f$var$switchBaseClasses = (0, $dfswM.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $45df37188db3053f$export$2e2bcd8739ae039 = $45df37188db3053f$var$switchBaseClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $aa7769819719368a$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $aa7769819719368a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $5wtOU.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $45df37188db3053f$export$baa0faa0c7ad8085), classes);
};
const $aa7769819719368a$var$SwitchBaseRoot = (0, $npagc.default)((0, $ecc40a2d226ef234$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $aa7769819719368a$var$SwitchBaseInput = (0, $npagc.default)("input", {
    shouldForwardProp: (0, $npagc.rootShouldForwardProp)
})({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $aa7769819719368a$var$SwitchBase = /*#__PURE__*/ $1T1QG.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $iXdVf.default)(props, $aa7769819719368a$var$_excluded);
    const [checked, setCheckedState] = (0, $d1acf12366a469be$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $83a17b5295da3528$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $ajTRS.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $aa7769819719368a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($aa7769819719368a$var$SwitchBaseRoot, (0, $ajTRS.default)({
        component: "span",
        className: (0, $aVXbR.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)($aa7769819719368a$var$SwitchBaseInput, (0, $ajTRS.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $aa7769819719368a$export$2e2bcd8739ae039 = $aa7769819719368a$var$SwitchBase;



var $gADeF = parcelRequire("gADeF");

var $ajTRS = parcelRequire("ajTRS");
parcelRequire("1T1QG");

parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $6a2b0b8a211cd826$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked");


parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $88ab5edac31104b7$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked");



var $npagc = parcelRequire("npagc");

var $3Py8h = parcelRequire("3Py8h");
"use client";
const $4628019bcae70b13$var$RadioButtonIconRoot = (0, $npagc.default)("span", {
    shouldForwardProp: (0, $npagc.rootShouldForwardProp)
})({
    position: "relative",
    display: "flex"
});
const $4628019bcae70b13$var$RadioButtonIconBackground = (0, $npagc.default)((0, $6a2b0b8a211cd826$export$2e2bcd8739ae039))({
    // Scale applied to prevent dot misalignment in Safari
    transform: "scale(1)"
});
const $4628019bcae70b13$var$RadioButtonIconDot = (0, $npagc.default)((0, $88ab5edac31104b7$export$2e2bcd8739ae039))(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        left: 0,
        position: "absolute",
        transform: "scale(0)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: "scale(1)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $4628019bcae70b13$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $ajTRS.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($4628019bcae70b13$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)($4628019bcae70b13$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)($4628019bcae70b13$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $4628019bcae70b13$export$2e2bcd8739ae039 = $4628019bcae70b13$var$RadioButtonIcon;



var $5wtOU = parcelRequire("5wtOU");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $dd288ab45f193197$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}


var $26e427956c242c7b$export$2e2bcd8739ae039 = (0, $dd288ab45f193197$export$2e2bcd8739ae039);



var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");
/**
 * @ignore - internal component.
 */ const $9f2d8b467939ac6b$var$RadioGroupContext = /*#__PURE__*/ $1T1QG.createContext(undefined);
var $9f2d8b467939ac6b$export$2e2bcd8739ae039 = $9f2d8b467939ac6b$var$RadioGroupContext;


"use client";
function $c32cca3e61048ad2$export$2e2bcd8739ae039() {
    return $1T1QG.useContext((0, $9f2d8b467939ac6b$export$2e2bcd8739ae039));
}



var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $495a08e106172cf4$export$192f7b2363c77155(slot) {
    return (0, $iNQht.default)("MuiRadio", slot);
}
const $495a08e106172cf4$var$radioClasses = (0, $dfswM.default)("MuiRadio", [
    "root",
    "checked",
    "disabled",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall"
]);
var $495a08e106172cf4$export$2e2bcd8739ae039 = $495a08e106172cf4$var$radioClasses;



var $npagc = parcelRequire("npagc");

var $3Py8h = parcelRequire("3Py8h");
"use client";
const $c7a6a2f699a36e04$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size",
    "className"
];
const $c7a6a2f699a36e04$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $5wtOU.default)(color)}`,
            size !== "medium" && `size${(0, $5wtOU.default)(size)}`
        ]
    };
    return (0, $ajTRS.default)({}, classes, (0, $iV85C.default)(slots, (0, $495a08e106172cf4$export$192f7b2363c77155), classes));
};
const $c7a6a2f699a36e04$var$RadioRoot = (0, $npagc.default)((0, $aa7769819719368a$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $npagc.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiRadio",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== "medium" && styles[`size${(0, $5wtOU.default)(ownerState.size)}`],
            styles[`color${(0, $5wtOU.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7Etkp.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $495a08e106172cf4$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $495a08e106172cf4$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function $c7a6a2f699a36e04$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $c7a6a2f699a36e04$var$defaultCheckedIcon = /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4628019bcae70b13$export$2e2bcd8739ae039), {
    checked: true
});
const $c7a6a2f699a36e04$var$defaultIcon = /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4628019bcae70b13$export$2e2bcd8739ae039), {});
const $c7a6a2f699a36e04$var$Radio = /*#__PURE__*/ $1T1QG.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiRadio"
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $c7a6a2f699a36e04$var$defaultCheckedIcon, color: color = "primary", icon: icon = $c7a6a2f699a36e04$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = "medium", className: className } = props, other = (0, $iXdVf.default)(props, $c7a6a2f699a36e04$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $c7a6a2f699a36e04$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $c32cca3e61048ad2$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $26e427956c242c7b$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === "undefined") checked = $c7a6a2f699a36e04$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === "undefined") name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $3Py8h.jsx)($c7a6a2f699a36e04$var$RadioRoot, (0, $ajTRS.default)({
        type: "radio",
        icon: /*#__PURE__*/ $1T1QG.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $c7a6a2f699a36e04$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $1T1QG.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $c7a6a2f699a36e04$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $aVXbR.default)(classes.root, className)
    }, other));
});
var $c7a6a2f699a36e04$export$2e2bcd8739ae039 = $c7a6a2f699a36e04$var$Radio;


var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $3MwXn = parcelRequire("3MwXn");

var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $fxhNB = parcelRequire("fxhNB");

var $1T1QG = parcelRequire("1T1QG");



var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");



var $5wtOU = parcelRequire("5wtOU");

var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");



var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");




var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");


var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $ae3c34df0623be15$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $48e766ac1390e9bf$export$2e2bcd8739ae039 = (0, $ae3c34df0623be15$export$2e2bcd8739ae039);




function $082f5cce4853fb88$export$2e2bcd8739ae039(node) {
    const doc = (0, $743613eeafeadd3a$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $200f56383d159758$export$2e2bcd8739ae039 = (0, $082f5cce4853fb88$export$2e2bcd8739ae039);





var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");



var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");



// Is a vertical scrollbar displayed?
function $0158d265ac0385df$var$isOverflowing(container) {
    const doc = (0, $743613eeafeadd3a$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $082f5cce4853fb88$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $0158d265ac0385df$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $0158d265ac0385df$var$getPaddingRight(element) {
    return parseInt((0, $082f5cce4853fb88$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $0158d265ac0385df$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $0158d265ac0385df$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$0158d265ac0385df$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $0158d265ac0385df$export$e1bd0c6150f13d96(element, show);
    });
}
function $0158d265ac0385df$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $0158d265ac0385df$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($0158d265ac0385df$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $1f4ecd10afea7820$export$2e2bcd8739ae039)((0, $743613eeafeadd3a$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$0158d265ac0385df$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $743613eeafeadd3a$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$0158d265ac0385df$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $743613eeafeadd3a$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $082f5cce4853fb88$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $0158d265ac0385df$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $0158d265ac0385df$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $0158d265ac0385df$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $0158d265ac0385df$var$getHiddenSiblings(container);
        $0158d265ac0385df$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $0158d265ac0385df$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $0158d265ac0385df$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $0158d265ac0385df$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $0158d265ac0385df$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $0158d265ac0385df$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $0158d265ac0385df$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $0158d265ac0385df$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


"use client";
function $19d85b68686c066b$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $19d85b68686c066b$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $19d85b68686c066b$var$defaultManager = new (0, $0158d265ac0385df$export$ce11c4ecd08cea67)();
function $19d85b68686c066b$export$33ffd74ebf07f060(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $19d85b68686c066b$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $1T1QG.useRef({});
    const mountNodeRef = $1T1QG.useRef(null);
    const modalRef = $1T1QG.useRef(null);
    const handleRef = (0, $d2fee4866c2743fb$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $1T1QG.useState(!open);
    const hasTransition = $19d85b68686c066b$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $743613eeafeadd3a$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $f10dd87bccb0014d$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $19d85b68686c066b$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $1T1QG.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $f10dd87bccb0014d$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $0158d265ac0385df$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $1T1QG.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $1T1QG.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $1T1QG.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $f63967d7c4f59bd9$export$24d5698b57eff81c)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $ajTRS.default)({}, propsEventHandlers, otherHandlers);
        return (0, $ajTRS.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $ajTRS.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $dd288ab45f193197$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $dd288ab45f193197$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}



var $iV85C = parcelRequire("iV85C");

var $1T1QG = parcelRequire("1T1QG");



var $3Py8h = parcelRequire("3Py8h");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $700e11d6df3fb857$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $700e11d6df3fb857$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $700e11d6df3fb857$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $700e11d6df3fb857$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $700e11d6df3fb857$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $700e11d6df3fb857$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($700e11d6df3fb857$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $700e11d6df3fb857$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$700e11d6df3fb857$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $700e11d6df3fb857$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $700e11d6df3fb857$export$34eba2437817a67b(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $700e11d6df3fb857$var$defaultGetTabbable, isEnabled: isEnabled = $700e11d6df3fb857$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $1T1QG.useRef(false);
    const sentinelStart = $1T1QG.useRef(null);
    const sentinelEnd = $1T1QG.useRef(null);
    const nodeToRestore = $1T1QG.useRef(null);
    const reactFocusEventTarget = $1T1QG.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $1T1QG.useRef(false);
    const rootRef = $1T1QG.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $d2fee4866c2743fb$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $1T1QG.useRef(null);
    $1T1QG.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $1T1QG.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $743613eeafeadd3a$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $1T1QG.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $743613eeafeadd3a$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $1T1QG.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}




var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");







var $3Py8h = parcelRequire("3Py8h");
"use client";
const $a2c582129c3c8d70$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $a2c582129c3c8d70$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $a2c582129c3c8d70$var$Fade = /*#__PURE__*/ $1T1QG.forwardRef(function Fade(props, ref) {
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $97e45c35ce24099f$export$2e2bcd8739ae039) } = props, other = (0, $iXdVf.default)(props, $a2c582129c3c8d70$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $1T1QG.useRef(null);
    const handleRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $3c14342afe4d3400$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $3c14342afe4d3400$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $3c14342afe4d3400$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)(TransitionComponent, (0, $ajTRS.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $1T1QG.cloneElement(children, (0, $ajTRS.default)({
                style: (0, $ajTRS.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $a2c582129c3c8d70$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $a2c582129c3c8d70$export$2e2bcd8739ae039 = $a2c582129c3c8d70$var$Fade;



var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $a0eee6dcad9de8f7$export$9927a91fd93152bd(slot) {
    return (0, $iNQht.default)("MuiBackdrop", slot);
}
const $a0eee6dcad9de8f7$var$backdropClasses = (0, $dfswM.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $a0eee6dcad9de8f7$export$2e2bcd8739ae039 = $a0eee6dcad9de8f7$var$backdropClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $9702be143407857e$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $9702be143407857e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $a0eee6dcad9de8f7$export$9927a91fd93152bd), classes);
};
const $9702be143407857e$var$BackdropRoot = (0, $npagc.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $9702be143407857e$var$Backdrop = /*#__PURE__*/ $1T1QG.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $a2c582129c3c8d70$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $iXdVf.default)(props, $9702be143407857e$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $9702be143407857e$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $3Py8h.jsx)(TransitionComponent, (0, $ajTRS.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($9702be143407857e$var$BackdropRoot, (0, $ajTRS.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $aVXbR.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $ajTRS.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $9702be143407857e$export$2e2bcd8739ae039 = $9702be143407857e$var$Backdrop;



var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $d8ef771acfde8dd6$export$67960e22b12a638d(slot) {
    return (0, $iNQht.default)("MuiModal", slot);
}
const $d8ef771acfde8dd6$var$modalClasses = (0, $dfswM.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $d8ef771acfde8dd6$export$2e2bcd8739ae039 = $d8ef771acfde8dd6$var$modalClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $167f720a102c0662$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $167f720a102c0662$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $d8ef771acfde8dd6$export$67960e22b12a638d), classes);
};
const $167f720a102c0662$var$ModalRoot = (0, $npagc.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $167f720a102c0662$var$ModalBackdrop = (0, $npagc.default)((0, $9702be143407857e$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $167f720a102c0662$var$Modal = /*#__PURE__*/ $1T1QG.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $gADeF.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $167f720a102c0662$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $iXdVf.default)(props, $167f720a102c0662$var$_excluded);
    const propsWithDefaults = (0, $ajTRS.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $19d85b68686c066b$export$33ffd74ebf07f060)((0, $ajTRS.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $ajTRS.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $167f720a102c0662$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $167f720a102c0662$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $3b38c2c568b5248d$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $aVXbR.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $3b38c2c568b5248d$export$1e5c9e6e4e15efe3)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $ajTRS.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $aVXbR.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $23736008cbe3d7fa$export$602eac185826482c), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $3Py8h.jsxs)(RootSlot, (0, $ajTRS.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $3Py8h.jsx)(BackdropSlot, (0, $ajTRS.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $700e11d6df3fb857$export$34eba2437817a67b), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $1T1QG.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $167f720a102c0662$export$2e2bcd8739ae039 = $167f720a102c0662$var$Modal;




var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $c32c08d8b1af6d61$export$88f455dd56c95edb(slot) {
    return (0, $iNQht.default)("MuiPopover", slot);
}
const $c32c08d8b1af6d61$var$popoverClasses = (0, $dfswM.default)("MuiPopover", [
    "root",
    "paper"
]);
var $c32c08d8b1af6d61$export$2e2bcd8739ae039 = $c32c08d8b1af6d61$var$popoverClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $9af2eda26f6b5694$var$_excluded = [
    "onEntering"
], $9af2eda26f6b5694$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $9af2eda26f6b5694$var$_excluded3 = [
    "slotProps"
];
function $9af2eda26f6b5694$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $9af2eda26f6b5694$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $9af2eda26f6b5694$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $9af2eda26f6b5694$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $9af2eda26f6b5694$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $c32c08d8b1af6d61$export$88f455dd56c95edb), classes);
};
const $9af2eda26f6b5694$export$bcce13685275fc99 = (0, $npagc.default)((0, $167f720a102c0662$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $9af2eda26f6b5694$export$821346c38a2d9390 = (0, $npagc.default)((0, $0a163fcc25046a25$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $9af2eda26f6b5694$var$Popover = /*#__PURE__*/ $1T1QG.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $e236f531d361181f$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $iXdVf.default)(props.TransitionProps, $9af2eda26f6b5694$var$_excluded), other = (0, $iXdVf.default)(props, $9af2eda26f6b5694$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $1T1QG.useRef();
    const handlePaperRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $ajTRS.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $9af2eda26f6b5694$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $1T1QG.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $9af2eda26f6b5694$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $8c4927d8b7167c70$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $9af2eda26f6b5694$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $9af2eda26f6b5694$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $1T1QG.useCallback((elemRect)=>{
        return {
            vertical: $9af2eda26f6b5694$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $9af2eda26f6b5694$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $1T1QG.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $9af2eda26f6b5694$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $200f56383d159758$export$2e2bcd8739ae039)($9af2eda26f6b5694$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $9af2eda26f6b5694$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $1T1QG.useState(open);
    const setPositioningStyles = $1T1QG.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $1T1QG.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $1T1QG.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $1T1QG.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $1T1QG.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $48e766ac1390e9bf$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $200f56383d159758$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $8c4927d8b7167c70$export$2e2bcd8739ae039)($9af2eda26f6b5694$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $9af2eda26f6b5694$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $9af2eda26f6b5694$export$821346c38a2d9390;
    const paperProps = (0, $3b38c2c568b5248d$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: (0, $ajTRS.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $ajTRS.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $aVXbR.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $3b38c2c568b5248d$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $aVXbR.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $iXdVf.default)(_useSlotProps, $9af2eda26f6b5694$var$_excluded3);
    return /*#__PURE__*/ (0, $3Py8h.jsx)(RootSlot, (0, $ajTRS.default)({}, rootProps, !(0, $96ba78417123a6d2$export$e28348cc2430497)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)(TransitionComponent, (0, $ajTRS.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $3Py8h.jsx)(PaperSlot, (0, $ajTRS.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $9af2eda26f6b5694$export$2e2bcd8739ae039 = $9af2eda26f6b5694$var$Popover;



var $npagc = parcelRequire("npagc");


var $gADeF = parcelRequire("gADeF");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $cf173e64ea3dab4f$export$2cf86a63a84fe23d(slot) {
    return (0, $iNQht.default)("MuiMenu", slot);
}
const $cf173e64ea3dab4f$var$menuClasses = (0, $dfswM.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $cf173e64ea3dab4f$export$2e2bcd8739ae039 = $cf173e64ea3dab4f$var$menuClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $13f11e3c954e513e$var$_excluded = [
    "onEntering"
], $13f11e3c954e513e$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $13f11e3c954e513e$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $13f11e3c954e513e$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $13f11e3c954e513e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $cf173e64ea3dab4f$export$2cf86a63a84fe23d), classes);
};
const $13f11e3c954e513e$var$MenuRoot = (0, $npagc.default)((0, $9af2eda26f6b5694$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $npagc.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $13f11e3c954e513e$export$4f7c51a5920c9f33 = (0, $npagc.default)((0, $9af2eda26f6b5694$export$821346c38a2d9390), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $13f11e3c954e513e$var$MenuMenuList = (0, $npagc.default)((0, $0c6bdc89c1f59767$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $13f11e3c954e513e$var$Menu = /*#__PURE__*/ $1T1QG.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $iXdVf.default)(props.TransitionProps, $13f11e3c954e513e$var$_excluded), other = (0, $iXdVf.default)(props, $13f11e3c954e513e$var$_excluded2);
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $ajTRS.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $13f11e3c954e513e$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $1T1QG.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $1T1QG.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $1T1QG.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $13f11e3c954e513e$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $3b38c2c568b5248d$export$1e5c9e6e4e15efe3)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $3b38c2c568b5248d$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)($13f11e3c954e513e$var$MenuRoot, (0, $ajTRS.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $13f11e3c954e513e$var$RTL_ORIGIN : $13f11e3c954e513e$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $ajTRS.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($13f11e3c954e513e$var$MenuMenuList, (0, $ajTRS.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $aVXbR.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $13f11e3c954e513e$export$2e2bcd8739ae039 = $13f11e3c954e513e$var$Menu;



var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");

var $5wtOU = parcelRequire("5wtOU");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $a3f10e57c38c2f79$export$1ee13051fd9e2ab5(slot) {
    return (0, $iNQht.default)("MuiNativeSelect", slot);
}
const $a3f10e57c38c2f79$var$nativeSelectClasses = (0, $dfswM.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $a3f10e57c38c2f79$export$2e2bcd8739ae039 = $a3f10e57c38c2f79$var$nativeSelectClasses;



var $npagc = parcelRequire("npagc");

var $3Py8h = parcelRequire("3Py8h");
"use client";
const $602057aa3eee0e8c$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $602057aa3eee0e8c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $5wtOU.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $a3f10e57c38c2f79$export$1ee13051fd9e2ab5), classes);
};
const $602057aa3eee0e8c$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $ajTRS.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $ajTRS.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $a3f10e57c38c2f79$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $602057aa3eee0e8c$var$NativeSelectSelect = (0, $npagc.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $npagc.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $a3f10e57c38c2f79$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($602057aa3eee0e8c$export$c1eccd1617458c87);
const $602057aa3eee0e8c$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $ajTRS.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $a3f10e57c38c2f79$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $602057aa3eee0e8c$var$NativeSelectIcon = (0, $npagc.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $5wtOU.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($602057aa3eee0e8c$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $602057aa3eee0e8c$var$NativeSelectInput = /*#__PURE__*/ $1T1QG.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $iXdVf.default)(props, $602057aa3eee0e8c$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $602057aa3eee0e8c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)($602057aa3eee0e8c$var$NativeSelectSelect, (0, $ajTRS.default)({
                ownerState: ownerState,
                className: (0, $aVXbR.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $3Py8h.jsx)($602057aa3eee0e8c$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $602057aa3eee0e8c$export$2e2bcd8739ae039 = $602057aa3eee0e8c$var$NativeSelectInput;




var $npagc = parcelRequire("npagc");



var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $9ca5250931769d12$export$2c0c1ee5a3392e(slot) {
    return (0, $iNQht.default)("MuiSelect", slot);
}
const $9ca5250931769d12$var$selectClasses = (0, $dfswM.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $9ca5250931769d12$export$2e2bcd8739ae039 = $9ca5250931769d12$var$selectClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
var $58871410ea182a5e$var$_span;
const $58871410ea182a5e$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $58871410ea182a5e$var$SelectSelect = (0, $npagc.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $9ca5250931769d12$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $9ca5250931769d12$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $9ca5250931769d12$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $9ca5250931769d12$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $602057aa3eee0e8c$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $9ca5250931769d12$export$2e2bcd8739ae039).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $58871410ea182a5e$var$SelectIcon = (0, $npagc.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $5wtOU.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $602057aa3eee0e8c$export$e7a817afd12a40d0));
const $58871410ea182a5e$var$SelectNativeInput = (0, $npagc.default)("input", {
    shouldForwardProp: (prop)=>(0, $npagc.slotShouldForwardProp)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $58871410ea182a5e$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $58871410ea182a5e$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $58871410ea182a5e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $5wtOU.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $9ca5250931769d12$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $58871410ea182a5e$var$SelectInput = /*#__PURE__*/ $1T1QG.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $iXdVf.default)(props, $58871410ea182a5e$var$_excluded);
    const [value, setValueState] = (0, $d1acf12366a469be$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $d1acf12366a469be$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $1T1QG.useRef(null);
    const displayRef = $1T1QG.useRef(null);
    const [displayNode, setDisplayNode] = $1T1QG.useState(null);
    const { current: isOpenControlled } = $1T1QG.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $1T1QG.useState();
    const handleRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $1T1QG.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $1T1QG.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $1T1QG.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $1T1QG.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $1T1QG.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $8c4927d8b7167c70$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $1T1QG.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $be9b17d8e974e085$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $1T1QG.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $fxhNB.default)(2));
            selected = value.some((v)=>$58871410ea182a5e$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $58871410ea182a5e$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $1T1QG.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $ajTRS.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $58871410ea182a5e$var$useUtilityClasses(ownerState);
    const paperProps = (0, $ajTRS.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $9dc24b323e690fdf$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)($58871410ea182a5e$var$SelectSelect, (0, $ajTRS.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $aVXbR.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $58871410ea182a5e$var$isEmpty(display) ? $58871410ea182a5e$var$_span || ($58871410ea182a5e$var$_span = /*#__PURE__*/ (0, $3Py8h.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $3Py8h.jsx)($58871410ea182a5e$var$SelectNativeInput, (0, $ajTRS.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $3Py8h.jsx)($58871410ea182a5e$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $13f11e3c954e513e$export$2e2bcd8739ae039), (0, $ajTRS.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $ajTRS.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    "aria-multiselectable": multiple ? "true" : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $ajTRS.default)({}, MenuProps.slotProps, {
                    paper: (0, $ajTRS.default)({}, paperProps, {
                        style: (0, $ajTRS.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $58871410ea182a5e$export$2e2bcd8739ae039 = $58871410ea182a5e$var$SelectInput;






var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $iV85C = parcelRequire("iV85C");

var $3MwXn = parcelRequire("3MwXn");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $fxhNB = parcelRequire("fxhNB");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");




var $3Py8h = parcelRequire("3Py8h");
"use client";
const $585584ab83ed6d99$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $585584ab83ed6d99$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $585584ab83ed6d99$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $585584ab83ed6d99$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflow;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $585584ab83ed6d99$export$d1710922ecaf577a = /*#__PURE__*/ $1T1QG.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $iXdVf.default)(props, $585584ab83ed6d99$var$_excluded);
    const { current: isControlled } = $1T1QG.useRef(value != null);
    const inputRef = $1T1QG.useRef(null);
    const handleRef = (0, $d2fee4866c2743fb$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const shadowRef = $1T1QG.useRef(null);
    const renders = $1T1QG.useRef(0);
    const [state, setState] = $1T1QG.useState({
        outerHeightStyle: 0
    });
    const getUpdatedState = $1T1QG.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $082f5cce4853fb88$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $585584ab83ed6d99$var$getStyleValue(computedStyle.paddingBottom) + $585584ab83ed6d99$var$getStyleValue(computedStyle.paddingTop);
        const border = $585584ab83ed6d99$var$getStyleValue(computedStyle.borderBottomWidth) + $585584ab83ed6d99$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflow: overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const updateState = (prevState, newState)=>{
        const { outerHeightStyle: outerHeightStyle, overflow: overflow } = newState;
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow: overflow,
                outerHeightStyle: outerHeightStyle
            };
        }
        return prevState;
    };
    const syncHeight = $1T1QG.useCallback(()=>{
        const newState = getUpdatedState();
        if ($585584ab83ed6d99$var$isEmpty(newState)) return;
        setState((prevState)=>updateState(prevState, newState));
    }, [
        getUpdatedState
    ]);
    (0, $ac1861e6d86aa648$export$2e2bcd8739ae039)(()=>{
        const syncHeightWithFlushSync = ()=>{
            const newState = getUpdatedState();
            if ($585584ab83ed6d99$var$isEmpty(newState)) return;
            // In React 18, state updates in a ResizeObserver's callback are happening after
            // the paint, this leads to an infinite rendering.
            //
            // Using flushSync ensures that the states is updated before the next pain.
            // Related issue - https://github.com/facebook/react/issues/24331
            $27f1df944e3d0485$exports.flushSync(()=>{
                setState((prevState)=>updateState(prevState, newState));
            });
        };
        const handleResize = ()=>{
            renders.current = 0;
            syncHeightWithFlushSync();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $ae3c34df0623be15$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $082f5cce4853fb88$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener("resize", debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener("resize", debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        getUpdatedState
    ]);
    (0, $ac1861e6d86aa648$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    $1T1QG.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)("textarea", (0, $ajTRS.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: (0, $ajTRS.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? "hidden" : undefined
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $3Py8h.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $ajTRS.default)({}, $585584ab83ed6d99$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});


var $iV85C = parcelRequire("iV85C");




var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $5wtOU = parcelRequire("5wtOU");



var $ajTRS = parcelRequire("ajTRS");
parcelRequire("1T1QG");

parcelRequire("1T1QG");


var $l0LpY = parcelRequire("l0LpY");

var $5N3fo = parcelRequire("5N3fo");

var $3Py8h = parcelRequire("3Py8h");
"use client";
function $0b944bb8ebe5ae14$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $5N3fo.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $l0LpY.default), {
        styles: globalStyles
    });
}
var $0b944bb8ebe5ae14$export$2e2bcd8739ae039 = $0b944bb8ebe5ae14$var$GlobalStyles;



var $4Ydi5 = parcelRequire("4Ydi5");

var $557GP = parcelRequire("557GP");

var $3Py8h = parcelRequire("3Py8h");
"use client";
function $569c607adcdd8af6$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $0b944bb8ebe5ae14$export$2e2bcd8739ae039), (0, $ajTRS.default)({}, props, {
        defaultTheme: (0, $4Ydi5.default),
        themeId: (0, $557GP.default)
    }));
}
var $569c607adcdd8af6$export$2e2bcd8739ae039 = $569c607adcdd8af6$var$GlobalStyles;





var $3Py8h = parcelRequire("3Py8h");
"use client";
const $5d82838c205c229a$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $5d82838c205c229a$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $5wtOU.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $5d82838c205c229a$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $5d82838c205c229a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $5wtOU.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, $5wtOU.default)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $c2dea97f51686c9f$export$ef57d5c8ca2278f6), classes);
};
const $5d82838c205c229a$export$298a043133d72a38 = (0, $npagc.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $5d82838c205c229a$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $c2dea97f51686c9f$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $ajTRS.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $5d82838c205c229a$export$a1ad29c901026019 = (0, $npagc.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $5d82838c205c229a$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $ajTRS.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $ajTRS.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $c2dea97f51686c9f$export$2e2bcd8739ae039).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $c2dea97f51686c9f$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $5d82838c205c229a$var$inputGlobalStyles = /*#__PURE__*/ (0, $3Py8h.jsx)((0, $569c607adcdd8af6$export$2e2bcd8739ae039), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $5d82838c205c229a$var$InputBase = /*#__PURE__*/ $1T1QG.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $iXdVf.default)(props, $5d82838c205c229a$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $1T1QG.useRef(value != null);
    const inputRef = $1T1QG.useRef();
    const handleInputRefWarning = $1T1QG.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $1T1QG.useState(false);
    const muiFormControl = (0, $83a17b5295da3528$export$2e2bcd8739ae039)();
    const fcs = (0, $5463d9638c422d7c$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $1T1QG.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $1T1QG.useCallback((obj)=>{
        if ((0, $be9b17d8e974e085$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $675d87943b3ee26a$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $fxhNB.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $1T1QG.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $ajTRS.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $ajTRS.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $585584ab83ed6d99$export$d1710922ecaf577a);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $1T1QG.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $ajTRS.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $5d82838c205c229a$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $5d82838c205c229a$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $5d82838c205c229a$export$a1ad29c901026019;
    inputProps = (0, $ajTRS.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $5d82838c205c229a$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $3Py8h.jsxs)(Root, (0, $ajTRS.default)({}, rootProps, !(0, $96ba78417123a6d2$export$e28348cc2430497)(Root) && {
                ownerState: (0, $ajTRS.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $aVXbR.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c399561ca469fdec$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)(Input, (0, $ajTRS.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $96ba78417123a6d2$export$e28348cc2430497)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $ajTRS.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $aVXbR.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $ajTRS.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $5d82838c205c229a$export$2e2bcd8739ae039 = $5d82838c205c229a$var$InputBase;



var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $d5dac63d9f83cf1e$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $d5dac63d9f83cf1e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $iV85C.default)(slots, (0, $cb8e517f1d05f7c2$export$cdb270390122322b), classes);
    return (0, $ajTRS.default)({}, classes, composedClasses);
};
const $d5dac63d9f83cf1e$var$InputRoot = (0, $npagc.default)((0, $5d82838c205c229a$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $npagc.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $5d82838c205c229a$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $ajTRS.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $cb8e517f1d05f7c2$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $cb8e517f1d05f7c2$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $cb8e517f1d05f7c2$export$2e2bcd8739ae039).disabled}, .${(0, $cb8e517f1d05f7c2$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $cb8e517f1d05f7c2$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $d5dac63d9f83cf1e$var$InputInput = (0, $npagc.default)((0, $5d82838c205c229a$export$a1ad29c901026019), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $5d82838c205c229a$export$cf507b112810e72d)
})({});
const $d5dac63d9f83cf1e$var$Input = /*#__PURE__*/ $1T1QG.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $iXdVf.default)(props, $d5dac63d9f83cf1e$var$_excluded);
    const classes = $d5dac63d9f83cf1e$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3MwXn.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $d5dac63d9f83cf1e$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $d5dac63d9f83cf1e$var$InputInput;
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $5d82838c205c229a$export$2e2bcd8739ae039), (0, $ajTRS.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$d5dac63d9f83cf1e$var$Input.muiName = "Input";
var $d5dac63d9f83cf1e$export$2e2bcd8739ae039 = $d5dac63d9f83cf1e$var$Input;




var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");

var $3MwXn = parcelRequire("3MwXn");


var $iV85C = parcelRequire("iV85C");


var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $ff4b625adac9abd6$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $ff4b625adac9abd6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $iV85C.default)(slots, (0, $5cf357f4d885f067$export$3331e419f1a48437), classes);
    return (0, $ajTRS.default)({}, classes, composedClasses);
};
const $ff4b625adac9abd6$var$FilledInputRoot = (0, $npagc.default)((0, $5d82838c205c229a$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $npagc.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $5d82838c205c229a$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $ajTRS.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $5cf357f4d885f067$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $5cf357f4d885f067$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $5cf357f4d885f067$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $5cf357f4d885f067$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $5cf357f4d885f067$export$2e2bcd8739ae039).disabled}, .${(0, $5cf357f4d885f067$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $5cf357f4d885f067$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $ajTRS.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $ff4b625adac9abd6$var$FilledInputInput = (0, $npagc.default)((0, $5d82838c205c229a$export$a1ad29c901026019), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $5d82838c205c229a$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $ff4b625adac9abd6$var$FilledInput = /*#__PURE__*/ $1T1QG.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $iXdVf.default)(props, $ff4b625adac9abd6$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $ff4b625adac9abd6$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3MwXn.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $ff4b625adac9abd6$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $ff4b625adac9abd6$var$FilledInputInput;
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $5d82838c205c229a$export$2e2bcd8739ae039), (0, $ajTRS.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$ff4b625adac9abd6$var$FilledInput.muiName = "Input";
var $ff4b625adac9abd6$export$2e2bcd8739ae039 = $ff4b625adac9abd6$var$FilledInput;



var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");



var $iV85C = parcelRequire("iV85C");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");
parcelRequire("1T1QG");


var $npagc = parcelRequire("npagc");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $d90b07d41bb2ea7d$var$_span;
const $d90b07d41bb2ea7d$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $d90b07d41bb2ea7d$var$NotchedOutlineRoot = (0, $npagc.default)("fieldset", {
    shouldForwardProp: (0, $npagc.rootShouldForwardProp)
})({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $d90b07d41bb2ea7d$var$NotchedOutlineLegend = (0, $npagc.default)("legend", {
    shouldForwardProp: (0, $npagc.rootShouldForwardProp)
})(({ ownerState: ownerState, theme: theme })=>(0, $ajTRS.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $ajTRS.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $d90b07d41bb2ea7d$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $iXdVf.default)(props, $d90b07d41bb2ea7d$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $ajTRS.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)($d90b07d41bb2ea7d$var$NotchedOutlineRoot, (0, $ajTRS.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($d90b07d41bb2ea7d$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $3Py8h.jsx)("span", {
                children: label
            }) : $d90b07d41bb2ea7d$var$_span || ($d90b07d41bb2ea7d$var$_span = /*#__PURE__*/ (0, $3Py8h.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $npagc = parcelRequire("npagc");



var $gADeF = parcelRequire("gADeF");

var $3Py8h = parcelRequire("3Py8h");
"use client";
const $68140e16206f7261$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $68140e16206f7261$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $iV85C.default)(slots, (0, $63f066b46e18ed3f$export$89922944c7227687), classes);
    return (0, $ajTRS.default)({}, classes, composedClasses);
};
const $68140e16206f7261$var$OutlinedInputRoot = (0, $npagc.default)((0, $5d82838c205c229a$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $npagc.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $5d82838c205c229a$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $ajTRS.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $63f066b46e18ed3f$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $63f066b46e18ed3f$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $63f066b46e18ed3f$export$2e2bcd8739ae039).focused} .${(0, $63f066b46e18ed3f$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $63f066b46e18ed3f$export$2e2bcd8739ae039).error} .${(0, $63f066b46e18ed3f$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $63f066b46e18ed3f$export$2e2bcd8739ae039).disabled} .${(0, $63f066b46e18ed3f$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $ajTRS.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $68140e16206f7261$var$NotchedOutlineRoot = (0, $npagc.default)((0, $d90b07d41bb2ea7d$export$2e2bcd8739ae039), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $68140e16206f7261$var$OutlinedInputInput = (0, $npagc.default)((0, $5d82838c205c229a$export$a1ad29c901026019), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $5d82838c205c229a$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $68140e16206f7261$var$OutlinedInput = /*#__PURE__*/ $1T1QG.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text" } = props, other = (0, $iXdVf.default)(props, $68140e16206f7261$var$_excluded);
    const classes = $68140e16206f7261$var$useUtilityClasses(props);
    const muiFormControl = (0, $83a17b5295da3528$export$2e2bcd8739ae039)();
    const fcs = (0, $5463d9638c422d7c$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, $ajTRS.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $68140e16206f7261$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $68140e16206f7261$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $5d82838c205c229a$export$2e2bcd8739ae039), (0, $ajTRS.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $3Py8h.jsx)($68140e16206f7261$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $ajTRS.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$68140e16206f7261$var$OutlinedInput.muiName = "Input";
var $68140e16206f7261$export$2e2bcd8739ae039 = $68140e16206f7261$var$OutlinedInput;



var $gADeF = parcelRequire("gADeF");


var $npagc = parcelRequire("npagc");

var $3Py8h = parcelRequire("3Py8h");
"use client";
const $46f1ad6741eceffd$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $46f1ad6741eceffd$var$_excluded2 = [
    "root"
];
const $46f1ad6741eceffd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $46f1ad6741eceffd$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $npagc.rootShouldForwardProp)(prop) && prop !== "variant",
    slot: "Root"
};
const $46f1ad6741eceffd$var$StyledInput = (0, $npagc.default)((0, $d5dac63d9f83cf1e$export$2e2bcd8739ae039), $46f1ad6741eceffd$var$styledRootConfig)("");
const $46f1ad6741eceffd$var$StyledOutlinedInput = (0, $npagc.default)((0, $68140e16206f7261$export$2e2bcd8739ae039), $46f1ad6741eceffd$var$styledRootConfig)("");
const $46f1ad6741eceffd$var$StyledFilledInput = (0, $npagc.default)((0, $ff4b625adac9abd6$export$2e2bcd8739ae039), $46f1ad6741eceffd$var$styledRootConfig)("");
const $46f1ad6741eceffd$var$Select = /*#__PURE__*/ $1T1QG.forwardRef(function Select(inProps, ref) {
    const props = (0, $gADeF.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $db0bcc027518db01$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $iXdVf.default)(props, $46f1ad6741eceffd$var$_excluded);
    const inputComponent = native ? (0, $602057aa3eee0e8c$export$2e2bcd8739ae039) : (0, $58871410ea182a5e$export$2e2bcd8739ae039);
    const muiFormControl = (0, $83a17b5295da3528$export$2e2bcd8739ae039)();
    const fcs = (0, $5463d9638c422d7c$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $ajTRS.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $46f1ad6741eceffd$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $iXdVf.default)(classes, $46f1ad6741eceffd$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $3Py8h.jsx)($46f1ad6741eceffd$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $3Py8h.jsx)($46f1ad6741eceffd$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $3Py8h.jsx)($46f1ad6741eceffd$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($1T1QG.Fragment, {
        children: /*#__PURE__*/ $1T1QG.cloneElement(InputComponent, (0, $ajTRS.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $ajTRS.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $ajTRS.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $3MwXn.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $aVXbR.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$46f1ad6741eceffd$var$Select.muiName = "Select";
var $46f1ad6741eceffd$export$2e2bcd8739ae039 = $46f1ad6741eceffd$var$Select;


var $npagc = parcelRequire("npagc");
var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");

var $7Etkp = parcelRequire("7Etkp");

var $5wtOU = parcelRequire("5wtOU");


var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $79aa77d84baf4092$export$39f6debbec19b3ba(slot) {
    return (0, $iNQht.default)("MuiSwitch", slot);
}
const $79aa77d84baf4092$var$switchClasses = (0, $dfswM.default)("MuiSwitch", [
    "root",
    "edgeStart",
    "edgeEnd",
    "switchBase",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium",
    "checked",
    "disabled",
    "input",
    "thumb",
    "track"
]);
var $79aa77d84baf4092$export$2e2bcd8739ae039 = $79aa77d84baf4092$var$switchClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $8efc7798a14d68af$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $8efc7798a14d68af$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            edge && `edge${(0, $5wtOU.default)(edge)}`,
            `size${(0, $5wtOU.default)(size)}`
        ],
        switchBase: [
            "switchBase",
            `color${(0, $5wtOU.default)(color)}`,
            checked && "checked",
            disabled && "disabled"
        ],
        thumb: [
            "thumb"
        ],
        track: [
            "track"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $iV85C.default)(slots, (0, $79aa77d84baf4092$export$39f6debbec19b3ba), classes);
    return (0, $ajTRS.default)({}, classes, composedClasses);
};
const $8efc7798a14d68af$var$SwitchRoot = (0, $npagc.default)("span", {
    name: "MuiSwitch",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $5wtOU.default)(ownerState.edge)}`],
            styles[`size${(0, $5wtOU.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        display: "inline-flex",
        width: 58,
        height: 38,
        overflow: "hidden",
        padding: 12,
        boxSizing: "border-box",
        position: "relative",
        flexShrink: 0,
        zIndex: 0,
        // Reset the stacking context.
        verticalAlign: "middle",
        // For correct alignment with the text.
        "@media print": {
            colorAdjust: "exact"
        }
    }, ownerState.edge === "start" && {
        marginLeft: -8
    }, ownerState.edge === "end" && {
        marginRight: -8
    }, ownerState.size === "small" && {
        width: 40,
        height: 24,
        padding: 7,
        [`& .${(0, $79aa77d84baf4092$export$2e2bcd8739ae039).thumb}`]: {
            width: 16,
            height: 16
        },
        [`& .${(0, $79aa77d84baf4092$export$2e2bcd8739ae039).switchBase}`]: {
            padding: 4,
            [`&.${(0, $79aa77d84baf4092$export$2e2bcd8739ae039).checked}`]: {
                transform: "translateX(16px)"
            }
        }
    }));
const $8efc7798a14d68af$var$SwitchSwitchBase = (0, $npagc.default)((0, $aa7769819719368a$export$2e2bcd8739ae039), {
    name: "MuiSwitch",
    slot: "SwitchBase",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $79aa77d84baf4092$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== "default" && styles[`color${(0, $5wtOU.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            "left",
            "transform"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $79aa77d84baf4092$export$2e2bcd8739ae039).checked}`]: {
            transform: "translateX(20px)"
        },
        [`&.${(0, $79aa77d84baf4092$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $79aa77d84baf4092$export$2e2bcd8739ae039).checked} + .${(0, $79aa77d84baf4092$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $79aa77d84baf4092$export$2e2bcd8739ae039).disabled} + .${(0, $79aa77d84baf4092$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === "light" ? 0.12 : 0.2}`
        },
        [`& .${(0, $79aa77d84baf4092$export$2e2bcd8739ae039).input}`]: {
            left: "-100%",
            width: "300%"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7Etkp.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $79aa77d84baf4092$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7Etkp.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, $79aa77d84baf4092$export$2e2bcd8739ae039).disabled}`]: {
                color: theme.vars ? theme.vars.palette.Switch[`${ownerState.color}DisabledColor`] : `${theme.palette.mode === "light" ? (0, $7Etkp.lighten)(theme.palette[ownerState.color].main, 0.62) : (0, $7Etkp.darken)(theme.palette[ownerState.color].main, 0.55)}`
            }
        },
        [`&.${(0, $79aa77d84baf4092$export$2e2bcd8739ae039).checked} + .${(0, $79aa77d84baf4092$export$2e2bcd8739ae039).track}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main
        }
    }));
const $8efc7798a14d68af$var$SwitchTrack = (0, $npagc.default)("span", {
    name: "MuiSwitch",
    slot: "Track",
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: "100%",
        width: "100%",
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            "opacity",
            "background-color"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === "light" ? 0.38 : 0.3}`
    }));
const $8efc7798a14d68af$var$SwitchThumb = (0, $npagc.default)("span", {
    name: "MuiSwitch",
    slot: "Thumb",
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: "currentColor",
        width: 20,
        height: 20,
        borderRadius: "50%"
    }));
const $8efc7798a14d68af$var$Switch = /*#__PURE__*/ $1T1QG.forwardRef(function Switch(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiSwitch"
    });
    const { className: className, color: color = "primary", edge: edge = false, size: size = "medium", sx: sx } = props, other = (0, $iXdVf.default)(props, $8efc7798a14d68af$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $8efc7798a14d68af$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $3Py8h.jsx)($8efc7798a14d68af$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($8efc7798a14d68af$var$SwitchRoot, {
        className: (0, $aVXbR.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)($8efc7798a14d68af$var$SwitchSwitchBase, (0, $ajTRS.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $ajTRS.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $3Py8h.jsx)($8efc7798a14d68af$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $8efc7798a14d68af$export$2e2bcd8739ae039 = $8efc7798a14d68af$var$Switch;


var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");


var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");






var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");



var $npagc = parcelRequire("npagc");

var $5wtOU = parcelRequire("5wtOU");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $b1dcb873500ea8aa$export$a394fa61b1d583a9(slot) {
    return (0, $iNQht.default)("MuiFormHelperText", slot);
}
const $b1dcb873500ea8aa$var$formHelperTextClasses = (0, $dfswM.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $b1dcb873500ea8aa$export$2e2bcd8739ae039 = $b1dcb873500ea8aa$var$formHelperTextClasses;



var $gADeF = parcelRequire("gADeF");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $801159818e7707d0$var$_span;
const $801159818e7707d0$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $801159818e7707d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $5wtOU.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $b1dcb873500ea8aa$export$a394fa61b1d583a9), classes);
};
const $801159818e7707d0$var$FormHelperTextRoot = (0, $npagc.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $5wtOU.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $b1dcb873500ea8aa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $b1dcb873500ea8aa$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $801159818e7707d0$var$FormHelperText = /*#__PURE__*/ $1T1QG.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $iXdVf.default)(props, $801159818e7707d0$var$_excluded);
    const muiFormControl = (0, $83a17b5295da3528$export$2e2bcd8739ae039)();
    const fcs = (0, $5463d9638c422d7c$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $ajTRS.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $801159818e7707d0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($801159818e7707d0$var$FormHelperTextRoot, (0, $ajTRS.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $aVXbR.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $801159818e7707d0$var$_span || ($801159818e7707d0$var$_span = /*#__PURE__*/ (0, $3Py8h.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $801159818e7707d0$export$2e2bcd8739ae039 = $801159818e7707d0$var$FormHelperText;




var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $5a7f03dd6e31e63e$export$c1bdcbaf0596aeda(slot) {
    return (0, $iNQht.default)("MuiTextField", slot);
}
const $5a7f03dd6e31e63e$var$textFieldClasses = (0, $dfswM.default)("MuiTextField", [
    "root"
]);
var $5a7f03dd6e31e63e$export$2e2bcd8739ae039 = $5a7f03dd6e31e63e$var$textFieldClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $acd1b2a27b331456$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $acd1b2a27b331456$var$variantComponent = {
    standard: (0, $d5dac63d9f83cf1e$export$2e2bcd8739ae039),
    filled: (0, $ff4b625adac9abd6$export$2e2bcd8739ae039),
    outlined: (0, $68140e16206f7261$export$2e2bcd8739ae039)
};
const $acd1b2a27b331456$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $5a7f03dd6e31e63e$export$c1bdcbaf0596aeda), classes);
};
const $acd1b2a27b331456$var$TextFieldRoot = (0, $npagc.default)((0, $7c26d84ab517f189$export$2e2bcd8739ae039), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $acd1b2a27b331456$var$TextField = /*#__PURE__*/ $1T1QG.forwardRef(function TextField(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = "outlined" } = props, other = (0, $iXdVf.default)(props, $acd1b2a27b331456$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $acd1b2a27b331456$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $9dc24b323e690fdf$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $acd1b2a27b331456$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $3Py8h.jsx)(InputComponent, (0, $ajTRS.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($acd1b2a27b331456$var$TextFieldRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f4e04526214b55b7$export$2e2bcd8739ae039), (0, $ajTRS.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $46f1ad6741eceffd$export$2e2bcd8739ae039), (0, $ajTRS.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $801159818e7707d0$export$2e2bcd8739ae039), (0, $ajTRS.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $acd1b2a27b331456$export$2e2bcd8739ae039 = $acd1b2a27b331456$var$TextField;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");

var $7Etkp = parcelRequire("7Etkp");

var $npagc = parcelRequire("npagc");


var $gADeF = parcelRequire("gADeF");

var $5wtOU = parcelRequire("5wtOU");








var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $5502a7e6e01a273a$export$837848f5f6cee923(slot) {
    return (0, $iNQht.default)("MuiTooltip", slot);
}
const $5502a7e6e01a273a$var$tooltipClasses = (0, $dfswM.default)("MuiTooltip", [
    "popper",
    "popperInteractive",
    "popperArrow",
    "popperClose",
    "tooltip",
    "tooltipArrow",
    "touch",
    "tooltipPlacementLeft",
    "tooltipPlacementRight",
    "tooltipPlacementTop",
    "tooltipPlacementBottom",
    "arrow"
]);
var $5502a7e6e01a273a$export$2e2bcd8739ae039 = $5502a7e6e01a273a$var$tooltipClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $8669aa55f7f8651c$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $8669aa55f7f8651c$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $8669aa55f7f8651c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            "popper",
            !disableInteractive && "popperInteractive",
            arrow && "popperArrow"
        ],
        tooltip: [
            "tooltip",
            arrow && "tooltipArrow",
            touch && "touch",
            `tooltipPlacement${(0, $5wtOU.default)(placement.split("-")[0])}`
        ],
        arrow: [
            "arrow"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $5502a7e6e01a273a$export$837848f5f6cee923), classes);
};
const $8669aa55f7f8651c$var$TooltipPopper = (0, $npagc.default)((0, $9523926f49e29683$export$2e2bcd8739ae039), {
    name: "MuiTooltip",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $ajTRS.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: "none"
    }, !ownerState.disableInteractive && {
        pointerEvents: "auto"
    }, !open && {
        pointerEvents: "none"
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $5502a7e6e01a273a$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: "-0.71em",
            "&::before": {
                transformOrigin: "0 100%"
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $5502a7e6e01a273a$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: "-0.71em",
            "&::before": {
                transformOrigin: "100% 0"
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $5502a7e6e01a273a$export$2e2bcd8739ae039).arrow}`]: (0, $ajTRS.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: "-0.71em"
        } : {
            right: 0,
            marginRight: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "100% 100%"
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $5502a7e6e01a273a$export$2e2bcd8739ae039).arrow}`]: (0, $ajTRS.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: "-0.71em"
        } : {
            left: 0,
            marginLeft: "-0.71em"
        }, {
            height: "1em",
            width: "0.71em",
            "&::before": {
                transformOrigin: "0 0"
            }
        })
    }));
const $8669aa55f7f8651c$var$TooltipTooltip = (0, $npagc.default)("div", {
    name: "MuiTooltip",
    slot: "Tooltip",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $5wtOU.default)(ownerState.placement.split("-")[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $7Etkp.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: "4px 8px",
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: "break-word",
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: "relative",
        margin: 0
    }, ownerState.touch && {
        padding: "8px 16px",
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$8669aa55f7f8651c$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $5502a7e6e01a273a$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $ajTRS.default)({
            transformOrigin: "right center"
        }, !ownerState.isRtl ? (0, $ajTRS.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        }) : (0, $ajTRS.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        })),
        [`.${(0, $5502a7e6e01a273a$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $ajTRS.default)({
            transformOrigin: "left center"
        }, !ownerState.isRtl ? (0, $ajTRS.default)({
            marginLeft: "14px"
        }, ownerState.touch && {
            marginLeft: "24px"
        }) : (0, $ajTRS.default)({
            marginRight: "14px"
        }, ownerState.touch && {
            marginRight: "24px"
        })),
        [`.${(0, $5502a7e6e01a273a$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $ajTRS.default)({
            transformOrigin: "center bottom",
            marginBottom: "14px"
        }, ownerState.touch && {
            marginBottom: "24px"
        }),
        [`.${(0, $5502a7e6e01a273a$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $ajTRS.default)({
            transformOrigin: "center top",
            marginTop: "14px"
        }, ownerState.touch && {
            marginTop: "24px"
        })
    }));
const $8669aa55f7f8651c$var$TooltipArrow = (0, $npagc.default)("span", {
    name: "MuiTooltip",
    slot: "Arrow",
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: "hidden",
        position: "absolute",
        width: "1em",
        height: "0.71em" /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: "border-box",
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $7Etkp.alpha)(theme.palette.grey[700], 0.9),
        "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)"
        }
    }));
let $8669aa55f7f8651c$var$hystersisOpen = false;
const $8669aa55f7f8651c$var$hystersisTimer = new (0, $b17443dc4e529ae6$export$786b4da70f00938b)();
let $8669aa55f7f8651c$var$cursorPosition = {
    x: 0,
    y: 0
};
function $8669aa55f7f8651c$export$b9ee5a7ace0541f8() {
    $8669aa55f7f8651c$var$hystersisOpen = false;
    $8669aa55f7f8651c$var$hystersisTimer.clear();
}
function $8669aa55f7f8651c$var$composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $8669aa55f7f8651c$var$Tooltip = /*#__PURE__*/ $1T1QG.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiTooltip"
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = "bottom", PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $e236f531d361181f$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $iXdVf.default)(props, $8669aa55f7f8651c$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $1T1QG.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $3Py8h.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const [childNode, setChildNode] = $1T1QG.useState();
    const [arrowRef, setArrowRef] = $1T1QG.useState(null);
    const ignoreNonTouchEvents = $1T1QG.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $b17443dc4e529ae6$export$2e2bcd8739ae039)();
    const enterTimer = (0, $b17443dc4e529ae6$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $b17443dc4e529ae6$export$2e2bcd8739ae039)();
    const touchTimer = (0, $b17443dc4e529ae6$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $d1acf12366a469be$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: "Tooltip",
        state: "open"
    });
    let open = openState;
    const id = (0, $71c1fc9cdce170b3$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $1T1QG.useRef();
    const stopTouchInteraction = (0, $788a24ad2efceaa4$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $1T1QG.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $8669aa55f7f8651c$var$hystersisTimer.clear();
        $8669aa55f7f8651c$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $788a24ad2efceaa4$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $8669aa55f7f8651c$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $8669aa55f7f8651c$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleEnter = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== "touchstart") return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute("title");
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $8669aa55f7f8651c$var$hystersisOpen && enterNextDelay) enterTimer.start($8669aa55f7f8651c$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $4a2f2e3ed2159cdf$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $1T1QG.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleEnter(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleMouseOver = handleEnter;
    const handleMouseLeave = handleLeave;
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = "none";
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleEnter(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $1T1QG.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") handleClose(nativeEvent);
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    if (!title && title !== 0) open = false;
    const popperRef = $1T1QG.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $8669aa55f7f8651c$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === "string";
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps["aria-describedby"] = open ? id : null;
    } else {
        nameOrDescProps["aria-label"] = titleIsString ? title : null;
        nameOrDescProps["aria-labelledby"] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $ajTRS.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $aVXbR.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $8669aa55f7f8651c$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $8669aa55f7f8651c$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $8669aa55f7f8651c$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $8669aa55f7f8651c$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $1T1QG.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: "arrow",
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $ajTRS.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $ajTRS.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $8669aa55f7f8651c$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $8669aa55f7f8651c$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $e236f531d361181f$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $8669aa55f7f8651c$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $8669aa55f7f8651c$var$TooltipArrow;
    const popperProps = (0, $c2acd4b78787ea6e$export$b089efb01a7bdf50)(PopperComponent, (0, $ajTRS.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $aVXbR.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $c2acd4b78787ea6e$export$b089efb01a7bdf50)(TransitionComponent, (0, $ajTRS.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $c2acd4b78787ea6e$export$b089efb01a7bdf50)(TooltipComponent, (0, $ajTRS.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $aVXbR.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $c2acd4b78787ea6e$export$b089efb01a7bdf50)(ArrowComponent, (0, $ajTRS.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $aVXbR.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
        children: [
            /*#__PURE__*/ $1T1QG.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $3Py8h.jsx)(PopperComponent, (0, $ajTRS.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $9523926f49e29683$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $8669aa55f7f8651c$var$cursorPosition.y,
                            left: $8669aa55f7f8651c$var$cursorPosition.x,
                            right: $8669aa55f7f8651c$var$cursorPosition.x,
                            bottom: $8669aa55f7f8651c$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $3Py8h.jsx)(TransitionComponent, (0, $ajTRS.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $3Py8h.jsxs)(TooltipComponent, (0, $ajTRS.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $3Py8h.jsx)(ArrowComponent, (0, $ajTRS.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $8669aa55f7f8651c$export$2e2bcd8739ae039 = $8669aa55f7f8651c$var$Tooltip;



var $1T1QG = parcelRequire("1T1QG");
var $592bed19bfb0ac93$exports = {};
"use strict";
"use client";

Object.defineProperty($592bed19bfb0ac93$exports, "__esModule", {
    value: true
});
$592bed19bfb0ac93$exports.default = void 0;

var $592bed19bfb0ac93$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $592bed19bfb0ac93$var$_default = $592bed19bfb0ac93$exports.default = (0, $592bed19bfb0ac93$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1m1-8h-2V7h2z"
}), "InfoRounded");



const $b3451f27c11f61da$var$FormContainer = (props)=>{
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $7c26d84ab517f189$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            mb: 1,
            mt: 1,
            gap: 2,
            children: props.children
        })
    });
};
const $b3451f27c11f61da$var$StyledTextField = (0, $npagc.default)((0, $acd1b2a27b331456$export$2e2bcd8739ae039))(({ error: error, theme: theme })=>({
        color: error ? theme.palette.error.main : "inherit"
    }));
const $b3451f27c11f61da$var$FormTextField = ({ errorText: errorText, ...textFieldProps })=>{
    let inputProps = undefined;
    if (textFieldProps?.inputProps) inputProps = textFieldProps.inputProps?.maxLength ? textFieldProps.inputProps : {
        ...textFieldProps.inputProps,
        maxLength: (0, $5ed07630ed21dadb$export$85ea93c7f196b8c3).INPUT_MAX_CHARS
    };
    else inputProps = {
        maxLength: (0, $5ed07630ed21dadb$export$85ea93c7f196b8c3).INPUT_MAX_CHARS
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)($b3451f27c11f61da$var$StyledTextField, {
        ...textFieldProps,
        inputProps: inputProps,
        helperText: errorText ? errorText : "",
        sx: {
            flex: 1
        }
    });
};
const $b3451f27c11f61da$var$FormAutoCompleteTextField = (props)=>{
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $1a7eda2b3de6c330$export$2e2bcd8739ae039), {
        ...props
    });
};
const $b3451f27c11f61da$var$FormRadio = (props)=>{
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8a4dd1af00f66836$export$2e2bcd8739ae039), {
        ...props,
        control: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c7a6a2f699a36e04$export$2e2bcd8739ae039), {})
    });
};
const $b3451f27c11f61da$var$FormLabel = (props)=>{
    const [tooltipOpen, setTooltipOpen] = (0, $1T1QG.useState)(false);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4d34a93ef05aacc5$export$2e2bcd8739ae039), {
        ...props,
        children: props.info ? /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
            display: "flex",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                    children: props.children
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8669aa55f7f8651c$export$2e2bcd8739ae039), {
                    title: props.info,
                    open: tooltipOpen,
                    onClose: ()=>setTooltipOpen(false),
                    onClick: ()=>setTooltipOpen(true),
                    placement: "top",
                    arrow: true,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $5c784366741908ee$export$2e2bcd8739ae039), {
                        onMouseEnter: ()=>setTooltipOpen(true),
                        onMouseLeave: ()=>setTooltipOpen(false),
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($592bed19bfb0ac93$exports))), {})
                    })
                })
            ]
        }) : props.children
    });
};
const $b3451f27c11f61da$var$FormSwitch = (props)=>{
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8a4dd1af00f66836$export$2e2bcd8739ae039), {
        label: props.label,
        control: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8efc7798a14d68af$export$2e2bcd8739ae039), {
            ...props
        })
    });
};
const $b3451f27c11f61da$var$FormBoxRow = (props)=>{
    const { children: children, gap: gap, flexDirection: flexDirection } = props;
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
        display: "flex",
        gap: gap ? gap : 2,
        flex: 1,
        flexDirection: flexDirection ? {
            xs: "column",
            md: "row"
        } : undefined,
        children: children
    });
};
const $b3451f27c11f61da$var$FormSelect = (props)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $7c26d84ab517f189$export$2e2bcd8739ae039), {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f4e04526214b55b7$export$2e2bcd8739ae039), {
                id: rest.labelId,
                children: rest.label
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $46f1ad6741eceffd$export$2e2bcd8739ae039), {
                ...rest,
                children: children
            })
        ]
    });
};
const $b3451f27c11f61da$var$FormTitle = (props)=>/*#__PURE__*/ (0, $3Py8h.jsx)($b3451f27c11f61da$var$FormBoxRow, {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)("h4", {
            style: {
                margin: 0
            },
            children: props.title
        })
    });
var $b3451f27c11f61da$export$2e2bcd8739ae039 = {
    FormAutoCompleteTextField: $b3451f27c11f61da$var$FormAutoCompleteTextField,
    FormTextField: $b3451f27c11f61da$var$FormTextField,
    FormContainer: $b3451f27c11f61da$var$FormContainer,
    FormRadio: $b3451f27c11f61da$var$FormRadio,
    FormSwitch: $b3451f27c11f61da$var$FormSwitch,
    FormLabel: $b3451f27c11f61da$var$FormLabel,
    FormBoxRow: $b3451f27c11f61da$var$FormBoxRow,
    FormSelect: $b3451f27c11f61da$var$FormSelect,
    FormTitle: $b3451f27c11f61da$var$FormTitle
};



var $3Py8h = parcelRequire("3Py8h");


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $7ZhQx = parcelRequire("7ZhQx");
var $iV85C = parcelRequire("iV85C");
var $iNQht = parcelRequire("iNQht");

var $63vkt = parcelRequire("63vkt");


var $3osRD = parcelRequire("3osRD");

var $3Py8h = parcelRequire("3Py8h");
const $4c929f362fa81a8d$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth",
    "classes"
];
const $4c929f362fa81a8d$var$defaultTheme = (0, $3osRD.default)();
const $4c929f362fa81a8d$var$defaultCreateStyledComponent = (0, $2058cdfdf1f50d42$export$2e2bcd8739ae039)("div", {
    name: "MuiContainer",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $7ZhQx.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $4c929f362fa81a8d$var$useThemePropsDefault = (inProps)=>(0, $63vkt.default)({
        props: inProps,
        name: "MuiContainer",
        defaultTheme: $4c929f362fa81a8d$var$defaultTheme
    });
const $4c929f362fa81a8d$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $iNQht.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            "root",
            maxWidth && `maxWidth${(0, $7ZhQx.default)(String(maxWidth))}`,
            fixed && "fixed",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $iV85C.default)(slots, getContainerUtilityClass, classes);
};
function $4c929f362fa81a8d$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $4c929f362fa81a8d$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $4c929f362fa81a8d$var$useThemePropsDefault, componentName: componentName = "MuiContainer" } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
            width: "100%",
            marginLeft: "auto",
            boxSizing: "border-box",
            marginRight: "auto",
            display: "block"
        }, !ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("sm")]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({}, ownerState.maxWidth === "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("xs")]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: Math.max(theme.breakpoints.values.xs, 444)
            }
        }, ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up(ownerState.maxWidth)]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
            }
        }));
    const Container = /*#__PURE__*/ $1T1QG.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = "div", disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = "lg" } = props, other = (0, $iXdVf.default)(props, $4c929f362fa81a8d$var$_excluded);
        const ownerState = (0, $ajTRS.default)({}, props, {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $4c929f362fa81a8d$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $3Py8h.jsx)(ContainerRoot, (0, $ajTRS.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $aVXbR.default)(classes.root, className),
            ref: ref
        }, other)));
    });
    return Container;
}



var $5wtOU = parcelRequire("5wtOU");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");
"use client";
const $691082308a369afa$var$Container = (0, $4c929f362fa81a8d$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $npagc.default)("div", {
        name: "MuiContainer",
        slot: "Root",
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $5wtOU.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $gADeF.default)({
            props: inProps,
            name: "MuiContainer"
        })
});
var $691082308a369afa$export$2e2bcd8739ae039 = $691082308a369afa$var$Container;


var $npagc = parcelRequire("npagc");

var $3Py8h = parcelRequire("3Py8h");
parcelRequire("1T1QG");

var $3Py8h = parcelRequire("3Py8h");

const $15827f0d92c5ff99$var$MoovyRestricted = ({ action: action, resource: resource, visibility: visibility = true, children: children })=>{
    const { isPermission: isPermission } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: isPermission(action, resource) && visibility && children
    });
};
var $15827f0d92c5ff99$export$2e2bcd8739ae039 = $15827f0d92c5ff99$var$MoovyRestricted;


const $16d47fe2418a0b93$var$MoovyContainerContent = ({ action: action, resource: resource, children: children })=>{
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: action && resource ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $15827f0d92c5ff99$export$2e2bcd8739ae039), {
            action: action,
            resource: resource,
            children: children
        }) : /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
            children: children
        })
    });
};
var $16d47fe2418a0b93$export$2e2bcd8739ae039 = $16d47fe2418a0b93$var$MoovyContainerContent;



var $3Py8h = parcelRequire("3Py8h");

parcelRequire("1T1QG");
const $d853676d11a33bb6$var$MoovyContainerHeader = ({ breadcrumbs: breadcrumbs, children: children })=>{
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            breadcrumbs && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $131e55989189bbc4$export$2e2bcd8739ae039), {
                lastBreadcrumb: breadcrumbs?.lastBreadcrumb,
                customBreadcrumbs: breadcrumbs?.customBreadcrumbs
            }),
            children
        ]
    });
};
var $d853676d11a33bb6$export$2e2bcd8739ae039 = $d853676d11a33bb6$var$MoovyContainerHeader;



var $3Py8h = parcelRequire("3Py8h");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $7Etkp = parcelRequire("7Etkp");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");


var $3Py8h = parcelRequire("3Py8h");
"use client";
const $a976032e8b2c1f5c$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $a976032e8b2c1f5c$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $421323354d856804$export$46f01d01378ec5a2), classes);
};
const $a976032e8b2c1f5c$var$DividerRoot = (0, $npagc.default)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: "thin"
    }, ownerState.absolute && {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%"
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $7Etkp.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === "inset" && {
        marginLeft: 72
    }, ownerState.variant === "middle" && ownerState.orientation === "horizontal" && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === "middle" && ownerState.orientation === "vertical" && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        borderBottomWidth: 0,
        borderRightWidth: "thin"
    }, ownerState.flexItem && {
        alignSelf: "stretch",
        height: "auto"
    }), ({ ownerState: ownerState })=>(0, $ajTRS.default)({}, ownerState.children && {
        display: "flex",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        "&::before, &::after": {
            content: '""',
            alignSelf: "center"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({}, ownerState.children && ownerState.orientation !== "vertical" && {
        "&::before, &::after": {
            width: "100%",
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({}, ownerState.children && ownerState.orientation === "vertical" && {
        flexDirection: "column",
        "&::before, &::after": {
            height: "100%",
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState: ownerState })=>(0, $ajTRS.default)({}, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "90%"
        },
        "&::after": {
            width: "10%"
        }
    }, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "10%"
        },
        "&::after": {
            width: "90%"
        }
    }));
const $a976032e8b2c1f5c$var$DividerWrapper = (0, $npagc.default)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === "vertical" && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $a976032e8b2c1f5c$var$Divider = /*#__PURE__*/ $1T1QG.forwardRef(function Divider(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? "div" : "hr", flexItem: flexItem = false, light: light = false, orientation: orientation = "horizontal", role: role = component !== "hr" ? "separator" : undefined, textAlign: textAlign = "center", variant: variant = "fullWidth" } = props, other = (0, $iXdVf.default)(props, $a976032e8b2c1f5c$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $a976032e8b2c1f5c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($a976032e8b2c1f5c$var$DividerRoot, (0, $ajTRS.default)({
        as: component,
        className: (0, $aVXbR.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $3Py8h.jsx)($a976032e8b2c1f5c$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $a976032e8b2c1f5c$var$Divider.muiSkipListHighlight = true;
var $a976032e8b2c1f5c$export$2e2bcd8739ae039 = $a976032e8b2c1f5c$var$Divider;



parcelRequire("1T1QG");
const $344485076b4208c7$var$MoovyContainerSubHeader = ({ action: action, resource: resource, title: title, description: description, button: button, divider: divider, props: props, titleProps: titleProps })=>{
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const isMobile = (0, $ffad103d3c7e3bc8$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    const Render = ()=>/*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                    container: true,
                    direction: "row",
                    alignItems: "center",
                    p: 2,
                    ...props,
                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                        container: true,
                        item: true,
                        xs: 12,
                        direction: "row",
                        alignItems: description ? "flex-end" : "center",
                        gap: isMobile && description ? 1 : 0,
                        children: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                                item: true,
                                xs: description ? 12 : 8,
                                md: 8,
                                ...titleProps,
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)("h3", {
                                    style: {
                                        padding: 0,
                                        margin: 0,
                                        lineHeight: "120%"
                                    },
                                    children: title
                                })
                            }),
                            description && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                                item: true,
                                xs: 12,
                                md: 8,
                                children: description
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                                item: true,
                                md: 4,
                                xs: description ? 12 : 4,
                                display: "flex",
                                container: true,
                                justifyContent: "flex-end",
                                alignItems: "flex-end",
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
                                    children: button
                                })
                            })
                        ]
                    })
                }),
                divider && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    pb: 2,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a976032e8b2c1f5c$export$2e2bcd8739ae039), {})
                })
            ]
        });
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: action && resource ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $15827f0d92c5ff99$export$2e2bcd8739ae039), {
            action: action,
            resource: resource,
            children: /*#__PURE__*/ (0, $3Py8h.jsx)(Render, {})
        }) : /*#__PURE__*/ (0, $3Py8h.jsx)(Render, {})
    });
};
var $344485076b4208c7$export$2e2bcd8739ae039 = $344485076b4208c7$var$MoovyContainerSubHeader;




var $1T1QG = parcelRequire("1T1QG");
const $52a829e7310b7f4c$var$MoovyHeader = ({ breadcrumbsVisible: breadcrumbsVisible, children: children })=>{
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, {
        children: children && /*#__PURE__*/ (0, $3Py8h.jsx)("h1", {
            style: {
                marginTop: breadcrumbsVisible ? "0" : undefined
            },
            children: children
        })
    });
};
const $52a829e7310b7f4c$var$MoovySubHeader = ({ children: children })=>{
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, {
        children: children
    });
};
const $52a829e7310b7f4c$var$MoovyContent = ({ query: query, children: children })=>{
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, {
        children: [
            query && query.error && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                    item: true,
                    pl: 2,
                    pr: 2,
                    pb: 2,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $019112675a75b38b$export$2e2bcd8739ae039), {
                        query: query,
                        errorTitleKey: "common.actions.get.error"
                    })
                })
            }),
            children && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                    item: true,
                    pl: 2,
                    pr: 2,
                    pb: 2,
                    children: children
                })
            })
        ]
    });
};
const $52a829e7310b7f4c$var$MoovyContainer = ({ loading: loading, children: children })=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Children.toArray(children).some((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).isValidElement(child) && child.type !== (0, $d853676d11a33bb6$export$2e2bcd8739ae039) && child.type !== (0, $344485076b4208c7$export$2e2bcd8739ae039) && child.type !== (0, $16d47fe2418a0b93$export$2e2bcd8739ae039) && child.type !== (0, $15827f0d92c5ff99$export$2e2bcd8739ae039))) throw new Error("MoovyContainer contains invalid components. They must be MoovyContainerHeader, MoovyContainerSubHeader or MoovyContainerContent.");
    const getContent = (source, target)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Children.toArray(source).find((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).isValidElement(child) && child.type === target);
    };
    const header = getContent(children, (0, $d853676d11a33bb6$export$2e2bcd8739ae039));
    const subHeader = getContent(children, (0, $344485076b4208c7$export$2e2bcd8739ae039));
    const content = getContent(children, (0, $16d47fe2418a0b93$export$2e2bcd8739ae039));
    const breadcrumbsVisible = !!header?.props.breadcrumbs;
    const StyledPaper = (0, $npagc.default)((0, $0a163fcc25046a25$export$2e2bcd8739ae039))({
        boxShadow: "6px 6px 54px 0px rgba(0, 0, 0, 0.05)"
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
        sx: {
            position: "relative"
        },
        children: loading ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4cdfa78f7d1b8c19$export$2e2bcd8739ae039), {
            sx: {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }
        }) : /*#__PURE__*/ (0, $3Py8h.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)($52a829e7310b7f4c$var$MoovyHeader, {
                    breadcrumbsVisible: breadcrumbsVisible,
                    children: header
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $691082308a369afa$export$2e2bcd8739ae039), {
                    style: {
                        padding: 0
                    },
                    component: StyledPaper,
                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)($52a829e7310b7f4c$var$MoovySubHeader, {
                                children: subHeader
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)($52a829e7310b7f4c$var$MoovyContent, {
                                children: content
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $52a829e7310b7f4c$export$2e2bcd8739ae039 = $52a829e7310b7f4c$var$MoovyContainer;






var $3Py8h = parcelRequire("3Py8h");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");


var $5wtOU = parcelRequire("5wtOU");




var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $6b123947f59f4da8$export$2177af0aa15c34c2(slot) {
    return (0, $iNQht.default)("MuiDialog", slot);
}
const $6b123947f59f4da8$var$dialogClasses = (0, $dfswM.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $6b123947f59f4da8$export$2e2bcd8739ae039 = $6b123947f59f4da8$var$dialogClasses;



var $1T1QG = parcelRequire("1T1QG");
const $0c7639a31a4414e0$var$DialogContext = /*#__PURE__*/ $1T1QG.createContext({});
var $0c7639a31a4414e0$export$2e2bcd8739ae039 = $0c7639a31a4414e0$var$DialogContext;





var $3Py8h = parcelRequire("3Py8h");
"use client";
const $7bea536f0798909b$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $7bea536f0798909b$var$DialogBackdrop = (0, $npagc.default)((0, $9702be143407857e$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $7bea536f0798909b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $5wtOU.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $5wtOU.default)(scroll)}`,
            `paperWidth${(0, $5wtOU.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $6b123947f59f4da8$export$2177af0aa15c34c2), classes);
};
const $7bea536f0798909b$var$DialogRoot = (0, $npagc.default)((0, $167f720a102c0662$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $7bea536f0798909b$var$DialogContainer = (0, $npagc.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $5wtOU.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&::after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $7bea536f0798909b$var$DialogPaper = (0, $npagc.default)((0, $0a163fcc25046a25$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $5wtOU.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $5wtOU.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $6b123947f59f4da8$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $6b123947f59f4da8$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $6b123947f59f4da8$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $7bea536f0798909b$var$Dialog = /*#__PURE__*/ $1T1QG.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $0a163fcc25046a25$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $a2c582129c3c8d70$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $iXdVf.default)(props, $7bea536f0798909b$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $7bea536f0798909b$var$useUtilityClasses(ownerState);
    const backdropClick = $1T1QG.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $9dc24b323e690fdf$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $1T1QG.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($7bea536f0798909b$var$DialogRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $7bea536f0798909b$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $ajTRS.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)(TransitionComponent, (0, $ajTRS.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $3Py8h.jsx)($7bea536f0798909b$var$DialogContainer, {
                className: (0, $aVXbR.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $3Py8h.jsx)($7bea536f0798909b$var$DialogPaper, (0, $ajTRS.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $aVXbR.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $0c7639a31a4414e0$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $7bea536f0798909b$export$2e2bcd8739ae039 = $7bea536f0798909b$var$Dialog;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $0e977bad5816e80c$export$5e57a444791c63be(slot) {
    return (0, $iNQht.default)("MuiDialogActions", slot);
}
const $0e977bad5816e80c$var$dialogActionsClasses = (0, $dfswM.default)("MuiDialogActions", [
    "root",
    "spacing"
]);
var $0e977bad5816e80c$export$2e2bcd8739ae039 = $0e977bad5816e80c$var$dialogActionsClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $f390108b84fcd5b2$var$_excluded = [
    "className",
    "disableSpacing"
];
const $f390108b84fcd5b2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $0e977bad5816e80c$export$5e57a444791c63be), classes);
};
const $f390108b84fcd5b2$var$DialogActionsRoot = (0, $npagc.default)("div", {
    name: "MuiDialogActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        display: "flex",
        alignItems: "center",
        padding: 8,
        justifyContent: "flex-end",
        flex: "0 0 auto"
    }, !ownerState.disableSpacing && {
        "& > :not(style) ~ :not(style)": {
            marginLeft: 8
        }
    }));
const $f390108b84fcd5b2$var$DialogActions = /*#__PURE__*/ $1T1QG.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiDialogActions"
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $iXdVf.default)(props, $f390108b84fcd5b2$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $f390108b84fcd5b2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($f390108b84fcd5b2$var$DialogActionsRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $f390108b84fcd5b2$export$2e2bcd8739ae039 = $f390108b84fcd5b2$var$DialogActions;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $8abf46176579dbb5$export$61b0ee1f05fb344e(slot) {
    return (0, $iNQht.default)("MuiDialogContent", slot);
}
const $8abf46176579dbb5$var$dialogContentClasses = (0, $dfswM.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $8abf46176579dbb5$export$2e2bcd8739ae039 = $8abf46176579dbb5$var$dialogContentClasses;



var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $44f98dce8b6abdaf$export$f5d2ec7e4c47e088(slot) {
    return (0, $iNQht.default)("MuiDialogTitle", slot);
}
const $44f98dce8b6abdaf$var$dialogTitleClasses = (0, $dfswM.default)("MuiDialogTitle", [
    "root"
]);
var $44f98dce8b6abdaf$export$2e2bcd8739ae039 = $44f98dce8b6abdaf$var$dialogTitleClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $f1aede6b3222f80a$var$_excluded = [
    "className",
    "dividers"
];
const $f1aede6b3222f80a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $8abf46176579dbb5$export$61b0ee1f05fb344e), classes);
};
const $f1aede6b3222f80a$var$DialogContentRoot = (0, $npagc.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $44f98dce8b6abdaf$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $f1aede6b3222f80a$var$DialogContent = /*#__PURE__*/ $1T1QG.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $iXdVf.default)(props, $f1aede6b3222f80a$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        dividers: dividers
    });
    const classes = $f1aede6b3222f80a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($f1aede6b3222f80a$var$DialogContentRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $f1aede6b3222f80a$export$2e2bcd8739ae039 = $f1aede6b3222f80a$var$DialogContent;


var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");


var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $f0b53f8bfaaec241$var$_excluded = [
    "className",
    "id"
];
const $f0b53f8bfaaec241$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $44f98dce8b6abdaf$export$f5d2ec7e4c47e088), classes);
};
const $f0b53f8bfaaec241$var$DialogTitleRoot = (0, $npagc.default)((0, $a386176d6ca21602$export$2e2bcd8739ae039), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const $f0b53f8bfaaec241$var$DialogTitle = /*#__PURE__*/ $1T1QG.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className: className, id: idProp } = props, other = (0, $iXdVf.default)(props, $f0b53f8bfaaec241$var$_excluded);
    const ownerState = props;
    const classes = $f0b53f8bfaaec241$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $1T1QG.useContext((0, $0c7639a31a4414e0$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $3Py8h.jsx)($f0b53f8bfaaec241$var$DialogTitleRoot, (0, $ajTRS.default)({
        component: "h2",
        className: (0, $aVXbR.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $f0b53f8bfaaec241$export$2e2bcd8739ae039 = $f0b53f8bfaaec241$var$DialogTitle;



var $b51cd9b2d67bb13a$exports = {};
"use strict";
"use client";

Object.defineProperty($b51cd9b2d67bb13a$exports, "__esModule", {
    value: true
});
$b51cd9b2d67bb13a$exports.default = void 0;

var $b51cd9b2d67bb13a$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $b51cd9b2d67bb13a$var$_default = $b51cd9b2d67bb13a$exports.default = (0, $b51cd9b2d67bb13a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M18.3 5.71a.9959.9959 0 0 0-1.41 0L12 10.59 7.11 5.7a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4"
}), "CloseRounded");



parcelRequire("1T1QG");
const $7f916474711491ea$var$MoovyDialogConfirmation = (props)=>{
    const { open: open, header: header, content: content, lang: lang, onCancel: onCancel, onConfirm: onConfirm } = props;
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const resetView = ()=>{
        props.mutation?.reset();
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $7bea536f0798909b$export$2e2bcd8739ae039), {
        open: open,
        onClose: ()=>{
            resetView();
            onCancel();
        },
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f0b53f8bfaaec241$export$2e2bcd8739ae039), {
                sx: {
                    pr: 7
                },
                children: header
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $5c784366741908ee$export$2e2bcd8739ae039), {
                onClick: props.onCancel,
                sx: {
                    position: "absolute",
                    right: 10,
                    top: 10,
                    color: (theme)=>theme.palette.grey[500]
                },
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b51cd9b2d67bb13a$exports))), {})
            }),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f1aede6b3222f80a$export$2e2bcd8739ae039), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $019112675a75b38b$export$2e2bcd8739ae039), {
                        mutation: props.mutation,
                        errorTitleKey: lang.error
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                        style: {
                            padding: "5px"
                        },
                        children: content
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f390108b84fcd5b2$export$2e2bcd8739ae039), {
                sx: {
                    padding: 2
                },
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            resetView();
                            onCancel();
                        },
                        variant: "text",
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "common.buttons.cancel"
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                        disabled: props.mutation?.isPending || props.disableSubmit,
                        mutation: props.mutation,
                        onClick: ()=>{
                            onConfirm();
                        },
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: lang.confirmButton
                        })
                    })
                ]
            })
        ]
    });
};
var $7f916474711491ea$export$2e2bcd8739ae039 = $7f916474711491ea$var$MoovyDialogConfirmation;



var $3Py8h = parcelRequire("3Py8h");





const $259d9dbb3544503a$var$MoovyDialog = (props)=>{
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const fullScreen = (0, $ffad103d3c7e3bc8$export$2e2bcd8739ae039)(theme.breakpoints.down("md"));
    const { open: open, mutation: mutation, errorTitleKey: errorTitleKey, children: children, modalTitle: modalTitle, submitButtonContent: submitButtonContent, disableSubmit: disableSubmit, formReference: formReference, leftSideButtons: leftSideButtons, contentPadding: contentPadding, hideCancelButton: hideCancelButton, onCancel: onCancel, onSubmit: onSubmit, ...other } = props;
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $7bea536f0798909b$export$2e2bcd8739ae039), {
            open: open,
            onSubmit: onSubmit,
            fullScreen: fullScreen,
            onClose: onCancel,
            sx: fullScreen ? undefined : {
                "& .MuiDialog-paper": {
                    // Minimum width of all Moovy dialogs is set here
                    minWidth: "350px"
                }
            },
            ...other,
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f0b53f8bfaaec241$export$2e2bcd8739ae039), {
                    sx: {
                        pr: 7
                    },
                    children: modalTitle
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $5c784366741908ee$export$2e2bcd8739ae039), {
                    onClick: onCancel,
                    sx: {
                        position: "absolute",
                        right: 10,
                        top: 10,
                        color: (theme)=>theme.palette.grey[500]
                    },
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b51cd9b2d67bb13a$exports))), {})
                }),
                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f1aede6b3222f80a$export$2e2bcd8739ae039), {
                    dividers: true,
                    sx: {
                        padding: contentPadding,
                        position: "relative"
                    },
                    children: [
                        mutation && /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                            style: {
                                marginBottom: mutation?.error ? "1rem" : undefined
                            },
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $019112675a75b38b$export$2e2bcd8739ae039), {
                                mutation: mutation,
                                errorTitleKey: errorTitleKey || "common.actions.error"
                            })
                        }),
                        children,
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                            sx: {
                                opacity: 0.5
                            },
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $9702be143407857e$export$2e2bcd8739ae039), {
                                sx: {
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    backgroundColor: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).colorMainBackground,
                                    zIndex: 1
                                },
                                open: mutation?.isPending || false,
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b658ddb442599731$export$2e2bcd8739ae039), {})
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f390108b84fcd5b2$export$2e2bcd8739ae039), {
                    sx: {
                        padding: 2
                    },
                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                        sx: {
                            display: "flex",
                            justifyContent: leftSideButtons ? "space-between" : "right",
                            width: "100%"
                        },
                        children: [
                            leftSideButtons?.map((item)=>item),
                            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                                sx: {
                                    display: "flex",
                                    gap: 1
                                },
                                children: [
                                    !hideCancelButton && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                                        onClick: ()=>{
                                            onCancel();
                                        },
                                        variant: "text",
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                            id: "common.buttons.cancel"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                                        type: "submit",
                                        form: formReference,
                                        mutation: mutation,
                                        onClick: onSubmit,
                                        disabled: disableSubmit,
                                        children: submitButtonContent
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $259d9dbb3544503a$export$2e2bcd8739ae039 = $259d9dbb3544503a$var$MoovyDialog;




var $3Py8h = parcelRequire("3Py8h");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");


var $7Etkp = parcelRequire("7Etkp");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");






var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $8a990c13fcf8304c$export$5682c366c0c669d9(slot) {
    return (0, $iNQht.default)("MuiListItem", slot);
}
const $8a990c13fcf8304c$var$listItemClasses = (0, $dfswM.default)("MuiListItem", [
    "root",
    "container",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "padding",
    "button",
    "secondaryAction",
    "selected"
]);
var $8a990c13fcf8304c$export$2e2bcd8739ae039 = $8a990c13fcf8304c$var$listItemClasses;



var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $d2b399c3f14ea6a2$export$c09531d8563c67a5(slot) {
    return (0, $iNQht.default)("MuiListItemButton", slot);
}
const $d2b399c3f14ea6a2$var$listItemButtonClasses = (0, $dfswM.default)("MuiListItemButton", [
    "root",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $d2b399c3f14ea6a2$export$2e2bcd8739ae039 = $d2b399c3f14ea6a2$var$listItemButtonClasses;



var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");


var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $3cbc1e4bd0052931$export$ccdb26aeba48a86e(slot) {
    return (0, $iNQht.default)("MuiListItemSecondaryAction", slot);
}
const $3cbc1e4bd0052931$var$listItemSecondaryActionClasses = (0, $dfswM.default)("MuiListItemSecondaryAction", [
    "root",
    "disableGutters"
]);
var $3cbc1e4bd0052931$export$2e2bcd8739ae039 = $3cbc1e4bd0052931$var$listItemSecondaryActionClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $82b463a5081073a2$var$_excluded = [
    "className"
];
const $82b463a5081073a2$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $3cbc1e4bd0052931$export$ccdb26aeba48a86e), classes);
};
const $82b463a5081073a2$var$ListItemSecondaryActionRoot = (0, $npagc.default)("div", {
    name: "MuiListItemSecondaryAction",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        position: "absolute",
        right: 16,
        top: "50%",
        transform: "translateY(-50%)"
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $82b463a5081073a2$var$ListItemSecondaryAction = /*#__PURE__*/ $1T1QG.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiListItemSecondaryAction"
    });
    const { className: className } = props, other = (0, $iXdVf.default)(props, $82b463a5081073a2$var$_excluded);
    const context = $1T1QG.useContext((0, $be3ac30bfa71c06e$export$2e2bcd8739ae039));
    const ownerState = (0, $ajTRS.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $82b463a5081073a2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($82b463a5081073a2$var$ListItemSecondaryActionRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$82b463a5081073a2$var$ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
var $82b463a5081073a2$export$2e2bcd8739ae039 = $82b463a5081073a2$var$ListItemSecondaryAction;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $d458cf93737cba82$var$_excluded = [
    "className"
], $d458cf93737cba82$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $d458cf93737cba82$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $d458cf93737cba82$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            !disablePadding && "padding",
            divider && "divider",
            disabled && "disabled",
            button && "button",
            alignItems === "flex-start" && "alignItemsFlexStart",
            hasSecondaryAction && "secondaryAction",
            selected && "selected"
        ],
        container: [
            "container"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $8a990c13fcf8304c$export$5682c366c0c669d9), classes);
};
const $d458cf93737cba82$export$aed538f7519abe89 = (0, $npagc.default)("div", {
    name: "MuiListItem",
    slot: "Root",
    overridesResolver: $d458cf93737cba82$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "left"
    }, !ownerState.disablePadding && (0, $ajTRS.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $d2b399c3f14ea6a2$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $8a990c13fcf8304c$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $8a990c13fcf8304c$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $8a990c13fcf8304c$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $8a990c13fcf8304c$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.button && {
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $8a990c13fcf8304c$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $d458cf93737cba82$var$ListItemContainer = (0, $npagc.default)("li", {
    name: "MuiListItem",
    slot: "Container",
    overridesResolver: (props, styles)=>styles.container
})({
    position: "relative"
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $d458cf93737cba82$var$ListItem = /*#__PURE__*/ $1T1QG.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiListItem"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = "li", ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $iXdVf.default)(props.ContainerProps, $d458cf93737cba82$var$_excluded), other = (0, $iXdVf.default)(props, $d458cf93737cba82$var$_excluded2);
    const context = $1T1QG.useContext((0, $be3ac30bfa71c06e$export$2e2bcd8739ae039));
    const childContext = $1T1QG.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $1T1QG.useRef(null);
    (0, $675d87943b3ee26a$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $1T1QG.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $3a846aadfcffc110$export$2e2bcd8739ae039)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    const ownerState = (0, $ajTRS.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $d458cf93737cba82$var$useUtilityClasses(ownerState);
    const handleRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $d458cf93737cba82$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $aVXbR.default)((0, $8a990c13fcf8304c$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $ecc40a2d226ef234$export$2e2bcd8739ae039);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $be3ac30bfa71c06e$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $3Py8h.jsxs)($d458cf93737cba82$var$ListItemContainer, (0, $ajTRS.default)({
                as: ContainerComponent,
                className: (0, $aVXbR.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)(Root, (0, $ajTRS.default)({}, rootProps, !(0, $96ba78417123a6d2$export$e28348cc2430497)(Root) && {
                        as: Component,
                        ownerState: (0, $ajTRS.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $be3ac30bfa71c06e$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $3Py8h.jsxs)(Root, (0, $ajTRS.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $96ba78417123a6d2$export$e28348cc2430497)(Root) && {
            ownerState: (0, $ajTRS.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $82b463a5081073a2$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $d458cf93737cba82$export$2e2bcd8739ae039 = $d458cf93737cba82$var$ListItem;


parcelRequire("1T1QG");
const $836e912fb2b7fc60$var$MoovyListLabelValue = ({ data: data, breakpoint: breakpoint, splitByMiddle: splitByMiddle })=>{
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const isMobile = (0, $ffad103d3c7e3bc8$export$2e2bcd8739ae039)(theme.breakpoints.down(breakpoint || "sm"));
    if (isMobile) return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $44769ad997f9918f$export$2e2bcd8739ae039), {
        children: data.map((item, index)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $d458cf93737cba82$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $7308185c8ff27335$export$2e2bcd8739ae039), {
                    primary: item.label,
                    secondary: /*#__PURE__*/ (0, $3Py8h.jsx)("span", {
                        style: {
                            fontWeight: "bold"
                        },
                        children: item.value
                    })
                })
            }, index))
    });
    return data.map((item, index)=>/*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
            container: true,
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                    item: true,
                    xs: splitByMiddle ? 5 : 4,
                    children: item.label
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 1,
                    children: ":"
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                    item: true,
                    xs: splitByMiddle ? 6 : 5,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)("span", {
                        style: {
                            fontWeight: "bold"
                        },
                        children: item.value
                    })
                })
            ]
        }, index));
};
var $836e912fb2b7fc60$export$2e2bcd8739ae039 = $836e912fb2b7fc60$var$MoovyListLabelValue;



var $3Py8h = parcelRequire("3Py8h");

parcelRequire("1T1QG");

const $019112675a75b38b$var$getValidationErrors = (intl, validationErrors)=>{
    return validationErrors?.map((item)=>{
        return intl.formatMessage({
            id: `validation.code.${item.code}`,
            defaultMessage: intl.formatMessage({
                id: "validation.code.generic"
            })
        }, {
            field: intl.formatMessage({
                id: `validation.field.${item.field}`,
                defaultMessage: item.field
            })
        });
    });
};
const $019112675a75b38b$export$414e01788cec8720 = (intl, error)=>{
    if (error.response?.data?.validationErrors && error.response.data.validationErrors.length > 0) return $019112675a75b38b$var$getValidationErrors(intl, error.response.data.validationErrors);
    return null;
};
const $019112675a75b38b$export$b2aeb2d3d984ebee = (intl, error)=>{
    if (error.response?.data?.code) return intl.formatMessage({
        id: `api.error.code.${error.response?.data?.code}`,
        defaultMessage: intl.formatMessage({
            id: "api.error.code.generic"
        })
    });
    return null;
};
const $019112675a75b38b$var$MoovyMutationError = ({ mutation: mutation, query: query, errorTitleKey: errorTitleKey, errorBodyKey: errorBodyKey })=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const localizedErrorText = ({ mutation: mutation, query: query, errorBodyKey: errorBodyKey, errorTitleKey: errorTitleKey })=>{
        if (!mutation?.isError && !query?.isError) return "";
        const error = mutation?.error || query?.error;
        const localizedValidationErrors = $019112675a75b38b$export$414e01788cec8720(intl, error);
        const localizedError = $019112675a75b38b$export$b2aeb2d3d984ebee(intl, error);
        const localizedTitle = errorTitleKey && intl.formatMessage({
            id: errorTitleKey
        });
        if (localizedValidationErrors) return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $35d1b3ff9fe5891a$export$1da928963a217e70), {
            title: localizedTitle,
            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
                children: localizedValidationErrors.map((item, index)=>/*#__PURE__*/ (0, $3Py8h.jsx)("li", {
                        children: item
                    }, index))
            })
        });
        else if (localizedError) return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $35d1b3ff9fe5891a$export$1da928963a217e70), {
            title: localizedError
        });
        else return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $35d1b3ff9fe5891a$export$1da928963a217e70), {
            title: localizedTitle,
            children: errorBodyKey ? intl.formatMessage({
                id: errorBodyKey
            }) : null
        });
    };
    return localizedErrorText({
        mutation: mutation,
        query: query,
        errorBodyKey: errorBodyKey,
        errorTitleKey: errorTitleKey
    });
};
var $019112675a75b38b$export$2e2bcd8739ae039 = $019112675a75b38b$var$MoovyMutationError;




var $3Py8h = parcelRequire("3Py8h");

const $4cdfa78f7d1b8c19$var$MoovyProgress = (props)=>{
    const style = props.sx || {
        display: "flex",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
        sx: style,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b658ddb442599731$export$2e2bcd8739ae039), {
            ...props
        })
    });
};
var $4cdfa78f7d1b8c19$export$2e2bcd8739ae039 = $4cdfa78f7d1b8c19$var$MoovyProgress;




var $3Py8h = parcelRequire("3Py8h");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");


var $5wtOU = parcelRequire("5wtOU");

var $gADeF = parcelRequire("gADeF");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $27658fe134ec7d3f$export$e2cfa0ca4bce1fc2(slot) {
    return (0, $iNQht.default)("MuiFab", slot);
}
const $27658fe134ec7d3f$var$fabClasses = (0, $dfswM.default)("MuiFab", [
    "root",
    "primary",
    "secondary",
    "extended",
    "circular",
    "focusVisible",
    "disabled",
    "colorInherit",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge",
    "info",
    "error",
    "warning",
    "success"
]);
var $27658fe134ec7d3f$export$2e2bcd8739ae039 = $27658fe134ec7d3f$var$fabClasses;



var $npagc = parcelRequire("npagc");

var $3Py8h = parcelRequire("3Py8h");
"use client";
const $11e31eb22ff94faf$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "disableFocusRipple",
    "focusVisibleClassName",
    "size",
    "variant"
];
const $11e31eb22ff94faf$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `size${(0, $5wtOU.default)(size)}`,
            color === "inherit" ? "colorInherit" : color
        ]
    };
    const composedClasses = (0, $iV85C.default)(slots, (0, $27658fe134ec7d3f$export$e2cfa0ca4bce1fc2), classes);
    return (0, $ajTRS.default)({}, classes, composedClasses);
};
const $11e31eb22ff94faf$var$FabRoot = (0, $npagc.default)((0, $ecc40a2d226ef234$export$2e2bcd8739ae039), {
    name: "MuiFab",
    slot: "Root",
    shouldForwardProp: (prop)=>(0, $npagc.rootShouldForwardProp)(prop) || prop === "classes",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $5wtOU.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            styles[(0, $5wtOU.default)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    return (0, $ajTRS.default)({}, theme.typography.button, {
        minHeight: 36,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color"
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: "50%",
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: "none"
        },
        [`&.${(0, $27658fe134ec7d3f$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: (theme.vars || theme).shadows[6]
        }
    }, ownerState.size === "small" && {
        width: 40,
        height: 40
    }, ownerState.size === "medium" && {
        width: 48,
        height: 48
    }, ownerState.variant === "extended" && {
        borderRadius: 24,
        padding: "0 16px",
        width: "auto",
        minHeight: "auto",
        minWidth: 48,
        height: 48
    }, ownerState.variant === "extended" && ownerState.size === "small" && {
        width: "auto",
        padding: "0 8px",
        borderRadius: 17,
        minWidth: 34,
        height: 34
    }, ownerState.variant === "extended" && ownerState.size === "medium" && {
        width: "auto",
        padding: "0 16px",
        borderRadius: 20,
        minWidth: 40,
        height: 40
    }, ownerState.color === "inherit" && {
        color: "inherit"
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({}, ownerState.color !== "inherit" && ownerState.color !== "default" && (theme.vars || theme).palette[ownerState.color] != null && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }), ({ theme: theme })=>({
        [`&.${(0, $27658fe134ec7d3f$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    }));
const $11e31eb22ff94faf$var$Fab = /*#__PURE__*/ $1T1QG.forwardRef(function Fab(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiFab"
    });
    const { children: children, className: className, color: color = "default", component: component = "button", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, focusVisibleClassName: focusVisibleClassName, size: size = "large", variant: variant = "circular" } = props, other = (0, $iXdVf.default)(props, $11e31eb22ff94faf$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    });
    const classes = $11e31eb22ff94faf$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($11e31eb22ff94faf$var$FabRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $aVXbR.default)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref
    }, other, {
        classes: classes,
        children: children
    }));
});
var $11e31eb22ff94faf$export$2e2bcd8739ae039 = $11e31eb22ff94faf$var$Fab;


var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");







var $3Py8h = parcelRequire("3Py8h");
"use client";
const $d6d6c37ade146fff$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $d6d6c37ade146fff$var$styles = {
    entering: {
        transform: "none"
    },
    entered: {
        transform: "none"
    }
};
/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](/material-ui/react-button/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d6d6c37ade146fff$var$Zoom = /*#__PURE__*/ $1T1QG.forwardRef(function Zoom(props, ref) {
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $97e45c35ce24099f$export$2e2bcd8739ae039) } = props, other = (0, $iXdVf.default)(props, $d6d6c37ade146fff$var$_excluded);
    const nodeRef = $1T1QG.useRef(null);
    const handleRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $3c14342afe4d3400$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $3c14342afe4d3400$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("transform", transitionProps);
        node.style.transition = theme.transitions.create("transform", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $3c14342afe4d3400$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("transform", transitionProps);
        node.style.transition = theme.transitions.create("transform", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)(TransitionComponent, (0, $ajTRS.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $1T1QG.cloneElement(children, (0, $ajTRS.default)({
                style: (0, $ajTRS.default)({
                    transform: "scale(0)",
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $d6d6c37ade146fff$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $d6d6c37ade146fff$export$2e2bcd8739ae039 = $d6d6c37ade146fff$var$Zoom;



var $1T1QG = parcelRequire("1T1QG");
var $0d128473b5746220$exports = {};
"use strict";
"use client";

Object.defineProperty($0d128473b5746220$exports, "__esModule", {
    value: true
});
$0d128473b5746220$exports.default = void 0;

var $0d128473b5746220$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $0d128473b5746220$var$_default = $0d128473b5746220$exports.default = (0, $0d128473b5746220$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M8.12 14.71 12 10.83l3.88 3.88c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L12.7 8.71a.9959.9959 0 0 0-1.41 0L6.7 13.3c-.39.39-.39 1.02 0 1.41.39.38 1.03.39 1.42 0"
}), "KeyboardArrowUpRounded");


const $c9560da3d4f68f59$var$MoovyScrollToTop = ({})=>{
    const [showScroll, setshowScroll] = (0, $1T1QG.useState)(false);
    const [scrollY, setScrollY] = (0, $1T1QG.useState)(0);
    (0, $1T1QG.useEffect)(()=>{
        const handleScroll = ()=>{
            const innerHeight = window.innerHeight || 0;
            const y = window.scrollY;
            // Show the button only if user is scrolling down.
            setshowScroll(scrollY < y && y > innerHeight / 2);
            setScrollY(y);
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        scrollY
    ]);
    const scrollToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $d6d6c37ade146fff$export$2e2bcd8739ae039), {
            in: showScroll,
            timeout: {
                enter: 500,
                exit: 500
            },
            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $11e31eb22ff94faf$export$2e2bcd8739ae039), {
                size: "small",
                style: {
                    position: "fixed",
                    bottom: 16,
                    right: 16,
                    backgroundColor: "transparent"
                },
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0d128473b5746220$exports))), {
                    onClick: scrollToTop
                })
            })
        })
    });
};
var $c9560da3d4f68f59$export$2e2bcd8739ae039 = $c9560da3d4f68f59$var$MoovyScrollToTop;



var $3Py8h = parcelRequire("3Py8h");



var $1T1QG = parcelRequire("1T1QG");

const $2e40821b62a7b9dd$var$MoovySortAndFilter = ({ filterKey: filterKey, items: items, value: value, pt: pt, pb: pb, onChange: onChange })=>{
    const [state, setState] = (0, $adb860d4c4948aea$export$2e2bcd8739ae039)({
        key: filterKey,
        initialValue: {
            value: value || ""
        }
    });
    (0, $1T1QG.useEffect)(()=>{
        if (state.value) onChange(state.value);
    }, [
        state.value
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
        container: true,
        direction: "row",
        pt: pt,
        pb: pb,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
            item: true,
            md: 4,
            xs: 12,
            children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $7c26d84ab517f189$export$2e2bcd8739ae039), {
                fullWidth: true,
                size: "small",
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f4e04526214b55b7$export$2e2bcd8739ae039), {
                        id: "moovy-sort-and-filter-select-label",
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "moovySortAndFilter.sortingCriteria"
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $46f1ad6741eceffd$export$2e2bcd8739ae039), {
                        labelId: "moovy-sort-and-filter-select-label",
                        id: "moovy-sort-and-filter-select",
                        label: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "moovySortAndFilter.sortingCriteria"
                        }),
                        value: value,
                        onChange: (event)=>setState({
                                ...state,
                                value: event.target.value
                            }),
                        children: items.map((item, index)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $450c65ee2dafa292$export$2e2bcd8739ae039), {
                                value: item.key,
                                children: item.value
                            }, index))
                    })
                ]
            })
        })
    });
};
var $2e40821b62a7b9dd$export$2e2bcd8739ae039 = $2e40821b62a7b9dd$var$MoovySortAndFilter;



var $3Py8h = parcelRequire("3Py8h");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");


var $5wtOU = parcelRequire("5wtOU");

var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");


var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $402d22cba09acb7f$export$72aef224d6115253(slot) {
    return (0, $iNQht.default)("MuiTab", slot);
}
const $402d22cba09acb7f$var$tabClasses = (0, $dfswM.default)("MuiTab", [
    "root",
    "labelIcon",
    "textColorInherit",
    "textColorPrimary",
    "textColorSecondary",
    "selected",
    "disabled",
    "fullWidth",
    "wrapped",
    "iconWrapper"
]);
var $402d22cba09acb7f$export$2e2bcd8739ae039 = $402d22cba09acb7f$var$tabClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $e2bf0884486cfd13$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $e2bf0884486cfd13$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            icon && label && "labelIcon",
            `textColor${(0, $5wtOU.default)(textColor)}`,
            fullWidth && "fullWidth",
            wrapped && "wrapped",
            selected && "selected",
            disabled && "disabled"
        ],
        iconWrapper: [
            "iconWrapper"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $402d22cba09acb7f$export$72aef224d6115253), classes);
};
const $e2bf0884486cfd13$var$TabRoot = (0, $npagc.default)((0, $ecc40a2d226ef234$export$2e2bcd8739ae039), {
    name: "MuiTab",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $5wtOU.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: "relative",
        minHeight: 48,
        flexShrink: 0,
        padding: "12px 16px",
        overflow: "hidden",
        whiteSpace: "normal",
        textAlign: "center"
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === "top" || ownerState.iconPosition === "bottom" ? "column" : "row"
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $402d22cba09acb7f$export$2e2bcd8739ae039).iconWrapper}`]: (0, $ajTRS.default)({}, ownerState.iconPosition === "top" && {
            marginBottom: 6
        }, ownerState.iconPosition === "bottom" && {
            marginTop: 6
        }, ownerState.iconPosition === "start" && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === "end" && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === "inherit" && {
        color: "inherit",
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $402d22cba09acb7f$export$2e2bcd8739ae039).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $402d22cba09acb7f$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === "primary" && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $402d22cba09acb7f$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $402d22cba09acb7f$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === "secondary" && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $402d22cba09acb7f$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $402d22cba09acb7f$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: "none"
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $e2bf0884486cfd13$var$Tab = /*#__PURE__*/ $1T1QG.forwardRef(function Tab(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiTab"
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = "top", indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = "inherit", value: value, wrapped: wrapped = false } = props, other = (0, $iXdVf.default)(props, $e2bf0884486cfd13$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $e2bf0884486cfd13$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $1T1QG.isValidElement(iconProp) ? /*#__PURE__*/ $1T1QG.cloneElement(iconProp, {
        className: (0, $aVXbR.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($e2bf0884486cfd13$var$TabRoot, (0, $ajTRS.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $aVXbR.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === "top" || iconPosition === "start" ? /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $e2bf0884486cfd13$export$2e2bcd8739ae039 = $e2bf0884486cfd13$var$Tab;



var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");


var $3Py8h = parcelRequire("3Py8h");
"use client";
const $d423ca95270ef8d8$var$Context = /*#__PURE__*/ $1T1QG.createContext(null);
function $d423ca95270ef8d8$var$useUniquePrefix() {
    const [id, setId] = $1T1QG.useState(null);
    $1T1QG.useEffect(()=>{
        setId(`mui-p-${Math.round(Math.random() * 1e5)}`);
    }, []);
    return id;
}
function $d423ca95270ef8d8$export$2e2bcd8739ae039(props) {
    const { children: children, value: value } = props;
    const idPrefix = $d423ca95270ef8d8$var$useUniquePrefix();
    const context = $1T1QG.useMemo(()=>{
        return {
            idPrefix: idPrefix,
            value: value
        };
    }, [
        idPrefix,
        value
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($d423ca95270ef8d8$var$Context.Provider, {
        value: context,
        children: children
    });
}
function $d423ca95270ef8d8$export$5a3bad273ac578e0() {
    return $1T1QG.useContext($d423ca95270ef8d8$var$Context);
}
function $d423ca95270ef8d8$export$629f80328afcade5(context, value) {
    const { idPrefix: idPrefix } = context;
    if (idPrefix === null) return null;
    return `${context.idPrefix}-P-${value}`;
}
function $d423ca95270ef8d8$export$46f6d19d28231cb8(context, value) {
    const { idPrefix: idPrefix } = context;
    if (idPrefix === null) return null;
    return `${context.idPrefix}-T-${value}`;
}



var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");



var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");


// Source from https://github.com/alitaheri/normalize-scroll-left
let $67be9f14db19304c$var$cachedType;
function $67be9f14db19304c$export$a10970ffb6510128() {
    if ($67be9f14db19304c$var$cachedType) return $67be9f14db19304c$var$cachedType;
    const dummy = document.createElement("div");
    const container = document.createElement("div");
    container.style.width = "10px";
    container.style.height = "1px";
    dummy.appendChild(container);
    dummy.dir = "rtl";
    dummy.style.fontSize = "14px";
    dummy.style.width = "4px";
    dummy.style.height = "1px";
    dummy.style.position = "absolute";
    dummy.style.top = "-1000px";
    dummy.style.overflow = "scroll";
    document.body.appendChild(dummy);
    $67be9f14db19304c$var$cachedType = "reverse";
    if (dummy.scrollLeft > 0) $67be9f14db19304c$var$cachedType = "default";
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $67be9f14db19304c$var$cachedType = "negative";
    }
    document.body.removeChild(dummy);
    return $67be9f14db19304c$var$cachedType;
}
function $67be9f14db19304c$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== "rtl") return scrollLeft;
    const type = $67be9f14db19304c$export$a10970ffb6510128();
    switch(type){
        case "negative":
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case "reverse":
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $5529eeee253dd344$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $5529eeee253dd344$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $5529eeee253dd344$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error("Animation cancelled"));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error("Element already at target position"));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");




var $3Py8h = parcelRequire("3Py8h");
"use client";
const $fddf17d96ac14151$var$_excluded = [
    "onChange"
];
const $fddf17d96ac14151$var$styles = {
    width: 99,
    height: 99,
    position: "absolute",
    top: -9999,
    overflow: "scroll"
};
function $fddf17d96ac14151$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $iXdVf.default)(props, $fddf17d96ac14151$var$_excluded);
    const scrollbarHeight = $1T1QG.useRef();
    const nodeRef = $1T1QG.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $675d87943b3ee26a$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $48e766ac1390e9bf$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $200f56383d159758$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        onChange
    ]);
    $1T1QG.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)("div", (0, $ajTRS.default)({
        style: $fddf17d96ac14151$var$styles,
        ref: nodeRef
    }, other));
}



var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");
parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $3e396ee0bc67b980$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft");


parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $a67f5cb7986b1317$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");





var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $196e4a80f9d2a5e4$export$34861783d3c2eef8(slot) {
    return (0, $iNQht.default)("MuiTabScrollButton", slot);
}
const $196e4a80f9d2a5e4$var$tabScrollButtonClasses = (0, $dfswM.default)("MuiTabScrollButton", [
    "root",
    "vertical",
    "horizontal",
    "disabled"
]);
var $196e4a80f9d2a5e4$export$2e2bcd8739ae039 = $196e4a80f9d2a5e4$var$tabScrollButtonClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $c05688e30b5420ce$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $c05688e30b5420ce$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            disabled && "disabled"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $196e4a80f9d2a5e4$export$34861783d3c2eef8), classes);
};
const $c05688e30b5420ce$var$TabScrollButtonRoot = (0, $npagc.default)((0, $ecc40a2d226ef234$export$2e2bcd8739ae039), {
    name: "MuiTabScrollButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $196e4a80f9d2a5e4$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === "vertical" && {
        width: "100%",
        height: 40,
        "& svg": {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $c05688e30b5420ce$var$TabScrollButton = /*#__PURE__*/ $1T1QG.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiTabScrollButton"
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $iXdVf.default)(props, $c05688e30b5420ce$var$_excluded);
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $ajTRS.default)({
        isRtl: isRtl
    }, props);
    const classes = $c05688e30b5420ce$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $3e396ee0bc67b980$export$2e2bcd8739ae039);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $a67f5cb7986b1317$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $3b38c2c568b5248d$export$1e5c9e6e4e15efe3)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $3b38c2c568b5248d$export$1e5c9e6e4e15efe3)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: "small"
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)($c05688e30b5420ce$var$TabScrollButtonRoot, (0, $ajTRS.default)({
        component: "div",
        className: (0, $aVXbR.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === "left" ? /*#__PURE__*/ (0, $3Py8h.jsx)(StartButtonIcon, (0, $ajTRS.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $3Py8h.jsx)(EndButtonIcon, (0, $ajTRS.default)({}, endButtonIconProps))
    }));
});
var $c05688e30b5420ce$export$2e2bcd8739ae039 = $c05688e30b5420ce$var$TabScrollButton;




var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $55acd80d8b3e6cb4$export$cdd93bd054dec359(slot) {
    return (0, $iNQht.default)("MuiTabs", slot);
}
const $55acd80d8b3e6cb4$var$tabsClasses = (0, $dfswM.default)("MuiTabs", [
    "root",
    "vertical",
    "flexContainer",
    "flexContainerVertical",
    "centered",
    "scroller",
    "fixed",
    "scrollableX",
    "scrollableY",
    "hideScrollbar",
    "scrollButtons",
    "scrollButtonsHideMobile",
    "indicator"
]);
var $55acd80d8b3e6cb4$export$2e2bcd8739ae039 = $55acd80d8b3e6cb4$var$tabsClasses;





var $3Py8h = parcelRequire("3Py8h");
"use client";
const $448931189ca865c8$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $448931189ca865c8$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $448931189ca865c8$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $448931189ca865c8$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $448931189ca865c8$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            vertical && "vertical"
        ],
        scroller: [
            "scroller",
            fixed && "fixed",
            hideScrollbar && "hideScrollbar",
            scrollableX && "scrollableX",
            scrollableY && "scrollableY"
        ],
        flexContainer: [
            "flexContainer",
            vertical && "flexContainerVertical",
            centered && "centered"
        ],
        indicator: [
            "indicator"
        ],
        scrollButtons: [
            "scrollButtons",
            scrollButtonsHideMobile && "scrollButtonsHideMobile"
        ],
        scrollableX: [
            scrollableX && "scrollableX"
        ],
        hideScrollbar: [
            hideScrollbar && "hideScrollbar"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $55acd80d8b3e6cb4$export$cdd93bd054dec359), classes);
};
const $448931189ca865c8$var$TabsRoot = (0, $npagc.default)("div", {
    name: "MuiTabs",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $55acd80d8b3e6cb4$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $55acd80d8b3e6cb4$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $ajTRS.default)({
        overflow: "hidden",
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $55acd80d8b3e6cb4$export$2e2bcd8739ae039).scrollButtons}`]: {
            [theme.breakpoints.down("sm")]: {
                display: "none"
            }
        }
    }));
const $448931189ca865c8$var$TabsScroller = (0, $npagc.default)("div", {
    name: "MuiTabs",
    slot: "Scroller",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        position: "relative",
        display: "inline-block",
        flex: "1 1 auto",
        whiteSpace: "nowrap"
    }, ownerState.fixed && {
        overflowX: "hidden",
        width: "100%"
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: "none",
        // Firefox
        "&::-webkit-scrollbar": {
            display: "none" // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: "auto",
        overflowY: "hidden"
    }, ownerState.scrollableY && {
        overflowY: "auto",
        overflowX: "hidden"
    }));
const $448931189ca865c8$var$FlexContainer = (0, $npagc.default)("div", {
    name: "MuiTabs",
    slot: "FlexContainer",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        display: "flex"
    }, ownerState.vertical && {
        flexDirection: "column"
    }, ownerState.centered && {
        justifyContent: "center"
    }));
const $448931189ca865c8$var$TabsIndicator = (0, $npagc.default)("span", {
    name: "MuiTabs",
    slot: "Indicator",
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $ajTRS.default)({
        position: "absolute",
        height: 2,
        bottom: 0,
        width: "100%",
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === "primary" && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === "secondary" && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: "100%",
        width: 2,
        right: 0
    }));
const $448931189ca865c8$var$TabsScrollbarSize = (0, $npagc.default)((0, $fddf17d96ac14151$export$2e2bcd8739ae039))({
    overflowX: "auto",
    overflowY: "hidden",
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: "none",
    // Firefox
    "&::-webkit-scrollbar": {
        display: "none" // Safari + Chrome
    }
});
const $448931189ca865c8$var$defaultIndicatorStyle = {};
let $448931189ca865c8$var$warnedOnceTabPresent = false;
const $448931189ca865c8$var$Tabs = /*#__PURE__*/ $1T1QG.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiTabs"
    });
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = "div", allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = "primary", onChange: onChange, orientation: orientation = "horizontal", ScrollButtonComponent: ScrollButtonComponent = (0, $c05688e30b5420ce$export$2e2bcd8739ae039), scrollButtons: scrollButtons = "auto", selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = "primary", value: value, variant: variant = "standard", visibleScrollbar: visibleScrollbar = false } = props, other = (0, $iXdVf.default)(props, $448931189ca865c8$var$_excluded);
    const scrollable = variant === "scrollable";
    const vertical = orientation === "vertical";
    const scrollStart = vertical ? "scrollTop" : "scrollLeft";
    const start = vertical ? "top" : "left";
    const end = vertical ? "bottom" : "right";
    const clientSize = vertical ? "clientHeight" : "clientWidth";
    const size = vertical ? "height" : "width";
    const ownerState = (0, $ajTRS.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $448931189ca865c8$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $3b38c2c568b5248d$export$1e5c9e6e4e15efe3)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $3b38c2c568b5248d$export$1e5c9e6e4e15efe3)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $1T1QG.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $1T1QG.useState($448931189ca865c8$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $1T1QG.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $1T1QG.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $1T1QG.useState(false);
    const [scrollerStyle, setScrollerStyle] = $1T1QG.useState({
        overflow: "hidden",
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $1T1QG.useRef(null);
    const tabListRef = $1T1QG.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $67be9f14db19304c$export$3c615b88e5d7e4f6)(tabsNode, theme.direction),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $788a24ad2efceaa4$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = "top";
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? "right" : "left";
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $5529eeee253dd344$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $67be9f14db19304c$export$a10970ffb6510128)() === "reverse" ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $1T1QG.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $3Py8h.jsx)($448931189ca865c8$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $aVXbR.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === "auto" && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $3Py8h.jsx)(ScrollButtonComponent, (0, $ajTRS.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? "right" : "left",
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $aVXbR.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $3Py8h.jsx)(ScrollButtonComponent, (0, $ajTRS.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? "left" : "right",
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $aVXbR.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $788a24ad2efceaa4$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $788a24ad2efceaa4$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $1T1QG.useEffect(()=>{
        const handleResize = (0, $48e766ac1390e9bf$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $200f56383d159758$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener("resize", handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== "undefined") {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener("resize", handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $1T1QG.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== "undefined" && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $1T1QG.useEffect(()=>{
        setMounted(true);
    }, []);
    $1T1QG.useEffect(()=>{
        updateIndicatorState();
    });
    $1T1QG.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($448931189ca865c8$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $1T1QG.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $3Py8h.jsx)($448931189ca865c8$var$TabsIndicator, (0, $ajTRS.default)({}, TabIndicatorProps, {
        className: (0, $aVXbR.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $ajTRS.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $1T1QG.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $1T1QG.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $1T1QG.cloneElement(child, (0, $ajTRS.default)({
            fullWidth: variant === "fullWidth",
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $8c4927d8b7167c70$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute("role");
        if (role !== "tab") return;
        let previousItemKey = orientation === "horizontal" ? "ArrowLeft" : "ArrowUp";
        let nextItemKey = orientation === "horizontal" ? "ArrowRight" : "ArrowDown";
        if (orientation === "horizontal" && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = "ArrowRight";
            nextItemKey = "ArrowLeft";
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $448931189ca865c8$var$moveFocus(list, currentFocus, $448931189ca865c8$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $448931189ca865c8$var$moveFocus(list, currentFocus, $448931189ca865c8$var$nextItem);
                break;
            case "Home":
                event.preventDefault();
                $448931189ca865c8$var$moveFocus(list, null, $448931189ca865c8$var$nextItem);
                break;
            case "End":
                event.preventDefault();
                $448931189ca865c8$var$moveFocus(list, null, $448931189ca865c8$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($448931189ca865c8$var$TabsRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $3Py8h.jsxs)($448931189ca865c8$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? "Left" : "Right"}` : "marginBottom"]: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)($448931189ca865c8$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === "vertical" ? "vertical" : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $448931189ca865c8$export$2e2bcd8739ae039 = $448931189ca865c8$var$Tabs;




var $3Py8h = parcelRequire("3Py8h");
"use client";
const $a58fb06fabff6b5f$var$_excluded = [
    "children"
];
const $a58fb06fabff6b5f$var$TabList = /*#__PURE__*/ $1T1QG.forwardRef(function TabList(props, ref) {
    const { children: childrenProp } = props, other = (0, $iXdVf.default)(props, $a58fb06fabff6b5f$var$_excluded);
    const context = (0, $d423ca95270ef8d8$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError("No TabContext provided");
    const children = $1T1QG.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $1T1QG.isValidElement(child)) return null;
        return /*#__PURE__*/ $1T1QG.cloneElement(child, {
            // SOMEDAY: `Tabs` will set those themselves
            "aria-controls": (0, $d423ca95270ef8d8$export$629f80328afcade5)(context, child.props.value),
            id: (0, $d423ca95270ef8d8$export$46f6d19d28231cb8)(context, child.props.value)
        });
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $448931189ca865c8$export$2e2bcd8739ae039), (0, $ajTRS.default)({}, other, {
        ref: ref,
        value: context.value,
        children: children
    }));
});
var $a58fb06fabff6b5f$export$2e2bcd8739ae039 = $a58fb06fabff6b5f$var$TabList;



var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");

var $iV85C = parcelRequire("iV85C");

var $iNQht = parcelRequire("iNQht");

var $dfswM = parcelRequire("dfswM");
function $e214d8a0f653d129$export$cfb3da2e74936ec(slot) {
    return (0, $iNQht.default)("MuiTabPanel", slot);
}
const $e214d8a0f653d129$var$tabPanelClasses = (0, $dfswM.default)("MuiTabPanel", [
    "root"
]);
var $e214d8a0f653d129$export$2e2bcd8739ae039 = $e214d8a0f653d129$var$tabPanelClasses;




var $3Py8h = parcelRequire("3Py8h");
"use client";
const $a9c45a97b4477608$var$_excluded = [
    "children",
    "className",
    "value"
];
const $a9c45a97b4477608$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $e214d8a0f653d129$export$cfb3da2e74936ec), classes);
};
const $a9c45a97b4477608$var$TabPanelRoot = (0, $npagc.default)("div", {
    name: "MuiTabPanel",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(3)
    }));
const $a9c45a97b4477608$var$TabPanel = /*#__PURE__*/ $1T1QG.forwardRef(function TabPanel(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiTabPanel"
    });
    const { children: children, className: className, value: value } = props, other = (0, $iXdVf.default)(props, $a9c45a97b4477608$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props);
    const classes = $a9c45a97b4477608$var$useUtilityClasses(ownerState);
    const context = (0, $d423ca95270ef8d8$export$5a3bad273ac578e0)();
    if (context === null) throw new TypeError("No TabContext provided");
    const id = (0, $d423ca95270ef8d8$export$629f80328afcade5)(context, value);
    const tabId = (0, $d423ca95270ef8d8$export$46f6d19d28231cb8)(context, value);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($a9c45a97b4477608$var$TabPanelRoot, (0, $ajTRS.default)({
        "aria-labelledby": tabId,
        className: (0, $aVXbR.default)(classes.root, className),
        hidden: value !== context.value,
        id: id,
        ref: ref,
        role: "tabpanel",
        ownerState: ownerState
    }, other, {
        children: value === context.value && children
    }));
});
var $a9c45a97b4477608$export$2e2bcd8739ae039 = $a9c45a97b4477608$var$TabPanel;



const $752b2919b820e82b$var$MoovyTab = ({ tabKey: tabKey, tabHeaders: tabHeaders, defaultPanel: defaultPanel, tabPanels: tabPanels })=>{
    const [state, setState] = (0, $adb860d4c4948aea$export$2e2bcd8739ae039)({
        key: tabKey,
        initialValue: {
            value: defaultPanel || "0"
        }
    });
    (0, $1T1QG.useEffect)(()=>{
        if (state.value >= tabPanels.length) setState({
            ...state,
            value: (tabPanels.length - 1).toString()
        });
    }, [
        state
    ]);
    const handleChange = (event, newValue)=>{
        setState({
            ...state,
            value: newValue
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d423ca95270ef8d8$export$2e2bcd8739ae039), {
        value: state.value,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                sx: {
                    paddingTop: 2,
                    borderBottom: 1,
                    borderColor: "divider"
                },
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a58fb06fabff6b5f$export$2e2bcd8739ae039), {
                    onChange: handleChange,
                    children: tabHeaders.map((header, index)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $e2bf0884486cfd13$export$2e2bcd8739ae039), {
                            label: header,
                            value: index.toString()
                        }, index))
                })
            }),
            tabPanels.map((item, index)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $a9c45a97b4477608$export$2e2bcd8739ae039), {
                    value: index.toString(),
                    style: {
                        padding: 0
                    },
                    children: item
                }, index))
        ]
    });
};
var $752b2919b820e82b$export$2e2bcd8739ae039 = $752b2919b820e82b$var$MoovyTab;



var $3Py8h = parcelRequire("3Py8h");

var $npagc = parcelRequire("npagc");
var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");


var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $1e946ff910b0c626$export$315cb19215f77ce0(slot) {
    return (0, $iNQht.default)("MuiTable", slot);
}
const $1e946ff910b0c626$var$tableClasses = (0, $dfswM.default)("MuiTable", [
    "root",
    "stickyHeader"
]);
var $1e946ff910b0c626$export$2e2bcd8739ae039 = $1e946ff910b0c626$var$tableClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $7e3dbfb82185a082$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $7e3dbfb82185a082$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            stickyHeader && "stickyHeader"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $1e946ff910b0c626$export$315cb19215f77ce0), classes);
};
const $7e3dbfb82185a082$var$TableRoot = (0, $npagc.default)("table", {
    name: "MuiTable",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        display: "table",
        width: "100%",
        borderCollapse: "collapse",
        borderSpacing: 0,
        "& caption": (0, $ajTRS.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: "left",
            captionSide: "bottom"
        })
    }, ownerState.stickyHeader && {
        borderCollapse: "separate"
    }));
const $7e3dbfb82185a082$var$defaultComponent = "table";
const $7e3dbfb82185a082$var$Table = /*#__PURE__*/ $1T1QG.forwardRef(function Table(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiTable"
    });
    const { className: className, component: component = $7e3dbfb82185a082$var$defaultComponent, padding: padding = "normal", size: size = "medium", stickyHeader: stickyHeader = false } = props, other = (0, $iXdVf.default)(props, $7e3dbfb82185a082$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $7e3dbfb82185a082$var$useUtilityClasses(ownerState);
    const table = $1T1QG.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $0f6394a893d81a39$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($7e3dbfb82185a082$var$TableRoot, (0, $ajTRS.default)({
            as: component,
            role: component === $7e3dbfb82185a082$var$defaultComponent ? null : "table",
            ref: ref,
            className: (0, $aVXbR.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $7e3dbfb82185a082$export$2e2bcd8739ae039 = $7e3dbfb82185a082$var$Table;


var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $f926c2aecd84f345$export$eed427986a7abdf9(slot) {
    return (0, $iNQht.default)("MuiTableContainer", slot);
}
const $f926c2aecd84f345$var$tableContainerClasses = (0, $dfswM.default)("MuiTableContainer", [
    "root"
]);
var $f926c2aecd84f345$export$2e2bcd8739ae039 = $f926c2aecd84f345$var$tableContainerClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $6abbe67d79d2bbe1$var$_excluded = [
    "className",
    "component"
];
const $6abbe67d79d2bbe1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $f926c2aecd84f345$export$eed427986a7abdf9), classes);
};
const $6abbe67d79d2bbe1$var$TableContainerRoot = (0, $npagc.default)("div", {
    name: "MuiTableContainer",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    width: "100%",
    overflowX: "auto"
});
const $6abbe67d79d2bbe1$var$TableContainer = /*#__PURE__*/ $1T1QG.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiTableContainer"
    });
    const { className: className, component: component = "div" } = props, other = (0, $iXdVf.default)(props, $6abbe67d79d2bbe1$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        component: component
    });
    const classes = $6abbe67d79d2bbe1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($6abbe67d79d2bbe1$var$TableContainerRoot, (0, $ajTRS.default)({
        ref: ref,
        as: component,
        className: (0, $aVXbR.default)(classes.root, className),
        ownerState: ownerState
    }, other));
});
var $6abbe67d79d2bbe1$export$2e2bcd8739ae039 = $6abbe67d79d2bbe1$var$TableContainer;




var $1T1QG = parcelRequire("1T1QG");




const $c6e866c0d03fba92$var$StyledPaper = (0, $npagc.default)((0, $0a163fcc25046a25$export$2e2bcd8739ae039))({
    boxShadow: "none"
});
const $c6e866c0d03fba92$var$EmptyTable = (props)=>{
    const { children: children, query: query, emptyTextId: emptyTextId, errorTextId: errorTextId } = props;
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Children.map(children, (child, i)=>{
                // Parse only the first content which is the header of the table
                if (i > 1) return;
                return child;
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a3b5a93a68cc46b9$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                        colSpan: 99,
                        children: query?.isError ? /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                            style: {
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $019112675a75b38b$export$2e2bcd8739ae039), {
                                query: query,
                                errorTitleKey: errorTextId || "shared.moovyTable.action.failed"
                            })
                        }) : /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                            style: {
                                textAlign: "center"
                            },
                            children: emptyTextId && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                id: emptyTextId
                            }) || /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                id: "shared.moovyTable.action.emptySet"
                            })
                        })
                    })
                })
            })
        ]
    });
};
const $c6e866c0d03fba92$var$ContentTable = ({ items: items, emptyTextId: emptyTextId, errorTextId: errorTextId, query: query, pagination: pagination, ...tableProps })=>{
    const [page, setPage] = (0, $1T1QG.useState)(pagination?.page || 1);
    if (items?.length > 0 && tableProps.children) return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $6abbe67d79d2bbe1$export$2e2bcd8739ae039), {
        component: $c6e866c0d03fba92$var$StyledPaper,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $7e3dbfb82185a082$export$2e2bcd8739ae039), {
                ...tableProps,
                children: tableProps.children
            }),
            pagination && pagination.total > pagination.limit && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $55d02d7b1a5c4f16$export$2e2bcd8739ae039), {
                page: page,
                total: pagination.total,
                limit: pagination.limit,
                onNextPage: (page)=>{
                    setPage(page);
                    pagination.onNextPage(page);
                }
            })
        ]
    });
    else return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $7e3dbfb82185a082$export$2e2bcd8739ae039), {
        ...tableProps,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($c6e866c0d03fba92$var$EmptyTable, {
            query: query,
            emptyTextId: emptyTextId,
            errorTextId: errorTextId,
            children: tableProps.children
        })
    });
};
const $c6e866c0d03fba92$var$LoadingTable = (props)=>{
    const [isProgressVisible, setIsProgressVisible] = (0, $1T1QG.useState)(false);
    const [state] = (0, $adb860d4c4948aea$export$2e2bcd8739ae039)({
        key: (0, $5f8ca62b06e02682$export$add10c4cb4cd7fd0),
        initialValue: {
            value: ""
        }
    });
    (0, $1T1QG.useEffect)(()=>{
        setIsProgressVisible(!!state.value);
    }, [
        state.value
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, {
        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
            sx: {
                opacity: 0.5,
                color: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).progressBlockContentColor,
                pointerEvents: "none",
                position: "relative"
            },
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)($c6e866c0d03fba92$var$ContentTable, {
                    ...props
                }),
                !isProgressVisible && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4cdfa78f7d1b8c19$export$2e2bcd8739ae039), {
                    sx: {
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }
                })
            ]
        })
    });
};
const $c6e866c0d03fba92$var$MoovyTable = (props)=>{
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const isMobile = (0, $ffad103d3c7e3bc8$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    // As a default, the table is hidden in mobile view.
    const isHidden = props.hidden || isMobile;
    return !isHidden && (props.query?.isLoading || props.query?.isFetching ? /*#__PURE__*/ (0, $3Py8h.jsx)($c6e866c0d03fba92$var$LoadingTable, {
        ...props
    }) : /*#__PURE__*/ (0, $3Py8h.jsx)($c6e866c0d03fba92$var$ContentTable, {
        ...props
    }));
};
var $c6e866c0d03fba92$export$2e2bcd8739ae039 = $c6e866c0d03fba92$var$MoovyTable;



var $3Py8h = parcelRequire("3Py8h");



var $1T1QG = parcelRequire("1T1QG");



const $8002a2b5b87a23eb$var$MoovyGrid = ({ emptyTextId: emptyTextId, errorTextId: errorTextId, hidden: hidden, query: query, pagination: pagination, children: children })=>{
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const isMobile = (0, $ffad103d3c7e3bc8$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    const [page, setPage] = (0, $1T1QG.useState)(pagination?.page || 1);
    const cards = children;
    const showEmptyText = !query?.isError && (!cards || cards.length <= 0);
    const showLoading = query?.isLoading || query?.isFetching;
    // As a default, the grid is hidden in browser view.
    const isHidden = hidden || !isMobile;
    return !isHidden && /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
        container: true,
        gap: 2,
        justifyContent: "center",
        children: [
            showLoading && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4cdfa78f7d1b8c19$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $019112675a75b38b$export$2e2bcd8739ae039), {
                query: query,
                errorTitleKey: errorTextId || "common.actions.error"
            }),
            cards?.map((item, index)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    children: item
                }, index)),
            showEmptyText && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                container: true,
                xs: 12,
                justifyContent: "center",
                children: emptyTextId && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: emptyTextId
                }) || /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "common.actions.get.error"
                })
            }),
            pagination && pagination.total > pagination.limit && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $55d02d7b1a5c4f16$export$2e2bcd8739ae039), {
                        page: page,
                        total: pagination.total,
                        limit: pagination.limit,
                        onNextPage: (page)=>{
                            setPage(page);
                            pagination.onNextPage(page);
                        }
                    })
                })
            })
        ]
    });
};
var $8002a2b5b87a23eb$export$2e2bcd8739ae039 = $8002a2b5b87a23eb$var$MoovyGrid;



var $3Py8h = parcelRequire("3Py8h");


parcelRequire("1T1QG");
const $e0829f6a75e4b5e7$var$MoovyGridCard = (props)=>{
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const isMobile = (0, $ffad103d3c7e3bc8$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    return isMobile && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $735a53468da95e8b$export$2e2bcd8739ae039), {
        ...props
    });
};
var $e0829f6a75e4b5e7$export$2e2bcd8739ae039 = $e0829f6a75e4b5e7$var$MoovyGridCard;



var $3Py8h = parcelRequire("3Py8h");



var $0e5b464b06d073c2$exports = {};
"use strict";
"use client";

Object.defineProperty($0e5b464b06d073c2$exports, "__esModule", {
    value: true
});
$0e5b464b06d073c2$exports.default = void 0;

var $0e5b464b06d073c2$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $0e5b464b06d073c2$var$_default = $0e5b464b06d073c2$exports.default = (0, $0e5b464b06d073c2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "CheckCircleOutline");


const $c76a66d914cee346$var$MoovyParkingEnforcementStatus = ({ parkingEnforcement: parkingEnforcement })=>{
    return parkingEnforcement ? /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
        display: "flex",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0e5b464b06d073c2$exports))), {
                sx: {
                    mr: 1
                },
                color: "success"
            }),
            " ",
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "moovyParkingEnforcementStatus.yes"
            })
        ]
    }) : /*#__PURE__*/ (0, $3Py8h.jsx)("span", {
        style: {
            color: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).commonRed
        },
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
            id: "moovyParkingEnforcementStatus.no"
        })
    });
};
var $c76a66d914cee346$export$2e2bcd8739ae039 = $c76a66d914cee346$var$MoovyParkingEnforcementStatus;



var $3Py8h = parcelRequire("3Py8h");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");

var $aVXbR = parcelRequire("aVXbR");


var $aMdXx = parcelRequire("aMdXx");

var $iV85C = parcelRequire("iV85C");

var $7Etkp = parcelRequire("7Etkp");function $5ae0f71074d2e423$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $5ae0f71074d2e423$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function $5ae0f71074d2e423$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $5ae0f71074d2e423$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $5ae0f71074d2e423$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $5ae0f71074d2e423$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== "px") {
            if (fromUnit === "em") pxLength = $5ae0f71074d2e423$export$8af1d214c6c2f0f1(length) * $5ae0f71074d2e423$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === "rem") pxLength = $5ae0f71074d2e423$export$8af1d214c6c2f0f1(length) * $5ae0f71074d2e423$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== "px") {
            if (toUnit === "em") outputLength = pxLength / $5ae0f71074d2e423$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === "rem") outputLength = pxLength / $5ae0f71074d2e423$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $5ae0f71074d2e423$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $5ae0f71074d2e423$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $5ae0f71074d2e423$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = "rem", breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}



var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $de31376d6f2670eb$export$c987db9fc844f86(slot) {
    return (0, $iNQht.default)("MuiSkeleton", slot);
}
const $de31376d6f2670eb$var$skeletonClasses = (0, $dfswM.default)("MuiSkeleton", [
    "root",
    "text",
    "rectangular",
    "rounded",
    "circular",
    "pulse",
    "wave",
    "withChildren",
    "fitContent",
    "heightAuto"
]);
var $de31376d6f2670eb$export$2e2bcd8739ae039 = $de31376d6f2670eb$var$skeletonClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $be30d023e7b6f9c0$var$_excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let $be30d023e7b6f9c0$var$_ = (t)=>t, $be30d023e7b6f9c0$var$_t, $be30d023e7b6f9c0$var$_t2, $be30d023e7b6f9c0$var$_t3, $be30d023e7b6f9c0$var$_t4;
const $be30d023e7b6f9c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            animation,
            hasChildren && "withChildren",
            hasChildren && !width && "fitContent",
            hasChildren && !height && "heightAuto"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $de31376d6f2670eb$export$c987db9fc844f86), classes);
};
const $be30d023e7b6f9c0$var$pulseKeyframe = (0, $aMdXx.keyframes)($be30d023e7b6f9c0$var$_t || ($be30d023e7b6f9c0$var$_t = $be30d023e7b6f9c0$var$_`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const $be30d023e7b6f9c0$var$waveKeyframe = (0, $aMdXx.keyframes)($be30d023e7b6f9c0$var$_t2 || ($be30d023e7b6f9c0$var$_t2 = $be30d023e7b6f9c0$var$_`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const $be30d023e7b6f9c0$var$SkeletonRoot = (0, $npagc.default)("span", {
    name: "MuiSkeleton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const radiusUnit = (0, $5ae0f71074d2e423$export$65f2564e9a9b9222)(theme.shape.borderRadius) || "px";
    const radiusValue = (0, $5ae0f71074d2e423$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return (0, $ajTRS.default)({
        display: "block",
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $7Etkp.alpha)(theme.palette.text.primary, theme.palette.mode === "light" ? 0.11 : 0.13),
        height: "1.2em"
    }, ownerState.variant === "text" && {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        "&:empty:before": {
            content: '"\\00a0"'
        }
    }, ownerState.variant === "circular" && {
        borderRadius: "50%"
    }, ownerState.variant === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        "& > *": {
            visibility: "hidden"
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: "fit-content"
    }, ownerState.hasChildren && !ownerState.height && {
        height: "auto"
    });
}, ({ ownerState: ownerState })=>ownerState.animation === "pulse" && (0, $aMdXx.css)($be30d023e7b6f9c0$var$_t3 || ($be30d023e7b6f9c0$var$_t3 = $be30d023e7b6f9c0$var$_`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), $be30d023e7b6f9c0$var$pulseKeyframe), ({ ownerState: ownerState, theme: theme })=>ownerState.animation === "wave" && (0, $aMdXx.css)($be30d023e7b6f9c0$var$_t4 || ($be30d023e7b6f9c0$var$_t4 = $be30d023e7b6f9c0$var$_`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), $be30d023e7b6f9c0$var$waveKeyframe, (theme.vars || theme).palette.action.hover));
const $be30d023e7b6f9c0$var$Skeleton = /*#__PURE__*/ $1T1QG.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiSkeleton"
    });
    const { animation: animation = "pulse", className: className, component: component = "span", height: height, style: style, variant: variant = "text", width: width } = props, other = (0, $iXdVf.default)(props, $be30d023e7b6f9c0$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    });
    const classes = $be30d023e7b6f9c0$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($be30d023e7b6f9c0$var$SkeletonRoot, (0, $ajTRS.default)({
        as: component,
        ref: ref,
        className: (0, $aVXbR.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, $ajTRS.default)({
            width: width,
            height: height
        }, style)
    }));
});
var $be30d023e7b6f9c0$export$2e2bcd8739ae039 = $be30d023e7b6f9c0$var$Skeleton;



var $1T1QG = parcelRequire("1T1QG");








const $290ea4cf8141603d$export$e32ce87e5105839e = (navigate, error)=>{
    if (error && (0, $86c4afe1b01fac23$export$2e2bcd8739ae039).isAxiosError(error)) {
        const axiosError = error;
        if (axiosError?.response?.status === 404) navigate((0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).ROOT);
    }
};




const $b914262cfd70d60a$var$BackdropAnimation = ({ show: show })=>{
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const [state, setState] = (0, $adb860d4c4948aea$export$2e2bcd8739ae039)({
        key: (0, $5f8ca62b06e02682$export$add10c4cb4cd7fd0),
        initialValue: {
            value: ""
        }
    });
    (0, $1T1QG.useEffect)(()=>{
        if (show != !!state.value) setState({
            value: show ? "true" : ""
        });
    }, [
        show
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
        sx: {
            opacity: 0.5,
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: theme.zIndex.drawer + 1,
            visibility: show ? "visible" : "hidden"
        },
        id: (0, $f989e98d45efceaa$export$4b65f495352b3bd3).MOOVY_BACKDROP_ANIMATION,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $9702be143407857e$export$2e2bcd8739ae039), {
            sx: {
                backgroundColor: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).colorMainBackground
            },
            open: show,
            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4cdfa78f7d1b8c19$export$2e2bcd8739ae039), {})
        })
    });
};
const $b914262cfd70d60a$var$ProgressAnimation = ()=>{
    const getSkeletonAnimations = ()=>{
        const skeletonCount = 8;
        const skeletonItems = [];
        for(let i = 0; i < skeletonCount; i++)skeletonItems.push(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $be30d023e7b6f9c0$export$2e2bcd8739ae039), {
            animation: "wave"
        }, i));
        return skeletonItems.map((item)=>item);
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
        container: true,
        gap: 2,
        mt: 2,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $be30d023e7b6f9c0$export$2e2bcd8739ae039), {
                    variant: "rounded",
                    height: 60
                })
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                children: getSkeletonAnimations()
            })
        ]
    });
};
const $b914262cfd70d60a$var$MoovyQueryHandler = ({ query: query, rootPageIfNotFoundError: rootPageIfNotFoundError, children: children })=>{
    const navigate = (0, $e0cff2801449e77d$export$9770f232ac06a008)();
    if (rootPageIfNotFoundError) (0, $290ea4cf8141603d$export$e32ce87e5105839e)(navigate, query.error);
    const noDataAnimation = query.isFetching && !query.data;
    const dataAnimation = query.isFetching && !!query.data;
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            query.isError ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c338ce915869c7c0$export$2e2bcd8739ae039), {}) : noDataAnimation ? /*#__PURE__*/ (0, $3Py8h.jsx)($b914262cfd70d60a$var$ProgressAnimation, {}) : /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)($b914262cfd70d60a$var$BackdropAnimation, {
                        show: dataAnimation
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $019112675a75b38b$export$2e2bcd8739ae039), {
                query: query,
                errorTitleKey: "common.actions.get.error"
            })
        ]
    });
};
var $b914262cfd70d60a$export$2e2bcd8739ae039 = $b914262cfd70d60a$var$MoovyQueryHandler;





var $3Py8h = parcelRequire("3Py8h");


var $3Py8h = parcelRequire("3Py8h");








var $3Py8h = parcelRequire("3Py8h");



parcelRequire("1T1QG");

const $c308d832ed326a5d$var$CataloguePlaceInfo = ({ place: place })=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const data = [
        {
            label: intl.formatMessage({
                id: "page.catalogues.tabCatalogue.cataloguePlaceInfo.name"
            }),
            value: place?.name
        },
        {
            label: intl.formatMessage({
                id: "page.catalogues.tabCatalogue.cataloguePlaceInfo.street"
            }),
            value: `${(0, $fb47a354e391b3c4$export$ff20516246215bf)(place?.streetAddress, place?.postalCode, ", ")} ${place?.city}`
        },
        {
            label: intl.formatMessage({
                id: "page.catalogues.tabCatalogue.cataloguePlaceInfo.capacity"
            }),
            value: place?.capacity
        }
    ];
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)("h3", {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "page.catalogues.tabCatalogue.cataloguePlaceInfo.title"
                })
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a976032e8b2c1f5c$export$2e2bcd8739ae039), {
                style: {
                    marginBottom: "20px"
                }
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $836e912fb2b7fc60$export$2e2bcd8739ae039), {
                data: data,
                splitByMiddle: true
            })
        ]
    });
};
var $c308d832ed326a5d$export$2e2bcd8739ae039 = $c308d832ed326a5d$var$CataloguePlaceInfo;



var $3Py8h = parcelRequire("3Py8h");



parcelRequire("1T1QG");

const $7d0fb16f631a2a72$var$CatalogueStatusInfo = ({ catalogue: catalogue, whitelistOffering: whitelistOffering })=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const grantAmount = catalogue?.amount || 0;
    const grantedAmount = catalogue?.activeRights || 0;
    const data = [];
    !whitelistOffering && data.push({
        label: intl.formatMessage({
            id: "page.catalogues.tabCatalogue.catalogueStatusInfo.grantAmount"
        }),
        value: grantAmount
    });
    data.push({
        label: intl.formatMessage({
            id: "page.catalogues.tabCatalogue.catalogueStatusInfo.grantedAmount"
        }),
        value: whitelistOffering ? grantedAmount : (0, $fb47a354e391b3c4$export$ec9646ddc27ee461)(grantAmount, grantedAmount)
    });
    if (catalogue?.costCenter) data.push({
        label: intl.formatMessage({
            id: "page.catalogues.tabCatalogue.catalogueStatusInfo.costCenter"
        }),
        value: catalogue.costCenter
    });
    if (catalogue?.project) data.push({
        label: intl.formatMessage({
            id: "page.catalogues.tabCatalogue.catalogueStatusInfo.project"
        }),
        value: catalogue.project
    });
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)("h3", {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "page.catalogues.tabCatalogue.catalogueStatusInfo.title"
                })
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a976032e8b2c1f5c$export$2e2bcd8739ae039), {
                style: {
                    marginBottom: "20px"
                }
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $836e912fb2b7fc60$export$2e2bcd8739ae039), {
                data: data,
                splitByMiddle: true
            })
        ]
    });
};
var $7d0fb16f631a2a72$export$2e2bcd8739ae039 = $7d0fb16f631a2a72$var$CatalogueStatusInfo;






const $6b405f573a8ac986$var$BASE_URL = "offerings";
const $6b405f573a8ac986$var$getOfferingById = (id)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${(0, $5d4b99a1a33ba093$export$f654b28f82155665)(false)}/${$6b405f573a8ac986$var$BASE_URL}/${id}`).then((response)=>response.data);
};
const $6b405f573a8ac986$var$createOffering = (placeRef, offering)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).post(`${(0, $5d4b99a1a33ba093$export$f654b28f82155665)(false)}/places/${placeRef}/offering`, offering);
};
const $6b405f573a8ac986$var$updateOffering = (ref, placeRef, offering)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).put(`${(0, $5d4b99a1a33ba093$export$f654b28f82155665)(false)}/places/${placeRef}/${$6b405f573a8ac986$var$BASE_URL}/${ref}`, offering);
};
const $6b405f573a8ac986$var$getRightHoldersByOffering = (offeringId, queryParams)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${(0, $5d4b99a1a33ba093$export$f654b28f82155665)(false)}/offerings/${offeringId}/active-rights`, {
        params: queryParams
    }).then((response)=>response.data);
};
const $6b405f573a8ac986$export$ca807e2054383e2d = {
    getOfferingById: $6b405f573a8ac986$var$getOfferingById,
    createOffering: $6b405f573a8ac986$var$createOffering,
    updateOffering: $6b405f573a8ac986$var$updateOffering,
    getRightHoldersByOffering: $6b405f573a8ac986$var$getRightHoldersByOffering
};



var $3Py8h = parcelRequire("3Py8h");



var $1T1QG = parcelRequire("1T1QG");


var $3Py8h = parcelRequire("3Py8h");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");

var $1T1QG = parcelRequire("1T1QG");
/**
 * Provides information about the current step in Stepper.
 */ const $6998c144cb644165$var$StepperContext = /*#__PURE__*/ $1T1QG.createContext({});
function $6998c144cb644165$export$1ff9b16b13b0447() {
    return $1T1QG.useContext($6998c144cb644165$var$StepperContext);
}
var $6998c144cb644165$export$2e2bcd8739ae039 = $6998c144cb644165$var$StepperContext;



var $1T1QG = parcelRequire("1T1QG");
/**
 * Provides information about the current step in Stepper.
 */ const $dec9e74b5a2de585$var$StepContext = /*#__PURE__*/ $1T1QG.createContext({});
function $dec9e74b5a2de585$export$90d5f24cfecec416() {
    return $1T1QG.useContext($dec9e74b5a2de585$var$StepContext);
}
var $dec9e74b5a2de585$export$2e2bcd8739ae039 = $dec9e74b5a2de585$var$StepContext;



var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $3bcd3cf7f32a0109$export$8977e0f3c012cfac(slot) {
    return (0, $iNQht.default)("MuiStep", slot);
}
const $3bcd3cf7f32a0109$var$stepClasses = (0, $dfswM.default)("MuiStep", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel",
    "completed"
]);
var $3bcd3cf7f32a0109$export$2e2bcd8739ae039 = $3bcd3cf7f32a0109$var$stepClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $f6f1b9657beabe18$var$_excluded = [
    "active",
    "children",
    "className",
    "component",
    "completed",
    "disabled",
    "expanded",
    "index",
    "last"
];
const $f6f1b9657beabe18$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, completed: completed } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel",
            completed && "completed"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $3bcd3cf7f32a0109$export$8977e0f3c012cfac), classes);
};
const $f6f1b9657beabe18$var$StepRoot = (0, $npagc.default)("div", {
    name: "MuiStep",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({}, ownerState.orientation === "horizontal" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.alternativeLabel && {
        flex: 1,
        position: "relative"
    }));
const $f6f1b9657beabe18$var$Step = /*#__PURE__*/ $1T1QG.forwardRef(function Step(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiStep"
    });
    const { active: activeProp, children: children, className: className, component: component = "div", completed: completedProp, disabled: disabledProp, expanded: expanded = false, index: index, last: last } = props, other = (0, $iXdVf.default)(props, $f6f1b9657beabe18$var$_excluded);
    const { activeStep: activeStep, connector: connector, alternativeLabel: alternativeLabel, orientation: orientation, nonLinear: nonLinear } = $1T1QG.useContext((0, $6998c144cb644165$export$2e2bcd8739ae039));
    let [active = false, completed = false, disabled = false] = [
        activeProp,
        completedProp,
        disabledProp
    ];
    if (activeStep === index) active = activeProp !== undefined ? activeProp : true;
    else if (!nonLinear && activeStep > index) completed = completedProp !== undefined ? completedProp : true;
    else if (!nonLinear && activeStep < index) disabled = disabledProp !== undefined ? disabledProp : true;
    const contextValue = $1T1QG.useMemo(()=>({
            index: index,
            last: last,
            expanded: expanded,
            icon: index + 1,
            active: active,
            completed: completed,
            disabled: disabled
        }), [
        index,
        last,
        expanded,
        active,
        completed,
        disabled
    ]);
    const ownerState = (0, $ajTRS.default)({}, props, {
        active: active,
        orientation: orientation,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        expanded: expanded,
        component: component
    });
    const classes = $f6f1b9657beabe18$var$useUtilityClasses(ownerState);
    const newChildren = /*#__PURE__*/ (0, $3Py8h.jsxs)($f6f1b9657beabe18$var$StepRoot, (0, $ajTRS.default)({
        as: component,
        className: (0, $aVXbR.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            connector && alternativeLabel && index !== 0 ? connector : null,
            children
        ]
    }));
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $dec9e74b5a2de585$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: connector && !alternativeLabel && index !== 0 ? /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
            children: [
                connector,
                newChildren
            ]
        }) : newChildren
    });
});
var $f6f1b9657beabe18$export$2e2bcd8739ae039 = $f6f1b9657beabe18$var$Step;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");
parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $1b525c696a8671f0$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), "CheckCircle");


parcelRequire("1T1QG");

var $jdjLq = parcelRequire("jdjLq");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $41f5064c3f1a7976$export$2e2bcd8739ae039 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning");



var $lCLan = parcelRequire("lCLan");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $05474ed14511dab3$export$62a6e0748bec9297(slot) {
    return (0, $iNQht.default)("MuiStepIcon", slot);
}
const $05474ed14511dab3$var$stepIconClasses = (0, $dfswM.default)("MuiStepIcon", [
    "root",
    "active",
    "completed",
    "error",
    "text"
]);
var $05474ed14511dab3$export$2e2bcd8739ae039 = $05474ed14511dab3$var$stepIconClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
var $4e6f8d53adc6cb1f$var$_circle;
const $4e6f8d53adc6cb1f$var$_excluded = [
    "active",
    "className",
    "completed",
    "error",
    "icon"
];
const $4e6f8d53adc6cb1f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, active: active, completed: completed, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            active && "active",
            completed && "completed",
            error && "error"
        ],
        text: [
            "text"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $05474ed14511dab3$export$62a6e0748bec9297), classes);
};
const $4e6f8d53adc6cb1f$var$StepIconRoot = (0, $npagc.default)((0, $lCLan.default), {
    name: "MuiStepIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: "block",
        transition: theme.transitions.create("color", {
            duration: theme.transitions.duration.shortest
        }),
        color: (theme.vars || theme).palette.text.disabled,
        [`&.${(0, $05474ed14511dab3$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $05474ed14511dab3$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $05474ed14511dab3$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $4e6f8d53adc6cb1f$var$StepIconText = (0, $npagc.default)("text", {
    name: "MuiStepIcon",
    slot: "Text",
    overridesResolver: (props, styles)=>styles.text
})(({ theme: theme })=>({
        fill: (theme.vars || theme).palette.primary.contrastText,
        fontSize: theme.typography.caption.fontSize,
        fontFamily: theme.typography.fontFamily
    }));
const $4e6f8d53adc6cb1f$var$StepIcon = /*#__PURE__*/ $1T1QG.forwardRef(function StepIcon(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiStepIcon"
    });
    const { active: active = false, className: classNameProp, completed: completed = false, error: error = false, icon: icon } = props, other = (0, $iXdVf.default)(props, $4e6f8d53adc6cb1f$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        active: active,
        completed: completed,
        error: error
    });
    const classes = $4e6f8d53adc6cb1f$var$useUtilityClasses(ownerState);
    if (typeof icon === "number" || typeof icon === "string") {
        const className = (0, $aVXbR.default)(classNameProp, classes.root);
        if (error) return /*#__PURE__*/ (0, $3Py8h.jsx)($4e6f8d53adc6cb1f$var$StepIconRoot, (0, $ajTRS.default)({
            as: (0, $41f5064c3f1a7976$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        if (completed) return /*#__PURE__*/ (0, $3Py8h.jsx)($4e6f8d53adc6cb1f$var$StepIconRoot, (0, $ajTRS.default)({
            as: (0, $1b525c696a8671f0$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        return /*#__PURE__*/ (0, $3Py8h.jsxs)($4e6f8d53adc6cb1f$var$StepIconRoot, (0, $ajTRS.default)({
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                $4e6f8d53adc6cb1f$var$_circle || ($4e6f8d53adc6cb1f$var$_circle = /*#__PURE__*/ (0, $3Py8h.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "12"
                })),
                /*#__PURE__*/ (0, $3Py8h.jsx)($4e6f8d53adc6cb1f$var$StepIconText, {
                    className: classes.text,
                    x: "12",
                    y: "12",
                    textAnchor: "middle",
                    dominantBaseline: "central",
                    ownerState: ownerState,
                    children: icon
                })
            ]
        }));
    }
    return icon;
});
var $4e6f8d53adc6cb1f$export$2e2bcd8739ae039 = $4e6f8d53adc6cb1f$var$StepIcon;





var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $9468da2787a6524e$export$9625a725551d158a(slot) {
    return (0, $iNQht.default)("MuiStepLabel", slot);
}
const $9468da2787a6524e$var$stepLabelClasses = (0, $dfswM.default)("MuiStepLabel", [
    "root",
    "horizontal",
    "vertical",
    "label",
    "active",
    "completed",
    "error",
    "disabled",
    "iconContainer",
    "alternativeLabel",
    "labelContainer"
]);
var $9468da2787a6524e$export$2e2bcd8739ae039 = $9468da2787a6524e$var$stepLabelClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $6f2a56b8d3467b7b$var$_excluded = [
    "children",
    "className",
    "componentsProps",
    "error",
    "icon",
    "optional",
    "slotProps",
    "StepIconComponent",
    "StepIconProps"
];
const $6f2a56b8d3467b7b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, active: active, completed: completed, error: error, disabled: disabled, alternativeLabel: alternativeLabel } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            error && "error",
            disabled && "disabled",
            alternativeLabel && "alternativeLabel"
        ],
        label: [
            "label",
            active && "active",
            completed && "completed",
            error && "error",
            disabled && "disabled",
            alternativeLabel && "alternativeLabel"
        ],
        iconContainer: [
            "iconContainer",
            active && "active",
            completed && "completed",
            error && "error",
            disabled && "disabled",
            alternativeLabel && "alternativeLabel"
        ],
        labelContainer: [
            "labelContainer",
            alternativeLabel && "alternativeLabel"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $9468da2787a6524e$export$9625a725551d158a), classes);
};
const $6f2a56b8d3467b7b$var$StepLabelRoot = (0, $npagc.default)("span", {
    name: "MuiStepLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        display: "flex",
        alignItems: "center",
        [`&.${(0, $9468da2787a6524e$export$2e2bcd8739ae039).alternativeLabel}`]: {
            flexDirection: "column"
        },
        [`&.${(0, $9468da2787a6524e$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.orientation === "vertical" && {
        textAlign: "left",
        padding: "8px 0"
    }));
const $6f2a56b8d3467b7b$var$StepLabelLabel = (0, $npagc.default)("span", {
    name: "MuiStepLabel",
    slot: "Label",
    overridesResolver: (props, styles)=>styles.label
})(({ theme: theme })=>(0, $ajTRS.default)({}, theme.typography.body2, {
        display: "block",
        transition: theme.transitions.create("color", {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $9468da2787a6524e$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $9468da2787a6524e$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $9468da2787a6524e$export$2e2bcd8739ae039).alternativeLabel}`]: {
            marginTop: 16
        },
        [`&.${(0, $9468da2787a6524e$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $6f2a56b8d3467b7b$var$StepLabelIconContainer = (0, $npagc.default)("span", {
    name: "MuiStepLabel",
    slot: "IconContainer",
    overridesResolver: (props, styles)=>styles.iconContainer
})(()=>({
        flexShrink: 0,
        // Fix IE11 issue
        display: "flex",
        paddingRight: 8,
        [`&.${(0, $9468da2787a6524e$export$2e2bcd8739ae039).alternativeLabel}`]: {
            paddingRight: 0
        }
    }));
const $6f2a56b8d3467b7b$var$StepLabelLabelContainer = (0, $npagc.default)("span", {
    name: "MuiStepLabel",
    slot: "LabelContainer",
    overridesResolver: (props, styles)=>styles.labelContainer
})(({ theme: theme })=>({
        width: "100%",
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $9468da2787a6524e$export$2e2bcd8739ae039).alternativeLabel}`]: {
            textAlign: "center"
        }
    }));
const $6f2a56b8d3467b7b$var$StepLabel = /*#__PURE__*/ $1T1QG.forwardRef(function StepLabel(inProps, ref) {
    var _slotProps$label;
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiStepLabel"
    });
    const { children: children, className: className, componentsProps: componentsProps = {}, error: error = false, icon: iconProp, optional: optional, slotProps: slotProps = {}, StepIconComponent: StepIconComponentProp, StepIconProps: StepIconProps } = props, other = (0, $iXdVf.default)(props, $6f2a56b8d3467b7b$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation } = $1T1QG.useContext((0, $6998c144cb644165$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed, icon: iconContext } = $1T1QG.useContext((0, $dec9e74b5a2de585$export$2e2bcd8739ae039));
    const icon = iconProp || iconContext;
    let StepIconComponent = StepIconComponentProp;
    if (icon && !StepIconComponent) StepIconComponent = (0, $4e6f8d53adc6cb1f$export$2e2bcd8739ae039);
    const ownerState = (0, $ajTRS.default)({}, props, {
        active: active,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        error: error,
        orientation: orientation
    });
    const classes = $6f2a56b8d3467b7b$var$useUtilityClasses(ownerState);
    const labelSlotProps = (_slotProps$label = slotProps.label) != null ? _slotProps$label : componentsProps.label;
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($6f2a56b8d3467b7b$var$StepLabelRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            icon || StepIconComponent ? /*#__PURE__*/ (0, $3Py8h.jsx)($6f2a56b8d3467b7b$var$StepLabelIconContainer, {
                className: classes.iconContainer,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $3Py8h.jsx)(StepIconComponent, (0, $ajTRS.default)({
                    completed: completed,
                    active: active,
                    error: error,
                    icon: icon
                }, StepIconProps))
            }) : null,
            /*#__PURE__*/ (0, $3Py8h.jsxs)($6f2a56b8d3467b7b$var$StepLabelLabelContainer, {
                className: classes.labelContainer,
                ownerState: ownerState,
                children: [
                    children ? /*#__PURE__*/ (0, $3Py8h.jsx)($6f2a56b8d3467b7b$var$StepLabelLabel, (0, $ajTRS.default)({
                        ownerState: ownerState
                    }, labelSlotProps, {
                        className: (0, $aVXbR.default)(classes.label, labelSlotProps == null ? void 0 : labelSlotProps.className),
                        children: children
                    })) : null,
                    optional
                ]
            })
        ]
    }));
});
$6f2a56b8d3467b7b$var$StepLabel.muiName = "StepLabel";
var $6f2a56b8d3467b7b$export$2e2bcd8739ae039 = $6f2a56b8d3467b7b$var$StepLabel;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");

var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $d3a9af0601a96243$export$797947b6292e28e1(slot) {
    return (0, $iNQht.default)("MuiStepper", slot);
}
const $d3a9af0601a96243$var$stepperClasses = (0, $dfswM.default)("MuiStepper", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel"
]);
var $d3a9af0601a96243$export$2e2bcd8739ae039 = $d3a9af0601a96243$var$stepperClasses;



var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $5wtOU = parcelRequire("5wtOU");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");



var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $443d708d69c631d1$export$6fbaff484b0d9308(slot) {
    return (0, $iNQht.default)("MuiStepConnector", slot);
}
const $443d708d69c631d1$var$stepConnectorClasses = (0, $dfswM.default)("MuiStepConnector", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel",
    "active",
    "completed",
    "disabled",
    "line",
    "lineHorizontal",
    "lineVertical"
]);
var $443d708d69c631d1$export$2e2bcd8739ae039 = $443d708d69c631d1$var$stepConnectorClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $a96ef4a77243b0d4$var$_excluded = [
    "className"
];
const $a96ef4a77243b0d4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, active: active, completed: completed, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel",
            active && "active",
            completed && "completed",
            disabled && "disabled"
        ],
        line: [
            "line",
            `line${(0, $5wtOU.default)(orientation)}`
        ]
    };
    return (0, $iV85C.default)(slots, (0, $443d708d69c631d1$export$6fbaff484b0d9308), classes);
};
const $a96ef4a77243b0d4$var$StepConnectorRoot = (0, $npagc.default)("div", {
    name: "MuiStepConnector",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        flex: "1 1 auto"
    }, ownerState.orientation === "vertical" && {
        marginLeft: 12 // half icon
    }, ownerState.alternativeLabel && {
        position: "absolute",
        top: 12,
        left: "calc(-50% + 20px)",
        right: "calc(50% + 20px)"
    }));
const $a96ef4a77243b0d4$var$StepConnectorLine = (0, $npagc.default)("span", {
    name: "MuiStepConnector",
    slot: "Line",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.line,
            styles[`line${(0, $5wtOU.default)(ownerState.orientation)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[600];
    return (0, $ajTRS.default)({
        display: "block",
        borderColor: theme.vars ? theme.vars.palette.StepConnector.border : borderColor
    }, ownerState.orientation === "horizontal" && {
        borderTopStyle: "solid",
        borderTopWidth: 1
    }, ownerState.orientation === "vertical" && {
        borderLeftStyle: "solid",
        borderLeftWidth: 1,
        minHeight: 24
    });
});
const $a96ef4a77243b0d4$var$StepConnector = /*#__PURE__*/ $1T1QG.forwardRef(function StepConnector(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiStepConnector"
    });
    const { className: className } = props, other = (0, $iXdVf.default)(props, $a96ef4a77243b0d4$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation = "horizontal" } = $1T1QG.useContext((0, $6998c144cb644165$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed } = $1T1QG.useContext((0, $dec9e74b5a2de585$export$2e2bcd8739ae039));
    const ownerState = (0, $ajTRS.default)({}, props, {
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        active: active,
        completed: completed,
        disabled: disabled
    });
    const classes = $a96ef4a77243b0d4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($a96ef4a77243b0d4$var$StepConnectorRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($a96ef4a77243b0d4$var$StepConnectorLine, {
            className: classes.line,
            ownerState: ownerState
        })
    }));
});
var $a96ef4a77243b0d4$export$2e2bcd8739ae039 = $a96ef4a77243b0d4$var$StepConnector;




var $3Py8h = parcelRequire("3Py8h");
"use client";
const $a37c1bd20156d042$var$_excluded = [
    "activeStep",
    "alternativeLabel",
    "children",
    "className",
    "component",
    "connector",
    "nonLinear",
    "orientation"
];
const $a37c1bd20156d042$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, alternativeLabel: alternativeLabel, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $d3a9af0601a96243$export$797947b6292e28e1), classes);
};
const $a37c1bd20156d042$var$StepperRoot = (0, $npagc.default)("div", {
    name: "MuiStepper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        display: "flex"
    }, ownerState.orientation === "horizontal" && {
        flexDirection: "row",
        alignItems: "center"
    }, ownerState.orientation === "vertical" && {
        flexDirection: "column"
    }, ownerState.alternativeLabel && {
        alignItems: "flex-start"
    }));
const $a37c1bd20156d042$var$defaultConnector = /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a96ef4a77243b0d4$export$2e2bcd8739ae039), {});
const $a37c1bd20156d042$var$Stepper = /*#__PURE__*/ $1T1QG.forwardRef(function Stepper(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiStepper"
    });
    const { activeStep: activeStep = 0, alternativeLabel: alternativeLabel = false, children: children, className: className, component: component = "div", connector: connector = $a37c1bd20156d042$var$defaultConnector, nonLinear: nonLinear = false, orientation: orientation = "horizontal" } = props, other = (0, $iXdVf.default)(props, $a37c1bd20156d042$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        component: component
    });
    const classes = $a37c1bd20156d042$var$useUtilityClasses(ownerState);
    const childrenArray = $1T1QG.Children.toArray(children).filter(Boolean);
    const steps = childrenArray.map((step, index)=>{
        return /*#__PURE__*/ $1T1QG.cloneElement(step, (0, $ajTRS.default)({
            index: index,
            last: index + 1 === childrenArray.length
        }, step.props));
    });
    const contextValue = $1T1QG.useMemo(()=>({
            activeStep: activeStep,
            alternativeLabel: alternativeLabel,
            connector: connector,
            nonLinear: nonLinear,
            orientation: orientation
        }), [
        activeStep,
        alternativeLabel,
        connector,
        nonLinear,
        orientation
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $6998c144cb644165$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($a37c1bd20156d042$var$StepperRoot, (0, $ajTRS.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $aVXbR.default)(classes.root, className),
            ref: ref
        }, other, {
            children: steps
        }))
    });
});
var $a37c1bd20156d042$export$2e2bcd8739ae039 = $a37c1bd20156d042$var$Stepper;




var $1T1QG = parcelRequire("1T1QG");
const $9efc3d7accb9d2fe$export$e49861a9373f5f25 = (rightHolder)=>{
    if (rightHolder.type === "individual") {
        const dataIndividual = rightHolder;
        return `${dataIndividual.firstName}${dataIndividual.firstName ? " " : ""}${dataIndividual.lastName}`;
    } else if (rightHolder.type === "vehicle") {
        const dataVehicle = rightHolder;
        return dataVehicle.licensePlate;
    }
    return "";
};



var $1d497a506d9a8a6b$exports = {};
"use strict";
"use client";

Object.defineProperty($1d497a506d9a8a6b$exports, "__esModule", {
    value: true
});
$1d497a506d9a8a6b$exports.default = void 0;

var $1d497a506d9a8a6b$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $1d497a506d9a8a6b$var$_default = $1d497a506d9a8a6b$exports.default = (0, $1d497a506d9a8a6b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 14H4V6h16zM4 0h16v2H4zm0 22h16v2H4zm8-10c1.38 0 2.5-1.12 2.5-2.5S13.38 7 12 7 9.5 8.12 9.5 9.5 10.62 12 12 12m0-3.5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m5 7.49C17 13.9 13.69 13 12 13s-5 .9-5 2.99V17h10zm-8.19-.49c.61-.52 2.03-1 3.19-1 1.17 0 2.59.48 3.2 1z"
}), "ContactsOutlined");



var $e82629ceb64f6e49$exports = {};
"use strict";
"use client";

Object.defineProperty($e82629ceb64f6e49$exports, "__esModule", {
    value: true
});
$e82629ceb64f6e49$exports.default = void 0;

var $e82629ceb64f6e49$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $e82629ceb64f6e49$var$_default = $e82629ceb64f6e49$exports.default = (0, $e82629ceb64f6e49$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $3Py8h.jsx)("path", {
        d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7M7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9"
    }, "0"),
    /*#__PURE__*/ (0, $3Py8h.jsx)("circle", {
        cx: "12",
        cy: "9",
        r: "2.5"
    }, "1")
], "LocationOnOutlined");






const $bfd03858b5cf8c88$var$BASE_URL = `${(0, $5d4b99a1a33ba093$export$ff0725f0ea898f41)}/individuals`;
const $bfd03858b5cf8c88$var$createIndividual = (rightHolder)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).post($bfd03858b5cf8c88$var$BASE_URL, rightHolder);
};
const $bfd03858b5cf8c88$var$updateIndividual = (rightHolderRef, rightHolder)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).put(`${$bfd03858b5cf8c88$var$BASE_URL}/${rightHolderRef}`, rightHolder);
};
const $bfd03858b5cf8c88$var$getIndividualByRef = (ref)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get(`${$bfd03858b5cf8c88$var$BASE_URL}/${ref}`).then((response)=>response.data);
};
const $bfd03858b5cf8c88$var$getIndividualsByEmail = (email)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).get($bfd03858b5cf8c88$var$BASE_URL, {
        params: {
            email: email
        }
    }).then((response)=>response.data);
};
const $bfd03858b5cf8c88$var$grantRightToIndividual = (ref, data)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).post(`${$bfd03858b5cf8c88$var$BASE_URL}/${ref}/grant-right`, data);
};
const $bfd03858b5cf8c88$var$grantRightToVehicle = (data)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).post(`${(0, $5d4b99a1a33ba093$export$ff0725f0ea898f41)}/vehicles/grant-right`, data);
};
const $bfd03858b5cf8c88$var$RightHoldersAPI = {
    createIndividual: $bfd03858b5cf8c88$var$createIndividual,
    updateIndividual: $bfd03858b5cf8c88$var$updateIndividual,
    getIndividualByRef: $bfd03858b5cf8c88$var$getIndividualByRef,
    getIndividualsByEmail: $bfd03858b5cf8c88$var$getIndividualsByEmail,
    grantRightToIndividual: $bfd03858b5cf8c88$var$grantRightToIndividual,
    grantRightToVehicle: $bfd03858b5cf8c88$var$grantRightToVehicle
};
var $bfd03858b5cf8c88$export$2e2bcd8739ae039 = $bfd03858b5cf8c88$var$RightHoldersAPI;



var $3Py8h = parcelRequire("3Py8h");

var $3Py8h = parcelRequire("3Py8h");




var $1T1QG = parcelRequire("1T1QG");


var $eUHG3 = parcelRequire("eUHG3");



function $0096c5b24842924c$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $1T1QG = parcelRequire("1T1QG");



var $gADeF = parcelRequire("gADeF");




var $1T1QG = parcelRequire("1T1QG");

var $ajKsV = parcelRequire("ajKsV");
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $381cff6a989e76ba$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}
var $381cff6a989e76ba$export$2e2bcd8739ae039 = $381cff6a989e76ba$var$resolveComponentProps;



var $ajKsV = parcelRequire("ajKsV");
const $12e3e097abfa372a$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object
]);
var $12e3e097abfa372a$export$2e2bcd8739ae039 = $12e3e097abfa372a$var$refType;




const $5fcb694dda34c3a0$export$f07872cd524bec98 = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
const $5fcb694dda34c3a0$export$bdf8d867ddc968e = ({ openTo: openTo, defaultOpenTo: defaultOpenTo, views: views, defaultViews: defaultViews })=>{
    const viewsWithDefault = views ?? defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error("MUI X: The `views` prop must contain at least one view.");
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};


const $2c8437f6b047f676$export$a98b123b8f29e004 = (utils, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = utils.setHours(mergedDate, utils.getHours(timeParam));
    mergedDate = utils.setMinutes(mergedDate, utils.getMinutes(timeParam));
    mergedDate = utils.setSeconds(mergedDate, utils.getSeconds(timeParam));
    mergedDate = utils.setMilliseconds(mergedDate, utils.getMilliseconds(timeParam));
    return mergedDate;
};
const $2c8437f6b047f676$export$ca1f317ae8db2ee8 = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, utils: utils, timezone: timezone })=>{
    const today = $2c8437f6b047f676$export$a98b123b8f29e004(utils, utils.date(undefined, timezone), date);
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    }
    return null;
};
const $2c8437f6b047f676$export$36ca889e039badd5 = (utils, value)=>value == null || !utils.isValid(value) ? null : value;
const $2c8437f6b047f676$export$eb73579ccade48fd = (utils, value, defaultValue)=>{
    if (value == null || !utils.isValid(value)) return defaultValue;
    return value;
};
const $2c8437f6b047f676$export$8fabf9a4cbada414 = (utils, a, b)=>{
    if (!utils.isValid(a) && a != null && !utils.isValid(b) && b != null) return true;
    return utils.isEqual(a, b);
};
const $2c8437f6b047f676$export$62591b96a734eacd = (utils, year)=>{
    const firstMonth = utils.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(utils.addMonths(prevMonth, 1));
    }
    return months;
};
const $2c8437f6b047f676$export$1118e4272ea1e258 = (utils, timezone, valueType)=>valueType === "date" ? utils.startOfDay(utils.date(undefined, timezone)) : utils.date(undefined, timezone);
const $2c8437f6b047f676$export$fae94c0a662107ef = (utils, meridiem)=>{
    const date = utils.setHours(utils.date(), meridiem === "am" ? 2 : 14);
    return utils.format(date, "meridiem");
};
const $2c8437f6b047f676$var$dateViews = [
    "year",
    "month",
    "day"
];
const $2c8437f6b047f676$export$b32dfef9f07dea64 = (view)=>$2c8437f6b047f676$var$dateViews.includes(view);
const $2c8437f6b047f676$export$bb1c921f313ec928 = (utils, { format: format, views: views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $5fcb694dda34c3a0$export$f07872cd524bec98)(views, [
        "year"
    ])) return formats.year;
    if ((0, $5fcb694dda34c3a0$export$f07872cd524bec98)(views, [
        "month"
    ])) return formats.month;
    if ((0, $5fcb694dda34c3a0$export$f07872cd524bec98)(views, [
        "day"
    ])) return formats.dayOfMonth;
    if ((0, $5fcb694dda34c3a0$export$f07872cd524bec98)(views, [
        "month",
        "year"
    ])) return `${formats.month} ${formats.year}`;
    if ((0, $5fcb694dda34c3a0$export$f07872cd524bec98)(views, [
        "day",
        "month"
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(utils.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};
const $2c8437f6b047f676$export$24c38139da66592d = (utils, date)=>{
    const start = utils.startOfWeek(date);
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((diff)=>utils.addDays(start, diff));
};



const $a99658949db23f4e$var$timeViews = [
    "hours",
    "minutes",
    "seconds"
];
const $a99658949db23f4e$export$8f04d380cefd5a0d = (view)=>$a99658949db23f4e$var$timeViews.includes(view);
const $a99658949db23f4e$export$a3328136ac50623d = (view)=>$a99658949db23f4e$var$timeViews.includes(view) || view === "meridiem";
const $a99658949db23f4e$export$c3352ead7b032236 = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? "pm" : "am";
};
const $a99658949db23f4e$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? "pm" : "am";
        if (currentMeridiem !== meridiem) return meridiem === "am" ? value - 12 : value + 12;
    }
    return value;
};
const $a99658949db23f4e$export$c368d4ff66779998 = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = $a99658949db23f4e$export$4159dc823695870e(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
const $a99658949db23f4e$export$888a1ce13aa61986 = (date, utils)=>{
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const $a99658949db23f4e$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return $a99658949db23f4e$export$888a1ce13aa61986(dateLeft, utils) > $a99658949db23f4e$export$888a1ce13aa61986(dateRight, utils);
    };
const $a99658949db23f4e$export$3a6776b3863772fe = (utils, { format: format, views: views, ampm: ampm })=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $5fcb694dda34c3a0$export$f07872cd524bec98)(views, [
        "hours"
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, $5fcb694dda34c3a0$export$f07872cd524bec98)(views, [
        "minutes"
    ])) return formats.minutes;
    if ((0, $5fcb694dda34c3a0$export$f07872cd524bec98)(views, [
        "seconds"
    ])) return formats.seconds;
    if ((0, $5fcb694dda34c3a0$export$f07872cd524bec98)(views, [
        "minutes",
        "seconds"
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, $5fcb694dda34c3a0$export$f07872cd524bec98)(views, [
        "hours",
        "minutes",
        "seconds"
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};



const $101a7d0ae47539cf$export$8f74e8f4ed8ae0ac = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const $101a7d0ae47539cf$export$3f2547ddf892237a = (sections)=>Math.max(...sections.map((section)=>$101a7d0ae47539cf$export$8f74e8f4ed8ae0ac[section.type] ?? 1));
const $101a7d0ae47539cf$var$roundDate = (utils, granularity, date)=>{
    if (granularity === $101a7d0ae47539cf$export$8f74e8f4ed8ae0ac.year) return utils.startOfYear(date);
    if (granularity === $101a7d0ae47539cf$export$8f74e8f4ed8ae0ac.month) return utils.startOfMonth(date);
    if (granularity === $101a7d0ae47539cf$export$8f74e8f4ed8ae0ac.day) return utils.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < $101a7d0ae47539cf$export$8f74e8f4ed8ae0ac.minutes) roundedDate = utils.setMinutes(roundedDate, 0);
    if (granularity < $101a7d0ae47539cf$export$8f74e8f4ed8ae0ac.seconds) roundedDate = utils.setSeconds(roundedDate, 0);
    if (granularity < $101a7d0ae47539cf$export$8f74e8f4ed8ae0ac.milliseconds) roundedDate = utils.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const $101a7d0ae47539cf$export$6a31d56794238e4e = ({ props: props, utils: utils, granularity: granularity, timezone: timezone, getTodayDate: inGetTodayDate })=>{
    let referenceDate = inGetTodayDate ? inGetTodayDate() : $101a7d0ae47539cf$var$roundDate(utils, granularity, (0, $2c8437f6b047f676$export$1118e4272ea1e258)(utils, timezone));
    if (props.minDate != null && utils.isAfterDay(props.minDate, referenceDate)) referenceDate = $101a7d0ae47539cf$var$roundDate(utils, granularity, props.minDate);
    if (props.maxDate != null && utils.isBeforeDay(props.maxDate, referenceDate)) referenceDate = $101a7d0ae47539cf$var$roundDate(utils, granularity, props.maxDate);
    const isAfter = (0, $a99658949db23f4e$export$fb87c80b35a46b89)(props.disableIgnoringDatePartForTimeValidation ?? false, utils);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = $101a7d0ae47539cf$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, $2c8437f6b047f676$export$a98b123b8f29e004)(utils, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = $101a7d0ae47539cf$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, $2c8437f6b047f676$export$a98b123b8f29e004)(utils, referenceDate, props.maxTime));
    return referenceDate;
};



const $4ff936469a729129$export$2f3c5fac7a2a65f6 = (utils, formatToken)=>{
    const config = utils.formatTokenMap[formatToken];
    if (config == null) throw new Error([
        `MUI X: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."
    ].join("\n"));
    if (typeof config === "string") return {
        type: config,
        contentType: config === "meridiem" ? "letter" : "digit",
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
const $4ff936469a729129$var$getDeltaFromKeyCode = (keyCode)=>{
    switch(keyCode){
        case "ArrowUp":
            return 1;
        case "ArrowDown":
            return -1;
        case "PageUp":
            return 5;
        case "PageDown":
            return -5;
        default:
            return 0;
    }
};
const $4ff936469a729129$export$c65c7173f879039f = (utils, format)=>{
    const elements = [];
    const now = utils.date(undefined, "default");
    const startDate = utils.startOfWeek(now);
    const endDate = utils.endOfWeek(now);
    let current = startDate;
    while(utils.isBefore(current, endDate)){
        elements.push(current);
        current = utils.addDays(current, 1);
    }
    return elements.map((weekDay)=>utils.formatByString(weekDay, format));
};
const $4ff936469a729129$export$3ee1e7e19c2b047a = (utils, timezone, sectionType, format)=>{
    switch(sectionType){
        case "month":
            return (0, $2c8437f6b047f676$export$62591b96a734eacd)(utils, utils.date(undefined, timezone)).map((month)=>utils.formatByString(month, format));
        case "weekDay":
            return $4ff936469a729129$export$c65c7173f879039f(utils, format);
        case "meridiem":
            {
                const now = utils.date(undefined, timezone);
                return [
                    utils.startOfDay(now),
                    utils.endOfDay(now)
                ].map((date)=>utils.formatByString(date, format));
            }
        default:
            return [];
    }
};
const $4ff936469a729129$export$b918512475916205 = "s";
const $4ff936469a729129$var$NON_LOCALIZED_DIGITS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
];
const $4ff936469a729129$export$b42be9ae7016ef5d = (utils)=>{
    const today = utils.date(undefined);
    const formattedZero = utils.formatByString(utils.setSeconds(today, 0), $4ff936469a729129$export$b918512475916205);
    if (formattedZero === "0") return $4ff936469a729129$var$NON_LOCALIZED_DIGITS;
    return Array.from({
        length: 10
    }).map((_, index)=>utils.formatByString(utils.setSeconds(today, index), $4ff936469a729129$export$b918512475916205));
};
const $4ff936469a729129$export$7dd321105a319e8 = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === "0") return valueStr;
    const digits = [];
    let currentFormattedDigit = "";
    for(let i = 0; i < valueStr.length; i += 1){
        currentFormattedDigit += valueStr[i];
        const matchingDigitIndex = localizedDigits.indexOf(currentFormattedDigit);
        if (matchingDigitIndex > -1) {
            digits.push(matchingDigitIndex.toString());
            currentFormattedDigit = "";
        }
    }
    return digits.join("");
};
const $4ff936469a729129$export$80dbbc19eba82070 = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === "0") return valueStr;
    return valueStr.split("").map((char)=>localizedDigits[Number(char)]).join("");
};
const $4ff936469a729129$export$c28be6c4c9d8f124 = (valueStr, localizedDigits)=>{
    const nonLocalizedValueStr = $4ff936469a729129$export$7dd321105a319e8(valueStr, localizedDigits);
    // `Number(' ')` returns `0` even if ' ' is not a valid number.
    return nonLocalizedValueStr !== " " && !Number.isNaN(Number(nonLocalizedValueStr));
};
const $4ff936469a729129$export$713c6d756c12fc27 = (valueStr, size)=>{
    let cleanValueStr = valueStr;
    // Remove the leading zeros
    cleanValueStr = Number(cleanValueStr).toString();
    // Add enough leading zeros to fill the section
    while(cleanValueStr.length < size)cleanValueStr = `0${cleanValueStr}`;
    return cleanValueStr;
};
const $4ff936469a729129$export$ef88db4bceade9fd = (utils, value, sectionBoundaries, localizedDigits, section)=>{
    if (section.type === "day" && section.contentType === "digit-with-letter") {
        const date = utils.setDate(sectionBoundaries.longestMonth, value);
        return utils.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    let valueStr = value.toString();
    if (section.hasLeadingZerosInInput) valueStr = $4ff936469a729129$export$713c6d756c12fc27(valueStr, section.maxLength);
    return $4ff936469a729129$export$80dbbc19eba82070(valueStr, localizedDigits);
};
const $4ff936469a729129$export$5ed0f22513e58fe3 = (utils, timezone, section, keyCode, sectionsValueBoundaries, localizedDigits, activeDate, stepsAttributes)=>{
    const delta = $4ff936469a729129$var$getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === "Home";
    const isEnd = keyCode === "End";
    const shouldSetAbsolute = section.value === "" || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>$4ff936469a729129$export$ef88db4bceade9fd(utils, value, sectionBoundaries, localizedDigits, section);
        const step = section.type === "minutes" && stepsAttributes?.minutesStep ? stepsAttributes.minutesStep : 1;
        const currentSectionValue = parseInt($4ff936469a729129$export$7dd321105a319e8(section.value, localizedDigits), 10);
        let newSectionValueNumber = currentSectionValue + delta * step;
        if (shouldSetAbsolute) {
            if (section.type === "year" && !isEnd && !isStart) return utils.formatByString(utils.date(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = $4ff936469a729129$export$3ee1e7e19c2b047a(utils, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + delta) % options.length;
        const clampedIndex = (newOptionIndex + options.length) % options.length;
        return options[clampedIndex];
    };
    if (section.contentType === "digit" || section.contentType === "digit-with-letter") return adjustDigitSection();
    return adjustLetterSection();
};
const $4ff936469a729129$export$85daa91f6c6e875f = (section, target, localizedDigits)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === "non-input" ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === "non-input" && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number($4ff936469a729129$export$7dd321105a319e8(value, localizedDigits)).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        "input-rtl",
        "input-ltr"
    ].includes(target) && section.contentType === "digit" && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === "input-rtl") value = `\u2068${value}\u2069`;
    return value;
};
const $4ff936469a729129$export$2816862a602354ce = (utils, valueStr, currentFormat, newFormat)=>{
    return utils.formatByString(utils.parse(valueStr, currentFormat), newFormat);
};
const $4ff936469a729129$var$isFourDigitYearFormat = (utils, format)=>utils.formatByString(utils.date(undefined, "system"), format).length === 4;
const $4ff936469a729129$export$78b5830e2dd2de49 = (utils, contentType, sectionType, format)=>{
    if (contentType !== "digit") return false;
    const now = utils.date(undefined, "default");
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case "year":
            {
                if ($4ff936469a729129$var$isFourDigitYearFormat(utils, format)) {
                    const formatted0001 = utils.formatByString(utils.setYear(now, 1), format);
                    return formatted0001 === "0001";
                }
                const formatted2001 = utils.formatByString(utils.setYear(now, 2001), format);
                return formatted2001 === "01";
            }
        case "month":
            return utils.formatByString(utils.startOfYear(now), format).length > 1;
        case "day":
            return utils.formatByString(utils.startOfMonth(now), format).length > 1;
        case "weekDay":
            return utils.formatByString(utils.startOfWeek(now), format).length > 1;
        case "hours":
            return utils.formatByString(utils.setHours(now, 1), format).length > 1;
        case "minutes":
            return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
        case "seconds":
            return utils.formatByString(utils.setSeconds(now, 1), format).length > 1;
        default:
            throw new Error("Invalid section type");
    }
};
const $4ff936469a729129$export$b0c1bfd065bfe742 = (utils, sections, localizedDigits)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === "day");
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === "weekDay";
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push($4ff936469a729129$export$85daa91f6c6e875f(section, "non-input", localizedDigits));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(" ");
    const dateWithoutSeparatorStr = sectionValues.join(" ");
    return utils.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const $4ff936469a729129$export$9e6af343db7dd2 = (sections)=>sections.map((section)=>{
        return `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`;
    }).join("");
const $4ff936469a729129$export$7ffdf006c6dc825f = (sections, localizedDigits, isRtl)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = $4ff936469a729129$export$85daa91f6c6e875f(section, isRtl ? "input-rtl" : "input-ltr", localizedDigits);
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join("");
    if (!isRtl) return dateStr;
    // \u2066: start left-to-right isolation
    // \u2067: start right-to-left isolation
    // \u2068: start first strong character isolation
    // \u2069: pop isolation
    // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
    return `\u2066${dateStr}\u2069`;
};
const $4ff936469a729129$export$360600f456ea7d5f = (utils, localizedDigits, timezone)=>{
    const today = utils.date(undefined, timezone);
    const endOfYear = utils.endOfYear(today);
    const endOfDay = utils.endOfDay(today);
    const { maxDaysInMonth: maxDaysInMonth, longestMonth: longestMonth } = (0, $2c8437f6b047f676$export$62591b96a734eacd)(utils, today).reduce((acc, month)=>{
        const daysInMonth = utils.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format: format })=>({
                minimum: 0,
                maximum: $4ff936469a729129$var$isFourDigitYearFormat(utils, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: utils.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate: currentDate })=>({
                minimum: 1,
                maximum: currentDate != null && utils.isValid(currentDate) ? utils.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format: format, contentType: contentType })=>{
            if (contentType === "digit") {
                const daysInWeek = $4ff936469a729129$export$c65c7173f879039f(utils, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format: format })=>{
            const lastHourInDay = utils.getHours(endOfDay);
            const hasMeridiem = $4ff936469a729129$export$7dd321105a319e8(utils.formatByString(utils.endOfDay(today), format), localizedDigits) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number($4ff936469a729129$export$7dd321105a319e8(utils.formatByString(utils.startOfDay(today), format), localizedDigits))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: utils.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: utils.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 1
            }),
        empty: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
let $4ff936469a729129$var$warnedOnceInvalidSection = false;
const $4ff936469a729129$export$ef6fbc09372bd65c = (sections, valueType)=>{};
const $4ff936469a729129$var$transferDateSectionValue = (utils, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case "year":
            return utils.setYear(dateToTransferTo, utils.getYear(dateToTransferFrom));
        case "month":
            return utils.setMonth(dateToTransferTo, utils.getMonth(dateToTransferFrom));
        case "weekDay":
            {
                const formattedDaysInWeek = $4ff936469a729129$export$c65c7173f879039f(utils, section.format);
                const dayInWeekStrOfActiveDate = utils.formatByString(dateToTransferFrom, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return utils.addDays(dateToTransferFrom, diff);
            }
        case "day":
            return utils.setDate(dateToTransferTo, utils.getDate(dateToTransferFrom));
        case "meridiem":
            {
                const isAM = utils.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = utils.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return utils.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return utils.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case "hours":
            return utils.setHours(dateToTransferTo, utils.getHours(dateToTransferFrom));
        case "minutes":
            return utils.setMinutes(dateToTransferTo, utils.getMinutes(dateToTransferFrom));
        case "seconds":
            return utils.setSeconds(dateToTransferTo, utils.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const $4ff936469a729129$var$reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8,
    empty: 9
};
const $4ff936469a729129$export$6c6df982c77f60a9 = (utils, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>$4ff936469a729129$var$reliableSectionModificationOrder[a.type] - $4ff936469a729129$var$reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return $4ff936469a729129$var$transferDateSectionValue(utils, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
const $4ff936469a729129$export$a11b0059900ceec8 = ()=>navigator.userAgent.toLowerCase().includes("android");
const $4ff936469a729129$export$7725fd6fe0a2aadf = (sections, shouldApplyRTL)=>{
    const neighbors = {};
    if (!shouldApplyRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = index === 0 ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex: leftIndex,
                rightIndex: rightIndex
            };
        });
        return {
            neighbors: neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex(// eslint-disable-next-line @typescript-eslint/no-loop-func
        (section, index)=>index >= groupedSectionsStart && section.endSeparator?.includes(" ") && // Special case where the spaces were not there in the initial input
            section.endSeparator !== " / ");
        if (groupedSectionsEnd === -1) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex: leftIndex,
            rightIndex: rightIndex
        };
    });
    return {
        neighbors: neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};
const $4ff936469a729129$export$b31f27a6e35a0b27 = (selectedSections, sections)=>{
    if (selectedSections == null) return null;
    if (selectedSections === "all") return "all";
    if (typeof selectedSections === "string") return sections.findIndex((section)=>section.type === selectedSections);
    return selectedSections;
};
const $4ff936469a729129$export$b5e30842500b6cab = (section, utils)=>{
    if (!section.value) return undefined;
    switch(section.type){
        case "month":
            {
                if (section.contentType === "digit") return utils.format(utils.setMonth(utils.date(), Number(section.value) - 1), "month");
                const parsedDate = utils.parse(section.value, section.format);
                return parsedDate ? utils.format(parsedDate, "month") : undefined;
            }
        case "day":
            return section.contentType === "digit" ? utils.format(utils.setDate(utils.startOfYear(utils.date()), Number(section.value)), "dayOfMonthFull") : section.value;
        case "weekDay":
            // TODO: improve by providing the label of the week day
            return undefined;
        default:
            return undefined;
    }
};
const $4ff936469a729129$export$b46fd324c5adcf31 = (section, utils)=>{
    if (!section.value) return undefined;
    switch(section.type){
        case "weekDay":
            if (section.contentType === "letter") // TODO: improve by resolving the week day number from a letter week day
            return undefined;
            return Number(section.value);
        case "meridiem":
            {
                const parsedDate = utils.parse(`01:00 ${section.value}`, `${utils.formats.hours12h}:${utils.formats.minutes} ${section.format}`);
                if (parsedDate) return utils.getHours(parsedDate) >= 12 ? 1 : 0;
                return undefined;
            }
        case "day":
            return section.contentType === "digit-with-letter" ? parseInt(section.value, 10) : Number(section.value);
        case "month":
            {
                if (section.contentType === "digit") return Number(section.value);
                const parsedDate = utils.parse(section.value, section.format);
                return parsedDate ? utils.getMonth(parsedDate) + 1 : undefined;
            }
        default:
            return section.contentType !== "letter" ? Number(section.value) : undefined;
    }
};


const $59c1a689a11004ea$var$_excluded = [
    "value",
    "referenceDate"
];
const $59c1a689a11004ea$export$2764b246aa3b75ba = {
    emptyValue: null,
    getTodayValue: (0, $2c8437f6b047f676$export$1118e4272ea1e258),
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDate } = _ref, params = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_ref, $59c1a689a11004ea$var$_excluded);
        if (value != null && params.utils.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, $101a7d0ae47539cf$export$6a31d56794238e4e)(params);
    },
    cleanValue: (0, $2c8437f6b047f676$export$36ca889e039badd5),
    areValuesEqual: (0, $2c8437f6b047f676$export$8fabf9a4cbada414),
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (utils, value)=>value == null || !utils.isValid(value) ? null : utils.getTimezone(value),
    setTimezone: (utils, timezone, value)=>value == null ? null : utils.setTimezone(value, timezone)
};
const $59c1a689a11004ea$export$b602c94f557316b4 = {
    updateReferenceValue: (utils, value, prevReferenceValue)=>value == null || !utils.isValid(value) ? prevReferenceValue : value,
    getSectionsFromValue: (utils, date, prevSections, getSectionsFromDate)=>{
        const shouldReUsePrevDateSections = !utils.isValid(date) && !!prevSections;
        if (shouldReUsePrevDateSections) return prevSections;
        return getSectionsFromDate(date);
    },
    getV7HiddenInputValueFromSections: (0, $4ff936469a729129$export$9e6af343db7dd2),
    getV6InputValueFromSections: (0, $4ff936469a729129$export$7ffdf006c6dc825f),
    getActiveDateManager: (utils, state)=>({
            date: state.value,
            referenceDate: state.referenceValue,
            getSections: (sections)=>sections,
            getNewValuesFromNewActiveDate: (newActiveDate)=>({
                    value: newActiveDate,
                    referenceValue: newActiveDate == null || !utils.isValid(newActiveDate) ? state.referenceValue : newActiveDate
                })
        }),
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue)
};





var $1T1QG = parcelRequire("1T1QG");



var $gADeF = parcelRequire("gADeF");

var $1T1QG = parcelRequire("1T1QG");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $e106e0df44e59578$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $e20da214b1d76463$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $1T1QG.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $e106e0df44e59578$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $e603c0fa0a36e0f5$var$isHostComponent(element) {
    return typeof element === "string";
}
var $e603c0fa0a36e0f5$export$2e2bcd8739ae039 = $e603c0fa0a36e0f5$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $5e4c590aa7805b88$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $e603c0fa0a36e0f5$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $5e4c590aa7805b88$export$2e2bcd8739ae039 = $5e4c590aa7805b88$var$appendOwnerState;


function $4bc2aca8a1a0a2c8$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $4bc2aca8a1a0a2c8$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $4bc2aca8a1a0a2c8$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $4bc2aca8a1a0a2c8$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039 = $4bc2aca8a1a0a2c8$export$4f5d2d50c9deca37;


/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $27cd9bb4dabd1a66$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $27cd9bb4dabd1a66$export$2e2bcd8739ae039 = $27cd9bb4dabd1a66$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $a7d7750c99974e1c$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $a7d7750c99974e1c$export$2e2bcd8739ae039 = $a7d7750c99974e1c$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $2262bd0c37d03062$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $27cd9bb4dabd1a66$export$2e2bcd8739ae039)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $a7d7750c99974e1c$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $a7d7750c99974e1c$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $2262bd0c37d03062$export$2e2bcd8739ae039 = $2262bd0c37d03062$var$mergeSlotProps;



"use client";
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $ae26363b02eac268$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $381cff6a989e76ba$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $2262bd0c37d03062$export$2e2bcd8739ae039)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $5e4c590aa7805b88$export$2e2bcd8739ae039)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $ae26363b02eac268$export$2e2bcd8739ae039 = $ae26363b02eac268$var$useSlotProps;






var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $1c8a785890e03d41$var$useEnhancedEffect = typeof window !== "undefined" ? $1T1QG.useLayoutEffect : $1T1QG.useEffect;
var $1c8a785890e03d41$export$2e2bcd8739ae039 = $1c8a785890e03d41$var$useEnhancedEffect;



var $1T1QG = parcelRequire("1T1QG");

"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $b7b0b023b5749940$var$useEventCallback(fn) {
    const ref = $1T1QG.useRef(fn);
    (0, $1c8a785890e03d41$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $1T1QG.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $b7b0b023b5749940$export$2e2bcd8739ae039 = $b7b0b023b5749940$var$useEventCallback;



var $1T1QG = parcelRequire("1T1QG");


var $3Py8h = parcelRequire("3Py8h");
const $a69327a401bfde77$var$RtlContext = /*#__PURE__*/ $1T1QG.createContext();
function $a69327a401bfde77$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $3Py8h.jsx)($a69327a401bfde77$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $a69327a401bfde77$export$b2dd014b6c321cb = ()=>{
    const value = $1T1QG.useContext($a69327a401bfde77$var$RtlContext);
    return value ?? false;
};
var $a69327a401bfde77$export$2e2bcd8739ae039 = $a69327a401bfde77$var$RtlProvider;



var $1T1QG = parcelRequire("1T1QG");



var $1T1QG = parcelRequire("1T1QG");



var $1T1QG = parcelRequire("1T1QG");


var $gADeF = parcelRequire("gADeF");

var $3Py8h = parcelRequire("3Py8h");
"use client";
const $0c1c7d3e9094bc71$var$_excluded = [
    "localeText"
];
const $0c1c7d3e9094bc71$export$544976378534cf9 = /*#__PURE__*/ $1T1QG.createContext(null);
const $0c1c7d3e9094bc71$export$dc45bdc734ce6f1e = function LocalizationProvider(inProps) {
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(inProps, $0c1c7d3e9094bc71$var$_excluded);
    const { utils: parentUtils, localeText: parentLocaleText } = $1T1QG.useContext($0c1c7d3e9094bc71$export$544976378534cf9) ?? {
        utils: undefined,
        localeText: undefined
    };
    const props = (0, $gADeF.default)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: "MuiLocalizationProvider"
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $1T1QG.useMemo(()=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const utils = $1T1QG.useMemo(()=>{
        if (!DateAdapter) {
            if (parentUtils) return parentUtils;
            return null;
        }
        const adapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!adapter.isMUIAdapter) throw new Error([
            "MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`",
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"
        ].join(`\n`));
        return adapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentUtils
    ]);
    const defaultDates = $1T1QG.useMemo(()=>{
        if (!utils) return null;
        return {
            minDate: utils.date("1900-01-01T00:00:00.000"),
            maxDate: utils.date("2099-12-31T00:00:00.000")
        };
    }, [
        utils
    ]);
    const contextValue = $1T1QG.useMemo(()=>{
        return {
            utils: utils,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($0c1c7d3e9094bc71$export$544976378534cf9.Provider, {
        value: contextValue,
        children: children
    });
};



const $3f33724e76f40ee3$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, pickersTranslations)
                }
            }
        }
    };
};
const $3f33724e76f40ee3$export$7eae96bf9dd7ca56 = (params)=>{
    const { utils: utils, formatKey: formatKey, contextTranslation: contextTranslation, propsTranslation: propsTranslation } = params;
    return (value)=>{
        const formattedValue = value !== null && utils.isValid(value) ? utils.format(value, formatKey) : null;
        const translation = propsTranslation ?? contextTranslation;
        return translation(value, utils, formattedValue);
    };
};


// This object is not Partial<PickersLocaleText> because it is the default values
const $8d434a30d2f2b638$var$enUSPickers = {
    // Calendar navigation
    previousMonth: "Previous month",
    nextMonth: "Next month",
    // View navigation
    openPreviousView: "Open previous view",
    openNextView: "Open next view",
    calendarViewSwitchingButtonAriaLabel: (view)=>view === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
    // DateRange labels
    start: "Start",
    end: "End",
    startDate: "Start date",
    startTime: "Start time",
    endDate: "End date",
    endTime: "End time",
    // Action bar
    cancelButtonLabel: "Cancel",
    clearButtonLabel: "Clear",
    okButtonLabel: "OK",
    todayButtonLabel: "Today",
    // Toolbar titles
    datePickerToolbarTitle: "Select date",
    dateTimePickerToolbarTitle: "Select date & time",
    timePickerToolbarTitle: "Select time",
    dateRangePickerToolbarTitle: "Select date range",
    // Clock labels
    clockLabelText: (view, time, utils, formattedTime)=>`Select ${view}. ${!formattedTime && (time === null || !utils.isValid(time)) ? "No time selected" : `Selected time is ${formattedTime ?? utils.format(time, "fullTime")}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: "Week number",
    calendarWeekNumberHeaderText: "#",
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open picker labels
    openDatePickerDialogue: (value, utils, formattedDate)=>formattedDate || value !== null && utils.isValid(value) ? `Choose date, selected date is ${formattedDate ?? utils.format(value, "fullDate")}` : "Choose date",
    openTimePickerDialogue: (value, utils, formattedTime)=>formattedTime || value !== null && utils.isValid(value) ? `Choose time, selected time is ${formattedTime ?? utils.format(value, "fullTime")}` : "Choose time",
    fieldClearLabel: "Clear",
    // Table labels
    timeTableLabel: "pick time",
    dateTableLabel: "pick date",
    // Field section placeholders
    fieldYearPlaceholder: (params)=>"Y".repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === "letter" ? "MMMM" : "MM",
    fieldDayPlaceholder: ()=>"DD",
    fieldWeekDayPlaceholder: (params)=>params.contentType === "letter" ? "EEEE" : "EE",
    fieldHoursPlaceholder: ()=>"hh",
    fieldMinutesPlaceholder: ()=>"mm",
    fieldSecondsPlaceholder: ()=>"ss",
    fieldMeridiemPlaceholder: ()=>"aa",
    // View names
    year: "Year",
    month: "Month",
    day: "Day",
    weekDay: "Week day",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
    meridiem: "Meridiem",
    // Common
    empty: "Empty"
};
const $8d434a30d2f2b638$export$1af4c7e47ad72f44 = $8d434a30d2f2b638$var$enUSPickers;
const $8d434a30d2f2b638$export$137380d9ce54f7f = (0, $3f33724e76f40ee3$export$67c96d35a1b010b3)($8d434a30d2f2b638$var$enUSPickers);


const $f3e8032daddc32c6$export$4b5a24245de9f7f9 = ()=>{
    const localization = $1T1QG.useContext((0, $0c1c7d3e9094bc71$export$544976378534cf9));
    if (localization === null) throw new Error([
        "MUI X: Can not find the date and time pickers localization context.",
        "It looks like you forgot to wrap your component in LocalizationProvider.",
        "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"
    ].join("\n"));
    if (localization.utils === null) throw new Error([
        "MUI X: Can not find the date and time pickers adapter from its localization context.",
        "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."
    ].join("\n"));
    const localeText = $1T1QG.useMemo(()=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, (0, $8d434a30d2f2b638$export$1af4c7e47ad72f44), localization.localeText), [
        localization.localeText
    ]);
    return $1T1QG.useMemo(()=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, localization, {
            localeText: localeText
        }), [
        localization,
        localeText
    ]);
};
const $f3e8032daddc32c6$export$1163b47e39508a46 = ()=>$f3e8032daddc32c6$export$4b5a24245de9f7f9().utils;
const $f3e8032daddc32c6$export$7c38da3a2e90fa83 = ()=>$f3e8032daddc32c6$export$4b5a24245de9f7f9().defaultDates;
const $f3e8032daddc32c6$export$3a404aece3dff2fa = (timezone)=>{
    const utils = $f3e8032daddc32c6$export$1163b47e39508a46();
    const now = $1T1QG.useRef();
    if (now.current === undefined) now.current = utils.date(undefined, timezone);
    return now.current;
};


"use client";
function $7480e2bc04de1c42$export$87fe492f99f25a20(options) {
    const { props: props, validator: validator, value: value, timezone: timezone, onError: onError } = options;
    const adapter = (0, $f3e8032daddc32c6$export$4b5a24245de9f7f9)();
    const previousValidationErrorRef = $1T1QG.useRef(validator.valueManager.defaultErrorState);
    const validationError = validator({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
    const hasValidationError = validator.valueManager.hasError(validationError);
    $1T1QG.useEffect(()=>{
        if (onError && !validator.valueManager.isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        validator,
        onError,
        validationError,
        value
    ]);
    const getValidationErrorForNewValue = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newValue)=>{
        return validator({
            adapter: adapter,
            value: newValue,
            timezone: timezone,
            props: props
        });
    });
    return {
        validationError: validationError,
        hasValidationError: hasValidationError,
        getValidationErrorForNewValue: getValidationErrorForNewValue
    };
}






var $1T1QG = parcelRequire("1T1QG");

var $1T1QG = parcelRequire("1T1QG");
"use client";
function $9790f3f3f5426a25$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $1T1QG.useRef(controlled !== undefined);
    const [valueState, setValue] = $1T1QG.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $1T1QG.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}




"use client";
const $23b03662f60cdb73$export$3cdcc56057891b44 = ()=>(0, $f3e8032daddc32c6$export$4b5a24245de9f7f9)().localeText;






const $25d8a1c70e504122$var$expandFormat = ({ utils: utils, format: format })=>{
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = utils.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = utils.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error("MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the picker component.");
    }
    return nextFormat;
};
const $25d8a1c70e504122$var$getEscapedPartsFromFormat = ({ utils: utils, expandedFormat: expandedFormat })=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = utils.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, "g");
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(expandedFormat))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const $25d8a1c70e504122$var$getSectionPlaceholder = (utils, localeText, sectionConfig, sectionFormat)=>{
    switch(sectionConfig.type){
        case "year":
            return localeText.fieldYearPlaceholder({
                digitAmount: utils.formatByString(utils.date(undefined, "default"), sectionFormat).length,
                format: sectionFormat
            });
        case "month":
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case "day":
            return localeText.fieldDayPlaceholder({
                format: sectionFormat
            });
        case "weekDay":
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case "hours":
            return localeText.fieldHoursPlaceholder({
                format: sectionFormat
            });
        case "minutes":
            return localeText.fieldMinutesPlaceholder({
                format: sectionFormat
            });
        case "seconds":
            return localeText.fieldSecondsPlaceholder({
                format: sectionFormat
            });
        case "meridiem":
            return localeText.fieldMeridiemPlaceholder({
                format: sectionFormat
            });
        default:
            return sectionFormat;
    }
};
const $25d8a1c70e504122$var$createSection = ({ utils: utils, date: date, shouldRespectLeadingZeros: shouldRespectLeadingZeros, localeText: localeText, localizedDigits: localizedDigits, now: now, token: token, startSeparator: startSeparator })=>{
    if (token === "") throw new Error("MUI X: Should not call `commitToken` with an empty token");
    const sectionConfig = (0, $4ff936469a729129$export$2f3c5fac7a2a65f6)(utils, token);
    const hasLeadingZerosInFormat = (0, $4ff936469a729129$export$78b5830e2dd2de49)(utils, sectionConfig.contentType, sectionConfig.type, token);
    const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === "digit";
    const isValidDate = date != null && utils.isValid(date);
    let sectionValue = isValidDate ? utils.formatByString(date, token) : "";
    let maxLength = null;
    if (hasLeadingZerosInInput) {
        if (hasLeadingZerosInFormat) maxLength = sectionValue === "" ? utils.formatByString(now, token).length : sectionValue.length;
        else {
            if (sectionConfig.maxLength == null) throw new Error(`MUI X: The token ${token} should have a 'maxDigitNumber' property on it's adapter`);
            maxLength = sectionConfig.maxLength;
            if (isValidDate) sectionValue = (0, $4ff936469a729129$export$80dbbc19eba82070)((0, $4ff936469a729129$export$713c6d756c12fc27)((0, $4ff936469a729129$export$7dd321105a319e8)(sectionValue, localizedDigits), maxLength), localizedDigits);
        }
    }
    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, sectionConfig, {
        format: token,
        maxLength: maxLength,
        value: sectionValue,
        placeholder: $25d8a1c70e504122$var$getSectionPlaceholder(utils, localeText, sectionConfig, token),
        hasLeadingZerosInFormat: hasLeadingZerosInFormat,
        hasLeadingZerosInInput: hasLeadingZerosInInput,
        startSeparator: startSeparator,
        endSeparator: "",
        modified: false
    });
};
const $25d8a1c70e504122$var$buildSections = (params)=>{
    const { utils: utils, expandedFormat: expandedFormat, escapedParts: escapedParts } = params;
    const now = utils.date(undefined);
    const sections = [];
    let startSeparator = "";
    // This RegExp tests if the beginning of a string corresponds to a supported token
    const validTokens = Object.keys(utils.formatTokenMap).sort((a, b)=>b.length - a.length); // Sort to put longest word first
    const regExpFirstWordInFormat = /^([a-zA-Z]+)/;
    const regExpWordOnlyComposedOfTokens = new RegExp(`^(${validTokens.join("|")})*$`);
    const regExpFirstTokenInWord = new RegExp(`^(${validTokens.join("|")})`);
    const getEscapedPartOfCurrentChar = (i)=>escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
    let i = 0;
    while(i < expandedFormat.length){
        const escapedPartOfCurrentChar = getEscapedPartOfCurrentChar(i);
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const firstWordInFormat = regExpFirstWordInFormat.exec(expandedFormat.slice(i))?.[1];
        // The first word in the format is only composed of tokens.
        // We extract those tokens to create a new sections.
        if (!isEscapedChar && firstWordInFormat != null && regExpWordOnlyComposedOfTokens.test(firstWordInFormat)) {
            let word = firstWordInFormat;
            while(word.length > 0){
                const firstWord = regExpFirstTokenInWord.exec(word)[1];
                word = word.slice(firstWord.length);
                sections.push($25d8a1c70e504122$var$createSection((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, params, {
                    now: now,
                    token: firstWord,
                    startSeparator: startSeparator
                })));
                startSeparator = "";
            }
            i += firstWordInFormat.length;
        } else {
            const char = expandedFormat[i];
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && escapedPartOfCurrentChar?.start === i || escapedPartOfCurrentChar?.end === i;
            if (!isEscapeBoundary) {
                if (sections.length === 0) startSeparator += char;
                else sections[sections.length - 1].endSeparator += char;
            }
            i += 1;
        }
    }
    if (sections.length === 0 && startSeparator.length > 0) sections.push({
        type: "empty",
        contentType: "letter",
        maxLength: null,
        format: "",
        value: "",
        placeholder: "",
        hasLeadingZerosInFormat: false,
        hasLeadingZerosInInput: false,
        startSeparator: startSeparator,
        endSeparator: "",
        modified: false
    });
    return sections;
};
const $25d8a1c70e504122$var$postProcessSections = ({ isRtl: isRtl, formatDensity: formatDensity, sections: sections })=>{
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRtl && cleanedSeparator !== null && cleanedSeparator.includes(" ")) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === "spacious" && [
                "/",
                ".",
                "-"
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const $25d8a1c70e504122$export$34084be60bfe3b3b = (params)=>{
    let expandedFormat = $25d8a1c70e504122$var$expandFormat(params);
    if (params.isRtl && params.enableAccessibleFieldDOMStructure) expandedFormat = expandedFormat.split(" ").reverse().join(" ");
    const escapedParts = $25d8a1c70e504122$var$getEscapedPartsFromFormat((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, params, {
        expandedFormat: expandedFormat
    }));
    const sections = $25d8a1c70e504122$var$buildSections((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, params, {
        expandedFormat: expandedFormat,
        escapedParts: escapedParts
    }));
    return $25d8a1c70e504122$var$postProcessSections((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, params, {
        sections: sections
    }));
};



var $1T1QG = parcelRequire("1T1QG");



const $1370ae3083e8f472$export$c7e050e908c1b2bc = ({ timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChange, valueManager: valueManager })=>{
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const firstDefaultValue = $1T1QG.useRef(defaultValue);
    const inputValue = valueProp ?? firstDefaultValue.current ?? valueManager.emptyValue;
    const inputTimezone = $1T1QG.useMemo(()=>valueManager.getTimezone(utils, inputValue), [
        utils,
        valueManager,
        inputValue
    ]);
    const setInputTimezone = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(utils, inputTimezone, newValue);
    });
    const timezoneToRender = timezoneProp ?? inputTimezone ?? "default";
    const valueWithTimezoneToRender = $1T1QG.useMemo(()=>valueManager.setTimezone(utils, timezoneToRender, inputValue), [
        valueManager,
        utils,
        timezoneToRender,
        inputValue
    ]);
    const handleValueChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        onChange?.(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange: handleValueChange,
        timezone: timezoneToRender
    };
};
const $1370ae3083e8f472$export$174d749f3b4c0f49 = ({ name: name, timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChangeProp, valueManager: valueManager })=>{
    const [valueWithInputTimezone, setValue] = (0, $9790f3f3f5426a25$export$2e2bcd8739ae039)({
        name: name,
        state: "value",
        controlled: valueProp,
        default: defaultValue ?? valueManager.emptyValue
    });
    const onChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        setValue(newValue);
        onChangeProp?.(newValue, ...otherParams);
    });
    return $1370ae3083e8f472$export$c7e050e908c1b2bc({
        timezone: timezoneProp,
        value: valueWithInputTimezone,
        defaultValue: undefined,
        onChange: onChange,
        valueManager: valueManager
    });
};



const $5b6ed2b81b707d19$export$4e8d6353e50062e7 = (params)=>{
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const translations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    const adapter = (0, $f3e8032daddc32c6$export$4b5a24245de9f7f9)();
    const isRtl = (0, $a69327a401bfde77$export$b2dd014b6c321cb)();
    const { valueManager: valueManager, fieldValueManager: fieldValueManager, valueType: valueType, validator: validator, internalProps: internalProps, internalProps: { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, onChange: onChange, format: format, formatDensity: formatDensity = "dense", selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, shouldRespectLeadingZeros: shouldRespectLeadingZeros = false, timezone: timezoneProp, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = false } } = params;
    const { timezone: timezone, value: valueFromTheOutside, handleValueChange: handleValueChange } = (0, $1370ae3083e8f472$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    const localizedDigits = $1T1QG.useMemo(()=>(0, $4ff936469a729129$export$b42be9ae7016ef5d)(utils), [
        utils
    ]);
    const sectionsValueBoundaries = $1T1QG.useMemo(()=>(0, $4ff936469a729129$export$360600f456ea7d5f)(utils, localizedDigits, timezone), [
        utils,
        localizedDigits,
        timezone
    ]);
    const getSectionsFromValue = $1T1QG.useCallback((value, fallbackSections = null)=>fieldValueManager.getSectionsFromValue(utils, value, fallbackSections, (date)=>(0, $25d8a1c70e504122$export$34084be60bfe3b3b)({
                utils: utils,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRtl: isRtl
            })), [
        fieldValueManager,
        format,
        translations,
        localizedDigits,
        isRtl,
        shouldRespectLeadingZeros,
        utils,
        formatDensity,
        enableAccessibleFieldDOMStructure
    ]);
    const [state, setState] = $1T1QG.useState(()=>{
        const sections = getSectionsFromValue(valueFromTheOutside);
        (0, $4ff936469a729129$export$ef6fbc09372bd65c)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections: sections,
            value: valueFromTheOutside,
            referenceValue: valueManager.emptyValue,
            tempValueStrAndroid: null
        };
        const granularity = (0, $101a7d0ae47539cf$export$3f2547ddf892237a)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value: valueFromTheOutside,
            utils: utils,
            props: internalProps,
            granularity: granularity,
            timezone: timezone
        });
        return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, stateWithoutReferenceDate, {
            referenceValue: referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, $9790f3f3f5426a25$export$2e2bcd8739ae039)({
        controlled: selectedSectionsProp,
        default: null,
        name: "useField",
        state: "selectedSections"
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange?.(newSelectedSections);
    };
    const parsedSelectedSections = $1T1QG.useMemo(()=>(0, $4ff936469a729129$export$b31f27a6e35a0b27)(selectedSections, state.sections), [
        selectedSections,
        state.sections
    ]);
    const activeSectionIndex = parsedSelectedSections === "all" ? 0 : parsedSelectedSections;
    const publishValue = ({ value: value, referenceValue: referenceValue, sections: sections })=>{
        setState((prevState)=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, prevState, {
                sections: sections,
                value: value,
                referenceValue: referenceValue,
                tempValueStrAndroid: null
            }));
        if (valueManager.areValuesEqual(utils, state.value, value)) return;
        const context = {
            validationError: validator({
                adapter: adapter,
                value: value,
                timezone: timezone,
                props: internalProps
            })
        };
        handleValueChange(value, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return newSections;
    };
    const clearValue = ()=>{
        publishValue({
            value: valueManager.emptyValue,
            referenceValue: state.referenceValue,
            sections: getSectionsFromValue(valueManager.emptyValue)
        });
    };
    const clearActiveSection = ()=>{
        if (activeSectionIndex == null) return;
        const activeSection = state.sections[activeSectionIndex];
        const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const nonEmptySectionCountBefore = activeDateManager.getSections(state.sections).filter((section)=>section.value !== "").length;
        const hasNoOtherNonEmptySections = nonEmptySectionCountBefore === (activeSection.value === "" ? 0 : 1);
        const newSections = setSectionValue(activeSectionIndex, "");
        const newActiveDate = hasNoOtherNonEmptySections ? null : utils.getInvalidDate();
        const newValues = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
        publishValue((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, newValues, {
            sections: newSections
        }));
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = utils.parse(dateStr, format);
            if (date == null || !utils.isValid(date)) return null;
            const sections = (0, $25d8a1c70e504122$export$34084be60bfe3b3b)({
                utils: utils,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRtl: isRtl
            });
            return (0, $4ff936469a729129$export$6c6df982c77f60a9)(utils, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        const newReferenceValue = fieldValueManager.updateReferenceValue(utils, newValue, state.referenceValue);
        publishValue({
            value: newValue,
            referenceValue: newReferenceValue,
            sections: getSectionsFromValue(newValue, state.sections)
        });
    };
    const updateSectionValue = ({ activeSection: activeSection, newSectionValue: newSectionValue, shouldGoToNextSection: shouldGoToNextSection })=>{
        /**
     * 1. Decide which section should be focused
     */ if (shouldGoToNextSection && activeSectionIndex < state.sections.length - 1) setSelectedSections(activeSectionIndex + 1);
        /**
     * 2. Try to build a valid date from the new section value
     */ const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const newSections = setSectionValue(activeSectionIndex, newSectionValue);
        const newActiveDateSections = activeDateManager.getSections(newSections);
        const newActiveDate = (0, $4ff936469a729129$export$b0c1bfd065bfe742)(utils, newActiveDateSections, localizedDigits);
        let values;
        let shouldPublish;
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (newActiveDate != null && utils.isValid(newActiveDate)) {
            const mergedDate = (0, $4ff936469a729129$export$6c6df982c77f60a9)(utils, newActiveDate, newActiveDateSections, activeDateManager.referenceDate, true);
            values = activeDateManager.getNewValuesFromNewActiveDate(mergedDate);
            shouldPublish = true;
        } else {
            values = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
            shouldPublish = (newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date));
        }
        /**
     * Publish or update the internal state with the new value and sections.
     */ if (shouldPublish) return publishValue((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, values, {
            sections: newSections
        }));
        return setState((prevState)=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, prevState, values, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prev)=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, prev, {
                tempValueStrAndroid: tempValueStrAndroid
            }));
    $1T1QG.useEffect(()=>{
        const sections = getSectionsFromValue(state.value);
        (0, $4ff936469a729129$export$ef6fbc09372bd65c)(sections, valueType);
        setState((prevState)=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, prevState, {
                sections: sections
            }));
    }, [
        format,
        utils.locale,
        isRtl
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $1T1QG.useEffect(()=>{
        let shouldUpdate;
        if (!valueManager.areValuesEqual(utils, state.value, valueFromTheOutside)) shouldUpdate = true;
        else shouldUpdate = valueManager.getTimezone(utils, state.value) !== valueManager.getTimezone(utils, valueFromTheOutside);
        if (shouldUpdate) setState((prevState)=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, prevState, {
                value: valueFromTheOutside,
                referenceValue: fieldValueManager.updateReferenceValue(utils, valueFromTheOutside, prevState.referenceValue),
                sections: getSectionsFromValue(valueFromTheOutside)
            }));
    }, [
        valueFromTheOutside
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        state: state,
        activeSectionIndex: activeSectionIndex,
        parsedSelectedSections: parsedSelectedSections,
        setSelectedSections: setSelectedSections,
        clearValue: clearValue,
        clearActiveSection: clearActiveSection,
        updateSectionValue: updateSectionValue,
        updateValueFromValueStr: updateValueFromValueStr,
        setTempAndroidValueStr: setTempAndroidValueStr,
        getSectionsFromValue: getSectionsFromValue,
        sectionsValueBoundaries: sectionsValueBoundaries,
        localizedDigits: localizedDigits,
        timezone: timezone
    };
};




var $1T1QG = parcelRequire("1T1QG");



/**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */ /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ const $8d095b25375d2f3c$var$QUERY_LIFE_DURATION_MS = 5000;
const $8d095b25375d2f3c$var$isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
const $8d095b25375d2f3c$export$66d00048b8bb82f6 = ({ sections: sections, updateSectionValue: updateSectionValue, sectionsValueBoundaries: sectionsValueBoundaries, localizedDigits: localizedDigits, setTempAndroidValueStr: setTempAndroidValueStr, timezone: timezone })=>{
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const [query, setQuery] = $1T1QG.useState(null);
    const resetQuery = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)(()=>setQuery(null));
    $1T1QG.useEffect(()=>{
        if (query != null && sections[query.sectionIndex]?.type !== query.sectionType) resetQuery();
    }, [
        sections,
        query,
        resetQuery
    ]);
    $1T1QG.useEffect(()=>{
        if (query != null) {
            const timeout = setTimeout(()=>resetQuery(), $8d095b25375d2f3c$var$QUERY_LIFE_DURATION_MS);
            return ()=>{
                clearTimeout(timeout);
            };
        }
        return ()=>{};
    }, [
        query,
        resetQuery
    ]);
    const applyQuery = ({ keyPressed: keyPressed, sectionIndex: sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenate the value
        if (query != null && (!isValidQueryValue || isValidQueryValue(query.value)) && query.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${query.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!$8d095b25375d2f3c$var$isQueryResponseWithoutValue(queryResponse)) {
                setQuery({
                    sectionIndex: sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if ($8d095b25375d2f3c$var$isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            resetQuery();
            return null;
        }
        setQuery({
            sectionIndex: sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if ($8d095b25375d2f3c$var$isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, $4ff936469a729129$export$3ee1e7e19c2b047a)(utils, timezone, activeSection.type, format);
            if (activeSection.contentType === "letter") return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, $4ff936469a729129$export$2f3c5fac7a2a65f6)(utils, fallbackFormat).contentType === "letter") {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if ($8d095b25375d2f3c$var$isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case "month":
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, $4ff936469a729129$export$2816862a602354ce)(utils, fallbackValue, utils.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.month, formatFallbackValue);
                    }
                case "weekDay":
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.weekday, formatFallbackValue);
                    }
                case "meridiem":
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = (queryValue, section)=>{
            const cleanQueryValue = (0, $4ff936469a729129$export$7dd321105a319e8)(queryValue, localizedDigits);
            const queryValueNumber = Number(cleanQueryValue);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = queryValueNumber * 10 > sectionBoundaries.maximum || cleanQueryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, $4ff936469a729129$export$ef88db4bceade9fd)(utils, queryValueNumber, sectionBoundaries, localizedDigits, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection: shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === "digit" || activeSection.contentType === "digit-with-letter") return getNewSectionValue(queryValue, activeSection);
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === "month") {
                const hasLeadingZerosInFormat = (0, $4ff936469a729129$export$78b5830e2dd2de49)(utils, "digit", "month", "MM");
                const response = getNewSectionValue(queryValue, {
                    type: activeSection.type,
                    format: "MM",
                    hasLeadingZerosInFormat: hasLeadingZerosInFormat,
                    hasLeadingZerosInInput: true,
                    contentType: "digit",
                    maxLength: 2
                });
                if ($8d095b25375d2f3c$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $4ff936469a729129$export$2816862a602354ce)(utils, response.sectionValue, "MM", activeSection.format);
                return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === "weekDay") {
                const response = getNewSectionValue(queryValue, activeSection);
                if ($8d095b25375d2f3c$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $4ff936469a729129$export$c65c7173f879039f)(utils, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>(0, $4ff936469a729129$export$c28be6c4c9d8f124)(queryValue, localizedDigits));
    };
    const applyCharacterEditing = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((params)=>{
        const activeSection = sections[params.sectionIndex];
        const isNumericEditing = (0, $4ff936469a729129$export$c28be6c4c9d8f124)(params.keyPressed, localizedDigits);
        const response = isNumericEditing ? applyNumericEditing((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, params, {
            keyPressed: (0, $4ff936469a729129$export$80dbbc19eba82070)(params.keyPressed, localizedDigits)
        })) : applyLetterEditing(params);
        if (response == null) {
            setTempAndroidValueStr(null);
            return;
        }
        updateSectionValue({
            activeSection: activeSection,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
    return {
        applyCharacterEditing: applyCharacterEditing,
        resetCharacterQuery: resetQuery
    };
};



var $1T1QG = parcelRequire("1T1QG");




var $1T1QG = parcelRequire("1T1QG");
"use client";
let $ea1f3283f0dc1f21$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $ea1f3283f0dc1f21$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $1T1QG.useState(idOverride);
    const id = idOverride || defaultId;
    $1T1QG.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $ea1f3283f0dc1f21$var$globalId += 1;
            setDefaultId(`mui-${$ea1f3283f0dc1f21$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $ea1f3283f0dc1f21$var$safeReact = {
    ...$1T1QG
};
const $ea1f3283f0dc1f21$var$maybeReactUseId = $ea1f3283f0dc1f21$var$safeReact.useId;
function $ea1f3283f0dc1f21$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($ea1f3283f0dc1f21$var$maybeReactUseId !== undefined) {
        const reactId = $ea1f3283f0dc1f21$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $ea1f3283f0dc1f21$var$useGlobalId(idOverride);
}



/* Use it instead of .includes method for IE support */ function $68e3e92a73d67afe$export$22012a5c726bef55(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $68e3e92a73d67afe$export$4467fe8634707c85 = (innerFn, externalEvent)=>(event)=>{
        if (event.key === "Enter" || event.key === " ") {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
const $68e3e92a73d67afe$export$2e03bc8dde24716b = (fn)=>{
    setTimeout(fn, 0);
};
const $68e3e92a73d67afe$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $68e3e92a73d67afe$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
const $68e3e92a73d67afe$export$4165ccf43f4d7767 = (listElement)=>{
    const children = Array.from(listElement.children);
    return children.indexOf($68e3e92a73d67afe$export$cd4e5573fbe2b576(document));
};
const $68e3e92a73d67afe$export$9ae5b19305db48ce = "@media (pointer: fine)";




const $be189ebc8f09b944$export$3b5f62b9baf9717e = (params)=>{
    const { internalProps: { disabled: disabled, readOnly: readOnly = false }, forwardedProps: { sectionListRef: inSectionListRef, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onInput: onInput, onPaste: onPaste, focused: focusedProp, autoFocus: autoFocus = false }, fieldValueManager: fieldValueManager, applyCharacterEditing: applyCharacterEditing, resetCharacterQuery: resetCharacterQuery, setSelectedSections: setSelectedSections, parsedSelectedSections: parsedSelectedSections, state: state, clearActiveSection: clearActiveSection, clearValue: clearValue, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, sectionOrder: sectionOrder, areAllSectionsEmpty: areAllSectionsEmpty, sectionsValueBoundaries: sectionsValueBoundaries } = params;
    const sectionListRef = $1T1QG.useRef(null);
    const handleSectionListRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(inSectionListRef, sectionListRef);
    const translations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const id = (0, $ea1f3283f0dc1f21$export$2e2bcd8739ae039)();
    const [focused, setFocused] = $1T1QG.useState(false);
    const interactions = $1T1QG.useMemo(()=>({
            syncSelectionToDOM: ()=>{
                if (!sectionListRef.current) return;
                const selection = document.getSelection();
                if (!selection) return;
                if (parsedSelectedSections == null) {
                    // If the selection contains an element inside the field, we reset it.
                    if (selection.rangeCount > 0 && sectionListRef.current.getRoot().contains(selection.getRangeAt(0).startContainer)) selection.removeAllRanges();
                    if (focused) sectionListRef.current.getRoot().blur();
                    return;
                }
                // On multi input range pickers we want to update selection range only for the active input
                if (!sectionListRef.current.getRoot().contains((0, $68e3e92a73d67afe$export$cd4e5573fbe2b576)(document))) return;
                const range = new window.Range();
                let target;
                if (parsedSelectedSections === "all") target = sectionListRef.current.getRoot();
                else {
                    const section = state.sections[parsedSelectedSections];
                    if (section.type === "empty") target = sectionListRef.current.getSectionContainer(parsedSelectedSections);
                    else target = sectionListRef.current.getSectionContent(parsedSelectedSections);
                }
                range.selectNodeContents(target);
                target.focus();
                selection.removeAllRanges();
                selection.addRange(range);
            },
            getActiveSectionIndexFromDOM: ()=>{
                const activeElement = (0, $68e3e92a73d67afe$export$cd4e5573fbe2b576)(document);
                if (!activeElement || !sectionListRef.current || !sectionListRef.current.getRoot().contains(activeElement)) return null;
                return sectionListRef.current.getSectionIndexFromDOMElement(activeElement);
            },
            focusField: (newSelectedSections = 0)=>{
                if (!sectionListRef.current) return;
                const newParsedSelectedSections = (0, $4ff936469a729129$export$b31f27a6e35a0b27)(newSelectedSections, state.sections);
                setFocused(true);
                sectionListRef.current.getSectionContent(newParsedSelectedSections).focus();
            },
            setSelectedSections: (newSelectedSections)=>{
                if (!sectionListRef.current) return;
                const newParsedSelectedSections = (0, $4ff936469a729129$export$b31f27a6e35a0b27)(newSelectedSections, state.sections);
                const newActiveSectionIndex = newParsedSelectedSections === "all" ? 0 : newParsedSelectedSections;
                setFocused(newActiveSectionIndex !== null);
                setSelectedSections(newSelectedSections);
            },
            isFieldFocused: ()=>{
                const activeElement = (0, $68e3e92a73d67afe$export$cd4e5573fbe2b576)(document);
                return !!sectionListRef.current && sectionListRef.current.getRoot().contains(activeElement);
            }
        }), [
        parsedSelectedSections,
        setSelectedSections,
        state.sections,
        focused
    ]);
    /**
   * If a section content has been updated with a value we don't want to keep,
   * Then we need to imperatively revert it (we can't let React do it because the value did not change in his internal representation).
   */ const revertDOMSectionChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((sectionIndex)=>{
        if (!sectionListRef.current) return;
        const section = state.sections[sectionIndex];
        sectionListRef.current.getSectionContent(sectionIndex).innerHTML = section.value || section.placeholder;
        interactions.syncSelectionToDOM();
    });
    const handleContainerClick = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleContainerClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented() || !sectionListRef.current) return;
        setFocused(true);
        onClick?.(event, ...args);
        if (parsedSelectedSections === "all") setTimeout(()=>{
            const cursorPosition = document.getSelection().getRangeAt(0).startOffset;
            if (cursorPosition === 0) {
                setSelectedSections(sectionOrder.startIndex);
                return;
            }
            let sectionIndex = 0;
            let cursorOnStartOfSection = 0;
            while(cursorOnStartOfSection < cursorPosition && sectionIndex < state.sections.length){
                const section = state.sections[sectionIndex];
                sectionIndex += 1;
                cursorOnStartOfSection += `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`.length;
            }
            setSelectedSections(sectionIndex - 1);
        });
        else if (!focused) {
            setFocused(true);
            setSelectedSections(sectionOrder.startIndex);
        } else {
            const hasClickedOnASection = sectionListRef.current.getRoot().contains(event.target);
            if (!hasClickedOnASection) setSelectedSections(sectionOrder.startIndex);
        }
    });
    const handleContainerInput = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        onInput?.(event);
        if (!sectionListRef.current || parsedSelectedSections !== "all") return;
        const target = event.target;
        const keyPressed = target.textContent ?? "";
        sectionListRef.current.getRoot().innerHTML = state.sections.map((section)=>`${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`).join("");
        interactions.syncSelectionToDOM();
        if (keyPressed.length === 0 || keyPressed.charCodeAt(0) === 10) {
            resetCharacterQuery();
            clearValue();
            setSelectedSections("all");
        } else if (keyPressed.length > 1) updateValueFromValueStr(keyPressed);
        else applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: 0
        });
    });
    const handleContainerPaste = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        onPaste?.(event);
        if (readOnly || parsedSelectedSections !== "all") {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData("text");
        event.preventDefault();
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerFocus = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((...args)=>{
        onFocus?.(...args);
        if (focused || !sectionListRef.current) return;
        setFocused(true);
        const isFocusInsideASection = sectionListRef.current.getSectionIndexFromDOMElement((0, $68e3e92a73d67afe$export$cd4e5573fbe2b576)(document)) != null;
        if (!isFocusInsideASection) setSelectedSections(sectionOrder.startIndex);
    });
    const handleContainerBlur = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((...args)=>{
        onBlur?.(...args);
        setTimeout(()=>{
            if (!sectionListRef.current) return;
            const activeElement = (0, $68e3e92a73d67afe$export$cd4e5573fbe2b576)(document);
            const shouldBlur = !sectionListRef.current.getRoot().contains(activeElement);
            if (shouldBlur) {
                setFocused(false);
                setSelectedSections(null);
            }
        });
    });
    const getInputContainerClickHandler = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((sectionIndex)=>(event)=>{
            // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
            // We avoid this by checking if the call to this function is actually intended, or a side effect.
            if (event.isDefaultPrevented()) return;
            setSelectedSections(sectionIndex);
        });
    const handleInputContentMouseUp = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const getInputContentFocusHandler = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((sectionIndex)=>()=>{
            setSelectedSections(sectionIndex);
        });
    const handleInputContentPaste = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        // prevent default to avoid the input `onInput` handler being called
        event.preventDefault();
        if (readOnly || disabled || typeof parsedSelectedSections !== "number") return;
        const activeSection = state.sections[parsedSelectedSections];
        const pastedValue = event.clipboardData.getData("text");
        const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
        const digitsOnly = /^[0-9]+$/.test(pastedValue);
        const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
        const isValidPastedValue = activeSection.contentType === "letter" && lettersOnly || activeSection.contentType === "digit" && digitsOnly || activeSection.contentType === "digit-with-letter" && digitsAndLetterOnly;
        if (isValidPastedValue) {
            resetCharacterQuery();
            updateSectionValue({
                activeSection: activeSection,
                newSectionValue: pastedValue,
                shouldGoToNextSection: true
            });
        } else if (!lettersOnly && !digitsOnly) {
            resetCharacterQuery();
            updateValueFromValueStr(pastedValue);
        }
    });
    const handleInputContentDragOver = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = "none";
    });
    const handleInputContentInput = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        if (!sectionListRef.current) return;
        const target = event.target;
        const keyPressed = target.textContent ?? "";
        const sectionIndex = sectionListRef.current.getSectionIndexFromDOMElement(target);
        const section = state.sections[sectionIndex];
        if (readOnly || !sectionListRef.current) {
            revertDOMSectionChange(sectionIndex);
            return;
        }
        if (keyPressed.length === 0) {
            if (section.value === "") {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            const inputType = event.nativeEvent.inputType;
            if (inputType === "insertParagraph" || inputType === "insertLineBreak") {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            resetCharacterQuery();
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: sectionIndex
        });
        // The DOM value needs to remain the one React is expecting.
        revertDOMSectionChange(sectionIndex);
    });
    (0, $1c8a785890e03d41$export$2e2bcd8739ae039)(()=>{
        if (!focused || !sectionListRef.current) return;
        if (parsedSelectedSections === "all") sectionListRef.current.getRoot().focus();
        else if (typeof parsedSelectedSections === "number") {
            const domElement = sectionListRef.current.getSectionContent(parsedSelectedSections);
            if (domElement) domElement.focus();
        }
    }, [
        parsedSelectedSections,
        focused
    ]);
    const sectionBoundaries = $1T1QG.useMemo(()=>{
        return state.sections.reduce((acc, next)=>{
            acc[next.type] = sectionsValueBoundaries[next.type]({
                currentDate: null,
                contentType: next.contentType,
                format: next.format
            });
            return acc;
        }, {});
    }, [
        sectionsValueBoundaries,
        state.sections
    ]);
    const isContainerEditable = parsedSelectedSections === "all";
    const elements = $1T1QG.useMemo(()=>{
        return state.sections.map((section, index)=>{
            const isEditable = !isContainerEditable && !disabled && !readOnly;
            return {
                container: {
                    "data-sectionindex": index,
                    onClick: getInputContainerClickHandler(index)
                },
                content: {
                    tabIndex: isContainerEditable || index > 0 ? -1 : 0,
                    contentEditable: !isContainerEditable && !disabled && !readOnly,
                    role: "spinbutton",
                    id: `${id}-${section.type}`,
                    "aria-labelledby": `${id}-${section.type}`,
                    "aria-readonly": readOnly,
                    "aria-valuenow": (0, $4ff936469a729129$export$b46fd324c5adcf31)(section, utils),
                    "aria-valuemin": sectionBoundaries[section.type].minimum,
                    "aria-valuemax": sectionBoundaries[section.type].maximum,
                    "aria-valuetext": section.value ? (0, $4ff936469a729129$export$b5e30842500b6cab)(section, utils) : translations.empty,
                    "aria-label": translations[section.type],
                    "aria-disabled": disabled,
                    spellCheck: isEditable ? false : undefined,
                    autoCapitalize: isEditable ? "off" : undefined,
                    autoCorrect: isEditable ? "off" : undefined,
                    [parseInt($1T1QG.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: isEditable ? "next" : undefined,
                    children: section.value || section.placeholder,
                    onInput: handleInputContentInput,
                    onPaste: handleInputContentPaste,
                    onFocus: getInputContentFocusHandler(index),
                    onDragOver: handleInputContentDragOver,
                    onMouseUp: handleInputContentMouseUp,
                    inputMode: section.contentType === "letter" ? "text" : "numeric"
                },
                before: {
                    children: section.startSeparator
                },
                after: {
                    children: section.endSeparator
                }
            };
        });
    }, [
        state.sections,
        getInputContentFocusHandler,
        handleInputContentPaste,
        handleInputContentDragOver,
        handleInputContentInput,
        getInputContainerClickHandler,
        handleInputContentMouseUp,
        disabled,
        readOnly,
        isContainerEditable,
        translations,
        utils,
        sectionBoundaries,
        id
    ]);
    const handleValueStrChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        updateValueFromValueStr(event.target.value);
    });
    const valueStr = $1T1QG.useMemo(()=>areAllSectionsEmpty ? "" : fieldValueManager.getV7HiddenInputValueFromSections(state.sections), [
        areAllSectionsEmpty,
        state.sections,
        fieldValueManager
    ]);
    $1T1QG.useEffect(()=>{
        if (sectionListRef.current == null) throw new Error([
            "MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`",
            "You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.",
            "",
            "If you want to keep using an `<input />` HTML element for the editing, please remove the `enableAccessibleFieldDOMStructure` prop from your picker or field component:",
            "",
            "<DatePicker slots={{ textField: MyCustomTextField }} />",
            "",
            "Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element"
        ].join("\n"));
        if (autoFocus && sectionListRef.current) sectionListRef.current.getSectionContent(sectionOrder.startIndex).focus();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        interactions: interactions,
        returnedValue: {
            autoFocus: // Forwarded
            autoFocus,
            readOnly: readOnly,
            focused: focusedProp ?? focused,
            sectionListRef: handleSectionListRef,
            onBlur: handleContainerBlur,
            onClick: handleContainerClick,
            onFocus: handleContainerFocus,
            onInput: handleContainerInput,
            onPaste: handleContainerPaste,
            // Additional
            enableAccessibleFieldDOMStructure: true,
            elements: elements,
            // TODO v7: Try to set to undefined when there is a section selected.
            tabIndex: parsedSelectedSections === 0 ? -1 : 0,
            contentEditable: isContainerEditable,
            value: valueStr,
            onChange: handleValueStrChange,
            areAllSectionsEmpty: areAllSectionsEmpty
        }
    };
};




var $1T1QG = parcelRequire("1T1QG");





const $0dc184a89d9b20a6$var$cleanString = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, "");
const $0dc184a89d9b20a6$export$8bb5d1c9951d10ca = (sections, localizedDigits, isRtl)=>{
    let position = 0;
    let positionInInput = isRtl ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = (0, $4ff936469a729129$export$85daa91f6c6e875f)(section, isRtl ? "input-rtl" : "input-ltr", localizedDigits);
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = $0dc184a89d9b20a6$var$cleanString(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        // The ...InInput values consider the unicode characters but do include them in their indexes
        const cleanedValue = $0dc184a89d9b20a6$var$cleanString(renderedValue);
        const startInInput = positionInInput + (cleanedValue === "" ? 0 : renderedValue.indexOf(cleanedValue[0])) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput: startInInput,
            endInInput: endInInput
        }));
        position += sectionLength;
        // Move position to the end of string associated to the current section
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
const $0dc184a89d9b20a6$export$4995d3b7b56fcd3f = (params)=>{
    const isRtl = (0, $a69327a401bfde77$export$b2dd014b6c321cb)();
    const focusTimeoutRef = $1T1QG.useRef();
    const selectionSyncTimeoutRef = $1T1QG.useRef();
    const { forwardedProps: { onFocus: onFocus, onClick: onClick, onPaste: onPaste, onBlur: onBlur, inputRef: inputRefProp, placeholder: inPlaceholder }, internalProps: { readOnly: readOnly = false, disabled: disabled = false }, parsedSelectedSections: parsedSelectedSections, activeSectionIndex: activeSectionIndex, state: state, fieldValueManager: fieldValueManager, valueManager: valueManager, applyCharacterEditing: applyCharacterEditing, resetCharacterQuery: resetCharacterQuery, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, clearActiveSection: clearActiveSection, clearValue: clearValue, setTempAndroidValueStr: setTempAndroidValueStr, setSelectedSections: setSelectedSections, getSectionsFromValue: getSectionsFromValue, areAllSectionsEmpty: areAllSectionsEmpty, localizedDigits: localizedDigits } = params;
    const inputRef = $1T1QG.useRef(null);
    const handleRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(inputRefProp, inputRef);
    const sections = $1T1QG.useMemo(()=>$0dc184a89d9b20a6$export$8bb5d1c9951d10ca(state.sections, localizedDigits, isRtl), [
        state.sections,
        localizedDigits,
        isRtl
    ]);
    const interactions = $1T1QG.useMemo(()=>({
            syncSelectionToDOM: ()=>{
                if (!inputRef.current) return;
                if (parsedSelectedSections == null) {
                    if (inputRef.current.scrollLeft) // Ensure that input content is not marked as selected.
                    // setting selection range to 0 causes issues in Safari.
                    // https://bugs.webkit.org/show_bug.cgi?id=224425
                    inputRef.current.scrollLeft = 0;
                    return;
                }
                // On multi input range pickers we want to update selection range only for the active input
                // This helps to avoid the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
                // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
                if (inputRef.current !== (0, $68e3e92a73d67afe$export$cd4e5573fbe2b576)(document)) return;
                // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
                const currentScrollTop = inputRef.current.scrollTop;
                if (parsedSelectedSections === "all") inputRef.current.select();
                else {
                    const selectedSection = sections[parsedSelectedSections];
                    const selectionStart = selectedSection.type === "empty" ? selectedSection.startInInput - selectedSection.startSeparator.length : selectedSection.startInInput;
                    const selectionEnd = selectedSection.type === "empty" ? selectedSection.endInInput + selectedSection.endSeparator.length : selectedSection.endInInput;
                    if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
                        if (inputRef.current === (0, $68e3e92a73d67afe$export$cd4e5573fbe2b576)(document)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                    }
                    clearTimeout(selectionSyncTimeoutRef.current);
                    selectionSyncTimeoutRef.current = setTimeout(()=>{
                        // handle case when the selection is not updated correctly
                        // could happen on Android
                        if (inputRef.current && inputRef.current === (0, $68e3e92a73d67afe$export$cd4e5573fbe2b576)(document) && // The section might loose all selection, where `selectionStart === selectionEnd`
                        // https://github.com/mui/mui-x/pull/13652
                        inputRef.current.selectionStart === inputRef.current.selectionEnd && (inputRef.current.selectionStart !== selectionStart || inputRef.current.selectionEnd !== selectionEnd)) interactions.syncSelectionToDOM();
                    });
                }
                // Even reading this variable seems to do the trick, but also setting it just to make use of it
                inputRef.current.scrollTop = currentScrollTop;
            },
            getActiveSectionIndexFromDOM: ()=>{
                const browserStartIndex = inputRef.current.selectionStart ?? 0;
                const browserEndIndex = inputRef.current.selectionEnd ?? 0;
                if (browserStartIndex === 0 && browserEndIndex === 0) return null;
                const nextSectionIndex = browserStartIndex <= sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
                 : sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
            },
            focusField: (newSelectedSection = 0)=>{
                inputRef.current?.focus();
                setSelectedSections(newSelectedSection);
            },
            setSelectedSections: (newSelectedSections)=>setSelectedSections(newSelectedSections),
            isFieldFocused: ()=>inputRef.current === (0, $68e3e92a73d67afe$export$cd4e5573fbe2b576)(document)
        }), [
        inputRef,
        parsedSelectedSections,
        sections,
        setSelectedSections
    ]);
    const syncSelectionFromDOM = ()=>{
        const browserStartIndex = inputRef.current.selectionStart ?? 0;
        let nextSectionIndex;
        if (browserStartIndex <= sections[0].startInInput) // Special case if browser index is in invisible characters at the beginning
        nextSectionIndex = 1;
        else if (browserStartIndex >= sections[sections.length - 1].endInInput) // If the click is after the last character of the input, then we want to select the 1st section.
        nextSectionIndex = 1;
        else nextSectionIndex = sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    };
    const handleInputFocus = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((...args)=>{
        onFocus?.(...args);
        // The ref is guaranteed to be resolved at this point.
        const input = inputRef.current;
        clearTimeout(focusTimeoutRef.current);
        focusTimeoutRef.current = setTimeout(()=>{
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) return;
            if (activeSectionIndex != null) return;
            if (// avoid selecting all sections when focusing empty field without value
            input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections("all");
            else syncSelectionFromDOM();
        });
    });
    const handleInputClick = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented()) return;
        onClick?.(event, ...args);
        syncSelectionFromDOM();
    });
    const handleInputPaste = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        onPaste?.(event);
        // prevent default to avoid the input `onChange` handler being called
        event.preventDefault();
        if (readOnly || disabled) return;
        const pastedValue = event.clipboardData.getData("text");
        if (typeof parsedSelectedSections === "number") {
            const activeSection = state.sections[parsedSelectedSections];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = activeSection.contentType === "letter" && lettersOnly || activeSection.contentType === "digit" && digitsOnly || activeSection.contentType === "digit-with-letter" && digitsAndLetterOnly;
            if (isValidPastedValue) {
                resetCharacterQuery();
                updateSectionValue({
                    activeSection: activeSection,
                    newSectionValue: pastedValue,
                    shouldGoToNextSection: true
                });
                return;
            }
            if (lettersOnly || digitsOnly) // The pasted value corresponds to a single section, but not the expected type,
            // skip the modification
            return;
        }
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerBlur = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((...args)=>{
        onBlur?.(...args);
        setSelectedSections(null);
    });
    const handleInputChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        if (readOnly) return;
        const targetValue = event.target.value;
        if (targetValue === "") {
            resetCharacterQuery();
            clearValue();
            return;
        }
        const eventData = event.nativeEvent.data;
        // Calling `.fill(04/11/2022)` in playwright will trigger a change event with the requested content to insert in `event.nativeEvent.data`
        // usual changes have only the currently typed character in the `event.nativeEvent.data`
        const shouldUseEventData = eventData && eventData.length > 1;
        const valueStr = shouldUseEventData ? eventData : targetValue;
        const cleanValueStr = $0dc184a89d9b20a6$var$cleanString(valueStr);
        // If no section is selected or eventData should be used, we just try to parse the new value
        // This line is mostly triggered by imperative code / application tests.
        if (activeSectionIndex == null || shouldUseEventData) {
            updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
            return;
        }
        let keyPressed;
        if (parsedSelectedSections === "all" && cleanValueStr.length === 1) keyPressed = cleanValueStr;
        else {
            const prevValueStr = $0dc184a89d9b20a6$var$cleanString(fieldValueManager.getV6InputValueFromSections(sections, localizedDigits, isRtl));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = sections[activeSectionIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) // TODO: Support if the new date is valid
            return;
            // The active section being selected, the browser has replaced its value with the key pressed by the user.
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - $0dc184a89d9b20a6$var$cleanString(activeSection.endSeparator || "").length;
            keyPressed = cleanValueStr.slice(activeSection.start + $0dc184a89d9b20a6$var$cleanString(activeSection.startSeparator || "").length, activeSectionEndRelativeToNewValue);
        }
        if (keyPressed.length === 0) {
            if ((0, $4ff936469a729129$export$a11b0059900ceec8)()) setTempAndroidValueStr(valueStr);
            resetCharacterQuery();
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: activeSectionIndex
        });
    });
    const placeholder = $1T1QG.useMemo(()=>{
        if (inPlaceholder !== undefined) return inPlaceholder;
        return fieldValueManager.getV6InputValueFromSections(getSectionsFromValue(valueManager.emptyValue), localizedDigits, isRtl);
    }, [
        inPlaceholder,
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        localizedDigits,
        isRtl
    ]);
    const valueStr = $1T1QG.useMemo(()=>state.tempValueStrAndroid ?? fieldValueManager.getV6InputValueFromSections(state.sections, localizedDigits, isRtl), [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        localizedDigits,
        isRtl
    ]);
    $1T1QG.useEffect(()=>{
        // Select all the sections when focused on mount (`autoFocus = true` on the input)
        if (inputRef.current && inputRef.current === (0, $68e3e92a73d67afe$export$cd4e5573fbe2b576)(document)) setSelectedSections("all");
        return ()=>{
            clearTimeout(focusTimeoutRef.current);
            clearTimeout(selectionSyncTimeoutRef.current);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const inputMode = $1T1QG.useMemo(()=>{
        if (activeSectionIndex == null) return "text";
        if (state.sections[activeSectionIndex].contentType === "letter") return "text";
        return "numeric";
    }, [
        activeSectionIndex,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === (0, $68e3e92a73d67afe$export$cd4e5573fbe2b576)(document);
    const shouldShowPlaceholder = !inputHasFocus && areAllSectionsEmpty;
    return {
        interactions: interactions,
        returnedValue: {
            readOnly: // Forwarded
            readOnly,
            onBlur: handleContainerBlur,
            onClick: handleInputClick,
            onFocus: handleInputFocus,
            onPaste: handleInputPaste,
            inputRef: handleRef,
            // Additional
            enableAccessibleFieldDOMStructure: false,
            placeholder: placeholder,
            inputMode: inputMode,
            autoComplete: "off",
            value: shouldShowPlaceholder ? "" : valueStr,
            onChange: handleInputChange
        }
    };
};


const $e5a7561ca2bd0124$export$294aa081a6c6f55d = (params)=>{
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const { internalProps: internalProps, internalProps: { unstableFieldRef: unstableFieldRef, minutesStep: minutesStep, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = false, disabled: disabled = false, readOnly: readOnly = false }, forwardedProps: { onKeyDown: onKeyDown, error: error, clearable: clearable, onClear: onClear }, fieldValueManager: fieldValueManager, valueManager: valueManager, validator: validator } = params;
    const isRtl = (0, $a69327a401bfde77$export$b2dd014b6c321cb)();
    const stateResponse = (0, $5b6ed2b81b707d19$export$4e8d6353e50062e7)(params);
    const { state: state, activeSectionIndex: activeSectionIndex, parsedSelectedSections: parsedSelectedSections, setSelectedSections: setSelectedSections, clearValue: clearValue, clearActiveSection: clearActiveSection, updateSectionValue: updateSectionValue, setTempAndroidValueStr: setTempAndroidValueStr, sectionsValueBoundaries: sectionsValueBoundaries, localizedDigits: localizedDigits, timezone: timezone } = stateResponse;
    const characterEditingResponse = (0, $8d095b25375d2f3c$export$66d00048b8bb82f6)({
        sections: state.sections,
        updateSectionValue: updateSectionValue,
        sectionsValueBoundaries: sectionsValueBoundaries,
        localizedDigits: localizedDigits,
        setTempAndroidValueStr: setTempAndroidValueStr,
        timezone: timezone
    });
    const { resetCharacterQuery: resetCharacterQuery } = characterEditingResponse;
    const areAllSectionsEmpty = valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue);
    const useFieldTextField = enableAccessibleFieldDOMStructure ? (0, $be189ebc8f09b944$export$3b5f62b9baf9717e) : (0, $0dc184a89d9b20a6$export$4995d3b7b56fcd3f);
    const sectionOrder = $1T1QG.useMemo(()=>(0, $4ff936469a729129$export$7725fd6fe0a2aadf)(state.sections, isRtl && !enableAccessibleFieldDOMStructure), [
        state.sections,
        isRtl,
        enableAccessibleFieldDOMStructure
    ]);
    const { returnedValue: returnedValue, interactions: interactions } = useFieldTextField((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, params, stateResponse, characterEditingResponse, {
        areAllSectionsEmpty: areAllSectionsEmpty,
        sectionOrder: sectionOrder
    }));
    const handleContainerKeyDown = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        onKeyDown?.(event);
        if (disabled) return;
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case (event.ctrlKey || event.metaKey) && String.fromCharCode(event.keyCode) === "A" && !event.shiftKey && !event.altKey:
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections("all");
                break;
            // Move selection to next section
            case event.key === "ArrowRight":
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.startIndex);
                else if (parsedSelectedSections === "all") setSelectedSections(sectionOrder.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === "ArrowLeft":
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.endIndex);
                else if (parsedSelectedSections === "all") setSelectedSections(sectionOrder.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case event.key === "Delete":
                event.preventDefault();
                if (readOnly) break;
                if (parsedSelectedSections == null || parsedSelectedSections === "all") clearValue();
                else clearActiveSection();
                resetCharacterQuery();
                break;
            // Increment / decrement the selected section value
            case [
                "ArrowUp",
                "ArrowDown",
                "Home",
                "End",
                "PageUp",
                "PageDown"
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || activeSectionIndex == null) break;
                    const activeSection = state.sections[activeSectionIndex];
                    const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
                    const newSectionValue = (0, $4ff936469a729129$export$5ed0f22513e58fe3)(utils, timezone, activeSection, event.key, sectionsValueBoundaries, localizedDigits, activeDateManager.date, {
                        minutesStep: minutesStep
                    });
                    updateSectionValue({
                        activeSection: activeSection,
                        newSectionValue: newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
    (0, $1c8a785890e03d41$export$2e2bcd8739ae039)(()=>{
        interactions.syncSelectionToDOM();
    });
    const { hasValidationError: hasValidationError } = (0, $7480e2bc04de1c42$export$87fe492f99f25a20)({
        props: internalProps,
        validator: validator,
        timezone: timezone,
        value: state.value,
        onError: internalProps.onError
    });
    const inputError = $1T1QG.useMemo(()=>{
        // only override when `error` is undefined.
        // in case of multi input fields, the `error` value is provided externally and will always be defined.
        if (error !== undefined) return error;
        return hasValidationError;
    }, [
        hasValidationError,
        error
    ]);
    $1T1QG.useEffect(()=>{
        if (!inputError && activeSectionIndex == null) resetCharacterQuery();
    }, [
        state.referenceValue,
        activeSectionIndex,
        inputError
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // If `tempValueStrAndroid` is still defined for some section when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    $1T1QG.useEffect(()=>{
        if (state.tempValueStrAndroid != null && activeSectionIndex != null) {
            resetCharacterQuery();
            clearActiveSection();
        }
    }, [
        state.sections
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $1T1QG.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: interactions.getActiveSectionIndexFromDOM,
            setSelectedSections: interactions.setSelectedSections,
            focusField: interactions.focusField,
            isFieldFocused: interactions.isFieldFocused
        }));
    const handleClearValue = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (!interactions.isFieldFocused()) // setSelectedSections is called internally
        interactions.focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const commonForwardedProps = {
        onKeyDown: handleContainerKeyDown,
        onClear: handleClearValue,
        error: inputError,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled)
    };
    const commonAdditionalProps = {
        disabled: disabled,
        readOnly: readOnly
    };
    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, params.forwardedProps, commonForwardedProps, commonAdditionalProps, returnedValue);
};




const $4d39a15704c4df77$export$ffb3d0046ef3a2 = ({ props: props, value: value, timezone: timezone, adapter: adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, disablePast: disablePast, disableFuture: disableFuture } = props;
    const now = adapter.utils.date(undefined, timezone);
    const minDate = (0, $2c8437f6b047f676$export$eb73579ccade48fd)(adapter.utils, props.minDate, adapter.defaultDates.minDate);
    const maxDate = (0, $2c8437f6b047f676$export$eb73579ccade48fd)(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
    switch(true){
        case !adapter.utils.isValid(value):
            return "invalidDate";
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return "shouldDisableDate";
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return "shouldDisableMonth";
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return "shouldDisableYear";
        case Boolean(disableFuture && adapter.utils.isAfterDay(value, now)):
            return "disableFuture";
        case Boolean(disablePast && adapter.utils.isBeforeDay(value, now)):
            return "disablePast";
        case Boolean(minDate && adapter.utils.isBeforeDay(value, minDate)):
            return "minDate";
        case Boolean(maxDate && adapter.utils.isAfterDay(value, maxDate)):
            return "maxDate";
        default:
            return null;
    }
};
$4d39a15704c4df77$export$ffb3d0046ef3a2.valueManager = (0, $59c1a689a11004ea$export$2764b246aa3b75ba);




const $4f2e458897ab1673$export$7bd013ac69eb590c = ({ adapter: adapter, value: value, timezone: timezone, props: props })=>{
    if (value === null) return null;
    const { minTime: minTime, maxTime: maxTime, minutesStep: minutesStep, shouldDisableTime: shouldDisableTime, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, disablePast: disablePast, disableFuture: disableFuture } = props;
    const now = adapter.utils.date(undefined, timezone);
    const isAfter = (0, $a99658949db23f4e$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, adapter.utils);
    switch(true){
        case !adapter.utils.isValid(value):
            return "invalidDate";
        case Boolean(minTime && isAfter(minTime, value)):
            return "minTime";
        case Boolean(maxTime && isAfter(value, maxTime)):
            return "maxTime";
        case Boolean(disableFuture && adapter.utils.isAfter(value, now)):
            return "disableFuture";
        case Boolean(disablePast && adapter.utils.isBefore(value, now)):
            return "disablePast";
        case Boolean(shouldDisableTime && shouldDisableTime(value, "hours")):
            return "shouldDisableTime-hours";
        case Boolean(shouldDisableTime && shouldDisableTime(value, "minutes")):
            return "shouldDisableTime-minutes";
        case Boolean(shouldDisableTime && shouldDisableTime(value, "seconds")):
            return "shouldDisableTime-seconds";
        case Boolean(minutesStep && adapter.utils.getMinutes(value) % minutesStep !== 0):
            return "minutesStep";
        default:
            return null;
    }
};
$4f2e458897ab1673$export$7bd013ac69eb590c.valueManager = (0, $59c1a689a11004ea$export$2764b246aa3b75ba);



const $36aa9dc0cdfa81f8$export$ed94a8ff1f54c4f = ({ adapter: adapter, value: value, timezone: timezone, props: props })=>{
    const dateValidationResult = (0, $4d39a15704c4df77$export$ffb3d0046ef3a2)({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
    if (dateValidationResult !== null) return dateValidationResult;
    return (0, $4f2e458897ab1673$export$7bd013ac69eb590c)({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
};
$36aa9dc0cdfa81f8$export$ed94a8ff1f54c4f.valueManager = (0, $59c1a689a11004ea$export$2764b246aa3b75ba);




var $1T1QG = parcelRequire("1T1QG");
const $5aeaf2f033f161b7$export$430d9fc64cf058d6 = [
    "disablePast",
    "disableFuture",
    "minDate",
    "maxDate",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear"
];
const $5aeaf2f033f161b7$export$fd5e0f8b4115a8c7 = [
    "disablePast",
    "disableFuture",
    "minTime",
    "maxTime",
    "shouldDisableTime",
    "minutesStep",
    "ampm",
    "disableIgnoringDatePartForTimeValidation"
];
const $5aeaf2f033f161b7$export$1df62d3ba2121371 = [
    "minDateTime",
    "maxDateTime"
];
const $5aeaf2f033f161b7$var$VALIDATION_PROP_NAMES = [
    ...$5aeaf2f033f161b7$export$430d9fc64cf058d6,
    ...$5aeaf2f033f161b7$export$fd5e0f8b4115a8c7,
    ...$5aeaf2f033f161b7$export$1df62d3ba2121371
];
const $5aeaf2f033f161b7$export$5890f750904acddb = (props)=>$5aeaf2f033f161b7$var$VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});


"use client";
const $36f2d66e3b541c42$var$SHARED_FIELD_INTERNAL_PROP_NAMES = [
    "value",
    "defaultValue",
    "referenceDate",
    "format",
    "formatDensity",
    "onChange",
    "timezone",
    "onError",
    "shouldRespectLeadingZeros",
    "selectedSections",
    "onSelectedSectionsChange",
    "unstableFieldRef",
    "enableAccessibleFieldDOMStructure",
    "disabled",
    "readOnly",
    "dateSeparator"
];
const $36f2d66e3b541c42$export$be857fabf132acea = (props, valueType)=>{
    return $1T1QG.useMemo(()=>{
        const forwardedProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props);
        const internalProps = {};
        const extractProp = (propName)=>{
            if (forwardedProps.hasOwnProperty(propName)) {
                // @ts-ignore
                internalProps[propName] = forwardedProps[propName];
                delete forwardedProps[propName];
            }
        };
        $36f2d66e3b541c42$var$SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
        if (valueType === "date") (0, $5aeaf2f033f161b7$export$430d9fc64cf058d6).forEach(extractProp);
        else if (valueType === "time") (0, $5aeaf2f033f161b7$export$fd5e0f8b4115a8c7).forEach(extractProp);
        else if (valueType === "date-time") {
            (0, $5aeaf2f033f161b7$export$430d9fc64cf058d6).forEach(extractProp);
            (0, $5aeaf2f033f161b7$export$fd5e0f8b4115a8c7).forEach(extractProp);
            (0, $5aeaf2f033f161b7$export$1df62d3ba2121371).forEach(extractProp);
        }
        return {
            forwardedProps: forwardedProps,
            internalProps: internalProps
        };
    }, [
        props,
        valueType
    ]);
};





const $a466cc9353e69642$export$c04f15aa68a6177a = (props)=>{
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const defaultDates = (0, $f3e8032daddc32c6$export$7c38da3a2e90fa83)();
    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, {
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        format: props.format ?? utils.formats.keyboardDate,
        minDate: (0, $2c8437f6b047f676$export$eb73579ccade48fd)(utils, props.minDate, defaultDates.minDate),
        maxDate: (0, $2c8437f6b047f676$export$eb73579ccade48fd)(utils, props.maxDate, defaultDates.maxDate)
    });
};
const $a466cc9353e69642$export$e740b972b66c04cd = (props)=>{
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const ampm = props.ampm ?? utils.is12HourCycleInCurrentLocale();
    const defaultFormat = ampm ? utils.formats.fullTime12h : utils.formats.fullTime24h;
    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, {
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        format: props.format ?? defaultFormat
    });
};
const $a466cc9353e69642$export$ae5b8d06aeae1db3 = (props)=>{
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const defaultDates = (0, $f3e8032daddc32c6$export$7c38da3a2e90fa83)();
    const ampm = props.ampm ?? utils.is12HourCycleInCurrentLocale();
    const defaultFormat = ampm ? utils.formats.keyboardDateTime12h : utils.formats.keyboardDateTime24h;
    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, {
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        format: props.format ?? defaultFormat,
        disableIgnoringDatePartForTimeValidation: Boolean(props.minDateTime || props.maxDateTime),
        minDate: (0, $2c8437f6b047f676$export$eb73579ccade48fd)(utils, props.minDateTime ?? props.minDate, defaultDates.minDate),
        maxDate: (0, $2c8437f6b047f676$export$eb73579ccade48fd)(utils, props.maxDateTime ?? props.maxDate, defaultDates.maxDate),
        minTime: props.minDateTime ?? props.minTime,
        maxTime: props.maxDateTime ?? props.maxTime
    });
};


"use client";
const $8d92dc95662a5d59$export$2c2e7f1ceedfa8fa = (inProps)=>{
    const props = (0, $a466cc9353e69642$export$ae5b8d06aeae1db3)(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $36f2d66e3b541c42$export$be857fabf132acea)(props, "date-time");
    return (0, $e5a7561ca2bd0124$export$294aa081a6c6f55d)({
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $59c1a689a11004ea$export$2764b246aa3b75ba),
        fieldValueManager: (0, $59c1a689a11004ea$export$b602c94f557316b4),
        validator: (0, $36aa9dc0cdfa81f8$export$ed94a8ff1f54c4f),
        valueType: "date-time"
    });
};





var $1T1QG = parcelRequire("1T1QG");



var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $5wtOU = parcelRequire("5wtOU");




var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $b03b9025e0e09423$export$4b135a4b3a6c4550(slot) {
    return (0, $iNQht.default)("MuiInputAdornment", slot);
}
const $b03b9025e0e09423$var$inputAdornmentClasses = (0, $dfswM.default)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
var $b03b9025e0e09423$export$2e2bcd8739ae039 = $b03b9025e0e09423$var$inputAdornmentClasses;



var $gADeF = parcelRequire("gADeF");

var $3Py8h = parcelRequire("3Py8h");
"use client";
var $5a3af6fa98298c7b$var$_span;
const $5a3af6fa98298c7b$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $5a3af6fa98298c7b$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $5wtOU.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $5a3af6fa98298c7b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, $5wtOU.default)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, $5wtOU.default)(size)}`
        ]
    };
    return (0, $iV85C.default)(slots, (0, $b03b9025e0e09423$export$4b135a4b3a6c4550), classes);
};
const $5a3af6fa98298c7b$var$InputAdornmentRoot = (0, $npagc.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver: $5a3af6fa98298c7b$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $b03b9025e0e09423$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $b03b9025e0e09423$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const $5a3af6fa98298c7b$var$InputAdornment = /*#__PURE__*/ $1T1QG.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children: children, className: className, component: component = "div", disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $iXdVf.default)(props, $5a3af6fa98298c7b$var$_excluded);
    const muiFormControl = (0, $83a17b5295da3528$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $ajTRS.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $5a3af6fa98298c7b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c399561ca469fdec$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($5a3af6fa98298c7b$var$InputAdornmentRoot, (0, $ajTRS.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $aVXbR.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a386176d6ca21602$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $5a3af6fa98298c7b$var$_span || ($5a3af6fa98298c7b$var$_span = /*#__PURE__*/ (0, $3Py8h.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $5a3af6fa98298c7b$export$2e2bcd8739ae039 = $5a3af6fa98298c7b$var$InputAdornment;



var $jdjLq = parcelRequire("jdjLq");

var $1T1QG = parcelRequire("1T1QG");

var $3Py8h = parcelRequire("3Py8h");
const $705a86f4b9915dac$export$ed0fe318cc298673 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
const $705a86f4b9915dac$export$8afed21ef5c2afa5 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft");
const $705a86f4b9915dac$export$9ca09caa9c849d9c = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight");
const $705a86f4b9915dac$export$5fda1783bb83f57b = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar");
const $705a86f4b9915dac$export$8099ab97743c966c = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
    children: [
        /*#__PURE__*/ (0, $3Py8h.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $3Py8h.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), "Clock");
const $705a86f4b9915dac$export$90a8eab2a2411720 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
const $705a86f4b9915dac$export$7e95adcf912503e3 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
    children: [
        /*#__PURE__*/ (0, $3Py8h.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $3Py8h.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), "Time");
const $705a86f4b9915dac$export$cefbac224a47f32 = (0, $jdjLq.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");




var $3Py8h = parcelRequire("3Py8h");
"use client";
const $ea948cf9ba8223aa$var$_excluded = [
    "clearable",
    "onClear",
    "InputProps",
    "sx",
    "slots",
    "slotProps"
], $ea948cf9ba8223aa$var$_excluded2 = [
    "ownerState"
];
const $ea948cf9ba8223aa$export$db9644cdb7e3d432 = (props)=>{
    const translations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    const { clearable: clearable, onClear: onClear, InputProps: InputProps, sx: sx, slots: slots, slotProps: slotProps } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $ea948cf9ba8223aa$var$_excluded);
    const IconButton = slots?.clearButton ?? (0, $5c784366741908ee$export$2e2bcd8739ae039);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: IconButton,
        externalSlotProps: slotProps?.clearButton,
        ownerState: {},
        className: "clearButton",
        additionalProps: {
            title: translations.fieldClearLabel
        }
    }), iconButtonProps = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_useSlotProps, $ea948cf9ba8223aa$var$_excluded2);
    const EndClearIcon = slots?.clearIcon ?? (0, $705a86f4b9915dac$export$cefbac224a47f32);
    const endClearIconProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: EndClearIcon,
        externalSlotProps: slotProps?.clearIcon,
        ownerState: {}
    });
    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, other, {
        InputProps: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, InputProps, {
            endAdornment: /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
                children: [
                    clearable && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $5a3af6fa98298c7b$export$2e2bcd8739ae039), {
                        position: "end",
                        sx: {
                            marginRight: InputProps?.endAdornment ? -1 : -1.5
                        },
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)(IconButton, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, iconButtonProps, {
                            onClick: onClear,
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)(EndClearIcon, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                                fontSize: "small"
                            }, endClearIconProps))
                        }))
                    }),
                    InputProps?.endAdornment
                ]
            })
        }),
        sx: [
            {
                "& .clearButton": {
                    opacity: 1
                },
                "@media (pointer: fine)": {
                    "& .clearButton": {
                        opacity: 0
                    },
                    "&:hover, &:focus-within": {
                        ".clearButton": {
                            opacity: 1
                        }
                    }
                }
            },
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    });
};





var $1T1QG = parcelRequire("1T1QG");



var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");


/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ function $0a2d1fc7aa88aa06$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = "";
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? "" : " ") + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += " " + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}






const $3aa21ac95b53ec15$var$defaultGenerator = (componentName)=>componentName;
const $3aa21ac95b53ec15$var$createClassNameGenerator = ()=>{
    let generate = $3aa21ac95b53ec15$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $3aa21ac95b53ec15$var$defaultGenerator;
        }
    };
};
const $3aa21ac95b53ec15$var$ClassNameGenerator = $3aa21ac95b53ec15$var$createClassNameGenerator();
var $3aa21ac95b53ec15$export$2e2bcd8739ae039 = $3aa21ac95b53ec15$var$ClassNameGenerator;


const $c118923dfabedaa0$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $c118923dfabedaa0$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $c118923dfabedaa0$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $3aa21ac95b53ec15$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $c118923dfabedaa0$export$34c0130b1f3e8ae3(slot) {
    return $c118923dfabedaa0$export$9d6b9120de57c54[slot] !== undefined;
}



function $d71473e2d3ab95b6$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $c118923dfabedaa0$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}


function $6e78dc27ae86ac8a$export$d99678ed7aad1677(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiPickersTextField", slot);
}
const $6e78dc27ae86ac8a$export$284739773a7ae972 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiPickersTextField", [
    "root",
    "focused",
    "disabled",
    "error",
    "required"
]);





var $1T1QG = parcelRequire("1T1QG");



var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");







function $5cf63e52e1c03fa0$export$3821cb625ac26962(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiPickersInputBase", slot);
}
const $5cf63e52e1c03fa0$export$f20b5ba262568322 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiPickersInputBase", [
    "root",
    "focused",
    "disabled",
    "error",
    "notchedOutline",
    "sectionContent",
    "sectionBefore",
    "sectionAfter",
    "adornedStart",
    "adornedEnd",
    "input"
]);


function $d5b047ab83af50e3$export$c0dd951a3959ac7f(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiPickersOutlinedInput", slot);
}
const $d5b047ab83af50e3$export$a7da60486bcc91df = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, (0, $5cf63e52e1c03fa0$export$f20b5ba262568322), (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiPickersOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));




parcelRequire("1T1QG");

var $npagc = parcelRequire("npagc");

var $3Py8h = parcelRequire("3Py8h");
const $2cc3bdd0021f5eaf$var$_excluded = [
    "children",
    "className",
    "label",
    "notched",
    "shrink"
];
const $2cc3bdd0021f5eaf$var$OutlineRoot = (0, $npagc.default)("fieldset", {
    name: "MuiPickersOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        textAlign: "left",
        position: "absolute",
        bottom: 0,
        right: 0,
        top: -5,
        left: 0,
        margin: 0,
        padding: "0 8px",
        pointerEvents: "none",
        borderRadius: "inherit",
        borderStyle: "solid",
        borderWidth: 1,
        overflow: "hidden",
        minWidth: "0%",
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $2cc3bdd0021f5eaf$var$OutlineLabel = (0, $npagc.default)("span")(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: "inherit"
    }));
const $2cc3bdd0021f5eaf$var$OutlineLegend = (0, $npagc.default)("legend")(({ theme: theme })=>({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden",
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: {
                    withLabel: false
                },
                style: {
                    padding: 0,
                    lineHeight: "11px",
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create("width", {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    withLabel: true
                },
                style: {
                    display: "block",
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: "0.75em",
                    visibility: "hidden",
                    maxWidth: 0.01,
                    transition: theme.transitions.create("max-width", {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: "nowrap",
                    "& > span": {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: "inline-block",
                        opacity: 0,
                        visibility: "visible"
                    }
                }
            },
            {
                props: {
                    withLabel: true,
                    notched: true
                },
                style: {
                    maxWidth: "100%",
                    transition: theme.transitions.create("max-width", {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    }));
function $2cc3bdd0021f5eaf$export$2e2bcd8739ae039(props) {
    const { className: className, label: label } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $2cc3bdd0021f5eaf$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, {
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)($2cc3bdd0021f5eaf$var$OutlineRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        "aria-hidden": true,
        className: className
    }, other, {
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($2cc3bdd0021f5eaf$var$OutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $3Py8h.jsx)($2cc3bdd0021f5eaf$var$OutlineLabel, {
                children: label
            }) : /*#__PURE__*/ // notranslate needed while Google Translate will not fix zero-width space issue
            (0, $3Py8h.jsx)($2cc3bdd0021f5eaf$var$OutlineLabel, {
                className: "notranslate",
                children: "\u200B"
            })
        })
    }));
}





var $1T1QG = parcelRequire("1T1QG");



var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");



/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $80ff444e8db61245$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append("args[]", arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}


function $3dbd1d1246ec9038$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $80ff444e8db61245$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}



const $b922239ff06fa2ab$var$visuallyHidden = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
};
var $b922239ff06fa2ab$export$2e2bcd8739ae039 = $b922239ff06fa2ab$var$visuallyHidden;







var $1T1QG = parcelRequire("1T1QG");





var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");


function $dd7cdbc87e0c118f$export$f891a98d04ce6513(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiPickersSectionList", slot);
}
const $dd7cdbc87e0c118f$export$8455939b33d2ee90 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiPickersSectionList", [
    "root",
    "section",
    "sectionContent"
]);



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $3ff05f0cbbf29cbd$var$_excluded = [
    "slots",
    "slotProps",
    "elements",
    "sectionListRef"
];
const $3ff05f0cbbf29cbd$export$4ee86b293725486c = (0, $npagc.default)("div", {
    name: "MuiPickersSectionList",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    direction: "ltr /*! @noflip */",
    outline: "none"
});
const $3ff05f0cbbf29cbd$export$30e7187e386feb4f = (0, $npagc.default)("span", {
    name: "MuiPickersSectionList",
    slot: "Section",
    overridesResolver: (props, styles)=>styles.section
})({});
const $3ff05f0cbbf29cbd$export$c403b59604f63120 = (0, $npagc.default)("span", {
    name: "MuiPickersSectionList",
    slot: "SectionSeparator",
    overridesResolver: (props, styles)=>styles.sectionSeparator
})({
    whiteSpace: "pre"
});
const $3ff05f0cbbf29cbd$export$1f2c61561fe3d6 = (0, $npagc.default)("span", {
    name: "MuiPickersSectionList",
    slot: "SectionContent",
    overridesResolver: (props, styles)=>styles.sectionContent
})({
    outline: "none"
});
const $3ff05f0cbbf29cbd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        section: [
            "section"
        ],
        sectionContent: [
            "sectionContent"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $dd7cdbc87e0c118f$export$f891a98d04ce6513), classes);
};
function $3ff05f0cbbf29cbd$var$PickersSection(props) {
    const { slots: slots, slotProps: slotProps, element: element, classes: classes } = props;
    const Section = slots?.section ?? $3ff05f0cbbf29cbd$export$30e7187e386feb4f;
    const sectionProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: Section,
        externalSlotProps: slotProps?.section,
        externalForwardedProps: element.container,
        className: classes.section,
        ownerState: {}
    });
    const SectionContent = slots?.sectionContent ?? $3ff05f0cbbf29cbd$export$1f2c61561fe3d6;
    const sectionContentProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: SectionContent,
        externalSlotProps: slotProps?.sectionContent,
        externalForwardedProps: element.content,
        additionalProps: {
            suppressContentEditableWarning: true
        },
        className: classes.sectionContent,
        ownerState: {}
    });
    const SectionSeparator = slots?.sectionSeparator ?? $3ff05f0cbbf29cbd$export$c403b59604f63120;
    const sectionSeparatorBeforeProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.before,
        ownerState: {
            position: "before"
        }
    });
    const sectionSeparatorAfterProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.after,
        ownerState: {
            position: "after"
        }
    });
    return /*#__PURE__*/ (0, $3Py8h.jsxs)(Section, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, sectionProps, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)(SectionSeparator, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, sectionSeparatorBeforeProps)),
            /*#__PURE__*/ (0, $3Py8h.jsx)(SectionContent, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, sectionContentProps)),
            /*#__PURE__*/ (0, $3Py8h.jsx)(SectionSeparator, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, sectionSeparatorAfterProps))
        ]
    }));
}
/**
 * Demos:
 *
 * - [Custom field](https://mui.com/x/react-date-pickers/custom-field/)
 *
 * API:
 *
 * - [PickersSectionList API](https://mui.com/x/api/date-pickers/pickers-section-list/)
 */ const $3ff05f0cbbf29cbd$export$847fd4b97819700 = /*#__PURE__*/ $1T1QG.forwardRef(function PickersSectionList(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersSectionList"
    });
    const { slots: slots, slotProps: slotProps, elements: elements, sectionListRef: sectionListRef } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $3ff05f0cbbf29cbd$var$_excluded);
    const classes = $3ff05f0cbbf29cbd$var$useUtilityClasses(props);
    const rootRef = $1T1QG.useRef(null);
    const handleRootRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(ref, rootRef);
    const getRoot = (methodName)=>{
        if (!rootRef.current) throw new Error(`MUI X: Cannot call sectionListRef.${methodName} before the mount of the component.`);
        return rootRef.current;
    };
    $1T1QG.useImperativeHandle(sectionListRef, ()=>({
            getRoot () {
                return getRoot("getRoot");
            },
            getSectionContainer (index) {
                const root = getRoot("getSectionContainer");
                return root.querySelector(`.${(0, $dd7cdbc87e0c118f$export$8455939b33d2ee90).section}[data-sectionindex="${index}"]`);
            },
            getSectionContent (index) {
                const root = getRoot("getSectionContent");
                return root.querySelector(`.${(0, $dd7cdbc87e0c118f$export$8455939b33d2ee90).section}[data-sectionindex="${index}"] .${(0, $dd7cdbc87e0c118f$export$8455939b33d2ee90).sectionContent}`);
            },
            getSectionIndexFromDOMElement (element) {
                const root = getRoot("getSectionIndexFromDOMElement");
                if (element == null || !root.contains(element)) return null;
                let sectionContainer = null;
                if (element.classList.contains((0, $dd7cdbc87e0c118f$export$8455939b33d2ee90).section)) sectionContainer = element;
                else if (element.classList.contains((0, $dd7cdbc87e0c118f$export$8455939b33d2ee90).sectionContent)) sectionContainer = element.parentElement;
                if (sectionContainer == null) return null;
                return Number(sectionContainer.dataset.sectionindex);
            }
        }));
    const Root = slots?.root ?? $3ff05f0cbbf29cbd$export$4ee86b293725486c;
    const rootProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRootRef,
            suppressContentEditableWarning: true
        },
        className: classes.root,
        ownerState: {}
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)(Root, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, rootProps, {
        children: rootProps.contentEditable ? elements.map(({ content: content, before: before, after: after })=>`${before.children}${content.children}${after.children}`).join("") : /*#__PURE__*/ (0, $3Py8h.jsx)($1T1QG.Fragment, {
            children: elements.map((element, elementIndex)=>/*#__PURE__*/ (0, $3Py8h.jsx)($3ff05f0cbbf29cbd$var$PickersSection, {
                    slots: slots,
                    slotProps: slotProps,
                    element: element,
                    classes: classes
                }, elementIndex))
        })
    }));
});



var $3Py8h = parcelRequire("3Py8h");
const $cb5c631d483e2ce9$var$_excluded = [
    "elements",
    "areAllSectionsEmpty",
    "defaultValue",
    "label",
    "value",
    "onChange",
    "id",
    "autoFocus",
    "endAdornment",
    "startAdornment",
    "renderSuffix",
    "slots",
    "slotProps",
    "contentEditable",
    "tabIndex",
    "onInput",
    "onPaste",
    "onKeyDown",
    "fullWidth",
    "name",
    "readOnly",
    "inputProps",
    "inputRef",
    "sectionListRef"
];
const $cb5c631d483e2ce9$var$round = (value)=>Math.round(value * 1e5) / 1e5;
const $cb5c631d483e2ce9$export$ddc18880178d980e = (0, $npagc.default)("div", {
    name: "MuiPickersInputBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        cursor: "text",
        padding: 0,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        letterSpacing: `${$cb5c631d483e2ce9$var$round(0.15 / 16)}em`,
        variants: [
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: "100%"
                }
            }
        ]
    }));
const $cb5c631d483e2ce9$export$52f3fbbfe9321824 = (0, $npagc.default)((0, $3ff05f0cbbf29cbd$export$4ee86b293725486c), {
    name: "MuiPickersInputBase",
    slot: "SectionsContainer",
    overridesResolver: (props, styles)=>styles.sectionsContainer
})(({ theme: theme })=>({
        padding: "4px 0 5px",
        fontFamily: theme.typography.fontFamily,
        fontSize: "inherit",
        lineHeight: "1.4375em",
        // 23px
        flexGrow: 1,
        outline: "none",
        display: "flex",
        flexWrap: "nowrap",
        overflow: "hidden",
        letterSpacing: "inherit",
        // Baseline behavior
        width: "182px",
        variants: [
            {
                props: {
                    isRtl: true
                },
                style: {
                    textAlign: "right /*! @noflip */"
                }
            },
            {
                props: {
                    size: "small"
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: {
                    adornedStart: false,
                    focused: false,
                    filled: false
                },
                style: {
                    color: "currentColor",
                    opacity: 0
                }
            },
            {
                // Can't use the object notation because label can be null or undefined
                props: ({ adornedStart: adornedStart, focused: focused, filled: filled, label: label })=>!adornedStart && !focused && !filled && label == null,
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: theme.palette.mode === "light" ? 0.42 : 0.5
                }
            }
        ]
    }));
const $cb5c631d483e2ce9$var$PickersInputBaseSection = (0, $npagc.default)((0, $3ff05f0cbbf29cbd$export$30e7187e386feb4f), {
    name: "MuiPickersInputBase",
    slot: "Section",
    overridesResolver: (props, styles)=>styles.section
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: "inherit",
        letterSpacing: "inherit",
        lineHeight: "1.4375em",
        // 23px
        display: "flex"
    }));
const $cb5c631d483e2ce9$var$PickersInputBaseSectionContent = (0, $npagc.default)((0, $3ff05f0cbbf29cbd$export$1f2c61561fe3d6), {
    name: "MuiPickersInputBase",
    slot: "SectionContent",
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        lineHeight: "1.4375em",
        // 23px
        letterSpacing: "inherit",
        width: "fit-content",
        outline: "none"
    }));
const $cb5c631d483e2ce9$var$PickersInputBaseSectionSeparator = (0, $npagc.default)((0, $3ff05f0cbbf29cbd$export$c403b59604f63120), {
    name: "MuiPickersInputBase",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})(()=>({
        whiteSpace: "pre",
        letterSpacing: "inherit"
    }));
const $cb5c631d483e2ce9$var$PickersInputBaseInput = (0, $npagc.default)("input", {
    name: "MuiPickersInputBase",
    slot: "Input",
    overridesResolver: (props, styles)=>styles.hiddenInput
})((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, (0, $b922239ff06fa2ab$export$2e2bcd8739ae039)));
const $cb5c631d483e2ce9$var$useUtilityClasses = (ownerState)=>{
    const { focused: focused, disabled: disabled, error: error, classes: classes, fullWidth: fullWidth, readOnly: readOnly, color: color, size: size, endAdornment: endAdornment, startAdornment: startAdornment } = ownerState;
    const slots = {
        root: [
            "root",
            focused && !disabled && "focused",
            disabled && "disabled",
            readOnly && "readOnly",
            error && "error",
            fullWidth && "fullWidth",
            `color${(0, $3dbd1d1246ec9038$export$2e2bcd8739ae039)(color)}`,
            size === "small" && "inputSizeSmall",
            Boolean(startAdornment) && "adornedStart",
            Boolean(endAdornment) && "adornedEnd"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ],
        sectionsContainer: [
            "sectionsContainer"
        ],
        sectionContent: [
            "sectionContent"
        ],
        sectionBefore: [
            "sectionBefore"
        ],
        sectionAfter: [
            "sectionAfter"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $5cf63e52e1c03fa0$export$3821cb625ac26962), classes);
};
/**
 * @ignore - internal component.
 */ const $cb5c631d483e2ce9$export$ff827734ba831074 = /*#__PURE__*/ $1T1QG.forwardRef(function PickersInputBase(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersInputBase"
    });
    const { elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, value: value, onChange: onChange, id: id, endAdornment: endAdornment, startAdornment: startAdornment, renderSuffix: renderSuffix, slots: slots, slotProps: slotProps, contentEditable: contentEditable, tabIndex: tabIndex, onInput: onInput, onPaste: onPaste, onKeyDown: onKeyDown, name: name, readOnly: readOnly, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $cb5c631d483e2ce9$var$_excluded);
    const rootRef = $1T1QG.useRef(null);
    const handleRootRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(ref, rootRef);
    const handleInputRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(inputProps?.ref, inputRef);
    const isRtl = (0, $a69327a401bfde77$export$b2dd014b6c321cb)();
    const muiFormControl = (0, $83a17b5295da3528$export$2e2bcd8739ae039)();
    if (!muiFormControl) throw new Error("MUI X: PickersInputBase should always be used inside a PickersTextField component");
    const handleInputFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (muiFormControl.disabled) {
            event.stopPropagation();
            return;
        }
        muiFormControl.onFocus?.(event);
    };
    $1T1QG.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    $1T1QG.useEffect(()=>{
        if (!muiFormControl) return;
        if (areAllSectionsEmpty) muiFormControl.onEmpty();
        else muiFormControl.onFilled();
    }, [
        muiFormControl,
        areAllSectionsEmpty
    ]);
    const ownerState = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, muiFormControl, {
        isRtl: isRtl
    });
    const classes = $cb5c631d483e2ce9$var$useUtilityClasses(ownerState);
    const InputRoot = slots?.root || $cb5c631d483e2ce9$export$ddc18880178d980e;
    const inputRootProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: InputRoot,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            "aria-invalid": muiFormControl.error,
            ref: handleRootRef
        },
        className: classes.root,
        ownerState: ownerState
    });
    const InputSectionsContainer = slots?.input || $cb5c631d483e2ce9$export$52f3fbbfe9321824;
    return /*#__PURE__*/ (0, $3Py8h.jsxs)(InputRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, inputRootProps, {
        children: [
            startAdornment,
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3ff05f0cbbf29cbd$export$847fd4b97819700), {
                sectionListRef: sectionListRef,
                elements: elements,
                contentEditable: contentEditable,
                tabIndex: tabIndex,
                className: classes.sectionsContainer,
                onFocus: handleInputFocus,
                onBlur: muiFormControl.onBlur,
                onInput: onInput,
                onPaste: onPaste,
                onKeyDown: onKeyDown,
                slots: {
                    root: InputSectionsContainer,
                    section: $cb5c631d483e2ce9$var$PickersInputBaseSection,
                    sectionContent: $cb5c631d483e2ce9$var$PickersInputBaseSectionContent,
                    sectionSeparator: $cb5c631d483e2ce9$var$PickersInputBaseSectionSeparator
                },
                slotProps: {
                    root: {
                        ownerState: ownerState
                    },
                    sectionContent: {
                        className: (0, $5cf63e52e1c03fa0$export$f20b5ba262568322).sectionContent
                    },
                    sectionSeparator: ({ position: position })=>({
                            className: position === "before" ? (0, $5cf63e52e1c03fa0$export$f20b5ba262568322).sectionBefore : (0, $5cf63e52e1c03fa0$export$f20b5ba262568322).sectionAfter
                        })
                }
            }),
            endAdornment,
            renderSuffix ? renderSuffix((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, muiFormControl)) : null,
            /*#__PURE__*/ (0, $3Py8h.jsx)($cb5c631d483e2ce9$var$PickersInputBaseInput, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                name: name,
                className: classes.input,
                value: value,
                onChange: onChange,
                id: id,
                "aria-hidden": "true",
                tabIndex: -1,
                readOnly: readOnly,
                required: muiFormControl.required,
                disabled: muiFormControl.disabled
            }, inputProps, {
                ref: handleInputRef
            }))
        ]
    }));
});




var $3Py8h = parcelRequire("3Py8h");
const $bff22a8ccd764820$var$_excluded = [
    "label",
    "autoFocus",
    "ownerState",
    "notched"
];
const $bff22a8ccd764820$var$PickersOutlinedInputRoot = (0, $npagc.default)((0, $cb5c631d483e2ce9$export$ddc18880178d980e), {
    name: "MuiPickersOutlinedInput",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        padding: "0 14px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $d5b047ab83af50e3$export$a7da60486bcc91df).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $d5b047ab83af50e3$export$a7da60486bcc91df).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $d5b047ab83af50e3$export$a7da60486bcc91df).focused} .${(0, $d5b047ab83af50e3$export$a7da60486bcc91df).notchedOutline}`]: {
            borderStyle: "solid",
            borderWidth: 2
        },
        [`&.${(0, $d5b047ab83af50e3$export$a7da60486bcc91df).disabled}`]: {
            [`& .${(0, $d5b047ab83af50e3$export$a7da60486bcc91df).notchedOutline}`]: {
                borderColor: (theme.vars || theme).palette.action.disabled
            },
            "*": {
                color: (theme.vars || theme).palette.action.disabled
            }
        },
        [`&.${(0, $d5b047ab83af50e3$export$a7da60486bcc91df).error} .${(0, $d5b047ab83af50e3$export$a7da60486bcc91df).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        variants: Object.keys((theme.vars ?? theme).palette)// @ts-ignore
        .filter((key)=>(theme.vars ?? theme).palette[key]?.main ?? false).map((color)=>({
                props: {
                    color: color
                },
                style: {
                    [`&.${(0, $d5b047ab83af50e3$export$a7da60486bcc91df).focused}:not(.${(0, $d5b047ab83af50e3$export$a7da60486bcc91df).error}) .${(0, $d5b047ab83af50e3$export$a7da60486bcc91df).notchedOutline}`]: {
                        // @ts-ignore
                        borderColor: (theme.vars || theme).palette[color].main
                    }
                }
            }))
    };
});
const $bff22a8ccd764820$var$PickersOutlinedInputSectionsContainer = (0, $npagc.default)((0, $cb5c631d483e2ce9$export$52f3fbbfe9321824), {
    name: "MuiPickersOutlinedInput",
    slot: "SectionsContainer",
    overridesResolver: (props, styles)=>styles.sectionsContainer
})({
    padding: "16.5px 0",
    variants: [
        {
            props: {
                size: "small"
            },
            style: {
                padding: "8.5px 0"
            }
        }
    ]
});
const $bff22a8ccd764820$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $d5b047ab83af50e3$export$c0dd951a3959ac7f), classes);
    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $bff22a8ccd764820$export$44d4d00edb0c710f = /*#__PURE__*/ $1T1QG.forwardRef(function PickersOutlinedInput(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersOutlinedInput"
    });
    const { label: label, ownerState: ownerStateProp, notched: notched } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $bff22a8ccd764820$var$_excluded);
    const muiFormControl = (0, $83a17b5295da3528$export$2e2bcd8739ae039)();
    const ownerState = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, ownerStateProp, muiFormControl, {
        color: muiFormControl?.color || "primary"
    });
    const classes = $bff22a8ccd764820$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $cb5c631d483e2ce9$export$ff827734ba831074), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        slots: {
            root: $bff22a8ccd764820$var$PickersOutlinedInputRoot,
            input: $bff22a8ccd764820$var$PickersOutlinedInputSectionsContainer
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $2cc3bdd0021f5eaf$export$2e2bcd8739ae039), {
                shrink: Boolean(notched || state.adornedStart || state.focused || state.filled),
                notched: Boolean(notched || state.adornedStart || state.focused || state.filled),
                className: classes.notchedOutline,
                label: label != null && label !== "" && muiFormControl?.required ? /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                }) : label,
                ownerState: ownerState
            })
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$bff22a8ccd764820$export$44d4d00edb0c710f.muiName = "Input";





var $1T1QG = parcelRequire("1T1QG");



var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");
/**
 * @mui/styled-engine v6.1.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $8WG3W = parcelRequire("8WG3W");
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3620cf3bdf043fea$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $357c64242f92185d$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


function $4e414a2d83a85930$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $5b78a83710b79558$var$isDevelopment = false;
var $5b78a83710b79558$var$hyphenateRegex = /[A-Z]|^ms/g;
var $5b78a83710b79558$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $5b78a83710b79558$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $5b78a83710b79558$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $5b78a83710b79558$var$processStyleName = /* #__PURE__ */ (0, $4e414a2d83a85930$export$2e2bcd8739ae039)(function(styleName) {
    return $5b78a83710b79558$var$isCustomProperty(styleName) ? styleName : styleName.replace($5b78a83710b79558$var$hyphenateRegex, "-$&").toLowerCase();
});
var $5b78a83710b79558$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($5b78a83710b79558$var$animationRegex, function(match, p1, p2) {
                $5b78a83710b79558$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $5b78a83710b79558$var$cursor
                };
                return p1;
            });
    }
    if ((0, $357c64242f92185d$export$2e2bcd8739ae039)[key] !== 1 && !$5b78a83710b79558$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $5b78a83710b79558$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $5b78a83710b79558$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $5b78a83710b79558$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $5b78a83710b79558$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $5b78a83710b79558$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $5b78a83710b79558$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $5b78a83710b79558$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $5b78a83710b79558$var$cursor;
                var result = interpolation(mergedProps);
                $5b78a83710b79558$var$cursor = previousCursor;
                return $5b78a83710b79558$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $5b78a83710b79558$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $5b78a83710b79558$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($5b78a83710b79558$var$isProcessableValue(asString)) string += $5b78a83710b79558$var$processStyleName(key) + ":" + $5b78a83710b79558$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $5b78a83710b79558$var$isDevelopment) throw new Error($5b78a83710b79558$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($5b78a83710b79558$var$isProcessableValue(value[_i])) string += $5b78a83710b79558$var$processStyleName(key) + ":" + $5b78a83710b79558$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $5b78a83710b79558$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $5b78a83710b79558$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $5b78a83710b79558$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $5b78a83710b79558$var$cursor;
function $5b78a83710b79558$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $5b78a83710b79558$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $5b78a83710b79558$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $5b78a83710b79558$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $5b78a83710b79558$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $5b78a83710b79558$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $3620cf3bdf043fea$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $5b78a83710b79558$var$cursor
    };
}





function $86008e0ad512f109$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $8WG3W.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $86008e0ad512f109$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $86008e0ad512f109$var$wrapper = [];
function $86008e0ad512f109$export$13a2d3ef13012b32(styles) {
    $86008e0ad512f109$var$wrapper[0] = styles;
    return (0, $5b78a83710b79558$export$6321afa313b251b5)($86008e0ad512f109$var$wrapper);
}


// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function $be5c1449878212ce$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $be5c1449878212ce$var$deepClone(source) {
    if (!$be5c1449878212ce$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $be5c1449878212ce$var$deepClone(source[key]);
    });
    return output;
}
function $be5c1449878212ce$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($be5c1449878212ce$export$53b83ca8eaab0383(target) && $be5c1449878212ce$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if ($be5c1449878212ce$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $be5c1449878212ce$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $be5c1449878212ce$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $be5c1449878212ce$export$53b83ca8eaab0383(source[key]) ? $be5c1449878212ce$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}



var $1891bd26a444b1f3$exports = {};
"use strict";

$1891bd26a444b1f3$exports = (parcelRequire("bVBOL"));


function $380b147201b5d207$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || fallback;
}
function $380b147201b5d207$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $380b147201b5d207$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $380b147201b5d207$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $380b147201b5d207$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $1891bd26a444b1f3$exports.ForwardRef:
            return $380b147201b5d207$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $1891bd26a444b1f3$exports.Memo:
            return $380b147201b5d207$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}



// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $0a0cd239e2461814$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $0a0cd239e2461814$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $0a0cd239e2461814$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5, ...other } = breakpoints;
    const sortedValues = $0a0cd239e2461814$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}



function $2ef0024a50b8bf5a$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith("@container")).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $2ef0024a50b8bf5a$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === "@" || value.startsWith("@") && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $2ef0024a50b8bf5a$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $2ef0024a50b8bf5a$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace("@media", name ? `@container ${name}` : "@container");
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes("not all and")) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or");
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}


const $98088bd63d128350$var$shape = {
    borderRadius: 4
};
var $98088bd63d128350$export$2e2bcd8739ae039 = $98088bd63d128350$var$shape;






function $0154eb9a8de28948$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $be5c1449878212ce$export$2e2bcd8739ae039)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $0154eb9a8de28948$export$2e2bcd8739ae039 = $0154eb9a8de28948$var$merge;



const $2a291fcc752b9357$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $2a291fcc752b9357$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$2a291fcc752b9357$export$68c286be0e7e55b7[key]}px)`
};
const $2a291fcc752b9357$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === "number" ? key : $2a291fcc752b9357$export$68c286be0e7e55b7[key] || key;
                if (typeof result === "number") result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $2a291fcc752b9357$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $2a291fcc752b9357$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $2a291fcc752b9357$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $2ef0024a50b8bf5a$export$77c7c3e357f440e7)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $2ef0024a50b8bf5a$export$10a9745dfa00d15)(theme.containerQueries ? theme : $2a291fcc752b9357$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $2a291fcc752b9357$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $2a291fcc752b9357$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $2a291fcc752b9357$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $0154eb9a8de28948$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $2a291fcc752b9357$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $2a291fcc752b9357$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $2a291fcc752b9357$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $2a291fcc752b9357$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $be5c1449878212ce$export$2e2bcd8739ae039)(prev, next), {});
    return $2a291fcc752b9357$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $2a291fcc752b9357$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $2a291fcc752b9357$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $2a291fcc752b9357$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $2a291fcc752b9357$export$2e2bcd8739ae039 = $2a291fcc752b9357$var$breakpoints;





function $9ac75f09be0d9731$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $9ac75f09be0d9731$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $9ac75f09be0d9731$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $9ac75f09be0d9731$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $9ac75f09be0d9731$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $9ac75f09be0d9731$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $9ac75f09be0d9731$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $3dbd1d1246ec9038$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $2a291fcc752b9357$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $9ac75f09be0d9731$export$2e2bcd8739ae039 = $9ac75f09be0d9731$var$style;



function $f00eb0cb7a0ecc8a$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


const $aee8bb986cd3b310$var$properties = {
    m: "margin",
    p: "padding"
};
const $aee8bb986cd3b310$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $aee8bb986cd3b310$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $aee8bb986cd3b310$var$getCssProperties = (0, $f00eb0cb7a0ecc8a$export$2e2bcd8739ae039)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($aee8bb986cd3b310$var$aliases[prop]) prop = $aee8bb986cd3b310$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $aee8bb986cd3b310$var$properties[a];
    const direction = $aee8bb986cd3b310$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $aee8bb986cd3b310$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $aee8bb986cd3b310$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $aee8bb986cd3b310$var$spacingKeys = [
    ...$aee8bb986cd3b310$export$aab52a0dde05ad8a,
    ...$aee8bb986cd3b310$export$f8397d44f03ab6ad
];
function $aee8bb986cd3b310$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $9ac75f09be0d9731$export$2aa3fd96c49a84a8)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === "number" || typeof themeSpacing === "string") return (val)=>{
        if (typeof val === "string") return val;
        if (typeof themeSpacing === "string") return `calc(${val} * ${themeSpacing})`;
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === "string") return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === "number") return -transformed;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $aee8bb986cd3b310$export$1def6f833384e3d1(theme) {
    return $aee8bb986cd3b310$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $aee8bb986cd3b310$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    return transformer(propValue);
}
function $aee8bb986cd3b310$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $aee8bb986cd3b310$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $aee8bb986cd3b310$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $aee8bb986cd3b310$var$getCssProperties(prop);
    const styleFromPropValue = $aee8bb986cd3b310$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $2a291fcc752b9357$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
}
function $aee8bb986cd3b310$var$style(props, keys) {
    const transformer = $aee8bb986cd3b310$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$aee8bb986cd3b310$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $0154eb9a8de28948$export$2e2bcd8739ae039), {});
}
function $aee8bb986cd3b310$export$7ede87f9b603dd3c(props) {
    return $aee8bb986cd3b310$var$style(props, $aee8bb986cd3b310$export$aab52a0dde05ad8a);
}
$aee8bb986cd3b310$export$7ede87f9b603dd3c.propTypes = {};
$aee8bb986cd3b310$export$7ede87f9b603dd3c.filterProps = $aee8bb986cd3b310$export$aab52a0dde05ad8a;
function $aee8bb986cd3b310$export$6f98e8eaf0be1996(props) {
    return $aee8bb986cd3b310$var$style(props, $aee8bb986cd3b310$export$f8397d44f03ab6ad);
}
$aee8bb986cd3b310$export$6f98e8eaf0be1996.propTypes = {};
$aee8bb986cd3b310$export$6f98e8eaf0be1996.filterProps = $aee8bb986cd3b310$export$f8397d44f03ab6ad;
function $aee8bb986cd3b310$var$spacing(props) {
    return $aee8bb986cd3b310$var$style(props, $aee8bb986cd3b310$var$spacingKeys);
}
$aee8bb986cd3b310$var$spacing.propTypes = {};
$aee8bb986cd3b310$var$spacing.filterProps = $aee8bb986cd3b310$var$spacingKeys;
var $aee8bb986cd3b310$export$2e2bcd8739ae039 = $aee8bb986cd3b310$var$spacing;


function $637c1a7fe0058e3e$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $aee8bb986cd3b310$export$1def6f833384e3d1)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}











function $d69b1ba2be43cc82$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $0154eb9a8de28948$export$2e2bcd8739ae039)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $d69b1ba2be43cc82$export$2e2bcd8739ae039 = $d69b1ba2be43cc82$var$compose;




function $cb89ae44c7379b40$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $cb89ae44c7379b40$var$createBorderStyle(prop, transform) {
    return (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $cb89ae44c7379b40$export$1edee58a52776cd9 = $cb89ae44c7379b40$var$createBorderStyle("border", $cb89ae44c7379b40$export$34e2febe53ae29cc);
const $cb89ae44c7379b40$export$f9a7b6bd24892946 = $cb89ae44c7379b40$var$createBorderStyle("borderTop", $cb89ae44c7379b40$export$34e2febe53ae29cc);
const $cb89ae44c7379b40$export$5abca33e6be905d2 = $cb89ae44c7379b40$var$createBorderStyle("borderRight", $cb89ae44c7379b40$export$34e2febe53ae29cc);
const $cb89ae44c7379b40$export$e2ce9f12a980a822 = $cb89ae44c7379b40$var$createBorderStyle("borderBottom", $cb89ae44c7379b40$export$34e2febe53ae29cc);
const $cb89ae44c7379b40$export$47658cca1a909427 = $cb89ae44c7379b40$var$createBorderStyle("borderLeft", $cb89ae44c7379b40$export$34e2febe53ae29cc);
const $cb89ae44c7379b40$export$e7fb0694ba2404fc = $cb89ae44c7379b40$var$createBorderStyle("borderColor");
const $cb89ae44c7379b40$export$126a92c968acdb85 = $cb89ae44c7379b40$var$createBorderStyle("borderTopColor");
const $cb89ae44c7379b40$export$85cc51cb8fbb8c0e = $cb89ae44c7379b40$var$createBorderStyle("borderRightColor");
const $cb89ae44c7379b40$export$340b0327727f6d1a = $cb89ae44c7379b40$var$createBorderStyle("borderBottomColor");
const $cb89ae44c7379b40$export$60beef91a985b4bf = $cb89ae44c7379b40$var$createBorderStyle("borderLeftColor");
const $cb89ae44c7379b40$export$f9258c55612cbed7 = $cb89ae44c7379b40$var$createBorderStyle("outline", $cb89ae44c7379b40$export$34e2febe53ae29cc);
const $cb89ae44c7379b40$export$621fe586efeb64b9 = $cb89ae44c7379b40$var$createBorderStyle("outlineColor");
const $cb89ae44c7379b40$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $aee8bb986cd3b310$export$cb5ee237cce814a2)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $aee8bb986cd3b310$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $2a291fcc752b9357$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$cb89ae44c7379b40$export$7a57f79000377ca2.propTypes = {};
$cb89ae44c7379b40$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $cb89ae44c7379b40$var$borders = (0, $d69b1ba2be43cc82$export$2e2bcd8739ae039)($cb89ae44c7379b40$export$1edee58a52776cd9, $cb89ae44c7379b40$export$f9a7b6bd24892946, $cb89ae44c7379b40$export$5abca33e6be905d2, $cb89ae44c7379b40$export$e2ce9f12a980a822, $cb89ae44c7379b40$export$47658cca1a909427, $cb89ae44c7379b40$export$e7fb0694ba2404fc, $cb89ae44c7379b40$export$126a92c968acdb85, $cb89ae44c7379b40$export$85cc51cb8fbb8c0e, $cb89ae44c7379b40$export$340b0327727f6d1a, $cb89ae44c7379b40$export$60beef91a985b4bf, $cb89ae44c7379b40$export$7a57f79000377ca2, $cb89ae44c7379b40$export$f9258c55612cbed7, $cb89ae44c7379b40$export$621fe586efeb64b9);
var $cb89ae44c7379b40$export$2e2bcd8739ae039 = $cb89ae44c7379b40$var$borders;







const $0cb84319aa6847b4$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $aee8bb986cd3b310$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $aee8bb986cd3b310$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $2a291fcc752b9357$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$0cb84319aa6847b4$export$5df9adcb0db95e1e.propTypes = {};
$0cb84319aa6847b4$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $0cb84319aa6847b4$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $aee8bb986cd3b310$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $aee8bb986cd3b310$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $2a291fcc752b9357$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$0cb84319aa6847b4$export$ec60d70ff941a580.propTypes = {};
$0cb84319aa6847b4$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $0cb84319aa6847b4$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $aee8bb986cd3b310$export$cb5ee237cce814a2)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $aee8bb986cd3b310$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $2a291fcc752b9357$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$0cb84319aa6847b4$export$8a833ffa5f5dbeda.propTypes = {};
$0cb84319aa6847b4$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $0cb84319aa6847b4$export$baf44164ca3a34e8 = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "gridColumn"
});
const $0cb84319aa6847b4$export$8f7213a1cd01e832 = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "gridRow"
});
const $0cb84319aa6847b4$export$b0e0abbc49ba668 = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "gridAutoFlow"
});
const $0cb84319aa6847b4$export$bcd8b929d4b4142 = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "gridAutoColumns"
});
const $0cb84319aa6847b4$export$e5039a674e14c828 = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "gridAutoRows"
});
const $0cb84319aa6847b4$export$42bd9088661ffb03 = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "gridTemplateColumns"
});
const $0cb84319aa6847b4$export$920682ae05b999bc = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "gridTemplateRows"
});
const $0cb84319aa6847b4$export$1b88fbdd482fd33a = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "gridTemplateAreas"
});
const $0cb84319aa6847b4$export$bdb486e40d52d26f = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "gridArea"
});
const $0cb84319aa6847b4$var$grid = (0, $d69b1ba2be43cc82$export$2e2bcd8739ae039)($0cb84319aa6847b4$export$5df9adcb0db95e1e, $0cb84319aa6847b4$export$ec60d70ff941a580, $0cb84319aa6847b4$export$8a833ffa5f5dbeda, $0cb84319aa6847b4$export$baf44164ca3a34e8, $0cb84319aa6847b4$export$8f7213a1cd01e832, $0cb84319aa6847b4$export$b0e0abbc49ba668, $0cb84319aa6847b4$export$bcd8b929d4b4142, $0cb84319aa6847b4$export$e5039a674e14c828, $0cb84319aa6847b4$export$42bd9088661ffb03, $0cb84319aa6847b4$export$920682ae05b999bc, $0cb84319aa6847b4$export$1b88fbdd482fd33a, $0cb84319aa6847b4$export$bdb486e40d52d26f);
var $0cb84319aa6847b4$export$2e2bcd8739ae039 = $0cb84319aa6847b4$var$grid;




function $25fb7564ec746a3b$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $25fb7564ec746a3b$export$35e9368ef982300f = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "color",
    themeKey: "palette",
    transform: $25fb7564ec746a3b$export$dbaffd4420ea0ac6
});
const $25fb7564ec746a3b$export$2506f56c10355b33 = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $25fb7564ec746a3b$export$dbaffd4420ea0ac6
});
const $25fb7564ec746a3b$export$8c5a050822fd698c = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $25fb7564ec746a3b$export$dbaffd4420ea0ac6
});
const $25fb7564ec746a3b$var$palette = (0, $d69b1ba2be43cc82$export$2e2bcd8739ae039)($25fb7564ec746a3b$export$35e9368ef982300f, $25fb7564ec746a3b$export$2506f56c10355b33, $25fb7564ec746a3b$export$8c5a050822fd698c);
var $25fb7564ec746a3b$export$2e2bcd8739ae039 = $25fb7564ec746a3b$var$palette;





function $58fe803f173cba0c$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $58fe803f173cba0c$export$7e3df82ee760448c = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "width",
    transform: $58fe803f173cba0c$export$8afece71750ec241
});
const $58fe803f173cba0c$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $2a291fcc752b9357$export$68c286be0e7e55b7)[propValue];
            if (!breakpoint) return {
                maxWidth: $58fe803f173cba0c$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $2a291fcc752b9357$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$58fe803f173cba0c$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $58fe803f173cba0c$export$ee148fbbe8357dd2 = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "minWidth",
    transform: $58fe803f173cba0c$export$8afece71750ec241
});
const $58fe803f173cba0c$export$ac607276a8fe9f0a = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "height",
    transform: $58fe803f173cba0c$export$8afece71750ec241
});
const $58fe803f173cba0c$export$dc0d8bd0b94f8570 = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "maxHeight",
    transform: $58fe803f173cba0c$export$8afece71750ec241
});
const $58fe803f173cba0c$export$a43cf604e12f3b17 = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "minHeight",
    transform: $58fe803f173cba0c$export$8afece71750ec241
});
const $58fe803f173cba0c$export$ffed9f14fb65e276 = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "width",
    transform: $58fe803f173cba0c$export$8afece71750ec241
});
const $58fe803f173cba0c$export$905076ed6620e671 = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "size",
    cssProperty: "height",
    transform: $58fe803f173cba0c$export$8afece71750ec241
});
const $58fe803f173cba0c$export$6ccc93f785106a58 = (0, $9ac75f09be0d9731$export$2e2bcd8739ae039)({
    prop: "boxSizing"
});
const $58fe803f173cba0c$var$sizing = (0, $d69b1ba2be43cc82$export$2e2bcd8739ae039)($58fe803f173cba0c$export$7e3df82ee760448c, $58fe803f173cba0c$export$488fda99655ff65a, $58fe803f173cba0c$export$ee148fbbe8357dd2, $58fe803f173cba0c$export$ac607276a8fe9f0a, $58fe803f173cba0c$export$dc0d8bd0b94f8570, $58fe803f173cba0c$export$a43cf604e12f3b17, $58fe803f173cba0c$export$6ccc93f785106a58);
var $58fe803f173cba0c$export$2e2bcd8739ae039 = $58fe803f173cba0c$var$sizing;


const $f0520a57143ce906$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $cb89ae44c7379b40$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $cb89ae44c7379b40$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $cb89ae44c7379b40$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $cb89ae44c7379b40$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $cb89ae44c7379b40$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $cb89ae44c7379b40$export$34e2febe53ae29cc)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $cb89ae44c7379b40$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $25fb7564ec746a3b$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $25fb7564ec746a3b$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $25fb7564ec746a3b$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $aee8bb986cd3b310$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $aee8bb986cd3b310$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $0cb84319aa6847b4$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $0cb84319aa6847b4$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $0cb84319aa6847b4$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $58fe803f173cba0c$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $58fe803f173cba0c$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $58fe803f173cba0c$export$8afece71750ec241)
    },
    height: {
        transform: (0, $58fe803f173cba0c$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $58fe803f173cba0c$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $58fe803f173cba0c$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: "font"
    },
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $f0520a57143ce906$export$2e2bcd8739ae039 = $f0520a57143ce906$var$defaultSxConfig;


function $9906c9a64bb3198c$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $9906c9a64bb3198c$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $9906c9a64bb3198c$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $9ac75f09be0d9731$export$2aa3fd96c49a84a8)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $9ac75f09be0d9731$export$741ad47189a64aa0)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $9ac75f09be0d9731$export$741ad47189a64aa0)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $3dbd1d1246ec9038$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $2a291fcc752b9357$export$88347efdb2e19abd)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $f0520a57143ce906$export$2e2bcd8739ae039);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $2a291fcc752b9357$export$1f2600516e91381f)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $9906c9a64bb3198c$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $0154eb9a8de28948$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $2a291fcc752b9357$export$88347efdb2e19abd)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($9906c9a64bb3198c$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $0154eb9a8de28948$export$2e2bcd8739ae039)(css, breakpointsValues);
                        }
                    } else css = (0, $0154eb9a8de28948$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $2ef0024a50b8bf5a$export$456f6c1142f990db)(theme, (0, $2a291fcc752b9357$export$8922c90b6e020726)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $9906c9a64bb3198c$var$styleFunctionSx = $9906c9a64bb3198c$export$7d53d8bf2911e013();
$9906c9a64bb3198c$var$styleFunctionSx.filterProps = [
    "sx"
];
var $9906c9a64bb3198c$export$2e2bcd8739ae039 = $9906c9a64bb3198c$var$styleFunctionSx;



/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $4887192df78840a9$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== "function") return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === "&") return styles;
        if (selector.includes("data-") || selector.includes(".")) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, "")}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}


function $edc606fc0913240b$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $0a0cd239e2461814$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $637c1a7fe0058e3e$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $be5c1449878212ce$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: {
            mode: "light",
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $98088bd63d128350$export$2e2bcd8739ae039),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $2ef0024a50b8bf5a$export$2e2bcd8739ae039)(muiTheme);
    muiTheme.applyStyles = (0, $4887192df78840a9$export$2e2bcd8739ae039);
    muiTheme = args.reduce((acc, argument)=>(0, $be5c1449878212ce$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $f0520a57143ce906$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $9906c9a64bb3198c$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $edc606fc0913240b$export$2e2bcd8739ae039 = $edc606fc0913240b$var$createTheme;




function $08143462b9d167d0$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $86008e0ad512f109$export$13a2d3ef13012b32)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== "function") variant.style = (0, $86008e0ad512f109$export$13a2d3ef13012b32)(variant.style);
    });
    return result;
}


const $9ac0059b52a88c90$export$35e57303dbd8a66 = (0, $edc606fc0913240b$export$2e2bcd8739ae039)();
function $9ac0059b52a88c90$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
function $9ac0059b52a88c90$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $9ac0059b52a88c90$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $9ac0059b52a88c90$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $9ac0059b52a88c90$var$processStyle(props, style) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === "function" ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$9ac0059b52a88c90$var$processStyle(props, subStyle));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = otherStyles;
        }
        return $9ac0059b52a88c90$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ]);
    }
    if (resolvedStyle?.isProcessed) return resolvedStyle.style;
    return resolvedStyle;
}
function $9ac0059b52a88c90$var$processStyleVariants(props, variants, results = []) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === "function") {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === "function") {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(variant.style(mergedState));
        } else results.push(variant.style);
    }
    return results;
}
function $9ac0059b52a88c90$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $9ac0059b52a88c90$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $9ac0059b52a88c90$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $9ac0059b52a88c90$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $9ac0059b52a88c90$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $86008e0ad512f109$export$592c7226e4cb0171)(tag, (styles)=>styles.filter((style)=>style !== (0, $9906c9a64bb3198c$export$2e2bcd8739ae039)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $9ac0059b52a88c90$var$defaultOverridesResolver($9ac0059b52a88c90$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $9ac0059b52a88c90$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($9ac0059b52a88c90$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $86008e0ad512f109$export$2e2bcd8739ae039)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $9ac0059b52a88c90$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof style === "function" && style.__emotion_real !== style) return function styleFunctionProcessor(props) {
                return $9ac0059b52a88c90$var$processStyle(props, style);
            };
            if ((0, $be5c1449878212ce$export$53b83ca8eaab0383)(style)) {
                const serialized = (0, $08143462b9d167d0$export$2e2bcd8739ae039)(style);
                if (!serialized.variants) return serialized.style;
                return function styleObjectProcessor(props) {
                    return $9ac0059b52a88c90$var$processStyle(props, serialized);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $9ac0059b52a88c90$var$processStyle(props, styleOverrides[slotKey]);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $9ac0059b52a88c90$var$processStyleVariants(props, themeVariants);
            });
            if (!skipSx) expressionsTail.push((0, $9906c9a64bb3198c$export$2e2bcd8739ae039));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill("");
                const placeholdersTail = new Array(expressionsTail.length).fill("");
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $9ac0059b52a88c90$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $3dbd1d1246ec9038$export$2e2bcd8739ae039)(componentSlot || "")}`;
    return `Styled(${(0, $380b147201b5d207$export$2e2bcd8739ae039)(tag)})`;
}
function $9ac0059b52a88c90$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $9ac0059b52a88c90$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $9ac0059b52a88c90$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $9ac0059b52a88c90$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}








function $6109aaebdb3df086$export$6cb188bdacb35d0e(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiPickersFilledInput", slot);
}
const $6109aaebdb3df086$export$3964d3188824d772 = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, (0, $5cf63e52e1c03fa0$export$f20b5ba262568322), (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiPickersFilledInput", [
    "root",
    "underline",
    "input"
]));





var $3Py8h = parcelRequire("3Py8h");
const $45090804bb39327d$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState"
];
const $45090804bb39327d$var$PickersFilledInputRoot = (0, $npagc.default)((0, $cb5c631d483e2ce9$export$ddc18880178d980e), {
    name: "MuiPickersFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $9ac0059b52a88c90$export$3ba67b570e26eea0)(prop) && prop !== "disableUnderline"
})(({ theme: theme })=>{
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $6109aaebdb3df086$export$3964d3188824d772).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $6109aaebdb3df086$export$3964d3188824d772).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        "&::after": {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    "&::after": {
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: "absolute",
                        right: 0,
                        transform: "scaleX(0)",
                        transition: theme.transitions.create("transform", {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&.${(0, $6109aaebdb3df086$export$3964d3188824d772).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: "scaleX(1) translateX(0)"
                    },
                    [`&.${(0, $6109aaebdb3df086$export$3964d3188824d772).error}`]: {
                        "&:before, &:after": {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    "&::before": {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: "absolute",
                        right: 0,
                        transition: theme.transitions.create("border-bottom-color", {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $6109aaebdb3df086$export$3964d3188824d772).disabled}, .${(0, $6109aaebdb3df086$export$3964d3188824d772).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $6109aaebdb3df086$export$3964d3188824d772).disabled}:before`]: {
                        borderBottomStyle: "dotted"
                    }
                }
            },
            {
                props: ({ startAdornment: startAdornment })=>!!startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ endAdornment: endAdornment })=>!!endAdornment,
                style: {
                    paddingRight: 12
                }
            }
        ]
    };
});
const $45090804bb39327d$var$PickersFilledSectionsContainer = (0, $npagc.default)((0, $cb5c631d483e2ce9$export$52f3fbbfe9321824), {
    name: "MuiPickersFilledInput",
    slot: "sectionsContainer",
    overridesResolver: (props, styles)=>styles.sectionsContainer
})({
    paddingTop: 25,
    paddingRight: 12,
    paddingBottom: 8,
    paddingLeft: 12,
    variants: [
        {
            props: {
                size: "small"
            },
            style: {
                paddingTop: 21,
                paddingBottom: 4
            }
        },
        {
            props: ({ startAdornment: startAdornment })=>!!startAdornment,
            style: {
                paddingLeft: 0
            }
        },
        {
            props: ({ endAdornment: endAdornment })=>!!endAdornment,
            style: {
                paddingRight: 0
            }
        },
        {
            props: {
                hiddenLabel: true
            },
            style: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        {
            props: {
                hiddenLabel: true,
                size: "small"
            },
            style: {
                paddingTop: 8,
                paddingBottom: 9
            }
        }
    ]
});
const $45090804bb39327d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $6109aaebdb3df086$export$6cb188bdacb35d0e), classes);
    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $45090804bb39327d$export$8cc8c624890b5045 = /*#__PURE__*/ $1T1QG.forwardRef(function PickersFilledInput(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersFilledInput"
    });
    const { label: label, disableUnderline: disableUnderline = false, ownerState: ownerStateProp } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $45090804bb39327d$var$_excluded);
    const muiFormControl = (0, $83a17b5295da3528$export$2e2bcd8739ae039)();
    const ownerState = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, ownerStateProp, muiFormControl, {
        color: muiFormControl?.color || "primary"
    });
    const classes = $45090804bb39327d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $cb5c631d483e2ce9$export$ff827734ba831074), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        slots: {
            root: $45090804bb39327d$var$PickersFilledInputRoot,
            input: $45090804bb39327d$var$PickersFilledSectionsContainer
        },
        slotProps: {
            root: {
                disableUnderline: disableUnderline
            }
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$45090804bb39327d$export$8cc8c624890b5045.muiName = "Input";





var $1T1QG = parcelRequire("1T1QG");



var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");






function $6164f8f4de653529$export$defbb17803ff7cff(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiPickersFilledInput", slot);
}
const $6164f8f4de653529$export$f5c5ba079c8bb9dd = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, (0, $5cf63e52e1c03fa0$export$f20b5ba262568322), (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiPickersInput", [
    "root",
    "input"
]));





var $3Py8h = parcelRequire("3Py8h");
const $2280032c9bbde44e$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState"
];
const $2280032c9bbde44e$var$PickersInputRoot = (0, $npagc.default)((0, $cb5c631d483e2ce9$export$ddc18880178d980e), {
    name: "MuiPickersInput",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        "label + &": {
            marginTop: 16
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        color: color
                    },
                    style: {
                        "&::after": {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    "&::after": {
                        background: "red",
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: "absolute",
                        right: 0,
                        transform: "scaleX(0)",
                        transition: theme.transitions.create("transform", {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&.${(0, $6164f8f4de653529$export$f5c5ba079c8bb9dd).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: "scaleX(1) translateX(0)"
                    },
                    [`&.${(0, $6164f8f4de653529$export$f5c5ba079c8bb9dd).error}`]: {
                        "&:before, &:after": {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    "&::before": {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: "absolute",
                        right: 0,
                        transition: theme.transitions.create("border-bottom-color", {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: "none" // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $6164f8f4de653529$export$f5c5ba079c8bb9dd).disabled}, .${(0, $6164f8f4de653529$export$f5c5ba079c8bb9dd).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        "@media (hover: none)": {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $6164f8f4de653529$export$f5c5ba079c8bb9dd).disabled}:before`]: {
                        borderBottomStyle: "dotted"
                    }
                }
            }
        ]
    };
});
const $2280032c9bbde44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $6164f8f4de653529$export$defbb17803ff7cff), classes);
    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $2280032c9bbde44e$export$7c4ebb2cfaf4f474 = /*#__PURE__*/ $1T1QG.forwardRef(function PickersInput(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersInput"
    });
    const { label: label, disableUnderline: disableUnderline = false, ownerState: ownerStateProp } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $2280032c9bbde44e$var$_excluded);
    const muiFormControl = (0, $83a17b5295da3528$export$2e2bcd8739ae039)();
    const ownerState = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, ownerStateProp, muiFormControl, {
        disableUnderline: disableUnderline,
        color: muiFormControl?.color || "primary"
    });
    const classes = $2280032c9bbde44e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $cb5c631d483e2ce9$export$ff827734ba831074), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        slots: {
            root: $2280032c9bbde44e$var$PickersInputRoot
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$2280032c9bbde44e$export$7c4ebb2cfaf4f474.muiName = "Input";



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $8ca8fdc28774020c$var$_excluded = [
    "onFocus",
    "onBlur",
    "className",
    "color",
    "disabled",
    "error",
    "variant",
    "required",
    "InputProps",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "elements",
    "areAllSectionsEmpty",
    "onClick",
    "onKeyDown",
    "onKeyUp",
    "onPaste",
    "onInput",
    "endAdornment",
    "startAdornment",
    "tabIndex",
    "contentEditable",
    "focused",
    "value",
    "onChange",
    "fullWidth",
    "id",
    "name",
    "helperText",
    "FormHelperTextProps",
    "label",
    "InputLabelProps"
];
const $8ca8fdc28774020c$var$VARIANT_COMPONENT = {
    standard: (0, $2280032c9bbde44e$export$7c4ebb2cfaf4f474),
    filled: (0, $45090804bb39327d$export$8cc8c624890b5045),
    outlined: (0, $bff22a8ccd764820$export$44d4d00edb0c710f)
};
const $8ca8fdc28774020c$var$PickersTextFieldRoot = (0, $npagc.default)((0, $7c26d84ab517f189$export$2e2bcd8739ae039), {
    name: "MuiPickersTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $8ca8fdc28774020c$var$useUtilityClasses = (ownerState)=>{
    const { focused: focused, disabled: disabled, classes: classes, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            focused && !disabled && "focused",
            disabled && "disabled",
            required && "required"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $6e78dc27ae86ac8a$export$d99678ed7aad1677), classes);
};
const $8ca8fdc28774020c$export$b3e9b101d92e4d4d = /*#__PURE__*/ $1T1QG.forwardRef(function PickersTextField(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersTextField"
    });
    const { onFocus: // Props used by FormControl
    onFocus, onBlur: onBlur, className: className, color: color = "primary", disabled: disabled = false, error: error = false, variant: variant = "outlined", required: required = false, InputProps: // Props used by PickersInput
    InputProps, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef, elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onPaste: onPaste, onInput: onInput, endAdornment: endAdornment, startAdornment: startAdornment, tabIndex: tabIndex, contentEditable: contentEditable, focused: focused, value: value, onChange: onChange, fullWidth: fullWidth, id: idProp, name: name, helperText: // Props used by FormHelperText
    helperText, FormHelperTextProps: FormHelperTextProps, label: // Props used by InputLabel
    label, InputLabelProps: InputLabelProps } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $8ca8fdc28774020c$var$_excluded);
    const rootRef = $1T1QG.useRef(null);
    const handleRootRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(ref, rootRef);
    const id = (0, $ea1f3283f0dc1f21$export$2e2bcd8739ae039)(idProp);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const ownerState = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, {
        color: color,
        disabled: disabled,
        error: error,
        focused: focused,
        required: required,
        variant: variant
    });
    const classes = $8ca8fdc28774020c$var$useUtilityClasses(ownerState);
    const PickersInputComponent = $8ca8fdc28774020c$var$VARIANT_COMPONENT[variant];
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($8ca8fdc28774020c$var$PickersTextFieldRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ref: handleRootRef,
        focused: focused,
        onFocus: onFocus,
        onBlur: onBlur,
        disabled: disabled,
        variant: variant,
        error: error,
        color: color,
        fullWidth: fullWidth,
        required: required,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f4e04526214b55b7$export$2e2bcd8739ae039), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            /*#__PURE__*/ (0, $3Py8h.jsx)(PickersInputComponent, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                elements: elements,
                areAllSectionsEmpty: areAllSectionsEmpty,
                onClick: onClick,
                onKeyDown: onKeyDown,
                onKeyUp: onKeyUp,
                onInput: onInput,
                onPaste: onPaste,
                endAdornment: endAdornment,
                startAdornment: startAdornment,
                tabIndex: tabIndex,
                contentEditable: contentEditable,
                value: value,
                onChange: onChange,
                id: id,
                fullWidth: fullWidth,
                inputProps: inputProps,
                inputRef: inputRef,
                sectionListRef: sectionListRef,
                label: label,
                name: name,
                role: "group",
                "aria-labelledby": inputLabelId
            }, InputProps)),
            helperText && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $801159818e7707d0$export$2e2bcd8739ae039), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});




const $3720a86516927ef9$var$_excluded = [
    "enableAccessibleFieldDOMStructure"
], $3720a86516927ef9$var$_excluded2 = [
    "InputProps",
    "readOnly"
], $3720a86516927ef9$var$_excluded3 = [
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly",
    "InputProps",
    "inputProps",
    "inputRef"
];
const $3720a86516927ef9$export$20bf15d9b24b4dad = (_ref)=>{
    let { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure } = _ref, fieldResponse = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_ref, $3720a86516927ef9$var$_excluded);
    if (enableAccessibleFieldDOMStructure) {
        const { InputProps: InputProps, readOnly: readOnly } = fieldResponse, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(fieldResponse, $3720a86516927ef9$var$_excluded2);
        return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, other, {
            InputProps: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, InputProps ?? {}, {
                readOnly: readOnly
            })
        });
    }
    const { onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly, InputProps: InputProps, inputProps: inputProps, inputRef: inputRef } = fieldResponse, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(fieldResponse, $3720a86516927ef9$var$_excluded3);
    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, other, {
        InputProps: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, InputProps ?? {}, {
            readOnly: readOnly
        }),
        inputProps: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, inputProps ?? {}, {
            inputMode: inputMode,
            onPaste: onPaste,
            onKeyDown: onKeyDown,
            ref: inputRef
        })
    });
};



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $53aa224b2d514be5$var$_excluded = [
    "slots",
    "slotProps",
    "InputProps",
    "inputProps"
];
/**
 * Demos:
 *
 * - [DateTimeField](http://mui.com/x/react-date-pickers/date-time-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateTimeField API](https://mui.com/x/api/date-pickers/date-time-field/)
 */ const $53aa224b2d514be5$export$ae1ced156568f0b0 = /*#__PURE__*/ $1T1QG.forwardRef(function DateTimeField(inProps, inRef) {
    const themeProps = (0, $gADeF.default)({
        props: inProps,
        name: "MuiDateTimeField"
    });
    const { slots: slots, slotProps: slotProps, InputProps: InputProps, inputProps: inputProps } = themeProps, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(themeProps, $53aa224b2d514be5$var$_excluded);
    const ownerState = themeProps;
    const TextField = slots?.textField ?? (inProps.enableAccessibleFieldDOMStructure ? (0, $8ca8fdc28774020c$export$b3e9b101d92e4d4d) : (0, $acd1b2a27b331456$export$2e2bcd8739ae039));
    const textFieldProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: TextField,
        externalSlotProps: slotProps?.textField,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: inRef
        }
    });
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, InputProps, textFieldProps.InputProps);
    const fieldResponse = (0, $8d92dc95662a5d59$export$2c2e7f1ceedfa8fa)(textFieldProps);
    const convertedFieldResponse = (0, $3720a86516927ef9$export$20bf15d9b24b4dad)(fieldResponse);
    const processedFieldProps = (0, $ea948cf9ba8223aa$export$db9644cdb7e3d432)((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, convertedFieldResponse, {
        slots: slots,
        slotProps: slotProps
    }));
    return /*#__PURE__*/ (0, $3Py8h.jsx)(TextField, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, processedFieldProps));
});




var $1T1QG = parcelRequire("1T1QG");

var $gADeF = parcelRequire("gADeF");



var $1T1QG = parcelRequire("1T1QG");





var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");




function $e0579d2ce69c7631$export$c994a6b377ce38df(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiDateTimePickerTabs", slot);
}
const $e0579d2ce69c7631$export$a2a6922f6f97d267 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiDateTimePickerTabs", [
    "root"
]);




var $3Py8h = parcelRequire("3Py8h");
"use client";
const $ed9810fa41a895a8$var$viewToTab = (view)=>{
    if ((0, $2c8437f6b047f676$export$b32dfef9f07dea64)(view)) return "date";
    return "time";
};
const $ed9810fa41a895a8$var$tabToView = (tab)=>{
    if (tab === "date") return "day";
    return "hours";
};
const $ed9810fa41a895a8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $e0579d2ce69c7631$export$c994a6b377ce38df), classes);
};
const $ed9810fa41a895a8$var$DateTimePickerTabsRoot = (0, $npagc.default)((0, $448931189ca865c8$export$2e2bcd8739ae039), {
    name: "MuiDateTimePickerTabs",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        boxShadow: `0 -1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
        "&:last-child": {
            boxShadow: `0 1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
            [`& .${(0, $55acd80d8b3e6cb4$export$2e2bcd8739ae039).indicator}`]: {
                bottom: "auto",
                top: 0
            }
        }
    }));
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [DateTimePickerTabs API](https://mui.com/x/api/date-pickers/date-time-picker-tabs/)
 */ const $ed9810fa41a895a8$export$95dfad4074502244 = function DateTimePickerTabs(inProps) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiDateTimePickerTabs"
    });
    const { dateIcon: dateIcon = /*#__PURE__*/ (0, $3Py8h.jsx)((0, $705a86f4b9915dac$export$90a8eab2a2411720), {}), onViewChange: onViewChange, timeIcon: timeIcon = /*#__PURE__*/ (0, $3Py8h.jsx)((0, $705a86f4b9915dac$export$7e95adcf912503e3), {}), view: view, hidden: hidden = typeof window === "undefined" || window.innerHeight < 667, className: className, sx: sx } = props;
    const translations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    const classes = $ed9810fa41a895a8$var$useUtilityClasses(props);
    const handleChange = (event, value)=>{
        onViewChange($ed9810fa41a895a8$var$tabToView(value));
    };
    if (hidden) return null;
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($ed9810fa41a895a8$var$DateTimePickerTabsRoot, {
        ownerState: props,
        variant: "fullWidth",
        value: $ed9810fa41a895a8$var$viewToTab(view),
        onChange: handleChange,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(className, classes.root),
        sx: sx,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e2bf0884486cfd13$export$2e2bcd8739ae039), {
                value: "date",
                "aria-label": translations.dateTableLabel,
                icon: /*#__PURE__*/ (0, $3Py8h.jsx)($1T1QG.Fragment, {
                    children: dateIcon
                })
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e2bf0884486cfd13$export$2e2bcd8739ae039), {
                value: "time",
                "aria-label": translations.timeTableLabel,
                icon: /*#__PURE__*/ (0, $3Py8h.jsx)($1T1QG.Fragment, {
                    children: timeIcon
                })
            })
        ]
    });
};





var $1T1QG = parcelRequire("1T1QG");



var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");





var $1T1QG = parcelRequire("1T1QG");



var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");


function $93b51e4627b2a754$export$2aab7addfa1bc589(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiPickersToolbarText", slot);
}
const $93b51e4627b2a754$export$4ca7b92014bf2e56 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiPickersToolbarText", [
    "root",
    "selected"
]);



var $3Py8h = parcelRequire("3Py8h");
const $9dbd0e4436da1e35$var$_excluded = [
    "className",
    "selected",
    "value"
];
const $9dbd0e4436da1e35$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $93b51e4627b2a754$export$2aab7addfa1bc589), classes);
};
const $9dbd0e4436da1e35$var$PickersToolbarTextRoot = (0, $npagc.default)((0, $a386176d6ca21602$export$2e2bcd8739ae039), {
    name: "MuiPickersToolbarText",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $93b51e4627b2a754$export$4ca7b92014bf2e56).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>({
        transition: theme.transitions.create("color"),
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $93b51e4627b2a754$export$4ca7b92014bf2e56).selected}`]: {
            color: (theme.vars || theme).palette.text.primary
        }
    }));
const $9dbd0e4436da1e35$export$2006bc630443fa2 = /*#__PURE__*/ $1T1QG.forwardRef(function PickersToolbarText(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersToolbarText"
    });
    const { className: className, value: value } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $9dbd0e4436da1e35$var$_excluded);
    const classes = $9dbd0e4436da1e35$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($9dbd0e4436da1e35$var$PickersToolbarTextRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        component: "span"
    }, other, {
        children: value
    }));
});





var $1T1QG = parcelRequire("1T1QG");



var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");


function $580b93f6aa3ab710$export$b109c489973c3d80(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiPickersToolbar", slot);
}
const $580b93f6aa3ab710$export$59f09e5e2b3d9913 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiPickersToolbar", [
    "root",
    "content"
]);



var $3Py8h = parcelRequire("3Py8h");
const $a4249024e74e1302$var$_excluded = [
    "children",
    "className",
    "toolbarTitle",
    "hidden",
    "titleId",
    "isLandscape",
    "classes",
    "landscapeDirection"
];
const $a4249024e74e1302$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        content: [
            "content"
        ],
        penIconButton: [
            "penIconButton",
            isLandscape && "penIconButtonLandscape"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $580b93f6aa3ab710$export$b109c489973c3d80), classes);
};
const $a4249024e74e1302$var$PickersToolbarRoot = (0, $npagc.default)("div", {
    name: "MuiPickersToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "space-between",
        padding: theme.spacing(2, 3),
        variants: [
            {
                props: {
                    isLandscape: true
                },
                style: {
                    height: "auto",
                    maxWidth: 160,
                    padding: 16,
                    justifyContent: "flex-start",
                    flexWrap: "wrap"
                }
            }
        ]
    }));
const $a4249024e74e1302$var$PickersToolbarContent = (0, $npagc.default)("div", {
    name: "MuiPickersToolbar",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})({
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    flex: 1,
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                justifyContent: "flex-start",
                alignItems: "flex-start",
                flexDirection: "column"
            }
        },
        {
            props: {
                isLandscape: true,
                landscapeDirection: "row"
            },
            style: {
                flexDirection: "row"
            }
        }
    ]
});
const $a4249024e74e1302$export$eb3c4d84783d6feb = /*#__PURE__*/ $1T1QG.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersToolbar"
    });
    const { children: children, className: className, toolbarTitle: toolbarTitle, hidden: hidden, titleId: titleId } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $a4249024e74e1302$var$_excluded);
    const ownerState = props;
    const classes = $a4249024e74e1302$var$useUtilityClasses(ownerState);
    if (hidden) return null;
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($a4249024e74e1302$var$PickersToolbarRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a386176d6ca21602$export$2e2bcd8739ae039), {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)($a4249024e74e1302$var$PickersToolbarContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            })
        ]
    }));
});





var $1T1QG = parcelRequire("1T1QG");



var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");




var $3Py8h = parcelRequire("3Py8h");
const $f70eed4fc89c5764$var$_excluded = [
    "align",
    "className",
    "selected",
    "typographyClassName",
    "value",
    "variant",
    "width"
];
const $f70eed4fc89c5764$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $580b93f6aa3ab710$export$b109c489973c3d80), classes);
};
const $f70eed4fc89c5764$var$PickersToolbarButtonRoot = (0, $npagc.default)((0, $c8008865d6db946f$export$2e2bcd8739ae039), {
    name: "MuiPickersToolbarButton",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    padding: 0,
    minWidth: 16,
    textTransform: "none"
});
const $f70eed4fc89c5764$export$614ed940168c780c = /*#__PURE__*/ $1T1QG.forwardRef(function PickersToolbarButton(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersToolbarButton"
    });
    const { align: align, className: className, selected: selected, typographyClassName: typographyClassName, value: value, variant: variant, width: width } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $f70eed4fc89c5764$var$_excluded);
    const classes = $f70eed4fc89c5764$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($f70eed4fc89c5764$var$PickersToolbarButtonRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        variant: "text",
        ref: ref,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className)
    }, width ? {
        sx: {
            width: width
        }
    } : {}, other, {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $9dbd0e4436da1e35$export$2006bc630443fa2), {
            align: align,
            className: typographyClassName,
            variant: variant,
            value: value,
            selected: selected
        })
    }));
});





function $806e73834b16aef9$export$c40f5731216f0c9d(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiDateTimePickerToolbar", slot);
}
const $806e73834b16aef9$export$82ac739c3153ffd4 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiDateTimePickerToolbar", [
    "root",
    "dateContainer",
    "timeContainer",
    "timeDigitsContainer",
    "separator",
    "timeLabelReverse",
    "ampmSelection",
    "ampmLandscape",
    "ampmLabel"
]);



var $1T1QG = parcelRequire("1T1QG");


function $395c14dbcebe680a$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate, timezone: timezone }) {
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    return $1T1QG.useMemo(()=>{
        const now = utils.date(undefined, timezone);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils,
        timezone
    ]);
}
function $395c14dbcebe680a$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate, timezone: timezone }) {
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    return $1T1QG.useMemo(()=>{
        const now = utils.date(undefined, timezone);
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils,
        timezone
    ]);
}
function $395c14dbcebe680a$export$6aaabc31cb076d17(date, ampm, onChange, selectionState) {
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const meridiemMode = (0, $a99658949db23f4e$export$c3352ead7b032236)(date, utils);
    const handleMeridiemChange = $1T1QG.useCallback((mode)=>{
        const timeWithMeridiem = date == null ? null : (0, $a99658949db23f4e$export$c368d4ff66779998)(date, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, selectionState ?? "partial");
    }, [
        ampm,
        date,
        onChange,
        selectionState,
        utils
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}


const $790faeda284dc7ce$export$3f0060ce4cc8f4d0 = 36;
const $790faeda284dc7ce$export$dde58b009b497666 = 2;
const $790faeda284dc7ce$export$ee46b8a74d6c94d3 = 320;
const $790faeda284dc7ce$export$73724491020e90c7 = 280;
const $790faeda284dc7ce$export$f2fef360e2df0cb7 = 336;
const $790faeda284dc7ce$export$1c2eabda4acea0e4 = 232;
const $790faeda284dc7ce$export$a462ceb9cfdb5d71 = 48;






var $3Py8h = parcelRequire("3Py8h");
"use client";
const $97695ab1fe79e626$var$_excluded = [
    "ampm",
    "ampmInClock",
    "value",
    "onChange",
    "view",
    "isLandscape",
    "onViewChange",
    "toolbarFormat",
    "toolbarPlaceholder",
    "views",
    "disabled",
    "readOnly",
    "toolbarVariant",
    "toolbarTitle",
    "className"
];
const $97695ab1fe79e626$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape, isRtl: isRtl } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        dateContainer: [
            "dateContainer"
        ],
        timeContainer: [
            "timeContainer",
            isRtl && "timeLabelReverse"
        ],
        timeDigitsContainer: [
            "timeDigitsContainer",
            isRtl && "timeLabelReverse"
        ],
        separator: [
            "separator"
        ],
        ampmSelection: [
            "ampmSelection",
            isLandscape && "ampmLandscape"
        ],
        ampmLabel: [
            "ampmLabel"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $806e73834b16aef9$export$c40f5731216f0c9d), classes);
};
const $97695ab1fe79e626$var$DateTimePickerToolbarRoot = (0, $npagc.default)((0, $a4249024e74e1302$export$eb3c4d84783d6feb), {
    name: "MuiDateTimePickerToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        paddingLeft: 16,
        paddingRight: 16,
        justifyContent: "space-around",
        position: "relative",
        variants: [
            {
                props: {
                    toolbarVariant: "desktop"
                },
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    [`& .${(0, $580b93f6aa3ab710$export$59f09e5e2b3d9913).content} .${(0, $93b51e4627b2a754$export$4ca7b92014bf2e56).selected}`]: {
                        color: (theme.vars || theme).palette.primary.main,
                        fontWeight: theme.typography.fontWeightBold
                    }
                }
            },
            {
                props: {
                    toolbarVariant: "desktop",
                    isLandscape: true
                },
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    toolbarVariant: "desktop",
                    isLandscape: false
                },
                style: {
                    paddingLeft: 24,
                    paddingRight: 0
                }
            }
        ]
    }));
const $97695ab1fe79e626$var$DateTimePickerToolbarDateContainer = (0, $npagc.default)("div", {
    name: "MuiDateTimePickerToolbar",
    slot: "DateContainer",
    overridesResolver: (props, styles)=>styles.dateContainer
})({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
});
const $97695ab1fe79e626$var$DateTimePickerToolbarTimeContainer = (0, $npagc.default)("div", {
    name: "MuiDateTimePickerToolbar",
    slot: "TimeContainer",
    overridesResolver: (props, styles)=>styles.timeContainer
})({
    display: "flex",
    flexDirection: "row",
    variants: [
        {
            props: {
                isRtl: true
            },
            style: {
                flexDirection: "row-reverse"
            }
        },
        {
            props: {
                toolbarVariant: "desktop",
                isLandscape: false
            },
            style: {
                gap: 9,
                marginRight: 4,
                alignSelf: "flex-end"
            }
        },
        {
            props: ({ isLandscape: isLandscape, toolbarVariant: toolbarVariant })=>isLandscape && toolbarVariant !== "desktop",
            style: {
                flexDirection: "column"
            }
        },
        {
            props: ({ isLandscape: isLandscape, toolbarVariant: toolbarVariant, isRtl: isRtl })=>isLandscape && toolbarVariant !== "desktop" && isRtl,
            style: {
                flexDirection: "column-reverse"
            }
        }
    ]
});
const $97695ab1fe79e626$var$DateTimePickerToolbarTimeDigitsContainer = (0, $npagc.default)("div", {
    name: "MuiDateTimePickerToolbar",
    slot: "TimeDigitsContainer",
    overridesResolver: (props, styles)=>styles.timeDigitsContainer
})({
    display: "flex",
    variants: [
        {
            props: {
                isRtl: true
            },
            style: {
                flexDirection: "row-reverse"
            }
        },
        {
            props: {
                toolbarVariant: "desktop"
            },
            style: {
                gap: 1.5
            }
        }
    ]
});
const $97695ab1fe79e626$var$DateTimePickerToolbarSeparator = (0, $npagc.default)((0, $9dbd0e4436da1e35$export$2006bc630443fa2), {
    name: "MuiDateTimePickerToolbar",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})({
    margin: "0 4px 0 2px",
    cursor: "default",
    variants: [
        {
            props: {
                toolbarVariant: "desktop"
            },
            style: {
                margin: 0
            }
        }
    ]
});
// Taken from TimePickerToolbar
const $97695ab1fe79e626$var$DateTimePickerToolbarAmPmSelection = (0, $npagc.default)("div", {
    name: "MuiDateTimePickerToolbar",
    slot: "AmPmSelection",
    overridesResolver: (props, styles)=>[
            {
                [`.${(0, $806e73834b16aef9$export$82ac739c3153ffd4).ampmLabel}`]: styles.ampmLabel
            },
            {
                [`&.${(0, $806e73834b16aef9$export$82ac739c3153ffd4).ampmLandscape}`]: styles.ampmLandscape
            },
            styles.ampmSelection
        ]
})({
    display: "flex",
    flexDirection: "column",
    marginRight: "auto",
    marginLeft: 12,
    [`& .${(0, $806e73834b16aef9$export$82ac739c3153ffd4).ampmLabel}`]: {
        fontSize: 17
    },
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                margin: "4px 0 auto",
                flexDirection: "row",
                justifyContent: "space-around",
                width: "100%"
            }
        }
    ]
});
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Custom components](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [DateTimePickerToolbar API](https://mui.com/x/api/date-pickers/date-time-picker-toolbar/)
 */ function $97695ab1fe79e626$export$fe4ab7cbc0078243(inProps) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiDateTimePickerToolbar"
    });
    const { ampm: ampm, ampmInClock: ampmInClock, value: value, onChange: onChange, view: view, isLandscape: isLandscape, onViewChange: onViewChange, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", views: views, disabled: disabled, readOnly: readOnly, toolbarVariant: toolbarVariant = "mobile", toolbarTitle: inToolbarTitle, className: className } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $97695ab1fe79e626$var$_excluded);
    const isRtl = (0, $a69327a401bfde77$export$b2dd014b6c321cb)();
    const ownerState = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, {
        isRtl: isRtl
    });
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $395c14dbcebe680a$export$6aaabc31cb076d17)(value, ampm, onChange);
    const showAmPmControl = Boolean(ampm && !ampmInClock);
    const isDesktop = toolbarVariant === "desktop";
    const translations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    const classes = $97695ab1fe79e626$var$useUtilityClasses(ownerState);
    const toolbarTitle = inToolbarTitle ?? translations.dateTimePickerToolbarTitle;
    const formatHours = (time)=>ampm ? utils.format(time, "hours12h") : utils.format(time, "hours24h");
    const dateText = $1T1QG.useMemo(()=>{
        if (!value) return toolbarPlaceholder;
        if (toolbarFormat) return utils.formatByString(value, toolbarFormat);
        return utils.format(value, "shortDate");
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        utils
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($97695ab1fe79e626$var$DateTimePickerToolbarRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        isLandscape: isLandscape,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        toolbarTitle: toolbarTitle
    }, other, {
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsxs)($97695ab1fe79e626$var$DateTimePickerToolbarDateContainer, {
                className: classes.dateContainer,
                ownerState: ownerState,
                children: [
                    views.includes("year") && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f70eed4fc89c5764$export$614ed940168c780c), {
                        tabIndex: -1,
                        variant: "subtitle1",
                        onClick: ()=>onViewChange("year"),
                        selected: view === "year",
                        value: value ? utils.format(value, "year") : "\u2013"
                    }),
                    views.includes("day") && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f70eed4fc89c5764$export$614ed940168c780c), {
                        tabIndex: -1,
                        variant: isDesktop ? "h5" : "h4",
                        onClick: ()=>onViewChange("day"),
                        selected: view === "day",
                        value: dateText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3Py8h.jsxs)($97695ab1fe79e626$var$DateTimePickerToolbarTimeContainer, {
                className: classes.timeContainer,
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsxs)($97695ab1fe79e626$var$DateTimePickerToolbarTimeDigitsContainer, {
                        className: classes.timeDigitsContainer,
                        ownerState: ownerState,
                        children: [
                            views.includes("hours") && /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f70eed4fc89c5764$export$614ed940168c780c), {
                                        variant: isDesktop ? "h5" : "h3",
                                        width: isDesktop && !isLandscape ? (0, $790faeda284dc7ce$export$a462ceb9cfdb5d71) : undefined,
                                        onClick: ()=>onViewChange("hours"),
                                        selected: view === "hours",
                                        value: value ? formatHours(value) : "--"
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)($97695ab1fe79e626$var$DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? "h5" : "h3",
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f70eed4fc89c5764$export$614ed940168c780c), {
                                        variant: isDesktop ? "h5" : "h3",
                                        width: isDesktop && !isLandscape ? (0, $790faeda284dc7ce$export$a462ceb9cfdb5d71) : undefined,
                                        onClick: ()=>onViewChange("minutes"),
                                        selected: view === "minutes" || !views.includes("minutes") && view === "hours",
                                        value: value ? utils.format(value, "minutes") : "--",
                                        disabled: !views.includes("minutes")
                                    })
                                ]
                            }),
                            views.includes("seconds") && /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $3Py8h.jsx)($97695ab1fe79e626$var$DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? "h5" : "h3",
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f70eed4fc89c5764$export$614ed940168c780c), {
                                        variant: isDesktop ? "h5" : "h3",
                                        width: isDesktop && !isLandscape ? (0, $790faeda284dc7ce$export$a462ceb9cfdb5d71) : undefined,
                                        onClick: ()=>onViewChange("seconds"),
                                        selected: view === "seconds",
                                        value: value ? utils.format(value, "seconds") : "--"
                                    })
                                ]
                            })
                        ]
                    }),
                    showAmPmControl && !isDesktop && /*#__PURE__*/ (0, $3Py8h.jsxs)($97695ab1fe79e626$var$DateTimePickerToolbarAmPmSelection, {
                        className: classes.ampmSelection,
                        ownerState: ownerState,
                        children: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f70eed4fc89c5764$export$614ed940168c780c), {
                                variant: "subtitle2",
                                selected: meridiemMode === "am",
                                typographyClassName: classes.ampmLabel,
                                value: (0, $2c8437f6b047f676$export$fae94c0a662107ef)(utils, "am"),
                                onClick: readOnly ? undefined : ()=>handleMeridiemChange("am"),
                                disabled: disabled
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f70eed4fc89c5764$export$614ed940168c780c), {
                                variant: "subtitle2",
                                selected: meridiemMode === "pm",
                                typographyClassName: classes.ampmLabel,
                                value: (0, $2c8437f6b047f676$export$fae94c0a662107ef)(utils, "pm"),
                                onClick: readOnly ? undefined : ()=>handleMeridiemChange("pm"),
                                disabled: disabled
                            })
                        ]
                    }),
                    ampm && isDesktop && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f70eed4fc89c5764$export$614ed940168c780c), {
                        variant: "h5",
                        onClick: ()=>onViewChange("meridiem"),
                        selected: view === "meridiem",
                        value: value && meridiemMode ? (0, $2c8437f6b047f676$export$fae94c0a662107ef)(utils, meridiemMode) : "--",
                        width: (0, $790faeda284dc7ce$export$a462ceb9cfdb5d71)
                    })
                ]
            })
        ]
    }));
}



function $bf8c9a745e3f8782$export$6e4d96e87e6dc2d3(props, name) {
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const defaultDates = (0, $f3e8032daddc32c6$export$7c38da3a2e90fa83)();
    const themeProps = (0, $gADeF.default)({
        props: props,
        name: name
    });
    const ampm = themeProps.ampm ?? utils.is12HourCycleInCurrentLocale();
    const localeText = $1T1QG.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, themeProps.localeText, {
            dateTimePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, themeProps, (0, $5fcb694dda34c3a0$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            "year",
            "day",
            "hours",
            "minutes"
        ],
        defaultOpenTo: "day"
    }), {
        ampm: ampm,
        localeText: localeText,
        orientation: themeProps.orientation ?? "portrait",
        // TODO: Remove from public API
        disableIgnoringDatePartForTimeValidation: themeProps.disableIgnoringDatePartForTimeValidation ?? Boolean(themeProps.minDateTime || themeProps.maxDateTime || // allow time clock to correctly check time validity: https://github.com/mui/mui-x/issues/8520
        themeProps.disablePast || themeProps.disableFuture),
        disableFuture: themeProps.disableFuture ?? false,
        disablePast: themeProps.disablePast ?? false,
        minDate: (0, $2c8437f6b047f676$export$eb73579ccade48fd)(utils, themeProps.minDateTime ?? themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $2c8437f6b047f676$export$eb73579ccade48fd)(utils, themeProps.maxDateTime ?? themeProps.maxDate, defaultDates.maxDate),
        minTime: themeProps.minDateTime ?? themeProps.minTime,
        maxTime: themeProps.maxDateTime ?? themeProps.maxTime,
        slots: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
            toolbar: (0, $97695ab1fe79e626$export$fe4ab7cbc0078243),
            tabs: (0, $ed9810fa41a895a8$export$95dfad4074502244)
        }, themeProps.slots),
        slotProps: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, themeProps.slotProps, {
            toolbar: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                ampm: ampm
            }, themeProps.slotProps?.toolbar)
        })
    });
}


parcelRequire("1T1QG");



var $1T1QG = parcelRequire("1T1QG");




var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");



var $1T1QG = parcelRequire("1T1QG");


var $1T1QG = parcelRequire("1T1QG");


"use client";
const $29fb10fdf2e82488$export$7d1a419f34475191 = ({ shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast, timezone: timezone })=>{
    const adapter = (0, $f3e8032daddc32c6$export$4b5a24245de9f7f9)();
    return $1T1QG.useCallback((day)=>(0, $4d39a15704c4df77$export$ffb3d0046ef3a2)({
            adapter: adapter,
            value: day,
            timezone: timezone,
            props: {
                shouldDisableDate: shouldDisableDate,
                shouldDisableMonth: shouldDisableMonth,
                shouldDisableYear: shouldDisableYear,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};





"use client";
const $c6908850d6e5602f$export$2aba07ea6b6cf430 = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils)=>(state, action)=>{
        switch(action.type){
            case "changeMonth":
                return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.newMonth,
                    isMonthSwitchingAnimating: !reduceAnimations
                });
            case "changeMonthTimezone":
                {
                    const newTimezone = action.newTimezone;
                    if (utils.getTimezone(state.currentMonth) === newTimezone) return state;
                    let newCurrentMonth = utils.setTimezone(state.currentMonth, newTimezone);
                    if (utils.getMonth(newCurrentMonth) !== utils.getMonth(state.currentMonth)) newCurrentMonth = utils.setMonth(newCurrentMonth, utils.getMonth(state.currentMonth));
                    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, state, {
                        currentMonth: newCurrentMonth
                    });
                }
            case "finishMonthSwitchingAnimation":
                return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            case "changeFocusedDay":
                {
                    if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) return state;
                    const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
                    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, state, {
                        focusedDay: action.focusedDay,
                        isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
                        currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
                        slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? "left" : "right"
                    });
                }
            default:
                throw new Error("missing support");
        }
    };
const $c6908850d6e5602f$export$6d095e787d2b5e1f = (params)=>{
    const { value: value, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, disableSwitchToMonthOnDayFocus: disableSwitchToMonthOnDayFocus = false, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, timezone: timezone } = params;
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const reducerFn = $1T1QG.useRef($c6908850d6e5602f$export$2aba07ea6b6cf430(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
    const referenceDate = $1T1QG.useMemo(()=>{
        return (0, $59c1a689a11004ea$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            timezone: timezone,
            props: params,
            referenceDate: referenceDateProp,
            granularity: (0, $101a7d0ae47539cf$export$8f74e8f4ed8ae0ac).day
        });
    }, // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        referenceDateProp,
        timezone
    ]);
    const [calendarState, dispatch] = $1T1QG.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: referenceDate,
        currentMonth: utils.startOfMonth(referenceDate),
        slideDirection: "left"
    });
    // Ensure that `calendarState.currentMonth` timezone is updated when `referenceDate` (or timezone changes)
    // https://github.com/mui/mui-x/issues/10804
    $1T1QG.useEffect(()=>{
        dispatch({
            type: "changeMonthTimezone",
            newTimezone: utils.getTimezone(referenceDate)
        });
    }, [
        referenceDate,
        utils
    ]);
    const handleChangeMonth = $1T1QG.useCallback((payload)=>{
        dispatch((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
            type: "changeMonth"
        }, payload));
        if (onMonthChange) onMonthChange(payload.newMonth);
    }, [
        onMonthChange
    ]);
    const changeMonth = $1T1QG.useCallback((newDate)=>{
        const newDateRequested = newDate;
        if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) return;
        handleChangeMonth({
            newMonth: utils.startOfMonth(newDateRequested),
            direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? "left" : "right"
        });
    }, [
        calendarState.currentMonth,
        handleChangeMonth,
        utils
    ]);
    const isDateDisabled = (0, $29fb10fdf2e82488$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        timezone: timezone
    });
    const onMonthSwitchingAnimationEnd = $1T1QG.useCallback(()=>{
        dispatch({
            type: "finishMonthSwitchingAnimation"
        });
    }, []);
    const changeFocusedDay = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newFocusedDate, withoutMonthSwitchingAnimation)=>{
        if (!isDateDisabled(newFocusedDate)) dispatch({
            type: "changeFocusedDay",
            focusedDay: newFocusedDate,
            withoutMonthSwitchingAnimation: withoutMonthSwitchingAnimation
        });
    });
    return {
        referenceDate: referenceDate,
        calendarState: calendarState,
        changeMonth: changeMonth,
        changeFocusedDay: changeFocusedDay,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
        handleChangeMonth: handleChangeMonth
    };
};



parcelRequire("1T1QG");




var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");


const $42d6a2970e9f889c$export$5b0bb0174eb448ca = (slot)=>(0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiPickersFadeTransitionGroup", slot);
const $42d6a2970e9f889c$export$1461f245817ac559 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiPickersFadeTransitionGroup", [
    "root"
]);



var $3Py8h = parcelRequire("3Py8h");
const $fdb3247e09c40c07$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $42d6a2970e9f889c$export$5b0bb0174eb448ca), classes);
};
const $fdb3247e09c40c07$var$PickersFadeTransitionGroupRoot = (0, $npagc.default)((0, $fe45668052bb8991$export$2e2bcd8739ae039), {
    name: "MuiPickersFadeTransitionGroup",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    display: "block",
    position: "relative"
});
function $fdb3247e09c40c07$export$5262185daf493fee(inProps) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersFadeTransitionGroup"
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props;
    const classes = $fdb3247e09c40c07$var$useUtilityClasses(props);
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $3Py8h.jsx)($fdb3247e09c40c07$var$PickersFadeTransitionGroupRoot, {
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a2c582129c3c8d70$export$2e2bcd8739ae039), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: theme.transitions.duration.enteringScreen,
                enter: theme.transitions.duration.enteringScreen,
                exit: 0
            },
            children: children
        }, transKey)
    });
}





var $1T1QG = parcelRequire("1T1QG");





var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");





var $1T1QG = parcelRequire("1T1QG");





var $7Etkp = parcelRequire("7Etkp");
var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");



function $f6eef5a6062d061e$export$4b25deb0350d3e53(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiPickersDay", slot);
}
const $f6eef5a6062d061e$export$68b221ad3c35e288 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiPickersDay", [
    "root",
    "dayWithMargin",
    "dayOutsideMonth",
    "hiddenDaySpacingFiller",
    "today",
    "selected",
    "disabled"
]);



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $47319264a6440e1b$var$_excluded = [
    "autoFocus",
    "className",
    "day",
    "disabled",
    "disableHighlightToday",
    "disableMargin",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "outsideCurrentMonth",
    "selected",
    "showDaysOutsideCurrentMonth",
    "children",
    "today",
    "isFirstVisibleCell",
    "isLastVisibleCell"
];
const $47319264a6440e1b$var$useUtilityClasses = (ownerState)=>{
    const { selected: selected, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, today: today, disabled: disabled, outsideCurrentMonth: outsideCurrentMonth, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, classes: classes } = ownerState;
    const isHiddenDaySpacingFiller = outsideCurrentMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            "root",
            selected && !isHiddenDaySpacingFiller && "selected",
            disabled && "disabled",
            !disableMargin && "dayWithMargin",
            !disableHighlightToday && today && "today",
            outsideCurrentMonth && showDaysOutsideCurrentMonth && "dayOutsideMonth",
            isHiddenDaySpacingFiller && "hiddenDaySpacingFiller"
        ],
        hiddenDaySpacingFiller: [
            "hiddenDaySpacingFiller"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $f6eef5a6062d061e$export$4b25deb0350d3e53), classes);
};
const $47319264a6440e1b$var$styleArg = ({ theme: theme })=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, theme.typography.caption, {
        width: (0, $790faeda284dc7ce$export$3f0060ce4cc8f4d0),
        height: (0, $790faeda284dc7ce$export$3f0060ce4cc8f4d0),
        borderRadius: "50%",
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: "transparent",
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.short
        }),
        color: (theme.vars || theme).palette.text.primary,
        "@media (pointer: fine)": {
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        "&:focus": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${(0, $f6eef5a6062d061e$export$68b221ad3c35e288).selected}`]: {
                willChange: "background-color",
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $f6eef5a6062d061e$export$68b221ad3c35e288).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            "&:hover": {
                willChange: "background-color",
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $f6eef5a6062d061e$export$68b221ad3c35e288).disabled}:not(.${(0, $f6eef5a6062d061e$export$68b221ad3c35e288).selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $f6eef5a6062d061e$export$68b221ad3c35e288).disabled}&.${(0, $f6eef5a6062d061e$export$68b221ad3c35e288).selected}`]: {
            opacity: 0.6
        },
        variants: [
            {
                props: {
                    disableMargin: false
                },
                style: {
                    margin: `0 ${(0, $790faeda284dc7ce$export$dde58b009b497666)}px`
                }
            },
            {
                props: {
                    outsideCurrentMonth: true,
                    showDaysOutsideCurrentMonth: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary
                }
            },
            {
                props: {
                    disableHighlightToday: false,
                    today: true
                },
                style: {
                    [`&:not(.${(0, $f6eef5a6062d061e$export$68b221ad3c35e288).selected})`]: {
                        border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
                    }
                }
            }
        ]
    });
const $47319264a6440e1b$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.today && styles.today,
        !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $47319264a6440e1b$var$PickersDayRoot = (0, $npagc.default)((0, $ecc40a2d226ef234$export$2e2bcd8739ae039), {
    name: "MuiPickersDay",
    slot: "Root",
    overridesResolver: $47319264a6440e1b$var$overridesResolver
})($47319264a6440e1b$var$styleArg);
const $47319264a6440e1b$var$PickersDayFiller = (0, $npagc.default)("div", {
    name: "MuiPickersDay",
    slot: "Root",
    overridesResolver: $47319264a6440e1b$var$overridesResolver
})(({ theme: theme })=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, $47319264a6440e1b$var$styleArg({
        theme: theme
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: "none"
    }));
const $47319264a6440e1b$var$noop = ()=>{};
const $47319264a6440e1b$var$PickersDayRaw = /*#__PURE__*/ $1T1QG.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersDay"
    });
    const { autoFocus: autoFocus = false, className: className, day: day, disabled: disabled = false, disableHighlightToday: disableHighlightToday = false, disableMargin: disableMargin = false, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $47319264a6440e1b$var$noop, onBlur: onBlur = $47319264a6440e1b$var$noop, onKeyDown: onKeyDown = $47319264a6440e1b$var$noop, onMouseDown: onMouseDown = $47319264a6440e1b$var$noop, onMouseEnter: onMouseEnter = $47319264a6440e1b$var$noop, outsideCurrentMonth: outsideCurrentMonth, selected: selected = false, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth = false, children: children, today: isToday = false } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $47319264a6440e1b$var$_excluded);
    const ownerState = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, {
        autoFocus: autoFocus,
        disabled: disabled,
        disableHighlightToday: disableHighlightToday,
        disableMargin: disableMargin,
        selected: selected,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        today: isToday
    });
    const classes = $47319264a6440e1b$var$useUtilityClasses(ownerState);
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const ref = $1T1QG.useRef(null);
    const handleRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $1c8a785890e03d41$export$2e2bcd8739ae039)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For a day outside the current month, move the focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $3Py8h.jsx)($47319264a6440e1b$var$PickersDayFiller, {
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)($47319264a6440e1b$var$PickersDayRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: !children ? utils.format(day, "dayOfMonth") : children
    }));
});
const $47319264a6440e1b$export$d7378e6e864346fa = /*#__PURE__*/ $1T1QG.memo($47319264a6440e1b$var$PickersDayRaw);








var $1T1QG = parcelRequire("1T1QG");


var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");


var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");


/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $dda28a74b1beb944$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $021e3d13eb160bdf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $dda28a74b1beb944$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}


function $ded26f0bee9ce997$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $ded26f0bee9ce997$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $ded26f0bee9ce997$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $ded26f0bee9ce997$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



var $1T1QG = parcelRequire("1T1QG");



var $4fd21ef61d2be0cf$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $021e3d13eb160bdf$export$2e2bcd8739ae039)(node, c);
    });
};
var $4fd21ef61d2be0cf$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $ded26f0bee9ce997$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $4fd21ef61d2be0cf$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $2068d65b9cbba68b$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, $62cd2fb6df2fdc76$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $4fd21ef61d2be0cf$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $4fd21ef61d2be0cf$var$removeClass(node, baseClassName);
        if (activeClassName) $4fd21ef61d2be0cf$var$removeClass(node, activeClassName);
        if (doneClassName) $4fd21ef61d2be0cf$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $iXdVf.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).createElement((0, $97e45c35ce24099f$export$2e2bcd8739ae039), (0, $ajTRS.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Component);
$4fd21ef61d2be0cf$var$CSSTransition.defaultProps = {
    classNames: ""
};
$4fd21ef61d2be0cf$var$CSSTransition.propTypes = {};
var $4fd21ef61d2be0cf$export$2e2bcd8739ae039 = $4fd21ef61d2be0cf$var$CSSTransition;



const $e7e60a6e4f532f10$export$e98c1b6c3bbc3c59 = (slot)=>(0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiPickersSlideTransition", slot);
const $e7e60a6e4f532f10$export$d251a58673156a67 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiPickersSlideTransition", [
    "root",
    "slideEnter-left",
    "slideEnter-right",
    "slideEnterActive",
    "slideExit",
    "slideExitActiveLeft-left",
    "slideExitActiveLeft-right"
]);



var $3Py8h = parcelRequire("3Py8h");
const $0b5011bdc842695c$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const $0b5011bdc842695c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, slideDirection: slideDirection } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        exit: [
            "slideExit"
        ],
        enterActive: [
            "slideEnterActive"
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $e7e60a6e4f532f10$export$e98c1b6c3bbc3c59), classes);
};
const $0b5011bdc842695c$var$PickersSlideTransitionRoot = (0, $npagc.default)((0, $fe45668052bb8991$export$2e2bcd8739ae039), {
    name: "MuiPickersSlideTransition",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${(0, $e7e60a6e4f532f10$export$d251a58673156a67)["slideEnter-left"]}`]: styles["slideEnter-left"]
            },
            {
                [`.${(0, $e7e60a6e4f532f10$export$d251a58673156a67)["slideEnter-right"]}`]: styles["slideEnter-right"]
            },
            {
                [`.${(0, $e7e60a6e4f532f10$export$d251a58673156a67).slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${(0, $e7e60a6e4f532f10$export$d251a58673156a67).slideExit}`]: styles.slideExit
            },
            {
                [`.${(0, $e7e60a6e4f532f10$export$d251a58673156a67)["slideExitActiveLeft-left"]}`]: styles["slideExitActiveLeft-left"]
            },
            {
                [`.${(0, $e7e60a6e4f532f10$export$d251a58673156a67)["slideExitActiveLeft-right"]}`]: styles["slideExitActiveLeft-right"]
            }
        ]
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create("transform", {
        duration: theme.transitions.duration.complex,
        easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
    });
    return {
        display: "block",
        position: "relative",
        overflowX: "hidden",
        "& > *": {
            position: "absolute",
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, $e7e60a6e4f532f10$export$d251a58673156a67)["slideEnter-left"]}`]: {
            willChange: "transform",
            transform: "translate(100%)",
            zIndex: 1
        },
        [`& .${(0, $e7e60a6e4f532f10$export$d251a58673156a67)["slideEnter-right"]}`]: {
            willChange: "transform",
            transform: "translate(-100%)",
            zIndex: 1
        },
        [`& .${(0, $e7e60a6e4f532f10$export$d251a58673156a67).slideEnterActive}`]: {
            transform: "translate(0%)",
            transition: slideTransition
        },
        [`& .${(0, $e7e60a6e4f532f10$export$d251a58673156a67).slideExit}`]: {
            transform: "translate(0%)"
        },
        [`& .${(0, $e7e60a6e4f532f10$export$d251a58673156a67)["slideExitActiveLeft-left"]}`]: {
            willChange: "transform",
            transform: "translate(-100%)",
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, $e7e60a6e4f532f10$export$d251a58673156a67)["slideExitActiveLeft-right"]}`]: {
            willChange: "transform",
            transform: "translate(100%)",
            transition: slideTransition,
            zIndex: 0
        }
    };
});
function $0b5011bdc842695c$export$e868fcc7557d3a06(inProps) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersSlideTransition"
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $0b5011bdc842695c$var$_excluded);
    const classes = $0b5011bdc842695c$var$useUtilityClasses(props);
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    if (reduceAnimations) return /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)($0b5011bdc842695c$var$PickersSlideTransitionRoot, {
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $1T1QG.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4fd21ef61d2be0cf$export$2e2bcd8739ae039), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: theme.transitions.duration.complex,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}





const $8938ea3f6bf54b03$export$fbe827982a69894a = (slot)=>(0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiDayCalendar", slot);
const $8938ea3f6bf54b03$export$b3f91ee59da1294a = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiDayCalendar", [
    "root",
    "header",
    "weekDayLabel",
    "loadingContainer",
    "slideTransition",
    "monthContainer",
    "weekContainer",
    "weekNumberLabel",
    "weekNumber"
]);



var $3Py8h = parcelRequire("3Py8h");
const $a4d416cf529486fb$var$_excluded = [
    "parentProps",
    "day",
    "focusableDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], $a4d416cf529486fb$var$_excluded2 = [
    "ownerState"
];
const $a4d416cf529486fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        header: [
            "header"
        ],
        weekDayLabel: [
            "weekDayLabel"
        ],
        loadingContainer: [
            "loadingContainer"
        ],
        slideTransition: [
            "slideTransition"
        ],
        monthContainer: [
            "monthContainer"
        ],
        weekContainer: [
            "weekContainer"
        ],
        weekNumberLabel: [
            "weekNumberLabel"
        ],
        weekNumber: [
            "weekNumber"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $8938ea3f6bf54b03$export$fbe827982a69894a), classes);
};
const $a4d416cf529486fb$var$weeksContainerHeight = ((0, $790faeda284dc7ce$export$3f0060ce4cc8f4d0) + (0, $790faeda284dc7ce$export$dde58b009b497666) * 2) * 6;
const $a4d416cf529486fb$var$PickersCalendarDayRoot = (0, $npagc.default)("div", {
    name: "MuiDayCalendar",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({});
const $a4d416cf529486fb$var$PickersCalendarDayHeader = (0, $npagc.default)("div", {
    name: "MuiDayCalendar",
    slot: "Header",
    overridesResolver: (_, styles)=>styles.header
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $a4d416cf529486fb$var$PickersCalendarWeekDayLabel = (0, $npagc.default)((0, $a386176d6ca21602$export$2e2bcd8739ae039), {
    name: "MuiDayCalendar",
    slot: "WeekDayLabel",
    overridesResolver: (_, styles)=>styles.weekDayLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: "0 2px",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: (theme.vars || theme).palette.text.secondary
    }));
const $a4d416cf529486fb$var$PickersCalendarWeekNumberLabel = (0, $npagc.default)((0, $a386176d6ca21602$export$2e2bcd8739ae039), {
    name: "MuiDayCalendar",
    slot: "WeekNumberLabel",
    overridesResolver: (_, styles)=>styles.weekNumberLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: "0 2px",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: theme.palette.text.disabled
    }));
const $a4d416cf529486fb$var$PickersCalendarWeekNumber = (0, $npagc.default)((0, $a386176d6ca21602$export$2e2bcd8739ae039), {
    name: "MuiDayCalendar",
    slot: "WeekNumber",
    overridesResolver: (_, styles)=>styles.weekNumber
})(({ theme: theme })=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, theme.typography.caption, {
        width: (0, $790faeda284dc7ce$export$3f0060ce4cc8f4d0),
        height: (0, $790faeda284dc7ce$export$3f0060ce4cc8f4d0),
        padding: 0,
        margin: `0 ${(0, $790faeda284dc7ce$export$dde58b009b497666)}px`,
        color: theme.palette.text.disabled,
        fontSize: "0.75rem",
        alignItems: "center",
        justifyContent: "center",
        display: "inline-flex"
    }));
const $a4d416cf529486fb$var$PickersCalendarLoadingContainer = (0, $npagc.default)("div", {
    name: "MuiDayCalendar",
    slot: "LoadingContainer",
    overridesResolver: (_, styles)=>styles.loadingContainer
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: $a4d416cf529486fb$var$weeksContainerHeight
});
const $a4d416cf529486fb$var$PickersCalendarSlideTransition = (0, $npagc.default)((0, $0b5011bdc842695c$export$e868fcc7557d3a06), {
    name: "MuiDayCalendar",
    slot: "SlideTransition",
    overridesResolver: (_, styles)=>styles.slideTransition
})({
    minHeight: $a4d416cf529486fb$var$weeksContainerHeight
});
const $a4d416cf529486fb$var$PickersCalendarWeekContainer = (0, $npagc.default)("div", {
    name: "MuiDayCalendar",
    slot: "MonthContainer",
    overridesResolver: (_, styles)=>styles.monthContainer
})({
    overflow: "hidden"
});
const $a4d416cf529486fb$var$PickersCalendarWeek = (0, $npagc.default)("div", {
    name: "MuiDayCalendar",
    slot: "WeekContainer",
    overridesResolver: (_, styles)=>styles.weekContainer
})({
    margin: `${(0, $790faeda284dc7ce$export$dde58b009b497666)}px 0`,
    display: "flex",
    justifyContent: "center"
});
function $a4d416cf529486fb$var$WrappedDay(_ref) {
    let { parentProps: parentProps, day: day, focusableDay: focusableDay, selectedDays: selectedDays, isDateDisabled: isDateDisabled, currentMonthNumber: currentMonthNumber, isViewFocused: isViewFocused } = _ref, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_ref, $a4d416cf529486fb$var$_excluded);
    const { disabled: disabled, disableHighlightToday: disableHighlightToday, isMonthSwitchingAnimating: isMonthSwitchingAnimating, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, slots: slots, slotProps: slotProps, timezone: timezone } = parentProps;
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const now = (0, $f3e8032daddc32c6$export$3a404aece3dff2fa)(timezone);
    const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
    const isSelected = selectedDays.some((selectedDay)=>utils.isSameDay(selectedDay, day));
    const isToday = utils.isSameDay(day, now);
    const Day = slots?.day ?? (0, $47319264a6440e1b$export$d7378e6e864346fa);
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: Day,
        externalSlotProps: slotProps?.day,
        additionalProps: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
            disableHighlightToday: disableHighlightToday,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
            role: "gridcell",
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            "data-timestamp": utils.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, parentProps, {
            day: day,
            selected: isSelected
        })
    }), dayProps = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_useSlotProps, $a4d416cf529486fb$var$_excluded2);
    const isDisabled = $1T1QG.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const outsideCurrentMonth = $1T1QG.useMemo(()=>utils.getMonth(day) !== currentMonthNumber, [
        utils,
        day,
        currentMonthNumber
    ]);
    const isFirstVisibleCell = $1T1QG.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, startOfMonth);
        return utils.isSameDay(day, utils.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    const isLastVisibleCell = $1T1QG.useMemo(()=>{
        const endOfMonth = utils.endOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, endOfMonth);
        return utils.isSameDay(day, utils.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)(Day, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: isViewFocused && isFocusableDay,
        today: isToday,
        outsideCurrentMonth: outsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? "date" : undefined
    }));
}
function $a4d416cf529486fb$export$8fb56b32a5df6314(inProps) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiDayCalendar"
    });
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const { onFocusedDayChange: onFocusedDayChange, className: className, currentMonth: currentMonth, selectedDays: selectedDays, focusedDay: focusedDay, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $3Py8h.jsx)("span", {
            children: "..."
        }), slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, dayOfWeekFormatter: dayOfWeekFormatter = (date)=>utils.format(date, "weekdayShort").charAt(0).toUpperCase(), hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId, displayWeekNumber: displayWeekNumber, fixedWeekNumber: fixedWeekNumber, autoFocus: autoFocus, timezone: timezone } = props;
    const now = (0, $f3e8032daddc32c6$export$3a404aece3dff2fa)(timezone);
    const classes = $a4d416cf529486fb$var$useUtilityClasses(props);
    const isRtl = (0, $a69327a401bfde77$export$b2dd014b6c321cb)();
    const isDateDisabled = (0, $29fb10fdf2e82488$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    const translations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    const [internalHasFocus, setInternalHasFocus] = (0, $9790f3f3f5426a25$export$2e2bcd8739ae039)({
        name: "DayCalendar",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const [internalFocusedDay, setInternalFocusedDay] = $1T1QG.useState(()=>focusedDay || now);
    const handleDaySelect = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            setInternalFocusedDay(day);
            onFocusedViewChange?.(true);
            setInternalHasFocus(true);
        }
    };
    const handleKeyDown = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event, day)=>{
        switch(event.key){
            case "ArrowUp":
                focusDay(utils.addDays(day, -7));
                event.preventDefault();
                break;
            case "ArrowDown":
                focusDay(utils.addDays(day, 7));
                event.preventDefault();
                break;
            case "ArrowLeft":
                {
                    const newFocusedDayDefault = utils.addDays(day, isRtl ? 1 : -1);
                    const nextAvailableMonth = utils.addMonths(day, isRtl ? 1 : -1);
                    const closestDayToFocus = (0, $2c8437f6b047f676$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
                        maxDate: isRtl ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case "ArrowRight":
                {
                    const newFocusedDayDefault = utils.addDays(day, isRtl ? -1 : 1);
                    const nextAvailableMonth = utils.addMonths(day, isRtl ? -1 : 1);
                    const closestDayToFocus = (0, $2c8437f6b047f676$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRtl ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case "Home":
                focusDay(utils.startOfWeek(day));
                event.preventDefault();
                break;
            case "End":
                focusDay(utils.endOfWeek(day));
                event.preventDefault();
                break;
            case "PageUp":
                focusDay(utils.addMonths(day, 1));
                event.preventDefault();
                break;
            case "PageDown":
                focusDay(utils.addMonths(day, -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event, day)=>focusDay(day));
    const handleBlur = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event, day)=>{
        if (internalHasFocus && utils.isSameDay(internalFocusedDay, day)) onFocusedViewChange?.(false);
    });
    const currentMonthNumber = utils.getMonth(currentMonth);
    const currentYearNumber = utils.getYear(currentMonth);
    const validSelectedDays = $1T1QG.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>utils.startOfDay(day)), [
        utils,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: https://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = `${currentYearNumber}-${currentMonthNumber}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $1T1QG.useMemo(()=>/*#__PURE__*/ $1T1QG.createRef(), [
        transitionKey
    ]);
    const focusableDay = $1T1QG.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(currentMonth);
        const endOfMonth = utils.endOfMonth(currentMonth);
        if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) return (0, $2c8437f6b047f676$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: internalFocusedDay,
            minDate: startOfMonth,
            maxDate: endOfMonth,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        });
        return internalFocusedDay;
    }, [
        currentMonth,
        disableFuture,
        disablePast,
        internalFocusedDay,
        isDateDisabled,
        utils,
        timezone
    ]);
    const weeksToDisplay = $1T1QG.useMemo(()=>{
        const toDisplay = utils.getWeekArray(currentMonth);
        let nextMonth = utils.addMonths(currentMonth, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = utils.getWeekArray(nextMonth);
            const hasCommonWeek = utils.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = utils.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        utils
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($a4d416cf529486fb$var$PickersCalendarDayRoot, {
        role: "grid",
        "aria-labelledby": gridLabelId,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsxs)($a4d416cf529486fb$var$PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, $3Py8h.jsx)($a4d416cf529486fb$var$PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": translations.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: translations.calendarWeekNumberHeaderText
                    }),
                    (0, $2c8437f6b047f676$export$24c38139da66592d)(utils, now).map((weekday, i)=>/*#__PURE__*/ (0, $3Py8h.jsx)($a4d416cf529486fb$var$PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": utils.format(weekday, "weekday"),
                            className: classes.weekDayLabel,
                            children: dayOfWeekFormatter(weekday)
                        }, i.toString()))
                ]
            }),
            loading ? /*#__PURE__*/ (0, $3Py8h.jsx)($a4d416cf529486fb$var$PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $3Py8h.jsx)($a4d416cf529486fb$var$PickersCalendarSlideTransition, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $3Py8h.jsx)($a4d416cf529486fb$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, $3Py8h.jsxs)($a4d416cf529486fb$var$PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, $3Py8h.jsx)($a4d416cf529486fb$var$PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": translations.calendarWeekNumberAriaLabelText(utils.getWeekNumber(week[0])),
                                    children: translations.calendarWeekNumberText(utils.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, $3Py8h.jsx)($a4d416cf529486fb$var$WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        focusableDay: focusableDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        isViewFocused: internalHasFocus,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}





var $1T1QG = parcelRequire("1T1QG");




var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");




var $1T1QG = parcelRequire("1T1QG");


var $7Etkp = parcelRequire("7Etkp");
var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");




function $15d8eb437a1beb6b$export$db90a620ac957a73(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiPickersMonth", slot);
}
const $15d8eb437a1beb6b$export$911e3973fa70a12b = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiPickersMonth", [
    "root",
    "monthButton",
    "disabled",
    "selected"
]);



var $3Py8h = parcelRequire("3Py8h");
const $5502a6a83e1e635e$var$_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "aria-label",
    "monthsPerRow",
    "slots",
    "slotProps"
];
const $5502a6a83e1e635e$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        monthButton: [
            "monthButton",
            disabled && "disabled",
            selected && "selected"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $15d8eb437a1beb6b$export$db90a620ac957a73), classes);
};
const $5502a6a83e1e635e$var$PickersMonthRoot = (0, $npagc.default)("div", {
    name: "MuiPickersMonth",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexBasis: "33.3%",
    variants: [
        {
            props: {
                monthsPerRow: 4
            },
            style: {
                flexBasis: "25%"
            }
        }
    ]
});
const $5502a6a83e1e635e$var$MonthCalendarButton = (0, $npagc.default)("button", {
    name: "MuiPickersMonth",
    slot: "MonthButton",
    overridesResolver: (_, styles)=>[
            styles.monthButton,
            {
                [`&.${(0, $15d8eb437a1beb6b$export$911e3973fa70a12b).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $15d8eb437a1beb6b$export$911e3973fa70a12b).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        color: "unset",
        backgroundColor: "transparent",
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: "8px 0",
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: "pointer",
        "&:focus": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7Etkp.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7Etkp.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:disabled": {
            cursor: "auto",
            pointerEvents: "none"
        },
        [`&.${(0, $15d8eb437a1beb6b$export$911e3973fa70a12b).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $15d8eb437a1beb6b$export$911e3973fa70a12b).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            "&:focus, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $5502a6a83e1e635e$export$bc52fdb7f02f591a = /*#__PURE__*/ $1T1QG.memo(function PickersMonth(inProps) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersMonth"
    });
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, "aria-current": ariaCurrent, "aria-label": ariaLabel, slots: slots, slotProps: slotProps } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $5502a6a83e1e635e$var$_excluded);
    const ref = $1T1QG.useRef(null);
    const classes = $5502a6a83e1e635e$var$useUtilityClasses(props);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $1c8a785890e03d41$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const MonthButton = slots?.monthButton ?? $5502a6a83e1e635e$var$MonthCalendarButton;
    const monthButtonProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: MonthButton,
        externalSlotProps: slotProps?.monthButton,
        additionalProps: {
            children: children,
            disabled: disabled,
            tabIndex: tabIndex,
            ref: ref,
            type: "button",
            role: "radio",
            "aria-current": ariaCurrent,
            "aria-checked": selected,
            "aria-label": ariaLabel,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: props,
        className: classes.monthButton
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)($5502a6a83e1e635e$var$PickersMonthRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)(MonthButton, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, monthButtonProps))
    }));
});




function $13662eeab8882e9a$export$da0c97315339ebd9(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiMonthCalendar", slot);
}
const $13662eeab8882e9a$export$edf77d5566c7007c = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiMonthCalendar", [
    "root"
]);








var $3Py8h = parcelRequire("3Py8h");
"use client";
const $985a950487959c2b$var$_excluded = [
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "autoFocus",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $985a950487959c2b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $13662eeab8882e9a$export$da0c97315339ebd9), classes);
};
function $985a950487959c2b$export$5b6e066572408095(props, name) {
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const defaultDates = (0, $f3e8032daddc32c6$export$7c38da3a2e90fa83)();
    const themeProps = (0, $gADeF.default)({
        props: props,
        name: name
    });
    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        disableFuture: false,
        disablePast: false
    }, themeProps, {
        minDate: (0, $2c8437f6b047f676$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $2c8437f6b047f676$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $985a950487959c2b$var$MonthCalendarRoot = (0, $npagc.default)("div", {
    name: "MuiMonthCalendar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexWrap: "wrap",
    alignContent: "stretch",
    padding: "0 4px",
    width: (0, $790faeda284dc7ce$export$ee46b8a74d6c94d3),
    // avoid padding increasing width over defined
    boxSizing: "border-box"
});
const $985a950487959c2b$export$d7a7c85c0f5afc4a = /*#__PURE__*/ $1T1QG.forwardRef(function MonthCalendar(inProps, ref) {
    const props = $985a950487959c2b$export$5b6e066572408095(inProps, "MuiMonthCalendar");
    const { className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, autoFocus: autoFocus = false, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, monthsPerRow: monthsPerRow = 3, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $985a950487959c2b$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $1370ae3083e8f472$export$174d749f3b4c0f49)({
        name: "MonthCalendar",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $59c1a689a11004ea$export$2764b246aa3b75ba)
    });
    const now = (0, $f3e8032daddc32c6$export$3a404aece3dff2fa)(timezone);
    const isRtl = (0, $a69327a401bfde77$export$b2dd014b6c321cb)();
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const referenceDate = $1T1QG.useMemo(()=>(0, $59c1a689a11004ea$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $101a7d0ae47539cf$export$8f74e8f4ed8ae0ac).month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $985a950487959c2b$var$useUtilityClasses(ownerState);
    const todayMonth = $1T1QG.useMemo(()=>utils.getMonth(now), [
        utils,
        now
    ]);
    const selectedMonth = $1T1QG.useMemo(()=>{
        if (value != null) return utils.getMonth(value);
        return null;
    }, [
        value,
        utils
    ]);
    const [focusedMonth, setFocusedMonth] = $1T1QG.useState(()=>selectedMonth || utils.getMonth(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $9790f3f3f5426a25$export$2e2bcd8739ae039)({
        name: "MonthCalendar",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = $1T1QG.useCallback((dateToValidate)=>{
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = utils.startOfMonth(dateToValidate);
        if (utils.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (utils.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        utils
    ]);
    const handleMonthSelection = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event, month)=>{
        if (readOnly) return;
        const newDate = utils.setMonth(value ?? referenceDate, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((month)=>{
        if (!isMonthDisabled(utils.setMonth(value ?? referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    $1T1QG.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case "ArrowUp":
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowDown":
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowLeft":
                focusMonth((monthsInYear + month + (isRtl ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowRight":
                focusMonth((monthsInYear + month + (isRtl ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)($985a950487959c2b$var$MonthCalendarRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: (0, $2c8437f6b047f676$export$62591b96a734eacd)(utils, value ?? referenceDate).map((month)=>{
            const monthNumber = utils.getMonth(month);
            const monthText = utils.format(month, "monthShort");
            const monthLabel = utils.format(month, "month");
            const isSelected = monthNumber === selectedMonth;
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $5502a6a83e1e635e$export$bc52fdb7f02f591a), {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth && !isDisabled ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": todayMonth === monthNumber ? "date" : undefined,
                "aria-label": monthLabel,
                monthsPerRow: monthsPerRow,
                slots: slots,
                slotProps: slotProps,
                children: monthText
            }, monthText);
        })
    }));
});





var $1T1QG = parcelRequire("1T1QG");




var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");




var $1T1QG = parcelRequire("1T1QG");


var $7Etkp = parcelRequire("7Etkp");
var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");




function $ad9b4a74dc8adb8a$export$183c9f339a61cd79(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiPickersYear", slot);
}
const $ad9b4a74dc8adb8a$export$4ef58a3d9c6f4296 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiPickersYear", [
    "root",
    "yearButton",
    "selected",
    "disabled"
]);



var $3Py8h = parcelRequire("3Py8h");
const $f801d9e496bcd8bb$var$_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "yearsPerRow",
    "slots",
    "slotProps"
];
const $f801d9e496bcd8bb$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        yearButton: [
            "yearButton",
            disabled && "disabled",
            selected && "selected"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $ad9b4a74dc8adb8a$export$183c9f339a61cd79), classes);
};
const $f801d9e496bcd8bb$var$PickersYearRoot = (0, $npagc.default)("div", {
    name: "MuiPickersYear",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexBasis: "33.3%",
    variants: [
        {
            props: {
                yearsPerRow: 4
            },
            style: {
                flexBasis: "25%"
            }
        }
    ]
});
const $f801d9e496bcd8bb$var$YearCalendarButton = (0, $npagc.default)("button", {
    name: "MuiPickersYear",
    slot: "YearButton",
    overridesResolver: (_, styles)=>[
            styles.yearButton,
            {
                [`&.${(0, $ad9b4a74dc8adb8a$export$4ef58a3d9c6f4296).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $ad9b4a74dc8adb8a$export$4ef58a3d9c6f4296).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        color: "unset",
        backgroundColor: "transparent",
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: "6px 0",
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: "pointer",
        "&:focus": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $7Etkp.alpha)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7Etkp.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:disabled": {
            cursor: "auto",
            pointerEvents: "none"
        },
        [`&.${(0, $ad9b4a74dc8adb8a$export$4ef58a3d9c6f4296).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $ad9b4a74dc8adb8a$export$4ef58a3d9c6f4296).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            "&:focus, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $f801d9e496bcd8bb$export$261f3fbd5fd5814d = /*#__PURE__*/ $1T1QG.memo(function PickersYear(inProps) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersYear"
    });
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, "aria-current": ariaCurrent, slots: slots, slotProps: slotProps } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $f801d9e496bcd8bb$var$_excluded);
    const ref = $1T1QG.useRef(null);
    const classes = $f801d9e496bcd8bb$var$useUtilityClasses(props);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $1c8a785890e03d41$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const YearButton = slots?.yearButton ?? $f801d9e496bcd8bb$var$YearCalendarButton;
    const yearButtonProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: YearButton,
        externalSlotProps: slotProps?.yearButton,
        additionalProps: {
            children: children,
            disabled: disabled,
            tabIndex: tabIndex,
            ref: ref,
            type: "button",
            role: "radio",
            "aria-current": ariaCurrent,
            "aria-checked": selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: props,
        className: classes.yearButton
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)($f801d9e496bcd8bb$var$PickersYearRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)(YearButton, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, yearButtonProps))
    }));
});




function $2669d4505d7496a4$export$4477acc520094dec(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiYearCalendar", slot);
}
const $2669d4505d7496a4$export$e42d427cd9fe5fd7 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiYearCalendar", [
    "root"
]);








var $3Py8h = parcelRequire("3Py8h");
"use client";
const $a3694eb26bd305c5$var$_excluded = [
    "autoFocus",
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsOrder",
    "yearsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $a3694eb26bd305c5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $2669d4505d7496a4$export$4477acc520094dec), classes);
};
function $a3694eb26bd305c5$var$useYearCalendarDefaultizedProps(props, name) {
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const defaultDates = (0, $f3e8032daddc32c6$export$7c38da3a2e90fa83)();
    const themeProps = (0, $gADeF.default)({
        props: props,
        name: name
    });
    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        disablePast: false,
        disableFuture: false
    }, themeProps, {
        yearsPerRow: themeProps.yearsPerRow ?? 3,
        minDate: (0, $2c8437f6b047f676$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $2c8437f6b047f676$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $a3694eb26bd305c5$var$YearCalendarRoot = (0, $npagc.default)("div", {
    name: "MuiYearCalendar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    overflowY: "auto",
    height: "100%",
    padding: "0 4px",
    width: (0, $790faeda284dc7ce$export$ee46b8a74d6c94d3),
    maxHeight: (0, $790faeda284dc7ce$export$73724491020e90c7),
    // avoid padding increasing width over defined
    boxSizing: "border-box",
    position: "relative"
});
const $a3694eb26bd305c5$export$657f9200591b2b71 = /*#__PURE__*/ $1T1QG.forwardRef(function YearCalendar(inProps, ref) {
    const props = $a3694eb26bd305c5$var$useYearCalendarDefaultizedProps(inProps, "MuiYearCalendar");
    const { autoFocus: autoFocus, className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, yearsOrder: yearsOrder = "asc", yearsPerRow: yearsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $a3694eb26bd305c5$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $1370ae3083e8f472$export$174d749f3b4c0f49)({
        name: "YearCalendar",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $59c1a689a11004ea$export$2764b246aa3b75ba)
    });
    const now = (0, $f3e8032daddc32c6$export$3a404aece3dff2fa)(timezone);
    const isRtl = (0, $a69327a401bfde77$export$b2dd014b6c321cb)();
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const referenceDate = $1T1QG.useMemo(()=>(0, $59c1a689a11004ea$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $101a7d0ae47539cf$export$8f74e8f4ed8ae0ac).year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $a3694eb26bd305c5$var$useUtilityClasses(ownerState);
    const todayYear = $1T1QG.useMemo(()=>utils.getYear(now), [
        utils,
        now
    ]);
    const selectedYear = $1T1QG.useMemo(()=>{
        if (value != null) return utils.getYear(value);
        return null;
    }, [
        value,
        utils
    ]);
    const [focusedYear, setFocusedYear] = $1T1QG.useState(()=>selectedYear || utils.getYear(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $9790f3f3f5426a25$export$2e2bcd8739ae039)({
        name: "YearCalendar",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = $1T1QG.useCallback((dateToValidate)=>{
        if (disablePast && utils.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && utils.isAfterYear(dateToValidate, now)) return true;
        if (minDate && utils.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = utils.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        utils
    ]);
    const handleYearSelection = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event, year)=>{
        if (readOnly) return;
        const newDate = utils.setYear(value ?? referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((year)=>{
        if (!isYearDisabled(utils.setYear(value ?? referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus?.(year);
        }
    });
    $1T1QG.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const verticalDirection = yearsOrder !== "desc" ? yearsPerRow * 1 : yearsPerRow * -1;
    const horizontalDirection = isRtl && yearsOrder === "asc" || !isRtl && yearsOrder === "desc" ? -1 : 1;
    const handleKeyDown = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event, year)=>{
        switch(event.key){
            case "ArrowUp":
                focusYear(year - verticalDirection);
                event.preventDefault();
                break;
            case "ArrowDown":
                focusYear(year + verticalDirection);
                event.preventDefault();
                break;
            case "ArrowLeft":
                focusYear(year - horizontalDirection);
                event.preventDefault();
                break;
            case "ArrowRight":
                focusYear(year + horizontalDirection);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = $1T1QG.useRef(null);
    const handleRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(ref, scrollerRef);
    $1T1QG.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    const yearRange = utils.getYearRange([
        minDate,
        maxDate
    ]);
    if (yearsOrder === "desc") yearRange.reverse();
    return /*#__PURE__*/ (0, $3Py8h.jsx)($a3694eb26bd305c5$var$YearCalendarRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        ref: handleRef,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: yearRange.map((year)=>{
            const yearNumber = utils.getYear(year);
            const isSelected = yearNumber === selectedYear;
            const isDisabled = disabled || isYearDisabled(year);
            return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f801d9e496bcd8bb$export$261f3fbd5fd5814d), {
                selected: isSelected,
                value: yearNumber,
                onClick: handleYearSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && yearNumber === focusedYear,
                disabled: isDisabled,
                tabIndex: yearNumber === focusedYear && !isDisabled ? 0 : -1,
                onFocus: handleYearFocus,
                onBlur: handleYearBlur,
                "aria-current": todayYear === yearNumber ? "date" : undefined,
                yearsPerRow: yearsPerRow,
                slots: slots,
                slotProps: slotProps,
                children: utils.format(year, "year")
            }, utils.format(year, "year"));
        })
    }));
});



var $1T1QG = parcelRequire("1T1QG");


let $1d4419ac03a36f0f$var$warnedOnceNotValidView = false;
function $1d4419ac03a36f0f$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: inView, views: views, autoFocus: autoFocus, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange }) {
    const previousOpenTo = $1T1QG.useRef(openTo);
    const previousViews = $1T1QG.useRef(views);
    const defaultView = $1T1QG.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, $9790f3f3f5426a25$export$2e2bcd8739ae039)({
        name: "useViews",
        state: "view",
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = $1T1QG.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, $9790f3f3f5426a25$export$2e2bcd8739ae039)({
        name: "useViews",
        state: "focusedView",
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    $1T1QG.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = views[viewIndex - 1] ?? null;
    const nextView = views[viewIndex + 1] ?? null;
    const handleFocusedViewChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange?.(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newView)=>{
        // always keep the focused view in sync
        handleFocusedViewChange(newView, true);
        if (newView === view) return;
        setView(newView);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)(()=>{
        if (nextView) handleChangeView(nextView);
    });
    const setValueAndGoToNextView = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === "finish";
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but when it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? "partial" : currentViewSelectionState;
        onChange(value, globalSelectionState, selectedView);
        // Detects if the selected view is not the active one.
        // Can happen if multiple views are displayed, like in `DesktopDateTimePicker` or `MultiSectionDigitalClock`.
        if (selectedView && selectedView !== view) {
            const nextViewAfterSelected = views[views.indexOf(selectedView) + 1];
            if (nextViewAfterSelected) // move to next view after the selected one
            handleChangeView(nextViewAfterSelected);
        } else if (isSelectionFinishedOnCurrentView) goToNextView();
    });
    return {
        view: view,
        setView: handleChangeView,
        focusedView: focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView: nextView,
        previousView: previousView,
        // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
        defaultView: views.includes(openTo) ? openTo : views[0],
        goToNextView: goToNextView,
        setValueAndGoToNextView: setValueAndGoToNextView
    };
}





var $1T1QG = parcelRequire("1T1QG");




var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");










var $1T1QG = parcelRequire("1T1QG");




var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");





function $ad98128bf9fcdf53$export$cef978c25740de90(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiPickersArrowSwitcher", slot);
}
const $ad98128bf9fcdf53$export$f8819209558cd362 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiPickersArrowSwitcher", [
    "root",
    "spacer",
    "button",
    "previousIconButton",
    "nextIconButton",
    "leftArrowIcon",
    "rightArrowIcon"
]);



var $3Py8h = parcelRequire("3Py8h");
const $dc1cb27af374d73a$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel",
    "labelId"
], $dc1cb27af374d73a$var$_excluded2 = [
    "ownerState"
], $dc1cb27af374d73a$var$_excluded3 = [
    "ownerState"
];
const $dc1cb27af374d73a$var$PickersArrowSwitcherRoot = (0, $npagc.default)("div", {
    name: "MuiPickersArrowSwitcher",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex"
});
const $dc1cb27af374d73a$var$PickersArrowSwitcherSpacer = (0, $npagc.default)("div", {
    name: "MuiPickersArrowSwitcher",
    slot: "Spacer",
    overridesResolver: (props, styles)=>styles.spacer
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $dc1cb27af374d73a$var$PickersArrowSwitcherButton = (0, $npagc.default)((0, $5c784366741908ee$export$2e2bcd8739ae039), {
    name: "MuiPickersArrowSwitcher",
    slot: "Button",
    overridesResolver: (props, styles)=>styles.button
})({
    variants: [
        {
            props: {
                hidden: true
            },
            style: {
                visibility: "hidden"
            }
        }
    ]
});
const $dc1cb27af374d73a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        spacer: [
            "spacer"
        ],
        button: [
            "button"
        ],
        previousIconButton: [
            "previousIconButton"
        ],
        nextIconButton: [
            "nextIconButton"
        ],
        leftArrowIcon: [
            "leftArrowIcon"
        ],
        rightArrowIcon: [
            "rightArrowIcon"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $ad98128bf9fcdf53$export$cef978c25740de90), classes);
};
const $dc1cb27af374d73a$export$597b7cbdb7b2a24c = /*#__PURE__*/ $1T1QG.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    const isRtl = (0, $a69327a401bfde77$export$b2dd014b6c321cb)();
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersArrowSwitcher"
    });
    const { children: children, className: className, slots: slots, slotProps: slotProps, isNextDisabled: isNextDisabled, isNextHidden: isNextHidden, onGoToNext: onGoToNext, nextLabel: nextLabel, isPreviousDisabled: isPreviousDisabled, isPreviousHidden: isPreviousHidden, onGoToPrevious: onGoToPrevious, previousLabel: previousLabel, labelId: labelId } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $dc1cb27af374d73a$var$_excluded);
    const ownerState = props;
    const classes = $dc1cb27af374d73a$var$useUtilityClasses(ownerState);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const PreviousIconButton = slots?.previousIconButton ?? $dc1cb27af374d73a$var$PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps?.previousIconButton,
        additionalProps: {
            size: "medium",
            title: previousProps.label,
            "aria-label": previousProps.label,
            disabled: previousProps.isDisabled,
            edge: "end",
            onClick: previousProps.goTo
        },
        ownerState: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, ownerState, {
            hidden: previousProps.isHidden
        }),
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.button, classes.previousIconButton)
    });
    const NextIconButton = slots?.nextIconButton ?? $dc1cb27af374d73a$var$PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: NextIconButton,
        externalSlotProps: slotProps?.nextIconButton,
        additionalProps: {
            size: "medium",
            title: nextProps.label,
            "aria-label": nextProps.label,
            disabled: nextProps.isDisabled,
            edge: "start",
            onClick: nextProps.goTo
        },
        ownerState: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, ownerState, {
            hidden: nextProps.isHidden
        }),
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.button, classes.nextIconButton)
    });
    const LeftArrowIcon = slots?.leftArrowIcon ?? (0, $705a86f4b9915dac$export$8afed21ef5c2afa5);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps?.leftArrowIcon,
        additionalProps: {
            fontSize: "inherit"
        },
        ownerState: ownerState,
        className: classes.leftArrowIcon
    }), leftArrowIconProps = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_useSlotProps, $dc1cb27af374d73a$var$_excluded2);
    const RightArrowIcon = slots?.rightArrowIcon ?? (0, $705a86f4b9915dac$export$9ca09caa9c849d9c);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps?.rightArrowIcon,
        additionalProps: {
            fontSize: "inherit"
        },
        ownerState: ownerState,
        className: classes.rightArrowIcon
    }), rightArrowIconProps = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_useSlotProps2, $dc1cb27af374d73a$var$_excluded3);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($dc1cb27af374d73a$var$PickersArrowSwitcherRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)(PreviousIconButton, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, previousIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $3Py8h.jsx)(RightArrowIcon, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, $3Py8h.jsx)(LeftArrowIcon, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a386176d6ca21602$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                component: "span",
                id: labelId,
                children: children
            }) : /*#__PURE__*/ (0, $3Py8h.jsx)($dc1cb27af374d73a$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)(NextIconButton, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $3Py8h.jsx)(LeftArrowIcon, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, $3Py8h.jsx)(RightArrowIcon, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, rightArrowIconProps))
            }))
        ]
    }));
});




const $44b7b7980ab0e7dc$export$457ac4d3a1ad92b4 = (slot)=>(0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiPickersCalendarHeader", slot);
const $44b7b7980ab0e7dc$export$63db7afb9247cb91 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiPickersCalendarHeader", [
    "root",
    "labelContainer",
    "label",
    "switchViewButton",
    "switchViewIcon"
]);



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $896cb0d181524f2c$var$_excluded = [
    "slots",
    "slotProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "timezone",
    "format"
], $896cb0d181524f2c$var$_excluded2 = [
    "ownerState"
];
const $896cb0d181524f2c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        labelContainer: [
            "labelContainer"
        ],
        label: [
            "label"
        ],
        switchViewButton: [
            "switchViewButton"
        ],
        switchViewIcon: [
            "switchViewIcon"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $44b7b7980ab0e7dc$export$457ac4d3a1ad92b4), classes);
};
const $896cb0d181524f2c$var$PickersCalendarHeaderRoot = (0, $npagc.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    display: "flex",
    alignItems: "center",
    marginTop: 12,
    marginBottom: 4,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 40,
    minHeight: 40
});
const $896cb0d181524f2c$var$PickersCalendarHeaderLabelContainer = (0, $npagc.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "LabelContainer",
    overridesResolver: (_, styles)=>styles.labelContainer
})(({ theme: theme })=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        display: "flex",
        overflow: "hidden",
        alignItems: "center",
        cursor: "pointer",
        marginRight: "auto"
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $896cb0d181524f2c$var$PickersCalendarHeaderLabel = (0, $npagc.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "Label",
    overridesResolver: (_, styles)=>styles.label
})({
    marginRight: 6
});
const $896cb0d181524f2c$var$PickersCalendarHeaderSwitchViewButton = (0, $npagc.default)((0, $5c784366741908ee$export$2e2bcd8739ae039), {
    name: "MuiPickersCalendarHeader",
    slot: "SwitchViewButton",
    overridesResolver: (_, styles)=>styles.switchViewButton
})({
    marginRight: "auto",
    variants: [
        {
            props: {
                view: "year"
            },
            style: {
                [`.${(0, $44b7b7980ab0e7dc$export$63db7afb9247cb91).switchViewIcon}`]: {
                    transform: "rotate(180deg)"
                }
            }
        }
    ]
});
const $896cb0d181524f2c$var$PickersCalendarHeaderSwitchViewIcon = (0, $npagc.default)((0, $705a86f4b9915dac$export$ed0fe318cc298673), {
    name: "MuiPickersCalendarHeader",
    slot: "SwitchViewIcon",
    overridesResolver: (_, styles)=>styles.switchViewIcon
})(({ theme: theme })=>({
        willChange: "transform",
        transition: theme.transitions.create("transform"),
        transform: "rotate(0deg)"
    }));
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [PickersCalendarHeader API](https://mui.com/x/api/date-pickers/pickers-calendar-header/)
 */ const $896cb0d181524f2c$export$6801ffebb353f473 = /*#__PURE__*/ $1T1QG.forwardRef(function PickersCalendarHeader(inProps, ref) {
    const translations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersCalendarHeader"
    });
    const { slots: slots, slotProps: slotProps, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, view: view, reduceAnimations: reduceAnimations, views: views, labelId: labelId, className: className, timezone: timezone, format: format = `${utils.formats.month} ${utils.formats.year}` } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $896cb0d181524f2c$var$_excluded);
    const ownerState = props;
    const classes = $896cb0d181524f2c$var$useUtilityClasses(props);
    const SwitchViewButton = slots?.switchViewButton ?? $896cb0d181524f2c$var$PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps?.switchViewButton,
        additionalProps: {
            size: "small",
            "aria-label": translations.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState: ownerState,
        className: classes.switchViewButton
    });
    const SwitchViewIcon = slots?.switchViewIcon ?? $896cb0d181524f2c$var$PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps?.switchViewIcon,
        ownerState: ownerState,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_useSlotProps, $896cb0d181524f2c$var$_excluded2);
    const selectNextMonth = ()=>onMonthChange(utils.addMonths(month, 1), "left");
    const selectPreviousMonth = ()=>onMonthChange(utils.addMonths(month, -1), "right");
    const isNextMonthDisabled = (0, $395c14dbcebe680a$export$923e8cc135843169)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $395c14dbcebe680a$export$3b46d38ff4932cf7)(month, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === "year") return null;
    const label = utils.formatByString(month, format);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($896cb0d181524f2c$var$PickersCalendarHeaderRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, other, {
        ownerState: ownerState,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsxs)($896cb0d181524f2c$var$PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $fdb3247e09c40c07$export$5262185daf493fee), {
                        reduceAnimations: reduceAnimations,
                        transKey: label,
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)($896cb0d181524f2c$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: label
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $3Py8h.jsx)(SwitchViewButton, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)(SwitchViewIcon, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a2c582129c3c8d70$export$2e2bcd8739ae039), {
                in: view === "day",
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $dc1cb27af374d73a$export$597b7cbdb7b2a24c), {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: translations.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: translations.nextMonth
                })
            })
        ]
    }));
});




var $npagc = parcelRequire("npagc");

const $b49f245ba7b9ee5c$export$512b066b8abdfde4 = (0, $npagc.default)("div")({
    overflow: "hidden",
    width: (0, $790faeda284dc7ce$export$ee46b8a74d6c94d3),
    maxHeight: (0, $790faeda284dc7ce$export$f2fef360e2df0cb7),
    display: "flex",
    flexDirection: "column",
    margin: "0 auto"
});



const $376c8e4955882030$var$PREFERS_REDUCED_MOTION = "@media (prefers-reduced-motion: reduce)";
// detect if user agent has Android version < 10 or iOS version < 13
const $376c8e4955882030$var$mobileVersionMatches = typeof navigator !== "undefined" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const $376c8e4955882030$var$androidVersion = $376c8e4955882030$var$mobileVersionMatches && $376c8e4955882030$var$mobileVersionMatches[1] ? parseInt($376c8e4955882030$var$mobileVersionMatches[1], 10) : null;
const $376c8e4955882030$var$iOSVersion = $376c8e4955882030$var$mobileVersionMatches && $376c8e4955882030$var$mobileVersionMatches[2] ? parseInt($376c8e4955882030$var$mobileVersionMatches[2], 10) : null;
const $376c8e4955882030$export$7e3b2a595fb375e5 = $376c8e4955882030$var$androidVersion && $376c8e4955882030$var$androidVersion < 10 || $376c8e4955882030$var$iOSVersion && $376c8e4955882030$var$iOSVersion < 13 || false;
const $376c8e4955882030$export$ce40fb97be7f02d9 = ()=>{
    const prefersReduced = (0, $ffad103d3c7e3bc8$export$2e2bcd8739ae039)($376c8e4955882030$var$PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    return prefersReduced || $376c8e4955882030$export$7e3b2a595fb375e5;
};



const $be80c465e03f9bb8$export$da8c2318897a6672 = (slot)=>(0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiDateCalendar", slot);
const $be80c465e03f9bb8$export$d0237e2bb9598e8d = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiDateCalendar", [
    "root",
    "viewTransitionContainer"
]);






var $3Py8h = parcelRequire("3Py8h");
"use client";
const $b4b79aeb5fb212c2$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsOrder",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const $b4b79aeb5fb212c2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        viewTransitionContainer: [
            "viewTransitionContainer"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $be80c465e03f9bb8$export$da8c2318897a6672), classes);
};
function $b4b79aeb5fb212c2$var$useDateCalendarDefaultizedProps(props, name) {
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const defaultDates = (0, $f3e8032daddc32c6$export$7c38da3a2e90fa83)();
    const defaultReduceAnimations = (0, $376c8e4955882030$export$ce40fb97be7f02d9)();
    const themeProps = (0, $gADeF.default)({
        props: props,
        name: name
    });
    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, themeProps, {
        loading: themeProps.loading ?? false,
        disablePast: themeProps.disablePast ?? false,
        disableFuture: themeProps.disableFuture ?? false,
        openTo: themeProps.openTo ?? "day",
        views: themeProps.views ?? [
            "year",
            "day"
        ],
        reduceAnimations: themeProps.reduceAnimations ?? defaultReduceAnimations,
        renderLoading: themeProps.renderLoading ?? (()=>/*#__PURE__*/ (0, $3Py8h.jsx)("span", {
                children: "..."
            })),
        minDate: (0, $2c8437f6b047f676$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $2c8437f6b047f676$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $b4b79aeb5fb212c2$var$DateCalendarRoot = (0, $npagc.default)((0, $b49f245ba7b9ee5c$export$512b066b8abdfde4), {
    name: "MuiDateCalendar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "column",
    height: (0, $790faeda284dc7ce$export$f2fef360e2df0cb7)
});
const $b4b79aeb5fb212c2$var$DateCalendarViewTransitionContainer = (0, $npagc.default)((0, $fdb3247e09c40c07$export$5262185daf493fee), {
    name: "MuiDateCalendar",
    slot: "ViewTransitionContainer",
    overridesResolver: (props, styles)=>styles.viewTransitionContainer
})({});
const $b4b79aeb5fb212c2$export$68078fe5d2bf8909 = /*#__PURE__*/ $1T1QG.forwardRef(function DateCalendar(inProps, ref) {
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const id = (0, $ea1f3283f0dc1f21$export$2e2bcd8739ae039)();
    const props = $b4b79aeb5fb212c2$var$useDateCalendarDefaultizedProps(inProps, "MuiDateCalendar");
    const { autoFocus: autoFocus, onViewChange: onViewChange, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, onChange: onChange, onYearChange: onYearChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: inView, views: views, openTo: openTo, className: className, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, fixedWeekNumber: fixedWeekNumber, dayOfWeekFormatter: dayOfWeekFormatter, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, displayWeekNumber: displayWeekNumber, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, monthsPerRow: monthsPerRow, timezone: timezoneProp } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $b4b79aeb5fb212c2$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $1370ae3083e8f472$export$174d749f3b4c0f49)({
        name: "DateCalendar",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $59c1a689a11004ea$export$2764b246aa3b75ba)
    });
    const { view: view, setView: setView, focusedView: focusedView, setFocusedView: setFocusedView, goToNextView: goToNextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $1d4419ac03a36f0f$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { referenceDate: referenceDate, calendarState: calendarState, changeFocusedDay: changeFocusedDay, changeMonth: changeMonth, handleChangeMonth: handleChangeMonth, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $c6908850d6e5602f$export$6d095e787d2b5e1f)({
        value: value,
        referenceDate: referenceDateProp,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    const CalendarHeader = slots?.calendarHeader ?? (0, $896cb0d181524f2c$export$6801ffebb353f473);
    const calendarHeaderProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: CalendarHeader,
        externalSlotProps: slotProps?.calendarHeader,
        additionalProps: {
            views: views,
            view: view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (newMonth, direction)=>handleChangeMonth({
                    newMonth: newMonth,
                    direction: direction
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled: disabled,
            disablePast: disablePast,
            disableFuture: disableFuture,
            reduceAnimations: reduceAnimations,
            timezone: timezone,
            labelId: gridLabelId
        },
        ownerState: props
    });
    const handleDateMonthChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newDate)=>{
        const startOfMonth = utils.startOfMonth(newDate);
        const endOfMonth = utils.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $2c8437f6b047f676$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, "finish");
            onMonthChange?.(startOfMonth);
        } else {
            goToNextView();
            changeMonth(startOfMonth);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleDateYearChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newDate)=>{
        const startOfYear = utils.startOfYear(newDate);
        const endOfYear = utils.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $2c8437f6b047f676$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, "finish");
            onYearChange?.(closestEnabledDate);
        } else {
            goToNextView();
            changeMonth(startOfYear);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleSelectedDayChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, $2c8437f6b047f676$export$a98b123b8f29e004)(utils, day, value ?? referenceDate), "finish", view);
        return handleValueChange(day, "finish", view);
    });
    $1T1QG.useEffect(()=>{
        if (value != null && utils.isValid(value)) changeMonth(value);
    }, [
        value
    ]); // eslint-disable-line
    const ownerState = props;
    const classes = $b4b79aeb5fb212c2$var$useUtilityClasses(ownerState);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        timezone: timezone,
        gridLabelId: gridLabelId,
        slots: slots,
        slotProps: slotProps
    };
    const prevOpenViewRef = $1T1QG.useRef(view);
    $1T1QG.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = $1T1QG.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($b4b79aeb5fb212c2$var$DateCalendarRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)(CalendarHeader, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, calendarHeaderProps, {
                slots: slots,
                slotProps: slotProps
            })),
            /*#__PURE__*/ (0, $3Py8h.jsx)($b4b79aeb5fb212c2$var$DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $3Py8h.jsxs)("div", {
                    children: [
                        view === "year" && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a3694eb26bd305c5$export$657f9200591b2b71), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView("year", isViewFocused),
                            yearsOrder: yearsOrder,
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === "month" && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $985a950487959c2b$export$d7a7c85c0f5afc4a), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, baseDateValidationProps, commonViewProps, {
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView("month", isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === "day" && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a4d416cf529486fb$export$8fb56b32a5df6314), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView("day", isViewFocused),
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});




var $3Py8h = parcelRequire("3Py8h");
const $e5272c464051a472$export$69888ffe06193e5e = ({ view: view, onViewChange: onViewChange, views: views, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, monthsPerRow: monthsPerRow, onYearChange: onYearChange, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, displayWeekNumber: displayWeekNumber, timezone: timezone })=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $b4b79aeb5fb212c2$export$68078fe5d2bf8909), {
        view: view,
        onViewChange: onViewChange,
        views: views.filter((0, $2c8437f6b047f676$export$b32dfef9f07dea64)),
        focusedView: focusedView && (0, $2c8437f6b047f676$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsOrder: yearsOrder,
        yearsPerRow: yearsPerRow,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });









var $1T1QG = parcelRequire("1T1QG");








var $1T1QG = parcelRequire("1T1QG");






function $ea2c312fb50cb417$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");

function $186f7c57edde8759$export$5519b4d4bf80ce6f(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiPickersPopper", slot);
}
const $186f7c57edde8759$export$46e9184c9b1af0ce = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiPickersPopper", [
    "root",
    "paper"
]);





var $3Py8h = parcelRequire("3Py8h");
const $c48ba6440e847340$var$_excluded = [
    "PaperComponent",
    "popperPlacement",
    "ownerState",
    "children",
    "paperSlotProps",
    "paperClasses",
    "onPaperClick",
    "onPaperTouchStart"
];
const $c48ba6440e847340$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $186f7c57edde8759$export$5519b4d4bf80ce6f), classes);
};
const $c48ba6440e847340$var$PickersPopperRoot = (0, $npagc.default)((0, $9523926f49e29683$export$2e2bcd8739ae039), {
    name: "MuiPickersPopper",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $c48ba6440e847340$var$PickersPopperPaper = (0, $npagc.default)((0, $0a163fcc25046a25$export$2e2bcd8739ae039), {
    name: "MuiPickersPopper",
    slot: "Paper",
    overridesResolver: (_, styles)=>styles.paper
})({
    outline: 0,
    transformOrigin: "top center",
    variants: [
        {
            props: ({ placement: placement })=>[
                    "top",
                    "top-start",
                    "top-end"
                ].includes(placement),
            style: {
                transformOrigin: "bottom center"
            }
        }
    ]
});
function $c48ba6440e847340$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function $c48ba6440e847340$var$useClickAwayListener(active, onClickAway) {
    const movedRef = $1T1QG.useRef(false);
    const syntheticEventRef = $1T1QG.useRef(false);
    const nodeRef = $1T1QG.useRef(null);
    const activatedRef = $1T1QG.useRef(false);
    $1T1QG.useEffect(()=>{
        if (!active) return undefined;
        // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener("mousedown", armClickAwayListener, true);
        document.addEventListener("touchstart", armClickAwayListener, true);
        return ()=>{
            document.removeEventListener("mousedown", armClickAwayListener, true);
            document.removeEventListener("touchstart", armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        if (!activatedRef.current) return;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $ea2c312fb50cb417$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        "clientX" in event && $c48ba6440e847340$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = ()=>{
        syntheticEventRef.current = true;
    };
    $1T1QG.useEffect(()=>{
        if (active) {
            const doc = (0, $ea2c312fb50cb417$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener("touchstart", handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener("touchstart", handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    $1T1QG.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (for example setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, $ea2c312fb50cb417$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener("click", handleClickAway);
            return ()=>{
                doc.removeEventListener("click", handleClickAway);
                // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
const $c48ba6440e847340$var$PickersPopperPaperWrapper = /*#__PURE__*/ $1T1QG.forwardRef((props, ref)=>{
    const { PaperComponent: PaperComponent, popperPlacement: popperPlacement, ownerState: inOwnerState, children: children, paperSlotProps: paperSlotProps, paperClasses: paperClasses, onPaperClick: onPaperClick, onPaperTouchStart: onPaperTouchStart } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $c48ba6440e847340$var$_excluded);
    const ownerState = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, inOwnerState, {
        placement: popperPlacement
    });
    const paperProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: PaperComponent,
        externalSlotProps: paperSlotProps,
        additionalProps: {
            tabIndex: -1,
            elevation: 8,
            ref: ref
        },
        className: paperClasses,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)(PaperComponent, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, other, paperProps, {
        onClick: (event)=>{
            onPaperClick(event);
            paperProps.onClick?.(event);
        },
        onTouchStart: (event)=>{
            onPaperTouchStart(event);
            paperProps.onTouchStart?.(event);
        },
        ownerState: ownerState,
        children: children
    }));
});
function $c48ba6440e847340$export$96ce8482474de8a5(inProps) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersPopper"
    });
    const { anchorEl: anchorEl, children: children, containerRef: containerRef = null, shouldRestoreFocus: shouldRestoreFocus, onBlur: onBlur, onDismiss: onDismiss, open: open, role: role, placement: placement, slots: slots, slotProps: slotProps, reduceAnimations: inReduceAnimations } = props;
    $1T1QG.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            if (open && nativeEvent.key === "Escape") onDismiss();
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        onDismiss,
        open
    ]);
    const lastFocusedElementRef = $1T1QG.useRef(null);
    $1T1QG.useEffect(()=>{
        if (role === "tooltip" || shouldRestoreFocus && !shouldRestoreFocus()) return;
        if (open) lastFocusedElementRef.current = (0, $68e3e92a73d67afe$export$cd4e5573fbe2b576)(document);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        role,
        shouldRestoreFocus
    ]);
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = $c48ba6440e847340$var$useClickAwayListener(open, onBlur ?? onDismiss);
    const paperRef = $1T1QG.useRef(null);
    const handleRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(paperRef, containerRef);
    const handlePaperRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(handleRef, clickAwayRef);
    const ownerState = props;
    const classes = $c48ba6440e847340$var$useUtilityClasses(ownerState);
    const defaultReduceAnimations = (0, $376c8e4955882030$export$ce40fb97be7f02d9)();
    const reduceAnimations = inReduceAnimations ?? defaultReduceAnimations;
    const handleKeyDown = (event)=>{
        if (event.key === "Escape") {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            onDismiss();
        }
    };
    const Transition = slots?.desktopTransition ?? reduceAnimations ? (0, $a2c582129c3c8d70$export$2e2bcd8739ae039) : (0, $e236f531d361181f$export$2e2bcd8739ae039);
    const FocusTrap = slots?.desktopTrapFocus ?? (0, $700e11d6df3fb857$export$34eba2437817a67b);
    const Paper = slots?.desktopPaper ?? $c48ba6440e847340$var$PickersPopperPaper;
    const Popper = slots?.popper ?? $c48ba6440e847340$var$PickersPopperRoot;
    const popperProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: Popper,
        externalSlotProps: slotProps?.popper,
        additionalProps: {
            transition: true,
            role: role,
            open: open,
            anchorEl: anchorEl,
            placement: placement,
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: props
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)(Popper, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, popperProps, {
        children: ({ TransitionProps: TransitionProps, placement: popperPlacement })=>/*#__PURE__*/ (0, $3Py8h.jsx)(FocusTrap, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                open: open,
                disableAutoFocus: true,
                disableRestoreFocus: true,
                disableEnforceFocus: role === "tooltip",
                isEnabled: ()=>true
            }, slotProps?.desktopTrapFocus, {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)(Transition, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, TransitionProps, slotProps?.desktopTransition, {
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)($c48ba6440e847340$var$PickersPopperPaperWrapper, {
                        PaperComponent: Paper,
                        ownerState: ownerState,
                        popperPlacement: popperPlacement,
                        ref: handlePaperRef,
                        onPaperClick: onPaperClick,
                        onPaperTouchStart: onPaperTouchStart,
                        paperClasses: classes.paper,
                        paperSlotProps: slotProps?.desktopPaper,
                        children: children
                    })
                }))
            }))
    }));
}





var $1T1QG = parcelRequire("1T1QG");


var $1T1QG = parcelRequire("1T1QG");
const $52169986238b1077$export$7d3a09d5141ab1f4 = ({ open: open, onOpen: onOpen, onClose: onClose })=>{
    const isControllingOpenProp = $1T1QG.useRef(typeof open === "boolean").current;
    const [openState, setIsOpenState] = $1T1QG.useState(false);
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (for example initially opened)
    $1T1QG.useEffect(()=>{
        if (isControllingOpenProp) {
            if (typeof open !== "boolean") throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
            setIsOpenState(open);
        }
    }, [
        isControllingOpenProp,
        open
    ]);
    const setIsOpen = $1T1QG.useCallback((newIsOpen)=>{
        if (!isControllingOpenProp) setIsOpenState(newIsOpen);
        if (newIsOpen && onOpen) onOpen();
        if (!newIsOpen && onClose) onClose();
    }, [
        isControllingOpenProp,
        onOpen,
        onClose
    ]);
    return {
        isOpen: openState,
        setIsOpen: setIsOpen
    };
};





/**
 * Decide if the new value should be published
 * The published value will be passed to `onChange` if defined.
 */ const $fd470aa9e09d6ff8$var$shouldPublishValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    // The field is responsible for only calling `onChange` when needed.
    if (action.name === "setValueFromField") return true;
    if (action.name === "setValueFromAction") {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to publish the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            "accept",
            "today",
            "clear"
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === "setValueFromView" && action.selectionState !== "shallow") {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === "setValueFromShortcut") {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    return false;
};
/**
 * Decide if the new value should be committed.
 * The committed value will be passed to `onAccept` if defined.
 * It will also be used as a reset target when calling the `cancel` picker action (when clicking on the "Cancel" button).
 */ const $fd470aa9e09d6ff8$var$shouldCommitValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled, closeOnSelect: closeOnSelect } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    if (action.name === "setValueFromAction") {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to commit the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            "accept",
            "today",
            "clear"
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === "setValueFromView" && action.selectionState === "finish" && closeOnSelect) {
        // On picker where the 1st view is also the last view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onAccept`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === "setValueFromShortcut") return action.changeImportance === "accept" && hasChanged(dateState.lastCommittedValue);
    return false;
};
/**
 * Decide if the picker should be closed after the value is updated.
 */ const $fd470aa9e09d6ff8$var$shouldClosePicker = (params)=>{
    const { action: action, closeOnSelect: closeOnSelect } = params;
    if (action.name === "setValueFromAction") return true;
    if (action.name === "setValueFromView") return action.selectionState === "finish" && closeOnSelect;
    if (action.name === "setValueFromShortcut") return action.changeImportance === "accept";
    return false;
};
const $fd470aa9e09d6ff8$export$799b22a7b7fffaa3 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, validator: validator })=>{
    const { onAccept: onAccept, onChange: onChange, value: inValueWithoutRenderTimezone, defaultValue: inDefaultValue, closeOnSelect: closeOnSelect = wrapperVariant === "desktop", timezone: timezoneProp } = props;
    const { current: defaultValue } = $1T1QG.useRef(inDefaultValue);
    const { current: isControlled } = $1T1QG.useRef(inValueWithoutRenderTimezone !== undefined);
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const adapter = (0, $f3e8032daddc32c6$export$4b5a24245de9f7f9)();
    const { isOpen: isOpen, setIsOpen: setIsOpen } = (0, $52169986238b1077$export$7d3a09d5141ab1f4)(props);
    const { timezone: timezone, value: inValueWithTimezoneToRender, handleValueChange: handleValueChange } = (0, $1370ae3083e8f472$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: inValueWithoutRenderTimezone,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    const [dateState, setDateState] = $1T1QG.useState(()=>{
        let initialValue;
        if (inValueWithTimezoneToRender !== undefined) initialValue = inValueWithTimezoneToRender;
        else if (defaultValue !== undefined) initialValue = defaultValue;
        else initialValue = valueManager.emptyValue;
        return {
            draft: initialValue,
            lastPublishedValue: initialValue,
            lastCommittedValue: initialValue,
            lastControlledValue: inValueWithTimezoneToRender,
            hasBeenModifiedSinceMount: false
        };
    });
    const { getValidationErrorForNewValue: getValidationErrorForNewValue } = (0, $7480e2bc04de1c42$export$87fe492f99f25a20)({
        props: props,
        validator: validator,
        timezone: timezone,
        value: dateState.draft,
        onError: props.onError
    });
    const updateDate = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((action)=>{
        const updaterParams = {
            action: action,
            dateState: dateState,
            hasChanged: (comparison)=>!valueManager.areValuesEqual(utils, action.value, comparison),
            isControlled: isControlled,
            closeOnSelect: closeOnSelect
        };
        const shouldPublish = $fd470aa9e09d6ff8$var$shouldPublishValue(updaterParams);
        const shouldCommit = $fd470aa9e09d6ff8$var$shouldCommitValue(updaterParams);
        const shouldClose = $fd470aa9e09d6ff8$var$shouldClosePicker(updaterParams);
        setDateState((prev)=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, prev, {
                draft: action.value,
                lastPublishedValue: shouldPublish ? action.value : prev.lastPublishedValue,
                lastCommittedValue: shouldCommit ? action.value : prev.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        let cachedContext = null;
        const getContext = ()=>{
            if (!cachedContext) {
                const validationError = action.name === "setValueFromField" ? action.context.validationError : getValidationErrorForNewValue(action.value);
                cachedContext = {
                    validationError: validationError
                };
                if (action.name === "setValueFromShortcut") cachedContext.shortcut = action.shortcut;
            }
            return cachedContext;
        };
        if (shouldPublish) handleValueChange(action.value, getContext());
        if (shouldCommit && onAccept) onAccept(action.value, getContext());
        if (shouldClose) setIsOpen(false);
    });
    if (inValueWithTimezoneToRender !== undefined && (dateState.lastControlledValue === undefined || !valueManager.areValuesEqual(utils, dateState.lastControlledValue, inValueWithTimezoneToRender))) {
        const isUpdateComingFromPicker = valueManager.areValuesEqual(utils, dateState.draft, inValueWithTimezoneToRender);
        setDateState((prev)=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, prev, {
                lastControlledValue: inValueWithTimezoneToRender
            }, isUpdateComingFromPicker ? {} : {
                lastCommittedValue: inValueWithTimezoneToRender,
                lastPublishedValue: inValueWithTimezoneToRender,
                draft: inValueWithTimezoneToRender,
                hasBeenModifiedSinceMount: true
            }));
    }
    const handleClear = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.emptyValue,
            name: "setValueFromAction",
            pickerAction: "clear"
        });
    });
    const handleAccept = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: "setValueFromAction",
            pickerAction: "accept"
        });
    });
    const handleDismiss = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: "setValueFromAction",
            pickerAction: "dismiss"
        });
    });
    const handleCancel = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastCommittedValue,
            name: "setValueFromAction",
            pickerAction: "cancel"
        });
    });
    const handleSetToday = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.getTodayValue(utils, timezone, valueType),
            name: "setValueFromAction",
            pickerAction: "today"
        });
    });
    const handleOpen = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        event.preventDefault();
        setIsOpen(true);
    });
    const handleClose = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        event?.preventDefault();
        setIsOpen(false);
    });
    const handleChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newValue, selectionState = "partial")=>updateDate({
            name: "setValueFromView",
            value: newValue,
            selectionState: selectionState
        }));
    const handleSelectShortcut = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newValue, changeImportance, shortcut)=>updateDate({
            name: "setValueFromShortcut",
            value: newValue,
            changeImportance: changeImportance,
            shortcut: shortcut
        }));
    const handleChangeFromField = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newValue, context)=>updateDate({
            name: "setValueFromField",
            value: newValue,
            context: context
        }));
    const actions = {
        onClear: handleClear,
        onAccept: handleAccept,
        onDismiss: handleDismiss,
        onCancel: handleCancel,
        onSetToday: handleSetToday,
        onOpen: handleOpen,
        onClose: handleClose
    };
    const fieldResponse = {
        value: dateState.draft,
        onChange: handleChangeFromField
    };
    const viewValue = $1T1QG.useMemo(()=>valueManager.cleanValue(utils, dateState.draft), [
        utils,
        valueManager,
        dateState.draft
    ]);
    const viewResponse = {
        value: viewValue,
        onChange: handleChange,
        onClose: handleClose,
        open: isOpen
    };
    const isValid = (testedValue)=>{
        const error = validator({
            adapter: adapter,
            value: testedValue,
            timezone: timezone,
            props: props
        });
        return !valueManager.hasError(error);
    };
    const layoutResponse = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, actions, {
        value: viewValue,
        onChange: handleChange,
        onSelectShortcut: handleSelectShortcut,
        isValid: isValid
    });
    const contextValue = $1T1QG.useMemo(()=>({
            onOpen: handleOpen,
            onClose: handleClose,
            open: isOpen
        }), [
        isOpen,
        handleClose,
        handleOpen
    ]);
    return {
        open: isOpen,
        fieldProps: fieldResponse,
        viewProps: viewResponse,
        layoutProps: layoutResponse,
        actions: actions,
        contextValue: contextValue
    };
};





var $1T1QG = parcelRequire("1T1QG");




const $9437846163bf8d8a$var$_excluded = [
    "className",
    "sx"
];
const $9437846163bf8d8a$export$c0a71b697a2df210 = ({ props: props, propsFromPickerValue: propsFromPickerValue, additionalViewProps: additionalViewProps, autoFocusView: autoFocusView, rendererInterceptor: rendererInterceptor, fieldRef: fieldRef })=>{
    const { onChange: onChange, open: open, onClose: onClose } = propsFromPickerValue;
    const { view: inView, views: views, openTo: openTo, onViewChange: onViewChange, viewRenderers: viewRenderers, timezone: timezone } = props;
    const propsToForwardToView = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $9437846163bf8d8a$var$_excluded);
    const { view: view, setView: setView, defaultView: defaultView, focusedView: focusedView, setFocusedView: setFocusedView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $1d4419ac03a36f0f$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: onChange,
        onViewChange: onViewChange,
        autoFocus: autoFocusView
    });
    const { hasUIView: hasUIView, viewModeLookup: viewModeLookup } = $1T1QG.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            let viewMode;
            if (viewRenderers[viewForReduce] != null) viewMode = "UI";
            else viewMode = "field";
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === "UI") acc.hasUIView = true;
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {}
        }), [
        viewRenderers,
        views
    ]);
    const timeViewsCount = $1T1QG.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            if (viewRenderers[viewForReduce] != null && (0, $a99658949db23f4e$export$8f04d380cefd5a0d)(viewForReduce)) return acc + 1;
            return acc;
        }, 0), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const shouldRestoreFocus = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)(()=>currentViewMode === "UI");
    const [popperView, setPopperView] = $1T1QG.useState(currentViewMode === "UI" ? view : null);
    if (popperView !== view && viewModeLookup[view] === "UI") setPopperView(view);
    (0, $1c8a785890e03d41$export$2e2bcd8739ae039)(()=>{
        // Handle case of `DateTimePicker` without time renderers
        if (currentViewMode === "field" && open) {
            onClose();
            setTimeout(()=>{
                fieldRef?.current?.setSelectedSections(view);
                // focusing the input before the range selection is done
                // calling it outside of timeout results in an inconsistent behavior between Safari And Chrome
                fieldRef?.current?.focusField(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $1c8a785890e03d41$export$2e2bcd8739ae039)(()=>{
        if (!open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === "field" && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === "UI" && viewModeLookup[defaultView] === "UI") newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const layoutProps = {
        views: views,
        view: popperView,
        onViewChange: setView
    };
    return {
        hasUIView: hasUIView,
        shouldRestoreFocus: shouldRestoreFocus,
        layoutProps: layoutProps,
        renderCurrentView: ()=>{
            if (popperView == null) return null;
            const renderer = viewRenderers[popperView];
            if (renderer == null) return null;
            const rendererProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, propsToForwardToView, additionalViewProps, propsFromPickerValue, {
                views: views,
                timezone: timezone,
                onChange: setValueAndGoToNextView,
                view: popperView,
                onViewChange: setView,
                focusedView: focusedView,
                onFocusedViewChange: setFocusedView,
                showViewSwitcher: timeViewsCount > 1,
                timeViewsCount: timeViewsCount
            });
            if (rendererInterceptor) return rendererInterceptor(viewRenderers, popperView, rendererProps);
            return renderer(rendererProps);
        }
    };
};





var $1T1QG = parcelRequire("1T1QG");


function $779099630eb022b4$var$getOrientation() {
    if (typeof window === "undefined") return "portrait";
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait";
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
    return "portrait";
}
const $779099630eb022b4$export$6f60b24e37af6448 = (views, customOrientation)=>{
    const [orientation, setOrientation] = $1T1QG.useState($779099630eb022b4$var$getOrientation);
    (0, $1c8a785890e03d41$export$2e2bcd8739ae039)(()=>{
        const eventHandler = ()=>{
            setOrientation($779099630eb022b4$var$getOrientation());
        };
        window.addEventListener("orientationchange", eventHandler);
        return ()=>{
            window.removeEventListener("orientationchange", eventHandler);
        };
    }, []);
    if ((0, $68e3e92a73d67afe$export$22012a5c726bef55)(views, [
        "hours",
        "minutes",
        "seconds"
    ])) // could not display 13:34:44 in landscape mode
    return false;
    const orientationToUse = customOrientation || orientation;
    return orientationToUse === "landscape";
};


const $6eb51128c3fac23d$export$4e5139e5825b7b27 = ({ props: props, propsFromPickerValue: propsFromPickerValue, propsFromPickerViews: propsFromPickerViews, wrapperVariant: wrapperVariant })=>{
    const { orientation: orientation } = props;
    const isLandscape = (0, $779099630eb022b4$export$6f60b24e37af6448)(propsFromPickerViews.views, orientation);
    const isRtl = (0, $a69327a401bfde77$export$b2dd014b6c321cb)();
    const layoutProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, propsFromPickerViews, propsFromPickerValue, {
        isLandscape: isLandscape,
        isRtl: isRtl,
        wrapperVariant: wrapperVariant,
        disabled: props.disabled,
        readOnly: props.readOnly
    });
    return {
        layoutProps: layoutProps
    };
};



var $1T1QG = parcelRequire("1T1QG");
function $2550024cfba76df5$export$cfaabb8dcad411b(parameters) {
    const { props: props, pickerValueResponse: pickerValueResponse } = parameters;
    return $1T1QG.useMemo(()=>({
            value: pickerValueResponse.viewProps.value,
            open: pickerValueResponse.open,
            disabled: props.disabled ?? false,
            readOnly: props.readOnly ?? false
        }), [
        pickerValueResponse.viewProps.value,
        pickerValueResponse.open,
        props.disabled,
        props.readOnly
    ]);
}


const $ad286f8dcf1caecc$export$fc3313977ac596c4 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, additionalViewProps: additionalViewProps, validator: validator, autoFocusView: autoFocusView, rendererInterceptor: rendererInterceptor, fieldRef: fieldRef })=>{
    const pickerValueResponse = (0, $fd470aa9e09d6ff8$export$799b22a7b7fffaa3)({
        props: props,
        valueManager: valueManager,
        valueType: valueType,
        wrapperVariant: wrapperVariant,
        validator: validator
    });
    const pickerViewsResponse = (0, $9437846163bf8d8a$export$c0a71b697a2df210)({
        props: props,
        additionalViewProps: additionalViewProps,
        autoFocusView: autoFocusView,
        fieldRef: fieldRef,
        propsFromPickerValue: pickerValueResponse.viewProps,
        rendererInterceptor: rendererInterceptor
    });
    const pickerLayoutResponse = (0, $6eb51128c3fac23d$export$4e5139e5825b7b27)({
        props: props,
        wrapperVariant: wrapperVariant,
        propsFromPickerValue: pickerValueResponse.layoutProps,
        propsFromPickerViews: pickerViewsResponse.layoutProps
    });
    const pickerOwnerState = (0, $2550024cfba76df5$export$cfaabb8dcad411b)({
        props: props,
        pickerValueResponse: pickerValueResponse
    });
    return {
        // Picker value
        open: pickerValueResponse.open,
        actions: pickerValueResponse.actions,
        fieldProps: pickerValueResponse.fieldProps,
        // Picker views
        renderCurrentView: pickerViewsResponse.renderCurrentView,
        hasUIView: pickerViewsResponse.hasUIView,
        shouldRestoreFocus: pickerViewsResponse.shouldRestoreFocus,
        // Picker layout
        layoutProps: pickerLayoutResponse.layoutProps,
        // Picker context
        contextValue: pickerValueResponse.contextValue,
        // Picker owner state
        ownerState: pickerOwnerState
    };
};



var $1T1QG = parcelRequire("1T1QG");



var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");



function $2a69b26d9f9cbebb$export$1671c31de798d429(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiPickersLayout", slot);
}
const $2a69b26d9f9cbebb$export$7a6dac186703fe4c = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiPickersLayout", [
    "root",
    "landscape",
    "contentWrapper",
    "toolbar",
    "actionBar",
    "tabs",
    "shortcuts"
]);



parcelRequire("1T1QG");




parcelRequire("1T1QG");





var $3Py8h = parcelRequire("3Py8h");
"use client";
const $28af38f536c150be$var$_excluded = [
    "onAccept",
    "onClear",
    "onCancel",
    "onSetToday",
    "actions"
];
/**
 * Demos:
 *
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersActionBar API](https://mui.com/x/api/date-pickers/pickers-action-bar/)
 */ function $28af38f536c150be$export$72ffda3bb7ecf665(props) {
    const { onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, actions: actions } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $28af38f536c150be$var$_excluded);
    const translations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions?.map((actionType)=>{
        switch(actionType){
            case "clear":
                return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c8008865d6db946f$export$2e2bcd8739ae039), {
                    onClick: onClear,
                    children: translations.clearButtonLabel
                }, actionType);
            case "cancel":
                return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c8008865d6db946f$export$2e2bcd8739ae039), {
                    onClick: onCancel,
                    children: translations.cancelButtonLabel
                }, actionType);
            case "accept":
                return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c8008865d6db946f$export$2e2bcd8739ae039), {
                    onClick: onAccept,
                    children: translations.okButtonLabel
                }, actionType);
            case "today":
                return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c8008865d6db946f$export$2e2bcd8739ae039), {
                    onClick: onSetToday,
                    children: translations.todayButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f390108b84fcd5b2$export$2e2bcd8739ae039), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, other, {
        children: buttons
    }));
}





parcelRequire("1T1QG");






var $3Py8h = parcelRequire("3Py8h");
"use client";
const $b4075d98c44a2cff$var$_excluded = [
    "items",
    "changeImportance",
    "isLandscape",
    "onChange",
    "isValid"
], $b4075d98c44a2cff$var$_excluded2 = [
    "getValue"
];
/**
 * Demos:
 *
 * - [Shortcuts](https://mui.com/x/react-date-pickers/shortcuts/)
 *
 * API:
 *
 * - [PickersShortcuts API](https://mui.com/x/api/date-pickers/pickers-shortcuts/)
 */ function $b4075d98c44a2cff$export$8ba8fc65919fa1fe(props) {
    const { items: items, changeImportance: changeImportance = "accept", onChange: onChange, isValid: isValid } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $b4075d98c44a2cff$var$_excluded);
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((_ref)=>{
        let { getValue: getValue } = _ref, item = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_ref, $b4075d98c44a2cff$var$_excluded2);
        const newValue = getValue({
            isValid: isValid
        });
        return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, item, {
            label: item.label,
            onClick: ()=>{
                onChange(newValue, changeImportance, item);
            },
            disabled: !isValid(newValue)
        });
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $44769ad997f9918f$export$2e2bcd8739ae039), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        dense: true,
        sx: [
            {
                maxHeight: (0, $790faeda284dc7ce$export$f2fef360e2df0cb7),
                maxWidth: 200,
                overflow: "auto"
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $d458cf93737cba82$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $6778801d3fbd7fc0$export$2e2bcd8739ae039), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, item))
            }, item.id ?? item.label);
        })
    }));
}



var $3Py8h = parcelRequire("3Py8h");
"use client";
function $7d9847cffb4d6595$var$toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const $7d9847cffb4d6595$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            "root",
            isLandscape && "landscape"
        ],
        contentWrapper: [
            "contentWrapper"
        ],
        toolbar: [
            "toolbar"
        ],
        actionBar: [
            "actionBar"
        ],
        tabs: [
            "tabs"
        ],
        landscape: [
            "landscape"
        ],
        shortcuts: [
            "shortcuts"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $2a69b26d9f9cbebb$export$1671c31de798d429), classes);
};
const $7d9847cffb4d6595$var$usePickerLayout = (props)=>{
    const { wrapperVariant: wrapperVariant, onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, view: view, views: views, onViewChange: onViewChange, value: value, onChange: onChange, onSelectShortcut: onSelectShortcut, isValid: isValid, isLandscape: isLandscape, disabled: disabled, readOnly: readOnly, children: children, slots: slots, slotProps: slotProps } = props;
    const classes = $7d9847cffb4d6595$var$useUtilityClasses(props);
    // Action bar
    const ActionBar = slots?.actionBar ?? (0, $28af38f536c150be$export$72ffda3bb7ecf665);
    const actionBarProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: ActionBar,
        externalSlotProps: slotProps?.actionBar,
        additionalProps: {
            onAccept: onAccept,
            onClear: onClear,
            onCancel: onCancel,
            onSetToday: onSetToday,
            actions: wrapperVariant === "desktop" ? [] : [
                "cancel",
                "accept"
            ]
        },
        className: classes.actionBar,
        ownerState: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const actionBar = /*#__PURE__*/ (0, $3Py8h.jsx)(ActionBar, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots?.toolbar;
    const toolbarProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: Toolbar,
        externalSlotProps: slotProps?.toolbar,
        additionalProps: {
            isLandscape: isLandscape,
            onChange: onChange,
            value: value,
            view: view,
            onViewChange: onViewChange,
            views: views,
            disabled: disabled,
            readOnly: readOnly
        },
        className: classes.toolbar,
        ownerState: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const toolbar = $7d9847cffb4d6595$var$toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, $3Py8h.jsx)(Toolbar, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots?.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, $3Py8h.jsx)(Tabs, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        view: view,
        onViewChange: onViewChange,
        className: classes.tabs
    }, slotProps?.tabs)) : null;
    // Shortcuts
    const Shortcuts = slots?.shortcuts ?? (0, $b4075d98c44a2cff$export$8ba8fc65919fa1fe);
    const shortcutsProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: Shortcuts,
        externalSlotProps: slotProps?.shortcuts,
        additionalProps: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut
        },
        className: classes.shortcuts,
        ownerState: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            wrapperVariant: wrapperVariant
        }
    });
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, $3Py8h.jsx)(Shortcuts, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, shortcutsProps)) : null;
    return {
        toolbar: toolbar,
        content: content,
        tabs: tabs,
        actionBar: actionBar,
        shortcuts: shortcuts
    };
};
var $7d9847cffb4d6595$export$2e2bcd8739ae039 = $7d9847cffb4d6595$var$usePickerLayout;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $fc46d30a907f069d$var$useUtilityClasses = (ownerState)=>{
    const { isLandscape: isLandscape, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            isLandscape && "landscape"
        ],
        contentWrapper: [
            "contentWrapper"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $2a69b26d9f9cbebb$export$1671c31de798d429), classes);
};
const $fc46d30a907f069d$export$9a9363506c13836 = (0, $npagc.default)("div", {
    name: "MuiPickersLayout",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "grid",
    gridAutoColumns: "max-content auto max-content",
    gridAutoRows: "max-content auto max-content",
    [`& .${(0, $2a69b26d9f9cbebb$export$7a6dac186703fe4c).actionBar}`]: {
        gridColumn: "1 / 4",
        gridRow: 3
    },
    variants: [
        {
            props: {
                isLandscape: true
            },
            style: {
                [`& .${(0, $2a69b26d9f9cbebb$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: 1,
                    gridRow: "2 / 3"
                },
                [`.${(0, $2a69b26d9f9cbebb$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: "2 / 4",
                    gridRow: 1
                }
            }
        },
        {
            props: {
                isLandscape: true,
                isRtl: true
            },
            style: {
                [`& .${(0, $2a69b26d9f9cbebb$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: 3
                }
            }
        },
        {
            props: {
                isLandscape: false
            },
            style: {
                [`& .${(0, $2a69b26d9f9cbebb$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: "2 / 4",
                    gridRow: 1
                },
                [`& .${(0, $2a69b26d9f9cbebb$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: 1,
                    gridRow: "2 / 3"
                }
            }
        },
        {
            props: {
                isLandscape: false,
                isRtl: true
            },
            style: {
                [`& .${(0, $2a69b26d9f9cbebb$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: 3
                }
            }
        }
    ]
});
const $fc46d30a907f069d$export$bc1494d918129235 = (0, $npagc.default)("div", {
    name: "MuiPickersLayout",
    slot: "ContentWrapper",
    overridesResolver: (props, styles)=>styles.contentWrapper
})({
    gridColumn: 2,
    gridRow: 2,
    display: "flex",
    flexDirection: "column"
});
/**
 * Demos:
 *
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersLayout API](https://mui.com/x/api/date-pickers/pickers-layout/)
 */ const $fc46d30a907f069d$export$647f604ea2397c05 = /*#__PURE__*/ $1T1QG.forwardRef(function PickersLayout(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiPickersLayout"
    });
    const { toolbar: toolbar, content: content, tabs: tabs, actionBar: actionBar, shortcuts: shortcuts } = (0, $7d9847cffb4d6595$export$2e2bcd8739ae039)(props);
    const { sx: sx, className: className, isLandscape: isLandscape, wrapperVariant: wrapperVariant } = props;
    const classes = $fc46d30a907f069d$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($fc46d30a907f069d$export$9a9363506c13836, {
        ref: ref,
        sx: sx,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: props,
        children: [
            isLandscape ? shortcuts : toolbar,
            isLandscape ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $3Py8h.jsx)($fc46d30a907f069d$export$bc1494d918129235, {
                className: classes.contentWrapper,
                children: wrapperVariant === "desktop" ? /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
});



var $1T1QG = parcelRequire("1T1QG");


var $3Py8h = parcelRequire("3Py8h");
const $ec10b178b7b16965$export$38de57b7f4a44eea = /*#__PURE__*/ $1T1QG.createContext(null);
function $ec10b178b7b16965$export$38e969d523d4d57f(props) {
    const { contextValue: contextValue, localeText: localeText, children: children } = props;
    return /*#__PURE__*/ (0, $3Py8h.jsx)($ec10b178b7b16965$export$38de57b7f4a44eea.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $0c1c7d3e9094bc71$export$dc45bdc734ce6f1e), {
            localeText: localeText,
            children: children
        })
    });
}



var $3Py8h = parcelRequire("3Py8h");
const $ce8461dc80dc4c33$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
], $ce8461dc80dc4c33$var$_excluded2 = [
    "ownerState"
], $ce8461dc80dc4c33$var$_excluded3 = [
    "ownerState"
];
const $ce8461dc80dc4c33$export$b1b70bc56ac5be0e = (_ref)=>{
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_ref, $ce8461dc80dc4c33$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezone, name: name, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, autoFocus: autoFocus, localeText: localeText, reduceAnimations: reduceAnimations } = props;
    const containerRef = $1T1QG.useRef(null);
    const fieldRef = $1T1QG.useRef(null);
    const labelId = (0, $ea1f3283f0dc1f21$export$2e2bcd8739ae039)();
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const { open: open, actions: actions, hasUIView: hasUIView, layoutProps: layoutProps, renderCurrentView: renderCurrentView, shouldRestoreFocus: shouldRestoreFocus, fieldProps: pickerFieldProps, contextValue: contextValue, ownerState: ownerState } = (0, $ad286f8dcf1caecc$export$fc3313977ac596c4)((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, pickerParams, {
        props: props,
        fieldRef: fieldRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: "desktop"
    }));
    const InputAdornment = slots.inputAdornment ?? (0, $5a3af6fa98298c7b$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: InputAdornment,
        externalSlotProps: innerSlotProps?.inputAdornment,
        additionalProps: {
            position: "end"
        },
        ownerState: props
    }), inputAdornmentProps = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_useSlotProps, $ce8461dc80dc4c33$var$_excluded2);
    const OpenPickerButton = slots.openPickerButton ?? (0, $5c784366741908ee$export$2e2bcd8739ae039);
    const _useSlotProps2 = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: OpenPickerButton,
        externalSlotProps: innerSlotProps?.openPickerButton,
        additionalProps: {
            disabled: disabled || readOnly,
            onClick: open ? actions.onClose : actions.onOpen,
            "aria-label": getOpenDialogAriaText(pickerFieldProps.value),
            edge: inputAdornmentProps.position
        },
        ownerState: props
    }), openPickerButtonProps = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_useSlotProps2, $ce8461dc80dc4c33$var$_excluded3);
    const OpenPickerIcon = slots.openPickerIcon;
    const openPickerIconProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: OpenPickerIcon,
        externalSlotProps: innerSlotProps?.openPickerIcon,
        ownerState: ownerState
    });
    const Field = slots.field;
    const fieldProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, {
            readOnly: readOnly,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            timezone: timezone,
            label: label,
            name: name,
            autoFocus: autoFocus && !props.open,
            focused: open ? true : undefined
        }, inputRef ? {
            inputRef: inputRef
        } : {}),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    if (hasUIView) fieldProps.InputProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, fieldProps.InputProps, {
        ref: containerRef
    }, !props.disableOpenPicker && {
        [`${inputAdornmentProps.position}Adornment`]: /*#__PURE__*/ (0, $3Py8h.jsx)(InputAdornment, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, inputAdornmentProps, {
            children: /*#__PURE__*/ (0, $3Py8h.jsx)(OpenPickerButton, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)(OpenPickerIcon, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, openPickerIconProps))
            }))
        }))
    });
    const slotsForField = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        textField: slots.textField,
        clearIcon: slots.clearIcon,
        clearButton: slots.clearButton
    }, fieldProps.slots);
    const Layout = slots.layout ?? (0, $fc46d30a907f069d$export$647f604ea2397c05);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, innerSlotProps, {
        toolbar: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        popper: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
            "aria-labelledby": labelledById
        }, innerSlotProps?.popper)
    });
    const handleFieldRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(fieldRef, fieldProps.unstableFieldRef);
    const renderPicker = ()=>/*#__PURE__*/ (0, $3Py8h.jsxs)((0, $ec10b178b7b16965$export$38e969d523d4d57f), {
            contextValue: contextValue,
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)(Field, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    unstableFieldRef: handleFieldRef
                })),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c48ba6440e847340$export$96ce8482474de8a5), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                    role: "dialog",
                    placement: "bottom-start",
                    anchorEl: containerRef.current
                }, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    shouldRestoreFocus: shouldRestoreFocus,
                    reduceAnimations: reduceAnimations,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)(Layout, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, layoutProps, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};






const $a5c7bda3180b1cc0$var$_excluded = [
    "views",
    "format"
];
const $a5c7bda3180b1cc0$export$ebf7b30b32db6f57 = (utils, _ref, ignoreDateResolving)=>{
    let { views: views, format: format } = _ref, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_ref, $a5c7bda3180b1cc0$var$_excluded);
    if (format) return format;
    const dateViews = [];
    const timeViews = [];
    views.forEach((view)=>{
        if ((0, $a99658949db23f4e$export$8f04d380cefd5a0d)(view)) timeViews.push(view);
        else if ((0, $2c8437f6b047f676$export$b32dfef9f07dea64)(view)) dateViews.push(view);
    });
    if (timeViews.length === 0) return (0, $2c8437f6b047f676$export$bb1c921f313ec928)(utils, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        views: dateViews
    }, other), false);
    if (dateViews.length === 0) return (0, $a99658949db23f4e$export$3a6776b3863772fe)(utils, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        views: timeViews
    }, other));
    const timeFormat = (0, $a99658949db23f4e$export$3a6776b3863772fe)(utils, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        views: timeViews
    }, other));
    const dateFormat = ignoreDateResolving ? utils.formats.keyboardDate : (0, $2c8437f6b047f676$export$bb1c921f313ec928)(utils, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        views: dateViews
    }, other), false);
    return `${dateFormat} ${timeFormat}`;
};
const $a5c7bda3180b1cc0$var$resolveViews = (ampm, views, shouldUseSingleColumn)=>{
    if (shouldUseSingleColumn) return views.filter((view)=>!(0, $a99658949db23f4e$export$a3328136ac50623d)(view) || view === "hours");
    return ampm ? [
        ...views,
        "meridiem"
    ] : views;
};
const $a5c7bda3180b1cc0$var$resolveShouldRenderTimeInASingleColumn = (timeSteps, threshold)=>1440 / ((timeSteps.hours ?? 1) * (timeSteps.minutes ?? 5)) <= threshold;
function $a5c7bda3180b1cc0$export$e2d664f2dd4d34bc({ thresholdToRenderTimeInASingleColumn: inThreshold, ampm: ampm, timeSteps: inTimeSteps, views: views }) {
    const thresholdToRenderTimeInASingleColumn = inThreshold ?? 24;
    const timeSteps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        hours: 1,
        minutes: 5,
        seconds: 5
    }, inTimeSteps);
    const shouldRenderTimeInASingleColumn = $a5c7bda3180b1cc0$var$resolveShouldRenderTimeInASingleColumn(timeSteps, thresholdToRenderTimeInASingleColumn);
    return {
        thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn,
        timeSteps: timeSteps,
        shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn,
        views: $a5c7bda3180b1cc0$var$resolveViews(ampm, views, shouldRenderTimeInASingleColumn)
    };
}


parcelRequire("1T1QG");



var $1T1QG = parcelRequire("1T1QG");



var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");









function $2a3e6b98286ca538$export$148b188041a720e4(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiTimeClock", slot);
}
const $2a3e6b98286ca538$export$191dec874db3257b = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiTimeClock", [
    "root",
    "arrowSwitcher"
]);




var $1T1QG = parcelRequire("1T1QG");




var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");




var $1T1QG = parcelRequire("1T1QG");


var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");

const $a825fbef788a49b0$export$8c8ec20d3854d7e6 = 220;
const $a825fbef788a49b0$export$729c0e543e4dc21d = 36;
const $a825fbef788a49b0$var$clockCenter = {
    x: $a825fbef788a49b0$export$8c8ec20d3854d7e6 / 2,
    y: $a825fbef788a49b0$export$8c8ec20d3854d7e6 / 2
};
const $a825fbef788a49b0$var$baseClockPoint = {
    x: $a825fbef788a49b0$var$clockCenter.x,
    y: 0
};
const $a825fbef788a49b0$var$cx = $a825fbef788a49b0$var$baseClockPoint.x - $a825fbef788a49b0$var$clockCenter.x;
const $a825fbef788a49b0$var$cy = $a825fbef788a49b0$var$baseClockPoint.y - $a825fbef788a49b0$var$clockCenter.y;
const $a825fbef788a49b0$var$rad2deg = (rad)=>rad * (180 / Math.PI);
const $a825fbef788a49b0$var$getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - $a825fbef788a49b0$var$clockCenter.x;
    const y = offsetY - $a825fbef788a49b0$var$clockCenter.y;
    const atan = Math.atan2($a825fbef788a49b0$var$cx, $a825fbef788a49b0$var$cy) - Math.atan2(x, y);
    let deg = $a825fbef788a49b0$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
const $a825fbef788a49b0$export$b7f1bc3ea3ac4145 = (offsetX, offsetY, step = 1)=>{
    const angleStep = step * 6;
    let { value: value } = $a825fbef788a49b0$var$getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
const $a825fbef788a49b0$export$257b40f71c07d58f = (offsetX, offsetY, ampm)=>{
    const { value: value, distance: distance } = $a825fbef788a49b0$var$getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (!ampm) {
        if (distance < $a825fbef788a49b0$export$8c8ec20d3854d7e6 / 2 - $a825fbef788a49b0$export$729c0e543e4dc21d) {
            hour += 12;
            hour %= 24;
        }
    } else hour %= 12;
    return hour;
};



function $df27284d215ab1ef$export$12faa62796978e2f(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiClockPointer", slot);
}
const $df27284d215ab1ef$export$64afeec9352615cb = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiClockPointer", [
    "root",
    "thumb"
]);



var $3Py8h = parcelRequire("3Py8h");
const $8c99dba2a8a6cebb$var$_excluded = [
    "className",
    "hasSelected",
    "isInner",
    "type",
    "viewValue"
];
const $8c99dba2a8a6cebb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        thumb: [
            "thumb"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $df27284d215ab1ef$export$12faa62796978e2f), classes);
};
const $8c99dba2a8a6cebb$var$ClockPointerRoot = (0, $npagc.default)("div", {
    name: "MuiClockPointer",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        width: 2,
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: "absolute",
        left: "calc(50% - 1px)",
        bottom: "50%",
        transformOrigin: "center bottom 0px",
        variants: [
            {
                props: {
                    shouldAnimate: true
                },
                style: {
                    transition: theme.transitions.create([
                        "transform",
                        "height"
                    ])
                }
            }
        ]
    }));
const $8c99dba2a8a6cebb$var$ClockPointerThumb = (0, $npagc.default)("div", {
    name: "MuiClockPointer",
    slot: "Thumb",
    overridesResolver: (_, styles)=>styles.thumb
})(({ theme: theme })=>({
        width: 4,
        height: 4,
        backgroundColor: (theme.vars || theme).palette.primary.contrastText,
        borderRadius: "50%",
        position: "absolute",
        top: -21,
        left: `calc(50% - ${(0, $a825fbef788a49b0$export$729c0e543e4dc21d) / 2}px)`,
        border: `${((0, $a825fbef788a49b0$export$729c0e543e4dc21d) - 4) / 2}px solid ${(theme.vars || theme).palette.primary.main}`,
        boxSizing: "content-box",
        variants: [
            {
                props: {
                    hasSelected: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            }
        ]
    }));
function $8c99dba2a8a6cebb$export$f257f213e6c08f97(inProps) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiClockPointer"
    });
    const { className: className, isInner: isInner, type: type, viewValue: viewValue } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $8c99dba2a8a6cebb$var$_excluded);
    const previousType = $1T1QG.useRef(type);
    $1T1QG.useEffect(()=>{
        previousType.current = type;
    }, [
        type
    ]);
    const ownerState = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, {
        shouldAnimate: previousType.current !== type
    });
    const classes = $8c99dba2a8a6cebb$var$useUtilityClasses(ownerState);
    const getAngleStyle = ()=>{
        const max = type === "hours" ? 12 : 60;
        let angle = 360 / max * viewValue;
        if (type === "hours" && viewValue > 12) angle -= 360; // round up angle to max 360 degrees
        return {
            height: Math.round((isInner ? 0.26 : 0.4) * (0, $a825fbef788a49b0$export$8c8ec20d3854d7e6)),
            transform: `rotateZ(${angle}deg)`
        };
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)($8c99dba2a8a6cebb$var$ClockPointerRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        style: getAngleStyle(),
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($8c99dba2a8a6cebb$var$ClockPointerThumb, {
            ownerState: ownerState,
            className: classes.thumb
        })
    }));
}






function $804a897136994221$export$e44ecab24167799b(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiClock", slot);
}
const $804a897136994221$export$4626e3a61e161c64 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiClock", [
    "root",
    "clock",
    "wrapper",
    "squareMask",
    "pin",
    "amButton",
    "pmButton",
    "meridiemText",
    "selected"
]);




var $3Py8h = parcelRequire("3Py8h");
const $c2913a4c3122be3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, meridiemMode: meridiemMode } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        clock: [
            "clock"
        ],
        wrapper: [
            "wrapper"
        ],
        squareMask: [
            "squareMask"
        ],
        pin: [
            "pin"
        ],
        amButton: [
            "amButton",
            meridiemMode === "am" && "selected"
        ],
        pmButton: [
            "pmButton",
            meridiemMode === "pm" && "selected"
        ],
        meridiemText: [
            "meridiemText"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $804a897136994221$export$e44ecab24167799b), classes);
};
const $c2913a4c3122be3c$var$ClockRoot = (0, $npagc.default)("div", {
    name: "MuiClock",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: theme.spacing(2)
    }));
const $c2913a4c3122be3c$var$ClockClock = (0, $npagc.default)("div", {
    name: "MuiClock",
    slot: "Clock",
    overridesResolver: (_, styles)=>styles.clock
})({
    backgroundColor: "rgba(0,0,0,.07)",
    borderRadius: "50%",
    height: 220,
    width: 220,
    flexShrink: 0,
    position: "relative",
    pointerEvents: "none"
});
const $c2913a4c3122be3c$var$ClockWrapper = (0, $npagc.default)("div", {
    name: "MuiClock",
    slot: "Wrapper",
    overridesResolver: (_, styles)=>styles.wrapper
})({
    "&:focus": {
        outline: "none"
    }
});
const $c2913a4c3122be3c$var$ClockSquareMask = (0, $npagc.default)("div", {
    name: "MuiClock",
    slot: "SquareMask",
    overridesResolver: (_, styles)=>styles.squareMask
})({
    width: "100%",
    height: "100%",
    position: "absolute",
    pointerEvents: "auto",
    outline: 0,
    // Disable scroll capabilities.
    touchAction: "none",
    userSelect: "none",
    variants: [
        {
            props: {
                disabled: false
            },
            style: {
                "@media (pointer: fine)": {
                    cursor: "pointer",
                    borderRadius: "50%"
                },
                "&:active": {
                    cursor: "move"
                }
            }
        }
    ]
});
const $c2913a4c3122be3c$var$ClockPin = (0, $npagc.default)("div", {
    name: "MuiClock",
    slot: "Pin",
    overridesResolver: (_, styles)=>styles.pin
})(({ theme: theme })=>({
        width: 6,
        height: 6,
        borderRadius: "50%",
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    }));
const $c2913a4c3122be3c$var$meridiemButtonCommonStyles = (theme, meridiemMode)=>({
        zIndex: 1,
        bottom: 8,
        paddingLeft: 4,
        paddingRight: 4,
        width: (0, $a825fbef788a49b0$export$729c0e543e4dc21d),
        variants: [
            {
                props: {
                    meridiemMode: meridiemMode
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main,
                    color: (theme.vars || theme).palette.primary.contrastText,
                    "&:hover": {
                        backgroundColor: (theme.vars || theme).palette.primary.light
                    }
                }
            }
        ]
    });
const $c2913a4c3122be3c$var$ClockAmButton = (0, $npagc.default)((0, $5c784366741908ee$export$2e2bcd8739ae039), {
    name: "MuiClock",
    slot: "AmButton",
    overridesResolver: (_, styles)=>styles.amButton
})(({ theme: theme })=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, $c2913a4c3122be3c$var$meridiemButtonCommonStyles(theme, "am"), {
        // keeping it here to make TS happy
        position: "absolute",
        left: 8
    }));
const $c2913a4c3122be3c$var$ClockPmButton = (0, $npagc.default)((0, $5c784366741908ee$export$2e2bcd8739ae039), {
    name: "MuiClock",
    slot: "PmButton",
    overridesResolver: (_, styles)=>styles.pmButton
})(({ theme: theme })=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, $c2913a4c3122be3c$var$meridiemButtonCommonStyles(theme, "pm"), {
        // keeping it here to make TS happy
        position: "absolute",
        right: 8
    }));
const $c2913a4c3122be3c$var$ClockMeridiemText = (0, $npagc.default)((0, $a386176d6ca21602$export$2e2bcd8739ae039), {
    name: "MuiClock",
    slot: "meridiemText",
    overridesResolver: (_, styles)=>styles.meridiemText
})({
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
});
function $c2913a4c3122be3c$export$9735c82c4bae3302(inProps) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiClock"
    });
    const { ampm: ampm, ampmInClock: ampmInClock, autoFocus: autoFocus, children: children, value: value, handleMeridiemChange: handleMeridiemChange, isTimeDisabled: isTimeDisabled, meridiemMode: meridiemMode, minutesStep: minutesStep = 1, onChange: onChange, selectedId: selectedId, type: type, viewValue: viewValue, disabled: disabled = false, readOnly: readOnly, className: className } = props;
    const ownerState = props;
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const translations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    const isMoving = $1T1QG.useRef(false);
    const classes = $c2913a4c3122be3c$var$useUtilityClasses(ownerState);
    const isSelectedTimeDisabled = isTimeDisabled(viewValue, type);
    const isPointerInner = !ampm && type === "hours" && (viewValue < 1 || viewValue > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (disabled || readOnly) return;
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX: offsetX, offsetY: offsetY } = event;
        if (offsetX === undefined) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = type === "seconds" || type === "minutes" ? (0, $a825fbef788a49b0$export$b7f1bc3ea3ac4145)(offsetX, offsetY, minutesStep) : (0, $a825fbef788a49b0$export$257b40f71c07d58f)(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchSelection = (event)=>{
        isMoving.current = true;
        setTime(event, "shallow");
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, "finish");
            isMoving.current = false;
        }
    };
    const handleMouseMove = (event)=>{
        // event.buttons & PRIMARY_MOUSE_BUTTON
        if (event.buttons > 0) setTime(event.nativeEvent, "shallow");
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, "finish");
    };
    const hasSelected = $1T1QG.useMemo(()=>{
        if (type === "hours") return true;
        return viewValue % 5 === 0;
    }, [
        type,
        viewValue
    ]);
    const keyboardControlStep = type === "minutes" ? minutesStep : 1;
    const listboxRef = $1T1QG.useRef(null);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $1c8a785890e03d41$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const handleKeyDown = (event)=>{
        // TODO: Why this early exit?
        if (isMoving.current) return;
        switch(event.key){
            case "Home":
                // reset both hours and minutes
                handleValueChange(0, "partial");
                event.preventDefault();
                break;
            case "End":
                handleValueChange(type === "minutes" ? 59 : 23, "partial");
                event.preventDefault();
                break;
            case "ArrowUp":
                handleValueChange(viewValue + keyboardControlStep, "partial");
                event.preventDefault();
                break;
            case "ArrowDown":
                handleValueChange(viewValue - keyboardControlStep, "partial");
                event.preventDefault();
                break;
            case "PageUp":
                handleValueChange(viewValue + 5, "partial");
                event.preventDefault();
                break;
            case "PageDown":
                handleValueChange(viewValue - 5, "partial");
                event.preventDefault();
                break;
            case "Enter":
            case " ":
                handleValueChange(viewValue, "finish");
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($c2913a4c3122be3c$var$ClockRoot, {
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsxs)($c2913a4c3122be3c$var$ClockClock, {
                className: classes.clock,
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)($c2913a4c3122be3c$var$ClockSquareMask, {
                        onTouchMove: handleTouchSelection,
                        onTouchStart: handleTouchSelection,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove,
                        ownerState: {
                            disabled: disabled
                        },
                        className: classes.squareMask
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)($c2913a4c3122be3c$var$ClockPin, {
                                className: classes.pin
                            }),
                            value != null && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8c99dba2a8a6cebb$export$f257f213e6c08f97), {
                                type: type,
                                viewValue: viewValue,
                                isInner: isPointerInner,
                                hasSelected: hasSelected
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)($c2913a4c3122be3c$var$ClockWrapper, {
                        "aria-activedescendant": selectedId,
                        "aria-label": translations.clockLabelText(type, value, utils, value == null ? null : utils.format(value, "fullTime")),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        className: classes.wrapper,
                        children: children
                    })
                ]
            }),
            ampm && ampmInClock && /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)($c2913a4c3122be3c$var$ClockAmButton, {
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("am"),
                        disabled: disabled || meridiemMode === null,
                        ownerState: ownerState,
                        className: classes.amButton,
                        title: (0, $2c8437f6b047f676$export$fae94c0a662107ef)(utils, "am"),
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)($c2913a4c3122be3c$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $2c8437f6b047f676$export$fae94c0a662107ef)(utils, "am")
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)($c2913a4c3122be3c$var$ClockPmButton, {
                        disabled: disabled || meridiemMode === null,
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("pm"),
                        ownerState: ownerState,
                        className: classes.pmButton,
                        title: (0, $2c8437f6b047f676$export$fae94c0a662107ef)(utils, "pm"),
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)($c2913a4c3122be3c$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $2c8437f6b047f676$export$fae94c0a662107ef)(utils, "pm")
                        })
                    })
                ]
            })
        ]
    });
}


parcelRequire("1T1QG");


parcelRequire("1T1QG");


var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");



function $37ae3a8b9c3a3440$export$527226d166658911(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiClockNumber", slot);
}
const $37ae3a8b9c3a3440$export$c8efb3a779c9844a = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiClockNumber", [
    "root",
    "selected",
    "disabled"
]);



var $3Py8h = parcelRequire("3Py8h");
const $e280953e01ae8b7c$var$_excluded = [
    "className",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const $e280953e01ae8b7c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            disabled && "disabled"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $37ae3a8b9c3a3440$export$527226d166658911), classes);
};
const $e280953e01ae8b7c$var$ClockNumberRoot = (0, $npagc.default)("span", {
    name: "MuiClockNumber",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $37ae3a8b9c3a3440$export$c8efb3a779c9844a).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $37ae3a8b9c3a3440$export$c8efb3a779c9844a).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>({
        height: (0, $a825fbef788a49b0$export$729c0e543e4dc21d),
        width: (0, $a825fbef788a49b0$export$729c0e543e4dc21d),
        position: "absolute",
        left: `calc((100% - ${0, $a825fbef788a49b0$export$729c0e543e4dc21d}px) / 2)`,
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        color: (theme.vars || theme).palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        "&:focused": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        [`&.${(0, $37ae3a8b9c3a3440$export$c8efb3a779c9844a).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText
        },
        [`&.${(0, $37ae3a8b9c3a3440$export$c8efb3a779c9844a).disabled}`]: {
            pointerEvents: "none",
            color: (theme.vars || theme).palette.text.disabled
        },
        variants: [
            {
                props: {
                    inner: true
                },
                style: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, theme.typography.body2, {
                    color: (theme.vars || theme).palette.text.secondary
                })
            }
        ]
    }));
function $e280953e01ae8b7c$export$6d5c4c748c9cc92c(inProps) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiClockNumber"
    });
    const { className: className, disabled: disabled, index: index, inner: inner, label: label, selected: selected } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $e280953e01ae8b7c$var$_excluded);
    const ownerState = props;
    const classes = $e280953e01ae8b7c$var$useUtilityClasses(ownerState);
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = ((0, $a825fbef788a49b0$export$8c8ec20d3854d7e6) - (0, $a825fbef788a49b0$export$729c0e543e4dc21d) - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($e280953e01ae8b7c$var$ClockNumberRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        "aria-disabled": disabled ? true : undefined,
        "aria-selected": selected ? true : undefined,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + ((0, $a825fbef788a49b0$export$8c8ec20d3854d7e6) - (0, $a825fbef788a49b0$export$729c0e543e4dc21d)) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}



var $3Py8h = parcelRequire("3Py8h");
const $d6fd666bdd61d131$export$10850582eda9a8c7 = ({ ampm: ampm, value: value, getClockNumberText: getClockNumberText, isDisabled: isDisabled, selectedId: selectedId, utils: utils })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (hour === 0) label = "00";
        const inner = !ampm && (hour === 0 || hour > 12);
        label = utils.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $e280953e01ae8b7c$export$6d5c4c748c9cc92c), {
            id: selected ? selectedId : undefined,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
const $d6fd666bdd61d131$export$2c440057d7a731e4 = ({ utils: utils, value: value, isDisabled: isDisabled, getClockNumberText: getClockNumberText, selectedId: selectedId })=>{
    const f = utils.formatNumber;
    return [
        [
            5,
            f("05")
        ],
        [
            10,
            f("10")
        ],
        [
            15,
            f("15")
        ],
        [
            20,
            f("20")
        ],
        [
            25,
            f("25")
        ],
        [
            30,
            f("30")
        ],
        [
            35,
            f("35")
        ],
        [
            40,
            f("40")
        ],
        [
            45,
            f("45")
        ],
        [
            50,
            f("50")
        ],
        [
            55,
            f("55")
        ],
        [
            0,
            f("00")
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e280953e01ae8b7c$export$6d5c4c748c9cc92c), {
            label: label,
            id: selected ? selectedId : undefined,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};





var $1T1QG = parcelRequire("1T1QG");



const $e3a5e2edb34513e1$export$86ee3b7a301faaa3 = ({ value: value, referenceDate: referenceDateProp, utils: utils, props: props, timezone: timezone })=>{
    const referenceDate = $1T1QG.useMemo(()=>(0, $59c1a689a11004ea$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            referenceDate: referenceDateProp,
            granularity: (0, $101a7d0ae47539cf$export$8f74e8f4ed8ae0ac).day,
            timezone: timezone,
            getTodayDate: ()=>(0, $2c8437f6b047f676$export$1118e4272ea1e258)(utils, timezone, "date")
        }), // We only want to compute the reference date on mount.
    [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    return value ?? referenceDate;
};



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $30d2a068e8fb8317$var$_excluded = [
    "ampm",
    "ampmInClock",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "showViewSwitcher",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "timezone"
];
const $30d2a068e8fb8317$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        arrowSwitcher: [
            "arrowSwitcher"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $2a3e6b98286ca538$export$148b188041a720e4), classes);
};
const $30d2a068e8fb8317$var$TimeClockRoot = (0, $npagc.default)((0, $b49f245ba7b9ee5c$export$512b066b8abdfde4), {
    name: "MuiTimeClock",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "column",
    position: "relative"
});
const $30d2a068e8fb8317$var$TimeClockArrowSwitcher = (0, $npagc.default)((0, $dc1cb27af374d73a$export$597b7cbdb7b2a24c), {
    name: "MuiTimeClock",
    slot: "ArrowSwitcher",
    overridesResolver: (props, styles)=>styles.arrowSwitcher
})({
    position: "absolute",
    right: 12,
    top: 15
});
const $30d2a068e8fb8317$var$TIME_CLOCK_DEFAULT_VIEWS = [
    "hours",
    "minutes"
];
const $30d2a068e8fb8317$export$7e96244e18c4be57 = /*#__PURE__*/ $1T1QG.forwardRef(function TimeClock(inProps, ref) {
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiTimeClock"
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), ampmInClock: ampmInClock = false, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, showViewSwitcher: showViewSwitcher, onChange: onChange, view: inView, views: views = $30d2a068e8fb8317$var$TIME_CLOCK_DEFAULT_VIEWS, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, timezone: timezoneProp } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $30d2a068e8fb8317$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $1370ae3083e8f472$export$174d749f3b4c0f49)({
        name: "TimeClock",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $59c1a689a11004ea$export$2764b246aa3b75ba)
    });
    const valueOrReferenceDate = (0, $e3a5e2edb34513e1$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const translations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    const now = (0, $f3e8032daddc32c6$export$3a404aece3dff2fa)(timezone);
    const { view: view, setView: setView, previousView: previousView, nextView: nextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $1d4419ac03a36f0f$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $395c14dbcebe680a$export$6aaabc31cb076d17)(valueOrReferenceDate, ampm, setValueAndGoToNextView);
    const isTimeDisabled = $1T1QG.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $a99658949db23f4e$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = viewType === "hours" || viewType === "minutes" && views.includes("seconds");
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case "hours":
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), "hours");
                case "minutes":
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), "minutes");
                case "seconds":
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), "seconds");
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case "hours":
                {
                    const valueWithMeridiem = (0, $a99658949db23f4e$export$4159dc823695870e)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case "minutes":
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case "seconds":
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error("not supported");
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const selectedId = (0, $ea1f3283f0dc1f21$export$2e2bcd8739ae039)();
    const viewProps = $1T1QG.useMemo(()=>{
        switch(view){
            case "hours":
                {
                    const handleHoursChange = (hourValue, isFinish)=>{
                        const valueWithMeridiem = (0, $a99658949db23f4e$export$4159dc823695870e)(hourValue, meridiemMode, ampm);
                        setValueAndGoToNextView(utils.setHours(valueOrReferenceDate, valueWithMeridiem), isFinish, "hours");
                    };
                    return {
                        onChange: handleHoursChange,
                        viewValue: utils.getHours(valueOrReferenceDate),
                        children: (0, $d6fd666bdd61d131$export$10850582eda9a8c7)({
                            value: value,
                            utils: utils,
                            ampm: ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: translations.hoursClockNumberText,
                            isDisabled: (hourValue)=>disabled || isTimeDisabled(hourValue, "hours"),
                            selectedId: selectedId
                        })
                    };
                }
            case "minutes":
                {
                    const minutesValue = utils.getMinutes(valueOrReferenceDate);
                    const handleMinutesChange = (minuteValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setMinutes(valueOrReferenceDate, minuteValue), isFinish, "minutes");
                    };
                    return {
                        viewValue: minutesValue,
                        onChange: handleMinutesChange,
                        children: (0, $d6fd666bdd61d131$export$2c440057d7a731e4)({
                            utils: utils,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: translations.minutesClockNumberText,
                            isDisabled: (minuteValue)=>disabled || isTimeDisabled(minuteValue, "minutes"),
                            selectedId: selectedId
                        })
                    };
                }
            case "seconds":
                {
                    const secondsValue = utils.getSeconds(valueOrReferenceDate);
                    const handleSecondsChange = (secondValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setSeconds(valueOrReferenceDate, secondValue), isFinish, "seconds");
                    };
                    return {
                        viewValue: secondsValue,
                        onChange: handleSecondsChange,
                        children: (0, $d6fd666bdd61d131$export$2c440057d7a731e4)({
                            utils: utils,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: translations.secondsClockNumberText,
                            isDisabled: (secondValue)=>disabled || isTimeDisabled(secondValue, "seconds"),
                            selectedId: selectedId
                        })
                    };
                }
            default:
                throw new Error("You must provide the type for ClockView");
        }
    }, [
        view,
        utils,
        value,
        ampm,
        translations.hoursClockNumberText,
        translations.minutesClockNumberText,
        translations.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        selectedId,
        disabled
    ]);
    const ownerState = props;
    const classes = $30d2a068e8fb8317$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($30d2a068e8fb8317$var$TimeClockRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c2913a4c3122be3c$export$9735c82c4bae3302), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                autoFocus: autoFocus ?? !!focusedView,
                ampmInClock: ampmInClock && views.includes("hours"),
                value: value,
                type: view,
                ampm: ampm,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId,
                disabled: disabled,
                readOnly: readOnly
            }, viewProps)),
            showViewSwitcher && /*#__PURE__*/ (0, $3Py8h.jsx)($30d2a068e8fb8317$var$TimeClockArrowSwitcher, {
                className: classes.arrowSwitcher,
                slots: slots,
                slotProps: slotProps,
                onGoToPrevious: ()=>setView(previousView),
                isPreviousDisabled: !previousView,
                previousLabel: translations.openPreviousView,
                onGoToNext: ()=>setView(nextView),
                isNextDisabled: !nextView,
                nextLabel: translations.openNextView,
                ownerState: ownerState
            })
        ]
    }));
});





var $1T1QG = parcelRequire("1T1QG");




var $7Etkp = parcelRequire("7Etkp");
var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");











function $87207a1046ec6975$export$aeb645018b209578(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiDigitalClock", slot);
}
const $87207a1046ec6975$export$baf91642e79c8163 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiDigitalClock", [
    "root",
    "list",
    "item"
]);









var $3Py8h = parcelRequire("3Py8h");
"use client";
const $6958aaf842a40ca7$var$_excluded = [
    "ampm",
    "timeStep",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "views",
    "skipDisabled",
    "timezone"
];
const $6958aaf842a40ca7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        list: [
            "list"
        ],
        item: [
            "item"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $87207a1046ec6975$export$aeb645018b209578), classes);
};
const $6958aaf842a40ca7$var$DigitalClockRoot = (0, $npagc.default)((0, $b49f245ba7b9ee5c$export$512b066b8abdfde4), {
    name: "MuiDigitalClock",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    overflowY: "auto",
    width: "100%",
    "@media (prefers-reduced-motion: no-preference)": {
        scrollBehavior: "auto"
    },
    maxHeight: (0, $790faeda284dc7ce$export$1c2eabda4acea0e4),
    variants: [
        {
            props: {
                alreadyRendered: true
            },
            style: {
                "@media (prefers-reduced-motion: no-preference)": {
                    scrollBehavior: "smooth"
                }
            }
        }
    ]
});
const $6958aaf842a40ca7$var$DigitalClockList = (0, $npagc.default)((0, $0c6bdc89c1f59767$export$2e2bcd8739ae039), {
    name: "MuiDigitalClock",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    padding: 0
});
const $6958aaf842a40ca7$var$DigitalClockItem = (0, $npagc.default)((0, $450c65ee2dafa292$export$2e2bcd8739ae039), {
    name: "MuiDigitalClock",
    slot: "Item",
    overridesResolver: (props, styles)=>styles.item
})(({ theme: theme })=>({
        padding: "8px 16px",
        margin: "2px 4px",
        "&:first-of-type": {
            marginTop: 4
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        "&.Mui-selected": {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            "&:focus-visible, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        "&.Mui-focusVisible": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const $6958aaf842a40ca7$export$9a2b219a5b06deb7 = /*#__PURE__*/ $1T1QG.forwardRef(function DigitalClock(inProps, ref) {
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const containerRef = $1T1QG.useRef(null);
    const handleRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(ref, containerRef);
    const listRef = $1T1QG.useRef(null);
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiDigitalClock"
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), timeStep: timeStep = 30, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, views: views = [
        "hours"
    ], skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $6958aaf842a40ca7$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $1370ae3083e8f472$export$174d749f3b4c0f49)({
        name: "DigitalClock",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $59c1a689a11004ea$export$2764b246aa3b75ba)
    });
    const translations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    const now = (0, $f3e8032daddc32c6$export$3a404aece3dff2fa)(timezone);
    const ownerState = $1T1QG.useMemo(()=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, {
            alreadyRendered: !!containerRef.current
        }), [
        props
    ]);
    const classes = $6958aaf842a40ca7$var$useUtilityClasses(ownerState);
    const ClockItem = slots?.digitalClockItem ?? $6958aaf842a40ca7$var$DigitalClockItem;
    const clockItemProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: ClockItem,
        externalSlotProps: slotProps?.digitalClockItem,
        ownerState: {},
        className: classes.item
    });
    const valueOrReferenceDate = (0, $e3a5e2edb34513e1$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newValue)=>handleRawValueChange(newValue, "finish", "hours"));
    const { setValueAndGoToNextView: setValueAndGoToNextView } = (0, $1d4419ac03a36f0f$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleItemSelect = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newValue)=>{
        setValueAndGoToNextView(newValue, "finish");
    });
    $1T1QG.useEffect(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="listbox"] [role="option"][tabindex="0"], [role="listbox"] [role="option"][aria-selected="true"]');
        if (!activeItem) return;
        const offsetTop = activeItem.offsetTop;
        if (autoFocus || !!focusedView) activeItem.focus();
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const isTimeDisabled = $1T1QG.useCallback((valueToCheck)=>{
        const isAfter = (0, $a99658949db23f4e$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const containsValidTime = ()=>{
            if (minTime && isAfter(minTime, valueToCheck)) return false;
            if (maxTime && isAfter(valueToCheck, maxTime)) return false;
            if (disableFuture && isAfter(valueToCheck, now)) return false;
            if (disablePast && isAfter(now, valueToCheck)) return false;
            return true;
        };
        const isValidValue = ()=>{
            if (utils.getMinutes(valueToCheck) % minutesStep !== 0) return false;
            if (shouldDisableTime) return !shouldDisableTime(valueToCheck, "hours");
            return true;
        };
        return !containsValidTime() || !isValidValue();
    }, [
        disableIgnoringDatePartForTimeValidation,
        utils,
        minTime,
        maxTime,
        disableFuture,
        now,
        disablePast,
        minutesStep,
        shouldDisableTime
    ]);
    const timeOptions = $1T1QG.useMemo(()=>{
        const result = [];
        const startOfDay = utils.startOfDay(valueOrReferenceDate);
        let nextTimeStepOption = startOfDay;
        while(utils.isSameDay(valueOrReferenceDate, nextTimeStepOption)){
            result.push(nextTimeStepOption);
            nextTimeStepOption = utils.addMinutes(nextTimeStepOption, timeStep);
        }
        return result;
    }, [
        valueOrReferenceDate,
        timeStep,
        utils
    ]);
    const focusedOptionIndex = timeOptions.findIndex((option)=>utils.isEqual(option, valueOrReferenceDate));
    const handleKeyDown = (event)=>{
        switch(event.key){
            case "PageUp":
                {
                    const newIndex = (0, $68e3e92a73d67afe$export$4165ccf43f4d7767)(listRef.current) - 5;
                    const children = listRef.current.children;
                    const newFocusedIndex = Math.max(0, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            case "PageDown":
                {
                    const newIndex = (0, $68e3e92a73d67afe$export$4165ccf43f4d7767)(listRef.current) + 5;
                    const children = listRef.current.children;
                    const newFocusedIndex = Math.min(children.length - 1, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            default:
        }
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)($6958aaf842a40ca7$var$DigitalClockRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        ref: handleRef,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($6958aaf842a40ca7$var$DigitalClockList, {
            ref: listRef,
            role: "listbox",
            "aria-label": translations.timePickerToolbarTitle,
            className: classes.list,
            onKeyDown: handleKeyDown,
            children: timeOptions.map((option, index)=>{
                if (skipDisabled && isTimeDisabled(option)) return null;
                const isSelected = utils.isEqual(option, value);
                const formattedValue = utils.format(option, ampm ? "fullTime12h" : "fullTime24h");
                const tabIndex = focusedOptionIndex === index || focusedOptionIndex === -1 && index === 0 ? 0 : -1;
                return /*#__PURE__*/ (0, $3Py8h.jsx)(ClockItem, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                    onClick: ()=>!readOnly && handleItemSelect(option),
                    selected: isSelected,
                    disabled: disabled || isTimeDisabled(option),
                    disableRipple: readOnly,
                    role: "option",
                    "aria-disabled": readOnly,
                    "aria-selected": isSelected,
                    tabIndex: tabIndex
                }, clockItemProps, {
                    children: formattedValue
                }), `${option.valueOf()}-${formattedValue}`);
            })
        })
    }));
});





var $1T1QG = parcelRequire("1T1QG");




var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");










function $13d8440418eb17c7$export$b828b7724b7b2890(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiMultiSectionDigitalClock", slot);
}
const $13d8440418eb17c7$export$f2277d947b8f7a8a = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiMultiSectionDigitalClock", [
    "root"
]);





var $1T1QG = parcelRequire("1T1QG");


var $7Etkp = parcelRequire("7Etkp");
var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");






function $6d4eec1ec22c9101$export$ab23463cad6963ff(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiMultiSectionDigitalClockSection", slot);
}
const $6d4eec1ec22c9101$export$eaf2b63fa45eff23 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiMultiSectionDigitalClockSection", [
    "root",
    "item"
]);





var $3Py8h = parcelRequire("3Py8h");
const $0d18e21a0466228d$var$_excluded = [
    "autoFocus",
    "onChange",
    "className",
    "disabled",
    "readOnly",
    "items",
    "active",
    "slots",
    "slotProps",
    "skipDisabled"
];
const $0d18e21a0466228d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        item: [
            "item"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $6d4eec1ec22c9101$export$ab23463cad6963ff), classes);
};
const $0d18e21a0466228d$var$MultiSectionDigitalClockSectionRoot = (0, $npagc.default)((0, $0c6bdc89c1f59767$export$2e2bcd8739ae039), {
    name: "MuiMultiSectionDigitalClockSection",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        maxHeight: (0, $790faeda284dc7ce$export$1c2eabda4acea0e4),
        width: 56,
        padding: 0,
        overflow: "hidden",
        "@media (prefers-reduced-motion: no-preference)": {
            scrollBehavior: "auto"
        },
        "@media (pointer: fine)": {
            "&:hover": {
                overflowY: "auto"
            }
        },
        "@media (pointer: none), (pointer: coarse)": {
            overflowY: "auto"
        },
        "&:not(:first-of-type)": {
            borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
        },
        "&::after": {
            display: "block",
            content: '""',
            // subtracting the height of one item, extra margin and borders to make sure the max height is correct
            height: "calc(100% - 40px - 6px)"
        },
        variants: [
            {
                props: {
                    alreadyRendered: true
                },
                style: {
                    "@media (prefers-reduced-motion: no-preference)": {
                        scrollBehavior: "smooth"
                    }
                }
            }
        ]
    }));
const $0d18e21a0466228d$var$MultiSectionDigitalClockSectionItem = (0, $npagc.default)((0, $450c65ee2dafa292$export$2e2bcd8739ae039), {
    name: "MuiMultiSectionDigitalClockSection",
    slot: "Item",
    overridesResolver: (_, styles)=>styles.item
})(({ theme: theme })=>({
        padding: 8,
        margin: "2px 4px",
        width: (0, $790faeda284dc7ce$export$a462ceb9cfdb5d71),
        justifyContent: "center",
        "&:first-of-type": {
            marginTop: 4
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        "&.Mui-selected": {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            "&:focus-visible, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        "&.Mui-focusVisible": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const $0d18e21a0466228d$export$f971f93dc8464c = /*#__PURE__*/ $1T1QG.forwardRef(function MultiSectionDigitalClockSection(inProps, ref) {
    const containerRef = $1T1QG.useRef(null);
    const handleRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(ref, containerRef);
    const previousActive = $1T1QG.useRef(null);
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiMultiSectionDigitalClockSection"
    });
    const { autoFocus: autoFocus, onChange: onChange, className: className, disabled: disabled, readOnly: readOnly, items: items, active: active, slots: slots, slotProps: slotProps, skipDisabled: skipDisabled } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $0d18e21a0466228d$var$_excluded);
    const ownerState = $1T1QG.useMemo(()=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, {
            alreadyRendered: !!containerRef.current
        }), [
        props
    ]);
    const classes = $0d18e21a0466228d$var$useUtilityClasses(ownerState);
    const DigitalClockSectionItem = slots?.digitalClockSectionItem ?? $0d18e21a0466228d$var$MultiSectionDigitalClockSectionItem;
    $1T1QG.useEffect(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="option"][tabindex="0"], [role="option"][aria-selected="true"]');
        if (active && autoFocus && activeItem) activeItem.focus();
        if (!activeItem || previousActive.current === activeItem) return;
        previousActive.current = activeItem;
        const offsetTop = activeItem.offsetTop;
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const focusedOptionIndex = items.findIndex((item)=>item.isFocused(item.value));
    const handleKeyDown = (event)=>{
        switch(event.key){
            case "PageUp":
                {
                    const newIndex = (0, $68e3e92a73d67afe$export$4165ccf43f4d7767)(containerRef.current) - 5;
                    const children = containerRef.current.children;
                    const newFocusedIndex = Math.max(0, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            case "PageDown":
                {
                    const newIndex = (0, $68e3e92a73d67afe$export$4165ccf43f4d7767)(containerRef.current) + 5;
                    const children = containerRef.current.children;
                    const newFocusedIndex = Math.min(children.length - 1, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            default:
        }
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)($0d18e21a0466228d$var$MultiSectionDigitalClockSectionRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        ref: handleRef,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        autoFocusItem: autoFocus && active,
        role: "listbox",
        onKeyDown: handleKeyDown
    }, other, {
        children: items.map((option, index)=>{
            const isItemDisabled = option.isDisabled?.(option.value);
            const isDisabled = disabled || isItemDisabled;
            if (skipDisabled && isDisabled) return null;
            const isSelected = option.isSelected(option.value);
            const tabIndex = focusedOptionIndex === index || focusedOptionIndex === -1 && index === 0 ? 0 : -1;
            return /*#__PURE__*/ (0, $3Py8h.jsx)(DigitalClockSectionItem, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                onClick: ()=>!readOnly && onChange(option.value),
                selected: isSelected,
                disabled: isDisabled,
                disableRipple: readOnly,
                role: "option",
                "aria-disabled": readOnly || isDisabled || undefined,
                "aria-label": option.ariaLabel,
                "aria-selected": isSelected,
                tabIndex: tabIndex,
                className: classes.item
            }, slotProps?.digitalClockSectionItem, {
                children: option.label
            }), option.label);
        })
    }));
});


const $b744251590f18e82$export$9101aa7ba362bb4e = ({ now: now, value: value, utils: utils, ampm: ampm, isDisabled: isDisabled, resolveAriaLabel: resolveAriaLabel, timeStep: timeStep, valueOrReferenceDate: valueOrReferenceDate })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const result = [];
    const isSelected = (hour, overriddenCurrentHours)=>{
        const resolvedCurrentHours = overriddenCurrentHours ?? currentHours;
        if (resolvedCurrentHours === null) return false;
        if (ampm) {
            if (hour === 12) return resolvedCurrentHours === 12 || resolvedCurrentHours === 0;
            return resolvedCurrentHours === hour || resolvedCurrentHours - 12 === hour;
        }
        return resolvedCurrentHours === hour;
    };
    const isFocused = (hour)=>{
        return isSelected(hour, utils.getHours(valueOrReferenceDate));
    };
    const endHour = ampm ? 11 : 23;
    for(let hour = 0; hour <= endHour; hour += timeStep){
        let label = utils.format(utils.setHours(now, hour), ampm ? "hours12h" : "hours24h");
        const ariaLabel = resolveAriaLabel(parseInt(label, 10).toString());
        label = utils.formatNumber(label);
        result.push({
            value: hour,
            label: label,
            isSelected: isSelected,
            isDisabled: isDisabled,
            isFocused: isFocused,
            ariaLabel: ariaLabel
        });
    }
    return result;
};
const $b744251590f18e82$export$e7b56db95f8a7b9c = ({ value: value, utils: utils, isDisabled: isDisabled, timeStep: timeStep, resolveLabel: resolveLabel, resolveAriaLabel: resolveAriaLabel, hasValue: hasValue = true })=>{
    const isSelected = (timeValue)=>{
        if (value === null) return false;
        return hasValue && value === timeValue;
    };
    const isFocused = (timeValue)=>{
        return value === timeValue;
    };
    return [
        ...Array.from({
            length: Math.ceil(60 / timeStep)
        }, (_, index)=>{
            const timeValue = timeStep * index;
            return {
                value: timeValue,
                label: utils.formatNumber(resolveLabel(timeValue)),
                isDisabled: isDisabled,
                isSelected: isSelected,
                isFocused: isFocused,
                ariaLabel: resolveAriaLabel(timeValue.toString())
            };
        })
    ];
};







var $3Py8h = parcelRequire("3Py8h");
"use client";
const $50bf42e3e1d1f803$var$_excluded = [
    "ampm",
    "timeSteps",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "skipDisabled",
    "timezone"
];
const $50bf42e3e1d1f803$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $13d8440418eb17c7$export$b828b7724b7b2890), classes);
};
const $50bf42e3e1d1f803$var$MultiSectionDigitalClockRoot = (0, $npagc.default)((0, $b49f245ba7b9ee5c$export$512b066b8abdfde4), {
    name: "MuiMultiSectionDigitalClock",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        display: "flex",
        flexDirection: "row",
        width: "100%",
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $50bf42e3e1d1f803$export$c48dada788ff933b = /*#__PURE__*/ $1T1QG.forwardRef(function MultiSectionDigitalClock(inProps, ref) {
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const isRtl = (0, $a69327a401bfde77$export$b2dd014b6c321cb)();
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiMultiSectionDigitalClock"
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), timeSteps: inTimeSteps, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, views: inViews = [
        "hours",
        "minutes"
    ], openTo: openTo, onViewChange: onViewChange, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $50bf42e3e1d1f803$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $1370ae3083e8f472$export$174d749f3b4c0f49)({
        name: "MultiSectionDigitalClock",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $59c1a689a11004ea$export$2764b246aa3b75ba)
    });
    const translations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    const now = (0, $f3e8032daddc32c6$export$3a404aece3dff2fa)(timezone);
    const timeSteps = $1T1QG.useMemo(()=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
            hours: 1,
            minutes: 5,
            seconds: 5
        }, inTimeSteps), [
        inTimeSteps
    ]);
    const valueOrReferenceDate = (0, $e3a5e2edb34513e1$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newValue, selectionState, selectedView)=>handleRawValueChange(newValue, selectionState, selectedView));
    const views = $1T1QG.useMemo(()=>{
        if (!ampm || !inViews.includes("hours")) return inViews;
        return inViews.includes("meridiem") ? inViews : [
            ...inViews,
            "meridiem"
        ];
    }, [
        ampm,
        inViews
    ]);
    const { view: view, setValueAndGoToNextView: setValueAndGoToNextView, focusedView: focusedView } = (0, $1d4419ac03a36f0f$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleMeridiemValueChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newValue)=>{
        setValueAndGoToNextView(newValue, "finish", "meridiem");
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $395c14dbcebe680a$export$6aaabc31cb076d17)(valueOrReferenceDate, ampm, handleMeridiemValueChange, "finish");
    const isTimeDisabled = $1T1QG.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $a99658949db23f4e$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = viewType === "hours" || viewType === "minutes" && views.includes("seconds");
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case "hours":
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), "hours");
                case "minutes":
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), "minutes");
                case "seconds":
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), "seconds");
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case "hours":
                {
                    const valueWithMeridiem = (0, $a99658949db23f4e$export$4159dc823695870e)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case "minutes":
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case "seconds":
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error("not supported");
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const buildViewProps = $1T1QG.useCallback((viewToBuild)=>{
        switch(viewToBuild){
            case "hours":
                return {
                    onChange: (hours)=>{
                        const valueWithMeridiem = (0, $a99658949db23f4e$export$4159dc823695870e)(hours, meridiemMode, ampm);
                        setValueAndGoToNextView(utils.setHours(valueOrReferenceDate, valueWithMeridiem), "finish", "hours");
                    },
                    items: (0, $b744251590f18e82$export$9101aa7ba362bb4e)({
                        now: now,
                        value: value,
                        ampm: ampm,
                        utils: utils,
                        isDisabled: (hours)=>isTimeDisabled(hours, "hours"),
                        timeStep: timeSteps.hours,
                        resolveAriaLabel: translations.hoursClockNumberText,
                        valueOrReferenceDate: valueOrReferenceDate
                    })
                };
            case "minutes":
                return {
                    onChange: (minutes)=>{
                        setValueAndGoToNextView(utils.setMinutes(valueOrReferenceDate, minutes), "finish", "minutes");
                    },
                    items: (0, $b744251590f18e82$export$e7b56db95f8a7b9c)({
                        value: utils.getMinutes(valueOrReferenceDate),
                        utils: utils,
                        isDisabled: (minutes)=>isTimeDisabled(minutes, "minutes"),
                        resolveLabel: (minutes)=>utils.format(utils.setMinutes(now, minutes), "minutes"),
                        timeStep: timeSteps.minutes,
                        hasValue: !!value,
                        resolveAriaLabel: translations.minutesClockNumberText
                    })
                };
            case "seconds":
                return {
                    onChange: (seconds)=>{
                        setValueAndGoToNextView(utils.setSeconds(valueOrReferenceDate, seconds), "finish", "seconds");
                    },
                    items: (0, $b744251590f18e82$export$e7b56db95f8a7b9c)({
                        value: utils.getSeconds(valueOrReferenceDate),
                        utils: utils,
                        isDisabled: (seconds)=>isTimeDisabled(seconds, "seconds"),
                        resolveLabel: (seconds)=>utils.format(utils.setSeconds(now, seconds), "seconds"),
                        timeStep: timeSteps.seconds,
                        hasValue: !!value,
                        resolveAriaLabel: translations.secondsClockNumberText
                    })
                };
            case "meridiem":
                {
                    const amLabel = (0, $2c8437f6b047f676$export$fae94c0a662107ef)(utils, "am");
                    const pmLabel = (0, $2c8437f6b047f676$export$fae94c0a662107ef)(utils, "pm");
                    return {
                        onChange: handleMeridiemChange,
                        items: [
                            {
                                value: "am",
                                label: amLabel,
                                isSelected: ()=>!!value && meridiemMode === "am",
                                isFocused: ()=>!!valueOrReferenceDate && meridiemMode === "am",
                                ariaLabel: amLabel
                            },
                            {
                                value: "pm",
                                label: pmLabel,
                                isSelected: ()=>!!value && meridiemMode === "pm",
                                isFocused: ()=>!!valueOrReferenceDate && meridiemMode === "pm",
                                ariaLabel: pmLabel
                            }
                        ]
                    };
                }
            default:
                throw new Error(`Unknown view: ${viewToBuild} found.`);
        }
    }, [
        now,
        value,
        ampm,
        utils,
        timeSteps.hours,
        timeSteps.minutes,
        timeSteps.seconds,
        translations.hoursClockNumberText,
        translations.minutesClockNumberText,
        translations.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        handleMeridiemChange
    ]);
    const viewsToRender = $1T1QG.useMemo(()=>{
        if (!isRtl) return views;
        const digitViews = views.filter((v)=>v !== "meridiem");
        digitViews.reverse();
        if (views.includes("meridiem")) digitViews.push("meridiem");
        return digitViews;
    }, [
        isRtl,
        views
    ]);
    const viewTimeOptions = $1T1QG.useMemo(()=>{
        return views.reduce((result, currentView)=>{
            return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, result, {
                [currentView]: buildViewProps(currentView)
            });
        }, {});
    }, [
        views,
        buildViewProps
    ]);
    const ownerState = props;
    const classes = $50bf42e3e1d1f803$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($50bf42e3e1d1f803$var$MultiSectionDigitalClockRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "group"
    }, other, {
        children: viewsToRender.map((timeView)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $0d18e21a0466228d$export$f971f93dc8464c), {
                items: viewTimeOptions[timeView].items,
                onChange: viewTimeOptions[timeView].onChange,
                active: view === timeView,
                autoFocus: autoFocus ?? focusedView === timeView,
                disabled: disabled,
                readOnly: readOnly,
                slots: slots,
                slotProps: slotProps,
                skipDisabled: skipDisabled,
                "aria-label": translations.selectViewText(timeView)
            }, timeView))
    }));
});




var $3Py8h = parcelRequire("3Py8h");
const $423f7f44d9a12e34$export$a3ad21a1b07c504f = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, ampmInClock: ampmInClock, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, showViewSwitcher: showViewSwitcher, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timezone: timezone })=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $30d2a068e8fb8317$export$7e96244e18c4be57), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, $a99658949db23f4e$export$8f04d380cefd5a0d)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $a99658949db23f4e$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        ampmInClock: ampmInClock,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        showViewSwitcher: showViewSwitcher,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timezone: timezone
    });
const $423f7f44d9a12e34$export$a2917c76dc0aa7e = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $6958aaf842a40ca7$export$9a2b219a5b06deb7), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $a99658949db23f4e$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeStep: timeSteps?.minutes,
        skipDisabled: skipDisabled,
        timezone: timezone
    });
const $423f7f44d9a12e34$export$48a290886291c531 = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $50bf42e3e1d1f803$export$c48dada788ff933b), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $a99658949db23f4e$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeSteps: timeSteps,
        skipDisabled: skipDisabled,
        timezone: timezone
    });






var $1T1QG = parcelRequire("1T1QG");






var $3Py8h = parcelRequire("3Py8h");
/**
 * @ignore - internal component.
 */ const $e231de61aa657497$export$4066d2955a85e052 = /*#__PURE__*/ $1T1QG.forwardRef(function DesktopDateTimePickerLayout(props, ref) {
    const isRtl = (0, $a69327a401bfde77$export$b2dd014b6c321cb)();
    const { toolbar: toolbar, tabs: tabs, content: content, actionBar: actionBar, shortcuts: shortcuts } = (0, $7d9847cffb4d6595$export$2e2bcd8739ae039)(props);
    const { sx: sx, className: className, isLandscape: isLandscape, classes: classes } = props;
    const isActionBarVisible = actionBar && (actionBar.props.actions?.length ?? 0) > 0;
    const ownerState = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, {
        isRtl: isRtl
    });
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $fc46d30a907f069d$export$9a9363506c13836), {
        ref: ref,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)((0, $2a69b26d9f9cbebb$export$7a6dac186703fe4c).root, classes?.root, className),
        sx: [
            {
                [`& .${(0, $2a69b26d9f9cbebb$export$7a6dac186703fe4c).tabs}`]: {
                    gridRow: 4,
                    gridColumn: "1 / 4"
                },
                [`& .${(0, $2a69b26d9f9cbebb$export$7a6dac186703fe4c).actionBar}`]: {
                    gridRow: 5
                }
            },
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        ownerState: ownerState,
        children: [
            isLandscape ? shortcuts : toolbar,
            isLandscape ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $fc46d30a907f069d$export$bc1494d918129235), {
                className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)((0, $2a69b26d9f9cbebb$export$7a6dac186703fe4c).contentWrapper, classes?.contentWrapper),
                sx: {
                    display: "grid"
                },
                children: [
                    content,
                    tabs,
                    isActionBarVisible && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a976032e8b2c1f5c$export$2e2bcd8739ae039), {
                        sx: {
                            gridRow: 3,
                            gridColumn: "1 / 4"
                        }
                    })
                ]
            }),
            actionBar
        ]
    });
});







var $3Py8h = parcelRequire("3Py8h");
"use client";
const $a5a3b82e69917487$var$_excluded = [
    "openTo",
    "focusedView",
    "timeViewsCount"
];
const $a5a3b82e69917487$var$rendererInterceptor = function rendererInterceptor(inViewRenderers, popperView, rendererProps) {
    const { openTo: openTo, focusedView: focusedView, timeViewsCount: timeViewsCount } = rendererProps, otherProps = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(rendererProps, $a5a3b82e69917487$var$_excluded);
    const finalProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, otherProps, {
        focusedView: null,
        sx: [
            {
                [`&.${(0, $13d8440418eb17c7$export$f2277d947b8f7a8a).root}`]: {
                    borderBottom: 0
                },
                [`&.${(0, $13d8440418eb17c7$export$f2277d947b8f7a8a).root}, .${(0, $6d4eec1ec22c9101$export$eaf2b63fa45eff23).root}, &.${(0, $87207a1046ec6975$export$baf91642e79c8163).root}`]: {
                    maxHeight: (0, $790faeda284dc7ce$export$f2fef360e2df0cb7)
                }
            }
        ]
    });
    const isTimeViewActive = (0, $a99658949db23f4e$export$a3328136ac50623d)(popperView);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
        children: [
            inViewRenderers[!isTimeViewActive ? popperView : "day"]?.((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, rendererProps, {
                view: !isTimeViewActive ? popperView : "day",
                focusedView: focusedView && (0, $2c8437f6b047f676$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
                views: rendererProps.views.filter((0, $2c8437f6b047f676$export$b32dfef9f07dea64)),
                sx: [
                    {
                        gridColumn: 1
                    },
                    ...finalProps.sx
                ]
            })),
            timeViewsCount > 0 && /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a976032e8b2c1f5c$export$2e2bcd8739ae039), {
                        orientation: "vertical",
                        sx: {
                            gridColumn: 2
                        }
                    }),
                    inViewRenderers[isTimeViewActive ? popperView : "hours"]?.((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, finalProps, {
                        view: isTimeViewActive ? popperView : "hours",
                        focusedView: focusedView && (0, $a99658949db23f4e$export$a3328136ac50623d)(focusedView) ? focusedView : null,
                        openTo: (0, $a99658949db23f4e$export$a3328136ac50623d)(openTo) ? openTo : "hours",
                        views: rendererProps.views.filter((0, $a99658949db23f4e$export$a3328136ac50623d)),
                        sx: [
                            {
                                gridColumn: 3
                            },
                            ...finalProps.sx
                        ]
                    }))
                ]
            })
        ]
    });
};
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDateTimePicker API](https://mui.com/x/api/date-pickers/desktop-date-time-picker/)
 */ const $a5a3b82e69917487$export$74e5e82f1557571f = /*#__PURE__*/ $1T1QG.forwardRef(function DesktopDateTimePicker(inProps, ref) {
    const translations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, $bf8c9a745e3f8782$export$6e4d96e87e6dc2d3)(inProps, "MuiDesktopDateTimePicker");
    const { shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn, thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn, views: resolvedViews, timeSteps: timeSteps } = (0, $a5c7bda3180b1cc0$export$e2d664f2dd4d34bc)(defaultizedProps);
    const renderTimeView = shouldRenderTimeInASingleColumn ? (0, $423f7f44d9a12e34$export$a2917c76dc0aa7e) : (0, $423f7f44d9a12e34$export$48a290886291c531);
    const viewRenderers = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        day: (0, $e5272c464051a472$export$69888ffe06193e5e),
        month: (0, $e5272c464051a472$export$69888ffe06193e5e),
        year: (0, $e5272c464051a472$export$69888ffe06193e5e),
        hours: renderTimeView,
        minutes: renderTimeView,
        seconds: renderTimeView,
        meridiem: renderTimeView
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? true;
    // Need to avoid adding the `meridiem` view when unexpected renderer is specified
    const shouldHoursRendererContainMeridiemView = viewRenderers.hours?.name === (0, $423f7f44d9a12e34$export$48a290886291c531).name;
    const views = !shouldHoursRendererContainMeridiemView ? resolvedViews.filter((view)=>view !== "meridiem") : resolvedViews;
    const actionBarActions = shouldRenderTimeInASingleColumn ? [] : [
        "accept"
    ];
    // Props with the default values specific to the desktop variant
    const props = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $a5c7bda3180b1cc0$export$ebf7b30b32db6f57)(utils, defaultizedProps),
        views: views,
        yearsPerRow: defaultizedProps.yearsPerRow ?? 4,
        ampmInClock: ampmInClock,
        timeSteps: timeSteps,
        thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn,
        shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn,
        slots: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
            field: (0, $53aa224b2d514be5$export$ae1ced156568f0b0),
            layout: (0, $e231de61aa657497$export$4066d2955a85e052),
            openPickerIcon: (0, $705a86f4b9915dac$export$5fda1783bb83f57b)
        }, defaultizedProps.slots),
        slotProps: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, (0, $381cff6a989e76ba$export$2e2bcd8739ae039)(defaultizedProps.slotProps?.field, ownerState), (0, $5aeaf2f033f161b7$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                hidden: true,
                ampmInClock: ampmInClock,
                toolbarVariant: "desktop"
            }, defaultizedProps.slotProps?.toolbar),
            tabs: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                hidden: true
            }, defaultizedProps.slotProps?.tabs),
            actionBar: (ownerState)=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                    actions: actionBarActions
                }, (0, $381cff6a989e76ba$export$2e2bcd8739ae039)(defaultizedProps.slotProps?.actionBar, ownerState))
        })
    });
    const { renderPicker: renderPicker } = (0, $ce8461dc80dc4c33$export$b1b70bc56ac5be0e)({
        props: props,
        valueManager: (0, $59c1a689a11004ea$export$2764b246aa3b75ba),
        valueType: "date-time",
        getOpenDialogAriaText: (0, $3f33724e76f40ee3$export$7eae96bf9dd7ca56)({
            utils: utils,
            formatKey: "fullDate",
            contextTranslation: translations.openDatePickerDialogue,
            propsTranslation: props.localeText?.openDatePickerDialogue
        }),
        validator: (0, $36aa9dc0cdfa81f8$export$ed94a8ff1f54c4f),
        rendererInterceptor: $a5a3b82e69917487$var$rendererInterceptor
    });
    return renderPicker();
});
$a5a3b82e69917487$export$74e5e82f1557571f.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $12e3e097abfa372a$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */ maxDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */ minDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).number,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "day",
        "hours",
        "meridiem",
        "minutes",
        "month",
        "seconds",
        "year"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
            "all",
            "day",
            "empty",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */ skipDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object
    ]),
    /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */ thresholdToRenderTimeInASingleColumn: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).number,
    /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */ timeSteps: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).number,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).number,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).number
    }),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "day",
        "hours",
        "meridiem",
        "minutes",
        "month",
        "seconds",
        "year"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
        meridiem: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "day",
        "hours",
        "minutes",
        "month",
        "seconds",
        "year"
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "asc",
        "desc"
    ]),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        3,
        4
    ])
};




var $1T1QG = parcelRequire("1T1QG");

var $ajKsV = parcelRequire("ajKsV");











var $1T1QG = parcelRequire("1T1QG");




parcelRequire("1T1QG");




var $npagc = parcelRequire("npagc");


var $3Py8h = parcelRequire("3Py8h");
const $0b3498b415bfec38$var$PickersModalDialogRoot = (0, $npagc.default)((0, $7bea536f0798909b$export$2e2bcd8739ae039))({
    [`& .${(0, $6b123947f59f4da8$export$2e2bcd8739ae039).container}`]: {
        outline: 0
    },
    [`& .${(0, $6b123947f59f4da8$export$2e2bcd8739ae039).paper}`]: {
        outline: 0,
        minWidth: (0, $790faeda284dc7ce$export$ee46b8a74d6c94d3)
    }
});
const $0b3498b415bfec38$var$PickersModalDialogContent = (0, $npagc.default)((0, $f1aede6b3222f80a$export$2e2bcd8739ae039))({
    "&:first-of-type": {
        padding: 0
    }
});
function $0b3498b415bfec38$export$99f83c99e1491f77(props) {
    const { children: children, onDismiss: onDismiss, open: open, slots: slots, slotProps: slotProps } = props;
    const Dialog = slots?.dialog ?? $0b3498b415bfec38$var$PickersModalDialogRoot;
    const Transition = slots?.mobileTransition ?? (0, $a2c582129c3c8d70$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $3Py8h.jsx)(Dialog, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        open: open,
        onClose: onDismiss
    }, slotProps?.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps?.mobileTransition,
        PaperComponent: slots?.mobilePaper,
        PaperProps: slotProps?.mobilePaper,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($0b3498b415bfec38$var$PickersModalDialogContent, {
            children: children
        })
    }));
}







var $3Py8h = parcelRequire("3Py8h");
const $c85bb7c8b299a071$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
];
const $c85bb7c8b299a071$export$5ca0153a626a7dd7 = (_ref)=>{
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_ref, $c85bb7c8b299a071$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezone, name: name, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, localeText: localeText } = props;
    const fieldRef = $1T1QG.useRef(null);
    const labelId = (0, $ea1f3283f0dc1f21$export$2e2bcd8739ae039)();
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const { open: open, actions: actions, layoutProps: layoutProps, renderCurrentView: renderCurrentView, fieldProps: pickerFieldProps, contextValue: contextValue } = (0, $ad286f8dcf1caecc$export$fc3313977ac596c4)((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, pickerParams, {
        props: props,
        fieldRef: fieldRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: "mobile"
    }));
    const Field = slots.field;
    const fieldProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, !(disabled || readOnly) && {
            onClick: actions.onOpen,
            onKeyDown: (0, $68e3e92a73d67afe$export$4467fe8634707c85)(actions.onOpen)
        }, {
            readOnly: readOnly ?? true,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            timezone: timezone,
            label: label,
            name: name
        }, inputRef ? {
            inputRef: inputRef
        } : {}),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    fieldProps.inputProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, fieldProps.inputProps, {
        "aria-label": getOpenDialogAriaText(pickerFieldProps.value)
    });
    const slotsForField = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        textField: slots.textField
    }, fieldProps.slots);
    const Layout = slots.layout ?? (0, $fc46d30a907f069d$export$647f604ea2397c05);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, innerSlotProps, {
        toolbar: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
            "aria-labelledby": labelledById
        }, innerSlotProps?.mobilePaper)
    });
    const handleFieldRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(fieldRef, fieldProps.unstableFieldRef);
    const renderPicker = ()=>/*#__PURE__*/ (0, $3Py8h.jsxs)((0, $ec10b178b7b16965$export$38e969d523d4d57f), {
            contextValue: contextValue,
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)(Field, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    unstableFieldRef: handleFieldRef
                })),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $0b3498b415bfec38$export$99f83c99e1491f77), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)(Layout, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, layoutProps, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};






"use client";
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDateTimePicker API](https://mui.com/x/api/date-pickers/mobile-date-time-picker/)
 */ const $94e8bb732212f85b$export$5b4e219fe76d27da = /*#__PURE__*/ $1T1QG.forwardRef(function MobileDateTimePicker(inProps, ref) {
    const translations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, $bf8c9a745e3f8782$export$6e4d96e87e6dc2d3)(inProps, "MuiMobileDateTimePicker");
    const viewRenderers = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        day: (0, $e5272c464051a472$export$69888ffe06193e5e),
        month: (0, $e5272c464051a472$export$69888ffe06193e5e),
        year: (0, $e5272c464051a472$export$69888ffe06193e5e),
        hours: (0, $423f7f44d9a12e34$export$a3ad21a1b07c504f),
        minutes: (0, $423f7f44d9a12e34$export$a3ad21a1b07c504f),
        seconds: (0, $423f7f44d9a12e34$export$a3ad21a1b07c504f)
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? false;
    // Props with the default values specific to the mobile variant
    const props = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $a5c7bda3180b1cc0$export$ebf7b30b32db6f57)(utils, defaultizedProps),
        ampmInClock: ampmInClock,
        slots: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
            field: (0, $53aa224b2d514be5$export$ae1ced156568f0b0)
        }, defaultizedProps.slots),
        slotProps: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, (0, $381cff6a989e76ba$export$2e2bcd8739ae039)(defaultizedProps.slotProps?.field, ownerState), (0, $5aeaf2f033f161b7$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                hidden: false,
                ampmInClock: ampmInClock
            }, defaultizedProps.slotProps?.toolbar),
            tabs: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                hidden: false
            }, defaultizedProps.slotProps?.tabs)
        })
    });
    const { renderPicker: renderPicker } = (0, $c85bb7c8b299a071$export$5ca0153a626a7dd7)({
        props: props,
        valueManager: (0, $59c1a689a11004ea$export$2764b246aa3b75ba),
        valueType: "date-time",
        getOpenDialogAriaText: (0, $3f33724e76f40ee3$export$7eae96bf9dd7ca56)({
            utils: utils,
            formatKey: "fullDate",
            contextTranslation: translations.openDatePickerDialogue,
            propsTranslation: props.localeText?.openDatePickerDialogue
        }),
        validator: (0, $36aa9dc0cdfa81f8$export$ed94a8ff1f54c4f)
    });
    return renderPicker();
});
$94e8bb732212f85b$export$5b4e219fe76d27da.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $12e3e097abfa372a$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */ maxDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */ minDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).number,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "day",
        "hours",
        "minutes",
        "month",
        "seconds",
        "year"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
            "all",
            "day",
            "empty",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "day",
        "hours",
        "minutes",
        "month",
        "seconds",
        "year"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "day",
        "hours",
        "minutes",
        "month",
        "seconds",
        "year"
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "asc",
        "desc"
    ]),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        3,
        4
    ])
};




var $3Py8h = parcelRequire("3Py8h");
"use client";
const $ad585888a85c972f$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DateTimePicker API](https://mui.com/x/api/date-pickers/date-time-picker/)
 */ const $ad585888a85c972f$export$ccdfd7928785632e = /*#__PURE__*/ $1T1QG.forwardRef(function DateTimePicker(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiDateTimePicker"
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $68e3e92a73d67afe$export$9ae5b19305db48ce) } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $ad585888a85c972f$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $ffad103d3c7e3bc8$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a5a3b82e69917487$export$74e5e82f1557571f), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $94e8bb732212f85b$export$5b4e219fe76d27da), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
});



const $cec09b38543d677a$var$FormIndividualRightHolder = (props)=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const offeringName = props.offering?.name || "";
    const getFormDefaultValues = ()=>{
        return {
            firstName: props.defaultValues?.firstName || "",
            lastName: props.defaultValues?.lastName || "",
            email: props.defaultValues?.email || "",
            phoneNumber: props.defaultValues?.phoneNumber || (0, $f989e98d45efceaa$export$32ea325d92ea6082).PHONE_FI_COUNTRY_CODE,
            licensePlate: props.defaultValues?.licensePlate || "",
            catalogueId: props.catalogueId || "",
            validityStart: props.defaultValues?.validityStart || (0, $51c4c2d07d14dea7$exports.DateTime).local(),
            validityEnd: props.defaultValues?.validityEnd || null,
            costCenter: props.defaultValues?.costCenter || "",
            project: props.defaultValues?.project || ""
        };
    };
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $1T1QG.useState)(false);
    const [defaultValues, setDefaultValues] = (0, $1T1QG.useState)(getFormDefaultValues());
    (0, $1T1QG.useEffect)(()=>{
        setDefaultValues(getFormDefaultValues());
    }, [
        props.defaultValues?.firstName,
        props.defaultValues?.lastName,
        props.defaultValues?.email,
        props.defaultValues?.phoneNumber,
        props.defaultValues?.licensePlate,
        props.offering?.id
    ]);
    const schemaValidator = ()=>{
        return $d7c41ae3ced691f5$export$be5493f9613cbbe().shape({
            firstName: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            lastName: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            email: $d7c41ae3ced691f5$export$22b082955e083ec3().test("email", intl.formatMessage({
                id: "common.form.errors.email"
            }), function(email) {
                return (0, $5ed07630ed21dadb$export$371e338370561054)(email);
            }),
            phoneNumber: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().test("phoneNumber", intl.formatMessage({
                id: "common.form.errors.phoneNumber"
            }), (0, $5ed07630ed21dadb$export$dda1dcb0216445cd)),
            licensePlate: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().test("licensePlate", intl.formatMessage({
                id: "common.form.errors.licensePlate"
            }), (0, $5ed07630ed21dadb$export$dddb845077defee2)),
            validityStart: $d7c41ae3ced691f5$export$324d90190a8b822a().required(intl.formatMessage({
                id: "common.form.errors.invalidDateTime"
            })).typeError(intl.formatMessage({
                id: "common.form.errors.invalidDateTime"
            })),
            validityEnd: $d7c41ae3ced691f5$export$324d90190a8b822a().nullable().typeError(intl.formatMessage({
                id: "common.form.errors.invalidDateTime"
            })),
            costCenter: $d7c41ae3ced691f5$export$22b082955e083ec3().max(255),
            project: $d7c41ae3ced691f5$export$22b082955e083ec3().max(255)
        });
    };
    const onSubmitFormValues = (values)=>{
        const { firstName: firstName, lastName: lastName, email: email, phoneNumber: phoneNumber, licensePlate: licensePlate, catalogueId: catalogueId, validityStart: validityStart, validityEnd: validityEnd, costCenter: costCenter, project: project } = values;
        props.onSubmit({
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            email: email.trim(),
            phoneNumber: phoneNumber.trim(),
            licensePlate: licensePlate.trim().toLocaleUpperCase(),
            catalogueId: catalogueId,
            validityStart: validityStart,
            validityEnd: validityEnd,
            costCenter: costCenter?.trim() || undefined,
            project: project?.trim() || undefined
        });
    };
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const isMobile = (0, $ffad103d3c7e3bc8$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $eUHG3.Formik), {
            validate: ()=>setFormikValidateOnChange(true),
            validationSchema: schemaValidator(),
            enableReinitialize: true,
            initialValues: defaultValues,
            validateOnChange: formikValidateOnChange,
            onSubmit: (values)=>{
                onSubmitFormValues(values);
            },
            children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit, setFieldValue: setFieldValue })=>/*#__PURE__*/ (0, $3Py8h.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: props.formReference,
                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.customerDetails"
                                })
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                        name: "firstName",
                                        "data-testid": "firstName",
                                        value: values.firstName,
                                        label: intl.formatMessage({
                                            id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.firstName"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.firstName"
                                        }),
                                        onChange: handleChange,
                                        disabled: props.disableCustomerData,
                                        autoFocus: !props.disableCustomerData,
                                        error: !!errors.firstName,
                                        errorText: errors.firstName
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                        name: "lastName",
                                        "data-testid": "lastName",
                                        value: values.lastName,
                                        label: intl.formatMessage({
                                            id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.lastName"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.lastName"
                                        }),
                                        onChange: handleChange,
                                        disabled: props.disableCustomerData,
                                        error: !!errors.lastName,
                                        errorText: errors.lastName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                        name: "email",
                                        "data-testid": "email",
                                        value: values.email,
                                        label: intl.formatMessage({
                                            id: "common.text.email"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "common.text.email"
                                        }),
                                        onChange: handleChange,
                                        disabled: props.disableCustomerData,
                                        error: !!errors.email,
                                        errorText: errors.email
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                        name: "phoneNumber",
                                        "data-testid": "phoneNumber",
                                        value: values.phoneNumber,
                                        label: intl.formatMessage({
                                            id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.phoneNumber"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.phoneNumber"
                                        }),
                                        onChange: handleChange,
                                        disabled: props.disableCustomerData,
                                        error: !!errors.phoneNumber,
                                        errorText: errors.phoneNumber
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.productDetails"
                                })
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormSwitch, {
                                checked: true,
                                label: offeringName,
                                style: {
                                    fontWeight: "bold"
                                },
                                disabled: true
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                        name: "costCenter",
                                        "data-testid": "costCenter",
                                        value: values.costCenter,
                                        label: intl.formatMessage({
                                            id: "common.text.costCenter"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "common.text.costCenter"
                                        }),
                                        onChange: handleChange,
                                        autoFocus: props.disableCustomerData,
                                        error: !!errors.costCenter,
                                        errorText: errors.costCenter
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                        name: "project",
                                        "data-testid": "project",
                                        value: values.project,
                                        label: intl.formatMessage({
                                            id: "common.text.project"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "common.text.project"
                                        }),
                                        onChange: handleChange,
                                        error: !!errors.project,
                                        errorText: errors.project
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.licensePlateDetails"
                                })
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                                display: "flex",
                                gap: 2,
                                flex: 2,
                                pr: 1,
                                width: isMobile ? "100%" : "50%",
                                flexDirection: {
                                    xs: "column",
                                    md: "row"
                                },
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                    name: "licensePlate",
                                    "data-testid": "licensePlate",
                                    value: values.licensePlate,
                                    label: intl.formatMessage({
                                        id: "common.text.licensePlate"
                                    }),
                                    placeholder: intl.formatMessage({
                                        id: "common.text.licensePlate"
                                    }),
                                    onChange: handleChange,
                                    error: !!errors.licensePlate,
                                    errorText: errors.licensePlate
                                })
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.catalogues.tabCatalogue.formIndividualRightHolder.label.validity"
                                })
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ad585888a85c972f$export$ccdfd7928785632e), {
                                        name: "validityStart",
                                        "data-testid": "validityStart",
                                        value: values.validityStart,
                                        disablePast: true,
                                        onChange: (newValue)=>setFieldValue("validityStart", newValue),
                                        label: intl.formatMessage({
                                            id: "common.text.validityStart"
                                        }),
                                        slotProps: {
                                            textField: {
                                                helperText: errors.validityStart ? "" + errors?.validityStart : null,
                                                error: !!errors.validityStart
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ad585888a85c972f$export$ccdfd7928785632e), {
                                        name: "validityEnd",
                                        "data-testid": "validityEnd",
                                        value: values.validityEnd,
                                        onChange: (newValue)=>setFieldValue("validityEnd", newValue),
                                        label: intl.formatMessage({
                                            id: "common.text.validityEnd"
                                        }),
                                        slotProps: {
                                            textField: {
                                                helperText: errors.validityEnd ? "" + errors?.validityEnd : null,
                                                error: !!errors.validityEnd
                                            }
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
        })
    });
};
var $cec09b38543d677a$export$2e2bcd8739ae039 = $cec09b38543d677a$var$FormIndividualRightHolder;




const $c6c59046ac8c1505$var$StepAddRightHolder = (props)=>{
    const createRightHolder = (values)=>{
        const { firstName: firstName, lastName: lastName, email: email, phoneNumber: phoneNumber, licensePlate: licensePlate, validityStart: validityStart, validityEnd: validityEnd, catalogueId: catalogueId, project: project, costCenter: costCenter } = values;
        if (props.individualRightHolderId) {
            const dto = {
                licensePlate: licensePlate,
                catalogueId: catalogueId,
                validityStart: (0, $8cd8f065b47158d9$export$6ef9dbcccbc4ed7d).toUTC(validityStart),
                validityEnd: validityEnd ? (0, $8cd8f065b47158d9$export$6ef9dbcccbc4ed7d).toUTC(validityEnd) : undefined,
                active: true,
                costCenter: costCenter,
                project: project
            };
            props.onSubmit(dto);
        } else {
            const dto = {
                type: "individual",
                customerId: props.customerId,
                firstName: firstName,
                lastName: lastName,
                email: email,
                phoneNumber: (0, $fb47a354e391b3c4$export$b34d9e7bbdff763e)(phoneNumber),
                catalogueId: catalogueId,
                vehicles: [
                    {
                        licensePlate: licensePlate,
                        grantRights: [
                            {
                                rightHolderType: "vehicle",
                                validityStart: (0, $8cd8f065b47158d9$export$6ef9dbcccbc4ed7d).toUTC(validityStart),
                                validityEnd: validityEnd ? (0, $8cd8f065b47158d9$export$6ef9dbcccbc4ed7d).toUTC(validityEnd) : undefined,
                                active: true,
                                costCenter: costCenter,
                                project: project
                            }
                        ]
                    }
                ]
            };
            props.onSubmit(dto);
        }
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $cec09b38543d677a$export$2e2bcd8739ae039), {
        formReference: props.formReference,
        disableCustomerData: !!props.individualRightHolderId,
        offering: props.offering,
        catalogueId: props.catalogueId || "",
        onSubmit: createRightHolder,
        defaultValues: props.defaultValues
    });
};
var $c6c59046ac8c1505$export$2e2bcd8739ae039 = $c6c59046ac8c1505$var$StepAddRightHolder;



var $3Py8h = parcelRequire("3Py8h");




var $eUHG3 = parcelRequire("eUHG3");


var $1T1QG = parcelRequire("1T1QG");

const $6b84652766e657c5$var$StepFindRightHolder = (props)=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const schemaValidator = ()=>{
        return $d7c41ae3ced691f5$export$be5493f9613cbbe().shape({
            email: $d7c41ae3ced691f5$export$22b082955e083ec3().test("email", intl.formatMessage({
                id: "common.form.errors.email"
            }), function(email) {
                return (0, $5ed07630ed21dadb$export$371e338370561054)(email);
            })
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $eUHG3.Formik), {
        validationSchema: schemaValidator(),
        initialValues: {
            email: props.email
        },
        onSubmit: (values)=>{
            props.onSubmit(values);
        },
        enableReinitialize: true,
        children: ({ values: values, errors: errors, handleChange: handleChange, setFieldValue: setFieldValue, handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $3Py8h.jsx)("form", {
                onSubmit: handleSubmit,
                id: props.formReference,
                children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormContainer, {
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                id: "page.catalogues.tabCatalogue.modalFindRightHolder.info"
                            })
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormAutoCompleteTextField, {
                            options: props.selectableOptions,
                            value: values.email,
                            freeSolo: true,
                            onChange: (event, value)=>setFieldValue("email", value ?? ""),
                            renderInput: (params)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                    ...params,
                                    name: "email",
                                    "data-testid": "email",
                                    value: values.email,
                                    label: intl.formatMessage({
                                        id: "page.catalogues.tabCatalogue.modalFindRightHolder.form.label.email"
                                    }),
                                    placeholder: intl.formatMessage({
                                        id: "page.catalogues.tabCatalogue.modalFindRightHolder.form.label.email"
                                    }),
                                    onChange: handleChange,
                                    error: !!errors.email,
                                    errorText: errors.email,
                                    autoFocus: true,
                                    InputProps: {
                                        ...params.InputProps,
                                        endAdornment: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, {
                                            children: [
                                                props.isFetching ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b658ddb442599731$export$2e2bcd8739ae039), {
                                                    color: "inherit",
                                                    size: 20
                                                }) : null,
                                                params.InputProps.endAdornment
                                            ]
                                        })
                                    }
                                })
                        })
                    ]
                })
            })
    });
};
var $6b84652766e657c5$export$2e2bcd8739ae039 = $6b84652766e657c5$var$StepFindRightHolder;




const $8141644d02ba70da$var$ModalAddRightHolder = (props)=>{
    const [activeStep, setActiveStep] = (0, $1T1QG.useState)("STEP_FIND");
    const [completedSteps, setCompletedSteps] = (0, $1T1QG.useState)([]);
    const [filledEmail, setFilledEmail] = (0, $1T1QG.useState)("");
    const [givenEmail, setGivenEmail] = (0, $1T1QG.useState)("");
    const [emailOptions, setEmailOptions] = (0, $1T1QG.useState)([]);
    const [foundIndividual, setFoundIndividual] = (0, $1T1QG.useState)(null);
    const FORM_REFERENCE_FIND = "formModalIndividualsFind";
    const FORM_REFERENCE_FILL = "formModalIndividualsFill";
    const queryIndividualsByEmail = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$9f074a658d5580d),
            givenEmail
        ],
        queryFn: ()=>(0, $bfd03858b5cf8c88$export$2e2bcd8739ae039).getIndividualsByEmail(givenEmail || ""),
        retry: false,
        enabled: !!givenEmail
    });
    const goToFillStep = ()=>{
        if (!completedSteps.includes("STEP_FIND")) setCompletedSteps([
            ...completedSteps,
            "STEP_FIND"
        ]);
        setActiveStep("STEP_FILL");
        setFilledEmail(givenEmail);
    };
    const goToFindStep = ()=>{
        setCompletedSteps([]);
        setActiveStep("STEP_FIND");
    };
    (0, $1T1QG.useEffect)(()=>{
        if (!queryIndividualsByEmail.data || !queryIndividualsByEmail.isFetched) return;
        if (queryIndividualsByEmail.data.length <= 0) {
            setFoundIndividual(null);
            setEmailOptions([]);
            goToFillStep();
        } else if (queryIndividualsByEmail.data.length === 1) {
            setFoundIndividual(queryIndividualsByEmail.data[0]);
            setEmailOptions(queryIndividualsByEmail.data.map((item)=>item.email));
            goToFillStep();
        } else {
            setFoundIndividual(queryIndividualsByEmail.data[0]);
            setEmailOptions(queryIndividualsByEmail.data.map((item)=>item.email));
        }
    }, [
        queryIndividualsByEmail.fetchStatus
    ]);
    const createRightHolderMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $bfd03858b5cf8c88$export$2e2bcd8739ae039).createIndividual(dto),
        onSuccess: (response)=>{
            const rightHolder = response.data || {};
            let name = "";
            const dataIndividual = rightHolder;
            name = (0, $9efc3d7accb9d2fe$export$e49861a9373f5f25)(dataIndividual);
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.catalogues.tabCatalogue.modalFindRightHolder.actions.added",
                values: {
                    name: name
                }
            }));
            props.onSubmit(rightHolder);
        }
    });
    const grantRightMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $bfd03858b5cf8c88$export$2e2bcd8739ae039).grantRightToIndividual(foundIndividual?.id || "", dto),
        onSuccess: (response)=>{
            const rightHolder = response.data || {};
            let name = "";
            name = rightHolder.vehicle?.licensePlate || "";
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.catalogues.tabCatalogue.modalFindRightHolder.actions.added",
                values: {
                    name: name
                }
            }));
            props.onSubmit(rightHolder);
        }
    });
    const findEmail = (email)=>{
        if (email && email === givenEmail) goToFillStep();
        else setGivenEmail(email);
    };
    const cancel = ()=>{
        createRightHolderMutation.reset();
        props.onCancel();
    };
    const steps = [
        {
            label: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.catalogues.modalAddRightHolder.steps.bar.email"
            }),
            step: "STEP_FIND",
            icon: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1d497a506d9a8a6b$exports))), {
                fontSize: "large"
            })
        },
        {
            label: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.catalogues.modalAddRightHolder.steps.bar.rightHolder"
            }),
            step: "STEP_FILL",
            icon: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e82629ceb64f6e49$exports))), {
                fontSize: "large"
            })
        }
    ];
    const StepContent = ({ step: step })=>{
        switch(step){
            case "STEP_FIND":
                return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $6b84652766e657c5$export$2e2bcd8739ae039), {
                    isFetching: queryIndividualsByEmail.isFetching,
                    email: filledEmail ?? "",
                    selectableOptions: emailOptions,
                    formReference: FORM_REFERENCE_FIND,
                    onSubmit: ({ email: email })=>findEmail(email)
                });
            case "STEP_FILL":
                return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c6c59046ac8c1505$export$2e2bcd8739ae039), {
                    formReference: FORM_REFERENCE_FILL,
                    customerId: props.customerId,
                    offering: props.offering,
                    catalogueId: props.catalogueId || "",
                    individualRightHolderId: foundIndividual?.id,
                    defaultValues: {
                        firstName: foundIndividual?.firstName ?? "",
                        lastName: foundIndividual?.lastName ?? "",
                        email: foundIndividual?.email ?? filledEmail ?? "",
                        phoneNumber: foundIndividual?.phoneNumber ?? "",
                        licensePlate: foundIndividual?.vehicles[0]?.licensePlate ?? "",
                        catalogueId: props.catalogueId || "",
                        validityStart: (0, $51c4c2d07d14dea7$exports.DateTime).local(),
                        costCenter: "",
                        project: ""
                    },
                    onSubmit: (dto)=>foundIndividual ? grantRightMutation.mutate(dto) : createRightHolderMutation.mutate(dto)
                });
            default:
                (0, $fb47a354e391b3c4$export$16bf6fe03653420f)(step);
        }
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $259d9dbb3544503a$export$2e2bcd8739ae039), {
            open: props.open,
            onCancel: cancel,
            formReference: activeStep === "STEP_FIND" ? FORM_REFERENCE_FIND : FORM_REFERENCE_FILL,
            mutation: createRightHolderMutation,
            errorTitleKey: "common.actions.add.error",
            modalTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.catalogues.modalAddRightHolder.title"
            }),
            submitButtonContent: activeStep === "STEP_FIND" ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "common.buttons.next"
            }) : /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "common.buttons.save"
            }),
            leftSideButtons: completedSteps.includes("STEP_FIND") ? [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                    onClick: goToFindStep,
                    variant: "text",
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                        id: "common.buttons.back"
                    })
                }, "back")
            ] : undefined,
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                    style: {
                        marginBottom: queryIndividualsByEmail?.error ? "1rem" : undefined
                    },
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $019112675a75b38b$export$2e2bcd8739ae039), {
                        query: queryIndividualsByEmail,
                        errorTitleKey: "common.actions.get.error"
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                    sx: {
                        mt: "0px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a37c1bd20156d042$export$2e2bcd8739ae039), {
                            alternativeLabel: true,
                            sx: {
                                width: "100%",
                                padding: "0"
                            },
                            children: steps.map((item)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $f6f1b9657beabe18$export$2e2bcd8739ae039), {
                                    active: activeStep === item.step,
                                    completed: completedSteps.includes(item.step),
                                    disabled: completedSteps.includes(item.step),
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $6f2a56b8d3467b7b$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            children: /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)("h3", {
                                                    style: {
                                                        margin: "5px"
                                                    },
                                                    children: item.label
                                                })
                                            })
                                        })
                                    })
                                }, item.step.toString()))
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                            style: {
                                padding: "5px"
                            },
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)(StepContent, {
                                step: completedSteps.includes("STEP_FIND") ? "STEP_FILL" : "STEP_FIND"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $8141644d02ba70da$export$2e2bcd8739ae039 = $8141644d02ba70da$var$ModalAddRightHolder;



var $3Py8h = parcelRequire("3Py8h");

var $3Py8h = parcelRequire("3Py8h");



var $1T1QG = parcelRequire("1T1QG");


var $eUHG3 = parcelRequire("eUHG3");



const $7b6afd0633ec1dda$var$initialValues = {
    licensePlate: "",
    costCenter: "",
    project: "",
    validityStart: (0, $51c4c2d07d14dea7$exports.DateTime).local(),
    validityEnd: null
};
const $7b6afd0633ec1dda$var$FormIndividualRightHolder = (props)=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $1T1QG.useState)(false);
    const validationSchema = $d7c41ae3ced691f5$export$be5493f9613cbbe().shape({
        licensePlate: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().test("licensePlate", intl.formatMessage({
            id: "common.form.errors.licensePlate"
        }), function(licensePlate) {
            return (0, $5ed07630ed21dadb$export$dddb845077defee2)(licensePlate);
        }),
        validityStart: $d7c41ae3ced691f5$export$324d90190a8b822a().required(intl.formatMessage({
            id: "common.form.errors.invalidDateTime"
        })).typeError(intl.formatMessage({
            id: "common.form.errors.invalidDateTime"
        })),
        validityEnd: $d7c41ae3ced691f5$export$324d90190a8b822a().nullable().typeError(intl.formatMessage({
            id: "common.form.errors.invalidDateTime"
        })),
        costCenter: $d7c41ae3ced691f5$export$22b082955e083ec3(),
        project: $d7c41ae3ced691f5$export$22b082955e083ec3()
    });
    const onSubmitFormValues = (values)=>{
        const { validityStart: validityStart, validityEnd: validityEnd, costCenter: costCenter, project: project } = values;
        props.onSubmit({
            licensePlate: values.licensePlate.trim().toLocaleUpperCase(),
            validityStart: validityStart,
            validityEnd: validityEnd,
            costCenter: costCenter,
            project: project
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $eUHG3.Formik), {
        validate: ()=>setFormikValidateOnChange(true),
        validationSchema: validationSchema,
        enableReinitialize: true,
        initialValues: $7b6afd0633ec1dda$var$initialValues,
        validateOnChange: formikValidateOnChange,
        onSubmit: (values)=>{
            onSubmitFormValues(values);
        },
        children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit, setFieldValue: setFieldValue })=>/*#__PURE__*/ (0, $3Py8h.jsx)("form", {
                onSubmit: handleSubmit,
                id: props.formReference,
                children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormContainer, {
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTitle, {
                            title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                id: "page.catalogues.tabCatalogue.formVehicleRightHolder.label.vehicleDetails"
                            })
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                            fullWidth: true,
                            name: "licensePlate",
                            "data-testid": "licensePlate",
                            value: values.licensePlate,
                            label: intl.formatMessage({
                                id: "common.text.licensePlate"
                            }),
                            placeholder: intl.formatMessage({
                                id: "common.text.licensePlate"
                            }),
                            onChange: handleChange,
                            autoFocus: true,
                            error: !!errors.licensePlate,
                            errorText: errors.licensePlate
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTitle, {
                            title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                id: "page.catalogues.tabCatalogue.formVehicleRightHolder.label.validity"
                            })
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ad585888a85c972f$export$ccdfd7928785632e), {
                                    name: "validityStart",
                                    "data-testid": "validityStart",
                                    value: values.validityStart,
                                    disablePast: true,
                                    onChange: (newValue)=>setFieldValue("validityStart", newValue),
                                    label: intl.formatMessage({
                                        id: "common.text.validityStart"
                                    }),
                                    slotProps: {
                                        textField: {
                                            helperText: errors.validityStart ? "" + errors?.validityStart : null,
                                            error: !!errors.validityStart
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ad585888a85c972f$export$ccdfd7928785632e), {
                                    name: "validityEnd",
                                    "data-testid": "validityEnd",
                                    value: values.validityEnd,
                                    onChange: (newValue)=>setFieldValue("validityEnd", newValue),
                                    label: intl.formatMessage({
                                        id: "common.text.validityEnd"
                                    }),
                                    minDateTime: values.validityStart,
                                    slotProps: {
                                        textField: {
                                            helperText: errors.validityEnd ? "" + errors?.validityEnd : null,
                                            error: !!errors.validityEnd
                                        }
                                    }
                                })
                            ]
                        }),
                        props.showAccountingFields && /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                    name: "costCenter",
                                    "data-testid": "costCenter",
                                    value: values.costCenter,
                                    onChange: handleChange,
                                    label: intl.formatMessage({
                                        id: "common.text.costCenter"
                                    }),
                                    error: !!errors.costCenter,
                                    errorText: errors.costCenter
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                    name: "project",
                                    "data-testid": "project",
                                    value: values.project,
                                    onChange: handleChange,
                                    label: intl.formatMessage({
                                        id: "common.text.project"
                                    }),
                                    error: !!errors.project,
                                    errorText: errors.project
                                })
                            ]
                        })
                    ]
                })
            })
    });
};
var $7b6afd0633ec1dda$export$2e2bcd8739ae039 = $7b6afd0633ec1dda$var$FormIndividualRightHolder;








const $1e7ee73f0c10520a$var$ModalAddRightHolder = (props)=>{
    const FORM_VEHICLE_RIGHT_HOLDER = "formModalVehicleRightHolder";
    const createRightHolderMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $bfd03858b5cf8c88$export$2e2bcd8739ae039).grantRightToVehicle(dto),
        onSuccess: (response)=>{
            const right = response.data || {};
            let name = right.vehicle?.licensePlate || "";
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.catalogues.tabCatalogue.modalFindRightHolder.actions.added",
                values: {
                    name: name
                }
            }));
            props.onSubmit(right);
        }
    });
    const cancel = ()=>{
        createRightHolderMutation.reset();
        props.onCancel();
    };
    const createVehicleRightHolder = (values)=>{
        const { licensePlate: licensePlate, validityStart: validityStart, validityEnd: validityEnd, costCenter: costCenter, project: project } = values;
        const dto = {
            licensePlate: licensePlate,
            right: {
                rightHolderType: "vehicle",
                catalogueId: props.catalogueId,
                validityStart: (0, $8cd8f065b47158d9$export$6ef9dbcccbc4ed7d).toUTC(validityStart),
                validityEnd: validityEnd ? (0, $8cd8f065b47158d9$export$6ef9dbcccbc4ed7d).toUTC(validityEnd) : undefined,
                active: true,
                costCenter: costCenter?.trim() || undefined,
                project: project?.trim() || undefined
            }
        };
        createRightHolderMutation.mutate(dto);
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $259d9dbb3544503a$export$2e2bcd8739ae039), {
        open: props.open,
        onCancel: cancel,
        formReference: FORM_VEHICLE_RIGHT_HOLDER,
        mutation: createRightHolderMutation,
        errorTitleKey: "common.actions.add.error",
        modalTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
            id: "page.catalogues.modalAddVehicleRightHolder.title"
        }),
        submitButtonContent: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
            id: "common.buttons.save"
        }),
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $7b6afd0633ec1dda$export$2e2bcd8739ae039), {
            formReference: FORM_VEHICLE_RIGHT_HOLDER,
            onSubmit: createVehicleRightHolder,
            showAccountingFields: props.showAccountingFields
        })
    });
};
var $1e7ee73f0c10520a$export$2e2bcd8739ae039 = $1e7ee73f0c10520a$var$ModalAddRightHolder;





const $e6e9424a9a91cf2c$var$RightHolders = ({ queryActiveRights: queryActiveRights, place: place, customerId: customerId, catalogue: catalogue, offering: offering, showModalAddRightHolder: showModalAddRightHolder, showModalAddVehicle: showModalAddVehicle, pagination: pagination, onSubmitAdd: onSubmitAdd, onSubmitEdit: onSubmitEdit, onTerminate: onTerminate, onCancel: onCancel })=>{
    const navigate = (0, $e0cff2801449e77d$export$9770f232ac06a008)();
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const [showModalEditVehicle, setShowModalEditVehicle] = (0, $1T1QG.useState)(undefined);
    const activeRights = queryActiveRights.data?.data || [];
    const onClickRow = (row)=>{
        if (row.individual?.id) navigate(`${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).RIGHT_HOLDERS}/${row.individual?.id || ""}`, {
            state: {
                placeId: place.id,
                placeName: place.name,
                catalogueId: catalogue?.id,
                offeringName: catalogue?.offering?.name
            }
        });
        else navigate(`${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).RIGHTS}/${row.id || ""}`);
    };
    const isWhitelist = offering?.type === "WHITELIST";
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8002a2b5b87a23eb$export$2e2bcd8739ae039), {
                emptyTextId: "page.catalogues.tabCatalogue.rightHolders.table.action.empty",
                errorTextId: "page.catalogues.tabCatalogue.rightHolders.table.action.failed",
                query: queryActiveRights,
                pagination: pagination,
                children: activeRights.map((row)=>{
                    const normalContentList = [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "common.text.email"
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)("b", {
                            children: row.individual?.email || ""
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "common.text.licensePlate"
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)("b", {
                            children: row.vehicle?.licensePlate || ""
                        })
                    ];
                    const commonContentList = [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "page.catalogues.tabCatalogue.rightHolders.card.header.place"
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)("b", {
                            children: row.place.name
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "page.catalogues.tabCatalogue.rightHolders.card.header.validUntil"
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)("b", {
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                                utcDateTime: row.validityEnd,
                                emptyText: intl.formatMessage({
                                    id: "page.rightHolders.rightHolder.tab.vehicles.table.item.permanent"
                                })
                            })
                        })
                    ];
                    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0829f6a75e4b5e7$export$2e2bcd8739ae039), {
                        cardTitle: isWhitelist ? row.vehicle?.licensePlate || "" : (0, $fb47a354e391b3c4$export$ff20516246215bf)(row.individual?.lastName, row.individual?.firstName),
                        cardSecondaryTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                            utcDateTime: row.validityStart
                        }),
                        cardContentList: isWhitelist ? commonContentList : [
                            ...normalContentList,
                            ...commonContentList
                        ],
                        onCardClicked: ()=>onClickRow(row)
                    }, row.id);
                })
            }),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $c6e866c0d03fba92$export$2e2bcd8739ae039), {
                items: activeRights,
                emptyTextId: "page.catalogues.tabCatalogue.rightHolders.table.action.empty",
                errorTextId: "page.catalogues.tabCatalogue.rightHolders.table.action.failed",
                query: queryActiveRights,
                pagination: pagination,
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b52028b37ea87ec4$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                            children: [
                                !isWhitelist && /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                id: "page.catalogues.tabCatalogue.rightHolders.table.header.name"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                id: "common.text.email"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "common.text.licensePlate"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "page.catalogues.tabCatalogue.rightHolders.table.header.place"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "page.catalogues.tabCatalogue.rightHolders.table.header.validFrom"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "page.catalogues.tabCatalogue.rightHolders.table.header.validUntil"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a3b5a93a68cc46b9$export$2e2bcd8739ae039), {
                        "data-testid": "places-table-body",
                        children: activeRights.map((row)=>/*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                                onClick: ()=>onClickRow(row),
                                hover: true,
                                sx: {
                                    cursor: "pointer"
                                },
                                children: [
                                    !isWhitelist && /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $041febe0dbc86e0a$export$2e2bcd8739ae039), {
                                                    children: (0, $fb47a354e391b3c4$export$ff20516246215bf)(row.individual?.lastName, row.individual?.firstName)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                children: row.individual?.email || ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: row.individual ? row.vehicle?.licensePlate || "" : /*#__PURE__*/ (0, $3Py8h.jsx)((0, $041febe0dbc86e0a$export$2e2bcd8739ae039), {
                                            children: row.vehicle?.licensePlate || ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: row.place.name
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                                            utcDateTime: row.validityStart
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                                            utcDateTime: row.validityEnd,
                                            emptyText: intl.formatMessage({
                                                id: "page.rightHolders.rightHolder.tab.vehicles.table.item.permanent"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        align: "right",
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $041febe0dbc86e0a$export$2e2bcd8739ae039), {
                                            onClick: (evt)=>{
                                                evt.stopPropagation();
                                                setShowModalEditVehicle({
                                                    individualId: row.individual?.id,
                                                    rightId: row.id,
                                                    catalogueId: row.catalogueId,
                                                    licensePlate: row.vehicle?.licensePlate || "",
                                                    costCenter: row.costCenter,
                                                    project: row.project
                                                });
                                            },
                                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                id: "common.buttons.edit"
                                            })
                                        })
                                    })
                                ]
                            }, row.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8141644d02ba70da$export$2e2bcd8739ae039), {
                open: showModalAddRightHolder,
                customerId: customerId,
                catalogueId: catalogue?.id || "",
                offering: catalogue?.offering,
                onSubmit: ()=>{
                    onSubmitAdd(showModalEditVehicle?.individualId);
                },
                onCancel: ()=>onCancel()
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $362423ed72ac6e25$export$2e2bcd8739ae039), {
                open: !!showModalEditVehicle,
                rightId: showModalEditVehicle?.rightId || "",
                catalogueId: showModalEditVehicle?.catalogueId || "",
                licensePlate: showModalEditVehicle?.licensePlate || "",
                costCenter: showModalEditVehicle?.costCenter,
                project: showModalEditVehicle?.project,
                onTerminated: ()=>{
                    onTerminate(showModalEditVehicle?.individualId);
                    setShowModalEditVehicle(undefined);
                },
                onSubmit: ()=>{
                    onSubmitEdit(showModalEditVehicle?.individualId);
                    setShowModalEditVehicle(undefined);
                },
                onCancel: ()=>setShowModalEditVehicle(undefined),
                showAccountingFields: !isWhitelist
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $1e7ee73f0c10520a$export$2e2bcd8739ae039), {
                open: showModalAddVehicle,
                customerId: customerId,
                catalogueId: catalogue?.id || "",
                onSubmit: ()=>{
                    onSubmitAdd(showModalEditVehicle?.individualId);
                },
                onCancel: ()=>onCancel(),
                showAccountingFields: !isWhitelist
            })
        ]
    });
};
var $e6e9424a9a91cf2c$export$2e2bcd8739ae039 = $e6e9424a9a91cf2c$var$RightHolders;





var $1T1QG = parcelRequire("1T1QG");

var $3Py8h = parcelRequire("3Py8h");


var $1T1QG = parcelRequire("1T1QG");


const $76b9dca122479b61$var$SearchRightHolders = ({ initialSearch: initialSearch = "", onSearch: onSearch, query: query })=>{
    const [search, setSearch] = (0, $1T1QG.useState)(initialSearch);
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const searchInvalid = search?.length === 1 || search?.length === 2;
    const searchHandler = (evt)=>{
        evt.preventDefault();
        if (!searchInvalid) onSearch(search);
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
        style: {
            marginBottom: "2rem"
        },
        children: /*#__PURE__*/ (0, $3Py8h.jsx)("form", {
            onSubmit: searchHandler,
            id: "search",
            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                container: true,
                direction: "row",
                children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                    item: true,
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                            name: "searchTerm",
                            "data-testid": "searchTerm",
                            value: search,
                            label: intl.formatMessage({
                                id: "page.catalogues.tabCatalogue.search.label"
                            }),
                            onChange: (evt)=>{
                                setSearch(evt.target.value);
                            },
                            size: "small",
                            error: searchInvalid,
                            errorText: searchInvalid ? intl.formatMessage({
                                id: "page.catalogues.tabCatalogue.search.invalid"
                            }) : "",
                            type: "search"
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                            style: {
                                marginLeft: "1rem"
                            },
                            query: query,
                            type: "submit",
                            disabled: searchInvalid,
                            children: "Hae"
                        })
                    ]
                })
            })
        })
    });
};
var $76b9dca122479b61$export$2e2bcd8739ae039 = $76b9dca122479b61$var$SearchRightHolders;


const $07a0846cd6caa7d8$var$TabCatalogue = ({ catalogue: catalogue })=>{
    const queryClient = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)();
    const { tenant: tenant } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const [showModalAddRightHolder, setShowModalAddRightHolder] = (0, $1T1QG.useState)(false);
    const [showModalAddVehicle, setShowModalAddVehicle] = (0, $1T1QG.useState)(false);
    const place = catalogue?.place;
    const customerId = catalogue?.customer?.id;
    const catalogueId = catalogue?.id;
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const [pagingAndSortValues, setPagingAndSortValues] = (0, $adb860d4c4948aea$export$2e2bcd8739ae039)({
        key: (0, $5f8ca62b06e02682$export$60dd4bbd6d459f57),
        initialValue: (0, $55d02d7b1a5c4f16$export$4bec99d256114e49)("VEHICLE")
    });
    const [searchTerm, setSearchTerm] = (0, $adb860d4c4948aea$export$2e2bcd8739ae039)({
        key: "moovyCatalogueRightsSearch",
        initialValue: {
            value: ""
        }
    });
    const queryOffering = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$79b5a04d4c49a4e2),
            catalogue?.offering.id
        ],
        queryFn: ()=>(0, $6b405f573a8ac986$export$ca807e2054383e2d).getOfferingById(catalogue?.offering.id || ""),
        enabled: !!catalogue?.offering.id && !tenant,
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const offering = queryOffering.data;
    const queryActiveRights = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$e94a35ab41f6d829),
            catalogueId,
            pagingAndSortValues.page,
            pagingAndSortValues.sort,
            searchTerm.value
        ],
        queryFn: ()=>{
            const { page: page, limit: limit, sort: sort, direction: direction } = (0, $55d02d7b1a5c4f16$export$f381863f4c1c052a)(pagingAndSortValues);
            return (0, $7499271e3a060909$export$25753268427e50ea).getActiveRightsById(catalogueId || "", {
                page: page,
                limit: limit,
                sort: sort,
                direction: direction,
                searchTerm: searchTerm.value
            });
        },
        enabled: !!catalogueId
    });
    const pagination = queryActiveRights.data?.pageable ? {
        page: queryActiveRights.data.pageable.page,
        total: queryActiveRights.data.pageable.total,
        limit: queryActiveRights.data.pageable.limit,
        onNextPage: (page)=>setPagingAndSortValues({
                ...pagingAndSortValues,
                page: page.toString()
            })
    } : undefined;
    const refreshView = (individualId)=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $ec0c9d75a0d3a81a$export$93e1682d8eaccc31),
                catalogueId
            ]
        });
        if (offering?.id) {
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $ec0c9d75a0d3a81a$export$7cf5b9f73b9b2f2d),
                    offering.id
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $ec0c9d75a0d3a81a$export$79b5a04d4c49a4e2),
                    offering.id
                ]
            });
        }
        queryClient.invalidateQueries({
            queryKey: [
                (0, $ec0c9d75a0d3a81a$export$70a73d059c6beff0),
                place?.id
            ]
        });
        individualId && queryClient.invalidateQueries({
            queryKey: [
                (0, $ec0c9d75a0d3a81a$export$475c1d76a7297be4),
                individualId
            ]
        });
    };
    const isWhitelist = offering?.type === "WHITELIST";
    const isWebshopCatalogue = catalogue?.type === "WEBSHOP";
    const allowIndividualGrant = !isWebshopCatalogue && !isWhitelist;
    const allowVehicleGrant = !isWebshopCatalogue && catalogue?.allowVehicleGrant;
    const items = (0, $1a49c6a526fe14f2$export$88b06990067e1fdb)(intl, "ACTIVE_RIGHTS").filter((item)=>!isWhitelist || item.key !== "INDIVIDUAL");
    const onSubmitAdd = (individualId)=>{
        setShowModalAddRightHolder(false);
        setShowModalAddVehicle(false);
        refreshView(individualId);
    };
    const onSubmitEdit = (individualId)=>{
        refreshView(individualId);
    };
    const onTerminate = (individualId)=>{
        const newPage = (0, $55d02d7b1a5c4f16$export$e8b67cc4f4c44ec6)(pagination);
        if (newPage) setPagingAndSortValues({
            ...pagingAndSortValues,
            page: newPage
        });
        refreshView(individualId);
    };
    const onCancel = ()=>{
        setShowModalAddVehicle(false);
        setShowModalAddRightHolder(false);
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {
                    title: catalogue?.offering?.name,
                    props: {
                        paddingTop: 4
                    }
                }),
                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            direction: "row",
                            children: [
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                                    item: true,
                                    md: 6,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $7d0fb16f631a2a72$export$2e2bcd8739ae039), {
                                        catalogue: catalogue,
                                        whitelistOffering: isWhitelist
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                                    item: true,
                                    md: 6,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c308d832ed326a5d$export$2e2bcd8739ae039), {
                                        place: place
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {
                            props: {
                                pl: 0,
                                pr: 0
                            },
                            title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                id: "page.catalogues.tabCatalogue.title.rightHolder"
                            }),
                            titleProps: {
                                pb: 2
                            },
                            description: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $76b9dca122479b61$export$2e2bcd8739ae039), {
                                        initialSearch: searchTerm.value,
                                        onSearch: (newSearchTerm)=>{
                                            setSearchTerm({
                                                value: newSearchTerm
                                            });
                                            setPagingAndSortValues({
                                                ...pagingAndSortValues,
                                                page: 1
                                            });
                                        },
                                        query: queryActiveRights
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $2e40821b62a7b9dd$export$2e2bcd8739ae039), {
                                        filterKey: (0, $5f8ca62b06e02682$export$70568e7be1b89dff),
                                        items: items,
                                        value: pagingAndSortValues.sort,
                                        onChange: (value)=>{
                                            pagingAndSortValues.sort !== value && setPagingAndSortValues({
                                                ...pagingAndSortValues,
                                                sort: value,
                                                direction: (0, $1a49c6a526fe14f2$export$fcce7887255d1c69)(value)
                                            });
                                        }
                                    })
                                ]
                            }),
                            button: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $15827f0d92c5ff99$export$2e2bcd8739ae039), {
                                action: "CREATE",
                                resource: "RIGHT_HOLDERS",
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                                    children: isWhitelist ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                                        onClick: ()=>setShowModalAddVehicle(true),
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                            id: "page.catalogues.tabCatalogue.button.addVehicle"
                                        })
                                    }) : /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                                        container: true,
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "flex-end",
                                        children: [
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                                                item: true,
                                                children: allowIndividualGrant && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                                                    onClick: ()=>setShowModalAddRightHolder(true),
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                        id: "page.catalogues.tabCatalogue.button.addIndividual"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                                                item: true,
                                                pt: 1,
                                                children: allowVehicleGrant && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                                                    style: {
                                                        marginLeft: "1rem"
                                                    },
                                                    onClick: ()=>setShowModalAddVehicle(true),
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                        id: "page.catalogues.tabCatalogue.button.addVehicle"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e6e9424a9a91cf2c$export$2e2bcd8739ae039), {
                            queryActiveRights: queryActiveRights,
                            pagination: pagination,
                            customerId: customerId || "",
                            catalogue: catalogue,
                            place: {
                                id: place?.id || "",
                                name: place?.name || ""
                            },
                            offering: offering,
                            showModalAddRightHolder: showModalAddRightHolder,
                            showModalAddVehicle: showModalAddVehicle,
                            onSubmitAdd: onSubmitAdd,
                            onSubmitEdit: onSubmitEdit,
                            onTerminate: onTerminate,
                            onCancel: onCancel
                        })
                    ]
                })
            ]
        })
    });
};
var $07a0846cd6caa7d8$export$2e2bcd8739ae039 = $07a0846cd6caa7d8$var$TabCatalogue;



var $3Py8h = parcelRequire("3Py8h");
parcelRequire("1T1QG");

const $b9a365c920cb0339$var$TabInvitations = ({ catalogue: catalogue })=>{
    // The component is only intended to be shown tenant invitations
    if (catalogue?.customer.type !== "TENANT") return "";
    const tenantId = catalogue?.customer.id || "";
    const landlordId = catalogue?.customer.parentId || "";
    const catalogueId = catalogue?.id || "";
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $429e38326d2bbab8$export$2e2bcd8739ae039), {
        tenantId: tenantId,
        landlordId: landlordId,
        catalogueId: catalogueId
    });
};
var $b9a365c920cb0339$export$2e2bcd8739ae039 = $b9a365c920cb0339$var$TabInvitations;





var $3Py8h = parcelRequire("3Py8h");






var $3Py8h = parcelRequire("3Py8h");





var $47eae02696c05497$exports = {};
"use strict";
"use client";

Object.defineProperty($47eae02696c05497$exports, "__esModule", {
    value: true
});
$47eae02696c05497$exports.default = void 0;

var $47eae02696c05497$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $47eae02696c05497$var$_default = $47eae02696c05497$exports.default = (0, $47eae02696c05497$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3M12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1m1 4h-2v-2h2z"
}), "WarningRounded");



const $ff5faaa43264e890$var$InvitationsOngoing = ({ customerId: customerId, onLinkClicked: onLinkClicked })=>{
    const queryInvitations = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$96f07f442214aab),
            customerId
        ],
        queryFn: ()=>(0, $9f8b36004207981d$export$2e2bcd8739ae039).getInvitationsByCustomerId(false, customerId),
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const invitationsCount = queryInvitations.data ? queryInvitations.data.length : 0;
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
            pt: 1,
            visibility: invitationsCount > 0 ? "visible" : "hidden",
            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $041febe0dbc86e0a$export$2e2bcd8739ae039), {
                onClick: onLinkClicked,
                children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                    display: "flex",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($47eae02696c05497$exports))), {}),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                            marginLeft: "5px",
                            paddingTop: "2px",
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                values: {
                                    count: invitationsCount
                                },
                                id: "page.customers.tabAdministrators.invitationsOngoing.link"
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $ff5faaa43264e890$export$2e2bcd8739ae039 = $ff5faaa43264e890$var$InvitationsOngoing;




var $3Py8h = parcelRequire("3Py8h");


const $4023adf0312fe9ab$var$ModalAdminInvitations = ({ open: open, queryAdminInvitations: queryAdminInvitations, landlordId: landlordId, onClose: onClose })=>/*#__PURE__*/ (0, $3Py8h.jsxs)((0, $259d9dbb3544503a$export$2e2bcd8739ae039), {
        maxWidth: "lg",
        hideCancelButton: true,
        open: open,
        onCancel: onClose,
        onSubmit: onClose,
        errorTitleKey: "common.actions.add.error",
        modalTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
            id: "page.customers.tabAdministrators.modalAdminInvitations.title"
        }),
        submitButtonContent: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
            id: "common.ok"
        }),
        contentPadding: 0,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c9560da3d4f68f59$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $04dfc7c14f9267b3$export$2e2bcd8739ae039), {
                queryInvitations: queryAdminInvitations,
                customerId: landlordId
            })
        ]
    });
var $4023adf0312fe9ab$export$2e2bcd8739ae039 = $4023adf0312fe9ab$var$ModalAdminInvitations;




var $3Py8h = parcelRequire("3Py8h");





const $b25d2135574050a3$var$TableAdministrators = ({ queryAdministrators: queryAdministrators, setShowModalRemove: setShowModalRemove })=>{
    const { isPermission: isPermission, decodedToken: decodedToken } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const administrators = queryAdministrators.data || [];
    // Check that logged in user can't delete his own administrator rights
    const isCurrentUserRow = (row)=>row.id === decodedToken?.sub;
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8002a2b5b87a23eb$export$2e2bcd8739ae039), {
                emptyTextId: "page.customers.tabAdministrators.tableAdministrators.action.empty",
                errorTextId: "page.customers.tabAdministrators.tableAdministrators.action.failed",
                query: queryAdministrators,
                children: administrators.map((row)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0829f6a75e4b5e7$export$2e2bcd8739ae039), {
                        cardTitle: (0, $fb47a354e391b3c4$export$ff20516246215bf)(row.lastName, row.firstName),
                        cardSecondaryTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                            utcDateTime: row.createdAt
                        }),
                        cardContentList: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                id: "common.text.email"
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)("b", {
                                children: row.email
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                id: "page.customers.tabAdministrators.tableAdministrators.header.registeredIn"
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)("b", {
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                                    utcDateTime: row.createdAt,
                                    emptyText: "-"
                                })
                            })
                        ],
                        cardMenuActions: isPermission("DELETE", "USERS") && !isCurrentUserRow(row) ? [
                            {
                                itemText: intl.formatMessage({
                                    id: "page.customers.tabAdministrators.tableAdministrators.button.remove"
                                }),
                                onClick: ()=>setShowModalRemove({
                                        name: (0, $fb47a354e391b3c4$export$ff20516246215bf)(row.lastName, row.firstName),
                                        id: row.id
                                    })
                            }
                        ] : undefined
                    }, row.id))
            }),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $c6e866c0d03fba92$export$2e2bcd8739ae039), {
                items: administrators,
                emptyTextId: "page.customers.tabAdministrators.tableAdministrators.action.empty",
                errorTextId: "page.customers.tabAdministrators.tableAdministrators.action.failed",
                query: queryAdministrators,
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b52028b37ea87ec4$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "page.customers.tabAdministrators.tableAdministrators.header.name"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "common.text.email"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "page.customers.tabAdministrators.tableAdministrators.header.registeredIn"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $15827f0d92c5ff99$export$2e2bcd8739ae039), {
                                    action: "DELETE",
                                    resource: "USERS",
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a3b5a93a68cc46b9$export$2e2bcd8739ae039), {
                        children: administrators.map((row)=>/*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: (0, $fb47a354e391b3c4$export$ff20516246215bf)(row.lastName, row.firstName)
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: row.email
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                                            utcDateTime: row.createdAt
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $15827f0d92c5ff99$export$2e2bcd8739ae039), {
                                        action: "DELETE",
                                        resource: "USERS",
                                        visibility: !!row.createdAt && !isCurrentUserRow(row),
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                            align: "right",
                                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $041febe0dbc86e0a$export$2e2bcd8739ae039), {
                                                red: true,
                                                bold: true,
                                                onClick: ()=>setShowModalRemove({
                                                        name: (0, $fb47a354e391b3c4$export$ff20516246215bf)(row.lastName, row.firstName),
                                                        id: row.id
                                                    }),
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                    id: "page.customers.tabAdministrators.tableAdministrators.button.remove"
                                                })
                                            })
                                        })
                                    })
                                ]
                            }, row.id))
                    })
                ]
            })
        ]
    });
};
var $b25d2135574050a3$export$2e2bcd8739ae039 = $b25d2135574050a3$var$TableAdministrators;



var $1T1QG = parcelRequire("1T1QG");

const $913f22ba744c73bf$var$TabAdministrators = ({ customerId: customerId, showInvitationCreate: showInvitationCreate = true })=>{
    const queryClient = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)();
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const [modalAdminInvitations, setModalAdminInvitations] = (0, $1T1QG.useState)(false);
    const [showModalAdd, setShowModalAdd] = (0, $1T1QG.useState)(false);
    const [selectedUserForDeletion, setSelectedUserForDeletion] = (0, $1T1QG.useState)(null);
    const showModalRemove = selectedUserForDeletion !== null;
    const queryAdmins = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$6d14da40fa4f1ffe),
            customerId
        ],
        queryFn: ()=>(0, $3af058eac12e21cb$export$2e2bcd8739ae039).getUsersByCustomer(customerId),
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const queryAdminInvitations = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$96f07f442214aab),
            customerId
        ],
        queryFn: ()=>(0, $9f8b36004207981d$export$2e2bcd8739ae039).getInvitationsByCustomerId(false, customerId),
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const removeAdminUserMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (userId)=>(0, $3af058eac12e21cb$export$2e2bcd8739ae039).removeUser(customerId, userId),
        onSuccess: (response)=>{
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.customers.tabAdministrators.modalRemove.actions.removed"
            }));
            setSelectedUserForDeletion(null);
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $ec0c9d75a0d3a81a$export$6d14da40fa4f1ffe),
                    customerId
                ]
            });
        }
    });
    const onRefreshView = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $ec0c9d75a0d3a81a$export$96f07f442214aab),
                customerId
            ]
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c9560da3d4f68f59$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {
                        description: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.customers.tabAdministrators.infoText"
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ff5faaa43264e890$export$2e2bcd8739ae039), {
                                    customerId: customerId,
                                    onLinkClicked: ()=>setModalAdminInvitations(true)
                                })
                            ]
                        }),
                        button: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $15827f0d92c5ff99$export$2e2bcd8739ae039), {
                            action: "CREATE",
                            resource: "ADMIN_INVITATIONS",
                            visibility: showInvitationCreate,
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                                onClick: ()=>setShowModalAdd(true),
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.customers.tabAdministrators.button.newAdminInvitation"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b25d2135574050a3$export$2e2bcd8739ae039), {
                            queryAdministrators: queryAdmins,
                            setShowModalRemove: (user)=>setSelectedUserForDeletion(user)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $0444d6d626e783e4$export$2e2bcd8739ae039), {
                addingInvitationParams: {
                    invitationType: "ADMIN",
                    landlordId: customerId
                },
                open: showModalAdd,
                onSubmit: (response)=>{
                    setShowModalAdd(false);
                    (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                        id: "page.customers.tabAdministrators.actions.added",
                        values: {
                            name: response.name
                        }
                    }));
                    onRefreshView();
                },
                onCancel: ()=>setShowModalAdd(false)
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4023adf0312fe9ab$export$2e2bcd8739ae039), {
                open: modalAdminInvitations,
                landlordId: customerId,
                queryAdminInvitations: queryAdminInvitations,
                onClose: ()=>setModalAdminInvitations(false)
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $7f916474711491ea$export$2e2bcd8739ae039), {
                open: showModalRemove,
                lang: {
                    confirmButton: "common.buttons.yes",
                    error: "common.actions.remove.error"
                },
                header: intl.formatMessage({
                    id: "page.customers.tabAdministrators.modalRemove.header"
                }),
                content: intl.formatMessage({
                    id: "page.customers.tabAdministrators.modalRemove.content"
                }, {
                    name: selectedUserForDeletion?.name
                }),
                onCancel: ()=>setSelectedUserForDeletion(null),
                onConfirm: ()=>removeAdminUserMutation.mutate(selectedUserForDeletion?.id || ""),
                mutation: removeAdminUserMutation
            })
        ]
    });
};
var $913f22ba744c73bf$export$2e2bcd8739ae039 = $913f22ba744c73bf$var$TabAdministrators;


const $01190f929da15e6c$var$CatalogueTabs = ({ catalogue: catalogue })=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const { admin: admin, isPermission: isPermission } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    // Invitations and administrators tabs are only shown for tenant customer type and logged users who are not admin
    const isVisible = catalogue?.customer.type === "TENANT" && !admin && isPermission("READ", "TENANT_INVITATIONS");
    let tabHeaders = [
        intl.formatMessage({
            id: "page.places.catalogueTabs.catalogue.header"
        })
    ];
    let tabPanels = [
        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $07a0846cd6caa7d8$export$2e2bcd8739ae039), {
            catalogue: catalogue
        })
    ];
    if (isVisible) {
        tabHeaders.push(intl.formatMessage({
            id: "page.places.catalogueTabs.administrators.header"
        }), intl.formatMessage({
            id: "page.places.catalogueTabs.invitations.header"
        }));
        tabPanels.push(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $913f22ba744c73bf$export$2e2bcd8739ae039), {
            customerId: catalogue.customer.id,
            showInvitationCreate: false
        }), /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b9a365c920cb0339$export$2e2bcd8739ae039), {
            catalogue: catalogue
        }));
    }
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
        loading: false,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $752b2919b820e82b$export$2e2bcd8739ae039), {
                tabKey: "tabsRightHolderGroup",
                tabHeaders: tabHeaders,
                tabPanels: tabPanels
            })
        })
    });
};
var $01190f929da15e6c$export$2e2bcd8739ae039 = $01190f929da15e6c$var$CatalogueTabs;




var $3Py8h = parcelRequire("3Py8h");




var $1T1QG = parcelRequire("1T1QG");


var $e631bbd3618e6888$exports = {};
"use strict";
"use client";

Object.defineProperty($e631bbd3618e6888$exports, "__esModule", {
    value: true
});
$e631bbd3618e6888$exports.default = void 0;

var $e631bbd3618e6888$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $e631bbd3618e6888$var$_default = $e631bbd3618e6888$exports.default = (0, $e631bbd3618e6888$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M3 17.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.81 9.94l-3.75-3.75L3.15 17.1c-.1.1-.15.22-.15.36M20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), "EditRounded");



var $3Py8h = parcelRequire("3Py8h");

var $3Py8h = parcelRequire("3Py8h");



var $1T1QG = parcelRequire("1T1QG");
var $1b8854ba4157884d$exports = {};
"use strict";
Object.defineProperty($1b8854ba4157884d$exports, "__esModule", {
    value: true
});
var $1b8854ba4157884d$var$BUSINESS_ID_REGEX = /^[\d]{7}-[\d]$/;
var $1b8854ba4157884d$var$VAT_NUMBER_REGEX = /^FI[\d]{8}$/;
var $1b8854ba4157884d$var$MULTIPLIERS = [
    7,
    9,
    10,
    5,
    8,
    4,
    2
];
function $1b8854ba4157884d$var$randomBusinessIdWithoutChecksum() {
    while(true){
        var businessId = (Math.floor(Math.random() * 1000000) + 1000000).toString();
        if ($1b8854ba4157884d$var$FinnishBusinessIds.calculateChecksum(businessId) !== -1) return businessId;
    }
}
var $1b8854ba4157884d$var$FinnishBusinessIds = /** @class */ function() {
    function FinnishBusinessIds() {}
    FinnishBusinessIds.isValidBusinessId = function(businessId) {
        if (!$1b8854ba4157884d$var$BUSINESS_ID_REGEX.test(businessId)) return false;
        var givenChecksum = parseInt(businessId.substring(8, 9), 10);
        var idNumbers = businessId.substring(0, 7);
        var calculatedChecksum = FinnishBusinessIds.calculateChecksum(idNumbers);
        return calculatedChecksum === givenChecksum;
    };
    FinnishBusinessIds.isValidVatNumber = function(vatNumber) {
        if (!$1b8854ba4157884d$var$VAT_NUMBER_REGEX.test(vatNumber)) return false;
        var vatAsBusinessId = vatNumber.substring(2, 9) + "-" + vatNumber.substring(9, 10);
        return this.isValidBusinessId(vatAsBusinessId);
    };
    FinnishBusinessIds.generateBusinessId = function() {
        var businessId = $1b8854ba4157884d$var$randomBusinessIdWithoutChecksum();
        var checksum = FinnishBusinessIds.calculateChecksum(businessId);
        return businessId + "-" + checksum;
    };
    FinnishBusinessIds.generateVatNumber = function() {
        var countryCode = "FI";
        var businessId = $1b8854ba4157884d$var$randomBusinessIdWithoutChecksum();
        var checksum = FinnishBusinessIds.calculateChecksum(businessId);
        return countryCode + businessId + checksum;
    };
    FinnishBusinessIds.calculateChecksum = function(idNumbers) {
        var sum = 0;
        for(var i = 0; i < idNumbers.length; i++)sum += parseInt(idNumbers[i], 10) * $1b8854ba4157884d$var$MULTIPLIERS[i];
        var remainder = sum % 11;
        if (remainder === 1) return -1;
        else if (remainder > 1) remainder = 11 - remainder;
        return remainder;
    };
    return FinnishBusinessIds;
}();
$1b8854ba4157884d$exports.FinnishBusinessIds = $1b8854ba4157884d$var$FinnishBusinessIds;



var $eUHG3 = parcelRequire("eUHG3");

const $c147cb2e66039540$var$FormCustomer = (props)=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const getFormDefaultValues = ()=>{
        return {
            name: props.defaultValues?.name || "",
            streetAddress: props.defaultValues?.streetAddress || "",
            postalCode: props.defaultValues?.postalCode || "",
            city: props.defaultValues?.city || "",
            businessId: props.defaultValues?.businessId || ""
        };
    };
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $1T1QG.useState)(false);
    const [defaultValues, setDefaultValues] = (0, $1T1QG.useState)(getFormDefaultValues());
    (0, $1T1QG.useEffect)(()=>{
        setDefaultValues(getFormDefaultValues());
    }, [
        props.defaultValues?.businessId,
        props.defaultValues?.city,
        props.defaultValues?.name,
        props.defaultValues?.postalCode,
        props.defaultValues?.streetAddress
    ]);
    const CustomerSchema = ()=>{
        return $d7c41ae3ced691f5$export$be5493f9613cbbe().shape({
            name: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            businessId: $d7c41ae3ced691f5$export$22b082955e083ec3().test("businessId", intl.formatMessage({
                id: "common.form.errors.businessId"
            }), function(businessId) {
                return !!businessId && (0, $1b8854ba4157884d$exports.FinnishBusinessIds).isValidBusinessId(businessId);
            }),
            streetAddress: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            postalCode: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            city: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            }))
        });
    };
    const onSubmitFormValues = (values)=>{
        const { name: name, streetAddress: streetAddress, postalCode: postalCode, city: city, businessId: businessId } = values;
        props.onSubmit({
            name: name.trim(),
            streetAddress: streetAddress.trim(),
            postalCode: postalCode.trim(),
            city: city.trim(),
            businessId: businessId.trim()
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $eUHG3.Formik), {
            validate: ()=>setFormikValidateOnChange(true),
            validationSchema: CustomerSchema(),
            enableReinitialize: true,
            initialValues: defaultValues,
            validateOnChange: formikValidateOnChange,
            onSubmit: (values)=>{
                onSubmitFormValues(values);
            },
            children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $3Py8h.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: props.formReference,
                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            props.showTitle && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.customers.formCustomer.contentTitle"
                                })
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                        name: "name",
                                        "data-testid": "name",
                                        value: values.name,
                                        autoFocus: true,
                                        label: intl.formatMessage({
                                            id: "page.customers.formCustomer.label.name"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "page.customers.formCustomer.label.name"
                                        }),
                                        onChange: handleChange,
                                        error: !!errors.name,
                                        errorText: errors.name
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                        name: "businessId",
                                        "data-testid": "businessId",
                                        value: values.businessId,
                                        label: intl.formatMessage({
                                            id: "page.customers.formCustomer.label.businessId"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "page.customers.formCustomer.label.businessId"
                                        }),
                                        onChange: handleChange,
                                        error: !!errors.businessId,
                                        errorText: errors.businessId,
                                        disabled: props.editView
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                    flexDirection: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                            name: "streetAddress",
                                            "data-testid": "streetAddress",
                                            value: values.streetAddress,
                                            label: intl.formatMessage({
                                                id: "page.customers.formCustomer.label.streetAddress"
                                            }),
                                            placeholder: intl.formatMessage({
                                                id: "page.customers.formCustomer.label.streetAddress"
                                            }),
                                            onChange: handleChange,
                                            error: !!errors.streetAddress,
                                            errorText: errors.streetAddress
                                        }),
                                        /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                            children: [
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                                    name: "postalCode",
                                                    "data-testid": "postalCode",
                                                    value: values.postalCode,
                                                    label: intl.formatMessage({
                                                        id: "page.customers.formCustomer.label.postalCode"
                                                    }),
                                                    placeholder: intl.formatMessage({
                                                        id: "page.customers.formCustomer.label.postalCode"
                                                    }),
                                                    onChange: handleChange,
                                                    error: !!errors.postalCode,
                                                    errorText: errors.postalCode
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                                    name: "city",
                                                    "data-testid": "city",
                                                    value: values.city,
                                                    label: intl.formatMessage({
                                                        id: "page.customers.formCustomer.label.city"
                                                    }),
                                                    placeholder: intl.formatMessage({
                                                        id: "page.customers.formCustomer.label.city"
                                                    }),
                                                    onChange: handleChange,
                                                    error: !!errors.city,
                                                    errorText: errors.city
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
        })
    });
};
var $c147cb2e66039540$export$2e2bcd8739ae039 = $c147cb2e66039540$var$FormCustomer;







const $8a916499d5abaaf2$var$ModalEditCustomer = (props)=>{
    const FORM_REFERENCE = "formUpdateCustomer";
    const { defaultValues: defaultValues } = props;
    const updateCustomerMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $3af058eac12e21cb$export$2e2bcd8739ae039).updateCustomer(props.editableCustomerRef, dto),
        onSuccess: (response)=>{
            props.onSubmit(response.data);
        }
    });
    const updateCustomer = (values)=>{
        const { name: name, streetAddress: streetAddress, postalCode: postalCode, city: city } = values;
        const dto = {
            name: (0, $fb47a354e391b3c4$export$b9d2d3b623c012b1)(name, defaultValues.name),
            streetAddress: (0, $fb47a354e391b3c4$export$b9d2d3b623c012b1)(streetAddress, defaultValues.streetAddress),
            postalCode: (0, $fb47a354e391b3c4$export$b9d2d3b623c012b1)(postalCode, defaultValues.postalCode),
            city: (0, $fb47a354e391b3c4$export$b9d2d3b623c012b1)(city, defaultValues.city),
            businessId: undefined // Not allowed to modify by frontend
        };
        if ((0, $fb47a354e391b3c4$export$8f98ff223296ded9)(dto)) updateCustomerMutation.mutate(dto);
    };
    const cancel = ()=>{
        updateCustomerMutation.reset();
        props.onCancel();
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $259d9dbb3544503a$export$2e2bcd8739ae039), {
            open: props.open,
            onCancel: cancel,
            formReference: FORM_REFERENCE,
            errorTitleKey: "common.actions.update.error",
            modalTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.customer.modalEditCustomer.title"
            }),
            submitButtonContent: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "common.buttons.save"
            }),
            mutation: updateCustomerMutation,
            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c147cb2e66039540$export$2e2bcd8739ae039), {
                showTitle: true,
                onSubmit: (values)=>{
                    updateCustomer(values);
                },
                formReference: FORM_REFERENCE,
                defaultValues: defaultValues,
                editView: true
            })
        })
    });
};
var $8a916499d5abaaf2$export$2e2bcd8739ae039 = $8a916499d5abaaf2$var$ModalEditCustomer;





const $a7b12d6714269034$var$CustomerInformation = ({ header: header, customerId: customerId, customBreadcrumbs: customBreadcrumbs })=>{
    const queryClient = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)();
    const [showModal, setShowModal] = (0, $1T1QG.useState)(false);
    const { customer: customer, setCustomer: setCustomer } = (0, $a48e808e68b0e5f9$export$2e2bcd8739ae039)();
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const queryCustomer = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$b3c26f5832e8795f),
            customerId
        ],
        queryFn: ()=>(0, $3af058eac12e21cb$export$2e2bcd8739ae039).getCustomerByRef(customerId || ""),
        enabled: !!customerId,
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const { name: name, streetAddress: streetAddress, city: city, postalCode: postalCode, businessId: businessId, customerNumber: customerNumber } = queryCustomer.data ?? {};
    const defaultValues = {
        name: name || "",
        streetAddress: streetAddress || "",
        city: city || "",
        postalCode: postalCode || "",
        businessId: businessId || "",
        customerNumber: customerNumber || ""
    };
    const data = [
        {
            label: intl.formatMessage({
                id: "page.customers.customersInformation.name"
            }),
            value: `${defaultValues.name}`
        },
        {
            label: intl.formatMessage({
                id: "page.customers.customersInformation.streetAddress"
            }),
            value: `${(0, $fb47a354e391b3c4$export$ff20516246215bf)(defaultValues?.streetAddress, defaultValues?.postalCode, ", ")} ${defaultValues?.city}`
        },
        {
            label: intl.formatMessage({
                id: "page.customers.customersInformation.businessId"
            }),
            value: `${defaultValues.businessId}`
        },
        {
            label: intl.formatMessage({
                id: "page.customers.customersInformation.customerNumber"
            }),
            value: `${defaultValues.customerNumber}`
        }
    ];
    const refreshView = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $ec0c9d75a0d3a81a$export$b3c26f5832e8795f),
                customerId
            ]
        });
        queryClient.invalidateQueries({
            queryKey: [
                (0, $ec0c9d75a0d3a81a$export$7cf5b9f73b9b2f2d)
            ]
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b914262cfd70d60a$export$2e2bcd8739ae039), {
        query: queryCustomer,
        rootPageIfNotFoundError: true,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $d853676d11a33bb6$export$2e2bcd8739ae039), {
                        breadcrumbs: customBreadcrumbs,
                        children: header || name
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {
                        title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "page.customer.title"
                        }),
                        button: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $15827f0d92c5ff99$export$2e2bcd8739ae039), {
                            action: "EDIT",
                            resource: "CUSTOMER",
                            visibility: !!customerId,
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                                startIcon: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e631bbd3618e6888$exports))), {}),
                                onClick: ()=>setShowModal(true),
                                showAsIconButton: true,
                                "aria-label": intl.formatMessage({
                                    id: "page.customer.button.edit"
                                })
                            })
                        }),
                        divider: true
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $836e912fb2b7fc60$export$2e2bcd8739ae039), {
                            data: data
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8a916499d5abaaf2$export$2e2bcd8739ae039), {
                open: showModal,
                editableCustomerRef: customerId || "",
                defaultValues: defaultValues,
                onSubmit: (response)=>{
                    (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                        id: "page.customer.actions.updated",
                        values: {
                            name: response?.name
                        }
                    }));
                    response && response.id === customer.id && setCustomer(response);
                    refreshView();
                    setShowModal(false);
                },
                onCancel: ()=>setShowModal(false)
            })
        ]
    });
};
var $a7b12d6714269034$export$2e2bcd8739ae039 = $a7b12d6714269034$var$CustomerInformation;




parcelRequire("1T1QG");




const $696e64c10a59317a$var$Catalogue = ()=>{
    const { catalogueRef: catalogueRef } = (0, $e0cff2801449e77d$export$99eaa27ddbbb95ef)();
    const { tenant: tenant } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const catalogueId = catalogueRef || "";
    const queryCatalogue = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$93e1682d8eaccc31),
            catalogueId
        ],
        queryFn: ()=>(0, $7499271e3a060909$export$25753268427e50ea).getCataloguesByRef(catalogueId),
        enabled: !!catalogueId
    });
    const customerId = queryCatalogue.data?.customer?.id;
    const catalogue = queryCatalogue.data;
    const lastItem = catalogue?.name || catalogue?.customer?.name || "";
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b914262cfd70d60a$export$2e2bcd8739ae039), {
        query: queryCatalogue,
        rootPageIfNotFoundError: true,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c9560da3d4f68f59$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a7b12d6714269034$export$2e2bcd8739ae039), {
                            header: lastItem,
                            customerId: customerId,
                            customBreadcrumbs: {
                                lastBreadcrumb: lastItem,
                                customBreadcrumbs: !tenant ? [
                                    {
                                        route: `${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES}/${catalogue?.place.id}`,
                                        name: catalogue?.place.name || ""
                                    },
                                    {
                                        route: `${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).OFFERINGS}/${catalogue?.offering?.id}`,
                                        name: catalogue?.offering?.name || ""
                                    }
                                ] : undefined
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $01190f929da15e6c$export$2e2bcd8739ae039), {
                            catalogue: catalogue
                        })
                    })
                ]
            })
        ]
    });
};
var $696e64c10a59317a$export$2e2bcd8739ae039 = $696e64c10a59317a$var$Catalogue;



var $3Py8h = parcelRequire("3Py8h");




var $3Py8h = parcelRequire("3Py8h");



var $3Py8h = parcelRequire("3Py8h");


var $1T1QG = parcelRequire("1T1QG");
const $c49ecba184935556$var$TabSubPlaces = ({ customerId: customerId, queryPlaces: queryPlaces })=>{
    const [showSubPlaceModal, setShowSubPlaceModal] = (0, $1T1QG.useState)(false);
    const places = queryPlaces.data || [];
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
        loading: queryPlaces.isFetching,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $fec9f563e701e087$export$2e2bcd8739ae039), {
                        queryPlaces: queryPlaces,
                        places: places
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4a501defb6a96d4b$export$2e2bcd8739ae039), {
                        open: showSubPlaceModal,
                        onSubmit: (values)=>{
                            queryPlaces.refetch();
                            setShowSubPlaceModal(false);
                        },
                        onCancel: ()=>setShowSubPlaceModal(false),
                        customerId: customerId
                    })
                ]
            })
        ]
    });
};
var $c49ecba184935556$export$2e2bcd8739ae039 = $c49ecba184935556$var$TabSubPlaces;



const $9c78eef60c50f910$var$CustomerTabs = ({ customerId: customerId, enableTabPlaces: enableTabPlaces, enableTabAdmins: enableTabAdmins, queryPlaces: queryPlaces })=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const tabHeaders = [
        enableTabPlaces ? intl.formatMessage({
            id: "page.customer.customerTabs.locations.header"
        }) : "",
        enableTabAdmins ? intl.formatMessage({
            id: "page.customer.customerTabs.admins.header"
        }) : ""
    ].filter((item)=>item);
    const tabPanels = [
        enableTabPlaces ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c49ecba184935556$export$2e2bcd8739ae039), {
            customerId: customerId,
            queryPlaces: queryPlaces
        }) : "",
        enableTabAdmins ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $913f22ba744c73bf$export$2e2bcd8739ae039), {
            customerId: customerId
        }) : ""
    ].filter((item)=>item);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $752b2919b820e82b$export$2e2bcd8739ae039), {
        tabKey: "tabsRightHolderGroup",
        tabHeaders: tabHeaders,
        tabPanels: tabPanels
    });
};
var $9c78eef60c50f910$export$2e2bcd8739ae039 = $9c78eef60c50f910$var$CustomerTabs;




parcelRequire("1T1QG");



const $be0b234a79d7efdc$var$Customer = ()=>{
    let { customerRef: customerRef } = (0, $e0cff2801449e77d$export$99eaa27ddbbb95ef)();
    const { admin: admin, isPermission: isPermission } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const customerId = customerRef || "";
    const queryPlaces = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$995d68b6ebb26447),
            customerId
        ],
        queryFn: ()=>(0, $3af058eac12e21cb$export$2e2bcd8739ae039).getPlacesByCustomer(admin, customerId),
        enabled: !!customerId && isPermission("READ", "PLACES"),
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const enableTabPlaces = !!queryPlaces.data && queryPlaces.data.length > 0;
    const enableTabAdmins = isPermission("READ", "ADMIN_INVITATIONS");
    const showTabs = enableTabPlaces || enableTabAdmins;
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        direction: "row",
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a7b12d6714269034$export$2e2bcd8739ae039), {
                    customerId: customerId
                })
            }),
            showTabs && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $9c78eef60c50f910$export$2e2bcd8739ae039), {
                            customerId: customerId,
                            enableTabPlaces: enableTabPlaces,
                            enableTabAdmins: enableTabAdmins,
                            queryPlaces: queryPlaces
                        })
                    })
                })
            })
        ]
    });
};
var $be0b234a79d7efdc$export$2e2bcd8739ae039 = $be0b234a79d7efdc$var$Customer;



var $3Py8h = parcelRequire("3Py8h");

parcelRequire("1T1QG");
const $934a18d253b5961e$var$Invitations = ()=>{
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b463aef7f528c97c$export$2e2bcd8739ae039), {});
};
var $934a18d253b5961e$export$2e2bcd8739ae039 = $934a18d253b5961e$var$Invitations;



var $3Py8h = parcelRequire("3Py8h");




var $1T1QG = parcelRequire("1T1QG");





var $3Py8h = parcelRequire("3Py8h");








const $9081042e8600cd9d$var$StepLandlord = (props)=>{
    const { setCustomer: setCustomer } = (0, $a48e808e68b0e5f9$export$2e2bcd8739ae039)();
    const FORM_REFERENCE = "formStepAddLandlord";
    const createCustomerMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $3af058eac12e21cb$export$2e2bcd8739ae039).createCustomer(dto),
        onSuccess: (response)=>{
            const customer = response.data || {};
            setCustomer(customer, true);
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.steps.landlord.actions.added",
                values: {
                    name: customer.name
                }
            }));
            props.onStepCompleted();
        }
    });
    const createCustomer = (values)=>{
        const { name: name, streetAddress: streetAddress, postalCode: postalCode, city: city, businessId: businessId } = values;
        const dto = {
            type: "LANDLORD",
            name: name,
            streetAddress: streetAddress,
            postalCode: postalCode,
            city: city,
            businessId: businessId
        };
        createCustomerMutation.mutate(dto);
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)("h1", {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "page.steps.landlord.title"
                })
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $019112675a75b38b$export$2e2bcd8739ae039), {
                mutation: createCustomerMutation,
                errorTitleKey: "common.actions.add.error"
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)("p", {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "page.steps.landlord.info"
                })
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c147cb2e66039540$export$2e2bcd8739ae039), {
                onSubmit: (values)=>{
                    createCustomer(values);
                },
                formReference: FORM_REFERENCE
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                container: true,
                pt: 12,
                justifyContent: "flex-end",
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                    type: "submit",
                    mutation: createCustomerMutation,
                    form: FORM_REFERENCE,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                        id: "common.buttons.next"
                    })
                })
            })
        ]
    });
};
var $9081042e8600cd9d$export$2e2bcd8739ae039 = $9081042e8600cd9d$var$StepLandlord;



var $3Py8h = parcelRequire("3Py8h");


var $3Py8h = parcelRequire("3Py8h");



var $1T1QG = parcelRequire("1T1QG");

var $eUHG3 = parcelRequire("eUHG3");



const $cf2338fcccf655cb$var$FormPlace = (props)=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const { customer: customer } = (0, $a48e808e68b0e5f9$export$2e2bcd8739ae039)();
    const customerOptions = props.customers.map((item)=>{
        return {
            key: item.id,
            value: item.name
        };
    });
    const getFormDefaultValues = ()=>{
        return {
            name: props.defaultValues?.name || "",
            streetAddress: props.defaultValues?.streetAddress || "",
            postalCode: props.defaultValues?.postalCode || "",
            city: props.defaultValues?.city || "",
            capacity: props.defaultValues?.capacity || "",
            customerId: props.defaultValues?.customerId || customer.id
        };
    };
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $1T1QG.useState)(false);
    const [defaultValues, setDefaultValues] = (0, $1T1QG.useState)(getFormDefaultValues());
    (0, $1T1QG.useEffect)(()=>{
        setDefaultValues(getFormDefaultValues());
    }, [
        props.defaultValues?.capacity,
        props.defaultValues?.city,
        props.defaultValues?.name,
        props.defaultValues?.postalCode,
        props.defaultValues?.streetAddress,
        props.defaultValues?.customerId
    ]);
    const placeSchema = ()=>{
        return $d7c41ae3ced691f5$export$be5493f9613cbbe().shape({
            customerId: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            name: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            streetAddress: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            postalCode: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            city: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            capacity: $d7c41ae3ced691f5$export$98e628dec113755e().required(intl.formatMessage({
                id: "common.form.errors.empty"
            }))
        });
    };
    const onSubmitFormValues = (values)=>{
        const { name: name, streetAddress: streetAddress, postalCode: postalCode, city: city, capacity: capacity, customerId: customerId } = values;
        props.onSubmit({
            name: name.trim(),
            streetAddress: streetAddress.trim(),
            postalCode: postalCode.trim(),
            city: city.trim(),
            capacity: capacity,
            customerId: customerId
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $eUHG3.Formik), {
            validate: ()=>setFormikValidateOnChange(true),
            validationSchema: placeSchema(),
            enableReinitialize: true,
            initialValues: defaultValues,
            validateOnChange: formikValidateOnChange,
            onSubmit: (values)=>{
                onSubmitFormValues(values);
            },
            children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $3Py8h.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: props.formReference,
                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            props.showTitle && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.places.formPlace.contentTitle"
                                })
                            }),
                            customerOptions.length > 1 && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                flexDirection: "column",
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormSelect, {
                                    name: "customerId",
                                    label: intl.formatMessage({
                                        id: "page.places.formPlace.label.customer"
                                    }),
                                    value: values.customerId,
                                    onChange: handleChange,
                                    error: !!errors.customerId,
                                    children: customerOptions.map((item)=>{
                                        return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $450c65ee2dafa292$export$2e2bcd8739ae039), {
                                            value: item.key,
                                            children: item.value
                                        }, item.key);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                        name: "name",
                                        "data-testid": "name",
                                        value: values.name,
                                        autoFocus: true,
                                        label: intl.formatMessage({
                                            id: "page.places.formPlace.label.name"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "page.places.formPlace.label.name"
                                        }),
                                        onChange: handleChange,
                                        error: !!errors.name,
                                        errorText: errors.name
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                        name: "streetAddress",
                                        "data-testid": "streetAddress",
                                        value: values.streetAddress,
                                        label: intl.formatMessage({
                                            id: "page.places.formPlace.label.streetAddress"
                                        }),
                                        placeholder: intl.formatMessage({
                                            id: "page.places.formPlace.label.streetAddress"
                                        }),
                                        onChange: handleChange,
                                        error: !!errors.streetAddress,
                                        errorText: errors.streetAddress
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                                name: "postalCode",
                                                "data-testid": "postalCode",
                                                value: values.postalCode,
                                                label: intl.formatMessage({
                                                    id: "page.places.formPlace.label.postalCode"
                                                }),
                                                placeholder: intl.formatMessage({
                                                    id: "page.places.formPlace.label.postalCode"
                                                }),
                                                onChange: handleChange,
                                                error: !!errors.postalCode,
                                                errorText: errors.postalCode
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                                name: "city",
                                                "data-testid": "city",
                                                value: values.city,
                                                label: intl.formatMessage({
                                                    id: "page.places.formPlace.label.city"
                                                }),
                                                placeholder: intl.formatMessage({
                                                    id: "page.places.formPlace.label.city"
                                                }),
                                                onChange: handleChange,
                                                error: !!errors.city,
                                                errorText: errors.city
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                            name: "capacity",
                                            "data-testid": "capacity",
                                            value: values.capacity || "",
                                            type: "number",
                                            label: intl.formatMessage({
                                                id: "page.places.formPlace.label.capacity"
                                            }),
                                            placeholder: intl.formatMessage({
                                                id: "page.places.formPlace.label.capacity"
                                            }),
                                            onChange: handleChange,
                                            error: !!errors.capacity,
                                            errorText: errors.capacity,
                                            disabled: props?.editView
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
        })
    });
};
var $cf2338fcccf655cb$export$2e2bcd8739ae039 = $cf2338fcccf655cb$var$FormPlace;








const $e3d8e3ce18acd6b4$var$StepPlace = (props)=>{
    const { customer: customer, setPlace: setPlace } = (0, $a48e808e68b0e5f9$export$2e2bcd8739ae039)();
    const FORM_REFERENCE = "formStepAddPlace";
    const createPlaceMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $f7802c761d4f9d37$export$2bffccb0f948be1f).createPlaceWithDefaultOffering(dto),
        onSuccess: (response)=>{
            const place = response.data;
            setPlace(place);
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.steps.place.actions.added",
                values: {
                    name: place.name
                }
            }));
            props.onStepCompleted();
        }
    });
    const createPlace = (values)=>{
        const customerId = customer.id;
        const { name: name, streetAddress: streetAddress, postalCode: postalCode, city: city, capacity: capacity } = values;
        const createPlaceDto = {
            name: name,
            streetAddress: streetAddress,
            postalCode: postalCode,
            city: city,
            customerId: customerId,
            capacity: capacity
        };
        createPlaceMutation.mutate(createPlaceDto);
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)("h1", {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "page.steps.place.title"
                })
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $019112675a75b38b$export$2e2bcd8739ae039), {
                mutation: createPlaceMutation,
                errorTitleKey: "common.actions.update.error"
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)("p", {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "page.steps.place.info"
                })
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $cf2338fcccf655cb$export$2e2bcd8739ae039), {
                onSubmit: (values)=>{
                    createPlace(values);
                },
                formReference: FORM_REFERENCE,
                customers: []
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                container: true,
                pt: 12,
                justifyContent: "flex-end",
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                    type: "submit",
                    mutation: createPlaceMutation,
                    form: FORM_REFERENCE,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                        id: "common.buttons.complete"
                    })
                })
            })
        ]
    });
};
var $e3d8e3ce18acd6b4$export$2e2bcd8739ae039 = $e3d8e3ce18acd6b4$var$StepPlace;









const $66eb78e55a176042$var$LoginSteps = ()=>{
    const navigate = (0, $e0cff2801449e77d$export$9770f232ac06a008)();
    let eStep;
    (function(eStep) {
        eStep[eStep["STEP_LANDLORD"] = 0] = "STEP_LANDLORD";
        eStep[eStep["STEP_PLACE"] = 1] = "STEP_PLACE";
    })(eStep || (eStep = {}));
    const { customer: customer } = (0, $a48e808e68b0e5f9$export$2e2bcd8739ae039)();
    const { admin: admin } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const [activeStep, setActiveStep] = (0, $1T1QG.useState)(customer?.id ? 1 : 0);
    const [completedSteps, setCompletedSteps] = (0, $1T1QG.useState)([]);
    const queryPlaces = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$9e8d1e7efde0f0d3)
        ],
        queryFn: ()=>(0, $3af058eac12e21cb$export$2e2bcd8739ae039).getPlacesByCustomer(admin, customer.id),
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc),
        enabled: !!customer?.id
    });
    const queryInvitations = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$a10de6d4556ab62e)
        ],
        queryFn: ()=>(0, $9f8b36004207981d$export$2e2bcd8739ae039).getUserInvitations(),
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const isAllowedToCreateCustomer = queryInvitations.data?.find((invitation)=>!invitation.used && !invitation.landlordId);
    // If the user has no customer relationship defined and no open invitation to create one -> can't access Lupapalvelu
    const userHasNoRightsToContinue = !isAllowedToCreateCustomer && !customer.id;
    (0, $1T1QG.useEffect)(()=>{
        const response = queryPlaces.data;
        if (response && response.length > 0 && response[0]?.id && response[0]?.name) navigate((0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).ROOT, {
            replace: true
        });
    }, [
        queryPlaces.isSuccess
    ]);
    if (userHasNoRightsToContinue) return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $d853676d11a33bb6$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                    sx: {
                        mt: "2rem"
                    },
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                        id: "page.steps.noRights.header"
                    })
                })
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                    sx: {
                        pt: "1rem"
                    },
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)("p", {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "page.steps.noRights.content"
                        })
                    })
                })
            })
        ]
    });
    const stepCompleted = (step)=>{
        !completedSteps.includes(step) && setCompletedSteps([
            ...completedSteps,
            step
        ]);
        switch(step){
            case 0:
                setActiveStep(1);
                break;
            case 1:
                navigate((0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).ROOT, {
                    replace: true
                });
                break;
            default:
                (0, $fb47a354e391b3c4$export$16bf6fe03653420f)(step);
        }
    };
    const StepContent = ({ step: step })=>{
        switch(step){
            case 0:
                return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $9081042e8600cd9d$export$2e2bcd8739ae039), {
                    onStepCompleted: ()=>stepCompleted(0)
                });
            case 1:
                return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e3d8e3ce18acd6b4$export$2e2bcd8739ae039), {
                    onStepCompleted: ()=>stepCompleted(1)
                });
            default:
                (0, $fb47a354e391b3c4$export$16bf6fe03653420f)(step);
        }
    };
    const isLoading = ()=>{
        return queryPlaces.isFetching;
    };
    const steps = [
        {
            label: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.steps.bar.landlord.title"
            }),
            step: 0,
            icon: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1d497a506d9a8a6b$exports))), {
                fontSize: "large"
            }),
            description: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.steps.bar.landlord.description"
            })
        },
        {
            label: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.steps.bar.place.title"
            }),
            step: 1,
            icon: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e82629ceb64f6e49$exports))), {
                fontSize: "large"
            }),
            description: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.steps.bar.place.description"
            })
        }
    ];
    return /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
        children: isLoading() ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4cdfa78f7d1b8c19$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $3Py8h.jsx)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                    sx: {
                        mt: "30px"
                    },
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a37c1bd20156d042$export$2e2bcd8739ae039), {
                            alternativeLabel: true,
                            sx: {
                                width: "100%",
                                pt: "50px"
                            },
                            children: steps.map((item)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $f6f1b9657beabe18$export$2e2bcd8739ae039), {
                                    active: activeStep === item.step,
                                    disabled: activeStep !== item.step,
                                    completed: completedSteps.includes(item.step),
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $6f2a56b8d3467b7b$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)("h3", {
                                                        style: {
                                                            margin: "5px"
                                                        },
                                                        children: item.label
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                                                            style: {
                                                                display: "flex"
                                                            },
                                                            children: item.icon
                                                        }),
                                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            pl: 1,
                                                            children: item.description
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }, item.step))
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                            style: {
                                padding: "50px"
                            },
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)(StepContent, {
                                step: activeStep
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $66eb78e55a176042$export$2e2bcd8739ae039 = $66eb78e55a176042$var$LoginSteps;



var $3Py8h = parcelRequire("3Py8h");



var $3Py8h = parcelRequire("3Py8h");





var $1T1QG = parcelRequire("1T1QG");






var $3Py8h = parcelRequire("3Py8h");



var $eUHG3 = parcelRequire("eUHG3");


var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $74209af4e967f9bf$export$d72d4cbdc30b331f(slot) {
    return (0, $iNQht.default)("MuiFormGroup", slot);
}
const $74209af4e967f9bf$var$formGroupClasses = (0, $dfswM.default)("MuiFormGroup", [
    "root",
    "row",
    "error"
]);
var $74209af4e967f9bf$export$2e2bcd8739ae039 = $74209af4e967f9bf$var$formGroupClasses;





var $3Py8h = parcelRequire("3Py8h");
"use client";
const $97b9b45ce6640855$var$_excluded = [
    "className",
    "row"
];
const $97b9b45ce6640855$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            row && "row",
            error && "error"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $74209af4e967f9bf$export$d72d4cbdc30b331f), classes);
};
const $97b9b45ce6640855$var$FormGroupRoot = (0, $npagc.default)("div", {
    name: "MuiFormGroup",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $ajTRS.default)({
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap"
    }, ownerState.row && {
        flexDirection: "row"
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $97b9b45ce6640855$var$FormGroup = /*#__PURE__*/ $1T1QG.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiFormGroup"
    });
    const { className: className, row: row = false } = props, other = (0, $iXdVf.default)(props, $97b9b45ce6640855$var$_excluded);
    const muiFormControl = (0, $83a17b5295da3528$export$2e2bcd8739ae039)();
    const fcs = (0, $5463d9638c422d7c$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $ajTRS.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $97b9b45ce6640855$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($97b9b45ce6640855$var$FormGroupRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $97b9b45ce6640855$export$2e2bcd8739ae039 = $97b9b45ce6640855$var$FormGroup;







var $3Py8h = parcelRequire("3Py8h");
"use client";
const $016a87b721694d75$var$_excluded = [
    "actions",
    "children",
    "defaultValue",
    "name",
    "onChange",
    "value"
];
const $016a87b721694d75$var$RadioGroup = /*#__PURE__*/ $1T1QG.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp } = props, other = (0, $iXdVf.default)(props, $016a87b721694d75$var$_excluded);
    const rootRef = $1T1QG.useRef(null);
    const [value, setValueState] = (0, $d1acf12366a469be$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "RadioGroup"
    });
    $1T1QG.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector("input:not(:disabled):checked");
                if (!input) input = rootRef.current.querySelector("input:not(:disabled)");
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(ref, rootRef);
    const name = (0, $71c1fc9cdce170b3$export$2e2bcd8739ae039)(nameProp);
    const contextValue = $1T1QG.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $9f2d8b467939ac6b$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $97b9b45ce6640855$export$2e2bcd8739ae039), (0, $ajTRS.default)({
            role: "radiogroup",
            ref: handleRef
        }, other, {
            children: children
        }))
    });
});
var $016a87b721694d75$export$2e2bcd8739ae039 = $016a87b721694d75$var$RadioGroup;



var $1T1QG = parcelRequire("1T1QG");






const $82c3788d72d52a76$var$ModalCreateCatalogue = ({ open: open, onCancel: onCancel, onSubmit: onSubmit, offering: offering })=>{
    const FORM_REFERENCE = "formCreateCatalogue";
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const queryClient = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)();
    const [grantedTo, setGrantedTo] = (0, $1T1QG.useState)("TENANT");
    const mutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $7499271e3a060909$export$25753268427e50ea).createCatalogue(dto),
        onSuccess: ()=>{
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.offering.modalCreateCatalogue.mutation.success"
            }));
            onSubmit();
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $ec0c9d75a0d3a81a$export$7cf5b9f73b9b2f2d),
                    offering?.id
                ]
            });
        }
    });
    const { customer: customer } = (0, $a48e808e68b0e5f9$export$2e2bcd8739ae039)();
    (0, $1T1QG.useEffect)(()=>{
        mutation.reset();
        setGrantedTo("TENANT");
    }, [
        open
    ]);
    if (!offering) return null;
    const isWhitelist = offering.type === "WHITELIST";
    // Handle conflict response as a amount exceeds offering error message, no localized error message from backend
    const error = mutation.error ? mutation.error : undefined;
    const conflictErrorKey = error && error.response?.status === 409 ? "page.offering.modalCreateCatalogue.mutation.conflict" : undefined;
    const nameSchema = {
        catalogueName: $d7c41ae3ced691f5$export$22b082955e083ec3().required(intl.formatMessage({
            id: "common.form.errors.empty"
        }))
    };
    const amountSchema = {
        amount: $d7c41ae3ced691f5$export$98e628dec113755e().min(0, intl.formatMessage({
            id: "page.offering.modalCreateCatalogue.amount.minimum"
        })).required(intl.formatMessage({
            id: "common.form.errors.empty"
        })).typeError(intl.formatMessage({
            id: "common.form.errors.number"
        }))
    };
    const landlordSchema = $d7c41ae3ced691f5$export$be5493f9613cbbe().shape({
        ...nameSchema,
        ...amountSchema
    });
    const tenantSchema = $d7c41ae3ced691f5$export$be5493f9613cbbe().shape({
        ...nameSchema,
        ...amountSchema,
        customerName: $d7c41ae3ced691f5$export$22b082955e083ec3().required(intl.formatMessage({
            id: "common.form.errors.empty"
        })),
        businessId: $d7c41ae3ced691f5$export$22b082955e083ec3().required(intl.formatMessage({
            id: "common.form.errors.empty"
        })).test("businessId", intl.formatMessage({
            id: "common.form.errors.businessId"
        }), function(businessId) {
            return !!businessId && (0, $1b8854ba4157884d$exports.FinnishBusinessIds).isValidBusinessId(businessId);
        }),
        costCenter: $d7c41ae3ced691f5$export$22b082955e083ec3(),
        project: $d7c41ae3ced691f5$export$22b082955e083ec3(),
        streetAddress: $d7c41ae3ced691f5$export$22b082955e083ec3(),
        postalCode: $d7c41ae3ced691f5$export$22b082955e083ec3(),
        city: $d7c41ae3ced691f5$export$22b082955e083ec3()
    });
    const whitelistSchema = $d7c41ae3ced691f5$export$be5493f9613cbbe().shape(nameSchema);
    const submitHandler = (values)=>{
        const { catalogueName: catalogueName, amount: amount, customerName: customerName, businessId: businessId, costCenter: costCenter, project: project, streetAddress: streetAddress, postalCode: postalCode, city: city, allowVehicleGrant: allowVehicleGrant } = values;
        const dto = {
            name: catalogueName,
            costCenter: costCenter?.trim() || undefined,
            project: project?.trim() || undefined,
            amount: Number.parseInt(amount),
            customerId: customer.id,
            offeringId: offering.id,
            allowVehicleGrant: allowVehicleGrant
        };
        if (!isWhitelist && grantedTo === "TENANT") {
            dto.createTenant = {
                type: "TENANT",
                parentId: customer.id,
                name: customerName,
                businessId: businessId,
                streetAddress: !!streetAddress && streetAddress.trim().length > 0 ? streetAddress : undefined,
                postalCode: !!postalCode && postalCode.trim().length > 0 ? postalCode : undefined,
                city: !!city && city.trim().length > 0 ? city : undefined
            };
            dto.customerId = undefined;
        }
        mutation.mutate(dto);
    };
    const OwnerDetail = ()=>{
        return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $016a87b721694d75$export$2e2bcd8739ae039), {
            value: grantedTo,
            onChange: (event)=>setGrantedTo(event.target.value),
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormLabel, {
                    sx: {
                        fontWeight: "bold"
                    },
                    focused: false,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                        id: "page.offering.modalCreateCatalogue.grantedTo"
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormRadio, {
                    control: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c7a6a2f699a36e04$export$2e2bcd8739ae039), {}),
                    label: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                        id: "page.offering.modalCreateCatalogue.grantedTo.customer"
                    }),
                    value: "TENANT"
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormRadio, {
                    control: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c7a6a2f699a36e04$export$2e2bcd8739ae039), {}),
                    label: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                        id: "page.offering.modalCreateCatalogue.grantedTo.self"
                    }),
                    value: "LANDLORD"
                })
            ]
        });
    };
    const TenantDetail = ({ values: values, handleChange: handleChange, setFieldValue: setFieldValue, errors: errors })=>{
        return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormLabel, {
                    sx: {
                        fontWeight: "bold"
                    },
                    focused: false,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                        id: "page.offering.modalCreateCatalogue.customerLabel"
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                            name: "customerName",
                            "data-testid": "customerName",
                            value: values.customerName,
                            label: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.customerName"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.customerName"
                            }),
                            onChange: handleChange,
                            error: !!errors.customerName,
                            errorText: errors.customerName
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                            name: "businessId",
                            "data-testid": "businessId",
                            value: values.businessId,
                            label: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.businessId"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.businessId"
                            }),
                            onChange: handleChange,
                            error: !!errors.businessId,
                            errorText: errors.businessId
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                            name: "costCenter",
                            "data-testid": "costCenter",
                            value: values.costCenter,
                            label: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.costCenter"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.costCenter"
                            }),
                            onChange: handleChange,
                            error: !!errors.costCenter,
                            errorText: errors.costCenter
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                            name: "project",
                            "data-testid": "project",
                            value: values.project,
                            label: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.project"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.project"
                            }),
                            onChange: handleChange,
                            error: !!errors.project,
                            errorText: errors.project
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                            name: "streetAddress",
                            "data-testid": "streetAddress",
                            value: values.streetAddress,
                            label: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.streetAddress"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.streetAddress"
                            }),
                            onChange: handleChange,
                            error: !!errors.streetAddress,
                            errorText: errors.streetAddress
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                            name: "postalCode",
                            "data-testid": "postalCode",
                            value: values.postalCode,
                            label: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.postalCode"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.postalCode"
                            }),
                            onChange: handleChange,
                            error: !!errors.postalCode,
                            errorText: errors.postalCode
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                            name: "city",
                            "data-testid": "city",
                            value: values.city,
                            label: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.city"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.offering.modalCreateCatalogue.city"
                            }),
                            onChange: handleChange,
                            error: !!errors.city,
                            errorText: errors.city
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormLabel, {
                    style: {
                        fontWeight: "bold"
                    },
                    focused: false,
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "page.offering.modalCreateCatalogue.offering"
                        }),
                        (" " + offering.name) ?? ""
                    ]
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormSwitch, {
                    checked: values.allowVehicleGrant,
                    name: "allowVehicleGrant",
                    label: intl.formatMessage({
                        id: "page.offering.modalCreateCatalogue.allowVehicleGrant"
                    }),
                    style: {
                        fontWeight: "bold"
                    },
                    onChange: (event)=>setFieldValue("allowVehicleGrant", event.target.checked)
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $259d9dbb3544503a$export$2e2bcd8739ae039), {
        open: open,
        modalTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
            id: "page.offering.modalCreateCatalogue.title"
        }),
        submitButtonContent: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
            id: "common.buttons.save"
        }),
        onCancel: onCancel,
        mutation: mutation,
        formReference: FORM_REFERENCE,
        errorTitleKey: conflictErrorKey,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $eUHG3.Formik), {
            enableReinitialize: true,
            validateOnChange: false,
            initialValues: {
                amount: "",
                catalogueName: "",
                customerName: "",
                businessId: "",
                streetAddress: "",
                postalCode: "",
                city: "",
                costCenter: "",
                project: ""
            },
            validationSchema: isWhitelist ? whitelistSchema : grantedTo === "LANDLORD" ? landlordSchema : tenantSchema,
            onSubmit: (values)=>{
                submitHandler(values);
            },
            children: ({ handleSubmit: handleSubmit, handleChange: handleChange, setFieldValue: setFieldValue, values: values, errors: errors })=>/*#__PURE__*/ (0, $3Py8h.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: FORM_REFERENCE,
                    style: {
                        padding: "0 1rem"
                    },
                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormLabel, {
                                style: {
                                    fontWeight: "bold"
                                },
                                focused: false,
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.offering.modalCreateCatalogue.catalogueName"
                                })
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                name: "catalogueName",
                                value: values.catalogueName,
                                onChange: handleChange,
                                label: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.offering.modalCreateCatalogue.catalogueName"
                                }),
                                error: !!errors.catalogueName,
                                errorText: errors.catalogueName
                            }),
                            !isWhitelist && /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $3Py8h.jsx)(OwnerDetail, {}),
                                    grantedTo === "TENANT" && /*#__PURE__*/ (0, $3Py8h.jsx)(TenantDetail, {
                                        values: values,
                                        handleChange: handleChange,
                                        setFieldValue: setFieldValue,
                                        errors: errors
                                    }),
                                    !isWhitelist && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                        name: "amount",
                                        value: values.amount,
                                        onChange: handleChange,
                                        label: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                            id: "page.offering.modalCreateCatalogue.amount"
                                        }),
                                        error: !!errors.amount,
                                        errorText: errors.amount
                                    })
                                ]
                            })
                        ]
                    })
                })
        })
    });
};
var $82c3788d72d52a76$export$2e2bcd8739ae039 = $82c3788d72d52a76$var$ModalCreateCatalogue;



var $3Py8h = parcelRequire("3Py8h");






var $eUHG3 = parcelRequire("eUHG3");


parcelRequire("1T1QG");

const $aec05288d0d8220b$var$ModalEditCatalogue = ({ open: open, onCancel: onCancel, onSubmit: onSubmit, catalogue: catalogue, offering: offering })=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const queryClient = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)();
    const FORM_REFERENCE = "formEditCatalogue";
    const nameSchema = {
        catalogueName: $d7c41ae3ced691f5$export$22b082955e083ec3().required(intl.formatMessage({
            id: "common.form.errors.empty"
        }))
    };
    const schema = $d7c41ae3ced691f5$export$be5493f9613cbbe().shape({
        ...nameSchema,
        amount: $d7c41ae3ced691f5$export$98e628dec113755e().min(0, intl.formatMessage({
            id: "page.offering.modalEditCatalogue.amount.minimum"
        })).required(intl.formatMessage({
            id: "common.form.errors.empty"
        })).typeError(intl.formatMessage({
            id: "common.form.errors.number"
        }))
    });
    const whitelistSchema = $d7c41ae3ced691f5$export$be5493f9613cbbe().shape(nameSchema);
    const mutationCatalogue = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $7499271e3a060909$export$25753268427e50ea).updateCatalogue(catalogue?.id ?? "", dto),
        onSuccess: ()=>{
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.offering.modalEditCatalogue.mutation.success"
            }));
            onSubmit();
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $ec0c9d75a0d3a81a$export$7cf5b9f73b9b2f2d)
                ]
            });
        }
    });
    // Handle conflict response as a amount exceeds offering error message, no localized error message from backend
    const error = mutationCatalogue.error ? mutationCatalogue.error : undefined;
    const conflictErrorKey = error && error.response?.status === 409 ? "page.offering.modalCreateCatalogue.mutation.conflict" : undefined;
    const submitHandler = (values)=>{
        const amount = (0, $fb47a354e391b3c4$export$b9d2d3b623c012b1)(Number.parseInt(values.amount), catalogue?.amount);
        const name = (0, $fb47a354e391b3c4$export$b9d2d3b623c012b1)(values.catalogueName, catalogue?.name);
        if (name || amount) {
            const dto = {
                amount: amount ? Number.parseInt(amount) : catalogue?.amount || 0,
                name: name
            };
            mutationCatalogue.mutate(dto);
        }
    };
    const isWhitelist = offering?.type === "WHITELIST";
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $259d9dbb3544503a$export$2e2bcd8739ae039), {
        open: open,
        modalTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
            id: "page.offering.modalEditCatalogue.title"
        }),
        submitButtonContent: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
            id: "common.buttons.save"
        }),
        onCancel: onCancel,
        formReference: FORM_REFERENCE,
        mutation: mutationCatalogue,
        errorTitleKey: conflictErrorKey,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $eUHG3.Formik), {
            enableReinitialize: true,
            validateOnChange: false,
            initialValues: {
                catalogueName: catalogue?.name ?? "",
                amount: catalogue?.amount ? catalogue.amount.toString() : ""
            },
            validationSchema: isWhitelist ? whitelistSchema : schema,
            onSubmit: (values)=>submitHandler(values),
            children: ({ handleSubmit: handleSubmit, handleChange: handleChange, values: values, errors: errors })=>/*#__PURE__*/ (0, $3Py8h.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: FORM_REFERENCE,
                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormLabel, {
                                style: {
                                    fontWeight: "bold"
                                },
                                focused: false,
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.offering.modalEditCatalogue.catalogueName"
                                })
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                name: "catalogueName",
                                value: values.catalogueName,
                                onChange: handleChange,
                                label: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.offering.modalEditCatalogue.catalogueName"
                                }),
                                error: !!errors.catalogueName,
                                errorText: errors.catalogueName
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.offering.modalEditCatalogue.customer"
                                })
                            }),
                            catalogue?.customer.name,
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.offering.modalEditCatalogue.offering"
                                })
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormSwitch, {
                                checked: true,
                                label: offering?.name || "",
                                style: {
                                    fontWeight: "bold"
                                },
                                disabled: true
                            }),
                            !isWhitelist && /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormLabel, {
                                        style: {
                                            fontWeight: "bold"
                                        },
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                            id: "page.offering.modalEditCatalogue.amountLabel"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                        name: "amount",
                                        value: values.amount,
                                        onChange: handleChange,
                                        error: !!errors.amount,
                                        errorText: errors.amount,
                                        sx: {
                                            minWidth: "50%"
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
        })
    });
};
var $aec05288d0d8220b$export$2e2bcd8739ae039 = $aec05288d0d8220b$var$ModalEditCatalogue;






const $c073080e47a48afc$var$CataloguesTab = ({ offering: offering })=>{
    const navigate = (0, $e0cff2801449e77d$export$9770f232ac06a008)();
    const { isPermission: isPermission } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const queryClient = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)();
    const [showCreateCatalogueModal, setShowCreateCatalogueModal] = (0, $1T1QG.useState)(false);
    const [selectedCatalogueRef, setSelectedCatalogueRef] = (0, $1T1QG.useState)(undefined);
    const [pagingAndSortValues, setPagingAndSortValues] = (0, $adb860d4c4948aea$export$2e2bcd8739ae039)({
        key: (0, $5f8ca62b06e02682$export$2b74872b9eccd572),
        initialValue: (0, $55d02d7b1a5c4f16$export$4bec99d256114e49)("CREATED_AT")
    });
    if (!offering) return null;
    const queryCatalogs = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$7cf5b9f73b9b2f2d),
            offering.id,
            pagingAndSortValues.page,
            pagingAndSortValues.sort
        ],
        queryFn: ()=>{
            const { page: page, limit: limit, sort: sort, direction: direction } = (0, $55d02d7b1a5c4f16$export$f381863f4c1c052a)(pagingAndSortValues);
            return (0, $7499271e3a060909$export$25753268427e50ea).getByOffering(offering.id, {
                page: page,
                limit: limit,
                sort: sort,
                direction: direction
            });
        },
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const catalogues = queryCatalogs.data?.data ?? [];
    const pagination = queryCatalogs.data?.pageable ? {
        page: queryCatalogs.data.pageable.page,
        total: queryCatalogs.data.pageable.total,
        limit: queryCatalogs.data.pageable.limit,
        onNextPage: (page)=>setPagingAndSortValues({
                ...pagingAndSortValues,
                page: page.toString()
            })
    } : undefined;
    const onClickRow = (item)=>{
        navigate(`${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).CATALOGUES}/${item.id}`);
    };
    const refreshData = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $ec0c9d75a0d3a81a$export$7cf5b9f73b9b2f2d),
                offering.id
            ]
        });
        queryClient.invalidateQueries({
            queryKey: [
                (0, $ec0c9d75a0d3a81a$export$70a73d059c6beff0),
                offering.placeId
            ]
        });
        queryClient.invalidateQueries({
            queryKey: [
                (0, $ec0c9d75a0d3a81a$export$79b5a04d4c49a4e2),
                offering.placeId
            ]
        });
    };
    const items = (0, $1a49c6a526fe14f2$export$88b06990067e1fdb)(intl, "CATALOGUES");
    return /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {
                    description: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                id: "page.offering.cataloguesTab.infoText1"
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $15827f0d92c5ff99$export$2e2bcd8739ae039), {
                                action: "CREATE",
                                resource: "CATALOGUES",
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "page.offering.cataloguesTab.infoText2"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $2e40821b62a7b9dd$export$2e2bcd8739ae039), {
                                pt: 2,
                                filterKey: (0, $5f8ca62b06e02682$export$dd6ef14bcd36b902),
                                items: items,
                                value: pagingAndSortValues.sort,
                                onChange: (value)=>{
                                    pagingAndSortValues.sort !== value && setPagingAndSortValues({
                                        ...pagingAndSortValues,
                                        sort: value,
                                        direction: (0, $1a49c6a526fe14f2$export$fcce7887255d1c69)(value)
                                    });
                                }
                            })
                        ]
                    }),
                    button: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $15827f0d92c5ff99$export$2e2bcd8739ae039), {
                        action: "CREATE",
                        resource: "CATALOGUES",
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                            onClick: ()=>setShowCreateCatalogueModal(true),
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                id: "page.offering.cataloguesTab.createCatalogue"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8002a2b5b87a23eb$export$2e2bcd8739ae039), {
                            emptyTextId: "page.offering.cataloguesTab.table.empty",
                            errorTextId: "page.offering.cataloguesTab.table.error",
                            query: queryCatalogs,
                            pagination: pagination,
                            children: catalogues.map((catalog)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0829f6a75e4b5e7$export$2e2bcd8739ae039), {
                                    cardTitle: catalog.name || catalog.customer.name,
                                    cardSecondaryTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                                        utcDateTime: catalog.createdAt,
                                        dateOnly: true
                                    }),
                                    cardMenuActions: isPermission("EDIT", "CATALOGUES") ? [
                                        {
                                            itemText: intl.formatMessage({
                                                id: "page.offering.cataloguesTab.table.catalogue.edit"
                                            }),
                                            onClick: ()=>setSelectedCatalogueRef(catalog.id)
                                        }
                                    ] : undefined,
                                    cardContentList: [
                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                            id: "page.offering.cataloguesTab.table.customer"
                                        }),
                                        /*#__PURE__*/ (0, $3Py8h.jsx)("b", {
                                            children: catalog.customer.name
                                        }),
                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a62210b286c7b014$export$5fc72c219969b0e6), {
                                            amount: catalog.amount,
                                            activeRights: catalog.activeRights
                                        })
                                    ],
                                    onCardClicked: ()=>onClickRow(catalog)
                                }, catalog.id))
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $c6e866c0d03fba92$export$2e2bcd8739ae039), {
                            items: catalogues,
                            emptyTextId: "page.offering.cataloguesTab.table.empty",
                            errorTextId: "page.offering.cataloguesTab.table.error",
                            query: queryCatalogs,
                            pagination: pagination,
                            children: [
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b52028b37ea87ec4$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                    id: "page.offering.cataloguesTab.table.name"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                    id: "page.offering.cataloguesTab.table.customer"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                    id: "page.offering.cataloguesTab.table.overview"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                    id: "page.offering.cataloguesTab.table.timestamps"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a3b5a93a68cc46b9$export$2e2bcd8739ae039), {
                                    children: catalogues.map((item)=>/*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                                            onClick: ()=>onClickRow(item),
                                            hover: true,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $041febe0dbc86e0a$export$2e2bcd8739ae039), {
                                                        children: item.name || ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $041febe0dbc86e0a$export$2e2bcd8739ae039), {
                                                        children: item.customer.name
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: offering.type === "WHITELIST" ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a62210b286c7b014$export$4421fe64f84f2e51), {
                                                        offering: offering
                                                    }) : /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a62210b286c7b014$export$5fc72c219969b0e6), {
                                                        amount: item.amount,
                                                        activeRights: item.activeRights
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $601f8b5eb9aad27b$export$2e2bcd8739ae039), {
                                                        createdAt: item.createdAt,
                                                        updatedAt: item.updatedAt,
                                                        dateOnly: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    align: "right",
                                                    children: isPermission("EDIT", "CATALOGUES") && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $041febe0dbc86e0a$export$2e2bcd8739ae039), {
                                                        onClick: (evt)=>{
                                                            evt.stopPropagation();
                                                            setSelectedCatalogueRef(item.id);
                                                        },
                                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                            id: "page.offering.cataloguesTab.table.catalogue.edit"
                                                        })
                                                    })
                                                })
                                            ]
                                        }, item.id))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $82c3788d72d52a76$export$2e2bcd8739ae039), {
                            open: showCreateCatalogueModal,
                            onCancel: ()=>setShowCreateCatalogueModal(false),
                            onSubmit: ()=>{
                                setShowCreateCatalogueModal(false);
                                refreshData();
                            },
                            offering: offering
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $aec05288d0d8220b$export$2e2bcd8739ae039), {
                            open: !!selectedCatalogueRef,
                            onCancel: ()=>setSelectedCatalogueRef(undefined),
                            onSubmit: ()=>{
                                setSelectedCatalogueRef(undefined);
                                refreshData();
                            },
                            catalogue: catalogues.find((item)=>item.id === selectedCatalogueRef),
                            offering: offering
                        })
                    ]
                })
            ]
        })
    });
};
var $c073080e47a48afc$export$2e2bcd8739ae039 = $c073080e47a48afc$var$CataloguesTab;



var $3Py8h = parcelRequire("3Py8h");
parcelRequire("1T1QG");













const $8b9b1861646d870f$var$RightHoldersTab = ({ offering: offering })=>{
    const navigate = (0, $e0cff2801449e77d$export$9770f232ac06a008)();
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const [pagingAndSortValues, setPagingAndSortValues] = (0, $adb860d4c4948aea$export$2e2bcd8739ae039)({
        key: (0, $ec0c9d75a0d3a81a$export$9512f33c9b8e71c5),
        initialValue: (0, $55d02d7b1a5c4f16$export$4bec99d256114e49)("VEHICLE")
    });
    const [searchTerm, setSearchTerm] = (0, $adb860d4c4948aea$export$2e2bcd8739ae039)({
        key: "moovyOfferingRightHoldersSearch",
        initialValue: {
            value: ""
        }
    });
    if (!offering) return null;
    const queryRightHolders = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$9eb9aa3283b45cff),
            offering.id,
            pagingAndSortValues.page,
            pagingAndSortValues.sort,
            searchTerm.value
        ],
        queryFn: ()=>{
            const { page: page, limit: limit, sort: sort, direction: direction } = (0, $55d02d7b1a5c4f16$export$f381863f4c1c052a)(pagingAndSortValues);
            return (0, $6b405f573a8ac986$export$ca807e2054383e2d).getRightHoldersByOffering(offering.id, {
                page: page,
                limit: limit,
                sort: sort,
                direction: direction,
                searchTerm: searchTerm.value
            });
        },
        enabled: searchTerm.value.length >= 3
    });
    const rightHolders = queryRightHolders.data?.data ?? [];
    const pagination = queryRightHolders.data?.pageable ? {
        page: queryRightHolders.data.pageable.page,
        total: queryRightHolders.data.pageable.total,
        limit: queryRightHolders.data.pageable.limit,
        onNextPage: (page)=>setPagingAndSortValues({
                ...pagingAndSortValues,
                page: page.toString()
            })
    } : undefined;
    const onClickRow = (row)=>{
        if (row.individual?.id) navigate(`${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).RIGHT_HOLDERS}/${row.individual?.id || ""}`, {
            state: {
                placeId: row.place?.id,
                placeName: row.place?.name,
                catalogueId: row.catalogueId,
                offeringName: offering.name
            }
        });
        else navigate(`${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).RIGHTS}/${row.id || ""}`);
    };
    const items = (0, $1a49c6a526fe14f2$export$88b06990067e1fdb)(intl, "ACTIVE_RIGHTS").filter((item)=>offering.type !== "WHITELIST" || item.key !== "INDIVIDUAL");
    const isWhitelist = offering.type === "WHITELIST";
    return /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {
                    description: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $76b9dca122479b61$export$2e2bcd8739ae039), {
                                initialSearch: searchTerm.value,
                                onSearch: (newSearchTerm)=>{
                                    setSearchTerm({
                                        value: newSearchTerm
                                    });
                                    setPagingAndSortValues({
                                        ...pagingAndSortValues,
                                        page: 1
                                    });
                                },
                                query: queryRightHolders
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $2e40821b62a7b9dd$export$2e2bcd8739ae039), {
                                filterKey: (0, $ec0c9d75a0d3a81a$export$209a8ef612aeedd2),
                                items: items,
                                value: pagingAndSortValues.sort,
                                onChange: (value)=>{
                                    pagingAndSortValues.sort !== value && setPagingAndSortValues({
                                        ...pagingAndSortValues,
                                        sort: value,
                                        direction: (0, $1a49c6a526fe14f2$export$fcce7887255d1c69)(value)
                                    });
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8002a2b5b87a23eb$export$2e2bcd8739ae039), {
                            emptyTextId: searchTerm.value.length === 0 ? "page.offering.rightHoldersTab.table.search.empty" : "page.offering.rightHoldersTab.table.empty",
                            errorTextId: "page.offering.rightHoldersTab.table.error",
                            query: queryRightHolders,
                            pagination: pagination,
                            children: rightHolders.map((row)=>{
                                const normalContentList = [
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "common.text.email"
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)("b", {
                                        children: row.individual?.email || ""
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "common.text.licensePlate"
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)("b", {
                                        children: row.vehicle?.licensePlate || ""
                                    })
                                ];
                                const commonContentList = [
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "page.catalogues.tabCatalogue.rightHolders.card.header.place"
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)("b", {
                                        children: row.place?.name
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "page.catalogues.tabCatalogue.rightHolders.card.header.validUntil"
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)("b", {
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                                            utcDateTime: row.validityEnd,
                                            emptyText: intl.formatMessage({
                                                id: "page.rightHolders.rightHolder.tab.vehicles.table.item.permanent"
                                            })
                                        })
                                    })
                                ];
                                return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0829f6a75e4b5e7$export$2e2bcd8739ae039), {
                                    cardTitle: isWhitelist ? row.vehicle?.licensePlate || "" : (0, $fb47a354e391b3c4$export$ff20516246215bf)(row.individual?.lastName, row.individual?.firstName),
                                    cardSecondaryTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                                        utcDateTime: row.validityStart
                                    }),
                                    cardContentList: isWhitelist ? commonContentList : [
                                        ...normalContentList,
                                        ...commonContentList
                                    ],
                                    onCardClicked: ()=>onClickRow(row)
                                }, row.id);
                            })
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $c6e866c0d03fba92$export$2e2bcd8739ae039), {
                            items: rightHolders,
                            emptyTextId: searchTerm.value.length === 0 ? "page.offering.rightHoldersTab.table.search.empty" : "page.offering.rightHoldersTab.table.empty",
                            errorTextId: "page.offering.rightHoldersTab.table.error",
                            query: queryRightHolders,
                            pagination: pagination,
                            children: [
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b52028b37ea87ec4$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                                        children: [
                                            !isWhitelist && /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                            id: "page.catalogues.tabCatalogue.rightHolders.table.header.name"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                            id: "common.text.email"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                    id: "common.text.licensePlate"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                    id: "page.catalogues.tabCatalogue.rightHolders.table.header.place"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                    id: "page.offering.rightHoldersTab.table.header.customer"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                    id: "page.catalogues.tabCatalogue.rightHolders.table.header.validFrom"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                    id: "page.catalogues.tabCatalogue.rightHolders.table.header.validUntil"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a3b5a93a68cc46b9$export$2e2bcd8739ae039), {
                                    children: rightHolders.map((row)=>/*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                                            onClick: ()=>onClickRow(row),
                                            hover: true,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: [
                                                !isWhitelist && /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $041febe0dbc86e0a$export$2e2bcd8739ae039), {
                                                                children: (0, $fb47a354e391b3c4$export$ff20516246215bf)(row.individual?.lastName, row.individual?.firstName)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                            children: row.individual?.email || ""
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: row.individual ? row.vehicle?.licensePlate || "" : /*#__PURE__*/ (0, $3Py8h.jsx)((0, $041febe0dbc86e0a$export$2e2bcd8739ae039), {
                                                        children: row.vehicle?.licensePlate || ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: row.place?.name
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: row.customerName
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                                                        utcDateTime: row.validityStart
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                                                        utcDateTime: row.validityEnd,
                                                        emptyText: intl.formatMessage({
                                                            id: "page.rightHolders.rightHolder.tab.vehicles.table.item.permanent"
                                                        })
                                                    })
                                                })
                                            ]
                                        }, row.id))
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $8b9b1861646d870f$export$2e2bcd8739ae039 = $8b9b1861646d870f$var$RightHoldersTab;




var $3Py8h = parcelRequire("3Py8h");




var $1T1QG = parcelRequire("1T1QG");



var $3Py8h = parcelRequire("3Py8h");





var $eUHG3 = parcelRequire("eUHG3");



parcelRequire("1T1QG");
const $9d5c6828c203d966$var$ModalEditOffering = ({ open: open, onCancel: onCancel, onSubmit: onSubmit, offering: offering })=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const FORM_REFERENCE = "formEditOffering";
    const queryClient = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)();
    const mutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $6b405f573a8ac986$export$ca807e2054383e2d).updateOffering(offering?.id ?? "", offering?.placeId ?? "", dto),
        onSuccess: ()=>{
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.offering.modalEditOffering.mutation.success"
            }));
            onSubmit();
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $ec0c9d75a0d3a81a$export$79b5a04d4c49a4e2),
                    offering?.id
                ]
            });
        }
    });
    const schema = $d7c41ae3ced691f5$export$be5493f9613cbbe().shape({
        amount: $d7c41ae3ced691f5$export$98e628dec113755e().min(0, intl.formatMessage({
            id: "page.offering.modalEditOffering.amount.minimum"
        })).required(intl.formatMessage({
            id: "common.form.errors.empty"
        })).typeError(intl.formatMessage({
            id: "common.form.errors.number"
        }))
    });
    const submitHandler = (values)=>{
        if (values?.amount) return mutation.mutate({
            amount: Number.parseInt(values.amount)
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $259d9dbb3544503a$export$2e2bcd8739ae039), {
        open: open,
        modalTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
            id: "page.offering.modalEditOffering.title"
        }),
        submitButtonContent: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
            id: "common.buttons.save"
        }),
        onCancel: onCancel,
        formReference: FORM_REFERENCE,
        mutation: mutation,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $eUHG3.Formik), {
            enableReinitialize: true,
            validateOnChange: false,
            initialValues: {
                amount: offering?.amount ? "" + offering.amount : ""
            },
            validationSchema: schema,
            onSubmit: (values)=>submitHandler(values),
            children: ({ handleSubmit: handleSubmit, handleChange: handleChange, values: values, errors: errors })=>/*#__PURE__*/ (0, $3Py8h.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: FORM_REFERENCE,
                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.offering.modalEditOffering.product"
                                })
                            }),
                            offering?.name,
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.offering.modalEditOffering.amountLabel"
                                })
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                name: "amount",
                                value: values.amount,
                                onChange: handleChange,
                                error: !!errors.amount,
                                errorText: errors.amount,
                                sx: {
                                    minWidth: "50%"
                                }
                            })
                        ]
                    })
                })
        })
    });
};
var $9d5c6828c203d966$export$2e2bcd8739ae039 = $9d5c6828c203d966$var$ModalEditOffering;






const $0408f364b406735b$var$OfferingInfo = ({ queryOffering: queryOffering })=>{
    const [showModal, setShowModal] = (0, $1T1QG.useState)(false);
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const { tenant: tenant } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const offering = queryOffering.data;
    const queryPlace = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$823cd27a3f5f229e),
            offering?.placeId
        ],
        queryFn: ()=>(0, $f7802c761d4f9d37$export$2bffccb0f948be1f).getPlaceByRef(offering?.placeId || ""),
        enabled: !!offering,
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const place = queryPlace.data;
    const lastItem = offering?.name || "";
    const customBreadcrumbs = {
        lastBreadcrumb: lastItem,
        customBreadcrumbs: !tenant ? [
            {
                route: `${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES}/${place?.id}`,
                name: place?.name || ""
            }
        ] : undefined
    };
    const isWhitelist = offering?.type === "WHITELIST";
    const isEditable = !isWhitelist && !offering?.ignoreAmountForCatalogue;
    const { name: name, summary: summary, amount: amount } = offering ?? {};
    const defaultValues = {
        offeringName: name || "",
        placeName: place?.name || "",
        amount: offering?.ignoreAmountForCatalogue ? intl.formatMessage({
            id: "page.offering.offeringInfo.ignoreAmountLimits"
        }) : amount,
        cataloguesAmount: isWhitelist ? summary?.catalogues : (0, $fb47a354e391b3c4$export$ec9646ddc27ee461)(summary?.cataloguesTotalAmount || 0, summary?.catalogues || 0, true)
    };
    const data = [
        {
            label: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.offering.offeringInfo.name"
            }),
            value: `${defaultValues.offeringName}`
        },
        {
            label: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.offering.offeringInfo.location"
            }),
            value: `${defaultValues?.placeName}`
        },
        {
            label: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.offering.offeringInfo.catalogues.amount"
            }),
            value: `${defaultValues.cataloguesAmount}`
        }
    ];
    if (!isWhitelist) data.push({
        label: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
            id: "page.offering.offeringInfo.maximumAmount"
        }),
        value: `${defaultValues.amount}`
    });
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $d853676d11a33bb6$export$2e2bcd8739ae039), {
                        breadcrumbs: customBreadcrumbs,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {
                        title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "page.offering.offeringInfo.title"
                        }),
                        button: isEditable ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $15827f0d92c5ff99$export$2e2bcd8739ae039), {
                            action: "EDIT",
                            resource: "OFFERING",
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                                startIcon: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e631bbd3618e6888$exports))), {}),
                                onClick: ()=>setShowModal(true),
                                showAsIconButton: true,
                                "aria-label": intl.formatMessage({
                                    id: "page.offering.button.edit"
                                })
                            })
                        }) : undefined,
                        divider: true
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $836e912fb2b7fc60$export$2e2bcd8739ae039), {
                            data: data
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $9d5c6828c203d966$export$2e2bcd8739ae039), {
                open: showModal,
                offering: offering,
                onSubmit: ()=>{
                    setShowModal(false);
                },
                onCancel: ()=>setShowModal(false)
            })
        ]
    });
};
var $0408f364b406735b$export$2e2bcd8739ae039 = $0408f364b406735b$var$OfferingInfo;



parcelRequire("1T1QG");




const $a5656f0c2191a9bc$var$Offering = ()=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const { offeringId: offeringId } = (0, $e0cff2801449e77d$export$99eaa27ddbbb95ef)();
    const queryOffering = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$79b5a04d4c49a4e2),
            offeringId
        ],
        queryFn: ()=>(0, $6b405f573a8ac986$export$ca807e2054383e2d).getOfferingById(offeringId || ""),
        enabled: !!offeringId,
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b914262cfd70d60a$export$2e2bcd8739ae039), {
        query: queryOffering,
        rootPageIfNotFoundError: true,
        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
            container: true,
            spacing: 2,
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c9560da3d4f68f59$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $0408f364b406735b$export$2e2bcd8739ae039), {
                        queryOffering: queryOffering
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $752b2919b820e82b$export$2e2bcd8739ae039), {
                                tabKey: (0, $5f8ca62b06e02682$export$52484cb0e4bee674),
                                tabHeaders: [
                                    intl.formatMessage({
                                        id: "page.offering.cataloguesTab.header"
                                    }),
                                    intl.formatMessage({
                                        id: "page.offering.rightHoldersTab.header"
                                    })
                                ],
                                tabPanels: [
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c073080e47a48afc$export$2e2bcd8739ae039), {
                                        offering: queryOffering.data
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8b9b1861646d870f$export$2e2bcd8739ae039), {
                                        offering: queryOffering.data
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};
var $a5656f0c2191a9bc$export$2e2bcd8739ae039 = $a5656f0c2191a9bc$var$Offering;



var $3Py8h = parcelRequire("3Py8h");





var $1T1QG = parcelRequire("1T1QG");





var $3Py8h = parcelRequire("3Py8h");








const $34e5b2af2e88977e$var$ModalAddPlace = (props)=>{
    const FORM_REFERENCE = "formAddPlace";
    const { admin: admin } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const queryCustomers = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$6efe1800fcda6819)
        ],
        // TODO Antti: Should be fixed later because there might be more than 500 customers.
        // Anyway, this code is not in use so far because UI does not support adding sub places
        queryFn: ()=>admin ? (0, $3af058eac12e21cb$export$2e2bcd8739ae039).getLandlords(true, {
                limit: 500
            }) : (0, $3af058eac12e21cb$export$2e2bcd8739ae039).getCustomers(false, {
                limit: 500
            }),
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const customers = queryCustomers.data?.data || [];
    const createPlaceMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $f7802c761d4f9d37$export$2bffccb0f948be1f).createPlaceWithDefaultOffering(dto),
        onSuccess: (response)=>{
            const place = response.data || {};
            props.onSubmit(place);
        }
    });
    const createPlace = (values)=>{
        const { name: name, streetAddress: streetAddress, postalCode: postalCode, city: city, capacity: capacity, customerId: customerId } = values;
        const dto = {
            name: name,
            streetAddress: streetAddress,
            postalCode: postalCode,
            city: city,
            customerId: customerId,
            capacity: Number.parseInt(capacity)
        };
        createPlaceMutation.mutate(dto);
    };
    const cancel = ()=>{
        createPlaceMutation.reset();
        props.onCancel();
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $259d9dbb3544503a$export$2e2bcd8739ae039), {
            open: props.open,
            onCancel: cancel,
            formReference: FORM_REFERENCE,
            errorTitleKey: "common.actions.add.error",
            modalTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.places.modalAddPlace.title"
            }),
            submitButtonContent: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.places.modalAddPlace.button.add"
            }),
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $019112675a75b38b$export$2e2bcd8739ae039), {
                    mutation: createPlaceMutation,
                    errorTitleKey: "common.actions.add.error"
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $cf2338fcccf655cb$export$2e2bcd8739ae039), {
                    onSubmit: (values)=>createPlace(values),
                    formReference: FORM_REFERENCE,
                    customers: customers
                })
            ]
        })
    });
};
var $34e5b2af2e88977e$export$2e2bcd8739ae039 = $34e5b2af2e88977e$var$ModalAddPlace;








const $23e8e531a9995def$var$Places = ()=>{
    const navigate = (0, $e0cff2801449e77d$export$9770f232ac06a008)();
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const queryClient = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)();
    const { setCustomer: setCustomer, customer: customer, setPlace: setPlace } = (0, $a48e808e68b0e5f9$export$2e2bcd8739ae039)();
    const [showModalAdd, setShowModalAdd] = (0, $1T1QG.useState)(false);
    const [pagingAndSortValues, setPagingAndSortValues] = (0, $adb860d4c4948aea$export$2e2bcd8739ae039)({
        key: (0, $5f8ca62b06e02682$export$fc22b6fdc7ebba93),
        initialValue: (0, $55d02d7b1a5c4f16$export$4bec99d256114e49)("NAME")
    });
    const queryPlaces = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$d6da98a467d609dc),
            pagingAndSortValues.page,
            pagingAndSortValues.sort
        ],
        queryFn: ()=>{
            const { page: page, limit: limit, sort: sort, direction: direction } = (0, $55d02d7b1a5c4f16$export$f381863f4c1c052a)(pagingAndSortValues);
            return (0, $f7802c761d4f9d37$export$17a026f5eed4231).getPlaces({
                page: page,
                limit: limit,
                sort: sort,
                direction: direction
            });
        },
        enabled: !!customer?.id,
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const places = queryPlaces.data?.data || [];
    const pagination = queryPlaces.data?.pageable ? {
        page: queryPlaces.data.pageable.page,
        total: queryPlaces.data.pageable.total,
        limit: queryPlaces.data.pageable.limit,
        onNextPage: (page)=>setPagingAndSortValues({
                ...pagingAndSortValues,
                page: page.toString()
            })
    } : undefined;
    const items = (0, $1a49c6a526fe14f2$export$88b06990067e1fdb)(intl, "PLACES");
    const onClickRow = (place)=>{
        setPlace(place);
        setCustomer(place.customer);
        navigate(`${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES}/${place.id}`);
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c9560da3d4f68f59$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
                loading: queryPlaces.isPending,
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $d853676d11a33bb6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "page.places.list.title"
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {
                        action: "CREATE",
                        resource: "PLACES",
                        button: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                            onClick: ()=>setShowModalAdd(true),
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                id: "page.places.list.button.newPlace"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $2e40821b62a7b9dd$export$2e2bcd8739ae039), {
                                filterKey: (0, $5f8ca62b06e02682$export$a9c7fdd2cd34e65d),
                                items: items,
                                value: pagingAndSortValues.sort,
                                onChange: (value)=>{
                                    pagingAndSortValues.sort !== value && setPagingAndSortValues({
                                        ...pagingAndSortValues,
                                        sort: value,
                                        direction: (0, $1a49c6a526fe14f2$export$fcce7887255d1c69)(value)
                                    });
                                },
                                pt: 2,
                                pb: 2
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8002a2b5b87a23eb$export$2e2bcd8739ae039), {
                                emptyTextId: "page.places.list.table.action.empty",
                                errorTextId: "page.places.list.table.action.failed",
                                query: queryPlaces,
                                pagination: pagination,
                                children: places.map((row)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0829f6a75e4b5e7$export$2e2bcd8739ae039), {
                                        cardTitle: row.name,
                                        cardSecondaryTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                                            utcDateTime: row.createdAt
                                        }),
                                        cardContentList: [
                                            row.streetAddress,
                                            row.postalCode,
                                            row.city,
                                            row.customer?.name ?? ""
                                        ],
                                        onCardClicked: ()=>onClickRow(row)
                                    }, row.id))
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $c6e866c0d03fba92$export$2e2bcd8739ae039), {
                                items: places,
                                emptyTextId: "page.places.list.table.action.empty",
                                errorTextId: "page.places.list.table.action.failed",
                                query: queryPlaces,
                                pagination: pagination,
                                children: [
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b52028b37ea87ec4$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                        id: "page.places.list.table.header.name"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                        id: "page.places.list.table.header.streetAddress"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                        id: "page.places.list.table.header.postalCode"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                        id: "page.places.list.table.header.city"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                        id: "page.places.list.table.header.capacity"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                        id: "page.places.list.table.header.customer"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a3b5a93a68cc46b9$export$2e2bcd8739ae039), {
                                        "data-testid": "places-table-body",
                                        children: places.map((row)=>/*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                                                onClick: ()=>onClickRow(row),
                                                hover: true,
                                                sx: {
                                                    cursor: "pointer"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $041febe0dbc86e0a$export$2e2bcd8739ae039), {
                                                            bold: true,
                                                            children: row.name
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                        children: row.streetAddress
                                                    }),
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                        children: row.postalCode
                                                    }),
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                        children: row.city
                                                    }),
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                        children: row.capacity
                                                    }),
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                        children: row.customer?.name
                                                    })
                                                ]
                                            }, row.id))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $34e5b2af2e88977e$export$2e2bcd8739ae039), {
                open: showModalAdd,
                onSubmit: (response)=>{
                    setShowModalAdd(false);
                    (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                        id: "page.places.list.actions.added",
                        values: {
                            name: response.name
                        }
                    }));
                    queryClient.invalidateQueries({
                        queryKey: [
                            (0, $ec0c9d75a0d3a81a$export$d6da98a467d609dc)
                        ]
                    });
                },
                onCancel: ()=>setShowModalAdd(false)
            })
        ]
    });
};
var $23e8e531a9995def$export$2e2bcd8739ae039 = $23e8e531a9995def$var$Places;



var $3Py8h = parcelRequire("3Py8h");




var $1T1QG = parcelRequire("1T1QG");



var $3Py8h = parcelRequire("3Py8h");






const $b94dc6a908aaa7dd$var$ModalEditPlace = (props)=>{
    const FORM_REFERENCE = "formUpdatePlace";
    const { defaultValues: defaultValues } = props;
    const updatePlaceMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $f7802c761d4f9d37$export$2bffccb0f948be1f).updatePlace(props.editablePlaceRef, dto),
        onSuccess: (response)=>{
            props.onSubmit(response.data);
        }
    });
    const updatePlace = (values)=>{
        const { name: name, streetAddress: streetAddress, postalCode: postalCode, city: city } = values;
        // Note, capacity cannot be modify
        const dto = {
            name: (0, $fb47a354e391b3c4$export$b9d2d3b623c012b1)(name, defaultValues.name),
            streetAddress: (0, $fb47a354e391b3c4$export$b9d2d3b623c012b1)(streetAddress, defaultValues.streetAddress),
            postalCode: (0, $fb47a354e391b3c4$export$b9d2d3b623c012b1)(postalCode, defaultValues.postalCode),
            city: (0, $fb47a354e391b3c4$export$b9d2d3b623c012b1)(city, defaultValues.city)
        };
        if ((0, $fb47a354e391b3c4$export$8f98ff223296ded9)(dto)) updatePlaceMutation.mutate(dto);
    };
    const cancel = ()=>{
        updatePlaceMutation.reset();
        props.onCancel();
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $259d9dbb3544503a$export$2e2bcd8739ae039), {
            open: props.open,
            onCancel: cancel,
            formReference: FORM_REFERENCE,
            errorTitleKey: "common.actions.add.error",
            modalTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.place.modalEditPlace.title"
            }),
            submitButtonContent: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "common.buttons.save"
            }),
            mutation: updatePlaceMutation,
            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $cf2338fcccf655cb$export$2e2bcd8739ae039), {
                showTitle: true,
                onSubmit: (values)=>{
                    updatePlace(values);
                },
                formReference: FORM_REFERENCE,
                defaultValues: defaultValues,
                editView: true,
                customers: []
            })
        })
    });
};
var $b94dc6a908aaa7dd$export$2e2bcd8739ae039 = $b94dc6a908aaa7dd$var$ModalEditPlace;




var $3Py8h = parcelRequire("3Py8h");




var $1T1QG = parcelRequire("1T1QG");

var $07c00fccf25e2fa6$exports = {};
"use strict";
"use client";

Object.defineProperty($07c00fccf25e2fa6$exports, "__esModule", {
    value: true
});
$07c00fccf25e2fa6$exports.default = void 0;

var $07c00fccf25e2fa6$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $07c00fccf25e2fa6$var$_default = $07c00fccf25e2fa6$exports.default = (0, $07c00fccf25e2fa6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M20 12c0-.76.43-1.42 1.06-1.76.6-.33.94-1.01.94-1.7V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.89-1.99 1.99v2.55c0 .69.33 1.37.94 1.69C3.58 10.58 4 11.24 4 12s-.43 1.43-1.06 1.76c-.6.33-.94 1.01-.94 1.7V18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-2.54c0-.69-.34-1.37-.94-1.7-.63-.34-1.06-1-1.06-1.76m-5.5 4.1L12 14.5l-2.5 1.61c-.38.24-.87-.11-.75-.55l.75-2.88-2.3-1.88c-.35-.29-.17-.86.29-.89l2.96-.17 1.08-2.75c.17-.42.77-.42.93 0l1.08 2.76 2.96.17c.45.03.64.6.29.89l-2.3 1.88.76 2.86c.12.45-.37.8-.75.55"
}), "LocalActivityRounded");



var $3Py8h = parcelRequire("3Py8h");





var $eUHG3 = parcelRequire("eUHG3");



parcelRequire("1T1QG");
const $836a6cb169cccddf$var$ModalEditOffering = ({ open: open, onCancel: onCancel, onSubmit: onSubmit, offering: offering })=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const FORM_REFERENCE = "formEditOffering";
    const queryClient = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)();
    const mutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $6b405f573a8ac986$export$ca807e2054383e2d).updateOffering(offering?.id ?? "", offering?.placeId ?? "", dto),
        onSuccess: ()=>{
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.offering.modalEditOffering.mutation.success"
            }));
            onSubmit();
            queryClient.invalidateQueries({
                queryKey: [
                    (0, $ec0c9d75a0d3a81a$export$70a73d059c6beff0),
                    offering?.placeId
                ]
            });
        }
    });
    const schema = $d7c41ae3ced691f5$export$be5493f9613cbbe().shape({
        amount: $d7c41ae3ced691f5$export$98e628dec113755e().min(0, intl.formatMessage({
            id: "page.offering.modalEditOffering.amount.minimum"
        })).required(intl.formatMessage({
            id: "common.form.errors.empty"
        })).typeError(intl.formatMessage({
            id: "common.form.errors.number"
        }))
    });
    const submitHandler = (values)=>{
        if (values?.amount) return mutation.mutate({
            amount: Number.parseInt(values.amount)
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $259d9dbb3544503a$export$2e2bcd8739ae039), {
        open: open,
        modalTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
            id: "page.offering.modalEditOffering.title"
        }),
        submitButtonContent: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
            id: "common.buttons.save"
        }),
        onCancel: onCancel,
        formReference: FORM_REFERENCE,
        mutation: mutation,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $eUHG3.Formik), {
            enableReinitialize: true,
            validateOnChange: false,
            initialValues: {
                amount: offering?.amount ? "" + offering.amount : ""
            },
            validationSchema: schema,
            onSubmit: (values)=>submitHandler(values),
            children: ({ handleSubmit: handleSubmit, handleChange: handleChange, values: values, errors: errors })=>/*#__PURE__*/ (0, $3Py8h.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: FORM_REFERENCE,
                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.offering.modalEditOffering.product"
                                })
                            }),
                            offering?.name,
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTitle, {
                                title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.offering.modalEditOffering.amountLabel"
                                })
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                name: "amount",
                                value: values.amount,
                                onChange: handleChange,
                                error: !!errors.amount,
                                errorText: errors.amount,
                                sx: {
                                    minWidth: "50%"
                                }
                            })
                        ]
                    })
                })
        })
    });
};
var $836a6cb169cccddf$export$2e2bcd8739ae039 = $836a6cb169cccddf$var$ModalEditOffering;



var $7fb629d17ade657c$exports = {};
"use strict";
"use client";

Object.defineProperty($7fb629d17ade657c$exports, "__esModule", {
    value: true
});
$7fb629d17ade657c$exports.default = void 0;

var $7fb629d17ade657c$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $7fb629d17ade657c$var$_default = $7fb629d17ade657c$exports.default = (0, $7fb629d17ade657c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M22 14c0-1.95-1.4-3.57-3.25-3.92L17.4 6.05C17 4.82 15.85 4 14.56 4H9.44C8.15 4 7 4.82 6.6 6.05L5.81 8.4 4.41 7l.29-.29c.39-.39.39-1.02 0-1.41a.9959.9959 0 0 0-1.41 0l-2 2c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l.3-.3 1.79 1.79C3.18 10.72 2 12.22 2 14c0 1.5.83 2.79 2.05 3.48C4.28 18.9 5.51 20 7 20c1.3 0 2.4-.84 2.82-2h4.37c.41 1.16 1.51 2 2.82 2 1.49 0 2.72-1.1 2.95-2.52C21.17 16.79 22 15.5 22 14M7 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m4-8H7.41l-.02-.02 1.1-3.3c.14-.41.52-.68.95-.68H11zm2-4h1.56c.43 0 .81.27.95.68l1.1 3.32H13zm4 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1"
}), "ToysRounded");





const $d374c63f0a1a46fd$var$OfferingsTab = ({ placeId: placeId, queryOfferings: queryOfferings })=>{
    const navigate = (0, $e0cff2801449e77d$export$9770f232ac06a008)();
    const { isPermission: isPermission } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const queryClient = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)();
    const [showOfferingModal, setShowOfferingModal] = (0, $1T1QG.useState)(undefined);
    const offerings = queryOfferings.data || [];
    const onClickRow = (item)=>{
        navigate(`${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).OFFERINGS}/${item.id}`);
    };
    const refreshData = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $ec0c9d75a0d3a81a$export$70a73d059c6beff0),
                placeId
            ]
        });
    };
    const isWhitelist = (offering)=>{
        return offering.type === "WHITELIST";
    };
    const isEditable = (offering)=>{
        return isPermission("EDIT", "OFFERING") && !isWhitelist(offering) && !offering.ignoreAmountForCatalogue;
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b914262cfd70d60a$export$2e2bcd8739ae039), {
        query: queryOfferings,
        rootPageIfNotFoundError: true,
        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {
                    description: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                        id: "page.place.offeringsTab.infoText1"
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8002a2b5b87a23eb$export$2e2bcd8739ae039), {
                            emptyTextId: "page.place.offeringsTab.table.empty",
                            errorTextId: "page.place.offeringsTab.table.error",
                            query: queryOfferings,
                            children: offerings.map((offering)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0829f6a75e4b5e7$export$2e2bcd8739ae039), {
                                    onCardClicked: ()=>onClickRow(offering),
                                    cardTitle: offering.name ?? "",
                                    cardSecondaryTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                                        utcDateTime: offering.createdAt,
                                        dateOnly: true
                                    }),
                                    cardMenuActions: isEditable(offering) ? [
                                        {
                                            itemText: intl.formatMessage({
                                                id: "page.place.offeringsTab.table.offering.edit"
                                            }),
                                            onClick: ()=>setShowOfferingModal(offering)
                                        }
                                    ] : undefined,
                                    cardContentList: [
                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a62210b286c7b014$export$4421fe64f84f2e51), {
                                            offering: offering
                                        })
                                    ]
                                }, offering.id))
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $c6e866c0d03fba92$export$2e2bcd8739ae039), {
                            items: offerings,
                            emptyTextId: "page.place.offeringsTab.table.empty",
                            errorTextId: "page.place.offeringsTab.table.error",
                            query: queryOfferings,
                            children: [
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b52028b37ea87ec4$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                    id: "page.place.offeringsTab.table.product"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                    id: "page.place.offeringsTab.table.overview"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                    id: "page.place.offeringsTab.table.timestamps"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a3b5a93a68cc46b9$export$2e2bcd8739ae039), {
                                    children: offerings.map((offering)=>/*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                                            onClick: ()=>onClickRow(offering),
                                            hover: true,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        children: [
                                                            isWhitelist(offering) ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fb629d17ade657c$exports))), {
                                                                style: {
                                                                    marginRight: "1rem"
                                                                }
                                                            }) : /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($07c00fccf25e2fa6$exports))), {
                                                                style: {
                                                                    marginRight: "1rem"
                                                                }
                                                            }),
                                                            offering.name
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a62210b286c7b014$export$4421fe64f84f2e51), {
                                                        offering: offering
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $601f8b5eb9aad27b$export$2e2bcd8739ae039), {
                                                        createdAt: offering.createdAt,
                                                        updatedAt: offering.updatedAt,
                                                        dateOnly: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                                    align: "right",
                                                    children: isEditable(offering) && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $041febe0dbc86e0a$export$2e2bcd8739ae039), {
                                                        onClick: (evt)=>{
                                                            evt.stopPropagation();
                                                            setShowOfferingModal(offering);
                                                        },
                                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                            id: "page.place.offeringsTab.table.offering.edit"
                                                        })
                                                    })
                                                })
                                            ]
                                        }, offering.id))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $836a6cb169cccddf$export$2e2bcd8739ae039), {
                            open: !!showOfferingModal,
                            onCancel: ()=>setShowOfferingModal(undefined),
                            onSubmit: ()=>{
                                setShowOfferingModal(undefined);
                                refreshData();
                            },
                            offering: showOfferingModal
                        })
                    ]
                })
            ]
        })
    });
};
var $d374c63f0a1a46fd$export$2e2bcd8739ae039 = $d374c63f0a1a46fd$var$OfferingsTab;



var $3Py8h = parcelRequire("3Py8h");




const $56697a7be51198e7$var$PlaceInformation = ({ loading: loading, place: place, offeringAmount: offeringAmount, onEdit: onEdit })=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const data = [
        {
            label: intl.formatMessage({
                id: "page.placeRights.placeInformation.address"
            }),
            value: `${(0, $fb47a354e391b3c4$export$ff20516246215bf)(place?.streetAddress, place?.postalCode, ", ")} ${place?.city}`
        },
        {
            label: intl.formatMessage({
                id: "page.placeRights.placeInformation.capacity"
            }),
            value: place?.capacity
        },
        {
            label: intl.formatMessage({
                id: "page.placeRights.placeInformation.offeringAmount"
            }),
            value: (0, $fb47a354e391b3c4$export$ec9646ddc27ee461)(place?.capacity || 0, offeringAmount)
        }
    ];
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
        loading: loading,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "page.placeRights.placeInformation.header"
                }),
                button: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $15827f0d92c5ff99$export$2e2bcd8739ae039), {
                    action: "EDIT",
                    resource: "PLACES",
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                        startIcon: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e631bbd3618e6888$exports))), {}),
                        onClick: onEdit,
                        showAsIconButton: true,
                        "aria-label": intl.formatMessage({
                            id: "page.placeRights.placeInformation.button.edit"
                        })
                    })
                }),
                divider: true
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $836e912fb2b7fc60$export$2e2bcd8739ae039), {
                    data: data
                })
            })
        ]
    });
};
var $56697a7be51198e7$export$2e2bcd8739ae039 = $56697a7be51198e7$var$PlaceInformation;





var $3Py8h = parcelRequire("3Py8h");




const $4bedc645fdd667e2$var$SituationOverview = ({ parkingEnforcement: parkingEnforcement, isLoading: isLoading, cataloguesTotal: cataloguesTotal, capacity: capacity })=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const data = [
        {
            label: intl.formatMessage({
                id: "page.placeRights.situationOverview.totalAmount"
            }),
            value: capacity && cataloguesTotal && (0, $fb47a354e391b3c4$export$ec9646ddc27ee461)(capacity, cataloguesTotal)
        },
        {
            label: intl.formatMessage({
                id: "page.placeRights.situationOverview.parkingEnforcement"
            }),
            value: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c76a66d914cee346$export$2e2bcd8739ae039), {
                parkingEnforcement: parkingEnforcement
            })
        }
    ];
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
        loading: isLoading,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "page.placeRights.situationOverview.header"
                }),
                button: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                    startIcon: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e631bbd3618e6888$exports))), {}),
                    showAsIconButton: true,
                    "aria-label": "",
                    hidden: true
                }),
                divider: true
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $836e912fb2b7fc60$export$2e2bcd8739ae039), {
                    splitByMiddle: true,
                    data: data,
                    breakpoint: "lg"
                })
            })
        ]
    });
};
var $4bedc645fdd667e2$export$2e2bcd8739ae039 = $4bedc645fdd667e2$var$SituationOverview;




const $45308713f7e2553b$var$Place = ()=>{
    const queryClient = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)();
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const { placeRef: placeRef } = (0, $e0cff2801449e77d$export$99eaa27ddbbb95ef)();
    const { place: place, setPlace: setPlace } = (0, $a48e808e68b0e5f9$export$2e2bcd8739ae039)();
    const [showPlaceModal, setShowPlaceModal] = (0, $1T1QG.useState)(false);
    const queryPlace = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$823cd27a3f5f229e),
            placeRef
        ],
        queryFn: ()=>(0, $f7802c761d4f9d37$export$2bffccb0f948be1f).getPlaceByRef(placeRef || ""),
        enabled: !!placeRef,
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const queryOfferings = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$70a73d059c6beff0),
            placeRef
        ],
        queryFn: ()=>(0, $f7802c761d4f9d37$export$2bffccb0f948be1f).getOfferingsByPlace(placeRef || ""),
        enabled: !!placeRef,
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const defaultPlaceData = {
        name: queryPlace.data?.name || "",
        streetAddress: queryPlace.data?.streetAddress || "",
        postalCode: queryPlace.data?.postalCode || "",
        city: queryPlace.data?.city || "",
        capacity: queryPlace.data?.capacity?.toString() || "",
        customerId: queryPlace.data?.customer?.id || ""
    };
    const isParkingEnforcement = !!queryPlace.data?.parkingEnforcementZoneId;
    const normalOfferings = queryOfferings.data ? queryOfferings.data.filter((item)=>item.type !== "WHITELIST") : [];
    const cataloguesTotal = normalOfferings?.map((item)=>item.summary.cataloguesTotalAmount).reduce((accumulator, current)=>accumulator + current, 0);
    const offeringsTotal = normalOfferings.reduce((accumulator, offering)=>accumulator + offering.amount, 0);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b914262cfd70d60a$export$2e2bcd8739ae039), {
        query: queryPlace,
        rootPageIfNotFoundError: true,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c9560da3d4f68f59$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3Py8h.jsx)("h1", {
                children: place?.name
            }),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                        item: true,
                        md: 6,
                        xs: 12,
                        children: queryPlace.error || queryOfferings.error ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $019112675a75b38b$export$2e2bcd8739ae039), {
                            errorTitleKey: "common.actions.get.error",
                            query: queryPlace.isError ? queryPlace : queryOfferings
                        }) : /*#__PURE__*/ (0, $3Py8h.jsx)((0, $56697a7be51198e7$export$2e2bcd8739ae039), {
                            loading: queryPlace.isPending || queryOfferings.isPending,
                            place: queryPlace.data,
                            offeringAmount: offeringsTotal,
                            onEdit: ()=>setShowPlaceModal(true)
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                        item: true,
                        md: 6,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $019112675a75b38b$export$2e2bcd8739ae039), {
                                errorTitleKey: "common.actions.get.error",
                                query: queryPlace
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4bedc645fdd667e2$export$2e2bcd8739ae039), {
                                parkingEnforcement: isParkingEnforcement,
                                isLoading: queryPlace.isPending,
                                capacity: queryPlace.data?.capacity,
                                cataloguesTotal: cataloguesTotal
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $752b2919b820e82b$export$2e2bcd8739ae039), {
                                    tabKey: (0, $5f8ca62b06e02682$export$bf153b52ae22c83c),
                                    tabHeaders: [
                                        intl.formatMessage({
                                            id: "page.place.offeringsTab.header"
                                        })
                                    ],
                                    tabPanels: [
                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $d374c63f0a1a46fd$export$2e2bcd8739ae039), {
                                            queryOfferings: queryOfferings,
                                            placeId: placeRef || ""
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b94dc6a908aaa7dd$export$2e2bcd8739ae039), {
                        open: showPlaceModal,
                        editablePlaceRef: placeRef || "",
                        defaultValues: defaultPlaceData,
                        onSubmit: (response)=>{
                            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                id: "page.place.actions.updated",
                                values: {
                                    name: response?.name
                                }
                            }));
                            setShowPlaceModal(false);
                            response && response.id === place.id && setPlace(response);
                            queryClient.invalidateQueries({
                                queryKey: [
                                    (0, $ec0c9d75a0d3a81a$export$823cd27a3f5f229e),
                                    placeRef
                                ]
                            });
                            queryClient.invalidateQueries({
                                queryKey: [
                                    (0, $ec0c9d75a0d3a81a$export$d6da98a467d609dc)
                                ]
                            });
                        },
                        onCancel: ()=>setShowPlaceModal(false)
                    })
                ]
            })
        ]
    });
};
var $45308713f7e2553b$export$2e2bcd8739ae039 = $45308713f7e2553b$var$Place;



var $3Py8h = parcelRequire("3Py8h");






var $1T1QG = parcelRequire("1T1QG");





var $1T1QG = parcelRequire("1T1QG");



var $gADeF = parcelRequire("gADeF");



var $1T1QG = parcelRequire("1T1QG");

var $ajKsV = parcelRequire("ajKsV");







const $f9f8b7eb6ed3aac2$export$b0d0c72cc357b4dd = (sections)=>{
    const startDateSections = [];
    const endDateSections = [];
    sections.forEach((section)=>{
        if (section.dateName === "start") startDateSections.push(section);
        else endDateSections.push(section);
    });
    return {
        startDate: startDateSections,
        endDate: endDateSections
    };
};
const $f9f8b7eb6ed3aac2$export$927f12730cacf7f9 = (dateSections)=>dateSections.map((section, sectionIndex)=>{
        if (sectionIndex === dateSections.length - 1) return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, section, {
            separator: null
        });
        return section;
    });


const $f59e62e9d03b263b$var$_excluded = [
    "value",
    "referenceDate"
];
const $f59e62e9d03b263b$export$f0e1e223b0d1e9e1 = {
    emptyValue: [
        null,
        null
    ],
    getTodayValue: (utils, timezone, valueType)=>[
            (0, $2c8437f6b047f676$export$1118e4272ea1e258)(utils, timezone, valueType),
            (0, $2c8437f6b047f676$export$1118e4272ea1e258)(utils, timezone, valueType)
        ],
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDateProp } = _ref, params = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_ref, $f59e62e9d03b263b$var$_excluded);
        const shouldKeepStartDate = value[0] != null && params.utils.isValid(value[0]);
        const shouldKeepEndDate = value[1] != null && params.utils.isValid(value[1]);
        if (shouldKeepStartDate && shouldKeepEndDate) return value;
        const referenceDate = referenceDateProp ?? (0, $101a7d0ae47539cf$export$6a31d56794238e4e)(params);
        return [
            shouldKeepStartDate ? value[0] : referenceDate,
            shouldKeepEndDate ? value[1] : referenceDate
        ];
    },
    cleanValue: (utils, value)=>value.map((date)=>(0, $2c8437f6b047f676$export$36ca889e039badd5)(utils, date)),
    areValuesEqual: (utils, a, b)=>(0, $2c8437f6b047f676$export$8fabf9a4cbada414)(utils, a[0], b[0]) && (0, $2c8437f6b047f676$export$8fabf9a4cbada414)(utils, a[1], b[1]),
    isSameError: (a, b)=>b !== null && a[1] === b[1] && a[0] === b[0],
    hasError: (error)=>error[0] != null || error[1] != null,
    defaultErrorState: [
        null,
        null
    ],
    getTimezone: (utils, value)=>{
        const timezoneStart = value[0] == null || !utils.isValid(value[0]) ? null : utils.getTimezone(value[0]);
        const timezoneEnd = value[1] == null || !utils.isValid(value[1]) ? null : utils.getTimezone(value[1]);
        if (timezoneStart != null && timezoneEnd != null && timezoneStart !== timezoneEnd) throw new Error("MUI X: The timezone of the start and the end date should be the same.");
        return timezoneStart ?? timezoneEnd;
    },
    setTimezone: (utils, timezone, value)=>[
            value[0] == null ? null : utils.setTimezone(value[0], timezone),
            value[1] == null ? null : utils.setTimezone(value[1], timezone)
        ]
};
const $f59e62e9d03b263b$export$f11c2373fda8386 = ({ dateSeparator: dateSeparator = "\u2013" })=>({
        updateReferenceValue: (utils, value, prevReferenceValue)=>{
            const shouldKeepStartDate = value[0] != null && utils.isValid(value[0]);
            const shouldKeepEndDate = value[1] != null && utils.isValid(value[1]);
            if (!shouldKeepStartDate && !shouldKeepEndDate) return prevReferenceValue;
            if (shouldKeepStartDate && shouldKeepEndDate) return value;
            if (shouldKeepStartDate) return [
                value[0],
                prevReferenceValue[0]
            ];
            return [
                prevReferenceValue[1],
                value[1]
            ];
        },
        getSectionsFromValue: (utils, [start, end], fallbackSections, getSectionsFromDate)=>{
            const separatedFallbackSections = fallbackSections == null ? {
                startDate: null,
                endDate: null
            } : (0, $f9f8b7eb6ed3aac2$export$b0d0c72cc357b4dd)(fallbackSections);
            const getSections = (newDate, fallbackDateSections, position)=>{
                const shouldReUsePrevDateSections = !utils.isValid(newDate) && !!fallbackDateSections;
                if (shouldReUsePrevDateSections) return fallbackDateSections;
                const sections = getSectionsFromDate(newDate);
                return sections.map((section, sectionIndex)=>{
                    if (sectionIndex === sections.length - 1 && position === "start") return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, section, {
                        dateName: position,
                        // TODO: Check if RTL still works
                        endSeparator: `${section.endSeparator} ${dateSeparator} `
                    });
                    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, section, {
                        dateName: position
                    });
                });
            };
            return [
                ...getSections(start, separatedFallbackSections.startDate, "start"),
                ...getSections(end, separatedFallbackSections.endDate, "end")
            ];
        },
        getV7HiddenInputValueFromSections: (sections)=>{
            const dateRangeSections = (0, $f9f8b7eb6ed3aac2$export$b0d0c72cc357b4dd)(sections);
            return (0, $4ff936469a729129$export$9e6af343db7dd2)([
                ...dateRangeSections.startDate,
                ...dateRangeSections.endDate
            ]);
        },
        getV6InputValueFromSections: (sections, localizedDigits, isRtl)=>{
            const dateRangeSections = (0, $f9f8b7eb6ed3aac2$export$b0d0c72cc357b4dd)(sections);
            return (0, $4ff936469a729129$export$7ffdf006c6dc825f)([
                ...dateRangeSections.startDate,
                ...dateRangeSections.endDate
            ], localizedDigits, isRtl);
        },
        parseValueStr: (valueStr, referenceValue, parseDate)=>{
            // TODO: Improve because it would not work if some section have the same separator as the dateSeparator.
            const [startStr, endStr] = valueStr.split(dateSeparator);
            return [
                startStr,
                endStr
            ].map((dateStr, index)=>{
                if (dateStr == null) return null;
                return parseDate(dateStr.trim(), referenceValue[index]);
            });
        },
        getActiveDateManager: (utils, state, activeSection)=>{
            const index = activeSection.dateName === "start" ? 0 : 1;
            const updateDateInRange = (newDate, prevDateRange)=>index === 0 ? [
                    newDate,
                    prevDateRange[1]
                ] : [
                    prevDateRange[0],
                    newDate
                ];
            return {
                date: state.value[index],
                referenceDate: state.referenceValue[index],
                getSections: (sections)=>{
                    const dateRangeSections = (0, $f9f8b7eb6ed3aac2$export$b0d0c72cc357b4dd)(sections);
                    if (index === 0) return (0, $f9f8b7eb6ed3aac2$export$927f12730cacf7f9)(dateRangeSections.startDate);
                    return dateRangeSections.endDate;
                },
                getNewValuesFromNewActiveDate: (newActiveDate)=>({
                        value: updateDateInRange(newActiveDate, state.value),
                        referenceValue: newActiveDate == null || !utils.isValid(newActiveDate) ? state.referenceValue : updateDateInRange(newActiveDate, state.referenceValue)
                    })
            };
        }
    });




var $1T1QG = parcelRequire("1T1QG");

var $gADeF = parcelRequire("gADeF");




var $1T1QG = parcelRequire("1T1QG");




var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");




function $4a617d55a8151f18$export$eafce1c932fd58de(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiDateRangePickerToolbar", slot);
}
const $4a617d55a8151f18$export$657d09388937f683 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiDateRangePickerToolbar", [
    "root",
    "container"
]);



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $d2520552af5840e8$var$_excluded = [
    "value",
    "rangePosition",
    "onRangePositionChange",
    "toolbarFormat",
    "className",
    "onViewChange",
    "view",
    "views"
];
const $d2520552af5840e8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $4a617d55a8151f18$export$eafce1c932fd58de), classes);
};
const $d2520552af5840e8$var$DateRangePickerToolbarRoot = (0, $npagc.default)((0, $a4249024e74e1302$export$eb3c4d84783d6feb), {
    name: "MuiDateRangePickerToolbar",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({});
const $d2520552af5840e8$var$DateRangePickerToolbarContainer = (0, $npagc.default)("div", {
    name: "MuiDateRangePickerToolbar",
    slot: "Container",
    overridesResolver: (_, styles)=>styles.container
})({
    display: "flex"
});
/**
 * Demos:
 *
 * - [DateRangePicker](https://mui.com/x/react-date-pickers/date-range-picker/)
 * - [Custom components](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [DateRangePickerToolbar API](https://mui.com/x/api/date-pickers/date-range-picker-toolbar/)
 */ const $d2520552af5840e8$export$a6a90c1fe2022b58 = /*#__PURE__*/ $1T1QG.forwardRef(function DateRangePickerToolbar(inProps, ref) {
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiDateRangePickerToolbar"
    });
    const { value: [start, end], rangePosition: rangePosition, onRangePositionChange: onRangePositionChange, toolbarFormat: toolbarFormat, className: className } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $d2520552af5840e8$var$_excluded);
    const translations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    const startDateValue = start ? utils.formatByString(start, toolbarFormat || utils.formats.shortDate) : translations.start;
    const endDateValue = end ? utils.formatByString(end, toolbarFormat || utils.formats.shortDate) : translations.end;
    const ownerState = props;
    const classes = $d2520552af5840e8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($d2520552af5840e8$var$DateRangePickerToolbarRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, other, {
        toolbarTitle: translations.dateRangePickerToolbarTitle,
        isLandscape: false,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        children: /*#__PURE__*/ (0, $3Py8h.jsxs)($d2520552af5840e8$var$DateRangePickerToolbarContainer, {
            className: classes.container,
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f70eed4fc89c5764$export$614ed940168c780c), {
                    variant: start !== null ? "h5" : "h6",
                    value: startDateValue,
                    selected: rangePosition === "start",
                    onClick: ()=>onRangePositionChange("start")
                }),
                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $a386176d6ca21602$export$2e2bcd8739ae039), {
                    variant: "h5",
                    children: [
                        "\xa0",
                        "\u2013",
                        "\xa0"
                    ]
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f70eed4fc89c5764$export$614ed940168c780c), {
                    variant: end !== null ? "h5" : "h6",
                    value: endDateValue,
                    selected: rangePosition === "end",
                    onClick: ()=>onRangePositionChange("end")
                })
            ]
        })
    }));
});


function $dafa228b7a272213$export$b30bf963bdbf4d5b(props, name) {
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const defaultDates = (0, $f3e8032daddc32c6$export$7c38da3a2e90fa83)();
    const themeProps = (0, $gADeF.default)({
        props: props,
        name: name
    });
    const localeText = $1T1QG.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, themeProps.localeText, {
            dateRangePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, themeProps, {
        localeText: localeText,
        disableFuture: themeProps.disableFuture ?? false,
        disablePast: themeProps.disablePast ?? false,
        minDate: (0, $2c8437f6b047f676$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $2c8437f6b047f676$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate),
        slots: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
            toolbar: (0, $d2520552af5840e8$export$a6a90c1fe2022b58)
        }, themeProps.slots)
    });
}


parcelRequire("1T1QG");



var $1T1QG = parcelRequire("1T1QG");







var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");


parcelRequire("1T1QG");


var $1T1QG = parcelRequire("1T1QG");
/* eslint-disable */ const $ed11b7ecdfe53e4b$var$_keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function $ed11b7ecdfe53e4b$var$utf8Encode(str) {
    for(let n = 0; n < str.length; n++){
        const c = str.charCodeAt(n);
        if (c >= 128) throw new Error("ASCII only support");
    }
    return str;
}
const $ed11b7ecdfe53e4b$export$c62426fdd000a97e = (input)=>{
    let output = "";
    let chr1, chr2, chr3;
    let enc1, enc2, enc3, enc4;
    let i = 0;
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    while(i < input.length){
        enc1 = $ed11b7ecdfe53e4b$var$_keyStr.indexOf(input.charAt(i++));
        enc2 = $ed11b7ecdfe53e4b$var$_keyStr.indexOf(input.charAt(i++));
        enc3 = $ed11b7ecdfe53e4b$var$_keyStr.indexOf(input.charAt(i++));
        enc4 = $ed11b7ecdfe53e4b$var$_keyStr.indexOf(input.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) output = output + String.fromCharCode(chr2);
        if (enc4 != 64) output = output + String.fromCharCode(chr3);
    }
    return output;
};
const $ed11b7ecdfe53e4b$export$e510a73ee562749 = (input)=>{
    let output = "";
    let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    let i = 0;
    input = $ed11b7ecdfe53e4b$var$utf8Encode(input);
    while(i < input.length){
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
        enc4 = chr3 & 63;
        if (isNaN(chr2)) enc3 = enc4 = 64;
        else if (isNaN(chr3)) enc4 = 64;
        output = output + $ed11b7ecdfe53e4b$var$_keyStr.charAt(enc1) + $ed11b7ecdfe53e4b$var$_keyStr.charAt(enc2) + $ed11b7ecdfe53e4b$var$_keyStr.charAt(enc3) + $ed11b7ecdfe53e4b$var$_keyStr.charAt(enc4);
    }
    return output;
};


/* eslint-disable */ // See "precomputation" in notes
const $a0eda7357eef0d4d$var$k = [];
let $a0eda7357eef0d4d$var$i = 0;
for(; $a0eda7357eef0d4d$var$i < 64;)$a0eda7357eef0d4d$var$k[$a0eda7357eef0d4d$var$i] = 0 | Math.sin(++$a0eda7357eef0d4d$var$i % Math.PI) * 4294967296;
function $a0eda7357eef0d4d$export$a58ec6a60c09ca72(s) {
    const words = [];
    let b, c, d, j = unescape(encodeURI(s)) + "\x80", a = j.length;
    const h = [
        b = 0x67452301,
        c = 0xefcdab89,
        ~b,
        ~c
    ];
    s = --a / 4 + 2 | 15;
    // See "Length bits" in notes
    words[--s] = a * 8;
    for(; ~a;)// a !== -1
    words[a >> 2] |= j.charCodeAt(a) << 8 * a--;
    for($a0eda7357eef0d4d$var$i = j = 0; $a0eda7357eef0d4d$var$i < s; $a0eda7357eef0d4d$var$i += 16){
        a = h;
        for(; j < 64; a = [
            d = a[3],
            b + ((d = a[0] + [
                b & c | ~b & d,
                d & b | ~d & c,
                b ^ c ^ d,
                c ^ (b | ~d)
            ][a = j >> 4] + $a0eda7357eef0d4d$var$k[j] + ~~words[$a0eda7357eef0d4d$var$i | [
                j,
                5 * j + 1,
                3 * j + 5,
                7 * j
            ][a] & 15]) << (a = [
                7,
                12,
                17,
                22,
                5,
                9,
                14,
                20,
                4,
                11,
                16,
                23,
                6,
                10,
                15,
                21
            ][4 * a + j++ % 4]) | d >>> -a),
            b,
            c
        ]){
            b = a[1] | 0;
            c = a[2];
        }
        // See "Integer safety" in notes
        for(j = 4; j;)h[--j] += a[j];
    // j === 0
    }
    for(s = ""; j < 32;)s += (h[j >> 3] >> (1 ^ j++) * 4 & 15).toString(16);
    return s;
}


// eslint-disable-next-line @typescript-eslint/naming-convention
let $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc = /*#__PURE__*/ function(LICENSE_STATUS) {
    LICENSE_STATUS["NotFound"] = "NotFound";
    LICENSE_STATUS["Invalid"] = "Invalid";
    LICENSE_STATUS["ExpiredAnnual"] = "ExpiredAnnual";
    LICENSE_STATUS["ExpiredAnnualGrace"] = "ExpiredAnnualGrace";
    LICENSE_STATUS["ExpiredVersion"] = "ExpiredVersion";
    LICENSE_STATUS["Valid"] = "Valid";
    LICENSE_STATUS["OutOfScope"] = "OutOfScope";
    LICENSE_STATUS["NotAvailableInInitialProPlan"] = "NotAvailableInInitialProPlan";
    return LICENSE_STATUS;
}({});


const $3567bd8df27caa8c$export$6fffcc874c4891f0 = [
    "pro",
    "premium"
];
const $3567bd8df27caa8c$export$1632eb3abf3dacd4 = [
    "initial",
    "Q3-2024"
];


const $0b1f2dfdbb917897$export$dde05de07b040648 = [
    /**
 * A license is outdated if the current version of the software was released after the expiry date of the license.
 * But the license can be used indefinitely with an older version of the software.
 */ "perpetual",
    /**
 * On development, a license is outdated if the expiry date has been reached
 * On production, a license is outdated if the current version of the software was released after the expiry date of the license (see "perpetual")
 */ "annual",
    /**
 * Legacy. The previous name for 'annual'.
 * Can be removed once old license keys generated with 'subscription' are no longer supported.
 * To support for a while. We need more years of backward support and we sell multi year licenses.
 */ "subscription"
];


const $5db34b673e7210a7$var$getDefaultReleaseDate = ()=>{
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
};
function $5db34b673e7210a7$export$4c9b7f7dacd07671(releaseDate = $5db34b673e7210a7$var$getDefaultReleaseDate()) {
    return (0, $ed11b7ecdfe53e4b$export$e510a73ee562749)(releaseDate.getTime().toString());
}
function $5db34b673e7210a7$var$isPlanScopeSufficient(packageName, planScope) {
    let acceptedScopes;
    if (packageName.includes("-pro")) acceptedScopes = [
        "pro",
        "premium"
    ];
    else if (packageName.includes("-premium")) acceptedScopes = [
        "premium"
    ];
    else acceptedScopes = [];
    return acceptedScopes.includes(planScope);
}
const $5db34b673e7210a7$var$expiryReg = /^.*EXPIRY=([0-9]+),.*$/;
const $5db34b673e7210a7$var$PRO_PACKAGES_AVAILABLE_IN_INITIAL_PRO_PLAN = [
    "x-data-grid-pro",
    "x-date-pickers-pro"
];
/**
 * Format: ORDER:${orderNumber},EXPIRY=${expiryTimestamp},KEYVERSION=1
 */ const $5db34b673e7210a7$var$decodeLicenseVersion1 = (license)=>{
    let expiryTimestamp;
    try {
        expiryTimestamp = parseInt(license.match($5db34b673e7210a7$var$expiryReg)[1], 10);
        if (!expiryTimestamp || Number.isNaN(expiryTimestamp)) expiryTimestamp = null;
    } catch (err) {
        expiryTimestamp = null;
    }
    return {
        planScope: "pro",
        licenseModel: "perpetual",
        expiryTimestamp: expiryTimestamp,
        planVersion: "initial"
    };
};
/**
 * Format: O=${orderNumber},E=${expiryTimestamp},S=${planScope},LM=${licenseModel},PV=${planVersion},KV=2`;
 */ const $5db34b673e7210a7$var$decodeLicenseVersion2 = (license)=>{
    const licenseInfo = {
        planScope: null,
        licenseModel: null,
        expiryTimestamp: null,
        planVersion: "initial"
    };
    license.split(",").map((token)=>token.split("=")).filter((el)=>el.length === 2).forEach(([key, value])=>{
        if (key === "S") licenseInfo.planScope = value;
        if (key === "LM") licenseInfo.licenseModel = value;
        if (key === "E") {
            const expiryTimestamp = parseInt(value, 10);
            if (expiryTimestamp && !Number.isNaN(expiryTimestamp)) licenseInfo.expiryTimestamp = expiryTimestamp;
        }
        if (key === "PV") licenseInfo.planVersion = value;
    });
    return licenseInfo;
};
/**
 * Decode the license based on its key version and return a version-agnostic `MuiLicense` object.
 */ const $5db34b673e7210a7$var$decodeLicense = (encodedLicense)=>{
    const license = (0, $ed11b7ecdfe53e4b$export$c62426fdd000a97e)(encodedLicense);
    if (license.includes("KEYVERSION=1")) return $5db34b673e7210a7$var$decodeLicenseVersion1(license);
    if (license.includes("KV=2")) return $5db34b673e7210a7$var$decodeLicenseVersion2(license);
    return null;
};
function $5db34b673e7210a7$export$65cf4e2e0f5c4c60({ releaseInfo: releaseInfo, licenseKey: licenseKey, packageName: packageName }) {
    if (!releaseInfo) throw new Error("MUI X: The release information is missing. Not able to validate license.");
    if (!licenseKey) return {
        status: (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).NotFound
    };
    const hash = licenseKey.substr(0, 32);
    const encoded = licenseKey.substr(32);
    if (hash !== (0, $a0eda7357eef0d4d$export$a58ec6a60c09ca72)(encoded)) return {
        status: (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).Invalid
    };
    const license = $5db34b673e7210a7$var$decodeLicense(encoded);
    if (license == null) {
        console.error("MUI X: Error checking license. Key version not found!");
        return {
            status: (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    if (license.licenseModel == null || !(0, $0b1f2dfdbb917897$export$dde05de07b040648).includes(license.licenseModel)) {
        console.error("MUI X: Error checking license. Licensing model not found or invalid!");
        return {
            status: (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    if (license.expiryTimestamp == null) {
        console.error("MUI X: Error checking license. Expiry timestamp not found or invalid!");
        return {
            status: (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    license.licenseModel;
    {
        const pkgTimestamp = parseInt((0, $ed11b7ecdfe53e4b$export$c62426fdd000a97e)(releaseInfo), 10);
        if (Number.isNaN(pkgTimestamp)) throw new Error("MUI X: The release information is invalid. Not able to validate license.");
        if (license.expiryTimestamp < pkgTimestamp) return {
            status: (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).ExpiredVersion
        };
    }
    if (license.planScope == null || !(0, $3567bd8df27caa8c$export$6fffcc874c4891f0).includes(license.planScope)) {
        console.error("MUI X: Error checking license. planScope not found or invalid!");
        return {
            status: (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).Invalid
        };
    }
    if (!$5db34b673e7210a7$var$isPlanScopeSufficient(packageName, license.planScope)) return {
        status: (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).OutOfScope
    };
    // 'charts-pro' or 'tree-view-pro' can only be used with a newer Pro license
    if (license.planVersion === "initial" && license.planScope === "pro" && !$5db34b673e7210a7$var$PRO_PACKAGES_AVAILABLE_IN_INITIAL_PRO_PLAN.includes(packageName)) return {
        status: (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).NotAvailableInInitialProPlan
    };
    return {
        status: (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).Valid
    };
}


/* eslint-disable */ // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $a0f88faaddbe927b$export$2e2bcd8739ae039 = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();


/**
 * @ignore - do not document.
 */ // Store the license information in a global, so it can be shared
// when module duplication occurs. The duplication of the modules can happen
// if using multiple version of MUI X at the same time of the bundler
// decide to duplicate to improve the size of the chunks.
// eslint-disable-next-line no-underscore-dangle
(0, $a0f88faaddbe927b$export$2e2bcd8739ae039).__MUI_LICENSE_INFO__ = (0, $a0f88faaddbe927b$export$2e2bcd8739ae039).__MUI_LICENSE_INFO__ || {
    key: undefined
};
class $b6e2c4096e9dd265$export$2c56d2e2ae515eeb {
    static getLicenseInfo() {
        // eslint-disable-next-line no-underscore-dangle
        return (0, $a0f88faaddbe927b$export$2e2bcd8739ae039).__MUI_LICENSE_INFO__;
    }
    static getLicenseKey() {
        return $b6e2c4096e9dd265$export$2c56d2e2ae515eeb.getLicenseInfo().key;
    }
    static setLicenseKey(key) {
        const licenseInfo = $b6e2c4096e9dd265$export$2c56d2e2ae515eeb.getLicenseInfo();
        licenseInfo.key = key;
    }
}


function $af26a5d3b6404be6$var$showError(message) {
    console.error([
        "*************************************************************",
        "",
        ...message,
        "",
        "*************************************************************"
    ].join("\n"));
}
function $af26a5d3b6404be6$export$e03bc902b0abb5bd() {
    $af26a5d3b6404be6$var$showError([
        "MUI X: Invalid license key.",
        "",
        "Your MUI X license key format isn't valid. It could be because the license key is missing a character or has a typo.",
        "",
        "To solve the issue, you need to double check that `setLicenseKey()` is called with the right argument",
        "Please check the license key installation https://mui.com/r/x-license-key-installation."
    ]);
}
function $af26a5d3b6404be6$export$d0a8365d54384f87() {
    $af26a5d3b6404be6$var$showError([
        "MUI X: License key plan mismatch.",
        "",
        "Your use of MUI X is not compatible with the plan of your license key. The feature you are trying to use is not included in the plan of your license key. This happens if you try to use Data Grid Premium with a license key for the Pro plan.",
        "",
        "To solve the issue, you can upgrade your plan from Pro to Premium at https://mui.com/r/x-get-license?scope=premium.",
        "Of if you didn't intend to use Premium features, you can replace the import of `@mui/x-data-grid-premium` with `@mui/x-data-grid-pro`."
    ]);
}
function $af26a5d3b6404be6$export$fa76ce5cbafe3dc5() {
    $af26a5d3b6404be6$var$showError([
        "MUI X: Component not included in your license.",
        "",
        "The component you are trying to use is not included in the Pro Plan you purchased.",
        "",
        "Your license is from an old version of the Pro Plan that is only compatible with the `@mui/x-data-grid-pro` and `@mui/x-date-pickers-pro` commercial packages.",
        "",
        "To start using another Pro package, please consider reaching to our sales team to upgrade your license or visit https://mui.com/r/x-get-license to get a new license key."
    ]);
}
function $af26a5d3b6404be6$export$bfbf7dff305ffa2a({ plan: plan, packageName: packageName }) {
    $af26a5d3b6404be6$var$showError([
        "MUI X: Missing license key.",
        "",
        `The license key is missing. You might not be allowed to use \`${packageName}\` which is part of MUI X ${plan}.`,
        "",
        "To solve the issue, you can check the free trial conditions: https://mui.com/r/x-license-trial.",
        "If you are eligible no actions are required. If you are not eligible to the free trial, you need to purchase a license https://mui.com/r/x-get-license or stop using the software immediately."
    ]);
}
function $af26a5d3b6404be6$export$242a1b9acf4255b9({ packageName: packageName }) {
    $af26a5d3b6404be6$var$showError([
        "MUI X: Expired package version.",
        "",
        `You have installed a version of \`${packageName}\` that is outside of the maintenance plan of your license key. By default, commercial licenses provide access to new versions released during the first year after the purchase.`,
        "",
        "To solve the issue, you can renew your license https://mui.com/r/x-get-license or install an older version of the npm package that is compatible with your license key."
    ]);
}
function $af26a5d3b6404be6$export$1ba1f66631f7b541({ plan: plan, licenseKey: licenseKey, expiryTimestamp: expiryTimestamp }) {
    $af26a5d3b6404be6$var$showError([
        "MUI X: Expired license key.",
        "",
        `Your annual license key to use MUI X ${plan} in non-production environments has expired. If you are seeing this development console message, you might be close to breach the license terms by making direct or indirect changes to the frontend of an app that render a MUI X ${plan} component (more details in https://mui.com/r/x-license-annual).`,
        "",
        "To solve the problem you can either:",
        "",
        "- Renew your license https://mui.com/r/x-get-license and use the new key",
        `- Stop making changes to code depending directly or indirectly on MUI X ${plan}'s APIs`,
        "",
        "Note that your license is perpetual in production environments with any version released before your license term ends.",
        "",
        `- License key expiry timestamp: ${new Date(expiryTimestamp)}`,
        `- Installed license key: ${licenseKey}`,
        ""
    ]);
}
function $af26a5d3b6404be6$export$89cdc76bbf22084e({ plan: plan, licenseKey: licenseKey, expiryTimestamp: expiryTimestamp }) {
    throw new Error([
        "MUI X: Expired license key.",
        "",
        `Your annual license key to use MUI X ${plan} in non-production environments has expired. If you are seeing this development console message, you might be close to breach the license terms by making direct or indirect changes to the frontend of an app that render a MUI X ${plan} component (more details in https://mui.com/r/x-license-annual).`,
        "",
        "To solve the problem you can either:",
        "",
        "- Renew your license https://mui.com/r/x-get-license and use the new key",
        `- Stop making changes to code depending directly or indirectly on MUI X ${plan}'s APIs`,
        "",
        "Note that your license is perpetual in production environments with any version released before your license term ends.",
        "",
        `- License key expiry timestamp: ${new Date(expiryTimestamp)}`,
        `- Installed license key: ${licenseKey}`,
        ""
    ].join("\n"));
}




var $1T1QG = parcelRequire("1T1QG");
const $6760950fe6faa2b5$var$MuiLicenseInfoContext = /*#__PURE__*/ $1T1QG.createContext({
    key: undefined
});
var $6760950fe6faa2b5$export$2e2bcd8739ae039 = $6760950fe6faa2b5$var$MuiLicenseInfoContext;


const $d8fb333063125c1d$export$dc1f6c076f2a5d88 = {};
function $d8fb333063125c1d$export$bd780281ba7bfd9(packageName, releaseInfo) {
    const { key: contextKey } = $1T1QG.useContext((0, $6760950fe6faa2b5$export$2e2bcd8739ae039));
    return $1T1QG.useMemo(()=>{
        const licenseKey = contextKey ?? (0, $b6e2c4096e9dd265$export$2c56d2e2ae515eeb).getLicenseKey();
        // Cache the response to not trigger the error twice.
        if ($d8fb333063125c1d$export$dc1f6c076f2a5d88[packageName] && $d8fb333063125c1d$export$dc1f6c076f2a5d88[packageName].key === licenseKey) return $d8fb333063125c1d$export$dc1f6c076f2a5d88[packageName].licenseVerifier;
        const plan = packageName.includes("premium") ? "Premium" : "Pro";
        const licenseStatus = (0, $5db34b673e7210a7$export$65cf4e2e0f5c4c60)({
            releaseInfo: releaseInfo,
            licenseKey: licenseKey,
            packageName: packageName
        });
        const fullPackageName = `@mui/${packageName}`;
        if (licenseStatus.status === (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).Valid) ;
        else if (licenseStatus.status === (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).Invalid) (0, $af26a5d3b6404be6$export$e03bc902b0abb5bd)();
        else if (licenseStatus.status === (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).NotAvailableInInitialProPlan) (0, $af26a5d3b6404be6$export$fa76ce5cbafe3dc5)();
        else if (licenseStatus.status === (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).OutOfScope) (0, $af26a5d3b6404be6$export$d0a8365d54384f87)();
        else if (licenseStatus.status === (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).NotFound) (0, $af26a5d3b6404be6$export$bfbf7dff305ffa2a)({
            plan: plan,
            packageName: fullPackageName
        });
        else if (licenseStatus.status === (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).ExpiredAnnualGrace) (0, $af26a5d3b6404be6$export$1ba1f66631f7b541)((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
            plan: plan
        }, licenseStatus.meta));
        else if (licenseStatus.status === (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).ExpiredAnnual) (0, $af26a5d3b6404be6$export$89cdc76bbf22084e)((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
            plan: plan
        }, licenseStatus.meta));
        else if (licenseStatus.status === (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).ExpiredVersion) (0, $af26a5d3b6404be6$export$242a1b9acf4255b9)({
            packageName: fullPackageName
        });
        $d8fb333063125c1d$export$dc1f6c076f2a5d88[packageName] = {
            key: licenseKey,
            licenseVerifier: licenseStatus
        };
        return licenseStatus;
    }, [
        packageName,
        releaseInfo,
        contextKey
    ]);
}




var $3Py8h = parcelRequire("3Py8h");
function $0cc2b89d03bdc16d$var$getLicenseErrorMessage(licenseStatus) {
    switch(licenseStatus){
        case (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).ExpiredAnnualGrace:
        case (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).ExpiredAnnual:
            return "MUI X Expired license key";
        case (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).ExpiredVersion:
            return "MUI X Expired package version";
        case (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).Invalid:
            return "MUI X Invalid license key";
        case (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).OutOfScope:
            return "MUI X License key plan mismatch";
        case (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).NotAvailableInInitialProPlan:
            return "MUI X Product not covered by plan";
        case (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).NotFound:
            return "MUI X Missing license key";
        default:
            throw new Error("Unhandled MUI X license status.");
    }
}
function $0cc2b89d03bdc16d$export$e94943a72132ebdf(props) {
    const { packageName: packageName, releaseInfo: releaseInfo } = props;
    const licenseStatus = (0, $d8fb333063125c1d$export$bd780281ba7bfd9)(packageName, releaseInfo);
    if (licenseStatus.status === (0, $73e77bdf2a2c3150$export$4d5a447ae2d3c7bc).Valid) return null;
    return /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
        style: {
            position: "absolute",
            pointerEvents: "none",
            color: "#8282829e",
            zIndex: 100000,
            width: "100%",
            textAlign: "center",
            bottom: "50%",
            right: 0,
            letterSpacing: 5,
            fontSize: 24
        },
        children: $0cc2b89d03bdc16d$var$getLicenseErrorMessage(licenseStatus.status)
    });
}





const $555d1ccddbab635a$export$edcd7d0b4c3818f = ()=>{
    const releaseInfo = "MTczMDQzMzYwMDAwMA==";
    return releaseInfo;
};



const $a7cb2c9dae95b9ca$export$9da81b5a5c4a60ca = (slot)=>(0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiDateRangeCalendar", slot);
const $a7cb2c9dae95b9ca$export$57e995f78fa7756a = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiDateRangeCalendar", [
    "root",
    "monthContainer",
    "dayDragging"
]);


const $66bef3924fc52605$export$c7f604e63318fb66 = (utils, range)=>{
    return Boolean(range && range[0] && range[1] && !utils.isBefore(range[1], range[0]));
};
const $66bef3924fc52605$export$6a645c07cf2dc9cc = (utils, day, range)=>{
    return $66bef3924fc52605$export$c7f604e63318fb66(utils, range) && utils.isWithinRange(day, range);
};
const $66bef3924fc52605$export$d63c3232b6730bf6 = (utils, day, range)=>{
    return $66bef3924fc52605$export$c7f604e63318fb66(utils, range) && utils.isSameDay(day, range[0]);
};
const $66bef3924fc52605$export$ee65fa37269ed1c8 = (utils, day, range)=>{
    return $66bef3924fc52605$export$c7f604e63318fb66(utils, range) && utils.isSameDay(day, range[1]);
};



function $ba08a8477b6b3f9e$export$16d220d339b0b3fb({ utils: utils, range: range, newDate: selectedDate, rangePosition: rangePosition, allowRangeFlip: allowRangeFlip = false, shouldMergeDateAndTime: shouldMergeDateAndTime = false }) {
    const [start, end] = range;
    if (shouldMergeDateAndTime && selectedDate) {
        // If there is a date already selected, then we want to keep its time
        if (start && rangePosition === "start") selectedDate = (0, $2c8437f6b047f676$export$a98b123b8f29e004)(utils, selectedDate, start);
        if (end && rangePosition === "end") selectedDate = (0, $2c8437f6b047f676$export$a98b123b8f29e004)(utils, selectedDate, end);
    }
    if (rangePosition === "start") {
        const truthyResult = allowRangeFlip ? {
            nextSelection: "start",
            newRange: [
                end,
                selectedDate
            ]
        } : {
            nextSelection: "end",
            newRange: [
                selectedDate,
                null
            ]
        };
        return Boolean(end) && utils.isAfter(selectedDate, end) ? truthyResult : {
            nextSelection: "end",
            newRange: [
                selectedDate,
                end
            ]
        };
    }
    const truthyResult = allowRangeFlip ? {
        nextSelection: "end",
        newRange: [
            selectedDate,
            start
        ]
    } : {
        nextSelection: "end",
        newRange: [
            selectedDate,
            null
        ]
    };
    return Boolean(start) && utils.isBeforeDay(selectedDate, start) ? truthyResult : {
        nextSelection: "start",
        newRange: [
            start,
            selectedDate
        ]
    };
}
function $ba08a8477b6b3f9e$export$216d2ce628eab5d7(options) {
    if (options.newDate == null) return [
        null,
        null
    ];
    const [start, end] = options.range;
    const { newRange: newRange } = $ba08a8477b6b3f9e$export$16d220d339b0b3fb(options);
    if (!start || !end) return newRange;
    const [previewStart, previewEnd] = newRange;
    return options.rangePosition === "end" ? [
        end,
        previewEnd
    ] : [
        previewStart,
        start
    ];
}





var $1T1QG = parcelRequire("1T1QG");




var $7Etkp = parcelRequire("7Etkp");
var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");




function $105c94842a21bc46$export$678d04f59a9a713f(slot) {
    return (0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiDateRangePickerDay", slot);
}
const $105c94842a21bc46$export$d983409be2282164 = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiDateRangePickerDay", [
    "root",
    "rangeIntervalDayHighlight",
    "rangeIntervalDayHighlightStart",
    "rangeIntervalDayHighlightEnd",
    "rangeIntervalPreview",
    "rangeIntervalDayPreview",
    "rangeIntervalDayPreviewStart",
    "rangeIntervalDayPreviewEnd",
    "outsideCurrentMonth",
    "startOfMonth",
    "endOfMonth",
    "firstVisibleCell",
    "lastVisibleCell",
    "hiddenDayFiller",
    "day",
    "dayOutsideRangeInterval",
    "dayInsideRangeInterval",
    "notSelectedDate"
]);




var $3Py8h = parcelRequire("3Py8h");
"use client";
const $898bb80618f1713c$var$_excluded = [
    "className",
    "day",
    "outsideCurrentMonth",
    "isEndOfHighlighting",
    "isEndOfPreviewing",
    "isHighlighting",
    "isPreviewing",
    "isStartOfHighlighting",
    "isStartOfPreviewing",
    "selected",
    "isVisuallySelected",
    "sx",
    "draggable",
    "isFirstVisibleCell",
    "isLastVisibleCell"
];
const $898bb80618f1713c$var$releaseInfo = (0, $555d1ccddbab635a$export$edcd7d0b4c3818f)();
const $898bb80618f1713c$var$useUtilityClasses = (ownerState)=>{
    const { isHighlighting: isHighlighting, outsideCurrentMonth: outsideCurrentMonth, isStartOfHighlighting: isStartOfHighlighting, isStartOfMonth: isStartOfMonth, isEndOfHighlighting: isEndOfHighlighting, isEndOfMonth: isEndOfMonth, isPreviewing: isPreviewing, isStartOfPreviewing: isStartOfPreviewing, isEndOfPreviewing: isEndOfPreviewing, isFirstVisibleCell: isFirstVisibleCell, isLastVisibleCell: isLastVisibleCell, isHiddenDayFiller: isHiddenDayFiller, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            isHighlighting && "rangeIntervalDayHighlight",
            isStartOfHighlighting && "rangeIntervalDayHighlightStart",
            isEndOfHighlighting && "rangeIntervalDayHighlightEnd",
            outsideCurrentMonth && "outsideCurrentMonth",
            isStartOfMonth && "startOfMonth",
            isEndOfMonth && "endOfMonth",
            isFirstVisibleCell && "firstVisibleCell",
            isLastVisibleCell && "lastVisibleCell",
            isHiddenDayFiller && "hiddenDayFiller"
        ],
        rangeIntervalPreview: [
            "rangeIntervalPreview",
            isPreviewing && "rangeIntervalDayPreview",
            (isStartOfPreviewing || isStartOfMonth) && "rangeIntervalDayPreviewStart",
            (isEndOfPreviewing || isEndOfMonth) && "rangeIntervalDayPreviewEnd"
        ],
        day: [
            "day",
            !selected && "notSelectedDate",
            !isHighlighting && "dayOutsideRangeInterval",
            !selected && isHighlighting && "dayInsideRangeInterval"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $105c94842a21bc46$export$678d04f59a9a713f), classes);
};
const $898bb80618f1713c$var$endBorderStyle = {
    borderTopRightRadius: "50%",
    borderBottomRightRadius: "50%"
};
const $898bb80618f1713c$var$startBorderStyle = {
    borderTopLeftRadius: "50%",
    borderBottomLeftRadius: "50%"
};
const $898bb80618f1713c$var$DateRangePickerDayRoot = (0, $npagc.default)("div", {
    name: "MuiDateRangePickerDay",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            {
                [`&.${(0, $105c94842a21bc46$export$d983409be2282164).rangeIntervalDayHighlight}`]: styles.rangeIntervalDayHighlight
            },
            {
                [`&.${(0, $105c94842a21bc46$export$d983409be2282164).rangeIntervalDayHighlightStart}`]: styles.rangeIntervalDayHighlightStart
            },
            {
                [`&.${(0, $105c94842a21bc46$export$d983409be2282164).rangeIntervalDayHighlightEnd}`]: styles.rangeIntervalDayHighlightEnd
            },
            {
                [`&.${(0, $105c94842a21bc46$export$d983409be2282164).firstVisibleCell}`]: styles.firstVisibleCell
            },
            {
                [`&.${(0, $105c94842a21bc46$export$d983409be2282164).lastVisibleCell}`]: styles.lastVisibleCell
            },
            {
                [`&.${(0, $105c94842a21bc46$export$d983409be2282164).startOfMonth}`]: styles.startOfMonth
            },
            {
                [`&.${(0, $105c94842a21bc46$export$d983409be2282164).endOfMonth}`]: styles.endOfMonth
            },
            {
                [`&.${(0, $105c94842a21bc46$export$d983409be2282164).outsideCurrentMonth}`]: styles.outsideCurrentMonth
            },
            {
                [`&.${(0, $105c94842a21bc46$export$d983409be2282164).hiddenDayFiller}`]: styles.hiddenDayFiller
            },
            styles.root
        ]
})(({ theme: theme })=>({
        variants: [
            {
                props: {
                    isHiddenDayFiller: false
                },
                style: {
                    [`&:first-of-type .${(0, $105c94842a21bc46$export$d983409be2282164).rangeIntervalDayPreview}`]: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, $898bb80618f1713c$var$startBorderStyle, {
                        borderLeftColor: (theme.vars || theme).palette.divider
                    }),
                    [`&:last-of-type .${(0, $105c94842a21bc46$export$d983409be2282164).rangeIntervalDayPreview}`]: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, $898bb80618f1713c$var$endBorderStyle, {
                        borderRightColor: (theme.vars || theme).palette.divider
                    })
                }
            },
            {
                props: {
                    isHiddenDayFiller: false,
                    isHighlighting: true
                },
                style: {
                    borderRadius: 0,
                    color: (theme.vars || theme).palette.primary.contrastText,
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity),
                    "&:first-of-type": $898bb80618f1713c$var$startBorderStyle,
                    "&:last-of-type": $898bb80618f1713c$var$endBorderStyle
                }
            },
            {
                props: ({ ownerState: { isHiddenDayFiller: isHiddenDayFiller, isStartOfHighlighting: isStartOfHighlighting, isFirstVisibleCell: isFirstVisibleCell } })=>!isHiddenDayFiller && (isStartOfHighlighting || isFirstVisibleCell),
                style: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, $898bb80618f1713c$var$startBorderStyle, {
                    paddingLeft: 0
                })
            },
            {
                props: ({ ownerState: { isHiddenDayFiller: isHiddenDayFiller, isEndOfHighlighting: isEndOfHighlighting, isLastVisibleCell: isLastVisibleCell } })=>!isHiddenDayFiller && (isEndOfHighlighting || isLastVisibleCell),
                style: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, $898bb80618f1713c$var$endBorderStyle, {
                    paddingRight: 0
                })
            }
        ]
    }));
const $898bb80618f1713c$var$DateRangePickerDayRangeIntervalPreview = (0, $npagc.default)("div", {
    name: "MuiDateRangePickerDay",
    slot: "RangeIntervalPreview",
    overridesResolver: (_, styles)=>[
            {
                [`&.${(0, $105c94842a21bc46$export$d983409be2282164).rangeIntervalDayPreview}`]: styles.rangeIntervalDayPreview
            },
            {
                [`&.${(0, $105c94842a21bc46$export$d983409be2282164).rangeIntervalDayPreviewStart}`]: styles.rangeIntervalDayPreviewStart
            },
            {
                [`&.${(0, $105c94842a21bc46$export$d983409be2282164).rangeIntervalDayPreviewEnd}`]: styles.rangeIntervalDayPreviewEnd
            },
            styles.rangeIntervalPreview
        ]
})(({ theme: theme })=>({
        // replace default day component margin with transparent border to avoid jumping on preview
        border: "2px solid transparent",
        variants: [
            {
                props: {
                    isPreviewing: true,
                    isHiddenDayFiller: false
                },
                style: {
                    borderRadius: 0,
                    border: `2px dashed ${(theme.vars || theme).palette.divider}`,
                    borderLeftColor: "transparent",
                    borderRightColor: "transparent"
                }
            },
            {
                props: ({ ownerState: { isPreviewing: isPreviewing, isHiddenDayFiller: isHiddenDayFiller, isStartOfPreviewing: isStartOfPreviewing, isFirstVisibleCell: isFirstVisibleCell } })=>isPreviewing && !isHiddenDayFiller && (isStartOfPreviewing || isFirstVisibleCell),
                style: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                    borderLeftColor: (theme.vars || theme).palette.divider
                }, $898bb80618f1713c$var$startBorderStyle)
            },
            {
                props: ({ ownerState: { isPreviewing: isPreviewing, isHiddenDayFiller: isHiddenDayFiller, isEndOfPreviewing: isEndOfPreviewing, isLastVisibleCell: isLastVisibleCell } })=>isPreviewing && !isHiddenDayFiller && (isEndOfPreviewing || isLastVisibleCell),
                style: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                    borderRightColor: (theme.vars || theme).palette.divider
                }, $898bb80618f1713c$var$endBorderStyle)
            }
        ]
    }));
const $898bb80618f1713c$var$DateRangePickerDayDay = (0, $npagc.default)((0, $47319264a6440e1b$export$d7378e6e864346fa), {
    name: "MuiDateRangePickerDay",
    slot: "Day",
    overridesResolver: (_, styles)=>[
            {
                [`&.${(0, $105c94842a21bc46$export$d983409be2282164).dayInsideRangeInterval}`]: styles.dayInsideRangeInterval
            },
            {
                [`&.${(0, $105c94842a21bc46$export$d983409be2282164).dayOutsideRangeInterval}`]: styles.dayOutsideRangeInterval
            },
            {
                [`&.${(0, $105c94842a21bc46$export$d983409be2282164).notSelectedDate}`]: styles.notSelectedDate
            },
            styles.day
        ]
})({
    // Required to overlap preview border
    transform: "scale(1.1)",
    "& > *": {
        transform: "scale(0.9)"
    },
    variants: [
        {
            props: {
                draggable: true
            },
            style: {
                cursor: "grab",
                touchAction: "none"
            }
        }
    ]
});
const $898bb80618f1713c$var$DateRangePickerDayRaw = /*#__PURE__*/ $1T1QG.forwardRef(function DateRangePickerDay(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiDateRangePickerDay"
    });
    const { className: className, day: day, outsideCurrentMonth: outsideCurrentMonth, isHighlighting: isHighlighting, isPreviewing: isPreviewing, selected: selected = false, isVisuallySelected: isVisuallySelected, sx: sx, draggable: draggable, isFirstVisibleCell: isFirstVisibleCell, isLastVisibleCell: isLastVisibleCell } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $898bb80618f1713c$var$_excluded);
    (0, $d8fb333063125c1d$export$bd780281ba7bfd9)("x-date-pickers-pro", $898bb80618f1713c$var$releaseInfo);
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const isEndOfMonth = utils.isSameDay(day, utils.endOfMonth(day));
    const isStartOfMonth = utils.isSameDay(day, utils.startOfMonth(day));
    const shouldRenderHighlight = isHighlighting && !outsideCurrentMonth;
    const shouldRenderPreview = isPreviewing && !outsideCurrentMonth;
    const ownerState = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, {
        selected: selected,
        isStartOfMonth: isStartOfMonth,
        isEndOfMonth: isEndOfMonth,
        draggable: draggable,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        isHiddenDayFiller: outsideCurrentMonth && !other.showDaysOutsideCurrentMonth
    });
    const classes = $898bb80618f1713c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($898bb80618f1713c$var$DateRangePickerDayRoot, {
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        sx: sx,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($898bb80618f1713c$var$DateRangePickerDayRangeIntervalPreview, {
            className: classes.rangeIntervalPreview,
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, $3Py8h.jsx)($898bb80618f1713c$var$DateRangePickerDayDay, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, other, {
                ref: ref,
                disableMargin: true,
                day: day,
                selected: isVisuallySelected,
                outsideCurrentMonth: outsideCurrentMonth,
                className: classes.day,
                ownerState: ownerState,
                draggable: draggable,
                isFirstVisibleCell: isFirstVisibleCell,
                isLastVisibleCell: isLastVisibleCell
            }))
        })
    });
});
const $898bb80618f1713c$export$5c20dcd640d30b8b = /*#__PURE__*/ $1T1QG.memo($898bb80618f1713c$var$DateRangePickerDayRaw);





var $1T1QG = parcelRequire("1T1QG");


"use client";
const $a47e731a6452d560$var$resolveDateFromTarget = (target, utils, timezone)=>{
    const timestampString = target.dataset.timestamp;
    if (!timestampString) return null;
    const timestamp = +timestampString;
    return utils.date(new Date(timestamp).toISOString(), timezone);
};
const $a47e731a6452d560$var$isSameAsDraggingDate = (event)=>{
    const timestampString = event.target.dataset.timestamp;
    return timestampString === event.dataTransfer.getData("draggingDate");
};
const $a47e731a6452d560$var$resolveButtonElement = (element)=>{
    if (element) {
        if (element instanceof HTMLButtonElement && !element.disabled) return element;
        if (element.children.length) return $a47e731a6452d560$var$resolveButtonElement(element.children[0]);
        return null;
    }
    return element;
};
const $a47e731a6452d560$var$resolveElementFromTouch = (event, ignoreTouchTarget)=>{
    // don't parse multi-touch result
    if (event.changedTouches?.length === 1 && event.touches.length <= 1) {
        const element = document.elementFromPoint(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
        // `elementFromPoint` could have resolved preview div or wrapping div
        // might need to recursively find the nested button
        const buttonElement = $a47e731a6452d560$var$resolveButtonElement(element);
        if (ignoreTouchTarget && buttonElement === event.changedTouches[0].target) return null;
        return buttonElement;
    }
    return null;
};
const $a47e731a6452d560$var$useDragRangeEvents = ({ utils: utils, setRangeDragDay: setRangeDragDay, setIsDragging: setIsDragging, isDragging: isDragging, onDatePositionChange: onDatePositionChange, onDrop: onDrop, disableDragEditing: disableDragEditing, dateRange: dateRange, timezone: timezone })=>{
    const emptyDragImgRef = $1T1QG.useRef(null);
    $1T1QG.useEffect(()=>{
        // Preload the image - required for Safari support: https://stackoverflow.com/a/40923520/3303436
        emptyDragImgRef.current = document.createElement("img");
        emptyDragImgRef.current.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    }, []);
    const isElementDraggable = (day)=>{
        if (day == null) return false;
        const shouldInitDragging = !disableDragEditing && !!dateRange[0] && !!dateRange[1];
        const isSelectedStartDate = (0, $66bef3924fc52605$export$d63c3232b6730bf6)(utils, day, dateRange);
        const isSelectedEndDate = (0, $66bef3924fc52605$export$ee65fa37269ed1c8)(utils, day, dateRange);
        return shouldInitDragging && (isSelectedStartDate || isSelectedEndDate);
    };
    const handleDragStart = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        const newDate = $a47e731a6452d560$var$resolveDateFromTarget(event.target, utils, timezone);
        if (!isElementDraggable(newDate)) return;
        event.stopPropagation();
        if (emptyDragImgRef.current) event.dataTransfer.setDragImage(emptyDragImgRef.current, 0, 0);
        setRangeDragDay(newDate);
        event.dataTransfer.effectAllowed = "move";
        setIsDragging(true);
        const buttonDataset = event.target.dataset;
        if (buttonDataset.timestamp) event.dataTransfer.setData("draggingDate", buttonDataset.timestamp);
        if (buttonDataset.position) onDatePositionChange(buttonDataset.position);
    });
    const handleTouchStart = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        const target = $a47e731a6452d560$var$resolveElementFromTouch(event);
        if (!target) return;
        const newDate = $a47e731a6452d560$var$resolveDateFromTarget(target, utils, timezone);
        if (!isElementDraggable(newDate)) return;
        setRangeDragDay(newDate);
    });
    const handleDragEnter = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        if (!isDragging) return;
        event.preventDefault();
        event.stopPropagation();
        event.dataTransfer.dropEffect = "move";
        setRangeDragDay($a47e731a6452d560$var$resolveDateFromTarget(event.target, utils, timezone));
    });
    const handleTouchMove = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        const target = $a47e731a6452d560$var$resolveElementFromTouch(event);
        if (!target) return;
        const newDate = $a47e731a6452d560$var$resolveDateFromTarget(target, utils, timezone);
        if (newDate) setRangeDragDay(newDate);
        // this prevents initiating drag when user starts touchmove outside and then moves over a draggable element
        const targetsAreIdentical = target === event.changedTouches[0].target;
        if (!targetsAreIdentical || !isElementDraggable(newDate)) return;
        // on mobile we should only initialize dragging state after move is detected
        setIsDragging(true);
        const button = event.target;
        const buttonDataset = button.dataset;
        if (buttonDataset.position) onDatePositionChange(buttonDataset.position);
    });
    const handleDragLeave = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        if (!isDragging) return;
        event.preventDefault();
        event.stopPropagation();
    });
    const handleDragOver = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        if (!isDragging) return;
        event.preventDefault();
        event.stopPropagation();
        event.dataTransfer.dropEffect = "move";
    });
    const handleTouchEnd = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        if (!isDragging) return;
        setRangeDragDay(null);
        setIsDragging(false);
        const target = $a47e731a6452d560$var$resolveElementFromTouch(event, true);
        if (!target) return;
        // make sure the focused element is the element where touch ended
        target.focus();
        const newDate = $a47e731a6452d560$var$resolveDateFromTarget(target, utils, timezone);
        if (newDate) onDrop(newDate);
    });
    const handleDragEnd = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        if (!isDragging) return;
        event.preventDefault();
        event.stopPropagation();
        setIsDragging(false);
        setRangeDragDay(null);
    });
    const handleDrop = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event)=>{
        if (!isDragging) return;
        event.preventDefault();
        event.stopPropagation();
        setIsDragging(false);
        setRangeDragDay(null);
        // make sure the focused element is the element where drop ended
        event.currentTarget.focus();
        if ($a47e731a6452d560$var$isSameAsDraggingDate(event)) return;
        const newDate = $a47e731a6452d560$var$resolveDateFromTarget(event.target, utils, timezone);
        if (newDate) onDrop(newDate);
    });
    return {
        onDragStart: handleDragStart,
        onDragEnter: handleDragEnter,
        onDragLeave: handleDragLeave,
        onDragOver: handleDragOver,
        onDragEnd: handleDragEnd,
        onDrop: handleDrop,
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onTouchEnd: handleTouchEnd
    };
};
const $a47e731a6452d560$export$26d9b2e35f689abe = ({ disableDragEditing: disableDragEditing, utils: utils, onDatePositionChange: onDatePositionChange, onDrop: onDrop, dateRange: dateRange, timezone: timezone })=>{
    const [isDragging, setIsDragging] = $1T1QG.useState(false);
    const [rangeDragDay, setRangeDragDay] = $1T1QG.useState(null);
    const handleRangeDragDayChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((val)=>{
        if (!utils.isEqual(val, rangeDragDay)) setRangeDragDay(val);
    });
    const draggingDatePosition = $1T1QG.useMemo(()=>{
        const [start, end] = dateRange;
        if (rangeDragDay) {
            if (start && utils.isBefore(rangeDragDay, start)) return "start";
            if (end && utils.isAfter(rangeDragDay, end)) return "end";
        }
        return null;
    }, [
        dateRange,
        rangeDragDay,
        utils
    ]);
    const dragRangeEvents = $a47e731a6452d560$var$useDragRangeEvents({
        utils: utils,
        onDatePositionChange: onDatePositionChange,
        onDrop: onDrop,
        setIsDragging: setIsDragging,
        isDragging: isDragging,
        setRangeDragDay: handleRangeDragDayChange,
        disableDragEditing: disableDragEditing,
        dateRange: dateRange,
        timezone: timezone
    });
    return $1T1QG.useMemo(()=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
            isDragging: isDragging,
            rangeDragDay: rangeDragDay,
            draggingDatePosition: draggingDatePosition
        }, !disableDragEditing ? dragRangeEvents : {}), [
        isDragging,
        rangeDragDay,
        draggingDatePosition,
        disableDragEditing,
        dragRangeEvents
    ]);
};




const $dc8e84b7e4c1bc1b$export$a08461734e712d56 = (props, singleInputFieldRef)=>{
    const [rangePosition, setRangePosition] = (0, $9790f3f3f5426a25$export$2e2bcd8739ae039)({
        name: "useRangePosition",
        state: "rangePosition",
        controlled: props.rangePosition,
        default: props.defaultRangePosition ?? "start"
    });
    // When using a single input field,
    // we want to select the 1st section of the edited date when updating the range position.
    const syncRangePositionWithSingleInputField = (newRangePosition)=>{
        if (singleInputFieldRef?.current == null) return;
        const sections = singleInputFieldRef.current.getSections();
        const targetActiveSectionIndex = newRangePosition === "start" ? 0 : sections.length / 2;
        singleInputFieldRef.current.setSelectedSections(targetActiveSectionIndex);
    };
    const handleRangePositionChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newRangePosition)=>{
        setRangePosition(newRangePosition);
        props.onRangePositionChange?.(newRangePosition);
        syncRangePositionWithSingleInputField(newRangePosition);
    });
    return {
        rangePosition: rangePosition,
        onRangePositionChange: handleRangePositionChange
    };
};



const $9f56e15adef72aaf$export$4e17d2fd56bdf649 = 40;
const $9f56e15adef72aaf$export$c1e878bb226ff3de = (0, $790faeda284dc7ce$export$f2fef360e2df0cb7) + 12 * (0, $790faeda284dc7ce$export$dde58b009b497666);





var $1T1QG = parcelRequire("1T1QG");


var $npagc = parcelRequire("npagc");




var $3Py8h = parcelRequire("3Py8h");
"use client";
const $b6e6195685117115$var$_excluded = [
    "calendars",
    "month",
    "monthIndex",
    "labelId"
], $b6e6195685117115$var$_excluded2 = [
    "format",
    "slots",
    "slotProps",
    "currentMonth",
    "onMonthChange",
    "disableFuture",
    "disablePast",
    "minDate",
    "maxDate",
    "timezone",
    "reduceAnimations",
    "views",
    "view"
];
const $b6e6195685117115$var$PickersRangeCalendarHeaderContentMultipleCalendars = (0, $npagc.default)((0, $dc1cb27af374d73a$export$597b7cbdb7b2a24c))({
    padding: "12px 16px 4px 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
});
const $b6e6195685117115$export$5540b90af1b7e6d9 = /*#__PURE__*/ $1T1QG.forwardRef(function PickersRangeCalendarHeader(props, ref) {
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const translations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    const { calendars: calendars, month: month, monthIndex: monthIndex, labelId: labelId } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $b6e6195685117115$var$_excluded);
    const { format: format, slots: slots, slotProps: slotProps, currentMonth: currentMonth, onMonthChange: onMonthChange, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, timezone: timezone } = other, otherRangeProps = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(other, $b6e6195685117115$var$_excluded2);
    const isNextMonthDisabled = (0, $395c14dbcebe680a$export$923e8cc135843169)(currentMonth, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $395c14dbcebe680a$export$3b46d38ff4932cf7)(currentMonth, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    if (calendars === 1) return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $896cb0d181524f2c$export$6801ffebb353f473), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, other, {
        labelId: labelId,
        ref: ref
    }));
    const selectNextMonth = ()=>onMonthChange(utils.addMonths(currentMonth, 1), "left");
    const selectPreviousMonth = ()=>onMonthChange(utils.addMonths(currentMonth, -1), "right");
    return /*#__PURE__*/ (0, $3Py8h.jsx)($b6e6195685117115$var$PickersRangeCalendarHeaderContentMultipleCalendars, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, otherRangeProps, {
        ref: ref,
        onGoToPrevious: selectPreviousMonth,
        onGoToNext: selectNextMonth,
        isPreviousHidden: monthIndex !== 0,
        isPreviousDisabled: isPreviousMonthDisabled,
        previousLabel: translations.previousMonth,
        isNextHidden: monthIndex !== calendars - 1,
        isNextDisabled: isNextMonthDisabled,
        nextLabel: translations.nextMonth,
        slots: slots,
        slotProps: slotProps,
        labelId: labelId,
        children: utils.formatByString(month, format ?? `${utils.formats.month} ${utils.formats.year}`)
    }));
});



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $f39812671a7d34c3$var$_excluded = [
    "value",
    "defaultValue",
    "referenceDate",
    "onChange",
    "className",
    "disableFuture",
    "disablePast",
    "minDate",
    "maxDate",
    "shouldDisableDate",
    "reduceAnimations",
    "onMonthChange",
    "rangePosition",
    "defaultRangePosition",
    "onRangePositionChange",
    "calendars",
    "currentMonthCalendarPosition",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "disableHighlightToday",
    "readOnly",
    "disabled",
    "showDaysOutsideCurrentMonth",
    "dayOfWeekFormatter",
    "disableAutoMonthSwitching",
    "autoFocus",
    "fixedWeekNumber",
    "disableDragEditing",
    "displayWeekNumber",
    "timezone",
    "availableRangePositions",
    "views",
    "view",
    "openTo",
    "onViewChange"
], $f39812671a7d34c3$var$_excluded2 = [
    "isDragging",
    "rangeDragDay",
    "draggingDatePosition"
];
const $f39812671a7d34c3$var$releaseInfo = (0, $555d1ccddbab635a$export$edcd7d0b4c3818f)();
const $f39812671a7d34c3$var$DateRangeCalendarRoot = (0, $npagc.default)("div", {
    name: "MuiDateRangeCalendar",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "row"
});
const $f39812671a7d34c3$var$DateRangeCalendarMonthContainer = (0, $npagc.default)("div", {
    name: "MuiDateRangeCalendar",
    slot: "Container",
    overridesResolver: (_, styles)=>styles.monthContainer
})(({ theme: theme })=>({
        "&:not(:last-of-type)": {
            borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
        }
    }));
const $f39812671a7d34c3$var$weeksContainerHeight = ((0, $9f56e15adef72aaf$export$4e17d2fd56bdf649) + (0, $790faeda284dc7ce$export$dde58b009b497666) * 2) * 6;
const $f39812671a7d34c3$var$InnerDayCalendarForRange = (0, $npagc.default)((0, $a4d416cf529486fb$export$8fb56b32a5df6314))(({ theme: theme })=>({
        minWidth: 312,
        minHeight: $f39812671a7d34c3$var$weeksContainerHeight,
        [`&.${(0, $a7cb2c9dae95b9ca$export$57e995f78fa7756a).dayDragging}`]: {
            [`& .${(0, $105c94842a21bc46$export$d983409be2282164).day}`]: {
                cursor: "grabbing"
            },
            [`& .${(0, $105c94842a21bc46$export$d983409be2282164).root}:not(.${(0, $105c94842a21bc46$export$d983409be2282164).rangeIntervalDayHighlightStart}):not(.${(0, $105c94842a21bc46$export$d983409be2282164).rangeIntervalDayHighlightEnd}) .${(0, $105c94842a21bc46$export$d983409be2282164).day}:not(.${(0, $105c94842a21bc46$export$d983409be2282164).notSelectedDate})`]: {
                // we can't override `PickersDay` background color here, because it's styles take precedence
                opacity: 0.6
            }
        },
        [`&:not(.${(0, $a7cb2c9dae95b9ca$export$57e995f78fa7756a).dayDragging}) .${(0, $105c94842a21bc46$export$d983409be2282164).dayOutsideRangeInterval}`]: {
            "@media (pointer: fine)": {
                "&:hover": {
                    border: `1px solid ${(theme.vars || theme).palette.grey[500]}`
                }
            }
        }
    }));
const $f39812671a7d34c3$var$DayCalendarForRange = $f39812671a7d34c3$var$InnerDayCalendarForRange;
function $f39812671a7d34c3$var$useDateRangeCalendarDefaultizedProps(props, name) {
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const defaultDates = (0, $f3e8032daddc32c6$export$7c38da3a2e90fa83)();
    const defaultReduceAnimations = (0, $376c8e4955882030$export$ce40fb97be7f02d9)();
    const themeProps = (0, $gADeF.default)({
        props: props,
        name: name
    });
    return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, themeProps, {
        renderLoading: themeProps.renderLoading ?? (()=>/*#__PURE__*/ (0, $3Py8h.jsx)("span", {
                children: "..."
            })),
        reduceAnimations: themeProps.reduceAnimations ?? defaultReduceAnimations,
        loading: props.loading ?? false,
        disablePast: props.disablePast ?? false,
        disableFuture: props.disableFuture ?? false,
        openTo: themeProps.openTo ?? "day",
        views: themeProps.views ?? [
            "day"
        ],
        minDate: (0, $2c8437f6b047f676$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $2c8437f6b047f676$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate),
        calendars: themeProps.calendars ?? 2,
        disableDragEditing: themeProps.disableDragEditing ?? false,
        availableRangePositions: themeProps.availableRangePositions ?? [
            "start",
            "end"
        ]
    });
}
const $f39812671a7d34c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isDragging: isDragging } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        monthContainer: [
            "monthContainer"
        ],
        dayCalendar: [
            isDragging && "dayDragging"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, (0, $a7cb2c9dae95b9ca$export$9da81b5a5c4a60ca), classes);
};
/**
 * Demos:
 *
 * - [DateRangePicker](https://mui.com/x/react-date-pickers/date-range-picker/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 *
 * API:
 *
 * - [DateRangeCalendar API](https://mui.com/x/api/date-pickers/date-range-calendar/)
 */ const $f39812671a7d34c3$export$ee16faa35d8af1c6 = /*#__PURE__*/ $1T1QG.forwardRef(function DateRangeCalendar(inProps, ref) {
    const props = $f39812671a7d34c3$var$useDateRangeCalendarDefaultizedProps(inProps, "MuiDateRangeCalendar");
    const shouldHavePreview = (0, $ffad103d3c7e3bc8$export$2e2bcd8739ae039)((0, $68e3e92a73d67afe$export$9ae5b19305db48ce), {
        defaultMatches: false
    });
    const { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, rangePosition: rangePositionProp, defaultRangePosition: inDefaultRangePosition, onRangePositionChange: inOnRangePositionChange, calendars: calendars, currentMonthCalendarPosition: currentMonthCalendarPosition = 1, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, disableAutoMonthSwitching: disableAutoMonthSwitching, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, disableDragEditing: disableDragEditing, displayWeekNumber: displayWeekNumber, timezone: timezoneProp, availableRangePositions: availableRangePositions, views: views, view: inView, openTo: openTo, onViewChange: onViewChange } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $f39812671a7d34c3$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $1370ae3083e8f472$export$174d749f3b4c0f49)({
        name: "DateRangeCalendar",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $f59e62e9d03b263b$export$f0e1e223b0d1e9e1)
    });
    const { setValueAndGoToNextView: setValueAndGoToNextView, view: view } = (0, $1d4419ac03a36f0f$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus
    });
    const utils = (0, $f3e8032daddc32c6$export$1163b47e39508a46)();
    const now = (0, $f3e8032daddc32c6$export$3a404aece3dff2fa)(timezone);
    const id = (0, $ea1f3283f0dc1f21$export$2e2bcd8739ae039)();
    const { rangePosition: rangePosition, onRangePositionChange: onRangePositionChange } = (0, $dc8e84b7e4c1bc1b$export$a08461734e712d56)({
        rangePosition: rangePositionProp,
        defaultRangePosition: inDefaultRangePosition,
        onRangePositionChange: inOnRangePositionChange
    });
    const handleDatePositionChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((position)=>{
        if (rangePosition !== position) onRangePositionChange(position);
    });
    const handleSelectedDayChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newDate, selectionState, allowRangeFlip = false)=>{
        const { nextSelection: nextSelection, newRange: newRange } = (0, $ba08a8477b6b3f9e$export$16d220d339b0b3fb)({
            newDate: newDate,
            utils: utils,
            range: value,
            rangePosition: rangePosition,
            allowRangeFlip: allowRangeFlip,
            shouldMergeDateAndTime: true
        });
        const isNextSectionAvailable = availableRangePositions.includes(nextSelection);
        if (isNextSectionAvailable) onRangePositionChange(nextSelection);
        const isFullRangeSelected = rangePosition === "end" && (0, $66bef3924fc52605$export$c7f604e63318fb66)(utils, newRange);
        setValueAndGoToNextView(newRange, isFullRangeSelected || !isNextSectionAvailable ? "finish" : "partial", view);
    });
    const handleDrop = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newDate)=>{
        handleSelectedDayChange(newDate, undefined, true);
    });
    const shouldDisableDragEditing = disableDragEditing || disabled || readOnly;
    // Range going for the start of the start day to the end of the end day.
    // This makes sure that `isWithinRange` works with any time in the start and end day.
    const valueDayRange = $1T1QG.useMemo(()=>[
            value[0] == null || !utils.isValid(value[0]) ? value[0] : utils.startOfDay(value[0]),
            value[1] == null || !utils.isValid(value[1]) ? value[1] : utils.endOfDay(value[1])
        ], [
        value,
        utils
    ]);
    const _useDragRange = (0, $a47e731a6452d560$export$26d9b2e35f689abe)({
        disableDragEditing: shouldDisableDragEditing,
        onDrop: handleDrop,
        onDatePositionChange: handleDatePositionChange,
        utils: utils,
        dateRange: valueDayRange,
        timezone: timezone
    }), { isDragging: isDragging, rangeDragDay: rangeDragDay, draggingDatePosition: draggingDatePosition } = _useDragRange, dragEventHandlers = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_useDragRange, $f39812671a7d34c3$var$_excluded2);
    const ownerState = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, props, {
        isDragging: isDragging
    });
    const classes = $f39812671a7d34c3$var$useUtilityClasses(ownerState);
    const draggingRange = $1T1QG.useMemo(()=>{
        if (!valueDayRange[0] || !valueDayRange[1] || !rangeDragDay) return [
            null,
            null
        ];
        const newRange = (0, $ba08a8477b6b3f9e$export$16d220d339b0b3fb)({
            utils: utils,
            range: valueDayRange,
            newDate: rangeDragDay,
            rangePosition: rangePosition,
            allowRangeFlip: true
        }).newRange;
        return newRange[0] !== null && newRange[1] !== null ? [
            utils.startOfDay(newRange[0]),
            utils.endOfDay(newRange[1])
        ] : newRange;
    }, [
        rangePosition,
        rangeDragDay,
        utils,
        valueDayRange
    ]);
    const wrappedShouldDisableDate = $1T1QG.useMemo(()=>{
        if (!shouldDisableDate) return undefined;
        return (dayToTest)=>shouldDisableDate(dayToTest, draggingDatePosition || rangePosition);
    }, [
        shouldDisableDate,
        rangePosition,
        draggingDatePosition
    ]);
    const { calendarState: calendarState, changeFocusedDay: changeFocusedDay, changeMonth: changeMonth, handleChangeMonth: handleChangeMonth, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $c6908850d6e5602f$export$6d095e787d2b5e1f)({
        value: value[0] || value[1],
        referenceDate: referenceDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        disableSwitchToMonthOnDayFocus: true,
        maxDate: maxDate,
        minDate: minDate,
        onMonthChange: onMonthChange,
        reduceAnimations: reduceAnimations,
        shouldDisableDate: wrappedShouldDisableDate,
        timezone: timezone
    });
    const CalendarHeader = slots?.calendarHeader ?? (0, $b6e6195685117115$export$5540b90af1b7e6d9);
    const calendarHeaderProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: CalendarHeader,
        externalSlotProps: slotProps?.calendarHeader,
        additionalProps: {
            calendars: calendars,
            views: [
                "day"
            ],
            view: "day",
            currentMonth: calendarState.currentMonth,
            onMonthChange: (newMonth, direction)=>handleChangeMonth({
                    newMonth: newMonth,
                    direction: direction
                }),
            minDate: minDate,
            maxDate: maxDate,
            disabled: disabled,
            disablePast: disablePast,
            disableFuture: disableFuture,
            reduceAnimations: reduceAnimations,
            timezone: timezone,
            slots: slots,
            slotProps: slotProps
        },
        ownerState: props
    });
    const prevValue = $1T1QG.useRef(null);
    $1T1QG.useEffect(()=>{
        const date = rangePosition === "start" ? value[0] : value[1];
        if (!date || !utils.isValid(date)) return;
        const prevDate = rangePosition === "start" ? prevValue.current?.[0] : prevValue.current?.[1];
        prevValue.current = value;
        // The current date did not change, this call comes either from a `rangePosition` change or a change in the other date.
        // In both cases, we don't want to change the visible month(s).
        if (disableAutoMonthSwitching && prevDate && utils.isEqual(prevDate, date)) return;
        const displayingMonthRange = calendars - currentMonthCalendarPosition;
        const currentMonthNumber = utils.getMonth(calendarState.currentMonth);
        const requestedMonthNumber = utils.getMonth(date);
        if (!utils.isSameYear(calendarState.currentMonth, date) || requestedMonthNumber < currentMonthNumber || requestedMonthNumber > currentMonthNumber + displayingMonthRange) {
            const newMonth = rangePosition === "start" ? date : // If need to focus end, scroll to the state when "end" is displaying in the last calendar
            utils.addMonths(date, -displayingMonthRange);
            changeMonth(newMonth);
        }
    }, [
        rangePosition,
        value
    ]); // eslint-disable-line
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled
    };
    const [rangePreviewDay, setRangePreviewDay] = $1T1QG.useState(null);
    const CalendarTransitionProps = $1T1QG.useMemo(()=>({
            onMouseLeave: ()=>setRangePreviewDay(null)
        }), []);
    const previewingRange = (0, $ba08a8477b6b3f9e$export$216d2ce628eab5d7)({
        utils: utils,
        range: valueDayRange,
        newDate: rangePreviewDay,
        rangePosition: rangePosition
    });
    const handleDayMouseEnter = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((event, newPreviewRequest)=>{
        if (!(0, $66bef3924fc52605$export$6a645c07cf2dc9cc)(utils, newPreviewRequest, valueDayRange)) setRangePreviewDay(newPreviewRequest);
        else setRangePreviewDay(null);
    });
    const slotsForDayCalendar = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        day: (0, $898bb80618f1713c$export$5c20dcd640d30b8b)
    }, slots);
    const slotPropsForDayCalendar = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, slotProps, {
        day: (dayOwnerState)=>{
            const { day: day } = dayOwnerState;
            const isSelectedStartDate = (0, $66bef3924fc52605$export$d63c3232b6730bf6)(utils, day, valueDayRange);
            const isSelectedEndDate = (0, $66bef3924fc52605$export$ee65fa37269ed1c8)(utils, day, valueDayRange);
            const shouldInitDragging = !shouldDisableDragEditing && valueDayRange[0] && valueDayRange[1];
            const isElementDraggable = shouldInitDragging && (isSelectedStartDate || isSelectedEndDate);
            let datePosition;
            if (isSelectedStartDate) datePosition = "start";
            else if (isSelectedEndDate) datePosition = "end";
            const isStartOfHighlighting = isDragging ? (0, $66bef3924fc52605$export$d63c3232b6730bf6)(utils, day, draggingRange) : isSelectedStartDate;
            const isEndOfHighlighting = isDragging ? (0, $66bef3924fc52605$export$ee65fa37269ed1c8)(utils, day, draggingRange) : isSelectedEndDate;
            return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                isPreviewing: shouldHavePreview ? (0, $66bef3924fc52605$export$6a645c07cf2dc9cc)(utils, day, previewingRange) : false,
                isStartOfPreviewing: shouldHavePreview ? (0, $66bef3924fc52605$export$d63c3232b6730bf6)(utils, day, previewingRange) : false,
                isEndOfPreviewing: shouldHavePreview ? (0, $66bef3924fc52605$export$ee65fa37269ed1c8)(utils, day, previewingRange) : false,
                isHighlighting: (0, $66bef3924fc52605$export$6a645c07cf2dc9cc)(utils, day, isDragging ? draggingRange : valueDayRange),
                isStartOfHighlighting: isStartOfHighlighting,
                isEndOfHighlighting: isDragging ? (0, $66bef3924fc52605$export$ee65fa37269ed1c8)(utils, day, draggingRange) : isSelectedEndDate,
                onMouseEnter: shouldHavePreview ? handleDayMouseEnter : undefined,
                // apply selected styling to the dragging start or end day
                isVisuallySelected: dayOwnerState.selected || isDragging && (isStartOfHighlighting || isEndOfHighlighting),
                "data-position": datePosition
            }, dragEventHandlers, {
                draggable: isElementDraggable ? true : undefined
            }, (0, $381cff6a989e76ba$export$2e2bcd8739ae039)(slotProps?.day, dayOwnerState) ?? {});
        }
    });
    const calendarMonths = $1T1QG.useMemo(()=>Array.from({
            length: calendars
        }).map((_, index)=>index), [
        calendars
    ]);
    const visibleMonths = $1T1QG.useMemo(()=>{
        const firstMonth = utils.addMonths(calendarState.currentMonth, 1 - currentMonthCalendarPosition);
        return Array.from({
            length: calendars
        }).map((_, index)=>utils.addMonths(firstMonth, index));
    }, [
        utils,
        calendarState.currentMonth,
        calendars,
        currentMonthCalendarPosition
    ]);
    const focusedMonth = $1T1QG.useMemo(()=>{
        if (!autoFocus) return null;
        // The focus priority of the "day" view is as follows:
        // 1. Month of the `start` date
        // 2. Month of the `end` date
        // 3. Month of the current date
        // 4. First visible month
        if (value[0] != null) return visibleMonths.find((month)=>utils.isSameMonth(month, value[0]));
        if (value[1] != null) return visibleMonths.find((month)=>utils.isSameMonth(month, value[1]));
        return visibleMonths.find((month)=>utils.isSameMonth(month, now)) ?? visibleMonths[0];
    }, [
        utils,
        value,
        visibleMonths,
        autoFocus,
        now
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($f39812671a7d34c3$var$DateRangeCalendarRoot, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $0cc2b89d03bdc16d$export$e94943a72132ebdf), {
                packageName: "x-date-pickers-pro",
                releaseInfo: $f39812671a7d34c3$var$releaseInfo
            }),
            calendarMonths.map((monthIndex)=>{
                const month = visibleMonths[monthIndex];
                const labelId = `${id}-grid-${monthIndex}-label`;
                return /*#__PURE__*/ (0, $3Py8h.jsxs)($f39812671a7d34c3$var$DateRangeCalendarMonthContainer, {
                    className: classes.monthContainer,
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)(CalendarHeader, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, calendarHeaderProps, {
                            month: month,
                            monthIndex: monthIndex,
                            labelId: labelId
                        })),
                        /*#__PURE__*/ (0, $3Py8h.jsx)($f39812671a7d34c3$var$DayCalendarForRange, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                            className: classes.dayCalendar
                        }, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            selectedDays: value,
                            onSelectedDaysChange: handleSelectedDayChange,
                            currentMonth: month,
                            TransitionProps: CalendarTransitionProps,
                            shouldDisableDate: wrappedShouldDisableDate,
                            showDaysOutsideCurrentMonth: calendars === 1 && showDaysOutsideCurrentMonth,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            loading: loading,
                            renderLoading: renderLoading,
                            slots: slotsForDayCalendar,
                            slotProps: slotPropsForDayCalendar,
                            autoFocus: month === focusedMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            displayWeekNumber: displayWeekNumber,
                            timezone: timezone,
                            gridLabelId: labelId
                        }))
                    ]
                }, monthIndex);
            })
        ]
    }));
});



var $3Py8h = parcelRequire("3Py8h");
const $3991f640cd3f6217$export$5aac1f02b93501aa = ({ value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, rangePosition: rangePosition, defaultRangePosition: defaultRangePosition, onRangePositionChange: onRangePositionChange, calendars: calendars, currentMonthCalendarPosition: currentMonthCalendarPosition, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, disableAutoMonthSwitching: disableAutoMonthSwitching, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, disableDragEditing: disableDragEditing, displayWeekNumber: displayWeekNumber, timezone: timezone, availableRangePositions: availableRangePositions, views: views, view: view, onViewChange: onViewChange })=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39812671a7d34c3$export$ee16faa35d8af1c6), {
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        rangePosition: rangePosition,
        defaultRangePosition: defaultRangePosition,
        onRangePositionChange: onRangePositionChange,
        calendars: calendars,
        currentMonthCalendarPosition: currentMonthCalendarPosition,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        disableAutoMonthSwitching: disableAutoMonthSwitching,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        disableDragEditing: disableDragEditing,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone,
        availableRangePositions: availableRangePositions,
        view: view,
        views: views,
        onViewChange: onViewChange
    });





var $1T1QG = parcelRequire("1T1QG");






var $npagc = parcelRequire("npagc");
var $gADeF = parcelRequire("gADeF");












"use client";
const $127c3003d9453420$export$5591b0b878c1a989 = (inProps)=>{
    const props = (0, $a466cc9353e69642$export$c04f15aa68a6177a)(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $36f2d66e3b541c42$export$be857fabf132acea)(props, "date");
    return (0, $e5a7561ca2bd0124$export$294aa081a6c6f55d)({
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $59c1a689a11004ea$export$2764b246aa3b75ba),
        fieldValueManager: (0, $59c1a689a11004ea$export$b602c94f557316b4),
        validator: (0, $4d39a15704c4df77$export$ffb3d0046ef3a2),
        valueType: "date"
    });
};









const $dc7177be3348d05c$var$_excluded = [
    "shouldDisableDate"
];
const $dc7177be3348d05c$export$b3e10550232e39db = ({ adapter: adapter, value: value, timezone: timezone, props: props })=>{
    const [start, end] = value;
    const { shouldDisableDate: shouldDisableDate } = props, otherProps = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $dc7177be3348d05c$var$_excluded);
    const dateValidations = [
        (0, $4d39a15704c4df77$export$ffb3d0046ef3a2)({
            adapter: adapter,
            value: start,
            timezone: timezone,
            props: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, otherProps, {
                shouldDisableDate: (day)=>!!shouldDisableDate?.(day, "start")
            })
        }),
        (0, $4d39a15704c4df77$export$ffb3d0046ef3a2)({
            adapter: adapter,
            value: end,
            timezone: timezone,
            props: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, otherProps, {
                shouldDisableDate: (day)=>!!shouldDisableDate?.(day, "end")
            })
        })
    ];
    if (dateValidations[0] || dateValidations[1]) return dateValidations;
    // for partial input
    if (start === null || end === null) return [
        null,
        null
    ];
    if (!(0, $66bef3924fc52605$export$c7f604e63318fb66)(adapter.utils, value)) return [
        "invalidRange",
        "invalidRange"
    ];
    return [
        null,
        null
    ];
};
$dc7177be3348d05c$export$b3e10550232e39db.valueManager = (0, $f59e62e9d03b263b$export$f0e1e223b0d1e9e1);



/* TODO: remove this when a clearable behavior for multiple input range fields is implemented */ const $92af92afb66e403e$export$4974089e59c6941a = (props, excludedProps)=>{
    return Object.keys(props).reduce((acc, key)=>{
        if (!excludedProps.includes(key)) acc[key] = props[key];
        return acc;
    }, {});
};



var $1T1QG = parcelRequire("1T1QG");


const $0c5d656a52685240$export$da2976cb6f809437 = (params)=>{
    const unstableEndFieldRef = $1T1QG.useRef(null);
    const handleUnstableEndFieldRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(params.unstableEndFieldRef, unstableEndFieldRef);
    const [startSelectedSection, setStartSelectedSection] = $1T1QG.useState(params.selectedSections ?? null);
    const [endSelectedSection, setEndSelectedSection] = $1T1QG.useState(null);
    const getActiveField = ()=>{
        if (unstableEndFieldRef.current && unstableEndFieldRef.current.isFieldFocused()) return "end";
        return "start";
    };
    const handleStartSelectedSectionChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newSelectedSections)=>{
        setStartSelectedSection(newSelectedSections);
        if (getActiveField() === "start") params.onSelectedSectionsChange?.(newSelectedSections);
    });
    const handleEndSelectedSectionChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((newSelectedSections)=>{
        setEndSelectedSection(newSelectedSections);
        if (getActiveField() === "end") params.onSelectedSectionsChange?.(newSelectedSections);
    });
    const activeField = getActiveField();
    return {
        start: {
            unstableFieldRef: params.unstableStartFieldRef,
            selectedSections: activeField === "start" && params.selectedSections !== undefined ? params.selectedSections : startSelectedSection,
            onSelectedSectionsChange: handleStartSelectedSectionChange
        },
        end: {
            unstableFieldRef: handleUnstableEndFieldRef,
            selectedSections: activeField === "end" && params.selectedSections !== undefined ? params.selectedSections : endSelectedSection,
            onSelectedSectionsChange: handleEndSelectedSectionChange
        }
    };
};


const $50db6c2946a1f13f$export$7bbd5fc3b71530fb = ({ sharedProps: inSharedProps, startTextFieldProps: startTextFieldProps, unstableStartFieldRef: unstableStartFieldRef, endTextFieldProps: endTextFieldProps, unstableEndFieldRef: unstableEndFieldRef })=>{
    const sharedProps = (0, $a466cc9353e69642$export$c04f15aa68a6177a)(inSharedProps);
    const { value: valueProp, defaultValue: defaultValue, format: format, formatDensity: formatDensity, shouldRespectLeadingZeros: shouldRespectLeadingZeros, onChange: onChange, disabled: disabled, readOnly: readOnly, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezoneProp, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, autoFocus: autoFocus } = sharedProps;
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $1370ae3083e8f472$export$174d749f3b4c0f49)({
        name: "useMultiInputDateRangeField",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $f59e62e9d03b263b$export$f0e1e223b0d1e9e1)
    });
    const { validationError: validationError, getValidationErrorForNewValue: getValidationErrorForNewValue } = (0, $7480e2bc04de1c42$export$87fe492f99f25a20)({
        props: sharedProps,
        value: value,
        timezone: timezone,
        validator: (0, $dc7177be3348d05c$export$b3e10550232e39db),
        onError: sharedProps.onError
    });
    // TODO: Maybe export utility from `useField` instead of copy/pasting the logic
    const buildChangeHandler = (index)=>{
        return (newDate, rawContext)=>{
            const newDateRange = index === 0 ? [
                newDate,
                value[1]
            ] : [
                value[0],
                newDate
            ];
            const context = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, rawContext, {
                validationError: getValidationErrorForNewValue(newDateRange)
            });
            handleValueChange(newDateRange, context);
        };
    };
    const handleStartDateChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)(buildChangeHandler(0));
    const handleEndDateChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)(buildChangeHandler(1));
    const selectedSectionsResponse = (0, $0c5d656a52685240$export$da2976cb6f809437)({
        selectedSections: selectedSections,
        onSelectedSectionsChange: onSelectedSectionsChange,
        unstableStartFieldRef: unstableStartFieldRef,
        unstableEndFieldRef: unstableEndFieldRef
    });
    const startFieldProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        error: !!validationError[0]
    }, startTextFieldProps, selectedSectionsResponse.start, {
        disabled: disabled,
        readOnly: readOnly,
        format: format,
        formatDensity: formatDensity,
        shouldRespectLeadingZeros: shouldRespectLeadingZeros,
        timezone: timezone,
        value: valueProp === undefined ? undefined : valueProp[0],
        defaultValue: defaultValue === undefined ? undefined : defaultValue[0],
        onChange: handleStartDateChange,
        enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
        autoFocus: autoFocus // Do not add on end field.
    });
    const endFieldProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        error: !!validationError[1]
    }, endTextFieldProps, selectedSectionsResponse.end, {
        format: format,
        formatDensity: formatDensity,
        shouldRespectLeadingZeros: shouldRespectLeadingZeros,
        disabled: disabled,
        readOnly: readOnly,
        timezone: timezone,
        value: valueProp === undefined ? undefined : valueProp[1],
        defaultValue: defaultValue === undefined ? undefined : defaultValue[1],
        onChange: handleEndDateChange,
        enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure
    });
    const startDateResponse = (0, $127c3003d9453420$export$5591b0b878c1a989)(startFieldProps);
    const endDateResponse = (0, $127c3003d9453420$export$5591b0b878c1a989)(endFieldProps);
    /* TODO: Undo this change when a clearable behavior for multiple input range fields is implemented */ return {
        startDate: (0, $92af92afb66e403e$export$4974089e59c6941a)(startDateResponse, [
            "clearable",
            "onClear"
        ]),
        endDate: (0, $92af92afb66e403e$export$4974089e59c6941a)(endDateResponse, [
            "clearable",
            "onClear"
        ])
    };
};



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $95175d64e549e18d$var$_excluded = [
    "slots",
    "slotProps",
    "unstableStartFieldRef",
    "unstableEndFieldRef",
    "className"
];
const $95175d64e549e18d$export$9feaf892c0233a1e = (0, $d71473e2d3ab95b6$export$2e2bcd8739ae039)("MuiMultiInputDateRangeField", [
    "root",
    "separator"
]);
const $95175d64e549e18d$export$1f0f295188b72722 = (slot)=>(0, $c118923dfabedaa0$export$2e2bcd8739ae039)("MuiMultiInputDateRangeField", slot);
const $95175d64e549e18d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        separator: [
            "separator"
        ]
    };
    return (0, $0a2d1fc7aa88aa06$export$2e2bcd8739ae039)(slots, $95175d64e549e18d$export$1f0f295188b72722, classes);
};
const $95175d64e549e18d$var$MultiInputDateRangeFieldRoot = (0, $npagc.default)(/*#__PURE__*/ $1T1QG.forwardRef((props, ref)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $3fa3acfa795f4699$export$2e2bcd8739ae039), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        ref: ref,
        spacing: 2,
        direction: "row",
        alignItems: "center"
    }, props))), {
    name: "MuiMultiInputDateRangeField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $95175d64e549e18d$var$MultiInputDateRangeFieldSeparator = (0, $npagc.default)((0, $a386176d6ca21602$export$2e2bcd8739ae039), {
    name: "MuiMultiInputDateRangeField",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})({
    lineHeight: "1.4375em" // 23px
});
/**
 * Demos:
 *
 * - [DateRangeField](http://mui.com/x/react-date-pickers/date-range-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [MultiInputDateRangeField API](https://mui.com/x/api/multi-input-date-range-field/)
 */ const $95175d64e549e18d$export$806f5cf21816db1e = /*#__PURE__*/ $1T1QG.forwardRef(function MultiInputDateRangeField(inProps, ref) {
    const themeProps = (0, $gADeF.default)({
        props: inProps,
        name: "MuiMultiInputDateRangeField"
    });
    const { internalProps: internalProps, forwardedProps: forwardedProps } = (0, $36f2d66e3b541c42$export$be857fabf132acea)(themeProps, "date");
    const { slots: slots, slotProps: slotProps, unstableStartFieldRef: unstableStartFieldRef, unstableEndFieldRef: unstableEndFieldRef, className: className } = forwardedProps, otherForwardedProps = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(forwardedProps, $95175d64e549e18d$var$_excluded);
    const ownerState = themeProps;
    const classes = $95175d64e549e18d$var$useUtilityClasses(ownerState);
    const Root = slots?.root ?? $95175d64e549e18d$var$MultiInputDateRangeFieldRoot;
    const rootProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: otherForwardedProps,
        additionalProps: {
            ref: ref
        },
        ownerState: ownerState,
        className: (0, $4bc2aca8a1a0a2c8$export$2e2bcd8739ae039)(className, classes.root)
    });
    const TextField = slots?.textField ?? (inProps.enableAccessibleFieldDOMStructure ? (0, $8ca8fdc28774020c$export$b3e9b101d92e4d4d) : (0, $acd1b2a27b331456$export$2e2bcd8739ae039));
    const startTextFieldProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: TextField,
        externalSlotProps: slotProps?.textField,
        ownerState: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, ownerState, {
            position: "start"
        })
    });
    const endTextFieldProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: TextField,
        externalSlotProps: slotProps?.textField,
        ownerState: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, ownerState, {
            position: "end"
        })
    });
    const Separator = slots?.separator ?? $95175d64e549e18d$var$MultiInputDateRangeFieldSeparator;
    const separatorProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: Separator,
        externalSlotProps: slotProps?.separator,
        additionalProps: {
            children: ` ${internalProps.dateSeparator ?? "\u2013"} `
        },
        ownerState: ownerState,
        className: classes.separator
    });
    const fieldResponse = (0, $50db6c2946a1f13f$export$7bbd5fc3b71530fb)({
        sharedProps: internalProps,
        startTextFieldProps: startTextFieldProps,
        endTextFieldProps: endTextFieldProps,
        unstableStartFieldRef: unstableStartFieldRef,
        unstableEndFieldRef: unstableEndFieldRef
    });
    const startDateProps = (0, $3720a86516927ef9$export$20bf15d9b24b4dad)(fieldResponse.startDate);
    const endDateProps = (0, $3720a86516927ef9$export$20bf15d9b24b4dad)(fieldResponse.endDate);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)(Root, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, rootProps, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)(TextField, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                fullWidth: true
            }, startDateProps)),
            /*#__PURE__*/ (0, $3Py8h.jsx)(Separator, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, separatorProps)),
            /*#__PURE__*/ (0, $3Py8h.jsx)(TextField, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                fullWidth: true
            }, endDateProps))
        ]
    }));
});





var $1T1QG = parcelRequire("1T1QG");







var $1T1QG = parcelRequire("1T1QG");





const $407c8e6459946495$var$_excluded = [
    "clearable",
    "onClear"
];
const $407c8e6459946495$var$useMultiInputFieldSlotProps = ({ wrapperVariant: wrapperVariant, open: open, actions: actions, readOnly: readOnly, labelId: labelId, disableOpenPicker: disableOpenPicker, onBlur: onBlur, rangePosition: rangePosition, onRangePositionChange: onRangePositionChange, localeText: inLocaleText, pickerSlotProps: pickerSlotProps, pickerSlots: pickerSlots, fieldProps: fieldProps, anchorRef: anchorRef, currentView: currentView, initialView: initialView, onViewChange: onViewChange, startFieldRef: startFieldRef, endFieldRef: endFieldRef })=>{
    const translations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    const handleStartFieldRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(fieldProps.unstableStartFieldRef, startFieldRef);
    const handleEndFieldRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(fieldProps.unstableEndFieldRef, endFieldRef);
    const previousRangePosition = $1T1QG.useRef(rangePosition);
    $1T1QG.useEffect(()=>{
        if (!open) return;
        const currentFieldRef = rangePosition === "start" ? startFieldRef : endFieldRef;
        currentFieldRef.current?.focusField();
        if (!currentFieldRef.current || !currentView) {
            // could happen when the user is switching between the inputs
            previousRangePosition.current = rangePosition;
            return;
        }
        // bring back focus to the field
        currentFieldRef.current.setSelectedSections(// use the current view or `0` when the range position has just been swapped
        previousRangePosition.current === rangePosition ? currentView : 0);
        previousRangePosition.current = rangePosition;
    }, [
        rangePosition,
        open,
        currentView,
        startFieldRef,
        endFieldRef
    ]);
    const openRangeStartSelection = (event)=>{
        event.stopPropagation();
        onRangePositionChange("start");
        if (!readOnly && !disableOpenPicker) actions.onOpen(event);
    };
    const openRangeEndSelection = (event)=>{
        event.stopPropagation();
        onRangePositionChange("end");
        if (!readOnly && !disableOpenPicker) actions.onOpen(event);
    };
    const handleFocusStart = ()=>{
        if (open) {
            onRangePositionChange("start");
            if (previousRangePosition.current !== "start" && initialView) onViewChange?.(initialView);
        }
    };
    const handleFocusEnd = ()=>{
        if (open) {
            onRangePositionChange("end");
            if (previousRangePosition.current !== "end" && initialView) onViewChange?.(initialView);
        }
    };
    const slots = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        textField: pickerSlots?.textField,
        root: pickerSlots?.fieldRoot,
        separator: pickerSlots?.fieldSeparator
    }, fieldProps.slots);
    const slotProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, fieldProps.slotProps, {
        textField: (ownerState)=>{
            const resolvedComponentProps = (0, $381cff6a989e76ba$export$2e2bcd8739ae039)(pickerSlotProps?.textField, ownerState);
            let textFieldProps;
            let InputProps;
            if (ownerState.position === "start") {
                textFieldProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                    label: inLocaleText?.start ?? translations.start,
                    onKeyDown: (0, $68e3e92a73d67afe$export$4467fe8634707c85)(openRangeStartSelection),
                    onFocus: handleFocusStart,
                    focused: open ? rangePosition === "start" : undefined
                }, !readOnly && !fieldProps.disabled && {
                    onClick: openRangeStartSelection
                }, wrapperVariant === "mobile" && {
                    readOnly: true
                });
                if (anchorRef) InputProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, resolvedComponentProps?.InputProps, {
                    ref: anchorRef
                });
            } else {
                textFieldProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                    label: inLocaleText?.end ?? translations.end,
                    onKeyDown: (0, $68e3e92a73d67afe$export$4467fe8634707c85)(openRangeEndSelection),
                    onFocus: handleFocusEnd,
                    focused: open ? rangePosition === "end" : undefined
                }, !readOnly && !fieldProps.disabled && {
                    onClick: openRangeEndSelection
                }, wrapperVariant === "mobile" && {
                    readOnly: true
                });
                InputProps = resolvedComponentProps?.InputProps;
            }
            return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, labelId != null && {
                id: `${labelId}-${ownerState.position}`
            }, textFieldProps, (0, $381cff6a989e76ba$export$2e2bcd8739ae039)(pickerSlotProps?.textField, ownerState), {
                InputProps: InputProps
            });
        },
        root: (ownerState)=>{
            const rootProps = {
                onBlur: onBlur
            };
            return (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, rootProps, (0, $381cff6a989e76ba$export$2e2bcd8739ae039)(pickerSlotProps?.fieldRoot, ownerState));
        },
        separator: pickerSlotProps?.fieldSeparator
    });
    /* TODO: remove this when a clearable behavior for multiple input range fields is implemented */ const _ref = fieldProps, restFieldProps = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_ref, $407c8e6459946495$var$_excluded);
    const enrichedFieldProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, restFieldProps, {
        unstableStartFieldRef: handleStartFieldRef,
        unstableEndFieldRef: handleEndFieldRef,
        slots: slots,
        slotProps: slotProps
    });
    return enrichedFieldProps;
};
const $407c8e6459946495$var$useSingleInputFieldSlotProps = ({ wrapperVariant: wrapperVariant, open: open, actions: actions, readOnly: readOnly, labelId: labelId, disableOpenPicker: disableOpenPicker, label: label, onBlur: onBlur, rangePosition: rangePosition, onRangePositionChange: onRangePositionChange, startFieldRef: startFieldRef, endFieldRef: endFieldRef, pickerSlots: pickerSlots, pickerSlotProps: pickerSlotProps, fieldProps: fieldProps, anchorRef: anchorRef, currentView: currentView })=>{
    const handleFieldRef = (0, $e20da214b1d76463$export$2e2bcd8739ae039)(fieldProps.unstableFieldRef, startFieldRef, endFieldRef);
    $1T1QG.useEffect(()=>{
        if (!open || !startFieldRef.current) return;
        if (startFieldRef.current.isFieldFocused()) return;
        // bring back focus to the field with the current view section selected
        if (currentView) {
            const sections = startFieldRef.current.getSections().map((section)=>section.type);
            const newSelectedSection = rangePosition === "start" ? sections.indexOf(currentView) : sections.lastIndexOf(currentView);
            startFieldRef.current?.focusField(newSelectedSection);
        }
    }, [
        rangePosition,
        open,
        currentView,
        startFieldRef
    ]);
    const updateRangePosition = ()=>{
        if (!startFieldRef.current?.isFieldFocused()) return;
        const sections = startFieldRef.current.getSections();
        const activeSectionIndex = startFieldRef.current?.getActiveSectionIndex();
        const domRangePosition = activeSectionIndex == null || activeSectionIndex < sections.length / 2 ? "start" : "end";
        if (domRangePosition != null && domRangePosition !== rangePosition) onRangePositionChange(domRangePosition);
    };
    const handleSelectedSectionsChange = (0, $b7b0b023b5749940$export$2e2bcd8739ae039)((selectedSection)=>{
        setTimeout(updateRangePosition);
        fieldProps.onSelectedSectionsChange?.(selectedSection);
    });
    const openPicker = (event)=>{
        event.stopPropagation();
        if (!readOnly && !disableOpenPicker) actions.onOpen(event);
    };
    const slots = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, fieldProps.slots, {
        textField: pickerSlots?.textField,
        clearButton: pickerSlots?.clearButton,
        clearIcon: pickerSlots?.clearIcon
    });
    const slotProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, fieldProps.slotProps, {
        textField: pickerSlotProps?.textField,
        clearButton: pickerSlots?.clearButton,
        clearIcon: pickerSlots?.clearIcon
    });
    const enrichedFieldProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, fieldProps, {
        slots: slots,
        slotProps: slotProps,
        label: label,
        unstableFieldRef: handleFieldRef,
        onKeyDown: (0, $68e3e92a73d67afe$export$4467fe8634707c85)(openPicker, fieldProps.onKeyDown),
        onSelectedSectionsChange: handleSelectedSectionsChange,
        onBlur: onBlur,
        InputProps: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
            ref: anchorRef
        }, fieldProps?.InputProps),
        focused: open ? true : undefined
    }, labelId != null && {
        id: labelId
    }, wrapperVariant === "mobile" && {
        readOnly: true
    }, !readOnly && !fieldProps.disabled && {
        onClick: openPicker
    });
    return enrichedFieldProps;
};
const $407c8e6459946495$export$b25f5d250541f495 = (params)=>{
    if (params.fieldType === "multi-input") return $407c8e6459946495$var$useMultiInputFieldSlotProps(params);
    return $407c8e6459946495$var$useSingleInputFieldSlotProps(params);
/* eslint-enable react-hooks/rules-of-hooks */ };





var $3Py8h = parcelRequire("3Py8h");
const $f7a71ec1d9c49886$var$_excluded = [
    "props"
];
const $f7a71ec1d9c49886$var$releaseInfo = (0, $555d1ccddbab635a$export$edcd7d0b4c3818f)();
const $f7a71ec1d9c49886$export$caa24fbbedf06392 = (_ref)=>{
    let { props: props } = _ref, pickerParams = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_ref, $f7a71ec1d9c49886$var$_excluded);
    (0, $d8fb333063125c1d$export$bd780281ba7bfd9)("x-date-pickers-pro", $f7a71ec1d9c49886$var$releaseInfo);
    const { slots: slots, slotProps: slotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezone, label: label, inputRef: inputRef, name: name, readOnly: readOnly, disabled: disabled, autoFocus: autoFocus, disableOpenPicker: disableOpenPicker, localeText: localeText, reduceAnimations: reduceAnimations } = props;
    const fieldContainerRef = $1T1QG.useRef(null);
    const anchorRef = $1T1QG.useRef(null);
    const popperRef = $1T1QG.useRef(null);
    const startFieldRef = $1T1QG.useRef(null);
    const endFieldRef = $1T1QG.useRef(null);
    const initialView = $1T1QG.useRef(props.openTo ?? null);
    const fieldType = slots.field.fieldType ?? "multi-input";
    const { rangePosition: rangePosition, onRangePositionChange: onRangePositionChange } = (0, $dc8e84b7e4c1bc1b$export$a08461734e712d56)(props, fieldType === "single-input" ? startFieldRef : undefined);
    const { open: open, actions: actions, layoutProps: layoutProps, renderCurrentView: renderCurrentView, shouldRestoreFocus: shouldRestoreFocus, fieldProps: pickerFieldProps, contextValue: contextValue } = (0, $ad286f8dcf1caecc$export$fc3313977ac596c4)((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, pickerParams, {
        props: props,
        wrapperVariant: "desktop",
        autoFocusView: false,
        fieldRef: rangePosition === "start" ? startFieldRef : endFieldRef,
        additionalViewProps: {
            rangePosition: rangePosition,
            onRangePositionChange: onRangePositionChange
        }
    }));
    $1T1QG.useEffect(()=>{
        if (layoutProps.view) initialView.current = layoutProps.view;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleBlur = ()=>{
        (0, $68e3e92a73d67afe$export$2e03bc8dde24716b)(()=>{
            if (fieldContainerRef.current?.contains((0, $68e3e92a73d67afe$export$cd4e5573fbe2b576)(document)) || popperRef.current?.contains((0, $68e3e92a73d67afe$export$cd4e5573fbe2b576)(document))) return;
            actions.onDismiss();
        });
    };
    const Field = slots.field;
    const fieldProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: slotProps?.field,
        additionalProps: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, pickerFieldProps, {
            readOnly: readOnly,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            timezone: timezone,
            autoFocus: autoFocus && !props.open,
            ref: fieldContainerRef
        }, fieldType === "single-input" ? {
            inputRef: inputRef,
            name: name
        } : {}),
        ownerState: props
    });
    const enrichedFieldProps = (0, $407c8e6459946495$export$b25f5d250541f495)({
        wrapperVariant: "desktop",
        fieldType: fieldType,
        open: open,
        actions: actions,
        readOnly: readOnly,
        disableOpenPicker: disableOpenPicker,
        label: label,
        localeText: localeText,
        onBlur: handleBlur,
        rangePosition: rangePosition,
        onRangePositionChange: onRangePositionChange,
        pickerSlotProps: slotProps,
        pickerSlots: slots,
        fieldProps: fieldProps,
        anchorRef: anchorRef,
        startFieldRef: startFieldRef,
        endFieldRef: endFieldRef,
        currentView: layoutProps.view !== props.openTo ? layoutProps.view : undefined,
        initialView: initialView.current ?? undefined,
        onViewChange: layoutProps.onViewChange
    });
    const slotPropsForLayout = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, slotProps, {
        tabs: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, slotProps?.tabs, {
            rangePosition: rangePosition,
            onRangePositionChange: onRangePositionChange
        }),
        toolbar: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, slotProps?.toolbar, {
            rangePosition: rangePosition,
            onRangePositionChange: onRangePositionChange
        })
    });
    const Layout = slots?.layout ?? (0, $fc46d30a907f069d$export$647f604ea2397c05);
    const renderPicker = ()=>/*#__PURE__*/ (0, $3Py8h.jsxs)((0, $ec10b178b7b16965$export$38e969d523d4d57f), {
            contextValue: contextValue,
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)(Field, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, enrichedFieldProps)),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c48ba6440e847340$export$96ce8482474de8a5), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                    role: "tooltip",
                    placement: "bottom-start",
                    containerRef: popperRef,
                    anchorEl: anchorRef.current,
                    onBlur: handleBlur
                }, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    shouldRestoreFocus: shouldRestoreFocus,
                    reduceAnimations: reduceAnimations,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)(Layout, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, layoutProps, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotPropsForLayout,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};



"use client";
/**
 * Demos:
 *
 * - [DateRangePicker](https://mui.com/x/react-date-pickers/date-range-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDateRangePicker API](https://mui.com/x/api/date-pickers/desktop-date-range-picker/)
 */ const $fac29caa652f9351$export$55b7a82fef218f2e = /*#__PURE__*/ $1T1QG.forwardRef(function DesktopDateRangePicker(inProps, ref) {
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, $dafa228b7a272213$export$b30bf963bdbf4d5b)(inProps, "MuiDesktopDateRangePicker");
    const viewRenderers = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        day: (0, $3991f640cd3f6217$export$5aac1f02b93501aa)
    }, defaultizedProps.viewRenderers);
    const props = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        calendars: defaultizedProps.calendars ?? 2,
        views: [
            "day"
        ],
        openTo: "day",
        slots: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
            field: (0, $95175d64e549e18d$export$806f5cf21816db1e)
        }, defaultizedProps.slots),
        slotProps: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, (0, $381cff6a989e76ba$export$2e2bcd8739ae039)(defaultizedProps.slotProps?.field, ownerState), (0, $5aeaf2f033f161b7$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                hidden: true
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $f7a71ec1d9c49886$export$caa24fbbedf06392)({
        props: props,
        valueManager: (0, $f59e62e9d03b263b$export$f0e1e223b0d1e9e1),
        valueType: "date",
        validator: (0, $dc7177be3348d05c$export$b3e10550232e39db)
    });
    return renderPicker();
});
$fac29caa652f9351$export$55b7a82fef218f2e.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * The number of calendars to render on **desktop**.
   * @default 2
   */ calendars: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        1,
        2,
        3
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * Position the current month is rendered in.
   * @default 1
   */ currentMonthCalendarPosition: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        1,
        2,
        3
    ]),
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * The initial position in the edited date range.
   * Used when the component is not controlled.
   * @default 'start'
   */ defaultRangePosition: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "end",
        "start"
    ]),
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object),
    /**
   * If `true`, after selecting `start` date calendar will not automatically switch to the month of `end` date.
   * @default false
   */ disableAutoMonthSwitching: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, editing dates by dragging is disabled.
   * @default false
   */ disableDragEditing: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   * Ignored if the field has several inputs.
   */ inputRef: (0, $12e3e097abfa372a$export$2e2bcd8739ae039),
    /**
   * The label content.
   * Ignored if the field has several inputs.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Name attribute used by the `input` element in the Field.
   * Ignored if the field has several inputs.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the range position changes.
   * @param {RangePosition} rangePosition The new range position.
   */ onRangePositionChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * The position in the currently edited date range.
   * Used when the component position is controlled.
   */ rangePosition: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "end",
        "start"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Component rendered on the "day" view when `props.loading` is true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => "..."
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
            "all",
            "day",
            "empty",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @param {string} position The date to test, 'start' or 'end'.
   * @returns {boolean} Returns `true` if the date should be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func
    })
};




var $1T1QG = parcelRequire("1T1QG");

var $ajKsV = parcelRequire("ajKsV");










var $1T1QG = parcelRequire("1T1QG");










var $3Py8h = parcelRequire("3Py8h");
const $52185712ee9410d1$var$_excluded = [
    "props"
];
const $52185712ee9410d1$var$releaseInfo = (0, $555d1ccddbab635a$export$edcd7d0b4c3818f)();
const $52185712ee9410d1$export$cb5e55a8cf673aad = (_ref)=>{
    let { props: props } = _ref, pickerParams = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(_ref, $52185712ee9410d1$var$_excluded);
    (0, $d8fb333063125c1d$export$bd780281ba7bfd9)("x-date-pickers-pro", $52185712ee9410d1$var$releaseInfo);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezone, label: label, inputRef: inputRef, name: name, readOnly: readOnly, disabled: disabled, disableOpenPicker: disableOpenPicker, localeText: localeText } = props;
    const startFieldRef = $1T1QG.useRef(null);
    const endFieldRef = $1T1QG.useRef(null);
    const fieldType = slots.field.fieldType ?? "multi-input";
    const { rangePosition: rangePosition, onRangePositionChange: onRangePositionChange } = (0, $dc8e84b7e4c1bc1b$export$a08461734e712d56)(props, fieldType === "single-input" ? startFieldRef : undefined);
    const labelId = (0, $ea1f3283f0dc1f21$export$2e2bcd8739ae039)();
    const contextTranslations = (0, $23b03662f60cdb73$export$3cdcc56057891b44)();
    const { open: open, actions: actions, layoutProps: layoutProps, renderCurrentView: renderCurrentView, fieldProps: pickerFieldProps, contextValue: contextValue } = (0, $ad286f8dcf1caecc$export$fc3313977ac596c4)((0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, pickerParams, {
        props: props,
        wrapperVariant: "mobile",
        autoFocusView: true,
        fieldRef: rangePosition === "start" ? startFieldRef : endFieldRef,
        additionalViewProps: {
            rangePosition: rangePosition,
            onRangePositionChange: onRangePositionChange
        }
    }));
    const Field = slots.field;
    const fieldProps = (0, $ae26363b02eac268$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, pickerFieldProps, {
            readOnly: readOnly ?? true,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            timezone: timezone
        }, fieldType === "single-input" ? {
            inputRef: inputRef,
            name: name
        } : {}),
        ownerState: props
    });
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const enrichedFieldProps = (0, $407c8e6459946495$export$b25f5d250541f495)({
        wrapperVariant: "mobile",
        fieldType: fieldType,
        open: open,
        actions: actions,
        readOnly: readOnly,
        labelId: labelId,
        disableOpenPicker: disableOpenPicker,
        label: label,
        localeText: localeText,
        rangePosition: rangePosition,
        onRangePositionChange: onRangePositionChange,
        pickerSlots: slots,
        pickerSlotProps: innerSlotProps,
        fieldProps: fieldProps,
        startFieldRef: startFieldRef,
        endFieldRef: endFieldRef
    });
    const slotPropsForLayout = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, innerSlotProps, {
        tabs: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, innerSlotProps?.tabs, {
            rangePosition: rangePosition,
            onRangePositionChange: onRangePositionChange
        }),
        toolbar: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, innerSlotProps?.toolbar, {
            titleId: labelId,
            rangePosition: rangePosition,
            onRangePositionChange: onRangePositionChange
        })
    });
    const Layout = slots?.layout ?? (0, $fc46d30a907f069d$export$647f604ea2397c05);
    const finalLocaleText = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, contextTranslations, localeText);
    let labelledById = pickerParams.valueType === "date-time" ? `${labelId}-start-toolbar ${labelId}-end-toolbar` : labelId;
    if (isToolbarHidden) {
        const labels = [];
        if (fieldType === "multi-input") {
            if (finalLocaleText.start) labels.push(`${labelId}-start-label`);
            if (finalLocaleText.end) labels.push(`${labelId}-end-label`);
        } else if (label != null) labels.push(`${labelId}-label`);
        labelledById = labels.length > 0 ? labels.join(" ") : undefined;
    }
    const slotProps = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, innerSlotProps, {
        mobilePaper: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
            "aria-labelledby": labelledById
        }, innerSlotProps?.mobilePaper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $3Py8h.jsxs)((0, $ec10b178b7b16965$export$38e969d523d4d57f), {
            contextValue: contextValue,
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)(Field, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, enrichedFieldProps)),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $0b3498b415bfec38$export$99f83c99e1491f77), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)(Layout, (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, layoutProps, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotPropsForLayout,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};



"use client";
/**
 * Demos:
 *
 * - [DateRangePicker](https://mui.com/x/react-date-pickers/date-range-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDateRangePicker API](https://mui.com/x/api/date-pickers/mobile-date-range-picker/)
 */ const $93cdc713c5b00f91$export$8a80efd334695326 = /*#__PURE__*/ $1T1QG.forwardRef(function MobileDateRangePicker(inProps, ref) {
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, $dafa228b7a272213$export$b30bf963bdbf4d5b)(inProps, "MuiMobileDateRangePicker");
    const viewRenderers = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        day: (0, $3991f640cd3f6217$export$5aac1f02b93501aa)
    }, defaultizedProps.viewRenderers);
    const props = (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        // Force one calendar on mobile to avoid layout issues
        calendars: 1,
        views: [
            "day"
        ],
        openTo: "day",
        slots: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
            field: (0, $95175d64e549e18d$export$806f5cf21816db1e)
        }, defaultizedProps.slots),
        slotProps: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $c73b223a8889eea2$export$2e2bcd8739ae039)({}, (0, $381cff6a989e76ba$export$2e2bcd8739ae039)(defaultizedProps.slotProps?.field, ownerState), (0, $5aeaf2f033f161b7$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                }),
            toolbar: (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
                hidden: false
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $52185712ee9410d1$export$cb5e55a8cf673aad)({
        props: props,
        valueManager: (0, $f59e62e9d03b263b$export$f0e1e223b0d1e9e1),
        valueType: "date",
        validator: (0, $dc7177be3348d05c$export$b3e10550232e39db)
    });
    return renderPicker();
});
$93cdc713c5b00f91$export$8a80efd334695326.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * Position the current month is rendered in.
   * @default 1
   */ currentMonthCalendarPosition: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        1,
        2,
        3
    ]),
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * The initial position in the edited date range.
   * Used when the component is not controlled.
   * @default 'start'
   */ defaultRangePosition: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "end",
        "start"
    ]),
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object),
    /**
   * If `true`, after selecting `start` date calendar will not automatically switch to the month of `end` date.
   * @default false
   */ disableAutoMonthSwitching: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, editing dates by dragging is disabled.
   * @default false
   */ disableDragEditing: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * @default false
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   * Ignored if the field has several inputs.
   */ inputRef: (0, $12e3e097abfa372a$export$2e2bcd8739ae039),
    /**
   * The label content.
   * Ignored if the field has several inputs.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Name attribute used by the `input` element in the Field.
   * Ignored if the field has several inputs.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the range position changes.
   * @param {RangePosition} rangePosition The new range position.
   */ onRangePositionChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * The position in the currently edited date range.
   * Used when the component position is controlled.
   */ rangePosition: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
        "end",
        "start"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Component rendered on the "day" view when `props.loading` is true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => "..."
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOf([
            "all",
            "day",
            "empty",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @param {string} position The date to test, 'start' or 'end'.
   * @returns {boolean} Returns `true` if the date should be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).object),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($ajKsV))).func
    })
};



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $214dd2d53e0624bf$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DateRangePicker](https://mui.com/x/react-date-pickers/date-range-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DateRangePicker API](https://mui.com/x/api/date-pickers/date-range-picker/)
 */ const $214dd2d53e0624bf$export$17334619f3ac2224 = /*#__PURE__*/ $1T1QG.forwardRef(function DateRangePicker(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiDateRangePicker"
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = "@media (pointer: fine)" } = props, other = (0, $0096c5b24842924c$export$2e2bcd8739ae039)(props, $214dd2d53e0624bf$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $ffad103d3c7e3bc8$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $fac29caa652f9351$export$55b7a82fef218f2e), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $93cdc713c5b00f91$export$8a80efd334695326), (0, $c73b223a8889eea2$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
});






const $b0aec8b3581687ed$var$BASE_URL = `${(0, $5d4b99a1a33ba093$export$ff0725f0ea898f41)}/reports`;
const $b0aec8b3581687ed$var$getCataloguesReport = (customerIds, validFrom, validUntil)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).post(`${$b0aec8b3581687ed$var$BASE_URL}/catalogues`, {
        customerIds: customerIds,
        validFrom: validFrom,
        validUntil: validUntil
    });
};
const $b0aec8b3581687ed$var$getRightsReport = (customerIds, validFrom, validUntil)=>{
    return (0, $3b00cda3143fd0d7$export$388e0302ca0d9a41).post(`${$b0aec8b3581687ed$var$BASE_URL}/rights`, {
        customerIds: customerIds,
        validFrom: validFrom,
        validUntil: validUntil
    });
};
const $b0aec8b3581687ed$export$3e8100f11d458d8a = {
    getCataloguesReport: $b0aec8b3581687ed$var$getCataloguesReport,
    getRightsReport: $b0aec8b3581687ed$var$getRightsReport
};



var $ee89b1ae154d8a0b$exports = {};
/* jshint node:true */ "use strict";
var $3f346febc6aa8e36$exports = {};
/* jshint node:true */ "use strict";
var $5282f2faa25a6c91$exports = {};
var $c5db9e86a9d356e0$exports = {};
/* jshint node:true */ "use strict";

$c5db9e86a9d356e0$exports = (parcelRequire("3ZE5p")).EOL;


var $d84b5ca440652dd5$export$f6e2535fb5126e54;
var $d84b5ca440652dd5$export$43bee75e5e14138e;
var $d84b5ca440652dd5$export$a6cdc56e425d0d0a;
var $d84b5ca440652dd5$export$844ec244b1367d54;
var $d84b5ca440652dd5$export$7e4aa119212bc614;
var $d84b5ca440652dd5$export$f9ce7b637dfbe238;
var $d84b5ca440652dd5$export$871608497c498473;
"use strict";
$d84b5ca440652dd5$export$f6e2535fb5126e54 = (fn)=>{
    var getType = {};
    return fn && getType.toString.call(fn) === "[object Function]";
};
$d84b5ca440652dd5$export$43bee75e5e14138e = (arr)=>Array.isArray(arr);
$d84b5ca440652dd5$export$a6cdc56e425d0d0a = (obj)=>obj instanceof Object;
$d84b5ca440652dd5$export$844ec244b1367d54 = (str)=>typeof str === "string";
$d84b5ca440652dd5$export$7e4aa119212bc614 = (num)=>typeof num === "number";
$d84b5ca440652dd5$export$f9ce7b637dfbe238 = (bool)=>typeof bool === "boolean";
$d84b5ca440652dd5$export$871608497c498473 = (date)=>date instanceof Date;


$5282f2faa25a6c91$exports = function joinRows(rows, join) {
    if (!rows || !$d84b5ca440652dd5$export$43bee75e5e14138e(rows)) throw new TypeError('Invalid params "rows" for joinRows. Must be an array of string.');
    //Merge all rows in a single output with the correct End of Line string
    var r = rows.join(join || $c5db9e86a9d356e0$exports || "\n");
    return r;
};


var $af99786a60f121c0$exports = {};
/* jshint node:true */ "use strict";

class $af99786a60f121c0$var$Handler {
    constructor(options){
        this._options = options;
        // an object of {typeName:(value,index,parent)=>any}
        this._options.typeHandlers = this._options.typeHandlers || {};
    }
    /**
   * Check if results needing mapping to alternate value
   *
   * @returns [{item, value}] result
   */ _setHeaders(result, item) {
        let self = this;
        if (!item) return result;
        return result.map(function(element) {
            element.item = element.item ? item + self._options.headerPathString + element.item : item;
            return element;
        });
    }
    castValue(element, item, index, parent) {
        //cast by matching constructor
        const types = this._options.typeHandlers;
        for(let type in types)if ($af99786a60f121c0$var$isInstanceOfTypeName(element, type)) {
            element = types[type].call(types, element, index, parent);
            break; //first match we move on
        }
        return element;
    }
    checkComplex(element, item) {
        //Check if element is a Date
        if ($d84b5ca440652dd5$export$871608497c498473(element)) return [
            {
                item: item,
                value: (this._options.handleDate || this._handleDate)(element, item)
            }
        ];
        else if ($d84b5ca440652dd5$export$43bee75e5e14138e(element)) {
            var resultArray = this._handleArray(element, item);
            return this._setHeaders(resultArray, item);
        } else if ($d84b5ca440652dd5$export$a6cdc56e425d0d0a(element)) {
            var resultObject = this._handleObject(element);
            return this._setHeaders(resultObject, item);
        }
        return [
            {
                item: item,
                value: ""
            }
        ];
    }
    /**
   * Check the element type of the element call the correct handle function
   *
   * @param element Element that will be checked
   * @param item Used to make the headers/path breadcrumb
   * @returns [{item, value}] result
   */ check(element, item, index, parent) {
        element = this.castValue(element, item, index, parent);
        // try simple value by highier performance switch
        switch(typeof element){
            case "string":
                return [
                    {
                        item: item,
                        value: this._handleString(element, item)
                    }
                ];
            case "number":
                return [
                    {
                        item: item,
                        value: this._handleNumber(element, item)
                    }
                ];
            case "boolean":
                return [
                    {
                        item: item,
                        value: this._handleBoolean.bind(this)(element, item)
                    }
                ];
        }
        return this.checkComplex(element, item);
    }
    /**
   * Handle all Objects
   *
   * @param {Object} obj
   * @returns [{item, value}] result
   */ _handleObject(obj) {
        var result = [];
        //Look every object props
        for(var prop in obj){
            var propData = obj[prop];
            //Check the propData type
            var resultCheckType = this.check(propData, prop, prop, obj);
            //Append to results aka merge results aka array-append-array
            result = result.concat(resultCheckType);
        }
        return result;
    }
    /**
   * Handle all Arrays, merges arrays with primitive types in a single value
   *
   * @param {Array} array
   * @returns [{item, value}] result
   */ _handleArray(array) {
        let self = this;
        let result = [];
        var firstElementWithoutItem;
        for(let aIndex = 0; aIndex < array.length; ++aIndex){
            let element = array[aIndex];
            //Check the propData type
            var resultCheckType = self.check(element, null, aIndex, array);
            //Check for results without itens, merge all itens with the first occurrence
            if (resultCheckType.length === 0) continue;
            var firstResult = resultCheckType[0];
            if (!firstResult.item && firstElementWithoutItem !== undefined) {
                firstElementWithoutItem.value += self._options.arrayPathString + firstResult.value;
                continue;
            } else if (resultCheckType.length > 0 && !firstResult.item && firstElementWithoutItem === undefined) firstElementWithoutItem = firstResult;
            //Append to results
            result = result.concat(resultCheckType);
        }
        return result;
    }
    /**
   * Handle all Boolean variables, can be replaced with options.handleBoolean
   *
   * @param {Boolean} boolean
   * @returns {String} result
   */ _handleBoolean(boolean) {
        var result;
        //Check for booolean options
        if (boolean) result = this._options.booleanTrueString || "true";
        else result = this._options.booleanFalseString || "false";
        return result;
    }
    /**
   * Handle all String variables, can be replaced with options.handleString
   *
   * @param {String} string
   * @returns {String} string
   */ _handleString(string) {
        return string;
    }
    /**
   * Handle all Number variables, can be replaced with options.handleNumber
   *
   * @param {Number} number
   * @returns {Number} number
   */ _handleNumber(number) {
        return number;
    }
    /**
   * Handle all Date variables, can be replaced with options.handleDate
   *
   * @param {Date} number
   * @returns {string} result
   */ _handleDate(date) {
        return date.toLocaleDateString();
    }
}
$af99786a60f121c0$exports = $af99786a60f121c0$var$Handler;
const $af99786a60f121c0$var$globalScope = typeof window === "undefined" ? $parcel$global : window;
function $af99786a60f121c0$var$isInstanceOfTypeName(element, typeName) {
    if (element instanceof $af99786a60f121c0$var$globalScope[typeName]) return true; //Buffer and complex objects
    //literals in javascript cannot be checked by instance of
    switch(typeof element){
        case "string":
            return typeName === "String";
        case "boolean":
            return typeName === "Boolean";
        case "number":
            return typeName === "Number";
    }
    return false;
}




class $3f346febc6aa8e36$var$Parser {
    constructor(options){
        this._options = options || {};
        this._handler = new $af99786a60f121c0$exports(this._options);
        this._headers = this._options.headers || [];
        this._escape = (parcelRequire("f3yzx"))(this._options.textDelimiter, this._options.rowDelimiter, this._options.forceTextDelimiter);
    }
    /**
   * Generates a CSV file with optional headers based on the passed JSON,
   * with can be an Object or Array.
   *
   * @param {Object|Array} json
   * @param {Function} done(err,csv) - Callback function
   *      if error, returning error in call back.
   *      if csv is created successfully, returning csv output to callback.
   */ parse(json, done, stream) {
        if ($d84b5ca440652dd5$export$43bee75e5e14138e(json)) return done(null, this._parseArray(json, stream));
        else if ($d84b5ca440652dd5$export$a6cdc56e425d0d0a(json)) return done(null, this._parseObject(json));
        return done(new Error("Unable to parse the JSON object, its not an Array or Object."));
    }
    get headers() {
        let headers = this._headers;
        if (this._options.rename && this._options.rename.length > 0) headers = headers.map((header)=>this._options.rename[this._options.headers.indexOf(header)] || header);
        if (this._options.forceTextDelimiter) headers = headers.map((header)=>{
            return `${this._options.textDelimiter}${header}${this._options.textDelimiter}`;
        });
        if (this._options.mapHeaders) headers = headers.map(this._options.mapHeaders);
        return headers.join(this._options.rowDelimiter);
    }
    _checkRows(rows) {
        let lastRow = null;
        let finalRows = [];
        let fillGaps = (col, index)=>col === "" || col === undefined ? lastRow[index] : col;
        for (let row of rows){
            let missing = this._headers.length - row.length;
            if (missing > 0) row = row.concat(Array(missing).join(".").split("."));
            if (lastRow && this._options.fillGaps) row = row.map(fillGaps);
            finalRows.push(row.join(this._options.rowDelimiter));
            lastRow = row;
        }
        return finalRows;
    }
    _parseArray(json, stream) {
        let self = this;
        this._headers = this._headers || [];
        let fileRows = [];
        let outputFile;
        let fillRows;
        let getHeaderIndex = function(header) {
            var index = self._headers.indexOf(header);
            if (index === -1) {
                self._headers.push(header);
                index = self._headers.indexOf(header);
            }
            return index;
        };
        //Generate the csv output
        fillRows = function(result) {
            const rows = [];
            const fillAndPush = (row)=>rows.push(row.map((col)=>col != null ? col : ""));
            // initialize the array with empty strings to handle 'unpopular' headers
            const newRow = ()=>new Array(self._headers.length).fill(null);
            const emptyRowIndexByHeader = {};
            let currentRow = newRow();
            for (let element of result){
                let elementHeaderIndex = getHeaderIndex(element.item);
                if (currentRow[elementHeaderIndex] != undefined) {
                    fillAndPush(currentRow);
                    currentRow = newRow();
                }
                emptyRowIndexByHeader[elementHeaderIndex] = emptyRowIndexByHeader[elementHeaderIndex] || 0;
                // make sure there isn't a empty row for this header
                if (self._options.fillTopRow && emptyRowIndexByHeader[elementHeaderIndex] < rows.length) {
                    rows[emptyRowIndexByHeader[elementHeaderIndex]][elementHeaderIndex] = self._escape(element.value);
                    emptyRowIndexByHeader[elementHeaderIndex] += 1;
                    continue;
                }
                currentRow[elementHeaderIndex] = self._escape(element.value);
                emptyRowIndexByHeader[elementHeaderIndex] += 1;
            }
            // push last row
            if (currentRow.length > 0) fillAndPush(currentRow);
            fileRows = fileRows.concat(self._checkRows(rows));
        };
        for (let item of json){
            //Call checkType to list all items inside this object
            //Items are returned as a object {item: 'Prop Value, Item Name', value: 'Prop Data Value'}
            let itemResult = self._handler.check(item, self._options.mainPathItem, item, json);
            fillRows(itemResult);
        }
        if (!stream && self._options.includeHeaders) //Add the headers to the first line
        fileRows.unshift(this.headers);
        return $5282f2faa25a6c91$exports(fileRows, self._options.endOfLine);
    }
    _parseObject(json) {
        let self = this;
        let fileRows = [];
        let parseResult = [];
        let outputFile;
        let fillRows;
        let horizontalRows = [
            [],
            []
        ];
        fillRows = function(result) {
            var value = result.value || result.value === 0 ? result.value.toString() : self._options.undefinedString;
            value = self._escape(value);
            //Type header;value
            if (self._options.verticalOutput) {
                var row = [
                    result.item,
                    value
                ];
                fileRows.push(row.join(self._options.rowDelimiter));
            } else {
                horizontalRows[0].push(result.item);
                horizontalRows[1].push(value);
            }
        };
        for(var prop in json){
            var prefix = "";
            if (this._options.mainPathItem) prefix = this._options.mainPathItem + this._options.headerPathString;
            parseResult = this._handler.check(json[prop], prefix + prop, prop, json);
            parseResult.forEach(fillRows);
        }
        if (!this._options.verticalOutput) {
            fileRows.push(horizontalRows[0].join(this._options.rowDelimiter));
            fileRows.push(horizontalRows[1].join(this._options.rowDelimiter));
        }
        return $5282f2faa25a6c91$exports(fileRows, this._options.endOfLine);
    }
}
$3f346febc6aa8e36$exports = $3f346febc6aa8e36$var$Parser;


var $93fa77933580ea7d$exports = {};
/* jshint node:true */ "use strict";
var $ffca67c6536e02db$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
$ffca67c6536e02db$exports = $ffca67c6536e02db$var$Stream;

var $hTcvQ = parcelRequire("hTcvQ");
var $ffca67c6536e02db$require$EE = $hTcvQ.EventEmitter;

var $i4ovn = parcelRequire("i4ovn");
$i4ovn($ffca67c6536e02db$var$Stream, $ffca67c6536e02db$require$EE);

$ffca67c6536e02db$var$Stream.Readable = (parcelRequire("9YrrH"));

$ffca67c6536e02db$var$Stream.Writable = (parcelRequire("lwfyI"));

$ffca67c6536e02db$var$Stream.Duplex = (parcelRequire("Yy3ok"));

$ffca67c6536e02db$var$Stream.Transform = (parcelRequire("ib1Ma"));

$ffca67c6536e02db$var$Stream.PassThrough = (parcelRequire("fjWbN"));

$ffca67c6536e02db$var$Stream.finished = (parcelRequire("1pOrD"));

$ffca67c6536e02db$var$Stream.pipeline = (parcelRequire("4IIQ6"));
// Backwards-compat with node 0.4.x
$ffca67c6536e02db$var$Stream.Stream = $ffca67c6536e02db$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $ffca67c6536e02db$var$Stream() {
    $ffca67c6536e02db$require$EE.call(this);
}
$ffca67c6536e02db$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($ffca67c6536e02db$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};


var $93fa77933580ea7d$require$Transform = $ffca67c6536e02db$exports.Transform;
class $93fa77933580ea7d$var$Stream extends $93fa77933580ea7d$require$Transform {
    constructor(parser){
        super();
        this._parser = parser;
        this._options = parser._options;
        this._headers = this._options.headers || [];
        this._hasHeaders = false;
        this._lastError = null;
    }
    _mergeChunk(chunk) {
        let self = this;
        self._extra = self._extra || "";
        // Remove starting comma
        if (self._extra.charAt(0) == ",") self._extra = self._extra.substr(1);
        // Append extra to chunk
        chunk = self._extra + chunk.toString();
        // Clear extra memory
        if (self._extra.length > 0) self._extra = "";
        return chunk;
    }
    _wrapArray(data) {
        if (data.charAt(0) != "[") data = "[" + data;
        if (data.charAt(data.length - 1) != "]") data += "]";
        return data;
    }
    _transform(chunk, encoding, done) {
        let self = this;
        let json = null;
        // Append extra data to chunk data
        chunk = this._mergeChunk(chunk);
        if (!chunk) return done(this._lastError);
        // Split chunk in objects
        let parts = chunk.split("}");
        while(json === null && parts.length > 0)try {
            let data = self._wrapArray(parts.join("}"));
            json = JSON.parse(data);
        } catch (ex) {
            this._lastError = ex;
            let extraChunk = parts.pop();
            self._extra = extraChunk + (self._extra || "");
            if (parts.length > 0) parts[parts.length - 1] += "}";
        }
        if (!json) return done();
        this._parser.parse(json, (err, csvChunk)=>{
            if (err) return done(err);
            if (!self.hasHeaders) {
                self.hasHeaders = true;
                self.push(self._parser.headers);
            }
            self.push(self._options.endOfLine + csvChunk);
            done();
        }, true);
    }
}
$93fa77933580ea7d$exports = $93fa77933580ea7d$var$Stream;




/**
 * Main function that converts json to csv
 *
 * @param {Object|Array} json
 * @param {Object} [options]
 * @param {Function} callback(err, csv) - Callback function
 *      if error, returning error in call back.
 *      if csv is created successfully, returning csv output to callback.
 */ $ee89b1ae154d8a0b$exports = function() {
    const DEFAULT_OPTIONS = {
        headers: [],
        rename: [],
        headerPathString: ".",
        rowDelimiter: ",",
        textDelimiter: '"',
        arrayPathString: ";",
        undefinedString: "",
        endOfLine: $c5db9e86a9d356e0$exports || "\n",
        mainPathItem: null,
        booleanTrueString: null,
        booleanFalseString: null,
        includeHeaders: true,
        fillGaps: false,
        verticalOutput: true,
        forceTextDelimiter: false
    };
    // argument parsing
    let json, userOptions, callback;
    if (arguments.length === 3) [json, userOptions, callback] = arguments;
    else if (arguments.length === 2) {
        let any;
        [json, any] = arguments;
        if (typeof any === "function") callback = any;
        else if (typeof any === "object") userOptions = any;
    } else if (arguments.length === 1) {
        const [any] = arguments;
        if (typeof any === "object") {
            const defaultKeys = Object.keys(DEFAULT_OPTIONS);
            const objectKeys = Object.keys(any);
            const isOptions = objectKeys.every((key)=>defaultKeys.includes(key));
            if (objectKeys.length > 0 && isOptions) userOptions = any;
            else json = any;
        } else json = any;
    } else return new $93fa77933580ea7d$exports(new $3f346febc6aa8e36$exports(DEFAULT_OPTIONS));
    const options = Object.assign({}, DEFAULT_OPTIONS, userOptions);
    const parser = new $3f346febc6aa8e36$exports(options);
    // if no json is provided Stream API will be used
    if (!json) return new $93fa77933580ea7d$exports(parser);
    // always return an promise
    return new Promise((resolve, reject)=>{
        parser.parse(json, (err, result)=>{
            if (callback) return callback(err, result);
            if (err) return reject(err);
            if (reject) return resolve(result);
        });
    });
};




const $2157e273a61cce08$var$Reports = ()=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const { locale: locale } = (0, $268b84bc693ec63f$export$2e2bcd8739ae039)();
    const { isPermission: isPermission } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const [selectedCustomerId, setSelectedCustomerId] = (0, $1T1QG.useState)("");
    const [reportType, setReportType] = (0, $1T1QG.useState)(isPermission("READ", "CATALOGUE_REPORTS") ? "LANDLORD" : "TENANT");
    const initialDateTime = (0, $51c4c2d07d14dea7$exports.DateTime).local().setLocale(locale || "fi");
    const [givenStartDate, setGivenStartDate] = (0, $1T1QG.useState)(initialDateTime.startOf("day"));
    const [givenEndDate, setGivenEndDate] = (0, $1T1QG.useState)(initialDateTime.endOf("day"));
    const queryCustomers = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$6efe1800fcda6819)
        ],
        // TODO Antti: Should be fixed later because there might be more than 500 customers.
        queryFn: ()=>(0, $3af058eac12e21cb$export$2e2bcd8739ae039).getCustomers(false, {
                limit: 500,
                sort: "TYPE",
                direction: "ASC"
            }),
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const customers = queryCustomers.data?.data || [];
    const customerOptions = customers.map((item)=>{
        return {
            key: item.id,
            value: item.name
        };
    });
    if (customerOptions.length > 1) customerOptions.unshift({
        key: "ALL",
        value: intl.formatMessage({
            id: "page.reports.customer.all"
        })
    });
    const customerIds = selectedCustomerId === "ALL" ? customerOptions.slice(1).map((item)=>item.key) : [
        selectedCustomerId
    ];
    const successHandler = async (data)=>{
        if (!data || data.data.length == 0) {
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.reports.toast.error.emptyReport"
            }));
            return;
        }
        try {
            const result = await generateCSVReport(data);
            generateCSVFile(data.reportName, result);
        } catch (e) {
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.reports.toast.error.csvFailed"
            }), false);
        }
    };
    const cataloguesMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $b0aec8b3581687ed$export$3e8100f11d458d8a).getCataloguesReport(customerIds, (0, $8cd8f065b47158d9$export$6ef9dbcccbc4ed7d).toUTC(givenStartDate), (0, $8cd8f065b47158d9$export$6ef9dbcccbc4ed7d).toUTC(givenEndDate)),
        onSuccess: (response)=>successHandler(response.data)
    });
    const rightsMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $b0aec8b3581687ed$export$3e8100f11d458d8a).getRightsReport(customerIds, (0, $8cd8f065b47158d9$export$6ef9dbcccbc4ed7d).toUTC(givenStartDate), (0, $8cd8f065b47158d9$export$6ef9dbcccbc4ed7d).toUTC(givenEndDate)),
        onSuccess: (response)=>successHandler(response.data)
    });
    (0, $1T1QG.useEffect)(()=>{
        if (queryCustomers.isSuccess && !selectedCustomerId && customerOptions.length > 0) setSelectedCustomerId(customerOptions[0].key);
    }, [
        queryCustomers.isSuccess
    ]);
    const generateCSVReport = (reportResponse)=>{
        return new Promise((resolve, reject)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($ee89b1ae154d8a0b$exports)))(reportResponse.data, (err, csv)=>{
                if (err) return reject(new Error("CSV generation failed"));
                resolve(csv);
            });
        });
    };
    const generateCSVFile = (reportName, result)=>{
        const startDate = givenStartDate ? (0, $8cd8f065b47158d9$export$6c3b6c09c58d6bc3).toCustomString(givenStartDate) : "";
        const endDate = givenEndDate ? (0, $8cd8f065b47158d9$export$6c3b6c09c58d6bc3).toCustomString(givenEndDate) : "";
        const filename = `${reportName}-${startDate}-${endDate}`;
        const blob = new Blob([
            result
        ], {
            type: "data:text/csv;charset=utf-8,"
        });
        const blobURL = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.download = `${filename}.csv`;
        anchor.href = blobURL;
        anchor.dataset.downloadurl = [
            "text/csv",
            anchor.download,
            anchor.href
        ].join(":");
        anchor.click();
        // Remove URL.createObjectURL. The browser should not save the reference to the file.
        setTimeout(()=>{
            // For Firefox it is necessary to delay revoking the ObjectURL
            URL.revokeObjectURL(blobURL);
        }, 100);
    };
    const requestReport = ()=>{
        if (!givenStartDate && !givenEndDate && !selectedCustomerId) return;
        switch(reportType){
            case "LANDLORD":
                cataloguesMutation.mutate();
                break;
            case "TENANT":
                rightsMutation.mutate();
                break;
            default:
                (0, $fb47a354e391b3c4$export$16bf6fe03653420f)(reportType);
        }
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b914262cfd70d60a$export$2e2bcd8739ae039), {
        query: queryCustomers,
        rootPageIfNotFoundError: true,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c9560da3d4f68f59$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $d853676d11a33bb6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "page.reports.title"
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)("form", {
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                                container: true,
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                                    item: true,
                                    md: 6,
                                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormContainer, {
                                        children: [
                                            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $019112675a75b38b$export$2e2bcd8739ae039), {
                                                        mutation: cataloguesMutation,
                                                        errorTitleKey: "common.actions.get.error"
                                                    }),
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $019112675a75b38b$export$2e2bcd8739ae039), {
                                                        mutation: rightsMutation,
                                                        errorTitleKey: "common.actions.get.error"
                                                    })
                                                ]
                                            }),
                                            (isPermission("READ", "CATALOGUE_REPORTS") || isPermission("READ", "RIGHT_REPORTS")) && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $016a87b721694d75$export$2e2bcd8739ae039), {
                                                    value: reportType,
                                                    onChange: (event)=>setReportType(event.target.value),
                                                    children: [
                                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormLabel, {
                                                            sx: {
                                                                fontWeight: "bold"
                                                            },
                                                            focused: false,
                                                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                                id: "page.reports.type.radioGroup.title"
                                                            })
                                                        }),
                                                        isPermission("READ", "CATALOGUE_REPORTS") && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormRadio, {
                                                            control: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c7a6a2f699a36e04$export$2e2bcd8739ae039), {}),
                                                            label: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                                id: "page.reports.type.radioGroup.landlord"
                                                            }),
                                                            value: "LANDLORD"
                                                        }),
                                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormRadio, {
                                                            control: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c7a6a2f699a36e04$export$2e2bcd8739ae039), {}),
                                                            label: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                                id: "page.reports.type.radioGroup.tenant"
                                                            }),
                                                            value: "TENANT"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormLabel, {
                                                sx: {
                                                    fontWeight: "bold"
                                                },
                                                focused: false,
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                    id: "page.reports.customer.title"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormSelect, {
                                                    name: "customerId",
                                                    label: intl.formatMessage({
                                                        id: "page.reports.customer.label"
                                                    }),
                                                    value: selectedCustomerId,
                                                    onChange: (event)=>setSelectedCustomerId(event?.target?.value || ""),
                                                    children: customerOptions.map((item)=>{
                                                        return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $450c65ee2dafa292$export$2e2bcd8739ae039), {
                                                            value: item.key,
                                                            children: item.value
                                                        }, item.key);
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormLabel, {
                                                sx: {
                                                    fontWeight: "bold"
                                                },
                                                focused: false,
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                    id: "page.reports.range.title"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $7c26d84ab517f189$export$2e2bcd8739ae039), {
                                                    fullWidth: true,
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $214dd2d53e0624bf$export$17334619f3ac2224), {
                                                        localeText: {
                                                            start: intl.formatMessage({
                                                                id: "page.reports.daterange.start"
                                                            }),
                                                            end: intl.formatMessage({
                                                                id: "page.reports.daterange.end"
                                                            }),
                                                            toolbarTitle: intl.formatMessage({
                                                                id: "page.reports.range.title"
                                                            }),
                                                            cancelButtonLabel: intl.formatMessage({
                                                                id: "common.buttons.cancel"
                                                            }),
                                                            clearButtonLabel: intl.formatMessage({
                                                                id: "common.buttons.clear"
                                                            }),
                                                            okButtonLabel: intl.formatMessage({
                                                                id: "common.ok"
                                                            })
                                                        },
                                                        value: [
                                                            givenStartDate,
                                                            givenEndDate
                                                        ],
                                                        displayWeekNumber: true,
                                                        onAccept: (values)=>{
                                                            const startDate = values[0];
                                                            const endDate = values[1];
                                                            setGivenStartDate(startDate || initialDateTime.startOf("day"));
                                                            setGivenEndDate(endDate || initialDateTime.endOf("day"));
                                                        }
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                                                children: (isPermission("READ", "CATALOGUE_REPORTS") || isPermission("READ", "RIGHT_REPORTS")) && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                                                    onClick: requestReport,
                                                    mutation: reportType === "LANDLORD" ? cataloguesMutation : rightsMutation,
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                        id: "page.reports.submit.button"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $2157e273a61cce08$export$2e2bcd8739ae039 = $2157e273a61cce08$var$Reports;



var $3Py8h = parcelRequire("3Py8h");




var $3Py8h = parcelRequire("3Py8h");

var $3Py8h = parcelRequire("3Py8h");


var $1T1QG = parcelRequire("1T1QG");


var $eUHG3 = parcelRequire("eUHG3");


const $2cfcb318198695d7$var$FormEditRightHolder = (props)=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const getRightHolderValues = ()=>{
        let firstName, lastName, email, phoneNumber, licensePlate = "";
        if (props.rightHolder?.type === "individual") {
            const dataIndividual = props.rightHolder;
            firstName = dataIndividual.firstName;
            lastName = dataIndividual.lastName;
            email = dataIndividual.email;
            phoneNumber = dataIndividual.phoneNumber;
        } else if (props.rightHolder?.type === "vehicle") {
            const dataVehicle = props.rightHolder;
            licensePlate = dataVehicle.licensePlate;
        }
        return {
            firstName: firstName,
            lastName: lastName,
            email: email,
            phoneNumber: phoneNumber,
            licensePlate: licensePlate
        };
    };
    const getFormDefaultValues = ()=>{
        const { firstName: firstName, lastName: lastName, email: email, phoneNumber: phoneNumber, licensePlate: licensePlate } = getRightHolderValues();
        return {
            firstName: firstName || "",
            lastName: lastName || "",
            email: email || "",
            phoneNumber: phoneNumber || "",
            licensePlate: licensePlate || ""
        };
    };
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $1T1QG.useState)(false);
    const schemaValidator = ()=>{
        return $d7c41ae3ced691f5$export$be5493f9613cbbe().shape({
            firstName: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().test("firstName", intl.formatMessage({
                id: "common.form.errors.empty"
            }), function(firstName) {
                return props.rightHolder?.type !== "individual" || !!firstName;
            }),
            lastName: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().test("lastName", intl.formatMessage({
                id: "common.form.errors.empty"
            }), function(lastName) {
                return props.rightHolder?.type !== "individual" || !!lastName;
            }),
            email: $d7c41ae3ced691f5$export$22b082955e083ec3().test("email", intl.formatMessage({
                id: "common.form.errors.email"
            }), function(email) {
                return props.rightHolder?.type !== "individual" || (0, $5ed07630ed21dadb$export$371e338370561054)(email);
            }),
            phoneNumber: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().test("phoneNumber", intl.formatMessage({
                id: "common.form.errors.phoneNumber"
            }), function(phoneNumber) {
                return props.rightHolder?.type !== "individual" || (0, $5ed07630ed21dadb$export$dda1dcb0216445cd)(phoneNumber);
            }),
            licensePlate: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().test("licensePlate", intl.formatMessage({
                id: "common.form.errors.licensePlate"
            }), function(licensePlate) {
                return props.rightHolder?.type !== "vehicle" || (0, $5ed07630ed21dadb$export$dddb845077defee2)(licensePlate);
            })
        });
    };
    const onSubmitFormValues = (values)=>{
        const { firstName: firstName, lastName: lastName, email: email, phoneNumber: phoneNumber, licensePlate: licensePlate } = values;
        if (props.rightHolder?.type === "individual") props.onSubmit({
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            email: email.trim(),
            phoneNumber: phoneNumber
        });
        else props.onSubmit({
            firstName: undefined,
            lastName: undefined,
            email: undefined,
            phoneNumber: undefined,
            licensePlate: licensePlate.trim().toLocaleUpperCase()
        });
    };
    const FormIndividual = ({ values: values, handleChange: handleChange, errors: errors })=>{
        return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                            name: "firstName",
                            "data-testid": "firstName",
                            value: values.firstName,
                            label: intl.formatMessage({
                                id: "page.rightHolders.rightHolder.formEditRightHolder.label.firstName"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.rightHolders.rightHolder.formEditRightHolder.label.firstName"
                            }),
                            onChange: handleChange,
                            error: !!errors.firstName,
                            errorText: errors.firstName
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                            name: "lastName",
                            "data-testid": "lastName",
                            value: values.lastName,
                            label: intl.formatMessage({
                                id: "page.rightHolders.rightHolder.formEditRightHolder.label.lastName"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.rightHolders.rightHolder.formEditRightHolder.label.lastName"
                            }),
                            onChange: handleChange,
                            error: !!errors.lastName,
                            errorText: errors.lastName
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormBoxRow, {
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                            name: "email",
                            "data-testid": "email",
                            value: values.email,
                            label: intl.formatMessage({
                                id: "common.text.email"
                            }),
                            placeholder: intl.formatMessage({
                                id: "common.text.email"
                            }),
                            onChange: handleChange,
                            error: !!errors.email,
                            errorText: errors.email
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                            name: "phoneNumber",
                            "data-testid": "phoneNumber",
                            value: values.phoneNumber,
                            label: intl.formatMessage({
                                id: "page.rightHolders.rightHolder.formEditRightHolder.label.phoneNumber"
                            }),
                            placeholder: intl.formatMessage({
                                id: "page.rightHolders.rightHolder.formEditRightHolder.label.phoneNumber"
                            }),
                            onChange: handleChange,
                            error: !!errors.phoneNumber,
                            errorText: errors.phoneNumber
                        })
                    ]
                })
            ]
        });
    };
    const FormVehicle = ({ values: values, handleChange: handleChange, errors: errors })=>{
        return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                name: "licensePlate",
                "data-testid": "licensePlate",
                value: values.licensePlate,
                label: intl.formatMessage({
                    id: "common.text.licensePlate"
                }),
                placeholder: intl.formatMessage({
                    id: "common.text.licensePlate"
                }),
                onChange: handleChange,
                error: !!errors.licensePlate,
                errorText: errors.licensePlate
            })
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $eUHG3.Formik), {
            validate: ()=>setFormikValidateOnChange(true),
            validationSchema: schemaValidator(),
            enableReinitialize: true,
            initialValues: getFormDefaultValues(),
            validateOnChange: formikValidateOnChange,
            onSubmit: (values)=>{
                onSubmitFormValues(values);
            },
            children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $3Py8h.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: props.formReference,
                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            props.rightHolder?.type === "individual" && /*#__PURE__*/ (0, $3Py8h.jsx)(FormIndividual, {
                                values: values,
                                handleChange: handleChange,
                                errors: errors
                            }),
                            props.rightHolder?.type === "vehicle" && /*#__PURE__*/ (0, $3Py8h.jsx)(FormVehicle, {
                                values: values,
                                handleChange: handleChange,
                                errors: errors
                            })
                        ]
                    })
                })
        })
    });
};
var $2cfcb318198695d7$export$2e2bcd8739ae039 = $2cfcb318198695d7$var$FormEditRightHolder;









const $5594b4cafad53d4a$var$ModalEditRightHolder = (props)=>{
    const FORM_REFERENCE = "formEditRightHolder";
    const updateRightHolderMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $bfd03858b5cf8c88$export$2e2bcd8739ae039).updateIndividual(props.rightHolderRef, dto),
        onSuccess: (response)=>{
            const rightHolder = response.data || {};
            let name = "";
            if (rightHolder?.type === "individual") {
                const dataIndividual = rightHolder;
                name = (0, $9efc3d7accb9d2fe$export$e49861a9373f5f25)(dataIndividual);
            } else if (rightHolder?.type === "vehicle") {
                const dataVehicle = rightHolder;
                name = (0, $9efc3d7accb9d2fe$export$e49861a9373f5f25)(dataVehicle);
            }
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.rightHolders.rightHolder.modalEditRightHolder.actions.update",
                values: {
                    name: name
                }
            }));
            props.onSubmit(rightHolder);
        }
    });
    const updateIndividual = (values)=>{
        const { firstName: firstName, lastName: lastName, email: email, phoneNumber: phoneNumber } = values;
        if (props?.rightHolder.kind === "individual") {
            const originalDTO = props.rightHolder.dto;
            const dto = {
                type: "individual",
                firstName: (0, $fb47a354e391b3c4$export$b9d2d3b623c012b1)(firstName, originalDTO.firstName),
                lastName: (0, $fb47a354e391b3c4$export$b9d2d3b623c012b1)(lastName, originalDTO.lastName),
                email: (0, $fb47a354e391b3c4$export$b9d2d3b623c012b1)(email, originalDTO.email),
                phoneNumber: (0, $fb47a354e391b3c4$export$b34d9e7bbdff763e)(phoneNumber)
            };
            updateRightHolderMutation.mutate(dto);
        } else console.error("Save prevented because there is not valid right holder type.");
    };
    const cancel = ()=>{
        updateRightHolderMutation.reset();
        props.onCancel();
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $259d9dbb3544503a$export$2e2bcd8739ae039), {
            open: props.open,
            onCancel: cancel,
            formReference: FORM_REFERENCE,
            mutation: updateRightHolderMutation,
            errorTitleKey: "common.actions.update.error",
            modalTitle: props?.rightHolder.kind === "individual" ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.rightHolders.rightHolder.modalEditRightHolder.title.individual"
            }) : /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.rightHolders.rightHolder.modalEditRightHolder.title.vehicle"
            }),
            submitButtonContent: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "common.buttons.save"
            }),
            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $2cfcb318198695d7$export$2e2bcd8739ae039), {
                formReference: FORM_REFERENCE,
                rightHolder: props.rightHolder.dto,
                onSubmit: updateIndividual
            })
        })
    });
};
var $5594b4cafad53d4a$export$2e2bcd8739ae039 = $5594b4cafad53d4a$var$ModalEditRightHolder;




var $1T1QG = parcelRequire("1T1QG");




var $f8ca87aa0040398a$exports = {};
"use strict";
"use client";

Object.defineProperty($f8ca87aa0040398a$exports, "__esModule", {
    value: true
});
$f8ca87aa0040398a$exports.default = void 0;

var $f8ca87aa0040398a$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $f8ca87aa0040398a$var$_default = $f8ca87aa0040398a$exports.default = (0, $f8ca87aa0040398a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-.4 4.25-6.54 4.09c-.65.41-1.47.41-2.12 0L4.4 8.25c-.25-.16-.4-.43-.4-.72 0-.67.73-1.07 1.3-.72L12 11l6.7-4.19c.57-.35 1.3.05 1.3.72 0 .29-.15.56-.4.72"
}), "MailRounded");


var $794fd59fa086bc59$exports = {};
"use strict";
"use client";

Object.defineProperty($794fd59fa086bc59$exports, "__esModule", {
    value: true
});
$794fd59fa086bc59$exports.default = void 0;

var $794fd59fa086bc59$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $794fd59fa086bc59$var$_default = $794fd59fa086bc59$exports.default = (0, $794fd59fa086bc59$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4"
}), "PersonRounded");


var $f10f2c61eb2000af$exports = {};
"use strict";
"use client";

Object.defineProperty($f10f2c61eb2000af$exports, "__esModule", {
    value: true
});
$f10f2c61eb2000af$exports.default = void 0;

var $f10f2c61eb2000af$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $f10f2c61eb2000af$var$_default = $f10f2c61eb2000af$exports.default = (0, $f10f2c61eb2000af$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "m19.23 15.26-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98"
}), "PhoneRounded");




var $3Py8h = parcelRequire("3Py8h");







var $3Py8h = parcelRequire("3Py8h");


var $1T1QG = parcelRequire("1T1QG");









const $c3db903ea74e85fe$var$TableVehicles = (props)=>{
    const queryClient = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)();
    const navigate = (0, $e0cff2801449e77d$export$9770f232ac06a008)();
    const [showModalEditVehicle, setShowModalEditVehicle] = (0, $1T1QG.useState)(undefined);
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const { locale: locale } = (0, $268b84bc693ec63f$export$2e2bcd8739ae039)();
    const RenderVehicleData = ({ vehicle: vehicle })=>{
        return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
            children: vehicle.rights.map((right)=>/*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                    onClick: ()=>navigate(`${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).RIGHTS}/${right.id}`),
                    hover: true,
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                                utcDateTime: vehicle.createdAt
                            })
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $041febe0dbc86e0a$export$2e2bcd8739ae039), {
                                children: vehicle.licensePlate
                            })
                        }),
                        /*#__PURE__*/ (0, $3Py8h.jsx)(RenderRightData, {
                            licensePlate: vehicle.licensePlate,
                            right: right
                        })
                    ]
                }, right.id))
        });
    };
    const RenderRightData = ({ licensePlate: licensePlate, right: right })=>{
        return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                    children: right.offering?.name
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                    children: right.place?.name
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                        utcDateTime: right.validityStart
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                        utcDateTime: right?.validityEnd,
                        emptyText: intl.formatMessage({
                            id: "page.rightHolders.rightHolder.tab.vehicles.table.item.permanent"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)(RenderButton, {
                    licensePlate: licensePlate,
                    right: right
                })
            ]
        });
    };
    const isEndableRight = (right)=>{
        return props.allowToEndRight && right && (!right.validityEnd || (0, $8cd8f065b47158d9$export$6ef9dbcccbc4ed7d).fromUTC(right.validityEnd, locale) > (0, $51c4c2d07d14dea7$exports.DateTime).now());
    };
    const RenderButton = ({ licensePlate: licensePlate, right: right })=>{
        return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $15827f0d92c5ff99$export$2e2bcd8739ae039), {
            action: "EDIT",
            resource: "RIGHTS",
            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                children: isEndableRight(right) && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $041febe0dbc86e0a$export$2e2bcd8739ae039), {
                    bold: true,
                    onClick: (evt)=>{
                        evt.stopPropagation();
                        setShowModalEditVehicle({
                            licensePlate: licensePlate,
                            costCenter: right.costCenter,
                            project: right.project,
                            rightId: right.id,
                            catalogueId: right.catalogueId
                        });
                    },
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                        id: "common.buttons.edit"
                    })
                })
            })
        });
    };
    const RenderGridVehicleData = ({ vehicle: vehicle })=>{
        return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8002a2b5b87a23eb$export$2e2bcd8739ae039), {
            emptyTextId: "page.rightHolders.rightHolder.tab.vehicles.table.action.empty",
            errorTextId: "page.rightHolders.rightHolder.tab.vehicles.table.action.failed",
            query: props.queryRightHolder,
            children: vehicle.rights.map((right)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0829f6a75e4b5e7$export$2e2bcd8739ae039), {
                    onCardClicked: ()=>navigate(`${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).RIGHTS}/${right.id}`),
                    cardTitle: vehicle.licensePlate,
                    cardSecondaryTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                        utcDateTime: vehicle.createdAt
                    }),
                    cardContentList: getGridRightData(right),
                    cardMenuActions: getMenuItems(vehicle, right)
                }, vehicle.id))
        });
    };
    const getGridRightData = (right)=>{
        const getBySpace = (first, second)=>{
            return /*#__PURE__*/ (0, $3Py8h.jsxs)("div", {
                children: [
                    first,
                    " ",
                    second
                ]
            });
        };
        return [
            getBySpace(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.location"
            }), right?.place?.name),
            getBySpace(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.right"
            }), /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
                children: right?.offering?.name
            })),
            getBySpace(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.startRight"
            }), /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                utcDateTime: right?.validityStart
            })),
            getBySpace(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.rightHolders.rightHolder.tab.vehicles.table.mobileCard.endRight"
            }), /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                utcDateTime: right?.validityEnd,
                emptyText: intl.formatMessage({
                    id: "page.rightHolders.rightHolder.tab.vehicles.table.item.permanent"
                })
            }))
        ];
    };
    const getMenuItems = (vehicle, right)=>{
        return isEndableRight(right) ? [
            {
                itemText: intl.formatMessage({
                    id: "common.buttons.edit"
                }),
                onClick: ()=>setShowModalEditVehicle({
                        licensePlate: vehicle.licensePlate,
                        rightId: right.id,
                        catalogueId: right.catalogueId
                    })
            }
        ] : undefined;
    };
    const closeModalsAndRefresh = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                (0, $ec0c9d75a0d3a81a$export$475c1d76a7297be4),
                props.rightHolderId
            ]
        });
        setShowModalEditVehicle(undefined);
        props.refreshOffering();
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8002a2b5b87a23eb$export$2e2bcd8739ae039), {
                emptyTextId: "page.rightHolders.rightHolder.tab.vehicles.table.action.empty",
                errorTextId: "page.rightHolders.rightHolder.tab.vehicles.table.action.failed",
                query: props.queryRightHolder,
                children: props.vehicleRightHolders.map((row)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $1T1QG.Fragment), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)(RenderGridVehicleData, {
                            vehicle: row
                        })
                    }, row.id))
            }),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $c6e866c0d03fba92$export$2e2bcd8739ae039), {
                items: props.vehicleRightHolders,
                emptyTextId: "page.rightHolders.rightHolder.tab.vehicles.table.action.empty",
                errorTextId: "page.rightHolders.rightHolder.tab.vehicles.table.action.failed",
                query: props.queryRightHolder,
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b52028b37ea87ec4$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $d09e02ed62af0fe1$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "page.rightHolders.rightHolder.tab.vehicles.table.header.createdAt"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "common.text.licensePlate"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "page.rightHolders.rightHolder.tab.vehicles.table.header.right"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "page.rightHolders.rightHolder.tab.vehicles.table.header.place"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "page.rightHolders.rightHolder.tab.vehicles.table.header.validFrom"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "page.rightHolders.rightHolder.tab.vehicles.table.header.validUntil"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e274ae4234486f8c$export$2e2bcd8739ae039), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a3b5a93a68cc46b9$export$2e2bcd8739ae039), {
                        "data-testid": "places-table-body",
                        children: props.vehicleRightHolders.map((row)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $1T1QG.Fragment), {
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)(RenderVehicleData, {
                                    vehicle: row
                                })
                            }, row.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $362423ed72ac6e25$export$2e2bcd8739ae039), {
                open: !!showModalEditVehicle,
                rightId: showModalEditVehicle?.rightId || "",
                catalogueId: showModalEditVehicle?.catalogueId || "",
                licensePlate: showModalEditVehicle?.licensePlate || "",
                costCenter: showModalEditVehicle?.costCenter,
                project: showModalEditVehicle?.project,
                onTerminated: ()=>closeModalsAndRefresh(),
                onSubmit: ()=>{
                    closeModalsAndRefresh();
                },
                onCancel: ()=>setShowModalEditVehicle(undefined)
            })
        ]
    });
};
var $c3db903ea74e85fe$export$2e2bcd8739ae039 = $c3db903ea74e85fe$var$TableVehicles;





var $1T1QG = parcelRequire("1T1QG");
const $1ec930f7ba60b827$var$RightsAndVehicles = (props)=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const { place: place } = (0, $a48e808e68b0e5f9$export$2e2bcd8739ae039)();
    const { isPermission: isPermission } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const queryClient = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)();
    const isOfferingFetchAllowed = isPermission("READ", "OFFERING");
    const queryOfferings = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$70a73d059c6beff0),
            place.id
        ],
        queryFn: ()=>(0, $f7802c761d4f9d37$export$2bffccb0f948be1f).getOfferingsByPlace(place.id || ""),
        enabled: false,
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const offeringId = queryOfferings.data?.[0]?.id;
    (0, $1T1QG.useEffect)(()=>{
        if (offeringId) queryClient.invalidateQueries({
            queryKey: [
                (0, $ec0c9d75a0d3a81a$export$7cf5b9f73b9b2f2d),
                offeringId
            ]
        });
    }, [
        queryOfferings.isFetched
    ]);
    const RenderVehicles = ()=>{
        return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
            children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {
                        title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "page.rightHolders.rightHolder.tab.rightsAndVehicles.title"
                        }),
                        divider: true
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c3db903ea74e85fe$export$2e2bcd8739ae039), {
                            vehicleRightHolders: props.vehicles,
                            rightHolderId: props.individualRightHolder?.id || "",
                            queryRightHolder: props.queryRightHolder,
                            allowToEndRight: !!props.individualRightHolder,
                            refreshOffering: ()=>isOfferingFetchAllowed && queryClient.invalidateQueries({
                                    queryKey: [
                                        (0, $ec0c9d75a0d3a81a$export$70a73d059c6beff0),
                                        place.id
                                    ]
                                })
                        })
                    })
                ]
            })
        });
    };
    const tabHeaders = [
        intl.formatMessage({
            id: "page.rightHolders.rightHolder.tab.rightsAndVehicles.title"
        })
    ];
    const tabPanels = [
        /*#__PURE__*/ (0, $3Py8h.jsx)(RenderVehicles, {})
    ];
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $752b2919b820e82b$export$2e2bcd8739ae039), {
        tabKey: (0, $5f8ca62b06e02682$export$50da30c0967674ee),
        tabHeaders: tabHeaders,
        tabPanels: tabPanels
    });
};
var $1ec930f7ba60b827$export$2e2bcd8739ae039 = $1ec930f7ba60b827$var$RightsAndVehicles;




const $2ed4746c2fccd83a$var$RightHolder = ()=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    let { rightHolderRef: rightHolderRef } = (0, $e0cff2801449e77d$export$99eaa27ddbbb95ef)();
    const queryClient = (0, $9c3a537718ea5f59$export$22e77b9572c4fded)();
    const { tenant: tenant } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const { state: state } = (0, $e0cff2801449e77d$export$45d76561a5302f2b)();
    const [showModalEditRightHolder, setShowModalEditRightHolder] = (0, $1T1QG.useState)(false);
    const queryRightHolder = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$475c1d76a7297be4),
            rightHolderRef
        ],
        queryFn: ()=>(0, $bfd03858b5cf8c88$export$2e2bcd8739ae039).getIndividualByRef(rightHolderRef || ""),
        enabled: !!rightHolderRef,
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const rightHolderData = queryRightHolder.data;
    let rightHolder = {
        id: "",
        name: "-",
        email: undefined,
        phone: undefined,
        vehicles: [],
        type: rightHolderData?.type
    };
    let dataIndividual = rightHolderData?.type === "individual" ? rightHolderData : undefined;
    let dataVehicle = rightHolderData?.type === "vehicle" ? rightHolderData : undefined;
    if (dataIndividual) {
        const id = dataIndividual.id;
        const name = (0, $9efc3d7accb9d2fe$export$e49861a9373f5f25)(dataIndividual);
        const email = dataIndividual.email;
        const phone = dataIndividual.phoneNumber;
        const vehicles = dataIndividual.vehicles;
        rightHolder = {
            id: id,
            name: name,
            email: email,
            phone: phone,
            vehicles: vehicles
        };
    } else if (dataVehicle) {
        const id = dataVehicle.id;
        const name = (0, $9efc3d7accb9d2fe$export$e49861a9373f5f25)(dataVehicle);
        const vehicles = rightHolderData?.type === "vehicle" ? [
            rightHolderData
        ] : [];
        rightHolder = {
            id: id,
            name: name,
            vehicles: vehicles
        };
    }
    const { catalogueId: catalogueId, offeringName: offeringName, placeId: placeId, placeName: placeName } = state || {};
    const customBreadcrumbs = catalogueId && offeringName && placeId && placeName ? {
        lastBreadcrumb: rightHolder.name,
        customBreadcrumbs: tenant ? [
            {
                route: `${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES}/${placeId}`,
                name: placeName
            }
        ] : [
            {
                route: `${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES}/${placeId}`,
                name: placeName
            },
            {
                route: `${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).CATALOGUES}/${catalogueId}`,
                name: offeringName
            }
        ]
    } : undefined;
    const RightHolderListItem = ({ children: children })=>{
        return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $d458cf93737cba82$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                alignItems: "center"
            },
            children: children
        });
    };
    const RightHolderListItemText = ({ children: children })=>{
        return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $7308185c8ff27335$export$2e2bcd8739ae039), {
            sx: {
                pl: "10px"
            },
            children: children
        });
    };
    const showEditButton = rightHolderData?.type === "individual";
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b914262cfd70d60a$export$2e2bcd8739ae039), {
        query: queryRightHolder,
        rootPageIfNotFoundError: true,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c9560da3d4f68f59$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $d853676d11a33bb6$export$2e2bcd8739ae039), {
                                    breadcrumbs: customBreadcrumbs,
                                    children: rightHolder.name
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {
                                    title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "page.rightHolders.rightHolder.title"
                                    }),
                                    button: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $15827f0d92c5ff99$export$2e2bcd8739ae039), {
                                        action: "EDIT",
                                        resource: "RIGHT_HOLDERS",
                                        visibility: showEditButton,
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                                            startIcon: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e631bbd3618e6888$exports))), {}),
                                            onClick: ()=>setShowModalEditRightHolder(true),
                                            showAsIconButton: true,
                                            "aria-label": intl.formatMessage({
                                                id: "page.rightHolders.rightHolder.button.edit"
                                            })
                                        })
                                    }),
                                    divider: true
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $44769ad997f9918f$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $3Py8h.jsxs)(RightHolderListItem, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($794fd59fa086bc59$exports))), {}),
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)(RightHolderListItemText, {
                                                        children: rightHolder.name
                                                    })
                                                ]
                                            }),
                                            rightHolder.email && /*#__PURE__*/ (0, $3Py8h.jsxs)(RightHolderListItem, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f8ca87aa0040398a$exports))), {}),
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)(RightHolderListItemText, {
                                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $20ee4e07c5af013a$export$2e2bcd8739ae039), {
                                                            href: `mailto:${rightHolder.email}`,
                                                            children: rightHolder.email
                                                        })
                                                    })
                                                ]
                                            }),
                                            rightHolder.phone && /*#__PURE__*/ (0, $3Py8h.jsxs)(RightHolderListItem, {
                                                children: [
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f10f2c61eb2000af$exports))), {}),
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)(RightHolderListItemText, {
                                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $20ee4e07c5af013a$export$2e2bcd8739ae039), {
                                                            href: `tel:${rightHolder.phone}`,
                                                            children: rightHolder.phone
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $1ec930f7ba60b827$export$2e2bcd8739ae039), {
                                    queryRightHolder: queryRightHolder,
                                    individualRightHolder: dataIndividual,
                                    vehicles: rightHolder.vehicles
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $5594b4cafad53d4a$export$2e2bcd8739ae039), {
                        open: showModalEditRightHolder,
                        rightHolderRef: rightHolderRef || "",
                        rightHolder: {
                            kind: rightHolderData?.type,
                            dto: rightHolderData
                        },
                        onSubmit: (values)=>{
                            setShowModalEditRightHolder(false);
                            queryClient.invalidateQueries({
                                queryKey: [
                                    (0, $ec0c9d75a0d3a81a$export$475c1d76a7297be4),
                                    rightHolderRef
                                ]
                            });
                        },
                        onCancel: ()=>setShowModalEditRightHolder(false)
                    })
                ]
            })
        ]
    });
};
var $2ed4746c2fccd83a$export$2e2bcd8739ae039 = $2ed4746c2fccd83a$var$RightHolder;




var $3Py8h = parcelRequire("3Py8h");

parcelRequire("1T1QG");






const $d71e87cabae96da5$var$Right = ()=>{
    const { ref: ref } = (0, $e0cff2801449e77d$export$99eaa27ddbbb95ef)();
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    if (!ref) return null;
    const query = (0, $16bfa3cce9e56cee$export$dd0a697e1782aedd)({
        queryKey: [
            (0, $ec0c9d75a0d3a81a$export$d1676135628eec72),
            ref
        ],
        queryFn: ()=>(0, $7d92f70a64e5af9d$export$2e2bcd8739ae039).getRightByRef(ref),
        enabled: !!ref,
        staleTime: (0, $ec0c9d75a0d3a81a$export$55bcc68ad4a40abc)
    });
    const right = query.data;
    const data = [
        {
            label: intl.formatMessage({
                id: "page.right.start"
            }),
            value: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                utcDateTime: right?.validityStart
            })
        },
        {
            label: intl.formatMessage({
                id: "page.right.end"
            }),
            value: right?.validityEnd ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $235dbade6cd3cffe$export$2e2bcd8739ae039), {
                utcDateTime: right?.validityEnd
            }) : null
        },
        {
            label: intl.formatMessage({
                id: "page.right.licensePlate"
            }),
            value: right?.vehicle?.licensePlate
        },
        {
            label: intl.formatMessage({
                id: "page.right.place"
            }),
            value: right?.place?.name
        },
        {
            label: intl.formatMessage({
                id: "page.right.catalogue"
            }),
            value: right?.catalogue?.name
        },
        {
            label: intl.formatMessage({
                id: "page.right.individual"
            }),
            value: right?.individual?.email
        },
        {
            label: intl.formatMessage({
                id: "page.right.costCenter"
            }),
            value: right?.costCenter
        },
        {
            label: intl.formatMessage({
                id: "page.right.project"
            }),
            value: right?.project
        },
        {
            label: intl.formatMessage({
                id: "page.right.endReason"
            }),
            value: right?.endReason
        },
        {
            label: intl.formatMessage({
                id: "page.right.active"
            }),
            value: intl.formatMessage({
                id: right?.active ? "common.yes" : "common.no"
            })
        }
    ].filter((item)=>item.value);
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b914262cfd70d60a$export$2e2bcd8739ae039), {
        query: query,
        rootPageIfNotFoundError: false,
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c9560da3d4f68f59$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                direction: "row",
                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $d853676d11a33bb6$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.right.title"
                                })
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {
                                title: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "page.right.container.title"
                                }),
                                divider: true
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $836e912fb2b7fc60$export$2e2bcd8739ae039), {
                                    data: data
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $d71e87cabae96da5$export$2e2bcd8739ae039 = $d71e87cabae96da5$var$Right;



var $3Py8h = parcelRequire("3Py8h");




var $1T1QG = parcelRequire("1T1QG");


var $3Py8h = parcelRequire("3Py8h");


var $eUHG3 = parcelRequire("eUHG3");



var $1T1QG = parcelRequire("1T1QG");
const $34d7071c78bdfd3a$var$FormPassword = (props)=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const [formikValidateOnChange, setFormikValidateOnChange] = (0, $1T1QG.useState)(false);
    const [defaultValues] = (0, $1T1QG.useState)({
        oldPassword: "",
        newPassword: "",
        confirmNewPassword: ""
    });
    const SchemaValidation = ()=>{
        return $d7c41ae3ced691f5$export$be5493f9613cbbe().shape({
            oldPassword: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().required(intl.formatMessage({
                id: "common.form.errors.empty"
            })),
            newPassword: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().test("newPassword", intl.formatMessage({
                id: "page.users.formPassword.errors.password"
            }), function(newPassword) {
                const { confirmNewPassword: confirmNewPassword } = this.parent;
                if (newPassword && confirmNewPassword) return confirmNewPassword.localeCompare(newPassword) === 0;
                return false;
            }),
            confirmNewPassword: $d7c41ae3ced691f5$export$22b082955e083ec3().trim().test("confirmNewPassword", intl.formatMessage({
                id: "page.users.formPassword.errors.password"
            }), function(confirmNewPassword) {
                const { newPassword: newPassword } = this.parent;
                if (confirmNewPassword && newPassword) return newPassword.localeCompare(confirmNewPassword) === 0;
                return false;
            })
        });
    };
    const onSubmitFormValues = (values)=>{
        const { oldPassword: oldPassword, newPassword: newPassword } = values;
        props.onSubmit({
            newPassword: newPassword.trim(),
            oldPassword: oldPassword.trim()
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $eUHG3.Formik), {
            validate: ()=>setFormikValidateOnChange(true),
            validationSchema: SchemaValidation(),
            initialValues: defaultValues,
            validateOnChange: formikValidateOnChange,
            onSubmit: (values)=>{
                onSubmitFormValues(values);
            },
            children: ({ values: values, errors: errors, handleChange: handleChange, handleSubmit: handleSubmit })=>/*#__PURE__*/ (0, $3Py8h.jsx)("form", {
                    onSubmit: handleSubmit,
                    id: props.formReference,
                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormContainer, {
                        children: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                type: "password",
                                name: "oldPassword",
                                "data-testid": "oldPassword",
                                value: values.oldPassword,
                                label: intl.formatMessage({
                                    id: "page.users.formPassword.label.oldPassword"
                                }),
                                placeholder: intl.formatMessage({
                                    id: "page.users.formPassword.label.oldPassword"
                                }),
                                onChange: handleChange,
                                error: !!errors.oldPassword,
                                errorText: errors.oldPassword
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                type: "password",
                                name: "newPassword",
                                "data-testid": "newPassword",
                                value: values.newPassword,
                                label: intl.formatMessage({
                                    id: "page.users.formPassword.label.newPassword"
                                }),
                                placeholder: intl.formatMessage({
                                    id: "page.users.formPassword.label.newPassword"
                                }),
                                onChange: handleChange,
                                error: !!errors.newPassword,
                                errorText: errors.newPassword
                            }),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $b3451f27c11f61da$export$2e2bcd8739ae039).FormTextField, {
                                type: "password",
                                name: "confirmNewPassword",
                                "data-testid": "confirmNewPassword",
                                value: values.confirmNewPassword,
                                label: intl.formatMessage({
                                    id: "page.users.formPassword.label.confirmNewPassword"
                                }),
                                placeholder: intl.formatMessage({
                                    id: "page.users.formPassword.label.confirmNewPassword"
                                }),
                                onChange: handleChange,
                                error: !!errors.confirmNewPassword,
                                errorText: errors.confirmNewPassword
                            })
                        ]
                    })
                })
        })
    });
};
var $34d7071c78bdfd3a$export$2e2bcd8739ae039 = $34d7071c78bdfd3a$var$FormPassword;







const $32183587e53221ff$var$Users = ()=>{
    // TODO Antti: Is this needed somehow? Probably not.
    //const { user } = useAuthenticator((context) => [context.user])
    const { decodedToken: decodedToken } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const [showPasswordModal, setShowPasswordModal] = (0, $1T1QG.useState)(false);
    const FORM_REFERENCE = "formChangePassword";
    const changePasswordMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: (dto)=>(0, $c5bdd8e1d814380c$export$2e2bcd8739ae039).changePassword(dto.oldPassword, dto.newPassword),
        onSuccess: (response)=>{
            setShowPasswordModal(false);
            (0, $8c70bc2b53ae34cc$export$266cbe012f0ab791).showToast(/*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "page.users.modalChangePassword.action.changed"
            }));
        }
    });
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $52a829e7310b7f4c$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $d853676d11a33bb6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "page.users.label.user"
                        })
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $344485076b4208c7$export$2e2bcd8739ae039), {
                        title: (0, $fb47a354e391b3c4$export$ec6ba75237411d31)(decodedToken),
                        button: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                            startIcon: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e631bbd3618e6888$exports))), {}),
                            onClick: ()=>setShowPasswordModal(true),
                            showAsIconButton: true,
                            "aria-label": intl.formatMessage({
                                id: "page.users.button.edit"
                            })
                        }),
                        divider: true
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $16d47fe2418a0b93$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                            container: true,
                            direction: "row",
                            gap: 1,
                            children: [
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 3,
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)("b", {
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                            id: "common.text.email"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 9,
                                    children: decodedToken?.email
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 3,
                                    children: /*#__PURE__*/ (0, $3Py8h.jsx)("b", {
                                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                            id: "page.users.label.emailConfirmed"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                                    item: true,
                                    xs: 9,
                                    children: decodedToken?.email_verified ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "common.yes"
                                    }) : /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                        id: "common.no"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $259d9dbb3544503a$export$2e2bcd8739ae039), {
                open: showPasswordModal,
                onCancel: ()=>{
                    changePasswordMutation.reset();
                    setShowPasswordModal(false);
                },
                formReference: FORM_REFERENCE,
                errorTitleKey: "common.actions.add.error",
                modalTitle: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "page.users.modalChangePassword.title"
                }),
                submitButtonContent: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                    id: "page.users.modalChangePassword.button.add"
                }),
                children: [
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $019112675a75b38b$export$2e2bcd8739ae039), {
                        mutation: changePasswordMutation,
                        errorTitleKey: "common.actions.add.error"
                    }),
                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $34d7071c78bdfd3a$export$2e2bcd8739ae039), {
                        onSubmit: (values)=>changePasswordMutation.mutate(values),
                        formReference: FORM_REFERENCE
                    })
                ]
            })
        ]
    });
};
var $32183587e53221ff$export$2e2bcd8739ae039 = $32183587e53221ff$var$Users;






var $3Py8h = parcelRequire("3Py8h");

var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");

var $5wtOU = parcelRequire("5wtOU");


var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $1c4c069ace759edc$export$47a2da616e55e8e9(slot) {
    return (0, $iNQht.default)("MuiAppBar", slot);
}
const $1c4c069ace759edc$var$appBarClasses = (0, $dfswM.default)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning"
]);
var $1c4c069ace759edc$export$2e2bcd8739ae039 = $1c4c069ace759edc$var$appBarClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $e946a564bbcc81ae$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $e946a564bbcc81ae$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $5wtOU.default)(color)}`,
            `position${(0, $5wtOU.default)(position)}`
        ]
    };
    return (0, $iV85C.default)(slots, (0, $1c4c069ace759edc$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $e946a564bbcc81ae$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(")", "")}, ${var2})` : var2;
const $e946a564bbcc81ae$var$AppBarRoot = (0, $npagc.default)((0, $0a163fcc25046a25$export$2e2bcd8739ae039), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $5wtOU.default)(ownerState.position)}`],
            styles[`color${(0, $5wtOU.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $ajTRS.default)({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === "fixed" && {
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0,
        "@media print": {
            // Prevent the app bar to be visible on each printed page.
            position: "absolute"
        }
    }, ownerState.position === "absolute" && {
        position: "absolute",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "sticky" && {
        // ⚠️ sticky is not supported by IE11.
        position: "sticky",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "static" && {
        position: "static"
    }, ownerState.position === "relative" && {
        position: "relative"
    }, !theme.vars && (0, $ajTRS.default)({}, ownerState.color === "default" && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== "default" && ownerState.color !== "inherit" && ownerState.color !== "transparent" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, theme.palette.mode === "dark" && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === "transparent" && (0, $ajTRS.default)({
        backgroundColor: "transparent",
        color: "inherit"
    }, theme.palette.mode === "dark" && {
        backgroundImage: "none"
    })), theme.vars && (0, $ajTRS.default)({}, ownerState.color === "default" && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $e946a564bbcc81ae$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $e946a564bbcc81ae$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $e946a564bbcc81ae$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $e946a564bbcc81ae$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, {
        backgroundColor: "var(--AppBar-background)",
        color: ownerState.color === "inherit" ? "inherit" : "var(--AppBar-color)"
    }, ownerState.color === "transparent" && {
        backgroundImage: "none",
        backgroundColor: "transparent",
        color: "inherit"
    }));
});
const $e946a564bbcc81ae$var$AppBar = /*#__PURE__*/ $1T1QG.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiAppBar"
    });
    const { className: className, color: color = "primary", enableColorOnDark: enableColorOnDark = false, position: position = "fixed" } = props, other = (0, $iXdVf.default)(props, $e946a564bbcc81ae$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $e946a564bbcc81ae$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($e946a564bbcc81ae$var$AppBarRoot, (0, $ajTRS.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $aVXbR.default)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
var $e946a564bbcc81ae$export$2e2bcd8739ae039 = $e946a564bbcc81ae$var$AppBar;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");


var $iV85C = parcelRequire("iV85C");


var $ajTRS = parcelRequire("ajTRS");

var $iXdVf = parcelRequire("iXdVf");

var $1T1QG = parcelRequire("1T1QG");









var $3Py8h = parcelRequire("3Py8h");
"use client";
const $0f561fed82a0b85e$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $0f561fed82a0b85e$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $200f56383d159758$export$2e2bcd8739ae039)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== "none" && typeof transform === "string") {
        const transformValues = transform.split("(")[1].split(")")[0].split(",");
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === "left") {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === "right") {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === "up") {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $0f561fed82a0b85e$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === "function" ? containerPropProp() : containerPropProp;
}
function $0f561fed82a0b85e$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $0f561fed82a0b85e$var$resolveContainer(containerProp);
    const transform = $0f561fed82a0b85e$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $0f561fed82a0b85e$var$Slide = /*#__PURE__*/ $1T1QG.forwardRef(function Slide(props, ref) {
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = "down", easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $97e45c35ce24099f$export$2e2bcd8739ae039) } = props, other = (0, $iXdVf.default)(props, $0f561fed82a0b85e$var$_excluded);
    const childrenRef = $1T1QG.useRef(null);
    const handleRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(children.ref, childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $0f561fed82a0b85e$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $3c14342afe4d3400$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $3c14342afe4d3400$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", (0, $ajTRS.default)({}, transitionProps));
        node.style.transition = theme.transitions.create("transform", (0, $ajTRS.default)({}, transitionProps));
        node.style.webkitTransform = "none";
        node.style.transform = "none";
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $3c14342afe4d3400$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", transitionProps);
        node.style.transition = theme.transitions.create("transform", transitionProps);
        $0f561fed82a0b85e$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = "";
        node.style.transition = "";
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $1T1QG.useCallback(()=>{
        if (childrenRef.current) $0f561fed82a0b85e$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $1T1QG.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === "down" || direction === "right") return undefined;
        const handleResize = (0, $48e766ac1390e9bf$export$2e2bcd8739ae039)(()=>{
            if (childrenRef.current) $0f561fed82a0b85e$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $200f56383d159758$export$2e2bcd8739ae039)(childrenRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $1T1QG.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)(TransitionComponent, (0, $ajTRS.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $1T1QG.cloneElement(children, (0, $ajTRS.default)({
                ref: handleRef,
                style: (0, $ajTRS.default)({
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
var $0f561fed82a0b85e$export$2e2bcd8739ae039 = $0f561fed82a0b85e$var$Slide;




var $5wtOU = parcelRequire("5wtOU");


var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $d2bb30112c4a670b$export$b801318a856c9cd2(slot) {
    return (0, $iNQht.default)("MuiDrawer", slot);
}
const $d2bb30112c4a670b$var$drawerClasses = (0, $dfswM.default)("MuiDrawer", [
    "root",
    "docked",
    "paper",
    "paperAnchorLeft",
    "paperAnchorRight",
    "paperAnchorTop",
    "paperAnchorBottom",
    "paperAnchorDockedLeft",
    "paperAnchorDockedRight",
    "paperAnchorDockedTop",
    "paperAnchorDockedBottom",
    "modal"
]);
var $d2bb30112c4a670b$export$2e2bcd8739ae039 = $d2bb30112c4a670b$var$drawerClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $55955e47a4343994$var$_excluded = [
    "BackdropProps"
], $55955e47a4343994$var$_excluded2 = [
    "anchor",
    "BackdropProps",
    "children",
    "className",
    "elevation",
    "hideBackdrop",
    "ModalProps",
    "onClose",
    "open",
    "PaperProps",
    "SlideProps",
    "TransitionComponent",
    "transitionDuration",
    "variant"
];
const $55955e47a4343994$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === "permanent" || ownerState.variant === "persistent") && styles.docked,
        styles.modal
    ];
};
const $55955e47a4343994$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        docked: [
            (variant === "permanent" || variant === "persistent") && "docked"
        ],
        modal: [
            "modal"
        ],
        paper: [
            "paper",
            `paperAnchor${(0, $5wtOU.default)(anchor)}`,
            variant !== "temporary" && `paperAnchorDocked${(0, $5wtOU.default)(anchor)}`
        ]
    };
    return (0, $iV85C.default)(slots, (0, $d2bb30112c4a670b$export$b801318a856c9cd2), classes);
};
const $55955e47a4343994$var$DrawerRoot = (0, $npagc.default)((0, $167f720a102c0662$export$2e2bcd8739ae039), {
    name: "MuiDrawer",
    slot: "Root",
    overridesResolver: $55955e47a4343994$var$overridesResolver
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    }));
const $55955e47a4343994$var$DrawerDockedRoot = (0, $npagc.default)("div", {
    shouldForwardProp: (0, $npagc.rootShouldForwardProp),
    name: "MuiDrawer",
    slot: "Docked",
    skipVariantsResolver: false,
    overridesResolver: $55955e47a4343994$var$overridesResolver
})({
    flex: "0 0 auto"
});
const $55955e47a4343994$var$DrawerPaper = (0, $npagc.default)((0, $0a163fcc25046a25$export$2e2bcd8739ae039), {
    name: "MuiDrawer",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $5wtOU.default)(ownerState.anchor)}`],
            ownerState.variant !== "temporary" && styles[`paperAnchorDocked${(0, $5wtOU.default)(ownerState.anchor)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        flex: "1 0 auto",
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        // temporary style
        position: "fixed",
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0
    }, ownerState.anchor === "left" && {
        left: 0
    }, ownerState.anchor === "top" && {
        top: 0,
        left: 0,
        right: 0,
        height: "auto",
        maxHeight: "100%"
    }, ownerState.anchor === "right" && {
        right: 0
    }, ownerState.anchor === "bottom" && {
        top: "auto",
        left: 0,
        bottom: 0,
        right: 0,
        height: "auto",
        maxHeight: "100%"
    }, ownerState.anchor === "left" && ownerState.variant !== "temporary" && {
        borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "top" && ownerState.variant !== "temporary" && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "right" && ownerState.variant !== "temporary" && {
        borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === "bottom" && ownerState.variant !== "temporary" && {
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $55955e47a4343994$var$oppositeDirection = {
    left: "right",
    right: "left",
    top: "down",
    bottom: "up"
};
function $55955e47a4343994$export$2a62b49acb270576(anchor) {
    return [
        "left",
        "right"
    ].indexOf(anchor) !== -1;
}
function $55955e47a4343994$export$830f4f08342d299e(theme, anchor) {
    return theme.direction === "rtl" && $55955e47a4343994$export$2a62b49acb270576(anchor) ? $55955e47a4343994$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $55955e47a4343994$var$Drawer = /*#__PURE__*/ $1T1QG.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiDrawer"
    });
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = "left", BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0f561fed82a0b85e$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = "temporary" } = props, ModalProps = (0, $iXdVf.default)(props.ModalProps, $55955e47a4343994$var$_excluded), other = (0, $iXdVf.default)(props, $55955e47a4343994$var$_excluded2);
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $1T1QG.useRef(false);
    $1T1QG.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $55955e47a4343994$export$830f4f08342d299e(theme, anchorProp);
    const anchor = anchorProp;
    const ownerState = (0, $ajTRS.default)({}, props, {
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant
    }, other);
    const classes = $55955e47a4343994$var$useUtilityClasses(ownerState);
    const drawer = /*#__PURE__*/ (0, $3Py8h.jsx)($55955e47a4343994$var$DrawerPaper, (0, $ajTRS.default)({
        elevation: variant === "temporary" ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, $aVXbR.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        children: children
    }));
    if (variant === "permanent") return /*#__PURE__*/ (0, $3Py8h.jsx)($55955e47a4343994$var$DrawerDockedRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: drawer
    }));
    const slidingDrawer = /*#__PURE__*/ (0, $3Py8h.jsx)(TransitionComponent, (0, $ajTRS.default)({
        in: open,
        direction: $55955e47a4343994$var$oppositeDirection[anchorInvariant],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps, {
        children: drawer
    }));
    if (variant === "persistent") return /*#__PURE__*/ (0, $3Py8h.jsx)($55955e47a4343994$var$DrawerDockedRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: slidingDrawer
    }));
    // variant === temporary
    return /*#__PURE__*/ (0, $3Py8h.jsx)($55955e47a4343994$var$DrawerRoot, (0, $ajTRS.default)({
        BackdropProps: (0, $ajTRS.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration: transitionDuration
        }),
        className: (0, $aVXbR.default)(classes.root, classes.modal, className),
        open: open,
        ownerState: ownerState,
        onClose: onClose,
        hideBackdrop: hideBackdrop,
        ref: ref
    }, other, ModalProps, {
        children: slidingDrawer
    }));
});
var $55955e47a4343994$export$2e2bcd8739ae039 = $55955e47a4343994$var$Drawer;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $7Etkp = parcelRequire("7Etkp");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");






var $3Py8h = parcelRequire("3Py8h");
"use client";
const $67ceeed7a25a0d68$var$_excluded = [
    "alignItems",
    "autoFocus",
    "component",
    "children",
    "dense",
    "disableGutters",
    "divider",
    "focusVisibleClassName",
    "selected",
    "className"
];
const $67ceeed7a25a0d68$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $67ceeed7a25a0d68$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            divider && "divider",
            disabled && "disabled",
            alignItems === "flex-start" && "alignItemsFlexStart",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $iV85C.default)(slots, (0, $d2b399c3f14ea6a2$export$c09531d8563c67a5), classes);
    return (0, $ajTRS.default)({}, classes, composedClasses);
};
const $67ceeed7a25a0d68$var$ListItemButtonRoot = (0, $npagc.default)((0, $ecc40a2d226ef234$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $npagc.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiListItemButton",
    slot: "Root",
    overridesResolver: $67ceeed7a25a0d68$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        display: "flex",
        flexGrow: 1,
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minWidth: 0,
        boxSizing: "border-box",
        textAlign: "left",
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $d2b399c3f14ea6a2$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $d2b399c3f14ea6a2$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $d2b399c3f14ea6a2$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $7Etkp.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $d2b399c3f14ea6a2$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $d2b399c3f14ea6a2$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }));
const $67ceeed7a25a0d68$var$ListItemButton = /*#__PURE__*/ $1T1QG.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiListItemButton"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, component: component = "div", children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className } = props, other = (0, $iXdVf.default)(props, $67ceeed7a25a0d68$var$_excluded);
    const context = $1T1QG.useContext((0, $be3ac30bfa71c06e$export$2e2bcd8739ae039));
    const childContext = $1T1QG.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $1T1QG.useRef(null);
    (0, $675d87943b3ee26a$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $ajTRS.default)({}, props, {
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    });
    const classes = $67ceeed7a25a0d68$var$useUtilityClasses(ownerState);
    const handleRef = (0, $147755cb84aa0994$export$2e2bcd8739ae039)(listItemRef, ref);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $be3ac30bfa71c06e$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $3Py8h.jsx)($67ceeed7a25a0d68$var$ListItemButtonRoot, (0, $ajTRS.default)({
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === "div" ? "button" : component,
            focusVisibleClassName: (0, $aVXbR.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $aVXbR.default)(classes.root, className)
        }, other, {
            classes: classes,
            children: children
        }))
    });
});
var $67ceeed7a25a0d68$export$2e2bcd8739ae039 = $67ceeed7a25a0d68$var$ListItemButton;


var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $npagc = parcelRequire("npagc");

var $gADeF = parcelRequire("gADeF");



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $211617827ffd9e30$var$_excluded = [
    "className"
];
const $211617827ffd9e30$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, $iV85C.default)(slots, (0, $f79b291cce78cf4e$export$81478e24460c57f2), classes);
};
const $211617827ffd9e30$var$ListItemIconRoot = (0, $npagc.default)("div", {
    name: "MuiListItemIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: "inline-flex"
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $211617827ffd9e30$var$ListItemIcon = /*#__PURE__*/ $1T1QG.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiListItemIcon"
    });
    const { className: className } = props, other = (0, $iXdVf.default)(props, $211617827ffd9e30$var$_excluded);
    const context = $1T1QG.useContext((0, $be3ac30bfa71c06e$export$2e2bcd8739ae039));
    const ownerState = (0, $ajTRS.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $211617827ffd9e30$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($211617827ffd9e30$var$ListItemIconRoot, (0, $ajTRS.default)({
        className: (0, $aVXbR.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $211617827ffd9e30$export$2e2bcd8739ae039 = $211617827ffd9e30$var$ListItemIcon;


var $npagc = parcelRequire("npagc");
var $iXdVf = parcelRequire("iXdVf");

var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $aVXbR = parcelRequire("aVXbR");

var $iV85C = parcelRequire("iV85C");

var $gADeF = parcelRequire("gADeF");

var $npagc = parcelRequire("npagc");

var $dfswM = parcelRequire("dfswM");

var $iNQht = parcelRequire("iNQht");
function $6335e56c19946c30$export$b12cb262231eef32(slot) {
    return (0, $iNQht.default)("MuiToolbar", slot);
}
const $6335e56c19946c30$var$toolbarClasses = (0, $dfswM.default)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
var $6335e56c19946c30$export$2e2bcd8739ae039 = $6335e56c19946c30$var$toolbarClasses;



var $3Py8h = parcelRequire("3Py8h");
"use client";
const $48ba14c183053393$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $48ba14c183053393$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, $iV85C.default)(slots, (0, $6335e56c19946c30$export$b12cb262231eef32), classes);
};
const $48ba14c183053393$var$ToolbarRoot = (0, $npagc.default)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $ajTRS.default)({
        position: "relative",
        display: "flex",
        alignItems: "center"
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === "dense" && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === "regular" && theme.mixins.toolbar);
const $48ba14c183053393$var$Toolbar = /*#__PURE__*/ $1T1QG.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiToolbar"
    });
    const { className: className, component: component = "div", disableGutters: disableGutters = false, variant: variant = "regular" } = props, other = (0, $iXdVf.default)(props, $48ba14c183053393$var$_excluded);
    const ownerState = (0, $ajTRS.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $48ba14c183053393$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3Py8h.jsx)($48ba14c183053393$var$ToolbarRoot, (0, $ajTRS.default)({
        as: component,
        className: (0, $aVXbR.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $48ba14c183053393$export$2e2bcd8739ae039 = $48ba14c183053393$var$Toolbar;



var $1T1QG = parcelRequire("1T1QG");

var $3Py8h = parcelRequire("3Py8h");


var $810b79dc84229fc4$exports = {};

$810b79dc84229fc4$exports = (parcelRequire("kk3fj")).getBundleURL("hz0N3") + "carLogo.e02ef99a.svg";



var $2337debbe1b1ecbc$exports = {};
"use strict";
"use client";

Object.defineProperty($2337debbe1b1ecbc$exports, "__esModule", {
    value: true
});
$2337debbe1b1ecbc$exports.default = void 0;

var $2337debbe1b1ecbc$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $2337debbe1b1ecbc$var$_default = $2337debbe1b1ecbc$exports.default = (0, $2337debbe1b1ecbc$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $3Py8h.jsx)("path", {
        d: "M5 5h6c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6c.55 0 1-.45 1-1s-.45-1-1-1H5z"
    }, "0"),
    /*#__PURE__*/ (0, $3Py8h.jsx)("path", {
        d: "m20.65 11.65-2.79-2.79c-.32-.32-.86-.1-.86.35V11h-7c-.55 0-1 .45-1 1s.45 1 1 1h7v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.19.2-.51.01-.7"
    }, "1")
], "LogoutRounded");


var $b5d8329090aa45c8$exports = {};
"use strict";
"use client";

Object.defineProperty($b5d8329090aa45c8$exports, "__esModule", {
    value: true
});
$b5d8329090aa45c8$exports.default = void 0;

var $b5d8329090aa45c8$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $b5d8329090aa45c8$var$_default = $b5d8329090aa45c8$exports.default = (0, $b5d8329090aa45c8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), "Menu");





var $1T1QG = parcelRequire("1T1QG");






const $379685462ae898b2$var$UserItem = ({ anchorElement: anchorElement, onOpenUserMenu: onOpenUserMenu, onCloseMenu: onCloseMenu, onLogout: onLogout })=>{
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const navigate = (0, $e0cff2801449e77d$export$9770f232ac06a008)();
    const { locale: locale, setLocale: setLocale } = (0, $268b84bc693ec63f$export$2e2bcd8739ae039)();
    const { isAuthenticated: isAuthenticated, usernameShort: usernameShort } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const locKeys = Object.getOwnPropertyNames((0, $8dd6473b0029aaad$export$bc99aaabaf7b70a7));
    const locOptions = locKeys.map((key)=>{
        return {
            key: key,
            text: intl.formatMessage({
                id: `menu.user.${key}`
            })
        };
    });
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8cb92c640591b070$export$2e2bcd8739ae039), {
                onClick: (event)=>onOpenUserMenu(event),
                children: usernameShort
            }),
            /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $13f11e3c954e513e$export$2e2bcd8739ae039), {
                anchorEl: anchorElement,
                open: Boolean(anchorElement),
                onClose: onCloseMenu,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                children: [
                    isAuthenticated && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $450c65ee2dafa292$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            onCloseMenu();
                            navigate(`${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).USERS}`);
                        },
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                            id: "menu.user.detail"
                        })
                    }),
                    isAuthenticated && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a976032e8b2c1f5c$export$2e2bcd8739ae039), {}),
                    locOptions.map((item)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $450c65ee2dafa292$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                setLocale(item.key);
                                onCloseMenu();
                            },
                            disabled: item.key === locale,
                            children: item.text
                        }, item.key)),
                    isAuthenticated && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a976032e8b2c1f5c$export$2e2bcd8739ae039), {}),
                    isAuthenticated && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $450c65ee2dafa292$export$2e2bcd8739ae039), {
                        onClick: ()=>{
                            onLogout();
                            onCloseMenu();
                        },
                        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                            display: "flex",
                            gap: "5px",
                            children: [
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2337debbe1b1ecbc$exports))), {}),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                    id: "menu.user.logout"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const $379685462ae898b2$var$AppMenuTop = ({ anchorElUser: anchorElUser, appMenuOpen: appMenuOpen, onOpenUserMenu: onOpenUserMenu, onCloseMenu: onCloseMenu, onLogout: onLogout, onClickHamburgerMenu: onClickHamburgerMenu, onClickLogo: onClickLogo })=>{
    const { isAuthenticated: isAuthenticated } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const { customerConfigured: customerConfigured } = (0, $a48e808e68b0e5f9$export$2e2bcd8739ae039)();
    const intl = (0, $8e16b6ae5b8512e9$exports.useIntl)();
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const isMobile = (0, $ffad103d3c7e3bc8$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, {
        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
            container: true,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 6,
                    display: "flex",
                    justifyContent: "flex-start",
                    height: 30,
                    gap: 2,
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                            style: {
                                display: "flex",
                                cursor: "pointer"
                            },
                            onClick: onClickLogo,
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($810b79dc84229fc4$exports)))
                            })
                        }),
                        !isMobile && /*#__PURE__*/ (0, $3Py8h.jsx)("div", {
                            style: {
                                display: "flex",
                                height: "100%",
                                alignItems: "center",
                                cursor: "pointer"
                            },
                            onClick: onClickLogo,
                            children: /*#__PURE__*/ (0, $3Py8h.jsx)("h2", {
                                children: (0, $f989e98d45efceaa$export$32ea325d92ea6082).APP_FULLNAME
                            })
                        }),
                        isAuthenticated && customerConfigured && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
                            children: appMenuOpen && isMobile ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                                startIcon: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b51cd9b2d67bb13a$exports))), {
                                    style: {
                                        color: "white"
                                    }
                                }),
                                onClick: onClickHamburgerMenu,
                                showAsIconButton: true,
                                "aria-label": intl.formatMessage({
                                    id: "appMenuTop.button.closeMenu"
                                })
                            }) : /*#__PURE__*/ (0, $3Py8h.jsx)((0, $971b877bb5a46eb0$export$2e2bcd8739ae039), {
                                startIcon: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b5d8329090aa45c8$exports))), {
                                    style: {
                                        color: "white"
                                    }
                                }),
                                onClick: onClickHamburgerMenu,
                                showAsIconButton: true,
                                "aria-label": intl.formatMessage({
                                    id: "appMenuTop.button.menu"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f39a5c039f44d345$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 6,
                    display: "flex",
                    justifyContent: "right",
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)($379685462ae898b2$var$UserItem, {
                        anchorElement: anchorElUser,
                        onOpenUserMenu: onOpenUserMenu,
                        onCloseMenu: onCloseMenu,
                        onLogout: onLogout
                    })
                })
            ]
        })
    });
};
var $379685462ae898b2$export$2e2bcd8739ae039 = $379685462ae898b2$var$AppMenuTop;


var $ef7b0d38cc01cec2$exports = {};
"use strict";
"use client";

Object.defineProperty($ef7b0d38cc01cec2$exports, "__esModule", {
    value: true
});
$ef7b0d38cc01cec2$exports.default = void 0;

var $ef7b0d38cc01cec2$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $ef7b0d38cc01cec2$var$_default = $ef7b0d38cc01cec2$exports.default = (0, $ef7b0d38cc01cec2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"
}), "AssessmentOutlined");


var $5bdab1aa1b7148a0$exports = {};
"use strict";
"use client";

Object.defineProperty($5bdab1aa1b7148a0$exports, "__esModule", {
    value: true
});
$5bdab1aa1b7148a0$exports.default = void 0;

var $5bdab1aa1b7148a0$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $5bdab1aa1b7148a0$var$_default = $5bdab1aa1b7148a0$exports.default = (0, $5bdab1aa1b7148a0$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $3Py8h.jsx)("path", {
        d: "m21.99 14.77-1.43-4.11c-.14-.4-.52-.66-.97-.66H12.4c-.46 0-.83.26-.98.66L10 14.77v5.24c0 .55.45.99 1 .99s1-.45 1-1v-1h8v1c0 .55.45 1 1 1s.99-.44 1-.99zm-10.38-1.43.69-2c.05-.2.24-.34.46-.34h6.48c.21 0 .4.14.47.34l.69 2c.11.32-.13.66-.47.66h-7.85c-.34 0-.58-.34-.47-.66m.38 3.66c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1"
    }, "0"),
    /*#__PURE__*/ (0, $3Py8h.jsx)("path", {
        d: "M14 4.5V9h1V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v4H3c-.55 0-1 .45-1 1v12h1V9.5c0-.28.22-.5.5-.5h4c.28 0 .5-.22.5-.5v-4c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5"
    }, "1"),
    /*#__PURE__*/ (0, $3Py8h.jsx)("path", {
        d: "M5 11h2v2H5zm5-6h2v2h-2zM5 15h2v2H5zm0 4h2v2H5z"
    }, "2")
], "EmojiTransportationRounded");





var $cb02f4e091730161$exports = {};
"use strict";
"use client";

Object.defineProperty($cb02f4e091730161$exports, "__esModule", {
    value: true
});
$cb02f4e091730161$exports.default = void 0;

var $cb02f4e091730161$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $cb02f4e091730161$var$_default = $cb02f4e091730161$exports.default = (0, $cb02f4e091730161$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M7 3v2c0 .55.45 1 1 1s1-.45 1-1V4h10v16H9v-1c0-.55-.45-1-1-1s-1 .45-1 1v2c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2m2.5 12.5c.29-.12.55-.29.8-.48l-.02.03 1.01.39c.23.09.49 0 .61-.22l.84-1.46c.12-.21.07-.49-.12-.64l-.85-.68-.02.03c.02-.16.05-.32.05-.48s-.03-.32-.05-.48l.02.03.85-.68c.19-.15.24-.43.12-.64l-.84-1.46c-.12-.21-.38-.31-.61-.22l-1.01.39.02.03c-.25-.17-.51-.34-.8-.46l-.17-1.08C9.3 7.18 9.09 7 8.84 7H7.16c-.25 0-.46.18-.49.42L6.5 8.5c-.29.12-.55.29-.8.48l.02-.03-1.02-.39c-.23-.09-.49 0-.61.22l-.84 1.46c-.12.21-.07.49.12.64l.85.68.02-.03c-.02.15-.05.31-.05.47s.03.32.05.48l-.02-.03-.85.68c-.19.15-.24.43-.12.64l.84 1.46c.12.21.38.31.61.22l1.01-.39-.01-.04c.25.19.51.36.8.48l.17 1.07c.03.25.24.43.49.43h1.68c.25 0 .46-.18.49-.42zM6 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2"
}), "PhonelinkSetupRounded");


var $584c1dc88b9f7d6f$exports = {};
"use strict";
"use client";

Object.defineProperty($584c1dc88b9f7d6f$exports, "__esModule", {
    value: true
});
$584c1dc88b9f7d6f$exports.default = void 0;

var $584c1dc88b9f7d6f$var$_createSvgIcon = $51a51f6e7d5620b8$exports((parcelRequire("jJTzp")));

var $3Py8h = parcelRequire("3Py8h");
var $584c1dc88b9f7d6f$var$_default = $584c1dc88b9f7d6f$exports.default = (0, $584c1dc88b9f7d6f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3Py8h.jsx)("path", {
    d: "M12 2c-4.2 0-8 3.22-8 8.2 0 3.18 2.45 6.92 7.34 11.23.38.33.95.33 1.33 0C17.55 17.12 20 13.38 20 10.2 20 5.22 16.2 2 12 2m0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"
}), "PlaceRounded");







const $0a1a455c3be11598$var$StyledToolbar = (0, $npagc.default)((0, $48ba14c183053393$export$2e2bcd8739ae039))({
    background: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).colorMenuBackgroundGradient
});
const $0a1a455c3be11598$var$StyledListItemIcon = (0, $npagc.default)((0, $211617827ffd9e30$export$2e2bcd8739ae039))({
    minWidth: 16,
    paddingRight: "10px"
});
const $0a1a455c3be11598$var$drawerWidth = 280;
const $0a1a455c3be11598$var$Main = (0, $npagc.default)("main", {
    shouldForwardProp: (prop)=>prop !== "open" && prop !== "mobile"
})(({ theme: theme, open: open, mobile: mobile })=>({
        flexGrow: 1,
        paddingTop: 0,
        paddingBottom: 20,
        paddingLeft: 0,
        paddingRight: 0,
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        marginLeft: mobile ? 0 : `-${$0a1a455c3be11598$var$drawerWidth}px`,
        ...open && {
            transition: theme.transitions.create("margin", {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen
            }),
            marginLeft: 0
        },
        backgroundColor: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).colorMainBackground,
        minHeight: "100vh",
        maxHeight: "-webkit-fill-available"
    }));
const $0a1a455c3be11598$var$AppMenu = (props)=>{
    const theme = (0, $b326beddb66cbd82$export$2e2bcd8739ae039)();
    const mobile = (0, $ffad103d3c7e3bc8$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    const [anchorElUser, setAnchorElUser] = (0, $1T1QG.useState)(null);
    const [showSideMenu, setShowSideMenu] = (0, $1T1QG.useState)(mobile ? false : true);
    const { customer: customer, place: place, customerConfigured: customerConfigured, catalogueId: catalogueId } = (0, $a48e808e68b0e5f9$export$2e2bcd8739ae039)();
    const { isPermission: isPermission, isAuthenticated: isAuthenticated } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const navigate = (0, $e0cff2801449e77d$export$9770f232ac06a008)();
    const handleOpenUserMenu = (event)=>{
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseMenu = ()=>{
        setAnchorElUser(null);
    };
    const logoutMutation = (0, $65bd1d1c1af02cf0$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $c5bdd8e1d814380c$export$2e2bcd8739ae039).logout(),
        onSuccess: ()=>{
            window.location.reload();
        }
    });
    const closeSideMenu = ()=>{
        mobile && setShowSideMenu(false);
        return true;
    };
    const menuAdminItems = [
        {
            key: (0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).INVITATIONS,
            active: location.pathname === (0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).INVITATIONS,
            onClick: ()=>closeSideMenu() && navigate((0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).INVITATIONS),
            value: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "menu.invitations"
            }),
            icon: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cb02f4e091730161$exports))), {}),
            visible: isPermission("READ", "LANDLORD_INVITATIONS")
        },
        {
            key: (0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES,
            active: location.pathname === (0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES,
            onClick: ()=>closeSideMenu() && navigate((0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES),
            value: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "menu.allPlaces"
            }),
            icon: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($584c1dc88b9f7d6f$exports))), {}),
            visible: isPermission("READ", "ADMIN_PLACES")
        }
    ];
    const showAdminMenu = menuAdminItems.filter((item)=>item.visible).length > 0;
    const isValidBasePlusOtherRoute = (appRoute)=>{
        // The route must be something else than the base route.
        // E.g. /places/0455e4b5-546c-4b21-949c-db7dc87c6c23
        return RegExp(`^${appRoute}/.`).test(location.pathname);
    };
    const menuPlaceItems = [
        {
            key: (0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES,
            active: isValidBasePlusOtherRoute((0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES) || isValidBasePlusOtherRoute((0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).CATALOGUES) || isValidBasePlusOtherRoute((0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).RIGHT_HOLDERS) || isValidBasePlusOtherRoute((0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).OFFERINGS),
            onClick: ()=>{
                closeSideMenu();
                if (isPermission("READ", "PLACES")) navigate(`${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES}/${place.id}`);
                else navigate(`${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).CATALOGUES}/${catalogueId}`);
            },
            value: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "menu.places"
            }),
            icon: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($584c1dc88b9f7d6f$exports))), {}),
            visible: isPermission("READ", "PLACES") || isPermission("READ", "CATALOGUES")
        }
    ];
    const menuCustomerItems = [
        {
            key: (0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).CUSTOMERS,
            active: location.pathname == `${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).CUSTOMERS}/${customer.id}`,
            onClick: ()=>closeSideMenu() && navigate(`${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).CUSTOMERS}/${customer.id}`),
            value: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "menu.customer"
            }),
            icon: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5bdab1aa1b7148a0$exports))), {}),
            visible: true
        }
    ];
    const menuReportItems = [
        {
            key: (0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).REPORTS,
            active: location.pathname === (0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).REPORTS,
            onClick: ()=>closeSideMenu() && navigate((0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).REPORTS),
            value: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                id: "menu.reports"
            }),
            icon: /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ef7b0d38cc01cec2$exports))), {}),
            visible: isPermission("READ", "CATALOGUE_REPORTS") || isPermission("READ", "RIGHT_REPORTS")
        }
    ];
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).Fragment, {
        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
            sx: {
                display: "flex"
            },
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e946a564bbcc81ae$export$2e2bcd8739ae039), {
                    position: "fixed",
                    sx: {
                        zIndex: (theme)=>theme.zIndex.drawer + 1
                    },
                    elevation: 0,
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)($0a1a455c3be11598$var$StyledToolbar, {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $379685462ae898b2$export$2e2bcd8739ae039), {
                            anchorElUser: anchorElUser,
                            onOpenUserMenu: handleOpenUserMenu,
                            onCloseMenu: handleCloseMenu,
                            onLogout: ()=>logoutMutation.mutate(),
                            onClickHamburgerMenu: ()=>setShowSideMenu(!showSideMenu),
                            onClickLogo: ()=>closeSideMenu() && navigate((0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).ROOT),
                            appMenuOpen: showSideMenu
                        })
                    })
                }),
                isAuthenticated && customerConfigured && /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $55955e47a4343994$export$2e2bcd8739ae039), {
                    sx: {
                        width: $0a1a455c3be11598$var$drawerWidth,
                        flexShrink: 0,
                        "& .MuiDrawer-paper": {
                            width: $0a1a455c3be11598$var$drawerWidth,
                            boxSizing: "border-box",
                            border: "none"
                        }
                    },
                    variant: mobile ? undefined : "persistent",
                    anchor: "left",
                    open: showSideMenu,
                    onClose: ()=>setShowSideMenu(false),
                    children: [
                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $48ba14c183053393$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
                            sx: {
                                overflow: "auto"
                            },
                            children: [
                                showAdminMenu && /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $3Py8h.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $44769ad997f9918f$export$2e2bcd8739ae039), {
                                            subheader: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $73bbeed63998f838$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.FormattedMessage), {
                                                    id: "menu.subHeader.moovyAdmin"
                                                })
                                            }),
                                            children: menuAdminItems.filter((item)=>item.visible).map((item)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $d458cf93737cba82$export$2e2bcd8739ae039), {
                                                    disablePadding: true,
                                                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $67ceeed7a25a0d68$export$2e2bcd8739ae039), {
                                                        onClick: item.onClick,
                                                        selected: item.active,
                                                        children: [
                                                            /*#__PURE__*/ (0, $3Py8h.jsx)($0a1a455c3be11598$var$StyledListItemIcon, {
                                                                children: item.icon
                                                            }),
                                                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $7308185c8ff27335$export$2e2bcd8739ae039), {
                                                                primary: item.value
                                                            })
                                                        ]
                                                    })
                                                }, item.key))
                                        }),
                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a976032e8b2c1f5c$export$2e2bcd8739ae039), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $44769ad997f9918f$export$2e2bcd8739ae039), {
                                    subheader: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $73bbeed63998f838$export$2e2bcd8739ae039), {
                                        children: place.name
                                    }),
                                    children: menuPlaceItems.filter((item)=>item.visible).map((item)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $d458cf93737cba82$export$2e2bcd8739ae039), {
                                            disablePadding: true,
                                            children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $67ceeed7a25a0d68$export$2e2bcd8739ae039), {
                                                onClick: item.onClick,
                                                selected: item.active,
                                                children: [
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)($0a1a455c3be11598$var$StyledListItemIcon, {
                                                        children: item.icon
                                                    }),
                                                    /*#__PURE__*/ (0, $3Py8h.jsx)((0, $7308185c8ff27335$export$2e2bcd8739ae039), {
                                                        primary: item.value
                                                    })
                                                ]
                                            })
                                        }, item.key))
                                }),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a976032e8b2c1f5c$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $44769ad997f9918f$export$2e2bcd8739ae039), {
                                    subheader: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $73bbeed63998f838$export$2e2bcd8739ae039), {
                                        children: customer.name
                                    }),
                                    children: [
                                        menuCustomerItems.filter((item)=>item.visible).map((item)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $d458cf93737cba82$export$2e2bcd8739ae039), {
                                                disablePadding: true,
                                                children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $67ceeed7a25a0d68$export$2e2bcd8739ae039), {
                                                    onClick: item.onClick,
                                                    selected: item.active,
                                                    children: [
                                                        /*#__PURE__*/ (0, $3Py8h.jsx)($0a1a455c3be11598$var$StyledListItemIcon, {
                                                            children: item.icon
                                                        }),
                                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $7308185c8ff27335$export$2e2bcd8739ae039), {
                                                            primary: item.value
                                                        })
                                                    ]
                                                })
                                            }, item.key)),
                                        menuReportItems.filter((item)=>item.visible).map((item)=>/*#__PURE__*/ (0, $3Py8h.jsx)((0, $d458cf93737cba82$export$2e2bcd8739ae039), {
                                                disablePadding: true,
                                                children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $67ceeed7a25a0d68$export$2e2bcd8739ae039), {
                                                    onClick: item.onClick,
                                                    selected: item.active,
                                                    children: [
                                                        /*#__PURE__*/ (0, $3Py8h.jsx)($0a1a455c3be11598$var$StyledListItemIcon, {
                                                            children: item.icon
                                                        }),
                                                        /*#__PURE__*/ (0, $3Py8h.jsx)((0, $7308185c8ff27335$export$2e2bcd8739ae039), {
                                                            primary: item.value
                                                        })
                                                    ]
                                                })
                                            }, item.key))
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)($0a1a455c3be11598$var$Main, {
                    open: showSideMenu,
                    mobile: mobile,
                    children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $691082308a369afa$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $48ba14c183053393$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
                                children: props.children
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $0a1a455c3be11598$export$2e2bcd8739ae039 = $0a1a455c3be11598$var$AppMenu;




var $3Py8h = parcelRequire("3Py8h");

parcelRequire("1T1QG");



const $ba058681affd1e23$var$MoovyRoute = ({ isProgress: isProgress = false, isAllowed: isAllowed = true, redirectPath: redirectPath = (0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).ROOT, children: children })=>{
    const { isAuthenticated: isAuthenticated } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    if (isProgress) return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4cdfa78f7d1b8c19$export$2e2bcd8739ae039), {});
    if (!isAuthenticated || !isAllowed) return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$444b3ab0cb9aec40), {
        to: redirectPath,
        replace: true
    });
    return children ? children : /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$910ae8079b2c2852), {});
};
var $ba058681affd1e23$export$2e2bcd8739ae039 = $ba058681affd1e23$var$MoovyRoute;






var $3Py8h = parcelRequire("3Py8h");

var $1T1QG = parcelRequire("1T1QG");




var $3Py8h = parcelRequire("3Py8h");

var $1T1QG = parcelRequire("1T1QG");




const $1278c417eaf687d8$var$DevLogin = ()=>{
    const [email, setEmail] = (0, $1T1QG.useState)("");
    const [error, setError] = (0, $1T1QG.useState)("");
    const { setAuthentication: setAuthentication } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const handleSubmit = async (event)=>{
        event.preventDefault();
        setError("");
        try {
            const token = await (0, $c5bdd8e1d814380c$export$2e2bcd8739ae039).devLogin(email);
            const decoded = (0, $ee8f4a42aaf5c361$export$fa1e2fb699b7861e)(token);
            setAuthentication({
                userGroups: decoded["cognito:groups"]?.join(","),
                token: token
            });
            (0, $c5bdd8e1d814380c$export$2e2bcd8739ae039).setTokenToInterceptor(token);
        } catch (e) {
            setError(`${e.message}: ${e.response?.data?.error}`);
        }
    };
    return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $4edd6b1e774baeef$export$2e2bcd8739ae039), {
        component: "form",
        onSubmit: handleSubmit,
        sx: {
            marginTop: "1rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2
        },
        noValidate: true,
        autoComplete: "off",
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)("h1", {
                children: "Local development login is enabled"
            }),
            /*#__PURE__*/ (0, $3Py8h.jsxs)("p", {
                style: {
                    marginTop: 0
                },
                children: [
                    "Want to enable Cognito authentication? Set environment variable",
                    " ",
                    /*#__PURE__*/ (0, $3Py8h.jsx)("code", {
                        children: "DISABLE_COGNITO_AUTHENTICATION"
                    }),
                    " to false."
                ]
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $acd1b2a27b331456$export$2e2bcd8739ae039), {
                required: true,
                id: "outlined-required",
                label: "Email",
                value: email,
                onChange: (e)=>setEmail(e.target.value),
                type: "email",
                helperText: "Email to sign in with. Include word 'admin' to sign in with admin user."
            }),
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c8008865d6db946f$export$2e2bcd8739ae039), {
                variant: "contained",
                type: "submit",
                children: "Submit"
            }),
            error && /*#__PURE__*/ (0, $3Py8h.jsx)((0, $7b8826fb1a00e789$export$2e2bcd8739ae039), {
                severity: "error",
                children: error
            })
        ]
    });
};
var $1278c417eaf687d8$export$2e2bcd8739ae039 = $1278c417eaf687d8$var$DevLogin;




const $f3721d3295c9aa21$var$LocalAuthenticator = ({ children: children })=>{
    const { isAuthenticated: isAuthenticated, setAuthentication: setAuthentication, token: token } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const { customer: customer } = (0, $a48e808e68b0e5f9$export$2e2bcd8739ae039)();
    const authenticatedAndCustomerFound = Boolean(isAuthenticated && customer.id);
    const { queryPlaces: queryPlaces, queryCustomers: queryCustomers, waitingForCustomers: waitingForCustomers, waitingForPlaces: waitingForPlaces } = (0, $560b76bc43b3f649$export$2e2bcd8739ae039)({
        customerId: customer?.id,
        queryCataloguesEnabled: authenticatedAndCustomerFound,
        queryPlacesEnabled: authenticatedAndCustomerFound,
        queryCustomersEnabled: isAuthenticated
    });
    // Need to set user groups again from token after possible reload
    (0, $1T1QG.useEffect)(()=>{
        if (isAuthenticated) {
            const decoded = (0, $ee8f4a42aaf5c361$export$fa1e2fb699b7861e)(token);
            const userGroups = decoded ? decoded["cognito:groups"]?.join(",") : [];
            setAuthentication({
                userGroups: userGroups,
                token: token
            });
        }
    }, [
        isAuthenticated
    ]);
    if (!isAuthenticated) return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $1278c417eaf687d8$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $3Py8h.Fragment), {
        children: !isAuthenticated || waitingForCustomers || waitingForPlaces ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $4cdfa78f7d1b8c19$export$2e2bcd8739ae039), {}) : queryPlaces.isError || queryCustomers.isError ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c338ce915869c7c0$export$2e2bcd8739ae039), {}) : children
    });
};
var $f3721d3295c9aa21$export$2e2bcd8739ae039 = $f3721d3295c9aa21$var$LocalAuthenticator;


const $ed2dc96e5c72ed90$var$AppRoutes = ()=>{
    const { isPermission: isPermission } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    const { customer: customer, place: place, initialized: initialized, catalogueId: catalogueId } = (0, $a48e808e68b0e5f9$export$2e2bcd8739ae039)();
    const RouteHome = ()=>{
        const showLoginRoute = !customer?.id || !place?.id;
        const isRootPlaces = isPermission("READ", "ADMIN_PLACES");
        const isRootPlace = !isRootPlaces && isPermission("READ", "PLACES");
        return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ba058681affd1e23$export$2e2bcd8739ae039), {
            isProgress: !initialized,
            isAllowed: !showLoginRoute,
            redirectPath: (0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).LOGIN_STEPS,
            children: isRootPlaces ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$444b3ab0cb9aec40), {
                to: (0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES,
                replace: true
            }) : isRootPlace ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$444b3ab0cb9aec40), {
                to: `${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES}/${place.id}`,
                replace: true
            }) : /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$444b3ab0cb9aec40), {
                to: `${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).CATALOGUES}/${catalogueId}`,
                replace: true
            })
        });
    };
    const MoovyRouters = ()=>{
        return /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $e0cff2801449e77d$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$e7b0ac011bb776c6), {
                    index: true,
                    element: /*#__PURE__*/ (0, $3Py8h.jsx)(RouteHome, {})
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$e7b0ac011bb776c6), {
                    path: (0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).INVITATIONS,
                    element: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ba058681affd1e23$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "LANDLORD_INVITATIONS"),
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $934a18d253b5961e$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$e7b0ac011bb776c6), {
                    path: (0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).LOGIN_STEPS,
                    element: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ba058681affd1e23$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $66eb78e55a176042$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$e7b0ac011bb776c6), {
                    path: `${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).RIGHT_HOLDERS}/:rightHolderRef`,
                    element: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ba058681affd1e23$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "RIGHT_HOLDERS"),
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $2ed4746c2fccd83a$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$e7b0ac011bb776c6), {
                    path: (0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES,
                    element: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ba058681affd1e23$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "ADMIN_PLACES"),
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $23e8e531a9995def$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$e7b0ac011bb776c6), {
                    path: `${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES}/:placeParentRef${(0, $e88b4657ea1cb9ec$export$25c4819f1669a599).SUB_PLACES}/:placeRef`,
                    element: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ba058681affd1e23$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "PLACES"),
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $45308713f7e2553b$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$e7b0ac011bb776c6), {
                    path: `${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).PLACES}/:placeRef`,
                    element: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ba058681affd1e23$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "PLACES"),
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $45308713f7e2553b$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$e7b0ac011bb776c6), {
                    path: `${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).OFFERINGS}/:offeringId`,
                    element: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ba058681affd1e23$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "OFFERING"),
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $a5656f0c2191a9bc$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$e7b0ac011bb776c6), {
                    path: `${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).CATALOGUES}/:catalogueRef`,
                    element: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ba058681affd1e23$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $696e64c10a59317a$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$e7b0ac011bb776c6), {
                    path: `${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).CUSTOMERS}/:customerRef`,
                    element: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ba058681affd1e23$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "CUSTOMER"),
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $be0b234a79d7efdc$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$e7b0ac011bb776c6), {
                    path: (0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).REPORTS,
                    element: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ba058681affd1e23$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "CATALOGUE_REPORTS") || isPermission("READ", "RIGHT_REPORTS"),
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $2157e273a61cce08$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$e7b0ac011bb776c6), {
                    path: (0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).USERS,
                    element: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ba058681affd1e23$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $32183587e53221ff$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$e7b0ac011bb776c6), {
                    path: `${(0, $e88b4657ea1cb9ec$export$61147a57d3c24ac8).RIGHTS}/:ref`,
                    element: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ba058681affd1e23$export$2e2bcd8739ae039), {
                        isAllowed: isPermission("READ", "RIGHTS"),
                        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $d71e87cabae96da5$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e0cff2801449e77d$export$e7b0ac011bb776c6), {
                    path: "*",
                    element: /*#__PURE__*/ (0, $3Py8h.jsx)(RouteHome, {})
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $efa9cbb50e224d6a$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $0a1a455c3be11598$export$2e2bcd8739ae039), {
            children: (0, $01207a025fc0a048$export$c87012121925caf1) && (0, $01207a025fc0a048$export$a743660edcdb697b) ? /*#__PURE__*/ (0, $3Py8h.jsx)((0, $f3721d3295c9aa21$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)(MoovyRouters, {})
            }) : /*#__PURE__*/ (0, $3Py8h.jsx)((0, $e7beb9767bbe39d4$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $3Py8h.jsx)(MoovyRouters, {})
            })
        })
    });
};
var $ed2dc96e5c72ed90$export$2e2bcd8739ae039 = $ed2dc96e5c72ed90$var$AppRoutes;




var $ajTRS = parcelRequire("ajTRS");

var $1T1QG = parcelRequire("1T1QG");


var $gADeF = parcelRequire("gADeF");


var $3Py8h = parcelRequire("3Py8h");
"use client";
const $12b9f7e578355fe5$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $ajTRS.default)({
        WebkitFontSmoothing: "antialiased",
        // Antialiasing.
        MozOsxFontSmoothing: "grayscale",
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: "border-box",
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: "100%"
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $12b9f7e578355fe5$export$32180ef41b15b513 = (theme)=>(0, $ajTRS.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $12b9f7e578355fe5$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, "")] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $ajTRS.default)({
        html: $12b9f7e578355fe5$export$c0bb0b647f701bb5(theme, enableColorScheme),
        "*, *::before, *::after": {
            boxSizing: "inherit"
        },
        "strong, b": {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $ajTRS.default)({
            margin: 0
        }, $12b9f7e578355fe5$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $12b9f7e578355fe5$var$CssBaseline(inProps) {
    const props = (0, $gADeF.default)({
        props: inProps,
        name: "MuiCssBaseline"
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $3Py8h.jsxs)($1T1QG.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3Py8h.jsx)((0, $569c607adcdd8af6$export$2e2bcd8739ae039), {
                styles: (theme)=>$12b9f7e578355fe5$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $12b9f7e578355fe5$export$2e2bcd8739ae039 = $12b9f7e578355fe5$var$CssBaseline;










const $485d6edd1c926c0b$var$App = ()=>{
    const queryClient = new (0, $22d1ff11c1be2a75$export$405d0624ed55a03f)();
    const { locale: locale } = (0, $268b84bc693ec63f$export$2e2bcd8739ae039)();
    const { isAuthenticated: isAuthenticated } = (0, $e39fe3a403501733$export$2e2bcd8739ae039)();
    (0, $b6e2c4096e9dd265$export$2c56d2e2ae515eeb).setLicenseKey("0b8f51d13b8e3aef7b858e72e04e496fTz0xMDA3ODIsRT0xNzYxNzI3MjE0MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=");
    // TODO Antti:
    // Missing theme fixes:
    // * Autofill input color of login must be fixed
    const theme = (0, $9jP1l.default)({
        palette: {
            primary: {
                main: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).primaryMain
            },
            secondary: {
                main: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).secondaryMain
            },
            error: {
                main: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).errorMain
            },
            warning: {
                main: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).warningMain
            },
            info: {
                main: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).infoMain
            },
            success: {
                main: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).successMain
            },
            text: {
                primary: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).commonBlack
            },
            common: {
                black: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).commonBlack,
                white: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).commonWhite
            }
        },
        shape: {
            borderRadius: 10
        },
        typography: {
            fontFamily: (0, $61ffe96bb93d2a02$export$6039b89271c3de71).fontFamily
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    a: {
                        color: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).commonBlue
                    }
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontWeight: (0, $61ffe96bb93d2a02$export$6039b89271c3de71).buttonFontWeight
                    }
                }
            },
            MuiTableHead: {
                styleOverrides: {
                    root: {
                        backgroundColor: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).colorTableHeader,
                        "& .MuiTableCell-root": {
                            fontWeight: (0, $61ffe96bb93d2a02$export$6039b89271c3de71).tableHeadFontWeight
                        }
                    }
                }
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        "& input:-webkit-autofill": {
                            WebkitTextFillColor: (0, $61ffe96bb93d2a02$export$f86ab2f69f02b2d9).commonBlack
                        }
                    }
                }
            },
            MuiAvatar: {
                styleOverrides: {
                    root: {
                        cursor: "pointer"
                    }
                }
            },
            MuiListItem: {
                styleOverrides: {
                    root: {
                        display: "flex",
                        alignItems: "center",
                        paddingBottom: "0",
                        paddingTop: "2px",
                        paddingLeft: "2px",
                        paddingRight: "0",
                        margin: "0"
                    }
                }
            },
            MuiListItemText: {
                styleOverrides: {
                    root: {
                        paddingLeft: "10px"
                    }
                }
            }
        }
    });
    (0, $1T1QG.useEffect)(()=>{
        const reloadPage = (0, $78378c3af696644c$export$2e2bcd8739ae039).language !== locale;
        (0, $0fe07bf7356162c8$export$dbe3113d60765c1a).putVocabulariesForLanguage(locale, (0, $8dd6473b0029aaad$export$d2223424998443a9)[locale].translation);
        (0, $0fe07bf7356162c8$export$dbe3113d60765c1a).setLanguage(locale);
        (0, $78378c3af696644c$export$2e2bcd8739ae039).changeLanguage(locale);
        if (!isAuthenticated && reloadPage) // Cognito login page needs this
        window.location.reload();
    }, [
        locale,
        isAuthenticated
    ]);
    return /*#__PURE__*/ (0, $3Py8h.jsx)((0, $8e16b6ae5b8512e9$exports.IntlProvider), {
        locale: locale,
        messages: (0, $8dd6473b0029aaad$export$bc99aaabaf7b70a7)[locale].translation,
        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $9c3a537718ea5f59$export$45604f0cc8ae667b), {
            client: queryClient,
            children: [
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $88e7937026fbdb30$export$f2815235e76a62b9), {
                    position: "top-right"
                }),
                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $192882e5bbaffa89$export$3d7a1e8452f884f3).Provider, {
                    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $eeaa49d647eade80$export$2e2bcd8739ae039), {
                        theme: theme,
                        children: /*#__PURE__*/ (0, $3Py8h.jsxs)((0, $0c1c7d3e9094bc71$export$dc45bdc734ce6f1e), {
                            dateAdapter: (0, $a9251390360fca28$export$e130a45610e3b3b2),
                            adapterLocale: locale || "fi",
                            children: [
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $12b9f7e578355fe5$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $3Py8h.jsx)((0, $ed2dc96e5c72ed90$export$2e2bcd8739ae039), {})
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var $485d6edd1c926c0b$export$2e2bcd8739ae039 = $485d6edd1c926c0b$var$App;




var $1T1QG = parcelRequire("1T1QG");
var $897f2152020fdf2d$export$882461b6382ed46c;
var $897f2152020fdf2d$export$757ceba2d55c277e;
"use strict";

var $897f2152020fdf2d$var$i;
$897f2152020fdf2d$export$882461b6382ed46c = $27f1df944e3d0485$exports.createRoot;
$897f2152020fdf2d$export$757ceba2d55c277e = $27f1df944e3d0485$exports.hydrateRoot;





const $495f6f20308cda43$export$6f57813fe9f31bf9 = (0, $5d190961bb0838a0$export$7d8a5b498da695ac)({
    reducer: {
        moovyUi: $455a74580fe95862$export$2e2bcd8739ae039,
        moovyAuth: $1b8d920c7c0aec35$export$2e2bcd8739ae039
    }
});



var $31044f7c5b53d689$export$2e2bcd8739ae039 = (gtagId)=>{
    const scriptElements = [
        0,
        1
    ].map((_)=>document.createElement("script"));
    if (!/^[a-zA-Z0-9-]*$/.test(gtagId)) throw new Error(`GTAG_ID must only contain letters, numbers and hyphens (got: "${gtagId}")`);
    // first script element (loading Google Analytics)
    scriptElements[0].attributes.setNamedItem(document.createAttribute("async"));
    const srcAttribute = document.createAttribute("src");
    srcAttribute.value = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
    scriptElements[0].attributes.setNamedItem(srcAttribute);
    // second script element (inline script)
    scriptElements[1].textContent = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', '${gtagId}');
  `;
    // inject the script elements
    scriptElements.forEach((scriptElement)=>document.getElementsByTagName("body")[0].appendChild(scriptElement));
};


/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $16d17c26f0ead2cf$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $16d17c26f0ead2cf$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $16d17c26f0ead2cf$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $16d17c26f0ead2cf$var$isGlobalObj(window) || typeof self == "object" && $16d17c26f0ead2cf$var$isGlobalObj(self) || typeof $parcel$global == "object" && $16d17c26f0ead2cf$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $16d17c26f0ead2cf$export$256479dc0cea61c4() {
    return $16d17c26f0ead2cf$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $16d17c26f0ead2cf$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $16d17c26f0ead2cf$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

// eslint-disable-next-line @typescript-eslint/unbound-method
const $7a2b241ae9102e94$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7a2b241ae9102e94$export$e6127cc7fe7395c3(wat) {
    switch($7a2b241ae9102e94$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $7a2b241ae9102e94$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $7a2b241ae9102e94$var$isBuiltin(wat, className) {
    return $7a2b241ae9102e94$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7a2b241ae9102e94$export$9f9636d330b71954(wat) {
    return $7a2b241ae9102e94$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7a2b241ae9102e94$export$ef9e2056653f0c8e(wat) {
    return $7a2b241ae9102e94$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7a2b241ae9102e94$export$12e869b2a583f783(wat) {
    return $7a2b241ae9102e94$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7a2b241ae9102e94$export$844ec244b1367d54(wat) {
    return $7a2b241ae9102e94$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7a2b241ae9102e94$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7a2b241ae9102e94$export$c3825b437cbdea5c(wat) {
    return wat === null || $7a2b241ae9102e94$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7a2b241ae9102e94$export$53b83ca8eaab0383(wat) {
    return $7a2b241ae9102e94$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7a2b241ae9102e94$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $7a2b241ae9102e94$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7a2b241ae9102e94$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $7a2b241ae9102e94$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7a2b241ae9102e94$export$49841c62b9eff15(wat) {
    return $7a2b241ae9102e94$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $7a2b241ae9102e94$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7a2b241ae9102e94$export$bc2894c7158efbac(wat) {
    return $7a2b241ae9102e94$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7a2b241ae9102e94$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $7a2b241ae9102e94$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $7a2b241ae9102e94$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $8d0378382f5a1828$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/** Prefix for logging strings */ const $f78ca609428407bb$var$PREFIX = "Sentry Logger ";
const $f78ca609428407bb$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $f78ca609428407bb$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $f78ca609428407bb$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($f78ca609428407bb$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $f78ca609428407bb$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $f78ca609428407bb$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $8d0378382f5a1828$export$16a28057038b10ef) $f78ca609428407bb$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $f78ca609428407bb$export$cda52e2a8927a2ca(()=>{
                (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1).console[name](`${$f78ca609428407bb$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $f78ca609428407bb$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $f78ca609428407bb$export$af88d00dbe7f521 = $f78ca609428407bb$var$makeLogger();


const $75b4984e5522b249$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $75b4984e5522b249$export$7740643b9eeaf0c4() {
    return Date.now() / $75b4984e5522b249$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $75b4984e5522b249$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $75b4984e5522b249$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $75b4984e5522b249$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $75b4984e5522b249$export$ee52dced521e3e18 = $75b4984e5522b249$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $75b4984e5522b249$export$c5907b5a8838db13 = $75b4984e5522b249$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $75b4984e5522b249$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $75b4984e5522b249$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $75b4984e5522b249$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $75b4984e5522b249$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $75b4984e5522b249$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $75b4984e5522b249$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();



// eslint-disable-next-line deprecation/deprecation
const $e15b4fbcaae97cb7$var$WINDOW = (0, $16d17c26f0ead2cf$export$256479dc0cea61c4)();
const $e15b4fbcaae97cb7$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $e15b4fbcaae97cb7$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $e15b4fbcaae97cb7$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $e15b4fbcaae97cb7$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $e15b4fbcaae97cb7$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($e15b4fbcaae97cb7$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $7a2b241ae9102e94$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $e15b4fbcaae97cb7$export$1cfafeee2987818b() {
    try {
        return $e15b4fbcaae97cb7$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e15b4fbcaae97cb7$export$c660c1f3ab49225c(selector) {
    if ($e15b4fbcaae97cb7$var$WINDOW.document && $e15b4fbcaae97cb7$var$WINDOW.document.querySelector) return $e15b4fbcaae97cb7$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $e15b4fbcaae97cb7$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$e15b4fbcaae97cb7$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $d43244d0c656442a$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $d43244d0c656442a$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d43244d0c656442a$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $7a2b241ae9102e94$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $d43244d0c656442a$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $7a2b241ae9102e94$export$844ec244b1367d54)(value)) return false;
    if ((0, $7a2b241ae9102e94$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $7a2b241ae9102e94$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $d43244d0c656442a$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$d43244d0c656442a$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $2486f7fb3095088f$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $2486f7fb3095088f$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $2486f7fb3095088f$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $8d0378382f5a1828$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $2486f7fb3095088f$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $2486f7fb3095088f$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $2486f7fb3095088f$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $2486f7fb3095088f$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $2486f7fb3095088f$export$62ff257738bf57f5(value) {
    if ((0, $7a2b241ae9102e94$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$2486f7fb3095088f$var$getOwnProperties(value)
    };
    else if ((0, $7a2b241ae9102e94$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $2486f7fb3095088f$var$serializeEventTarget(value.target),
            currentTarget: $2486f7fb3095088f$var$serializeEventTarget(value.currentTarget),
            ...$2486f7fb3095088f$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $7a2b241ae9102e94$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $2486f7fb3095088f$var$serializeEventTarget(target) {
    try {
        return (0, $7a2b241ae9102e94$export$45a5e7f76e0caa8d)(target) ? (0, $e15b4fbcaae97cb7$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $2486f7fb3095088f$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $2486f7fb3095088f$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($2486f7fb3095088f$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $d43244d0c656442a$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $d43244d0c656442a$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $2486f7fb3095088f$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $2486f7fb3095088f$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $2486f7fb3095088f$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($2486f7fb3095088f$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $2486f7fb3095088f$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($2486f7fb3095088f$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $2486f7fb3095088f$var$isPojo(input) {
    if (!(0, $7a2b241ae9102e94$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $2486f7fb3095088f$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $7a2b241ae9102e94$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $0abc5e6206c3ae86$export$19f53698e68b2496() {
    const gbl = (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $0abc5e6206c3ae86$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $0abc5e6206c3ae86$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $0abc5e6206c3ae86$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $0abc5e6206c3ae86$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $0abc5e6206c3ae86$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $0abc5e6206c3ae86$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $0abc5e6206c3ae86$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $0abc5e6206c3ae86$export$d364f2020ab30578(input) {
    const match = input.match($0abc5e6206c3ae86$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $0abc5e6206c3ae86$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $d43244d0c656442a$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $d43244d0c656442a$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $d43244d0c656442a$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $0abc5e6206c3ae86$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $2486f7fb3095088f$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $0abc5e6206c3ae86$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


const $d6eeeba75dd6dfe8$export$849dbeeeda01ae98 = "production";


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $af23f9078c789d20$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;







/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $deb7ace6d5663abb$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($deb7ace6d5663abb$var$States || ($deb7ace6d5663abb$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $deb7ace6d5663abb$export$1fda8aa4d135f8aa(value) {
    return new $deb7ace6d5663abb$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $deb7ace6d5663abb$export$78e43115b553f358(reason) {
    return new $deb7ace6d5663abb$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $deb7ace6d5663abb$export$6f292d4960313241 {
    constructor(executor){
        $deb7ace6d5663abb$export$6f292d4960313241.prototype.__init.call(this);
        $deb7ace6d5663abb$export$6f292d4960313241.prototype.__init2.call(this);
        $deb7ace6d5663abb$export$6f292d4960313241.prototype.__init3.call(this);
        $deb7ace6d5663abb$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $deb7ace6d5663abb$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $deb7ace6d5663abb$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $deb7ace6d5663abb$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($deb7ace6d5663abb$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($deb7ace6d5663abb$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $deb7ace6d5663abb$var$States.PENDING) return;
            if ((0, $7a2b241ae9102e94$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $deb7ace6d5663abb$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $deb7ace6d5663abb$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $deb7ace6d5663abb$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $b46a173447ada04e$export$3c4238858b85e8ac() {
    return (0, $16d17c26f0ead2cf$export$7e223ec222791509)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $b46a173447ada04e$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $b46a173447ada04e$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $b46a173447ada04e$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $deb7ace6d5663abb$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $af23f9078c789d20$export$16a28057038b10ef) && processor.id && result === null && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $7a2b241ae9102e94$export$f5b060c2914b97c8)(result)) result.then((final)=>$b46a173447ada04e$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $b46a173447ada04e$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $d9442fbf30a3ff56$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $75b4984e5522b249$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $0abc5e6206c3ae86$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$d9442fbf30a3ff56$var$sessionToJSON(session)
    };
    if (context) $d9442fbf30a3ff56$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $d9442fbf30a3ff56$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $75b4984e5522b249$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $0abc5e6206c3ae86$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $d9442fbf30a3ff56$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $d9442fbf30a3ff56$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $d9442fbf30a3ff56$var$sessionToJSON(session) {
    return (0, $2486f7fb3095088f$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}






/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $0c5dfa55c02d3dae$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}





const $32e3c03de1c9a833$export$9ca9946bd449ac06 = "baggage";
const $32e3c03de1c9a833$export$6e69537d67fa20f = "sentry-";
const $32e3c03de1c9a833$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $32e3c03de1c9a833$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $32e3c03de1c9a833$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $7a2b241ae9102e94$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $32e3c03de1c9a833$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $32e3c03de1c9a833$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($32e3c03de1c9a833$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($32e3c03de1c9a833$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $32e3c03de1c9a833$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$32e3c03de1c9a833$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $32e3c03de1c9a833$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $32e3c03de1c9a833$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $32e3c03de1c9a833$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $32e3c03de1c9a833$export$bdd844ddb2def819) {
            (0, $8d0378382f5a1828$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $896026ba1cdc6157$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $896026ba1cdc6157$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($896026ba1cdc6157$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $896026ba1cdc6157$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $896026ba1cdc6157$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $32e3c03de1c9a833$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $0abc5e6206c3ae86$export$19f53698e68b2496)(),
            spanId: (0, $0abc5e6206c3ae86$export$19f53698e68b2496)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $0abc5e6206c3ae86$export$19f53698e68b2496)(),
            parentSpanId: parentSpanId || (0, $0abc5e6206c3ae86$export$19f53698e68b2496)().substring(16),
            spanId: (0, $0abc5e6206c3ae86$export$19f53698e68b2496)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $896026ba1cdc6157$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $896026ba1cdc6157$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $32e3c03de1c9a833$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $0abc5e6206c3ae86$export$19f53698e68b2496)(),
        spanId: (0, $0abc5e6206c3ae86$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $0abc5e6206c3ae86$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $0abc5e6206c3ae86$export$19f53698e68b2496)().substring(16),
        spanId: (0, $0abc5e6206c3ae86$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $896026ba1cdc6157$export$f35d907436da45cf(traceId = (0, $0abc5e6206c3ae86$export$19f53698e68b2496)(), spanId = (0, $0abc5e6206c3ae86$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}


// These are aligned with OpenTelemetry trace flags
const $391854fa51155a6b$export$208d5b368507fb8b = 0x0;
const $391854fa51155a6b$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $391854fa51155a6b$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $391854fa51155a6b$export$92d8c23565496537(span);
    return (0, $2486f7fb3095088f$export$d25f2688db1bb433)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $391854fa51155a6b$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $391854fa51155a6b$export$5caecac1caaf3a71(span);
    return (0, $896026ba1cdc6157$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $391854fa51155a6b$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $391854fa51155a6b$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $391854fa51155a6b$var$ensureTimestampInSeconds(input.getTime());
    return (0, $75b4984e5522b249$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $391854fa51155a6b$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $391854fa51155a6b$export$92d8c23565496537(span) {
    if ($391854fa51155a6b$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $391854fa51155a6b$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $391854fa51155a6b$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $391854fa51155a6b$export$eb571cd9b5d98de8);
}


/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $bf724425488f9967$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $2486f7fb3095088f$export$d25f2688db1bb433)({
        environment: options.environment || (0, $d6eeeba75dd6dfe8$export$849dbeeeda01ae98),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $bf724425488f9967$export$a117f995597e25df(span) {
    const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $bf724425488f9967$export$366bad00d6815eed((0, $391854fa51155a6b$export$92d8c23565496537)(span).trace_id || "", client, (0, $3b3c418f52d65472$export$c7be4b0125a10cba)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $0c5dfa55c02d3dae$export$c4c6a79b1260ca1b)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $391854fa51155a6b$export$92d8c23565496537)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $391854fa51155a6b$export$5caecac1caaf3a71)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $9b3b9cec6088b7fa$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $9b3b9cec6088b7fa$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $9b3b9cec6088b7fa$var$applySpanToEvent(event, span);
    $9b3b9cec6088b7fa$var$applyFingerprintToEvent(event, fingerprint);
    $9b3b9cec6088b7fa$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $9b3b9cec6088b7fa$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $9b3b9cec6088b7fa$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $9b3b9cec6088b7fa$export$b1a120a2871faa46(data, "extra", extra);
    $9b3b9cec6088b7fa$export$b1a120a2871faa46(data, "tags", tags);
    $9b3b9cec6088b7fa$export$b1a120a2871faa46(data, "user", user);
    $9b3b9cec6088b7fa$export$b1a120a2871faa46(data, "contexts", contexts);
    $9b3b9cec6088b7fa$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $9b3b9cec6088b7fa$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $9b3b9cec6088b7fa$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $2486f7fb3095088f$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $2486f7fb3095088f$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $2486f7fb3095088f$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $2486f7fb3095088f$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $9b3b9cec6088b7fa$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $9b3b9cec6088b7fa$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $9b3b9cec6088b7fa$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $391854fa51155a6b$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    const rootSpan = (0, $0c5dfa55c02d3dae$export$c4c6a79b1260ca1b)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $bf724425488f9967$export$a117f995597e25df)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $391854fa51155a6b$export$92d8c23565496537)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $9b3b9cec6088b7fa$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $0abc5e6206c3ae86$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $bfacf5e659b1c163$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $bfacf5e659b1c163$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $bfacf5e659b1c163$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $bfacf5e659b1c163$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $bfacf5e659b1c163$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $bfacf5e659b1c163$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $d9442fbf30a3ff56$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $bfacf5e659b1c163$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $7a2b241ae9102e94$export$53b83ca8eaab0383)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $bfacf5e659b1c163$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $bfacf5e659b1c163$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $75b4984e5522b249$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $9b3b9cec6088b7fa$export$43988bc651a80216)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $b46a173447ada04e$export$3c4238858b85e8ac)(),
            ...this._eventProcessors
        ];
        return (0, $b46a173447ada04e$export$bf2a096c3e883e79)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $0abc5e6206c3ae86$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $0abc5e6206c3ae86$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $0abc5e6206c3ae86$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $bfacf5e659b1c163$export$aa55d5ab8e05984f() {
    if (!$bfacf5e659b1c163$var$globalScope) $bfacf5e659b1c163$var$globalScope = new $bfacf5e659b1c163$export$775b6bb06e53a214();
    return $bfacf5e659b1c163$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $bfacf5e659b1c163$export$c83048efd17527d6(scope) {
    $bfacf5e659b1c163$var$globalScope = scope;
}
function $bfacf5e659b1c163$var$generatePropagationContext() {
    return {
        traceId: (0, $0abc5e6206c3ae86$export$19f53698e68b2496)(),
        spanId: (0, $0abc5e6206c3ae86$export$19f53698e68b2496)().substring(16)
    };
}



const $9a2a4aef8b561c15$export$31499a9cd224b78c = "7.112.2";


/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $19e624db95e0b5b5$export$24a86ef7798177e4 = parseFloat((0, $9a2a4aef8b561c15$export$31499a9cd224b78c));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $19e624db95e0b5b5$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $19e624db95e0b5b5$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $19e624db95e0b5b5$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $bfacf5e659b1c163$export$775b6bb06e53a214)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $bfacf5e659b1c163$export$775b6bb06e53a214)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $7a2b241ae9102e94$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $0abc5e6206c3ae86$export$19f53698e68b2496)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $0abc5e6206c3ae86$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $0abc5e6206c3ae86$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $19e624db95e0b5b5$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $75b4984e5522b249$export$7740643b9eeaf0c4)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $f78ca609428407bb$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $19e624db95e0b5b5$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $19e624db95e0b5b5$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $af23f9078c789d20$export$16a28057038b10ef) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $d9442fbf30a3ff56$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $d6eeeba75dd6dfe8$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1).navigator || {};
        const session = (0, $d9442fbf30a3ff56$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $d9442fbf30a3ff56$export$531818e825e774db)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $19e624db95e0b5b5$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $19e624db95e0b5b5$export$19eade501500c6c1() {
    (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1).__SENTRY__ = (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $19e624db95e0b5b5$export$4188a14ad302d1bc(hub) {
    const registry = $19e624db95e0b5b5$export$19eade501500c6c1();
    const oldHub = $19e624db95e0b5b5$export$bfa8a924a84a76b7(registry);
    $19e624db95e0b5b5$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $19e624db95e0b5b5$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $19e624db95e0b5b5$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $19e624db95e0b5b5$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $19e624db95e0b5b5$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $19e624db95e0b5b5$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $19e624db95e0b5b5$var$getGlobalHub(registry = $19e624db95e0b5b5$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$19e624db95e0b5b5$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $19e624db95e0b5b5$export$bfa8a924a84a76b7(registry).isOlderThan($19e624db95e0b5b5$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $19e624db95e0b5b5$export$849f05434e95d2f2(registry, new $19e624db95e0b5b5$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $19e624db95e0b5b5$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $19e624db95e0b5b5$export$236689a79f5aa020(carrier, parent = $19e624db95e0b5b5$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$19e624db95e0b5b5$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $19e624db95e0b5b5$export$bfa8a924a84a76b7(carrier).isOlderThan($19e624db95e0b5b5$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $19e624db95e0b5b5$export$849f05434e95d2f2(carrier, new $19e624db95e0b5b5$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $19e624db95e0b5b5$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $19e624db95e0b5b5$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $19e624db95e0b5b5$export$70d775fb1f267027(callback, options = {}) {
    const registry = $19e624db95e0b5b5$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $19e624db95e0b5b5$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $19e624db95e0b5b5$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $16d17c26f0ead2cf$export$7e223ec222791509)("hub", ()=>new $19e624db95e0b5b5$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $19e624db95e0b5b5$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $2e03999275d4fe37$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Does this filename look like it's part of the app code?
 */ function $4baeb2b7e95601a3$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $4baeb2b7e95601a3$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $4baeb2b7e95601a3$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $88530b1c1c4d5f59$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $88530b1c1c4d5f59$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $88530b1c1c4d5f59$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $88530b1c1c4d5f59$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $88530b1c1c4d5f59$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($88530b1c1c4d5f59$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $88530b1c1c4d5f59$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $88530b1c1c4d5f59$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $88530b1c1c4d5f59$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $88530b1c1c4d5f59$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $88530b1c1c4d5f59$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($88530b1c1c4d5f59$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($88530b1c1c4d5f59$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $88530b1c1c4d5f59$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $88530b1c1c4d5f59$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $88530b1c1c4d5f59$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $88530b1c1c4d5f59$var$defaultFunctionName;
        return fn.name || $88530b1c1c4d5f59$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $88530b1c1c4d5f59$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $88530b1c1c4d5f59$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $4baeb2b7e95601a3$export$35059013cd4a06db)(getModule)
    ];
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5356bc1441432547$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $5356bc1441432547$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $5356bc1441432547$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $5356bc1441432547$export$a3295358bff77e(object, depth);
    if ($5356bc1441432547$var$jsonSize(normalized) > maxSize) return $5356bc1441432547$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $5356bc1441432547$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $2e03999275d4fe37$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $7a2b241ae9102e94$export$c9f5652083b8129d)(value)) return value;
    const stringified = $5356bc1441432547$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $5356bc1441432547$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $2486f7fb3095088f$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $5356bc1441432547$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $5356bc1441432547$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $7a2b241ae9102e94$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $7a2b241ae9102e94$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $88530b1c1c4d5f59$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $5356bc1441432547$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $5356bc1441432547$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $5356bc1441432547$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5356bc1441432547$var$jsonSize(value) {
    return $5356bc1441432547$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $5356bc1441432547$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}







/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $b7d389fd659a89c0$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $0abc5e6206c3ae86$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $75b4984e5522b249$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $b7d389fd659a89c0$var$applyClientOptions(prepared, options);
    $b7d389fd659a89c0$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $b7d389fd659a89c0$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $b7d389fd659a89c0$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $0abc5e6206c3ae86$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $bfacf5e659b1c163$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $9b3b9cec6088b7fa$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $9b3b9cec6088b7fa$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $9b3b9cec6088b7fa$export$43988bc651a80216)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $b46a173447ada04e$export$3c4238858b85e8ac)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $b46a173447ada04e$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $b7d389fd659a89c0$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $b7d389fd659a89c0$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $b7d389fd659a89c0$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $d6eeeba75dd6dfe8$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $d43244d0c656442a$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $d43244d0c656442a$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $d43244d0c656442a$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $b7d389fd659a89c0$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $b7d389fd659a89c0$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $b7d389fd659a89c0$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $b7d389fd659a89c0$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $b7d389fd659a89c0$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $b7d389fd659a89c0$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $b7d389fd659a89c0$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $5356bc1441432547$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $5356bc1441432547$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $5356bc1441432547$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $5356bc1441432547$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $5356bc1441432547$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $391854fa51155a6b$export$92d8c23565496537)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $5356bc1441432547$export$a3295358bff77e)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $b7d389fd659a89c0$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $bfacf5e659b1c163$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $b7d389fd659a89c0$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($b7d389fd659a89c0$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($b7d389fd659a89c0$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $b7d389fd659a89c0$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $bfacf5e659b1c163$export$775b6bb06e53a214) || typeof hint === "function";
}
const $b7d389fd659a89c0$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $b7d389fd659a89c0$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$b7d389fd659a89c0$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $3b3c418f52d65472$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)().captureException(exception, (0, $b7d389fd659a89c0$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $3b3c418f52d65472$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $3b3c418f52d65472$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $3b3c418f52d65472$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $3b3c418f52d65472$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $3b3c418f52d65472$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $3b3c418f52d65472$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $3b3c418f52d65472$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $3b3c418f52d65472$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $3b3c418f52d65472$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $3b3c418f52d65472$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $3b3c418f52d65472$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $3b3c418f52d65472$export$9a4fed82c350c2bd(callback) {
    return (0, $19e624db95e0b5b5$export$70d775fb1f267027)(()=>{
        return callback((0, $19e624db95e0b5b5$export$68f3af03034c9e90)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $3b3c418f52d65472$export$e57ac09b143d92a2(span, callback) {
    return $3b3c418f52d65472$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $3b3c418f52d65472$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $3b3c418f52d65472$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $3b3c418f52d65472$export$c7be4b0125a10cba();
    const client = $3b3c418f52d65472$export$6bb76d6eba7e258c();
    if (!client) (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $0abc5e6206c3ae86$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $3b3c418f52d65472$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $3b3c418f52d65472$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $75b4984e5522b249$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $3b3c418f52d65472$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $75b4984e5522b249$export$ee52dced521e3e18)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $7a2b241ae9102e94$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $3b3c418f52d65472$export$4909b86c8034bf73(timeout) {
    const client = $3b3c418f52d65472$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $3b3c418f52d65472$export$8360e631d277ea4d(timeout) {
    const client = $3b3c418f52d65472$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 * @deprecated This function will be removed in the next major version of the Sentry SDK.
 */ function $3b3c418f52d65472$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $3b3c418f52d65472$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $3b3c418f52d65472$export$3f95c6f800b78024() {
    return !!$3b3c418f52d65472$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $3b3c418f52d65472$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $3b3c418f52d65472$export$c0d84948cecf78d8(context) {
    const client = $3b3c418f52d65472$export$6bb76d6eba7e258c();
    const isolationScope = (0, $19e624db95e0b5b5$export$68f3af03034c9e90)();
    const currentScope = $3b3c418f52d65472$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $d6eeeba75dd6dfe8$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $d9442fbf30a3ff56$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $d9442fbf30a3ff56$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $3b3c418f52d65472$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $3b3c418f52d65472$export$17a5be43989a0bc1() {
    const isolationScope = (0, $19e624db95e0b5b5$export$68f3af03034c9e90)();
    const currentScope = $3b3c418f52d65472$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $d9442fbf30a3ff56$export$56521d9ba90f62ee)(session);
    $3b3c418f52d65472$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $3b3c418f52d65472$var$_sendSessionUpdate() {
    const isolationScope = (0, $19e624db95e0b5b5$export$68f3af03034c9e90)();
    const currentScope = $3b3c418f52d65472$export$c7be4b0125a10cba();
    const client = $3b3c418f52d65472$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $3b3c418f52d65472$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $3b3c418f52d65472$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $3b3c418f52d65472$var$_sendSessionUpdate();
}








const $f8e6000d29329e0a$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $f8e6000d29329e0a$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $f8e6000d29329e0a$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $0abc5e6206c3ae86$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $f8e6000d29329e0a$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $f8e6000d29329e0a$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $f8e6000d29329e0a$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $f8e6000d29329e0a$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $f8e6000d29329e0a$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $f8e6000d29329e0a$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($f8e6000d29329e0a$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $b46a173447ada04e$export$8e4e25f54d456511), (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c));
        $f8e6000d29329e0a$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $f8e6000d29329e0a$export$2d8f5188773bcddd(integration) {
    const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
    if (!client || !client.addIntegration) {
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $f8e6000d29329e0a$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $f8e6000d29329e0a$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $f8e6000d29329e0a$export$2323046b9414659f(fn) {
    return fn;
}


let $e2f186284bd2b67f$var$originalFunctionToString;
const $e2f186284bd2b67f$var$INTEGRATION_NAME = "FunctionToString";
const $e2f186284bd2b67f$var$SETUP_CLIENTS = new WeakMap();
const $e2f186284bd2b67f$var$_functionToStringIntegration = ()=>{
    return {
        name: $e2f186284bd2b67f$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $e2f186284bd2b67f$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $2486f7fb3095088f$export$e6cc1e135e2092e5)(this);
                    const context = $e2f186284bd2b67f$var$SETUP_CLIENTS.has((0, $3b3c418f52d65472$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $e2f186284bd2b67f$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $e2f186284bd2b67f$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $e2f186284bd2b67f$export$7918117e9202e4fb = (0, $f8e6000d29329e0a$export$2323046b9414659f)($e2f186284bd2b67f$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $e2f186284bd2b67f$export$da4704525c20ae79 = (0, $f8e6000d29329e0a$export$afa219bf23651160)($e2f186284bd2b67f$var$INTEGRATION_NAME, $e2f186284bd2b67f$export$7918117e9202e4fb);



/** Regular expression used to parse a Dsn. */ const $bd17516cf9421867$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $bd17516cf9421867$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $bd17516cf9421867$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $bd17516cf9421867$export$b892860177f70a30(str) {
    const match = $bd17516cf9421867$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $f78ca609428407bb$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $bd17516cf9421867$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $bd17516cf9421867$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $bd17516cf9421867$var$validateDsn(dsn) {
    if (!(0, $8d0378382f5a1828$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $f78ca609428407bb$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $f78ca609428407bb$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$bd17516cf9421867$var$isValidProtocol(protocol)) {
        (0, $f78ca609428407bb$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $f78ca609428407bb$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $bd17516cf9421867$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $bd17516cf9421867$export$b892860177f70a30(from) : $bd17516cf9421867$var$dsnFromComponents(from);
    if (!components || !$bd17516cf9421867$var$validateDsn(components)) return undefined;
    return components;
}


const $1771321400d53665$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $1771321400d53665$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $1771321400d53665$var$_getIngestEndpoint(dsn) {
    return `${$1771321400d53665$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $1771321400d53665$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $2486f7fb3095088f$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $1771321400d53665$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $1771321400d53665$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$1771321400d53665$var$_getIngestEndpoint(dsn)}?${$1771321400d53665$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $1771321400d53665$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $bd17516cf9421867$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$1771321400d53665$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $bd17516cf9421867$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $11d7b718b83002b9$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $11d7b718b83002b9$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $11d7b718b83002b9$var$INTEGRATION_NAME = "InboundFilters";
const $11d7b718b83002b9$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $11d7b718b83002b9$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $11d7b718b83002b9$var$_mergeOptions(options, clientOptions);
            return $11d7b718b83002b9$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $11d7b718b83002b9$export$cb3c5c2ceb9818ba = (0, $f8e6000d29329e0a$export$2323046b9414659f)($11d7b718b83002b9$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $11d7b718b83002b9$export$2ffbb5359dcc6be4 = (0, $f8e6000d29329e0a$export$afa219bf23651160)($11d7b718b83002b9$var$INTEGRATION_NAME, $11d7b718b83002b9$export$cb3c5c2ceb9818ba);
function $11d7b718b83002b9$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $11d7b718b83002b9$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $11d7b718b83002b9$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $11d7b718b83002b9$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $11d7b718b83002b9$var$_isSentryError(event)) {
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $0abc5e6206c3ae86$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($11d7b718b83002b9$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $0abc5e6206c3ae86$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($11d7b718b83002b9$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $0abc5e6206c3ae86$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($11d7b718b83002b9$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $0abc5e6206c3ae86$export$4157119e2b157127)(event)}.\nUrl: ${$11d7b718b83002b9$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$11d7b718b83002b9$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $0abc5e6206c3ae86$export$4157119e2b157127)(event)}.\nUrl: ${$11d7b718b83002b9$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $11d7b718b83002b9$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $11d7b718b83002b9$var$_getPossibleEventMessages(event).some((message)=>(0, $d43244d0c656442a$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $11d7b718b83002b9$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $d43244d0c656442a$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $11d7b718b83002b9$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $11d7b718b83002b9$var$_getEventFilterUrl(event);
    return !url ? false : (0, $d43244d0c656442a$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $11d7b718b83002b9$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $11d7b718b83002b9$var$_getEventFilterUrl(event);
    return !url ? true : (0, $d43244d0c656442a$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $11d7b718b83002b9$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $af23f9078c789d20$export$16a28057038b10ef) && possibleMessages.length === 0) (0, $f78ca609428407bb$export$af88d00dbe7f521).error(`Could not extract message for event ${(0, $0abc5e6206c3ae86$export$4157119e2b157127)(event)}`);
    return possibleMessages;
}
function $11d7b718b83002b9$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $11d7b718b83002b9$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $11d7b718b83002b9$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $11d7b718b83002b9$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $0abc5e6206c3ae86$export$4157119e2b157127)(event)}`);
        return null;
    }
}





/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $72c7e0ab47307024$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $af23f9078c789d20$export$16a28057038b10ef) (0, $f78ca609428407bb$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $f78ca609428407bb$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $3b3c418f52d65472$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $72c7e0ab47307024$export$ecb76f41d43c0e43(client);
    $72c7e0ab47307024$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $72c7e0ab47307024$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $72c7e0ab47307024$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}







// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $c2fd36cedd20de25$var$WINDOW = (0, $16d17c26f0ead2cf$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $c2fd36cedd20de25$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $c2fd36cedd20de25$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $c2fd36cedd20de25$var$WINDOW && !!$c2fd36cedd20de25$var$WINDOW.history.pushState && !!$c2fd36cedd20de25$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}





// We keep the handlers globally
const $7aed7ba372d2e673$var$handlers = {};
const $7aed7ba372d2e673$var$instrumented = {};
/** Add a handler function. */ function $7aed7ba372d2e673$export$a4e09611e30da72e(type, handler) {
    $7aed7ba372d2e673$var$handlers[type] = $7aed7ba372d2e673$var$handlers[type] || [];
    $7aed7ba372d2e673$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $7aed7ba372d2e673$export$b17eab759a1cb5fe() {
    Object.keys($7aed7ba372d2e673$var$handlers).forEach((key)=>{
        $7aed7ba372d2e673$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $7aed7ba372d2e673$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$7aed7ba372d2e673$var$instrumented[type]) {
        instrumentFn();
        $7aed7ba372d2e673$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $7aed7ba372d2e673$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $7aed7ba372d2e673$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $8d0378382f5a1828$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $88530b1c1c4d5f59$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


const $2c6eb7f56917cfd8$var$WINDOW = (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1);
let $2c6eb7f56917cfd8$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $2c6eb7f56917cfd8$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $7aed7ba372d2e673$export$a4e09611e30da72e)(type, handler);
    (0, $7aed7ba372d2e673$export$e18d6c5462c01368)(type, $2c6eb7f56917cfd8$var$instrumentHistory);
}
function $2c6eb7f56917cfd8$var$instrumentHistory() {
    if (!(0, $c2fd36cedd20de25$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $2c6eb7f56917cfd8$var$WINDOW.onpopstate;
    $2c6eb7f56917cfd8$var$WINDOW.onpopstate = function(...args) {
        const to = $2c6eb7f56917cfd8$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $2c6eb7f56917cfd8$var$lastHref;
        $2c6eb7f56917cfd8$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $7aed7ba372d2e673$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $2c6eb7f56917cfd8$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $2c6eb7f56917cfd8$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $7aed7ba372d2e673$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $2486f7fb3095088f$export$9563e054e6f787fb)($2c6eb7f56917cfd8$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $2486f7fb3095088f$export$9563e054e6f787fb)($2c6eb7f56917cfd8$var$WINDOW.history, "replaceState", historyReplacementFunction);
}




// eslint-disable-next-line deprecation/deprecation
const $8c4451bdd75a3273$var$WINDOW = (0, $16d17c26f0ead2cf$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $8c4451bdd75a3273$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $8c4451bdd75a3273$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $8c4451bdd75a3273$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $8c4451bdd75a3273$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $8c4451bdd75a3273$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $8c4451bdd75a3273$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $8c4451bdd75a3273$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$8c4451bdd75a3273$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($8c4451bdd75a3273$export$18cf36ed71d733e7($8c4451bdd75a3273$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $8c4451bdd75a3273$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $8c4451bdd75a3273$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $8d0378382f5a1828$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $8c4451bdd75a3273$export$531055a6c684a70a() {
    return "ReportingObserver" in $8c4451bdd75a3273$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $8c4451bdd75a3273$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$8c4451bdd75a3273$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}



/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $a43e6439fd35dae3$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $9a2a4aef8b561c15$export$31499a9cd224b78c)
            })),
        version: (0, $9a2a4aef8b561c15$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $32ccdd6e4b62c3ba$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $32ccdd6e4b62c3ba$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $32ccdd6e4b62c3ba$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $32ccdd6e4b62c3ba$export$604a45d95a155e2b(envelope, types) {
    return $32ccdd6e4b62c3ba$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $32ccdd6e4b62c3ba$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $32ccdd6e4b62c3ba$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $32ccdd6e4b62c3ba$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $32ccdd6e4b62c3ba$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $5356bc1441432547$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $32ccdd6e4b62c3ba$var$concatBuffers(parts);
}
function $32ccdd6e4b62c3ba$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $32ccdd6e4b62c3ba$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $32ccdd6e4b62c3ba$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $32ccdd6e4b62c3ba$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $2486f7fb3095088f$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $32ccdd6e4b62c3ba$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $32ccdd6e4b62c3ba$export$b11169581eeaf237(type) {
    return $32ccdd6e4b62c3ba$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $32ccdd6e4b62c3ba$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $32ccdd6e4b62c3ba$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $bd17516cf9421867$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $2486f7fb3095088f$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}

/** An error emitted by Sentry SDKs and related utilities. */ class $31ea12416213c5aa$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $8ab03cb37adbe9d6$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $8ab03cb37adbe9d6$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $32ccdd6e4b62c3ba$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $bd17516cf9421867$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $32ccdd6e4b62c3ba$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $8ab03cb37adbe9d6$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $32ccdd6e4b62c3ba$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $8ab03cb37adbe9d6$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $32ccdd6e4b62c3ba$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $32ccdd6e4b62c3ba$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}







/**
 * Generate bucket key from metric properties.
 */ function $7706d5980c359887$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $2486f7fb3095088f$export$d25f2688db1bb433)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $7706d5980c359887$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $7706d5980c359887$export$66decd709db01dc8(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $7706d5980c359887$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, "_");
}
/** Sanitizes metric keys */ function $7706d5980c359887$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, "_");
}
function $7706d5980c359887$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, "");
}
const $7706d5980c359887$var$tagValueReplacements = [
    [
        "\n",
        "\\n"
    ],
    [
        "\r",
        "\\r"
    ],
    [
        "	",
        "\\t"
    ],
    [
        "\\",
        "\\\\"
    ],
    [
        "|",
        "\\u{7c}"
    ],
    [
        ",",
        "\\u{2c}"
    ]
];
function $7706d5980c359887$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $7706d5980c359887$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $7706d5980c359887$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $7706d5980c359887$var$getCharOrReplacement(char), "");
}
/**
 * Sanitizes tags.
 */ function $7706d5980c359887$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $7706d5980c359887$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $7706d5980c359887$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $6c6dffb4be853dc0$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $bd17516cf9421867$export$44d472fbb931a776)(dsn);
    const item = $6c6dffb4be853dc0$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $32ccdd6e4b62c3ba$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $6c6dffb4be853dc0$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $7706d5980c359887$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}





const $2315f9f5121a434b$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $2315f9f5121a434b$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $bd17516cf9421867$export$128827c3562ec0cb)(options.dsn);
        else (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $1771321400d53665$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $0abc5e6206c3ae86$export$6de4ffac6a2f1098)(exception)) {
            (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log($2315f9f5121a434b$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $7a2b241ae9102e94$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $7a2b241ae9102e94$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $0abc5e6206c3ae86$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log($2315f9f5121a434b$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $d9442fbf30a3ff56$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $deb7ace6d5663abb$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $f8e6000d29329e0a$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $f8e6000d29329e0a$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $8ab03cb37adbe9d6$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $32ccdd6e4b62c3ba$export$d650323442802f6f)(env, (0, $32ccdd6e4b62c3ba$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $8ab03cb37adbe9d6$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $6c6dffb4be853dc0$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $f8e6000d29329e0a$export$51abed9797baa598)(this, integrations);
        (0, $f8e6000d29329e0a$export$35abcfd71227c6ca)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $d9442fbf30a3ff56$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $deb7ace6d5663abb$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $19e624db95e0b5b5$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $b7d389fd659a89c0$export$2d67fb380bd11267)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $bf724425488f9967$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $af23f9078c789d20$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $f78ca609428407bb$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $2315f9f5121a434b$var$isTransactionEvent(event);
        const isError = $2315f9f5121a434b$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $deb7ace6d5663abb$export$78e43115b553f358)(new (0, $31ea12416213c5aa$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $31ea12416213c5aa$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $2315f9f5121a434b$var$processBeforeSend(options, prepared, hint);
            return $2315f9f5121a434b$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                throw new (0, $31ea12416213c5aa$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $31ea12416213c5aa$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $31ea12416213c5aa$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).error("Error while sending event:", reason);
        });
        else (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $2315f9f5121a434b$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $7a2b241ae9102e94$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $7a2b241ae9102e94$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $31ea12416213c5aa$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $31ea12416213c5aa$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $7a2b241ae9102e94$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $31ea12416213c5aa$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $2315f9f5121a434b$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($2315f9f5121a434b$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($2315f9f5121a434b$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $2315f9f5121a434b$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $2315f9f5121a434b$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $2315f9f5121a434b$export$9aac0b9f77928fbf(callback) {
    const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $1c8b3e9705e3374e$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $75b4984e5522b249$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $32ccdd6e4b62c3ba$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $iD6fk = parcelRequire("iD6fk");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $cff9a4d96bff0440$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;




/**
 * This function creates an exception from a JavaScript Error
 */ function $89757242536346b6$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $89757242536346b6$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $89757242536346b6$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $89757242536346b6$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $7a2b241ae9102e94$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $89757242536346b6$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $5356bc1441432547$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $89757242536346b6$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $89757242536346b6$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $89757242536346b6$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $89757242536346b6$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $89757242536346b6$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $89757242536346b6$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $89757242536346b6$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($89757242536346b6$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $89757242536346b6$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $89757242536346b6$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $89757242536346b6$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $0abc5e6206c3ae86$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $deb7ace6d5663abb$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $89757242536346b6$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $89757242536346b6$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $deb7ace6d5663abb$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $89757242536346b6$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $7a2b241ae9102e94$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $89757242536346b6$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $7a2b241ae9102e94$export$ef9e2056653f0c8e)(exception) || (0, $7a2b241ae9102e94$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $89757242536346b6$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $7a2b241ae9102e94$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $89757242536346b6$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $0abc5e6206c3ae86$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $7a2b241ae9102e94$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $89757242536346b6$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $7a2b241ae9102e94$export$53b83ca8eaab0383)(exception) || (0, $7a2b241ae9102e94$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $89757242536346b6$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $0abc5e6206c3ae86$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $89757242536346b6$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $0abc5e6206c3ae86$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $0abc5e6206c3ae86$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $89757242536346b6$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $89757242536346b6$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $7a2b241ae9102e94$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $89757242536346b6$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $2486f7fb3095088f$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $7a2b241ae9102e94$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $7a2b241ae9102e94$export$9671ea99bd126ace)(exception)) {
        const className = $89757242536346b6$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $89757242536346b6$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}





const $0c03304570a3d428$export$56d8a8a25bd48b81 = (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1);
let $0c03304570a3d428$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $0c03304570a3d428$export$b79738ab10c590b2() {
    return $0c03304570a3d428$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $0c03304570a3d428$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $0c03304570a3d428$var$ignoreOnError++;
    setTimeout(()=>{
        $0c03304570a3d428$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $0c03304570a3d428$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $2486f7fb3095088f$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$0c03304570a3d428$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $0c03304570a3d428$export$1265a142ff5ba165();
            (0, $3b3c418f52d65472$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $0abc5e6206c3ae86$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $0abc5e6206c3ae86$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $3b3c418f52d65472$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $2486f7fb3095088f$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $2486f7fb3095088f$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $832c383e659d858c$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $bd17516cf9421867$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $832c383e659d858c$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $32ccdd6e4b62c3ba$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $832c383e659d858c$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $d1d077ebee1bfdb0$export$1df9218a526d318d extends (0, $2315f9f5121a434b$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $0c03304570a3d428$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $iD6fk.getSDKSource)();
        (0, $a43e6439fd35dae3$export$b9f95b027256052c)(options, "browser", [
            "browser"
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $0c03304570a3d428$export$56d8a8a25bd48b81).document) (0, $0c03304570a3d428$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $0c03304570a3d428$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $89757242536346b6$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $89757242536346b6$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $cff9a4d96bff0440$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $832c383e659d858c$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $cff9a4d96bff0440$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $cff9a4d96bff0440$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $cff9a4d96bff0440$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $1c8b3e9705e3374e$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $bd17516cf9421867$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}









const $b2d47dbe7e2ec34d$var$WINDOW = (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1);
const $b2d47dbe7e2ec34d$var$DEBOUNCE_DURATION = 1000;
let $b2d47dbe7e2ec34d$var$debounceTimerID;
let $b2d47dbe7e2ec34d$var$lastCapturedEventType;
let $b2d47dbe7e2ec34d$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $b2d47dbe7e2ec34d$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $7aed7ba372d2e673$export$a4e09611e30da72e)(type, handler);
    (0, $7aed7ba372d2e673$export$e18d6c5462c01368)(type, $b2d47dbe7e2ec34d$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $b2d47dbe7e2ec34d$export$3014bbf0af0e1d4a() {
    if (!$b2d47dbe7e2ec34d$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $7aed7ba372d2e673$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $b2d47dbe7e2ec34d$var$makeDOMEventHandler(triggerDOMHandler, true);
    $b2d47dbe7e2ec34d$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $b2d47dbe7e2ec34d$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $b2d47dbe7e2ec34d$var$WINDOW[target] && $b2d47dbe7e2ec34d$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $2486f7fb3095088f$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $b2d47dbe7e2ec34d$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $2486f7fb3095088f$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $b2d47dbe7e2ec34d$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $b2d47dbe7e2ec34d$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $b2d47dbe7e2ec34d$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $b2d47dbe7e2ec34d$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $b2d47dbe7e2ec34d$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $b2d47dbe7e2ec34d$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($b2d47dbe7e2ec34d$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $2486f7fb3095088f$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $2486f7fb3095088f$export$e73679ffaf56810e)(target, "_sentryId", (0, $0abc5e6206c3ae86$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$b2d47dbe7e2ec34d$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $b2d47dbe7e2ec34d$var$lastCapturedEventType = event.type;
            $b2d47dbe7e2ec34d$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($b2d47dbe7e2ec34d$var$debounceTimerID);
        $b2d47dbe7e2ec34d$var$debounceTimerID = $b2d47dbe7e2ec34d$var$WINDOW.setTimeout(()=>{
            $b2d47dbe7e2ec34d$var$lastCapturedEventTargetId = undefined;
            $b2d47dbe7e2ec34d$var$lastCapturedEventType = undefined;
        }, $b2d47dbe7e2ec34d$var$DEBOUNCE_DURATION);
    };
}
function $b2d47dbe7e2ec34d$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $9f446be840593dc0$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $7aed7ba372d2e673$export$a4e09611e30da72e)(type, handler);
    (0, $7aed7ba372d2e673$export$e18d6c5462c01368)(type, $9f446be840593dc0$var$instrumentConsole);
}
function $9f446be840593dc0$var$instrumentConsole() {
    if (!("console" in (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1))) return;
    (0, $f78ca609428407bb$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1).console)) return;
        (0, $2486f7fb3095088f$export$9563e054e6f787fb)((0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $f78ca609428407bb$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $7aed7ba372d2e673$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $f78ca609428407bb$export$77c4ce905194557b)[level];
                log && log.apply((0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $5adf1dbc05c20562$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $7aed7ba372d2e673$export$a4e09611e30da72e)(type, handler);
    (0, $7aed7ba372d2e673$export$e18d6c5462c01368)(type, $5adf1dbc05c20562$var$instrumentFetch);
}
function $5adf1dbc05c20562$var$instrumentFetch() {
    if (!(0, $8c4451bdd75a3273$export$c82d238e23c40b21)()) return;
    (0, $2486f7fb3095088f$export$9563e054e6f787fb)((0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $5adf1dbc05c20562$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $7aed7ba372d2e673$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $7aed7ba372d2e673$export$b18c893e424d3127)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $7aed7ba372d2e673$export$b18c893e424d3127)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $5adf1dbc05c20562$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $5adf1dbc05c20562$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($5adf1dbc05c20562$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $5adf1dbc05c20562$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $5adf1dbc05c20562$var$getUrlFromResource(url),
            method: $5adf1dbc05c20562$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $5adf1dbc05c20562$var$getUrlFromResource(arg),
        method: $5adf1dbc05c20562$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}





const $3c4b84232c65ad9a$var$WINDOW = (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1);
const $3c4b84232c65ad9a$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3c4b84232c65ad9a$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $7aed7ba372d2e673$export$a4e09611e30da72e)(type, handler);
    (0, $7aed7ba372d2e673$export$e18d6c5462c01368)(type, $3c4b84232c65ad9a$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $3c4b84232c65ad9a$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$3c4b84232c65ad9a$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $2486f7fb3095088f$export$9563e054e6f787fb)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $7a2b241ae9102e94$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $3c4b84232c65ad9a$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$3c4b84232c65ad9a$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$3c4b84232c65ad9a$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $7aed7ba372d2e673$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $2486f7fb3095088f$export$9563e054e6f787fb)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $2486f7fb3095088f$export$9563e054e6f787fb)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$3c4b84232c65ad9a$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $7a2b241ae9102e94$export$844ec244b1367d54)(header) && (0, $7a2b241ae9102e94$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $2486f7fb3095088f$export$9563e054e6f787fb)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$3c4b84232c65ad9a$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $7aed7ba372d2e673$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $3c4b84232c65ad9a$var$parseUrl(url) {
    if ((0, $7a2b241ae9102e94$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $b558a229e6ddb058$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $b558a229e6ddb058$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $b558a229e6ddb058$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $b558a229e6ddb058$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $36c101e70d27a732$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $36c101e70d27a732$export$e01cef29b4327697(level) {
    return $36c101e70d27a732$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $36c101e70d27a732$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $36c101e70d27a732$export$411d0ffdba845b6c.includes(level) ? level : "log";
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $3a14474c2326a9a3$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $3a14474c2326a9a3$var$INTEGRATION_NAME = "Breadcrumbs";
const $3a14474c2326a9a3$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $3a14474c2326a9a3$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $9f446be840593dc0$export$1d6e0d073f9e6723)($3a14474c2326a9a3$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $b2d47dbe7e2ec34d$export$5aeffd3db2cf9df7)($3a14474c2326a9a3$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $3c4b84232c65ad9a$export$26ace48dd54c9aea)($3a14474c2326a9a3$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $5adf1dbc05c20562$export$f75d3c772c923df0)($3a14474c2326a9a3$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $2c6eb7f56917cfd8$export$3f18c56c58114e75)($3a14474c2326a9a3$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", $3a14474c2326a9a3$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $3a14474c2326a9a3$export$c079d904b326663a = (0, $f8e6000d29329e0a$export$2323046b9414659f)($3a14474c2326a9a3$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $3a14474c2326a9a3$export$2dc68d50d56fbbd = (0, $f8e6000d29329e0a$export$afa219bf23651160)($3a14474c2326a9a3$var$INTEGRATION_NAME, $3a14474c2326a9a3$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $3a14474c2326a9a3$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $3b3c418f52d65472$export$6bb76d6eba7e258c)() !== client) return;
        (0, $3b3c418f52d65472$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $0abc5e6206c3ae86$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $3a14474c2326a9a3$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $3b3c418f52d65472$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $3a14474c2326a9a3$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $cff9a4d96bff0440$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$3a14474c2326a9a3$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$3a14474c2326a9a3$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $3a14474c2326a9a3$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $3a14474c2326a9a3$var$_isEvent(event) ? event.target : event;
            target = (0, $e15b4fbcaae97cb7$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $e15b4fbcaae97cb7$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $3b3c418f52d65472$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $3a14474c2326a9a3$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $3b3c418f52d65472$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $36c101e70d27a732$export$d771ef054122c30a)(handlerData.level),
            message: (0, $d43244d0c656442a$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $d43244d0c656442a$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $3b3c418f52d65472$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $3a14474c2326a9a3$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $3b3c418f52d65472$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $3c4b84232c65ad9a$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $3b3c418f52d65472$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $3a14474c2326a9a3$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $3b3c418f52d65472$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $3b3c418f52d65472$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $3b3c418f52d65472$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $3a14474c2326a9a3$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $3b3c418f52d65472$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $b558a229e6ddb058$export$7a5253c0f62e0150)((0, $0c03304570a3d428$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $b558a229e6ddb058$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $b558a229e6ddb058$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $3b3c418f52d65472$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $3a14474c2326a9a3$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $cdab0846da1aae66$var$INTEGRATION_NAME = "Dedupe";
const $cdab0846da1aae66$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $cdab0846da1aae66$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($cdab0846da1aae66$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $cff9a4d96bff0440$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $cdab0846da1aae66$export$6d39aa44cd0c7567 = (0, $f8e6000d29329e0a$export$2323046b9414659f)($cdab0846da1aae66$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $cdab0846da1aae66$export$688d98c249d31ad3 = (0, $f8e6000d29329e0a$export$afa219bf23651160)($cdab0846da1aae66$var$INTEGRATION_NAME, $cdab0846da1aae66$export$6d39aa44cd0c7567);
function $cdab0846da1aae66$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($cdab0846da1aae66$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($cdab0846da1aae66$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $cdab0846da1aae66$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$cdab0846da1aae66$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$cdab0846da1aae66$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $cdab0846da1aae66$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $cdab0846da1aae66$var$_getExceptionFromEvent(previousEvent);
    const currentException = $cdab0846da1aae66$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$cdab0846da1aae66$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$cdab0846da1aae66$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $cdab0846da1aae66$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $cdab0846da1aae66$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $cdab0846da1aae66$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $cdab0846da1aae66$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $cdab0846da1aae66$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $cdab0846da1aae66$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}





let $187cc5ad6d517684$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $187cc5ad6d517684$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $7aed7ba372d2e673$export$a4e09611e30da72e)(type, handler);
    (0, $7aed7ba372d2e673$export$e18d6c5462c01368)(type, $187cc5ad6d517684$var$instrumentError);
}
function $187cc5ad6d517684$var$instrumentError() {
    $187cc5ad6d517684$var$_oldOnErrorHandler = (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1).onerror;
    (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $7aed7ba372d2e673$export$b18c893e424d3127)("error", handlerData);
        if ($187cc5ad6d517684$var$_oldOnErrorHandler && !$187cc5ad6d517684$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $187cc5ad6d517684$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $66436e7a47cb08d6$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $66436e7a47cb08d6$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $7aed7ba372d2e673$export$a4e09611e30da72e)(type, handler);
    (0, $7aed7ba372d2e673$export$e18d6c5462c01368)(type, $66436e7a47cb08d6$var$instrumentUnhandledRejection);
}
function $66436e7a47cb08d6$var$instrumentUnhandledRejection() {
    $66436e7a47cb08d6$var$_oldOnUnhandledRejectionHandler = (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $7aed7ba372d2e673$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($66436e7a47cb08d6$var$_oldOnUnhandledRejectionHandler && !$66436e7a47cb08d6$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $66436e7a47cb08d6$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $d885a5291a82df6e$var$INTEGRATION_NAME = "GlobalHandlers";
const $d885a5291a82df6e$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $d885a5291a82df6e$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $d885a5291a82df6e$var$_installGlobalOnErrorHandler(client);
                $d885a5291a82df6e$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $d885a5291a82df6e$var$_installGlobalOnUnhandledRejectionHandler(client);
                $d885a5291a82df6e$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $d885a5291a82df6e$export$66acc70e8cf2b71a = (0, $f8e6000d29329e0a$export$2323046b9414659f)($d885a5291a82df6e$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $d885a5291a82df6e$export$204155decbc90e5a = (0, $f8e6000d29329e0a$export$afa219bf23651160)($d885a5291a82df6e$var$INTEGRATION_NAME, $d885a5291a82df6e$export$66acc70e8cf2b71a);
function $d885a5291a82df6e$var$_installGlobalOnErrorHandler(client) {
    (0, $187cc5ad6d517684$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $d885a5291a82df6e$var$getOptions();
        if ((0, $3b3c418f52d65472$export$6bb76d6eba7e258c)() !== client || (0, $0c03304570a3d428$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $7a2b241ae9102e94$export$844ec244b1367d54)(msg) ? $d885a5291a82df6e$var$_eventFromIncompleteOnError(msg, url, line, column) : $d885a5291a82df6e$var$_enhanceEventWithInitialFrame((0, $89757242536346b6$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $3b3c418f52d65472$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $d885a5291a82df6e$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $66436e7a47cb08d6$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $d885a5291a82df6e$var$getOptions();
        if ((0, $3b3c418f52d65472$export$6bb76d6eba7e258c)() !== client || (0, $0c03304570a3d428$export$b79738ab10c590b2)()) return;
        const error = $d885a5291a82df6e$var$_getUnhandledRejectionError(e);
        const event = (0, $7a2b241ae9102e94$export$c3825b437cbdea5c)(error) ? $d885a5291a82df6e$var$_eventFromRejectionWithPrimitive(error) : (0, $89757242536346b6$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $3b3c418f52d65472$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $d885a5291a82df6e$var$_getUnhandledRejectionError(error) {
    if ((0, $7a2b241ae9102e94$export$c3825b437cbdea5c)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $d885a5291a82df6e$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d885a5291a82df6e$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $7a2b241ae9102e94$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $d885a5291a82df6e$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d885a5291a82df6e$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $7a2b241ae9102e94$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $e15b4fbcaae97cb7$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $d885a5291a82df6e$var$globalHandlerLog(type) {
    (0, $cff9a4d96bff0440$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $d885a5291a82df6e$var$getOptions() {
    const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




const $6757330cdae01dc8$var$INTEGRATION_NAME = "HttpContext";
const $6757330cdae01dc8$var$_httpContextIntegration = ()=>{
    return {
        name: $6757330cdae01dc8$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $0c03304570a3d428$export$56d8a8a25bd48b81).navigator && !(0, $0c03304570a3d428$export$56d8a8a25bd48b81).location && !(0, $0c03304570a3d428$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $0c03304570a3d428$export$56d8a8a25bd48b81).location && (0, $0c03304570a3d428$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $0c03304570a3d428$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $0c03304570a3d428$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $6757330cdae01dc8$export$1378794447170364 = (0, $f8e6000d29329e0a$export$2323046b9414659f)($6757330cdae01dc8$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $6757330cdae01dc8$export$5d2ee9a544b09a94 = (0, $f8e6000d29329e0a$export$afa219bf23651160)($6757330cdae01dc8$var$INTEGRATION_NAME, $6757330cdae01dc8$export$1378794447170364);





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $8f2f9f4f3e3dbbd6$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $7a2b241ae9102e94$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $8f2f9f4f3e3dbbd6$var$truncateAggregateExceptions($8f2f9f4f3e3dbbd6$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $8f2f9f4f3e3dbbd6$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $7a2b241ae9102e94$export$49034edbe6b62415)(error[key], Error)) {
        $8f2f9f4f3e3dbbd6$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $8f2f9f4f3e3dbbd6$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $8f2f9f4f3e3dbbd6$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $7a2b241ae9102e94$export$49034edbe6b62415)(childError, Error)) {
            $8f2f9f4f3e3dbbd6$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $8f2f9f4f3e3dbbd6$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $8f2f9f4f3e3dbbd6$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $8f2f9f4f3e3dbbd6$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $8f2f9f4f3e3dbbd6$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $8f2f9f4f3e3dbbd6$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $d43244d0c656442a$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $b1b7d8736f233a76$var$DEFAULT_KEY = "cause";
const $b1b7d8736f233a76$var$DEFAULT_LIMIT = 5;
const $b1b7d8736f233a76$var$INTEGRATION_NAME = "LinkedErrors";
const $b1b7d8736f233a76$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $b1b7d8736f233a76$var$DEFAULT_LIMIT;
    const key = options.key || $b1b7d8736f233a76$var$DEFAULT_KEY;
    return {
        name: $b1b7d8736f233a76$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $8f2f9f4f3e3dbbd6$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $89757242536346b6$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $b1b7d8736f233a76$export$ebabb00eb7f3a395 = (0, $f8e6000d29329e0a$export$2323046b9414659f)($b1b7d8736f233a76$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $b1b7d8736f233a76$export$8d1e60aaf616fb4f = (0, $f8e6000d29329e0a$export$afa219bf23651160)($b1b7d8736f233a76$var$INTEGRATION_NAME, $b1b7d8736f233a76$export$ebabb00eb7f3a395);





const $58c4ecf8448cd7ac$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $58c4ecf8448cd7ac$var$INTEGRATION_NAME = "TryCatch";
const $58c4ecf8448cd7ac$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $58c4ecf8448cd7ac$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $2486f7fb3095088f$export$9563e054e6f787fb)((0, $0c03304570a3d428$export$56d8a8a25bd48b81), "setTimeout", $58c4ecf8448cd7ac$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $2486f7fb3095088f$export$9563e054e6f787fb)((0, $0c03304570a3d428$export$56d8a8a25bd48b81), "setInterval", $58c4ecf8448cd7ac$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $2486f7fb3095088f$export$9563e054e6f787fb)((0, $0c03304570a3d428$export$56d8a8a25bd48b81), "requestAnimationFrame", $58c4ecf8448cd7ac$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $0c03304570a3d428$export$56d8a8a25bd48b81)) (0, $2486f7fb3095088f$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $58c4ecf8448cd7ac$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $58c4ecf8448cd7ac$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($58c4ecf8448cd7ac$var$_wrapEventTarget);
            }
        }
    };
};
const $58c4ecf8448cd7ac$export$59bfe9f1c76150e = (0, $f8e6000d29329e0a$export$2323046b9414659f)($58c4ecf8448cd7ac$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $58c4ecf8448cd7ac$export$f1a018517668e6d3 = (0, $f8e6000d29329e0a$export$afa219bf23651160)($58c4ecf8448cd7ac$var$INTEGRATION_NAME, $58c4ecf8448cd7ac$export$59bfe9f1c76150e);
function $58c4ecf8448cd7ac$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $0c03304570a3d428$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $88530b1c1c4d5f59$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $58c4ecf8448cd7ac$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $0c03304570a3d428$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $88530b1c1c4d5f59$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $58c4ecf8448cd7ac$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $2486f7fb3095088f$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $88530b1c1c4d5f59$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $2486f7fb3095088f$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $88530b1c1c4d5f59$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $0c03304570a3d428$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $58c4ecf8448cd7ac$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $0c03304570a3d428$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $2486f7fb3095088f$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $0c03304570a3d428$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $88530b1c1c4d5f59$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $0c03304570a3d428$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $88530b1c1c4d5f59$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $2486f7fb3095088f$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



// global reference to slice
const $efe2ac1da6869e24$var$UNKNOWN_FUNCTION = "?";
const $efe2ac1da6869e24$var$OPERA10_PRIORITY = 10;
const $efe2ac1da6869e24$var$OPERA11_PRIORITY = 20;
const $efe2ac1da6869e24$var$CHROME_PRIORITY = 30;
const $efe2ac1da6869e24$var$WINJS_PRIORITY = 40;
const $efe2ac1da6869e24$var$GECKO_PRIORITY = 50;
function $efe2ac1da6869e24$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $efe2ac1da6869e24$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $efe2ac1da6869e24$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $efe2ac1da6869e24$var$chromeStackParserFn = (line)=>{
    const parts = $efe2ac1da6869e24$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $efe2ac1da6869e24$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $efe2ac1da6869e24$var$extractSafariExtensionDetails(parts[1] || $efe2ac1da6869e24$var$UNKNOWN_FUNCTION, parts[2]);
        return $efe2ac1da6869e24$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $efe2ac1da6869e24$export$263a749fff749872 = [
    $efe2ac1da6869e24$var$CHROME_PRIORITY,
    $efe2ac1da6869e24$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $efe2ac1da6869e24$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $efe2ac1da6869e24$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $efe2ac1da6869e24$var$gecko = (line)=>{
    const parts = $efe2ac1da6869e24$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $efe2ac1da6869e24$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $efe2ac1da6869e24$var$UNKNOWN_FUNCTION;
        [func, filename] = $efe2ac1da6869e24$var$extractSafariExtensionDetails(func, filename);
        return $efe2ac1da6869e24$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $efe2ac1da6869e24$export$cdba47a5dd2804d = [
    $efe2ac1da6869e24$var$GECKO_PRIORITY,
    $efe2ac1da6869e24$var$gecko
];
const $efe2ac1da6869e24$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $efe2ac1da6869e24$var$winjs = (line)=>{
    const parts = $efe2ac1da6869e24$var$winjsRegex.exec(line);
    return parts ? $efe2ac1da6869e24$var$createFrame(parts[2], parts[1] || $efe2ac1da6869e24$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $efe2ac1da6869e24$export$179460296da408e8 = [
    $efe2ac1da6869e24$var$WINJS_PRIORITY,
    $efe2ac1da6869e24$var$winjs
];
const $efe2ac1da6869e24$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $efe2ac1da6869e24$var$opera10 = (line)=>{
    const parts = $efe2ac1da6869e24$var$opera10Regex.exec(line);
    return parts ? $efe2ac1da6869e24$var$createFrame(parts[2], parts[3] || $efe2ac1da6869e24$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $efe2ac1da6869e24$export$f892b52c880ffc7a = [
    $efe2ac1da6869e24$var$OPERA10_PRIORITY,
    $efe2ac1da6869e24$var$opera10
];
const $efe2ac1da6869e24$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $efe2ac1da6869e24$var$opera11 = (line)=>{
    const parts = $efe2ac1da6869e24$var$opera11Regex.exec(line);
    return parts ? $efe2ac1da6869e24$var$createFrame(parts[5], parts[3] || parts[4] || $efe2ac1da6869e24$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $efe2ac1da6869e24$export$af11af13f09fb0dc = [
    $efe2ac1da6869e24$var$OPERA11_PRIORITY,
    $efe2ac1da6869e24$var$opera11
];
const $efe2ac1da6869e24$export$7197c0fe6554c079 = [
    $efe2ac1da6869e24$export$263a749fff749872,
    $efe2ac1da6869e24$export$cdba47a5dd2804d,
    $efe2ac1da6869e24$export$179460296da408e8
];
const $efe2ac1da6869e24$export$2b2b997d81bf3907 = (0, $88530b1c1c4d5f59$export$a5739666fb2d03d4)(...$efe2ac1da6869e24$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $efe2ac1da6869e24$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $efe2ac1da6869e24$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $dffb3afb92449f1c$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $dffb3afb92449f1c$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $dffb3afb92449f1c$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $dffb3afb92449f1c$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $dffb3afb92449f1c$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $dffb3afb92449f1c$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $dffb3afb92449f1c$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $dffb3afb92449f1c$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $ba194b5ccb45af41$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $deb7ace6d5663abb$export$78e43115b553f358)(new (0, $31ea12416213c5aa$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $deb7ace6d5663abb$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $deb7ace6d5663abb$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $c0ef84eaba43fb69$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $c0ef84eaba43fb69$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $ba194b5ccb45af41$export$85a4f67f852183e6)(options.bufferSize || $c0ef84eaba43fb69$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $32ccdd6e4b62c3ba$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $32ccdd6e4b62c3ba$export$b11169581eeaf237)(type);
            if ((0, $dffb3afb92449f1c$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $c0ef84eaba43fb69$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $deb7ace6d5663abb$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $32ccdd6e4b62c3ba$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $32ccdd6e4b62c3ba$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $c0ef84eaba43fb69$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $32ccdd6e4b62c3ba$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $32ccdd6e4b62c3ba$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $dffb3afb92449f1c$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $31ea12416213c5aa$export$5949942ba2a7c0e2)) {
                (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $deb7ace6d5663abb$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $c0ef84eaba43fb69$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}






let $41c32d768d03329b$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $41c32d768d03329b$export$8be2119ce08e3379() {
    if ($41c32d768d03329b$var$cachedFetchImpl) return $41c32d768d03329b$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $8c4451bdd75a3273$export$18cf36ed71d733e7)((0, $0c03304570a3d428$export$56d8a8a25bd48b81).fetch)) return $41c32d768d03329b$var$cachedFetchImpl = (0, $0c03304570a3d428$export$56d8a8a25bd48b81).fetch.bind((0, $0c03304570a3d428$export$56d8a8a25bd48b81));
    const document = (0, $0c03304570a3d428$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $0c03304570a3d428$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $cff9a4d96bff0440$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $41c32d768d03329b$var$cachedFetchImpl = fetchImpl.bind((0, $0c03304570a3d428$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $41c32d768d03329b$export$d499686d2dd738c6() {
    $41c32d768d03329b$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $ea269b3e84903f8c$export$b2311068c46d7cc8(options, nativeFetch = (0, $41c32d768d03329b$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $41c32d768d03329b$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $deb7ace6d5663abb$export$78e43115b553f358)(e);
        }
    }
    return (0, $c0ef84eaba43fb69$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $5a5d228ec3785bee$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $5a5d228ec3785bee$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $deb7ace6d5663abb$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $5a5d228ec3785bee$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $c0ef84eaba43fb69$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $e6a702de1fdf388e$export$5ef831fccfce35e5 = [
    (0, $11d7b718b83002b9$export$cb3c5c2ceb9818ba)(),
    (0, $e2f186284bd2b67f$export$7918117e9202e4fb)(),
    (0, $58c4ecf8448cd7ac$export$59bfe9f1c76150e)(),
    (0, $3a14474c2326a9a3$export$c079d904b326663a)(),
    (0, $d885a5291a82df6e$export$66acc70e8cf2b71a)(),
    (0, $b1b7d8736f233a76$export$ebabb00eb7f3a395)(),
    (0, $cdab0846da1aae66$export$6d39aa44cd0c7567)(),
    (0, $6757330cdae01dc8$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $e6a702de1fdf388e$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$e6a702de1fdf388e$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $e6a702de1fdf388e$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $e6a702de1fdf388e$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $0c03304570a3d428$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $0c03304570a3d428$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $0c03304570a3d428$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $88530b1c1c4d5f59$export$1d5cf88b347146d4)(options.stackParser || (0, $efe2ac1da6869e24$export$2b2b997d81bf3907)),
        integrations: (0, $f8e6000d29329e0a$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $8c4451bdd75a3273$export$edf3cb81fd7d2a3e)() ? (0, $ea269b3e84903f8c$export$b2311068c46d7cc8) : (0, $5a5d228ec3785bee$export$5e1441cee30d5a39))
    };
    (0, $72c7e0ab47307024$export$5333c3f1c58d9bc1)((0, $d1d077ebee1bfdb0$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $e6a702de1fdf388e$var$startSessionTracking();
}
const $e6a702de1fdf388e$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $0c03304570a3d428$export$56d8a8a25bd48b81).document) {
        (0, $cff9a4d96bff0440$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $cff9a4d96bff0440$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    // TODO(v8): Remove this entire if statement. `eventId` will be a required option.
    // eslint-disable-next-line deprecation/deprecation
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $0c03304570a3d428$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $1771321400d53665$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $0c03304570a3d428$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $0c03304570a3d428$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $0c03304570a3d428$export$56d8a8a25bd48b81).document.head || (0, $0c03304570a3d428$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $cff9a4d96bff0440$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $e6a702de1fdf388e$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $e6a702de1fdf388e$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e6a702de1fdf388e$export$4997ffc0176396a6(fn) {
    return (0, $0c03304570a3d428$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $e6a702de1fdf388e$var$startSessionTracking() {
    if (typeof (0, $0c03304570a3d428$export$56d8a8a25bd48b81).document === "undefined") {
        (0, $cff9a4d96bff0440$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $3b3c418f52d65472$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $3b3c418f52d65472$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $2c6eb7f56917cfd8$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $3b3c418f52d65472$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $3b3c418f52d65472$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $e6a702de1fdf388e$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
    if (client) client.captureUserFeedback(feedback);
}



/**
 * Inits the React SDK
 */ function $e331597552da4313$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $a43e6439fd35dae3$export$b9f95b027256052c)(opts, "react");
    (0, $e6a702de1fdf388e$export$2cd8252107eb640b)(opts);
}









/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $3717f11d9edb58cd$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $3717f11d9edb58cd$export$8e9a29865c0a1226 = (0, $896026ba1cdc6157$export$8e9a29865c0a1226);


let $a47a25dac5744c15$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $a47a25dac5744c15$export$637857c1d87b640c() {
    if ($a47a25dac5744c15$var$errorsInstrumented) return;
    $a47a25dac5744c15$var$errorsInstrumented = true;
    (0, $187cc5ad6d517684$export$55b5c3ba2194f0c6)($a47a25dac5744c15$var$errorCallback);
    (0, $66436e7a47cb08d6$export$8bf4fc6858821a4e)($a47a25dac5744c15$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $a47a25dac5744c15$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $3717f11d9edb58cd$export$a7feb32fdd923295)();
    if (activeTransaction) {
        const status = "internal_error";
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$a47a25dac5744c15$var$errorCallback.tag = "sentry_tracingErrorCallback";




















/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $d14376ae5c87ec5f$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $d14376ae5c87ec5f$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $d14376ae5c87ec5f$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $7a2b241ae9102e94$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $ec5dc6e344042b9b$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}


/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $ee681c8f4e6404de$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)();
    const scope = (0, $3b3c418f52d65472$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $ee681c8f4e6404de$var$normalizeContext(context);
    const activeSpan = $ee681c8f4e6404de$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $d14376ae5c87ec5f$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $ee681c8f4e6404de$export$a1bd95187356f372(context, callback) {
    const spanContext = $ee681c8f4e6404de$var$normalizeContext(context);
    return (0, $19e624db95e0b5b5$export$70d775fb1f267027)(()=>{
        return (0, $3b3c418f52d65472$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $ee681c8f4e6404de$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $d14376ae5c87ec5f$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $391854fa51155a6b$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $ee681c8f4e6404de$export$cb9e396e6b90b703 = $ee681c8f4e6404de$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $ee681c8f4e6404de$export$c10292ad04b92aea(context, callback) {
    const spanContext = $ee681c8f4e6404de$var$normalizeContext(context);
    return (0, $19e624db95e0b5b5$export$70d775fb1f267027)(()=>{
        return (0, $3b3c418f52d65472$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $ee681c8f4e6404de$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $d14376ae5c87ec5f$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $391854fa51155a6b$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $ee681c8f4e6404de$export$63dbba021a6b4047(context) {
    if (!(0, $ec5dc6e344042b9b$export$5008da00b1b6dee6)()) return undefined;
    const spanContext = $ee681c8f4e6404de$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)();
    const parentSpan = context.scope ? context.scope.getSpan() : $ee681c8f4e6404de$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $3b3c418f52d65472$export$c7be4b0125a10cba)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $ee681c8f4e6404de$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $ee681c8f4e6404de$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $3b3c418f52d65472$export$c7be4b0125a10cba)().getSpan();
}
const $ee681c8f4e6404de$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $3b3c418f52d65472$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $896026ba1cdc6157$export$ca5c066532785b6e)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $af23f9078c789d20$export$16a28057038b10ef) && traceparentData) (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $2486f7fb3095088f$export$d25f2688db1bb433)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $19e624db95e0b5b5$export$70d775fb1f267027)(()=>{
        return callback(transactionContext);
    });
};
function $ee681c8f4e6404de$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $ec5dc6e344042b9b$export$5008da00b1b6dee6)()) return undefined;
    const isolationScope = (0, $19e624db95e0b5b5$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $bf724425488f9967$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $391854fa51155a6b$export$5caecac1caaf3a71)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $ee681c8f4e6404de$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $ee681c8f4e6404de$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $391854fa51155a6b$export$3f7581298f56c6d7)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $ee681c8f4e6404de$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $ee681c8f4e6404de$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $ee681c8f4e6404de$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $2486f7fb3095088f$export$e73679ffaf56810e)(span, $ee681c8f4e6404de$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $2486f7fb3095088f$export$e73679ffaf56810e)(span, $ee681c8f4e6404de$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $ee681c8f4e6404de$export$c08fbc656a245d03(span) {
    return {
        scope: span[$ee681c8f4e6404de$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$ee681c8f4e6404de$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $90d37236246771d2$var$SPAN_METRIC_SUMMARY;
function $90d37236246771d2$var$getMetricStorageForSpan(span) {
    return $90d37236246771d2$var$SPAN_METRIC_SUMMARY ? $90d37236246771d2$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $90d37236246771d2$export$2e7205e45c58797d(span) {
    const storage = $90d37236246771d2$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $2486f7fb3095088f$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $90d37236246771d2$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $ee681c8f4e6404de$export$1be426a8e585c83e)();
    if (span) {
        const storage = $90d37236246771d2$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$90d37236246771d2$var$SPAN_METRIC_SUMMARY) $90d37236246771d2$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $90d37236246771d2$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $a8f596f3c433b5b1$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $a8f596f3c433b5b1$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $a8f596f3c433b5b1$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $a8f596f3c433b5b1$export$cca8dd30f57f805e = "sentry.origin";
/**
 * The id of the profile that this span occured in.
 */ const $a8f596f3c433b5b1$export$1efec95406bbe327 = "profile_id";




/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $68ddfd2d9bd9e711$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})($68ddfd2d9bd9e711$export$beb8e6a823e89c5d || ($68ddfd2d9bd9e711$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $68ddfd2d9bd9e711$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $68ddfd2d9bd9e711$export$ac65c70d78fcdb55 = $68ddfd2d9bd9e711$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $68ddfd2d9bd9e711$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag("http.status_code", String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData("http.response.status_code", httpStatus);
    const spanStatus = $68ddfd2d9bd9e711$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== "unknown_error") span.setStatus(spanStatus);
}


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $125aaf0c68def7c5$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $125aaf0c68def7c5$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $0abc5e6206c3ae86$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $0abc5e6206c3ae86$export$19f53698e68b2496)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $75b4984e5522b249$export$ee52dced521e3e18)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || "sentry";
        this._attributes = {};
        this.setAttributes({
            [(0, $a8f596f3c433b5b1$export$cca8dd30f57f805e)]: spanContext.origin || "manual",
            [(0, $a8f596f3c433b5b1$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || "";
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $a8f596f3c433b5b1$export$1a413bd9a88fdb09];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $a8f596f3c433b5b1$export$1a413bd9a88fdb09), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $a8f596f3c433b5b1$export$cca8dd30f57f805e];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $a8f596f3c433b5b1$export$cca8dd30f57f805e), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $391854fa51155a6b$export$eb571cd9b5d98de8) : (0, $391854fa51155a6b$export$208d5b368507fb8b)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $125aaf0c68def7c5$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $0c5dfa55c02d3dae$export$c4c6a79b1260ca1b)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $af23f9078c789d20$export$16a28057038b10ef) && rootSpan) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = (0, $391854fa51155a6b$export$92d8c23565496537)(childSpan).description || "< unknown name >";
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $f78ca609428407bb$export$af88d00dbe7f521).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $68ddfd2d9bd9e711$export$2ad6630ec8164254)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === "ok";
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $0c5dfa55c02d3dae$export$c4c6a79b1260ca1b)(this);
        if ((0, $af23f9078c789d20$export$16a28057038b10ef) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $f78ca609428407bb$export$af88d00dbe7f521).log(logMessage.replace("Starting", "Finishing"));
        }
        this._endTime = (0, $391854fa51155a6b$export$3f7581298f56c6d7)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $391854fa51155a6b$export$7e9f8ae9e4a328ab)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $2486f7fb3095088f$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $391854fa51155a6b$export$46c6fbd1d265ebf0)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $2486f7fb3095088f$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $a8f596f3c433b5b1$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $a8f596f3c433b5b1$export$cca8dd30f57f805e],
            _metrics_summary: (0, $90d37236246771d2$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $a8f596f3c433b5b1$export$1efec95406bbe327],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}











/** JSDoc */ class $3704230016645bb6$export$febc5573c75cefb0 extends (0, $125aaf0c68def7c5$export$5f1714a13ed34c01) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)();
        this._name = transactionContext.name || "";
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: "custom",
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $a8f596f3c433b5b1$export$d7a7d984b0791405] && {
                source: this._attributes[0, $a8f596f3c433b5b1$export$d7a7d984b0791405]
            },
            ...this._attributes[0, $a8f596f3c433b5b1$export$ccfe0a40627cc34b] && {
                sampleRate: this._attributes[0, $a8f596f3c433b5b1$export$ccfe0a40627cc34b]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = "custom") {
        this._name = name;
        this.setAttribute((0, $a8f596f3c433b5b1$export$d7a7d984b0791405), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $125aaf0c68def7c5$export$10c95c129cd0d4fe)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $391854fa51155a6b$export$3f7581298f56c6d7)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $2486f7fb3095088f$export$d25f2688db1bb433)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $bf724425488f9967$export$a117f995597e25df)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts["profile"] !== undefined) return this._contexts["profile"].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $391854fa51155a6b$export$92d8c23565496537)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $391854fa51155a6b$export$92d8c23565496537)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $ee681c8f4e6404de$export$c08fbc656a245d03)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $391854fa51155a6b$export$46c6fbd1d265ebf0)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $2486f7fb3095088f$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $bf724425488f9967$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $90d37236246771d2$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}


const $c890784f2b5b8280$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $c890784f2b5b8280$var$FINISH_REASON_TAG = "finishReason";
const $c890784f2b5b8280$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $c890784f2b5b8280$export$370d6113c18ba86c extends (0, $125aaf0c68def7c5$export$10c95c129cd0d4fe) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $391854fa51155a6b$export$92d8c23565496537)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $c890784f2b5b8280$export$b279e6bd7040371f extends (0, $3704230016645bb6$export$febc5573c75cefb0) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $c890784f2b5b8280$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $c890784f2b5b8280$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $c890784f2b5b8280$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $c890784f2b5b8280$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $c890784f2b5b8280$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $391854fa51155a6b$export$3f7581298f56c6d7)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === "ui.action.click") this.setAttribute($c890784f2b5b8280$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $af23f9078c789d20$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
            (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Tracing] finishing IdleTransaction", new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $391854fa51155a6b$export$92d8c23565496537)(span).timestamp) {
                    span.setStatus("cancelled");
                    span.end(endTimestampInS);
                    (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $391854fa51155a6b$export$92d8c23565496537)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $af23f9078c789d20$export$16a28057038b10ef) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Tracing] flushing IdleTransaction");
        } else (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $c890784f2b5b8280$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $c890784f2b5b8280$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Tracing] Received finish signal for idle transaction.");
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $c890784f2b5b8280$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $75b4984e5522b249$export$ee52dced521e3e18)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $c890784f2b5b8280$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Tracing] Transaction finished because of no change for 3 heart beats");
                this.setStatus("deadline_exceeded");
                this._finishReason = $c890784f2b5b8280$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}







/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $db775f85015e2649$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $ec5dc6e344042b9b$export$5008da00b1b6dee6)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $a8f596f3c433b5b1$export$ccfe0a40627cc34b), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $a8f596f3c433b5b1$export$ccfe0a40627cc34b), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $a8f596f3c433b5b1$export$ccfe0a40627cc34b), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $a8f596f3c433b5b1$export$ccfe0a40627cc34b), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$db775f85015e2649$export$2603c8d332a51c42(sampleRate)) {
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $af23f9078c789d20$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
    (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $391854fa51155a6b$export$92d8c23565496537)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $db775f85015e2649$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $7a2b241ae9102e94$export$c9f5652083b8129d)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}



/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $9d41dbc71d08bcd0$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": (0, $391854fa51155a6b$export$7e9f8ae9e4a328ab)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $9d41dbc71d08bcd0$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $af23f9078c789d20$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $3704230016645bb6$export$febc5573c75cefb0)(transactionContext, this);
    transaction = (0, $db775f85015e2649$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $9d41dbc71d08bcd0$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $c890784f2b5b8280$export$b279e6bd7040371f)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $db775f85015e2649$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $9d41dbc71d08bcd0$export$653d0ef2bad9cdf9() {
    const carrier = (0, $19e624db95e0b5b5$export$19eade501500c6c1)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $9d41dbc71d08bcd0$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $9d41dbc71d08bcd0$var$traceHeaders;
    (0, $a47a25dac5744c15$export$637857c1d87b640c)();
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $56f8b2b50d64810a$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;






const $e3f900f64ccd9f84$export$56d8a8a25bd48b81 = (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $c71764540c2771f4$export$6f18f55521af71a1() {
    if ((0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document) (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $3717f11d9edb58cd$export$a7feb32fdd923295)();
        if ((0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            const { op: op, status: status } = (0, $391854fa51155a6b$export$92d8c23565496537)(activeTransaction);
            (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.end();
        }
    });
    else (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}




const $c487dba6b99e4a76$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $af384b824c2c2d7c$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $abf4cfe7f8569032$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $abf4cfe7f8569032$export$6431553786c94949 = ()=>{
    if ((0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $abf4cfe7f8569032$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6eafa83561bcb876$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $abf4cfe7f8569032$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $79c123404103ad56$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $abf4cfe7f8569032$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document && (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document.prerendering || (0, $6eafa83561bcb876$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $af384b824c2c2d7c$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $db034b909b68def9$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c523eb9005df4f66$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $500feefca06f9150$export$a7873055838e5ad8 = (onReport)=>{
    const metric = (0, $79c123404103ad56$export$3c29b44508a0612b)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $db034b909b68def9$export$d1203567a167490e)("layout-shift", handleEntries);
    if (po) {
        report = (0, $c487dba6b99e4a76$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $c523eb9005df4f66$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $a88d3e80f2fa7054$var$firstHiddenTime = -1;
const $a88d3e80f2fa7054$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document && (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document.visibilityState) $a88d3e80f2fa7054$var$firstHiddenTime = (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $a88d3e80f2fa7054$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $c523eb9005df4f66$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $a88d3e80f2fa7054$var$firstHiddenTime = timeStamp;
    }, true);
};
const $a88d3e80f2fa7054$export$443f86b2c77012c4 = ()=>{
    if ($a88d3e80f2fa7054$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $a88d3e80f2fa7054$var$initHiddenTime();
        $a88d3e80f2fa7054$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $a88d3e80f2fa7054$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $7c71949c6ce74e19$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $a88d3e80f2fa7054$export$443f86b2c77012c4)();
    const metric = (0, $79c123404103ad56$export$3c29b44508a0612b)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $db034b909b68def9$export$d1203567a167490e)("first-input", handleEntries);
    report = (0, $c487dba6b99e4a76$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $c523eb9005df4f66$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};







let $3bd194deabb0e3d7$var$interactionCountEstimate = 0;
let $3bd194deabb0e3d7$var$minKnownInteractionId = Infinity;
let $3bd194deabb0e3d7$var$maxKnownInteractionId = 0;
const $3bd194deabb0e3d7$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $3bd194deabb0e3d7$var$minKnownInteractionId = Math.min($3bd194deabb0e3d7$var$minKnownInteractionId, e.interactionId);
            $3bd194deabb0e3d7$var$maxKnownInteractionId = Math.max($3bd194deabb0e3d7$var$maxKnownInteractionId, e.interactionId);
            $3bd194deabb0e3d7$var$interactionCountEstimate = $3bd194deabb0e3d7$var$maxKnownInteractionId ? ($3bd194deabb0e3d7$var$maxKnownInteractionId - $3bd194deabb0e3d7$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $3bd194deabb0e3d7$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $3bd194deabb0e3d7$export$8a962f2683a476d1 = ()=>{
    return $3bd194deabb0e3d7$var$po ? $3bd194deabb0e3d7$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $3bd194deabb0e3d7$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $3bd194deabb0e3d7$var$po) return;
    $3bd194deabb0e3d7$var$po = (0, $db034b909b68def9$export$d1203567a167490e)("event", $3bd194deabb0e3d7$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $d0e9c5ac31da43dc$var$getInteractionCountForNavigation = ()=>{
    return (0, $3bd194deabb0e3d7$export$8a962f2683a476d1)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $d0e9c5ac31da43dc$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $d0e9c5ac31da43dc$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $d0e9c5ac31da43dc$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $d0e9c5ac31da43dc$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $d0e9c5ac31da43dc$var$longestInteractionList[$d0e9c5ac31da43dc$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $d0e9c5ac31da43dc$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $d0e9c5ac31da43dc$var$longestInteractionList.length < $d0e9c5ac31da43dc$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $d0e9c5ac31da43dc$var$longestInteractionMap[interaction.id] = interaction;
            $d0e9c5ac31da43dc$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $d0e9c5ac31da43dc$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $d0e9c5ac31da43dc$var$longestInteractionList.splice($d0e9c5ac31da43dc$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $d0e9c5ac31da43dc$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $d0e9c5ac31da43dc$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($d0e9c5ac31da43dc$var$longestInteractionList.length - 1, Math.floor($d0e9c5ac31da43dc$var$getInteractionCountForNavigation() / 50));
    return $d0e9c5ac31da43dc$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $d0e9c5ac31da43dc$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $3bd194deabb0e3d7$export$67d90cda6b78a2eb)();
    const metric = (0, $79c123404103ad56$export$3c29b44508a0612b)("INP");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $d0e9c5ac31da43dc$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === "first-input") {
                const noMatchingEntry = !$d0e9c5ac31da43dc$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $d0e9c5ac31da43dc$var$processEntry(entry);
            }
        });
        const inp = $d0e9c5ac31da43dc$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $db034b909b68def9$export$d1203567a167490e)("event", handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $c487dba6b99e4a76$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: "first-input",
            buffered: true
        });
        (0, $c523eb9005df4f66$export$91ec2be6fdd8f1b4)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $d0e9c5ac31da43dc$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8c287b0dc228456a$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $8c287b0dc228456a$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $a88d3e80f2fa7054$export$443f86b2c77012c4)();
    const metric = (0, $79c123404103ad56$export$3c29b44508a0612b)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $6eafa83561bcb876$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $db034b909b68def9$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $c487dba6b99e4a76$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$8c287b0dc228456a$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $8c287b0dc228456a$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            if ((0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $c523eb9005df4f66$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $ad7429962a07bfdb$var$whenReady = (callback)=>{
    if (!(0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document) return;
    if ((0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document.prerendering) addEventListener("prerenderingchange", ()=>$ad7429962a07bfdb$var$whenReady(callback), true);
    else if ((0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document.readyState !== "complete") addEventListener("load", ()=>$ad7429962a07bfdb$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $ad7429962a07bfdb$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $79c123404103ad56$export$3c29b44508a0612b)("TTFB");
    const report = (0, $c487dba6b99e4a76$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    $ad7429962a07bfdb$var$whenReady(()=>{
        const navEntry = (0, $abf4cfe7f8569032$export$6431553786c94949)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $6eafa83561bcb876$export$d3e828b3c7b5b845)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $c0253c3b07cda670$var$handlers = {};
const $c0253c3b07cda670$var$instrumented = {};
let $c0253c3b07cda670$var$_previousCls;
let $c0253c3b07cda670$var$_previousFid;
let $c0253c3b07cda670$var$_previousLcp;
let $c0253c3b07cda670$var$_previousTtfb;
let $c0253c3b07cda670$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $c0253c3b07cda670$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $c0253c3b07cda670$var$addMetricObserver("cls", callback, $c0253c3b07cda670$var$instrumentCls, $c0253c3b07cda670$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $c0253c3b07cda670$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $c0253c3b07cda670$var$addMetricObserver("lcp", callback, $c0253c3b07cda670$var$instrumentLcp, $c0253c3b07cda670$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $c0253c3b07cda670$export$699d9529c099a797(callback) {
    return $c0253c3b07cda670$var$addMetricObserver("ttfb", callback, $c0253c3b07cda670$var$instrumentTtfb, $c0253c3b07cda670$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $c0253c3b07cda670$export$2707d7471c0b918f(callback) {
    return $c0253c3b07cda670$var$addMetricObserver("fid", callback, $c0253c3b07cda670$var$instrumentFid, $c0253c3b07cda670$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $c0253c3b07cda670$export$da3b76aa2022cbd7(callback) {
    return $c0253c3b07cda670$var$addMetricObserver("inp", callback, $c0253c3b07cda670$var$instrumentInp, $c0253c3b07cda670$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $c0253c3b07cda670$export$69816c1a049f8db6(type, callback) {
    $c0253c3b07cda670$var$addHandler(type, callback);
    if (!$c0253c3b07cda670$var$instrumented[type]) {
        $c0253c3b07cda670$var$instrumentPerformanceObserver(type);
        $c0253c3b07cda670$var$instrumented[type] = true;
    }
    return $c0253c3b07cda670$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $c0253c3b07cda670$var$triggerHandlers(type, data) {
    const typeHandlers = $c0253c3b07cda670$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $88530b1c1c4d5f59$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $c0253c3b07cda670$var$instrumentCls() {
    return (0, $500feefca06f9150$export$a7873055838e5ad8)((metric)=>{
        $c0253c3b07cda670$var$triggerHandlers("cls", {
            metric: metric
        });
        $c0253c3b07cda670$var$_previousCls = metric;
    });
}
function $c0253c3b07cda670$var$instrumentFid() {
    return (0, $7c71949c6ce74e19$export$39705a25c49af873)((metric)=>{
        $c0253c3b07cda670$var$triggerHandlers("fid", {
            metric: metric
        });
        $c0253c3b07cda670$var$_previousFid = metric;
    });
}
function $c0253c3b07cda670$var$instrumentLcp() {
    return (0, $8c287b0dc228456a$export$947b1626ab8d5632)((metric)=>{
        $c0253c3b07cda670$var$triggerHandlers("lcp", {
            metric: metric
        });
        $c0253c3b07cda670$var$_previousLcp = metric;
    });
}
function $c0253c3b07cda670$var$instrumentTtfb() {
    return (0, $ad7429962a07bfdb$export$33a01e6c5f2c7e33)((metric)=>{
        $c0253c3b07cda670$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $c0253c3b07cda670$var$_previousTtfb = metric;
    });
}
function $c0253c3b07cda670$var$instrumentInp() {
    return (0, $d0e9c5ac31da43dc$export$7df4b36ecaed99e1)((metric)=>{
        $c0253c3b07cda670$var$triggerHandlers("inp", {
            metric: metric
        });
        $c0253c3b07cda670$var$_previousInp = metric;
    });
}
function $c0253c3b07cda670$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $c0253c3b07cda670$var$addHandler(type, callback);
    let stopListening;
    if (!$c0253c3b07cda670$var$instrumented[type]) {
        stopListening = instrumentFn();
        $c0253c3b07cda670$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $c0253c3b07cda670$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $c0253c3b07cda670$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $db034b909b68def9$export$d1203567a167490e)(type, (entries)=>{
        $c0253c3b07cda670$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $c0253c3b07cda670$var$addHandler(type, handler) {
    $c0253c3b07cda670$var$handlers[type] = $c0253c3b07cda670$var$handlers[type] || [];
    $c0253c3b07cda670$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $c0253c3b07cda670$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $c0253c3b07cda670$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}



/**
 * Create envelope from Span item.
 */ function $d57e296a33d829d4$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $bd17516cf9421867$export$44d472fbb931a776)(dsn);
    const items = spans.map($d57e296a33d829d4$var$createSpanItem);
    return (0, $32ccdd6e4b62c3ba$export$f93f7f385160c44e)(headers, items);
}
function $d57e296a33d829d4$var$createSpanItem(span) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        span
    ];
}


/**
 * Adds a measurement to the current active transaction.
 */ function $f6221b05586042ed$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $3717f11d9edb58cd$export$a7feb32fdd923295)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}







/**
 * Checks if a given value is a valid measurement value.
 */ function $d5f4541017e51400$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $d5f4541017e51400$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}



const $52c16c8053eb80b3$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $52c16c8053eb80b3$var$msToSec(time) {
    return time / 1000;
}
function $52c16c8053eb80b3$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81) && (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).addEventListener && (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).performance;
}
let $52c16c8053eb80b3$var$_performanceCursor = 0;
let $52c16c8053eb80b3$var$_measurements = {};
let $52c16c8053eb80b3$var$_lcpEntry;
let $52c16c8053eb80b3$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $52c16c8053eb80b3$export$7c69f0412d101b88() {
    const performance = $52c16c8053eb80b3$var$getBrowserPerformanceAPI();
    if (performance && (0, $75b4984e5522b249$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCallback = $52c16c8053eb80b3$var$_trackFID();
        const clsCallback = $52c16c8053eb80b3$var$_trackCLS();
        const lcpCallback = $52c16c8053eb80b3$var$_trackLCP();
        const ttfbCallback = $52c16c8053eb80b3$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $52c16c8053eb80b3$export$f396d19077034ad2() {
    (0, $c0253c3b07cda670$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $3717f11d9edb58cd$export$a7feb32fdd923295)();
            if (!transaction) return;
            const startTime = $52c16c8053eb80b3$var$msToSec((0, $75b4984e5522b249$export$baf075a948ffc0bf) + entry.startTime);
            const duration = $52c16c8053eb80b3$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $52c16c8053eb80b3$export$e27543e0976315e4() {
    (0, $c0253c3b07cda670$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $3717f11d9edb58cd$export$a7feb32fdd923295)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $52c16c8053eb80b3$var$msToSec((0, $75b4984e5522b249$export$baf075a948ffc0bf) + entry.startTime);
                const duration = $52c16c8053eb80b3$var$msToSec(entry.duration);
                const span = {
                    description: (0, $e15b4fbcaae97cb7$export$5647df6b7814ac86)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $e15b4fbcaae97cb7$export$26727cfcc4d7e0fc)(entry.target);
                if (componentName) span.attributes = {
                    "ui.component_name": componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $52c16c8053eb80b3$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $52c16c8053eb80b3$var$getBrowserPerformanceAPI();
    if (performance && (0, $75b4984e5522b249$export$baf075a948ffc0bf)) {
        const inpCallback = $52c16c8053eb80b3$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $52c16c8053eb80b3$var$_trackCLS() {
    return (0, $c0253c3b07cda670$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Measurements] Adding CLS");
        $52c16c8053eb80b3$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $52c16c8053eb80b3$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $52c16c8053eb80b3$var$_trackLCP() {
    return (0, $c0253c3b07cda670$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Measurements] Adding LCP");
        $52c16c8053eb80b3$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $52c16c8053eb80b3$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $52c16c8053eb80b3$var$_trackFID() {
    return (0, $c0253c3b07cda670$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $52c16c8053eb80b3$var$msToSec((0, $75b4984e5522b249$export$baf075a948ffc0bf));
        const startTime = $52c16c8053eb80b3$var$msToSec(entry.startTime);
        (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Measurements] Adding FID");
        $52c16c8053eb80b3$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $52c16c8053eb80b3$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function $52c16c8053eb80b3$var$_trackTtfb() {
    return (0, $c0253c3b07cda670$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Measurements] Adding TTFB");
        $52c16c8053eb80b3$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
const $52c16c8053eb80b3$var$INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $52c16c8053eb80b3$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $c0253c3b07cda670$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $52c16c8053eb80b3$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
        if (!entry || !client) return;
        const interactionType = $52c16c8053eb80b3$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $52c16c8053eb80b3$var$msToSec((0, $75b4984e5522b249$export$baf075a948ffc0bf) + entry.startTime);
        const duration = $52c16c8053eb80b3$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $125aaf0c68def7c5$export$5f1714a13ed34c01)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $e15b4fbcaae97cb7$export$5647df6b7814ac86)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== "" ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: "millisecond"
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $52c16c8053eb80b3$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $d57e296a33d829d4$export$19a0081d4b39d77)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).error("Error while sending interaction:", reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $52c16c8053eb80b3$export$5f8fa6b3467a7443(transaction) {
    const performance = $52c16c8053eb80b3$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).performance.getEntries || !(0, $75b4984e5522b249$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $52c16c8053eb80b3$var$msToSec((0, $75b4984e5522b249$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $391854fa51155a6b$export$92d8c23565496537)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($52c16c8053eb80b3$var$_performanceCursor).forEach((entry)=>{
        const startTime = $52c16c8053eb80b3$var$msToSec(entry.startTime);
        const duration = $52c16c8053eb80b3$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $52c16c8053eb80b3$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $52c16c8053eb80b3$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $a88d3e80f2fa7054$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Measurements] Adding FP");
                        $52c16c8053eb80b3$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Measurements] Adding FCP");
                        $52c16c8053eb80b3$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                $52c16c8053eb80b3$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $52c16c8053eb80b3$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $52c16c8053eb80b3$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $52c16c8053eb80b3$var$_addTtfbRequestTimeToMeasurements($52c16c8053eb80b3$var$_measurements);
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$52c16c8053eb80b3$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $52c16c8053eb80b3$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $52c16c8053eb80b3$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $52c16c8053eb80b3$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $52c16c8053eb80b3$var$_measurements["mark.fid"];
        if (fidMark && $52c16c8053eb80b3$var$_measurements["fid"]) {
            // create span for FID
            (0, $d5f4541017e51400$export$8bd469e1f37aa721)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $52c16c8053eb80b3$var$msToSec($52c16c8053eb80b3$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $52c16c8053eb80b3$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $52c16c8053eb80b3$var$_measurements)) delete $52c16c8053eb80b3$var$_measurements.cls;
        Object.keys($52c16c8053eb80b3$var$_measurements).forEach((measurementName)=>{
            (0, $f6221b05586042ed$export$7cc31b475d33a706)(measurementName, $52c16c8053eb80b3$var$_measurements[measurementName].value, $52c16c8053eb80b3$var$_measurements[measurementName].unit);
        });
        $52c16c8053eb80b3$var$_tagMetricInfo(transaction);
    }
    $52c16c8053eb80b3$var$_lcpEntry = undefined;
    $52c16c8053eb80b3$var$_clsEntry = undefined;
    $52c16c8053eb80b3$var$_measurements = {};
}
/** Create measure related spans */ function $52c16c8053eb80b3$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $d5f4541017e51400$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $52c16c8053eb80b3$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $52c16c8053eb80b3$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $52c16c8053eb80b3$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $52c16c8053eb80b3$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $52c16c8053eb80b3$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $52c16c8053eb80b3$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $52c16c8053eb80b3$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $d5f4541017e51400$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $52c16c8053eb80b3$var$msToSec(start),
        endTimestamp: timeOrigin + $52c16c8053eb80b3$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $52c16c8053eb80b3$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $d5f4541017e51400$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "request",
            startTimestamp: timeOrigin + $52c16c8053eb80b3$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $52c16c8053eb80b3$var$msToSec(entry.responseEnd)
        });
        (0, $d5f4541017e51400$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "response",
            startTimestamp: timeOrigin + $52c16c8053eb80b3$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $52c16c8053eb80b3$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $52c16c8053eb80b3$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $b558a229e6ddb058$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $52c16c8053eb80b3$var$setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    $52c16c8053eb80b3$var$setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    $52c16c8053eb80b3$var$setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data["server.address"] = parsedUrl.host;
    data["url.same_origin"] = resourceUrl.includes((0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $d5f4541017e51400$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).location.origin, ""),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $52c16c8053eb80b3$var$_trackNavigator(transaction) {
    const navigator = (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("connectionType", connection.type);
        if ((0, $d5f4541017e51400$export$27169ccae1b439e3)(connection.rtt)) $52c16c8053eb80b3$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $d5f4541017e51400$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $d5f4541017e51400$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $52c16c8053eb80b3$var$_tagMetricInfo(transaction) {
    if ($52c16c8053eb80b3$var$_lcpEntry) {
        (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($52c16c8053eb80b3$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.element", (0, $e15b4fbcaae97cb7$export$5647df6b7814ac86)($52c16c8053eb80b3$var$_lcpEntry.element));
        if ($52c16c8053eb80b3$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.id", $52c16c8053eb80b3$var$_lcpEntry.id);
        if ($52c16c8053eb80b3$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.url", $52c16c8053eb80b3$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.size", $52c16c8053eb80b3$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($52c16c8053eb80b3$var$_clsEntry && $52c16c8053eb80b3$var$_clsEntry.sources) {
        (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Measurements] Adding CLS Data");
        $52c16c8053eb80b3$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $e15b4fbcaae97cb7$export$5647df6b7814ac86)(source.node)));
    }
}
function $52c16c8053eb80b3$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $52c16c8053eb80b3$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $52c16c8053eb80b3$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $abf4cfe7f8569032$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Measurements] Adding TTFB Request Time");
        _measurements["ttfb.requestTime"] = {
            value: responseStart - requestStart,
            unit: "millisecond"
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $52c16c8053eb80b3$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $ec5dc6e344042b9b$export$5008da00b1b6dee6)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === "function") sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $db775f85015e2649$export$2603c8d332a51c42)(sampleRate)) {
        (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("[Tracing] Discarding interaction span because of invalid sample rate.");
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}






/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $7d227e26aadec68d$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!(0, $ec5dc6e344042b9b$export$5008da00b1b6dee6)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $7d227e26aadec68d$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $3b3c418f52d65472$export$c7be4b0125a10cba)();
    const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $7d227e26aadec68d$var$getFullURL(url);
    const host = fullUrl ? (0, $b558a229e6ddb058$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $ee681c8f4e6404de$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host,
            [(0, $a8f596f3c433b5b1$export$cca8dd30f57f805e)]: spanOrigin
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $7d227e26aadec68d$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $7d227e26aadec68d$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $19e624db95e0b5b5$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $391854fa51155a6b$export$7e9f8ae9e4a328ab)(span) : (0, $896026ba1cdc6157$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $32e3c03de1c9a833$export$56766feef403f365)(dsc || (span ? (0, $bf724425488f9967$export$a117f995597e25df)(span) : (0, $bf724425488f9967$export$366bad00d6815eed)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== "undefined" && (0, $7a2b241ae9102e94$export$49034edbe6b62415)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $7a2b241ae9102e94$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $32e3c03de1c9a833$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $32e3c03de1c9a833$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
function $7d227e26aadec68d$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $7d227e26aadec68d$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $68ddfd2d9bd9e711$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus("internal_error");
    span.end();
}




/* eslint-disable max-lines */ const $6c26048dede701bf$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $6c26048dede701bf$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $6c26048dede701bf$export$15bd0305d05ad07b,
    tracePropagationTargets: $6c26048dede701bf$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $6c26048dede701bf$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $6c26048dede701bf$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $6c26048dede701bf$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$6c26048dede701bf$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $5adf1dbc05c20562$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $7d227e26aadec68d$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $6c26048dede701bf$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $b558a229e6ddb058$export$7a5253c0f62e0150)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                "http.url": fullUrl,
                "server.address": host
            });
        }
        if (enableHTTPTimings && createdSpan) $6c26048dede701bf$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $3c4b84232c65ad9a$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $6c26048dede701bf$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $6c26048dede701bf$var$addHTTPTimings(createdSpan);
    });
}
function $6c26048dede701bf$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $6c26048dede701bf$var$addHTTPTimings(span) {
    const { url: url } = (0, $391854fa51155a6b$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $c0253c3b07cda670$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($6c26048dede701bf$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $6c26048dede701bf$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $6c26048dede701bf$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $6c26048dede701bf$var$getAbsoluteTime(time = 0) {
    return (((0, $75b4984e5522b249$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $6c26048dede701bf$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $6c26048dede701bf$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $75b4984e5522b249$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $6c26048dede701bf$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $6c26048dede701bf$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $6c26048dede701bf$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $6c26048dede701bf$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $6c26048dede701bf$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $6c26048dede701bf$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $6c26048dede701bf$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $6c26048dede701bf$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $6c26048dede701bf$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $6c26048dede701bf$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $6c26048dede701bf$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $d43244d0c656442a$export$a7a5ec66062ea5d)(url, tracePropagationTargets || $6c26048dede701bf$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $6c26048dede701bf$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $3c4b84232c65ad9a$export$55b6bb1e45c6cf59];
    if (!(0, $ec5dc6e344042b9b$export$5008da00b1b6dee6)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $68ddfd2d9bd9e711$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $3b3c418f52d65472$export$c7be4b0125a10cba)();
    const isolationScope = (0, $19e624db95e0b5b5$export$68f3af03034c9e90)();
    const fullUrl = $6c26048dede701bf$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $b558a229e6ddb058$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $ee681c8f4e6404de$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host,
            [(0, $a8f596f3c433b5b1$export$cca8dd30f57f805e)]: "auto.http.browser"
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $391854fa51155a6b$export$7e9f8ae9e4a328ab)(span) : (0, $896026ba1cdc6157$export$f35d907436da45cf)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $32e3c03de1c9a833$export$56766feef403f365)(dsc || (span ? (0, $bf724425488f9967$export$a117f995597e25df)(span) : (0, $bf724425488f9967$export$366bad00d6815eed)(traceId, client, scope)));
        $6c26048dede701bf$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $6c26048dede701bf$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $32e3c03de1c9a833$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $6c26048dede701bf$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}



const $372ce2d55fd5d92e$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $372ce2d55fd5d92e$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $c890784f2b5b8280$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $6c26048dede701bf$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $372ce2d55fd5d92e$export$b4109253475213e9 = (_options = {})=>{
    const _hasSetTracePropagationTargets = (0, $56f8b2b50d64810a$export$16a28057038b10ef) ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    (0, $9d41dbc71d08bcd0$export$653d0ef2bad9cdf9)();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
    const options = {
        ...$372ce2d55fd5d92e$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $52c16c8053eb80b3$export$7c69f0412d101b88)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ const interactionIdToRouteNameMapping = {};
    if (options.enableInp) (0, $52c16c8053eb80b3$export$f17d06681a4744a3)(interactionIdToRouteNameMapping, options.interactionsSampleRate);
    if (options.enableLongTask) (0, $52c16c8053eb80b3$export$f396d19077034ad2)();
    if (options._experiments.enableInteractions) (0, $52c16c8053eb80b3$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        context: undefined
    };
    /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        const hub = (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)();
        const { beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $372ce2d55fd5d92e$export$f147b32b03c9cf11("sentry-trace") : "";
            const baggage = isPageloadTransaction ? $372ce2d55fd5d92e$export$f147b32b03c9cf11("baggage") : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $896026ba1cdc6157$export$261f383d16a93e39)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $9d41dbc71d08bcd0$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document) {
            (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document.addEventListener("readystatechange", ()=>{
                if ([
                    "interactive",
                    "complete"
                ].includes((0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                "interactive",
                "complete"
            ].includes((0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            _collectWebVitals();
            (0, $52c16c8053eb80b3$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    return {
        name: $372ce2d55fd5d92e$export$bbd2089f30bd3708,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: ()=>{},
        afterAllSetup (client) {
            const clientOptions = client.getOptions();
            const { markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = options;
            const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            const tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if ((0, $56f8b2b50d64810a$export$16a28057038b10ef) && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
            let activeSpan;
            let startingUrl = (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).location && (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).location.href;
            if (client.on) {
                client.on("startNavigationSpan", (context)=>{
                    if (activeSpan) {
                        (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $391854fa51155a6b$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "navigation",
                        ...context
                    });
                });
                client.on("startPageLoadSpan", (context)=>{
                    if (activeSpan) {
                        (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $391854fa51155a6b$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "pageload",
                        ...context
                    });
                });
            }
            if (options.instrumentPageLoad && client.emit && (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).location) {
                const context = {
                    name: (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: (0, $75b4984e5522b249$export$baf075a948ffc0bf) ? (0, $75b4984e5522b249$export$baf075a948ffc0bf) / 1000 : undefined,
                    origin: "auto.pageload.browser",
                    attributes: {
                        [(0, $a8f596f3c433b5b1$export$d7a7d984b0791405)]: "url"
                    }
                };
                $372ce2d55fd5d92e$export$aa44a07f82af519f(client, context);
            }
            if (options.instrumentNavigation && client.emit && (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).location) (0, $2c6eb7f56917cfd8$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                    startingUrl = undefined;
                    return;
                }
                if (from !== to) {
                    startingUrl = undefined;
                    const context = {
                        name: (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).location.pathname,
                        origin: "auto.navigation.browser",
                        attributes: {
                            [(0, $a8f596f3c433b5b1$export$d7a7d984b0791405)]: "url"
                        }
                    };
                    $372ce2d55fd5d92e$export$7d159749bd9969ad(client, context);
                }
            });
            if (markBackgroundSpan) (0, $c71764540c2771f4$export$6f18f55521af71a1)();
            if (_experiments.enableInteractions) $372ce2d55fd5d92e$var$registerInteractionListener(options, latestRoute);
            if (options.enableInp) $372ce2d55fd5d92e$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute);
            (0, $6c26048dede701bf$export$864489cb3478db3e)({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        },
        options: // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $372ce2d55fd5d92e$export$aa44a07f82af519f(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startPageLoadSpan", spanOptions);
    const span = (0, $ee681c8f4e6404de$export$1be426a8e585c83e)();
    const op = span && (0, $391854fa51155a6b$export$92d8c23565496537)(span).op;
    return op === "pageload" ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $372ce2d55fd5d92e$export$7d159749bd9969ad(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startNavigationSpan", spanOptions);
    const span = (0, $ee681c8f4e6404de$export$1be426a8e585c83e)();
    const op = span && (0, $391854fa51155a6b$export$92d8c23565496537)(span).op;
    return op === "navigation" ? span : undefined;
}
/** Returns the value of a meta tag */ function $372ce2d55fd5d92e$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $e15b4fbcaae97cb7$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
/** Start listener for interaction transactions */ function $372ce2d55fd5d92e$var$registerInteractionListener(options, latestRoute) {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = ()=>{
        const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const op = "ui.action.click";
        // eslint-disable-next-line deprecation/deprecation
        const currentTransaction = (0, $3717f11d9edb58cd$export$a7feb32fdd923295)();
        if (currentTransaction && currentTransaction.op && [
            "navigation",
            "pageload"
        ].includes(currentTransaction.op)) {
            (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason("interactionInterrupted");
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            (0, $56f8b2b50d64810a$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        const { location: location } = (0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81);
        const context = {
            name: latestRoute.name,
            op: op,
            trimEnd: true,
            data: {
                [(0, $a8f596f3c433b5b1$export$d7a7d984b0791405)]: latestRoute.context ? $372ce2d55fd5d92e$var$getSource(latestRoute.context) : "url"
            }
        };
        inflightInteractionTransaction = (0, $9d41dbc71d08bcd0$export$479dbd817e392a4f)(// eslint-disable-next-line deprecation/deprecation
        (0, $19e624db95e0b5b5$export$a07cdf6544bbd7c)(), context, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
    };
    [
        "click"
    ].forEach((type)=>{
        if ((0, $e3f900f64ccd9f84$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
            once: false,
            capture: true
        });
    });
}
function $372ce2d55fd5d92e$var$isPerformanceEventTiming(entry) {
    return "duration" in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $372ce2d55fd5d92e$var$MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function $372ce2d55fd5d92e$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
        const replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $3717f11d9edb58cd$export$a7feb32fdd923295)();
        const currentScope = (0, $3b3c418f52d65472$export$c7be4b0125a10cba)();
        const user = currentScope !== undefined ? currentScope.getUser() : undefined;
        entries.forEach((entry)=>{
            if ($372ce2d55fd5d92e$var$isPerformanceEventTiming(entry)) {
                const interactionId = entry.interactionId;
                if (interactionId === undefined) return;
                const existingInteraction = interactionIdToRouteNameMapping[interactionId];
                const duration = entry.duration;
                const startTime = entry.startTime;
                const keys = Object.keys(interactionIdToRouteNameMapping);
                const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                    return interactionIdToRouteNameMapping[a].duration < interactionIdToRouteNameMapping[b].duration ? a : b;
                }) : undefined;
                // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                // This is also checked in the web-vitals library.
                if (entry.entryType === "first-input") {
                    const matchingEntry = keys.map((key)=>interactionIdToRouteNameMapping[key]).some((interaction)=>{
                        return interaction.duration === duration && interaction.startTime === startTime;
                    });
                    if (matchingEntry) return;
                }
                // Interactions with an id of 0 and are not first-input are not valid.
                if (!interactionId) return;
                // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                else if (keys.length < $372ce2d55fd5d92e$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > interactionIdToRouteNameMapping[minInteractionId].duration) {
                    // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                    const routeName = latestRoute.name;
                    const parentContext = latestRoute.context;
                    if (routeName && parentContext) {
                        if (minInteractionId && Object.keys(interactionIdToRouteNameMapping).length >= $372ce2d55fd5d92e$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                        delete interactionIdToRouteNameMapping[minInteractionId];
                        interactionIdToRouteNameMapping[interactionId] = {
                            routeName: routeName,
                            duration: duration,
                            parentContext: parentContext,
                            user: user,
                            activeTransaction: activeTransaction,
                            replayId: replayId,
                            startTime: startTime
                        };
                    }
                }
            }
        });
    };
    (0, $c0253c3b07cda670$export$69816c1a049f8db6)("event", handleEntries);
    (0, $c0253c3b07cda670$export$69816c1a049f8db6)("first-input", handleEntries);
}
function $372ce2d55fd5d92e$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $a8f596f3c433b5b1$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $a8f596f3c433b5b1$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}

































/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */ // eslint-disable-next-line deprecation/deprecation
function $6e5f9e0a44d73be3$export$d92e61f5600202af(url, hubOrClient) {
    const client = hubOrClient && $6e5f9e0a44d73be3$var$isHub(hubOrClient) ? hubOrClient.getClient() : hubOrClient;
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $6e5f9e0a44d73be3$var$checkDsn(url, dsn) || $6e5f9e0a44d73be3$var$checkTunnel(url, tunnel);
}
function $6e5f9e0a44d73be3$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $6e5f9e0a44d73be3$var$removeTrailingSlash(url) === $6e5f9e0a44d73be3$var$removeTrailingSlash(tunnel);
}
function $6e5f9e0a44d73be3$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $6e5f9e0a44d73be3$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
// eslint-disable-next-line deprecation/deprecation
function $6e5f9e0a44d73be3$var$isHub(hubOrClient) {
    // eslint-disable-next-line deprecation/deprecation
    return hubOrClient.getClient !== undefined;
}













var $fd50498137c08b1e$exports = {};

$parcel$export($fd50498137c08b1e$exports, "FunctionToString", function () { return $e2f186284bd2b67f$export$da4704525c20ae79; });
$parcel$export($fd50498137c08b1e$exports, "InboundFilters", function () { return $11d7b718b83002b9$export$2ffbb5359dcc6be4; });
$parcel$export($fd50498137c08b1e$exports, "LinkedErrors", function () { return $d2b12a470a4663cc$export$8d1e60aaf616fb4f; });






/**
 * Extracts stack frames from the error.stack string
 */ function $54d51ab2f0c73f35$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $54d51ab2f0c73f35$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    const frames = $54d51ab2f0c73f35$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $54d51ab2f0c73f35$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    else // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${(0, $2486f7fb3095088f$export$b0244d5063c0b61b)(exception)}`;
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function $54d51ab2f0c73f35$export$9dd56ed1ef0c3420(// eslint-disable-next-line deprecation/deprecation
getHubOrClient, stackParser, exception, hint) {
    const client = typeof getHubOrClient === "function" ? getHubOrClient().getClient() : getHubOrClient;
    let ex = exception;
    const providedMechanism = hint && hint.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    let extras;
    if (!(0, $7a2b241ae9102e94$export$e6127cc7fe7395c3)(exception)) {
        if ((0, $7a2b241ae9102e94$export$53b83ca8eaab0383)(exception)) {
            const normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = {
                ["__serialized__"]: (0, $5356bc1441432547$export$23fbbb20bed71033)(exception, normalizeDepth)
            };
            const message = $54d51ab2f0c73f35$var$getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    const event = {
        exception: {
            values: [
                $54d51ab2f0c73f35$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $0abc5e6206c3ae86$export$f26508487bf83ee7)(event, undefined, undefined);
    (0, $0abc5e6206c3ae86$export$c69a9a0313b03bb1)(event, mechanism);
    return {
        ...event,
        event_id: hint && hint.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $54d51ab2f0c73f35$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint && hint.event_id,
        level: level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        const frames = $54d51ab2f0c73f35$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $7a2b241ae9102e94$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}



const $d2b12a470a4663cc$var$DEFAULT_KEY = "cause";
const $d2b12a470a4663cc$var$DEFAULT_LIMIT = 5;
const $d2b12a470a4663cc$var$INTEGRATION_NAME = "LinkedErrors";
const $d2b12a470a4663cc$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $d2b12a470a4663cc$var$DEFAULT_LIMIT;
    const key = options.key || $d2b12a470a4663cc$var$DEFAULT_KEY;
    return {
        name: $d2b12a470a4663cc$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $8f2f9f4f3e3dbbd6$export$b91c38ed7d8ae9b2)((0, $54d51ab2f0c73f35$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $d2b12a470a4663cc$export$ebabb00eb7f3a395 = (0, $f8e6000d29329e0a$export$2323046b9414659f)($d2b12a470a4663cc$var$_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $d2b12a470a4663cc$export$8d1e60aaf616fb4f = (0, $f8e6000d29329e0a$export$afa219bf23651160)($d2b12a470a4663cc$var$INTEGRATION_NAME, $d2b12a470a4663cc$export$ebabb00eb7f3a395);


 /* eslint-disable deprecation/deprecation */ 


/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $46763ee46f5e2adb$export$99d02219d259eb94 = $fd50498137c08b1e$exports;
















var $837d3008f05e6417$exports = {};

$parcel$export($837d3008f05e6417$exports, "GlobalHandlers", function () { return $d885a5291a82df6e$export$204155decbc90e5a; });
$parcel$export($837d3008f05e6417$exports, "TryCatch", function () { return $58c4ecf8448cd7ac$export$f1a018517668e6d3; });
$parcel$export($837d3008f05e6417$exports, "Breadcrumbs", function () { return $3a14474c2326a9a3$export$2dc68d50d56fbbd; });
$parcel$export($837d3008f05e6417$exports, "LinkedErrors", function () { return $b1b7d8736f233a76$export$8d1e60aaf616fb4f; });
$parcel$export($837d3008f05e6417$exports, "HttpContext", function () { return $6757330cdae01dc8$export$5d2ee9a544b09a94; });
$parcel$export($837d3008f05e6417$exports, "Dedupe", function () { return $cdab0846da1aae66$export$688d98c249d31ad3; });






 /* eslint-disable deprecation/deprecation */ 

// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $ced144b954486f58$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $f04bc83cc42fe463$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}


var $1fSew = parcelRequire("1fSew");

/**
 * Returns true if we are in the browser.
 */ function $2699263b96e8d034$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, $1fSew.isNodeEnv)() || $2699263b96e8d034$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $2699263b96e8d034$var$isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1).process !== undefined && (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1).process.type === "renderer");
}




// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $c7a0a995f0f65f86$var$WINDOW = (0, $16d17c26f0ead2cf$export$f1a6cdb1459e81d1);
const $c7a0a995f0f65f86$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $c7a0a995f0f65f86$var$REPLAY_EVENT_NAME = "replay_event";
const $c7a0a995f0f65f86$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
// The idle limit for a session after which recording is paused.
const $c7a0a995f0f65f86$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $c7a0a995f0f65f86$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $c7a0a995f0f65f86$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $c7a0a995f0f65f86$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $c7a0a995f0f65f86$var$BUFFER_CHECKOUT_TIME = 60000;
const $c7a0a995f0f65f86$var$RETRY_BASE_INTERVAL = 5000;
const $c7a0a995f0f65f86$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $c7a0a995f0f65f86$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $c7a0a995f0f65f86$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $c7a0a995f0f65f86$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $c7a0a995f0f65f86$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $c7a0a995f0f65f86$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $c7a0a995f0f65f86$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $c7a0a995f0f65f86$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $c7a0a995f0f65f86$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $c7a0a995f0f65f86$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $c7a0a995f0f65f86$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $c7a0a995f0f65f86$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($c7a0a995f0f65f86$var$NodeType$1 || ($c7a0a995f0f65f86$var$NodeType$1 = {}));
function $c7a0a995f0f65f86$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $c7a0a995f0f65f86$var$isShadowRoot(n) {
    const host = $c7a0a995f0f65f86$var$_optionalChain$5([
        n,
        "optionalAccess",
        (_)=>_.host
    ]);
    return Boolean($c7a0a995f0f65f86$var$_optionalChain$5([
        host,
        "optionalAccess",
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $c7a0a995f0f65f86$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $c7a0a995f0f65f86$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $c7a0a995f0f65f86$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $c7a0a995f0f65f86$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $c7a0a995f0f65f86$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $c7a0a995f0f65f86$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $c7a0a995f0f65f86$var$stringifyRule(rule) {
    let importStringified;
    if ($c7a0a995f0f65f86$var$isCSSImportRule(rule)) try {
        importStringified = $c7a0a995f0f65f86$var$stringifyStylesheet(rule.styleSheet) || $c7a0a995f0f65f86$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($c7a0a995f0f65f86$var$isCSSStyleRule(rule) && rule.selectorText.includes(":")) return $c7a0a995f0f65f86$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $c7a0a995f0f65f86$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $c7a0a995f0f65f86$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $c7a0a995f0f65f86$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $c7a0a995f0f65f86$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = $c7a0a995f0f65f86$var$_optionalChain$5([
            this,
            "access",
            (_3)=>_3.getMeta,
            "call",
            (_4)=>_4(n),
            "optionalAccess",
            (_5)=>_5.id
        ]);
        return $c7a0a995f0f65f86$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $c7a0a995f0f65f86$var$createMirror() {
    return new $c7a0a995f0f65f86$var$Mirror();
}
function $c7a0a995f0f65f86$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $c7a0a995f0f65f86$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $c7a0a995f0f65f86$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $c7a0a995f0f65f86$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $c7a0a995f0f65f86$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $c7a0a995f0f65f86$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $c7a0a995f0f65f86$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$c7a0a995f0f65f86$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $c7a0a995f0f65f86$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $c7a0a995f0f65f86$var$toLowerCase(type) : null;
}
function $c7a0a995f0f65f86$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
let $c7a0a995f0f65f86$var$_id = 1;
const $c7a0a995f0f65f86$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $c7a0a995f0f65f86$var$IGNORED_NODE = -2;
function $c7a0a995f0f65f86$var$genId() {
    return $c7a0a995f0f65f86$var$_id++;
}
function $c7a0a995f0f65f86$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $c7a0a995f0f65f86$var$toLowerCase(element.tagName);
    if ($c7a0a995f0f65f86$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $c7a0a995f0f65f86$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $c7a0a995f0f65f86$var$canvasService;
let $c7a0a995f0f65f86$var$canvasCtx;
const $c7a0a995f0f65f86$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $c7a0a995f0f65f86$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $c7a0a995f0f65f86$var$URL_WWW_MATCH = /^www\..*/i;
const $c7a0a995f0f65f86$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $c7a0a995f0f65f86$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($c7a0a995f0f65f86$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($c7a0a995f0f65f86$var$URL_PROTOCOL_MATCH.test(filePath) || $c7a0a995f0f65f86$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($c7a0a995f0f65f86$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$c7a0a995f0f65f86$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $c7a0a995f0f65f86$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $c7a0a995f0f65f86$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $c7a0a995f0f65f86$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($c7a0a995f0f65f86$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($c7a0a995f0f65f86$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $c7a0a995f0f65f86$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $c7a0a995f0f65f86$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
function $c7a0a995f0f65f86$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    const a = doc.createElement("a");
    a.href = attributeValue;
    return a.href;
}
function $c7a0a995f0f65f86$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $c7a0a995f0f65f86$var$getHref() {
    const a = document.createElement("a");
    a.href = "";
    return a.href;
}
function $c7a0a995f0f65f86$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $c7a0a995f0f65f86$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $c7a0a995f0f65f86$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $c7a0a995f0f65f86$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $c7a0a995f0f65f86$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $c7a0a995f0f65f86$var$absoluteToStylesheet(value, $c7a0a995f0f65f86$var$getHref());
    else if (tagName === "object" && name === "data") return $c7a0a995f0f65f86$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $c7a0a995f0f65f86$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $c7a0a995f0f65f86$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $c7a0a995f0f65f86$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $c7a0a995f0f65f86$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $c7a0a995f0f65f86$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $c7a0a995f0f65f86$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($c7a0a995f0f65f86$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $c7a0a995f0f65f86$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $c7a0a995f0f65f86$var$distanceToMatch(el, $c7a0a995f0f65f86$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $c7a0a995f0f65f86$var$distanceToMatch(el, $c7a0a995f0f65f86$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $c7a0a995f0f65f86$var$distanceToMatch(el, $c7a0a995f0f65f86$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $c7a0a995f0f65f86$var$distanceToMatch(el, $c7a0a995f0f65f86$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $c7a0a995f0f65f86$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $c7a0a995f0f65f86$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $c7a0a995f0f65f86$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $c7a0a995f0f65f86$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $c7a0a995f0f65f86$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $c7a0a995f0f65f86$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $c7a0a995f0f65f86$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $c7a0a995f0f65f86$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $c7a0a995f0f65f86$var$serializeTextNode(n, {
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $c7a0a995f0f65f86$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $c7a0a995f0f65f86$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $c7a0a995f0f65f86$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $c7a0a995f0f65f86$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : undefined;
    const isScript = parentTagName === "SCRIPT" ? true : undefined;
    const isTextarea = parentTagName === "TEXTAREA" ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($c7a0a995f0f65f86$var$_optionalChain$5([
                n,
                "access",
                (_6)=>_6.parentNode,
                "access",
                (_7)=>_7.sheet,
                "optionalAccess",
                (_8)=>_8.cssRules
            ])) textContent = $c7a0a995f0f65f86$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $c7a0a995f0f65f86$var$absoluteToStylesheet(textContent, $c7a0a995f0f65f86$var$getHref());
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $c7a0a995f0f65f86$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $c7a0a995f0f65f86$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $c7a0a995f0f65f86$var$maskInputValue({
            isMasked: $c7a0a995f0f65f86$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $c7a0a995f0f65f86$var$NodeType$1.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $c7a0a995f0f65f86$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $c7a0a995f0f65f86$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $c7a0a995f0f65f86$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$c7a0a995f0f65f86$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $c7a0a995f0f65f86$var$transformAttribute(doc, tagName, $c7a0a995f0f65f86$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $c7a0a995f0f65f86$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $c7a0a995f0f65f86$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && !(n.innerText || n.textContent || "").trim().length) {
        const cssText = $c7a0a995f0f65f86$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $c7a0a995f0f65f86$var$absoluteToStylesheet(cssText, $c7a0a995f0f65f86$var$getHref());
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n;
        const type = $c7a0a995f0f65f86$var$getInputType(el);
        const value = $c7a0a995f0f65f86$var$getInputValue(el, $c7a0a995f0f65f86$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $c7a0a995f0f65f86$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $c7a0a995f0f65f86$var$shouldMaskInput({
                type: type,
                tagName: $c7a0a995f0f65f86$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $c7a0a995f0f65f86$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$c7a0a995f0f65f86$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$c7a0a995f0f65f86$var$canvasService) {
            $c7a0a995f0f65f86$var$canvasService = doc.createElement("canvas");
            $c7a0a995f0f65f86$var$canvasCtx = $c7a0a995f0f65f86$var$canvasService.getContext("2d");
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = "anonymous";
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $c7a0a995f0f65f86$var$canvasService.width = image.naturalWidth;
                $c7a0a995f0f65f86$var$canvasService.height = image.naturalHeight;
                $c7a0a995f0f65f86$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $c7a0a995f0f65f86$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes.rr_mediaState = n.paused ? "paused" : "played";
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $c7a0a995f0f65f86$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $c7a0a995f0f65f86$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $c7a0a995f0f65f86$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $c7a0a995f0f65f86$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $c7a0a995f0f65f86$var$NodeType$1.Comment) return true;
    else if (sn.type === $c7a0a995f0f65f86$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === "script" || sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && sn.attributes.href.endsWith(".js"))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name) === "application-name" || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.rel) === "icon" || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name) === "robots" || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name) === "googlebot" || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name) === "author" || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name) === "generator" || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name) === "framework" || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name) === "publisher" || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name) === "progid" || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name) === "verification" || $c7a0a995f0f65f86$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $c7a0a995f0f65f86$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $c7a0a995f0f65f86$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($c7a0a995f0f65f86$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $c7a0a995f0f65f86$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $c7a0a995f0f65f86$var$IGNORED_NODE;
    else id = $c7a0a995f0f65f86$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $c7a0a995f0f65f86$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $c7a0a995f0f65f86$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $c7a0a995f0f65f86$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $c7a0a995f0f65f86$var$NodeType$1.Document || serializedNode.type === $c7a0a995f0f65f86$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $c7a0a995f0f65f86$var$NodeType$1.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $c7a0a995f0f65f86$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($c7a0a995f0f65f86$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $c7a0a995f0f65f86$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $c7a0a995f0f65f86$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $c7a0a995f0f65f86$var$isShadowRoot(n.parentNode) && $c7a0a995f0f65f86$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $c7a0a995f0f65f86$var$NodeType$1.Element && serializedNode.tagName === "iframe") $c7a0a995f0f65f86$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $c7a0a995f0f65f86$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $c7a0a995f0f65f86$var$NodeType$1.Element && serializedNode.tagName === "link" && serializedNode.attributes.rel === "stylesheet") $c7a0a995f0f65f86$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $c7a0a995f0f65f86$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $c7a0a995f0f65f86$var$snapshot(n, options) {
    const { mirror: mirror = new $c7a0a995f0f65f86$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $c7a0a995f0f65f86$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $c7a0a995f0f65f86$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $c7a0a995f0f65f86$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $c7a0a995f0f65f86$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $c7a0a995f0f65f86$var$_mirror = {
    map: {},
    getId () {
        console.error($c7a0a995f0f65f86$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($c7a0a995f0f65f86$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($c7a0a995f0f65f86$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($c7a0a995f0f65f86$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($c7a0a995f0f65f86$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $c7a0a995f0f65f86$var$_mirror = new Proxy($c7a0a995f0f65f86$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($c7a0a995f0f65f86$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $c7a0a995f0f65f86$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $c7a0a995f0f65f86$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$c7a0a995f0f65f86$var$hookSetter(target, key, original || {}, true);
}
function $c7a0a995f0f65f86$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $c7a0a995f0f65f86$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $c7a0a995f0f65f86$var$nowTimestamp = ()=>new Date().getTime();
function $c7a0a995f0f65f86$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $c7a0a995f0f65f86$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_)=>_.documentElement,
            "access",
            (_2)=>_2.scrollLeft
        ]) || $c7a0a995f0f65f86$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_3)=>_3.body,
            "optionalAccess",
            (_4)=>_4.parentElement,
            "optionalAccess",
            (_5)=>_5.scrollLeft
        ]) || $c7a0a995f0f65f86$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_6)=>_6.body,
            "optionalAccess",
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $c7a0a995f0f65f86$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_8)=>_8.documentElement,
            "access",
            (_9)=>_9.scrollTop
        ]) || $c7a0a995f0f65f86$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_10)=>_10.body,
            "optionalAccess",
            (_11)=>_11.parentElement,
            "optionalAccess",
            (_12)=>_12.scrollTop
        ]) || $c7a0a995f0f65f86$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_13)=>_13.body,
            "optionalAccess",
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $c7a0a995f0f65f86$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $c7a0a995f0f65f86$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $c7a0a995f0f65f86$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    if (!el) return false;
    const blockedPredicate = $c7a0a995f0f65f86$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $c7a0a995f0f65f86$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $c7a0a995f0f65f86$var$distanceToMatch(el, $c7a0a995f0f65f86$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $c7a0a995f0f65f86$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $c7a0a995f0f65f86$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $c7a0a995f0f65f86$var$IGNORED_NODE;
}
function $c7a0a995f0f65f86$var$isAncestorRemoved(target, mirror) {
    if ($c7a0a995f0f65f86$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $c7a0a995f0f65f86$var$isAncestorRemoved(target.parentNode, mirror);
}
function $c7a0a995f0f65f86$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $c7a0a995f0f65f86$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $c7a0a995f0f65f86$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $c7a0a995f0f65f86$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $c7a0a995f0f65f86$var$hasShadowRoot(n) {
    return Boolean($c7a0a995f0f65f86$var$_optionalChain$4([
        n,
        "optionalAccess",
        (_18)=>_18.shadowRoot
    ]));
}
class $c7a0a995f0f65f86$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, $ced144b954486f58$export$8db64e83cc1a933c)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $c7a0a995f0f65f86$var$getShadowHost(n) {
    let shadowHost = null;
    if ($c7a0a995f0f65f86$var$_optionalChain$4([
        n,
        "access",
        (_19)=>_19.getRootNode,
        "optionalCall",
        (_20)=>_20(),
        "optionalAccess",
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $c7a0a995f0f65f86$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $c7a0a995f0f65f86$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $c7a0a995f0f65f86$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $c7a0a995f0f65f86$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $c7a0a995f0f65f86$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $c7a0a995f0f65f86$var$shadowHostInDom(n);
}
let $c7a0a995f0f65f86$var$cachedRequestAnimationFrameImplementation;
function $c7a0a995f0f65f86$var$getRequestAnimationFrameImplementation() {
    if ($c7a0a995f0f65f86$var$cachedRequestAnimationFrameImplementation) return $c7a0a995f0f65f86$var$cachedRequestAnimationFrameImplementation;
    const document1 = window.document;
    let requestAnimationFrameImplementation = window.requestAnimationFrame;
    if (document1 && typeof document1.createElement === "function") try {
        const sandbox = document1.createElement("iframe");
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.requestAnimationFrame) requestAnimationFrameImplementation = contentWindow.requestAnimationFrame;
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $c7a0a995f0f65f86$var$cachedRequestAnimationFrameImplementation = requestAnimationFrameImplementation.bind(window);
}
function $c7a0a995f0f65f86$var$onRequestAnimationFrame(...rest) {
    return $c7a0a995f0f65f86$var$getRequestAnimationFrameImplementation()(...rest);
}
var $c7a0a995f0f65f86$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($c7a0a995f0f65f86$var$EventType || {});
var $c7a0a995f0f65f86$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($c7a0a995f0f65f86$var$IncrementalSource || {});
var $c7a0a995f0f65f86$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($c7a0a995f0f65f86$var$MouseInteractions || {});
var $c7a0a995f0f65f86$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($c7a0a995f0f65f86$var$PointerTypes || {});
function $c7a0a995f0f65f86$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $c7a0a995f0f65f86$var$isNodeInLinkedList(n) {
    return "__ln" in n;
}
class $c7a0a995f0f65f86$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = $c7a0a995f0f65f86$var$_optionalChain$3([
            current,
            "optionalAccess",
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $c7a0a995f0f65f86$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $c7a0a995f0f65f86$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $c7a0a995f0f65f86$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $c7a0a995f0f65f86$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $c7a0a995f0f65f86$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $c7a0a995f0f65f86$var$IGNORED_NODE;
                while(nextId === $c7a0a995f0f65f86$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$c7a0a995f0f65f86$var$inDom(n)) return;
                const parentId = $c7a0a995f0f65f86$var$isShadowRoot(n.parentNode) ? this.mirror.getId($c7a0a995f0f65f86$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $c7a0a995f0f65f86$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($c7a0a995f0f65f86$var$isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if ($c7a0a995f0f65f86$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($c7a0a995f0f65f86$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($c7a0a995f0f65f86$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$c7a0a995f0f65f86$var$isAncestorInSet(this.droppedSet, n) && !$c7a0a995f0f65f86$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($c7a0a995f0f65f86$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($c7a0a995f0f65f86$var$isIgnored(m.target, this.mirror)) return;
            let unattachedDoc;
            try {
                unattachedDoc = document.implementation.createHTMLDocument();
            } catch (e) {
                unattachedDoc = this.doc;
            }
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$c7a0a995f0f65f86$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $c7a0a995f0f65f86$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $c7a0a995f0f65f86$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $c7a0a995f0f65f86$var$getInputValue(target, tagName, type);
                            const isInputMasked = $c7a0a995f0f65f86$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $c7a0a995f0f65f86$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $c7a0a995f0f65f86$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($c7a0a995f0f65f86$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributes.find((a)=>a.node === m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$c7a0a995f0f65f86$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $c7a0a995f0f65f86$var$transformAttribute(this.doc, $c7a0a995f0f65f86$var$toLowerCase(target.tagName), $c7a0a995f0f65f86$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                const old = unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($c7a0a995f0f65f86$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $c7a0a995f0f65f86$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($c7a0a995f0f65f86$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $c7a0a995f0f65f86$var$isIgnored(n, this.mirror) || !$c7a0a995f0f65f86$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $c7a0a995f0f65f86$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($c7a0a995f0f65f86$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$c7a0a995f0f65f86$var$moveKey(nodeId, parentId)]) $c7a0a995f0f65f86$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $c7a0a995f0f65f86$var$isShadowRoot(m.target) && $c7a0a995f0f65f86$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($c7a0a995f0f65f86$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$c7a0a995f0f65f86$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$c7a0a995f0f65f86$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($c7a0a995f0f65f86$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $c7a0a995f0f65f86$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$c7a0a995f0f65f86$var$deepDelete(addsSet, childN));
}
function $c7a0a995f0f65f86$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $c7a0a995f0f65f86$var$_isParentRemoved(removes, n, mirror);
}
function $c7a0a995f0f65f86$var$_isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $c7a0a995f0f65f86$var$_isParentRemoved(removes, parentNode, mirror);
}
function $c7a0a995f0f65f86$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $c7a0a995f0f65f86$var$_isAncestorInSet(set, n);
}
function $c7a0a995f0f65f86$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $c7a0a995f0f65f86$var$_isAncestorInSet(set, parentNode);
}
let $c7a0a995f0f65f86$var$errorHandler;
function $c7a0a995f0f65f86$var$registerErrorHandler(handler) {
    $c7a0a995f0f65f86$var$errorHandler = handler;
}
function $c7a0a995f0f65f86$var$unregisterErrorHandler() {
    $c7a0a995f0f65f86$var$errorHandler = undefined;
}
const $c7a0a995f0f65f86$var$callbackWrapper = (cb)=>{
    if (!$c7a0a995f0f65f86$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($c7a0a995f0f65f86$var$errorHandler && $c7a0a995f0f65f86$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $c7a0a995f0f65f86$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $c7a0a995f0f65f86$var$mutationBuffers = [];
function $c7a0a995f0f65f86$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $c7a0a995f0f65f86$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $c7a0a995f0f65f86$var$MutationBuffer();
    $c7a0a995f0f65f86$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $c7a0a995f0f65f86$var$_optionalChain$2([
        window,
        "optionalAccess",
        (_)=>_.Zone,
        "optionalAccess",
        (_2)=>_2.__symbol__,
        "optionalCall",
        (_3)=>_3("MutationObserver")
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($c7a0a995f0f65f86$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $c7a0a995f0f65f86$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $c7a0a995f0f65f86$var$throttle$1($c7a0a995f0f65f86$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $c7a0a995f0f65f86$var$callbackWrapper($c7a0a995f0f65f86$var$throttle$1($c7a0a995f0f65f86$var$callbackWrapper((evt)=>{
        const target = $c7a0a995f0f65f86$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $c7a0a995f0f65f86$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $c7a0a995f0f65f86$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $c7a0a995f0f65f86$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $c7a0a995f0f65f86$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $c7a0a995f0f65f86$var$IncrementalSource.MouseMove : $c7a0a995f0f65f86$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $c7a0a995f0f65f86$var$on("mousemove", updatePosition, doc),
        $c7a0a995f0f65f86$var$on("touchmove", updatePosition, doc),
        $c7a0a995f0f65f86$var$on("drag", updatePosition, doc)
    ];
    return $c7a0a995f0f65f86$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $c7a0a995f0f65f86$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $c7a0a995f0f65f86$var$getEventTarget(event);
            if ($c7a0a995f0f65f86$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $c7a0a995f0f65f86$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $c7a0a995f0f65f86$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $c7a0a995f0f65f86$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $c7a0a995f0f65f86$var$PointerTypes.Touch) {
                    if ($c7a0a995f0f65f86$var$MouseInteractions[eventKey] === $c7a0a995f0f65f86$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($c7a0a995f0f65f86$var$MouseInteractions[eventKey] === $c7a0a995f0f65f86$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $c7a0a995f0f65f86$var$PointerTypes.Pen;
            } else if ($c7a0a995f0f65f86$var$legacy_isTouchEvent(event)) pointerType = $c7a0a995f0f65f86$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $c7a0a995f0f65f86$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $c7a0a995f0f65f86$var$PointerTypes.Mouse) pointerType = null;
            } else if ($c7a0a995f0f65f86$var$MouseInteractions[eventKey] === $c7a0a995f0f65f86$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $c7a0a995f0f65f86$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $c7a0a995f0f65f86$var$callbackWrapper(mouseInteractionCb)({
                type: $c7a0a995f0f65f86$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($c7a0a995f0f65f86$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $c7a0a995f0f65f86$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($c7a0a995f0f65f86$var$MouseInteractions[eventKey]){
            case $c7a0a995f0f65f86$var$MouseInteractions.MouseDown:
            case $c7a0a995f0f65f86$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $c7a0a995f0f65f86$var$MouseInteractions.TouchStart:
            case $c7a0a995f0f65f86$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($c7a0a995f0f65f86$var$on(eventName, handler, doc));
    });
    return $c7a0a995f0f65f86$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $c7a0a995f0f65f86$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $c7a0a995f0f65f86$var$callbackWrapper($c7a0a995f0f65f86$var$throttle$1($c7a0a995f0f65f86$var$callbackWrapper((evt)=>{
        const target = $c7a0a995f0f65f86$var$getEventTarget(evt);
        if (!target || $c7a0a995f0f65f86$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $c7a0a995f0f65f86$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $c7a0a995f0f65f86$var$on("scroll", updatePosition, doc);
}
function $c7a0a995f0f65f86$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $c7a0a995f0f65f86$var$callbackWrapper($c7a0a995f0f65f86$var$throttle$1($c7a0a995f0f65f86$var$callbackWrapper(()=>{
        const height = $c7a0a995f0f65f86$var$getWindowHeight();
        const width = $c7a0a995f0f65f86$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $c7a0a995f0f65f86$var$on("resize", updateDimension, win);
}
const $c7a0a995f0f65f86$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $c7a0a995f0f65f86$var$lastInputValueMap = new WeakMap();
function $c7a0a995f0f65f86$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $c7a0a995f0f65f86$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $c7a0a995f0f65f86$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $c7a0a995f0f65f86$var$INPUT_TAGS.indexOf(tagName) < 0 || $c7a0a995f0f65f86$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $c7a0a995f0f65f86$var$getInputType(target);
        let text = $c7a0a995f0f65f86$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $c7a0a995f0f65f86$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $c7a0a995f0f65f86$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $c7a0a995f0f65f86$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $c7a0a995f0f65f86$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $c7a0a995f0f65f86$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $c7a0a995f0f65f86$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $c7a0a995f0f65f86$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $c7a0a995f0f65f86$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$c7a0a995f0f65f86$var$on(eventName, $c7a0a995f0f65f86$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$c7a0a995f0f65f86$var$hookSetter(p[0], p[1], {
            set () {
                $c7a0a995f0f65f86$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $c7a0a995f0f65f86$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $c7a0a995f0f65f86$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($c7a0a995f0f65f86$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $c7a0a995f0f65f86$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $c7a0a995f0f65f86$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $c7a0a995f0f65f86$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $c7a0a995f0f65f86$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $c7a0a995f0f65f86$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $c7a0a995f0f65f86$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $c7a0a995f0f65f86$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $c7a0a995f0f65f86$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $c7a0a995f0f65f86$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $c7a0a995f0f65f86$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $c7a0a995f0f65f86$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $c7a0a995f0f65f86$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $c7a0a995f0f65f86$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($c7a0a995f0f65f86$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($c7a0a995f0f65f86$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($c7a0a995f0f65f86$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($c7a0a995f0f65f86$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $c7a0a995f0f65f86$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $c7a0a995f0f65f86$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$c7a0a995f0f65f86$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $c7a0a995f0f65f86$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $c7a0a995f0f65f86$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$c7a0a995f0f65f86$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $c7a0a995f0f65f86$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $c7a0a995f0f65f86$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? $c7a0a995f0f65f86$var$_optionalChain$2([
        host,
        "access",
        (_4)=>_4.defaultView,
        "optionalAccess",
        (_5)=>_5.Document
    ]) : $c7a0a995f0f65f86$var$_optionalChain$2([
        host,
        "access",
        (_6)=>_6.ownerDocument,
        "optionalAccess",
        (_7)=>_7.defaultView,
        "optionalAccess",
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $c7a0a995f0f65f86$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($c7a0a995f0f65f86$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_10)=>_10.prototype
    ]), "adoptedStyleSheets") : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $c7a0a995f0f65f86$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_11)=>_11.get,
                "optionalAccess",
                (_12)=>_12.call,
                "call",
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $c7a0a995f0f65f86$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_14)=>_14.set,
                "optionalAccess",
                (_15)=>_15.call,
                "call",
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $c7a0a995f0f65f86$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $c7a0a995f0f65f86$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $c7a0a995f0f65f86$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $c7a0a995f0f65f86$var$getIdAndStyleId($c7a0a995f0f65f86$var$_optionalChain$2([
                thisArg,
                "access",
                (_17)=>_17.parentRule,
                "optionalAccess",
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $c7a0a995f0f65f86$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $c7a0a995f0f65f86$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $c7a0a995f0f65f86$var$getIdAndStyleId($c7a0a995f0f65f86$var$_optionalChain$2([
                thisArg,
                "access",
                (_19)=>_19.parentRule,
                "optionalAccess",
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $c7a0a995f0f65f86$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $c7a0a995f0f65f86$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $c7a0a995f0f65f86$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $c7a0a995f0f65f86$var$callbackWrapper((type)=>$c7a0a995f0f65f86$var$throttle$1($c7a0a995f0f65f86$var$callbackWrapper((event)=>{
            const target = $c7a0a995f0f65f86$var$getEventTarget(event);
            if (!target || $c7a0a995f0f65f86$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $c7a0a995f0f65f86$var$on("play", handler(0), doc),
        $c7a0a995f0f65f86$var$on("pause", handler(1), doc),
        $c7a0a995f0f65f86$var$on("seeked", handler(2), doc),
        $c7a0a995f0f65f86$var$on("volumechange", handler(3), doc),
        $c7a0a995f0f65f86$var$on("ratechange", handler(4), doc)
    ];
    return $c7a0a995f0f65f86$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $c7a0a995f0f65f86$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $c7a0a995f0f65f86$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            setTimeout($c7a0a995f0f65f86$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $c7a0a995f0f65f86$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $c7a0a995f0f65f86$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $c7a0a995f0f65f86$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $c7a0a995f0f65f86$var$_optionalChain$2([
            selection,
            "optionalAccess",
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $c7a0a995f0f65f86$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $c7a0a995f0f65f86$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $c7a0a995f0f65f86$var$on("selectionchange", updateSelection);
}
function $c7a0a995f0f65f86$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $c7a0a995f0f65f86$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $c7a0a995f0f65f86$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    const mutationObserver = $c7a0a995f0f65f86$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $c7a0a995f0f65f86$var$initMoveObserver(o);
    const mouseInteractionHandler = $c7a0a995f0f65f86$var$initMouseInteractionObserver(o);
    const scrollHandler = $c7a0a995f0f65f86$var$initScrollObserver(o);
    const viewportResizeHandler = $c7a0a995f0f65f86$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $c7a0a995f0f65f86$var$initInputObserver(o);
    const mediaInteractionHandler = $c7a0a995f0f65f86$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $c7a0a995f0f65f86$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const adoptedStyleSheetObserver = $c7a0a995f0f65f86$var$initAdoptedStyleSheetObserver(o, o.doc);
    const styleDeclarationObserver = $c7a0a995f0f65f86$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $c7a0a995f0f65f86$var$initFontObserver(o) : ()=>{};
    const selectionObserver = $c7a0a995f0f65f86$var$initSelectionObserver(o);
    const customElementObserver = $c7a0a995f0f65f86$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $c7a0a995f0f65f86$var$callbackWrapper(()=>{
        $c7a0a995f0f65f86$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $c7a0a995f0f65f86$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $c7a0a995f0f65f86$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $c7a0a995f0f65f86$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function $c7a0a995f0f65f86$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $c7a0a995f0f65f86$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $c7a0a995f0f65f86$var$CrossOriginIframeMirror($c7a0a995f0f65f86$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $c7a0a995f0f65f86$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $c7a0a995f0f65f86$var$CrossOriginIframeMirror($c7a0a995f0f65f86$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $c7a0a995f0f65f86$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $c7a0a995f0f65f86$var$_optionalChain$1([
            this,
            "access",
            (_)=>_.loadListener,
            "optionalCall",
            (_2)=>_2(iframeEl)
        ]);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $c7a0a995f0f65f86$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c7a0a995f0f65f86$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $c7a0a995f0f65f86$var$EventType.Meta:
            case $c7a0a995f0f65f86$var$EventType.Load:
            case $c7a0a995f0f65f86$var$EventType.DomContentLoaded:
                return false;
            case $c7a0a995f0f65f86$var$EventType.Plugin:
                return e;
            case $c7a0a995f0f65f86$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e;
            case $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $c7a0a995f0f65f86$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $c7a0a995f0f65f86$var$IncrementalSource.Drag:
                    case $c7a0a995f0f65f86$var$IncrementalSource.TouchMove:
                    case $c7a0a995f0f65f86$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $c7a0a995f0f65f86$var$IncrementalSource.ViewportResize:
                        return false;
                    case $c7a0a995f0f65f86$var$IncrementalSource.MediaInteraction:
                    case $c7a0a995f0f65f86$var$IncrementalSource.MouseInteraction:
                    case $c7a0a995f0f65f86$var$IncrementalSource.Scroll:
                    case $c7a0a995f0f65f86$var$IncrementalSource.CanvasMutation:
                    case $c7a0a995f0f65f86$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        return e;
                    case $c7a0a995f0f65f86$var$IncrementalSource.StyleSheetRule:
                    case $c7a0a995f0f65f86$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleId"
                        ]);
                        return e;
                    case $c7a0a995f0f65f86$var$IncrementalSource.Font:
                        return e;
                    case $c7a0a995f0f65f86$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e;
                    case $c7a0a995f0f65f86$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleIds"
                        ]);
                        $c7a0a995f0f65f86$var$_optionalChain$1([
                            e,
                            "access",
                            (_3)=>_3.data,
                            "access",
                            (_4)=>_4.styles,
                            "optionalAccess",
                            (_5)=>_5.forEach,
                            "call",
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        "styleId"
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $c7a0a995f0f65f86$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $c7a0a995f0f65f86$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $c7a0a995f0f65f86$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$c7a0a995f0f65f86$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        const observer = $c7a0a995f0f65f86$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($c7a0a995f0f65f86$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        setTimeout(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($c7a0a995f0f65f86$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($c7a0a995f0f65f86$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $c7a0a995f0f65f86$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
}
class $c7a0a995f0f65f86$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
}
class $c7a0a995f0f65f86$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $c7a0a995f0f65f86$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $c7a0a995f0f65f86$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $c7a0a995f0f65f86$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        $c7a0a995f0f65f86$var$onRequestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}
function $c7a0a995f0f65f86$var$wrapEvent(e) {
    const eWithTime = e;
    eWithTime.timestamp = $c7a0a995f0f65f86$var$nowTimestamp();
    return eWithTime;
}
let $c7a0a995f0f65f86$var$_takeFullSnapshot;
const $c7a0a995f0f65f86$var$mirror = $c7a0a995f0f65f86$var$createMirror();
function $c7a0a995f0f65f86$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $c7a0a995f0f65f86$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $c7a0a995f0f65f86$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $c7a0a995f0f65f86$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    const wrappedEmit = (e, isCheckout)=>{
        if ((0, $f04bc83cc42fe463$export$3cc482e6b02f32f7)([
            $c7a0a995f0f65f86$var$mutationBuffers,
            "access",
            (_)=>_[0],
            "optionalAccess",
            (_2)=>_2.isFrozen,
            "call",
            (_3)=>_3()
        ]) && e.type !== $c7a0a995f0f65f86$var$EventType.FullSnapshot && !(e.type === $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot && e.data.source === $c7a0a995f0f65f86$var$IncrementalSource.Mutation)) $c7a0a995f0f65f86$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $f04bc83cc42fe463$export$3cc482e6b02f32f7)([
            emit,
            "optionalCall",
            (_4)=>_4(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e.type === $c7a0a995f0f65f86$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $c7a0a995f0f65f86$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
            type: $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot,
            data: {
                source: $c7a0a995f0f65f86$var$IncrementalSource.Mutation,
                ...m
            }
        }));
    };
    const wrappedScrollEmit = (p)=>wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
            type: $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot,
            data: {
                source: $c7a0a995f0f65f86$var$IncrementalSource.Scroll,
                ...p
            }
        }));
    const wrappedCanvasMutationEmit = (p)=>wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
            type: $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot,
            data: {
                source: $c7a0a995f0f65f86$var$IncrementalSource.CanvasMutation,
                ...p
            }
        }));
    const wrappedAdoptedStyleSheetEmit = (a)=>wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
            type: $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot,
            data: {
                source: $c7a0a995f0f65f86$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        }));
    const stylesheetManager = new $c7a0a995f0f65f86$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $c7a0a995f0f65f86$var$IframeManagerNoop() : new $c7a0a995f0f65f86$var$IframeManager({
        mirror: $c7a0a995f0f65f86$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $c7a0a995f0f65f86$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $c7a0a995f0f65f86$var$ProcessedNodeManager();
    const canvasManager = $c7a0a995f0f65f86$var$_getCanvasManager(getCanvasManager, {
        mirror: $c7a0a995f0f65f86$var$mirror,
        win: window,
        mutationCb: (p)=>wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
                type: $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot,
                data: {
                    source: $c7a0a995f0f65f86$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            })),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $c7a0a995f0f65f86$var$ShadowDomManagerNoop() : new $c7a0a995f0f65f86$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $c7a0a995f0f65f86$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
            type: $c7a0a995f0f65f86$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $c7a0a995f0f65f86$var$getWindowWidth(),
                height: $c7a0a995f0f65f86$var$getWindowHeight()
            }
        }), isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $c7a0a995f0f65f86$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $c7a0a995f0f65f86$var$snapshot(document, {
            mirror: $c7a0a995f0f65f86$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($c7a0a995f0f65f86$var$isSerializedIframe(n, $c7a0a995f0f65f86$var$mirror)) iframeManager.addIframe(n);
                if ($c7a0a995f0f65f86$var$isSerializedStylesheet(n, $c7a0a995f0f65f86$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($c7a0a995f0f65f86$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
            type: $c7a0a995f0f65f86$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $c7a0a995f0f65f86$var$getWindowScroll(window)
            }
        }));
        $c7a0a995f0f65f86$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $c7a0a995f0f65f86$var$mirror.getId(document));
    };
    $c7a0a995f0f65f86$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $c7a0a995f0f65f86$var$callbackWrapper($c7a0a995f0f65f86$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
                        type: $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    })),
                mouseInteractionCb: (d)=>wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
                        type: $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c7a0a995f0f65f86$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    })),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
                        type: $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c7a0a995f0f65f86$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    })),
                inputCb: (v)=>wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
                        type: $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c7a0a995f0f65f86$var$IncrementalSource.Input,
                            ...v
                        }
                    })),
                mediaInteractionCb: (p)=>wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
                        type: $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c7a0a995f0f65f86$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    })),
                styleSheetRuleCb: (r)=>wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
                        type: $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c7a0a995f0f65f86$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    })),
                styleDeclarationCb: (r)=>wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
                        type: $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c7a0a995f0f65f86$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    })),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
                        type: $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c7a0a995f0f65f86$var$IncrementalSource.Font,
                            ...p
                        }
                    })),
                selectionCb: (p)=>{
                    wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
                        type: $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c7a0a995f0f65f86$var$IncrementalSource.Selection,
                            ...p
                        }
                    }));
                },
                customElementCb: (c)=>{
                    wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
                        type: $c7a0a995f0f65f86$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $c7a0a995f0f65f86$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    }));
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $c7a0a995f0f65f86$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $f04bc83cc42fe463$export$3cc482e6b02f32f7)([
                    plugins,
                    "optionalAccess",
                    (_5)=>_5.filter,
                    "call",
                    (_6)=>_6((p)=>p.observer),
                    "optionalAccess",
                    (_7)=>_7.map,
                    "call",
                    (_8)=>_8((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
                                        type: $c7a0a995f0f65f86$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    }))
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($c7a0a995f0f65f86$var$on("DOMContentLoaded", ()=>{
                wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
                    type: $c7a0a995f0f65f86$var$EventType.DomContentLoaded,
                    data: {}
                }));
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($c7a0a995f0f65f86$var$on("load", ()=>{
                wrappedEmit($c7a0a995f0f65f86$var$wrapEvent({
                    type: $c7a0a995f0f65f86$var$EventType.Load,
                    data: {}
                }));
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $c7a0a995f0f65f86$var$_takeFullSnapshot = undefined;
            $c7a0a995f0f65f86$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $c7a0a995f0f65f86$var$takeFullSnapshot(isCheckout) {
    if (!$c7a0a995f0f65f86$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $c7a0a995f0f65f86$var$_takeFullSnapshot(isCheckout);
}
$c7a0a995f0f65f86$var$record.mirror = $c7a0a995f0f65f86$var$mirror;
$c7a0a995f0f65f86$var$record.takeFullSnapshot = $c7a0a995f0f65f86$var$takeFullSnapshot;
function $c7a0a995f0f65f86$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $c7a0a995f0f65f86$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn("Unable to initialize CanvasManager");
        return new $c7a0a995f0f65f86$var$CanvasManagerNoop();
    }
}
const $c7a0a995f0f65f86$var$ReplayEventTypeIncrementalSnapshot = 3;
const $c7a0a995f0f65f86$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $c7a0a995f0f65f86$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $c7a0a995f0f65f86$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $c7a0a995f0f65f86$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $c7a0a995f0f65f86$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $5356bc1441432547$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === "console";
    });
}
const $c7a0a995f0f65f86$var$INTERACTIVE_SELECTOR = "button,a";
/** Get the closest interactive parent element, or else return the given element. */ function $c7a0a995f0f65f86$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($c7a0a995f0f65f86$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $c7a0a995f0f65f86$var$getClickTargetNode(event) {
    const target = $c7a0a995f0f65f86$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $c7a0a995f0f65f86$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $c7a0a995f0f65f86$var$getTargetNode(event) {
    if ($c7a0a995f0f65f86$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $c7a0a995f0f65f86$var$isEventWithTarget(event) {
    return typeof event === "object" && !!event && "target" in event;
}
let $c7a0a995f0f65f86$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $c7a0a995f0f65f86$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$c7a0a995f0f65f86$var$handlers) {
        $c7a0a995f0f65f86$var$handlers = [];
        $c7a0a995f0f65f86$var$monkeyPatchWindowOpen();
    }
    $c7a0a995f0f65f86$var$handlers.push(cb);
    return ()=>{
        const pos = $c7a0a995f0f65f86$var$handlers ? $c7a0a995f0f65f86$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $c7a0a995f0f65f86$var$handlers.splice(pos, 1);
    };
}
function $c7a0a995f0f65f86$var$monkeyPatchWindowOpen() {
    (0, $2486f7fb3095088f$export$9563e054e6f787fb)($c7a0a995f0f65f86$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($c7a0a995f0f65f86$var$handlers) try {
                $c7a0a995f0f65f86$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($c7a0a995f0f65f86$var$WINDOW, args);
        };
    });
}
/** Handle a click. */ function $c7a0a995f0f65f86$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $c7a0a995f0f65f86$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $c7a0a995f0f65f86$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $c7a0a995f0f65f86$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $c7a0a995f0f65f86$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($c7a0a995f0f65f86$var$ignoreElement(node, this._ignoreSelector) || !$c7a0a995f0f65f86$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $c7a0a995f0f65f86$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $c7a0a995f0f65f86$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $c7a0a995f0f65f86$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $c7a0a995f0f65f86$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $c7a0a995f0f65f86$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $c7a0a995f0f65f86$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $c7a0a995f0f65f86$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = setTimeout(()=>this._checkClicks(), 1000);
    }
}
const $c7a0a995f0f65f86$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
/** exported for tests only */ function $c7a0a995f0f65f86$var$ignoreElement(node, ignoreSelector) {
    if (!$c7a0a995f0f65f86$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $c7a0a995f0f65f86$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $c7a0a995f0f65f86$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $c7a0a995f0f65f86$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$c7a0a995f0f65f86$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if (source === $c7a0a995f0f65f86$var$IncrementalSource.Mutation) clickDetector.registerMutation(event.timestamp);
        if (source === $c7a0a995f0f65f86$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($c7a0a995f0f65f86$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $c7a0a995f0f65f86$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $c7a0a995f0f65f86$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $c7a0a995f0f65f86$var$isIncrementalEvent(event) {
    return event.type === $c7a0a995f0f65f86$var$ReplayEventTypeIncrementalSnapshot;
}
function $c7a0a995f0f65f86$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $c7a0a995f0f65f86$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $c7a0a995f0f65f86$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: "default",
        ...breadcrumb
    };
}
var $c7a0a995f0f65f86$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($c7a0a995f0f65f86$var$NodeType || ($c7a0a995f0f65f86$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $c7a0a995f0f65f86$var$ATTRIBUTES_TO_RECORD = new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $c7a0a995f0f65f86$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($c7a0a995f0f65f86$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $c7a0a995f0f65f86$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $c7a0a995f0f65f86$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $c7a0a995f0f65f86$var$handleClick(replay.clickDetector, result, $c7a0a995f0f65f86$var$getClickTargetNode(handlerData.event));
        $c7a0a995f0f65f86$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $c7a0a995f0f65f86$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $c7a0a995f0f65f86$var$record.mirror.getId(target);
    const node = nodeId && $c7a0a995f0f65f86$var$record.mirror.getNode(nodeId);
    const meta = node && $c7a0a995f0f65f86$var$record.mirror.getMeta(node);
    const element = meta && $c7a0a995f0f65f86$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $c7a0a995f0f65f86$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(""),
                attributes: $c7a0a995f0f65f86$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $c7a0a995f0f65f86$var$handleDom(handlerData) {
    const { target: target, message: message } = $c7a0a995f0f65f86$var$getDomTarget(handlerData);
    return $c7a0a995f0f65f86$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$c7a0a995f0f65f86$var$getBaseDomBreadcrumb(target, message)
    });
}
function $c7a0a995f0f65f86$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $c7a0a995f0f65f86$var$getClickTargetNode(handlerData.event) : $c7a0a995f0f65f86$var$getTargetNode(handlerData.event);
        message = (0, $e15b4fbcaae97cb7$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch (e) {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $c7a0a995f0f65f86$var$isElement(node) {
    return node.type === $c7a0a995f0f65f86$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $c7a0a995f0f65f86$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $c7a0a995f0f65f86$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $c7a0a995f0f65f86$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $c7a0a995f0f65f86$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $c7a0a995f0f65f86$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $e15b4fbcaae97cb7$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $c7a0a995f0f65f86$var$getBaseDomBreadcrumb(target, message);
    return $c7a0a995f0f65f86$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $c7a0a995f0f65f86$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $c7a0a995f0f65f86$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $c7a0a995f0f65f86$var$createResourceEntry,
    paint: $c7a0a995f0f65f86$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $c7a0a995f0f65f86$var$createNavigationEntry
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $c7a0a995f0f65f86$var$createPerformanceEntries(entries) {
    return entries.map($c7a0a995f0f65f86$var$createPerformanceEntry).filter(Boolean);
}
function $c7a0a995f0f65f86$var$createPerformanceEntry(entry) {
    if (!$c7a0a995f0f65f86$var$ENTRY_TYPES[entry.entryType]) return null;
    return $c7a0a995f0f65f86$var$ENTRY_TYPES[entry.entryType](entry);
}
function $c7a0a995f0f65f86$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $75b4984e5522b249$export$baf075a948ffc0bf) || $c7a0a995f0f65f86$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $c7a0a995f0f65f86$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $c7a0a995f0f65f86$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $c7a0a995f0f65f86$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $c7a0a995f0f65f86$var$getAbsoluteTime(startTime),
        end: $c7a0a995f0f65f86$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $c7a0a995f0f65f86$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $c7a0a995f0f65f86$var$getAbsoluteTime(startTime),
        end: $c7a0a995f0f65f86$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on an LCP metric.
 */ function $c7a0a995f0f65f86$var$getLargestContentfulPaint(metric) {
    const entries = metric.entries;
    const lastEntry = entries[entries.length - 1];
    const element = lastEntry ? lastEntry.element : undefined;
    const value = metric.value;
    const end = $c7a0a995f0f65f86$var$getAbsoluteTime(value);
    const data = {
        type: "largest-contentful-paint",
        name: "largest-contentful-paint",
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            nodeId: element ? $c7a0a995f0f65f86$var$record.mirror.getId(element) : undefined
        }
    };
    return data;
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $c7a0a995f0f65f86$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, $c0253c3b07cda670$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $c0253c3b07cda670$export$3fd4b53331200102)(({ metric: metric })=>{
        replay.replayPerformanceEntries.push($c7a0a995f0f65f86$var$getLargestContentfulPaint(metric));
    }));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $c7a0a995f0f65f86$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const $c7a0a995f0f65f86$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $c7a0a995f0f65f86$var$e() {
    const e = new Blob([
        $c7a0a995f0f65f86$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function $c7a0a995f0f65f86$var$logInfo(message, shouldAddBreadcrumb) {
    if (!$c7a0a995f0f65f86$var$DEBUG_BUILD) return;
    (0, $f78ca609428407bb$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) $c7a0a995f0f65f86$var$addLogBreadcrumb(message);
}
/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */ function $c7a0a995f0f65f86$var$logInfoNextTick(message, shouldAddBreadcrumb) {
    if (!$c7a0a995f0f65f86$var$DEBUG_BUILD) return;
    (0, $f78ca609428407bb$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    setTimeout(()=>{
        $c7a0a995f0f65f86$var$addLogBreadcrumb(message);
    }, 0);
}
function $c7a0a995f0f65f86$var$addLogBreadcrumb(message) {
    (0, $3b3c418f52d65472$export$efda9a273d7a036d)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: "info",
        message: message
    }, {
        level: "info"
    });
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $c7a0a995f0f65f86$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$c7a0a995f0f65f86$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $c7a0a995f0f65f86$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $c7a0a995f0f65f86$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $c7a0a995f0f65f86$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $c7a0a995f0f65f86$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $c7a0a995f0f65f86$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $c7a0a995f0f65f86$var$logInfo("[Replay] Destroying compression worker");
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener("message", listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).error("[Replay]", response.response);
                    reject(new Error("Error in compression worker"));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener("message", listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $c7a0a995f0f65f86$var$EventBufferCompressionWorker {
    /** @inheritdoc */ constructor(worker){
        this._worker = new $c7a0a995f0f65f86$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $c7a0a995f0f65f86$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $c7a0a995f0f65f86$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $c7a0a995f0f65f86$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage("clear").then(null, (e)=>{
            $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn('[Replay] Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $c7a0a995f0f65f86$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $c7a0a995f0f65f86$var$EventBufferArray();
        this._compression = new $c7a0a995f0f65f86$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $c7a0a995f0f65f86$var$logInfo("[Replay] Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("[Replay] Failed to add events when switching buffers.", error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $c7a0a995f0f65f86$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $c7a0a995f0f65f86$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $c7a0a995f0f65f86$var$logInfo("[Replay] Using simple buffer");
    return new $c7a0a995f0f65f86$var$EventBufferArray();
}
function $c7a0a995f0f65f86$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $c7a0a995f0f65f86$var$_getWorkerUrl();
        if (!workerUrl) return;
        $c7a0a995f0f65f86$var$logInfo(`[Replay] Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new $c7a0a995f0f65f86$var$EventBufferProxy(worker);
    } catch (error) {
        $c7a0a995f0f65f86$var$logInfo("[Replay] Failed to create compression worker");
    // Fall back to use simple event buffer array
    }
}
function $c7a0a995f0f65f86$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $c7a0a995f0f65f86$var$e();
    return "";
}
/** If sessionStorage is available. */ function $c7a0a995f0f65f86$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return "sessionStorage" in $c7a0a995f0f65f86$var$WINDOW && !!$c7a0a995f0f65f86$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $c7a0a995f0f65f86$var$clearSession(replay) {
    $c7a0a995f0f65f86$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $c7a0a995f0f65f86$var$deleteSession() {
    if (!$c7a0a995f0f65f86$var$hasSessionStorage()) return;
    try {
        $c7a0a995f0f65f86$var$WINDOW.sessionStorage.removeItem($c7a0a995f0f65f86$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $c7a0a995f0f65f86$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $c7a0a995f0f65f86$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $0abc5e6206c3ae86$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $c7a0a995f0f65f86$var$saveSession(session) {
    if (!$c7a0a995f0f65f86$var$hasSessionStorage()) return;
    try {
        $c7a0a995f0f65f86$var$WINDOW.sessionStorage.setItem($c7a0a995f0f65f86$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $c7a0a995f0f65f86$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $c7a0a995f0f65f86$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $c7a0a995f0f65f86$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $c7a0a995f0f65f86$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $c7a0a995f0f65f86$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $c7a0a995f0f65f86$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $c7a0a995f0f65f86$var$fetchSession(traceInternals) {
    if (!$c7a0a995f0f65f86$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $c7a0a995f0f65f86$var$WINDOW.sessionStorage.getItem($c7a0a995f0f65f86$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $c7a0a995f0f65f86$var$logInfoNextTick("[Replay] Loading existing session", traceInternals);
        return $c7a0a995f0f65f86$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $c7a0a995f0f65f86$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $c7a0a995f0f65f86$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $c7a0a995f0f65f86$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $c7a0a995f0f65f86$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $c7a0a995f0f65f86$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$c7a0a995f0f65f86$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $c7a0a995f0f65f86$var$loadOrCreateSession({ traceInternals: traceInternals, sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $c7a0a995f0f65f86$var$fetchSession(traceInternals);
    // No session exists yet, just create a new one
    if (!existingSession) {
        $c7a0a995f0f65f86$var$logInfoNextTick("[Replay] Creating new session", traceInternals);
        return $c7a0a995f0f65f86$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$c7a0a995f0f65f86$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $c7a0a995f0f65f86$var$logInfoNextTick("[Replay] Session in sessionStorage is expired, creating new one...");
    return $c7a0a995f0f65f86$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $c7a0a995f0f65f86$var$isCustomEvent(event) {
    return event.type === $c7a0a995f0f65f86$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $c7a0a995f0f65f86$var$addEventSync(replay, event, isCheckout) {
    if (!$c7a0a995f0f65f86$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $c7a0a995f0f65f86$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $c7a0a995f0f65f86$var$addEvent(replay, event, isCheckout) {
    if (!$c7a0a995f0f65f86$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $c7a0a995f0f65f86$var$_addEvent(replay, event, isCheckout);
}
async function $c7a0a995f0f65f86$var$_addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === "buffer") replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $c7a0a995f0f65f86$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $c7a0a995f0f65f86$var$EventBufferSizeExceededError ? "addEventSizeExceeded" : "addEvent";
        $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).error(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
        if (client) client.recordDroppedEvent("internal_sdk_error", "replay");
    }
}
/** Exported only for tests. */ function $c7a0a995f0f65f86$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $c7a0a995f0f65f86$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $c7a0a995f0f65f86$var$logInfo(`[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`, replay.getOptions()._experiments.traceInternals);
        return false;
    }
    return true;
}
function $c7a0a995f0f65f86$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $c7a0a995f0f65f86$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).error("[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...", error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function $c7a0a995f0f65f86$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $c7a0a995f0f65f86$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/** If the event is an replay event */ function $c7a0a995f0f65f86$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
/** If the event is a feedback event */ function $c7a0a995f0f65f86$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $c7a0a995f0f65f86$var$handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    const enforceStatusCode = $c7a0a995f0f65f86$var$isBaseTransportSend();
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$c7a0a995f0f65f86$var$isErrorEvent(event) && !$c7a0a995f0f65f86$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        if ($c7a0a995f0f65f86$var$isTransactionEvent(event)) {
            $c7a0a995f0f65f86$var$handleTransactionEvent(replay, event);
            return;
        }
        $c7a0a995f0f65f86$var$handleErrorEvent(replay, event);
    };
}
function $c7a0a995f0f65f86$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $c7a0a995f0f65f86$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== "buffer" || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    setTimeout(()=>{
        // Capture current event buffer as new replay
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.sendBufferedReplayOrFlush();
    });
}
function $c7a0a995f0f65f86$var$isBaseTransportSend() {
    const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
    if (!client) return false;
    const transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $c7a0a995f0f65f86$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$c7a0a995f0f65f86$var$isErrorEvent(event)) return;
        $c7a0a995f0f65f86$var$handleHydrationError(replay, event);
    };
}
function $c7a0a995f0f65f86$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0].value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $c7a0a995f0f65f86$var$createBreadcrumb({
            category: "replay.hydrate-error"
        });
        $c7a0a995f0f65f86$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $c7a0a995f0f65f86$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $c7a0a995f0f65f86$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $c7a0a995f0f65f86$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $c7a0a995f0f65f86$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $c7a0a995f0f65f86$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $c7a0a995f0f65f86$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $c7a0a995f0f65f86$var$handleGlobalEventListener(replay, includeAfterSendEventHandling = false) {
    const afterSendHandler = includeAfterSendEventHandling ? $c7a0a995f0f65f86$var$handleAfterSendEvent(replay) : undefined;
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if ($c7a0a995f0f65f86$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$c7a0a995f0f65f86$var$isErrorEvent(event) && !$c7a0a995f0f65f86$var$isTransactionEvent(event) && !$c7a0a995f0f65f86$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if ($c7a0a995f0f65f86$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $c7a0a995f0f65f86$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($c7a0a995f0f65f86$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).log("[Replay] Ignoring error from rrweb internals", event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $c7a0a995f0f65f86$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    }, {
        id: "Replay"
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $c7a0a995f0f65f86$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $c7a0a995f0f65f86$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $c7a0a995f0f65f86$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $c7a0a995f0f65f86$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $c7a0a995f0f65f86$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $c7a0a995f0f65f86$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $c7a0a995f0f65f86$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($c7a0a995f0f65f86$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $6e5f9e0a44d73be3$export$d92e61f5600202af)(url, (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)());
}
/** Add a performance entry breadcrumb */ function $c7a0a995f0f65f86$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($c7a0a995f0f65f86$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $c7a0a995f0f65f86$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function $c7a0a995f0f65f86$var$handleFetch(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, fetchData: fetchData, response: response } = handlerData;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url } = fetchData;
    return {
        type: "resource.fetch",
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: response ? response.status : undefined
        }
    };
}
/**
 * Returns a listener to be added to `addFetchInstrumentationHandler(listener)`.
 */ function $c7a0a995f0f65f86$var$handleFetchSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $c7a0a995f0f65f86$var$handleFetch(handlerData);
        $c7a0a995f0f65f86$var$addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function $c7a0a995f0f65f86$var$handleXhr(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, xhr: xhr } = handlerData;
    const sentryXhrData = xhr[0, $3c4b84232c65ad9a$export$55b6bb1e45c6cf59];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url, status_code: statusCode } = sentryXhrData;
    if (url === undefined) return null;
    return {
        type: "resource.xhr",
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method: method,
            statusCode: statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addXhrInstrumentationHandler(listener)`.
 */ function $c7a0a995f0f65f86$var$handleXhrSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $c7a0a995f0f65f86$var$handleXhr(handlerData);
        $c7a0a995f0f65f86$var$addNetworkBreadcrumb(replay, result);
    };
}
/** Get the size of a body. */ function $c7a0a995f0f65f86$var$getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $c7a0a995f0f65f86$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $c7a0a995f0f65f86$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $c7a0a995f0f65f86$var$getBodyString(body) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $c7a0a995f0f65f86$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
/** Merge a warning into an existing network request/response. */ function $c7a0a995f0f65f86$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $c7a0a995f0f65f86$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $2486f7fb3095088f$export$d25f2688db1bb433)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $c7a0a995f0f65f86$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $c7a0a995f0f65f86$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $c7a0a995f0f65f86$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $c7a0a995f0f65f86$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $c7a0a995f0f65f86$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $c7a0a995f0f65f86$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    const exceedsSizeLimit = body.length > $c7a0a995f0f65f86$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $c7a0a995f0f65f86$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $c7a0a995f0f65f86$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e3) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $c7a0a995f0f65f86$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === "[" && last === "]" || first === "{" && last === "}";
}
/** Match an URL against a list of strings/Regex. */ function $c7a0a995f0f65f86$var$urlMatches(url, urls) {
    const fullUrl = $c7a0a995f0f65f86$var$getFullUrl(url);
    return (0, $d43244d0c656442a$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $c7a0a995f0f65f86$var$getFullUrl(url, baseURI = $c7a0a995f0f65f86$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($c7a0a995f0f65f86$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $c7a0a995f0f65f86$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $c7a0a995f0f65f86$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $c7a0a995f0f65f86$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $c7a0a995f0f65f86$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).error("[Replay] Failed to capture fetch breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $c7a0a995f0f65f86$var$enrichFetchBreadcrumb(breadcrumb, hint, options) {
    const { input: input, response: response } = hint;
    const body = input ? $c7a0a995f0f65f86$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $c7a0a995f0f65f86$var$getBodySize(body, options.textEncoder);
    const resSize = response ? $c7a0a995f0f65f86$var$parseContentLengthHeader(response.headers.get("content-length")) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $c7a0a995f0f65f86$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $c7a0a995f0f65f86$var$urlMatches(url, options.networkDetailAllowUrls) && !$c7a0a995f0f65f86$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $c7a0a995f0f65f86$var$_getRequestInfo(options, hint.input, requestBodySize) : $c7a0a995f0f65f86$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $c7a0a995f0f65f86$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $c7a0a995f0f65f86$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $c7a0a995f0f65f86$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $c7a0a995f0f65f86$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $c7a0a995f0f65f86$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $c7a0a995f0f65f86$var$getBodyString(requestBody);
    const data = $c7a0a995f0f65f86$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $c7a0a995f0f65f86$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $c7a0a995f0f65f86$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $c7a0a995f0f65f86$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $c7a0a995f0f65f86$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $c7a0a995f0f65f86$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $c7a0a995f0f65f86$var$_parseFetchResponseBody(response);
    const result = $c7a0a995f0f65f86$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        textEncoder: textEncoder,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $c7a0a995f0f65f86$var$mergeWarning(result, warning);
    return result;
}
function $c7a0a995f0f65f86$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $c7a0a995f0f65f86$var$getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return $c7a0a995f0f65f86$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $c7a0a995f0f65f86$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $c7a0a995f0f65f86$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("[Replay] Failed to serialize response body", error);
        // fallback
        return $c7a0a995f0f65f86$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $c7a0a995f0f65f86$var$_parseFetchResponseBody(response) {
    const res = $c7a0a995f0f65f86$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await $c7a0a995f0f65f86$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("[Replay] Failed to get text body from response", error);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
}
function $c7a0a995f0f65f86$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== "object") return undefined;
    return fetchArgs[1].body;
}
function $c7a0a995f0f65f86$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $c7a0a995f0f65f86$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $c7a0a995f0f65f86$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $c7a0a995f0f65f86$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $c7a0a995f0f65f86$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $c7a0a995f0f65f86$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $c7a0a995f0f65f86$var$getAllowedHeaders(headers, allowedHeaders);
}
function $c7a0a995f0f65f86$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("[Replay] Failed to clone response body", error);
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $c7a0a995f0f65f86$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = setTimeout(()=>reject(new Error("Timeout while trying to read response body")), 500);
        $c7a0a995f0f65f86$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $c7a0a995f0f65f86$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $c7a0a995f0f65f86$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $c7a0a995f0f65f86$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $c7a0a995f0f65f86$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $c7a0a995f0f65f86$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).error("[Replay] Failed to capture xhr breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $c7a0a995f0f65f86$var$enrichXhrBreadcrumb(breadcrumb, hint, options) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $c7a0a995f0f65f86$var$getBodySize(input, options.textEncoder);
    const resSize = xhr.getResponseHeader("content-length") ? $c7a0a995f0f65f86$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $c7a0a995f0f65f86$var$_getBodySize(xhr.response, xhr.responseType, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $c7a0a995f0f65f86$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$c7a0a995f0f65f86$var$urlMatches(url, options.networkDetailAllowUrls) || $c7a0a995f0f65f86$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $c7a0a995f0f65f86$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $c7a0a995f0f65f86$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $3c4b84232c65ad9a$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $c7a0a995f0f65f86$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $c7a0a995f0f65f86$var$getAllowedHeaders($c7a0a995f0f65f86$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $c7a0a995f0f65f86$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $c7a0a995f0f65f86$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $c7a0a995f0f65f86$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $c7a0a995f0f65f86$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $c7a0a995f0f65f86$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $c7a0a995f0f65f86$var$mergeWarning(response, responseWarning) : response
    };
}
function $c7a0a995f0f65f86$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $c7a0a995f0f65f86$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $c7a0a995f0f65f86$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("[Replay] Failed to get xhr response body", ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $c7a0a995f0f65f86$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && body && typeof body === "object") return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $c7a0a995f0f65f86$var$_getBodySize(body, responseType, textEncoder) {
    try {
        const bodyStr = responseType === "json" && body && typeof body === "object" ? JSON.stringify(body) : body;
        return $c7a0a995f0f65f86$var$getBodySize(bodyStr, textEncoder);
    } catch (e3) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $c7a0a995f0f65f86$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
    try {
        const textEncoder = new TextEncoder();
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            textEncoder: textEncoder,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client && client.on) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$c7a0a995f0f65f86$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
        else {
            // Fallback behavior
            (0, $5adf1dbc05c20562$export$f75d3c772c923df0)($c7a0a995f0f65f86$var$handleFetchSpanListener(replay));
            (0, $3c4b84232c65ad9a$export$26ace48dd54c9aea)($c7a0a995f0f65f86$var$handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $c7a0a995f0f65f86$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($c7a0a995f0f65f86$var$_isXhrBreadcrumb(breadcrumb) && $c7a0a995f0f65f86$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $c7a0a995f0f65f86$var$enrichXhrBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $c7a0a995f0f65f86$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($c7a0a995f0f65f86$var$_isFetchBreadcrumb(breadcrumb) && $c7a0a995f0f65f86$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $c7a0a995f0f65f86$var$enrichFetchBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $c7a0a995f0f65f86$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("Error when enriching network breadcrumb");
    }
}
function $c7a0a995f0f65f86$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $c7a0a995f0f65f86$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $c7a0a995f0f65f86$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $c7a0a995f0f65f86$var$_isFetchHint(hint) {
    return hint && hint.response;
}
let $c7a0a995f0f65f86$var$_LAST_BREADCRUMB = null;
function $c7a0a995f0f65f86$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
const $c7a0a995f0f65f86$var$handleScopeListener = (replay)=>(scope)=>{
        if (!replay.isEnabled()) return;
        const result = $c7a0a995f0f65f86$var$handleScope(scope);
        if (!result) return;
        $c7a0a995f0f65f86$var$addBreadcrumbEvent(replay, result);
    };
/**
 * An event handler to handle scope changes.
 */ function $c7a0a995f0f65f86$var$handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if ($c7a0a995f0f65f86$var$_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    $c7a0a995f0f65f86$var$_LAST_BREADCRUMB = newBreadcrumb;
    if (!$c7a0a995f0f65f86$var$isBreadcrumbWithCategory(newBreadcrumb) || [
        "fetch",
        "xhr",
        "sentry.event",
        "sentry.transaction"
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith("ui.")) return null;
    if (newBreadcrumb.category === "console") return $c7a0a995f0f65f86$var$normalizeConsoleBreadcrumb(newBreadcrumb);
    return $c7a0a995f0f65f86$var$createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function $c7a0a995f0f65f86$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $c7a0a995f0f65f86$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $c7a0a995f0f65f86$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $c7a0a995f0f65f86$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $5356bc1441432547$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $c7a0a995f0f65f86$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $c7a0a995f0f65f86$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $c7a0a995f0f65f86$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
/**
 * Add global listeners that cannot be removed.
 */ function $c7a0a995f0f65f86$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const scope = (0, $3b3c418f52d65472$export$c7be4b0125a10cba)();
    const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
    scope.addScopeListener($c7a0a995f0f65f86$var$handleScopeListener(replay));
    (0, $b2d47dbe7e2ec34d$export$5aeffd3db2cf9df7)($c7a0a995f0f65f86$var$handleDomListener(replay));
    (0, $2c6eb7f56917cfd8$export$3f18c56c58114e75)($c7a0a995f0f65f86$var$handleHistorySpanListener(replay));
    $c7a0a995f0f65f86$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $c7a0a995f0f65f86$var$handleGlobalEventListener(replay, !$c7a0a995f0f65f86$var$hasHooks(client));
    if (client && client.addEventProcessor) client.addEventProcessor(eventProcessor);
    else (0, $2315f9f5121a434b$export$9aac0b9f77928fbf)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if ($c7a0a995f0f65f86$var$hasHooks(client)) {
        client.on("beforeSendEvent", $c7a0a995f0f65f86$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $c7a0a995f0f65f86$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("startTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We may be missing the initial startTransaction due to timing issues,
        // so we capture it on finish again.
        client.on("finishTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We want to flush replay
        client.on("beforeSendFeedback", (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c7a0a995f0f65f86$var$hasHooks(client) {
    return !!(client && client.on);
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $c7a0a995f0f65f86$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($c7a0a995f0f65f86$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $c7a0a995f0f65f86$var$createMemoryEntry($c7a0a995f0f65f86$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $c7a0a995f0f65f86$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $c7a0a995f0f65f86$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $c7a0a995f0f65f86$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("[Replay] Received replay event after session expired.");
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $c7a0a995f0f65f86$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$c7a0a995f0f65f86$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $c7a0a995f0f65f86$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === "buffer" && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $c7a0a995f0f65f86$var$logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $c7a0a995f0f65f86$var$saveSession(replay.session);
                }
            }
            if (replay.recordingMode === "session") // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $c7a0a995f0f65f86$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $c7a0a995f0f65f86$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $c7a0a995f0f65f86$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $c7a0a995f0f65f86$var$addEventSync(replay, $c7a0a995f0f65f86$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $c7a0a995f0f65f86$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $32ccdd6e4b62c3ba$export$f93f7f385160c44e)((0, $32ccdd6e4b62c3ba$export$92b6093782fe661b)(replayEvent, (0, $32ccdd6e4b62c3ba$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $c7a0a995f0f65f86$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $c7a0a995f0f65f86$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === "object" && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    if (client.emit) client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $b7d389fd659a89c0$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $19e624db95e0b5b5$export$68f3af03034c9e90)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata && client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0"
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $c7a0a995f0f65f86$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $c7a0a995f0f65f86$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
    const scope = (0, $3b3c418f52d65472$export$c7be4b0125a10cba)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return;
    const baseEvent = {
        type: $c7a0a995f0f65f86$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $c7a0a995f0f65f86$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "replay", baseEvent);
        $c7a0a995f0f65f86$var$logInfo("An event processor returned `null`, will not send event.");
        return;
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $c7a0a995f0f65f86$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($c7a0a995f0f65f86$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) return response;
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $c7a0a995f0f65f86$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $dffb3afb92449f1c$export$699aff705e0d49d4)({}, response);
    if ((0, $dffb3afb92449f1c$export$6c91fec22056810a)(rateLimits, "replay")) throw new $c7a0a995f0f65f86$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $c7a0a995f0f65f86$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $c7a0a995f0f65f86$var$RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $c7a0a995f0f65f86$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $c7a0a995f0f65f86$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, options: options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $c7a0a995f0f65f86$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $c7a0a995f0f65f86$var$TransportStatusCodeError || err instanceof $c7a0a995f0f65f86$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $3b3c418f52d65472$export$2f04de43fe27971a)("Replays", {
            _retryCount: retryConfig.count
        });
        if ($c7a0a995f0f65f86$var$DEBUG_BUILD && options._experiments && options._experiments.captureExceptions) (0, $3b3c418f52d65472$export$f5282963edea4a68)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $c7a0a995f0f65f86$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$c7a0a995f0f65f86$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await $c7a0a995f0f65f86$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $c7a0a995f0f65f86$var$THROTTLED = "__THROTTLED";
const $c7a0a995f0f65f86$var$SKIPPED = "__SKIPPED";
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c7a0a995f0f65f86$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $c7a0a995f0f65f86$var$SKIPPED : $c7a0a995f0f65f86$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $c7a0a995f0f65f86$var$ReplayContainer {
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $c7a0a995f0f65f86$var$ReplayContainer.prototype.__init.call(this);
        $c7a0a995f0f65f86$var$ReplayContainer.prototype.__init2.call(this);
        $c7a0a995f0f65f86$var$ReplayContainer.prototype.__init3.call(this);
        $c7a0a995f0f65f86$var$ReplayContainer.prototype.__init4.call(this);
        $c7a0a995f0f65f86$var$ReplayContainer.prototype.__init5.call(this);
        $c7a0a995f0f65f86$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $c7a0a995f0f65f86$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $c7a0a995f0f65f86$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $c7a0a995f0f65f86$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $c7a0a995f0f65f86$var$throttle((event, isCheckout)=>$c7a0a995f0f65f86$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($c7a0a995f0f65f86$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $c7a0a995f0f65f86$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $c7a0a995f0f65f86$var$ClickDetector(this, slowClickConfig);
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $c7a0a995f0f65f86$var$logInfoNextTick(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") throw new Error("Replay recording is already in progress");
        if (this._isEnabled && this.recordingMode === "buffer") throw new Error("Replay buffering is in progress, call `flush()` to save the replay");
        $c7a0a995f0f65f86$var$logInfoNextTick("[Replay] Starting replay in session mode", this._options._experiments.traceInternals);
        const session = $c7a0a995f0f65f86$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error("Replay recording is already in progress");
        $c7a0a995f0f65f86$var$logInfoNextTick("[Replay] Starting replay in buffer mode", this._options._experiments.traceInternals);
        const session = $c7a0a995f0f65f86$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $c7a0a995f0f65f86$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" && {
                    checkoutEveryNms: $c7a0a995f0f65f86$var$BUFFER_CHECKOUT_TIME
                },
                emit: $c7a0a995f0f65f86$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $c7a0a995f0f65f86$var$logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ""}`, this._options._experiments.traceInternals);
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $c7a0a995f0f65f86$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $c7a0a995f0f65f86$var$logInfo("[Replay] Pausing replay", this._options._experiments.traceInternals);
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $c7a0a995f0f65f86$var$logInfo("[Replay] Resuming replay", this._options._experiments.traceInternals);
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $c7a0a995f0f65f86$var$logInfo("[Replay] Converting buffer to session", this._options._experiments.traceInternals);
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === "session") return;
        // Re-start recording in session-mode
        this.recordingMode = "session";
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === "buffer") return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $c7a0a995f0f65f86$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$c7a0a995f0f65f86$var$WINDOW.location.pathname}${$c7a0a995f0f65f86$var$WINDOW.location.hash}${$c7a0a995f0f65f86$var$WINDOW.location.search}`;
        const url = `${$c7a0a995f0f65f86$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $c7a0a995f0f65f86$var$THROTTLED) {
            const breadcrumb = $c7a0a995f0f65f86$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$c7a0a995f0f65f86$var$addEventSync(this, {
                    type: $c7a0a995f0f65f86$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        // eslint-disable-next-line deprecation/deprecation
        const lastTransaction = this.lastTransaction || (0, $3b3c418f52d65472$export$c7be4b0125a10cba)().getTransaction();
        const attributes = lastTransaction && (0, $391854fa51155a6b$export$92d8c23565496537)(lastTransaction).data || {};
        const source = attributes[0, $a8f596f3c433b5b1$export$d7a7d984b0791405];
        if (!lastTransaction || !source || ![
            "route",
            "custom"
        ].includes(source)) return undefined;
        return (0, $391854fa51155a6b$export$92d8c23565496537)(lastTransaction).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $c7a0a995f0f65f86$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).error("[Replay]", error);
        if ($c7a0a995f0f65f86$var$DEBUG_BUILD && this._options._experiments && this._options._experiments.captureExceptions) (0, $3b3c418f52d65472$export$f5282963edea4a68)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $c7a0a995f0f65f86$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($c7a0a995f0f65f86$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "refresh session"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $c7a0a995f0f65f86$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $c7a0a995f0f65f86$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $c7a0a995f0f65f86$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $c7a0a995f0f65f86$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $c7a0a995f0f65f86$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        this._performanceCleanupCallback = $c7a0a995f0f65f86$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $c7a0a995f0f65f86$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $c7a0a995f0f65f86$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $c7a0a995f0f65f86$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $c7a0a995f0f65f86$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($c7a0a995f0f65f86$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $c7a0a995f0f65f86$var$createBreadcrumb({
                category: "ui.blur"
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $c7a0a995f0f65f86$var$createBreadcrumb({
                category: "ui.focus"
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $c7a0a995f0f65f86$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $c7a0a995f0f65f86$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $c7a0a995f0f65f86$var$logInfo("[Replay] Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $c7a0a995f0f65f86$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        const performanceEntries = $c7a0a995f0f65f86$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        return Promise.all($c7a0a995f0f65f86$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).error("[Replay] No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $c7a0a995f0f65f86$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accomodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error("Session is too long, not sending replay");
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $c7a0a995f0f65f86$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: timestamp
            });
        } catch (err) {
            this._handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: "sendReplay"
            });
            const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
            if (client) client.recordDroppedEvent("send_error", "replay");
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).error("[Replay] Attempting to finish replay event after session expired.");
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $c7a0a995f0f65f86$var$logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`, this._options._experiments.traceInternals);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $c7a0a995f0f65f86$var$logInfo("[Replay] Flushing initial segment without checkout.", this._options._experiments.traceInternals);
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = undefined;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                $c7a0a995f0f65f86$var$DEBUG_BUILD && (0, $f78ca609428407bb$export$af88d00dbe7f521).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $c7a0a995f0f65f86$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $c7a0a995f0f65f86$var$createBreadcrumb({
                    category: "replay.mutations",
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: "mutationLimit",
                    forceFlush: this.recordingMode === "session"
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $c7a0a995f0f65f86$var$getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    const deprecatedSelectors = typeof deprecatedSelectorOption === "string" ? deprecatedSelectorOption.split(",") : [];
    const allSelectors = [
        ...selectors,
        // @deprecated
        ...deprecatedSelectors,
        // sentry defaults
        ...defaultSelectors
    ];
    // @deprecated
    if (typeof deprecatedClassOption !== "undefined") {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === "string") allSelectors.push(`.${deprecatedClassOption}`);
        (0, $f78ca609428407bb$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.");
        });
    }
    return allSelectors.join(",");
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $c7a0a995f0f65f86$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore, blockClass: // eslint-disable-next-line deprecation/deprecation
blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
blockSelector, maskTextClass: // eslint-disable-next-line deprecation/deprecation
maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
ignoreClass }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $c7a0a995f0f65f86$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ], maskTextClass, maskTextSelector);
    const unmaskSelector = $c7a0a995f0f65f86$var$getOption(unmask, [
        ".sentry-unmask",
        "[data-sentry-unmask]"
    ]);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $c7a0a995f0f65f86$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ], blockClass, blockSelector),
        unblockSelector: $c7a0a995f0f65f86$var$getOption(unblock, [
            ".sentry-unblock",
            "[data-sentry-unblock]"
        ]),
        ignoreSelector: $c7a0a995f0f65f86$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $c7a0a995f0f65f86$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precendence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "")) return value.replace(/[\S]/g, "*");
    return value;
}
const $c7a0a995f0f65f86$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $c7a0a995f0f65f86$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
let $c7a0a995f0f65f86$var$_initialized = false;
const $c7a0a995f0f65f86$export$2832a2ae028f5e28 = (options)=>{
    // eslint-disable-next-line deprecation/deprecation
    return new $c7a0a995f0f65f86$export$6b59b88de1ff9cb7(options);
};
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 * @deprecated Use `replayIntegration()` instead.
 */ class $c7a0a995f0f65f86$export$6b59b88de1ff9cb7 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Replay";
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $c7a0a995f0f65f86$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $c7a0a995f0f65f86$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $c7a0a995f0f65f86$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $c7a0a995f0f65f86$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, sessionSampleRate: sessionSampleRate, errorSampleRate: errorSampleRate, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        "title",
        "placeholder"
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, blockClass: // eslint-disable-next-line deprecation/deprecation
    blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
    blockSelector, maskInputOptions: // eslint-disable-next-line deprecation/deprecation
    maskInputOptions, maskTextClass: // eslint-disable-next-line deprecation/deprecation
    maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
    maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
    ignoreClass } = {}){
        // eslint-disable-next-line deprecation/deprecation
        this.name = $c7a0a995f0f65f86$export$6b59b88de1ff9cb7.id;
        const privacyOptions = $c7a0a995f0f65f86$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            ignoreClass: ignoreClass
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                ...maskInputOptions || {},
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$c7a0a995f0f65f86$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $c7a0a995f0f65f86$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $c7a0a995f0f65f86$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            sessionSampleRate: sessionSampleRate,
            errorSampleRate: errorSampleRate,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $c7a0a995f0f65f86$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $c7a0a995f0f65f86$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            _experiments: _experiments
        };
        if (typeof sessionSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $c7a0a995f0f65f86$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$c7a0a995f0f65f86$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $2699263b96e8d034$export$4e09c449d6c407f7)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $c7a0a995f0f65f86$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $c7a0a995f0f65f86$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!(0, $2699263b96e8d034$export$4e09c449d6c407f7)()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === "session"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        // We have to run this in _initialize, because this runs in setTimeout
        // So when this runs all integrations have been added
        // Before this, we cannot access integrations on the client,
        // so we need to mutate the options here
        this._maybeLoadFromReplayCanvasIntegration();
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $c7a0a995f0f65f86$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $c7a0a995f0f65f86$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration() {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
$c7a0a995f0f65f86$export$6b59b88de1ff9cb7.__initStatic();
/** Parse Replay-related options from SDK options */ function $c7a0a995f0f65f86$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $2486f7fb3095088f$export$d25f2688db1bb433)(initialOptions)
    };
    if (!opt) {
        (0, $f78ca609428407bb$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("SDK client is not available.");
        });
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) (0, $f78ca609428407bb$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (typeof opt.replaysSessionSampleRate === "number") finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === "number") finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function $c7a0a995f0f65f86$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$c7a0a995f0f65f86$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ // eslint-disable-next-line deprecation/deprecation
function $c7a0a995f0f65f86$export$81cc0d0f72285d1() {
    const client = (0, $3b3c418f52d65472$export$6bb76d6eba7e258c)();
    return client && client.getIntegrationByName && client.getIntegrationByName("Replay");
}
// eslint-disable-next-line deprecation/deprecation
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $c7a0a995f0f65f86$export$b28310b2f161456b = $c7a0a995f0f65f86$export$81cc0d0f72285d1;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $c7a0a995f0f65f86$export$d7706faf7ab354bf = $c7a0a995f0f65f86$export$2832a2ae028f5e28;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ // eslint-disable-next-line deprecation/deprecation
class $c7a0a995f0f65f86$export$a35c789ed37ee0f7 extends $c7a0a995f0f65f86$export$6b59b88de1ff9cb7 {
}









let $c3b2f03131c29060$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
if ((0, $0c03304570a3d428$export$56d8a8a25bd48b81).Sentry && (0, $0c03304570a3d428$export$56d8a8a25bd48b81).Sentry.Integrations) $c3b2f03131c29060$var$windowIntegrations = (0, $0c03304570a3d428$export$56d8a8a25bd48b81).Sentry.Integrations;
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $c3b2f03131c29060$export$99d02219d259eb94 = {
    ...$c3b2f03131c29060$var$windowIntegrations,
    // eslint-disable-next-line deprecation/deprecation
    ...(0, $46763ee46f5e2adb$export$99d02219d259eb94),
    ...$837d3008f05e6417$exports
};





var $3HlGj = parcelRequire("3HlGj");

var $1T1QG = parcelRequire("1T1QG");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $9f7a27c52259e36e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


const $08b735e255ddfcef$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouterv6.tsx"; /* eslint-disable max-lines */ 
let $08b735e255ddfcef$var$activeTransaction;
let $08b735e255ddfcef$var$_useEffect;
let $08b735e255ddfcef$var$_useLocation;
let $08b735e255ddfcef$var$_useNavigationType;
let $08b735e255ddfcef$var$_createRoutesFromChildren;
let $08b735e255ddfcef$var$_matchRoutes;
let $08b735e255ddfcef$var$_customStartTransaction;
let $08b735e255ddfcef$var$_startTransactionOnLocationChange;
let $08b735e255ddfcef$var$_stripBasename = false;
/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function $08b735e255ddfcef$export$47113a480541ff59(options) {
    const integration = (0, $372ce2d55fd5d92e$export$b4109253475213e9)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { useEffect: useEffect, useLocation: useLocation, useNavigationType: useNavigationType, createRoutesFromChildren: createRoutesFromChildren, matchRoutes: matchRoutes, stripBasename: stripBasename, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const startNavigationCallback = (startSpanOptions)=>{
                (0, $372ce2d55fd5d92e$export$7d159749bd9969ad)(client, startSpanOptions);
                return undefined;
            };
            const initPathName = (0, $0c03304570a3d428$export$56d8a8a25bd48b81) && (0, $0c03304570a3d428$export$56d8a8a25bd48b81).location && (0, $0c03304570a3d428$export$56d8a8a25bd48b81).location.pathname;
            if (instrumentPageLoad && initPathName) (0, $372ce2d55fd5d92e$export$aa44a07f82af519f)(client, {
                name: initPathName,
                attributes: {
                    [(0, $a8f596f3c433b5b1$export$d7a7d984b0791405)]: "url",
                    [(0, $a8f596f3c433b5b1$export$1a413bd9a88fdb09)]: "pageload",
                    [(0, $a8f596f3c433b5b1$export$cca8dd30f57f805e)]: "auto.pageload.react.reactrouter_v6"
                }
            });
            $08b735e255ddfcef$var$_useEffect = useEffect;
            $08b735e255ddfcef$var$_useLocation = useLocation;
            $08b735e255ddfcef$var$_useNavigationType = useNavigationType;
            $08b735e255ddfcef$var$_matchRoutes = matchRoutes;
            $08b735e255ddfcef$var$_createRoutesFromChildren = createRoutesFromChildren;
            $08b735e255ddfcef$var$_stripBasename = stripBasename || false;
            $08b735e255ddfcef$var$_customStartTransaction = startNavigationCallback;
            $08b735e255ddfcef$var$_startTransactionOnLocationChange = instrumentNavigation;
        }
    };
}
/**
 * @deprecated Use `reactRouterV6BrowserTracingIntegration()` instead.
 */ function $08b735e255ddfcef$export$e6e76890c5208db1(useEffect, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes, stripBasename) {
    return (customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true)=>{
        const initPathName = (0, $0c03304570a3d428$export$56d8a8a25bd48b81) && (0, $0c03304570a3d428$export$56d8a8a25bd48b81).location && (0, $0c03304570a3d428$export$56d8a8a25bd48b81).location.pathname;
        if (startTransactionOnPageLoad && initPathName) $08b735e255ddfcef$var$activeTransaction = customStartTransaction({
            name: initPathName,
            attributes: {
                [(0, $a8f596f3c433b5b1$export$d7a7d984b0791405)]: "url",
                [(0, $a8f596f3c433b5b1$export$1a413bd9a88fdb09)]: "pageload",
                [(0, $a8f596f3c433b5b1$export$cca8dd30f57f805e)]: "auto.pageload.react.reactrouter_v6"
            }
        });
        $08b735e255ddfcef$var$_useEffect = useEffect;
        $08b735e255ddfcef$var$_useLocation = useLocation;
        $08b735e255ddfcef$var$_useNavigationType = useNavigationType;
        $08b735e255ddfcef$var$_matchRoutes = matchRoutes;
        $08b735e255ddfcef$var$_createRoutesFromChildren = createRoutesFromChildren;
        $08b735e255ddfcef$var$_stripBasename = stripBasename || false;
        $08b735e255ddfcef$var$_customStartTransaction = customStartTransaction;
        $08b735e255ddfcef$var$_startTransactionOnLocationChange = startTransactionOnLocationChange;
    };
}
/**
 * Strip the basename from a pathname if exists.
 *
 * Vendored and modified from `react-router`
 * https://github.com/remix-run/react-router/blob/462bb712156a3f739d6139a0f14810b76b002df6/packages/router/utils.ts#L1038
 */ function $08b735e255ddfcef$var$stripBasenameFromPathname(pathname, basename) {
    if (!basename || basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return pathname;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    const startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    const nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return pathname;
    return pathname.slice(startIndex) || "/";
}
function $08b735e255ddfcef$var$getNormalizedName(routes, location, branches, basename = "") {
    if (!routes || routes.length === 0) return [
        $08b735e255ddfcef$var$_stripBasename ? $08b735e255ddfcef$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        "url"
    ];
    let pathBuilder = "";
    if (branches) // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let x = 0; x < branches.length; x++){
        const branch = branches[x];
        const route = branch.route;
        if (route) {
            // Early return if index route
            if (route.index) return [
                $08b735e255ddfcef$var$_stripBasename ? $08b735e255ddfcef$var$stripBasenameFromPathname(branch.pathname, basename) : branch.pathname,
                "route"
            ];
            const path = route.path;
            if (path) {
                const newPath = path[0] === "/" || pathBuilder[pathBuilder.length - 1] === "/" ? path : `/${path}`;
                pathBuilder += newPath;
                if (basename + branch.pathname === location.pathname) {
                    if (// If the route defined on the element is something like
                    // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
                    // We should check against the branch.pathname for the number of / seperators
                    (0, $b558a229e6ddb058$export$69dd85280a8d374c)(pathBuilder) !== (0, $b558a229e6ddb058$export$69dd85280a8d374c)(branch.pathname) && // We should not count wildcard operators in the url segments calculation
                    pathBuilder.slice(-2) !== "/*") return [
                        ($08b735e255ddfcef$var$_stripBasename ? "" : basename) + newPath,
                        "route"
                    ];
                    return [
                        ($08b735e255ddfcef$var$_stripBasename ? "" : basename) + pathBuilder,
                        "route"
                    ];
                }
            }
        }
    }
    return [
        $08b735e255ddfcef$var$_stripBasename ? $08b735e255ddfcef$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        "url"
    ];
}
function $08b735e255ddfcef$var$updatePageloadTransaction(activeRootSpan, location, routes, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $08b735e255ddfcef$var$_matchRoutes(routes, location, basename);
    if (activeRootSpan && branches) {
        const [name, source] = $08b735e255ddfcef$var$getNormalizedName(routes, location, branches, basename);
        activeRootSpan.updateName(name);
        activeRootSpan.setAttribute((0, $a8f596f3c433b5b1$export$d7a7d984b0791405), source);
    }
}
function $08b735e255ddfcef$var$handleNavigation(location, routes, navigationType, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $08b735e255ddfcef$var$_matchRoutes(routes, location, basename);
    if ($08b735e255ddfcef$var$_startTransactionOnLocationChange && (navigationType === "PUSH" || navigationType === "POP") && branches) {
        if ($08b735e255ddfcef$var$activeTransaction) $08b735e255ddfcef$var$activeTransaction.end();
        const [name, source] = $08b735e255ddfcef$var$getNormalizedName(routes, location, branches, basename);
        $08b735e255ddfcef$var$activeTransaction = $08b735e255ddfcef$var$_customStartTransaction({
            name: name,
            attributes: {
                [(0, $a8f596f3c433b5b1$export$d7a7d984b0791405)]: source,
                [(0, $a8f596f3c433b5b1$export$1a413bd9a88fdb09)]: "navigation",
                [(0, $a8f596f3c433b5b1$export$cca8dd30f57f805e)]: "auto.navigation.react.reactrouter_v6"
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $08b735e255ddfcef$export$c6111e8561a02a8b(Routes) {
    if (!$08b735e255ddfcef$var$_useEffect || !$08b735e255ddfcef$var$_useLocation || !$08b735e255ddfcef$var$_useNavigationType || !$08b735e255ddfcef$var$_createRoutesFromChildren || !$08b735e255ddfcef$var$_matchRoutes || !$08b735e255ddfcef$var$_customStartTransaction) {
        (0, $9f7a27c52259e36e$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn(`reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.
      useEffect: ${$08b735e255ddfcef$var$_useEffect}. useLocation: ${$08b735e255ddfcef$var$_useLocation}. useNavigationType: ${$08b735e255ddfcef$var$_useNavigationType}.
      createRoutesFromChildren: ${$08b735e255ddfcef$var$_createRoutesFromChildren}. matchRoutes: ${$08b735e255ddfcef$var$_matchRoutes}. customStartTransaction: ${$08b735e255ddfcef$var$_customStartTransaction}.`);
        return Routes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const location = $08b735e255ddfcef$var$_useLocation();
        const navigationType = $08b735e255ddfcef$var$_useNavigationType();
        $08b735e255ddfcef$var$_useEffect(()=>{
            const routes = $08b735e255ddfcef$var$_createRoutesFromChildren(props.children);
            if (isMountRenderPass) {
                $08b735e255ddfcef$var$updatePageloadTransaction($08b735e255ddfcef$var$getActiveRootSpan(), location, routes);
                isMountRenderPass = false;
            } else $08b735e255ddfcef$var$handleNavigation(location, routes, navigationType);
        }, // `props.children` is purpusely not included in the dependency array, because we do not want to re-run this effect
        // when the children change. We only want to start transactions when the location or navigation type change.
        [
            location,
            navigationType
        ]);
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params
        return $1T1QG.createElement(Routes, {
            ...props,
            __self: this,
            __source: {
                fileName: $08b735e255ddfcef$var$_jsxFileName,
                lineNumber: 329
            }
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($3HlGj)))(SentryRoutes, Routes);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return SentryRoutes;
}
function $08b735e255ddfcef$export$1f41b3e298c8040f(origUseRoutes) {
    if (!$08b735e255ddfcef$var$_useEffect || !$08b735e255ddfcef$var$_useLocation || !$08b735e255ddfcef$var$_useNavigationType || !$08b735e255ddfcef$var$_matchRoutes || !$08b735e255ddfcef$var$_customStartTransaction) {
        (0, $9f7a27c52259e36e$export$16a28057038b10ef) && (0, $f78ca609428407bb$export$af88d00dbe7f521).warn("reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.");
        return origUseRoutes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const { routes: routes, locationArg: locationArg } = props;
        const Routes = origUseRoutes(routes, locationArg);
        const location = $08b735e255ddfcef$var$_useLocation();
        const navigationType = $08b735e255ddfcef$var$_useNavigationType();
        // A value with stable identity to either pick `locationArg` if available or `location` if not
        const stableLocationParam = typeof locationArg === "string" || locationArg && locationArg.pathname ? locationArg : location;
        $08b735e255ddfcef$var$_useEffect(()=>{
            const normalizedLocation = typeof stableLocationParam === "string" ? {
                pathname: stableLocationParam
            } : stableLocationParam;
            if (isMountRenderPass) {
                $08b735e255ddfcef$var$updatePageloadTransaction($08b735e255ddfcef$var$getActiveRootSpan(), normalizedLocation, routes);
                isMountRenderPass = false;
            } else $08b735e255ddfcef$var$handleNavigation(normalizedLocation, routes, navigationType);
        }, [
            navigationType,
            stableLocationParam
        ]);
        return Routes;
    };
    // eslint-disable-next-line react/display-name
    return (routes, locationArg)=>{
        return $1T1QG.createElement(SentryRoutes, {
            routes: routes,
            locationArg: locationArg,
            __self: this,
            __source: {
                fileName: $08b735e255ddfcef$var$_jsxFileName,
                lineNumber: 386
            }
        });
    };
}
function $08b735e255ddfcef$export$7f4c656bd7ebbb6b(createRouterFunction) {
    // `opts` for createBrowserHistory and createMemoryHistory are different, but also not relevant for us at the moment.
    // `basename` is the only option that is relevant for us, and it is the same for all.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(routes, opts) {
        const router = createRouterFunction(routes, opts);
        const basename = opts && opts.basename;
        const activeRootSpan = $08b735e255ddfcef$var$getActiveRootSpan();
        // The initial load ends when `createBrowserRouter` is called.
        // This is the earliest convenient time to update the transaction name.
        // Callbacks to `router.subscribe` are not called for the initial load.
        if (router.state.historyAction === "POP" && activeRootSpan) $08b735e255ddfcef$var$updatePageloadTransaction(activeRootSpan, router.state.location, routes, undefined, basename);
        router.subscribe((state)=>{
            const location = state.location;
            if ($08b735e255ddfcef$var$_startTransactionOnLocationChange && (state.historyAction === "PUSH" || state.historyAction === "POP")) $08b735e255ddfcef$var$handleNavigation(location, routes, state.historyAction, undefined, basename);
        });
        return router;
    };
}
function $08b735e255ddfcef$var$getActiveRootSpan() {
    // Legacy behavior for "old" react router instrumentation
    if ($08b735e255ddfcef$var$activeTransaction) return $08b735e255ddfcef$var$activeTransaction;
    const span = (0, $ee681c8f4e6404de$export$1be426a8e585c83e)();
    const rootSpan = span ? (0, $0c5dfa55c02d3dae$export$c4c6a79b1260ca1b)(span) : undefined;
    if (!rootSpan) return undefined;
    const op = (0, $391854fa51155a6b$export$92d8c23565496537)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === "navigation" || op === "pageload" ? rootSpan : undefined;
}




var $1T1QG = parcelRequire("1T1QG");

var $be48023fb6d3f52d$export$2e2bcd8739ae039 = ()=>{
    $e331597552da4313$export$2cd8252107eb640b({
        dsn: (0, $01207a025fc0a048$export$6faa4a850bc4d0ce),
        environment: (0, $01207a025fc0a048$export$be46596bc6608f3b),
        debug: (0, $01207a025fc0a048$export$e987ec915f285263),
        release: (0, $01207a025fc0a048$export$d2c893bfac1da9a1),
        integrations: [
            // See docs for support of different versions of variation of react router
            // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
            $08b735e255ddfcef$export$47113a480541ff59({
                useEffect: (0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).useEffect,
                useLocation: $e0cff2801449e77d$export$45d76561a5302f2b,
                useNavigationType: $e0cff2801449e77d$export$1b3f31771c5d07c,
                createRoutesFromChildren: $e0cff2801449e77d$export$16da398f5434bdec,
                matchRoutes: $ab1356c645cbcf88$export$2708184779ceb39d
            }),
            $c7a0a995f0f65f86$export$2832a2ae028f5e28({
                // Default values, but makes it explicit for privacy reasons
                maskAllText: true,
                maskAllInputs: true,
                blockAllMedia: true
            })
        ],
        tracesSampleRate: (0, $01207a025fc0a048$export$934e799b0e87def5),
        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: (0, $01207a025fc0a048$export$6229fa3b56a23727),
        // Setting these will enable the replay feature.
        // By default, all user input and text is masked with * and all media is blocked for privacy reasons
        replaysSessionSampleRate: (0, $01207a025fc0a048$export$d991ba28bdd15482),
        replaysOnErrorSampleRate: (0, $01207a025fc0a048$export$6d698ff2c1f4a0ca)
    });
};


if (0, $01207a025fc0a048$export$6faa4a850bc4d0ce) (0, $be48023fb6d3f52d$export$2e2bcd8739ae039)();
(0, $657101dca2c3f08b$export$11ac3725994bec7b).configure({
    Auth: {
        Cognito: {
            userPoolId: (0, $01207a025fc0a048$export$51eee90b2075d4e1),
            userPoolClientId: (0, $01207a025fc0a048$export$1c5434afbe5b51),
            loginWith: {
                email: true
            }
        }
    }
});
const $7d0d880cf2ba634e$var$root = (0, $897f2152020fdf2d$export$882461b6382ed46c)(document.getElementById("root"));
if ((0, $01207a025fc0a048$export$be46596bc6608f3b) === "production" && (0, $01207a025fc0a048$export$c1914de753539b0b)) (0, $31044f7c5b53d689$export$2e2bcd8739ae039)((0, $01207a025fc0a048$export$c1914de753539b0b));
$7d0d880cf2ba634e$var$root.render(/*#__PURE__*/ (0, $3Py8h.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1T1QG))).StrictMode, {
    children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $c0f5ae171f734a84$export$2e2bcd8739ae039), {
        store: (0, $495f6f20308cda43$export$6f57813fe9f31bf9),
        children: /*#__PURE__*/ (0, $3Py8h.jsx)((0, $485d6edd1c926c0b$export$2e2bcd8739ae039), {})
    })
}));

})();
//# sourceMappingURL=index.e9d882e1.js.map
